/**
 * GQty AUTO-GENERATED CODE: PLEASE DO NOT MODIFY MANUALLY
 */

import { SchemaUnionsKey, type ScalarsEnumsHash } from 'gqty'

export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never
}
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any }
  /** Numeric custom scalar type */
  Numeric: { input: any; output: any }
}

export interface AIArticleGenerateInput {
  category?: InputMaybe<Scalars['String']['input']>
  targetAudience?: InputMaybe<Scalars['String']['input']>
  tone?: InputMaybe<Scalars['String']['input']>
  topic: Scalars['String']['input']
}

export interface AIArticleStreamInput {
  articleId?: InputMaybe<Scalars['String']['input']>
  category?: InputMaybe<Scalars['String']['input']>
  streamId: Scalars['String']['input']
  targetAudience?: InputMaybe<Scalars['String']['input']>
  tone?: InputMaybe<Scalars['String']['input']>
  topic: Scalars['String']['input']
}

/** One policy being accepted, with the revision the member was shown */
export interface AcceptMyPolicyItemInput {
  itemKey: Scalars['String']['input']
  policyRevisionId: Scalars['ID']['input']
  revisionSha256: Scalars['String']['input']
}

/** Input for a recipient accepting a shared-package invite */
export interface AcceptSharedCreditsInput {
  inviteToken?: InputMaybe<Scalars['String']['input']>
  ownerClientId: Scalars['ID']['input']
  serviceId: Scalars['ID']['input']
}

/** Provider type for access control doors */
export enum AccessControlProvider {
  Hapana = 'Hapana',
  Inception = 'Inception',
}

export enum AccessMode {
  both = 'both',
  fob = 'fob',
  qr = 'qr',
}

/** Access control permissions for staff users */
export enum AccessPermissions {
  read_write_policies = 'read_write_policies',
  read_write_site_groups = 'read_write_site_groups',
  read_write_users = 'read_write_users',
  write_access_rules_to_users = 'write_access_rules_to_users',
}

export enum AccessProvider {
  DRAGONFLY = 'DRAGONFLY',
  INCEPTION = 'INCEPTION',
  INNER_INTELLIGENCE = 'INNER_INTELLIGENCE',
  VIVA_MAC = 'VIVA_MAC',
}

/** Input for a member-initiated account deletion request */
export interface AccountDeletionRequestInput {
  clientId: Scalars['String']['input']
  feedback?: InputMaybe<Scalars['String']['input']>
  reason?: InputMaybe<Scalars['String']['input']>
  siteId: Scalars['String']['input']
}

/** Columns that can be used to sort activity stream */
export enum ActivityStreamOrderByColumn {
  sessionDate = 'sessionDate',
  sessionName = 'sessionName',
  statusDate = 'statusDate',
}

export interface AddAccessRuleInputInput {
  assignmentType: StaffAccessRuleAssignmentType
  siteGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>
  siteIds?: InputMaybe<Array<Scalars['ID']['input']>>
  staffAccessPolicyId: Scalars['ID']['input']
}

export interface AddClientToSiteSiteSpecificDataInput {
  enrollmentSource?: InputMaybe<Scalars['String']['input']>
  membershipType?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  preferences?: InputMaybe<AddClientToSiteSiteSpecificDataPreferencesInput>
  useAccountCreditsOnRecurringInvoices?: InputMaybe<Scalars['Boolean']['input']>
}

export interface AddClientToSiteSiteSpecificDataPreferencesInput {
  communications?: InputMaybe<Scalars['String']['input']>
  notifications?: InputMaybe<Scalars['Boolean']['input']>
}

/** Whether a membership line discount also covers its attached add-on lines */
export enum AddOnDiscountScope {
  MEMBERSHIP_AND_ADD_ONS = 'MEMBERSHIP_AND_ADD_ONS',
  MEMBERSHIP_ONLY = 'MEMBERSHIP_ONLY',
}

export interface AddSmsPackageOptionInputInput {
  /** Number of SMS credits in this package */
  count: Scalars['Float']['input']
  /** Price for this SMS package option */
  price: Scalars['Float']['input']
}

export interface AddSupportMessageInput {
  html?: InputMaybe<Scalars['String']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  metadata?: InputMaybe<Scalars['JSON']['input']>
  pageContextMeta?: InputMaybe<Scalars['JSON']['input']>
  role: SupportMessageRole
  supportChatId: Scalars['String']['input']
  text: Scalars['String']['input']
  thinkingText?: InputMaybe<Scalars['String']['input']>
}

/** Additonal billing types option */
export enum AddtionalBillingType {
  CUSTOM = 'CUSTOM',
  DEFAULT = 'DEFAULT',
}

/** Input for manual credit adjustment */
export interface AdjustCreditsInput {
  amount: Scalars['Float']['input']
  direction: ServiceCreditLedgerDirection
  notes?: InputMaybe<Scalars['String']['input']>
  /** Period ID for the credit adjustment. Can be a real UUID or "virtual-N" for future periods that need materialization. */
  periodId?: InputMaybe<Scalars['String']['input']>
  reason?: InputMaybe<Scalars['String']['input']>
  serviceId: Scalars['String']['input']
  siteId: Scalars['String']['input']
  /** Optional session type ID to adjust credits for. If not provided, adjusts the first LIMITED allocation. */
  siteSessionTypeId?: InputMaybe<Scalars['String']['input']>
}

/** Add or remove hours on a lamp set, with the reason recorded in its history */
export interface AdjustEquipmentLampHoursInput {
  deltaHours: Scalars['Float']['input']
  equipmentId: Scalars['ID']['input']
  lampSet: EquipmentLampSet
  reason: Scalars['String']['input']
}

/** Input for adjusting stock quantity for a product variant */
export interface AdjustStockInput {
  adjustmentType: PosStockAdjusmentType
  posProductVariableId: Scalars['ID']['input']
  quantityAdjustment: Scalars['Float']['input']
  reason?: InputMaybe<Scalars['String']['input']>
  referenceId?: InputMaybe<Scalars['ID']['input']>
}

export interface AdminAuditEventsFilterDateRangeInput {
  endDate: Scalars['String']['input']
  startDate: Scalars['String']['input']
}

export interface AdminAuditEventsFilterInput {
  actions?: InputMaybe<Array<AuditAction>>
  affectedUserId?: InputMaybe<Scalars['String']['input']>
  corporateId?: InputMaybe<Scalars['String']['input']>
  dateRange?: InputMaybe<AdminAuditEventsFilterDateRangeInput>
  memberId?: InputMaybe<Scalars['String']['input']>
  resources?: InputMaybe<Array<AuditResource>>
  searchText?: InputMaybe<Scalars['String']['input']>
  severity?: InputMaybe<Array<AuditSeverity>>
  siteId?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<Array<AuditSource>>
  systemOnly?: InputMaybe<Scalars['Boolean']['input']>
  userId?: InputMaybe<Scalars['String']['input']>
  visibility?: InputMaybe<Array<AuditVisibility>>
}

/** Sort order for admin aggregator session lists */
export enum AdminAggregatorSessionSort {
  START_TIME_ASC = 'START_TIME_ASC',
  START_TIME_DESC = 'START_TIME_DESC',
}

export enum AdminMobileFleetAppleSessionAction {
  enter_code = 'enter_code',
  reconnect = 'reconnect',
  wait = 'wait',
}

export enum AdminMobileFleetAppleTeamIssue {
  agreements_pending = 'agreements_pending',
  asc_key_missing = 'asc_key_missing',
  check_failed = 'check_failed',
  membership_expired = 'membership_expired',
  membership_expiring = 'membership_expiring',
  membership_unknown = 'membership_unknown',
  never_checked = 'never_checked',
}

export enum AdminMobileFleetBlocker {
  android_package_name = 'android_package_name',
  app_store_app_id = 'app_store_app_id',
  ios_bundle_id = 'ios_bundle_id',
  play_store_id = 'play_store_id',
}

export enum AdminMobileFleetCredentialState {
  error = 'error',
  ok = 'ok',
  unknown = 'unknown',
  warning = 'warning',
}

export enum AdminMobileFleetCredentialsStatus {
  configured = 'configured',
  missing = 'missing',
  unknown = 'unknown',
}

export enum AdminMobileFleetNextActionKind {
  building = 'building',
  continue_setup = 'continue_setup',
  fix_failure = 'fix_failure',
  monitor = 'monitor',
  on_hold = 'on_hold',
  release_to_stores = 'release_to_stores',
  submit_to_review = 'submit_to_review',
  up_to_date = 'up_to_date',
  waiting_on_client = 'waiting_on_client',
  waiting_review = 'waiting_review',
}

export enum AdminMobileFleetPlatformFilter {
  all = 'all',
  android = 'android',
  ios = 'ios',
}

export enum AdminMobileFleetQuickFilter {
  all = 'all',
  in_progress = 'in_progress',
  live = 'live',
  needs_action = 'needs_action',
}

export enum AdminMobileFleetReleaseStage {
  approved = 'approved',
  building = 'building',
  built = 'built',
  failed = 'failed',
  in_review = 'in_review',
  live = 'live',
  not_built = 'not_built',
  not_configured = 'not_configured',
  ready_to_release = 'ready_to_release',
  rejected = 'rejected',
  submitted = 'submitted',
  unknown = 'unknown',
  waiting_for_review = 'waiting_for_review',
}

export enum AdminMobileFleetSeverity {
  error = 'error',
  info = 'info',
  neutral = 'neutral',
  success = 'success',
  warning = 'warning',
}

export enum AdminMobileFleetStatusFilter {
  all = 'all',
  builds_running = 'builds_running',
  failed_operations = 'failed_operations',
  in_review = 'in_review',
  live = 'live',
  missing_credentials = 'missing_credentials',
  ready_to_release = 'ready_to_release',
  ready_to_submit = 'ready_to_submit',
  rejected = 'rejected',
  waiting_on_client = 'waiting_on_client',
}

/** Permissions of an admin user */
export enum AdminUserPermissions {
  access_to_all_reports = 'access_to_all_reports',
  access_to_internal_api_documentation = 'access_to_internal_api_documentation',
  add_new_corporates = 'add_new_corporates',
  add_new_sites_for_corporates = 'add_new_sites_for_corporates',
  log_in_as_corporates_and_sites = 'log_in_as_corporates_and_sites',
  manage_content = 'manage_content',
  read_corporates_and_sites = 'read_corporates_and_sites',
  read_public_api_dashboard = 'read_public_api_dashboard',
  read_public_api_usage_stats_report_only = 'read_public_api_usage_stats_report_only',
  read_system_settings = 'read_system_settings',
  read_write_admin_user = 'read_write_admin_user',
  scheduled_jobs_access = 'scheduled_jobs_access',
  write_admin_access_groups = 'write_admin_access_groups',
  write_blacklist_ips = 'write_blacklist_ips',
  write_corporate_status = 'write_corporate_status',
  write_corporates_and_sites = 'write_corporates_and_sites',
  write_public_api_dashboard = 'write_public_api_dashboard',
  write_site_status = 'write_site_status',
  write_system_settings = 'write_system_settings',
}

/** Status of an admin user */
export enum AdminUserStatus {
  active = 'active',
  inactive = 'inactive',
}

export interface AdminUsersFilterInput {
  /** Access group ID */
  accessGroupId?: InputMaybe<Scalars['String']['input']>
  /** Status */
  status?: InputMaybe<AdminUserStatus>
}

export enum AdminUsersOrderBy {
  email = 'email',
  name = 'name',
}

export interface AdminUsersOrderByInput {
  column: AdminUsersOrderBy
  direction: OrderByDirection
}

export interface AdoptMemberMovementLocationResolutionInput {
  destinationServiceTemplateId: Scalars['ID']['input']
  destinationSiteId: Scalars['ID']['input']
  sourceServiceTemplateId: Scalars['ID']['input']
  sourceSiteId: Scalars['ID']['input']
}

/** What a jurisdiction rule requires of a client in an age band */
export enum AgeBandOutcome {
  ALLOWED = 'ALLOWED',
  GUARDIAN_CONSENT_SIGNED = 'GUARDIAN_CONSENT_SIGNED',
  GUARDIAN_PRESENT_EACH_VISIT = 'GUARDIAN_PRESENT_EACH_VISIT',
  MEDICAL_AUTHORIZATION = 'MEDICAL_AUTHORIZATION',
  PROHIBITED = 'PROHIBITED',
}

/** The date of birth evidence a jurisdiction rule requires */
export enum AgeEvidenceRequired {
  SELF_REPORTED_OK = 'SELF_REPORTED_OK',
  STAFF_ID_CHECK = 'STAFF_ID_CHECK',
}

/** How a client date of birth was verified */
export enum AgeVerificationMethod {
  SELF_REPORTED = 'SELF_REPORTED',
  STAFF_ID_CHECK = 'STAFF_ID_CHECK',
}

/** Status reported by the external tanning hardware agent */
export enum AgentStatus {
  available = 'available',
  delay = 'delay',
  dirty = 'dirty',
  error = 'error',
  finishing = 'finishing',
  in_use = 'in_use',
}

/** Input for creating an aggregator provider */
export interface AggregatorProviderCreateInput {
  displayName: Scalars['String']['input']
  inboundSecretName?: InputMaybe<Scalars['String']['input']>
  isActive: Scalars['Boolean']['input']
  logoUrl?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  secretName: Scalars['String']['input']
  setupInstructions?: InputMaybe<Scalars['String']['input']>
  webhookUrl?: InputMaybe<Scalars['String']['input']>
}

/** Input for updating an aggregator provider */
export interface AggregatorProviderUpdateInput {
  displayName?: InputMaybe<Scalars['String']['input']>
  inboundSecretName?: InputMaybe<Scalars['String']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  logoUrl?: InputMaybe<Scalars['String']['input']>
  secretName?: InputMaybe<Scalars['String']['input']>
  setupInstructions?: InputMaybe<Scalars['String']['input']>
  webhookUrl?: InputMaybe<Scalars['String']['input']>
}

/** Method used to accept agreement */
export enum AgreementMethod {
  CHECKBOX = 'CHECKBOX',
  ELECTRONIC = 'ELECTRONIC',
  IMPORTED = 'IMPORTED',
  PAPER = 'PAPER',
  SIGNATURE = 'SIGNATURE',
  TERMINAL = 'TERMINAL',
}

/** Client surface that captured the agreement signature */
export enum AgreementSignedSource {
  EMBED_WEB = 'EMBED_WEB',
  KIOSK = 'KIOSK',
  MOBILE = 'MOBILE',
  TERMINAL = 'TERMINAL',
}

/** Status of client agreement */
export enum AgreementStatus {
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  EXPIRED = 'EXPIRED',
  PENDING = 'PENDING',
  REVOKED = 'REVOKED',
}

/** Type of agreement: service agreement, policy, or waiver */
export enum AgreementType {
  POLICY = 'POLICY',
  SERVICE_AGREEMENT = 'SERVICE_AGREEMENT',
  WAIVER = 'WAIVER',
}

export enum AlertOperator {
  is = 'is',
  is_after = 'is_after',
  is_before = 'is_before',
  is_greater_than = 'is_greater_than',
  is_known = 'is_known',
  is_less_than = 'is_less_than',
  is_not = 'is_not',
  is_not_selected = 'is_not_selected',
  is_selected = 'is_selected',
  is_unknown = 'is_unknown',
}

/** Input for giving a family member access to a family package; a null allocatedCredits leaves the member capped only by the package balance */
export interface AllocateFamilyPackageInput {
  allocatedCredits?: InputMaybe<Scalars['Float']['input']>
  clientId: Scalars['ID']['input']
  serviceId: Scalars['ID']['input']
}

/** Cube filter — server-side scope filters are added by queryRewrite */
export interface AnalyticsV2FilterInput {
  member: Scalars['String']['input']
  operator: AnalyticsV2FilterOperator
  values?: InputMaybe<Array<Scalars['String']['input']>>
}

/** Cube filter operators — superset of SQL comparison + set operators */
export enum AnalyticsV2FilterOperator {
  contains = 'contains',
  endsWith = 'endsWith',
  equals = 'equals',
  gt = 'gt',
  gte = 'gte',
  in = 'in',
  inDateRange = 'inDateRange',
  lt = 'lt',
  lte = 'lte',
  notContains = 'notContains',
  notEquals = 'notEquals',
  notIn = 'notIn',
  notInDateRange = 'notInDateRange',
  notSet = 'notSet',
  set = 'set',
  startsWith = 'startsWith',
}

/** Sort direction for an order entry */
export enum AnalyticsV2OrderDirection {
  asc = 'asc',
  desc = 'desc',
}

/** One member → direction pair for the Cube query order */
export interface AnalyticsV2OrderEntry {
  direction: AnalyticsV2OrderDirection
  member: Scalars['String']['input']
}

/** Cube measure-query input — permission filters injected server-side */
export interface AnalyticsV2QueryMeasureInput {
  dimensions?: InputMaybe<Array<Scalars['String']['input']>>
  filters?: InputMaybe<Array<AnalyticsV2FilterInput>>
  limit?: InputMaybe<Scalars['Float']['input']>
  measures: Array<Scalars['String']['input']>
  order?: InputMaybe<Array<AnalyticsV2OrderEntry>>
  segments?: InputMaybe<Array<Scalars['String']['input']>>
  timeDimensions?: InputMaybe<Array<AnalyticsV2TimeDimensionInput>>
}

/** Cube time dimension specification with optional granularity + range */
export interface AnalyticsV2TimeDimensionInput {
  dateRange?: InputMaybe<Scalars['String']['input']>
  dimension: Scalars['String']['input']
  granularity?: InputMaybe<AnalyticsV2TimeGranularity>
}

/** Cube time-dimension bucketing granularity */
export enum AnalyticsV2TimeGranularity {
  day = 'day',
  hour = 'hour',
  minute = 'minute',
  month = 'month',
  quarter = 'quarter',
  second = 'second',
  week = 'week',
  year = 'year',
}

/** Confidence indicator surfaced alongside every measure response */
export enum AnalyticsV2TrustTier {
  deprecated = 'deprecated',
  preliminary = 'preliminary',
  unknown = 'unknown',
  verified = 'verified',
}

export enum AndroidPermission {
  ACCESS_COARSE_LOCATION = 'ACCESS_COARSE_LOCATION',
  ACCESS_FINE_LOCATION = 'ACCESS_FINE_LOCATION',
  ACTIVITY_RECOGNITION = 'ACTIVITY_RECOGNITION',
  BLUETOOTH_CONNECT = 'BLUETOOTH_CONNECT',
  CAMERA = 'CAMERA',
  INTERNET = 'INTERNET',
  POST_NOTIFICATIONS = 'POST_NOTIFICATIONS',
  READ_CALENDAR = 'READ_CALENDAR',
  READ_EXTERNAL_STORAGE = 'READ_EXTERNAL_STORAGE',
  READ_MEDIA_IMAGES = 'READ_MEDIA_IMAGES',
  RECORD_AUDIO = 'RECORD_AUDIO',
  WRITE_CALENDAR = 'WRITE_CALENDAR',
  WRITE_EXTERNAL_STORAGE = 'WRITE_EXTERNAL_STORAGE',
}

/** What authenticated a logged call: an API key, a member, or a webhook subscription */
export enum ApiCallLogCredentialType {
  api_key = 'api_key',
  member = 'member',
  webhook_subscription = 'webhook_subscription',
}

export interface ApiCallLogFilterInput {
  from?: InputMaybe<Scalars['String']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  siteId?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<ApiCallLogStatus>
  statusCode?: InputMaybe<Scalars['Int']['input']>
  to?: InputMaybe<Scalars['String']['input']>
  types?: InputMaybe<Array<ApiCallLogType>>
}

/** success = 2xx; error = anything else, including no response at all */
export enum ApiCallLogStatus {
  error = 'error',
  success = 'success',
}

/** Which surface a logged call belongs to */
export enum ApiCallLogType {
  business_api = 'business_api',
  member_api = 'member_api',
  webhook = 'webhook',
}

export interface ApiCredentialCreateInput {
  name: Scalars['String']['input']
  scopes: Array<Scalars['String']['input']>
}

/** API credential environment. */
export enum ApiCredentialEnv {
  Live = 'Live',
  Test = 'Test',
}

/** Which partner surface an API credential authenticates on. */
export enum ApiCredentialKind {
  Native = 'Native',
  PartnerV1 = 'PartnerV1',
}

export interface ApiCredentialRenameInput {
  name: Scalars['String']['input']
}

/** Lifecycle status of an API credential. */
export enum ApiCredentialStatus {
  Active = 'Active',
  Expired = 'Expired',
  Revoked = 'Revoked',
  Rotating = 'Rotating',
}

export interface ApiCredentialUpdateScopesInput {
  scopes: Array<Scalars['String']['input']>
}

/** Whether the current mint expects a person (connect) or not (renew) */
export enum AppleAccountSessionMode {
  connect = 'connect',
  renew = 'renew',
}

/** Where the shared Apple session is in its connect / renew lifecycle */
export enum AppleAccountSessionStatus {
  awaiting_code = 'awaiting_code',
  connected = 'connected',
  disconnected = 'disconnected',
  failed = 'failed',
  needs_two_factor = 'needs_two_factor',
  starting = 'starting',
}

/** Why App Store Connect automation is unavailable for a brand */
export enum AppleAutomationReason {
  incomplete = 'incomplete',
  noCorporateKey = 'noCorporateKey',
  noHapanaKey = 'noHapanaKey',
  noTeamId = 'noTeamId',
}

/** Which Apple account's API key the automation would act as */
export enum AppleAutomationSource {
  corporate = 'corporate',
  hapanaTeam = 'hapanaTeam',
}

export enum AppleContentRightsDeclaration {
  DOES_NOT_USE_THIRD_PARTY_CONTENT = 'DOES_NOT_USE_THIRD_PARTY_CONTENT',
  USES_THIRD_PARTY_CONTENT = 'USES_THIRD_PARTY_CONTENT',
}

export interface ApproveMemberMovementRunInput {
  attestation: MemberMovementAttestationInput
  corporateId: Scalars['ID']['input']
  runId: Scalars['ID']['input']
}

/** Brand memberships, packages or add-ons to archive together. Only live ones are archived; the others are skipped with a reason. */
export interface ArchiveCorporateServiceTemplatesInput {
  corporateServiceTemplateIds: Array<Scalars['ID']['input']>
}

/** Why no location group can be offered to the caller, whatever permissions the policy holds */
export enum AssignabilityBlockedReason {
  NO_GROUP_RULES = 'NO_GROUP_RULES',
}

/** What caused an assigned staff change */
export enum AssignedStaffSource {
  MANUAL = 'MANUAL',
  MERGE = 'MERGE',
  SALE = 'SALE',
}

export enum AttendanceSource {
  AUTO = 'AUTO',
  BOOKING = 'BOOKING',
  CHECK_IN = 'CHECK_IN',
  MANUAL = 'MANUAL',
}

export enum AttendanceStatus {
  ATTENDED = 'ATTENDED',
  CONFIRMED = 'CONFIRMED',
  LATE_CANCELLED = 'LATE_CANCELLED',
  NO_SHOW = 'NO_SHOW',
}

export enum AttendanceType {
  ADMIN = 'ADMIN',
  AGGREGATOR = 'AGGREGATOR',
  BILLING = 'BILLING',
  CREDIT = 'CREDIT',
  DROP_IN = 'DROP_IN',
  EQUIPMENT = 'EQUIPMENT',
  FREE = 'FREE',
  GUEST_PASS = 'GUEST_PASS',
}

/** Type of audit action */
export enum AuditAction {
  ACCESS_POINT_CREATED = 'ACCESS_POINT_CREATED',
  ACCESS_POINT_DELETED = 'ACCESS_POINT_DELETED',
  ACCESS_POINT_MOVED = 'ACCESS_POINT_MOVED',
  ACCESS_POINT_QR_GENERATED = 'ACCESS_POINT_QR_GENERATED',
  ACCESS_POINT_UPDATED = 'ACCESS_POINT_UPDATED',
  ACCESS_POLICY_CREATED = 'ACCESS_POLICY_CREATED',
  ACCESS_POLICY_DELETED = 'ACCESS_POLICY_DELETED',
  ACCESS_POLICY_UPDATED = 'ACCESS_POLICY_UPDATED',
  ACCESS_ZONE_CREATED = 'ACCESS_ZONE_CREATED',
  ACCESS_ZONE_DELETED = 'ACCESS_ZONE_DELETED',
  ACCESS_ZONE_UPDATED = 'ACCESS_ZONE_UPDATED',
  ACCOUNT_CODE_ACTIVATED = 'ACCOUNT_CODE_ACTIVATED',
  ACCOUNT_CODE_ASSIGNED = 'ACCOUNT_CODE_ASSIGNED',
  ACCOUNT_CODE_CREATED = 'ACCOUNT_CODE_CREATED',
  ACCOUNT_CODE_DEACTIVATED = 'ACCOUNT_CODE_DEACTIVATED',
  ACCOUNT_CODE_UNASSIGNED = 'ACCOUNT_CODE_UNASSIGNED',
  ACCOUNT_CODE_UPDATED = 'ACCOUNT_CODE_UPDATED',
  ADMIN_USER_CREATED = 'ADMIN_USER_CREATED',
  ADMIN_USER_DELETED = 'ADMIN_USER_DELETED',
  ADMIN_USER_LOGIN = 'ADMIN_USER_LOGIN',
  ADMIN_USER_LOGOUT = 'ADMIN_USER_LOGOUT',
  ADMIN_USER_UPDATED = 'ADMIN_USER_UPDATED',
  AGREEMENT_SENT = 'AGREEMENT_SENT',
  AGREEMENT_SIGNED = 'AGREEMENT_SIGNED',
  AGREEMENT_VIEWED = 'AGREEMENT_VIEWED',
  AGREEMENT_VOIDED = 'AGREEMENT_VOIDED',
  AI_ARTICLE_GENERATED = 'AI_ARTICLE_GENERATED',
  AI_CONVERSATION_ENDED = 'AI_CONVERSATION_ENDED',
  AI_CONVERSATION_STARTED = 'AI_CONVERSATION_STARTED',
  AI_FEEDBACK_PROVIDED = 'AI_FEEDBACK_PROVIDED',
  AI_INTENT_DETECTED = 'AI_INTENT_DETECTED',
  AI_KNOWLEDGE_SEARCH = 'AI_KNOWLEDGE_SEARCH',
  AI_RESPONSE_GENERATED = 'AI_RESPONSE_GENERATED',
  AI_SUPPORT_TICKET_CREATED = 'AI_SUPPORT_TICKET_CREATED',
  ALLOWED_NETWORK_CREATED = 'ALLOWED_NETWORK_CREATED',
  ALLOWED_NETWORK_DELETED = 'ALLOWED_NETWORK_DELETED',
  ALLOWED_NETWORK_UPDATED = 'ALLOWED_NETWORK_UPDATED',
  API_CREDENTIAL_CREATED = 'API_CREDENTIAL_CREATED',
  API_CREDENTIAL_RENAMED = 'API_CREDENTIAL_RENAMED',
  API_CREDENTIAL_REVOKED = 'API_CREDENTIAL_REVOKED',
  API_CREDENTIAL_ROTATED = 'API_CREDENTIAL_ROTATED',
  API_CREDENTIAL_SCOPES_UPDATED = 'API_CREDENTIAL_SCOPES_UPDATED',
  AWARD_EARNED = 'AWARD_EARNED',
  BOOKING_CREDIT_COST_ADJUSTED = 'BOOKING_CREDIT_COST_ADJUSTED',
  BOOKING_CREDIT_PACKAGE_CHANGED = 'BOOKING_CREDIT_PACKAGE_CHANGED',
  BOOKING_PAYMENT_TYPE_CHANGED = 'BOOKING_PAYMENT_TYPE_CHANGED',
  BRAND_SETTING_UPDATED = 'BRAND_SETTING_UPDATED',
  CAROUSEL_GROUP_CREATED = 'CAROUSEL_GROUP_CREATED',
  CAROUSEL_GROUP_DELETED = 'CAROUSEL_GROUP_DELETED',
  CAROUSEL_GROUP_UPDATED = 'CAROUSEL_GROUP_UPDATED',
  CASH_DRAWER_CLOSED = 'CASH_DRAWER_CLOSED',
  CASH_DRAWER_OPENED = 'CASH_DRAWER_OPENED',
  CHALLENGE_ASSESSMENT_SUBMITTED = 'CHALLENGE_ASSESSMENT_SUBMITTED',
  CHALLENGE_COMPLETED = 'CHALLENGE_COMPLETED',
  CHALLENGE_ENROLLED = 'CHALLENGE_ENROLLED',
  CHALLENGE_ENROLLMENT_ARCHIVED = 'CHALLENGE_ENROLLMENT_ARCHIVED',
  CHALLENGE_EXPIRED = 'CHALLENGE_EXPIRED',
  CHALLENGE_GOAL_SUBMITTED = 'CHALLENGE_GOAL_SUBMITTED',
  CHALLENGE_RESUMED = 'CHALLENGE_RESUMED',
  CHALLENGE_WITHDRAWN = 'CHALLENGE_WITHDRAWN',
  CLIENT_AGE_VERIFIED = 'CLIENT_AGE_VERIFIED',
  CLIENT_DOB_CORRECTED = 'CLIENT_DOB_CORRECTED',
  COMMISSION_ACTIVATION_STEP = 'COMMISSION_ACTIVATION_STEP',
  COMMISSION_ADJUSTMENT_ADDED = 'COMMISSION_ADJUSTMENT_ADDED',
  COMMISSION_ASSIGNMENT_CHANGED = 'COMMISSION_ASSIGNMENT_CHANGED',
  COMMISSION_ELIGIBILITY_CHANGED = 'COMMISSION_ELIGIBILITY_CHANGED',
  COMMISSION_ITEM_SETTING_CHANGED = 'COMMISSION_ITEM_SETTING_CHANGED',
  COMMISSION_OWNER_CHANGED = 'COMMISSION_OWNER_CHANGED',
  COMMISSION_PERIOD_TRANSITIONED = 'COMMISSION_PERIOD_TRANSITIONED',
  COMMISSION_PLAN_AVAILABILITY_CHANGED = 'COMMISSION_PLAN_AVAILABILITY_CHANGED',
  COMMISSION_PLAN_SAVED = 'COMMISSION_PLAN_SAVED',
  COMMISSION_SETTINGS_CHANGED = 'COMMISSION_SETTINGS_CHANGED',
  CONTENT_ARCHIVED = 'CONTENT_ARCHIVED',
  CONTENT_COMPLETED = 'CONTENT_COMPLETED',
  CONTENT_CREATED = 'CONTENT_CREATED',
  CONTENT_DELETED = 'CONTENT_DELETED',
  CONTENT_DOWNLOADED = 'CONTENT_DOWNLOADED',
  CONTENT_DOWNLOAD_ACCESS_CHECK = 'CONTENT_DOWNLOAD_ACCESS_CHECK',
  CONTENT_DOWNLOAD_BATCH_SYNCED = 'CONTENT_DOWNLOAD_BATCH_SYNCED',
  CONTENT_DUPLICATED = 'CONTENT_DUPLICATED',
  CONTENT_FAVORITED = 'CONTENT_FAVORITED',
  CONTENT_PERMANENTLY_DELETED = 'CONTENT_PERMANENTLY_DELETED',
  CONTENT_PUBLISHED = 'CONTENT_PUBLISHED',
  CONTENT_REORDERED = 'CONTENT_REORDERED',
  CONTENT_SCHEDULED_PUBLISH_SKIPPED = 'CONTENT_SCHEDULED_PUBLISH_SKIPPED',
  CONTENT_UNFAVORITED = 'CONTENT_UNFAVORITED',
  CONTENT_UNPUBLISHED = 'CONTENT_UNPUBLISHED',
  CONTENT_UPDATED = 'CONTENT_UPDATED',
  CONTENT_VERSION_RESTORED = 'CONTENT_VERSION_RESTORED',
  CONTENT_VIEWED = 'CONTENT_VIEWED',
  CONTENT_WATCH_LATER_ADDED = 'CONTENT_WATCH_LATER_ADDED',
  CONTENT_WATCH_LATER_REMOVED = 'CONTENT_WATCH_LATER_REMOVED',
  CORPORATE_CREATED = 'CORPORATE_CREATED',
  CORPORATE_UPDATED = 'CORPORATE_UPDATED',
  DATA_DELETION = 'DATA_DELETION',
  DATA_EXPORT = 'DATA_EXPORT',
  DATA_IMPORT = 'DATA_IMPORT',
  DEMO_CLEANUP = 'DEMO_CLEANUP',
  DEMO_CORPORATE_CREATED = 'DEMO_CORPORATE_CREATED',
  DEMO_EMAIL_VERIFIED = 'DEMO_EMAIL_VERIFIED',
  DEMO_READY = 'DEMO_READY',
  DEMO_SEEDING_COMPLETED = 'DEMO_SEEDING_COMPLETED',
  DEMO_SEEDING_FAILED = 'DEMO_SEEDING_FAILED',
  DEMO_SEEDING_STARTED = 'DEMO_SEEDING_STARTED',
  DEMO_SIGNUP = 'DEMO_SIGNUP',
  DISPUTE_CREATED = 'DISPUTE_CREATED',
  DISPUTE_LOST = 'DISPUTE_LOST',
  DISPUTE_WON = 'DISPUTE_WON',
  DOOR_ACCESS_DENIED = 'DOOR_ACCESS_DENIED',
  DOOR_ACCESS_GRANTED = 'DOOR_ACCESS_GRANTED',
  DOOR_LOCKED = 'DOOR_LOCKED',
  DOOR_UNLOCKED = 'DOOR_UNLOCKED',
  DOOR_UNLOCK_FAILED = 'DOOR_UNLOCK_FAILED',
  ECOMMERCE_PURCHASE = 'ECOMMERCE_PURCHASE',
  ELECTRONIC_CONSENT_GIVEN = 'ELECTRONIC_CONSENT_GIVEN',
  ELECTRONIC_CONSENT_WITHDRAWN = 'ELECTRONIC_CONSENT_WITHDRAWN',
  EMAIL_BOUNCED = 'EMAIL_BOUNCED',
  EMAIL_CLICKED = 'EMAIL_CLICKED',
  EMAIL_COMPLAINED = 'EMAIL_COMPLAINED',
  EMAIL_DELIVERED = 'EMAIL_DELIVERED',
  EMAIL_FAILED = 'EMAIL_FAILED',
  EMAIL_OPENED = 'EMAIL_OPENED',
  EMAIL_SENT = 'EMAIL_SENT',
  EMAIL_SUPPRESSED = 'EMAIL_SUPPRESSED',
  EQUIPMENT_JURISDICTION_RULE_RETIRED = 'EQUIPMENT_JURISDICTION_RULE_RETIRED',
  EQUIPMENT_JURISDICTION_RULE_SAVED = 'EQUIPMENT_JURISDICTION_RULE_SAVED',
  EQUIPMENT_LAMP_CHANGED = 'EQUIPMENT_LAMP_CHANGED',
  EQUIPMENT_LAMP_HOURS_ADJUSTED = 'EQUIPMENT_LAMP_HOURS_ADJUSTED',
  EQUIPMENT_LAMP_SETTINGS_UPDATED = 'EQUIPMENT_LAMP_SETTINGS_UPDATED',
  EZYPAY_WEBHOOK_SWITCHED = 'EZYPAY_WEBHOOK_SWITCHED',
  FAMILY_ALLOCATION_REVOKED = 'FAMILY_ALLOCATION_REVOKED',
  FAMILY_ALLOCATION_UPDATED = 'FAMILY_ALLOCATION_UPDATED',
  FAMILY_CREATED = 'FAMILY_CREATED',
  FAMILY_DISSOLVED = 'FAMILY_DISSOLVED',
  FAMILY_DUPLICATE_SERVICE_FLAGGED = 'FAMILY_DUPLICATE_SERVICE_FLAGGED',
  FAMILY_INVITE_LINK_CREATED = 'FAMILY_INVITE_LINK_CREATED',
  FAMILY_MEMBER_ADDED = 'FAMILY_MEMBER_ADDED',
  FAMILY_MEMBER_DECLINED = 'FAMILY_MEMBER_DECLINED',
  FAMILY_MEMBER_INVITED = 'FAMILY_MEMBER_INVITED',
  FAMILY_MEMBER_JOINED = 'FAMILY_MEMBER_JOINED',
  FAMILY_MEMBER_LEFT = 'FAMILY_MEMBER_LEFT',
  FAMILY_MEMBER_REMOVED = 'FAMILY_MEMBER_REMOVED',
  FAMILY_PACKAGE_ALLOCATED = 'FAMILY_PACKAGE_ALLOCATED',
  FAMILY_PERMISSION_CHANGED = 'FAMILY_PERMISSION_CHANGED',
  FAMILY_ROLE_CHANGED = 'FAMILY_ROLE_CHANGED',
  FEATURE_ACCESSED = 'FEATURE_ACCESSED',
  FITNESS_PASSPORT_CONNECTION_TESTED = 'FITNESS_PASSPORT_CONNECTION_TESTED',
  FITNESS_PASSPORT_MEMBER_LINKED = 'FITNESS_PASSPORT_MEMBER_LINKED',
  FITNESS_PASSPORT_MEMBER_REFRESHED = 'FITNESS_PASSPORT_MEMBER_REFRESHED',
  FITNESS_PASSPORT_MEMBER_UNLINKED = 'FITNESS_PASSPORT_MEMBER_UNLINKED',
  FITNESS_PASSPORT_TOKENS_UPDATED = 'FITNESS_PASSPORT_TOKENS_UPDATED',
  FITNESS_PASSPORT_VISITS_REPLAYED = 'FITNESS_PASSPORT_VISITS_REPLAYED',
  FORM_RECORDS_PURGED = 'FORM_RECORDS_PURGED',
  FORM_RESULT_RECORDED_EXTERNALLY = 'FORM_RESULT_RECORDED_EXTERNALLY',
  GDPR_REQUEST = 'GDPR_REQUEST',
  GOAL_CREATED = 'GOAL_CREATED',
  GOAL_DELETED = 'GOAL_DELETED',
  GOAL_UPDATED = 'GOAL_UPDATED',
  GROW_CORPORATE_SETTINGS_UPDATED = 'GROW_CORPORATE_SETTINGS_UPDATED',
  GROW_CUSTOM_FIELDS_CACHE_REFRESHED = 'GROW_CUSTOM_FIELDS_CACHE_REFRESHED',
  GROW_CUSTOM_FIELD_SYNCED = 'GROW_CUSTOM_FIELD_SYNCED',
  GROW_HQ_AUTHENTICATION_CLEARED = 'GROW_HQ_AUTHENTICATION_CLEARED',
  GROW_HQ_AUTHENTICATION_SET = 'GROW_HQ_AUTHENTICATION_SET',
  GROW_HQ_CREATED = 'GROW_HQ_CREATED',
  GROW_HQ_DELETED = 'GROW_HQ_DELETED',
  GROW_HQ_SYNC_TRIGGERED = 'GROW_HQ_SYNC_TRIGGERED',
  GROW_HQ_UPDATED = 'GROW_HQ_UPDATED',
  GROW_SITE_AUTHENTICATION_CLEARED = 'GROW_SITE_AUTHENTICATION_CLEARED',
  GROW_SITE_AUTHENTICATION_SET = 'GROW_SITE_AUTHENTICATION_SET',
  GROW_SITE_LINKED_TO_HQ = 'GROW_SITE_LINKED_TO_HQ',
  GROW_SITE_LOCATION_CREATED = 'GROW_SITE_LOCATION_CREATED',
  GROW_SITE_SETTINGS_UPDATED = 'GROW_SITE_SETTINGS_UPDATED',
  GROW_SITE_SYNC_TRIGGERED = 'GROW_SITE_SYNC_TRIGGERED',
  GROW_SITE_UNLINKED_FROM_HQ = 'GROW_SITE_UNLINKED_FROM_HQ',
  GROW_TOKEN_REFRESHED = 'GROW_TOKEN_REFRESHED',
  GROW_TOKEN_REFRESH_FAILED = 'GROW_TOKEN_REFRESH_FAILED',
  GUARDIAN_AUTHORITY_REVOKED = 'GUARDIAN_AUTHORITY_REVOKED',
  GUARDIAN_PERMISSION_WITHDRAWN = 'GUARDIAN_PERMISSION_WITHDRAWN',
  IMPERSONATION_ENDED = 'IMPERSONATION_ENDED',
  IMPERSONATION_STARTED = 'IMPERSONATION_STARTED',
  INTEGRATION_CLIENT_SYNCED = 'INTEGRATION_CLIENT_SYNCED',
  INTEGRATION_CLIENT_SYNC_FAILED = 'INTEGRATION_CLIENT_SYNC_FAILED',
  INTEGRATION_CONFIG_UPDATED = 'INTEGRATION_CONFIG_UPDATED',
  INTEGRATION_CONNECTED = 'INTEGRATION_CONNECTED',
  INTEGRATION_DISCONNECTED = 'INTEGRATION_DISCONNECTED',
  INTEGRATION_SYNC_COMPLETED = 'INTEGRATION_SYNC_COMPLETED',
  INTEGRATION_SYNC_FAILED = 'INTEGRATION_SYNC_FAILED',
  INTEGRATION_SYNC_STARTED = 'INTEGRATION_SYNC_STARTED',
  INTEGRATION_TOKEN_REFRESHED = 'INTEGRATION_TOKEN_REFRESHED',
  INTEGRATION_TOKEN_REFRESH_FAILED = 'INTEGRATION_TOKEN_REFRESH_FAILED',
  INTEGRATION_WEBHOOK_DELIVERY_FAILED = 'INTEGRATION_WEBHOOK_DELIVERY_FAILED',
  INTEGRATION_WEBHOOK_DELIVERY_SUCCEEDED = 'INTEGRATION_WEBHOOK_DELIVERY_SUCCEEDED',
  INVOICES_IMPORTED = 'INVOICES_IMPORTED',
  INVOICE_CANCELLED = 'INVOICE_CANCELLED',
  INVOICE_CREATED = 'INVOICE_CREATED',
  INVOICE_PAID = 'INVOICE_PAID',
  INVOICE_REINSTATED = 'INVOICE_REINSTATED',
  INVOICE_UPDATED = 'INVOICE_UPDATED',
  INVOICE_VOIDED = 'INVOICE_VOIDED',
  KNOWLEDGE_ARTICLE_ARCHIVED = 'KNOWLEDGE_ARTICLE_ARCHIVED',
  KNOWLEDGE_ARTICLE_CREATED = 'KNOWLEDGE_ARTICLE_CREATED',
  KNOWLEDGE_ARTICLE_DELETED = 'KNOWLEDGE_ARTICLE_DELETED',
  KNOWLEDGE_ARTICLE_IMAGE_UPLOADED = 'KNOWLEDGE_ARTICLE_IMAGE_UPLOADED',
  KNOWLEDGE_ARTICLE_PUBLISHED = 'KNOWLEDGE_ARTICLE_PUBLISHED',
  KNOWLEDGE_ARTICLE_RESTORED = 'KNOWLEDGE_ARTICLE_RESTORED',
  KNOWLEDGE_ARTICLE_TRANSLATION_ADDED = 'KNOWLEDGE_ARTICLE_TRANSLATION_ADDED',
  KNOWLEDGE_ARTICLE_UPDATED = 'KNOWLEDGE_ARTICLE_UPDATED',
  KNOWLEDGE_ARTICLE_VIDEO_UPLOADED = 'KNOWLEDGE_ARTICLE_VIDEO_UPLOADED',
  KNOWLEDGE_CATEGORY_CREATED = 'KNOWLEDGE_CATEGORY_CREATED',
  KNOWLEDGE_CATEGORY_DELETED = 'KNOWLEDGE_CATEGORY_DELETED',
  KNOWLEDGE_CATEGORY_REORDERED = 'KNOWLEDGE_CATEGORY_REORDERED',
  KNOWLEDGE_CATEGORY_UPDATED = 'KNOWLEDGE_CATEGORY_UPDATED',
  LEADERBOARD_MATERIALIZED = 'LEADERBOARD_MATERIALIZED',
  LEADERBOARD_RANK_CHANGED = 'LEADERBOARD_RANK_CHANGED',
  MAGIC_LINK_SENT = 'MAGIC_LINK_SENT',
  MEMBERSHIP_CANCELLED = 'MEMBERSHIP_CANCELLED',
  MEMBERSHIP_CREATED = 'MEMBERSHIP_CREATED',
  MEMBERSHIP_RENEWED = 'MEMBERSHIP_RENEWED',
  MEMBERSHIP_RESUMED = 'MEMBERSHIP_RESUMED',
  MEMBERSHIP_SUSPENDED = 'MEMBERSHIP_SUSPENDED',
  MEMBERSHIP_TRANSFERRED = 'MEMBERSHIP_TRANSFERRED',
  MEMBERSHIP_TRANSFER_REVERTED = 'MEMBERSHIP_TRANSFER_REVERTED',
  MEMBERSHIP_UPDATED = 'MEMBERSHIP_UPDATED',
  MEMBER_ANONYMISED = 'MEMBER_ANONYMISED',
  MEMBER_ASSIGNED_STAFF_CHANGED = 'MEMBER_ASSIGNED_STAFF_CHANGED',
  MEMBER_BLOCKED = 'MEMBER_BLOCKED',
  MEMBER_CHECKIN = 'MEMBER_CHECKIN',
  MEMBER_CHECKOUT = 'MEMBER_CHECKOUT',
  MEMBER_COPIED_TO_LOCATION = 'MEMBER_COPIED_TO_LOCATION',
  MEMBER_CREATED = 'MEMBER_CREATED',
  MEMBER_CREATED_BULK = 'MEMBER_CREATED_BULK',
  MEMBER_DELETED = 'MEMBER_DELETED',
  MEMBER_FOB_REASSIGNED = 'MEMBER_FOB_REASSIGNED',
  MEMBER_LINKED_TO_SITE_BULK = 'MEMBER_LINKED_TO_SITE_BULK',
  MEMBER_LOGIN = 'MEMBER_LOGIN',
  MEMBER_LOGOUT = 'MEMBER_LOGOUT',
  MEMBER_MERGED = 'MEMBER_MERGED',
  MEMBER_MOVEMENT_CONFIG_UPDATED = 'MEMBER_MOVEMENT_CONFIG_UPDATED',
  MEMBER_MOVEMENT_DESTINATION_CHOSEN = 'MEMBER_MOVEMENT_DESTINATION_CHOSEN',
  MEMBER_MOVEMENT_EMERGENCY_STOP = 'MEMBER_MOVEMENT_EMERGENCY_STOP',
  MEMBER_MOVEMENT_INCOMING_DISMISSED = 'MEMBER_MOVEMENT_INCOMING_DISMISSED',
  MEMBER_MOVEMENT_INCOMING_NOTIFIERS_UPDATED = 'MEMBER_MOVEMENT_INCOMING_NOTIFIERS_UPDATED',
  MEMBER_MOVEMENT_LOCATION_POSTURE_UPDATED = 'MEMBER_MOVEMENT_LOCATION_POSTURE_UPDATED',
  MEMBER_MOVEMENT_REINITIATED = 'MEMBER_MOVEMENT_REINITIATED',
  MEMBER_MOVEMENT_ROLLING_TOGGLED = 'MEMBER_MOVEMENT_ROLLING_TOGGLED',
  MEMBER_MOVEMENT_RUN_APPROVED = 'MEMBER_MOVEMENT_RUN_APPROVED',
  MEMBER_PROFILE_VIEWED = 'MEMBER_PROFILE_VIEWED',
  MEMBER_UNBLOCKED = 'MEMBER_UNBLOCKED',
  MEMBER_UPDATED = 'MEMBER_UPDATED',
  METRIC_ENTRY_CREATED = 'METRIC_ENTRY_CREATED',
  METRIC_ENTRY_DELETED = 'METRIC_ENTRY_DELETED',
  METRIC_PERSONAL_BEST = 'METRIC_PERSONAL_BEST',
  MILESTONE_REACHED = 'MILESTONE_REACHED',
  NOTE_CREATED = 'NOTE_CREATED',
  NOTE_UPDATED = 'NOTE_UPDATED',
  ONBOARDING_STEP_COMPLETED = 'ONBOARDING_STEP_COMPLETED',
  ONBOARDING_STEP_VIEWED = 'ONBOARDING_STEP_VIEWED',
  OWED_BALANCE_BLOCK_OVERRIDE = 'OWED_BALANCE_BLOCK_OVERRIDE',
  PACKAGE_SHARED = 'PACKAGE_SHARED',
  PACKAGE_SHARE_REVOKED = 'PACKAGE_SHARE_REVOKED',
  PAGE_VIEWED = 'PAGE_VIEWED',
  PASSWORD_RESET_REQUESTED = 'PASSWORD_RESET_REQUESTED',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  PAYMENT_FALLBACK_ATTEMPTED = 'PAYMENT_FALLBACK_ATTEMPTED',
  PAYMENT_FALLBACK_EXHAUSTED = 'PAYMENT_FALLBACK_EXHAUSTED',
  PAYMENT_FALLBACK_RECOVERED = 'PAYMENT_FALLBACK_RECOVERED',
  PAYMENT_FALLBACK_SCHEDULED = 'PAYMENT_FALLBACK_SCHEDULED',
  PAYMENT_FALLBACK_SKIPPED = 'PAYMENT_FALLBACK_SKIPPED',
  PAYMENT_GATEWAY_FEES_APPLIED = 'PAYMENT_GATEWAY_FEES_APPLIED',
  PAYMENT_METHOD_ADDED = 'PAYMENT_METHOD_ADDED',
  PAYMENT_METHOD_BACKUP_CLEARED = 'PAYMENT_METHOD_BACKUP_CLEARED',
  PAYMENT_METHOD_BACKUP_SET = 'PAYMENT_METHOD_BACKUP_SET',
  PAYMENT_METHOD_REMOVED = 'PAYMENT_METHOD_REMOVED',
  PAYMENT_PROCESSED = 'PAYMENT_PROCESSED',
  PAYMENT_REFUNDED = 'PAYMENT_REFUNDED',
  PENDING_ITEMS_AUTO_SEND_SKIPPED = 'PENDING_ITEMS_AUTO_SEND_SKIPPED',
  PENDING_ITEMS_HANDOFF_CLOSED = 'PENDING_ITEMS_HANDOFF_CLOSED',
  PENDING_ITEMS_HANDOFF_COMPLETED = 'PENDING_ITEMS_HANDOFF_COMPLETED',
  PENDING_ITEMS_HANDOFF_CREATED = 'PENDING_ITEMS_HANDOFF_CREATED',
  PENDING_ITEMS_IDENTITY_FAILED = 'PENDING_ITEMS_IDENTITY_FAILED',
  POLICY_ACCEPTANCE_VOIDED = 'POLICY_ACCEPTANCE_VOIDED',
  POLICY_ACCEPTED = 'POLICY_ACCEPTED',
  POLICY_BULK_SEND_CANCELLED = 'POLICY_BULK_SEND_CANCELLED',
  POLICY_BULK_SEND_COMPLETED = 'POLICY_BULK_SEND_COMPLETED',
  POLICY_BULK_SEND_STARTED = 'POLICY_BULK_SEND_STARTED',
  POLICY_COMPLIANCE_SETTINGS_UPDATED = 'POLICY_COMPLIANCE_SETTINGS_UPDATED',
  POLICY_EVIDENCE_EXPORTED = 'POLICY_EVIDENCE_EXPORTED',
  POLICY_EVIDENCE_EXPORT_DOWNLOADED = 'POLICY_EVIDENCE_EXPORT_DOWNLOADED',
  POLICY_EVIDENCE_EXPORT_REQUESTED = 'POLICY_EVIDENCE_EXPORT_REQUESTED',
  POLICY_EVIDENCE_EXPORT_REVOKED = 'POLICY_EVIDENCE_EXPORT_REVOKED',
  POLICY_EVIDENCE_IMPORTED = 'POLICY_EVIDENCE_IMPORTED',
  POLICY_EVIDENCE_PURGED = 'POLICY_EVIDENCE_PURGED',
  POLICY_IMPORT_VOIDED = 'POLICY_IMPORT_VOIDED',
  POLICY_PAPER_RECORDED = 'POLICY_PAPER_RECORDED',
  POLICY_RENEWAL_REMINDER_SKIPPED = 'POLICY_RENEWAL_REMINDER_SKIPPED',
  PUSH_NOTIFICATION_DELIVERED = 'PUSH_NOTIFICATION_DELIVERED',
  PUSH_NOTIFICATION_SENT = 'PUSH_NOTIFICATION_SENT',
  REFERRAL_BONUS_AWARDED = 'REFERRAL_BONUS_AWARDED',
  REFERRAL_DECLINED = 'REFERRAL_DECLINED',
  REFERRAL_RECORDED = 'REFERRAL_RECORDED',
  SALE_OUTSIDE_AVAILABILITY_OVERRIDE = 'SALE_OUTSIDE_AVAILABILITY_OVERRIDE',
  SALE_OUTSIDE_DYNAMIC_DISPLAY_OVERRIDE = 'SALE_OUTSIDE_DYNAMIC_DISPLAY_OVERRIDE',
  SANDBOX_CREATE_TRIGGERED = 'SANDBOX_CREATE_TRIGGERED',
  SANDBOX_DELETE_TRIGGERED = 'SANDBOX_DELETE_TRIGGERED',
  SANDBOX_RESYNC_TRIGGERED = 'SANDBOX_RESYNC_TRIGGERED',
  SANDBOX_SITE_INDEX_EVICTED = 'SANDBOX_SITE_INDEX_EVICTED',
  SERVICE_CREDITS_ADJUSTED = 'SERVICE_CREDITS_ADJUSTED',
  SESSION_ATTENDED = 'SESSION_ATTENDED',
  SESSION_BOOKED = 'SESSION_BOOKED',
  SESSION_CANCELLED = 'SESSION_CANCELLED',
  SESSION_CREATED = 'SESSION_CREATED',
  SESSION_DELETED = 'SESSION_DELETED',
  SESSION_NO_SHOW = 'SESSION_NO_SHOW',
  SESSION_UPDATED = 'SESSION_UPDATED',
  SESSION_WAITLISTED = 'SESSION_WAITLISTED',
  SETTING_UPDATED = 'SETTING_UPDATED',
  SHARE_COMPLETED = 'SHARE_COMPLETED',
  SHARE_GENERATED = 'SHARE_GENERATED',
  SITE_ALERT_DELETED = 'SITE_ALERT_DELETED',
  SITE_ALERT_ENDED = 'SITE_ALERT_ENDED',
  SITE_ALERT_POSTED = 'SITE_ALERT_POSTED',
  SITE_ALERT_UPDATED = 'SITE_ALERT_UPDATED',
  SITE_CREATED = 'SITE_CREATED',
  SITE_DELETED = 'SITE_DELETED',
  SITE_DUPLICATED = 'SITE_DUPLICATED',
  SITE_FOB_FORMAT_CHANGED = 'SITE_FOB_FORMAT_CHANGED',
  SITE_INDEX_BACKFILLED = 'SITE_INDEX_BACKFILLED',
  SITE_POLICY_REVISION_ACTIVATED = 'SITE_POLICY_REVISION_ACTIVATED',
  SITE_POLICY_REVISION_CANCELLED = 'SITE_POLICY_REVISION_CANCELLED',
  SITE_POLICY_REVISION_PUBLISHED = 'SITE_POLICY_REVISION_PUBLISHED',
  SITE_POLICY_REVISION_SCHEDULED = 'SITE_POLICY_REVISION_SCHEDULED',
  SITE_SETTING_UPDATED = 'SITE_SETTING_UPDATED',
  SITE_UPDATED = 'SITE_UPDATED',
  SITE_V2_STATUS_CHANGED = 'SITE_V2_STATUS_CHANGED',
  SMS_DELIVERED = 'SMS_DELIVERED',
  SMS_SENT = 'SMS_SENT',
  STAFF_ALLOWED_NETWORKS_CHANGED = 'STAFF_ALLOWED_NETWORKS_CHANGED',
  STAFF_APPROVAL_PIN_SET = 'STAFF_APPROVAL_PIN_SET',
  STAFF_CLOCK_IN = 'STAFF_CLOCK_IN',
  STAFF_CLOCK_OUT = 'STAFF_CLOCK_OUT',
  STAFF_CREATED = 'STAFF_CREATED',
  STAFF_DELETED = 'STAFF_DELETED',
  STAFF_INVITATION_ACCEPTED = 'STAFF_INVITATION_ACCEPTED',
  STAFF_INVITATION_RESENT = 'STAFF_INVITATION_RESENT',
  STAFF_INVITATION_REVOKED = 'STAFF_INVITATION_REVOKED',
  STAFF_INVITATION_SENT = 'STAFF_INVITATION_SENT',
  STAFF_LOGIN = 'STAFF_LOGIN',
  STAFF_LOGOUT = 'STAFF_LOGOUT',
  STAFF_ROLE_CHANGED = 'STAFF_ROLE_CHANGED',
  STAFF_SESSIONS_REVOKED = 'STAFF_SESSIONS_REVOKED',
  STAFF_SESSION_POLICY_UPDATED = 'STAFF_SESSION_POLICY_UPDATED',
  STAFF_TIME_CLOCK_MANUAL_ENTRY = 'STAFF_TIME_CLOCK_MANUAL_ENTRY',
  STAFF_UPDATED = 'STAFF_UPDATED',
  STREAK_BROKEN = 'STREAK_BROKEN',
  STREAK_STARTED = 'STREAK_STARTED',
  SUPPORT_TICKET_SUBMITTED = 'SUPPORT_TICKET_SUBMITTED',
  SYSTEM_CONFIG_CHANGED = 'SYSTEM_CONFIG_CHANGED',
  TANNING_REGULATION_OVERRIDE = 'TANNING_REGULATION_OVERRIDE',
  TANNING_SESSION_REVERSED = 'TANNING_SESSION_REVERSED',
  TANNING_SKIN_TYPE_OVERRIDE = 'TANNING_SKIN_TYPE_OVERRIDE',
  TRIAL_ACCESS_PROVISIONED = 'TRIAL_ACCESS_PROVISIONED',
  TRIAL_CLOSED = 'TRIAL_CLOSED',
  TRIAL_CONVERTED = 'TRIAL_CONVERTED',
  TRIAL_EXPIRED = 'TRIAL_EXPIRED',
  TRIAL_EXTENDED = 'TRIAL_EXTENDED',
  TRIAL_REOPENED = 'TRIAL_REOPENED',
  TRIAL_STARTED = 'TRIAL_STARTED',
  VIDEO_COMPLETED = 'VIDEO_COMPLETED',
  VIDEO_SESSION_STARTED = 'VIDEO_SESSION_STARTED',
  WEBHOOK_CREATED = 'WEBHOOK_CREATED',
  WEBHOOK_DELETED = 'WEBHOOK_DELETED',
  WEBHOOK_DISABLED = 'WEBHOOK_DISABLED',
  WEBHOOK_DISABLED_AUTO = 'WEBHOOK_DISABLED_AUTO',
  WEBHOOK_ENABLED = 'WEBHOOK_ENABLED',
  WEBHOOK_SECRET_ROTATED = 'WEBHOOK_SECRET_ROTATED',
  WEBHOOK_UPDATED = 'WEBHOOK_UPDATED',
  ZAPIER_LOCATION_CONNECTED = 'ZAPIER_LOCATION_CONNECTED',
  ZAPIER_LOCATION_DISCONNECTED = 'ZAPIER_LOCATION_DISCONNECTED',
  ZAPIER_SUBSCRIPTION_CREATED = 'ZAPIER_SUBSCRIPTION_CREATED',
  ZAPIER_SUBSCRIPTION_REMOVED = 'ZAPIER_SUBSCRIPTION_REMOVED',
}

/** Field to group audit events by for aggregation */
export enum AuditAggregationGroupBy {
  action = 'action',
  affectedUserId = 'affectedUserId',
  date = 'date',
  resource = 'resource',
  severity = 'severity',
  siteName = 'siteName',
  source = 'source',
  userId = 'userId',
}

/** Device type (mobile, tablet, desktop) */
export enum AuditDeviceType {
  DESKTOP = 'DESKTOP',
  MOBILE = 'MOBILE',
  TABLET = 'TABLET',
}

export interface AuditEventsFilterDateRangeInput {
  endDate: Scalars['String']['input']
  startDate: Scalars['String']['input']
}

export interface AuditEventsFilterInput {
  actions?: InputMaybe<Array<AuditAction>>
  affectedUserId?: InputMaybe<Scalars['String']['input']>
  corporateId: Scalars['String']['input']
  dateRange?: InputMaybe<AuditEventsFilterDateRangeInput>
  excludeActions?: InputMaybe<Array<AuditAction>>
  memberId?: InputMaybe<Scalars['String']['input']>
  resources?: InputMaybe<Array<AuditResource>>
  searchText?: InputMaybe<Scalars['String']['input']>
  severity?: InputMaybe<Array<AuditSeverity>>
  siteId?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<Array<AuditSource>>
  systemOnly?: InputMaybe<Scalars['Boolean']['input']>
  userId?: InputMaybe<Scalars['String']['input']>
  visibility?: InputMaybe<Array<AuditVisibility>>
}

export interface AuditEventsPaginationInput {
  page: Scalars['Float']['input']
  pageSize: Scalars['Float']['input']
}

export interface AuditEventsSortInput {
  direction: AuditSortDirection
  field: AuditSortField
}

/** Platform/OS of the client device */
export enum AuditPlatform {
  ANDROID = 'ANDROID',
  IOS = 'IOS',
  WEB = 'WEB',
}

/** Type of resource being audited */
export enum AuditResource {
  ACCESS_POINT = 'ACCESS_POINT',
  ACCESS_ZONE = 'ACCESS_ZONE',
  ACCOUNT_CODE = 'ACCOUNT_CODE',
  ADMIN_USER = 'ADMIN_USER',
  AGREEMENT = 'AGREEMENT',
  AI_CONVERSATION = 'AI_CONVERSATION',
  AI_INTERACTION = 'AI_INTERACTION',
  ALLOWED_NETWORK = 'ALLOWED_NETWORK',
  API_CREDENTIAL = 'API_CREDENTIAL',
  BOOKING = 'BOOKING',
  CASH_DRAWER = 'CASH_DRAWER',
  CLIENT_FORM_SUBMISSION = 'CLIENT_FORM_SUBMISSION',
  COMMISSION = 'COMMISSION',
  COMMUNICATION = 'COMMUNICATION',
  CONTENT_AWARD = 'CONTENT_AWARD',
  CONTENT_CAROUSEL_GROUP = 'CONTENT_CAROUSEL_GROUP',
  CONTENT_CHALLENGE = 'CONTENT_CHALLENGE',
  CONTENT_ENTRY = 'CONTENT_ENTRY',
  CONTENT_GOAL = 'CONTENT_GOAL',
  CONTENT_LEADERBOARD = 'CONTENT_LEADERBOARD',
  CONTENT_METRIC = 'CONTENT_METRIC',
  CONTENT_TYPE = 'CONTENT_TYPE',
  CONTENT_VIDEO = 'CONTENT_VIDEO',
  CORPORATE = 'CORPORATE',
  DEMO_PROFILE = 'DEMO_PROFILE',
  DISPUTE = 'DISPUTE',
  DOOR = 'DOOR',
  EGYM = 'EGYM',
  EQUIPMENT = 'EQUIPMENT',
  EQUIPMENT_ASSIGNMENT = 'EQUIPMENT_ASSIGNMENT',
  EQUIPMENT_JURISDICTION_RULE = 'EQUIPMENT_JURISDICTION_RULE',
  FAMILY = 'FAMILY',
  FITNESS_PASSPORT_INTEGRATION = 'FITNESS_PASSPORT_INTEGRATION',
  FITNESS_PASSPORT_LINK = 'FITNESS_PASSPORT_LINK',
  GROW_CORPORATE = 'GROW_CORPORATE',
  GROW_HQ = 'GROW_HQ',
  GROW_SITE = 'GROW_SITE',
  GROW_TOKEN = 'GROW_TOKEN',
  HUBSPOT = 'HUBSPOT',
  IMPORT_SESSION = 'IMPORT_SESSION',
  INTEGRATION_CLIENT = 'INTEGRATION_CLIENT',
  INTEGRATION_LOCATION = 'INTEGRATION_LOCATION',
  INTEGRATION_SYNC = 'INTEGRATION_SYNC',
  INTEGRATION_TOKEN = 'INTEGRATION_TOKEN',
  INTEGRATION_WEBHOOK_DELIVERY = 'INTEGRATION_WEBHOOK_DELIVERY',
  INVOICE = 'INVOICE',
  KNOWLEDGE_ARTICLE = 'KNOWLEDGE_ARTICLE',
  KNOWLEDGE_CATEGORY = 'KNOWLEDGE_CATEGORY',
  KNOWLEDGE_TRANSLATION = 'KNOWLEDGE_TRANSLATION',
  MEMBER = 'MEMBER',
  MEMBERSHIP = 'MEMBERSHIP',
  ONBOARDING_CHECKLIST = 'ONBOARDING_CHECKLIST',
  PAGE = 'PAGE',
  PAYMENT = 'PAYMENT',
  REPORT = 'REPORT',
  SERVICE = 'SERVICE',
  SESSION = 'SESSION',
  SETTING = 'SETTING',
  SHARE_CARD = 'SHARE_CARD',
  SITE = 'SITE',
  SITE_ALERT = 'SITE_ALERT',
  SITE_POLICY = 'SITE_POLICY',
  STAFF = 'STAFF',
  STAFF_INVITATION = 'STAFF_INVITATION',
  SUPPORT_TICKET = 'SUPPORT_TICKET',
  SYSTEM_CONFIG = 'SYSTEM_CONFIG',
  TRIAL = 'TRIAL',
  WEBHOOK = 'WEBHOOK',
  ZAPIER_CONNECTION = 'ZAPIER_CONNECTION',
  ZAPIER_SUBSCRIPTION = 'ZAPIER_SUBSCRIPTION',
}

/** Severity level of the audit event */
export enum AuditSeverity {
  CRITICAL = 'CRITICAL',
  INFO = 'INFO',
  SECURITY = 'SECURITY',
  WARNING = 'WARNING',
}

/** Sort direction for audit queries */
export enum AuditSortDirection {
  asc = 'asc',
  desc = 'desc',
}

/** Field to sort audit events by */
export enum AuditSortField {
  action = 'action',
  resource = 'resource',
  severity = 'severity',
  timestamp = 'timestamp',
}

/** Source application of the audit event */
export enum AuditSource {
  ADMIN_WEB = 'ADMIN_WEB',
  API = 'API',
  CORE_WEB = 'CORE_WEB',
  EMBED_WEB = 'EMBED_WEB',
  INTEGRATION = 'INTEGRATION',
  KIOSK = 'KIOSK',
  MOBILE = 'MOBILE',
  SYSTEM = 'SYSTEM',
  WEBHOOK = 'WEBHOOK',
}

/** Visibility level of the audit event */
export enum AuditVisibility {
  CUSTOMER = 'CUSTOMER',
  INTERNAL = 'INTERNAL',
  SYSTEM = 'SYSTEM',
}

export enum AutoConvertTrigger {
  NEVER = 'NEVER',
  ON_CREDIT_DEPLETION = 'ON_CREDIT_DEPLETION',
  ON_EXPIRY = 'ON_EXPIRY',
}

/** Auto logout duration options in minutes */
export enum AutoLogoutMinutes {
  FIFTEEN = 'FIFTEEN',
  FIVE = 'FIVE',
  SIXTY = 'SIXTY',
  TEN = 'TEN',
  THIRTY = 'THIRTY',
}

export enum AutoRenewType {
  ON_CUSTOM_EXPIRATION_DATE = 'ON_CUSTOM_EXPIRATION_DATE',
  ON_TERM_DATE = 'ON_TERM_DATE',
}

export interface AvailableReportsInputInput {
  siteId?: InputMaybe<Scalars['String']['input']>
}

export interface AvailableToAssignRegionsFilterInput {
  permissions?: InputMaybe<Array<Scalars['String']['input']>>
}

/** One grant to set: scope (ALL_SITES, SITE + siteId, ROLE/USER + principalId) and capability (VIEW or EDIT) */
export interface BiAccessGrantInput {
  capability: Scalars['String']['input']
  principalId?: InputMaybe<Scalars['String']['input']>
  scopeType: Scalars['String']['input']
  siteId?: InputMaybe<Scalars['String']['input']>
}

/** Soft-delete one tenant dashboard for the calling corporate */
export interface BiDeleteDashboardInput {
  dashboardId: Scalars['String']['input']
}

/** One parity check: a Cube query and its GoodData counterpart for a corporate */
export interface BiParityCheckInput {
  corporateId: Scalars['ID']['input']
  cubeQuery: AnalyticsV2QueryMeasureInput
  gooddata?: InputMaybe<BiParityGoodDataMetricRef>
  sessionCookie?: InputMaybe<Scalars['String']['input']>
  tolerancePct?: InputMaybe<Scalars['Float']['input']>
}

/** GoodData metric to execute for the comparison: workspace + metric id, with an optional absolute date filter */
export interface BiParityGoodDataMetricRef {
  dateDatasetId?: InputMaybe<Scalars['String']['input']>
  dateFrom?: InputMaybe<Scalars['String']['input']>
  dateTo?: InputMaybe<Scalars['String']['input']>
  metricId: Scalars['String']['input']
  workspaceId: Scalars['String']['input']
}

/** Verdict of a parity check. gooddata_not_configured = no GoodData API credentials on this environment */
export enum BiParityStatus {
  cube_no_data = 'cube_no_data',
  gooddata_not_configured = 'gooddata_not_configured',
  match = 'match',
  mismatch = 'mismatch',
}

/** Publish (upsert) one dashboard bundle for the calling corporate — Hapana staff only */
export interface BiPublishDashboardInput {
  bundleJson: Scalars['String']['input']
  sortOrder?: InputMaybe<Scalars['Float']['input']>
}

/** Replace the visibility and full grant set for one BI dashboard or widget — requires bi_admin or ownership */
export interface BiSetAccessInput {
  grants: Array<BiAccessGrantInput>
  subjectId: Scalars['String']['input']
  subjectType: Scalars['String']['input']
  visibility: Scalars['String']['input']
}

/** Set (or clear) the calling user's default BI dashboard */
export interface BiSetDefaultDashboardInput {
  dashboardId?: InputMaybe<Scalars['String']['input']>
}

/** Persist the DashView workspace id for the calling corporate — Hapana staff only */
export interface BiSetMigrationConfigInput {
  classicDashboardsEnabled?: InputMaybe<Scalars['Boolean']['input']>
  workspaceId: Scalars['String']['input']
}

/** Available BigQuery export report names */
export enum BigQueryExportName {
  AllClients = 'AllClients',
  AllInvoices = 'AllInvoices',
  BankDraft = 'BankDraft',
  Birthdays = 'Birthdays',
  CancellationReport = 'CancellationReport',
  ClientAbsent = 'ClientAbsent',
  ClientCheckInCorporate = 'ClientCheckInCorporate',
  ClientCheckInDetailed = 'ClientCheckInDetailed',
  ClientCheckInSummary = 'ClientCheckInSummary',
  ClientsWithAccountCredit = 'ClientsWithAccountCredit',
  CurrentInventory = 'CurrentInventory',
  Delinquency = 'Delinquency',
  ExpiredSessionCredits = 'ExpiredSessionCredits',
  EzypaySettlement = 'EzypaySettlement',
  FailedPayment = 'FailedPayment',
  FailedPaymentHistory = 'FailedPaymentHistory',
  FirstVisits = 'FirstVisits',
  GiftCards = 'GiftCards',
  IncomeHandover = 'IncomeHandover',
  LateCancels = 'LateCancels',
  MemberMovement = 'MemberMovement',
  MembershipDetails = 'MembershipDetails',
  MembershipsExpiring = 'MembershipsExpiring',
  NetRevenueDetails = 'NetRevenueDetails',
  NetRevenueInProgress = 'NetRevenueInProgress',
  NewClientReport = 'NewClientReport',
  NoShow = 'NoShow',
  POSHistory = 'POSHistory',
  PayrollReport = 'PayrollReport',
  PostcodeReport = 'PostcodeReport',
  ProjectedRevenue = 'ProjectedRevenue',
  PromoCodeUsage = 'PromoCodeUsage',
  Referrals = 'Referrals',
  RevenueTags = 'RevenueTags',
  RevenueUsed = 'RevenueUsed',
  SalesAndPaymentReport = 'SalesAndPaymentReport',
  SalesByService = 'SalesByService',
  SessionCreditsRemaining = 'SessionCreditsRemaining',
  SessionFeedback = 'SessionFeedback',
  StripeCardUpdater = 'StripeCardUpdater',
  StripeSettlement = 'StripeSettlement',
  SuspendedMemberships = 'SuspendedMemberships',
}

export enum BillingCycleUnit {
  MONTHS = 'MONTHS',
  WEEKS = 'WEEKS',
  YEARS = 'YEARS',
}

/** Input for creating a block slot */
export interface BlockSlotCreateInput {
  date: Scalars['String']['input']
  description?: InputMaybe<Scalars['String']['input']>
  endTime: Scalars['String']['input']
  name: Scalars['String']['input']
  siteLocationId: Scalars['String']['input']
  siteLocationRoomId?: InputMaybe<Scalars['String']['input']>
  staffUserIds?: InputMaybe<Array<Scalars['String']['input']>>
  startTime: Scalars['String']['input']
}

/** Input for creating a booking activity log entry */
export interface BookingActivityLogCreateInput {
  activityType: BookingActivityType
  bookingId: Scalars['String']['input']
  clientId: Scalars['String']['input']
  createdBy?: InputMaybe<Scalars['String']['input']>
  createdByType?: InputMaybe<CreatedByType>
  siteId: Scalars['String']['input']
  value?: InputMaybe<Scalars['String']['input']>
}

export enum BookingActivityType {
  attendance_updated = 'attendance_updated',
  booking_cancelled = 'booking_cancelled',
  booking_created = 'booking_created',
  booking_late_cancelled = 'booking_late_cancelled',
  booking_reinstated = 'booking_reinstated',
  credit_cost_adjusted = 'credit_cost_adjusted',
  credit_package_changed = 'credit_package_changed',
  invitation_accepted = 'invitation_accepted',
  invitation_sent = 'invitation_sent',
  payment_type_changed = 'payment_type_changed',
  session_cancelled = 'session_cancelled',
  spot_changed = 'spot_changed',
  status_changed = 'status_changed',
}

/** Computed booking availability for a session */
export enum BookingAvailability {
  Cancelled = 'Cancelled',
  Closed = 'Closed',
  Completed = 'Completed',
  Full = 'Full',
  Open = 'Open',
  Waitlist = 'Waitlist',
}

/** Input for creating a booking */
export interface BookingCreateInput {
  aggregatorProviderId?: InputMaybe<Scalars['String']['input']>
  bookedByClientId?: InputMaybe<Scalars['String']['input']>
  bookingSource: BookingSource
  clientId: Scalars['String']['input']
  creditOwnerClientId?: InputMaybe<Scalars['String']['input']>
  dropInAmount?: InputMaybe<Scalars['Numeric']['input']>
  externalReferenceId?: InputMaybe<Scalars['String']['input']>
  externalUserId?: InputMaybe<Scalars['String']['input']>
  forFamilyMember?: InputMaybe<Scalars['Boolean']['input']>
  guestServiceId?: InputMaybe<Scalars['ID']['input']>
  invitedByStaffUserId?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  owedBalanceOverride?: InputMaybe<OwedBalanceOverrideInput>
  paymentStatus?: InputMaybe<BookingPaymentStatus>
  selectedServiceIds?: InputMaybe<Array<Scalars['ID']['input']>>
  serviceId?: InputMaybe<Scalars['String']['input']>
  sessionId: Scalars['String']['input']
  sharedServiceId?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<Source>
  spotId?: InputMaybe<Scalars['Float']['input']>
  status?: InputMaybe<BookingStatus>
  totalCreditsRequired?: InputMaybe<Scalars['Float']['input']>
}

export enum BookingCreditPackageIneligibleReason {
  CURRENT_PACKAGE = 'CURRENT_PACKAGE',
  INSUFFICIENT_CREDITS = 'INSUFFICIENT_CREDITS',
  NOT_ACTIVE = 'NOT_ACTIVE',
  NO_ELIGIBLE_CREDITS = 'NO_ELIGIBLE_CREDITS',
  SHARE_ALLOCATION_USED_UP = 'SHARE_ALLOCATION_USED_UP',
  SHARE_LIMIT_REACHED = 'SHARE_LIMIT_REACHED',
}

/** Type of booking fee (no-show or late cancel) */
export enum BookingFeeType {
  LATE_CANCEL = 'LATE_CANCEL',
  NO_SHOW = 'NO_SHOW',
}

export enum BookingPaymentMethodKind {
  ACCOUNT_CREDIT = 'ACCOUNT_CREDIT',
  BANK = 'BANK',
  CARD = 'CARD',
  CASH = 'CASH',
  CREDITS = 'CREDITS',
  CUSTOM = 'CUSTOM',
  DROP_IN = 'DROP_IN',
  FREE = 'FREE',
  GUEST_PASS = 'GUEST_PASS',
}

export enum BookingPaymentStatus {
  paid = 'paid',
  pending = 'pending',
}

export enum BookingSource {
  ADMIN = 'ADMIN',
  AGGREGATOR = 'AGGREGATOR',
  BILLING = 'BILLING',
  CREDIT = 'CREDIT',
  DROP_IN = 'DROP_IN',
  FREE = 'FREE',
  GUEST_PASS = 'GUEST_PASS',
  IMPORT = 'IMPORT',
}

export enum BookingStatus {
  ATTENDED = 'ATTENDED',
  CANCELLED = 'CANCELLED',
  CONFIRMED = 'CONFIRMED',
  DECLINED = 'DECLINED',
  EXPIRED = 'EXPIRED',
  INVITED = 'INVITED',
  LATE_CANCELLED = 'LATE_CANCELLED',
  NO_SHOW = 'NO_SHOW',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
}

/** Input for updating a booking */
export interface BookingUpdateInput {
  bookingSource?: InputMaybe<BookingSource>
  cancelledAt?: InputMaybe<Scalars['String']['input']>
  cancelledBy?: InputMaybe<Scalars['String']['input']>
  confirmedAt?: InputMaybe<Scalars['String']['input']>
  destinationFeeInvoiceId?: InputMaybe<Scalars['ID']['input']>
  dropInAmount?: InputMaybe<Scalars['Numeric']['input']>
  dropInInvoiceId?: InputMaybe<Scalars['String']['input']>
  invitationAcceptedAt?: InputMaybe<Scalars['String']['input']>
  lateCancelCreditsKept?: InputMaybe<Scalars['Float']['input']>
  lateCancelFeeInvoiceId?: InputMaybe<Scalars['String']['input']>
  noShowFeeInvoiceId?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  paymentStatus?: InputMaybe<BookingPaymentStatus>
  spotId?: InputMaybe<Scalars['Float']['input']>
  status?: InputMaybe<BookingStatus>
  totalCreditsRequired?: InputMaybe<Scalars['Float']['input']>
}

/** A brand add-on as the form sends it. */
export interface BrandAddOnConfigInput {
  agreementEnabled: Scalars['Boolean']['input']
  agreementSendConfirmation?: InputMaybe<Scalars['Boolean']['input']>
  agreementText?: InputMaybe<Scalars['String']['input']>
  credits: Array<BrandAddOnCreditLineInput>
  currency?: InputMaybe<Currency>
  description?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  pricePoints: Array<BrandAddOnPricePointInput>
}

/** A credit line of a brand add-on as the form sends it. */
export interface BrandAddOnCreditLineInput {
  amount?: InputMaybe<Scalars['Float']['input']>
  corporateSessionTypeIds: Array<Scalars['ID']['input']>
  creditLineId: Scalars['ID']['input']
  creditsType: CreditType
}

/** A field of a brand add-on that a location can change and the brand can push. */
export enum BrandAddOnField {
  agreement = 'agreement',
  creditLine = 'creditLine',
  description = 'description',
  name = 'name',
  parents = 'parents',
  paymentType = 'paymentType',
  price = 'price',
  tax = 'tax',
}

/** A price of a brand add-on as the form sends it. */
export interface BrandAddOnPricePointInput {
  corporateTaxSettingIds?: InputMaybe<Array<Scalars['ID']['input']>>
  parentCorporateServiceTemplateIds: Array<Scalars['ID']['input']>
  paymentType: ServiceTemplateAddOnPaymentType
  price: Scalars['Numeric']['input']
  pricePointId: Scalars['ID']['input']
  taxEnabled: Scalars['Boolean']['input']
}

/** Why a brand add-on is not linked to one of its memberships at a location: the membership has not reached that location, or is not live. */
export enum BrandAddOnSkippedLinkReason {
  NOT_ACTIVE = 'NOT_ACTIVE',
  NOT_AT_LOCATION = 'NOT_AT_LOCATION',
}

/** A brand artwork slot an operator can upload during onboarding */
export enum BrandArtworkField {
  appIcon = 'appIcon',
  loginLogo = 'loginLogo',
  splashLight = 'splashLight',
}

/** Image formats accepted for brand artwork */
export enum BrandArtworkFormat {
  jpeg = 'jpeg',
  png = 'png',
}

export enum BrandBuildConfigViewStatus {
  incomplete = 'incomplete',
  ready = 'ready',
  unknownBrand = 'unknownBrand',
}

export enum BrandConfigSavedByPersona {
  corporate = 'corporate',
  staff = 'staff',
  system = 'system',
}

export enum BrandEnvironment {
  dev = 'dev',
  local = 'local',
  production = 'production',
  qa = 'qa',
  staging = 'staging',
}

export interface BrandFacebookConfigInput {
  appId: Scalars['String']['input']
  clientToken: Scalars['String']['input']
  displayName: Scalars['String']['input']
}

export enum BrandNativeReleaseReason {
  asset_change = 'asset_change',
  manual = 'manual',
  native_config_change = 'native_config_change',
  new_brand = 'new_brand',
  seed = 'seed',
}

export enum BrandNativeReleaseStatus {
  building = 'building',
  built = 'built',
  dispatched = 'dispatched',
  failed = 'failed',
  inReview = 'inReview',
  pendingDeveloperRelease = 'pendingDeveloperRelease',
  rejected = 'rejected',
  released = 'released',
  requested = 'requested',
  submitted = 'submitted',
  waitingForReview = 'waitingForReview',
}

/** A home-logo or tab-icon slot staff can upload for a brand app */
export enum BrandNavigationArtworkField {
  homeLogo = 'homeLogo',
  tabBookings = 'tabBookings',
  tabExplore = 'tabExplore',
  tabHome = 'tabHome',
  tabMore = 'tabMore',
  tabPackages = 'tabPackages',
}

export enum BrandObservePerfStatus {
  improved = 'improved',
  insufficientData = 'insufficientData',
  regressed = 'regressed',
  steady = 'steady',
}

export enum BrandPlatform {
  android = 'android',
  ios = 'ios',
}

export enum BrandProvisionStatus {
  dispatched = 'dispatched',
  done = 'done',
  failed = 'failed',
  manualRequired = 'manualRequired',
  skipped = 'skipped',
}

export enum BrandProvisionStep {
  androidSigning = 'androidSigning',
  apnsKey = 'apnsKey',
  apnsKeyUpload = 'apnsKeyUpload',
  appPrivacy = 'appPrivacy',
  appRecord = 'appRecord',
  appearance = 'appearance',
  branch = 'branch',
  buildFloor = 'buildFloor',
  easWebhooks = 'easWebhooks',
  expoProject = 'expoProject',
  firebase = 'firebase',
  iosSigning = 'iosSigning',
  mobileConfig = 'mobileConfig',
  oneSignal = 'oneSignal',
  playDataSafety = 'playDataSafety',
  playDeclarations = 'playDeclarations',
  pushApp = 'pushApp',
  reviewerAccount = 'reviewerAccount',
  storeContent = 'storeContent',
  storeWebhooks = 'storeWebhooks',
  testFlight = 'testFlight',
}

export enum BrandProvisioningOwner {
  client = 'client',
  hapana = 'hapana',
}

export enum BrandProvisioningStepStatus {
  blocked = 'blocked',
  dispatched = 'dispatched',
  failed = 'failed',
  skipped = 'skipped',
  succeeded = 'succeeded',
}

export enum BrandPushPath {
  hapana = 'hapana',
  onesignal = 'onesignal',
  undecided = 'undecided',
}

export enum BrandRegistryStatus {
  active = 'active',
  provisioning = 'provisioning',
  retired = 'retired',
  suspended = 'suspended',
}

export enum BrandReleaseRequirement {
  androidAppVersion = 'androidAppVersion',
  androidPackage = 'androidPackage',
  androidSigningCredentials = 'androidSigningCredentials',
  appIcon = 'appIcon',
  appStoreConnectAppId = 'appStoreConnectAppId',
  appleAgreementsSigned = 'appleAgreementsSigned',
  appleCertificateValid = 'appleCertificateValid',
  appleId = 'appleId',
  appleMembershipValid = 'appleMembershipValid',
  appleTeamId = 'appleTeamId',
  branchAppLink = 'branchAppLink',
  brandBuildable = 'brandBuildable',
  brandSlug = 'brandSlug',
  buildConfig = 'buildConfig',
  businessInAppLocation = 'businessInAppLocation',
  businessMembership = 'businessMembership',
  businessPack = 'businessPack',
  businessPaymentGateway = 'businessPaymentGateway',
  businessReadinessUnchecked = 'businessReadinessUnchecked',
  businessReviewerMember = 'businessReviewerMember',
  businessUpcomingClasses = 'businessUpcomingClasses',
  easProjectId = 'easProjectId',
  firebaseAndroidApp = 'firebaseAndroidApp',
  firebaseIosApp = 'firebaseIosApp',
  iosAppVersion = 'iosAppVersion',
  iosBundleId = 'iosBundleId',
  iosSigningCredentials = 'iosSigningCredentials',
  mobileConfigColors = 'mobileConfigColors',
  playStoreId = 'playStoreId',
}

export enum BrandReleaseStoreVerdict {
  pendingDeveloperRelease = 'pendingDeveloperRelease',
  rejected = 'rejected',
  released = 'released',
}

/** How a scheduled go-live time is read: in each location's own timezone, or as one instant in the author's timezone. */
export enum BrandScheduleClock {
  INSTANT = 'INSTANT',
  SITE_LOCAL = 'SITE_LOCAL',
}

/** Why a bulk archive left one alone: it is not one of the brand's, it is not live (a draft, scheduled or already archived), or someone else changed it while the archive ran. */
export enum BrandServiceTemplateArchiveSkipReason {
  CHANGED = 'CHANGED',
  NOT_FOUND = 'NOT_FOUND',
  NOT_LIVE = 'NOT_LIVE',
}

/** Why a location cannot receive a brand membership, package or add-on. */
export enum BrandServiceTemplateBlockedReasonCode {
  CURRENCY_MISMATCH = 'CURRENCY_MISMATCH',
  SESSION_GROUP_UNAVAILABLE = 'SESSION_GROUP_UNAVAILABLE',
  TAX_DISABLED = 'TAX_DISABLED',
  TAX_UNAVAILABLE = 'TAX_UNAVAILABLE',
  VALIDATION = 'VALIDATION',
}

/** What a brand write does at its locations. */
export enum BrandServiceTemplateChangeSetKind {
  ACTIVATE = 'ACTIVATE',
  ARCHIVE = 'ARCHIVE',
  CREATE = 'CREATE',
  EDIT = 'EDIT',
  WITHDRAW = 'WITHDRAW',
}

/** The outcome of a brand write at one location. HELD_BACK: the location could not take it and gets it once it can. */
export enum BrandServiceTemplateChangeSetSiteStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  HELD_BACK = 'HELD_BACK',
  PENDING = 'PENDING',
  SKIPPED = 'SKIPPED',
}

/** How far a brand write has reached its locations. */
export enum BrandServiceTemplateChangeSetStatus {
  COMPLETED = 'COMPLETED',
  EXECUTING = 'EXECUTING',
  PARTIALLY_FAILED = 'PARTIALLY_FAILED',
}

/** Whether a live edit reaches existing clients, or only purchases made after it is published. */
export enum BrandServiceTemplateMemberImpact {
  EXISTING = 'EXISTING',
  NEW_ONLY = 'NEW_ONLY',
}

/** Why a brand membership, package or add-on cannot be published at all. */
export enum BrandServiceTemplateRefusalCode {
  CURRENCY_MISMATCH = 'CURRENCY_MISMATCH',
  NO_CURRENCY = 'NO_CURRENCY',
  PRICING_LOCKED_UNLINKED = 'PRICING_LOCKED_UNLINKED',
  UNKNOWN_PARENT = 'UNKNOWN_PARENT',
}

/** A section of a brand membership, package or add-on that the brand can lock. */
export enum BrandServiceTemplateSection {
  ADD_ON_INFORMATION = 'ADD_ON_INFORMATION',
  AGREEMENTS = 'AGREEMENTS',
  PRICING = 'PRICING',
}

/** How a brand write is applied at one location. ARCHIVE takes the whole add-on off sale; WITHDRAW takes it off one location the brand removed; LINK adds the memberships and packages that have reached the location since. */
export enum BrandServiceTemplateSiteAction {
  ACTIVATE = 'ACTIVATE',
  ARCHIVE = 'ARCHIVE',
  CREATE = 'CREATE',
  FORK = 'FORK',
  IN_PLACE = 'IN_PLACE',
  LINK = 'LINK',
  WITHDRAW = 'WITHDRAW',
}

/** A brand item and the locations the person confirmed taking it off sale at. */
export interface BrandServiceTemplateWithdrawalAcknowledgementInput {
  corporateServiceTemplateId: Scalars['ID']['input']
  siteIds: Array<Scalars['ID']['input']>
}

export enum BrandSetupEvidence {
  attestation = 'attestation',
  firebaseApps = 'firebaseApps',
  readiness = 'readiness',
  signInClients = 'signInClients',
}

export enum BrandSetupStep {
  appStoreRecord = 'appStoreRecord',
  appleAccount = 'appleAccount',
  deepLinks = 'deepLinks',
  firebaseConfig = 'firebaseConfig',
  iosBundleId = 'iosBundleId',
  playStoreApp = 'playStoreApp',
  storeListing = 'storeListing',
  supportSignIn = 'supportSignIn',
}

export enum BrandSetupStepState {
  actionable = 'actionable',
  awaitingAttestation = 'awaitingAttestation',
  blocked = 'blocked',
  degrading = 'degrading',
  satisfied = 'satisfied',
}

export enum BrandStatus {
  active = 'active',
  inactive = 'inactive',
}

export enum BrandStoreAssetFormat {
  jpeg = 'jpeg',
  jpg = 'jpg',
  png = 'png',
}

export enum BrandStoreAssetStatus {
  invalid = 'invalid',
  staged = 'staged',
  valid = 'valid',
}

export enum BrandStoreAssetType {
  app_icon = 'app_icon',
  app_preview = 'app_preview',
  feature_graphic = 'feature_graphic',
  screenshot = 'screenshot',
}

export enum BrandStoreListingPublicationStatus {
  live = 'live',
  needs_attention = 'needs_attention',
  not_submitted = 'not_submitted',
  submitted = 'submitted',
}

export enum BrandStoreOperationAction {
  promote_release = 'promote_release',
  release_testflight = 'release_testflight',
  setup_testflight = 'setup_testflight',
  submit_review = 'submit_review',
  sync_app_information = 'sync_app_information',
  sync_availability = 'sync_availability',
  sync_listing = 'sync_listing',
  sync_pricing = 'sync_pricing',
  sync_review_detail = 'sync_review_detail',
  sync_status = 'sync_status',
  sync_testers = 'sync_testers',
  upload_assets = 'upload_assets',
}

export enum BrandStoreOperationStatus {
  failed = 'failed',
  queued = 'queued',
  running = 'running',
  succeeded = 'succeeded',
}

export enum BrandStoreProvider {
  app_store_connect = 'app_store_connect',
  expo = 'expo',
  google_play = 'google_play',
}

export enum BrandStoreSnapshotStatus {
  attention_required = 'attention_required',
  failed = 'failed',
  not_configured = 'not_configured',
  ready = 'ready',
  syncing = 'syncing',
}

export enum BrandStoreTesterSource {
  corporate_contact = 'corporate_contact',
  hapana_staff = 'hapana_staff',
}

/** The EAS update channel a brand build listens on */
export enum BrandUpdateChannel {
  development = 'development',
  release = 'release',
}

/** Mobile app branding image field names */
export enum BrandingImageFieldName {
  appIconUrl = 'appIconUrl',
  logoUrl = 'logoUrl',
  splashScreenDarkUrl = 'splashScreenDarkUrl',
  splashScreenUrl = 'splashScreenUrl',
}

export enum BuildConfigSource {
  core = 'core',
  environment = 'environment',
  fleetDefault = 'fleetDefault',
  registry = 'registry',
}

export interface BulkAddSmsPackageOptionsInputInput {
  /** Array of pricing options to add */
  options: Array<AddSmsPackageOptionInputInput>
}

/** A single invoice with its known current date for a bulk schedule date update. */
export interface BulkUpdateInvoiceScheduleDateItem {
  currentDate: Scalars['String']['input']
  invoiceId: Scalars['String']['input']
}

/** Input for bulk shifting invoice dates by a delta. Each invoice includes its current date from the FE to avoid re-deriving it on the backend. Positive deltaDays = forward, negative = backward. */
export interface BulkUpdateInvoiceScheduleDatesInput {
  deltaDays: Scalars['Float']['input']
  invoices: Array<BulkUpdateInvoiceScheduleDateItem>
}

/** Input for bulk updating invoice amounts */
export interface BulkUpdateInvoicesInput {
  invoiceIds: Array<Scalars['String']['input']>
  totalAmount: Scalars['Numeric']['input']
}

/** Smart bulk amount update for mixed invoice types. Routes pre-sale, single, and recurring invoices to their correct service methods. Per-item error isolation. Setting totalAmount to 0 applies a full discount to pre-sale invoices. */
export interface BulkUpdateScheduledAmountsInput {
  invoiceIds: Array<Scalars['String']['input']>
  totalAmount: Scalars['Numeric']['input']
}

/** Smart bulk date shift for mixed invoice types. Routes pre-sale, single, and recurring invoices to their correct service methods. Per-item error isolation — a failure does not roll back other items. */
export interface BulkUpdateScheduledDatesInput {
  deltaDays: Scalars['Float']['input']
  invoices: Array<BulkUpdateInvoiceScheduleDateItem>
  memberNotification?: InputMaybe<MemberNotificationInput>
  shortfallAction?: InputMaybe<PresaleShortfallAction>
}

/** Business profile tab options */
export enum BusinessProfileTab {
  CLIENTS = 'CLIENTS',
  HOME = 'HOME',
  REPORTS = 'REPORTS',
  RETAIL = 'RETAIL',
  SCHEDULE = 'SCHEDULE',
}

export enum BusinessType {
  crossfit = 'crossfit',
  cycling = 'cycling',
  dance = 'dance',
  fitness_gym = 'fitness_gym',
  gym = 'gym',
  martial_arts = 'martial_arts',
  other = 'other',
  pilates = 'pilates',
  swimming = 'swimming',
  yoga = 'yoga',
}

export interface CalculateCartItemsAddOnAttachmentInput {
  parentServiceId?: InputMaybe<Scalars['ID']['input']>
  parentServiceTemplateId?: InputMaybe<Scalars['ID']['input']>
}

export interface CalculateCartItemsInput {
  addOnAttachment?: InputMaybe<CalculateCartItemsAddOnAttachmentInput>
  additionalCredits?: InputMaybe<Scalars['Float']['input']>
  billingCycleAmount?: InputMaybe<Scalars['Float']['input']>
  billingCycleUnit?: InputMaybe<Scalars['String']['input']>
  billingDay?: InputMaybe<Scalars['Float']['input']>
  chargeSetupFeeUpFront?: InputMaybe<Scalars['Boolean']['input']>
  discountType?: InputMaybe<DiscountType>
  discountValue?: InputMaybe<Scalars['String']['input']>
  giftCardTemplateId?: InputMaybe<Scalars['ID']['input']>
  itemId: Scalars['String']['input']
  itemType?: InputMaybe<SaleItemType>
  lengthAmount?: InputMaybe<Scalars['Float']['input']>
  lengthUnit?: InputMaybe<Scalars['String']['input']>
  oneTimeSetupFee?: InputMaybe<Scalars['String']['input']>
  oneTimeSetupFeeTaxSettingIds: Array<Scalars['String']['input']>
  payUpFront?: InputMaybe<Scalars['Boolean']['input']>
  paymentDate?: InputMaybe<Scalars['String']['input']>
  primaryCreditLineType?: InputMaybe<CreditType>
  productTemplateId?: InputMaybe<Scalars['ID']['input']>
  quantity: Scalars['Float']['input']
  revenueTagId?: InputMaybe<Scalars['ID']['input']>
  secondaryRecurringFeeAmount?: InputMaybe<Scalars['String']['input']>
  secondaryRecurringFeeBillingCycleAmount?: InputMaybe<Scalars['Float']['input']>
  secondaryRecurringFeeBillingCycleUnit?: InputMaybe<Scalars['String']['input']>
  secondaryRecurringFeeTaxSettingIds: Array<Scalars['String']['input']>
  serviceStartDate?: InputMaybe<Scalars['String']['input']>
  serviceTemplateId?: InputMaybe<Scalars['String']['input']>
  taxSettingIds: Array<Scalars['String']['input']>
  totalCredits?: InputMaybe<Scalars['Float']['input']>
  unitPrice: Scalars['String']['input']
}

/** released = the parked payment was cancelled at the gateway and the invoice released; already_closed = nothing was awaiting the member any more, so nothing was cancelled; succeeded = the bank had already approved the charge, so the payment settled instead */
export enum CancelPendingClientActionOutcome {
  already_closed = 'already_closed',
  released = 'released',
  succeeded = 'succeeded',
}

/** Input for canceling a membership plan change that is awaiting payment */
export interface CancelPendingPaymentPlanChangeInput {
  servicePlanChangeId: Scalars['ID']['input']
  siteId: Scalars['ID']['input']
}

/** Input for canceling a scheduled membership plan change */
export interface CancelScheduledPlanChangeInput {
  servicePlanChangeId: Scalars['ID']['input']
  siteId: Scalars['ID']['input']
}

/** Input for cancelling a session */
export interface CancelSessionInput {
  includeModifiedSessions?: InputMaybe<Scalars['Boolean']['input']>
  message?: InputMaybe<Scalars['String']['input']>
  notificationMethods: Array<NotificationMethod>
  overrideDownstreamSplits?: InputMaybe<Scalars['Boolean']['input']>
  scope: CancelSessionScope
  sessionId: Scalars['String']['input']
  siteId: Scalars['String']['input']
  subject?: InputMaybe<Scalars['String']['input']>
}

/** Scope of session cancellation */
export enum CancelSessionScope {
  future = 'future',
  single = 'single',
}

/** Input for batch cancelling multiple sessions */
export interface CancelSessionsBatchInput {
  message?: InputMaybe<Scalars['String']['input']>
  notificationMethods: Array<NotificationMethod>
  sessionIds: Array<Scalars['String']['input']>
  siteId: Scalars['String']['input']
  subject?: InputMaybe<Scalars['String']['input']>
}

/** Sessions to cancel, one by one, while a location is temporarily closed */
export interface CancelSessionsForClosureInput {
  message?: InputMaybe<Scalars['String']['input']>
  notificationMethods: Array<NotificationMethod>
  sessionIds: Array<Scalars['String']['input']>
  siteAlertId: Scalars['ID']['input']
  siteId: Scalars['ID']['input']
  subject?: InputMaybe<Scalars['String']['input']>
}

export enum CancellationEffectiveDateRule {
  AFTER_NOTICE = 'AFTER_NOTICE',
  IMMEDIATE = 'IMMEDIATE',
  NEXT_BILLING_DATE_AFTER_NOTICE = 'NEXT_BILLING_DATE_AFTER_NOTICE',
}

export enum CancellationFeeBreakdownKind {
  FIXED_AMOUNT = 'FIXED_AMOUNT',
  FLAT_CHARGE = 'FLAT_CHARGE',
  PERCENT_OF_CYCLE = 'PERCENT_OF_CYCLE',
  REMAINING_TERM = 'REMAINING_TERM',
}

export enum CancellationFeeSource {
  FEE_SCHEDULE = 'FEE_SCHEDULE',
  FLAT_CHARGE = 'FLAT_CHARGE',
  NONE = 'NONE',
}

export enum CancellationFeeValueKind {
  FIXED_AMOUNT = 'FIXED_AMOUNT',
  PERCENT_OF_CYCLE = 'PERCENT_OF_CYCLE',
  REMAINING_TERM = 'REMAINING_TERM',
}

export enum CancellationNoticePeriodUnit {
  DAYS = 'DAYS',
  MONTHS = 'MONTHS',
  WEEKS = 'WEEKS',
}

export enum CancellationPreviewBlocker {
  ALREADY_SCHEDULED = 'ALREADY_SCHEDULED',
  CANCELLATION_DISABLED = 'CANCELLATION_DISABLED',
  FAILED_INVOICES = 'FAILED_INVOICES',
  MEMBERSHIP_PAUSED = 'MEMBERSHIP_PAUSED',
  MINIMUM_TERM = 'MINIMUM_TERM',
}

export enum CancellationTierBasis {
  MONTHS_ELAPSED = 'MONTHS_ELAPSED',
  TERM_PERCENT = 'TERM_PERCENT',
}

/** Type of card funding */
export enum CardFunding {
  Credit = 'Credit',
  Debit = 'Debit',
  Prepaid = 'Prepaid',
  Unknown = 'Unknown',
}

/** Status of a cash drawer session */
export enum CashDrawerSessionStatus {
  closed = 'closed',
  open = 'open',
}

/** Whether a cash drawer history row is a payment, a refund, or a void/payout adjustment */
export enum CashDrawerTransactionKind {
  Payment = 'Payment',
  Payout = 'Payout',
  Refund = 'Refund',
  Void = 'Void',
}

export enum CatalogOrderBy {
  publishedAt = 'publishedAt',
  sortOrder = 'sortOrder',
}

/** Input for an immediate or scheduled membership plan change */
export interface ChangeMembershipPlanInput {
  /** Collect the pro-rated amount in the staff checkout instead of charging the default payment method. The plan change is held and applies only when that invoice is paid. Immediate upgrades of active memberships only. */
  collectAtCheckout?: InputMaybe<Scalars['Boolean']['input']>
  customPrice?: InputMaybe<Scalars['String']['input']>
  effectiveType: ServicePlanChangeEffectiveType
  /** Where to refund the first cycle difference. Only read when the first invoice is already paid and the new plan is cheaper. */
  firstCycleRefundMethod?: InputMaybe<RefundType>
  reason?: InputMaybe<Scalars['String']['input']>
  replaceExistingScheduled?: InputMaybe<Scalars['Boolean']['input']>
  serviceId: Scalars['ID']['input']
  signedClientAgreementId?: InputMaybe<Scalars['ID']['input']>
  siteId: Scalars['ID']['input']
  toServiceTemplateId: Scalars['ID']['input']
}

export enum CheckInAttemptStatus {
  FAIL = 'FAIL',
  NOT_RECOGNISED = 'NOT_RECOGNISED',
  SUCCESS = 'SUCCESS',
}

export enum CheckInAuditFailReason {
  AGGREGATOR_DECLINED = 'AGGREGATOR_DECLINED',
  AGGREGATOR_VALIDATION_REQUIRED = 'AGGREGATOR_VALIDATION_REQUIRED',
  BLOCKED = 'BLOCKED',
  BOOKING_PAYMENT_PENDING = 'BOOKING_PAYMENT_PENDING',
  BOOKING_REQUIRED = 'BOOKING_REQUIRED',
  CHECKIN_DISABLED = 'CHECKIN_DISABLED',
  CHECK_IN_WINDOW_EXPIRED = 'CHECK_IN_WINDOW_EXPIRED',
  CLASS_IN_PROGRESS = 'CLASS_IN_PROGRESS',
  DUPLICATE_FOB = 'DUPLICATE_FOB',
  FAILED_PAYMENTS = 'FAILED_PAYMENTS',
  MEMBERSHIP_ON_HOLD = 'MEMBERSHIP_ON_HOLD',
  MEMBERSHIP_WINDOW = 'MEMBERSHIP_WINDOW',
  NOT_IN_TIME = 'NOT_IN_TIME',
  NO_ACTIVE_PACKAGE = 'NO_ACTIVE_PACKAGE',
  NO_CREDITS = 'NO_CREDITS',
  NO_VALID_MEMBERSHIP_OR_BOOKING = 'NO_VALID_MEMBERSHIP_OR_BOOKING',
  PROSPECT = 'PROSPECT',
  QUESTIONNAIRE_FAILED = 'QUESTIONNAIRE_FAILED',
  SCAN_METHOD_NOT_ALLOWED = 'SCAN_METHOD_NOT_ALLOWED',
  SECONDARY_DOOR_NOT_A_CHECKIN = 'SECONDARY_DOOR_NOT_A_CHECKIN',
  SPACE_BLOCKED = 'SPACE_BLOCKED',
  SUSPENDED = 'SUSPENDED',
  UNKNOWN_ACCESS_POINT = 'UNKNOWN_ACCESS_POINT',
  UNKNOWN_FOB = 'UNKNOWN_FOB',
  WHO_CAN_ENTER = 'WHO_CAN_ENTER',
  ZONE_SCHEDULE = 'ZONE_SCHEDULE',
  ZONE_SCHEDULE_UNRESOLVABLE = 'ZONE_SCHEDULE_UNRESOLVABLE',
}

export enum CheckInFailReason {
  AGGREGATOR_DECLINED = 'AGGREGATOR_DECLINED',
  AGGREGATOR_VALIDATION_REQUIRED = 'AGGREGATOR_VALIDATION_REQUIRED',
  BOOKING_PAYMENT_PENDING = 'BOOKING_PAYMENT_PENDING',
  CHECK_IN_WINDOW_EXPIRED = 'CHECK_IN_WINDOW_EXPIRED',
  FAILED_PAYMENTS = 'FAILED_PAYMENTS',
  MEMBERSHIP_ON_HOLD = 'MEMBERSHIP_ON_HOLD',
  NOT_IN_TIME = 'NOT_IN_TIME',
  NO_ACTIVE_PACKAGE = 'NO_ACTIVE_PACKAGE',
  NO_CREDITS = 'NO_CREDITS',
  NO_VALID_MEMBERSHIP_OR_BOOKING = 'NO_VALID_MEMBERSHIP_OR_BOOKING',
  QUESTIONNAIRE_FAILED = 'QUESTIONNAIRE_FAILED',
  SUSPENDED = 'SUSPENDED',
}

export enum CheckInSource {
  AGGREGATOR = 'AGGREGATOR',
  BARCODE_DEVICE_SCAN = 'BARCODE_DEVICE_SCAN',
  BARCODE_SCAN = 'BARCODE_SCAN',
  CONTACTLESS = 'CONTACTLESS',
  CORE = 'CORE',
  FOB_DEVICE_SCAN = 'FOB_DEVICE_SCAN',
  FOB_SCAN = 'FOB_SCAN',
  IMPORT = 'IMPORT',
  IN_APP = 'IN_APP',
  KIOSK = 'KIOSK',
  PUBLIC_API = 'PUBLIC_API',
  QR_CODE = 'QR_CODE',
  WIDGET = 'WIDGET',
}

export enum CheckInStatus {
  FAIL = 'FAIL',
  SUCCESS = 'SUCCESS',
  UNKNOWN = 'UNKNOWN',
}

export enum CheckInType {
  GENERAL = 'GENERAL',
  SESSION = 'SESSION',
  TANNING = 'TANNING',
  ZONE = 'ZONE',
}

export interface ChooseIncomingMovementDestinationInput {
  destinationServiceTemplateId: Scalars['ID']['input']
  memberMovementId: Scalars['ID']['input']
  saveAsBrandMapping?: InputMaybe<Scalars['Boolean']['input']>
}

/** Input for claiming a guest pass invite by token */
export interface ClaimGuestPassInput {
  dateOfBirth?: InputMaybe<Scalars['String']['input']>
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  phone?: InputMaybe<Scalars['String']['input']>
  policies?: InputMaybe<Scalars['String']['input']>
  token: Scalars['String']['input']
}

/** What a client activity feed row records */
export enum ClientActivityFeedKind {
  BOOKING = 'BOOKING',
  ZONE_CHECK_IN = 'ZONE_CHECK_IN',
}

export interface ClientActivityStreamPaginatedOrderByInput {
  column: ActivityStreamOrderByColumn
  direction: OrderByDirection
}

export interface ClientAgreementsWithPaginationFiltersInput {
  status?: InputMaybe<ClientAgreementsWithPaginationFiltersStatusInput>
}

export interface ClientAgreementsWithPaginationFiltersStatusInput {
  value: AgreementStatus
}

/** Status of a client booking buddy relationship */
export enum ClientBookingBuddyStatus {
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  PENDING = 'PENDING',
  REVOKED = 'REVOKED',
}

/** Columns that can be used to sort client bookings */
export enum ClientBookingOrderByColumn {
  sessionDate = 'sessionDate',
  sessionName = 'sessionName',
}

export interface ClientBookingsPaginatedOrderByInput {
  column: ClientBookingOrderByColumn
  direction: OrderByDirection
}

export interface ClientContactLogsFiltersChannelInput {
  value: Scalars['String']['input']
}

export interface ClientContactLogsFiltersInput {
  channel?: InputMaybe<ClientContactLogsFiltersChannelInput>
  sentAt?: InputMaybe<ClientContactLogsFiltersSentAtInput>
}

export interface ClientContactLogsFiltersSentAtInput {
  value: Array<Scalars['String']['input']>
}

/** Type of relationship in ClientFamily */
export enum ClientFamilyRelationship {
  CHILD = 'CHILD',
  FRIEND = 'FRIEND',
  LEGAL_GUARDIAN = 'LEGAL_GUARDIAN',
  OTHER = 'OTHER',
  PARENT = 'PARENT',
  PARTNER = 'PARTNER',
  SIBLING = 'SIBLING',
  SPOUSE = 'SPOUSE',
}

export interface ClientFilesWithPaginationFiltersFileTypeInput {
  value: Scalars['String']['input']
}

export interface ClientFilesWithPaginationFiltersInput {
  fileType?: InputMaybe<ClientFilesWithPaginationFiltersFileTypeInput>
}

/** Client filters with specific validation per filter type */
export interface ClientFilters {
  ageRange?: InputMaybe<ClientFiltersAgeRangeInput>
  attendanceMilestone?: InputMaybe<ClientFiltersNoShowLateCancelAccrualInput>
  birthMonth?: InputMaybe<ClientFiltersGenderInput>
  clientStatus?: InputMaybe<ClientFiltersGenderInput>
  contractStatus?: InputMaybe<ClientFiltersGenderInput>
  contractType?: InputMaybe<ClientFiltersGenderInput>
  daysAbsent?: InputMaybe<ClientFiltersAgeRangeInput>
  daysInactive?: InputMaybe<ClientFiltersAgeRangeInput>
  email?: InputMaybe<ClientFiltersFirstNameInput>
  emailOptIn?: InputMaybe<ClientFiltersGenderInput>
  failedPaymentsCount?: InputMaybe<ClientFiltersNoShowLateCancelAccrualInput>
  firstName?: InputMaybe<ClientFiltersFirstNameInput>
  fullName?: InputMaybe<ClientFiltersFirstNameInput>
  gender?: InputMaybe<ClientFiltersGenderInput>
  hasCreditsForSessionType?: InputMaybe<ClientFiltersHasCreditsForSessionTypeInput>
  isSuspended?: InputMaybe<ClientFiltersGenderInput>
  joinDate?: InputMaybe<ClientFiltersJoinDateInput>
  lastAttendanceDate?: InputMaybe<ClientFiltersJoinDateInput>
  lastName?: InputMaybe<ClientFiltersFirstNameInput>
  lastPaymentDate?: InputMaybe<ClientFiltersJoinDateInput>
  lastVisitDate?: InputMaybe<ClientFiltersJoinDateInput>
  locationStatus?: InputMaybe<ClientFiltersGenderInput>
  masterUnsubscribe?: InputMaybe<ClientFiltersGenderInput>
  noShowLateCancelAccrual?: InputMaybe<ClientFiltersNoShowLateCancelAccrualInput>
  phone?: InputMaybe<ClientFiltersFirstNameInput>
  profileCreatedDate?: InputMaybe<ClientFiltersJoinDateInput>
  sessionFrequency?: InputMaybe<ClientFiltersGenderInput>
  smsOptIn?: InputMaybe<ClientFiltersGenderInput>
}

export interface ClientFiltersAgeRangeInput {
  logicalOperator: LogicalOperator
  orderIndex?: InputMaybe<Scalars['Float']['input']>
  using: Array<ClientFiltersAgeRangeUsingInput>
}

export interface ClientFiltersAgeRangeUsingInput {
  max?: InputMaybe<Scalars['String']['input']>
  min?: InputMaybe<Scalars['String']['input']>
  operator: NumericToDateFilterOperator
  value?: InputMaybe<Scalars['String']['input']>
}

export interface ClientFiltersFirstNameInput {
  logicalOperator: LogicalOperator
  orderIndex?: InputMaybe<Scalars['Float']['input']>
  using: Array<ClientFiltersFirstNameUsingInput>
}

export interface ClientFiltersFirstNameUsingInput {
  operator: TextFilterOperator
  value: Scalars['String']['input']
}

export interface ClientFiltersGenderInput {
  logicalOperator: LogicalOperator
  orderIndex?: InputMaybe<Scalars['Float']['input']>
  using: Array<ClientFiltersGenderUsingInput>
}

export interface ClientFiltersGenderUsingInput {
  operator: SelectFilterOperator
  value: Array<Scalars['String']['input']>
}

export interface ClientFiltersHasCreditsForSessionTypeInput {
  bookingDate?: InputMaybe<Scalars['String']['input']>
  siteSessionTypeId: Scalars['ID']['input']
}

export interface ClientFiltersJoinDateInput {
  logicalOperator: LogicalOperator
  orderIndex?: InputMaybe<Scalars['Float']['input']>
  using: Array<ClientFiltersJoinDateUsingInput>
}

export interface ClientFiltersJoinDateUsingInput {
  from?: InputMaybe<Scalars['String']['input']>
  operator: DateFilterOperator
  to?: InputMaybe<Scalars['String']['input']>
  value?: InputMaybe<Scalars['String']['input']>
}

export interface ClientFiltersNoShowLateCancelAccrualInput {
  logicalOperator: LogicalOperator
  orderIndex?: InputMaybe<Scalars['Float']['input']>
  using: Array<ClientFiltersNoShowLateCancelAccrualUsingInput>
}

export interface ClientFiltersNoShowLateCancelAccrualUsingInput {
  max?: InputMaybe<Scalars['Float']['input']>
  min?: InputMaybe<Scalars['Float']['input']>
  operator: NumericFilterOperator
  value?: InputMaybe<Scalars['Float']['input']>
}

export interface ClientFormSubmissionsWithPaginationFiltersInput {
  status?: InputMaybe<ClientFormSubmissionsWithPaginationFiltersStatusInput>
}

export interface ClientFormSubmissionsWithPaginationFiltersStatusInput {
  value: Scalars['String']['input']
}

/** Grow sync status for a client, overall or per-location */
export enum ClientGrowSyncStatus {
  FAILED = 'FAILED',
  NOT_SYNCED = 'NOT_SYNCED',
  PENDING = 'PENDING',
  SYNCED = 'SYNCED',
  SYNCING = 'SYNCING',
}

/** Input for creating a client note */
export interface ClientNoteCreateInput {
  clientId: Scalars['String']['input']
  content?: InputMaybe<Scalars['String']['input']>
}

/** Input for updating a client note */
export interface ClientNoteUpdateInput {
  content?: InputMaybe<Scalars['String']['input']>
}

export enum ClientOrderBy {
  createdAt = 'createdAt',
  email = 'email',
  firstName = 'firstName',
  lastName = 'lastName',
  updatedAt = 'updatedAt',
}

/** Status of a client payment method */
export enum ClientPaymentMethodStatus {
  Active = 'Active',
  Canceled = 'Canceled',
  Created = 'Created',
  Deleted = 'Deleted',
  Failed = 'Failed',
  Processing = 'Processing',
}

/** Type of client payment method */
export enum ClientPaymentMethodType {
  Bank = 'Bank',
  Card = 'Card',
  Unknown = 'Unknown',
}

/** Client profile tab options for system preferences */
export enum ClientProfileTab {
  CONTACT_LOGS = 'CONTACT_LOGS',
  DOCUMENTS = 'DOCUMENTS',
  INFORMATION = 'INFORMATION',
  NOTES = 'NOTES',
  OVERVIEW = 'OVERVIEW',
  PACKAGES = 'PACKAGES',
  PAYMENT = 'PAYMENT',
  SCHEDULE = 'SCHEDULE',
  SOAP_SESSION = 'SOAP_SESSION',
}

/** Status of a client relation */
export enum ClientRelationStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING',
  REVOKED = 'REVOKED',
}

/** Stored client-to-client relation kind */
export enum ClientRelationType {
  BUDDY = 'BUDDY',
  EMPLOYEE = 'EMPLOYEE',
  FAMILY = 'FAMILY',
  OTHER = 'OTHER',
  SHARED = 'SHARED',
}

/** Relation kind as surfaced in the unified Relations view */
export enum ClientRelationViewType {
  BUDDY = 'BUDDY',
  FAMILY = 'FAMILY',
  OTHER = 'OTHER',
  SHARED = 'SHARED',
}

export enum ClientServicesSortBy {
  createdAt = 'createdAt',
  expiresAt = 'expiresAt',
  name = 'name',
  startsAt = 'startsAt',
}

/** How an automatically created client-site link came to exist */
export enum ClientSiteLinkSource {
  CHECK_IN = 'CHECK_IN',
  IMPORT = 'IMPORT',
}

/** Source of client creation */
export enum ClientSource {
  AGGREGATOR = 'AGGREGATOR',
  APP = 'APP',
  APP_WEB_SIGNUP = 'APP_WEB_SIGNUP',
  BUSINESS_ADDED = 'BUSINESS_ADDED',
  CLIENT_REFERRAL = 'CLIENT_REFERRAL',
  EMBED_CREATED = 'EMBED_CREATED',
  HAPANA = 'HAPANA',
  KIOSK = 'KIOSK',
  MIGRATION_IMPORTED = 'MIGRATION_IMPORTED',
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
  STAFF = 'STAFF',
  THIRD_PARTY = 'THIRD_PARTY',
  WEB = 'WEB',
}

/** Actor type for timeline event initiator */
export enum ClientTimelineActorType {
  MEMBER = 'MEMBER',
  STAFF = 'STAFF',
  SYSTEM = 'SYSTEM',
  UNKNOWN = 'UNKNOWN',
}

/** Event type for client timeline entries */
export enum ClientTimelineEventType {
  ACCESS_EVENT = 'ACCESS_EVENT',
  ASSIGNED_STAFF_CHANGED = 'ASSIGNED_STAFF_CHANGED',
  BOOKING_CANCELLED = 'BOOKING_CANCELLED',
  BOOKING_CREATED = 'BOOKING_CREATED',
  BOOKING_LATE_CANCELLED = 'BOOKING_LATE_CANCELLED',
  BOOKING_NO_SHOW = 'BOOKING_NO_SHOW',
  CHECK_IN = 'CHECK_IN',
  COMMISSION_OWNER_CHANGED = 'COMMISSION_OWNER_CHANGED',
  COMMUNICATION_EMAIL = 'COMMUNICATION_EMAIL',
  COMMUNICATION_PUSH = 'COMMUNICATION_PUSH',
  COMMUNICATION_SMS = 'COMMUNICATION_SMS',
  ECOMMERCE_PURCHASE = 'ECOMMERCE_PURCHASE',
  INVOICE_CANCELLED = 'INVOICE_CANCELLED',
  INVOICE_ISSUED = 'INVOICE_ISSUED',
  INVOICE_REINSTATED = 'INVOICE_REINSTATED',
  MEMBERSHIP_STATUS_CHANGED = 'MEMBERSHIP_STATUS_CHANGED',
  NOTE_CREATED = 'NOTE_CREATED',
  PACKAGE_SHARING_CHANGED = 'PACKAGE_SHARING_CHANGED',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  PAYMENT_MADE = 'PAYMENT_MADE',
  PAYMENT_PROCESSING = 'PAYMENT_PROCESSING',
  REFUND_ISSUED = 'REFUND_ISSUED',
  SESSION_ATTENDED = 'SESSION_ATTENDED',
  TANNING_SESSION_REVERSED = 'TANNING_SESSION_REVERSED',
  WAITLIST_JOINED = 'WAITLIST_JOINED',
  WAITLIST_REMOVED = 'WAITLIST_REMOVED',
}

/** Normalized platform where timeline event originated */
export enum ClientTimelinePlatform {
  CORE = 'CORE',
  INTEGRATION = 'INTEGRATION',
  KIOSK = 'KIOSK',
  MOBILE = 'MOBILE',
  SYSTEM = 'SYSTEM',
  UNKNOWN = 'UNKNOWN',
  WEB_EMBED = 'WEB_EMBED',
}

/** Underlying source used to build timeline event */
export enum ClientTimelineSource {
  AUDIT = 'AUDIT',
  BOOKING_ACTIVITY = 'BOOKING_ACTIVITY',
  CHECKINS = 'CHECKINS',
  COMMUNICATIONS = 'COMMUNICATIONS',
  ECOMMERCE = 'ECOMMERCE',
  NOTES = 'NOTES',
  WAITLIST = 'WAITLIST',
}

/** Whether a client is a person or an organisation that pays for its employees */
export enum ClientType {
  ORGANISATION = 'ORGANISATION',
  PERSON = 'PERSON',
}

export interface ClientsOrderByInput {
  column: ClientOrderBy
  direction: OrderByDirection
}

/** Whether a staff shift is open (IN), closed (OUT), or a missed clock-out (INCOMPLETE) */
export enum ClockStatus {
  IN = 'IN',
  INCOMPLETE = 'INCOMPLETE',
  OUT = 'OUT',
}

export enum CloseReason {
  lost_to_competitor = 'lost_to_competitor',
  no_budget = 'no_budget',
  no_response = 'no_response',
  other = 'other',
  wrong_fit = 'wrong_fit',
  wrong_icp = 'wrong_icp',
  wrong_timing = 'wrong_timing',
}

/** Common input for date-ranged CMS analytics queries */
export interface CmsAnalyticsDateRangeInput {
  corporateId: Scalars['String']['input']
  endDate: Scalars['String']['input']
  siteIds?: InputMaybe<Array<Scalars['String']['input']>>
  startDate: Scalars['String']['input']
}

/** Input for CMS analytics queries that do not require a date range */
export interface CmsAnalyticsSiteInput {
  corporateId: Scalars['String']['input']
  siteIds?: InputMaybe<Array<Scalars['String']['input']>>
}

export interface CmsContentEntryCreateImageMetadataFocalPointInput {
  x: Scalars['Float']['input']
  y: Scalars['Float']['input']
}

export interface CmsContentEntryCreateImageMetadataInput {
  focalPoint?: InputMaybe<CmsContentEntryCreateImageMetadataFocalPointInput>
  format?: InputMaybe<Scalars['String']['input']>
  gcsPath?: InputMaybe<Scalars['String']['input']>
  height?: InputMaybe<Scalars['Float']['input']>
  variants?: InputMaybe<Scalars['JSONObject']['input']>
  width?: InputMaybe<Scalars['Float']['input']>
}

/** Input for creating a new content entry */
export interface CmsContentEntryCreateInput {
  bodyHtml?: InputMaybe<Scalars['String']['input']>
  bodyMarkdown?: InputMaybe<Scalars['String']['input']>
  contentTypeId: Scalars['ID']['input']
  coverMediaId?: InputMaybe<Scalars['ID']['input']>
  createdAtLevel: ContentEntryLevel
  createdAtSiteId?: InputMaybe<Scalars['ID']['input']>
  excludedRegionIds?: InputMaybe<Array<Scalars['ID']['input']>>
  excludedSiteIds?: InputMaybe<Array<Scalars['ID']['input']>>
  externalSource?: InputMaybe<Scalars['String']['input']>
  fields?: InputMaybe<Scalars['JSONObject']['input']>
  imageMetadata?: InputMaybe<CmsContentEntryCreateImageMetadataInput>
  imageUrl?: InputMaybe<Scalars['String']['input']>
  includedRegionIds?: InputMaybe<Array<Scalars['ID']['input']>>
  includedSiteIds?: InputMaybe<Array<Scalars['ID']['input']>>
  instructorIds?: InputMaybe<Array<Scalars['ID']['input']>>
  packageExclusionIds?: InputMaybe<Array<Scalars['ID']['input']>>
  packageExclusionNames?: InputMaybe<Array<Scalars['String']['input']>>
  packageIds?: InputMaybe<Array<Scalars['ID']['input']>>
  packageNames?: InputMaybe<Array<Scalars['String']['input']>>
  sortOrder: Scalars['Float']['input']
  status: ContentStatus
  title: Scalars['String']['input']
  visibilityScope: VisibilityScope
}

export enum CmsContentEntrySource {
  BRAND = 'BRAND',
  CONTENT_LIBRARY = 'CONTENT_LIBRARY',
}

/** Input for updating an existing content entry */
export interface CmsContentEntryUpdateInput {
  bodyHtml?: InputMaybe<Scalars['String']['input']>
  bodyMarkdown?: InputMaybe<Scalars['String']['input']>
  coverMediaId?: InputMaybe<Scalars['ID']['input']>
  excludedRegionIds?: InputMaybe<Array<Scalars['ID']['input']>>
  excludedSiteIds?: InputMaybe<Array<Scalars['ID']['input']>>
  fields?: InputMaybe<Scalars['JSONObject']['input']>
  imageMetadata?: InputMaybe<CmsContentEntryCreateImageMetadataInput>
  imageUrl?: InputMaybe<Scalars['String']['input']>
  includedRegionIds?: InputMaybe<Array<Scalars['ID']['input']>>
  includedSiteIds?: InputMaybe<Array<Scalars['ID']['input']>>
  instructorIds?: InputMaybe<Array<Scalars['ID']['input']>>
  packageExclusionIds?: InputMaybe<Array<Scalars['ID']['input']>>
  packageExclusionNames?: InputMaybe<Array<Scalars['String']['input']>>
  packageIds?: InputMaybe<Array<Scalars['ID']['input']>>
  packageNames?: InputMaybe<Array<Scalars['String']['input']>>
  sortOrder?: InputMaybe<Scalars['Float']['input']>
  status?: InputMaybe<ContentStatus>
  title?: InputMaybe<Scalars['String']['input']>
  visibilityScope?: InputMaybe<VisibilityScope>
}

/** Input for updating an existing media asset */
export interface CmsContentMediaUpdateInput {
  blurhash?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  fileName?: InputMaybe<Scalars['String']['input']>
  focalPoint?: InputMaybe<CmsContentEntryCreateImageMetadataFocalPointInput>
  folder?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  variants?: InputMaybe<Scalars['JSONObject']['input']>
}

/** Input for scheduling a publish or unpublish action */
export interface CmsContentScheduleCreateInput {
  action: ScheduleAction
  contentEntryId: Scalars['ID']['input']
  contentVersionId?: InputMaybe<Scalars['ID']['input']>
  scheduledAt: Scalars['String']['input']
}

/** Input for creating a content target */
export interface CmsContentTargetCreateInput {
  targetId: Scalars['ID']['input']
  targetType: TargetType
}

/** Which kind of custom (non-catalog) name to list: package, tag, or instructor. */
export enum CmsCustomEntryKind {
  instructor = 'instructor',
  package = 'package',
  tag = 'tag',
}

/** Time granularity for trend data */
export enum CmsGranularity {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
}

/** Type of change detected during preview */
export enum CmsImportChangeType {
  NEW = 'NEW',
  UNCHANGED = 'UNCHANGED',
  UPDATED = 'UPDATED',
}

/** Mapping status of a preview item */
export enum CmsImportMappingStatus {
  CONFLICT = 'CONFLICT',
  MAPPED = 'MAPPED',
  PARTIAL = 'PARTIAL',
  SKIPPED = 'SKIPPED',
  UNMAPPED = 'UNMAPPED',
}

/** Write strategy — INSERT (skip existing), REPLACE (update existing), or INCREMENTAL (new items only) */
export enum CmsImportMode {
  INCREMENTAL = 'INCREMENTAL',
  INSERT = 'INSERT',
  REPLACE = 'REPLACE',
}

/** Options for configuring an import run */
export interface CmsImportOptionsInput {
  importMode?: InputMaybe<CmsImportMode>
  jwPlayerCompressedRendition?: InputMaybe<Scalars['Boolean']['input']>
  jwPlayerExcludeDrafts?: InputMaybe<Scalars['Boolean']['input']>
  jwPlayerLinkedOnly?: InputMaybe<Scalars['Boolean']['input']>
  skipContentfulAssets?: InputMaybe<Scalars['Boolean']['input']>
  skipJWPlayer?: InputMaybe<Scalars['Boolean']['input']>
  skipMongoDB?: InputMaybe<Scalars['Boolean']['input']>
  skipV1Aurora?: InputMaybe<Scalars['Boolean']['input']>
  skipV1ChallengeData?: InputMaybe<Scalars['Boolean']['input']>
  stepByStep?: InputMaybe<Scalars['Boolean']['input']>
}

/** Status of a content import run */
export enum CmsImportRunStatus {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  CONFIGURING = 'CONFIGURING',
  EXECUTING = 'EXECUTING',
  FAILED = 'FAILED',
  PREVIEWING = 'PREVIEWING',
  ROLLED_BACK = 'ROLLED_BACK',
  VERIFYING = 'VERIFYING',
}

/** Status of an import step */
export enum CmsImportStepStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PAUSED = 'PAUSED',
  PENDING = 'PENDING',
  RUNNING = 'RUNNING',
  SKIPPED = 'SKIPPED',
}

/** Type of import step */
export enum CmsImportStepType {
  CONTENTFUL_ASSETS = 'CONTENTFUL_ASSETS',
  CONTENTFUL_ENTRIES = 'CONTENTFUL_ENTRIES',
  JWPLAYER_VIDEOS = 'JWPLAYER_VIDEOS',
  MONGODB_CHALLENGES = 'MONGODB_CHALLENGES',
  MONGODB_METRICS = 'MONGODB_METRICS',
  V1_AURORA_CONTENT = 'V1_AURORA_CONTENT',
  VERIFICATION = 'VERIFICATION',
}

/** Input for top videos query */
export interface CmsTopVideosInput {
  corporateId: Scalars['String']['input']
  endDate: Scalars['String']['input']
  siteIds?: InputMaybe<Array<Scalars['String']['input']>>
  sortBy?: InputMaybe<CmsVideoSortBy>
  startDate: Scalars['String']['input']
}

/** Input for per-video analytics */
export interface CmsVideoAnalyticsInput {
  contentMediaId: Scalars['String']['input']
  corporateId: Scalars['String']['input']
  endDate: Scalars['String']['input']
  startDate: Scalars['String']['input']
}

/** Input for video engagement trend */
export interface CmsVideoEngagementTrendInput {
  corporateId: Scalars['String']['input']
  endDate: Scalars['String']['input']
  granularity?: InputMaybe<CmsGranularity>
  startDate: Scalars['String']['input']
}

/** Sort criteria for top videos */
export enum CmsVideoSortBy {
  AVG_WATCH_TIME = 'AVG_WATCH_TIME',
  COMPLETION_RATE = 'COMPLETION_RATE',
  TOTAL_VIEWS = 'TOTAL_VIEWS',
  UNIQUE_VIEWERS = 'UNIQUE_VIEWERS',
}

export enum ColumnFormat {
  enum = 'enum',
}

/** Who is making the communication preferences update */
export enum CommPrefsSource {
  CLIENT = 'CLIENT',
  STAFF = 'STAFF',
}

export interface CommissionAttributionResolutionInput {
  serviceId: Scalars['ID']['input']
  staffUserId: Scalars['ID']['input']
}

export enum CommissionAttributionSourceSetting {
  ASSIGNED_STAFF = 'ASSIGNED_STAFF',
  PROCESSED_BY = 'PROCESSED_BY',
  SOLD_BY = 'SOLD_BY',
}

export enum CommissionBase {
  GROSS_INCLUDING_TAX = 'GROSS_INCLUDING_TAX',
  NET_OF_TAX = 'NET_OF_TAX',
}

export enum CommissionCategory {
  ADD_ON = 'ADD_ON',
  DISHONOUR_FEE = 'DISHONOUR_FEE',
  GIFT_CARD = 'GIFT_CARD',
  INTRO_OFFER = 'INTRO_OFFER',
  JOINING_FEE = 'JOINING_FEE',
  MEMBERSHIP = 'MEMBERSHIP',
  MEMBERSHIP_SIGNUP = 'MEMBERSHIP_SIGNUP',
  PACK = 'PACK',
  RETAIL = 'RETAIL',
  SINGLE_PAYMENT = 'SINGLE_PAYMENT',
  SINGLE_VISIT = 'SINGLE_VISIT',
}

export enum CommissionDashboardEmployeeStatus {
  FINALISED = 'FINALISED',
  PAID = 'PAID',
  READY = 'READY',
  REVIEW = 'REVIEW',
}

/** Filters for the commission dashboard; every field is optional */
export interface CommissionDashboardInput {
  category?: InputMaybe<Scalars['String']['input']>
  commissionPeriodId?: InputMaybe<Scalars['String']['input']>
  siteIds?: InputMaybe<Array<Scalars['ID']['input']>>
  staffUserId?: InputMaybe<Scalars['ID']['input']>
}

export enum CommissionDashboardReviewReason {
  CLAWBACK = 'CLAWBACK',
  LATE = 'LATE',
  NEGATIVE = 'NEGATIVE',
}

export enum CommissionEarnerRole {
  MANAGER = 'MANAGER',
  SELLER = 'SELLER',
}

export enum CommissionEnablementReason {
  ACTIVATION = 'ACTIVATION',
  DISABLED_BY_ADMIN = 'DISABLED_BY_ADMIN',
  ENTITLEMENT_LOST = 'ENTITLEMENT_LOST',
  RE_ENABLED = 'RE_ENABLED',
}

export enum CommissionEventKind {
  CANCELLATION = 'CANCELLATION',
  CANCELLATION_REVERSED = 'CANCELLATION_REVERSED',
  PAYMENT = 'PAYMENT',
  RECALC = 'RECALC',
  REFUND = 'REFUND',
}

export enum CommissionEventStatus {
  EXCLUDED = 'EXCLUDED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  PROCESSED = 'PROCESSED',
  SKIPPED_DISABLED = 'SKIPPED_DISABLED',
}

export interface CommissionItemRefInput {
  itemId: Scalars['String']['input']
  itemType: CommissionItemType
}

export enum CommissionItemSettingSource {
  BRAND = 'BRAND',
  DEFAULT = 'DEFAULT',
  LOCATION = 'LOCATION',
}

export enum CommissionItemType {
  BOOKING = 'BOOKING',
  GIFT_CARD = 'GIFT_CARD',
  PRODUCT = 'PRODUCT',
  TEMPLATE = 'TEMPLATE',
}

export enum CommissionLeaverRule {
  STOP = 'STOP',
  TO_MANAGER = 'TO_MANAGER',
}

export enum CommissionLineKind {
  ADJUSTMENT = 'ADJUSTMENT',
  CARRY_IN = 'CARRY_IN',
  CARRY_OUT = 'CARRY_OUT',
  CARRY_REVERSAL = 'CARRY_REVERSAL',
  CLAWBACK = 'CLAWBACK',
  EARN = 'EARN',
  TIER_TRUE_UP = 'TIER_TRUE_UP',
  TIER_TRUE_UP_REVERSAL = 'TIER_TRUE_UP_REVERSAL',
  UPFRONT = 'UPFRONT',
}

export enum CommissionManagerScope {
  LOCATION = 'LOCATION',
  TEAM = 'TEAM',
}

export enum CommissionOwnerChangeMode {
  FUTURE = 'FUTURE',
  RECALC_FROM = 'RECALC_FROM',
}

export enum CommissionPeriodLength {
  FORTNIGHTLY = 'FORTNIGHTLY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
}

export enum CommissionPeriodStatus {
  CLOSED = 'CLOSED',
  CLOSING = 'CLOSING',
  OPEN = 'OPEN',
  PAID = 'PAID',
  REOPENED = 'REOPENED',
  REVIEW = 'REVIEW',
}

export enum CommissionPeriodTransitionTarget {
  CLOSED = 'CLOSED',
  PAID = 'PAID',
  REOPENED = 'REOPENED',
}

export enum CommissionPlanScope {
  BRAND = 'BRAND',
  LOCATION = 'LOCATION',
}

export enum CommissionPlanSource {
  BRAND_ROLE = 'BRAND_ROLE',
  INDIVIDUAL = 'INDIVIDUAL',
  LOCATION_ROLE = 'LOCATION_ROLE',
  NONE = 'NONE',
}

export enum CommissionPlanStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export enum CommunicationTemplateAliases {
  ALLOCATE_WITHOUT_PAYMENT = 'ALLOCATE_WITHOUT_PAYMENT',
  ASSESSMENT_REMINDER_TO_CLIENT = 'ASSESSMENT_REMINDER_TO_CLIENT',
  BACKUP_CARD_CHARGED = 'BACKUP_CARD_CHARGED',
  BIRTHDAY_MESSAGE_TO_CLIENT = 'BIRTHDAY_MESSAGE_TO_CLIENT',
  BOOKING_CONFIRMATION_WITH_RESOURCES = 'BOOKING_CONFIRMATION_WITH_RESOURCES',
  BOOKING_REQUEST_ACCEPTED = 'BOOKING_REQUEST_ACCEPTED',
  BOOKING_REQUEST_CONFIRMATION = 'BOOKING_REQUEST_CONFIRMATION',
  BOOKING_REQUEST_DECLINED = 'BOOKING_REQUEST_DECLINED',
  BOOKING_REQUEST_RESCHEDULE = 'BOOKING_REQUEST_RESCHEDULE',
  CANCEL_CLIENT_FROM_SINGLE_SESSION_CLASS = 'CANCEL_CLIENT_FROM_SINGLE_SESSION_CLASS',
  CHANGED_EMAIL_ADDRESS = 'CHANGED_EMAIL_ADDRESS',
  CLASS_BOOKING_CONFIRMATION_RECURRING = 'CLASS_BOOKING_CONFIRMATION_RECURRING',
  CLASS_BOOKING_CONFIRMATION_SINGLE = 'CLASS_BOOKING_CONFIRMATION_SINGLE',
  CLASS_BOOKING_NOTIFICATION_TO_BUSINESS = 'CLASS_BOOKING_NOTIFICATION_TO_BUSINESS',
  CLIENT_EARLY_CANCEL = 'CLIENT_EARLY_CANCEL',
  CLIENT_FORM_HANDOFF_APP = 'CLIENT_FORM_HANDOFF_APP',
  CLIENT_FORM_LINK = 'CLIENT_FORM_LINK',
  CLIENT_FORM_SUBMISSION_COPY = 'CLIENT_FORM_SUBMISSION_COPY',
  CLIENT_QUESTIONNAIRE_FORM = 'CLIENT_QUESTIONNAIRE_FORM',
  CONTRACT_SIGNED = 'CONTRACT_SIGNED',
  CONTRACT_TO_SIGN = 'CONTRACT_TO_SIGN',
  CONTRACT_TO_SIGN_AUTO_RENEW = 'CONTRACT_TO_SIGN_AUTO_RENEW',
  COVER_ASSIGNED = 'COVER_ASSIGNED',
  COVER_CLAIMED = 'COVER_CLAIMED',
  COVER_ESCALATED = 'COVER_ESCALATED',
  COVER_FILLED = 'COVER_FILLED',
  COVER_MESSAGE = 'COVER_MESSAGE',
  COVER_OFFER = 'COVER_OFFER',
  COVER_OFFER_TURN = 'COVER_OFFER_TURN',
  COVER_REMINDER = 'COVER_REMINDER',
  COVER_TAKEN = 'COVER_TAKEN',
  COVER_UNFILLED = 'COVER_UNFILLED',
  CREDITS_RUNNING_LOW = 'CREDITS_RUNNING_LOW',
  DELETE_CLIENT_FROM_RECURRING_SESSION_CLASS = 'DELETE_CLIENT_FROM_RECURRING_SESSION_CLASS',
  DELETE_CLIENT_FROM_SINGLE_SESSION_CLASS = 'DELETE_CLIENT_FROM_SINGLE_SESSION_CLASS',
  FAILED_PAYMENT = 'FAILED_PAYMENT',
  FAILED_PAYMENT_GIFTCARD = 'FAILED_PAYMENT_GIFTCARD',
  FAILED_PAYMENT_SINGLE = 'FAILED_PAYMENT_SINGLE',
  FEEDBACK_REQUEST_MANUAL = 'FEEDBACK_REQUEST_MANUAL',
  FIRST_SESSION_EMAIL = 'FIRST_SESSION_EMAIL',
  FIRST_VISIT_ANNIVERSARY = 'FIRST_VISIT_ANNIVERSARY',
  FIRST_VISIT_EMAIL = 'FIRST_VISIT_EMAIL',
  GENERIC_APP_CLIENT_REQUEST_TO_NEW_BUSINESS = 'GENERIC_APP_CLIENT_REQUEST_TO_NEW_BUSINESS',
  GENERIC_APP_CLIENT_REQUEST_TO_OLD_BUSINESS = 'GENERIC_APP_CLIENT_REQUEST_TO_OLD_BUSINESS',
  GIFT_CARD_RECEIPT = 'GIFT_CARD_RECEIPT',
  GIFT_CARD_RECIPIENT = 'GIFT_CARD_RECIPIENT',
  GUEST_PASS_INVITE = 'GUEST_PASS_INVITE',
  INSTRUCTOR_SUBSTITUTED = 'INSTRUCTOR_SUBSTITUTED',
  INVITE_TO_RECURRING_SESSION_OR_CLASS = 'INVITE_TO_RECURRING_SESSION_OR_CLASS',
  INVITE_TO_SINGLE_SESSION_OR_CLASS = 'INVITE_TO_SINGLE_SESSION_OR_CLASS',
  INVOICE_PAYMENT_LOG = 'INVOICE_PAYMENT_LOG',
  INVOICE_REFUNDED = 'INVOICE_REFUNDED',
  MEMBERSHIP_AUTO_RENEW = 'MEMBERSHIP_AUTO_RENEW',
  MEMBERSHIP_CANCELLED = 'MEMBERSHIP_CANCELLED',
  MEMBERSHIP_CARD_EXPIRING = 'MEMBERSHIP_CARD_EXPIRING',
  MEMBERSHIP_RENEWAL_REMINDER = 'MEMBERSHIP_RENEWAL_REMINDER',
  MEMBERSHIP_SUSPENDED = 'MEMBERSHIP_SUSPENDED',
  MEMBERSHIP_UPDATED = 'MEMBERSHIP_UPDATED',
  PAYMENT_3DS_AUTHENTICATION_REQUIRED = 'PAYMENT_3DS_AUTHENTICATION_REQUIRED',
  PAYMENT_RECEIPT = 'PAYMENT_RECEIPT',
  PAYMENT_REQUEST_MEMBERSHIP_PACKAGE = 'PAYMENT_REQUEST_MEMBERSHIP_PACKAGE',
  PAYMENT_REQUEST_RECURRING_PAYMENT = 'PAYMENT_REQUEST_RECURRING_PAYMENT',
  PAYMENT_REQUEST_SINGLE_PACKAGE = 'PAYMENT_REQUEST_SINGLE_PACKAGE',
  PAYMENT_REQUEST_SINGLE_PAYMENT = 'PAYMENT_REQUEST_SINGLE_PAYMENT',
  REMOVE_FROM_SESSION_DUE_TO_INSUFFICIENT_CREDIT = 'REMOVE_FROM_SESSION_DUE_TO_INSUFFICIENT_CREDIT',
  RESERVATION_REMINDER = 'RESERVATION_REMINDER',
  RESET_PASSWORD_FOR_ADMIN_USER = 'RESET_PASSWORD_FOR_ADMIN_USER',
  RESET_PASSWORD_FOR_TEAM_MEMBER = 'RESET_PASSWORD_FOR_TEAM_MEMBER',
  RESET_PASSWORD_TRIGGERED_FROM_BUSINESS = 'RESET_PASSWORD_TRIGGERED_FROM_BUSINESS',
  RESET_PASSWORD_TRIGGERED_FROM_CLIENT = 'RESET_PASSWORD_TRIGGERED_FROM_CLIENT',
  RESOURCE_SPOT_CHANGED = 'RESOURCE_SPOT_CHANGED',
  SESSION_MESSAGE_TO_CLIENT = 'SESSION_MESSAGE_TO_CLIENT',
  SESSION_PACKAGE_EXPIRING_SOON = 'SESSION_PACKAGE_EXPIRING_SOON',
  TEACHER_SUB_NOTIFICATION = 'TEACHER_SUB_NOTIFICATION',
  WAITLIST_BOOKING_CONFIRMATION_BUSINESS = 'WAITLIST_BOOKING_CONFIRMATION_BUSINESS',
  WAITLIST_BOOKING_CONFIRMATION_CLIENT = 'WAITLIST_BOOKING_CONFIRMATION_CLIENT',
  WAITLIST_SPOT_AVAILABLE = 'WAITLIST_SPOT_AVAILABLE',
  WAITLIST_SPOT_CONFIRMATION = 'WAITLIST_SPOT_CONFIRMATION',
  WELCOME_EMAIL_TO_MEMBER = 'WELCOME_EMAIL_TO_MEMBER',
  WELCOME_EMAIL_TO_MEMBER_ALREADY_REGISTERED = 'WELCOME_EMAIL_TO_MEMBER_ALREADY_REGISTERED',
  WELCOME_EMAIL_TO_TEAM_MEMBER = 'WELCOME_EMAIL_TO_TEAM_MEMBER',
  ZOOM_RESERVATION_REMINDER = 'ZOOM_RESERVATION_REMINDER',
}

export enum CommunicationTemplatePlaceholders {
  ACCEPT_LINK = 'ACCEPT_LINK',
  AGREEMENT_CONTENT = 'AGREEMENT_CONTENT',
  AMOUNT = 'AMOUNT',
  AMOUNT_PAID = 'AMOUNT_PAID',
  ASSESSMENT_NAME = 'ASSESSMENT_NAME',
  BACKUP_CARD_BRAND = 'BACKUP_CARD_BRAND',
  BACKUP_CARD_LAST4 = 'BACKUP_CARD_LAST4',
  BILLING_ADJUSTMENT_SUMMARY = 'BILLING_ADJUSTMENT_SUMMARY',
  BILLING_CYCLE = 'BILLING_CYCLE',
  BILLING_FREQUENCY = 'BILLING_FREQUENCY',
  BILLING_PERIOD = 'BILLING_PERIOD',
  BUSINESS_LINK = 'BUSINESS_LINK',
  BUSINESS_LOGO = 'BUSINESS_LOGO',
  BUSINESS_NAME = 'BUSINESS_NAME',
  BUSINESS_PHONE = 'BUSINESS_PHONE',
  BUSINESS_WEBSITE = 'BUSINESS_WEBSITE',
  CANCELLATION_DATE = 'CANCELLATION_DATE',
  CANCELLATION_DEADLINE_DATE = 'CANCELLATION_DEADLINE_DATE',
  CLIENT_EMAIL = 'CLIENT_EMAIL',
  CLIENT_FIRST_NAME = 'CLIENT_FIRST_NAME',
  CLIENT_ID = 'CLIENT_ID',
  CLIENT_LAST_NAME = 'CLIENT_LAST_NAME',
  CLIENT_NAME = 'CLIENT_NAME',
  CLIENT_PHONE = 'CLIENT_PHONE',
  COMPLETED_DATE = 'COMPLETED_DATE',
  CORPORATE_NAME = 'CORPORATE_NAME',
  COVER_BOARD_LINK = 'COVER_BOARD_LINK',
  COVER_CLAIMANT_NAME = 'COVER_CLAIMANT_NAME',
  COVER_CLAIM_LINK = 'COVER_CLAIM_LINK',
  COVER_CLASS_OWNER = 'COVER_CLASS_OWNER',
  COVER_ESCALATION_LINE = 'COVER_ESCALATION_LINE',
  COVER_ESCALATION_TITLE = 'COVER_ESCALATION_TITLE',
  COVER_MESSAGE = 'COVER_MESSAGE',
  COVER_MESSAGE_AUTHOR = 'COVER_MESSAGE_AUTHOR',
  COVER_MESSAGE_RICH_TEXT = 'COVER_MESSAGE_RICH_TEXT',
  COVER_MESSAGE_SMS = 'COVER_MESSAGE_SMS',
  COVER_NOTE = 'COVER_NOTE',
  COVER_NOTE_LINE = 'COVER_NOTE_LINE',
  COVER_QUEUE_LINK = 'COVER_QUEUE_LINK',
  COVER_REQUESTER_NAME = 'COVER_REQUESTER_NAME',
  COVER_RESPOND_BY = 'COVER_RESPOND_BY',
  COVER_SUB_NAME = 'COVER_SUB_NAME',
  COVER_URGENCY_LINE = 'COVER_URGENCY_LINE',
  COVER_URGENCY_PREFIX = 'COVER_URGENCY_PREFIX',
  CURRENCY_SYMBOL = 'CURRENCY_SYMBOL',
  DAYS_OF_WEEK = 'DAYS_OF_WEEK',
  DAYS_UNTIL_EXPIRY = 'DAYS_UNTIL_EXPIRY',
  DECLINED_PAYMENT_METHOD = 'DECLINED_PAYMENT_METHOD',
  DECLINE_LINK = 'DECLINE_LINK',
  EMERGENCY_CONTACT_EMAIL = 'EMERGENCY_CONTACT_EMAIL',
  EMERGENCY_CONTACT_NAME = 'EMERGENCY_CONTACT_NAME',
  EMERGENCY_CONTACT_PHONE = 'EMERGENCY_CONTACT_PHONE',
  END_DATE = 'END_DATE',
  END_TIME = 'END_TIME',
  EXPIRY_DURATION = 'EXPIRY_DURATION',
  EXP_DATE = 'EXP_DATE',
  FEEDBACK_LINK = 'FEEDBACK_LINK',
  FIRST_VISIT_DATE = 'FIRST_VISIT_DATE',
  FIRST_VISIT_INSTRUCTOR = 'FIRST_VISIT_INSTRUCTOR',
  FIRST_VISIT_SESSION_NAME = 'FIRST_VISIT_SESSION_NAME',
  FORM_ANSWERS = 'FORM_ANSWERS',
  FORM_LINK = 'FORM_LINK',
  FORM_NAME = 'FORM_NAME',
  FORM_RESULT = 'FORM_RESULT',
  FROM_EMAIL = 'FROM_EMAIL',
  FROM_NAME = 'FROM_NAME',
  GENERIC_APP_CLIENT_NAME = 'GENERIC_APP_CLIENT_NAME',
  GIFT_CARD_DESIGN = 'GIFT_CARD_DESIGN',
  GIFT_CARD_EXPIRY_DATE = 'GIFT_CARD_EXPIRY_DATE',
  GIFT_CARD_NAME = 'GIFT_CARD_NAME',
  GIFT_CARD_NUMBER = 'GIFT_CARD_NUMBER',
  GIFT_CARD_VALUE = 'GIFT_CARD_VALUE',
  GUEST_PASS_LINK = 'GUEST_PASS_LINK',
  INSTRUCTOR = 'INSTRUCTOR',
  INSTRUCTOR_FIRST_NAME = 'INSTRUCTOR_FIRST_NAME',
  INVOICE_AMOUNT = 'INVOICE_AMOUNT',
  INVOICE_DATE = 'INVOICE_DATE',
  INVOICE_LINK = 'INVOICE_LINK',
  INVOICE_NUMBER = 'INVOICE_NUMBER',
  LINK_TO_AGREEMENT = 'LINK_TO_AGREEMENT',
  LOCATION = 'LOCATION',
  LOCATION_ADDRESS = 'LOCATION_ADDRESS',
  LOGIN_LINK = 'LOGIN_LINK',
  LOGIN_URL = 'LOGIN_URL',
  LOGO_URL = 'LOGO_URL',
  MASTER_ADMIN_FIRST_NAME = 'MASTER_ADMIN_FIRST_NAME',
  MEMBERSHIP_NAME = 'MEMBERSHIP_NAME',
  NEW_INSTRUCTOR_NAME = 'NEW_INSTRUCTOR_NAME',
  NEXT_PAYMENT_AMOUNT = 'NEXT_PAYMENT_AMOUNT',
  NEXT_PAYMENT_DATE = 'NEXT_PAYMENT_DATE',
  OLD_INSTRUCTOR_NAME = 'OLD_INSTRUCTOR_NAME',
  PACKAGE_NAME = 'PACKAGE_NAME',
  PASSWORD = 'PASSWORD',
  PAYMENT_AMOUNT = 'PAYMENT_AMOUNT',
  PAYMENT_APPROVAL_EXPIRES_AT = 'PAYMENT_APPROVAL_EXPIRES_AT',
  PAYMENT_APPROVAL_LINK = 'PAYMENT_APPROVAL_LINK',
  PAYMENT_CARD_LABEL = 'PAYMENT_CARD_LABEL',
  PAYMENT_DATE = 'PAYMENT_DATE',
  PAYMENT_DESCRIPTION = 'PAYMENT_DESCRIPTION',
  PAYMENT_FAILURE_REASON = 'PAYMENT_FAILURE_REASON',
  PERSONAL_MESSAGE = 'PERSONAL_MESSAGE',
  PREVIOUS_START_DATE = 'PREVIOUS_START_DATE',
  RECURRING_TYPE = 'RECURRING_TYPE',
  REFUND_AMOUNT = 'REFUND_AMOUNT',
  REFUND_TYPE = 'REFUND_TYPE',
  REMAINING_CREDITS = 'REMAINING_CREDITS',
  RENEWAL_DATE = 'RENEWAL_DATE',
  RENEWAL_PRICE = 'RENEWAL_PRICE',
  RENEWAL_TERM = 'RENEWAL_TERM',
  RESERVATION_DATES = 'RESERVATION_DATES',
  RESET_PASSWORD_LINK = 'RESET_PASSWORD_LINK',
  RESOURCE_NUMBER = 'RESOURCE_NUMBER',
  SESSION_IMAGE_HTML = 'SESSION_IMAGE_HTML',
  SESSION_MESSAGE = 'SESSION_MESSAGE',
  SESSION_NAME = 'SESSION_NAME',
  SESSION_SERIES = 'SESSION_SERIES',
  SESSION_TYPE = 'SESSION_TYPE',
  SIGNUP_LINK = 'SIGNUP_LINK',
  STAFF_ACTION_FIRST_NAME = 'STAFF_ACTION_FIRST_NAME',
  STAFF_FIRST_NAME = 'STAFF_FIRST_NAME',
  START_DATE = 'START_DATE',
  START_TIME = 'START_TIME',
  SUSPEND_END = 'SUSPEND_END',
  SUSPEND_START = 'SUSPEND_START',
  TO_NAME = 'TO_NAME',
  UNSUBSCRIBE_LINK = 'UNSUBSCRIBE_LINK',
  UPDATE_MESSAGE = 'UPDATE_MESSAGE',
  WAITLIST_LINK = 'WAITLIST_LINK',
  ZOOM_JOIN_URL = 'ZOOM_JOIN_URL',
}

/** Type of communication channel (EMAIL, SMS, or PUSH) */
export enum CommunicationType {
  EMAIL = 'EMAIL',
  PUSH = 'PUSH',
  SMS = 'SMS',
}

export interface CompleteMediaUploadInputInput {
  blurhash?: InputMaybe<Scalars['String']['input']>
  contentMediaId: Scalars['ID']['input']
  duration?: InputMaybe<Scalars['Float']['input']>
  height?: InputMaybe<Scalars['Float']['input']>
  width?: InputMaybe<Scalars['Float']['input']>
}

/** Staff reason for starting a UV session although the location requires a current skin type assessment */
export interface ComplianceOverrideInput {
  reason: Scalars['String']['input']
}

/** Who recorded a consent or permission withdrawal */
export enum ConsentWithdrawalSource {
  INBOUND_STOP = 'INBOUND_STOP',
  SIGNER = 'SIGNER',
  STAFF_ON_BEHALF = 'STAFF_ON_BEHALF',
}

export enum ContactlessCheckInFormQuestionType {
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  NUMBER = 'NUMBER',
  TEMPERATURE = 'TEMPERATURE',
  TEXT = 'TEXT',
  YES_NO = 'YES_NO',
}

export enum ContentApiKeyStatus {
  active = 'active',
  revoked = 'revoked',
}

/** Action to perform on content entries in bulk */
export enum ContentBulkAction {
  ARCHIVE = 'ARCHIVE',
  DELETE = 'DELETE',
  PERMANENTLY_DELETE = 'PERMANENTLY_DELETE',
  PUBLISH = 'PUBLISH',
  UNPUBLISH = 'UNPUBLISH',
}

export interface ContentEntriesFiltersInput {
  categoryEntryId?: InputMaybe<Scalars['ID']['input']>
  contentTypeGroup?: InputMaybe<ContentTypeGroup>
  contentTypeId?: InputMaybe<Scalars['ID']['input']>
  createdAtLevel?: InputMaybe<ContentEntryLevel>
  createdAtSiteId?: InputMaybe<Scalars['ID']['input']>
  excludeStatus?: InputMaybe<ContentStatus>
  source?: InputMaybe<CmsContentEntrySource>
  status?: InputMaybe<ContentStatus>
}

export interface ContentEntriesOrderByInput {
  column: ContentEntryOrderBy
  direction: OrderByDirection
}

/** Level at which the content entry was created */
export enum ContentEntryLevel {
  CORPORATE = 'CORPORATE',
  SITE = 'SITE',
}

/** Columns available for ordering content entry lists */
export enum ContentEntryOrderBy {
  createdAt = 'createdAt',
  publishedAt = 'publishedAt',
  sortOrder = 'sortOrder',
  title = 'title',
  updatedAt = 'updatedAt',
}

export interface ContentMediaLibraryFiltersInput {
  folder?: InputMaybe<Scalars['String']['input']>
  mediaType?: InputMaybe<MediaType>
  mediaTypes?: InputMaybe<Array<MediaType>>
  mimeType?: InputMaybe<Scalars['String']['input']>
  tags?: InputMaybe<Array<Scalars['String']['input']>>
}

export interface ContentMediaLibraryOrderByInput {
  column: MediaOrderBy
  direction: OrderByDirection
}

/** Lifecycle status of a content entry */
export enum ContentStatus {
  ARCHIVED = 'ARCHIVED',
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  SCHEDULED = 'SCHEDULED',
}

/** Grouping of content types for organization */
export enum ContentTypeGroup {
  ARTICLE = 'ARTICLE',
  BANNER = 'BANNER',
  FEATURE = 'FEATURE',
  TAXONOMY = 'TAXONOMY',
}

/** Where a video plays from when it is not a Hapana-hosted file */
export enum ContentVideoSource {
  CONTENT_LIBRARY = 'CONTENT_LIBRARY',
}

export enum CoreAppServiceKeyName {
  branchLiveKey = 'branchLiveKey',
  branchTestKey = 'branchTestKey',
  oneSignalAppId = 'oneSignalAppId',
}

export enum CorePlanLevel {
  basic = 'basic',
  enterprise = 'enterprise',
  premium = 'premium',
  standard = 'standard',
}

/** A brand add-on as the form holds it, saved or not, to preview a publish of. With selectedGroupKeys, a saved add-on is previewed with only those changes applied, as Save & publish would. */
export interface CorporateAddOnDryRunInput {
  assignedSiteGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>
  assignedSiteIds?: InputMaybe<Array<Scalars['ID']['input']>>
  config: BrandAddOnConfigInput
  corporateServiceTemplateId?: InputMaybe<Scalars['ID']['input']>
  isAllLocations: Scalars['Boolean']['input']
  lockedSections?: InputMaybe<Array<BrandServiceTemplateSection>>
  selectedGroupKeys?: InputMaybe<Array<Scalars['String']['input']>>
}

/** Input for updating a corporate communication template */
export interface CorporateCommunicationTemplateUpdateInput {
  alias: CommunicationTemplateAliases
  emailBody?: InputMaybe<Scalars['String']['input']>
  emailCcEmail?: InputMaybe<Scalars['String']['input']>
  emailCcLocation?: InputMaybe<Scalars['Boolean']['input']>
  emailCopyEmployee?: InputMaybe<EmailCopyEmployee>
  emailReplyToEmail?: InputMaybe<Scalars['String']['input']>
  emailReplyToName?: InputMaybe<Scalars['String']['input']>
  emailSendBefore?: InputMaybe<Scalars['Float']['input']>
  emailSendBeforeUnit?: InputMaybe<EmailSendBeforeUnit>
  emailSendCalendarAttachment?: InputMaybe<Scalars['Boolean']['input']>
  emailSendEmailAs?: InputMaybe<EmailSendAs>
  emailSendOnlyToActiveClients?: InputMaybe<Scalars['Boolean']['input']>
  emailSubject?: InputMaybe<Scalars['String']['input']>
  emailUseHapanaLayout?: InputMaybe<Scalars['Boolean']['input']>
  enableEmail?: InputMaybe<Scalars['Boolean']['input']>
  enablePush?: InputMaybe<Scalars['Boolean']['input']>
  enableSms?: InputMaybe<Scalars['Boolean']['input']>
  ignoredSitesIds?: InputMaybe<Array<Scalars['ID']['input']>>
  pushMessage?: InputMaybe<Scalars['String']['input']>
  pushTitle?: InputMaybe<Scalars['String']['input']>
  smsMessage?: InputMaybe<Scalars['String']['input']>
  targetedServiceTemplateIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

/** Input for updating a corporate communication template version */
export interface CorporateCommunicationTemplateVersionUpdateInput {
  assignedSiteGroups?: InputMaybe<Array<Scalars['String']['input']>>
  assignedSites?: InputMaybe<Array<Scalars['String']['input']>>
  emailBody?: InputMaybe<Scalars['String']['input']>
  emailCcEmail?: InputMaybe<Scalars['String']['input']>
  emailCcLocation?: InputMaybe<Scalars['Boolean']['input']>
  emailCopyEmployee?: InputMaybe<EmailCopyEmployee>
  emailReplyToEmail?: InputMaybe<Scalars['String']['input']>
  emailReplyToName?: InputMaybe<Scalars['String']['input']>
  emailSendBefore?: InputMaybe<Scalars['Float']['input']>
  emailSendBeforeUnit?: InputMaybe<EmailSendBeforeUnit>
  emailSendCalendarAttachment?: InputMaybe<Scalars['Boolean']['input']>
  emailSendEmailAs?: InputMaybe<EmailSendAs>
  emailSendOnlyToActiveClients?: InputMaybe<Scalars['Boolean']['input']>
  emailSubject?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  pushMessage?: InputMaybe<Scalars['String']['input']>
  pushTitle?: InputMaybe<Scalars['String']['input']>
  smsMessage?: InputMaybe<Scalars['String']['input']>
  targetedServiceTemplateIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export enum CorporateFaqStatus {
  draft = 'draft',
  published = 'published',
}

/** Input for creating a corporate payout account */
export interface CorporatePayoutAccountInput {
  currency: StripePayoutCurrency
  currencyConversionFee: CorporatePayoutAccountPayoutFeeInput
  name: Scalars['String']['input']
  payoutFee: CorporatePayoutAccountPayoutFeeInput
  stripeId: Scalars['String']['input']
}

export enum CorporatePayoutAccountOrderBy {
  createdAt = 'createdAt',
  name = 'name',
  updatedAt = 'updatedAt',
}

export interface CorporatePayoutAccountPayoutFeeInput {
  enabled: Scalars['Boolean']['input']
  rate?: InputMaybe<Scalars['Numeric']['input']>
}

export interface CorporatePayoutAccountsOrderByInput {
  column: CorporatePayoutAccountOrderBy
  direction: OrderByDirection
}

/** Corporate-level permissions for staff users */
export enum CorporatePermissions {
  bi_admin = 'bi_admin',
  bi_explorer = 'bi_explorer',
  bi_exports = 'bi_exports',
  bi_view_only = 'bi_view_only',
  clients__corporate_merge = 'clients__corporate_merge',
  content__configure_permissions = 'content__configure_permissions',
  content__delete = 'content__delete',
  content__moderate = 'content__moderate',
  content__publish = 'content__publish',
  content__read = 'content__read',
  content__view_analytics = 'content__view_analytics',
  content__write = 'content__write',
  corporate__commissions__manage = 'corporate__commissions__manage',
  corporate__commissions__periods = 'corporate__commissions__periods',
  download_exports = 'download_exports',
  manage_add_ons = 'manage_add_ons',
  manage_plan = 'manage_plan',
  marketplace__manage_integrations = 'marketplace__manage_integrations',
  member_movement__approve = 'member_movement__approve',
  member_movement__configure = 'member_movement__configure',
  member_movement__view = 'member_movement__view',
  pii__export_pii = 'pii__export_pii',
  pii__view_contact_details = 'pii__view_contact_details',
  pii__view_full_identity = 'pii__view_full_identity',
  read_controls = 'read_controls',
  security__allowed_networks__manage = 'security__allowed_networks__manage',
  write_controls = 'write_controls',
}

/** Where a brand membership, package or add-on is in its lifecycle. Draft and Scheduled exist only at brand level. */
export enum CorporateServiceTemplateStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  DELETED = 'DELETED',
  DRAFT = 'DRAFT',
  SCHEDULED = 'SCHEDULED',
}

/** The kind of retail item a brand authors: a membership, a package or an add-on. */
export enum CorporateServiceTemplateType {
  ADD_ON = 'ADD_ON',
  MEMBERSHIP = 'MEMBERSHIP',
  PACKAGE = 'PACKAGE',
}

/** A brand membership, package or add-on, and the version the change was made against. A stale version is refused. */
export interface CorporateServiceTemplateVersionInput {
  corporateServiceTemplateId: Scalars['ID']['input']
  expectedVersion: Scalars['Float']['input']
}

/** Why a brand session group name cannot be saved. */
export enum CorporateSessionTypeNameClash {
  DUPLICATE_BRAND_NAME = 'DUPLICATE_BRAND_NAME',
  RESERVED_NAME = 'RESERVED_NAME',
}

/** The name and distribution a brand session group is about to be saved with. Omit the id for a new group; send an empty distribution to preview a delete. */
export interface CorporateSessionTypeSyncPreviewInput {
  assignedSiteGroupIds: Array<Scalars['ID']['input']>
  assignedSiteIds: Array<Scalars['ID']['input']>
  corporateSessionTypeId?: InputMaybe<Scalars['ID']['input']>
  isAllLocations: Scalars['Boolean']['input']
  name: Scalars['String']['input']
}

/** What happens at a location a brand session group stops targeting: remove the session type where nothing uses it and hand over the rest, or hand every one over to the location. */
export enum CorporateSessionTypeWithdrawMode {
  HAND_OVER = 'HAND_OVER',
  REMOVE_UNUSED = 'REMOVE_UNUSED',
}

export enum CorporateTier {
  basic = 'basic',
  premium = 'premium',
  pro = 'pro',
}

export enum CorporateWebhookStatus {
  disabled = 'disabled',
  enabled = 'enabled',
  failing = 'failing',
}

export interface CountriesFilterInput {
  /** Filter by currency code */
  currencyCode?: InputMaybe<Scalars['String']['input']>
  /** Filter by ISO code */
  isoCode?: InputMaybe<Scalars['String']['input']>
}

export enum CountriesOrderBy {
  currencyCode = 'currencyCode',
  isoCode = 'isoCode',
  name = 'name',
}

export interface CountriesOrderByInput {
  column: CountriesOrderBy
  direction: OrderByDirection
}

/** How a cover is decided: first eligible claim wins, a manager picks a claimant, or a manager approves the request before it is offered */
export enum CoverApprovalMode {
  AUTO_FIRST_CLAIM = 'AUTO_FIRST_CLAIM',
  MANAGER_PICK = 'MANAGER_PICK',
  PRE_APPROVE = 'PRE_APPROVE',
}

/** Why a cover request closed */
export enum CoverCancelReason {
  MANAGER_CANCELLED = 'MANAGER_CANCELLED',
  REQUESTER_CANCELLED = 'REQUESTER_CANCELLED',
  REQUESTER_DEACTIVATED = 'REQUESTER_DEACTIVATED',
  SESSION_CANCELLED = 'SESSION_CANCELLED',
}

/** State of one claim on a cover */
export enum CoverClaimStatus {
  FAILED = 'FAILED',
  LOST = 'LOST',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  WITHDRAWN = 'WITHDRAWN',
  WON = 'WON',
}

/** Where a claim came from: the open covers board, a claim link, or a manager */
export enum CoverClaimVia {
  BOARD = 'BOARD',
  LINK = 'LINK',
  MANAGER = 'MANAGER',
}

/** The channel a cover notification attempt went out on */
export enum CoverCommunicationChannel {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
}

/** Whether a cover notification was sent by the system or was a message someone wrote */
export enum CoverCommunicationKind {
  AUTOMATED = 'AUTOMATED',
  MESSAGE = 'MESSAGE',
}

/** Why a cover notification was not sent on a channel */
export enum CoverCommunicationSkipReason {
  NO_CONSENT = 'NO_CONSENT',
  NO_EMAIL = 'NO_EMAIL',
  NO_PHONE = 'NO_PHONE',
  QUIET_HOURS = 'QUIET_HOURS',
}

/** What happened to one cover notification attempt */
export enum CoverCommunicationStatus {
  FAILED = 'FAILED',
  SENT = 'SENT',
  SKIPPED = 'SKIPPED',
}

/** Something a manager should know about an otherwise eligible instructor */
export enum CoverEligibilityWarning {
  OUTSIDE_WORKING_HOURS = 'OUTSIDE_WORKING_HOURS',
}

/** How a cover was filled */
export enum CoverFilledVia {
  CLAIM = 'CLAIM',
  DEADLINE_PICK = 'DEADLINE_PICK',
  MANAGER_ASSIGN = 'MANAGER_ASSIGN',
  MANAGER_PICK = 'MANAGER_PICK',
  SCHEDULE_CHANGE = 'SCHEDULE_CHANGE',
}

export interface CoverImagePositionInput {
  x: Scalars['Float']['input']
  y: Scalars['Float']['input']
}

/** Why an instructor is not offered a cover */
export enum CoverIneligibilityReason {
  ALREADY_TEACHING = 'ALREADY_TEACHING',
  CROSS_SITE_DISABLED = 'CROSS_SITE_DISABLED',
  INACTIVE = 'INACTIVE',
  IS_REQUESTER = 'IS_REQUESTER',
  MISSING_CLAIM_PERMISSION = 'MISSING_CLAIM_PERMISSION',
  NOT_INSTRUCTOR_AT_SITE = 'NOT_INSTRUCTOR_AT_SITE',
  NOT_QUALIFIED = 'NOT_QUALIFIED',
  SCHEDULE_CONFLICT = 'SCHEDULE_CONFLICT',
}

/** Whether booked members are emailed when a cover fills */
export enum CoverMemberNotification {
  OFF = 'OFF',
  ON_FILL = 'ON_FILL',
}

/** How someone a manager can message is connected to a cover */
export enum CoverMessageAudienceRole {
  ASSIGNEE = 'ASSIGNEE',
  CLAIMANT = 'CLAIMANT',
  ELIGIBLE = 'ELIGIBLE',
  OFFERED = 'OFFERED',
  REQUESTER = 'REQUESTER',
}

/** A channel a cover message was sent on */
export enum CoverMessageChannel {
  EMAIL = 'EMAIL',
  IN_APP = 'IN_APP',
  SMS = 'SMS',
}

/** Who a cover message goes to: the thread, everyone eligible, the claimants, the instructor being covered, or chosen people */
export enum CoverMessageRecipientMode {
  ALL_ELIGIBLE = 'ALL_ELIGIBLE',
  CLAIMANTS = 'CLAIMANTS',
  REQUESTER = 'REQUESTER',
  SPECIFIC = 'SPECIFIC',
  THREAD = 'THREAD',
}

/** Where a one-at-a-time cover offer stands for the instructor it was sent to */
export enum CoverOfferStatus {
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  EXPIRED = 'EXPIRED',
  OFFERED = 'OFFERED',
}

/** How a cover is offered: to everyone eligible at once, one ranked preferred sub at a time, or one at a time until a cut-off and then to everyone */
export enum CoverOfferStrategy {
  BLAST = 'BLAST',
  WATERFALL = 'WATERFALL',
  WATERFALL_THEN_BLAST = 'WATERFALL_THEN_BLAST',
}

/** A preferred sub to save for a location */
export interface CoverPreferredSubInput {
  rank: Scalars['Float']['input']
  sessionTypeId?: InputMaybe<Scalars['ID']['input']>
  staffUserId: Scalars['ID']['input']
}

/** Lifecycle state of a class cover request */
export enum CoverRequestStatus {
  CANCELLED = 'CANCELLED',
  CLAIMED = 'CLAIMED',
  ESCALATED = 'ESCALATED',
  FILLED = 'FILLED',
  OPEN = 'OPEN',
  PENDING_RELEASE = 'PENDING_RELEASE',
  UNFILLED = 'UNFILLED',
}

/** Class cover settings to store for a site or the brand default; an empty field inherits the next level up */
export interface CoverSettingsInput {
  approvalMode?: InputMaybe<CoverApprovalMode>
  crossSiteCoversEnabled?: InputMaybe<Scalars['Boolean']['input']>
  escalateBeforeStartMinutes?: InputMaybe<Scalars['Float']['input']>
  lastMinuteThresholdMinutes?: InputMaybe<Scalars['Float']['input']>
  memberNotification?: InputMaybe<CoverMemberNotification>
  offerStrategy?: InputMaybe<CoverOfferStrategy>
  offerWindowMinutes?: InputMaybe<Scalars['Float']['input']>
  quietHoursEnd?: InputMaybe<Scalars['String']['input']>
  quietHoursStart?: InputMaybe<Scalars['String']['input']>
  reminderEnabled?: InputMaybe<Scalars['Boolean']['input']>
  selfServeCutoffMinutes?: InputMaybe<Scalars['Float']['input']>
  showSubMarkerToMembers?: InputMaybe<Scalars['Boolean']['input']>
  smsEnabled?: InputMaybe<Scalars['Boolean']['input']>
  travelBufferMinutes?: InputMaybe<Scalars['Float']['input']>
}

/** The full set of class types a staff member is qualified to cover at a location */
export interface CoverStaffQualificationsInput {
  siteSessionTypeIds: Array<Scalars['ID']['input']>
  staffUserId: Scalars['ID']['input']
}

/** A new price group; a session type already in another group moves to this one */
export interface CreateAddOnPriceGroupInput {
  name: Scalars['String']['input']
  siteId: Scalars['ID']['input']
  siteSessionTypeIds: Array<Scalars['ID']['input']>
  taxSettingIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

/** Input for pre-creating a staged add-on invoice before equipment assignment */
export interface CreateAddonInvoiceInput {
  clientId: Scalars['String']['input']
  equipmentId: Scalars['String']['input']
  siteId: Scalars['String']['input']
  siteSessionTypeId?: InputMaybe<Scalars['String']['input']>
}

export interface CreateAdminAccessGroupInputInput {
  corporates: Array<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  isAllCorporates: Scalars['Boolean']['input']
  isRestricted: Scalars['Boolean']['input']
  name: Scalars['String']['input']
  password?: InputMaybe<Scalars['String']['input']>
  permissions: Array<AdminUserPermissions>
}

/** Input for creating an admin user impersonation session */
export interface CreateAdminUserImpersonationSessionInput {
  corporateId: Scalars['String']['input']
  siteId?: InputMaybe<Scalars['String']['input']>
  staffUserId: Scalars['String']['input']
  urlPrefix: Scalars['String']['input']
}

export interface CreateAdminUserInputInput {
  accessGroupId: Scalars['ID']['input']
  /** Password for protected access groups */
  accessGroupPassword?: InputMaybe<Scalars['String']['input']>
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  phone: Scalars['String']['input']
}

export interface CreateAuditEventDetailsChangesInput {
  displayName?: InputMaybe<Scalars['String']['input']>
  field: Scalars['String']['input']
  fieldType?: InputMaybe<Scalars['String']['input']>
  newValue?: InputMaybe<Scalars['String']['input']>
  oldValue?: InputMaybe<Scalars['String']['input']>
}

export interface CreateAuditEventDetailsInput {
  changes?: InputMaybe<Array<CreateAuditEventDetailsChangesInput>>
  contextJson?: InputMaybe<Scalars['String']['input']>
  metadataJson?: InputMaybe<Scalars['String']['input']>
  newValueJson?: InputMaybe<Scalars['String']['input']>
  previousValueJson?: InputMaybe<Scalars['String']['input']>
  reason?: InputMaybe<Scalars['String']['input']>
  summary?: InputMaybe<Scalars['String']['input']>
}

export interface CreateAuditEventInputInput {
  accessPointId?: InputMaybe<Scalars['String']['input']>
  action: AuditAction
  affectedUserEmail?: InputMaybe<Scalars['String']['input']>
  affectedUserFirstName?: InputMaybe<Scalars['String']['input']>
  affectedUserId?: InputMaybe<Scalars['String']['input']>
  affectedUserLastName?: InputMaybe<Scalars['String']['input']>
  browserName?: InputMaybe<Scalars['String']['input']>
  browserVersion?: InputMaybe<Scalars['String']['input']>
  corporateId: Scalars['String']['input']
  /** Corporate/brand name (denormalized) */
  corporateName?: InputMaybe<Scalars['String']['input']>
  /** Corporate slug for dataset naming */
  corporateSlug?: InputMaybe<Scalars['String']['input']>
  details?: InputMaybe<CreateAuditEventDetailsInput>
  deviceType?: InputMaybe<AuditDeviceType>
  doorId?: InputMaybe<Scalars['String']['input']>
  /** Email domain without username */
  emailDomain?: InputMaybe<Scalars['String']['input']>
  ipAddress?: InputMaybe<Scalars['String']['input']>
  language?: InputMaybe<Scalars['String']['input']>
  memberId?: InputMaybe<Scalars['String']['input']>
  osName?: InputMaybe<Scalars['String']['input']>
  osVersion?: InputMaybe<Scalars['String']['input']>
  pageName?: InputMaybe<Scalars['String']['input']>
  pageUrl?: InputMaybe<Scalars['String']['input']>
  platform?: InputMaybe<AuditPlatform>
  resource: AuditResource
  resourceId?: InputMaybe<Scalars['String']['input']>
  screenHeight?: InputMaybe<Scalars['Float']['input']>
  screenWidth?: InputMaybe<Scalars['Float']['input']>
  sessionId?: InputMaybe<Scalars['String']['input']>
  severity: AuditSeverity
  siteId?: InputMaybe<Scalars['String']['input']>
  siteName?: InputMaybe<Scalars['String']['input']>
  source: AuditSource
  timezone?: InputMaybe<Scalars['String']['input']>
  userAgent?: InputMaybe<Scalars['String']['input']>
  userEmail?: InputMaybe<Scalars['String']['input']>
  userFirstName?: InputMaybe<Scalars['String']['input']>
  userId?: InputMaybe<Scalars['String']['input']>
  userLastName?: InputMaybe<Scalars['String']['input']>
  /** User roles at time of action */
  userRoles?: InputMaybe<Array<Scalars['String']['input']>>
  visibility: AuditVisibility
}

/** Input for creating a new carousel group */
export interface CreateCarouselGroupInput {
  name: Scalars['String']['input']
}

export interface CreateClientAddressInput {
  city?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  streetAddress?: InputMaybe<Scalars['String']['input']>
  streetNumber?: InputMaybe<Scalars['String']['input']>
  unit?: InputMaybe<Scalars['String']['input']>
  zipCode?: InputMaybe<Scalars['String']['input']>
}

export interface CreateClientAlertInputInput {
  clientId: Scalars['String']['input']
  description?: InputMaybe<Scalars['String']['input']>
  endDate?: InputMaybe<Scalars['String']['input']>
  startDate?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
}

export interface CreateClientCustomPropertiesInput {
  siteCustomPropertyId: Scalars['String']['input']
  value: Scalars['String']['input']
}

export interface CreateClientEmergencyContactAddressInput {
  city?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  street?: InputMaybe<Scalars['String']['input']>
  streetNumber?: InputMaybe<Scalars['String']['input']>
  unit?: InputMaybe<Scalars['String']['input']>
  zipCode?: InputMaybe<Scalars['String']['input']>
}

export interface CreateClientEmergencyContactInput {
  address?: InputMaybe<CreateClientEmergencyContactAddressInput>
  email?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  relationship?: InputMaybe<Scalars['String']['input']>
}

/** Input for creating a client family relation */
export interface CreateClientFamilyInput {
  email: Scalars['String']['input']
  name: Scalars['String']['input']
  relationship: ClientFamilyRelationship
}

export interface CreateClientFileInput {
  fileName: Scalars['String']['input']
  format: Scalars['String']['input']
}

/** Input for creating a new client */
export interface CreateClientInput {
  activePackagesCount?: InputMaybe<Scalars['Float']['input']>
  address?: InputMaybe<CreateClientAddressInput>
  barcodeId?: InputMaybe<Scalars['String']['input']>
  customProperties?: InputMaybe<Array<CreateClientCustomPropertiesInput>>
  customerId?: InputMaybe<Scalars['String']['input']>
  dateOfBirth?: InputMaybe<Scalars['String']['input']>
  email: Scalars['String']['input']
  emergencyContact?: InputMaybe<CreateClientEmergencyContactInput>
  enrollmentSource?: InputMaybe<Scalars['String']['input']>
  firebaseId?: InputMaybe<Scalars['String']['input']>
  firstName: Scalars['String']['input']
  gender?: InputMaybe<Scalars['String']['input']>
  homeLocationIds?: InputMaybe<Array<Scalars['String']['input']>>
  homePhoneNumber?: InputMaybe<Scalars['String']['input']>
  homeSiteId?: InputMaybe<Scalars['String']['input']>
  isProspect?: InputMaybe<Scalars['Boolean']['input']>
  lastName: Scalars['String']['input']
  mobilePhoneNumber?: InputMaybe<Scalars['String']['input']>
  occupation?: InputMaybe<Scalars['String']['input']>
  questionnaireAnswers?: InputMaybe<Array<SubmitClientFormsQuestionnaireAnswersInput>>
  recentSiteId?: InputMaybe<Scalars['String']['input']>
  sendWelcomeEmail?: InputMaybe<Scalars['Boolean']['input']>
  source?: InputMaybe<ClientSource>
}

/** A new brand add-on, saved as a draft with its locks and its locations. */
export interface CreateCorporateAddOnDraftInput {
  assignedSiteGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>
  assignedSiteIds?: InputMaybe<Array<Scalars['ID']['input']>>
  config: BrandAddOnConfigInput
  isAllLocations: Scalars['Boolean']['input']
  lockedSections?: InputMaybe<Array<BrandServiceTemplateSection>>
}

export interface CreateCorporateHubspotInput {
  companyId?: InputMaybe<Scalars['String']['input']>
  companyName?: InputMaybe<Scalars['String']['input']>
}

/** A new brand session group, the locations and location groups it is distributed to, and the locations whose same-named session type the admin agreed to adopt. */
export interface CreateCorporateSessionTypeInput {
  acknowledgedAdoptionSiteIds?: InputMaybe<Array<Scalars['ID']['input']>>
  allowEditingSessionType: Scalars['Boolean']['input']
  allowMultiLocationAccess: Scalars['Boolean']['input']
  assignedSiteGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>
  assignedSiteIds?: InputMaybe<Array<Scalars['ID']['input']>>
  color: Scalars['String']['input']
  isAllLocations: Scalars['Boolean']['input']
  lockedSections?: InputMaybe<Array<SessionGroupSection>>
  name: Scalars['String']['input']
}

/** A new brand tax type, plus the locations and location groups it is distributed to. */
export interface CreateCorporateTaxSettingInput {
  assignedSiteGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>
  assignedSiteIds?: InputMaybe<Array<Scalars['ID']['input']>>
  enabled: Scalars['Boolean']['input']
  isLocked?: InputMaybe<Scalars['Boolean']['input']>
  name: Scalars['String']['input']
  rate: Scalars['String']['input']
  setting: TaxSettingType
}

export interface CreateCorporateWebhookInputInput {
  allSites?: InputMaybe<Scalars['Boolean']['input']>
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  events: Array<Scalars['String']['input']>
  headerKey?: InputMaybe<Scalars['String']['input']>
  headerValue?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  siteIds?: InputMaybe<Array<Scalars['String']['input']>>
  url: Scalars['String']['input']
}

/** Input for starting a tanning session assignment */
export interface CreateEquipmentAssignmentInput {
  checkInId?: InputMaybe<Scalars['String']['input']>
  clientId?: InputMaybe<Scalars['String']['input']>
  complianceOverride?: InputMaybe<ComplianceOverrideInput>
  delayMinutes: Scalars['Int']['input']
  equipmentId: Scalars['String']['input']
  /** Staff attest that a parent or guardian is present and their photo ID was checked (D-01) */
  guardianPresenceAttested?: InputMaybe<Scalars['Boolean']['input']>
  isOverride?: InputMaybe<Scalars['Boolean']['input']>
  owedBalanceOverride?: InputMaybe<OwedBalanceOverrideInput>
  regulationOverrides?: InputMaybe<Array<TanningRegulationOverrideInput>>
  siteId: Scalars['String']['input']
  siteSessionTypeId?: InputMaybe<Scalars['String']['input']>
  timerMinutes: Scalars['Int']['input']
}

/** Input for creating a new equipment unit */
export interface CreateEquipmentInput {
  category: EquipmentCategory
  copyImageFromEquipmentId?: InputMaybe<Scalars['ID']['input']>
  defaultDelayMinutes?: InputMaybe<Scalars['Int']['input']>
  defaultTimerMinutes?: InputMaybe<Scalars['Int']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  manufacturer?: InputMaybe<Scalars['String']['input']>
  maxDelayMinutes?: InputMaybe<Scalars['Int']['input']>
  maxTimerMinutes?: InputMaybe<Scalars['Int']['input']>
  minDelayMinutes?: InputMaybe<Scalars['Int']['input']>
  minTimerMinutes?: InputMaybe<Scalars['Int']['input']>
  name: Scalars['String']['input']
  nonUvCategory?: InputMaybe<NonUvCategory>
  qualityCategory?: InputMaybe<EquipmentQualityCategory>
  siteId: Scalars['String']['input']
  siteSessionTypeIds?: InputMaybe<Array<Scalars['String']['input']>>
  timerId: Scalars['Int']['input']
}

/** Input for creating tanning safety regulations for an equipment category */
export interface CreateEquipmentRegulationInput {
  equipmentCategory: EquipmentCategory
  rules: CreateEquipmentRegulationRulesInput
  siteId: Scalars['String']['input']
}

export interface CreateEquipmentRegulationRulesCustomerAgeMaxFrequencyAfterNoCategoryTanInput {
  afterXDaysOfNoCategoryTan: Scalars['Float']['input']
  enabled: Scalars['Boolean']['input']
  everyXDays: Scalars['Float']['input']
  forTheFirstXDays: Scalars['Float']['input']
  maxAge: Scalars['Float']['input']
  maxUses: Scalars['Float']['input']
}

export interface CreateEquipmentRegulationRulesCustomerAgeMaxFrequencyInput {
  enabled: Scalars['Boolean']['input']
  everyXDays: Scalars['Float']['input']
  maxAge: Scalars['Float']['input']
  maxUses: Scalars['Float']['input']
}

export interface CreateEquipmentRegulationRulesHoursBetweenUsesFromStartOfPreviousInput {
  enabled: Scalars['Boolean']['input']
  hours: Scalars['Float']['input']
}

export interface CreateEquipmentRegulationRulesInput {
  allowOverride: Scalars['Boolean']['input']
  customerAgeMaxFrequency: CreateEquipmentRegulationRulesCustomerAgeMaxFrequencyInput
  customerAgeMaxFrequencyAfterNoCategoryTan: CreateEquipmentRegulationRulesCustomerAgeMaxFrequencyAfterNoCategoryTanInput
  hoursBetweenUsesFromStartOfPrevious: CreateEquipmentRegulationRulesHoursBetweenUsesFromStartOfPreviousInput
  minimumDaysBetweenUses: CreateEquipmentRegulationRulesMinimumDaysBetweenUsesInput
  minimumHoursBetweenUses: CreateEquipmentRegulationRulesMinimumHoursBetweenUsesInput
  nonUvAgeRules?: InputMaybe<CreateEquipmentRegulationRulesNonUvAgeRulesInput>
  skinTypeRequired?: InputMaybe<CreateEquipmentRegulationRulesSkinTypeRequiredInput>
  uvAgeRules?: InputMaybe<CreateEquipmentRegulationRulesUvAgeRulesInput>
}

export interface CreateEquipmentRegulationRulesMinimumDaysBetweenUsesInput {
  days: Scalars['Float']['input']
  enabled: Scalars['Boolean']['input']
}

export interface CreateEquipmentRegulationRulesMinimumHoursBetweenUsesInput {
  enabled: Scalars['Boolean']['input']
  hours: Scalars['Float']['input']
}

export interface CreateEquipmentRegulationRulesNonUvAgeRulesByCategoryInput {
  red_light?: InputMaybe<CreateEquipmentRegulationRulesUvAgeRulesInput>
  spa: CreateEquipmentRegulationRulesUvAgeRulesInput
  spray: CreateEquipmentRegulationRulesUvAgeRulesInput
  wellness: CreateEquipmentRegulationRulesUvAgeRulesInput
}

export interface CreateEquipmentRegulationRulesNonUvAgeRulesInput {
  byCategory?: InputMaybe<CreateEquipmentRegulationRulesNonUvAgeRulesByCategoryInput>
  categoryBased: Scalars['Boolean']['input']
  general?: InputMaybe<CreateEquipmentRegulationRulesUvAgeRulesInput>
}

export interface CreateEquipmentRegulationRulesSkinTypeRequiredInput {
  allowOverride: Scalars['Boolean']['input']
  autoSend: Scalars['Boolean']['input']
  autoSendDeviceTokenId?: InputMaybe<Scalars['String']['input']>
  mode: SkinTypeRequirementMode
  resurveyInterval: ResurveyInterval
  skinTypeFormId?: InputMaybe<Scalars['String']['input']>
}

export interface CreateEquipmentRegulationRulesUvAgeRulesInput {
  doctorsNote?: InputMaybe<CreateEquipmentRegulationRulesUvAgeRulesMinorWithParentalConsentInput>
  minimumAge: CreateEquipmentRegulationRulesUvAgeRulesMinimumAgeInput
  minorWithParentalConsent: CreateEquipmentRegulationRulesUvAgeRulesMinorWithParentalConsentInput
}

export interface CreateEquipmentRegulationRulesUvAgeRulesMinimumAgeInput {
  enabled: Scalars['Boolean']['input']
  enforceNoOverride: Scalars['Boolean']['input']
  value: Scalars['Float']['input']
}

export interface CreateEquipmentRegulationRulesUvAgeRulesMinorWithParentalConsentInput {
  enabled: Scalars['Boolean']['input']
  max: Scalars['Float']['input']
  min: Scalars['Float']['input']
}

export interface CreateExternalMediaAssetInputInput {
  fileName: Scalars['String']['input']
  folder?: InputMaybe<Scalars['String']['input']>
  mimeType: ExternalVideoMimeType
  url: Scalars['String']['input']
}

/** Input for creating a new goal */
export interface CreateGoalInput {
  name: Scalars['String']['input']
}

export interface CreateInvoiceInputInput {
  beneficiaryId?: InputMaybe<Scalars['ID']['input']>
  clientId?: InputMaybe<Scalars['ID']['input']>
  currency: Currency
  items: Array<CreateInvoiceItemsInput>
  source: InvoiceSource
}

export interface CreateInvoiceItemsBillableItemInput {
  addAsAccountCredits: Scalars['Boolean']['input']
  description: Scalars['String']['input']
  invoiceDate: Scalars['String']['input']
  price: Scalars['Numeric']['input']
  revenueTagId?: InputMaybe<Scalars['ID']['input']>
  serviceTemplateId?: InputMaybe<Scalars['ID']['input']>
  taxSettingsIds: Array<Scalars['ID']['input']>
}

export interface CreateInvoiceItemsBookingInput {
  bookingId: Scalars['ID']['input']
  dropInPrice: Scalars['Numeric']['input']
  revenueTagId?: InputMaybe<Scalars['String']['input']>
  sessionId: Scalars['ID']['input']
  sessionName: Scalars['String']['input']
  sessionStartTime: Scalars['String']['input']
  taxSettingIds: Array<Scalars['String']['input']>
}

export interface CreateInvoiceItemsDestinationFeeInput {
  metadata: CreateInvoiceItemsDestinationFeeMetadataInput
}

export interface CreateInvoiceItemsDestinationFeeMetadataInput {
  itemType: Scalars['String']['input']
  siteId: Scalars['ID']['input']
}

export interface CreateInvoiceItemsGiftCardInput {
  customId: Scalars['String']['input']
  deliveryDate?: InputMaybe<Scalars['String']['input']>
  designId?: InputMaybe<Scalars['String']['input']>
  expiryDate?: InputMaybe<Scalars['String']['input']>
  expiryMode?: InputMaybe<GiftCardExpiryMode>
  giftCardTemplateId: Scalars['ID']['input']
  personalMessage?: InputMaybe<Scalars['String']['input']>
  purchaserEmail: Scalars['String']['input']
  purchaserName: Scalars['String']['input']
  recipientEmail?: InputMaybe<Scalars['String']['input']>
  recipientFullName?: InputMaybe<Scalars['String']['input']>
  recipientName: Scalars['String']['input']
  sendToRecipient: Scalars['Boolean']['input']
  value: Scalars['Numeric']['input']
}

export interface CreateInvoiceItemsInput {
  billableItem?: InputMaybe<CreateInvoiceItemsBillableItemInput>
  booking?: InputMaybe<CreateInvoiceItemsBookingInput>
  destinationFee?: InputMaybe<CreateInvoiceItemsDestinationFeeInput>
  discountReason?: InputMaybe<Scalars['String']['input']>
  discountType?: InputMaybe<DiscountType>
  discountValue?: InputMaybe<Scalars['Numeric']['input']>
  giftCard?: InputMaybe<CreateInvoiceItemsGiftCardInput>
  itemType: SaleItemType
  lateCancelFee?: InputMaybe<CreateInvoiceItemsLateCancelFeeInput>
  noShowFee?: InputMaybe<CreateInvoiceItemsNoShowFeeInput>
  product?: InputMaybe<CreateInvoiceItemsProductInput>
  promoCodeId?: InputMaybe<Scalars['ID']['input']>
  quantity: Scalars['Float']['input']
  recurringServicePayment?: InputMaybe<CreateInvoiceItemsRecurringServicePaymentInput>
  referredByStaffUserId?: InputMaybe<Scalars['ID']['input']>
  scheduleDateAdjustment?: InputMaybe<CreateInvoiceItemsScheduleDateAdjustmentInput>
  service?: InputMaybe<CreateInvoiceItemsServiceInput>
  serviceActionFee?: InputMaybe<CreateInvoiceItemsServiceActionFeeInput>
}

export interface CreateInvoiceItemsLateCancelFeeInput {
  metadata: CreateInvoiceItemsLateCancelFeeMetadataInput
}

export interface CreateInvoiceItemsLateCancelFeeMetadataInput {
  bookingId: Scalars['ID']['input']
  itemType: Scalars['String']['input']
  lateCancelFeeId?: InputMaybe<Scalars['String']['input']>
  lateCancelFeeName?: InputMaybe<Scalars['String']['input']>
  sessionDate: Scalars['String']['input']
  sessionId: Scalars['ID']['input']
  sessionName: Scalars['String']['input']
  sessionTime: Scalars['String']['input']
  sessionTypeId: Scalars['ID']['input']
  sessionTypeName: Scalars['String']['input']
}

export interface CreateInvoiceItemsNoShowFeeInput {
  metadata: CreateInvoiceItemsNoShowFeeMetadataInput
}

export interface CreateInvoiceItemsNoShowFeeMetadataInput {
  bookingId: Scalars['ID']['input']
  itemType: Scalars['String']['input']
  noShowFeeId?: InputMaybe<Scalars['String']['input']>
  noShowFeeName?: InputMaybe<Scalars['String']['input']>
  sessionDate: Scalars['String']['input']
  sessionId: Scalars['ID']['input']
  sessionName: Scalars['String']['input']
  sessionTime: Scalars['String']['input']
  sessionTypeId: Scalars['ID']['input']
  sessionTypeName: Scalars['String']['input']
}

export interface CreateInvoiceItemsProductInput {
  productId: Scalars['ID']['input']
  productTemplateId: Scalars['ID']['input']
}

export interface CreateInvoiceItemsRecurringServicePaymentInput {
  amount: Scalars['Numeric']['input']
  beneficiaryClientId?: InputMaybe<Scalars['ID']['input']>
  description: Scalars['String']['input']
  invoiceDate: Scalars['String']['input']
  metadata: CreateInvoiceItemsRecurringServicePaymentMetadataInput
  proratedCredits?: InputMaybe<Scalars['Float']['input']>
  prorationEndDate?: InputMaybe<Scalars['String']['input']>
  prorationStartDate?: InputMaybe<Scalars['String']['input']>
  serviceId: Scalars['ID']['input']
  totalCredits?: InputMaybe<Scalars['Float']['input']>
}

export interface CreateInvoiceItemsRecurringServicePaymentMetadataInput {
  isSecondaryFee?: InputMaybe<Scalars['Boolean']['input']>
  itemType: Scalars['String']['input']
  recurringInvoiceId: Scalars['ID']['input']
  recurringInvoiceName: Scalars['String']['input']
  sequenceNumber: Scalars['Float']['input']
  serviceTemplateName: Scalars['String']['input']
}

export interface CreateInvoiceItemsScheduleDateAdjustmentInput {
  amount: Scalars['String']['input']
  description: Scalars['String']['input']
  metadata: CreateInvoiceItemsScheduleDateAdjustmentMetadataInput
}

export interface CreateInvoiceItemsScheduleDateAdjustmentMetadataInput {
  itemType: Scalars['String']['input']
  newStartDate: Scalars['String']['input']
  oldStartDate: Scalars['String']['input']
  serviceId: Scalars['ID']['input']
  sourceInvoiceId: Scalars['ID']['input']
}

export interface CreateInvoiceItemsServiceActionFeeInput {
  amount: Scalars['String']['input']
  description: Scalars['String']['input']
  metadata: CreateInvoiceItemsServiceActionFeeMetadataInput
  taxSettingsSnapshot?: InputMaybe<
    Array<CreateInvoiceItemsServiceActionFeeTaxSettingsSnapshotInput>
  >
}

export interface CreateInvoiceItemsServiceActionFeeMetadataInput {
  actionType: ServiceActionType
  itemType: Scalars['String']['input']
  serviceCancellationId?: InputMaybe<Scalars['String']['input']>
  serviceId: Scalars['ID']['input']
  serviceSuspensionId?: InputMaybe<Scalars['String']['input']>
  withdrawnAt?: InputMaybe<Scalars['String']['input']>
}

export interface CreateInvoiceItemsServiceActionFeeTaxSettingsSnapshotInput {
  amount: Scalars['Numeric']['input']
  name: Scalars['String']['input']
  taxSettingId: Scalars['String']['input']
  type: TaxSettingType
}

export interface CreateInvoiceItemsServiceInput {
  addOnAttachment?: InputMaybe<CalculateCartItemsAddOnAttachmentInput>
  beneficiaryClientId?: InputMaybe<Scalars['ID']['input']>
  chargeSetupFeeUpFront?: InputMaybe<Scalars['Boolean']['input']>
  creditValidUntilDate?: InputMaybe<Scalars['String']['input']>
  discountAppliesToAllPayments?: InputMaybe<Scalars['Boolean']['input']>
  discountScope?: InputMaybe<AddOnDiscountScope>
  enableAutoRenew: Scalars['Boolean']['input']
  oneTimeSetupFee?: InputMaybe<Scalars['Numeric']['input']>
  paidInFullCycles?: InputMaybe<Scalars['Float']['input']>
  payUpFront?: InputMaybe<Scalars['Boolean']['input']>
  proratedAmount?: InputMaybe<Scalars['Numeric']['input']>
  prorationEndDate?: InputMaybe<Scalars['String']['input']>
  prorationStartDate?: InputMaybe<Scalars['String']['input']>
  serviceFirstBillingDate: Scalars['String']['input']
  serviceStartDate: Scalars['String']['input']
  serviceTemplateId: Scalars['ID']['input']
  signedClientAgreementId?: InputMaybe<Scalars['ID']['input']>
  signedClientAgreementIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export interface CreateLeaderboardConfigInputInput {
  autoRollover: Scalars['Boolean']['input']
  config: Scalars['JSONObject']['input']
  customEndDate?: InputMaybe<Scalars['String']['input']>
  customStartDate?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  imageUrl?: InputMaybe<Scalars['String']['input']>
  leaderboardType: LeaderboardType
  memberDisplayFormat: MemberDisplayFormat
  minParticipants: Scalars['Float']['input']
  name: Scalars['String']['input']
  rankingDirection: RankingDirection
  refreshFrequency: RefreshFrequency
  scope: LeaderboardScope
  scoreType: ScoreType
  siteIds?: InputMaybe<Array<Scalars['String']['input']>>
  timePeriodType: TimePeriodType
  visibility: LeaderboardVisibility
}

export interface CreateManualRefundInputInput {
  amount: Scalars['Numeric']['input']
  paymentId: Scalars['ID']['input']
  reason: Scalars['String']['input']
  refundMethod: RefundType
}

export interface CreateMemberMovementRunInput {
  attestation?: InputMaybe<MemberMovementAttestationInput>
  config?: InputMaybe<MemberMovementConfigInput>
  corporateId: Scalars['ID']['input']
  mode?: InputMaybe<MemberMovementRunMode>
  periodEnd?: InputMaybe<Scalars['String']['input']>
  periodStart?: InputMaybe<Scalars['String']['input']>
  timezone?: InputMaybe<Scalars['String']['input']>
}

/** Input for creating an organisation client */
export interface CreateOrganisationInput {
  billingEmail: Scalars['String']['input']
  companyName: Scalars['String']['input']
  phone?: InputMaybe<Scalars['String']['input']>
  taxIdentifier?: InputMaybe<Scalars['String']['input']>
}

export interface CreatePaymentsInputInput {
  amount: Scalars['Numeric']['input']
  canCompleteCardChallenge?: InputMaybe<Scalars['Boolean']['input']>
  canRecoverCardChallengeRemotely?: InputMaybe<Scalars['Boolean']['input']>
  clientPaymentMethodId?: InputMaybe<Scalars['ID']['input']>
  customPaymentMethodLabel?: InputMaybe<Scalars['String']['input']>
  paymentMethodType: PaymentMethodType
  saveForFutureUse?: InputMaybe<Scalars['Boolean']['input']>
  terminalReaderId?: InputMaybe<Scalars['ID']['input']>
  useTerminalCardForRecurring?: InputMaybe<Scalars['Boolean']['input']>
}

/** Input for creating a new POS category */
export interface CreatePosCategoryInput {
  description?: InputMaybe<Scalars['String']['input']>
  displayOrder?: InputMaybe<Scalars['Int']['input']>
  name: Scalars['String']['input']
  revenueTagId?: InputMaybe<Scalars['String']['input']>
  status: PosCategoryStatus
}

/** Input for creating a new POS product with variants */
export interface CreatePosProductInput {
  categoryId?: InputMaybe<Scalars['ID']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  productName: Scalars['String']['input']
  revenueTag?: InputMaybe<Scalars['ID']['input']>
  supplierId?: InputMaybe<Scalars['ID']['input']>
  variables: Array<PosProductVariableInput>
}

export interface CreateRegionInputInput {
  /** Country ID from Admin DB */
  countryId: Scalars['ID']['input']
  /** Latitude coordinate */
  latitude?: InputMaybe<Scalars['Float']['input']>
  /** Longitude coordinate */
  longitude?: InputMaybe<Scalars['Float']['input']>
  /** Region name */
  name: Scalars['String']['input']
  /** Zone ID from Admin DB (optional) */
  zoneId?: InputMaybe<Scalars['ID']['input']>
}

export interface CreateSavedReportInputInput {
  baseReportName: ReportName
  categoryId?: InputMaybe<Scalars['String']['input']>
  columnLabels?: InputMaybe<Scalars['JSONObject']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  savedColumns?: InputMaybe<Array<Scalars['String']['input']>>
  savedDateRange?: InputMaybe<CreateSavedReportSavedDateRangeInput>
  savedFilters?: InputMaybe<Scalars['JSONObject']['input']>
  savedSiteIds?: InputMaybe<Array<Scalars['String']['input']>>
  savedSort?: InputMaybe<Array<CreateSavedReportSavedSortInput>>
  siteId?: InputMaybe<Scalars['String']['input']>
}

export interface CreateSavedReportSavedDateRangeInput {
  from?: InputMaybe<Scalars['String']['input']>
  to?: InputMaybe<Scalars['String']['input']>
  type: DateRangeType
  value?: InputMaybe<Scalars['String']['input']>
}

export interface CreateSavedReportSavedSortInput {
  column: Scalars['String']['input']
  direction: SortDirection
}

export interface CreateScheduledPushSendInput {
  audienceType: ScheduledPushAudienceType
  message: Scalars['String']['input']
  /** Wall-clock send time at the site (yyyy-MM-ddTHH:mm), interpreted in the site's timezone. Null sends immediately. */
  sendAtLocal?: InputMaybe<Scalars['String']['input']>
  sessionId?: InputMaybe<Scalars['ID']['input']>
  siteId: Scalars['ID']['input']
  title: Scalars['String']['input']
}

export interface CreateServiceTemplateCancellationFeeScheduleInput {
  basis: CancellationTierBasis
  enabled: Scalars['Boolean']['input']
  tiers: Array<CreateServiceTemplateCancellationFeeScheduleTiersInput>
}

export interface CreateServiceTemplateCancellationFeeScheduleTiersInput {
  amount?: InputMaybe<Scalars['Numeric']['input']>
  kind: CancellationFeeValueKind
  percent?: InputMaybe<Scalars['Float']['input']>
  until: Scalars['Float']['input']
}

export interface CreateServiceTemplateCancellationInput {
  effectiveDateRule?: InputMaybe<CancellationEffectiveDateRule>
  feeSchedule?: InputMaybe<CreateServiceTemplateCancellationFeeScheduleInput>
  isEnabledForClient: Scalars['Boolean']['input']
  minimumTerm?: InputMaybe<CreateServiceTemplateCancellationMinimumTermInput>
  noticePeriodDays?: InputMaybe<Scalars['Float']['input']>
}

export interface CreateServiceTemplateCancellationMinimumTermAfterInput {
  amount: Scalars['Float']['input']
  unit: MinimumTermAfterUnit
}

export interface CreateServiceTemplateCancellationMinimumTermChargeInput {
  amount: Scalars['Numeric']['input']
  isTaxEnabled: Scalars['Boolean']['input']
  taxSettingIds: Array<Scalars['ID']['input']>
}

export interface CreateServiceTemplateCancellationMinimumTermInput {
  after?: InputMaybe<CreateServiceTemplateCancellationMinimumTermAfterInput>
  charge?: InputMaybe<CreateServiceTemplateCancellationMinimumTermChargeInput>
  enabled: Scalars['Boolean']['input']
}

/** Input for creating a new service template category */
export interface CreateServiceTemplateCategoryInput {
  description?: InputMaybe<Scalars['String']['input']>
  displayOrder?: InputMaybe<Scalars['Float']['input']>
  name: Scalars['String']['input']
  status: ServiceTemplateCategoryStatus
}

export interface CreateServiceTemplateCreditsInput {
  amount?: InputMaybe<Scalars['Float']['input']>
  creditsType: CreditType
  expirationAmount?: InputMaybe<Scalars['Float']['input']>
  expirationEnabled: Scalars['Boolean']['input']
  expirationType?: InputMaybe<CreditExpirationType>
  expirationUnit?: InputMaybe<CreditExpirationUnit>
  order: Scalars['Float']['input']
  serviceCreditTemplateId?: InputMaybe<Scalars['String']['input']>
  siteSessionTypeIds: Array<Scalars['String']['input']>
}

export interface CreateServiceTemplateFeeRevenueTagsInput {
  cancellationFee?: InputMaybe<Scalars['ID']['input']>
  oneTimeSetupFee?: InputMaybe<Scalars['ID']['input']>
  secondaryRecurringFee?: InputMaybe<Scalars['ID']['input']>
  suspensionFee?: InputMaybe<Scalars['ID']['input']>
}

export interface CreateServiceTemplateFirstCreditAllocationDateInput {
  enabled: Scalars['Boolean']['input']
  firstCreditAllocationDateType?: InputMaybe<FirstCreditAllocationDateType>
  onDate?: InputMaybe<Scalars['String']['input']>
}

export interface CreateServiceTemplateGuestPassAllowanceCreditLinesInput {
  credits: Scalars['Float']['input']
  serviceCreditTemplateId?: InputMaybe<Scalars['ID']['input']>
  siteSessionTypeIds: Array<Scalars['ID']['input']>
}

export interface CreateServiceTemplateGuestPassAllowanceInput {
  carryForwardCap?: InputMaybe<Scalars['Float']['input']>
  companionTemplateId?: InputMaybe<Scalars['ID']['input']>
  creditLines?: InputMaybe<Array<CreateServiceTemplateGuestPassAllowanceCreditLinesInput>>
  enabled: Scalars['Boolean']['input']
  expiryBehaviour?: InputMaybe<GuestPassExpiryBehaviour>
  intervalAmount?: InputMaybe<Scalars['Float']['input']>
  intervalUnit?: InputMaybe<BillingCycleUnit>
  newClientsOnlyEnabled?: InputMaybe<Scalars['Boolean']['input']>
  passesPerInterval?: InputMaybe<Scalars['Float']['input']>
  siteSessionTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export interface CreateServiceTemplateInputInput {
  accessSchedule?: InputMaybe<Scalars['JSONObject']['input']>
  accountCodeId?: InputMaybe<Scalars['String']['input']>
  agreementEnabled?: InputMaybe<Scalars['Boolean']['input']>
  agreementSendConfirmation?: InputMaybe<Scalars['Boolean']['input']>
  agreementText?: InputMaybe<Scalars['String']['input']>
  autoConvertTo?: InputMaybe<Scalars['String']['input']>
  autoConvertTrigger?: InputMaybe<AutoConvertTrigger>
  autoRenewEnabled?: InputMaybe<Scalars['Boolean']['input']>
  autoRenewType?: InputMaybe<AutoRenewType>
  billingAnchorDate?: InputMaybe<Scalars['String']['input']>
  billingCycleAmount?: InputMaybe<Scalars['Float']['input']>
  billingCycleUnit?: InputMaybe<BillingCycleUnit>
  billingDay?: InputMaybe<Scalars['Float']['input']>
  cancellation?: InputMaybe<CreateServiceTemplateCancellationInput>
  cancellationNoticePeriodAmount?: InputMaybe<Scalars['Float']['input']>
  cancellationNoticePeriodUnit?: InputMaybe<CancellationNoticePeriodUnit>
  categoryId?: InputMaybe<Scalars['String']['input']>
  categoryName?: InputMaybe<Scalars['String']['input']>
  changePlanEnabled?: InputMaybe<Scalars['Boolean']['input']>
  chargeSetupFeeUpFront?: InputMaybe<Scalars['Boolean']['input']>
  clientOnlinePurchaseExpiryDate?: InputMaybe<Scalars['String']['input']>
  clientOnlinePurchaseExpiryEnabled?: InputMaybe<Scalars['Boolean']['input']>
  creditRolloverPolicy?: InputMaybe<CreditRolloverPolicy>
  creditWindowEndDate?: InputMaybe<Scalars['String']['input']>
  credits?: InputMaybe<Array<CreateServiceTemplateCreditsInput>>
  description?: InputMaybe<Scalars['String']['input']>
  displayOrder?: InputMaybe<Scalars['Float']['input']>
  dynamicDisplayServiceTemplateIds?: InputMaybe<Array<Scalars['String']['input']>>
  earlyAccessDurationAmount?: InputMaybe<Scalars['Float']['input']>
  earlyAccessDurationUnit?: InputMaybe<EarlyAccessDurationUnit>
  expiryAlertInDays?: InputMaybe<Scalars['Float']['input']>
  extraBookingWindow?: InputMaybe<Scalars['Float']['input']>
  familyShareable?: InputMaybe<Scalars['Boolean']['input']>
  feeRevenueTags?: InputMaybe<CreateServiceTemplateFeeRevenueTagsInput>
  firstCreditAllocationDate?: InputMaybe<CreateServiceTemplateFirstCreditAllocationDateInput>
  futureStartDate?: InputMaybe<Scalars['String']['input']>
  guestPassAllowance?: InputMaybe<CreateServiceTemplateGuestPassAllowanceInput>
  inheritAgreementsOnConvert?: InputMaybe<Scalars['Boolean']['input']>
  isAllSharedSites: Scalars['Boolean']['input']
  isClientControlEnabled?: InputMaybe<Scalars['Boolean']['input']>
  isDefaultForTransferredClient?: InputMaybe<Scalars['Boolean']['input']>
  isEnabledForCMS: Scalars['Boolean']['input']
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>
  isIntroOffer: Scalars['Boolean']['input']
  isRestricted: Scalars['Boolean']['input']
  lengthAmount?: InputMaybe<Scalars['Float']['input']>
  lengthType?: InputMaybe<ServiceLengthType>
  lengthUnit?: InputMaybe<ServiceLengthUnit>
  limitSale?: InputMaybe<CreateServiceTemplateLimitSaleInput>
  maxSharingCredits?: InputMaybe<Scalars['Float']['input']>
  maxSharingRecipients?: InputMaybe<Scalars['Float']['input']>
  minimumHomeUsageInDays?: InputMaybe<Scalars['Float']['input']>
  multiplePaymentOptions?: InputMaybe<CreateServiceTemplateMultiplePaymentOptionsInput>
  name: Scalars['String']['input']
  newSaleDynamicDisplayServiceTemplateIds?: InputMaybe<Array<Scalars['String']['input']>>
  oneActivePerFamily?: InputMaybe<Scalars['Boolean']['input']>
  oneTimeSetupFee?: InputMaybe<Scalars['Numeric']['input']>
  oneTimeSetupFeeTaxEnabled?: InputMaybe<Scalars['Boolean']['input']>
  oneTimeSetupFeeTaxSettingIds?: InputMaybe<Array<Scalars['ID']['input']>>
  onlineSaleEnabled: Scalars['Boolean']['input']
  onlineSaleStartDate?: InputMaybe<Scalars['String']['input']>
  payUpFrontEnabled?: InputMaybe<Scalars['Boolean']['input']>
  price: Scalars['Numeric']['input']
  revenueTag?: InputMaybe<Scalars['String']['input']>
  saleAvailableFromDate?: InputMaybe<Scalars['String']['input']>
  saleAvailableUntilDate?: InputMaybe<Scalars['String']['input']>
  secondaryRecurringFee?: InputMaybe<CreateServiceTemplateSecondaryRecurringFeeInput>
  selfServicePause?: InputMaybe<CreateServiceTemplateSelfServicePauseInput>
  serviceFirstBillingDate?: InputMaybe<CreateServiceTemplateServiceFirstBillingDateInput>
  sharedSiteIds: Array<Scalars['String']['input']>
  sharingCreditsAmount?: InputMaybe<Scalars['Float']['input']>
  sharingCreditsEnabled?: InputMaybe<Scalars['Boolean']['input']>
  siteAgreementTemplateId?: InputMaybe<Scalars['String']['input']>
  siteId: Scalars['String']['input']
  taxEnabled: Scalars['Boolean']['input']
  taxSettingIds?: InputMaybe<Array<Scalars['ID']['input']>>
  tierOrder?: InputMaybe<Scalars['Float']['input']>
  toServiceTemplateId?: InputMaybe<Scalars['String']['input']>
  type: ServiceTemplateType
}

export interface CreateServiceTemplateLimitSaleInput {
  perAccount?: InputMaybe<Scalars['Float']['input']>
  perClient?: InputMaybe<Scalars['Float']['input']>
}

export interface CreateServiceTemplateMultiplePaymentOptionsInput {
  payNowMode: PaymentMode
  recurringMode: PaymentMode
}

export interface CreateServiceTemplateSecondaryRecurringFeeInput {
  amount: Scalars['Numeric']['input']
  billingCycleAmount?: InputMaybe<Scalars['Float']['input']>
  billingCycleUnit?: InputMaybe<BillingCycleUnit>
  enabled: Scalars['Boolean']['input']
  serviceFirstBillingDate?: InputMaybe<CreateServiceTemplateServiceFirstBillingDateInput>
  taxEnabled?: InputMaybe<Scalars['Boolean']['input']>
  taxSettingIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export interface CreateServiceTemplateSelfServicePauseFeeCadenceInput {
  amount: Scalars['Float']['input']
  unit: SelfServicePauseCadenceUnit
}

export interface CreateServiceTemplateSelfServicePauseFeeInput {
  amount?: InputMaybe<Scalars['Numeric']['input']>
  cadence?: InputMaybe<CreateServiceTemplateSelfServicePauseFeeCadenceInput>
  chargeMode: SelfServicePauseChargeMode
}

export interface CreateServiceTemplateSelfServicePauseInput {
  enabled: Scalars['Boolean']['input']
  fee: CreateServiceTemplateSelfServicePauseFeeInput
  noticePeriodDays?: InputMaybe<Scalars['Float']['input']>
  suspensionType: ServiceSuspensionType
}

export interface CreateServiceTemplateServiceFirstBillingDateAfterInput {
  amount: Scalars['Float']['input']
  unit: FirstPaymentAfterUnit
}

export interface CreateServiceTemplateServiceFirstBillingDateInput {
  after?: InputMaybe<CreateServiceTemplateServiceFirstBillingDateAfterInput>
  enabled: Scalars['Boolean']['input']
  onDate?: InputMaybe<Scalars['String']['input']>
}

export interface CreateServiceTemplateSessionTypeAddOnInput {
  addOnName?: InputMaybe<Scalars['String']['input']>
  /** Retired (OC-857): a price applies to every machine offering the session type. Always null; ignored on input. */
  equipmentId?: InputMaybe<Scalars['ID']['input']>
  fromServiceTemplateId: Scalars['ID']['input']
  price: Scalars['Numeric']['input']
  siteId: Scalars['ID']['input']
  siteSessionTypeId: Scalars['ID']['input']
  taxSettingIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

/** Input for an owner minting a share link for their package */
export interface CreateSharedCreditInviteInput {
  allocatedCredits?: InputMaybe<Scalars['Float']['input']>
  recipientClientId?: InputMaybe<Scalars['ID']['input']>
  serviceId: Scalars['ID']['input']
}

/** Input for creating a per-site accounting code */
export interface CreateSiteAccountCodeInput {
  code: Scalars['String']['input']
  description?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
}

export interface CreateSiteAdminConfigurationsFeesInput {
  brandRebatesTemplateIds?: InputMaybe<Array<Scalars['String']['input']>>
  clientFeesTemplateId?: InputMaybe<Scalars['String']['input']>
  hapanaFeesTemplateId?: InputMaybe<Scalars['String']['input']>
  royaltiesAndFeesTemplateId?: InputMaybe<Scalars['String']['input']>
}

export interface CreateSiteAdminConfigurationsFobCredentialFormatInput {
  byteOrder: FobByteOrder
  controller: FobController
  readerFormat: FobReaderFormat
  serialNotation?: InputMaybe<FobSerialNotation>
}

export interface CreateSiteAdminConfigurationsInput {
  allowToEnableClientMultiplePaymentMethods?: InputMaybe<Scalars['Boolean']['input']>
  bankAccountCapabilities?: InputMaybe<Scalars['Boolean']['input']>
  displayAccountCreditsTab?: InputMaybe<Scalars['Boolean']['input']>
  displayStripeConnectPaymentGateway?: InputMaybe<Scalars['Boolean']['input']>
  enableAddOns?: InputMaybe<Scalars['Boolean']['input']>
  enableAppAndWebsiteWidgets?: InputMaybe<Scalars['Boolean']['input']>
  enableCorporateDashboardAndPublicApi?: InputMaybe<Scalars['Boolean']['input']>
  enableDigitalLocations?: InputMaybe<Scalars['Boolean']['input']>
  enableDoorAccess?: InputMaybe<Scalars['Boolean']['input']>
  enableMembershipPlanChange?: InputMaybe<Scalars['Boolean']['input']>
  enableOfflineDoorSync?: InputMaybe<Scalars['Boolean']['input']>
  enableSharedSites?: InputMaybe<Scalars['Boolean']['input']>
  enableTanningFeatures?: InputMaybe<Scalars['Boolean']['input']>
  fees?: InputMaybe<CreateSiteAdminConfigurationsFeesInput>
  fobCredentialFormat?: InputMaybe<CreateSiteAdminConfigurationsFobCredentialFormatInput>
  hasBankAccountCapabilities?: InputMaybe<Scalars['Boolean']['input']>
  hasBankAccountRefundCapabilities?: InputMaybe<Scalars['Boolean']['input']>
  monthlySmsCredits?: InputMaybe<Scalars['Float']['input']>
  paymentGateway?: InputMaybe<CreateSiteAdminConfigurationsPaymentGatewayInput>
  processingFees?: InputMaybe<CreateSiteAdminConfigurationsProcessingFeesInput>
  sms?: InputMaybe<CreateSiteAdminConfigurationsSmsInput>
}

export interface CreateSiteAdminConfigurationsPaymentGatewayInput {
  accountCodesEnabled?: InputMaybe<Scalars['Boolean']['input']>
  applePayEnabled?: InputMaybe<Scalars['Boolean']['input']>
  enableTerminals?: InputMaybe<Scalars['Boolean']['input']>
  ezypayDisplayAccountingCode?: InputMaybe<Scalars['String']['input']>
  googlePayEnabled?: InputMaybe<Scalars['Boolean']['input']>
  introOfferDefaultAccountCodeId?: InputMaybe<Scalars['String']['input']>
  stripeId?: InputMaybe<Scalars['String']['input']>
  transactionLimitAmount?: InputMaybe<Scalars['Float']['input']>
}

export interface CreateSiteAdminConfigurationsProcessingFeesInput {
  amexCardProcessingFlatFee?: InputMaybe<Scalars['Float']['input']>
  amexCardProcessingPercentageFee?: InputMaybe<Scalars['Float']['input']>
  bankProcessingFlatFee?: InputMaybe<Scalars['Float']['input']>
  bankProcessingPercentageFee?: InputMaybe<Scalars['Float']['input']>
  cardProcessingFlatFee?: InputMaybe<Scalars['Float']['input']>
  cardProcessingPercentageFee?: InputMaybe<Scalars['Float']['input']>
}

export interface CreateSiteAdminConfigurationsSmsInput {
  fromName?: InputMaybe<Scalars['String']['input']>
  twilioSubaccount?: InputMaybe<CreateSiteAdminConfigurationsSmsTwilioSubaccountInput>
}

export interface CreateSiteAdminConfigurationsSmsTwilioSubaccountInput {
  id?: InputMaybe<Scalars['String']['input']>
  token?: InputMaybe<Scalars['String']['input']>
}

/** A null startsAt posts the alert now; a null endsAt runs it until further notice */
export interface CreateSiteAlertInput {
  amenityId?: InputMaybe<Scalars['ID']['input']>
  body?: InputMaybe<Scalars['String']['input']>
  endsAt?: InputMaybe<Scalars['String']['input']>
  linkLabel?: InputMaybe<Scalars['String']['input']>
  linkUrl?: InputMaybe<Scalars['String']['input']>
  marksLocationClosed: Scalars['Boolean']['input']
  showAsPopup: Scalars['Boolean']['input']
  siteId: Scalars['ID']['input']
  startsAt?: InputMaybe<Scalars['String']['input']>
  theme: SiteAlertTheme
  title: Scalars['String']['input']
}

export interface CreateSiteBusinessHoursCustomHoursInput {
  friday?: InputMaybe<CreateSiteBusinessHoursCustomHoursMondayInput>
  monday?: InputMaybe<CreateSiteBusinessHoursCustomHoursMondayInput>
  saturday?: InputMaybe<CreateSiteBusinessHoursCustomHoursMondayInput>
  sunday?: InputMaybe<CreateSiteBusinessHoursCustomHoursMondayInput>
  thursday?: InputMaybe<CreateSiteBusinessHoursCustomHoursMondayInput>
  tuesday?: InputMaybe<CreateSiteBusinessHoursCustomHoursMondayInput>
  wednesday?: InputMaybe<CreateSiteBusinessHoursCustomHoursMondayInput>
}

export interface CreateSiteBusinessHoursCustomHoursMondayInput {
  endTime: Scalars['String']['input']
  startTime: Scalars['String']['input']
}

export interface CreateSiteBusinessHoursExceptionsInput {
  date: Scalars['String']['input']
  id: Scalars['ID']['input']
  isClosed: Scalars['Boolean']['input']
  label: Scalars['String']['input']
  ranges: Array<CreateSiteBusinessHoursWeeklyMondayRangesInput>
}

export interface CreateSiteBusinessHoursInput {
  customHours?: InputMaybe<CreateSiteBusinessHoursCustomHoursInput>
  endTime?: InputMaybe<Scalars['String']['input']>
  exceptions?: InputMaybe<Array<CreateSiteBusinessHoursExceptionsInput>>
  hasCustomHours: Scalars['Boolean']['input']
  is24x7?: InputMaybe<Scalars['Boolean']['input']>
  startTime?: InputMaybe<Scalars['String']['input']>
  weekly?: InputMaybe<CreateSiteBusinessHoursWeeklyInput>
}

export interface CreateSiteBusinessHoursWeeklyInput {
  friday: CreateSiteBusinessHoursWeeklyMondayInput
  monday: CreateSiteBusinessHoursWeeklyMondayInput
  saturday: CreateSiteBusinessHoursWeeklyMondayInput
  sunday: CreateSiteBusinessHoursWeeklyMondayInput
  thursday: CreateSiteBusinessHoursWeeklyMondayInput
  tuesday: CreateSiteBusinessHoursWeeklyMondayInput
  wednesday: CreateSiteBusinessHoursWeeklyMondayInput
}

export interface CreateSiteBusinessHoursWeeklyMondayInput {
  isClosed: Scalars['Boolean']['input']
  ranges: Array<CreateSiteBusinessHoursWeeklyMondayRangesInput>
}

export interface CreateSiteBusinessHoursWeeklyMondayRangesInput {
  closesAt: Scalars['String']['input']
  opensAt: Scalars['String']['input']
}

export interface CreateSiteCustomIntegrationsInput {
  integrationId: Scalars['ID']['input']
  keyValues: Array<CreateSiteCustomIntegrationsKeyValuesInput>
}

export interface CreateSiteCustomIntegrationsKeyValuesInput {
  key: Scalars['ID']['input']
  value?: InputMaybe<Scalars['String']['input']>
}

export interface CreateSiteFormInputInput {
  description: Scalars['String']['input']
  name: Scalars['String']['input']
}

export interface CreateSiteGroupInputInput {
  name: Scalars['String']['input']
  siteIds: Array<Scalars['ID']['input']>
}

export interface CreateSiteInputInput {
  addressCity?: InputMaybe<Scalars['String']['input']>
  addressCountry?: InputMaybe<Scalars['String']['input']>
  addressPostalCode?: InputMaybe<Scalars['String']['input']>
  addressState?: InputMaybe<Scalars['String']['input']>
  addressStreet?: InputMaybe<Scalars['String']['input']>
  addressStreet2?: InputMaybe<Scalars['String']['input']>
  adminConfigurations?: InputMaybe<CreateSiteAdminConfigurationsInput>
  appName?: InputMaybe<Scalars['String']['input']>
  businessEmail?: InputMaybe<Scalars['String']['input']>
  businessHours?: InputMaybe<CreateSiteBusinessHoursInput>
  capacity?: InputMaybe<Scalars['Float']['input']>
  clientFeesTemplateId?: InputMaybe<Scalars['String']['input']>
  connectedSharedSiteIds?: InputMaybe<Array<Scalars['String']['input']>>
  corePlanLevel?: InputMaybe<CorePlanLevel>
  countryId?: InputMaybe<Scalars['ID']['input']>
  customIntegrations?: InputMaybe<Array<CreateSiteCustomIntegrationsInput>>
  description?: InputMaybe<Scalars['String']['input']>
  displayBusinessHours: Scalars['Boolean']['input']
  email?: InputMaybe<Scalars['String']['input']>
  gatewayCurrentPaymentMethodId?: InputMaybe<Scalars['String']['input']>
  gatewayCustomerId?: InputMaybe<Scalars['String']['input']>
  hapanaFeesTemplateId?: InputMaybe<Scalars['ID']['input']>
  integrations?: InputMaybe<CreateSiteIntegrationsInput>
  isDigital?: InputMaybe<Scalars['Boolean']['input']>
  membersCount?: InputMaybe<Scalars['Float']['input']>
  name: Scalars['String']['input']
  openDate?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  phonePrefix?: InputMaybe<Scalars['String']['input']>
  rebateTemplateIds?: InputMaybe<Array<Scalars['ID']['input']>>
  regionId?: InputMaybe<Scalars['ID']['input']>
  royaltiesTemplateId?: InputMaybe<Scalars['ID']['input']>
  stateId?: InputMaybe<Scalars['String']['input']>
  timezone?: InputMaybe<Scalars['String']['input']>
  v1EncryptedId?: InputMaybe<Scalars['String']['input']>
  website?: InputMaybe<Scalars['String']['input']>
  workshopType: SiteWorkshopType
}

export interface CreateSiteIntegrationsBarcodeUrlInput {
  barcodeCheckInUrl?: InputMaybe<Scalars['String']['input']>
}

export interface CreateSiteIntegrationsCalendarSyncCalendarsInput {
  calendarId: Scalars['String']['input']
  calendarLink: Scalars['String']['input']
  calendarName: Scalars['String']['input']
}

export interface CreateSiteIntegrationsCalendarSyncInput {
  calendars?: InputMaybe<Array<CreateSiteIntegrationsCalendarSyncCalendarsInput>>
}

export interface CreateSiteIntegrationsEgymInput {
  activeMembershipType: EgymMembershipType
  consecutiveFailures?: InputMaybe<Scalars['Float']['input']>
  enabled: Scalars['Boolean']['input']
  lastError?: InputMaybe<Scalars['String']['input']>
  lastFailureAt?: InputMaybe<Scalars['String']['input']>
  lastSuccessAt?: InputMaybe<Scalars['String']['input']>
}

export interface CreateSiteIntegrationsFitnessPassportInput {
  deviceTokenSuffix?: InputMaybe<Scalars['String']['input']>
  enabled: Scalars['Boolean']['input']
  failurePolicy: FitnessPassportFailurePolicy
  lastTestError?: InputMaybe<Scalars['String']['input']>
  lastTestOutcome?: InputMaybe<FitnessPassportConnectionState>
  lastTestedAt?: InputMaybe<Scalars['String']['input']>
  siteTokenSuffix?: InputMaybe<Scalars['String']['input']>
}

export interface CreateSiteIntegrationsFrontDeskKioskBetaVersionInput {
  classCheckInEnabled?: InputMaybe<Scalars['Boolean']['input']>
  classCheckInRequirePolicies?: InputMaybe<Scalars['Boolean']['input']>
  classCheckInSpotBooking?: InputMaybe<Scalars['Boolean']['input']>
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  introOffersEnabled?: InputMaybe<Scalars['Boolean']['input']>
  kioskPinHash?: InputMaybe<Scalars['String']['input']>
  kioskPinSetAt?: InputMaybe<Scalars['String']['input']>
  kioskSessionId?: InputMaybe<Scalars['String']['input']>
  kioskSessionValidityDays?: InputMaybe<Scalars['Float']['input']>
  kioskUrlV2?: InputMaybe<Scalars['String']['input']>
  packagesMembershipsEnabled?: InputMaybe<Scalars['Boolean']['input']>
}

export interface CreateSiteIntegrationsFrontDeskKioskInput {
  betaVersion?: InputMaybe<CreateSiteIntegrationsFrontDeskKioskBetaVersionInput>
  kioskDefaults?: InputMaybe<CreateSiteIntegrationsFrontDeskKioskKioskDefaultsInput>
  kioskUrlV1?: InputMaybe<Scalars['String']['input']>
}

export interface CreateSiteIntegrationsFrontDeskKioskKioskDefaultsInput {
  checkIn?: InputMaybe<Scalars['Boolean']['input']>
  classCheckIn?: InputMaybe<Scalars['Boolean']['input']>
  forms?: InputMaybe<Scalars['Boolean']['input']>
  introOffers?: InputMaybe<Scalars['Boolean']['input']>
  manageAccount?: InputMaybe<Scalars['Boolean']['input']>
  packages?: InputMaybe<Scalars['Boolean']['input']>
}

export interface CreateSiteIntegrationsGrowAuthenticationInput {
  accessToken: Scalars['String']['input']
  expiresAt: Scalars['String']['input']
  refreshToken: Scalars['String']['input']
}

export interface CreateSiteIntegrationsGrowInput {
  authentication?: InputMaybe<CreateSiteIntegrationsGrowAuthenticationInput>
  enabled: Scalars['Boolean']['input']
  growLocationId?: InputMaybe<Scalars['String']['input']>
  hqId?: InputMaybe<Scalars['String']['input']>
  lastCollect?: InputMaybe<CreateSiteIntegrationsGrowLastCollectInput>
}

export interface CreateSiteIntegrationsGrowLastCollectInput {
  full?: InputMaybe<Scalars['String']['input']>
  partial?: InputMaybe<Scalars['String']['input']>
}

export interface CreateSiteIntegrationsHapanaApiKeyInput {
  apiKey?: InputMaybe<Scalars['String']['input']>
}

export interface CreateSiteIntegrationsImportClientsInput {
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  lastImportDate?: InputMaybe<Scalars['String']['input']>
}

export interface CreateSiteIntegrationsInput {
  accessControls?: InputMaybe<UpdateAccessControlsInputInput>
  accuroFit?: InputMaybe<UpdateAccuroFitInputInput>
  barcodeUrl?: InputMaybe<CreateSiteIntegrationsBarcodeUrlInput>
  calendarSync?: InputMaybe<CreateSiteIntegrationsCalendarSyncInput>
  classPass?: InputMaybe<UpdateClassPassInputInput>
  egym?: InputMaybe<CreateSiteIntegrationsEgymInput>
  externalFeedbackLink?: InputMaybe<UpdateExternalFeedbackLinkInputInput>
  facebookPixel?: InputMaybe<UpdateFacebookPixelInputInput>
  fitnessPassport?: InputMaybe<CreateSiteIntegrationsFitnessPassportInput>
  frontDeskKiosk?: InputMaybe<CreateSiteIntegrationsFrontDeskKioskInput>
  googleTagManager?: InputMaybe<UpdateGoogleTagManagerInputInput>
  grow?: InputMaybe<CreateSiteIntegrationsGrowInput>
  /** WIP: This schema needs to be revisited based on final implementation requirements */
  hapanaAccessController?: InputMaybe<UpdateHapanaAccessControllerInputInput>
  hapanaApiKey?: InputMaybe<CreateSiteIntegrationsHapanaApiKeyInput>
  importClients?: InputMaybe<CreateSiteIntegrationsImportClientsInput>
  spivi?: InputMaybe<UpdateSpiviInputInput>
  tanning?: InputMaybe<CreateSiteIntegrationsTanningInput>
  tanningHealth?: InputMaybe<CreateSiteIntegrationsTanningHealthInput>
  topaz?: InputMaybe<UpdateTopazInputInput>
  wellhub?: InputMaybe<CreateSiteIntegrationsWellhubInput>
  zapier?: InputMaybe<UpdateZapierInputInput>
  zoom?: InputMaybe<CreateSiteIntegrationsZoomInput>
}

export interface CreateSiteIntegrationsTanningHealthInput {
  consecutiveStartFailures?: InputMaybe<Scalars['Float']['input']>
  lastBedUpdateAt?: InputMaybe<Scalars['String']['input']>
  lastRegisteredAt?: InputMaybe<Scalars['String']['input']>
  lastStartError?: InputMaybe<CreateSiteIntegrationsTanningHealthLastStartErrorInput>
  lastStartFailureAt?: InputMaybe<Scalars['String']['input']>
  lastStartSuccessAt?: InputMaybe<Scalars['String']['input']>
}

export interface CreateSiteIntegrationsTanningHealthLastStartErrorInput {
  connectorCode?: InputMaybe<Scalars['String']['input']>
  kind: TanningConnectorErrorKind
  message: Scalars['String']['input']
}

export interface CreateSiteIntegrationsTanningInput {
  apiKey?: InputMaybe<Scalars['String']['input']>
  externalApiKey?: InputMaybe<Scalars['String']['input']>
  externalApiUrl?: InputMaybe<Scalars['String']['input']>
  maintenanceEmail?: InputMaybe<Scalars['String']['input']>
}

export interface CreateSiteIntegrationsWellhubInput {
  connectedAt?: InputMaybe<Scalars['String']['input']>
  enabled: Scalars['Boolean']['input']
  gymId?: InputMaybe<Scalars['String']['input']>
  gymName?: InputMaybe<Scalars['String']['input']>
}

export interface CreateSiteIntegrationsZoomAuthenticationInput {
  accessToken: Scalars['String']['input']
  expiresAt: Scalars['String']['input']
  refreshToken: Scalars['String']['input']
}

export interface CreateSiteIntegrationsZoomInput {
  accountId?: InputMaybe<Scalars['String']['input']>
  authentication?: InputMaybe<CreateSiteIntegrationsZoomAuthenticationInput>
  authorized: Scalars['Boolean']['input']
  connectedAt?: InputMaybe<Scalars['String']['input']>
  connectedUserEmail?: InputMaybe<Scalars['String']['input']>
  connectedUserId?: InputMaybe<Scalars['String']['input']>
  userId?: InputMaybe<Scalars['String']['input']>
}

/** Input for creating a site location with optional rooms */
export interface CreateSiteLocationInput {
  addressLine1?: InputMaybe<Scalars['String']['input']>
  addressLine2?: InputMaybe<Scalars['String']['input']>
  channelId?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  isDefault: Scalars['Boolean']['input']
  name: Scalars['String']['input']
  postalCode?: InputMaybe<Scalars['String']['input']>
  rooms?: InputMaybe<Array<CreateSiteLocationRoomInput>>
  state?: InputMaybe<Scalars['String']['input']>
  type: SiteLocationType
}

export interface CreateSiteLocationRoomCustomHoursInput {
  friday?: InputMaybe<CreateSiteLocationRoomCustomHoursMondayInput>
  monday?: InputMaybe<CreateSiteLocationRoomCustomHoursMondayInput>
  saturday?: InputMaybe<CreateSiteLocationRoomCustomHoursMondayInput>
  sunday?: InputMaybe<CreateSiteLocationRoomCustomHoursMondayInput>
  thursday?: InputMaybe<CreateSiteLocationRoomCustomHoursMondayInput>
  tuesday?: InputMaybe<CreateSiteLocationRoomCustomHoursMondayInput>
  wednesday?: InputMaybe<CreateSiteLocationRoomCustomHoursMondayInput>
}

export interface CreateSiteLocationRoomCustomHoursMondayInput {
  endTime: Scalars['String']['input']
  startTime: Scalars['String']['input']
}

/** Input for creating a room in a site location */
export interface CreateSiteLocationRoomInput {
  allowOverlapping: Scalars['Boolean']['input']
  customHours?: InputMaybe<CreateSiteLocationRoomCustomHoursInput>
  endTime?: InputMaybe<Scalars['String']['input']>
  hasResourceBooking: Scalars['Boolean']['input']
  name: Scalars['String']['input']
  roomResourceTemplateId?: InputMaybe<Scalars['String']['input']>
  sameHoursAsLocation: Scalars['Boolean']['input']
  startTime?: InputMaybe<Scalars['String']['input']>
}

export interface CreateSitePayrollTierConfigurationInputInput {
  payrollType: PayrollType
  rates: CreateSitePayrollTierConfigurationRatesInput
  siteSessionTypeId?: InputMaybe<Scalars['ID']['input']>
  type: PayrollTierType
}

export interface CreateSitePayrollTierConfigurationRatesInput {
  bonusClassFull?: InputMaybe<Scalars['Float']['input']>
  bonusFlat?: InputMaybe<Scalars['Float']['input']>
  bonusPerClient?: InputMaybe<Scalars['Float']['input']>
  clientOver?: InputMaybe<Scalars['Float']['input']>
  flat?: InputMaybe<Scalars['Float']['input']>
  hourly?: InputMaybe<Scalars['Float']['input']>
  perHead?: InputMaybe<Scalars['Float']['input']>
  percentage?: InputMaybe<Scalars['Float']['input']>
  unlimitedFixed?: InputMaybe<Scalars['Float']['input']>
}

export interface CreateSitePayrollTierInputInput {
  name: Scalars['String']['input']
}

export interface CreateSitePolicyInputInput {
  acceptanceMethod?: InputMaybe<PolicyAcceptanceMethod>
  content: Scalars['String']['input']
  equipmentScope?: InputMaybe<Array<PolicyEquipmentScope>>
  guardianInPersonOnly?: InputMaybe<Scalars['Boolean']['input']>
  isRequiredToAgree: Scalars['Boolean']['input']
  name: Scalars['String']['input']
  renewalMonths?: InputMaybe<Scalars['Float']['input']>
  requiredForEquipmentUse?: InputMaybe<Scalars['Boolean']['input']>
  signerRule?: InputMaybe<PolicySignerRule>
}

/** Input for creating a room resource template with advanced layout capabilities */
export interface CreateSiteRoomResourceTemplateInput {
  bookingProperties?: InputMaybe<Array<CreateSiteRoomResourceTemplatePropertyInput>>
  boxId?: InputMaybe<Scalars['Float']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  isDefault: Scalars['Boolean']['input']
  isDraft: Scalars['Boolean']['input']
  name: Scalars['String']['input']
  spotHeight?: InputMaybe<Scalars['Float']['input']>
  spotWidth?: InputMaybe<Scalars['Float']['input']>
  spots: Array<CreateSiteRoomResourceTemplateSpotsInput>
}

/** Input for creating a property requirement (primary or custom) */
export interface CreateSiteRoomResourceTemplatePropertyInput {
  defaultValue?: InputMaybe<Scalars['String']['input']>
  isRequired: Scalars['Boolean']['input']
  name?: InputMaybe<Scalars['String']['input']>
  orderIndex: Scalars['Float']['input']
  primaryPropertyType?: InputMaybe<RoomResourceTemplateBookingPropertyTypes>
  siteCustomPropertyId?: InputMaybe<Scalars['String']['input']>
  type: SiteRoomResourceTemplatePropertyTypes
}

export interface CreateSiteRoomResourceTemplateSpotsInput {
  enabled: Scalars['Boolean']['input']
  equipmentType: EquipmentType
  height: Scalars['Float']['input']
  name: Scalars['String']['input']
  position: Scalars['String']['input']
  width: Scalars['Float']['input']
  x: Scalars['Float']['input']
  y: Scalars['Float']['input']
}

export interface CreateSiteSettingsCustomizationColorInputInput {
  color: Scalars['String']['input']
}

/** Input for creating a new site supplier */
export interface CreateSiteSupplierInput {
  address?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  phone?: InputMaybe<Scalars['String']['input']>
  status: SiteSupplierStatus
}

export interface CreateSiteWebhookInputInput {
  events: Array<Scalars['String']['input']>
  headerKey?: InputMaybe<Scalars['String']['input']>
  headerValue?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  url: Scalars['String']['input']
}

export interface CreateStaffAccessPolicyInputInput {
  accessPermissions?: InputMaybe<Array<AccessPermissions>>
  allowedNetworkIds?: InputMaybe<Array<Scalars['ID']['input']>>
  corporatePermissions?: InputMaybe<Array<CorporatePermissions>>
  name: Scalars['String']['input']
  sitePermissions?: InputMaybe<Array<SitePermissions>>
}

export interface CreateStaffAllowedNetworkInputInput {
  address: Scalars['String']['input']
  label: Scalars['String']['input']
  notes?: InputMaybe<Scalars['String']['input']>
  siteId?: InputMaybe<Scalars['ID']['input']>
}

export interface CreateStaffUserDataInput {
  isInstructor?: InputMaybe<Scalars['Boolean']['input']>
  payrollId?: InputMaybe<Scalars['String']['input']>
  siteId?: InputMaybe<Scalars['ID']['input']>
  workingHours?: InputMaybe<UpdateWorkingHoursWorkingHoursInput>
}

export interface CreateStaffUserInputInput {
  about: Scalars['String']['input']
  allowedNetworkIds?: InputMaybe<Array<Scalars['ID']['input']>>
  /** Set when creating from a location: allowedNetworkIds must be that location's */
  allowedNetworksSiteId?: InputMaybe<Scalars['ID']['input']>
  data?: InputMaybe<CreateStaffUserDataInput>
  dateOfBirth?: InputMaybe<Scalars['String']['input']>
  email: Scalars['String']['input']
  employeeNumber?: InputMaybe<Scalars['Float']['input']>
  firstName: Scalars['String']['input']
  gender?: InputMaybe<Scalars['String']['input']>
  hobbies: Scalars['String']['input']
  instagramHandle: Scalars['String']['input']
  lastName: Scalars['String']['input']
  phone: Scalars['String']['input']
  rules: Array<AddAccessRuleInputInput>
  siteData?: InputMaybe<CreateStaffUserDataInput>
  status: StaffUserStatus
}

export interface CreateStaffUserSmartGroupFiltersInput {
  ageRange?: InputMaybe<ClientFiltersAgeRangeInput>
  attendanceMilestone?: InputMaybe<ClientFiltersNoShowLateCancelAccrualInput>
  birthMonth?: InputMaybe<ClientFiltersGenderInput>
  clientStatus?: InputMaybe<ClientFiltersGenderInput>
  contractStatus?: InputMaybe<ClientFiltersGenderInput>
  contractType?: InputMaybe<ClientFiltersGenderInput>
  daysAbsent?: InputMaybe<ClientFiltersAgeRangeInput>
  daysInactive?: InputMaybe<ClientFiltersAgeRangeInput>
  email?: InputMaybe<ClientFiltersFirstNameInput>
  emailOptIn?: InputMaybe<ClientFiltersGenderInput>
  failedPaymentsCount?: InputMaybe<ClientFiltersNoShowLateCancelAccrualInput>
  firstName?: InputMaybe<ClientFiltersFirstNameInput>
  fullName?: InputMaybe<ClientFiltersFirstNameInput>
  gender?: InputMaybe<ClientFiltersGenderInput>
  hasCreditsForSessionType?: InputMaybe<ClientFiltersHasCreditsForSessionTypeInput>
  isSuspended?: InputMaybe<ClientFiltersGenderInput>
  joinDate?: InputMaybe<ClientFiltersJoinDateInput>
  lastAttendanceDate?: InputMaybe<ClientFiltersJoinDateInput>
  lastName?: InputMaybe<ClientFiltersFirstNameInput>
  lastPaymentDate?: InputMaybe<ClientFiltersJoinDateInput>
  lastVisitDate?: InputMaybe<ClientFiltersJoinDateInput>
  locationStatus?: InputMaybe<ClientFiltersGenderInput>
  masterUnsubscribe?: InputMaybe<ClientFiltersGenderInput>
  noShowLateCancelAccrual?: InputMaybe<ClientFiltersNoShowLateCancelAccrualInput>
  phone?: InputMaybe<ClientFiltersFirstNameInput>
  profileCreatedDate?: InputMaybe<ClientFiltersJoinDateInput>
  sessionFrequency?: InputMaybe<ClientFiltersGenderInput>
  smsOptIn?: InputMaybe<ClientFiltersGenderInput>
}

export interface CreateStaffUserSmartGroupInputInput {
  filters?: InputMaybe<CreateStaffUserSmartGroupFiltersInput>
  isVisible: Scalars['Boolean']['input']
  name: Scalars['String']['input']
}

export interface CreateSupportTicketInput {
  brandId?: InputMaybe<Scalars['String']['input']>
  brandName?: InputMaybe<Scalars['String']['input']>
  chatHistory?: InputMaybe<Array<TicketChatMessageInput>>
  chatId?: InputMaybe<Scalars['String']['input']>
  corporateId?: InputMaybe<Scalars['String']['input']>
  corporateName?: InputMaybe<Scalars['String']['input']>
  /** The URL the user was viewing when they reported the issue */
  currentUrl?: InputMaybe<Scalars['String']['input']>
  description: Scalars['String']['input']
  email: Scalars['String']['input']
  /** Browser/OS/device info (PostHog context) */
  environment?: InputMaybe<Scalars['String']['input']>
  /** Structured per-issue-type conditional field answers */
  fields?: InputMaybe<Array<SupportTicketFieldInput>>
  firstName: Scalars['String']['input']
  issueType?: InputMaybe<SupportIssueType>
  lastName: Scalars['String']['input']
  locationId?: InputMaybe<Scalars['String']['input']>
  locationName?: InputMaybe<Scalars['String']['input']>
  pageName?: InputMaybe<Scalars['String']['input']>
  pathname?: InputMaybe<Scalars['String']['input']>
  planTier?: InputMaybe<Scalars['String']['input']>
  /** PostHog distinct ID for user tracking */
  posthogDistinctId?: InputMaybe<Scalars['String']['input']>
  /** PostHog session replay URL for debugging */
  posthogSessionUrl?: InputMaybe<Scalars['String']['input']>
  /** Screenshots attached to the support ticket */
  screenshots?: InputMaybe<Array<ScreenshotInput>>
  siteId?: InputMaybe<Scalars['String']['input']>
  siteName?: InputMaybe<Scalars['String']['input']>
  /** Optional subject - auto-generated from description if not provided */
  subject?: InputMaybe<Scalars['String']['input']>
  userId?: InputMaybe<Scalars['String']['input']>
  userRole?: InputMaybe<Scalars['String']['input']>
}

export interface CreateTaxSettingInputInput {
  enabled: Scalars['Boolean']['input']
  name: Scalars['String']['input']
  rate: Scalars['String']['input']
  setting: TaxSettingType
}

export interface CreateTerminalHandoffRequestAgreementsInput {
  agreementId?: InputMaybe<Scalars['ID']['input']>
  inlineContent?: InputMaybe<Scalars['String']['input']>
  inlineName?: InputMaybe<Scalars['String']['input']>
  reference: Scalars['String']['input']
  siteAgreementTemplateId?: InputMaybe<Scalars['ID']['input']>
}

export interface CreateTerminalHandoffRequestInput {
  agreements: Array<CreateTerminalHandoffRequestAgreementsInput>
  clientId: Scalars['ID']['input']
  fields: Array<TerminalHandoffField>
  siteId: Scalars['ID']['input']
  siteTerminalReaderId: Scalars['ID']['input']
  sourceSurface: TerminalHandoffSourceSurface
}

export enum CreatedAtLevel {
  CORPORATE = 'CORPORATE',
  SITE = 'SITE',
}

/** Type of actor who created the activity: STAFF, CLIENT, or SYSTEM */
export enum CreatedByType {
  AGGREGATOR = 'AGGREGATOR',
  CLIENT = 'CLIENT',
  STAFF = 'STAFF',
  SYSTEM = 'SYSTEM',
}

/** Input type for a door provider credential field */
export enum CredentialFieldType {
  password = 'password',
  text = 'text',
  url = 'url',
}

export enum CreditExpirationType {
  CUSTOM = 'CUSTOM',
  ON_NEXT_ALLOCATION = 'ON_NEXT_ALLOCATION',
}

export enum CreditExpirationUnit {
  DAYS = 'DAYS',
  MONTHS = 'MONTHS',
  WEEKS = 'WEEKS',
  YEARS = 'YEARS',
}

export enum CreditRolloverPolicy {
  NO_ROLLOVER = 'NO_ROLLOVER',
  ROLLOVER_ALL = 'ROLLOVER_ALL',
  ROLLOVER_UNUSED = 'ROLLOVER_UNUSED',
}

/** Why a client could not pay for a session with credits */
export enum CreditShortfallReason {
  FAMILY_CREDITS_ON_HOLD = 'FAMILY_CREDITS_ON_HOLD',
  FAMILY_CREDITS_SUSPENDED = 'FAMILY_CREDITS_SUSPENDED',
  NOT_VALID_ON_DATE = 'NOT_VALID_ON_DATE',
  NO_ACTIVE_PACKAGE = 'NO_ACTIVE_PACKAGE',
  NO_CREDITS_REMAINING = 'NO_CREDITS_REMAINING',
  SESSION_DOES_NOT_USE_CREDITS = 'SESSION_DOES_NOT_USE_CREDITS',
  SESSION_TYPE_NOT_COVERED = 'SESSION_TYPE_NOT_COVERED',
}

export enum CreditType {
  LIMITED = 'LIMITED',
  UNLIMITED = 'UNLIMITED',
}

/** Currency */
export enum Currency {
  AED = 'AED',
  AFN = 'AFN',
  ALL = 'ALL',
  ANG = 'ANG',
  AOA = 'AOA',
  ARS = 'ARS',
  AUD = 'AUD',
  AWG = 'AWG',
  AZN = 'AZN',
  BAM = 'BAM',
  BBD = 'BBD',
  BGN = 'BGN',
  BHD = 'BHD',
  BMD = 'BMD',
  BND = 'BND',
  BOB = 'BOB',
  BRL = 'BRL',
  BSD = 'BSD',
  BWP = 'BWP',
  BYR = 'BYR',
  BZD = 'BZD',
  CAD = 'CAD',
  CHF = 'CHF',
  CLP = 'CLP',
  CNY = 'CNY',
  COP = 'COP',
  CRC = 'CRC',
  CUP = 'CUP',
  CZK = 'CZK',
  DKK = 'DKK',
  DOP = 'DOP',
  EGP = 'EGP',
  EUR = 'EUR',
  FJD = 'FJD',
  FKP = 'FKP',
  GBP = 'GBP',
  GGP = 'GGP',
  GHC = 'GHC',
  GIP = 'GIP',
  GTQ = 'GTQ',
  GYD = 'GYD',
  HKD = 'HKD',
  HNL = 'HNL',
  HRK = 'HRK',
  HUF = 'HUF',
  IDR = 'IDR',
  ILS = 'ILS',
  IMP = 'IMP',
  INR = 'INR',
  IRR = 'IRR',
  ISK = 'ISK',
  JEP = 'JEP',
  JMD = 'JMD',
  JPY = 'JPY',
  KGS = 'KGS',
  KHR = 'KHR',
  KPW = 'KPW',
  KRW = 'KRW',
  KYD = 'KYD',
  KZT = 'KZT',
  LAK = 'LAK',
  LBP = 'LBP',
  LKR = 'LKR',
  LRD = 'LRD',
  LTL = 'LTL',
  LVL = 'LVL',
  MKD = 'MKD',
  MNT = 'MNT',
  MUR = 'MUR',
  MXN = 'MXN',
  MYR = 'MYR',
  MZN = 'MZN',
  NAD = 'NAD',
  NGN = 'NGN',
  NIO = 'NIO',
  NOK = 'NOK',
  NPR = 'NPR',
  NZD = 'NZD',
  OMR = 'OMR',
  PAB = 'PAB',
  PEN = 'PEN',
  PHP = 'PHP',
  PKR = 'PKR',
  PLN = 'PLN',
  PYG = 'PYG',
  QAR = 'QAR',
  RON = 'RON',
  RSD = 'RSD',
  RUB = 'RUB',
  SAR = 'SAR',
  SBD = 'SBD',
  SCR = 'SCR',
  SEK = 'SEK',
  SGD = 'SGD',
  SHP = 'SHP',
  SOS = 'SOS',
  SRD = 'SRD',
  SVC = 'SVC',
  SYP = 'SYP',
  THB = 'THB',
  TRL = 'TRL',
  TRY = 'TRY',
  TTD = 'TTD',
  TVD = 'TVD',
  TWD = 'TWD',
  UAH = 'UAH',
  USD = 'USD',
  UYU = 'UYU',
  UZS = 'UZS',
  VEF = 'VEF',
  VND = 'VND',
  XCD = 'XCD',
  YER = 'YER',
  ZAR = 'ZAR',
  ZWD = 'ZWD',
}

/** Current opening method of a custom link */
export enum CustomLinkOpeningMethod {
  NEW_TAB = 'NEW_TAB',
  NEW_WINDOW = 'NEW_WINDOW',
  SAME_TAB = 'SAME_TAB',
}

/** Input for creating custom property alerts */
export interface CustomPropertyAlertCreateInput {
  isDisplayPropertyValueAsAlert: Scalars['Boolean']['input']
  operator: AlertOperator
  text?: InputMaybe<Scalars['String']['input']>
  value?: InputMaybe<Scalars['String']['input']>
}

/** Input for updating custom property alerts */
export interface CustomPropertyAlertUpdateInput {
  isDisplayPropertyValueAsAlert?: InputMaybe<Scalars['Boolean']['input']>
  operator?: InputMaybe<AlertOperator>
  text?: InputMaybe<Scalars['String']['input']>
  value?: InputMaybe<Scalars['String']['input']>
}

export enum CustomPropertyCategory {
  custom = 'custom',
  emergency_contact = 'emergency_contact',
  primary_info = 'primary_info',
}

/** Type of user who changed a custom property value */
export enum CustomPropertyChangedByType {
  admin = 'admin',
  client = 'client',
  form_submission = 'form_submission',
  staff = 'staff',
  system = 'system',
}

/** Input for creating custom properties */
export interface CustomPropertyCreateInput {
  category: CustomPropertyCategory
  enableClientEditing: Scalars['Boolean']['input']
  growId?: InputMaybe<Scalars['String']['input']>
  hasSubtext: Scalars['Boolean']['input']
  name: Scalars['String']['input']
  options?: InputMaybe<Array<CustomPropertyCreateOptionsInput>>
  subtext?: InputMaybe<Scalars['String']['input']>
  type: CustomPropertyType
}

export interface CustomPropertyCreateOptionsInput {
  displayOrder?: InputMaybe<Scalars['Float']['input']>
  option: Scalars['String']['input']
}

export enum CustomPropertyType {
  checkbox = 'checkbox',
  date_picker = 'date_picker',
  number = 'number',
  other = 'other',
  select = 'select',
  text = 'text',
  text_area = 'text_area',
}

/** Input for updating custom properties */
export interface CustomPropertyUpdateInput {
  category?: InputMaybe<CustomPropertyCategory>
  enableClientEditing?: InputMaybe<Scalars['Boolean']['input']>
  growId?: InputMaybe<Scalars['String']['input']>
  hasSubtext?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  options?: InputMaybe<Array<CustomPropertyCreateOptionsInput>>
  subtext?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<CustomPropertyType>
}

/** Dark mode adjustment strategy */
export enum DarkModeStrategy {
  MANUAL = 'MANUAL',
  NONE = 'NONE',
  SMART = 'SMART',
}

/** Input for dashboard queries */
export interface DashboardInput {
  endDate?: InputMaybe<Scalars['String']['input']>
  locationId?: InputMaybe<Scalars['String']['input']>
  startDate?: InputMaybe<Scalars['String']['input']>
}

/** Database provisioning model for a corporate brand. core = shared demo database; independent = isolated dedicated database. */
export enum DatabaseType {
  core = 'core',
  independent = 'independent',
}

export enum DateFilterOperator {
  is = 'is',
  is_after = 'is_after',
  is_before = 'is_before',
  is_between = 'is_between',
}

/** Date range filter */
export interface DateRange {
  /** ISO date string (YYYY-MM-DD) */
  end: Scalars['String']['input']
  /** ISO date string (YYYY-MM-DD) */
  start: Scalars['String']['input']
}

export enum DateRangeDirection {
  future = 'future',
  past = 'past',
}

export enum DateRangeType {
  fixed = 'fixed',
  relative = 'relative',
}

export enum DayOfWeek {
  FRIDAY = 'FRIDAY',
  MONDAY = 'MONDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
  THURSDAY = 'THURSDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
}

/** Input for a recipient declining a shared-package invite */
export interface DeclineSharedCreditsInput {
  inviteToken?: InputMaybe<Scalars['String']['input']>
  ownerClientId: Scalars['ID']['input']
  serviceId: Scalars['ID']['input']
}

/** Supported deep link destination screens in the mobile app */
export enum DeepLinkDestination {
  aboutUs = 'aboutUs',
  activate = 'activate',
  allVideos = 'allVideos',
  billingHistory = 'billingHistory',
  billingInformation = 'billingInformation',
  buddy = 'buddy',
  buyGiftCard = 'buyGiftCard',
  buyPackage = 'buyPackage',
  challenges = 'challenges',
  changePassword = 'changePassword',
  contactlessCheckin = 'contactlessCheckin',
  editProfile = 'editProfile',
  help = 'help',
  home = 'home',
  instructorProfile = 'instructorProfile',
  more = 'more',
  myBooking = 'myBooking',
  myPackage = 'myPackage',
  newsCategoryDetail = 'newsCategoryDetail',
  newsDetail = 'newsDetail',
  newsHome = 'newsHome',
  newsSubCategoryDetail = 'newsSubCategoryDetail',
  packageDetail = 'packageDetail',
  performanceMetrics = 'performanceMetrics',
  privates = 'privates',
  redeemGiftCard = 'redeemGiftCard',
  refer = 'refer',
  referFriend = 'referFriend',
  sessionDetail = 'sessionDetail',
  sessions = 'sessions',
  sharePackage = 'sharePackage',
  sites = 'sites',
  stats = 'stats',
  viewProfile = 'viewProfile',
  visitHistory = 'visitHistory',
  webUrl = 'webUrl',
  workshops = 'workshops',
}

/** Input for deleting a session (scope single) or it and every later occurrence of its series (scope future): bookings are cancelled, refunded and notified first, then the sessions are removed from the schedule and the member app */
export interface DeleteSessionOccurrencesInput {
  includeDownstreamSplits?: InputMaybe<Scalars['Boolean']['input']>
  includeModifiedSessions?: InputMaybe<Scalars['Boolean']['input']>
  message?: InputMaybe<Scalars['String']['input']>
  notificationMethods: Array<NotificationMethod>
  scope: CancelSessionScope
  sessionId: Scalars['String']['input']
  siteId: Scalars['String']['input']
  subject?: InputMaybe<Scalars['String']['input']>
}

/** Configuration input for demo seeding */
export interface DemoSeedingConfigInput {
  density?: InputMaybe<DemoSeedingDensity>
  locationCount: Scalars['Float']['input']
  timeRangeMonths: Scalars['Float']['input']
}

/** Session density for demo data generation */
export enum DemoSeedingDensity {
  HEAVY = 'HEAVY',
  LIGHT = 'LIGHT',
}

/** Status of a demo seeding job */
export enum DemoSeedingJobStatus {
  CLEARING = 'CLEARING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING',
}

/** Persona type for demo data generation */
export enum DemoSeedingPersona {
  STUDIO = 'STUDIO',
}

/** What a kiosk reported it is doing when it flagged itself busy */
export enum DeviceBusyReason {
  FORM_IN_PROGRESS = 'FORM_IN_PROGRESS',
  MEMBER_SIGNUP = 'MEMBER_SIGNUP',
  PURCHASE = 'PURCHASE',
}

/** An optional capability staff can grant to a paired kiosk */
export enum DeviceCapability {
  FORMS = 'FORMS',
}

/** Which credential members present at this Check-In Agent terminal: a barcode, or an RFID fob/card read as its chip serial */
export enum DeviceInputMode {
  BARCODE = 'BARCODE',
  FOB = 'FOB',
}

/** What a paired device is: a Check-In Agent terminal or a self-service kiosk */
export enum DeviceKind {
  CHECKIN_AGENT = 'CHECKIN_AGENT',
  KIOSK = 'KIOSK',
}

/** Whether a paired device has reported in recently, computed from its last heartbeat */
export enum DeviceLiveness {
  OFFLINE_NEVER_SEEN = 'OFFLINE_NEVER_SEEN',
  ONLINE = 'ONLINE',
  STALE = 'STALE',
}

/** Platform type for device tokens */
export enum DevicePlatform {
  android = 'android',
  ios = 'ios',
  web = 'web',
}

/** Live reachability of a physical access point device, independent of its lifecycle status */
export enum DeviceReachability {
  OFFLINE = 'OFFLINE',
  ONLINE = 'ONLINE',
  UNKNOWN = 'UNKNOWN',
}

export interface DirectUploadConfirmInput {
  /** ID of the entity the image belongs to */
  id: Scalars['ID']['input']
  originalFilename?: InputMaybe<Scalars['String']['input']>
  target: DirectUploadTarget
  /** Opaque reference to the uploaded object, echoed back from the upload URL response */
  uploadRef: Scalars['String']['input']
}

/** File formats accepted by the direct upload path */
export enum DirectUploadFormat {
  csv = 'csv',
  doc = 'doc',
  docx = 'docx',
  gif = 'gif',
  heic = 'heic',
  heif = 'heif',
  jpeg = 'jpeg',
  jpg = 'jpg',
  otf = 'otf',
  pdf = 'pdf',
  png = 'png',
  rtf = 'rtf',
  ttf = 'ttf',
  txt = 'txt',
  webp = 'webp',
  woff = 'woff',
  woff2 = 'woff2',
  xls = 'xls',
  xlsx = 'xlsx',
}

/** Configured direct upload targets */
export enum DirectUploadTarget {
  clientFile = 'clientFile',
  customFont = 'customFont',
  customHeadingFont = 'customHeadingFont',
  mobileAppBrandingAppIcon = 'mobileAppBrandingAppIcon',
  mobileAppBrandingHomeLogo = 'mobileAppBrandingHomeLogo',
  mobileAppBrandingLogo = 'mobileAppBrandingLogo',
  mobileAppBrandingSplashDark = 'mobileAppBrandingSplashDark',
  mobileAppBrandingSplashLight = 'mobileAppBrandingSplashLight',
  mobileAppBrandingTabBookings = 'mobileAppBrandingTabBookings',
  mobileAppBrandingTabExplore = 'mobileAppBrandingTabExplore',
  mobileAppBrandingTabHome = 'mobileAppBrandingTabHome',
  mobileAppBrandingTabMore = 'mobileAppBrandingTabMore',
  mobileAppBrandingTabPackages = 'mobileAppBrandingTabPackages',
  staffAvatar = 'staffAvatar',
}

export interface DirectUploadUrlInput {
  format: DirectUploadFormat
  /** ID of the entity the image belongs to */
  id: Scalars['ID']['input']
  target: DirectUploadTarget
}

/** Type of a discount */
export enum DiscountType {
  flat = 'flat',
  percentage = 'percentage',
}

export interface DismissBlockedMovementInput {
  corporateId: Scalars['ID']['input']
  movementId: Scalars['ID']['input']
  note?: InputMaybe<Scalars['String']['input']>
}

export interface DismissIncomingMovementInput {
  memberMovementId: Scalars['ID']['input']
  reason?: InputMaybe<Scalars['String']['input']>
}

/** The site policy revision a member was shown before accepting it */
export interface DisplayedPolicyRevisionInput {
  policyRevisionId: Scalars['ID']['input']
  revisionSha256?: InputMaybe<Scalars['String']['input']>
  sitePolicyId: Scalars['ID']['input']
}

/** Status of a payment dispute */
export enum DisputeStatus {
  Canceled = 'Canceled',
  Lost = 'Lost',
  NeedsEvidence = 'NeedsEvidence',
  Open = 'Open',
  Submitted = 'Submitted',
  Won = 'Won',
}

/** Verification status of a DNS record */
export enum DnsRecordStatus {
  failed = 'failed',
  not_started = 'not_started',
  pending = 'pending',
  temporary_failure = 'temporary_failure',
  verified = 'verified',
}

/** Type of DNS record */
export enum DnsRecordType {
  CNAME = 'CNAME',
  MX = 'MX',
  TXT = 'TXT',
}

export enum DocumentFileVersionFormat {
  csv = 'csv',
  doc = 'doc',
  docx = 'docx',
  gif = 'gif',
  heic = 'heic',
  heif = 'heif',
  jpeg = 'jpeg',
  jpg = 'jpg',
  pdf = 'pdf',
  png = 'png',
  rtf = 'rtf',
  txt = 'txt',
  webp = 'webp',
  xls = 'xls',
  xlsx = 'xlsx',
}

export enum DocumentFileVersionType {
  Original = 'Original',
}

export enum DoorAccessCredentialType {
  BARCODE = 'BARCODE',
  FOB = 'FOB',
  QR = 'QR',
}

export enum DoorAccessEventDeniedBy {
  BOOKING_REQUIRED = 'BOOKING_REQUIRED',
  CLASS_IN_PROGRESS = 'CLASS_IN_PROGRESS',
  MEMBERSHIP_WINDOW = 'MEMBERSHIP_WINDOW',
  MEMBER_ELIGIBILITY = 'MEMBER_ELIGIBILITY',
  SCAN_METHOD_NOT_ALLOWED = 'SCAN_METHOD_NOT_ALLOWED',
  SPACE_BLOCKED = 'SPACE_BLOCKED',
  UNKNOWN_ACCESS_POINT = 'UNKNOWN_ACCESS_POINT',
  WHO_CAN_ENTER = 'WHO_CAN_ENTER',
  ZONE_SCHEDULE = 'ZONE_SCHEDULE',
  ZONE_SCHEDULE_UNRESOLVABLE = 'ZONE_SCHEDULE_UNRESOLVABLE',
}

export enum DoorAccessEventSortField {
  CREATED_AT = 'CREATED_AT',
  DOOR = 'DOOR',
  MEMBER = 'MEMBER',
  METHOD = 'METHOD',
  OUTCOME = 'OUTCOME',
  REASON = 'REASON',
  SOURCE = 'SOURCE',
  ZONE = 'ZONE',
}

export enum DoorAccessOutcome {
  ALLOWED = 'ALLOWED',
  DENIED = 'DENIED',
}

/** Why a door provider connection test failed */
export enum DoorConnectionFailureReason {
  credentials_rejected = 'credentials_rejected',
  door_not_found = 'door_not_found',
  panel_unreachable = 'panel_unreachable',
}

export enum DoorProvider {
  INCEPTION = 'INCEPTION',
  VIVA_MAC = 'VIVA_MAC',
}

/** Outcome of the most recent door access reconcile run for an access point */
export enum DoorReconcileStatus {
  FAILED = 'FAILED',
  OK = 'OK',
  PARTIAL = 'PARTIAL',
}

export enum DoorType {
  automatic = 'automatic',
  double_slide = 'double_slide',
  single = 'single',
}

/** Input for BigQuery export download */
export interface DownloadBigQueryExportInput {
  dateRange?: InputMaybe<DateRange>
  exportName: BigQueryExportName
  filters?: InputMaybe<ExportFilters>
  locationId?: InputMaybe<Scalars['String']['input']>
}

/** Refund method for paid drop-in booking cancellations */
export enum DropInRefundMethod {
  ACCOUNT_CREDIT = 'ACCOUNT_CREDIT',
  ORIGINAL_PAYMENT_METHOD = 'ORIGINAL_PAYMENT_METHOD',
}

/** A brand membership, package or add-on to copy into a new draft, and the name the copy takes. */
export interface DuplicateCorporateServiceTemplateInput {
  corporateServiceTemplateId: Scalars['ID']['input']
  name: Scalars['String']['input']
}

/** The electronic consent ceremony a site uses */
export enum ESignConsentProfile {
  AU_LINK = 'AU_LINK',
  US_ACCESS_CODE = 'US_ACCESS_CODE',
}

export enum EarlyAccessApplyTo {
  NEW_ONLY = 'NEW_ONLY',
  NOT_YET_STARTED = 'NOT_YET_STARTED',
}

export enum EarlyAccessDurationUnit {
  DAYS = 'DAYS',
  MONTHS = 'MONTHS',
  WEEKS = 'WEEKS',
}

/** Active membership type pushed for members synced from a site to eGym */
export enum EgymMembershipType {
  BASIC = 'BASIC',
  PREMIUM = 'PREMIUM',
  PROSPECT = 'PROSPECT',
}

export enum EmailCopyEmployee {
  BCC = 'BCC',
  CC = 'CC',
  NO = 'NO',
}

/** Verification status of an email domain */
export enum EmailDomainStatus {
  failed = 'failed',
  not_started = 'not_started',
  partially_failed = 'partially_failed',
  partially_verified = 'partially_verified',
  pending = 'pending',
  temporary_failure = 'temporary_failure',
  verified = 'verified',
}

export enum EmailSendAs {
  HTML = 'HTML',
  PLAIN_TEXT = 'PLAIN_TEXT',
}

export enum EmailSendBeforeUnit {
  DAYS = 'DAYS',
  HOURS = 'HOURS',
  MINUTES = 'MINUTES',
}

/** Button style for appearance configuration */
export enum EmbedAppearanceButtonStyle {
  PILL = 'PILL',
  ROUNDED = 'ROUNDED',
  SQUARE = 'SQUARE',
}

/** Button style for embed widget */
export enum EmbedButtonStyle {
  ROUNDED = 'ROUNDED',
  SHARP = 'SHARP',
}

/** Sidebar position for embed layout */
export enum EmbedSidebarPosition {
  LEFT = 'LEFT',
  NONE = 'NONE',
  RIGHT = 'RIGHT',
}

/** One employee row to link to an organisation */
export interface EmployeeLinkInput {
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
}

export enum EmployeeLinkOutcome {
  ALREADY_LINKED = 'ALREADY_LINKED',
  CREATED_AND_LINKED = 'CREATED_AND_LINKED',
  DUPLICATE_EMAIL = 'DUPLICATE_EMAIL',
  FAILED = 'FAILED',
  INVALID_EMAIL = 'INVALID_EMAIL',
  LINKED = 'LINKED',
}

/** Status of a tanning bed assignment session */
export enum EquipmentAssignmentStatus {
  cancelled = 'cancelled',
  created = 'created',
  done = 'done',
}

/** Category of equipment: UV (tanning bed) or regular (spa/spray/wellness) */
export enum EquipmentCategory {
  UV = 'UV',
  regular = 'regular',
}

export interface EquipmentComplianceReportFilterInput {
  equipmentCategory?: InputMaybe<PolicyEquipmentScope>
  search?: InputMaybe<Scalars['String']['input']>
  statuses?: InputMaybe<Array<EquipmentComplianceStatus>>
}

export interface EquipmentComplianceReportPageInput {
  limit: Scalars['Float']['input']
  offset: Scalars['Float']['input']
}

/** How the equipment compliance report is ordered */
export enum EquipmentComplianceSort {
  LAST_VISIT = 'LAST_VISIT',
  NAME = 'NAME',
  STATUS = 'STATUS',
}

/** Ascending or descending order for the equipment compliance report */
export enum EquipmentComplianceSortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

/** Report status of a client for a category from the age and policy checks only: ready, ready with a renewal to sign, or blocked. Skin type and operational checks are not part of it */
export enum EquipmentComplianceStatus {
  BLOCKED = 'BLOCKED',
  READY = 'READY',
  RENEWAL_DUE = 'RENEWAL_DUE',
}

/** Which location requirement was not met when the session was allowed to start */
export enum EquipmentComplianceWarningCode {
  SKIN_TYPE_CONFIGURATION_ERROR = 'SKIN_TYPE_CONFIGURATION_ERROR',
  SKIN_TYPE_DUE = 'SKIN_TYPE_DUE',
  SKIN_TYPE_REQUIRED = 'SKIN_TYPE_REQUIRED',
}

/** Minutes for one skin type band at one session number */
export interface EquipmentExposureScheduleRowInput {
  bandId: Scalars['ID']['input']
  minutes: Scalars['Numeric']['input']
  sessionNumber: Scalars['Int']['input']
}

/** A jurisdiction age rule to save as a new revision */
export interface EquipmentJurisdictionRuleInput {
  ageBands: Array<JurisdictionAgeBandInput>
  ageEvidenceRequired: AgeEvidenceRequired
  effectiveFrom: Scalars['String']['input']
  effectiveTo?: InputMaybe<Scalars['String']['input']>
  equipmentScope: Array<PolicyEquipmentScope>
  jurisdictionCode: Scalars['String']['input']
  notes?: InputMaybe<Scalars['String']['input']>
}

/** Lamp hour history event: tracking enabled with starting hours, lamps changed, a manual adjustment, or an alert sent at the warning level or lamp life */
export enum EquipmentLampLogEventType {
  ADJUSTMENT = 'ADJUSTMENT',
  DUE_NOTIFIED = 'DUE_NOTIFIED',
  LAMP_CHANGE = 'LAMP_CHANGE',
  TRACKING_ENABLED = 'TRACKING_ENABLED',
  WARNING_NOTIFIED = 'WARNING_NOTIFIED',
}

/** Page through a bed lamp history, newest first */
export interface EquipmentLampLogsInput {
  cursor?: InputMaybe<Scalars['String']['input']>
  equipmentId: Scalars['ID']['input']
  lampSet?: InputMaybe<EquipmentLampSet>
  limit?: InputMaybe<Scalars['Int']['input']>
}

/** A set of lamps in a bed that is changed as one: the body lamps or the facial lamps */
export enum EquipmentLampSet {
  BODY = 'BODY',
  FACIAL = 'FACIAL',
}

/** Lamp hours against the warning threshold and the lamp life */
export enum EquipmentLampState {
  DUE = 'DUE',
  OK = 'OK',
  WARNING = 'WARNING',
}

export enum EquipmentQualityCategory {
  diamond = 'diamond',
  gold = 'gold',
  platinum = 'platinum',
  silver = 'silver',
}

/** One client and equipment pair to evaluate */
export interface EquipmentReadinessRequestInput {
  clientId: Scalars['ID']['input']
  equipmentId: Scalars['ID']['input']
}

/** How a client can pay for one session type on an equipment unit */
export enum EquipmentSessionTypeAvailabilityKind {
  BLOCKED = 'BLOCKED',
  CREDITS = 'CREDITS',
  CREDITS_ADD_ON = 'CREDITS_ADD_ON',
  CREDITS_ADD_ON_PREPAID = 'CREDITS_ADD_ON_PREPAID',
  NONE = 'NONE',
}

/** Why a client cannot use a session type on an equipment unit */
export enum EquipmentSessionTypeBlockReason {
  NO_COVERING_PLAN = 'NO_COVERING_PLAN',
  NO_MATCHING_PLAN = 'NO_MATCHING_PLAN',
  PLAN_CREDITS_USED_UP = 'PLAN_CREDITS_USED_UP',
}

/** The authoritative outcome of an equipment start evaluation */
export enum EquipmentStartDecision {
  ALLOW = 'ALLOW',
  DENY = 'DENY',
}

/** Current operational status of a tanning bed / equipment unit */
export enum EquipmentStatus {
  available = 'available',
  delay = 'delay',
  dirty = 'dirty',
  disabled = 'disabled',
  error = 'error',
  in_use = 'in_use',
}

/** Types of equipment that can be placed as spots on a room resource template */
export enum EquipmentType {
  bike = 'bike',
  cable_machine = 'cable_machine',
  chair = 'chair',
  elliptical = 'elliptical',
  mat = 'mat',
  reformer = 'reformer',
  rower = 'rower',
  spot = 'spot',
  squat_rack = 'squat_rack',
  treadmill = 'treadmill',
  weight_bench = 'weight_bench',
}

export interface ExecuteMemberMovementManualTransferInput {
  attestation: MemberMovementAttestationInput
  input: MemberMovementManualTransferInput
}

/** Optional filters for export queries */
export interface ExportFilters {
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>
  membershipType?: InputMaybe<Scalars['String']['input']>
  paymentStatus?: InputMaybe<Scalars['String']['input']>
  serviceType?: InputMaybe<Scalars['String']['input']>
}

/** File format for a report export */
export enum ExportFormat {
  CSV = 'CSV',
  XLSX = 'XLSX',
}

export enum ExportJobStatusEnum {
  completed = 'completed',
  failed = 'failed',
  running = 'running',
}

export interface ExportReportInputInput {
  columnFilters?: InputMaybe<Scalars['JSONObject']['input']>
  columns?: InputMaybe<Array<Scalars['String']['input']>>
  dateFormat?: InputMaybe<Scalars['String']['input']>
  dateFrom?: InputMaybe<Scalars['String']['input']>
  dateTo?: InputMaybe<Scalars['String']['input']>
  filters?: InputMaybe<Scalars['JSONObject']['input']>
  format?: InputMaybe<ExportFormat>
  numberFormat?: InputMaybe<Scalars['String']['input']>
  orderBy?: InputMaybe<Array<RunReportOrderByInput>>
  reportName?: InputMaybe<ReportName>
  savedReportId?: InputMaybe<Scalars['String']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  siteIds?: InputMaybe<Array<Scalars['String']['input']>>
  timeFormat?: InputMaybe<Scalars['String']['input']>
}

/** Input for settlement export mutation */
export interface ExportSettlementInput {
  /** Bulk by date range start */
  dateFrom?: InputMaybe<Scalars['String']['input']>
  /** Bulk by date range end */
  dateTo?: InputMaybe<Scalars['String']['input']>
  /** Type of export to generate */
  exportType: SettlementExportType
  /** Authorization context — required */
  siteIds: Array<Scalars['String']['input']>
  /** Single payout export */
  sitePayoutId?: InputMaybe<Scalars['String']['input']>
  /** Bulk export — multiple specific payouts */
  sitePayoutIds?: InputMaybe<Array<Scalars['String']['input']>>
}

/** Extend an active paid-in-full plan, or reactivate an expired one */
export interface ExtendServiceInput {
  durationAmount: Scalars['Float']['input']
  durationUnit: ServiceExtensionUnit
  serviceId: Scalars['ID']['input']
  siteId: Scalars['ID']['input']
}

export enum ExternalVideoMimeType {
  VIDEO_HLS = 'VIDEO_HLS',
  VIDEO_MP4 = 'VIDEO_MP4',
  VIDEO_VIMEO = 'VIDEO_VIMEO',
  VIDEO_WEBM = 'VIDEO_WEBM',
  VIDEO_WISTIA = 'VIDEO_WISTIA',
  VIDEO_YOUTUBE = 'VIDEO_YOUTUBE',
}

export interface EzypayCustomerPaidFeeEstimateRequest {
  cardBrand?: InputMaybe<Scalars['String']['input']>
  clientId?: InputMaybe<Scalars['ID']['input']>
  paymentMethodType: PaymentMethodType
  serviceTemplateId?: InputMaybe<Scalars['ID']['input']>
  siteId: Scalars['ID']['input']
  subtotalAmount: Scalars['Numeric']['input']
}

export enum FailedPaymentFeeScope {
  ALL_PAYMENTS = 'ALL_PAYMENTS',
  RECURRING_MEMBERSHIP_ONLY = 'RECURRING_MEMBERSHIP_ONLY',
}

/** Normalized category for payment failure reasons */
export enum FailureCategory {
  AuthenticationFailed = 'AuthenticationFailed',
  AuthenticationRequired = 'AuthenticationRequired',
  AuthenticationRequired3DSAutomated = 'AuthenticationRequired3DSAutomated',
  CardChallengeAbandoned = 'CardChallengeAbandoned',
  CardChallengeDismissed = 'CardChallengeDismissed',
  CardChallengeReleasedByStaff = 'CardChallengeReleasedByStaff',
  DoNotHonor = 'DoNotHonor',
  ExpiredCard = 'ExpiredCard',
  FraudSuspected = 'FraudSuspected',
  HardDeclineOther = 'HardDeclineOther',
  InsufficientFunds = 'InsufficientFunds',
  InternalError = 'InternalError',
  InvalidRequest = 'InvalidRequest',
  LostStolen = 'LostStolen',
  PaymentMethodInvalid = 'PaymentMethodInvalid',
  RateLimited = 'RateLimited',
  TemporaryNetwork = 'TemporaryNetwork',
  TerminalReleasedByStaff = 'TerminalReleasedByStaff',
  TerminalTimedOut = 'TerminalTimedOut',
}

/** Role of a member within a family */
export enum FamilyMemberRole {
  ADMIN = 'ADMIN',
  DEPENDENT = 'DEPENDENT',
}

/** Lifecycle status of a family membership */
export enum FamilyMemberStatus {
  ACTIVE = 'ACTIVE',
  DECLINED = 'DECLINED',
  LEFT = 'LEFT',
  PENDING = 'PENDING',
  REMOVED = 'REMOVED',
}

/** Lifecycle status of a family */
export enum FamilyStatus {
  ACTIVE = 'ACTIVE',
  DISSOLVED = 'DISSOLVED',
}

/** Lifecycle state of a feature data refresh run */
export enum FeatureDataRefreshState {
  DONE = 'DONE',
  FAILED = 'FAILED',
  MIGRATING = 'MIGRATING',
  PENDING = 'PENDING',
  REBUILDING_SITE_INDEX = 'REBUILDING_SITE_INDEX',
  RECONCILING_IDENTITIES = 'RECONCILING_IDENTITIES',
  REPOINTING = 'REPOINTING',
  RESTORING = 'RESTORING',
}

export enum FeeAccountType {
  CLIENT = 'CLIENT',
  CORPORATE = 'CORPORATE',
  SITE = 'SITE',
}

export interface FeeCalculationRequest {
  clientPaymentMethodId?: InputMaybe<Scalars['ID']['input']>
  invoiceId?: InputMaybe<Scalars['ID']['input']>
  paymentMethodType: PaymentMethodType
  siteId: Scalars['ID']['input']
  subtotalAmount: Scalars['Numeric']['input']
}

export enum FeeClassificationTypes {
  AMEX = 'AMEX',
  BANK = 'BANK',
  EU = 'EU',
  INTERNATIONAL = 'INTERNATIONAL',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  PREMIUM = 'PREMIUM',
  STANDARD = 'STANDARD',
  TERMINAL = 'TERMINAL',
  TERMINAL_INTERNATIONAL = 'TERMINAL_INTERNATIONAL',
  UK = 'UK',
}

export enum FeeConfigurationOrderBy {
  createdAt = 'createdAt',
  enabled = 'enabled',
  name = 'name',
}

export interface FeeConfigurationsOrderByInput {
  column: FeeConfigurationOrderBy
  direction: OrderByDirection
}

export enum FeeEventType {
  BANK_FLAT_FEE = 'BANK_FLAT_FEE',
  BANK_PERCENT_FEE = 'BANK_PERCENT_FEE',
  CARD_FLAT_AMEX_FEE = 'CARD_FLAT_AMEX_FEE',
  CARD_FLAT_BNPL_FEE = 'CARD_FLAT_BNPL_FEE',
  CARD_FLAT_FEE = 'CARD_FLAT_FEE',
  CARD_PERCENT_AMEX_FEE = 'CARD_PERCENT_AMEX_FEE',
  CARD_PERCENT_BNPL_FEE = 'CARD_PERCENT_BNPL_FEE',
  CARD_PERCENT_FEE = 'CARD_PERCENT_FEE',
  CARD_PERCENT_INTERNATIONAL = 'CARD_PERCENT_INTERNATIONAL',
  CARD_UPDATER_FEE = 'CARD_UPDATER_FEE',
  DISPUTE_FEE = 'DISPUTE_FEE',
  EU_CARD_PERCENT_FEE = 'EU_CARD_PERCENT_FEE',
  EU_CARD_PROCESSING_FLAT_FEE = 'EU_CARD_PROCESSING_FLAT_FEE',
  FAILED_PAYMENT_FEE_ALL_FAILURE_BANK = 'FAILED_PAYMENT_FEE_ALL_FAILURE_BANK',
  FAILED_PAYMENT_FEE_ALL_FAILURE_CARD = 'FAILED_PAYMENT_FEE_ALL_FAILURE_CARD',
  FAILED_PAYMENT_FEE_AT_COLLECTIONS_BANK = 'FAILED_PAYMENT_FEE_AT_COLLECTIONS_BANK',
  FAILED_PAYMENT_FEE_AT_COLLECTIONS_CARD = 'FAILED_PAYMENT_FEE_AT_COLLECTIONS_CARD',
  FAILED_PAYMENT_FEE_FIRST_TIME_FAIL_BANK = 'FAILED_PAYMENT_FEE_FIRST_TIME_FAIL_BANK',
  FAILED_PAYMENT_FEE_FIRST_TIME_FAIL_CARD = 'FAILED_PAYMENT_FEE_FIRST_TIME_FAIL_CARD',
  FAILED_PAYMENT_FEE_SENT_FOR_COLLECTIONS_BANK = 'FAILED_PAYMENT_FEE_SENT_FOR_COLLECTIONS_BANK',
  FAILED_PAYMENT_FEE_SENT_FOR_COLLECTIONS_CARD = 'FAILED_PAYMENT_FEE_SENT_FOR_COLLECTIONS_CARD',
  FAILED_PAYMENT_RECOVERY_FEE_BANK = 'FAILED_PAYMENT_RECOVERY_FEE_BANK',
  FAILED_PAYMENT_RECOVERY_FEE_CARD = 'FAILED_PAYMENT_RECOVERY_FEE_CARD',
  LOAD_FEE = 'LOAD_FEE',
  PREMIUM_CARD_PROCESSING_FLAT_FEE = 'PREMIUM_CARD_PROCESSING_FLAT_FEE',
  PREMIUM_CARD_PROCESSING_PERCENT_FEE = 'PREMIUM_CARD_PROCESSING_PERCENT_FEE',
  TERMINAL_CARD_INTERNATIONAL_FLAT = 'TERMINAL_CARD_INTERNATIONAL_FLAT',
  TERMINAL_CARD_INTERNATIONAL_PERCENT = 'TERMINAL_CARD_INTERNATIONAL_PERCENT',
  TERMINAL_CARD_LOCAL_FLAT = 'TERMINAL_CARD_LOCAL_FLAT',
  TERMINAL_CARD_LOCAL_PERCENT = 'TERMINAL_CARD_LOCAL_PERCENT',
  UK_CARD_PERCENT_FEE = 'UK_CARD_PERCENT_FEE',
  UK_CARD_PROCESSING_FLAT_FEE = 'UK_CARD_PROCESSING_FLAT_FEE',
}

export enum FeeRateType {
  FIXED = 'FIXED',
  PERCENT = 'PERCENT',
}

export interface FeeTemplateFeesInput {
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  feeId: Scalars['String']['input']
  rate?: InputMaybe<Scalars['Float']['input']>
}

export interface FeeTemplateInput {
  fees: Array<FeeTemplateFeesInput>
  name: Scalars['String']['input']
}

export enum FeedbackQuestionType {
  CHECKBOX = 'CHECKBOX',
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  RATING = 'RATING',
  TEXT = 'TEXT',
  YES_NO = 'YES_NO',
}

export enum FileUploadConfigFieldPendingStatus {
  PROCESSING = 'PROCESSING',
  UPLOADING = 'UPLOADING',
}

export enum FileUploadConfigFieldStatus {
  PROCESSING = 'PROCESSING',
  READY = 'READY',
}

export interface FinalizeCustomFontFontInput {
  displayName?: InputMaybe<Scalars['String']['input']>
  format: FontFormat
  name: Scalars['String']['input']
  uploadedAt: Scalars['String']['input']
  uploadedBy?: InputMaybe<Scalars['String']['input']>
  url: Scalars['String']['input']
}

export enum FindClientFeesTemplatesSortFields {
  createdAt = 'createdAt',
  name = 'name',
  updatedAt = 'updatedAt',
}

export interface FindClientFeesTemplatesSortOptions {
  direction?: InputMaybe<SortDirection>
  field?: InputMaybe<FindClientFeesTemplatesSortFields>
}

export enum FindClientsSortFields {
  clientId = 'clientId',
  createdAt = 'createdAt',
  email = 'email',
  firstName = 'firstName',
  lastName = 'lastName',
  mobilePhoneNumber = 'mobilePhoneNumber',
}

export interface FindClientsSortOptions {
  direction?: InputMaybe<SortDirection>
  field?: InputMaybe<FindClientsSortFields>
}

export enum FindCorporatesSortFields {
  corporateId = 'corporateId',
  createdAt = 'createdAt',
  name = 'name',
  status = 'status',
}

export interface FindCorporatesSortOptions {
  direction?: InputMaybe<SortDirection>
  field?: InputMaybe<FindCorporatesSortFields>
}

export enum FindFeesTemplatesSortFields {
  createdAt = 'createdAt',
  name = 'name',
  updatedAt = 'updatedAt',
}

export interface FindFeesTemplatesSortOptions {
  direction?: InputMaybe<SortDirection>
  field?: InputMaybe<FindFeesTemplatesSortFields>
}

export interface FindStaffUsersOrderByInput {
  column: StaffUserOrderBy
  direction: OrderByDirection
}

export enum FirebaseAppProjectEnvironment {
  dev = 'dev',
  prod = 'prod',
  staging = 'staging',
}

export enum FirebaseAppProjectStatus {
  active = 'active',
  full = 'full',
  standby = 'standby',
}

export enum FirstCreditAllocationDateType {
  ON_DATE = 'ON_DATE',
  ON_FIRST_USE = 'ON_FIRST_USE',
}

export enum FirstCycleSettlementKind {
  Charge = 'Charge',
  None = 'None',
  Refund = 'Refund',
  RepriceScheduledInvoice = 'RepriceScheduledInvoice',
}

export enum FirstPaymentAfterUnit {
  DAYS = 'DAYS',
  MONTHS = 'MONTHS',
  ON_CYCLE = 'ON_CYCLE',
  WEEKS = 'WEEKS',
}

export enum FitnessPassportCheckOutcome {
  ACTIVE = 'ACTIVE',
  ERROR = 'ERROR',
  INACTIVE = 'INACTIVE',
  UNREACHABLE = 'UNREACHABLE',
}

/** Outcome of the most recent Fitness Passport connection test */
export enum FitnessPassportConnectionState {
  CONNECTED = 'CONNECTED',
  NOT_CONFIGURED = 'NOT_CONFIGURED',
  REJECTED = 'REJECTED',
  UNREACHABLE = 'UNREACHABLE',
}

/** What a location does when Fitness Passport cannot be reached at check-in */
export enum FitnessPassportFailurePolicy {
  ALLOW_ENTRY = 'ALLOW_ENTRY',
  HOLD_ENTRY = 'HOLD_ENTRY',
}

export enum FitnessPassportLinkStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  REMOVED = 'REMOVED',
  UNVERIFIED = 'UNVERIFIED',
}

export enum FitnessPassportVisitOutcome {
  DECLINED = 'DECLINED',
  EXHAUSTED = 'EXHAUSTED',
  NOT_ADMITTED = 'NOT_ADMITTED',
  POTENTIAL_DUPLICATE = 'POTENTIAL_DUPLICATE',
  QUEUED = 'QUEUED',
  REGISTERED = 'REGISTERED',
  VALIDATED_ONLY = 'VALIDATED_ONLY',
}

/** Byte order the reader reads the card serial in — LE is U-Prox "Standard", BE is U-Prox "Direct" */
export enum FobByteOrder {
  BE = 'BE',
  LE = 'LE',
}

/** Outcome of the most recent fob registration attempt against a capture request */
export enum FobCaptureResultCode {
  CANCELLED = 'CANCELLED',
  CAPTURED = 'CAPTURED',
  COLLISION = 'COLLISION',
  DUPLICATE_SCAN = 'DUPLICATE_SCAN',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  INPUT_MODE_MISMATCH = 'INPUT_MODE_MISMATCH',
  INVALID_SERIAL = 'INVALID_SERIAL',
  NOT_PENDING = 'NOT_PENDING',
  NO_FORMAT = 'NO_FORMAT',
  REGISTERED = 'REGISTERED',
  REQUEST_MISMATCH = 'REQUEST_MISMATCH',
}

/** Lifecycle of a request to register the next fob a Check-In Agent reads */
export enum FobCaptureStatus {
  CANCELLED = 'CANCELLED',
  COLLISION = 'COLLISION',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  REGISTERED = 'REGISTERED',
}

/** Controller receive channel on the wall — sets the width kept for an unpartitioned format (26-bit on Wiegand-26, 27-bit on TECOM-27, the whole frame on FULL_FRAME) */
export enum FobController {
  FULL_FRAME = 'FULL_FRAME',
  VIVA_TECOM27 = 'VIVA_TECOM27',
  VIVA_W26 = 'VIVA_W26',
}

/** A location fob derivation format: byte order, reader format, controller */
export interface FobDerivationConfigInput {
  byteOrder: FobByteOrder
  controller: FobController
  readerFormat: FobReaderFormat
  serialNotation?: InputMaybe<FobSerialNotation>
}

/** Wiegand frame the reader emits. W26 and W34 are partitioned, so only the 16-bit card field survives; W42 is unpartitioned and passes the whole frame; RAW performs no conversion and keeps the captured value as-is */
export enum FobReaderFormat {
  RAW = 'RAW',
  W26 = 'W26',
  W34 = 'W34',
  W42 = 'W42',
}

/** Whether this location captures the chip serial as hex or the number printed on the card as decimal */
export enum FobSerialNotation {
  DECIMAL = 'DECIMAL',
  HEX = 'HEX',
}

/** Field name for font upload (customFont or customHeadingFont) */
export enum FontFieldName {
  customFont = 'customFont',
  customHeadingFont = 'customHeadingFont',
}

/** Font file format */
export enum FontFormat {
  otf = 'otf',
  ttf = 'ttf',
  woff = 'woff',
  woff2 = 'woff2',
}

/** Source of the font (builtin, google, or custom upload) */
export enum FontSource {
  builtin = 'builtin',
  custom = 'custom',
  google = 'google',
}

/** Whether an outstanding form required before booking blocks the booking in the app or only reminds the member */
export enum FormBookingGateMode {
  BLOCK = 'BLOCK',
  REMIND = 'REMIND',
}

/** The channel a form submission was completed through */
export enum FormCompletedVia {
  EMBED = 'EMBED',
  EXTERNAL = 'EXTERNAL',
  KIOSK = 'KIOSK',
  MEMBER_APP = 'MEMBER_APP',
  PUBLIC_LINK = 'PUBLIC_LINK',
  SIGNUP = 'SIGNUP',
  STAFF_CORE = 'STAFF_CORE',
}

/** Where a result recorded outside Hapana came from: a migration from another system, or staff recording an assessment done elsewhere */
export enum FormExternalResultSource {
  MIGRATION = 'MIGRATION',
  STAFF_ASSIGNED = 'STAFF_ASSIGNED',
}

/** How a form assignment is delivered to the client */
export enum FormHandoffChannel {
  KIOSK = 'KIOSK',
  MEMBER_APP = 'MEMBER_APP',
  PUBLIC_LINK = 'PUBLIC_LINK',
  STAFF_SCREEN = 'STAFF_SCREEN',
}

/** Why a form delivery attempt ended the way it did */
export enum FormHandoffResultCode {
  ASSIGNMENT_CANCELLED = 'ASSIGNMENT_CANCELLED',
  CLIENT_MERGED = 'CLIENT_MERGED',
  COMPLETED_ELSEWHERE = 'COMPLETED_ELSEWHERE',
  DATE_OF_BIRTH_MISSING = 'DATE_OF_BIRTH_MISSING',
  DEVICE_CAPABILITY_REMOVED = 'DEVICE_CAPABILITY_REMOVED',
  DEVICE_REVOKED = 'DEVICE_REVOKED',
  IDENTITY_FAILED = 'IDENTITY_FAILED',
  IDLE_TIMEOUT = 'IDLE_TIMEOUT',
  NOT_ME = 'NOT_ME',
  NO_DELIVERABLE_CHANNEL = 'NO_DELIVERABLE_CHANNEL',
  PROVIDER_FAILED = 'PROVIDER_FAILED',
  REROUTED = 'REROUTED',
  STAFF_CANCELLED = 'STAFF_CANCELLED',
  TTL = 'TTL',
}

/** Where one delivery attempt of a form assignment has got to */
export enum FormHandoffStatus {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  DECLINED = 'DECLINED',
  DELIVERED = 'DELIVERED',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  OPENED = 'OPENED',
  SENT = 'SENT',
  SHOWN = 'SHOWN',
}

/** The activity a form assignment must be completed before */
export enum FormRequiredBefore {
  BOOKING = 'BOOKING',
  NONE = 'NONE',
  TANNING = 'TANNING',
}

/** Image format of an uploaded form signature */
export enum FormSignatureFormat {
  PNG = 'PNG',
}

/** Status of a form submission */
export enum FormSubmissionStatus {
  COMPLETED = 'COMPLETED',
  PENDING = 'PENDING',
}

/** Type of payment gateway */
export enum GatewayType {
  Ezypay = 'Ezypay',
  Stripe = 'Stripe',
}

export interface GenerateCoverImageUploadUrlInput {
  contentType: Scalars['String']['input']
  filename: Scalars['String']['input']
  knowledgeArticleId: Scalars['ID']['input']
}

export interface GenerateFileUploadUrlInput {
  /** Client ID for ClientFile table */
  clientId?: InputMaybe<Scalars['String']['input']>
  /** Name of the file being uploaded */
  fileName: Scalars['String']['input']
  /** Format of the file being uploaded */
  format: Scalars['String']['input']
  /** The ID of the entity */
  id: Scalars['ID']['input']
  /** Additional metadata to include in signed URL headers */
  metadata?: InputMaybe<Scalars['JSONObject']['input']>
  /** Site ID for ClientFile table */
  siteId?: InputMaybe<Scalars['String']['input']>
  /** Name of the table */
  table: Scalars['String']['input']
}

export interface GenerateFileUrlInput {
  /** Name of the file being uploaded */
  fileName: Scalars['String']['input']
  /** The formats of the entity files */
  formats: Array<Scalars['String']['input']>
  /** The ID of the entity */
  id: Scalars['ID']['input']
  /** Name of the table */
  table: Scalars['String']['input']
  /** The variants of the entity files */
  variants: Array<Scalars['String']['input']>
}

export interface GenerateImagePublicSignedUrlInput {
  format: ImageFileVersionFormat
}

/** Input for creating a new gift card design */
export interface GiftCardDesignCreateInput {
  siteId: Scalars['ID']['input']
}

/** How the expiry of a gift card being sold is chosen: the template default, a staff-chosen date, or no expiry */
export enum GiftCardExpiryMode {
  CustomDate = 'CustomDate',
  NoExpiry = 'NoExpiry',
  TemplateDefault = 'TemplateDefault',
}

/** Whether a purchased gift card may carry an expiry date in a jurisdiction */
export enum GiftCardExpiryPolicy {
  NotPermitted = 'NotPermitted',
  Permitted = 'Permitted',
}

/** What happened to a gift card expiry rule */
export enum GiftCardExpiryRuleHistoryAction {
  Approved = 'Approved',
  Created = 'Created',
  Deleted = 'Deleted',
  Revoked = 'Revoked',
  Seeded = 'Seeded',
  Updated = 'Updated',
}

/** Legal review state of a gift card expiry rule; only APPROVED rules are enforced */
export enum GiftCardExpiryRuleReviewStatus {
  Approved = 'Approved',
  Draft = 'Draft',
}

/** The level a resolved gift card expiry policy came from: the platform default, a country rule or a state/province override */
export enum GiftCardExpiryRuleSource {
  Country = 'Country',
  Default = 'Default',
  Zone = 'Zone',
}

/** Filters for gift card list queries */
export interface GiftCardFilter {
  search?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<GiftCardFilterType>
}

/** Filter gift cards by issued or claimed status */
export enum GiftCardFilterType {
  Claimed = 'Claimed',
  Issued = 'Issued',
}

/** Filters for the site-scoped gift card list (Retail Dashboard) */
export interface GiftCardSiteListFilter {
  dateFrom?: InputMaybe<Scalars['String']['input']>
  dateTo?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Float']['input']>
  offset?: InputMaybe<Scalars['Float']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<GiftCardStatus>
}

/** Derived status of a gift card, computed from its current balance and whether its expiry has been processed */
export enum GiftCardStatus {
  Active = 'Active',
  Expired = 'Expired',
  PartiallyRedeemed = 'PartiallyRedeemed',
  Redeemed = 'Redeemed',
}

/** Input for creating a new gift card template */
export interface GiftCardTemplateCreateInput {
  description?: InputMaybe<Scalars['String']['input']>
  expiryEnabled?: InputMaybe<Scalars['Boolean']['input']>
  expiryMonths?: InputMaybe<Scalars['Float']['input']>
  fixedAmount?: InputMaybe<Scalars['Numeric']['input']>
  fixedValue?: InputMaybe<Scalars['Numeric']['input']>
  fixedValueEnabled: Scalars['Boolean']['input']
  giftCardDesignId?: InputMaybe<Scalars['ID']['input']>
  isAllSharedSites: Scalars['Boolean']['input']
  isOnlineSaleEnabled: Scalars['Boolean']['input']
  name: Scalars['String']['input']
  restrictedMembershipTemplateIds: Array<Scalars['ID']['input']>
  restrictedPackageTemplateIds: Array<Scalars['ID']['input']>
  restrictedSaleEnabled: Scalars['Boolean']['input']
  revenueTagId?: InputMaybe<Scalars['String']['input']>
  sharedSiteIds: Array<Scalars['ID']['input']>
}

/** Filters for gift card template list queries */
export interface GiftCardTemplateFilter {
  fixedValueEnabled?: InputMaybe<Scalars['Boolean']['input']>
  isOnlineSaleEnabled?: InputMaybe<Scalars['Boolean']['input']>
  restrictedSaleEnabled?: InputMaybe<Scalars['Boolean']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<GiftCardTemplateStatus>
}

/** Sort options for gift card template list queries */
export interface GiftCardTemplateSort {
  direction: SortDirection
  field: GiftCardTemplateSortFields
}

/** Fields for sorting gift card template list queries */
export enum GiftCardTemplateSortFields {
  createdAt = 'createdAt',
  name = 'name',
  status = 'status',
  updatedAt = 'updatedAt',
}

/** Status of a gift card template */
export enum GiftCardTemplateStatus {
  Active = 'Active',
  Archived = 'Archived',
}

/** Input for updating an existing gift card template */
export interface GiftCardTemplateUpdateInput {
  description?: InputMaybe<Scalars['String']['input']>
  expiryEnabled?: InputMaybe<Scalars['Boolean']['input']>
  expiryMonths?: InputMaybe<Scalars['Float']['input']>
  fixedAmount?: InputMaybe<Scalars['Numeric']['input']>
  fixedValue?: InputMaybe<Scalars['Numeric']['input']>
  fixedValueEnabled?: InputMaybe<Scalars['Boolean']['input']>
  giftCardDesignId?: InputMaybe<Scalars['ID']['input']>
  isAllSharedSites?: InputMaybe<Scalars['Boolean']['input']>
  isOnlineSaleEnabled?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  restrictedMembershipTemplateIds?: InputMaybe<Array<Scalars['ID']['input']>>
  restrictedPackageTemplateIds?: InputMaybe<Array<Scalars['ID']['input']>>
  restrictedSaleEnabled?: InputMaybe<Scalars['Boolean']['input']>
  revenueTagId?: InputMaybe<Scalars['String']['input']>
  sharedSiteIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export interface GiftCardTemplatesPaginationInput {
  limit?: InputMaybe<Scalars['Float']['input']>
  offset?: InputMaybe<Scalars['Float']['input']>
}

export enum GiftCardValidationReason {
  GIFT_CARD_EXPIRED = 'GIFT_CARD_EXPIRED',
}

/** Grow sync-status filter for the clients list */
export enum GrowStatusFilter {
  FAILED = 'FAILED',
  NOT_SYNCED = 'NOT_SYNCED',
  SYNCED = 'SYNCED',
}

export enum GuestPassByTokenError {
  ALREADY_CLAIMED = 'ALREADY_CLAIMED',
  EXPIRED = 'EXPIRED',
  NOT_FOUND = 'NOT_FOUND',
  REVOKED = 'REVOKED',
}

export enum GuestPassExpiryBehaviour {
  CARRY_FORWARD = 'CARRY_FORWARD',
  EXPIRE = 'EXPIRE',
}

export enum GuestPassStatus {
  ACCEPTED = 'ACCEPTED',
  EXPIRED = 'EXPIRED',
  PENDING = 'PENDING',
  REVOKED = 'REVOKED',
  USED = 'USED',
}

/** Filter for listing guest passes (at least one id filter is required) */
export interface GuestPassesFilterInput {
  recipientClientId?: InputMaybe<Scalars['ID']['input']>
  senderClientId?: InputMaybe<Scalars['ID']['input']>
  serviceId?: InputMaybe<Scalars['ID']['input']>
  status?: InputMaybe<GuestPassStatus>
}

/** Source of the heading font (google or custom upload) */
export enum HeadingFontSource {
  custom = 'custom',
  google = 'google',
}

/** Result of releasing a payment held for remote 3DS approval */
export enum HeldPaymentReleaseOutcome {
  already_closed = 'already_closed',
  released = 'released',
  succeeded = 'succeeded',
}

/** Why staff or the kiosk released a payment held for remote 3DS approval */
export enum HeldPaymentReleaseReason {
  switch_method = 'switch_method',
  switch_terminal = 'switch_terminal',
}

export enum ImageFileVersionFormat {
  jpeg = 'jpeg',
  png = 'png',
  webp = 'webp',
}

export enum ImageFileVersionType {
  GooglePlayAppIcon = 'GooglePlayAppIcon',
  Large = 'Large',
  Medium = 'Medium',
  NativeAppIcon = 'NativeAppIcon',
  NativeSplash = 'NativeSplash',
  Original = 'Original',
  Small = 'Small',
  Thumbnail = 'Thumbnail',
}

export interface ImagePublicSignedUrlInput {
  format: ImageFileVersionFormat
  type: ImageSupportedVariant
}

/** All supported variants of an image */
export enum ImageSupportedVariant {
  large = 'large',
  medium = 'medium',
  original = 'original',
  small = 'small',
  thumbnail = 'thumbnail',
}

/** Input for importing clients from CSV */
export interface ImportClientsInput {
  csvContent: Scalars['String']['input']
}

export enum ImportPreviewFilterBy {
  all = 'all',
  errors = 'errors',
  pending = 'pending',
  skipped = 'skipped',
  valid = 'valid',
  warnings = 'warnings',
}

export enum ImportSessionStatusEnum {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  COMPLETED_WITH_ERRORS = 'COMPLETED_WITH_ERRORS',
  DELETING = 'DELETING',
  ERROR = 'ERROR',
  LOADING = 'LOADING',
  PARSED = 'PARSED',
  PARSING = 'PARSING',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  READY = 'READY',
  REVALIDATING = 'REVALIDATING',
  VALIDATING = 'VALIDATING',
}

export interface IncomingApprovalDecisionInput {
  destinationServiceTemplateId?: InputMaybe<Scalars['ID']['input']>
  expectedDestinationServiceTemplateId?: InputMaybe<Scalars['ID']['input']>
  movementId: Scalars['ID']['input']
  reason?: InputMaybe<Scalars['String']['input']>
}

export interface InitSignupSignatureUploadIntendedClientInput {
  dateOfBirth?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
}

export interface InitializeVideoUploadInput {
  contentType: Scalars['String']['input']
  fileName: Scalars['String']['input']
  fileSize: Scalars['Int']['input']
  knowledgeArticleId: Scalars['ID']['input']
  origin: Scalars['String']['input']
}

export interface InitiateMediaUploadInputInput {
  description?: InputMaybe<Scalars['String']['input']>
  fileName: Scalars['String']['input']
  fileSize?: InputMaybe<Scalars['Float']['input']>
  folder?: InputMaybe<Scalars['String']['input']>
  mimeType: Scalars['String']['input']
  title?: InputMaybe<Scalars['String']['input']>
}

export enum InvitationRole {
  brand_admin = 'brand_admin',
  brand_owner = 'brand_owner',
  front_desk = 'front_desk',
  instructor = 'instructor',
  location_manager = 'location_manager',
}

export enum InvitationStatus {
  accepted = 'accepted',
  expired = 'expired',
  pending = 'pending',
  revoked = 'revoked',
}

export interface InviteStaffMemberInvitationInput {
  email: Scalars['String']['input']
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  permissionPolicyIds?: InputMaybe<Array<Scalars['String']['input']>>
  role: InvitationRole
  siteId?: InputMaybe<Scalars['ID']['input']>
}

/** Who cancelled an invoice, recorded only for cancels that can be reinstated */
export enum InvoiceCancellationSource {
  StaffManual = 'StaffManual',
}

/** Type of an invoice item */
export enum InvoiceItemType {
  BillableItem = 'BillableItem',
  Booking = 'Booking',
  DestinationFee = 'DestinationFee',
  DishonorFee = 'DishonorFee',
  FailedPaymentFee = 'FailedPaymentFee',
  GiftCard = 'GiftCard',
  LateCancelFee = 'LateCancelFee',
  LoadFee = 'LoadFee',
  NoShowFee = 'NoShowFee',
  OneTimeSetupFee = 'OneTimeSetupFee',
  Product = 'Product',
  RecurringServicePayment = 'RecurringServicePayment',
  ScheduleDateAdjustment = 'ScheduleDateAdjustment',
  SecondaryFeeProration = 'SecondaryFeeProration',
  Service = 'Service',
  ServiceActionFee = 'ServiceActionFee',
  SettledTransactionFee = 'SettledTransactionFee',
  SuspensionCredit = 'SuspensionCredit',
  TransactionFee = 'TransactionFee',
}

/** What a draft invoice is still waiting on: an agreement signature, payment, or both */
export enum InvoicePendingReason {
  AwaitingPayment = 'AwaitingPayment',
  AwaitingSignature = 'AwaitingSignature',
  AwaitingSignatureAndPayment = 'AwaitingSignatureAndPayment',
}

/** Source of an invoice */
export enum InvoiceSource {
  APP = 'APP',
  CORE = 'CORE',
  IMPORT = 'IMPORT',
  KIOSK = 'KIOSK',
  MEMBER_MOVEMENT = 'MEMBER_MOVEMENT',
  SYSTEM = 'SYSTEM',
  WIDGET = 'WIDGET',
}

/** Status of an invoice */
export enum InvoiceStatus {
  Canceled = 'Canceled',
  Collections = 'Collections',
  Disputing = 'Disputing',
  Failed = 'Failed',
  FailedCanceled = 'FailedCanceled',
  FailedRetry = 'FailedRetry',
  Paid = 'Paid',
  Processing = 'Processing',
  Refunded = 'Refunded',
  RefundedPartial = 'RefundedPartial',
  Refunding = 'Refunding',
  RefundingPartial = 'RefundingPartial',
  RequiresAction = 'RequiresAction',
  Scheduled = 'Scheduled',
  Staged = 'Staged',
  Voided = 'Voided',
}

/** Type of an invoice based on its items */
export enum InvoiceType {
  AddOn = 'AddOn',
  GiftCard = 'GiftCard',
  Membership = 'Membership',
  Package = 'Package',
  Pos = 'Pos',
  Single = 'Single',
}

export interface InvoicesFilterCreatedAtInput {
  from?: InputMaybe<Scalars['String']['input']>
  to?: InputMaybe<Scalars['String']['input']>
}

export interface InvoicesFilterInput {
  clientId?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<InvoicesFilterCreatedAtInput>
  invoiceTypes?: InputMaybe<Array<InvoiceType>>
  saleDate?: InputMaybe<InvoicesFilterSaleDateInput>
  status?: InputMaybe<InvoiceStatus>
  statuses?: InputMaybe<Array<InvoiceStatus>>
}

export interface InvoicesFilterSaleDateInput {
  from?: InputMaybe<Scalars['String']['input']>
  to?: InputMaybe<Scalars['String']['input']>
}

export enum InvoicesOrderBy {
  createdAt = 'createdAt',
  dueDate = 'dueDate',
  processedAt = 'processedAt',
  saleDate = 'saleDate',
  status = 'status',
  totalAmount = 'totalAmount',
  updatedAt = 'updatedAt',
}

export interface InvoicesOrderByInput {
  column: InvoicesOrderBy
  direction: OrderByDirection
}

export enum IosUsageDescriptionKey {
  NSBluetoothAlwaysUsageDescription = 'NSBluetoothAlwaysUsageDescription',
  NSCalendarsUsageDescription = 'NSCalendarsUsageDescription',
  NSCameraUsageDescription = 'NSCameraUsageDescription',
  NSContactsUsageDescription = 'NSContactsUsageDescription',
  NSFaceIDUsageDescription = 'NSFaceIDUsageDescription',
  NSLocationWhenInUseUsageDescription = 'NSLocationWhenInUseUsageDescription',
  NSMicrophoneUsageDescription = 'NSMicrophoneUsageDescription',
  NSMotionUsageDescription = 'NSMotionUsageDescription',
  NSPhotoLibraryAddUsageDescription = 'NSPhotoLibraryAddUsageDescription',
  NSPhotoLibraryUsageDescription = 'NSPhotoLibraryUsageDescription',
  NSUserTrackingUsageDescription = 'NSUserTrackingUsageDescription',
}

/** An inclusive age range and what the rule requires for it */
export interface JurisdictionAgeBandInput {
  maxAge?: InputMaybe<Scalars['Float']['input']>
  minAge: Scalars['Float']['input']
  outcome: AgeBandOutcome
}

/** Lifecycle of a jurisdiction rule revision */
export enum JurisdictionRuleStatus {
  ACTIVE = 'ACTIVE',
  RETIRED = 'RETIRED',
  SUPERSEDED = 'SUPERSEDED',
}

export interface KnowledgeArticleCategoryCreateInput {
  color?: InputMaybe<Scalars['String']['input']>
  icon?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  slug?: InputMaybe<Scalars['String']['input']>
  sortOrder?: InputMaybe<Scalars['Int']['input']>
}

export interface KnowledgeArticleCategoryUpdateInput {
  color?: InputMaybe<Scalars['String']['input']>
  icon?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  sortOrder?: InputMaybe<Scalars['Int']['input']>
}

export interface KnowledgeArticleCreateInput {
  category?: InputMaybe<Scalars['String']['input']>
  contentMarkdown: Scalars['String']['input']
  coverImagePosition?: InputMaybe<CoverImagePositionInput>
  coverImageUrl?: InputMaybe<Scalars['String']['input']>
  metaDescription?: InputMaybe<Scalars['String']['input']>
  metaTitle?: InputMaybe<Scalars['String']['input']>
  permissionTags?: InputMaybe<Array<Scalars['String']['input']>>
  roleTags?: InputMaybe<Array<Scalars['String']['input']>>
  slug: Scalars['String']['input']
  status?: InputMaybe<KnowledgeArticleStatus>
  subtitle?: InputMaybe<Scalars['String']['input']>
  summary?: InputMaybe<Scalars['String']['input']>
  tags?: InputMaybe<Array<Scalars['String']['input']>>
  tierTags?: InputMaybe<Array<Scalars['String']['input']>>
  title: Scalars['String']['input']
}

export interface KnowledgeArticleFilterInput {
  category?: InputMaybe<Scalars['String']['input']>
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>
  permissionTags?: InputMaybe<Array<Scalars['String']['input']>>
  roleTags?: InputMaybe<Array<Scalars['String']['input']>>
  search?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<KnowledgeArticleStatus>
  tags?: InputMaybe<Array<Scalars['String']['input']>>
  tierTags?: InputMaybe<Array<Scalars['String']['input']>>
}

/**
 * Reviewer edits to a PENDING_REVIEW proposal (merge-with-changes). Only proposal
 * fields — the live article is untouched until approval.
 */
export interface KnowledgeArticleRevisionContentInput {
  proposedCategory?: InputMaybe<Scalars['String']['input']>
  proposedContentMarkdown?: InputMaybe<Scalars['String']['input']>
  proposedSubtitle?: InputMaybe<Scalars['String']['input']>
  proposedSummary?: InputMaybe<Scalars['String']['input']>
  proposedTitle?: InputMaybe<Scalars['String']['input']>
}

export interface KnowledgeArticleRevisionFilterInput {
  changeType?: InputMaybe<RevisionChangeType>
  knowledgeArticleId?: InputMaybe<Scalars['ID']['input']>
  reviewState?: InputMaybe<RevisionReviewState>
}

export enum KnowledgeArticleStatus {
  ARCHIVED = 'ARCHIVED',
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
}

export interface KnowledgeArticleTranslationInput {
  contentMarkdown: Scalars['String']['input']
  locale: Scalars['String']['input']
  metaDescription?: InputMaybe<Scalars['String']['input']>
  metaTitle?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  summary?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
}

export interface KnowledgeArticleUpdateInput {
  category?: InputMaybe<Scalars['String']['input']>
  contentMarkdown?: InputMaybe<Scalars['String']['input']>
  coverImagePosition?: InputMaybe<CoverImagePositionInput>
  coverImageUrl?: InputMaybe<Scalars['String']['input']>
  metaDescription?: InputMaybe<Scalars['String']['input']>
  metaTitle?: InputMaybe<Scalars['String']['input']>
  permissionTags?: InputMaybe<Array<Scalars['String']['input']>>
  roleTags?: InputMaybe<Array<Scalars['String']['input']>>
  slug?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<KnowledgeArticleStatus>
  subtitle?: InputMaybe<Scalars['String']['input']>
  summary?: InputMaybe<Scalars['String']['input']>
  tags?: InputMaybe<Array<Scalars['String']['input']>>
  tierTags?: InputMaybe<Array<Scalars['String']['input']>>
  title?: InputMaybe<Scalars['String']['input']>
}

export interface KnowledgeDocumentInput {
  category: Scalars['String']['input']
  content: Scalars['String']['input']
  corporateId: Scalars['String']['input']
  siteId?: InputMaybe<Scalars['String']['input']>
  source: Scalars['String']['input']
  tags: Array<Scalars['String']['input']>
  title: Scalars['String']['input']
}

export interface KnowledgeSearchInput {
  category?: InputMaybe<Scalars['String']['input']>
  corporateId: Scalars['String']['input']
  limit?: InputMaybe<Scalars['Int']['input']>
  planTier?: InputMaybe<Scalars['String']['input']>
  query: Scalars['String']['input']
  scopeLevel?: InputMaybe<Scalars['String']['input']>
  userRole?: InputMaybe<Scalars['String']['input']>
}

/** Tracking settings for one lamp set; starting hours apply when tracking is turned on */
export interface LampSetSettingsInput {
  enabled: Scalars['Boolean']['input']
  lifeHours?: InputMaybe<Scalars['Int']['input']>
  startingAsOf?: InputMaybe<Scalars['String']['input']>
  startingHours?: InputMaybe<Scalars['Float']['input']>
  warningHours?: InputMaybe<Scalars['Int']['input']>
}

export enum LeadSource {
  admin_creation = 'admin_creation',
  demo_signup = 'demo_signup',
  organic = 'organic',
  paid = 'paid',
  partner = 'partner',
  referral = 'referral',
}

/** Full-list replacement of a site's configured lead sources. */
export interface LeadSourcesBulkUpdateInput {
  leadSources: Array<Scalars['String']['input']>
}

/** Metric used for challenge leaderboard ranking */
export enum LeaderboardMetric {
  ATTENDANCE = 'ATTENDANCE',
  GOALS = 'GOALS',
}

/** Leaderboard scope — single site or cross-location */
export enum LeaderboardScope {
  CROSS_LOCATION = 'CROSS_LOCATION',
  SITE = 'SITE',
}

/** Leaderboard lifecycle status: DRAFT → ACTIVE → ARCHIVED */
export enum LeaderboardStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  DRAFT = 'DRAFT',
}

/** Leaderboard type — determines which source data is aggregated */
export enum LeaderboardType {
  ATTENDANCE = 'ATTENDANCE',
  CHALLENGE = 'CHALLENGE',
  METRIC = 'METRIC',
  STREAK = 'STREAK',
}

/** Who can view the leaderboard */
export enum LeaderboardVisibility {
  ALL_MEMBERS = 'ALL_MEMBERS',
  PARTICIPANTS_ONLY = 'PARTICIPANTS_ONLY',
  STAFF_ONLY = 'STAFF_ONLY',
}

/** Input for linking a Hapana Push app to a corporate */
export interface LinkCorporatePushAppInput {
  /** Hapana Push app id */
  id: Scalars['String']['input']
  /** Hapana Push sending key */
  key: Scalars['String']['input']
  /** Push app ids already stored on the brand that the caller confirmed replacing */
  replacesAppIds?: InputMaybe<Array<Scalars['String']['input']>>
}

export interface ListAllScheduledInvoicesFilterDateRangeInput {
  from?: InputMaybe<Scalars['String']['input']>
  to?: InputMaybe<Scalars['String']['input']>
}

export interface ListAllScheduledInvoicesFilterInput {
  clientId?: InputMaybe<Scalars['ID']['input']>
  dateRange?: InputMaybe<ListAllScheduledInvoicesFilterDateRangeInput>
  serviceId?: InputMaybe<Scalars['ID']['input']>
  type?: InputMaybe<ScheduledInvoiceType>
}

/** Input for listing all scheduled invoices with filters and pagination */
export interface ListAllScheduledInvoicesInput {
  filter?: InputMaybe<ListAllScheduledInvoicesFilterInput>
  lookAheadMonths: Scalars['Float']['input']
  page: Scalars['Float']['input']
  pageSize: Scalars['Float']['input']
  search?: InputMaybe<Scalars['String']['input']>
}

export interface ListCancelledInvoicesFilterDateRangeInput {
  from?: InputMaybe<Scalars['String']['input']>
  to?: InputMaybe<Scalars['String']['input']>
}

export interface ListCancelledInvoicesFilterInput {
  clientId?: InputMaybe<Scalars['ID']['input']>
  dateRange?: InputMaybe<ListCancelledInvoicesFilterDateRangeInput>
  invoiceTypes?: InputMaybe<Array<InvoiceType>>
}

/** Input for listing staff-cancelled invoices with filters and pagination */
export interface ListCancelledInvoicesInput {
  filter?: InputMaybe<ListCancelledInvoicesFilterInput>
  page: Scalars['Float']['input']
  pageSize: Scalars['Float']['input']
  search?: InputMaybe<Scalars['String']['input']>
}

/** Pagination arguments for listing past recurring invoices by service */
export interface ListPastInvoicesByServiceArgs {
  cursor?: InputMaybe<Scalars['String']['input']>
  orderBy?: InputMaybe<Array<ListPastInvoicesByServiceArgsOrderByInput>>
  pageSize?: InputMaybe<Scalars['Float']['input']>
  serviceId: Scalars['ID']['input']
}

export interface ListPastInvoicesByServiceArgsOrderByInput {
  column: RecurringInvoiceOrderBy
  direction: OrderByDirection
}

export interface ListRecurringInvoicesFilterInput {
  excludeSecondaryFees?: InputMaybe<Scalars['Boolean']['input']>
  status?: InputMaybe<RecurringInvoiceStatus>
  statuses?: InputMaybe<Array<RecurringInvoiceStatus>>
}

/** Input for listing recurring invoices with pagination and filters */
export interface ListRecurringInvoicesInput {
  cursor?: InputMaybe<Scalars['String']['input']>
  filter?: InputMaybe<ListRecurringInvoicesFilterInput>
  pageSize?: InputMaybe<Scalars['Float']['input']>
  search?: InputMaybe<Scalars['String']['input']>
}

/** Pagination arguments for listing scheduled/future recurring invoices by service */
export interface ListScheduledInvoicesByServiceArgs {
  lookAheadMonths?: InputMaybe<Scalars['Float']['input']>
  orderBy?: InputMaybe<Array<ListScheduledInvoicesByServiceArgsOrderByInput>>
  page: Scalars['Float']['input']
  pageSize: Scalars['Float']['input']
  serviceId: Scalars['ID']['input']
}

export interface ListScheduledInvoicesByServiceArgsOrderByInput {
  column: RecurringInvoiceOrderBy
  direction: OrderByDirection
}

export interface ListScheduledJobRunsPaginateInput {
  limit: Scalars['Float']['input']
  offset: Scalars['Float']['input']
}

export interface ListServicesByTemplateTypeFilterInput {
  status?: InputMaybe<ServiceStatus>
  statuses?: InputMaybe<Array<ServiceStatus>>
}

/** Input for listing services by template type with pagination and filters */
export interface ListServicesByTemplateTypeInput {
  cursor?: InputMaybe<Scalars['String']['input']>
  filter?: InputMaybe<ListServicesByTemplateTypeFilterInput>
  pageSize?: InputMaybe<Scalars['Float']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  templateType: ServiceTemplateType
}

/** Already-formatted live occupancy label; the app maps it to localised copy */
export enum LiveOccupancyLabelKey {
  CLOSED = 'CLOSED',
  LEVEL_BUSY = 'LEVEL_BUSY',
  LEVEL_MODERATE = 'LEVEL_MODERATE',
  LEVEL_QUIET = 'LEVEL_QUIET',
  LEVEL_VERY_BUSY = 'LEVEL_VERY_BUSY',
  LIVE_ABOUT = 'LIVE_ABOUT',
  LIVE_FEWER_THAN = 'LIVE_FEWER_THAN',
  TEMPORARILY_CLOSED = 'TEMPORARILY_CLOSED',
}

export enum LiveOccupancyStatus {
  CLOSED = 'CLOSED',
  OPEN = 'OPEN',
  TEMPORARILY_CLOSED = 'TEMPORARILY_CLOSED',
}

/** Record that lamps were replaced on the given date (site timezone); hours restart from newHours */
export interface LogEquipmentLampChangeInput {
  changedAt: Scalars['String']['input']
  equipmentId: Scalars['ID']['input']
  lampSets: Array<EquipmentLampSet>
  newHours?: InputMaybe<Scalars['Float']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
}

export enum LogicalOperator {
  and = 'and',
  or = 'or',
}

export enum MediaOrderBy {
  createdAt = 'createdAt',
  fileName = 'fileName',
  fileSize = 'fileSize',
}

/** Type of media asset */
export enum MediaType {
  AUDIO = 'AUDIO',
  DOCUMENT = 'DOCUMENT',
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
}

/** How member names are displayed on the leaderboard */
export enum MemberDisplayFormat {
  ANONYMOUS_ID = 'ANONYMOUS_ID',
  FIRST_NAME_LAST_INITIAL = 'FIRST_NAME_LAST_INITIAL',
  FULL_NAME = 'FULL_NAME',
}

export enum MemberExperienceDarkMode {
  auto = 'auto',
  dark = 'dark',
  light = 'light',
}

export enum MemberExperienceStreakScope {
  BRAND = 'BRAND',
  SITE = 'SITE',
}

export enum MemberExperienceSurface {
  Embed = 'Embed',
  Kiosk = 'Kiosk',
  Mobile = 'Mobile',
}

/** Third-party integrations configurable per member-experience surface */
export enum MemberExperienceSurfaceIntegrationProvider {
  facebook = 'facebook',
}

/** One answer from a member's session feedback */
export interface MemberFeedbackAnswerInput {
  answer: Scalars['String']['input']
  questionId: Scalars['ID']['input']
}

/** One answer to a question on a member form */
export interface MemberFormAnswerInput {
  answer?: InputMaybe<Scalars['String']['input']>
  siteFormQuestionId: Scalars['String']['input']
}

/** The member channel a form was completed in: the mobile app or a web embed */
export enum MemberFormChannel {
  EMBED = 'EMBED',
  MEMBER_APP = 'MEMBER_APP',
}

/** Lifecycle state of a marketplace member link (e.g. eGym account link). */
export enum MemberLinkStatus {
  error = 'error',
  linked = 'linked',
  pending = 'pending',
  pending_review = 'pending_review',
  unlinked = 'unlinked',
}

/** Where a location’s effective rolling approval posture comes from */
export enum MemberMovementApprovalPostureSource {
  BRAND_DEFAULT = 'BRAND_DEFAULT',
  BRAND_LOCKED = 'BRAND_LOCKED',
  LOCATION_OVERRIDE = 'LOCATION_OVERRIDE',
}

export interface MemberMovementApprovalReadinessInput {
  corporateId: Scalars['ID']['input']
  runId: Scalars['ID']['input']
}

/** Typed-name + disclaimer-version acceptance required for consequential actions */
export interface MemberMovementAttestationInput {
  disclaimerVersion: Scalars['String']['input']
  typedName: Scalars['String']['input']
}

export interface MemberMovementAttestationRegisterInput {
  corporateId: Scalars['ID']['input']
  scope?: InputMaybe<Scalars['String']['input']>
}

/** Which consequential action a recorded attestation covers */
export enum MemberMovementAttestationScope {
  CONFIG = 'CONFIG',
  MANUAL_TRANSFER = 'MANUAL_TRANSFER',
  ROLLING_ENABLE = 'ROLLING_ENABLE',
  RUN_APPROVAL = 'RUN_APPROVAL',
}

/** Whether the destination membership retains the source price or uses its own */
export enum MemberMovementBillingAmountStrategy {
  RETAIN_SOURCE = 'RETAIN_SOURCE',
  USE_DESTINATION = 'USE_DESTINATION',
}

/** How Movement Managers are notified of blocked movements */
export enum MemberMovementBlockedNotificationCadence {
  DAILY_DIGEST = 'DAILY_DIGEST',
  IMMEDIATE = 'IMMEDIATE',
}

export interface MemberMovementBlockedQueueInput {
  blockedReason?: InputMaybe<MemberMovementBlockedReason>
  corporateId: Scalars['ID']['input']
  cursor?: InputMaybe<Scalars['String']['input']>
  destinationSiteId?: InputMaybe<Scalars['ID']['input']>
  pageSize?: InputMaybe<Scalars['Float']['input']>
  runId?: InputMaybe<Scalars['ID']['input']>
  sourceSiteId?: InputMaybe<Scalars['ID']['input']>
  trigger?: InputMaybe<MemberMovementTrigger>
}

/** Why a movement is sitting in the Blocked/Replay queue */
export enum MemberMovementBlockedReason {
  EXECUTION_FAILED = 'EXECUTION_FAILED',
  MAPPING_STALE = 'MAPPING_STALE',
  PREFLIGHT_FAILED = 'PREFLIGHT_FAILED',
  TEMPLATE_UNRESOLVED = 'TEMPLATE_UNRESOLVED',
}

/** Candidacy exclusion set: only the membership own home site (default), or every site the member belongs to */
export enum MemberMovementCandidateHomeExclusion {
  ALL_MEMBERSHIP_SITES = 'ALL_MEMBERSHIP_SITES',
  OWN_HOME_ONLY = 'OWN_HOME_ONLY',
}

/** Staff-editable Member Movement config fields (entitlement fields are admin-only and excluded) */
export interface MemberMovementConfigInput {
  allowArchivedDestinations?: InputMaybe<Scalars['Boolean']['input']>
  billingAmountStrategy?: InputMaybe<MemberMovementBillingAmountStrategy>
  blockedNotificationCadence?: InputMaybe<MemberMovementBlockedNotificationCadence>
  candidateHomeExclusion?: InputMaybe<MemberMovementCandidateHomeExclusion>
  declineCooldownDays?: InputMaybe<Scalars['Float']['input']>
  excludeScheduledCancellations?: InputMaybe<Scalars['Boolean']['input']>
  excludeSuspendedMemberships?: InputMaybe<Scalars['Boolean']['input']>
  excludedClientIds?: InputMaybe<Array<Scalars['ID']['input']>>
  excludedPackageCategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>
  growTransferTag?: InputMaybe<Scalars['String']['input']>
  includedSiteIds?: InputMaybe<Array<Scalars['ID']['input']>>
  incomingApprovalExpiryDays?: InputMaybe<Scalars['Float']['input']>
  incomingApprovalNotifiers?: InputMaybe<Array<MemberMovementIncomingApproverInput>>
  maxMovementsPerCycle?: InputMaybe<MemberMovementMaxMovementsPerCycleInput>
  minMembershipPrice?: InputMaybe<Scalars['Float']['input']>
  minNonHomeVisits?: InputMaybe<Scalars['Float']['input']>
  minPaidAmountInPeriod?: InputMaybe<Scalars['Float']['input']>
  minTenure?: InputMaybe<MemberMovementDurationConfigInput>
  minTenureCutoffDate?: InputMaybe<Scalars['String']['input']>
  minVisitPercentAtCandidate?: InputMaybe<Scalars['Float']['input']>
  minVisits?: InputMaybe<Scalars['Float']['input']>
  minVisitsScope?: InputMaybe<MemberMovementVisitsScope>
  movementManagerStaffUserIds?: InputMaybe<Array<Scalars['ID']['input']>>
  operatingMode?: InputMaybe<MemberMovementOperatingMode>
  postMovementGracePeriodDays?: InputMaybe<Scalars['Float']['input']>
  rollingApprovalLocked?: InputMaybe<Scalars['Boolean']['input']>
  rollingApprovalType?: InputMaybe<MemberMovementRollingApprovalType>
  rollingSchedule?: InputMaybe<MemberMovementConfigRollingScheduleInput>
  templateMappingMode?: InputMaybe<MemberMovementTemplateMappingMode>
  visitScope?: InputMaybe<MemberMovementConfigVisitScopeInput>
  visitWindowHours?: InputMaybe<Scalars['Float']['input']>
}

export interface MemberMovementConfigRollingScheduleInput {
  evaluationWindow: MemberMovementDurationConfigInput
  frequency: MemberMovementDurationConfigInput
  previewWindowHours: Scalars['Float']['input']
}

export interface MemberMovementConfigVisitScopeInput {
  class: Scalars['Boolean']['input']
  general: Scalars['Boolean']['input']
}

/** Input variant of MemberMovementDurationConfig */
export interface MemberMovementDurationConfigInput {
  unit: MemberMovementDurationUnit
  value: Scalars['Float']['input']
}

/** Time unit for a relative duration config */
export enum MemberMovementDurationUnit {
  DAYS = 'DAYS',
  HOURS = 'HOURS',
  MONTHS = 'MONTHS',
  WEEKS = 'WEEKS',
}

export interface MemberMovementEligibilityCheckInput {
  clientId: Scalars['ID']['input']
  corporateId: Scalars['ID']['input']
  serviceId?: InputMaybe<Scalars['ID']['input']>
}

/** Hapana-Admin-only Member Movement force-off switch (enabled) */
export interface MemberMovementEntitlementInput {
  enabled?: InputMaybe<Scalars['Boolean']['input']>
}

/** Stable machine key identifying which eligibility gate produced a result */
export enum MemberMovementGateKey {
  CATEGORY_NOT_EXCLUDED = 'CATEGORY_NOT_EXCLUDED',
  CLIENT_NOT_EXCLUDED = 'CLIENT_NOT_EXCLUDED',
  HAS_NON_HOME_VISITS = 'HAS_NON_HOME_VISITS',
  HOME_SITE_IN_SCOPE = 'HOME_SITE_IN_SCOPE',
  MEMBERSHIP_STATUS = 'MEMBERSHIP_STATUS',
  MIN_MEMBERSHIP_PRICE = 'MIN_MEMBERSHIP_PRICE',
  MIN_PAID_AT_HOME = 'MIN_PAID_AT_HOME',
  MIN_PERCENT_AT_CANDIDATE = 'MIN_PERCENT_AT_CANDIDATE',
  MIN_TENURE = 'MIN_TENURE',
  MIN_VISITS = 'MIN_VISITS',
  NOT_IN_GRACE_PERIOD = 'NOT_IN_GRACE_PERIOD',
  NOT_RECENTLY_DECLINED = 'NOT_RECENTLY_DECLINED',
  NO_NON_HOME_TIE = 'NO_NON_HOME_TIE',
  OPEN_MOVEMENT_PENDING = 'OPEN_MOVEMENT_PENDING',
  SCHEDULED_CANCELLATION = 'SCHEDULED_CANCELLATION',
  TEMPLATE_RESOLVABLE = 'TEMPLATE_RESOLVABLE',
}

/** Outcome of a single eligibility gate */
export enum MemberMovementGateStatus {
  FAIL = 'FAIL',
  PASS = 'PASS',
  SKIP = 'SKIP',
}

export interface MemberMovementHomeSiteRecoveryInput {
  corporateId: Scalars['ID']['input']
  cursor?: InputMaybe<Scalars['String']['input']>
  pageSize?: InputMaybe<Scalars['Float']['input']>
}

export interface MemberMovementIncomingApprovalQueueInput {
  cursor?: InputMaybe<Scalars['String']['input']>
  destinationSiteId?: InputMaybe<Scalars['ID']['input']>
  pageSize?: InputMaybe<Scalars['Float']['input']>
}

export interface MemberMovementIncomingApproverInput {
  siteId: Scalars['ID']['input']
  staffUserIds: Array<Scalars['ID']['input']>
}

export interface MemberMovementIncomingDestinationTemplatesInput {
  memberMovementId: Scalars['ID']['input']
}

export interface MemberMovementIncomingMovementInput {
  memberMovementId: Scalars['ID']['input']
}

export interface MemberMovementIncomingNotifierCandidatesInput {
  siteId: Scalars['ID']['input']
}

export interface MemberMovementIncomingQueueInput {
  cursor?: InputMaybe<Scalars['String']['input']>
  destinationSiteId?: InputMaybe<Scalars['ID']['input']>
  pageSize?: InputMaybe<Scalars['Float']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  segment: MemberMovementIncomingSegment
}

/** A location’s incoming member movement queue segment */
export enum MemberMovementIncomingSegment {
  AWAITING = 'AWAITING',
  FAILED = 'FAILED',
  HISTORY = 'HISTORY',
  UNMATCHED = 'UNMATCHED',
}

export interface MemberMovementIncomingSummaryInput {
  destinationSiteId?: InputMaybe<Scalars['ID']['input']>
}

export interface MemberMovementLocationPosturesInput {
  siteIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export interface MemberMovementLocationResolutionsInput {
  cursor?: InputMaybe<Scalars['String']['input']>
  pageSize?: InputMaybe<Scalars['Float']['input']>
}

export interface MemberMovementManualTransferInput {
  clientId: Scalars['ID']['input']
  corporateId: Scalars['ID']['input']
  destinationServiceTemplateId?: InputMaybe<Scalars['ID']['input']>
  destinationSiteId: Scalars['ID']['input']
  sourceServiceId: Scalars['ID']['input']
}

/** How a template mapping was resolved */
export enum MemberMovementMappingMatchType {
  MANUAL = 'MANUAL',
  NAME_EXACT = 'NAME_EXACT',
}

export enum MemberMovementMappingStateFilter {
  INELIGIBLE = 'INELIGIBLE',
  MOVABLE = 'MOVABLE',
  RESOLVED = 'RESOLVED',
  UNRESOLVED = 'UNRESOLVED',
}

/** Input variant of MemberMovementMaxMovementsPerCycle */
export interface MemberMovementMaxMovementsPerCycleInput {
  absolute?: InputMaybe<Scalars['Float']['input']>
  percentOfActiveMembers: Scalars['Float']['input']
}

/** Which operating mode(s) a corporate has enabled */
export enum MemberMovementOperatingMode {
  BOTH = 'BOTH',
  PERIOD_RUNS = 'PERIOD_RUNS',
  ROLLING = 'ROLLING',
}

export interface MemberMovementPaymentCollectionInput {
  corporateId: Scalars['ID']['input']
  cursor?: InputMaybe<Scalars['String']['input']>
  destinationSiteId?: InputMaybe<Scalars['ID']['input']>
  includeCollected?: InputMaybe<Scalars['Boolean']['input']>
  pageSize?: InputMaybe<Scalars['Float']['input']>
  runId?: InputMaybe<Scalars['ID']['input']>
  trigger?: InputMaybe<MemberMovementTrigger>
}

/** Why a payment method could not migrate (NOT_POSSIBLE) or failed (FAILED) */
export enum MemberMovementPaymentMigrationReason {
  BANK_AUTHORISATION_MISSING = 'BANK_AUTHORISATION_MISSING',
  BANK_MANDATE = 'BANK_MANDATE',
  CROSS_COUNTRY = 'CROSS_COUNTRY',
  CROSS_GATEWAY = 'CROSS_GATEWAY',
  CROSS_PLATFORM = 'CROSS_PLATFORM',
  GATEWAY_ERROR = 'GATEWAY_ERROR',
  GATEWAY_UNAVAILABLE = 'GATEWAY_UNAVAILABLE',
  NO_SOURCE_METHOD = 'NO_SOURCE_METHOD',
  SOURCE_METHOD_INVALID = 'SOURCE_METHOD_INVALID',
}

/** Outcome of the post-commit payment-method migration attempt */
export enum MemberMovementPaymentMigrationStatus {
  EXISTING_METHOD = 'EXISTING_METHOD',
  FAILED = 'FAILED',
  MIGRATED = 'MIGRATED',
  NOT_POSSIBLE = 'NOT_POSSIBLE',
}

/** First-failed-gate reason code recorded on a movement evaluation */
export enum MemberMovementReasonCode {
  BELOW_MIN_MEMBERSHIP_PRICE = 'BELOW_MIN_MEMBERSHIP_PRICE',
  BELOW_MIN_PAID = 'BELOW_MIN_PAID',
  BELOW_MIN_PERCENT = 'BELOW_MIN_PERCENT',
  BELOW_MIN_TENURE = 'BELOW_MIN_TENURE',
  BELOW_MIN_VISITS = 'BELOW_MIN_VISITS',
  CANDIDATE_IS_HOME = 'CANDIDATE_IS_HOME',
  EXCLUDED_CLIENT = 'EXCLUDED_CLIENT',
  EXCLUDED_PACKAGE_CATEGORY = 'EXCLUDED_PACKAGE_CATEGORY',
  EXCLUDED_SITE = 'EXCLUDED_SITE',
  HELD_BY_OTHER_RUN = 'HELD_BY_OTHER_RUN',
  INCOMING_APPROVAL_DECLINED_COOLDOWN = 'INCOMING_APPROVAL_DECLINED_COOLDOWN',
  NON_HOME_TIE_NO_MOVEMENT = 'NON_HOME_TIE_NO_MOVEMENT',
  NO_NON_HOME_VISITS = 'NO_NON_HOME_VISITS',
  POST_MOVEMENT_GRACE_PERIOD = 'POST_MOVEMENT_GRACE_PERIOD',
  PRESALE_NOT_STARTED = 'PRESALE_NOT_STARTED',
  SCHEDULED_CANCELLATION_EXCLUDED = 'SCHEDULED_CANCELLATION_EXCLUDED',
  SUSPENDED_EXCLUDED = 'SUSPENDED_EXCLUDED',
  TEMPLATE_UNRESOLVED = 'TEMPLATE_UNRESOLVED',
}

export interface MemberMovementReplayMappingFixInput {
  destinationServiceTemplateId: Scalars['ID']['input']
  destinationSiteId: Scalars['ID']['input']
  sourceServiceTemplateId: Scalars['ID']['input']
  sourceSiteId: Scalars['ID']['input']
}

export interface MemberMovementRevertLogInput {
  corporateId: Scalars['ID']['input']
  cursor?: InputMaybe<Scalars['String']['input']>
  pageSize?: InputMaybe<Scalars['Float']['input']>
  runId?: InputMaybe<Scalars['ID']['input']>
  trigger?: InputMaybe<MemberMovementTrigger>
}

export interface MemberMovementReviewDecisionInput {
  destinationServiceTemplateId?: InputMaybe<Scalars['ID']['input']>
  destinationSiteId?: InputMaybe<Scalars['ID']['input']>
  forceInclude?: InputMaybe<Scalars['Boolean']['input']>
  movementId: Scalars['ID']['input']
  note?: InputMaybe<Scalars['String']['input']>
  reviewStatus: MemberMovementReviewStatus
}

/** Batch-mode approval-grid review decision for a qualified movement */
export enum MemberMovementReviewStatus {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REMAPPED = 'REMAPPED',
  REMOVED = 'REMOVED',
}

/** Rolling posture: AUTOMATIC executes qualified members after the preview window; APPROVAL parks them for the incoming location to accept */
export enum MemberMovementRollingApprovalType {
  APPROVAL = 'APPROVAL',
  AUTOMATIC = 'AUTOMATIC',
}

/** Whether a Member Movement run is a batch Period Run or a rolling evaluation cycle */
export enum MemberMovementRunMode {
  PERIOD_RUN = 'PERIOD_RUN',
  ROLLING_CYCLE = 'ROLLING_CYCLE',
}

/** Lifecycle status of a Member Movement run */
export enum MemberMovementRunStatus {
  APPROVED = 'APPROVED',
  CALCULATING = 'CALCULATING',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  COMPLETED_WITH_ERRORS = 'COMPLETED_WITH_ERRORS',
  DRAFT = 'DRAFT',
  EXECUTING = 'EXECUTING',
  FAILED = 'FAILED',
  REQUIRES_REVIEW = 'REQUIRES_REVIEW',
  REVIEW = 'REVIEW',
}

export interface MemberMovementRunsInput {
  corporateId: Scalars['ID']['input']
  cursor?: InputMaybe<Scalars['String']['input']>
  pageSize?: InputMaybe<Scalars['Float']['input']>
}

/** Lifecycle status of a single MemberMovement row */
export enum MemberMovementStatus {
  BLOCKED = 'BLOCKED',
  DISMISSED = 'DISMISSED',
  EVALUATED = 'EVALUATED',
  MOVED = 'MOVED',
  MOVED_PENDING_HOMESITE = 'MOVED_PENDING_HOMESITE',
  MOVE_FAILED = 'MOVE_FAILED',
  QUALIFIED = 'QUALIFIED',
  REVERTED = 'REVERTED',
}

/** How destination service templates are resolved */
export enum MemberMovementTemplateMappingMode {
  MAPPING_MATRIX = 'MAPPING_MATRIX',
  NOMINATED_DEFAULT = 'NOMINATED_DEFAULT',
}

/** What caused a MemberMovement row to be created */
export enum MemberMovementTrigger {
  MANUAL = 'MANUAL',
  REPLAY = 'REPLAY',
  ROLLING = 'ROLLING',
  RUN = 'RUN',
}

/** What minVisits counts against — the candidate site only, or all locations */
export enum MemberMovementVisitsScope {
  ALL_LOCATIONS = 'ALL_LOCATIONS',
  CANDIDATE_SITE = 'CANDIDATE_SITE',
}

export interface MemberMovementsFilterInput {
  corporateId: Scalars['ID']['input']
  cursor?: InputMaybe<Scalars['String']['input']>
  destinationSiteId?: InputMaybe<Scalars['ID']['input']>
  mappingState?: InputMaybe<MemberMovementMappingStateFilter>
  page?: InputMaybe<Scalars['Float']['input']>
  pageSize?: InputMaybe<Scalars['Float']['input']>
  reasonCode?: InputMaybe<Scalars['String']['input']>
  runId?: InputMaybe<Scalars['ID']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  siteId?: InputMaybe<Scalars['ID']['input']>
  sourceSiteId?: InputMaybe<Scalars['ID']['input']>
  status?: InputMaybe<MemberMovementStatus>
  statuses?: InputMaybe<Array<MemberMovementStatus>>
  trigger?: InputMaybe<Scalars['String']['input']>
}

/** Notify the member of each moved pre-sale membership with the MEMBERSHIP_UPDATED template. A channel only sends when it is also enabled on that template; message is an optional operator note. */
export interface MemberNotificationInput {
  channels: Array<MessageType>
  message?: InputMaybe<Scalars['String']['input']>
}

export enum MemberPauseAllowanceUnit {
  BILLING_CYCLES = 'BILLING_CYCLES',
  DAYS = 'DAYS',
}

export enum MemberPauseBlocker {
  ALLOWANCE_EXCEEDED = 'ALLOWANCE_EXCEEDED',
  BEFORE_NOTICE_PERIOD = 'BEFORE_NOTICE_PERIOD',
  BELOW_MIN_PAUSE = 'BELOW_MIN_PAUSE',
  END_BEFORE_START = 'END_BEFORE_START',
  EXCEEDS_MAX_SINGLE_PAUSE = 'EXCEEDS_MAX_SINGLE_PAUSE',
  FAILED_INVOICES = 'FAILED_INVOICES',
  HAS_LIVE_PAUSE = 'HAS_LIVE_PAUSE',
  NOT_ACTIVE = 'NOT_ACTIVE',
  NOT_ENABLED = 'NOT_ENABLED',
  NOT_ON_BILLING_DATE = 'NOT_ON_BILLING_DATE',
  NO_RECURRING_BILLING = 'NO_RECURRING_BILLING',
  PAUSE_TYPE_UNAVAILABLE = 'PAUSE_TYPE_UNAVAILABLE',
  REASON_REQUIRED = 'REASON_REQUIRED',
  SCHEDULED_CANCELLATION = 'SCHEDULED_CANCELLATION',
}

/** The dates and reason the member chose. The end date is inclusive; the membership resumes the day after. Source says whether the request came from the app or the embed widget. */
export interface MemberPauseInput {
  endDate: Scalars['String']['input']
  reasonId?: InputMaybe<Scalars['String']['input']>
  source: MemberServiceSuspensionSource
  startDate: Scalars['String']['input']
}

/** The dates and reason to quote, before the member confirms. */
export interface MemberPauseWindowInput {
  endDate: Scalars['String']['input']
  reasonId?: InputMaybe<Scalars['String']['input']>
  startDate: Scalars['String']['input']
}

export enum MemberServiceSuspensionSource {
  MEMBER_APP = 'MEMBER_APP',
  MEMBER_EMBED = 'MEMBER_EMBED',
}

/** A member submitting feedback for a session they attended */
export interface MemberSessionFeedbackInput {
  answers: Array<MemberFeedbackAnswerInput>
  clientId: Scalars['ID']['input']
  comments?: InputMaybe<Scalars['String']['input']>
  sessionId: Scalars['ID']['input']
  siteId: Scalars['ID']['input']
}

export enum MembershipImportBlockingIssueCode {
  PRESALE_FILE_HAS_MEMBER_HISTORY = 'PRESALE_FILE_HAS_MEMBER_HISTORY',
  PRESALE_FILE_MANY_FIRST_PAYMENT_DATES = 'PRESALE_FILE_MANY_FIRST_PAYMENT_DATES',
  PRESALE_FILE_WIDE_PURCHASE_SPAN = 'PRESALE_FILE_WIDE_PURCHASE_SPAN',
}

export enum MembershipMemberStatusFilter {
  ACTIVE = 'ACTIVE',
  ALL = 'ALL',
  EXPIRED = 'EXPIRED',
}

/** Input for executing a client merge operation */
export interface MergeClientsInput {
  mergeScope: MergeScope
  profileChoices: MergeProfileChoicesInput
  siteId: Scalars['ID']['input']
  sourceClientId: Scalars['ID']['input']
  targetClientId: Scalars['ID']['input']
}

/** Input for generating a merge clients preview */
export interface MergeClientsPreviewInput {
  mergeScope: MergeScope
  siteId: Scalars['ID']['input']
  sourceClientId: Scalars['ID']['input']
  targetClientId: Scalars['ID']['input']
}

/** User choice for a custom property conflict during merge */
export interface MergeCustomPropertyChoice {
  keepSource: Scalars['Boolean']['input']
  siteCustomPropertyId: Scalars['String']['input']
}

/** User choices for which profile fields to keep from the source client */
export interface MergeProfileChoicesInput {
  customPropertyChoices: Array<MergeCustomPropertyChoice>
  keepSourceAddress: Scalars['Boolean']['input']
  keepSourceBarcodeId: Scalars['Boolean']['input']
  keepSourceCustomerId: Scalars['Boolean']['input']
  keepSourceDateOfBirth: Scalars['Boolean']['input']
  keepSourceEmail: Scalars['Boolean']['input']
  keepSourceEmergencyContact: Scalars['Boolean']['input']
  keepSourceFirstName: Scalars['Boolean']['input']
  keepSourceFobNumber: Scalars['Boolean']['input']
  keepSourceGender: Scalars['Boolean']['input']
  keepSourceLastName: Scalars['Boolean']['input']
  keepSourcePhone: Scalars['Boolean']['input']
  keepSourceProfileImage: Scalars['Boolean']['input']
}

/** Scope of a client merge operation */
export enum MergeScope {
  CORPORATE = 'CORPORATE',
  SITE = 'SITE',
}

/** Type of message to send */
export enum MessageType {
  email = 'email',
  push = 'push',
  sms = 'sms',
}

export enum MinimumTermAfterUnit {
  DAYS = 'DAYS',
  MONTHS = 'MONTHS',
  WEEKS = 'WEEKS',
  YEARS = 'YEARS',
}

export enum MobileAppChangeField {
  accentColor = 'accentColor',
  appIconUrl = 'appIconUrl',
  appMenu = 'appMenu',
  associatedDomains = 'associatedDomains',
  backgroundColor = 'backgroundColor',
  backgroundModes = 'backgroundModes',
  bundleIdIos = 'bundleIdIos',
  channels = 'channels',
  expoConfigPlugins = 'expoConfigPlugins',
  firebaseNativeConfig = 'firebaseNativeConfig',
  fontConfig = 'fontConfig',
  fontFamily = 'fontFamily',
  homeLogoUrl = 'homeLogoUrl',
  iosEntitlements = 'iosEntitlements',
  logoUrl = 'logoUrl',
  mapsConfig = 'mapsConfig',
  nativeCapabilities = 'nativeCapabilities',
  nativeDependencies = 'nativeDependencies',
  nativeRuntime = 'nativeRuntime',
  nativeSplashBackgroundColor = 'nativeSplashBackgroundColor',
  packageAndroid = 'packageAndroid',
  permissions = 'permissions',
  primaryColor = 'primaryColor',
  profileConfig = 'profileConfig',
  pushNotificationConfig = 'pushNotificationConfig',
  secondaryColor = 'secondaryColor',
  signInWithApple = 'signInWithApple',
  splashScreenDarkUrl = 'splashScreenDarkUrl',
  splashScreenUrl = 'splashScreenUrl',
  storeAssets = 'storeAssets',
  storeListing = 'storeListing',
  tabIconBookingsUrl = 'tabIconBookingsUrl',
  tabIconExploreUrl = 'tabIconExploreUrl',
  tabIconHomeUrl = 'tabIconHomeUrl',
  tabIconMoreUrl = 'tabIconMoreUrl',
  tabIconPackagesUrl = 'tabIconPackagesUrl',
  textColor = 'textColor',
  urlSchemes = 'urlSchemes',
}

export enum MobileAppChangeImpact {
  native = 'native',
  runtime = 'runtime',
  store_metadata = 'store_metadata',
}

export enum MobileAppPlatform {
  android = 'android',
  ios = 'ios',
}

export interface MobileCustomizationAdvancedFeaturesDarkModeInput {
  adjustmentStrategy: DarkModeStrategy
  auto: Scalars['Boolean']['input']
  overrides?: InputMaybe<MobileCustomizationAdvancedFeaturesDarkModeOverridesInput>
}

export interface MobileCustomizationAdvancedFeaturesDarkModeOverridesInput {
  background?: InputMaybe<Scalars['String']['input']>
  primary?: InputMaybe<Scalars['String']['input']>
  secondary?: InputMaybe<Scalars['String']['input']>
  surface?: InputMaybe<Scalars['String']['input']>
}

export interface MobileCustomizationAdvancedFeaturesInput {
  barcodeEnabled: Scalars['Boolean']['input']
  callUsEnabled: Scalars['Boolean']['input']
  challenge: Scalars['Boolean']['input']
  contactlessCheckin: Scalars['Boolean']['input']
  darkMode: MobileCustomizationAdvancedFeaturesDarkModeInput
  darkModeSupport: Scalars['Boolean']['input']
  displayInstructor: Scalars['Boolean']['input']
  editFieldsEnable: Scalars['Boolean']['input']
  evoltIntegrationEnabled: Scalars['Boolean']['input']
  filterTimeAvailable: Scalars['Boolean']['input']
  isAnyAvailable: Scalars['Boolean']['input']
  isDynamicImages: Scalars['Boolean']['input']
  isSquareButton: Scalars['Boolean']['input']
  newsFeedAvailable: Scalars['Boolean']['input']
  profilePhoto: Scalars['Boolean']['input']
  sessionDisplay: SessionDisplayType
  showBilling: Scalars['Boolean']['input']
  shownCommPref: Scalars['Boolean']['input']
  statsAvailable: Scalars['Boolean']['input']
}

export interface MobileCustomizationBrandingInput {
  appIcon?: InputMaybe<Scalars['String']['input']>
  loginBackground?: InputMaybe<Scalars['String']['input']>
  logo?: InputMaybe<Scalars['String']['input']>
  splashScreen?: InputMaybe<Scalars['String']['input']>
}

export interface MobileCustomizationColorsInput {
  accent?: InputMaybe<Scalars['String']['input']>
  background?: InputMaybe<Scalars['String']['input']>
  error?: InputMaybe<Scalars['String']['input']>
  info?: InputMaybe<Scalars['String']['input']>
  primary: Scalars['String']['input']
  secondary: Scalars['String']['input']
  success?: InputMaybe<Scalars['String']['input']>
  surface?: InputMaybe<Scalars['String']['input']>
  text?: InputMaybe<Scalars['String']['input']>
  textSecondary?: InputMaybe<Scalars['String']['input']>
  warning?: InputMaybe<Scalars['String']['input']>
}

export interface MobileCustomizationCoreFeaturesInput {
  digital: Scalars['Boolean']['input']
  explore: Scalars['Boolean']['input']
  purchase: Scalars['Boolean']['input']
  schedule: Scalars['Boolean']['input']
  workouts: Scalars['Boolean']['input']
}

export interface MobileCustomizationFontsInput {
  defaultLanguage: MobileSupportedLanguage
  languageFonts?: InputMaybe<MobileCustomizationFontsLanguageFontsInput>
  supportedLanguages: Array<MobileSupportedLanguage>
}

export interface MobileCustomizationFontsLanguageFontsENInput {
  customFonts: Array<Scalars['String']['input']>
  fontFamily: Scalars['String']['input']
  language: MobileSupportedLanguage
  letterSpacing?: InputMaybe<MobileCustomizationFontsLanguageFontsENLetterSpacingInput>
  lineHeight?: InputMaybe<MobileCustomizationFontsLanguageFontsENLineHeightInput>
  sizes: MobileCustomizationFontsLanguageFontsENSizesInput
}

export interface MobileCustomizationFontsLanguageFontsENLetterSpacingInput {
  normal: Scalars['Float']['input']
  tight: Scalars['Float']['input']
  wide: Scalars['Float']['input']
}

export interface MobileCustomizationFontsLanguageFontsENLineHeightInput {
  lg: Scalars['Float']['input']
  md: Scalars['Float']['input']
  sm: Scalars['Float']['input']
  xl: Scalars['Float']['input']
  xs: Scalars['Float']['input']
  xxl: Scalars['Float']['input']
}

export interface MobileCustomizationFontsLanguageFontsENSizesInput {
  lg: Scalars['Float']['input']
  md: Scalars['Float']['input']
  sm: Scalars['Float']['input']
  xl: Scalars['Float']['input']
  xs: Scalars['Float']['input']
  xxl: Scalars['Float']['input']
}

export interface MobileCustomizationFontsLanguageFontsInput {
  EN?: InputMaybe<MobileCustomizationFontsLanguageFontsENInput>
  ES?: InputMaybe<MobileCustomizationFontsLanguageFontsENInput>
}

/** Mobile app customization input */
export interface MobileCustomizationInput {
  advancedFeatures?: InputMaybe<MobileCustomizationAdvancedFeaturesInput>
  branding?: InputMaybe<MobileCustomizationBrandingInput>
  colors?: InputMaybe<MobileCustomizationColorsInput>
  coreFeatures?: InputMaybe<MobileCustomizationCoreFeaturesInput>
  fontFamily?: InputMaybe<Scalars['String']['input']>
  fonts?: InputMaybe<MobileCustomizationFontsInput>
  logoUrl?: InputMaybe<Scalars['String']['input']>
  primaryColor?: InputMaybe<Scalars['String']['input']>
  secondaryColor?: InputMaybe<Scalars['String']['input']>
  sessionFilters?: InputMaybe<MobileCustomizationSessionFiltersInput>
  theme?: InputMaybe<MobileCustomizationThemeInput>
}

export interface MobileCustomizationSessionFiltersInput {
  category: Scalars['Boolean']['input']
  duration: Scalars['Boolean']['input']
  instructors: Scalars['Boolean']['input']
  room: Scalars['Boolean']['input']
  sessionTemplate: Scalars['Boolean']['input']
  sessionTime: Scalars['Boolean']['input']
}

export interface MobileCustomizationThemeBorderRadiusInput {
  lg: Scalars['Float']['input']
  md: Scalars['Float']['input']
  sm: Scalars['Float']['input']
  xl: Scalars['Float']['input']
}

export interface MobileCustomizationThemeInput {
  borderRadius: MobileCustomizationThemeBorderRadiusInput
  spacing: MobileCustomizationThemeSpacingInput
}

export interface MobileCustomizationThemeSpacingInput {
  lg: Scalars['Float']['input']
  md: Scalars['Float']['input']
  sm: Scalars['Float']['input']
  xl: Scalars['Float']['input']
  xs: Scalars['Float']['input']
  xxl: Scalars['Float']['input']
}

/** Supported languages for mobile app */
export enum MobileSupportedLanguage {
  EN = 'EN',
  ES = 'ES',
}

/** Input for booking multiple clients into multiple sessions */
export interface MultipleReservationInput {
  clientIds: Array<Scalars['ID']['input']>
  sendInviteEmail: Scalars['Boolean']['input']
  sessionIds: Array<Scalars['String']['input']>
}

export enum MultipleReservationOutcome {
  booked = 'booked',
  failed = 'failed',
  skipped = 'skipped',
  waitlisted = 'waitlisted',
}

/** Whose documents these are, seen from the signed-in member */
export enum MyPendingRelationship {
  DEPENDANT = 'DEPENDANT',
  SELF = 'SELF',
}

/** Why a native policy accept was refused */
export enum MyPolicyRefusalCode {
  HOSTED_PAGE_REQUIRED = 'HOSTED_PAGE_REQUIRED',
  NOT_ACCEPTED = 'NOT_ACCEPTED',
  NOT_PENDING = 'NOT_PENDING',
}

export interface NLPAnalysisInput {
  analysisType?: InputMaybe<Scalars['String']['input']>
  corporateId: Scalars['String']['input']
  text: Scalars['String']['input']
}

export enum NativePermissionSource {
  added = 'added',
  default = 'default',
  removed = 'removed',
}

export enum NewSaleItemTypes {
  addOns = 'addOns',
  giftCards = 'giftCards',
  membership = 'membership',
  products = 'products',
  recurringPayment = 'recurringPayment',
  sessionPackage = 'sessionPackage',
  singlePayment = 'singlePayment',
}

/** Sub-category for regular (non-UV) equipment */
export enum NonUvCategory {
  red_light = 'red_light',
  spa = 'spa',
  spray = 'spray',
  wellness = 'wellness',
}

/** Notification method types */
export enum NotificationMethod {
  email = 'email',
  push = 'push',
  sms = 'sms',
}

export enum NumericFilterOperator {
  is = 'is',
  is_between = 'is_between',
  is_greater_than = 'is_greater_than',
  is_less_than = 'is_less_than',
  is_not = 'is_not',
}

export enum NumericToDateFilterOperator {
  is = 'is',
  is_between = 'is_between',
  is_greater_than = 'is_greater_than',
  is_less_than = 'is_less_than',
  is_not = 'is_not',
}

/** How a location shows its live occupancy to members */
export enum OccupancyDisplayMode {
  BANDED = 'BANDED',
  LEVEL = 'LEVEL',
}

export interface OnboardBrandBranchCredentialsInput {
  branchLiveKey: Scalars['String']['input']
  branchSecret: Scalars['String']['input']
  branchTestKey?: InputMaybe<Scalars['String']['input']>
}

export enum OnboardingCategory {
  client_interface = 'client_interface',
  operations = 'operations',
  settings = 'settings',
}

export enum OnboardingStepKey {
  account_settings = 'account_settings',
  first_client = 'first_client',
  first_session = 'first_session',
  location_settings = 'location_settings',
  retail_settings = 'retail_settings',
  scheduler_ready = 'scheduler_ready',
  team_access = 'team_access',
}

/** The direction of the order by */
export enum OrderByDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

/** A membership or pack for each chosen employee on one invoice to the organisation. paidInFullCycles sells a membership paid in full for that many billing cycles. */
export interface OrganisationInvoiceInput {
  employeeClientIds: Array<Scalars['ID']['input']>
  organisationClientId: Scalars['ID']['input']
  paidInFullCycles?: InputMaybe<Scalars['Float']['input']>
  serviceTemplateId: Scalars['ID']['input']
  startDate: Scalars['String']['input']
}

/** Staff reason for letting a client visit although they owe at a location of a brand that blocks on debt anywhere */
export interface OwedBalanceOverrideInput {
  reason: Scalars['String']['input']
}

export interface PaginationInput {
  cursor?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Float']['input']>
  offset?: InputMaybe<Scalars['Float']['input']>
  page?: InputMaybe<Scalars['Float']['input']>
  pageSize?: InputMaybe<Scalars['Float']['input']>
}

export interface PaperPolicyFormSlotInput {
  policyRevisionId: Scalars['ID']['input']
  signedOn: Scalars['String']['input']
  signerCapacity: SignerCapacity
  signerId: Scalars['ID']['input']
  signerName: Scalars['String']['input']
}

/** Whether the email provider accepted the payment approval email */
export enum PaymentApprovalDeliveryState {
  failed = 'failed',
  sent = 'sent',
  unknown = 'unknown',
}

/** State of the approval link emailed for a held payment */
export enum PaymentApprovalLinkState {
  active = 'active',
  expired = 'expired',
  none = 'none',
}

/** State of a dispute */
export enum PaymentDisputeState {
  Lost = 'Lost',
  None = 'None',
  Open = 'Open',
  Won = 'Won',
}

/** Why failover was skipped or stopped for a payment */
export enum PaymentFallbackReason {
  BackupAttemptExhausted = 'BackupAttemptExhausted',
  BackupCardsExhausted = 'BackupCardsExhausted',
  BackupNoLongerEligible = 'BackupNoLongerEligible',
  CardIneligible = 'CardIneligible',
  FailoverDisabled = 'FailoverDisabled',
  FraudCategoryBlock = 'FraudCategoryBlock',
  GatewayUnsupported = 'GatewayUnsupported',
  NoCardAvailable = 'NoCardAvailable',
  PrimaryNotBank = 'PrimaryNotBank',
}

/** Where a payment sits in the bank-decline failover cascade */
export enum PaymentFallbackState {
  Attempted = 'Attempted',
  Exhausted = 'Exhausted',
  Recovered = 'Recovered',
  Scheduled = 'Scheduled',
  Skipped = 'Skipped',
}

export enum PaymentGateway {
  EZYPAY = 'EZYPAY',
  FAT_ZEBRA = 'FAT_ZEBRA',
  MIDTRANS = 'MIDTRANS',
  SPHERE = 'SPHERE',
  STRIPE = 'STRIPE',
  STRIPE_CONNECT = 'STRIPE_CONNECT',
}

/** Status of a payment gateway transaction attempt */
export enum PaymentGatewayTransactionStatus {
  Canceled = 'Canceled',
  Failed = 'Failed',
  Processing = 'Processing',
  RequiresAction = 'RequiresAction',
  Success = 'Success',
}

/** Billing-obligation category that blocks removing a client payment method (OC-657) */
export enum PaymentMethodRemovalBlockReason {
  ACTIVE_PACKAGE_OR_MEMBERSHIP = 'ACTIVE_PACKAGE_OR_MEMBERSHIP',
  OUTSTANDING_FEE_OR_FAILED_PAYMENT = 'OUTSTANDING_FEE_OR_FAILED_PAYMENT',
  PENDING_BANK_APPROVAL = 'PENDING_BANK_APPROVAL',
  UPCOMING_BILLING_OR_SCHEDULED_INVOICE = 'UPCOMING_BILLING_OR_SCHEDULED_INVOICE',
}

/** Type of a payment method */
export enum PaymentMethodType {
  AccountCredit = 'AccountCredit',
  Bank = 'Bank',
  Card = 'Card',
  Cash = 'Cash',
  Custom = 'Custom',
  LocationTransfer = 'LocationTransfer',
  Terminal = 'Terminal',
}

export enum PaymentMode {
  ANY = 'ANY',
  BANK_ONLY = 'BANK_ONLY',
  CREDIT_CARD_ONLY = 'CREDIT_CARD_ONLY',
}

/** Current state of a payment that was held for remote 3DS approval */
export enum PaymentRecoveryState {
  expired = 'expired',
  failed = 'failed',
  held = 'held',
  succeeded = 'succeeded',
  with_staff = 'with_staff',
}

/** Charge-routing transport for a corporate: legacy queues or gateway-keyed queues */
export enum PaymentRoutingMode {
  GatewayQueues = 'GatewayQueues',
  Legacy = 'Legacy',
}

/** Status of a payment */
export enum PaymentStatus {
  Canceled = 'Canceled',
  Failed = 'Failed',
  PartiallyRefunded = 'PartiallyRefunded',
  Pending = 'Pending',
  Processing = 'Processing',
  Refunded = 'Refunded',
  Success = 'Success',
}

/** Payment status values for filtering and displaying client bookings */
export enum PaymentStatusFilter {
  failed = 'failed',
  paid = 'paid',
  partially_refunded = 'partially_refunded',
  pending = 'pending',
  processing = 'processing',
  refunded = 'refunded',
}

/** Device wallet a card was collected through */
export enum PaymentWallet {
  ApplePay = 'ApplePay',
  GooglePay = 'GooglePay',
}

/** How a corporate's sites sequence their nightly payments steps: legacy schedulers, shadow (tree built, steps no-op) or flow (tree authoritative) */
export enum PaymentsPipelineMode {
  Flow = 'Flow',
  Legacy = 'Legacy',
  Shadow = 'Shadow',
}

export enum PayrollAdditionalTypes {
  lateCancel = 'lateCancel',
  noShow = 'noShow',
}

export enum PayrollTierType {
  SESSION_TYPE = 'SESSION_TYPE',
  TIME_CLOCK = 'TIME_CLOCK',
}

export enum PayrollType {
  FLAT_AND_PER_CLIENT_BONUS_PLUS_FULL_CLASS_BONUS = 'FLAT_AND_PER_CLIENT_BONUS_PLUS_FULL_CLASS_BONUS',
  FLAT_RATE = 'FLAT_RATE',
  FLAT_RATE_AND_FLAT_BONUS = 'FLAT_RATE_AND_FLAT_BONUS',
  FLAT_RATE_AND_PER_CLIENT_BONUS = 'FLAT_RATE_AND_PER_CLIENT_BONUS',
  HOURLY_RATE = 'HOURLY_RATE',
  PERCENTAGE_PER_CREDIT_DIVIDED_BY_AMOUNT_PAID = 'PERCENTAGE_PER_CREDIT_DIVIDED_BY_AMOUNT_PAID',
  PERCENTAGE_PER_CREDIT_DIVIDED_BY_AMOUNT_PAID_PLUS_UNLIMITED_FIXED_RATE = 'PERCENTAGE_PER_CREDIT_DIVIDED_BY_AMOUNT_PAID_PLUS_UNLIMITED_FIXED_RATE',
  PER_HEAD = 'PER_HEAD',
  PER_HEAD_AND_FLAT_BONUS = 'PER_HEAD_AND_FLAT_BONUS',
  PER_HEAD_AND_PER_CLIENT_BONUS = 'PER_HEAD_AND_PER_CLIENT_BONUS',
}

export enum PendingChangeType {
  AddOnCancellation = 'AddOnCancellation',
  Cancellation = 'Cancellation',
  PlanChange = 'PlanChange',
  Suspension = 'Suspension',
}

/** Which capability completes a pending item: this link, or the agreement or form link it hands off to */
export enum PendingItemHandoffCapability {
  AGREEMENT_SIGN = 'AGREEMENT_SIGN',
  FORM_FILL = 'FORM_FILL',
  PENDING_ITEMS = 'PENDING_ITEMS',
}

/** The kind of obligation a pending item stands for */
export enum PendingItemKind {
  AGE_VERIFICATION = 'AGE_VERIFICATION',
  PROFILE_FIELDS = 'PROFILE_FIELDS',
  SERVICE_AGREEMENT = 'SERVICE_AGREEMENT',
  SITE_FORM = 'SITE_FORM',
  SITE_POLICY = 'SITE_POLICY',
  SKIN_TYPE_FORM = 'SKIN_TYPE_FORM',
}

/** Why an automatic or bulk pending-items text was not sent to a client */
export enum PendingItemsAutoSendSkipReason {
  ALREADY_SENT_TODAY = 'ALREADY_SENT_TODAY',
  CANCELLED = 'CANCELLED',
  CLIENT_NOT_AT_SITE = 'CLIENT_NOT_AT_SITE',
  GUARDIAN_IN_PERSON_ONLY = 'GUARDIAN_IN_PERSON_ONLY',
  GUARDIAN_REQUIRED = 'GUARDIAN_REQUIRED',
  HANDOFF_IN_PROGRESS = 'HANDOFF_IN_PROGRESS',
  NOTHING_PENDING = 'NOTHING_PENDING',
  NO_TEXT_CONSENT = 'NO_TEXT_CONSENT',
  NO_VALID_MOBILE = 'NO_VALID_MOBILE',
  OVER_CAP = 'OVER_CAP',
  RATE_LIMITED = 'RATE_LIMITED',
  REFUSED = 'REFUSED',
  SETTING_OFF = 'SETTING_OFF',
}

/** How a pending-items handoff reaches its signer */
export enum PendingItemsChannel {
  APP = 'APP',
  DESK = 'DESK',
  KIOSK = 'KIOSK',
  QR = 'QR',
  SMS = 'SMS',
}

/** Lifecycle of a pending-items handoff */
export enum PendingItemsHandoffStatus {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  CREATED = 'CREATED',
  DELIVERED = 'DELIVERED',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  LOCKED = 'LOCKED',
  OPENED = 'OPENED',
  SENT = 'SENT',
  SUPERSEDED = 'SUPERSEDED',
}

/** canceled = stopped at the gateway before it settled; already_settled = the gateway had already resolved it, so nothing was cancelled */
export enum PendingPaymentCancellationOutcome {
  already_settled = 'already_settled',
  canceled = 'canceled',
}

/** Why staff cancelled an in-flight payment */
export enum PendingPaymentCancellationReason {
  charged_in_error = 'charged_in_error',
  duplicate_payment = 'duplicate_payment',
  member_disputed = 'member_disputed',
  membership_cancelled = 'membership_cancelled',
  other = 'other',
}

export enum PeriodOfTime {
  DAYS = 'DAYS',
  HOURS = 'HOURS',
  MINUTES = 'MINUTES',
  MONTHS = 'MONTHS',
  WEEKS = 'WEEKS',
  days = 'days',
  hours = 'hours',
  minutes = 'minutes',
  months = 'months',
  weeks = 'weeks',
}

/** PII classification level for report columns */
export enum PiiClassification {
  behavioural_attributed = 'behavioural_attributed',
  date_of_birth = 'date_of_birth',
  demographic = 'demographic',
  direct_contact = 'direct_contact',
  financial_identifier = 'financial_identifier',
  health = 'health',
  none = 'none',
  person_name = 'person_name',
}

export enum PlanChangeDirection {
  CURRENT = 'CURRENT',
  DOWNGRADE = 'DOWNGRADE',
  UPGRADE = 'UPGRADE',
}

/** How a client accepts a site policy revision */
export enum PolicyAcceptanceMethod {
  CHECKBOX = 'CHECKBOX',
  SIGNATURE = 'SIGNATURE',
}

/** Whether a policy acceptance counts towards readiness, and why not */
export enum PolicyAcceptanceState {
  CAPACITY_MISMATCH = 'CAPACITY_MISMATCH',
  COUNTED = 'COUNTED',
  DUPLICATE = 'DUPLICATE',
  REVOKED = 'REVOKED',
  UNVERIFIED_HISTORICAL = 'UNVERIFIED_HISTORICAL',
  VOIDED = 'VOIDED',
  WITHDRAWN = 'WITHDRAWN',
}

/** Lifecycle of a bulk pending-items send from the compliance report */
export enum PolicyBulkSendStatus {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  QUEUED = 'QUEUED',
  RUNNING = 'RUNNING',
}

/** The equipment policy settings to change; omitted fields keep their saved value */
export interface PolicyComplianceSettingsInput {
  allowQueueBeforePoliciesSigned?: InputMaybe<Scalars['Boolean']['input']>
  allowRemoteGuardianSigning?: InputMaybe<Scalars['Boolean']['input']>
  autoSendPendingItemsLink?: InputMaybe<Scalars['Boolean']['input']>
  eSignConsentProfile?: InputMaybe<ESignConsentProfile>
  guardianConsentAge?: InputMaybe<Scalars['Float']['input']>
  pendingItemsLinkTtlHours?: InputMaybe<Scalars['Float']['input']>
  renewalReminderDays?: InputMaybe<Scalars['Float']['input']>
  sendOnHomeLocationChange?: InputMaybe<Scalars['Boolean']['input']>
  sendOnPlanPurchase?: InputMaybe<Scalars['Boolean']['input']>
  sendPushForPendingPolicies?: InputMaybe<Scalars['Boolean']['input']>
}

/** Equipment category a policy or jurisdiction rule covers; an empty scope means all */
export enum PolicyEquipmentScope {
  RED_LIGHT = 'RED_LIGHT',
  SPA = 'SPA',
  SPRAY = 'SPRAY',
  UNCATEGORISED = 'UNCATEGORISED',
  UV = 'UV',
  WELLNESS = 'WELLNESS',
}

/** Lifecycle of a bulk policy evidence export */
export enum PolicyEvidenceExportStatus {
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  READY = 'READY',
  REVOKED = 'REVOKED',
}

/** Lifecycle of an immutable site policy revision */
export enum PolicyRevisionStatus {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  HISTORICAL = 'HISTORICAL',
  SCHEDULED = 'SCHEDULED',
  SUPERSEDED = 'SUPERSEDED',
}

/** Who must sign a policy when the participant is a minor */
export enum PolicySignerRule {
  BOTH_IF_MINOR = 'BOTH_IF_MINOR',
  CLIENT = 'CLIENT',
  GUARDIAN_IF_MINOR = 'GUARDIAN_IF_MINOR',
}

export enum PosActivityCategory {
  creation = 'creation',
  modification = 'modification',
  status_change = 'status_change',
  stock = 'stock',
}

export enum PosActivityType {
  product_archived = 'product_archived',
  product_created = 'product_created',
  product_updated = 'product_updated',
  stock_adjusted = 'stock_adjusted',
  variant_added = 'variant_added',
  variant_deleted = 'variant_deleted',
  variant_updated = 'variant_updated',
}

export enum PosCategoryStatus {
  active = 'active',
  inactive = 'inactive',
}

export enum PosProductStatus {
  active = 'active',
  archived = 'archived',
  deleted = 'deleted',
}

/** Input for creating a product variant attribute */
export interface PosProductVariableAttributeInput {
  attributeName: Scalars['String']['input']
  attributeValue: Scalars['String']['input']
  displayOrder?: InputMaybe<Scalars['Int']['input']>
}

/** Input for creating a product variant with attributes */
export interface PosProductVariableInput {
  attributes: Array<PosProductVariableAttributeInput>
  barcode?: InputMaybe<Scalars['String']['input']>
  cost?: InputMaybe<Scalars['String']['input']>
  currentStock?: InputMaybe<Scalars['Int']['input']>
  isDefault: Scalars['Boolean']['input']
  isEnabledForSale: Scalars['Boolean']['input']
  isFeatured: Scalars['Boolean']['input']
  maxStockLevel?: InputMaybe<Scalars['Int']['input']>
  minStockLevel?: InputMaybe<Scalars['Int']['input']>
  price: Scalars['String']['input']
  sku?: InputMaybe<Scalars['String']['input']>
  sortOrder: Scalars['Int']['input']
  taxSettingIds?: InputMaybe<Array<Scalars['ID']['input']>>
  trackStock: Scalars['Boolean']['input']
  variableName: Scalars['String']['input']
}

export enum PosStockAdjusmentType {
  damage = 'damage',
  inventory_recount = 'inventory_recount',
  loss = 'loss',
  restock_return = 'restock_return',
  sale = 'sale',
  stock_received = 'stock_received',
  theft = 'theft',
  transfer = 'transfer',
}

export enum PresaleShortfallAction {
  Absorb = 'Absorb',
  Charge = 'Charge',
}

/** Input for pricing a candidate pre-sale opening-date move without applying it. */
export interface PreviewPresaleDateShiftInput {
  invoiceDate: Scalars['String']['input']
  invoiceId: Scalars['ID']['input']
}

/** One pause to quote. startDate is required here even though creation defaults it, because a preview must state which day it priced. */
export interface PreviewSuspensionPlanPauseInput {
  chargeAmount?: InputMaybe<Scalars['String']['input']>
  chargeMode?: InputMaybe<ServiceSuspensionChargeMode>
  endDate?: InputMaybe<Scalars['String']['input']>
  feeBillingCycleAmount?: InputMaybe<Scalars['Float']['input']>
  feeBillingCycleUnit?: InputMaybe<Scalars['String']['input']>
  startDate: Scalars['String']['input']
  suspensionType?: InputMaybe<ServiceSuspensionType>
}

/** Input for creating a private session from template and booking the client atomically */
export interface PrivateBookingCreateInput {
  bookedByClientId?: InputMaybe<Scalars['String']['input']>
  bookingSource?: InputMaybe<BookingSource>
  clientId: Scalars['String']['input']
  date: Scalars['String']['input']
  forFamilyMember?: InputMaybe<Scalars['Boolean']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  owedBalanceOverride?: InputMaybe<OwedBalanceOverrideInput>
  serviceId?: InputMaybe<Scalars['String']['input']>
  sessionTemplateId: Scalars['String']['input']
  /** Shared package to pay from: the family package allocated to the member on a family booking, or a package shared with the client on a self booking */
  sharedServiceId?: InputMaybe<Scalars['String']['input']>
  staffUserIds?: InputMaybe<Array<Scalars['String']['input']>>
  startTime: Scalars['String']['input']
}

export enum ProcessCSVImportStatus {
  ERROR = 'ERROR',
  PARSING = 'PARSING',
}

export enum ProcessZIPImportStatus {
  PARSING = 'PARSING',
}

export enum ProductPlanTier {
  basic = 'basic',
  premium = 'premium',
  pro = 'pro',
}

/** Input for creating a new promo code */
export interface PromoCodeCreateInput {
  clientUseLimit?: InputMaybe<Scalars['Float']['input']>
  code: Scalars['String']['input']
  discountType: PromoCodeDiscountType
  discountValue: Scalars['Numeric']['input']
  endDate?: InputMaybe<Scalars['String']['input']>
  globalUseLimit?: InputMaybe<Scalars['Float']['input']>
  isAvailableAfterIntroOffer: Scalars['Boolean']['input']
  isAvailableBeforeIntroOffer: Scalars['Boolean']['input']
  isAvailableForOnlineSale: Scalars['Boolean']['input']
  isDiscountFutureInvoices: Scalars['Boolean']['input']
  membershipIds: Array<Scalars['ID']['input']>
  name: Scalars['String']['input']
  packageIds: Array<Scalars['ID']['input']>
  productIds: Array<Scalars['ID']['input']>
  startDate: Scalars['String']['input']
}

/** Type of discount applied by promo code */
export enum PromoCodeDiscountType {
  fixed = 'fixed',
  percentage = 'percentage',
}

/** Input for duplicating a promo code */
export interface PromoCodeDuplicateInput {
  newCode: Scalars['String']['input']
  newName?: InputMaybe<Scalars['String']['input']>
}

/** The kind of item a promo code is being applied to */
export enum PromoCodeItemType {
  MEMBERSHIP = 'MEMBERSHIP',
  PACKAGE = 'PACKAGE',
  PRODUCT = 'PRODUCT',
}

/** Sort options for promo code list queries */
export interface PromoCodeSort {
  direction: SortDirection
  field: PromoCodeSortFields
}

/** Fields for sorting promo code list queries */
export enum PromoCodeSortFields {
  Code = 'Code',
  CreatedAt = 'CreatedAt',
  EndDate = 'EndDate',
  Name = 'Name',
  StartDate = 'StartDate',
  UpdatedAt = 'UpdatedAt',
}

/** Status of a promo code */
export enum PromoCodeStatus {
  active = 'active',
  archived = 'archived',
}

/** Input for updating an existing promo code */
export interface PromoCodeUpdateInput {
  clientUseLimit?: InputMaybe<Scalars['Float']['input']>
  code?: InputMaybe<Scalars['String']['input']>
  discountType?: InputMaybe<PromoCodeDiscountType>
  discountValue?: InputMaybe<Scalars['Numeric']['input']>
  endDate?: InputMaybe<Scalars['String']['input']>
  globalUseLimit?: InputMaybe<Scalars['Float']['input']>
  isAvailableAfterIntroOffer?: InputMaybe<Scalars['Boolean']['input']>
  isAvailableBeforeIntroOffer?: InputMaybe<Scalars['Boolean']['input']>
  isAvailableForOnlineSale?: InputMaybe<Scalars['Boolean']['input']>
  isDiscountFutureInvoices?: InputMaybe<Scalars['Boolean']['input']>
  membershipIds?: InputMaybe<Array<Scalars['ID']['input']>>
  name?: InputMaybe<Scalars['String']['input']>
  packageIds?: InputMaybe<Array<Scalars['ID']['input']>>
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>
  startDate?: InputMaybe<Scalars['String']['input']>
}

/** Promo code ID for tracking usage after payment */
export interface PromoCodeUsageInput {
  promoCodeId: Scalars['ID']['input']
}

/** Input for validating promo code usage */
export interface PromoCodeValidationInput {
  beneficiaryId?: InputMaybe<Scalars['ID']['input']>
  clientId?: InputMaybe<Scalars['ID']['input']>
  code: Scalars['String']['input']
  isOnlineSale?: InputMaybe<Scalars['Boolean']['input']>
  itemId?: InputMaybe<Scalars['ID']['input']>
  itemType?: InputMaybe<PromoCodeItemType>
}

export interface ProspectInput {
  email: Scalars['String']['input']
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  role?: InputMaybe<Scalars['String']['input']>
}

export enum PublicApiLogLevel {
  full = 'full',
  metadata = 'metadata',
  request = 'request',
}

/** Payment method kind used to settle an agreement-gated invoice after signing */
export enum PublicSigningPaymentMethodType {
  bank = 'bank',
  card = 'card',
}

/** Save & publish on a live brand add-on: the form with its locations, the changes chosen from it, and whether a credit change reaches existing clients or only new purchases. A change of locations always applies: an added location gets the add-on, a removed one has it withdrawn. */
export interface PublishCorporateAddOnChangesInput {
  assignedSiteGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>
  assignedSiteIds?: InputMaybe<Array<Scalars['ID']['input']>>
  config: BrandAddOnConfigInput
  corporateServiceTemplateId: Scalars['ID']['input']
  expectedVersion: Scalars['Float']['input']
  isAllLocations: Scalars['Boolean']['input']
  lockedSections?: InputMaybe<Array<BrandServiceTemplateSection>>
  memberImpact: BrandServiceTemplateMemberImpact
  selectedGroupKeys: Array<Scalars['String']['input']>
}

export enum PushProvider {
  hapana = 'hapana',
  onesignal = 'onesignal',
}

/** Ranking direction — DESC (higher is better) or ASC (lower is better) */
export enum RankingDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

/** FOB reader protocol configured on the access point device */
export enum ReaderType {
  TECOM = 'TECOM',
  WIEGAND = 'WIEGAND',
}

/** When an obligation falls due: now, as a renewal of a counted acceptance, or when a scheduled revision takes effect */
export enum ReadinessItemTiming {
  DUE_NOW = 'DUE_NOW',
  RENEWAL = 'RENEWAL',
  SCHEDULED = 'SCHEDULED',
}

/** Why a readiness dimension fails or an item is outstanding */
export enum ReadinessReasonCode {
  AGE_PROHIBITED = 'AGE_PROHIBITED',
  AGE_VERIFICATION_REQUIRED = 'AGE_VERIFICATION_REQUIRED',
  CAPACITY_MISMATCH = 'CAPACITY_MISMATCH',
  ELIGIBILITY_UNAVAILABLE = 'ELIGIBILITY_UNAVAILABLE',
  GUARDIAN_PRESENCE_REQUIRED = 'GUARDIAN_PRESENCE_REQUIRED',
  IDEMPOTENCY_CONFLICT = 'IDEMPOTENCY_CONFLICT',
  MEDICAL_AUTHORIZATION_UNSUPPORTED = 'MEDICAL_AUTHORIZATION_UNSUPPORTED',
  OPERATIONAL_BLOCKED = 'OPERATIONAL_BLOCKED',
  POLICIES_NOT_ACCEPTED = 'POLICIES_NOT_ACCEPTED',
  POLICY_VERSION_CHANGED = 'POLICY_VERSION_CHANGED',
  RENEWAL_EXPIRED = 'RENEWAL_EXPIRED',
  SKIN_TYPE_DUE = 'SKIN_TYPE_DUE',
  SKIN_TYPE_MISSING = 'SKIN_TYPE_MISSING',
}

/** Result of one readiness dimension */
export enum ReadinessStatus {
  FAIL = 'FAIL',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  PASS = 'PASS',
}

/** Reason for not being auto retryable */
export enum ReasonsNotAutoRetryable {
  AgreementRequired = 'AgreementRequired',
  BackupAttemptExhausted = 'BackupAttemptExhausted',
  ManualPayment = 'ManualPayment',
  MaxAutoRetryAttemptsReached = 'MaxAutoRetryAttemptsReached',
  NonRecoverableFailure = 'NonRecoverableFailure',
  OrphanedDispatchHeldForReview = 'OrphanedDispatchHeldForReview',
  PaymentNotFailed = 'PaymentNotFailed',
  RetryDisabled = 'RetryDisabled',
  StrandedSuccessHeldForReview = 'StrandedSuccessHeldForReview',
  Superseded = 'Superseded',
}

export interface RebateTemplateFeesInput {
  enabled: Scalars['Boolean']['input']
  feeId: Scalars['ID']['input']
  rate: Scalars['Numeric']['input']
}

/** Input for creating a rebate template */
export interface RebateTemplateInput {
  corporatePayoutAccountId: Scalars['ID']['input']
  fees?: InputMaybe<Array<RebateTemplateFeesInput>>
  name: Scalars['String']['input']
}

export enum RebateTemplateOrderBy {
  createdAt = 'createdAt',
  name = 'name',
  updatedAt = 'updatedAt',
}

/** Input for updating a rebate template */
export interface RebateTemplateUpdate {
  corporatePayoutAccountId?: InputMaybe<Scalars['ID']['input']>
  fees?: InputMaybe<Array<RebateTemplateFeesInput>>
  name?: InputMaybe<Scalars['String']['input']>
}

export interface RebateTemplatesOrderByInput {
  column: RebateTemplateOrderBy
  direction: OrderByDirection
}

export interface RecalculateClientSiteAggregatesInputInput {
  siteIds: Array<Scalars['String']['input']>
}

/** Recurrence pattern types for recurring sessions */
export enum RecurrenceType {
  Daily = 'Daily',
  Monthly = 'Monthly',
  Weekly = 'Weekly',
}

/** Fields available for ordering recurring invoice listings */
export enum RecurringInvoiceOrderBy {
  amount = 'amount',
  createdAt = 'createdAt',
  invoiceDate = 'invoiceDate',
}

export enum RecurringInvoiceStatus {
  Active = 'Active',
  Canceled = 'Canceled',
  Suspended = 'Suspended',
}

export enum RecurringInvoiceType {
  SecondaryFee = 'SecondaryFee',
  ServicePayment = 'ServicePayment',
  SuspensionFee = 'SuspensionFee',
}

/** Input for creating a recurring session pattern from a template */
export interface RecurringSessionCreateFromTemplateInput {
  durationMinutes?: InputMaybe<Scalars['Float']['input']>
  endAfterOccurrences?: InputMaybe<Scalars['Float']['input']>
  endDate?: InputMaybe<Scalars['String']['input']>
  endTime?: InputMaybe<Scalars['String']['input']>
  isRoomResourceEnabled?: InputMaybe<Scalars['Boolean']['input']>
  lateCancelFeeId?: InputMaybe<Scalars['String']['input']>
  lateCancelFeeMode?: InputMaybe<SessionFeeMode>
  noShowFeeId?: InputMaybe<Scalars['String']['input']>
  noShowFeeMode?: InputMaybe<SessionFeeMode>
  recurrenceDayOfMonth?: InputMaybe<Scalars['Float']['input']>
  recurrenceDaysOfWeek?: InputMaybe<Array<DayOfWeek>>
  recurrenceInterval: Scalars['Float']['input']
  recurrenceType: RecurrenceType
  revenueTagId?: InputMaybe<Scalars['String']['input']>
  sessionTemplateId: Scalars['String']['input']
  siteId: Scalars['String']['input']
  siteLocationId?: InputMaybe<Scalars['String']['input']>
  siteLocationRoomId?: InputMaybe<Scalars['String']['input']>
  size?: InputMaybe<Scalars['Float']['input']>
  staffUserIds?: InputMaybe<Array<Scalars['String']['input']>>
  startDate: Scalars['String']['input']
  startTime: Scalars['String']['input']
  status?: InputMaybe<RecurringSessionStatus>
}

/** Input for creating a recurring session pattern */
export interface RecurringSessionCreateInput {
  allowOverlappingSessions?: InputMaybe<Scalars['Boolean']['input']>
  category: SessionCategory
  creditsRequired: Scalars['Float']['input']
  customFields?: InputMaybe<Array<SessionTemplateCustomFieldsInput>>
  description?: InputMaybe<Scalars['String']['input']>
  dropinPrice: Scalars['Numeric']['input']
  durationMinutes: Scalars['Float']['input']
  endAfterOccurrences?: InputMaybe<Scalars['Float']['input']>
  endDate?: InputMaybe<Scalars['String']['input']>
  endTime: Scalars['String']['input']
  isPaymentRequired: Scalars['Boolean']['input']
  isRequestBookingEnabled: Scalars['Boolean']['input']
  isRequiredSessionFeedback: Scalars['Boolean']['input']
  isRequiredTwoPartAuthentication: Scalars['Boolean']['input']
  isRoomResourceEnabled?: InputMaybe<Scalars['Boolean']['input']>
  itemsSupplied?: InputMaybe<Scalars['String']['input']>
  itemsToBring?: InputMaybe<Scalars['String']['input']>
  lateCancelFeeId?: InputMaybe<Scalars['String']['input']>
  lateCancelFeeMode?: InputMaybe<SessionFeeMode>
  name: Scalars['String']['input']
  noShowFeeId?: InputMaybe<Scalars['String']['input']>
  noShowFeeMode?: InputMaybe<SessionFeeMode>
  recurrenceDayOfMonth?: InputMaybe<Scalars['Float']['input']>
  recurrenceDaysOfWeek?: InputMaybe<Array<DayOfWeek>>
  recurrenceInterval: Scalars['Float']['input']
  recurrenceType: RecurrenceType
  revenueTagId?: InputMaybe<Scalars['String']['input']>
  rootRecurringSessionsId?: InputMaybe<Scalars['String']['input']>
  sessionImage?: InputMaybe<SessionTemplateSessionImageInput>
  sessionTemplateId?: InputMaybe<Scalars['String']['input']>
  siteId: Scalars['String']['input']
  siteLocationId: Scalars['String']['input']
  siteLocationRoomId?: InputMaybe<Scalars['String']['input']>
  siteSessionTypeId: Scalars['String']['input']
  size: Scalars['Float']['input']
  staffUserIds?: InputMaybe<Array<Scalars['String']['input']>>
  startDate: Scalars['String']['input']
  startTime: Scalars['String']['input']
  status: RecurringSessionStatus
  taxEnabled: Scalars['Boolean']['input']
  taxSettingIds?: InputMaybe<Array<Scalars['String']['input']>>
  waitlistEnabled: Scalars['Boolean']['input']
  waitlistSize?: InputMaybe<Scalars['Float']['input']>
}

/** Scope for editing recurring session occurrences */
export enum RecurringSessionEditScope {
  Single = 'Single',
  ThisAndFuture = 'ThisAndFuture',
}

/** Status types for recurring sessions */
export enum RecurringSessionStatus {
  Active = 'Active',
  Inactive = 'Inactive',
}

/** Redirect after package payment options */
export enum RedirectAfterPackagePayment {
  CHECKOUT = 'CHECKOUT',
  CLASSES = 'CLASSES',
  DASHBOARD = 'DASHBOARD',
  PACKAGES = 'PACKAGES',
}

/** How often rankings are recomputed */
export enum RefreshFrequency {
  DAILY = 'DAILY',
  HOURLY = 'HOURLY',
  MANUAL = 'MANUAL',
}

/** How a refund was split across the invoice items it returned */
export enum RefundAllocationMethod {
  BackfillFeeFirst = 'BackfillFeeFirst',
  BackfillProRata = 'BackfillProRata',
  FeeFirst = 'FeeFirst',
  ProRata = 'ProRata',
}

/** Origin of a refund */
export enum RefundOrigin {
  DisputeLost = 'DisputeLost',
  Operational = 'Operational',
}

/** Full-list replacement of a site’s configured refund reasons. */
export interface RefundReasonsBulkUpdateInput {
  refundReasons: Array<RefundReasonsBulkUpdateRefundReasonsInput>
}

export interface RefundReasonsBulkUpdateRefundReasonsInput {
  createdAt?: InputMaybe<Scalars['String']['input']>
  enabled: Scalars['Boolean']['input']
  id?: InputMaybe<Scalars['String']['input']>
  reason: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

/** Status of a refund */
export enum RefundStatus {
  Completed = 'Completed',
  Failed = 'Failed',
  Pending = 'Pending',
}

/** Type of a refund */
export enum RefundType {
  AccountCredit = 'AccountCredit',
  Cash = 'Cash',
  Gateway = 'Gateway',
  LocationTransfer = 'LocationTransfer',
}

/** Customer-paid gateway fee that a refund can return in full */
export enum RefundableGatewayFeeCode {
  FailedPaymentFee = 'FailedPaymentFee',
  LoadFee = 'LoadFee',
  TransactionFee = 'TransactionFee',
}

/** Input for registering a device token for push notifications */
export interface RegisterDeviceTokenInput {
  appVersion?: InputMaybe<Scalars['String']['input']>
  deviceInfo?: InputMaybe<Scalars['String']['input']>
  deviceToken: Scalars['String']['input']
  platform: DevicePlatform
}

/** Input for registering a custom email domain */
export interface RegisterDomainInput {
  customReturnPath?: InputMaybe<Scalars['String']['input']>
  domain: Scalars['String']['input']
  fromLocalPart: Scalars['String']['input']
  region?: InputMaybe<Scalars['String']['input']>
}

export interface ReinitiateIncomingMovementInput {
  destinationServiceTemplateId?: InputMaybe<Scalars['ID']['input']>
  memberMovementId: Scalars['ID']['input']
}

/** Why a staff-cancelled invoice cannot be reinstated */
export enum ReinstateBlockedReason {
  AgreementRevoked = 'AgreementRevoked',
  CreatedService = 'CreatedService',
  HasProducts = 'HasProducts',
  ParentInactive = 'ParentInactive',
  ParentPaused = 'ParentPaused',
  PausedSinceCancel = 'PausedSinceCancel',
  PlanChange = 'PlanChange',
  SuspensionCredit = 'SuspensionCredit',
}

/** An invoice to reinstate, with a new date when its original date has passed */
export interface ReinstateInvoiceInput {
  invoiceId: Scalars['ID']['input']
  newDueDate?: InputMaybe<Scalars['String']['input']>
}

export enum ReleaseHubAvailabilityKind {
  AVAILABLE = 'AVAILABLE',
  COMING_SOON = 'COMING_SOON',
  CONTACT_US = 'CONTACT_US',
  UPGRADE = 'UPGRADE',
}

export enum ReleaseHubScope {
  BOTH = 'BOTH',
  BRAND = 'BRAND',
  LOCATION = 'LOCATION',
}

export enum ReleaseHubStage {
  COMING_SOON = 'COMING_SOON',
  PULLED = 'PULLED',
  RELEASED = 'RELEASED',
}

export enum ReleaseHubType {
  FEATURE = 'FEATURE',
  FIX = 'FIX',
  IMPROVEMENT = 'IMPROVEMENT',
}

export interface ReleaseNoteCreateInput {
  contentMarkdown: Scalars['String']['input']
  permissionTags?: InputMaybe<Array<Scalars['String']['input']>>
  releaseType: ReleaseNoteType
  roleTags?: InputMaybe<Array<Scalars['String']['input']>>
  slug: Scalars['String']['input']
  status?: InputMaybe<ReleaseNoteStatus>
  summary?: InputMaybe<Scalars['String']['input']>
  tags?: InputMaybe<Array<Scalars['String']['input']>>
  tierTags?: InputMaybe<Array<Scalars['String']['input']>>
  title: Scalars['String']['input']
  version?: InputMaybe<Scalars['String']['input']>
}

export interface ReleaseNoteFilterInput {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>
  permissionTags?: InputMaybe<Array<Scalars['String']['input']>>
  releaseType?: InputMaybe<ReleaseNoteType>
  roleTags?: InputMaybe<Array<Scalars['String']['input']>>
  search?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<ReleaseNoteStatus>
  tags?: InputMaybe<Array<Scalars['String']['input']>>
  tierTags?: InputMaybe<Array<Scalars['String']['input']>>
}

export enum ReleaseNoteStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
}

export interface ReleaseNoteTranslationInput {
  contentMarkdown: Scalars['String']['input']
  locale: Scalars['String']['input']
  summary?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
}

export enum ReleaseNoteTranslationStatus {
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  TRANSLATED = 'TRANSLATED',
}

export enum ReleaseNoteType {
  BREAKING_CHANGE = 'BREAKING_CHANGE',
  BUG_FIX = 'BUG_FIX',
  ENHANCEMENT = 'ENHANCEMENT',
  FEATURE = 'FEATURE',
}

export interface ReleaseNoteUpdateInput {
  contentMarkdown?: InputMaybe<Scalars['String']['input']>
  permissionTags?: InputMaybe<Array<Scalars['String']['input']>>
  releaseType?: InputMaybe<ReleaseNoteType>
  roleTags?: InputMaybe<Array<Scalars['String']['input']>>
  slug?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<ReleaseNoteStatus>
  summary?: InputMaybe<Scalars['String']['input']>
  tags?: InputMaybe<Array<Scalars['String']['input']>>
  tierTags?: InputMaybe<Array<Scalars['String']['input']>>
  title?: InputMaybe<Scalars['String']['input']>
  version?: InputMaybe<Scalars['String']['input']>
}

/** released = the attempt was cancelled at the gateway; recovered = the gateway had already settled it; not_found = nothing was in flight */
export enum ReleaseTerminalPaymentOutcome {
  not_found = 'not_found',
  recovered = 'recovered',
  released = 'released',
}

export enum ReleaseType {
  ROLLING = 'ROLLING',
  TIMED = 'TIMED',
  rolling = 'rolling',
  timed = 'timed',
}

export interface RemapMemberMovementsLikeForLikeInput {
  corporateId: Scalars['ID']['input']
  destinationServiceTemplateId: Scalars['ID']['input']
  persistMapping?: InputMaybe<Scalars['Boolean']['input']>
  runId: Scalars['ID']['input']
  sourceMovementId: Scalars['ID']['input']
}

/** Input for an owner removing a recipient from their own shared package */
export interface RemoveMySharedCreditRecipientInput {
  recipientClientId: Scalars['ID']['input']
  serviceId: Scalars['ID']['input']
}

/** Input for reordering a single corporate FAQ */
export interface ReorderCorporateFaqInput {
  corporateFaqId: Scalars['String']['input']
  displayOrder: Scalars['Float']['input']
}

/** Input containing array of FAQs with new display orders */
export interface ReorderCorporateFaqsInput {
  faqs: Array<ReorderCorporateFaqInput>
}

/** Input containing array of categories with new display orders */
export interface ReorderPosCategoriesInput {
  categories: Array<ReorderPosCategoryInput>
}

/** Input for reordering a single category */
export interface ReorderPosCategoryInput {
  displayOrder: Scalars['Int']['input']
  posCategoryId: Scalars['ID']['input']
}

/** Input containing array of categories with new display orders */
export interface ReorderServiceTemplateCategoriesInput {
  categories: Array<ReorderServiceTemplateCategoryInput>
}

/** Input for reordering a single service template category */
export interface ReorderServiceTemplateCategoryInput {
  displayOrder: Scalars['Int']['input']
  serviceTemplateCategoryId: Scalars['ID']['input']
}

/** The templates shown on one page of the Core list in their new order, and the position of that page in the full list */
export interface ReorderSessionTemplatesInput {
  offset: Scalars['Float']['input']
  sessionTemplateIds: Array<Scalars['String']['input']>
}

/** Input for reordering a single site session type */
export interface ReorderSiteSessionTypeInput {
  displayOrder: Scalars['Float']['input']
  siteSessionTypeId: Scalars['String']['input']
}

/** Input containing array of session types with new display orders */
export interface ReorderSiteSessionTypesInput {
  sessionTypes: Array<ReorderSiteSessionTypeInput>
}

export interface ReplaceExternalMediaAssetInputInput {
  contentMediaId: Scalars['ID']['input']
  fileName: Scalars['String']['input']
  mimeType: ReplaceExternalVideoMimeType
  url: Scalars['String']['input']
}

export enum ReplaceExternalVideoMimeType {
  VIDEO_HLS = 'VIDEO_HLS',
  VIDEO_MP4 = 'VIDEO_MP4',
  VIDEO_VIMEO = 'VIDEO_VIMEO',
  VIDEO_WEBM = 'VIDEO_WEBM',
  VIDEO_WISTIA = 'VIDEO_WISTIA',
  VIDEO_YOUTUBE = 'VIDEO_YOUTUBE',
}

export interface ReplaceMediaAssetInputInput {
  contentMediaId: Scalars['ID']['input']
  fileName: Scalars['String']['input']
  fileSize?: InputMaybe<Scalars['Float']['input']>
  mimeType: Scalars['String']['input']
}

export interface ReplayBlockedMovementsInput {
  corporateId: Scalars['ID']['input']
  mappingFix?: InputMaybe<Array<MemberMovementReplayMappingFixInput>>
  movementIds: Array<Scalars['ID']['input']>
}

export interface ReportDefinitionInputInput {
  filters?: InputMaybe<Scalars['JSONObject']['input']>
  reportName: ReportName
  siteIds?: InputMaybe<Array<Scalars['String']['input']>>
}

/** Available report identifiers */
export enum ReportName {
  account_credit_balance = 'account_credit_balance',
  add_on_memberships = 'add_on_memberships',
  add_ons_report = 'add_ons_report',
  all_clients = 'all_clients',
  all_invoices = 'all_invoices',
  amount_due = 'amount_due',
  attendance_by_session = 'attendance_by_session',
  awards_summary = 'awards_summary',
  banner_clicks = 'banner_clicks',
  birthdays = 'birthdays',
  cancellation_report = 'cancellation_report',
  cash_drawer = 'cash_drawer',
  challenge_enrollment_detail = 'challenge_enrollment_detail',
  challenge_member_consolidated = 'challenge_member_consolidated',
  challenge_member_daily = 'challenge_member_daily',
  challenge_participation = 'challenge_participation',
  challenge_performance = 'challenge_performance',
  challenges = 'challenges',
  client_checkin = 'client_checkin',
  client_engagement = 'client_engagement',
  client_equipment_usage = 'client_equipment_usage',
  client_lifetime_value = 'client_lifetime_value',
  client_retention_rate = 'client_retention_rate',
  clients_absent = 'clients_absent',
  commission_detail = 'commission_detail',
  commission_events = 'commission_events',
  commission_summary = 'commission_summary',
  content_engagement = 'content_engagement',
  content_library_billing_evidence = 'content_library_billing_evidence',
  content_library_member_usage = 'content_library_member_usage',
  content_library_statement = 'content_library_statement',
  content_library_title_usage = 'content_library_title_usage',
  content_library_usage_by_corporate = 'content_library_usage_by_corporate',
  content_library_usage_detail = 'content_library_usage_detail',
  contract_agreement = 'contract_agreement',
  current_inventory = 'current_inventory',
  delinquency = 'delinquency',
  discount_usage = 'discount_usage',
  drdr_report = 'drdr_report',
  equipment_usage = 'equipment_usage',
  expired_session_credits = 'expired_session_credits',
  ezypay_settlement = 'ezypay_settlement',
  failed_payment_history = 'failed_payment_history',
  failed_payments = 'failed_payments',
  first_visits = 'first_visits',
  gift_cards = 'gift_cards',
  guest_pass = 'guest_pass',
  income_handover = 'income_handover',
  intro_offer_conversions = 'intro_offer_conversions',
  kpi_performance = 'kpi_performance',
  late_cancels = 'late_cancels',
  leaderboard_history = 'leaderboard_history',
  member_metric_detail = 'member_metric_detail',
  member_movement = 'member_movement',
  member_movement_transfer_summary = 'member_movement_transfer_summary',
  member_movement_transfers = 'member_movement_transfers',
  member_status_summary = 'member_status_summary',
  membership_details = 'membership_details',
  memberships_expiring = 'memberships_expiring',
  metric_tracking = 'metric_tracking',
  missing_payment_methods = 'missing_payment_methods',
  monthly_billing_statement = 'monthly_billing_statement',
  multi_location_comparison = 'multi_location_comparison',
  net_revenue = 'net_revenue',
  new_clients = 'new_clients',
  no_shows = 'no_shows',
  one_to_one_sessions = 'one_to_one_sessions',
  payroll = 'payroll',
  payroll_tier_audit = 'payroll_tier_audit',
  pos_history = 'pos_history',
  presold_services = 'presold_services',
  projected_revenue = 'projected_revenue',
  promo_code_usage = 'promo_code_usage',
  referrals = 'referrals',
  refund_history = 'refund_history',
  revenue_leakage = 'revenue_leakage',
  revenue_used = 'revenue_used',
  royalty_fee_distribution = 'royalty_fee_distribution',
  sales_by_service = 'sales_by_service',
  session_credits_remaining = 'session_credits_remaining',
  session_feedback = 'session_feedback',
  session_performance = 'session_performance',
  staff_earnings = 'staff_earnings',
  staff_utilisation = 'staff_utilisation',
  stripe_card_updater = 'stripe_card_updater',
  stripe_settlement = 'stripe_settlement',
  suspended_memberships = 'suspended_memberships',
  tax_summary = 'tax_summary',
  theme_subscription_usage = 'theme_subscription_usage',
  unpaid_sessions = 'unpaid_sessions',
  upgrade_downgrade_report = 'upgrade_downgrade_report',
  video_performance = 'video_performance',
  waitlist = 'waitlist',
  write_off_bad_debt = 'write_off_bad_debt',
}

export enum ReportNoticeLevel {
  error = 'error',
  info = 'info',
  warning = 'warning',
}

/** Report permission categories */
export enum ReportPermissionCategory {
  client_and_attendance = 'client_and_attendance',
  commissions = 'commissions',
  content = 'content',
  financial = 'financial',
  staff = 'staff',
}

/** The member to register a fob for and the browser asking, whose paired terminal will read it */
export interface RequestFobCaptureInput {
  clientId: Scalars['ID']['input']
  siteId: Scalars['ID']['input']
  widgetDeviceId: Scalars['String']['input']
}

/** Whether the bed was started again at once, or is cooling down after the stop and needs Reset pressed again once it shows Dirty */
export enum RestartEquipmentAssignmentOutcome {
  cooling_down = 'cooling_down',
  restarted = 'restarted',
}

/** How long a location keeps a completed assessment current: forever, 12 months from completion, or until the next calendar year */
export enum ResurveyInterval {
  CALENDAR_YEAR = 'CALENDAR_YEAR',
  MONTHS_12 = 'MONTHS_12',
  NEVER = 'NEVER',
}

export interface RetryMemberMovementPaymentMigrationInput {
  corporateId: Scalars['ID']['input']
  memberMovementId: Scalars['ID']['input']
}

export interface RetryPaymentsInputInput {
  retries: Array<RetryPaymentsRetriesInput>
}

export interface RetryPaymentsRetriesInput {
  amount: Scalars['Numeric']['input']
  canCompleteCardChallenge?: InputMaybe<Scalars['Boolean']['input']>
  canRecoverCardChallengeRemotely?: InputMaybe<Scalars['Boolean']['input']>
  clientPaymentMethodId?: InputMaybe<Scalars['ID']['input']>
  customPaymentMethodLabel?: InputMaybe<Scalars['String']['input']>
  paymentId?: InputMaybe<Scalars['ID']['input']>
  paymentMethodType: PaymentMethodType
  saveForFutureUse?: InputMaybe<Scalars['Boolean']['input']>
  terminalReaderId?: InputMaybe<Scalars['ID']['input']>
  useTerminalCardForRecurring?: InputMaybe<Scalars['Boolean']['input']>
}

/** Revenue tag mapping options */
export enum RevenueTagMapping {
  DISHONOUR_FEE = 'DISHONOUR_FEE',
  LATE_CANCEL_FEE = 'LATE_CANCEL_FEE',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  NO_SHOW_FEE = 'NO_SHOW_FEE',
  ONE_TIME_SETUP_FEE = 'ONE_TIME_SETUP_FEE',
  SECONDARY_RECURRING_FEE = 'SECONDARY_RECURRING_FEE',
}

export enum ReversalReason {
  CLIENT_REQUEST = 'CLIENT_REQUEST',
  MISTAKE = 'MISTAKE',
  OTHER = 'OTHER',
  SYSTEM_ERROR = 'SYSTEM_ERROR',
}

export interface ReviewMemberMovementsInput {
  corporateId: Scalars['ID']['input']
  decisions: Array<MemberMovementReviewDecisionInput>
  runId: Scalars['ID']['input']
}

export enum RevisionChangeType {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
}

export enum RevisionReviewState {
  APPROVED = 'APPROVED',
  PENDING_REVIEW = 'PENDING_REVIEW',
  REJECTED = 'REJECTED',
}

/** Input for removing a family member's access to a family package */
export interface RevokeFamilyAllocationInput {
  clientId: Scalars['ID']['input']
  serviceId: Scalars['ID']['input']
}

/** Move credits that expired on a pack onto another of the same client's packs */
export interface RolloverExpiredCreditsInput {
  credits: Scalars['Float']['input']
  note?: InputMaybe<Scalars['String']['input']>
  siteId: Scalars['ID']['input']
  sourceServiceId: Scalars['ID']['input']
  targetServiceId: Scalars['ID']['input']
}

/** Types of booking properties available for room resource templates */
export enum RoomResourceTemplateBookingPropertyTypes {
  address = 'address',
  birthday = 'birthday',
  contactNumberHome = 'contactNumberHome',
  contactNumberMobile = 'contactNumberMobile',
  email = 'email',
  emergencyContactAddress = 'emergencyContactAddress',
  emergencyContactContact = 'emergencyContactContact',
  emergencyContactEmail = 'emergencyContactEmail',
  emergencyContactName = 'emergencyContactName',
  emergencyContactRelationship = 'emergencyContactRelationship',
  firstName = 'firstName',
  gender = 'gender',
  lastName = 'lastName',
  occupation = 'occupation',
}

/** Input for creating a royalties and fees template */
export interface RoyaltiesAndFeesTemplateInput {
  marketingFee: RoyaltiesAndFeesTemplateRoyaltyFee1Input
  name: Scalars['String']['input']
  royaltyBaseMode?: InputMaybe<RoyaltyBaseMode>
  royaltyFee1: RoyaltiesAndFeesTemplateRoyaltyFee1Input
  royaltyFee2: RoyaltiesAndFeesTemplateRoyaltyFee1Input
  softwareFee: RoyaltiesAndFeesTemplateRoyaltyFee1Input
}

export enum RoyaltiesAndFeesTemplateOrderBy {
  createdAt = 'createdAt',
  name = 'name',
  updatedAt = 'updatedAt',
}

export interface RoyaltiesAndFeesTemplateRoyaltyFee1Input {
  enabled: Scalars['Boolean']['input']
  payoutAccountId?: InputMaybe<Scalars['ID']['input']>
  rate?: InputMaybe<Scalars['Numeric']['input']>
}

/** Input for updating a royalties and fees template */
export interface RoyaltiesAndFeesTemplateUpdate {
  marketingFee?: InputMaybe<RoyaltiesAndFeesTemplateRoyaltyFee1Input>
  name?: InputMaybe<Scalars['String']['input']>
  royaltyBaseMode?: InputMaybe<RoyaltyBaseMode>
  royaltyFee1?: InputMaybe<RoyaltiesAndFeesTemplateRoyaltyFee1Input>
  royaltyFee2?: InputMaybe<RoyaltiesAndFeesTemplateRoyaltyFee1Input>
  softwareFee?: InputMaybe<RoyaltiesAndFeesTemplateRoyaltyFee1Input>
}

export interface RoyaltiesAndFeesTemplatesOrderByInput {
  column: RoyaltiesAndFeesTemplateOrderBy
  direction: OrderByDirection
}

/** Whether royalties are calculated on the amount paid including or excluding tax */
export enum RoyaltyBaseMode {
  TaxExclusive = 'TaxExclusive',
  TaxInclusive = 'TaxInclusive',
}

export interface RunReportInputInput {
  columnFilters?: InputMaybe<Scalars['JSONObject']['input']>
  columns?: InputMaybe<Array<Scalars['String']['input']>>
  cursor?: InputMaybe<Scalars['String']['input']>
  dateFormat?: InputMaybe<Scalars['String']['input']>
  dateFrom?: InputMaybe<Scalars['String']['input']>
  dateTo?: InputMaybe<Scalars['String']['input']>
  filters?: InputMaybe<Scalars['JSONObject']['input']>
  numberFormat?: InputMaybe<Scalars['String']['input']>
  orderBy?: InputMaybe<Array<RunReportOrderByInput>>
  page?: InputMaybe<Scalars['Float']['input']>
  pageSize: Scalars['Float']['input']
  reportName?: InputMaybe<ReportName>
  savedReportId?: InputMaybe<Scalars['String']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  siteIds?: InputMaybe<Array<Scalars['String']['input']>>
  timeFormat?: InputMaybe<Scalars['String']['input']>
}

export interface RunReportOrderByInput {
  column: Scalars['String']['input']
  direction: SortDirection
}

export enum SaleAvailabilityState {
  AVAILABLE = 'AVAILABLE',
  NOT_YET_AVAILABLE = 'NOT_YET_AVAILABLE',
  NO_LONGER_AVAILABLE = 'NO_LONGER_AVAILABLE',
}

/** Later invoices of the same sale to schedule, or to join onto a pending membership, once the invoice paid today is paid. followsReaderCard puts them on the card the reader saves today, falling back to clientPaymentMethodId. heldPaymentId and heldClientPaymentMethodId name the payment checkout saw held and its card, which stay recorded when the hold ended before this call arrived */
export interface SaleFollowUpInput {
  clientPaymentMethodId: Scalars['ID']['input']
  followsReaderCard?: InputMaybe<Scalars['Boolean']['input']>
  heldClientPaymentMethodId?: InputMaybe<Scalars['ID']['input']>
  heldPaymentId?: InputMaybe<Scalars['ID']['input']>
  joinInvoiceIds: Array<Scalars['ID']['input']>
  scheduleInvoiceIds: Array<Scalars['ID']['input']>
}

/** Type of a sale item */
export enum SaleItemType {
  BillableItem = 'BillableItem',
  Booking = 'Booking',
  DestinationFee = 'DestinationFee',
  GiftCard = 'GiftCard',
  LateCancelFee = 'LateCancelFee',
  NoShowFee = 'NoShowFee',
  Product = 'Product',
  RecurringServicePayment = 'RecurringServicePayment',
  ScheduleDateAdjustment = 'ScheduleDateAdjustment',
  Service = 'Service',
  ServiceActionFee = 'ServiceActionFee',
}

/** A Client PII column the sandbox anonymiser rewrites */
export enum SandboxAnonymisedClientColumn {
  address = 'address',
  dateOfBirth = 'dateOfBirth',
  email = 'email',
  emergencyContact = 'emergencyContact',
  homePhoneNumber = 'homePhoneNumber',
  mobilePhoneNumber = 'mobilePhoneNumber',
  originalEmail = 'originalEmail',
}

/** What the latest sandbox migration job did: create, resync or delete */
export enum SandboxJobKind {
  create = 'create',
  delete = 'delete',
  resync = 'resync',
}

/** Status of a sandbox migration job */
export enum SandboxJobStatus {
  completed = 'completed',
  failed = 'failed',
  in_progress = 'in_progress',
  pending = 'pending',
}

/** What the data_copy patch did to a Client row */
export enum SandboxReportClientAction {
  anonymised_copy_written = 'anonymised_copy_written',
  anonymised_non_test_domain = 'anonymised_non_test_domain',
  kept_test_account = 'kept_test_account',
}

export enum SandboxStatusFilter {
  active = 'active',
  all = 'all',
  failed = 'failed',
  none = 'none',
  orphaned = 'orphaned',
  running = 'running',
  sandboxes = 'sandboxes',
}

/** Step in the sandbox migration pipeline */
export enum SandboxStepName {
  admin_db = 'admin_db',
  anonymise = 'anonymise',
  data_copy = 'data_copy',
  datastream = 'datastream',
  drop_database = 'drop_database',
  feature_flags = 'feature_flags',
  firebase = 'firebase',
  payout_accounts = 'payout_accounts',
  remove_admin = 'remove_admin',
  report_views = 'report_views',
  schema_migrations = 'schema_migrations',
  setup_db = 'setup_db',
  site_index = 'site_index',
  stamp_corporate_id = 'stamp_corporate_id',
  stripe = 'stripe',
  teardown_datastream = 'teardown_datastream',
  teardown_stripe = 'teardown_stripe',
  test_staff_user = 'test_staff_user',
  verify = 'verify',
  verify_schema = 'verify_schema',
}

/** Status of an individual sandbox migration step */
export enum SandboxStepStatus {
  completed = 'completed',
  failed = 'failed',
  in_progress = 'in_progress',
  pending = 'pending',
}

/** Replaces a UV bed's whole exposure schedule; bands are the location's skin type form bands at formRevision */
export interface SaveEquipmentExposureScheduleInput {
  equipmentId: Scalars['ID']['input']
  formRevision: Scalars['Int']['input']
  note?: InputMaybe<Scalars['String']['input']>
  rows: Array<EquipmentExposureScheduleRowInput>
}

export interface SaveMovementTemplateMappingsMappingsInput {
  destinationServiceTemplateId: Scalars['ID']['input']
  destinationSiteId: Scalars['ID']['input']
  sourceServiceTemplateId: Scalars['ID']['input']
  sourceSiteId: Scalars['ID']['input']
}

export interface SaveScoredSiteFormFormInput {
  defaultRequiredBefore: FormRequiredBefore
  description: Scalars['String']['input']
  name: Scalars['String']['input']
  resultCustomPropertyId?: InputMaybe<Scalars['ID']['input']>
  resultPropertyMapping?: InputMaybe<Scalars['JSONObject']['input']>
  scoreBands?: InputMaybe<Array<SaveScoredSiteFormFormScoreBandsInput>>
  scoringEnabled: Scalars['Boolean']['input']
  showResultOnProfile: Scalars['Boolean']['input']
  showResultToClient: Scalars['Boolean']['input']
}

export interface SaveScoredSiteFormFormScoreBandsInput {
  bandId: Scalars['ID']['input']
  description?: InputMaybe<Scalars['String']['input']>
  label: Scalars['String']['input']
  max: Scalars['Float']['input']
  min: Scalars['Float']['input']
}

export interface SaveScoredSiteFormQuestionsInput {
  excludeFromScore: Scalars['Boolean']['input']
  mustAnswerYes: Scalars['Boolean']['input']
  optionScores?: InputMaybe<Array<Scalars['Float']['input']>>
  options?: InputMaybe<Array<Scalars['String']['input']>>
  required: Scalars['Boolean']['input']
  siteCustomPropertyId?: InputMaybe<Scalars['ID']['input']>
  siteFormQuestionId?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  type: SiteFormQuestionType
}

export enum SavedReportVisibility {
  CORPORATE = 'CORPORATE',
  PERSONAL = 'PERSONAL',
}

/** Action to perform on the scheduled date */
export enum ScheduleAction {
  PUBLISH = 'PUBLISH',
  UNPUBLISH = 'UNPUBLISH',
}

/** When a brand draft goes live: a wall time read in each location's timezone, or as one instant in the author's. */
export interface ScheduleCorporateServiceTemplateInput {
  corporateServiceTemplateId: Scalars['ID']['input']
  expectedVersion: Scalars['Float']['input']
  scheduleAuthorTimezone?: InputMaybe<Scalars['String']['input']>
  scheduleClock: BrandScheduleClock
  scheduleWallTime: Scalars['String']['input']
}

export enum ScheduleDefaultView {
  AGENDA = 'AGENDA',
  CALENDAR = 'CALENDAR',
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
}

/** Input for scheduling an invoice with a payment method */
export interface ScheduleInvoiceInput {
  accountCreditAmount?: InputMaybe<Scalars['Numeric']['input']>
  attachPaymentMethodOnly?: InputMaybe<Scalars['Boolean']['input']>
  clientPaymentMethodId: Scalars['ID']['input']
}

export enum ScheduledInvoiceType {
  InitialInvoice = 'InitialInvoice',
  Recurring = 'Recurring',
  Single = 'Single',
}

/** Hierarchy level at which a scheduled job is registered */
export enum ScheduledJobLevel {
  corporate = 'corporate',
  site = 'site',
  system = 'system',
}

/** Lifecycle status of a single scheduled-job run */
export enum ScheduledJobRunStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  SKIPPED = 'SKIPPED',
}

/** Manual-trigger safety: 'safe' = trigger freely, 'warn' = strong confirm (default), 'disabled' = blocked */
export enum ScheduledJobTriggerSafety {
  disabled = 'disabled',
  safe = 'safe',
  warn = 'warn',
}

/** Whether a run was fired by the repeatable schedule or triggered manually */
export enum ScheduledJobTriggerSource {
  manual = 'manual',
  scheduled = 'scheduled',
}

/** SITE_CLIENTS = every live member of the site; SESSION_BOOKINGS = members booked into one session at the site */
export enum ScheduledPushAudienceType {
  SESSION_BOOKINGS = 'SESSION_BOOKINGS',
  SITE_CLIENTS = 'SITE_CLIENTS',
}

/** Why a scheduled push notification did not go out */
export enum ScheduledPushFailureReason {
  CREATOR_NOT_AUTHORIZED = 'CREATOR_NOT_AUTHORIZED',
  DELIVERY_FAILED = 'DELIVERY_FAILED',
  DISPATCH_INTERRUPTED = 'DISPATCH_INTERRUPTED',
  MISSED_WINDOW = 'MISSED_WINDOW',
  PUSH_PROVIDER_UNSUPPORTED = 'PUSH_PROVIDER_UNSUPPORTED',
  RECIPIENT_CEILING_EXCEEDED = 'RECIPIENT_CEILING_EXCEEDED',
  SESSION_OUTSIDE_SITE = 'SESSION_OUTSIDE_SITE',
}

/** Lifecycle of a scheduled push notification */
export enum ScheduledPushSendStatus {
  CANCELLED = 'CANCELLED',
  FAILED = 'FAILED',
  SCHEDULED = 'SCHEDULED',
  SENDING = 'SENDING',
  SENT = 'SENT',
}

export enum SchedulerTimeSlotDuration {
  FIFTEEN_MINUTES = 'FIFTEEN_MINUTES',
  FORTY_FIVE_MINUTES = 'FORTY_FIVE_MINUTES',
  SIXTY_MINUTES = 'SIXTY_MINUTES',
  THIRTY_MINUTES = 'THIRTY_MINUTES',
  TWENTY_MINUTES = 'TWENTY_MINUTES',
}

/** Score type — specific scoring variant within a leaderboard type */
export enum ScoreType {
  CHALLENGE_COMPLETION_PCT = 'CHALLENGE_COMPLETION_PCT',
  CURRENT_STREAK = 'CURRENT_STREAK',
  LONGEST_STREAK = 'LONGEST_STREAK',
  METRIC_PERSONAL_BEST = 'METRIC_PERSONAL_BEST',
  METRIC_TOTAL_VOLUME = 'METRIC_TOTAL_VOLUME',
  TOTAL_ATTENDANCE = 'TOTAL_ATTENDANCE',
}

export interface ScreenshotInput {
  /** Base64-encoded image data */
  base64Data: Scalars['String']['input']
  contentType: Scalars['String']['input']
  filename: Scalars['String']['input']
}

export enum SelectFilterOperator {
  in = 'in',
  is = 'is',
}

export enum SelfServicePauseCadenceUnit {
  MONTHS = 'MONTHS',
  WEEKS = 'WEEKS',
}

export enum SelfServicePauseChargeMode {
  NONE = 'NONE',
  PARTIAL = 'PARTIAL',
  RECURRING = 'RECURRING',
}

export enum SelfServicePauseDurationUnit {
  BILLING_CYCLES = 'BILLING_CYCLES',
  DAYS = 'DAYS',
  MONTHS = 'MONTHS',
  WEEKS = 'WEEKS',
}

/** Input for sending a guest pass from a service allocation */
export interface SendGuestPassInput {
  recipientEmail?: InputMaybe<Scalars['String']['input']>
  recipientName?: InputMaybe<Scalars['String']['input']>
  recipientPhone?: InputMaybe<Scalars['String']['input']>
  serviceId: Scalars['ID']['input']
}

export interface SendMessageEmailOptionsInput {
  from?: InputMaybe<Scalars['String']['input']>
  headers?: InputMaybe<Scalars['JSONObject']['input']>
  replyTo?: InputMaybe<Scalars['String']['input']>
  tags?: InputMaybe<Array<SendMessageEmailOptionsTagsInput>>
}

export interface SendMessageEmailOptionsTagsInput {
  name: Scalars['String']['input']
  value: Scalars['String']['input']
}

/** Input for sending a message */
export interface SendMessageInput {
  clientIds?: InputMaybe<Array<Scalars['String']['input']>>
  content: Scalars['String']['input']
  emailOptions?: InputMaybe<SendMessageEmailOptionsInput>
  isTransactional?: InputMaybe<Scalars['Boolean']['input']>
  messageType: MessageType
  recipients: Array<Scalars['String']['input']>
  siteId: Scalars['String']['input']
  smsFrom?: InputMaybe<Scalars['String']['input']>
  smsStatusCallback?: InputMaybe<Scalars['String']['input']>
  subject?: InputMaybe<Scalars['String']['input']>
  templateAlias?: InputMaybe<Scalars['String']['input']>
}

/** Type of service action that triggered the fee */
export enum ServiceActionType {
  CANCELLATION = 'CANCELLATION',
  SUSPENSION = 'SUSPENSION',
}

export enum ServiceCancellationStatus {
  CANCELED = 'CANCELED',
  EXECUTED = 'EXECUTED',
  REVERSED = 'REVERSED',
  SCHEDULED = 'SCHEDULED',
}

export enum ServiceCreditLedgerDirection {
  IN = 'IN',
  OUT = 'OUT',
}

export enum ServiceCreditLedgerTransactionType {
  ALLOCATED = 'ALLOCATED',
  BOOKING = 'BOOKING',
  EXPIRED = 'EXPIRED',
  MANUAL = 'MANUAL',
  REFUND = 'REFUND',
}

/** Input for sharing a package with a recipient */
export interface ServiceCreditShareAddRecipientInput {
  allocatedCredits?: InputMaybe<Scalars['Float']['input']>
  recipientClientId: Scalars['ID']['input']
  serviceId: Scalars['ID']['input']
}

/** Input for revoking a shared-package recipient */
export interface ServiceCreditShareRemoveInput {
  recipientClientId: Scalars['ID']['input']
  serviceId: Scalars['ID']['input']
}

export enum ServiceCreditShareStatus {
  accepted = 'accepted',
  declined = 'declined',
  pending = 'pending',
  revoked = 'revoked',
}

/** Whether staff extended an active plan or reactivated an expired one */
export enum ServiceExtensionType {
  EXTEND = 'EXTEND',
  REACTIVATE = 'REACTIVATE',
}

/** Unit of the duration a plan is extended or reactivated for */
export enum ServiceExtensionUnit {
  DAYS = 'DAYS',
  MONTHS = 'MONTHS',
  WEEKS = 'WEEKS',
}

export enum ServiceLengthType {
  LIMITED = 'LIMITED',
  UNENDING = 'UNENDING',
}

export enum ServiceLengthUnit {
  DAYS = 'DAYS',
  MONTHS = 'MONTHS',
  WEEKS = 'WEEKS',
  YEARS = 'YEARS',
}

export enum ServicePlanChangeEffectiveType {
  EndOfCycle = 'EndOfCycle',
  Immediate = 'Immediate',
}

export enum ServicePlanChangeStatus {
  Canceled = 'Canceled',
  Executed = 'Executed',
  PendingPayment = 'PendingPayment',
  Scheduled = 'Scheduled',
}

export enum ServiceStatus {
  Active = 'Active',
  Canceled = 'Canceled',
  Completed = 'Completed',
  Expired = 'Expired',
  PendingStartDate = 'PendingStartDate',
  Suspended = 'Suspended',
}

export enum ServiceSuspensionChargeMode {
  FULL = 'FULL',
  NONE = 'NONE',
  PARTIAL = 'PARTIAL',
  RECURRING = 'RECURRING',
}

export enum ServiceSuspensionCreditMethod {
  CREDIT_VALUE_BASED = 'CREDIT_VALUE_BASED',
  TIME_BASED = 'TIME_BASED',
}

export enum ServiceSuspensionType {
  PRORATED = 'PRORATED',
  TIME_SHIFT = 'TIME_SHIFT',
}

export enum ServiceTemplateAddOnPaymentType {
  ONE_TIME = 'ONE_TIME',
  RECURRING = 'RECURRING',
}

/** A plan's add-on price for one price group */
export interface ServiceTemplateAddOnPriceGroupPriceInput {
  addOnPriceGroupId: Scalars['ID']['input']
  /** Empty or 0 removes the plan's price for the group */
  price?: InputMaybe<Scalars['Numeric']['input']>
}

export enum ServiceTemplateCategoryStatus {
  active = 'active',
  inactive = 'inactive',
}

/** Fields available for ordering service templates */
export enum ServiceTemplateOrderBy {
  createdAt = 'createdAt',
  name = 'name',
  price = 'price',
  status = 'status',
  type = 'type',
  updatedAt = 'updatedAt',
}

export enum ServiceTemplateStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  DELETED = 'DELETED',
  SCHEDULED = 'SCHEDULED',
}

export enum ServiceTemplateType {
  ADD_ON = 'ADD_ON',
  GUEST_PASS = 'GUEST_PASS',
  MEMBERSHIP = 'MEMBERSHIP',
  PACKAGE = 'PACKAGE',
}

export interface ServiceTemplatesPaginatedOrderByInput {
  column: ServiceTemplateOrderBy
  direction: OrderByDirection
}

/** Input for configuring a provider on a session */
export interface SessionAggregatorConfigInput {
  aggregatorProviderId: Scalars['String']['input']
  isEnabled: Scalars['Boolean']['input']
  spotLimit?: InputMaybe<Scalars['Float']['input']>
}

/** Session category types */
export enum SessionCategory {
  CLASS = 'CLASS',
  PRIVATE = 'PRIVATE',
  WORKSHOP = 'WORKSHOP',
}

/** Input for creating a custom session */
export interface SessionCreateCustomInput {
  aggregatorConfigs?: InputMaybe<Array<SessionAggregatorConfigInput>>
  allowOverlappingSessions?: InputMaybe<Scalars['Boolean']['input']>
  category: SessionCategory
  creditsRequired: Scalars['Float']['input']
  customCancelPolicy?: InputMaybe<SessionTemplateCustomCancelPolicyInput>
  customFields: Array<SessionTemplateCustomFieldsInput>
  customReleaseSchedule?: InputMaybe<SessionTemplateCustomReleaseScheduleInput>
  date: Scalars['String']['input']
  description?: InputMaybe<Scalars['String']['input']>
  disabledSpotIds?: InputMaybe<Array<Scalars['Float']['input']>>
  dropinPrice: Scalars['Numeric']['input']
  endTime: Scalars['String']['input']
  isBlockSlot: Scalars['Boolean']['input']
  isModified: Scalars['Boolean']['input']
  isPaymentRequired: Scalars['Boolean']['input']
  isRequestBookingEnabled: Scalars['Boolean']['input']
  isRequiredSessionFeedback: Scalars['Boolean']['input']
  isRequiredTwoPartAuthentication: Scalars['Boolean']['input']
  isRoomResourceEnabled?: InputMaybe<Scalars['Boolean']['input']>
  itemsSupplied?: InputMaybe<Scalars['String']['input']>
  itemsToBring?: InputMaybe<Scalars['String']['input']>
  lateCancelFeeId?: InputMaybe<Scalars['String']['input']>
  lateCancelFeeMode?: InputMaybe<SessionFeeMode>
  name: Scalars['String']['input']
  noShowFeeId?: InputMaybe<Scalars['String']['input']>
  noShowFeeMode?: InputMaybe<SessionFeeMode>
  recurrenceDate?: InputMaybe<Scalars['String']['input']>
  recurringSessionsId?: InputMaybe<Scalars['String']['input']>
  revenueTagId?: InputMaybe<Scalars['String']['input']>
  sessionImage?: InputMaybe<SessionTemplateSessionImageInput>
  sessionTemplateId?: InputMaybe<Scalars['String']['input']>
  siteLocationId: Scalars['String']['input']
  siteLocationRoomId?: InputMaybe<Scalars['String']['input']>
  siteSessionTypeId: Scalars['String']['input']
  size: Scalars['Float']['input']
  staffUserIds?: InputMaybe<Array<Scalars['String']['input']>>
  startTime: Scalars['String']['input']
  status: SessionStatus
  taxEnabled: Scalars['Boolean']['input']
  taxSettingIds?: InputMaybe<Array<Scalars['String']['input']>>
  waitlistBatchSize?: InputMaybe<Scalars['Float']['input']>
  waitlistEnabled: Scalars['Boolean']['input']
  waitlistInvitationStrategy?: InputMaybe<WaitlistInvitationStrategy>
  waitlistInvitationTimeout?: InputMaybe<Scalars['Float']['input']>
  waitlistSize?: InputMaybe<Scalars['Float']['input']>
}

/** Input for creating a session from a template */
export interface SessionCreateFromTemplateInput {
  aggregatorConfigs?: InputMaybe<Array<SessionAggregatorConfigInput>>
  creditsRequired?: InputMaybe<Scalars['Float']['input']>
  date: Scalars['String']['input']
  description?: InputMaybe<Scalars['String']['input']>
  dropinPrice?: InputMaybe<Scalars['Numeric']['input']>
  endTime?: InputMaybe<Scalars['String']['input']>
  isModified: Scalars['Boolean']['input']
  isRoomResourceEnabled?: InputMaybe<Scalars['Boolean']['input']>
  lateCancelFeeId?: InputMaybe<Scalars['String']['input']>
  lateCancelFeeMode?: InputMaybe<SessionFeeMode>
  name?: InputMaybe<Scalars['String']['input']>
  noShowFeeId?: InputMaybe<Scalars['String']['input']>
  noShowFeeMode?: InputMaybe<SessionFeeMode>
  recurrenceDate?: InputMaybe<Scalars['String']['input']>
  recurringSessionsId?: InputMaybe<Scalars['String']['input']>
  revenueTagId?: InputMaybe<Scalars['String']['input']>
  sessionTemplateId: Scalars['String']['input']
  siteLocationId?: InputMaybe<Scalars['String']['input']>
  siteLocationRoomId?: InputMaybe<Scalars['String']['input']>
  size?: InputMaybe<Scalars['Float']['input']>
  staffUserIds?: InputMaybe<Array<Scalars['String']['input']>>
  startTime: Scalars['String']['input']
}

/** Which session and scope to preview a delete for */
export interface SessionDeletionPreviewInput {
  includeModifiedSessions?: InputMaybe<Scalars['Boolean']['input']>
  scope: CancelSessionScope
  sessionId: Scalars['String']['input']
  siteId: Scalars['String']['input']
}

/** Display type for sessions */
export enum SessionDisplayType {
  GRID = 'GRID',
  LIST = 'LIST',
}

export enum SessionFeeMode {
  Custom = 'Custom',
  Default = 'Default',
  None = 'None',
}

export enum SessionFeeSource {
  Custom = 'Custom',
  General = 'General',
}

/** Answer type for a configured session feedback question */
export enum SessionFeedbackAnswerType {
  MULTI_LINE_TEXT = 'MULTI_LINE_TEXT',
  SLIDER = 'SLIDER',
  STAR_RATING = 'STAR_RATING',
}

/** Input for creating a session feedback question */
export interface SessionFeedbackQuestionCreateInput {
  active: Scalars['Boolean']['input']
  answerType: SessionFeedbackAnswerType
  characterLimit?: InputMaybe<Scalars['Float']['input']>
  helperText?: InputMaybe<Scalars['String']['input']>
  maxLabel?: InputMaybe<Scalars['String']['input']>
  minLabel?: InputMaybe<Scalars['String']['input']>
  presetKey?: InputMaybe<Scalars['String']['input']>
  questionText: Scalars['String']['input']
  required: Scalars['Boolean']['input']
  scaleMax?: InputMaybe<Scalars['Float']['input']>
  sliderMax?: InputMaybe<Scalars['Float']['input']>
  sliderMin?: InputMaybe<Scalars['Float']['input']>
}

/** Input for updating a session feedback question */
export interface SessionFeedbackQuestionUpdateInput {
  active?: InputMaybe<Scalars['Boolean']['input']>
  answerType?: InputMaybe<SessionFeedbackAnswerType>
  characterLimit?: InputMaybe<Scalars['Float']['input']>
  helperText?: InputMaybe<Scalars['String']['input']>
  maxLabel?: InputMaybe<Scalars['String']['input']>
  minLabel?: InputMaybe<Scalars['String']['input']>
  questionText?: InputMaybe<Scalars['String']['input']>
  required?: InputMaybe<Scalars['Boolean']['input']>
  scaleMax?: InputMaybe<Scalars['Float']['input']>
  sliderMax?: InputMaybe<Scalars['Float']['input']>
  sliderMin?: InputMaybe<Scalars['Float']['input']>
}

/** Whether a member is asked for, has given, or cannot give feedback on a session */
export enum SessionFeedbackStatus {
  COMPLETE = 'COMPLETE',
  PENDING = 'PENDING',
  UNAVAILABLE = 'UNAVAILABLE',
}

export enum SessionFilterCalendarMode {
  calendar = 'calendar',
  list = 'list',
  room = 'room',
  team = 'team',
}

/** Input for creating a session filter */
export interface SessionFilterCreateInput {
  calendarMode?: InputMaybe<SessionFilterCalendarMode>
  filters?: InputMaybe<Scalars['JSONObject']['input']>
  isDefault: Scalars['Boolean']['input']
  isVisible: Scalars['Boolean']['input']
  name: Scalars['String']['input']
  visibility: SessionFilterVisibility
}

/** Input for updating a session filter */
export interface SessionFilterUpdateInput {
  calendarMode?: InputMaybe<SessionFilterCalendarMode>
  filters?: InputMaybe<Scalars['JSONObject']['input']>
  isDefault?: InputMaybe<Scalars['Boolean']['input']>
  isVisible?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  visibility?: InputMaybe<SessionFilterVisibility>
}

export enum SessionFilterVisibility {
  CREATOR = 'CREATOR',
  EVERYONE = 'EVERYONE',
}

/** A lockable section of a brand session group. */
export enum SessionGroupSection {
  ADVANCED_CONFIGURATIONS = 'ADVANCED_CONFIGURATIONS',
  INFORMATION = 'INFORMATION',
}

/** Filter input for session queries */
export interface SessionQueryFiltersInput {
  categories?: InputMaybe<Array<SessionCategory>>
  clientIds?: InputMaybe<Array<Scalars['String']['input']>>
  excludeStartedSessions?: InputMaybe<Scalars['Boolean']['input']>
  includeCancelled?: InputMaybe<Scalars['Boolean']['input']>
  recurringSessionsId?: InputMaybe<Scalars['String']['input']>
  siteLocationIds?: InputMaybe<Array<Scalars['String']['input']>>
  siteLocationRoomIds?: InputMaybe<Array<Scalars['String']['input']>>
  siteSessionTypeIds?: InputMaybe<Array<Scalars['String']['input']>>
  staffUserIds?: InputMaybe<Array<Scalars['String']['input']>>
}

/** Session status types */
export enum SessionStatus {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  SCHEDULED = 'SCHEDULED',
}

export interface SessionTemplateCustomCancelPolicyInput {
  days: Scalars['Float']['input']
  hours: Scalars['Float']['input']
  minutes: Scalars['Float']['input']
}

export interface SessionTemplateCustomFieldsInput {
  enabled: Scalars['Boolean']['input']
  id?: InputMaybe<Scalars['String']['input']>
  information?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  value?: InputMaybe<Scalars['String']['input']>
}

export interface SessionTemplateCustomReleaseScheduleInput {
  bookingAdvanceDays: Scalars['Float']['input']
  bookingAdvanceHours: Scalars['Float']['input']
  dayOfWeek?: InputMaybe<Scalars['String']['input']>
  hoursBeforeStart?: InputMaybe<Scalars['Float']['input']>
  intervalType?: InputMaybe<Scalars['String']['input']>
  intervalValue?: InputMaybe<Scalars['Float']['input']>
  releaseType: Scalars['String']['input']
  time?: InputMaybe<Scalars['String']['input']>
}

/** Input for creating a session template */
export interface SessionTemplateInput {
  allowOverlappingSessions?: InputMaybe<Scalars['Boolean']['input']>
  availableForStaffUserIds?: InputMaybe<Array<Scalars['String']['input']>>
  category: SessionCategory
  creditsRequired: Scalars['Float']['input']
  customCancelPolicy?: InputMaybe<SessionTemplateCustomCancelPolicyInput>
  customFields: Array<SessionTemplateCustomFieldsInput>
  customReleaseSchedule?: InputMaybe<SessionTemplateCustomReleaseScheduleInput>
  description?: InputMaybe<Scalars['String']['input']>
  dropInPrice: Scalars['Numeric']['input']
  durationHours: Scalars['Float']['input']
  durationMinutes: Scalars['Float']['input']
  isPaymentRequired: Scalars['Boolean']['input']
  isRequestBookingEnabled: Scalars['Boolean']['input']
  isRequiredSessionFeedback: Scalars['Boolean']['input']
  isRequiredTwoPartAuthentication: Scalars['Boolean']['input']
  isRoomResourceEnabled?: InputMaybe<Scalars['Boolean']['input']>
  itemsSupplied?: InputMaybe<Scalars['String']['input']>
  itemsToBring?: InputMaybe<Scalars['String']['input']>
  lateCancelFeeId?: InputMaybe<Scalars['String']['input']>
  lateCancelFeeMode?: InputMaybe<SessionFeeMode>
  name: Scalars['String']['input']
  noShowFeeId?: InputMaybe<Scalars['String']['input']>
  noShowFeeMode?: InputMaybe<SessionFeeMode>
  revenueTagId?: InputMaybe<Scalars['String']['input']>
  sessionImage?: InputMaybe<SessionTemplateSessionImageInput>
  siteLocationId: Scalars['String']['input']
  siteLocationRoomId?: InputMaybe<Scalars['String']['input']>
  siteSessionTypeId: Scalars['String']['input']
  size: Scalars['Float']['input']
  taxEnabled: Scalars['Boolean']['input']
  taxSettingIds?: InputMaybe<Array<Scalars['String']['input']>>
  waitlistEnabled: Scalars['Boolean']['input']
  waitlistSize?: InputMaybe<Scalars['Float']['input']>
}

export interface SessionTemplateSessionImageInput {
  lastFailure?: InputMaybe<SessionTemplateSessionImageLastFailureInput>
  pending?: InputMaybe<SessionTemplateSessionImagePendingInput>
  status?: InputMaybe<FileUploadConfigFieldStatus>
  versions?: InputMaybe<Array<SessionTemplateSessionImageVersionsInput>>
}

export interface SessionTemplateSessionImageLastFailureInput {
  errorMessage: Scalars['String']['input']
  failedAt: Scalars['String']['input']
  tempUrl: Scalars['String']['input']
  uploadRequestedBy: Scalars['ID']['input']
}

export interface SessionTemplateSessionImagePendingInput {
  status: FileUploadConfigFieldPendingStatus
  tempUrl: Scalars['String']['input']
  uploadRequestedAt: Scalars['String']['input']
  uploadRequestedBy: Scalars['ID']['input']
}

export interface SessionTemplateSessionImageVersionsInput {
  format?: InputMaybe<Scalars['String']['input']>
  height?: InputMaybe<Scalars['Float']['input']>
  type: Scalars['String']['input']
  url: Scalars['String']['input']
  width?: InputMaybe<Scalars['Float']['input']>
}

/** Input for managing staff user access to a session template */
export interface SessionTemplateStaffUserInput {
  staffUserId: Scalars['String']['input']
}

/** Input for updating a session template */
export interface SessionTemplateUpdateInput {
  allowOverlappingSessions?: InputMaybe<Scalars['Boolean']['input']>
  category?: InputMaybe<SessionCategory>
  creditsRequired?: InputMaybe<Scalars['Float']['input']>
  customCancelPolicy?: InputMaybe<SessionTemplateCustomCancelPolicyInput>
  customFields?: InputMaybe<Array<SessionTemplateCustomFieldsInput>>
  customReleaseSchedule?: InputMaybe<SessionTemplateCustomReleaseScheduleInput>
  description?: InputMaybe<Scalars['String']['input']>
  dropInPrice?: InputMaybe<Scalars['Numeric']['input']>
  durationHours?: InputMaybe<Scalars['Float']['input']>
  durationMinutes?: InputMaybe<Scalars['Float']['input']>
  isPaymentRequired?: InputMaybe<Scalars['Boolean']['input']>
  isRequestBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>
  isRequiredSessionFeedback?: InputMaybe<Scalars['Boolean']['input']>
  isRequiredTwoPartAuthentication?: InputMaybe<Scalars['Boolean']['input']>
  isRoomResourceEnabled?: InputMaybe<Scalars['Boolean']['input']>
  itemsSupplied?: InputMaybe<Scalars['String']['input']>
  itemsToBring?: InputMaybe<Scalars['String']['input']>
  lateCancelFeeId?: InputMaybe<Scalars['String']['input']>
  lateCancelFeeMode?: InputMaybe<SessionFeeMode>
  name?: InputMaybe<Scalars['String']['input']>
  noShowFeeId?: InputMaybe<Scalars['String']['input']>
  noShowFeeMode?: InputMaybe<SessionFeeMode>
  revenueTagId?: InputMaybe<Scalars['String']['input']>
  sessionImage?: InputMaybe<SessionTemplateSessionImageInput>
  siteLocationRoomId?: InputMaybe<Scalars['String']['input']>
  siteSessionTypeId?: InputMaybe<Scalars['String']['input']>
  size?: InputMaybe<Scalars['Float']['input']>
  taxEnabled?: InputMaybe<Scalars['Boolean']['input']>
  taxSettingIds?: InputMaybe<Array<Scalars['String']['input']>>
  waitlistEnabled?: InputMaybe<Scalars['Boolean']['input']>
  waitlistSize?: InputMaybe<Scalars['Float']['input']>
}

/** Input for updating a session */
export interface SessionUpdateInput {
  aggregatorConfigs?: InputMaybe<Array<SessionAggregatorConfigInput>>
  allowOverlappingSessions?: InputMaybe<Scalars['Boolean']['input']>
  category?: InputMaybe<SessionCategory>
  creditsRequired?: InputMaybe<Scalars['Float']['input']>
  customCancelPolicy?: InputMaybe<SessionTemplateCustomCancelPolicyInput>
  customFields?: InputMaybe<Array<SessionTemplateCustomFieldsInput>>
  customReleaseSchedule?: InputMaybe<SessionTemplateCustomReleaseScheduleInput>
  date?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  disabledSpotIds?: InputMaybe<Array<Scalars['Float']['input']>>
  dropinPrice?: InputMaybe<Scalars['Numeric']['input']>
  endTime?: InputMaybe<Scalars['String']['input']>
  isBlockSlot?: InputMaybe<Scalars['Boolean']['input']>
  isModified?: InputMaybe<Scalars['Boolean']['input']>
  isPaymentRequired?: InputMaybe<Scalars['Boolean']['input']>
  isRequestBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>
  isRequiredSessionFeedback?: InputMaybe<Scalars['Boolean']['input']>
  isRequiredTwoPartAuthentication?: InputMaybe<Scalars['Boolean']['input']>
  isRoomResourceEnabled?: InputMaybe<Scalars['Boolean']['input']>
  itemsSupplied?: InputMaybe<Scalars['String']['input']>
  itemsToBring?: InputMaybe<Scalars['String']['input']>
  lateCancelFeeId?: InputMaybe<Scalars['String']['input']>
  lateCancelFeeMode?: InputMaybe<SessionFeeMode>
  name?: InputMaybe<Scalars['String']['input']>
  noShowFeeId?: InputMaybe<Scalars['String']['input']>
  noShowFeeMode?: InputMaybe<SessionFeeMode>
  recurrenceDate?: InputMaybe<Scalars['String']['input']>
  recurringSessionsId?: InputMaybe<Scalars['String']['input']>
  revenueTagId?: InputMaybe<Scalars['String']['input']>
  sessionImage?: InputMaybe<SessionTemplateSessionImageInput>
  sessionTemplateId?: InputMaybe<Scalars['String']['input']>
  siteLocationId?: InputMaybe<Scalars['String']['input']>
  siteLocationRoomId?: InputMaybe<Scalars['String']['input']>
  siteSessionTypeId?: InputMaybe<Scalars['String']['input']>
  size?: InputMaybe<Scalars['Float']['input']>
  staffUserIds?: InputMaybe<Array<Scalars['String']['input']>>
  startTime?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<SessionStatus>
  taxEnabled?: InputMaybe<Scalars['Boolean']['input']>
  taxSettingIds?: InputMaybe<Array<Scalars['String']['input']>>
  waitlistBatchSize?: InputMaybe<Scalars['Float']['input']>
  waitlistEnabled?: InputMaybe<Scalars['Boolean']['input']>
  waitlistInvitationStrategy?: InputMaybe<WaitlistInvitationStrategy>
  waitlistInvitationTimeout?: InputMaybe<Scalars['Float']['input']>
  waitlistSize?: InputMaybe<Scalars['Float']['input']>
}

export interface SetContentTargetingInputInput {
  targets?: InputMaybe<Array<CmsContentTargetCreateInput>>
  visibilityScope: VisibilityScope
}

export interface SetMemberMovementIncomingNotifiersInput {
  siteId: Scalars['ID']['input']
  staffUserIds: Array<Scalars['ID']['input']>
}

export interface SetMemberMovementLocationPostureInput {
  rollingApprovalType?: InputMaybe<MemberMovementRollingApprovalType>
  siteId: Scalars['ID']['input']
}

export interface SetRollingModeInput {
  attestation?: InputMaybe<MemberMovementAttestationInput>
  corporateId: Scalars['ID']['input']
  enabled: Scalars['Boolean']['input']
}

export interface SetSavedReportCategoryTargetingTargetsInput {
  targetId: Scalars['String']['input']
  targetType: TargetType
}

export interface SetSavedReportTargetingTargetsInput {
  targetId: Scalars['String']['input']
  targetType: TargetType
}

/** A membership's or package's add-on price per price group at its location */
export interface SetServiceTemplateAddOnPriceGroupPricesInput {
  prices: Array<ServiceTemplateAddOnPriceGroupPriceInput>
  serviceTemplateId: Scalars['ID']['input']
  siteId: Scalars['ID']['input']
}

export interface SetSessionTemplateFeedbackQuestionsInputInput {
  questions: Array<SetSessionTemplateFeedbackQuestionsQuestionsInput>
}

export interface SetSessionTemplateFeedbackQuestionsQuestionsInput {
  active: Scalars['Boolean']['input']
  sessionFeedbackQuestionId: Scalars['ID']['input']
}

/** Type of settlement export to generate */
export enum SettlementExportType {
  detailed = 'detailed',
  detailed_summary = 'detailed_summary',
  master = 'master',
  pdf = 'pdf',
  summary = 'summary',
}

/** Input for setting up an Ezypay gateway for a site */
export interface SetupEzypayGatewayInput {
  isSandbox: Scalars['Boolean']['input']
  merchantId?: InputMaybe<Scalars['ID']['input']>
  merchantPassword?: InputMaybe<Scalars['String']['input']>
  merchantUsername?: InputMaybe<Scalars['String']['input']>
  paymentContactEmail?: InputMaybe<Scalars['String']['input']>
  siteId: Scalars['ID']['input']
}

/** Kind of shared-credit activity entry */
export enum SharedRelationActivityType {
  SESSION_BOOKED = 'SESSION_BOOKED',
  SESSION_CANCELLED = 'SESSION_CANCELLED',
}

export enum ShiftDatesApplyTo {
  both = 'both',
  primary = 'primary',
  secondary = 'secondary',
}

/** Position of sidebar in widget layout */
export enum SidebarPosition {
  left = 'left',
  none = 'none',
  right = 'right',
}

/** The capacity a signer accepts a policy slot in */
export enum SignerCapacity {
  CLIENT_ADULT = 'CLIENT_ADULT',
  GUARDIAN = 'GUARDIAN',
  PARTICIPANT_MINOR = 'PARTICIPANT_MINOR',
}

/** Input for creating a site access point */
export interface SiteAccessPointCreateInput {
  externalConfig?: InputMaybe<Scalars['JSONObject']['input']>
  internalConfig?: InputMaybe<SiteAccessPointInternalConfigInput>
  name: Scalars['String']['input']
  provider: AccessProvider
  provisionData?: InputMaybe<Scalars['JSONObject']['input']>
  siteAccessZoneId?: InputMaybe<Scalars['String']['input']>
}

/** Internal configuration input for a site access point */
export interface SiteAccessPointInternalConfigInput {
  accessMode?: InputMaybe<AccessMode>
  doorType?: InputMaybe<DoorType>
  readerType?: InputMaybe<ReaderType>
  timerSeconds?: InputMaybe<Scalars['Float']['input']>
}

/** Current status of a site access point */
export enum SiteAccessPointStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

/** Input for updating a site access point */
export interface SiteAccessPointUpdateInput {
  externalConfig?: InputMaybe<Scalars['JSONObject']['input']>
  internalConfig?: InputMaybe<SiteAccessPointInternalConfigInput>
  name?: InputMaybe<Scalars['String']['input']>
  provisionData?: InputMaybe<Scalars['JSONObject']['input']>
  qrCodeGeneratedAt?: InputMaybe<Scalars['String']['input']>
  qrCodeUrl?: InputMaybe<Scalars['String']['input']>
  siteAccessZoneId?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<SiteAccessPointStatus>
}

/** Input for creating an access zone */
export interface SiteAccessZoneCreateInput {
  metadata?: InputMaybe<Scalars['JSONObject']['input']>
  name: Scalars['String']['input']
  siteId: Scalars['String']['input']
}

/** Input for updating an access zone */
export interface SiteAccessZoneUpdateInput {
  config?: InputMaybe<Scalars['JSONObject']['input']>
  metadata?: InputMaybe<Scalars['JSONObject']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

/** Input for the per-site accounting-code feature configuration */
export interface SiteAccountCodeConfigInput {
  accountCodesEnabled?: InputMaybe<Scalars['Boolean']['input']>
  introOfferDefaultAccountCodeId?: InputMaybe<Scalars['ID']['input']>
}

export enum SiteAccountCodeStatus {
  active = 'active',
  inactive = 'inactive',
}

/** Input for updating site admin payment gateway configuration */
export interface SiteAdminConfigPaymentGatewayInput {
  accountCodesEnabled?: InputMaybe<Scalars['Boolean']['input']>
  applePayEnabled?: InputMaybe<Scalars['Boolean']['input']>
  enableTerminals?: InputMaybe<Scalars['Boolean']['input']>
  ezypayDisplayAccountingCode?: InputMaybe<Scalars['String']['input']>
  googlePayEnabled?: InputMaybe<Scalars['Boolean']['input']>
  introOfferDefaultAccountCodeId?: InputMaybe<Scalars['String']['input']>
  stripeId?: InputMaybe<Scalars['String']['input']>
  transactionLimitAmount?: InputMaybe<Scalars['Float']['input']>
}

/** Input for updating site admin configurations */
export interface SiteAdminConfigurationsUpdateInput {
  allowToEnableClientMultiplePaymentMethods?: InputMaybe<Scalars['Boolean']['input']>
  bankAccountCapabilities?: InputMaybe<Scalars['Boolean']['input']>
  displayAccountCreditsTab?: InputMaybe<Scalars['Boolean']['input']>
  displayStripeConnectPaymentGateway?: InputMaybe<Scalars['Boolean']['input']>
  enableAddOns?: InputMaybe<Scalars['Boolean']['input']>
  enableAppAndWebsiteWidgets?: InputMaybe<Scalars['Boolean']['input']>
  enableCorporateDashboardAndPublicApi?: InputMaybe<Scalars['Boolean']['input']>
  enableDigitalLocations?: InputMaybe<Scalars['Boolean']['input']>
  enableDoorAccess?: InputMaybe<Scalars['Boolean']['input']>
  enableMembershipPlanChange?: InputMaybe<Scalars['Boolean']['input']>
  enableOfflineDoorSync?: InputMaybe<Scalars['Boolean']['input']>
  enableSharedSites?: InputMaybe<Scalars['Boolean']['input']>
  enableTanningFeatures?: InputMaybe<Scalars['Boolean']['input']>
  fees?: InputMaybe<CreateSiteAdminConfigurationsFeesInput>
  fobCredentialFormat?: InputMaybe<CreateSiteAdminConfigurationsFobCredentialFormatInput>
  hasBankAccountCapabilities?: InputMaybe<Scalars['Boolean']['input']>
  hasBankAccountRefundCapabilities?: InputMaybe<Scalars['Boolean']['input']>
  monthlySmsCredits?: InputMaybe<Scalars['Float']['input']>
  paymentGateway?: InputMaybe<CreateSiteAdminConfigurationsPaymentGatewayInput>
  processingFees?: InputMaybe<CreateSiteAdminConfigurationsProcessingFeesInput>
  sms?: InputMaybe<CreateSiteAdminConfigurationsSmsInput>
}

export enum SiteAlertStatus {
  ACTIVE = 'ACTIVE',
  ENDED = 'ENDED',
  SCHEDULED = 'SCHEDULED',
}

/** Fixed semantic look of a location alert, independent of brand colours */
export enum SiteAlertTheme {
  INFO = 'INFO',
  POSITIVE = 'POSITIVE',
  URGENT = 'URGENT',
  WARNING = 'WARNING',
}

export enum SiteAmenityGroup {
  ACCESSIBILITY = 'ACCESSIBILITY',
  EQUIPMENT = 'EQUIPMENT',
  FACILITIES = 'FACILITIES',
  MORE = 'MORE',
  SERVICES = 'SERVICES',
}

/** A Hapana catalog amenity. Append-only: keys are never renamed or removed. */
export enum SiteAmenityKey {
  ACCESSIBLE_BATHROOM = 'ACCESSIBLE_BATHROOM',
  BIKE_RACKS = 'BIKE_RACKS',
  BOXING_BAGS = 'BOXING_BAGS',
  CAFE = 'CAFE',
  CARDIO = 'CARDIO',
  CHANGE_ROOMS = 'CHANGE_ROOMS',
  CHILDCARE = 'CHILDCARE',
  COLD_PLUNGE = 'COLD_PLUNGE',
  FREE_WEIGHTS = 'FREE_WEIGHTS',
  FREE_WIFI = 'FREE_WIFI',
  FUNCTIONAL_AREA = 'FUNCTIONAL_AREA',
  HEARING_LOOP = 'HEARING_LOOP',
  LIFT = 'LIFT',
  LOCKERS = 'LOCKERS',
  OUTDOOR_AREA = 'OUTDOOR_AREA',
  PARKING = 'PARKING',
  PERSONAL_TRAINING = 'PERSONAL_TRAINING',
  POOL = 'POOL',
  RECOVERY_ZONE = 'RECOVERY_ZONE',
  REFORMERS = 'REFORMERS',
  RESISTANCE_MACHINES = 'RESISTANCE_MACHINES',
  RETAIL = 'RETAIL',
  SAUNA = 'SAUNA',
  SHOWERS = 'SHOWERS',
  SPA = 'SPA',
  STEAM_ROOM = 'STEAM_ROOM',
  STRETCHING_AREA = 'STRETCHING_AREA',
  TOWEL_SERVICE = 'TOWEL_SERVICE',
  TURF = 'TURF',
  WHEELCHAIR_ACCESS = 'WHEELCHAIR_ACCESS',
}

export enum SiteAmenityStatus {
  CLOSED = 'CLOSED',
  NO_SCHEDULE = 'NO_SCHEDULE',
  OPEN = 'OPEN',
}

export interface SiteAuditEventsFilterInput {
  actions?: InputMaybe<Array<AuditAction>>
  affectedUserId?: InputMaybe<Scalars['String']['input']>
  corporateId?: InputMaybe<Scalars['String']['input']>
  dateRange?: InputMaybe<AuditEventsFilterDateRangeInput>
  excludeActions?: InputMaybe<Array<AuditAction>>
  memberId?: InputMaybe<Scalars['String']['input']>
  resources?: InputMaybe<Array<AuditResource>>
  searchText?: InputMaybe<Scalars['String']['input']>
  severity?: InputMaybe<Array<AuditSeverity>>
  siteId?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<Array<AuditSource>>
  systemOnly?: InputMaybe<Scalars['Boolean']['input']>
  userId?: InputMaybe<Scalars['String']['input']>
  visibility?: InputMaybe<Array<AuditVisibility>>
}

/** A configuration area a site duplicate copies */
export enum SiteCloneArea {
  ACCOUNT_CODES = 'ACCOUNT_CODES',
  ADD_ONS = 'ADD_ONS',
  AGREEMENTS = 'AGREEMENTS',
  COMMUNICATIONS = 'COMMUNICATIONS',
  EQUIPMENT = 'EQUIPMENT',
  EQUIPMENT_REGULATIONS = 'EQUIPMENT_REGULATIONS',
  FEES = 'FEES',
  FORMS_AND_CUSTOM_FIELDS = 'FORMS_AND_CUSTOM_FIELDS',
  GIFT_CARDS = 'GIFT_CARDS',
  IMAGES = 'IMAGES',
  INTEGRATIONS = 'INTEGRATIONS',
  PAYROLL = 'PAYROLL',
  PLAN_OVERRIDE = 'PLAN_OVERRIDE',
  POLICIES_AND_TAX = 'POLICIES_AND_TAX',
  PRODUCT_VARIABLE_ATTRIBUTES = 'PRODUCT_VARIABLE_ATTRIBUTES',
  PROMO_CODES = 'PROMO_CODES',
  RETAIL = 'RETAIL',
  ROOMS = 'ROOMS',
  SERVICES_AND_PRICING = 'SERVICES_AND_PRICING',
  SESSION_FILTERS = 'SESSION_FILTERS',
  SESSION_TYPES_AND_TEMPLATES = 'SESSION_TYPES_AND_TEMPLATES',
  SITE_SETTINGS = 'SITE_SETTINGS',
  SUB_LOCATIONS = 'SUB_LOCATIONS',
}

/** Which optional configuration areas a site duplicate copies */
export interface SiteCloneIncludeInput {
  accountCodes: Scalars['Boolean']['input']
  addOns: Scalars['Boolean']['input']
  agreements: Scalars['Boolean']['input']
  equipmentRegulations: Scalars['Boolean']['input']
  fees: Scalars['Boolean']['input']
  images: Scalars['Boolean']['input']
  integrations: Scalars['Boolean']['input']
  planOverride: Scalars['Boolean']['input']
  productVariableAttributes: Scalars['Boolean']['input']
  promoCodes: Scalars['Boolean']['input']
  rooms: Scalars['Boolean']['input']
  sessionFilters: Scalars['Boolean']['input']
}

export enum SiteCloneJobStatus {
  FAILED = 'FAILED',
  QUEUED = 'QUEUED',
  RUNNING = 'RUNNING',
  SUCCEEDED = 'SUCCEEDED',
}

export enum SiteCloneJobStep {
  APPLYING_SITE_SETTINGS = 'APPLYING_SITE_SETTINGS',
  COPYING_CONFIGURATION = 'COPYING_CONFIGURATION',
  COPYING_IMAGES = 'COPYING_IMAGES',
  COPYING_PRICING = 'COPYING_PRICING',
  COPYING_SERVICES = 'COPYING_SERVICES',
  CREATING_SITE = 'CREATING_SITE',
  DONE = 'DONE',
  QUEUED = 'QUEUED',
  RECONCILING_TAX = 'RECONCILING_TAX',
}

/** Input for updating site communication templates */
export interface SiteCommunicationTemplateUpdateInput {
  allowedPlaceholders?: InputMaybe<Array<CommunicationTemplatePlaceholders>>
  emailBody?: InputMaybe<Scalars['String']['input']>
  emailCcEmail?: InputMaybe<Scalars['String']['input']>
  emailCcLocation?: InputMaybe<Scalars['Boolean']['input']>
  emailCopyEmployee?: InputMaybe<EmailCopyEmployee>
  emailDefaultOn?: InputMaybe<Scalars['Boolean']['input']>
  emailEnabled?: InputMaybe<Scalars['Boolean']['input']>
  emailReplyToEmail?: InputMaybe<Scalars['String']['input']>
  emailReplyToName?: InputMaybe<Scalars['String']['input']>
  emailSendBefore?: InputMaybe<Scalars['Float']['input']>
  emailSendBeforeUnit?: InputMaybe<EmailSendBeforeUnit>
  emailSendCalendarAttachment?: InputMaybe<Scalars['Boolean']['input']>
  emailSendEmailAs?: InputMaybe<EmailSendAs>
  emailSendOnlyToActiveClients?: InputMaybe<Scalars['Boolean']['input']>
  emailSubject?: InputMaybe<Scalars['String']['input']>
  emailUseHapanaLayout?: InputMaybe<Scalars['Boolean']['input']>
  pushNotificationDefaultOn?: InputMaybe<Scalars['Boolean']['input']>
  pushNotificationEnabled?: InputMaybe<Scalars['Boolean']['input']>
  pushNotificationMessage?: InputMaybe<Scalars['String']['input']>
  pushNotificationTitle?: InputMaybe<Scalars['String']['input']>
  readOnly?: InputMaybe<Scalars['Boolean']['input']>
  smsDefaultOn?: InputMaybe<Scalars['Boolean']['input']>
  smsEnabled?: InputMaybe<Scalars['Boolean']['input']>
  smsMessage?: InputMaybe<Scalars['String']['input']>
  targetedServiceTemplateIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export interface SiteCommunicationTemplatesActiveCommunicationTypeInput {
  operator: Scalars['String']['input']
  value: Scalars['String']['input']
}

/** Why a site duplicate was refused or failed */
export enum SiteDuplicateErrorCode {
  CLEANUP_FAILED = 'CLEANUP_FAILED',
  COPY_FAILED = 'COPY_FAILED',
  INTERRUPTED = 'INTERRUPTED',
  INVALID_TIMEZONE = 'INVALID_TIMEZONE',
  JOB_NOT_FOUND = 'JOB_NOT_FOUND',
  NAME_TAKEN = 'NAME_TAKEN',
  REGION_NOT_FOUND = 'REGION_NOT_FOUND',
  SOURCE_NOT_FOUND = 'SOURCE_NOT_FOUND',
  SOURCE_NOT_V2 = 'SOURCE_NOT_V2',
  ZONE_NOT_IN_COUNTRY = 'ZONE_NOT_IN_COUNTRY',
}

/** Details of the new site and what a duplicate copies from its source */
export interface SiteDuplicateInput {
  addressCity?: InputMaybe<Scalars['String']['input']>
  addressPostalCode?: InputMaybe<Scalars['String']['input']>
  addressStreet?: InputMaybe<Scalars['String']['input']>
  appName?: InputMaybe<Scalars['String']['input']>
  countryId: Scalars['ID']['input']
  email: Scalars['String']['input']
  enableV2: Scalars['Boolean']['input']
  idempotencyKey: Scalars['ID']['input']
  include: SiteCloneIncludeInput
  name: Scalars['String']['input']
  phone?: InputMaybe<Scalars['String']['input']>
  regionId?: InputMaybe<Scalars['ID']['input']>
  sourceSiteId: Scalars['ID']['input']
  timezone: Scalars['String']['input']
  zoneId: Scalars['ID']['input']
}

/** Input for creating site form questions */
export interface SiteFormQuestionCreateInput {
  options?: InputMaybe<Array<Scalars['String']['input']>>
  siteCustomPropertyId?: InputMaybe<Scalars['ID']['input']>
  title: Scalars['String']['input']
  type: SiteFormQuestionType
}

export enum SiteFormQuestionType {
  boolean = 'boolean',
  radio = 'radio',
  range = 'range',
  select = 'select',
  signature = 'signature',
  text = 'text',
  textBlurb = 'textBlurb',
}

/** Input for updating site form questions */
export interface SiteFormQuestionUpdateInput {
  options?: InputMaybe<Array<Scalars['String']['input']>>
  siteCustomPropertyId?: InputMaybe<Scalars['ID']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<SiteFormQuestionType>
}

/** A Hapana-provided form template */
export enum SiteFormTemplateKey {
  FITZPATRICK_SKIN_TYPE = 'FITZPATRICK_SKIN_TYPE',
}

/** Input for updating site forms */
export interface SiteFormUpdateInput {
  description?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export enum SiteGroupOrderBy {
  name = 'name',
}

export interface SiteGroupsOrderByInput {
  column: SiteGroupOrderBy
  direction: OrderByDirection
}

/** Icons a business can choose for an information block or custom amenity */
export enum SiteInfoBlockIcon {
  ACCESSIBILITY = 'ACCESSIBILITY',
  CAFE = 'CAFE',
  CHILDCARE = 'CHILDCARE',
  CLOCK = 'CLOCK',
  EQUIPMENT = 'EQUIPMENT',
  INFO = 'INFO',
  LOCKER = 'LOCKER',
  PARKING = 'PARKING',
  SHOWER = 'SHOWER',
  STAR = 'STAR',
  TOWEL = 'TOWEL',
  WIFI = 'WIFI',
}

/** Icon vocabulary for amenities and information blocks */
export enum SiteInfoIcon {
  ACCESSIBILITY = 'ACCESSIBILITY',
  BIKE = 'BIKE',
  BOXING_GLOVE = 'BOXING_GLOVE',
  CAFE = 'CAFE',
  CHILDCARE = 'CHILDCARE',
  CLOCK = 'CLOCK',
  DOOR = 'DOOR',
  DUMBBELL = 'DUMBBELL',
  EQUIPMENT = 'EQUIPMENT',
  HEARING = 'HEARING',
  HEART = 'HEART',
  INFO = 'INFO',
  LEAF = 'LEAF',
  LIFT = 'LIFT',
  LOCKER = 'LOCKER',
  PARKING = 'PARKING',
  PERSON = 'PERSON',
  REFORMER = 'REFORMER',
  RETAIL_BAG = 'RETAIL_BAG',
  SHOWER = 'SHOWER',
  SNOWFLAKE = 'SNOWFLAKE',
  STAR = 'STAR',
  STEAM = 'STEAM',
  STRETCH = 'STRETCH',
  TOWEL = 'TOWEL',
  TURF = 'TURF',
  WATER = 'WATER',
  WIFI = 'WIFI',
}

/** A custom late-cancel fee to create (no id) or update (id present) */
export interface SiteLateCancelFeeSaveInput {
  automaticCharge: Scalars['Boolean']['input']
  creditRefund: Scalars['Boolean']['input']
  lateCancelFeeId?: InputMaybe<Scalars['ID']['input']>
  name: Scalars['String']['input']
  price: Scalars['Numeric']['input']
  revenueTagId?: InputMaybe<Scalars['ID']['input']>
  taxSettingIds?: InputMaybe<Array<Scalars['ID']['input']>>
  unlimitedCreditsOnly: Scalars['Boolean']['input']
}

/** Type of site location - physical or digital channel */
export enum SiteLocationType {
  DIGITAL = 'DIGITAL',
  PHYSICAL = 'PHYSICAL',
}

/** A custom no-show fee to create (no id) or update (id present) */
export interface SiteNoShowFeeSaveInput {
  automaticCharge: Scalars['Boolean']['input']
  creditRefund: Scalars['Boolean']['input']
  name: Scalars['String']['input']
  noShowFeeId?: InputMaybe<Scalars['ID']['input']>
  price: Scalars['Numeric']['input']
  revenueTagId?: InputMaybe<Scalars['ID']['input']>
  taxSettingIds?: InputMaybe<Array<Scalars['ID']['input']>>
  unlimitedCreditsOnly: Scalars['Boolean']['input']
}

/** Onboarding status for site payment gateway */
export enum SitePaymentGatewayOnboardingStatus {
  InProgress = 'InProgress',
  NotStarted = 'NotStarted',
  Onboarded = 'Onboarded',
  PendingVerification = 'PendingVerification',
  Rejected = 'Rejected',
  RequiresAction = 'RequiresAction',
  Suspended = 'Suspended',
}

/** Site-level permissions for staff users */
export enum SitePermissions {
  access__capital = 'access__capital',
  access__clients = 'access__clients',
  access__dashboards__display_home_revenue_and_retail_snapshot = 'access__dashboards__display_home_revenue_and_retail_snapshot',
  access__dashboards__display_home_snapshot = 'access__dashboards__display_home_snapshot',
  access__notifications__receive_sms_running_low = 'access__notifications__receive_sms_running_low',
  access__reports = 'access__reports',
  access__retail = 'access__retail',
  access__settings = 'access__settings',
  audit__read = 'audit__read',
  clients__bulk_edit_packages_expiry_date = 'clients__bulk_edit_packages_expiry_date',
  clients__client_merge = 'clients__client_merge',
  clients__client_password_reset = 'clients__client_password_reset',
  clients__delete = 'clients__delete',
  clients__owed_balance_block__override = 'clients__owed_balance_block__override',
  clients__policy_forms__approve_paper = 'clients__policy_forms__approve_paper',
  clients__policy_forms__record_paper = 'clients__policy_forms__record_paper',
  clients__policy_forms__view_evidence = 'clients__policy_forms__view_evidence',
  clients__policy_forms__void = 'clients__policy_forms__void',
  commissions__adjust = 'commissions__adjust',
  commissions__attribution__edit = 'commissions__attribution__edit',
  content__create = 'content__create',
  content__delete_own = 'content__delete_own',
  content__edit_own = 'content__edit_own',
  content__publish_own = 'content__publish_own',
  content__view_corporate = 'content__view_corporate',
  import__approve_and_execute = 'import__approve_and_execute',
  import__delete = 'import__delete',
  import__download_audit = 'import__download_audit',
  import__download_source = 'import__download_source',
  import__initiate = 'import__initiate',
  import__preview = 'import__preview',
  member_movement__approve_incoming = 'member_movement__approve_incoming',
  member_movement__manage_incoming = 'member_movement__manage_incoming',
  payments__access_to_cash_draw = 'payments__access_to_cash_draw',
  payments__advanced_checkout = 'payments__advanced_checkout',
  payments__advanced_checkout__auto_renew = 'payments__advanced_checkout__auto_renew',
  payments__advanced_checkout__credit_activation_date = 'payments__advanced_checkout__credit_activation_date',
  payments__advanced_checkout__credit_valid_until = 'payments__advanced_checkout__credit_valid_until',
  payments__advanced_checkout__discount_any_price = 'payments__advanced_checkout__discount_any_price',
  payments__advanced_checkout__discount_only_lower_price = 'payments__advanced_checkout__discount_only_lower_price',
  payments__advanced_checkout__first_payment_date = 'payments__advanced_checkout__first_payment_date',
  payments__advanced_checkout__one_time_setup_fee = 'payments__advanced_checkout__one_time_setup_fee',
  payments__advanced_checkout__pay_up_front = 'payments__advanced_checkout__pay_up_front',
  payments__bulk_edit_transactions = 'payments__bulk_edit_transactions',
  payments__change_client_payment_method = 'payments__change_client_payment_method',
  payments__edit_dishonor_fee = 'payments__edit_dishonor_fee',
  payments__invoice_reinstate = 'payments__invoice_reinstate',
  payments__payroll_report_access = 'payments__payroll_report_access',
  payments__process_payments_within_schedule = 'payments__process_payments_within_schedule',
  payments__refund = 'payments__refund',
  payments__request_payment_access = 'payments__request_payment_access',
  payments__retry_failed_payment_with_payment_method = 'payments__retry_failed_payment_with_payment_method',
  payments__send_payment_request_email = 'payments__send_payment_request_email',
  payments__service_cancellation = 'payments__service_cancellation',
  payments__service_cancellation_notice_override = 'payments__service_cancellation_notice_override',
  payments__service_credit_adjustment = 'payments__service_credit_adjustment',
  payments__service_plan_change = 'payments__service_plan_change',
  reports__client_and_attendance = 'reports__client_and_attendance',
  reports__commissions = 'reports__commissions',
  reports__download = 'reports__download',
  reports__edit_restricted_reports = 'reports__edit_restricted_reports',
  reports__financial = 'reports__financial',
  reports__inventory = 'reports__inventory',
  reports__policy_evidence_export = 'reports__policy_evidence_export',
  reports__staff = 'reports__staff',
  retail__sales__sell_outside_availability = 'retail__sales__sell_outside_availability',
  retail__sales__sell_outside_dynamic_display = 'retail__sales__sell_outside_dynamic_display',
  schedule__add_or_remove_booked_clients = 'schedule__add_or_remove_booked_clients',
  schedule__allow_as_instructor_for_schedule = 'schedule__allow_as_instructor_for_schedule',
  schedule__allow_bookings_for_team_outside_of_employee_work_hours = 'schedule__allow_bookings_for_team_outside_of_employee_work_hours',
  schedule__allow_custom_session_creation = 'schedule__allow_custom_session_creation',
  schedule__booking_for_all_team_members = 'schedule__booking_for_all_team_members',
  schedule__booking_requests = 'schedule__booking_requests',
  schedule__bulk_cancel_sessions = 'schedule__bulk_cancel_sessions',
  schedule__communicate_with_clients_within_schedule = 'schedule__communicate_with_clients_within_schedule',
  schedule__covers__approve = 'schedule__covers__approve',
  schedule__covers__claim = 'schedule__covers__claim',
  schedule__covers__manage_qualifications = 'schedule__covers__manage_qualifications',
  schedule__covers__request = 'schedule__covers__request',
  schedule__edit_of_employee_work_hours = 'schedule__edit_of_employee_work_hours',
  schedule__enable_late_cancel_and_refund = 'schedule__enable_late_cancel_and_refund',
  schedule__enable_sub_instructor = 'schedule__enable_sub_instructor',
  schedule__enable_sub_instructor_edit_instructor = 'schedule__enable_sub_instructor_edit_instructor',
  schedule__manage_site_views = 'schedule__manage_site_views',
  schedule__mark_attendance = 'schedule__mark_attendance',
  schedule__sessions__add_and_edit = 'schedule__sessions__add_and_edit',
  schedule__sessions__cancel = 'schedule__sessions__cancel',
  schedule__sessions__delete = 'schedule__sessions__delete',
  schedule__soap_notes__read = 'schedule__soap_notes__read',
  schedule__soap_notes__write = 'schedule__soap_notes__write',
  schedule__team_view_access = 'schedule__team_view_access',
  settings__account = 'settings__account',
  settings__account__billing = 'settings__account__billing',
  settings__account__commissions = 'settings__account__commissions',
  settings__account__invoice = 'settings__account__invoice',
  settings__account__manage_add_ons = 'settings__account__manage_add_ons',
  settings__account__manage_plan = 'settings__account__manage_plan',
  settings__account__payroll = 'settings__account__payroll',
  settings__account__point_of_sale = 'settings__account__point_of_sale',
  settings__account__sms_credits = 'settings__account__sms_credits',
  settings__account__tax = 'settings__account__tax',
  settings__covers = 'settings__covers',
  settings__location = 'settings__location',
  settings__location__checkin = 'settings__location__checkin',
  settings__location__communication = 'settings__location__communication',
  settings__location__configurations = 'settings__location__configurations',
  settings__location__integrations = 'settings__location__integrations',
  settings__location__member_alerts = 'settings__location__member_alerts',
  settings__location__operations = 'settings__location__operations',
  settings__location__policy_gating = 'settings__location__policy_gating',
  settings__location__policy_import = 'settings__location__policy_import',
  settings__location__policy_import_trusted = 'settings__location__policy_import_trusted',
  settings__location__social_media = 'settings__location__social_media',
  settings__location__website_widgets = 'settings__location__website_widgets',
  settings__retail = 'settings__retail',
  settings__retail__account_codes__read = 'settings__retail__account_codes__read',
  settings__retail__account_codes__write = 'settings__retail__account_codes__write',
  settings__retail__add_ons__read = 'settings__retail__add_ons__read',
  settings__retail__add_ons__write = 'settings__retail__add_ons__write',
  settings__retail__fees = 'settings__retail__fees',
  settings__retail__general_settings = 'settings__retail__general_settings',
  settings__retail__gift_cards__read = 'settings__retail__gift_cards__read',
  settings__retail__gift_cards__write = 'settings__retail__gift_cards__write',
  settings__retail__memberships__archive = 'settings__retail__memberships__archive',
  settings__retail__memberships__read = 'settings__retail__memberships__read',
  settings__retail__memberships__write = 'settings__retail__memberships__write',
  settings__retail__memberships__write_restricted = 'settings__retail__memberships__write_restricted',
  settings__retail__packages__archive = 'settings__retail__packages__archive',
  settings__retail__packages__read = 'settings__retail__packages__read',
  settings__retail__packages__write = 'settings__retail__packages__write',
  settings__retail__packages__write_restricted = 'settings__retail__packages__write_restricted',
  settings__retail__products__read = 'settings__retail__products__read',
  settings__retail__products__write_add = 'settings__retail__products__write_add',
  settings__retail__products__write_edit = 'settings__retail__products__write_edit',
  settings__retail__promo_codes = 'settings__retail__promo_codes',
  settings__retail__sale_settings = 'settings__retail__sale_settings',
  settings__retail__terminals = 'settings__retail__terminals',
  settings__scheduler = 'settings__scheduler',
  settings__scheduler__calendar_configurations = 'settings__scheduler__calendar_configurations',
  settings__scheduler__rules = 'settings__scheduler__rules',
  settings__scheduler__session_templates = 'settings__scheduler__session_templates',
  settings__scheduler__session_types = 'settings__scheduler__session_types',
  site_pii__export_pii = 'site_pii__export_pii',
  site_pii__view_contact_details = 'site_pii__view_contact_details',
  site_pii__view_full_identity = 'site_pii__view_full_identity',
  wellness__equipment_eligibility__view = 'wellness__equipment_eligibility__view',
  wellness__equipment_lamps__manage = 'wellness__equipment_lamps__manage',
  wellness__equipment_skin_type__assign = 'wellness__equipment_skin_type__assign',
  wellness__equipment_skin_type__override = 'wellness__equipment_skin_type__override',
  wellness__equipment_test_time__override = 'wellness__equipment_test_time__override',
  wellness__equipments__manage = 'wellness__equipments__manage',
}

/** Input for updating site policies */
export interface SitePolicyUpdateInput {
  acceptanceMethod?: InputMaybe<PolicyAcceptanceMethod>
  content?: InputMaybe<Scalars['String']['input']>
  /** Site-local date the new revision starts blocking; omit to publish immediately */
  effectiveFrom?: InputMaybe<Scalars['String']['input']>
  equipmentScope?: InputMaybe<Array<PolicyEquipmentScope>>
  guardianInPersonOnly?: InputMaybe<Scalars['Boolean']['input']>
  isRequiredToAgree?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  renewalMonths?: InputMaybe<Scalars['Float']['input']>
  /** Ask clients to accept again: the new revision raises the acceptance generation */
  requireReacceptance?: InputMaybe<Scalars['Boolean']['input']>
  requiredForEquipmentUse?: InputMaybe<Scalars['Boolean']['input']>
  signerRule?: InputMaybe<PolicySignerRule>
}

/** Types of template properties (primary or custom) */
export enum SiteRoomResourceTemplatePropertyTypes {
  custom = 'custom',
  primary = 'primary',
}

export interface SiteSessionTypeCustomColorsInput {
  colorName: Scalars['String']['input']
  hexCode: Scalars['String']['input']
}

/** Input for creating a site session type */
export interface SiteSessionTypeInput {
  allowEditingSessionType: Scalars['Boolean']['input']
  allowMultiLocationAccess: Scalars['Boolean']['input']
  category?: InputMaybe<Scalars['String']['input']>
  code?: InputMaybe<Scalars['Float']['input']>
  color: Scalars['String']['input']
  customColors?: InputMaybe<Array<SiteSessionTypeCustomColorsInput>>
  displayOrder?: InputMaybe<Scalars['Float']['input']>
  name: Scalars['String']['input']
}

/** Input for updating a site session type */
export interface SiteSessionTypeUpdateInput {
  allowEditingSessionType?: InputMaybe<Scalars['Boolean']['input']>
  allowMultiLocationAccess?: InputMaybe<Scalars['Boolean']['input']>
  category?: InputMaybe<Scalars['String']['input']>
  code?: InputMaybe<Scalars['Float']['input']>
  color?: InputMaybe<Scalars['String']['input']>
  customColors?: InputMaybe<Array<SiteSessionTypeCustomColorsInput>>
  displayOrder?: InputMaybe<Scalars['Float']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export enum SiteStatus {
  active = 'active',
  inactive = 'inactive',
}

export enum SiteSupplierStatus {
  active = 'active',
  inactive = 'inactive',
}

export enum SiteTerminalReaderOrderByField {
  createdAt = 'createdAt',
  isActive = 'isActive',
  name = 'name',
}

export interface SiteTerminalReadersOrderByInput {
  column: SiteTerminalReaderOrderByField
  direction: OrderByDirection
}

/** Site-level theme enablement status */
export enum SiteThemeStatus {
  Active = 'Active',
  Disabled = 'Disabled',
}

export enum SiteWebhookDeliveryStatus {
  failed = 'failed',
  pending = 'pending',
  retrying = 'retrying',
  success = 'success',
}

export enum SiteWebhookStatus {
  disabled = 'disabled',
  enabled = 'enabled',
  failing = 'failing',
}

export enum SiteWebhookStatusInput {
  disabled = 'disabled',
  enabled = 'enabled',
}

export enum SiteWorkshopType {
  crossfit = 'crossfit',
  cycling = 'cycling',
  dance = 'dance',
  fitness = 'fitness',
  martial_arts = 'martial_arts',
  pilates = 'pilates',
  swimming = 'swimming',
  yoga = 'yoga',
}

/** Workshop category filter for the Website Widgets configurator */
export enum SiteWorkshopTypes {
  CONTINUOUS = 'CONTINUOUS',
  RECURRING = 'RECURRING',
  SINGLE = 'SINGLE',
}

export interface SitesFilterCreatedAtInput {
  /** Filter by creation date from (ISO string) */
  from?: InputMaybe<Scalars['String']['input']>
  /** Filter by creation date to (ISO string) */
  to?: InputMaybe<Scalars['String']['input']>
}

export interface SitesFilterInput {
  /** Filter by creation date range */
  createdAt?: InputMaybe<SitesFilterCreatedAtInput>
  /** Filter by digital status */
  isDigital?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter by V2 enabled status (from admin DB SiteIndex) */
  isV2Enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter by site status */
  status?: InputMaybe<SiteStatus>
}

export enum SitesOrderBy {
  appName = 'appName',
  corePlanLevel = 'corePlanLevel',
  createdAt = 'createdAt',
  isDigital = 'isDigital',
  name = 'name',
  siteId = 'siteId',
  status = 'status',
}

export interface SitesOrderByInput {
  column: SitesOrderBy
  direction: OrderByDirection
}

/** Where the client's skin type assessment stands against this location's requirement for UV sessions */
export enum SkinTypeEligibilityStatus {
  CONFIGURATION_ERROR = 'CONFIGURATION_ERROR',
  CURRENT = 'CURRENT',
  DUE = 'DUE',
  MISSING = 'MISSING',
  NOT_REQUIRED = 'NOT_REQUIRED',
}

/** What staff may do next for this client on a UV bed */
export enum SkinTypePermittedAction {
  OVERRIDE = 'OVERRIDE',
  SEND_FORM = 'SEND_FORM',
  START = 'START',
}

/** Whether a UV session needs a current skin type assessment: not required, warn the operator, or block until it is done or overridden */
export enum SkinTypeRequirementMode {
  BLOCK = 'BLOCK',
  OFF = 'OFF',
  WARN = 'WARN',
}

/** Supported currencies for SMS packages */
export enum SmsAllowedCurrencies {
  AUD = 'AUD',
  USD = 'USD',
}

/** Direction of SMS credits movement: in (added) or out (consumed) */
export enum SmsCreditsDirection {
  in = 'in',
  out = 'out',
}

/** Reason for SMS credits movement: monthly_allocation, extra_purchase, or consumption */
export enum SmsCreditsReason {
  consumption = 'consumption',
  extra_purchase = 'extra_purchase',
  monthly_allocation = 'monthly_allocation',
}

export interface SmsPackagesFilterInput {
  /** Filter by country ID */
  countryId?: InputMaybe<Scalars['ID']['input']>
  /** Filter by currency */
  currency?: InputMaybe<SmsAllowedCurrencies>
}

export enum SmsPackagesOrderBy {
  country = 'country',
  createdAt = 'createdAt',
  currency = 'currency',
  updatedAt = 'updatedAt',
}

export interface SmsPackagesOrderByInput {
  column: SmsPackagesOrderBy
  direction: OrderByDirection
}

export interface SoapNoteCreateContentInput {
  assessment?: InputMaybe<Scalars['String']['input']>
  objective?: InputMaybe<Scalars['String']['input']>
  plan?: InputMaybe<Scalars['String']['input']>
  sessionDate: Scalars['String']['input']
  sessionTitle: Scalars['String']['input']
  subjective?: InputMaybe<Scalars['String']['input']>
  trainerName: Scalars['String']['input']
}

/** Input for creating a SOAP note */
export interface SoapNoteCreateInput {
  clientId: Scalars['String']['input']
  content: SoapNoteCreateContentInput
  sessionId: Scalars['String']['input']
}

/** Input for updating a SOAP note */
export interface SoapNoteUpdateInput {
  content?: InputMaybe<SoapNoteCreateContentInput>
}

export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum SortOrder {
  asc = 'asc',
  desc = 'desc',
}

/** Sort package direction options */
export enum SortPackageDirection {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING',
}

/** Sort package field options */
export enum SortPackageField {
  NAME = 'NAME',
  PRICE = 'PRICE',
}

export enum Source {
  AGGREGATOR = 'AGGREGATOR',
  APP = 'APP',
  KIOSK = 'KIOSK',
  STAFF = 'STAFF',
  WEB = 'WEB',
}

export interface StaffAccessPoliciesOrderByInput {
  column: StaffAccessPolicyOrderBy
  direction: OrderByDirection
}

export enum StaffAccessPolicyOrderBy {
  name = 'name',
}

/** Type of site assignment for access rules */
export enum StaffAccessRuleAssignmentType {
  DIRECT_SITES = 'DIRECT_SITES',
  SITE_GROUPS = 'SITE_GROUPS',
}

/** Input for creating a staff session assignment */
export interface StaffSessionAssignmentCreateInput {
  role?: InputMaybe<StaffSessionRole>
  sessionId: Scalars['String']['input']
  siteId?: InputMaybe<Scalars['String']['input']>
  staffUserId: Scalars['String']['input']
}

/** Input for updating a staff session assignment */
export interface StaffSessionAssignmentUpdateInput {
  role: StaffSessionRole
}

/** Role of a staff member in a session */
export enum StaffSessionRole {
  ASSISTANT = 'ASSISTANT',
  INSTRUCTOR = 'INSTRUCTOR',
  SUBSTITUTE = 'SUBSTITUTE',
}

/** Levels of access a staff user can have */
export enum StaffUserAccessLevel {
  access = 'access',
  corporate = 'corporate',
  sites = 'sites',
}

export enum StaffUserOrderBy {
  firstName = 'firstName',
  lastName = 'lastName',
}

/** Current status of a staff user */
export enum StaffUserStatus {
  active = 'active',
  inactive = 'inactive',
}

/** Input for starting Stripe Connect onboarding */
export interface StartStripeConnectOnboardingInput {
  isSandbox: Scalars['Boolean']['input']
  paymentContactEmail?: InputMaybe<Scalars['String']['input']>
  siteId: Scalars['ID']['input']
}

export interface StartSupportChatInput {
  initialMessage: Scalars['String']['input']
  locale?: InputMaybe<Scalars['String']['input']>
  locationId?: InputMaybe<Scalars['String']['input']>
  locationName?: InputMaybe<Scalars['String']['input']>
  pageContextMeta?: InputMaybe<Scalars['JSON']['input']>
  pageName?: InputMaybe<Scalars['String']['input']>
  pathname?: InputMaybe<Scalars['String']['input']>
  planTier?: InputMaybe<Scalars['String']['input']>
  scopeLevel?: InputMaybe<Scalars['String']['input']>
  scopeName?: InputMaybe<Scalars['String']['input']>
  siteId?: InputMaybe<Scalars['String']['input']>
  siteName?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<SupportChatSource>
  suggestedQuickQuestionId?: InputMaybe<Scalars['String']['input']>
  timezone?: InputMaybe<Scalars['String']['input']>
  userId: Scalars['String']['input']
  userRole?: InputMaybe<Scalars['String']['input']>
}

export enum StoreBlockerKind {
  apple_agreements = 'apple_agreements',
  apple_app_record = 'apple_app_record',
  apple_credentials = 'apple_credentials',
  play_access = 'play_access',
  play_agreements = 'play_agreements',
}

export interface StreamSupportMessageInput {
  locale?: InputMaybe<Scalars['String']['input']>
  locationId?: InputMaybe<Scalars['String']['input']>
  locationName?: InputMaybe<Scalars['String']['input']>
  pageContextMeta?: InputMaybe<Scalars['JSON']['input']>
  siteId?: InputMaybe<Scalars['String']['input']>
  siteName?: InputMaybe<Scalars['String']['input']>
  streamId: Scalars['String']['input']
  supportChatId: Scalars['String']['input']
  text: Scalars['String']['input']
  timezone?: InputMaybe<Scalars['String']['input']>
}

/** The type of agreement for a country */
export enum StripeAgreementType {
  Full = 'Full',
  Recipient = 'Recipient',
}

/** Supported currencies for Stripe payouts */
export enum StripePayoutCurrency {
  AUD = 'AUD',
  CAD = 'CAD',
  EUR = 'EUR',
  GBP = 'GBP',
  NZD = 'NZD',
  SGD = 'SGD',
  USD = 'USD',
}

export interface SubmitClientFormsQuestionnaireAnswersInput {
  answer: Scalars['String']['input']
  expectedRevision?: InputMaybe<Scalars['Float']['input']>
  formId: Scalars['String']['input']
  formName: Scalars['String']['input']
  question: Scalars['String']['input']
  questionId: Scalars['String']['input']
  signupAttemptId?: InputMaybe<Scalars['ID']['input']>
  type: Scalars['String']['input']
}

export interface SubmitFormAnswersAnswersInput {
  answer: Scalars['String']['input']
  siteFormQuestionId: Scalars['String']['input']
}

export interface SubmitSessionFeedbackFeedbackAnswersInput {
  answer: Scalars['String']['input']
  questionId: Scalars['String']['input']
  questionText: Scalars['String']['input']
}

export interface SubmitSessionFeedbackInputInput {
  attendanceId: Scalars['String']['input']
  clientId: Scalars['String']['input']
  comments?: InputMaybe<Scalars['String']['input']>
  feedbackAnswers: Array<SubmitSessionFeedbackFeedbackAnswersInput>
  overallRating?: InputMaybe<Scalars['Float']['input']>
  sessionId: Scalars['String']['input']
  siteId: Scalars['String']['input']
}

/** Input for substituting an instructor in a session */
export interface SubstituteInstructorInput {
  instructorToRemoveId: Scalars['String']['input']
  sessionId: Scalars['String']['input']
  substituteInstructorId: Scalars['String']['input']
}

export enum SupportChatSource {
  API = 'API',
  EMAIL = 'EMAIL',
  SLACK = 'SLACK',
  UI = 'UI',
}

export enum SupportChatStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  ENDED = 'ENDED',
}

export enum SupportIssueType {
  CHANGE_PLAN = 'CHANGE_PLAN',
  DATA_TASK = 'DATA_TASK',
  FEATURE_REQUEST = 'FEATURE_REQUEST',
  GENERAL_QUESTION = 'GENERAL_QUESTION',
  OTHER = 'OTHER',
  REPORT_A_PROBLEM = 'REPORT_A_PROBLEM',
  STUDIO_BILLING_CONCERN = 'STUDIO_BILLING_CONCERN',
  SUCCESS_REQUEST = 'SUCCESS_REQUEST',
}

export interface SupportMessageFeedbackInput {
  /** true = helpful, false = not helpful, null = rating cleared */
  feedback?: InputMaybe<Scalars['Boolean']['input']>
  pageName?: InputMaybe<Scalars['String']['input']>
  pathname?: InputMaybe<Scalars['String']['input']>
  /** Location the staff member was in when they rated (absent at brand level) */
  siteId?: InputMaybe<Scalars['String']['input']>
  supportChatId: Scalars['String']['input']
  supportChatMessageId: Scalars['String']['input']
}

export enum SupportMessageRole {
  ASSISTANT = 'ASSISTANT',
  SYSTEM = 'SYSTEM',
  USER = 'USER',
}

export interface SupportTicketFieldInput {
  key: Scalars['String']['input']
  label: Scalars['String']['input']
  value: Scalars['String']['input']
}

/** Supported payment gateway */
export enum SupportedPaymentGateway {
  Ezypay = 'Ezypay',
  Stripe = 'Stripe',
}

/** One pause in a batch. Every field the single-pause form carries is repeated per pause: reason, window, pause type and fee. */
export interface SuspendServiceBatchPauseInput {
  chargeAmount?: InputMaybe<Scalars['Numeric']['input']>
  chargeMode?: InputMaybe<ServiceSuspensionChargeMode>
  endDate?: InputMaybe<Scalars['String']['input']>
  feeBillingCycleAmount?: InputMaybe<Scalars['Float']['input']>
  feeBillingCycleUnit?: InputMaybe<Scalars['String']['input']>
  reason?: InputMaybe<Scalars['String']['input']>
  startDate?: InputMaybe<Scalars['String']['input']>
  suspensionType?: InputMaybe<ServiceSuspensionType>
}

export enum SuspensionRowState {
  Paused = 'Paused',
  Rescheduled = 'Rescheduled',
}

/** One parent attachment (price, payment type, tax) for an add-on template */
export interface SyncServiceTemplateAddOnParentInput {
  corporatePricePointId?: InputMaybe<Scalars['ID']['input']>
  enabled: Scalars['Boolean']['input']
  parentServiceTemplateId: Scalars['ID']['input']
  paymentType: ServiceTemplateAddOnPaymentType
  price: Scalars['Numeric']['input']
  taxEnabled: Scalars['Boolean']['input']
  taxSettingIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

/** Input replacing an add-on template's full set of parent attachments */
export interface SyncServiceTemplateAddOnParentsInput {
  addOnServiceTemplateId: Scalars['ID']['input']
  parents: Array<SyncServiceTemplateAddOnParentInput>
}

export interface SyncSmsPackageOptionsInputInput {
  /** Complete list of desired options - backend handles add/update/delete */
  options: Array<SyncSmsPackageOptionsOptionsInput>
}

export interface SyncSmsPackageOptionsOptionsInput {
  /** Number of SMS credits in this package */
  count: Scalars['Float']['input']
  /** Option ID - omit for new options */
  optionId?: InputMaybe<Scalars['ID']['input']>
  /** Price for this SMS package option */
  price: Scalars['Float']['input']
}

/** Sync status for Grow integration */
export enum SyncStatus {
  failed = 'failed',
  pending = 'pending',
  success = 'success',
  syncing = 'syncing',
}

export enum TagMatch {
  all = 'all',
  any = 'any',
}

/** Why a call to the tanning connector failed */
export enum TanningConnectorErrorKind {
  ADDRESS_NOT_FOUND = 'ADDRESS_NOT_FOUND',
  CERTIFICATE = 'CERTIFICATE',
  CONNECTION_REFUSED = 'CONNECTION_REFUSED',
  CONNECTOR_REFUSED = 'CONNECTOR_REFUSED',
  HOST_UNREACHABLE = 'HOST_UNREACHABLE',
  NOT_THE_CONNECTOR = 'NOT_THE_CONNECTOR',
  SECURE_CONNECTION_FAILED = 'SECURE_CONNECTION_FAILED',
  TIMED_OUT = 'TIMED_OUT',
  UNKNOWN = 'UNKNOWN',
  WRONG_KEY = 'WRONG_KEY',
}

/** Why a tanning connector is not working, most severe first */
export enum TanningConnectorHealthReason {
  ADDRESS_SHARED = 'ADDRESS_SHARED',
  CONNECTOR_DISCONNECTED = 'CONNECTOR_DISCONNECTED',
  CONNECTOR_ERROR = 'CONNECTOR_ERROR',
  CONNECTOR_KEY_REJECTED = 'CONNECTOR_KEY_REJECTED',
  CONNECTOR_UNHEALTHY = 'CONNECTOR_UNHEALTHY',
  CONNECTOR_UNREACHABLE = 'CONNECTOR_UNREACHABLE',
  LIVE_CHECK_FAILED = 'LIVE_CHECK_FAILED',
  NOT_SET_UP = 'NOT_SET_UP',
  RECENT_START_FAILURES = 'RECENT_START_FAILURES',
  STARTS_FAILING = 'STARTS_FAILING',
}

/** Overall state of a site's tanning connector */
export enum TanningConnectorVerdict {
  NEEDS_ATTENTION = 'NEEDS_ATTENTION',
  NOT_SET_UP = 'NOT_SET_UP',
  NOT_WORKING = 'NOT_WORKING',
  WORKING = 'WORKING',
}

/** Staff note for overriding one tanning regulation the client fails */
export interface TanningRegulationOverrideInput {
  note: Scalars['String']['input']
  rule: TanningRegulationRule
}

/** One tanning regulation a client can fail when put in a bed */
export enum TanningRegulationRule {
  AGE_MAX_FREQUENCY = 'AGE_MAX_FREQUENCY',
  AGE_MAX_FREQUENCY_AFTER_NO_CATEGORY_TAN = 'AGE_MAX_FREQUENCY_AFTER_NO_CATEGORY_TAN',
  DOCTORS_NOTE = 'DOCTORS_NOTE',
  HOURS_FROM_START_OF_PREVIOUS = 'HOURS_FROM_START_OF_PREVIOUS',
  MINIMUM_AGE = 'MINIMUM_AGE',
  MINIMUM_DAYS_BETWEEN_USES = 'MINIMUM_DAYS_BETWEEN_USES',
  MINIMUM_HOURS_BETWEEN_USES = 'MINIMUM_HOURS_BETWEEN_USES',
  PARENTAL_CONSENT = 'PARENTAL_CONSENT',
}

/** Why staff voided a running tanning session instead of moving it to another bed */
export enum TanningSessionVoidReason {
  EQUIPMENT_FAILURE = 'EQUIPMENT_FAILURE',
  NO_SOLUTION = 'NO_SOLUTION',
  OTHER = 'OTHER',
}

/** Type of target entity for content visibility targeting */
export enum TargetType {
  REGION = 'REGION',
  SITE = 'SITE',
  SITE_GROUP = 'SITE_GROUP',
}

export enum TaxSettingType {
  exclusive = 'exclusive',
  inclusive = 'inclusive',
}

/** Type of tax calculation */
export enum TaxType {
  exclusive = 'exclusive',
  inclusive = 'inclusive',
}

/** Source level for resolved templates in the hierarchy */
export enum TemplateSource {
  admin = 'admin',
  corporate = 'corporate',
  corporate_version = 'corporate_version',
  site = 'site',
}

/** Why a reader hand-off stopped */
export enum TerminalHandoffFailureCode {
  CUSTOMER_CANCELED = 'CUSTOMER_CANCELED',
  FINALISATION_ERROR = 'FINALISATION_ERROR',
  PROVIDER_ERROR = 'PROVIDER_ERROR',
  READER_BUSY = 'READER_BUSY',
  READER_OFFLINE = 'READER_OFFLINE',
  STAFF_CANCELLED = 'STAFF_CANCELLED',
  STORAGE_ERROR = 'STORAGE_ERROR',
  TIMEOUT = 'TIMEOUT',
}

/** A client profile detail a member can enter on a Stripe reader */
export enum TerminalHandoffField {
  DATE_OF_BIRTH = 'DATE_OF_BIRTH',
  EMAIL = 'EMAIL',
  EMERGENCY_CONTACT_NAME = 'EMERGENCY_CONTACT_NAME',
  EMERGENCY_CONTACT_PHONE = 'EMERGENCY_CONTACT_PHONE',
  MOBILE_PHONE = 'MOBILE_PHONE',
  ZIP_CODE = 'ZIP_CODE',
}

/** Why a detail entered on the reader was not written to the client */
export enum TerminalHandoffHoldReason {
  EMAIL_CONFLICT = 'EMAIL_CONFLICT',
  FIELD_NO_LONGER_EMPTY = 'FIELD_NO_LONGER_EMPTY',
  INVALID_VALUE = 'INVALID_VALUE',
}

/** The Core screen a reader hand-off was started from */
export enum TerminalHandoffSourceSurface {
  CHECKOUT = 'CHECKOUT',
  CLIENT_PROFILE = 'CLIENT_PROFILE',
  DOCUMENTS = 'DOCUMENTS',
  TEST = 'TEST',
}

/** Where a reader hand-off is in its lifecycle */
export enum TerminalHandoffStatus {
  APPLIED = 'APPLIED',
  AWAITING_MEMBER = 'AWAITING_MEMBER',
  CANCELLED = 'CANCELLED',
  CAPTURED = 'CAPTURED',
  FAILED = 'FAILED',
  SENDING = 'SENDING',
  STORED = 'STORED',
  TIMED_OUT = 'TIMED_OUT',
}

export enum TerminalHandoffStepKind {
  FIELD = 'FIELD',
  SIGNATURE = 'SIGNATURE',
}

export enum TerminalHandoffStepState {
  APPLIED = 'APPLIED',
  CAPTURED = 'CAPTURED',
  FAILED = 'FAILED',
  HELD = 'HELD',
  ON_READER = 'ON_READER',
  PENDING = 'PENDING',
  SKIPPED = 'SKIPPED',
}

export enum TerminalLocationAddressField {
  city = 'city',
  postalCode = 'postalCode',
  state = 'state',
  street = 'street',
  street2 = 'street2',
}

export enum TerminalPaymentMethodType {
  card = 'card',
  unknown = 'unknown',
}

export enum TerminalReaderInputType {
  email = 'email',
  numeric = 'numeric',
  phone = 'phone',
  signature = 'signature',
  text = 'text',
}

export enum TerminalReaderUnsupportedReason {
  BUSY = 'BUSY',
  NOT_STRIPE = 'NOT_STRIPE',
  OFFLINE = 'OFFLINE',
  UNSUPPORTED_DEVICE = 'UNSUPPORTED_DEVICE',
}

/** Where members sign agreements in person at a location */
export enum TerminalSignatureDevice {
  ON_SCREEN = 'ON_SCREEN',
  STRIPE_READER = 'STRIPE_READER',
  TOPAZ_PAD = 'TOPAZ_PAD',
}

/** What staff are offered when the reader cannot be used */
export enum TerminalSignatureFallback {
  NONE = 'NONE',
  ON_SCREEN = 'ON_SCREEN',
  TOPAZ_PAD = 'TOPAZ_PAD',
}

export enum TextFilterOperator {
  contains = 'contains',
  does_not_contain = 'does_not_contain',
  is = 'is',
  is_not = 'is_not',
}

export enum ThemeKey {
  access = 'access',
  experience = 'experience',
  hapana_ai = 'hapana_ai',
  retention = 'retention',
}

/** Corporate-level theme subscription status */
export enum ThemeSubscriptionStatus {
  Active = 'Active',
  Cancelled = 'Cancelled',
  Expired = 'Expired',
  Inactive = 'Inactive',
  PastDue = 'PastDue',
  Trial = 'Trial',
}

export enum ThemeValueSource {
  Global = 'Global',
  Surface = 'Surface',
}

/** Who can use this integration key */
export enum ThirdPartyIntegrationAvailableFor {
  CLIENT = 'CLIENT',
  CORPORATE = 'CORPORATE',
  SITE = 'SITE',
}

/** Input for creating a third party integration */
export interface ThirdPartyIntegrationCreateInput {
  description: Scalars['String']['input']
  enabled: Scalars['Boolean']['input']
  name: Scalars['String']['input']
}

/** Input for creating a third party integration key */
export interface ThirdPartyIntegrationKeyCreateInput {
  availableFor: ThirdPartyIntegrationAvailableFor
  name: Scalars['String']['input']
  uniqueAcross?: InputMaybe<ThirdPartyIntegrationUniqueAcross>
  visibilityAt: ThirdPartyIntegrationVisibilityAt
}

/** Input for updating a third party integration key */
export interface ThirdPartyIntegrationKeyUpdateInput {
  availableFor?: InputMaybe<ThirdPartyIntegrationAvailableFor>
  name?: InputMaybe<Scalars['String']['input']>
  uniqueAcross?: InputMaybe<ThirdPartyIntegrationUniqueAcross>
  visibilityAt?: InputMaybe<ThirdPartyIntegrationVisibilityAt>
}

/** Uniqueness scope for client integration keys */
export enum ThirdPartyIntegrationUniqueAcross {
  CORPORATE = 'CORPORATE',
  SITE = 'SITE',
}

/** Input for updating a third party integration */
export interface ThirdPartyIntegrationUpdateInput {
  description?: InputMaybe<Scalars['String']['input']>
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

/** Where the integration key is visible */
export enum ThirdPartyIntegrationVisibilityAt {
  API_DISABLED = 'API_DISABLED',
  API_ENABLED = 'API_ENABLED',
  CORPORATE = 'CORPORATE',
  SITE = 'SITE',
  SUPER_ADMIN = 'SUPER_ADMIN',
}

export interface TicketChatMessageInput {
  content: Scalars['String']['input']
  role: Scalars['String']['input']
  timestamp?: InputMaybe<Scalars['String']['input']>
}

/** Time period type including CUSTOM for date-range leaderboards */
export enum TimePeriodType {
  ALL_TIME = 'ALL_TIME',
  CUSTOM = 'CUSTOM',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  WEEKLY = 'WEEKLY',
}

/** Controls whether processing fees pass through to clients or are absorbed by business */
export enum TransactionFeePreference {
  toBusiness = 'toBusiness',
  toClient = 'toClient',
}

export enum TranslationStatus {
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  REVIEWED = 'REVIEWED',
  TRANSLATED = 'TRANSLATED',
}

export enum TrialStatus {
  active_paid = 'active_paid',
  churned = 'churned',
  closed = 'closed',
  converting = 'converting',
  prospect = 'prospect',
  trial_active = 'trial_active',
  trial_expired = 'trial_expired',
  trial_expiring = 'trial_expiring',
}

export interface UpdateAccessControlsDoorsInput {
  accessGroupId?: InputMaybe<Scalars['String']['input']>
  accessHours: Scalars['Boolean']['input']
  doorId: Scalars['String']['input']
  endTime?: InputMaybe<Scalars['String']['input']>
  label: Scalars['String']['input']
  provider: AccessControlProvider
  sessionTypes: Array<Scalars['String']['input']>
  startTime?: InputMaybe<Scalars['String']['input']>
}

export interface UpdateAccessControlsInputInput {
  doors?: InputMaybe<Array<UpdateAccessControlsDoorsInput>>
}

export interface UpdateAccessRuleInputInput {
  assignmentType?: InputMaybe<StaffAccessRuleAssignmentType>
  siteGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>
  siteIds?: InputMaybe<Array<Scalars['ID']['input']>>
  staffAccessPolicyId?: InputMaybe<Scalars['ID']['input']>
}

export interface UpdateAccuroFitInputInput {
  clientId?: InputMaybe<Scalars['String']['input']>
}

/** Fields left out keep their current value */
export interface UpdateAddOnPriceGroupInput {
  addOnPriceGroupId: Scalars['ID']['input']
  name?: InputMaybe<Scalars['String']['input']>
  /** The group's full session type list; one already in another group moves to this one, one left out keeps its prices as own prices */
  siteSessionTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>
  taxSettingIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export interface UpdateAdminUserInputInput {
  accessGroupId: Scalars['ID']['input']
  /** Password for protected access groups */
  accessGroupPassword?: InputMaybe<Scalars['String']['input']>
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  phone: Scalars['String']['input']
}

export interface UpdateAppStoreCredentialsInputInput {
  apnsAuthKey?: InputMaybe<Scalars['String']['input']>
  apnsKeyId?: InputMaybe<Scalars['String']['input']>
  appleAccountName?: InputMaybe<Scalars['String']['input']>
  appleIssuerId?: InputMaybe<Scalars['String']['input']>
  appleKeyId?: InputMaybe<Scalars['String']['input']>
  applePrivateKey?: InputMaybe<Scalars['String']['input']>
  appleTeamId?: InputMaybe<Scalars['String']['input']>
  bundleId?: InputMaybe<Scalars['String']['input']>
  firebaseAndroidConfig?: InputMaybe<Scalars['String']['input']>
  firebaseIosConfig?: InputMaybe<Scalars['String']['input']>
  googleServiceAccountEmail?: InputMaybe<Scalars['String']['input']>
  googleServiceAccountJson?: InputMaybe<Scalars['String']['input']>
  jwPlayerLicenseKey?: InputMaybe<Scalars['String']['input']>
  packageName?: InputMaybe<Scalars['String']['input']>
  userId?: InputMaybe<Scalars['String']['input']>
}

export interface UpdateBrandIdentityIdentityInput {
  appleId?: InputMaybe<Scalars['String']['input']>
  appleItcTeamId?: InputMaybe<Scalars['String']['input']>
  appleTeamId?: InputMaybe<Scalars['String']['input']>
  ascAppId?: InputMaybe<Scalars['String']['input']>
  bundleIdIos?: InputMaybe<Scalars['String']['input']>
  packageAndroid?: InputMaybe<Scalars['String']['input']>
  playStoreId?: InputMaybe<Scalars['String']['input']>
  scheme?: InputMaybe<Scalars['String']['input']>
}

export interface UpdateBrandNativePermissionsIosUsageDescriptionsInput {
  key: IosUsageDescriptionKey
  text: Scalars['String']['input']
}

/** Input for updating an existing carousel group */
export interface UpdateCarouselGroupInput {
  name?: InputMaybe<Scalars['String']['input']>
}

export interface UpdateClassPassInputInput {
  classPassSpotsPerSession?: InputMaybe<Scalars['Float']['input']>
  enabled: Scalars['Boolean']['input']
}

export interface UpdateClientAlertInputInput {
  alertId: Scalars['String']['input']
  description?: InputMaybe<Scalars['String']['input']>
  endDate?: InputMaybe<Scalars['String']['input']>
  startDate?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export interface UpdateClientCommunicationPreferencesInput {
  email?: InputMaybe<Scalars['Boolean']['input']>
  notifications?: InputMaybe<Scalars['Boolean']['input']>
  phone?: InputMaybe<Scalars['Boolean']['input']>
  sms?: InputMaybe<Scalars['Boolean']['input']>
}

export interface UpdateClientCustomPropertyValuesValuesInput {
  siteCustomPropertyId: Scalars['String']['input']
  value?: InputMaybe<Scalars['String']['input']>
}

/** Input for updating a client family relation */
export interface UpdateClientFamilyInput {
  email?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  relationship?: InputMaybe<ClientFamilyRelationship>
}

/** Input for updating a client */
export interface UpdateClientInput {
  activePackagesCount?: InputMaybe<Scalars['Float']['input']>
  address?: InputMaybe<CreateClientAddressInput>
  barcode?: InputMaybe<Scalars['String']['input']>
  communicationPreferences?: InputMaybe<UpdateClientCommunicationPreferencesInput>
  confirmFobReassign?: InputMaybe<Scalars['Boolean']['input']>
  csn?: InputMaybe<Scalars['String']['input']>
  customerId?: InputMaybe<Scalars['String']['input']>
  dateOfBirth?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  emergencyContact?: InputMaybe<CreateClientEmergencyContactInput>
  favoriteSiteIds?: InputMaybe<Array<Scalars['String']['input']>>
  firebaseId?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  fobNumber?: InputMaybe<Scalars['String']['input']>
  gender?: InputMaybe<Scalars['String']['input']>
  homeLocationIds?: InputMaybe<Array<Scalars['String']['input']>>
  homePhoneNumber?: InputMaybe<Scalars['String']['input']>
  homeSiteId?: InputMaybe<Scalars['String']['input']>
  homeSiteName?: InputMaybe<Scalars['String']['input']>
  isProspect?: InputMaybe<Scalars['Boolean']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  mobilePhoneNumber?: InputMaybe<Scalars['String']['input']>
  occupation?: InputMaybe<Scalars['String']['input']>
  recentSiteId?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<ClientSource>
}

/** Email input for updating corporate communication settings */
export interface UpdateCommunicationEmailInput {
  defaultFromEmail?: InputMaybe<Scalars['String']['input']>
  defaultFromName?: InputMaybe<Scalars['String']['input']>
}

export interface UpdateCommunicationTemplateCommunicationTemplateInput {
  emailBody?: InputMaybe<Scalars['String']['input']>
  emailEnabled?: InputMaybe<Scalars['Boolean']['input']>
  emailSubject?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  pushNotificationEnabled?: InputMaybe<Scalars['Boolean']['input']>
  pushNotificationMessage?: InputMaybe<Scalars['String']['input']>
  pushNotificationTitle?: InputMaybe<Scalars['String']['input']>
  smsEnabled?: InputMaybe<Scalars['Boolean']['input']>
  smsMessage?: InputMaybe<Scalars['String']['input']>
}

/** A saved draft or scheduled brand add-on, replaced with the values sent. */
export interface UpdateCorporateAddOnDraftInput {
  assignedSiteGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>
  assignedSiteIds?: InputMaybe<Array<Scalars['ID']['input']>>
  config: BrandAddOnConfigInput
  corporateServiceTemplateId: Scalars['ID']['input']
  expectedVersion: Scalars['Float']['input']
  isAllLocations: Scalars['Boolean']['input']
  lockedSections?: InputMaybe<Array<BrandServiceTemplateSection>>
}

export interface UpdateCorporateAdminConfigurationsAppSettingsClientSelfServiceSuspensionInput {
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  maxSuspensionDays?: InputMaybe<Scalars['Float']['input']>
  minSuspensionDays?: InputMaybe<Scalars['Float']['input']>
  totalCalendarYearSuspensionDays?: InputMaybe<Scalars['Float']['input']>
}

export interface UpdateCorporateAdminConfigurationsAppSettingsInput {
  androidVersion?: InputMaybe<Scalars['String']['input']>
  classTimeFilter?: InputMaybe<Scalars['Boolean']['input']>
  clientSelfServiceSuspension?: InputMaybe<UpdateCorporateAdminConfigurationsAppSettingsClientSelfServiceSuspensionInput>
  displayInstructor?: InputMaybe<Scalars['Boolean']['input']>
  displayPackageDescription?: InputMaybe<Scalars['Boolean']['input']>
  displayProfilePicture?: InputMaybe<Scalars['Boolean']['input']>
  displayTodayClasses?: InputMaybe<Scalars['Boolean']['input']>
  forceUpdateAndroid?: InputMaybe<Scalars['Boolean']['input']>
  forceUpdateIOS?: InputMaybe<Scalars['Boolean']['input']>
  iosVersion?: InputMaybe<Scalars['String']['input']>
  privatesAnyAvailable?: InputMaybe<Scalars['Boolean']['input']>
  purchaseRedirect?: InputMaybe<Scalars['String']['input']>
  pushProvider?: InputMaybe<PushProvider>
  redirectUrl?: InputMaybe<Scalars['String']['input']>
  signUpRedirect?: InputMaybe<Scalars['String']['input']>
  signUpToggle?: InputMaybe<Scalars['Boolean']['input']>
}

export interface UpdateCorporateAdminConfigurationsInput {
  appSettings?: InputMaybe<UpdateCorporateAdminConfigurationsAppSettingsInput>
  customization?: InputMaybe<UpdateCorporateCustomizationInput>
  hubspot?: InputMaybe<CreateCorporateHubspotInput>
  paymentRouting?: InputMaybe<UpdateCorporateAdminConfigurationsPaymentRoutingInput>
  publicApi?: InputMaybe<UpdateCorporateAdminConfigurationsPublicApiInput>
  system?: InputMaybe<UpdateCorporateAdminConfigurationsSystemInput>
}

export interface UpdateCorporateAdminConfigurationsPaymentRoutingInput {
  chargeRouting?: InputMaybe<PaymentRoutingMode>
  pipeline?: InputMaybe<UpdateCorporateAdminConfigurationsPaymentRoutingPipelineInput>
}

export interface UpdateCorporateAdminConfigurationsPaymentRoutingPipelineInput {
  mode?: InputMaybe<PaymentsPipelineMode>
}

export interface UpdateCorporateAdminConfigurationsPublicApiInput {
  logLevel?: InputMaybe<PublicApiLogLevel>
}

export interface UpdateCorporateAdminConfigurationsSystemInput {
  blockWhenClientOwesAtAnyLocation?: InputMaybe<Scalars['Boolean']['input']>
  classicDashboardsEnabled?: InputMaybe<Scalars['Boolean']['input']>
  connectedSiteForPassportAccess?: InputMaybe<Scalars['Boolean']['input']>
  corporateClientLookup?: InputMaybe<Scalars['Boolean']['input']>
  generateAttendanceStatisticsPerSessionTemplate?: InputMaybe<Scalars['Boolean']['input']>
}

/** Input for updating corporate communication email settings */
export interface UpdateCorporateCommunicationSettingsInput {
  email?: InputMaybe<UpdateCommunicationEmailInput>
}

/** Input for updating a corporate custom third-party integration */
export interface UpdateCorporateCustomThirdPartyIntegrationInput {
  keyValues: Array<UpdateCorporateCustomThirdPartyIntegrationKeyValuesInput>
  thirdPartyIntegrationId: Scalars['String']['input']
}

export interface UpdateCorporateCustomThirdPartyIntegrationKeyValuesInput {
  key: Scalars['String']['input']
  value?: InputMaybe<Scalars['String']['input']>
}

export interface UpdateCorporateCustomizationColorSchemaInput {
  backgroundColor?: InputMaybe<Scalars['String']['input']>
  primaryColor?: InputMaybe<Scalars['String']['input']>
  primaryTextColor?: InputMaybe<Scalars['String']['input']>
  secondaryColor?: InputMaybe<Scalars['String']['input']>
  secondaryTextColor?: InputMaybe<Scalars['String']['input']>
}

export interface UpdateCorporateCustomizationInput {
  buttonStyle?: InputMaybe<Scalars['String']['input']>
  colorSchema?: InputMaybe<UpdateCorporateCustomizationColorSchemaInput>
  customCssLink?: InputMaybe<Scalars['String']['input']>
}

/** Input for updating a corporate FAQ */
export interface UpdateCorporateFaqInput {
  heading?: InputMaybe<Scalars['String']['input']>
  response?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<CorporateFaqStatus>
}

export interface UpdateCorporateInput {
  adminConfigurations?: InputMaybe<UpdateCorporateAdminConfigurationsInput>
  clientTenantId?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<Scalars['String']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  customization?: InputMaybe<UpdateCorporateCustomizationInput>
  dashboardHeroImage?: InputMaybe<UpdateCorporateLogoImageInput>
  dashboardHeroImageTemp?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  embedWidgetConfig?: InputMaybe<Scalars['JSONObject']['input']>
  isOnboarding?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<Scalars['String']['input']>
  leadSource?: InputMaybe<Scalars['String']['input']>
  logoImage?: InputMaybe<UpdateCorporateLogoImageInput>
  logoImageTemp?: InputMaybe<Scalars['String']['input']>
  migrationStatus?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  onboardingCompletedAt?: InputMaybe<Scalars['String']['input']>
  paymentAuthorisationConfig?: InputMaybe<UpdateCorporatePaymentAuthorisationConfigInput>
  phone?: InputMaybe<Scalars['String']['input']>
  planTier?: InputMaybe<ProductPlanTier>
  region?: InputMaybe<Scalars['String']['input']>
  sitesCount?: InputMaybe<Scalars['Float']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  staffTenantId?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  subdomain?: InputMaybe<Scalars['String']['input']>
  tier?: InputMaybe<Scalars['String']['input']>
  timezone?: InputMaybe<Scalars['String']['input']>
  trialConvertedAt?: InputMaybe<Scalars['String']['input']>
  trialExpiresAt?: InputMaybe<Scalars['String']['input']>
  trialStartedAt?: InputMaybe<Scalars['String']['input']>
  trialStatus?: InputMaybe<Scalars['String']['input']>
  updatedBy?: InputMaybe<Scalars['String']['input']>
  urlPrefix?: InputMaybe<Scalars['String']['input']>
  website?: InputMaybe<Scalars['String']['input']>
}

/** Input for updating corporate Contentful / native content settings */
export interface UpdateCorporateIntegrationsContentfulInput {
  accessToken?: InputMaybe<Scalars['String']['input']>
  /** Base URL for the native content API */
  contentApiBaseUrl?: InputMaybe<Scalars['String']['input']>
  managementAccessToken?: InputMaybe<Scalars['String']['input']>
  previewToken?: InputMaybe<Scalars['String']['input']>
  spaceId?: InputMaybe<Scalars['String']['input']>
  /** Enable native V2 Content Suite (embed) for this brand */
  useNativeContent?: InputMaybe<Scalars['Boolean']['input']>
}

/** Input for updating corporate deeplinking integration settings */
export interface UpdateCorporateIntegrationsDeeplinkingInput {
  androidPackageName?: InputMaybe<Scalars['String']['input']>
  dynamicDomainLink?: InputMaybe<Scalars['String']['input']>
  iosAppStoreId?: InputMaybe<Scalars['String']['input']>
  iosBundleId?: InputMaybe<Scalars['String']['input']>
  webApiKey?: InputMaybe<Scalars['String']['input']>
}

/** Input for the corporate eGym master enable (the API key is per-location) */
export interface UpdateCorporateIntegrationsEgymInput {
  enabled?: InputMaybe<Scalars['Boolean']['input']>
}

/** Input for updating corporate grow integration settings */
export interface UpdateCorporateIntegrationsGrowInput {
  enableHqLocationSync?: InputMaybe<Scalars['Boolean']['input']>
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  syncDndAndChannels?: InputMaybe<Scalars['Boolean']['input']>
}

/** Input for updating corporate push notification keys */
export interface UpdateCorporateIntegrationsPushNotificationInput {
  /** OneSignal App ID */
  id: Scalars['String']['input']
  /** OneSignal REST API Key */
  key: Scalars['String']['input']
}

/** Input for updating corporate Zapier integration settings */
export interface UpdateCorporateIntegrationsZapierInput {
  enabled?: InputMaybe<Scalars['Boolean']['input']>
}

export interface UpdateCorporateLogoImageInput {
  url?: InputMaybe<Scalars['String']['input']>
}

export interface UpdateCorporatePaymentAuthorisationConfigBankDebitAuthorisationInput {
  coversLocationsFrom: Scalars['String']['input']
  evidenceReference: Scalars['String']['input']
  originatorName: Scalars['String']['input']
}

export interface UpdateCorporatePaymentAuthorisationConfigInput {
  bankDebitAuthorisation?: InputMaybe<UpdateCorporatePaymentAuthorisationConfigBankDebitAuthorisationInput>
  cancellationPolicy: Scalars['String']['input']
  customerServiceContact: Scalars['String']['input']
  depositNote?: InputMaybe<Scalars['String']['input']>
  legalEntityName?: InputMaybe<Scalars['String']['input']>
  salesTaxNote?: InputMaybe<Scalars['String']['input']>
  template?: InputMaybe<Scalars['String']['input']>
}

export interface UpdateCorporatePayoutAccountInputInput {
  currency?: InputMaybe<StripePayoutCurrency>
  currencyConversionFee?: InputMaybe<CorporatePayoutAccountPayoutFeeInput>
  name?: InputMaybe<Scalars['String']['input']>
  payoutFee?: InputMaybe<CorporatePayoutAccountPayoutFeeInput>
  stripeId?: InputMaybe<Scalars['String']['input']>
}

/** Fields to change on a brand session group. Changing the distribution re-resolves which locations carry it; withdrawMode is required when a location stops receiving it. */
export interface UpdateCorporateSessionTypeInput {
  acknowledgedAdoptionSiteIds?: InputMaybe<Array<Scalars['ID']['input']>>
  allowEditingSessionType?: InputMaybe<Scalars['Boolean']['input']>
  allowMultiLocationAccess?: InputMaybe<Scalars['Boolean']['input']>
  assignedSiteGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>
  assignedSiteIds?: InputMaybe<Array<Scalars['ID']['input']>>
  color?: InputMaybe<Scalars['String']['input']>
  isAllLocations?: InputMaybe<Scalars['Boolean']['input']>
  lockedSections?: InputMaybe<Array<SessionGroupSection>>
  name?: InputMaybe<Scalars['String']['input']>
  withdrawMode?: InputMaybe<CorporateSessionTypeWithdrawMode>
}

/** Fields to change on a brand tax type. Changing the assignment lists re-resolves which locations carry it. */
export interface UpdateCorporateTaxSettingInput {
  assignedSiteGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>
  assignedSiteIds?: InputMaybe<Array<Scalars['ID']['input']>>
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  isLocked?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  rate?: InputMaybe<Scalars['String']['input']>
  setting?: InputMaybe<TaxSettingType>
}

export interface UpdateCorporateWebhookInputInput {
  allSites?: InputMaybe<Scalars['Boolean']['input']>
  events?: InputMaybe<Array<Scalars['String']['input']>>
  headerKey?: InputMaybe<Scalars['String']['input']>
  headerValue?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  siteIds?: InputMaybe<Array<Scalars['String']['input']>>
  url?: InputMaybe<Scalars['String']['input']>
}

/** Input for updating eGym integration configuration (apiKey is write-only) */
export interface UpdateEgymIntegrationInput {
  activeMembershipType: EgymMembershipType
  apiKey?: InputMaybe<Scalars['String']['input']>
  enabled: Scalars['Boolean']['input']
}

export interface UpdateEmbedCustomizationCustomizationAdvancedFilterOptionsInput {
  category: Scalars['Boolean']['input']
  duration: Scalars['Boolean']['input']
  instructor: Scalars['Boolean']['input']
  location: Scalars['Boolean']['input']
  time: Scalars['Boolean']['input']
}

export interface UpdateEmbedCustomizationCustomizationAdvancedInput {
  buttonStyle: EmbedButtonStyle
  classTimeFilter: Scalars['Boolean']['input']
  customCssLink: Scalars['String']['input']
  displayInstructor: Scalars['Boolean']['input']
  displayPackageDescription: Scalars['Boolean']['input']
  displayProfilePicture: Scalars['Boolean']['input']
  filterOptions: UpdateEmbedCustomizationCustomizationAdvancedFilterOptionsInput
  privatesAnyAvailable: Scalars['Boolean']['input']
  redirectUrl: Scalars['String']['input']
  showFilters: Scalars['Boolean']['input']
  signUpEnabled: Scalars['Boolean']['input']
}

export interface UpdateEmbedCustomizationCustomizationAppearanceInput {
  borderRadius: Scalars['Float']['input']
  buttonStyle: EmbedAppearanceButtonStyle
  fontFamily: Scalars['String']['input']
  fontSize: Scalars['Float']['input']
}

export interface UpdateEmbedCustomizationCustomizationBrandingInput {
  appName: Scalars['String']['input']
  faviconUrl: Scalars['String']['input']
  logoUrl: Scalars['String']['input']
}

export interface UpdateEmbedCustomizationCustomizationColorsInput {
  backgroundColor: Scalars['String']['input']
  primaryColor: Scalars['String']['input']
  primaryTextColor: Scalars['String']['input']
  secondaryColor: Scalars['String']['input']
  secondaryTextColor: Scalars['String']['input']
}

export interface UpdateEmbedCustomizationCustomizationCustomTextInput {
  defaultLanguage: Scalars['String']['input']
  translations: Scalars['JSONObject']['input']
}

export interface UpdateEmbedCustomizationCustomizationInput {
  advanced?: InputMaybe<UpdateEmbedCustomizationCustomizationAdvancedInput>
  appearance?: InputMaybe<UpdateEmbedCustomizationCustomizationAppearanceInput>
  branding?: InputMaybe<UpdateEmbedCustomizationCustomizationBrandingInput>
  colors?: InputMaybe<UpdateEmbedCustomizationCustomizationColorsInput>
  customText?: InputMaybe<UpdateEmbedCustomizationCustomizationCustomTextInput>
  layout?: InputMaybe<UpdateEmbedCustomizationCustomizationLayoutInput>
  modules?: InputMaybe<UpdateEmbedCustomizationCustomizationModulesInput>
}

export interface UpdateEmbedCustomizationCustomizationLayoutInput {
  footerVisible: Scalars['Boolean']['input']
  headerVisible: Scalars['Boolean']['input']
  sidebarPosition: EmbedSidebarPosition
}

export interface UpdateEmbedCustomizationCustomizationModulesInput {
  classes: Scalars['Boolean']['input']
  dashboard: Scalars['Boolean']['input']
  packages: Scalars['Boolean']['input']
  payments: Scalars['Boolean']['input']
  privates: Scalars['Boolean']['input']
  profile: Scalars['Boolean']['input']
  schedule: Scalars['Boolean']['input']
  workshops: Scalars['Boolean']['input']
}

export interface UpdateEmbedWebsiteWidgetsWebsiteWidgetsInput {
  selectedWidgets?: InputMaybe<Array<Scalars['String']['input']>>
  widgetSettings?: InputMaybe<Scalars['JSONObject']['input']>
}

/** Input for updating an equipment unit */
export interface UpdateEquipmentInput {
  category?: InputMaybe<EquipmentCategory>
  defaultDelayMinutes?: InputMaybe<Scalars['Int']['input']>
  defaultTimerMinutes?: InputMaybe<Scalars['Int']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  manufacturer?: InputMaybe<Scalars['String']['input']>
  maxDelayMinutes?: InputMaybe<Scalars['Int']['input']>
  maxTimerMinutes?: InputMaybe<Scalars['Int']['input']>
  minDelayMinutes?: InputMaybe<Scalars['Int']['input']>
  minTimerMinutes?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  nonUvCategory?: InputMaybe<NonUvCategory>
  qualityCategory?: InputMaybe<EquipmentQualityCategory>
  siteSessionTypeIds?: InputMaybe<Array<Scalars['String']['input']>>
  timerId?: InputMaybe<Scalars['Int']['input']>
}

/** Lamp tracking settings for a bed; a lamp set left out is unchanged */
export interface UpdateEquipmentLampSettingsInput {
  body?: InputMaybe<LampSetSettingsInput>
  equipmentId: Scalars['ID']['input']
  facial?: InputMaybe<LampSetSettingsInput>
}

/** Input for updating tanning safety regulations */
export interface UpdateEquipmentRegulationInput {
  equipmentCategory?: InputMaybe<EquipmentCategory>
  rules?: InputMaybe<CreateEquipmentRegulationRulesInput>
}

export interface UpdateExternalFeedbackLinkInputInput {
  url?: InputMaybe<Scalars['String']['input']>
}

/** Input for updating an existing Ezypay gateway configuration */
export interface UpdateEzypayGatewayInput {
  merchantId?: InputMaybe<Scalars['ID']['input']>
  merchantPassword?: InputMaybe<Scalars['String']['input']>
  merchantUsername?: InputMaybe<Scalars['String']['input']>
  paymentContactEmail?: InputMaybe<Scalars['String']['input']>
  sitePaymentGatewayId: Scalars['ID']['input']
}

export interface UpdateFacebookPixelEventsInput {
  enabled: Scalars['Boolean']['input']
  facebookEventName: Scalars['String']['input']
  name: Scalars['String']['input']
}

export interface UpdateFacebookPixelInputInput {
  events?: InputMaybe<Array<UpdateFacebookPixelEventsInput>>
  pixelId?: InputMaybe<Scalars['String']['input']>
}

export interface UpdateFamilySettingsInputInput {
  adminsPerFamily: Scalars['Float']['input']
}

export interface UpdateFeeConfigurationInputInput {
  accountType?: InputMaybe<FeeAccountType>
  description?: InputMaybe<Scalars['String']['input']>
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  eventType?: InputMaybe<FeeEventType>
  name?: InputMaybe<Scalars['String']['input']>
  paymentGateway?: InputMaybe<PaymentGateway>
  rate?: InputMaybe<Scalars['Numeric']['input']>
  rateType?: InputMaybe<FeeRateType>
  webhookEndpoint?: InputMaybe<Scalars['String']['input']>
  webhookType?: InputMaybe<Scalars['String']['input']>
}

/** Input for updating Fitness Passport integration configuration (both tokens are write-only) */
export interface UpdateFitnessPassportInput {
  deviceToken?: InputMaybe<Scalars['String']['input']>
  enabled: Scalars['Boolean']['input']
  failurePolicy: FitnessPassportFailurePolicy
  siteToken?: InputMaybe<Scalars['String']['input']>
}

export interface UpdateFrontDeskKioskBetaVersionInput {
  classCheckInEnabled?: InputMaybe<Scalars['Boolean']['input']>
  classCheckInRequirePolicies?: InputMaybe<Scalars['Boolean']['input']>
  classCheckInSpotBooking?: InputMaybe<Scalars['Boolean']['input']>
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  introOffersEnabled?: InputMaybe<Scalars['Boolean']['input']>
  packagesMembershipsEnabled?: InputMaybe<Scalars['Boolean']['input']>
}

/** Input for updating Front Desk Kiosk integration (kiosk URLs are read-only) */
export interface UpdateFrontDeskKioskInput {
  betaVersion?: InputMaybe<UpdateFrontDeskKioskBetaVersionInput>
  kioskDefaults?: InputMaybe<UpdateFrontDeskKioskKioskDefaultsInput>
}

export interface UpdateFrontDeskKioskKioskDefaultsInput {
  checkIn?: InputMaybe<Scalars['Boolean']['input']>
  classCheckIn?: InputMaybe<Scalars['Boolean']['input']>
  forms?: InputMaybe<Scalars['Boolean']['input']>
  introOffers?: InputMaybe<Scalars['Boolean']['input']>
  manageAccount?: InputMaybe<Scalars['Boolean']['input']>
  packages?: InputMaybe<Scalars['Boolean']['input']>
}

/** Input for updating shared site settings across all gift card templates for a site */
export interface UpdateGiftCardTemplatesSharedSitesInput {
  isAllSharedSites: Scalars['Boolean']['input']
  sharedSiteIds: Array<Scalars['ID']['input']>
  siteId: Scalars['ID']['input']
}

/** Input for updating an existing goal */
export interface UpdateGoalInput {
  name?: InputMaybe<Scalars['String']['input']>
  sortOrder?: InputMaybe<Scalars['Float']['input']>
}

export interface UpdateGoogleTagManagerInputInput {
  gtmId?: InputMaybe<Scalars['String']['input']>
}

export interface UpdateGrowAuthenticationInput {
  accessToken: Scalars['String']['input']
  expiresAt: Scalars['String']['input']
  refreshToken: Scalars['String']['input']
}

/** Input for updating a GrowHq */
export interface UpdateGrowHqInput {
  name?: InputMaybe<Scalars['String']['input']>
}

/** Input for updating Grow integration */
export interface UpdateGrowInput {
  authentication?: InputMaybe<UpdateGrowAuthenticationInput>
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  growLocationId?: InputMaybe<Scalars['String']['input']>
  hqId?: InputMaybe<Scalars['String']['input']>
  lastCollect?: InputMaybe<UpdateGrowLastCollectInput>
}

export interface UpdateGrowLastCollectInput {
  full?: InputMaybe<Scalars['String']['input']>
  partial?: InputMaybe<Scalars['String']['input']>
}

export interface UpdateHapanaAccessControllerAccessPointsInput {
  accessPointId?: InputMaybe<Scalars['String']['input']>
  accessPointName: Scalars['String']['input']
  groupName: Scalars['String']['input']
  provisionCode: Scalars['String']['input']
}

export interface UpdateHapanaAccessControllerGroupsInput {
  groupId?: InputMaybe<Scalars['String']['input']>
  groupName: Scalars['String']['input']
}

export interface UpdateHapanaAccessControllerInputInput {
  accessPoints?: InputMaybe<Array<UpdateHapanaAccessControllerAccessPointsInput>>
  groups?: InputMaybe<Array<UpdateHapanaAccessControllerGroupsInput>>
}

/** Input for updating corporate kiosk defaults (all fields optional) */
export interface UpdateKioskDefaultsInput {
  checkIn?: InputMaybe<Scalars['Boolean']['input']>
  classCheckIn?: InputMaybe<Scalars['Boolean']['input']>
  forms?: InputMaybe<Scalars['Boolean']['input']>
  introOffers?: InputMaybe<Scalars['Boolean']['input']>
  manageAccount?: InputMaybe<Scalars['Boolean']['input']>
  packages?: InputMaybe<Scalars['Boolean']['input']>
}

export interface UpdateLeaderboardConfigInputInput {
  autoRollover?: InputMaybe<Scalars['Boolean']['input']>
  config?: InputMaybe<Scalars['JSONObject']['input']>
  customEndDate?: InputMaybe<Scalars['String']['input']>
  customStartDate?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  imageUrl?: InputMaybe<Scalars['String']['input']>
  memberDisplayFormat?: InputMaybe<MemberDisplayFormat>
  minParticipants?: InputMaybe<Scalars['Float']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  rankingDirection?: InputMaybe<RankingDirection>
  refreshFrequency?: InputMaybe<RefreshFrequency>
  scope?: InputMaybe<LeaderboardScope>
  siteIds?: InputMaybe<Array<Scalars['String']['input']>>
  timePeriodType?: InputMaybe<TimePeriodType>
  visibility?: InputMaybe<LeaderboardVisibility>
}

export interface UpdateMeInputInput {
  dateOfBirth?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  gender?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
}

export interface UpdateMemberExperienceSettingsFilterOptionsInput {
  category: Scalars['Boolean']['input']
  duration: Scalars['Boolean']['input']
  instructor: Scalars['Boolean']['input']
  location: Scalars['Boolean']['input']
  room: Scalars['Boolean']['input']
  sessionType: Scalars['Boolean']['input']
  time: Scalars['Boolean']['input']
}

export interface UpdateMemberMovementRunConfigInput {
  attestation: MemberMovementAttestationInput
  config: MemberMovementConfigInput
  runId: Scalars['ID']['input']
}

/** Ordered array of serviceTemplateIds — position 0 = lowest tier (tierOrder 1), highest index = highest tier. Templates omitted from the array have their tierOrder set to NULL. */
export interface UpdateMembershipTierOrdersInput {
  orderedTemplateIds: Array<Scalars['ID']['input']>
  /** Only allow plan changes within the same membership category. Saved with the order in one transaction; omit it to leave the setting unchanged. */
  restrictPlanChangesToCategory?: InputMaybe<Scalars['Boolean']['input']>
  siteId: Scalars['ID']['input']
}

/** Input for updating a POS category */
export interface UpdatePosCategoryInput {
  description?: InputMaybe<Scalars['String']['input']>
  displayOrder?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  revenueTagId?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<PosCategoryStatus>
}

/** Input for updating POS product base information and variables */
export interface UpdatePosProductInput {
  categoryId?: InputMaybe<Scalars['ID']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  productName?: InputMaybe<Scalars['String']['input']>
  revenueTag?: InputMaybe<Scalars['ID']['input']>
  supplierId?: InputMaybe<Scalars['ID']['input']>
  variables?: InputMaybe<Array<UpdatePosProductVariableInput>>
}

/** Input for creating or updating a product variant (with optional ID for updates) */
export interface UpdatePosProductVariableInput {
  attributes?: InputMaybe<Array<PosProductVariableAttributeInput>>
  barcode?: InputMaybe<Scalars['String']['input']>
  cost?: InputMaybe<Scalars['String']['input']>
  currentStock?: InputMaybe<Scalars['Int']['input']>
  isDefault?: InputMaybe<Scalars['Boolean']['input']>
  isEnabledForSale?: InputMaybe<Scalars['Boolean']['input']>
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>
  maxStockLevel?: InputMaybe<Scalars['Int']['input']>
  minStockLevel?: InputMaybe<Scalars['Int']['input']>
  posProductVariableId?: InputMaybe<Scalars['ID']['input']>
  price?: InputMaybe<Scalars['String']['input']>
  sku?: InputMaybe<Scalars['String']['input']>
  sortOrder?: InputMaybe<Scalars['Int']['input']>
  taxSettingIds?: InputMaybe<Array<Scalars['ID']['input']>>
  trackStock?: InputMaybe<Scalars['Boolean']['input']>
  variableName?: InputMaybe<Scalars['String']['input']>
}

/** Input for updating the amount of a pre-sale initial scheduled invoice. Setting totalAmount to 0 applies a full discount. */
export interface UpdatePresaleInitialInvoiceAmountInput {
  invoiceId: Scalars['ID']['input']
  totalAmount: Scalars['Numeric']['input']
}

/** Input for updating the date of a pre-sale initial scheduled invoice. shortfallAction applies only when the move leaves the member underpaid; absent means absorb. */
export interface UpdatePresaleInitialInvoiceDateInput {
  invoiceDate: Scalars['String']['input']
  invoiceId: Scalars['ID']['input']
  memberNotification?: InputMaybe<MemberNotificationInput>
  shortfallAction?: InputMaybe<PresaleShortfallAction>
}

export interface UpdateRegionInputInput {
  countryId?: InputMaybe<Scalars['ID']['input']>
  latitude?: InputMaybe<Scalars['Float']['input']>
  longitude?: InputMaybe<Scalars['Float']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  zoneId?: InputMaybe<Scalars['ID']['input']>
}

export interface UpdateSavedReportInputInput {
  categoryId?: InputMaybe<Scalars['String']['input']>
  columnLabels?: InputMaybe<Scalars['JSONObject']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  expectedUpdatedAt?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  savedColumns?: InputMaybe<Array<Scalars['String']['input']>>
  savedDateRange?: InputMaybe<CreateSavedReportSavedDateRangeInput>
  savedFilters?: InputMaybe<Scalars['JSONObject']['input']>
  savedReportId: Scalars['String']['input']
  savedSiteIds?: InputMaybe<Array<Scalars['String']['input']>>
  savedSort?: InputMaybe<Array<UpdateSavedReportSavedSortInput>>
}

export interface UpdateSavedReportSavedSortInput {
  column: Scalars['String']['input']
  direction: SortDirection
}

/** Input for updating a single scheduled invoice date. Handles virtual and materialized invoices. */
export interface UpdateScheduledInvoiceDateInput {
  invoiceDate: Scalars['String']['input']
  invoiceId: Scalars['String']['input']
}

export interface UpdateScheduledPushSendInput {
  audienceType: ScheduledPushAudienceType
  message: Scalars['String']['input']
  scheduledPushSendId: Scalars['ID']['input']
  /** Wall-clock send time at the site (yyyy-MM-ddTHH:mm), interpreted in the site's timezone. Null sends immediately. */
  sendAtLocal?: InputMaybe<Scalars['String']['input']>
  sessionId?: InputMaybe<Scalars['ID']['input']>
  siteId: Scalars['ID']['input']
  title: Scalars['String']['input']
}

/** Input for updating a service template category */
export interface UpdateServiceTemplateCategoryInput {
  description?: InputMaybe<Scalars['String']['input']>
  displayOrder?: InputMaybe<Scalars['Float']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<ServiceTemplateCategoryStatus>
}

export interface UpdateServiceTemplateInputInput {
  accessSchedule?: InputMaybe<Scalars['JSONObject']['input']>
  accountCodeId?: InputMaybe<Scalars['String']['input']>
  agreementEnabled?: InputMaybe<Scalars['Boolean']['input']>
  agreementSendConfirmation?: InputMaybe<Scalars['Boolean']['input']>
  agreementText?: InputMaybe<Scalars['String']['input']>
  applyGuestPassAllowanceToActiveMembers?: InputMaybe<Scalars['Boolean']['input']>
  autoConvertTo?: InputMaybe<Scalars['String']['input']>
  autoConvertTrigger?: InputMaybe<AutoConvertTrigger>
  autoRenewEnabled?: InputMaybe<Scalars['Boolean']['input']>
  autoRenewType?: InputMaybe<AutoRenewType>
  billingAnchorDate?: InputMaybe<Scalars['String']['input']>
  billingCycleAmount?: InputMaybe<Scalars['Float']['input']>
  billingCycleUnit?: InputMaybe<BillingCycleUnit>
  billingDay?: InputMaybe<Scalars['Float']['input']>
  cancellation?: InputMaybe<CreateServiceTemplateCancellationInput>
  cancellationNoticePeriodAmount?: InputMaybe<Scalars['Float']['input']>
  cancellationNoticePeriodUnit?: InputMaybe<CancellationNoticePeriodUnit>
  categoryId?: InputMaybe<Scalars['String']['input']>
  categoryName?: InputMaybe<Scalars['String']['input']>
  changePlanEnabled?: InputMaybe<Scalars['Boolean']['input']>
  chargeSetupFeeUpFront?: InputMaybe<Scalars['Boolean']['input']>
  clientOnlinePurchaseExpiryDate?: InputMaybe<Scalars['String']['input']>
  clientOnlinePurchaseExpiryEnabled?: InputMaybe<Scalars['Boolean']['input']>
  creditRolloverPolicy?: InputMaybe<CreditRolloverPolicy>
  creditWindowEndDate?: InputMaybe<Scalars['String']['input']>
  credits?: InputMaybe<Array<CreateServiceTemplateCreditsInput>>
  description?: InputMaybe<Scalars['String']['input']>
  displayOrder?: InputMaybe<Scalars['Float']['input']>
  dynamicDisplayServiceTemplateIds?: InputMaybe<Array<Scalars['String']['input']>>
  earlyAccessApplyTo?: InputMaybe<EarlyAccessApplyTo>
  earlyAccessDurationAmount?: InputMaybe<Scalars['Float']['input']>
  earlyAccessDurationUnit?: InputMaybe<EarlyAccessDurationUnit>
  expiryAlertInDays?: InputMaybe<Scalars['Float']['input']>
  extraBookingWindow?: InputMaybe<Scalars['Float']['input']>
  familyShareable?: InputMaybe<Scalars['Boolean']['input']>
  feeRevenueTags?: InputMaybe<CreateServiceTemplateFeeRevenueTagsInput>
  firstCreditAllocationDate?: InputMaybe<CreateServiceTemplateFirstCreditAllocationDateInput>
  futureStartDate?: InputMaybe<Scalars['String']['input']>
  guestPassAllowance?: InputMaybe<CreateServiceTemplateGuestPassAllowanceInput>
  inheritAgreementsOnConvert?: InputMaybe<Scalars['Boolean']['input']>
  isAllSharedSites?: InputMaybe<Scalars['Boolean']['input']>
  isClientControlEnabled?: InputMaybe<Scalars['Boolean']['input']>
  isDefaultForTransferredClient?: InputMaybe<Scalars['Boolean']['input']>
  isEnabledForCMS?: InputMaybe<Scalars['Boolean']['input']>
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>
  isIntroOffer?: InputMaybe<Scalars['Boolean']['input']>
  isRestricted?: InputMaybe<Scalars['Boolean']['input']>
  lengthAmount?: InputMaybe<Scalars['Float']['input']>
  lengthType?: InputMaybe<ServiceLengthType>
  lengthUnit?: InputMaybe<ServiceLengthUnit>
  limitSale?: InputMaybe<CreateServiceTemplateLimitSaleInput>
  maxSharingCredits?: InputMaybe<Scalars['Float']['input']>
  maxSharingRecipients?: InputMaybe<Scalars['Float']['input']>
  minimumHomeUsageInDays?: InputMaybe<Scalars['Float']['input']>
  multiplePaymentOptions?: InputMaybe<CreateServiceTemplateMultiplePaymentOptionsInput>
  name?: InputMaybe<Scalars['String']['input']>
  newSaleDynamicDisplayServiceTemplateIds?: InputMaybe<Array<Scalars['String']['input']>>
  oneActivePerFamily?: InputMaybe<Scalars['Boolean']['input']>
  oneTimeSetupFee?: InputMaybe<Scalars['Numeric']['input']>
  oneTimeSetupFeeTaxEnabled?: InputMaybe<Scalars['Boolean']['input']>
  oneTimeSetupFeeTaxSettingIds?: InputMaybe<Array<Scalars['ID']['input']>>
  onlineSaleEnabled?: InputMaybe<Scalars['Boolean']['input']>
  onlineSaleStartDate?: InputMaybe<Scalars['String']['input']>
  payUpFrontEnabled?: InputMaybe<Scalars['Boolean']['input']>
  price?: InputMaybe<Scalars['Numeric']['input']>
  revenueTag?: InputMaybe<Scalars['String']['input']>
  saleAvailableFromDate?: InputMaybe<Scalars['String']['input']>
  saleAvailableUntilDate?: InputMaybe<Scalars['String']['input']>
  secondaryRecurringFee?: InputMaybe<CreateServiceTemplateSecondaryRecurringFeeInput>
  selfServicePause?: InputMaybe<CreateServiceTemplateSelfServicePauseInput>
  serviceFirstBillingDate?: InputMaybe<CreateServiceTemplateServiceFirstBillingDateInput>
  serviceTemplateId?: InputMaybe<Scalars['String']['input']>
  sharedSiteIds?: InputMaybe<Array<Scalars['String']['input']>>
  sharingCreditsAmount?: InputMaybe<Scalars['Float']['input']>
  sharingCreditsEnabled?: InputMaybe<Scalars['Boolean']['input']>
  siteAgreementTemplateId?: InputMaybe<Scalars['String']['input']>
  siteId?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<ServiceTemplateStatus>
  taxEnabled?: InputMaybe<Scalars['Boolean']['input']>
  taxSettingIds?: InputMaybe<Array<Scalars['ID']['input']>>
  tierOrder?: InputMaybe<Scalars['Float']['input']>
  toServiceTemplateId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<ServiceTemplateType>
}

export interface UpdateServiceTemplateSessionTypeAddOnInput {
  addOnName?: InputMaybe<Scalars['String']['input']>
  price?: InputMaybe<Scalars['Numeric']['input']>
  serviceTemplateSessionTypeAddOnId: Scalars['ID']['input']
  taxSettingIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

/** Input for updating a per-site accounting code (partial) */
export interface UpdateSiteAccountCodeInput {
  code?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

/** Replaces every editable field of an alert */
export interface UpdateSiteAlertInput {
  amenityId?: InputMaybe<Scalars['ID']['input']>
  body?: InputMaybe<Scalars['String']['input']>
  endsAt?: InputMaybe<Scalars['String']['input']>
  linkLabel?: InputMaybe<Scalars['String']['input']>
  linkUrl?: InputMaybe<Scalars['String']['input']>
  marksLocationClosed: Scalars['Boolean']['input']
  showAsPopup: Scalars['Boolean']['input']
  siteAlertId: Scalars['ID']['input']
  startsAt?: InputMaybe<Scalars['String']['input']>
  theme: SiteAlertTheme
  title: Scalars['String']['input']
}

export interface UpdateSiteCommunicationsSettingsUpdatesBlackoutTimeInput {
  endTime?: InputMaybe<Scalars['Float']['input']>
  startTime?: InputMaybe<Scalars['Float']['input']>
}

export interface UpdateSiteCommunicationsSettingsUpdatesCustomShortCodesInput {
  androidApp?: InputMaybe<Scalars['String']['input']>
  androidAppDownload?: InputMaybe<Scalars['String']['input']>
  classes?: InputMaybe<Scalars['String']['input']>
  dashboard?: InputMaybe<Scalars['String']['input']>
  iOSApp?: InputMaybe<Scalars['String']['input']>
  iOSAppDownload?: InputMaybe<Scalars['String']['input']>
  packages?: InputMaybe<Scalars['String']['input']>
  workshops?: InputMaybe<Scalars['String']['input']>
}

/** Input for updating site communication settings */
export interface UpdateSiteCommunicationsSettingsUpdatesInput {
  blackoutTime?: InputMaybe<UpdateSiteCommunicationsSettingsUpdatesBlackoutTimeInput>
  customShortCodes?: InputMaybe<UpdateSiteCommunicationsSettingsUpdatesCustomShortCodesInput>
  emailDefaultFrom?: InputMaybe<Scalars['String']['input']>
  emailDefaultFromName?: InputMaybe<Scalars['String']['input']>
  smsDefaultFromName?: InputMaybe<Scalars['String']['input']>
}

/** Input for updating a third-party integration configuration at site level */
export interface UpdateSiteCustomThirdPartyIntegrationInput {
  keyValues: Array<CreateSiteCustomIntegrationsKeyValuesInput>
  thirdPartyIntegrationId: Scalars['ID']['input']
}

export interface UpdateSiteGroupInputInput {
  name?: InputMaybe<Scalars['String']['input']>
  siteIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export interface UpdateSiteInputInput {
  addressCity?: InputMaybe<Scalars['String']['input']>
  addressCountry?: InputMaybe<Scalars['String']['input']>
  addressPostalCode?: InputMaybe<Scalars['String']['input']>
  addressState?: InputMaybe<Scalars['String']['input']>
  addressStreet?: InputMaybe<Scalars['String']['input']>
  addressStreet2?: InputMaybe<Scalars['String']['input']>
  adminConfigurations?: InputMaybe<CreateSiteAdminConfigurationsInput>
  appName?: InputMaybe<Scalars['String']['input']>
  businessEmail?: InputMaybe<Scalars['String']['input']>
  businessHours?: InputMaybe<CreateSiteBusinessHoursInput>
  capacity?: InputMaybe<Scalars['Float']['input']>
  clientFeesTemplateId?: InputMaybe<Scalars['String']['input']>
  connectedSharedSiteIds?: InputMaybe<Array<Scalars['String']['input']>>
  corePlanLevel?: InputMaybe<CorePlanLevel>
  countryId?: InputMaybe<Scalars['ID']['input']>
  customIntegrations?: InputMaybe<Array<CreateSiteCustomIntegrationsInput>>
  description?: InputMaybe<Scalars['String']['input']>
  displayBusinessHours?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  gatewayCurrentPaymentMethodId?: InputMaybe<Scalars['String']['input']>
  gatewayCustomerId?: InputMaybe<Scalars['String']['input']>
  hapanaFeesTemplateId?: InputMaybe<Scalars['ID']['input']>
  integrations?: InputMaybe<CreateSiteIntegrationsInput>
  isDigital?: InputMaybe<Scalars['Boolean']['input']>
  membersCount?: InputMaybe<Scalars['Float']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  openDate?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  phonePrefix?: InputMaybe<Scalars['String']['input']>
  rebateTemplateIds?: InputMaybe<Array<Scalars['ID']['input']>>
  regionId?: InputMaybe<Scalars['ID']['input']>
  royaltiesTemplateId?: InputMaybe<Scalars['ID']['input']>
  stateId?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<SiteStatus>
  timezone?: InputMaybe<Scalars['String']['input']>
  v1EncryptedId?: InputMaybe<Scalars['String']['input']>
  website?: InputMaybe<Scalars['String']['input']>
  workshopType?: InputMaybe<SiteWorkshopType>
}

/** Input for updating a site location with replacement rooms */
export interface UpdateSiteLocationInput {
  addressLine1?: InputMaybe<Scalars['String']['input']>
  addressLine2?: InputMaybe<Scalars['String']['input']>
  channelId?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  isDefault?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  postalCode?: InputMaybe<Scalars['String']['input']>
  rooms?: InputMaybe<Array<CreateSiteLocationRoomInput>>
  state?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<SiteLocationType>
}

/** Input for updating a room in a site location */
export interface UpdateSiteLocationRoomInput {
  allowOverlapping?: InputMaybe<Scalars['Boolean']['input']>
  customHours?: InputMaybe<CreateSiteLocationRoomCustomHoursInput>
  endTime?: InputMaybe<Scalars['String']['input']>
  hasResourceBooking?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  roomResourceTemplateId?: InputMaybe<Scalars['String']['input']>
  sameHoursAsLocation?: InputMaybe<Scalars['Boolean']['input']>
  startTime?: InputMaybe<Scalars['String']['input']>
}

/** Replaces a location’s whole Plan your visit configuration */
export interface UpdateSiteMemberAppSettingsInput {
  settings: UpdateSiteMemberAppSettingsSettingsInput
  siteId: Scalars['ID']['input']
}

export interface UpdateSiteMemberAppSettingsSettingsInput {
  locationInformation: UpdateSiteMemberAppSettingsSettingsLocationInformationInput
  planYourVisit: UpdateSiteMemberAppSettingsSettingsPlanYourVisitInput
}

export interface UpdateSiteMemberAppSettingsSettingsLocationInformationAmenitiesInput {
  isEnabled: Scalars['Boolean']['input']
  items: Array<UpdateSiteMemberAppSettingsSettingsLocationInformationAmenitiesItemsInput>
  maxVisible: Scalars['Int']['input']
}

export interface UpdateSiteMemberAppSettingsSettingsLocationInformationAmenitiesItemsInput {
  amenityKey?: InputMaybe<SiteAmenityKey>
  customIcon?: InputMaybe<SiteInfoBlockIcon>
  customName?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  isVisible: Scalars['Boolean']['input']
  note?: InputMaybe<Scalars['String']['input']>
  schedule?: InputMaybe<UpdateSiteMemberAppSettingsSettingsLocationInformationStaffedHoursScheduleInput>
}

export interface UpdateSiteMemberAppSettingsSettingsLocationInformationBlocksInput {
  body: Scalars['String']['input']
  icon?: InputMaybe<SiteInfoBlockIcon>
  id: Scalars['ID']['input']
  isVisible: Scalars['Boolean']['input']
  linkLabel?: InputMaybe<Scalars['String']['input']>
  linkUrl?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
}

export interface UpdateSiteMemberAppSettingsSettingsLocationInformationInput {
  amenities: UpdateSiteMemberAppSettingsSettingsLocationInformationAmenitiesInput
  blocks: Array<UpdateSiteMemberAppSettingsSettingsLocationInformationBlocksInput>
  heading: Scalars['String']['input']
  isEnabled: Scalars['Boolean']['input']
  staffedHours: UpdateSiteMemberAppSettingsSettingsLocationInformationStaffedHoursInput
}

export interface UpdateSiteMemberAppSettingsSettingsLocationInformationStaffedHoursInput {
  isEnabled: Scalars['Boolean']['input']
  label: Scalars['String']['input']
  schedule: UpdateSiteMemberAppSettingsSettingsLocationInformationStaffedHoursScheduleInput
}

export interface UpdateSiteMemberAppSettingsSettingsLocationInformationStaffedHoursScheduleInput {
  exceptions: Array<CreateSiteBusinessHoursExceptionsInput>
  is24x7: Scalars['Boolean']['input']
  weekly: CreateSiteBusinessHoursWeeklyInput
}

export interface UpdateSiteMemberAppSettingsSettingsPlanYourVisitForecastInput {
  chartEndHour?: InputMaybe<Scalars['Int']['input']>
  chartStartHour?: InputMaybe<Scalars['Int']['input']>
  isEnabled: Scalars['Boolean']['input']
  lookbackWeeks: Scalars['Int']['input']
}

export interface UpdateSiteMemberAppSettingsSettingsPlanYourVisitInput {
  forecast: UpdateSiteMemberAppSettingsSettingsPlanYourVisitForecastInput
  isEnabled: Scalars['Boolean']['input']
  isVisibleToGuests: Scalars['Boolean']['input']
  liveOccupancy: UpdateSiteMemberAppSettingsSettingsPlanYourVisitLiveOccupancyInput
  title: Scalars['String']['input']
}

export interface UpdateSiteMemberAppSettingsSettingsPlanYourVisitLiveOccupancyInput {
  averageVisitMinutes: Scalars['Int']['input']
  bandSize: Scalars['Int']['input']
  displayMode: OccupancyDisplayMode
  hideWhenClosed: Scalars['Boolean']['input']
  isEnabled: Scalars['Boolean']['input']
  privacyFloor: Scalars['Int']['input']
}

/** The location’s opening schedule; the legacy business hours fields are derived from it */
export interface UpdateSiteOpeningHoursInput {
  displayBusinessHours: Scalars['Boolean']['input']
  schedule: UpdateSiteMemberAppSettingsSettingsLocationInformationStaffedHoursScheduleInput
  siteId: Scalars['ID']['input']
}

export interface UpdateSitePayrollTierConfigurationInputInput {
  payrollType?: InputMaybe<PayrollType>
  rates?: InputMaybe<CreateSitePayrollTierConfigurationRatesInput>
  siteSessionTypeId?: InputMaybe<Scalars['ID']['input']>
  type?: InputMaybe<PayrollTierType>
}

export interface UpdateSitePayrollTierInputInput {
  name: Scalars['String']['input']
}

/** Input for changing a location's product plan override */
export interface UpdateSitePlanOverrideInput {
  planOverrideAllowed?: InputMaybe<Scalars['Boolean']['input']>
  planTierOverride?: InputMaybe<ProductPlanTier>
}

/** Input for updating a room resource template with advanced layout capabilities */
export interface UpdateSiteRoomResourceTemplateInput {
  bookingProperties?: InputMaybe<Array<CreateSiteRoomResourceTemplatePropertyInput>>
  boxId?: InputMaybe<Scalars['Float']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  isDefault?: InputMaybe<Scalars['Boolean']['input']>
  isDraft?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  spotHeight?: InputMaybe<Scalars['Float']['input']>
  spotWidth?: InputMaybe<Scalars['Float']['input']>
  spots?: InputMaybe<Array<CreateSiteRoomResourceTemplateSpotsInput>>
}

export interface UpdateSiteSettingsAccountBillingInputInput {
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  retryFailedPayments?: InputMaybe<UpdateSiteSettingsAccountBillingRetryFailedPaymentsInput>
  transactionFeePreference?: InputMaybe<TransactionFeePreference>
}

export interface UpdateSiteSettingsAccountBillingRetryFailedPaymentsInput {
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  intervalInDays?: InputMaybe<Scalars['Float']['input']>
  maxAttempts?: InputMaybe<Scalars['Float']['input']>
  maxFailoversPerDay?: InputMaybe<Scalars['Float']['input']>
}

export interface UpdateSiteSettingsAccountInvoiceInputInput {
  email?: InputMaybe<Scalars['String']['input']>
  label?: InputMaybe<Scalars['String']['input']>
}

export interface UpdateSiteSettingsAccountPayrollInputInput {
  additionalTypes?: InputMaybe<Array<PayrollAdditionalTypes>>
}

export interface UpdateSiteSettingsAccountPointOfSaleInputInput {
  enableCashDrawer?: InputMaybe<Scalars['Boolean']['input']>
  itemTypes?: InputMaybe<Array<NewSaleItemTypes>>
}

export interface UpdateSiteSettingsAccountTaxInputInput {
  enabled?: InputMaybe<Scalars['Boolean']['input']>
}

export interface UpdateSiteSettingsBlockingReasonsInputInput {
  blockingReasons: Array<UpdateSiteSettingsSuspensionReasonsSuspensionReasonsInput>
}

export interface UpdateSiteSettingsBusinessCustomizationAddressCoordinatesInput {
  latitude?: InputMaybe<Scalars['Float']['input']>
  longitude?: InputMaybe<Scalars['Float']['input']>
}

export interface UpdateSiteSettingsBusinessCustomizationAddressInput {
  city?: InputMaybe<Scalars['String']['input']>
  coordinates?: InputMaybe<UpdateSiteSettingsBusinessCustomizationAddressCoordinatesInput>
  country?: InputMaybe<Scalars['String']['input']>
  postalCode?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  street?: InputMaybe<Scalars['String']['input']>
}

export interface UpdateSiteSettingsBusinessCustomizationColorsInput {
  color: Scalars['String']['input']
}

export interface UpdateSiteSettingsBusinessCustomizationInputInput {
  address?: InputMaybe<UpdateSiteSettingsBusinessCustomizationAddressInput>
  colors?: InputMaybe<Array<UpdateSiteSettingsBusinessCustomizationColorsInput>>
  dashboardRevenuePeriod?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  logoImage?: InputMaybe<Scalars['String']['input']>
  logoImageTemp?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
}

export interface UpdateSiteSettingsBusinessLocationsInputInput {
  businessHours?: InputMaybe<CreateSiteBusinessHoursInput>
  displayBusinessHours?: InputMaybe<Scalars['Boolean']['input']>
}

export interface UpdateSiteSettingsCalendarConfigurationsInputInput {
  calendarInterval?: InputMaybe<Scalars['Float']['input']>
  calendarMaxTime?: InputMaybe<Scalars['String']['input']>
  calendarMinTime?: InputMaybe<Scalars['String']['input']>
  calendarStartDay?: InputMaybe<Scalars['String']['input']>
  defaultBookedListOrder?: InputMaybe<Scalars['String']['input']>
  defaultCalendarView?: InputMaybe<Scalars['String']['input']>
  enableContinuousEvents?: InputMaybe<Scalars['Boolean']['input']>
  enableDragAndDrop?: InputMaybe<Scalars['Boolean']['input']>
  hideRoomFromRoomView?: InputMaybe<Scalars['Boolean']['input']>
  hideTeamMemberFromTeamView?: InputMaybe<Scalars['Boolean']['input']>
}

export interface UpdateSiteSettingsCancellationReasonsInputInput {
  cancellationReasons: Array<UpdateSiteSettingsSuspensionReasonsSuspensionReasonsInput>
}

export interface UpdateSiteSettingsCheckInContactlessCheckInFormQuestionsInput {
  allowCheckInIfBelowOrEqualTo?: InputMaybe<Scalars['Float']['input']>
  favorite?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['String']['input']
  options?: InputMaybe<Array<UpdateSiteSettingsCheckInContactlessCheckInFormQuestionsOptionsInput>>
  order?: InputMaybe<Scalars['Float']['input']>
  question: Scalars['String']['input']
  type: ContactlessCheckInFormQuestionType
}

export interface UpdateSiteSettingsCheckInContactlessCheckInFormQuestionsOptionsInput {
  allowCheckIn: Scalars['Boolean']['input']
  id: Scalars['String']['input']
  order?: InputMaybe<Scalars['Float']['input']>
  text: Scalars['String']['input']
}

export interface UpdateSiteSettingsCheckInContactlessCheckInInput {
  enableDoorAccess?: InputMaybe<Scalars['Boolean']['input']>
  enableForm?: InputMaybe<Scalars['Boolean']['input']>
  enableQRCodeDeeplink?: InputMaybe<Scalars['Boolean']['input']>
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  formQuestions?: InputMaybe<Array<UpdateSiteSettingsCheckInContactlessCheckInFormQuestionsInput>>
  policies?: InputMaybe<Array<UpdateSiteSettingsCheckInContactlessCheckInPoliciesInput>>
  policyIds?: InputMaybe<Array<Scalars['String']['input']>>
  skipCheckInQuestions?: InputMaybe<Scalars['Boolean']['input']>
}

export interface UpdateSiteSettingsCheckInContactlessCheckInPoliciesInput {
  enabled: Scalars['Boolean']['input']
  order: Scalars['Float']['input']
  sitePolicyId: Scalars['String']['input']
}

export interface UpdateSiteSettingsCheckInInputInput {
  barcodeCheckInScreenRefreshPeriodInSeconds?: InputMaybe<Scalars['Float']['input']>
  bookingGateMode?: InputMaybe<FormBookingGateMode>
  checkInEndTime?: InputMaybe<Scalars['Float']['input']>
  checkInMarksAttendance?: InputMaybe<Scalars['Boolean']['input']>
  checkInStartTime?: InputMaybe<Scalars['Float']['input']>
  contactlessCheckIn?: InputMaybe<UpdateSiteSettingsCheckInContactlessCheckInInput>
  enableCheckInPopups?: InputMaybe<Scalars['Boolean']['input']>
  enableCheckInSoundAlerts?: InputMaybe<Scalars['Boolean']['input']>
  enableCheckInWidget?: InputMaybe<Scalars['Boolean']['input']>
  enableGeneralCheckIn?: InputMaybe<Scalars['Boolean']['input']>
  enableMobileClientCheckIn?: InputMaybe<Scalars['Boolean']['input']>
  enableReEntryGracePeriod?: InputMaybe<Scalars['Boolean']['input']>
  failOpenOffline?: InputMaybe<Scalars['Boolean']['input']>
  reEntryGracePeriodInSeconds?: InputMaybe<Scalars['Float']['input']>
}

export interface UpdateSiteSettingsContactlessCheckInFormQuestionsInputInput {
  questions: Array<UpdateSiteSettingsCheckInContactlessCheckInFormQuestionsInput>
}

export interface UpdateSiteSettingsContactlessCheckInInputInput {
  enableDoorAccess?: InputMaybe<Scalars['Boolean']['input']>
  enableForm?: InputMaybe<Scalars['Boolean']['input']>
  enableQRCodeDeeplink?: InputMaybe<Scalars['Boolean']['input']>
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  formQuestions?: InputMaybe<Array<UpdateSiteSettingsCheckInContactlessCheckInFormQuestionsInput>>
  policies?: InputMaybe<Array<UpdateSiteSettingsContactlessCheckInPoliciesInput>>
  policyIds?: InputMaybe<Array<Scalars['String']['input']>>
  skipCheckInQuestions?: InputMaybe<Scalars['Boolean']['input']>
}

export interface UpdateSiteSettingsContactlessCheckInPoliciesInput {
  enabled: Scalars['Boolean']['input']
  order: Scalars['Float']['input']
  sitePolicyId: Scalars['String']['input']
}

export interface UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsCustomPropertiesInput {
  customPropertyId: Scalars['String']['input']
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  required?: InputMaybe<Scalars['Boolean']['input']>
}

export interface UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsEmergencyContactInput {
  emergencyContactAddress: UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput
  emergencyContactEmail: UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput
  emergencyContactName: UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput
  emergencyContactPhone: UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput
  emergencyContactRelation: UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput
}

export interface UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsInput {
  customProperties?: InputMaybe<
    Array<
      InputMaybe<UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsCustomPropertiesInput>
    >
  >
  emergencyContact: UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsEmergencyContactInput
  formIds?: InputMaybe<Array<Scalars['String']['input']>>
  primaryProfile: UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileInput
}

export interface UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput {
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  required?: InputMaybe<Scalars['Boolean']['input']>
}

export interface UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileInput {
  address: UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput
  barcode: UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput
  birthday: UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput
  confirmPassword: UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput
  email: UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput
  firstName: UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput
  gender: UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput
  howDidYouHeadAboutUs: UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput
  lastName: UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput
  occupation: UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput
  password: UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput
  phone: UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput
  zipCode: UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput
}

export interface UpdateSiteSettingsLocationOperationBusinessSignUpFieldsInputInput {
  businessSignUpFields: UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsInput
}

export interface UpdateSiteSettingsLocationOperationClientSignUpFieldsClientSignUpFieldsInput {
  customProperties?: InputMaybe<
    Array<
      InputMaybe<UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsCustomPropertiesInput>
    >
  >
  emergencyContact: UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsEmergencyContactInput
  formIds?: InputMaybe<Array<Scalars['String']['input']>>
  policyIds?: InputMaybe<Array<Scalars['String']['input']>>
  primaryProfile: UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileInput
}

export interface UpdateSiteSettingsLocationOperationClientSignUpFieldsInputInput {
  clientSignUpFields: UpdateSiteSettingsLocationOperationClientSignUpFieldsClientSignUpFieldsInput
}

export interface UpdateSiteSettingsLocationOperationsMainInputInput {
  autoLogout?: InputMaybe<Scalars['Boolean']['input']>
  autoLogoutMinutes?: InputMaybe<AutoLogoutMinutes>
  enableBookABuddy?: InputMaybe<Scalars['Boolean']['input']>
  enableBuddySessionSharingVisibility?: InputMaybe<Scalars['Boolean']['input']>
  enableClientsToSignUp?: InputMaybe<Scalars['Boolean']['input']>
  preventDuplicatePhoneSignUp?: InputMaybe<Scalars['Boolean']['input']>
}

export interface UpdateSiteSettingsRegionalCommunicationInputInput {
  currency?: InputMaybe<Scalars['String']['input']>
  dateFormat?: InputMaybe<Scalars['String']['input']>
  numberFormat?: InputMaybe<Scalars['String']['input']>
  timeFormat?: InputMaybe<Scalars['String']['input']>
}

export interface UpdateSiteSettingsRetailAdditionalBillingTypesInputInput {
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  types?: InputMaybe<Array<UpdateSiteSettingsRetailAdditionalBillingTypesTypesInput>>
}

export interface UpdateSiteSettingsRetailAdditionalBillingTypesTypesInput {
  createdAt: Scalars['String']['input']
  enabled: Scalars['Boolean']['input']
  id: Scalars['ID']['input']
  name: Scalars['String']['input']
  type: AddtionalBillingType
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export interface UpdateSiteSettingsRetailCreditsInputInput {
  enableCreditsOnHoldIfClientHadFailedPayment?: InputMaybe<Scalars['Boolean']['input']>
  enableCreditsOnHoldIfClientHadTerminalFailedPayment?: InputMaybe<Scalars['Boolean']['input']>
  enableCreditsOnHoldIfClientHasProcessingPayment?: InputMaybe<Scalars['Boolean']['input']>
  referrals?: InputMaybe<UpdateSiteSettingsRetailCreditsReferralsInput>
}

export interface UpdateSiteSettingsRetailCreditsReferralsInput {
  creditsExistingClient?: InputMaybe<Scalars['Float']['input']>
  creditsToNewClient?: InputMaybe<Scalars['Float']['input']>
  existingClientEnabled?: InputMaybe<Scalars['Boolean']['input']>
  newClientEnabled?: InputMaybe<Scalars['Boolean']['input']>
}

export interface UpdateSiteSettingsRetailFeesDestinationInput {
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  price?: InputMaybe<Scalars['String']['input']>
  revenueTagId?: InputMaybe<Scalars['ID']['input']>
  taxSettings?: InputMaybe<Array<Scalars['String']['input']>>
}

export interface UpdateSiteSettingsRetailFeesDishonorInput {
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  onAllAttempts?: InputMaybe<Scalars['String']['input']>
  onDelinquentDays?: InputMaybe<UpdateSiteSettingsRetailFeesDishonorOnDelinquentDaysInput>
  onFirstAttempt?: InputMaybe<Scalars['String']['input']>
  onSecondAttempt?: InputMaybe<Scalars['String']['input']>
  onThirdAttempt?: InputMaybe<Scalars['String']['input']>
  taxSettings?: InputMaybe<Array<Scalars['String']['input']>>
}

export interface UpdateSiteSettingsRetailFeesDishonorOnDelinquentDaysInput {
  amount: Scalars['String']['input']
  days: Scalars['Float']['input']
}

export interface UpdateSiteSettingsRetailFeesInputInput {
  customLateCancelFeesEnabled?: InputMaybe<Scalars['Boolean']['input']>
  customNoShowFeesEnabled?: InputMaybe<Scalars['Boolean']['input']>
  destination?: InputMaybe<UpdateSiteSettingsRetailFeesDestinationInput>
  dishonor?: InputMaybe<UpdateSiteSettingsRetailFeesDishonorInput>
  lateCancel?: InputMaybe<UpdateSiteSettingsRetailFeesNoShowInput>
  noShow?: InputMaybe<UpdateSiteSettingsRetailFeesNoShowInput>
}

export interface UpdateSiteSettingsRetailFeesNoShowAutomaticInput {
  enabled: Scalars['Boolean']['input']
}

export interface UpdateSiteSettingsRetailFeesNoShowInput {
  automatic?: InputMaybe<UpdateSiteSettingsRetailFeesNoShowAutomaticInput>
  creditRefund?: InputMaybe<Scalars['Boolean']['input']>
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  price?: InputMaybe<Scalars['String']['input']>
  revenueTagId?: InputMaybe<Scalars['String']['input']>
  taxSettings?: InputMaybe<Array<Scalars['String']['input']>>
  unlimitedCreditsOnly?: InputMaybe<Scalars['Boolean']['input']>
}

export interface UpdateSiteSettingsRetailGeneralSalesAdditionalSortOfPackagesInput {
  direction: SortPackageDirection
  field: SortPackageField
}

export interface UpdateSiteSettingsRetailGeneralSalesInputInput {
  additionalSortOfPackages?: InputMaybe<UpdateSiteSettingsRetailGeneralSalesAdditionalSortOfPackagesInput>
  allowChangeOfProcessedByAtSale?: InputMaybe<Scalars['Boolean']['input']>
  allowMembershipSalesWithDuplicateCreditOrSessionTypes?: InputMaybe<Scalars['Boolean']['input']>
  allowSessionPackageSalesWithDuplicateCreditOrSessionTypes?: InputMaybe<
    Scalars['Boolean']['input']
  >
  autoAssignClientBarcodeNumber?: InputMaybe<Scalars['Boolean']['input']>
  autoRenewExhaustedSessionPackages?: InputMaybe<Scalars['Boolean']['input']>
  defaultAutoRenewToggleEnabledAtSale?: InputMaybe<Scalars['Boolean']['input']>
  enableAllMembershipsSoldOnlineToBeCancelledByMember?: InputMaybe<Scalars['Boolean']['input']>
  enableRestrictedPackages?: InputMaybe<Scalars['Boolean']['input']>
  redirectAfterPackagePayment?: InputMaybe<RedirectAfterPackagePayment>
  revenueTagDefaults?: InputMaybe<Scalars['JSONObject']['input']>
  revenueTagging?: InputMaybe<Array<UpdateSiteSettingsRetailGeneralSalesRevenueTaggingInput>>
}

export interface UpdateSiteSettingsRetailGeneralSalesRevenueTaggingInput {
  createdAt: Scalars['String']['input']
  description: Scalars['String']['input']
  enabled: Scalars['Boolean']['input']
  glCode: Scalars['String']['input']
  id: Scalars['ID']['input']
  mapping?: InputMaybe<RevenueTagMapping>
  name: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export interface UpdateSiteSettingsRetailGiftcardsInputInput {
  requireRecipientForGiftCardSales?: InputMaybe<Scalars['Boolean']['input']>
}

export interface UpdateSiteSettingsRetailSalesSettingsInputInput {
  miniumSignUpAge?: InputMaybe<Scalars['Float']['input']>
  printPosReceipt?: InputMaybe<Scalars['Float']['input']>
  requireRecipientForGiftCardSales?: InputMaybe<Scalars['Boolean']['input']>
  suppliers?: InputMaybe<Array<UpdateSiteSettingsRetailSalesSettingsSuppliersInput>>
}

export interface UpdateSiteSettingsRetailSalesSettingsSuppliersInput {
  address?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  name: Scalars['String']['input']
  phone?: InputMaybe<Scalars['String']['input']>
  status: SiteSupplierStatus
}

export interface UpdateSiteSettingsRetailSuspensionsInputInput {
  secondaryFeesContinueDuringSuspension?: InputMaybe<Scalars['Boolean']['input']>
  selfServicePause?: InputMaybe<UpdateSiteSettingsRetailSuspensionsSelfServicePauseInput>
}

export interface UpdateSiteSettingsRetailSuspensionsSelfServicePauseInput {
  alignToBillingCycle?: InputMaybe<Scalars['Boolean']['input']>
  enabled: Scalars['Boolean']['input']
  maxPerCalendarYear?: InputMaybe<UpdateSiteSettingsRetailSuspensionsSelfServicePauseMaxPerCalendarYearInput>
  noticePeriodDays?: InputMaybe<Scalars['Float']['input']>
  reasonIds?: InputMaybe<Array<Scalars['String']['input']>>
  reasonMandatory?: InputMaybe<Scalars['Boolean']['input']>
}

export interface UpdateSiteSettingsRetailSuspensionsSelfServicePauseMaxPerCalendarYearInput {
  amount: Scalars['Float']['input']
  unit: SelfServicePauseDurationUnit
}

export interface UpdateSiteSettingsSchedulerBookingRulesEnforceFixedBookingSlotIntervalsInput {
  duration?: InputMaybe<Scalars['Float']['input']>
}

export interface UpdateSiteSettingsSchedulerBookingRulesInputInput {
  allowMemberOverlappingSessions?: InputMaybe<Scalars['Boolean']['input']>
  allowStaffOverbooking?: InputMaybe<Scalars['Boolean']['input']>
  autoConfirmRequests?: InputMaybe<Scalars['Boolean']['input']>
  autoDeductCredits?: InputMaybe<Scalars['Boolean']['input']>
  bookingNotifications?: InputMaybe<Scalars['Boolean']['input']>
  enableBookABuddy?: InputMaybe<Scalars['Boolean']['input']>
  enableBookingRequests?: InputMaybe<Scalars['Boolean']['input']>
  enforceFixedBookingSlotIntervals?: InputMaybe<UpdateSiteSettingsSchedulerBookingRulesEnforceFixedBookingSlotIntervalsInput>
  enforceFixedBookingSlotIntervalsDuration?: InputMaybe<SchedulerTimeSlotDuration>
  requestTimeSlots?: InputMaybe<UpdateSiteSettingsSchedulerBookingRulesRequestTimeSlotsInput>
  requestTimeSlotsDuration?: InputMaybe<SchedulerTimeSlotDuration>
}

export interface UpdateSiteSettingsSchedulerBookingRulesRequestTimeSlotsInput {
  duration?: InputMaybe<Scalars['Float']['input']>
}

export interface UpdateSiteSettingsSchedulerCancellationRulesInputInput {
  allowClientDeclineAndCancelSessions?: InputMaybe<Scalars['Boolean']['input']>
  allowClientsToDeclineAndCancel?: InputMaybe<Scalars['Boolean']['input']>
  policies?: InputMaybe<UpdateSiteSettingsSchedulerCancellationRulesPoliciesInput>
}

export interface UpdateSiteSettingsSchedulerCancellationRulesPoliciesClassesInput {
  days: Scalars['Float']['input']
  hours: Scalars['Float']['input']
  minutes: Scalars['Float']['input']
}

export interface UpdateSiteSettingsSchedulerCancellationRulesPoliciesInput {
  classes?: InputMaybe<UpdateSiteSettingsSchedulerCancellationRulesPoliciesClassesInput>
  privates?: InputMaybe<UpdateSiteSettingsSchedulerCancellationRulesPoliciesClassesInput>
  workshops?: InputMaybe<UpdateSiteSettingsSchedulerCancellationRulesPoliciesClassesInput>
}

export interface UpdateSiteSettingsSchedulerClassesRulesInputInput {
  daysInAdvance?: InputMaybe<Scalars['Float']['input']>
  defaultColor?: InputMaybe<Scalars['String']['input']>
  displayClassSize?: InputMaybe<Scalars['Boolean']['input']>
  displayCompletedClasses?: InputMaybe<Scalars['Boolean']['input']>
  displayPriceColumn?: InputMaybe<Scalars['Boolean']['input']>
  instructorTypeFilter?: InputMaybe<Scalars['Boolean']['input']>
  roomTypeFilter?: InputMaybe<Scalars['Boolean']['input']>
  sessionTypeFilter?: InputMaybe<Scalars['Boolean']['input']>
  soapNotes?: InputMaybe<Scalars['Boolean']['input']>
}

export interface UpdateSiteSettingsSchedulerPrivatesRulesInputInput {
  daysInAdvance?: InputMaybe<Scalars['Float']['input']>
}

export interface UpdateSiteSettingsSchedulerReservationsRulesDaysInAdvanceInput {
  releaseType?: InputMaybe<ReleaseType>
  rolling?: InputMaybe<UpdateSiteSettingsSchedulerReservationsRulesDaysInAdvanceRollingInput>
  timed?: InputMaybe<UpdateSiteSettingsSchedulerReservationsRulesDaysInAdvanceTimedInput>
}

export interface UpdateSiteSettingsSchedulerReservationsRulesDaysInAdvanceRollingInput {
  classesBookedUpTo?: InputMaybe<Scalars['Float']['input']>
  periodOfTime?: InputMaybe<PeriodOfTime>
  time?: InputMaybe<Scalars['String']['input']>
  upTo?: InputMaybe<Scalars['Float']['input']>
}

export interface UpdateSiteSettingsSchedulerReservationsRulesDaysInAdvanceTimedInput {
  dayOfWeek?: InputMaybe<DayOfWeek>
  hoursAfter?: InputMaybe<Scalars['Float']['input']>
  numberOfWeeks?: InputMaybe<Scalars['Float']['input']>
  time?: InputMaybe<Scalars['String']['input']>
}

export interface UpdateSiteSettingsSchedulerReservationsRulesInputInput {
  daysInAdvance?: InputMaybe<UpdateSiteSettingsSchedulerReservationsRulesDaysInAdvanceInput>
  multipleReservations?: InputMaybe<Scalars['Boolean']['input']>
  overrides?: InputMaybe<UpdateSiteSettingsSchedulerReservationsRulesOverridesInput>
}

export interface UpdateSiteSettingsSchedulerReservationsRulesOverridesInput {
  byCategory?: InputMaybe<Scalars['JSONObject']['input']>
  bySessionType?: InputMaybe<Scalars['JSONObject']['input']>
}

export interface UpdateSiteSettingsSchedulerWaitlistRulesFirstToClaimInput {
  enabled: Scalars['Boolean']['input']
  windowHours: Scalars['Float']['input']
}

export interface UpdateSiteSettingsSchedulerWaitlistRulesInputInput {
  autoConfirmClients?: InputMaybe<Scalars['Boolean']['input']>
  firstToClaim?: InputMaybe<UpdateSiteSettingsSchedulerWaitlistRulesFirstToClaimInput>
  lockPeriod?: InputMaybe<UpdateSiteSettingsSchedulerWaitlistRulesLockPeriodInput>
  manualMovements?: InputMaybe<Scalars['Boolean']['input']>
  promotion?: InputMaybe<UpdateSiteSettingsSchedulerWaitlistRulesPromotionInput>
  restrictions?: InputMaybe<UpdateSiteSettingsSchedulerWaitlistRulesRestrictionsInput>
  strategy?: InputMaybe<WaitlistStrategy>
  topNBatchSize?: InputMaybe<Scalars['Float']['input']>
}

export interface UpdateSiteSettingsSchedulerWaitlistRulesLockPeriodInput {
  periodOfTime?: InputMaybe<PeriodOfTime>
  value?: InputMaybe<Scalars['Float']['input']>
}

export interface UpdateSiteSettingsSchedulerWaitlistRulesPromotionConfirmationWindowInput {
  periodOfTime?: InputMaybe<PeriodOfTime>
  value?: InputMaybe<Scalars['Float']['input']>
}

export interface UpdateSiteSettingsSchedulerWaitlistRulesPromotionInput {
  confirmationWindow?: InputMaybe<UpdateSiteSettingsSchedulerWaitlistRulesPromotionConfirmationWindowInput>
  method?: InputMaybe<WaitlistPromotionMethod>
  periodOfTime?: InputMaybe<PeriodOfTime>
  value?: InputMaybe<Scalars['Float']['input']>
}

export interface UpdateSiteSettingsSchedulerWaitlistRulesRestrictionsInput {
  type?: InputMaybe<WaitlistRestrictionType>
}

export interface UpdateSiteSettingsSchedulerWorkshopsRulesInputInput {
  daysInAdvance?: InputMaybe<Scalars['Float']['input']>
}

export interface UpdateSiteSettingsSocialMediaInputInput {
  facebook?: InputMaybe<Scalars['String']['input']>
  instagram?: InputMaybe<Scalars['String']['input']>
  website?: InputMaybe<Scalars['String']['input']>
  x?: InputMaybe<Scalars['String']['input']>
}

export interface UpdateSiteSettingsSuspensionReasonsInputInput {
  suspensionReasons: Array<UpdateSiteSettingsSuspensionReasonsSuspensionReasonsInput>
}

export interface UpdateSiteSettingsSuspensionReasonsSuspensionReasonsInput {
  createdAt?: InputMaybe<Scalars['String']['input']>
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  reason?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

/** Input for updating a site supplier */
export interface UpdateSiteSupplierInput {
  address?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<SiteSupplierStatus>
}

export interface UpdateSiteTerminalHandoffSettingsAgreementConsentTextsInput {
  siteAgreementTemplateId: Scalars['ID']['input']
  text: Scalars['String']['input']
}

export interface UpdateSiteTerminalHandoffSettingsEmailConsentToggleInput {
  enabled: Scalars['Boolean']['input']
  title: Scalars['String']['input']
}

export interface UpdateSiteTerminalHandoffSettingsInput {
  agreementConsentTexts: Array<UpdateSiteTerminalHandoffSettingsAgreementConsentTextsInput>
  consentText: Scalars['String']['input']
  eligibleFields: Array<TerminalHandoffField>
  emailConsentToggle: UpdateSiteTerminalHandoffSettingsEmailConsentToggleInput
  fallback: TerminalSignatureFallback
  fieldCaptureEnabled: Scalars['Boolean']['input']
  signAllLocations: Scalars['Boolean']['input']
  signatureDevice: TerminalSignatureDevice
  smsConsentToggle: UpdateSiteTerminalHandoffSettingsEmailConsentToggleInput
}

export interface UpdateSiteTerminalReaderInputInput {
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export interface UpdateSiteWebhookInputInput {
  events?: InputMaybe<Array<Scalars['String']['input']>>
  headerKey?: InputMaybe<Scalars['String']['input']>
  headerValue?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<SiteWebhookStatusInput>
  url?: InputMaybe<Scalars['String']['input']>
}

export interface UpdateSmsPackageOptionInputInput {
  count?: InputMaybe<Scalars['Float']['input']>
  price?: InputMaybe<Scalars['Float']['input']>
}

export interface UpdateSpiviInputInput {
  boxId?: InputMaybe<Scalars['String']['input']>
  password?: InputMaybe<Scalars['String']['input']>
  publicKey?: InputMaybe<Scalars['String']['input']>
  siteId?: InputMaybe<Scalars['String']['input']>
  sourceName?: InputMaybe<Scalars['String']['input']>
}

export interface UpdateStaffAccessPolicyInputInput {
  accessPermissions?: InputMaybe<Array<AccessPermissions>>
  allowedNetworkIds?: InputMaybe<Array<Scalars['ID']['input']>>
  corporatePermissions?: InputMaybe<Array<CorporatePermissions>>
  name?: InputMaybe<Scalars['String']['input']>
  sitePermissions?: InputMaybe<Array<SitePermissions>>
}

export interface UpdateStaffAllowedNetworkInputInput {
  address?: InputMaybe<Scalars['String']['input']>
  label?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  siteId?: InputMaybe<Scalars['ID']['input']>
}

export interface UpdateStaffSessionPolicyInputInput {
  /** Whether a location's own auto-logout setting may apply on its pages */
  allowLocationIdleTimeout: Scalars['Boolean']['input']
  /** Sign staff out after this many idle minutes on brand-level pages; null for never */
  brandIdleTimeoutMinutes?: InputMaybe<Scalars['Int']['input']>
  /** Force a fresh sign-in once a session is this many hours old; null for never */
  maxSessionHours?: InputMaybe<Scalars['Int']['input']>
}

export interface UpdateStaffUserInputInput {
  about?: InputMaybe<Scalars['String']['input']>
  accessLevel?: InputMaybe<Array<StaffUserAccessLevel>>
  data?: InputMaybe<CreateStaffUserDataInput>
  dateOfBirth?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  employeeNumber?: InputMaybe<Scalars['Float']['input']>
  favoriteReportNames?: InputMaybe<Array<Scalars['String']['input']>>
  favoriteSavedReportIds?: InputMaybe<Array<Scalars['ID']['input']>>
  favoriteSiteIds?: InputMaybe<Array<Scalars['ID']['input']>>
  firstName?: InputMaybe<Scalars['String']['input']>
  gender?: InputMaybe<Scalars['String']['input']>
  hobbies?: InputMaybe<Scalars['String']['input']>
  instagramHandle?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  siteData?: InputMaybe<CreateStaffUserDataInput>
}

export interface UpdateStaffUserSmartGroupInputInput {
  filters?: InputMaybe<CreateStaffUserSmartGroupFiltersInput>
  isVisible?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export interface UpdateStaffUserStatusInputInput {
  status: StaffUserStatus
}

export interface UpdateSupportChatInput {
  evalScore?: InputMaybe<Scalars['Float']['input']>
  responseLatencyMs?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<SupportChatStatus>
}

export interface UpdateSystemPreferencesInputInput {
  systemPreferences: UpdateSystemPreferencesSystemPreferencesInput
}

export interface UpdateSystemPreferencesSystemPreferencesAvailableClientsTabsInput {
  assessment?: InputMaybe<Scalars['Boolean']['input']>
  information?: InputMaybe<Scalars['Boolean']['input']>
  notes?: InputMaybe<Scalars['Boolean']['input']>
  payment?: InputMaybe<Scalars['Boolean']['input']>
  schedule?: InputMaybe<Scalars['Boolean']['input']>
}

export interface UpdateSystemPreferencesSystemPreferencesInput {
  availableClientsTabs?: InputMaybe<UpdateSystemPreferencesSystemPreferencesAvailableClientsTabsInput>
  defaultAllLocationsSearch?: InputMaybe<Scalars['Boolean']['input']>
  defaultBusinessProfileTab?: InputMaybe<BusinessProfileTab>
  defaultClientTab?: InputMaybe<ClientProfileTab>
  showBusinessInfo?: InputMaybe<Scalars['Boolean']['input']>
  tabsDisplayed?: InputMaybe<UpdateSystemPreferencesSystemPreferencesTabsDisplayedInput>
}

export interface UpdateSystemPreferencesSystemPreferencesTabsDisplayedInput {
  classes?: InputMaybe<Scalars['Boolean']['input']>
  packages?: InputMaybe<Scalars['Boolean']['input']>
  requestBooking?: InputMaybe<Scalars['Boolean']['input']>
  workshops?: InputMaybe<Scalars['Boolean']['input']>
}

/** Input for updating the tanning hardware integration configuration */
export interface UpdateTanningIntegrationInput {
  apiKey?: InputMaybe<Scalars['String']['input']>
  externalApiKey?: InputMaybe<Scalars['String']['input']>
  externalApiUrl?: InputMaybe<Scalars['String']['input']>
  maintenanceEmail?: InputMaybe<Scalars['String']['input']>
}

export interface UpdateTaxSettingInputInput {
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  rate?: InputMaybe<Scalars['String']['input']>
  setting?: InputMaybe<TaxSettingType>
}

export interface UpdateTopazInputInput {
  enabled: Scalars['Boolean']['input']
}

/** Input for updating a virtual invoice - materializes first, then applies changes */
export interface UpdateVirtualInvoiceInput {
  amount?: InputMaybe<Scalars['Numeric']['input']>
  discountReason?: InputMaybe<Scalars['String']['input']>
  discountType?: InputMaybe<DiscountType>
  discountValue?: InputMaybe<Scalars['Numeric']['input']>
  invoiceDate?: InputMaybe<Scalars['String']['input']>
  recurringInvoiceId: Scalars['ID']['input']
  sequenceNumber: Scalars['Float']['input']
}

export interface UpdateWorkingHoursWorkingHoursInput {
  customHoursEnabled: Scalars['Boolean']['input']
  friday?: InputMaybe<UpdateWorkingHoursWorkingHoursMondayInput>
  monday?: InputMaybe<UpdateWorkingHoursWorkingHoursMondayInput>
  saturday?: InputMaybe<UpdateWorkingHoursWorkingHoursMondayInput>
  sunday?: InputMaybe<UpdateWorkingHoursWorkingHoursMondayInput>
  thursday?: InputMaybe<UpdateWorkingHoursWorkingHoursMondayInput>
  tuesday?: InputMaybe<UpdateWorkingHoursWorkingHoursMondayInput>
  wednesday?: InputMaybe<UpdateWorkingHoursWorkingHoursMondayInput>
}

export interface UpdateWorkingHoursWorkingHoursMondayInput {
  endTime: Scalars['String']['input']
  startTime: Scalars['String']['input']
}

export interface UpdateZapierInputInput {
  webhooks?: InputMaybe<UpdateZapierWebhooksInput>
}

export interface UpdateZapierWebhooksInput {
  client?: InputMaybe<Scalars['String']['input']>
  clientCheckIn?: InputMaybe<Scalars['String']['input']>
  firstSessionBooking?: InputMaybe<Scalars['String']['input']>
  lead?: InputMaybe<Scalars['String']['input']>
  membershipCancellation?: InputMaybe<Scalars['String']['input']>
  membershipSuspension?: InputMaybe<Scalars['String']['input']>
  packagePurchase?: InputMaybe<Scalars['String']['input']>
  sessionBooking?: InputMaybe<Scalars['String']['input']>
}

/** Input for updating Zoom integration */
export interface UpdateZoomInput {
  authorized?: InputMaybe<Scalars['Boolean']['input']>
  userId?: InputMaybe<Scalars['String']['input']>
}

export interface UserContextInput {
  permissions?: InputMaybe<Array<Scalars['String']['input']>>
  role?: InputMaybe<Scalars['String']['input']>
  tier?: InputMaybe<Scalars['String']['input']>
  userId: Scalars['String']['input']
}

/** Type of user (api type is for REST API key authenticated requests) */
export enum UserType {
  admin = 'admin',
  api = 'api',
  client = 'client',
  staff = 'staff',
}

export enum VideoTranscodingStatus {
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  RUNNING = 'RUNNING',
  SUCCEEDED = 'SUCCEEDED',
}

export enum VideoUploadStatus {
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  READY = 'READY',
  UPLOADED = 'UPLOADED',
  UPLOADING = 'UPLOADING',
}

/** Visibility scope controlling which sites can see the content. `ALL` and `BRAND_ONLY` are the canonical content-suite values. `SPECIFIC` is accepted as a federation-compat shim only (the reporting subgraph's SavedReport enum still uses it as an input) and is silently coerced to `ALL` at the corporates write boundary; it will be removed once reporting drops it on its side. */
export enum VisibilityScope {
  ALL = 'ALL',
  BRAND_ONLY = 'BRAND_ONLY',
  SPECIFIC = 'SPECIFIC',
}

/** Input for voiding a running tanning session: the reason, an optional staff note, and whether to take the bed out of use */
export interface VoidEquipmentAssignmentInput {
  assignmentId: Scalars['ID']['input']
  markEquipmentUnavailable: Scalars['Boolean']['input']
  note?: InputMaybe<Scalars['String']['input']>
  reason: TanningSessionVoidReason
}

export enum WaitlistEntryStatus {
  CANCELLED = 'CANCELLED',
  CONVERTED = 'CONVERTED',
  EXPIRED = 'EXPIRED',
  INVITED = 'INVITED',
  WAITING = 'WAITING',
}

/** Waitlist invitation strategy types */
export enum WaitlistInvitationStrategy {
  ALL = 'ALL',
  DYNAMIC = 'DYNAMIC',
  TOP_N = 'TOP_N',
}

export enum WaitlistPromotionMethod {
  AUTOMATIC = 'AUTOMATIC',
  CONFIRMATION_WINDOW = 'CONFIRMATION_WINDOW',
}

export enum WaitlistRestrictionType {
  DEDUCT_CREDIT_WHEN_JOINING = 'DEDUCT_CREDIT_WHEN_JOINING',
  ENABLE_JOIN_WITHOUT_VALID_CREDITS = 'ENABLE_JOIN_WITHOUT_VALID_CREDITS',
  ENABLE_JOIN_WITH_VALID_CREDITS = 'ENABLE_JOIN_WITH_VALID_CREDITS',
}

export enum WaitlistStrategy {
  ALL = 'ALL',
  DYNAMIC = 'DYNAMIC',
  TOP_N = 'TOP_N',
}

/** Type of webhook endpoint (corporate or site level) */
export enum WebhookType {
  corporate = 'corporate',
  site = 'site',
}

/** How the Hapana schedule and the Wellhub catalog disagree about one class, session or slot */
export enum WellhubDivergenceKind {
  CapacityDrift = 'CapacityDrift',
  ClassDuplicated = 'ClassDuplicated',
  ClassMissing = 'ClassMissing',
  ClassUnadopted = 'ClassUnadopted',
  SlotMissing = 'SlotMissing',
  SlotNeverPushed = 'SlotNeverPushed',
  SlotOrphaned = 'SlotOrphaned',
  SlotShouldBeDeleted = 'SlotShouldBeDeleted',
}

/** Button style for widget appearance */
export enum WidgetButtonStyle {
  pill = 'pill',
  rounded = 'rounded',
  square = 'square',
}

export interface ZonesFilterInput {
  /** Filter by country ID */
  countryId?: InputMaybe<Scalars['String']['input']>
  /** Filter by timezone */
  timezone?: InputMaybe<Scalars['String']['input']>
}

export enum ZonesOrderBy {
  code = 'code',
  name = 'name',
  timezone = 'timezone',
}

export interface ZonesOrderByInput {
  column: ZonesOrderBy
  direction: OrderByDirection
}

export const scalarsEnumsHash: ScalarsEnumsHash = {
  AccessControlProvider: true,
  AccessMode: true,
  AccessPermissions: true,
  AccessProvider: true,
  ActivityStreamOrderByColumn: true,
  AddOnDiscountScope: true,
  AddtionalBillingType: true,
  AdminAggregatorSessionSort: true,
  AdminMobileFleetAppleSessionAction: true,
  AdminMobileFleetAppleTeamIssue: true,
  AdminMobileFleetBlocker: true,
  AdminMobileFleetCredentialState: true,
  AdminMobileFleetCredentialsStatus: true,
  AdminMobileFleetNextActionKind: true,
  AdminMobileFleetPlatformFilter: true,
  AdminMobileFleetQuickFilter: true,
  AdminMobileFleetReleaseStage: true,
  AdminMobileFleetSeverity: true,
  AdminMobileFleetStatusFilter: true,
  AdminUserPermissions: true,
  AdminUserStatus: true,
  AdminUsersOrderBy: true,
  AgeBandOutcome: true,
  AgeEvidenceRequired: true,
  AgeVerificationMethod: true,
  AgentStatus: true,
  AgreementMethod: true,
  AgreementSignedSource: true,
  AgreementStatus: true,
  AgreementType: true,
  AlertOperator: true,
  AnalyticsV2FilterOperator: true,
  AnalyticsV2OrderDirection: true,
  AnalyticsV2TimeGranularity: true,
  AnalyticsV2TrustTier: true,
  AndroidPermission: true,
  ApiCallLogCredentialType: true,
  ApiCallLogStatus: true,
  ApiCallLogType: true,
  ApiCredentialEnv: true,
  ApiCredentialKind: true,
  ApiCredentialStatus: true,
  AppleAccountSessionMode: true,
  AppleAccountSessionStatus: true,
  AppleAutomationReason: true,
  AppleAutomationSource: true,
  AppleContentRightsDeclaration: true,
  AssignabilityBlockedReason: true,
  AssignedStaffSource: true,
  AttendanceSource: true,
  AttendanceStatus: true,
  AttendanceType: true,
  AuditAction: true,
  AuditAggregationGroupBy: true,
  AuditDeviceType: true,
  AuditPlatform: true,
  AuditResource: true,
  AuditSeverity: true,
  AuditSortDirection: true,
  AuditSortField: true,
  AuditSource: true,
  AuditVisibility: true,
  AutoConvertTrigger: true,
  AutoLogoutMinutes: true,
  AutoRenewType: true,
  BiParityStatus: true,
  BigQueryExportName: true,
  BillingCycleUnit: true,
  BookingActivityType: true,
  BookingAvailability: true,
  BookingCreditPackageIneligibleReason: true,
  BookingFeeType: true,
  BookingPaymentMethodKind: true,
  BookingPaymentStatus: true,
  BookingSource: true,
  BookingStatus: true,
  Boolean: true,
  BrandAddOnField: true,
  BrandAddOnSkippedLinkReason: true,
  BrandArtworkField: true,
  BrandArtworkFormat: true,
  BrandBuildConfigViewStatus: true,
  BrandConfigSavedByPersona: true,
  BrandEnvironment: true,
  BrandNativeReleaseReason: true,
  BrandNativeReleaseStatus: true,
  BrandNavigationArtworkField: true,
  BrandObservePerfStatus: true,
  BrandPlatform: true,
  BrandProvisionStatus: true,
  BrandProvisionStep: true,
  BrandProvisioningOwner: true,
  BrandProvisioningStepStatus: true,
  BrandPushPath: true,
  BrandRegistryStatus: true,
  BrandReleaseRequirement: true,
  BrandReleaseStoreVerdict: true,
  BrandScheduleClock: true,
  BrandServiceTemplateArchiveSkipReason: true,
  BrandServiceTemplateBlockedReasonCode: true,
  BrandServiceTemplateChangeSetKind: true,
  BrandServiceTemplateChangeSetSiteStatus: true,
  BrandServiceTemplateChangeSetStatus: true,
  BrandServiceTemplateMemberImpact: true,
  BrandServiceTemplateRefusalCode: true,
  BrandServiceTemplateSection: true,
  BrandServiceTemplateSiteAction: true,
  BrandSetupEvidence: true,
  BrandSetupStep: true,
  BrandSetupStepState: true,
  BrandStatus: true,
  BrandStoreAssetFormat: true,
  BrandStoreAssetStatus: true,
  BrandStoreAssetType: true,
  BrandStoreListingPublicationStatus: true,
  BrandStoreOperationAction: true,
  BrandStoreOperationStatus: true,
  BrandStoreProvider: true,
  BrandStoreSnapshotStatus: true,
  BrandStoreTesterSource: true,
  BrandUpdateChannel: true,
  BrandingImageFieldName: true,
  BuildConfigSource: true,
  BusinessProfileTab: true,
  BusinessType: true,
  CancelPendingClientActionOutcome: true,
  CancelSessionScope: true,
  CancellationEffectiveDateRule: true,
  CancellationFeeBreakdownKind: true,
  CancellationFeeSource: true,
  CancellationFeeValueKind: true,
  CancellationNoticePeriodUnit: true,
  CancellationPreviewBlocker: true,
  CancellationTierBasis: true,
  CardFunding: true,
  CashDrawerSessionStatus: true,
  CashDrawerTransactionKind: true,
  CatalogOrderBy: true,
  CheckInAttemptStatus: true,
  CheckInAuditFailReason: true,
  CheckInFailReason: true,
  CheckInSource: true,
  CheckInStatus: true,
  CheckInType: true,
  ClientActivityFeedKind: true,
  ClientBookingBuddyStatus: true,
  ClientBookingOrderByColumn: true,
  ClientFamilyRelationship: true,
  ClientGrowSyncStatus: true,
  ClientOrderBy: true,
  ClientPaymentMethodStatus: true,
  ClientPaymentMethodType: true,
  ClientProfileTab: true,
  ClientRelationStatus: true,
  ClientRelationType: true,
  ClientRelationViewType: true,
  ClientServicesSortBy: true,
  ClientSiteLinkSource: true,
  ClientSource: true,
  ClientTimelineActorType: true,
  ClientTimelineEventType: true,
  ClientTimelinePlatform: true,
  ClientTimelineSource: true,
  ClientType: true,
  ClockStatus: true,
  CloseReason: true,
  CmsContentEntrySource: true,
  CmsCustomEntryKind: true,
  CmsGranularity: true,
  CmsImportChangeType: true,
  CmsImportMappingStatus: true,
  CmsImportMode: true,
  CmsImportRunStatus: true,
  CmsImportStepStatus: true,
  CmsImportStepType: true,
  CmsVideoSortBy: true,
  ColumnFormat: true,
  CommPrefsSource: true,
  CommissionAttributionSourceSetting: true,
  CommissionBase: true,
  CommissionCategory: true,
  CommissionDashboardEmployeeStatus: true,
  CommissionDashboardReviewReason: true,
  CommissionEarnerRole: true,
  CommissionEnablementReason: true,
  CommissionEventKind: true,
  CommissionEventStatus: true,
  CommissionItemSettingSource: true,
  CommissionItemType: true,
  CommissionLeaverRule: true,
  CommissionLineKind: true,
  CommissionManagerScope: true,
  CommissionOwnerChangeMode: true,
  CommissionPeriodLength: true,
  CommissionPeriodStatus: true,
  CommissionPeriodTransitionTarget: true,
  CommissionPlanScope: true,
  CommissionPlanSource: true,
  CommissionPlanStatus: true,
  CommunicationTemplateAliases: true,
  CommunicationTemplatePlaceholders: true,
  CommunicationType: true,
  ConsentWithdrawalSource: true,
  ContactlessCheckInFormQuestionType: true,
  ContentApiKeyStatus: true,
  ContentBulkAction: true,
  ContentEntryLevel: true,
  ContentEntryOrderBy: true,
  ContentStatus: true,
  ContentTypeGroup: true,
  ContentVideoSource: true,
  CoreAppServiceKeyName: true,
  CorePlanLevel: true,
  CorporateFaqStatus: true,
  CorporatePayoutAccountOrderBy: true,
  CorporatePermissions: true,
  CorporateServiceTemplateStatus: true,
  CorporateServiceTemplateType: true,
  CorporateSessionTypeNameClash: true,
  CorporateSessionTypeWithdrawMode: true,
  CorporateTier: true,
  CorporateWebhookStatus: true,
  CountriesOrderBy: true,
  CoverApprovalMode: true,
  CoverCancelReason: true,
  CoverClaimStatus: true,
  CoverClaimVia: true,
  CoverCommunicationChannel: true,
  CoverCommunicationKind: true,
  CoverCommunicationSkipReason: true,
  CoverCommunicationStatus: true,
  CoverEligibilityWarning: true,
  CoverFilledVia: true,
  CoverIneligibilityReason: true,
  CoverMemberNotification: true,
  CoverMessageAudienceRole: true,
  CoverMessageChannel: true,
  CoverMessageRecipientMode: true,
  CoverOfferStatus: true,
  CoverOfferStrategy: true,
  CoverRequestStatus: true,
  CreatedAtLevel: true,
  CreatedByType: true,
  CredentialFieldType: true,
  CreditExpirationType: true,
  CreditExpirationUnit: true,
  CreditRolloverPolicy: true,
  CreditShortfallReason: true,
  CreditType: true,
  Currency: true,
  CustomLinkOpeningMethod: true,
  CustomPropertyCategory: true,
  CustomPropertyChangedByType: true,
  CustomPropertyType: true,
  DarkModeStrategy: true,
  DatabaseType: true,
  DateFilterOperator: true,
  DateRangeDirection: true,
  DateRangeType: true,
  DayOfWeek: true,
  DeepLinkDestination: true,
  DemoSeedingDensity: true,
  DemoSeedingJobStatus: true,
  DemoSeedingPersona: true,
  DeviceBusyReason: true,
  DeviceCapability: true,
  DeviceInputMode: true,
  DeviceKind: true,
  DeviceLiveness: true,
  DevicePlatform: true,
  DeviceReachability: true,
  DirectUploadFormat: true,
  DirectUploadTarget: true,
  DiscountType: true,
  DisputeStatus: true,
  DnsRecordStatus: true,
  DnsRecordType: true,
  DocumentFileVersionFormat: true,
  DocumentFileVersionType: true,
  DoorAccessCredentialType: true,
  DoorAccessEventDeniedBy: true,
  DoorAccessEventSortField: true,
  DoorAccessOutcome: true,
  DoorConnectionFailureReason: true,
  DoorProvider: true,
  DoorReconcileStatus: true,
  DoorType: true,
  DropInRefundMethod: true,
  ESignConsentProfile: true,
  EarlyAccessApplyTo: true,
  EarlyAccessDurationUnit: true,
  EgymMembershipType: true,
  EmailCopyEmployee: true,
  EmailDomainStatus: true,
  EmailSendAs: true,
  EmailSendBeforeUnit: true,
  EmbedAppearanceButtonStyle: true,
  EmbedButtonStyle: true,
  EmbedSidebarPosition: true,
  EmployeeLinkOutcome: true,
  EquipmentAssignmentStatus: true,
  EquipmentCategory: true,
  EquipmentComplianceSort: true,
  EquipmentComplianceSortDirection: true,
  EquipmentComplianceStatus: true,
  EquipmentComplianceWarningCode: true,
  EquipmentLampLogEventType: true,
  EquipmentLampSet: true,
  EquipmentLampState: true,
  EquipmentQualityCategory: true,
  EquipmentSessionTypeAvailabilityKind: true,
  EquipmentSessionTypeBlockReason: true,
  EquipmentStartDecision: true,
  EquipmentStatus: true,
  EquipmentType: true,
  ExportFormat: true,
  ExportJobStatusEnum: true,
  ExternalVideoMimeType: true,
  FailedPaymentFeeScope: true,
  FailureCategory: true,
  FamilyMemberRole: true,
  FamilyMemberStatus: true,
  FamilyStatus: true,
  FeatureDataRefreshState: true,
  FeeAccountType: true,
  FeeClassificationTypes: true,
  FeeConfigurationOrderBy: true,
  FeeEventType: true,
  FeeRateType: true,
  FeedbackQuestionType: true,
  FileUploadConfigFieldPendingStatus: true,
  FileUploadConfigFieldStatus: true,
  FindClientFeesTemplatesSortFields: true,
  FindClientsSortFields: true,
  FindCorporatesSortFields: true,
  FindFeesTemplatesSortFields: true,
  FirebaseAppProjectEnvironment: true,
  FirebaseAppProjectStatus: true,
  FirstCreditAllocationDateType: true,
  FirstCycleSettlementKind: true,
  FirstPaymentAfterUnit: true,
  FitnessPassportCheckOutcome: true,
  FitnessPassportConnectionState: true,
  FitnessPassportFailurePolicy: true,
  FitnessPassportLinkStatus: true,
  FitnessPassportVisitOutcome: true,
  Float: true,
  FobByteOrder: true,
  FobCaptureResultCode: true,
  FobCaptureStatus: true,
  FobController: true,
  FobReaderFormat: true,
  FobSerialNotation: true,
  FontFieldName: true,
  FontFormat: true,
  FontSource: true,
  FormBookingGateMode: true,
  FormCompletedVia: true,
  FormExternalResultSource: true,
  FormHandoffChannel: true,
  FormHandoffResultCode: true,
  FormHandoffStatus: true,
  FormRequiredBefore: true,
  FormSignatureFormat: true,
  FormSubmissionStatus: true,
  GatewayType: true,
  GiftCardExpiryMode: true,
  GiftCardExpiryPolicy: true,
  GiftCardExpiryRuleHistoryAction: true,
  GiftCardExpiryRuleReviewStatus: true,
  GiftCardExpiryRuleSource: true,
  GiftCardFilterType: true,
  GiftCardStatus: true,
  GiftCardTemplateSortFields: true,
  GiftCardTemplateStatus: true,
  GiftCardValidationReason: true,
  GrowStatusFilter: true,
  GuestPassByTokenError: true,
  GuestPassExpiryBehaviour: true,
  GuestPassStatus: true,
  HeadingFontSource: true,
  HeldPaymentReleaseOutcome: true,
  HeldPaymentReleaseReason: true,
  ID: true,
  ImageFileVersionFormat: true,
  ImageFileVersionType: true,
  ImageSupportedVariant: true,
  ImportPreviewFilterBy: true,
  ImportSessionStatusEnum: true,
  Int: true,
  InvitationRole: true,
  InvitationStatus: true,
  InvoiceCancellationSource: true,
  InvoiceItemType: true,
  InvoicePendingReason: true,
  InvoiceSource: true,
  InvoiceStatus: true,
  InvoiceType: true,
  InvoicesOrderBy: true,
  IosUsageDescriptionKey: true,
  JSON: true,
  JSONObject: true,
  JurisdictionRuleStatus: true,
  KnowledgeArticleStatus: true,
  LeadSource: true,
  LeaderboardMetric: true,
  LeaderboardScope: true,
  LeaderboardStatus: true,
  LeaderboardType: true,
  LeaderboardVisibility: true,
  LiveOccupancyLabelKey: true,
  LiveOccupancyStatus: true,
  LogicalOperator: true,
  MediaOrderBy: true,
  MediaType: true,
  MemberDisplayFormat: true,
  MemberExperienceDarkMode: true,
  MemberExperienceStreakScope: true,
  MemberExperienceSurface: true,
  MemberExperienceSurfaceIntegrationProvider: true,
  MemberFormChannel: true,
  MemberLinkStatus: true,
  MemberMovementApprovalPostureSource: true,
  MemberMovementAttestationScope: true,
  MemberMovementBillingAmountStrategy: true,
  MemberMovementBlockedNotificationCadence: true,
  MemberMovementBlockedReason: true,
  MemberMovementCandidateHomeExclusion: true,
  MemberMovementDurationUnit: true,
  MemberMovementGateKey: true,
  MemberMovementGateStatus: true,
  MemberMovementIncomingSegment: true,
  MemberMovementMappingMatchType: true,
  MemberMovementMappingStateFilter: true,
  MemberMovementOperatingMode: true,
  MemberMovementPaymentMigrationReason: true,
  MemberMovementPaymentMigrationStatus: true,
  MemberMovementReasonCode: true,
  MemberMovementReviewStatus: true,
  MemberMovementRollingApprovalType: true,
  MemberMovementRunMode: true,
  MemberMovementRunStatus: true,
  MemberMovementStatus: true,
  MemberMovementTemplateMappingMode: true,
  MemberMovementTrigger: true,
  MemberMovementVisitsScope: true,
  MemberPauseAllowanceUnit: true,
  MemberPauseBlocker: true,
  MemberServiceSuspensionSource: true,
  MembershipImportBlockingIssueCode: true,
  MembershipMemberStatusFilter: true,
  MergeScope: true,
  MessageType: true,
  MinimumTermAfterUnit: true,
  MobileAppChangeField: true,
  MobileAppChangeImpact: true,
  MobileAppPlatform: true,
  MobileSupportedLanguage: true,
  MultipleReservationOutcome: true,
  MyPendingRelationship: true,
  MyPolicyRefusalCode: true,
  NativePermissionSource: true,
  NewSaleItemTypes: true,
  NonUvCategory: true,
  NotificationMethod: true,
  Numeric: true,
  NumericFilterOperator: true,
  NumericToDateFilterOperator: true,
  OccupancyDisplayMode: true,
  OnboardingCategory: true,
  OnboardingStepKey: true,
  OrderByDirection: true,
  PaymentApprovalDeliveryState: true,
  PaymentApprovalLinkState: true,
  PaymentDisputeState: true,
  PaymentFallbackReason: true,
  PaymentFallbackState: true,
  PaymentGateway: true,
  PaymentGatewayTransactionStatus: true,
  PaymentMethodRemovalBlockReason: true,
  PaymentMethodType: true,
  PaymentMode: true,
  PaymentRecoveryState: true,
  PaymentRoutingMode: true,
  PaymentStatus: true,
  PaymentStatusFilter: true,
  PaymentWallet: true,
  PaymentsPipelineMode: true,
  PayrollAdditionalTypes: true,
  PayrollTierType: true,
  PayrollType: true,
  PendingChangeType: true,
  PendingItemHandoffCapability: true,
  PendingItemKind: true,
  PendingItemsAutoSendSkipReason: true,
  PendingItemsChannel: true,
  PendingItemsHandoffStatus: true,
  PendingPaymentCancellationOutcome: true,
  PendingPaymentCancellationReason: true,
  PeriodOfTime: true,
  PiiClassification: true,
  PlanChangeDirection: true,
  PolicyAcceptanceMethod: true,
  PolicyAcceptanceState: true,
  PolicyBulkSendStatus: true,
  PolicyEquipmentScope: true,
  PolicyEvidenceExportStatus: true,
  PolicyRevisionStatus: true,
  PolicySignerRule: true,
  PosActivityCategory: true,
  PosActivityType: true,
  PosCategoryStatus: true,
  PosProductStatus: true,
  PosStockAdjusmentType: true,
  PresaleShortfallAction: true,
  ProcessCSVImportStatus: true,
  ProcessZIPImportStatus: true,
  ProductPlanTier: true,
  PromoCodeDiscountType: true,
  PromoCodeItemType: true,
  PromoCodeSortFields: true,
  PromoCodeStatus: true,
  PublicApiLogLevel: true,
  PublicSigningPaymentMethodType: true,
  PushProvider: true,
  RankingDirection: true,
  ReaderType: true,
  ReadinessItemTiming: true,
  ReadinessReasonCode: true,
  ReadinessStatus: true,
  ReasonsNotAutoRetryable: true,
  RebateTemplateOrderBy: true,
  RecurrenceType: true,
  RecurringInvoiceOrderBy: true,
  RecurringInvoiceStatus: true,
  RecurringInvoiceType: true,
  RecurringSessionEditScope: true,
  RecurringSessionStatus: true,
  RedirectAfterPackagePayment: true,
  RefreshFrequency: true,
  RefundAllocationMethod: true,
  RefundOrigin: true,
  RefundStatus: true,
  RefundType: true,
  RefundableGatewayFeeCode: true,
  ReinstateBlockedReason: true,
  ReleaseHubAvailabilityKind: true,
  ReleaseHubScope: true,
  ReleaseHubStage: true,
  ReleaseHubType: true,
  ReleaseNoteStatus: true,
  ReleaseNoteTranslationStatus: true,
  ReleaseNoteType: true,
  ReleaseTerminalPaymentOutcome: true,
  ReleaseType: true,
  ReplaceExternalVideoMimeType: true,
  ReportName: true,
  ReportNoticeLevel: true,
  ReportPermissionCategory: true,
  RestartEquipmentAssignmentOutcome: true,
  ResurveyInterval: true,
  RevenueTagMapping: true,
  ReversalReason: true,
  RevisionChangeType: true,
  RevisionReviewState: true,
  RoomResourceTemplateBookingPropertyTypes: true,
  RoyaltiesAndFeesTemplateOrderBy: true,
  RoyaltyBaseMode: true,
  SaleAvailabilityState: true,
  SaleItemType: true,
  SandboxAnonymisedClientColumn: true,
  SandboxJobKind: true,
  SandboxJobStatus: true,
  SandboxReportClientAction: true,
  SandboxStatusFilter: true,
  SandboxStepName: true,
  SandboxStepStatus: true,
  SavedReportVisibility: true,
  ScheduleAction: true,
  ScheduleDefaultView: true,
  ScheduledInvoiceType: true,
  ScheduledJobLevel: true,
  ScheduledJobRunStatus: true,
  ScheduledJobTriggerSafety: true,
  ScheduledJobTriggerSource: true,
  ScheduledPushAudienceType: true,
  ScheduledPushFailureReason: true,
  ScheduledPushSendStatus: true,
  SchedulerTimeSlotDuration: true,
  ScoreType: true,
  SelectFilterOperator: true,
  SelfServicePauseCadenceUnit: true,
  SelfServicePauseChargeMode: true,
  SelfServicePauseDurationUnit: true,
  ServiceActionType: true,
  ServiceCancellationStatus: true,
  ServiceCreditLedgerDirection: true,
  ServiceCreditLedgerTransactionType: true,
  ServiceCreditShareStatus: true,
  ServiceExtensionType: true,
  ServiceExtensionUnit: true,
  ServiceLengthType: true,
  ServiceLengthUnit: true,
  ServicePlanChangeEffectiveType: true,
  ServicePlanChangeStatus: true,
  ServiceStatus: true,
  ServiceSuspensionChargeMode: true,
  ServiceSuspensionCreditMethod: true,
  ServiceSuspensionType: true,
  ServiceTemplateAddOnPaymentType: true,
  ServiceTemplateCategoryStatus: true,
  ServiceTemplateOrderBy: true,
  ServiceTemplateStatus: true,
  ServiceTemplateType: true,
  SessionCategory: true,
  SessionDisplayType: true,
  SessionFeeMode: true,
  SessionFeeSource: true,
  SessionFeedbackAnswerType: true,
  SessionFeedbackStatus: true,
  SessionFilterCalendarMode: true,
  SessionFilterVisibility: true,
  SessionGroupSection: true,
  SessionStatus: true,
  SettlementExportType: true,
  SharedRelationActivityType: true,
  ShiftDatesApplyTo: true,
  SidebarPosition: true,
  SignerCapacity: true,
  SiteAccessPointStatus: true,
  SiteAccountCodeStatus: true,
  SiteAlertStatus: true,
  SiteAlertTheme: true,
  SiteAmenityGroup: true,
  SiteAmenityKey: true,
  SiteAmenityStatus: true,
  SiteCloneArea: true,
  SiteCloneJobStatus: true,
  SiteCloneJobStep: true,
  SiteDuplicateErrorCode: true,
  SiteFormQuestionType: true,
  SiteFormTemplateKey: true,
  SiteGroupOrderBy: true,
  SiteInfoBlockIcon: true,
  SiteInfoIcon: true,
  SiteLocationType: true,
  SitePaymentGatewayOnboardingStatus: true,
  SitePermissions: true,
  SiteRoomResourceTemplatePropertyTypes: true,
  SiteStatus: true,
  SiteSupplierStatus: true,
  SiteTerminalReaderOrderByField: true,
  SiteThemeStatus: true,
  SiteWebhookDeliveryStatus: true,
  SiteWebhookStatus: true,
  SiteWebhookStatusInput: true,
  SiteWorkshopType: true,
  SiteWorkshopTypes: true,
  SitesOrderBy: true,
  SkinTypeEligibilityStatus: true,
  SkinTypePermittedAction: true,
  SkinTypeRequirementMode: true,
  SmsAllowedCurrencies: true,
  SmsCreditsDirection: true,
  SmsCreditsReason: true,
  SmsPackagesOrderBy: true,
  SortDirection: true,
  SortOrder: true,
  SortPackageDirection: true,
  SortPackageField: true,
  Source: true,
  StaffAccessPolicyOrderBy: true,
  StaffAccessRuleAssignmentType: true,
  StaffSessionRole: true,
  StaffUserAccessLevel: true,
  StaffUserOrderBy: true,
  StaffUserStatus: true,
  StoreBlockerKind: true,
  String: true,
  StripeAgreementType: true,
  StripePayoutCurrency: true,
  SupportChatSource: true,
  SupportChatStatus: true,
  SupportIssueType: true,
  SupportMessageRole: true,
  SupportedPaymentGateway: true,
  SuspensionRowState: true,
  SyncStatus: true,
  TagMatch: true,
  TanningConnectorErrorKind: true,
  TanningConnectorHealthReason: true,
  TanningConnectorVerdict: true,
  TanningRegulationRule: true,
  TanningSessionVoidReason: true,
  TargetType: true,
  TaxSettingType: true,
  TaxType: true,
  TemplateSource: true,
  TerminalHandoffFailureCode: true,
  TerminalHandoffField: true,
  TerminalHandoffHoldReason: true,
  TerminalHandoffSourceSurface: true,
  TerminalHandoffStatus: true,
  TerminalHandoffStepKind: true,
  TerminalHandoffStepState: true,
  TerminalLocationAddressField: true,
  TerminalPaymentMethodType: true,
  TerminalReaderInputType: true,
  TerminalReaderUnsupportedReason: true,
  TerminalSignatureDevice: true,
  TerminalSignatureFallback: true,
  TextFilterOperator: true,
  ThemeKey: true,
  ThemeSubscriptionStatus: true,
  ThemeValueSource: true,
  ThirdPartyIntegrationAvailableFor: true,
  ThirdPartyIntegrationUniqueAcross: true,
  ThirdPartyIntegrationVisibilityAt: true,
  TimePeriodType: true,
  TransactionFeePreference: true,
  TranslationStatus: true,
  TrialStatus: true,
  UserType: true,
  VideoTranscodingStatus: true,
  VideoUploadStatus: true,
  VisibilityScope: true,
  WaitlistEntryStatus: true,
  WaitlistInvitationStrategy: true,
  WaitlistPromotionMethod: true,
  WaitlistRestrictionType: true,
  WaitlistStrategy: true,
  WebhookType: true,
  WellhubDivergenceKind: true,
  WidgetButtonStyle: true,
  ZonesOrderBy: true,
}
export const generatedSchema = {
  AIArticleGenerateInput: {
    category: { __type: 'String' },
    targetAudience: { __type: 'String' },
    tone: { __type: 'String' },
    topic: { __type: 'String!' },
  },
  AIArticleStreamInput: {
    articleId: { __type: 'String' },
    category: { __type: 'String' },
    streamId: { __type: 'String!' },
    targetAudience: { __type: 'String' },
    tone: { __type: 'String' },
    topic: { __type: 'String!' },
  },
  AIArticleStreamResult: {
    __typename: { __type: 'String!' },
    articleId: { __type: 'String!' },
    streamId: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  AIGeneratedArticle: {
    __typename: { __type: 'String!' },
    citations: { __type: '[ArticleCitation!]!' },
    confidence: { __type: 'Float!' },
    contentMarkdown: { __type: 'String!' },
    subtitle: { __type: 'String!' },
    suggestedSlug: { __type: 'String!' },
    suggestedTags: { __type: '[String!]!' },
    summary: { __type: 'String!' },
    title: { __type: 'String!' },
  },
  AcceptInvitation: {
    __typename: { __type: 'String!' },
    invitation: { __type: 'AcceptInvitationInvitation!' },
  },
  AcceptInvitationInvitation: {
    __typename: { __type: 'String!' },
    corporateId: { __type: 'ID!' },
    email: { __type: 'String!' },
    invitationId: { __type: 'ID!' },
    permissionPolicyIds: { __type: '[String!]' },
    role: { __type: 'String!' },
    siteId: { __type: 'ID' },
  },
  AcceptMyPoliciesResult: {
    __typename: { __type: 'String!' },
    acceptedItemKeys: { __type: '[String!]!' },
    refusals: { __type: '[MyPolicyRefusal!]!' },
    refusedItemKeys: { __type: '[String!]!' },
  },
  AcceptMyPolicyItemInput: {
    itemKey: { __type: 'String!' },
    policyRevisionId: { __type: 'ID!' },
    revisionSha256: { __type: 'String!' },
  },
  AcceptPolicies: {
    __typename: { __type: 'String!' },
    acceptedCount: { __type: 'Float!' },
    message: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  AcceptSharedCreditsInput: {
    inviteToken: { __type: 'String' },
    ownerClientId: { __type: 'ID!' },
    serviceId: { __type: 'ID!' },
  },
  AcceptSitePolicies: {
    __typename: { __type: 'String!' },
    acceptedPolicyIds: { __type: '[String!]!' },
    skippedPolicyIds: { __type: '[String!]!' },
  },
  AccountDeletionRequestInput: {
    clientId: { __type: 'String!' },
    feedback: { __type: 'String' },
    reason: { __type: 'String' },
    siteId: { __type: 'String!' },
  },
  AccountDeletionRequestResult: {
    __typename: { __type: 'String!' },
    message: { __type: 'String!' },
    requestId: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  AcknowledgeFontDeployment: {
    __typename: { __type: 'String!' },
    channels: { __type: 'MobileAppChannels!' },
    success: { __type: 'Boolean!' },
  },
  ActiveSiteAlert: {
    __typename: { __type: 'String!' },
    amenityId: { __type: 'ID' },
    body: { __type: 'String' },
    endsAt: { __type: 'String' },
    link: { __type: 'SiteAlertLink' },
    marksLocationClosed: { __type: 'Boolean!' },
    showAsPopup: { __type: 'Boolean!' },
    siteAlertId: { __type: 'ID!' },
    startsAt: { __type: 'String!' },
    theme: { __type: 'SiteAlertTheme!' },
    title: { __type: 'String!' },
    updatedAt: { __type: 'String!' },
  },
  ActivityStreamItem: {
    __typename: { __type: 'String!' },
    activity: { __type: 'ActivityStreamItemActivity' },
    booking: { __type: 'ActivityStreamItemBooking!' },
    session: { __type: 'ActivityStreamItemSession!' },
  },
  ActivityStreamItemActivity: {
    __typename: { __type: 'String!' },
    byName: { __type: 'String!' },
    statusDate: { __type: 'String!' },
    type: { __type: 'BookingActivityType!' },
  },
  ActivityStreamItemBooking: {
    __typename: { __type: 'String!' },
    bookingId: { __type: 'String!' },
    status: { __type: 'BookingStatus!' },
  },
  ActivityStreamItemSession: {
    __typename: { __type: 'String!' },
    endTime: { __type: 'String' },
    instructors: { __type: '[ActivityStreamItemSessionInstructors!]!' },
    name: { __type: 'String!' },
    sessionId: { __type: 'String!' },
    startTime: { __type: 'String' },
  },
  ActivityStreamItemSessionInstructors: {
    __typename: { __type: 'String!' },
    firstName: { __type: 'String!' },
    lastName: { __type: 'String!' },
  },
  ActivityStreamPaginationResult: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'ClientBookingsPageInfo!' },
    results: { __type: '[ActivityStreamResultItem!]!' },
  },
  ActivityStreamResultItem: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'ActivityStreamItem!' },
  },
  AddAccessRuleInputInput: {
    assignmentType: { __type: 'StaffAccessRuleAssignmentType!' },
    siteGroupIds: { __type: '[ID!]' },
    siteIds: { __type: '[ID!]' },
    staffAccessPolicyId: { __type: 'ID!' },
  },
  AddClientToSiteResponse: {
    __typename: { __type: 'String!' },
    message: { __type: 'String' },
    success: { __type: 'Boolean!' },
  },
  AddClientToSiteSiteSpecificDataInput: {
    enrollmentSource: { __type: 'String' },
    membershipType: { __type: 'String' },
    notes: { __type: 'String' },
    preferences: { __type: 'AddClientToSiteSiteSpecificDataPreferencesInput' },
    useAccountCreditsOnRecurringInvoices: { __type: 'Boolean' },
  },
  AddClientToSiteSiteSpecificDataPreferencesInput: {
    communications: { __type: 'String' },
    notifications: { __type: 'Boolean' },
  },
  AddCustomPropertyAlert: { __typename: { __type: 'String!' }, success: { __type: 'Boolean!' } },
  AddOnPriceGroup: {
    __typename: { __type: 'String!' },
    addOnPriceGroupId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    name: { __type: 'String!' },
    priceCount: { __type: 'Int!' },
    siteId: { __type: 'ID!' },
    siteSessionTypeIds: { __type: '[ID!]!' },
    taxSettingIds: { __type: '[ID!]' },
    updatedAt: { __type: 'String!' },
  },
  AddOnPriceGroupPrice: {
    __typename: { __type: 'String!' },
    addOnPriceGroupId: { __type: 'ID!' },
    addOnPriceGroupPriceId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    price: { __type: 'Numeric!' },
    serviceTemplateId: { __type: 'ID!' },
    siteId: { __type: 'ID!' },
    updatedAt: { __type: 'String!' },
  },
  AddOnPriceGroupSessionTypeOption: {
    __typename: { __type: 'String!' },
    code: { __type: 'Float' },
    name: { __type: 'String!' },
    siteSessionTypeId: { __type: 'String!' },
  },
  AddReferral: {
    __typename: { __type: 'String!' },
    message: { __type: 'String!' },
    showReferralMsg: { __type: 'Boolean!' },
    success: { __type: 'Boolean!' },
  },
  AddReferralBonus: {
    __typename: { __type: 'String!' },
    message: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  AddSmsPackageOptionInputInput: { count: { __type: 'Float!' }, price: { __type: 'Float!' } },
  AddSupportMessageInput: {
    html: { __type: 'String' },
    locale: { __type: 'String' },
    metadata: { __type: 'JSON' },
    pageContextMeta: { __type: 'JSON' },
    role: { __type: 'SupportMessageRole!' },
    supportChatId: { __type: 'String!' },
    text: { __type: 'String!' },
    thinkingText: { __type: 'String' },
  },
  AdjustCreditsInput: {
    amount: { __type: 'Float!' },
    direction: { __type: 'ServiceCreditLedgerDirection!' },
    notes: { __type: 'String' },
    periodId: { __type: 'String' },
    reason: { __type: 'String' },
    serviceId: { __type: 'String!' },
    siteId: { __type: 'String!' },
    siteSessionTypeId: { __type: 'String' },
  },
  AdjustEquipmentLampHoursInput: {
    deltaHours: { __type: 'Float!' },
    equipmentId: { __type: 'ID!' },
    lampSet: { __type: 'EquipmentLampSet!' },
    reason: { __type: 'String!' },
  },
  AdjustStockInput: {
    adjustmentType: { __type: 'PosStockAdjusmentType!' },
    posProductVariableId: { __type: 'ID!' },
    quantityAdjustment: { __type: 'Float!' },
    reason: { __type: 'String' },
    referenceId: { __type: 'ID' },
  },
  AdjustStockResponse: {
    __typename: { __type: 'String!' },
    posStockAdjustmentId: { __type: 'ID!' },
    quantityAfter: { __type: 'Int!' },
  },
  AdminAccessGroup: {
    __typename: { __type: 'String!' },
    corporates: { __type: '[String!]!' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'String!' },
    description: { __type: 'String' },
    groupId: { __type: 'ID!' },
    isAllCorporates: { __type: 'Boolean!' },
    isDefault: { __type: 'Boolean!' },
    isRestricted: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    permissions: { __type: '[AdminUserPermissions!]!' },
    updatedAt: { __type: 'String!' },
  },
  AdminAggregatorBookingTotals: {
    __typename: { __type: 'String!' },
    attended: { __type: 'Float!' },
    booked: { __type: 'Float!' },
    cancelled: { __type: 'Float!' },
    lateCancelled: { __type: 'Float!' },
    noShow: { __type: 'Float!' },
    upcoming: { __type: 'Float!' },
    withSpot: { __type: 'Float!' },
  },
  AdminAggregatorDayTotals: {
    __typename: { __type: 'String!' },
    attended: { __type: 'Float!' },
    booked: { __type: 'Float!' },
    cancelled: { __type: 'Float!' },
    lateCancelled: { __type: 'Float!' },
    noShow: { __type: 'Float!' },
    upcoming: { __type: 'Float!' },
    withSpot: { __type: 'Float!' },
    date: { __type: 'String!' },
    sessionCount: { __type: 'Float!' },
  },
  AdminAggregatorLocationSummary: {
    __typename: { __type: 'String!' },
    days: { __type: '[AdminAggregatorDayTotals!]!' },
    sessionCount: { __type: 'Float!' },
    siteName: { __type: 'String' },
    siteTimezone: { __type: 'String' },
    totals: { __type: 'AdminAggregatorBookingTotals!' },
  },
  AdminAggregatorSession: {
    __typename: { __type: 'String!' },
    aggregatorAttendedCount: { __type: 'Float' },
    aggregatorBookedCount: { __type: 'Float' },
    aggregatorCancelledCount: { __type: 'Float' },
    aggregatorLateCancelledCount: { __type: 'Float' },
    aggregatorNoShowCount: { __type: 'Float' },
    aggregatorWithSpotCount: { __type: 'Float' },
    availableSpots: { __type: 'Float!' },
    bookedCount: { __type: 'Float!' },
    instructors: { __type: '[AggregatorSessionInstructor!]!' },
    locationName: { __type: 'String' },
    room: { __type: 'AggregatorSessionRoom' },
    sessionCategory: { __type: 'String' },
    sessionEndTime: { __type: 'String!' },
    sessionId: { __type: 'String!' },
    sessionName: { __type: 'String!' },
    sessionStartTime: { __type: 'String!' },
    size: { __type: 'Float!' },
    status: { __type: 'String!' },
  },
  AdminAggregatorSessionsResponse: {
    __typename: { __type: 'String!' },
    sessions: { __type: '[AdminAggregatorSession!]!' },
    siteTimezone: { __type: 'String' },
    totalCount: { __type: 'Float!' },
  },
  AdminAuditEventsFilterDateRangeInput: {
    endDate: { __type: 'String!' },
    startDate: { __type: 'String!' },
  },
  AdminAuditEventsFilterInput: {
    actions: { __type: '[AuditAction!]' },
    affectedUserId: { __type: 'String' },
    corporateId: { __type: 'String' },
    dateRange: { __type: 'AdminAuditEventsFilterDateRangeInput' },
    memberId: { __type: 'String' },
    resources: { __type: '[AuditResource!]' },
    searchText: { __type: 'String' },
    severity: { __type: '[AuditSeverity!]' },
    siteId: { __type: 'String' },
    source: { __type: '[AuditSource!]' },
    systemOnly: { __type: 'Boolean' },
    userId: { __type: 'String' },
    visibility: { __type: '[AuditVisibility!]' },
  },
  AdminMobileFleet: {
    __typename: { __type: 'String!' },
    brands: { __type: '[AdminMobileFleetBrand!]!' },
    credentials: { __type: 'AdminMobileFleetCredentials!' },
    summary: { __type: 'AdminMobileFleetSummary!' },
  },
  AdminMobileFleetActivity: {
    __typename: { __type: 'String!' },
    description: { __type: 'String' },
    severity: { __type: 'AdminMobileFleetSeverity!' },
    timestamp: { __type: 'String' },
    title: { __type: 'String!' },
  },
  AdminMobileFleetAppleSession: {
    __typename: { __type: 'String!' },
    action: { __type: 'AdminMobileFleetAppleSessionAction' },
    lastVerifiedAt: { __type: 'String' },
    needsAction: { __type: 'Boolean!' },
    state: { __type: 'AdminMobileFleetCredentialState!' },
    status: { __type: 'AppleAccountSessionStatus!' },
    trustExpiresAt: { __type: 'String' },
  },
  AdminMobileFleetAppleTeam: {
    __typename: { __type: 'String!' },
    agreementsPending: { __type: 'Boolean' },
    appleTeamId: { __type: 'String!' },
    brandCount: { __type: 'Float!' },
    checkedAt: { __type: 'String' },
    corporateId: { __type: 'String' },
    hasAscKey: { __type: 'Boolean' },
    issues: { __type: '[AdminMobileFleetAppleTeamIssue!]!' },
    membershipExpiresAt: { __type: 'String' },
    name: { __type: 'String' },
    state: { __type: 'AdminMobileFleetCredentialState!' },
  },
  AdminMobileFleetBrand: {
    __typename: { __type: 'String!' },
    android: { __type: 'AdminMobileFleetPlatform!' },
    appName: { __type: 'String' },
    blockers: { __type: '[AdminMobileFleetBlocker!]!' },
    brandId: { __type: 'String!' },
    brandName: { __type: 'String!' },
    corporateId: { __type: 'String' },
    environment: { __type: 'BrandEnvironment!' },
    ios: { __type: 'AdminMobileFleetPlatform!' },
    latestActivity: { __type: 'AdminMobileFleetActivity!' },
    nextAction: { __type: 'AdminMobileFleetNextAction!' },
    operations: { __type: 'AdminMobileFleetOperations!' },
    prerequisites: { __type: '[AdminMobileFleetPrerequisite!]!' },
    releaseHold: { __type: 'BrandReleaseHold' },
    setup: { __type: 'AdminMobileFleetSetup!' },
    setupProgress: { __type: 'Float!' },
    updatedAt: { __type: 'String' },
  },
  AdminMobileFleetCredentials: {
    __typename: { __type: 'String!' },
    appleSession: { __type: 'AdminMobileFleetAppleSession!' },
    appleTeams: { __type: '[AdminMobileFleetAppleTeam!]!' },
    easTokenPresent: { __type: 'Boolean!' },
    githubTokenPresent: { __type: 'Boolean!' },
    playPublisherConfigured: { __type: 'Boolean!' },
  },
  AdminMobileFleetNextAction: {
    __typename: { __type: 'String!' },
    description: { __type: 'String!' },
    kind: { __type: 'AdminMobileFleetNextActionKind!' },
    platforms: { __type: '[BrandPlatform!]!' },
    primaryAction: { __type: 'String' },
    severity: { __type: 'AdminMobileFleetSeverity!' },
    title: { __type: 'String!' },
  },
  AdminMobileFleetOperations: {
    __typename: { __type: 'String!' },
    failedCount: { __type: 'Float!' },
    lastAction: { __type: 'BrandStoreOperationAction' },
    lastError: { __type: 'String' },
    lastPlatform: { __type: 'BrandPlatform' },
    lastStatus: { __type: 'BrandStoreOperationStatus' },
    lastUpdatedAt: { __type: 'String' },
    runningCount: { __type: 'Float!' },
  },
  AdminMobileFleetPlatform: {
    __typename: { __type: 'String!' },
    appStoreId: { __type: 'String' },
    bundleId: { __type: 'String' },
    ciRunUrl: { __type: 'String' },
    completedAt: { __type: 'String' },
    credentialsStatus: { __type: 'AdminMobileFleetCredentialsStatus!' },
    dispatchedAt: { __type: 'String' },
    easBuildUrl: { __type: 'String' },
    failureReason: { __type: 'String' },
    inReviewDays: { __type: 'Float' },
    latestBuildNumber: { __type: 'Float' },
    latestVersion: { __type: 'String' },
    packageName: { __type: 'String' },
    performance: { __type: 'BrandObservePerformance!' },
    platform: { __type: 'BrandPlatform!' },
    playStoreId: { __type: 'String' },
    providerBuildNumber: { __type: 'Float' },
    providerError: { __type: 'String' },
    providerStateSince: { __type: 'String' },
    providerStatus: { __type: 'BrandStoreSnapshotStatus' },
    providerSyncedAt: { __type: 'String' },
    providerUpdatedAt: { __type: 'String' },
    providerVersion: { __type: 'String' },
    rawProviderState: { __type: 'String' },
    rejection: { __type: 'AdminMobileFleetRejection' },
    releaseId: { __type: 'String' },
    releaseStatus: { __type: 'BrandNativeReleaseStatus' },
    releasedBy: { __type: 'AdminMobileFleetReleasedBy' },
    requestedAt: { __type: 'String' },
    requestedBy: { __type: 'AdminMobileFleetRequestedBy' },
    reviewSince: { __type: 'String' },
    rolloutPercentage: { __type: 'Float' },
    secondaryLabel: { __type: 'String' },
    stage: { __type: 'AdminMobileFleetReleaseStage!' },
    statusLabel: { __type: 'String!' },
    storeUrl: { __type: 'String' },
    testUrl: { __type: 'String' },
    track: { __type: 'String' },
  },
  AdminMobileFleetPrerequisite: {
    __typename: { __type: 'String!' },
    kind: { __type: 'StoreBlockerKind!' },
    platform: { __type: 'BrandPlatform!' },
    since: { __type: 'String' },
  },
  AdminMobileFleetRejection: {
    __typename: { __type: 'String!' },
    reason: { __type: 'String' },
    reviewUrl: { __type: 'String' },
    since: { __type: 'String' },
  },
  AdminMobileFleetReleasedBy: {
    __typename: { __type: 'String!' },
    at: { __type: 'String' },
    name: { __type: 'String' },
  },
  AdminMobileFleetRequestedBy: {
    __typename: { __type: 'String!' },
    at: { __type: 'String' },
    email: { __type: 'String' },
    name: { __type: 'String' },
  },
  AdminMobileFleetSetup: {
    __typename: { __type: 'String!' },
    blockers: { __type: '[AdminMobileFleetBlocker!]!' },
    complete: { __type: 'Boolean!' },
    missingCount: { __type: 'Float!' },
    satisfiedCount: { __type: 'Float!' },
    totalCount: { __type: 'Float!' },
  },
  AdminMobileFleetSummary: {
    __typename: { __type: 'String!' },
    buildsRunning: { __type: 'Float!' },
    failedOperations: { __type: 'Float!' },
    inReview: { __type: 'Float!' },
    lastStoreSyncAt: { __type: 'String' },
    live: { __type: 'Float!' },
    missingCredentials: { __type: 'Float!' },
    needsAttention: { __type: 'Float!' },
    readyToRelease: { __type: 'Float!' },
    readyToSubmit: { __type: 'Float!' },
    rejected: { __type: 'Float!' },
    storeSyncStale: { __type: 'Boolean!' },
    totalBrands: { __type: 'Float!' },
    waitingOnClient: { __type: 'Float!' },
  },
  AdminUpdateCorporateAggregatorIntegration: {
    __typename: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  AdminUpdateCorporateAggregatorProviderSites: {
    __typename: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  AdminUpdateSiteV2Enabled: {
    __typename: { __type: 'String!' },
    isV2Enabled: { __type: 'Boolean!' },
    siteId: { __type: 'String!' },
  },
  AdminUser: {
    __typename: { __type: 'String!' },
    accessGroupId: { __type: 'ID!' },
    adminAccessGroup: { __type: 'AdminAccessGroup' },
    adminUserId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'String!' },
    email: { __type: 'String!' },
    firebaseId: { __type: 'String!' },
    firstName: { __type: 'String!' },
    lastName: { __type: 'String!' },
    name: { __type: 'String!' },
    phone: { __type: 'String!' },
    profileImage: {
      __type: 'ImagePublicSignedUrl',
      __args: { input: 'ImagePublicSignedUrlInput!' },
    },
    provisionedAt: { __type: 'String!' },
    status: { __type: 'AdminUserStatus!' },
    updatedAt: { __type: 'String!' },
  },
  AdminUserImpersonationSessionResponse: {
    __typename: { __type: 'String!' },
    redirectUrl: { __type: 'String!' },
    sessionId: { __type: 'String!' },
  },
  AdminUsers: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'AdminUsersPageInfo!' },
    results: { __type: '[AdminUsersResults!]!' },
  },
  AdminUsersFilterInput: {
    accessGroupId: { __type: 'String' },
    status: { __type: 'AdminUserStatus' },
  },
  AdminUsersOrderByInput: {
    column: { __type: 'AdminUsersOrderBy!' },
    direction: { __type: 'OrderByDirection!' },
  },
  AdminUsersPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  AdminUsersResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'AdminUser!' },
  },
  AdoptMemberMovementLocationResolutionInput: {
    destinationServiceTemplateId: { __type: 'ID!' },
    destinationSiteId: { __type: 'ID!' },
    sourceServiceTemplateId: { __type: 'ID!' },
    sourceSiteId: { __type: 'ID!' },
  },
  AdoptMemberMovementLocationResolutionResult: {
    __typename: { __type: 'String!' },
    mappingSaved: { __type: 'Boolean!' },
    rowsResolved: { __type: 'Float!' },
  },
  AgentDiagnostics: {
    __typename: { __type: 'String!' },
    commPort: { __type: 'String' },
    connected: { __type: 'Boolean!' },
    healthy: { __type: 'Boolean!' },
    maxRooms: { __type: 'Float' },
    version: { __type: 'String' },
  },
  AggregatorProvider: {
    __typename: { __type: 'String!' },
    aggregatorProviderId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    deletedAt: { __type: 'String' },
    displayName: { __type: 'String!' },
    inboundSecretName: { __type: 'String' },
    isActive: { __type: 'Boolean!' },
    logoUrl: { __type: 'String' },
    name: { __type: 'String!' },
    secretName: { __type: 'String!' },
    setupInstructions: { __type: 'String' },
    updatedAt: { __type: 'String!' },
    webhookUrl: { __type: 'String' },
  },
  AggregatorProviderCreateInput: {
    displayName: { __type: 'String!' },
    inboundSecretName: { __type: 'String' },
    isActive: { __type: 'Boolean!' },
    logoUrl: { __type: 'String' },
    name: { __type: 'String!' },
    secretName: { __type: 'String!' },
    setupInstructions: { __type: 'String' },
    webhookUrl: { __type: 'String' },
  },
  AggregatorProviderUpdateInput: {
    displayName: { __type: 'String' },
    inboundSecretName: { __type: 'String' },
    isActive: { __type: 'Boolean' },
    logoUrl: { __type: 'String' },
    secretName: { __type: 'String' },
    setupInstructions: { __type: 'String' },
    webhookUrl: { __type: 'String' },
  },
  AggregatorSessionInstructor: {
    __typename: { __type: 'String!' },
    firstName: { __type: 'String!' },
    lastName: { __type: 'String!' },
    role: { __type: 'String!' },
    staffUserId: { __type: 'String!' },
  },
  AggregatorSessionRoom: {
    __typename: { __type: 'String!' },
    roomId: { __type: 'String!' },
    roomName: { __type: 'String!' },
  },
  AllDefaults: {
    __typename: { __type: 'String!' },
    defaults: { __type: 'JSONObject!' },
    language: { __type: 'String!' },
  },
  AllocateFamilyPackageInput: {
    allocatedCredits: { __type: 'Float' },
    clientId: { __type: 'ID!' },
    serviceId: { __type: 'ID!' },
  },
  AnalyticsV2CubeDimensionMeta: {
    __typename: { __type: 'String!' },
    description: { __type: 'String' },
    meta: { __type: 'JSONObject' },
    name: { __type: 'String!' },
    shown: { __type: 'Boolean' },
    title: { __type: 'String!' },
    type: { __type: 'String!' },
  },
  AnalyticsV2CubeEntityMeta: {
    __typename: { __type: 'String!' },
    description: { __type: 'String' },
    dimensions: { __type: '[AnalyticsV2CubeDimensionMeta!]!' },
    measures: { __type: '[AnalyticsV2CubeMeasureMeta!]!' },
    name: { __type: 'String!' },
    segments: { __type: '[AnalyticsV2CubeSegmentMeta!]!' },
    title: { __type: 'String!' },
  },
  AnalyticsV2CubeMeasureMeta: {
    __typename: { __type: 'String!' },
    description: { __type: 'String' },
    meta: { __type: 'JSONObject' },
    name: { __type: 'String!' },
    title: { __type: 'String!' },
    type: { __type: 'String!' },
  },
  AnalyticsV2CubeSchemaMetaResponse: {
    __typename: { __type: 'String!' },
    cubes: { __type: '[AnalyticsV2CubeEntityMeta!]!' },
  },
  AnalyticsV2CubeSegmentMeta: {
    __typename: { __type: 'String!' },
    name: { __type: 'String!' },
    title: { __type: 'String!' },
  },
  AnalyticsV2FilterInput: {
    member: { __type: 'String!' },
    operator: { __type: 'AnalyticsV2FilterOperator!' },
    values: { __type: '[String!]' },
  },
  AnalyticsV2OrderEntry: {
    direction: { __type: 'AnalyticsV2OrderDirection!' },
    member: { __type: 'String!' },
  },
  AnalyticsV2QueryMeasureInput: {
    dimensions: { __type: '[String!]' },
    filters: { __type: '[AnalyticsV2FilterInput!]' },
    limit: { __type: 'Float' },
    measures: { __type: '[String!]!' },
    order: { __type: '[AnalyticsV2OrderEntry!]' },
    segments: { __type: '[String!]' },
    timeDimensions: { __type: '[AnalyticsV2TimeDimensionInput!]' },
  },
  AnalyticsV2QueryMeasureResponse: {
    __typename: { __type: 'String!' },
    queryDurationMs: { __type: 'Float!' },
    rows: { __type: '[JSONObject!]!' },
    totalRows: { __type: 'Float!' },
    transparency: { __type: 'AnalyticsV2TransparencyBlock!' },
    trustTier: { __type: 'AnalyticsV2TrustTier!' },
  },
  AnalyticsV2QuerySqlResponse: { __typename: { __type: 'String!' }, sql: { __type: 'String!' } },
  AnalyticsV2TimeDimensionInput: {
    dateRange: { __type: 'String' },
    dimension: { __type: 'String!' },
    granularity: { __type: 'AnalyticsV2TimeGranularity' },
  },
  AnalyticsV2TransparencyBlock: {
    __typename: { __type: 'String!' },
    dataFreshness: { __type: 'String!' },
    dimensionsUsed: { __type: '[String!]!' },
    measureUsed: { __type: 'String!' },
    scopeApplied: { __type: 'String!' },
    timeRange: { __type: 'String' },
  },
  AndroidPermissionState: {
    __typename: { __type: 'String!' },
    locked: { __type: 'Boolean!' },
    permission: { __type: 'AndroidPermission!' },
    source: { __type: 'NativePermissionSource!' },
  },
  AnonymiseClientResponse: {
    __typename: { __type: 'String!' },
    message: { __type: 'String' },
    success: { __type: 'Boolean!' },
  },
  ApiCallLog: {
    __typename: { __type: 'String!' },
    attempt: { __type: 'Int' },
    clientId: { __type: 'String' },
    corporateId: { __type: 'String!' },
    credentialId: { __type: 'String' },
    credentialLabel: { __type: 'String' },
    credentialType: { __type: 'ApiCallLogCredentialType' },
    durationMs: { __type: 'Int!' },
    error: { __type: 'String' },
    eventId: { __type: 'String' },
    eventType: { __type: 'String' },
    id: { __type: 'String!' },
    maxAttempts: { __type: 'Int' },
    method: { __type: 'String!' },
    occurredAt: { __type: 'String!' },
    path: { __type: 'String!' },
    remoteIp: { __type: 'String' },
    requestBody: { __type: 'String' },
    requestBodyBytes: { __type: 'Int' },
    requestBodyTruncated: { __type: 'Boolean!' },
    requestHeaders: { __type: 'String' },
    requestId: { __type: 'String' },
    requestQuery: { __type: 'String' },
    responseBody: { __type: 'String' },
    responseBodyBytes: { __type: 'Int' },
    responseBodyTruncated: { __type: 'Boolean!' },
    responseHeaders: { __type: 'String' },
    route: { __type: 'String' },
    searchIds: { __type: '[String!]!' },
    siteId: { __type: 'String' },
    siteName: { __type: 'String' },
    statusCode: { __type: 'Int' },
    truncated: { __type: 'Boolean!' },
    type: { __type: 'ApiCallLogType!' },
    userAgent: { __type: 'String' },
  },
  ApiCallLogFilterInput: {
    from: { __type: 'String' },
    search: { __type: 'String' },
    siteId: { __type: 'String' },
    status: { __type: 'ApiCallLogStatus' },
    statusCode: { __type: 'Int' },
    to: { __type: 'String' },
    types: { __type: '[ApiCallLogType!]' },
  },
  ApiCallLogPage: {
    __typename: { __type: 'String!' },
    from: { __type: 'String!' },
    nextCursor: { __type: 'String' },
    rows: { __type: '[ApiCallLogSummary!]!' },
    to: { __type: 'String!' },
  },
  ApiCallLogSummary: {
    __typename: { __type: 'String!' },
    attempt: { __type: 'Int' },
    clientId: { __type: 'String' },
    corporateId: { __type: 'String!' },
    credentialId: { __type: 'String' },
    credentialLabel: { __type: 'String' },
    credentialType: { __type: 'ApiCallLogCredentialType' },
    durationMs: { __type: 'Int!' },
    error: { __type: 'String' },
    eventId: { __type: 'String' },
    eventType: { __type: 'String' },
    id: { __type: 'String!' },
    maxAttempts: { __type: 'Int' },
    method: { __type: 'String!' },
    occurredAt: { __type: 'String!' },
    path: { __type: 'String!' },
    requestId: { __type: 'String' },
    route: { __type: 'String' },
    siteId: { __type: 'String' },
    siteName: { __type: 'String' },
    statusCode: { __type: 'Int' },
    type: { __type: 'ApiCallLogType!' },
  },
  ApiCredential: {
    __typename: { __type: 'String!' },
    apiCredentialId: { __type: 'ID!' },
    corporateId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'ID' },
    env: { __type: 'ApiCredentialEnv!' },
    keyPrefix: { __type: 'String!' },
    kind: { __type: 'ApiCredentialKind!' },
    lastUsedAt: { __type: 'String' },
    lastUsedIp: { __type: 'String' },
    name: { __type: 'String!' },
    replacedByCredId: { __type: 'ID' },
    revokedAt: { __type: 'String' },
    rotatesAt: { __type: 'String' },
    scopes: { __type: '[String!]!' },
    siteBindings: { __type: '[ApiCredentialSiteBinding!]' },
    status: { __type: 'ApiCredentialStatus!' },
    updatedAt: { __type: 'String!' },
  },
  ApiCredentialCreateInput: { name: { __type: 'String!' }, scopes: { __type: '[String!]!' } },
  ApiCredentialRenameInput: { name: { __type: 'String!' } },
  ApiCredentialSiteBinding: {
    __typename: { __type: 'String!' },
    siteId: { __type: 'ID!' },
    v1EncryptedId: { __type: 'String!' },
  },
  ApiCredentialUpdateScopesInput: { scopes: { __type: '[String!]!' } },
  ApiCredentialWithSecret: {
    __typename: { __type: 'String!' },
    apiCredentialId: { __type: 'ID!' },
    cleartextSecret: { __type: 'String!' },
    corporateId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'ID' },
    env: { __type: 'ApiCredentialEnv!' },
    keyPrefix: { __type: 'String!' },
    kind: { __type: 'ApiCredentialKind!' },
    lastUsedAt: { __type: 'String' },
    lastUsedIp: { __type: 'String' },
    name: { __type: 'String!' },
    replacedByCredId: { __type: 'ID' },
    revokedAt: { __type: 'String' },
    rotatesAt: { __type: 'String' },
    scopes: { __type: '[String!]!' },
    siteBindings: { __type: '[ApiCredentialSiteBinding!]' },
    status: { __type: 'ApiCredentialStatus!' },
    updatedAt: { __type: 'String!' },
  },
  AppStoreCredentials: {
    __typename: { __type: 'String!' },
    apnsKeyId: { __type: 'String' },
    appleAccountName: { __type: 'String' },
    appleIssuerId: { __type: 'String' },
    appleKeyId: { __type: 'String' },
    appleTeamId: { __type: 'String' },
    bundleId: { __type: 'String' },
    corporateId: { __type: 'String!' },
    googleServiceAccountEmail: { __type: 'String' },
    hasApnsAuthKey: { __type: 'Boolean!' },
    hasApplePrivateKey: { __type: 'Boolean!' },
    hasFirebaseAndroidConfig: { __type: 'Boolean!' },
    hasFirebaseIosConfig: { __type: 'Boolean!' },
    hasGoogleServiceAccountJson: { __type: 'Boolean!' },
    jwPlayerLicenseKey: { __type: 'String' },
    packageName: { __type: 'String' },
    platform: { __type: 'String!' },
  },
  AppendSignatureToAgreement: {
    __typename: { __type: 'String!' },
    agreementId: { __type: 'String!' },
    signatureCount: { __type: 'Float!' },
    status: { __type: 'String!' },
  },
  AppleAccountSession: {
    __typename: { __type: 'String!' },
    appleId: { __type: 'String!' },
    codeRequestedAt: { __type: 'String' },
    connectedAt: { __type: 'String' },
    hasStoredPassword: { __type: 'Boolean!' },
    lastError: { __type: 'String' },
    lastVerifiedAt: { __type: 'String' },
    mode: { __type: 'AppleAccountSessionMode' },
    requestedAt: { __type: 'String' },
    status: { __type: 'AppleAccountSessionStatus!' },
    trustExpiresAt: { __type: 'String' },
  },
  AppleAutomationStatus: {
    __typename: { __type: 'String!' },
    available: { __type: 'Boolean!' },
    keyId: { __type: 'String' },
    reason: { __type: 'AppleAutomationReason' },
    source: { __type: 'AppleAutomationSource' },
  },
  AppleTeamCandidate: {
    __typename: { __type: 'String!' },
    contentProviderId: { __type: 'String!' },
    name: { __type: 'String!' },
  },
  AppleTeamCompliance: {
    __typename: { __type: 'String!' },
    agreementsPending: { __type: 'Boolean' },
    appleTeamId: { __type: 'String!' },
    checkError: { __type: 'String' },
    checkedAt: { __type: 'String' },
    earliestCertExpiresAt: { __type: 'String' },
    membershipExpiresAt: { __type: 'String' },
    name: { __type: 'String' },
  },
  AppliedFee: {
    __typename: { __type: 'String!' },
    calculatedAmount: { __type: 'Float!' },
    enabled: { __type: 'Boolean!' },
    feeId: { __type: 'String!' },
    feeName: { __type: 'String!' },
    flatAmount: { __type: 'Float' },
    percentRate: { __type: 'Float' },
  },
  ApplySessionTemplateResult: {
    __typename: { __type: 'String!' },
    sessionTemplate: { __type: 'SessionTemplate!' },
    skippedSessionCount: { __type: 'Float!' },
    spotMoves: { __type: '[SpotMove!]!' },
    updatedRecurringPatternCount: { __type: 'Float!' },
    updatedSessionCount: { __type: 'Float!' },
  },
  ApprovalPinStatus: {
    __typename: { __type: 'String!' },
    isSet: { __type: 'Boolean!' },
    lockedUntil: { __type: 'String' },
    setAt: { __type: 'String' },
  },
  ApproveAllImports: {
    __typename: { __type: 'String!' },
    results: { __type: '[ApproveAllImportsResults!]!' },
  },
  ApproveAllImportsResults: {
    __typename: { __type: 'String!' },
    error: { __type: 'String' },
    importSessionId: { __type: 'ID!' },
    status: { __type: 'String!' },
    totalValidRows: { __type: 'Float!' },
  },
  ApproveCheckinResult: {
    __typename: { __type: 'String!' },
    checkinFlag: { __type: 'Float!' },
    checkinId: { __type: 'String' },
    message: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  ApproveImport: {
    __typename: { __type: 'String!' },
    importSessionId: { __type: 'ID!' },
    status: { __type: 'String!' },
    totalValidRows: { __type: 'Float!' },
  },
  ApproveMemberMovementRunInput: {
    attestation: { __type: 'MemberMovementAttestationInput!' },
    corporateId: { __type: 'ID!' },
    runId: { __type: 'ID!' },
  },
  ArchiveCorporateServiceTemplatesInput: { corporateServiceTemplateIds: { __type: '[ID!]!' } },
  ArchiveProductResponse: { __typename: { __type: 'String!' }, success: { __type: 'Boolean!' } },
  ArticleCitation: {
    __typename: { __type: 'String!' },
    snippet: { __type: 'String' },
    source: { __type: 'String!' },
    title: { __type: 'String!' },
    url: { __type: 'String' },
  },
  ArticleRefreshStats: {
    __typename: { __type: 'String!' },
    articlesCreated: { __type: 'Int!' },
    articlesFailed: { __type: 'Int!' },
    articlesUnchanged: { __type: 'Int!' },
    articlesUpdated: { __type: 'Int!' },
  },
  AssignClientSiteStaffResponse: {
    __typename: { __type: 'String!' },
    changed: { __type: 'Boolean!' },
    success: { __type: 'Boolean!' },
  },
  AssignFormResponse: {
    __typename: { __type: 'String!' },
    formSubmissionId: { __type: 'String!' },
    message: { __type: 'String' },
    success: { __type: 'Boolean!' },
  },
  AssignSitePayrollTier: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    createdByStaffUserId: { __type: 'ID' },
    endDate: { __type: 'String' },
    futureAssignmentDate: { __type: 'String' },
    payrollTierAssignmentId: { __type: 'ID!' },
    siteId: { __type: 'ID!' },
    sitePayrollTierId: { __type: 'ID!' },
    staffUserId: { __type: 'ID!' },
    staffUserName: { __type: 'String' },
    startDate: { __type: 'String!' },
    updatedAt: { __type: 'String!' },
  },
  AssignedStaffEntry: {
    __typename: { __type: 'String!' },
    changedByName: { __type: 'String' },
    endedAt: { __type: 'String' },
    historyId: { __type: 'String!' },
    isStaffActive: { __type: 'Boolean' },
    source: { __type: 'AssignedStaffSource!' },
    sourceInvoiceId: { __type: 'String' },
    staffName: { __type: 'String' },
    staffUserId: { __type: 'String' },
    startedAt: { __type: 'String!' },
  },
  AssignedStaffHistory: {
    __typename: { __type: 'String!' },
    entries: { __type: '[AssignedStaffEntry!]!' },
    hasMore: { __type: 'Boolean!' },
  },
  Attendance: {
    __typename: { __type: 'String!' },
    attendanceId: { __type: 'ID!' },
    attendanceSource: { __type: 'AttendanceSource!' },
    attendanceType: { __type: 'AttendanceType!' },
    attendedAt: { __type: 'String' },
    bookingId: { __type: 'ID' },
    checkInId: { __type: 'ID' },
    clientId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    equipmentId: { __type: 'ID' },
    invoiceId: { __type: 'ID' },
    isImported: { __type: 'Boolean!' },
    isReversed: { __type: 'Boolean!' },
    markedBy: { __type: 'ID' },
    refundInvoiceId: { __type: 'ID' },
    reversalNote: { __type: 'String' },
    reversalReason: { __type: 'ReversalReason' },
    reversedAt: { __type: 'String' },
    reversedBy: { __type: 'ID' },
    sessionId: { __type: 'ID' },
    totalCreditsUsed: { __type: 'Float!' },
    updatedAt: { __type: 'String!' },
  },
  AuditAggregationGroup: {
    __typename: { __type: 'String!' },
    count: { __type: 'Float!' },
    groupKey: { __type: 'String!' },
    groupLabel: { __type: 'String!' },
  },
  AuditAggregationResult: {
    __typename: { __type: 'String!' },
    groupBy: { __type: 'String!' },
    groups: { __type: '[AuditAggregationGroup!]!' },
    totalCount: { __type: 'Float!' },
  },
  AuditEvent: {
    __typename: { __type: 'String!' },
    accessPointId: { __type: 'String' },
    action: { __type: 'AuditAction!' },
    affectedUserEmail: { __type: 'String' },
    affectedUserFirstName: { __type: 'String' },
    affectedUserId: { __type: 'String' },
    affectedUserLastName: { __type: 'String' },
    browserName: { __type: 'String' },
    browserVersion: { __type: 'String' },
    corporateId: { __type: 'String!' },
    corporateName: { __type: 'String' },
    corporateSlug: { __type: 'String' },
    details: { __type: 'AuditEventDetails' },
    deviceType: { __type: 'AuditDeviceType' },
    doorId: { __type: 'String' },
    emailDomain: { __type: 'String' },
    geoCity: { __type: 'String' },
    geoCountry: { __type: 'String' },
    geoCountryName: { __type: 'String' },
    geoIsEU: { __type: 'Boolean' },
    geoLatitude: { __type: 'Float' },
    geoLongitude: { __type: 'Float' },
    geoRegion: { __type: 'String' },
    geoTimezone: { __type: 'String' },
    id: { __type: 'String!' },
    ipAddress: { __type: 'String' },
    language: { __type: 'String' },
    memberId: { __type: 'String' },
    osName: { __type: 'String' },
    osVersion: { __type: 'String' },
    pageName: { __type: 'String' },
    pageUrl: { __type: 'String' },
    platform: { __type: 'AuditPlatform' },
    requestId: { __type: 'String' },
    resource: { __type: 'AuditResource!' },
    resourceId: { __type: 'String' },
    schemaVersion: { __type: 'Float!' },
    screenHeight: { __type: 'Float' },
    screenWidth: { __type: 'Float' },
    sessionId: { __type: 'String' },
    severity: { __type: 'AuditSeverity!' },
    siteId: { __type: 'String' },
    siteName: { __type: 'String' },
    source: { __type: 'AuditSource!' },
    timestamp: { __type: 'String!' },
    timezone: { __type: 'String' },
    userAgent: { __type: 'String' },
    userEmail: { __type: 'String' },
    userFirstName: { __type: 'String' },
    userId: { __type: 'String' },
    userLastName: { __type: 'String' },
    userRoles: { __type: '[String!]' },
    visibility: { __type: 'AuditVisibility!' },
  },
  AuditEventDetails: {
    __typename: { __type: 'String!' },
    changes: { __type: '[AuditFieldChange!]' },
    contextJson: { __type: 'String' },
    metadataJson: { __type: 'String' },
    newValueJson: { __type: 'String' },
    previousValueJson: { __type: 'String' },
    reason: { __type: 'String' },
    summary: { __type: 'String' },
  },
  AuditEventsFilterDateRangeInput: {
    endDate: { __type: 'String!' },
    startDate: { __type: 'String!' },
  },
  AuditEventsFilterInput: {
    actions: { __type: '[AuditAction!]' },
    affectedUserId: { __type: 'String' },
    corporateId: { __type: 'String!' },
    dateRange: { __type: 'AuditEventsFilterDateRangeInput' },
    excludeActions: { __type: '[AuditAction!]' },
    memberId: { __type: 'String' },
    resources: { __type: '[AuditResource!]' },
    searchText: { __type: 'String' },
    severity: { __type: '[AuditSeverity!]' },
    siteId: { __type: 'String' },
    source: { __type: '[AuditSource!]' },
    systemOnly: { __type: 'Boolean' },
    userId: { __type: 'String' },
    visibility: { __type: '[AuditVisibility!]' },
  },
  AuditEventsPaginationInput: { page: { __type: 'Float!' }, pageSize: { __type: 'Float!' } },
  AuditEventsSortInput: {
    direction: { __type: 'AuditSortDirection!' },
    field: { __type: 'AuditSortField!' },
  },
  AuditFieldChange: {
    __typename: { __type: 'String!' },
    displayName: { __type: 'String' },
    field: { __type: 'String!' },
    fieldType: { __type: 'String' },
    newValue: { __type: 'String' },
    oldValue: { __type: 'String' },
  },
  AuditPaginationResult: {
    __typename: { __type: 'String!' },
    currentPage: { __type: 'Float!' },
    hasNextPage: { __type: 'Boolean!' },
    hasPreviousPage: { __type: 'Boolean!' },
    pageSize: { __type: 'Float!' },
    totalCount: { __type: 'Float!' },
    totalPages: { __type: 'Float!' },
  },
  AuditQueryResult: {
    __typename: { __type: 'String!' },
    events: { __type: '[AuditEvent!]!' },
    pagination: { __type: 'AuditPaginationResult!' },
  },
  AvailableClientTabsResponse: {
    __typename: { __type: 'String!' },
    tabs: { __type: '[ClientTab!]!' },
  },
  AvailableExport: {
    __typename: { __type: 'String!' },
    category: { __type: 'String!' },
    label: { __type: 'String!' },
    name: { __type: 'BigQueryExportName!' },
    spannerSupported: { __type: 'Boolean!' },
  },
  AvailableReports: {
    __typename: { __type: 'String!' },
    reports: { __type: '[ReportDefinition!]!' },
  },
  AvailableReportsInputInput: { siteId: { __type: 'String' } },
  AvailableToAssignRegionsFilterInput: { permissions: { __type: '[String!]' } },
  AvailableZapierLocations: {
    __typename: { __type: 'String!' },
    alreadyConnected: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    siteId: { __type: 'String!' },
  },
  AwardsSummary: {
    __typename: { __type: 'String!' },
    mostEarnedAwardCount: { __type: 'Float!' },
    mostEarnedAwardName: { __type: 'String' },
    pendingAwards: { __type: 'Float!' },
    totalAwardsEarned: { __type: 'Float!' },
    uniqueRecipients: { __type: 'Float!' },
  },
  BiAccessGrantEntry: {
    __typename: { __type: 'String!' },
    capability: { __type: 'String!' },
    principalId: { __type: 'String' },
    scopeType: { __type: 'String!' },
    siteId: { __type: 'String' },
  },
  BiAccessGrantInput: {
    capability: { __type: 'String!' },
    principalId: { __type: 'String' },
    scopeType: { __type: 'String!' },
    siteId: { __type: 'String' },
  },
  BiDeleteDashboardInput: { dashboardId: { __type: 'String!' } },
  BiMigrationConfig: {
    __typename: { __type: 'String!' },
    classicDashboardsEnabled: { __type: 'Boolean!' },
    updatedAt: { __type: 'String' },
    updatedBy: { __type: 'String' },
    workspaceId: { __type: 'String' },
  },
  BiParityCheckInput: {
    corporateId: { __type: 'ID!' },
    cubeQuery: { __type: 'AnalyticsV2QueryMeasureInput!' },
    gooddata: { __type: 'BiParityGoodDataMetricRef' },
    sessionCookie: { __type: 'String' },
    tolerancePct: { __type: 'Float' },
  },
  BiParityCheckResult: {
    __typename: { __type: 'String!' },
    checkedBy: { __type: 'String!' },
    corporateId: { __type: 'String!' },
    cubeDurationMs: { __type: 'Float!' },
    cubeValue: { __type: 'Float' },
    delta: { __type: 'Float' },
    deltaPct: { __type: 'Float' },
    gooddataValue: { __type: 'Float' },
    status: { __type: 'BiParityStatus!' },
    tolerancePct: { __type: 'Float!' },
  },
  BiParityGoodDataMetricRef: {
    dateDatasetId: { __type: 'String' },
    dateFrom: { __type: 'String' },
    dateTo: { __type: 'String' },
    metricId: { __type: 'String!' },
    workspaceId: { __type: 'String!' },
  },
  BiPublishDashboardInput: { bundleJson: { __type: 'String!' }, sortOrder: { __type: 'Float' } },
  BiSetAccessInput: {
    grants: { __type: '[BiAccessGrantInput!]!' },
    subjectId: { __type: 'String!' },
    subjectType: { __type: 'String!' },
    visibility: { __type: 'String!' },
  },
  BiSetDefaultDashboardInput: { dashboardId: { __type: 'String' } },
  BiSetMigrationConfigInput: {
    classicDashboardsEnabled: { __type: 'Boolean' },
    workspaceId: { __type: 'String!' },
  },
  BiSubjectAccess: {
    __typename: { __type: 'String!' },
    createdBy: { __type: 'String!' },
    grants: { __type: '[BiAccessGrantEntry!]!' },
    subjectId: { __type: 'String!' },
    subjectType: { __type: 'String!' },
    visibility: { __type: 'String!' },
  },
  BiTenantDashboardBundle: {
    __typename: { __type: 'String!' },
    biDashboardId: { __type: 'String!' },
    bundleJson: { __type: 'String!' },
    canEdit: { __type: 'Boolean!' },
    createdBy: { __type: 'String!' },
    dashboardId: { __type: 'String!' },
    origin: { __type: 'String!' },
    sortOrder: { __type: 'Float!' },
    title: { __type: 'String!' },
    updatedAt: { __type: 'String!' },
    visibility: { __type: 'String!' },
  },
  BiTenantDashboardsResponse: {
    __typename: { __type: 'String!' },
    access: { __type: '[BiSubjectAccess!]!' },
    bundles: { __type: '[BiTenantDashboardBundle!]!' },
    canAuthor: { __type: 'Boolean!' },
    canManageAccess: { __type: 'Boolean!' },
    classicDashboardsEnabled: { __type: 'Boolean!' },
    defaultDashboardId: { __type: 'String' },
    viewer: { __type: 'BiViewerContext!' },
  },
  BiViewerContext: {
    __typename: { __type: 'String!' },
    identifier: { __type: 'String' },
    isAllSites: { __type: 'Boolean!' },
    policyIds: { __type: '[String!]!' },
    siteIds: { __type: '[String!]!' },
    staffUserId: { __type: 'String' },
  },
  BlockClientResponse: {
    __typename: { __type: 'String!' },
    message: { __type: 'String' },
    success: { __type: 'Boolean!' },
  },
  BlockSlotCreateInput: {
    date: { __type: 'String!' },
    description: { __type: 'String' },
    endTime: { __type: 'String!' },
    name: { __type: 'String!' },
    siteLocationId: { __type: 'String!' },
    siteLocationRoomId: { __type: 'String' },
    staffUserIds: { __type: '[String!]' },
    startTime: { __type: 'String!' },
  },
  Booking: {
    __typename: { __type: 'String!' },
    aggregatorProviderId: { __type: 'String' },
    bookedByClientId: { __type: 'ID' },
    bookingId: { __type: 'ID!' },
    bookingSource: { __type: 'BookingSource' },
    cancelledAt: { __type: 'String' },
    cancelledBy: { __type: 'ID' },
    client: { __type: 'BookingClient' },
    clientId: { __type: 'ID!' },
    clientName: { __type: 'String' },
    confirmedAt: { __type: 'String' },
    createdAt: { __type: 'String!' },
    creditSourceNames: { __type: '[String!]' },
    destinationFeeEligible: { __type: 'Boolean' },
    destinationFeeInvoiceId: { __type: 'ID' },
    destinationFeeInvoiceStatus: { __type: 'InvoiceStatus' },
    dropInAmount: { __type: 'Numeric' },
    dropInInvoiceId: { __type: 'ID' },
    externalReferenceId: { __type: 'String' },
    externalUserId: { __type: 'String' },
    invitationAcceptedAt: { __type: 'String' },
    invitationSentAt: { __type: 'String' },
    invitedByStaffUserId: { __type: 'ID' },
    isFamilyBooking: { __type: 'Boolean' },
    isFirstVisit: { __type: 'Boolean' },
    isImported: { __type: 'Boolean!' },
    isVisitingLocation: { __type: 'Boolean' },
    lateCancelCreditsKept: { __type: 'Float' },
    lateCancelFeeInvoiceId: { __type: 'ID' },
    lateCancelFeeInvoiceStatus: { __type: 'InvoiceStatus' },
    noShowFeeInvoiceId: { __type: 'ID' },
    noShowFeeInvoiceStatus: { __type: 'InvoiceStatus' },
    notes: { __type: 'String' },
    paymentMethod: { __type: 'BookingPaymentMethod' },
    paymentStatus: { __type: 'BookingPaymentStatus' },
    sessionId: { __type: 'ID!' },
    sharedCreditOwnerClientId: { __type: 'ID' },
    sharedCreditOwnerName: { __type: 'String' },
    siteAttendanceCount: { __type: 'Float' },
    siteId: { __type: 'ID!' },
    source: { __type: 'Source!' },
    spotId: { __type: 'Float' },
    status: { __type: 'BookingStatus!' },
    totalAttendanceCount: { __type: 'Float' },
    totalCreditsRequired: { __type: 'Float!' },
    updatedAt: { __type: 'String!' },
    usedUnlimitedCredit: { __type: 'Boolean' },
  },
  BookingActivityLog: {
    __typename: { __type: 'String!' },
    activityType: { __type: 'BookingActivityType!' },
    bookingActivityLogId: { __type: 'String!' },
    bookingId: { __type: 'String!' },
    clientFirstName: { __type: 'String' },
    clientId: { __type: 'String!' },
    clientLastName: { __type: 'String' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'String' },
    createdByFirstName: { __type: 'String' },
    createdByLastName: { __type: 'String' },
    createdByName: { __type: 'String' },
    createdByType: { __type: 'CreatedByType' },
    sessionName: { __type: 'String' },
    sessionStartTime: { __type: 'String' },
    siteId: { __type: 'String!' },
    triggeredByName: { __type: 'String' },
    value: { __type: 'String' },
  },
  BookingActivityLogCreateInput: {
    activityType: { __type: 'BookingActivityType!' },
    bookingId: { __type: 'String!' },
    clientId: { __type: 'String!' },
    createdBy: { __type: 'String' },
    createdByType: { __type: 'CreatedByType' },
    siteId: { __type: 'String!' },
    value: { __type: 'String' },
  },
  BookingBuddyLinkedAccount: {
    __typename: { __type: 'String!' },
    acceptedAt: { __type: 'String' },
    buddyClientId: { __type: 'ID!' },
    clientId: { __type: 'ID!' },
    email: { __type: 'String' },
    firstName: { __type: 'String' },
    initiatedBy: { __type: 'ID' },
    lastName: { __type: 'String' },
    profileImageUrl: { __type: 'String' },
    sessionBookingSource: { __type: 'String' },
    sessionBookingStatus: { __type: 'String' },
    status: { __type: 'ClientBookingBuddyStatus!' },
  },
  BookingBuddyMutationResult: {
    __typename: { __type: 'String!' },
    message: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  BookingClient: {
    __typename: { __type: 'String!' },
    alerts: { __type: '[ClientAlert!]!' },
    email: { __type: 'String' },
    firstName: { __type: 'String' },
    id: { __type: 'String!' },
    lastName: { __type: 'String' },
    mobilePhoneNumber: { __type: 'String' },
    name: { __type: 'String' },
    siteId: { __type: 'String' },
  },
  BookingCreateInput: {
    aggregatorProviderId: { __type: 'String' },
    bookedByClientId: { __type: 'String' },
    bookingSource: { __type: 'BookingSource!' },
    clientId: { __type: 'String!' },
    creditOwnerClientId: { __type: 'String' },
    dropInAmount: { __type: 'Numeric' },
    externalReferenceId: { __type: 'String' },
    externalUserId: { __type: 'String' },
    forFamilyMember: { __type: 'Boolean' },
    guestServiceId: { __type: 'ID' },
    invitedByStaffUserId: { __type: 'String' },
    notes: { __type: 'String' },
    owedBalanceOverride: { __type: 'OwedBalanceOverrideInput' },
    paymentStatus: { __type: 'BookingPaymentStatus' },
    selectedServiceIds: { __type: '[ID!]' },
    serviceId: { __type: 'String' },
    sessionId: { __type: 'String!' },
    sharedServiceId: { __type: 'String' },
    source: { __type: 'Source' },
    spotId: { __type: 'Float' },
    status: { __type: 'BookingStatus' },
    totalCreditsRequired: { __type: 'Float' },
  },
  BookingCreditPackageOption: {
    __typename: { __type: 'String!' },
    canCombine: { __type: 'Boolean!' },
    creditsRemaining: { __type: 'Float' },
    expiryDate: { __type: 'String' },
    ineligibleReason: { __type: 'BookingCreditPackageIneligibleReason' },
    isCurrent: { __type: 'Boolean!' },
    isUnlimited: { __type: 'Boolean!' },
    packageName: { __type: 'String!' },
    renewsWhenUsed: { __type: 'Boolean!' },
    serviceId: { __type: 'ID!' },
    sharedCreditOwnerClientId: { __type: 'ID' },
    sharedCreditOwnerName: { __type: 'String' },
    status: { __type: 'ServiceStatus!' },
  },
  BookingCreditPackageOptions: {
    __typename: { __type: 'String!' },
    bookingId: { __type: 'ID!' },
    creditsRequired: { __type: 'Float!' },
    creditsToRefund: { __type: 'Float!' },
    options: { __type: '[BookingCreditPackageOption!]!' },
    originalPackageExpired: { __type: 'Boolean!' },
  },
  BookingCreditShortfall: {
    __typename: { __type: 'String!' },
    bookingId: { __type: 'ID!' },
    clientId: { __type: 'ID!' },
    reason: { __type: 'CreditShortfallReason' },
  },
  BookingPaginationResult: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'BookingPaginationResultPageInfo!' },
    results: { __type: '[BookingPaginationResultResults!]!' },
  },
  BookingPaginationResultPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Float!' },
  },
  BookingPaginationResultResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'Booking!' },
  },
  BookingPaymentMethod: {
    __typename: { __type: 'String!' },
    brand: { __type: 'String' },
    kind: { __type: 'BookingPaymentMethodKind!' },
    last4: { __type: 'String' },
  },
  BookingUpdateInput: {
    bookingSource: { __type: 'BookingSource' },
    cancelledAt: { __type: 'String' },
    cancelledBy: { __type: 'String' },
    confirmedAt: { __type: 'String' },
    destinationFeeInvoiceId: { __type: 'ID' },
    dropInAmount: { __type: 'Numeric' },
    dropInInvoiceId: { __type: 'String' },
    invitationAcceptedAt: { __type: 'String' },
    lateCancelCreditsKept: { __type: 'Float' },
    lateCancelFeeInvoiceId: { __type: 'String' },
    noShowFeeInvoiceId: { __type: 'String' },
    notes: { __type: 'String' },
    paymentStatus: { __type: 'BookingPaymentStatus' },
    spotId: { __type: 'Float' },
    status: { __type: 'BookingStatus' },
    totalCreditsRequired: { __type: 'Float' },
  },
  BranchConfigStatus: {
    __typename: { __type: 'String!' },
    appLink: { __type: 'String' },
    hasKey: { __type: 'Boolean!' },
    hasSecret: { __type: 'Boolean!' },
    isConfigured: { __type: 'Boolean!' },
    message: { __type: 'String' },
  },
  BrandAddOnConfig: {
    __typename: { __type: 'String!' },
    agreementEnabled: { __type: 'Boolean!' },
    agreementSendConfirmation: { __type: 'Boolean' },
    agreementText: { __type: 'String' },
    credits: { __type: '[BrandAddOnCreditLine!]!' },
    currency: { __type: 'Currency' },
    description: { __type: 'String' },
    name: { __type: 'String!' },
    pricePoints: { __type: '[BrandAddOnPricePoint!]!' },
  },
  BrandAddOnConfigInput: {
    agreementEnabled: { __type: 'Boolean!' },
    agreementSendConfirmation: { __type: 'Boolean' },
    agreementText: { __type: 'String' },
    credits: { __type: '[BrandAddOnCreditLineInput!]!' },
    currency: { __type: 'Currency' },
    description: { __type: 'String' },
    name: { __type: 'String!' },
    pricePoints: { __type: '[BrandAddOnPricePointInput!]!' },
  },
  BrandAddOnCreditLine: {
    __typename: { __type: 'String!' },
    amount: { __type: 'Float' },
    corporateSessionTypeIds: { __type: '[ID!]!' },
    creditLineId: { __type: 'ID!' },
    creditsType: { __type: 'CreditType!' },
  },
  BrandAddOnCreditLineInput: {
    amount: { __type: 'Float' },
    corporateSessionTypeIds: { __type: '[ID!]!' },
    creditLineId: { __type: 'ID!' },
    creditsType: { __type: 'CreditType!' },
  },
  BrandAddOnDependents: {
    __typename: { __type: 'String!' },
    brandParentNames: { __type: '[String!]!' },
    locationLinkCount: { __type: 'Float!' },
    siteId: { __type: 'ID!' },
  },
  BrandAddOnDryRun: {
    __typename: { __type: 'String!' },
    dependents: { __type: '[BrandAddOnDependents!]!' },
    locationAuthoredCount: { __type: 'Float!' },
    receivingSiteCount: { __type: 'Float!' },
    refusals: { __type: '[BrandServiceTemplateRefusal!]!' },
    sites: { __type: '[BrandAddOnDryRunSite!]!' },
    unlinkedPricePointCount: { __type: 'Float!' },
  },
  BrandAddOnDryRunSite: {
    __typename: { __type: 'String!' },
    autoCreate: { __type: 'BrandServiceTemplateAutoCreate!' },
    blockedReasons: { __type: '[BrandServiceTemplateBlockedReason!]!' },
    keptLocalFields: { __type: '[BrandAddOnField!]!' },
    siteId: { __type: 'ID!' },
    skippedLinks: { __type: '[BrandAddOnSkippedLink!]!' },
  },
  BrandAddOnLocationPricePoint: {
    __typename: { __type: 'String!' },
    isLinkedHere: { __type: 'Boolean!' },
    paymentType: { __type: 'ServiceTemplateAddOnPaymentType!' },
    price: { __type: 'Numeric!' },
    pricePointId: { __type: 'ID!' },
    taxEnabled: { __type: 'Boolean!' },
    taxSettingIds: { __type: '[ID!]' },
  },
  BrandAddOnPricePoint: {
    __typename: { __type: 'String!' },
    corporateTaxSettingIds: { __type: '[ID!]' },
    parentCorporateServiceTemplateIds: { __type: '[ID!]!' },
    paymentType: { __type: 'ServiceTemplateAddOnPaymentType!' },
    price: { __type: 'Numeric!' },
    pricePointId: { __type: 'ID!' },
    taxEnabled: { __type: 'Boolean!' },
  },
  BrandAddOnPricePointInput: {
    corporateTaxSettingIds: { __type: '[ID!]' },
    parentCorporateServiceTemplateIds: { __type: '[ID!]!' },
    paymentType: { __type: 'ServiceTemplateAddOnPaymentType!' },
    price: { __type: 'Numeric!' },
    pricePointId: { __type: 'ID!' },
    taxEnabled: { __type: 'Boolean!' },
  },
  BrandAddOnSkippedLink: {
    __typename: { __type: 'String!' },
    parentCorporateServiceTemplateId: { __type: 'ID!' },
    parentName: { __type: 'String!' },
    pricePointId: { __type: 'ID!' },
    reason: { __type: 'BrandAddOnSkippedLinkReason!' },
  },
  BrandAppAvailability: {
    __typename: { __type: 'String!' },
    availableInNewTerritories: { __type: 'Boolean!' },
    baseTerritory: { __type: 'String!' },
    brandId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    platform: { __type: 'BrandPlatform!' },
    territories: { __type: '[String!]!' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'String' },
  },
  BrandAppInformation: {
    __typename: { __type: 'String!' },
    ageRatingInfoUrl: { __type: 'String' },
    brandId: { __type: 'String!' },
    contentRightsDeclaration: { __type: 'AppleContentRightsDeclaration!' },
    copyright: { __type: 'String' },
    createdAt: { __type: 'String!' },
    platform: { __type: 'BrandPlatform!' },
    primaryCategory: { __type: 'String!' },
    secondaryCategory: { __type: 'String' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'String' },
  },
  BrandArtwork: {
    __typename: { __type: 'String!' },
    appIconUrl: { __type: 'String' },
    loginLogoUrl: { __type: 'String' },
    splashScreenUrl: { __type: 'String' },
  },
  BrandArtworkUploadUrl: {
    __typename: { __type: 'String!' },
    fileUrl: { __type: 'String!' },
    uploadRef: { __type: 'String!' },
    uploadUrl: { __type: 'String!' },
  },
  BrandBuildConfigView: {
    __typename: { __type: 'String!' },
    brandId: { __type: 'String!' },
    configJson: { __type: 'String' },
    missingFields: { __type: '[String!]!' },
    sources: { __type: '[BuildConfigSourceEntry!]!' },
    status: { __type: 'BrandBuildConfigViewStatus!' },
    unreadableCoreKeys: { __type: '[CoreAppServiceKeyName!]!' },
  },
  BrandBuildProfile: {
    __typename: { __type: 'String!' },
    branchLiveKey: { __type: 'String' },
    branchTestKey: { __type: 'String' },
    brandId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    expoOwner: { __type: 'String' },
    facebook: { __type: 'BrandFacebookConfig' },
    googleSupportClientId: { __type: 'String' },
    isV2Api: { __type: 'Boolean!' },
    platformAndroid: { __type: 'JSONObject' },
    platformIos: { __type: 'JSONObject' },
    plugins: { __type: 'JSONObject' },
    streakScope: { __type: 'String' },
    translations: { __type: 'JSONObject' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'String' },
  },
  BrandConfig: {
    __typename: { __type: 'String!' },
    payload: { __type: 'String!' },
    publicPayloadHash: { __type: 'String!' },
    versionId: { __type: 'String!' },
  },
  BrandConfigVersionSummary: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    isCurrent: { __type: 'Boolean!' },
    savedBy: { __type: 'String' },
    savedByPersona: { __type: 'BrandConfigSavedByPersona' },
    versionId: { __type: 'String!' },
  },
  BrandFacebookConfig: {
    __typename: { __type: 'String!' },
    appId: { __type: 'String!' },
    clientToken: { __type: 'String!' },
    displayName: { __type: 'String!' },
  },
  BrandFacebookConfigInput: {
    appId: { __type: 'String!' },
    clientToken: { __type: 'String!' },
    displayName: { __type: 'String!' },
  },
  BrandFirebaseApp: {
    __typename: { __type: 'String!' },
    appId: { __type: 'String!' },
    identifier: { __type: 'String!' },
    platform: { __type: 'BrandPlatform!' },
  },
  BrandFirebaseApps: {
    __typename: { __type: 'String!' },
    android: { __type: 'BrandFirebaseApp' },
    ios: { __type: 'BrandFirebaseApp' },
    projectId: { __type: 'String!' },
  },
  BrandFirebaseConfigFile: {
    __typename: { __type: 'String!' },
    contents: { __type: 'String!' },
    filename: { __type: 'String!' },
  },
  BrandIdentity: {
    __typename: { __type: 'String!' },
    appleId: { __type: 'String' },
    appleItcTeamId: { __type: 'String' },
    appleTeamId: { __type: 'String' },
    ascAppId: { __type: 'String' },
    brandId: { __type: 'String!' },
    bundleIdIos: { __type: 'String' },
    packageAndroid: { __type: 'String' },
    playStoreId: { __type: 'String' },
    scheme: { __type: 'String' },
  },
  BrandNativePermissions: {
    __typename: { __type: 'String!' },
    android: { __type: '[AndroidPermissionState!]!' },
    brandId: { __type: 'String!' },
    ios: { __type: '[IosUsageDescriptionState!]!' },
  },
  BrandNativeRelease: {
    __typename: { __type: 'String!' },
    appVersion: { __type: 'String' },
    brandId: { __type: 'String!' },
    buildNumber: { __type: 'Float!' },
    ciRunUrl: { __type: 'String' },
    completedAt: { __type: 'String' },
    dispatchedAt: { __type: 'String' },
    easBuildId: { __type: 'String' },
    easBuildUrl: { __type: 'String' },
    failureReason: { __type: 'String' },
    nativeRevision: { __type: 'Float' },
    platform: { __type: 'BrandPlatform!' },
    reason: { __type: 'BrandNativeReleaseReason!' },
    releaseId: { __type: 'String!' },
    requestedAt: { __type: 'String!' },
    requestedBy: { __type: 'String' },
    status: { __type: 'BrandNativeReleaseStatus!' },
    storeBuildNumber: { __type: 'Float' },
    storeSubmissionId: { __type: 'String' },
    submitToReviewRequested: { __type: 'Boolean!' },
  },
  BrandNavigationArtwork: {
    __typename: { __type: 'String!' },
    homeLogoUrl: { __type: 'String' },
    tabBookingsUrl: { __type: 'String' },
    tabExploreUrl: { __type: 'String' },
    tabHomeUrl: { __type: 'String' },
    tabMoreUrl: { __type: 'String' },
    tabPackagesUrl: { __type: 'String' },
  },
  BrandObservePerformance: {
    __typename: { __type: 'String!' },
    appVersion: { __type: 'String' },
    capturedAt: { __type: 'String' },
    coldLaunchMedianMs: { __type: 'Float' },
    previousAppVersion: { __type: 'String' },
    status: { __type: 'BrandObservePerfStatus!' },
    ttiMedianMs: { __type: 'Float' },
    worstChangeRatio: { __type: 'Float' },
  },
  BrandProvisionOutcome: {
    __typename: { __type: 'String!' },
    detail: { __type: 'String!' },
    owner: { __type: 'BrandProvisioningOwner' },
    status: { __type: 'BrandProvisionStatus!' },
    step: { __type: 'BrandProvisionStep!' },
  },
  BrandProvisioningOutcome: {
    __typename: { __type: 'String!' },
    actorId: { __type: 'String!' },
    detail: { __type: 'String!' },
    owner: { __type: 'BrandProvisioningOwner!' },
    platform: { __type: 'BrandPlatform' },
    recordedAt: { __type: 'String!' },
    runId: { __type: 'String!' },
    status: { __type: 'BrandProvisioningStepStatus!' },
    step: { __type: 'BrandProvisionStep!' },
  },
  BrandPushSettings: {
    __typename: { __type: 'String!' },
    appId: { __type: 'String' },
    brandId: { __type: 'String!' },
    configuredProvider: { __type: 'PushProvider' },
    firebaseProjectId: { __type: 'String' },
    path: { __type: 'BrandPushPath!' },
  },
  BrandReleaseHold: {
    __typename: { __type: 'String!' },
    brandId: { __type: 'String!' },
    reason: { __type: 'String' },
    setAt: { __type: 'String' },
    setByName: { __type: 'String' },
  },
  BrandReleaseReadiness: {
    __typename: { __type: 'String!' },
    missing: { __type: '[BrandReleaseRequirementDetail!]!' },
    platform: { __type: 'BrandPlatform!' },
    ready: { __type: 'Boolean!' },
    warnings: { __type: '[BrandReleaseRequirementDetail!]!' },
  },
  BrandReleaseRequirementDetail: {
    __typename: { __type: 'String!' },
    detail: { __type: 'String' },
    label: { __type: 'String!' },
    requirement: { __type: 'BrandReleaseRequirement!' },
    source: { __type: 'String!' },
  },
  BrandReleaseStatus: {
    __typename: { __type: 'String!' },
    currentAppVersion: { __type: 'String' },
    latestRelease: { __type: 'BrandNativeRelease' },
    platform: { __type: 'BrandPlatform!' },
    testingLink: { __type: 'String' },
  },
  BrandServiceTemplateArchiveSkip: {
    __typename: { __type: 'String!' },
    corporateServiceTemplateId: { __type: 'ID!' },
    reason: { __type: 'BrandServiceTemplateArchiveSkipReason!' },
  },
  BrandServiceTemplateAutoCreate: {
    __typename: { __type: 'String!' },
    corporateSessionTypeIds: { __type: '[ID!]!' },
    corporateTaxSettingIds: { __type: '[ID!]!' },
  },
  BrandServiceTemplateBlockedReason: {
    __typename: { __type: 'String!' },
    code: { __type: 'BrandServiceTemplateBlockedReasonCode!' },
    message: { __type: 'String!' },
  },
  BrandServiceTemplateName: {
    __typename: { __type: 'String!' },
    name: { __type: 'String!' },
    type: { __type: 'CorporateServiceTemplateType!' },
  },
  BrandServiceTemplateRefusal: {
    __typename: { __type: 'String!' },
    code: { __type: 'BrandServiceTemplateRefusalCode!' },
    itemId: { __type: 'ID' },
    message: { __type: 'String!' },
    siteIds: { __type: '[ID!]' },
  },
  BrandServiceTemplateRollout: {
    __typename: { __type: 'String!' },
    changeSetId: { __type: 'ID!' },
    kind: { __type: 'BrandServiceTemplateChangeSetKind!' },
    sites: { __type: '[BrandServiceTemplateRolloutSite!]!' },
    status: { __type: 'BrandServiceTemplateChangeSetStatus!' },
  },
  BrandServiceTemplateRolloutSite: {
    __typename: { __type: 'String!' },
    action: { __type: 'BrandServiceTemplateSiteAction!' },
    error: { __type: 'String' },
    resultServiceTemplateId: { __type: 'String' },
    siteId: { __type: 'ID!' },
    status: { __type: 'BrandServiceTemplateChangeSetSiteStatus!' },
  },
  BrandServiceTemplateScheduledSite: {
    __typename: { __type: 'String!' },
    activateAt: { __type: 'String!' },
    isUtcFallback: { __type: 'Boolean!' },
    siteId: { __type: 'ID!' },
    timezone: { __type: 'String!' },
  },
  BrandServiceTemplateWithdrawal: {
    __typename: { __type: 'String!' },
    corporateServiceTemplateId: { __type: 'ID!' },
    name: { __type: 'String!' },
    sites: { __type: '[BrandServiceTemplateWithdrawalSite!]!' },
    type: { __type: 'CorporateServiceTemplateType!' },
  },
  BrandServiceTemplateWithdrawalAcknowledgementInput: {
    corporateServiceTemplateId: { __type: 'ID!' },
    siteIds: { __type: '[ID!]!' },
  },
  BrandServiceTemplateWithdrawalSite: {
    __typename: { __type: 'String!' },
    activeClientCount: { __type: 'Float!' },
    siteId: { __type: 'ID!' },
  },
  BrandSetupAttestation: {
    __typename: { __type: 'String!' },
    attestedAt: { __type: 'String!' },
    attestedBy: { __type: 'String!' },
    note: { __type: 'String' },
    step: { __type: 'BrandSetupStep!' },
  },
  BrandSetupStepView: {
    __typename: { __type: 'String!' },
    attestation: { __type: 'BrandSetupAttestation' },
    blockedBy: { __type: '[BrandSetupStep!]!' },
    evidence: { __type: 'BrandSetupEvidence!' },
    label: { __type: 'String!' },
    requirements: { __type: '[BrandReleaseRequirement!]!' },
    source: { __type: 'String!' },
    state: { __type: 'BrandSetupStepState!' },
    step: { __type: 'BrandSetupStep!' },
  },
  BrandStoreAssetUploadUrl: {
    __typename: { __type: 'String!' },
    gcsPath: { __type: 'String!' },
    uploadRef: { __type: 'String!' },
    uploadUrl: { __type: 'String!' },
  },
  BrandStoreAssets: {
    __typename: { __type: 'String!' },
    assetId: { __type: 'String!' },
    assetType: { __type: 'BrandStoreAssetType!' },
    brandId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    deviceClass: { __type: 'String' },
    filename: { __type: 'String!' },
    gcsPath: { __type: 'String!' },
    height: { __type: 'Float' },
    locale: { __type: 'String!' },
    platform: { __type: 'BrandPlatform!' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'String' },
    validationError: { __type: 'String' },
    validationStatus: { __type: 'BrandStoreAssetStatus!' },
    width: { __type: 'Float' },
  },
  BrandStoreListingPublicationView: {
    __typename: { __type: 'String!' },
    checkedAt: { __type: 'String!' },
    detail: { __type: 'String' },
    platform: { __type: 'BrandPlatform!' },
    status: { __type: 'BrandStoreListingPublicationStatus!' },
    submittedAt: { __type: 'String' },
  },
  BrandStoreListings: {
    __typename: { __type: 'String!' },
    appName: { __type: 'String' },
    brandId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    description: { __type: 'String' },
    keywords: { __type: 'String' },
    locale: { __type: 'String!' },
    marketingUrl: { __type: 'String' },
    platform: { __type: 'BrandPlatform!' },
    privacyPolicyUrl: { __type: 'String' },
    releaseNotes: { __type: 'String' },
    shortDescription: { __type: 'String' },
    subtitle: { __type: 'String' },
    supportUrl: { __type: 'String' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'String' },
  },
  BrandStoreOperationsOverview: {
    __typename: { __type: 'String!' },
    operations: { __type: '[BrandStoreOperationsOverviewOperations!]!' },
    snapshots: { __type: '[BrandStoreOperationsOverviewSnapshots!]!' },
  },
  BrandStoreOperationsOverviewOperations: {
    __typename: { __type: 'String!' },
    action: { __type: 'BrandStoreOperationAction!' },
    brandId: { __type: 'String!' },
    completedAt: { __type: 'String' },
    createdAt: { __type: 'String!' },
    error: { __type: 'String' },
    idempotencyKey: { __type: 'String!' },
    operationId: { __type: 'String!' },
    platform: { __type: 'BrandPlatform!' },
    provider: { __type: 'BrandStoreProvider!' },
    requestedBy: { __type: 'String' },
    startedAt: { __type: 'String' },
    status: { __type: 'BrandStoreOperationStatus!' },
    updatedAt: { __type: 'String!' },
  },
  BrandStoreOperationsOverviewSnapshots: {
    __typename: { __type: 'String!' },
    blockerKind: { __type: 'StoreBlockerKind' },
    brandId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    error: { __type: 'String' },
    platform: { __type: 'BrandPlatform!' },
    provider: { __type: 'BrandStoreProvider!' },
    providerBuildNumber: { __type: 'Float' },
    providerUpdatedAt: { __type: 'String' },
    providerVersion: { __type: 'String' },
    rawReleaseState: { __type: 'String' },
    remoteAppId: { __type: 'String' },
    rolloutPercentage: { __type: 'Float' },
    status: { __type: 'BrandStoreSnapshotStatus!' },
    statusSince: { __type: 'String' },
    syncedAt: { __type: 'String' },
    track: { __type: 'String' },
    updatedAt: { __type: 'String!' },
  },
  BrandStoreReviewDetail: {
    __typename: { __type: 'String!' },
    brandId: { __type: 'String!' },
    contactEmail: { __type: 'String' },
    contactFirstName: { __type: 'String' },
    contactLastName: { __type: 'String' },
    contactPhone: { __type: 'String' },
    createdAt: { __type: 'String!' },
    demoAccountName: { __type: 'String' },
    demoAccountRequired: { __type: 'Boolean!' },
    hasDemoAccountPassword: { __type: 'Boolean!' },
    notes: { __type: 'String' },
    platform: { __type: 'BrandPlatform!' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'String' },
  },
  BrandStoreTesters: {
    __typename: { __type: 'String!' },
    brandId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    email: { __type: 'String!' },
    name: { __type: 'String' },
    platforms: { __type: '[BrandPlatform!]!' },
    source: { __type: 'BrandStoreTesterSource!' },
    testerId: { __type: 'String!' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'String' },
  },
  BrandSummary: {
    __typename: { __type: 'String!' },
    brandId: { __type: 'String!' },
    environment: { __type: 'BrandEnvironment!' },
    name: { __type: 'String!' },
    status: { __type: 'BrandRegistryStatus!' },
  },
  BuddyInviteContext: {
    __typename: { __type: 'String!' },
    inviterFirstName: { __type: 'String' },
    inviterLastName: { __type: 'String' },
    inviterProfileImageUrl: { __type: 'String' },
    valid: { __type: 'Boolean!' },
  },
  BuddyInviteTokenResult: { __typename: { __type: 'String!' }, inviteToken: { __type: 'String!' } },
  BuildConfigSourceEntry: {
    __typename: { __type: 'String!' },
    path: { __type: 'String!' },
    source: { __type: 'BuildConfigSource!' },
  },
  BulkAddSmsPackageOptionsInputInput: { options: { __type: '[AddSmsPackageOptionInputInput!]!' } },
  BulkInviteStaff: {
    __typename: { __type: 'String!' },
    email: { __type: 'String!' },
    invitationId: { __type: 'ID!' },
    token: { __type: 'String!' },
  },
  BulkRevertMemberMovementItemResult: {
    __typename: { __type: 'String!' },
    destinationChargesTaken: { __type: '[MemberMovementDestinationCharge!]!' },
    error: { __type: 'String' },
    memberMovementId: { __type: 'ID!' },
    reverted: { __type: 'Boolean!' },
  },
  BulkRevertMemberMovementsResult: {
    __typename: { __type: 'String!' },
    failed: { __type: 'Float!' },
    memberMovementRunId: { __type: 'ID!' },
    results: { __type: '[BulkRevertMemberMovementItemResult!]!' },
    reverted: { __type: 'Float!' },
    total: { __type: 'Float!' },
  },
  BulkUpdateContentEntryStatus: {
    __typename: { __type: 'String!' },
    failureCount: { __type: 'Float!' },
    successCount: { __type: 'Float!' },
  },
  BulkUpdateInvoiceResult: {
    __typename: { __type: 'String!' },
    error: { __type: 'String' },
    invoiceId: { __type: 'String!' },
    success: { __type: 'Boolean!' },
    wasMaterialized: { __type: 'Boolean' },
  },
  BulkUpdateInvoiceScheduleDateItem: {
    currentDate: { __type: 'String!' },
    invoiceId: { __type: 'String!' },
  },
  BulkUpdateInvoiceScheduleDatesInput: {
    deltaDays: { __type: 'Float!' },
    invoices: { __type: '[BulkUpdateInvoiceScheduleDateItem!]!' },
  },
  BulkUpdateInvoicesInput: {
    invoiceIds: { __type: '[String!]!' },
    totalAmount: { __type: 'Numeric!' },
  },
  BulkUpdateInvoicesResult: {
    __typename: { __type: 'String!' },
    results: { __type: '[BulkUpdateInvoiceResult!]!' },
    totalFailed: { __type: 'Float!' },
    totalRequested: { __type: 'Float!' },
    totalSucceeded: { __type: 'Float!' },
  },
  BulkUpdateScheduledAmountsInput: {
    invoiceIds: { __type: '[String!]!' },
    totalAmount: { __type: 'Numeric!' },
  },
  BulkUpdateScheduledDatesInput: {
    deltaDays: { __type: 'Float!' },
    invoices: { __type: '[BulkUpdateInvoiceScheduleDateItem!]!' },
    memberNotification: { __type: 'MemberNotificationInput' },
    shortfallAction: { __type: 'PresaleShortfallAction' },
  },
  BulkUpdateSites: {
    __typename: { __type: 'String!' },
    failedSites: { __type: '[Site!]!' },
    successSites: { __type: '[Site!]!' },
  },
  BusinessClientSignUpFields: {
    __typename: { __type: 'String!' },
    customProperties: { __type: '[BusinessClientSignUpFieldsCustomProperties!]!' },
    questionnaires: { __type: '[BusinessClientSignUpFieldsQuestionnaires!]!' },
    static: { __type: '[BusinessClientSignUpFieldsStatic!]!' },
  },
  BusinessClientSignUpFieldsCustomProperties: {
    __typename: { __type: 'String!' },
    alerts: { __type: '[BusinessClientSignUpFieldsCustomPropertiesAlerts!]!' },
    category: { __type: 'String!' },
    enableClientEditing: { __type: 'Boolean!' },
    hasSubtext: { __type: 'Boolean!' },
    id: { __type: 'String!' },
    name: { __type: 'String!' },
    options: { __type: '[BusinessClientSignUpFieldsCustomPropertiesOptions!]!' },
    required: { __type: 'Boolean!' },
    subtext: { __type: 'String' },
    type: { __type: 'String!' },
  },
  BusinessClientSignUpFieldsCustomPropertiesAlerts: {
    __typename: { __type: 'String!' },
    id: { __type: 'String!' },
    isDisplayPropertyValueAsAlert: { __type: 'Boolean!' },
    operator: { __type: 'String!' },
    text: { __type: 'String' },
    value: { __type: 'String' },
  },
  BusinessClientSignUpFieldsCustomPropertiesOptions: {
    __typename: { __type: 'String!' },
    label: { __type: 'String!' },
    value: { __type: 'String!' },
  },
  BusinessClientSignUpFieldsQuestionnaires: {
    __typename: { __type: 'String!' },
    description: { __type: 'String!' },
    id: { __type: 'String!' },
    name: { __type: 'String!' },
    questions: { __type: '[BusinessClientSignUpFieldsQuestionnairesQuestions!]!' },
    revision: { __type: 'Float' },
    scoringEnabled: { __type: 'Boolean' },
  },
  BusinessClientSignUpFieldsQuestionnairesQuestions: {
    __typename: { __type: 'String!' },
    answerType: { __type: 'String!' },
    id: { __type: 'String!' },
    options: { __type: '[String!]!' },
    order: { __type: 'Float!' },
    placeholder: { __type: 'String!' },
    question: { __type: 'String!' },
  },
  BusinessClientSignUpFieldsStatic: {
    __typename: { __type: 'String!' },
    required: { __type: 'Boolean!' },
    type: { __type: 'String!' },
  },
  CalculateCart: {
    __typename: { __type: 'String!' },
    dueToday: { __type: 'String!' },
    futurePayments: { __type: 'String!' },
    items: { __type: '[CalculateCartItems!]!' },
    preTaxTotal: { __type: 'String!' },
    secondaryRecurringFeeFuturePayments: { __type: 'String!' },
    subtotal: { __type: 'String!' },
    taxBreakdown: { __type: '[CalculateCartTaxBreakdown!]!' },
    totalAmount: { __type: 'String!' },
    totalDiscount: { __type: 'String!' },
    totalExclusiveTax: { __type: 'String!' },
    totalInclusiveTax: { __type: 'String!' },
    totalTax: { __type: 'String!' },
  },
  CalculateCartItems: {
    __typename: { __type: 'String!' },
    additionalCreditsAmount: { __type: 'String' },
    discountAmount: { __type: 'String!' },
    earlyAccess: { __type: 'EarlyAccessTimeline' },
    exclusiveTaxAmount: { __type: 'String!' },
    inclusiveTaxAmount: { __type: 'String!' },
    invoiceDate: { __type: 'String' },
    itemId: { __type: 'String!' },
    joinsPresaleInvoice: { __type: 'Boolean' },
    preTaxAmount: { __type: 'String!' },
    proratedAmount: { __type: 'String' },
    proratedCredits: { __type: 'Float' },
    proratedDays: { __type: 'Float' },
    proratedTotalAmount: { __type: 'String' },
    prorationEndDate: { __type: 'String' },
    prorationStartDate: { __type: 'String' },
    quantity: { __type: 'Float!' },
    revenueTag: { __type: 'RevenueTagSnapshot' },
    secondaryRecurringFeeTaxes: { __type: '[CalculateCartItemsTaxes!]!' },
    secondaryRecurringFeeTotalBillingCycles: { __type: 'Float' },
    setupFeeChargedToday: { __type: 'Boolean' },
    taxes: { __type: '[CalculateCartItemsTaxes!]!' },
    totalAmount: { __type: 'String!' },
    totalBillingCycles: { __type: 'Float' },
    totalCredits: { __type: 'Float' },
    totalValue: { __type: 'String!' },
    unitPrice: { __type: 'String!' },
  },
  CalculateCartItemsAddOnAttachmentInput: {
    parentServiceId: { __type: 'ID' },
    parentServiceTemplateId: { __type: 'ID' },
  },
  CalculateCartItemsInput: {
    addOnAttachment: { __type: 'CalculateCartItemsAddOnAttachmentInput' },
    additionalCredits: { __type: 'Float' },
    billingCycleAmount: { __type: 'Float' },
    billingCycleUnit: { __type: 'String' },
    billingDay: { __type: 'Float' },
    chargeSetupFeeUpFront: { __type: 'Boolean' },
    discountType: { __type: 'DiscountType' },
    discountValue: { __type: 'String' },
    giftCardTemplateId: { __type: 'ID' },
    itemId: { __type: 'String!' },
    itemType: { __type: 'SaleItemType' },
    lengthAmount: { __type: 'Float' },
    lengthUnit: { __type: 'String' },
    oneTimeSetupFee: { __type: 'String' },
    oneTimeSetupFeeTaxSettingIds: { __type: '[String!]!' },
    payUpFront: { __type: 'Boolean' },
    paymentDate: { __type: 'String' },
    primaryCreditLineType: { __type: 'CreditType' },
    productTemplateId: { __type: 'ID' },
    quantity: { __type: 'Float!' },
    revenueTagId: { __type: 'ID' },
    secondaryRecurringFeeAmount: { __type: 'String' },
    secondaryRecurringFeeBillingCycleAmount: { __type: 'Float' },
    secondaryRecurringFeeBillingCycleUnit: { __type: 'String' },
    secondaryRecurringFeeTaxSettingIds: { __type: '[String!]!' },
    serviceStartDate: { __type: 'String' },
    serviceTemplateId: { __type: 'String' },
    taxSettingIds: { __type: '[String!]!' },
    totalCredits: { __type: 'Float' },
    unitPrice: { __type: 'String!' },
  },
  CalculateCartItemsTaxes: {
    __typename: { __type: 'String!' },
    amount: { __type: 'String!' },
    name: { __type: 'String!' },
    rate: { __type: 'String!' },
    taxSettingId: { __type: 'String!' },
    type: { __type: 'TaxType!' },
  },
  CalculateCartTaxBreakdown: {
    __typename: { __type: 'String!' },
    name: { __type: 'String!' },
    rate: { __type: 'String!' },
    taxSettingId: { __type: 'String!' },
    totalAmount: { __type: 'String!' },
    type: { __type: 'TaxType!' },
  },
  CalendarSession: {
    __typename: { __type: 'String!' },
    bookedCount: { __type: 'Float' },
    bookings: { __type: '[CalendarSessionBooking!]' },
    description: { __type: 'String' },
    endTime: { __type: 'String!' },
    instructor: { __type: '[CalendarSessionInstructor!]' },
    isBlockSlot: { __type: 'Boolean!' },
    isFullyPaid: { __type: 'Boolean!' },
    isPublishedToWellhub: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    roomName: { __type: 'String' },
    sessionId: { __type: 'String!' },
    sessionTypeColor: { __type: 'String' },
    siteLocationRoomId: { __type: 'String' },
    size: { __type: 'Float!' },
    staffUserIds: { __type: '[String!]' },
    startTime: { __type: 'String!' },
    status: { __type: 'SessionStatus!' },
    waitlistCount: { __type: 'Float!' },
    waitlistEnabled: { __type: 'Boolean!' },
  },
  CalendarSessionBooking: { __typename: { __type: 'String!' }, clientName: { __type: 'String' } },
  CalendarSessionInstructor: {
    __typename: { __type: 'String!' },
    name: { __type: 'String' },
    staffUserId: { __type: 'String!' },
  },
  CancelFormAssignmentResponse: {
    __typename: { __type: 'String!' },
    message: { __type: 'String' },
    success: { __type: 'Boolean!' },
  },
  CancelImportSession: {
    __typename: { __type: 'String!' },
    importSessionId: { __type: 'ID!' },
    status: { __type: 'ImportSessionStatusEnum!' },
  },
  CancelPendingClientActionResult: {
    __typename: { __type: 'String!' },
    outcome: { __type: 'CancelPendingClientActionOutcome!' },
  },
  CancelPendingPaymentPlanChangeInput: {
    servicePlanChangeId: { __type: 'ID!' },
    siteId: { __type: 'ID!' },
  },
  CancelPendingPaymentResult: {
    __typename: { __type: 'String!' },
    outcome: { __type: 'PendingPaymentCancellationOutcome!' },
    paymentId: { __type: 'String!' },
    status: { __type: 'PaymentStatus!' },
  },
  CancelScheduledPlanChangeInput: {
    servicePlanChangeId: { __type: 'ID!' },
    siteId: { __type: 'ID!' },
  },
  CancelSessionInput: {
    includeModifiedSessions: { __type: 'Boolean' },
    message: { __type: 'String' },
    notificationMethods: { __type: '[NotificationMethod!]!' },
    overrideDownstreamSplits: { __type: 'Boolean' },
    scope: { __type: 'CancelSessionScope!' },
    sessionId: { __type: 'String!' },
    siteId: { __type: 'String!' },
    subject: { __type: 'String' },
  },
  CancelSessionsBatchInput: {
    message: { __type: 'String' },
    notificationMethods: { __type: '[NotificationMethod!]!' },
    sessionIds: { __type: '[String!]!' },
    siteId: { __type: 'String!' },
    subject: { __type: 'String' },
  },
  CancelSessionsForClosureInput: {
    message: { __type: 'String' },
    notificationMethods: { __type: '[NotificationMethod!]!' },
    sessionIds: { __type: '[String!]!' },
    siteAlertId: { __type: 'ID!' },
    siteId: { __type: 'ID!' },
    subject: { __type: 'String' },
  },
  CancelTerminalAction: { __typename: { __type: 'String!' }, success: { __type: 'Boolean!' } },
  CancellationFeeBreakdown: {
    __typename: { __type: 'String!' },
    cycleAmount: { __type: 'String' },
    kind: { __type: 'CancellationFeeBreakdownKind!' },
    percent: { __type: 'Float' },
    remainingCycles: { __type: 'Float' },
  },
  CancellationNoticePaymentDue: {
    __typename: { __type: 'String!' },
    amount: { __type: 'String!' },
    currency: { __type: 'String!' },
    description: { __type: 'String' },
    invoiceDate: { __type: 'String!' },
    type: { __type: 'RecurringInvoiceType!' },
  },
  CancellationNoticePreview: {
    __typename: { __type: 'String!' },
    lastActiveDate: { __type: 'String!' },
    noticeCancelDate: { __type: 'String!' },
    noticePeriodAmount: { __type: 'Float!' },
    noticePeriodUnit: { __type: 'CancellationNoticePeriodUnit!' },
    paymentsDue: { __type: '[CancellationNoticePaymentDue!]!' },
    requestDate: { __type: 'String!' },
  },
  CancelledInvoiceRow: {
    __typename: { __type: 'String!' },
    cancelledByStaffName: { __type: 'String' },
    invoice: { __type: 'Invoice!' },
    latestReinstateDate: { __type: 'String' },
    reinstateBlockedReason: { __type: 'ReinstateBlockedReason' },
    requiresNewDate: { __type: 'Boolean!' },
  },
  CashDrawerBillingTypeTotal: {
    __typename: { __type: 'String!' },
    label: { __type: 'String!' },
    sales: { __type: 'Numeric!' },
    voided: { __type: 'Numeric!' },
  },
  CashDrawerSession: {
    __typename: { __type: 'String!' },
    actualCash: { __type: 'Numeric' },
    additionalBillingTypeTotals: { __type: '[CashDrawerBillingTypeTotal!]!' },
    cashAdjustments: { __type: 'Numeric!' },
    cashDrawerSessionId: { __type: 'ID!' },
    cashRefunds: { __type: 'Numeric!' },
    cashSales: { __type: 'Numeric!' },
    closedAt: { __type: 'String' },
    closedByStaffUserId: { __type: 'ID' },
    createdAt: { __type: 'String!' },
    difference: { __type: 'Numeric' },
    expectedCash: { __type: 'Numeric' },
    expectedInDrawer: { __type: 'Numeric!' },
    openedAt: { __type: 'String!' },
    openedByStaffUserId: { __type: 'ID!' },
    siteId: { __type: 'ID!' },
    startingCash: { __type: 'Numeric!' },
    status: { __type: 'CashDrawerSessionStatus!' },
    updatedAt: { __type: 'String!' },
  },
  CashDrawerSessionTransactions: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'CashDrawerSessionTransactionsPageInfo!' },
    results: { __type: '[CashDrawerSessionTransactionsResults!]!' },
  },
  CashDrawerSessionTransactionsPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  CashDrawerSessionTransactionsResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'CashDrawerTransaction!' },
  },
  CashDrawerSessions: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'CashDrawerSessionsPageInfo!' },
    results: { __type: '[CashDrawerSessionsResults!]!' },
  },
  CashDrawerSessionsPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  CashDrawerSessionsResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'CashDrawerSession!' },
  },
  CashDrawerTransaction: {
    __typename: { __type: 'String!' },
    amount: { __type: 'Numeric!' },
    billingType: { __type: 'String!' },
    clientName: { __type: 'String' },
    description: { __type: 'String!' },
    kind: { __type: 'CashDrawerTransactionKind!' },
    occurredAt: { __type: 'String!' },
    sourceId: { __type: 'ID!' },
  },
  ChallengeAnalytics: {
    __typename: { __type: 'String!' },
    articleCompletionRate: { __type: 'Float!' },
    assessmentCompletionRate: { __type: 'Float!' },
    averageAttendanceRate: { __type: 'Float!' },
    averageGoalCompletionRate: { __type: 'Float!' },
    totalActive: { __type: 'Float!' },
    totalCompleted: { __type: 'Float!' },
    totalEnrolled: { __type: 'Float!' },
    totalExpired: { __type: 'Float!' },
    totalWithdrawn: { __type: 'Float!' },
  },
  ChallengeCatalog: {
    __typename: { __type: 'String!' },
    data: { __type: '[ChallengeDetail!]!' },
    hasMore: { __type: 'Boolean!' },
    totalCount: { __type: 'Float!' },
  },
  ChallengeDetail: {
    __typename: { __type: 'String!' },
    contentEntryId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    description: { __type: 'String' },
    fields: { __type: 'JSONObject!' },
    imageUrl: { __type: 'String' },
    publishedAt: { __type: 'String' },
    slug: { __type: 'String!' },
    status: { __type: 'String!' },
    title: { __type: 'String!' },
  },
  ChallengeLeaderboardEntry: {
    __typename: { __type: 'String!' },
    client: { __type: 'ChallengeLeaderboardEntryClient!' },
    clientId: { __type: 'String!' },
    rank: { __type: 'Float!' },
    score: { __type: 'Float!' },
  },
  ChallengeLeaderboardEntryClient: {
    __typename: { __type: 'String!' },
    firstName: { __type: 'String!' },
    lastName: { __type: 'String!' },
    profileImage: { __type: 'String' },
  },
  ChallengeOverview: {
    __typename: { __type: 'String!' },
    activeChallenges: { __type: 'Float!' },
    avgAttendanceProgress: { __type: 'Float!' },
    completedEnrollments: { __type: 'Float!' },
    completionRate: { __type: 'Float!' },
    totalEnrollments: { __type: 'Float!' },
  },
  ChallengeParticipationTimeline: {
    __typename: { __type: 'String!' },
    buckets: { __type: '[ChallengeParticipationTimelineBuckets!]!' },
  },
  ChallengeParticipationTimelineBuckets: {
    __typename: { __type: 'String!' },
    completed: { __type: 'Float!' },
    date: { __type: 'String!' },
    enrolled: { __type: 'Float!' },
    withdrawn: { __type: 'Float!' },
  },
  ChangeMembershipPlanInput: {
    collectAtCheckout: { __type: 'Boolean' },
    customPrice: { __type: 'String' },
    effectiveType: { __type: 'ServicePlanChangeEffectiveType!' },
    firstCycleRefundMethod: { __type: 'RefundType' },
    reason: { __type: 'String' },
    replaceExistingScheduled: { __type: 'Boolean' },
    serviceId: { __type: 'ID!' },
    signedClientAgreementId: { __type: 'ID' },
    siteId: { __type: 'ID!' },
    toServiceTemplateId: { __type: 'ID!' },
  },
  ChangeMembershipPlanResult: {
    __typename: { __type: 'String!' },
    proratedInvoiceId: { __type: 'ID' },
    servicePlanChangeId: { __type: 'ID!' },
  },
  CheckIn: {
    __typename: { __type: 'String!' },
    accessProviderId: { __type: 'String' },
    checkInId: { __type: 'ID!' },
    client: { __type: 'Client' },
    clientId: { __type: 'ID!' },
    contactlessCheckInAnswers: { __type: 'JSONObject' },
    createdAt: { __type: 'String!' },
    dateTime: { __type: 'String!' },
    deletedAt: { __type: 'String' },
    destinationFee: { __type: 'CheckInDestinationFee' },
    externalEventId: { __type: 'String' },
    externalFailCode: { __type: 'String' },
    failReason: { __type: 'CheckInFailReason' },
    failedInvoices: { __type: '[CheckInFailedInvoices!]' },
    holdOwnerFirstName: { __type: 'String' },
    nextSession: { __type: 'CheckInNextSession' },
    service: { __type: 'CheckInService' },
    site: { __type: 'SitePreview!' },
    siteAccessZoneId: { __type: 'String' },
    siteId: { __type: 'ID!' },
    source: { __type: 'CheckInSource!' },
    sourceId: { __type: 'String' },
    stagedInvoices: { __type: '[CheckInStagedInvoices!]' },
    status: { __type: 'CheckInStatus!' },
    type: { __type: 'CheckInType!' },
  },
  CheckInAttempt: {
    __typename: { __type: 'String!' },
    attemptId: { __type: 'String!' },
    barcode: { __type: 'String' },
    checkInId: { __type: 'String' },
    clientId: { __type: 'String' },
    createdAt: { __type: 'String!' },
    failReason: { __type: 'String' },
    firstName: { __type: 'String' },
    lastName: { __type: 'String' },
    siteId: { __type: 'String!' },
    source: { __type: 'String!' },
    status: { __type: 'CheckInAttemptStatus!' },
  },
  CheckInAttemptsPaginationResult: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    items: { __type: '[CheckInAttempt!]!' },
  },
  CheckInByBookingResult: {
    __typename: { __type: 'String!' },
    booking: { __type: 'CheckInByBookingResultBooking!' },
    checkinFlag: { __type: 'Float!' },
    message: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  CheckInByBookingResultBooking: {
    __typename: { __type: 'String!' },
    checkedIn: { __type: 'Boolean!' },
    checkinTime: { __type: 'String!' },
    id: { __type: 'String!' },
  },
  CheckInDestinationFee: {
    __typename: { __type: 'String!' },
    alreadyChargedToday: { __type: 'Boolean!' },
    amount: { __type: 'String!' },
    currency: { __type: 'String!' },
    existingStagedInvoiceId: { __type: 'String' },
    label: { __type: 'String!' },
    membershipName: { __type: 'String' },
    siteName: { __type: 'String!' },
    taxAmount: { __type: 'String' },
  },
  CheckInFailedInvoices: {
    __typename: { __type: 'String!' },
    amount: { __type: 'String!' },
    description: { __type: 'String' },
    dueDate: { __type: 'String' },
    hasFailureHistory: { __type: 'Boolean' },
    invoiceId: { __type: 'ID!' },
    siteId: { __type: 'ID' },
    siteName: { __type: 'String' },
    status: { __type: 'InvoiceStatus' },
  },
  CheckInNextSession: {
    __typename: { __type: 'String!' },
    bookingId: { __type: 'ID' },
    sessionDateTime: { __type: 'String' },
    sessionId: { __type: 'ID!' },
    sessionName: { __type: 'String' },
  },
  CheckInService: {
    __typename: { __type: 'String!' },
    creditsRemaining: { __type: 'Float' },
    isGuestPass: { __type: 'Boolean' },
    serviceId: { __type: 'ID!' },
    serviceName: { __type: 'String' },
    serviceType: { __type: 'String' },
  },
  CheckInStagedInvoices: {
    __typename: { __type: 'String!' },
    amount: { __type: 'String!' },
    description: { __type: 'String' },
    dueDate: { __type: 'String' },
    invoiceId: { __type: 'ID!' },
  },
  CheckInsPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    hasPreviousPage: { __type: 'Boolean' },
    startCursor: { __type: 'String' },
  },
  CheckInsPaginationResult: {
    __typename: { __type: 'String!' },
    items: { __type: '[CheckIn!]!' },
    pageInfo: { __type: 'CheckInsPageInfo!' },
    totalCount: { __type: 'Float' },
  },
  CheckoutSessionResponse: {
    __typename: { __type: 'String!' },
    checkoutUrl: { __type: 'String!' },
  },
  ChooseIncomingMovementDestinationInput: {
    destinationServiceTemplateId: { __type: 'ID!' },
    memberMovementId: { __type: 'ID!' },
    saveAsBrandMapping: { __type: 'Boolean' },
  },
  ClaimGuestPassInput: {
    dateOfBirth: { __type: 'String' },
    email: { __type: 'String!' },
    firstName: { __type: 'String!' },
    lastName: { __type: 'String!' },
    phone: { __type: 'String' },
    policies: { __type: 'String' },
    token: { __type: 'String!' },
  },
  ClaimGuestPassResult: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'ID!' },
    guestPass: { __type: 'GuestPass!' },
    isExisting: { __type: 'Boolean!' },
  },
  ClassPassSettings: {
    __typename: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
    siteIds: { __type: '[String!]!' },
  },
  CleanupOrphanedCarouselGroupsResult: {
    __typename: { __type: 'String!' },
    deletedCount: { __type: 'Float!' },
  },
  ClearGrowHqAuthentication: { __typename: { __type: 'String!' }, success: { __type: 'Boolean!' } },
  Client: {
    __typename: { __type: 'String!' },
    activePackagesCount: { __type: 'Float' },
    address: { __type: 'ClientAddress' },
    alerts: { __type: '[ClientAlert!]!' },
    attendanceCount: { __type: 'Float!' },
    barcode: { __type: 'String' },
    billingEmail: { __type: 'String' },
    blockReason: { __type: 'String' },
    buddies: { __type: '[Client!]!' },
    clientSiteStatus: { __type: 'String' },
    clientType: { __type: 'ClientType' },
    communicationPreferences: { __type: 'ClientCommunicationPreferences' },
    companyName: { __type: 'String' },
    corporateId: { __type: 'String' },
    createdAt: { __type: 'String!' },
    customProperties: { __type: '[CustomPropertyWithClientValue!]' },
    customerId: { __type: 'String' },
    dateOfBirth: { __type: 'String' },
    doorCredential: { __type: 'ClientDoorCredential' },
    email: { __type: 'String' },
    emergencyContact: { __type: 'ClientEmergencyContact' },
    favoriteSiteIds: { __type: '[String!]' },
    firebaseId: { __type: 'String' },
    firstName: { __type: 'String' },
    fobNumber: { __type: 'String' },
    gender: { __type: 'String' },
    homeLocationIds: { __type: '[String!]' },
    homePhoneNumber: { __type: 'String' },
    homeSiteId: { __type: 'String' },
    homeSiteName: { __type: 'String' },
    id: { __type: 'String!' },
    introOffersClaimed: { __type: '[ClientIntroOffersClaimed!]!' },
    isProspect: { __type: 'Boolean' },
    isSuspended: { __type: 'Boolean' },
    joinDate: { __type: 'String' },
    lastBooking: { __type: 'String' },
    lastName: { __type: 'String' },
    lastVisit: { __type: 'String' },
    locationStatuses: { __type: '[ClientLocationStatus!]!' },
    membershipStatus: { __type: 'String!' },
    mobilePhoneNumber: { __type: 'String' },
    name: { __type: 'String!' },
    notes: { __type: '[ClientNoteSite!]!' },
    occupation: { __type: 'String' },
    pendingAgreements: { __type: '[PendingAgreement!]!' },
    pendingForms: { __type: '[MemberPendingForm!]!', __args: { siteId: 'String' } },
    pendingPolicies: { __type: '[PendingPolicy!]!' },
    profile: { __type: 'String' },
    profileImage: {
      __type: 'ImagePublicSignedUrl',
      __args: { input: 'ImagePublicSignedUrlInput!' },
    },
    recentSiteId: { __type: 'String' },
    relations: { __type: '[ClientFamily!]!' },
    siteId: { __type: 'String' },
    siteInformation: { __type: '[ClientSiteInfo!]!' },
    siteRelationships: { __type: '[ClientSiteRelationship!]!' },
    smartGroups: { __type: '[StaffUserSmartGroup!]!' },
    source: { __type: 'ClientSource' },
    taxIdentifier: { __type: 'String' },
    totalCheckInCount: { __type: 'Float!' },
    updatedAt: { __type: 'String!' },
  },
  ClientActivityFeedCheckIn: {
    __typename: { __type: 'String!' },
    checkInId: { __type: 'String!' },
    dateTime: { __type: 'String!' },
    doorName: { __type: 'String' },
    type: { __type: 'CheckInType!' },
    zoneName: { __type: 'String' },
  },
  ClientActivityFeedItem: {
    __typename: { __type: 'String!' },
    activity: { __type: 'ActivityStreamItemActivity' },
    booking: { __type: 'ActivityStreamItemBooking' },
    checkIn: { __type: 'ClientActivityFeedCheckIn' },
    kind: { __type: 'ClientActivityFeedKind!' },
    session: { __type: 'ActivityStreamItemSession' },
  },
  ClientActivityFeedPaginationResult: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'ClientBookingsPageInfo!' },
    results: { __type: '[ClientActivityFeedResultItem!]!' },
  },
  ClientActivityFeedResultItem: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'ClientActivityFeedItem!' },
  },
  ClientActivityStreamPaginatedOrderByInput: {
    column: { __type: 'ActivityStreamOrderByColumn!' },
    direction: { __type: 'OrderByDirection!' },
  },
  ClientAddress: {
    __typename: { __type: 'String!' },
    city: { __type: 'String' },
    country: { __type: 'String' },
    state: { __type: 'String' },
    streetAddress: { __type: 'String' },
    streetNumber: { __type: 'String' },
    unit: { __type: 'String' },
    zipCode: { __type: 'String' },
  },
  ClientAdmin: {
    __typename: { __type: 'String!' },
    activePackagesCount: { __type: 'Float' },
    address: { __type: 'ClientAddress' },
    alerts: { __type: '[ClientAlert!]' },
    attendanceCount: { __type: 'Float!' },
    barcode: { __type: 'String' },
    billingEmail: { __type: 'String' },
    clientId: { __type: 'String!' },
    clientType: { __type: 'ClientType' },
    communicationPreferences: { __type: 'ClientCommunicationPreferences' },
    companyName: { __type: 'String' },
    corporateId: { __type: 'String' },
    createdAt: { __type: 'String!' },
    customerId: { __type: 'String' },
    dateOfBirth: { __type: 'String' },
    email: { __type: 'String' },
    emergencyContact: { __type: 'ClientEmergencyContact' },
    favoriteSiteIds: { __type: '[String!]' },
    firebaseId: { __type: 'String' },
    firstName: { __type: 'String!' },
    fobNumber: { __type: 'String' },
    gender: { __type: 'String' },
    homeLocationIds: { __type: '[String!]' },
    homePhoneNumber: { __type: 'String' },
    homeSiteId: { __type: 'String' },
    homeSiteName: { __type: 'String' },
    id: { __type: 'String' },
    introOffersClaimed: { __type: '[ClientIntroOffersClaimed!]' },
    isProspect: { __type: 'Boolean' },
    joinDate: { __type: 'String!' },
    lastBooking: { __type: 'String' },
    lastName: { __type: 'String!' },
    lastVisit: { __type: 'String' },
    membershipStatus: { __type: 'String' },
    mobilePhoneNumber: { __type: 'String' },
    name: { __type: 'String' },
    notes: { __type: '[String!]' },
    occupation: { __type: 'String' },
    profile: { __type: 'String' },
    recentSiteId: { __type: 'String' },
    siteRelationships: { __type: '[ClientSiteRelationship!]' },
    smartGroups: { __type: '[StaffUserSmartGroup!]' },
    source: { __type: 'ClientSource' },
    taxIdentifier: { __type: 'String' },
    updatedAt: { __type: 'String!' },
  },
  ClientAgeVerification: {
    __typename: { __type: 'String!' },
    ageVerificationMethod: { __type: 'AgeVerificationMethod' },
    ageVerifiedAt: { __type: 'String' },
    ageVerifiedByStaffUserId: { __type: 'ID' },
    capacityMismatchAgreementIds: { __type: '[ID!]!' },
    clientId: { __type: 'ID!' },
    dateOfBirth: { __type: 'String' },
  },
  ClientAgreement: {
    __typename: { __type: 'String!' },
    agreementContent: { __type: 'String!' },
    agreementId: { __type: 'ID!' },
    agreementMethod: { __type: 'AgreementMethod' },
    agreementName: { __type: 'String!' },
    agreementVersion: { __type: 'String!' },
    clientId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    expiresAt: { __type: 'String' },
    ipAddress: { __type: 'String' },
    linkedInvoiceId: { __type: 'ID' },
    nativeSignatureUrls: { __type: '[String!]' },
    publicAccessLinkId: { __type: 'ID' },
    renderedContent: { __type: 'String' },
    sentAt: { __type: 'String' },
    sentByStaffUserId: { __type: 'ID' },
    serviceId: { __type: 'ID' },
    signatureImageUrls: { __type: '[String!]' },
    signatureOnly: { __type: 'Boolean' },
    signedAt: { __type: 'String' },
    signedPdfGcsUri: { __type: 'String' },
    signedPdfSha256: { __type: 'String' },
    signedViewLinkId: { __type: 'ID' },
    siteAgreementTemplateId: { __type: 'ID' },
    siteId: { __type: 'ID!' },
    status: { __type: 'AgreementStatus!' },
    terminalHandoffRequestId: { __type: 'ID' },
    type: { __type: 'AgreementType!' },
    userAgent: { __type: 'String' },
    voidReason: { __type: 'String' },
    voidedAt: { __type: 'String' },
    voidedByStaffUserId: { __type: 'ID' },
  },
  ClientAgreementsWithPagination: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'ClientAgreementsWithPaginationPageInfo!' },
    results: { __type: '[ClientAgreementsWithPaginationResults!]!' },
  },
  ClientAgreementsWithPaginationFiltersInput: {
    status: { __type: 'ClientAgreementsWithPaginationFiltersStatusInput' },
  },
  ClientAgreementsWithPaginationFiltersStatusInput: { value: { __type: 'AgreementStatus!' } },
  ClientAgreementsWithPaginationPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  ClientAgreementsWithPaginationResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'ClientAgreement!' },
  },
  ClientAlert: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'String!' },
    data: { __type: 'ClientAlertData' },
    requiresFetch: { __type: 'Boolean!' },
    type: { __type: 'String!' },
  },
  ClientAlertData: {
    __typename: { __type: 'String!' },
    address: { __type: 'String' },
    alertId: { __type: 'String' },
    count: { __type: 'Float' },
    dateOfBirth: { __type: 'String' },
    description: { __type: 'String' },
    endDate: { __type: 'String' },
    failed: { __type: 'Float' },
    homeSiteName: { __type: 'String' },
    isSuspended: { __type: 'Boolean' },
    items: { __type: '[ClientAlertItem!]' },
    notes: { __type: 'Float' },
    outstanding: { __type: 'Float' },
    properties: { __type: 'Float' },
    startDate: { __type: 'String' },
    title: { __type: 'String' },
  },
  ClientAlertItem: {
    __typename: { __type: 'String!' },
    alertId: { __type: 'String' },
    description: { __type: 'String' },
    endDate: { __type: 'String' },
    startDate: { __type: 'String' },
    title: { __type: 'String' },
  },
  ClientAttendanceStats: {
    __typename: { __type: 'String!' },
    attendedLast30Days: { __type: 'Float!' },
    lastAttendanceDate: { __type: 'String' },
    monthlyAttendance: { __type: '[MonthlyAttendance!]!' },
    noShowCount: { __type: 'Float!' },
    siteJoinDate: { __type: 'String' },
    totalAttendedCount: { __type: 'Float!' },
    upcomingCount: { __type: 'Float!' },
  },
  ClientBookedSession: {
    __typename: { __type: 'String!' },
    booking: { __type: 'ClientBookedSessionBooking!' },
    invoice: { __type: 'ClientBookingInvoice' },
    packagesUsed: { __type: '[String!]' },
    session: { __type: 'ClientBookingSession!' },
    tanning: { __type: 'ClientBookingTanning' },
  },
  ClientBookedSessionBooking: {
    __typename: { __type: 'String!' },
    aggregatorProviderDisplayName: { __type: 'String' },
    aggregatorProviderId: { __type: 'String' },
    bookedBy: { __type: 'ClientBookedSessionBookingBookedBy!' },
    bookedByClientId: { __type: 'ID' },
    bookingId: { __type: 'ID!' },
    bookingSource: { __type: 'BookingSource' },
    cancelledAt: { __type: 'String' },
    cancelledByName: { __type: 'ClientBookedSessionBookingCancelledByName' },
    invitedByStaffUserId: { __type: 'ID' },
    isImportedVisit: { __type: 'Boolean' },
    paymentStatus: { __type: 'BookingPaymentStatus' },
    sharedCreditOwnerClientId: { __type: 'ID' },
    spotId: { __type: 'Float' },
    status: { __type: 'BookingStatus!' },
    waitlistPosition: { __type: 'Float' },
  },
  ClientBookedSessionBookingBookedBy: {
    __typename: { __type: 'String!' },
    firstName: { __type: 'String!' },
    lastName: { __type: 'String!' },
  },
  ClientBookedSessionBookingCancelledByName: {
    __typename: { __type: 'String!' },
    firstName: { __type: 'String!' },
    lastName: { __type: 'String!' },
  },
  ClientBookingBuddy: {
    __typename: { __type: 'String!' },
    acceptedAt: { __type: 'String' },
    buddyClientId: { __type: 'String!' },
    clientId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    initiatedBy: { __type: 'String!' },
    invitedAt: { __type: 'String!' },
    revokedAt: { __type: 'String' },
    revokedBy: { __type: 'String' },
    status: { __type: 'ClientBookingBuddyStatus!' },
    updatedAt: { __type: 'String!' },
  },
  ClientBookingInstructor: {
    __typename: { __type: 'String!' },
    firstName: { __type: 'String!' },
    lastName: { __type: 'String!' },
    profileImageUrl: { __type: 'String' },
    staffUserId: { __type: 'String' },
  },
  ClientBookingInvoice: {
    __typename: { __type: 'String!' },
    fullyPaidDate: { __type: 'String' },
    invoiceId: { __type: 'String!' },
    paidBy: { __type: 'ClientBookingInvoicePaidBy' },
    staffUserId: { __type: 'String' },
    status: { __type: 'String!' },
  },
  ClientBookingInvoicePaidBy: {
    __typename: { __type: 'String!' },
    firstName: { __type: 'String!' },
    lastName: { __type: 'String!' },
  },
  ClientBookingPackage: {
    __typename: { __type: 'String!' },
    canceledAt: { __type: 'String' },
    creditDetails: { __type: '[ClientBookingPackageCreditDetails!]!' },
    creditsRemaining: { __type: 'Float!' },
    expiryDate: { __type: 'String' },
    packageAgreementAccepted: { __type: 'Boolean!' },
    packageCategory: { __type: 'String' },
    packageId: { __type: 'String!' },
    packageName: { __type: 'String!' },
    packageStatus: { __type: 'String!' },
    packageSubscriptionId: { __type: 'String!' },
    suspensionPeriod: { __type: '[ClientBookingPackageSuspensionPeriod!]!' },
  },
  ClientBookingPackageCreditDetails: {
    __typename: { __type: 'String!' },
    endDate: { __type: 'String!' },
    startDate: { __type: 'String!' },
    totalCreditsRemaining: { __type: 'Float!' },
  },
  ClientBookingPackageSuspensionPeriod: {
    __typename: { __type: 'String!' },
    endDate: { __type: 'String!' },
    startDate: { __type: 'String!' },
  },
  ClientBookingResult: {
    __typename: { __type: 'String!' },
    bookingId: { __type: 'ID' },
    clientId: { __type: 'ID!' },
    error: { __type: 'String' },
    outcome: { __type: 'MultipleReservationOutcome!' },
    success: { __type: 'Boolean!' },
    waitlistEntryId: { __type: 'ID' },
  },
  ClientBookingResultItem: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'ClientBookedSession!' },
  },
  ClientBookingRoom: {
    __typename: { __type: 'String!' },
    name: { __type: 'String!' },
    roomId: { __type: 'String!' },
    roomResourceTemplateId: { __type: 'String' },
  },
  ClientBookingSession: {
    __typename: { __type: 'String!' },
    category: { __type: 'SessionCategory!' },
    creditsRequired: { __type: 'Float' },
    customCancelPolicy: { __type: 'SessionTemplateCustomCancelPolicy' },
    dropinPrice: { __type: 'Float' },
    endTime: { __type: 'String!' },
    instructors: { __type: '[ClientBookingInstructor!]!' },
    isRequiredSessionFeedback: { __type: 'Boolean' },
    name: { __type: 'String!' },
    room: { __type: 'ClientBookingRoom' },
    sessionId: { __type: 'String!' },
    sessionImage: { __type: 'String' },
    sessionTemplateId: { __type: 'String' },
    site: { __type: 'ClientBookingSite' },
    siteId: { __type: 'String!' },
    siteLocationId: { __type: 'String!' },
    siteLocationRoomId: { __type: 'String' },
    startTime: { __type: 'String!' },
    zoomJoinUrl: { __type: 'String' },
  },
  ClientBookingSite: {
    __typename: { __type: 'String!' },
    name: { __type: 'String!' },
    timezone: { __type: 'String!' },
  },
  ClientBookingTanning: {
    __typename: { __type: 'String!' },
    addOnInvoiceId: { __type: 'String' },
    cancelledAt: { __type: 'String' },
    checkInId: { __type: 'String' },
    doneAt: { __type: 'String' },
    equipmentAssignmentId: { __type: 'String!' },
    equipmentCategory: { __type: 'EquipmentCategory!' },
    equipmentName: { __type: 'String!' },
    nonUvCategory: { __type: 'NonUvCategory' },
    siteSessionTypeName: { __type: 'String' },
    timerMinutes: { __type: 'Float!' },
  },
  ClientBookingsPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Float!' },
  },
  ClientBookingsPaginatedOrderByInput: {
    column: { __type: 'ClientBookingOrderByColumn!' },
    direction: { __type: 'OrderByDirection!' },
  },
  ClientBookingsPaginationResult: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'ClientBookingsPageInfo!' },
    results: { __type: '[ClientBookingResultItem!]!' },
  },
  ClientCommunicationPreferences: {
    __typename: { __type: 'String!' },
    email: { __type: 'Boolean' },
    notifications: { __type: 'Boolean' },
    phone: { __type: 'Boolean' },
    sms: { __type: 'Boolean' },
  },
  ClientContactLog: {
    __typename: { __type: 'String!' },
    bouncedAt: { __type: 'String' },
    channel: { __type: 'String!' },
    communicationsLogId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    failureReason: { __type: 'String' },
    renderedContent: { __type: 'String' },
    renderedSubject: { __type: 'String' },
    sentAt: { __type: 'String' },
    status: { __type: 'String' },
  },
  ClientContactLogs: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'ClientContactLogsPageInfo!' },
    results: { __type: '[ClientContactLogsResults!]!' },
  },
  ClientContactLogsFiltersChannelInput: { value: { __type: 'String!' } },
  ClientContactLogsFiltersInput: {
    channel: { __type: 'ClientContactLogsFiltersChannelInput' },
    sentAt: { __type: 'ClientContactLogsFiltersSentAtInput' },
  },
  ClientContactLogsFiltersSentAtInput: { value: { __type: '[String!]!' } },
  ClientContactLogsPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  ClientContactLogsResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'ClientContactLog!' },
  },
  ClientCustomAlert: {
    __typename: { __type: 'String!' },
    alertId: { __type: 'String!' },
    clientId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'String!' },
    createdByName: { __type: 'String' },
    description: { __type: 'String' },
    endDate: { __type: 'String' },
    siteId: { __type: 'String!' },
    startDate: { __type: 'String' },
    title: { __type: 'String!' },
    updatedAt: { __type: 'String!' },
  },
  ClientCustomAlertMutationResponse: {
    __typename: { __type: 'String!' },
    alert: { __type: 'ClientCustomAlert' },
    message: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  ClientCustomAlertsResponse: {
    __typename: { __type: 'String!' },
    alerts: { __type: '[ClientCustomAlert!]!' },
  },
  ClientCustomPropertyValue: {
    __typename: { __type: 'String!' },
    changedBy: { __type: 'String' },
    changedByType: { __type: 'CustomPropertyChangedByType' },
    clientId: { __type: 'String!' },
    customPropertyValueId: { __type: 'String!' },
    siteCustomPropertyId: { __type: 'String!' },
    siteId: { __type: 'String!' },
    updatedAt: { __type: 'String!' },
    value: { __type: 'String' },
    version: { __type: 'Float' },
  },
  ClientCustomPropertyValueHistoryEntry: {
    __typename: { __type: 'String!' },
    changedAt: { __type: 'String!' },
    changedByType: { __type: 'CustomPropertyChangedByType!' },
    historyId: { __type: 'String!' },
    sourceFormSubmissionId: { __type: 'String' },
    value: { __type: 'String' },
  },
  ClientCustomPropertyValueHistoryPage: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    entries: { __type: '[ClientCustomPropertyValueHistoryEntry!]!' },
    hasNextPage: { __type: 'Boolean!' },
  },
  ClientCustomPropertyValuesResponse: {
    __typename: { __type: 'String!' },
    lockedSiteCustomPropertyIds: { __type: '[String!]!' },
    values: { __type: '[ClientCustomPropertyValue!]!' },
    withheldSiteCustomPropertyIds: { __type: '[String!]!' },
  },
  ClientDoorCredential: { __typename: { __type: 'String!' }, serial: { __type: 'String' } },
  ClientEmailStatus: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'ID' },
    email: { __type: 'String' },
    exists: { __type: 'Boolean!' },
    firstName: { __type: 'String' },
    homeSiteName: { __type: 'String' },
    lastName: { __type: 'String' },
  },
  ClientEmergencyContact: {
    __typename: { __type: 'String!' },
    address: { __type: 'ClientEmergencyContactAddress' },
    email: { __type: 'String' },
    name: { __type: 'String' },
    phone: { __type: 'String' },
    relationship: { __type: 'String' },
  },
  ClientEmergencyContactAddress: {
    __typename: { __type: 'String!' },
    city: { __type: 'String' },
    country: { __type: 'String' },
    state: { __type: 'String' },
    street: { __type: 'String' },
    streetNumber: { __type: 'String' },
    unit: { __type: 'String' },
    zipCode: { __type: 'String' },
  },
  ClientFamily: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    email: { __type: 'String' },
    familyMemberClientId: { __type: 'String!' },
    isPrimaryAccountHolder: { __type: 'Boolean!' },
    linkedClientId: { __type: 'String' },
    name: { __type: 'String!' },
    relationship: { __type: 'ClientFamilyRelationship!' },
    relationshipInverse: { __type: 'ClientFamilyRelationship!' },
    updatedAt: { __type: 'String!' },
  },
  ClientFavoriteInstructor: {
    __typename: { __type: 'String!' },
    instructorId: { __type: 'String!' },
  },
  ClientFeesTemplate: {
    __typename: { __type: 'String!' },
    clientFeesTemplateId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    fees: { __type: '[HapanaFeesTemplateFees!]!' },
    name: { __type: 'String!' },
    sites: { __type: '[Site!]!' },
    updatedAt: { __type: 'String!' },
  },
  ClientFeesTemplatesPageInfo: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'HapanaFeesTemplatesBasePageInfo!' },
    results: { __type: '[ClientFeesTemplate!]!' },
  },
  ClientFile: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'String!' },
    createdAt: { __type: 'String' },
    fileId: { __type: 'String!' },
    fileJSON: { __type: 'ClientFileFileJSON!' },
    fileName: { __type: 'String!' },
    fileType: { __type: 'String!' },
    siteId: { __type: 'String!' },
    uploadedAt: { __type: 'String!' },
    url: { __type: 'String!' },
  },
  ClientFileFileJSON: {
    __typename: { __type: 'String!' },
    lastFailure: { __type: 'ClientFileFileJSONLastFailure' },
    pending: { __type: 'ClientFileFileJSONPending' },
    status: { __type: 'FileUploadConfigFieldStatus!' },
    versions: { __type: '[DocumentFileVersion!]' },
  },
  ClientFileFileJSONLastFailure: {
    __typename: { __type: 'String!' },
    errorMessage: { __type: 'String!' },
    failedAt: { __type: 'String!' },
    tempUrl: { __type: 'String!' },
    uploadRequestedBy: { __type: 'ID!' },
  },
  ClientFileFileJSONPending: {
    __typename: { __type: 'String!' },
    status: { __type: 'FileUploadConfigFieldPendingStatus!' },
    tempUrl: { __type: 'String!' },
    uploadRequestedAt: { __type: 'String!' },
    uploadRequestedBy: { __type: 'ID!' },
  },
  ClientFileUrl: { __typename: { __type: 'String!' }, url: { __type: 'String!' } },
  ClientFilesWithPagination: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'ClientFilesWithPaginationPageInfo!' },
    results: { __type: '[ClientFilesWithPaginationResults!]!' },
  },
  ClientFilesWithPaginationFiltersFileTypeInput: { value: { __type: 'String!' } },
  ClientFilesWithPaginationFiltersInput: {
    fileType: { __type: 'ClientFilesWithPaginationFiltersFileTypeInput' },
  },
  ClientFilesWithPaginationPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  ClientFilesWithPaginationResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'ClientFile!' },
  },
  ClientFilters: {
    ageRange: { __type: 'ClientFiltersAgeRangeInput' },
    attendanceMilestone: { __type: 'ClientFiltersNoShowLateCancelAccrualInput' },
    birthMonth: { __type: 'ClientFiltersGenderInput' },
    clientStatus: { __type: 'ClientFiltersGenderInput' },
    contractStatus: { __type: 'ClientFiltersGenderInput' },
    contractType: { __type: 'ClientFiltersGenderInput' },
    daysAbsent: { __type: 'ClientFiltersAgeRangeInput' },
    daysInactive: { __type: 'ClientFiltersAgeRangeInput' },
    email: { __type: 'ClientFiltersFirstNameInput' },
    emailOptIn: { __type: 'ClientFiltersGenderInput' },
    failedPaymentsCount: { __type: 'ClientFiltersNoShowLateCancelAccrualInput' },
    firstName: { __type: 'ClientFiltersFirstNameInput' },
    fullName: { __type: 'ClientFiltersFirstNameInput' },
    gender: { __type: 'ClientFiltersGenderInput' },
    hasCreditsForSessionType: { __type: 'ClientFiltersHasCreditsForSessionTypeInput' },
    isSuspended: { __type: 'ClientFiltersGenderInput' },
    joinDate: { __type: 'ClientFiltersJoinDateInput' },
    lastAttendanceDate: { __type: 'ClientFiltersJoinDateInput' },
    lastName: { __type: 'ClientFiltersFirstNameInput' },
    lastPaymentDate: { __type: 'ClientFiltersJoinDateInput' },
    lastVisitDate: { __type: 'ClientFiltersJoinDateInput' },
    locationStatus: { __type: 'ClientFiltersGenderInput' },
    masterUnsubscribe: { __type: 'ClientFiltersGenderInput' },
    noShowLateCancelAccrual: { __type: 'ClientFiltersNoShowLateCancelAccrualInput' },
    phone: { __type: 'ClientFiltersFirstNameInput' },
    profileCreatedDate: { __type: 'ClientFiltersJoinDateInput' },
    sessionFrequency: { __type: 'ClientFiltersGenderInput' },
    smsOptIn: { __type: 'ClientFiltersGenderInput' },
  },
  ClientFiltersAgeRangeInput: {
    logicalOperator: { __type: 'LogicalOperator!' },
    orderIndex: { __type: 'Float' },
    using: { __type: '[ClientFiltersAgeRangeUsingInput!]!' },
  },
  ClientFiltersAgeRangeUsingInput: {
    max: { __type: 'String' },
    min: { __type: 'String' },
    operator: { __type: 'NumericToDateFilterOperator!' },
    value: { __type: 'String' },
  },
  ClientFiltersFirstNameInput: {
    logicalOperator: { __type: 'LogicalOperator!' },
    orderIndex: { __type: 'Float' },
    using: { __type: '[ClientFiltersFirstNameUsingInput!]!' },
  },
  ClientFiltersFirstNameUsingInput: {
    operator: { __type: 'TextFilterOperator!' },
    value: { __type: 'String!' },
  },
  ClientFiltersGenderInput: {
    logicalOperator: { __type: 'LogicalOperator!' },
    orderIndex: { __type: 'Float' },
    using: { __type: '[ClientFiltersGenderUsingInput!]!' },
  },
  ClientFiltersGenderUsingInput: {
    operator: { __type: 'SelectFilterOperator!' },
    value: { __type: '[String!]!' },
  },
  ClientFiltersHasCreditsForSessionTypeInput: {
    bookingDate: { __type: 'String' },
    siteSessionTypeId: { __type: 'ID!' },
  },
  ClientFiltersJoinDateInput: {
    logicalOperator: { __type: 'LogicalOperator!' },
    orderIndex: { __type: 'Float' },
    using: { __type: '[ClientFiltersJoinDateUsingInput!]!' },
  },
  ClientFiltersJoinDateUsingInput: {
    from: { __type: 'String' },
    operator: { __type: 'DateFilterOperator!' },
    to: { __type: 'String' },
    value: { __type: 'String' },
  },
  ClientFiltersNoShowLateCancelAccrualInput: {
    logicalOperator: { __type: 'LogicalOperator!' },
    orderIndex: { __type: 'Float' },
    using: { __type: '[ClientFiltersNoShowLateCancelAccrualUsingInput!]!' },
  },
  ClientFiltersNoShowLateCancelAccrualUsingInput: {
    max: { __type: 'Float' },
    min: { __type: 'Float' },
    operator: { __type: 'NumericFilterOperator!' },
    value: { __type: 'Float' },
  },
  ClientFormAnswer: {
    __typename: { __type: 'String!' },
    answer: { __type: 'String!' },
    answeredAt: { __type: 'String!' },
    formSubmissionId: { __type: 'String!' },
    siteFormQuestionId: { __type: 'String!' },
  },
  ClientFormResult: {
    __typename: { __type: 'String!' },
    assessedAt: { __type: 'String' },
    clientId: { __type: 'String!' },
    completedAt: { __type: 'String' },
    completedVia: { __type: 'FormCompletedVia' },
    completionSequence: { __type: 'Float' },
    formSubmissionId: { __type: 'String!' },
    resultBandId: { __type: 'String' },
    resultBandIndex: { __type: 'Float' },
    resultDescription: { __type: 'String' },
    resultLabel: { __type: 'String' },
    resultSource: { __type: 'FormExternalResultSource' },
    siteFormId: { __type: 'String!' },
    siteId: { __type: 'String!' },
    totalScore: { __type: 'Float' },
  },
  ClientFormSubmission: {
    __typename: { __type: 'String!' },
    answers: { __type: '[ClientFormAnswer!]' },
    assignedAt: { __type: 'String!' },
    assignedBy: { __type: 'String' },
    cancellationReason: { __type: 'String' },
    cancelledAt: { __type: 'String' },
    clientId: { __type: 'String!' },
    completedAt: { __type: 'String' },
    completedDeviceTokenId: { __type: 'String' },
    completedVia: { __type: 'FormCompletedVia' },
    formName: { __type: 'String!' },
    formSnapshot: { __type: 'JSON' },
    formSubmissionId: { __type: 'String!' },
    handoffId: { __type: 'String' },
    isCurrentResult: { __type: 'Boolean' },
    purgeReason: { __type: 'String' },
    purgedAt: { __type: 'String' },
    requiredBefore: { __type: 'FormRequiredBefore' },
    resultBandId: { __type: 'String' },
    resultBandIndex: { __type: 'Float' },
    resultLabel: { __type: 'String' },
    scoringSnapshot: { __type: 'JSON' },
    siteFormId: { __type: 'String!' },
    siteId: { __type: 'String!' },
    status: { __type: 'FormSubmissionStatus!' },
    supersededAt: { __type: 'String' },
    totalScore: { __type: 'Float' },
  },
  ClientFormSubmissionWithClient: {
    __typename: { __type: 'String!' },
    answers: { __type: '[ClientFormAnswer!]!' },
    assignedAt: { __type: 'String!' },
    assignedBy: { __type: 'String' },
    cancellationReason: { __type: 'String' },
    cancelledAt: { __type: 'String' },
    clientId: { __type: 'String!' },
    completedAt: { __type: 'String' },
    completedDeviceTokenId: { __type: 'String' },
    completedVia: { __type: 'FormCompletedVia' },
    formSnapshot: { __type: 'JSON' },
    formSubmissionId: { __type: 'String!' },
    handoffId: { __type: 'String' },
    isCurrentResult: { __type: 'Boolean' },
    purgeReason: { __type: 'String' },
    purgedAt: { __type: 'String' },
    requiredBefore: { __type: 'FormRequiredBefore' },
    resultBandId: { __type: 'String' },
    resultBandIndex: { __type: 'Float' },
    resultLabel: { __type: 'String' },
    scoringSnapshot: { __type: 'JSON' },
    siteFormId: { __type: 'String!' },
    siteId: { __type: 'String!' },
    status: { __type: 'FormSubmissionStatus!' },
    supersededAt: { __type: 'String' },
    totalScore: { __type: 'Float' },
  },
  ClientFormSubmissionsResponse: {
    __typename: { __type: 'String!' },
    submissions: { __type: '[ClientFormSubmission!]!' },
  },
  ClientFormSubmissionsWithPagination: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'ClientFormSubmissionsWithPaginationPageInfo!' },
    results: { __type: '[ClientFormSubmissionsWithPaginationResults!]!' },
  },
  ClientFormSubmissionsWithPaginationFiltersInput: {
    status: { __type: 'ClientFormSubmissionsWithPaginationFiltersStatusInput' },
  },
  ClientFormSubmissionsWithPaginationFiltersStatusInput: { value: { __type: 'String!' } },
  ClientFormSubmissionsWithPaginationPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  ClientFormSubmissionsWithPaginationResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'ClientFormSubmission!' },
  },
  ClientGrowLocationsSummary: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'String!' },
    locations: { __type: '[GrowClientLocation!]!' },
  },
  ClientGrowStatus: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'String!' },
    locations: { __type: '[GrowContactLocationStatus!]!' },
    overallStatus: { __type: 'ClientGrowSyncStatus!' },
  },
  ClientGrowStatusSummary: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'String!' },
    status: { __type: 'ClientGrowSyncStatus!' },
  },
  ClientImportResult: {
    __typename: { __type: 'String!' },
    errors: { __type: '[ClientImportResultErrors!]!' },
    failedImports: { __type: 'Float!' },
    successfulImports: { __type: 'Float!' },
    totalRows: { __type: 'Float!' },
  },
  ClientImportResultErrors: {
    __typename: { __type: 'String!' },
    error: { __type: 'String!' },
    row: { __type: 'Float!' },
  },
  ClientIntroOffersClaimed: {
    __typename: { __type: 'String!' },
    claimedAt: { __type: 'String!' },
    offerId: { __type: 'String!' },
    siteId: { __type: 'String' },
    usedAt: { __type: 'String' },
  },
  ClientIpInfo: {
    __typename: { __type: 'String!' },
    ipAddress: { __type: 'String' },
    isPublic: { __type: 'Boolean!' },
  },
  ClientLifetimeSpend: {
    __typename: { __type: 'String!' },
    currency: { __type: 'String!' },
    netSpend: { __type: 'String!' },
  },
  ClientLocationStatus: {
    __typename: { __type: 'String!' },
    siteId: { __type: 'String!' },
    siteName: { __type: 'String' },
    status: { __type: 'String!' },
  },
  ClientNextBilling: {
    __typename: { __type: 'String!' },
    amount: { __type: 'String!' },
    currency: { __type: 'String!' },
    nextInvoiceDate: { __type: 'String!' },
  },
  ClientNote: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'String!' },
    content: { __type: 'String' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'String!' },
    createdByEmail: { __type: 'String' },
    createdByName: { __type: 'String' },
    noteId: { __type: 'String!' },
    siteId: { __type: 'String!' },
  },
  ClientNoteCreateInput: { clientId: { __type: 'String!' }, content: { __type: 'String' } },
  ClientNoteSite: {
    __typename: { __type: 'String!' },
    id: { __type: 'String!' },
    siteId: { __type: 'String!' },
  },
  ClientNoteUpdateInput: { content: { __type: 'String' } },
  ClientNotesResponse: { __typename: { __type: 'String!' }, notes: { __type: '[ClientNote!]!' } },
  ClientPaymentMethod: {
    __typename: { __type: 'String!' },
    bankAccountType: { __type: 'String' },
    bankCode: { __type: 'String' },
    bankFingerprint: { __type: 'String' },
    bankHolderType: { __type: 'String' },
    bankLast4: { __type: 'String' },
    bankName: { __type: 'String' },
    cardBrand: { __type: 'String' },
    cardBrandProduct: { __type: 'String' },
    cardCountry: { __type: 'String' },
    cardExpMonth: { __type: 'String' },
    cardExpYear: { __type: 'String' },
    cardFingerprint: { __type: 'String' },
    cardFunding: { __type: 'CardFunding' },
    cardLast4: { __type: 'String' },
    clientId: { __type: 'ID' },
    clientPaymentMethodId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'ID' },
    deletedAt: { __type: 'String' },
    deletedBy: { __type: 'ID' },
    gatewayCustomerId: { __type: 'String' },
    gatewayPaymentIntentId: { __type: 'String' },
    gatewayPaymentMethodId: { __type: 'String' },
    gatewaySetupIntentId: { __type: 'String' },
    isBackup: { __type: 'Boolean' },
    isDefault: { __type: 'Boolean!' },
    isLive: { __type: 'Boolean!' },
    mandateAcceptedAt: { __type: 'String' },
    mandateAuthorisationAgreementId: { __type: 'ID' },
    mandateId: { __type: 'String' },
    mandateStatus: { __type: 'String' },
    mandateUrl: { __type: 'String' },
    removalEligibility: { __type: 'PaymentMethodRemovalEligibility' },
    siteId: { __type: 'ID!' },
    sitePaymentGatewayId: { __type: 'ID!' },
    sitePaymentGatewayType: { __type: 'SupportedPaymentGateway!' },
    status: { __type: 'ClientPaymentMethodStatus!' },
    type: { __type: 'ClientPaymentMethodType!' },
    updatedAt: { __type: 'String!' },
    wallet: { __type: 'PaymentWallet' },
  },
  ClientPermissions: {
    __typename: { __type: 'String!' },
    canChangePassword: { __type: 'Boolean!' },
    canDelete: { __type: 'Boolean!' },
    canEdit: { __type: 'Boolean!' },
  },
  ClientPolicyCompliance: {
    __typename: { __type: 'String!' },
    ageVerificationMethod: { __type: 'AgeVerificationMethod' },
    ageVerifiedAt: { __type: 'String' },
    categories: { __type: '[EquipmentReadinessView!]!' },
    clientId: { __type: 'ID!' },
    dobVerified: { __type: 'Boolean!' },
    siteId: { __type: 'ID!' },
  },
  ClientProfileSnapshot: {
    __typename: { __type: 'String!' },
    address: { __type: 'String' },
    communicationPreferences: { __type: 'String' },
    customerId: { __type: 'String' },
    dateOfBirth: { __type: 'String' },
    email: { __type: 'String' },
    emergencyContact: { __type: 'String' },
    firstName: { __type: 'String' },
    fobNumber: { __type: 'String' },
    gender: { __type: 'String' },
    homePhoneNumber: { __type: 'String' },
    homeSiteId: { __type: 'String' },
    homeSiteName: { __type: 'String' },
    id: { __type: 'String!' },
    lastName: { __type: 'String' },
    mobilePhoneNumber: { __type: 'String' },
    occupation: { __type: 'String' },
    profileImageJSON: { __type: 'String' },
  },
  ClientRelationMutationResult: {
    __typename: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  ClientRelationView: {
    __typename: { __type: 'String!' },
    allocatedCredits: { __type: 'Float' },
    counterpartyClientId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    email: { __type: 'String' },
    imageUrl: { __type: 'String' },
    isOwner: { __type: 'Boolean' },
    name: { __type: 'String!' },
    phone: { __type: 'String' },
    relationshipSubtype: { __type: 'String' },
    serviceId: { __type: 'ID' },
    status: { __type: 'ClientRelationStatus!' },
    type: { __type: 'ClientRelationViewType!' },
  },
  ClientResult: {
    __typename: { __type: 'String!' },
    client: { __type: 'Client' },
    permissions: { __type: 'ClientPermissions!' },
  },
  ClientService: {
    __typename: { __type: 'String!' },
    activatedStartDate: { __type: 'String' },
    activeSuspension: { __type: 'ClientServiceActiveSuspension' },
    addOns: { __type: '[ClientServiceAddOn!]' },
    autoRenew: { __type: 'Boolean!' },
    billingCycleAmount: { __type: 'Float' },
    billingCycleUnit: { __type: 'String' },
    canceledAt: { __type: 'String' },
    cancellationReason: { __type: 'String' },
    changePlanEnabled: { __type: 'Boolean' },
    clientId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    createdByInvoiceId: { __type: 'ID' },
    createdByInvoiceStatus: { __type: 'String' },
    creditBalanceSnapshot: { __type: 'CreditBalanceSnapshotOutput' },
    currency: { __type: 'String' },
    expiredCreditsAvailableForRollover: { __type: 'Float' },
    expiresAt: { __type: 'String' },
    isAllSharedSites: { __type: 'Boolean' },
    isRefunded: { __type: 'Boolean' },
    lastExecutedPlanChange: { __type: 'ClientServiceLastExecutedPlanChange' },
    latestExtension: { __type: 'ServiceExtensionSummary' },
    minimumHomeUsageInDays: { __type: 'Float' },
    netPrice: { __type: 'Float' },
    nextBillingDate: { __type: 'String' },
    nextInvoiceDate: { __type: 'String' },
    onHold: { __type: 'Boolean!' },
    parentServiceId: { __type: 'String' },
    pendingPaymentPlanChange: { __type: 'ClientServicePendingPaymentPlanChange' },
    price: { __type: 'Float' },
    purchasedAt: { __type: 'String!' },
    recurringInvoices: { __type: '[RecurringInvoice!]!' },
    referredByStaffName: { __type: 'String' },
    scheduledCancellation: { __type: 'ServiceCancellation' },
    scheduledPlanChange: { __type: 'ClientServiceScheduledPlanChange' },
    scheduledSuspension: { __type: 'ClientServiceScheduledSuspension' },
    serviceId: { __type: 'String!' },
    serviceTemplateId: { __type: 'String!' },
    serviceTemplateName: { __type: 'String' },
    serviceTemplateType: { __type: 'String' },
    sharedCredits: { __type: 'ClientServiceSharedCredits' },
    sharedHomeUsageUnlockDate: { __type: 'String' },
    sharedSiteIds: { __type: '[String!]' },
    signedClientAgreementId: { __type: 'String' },
    siteId: { __type: 'String!' },
    startsAt: { __type: 'String!' },
    status: { __type: 'ServiceStatus!' },
    templateCreditSessionTypes: { __type: '[TemplateCreditSessionType!]' },
    updatedAt: { __type: 'String!' },
  },
  ClientServiceActiveSuspension: {
    __typename: { __type: 'String!' },
    endDate: { __type: 'String' },
  },
  ClientServiceAddOn: {
    __typename: { __type: 'String!' },
    amount: { __type: 'Float' },
    canceledAt: { __type: 'String' },
    currency: { __type: 'String' },
    description: { __type: 'String' },
    name: { __type: 'String!' },
    paymentType: { __type: 'ServiceTemplateAddOnPaymentType!' },
    scheduledCancellation: { __type: 'ClientServiceAddOnScheduledCancellation' },
    serviceId: { __type: 'ID!' },
    serviceTemplateId: { __type: 'ID!' },
    startsAt: { __type: 'String!' },
    status: { __type: 'ServiceStatus!' },
  },
  ClientServiceAddOnScheduledCancellation: {
    __typename: { __type: 'String!' },
    cancellationDate: { __type: 'String!' },
    chargeAmount: { __type: 'Numeric' },
    chargeMode: { __type: 'ServiceSuspensionChargeMode' },
    serviceCancellationId: { __type: 'String!' },
  },
  ClientServiceLastExecutedPlanChange: {
    __typename: { __type: 'String!' },
    executedAt: { __type: 'String' },
    fromServiceTemplateName: { __type: 'String' },
    initiatedByStaffName: { __type: 'String' },
    servicePlanChangeId: { __type: 'ID!' },
  },
  ClientServicePendingPaymentPlanChange: {
    __typename: { __type: 'String!' },
    effectiveDate: { __type: 'String!' },
    proratedInvoiceId: { __type: 'ID!' },
    proratedInvoiceStatus: { __type: 'InvoiceStatus!' },
    servicePlanChangeId: { __type: 'ID!' },
    toServiceTemplateId: { __type: 'ID!' },
    toServiceTemplateName: { __type: 'String' },
  },
  ClientServiceScheduledPlanChange: {
    __typename: { __type: 'String!' },
    effectiveDate: { __type: 'String!' },
    servicePlanChangeId: { __type: 'ID!' },
    status: { __type: 'String!' },
    toServiceTemplateId: { __type: 'ID!' },
    toServiceTemplateName: { __type: 'String' },
  },
  ClientServiceScheduledSuspension: {
    __typename: { __type: 'String!' },
    endDate: { __type: 'String' },
    startDate: { __type: 'String!' },
  },
  ClientServiceSharedCredits: {
    __typename: { __type: 'String!' },
    allocatedCredits: { __type: 'Float' },
    consumedCredits: { __type: 'Float' },
    isOwner: { __type: 'Boolean!' },
    maxSharingCredits: { __type: 'Float' },
    ownerClientId: { __type: 'String!' },
    ownerName: { __type: 'String' },
    recipientNames: { __type: '[String!]' },
    remainingCredits: { __type: 'Float' },
  },
  ClientServicesPaginationResult: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'ClientServicesPaginationResultPageInfo!' },
    results: { __type: '[ClientServicesPaginationResultResults!]!' },
  },
  ClientServicesPaginationResultPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  ClientServicesPaginationResultResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'ClientService!' },
  },
  ClientSite: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    creditAccountBalance: { __type: 'String' },
    favoriteInstructorIds: { __type: '[String!]' },
    joinDate: { __type: 'String!' },
    lastAttendanceDate: { __type: 'String' },
    lastBillingDate: { __type: 'String' },
    lastBookingDate: { __type: 'String' },
    siteId: { __type: 'String!' },
    siteSpecificData: { __type: 'ClientSiteRelationshipSiteSpecificData' },
    updatedAt: { __type: 'String!' },
  },
  ClientSiteAssignedStaff: {
    __typename: { __type: 'String!' },
    current: { __type: 'AssignedStaffEntry' },
    previous: { __type: 'AssignedStaffEntry' },
  },
  ClientSiteInfo: {
    __typename: { __type: 'String!' },
    checkInCount: { __type: 'Float!' },
    joinDate: { __type: 'String' },
    lastCheckInOn: { __type: 'String' },
    site: { __type: 'ClientSiteInfoSite!' },
    siteId: { __type: 'String!' },
  },
  ClientSiteInfoSite: { __typename: { __type: 'String!' }, name: { __type: 'String!' } },
  ClientSiteRelationship: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    creditAccountBalance: { __type: 'String' },
    joinDate: { __type: 'String!' },
    lastAttendanceDate: { __type: 'String' },
    lastBillingDate: { __type: 'String' },
    lastBookingDate: { __type: 'String' },
    siteId: { __type: 'String!' },
    siteSpecificData: { __type: 'ClientSiteRelationshipSiteSpecificData' },
    updatedAt: { __type: 'String!' },
  },
  ClientSiteRelationshipSiteSpecificData: {
    __typename: { __type: 'String!' },
    enrollmentSource: { __type: 'String' },
    linkSource: { __type: 'ClientSiteLinkSource' },
    membershipType: { __type: 'String' },
    notes: { __type: 'String' },
    preferences: { __type: 'ClientSiteRelationshipSiteSpecificDataPreferences' },
    useAccountCreditsOnRecurringInvoices: { __type: 'Boolean' },
  },
  ClientSiteRelationshipSiteSpecificDataPreferences: {
    __typename: { __type: 'String!' },
    communications: { __type: 'String' },
    notifications: { __type: 'Boolean' },
  },
  ClientSiteStatsResponse: {
    __typename: { __type: 'String!' },
    totalClients: { __type: 'Float!' },
  },
  ClientSitesResponse: {
    __typename: { __type: 'String!' },
    sites: { __type: '[ClientSitesResponseSites!]!' },
  },
  ClientSitesResponseSites: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    creditAccountBalance: { __type: 'String' },
    favoriteInstructorIds: { __type: '[String!]' },
    joinDate: { __type: 'String!' },
    lastAttendanceDate: { __type: 'String' },
    lastBillingDate: { __type: 'String' },
    lastBookingDate: { __type: 'String' },
    siteId: { __type: 'String!' },
    siteSpecificData: { __type: 'ClientSiteRelationshipSiteSpecificData' },
    updatedAt: { __type: 'String!' },
  },
  ClientStats: {
    __typename: { __type: 'String!' },
    joinDate: { __type: 'String!' },
    statsLast30: { __type: 'Float!' },
    statsLifetime: { __type: 'Float!' },
    statsWeekly: { __type: 'Float!' },
    totalInstructors: { __type: 'Float!' },
    totalLocations: { __type: 'Float!' },
  },
  ClientTab: {
    __typename: { __type: 'String!' },
    count: { __type: 'Float!' },
    description: { __type: 'String' },
    enabled: { __type: 'Boolean!' },
    id: { __type: 'String!' },
    label: { __type: 'String!' },
    name: { __type: 'String!' },
    value: { __type: 'String!' },
  },
  ClientTanningSessionItem: {
    __typename: { __type: 'String!' },
    cancelledAt: { __type: 'String' },
    checkInId: { __type: 'String' },
    clientId: { __type: 'String!' },
    dateTime: { __type: 'String!' },
    doneAt: { __type: 'String' },
    equipmentAssignmentId: { __type: 'String!' },
    equipmentCategory: { __type: 'String!' },
    equipmentId: { __type: 'String!' },
    equipmentName: { __type: 'String!' },
    siteId: { __type: 'String!' },
    siteSessionTypeName: { __type: 'String' },
    source: { __type: 'CheckInSource' },
    status: { __type: 'EquipmentAssignmentStatus!' },
    timerMinutes: { __type: 'Float!' },
  },
  ClientTanningSessionResultItem: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'ClientTanningSessionItem!' },
  },
  ClientTanningSessionsPaginationResult: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'TanningPageInfo!' },
    results: { __type: '[ClientTanningSessionResultItem!]!' },
  },
  ClientTimelineActor: {
    __typename: { __type: 'String!' },
    email: { __type: 'String' },
    id: { __type: 'String' },
    name: { __type: 'String' },
    type: { __type: 'ClientTimelineActorType!' },
  },
  ClientTimelineEvent: {
    __typename: { __type: 'String!' },
    actor: { __type: 'ClientTimelineActor' },
    eventId: { __type: 'String!' },
    eventType: { __type: 'ClientTimelineEventType!' },
    occurredAt: { __type: 'String!' },
    payload: { __type: 'ClientTimelinePayload' },
    source: { __type: 'ClientTimelineSource!' },
  },
  ClientTimelineMetadata: {
    __typename: { __type: 'String!' },
    durationMs: { __type: 'Float!' },
    sourcesSkipped: { __type: '[ClientTimelineSource!]!' },
    sourcesUsed: { __type: '[ClientTimelineSource!]!' },
  },
  ClientTimelinePageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Float!' },
  },
  ClientTimelinePartialData: {
    __typename: { __type: 'String!' },
    generatedAt: { __type: 'String!' },
    isPartial: { __type: 'Boolean!' },
    unavailableSources: { __type: '[ClientTimelineSource!]!' },
  },
  ClientTimelinePayload: {
    __typename: { __type: 'String!' },
    amount: { __type: 'String' },
    bookingId: { __type: 'String' },
    channel: { __type: 'String' },
    communicationId: { __type: 'String' },
    currency: { __type: 'String' },
    invoiceId: { __type: 'String' },
    location: { __type: 'String' },
    messagePreview: { __type: 'String' },
    messageSubject: { __type: 'String' },
    metadataJson: { __type: 'String' },
    noteId: { __type: 'String' },
    notePreview: { __type: 'String' },
    paymentId: { __type: 'String' },
    platform: { __type: 'ClientTimelinePlatform' },
    platformRaw: { __type: 'String' },
    reason: { __type: 'String' },
    sessionId: { __type: 'String' },
    sessionName: { __type: 'String' },
    sessionStartTime: { __type: 'String' },
    status: { __type: 'String' },
    summary: { __type: 'String' },
    waitlistEntryId: { __type: 'String' },
  },
  ClientTimelineResult: {
    __typename: { __type: 'String!' },
    appliedEventTypes: { __type: '[ClientTimelineEventType!]!' },
    availableEventTypes: { __type: '[ClientTimelineEventType!]!' },
    events: { __type: '[ClientTimelineEvent!]!' },
    metadata: { __type: 'ClientTimelineMetadata!' },
    pageInfo: { __type: 'ClientTimelinePageInfo!' },
    partialData: { __type: 'ClientTimelinePartialData!' },
  },
  ClientUpcomingInvoice: {
    __typename: { __type: 'String!' },
    dueDate: { __type: 'String!' },
    invoiceId: { __type: 'String!' },
    pendingChange: { __type: 'PendingChange' },
    recurringInvoiceId: { __type: 'ID' },
    recurringInvoiceStatus: { __type: 'String' },
    status: { __type: 'String!' },
    totalAmount: { __type: 'String!' },
  },
  ClientUpcomingInvoicesResult: {
    __typename: { __type: 'String!' },
    results: { __type: '[ClientUpcomingInvoice!]!' },
  },
  ClientsOrderByInput: {
    column: { __type: 'ClientOrderBy!' },
    direction: { __type: 'OrderByDirection!' },
  },
  ClientsResult: {
    __typename: { __type: 'String!' },
    enabledFilters: { __type: 'EnabledFilters' },
    hasAnyBarcode: { __type: 'Boolean' },
    pageInfo: { __type: 'ClientsResultPageInfo!' },
    permissions: { __type: 'ClientPermissions!' },
    results: { __type: '[ClientsResultResults!]!' },
  },
  ClientsResultPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  ClientsResultResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'Client!' },
  },
  ClosureSessionCancellationResult: {
    __typename: { __type: 'String!' },
    errorCode: { __type: 'String' },
    errorMessage: { __type: 'String' },
    isCancelled: { __type: 'Boolean!' },
    sessionId: { __type: 'String!' },
  },
  CmsAnalyticsDateRangeInput: {
    corporateId: { __type: 'String!' },
    endDate: { __type: 'String!' },
    siteIds: { __type: '[String!]' },
    startDate: { __type: 'String!' },
  },
  CmsAnalyticsSiteInput: { corporateId: { __type: 'String!' }, siteIds: { __type: '[String!]' } },
  CmsCarouselGroup: {
    __typename: { __type: 'String!' },
    carouselGroupId: { __type: 'ID!' },
    corporateId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    name: { __type: 'String!' },
    slug: { __type: 'String!' },
    updatedAt: { __type: 'String!' },
  },
  CmsCatalogCategory: {
    __typename: { __type: 'String!' },
    contentCount: { __type: 'Float!' },
    id: { __type: 'ID!' },
    sortOrder: { __type: 'Float!' },
    subcategories: { __type: '[CmsCatalogCategorySubcategories!]!' },
    tags: { __type: '[String!]!' },
    title: { __type: 'String!' },
  },
  CmsCatalogCategorySubcategories: {
    __typename: { __type: 'String!' },
    contentCount: { __type: 'Float!' },
    description: { __type: 'String' },
    id: { __type: 'String!' },
    image: { __type: 'CmsCatalogCategorySubcategoriesImage' },
    sortOrder: { __type: 'Float!' },
    title: { __type: 'String!' },
  },
  CmsCatalogCategorySubcategoriesImage: {
    __typename: { __type: 'String!' },
    alt: { __type: 'String' },
    url: { __type: 'String!' },
  },
  CmsCatalogResult: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String' },
    hasMore: { __type: 'Boolean!' },
    items: { __type: '[CmsContentEntry!]!' },
    totalCount: { __type: 'Float!' },
  },
  CmsContentEntry: {
    __typename: { __type: 'String!' },
    bodyHtml: { __type: 'String' },
    bodyMarkdown: { __type: 'String' },
    contentEntryId: { __type: 'ID!' },
    contentTypeId: { __type: 'ID!' },
    corporateId: { __type: 'ID!' },
    coverMediaId: { __type: 'ID' },
    createdAt: { __type: 'String!' },
    createdAtLevel: { __type: 'ContentEntryLevel!' },
    createdAtSiteId: { __type: 'ID' },
    createdBy: { __type: 'ID!' },
    createdByName: { __type: 'String' },
    deletedAt: { __type: 'String' },
    excludedRegionIds: { __type: '[ID!]' },
    excludedSiteIds: { __type: '[ID!]' },
    externalSource: { __type: 'String' },
    fields: { __type: 'JSONObject' },
    imageAlt: { __type: 'String' },
    imageMetadata: { __type: 'CmsContentEntryImageMetadata' },
    imageUrl: { __type: 'String' },
    includedRegionIds: { __type: '[ID!]' },
    includedSiteIds: { __type: '[ID!]' },
    instructorIds: { __type: '[ID!]' },
    packageExclusionIds: { __type: '[ID!]' },
    packageExclusionNames: { __type: '[String!]' },
    packageIds: { __type: '[ID!]' },
    packageNames: { __type: '[String!]' },
    publishedAt: { __type: 'String' },
    publishedByName: { __type: 'String' },
    publishedVersionId: { __type: 'ID' },
    slug: { __type: 'String' },
    sortOrder: { __type: 'Float!' },
    status: { __type: 'ContentStatus!' },
    title: { __type: 'String!' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'ID' },
    updatedByName: { __type: 'String' },
    version: { __type: 'Float!' },
    visibilityScope: { __type: 'VisibilityScope!' },
  },
  CmsContentEntryCreateImageMetadataFocalPointInput: {
    x: { __type: 'Float!' },
    y: { __type: 'Float!' },
  },
  CmsContentEntryCreateImageMetadataInput: {
    focalPoint: { __type: 'CmsContentEntryCreateImageMetadataFocalPointInput' },
    format: { __type: 'String' },
    gcsPath: { __type: 'String' },
    height: { __type: 'Float' },
    variants: { __type: 'JSONObject' },
    width: { __type: 'Float' },
  },
  CmsContentEntryCreateInput: {
    bodyHtml: { __type: 'String' },
    bodyMarkdown: { __type: 'String' },
    contentTypeId: { __type: 'ID!' },
    coverMediaId: { __type: 'ID' },
    createdAtLevel: { __type: 'ContentEntryLevel!' },
    createdAtSiteId: { __type: 'ID' },
    excludedRegionIds: { __type: '[ID!]' },
    excludedSiteIds: { __type: '[ID!]' },
    externalSource: { __type: 'String' },
    fields: { __type: 'JSONObject' },
    imageMetadata: { __type: 'CmsContentEntryCreateImageMetadataInput' },
    imageUrl: { __type: 'String' },
    includedRegionIds: { __type: '[ID!]' },
    includedSiteIds: { __type: '[ID!]' },
    instructorIds: { __type: '[ID!]' },
    packageExclusionIds: { __type: '[ID!]' },
    packageExclusionNames: { __type: '[String!]' },
    packageIds: { __type: '[ID!]' },
    packageNames: { __type: '[String!]' },
    sortOrder: { __type: 'Float!' },
    status: { __type: 'ContentStatus!' },
    title: { __type: 'String!' },
    visibilityScope: { __type: 'VisibilityScope!' },
  },
  CmsContentEntryImageMetadata: {
    __typename: { __type: 'String!' },
    focalPoint: { __type: 'CmsContentEntryImageMetadataFocalPoint' },
    format: { __type: 'String' },
    gcsPath: { __type: 'String' },
    height: { __type: 'Float' },
    variants: { __type: 'JSONObject' },
    width: { __type: 'Float' },
  },
  CmsContentEntryImageMetadataFocalPoint: {
    __typename: { __type: 'String!' },
    x: { __type: 'Float!' },
    y: { __type: 'Float!' },
  },
  CmsContentEntryUpdateInput: {
    bodyHtml: { __type: 'String' },
    bodyMarkdown: { __type: 'String' },
    coverMediaId: { __type: 'ID' },
    excludedRegionIds: { __type: '[ID!]' },
    excludedSiteIds: { __type: '[ID!]' },
    fields: { __type: 'JSONObject' },
    imageMetadata: { __type: 'CmsContentEntryCreateImageMetadataInput' },
    imageUrl: { __type: 'String' },
    includedRegionIds: { __type: '[ID!]' },
    includedSiteIds: { __type: '[ID!]' },
    instructorIds: { __type: '[ID!]' },
    packageExclusionIds: { __type: '[ID!]' },
    packageExclusionNames: { __type: '[String!]' },
    packageIds: { __type: '[ID!]' },
    packageNames: { __type: '[String!]' },
    sortOrder: { __type: 'Float' },
    status: { __type: 'ContentStatus' },
    title: { __type: 'String' },
    visibilityScope: { __type: 'VisibilityScope' },
  },
  CmsContentMedia: {
    __typename: { __type: 'String!' },
    blurhash: { __type: 'String' },
    contentMediaId: { __type: 'ID!' },
    corporateId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    createdByStaffUserId: { __type: 'ID!' },
    createdByStaffUserName: { __type: 'String' },
    deletedAt: { __type: 'String' },
    description: { __type: 'String' },
    duration: { __type: 'Float' },
    fileName: { __type: 'String!' },
    fileSize: { __type: 'Float' },
    focalPoint: { __type: 'CmsContentEntryImageMetadataFocalPoint' },
    folder: { __type: 'String' },
    gcsPath: { __type: 'String' },
    height: { __type: 'Float' },
    hlsManifestUrl: { __type: 'String' },
    mimeType: { __type: 'String!' },
    mp4Url: { __type: 'String' },
    processingStatus: { __type: 'String' },
    source: { __type: 'ContentVideoSource' },
    thumbnailUrl: { __type: 'String' },
    title: { __type: 'String' },
    transcoderJobId: { __type: 'String' },
    updatedAt: { __type: 'String' },
    updatedByStaffUserId: { __type: 'ID' },
    updatedByStaffUserName: { __type: 'String' },
    uploadUrl: { __type: 'String' },
    url: { __type: 'String' },
    usageCount: { __type: 'Float' },
    variants: { __type: 'JSONObject' },
    width: { __type: 'Float' },
  },
  CmsContentMediaUpdateInput: {
    blurhash: { __type: 'String' },
    description: { __type: 'String' },
    fileName: { __type: 'String' },
    focalPoint: { __type: 'CmsContentEntryCreateImageMetadataFocalPointInput' },
    folder: { __type: 'String' },
    title: { __type: 'String' },
    variants: { __type: 'JSONObject' },
  },
  CmsContentSchedule: {
    __typename: { __type: 'String!' },
    action: { __type: 'ScheduleAction!' },
    contentEntryId: { __type: 'ID!' },
    contentScheduleId: { __type: 'ID!' },
    contentVersionId: { __type: 'ID' },
    corporateId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'ID!' },
    createdByName: { __type: 'String' },
    executedAt: { __type: 'String' },
    scheduledAt: { __type: 'String!' },
  },
  CmsContentScheduleCreateInput: {
    action: { __type: 'ScheduleAction!' },
    contentEntryId: { __type: 'ID!' },
    contentVersionId: { __type: 'ID' },
    scheduledAt: { __type: 'String!' },
  },
  CmsContentTarget: {
    __typename: { __type: 'String!' },
    contentEntryId: { __type: 'ID!' },
    contentTargetId: { __type: 'ID!' },
    corporateId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    targetId: { __type: 'ID!' },
    targetType: { __type: 'TargetType!' },
  },
  CmsContentTargetCreateInput: {
    targetId: { __type: 'ID!' },
    targetType: { __type: 'TargetType!' },
  },
  CmsContentType: {
    __typename: { __type: 'String!' },
    contentTypeId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    defaultFields: { __type: 'JSONObject' },
    fieldSchema: { __type: 'JSONObject!' },
    groupName: { __type: 'ContentTypeGroup!' },
    iconName: { __type: 'String' },
    isSystem: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    slug: { __type: 'String!' },
    sortOrder: { __type: 'Float!' },
    updatedAt: { __type: 'String!' },
  },
  CmsContentVersion: {
    __typename: { __type: 'String!' },
    bodyHtml: { __type: 'String' },
    bodyMarkdown: { __type: 'String' },
    changeNote: { __type: 'String' },
    contentEntryId: { __type: 'ID!' },
    contentVersionId: { __type: 'ID!' },
    corporateId: { __type: 'ID!' },
    coverMediaId: { __type: 'ID' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'ID!' },
    createdByName: { __type: 'String' },
    excludedRegionIds: { __type: '[ID!]' },
    excludedSiteIds: { __type: '[ID!]' },
    fields: { __type: 'JSONObject' },
    imageMetadata: { __type: 'CmsContentEntryImageMetadata' },
    imageUrl: { __type: 'String' },
    includedRegionIds: { __type: '[ID!]' },
    includedSiteIds: { __type: '[ID!]' },
    instructorIds: { __type: '[ID!]' },
    packageExclusionIds: { __type: '[ID!]' },
    packageExclusionNames: { __type: '[String!]' },
    packageIds: { __type: '[ID!]' },
    packageNames: { __type: '[String!]' },
    sortOrder: { __type: 'Float' },
    title: { __type: 'String!' },
    versionNumber: { __type: 'Float!' },
    visibilityScope: { __type: 'VisibilityScope' },
  },
  CmsGoal: {
    __typename: { __type: 'String!' },
    corporateId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    goalId: { __type: 'ID!' },
    name: { __type: 'String!' },
    sortOrder: { __type: 'Float!' },
    updatedAt: { __type: 'String!' },
  },
  CmsImportContentfulConfig: {
    __typename: { __type: 'String!' },
    configured: { __type: 'Boolean!' },
    spaceId: { __type: 'String' },
  },
  CmsImportContentfulSpace: {
    __typename: { __type: 'String!' },
    id: { __type: 'String!' },
    name: { __type: 'String!' },
  },
  CmsImportJwPlayerSite: {
    __typename: { __type: 'String!' },
    id: { __type: 'String!' },
    name: { __type: 'String!' },
  },
  CmsImportJwPlayerSitesResult: {
    __typename: { __type: 'String!' },
    configured: { __type: 'Boolean!' },
    sites: { __type: '[CmsImportJwPlayerSite!]!' },
  },
  CmsImportLegacyMongoBrand: {
    __typename: { __type: 'String!' },
    challengesV1: { __type: 'Float!' },
    challengesV2: { __type: 'Float!' },
    legacyCorporateId: { __type: 'String!' },
    legacyCorporateName: { __type: 'String' },
  },
  CmsImportLegacyMongoBrandOptions: {
    __typename: { __type: 'String!' },
    brands: { __type: '[CmsImportLegacyMongoBrand!]!' },
    savedLegacyCorporateId: { __type: 'String' },
    suggestedLegacyCorporateId: { __type: 'String' },
  },
  CmsImportOptionsInput: {
    importMode: { __type: 'CmsImportMode' },
    jwPlayerCompressedRendition: { __type: 'Boolean' },
    jwPlayerExcludeDrafts: { __type: 'Boolean' },
    jwPlayerLinkedOnly: { __type: 'Boolean' },
    skipContentfulAssets: { __type: 'Boolean' },
    skipJWPlayer: { __type: 'Boolean' },
    skipMongoDB: { __type: 'Boolean' },
    skipV1Aurora: { __type: 'Boolean' },
    skipV1ChallengeData: { __type: 'Boolean' },
    stepByStep: { __type: 'Boolean' },
  },
  CmsImportRun: {
    __typename: { __type: 'String!' },
    completedAt: { __type: 'String' },
    corporateId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'String!' },
    createdByName: { __type: 'String' },
    importMode: { __type: 'CmsImportMode!' },
    importRunId: { __type: 'String!' },
    rolledBackAt: { __type: 'String' },
    sources: { __type: 'JSONObject' },
    startedAt: { __type: 'String' },
    status: { __type: 'CmsImportRunStatus!' },
    summary: { __type: 'JSONObject' },
    updatedAt: { __type: 'String!' },
  },
  CmsImportRunGenerateUploadUrl: {
    __typename: { __type: 'String!' },
    gcsPath: { __type: 'String!' },
    uploadUrl: { __type: 'String!' },
  },
  CmsImportRunPreview: {
    __typename: { __type: 'String!' },
    changeType: { __type: 'CmsImportChangeType' },
    createdAt: { __type: 'String!' },
    importRunId: { __type: 'String!' },
    manualOverride: { __type: 'JSONObject' },
    mappedData: { __type: 'JSONObject' },
    mappingNotes: { __type: '[JSONObject!]' },
    mappingStatus: { __type: 'CmsImportMappingStatus!' },
    previewId: { __type: 'String!' },
    sourceData: { __type: 'JSONObject' },
    sourceId: { __type: 'String!' },
    sourceSystem: { __type: 'String!' },
    sourceType: { __type: 'String' },
  },
  CmsImportRunPreviews: {
    __typename: { __type: 'String!' },
    items: { __type: '[CmsImportRunPreview!]!' },
    total: { __type: 'Float!' },
  },
  CmsImportRunStep: {
    __typename: { __type: 'String!' },
    completedAt: { __type: 'String' },
    createdAt: { __type: 'String!' },
    currentItem: { __type: 'String' },
    errors: { __type: '[CmsImportRunStepErrors!]' },
    failedItems: { __type: 'Float' },
    importRunId: { __type: 'String!' },
    importRunStepId: { __type: 'String!' },
    processedItems: { __type: 'Float' },
    skippedItems: { __type: 'Float' },
    sortOrder: { __type: 'Float!' },
    startedAt: { __type: 'String' },
    status: { __type: 'CmsImportStepStatus!' },
    stepType: { __type: 'CmsImportStepType!' },
    totalItems: { __type: 'Float' },
    updatedAt: { __type: 'String!' },
    warnings: { __type: '[CmsImportRunStepWarnings!]' },
  },
  CmsImportRunStepErrors: {
    __typename: { __type: 'String!' },
    attempt: { __type: 'Float' },
    category: { __type: 'String' },
    error: { __type: 'String!' },
    itemId: { __type: 'String!' },
    timestamp: { __type: 'String!' },
  },
  CmsImportRunStepWarnings: {
    __typename: { __type: 'String!' },
    itemId: { __type: 'String!' },
    message: { __type: 'String!' },
    timestamp: { __type: 'String!' },
  },
  CmsImportRunWithSteps: {
    __typename: { __type: 'String!' },
    completedAt: { __type: 'String' },
    corporateId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'String!' },
    createdByName: { __type: 'String' },
    importMode: { __type: 'CmsImportMode!' },
    importRunId: { __type: 'String!' },
    rollbackInProgress: { __type: 'Boolean!' },
    rollbackProcessedCount: { __type: 'Float' },
    rollbackTotalCount: { __type: 'Float' },
    rolledBackAt: { __type: 'String' },
    sources: { __type: 'JSONObject' },
    startedAt: { __type: 'String' },
    status: { __type: 'CmsImportRunStatus!' },
    steps: { __type: '[CmsImportRunStep!]!' },
    summary: { __type: 'JSONObject' },
    updatedAt: { __type: 'String!' },
  },
  CmsImportV1AuroraBrand: {
    __typename: { __type: 'String!' },
    connectedSiteCount: { __type: 'Int!' },
    isActive: { __type: 'Boolean!' },
    name: { __type: 'String' },
    slug: { __type: 'String' },
    streaksEnabled: { __type: 'Boolean!' },
    v1CorporateId: { __type: 'Int!' },
  },
  CmsImportV1AuroraBrandOptions: {
    __typename: { __type: 'String!' },
    brands: { __type: '[CmsImportV1AuroraBrand!]!' },
    savedV1CorporateId: { __type: 'Int' },
    suggestedV1CorporateId: { __type: 'Int' },
  },
  CmsTopVideosInput: {
    corporateId: { __type: 'String!' },
    endDate: { __type: 'String!' },
    siteIds: { __type: '[String!]' },
    sortBy: { __type: 'CmsVideoSortBy' },
    startDate: { __type: 'String!' },
  },
  CmsVideoAnalyticsInput: {
    contentMediaId: { __type: 'String!' },
    corporateId: { __type: 'String!' },
    endDate: { __type: 'String!' },
    startDate: { __type: 'String!' },
  },
  CmsVideoEngagementTrendInput: {
    corporateId: { __type: 'String!' },
    endDate: { __type: 'String!' },
    granularity: { __type: 'CmsGranularity' },
    startDate: { __type: 'String!' },
  },
  CodebaseSyncStats: {
    __typename: { __type: 'String!' },
    documentsFailed: { __type: 'Int!' },
    documentsProcessed: { __type: 'Int!' },
    documentsStored: { __type: 'Int!' },
  },
  CommissionActivationResult: {
    __typename: { __type: 'String!' },
    activationDate: { __type: 'String!' },
    firstPeriodId: { __type: 'ID!' },
    schedulersRegistered: { __type: 'Boolean!' },
  },
  CommissionAdjustmentStaff: {
    __typename: { __type: 'String!' },
    name: { __type: 'String!' },
    staffUserId: { __type: 'ID!' },
  },
  CommissionAssignment: {
    __typename: { __type: 'String!' },
    commissionAssignmentId: { __type: 'ID!' },
    commissionPlanId: { __type: 'ID!' },
    earnerRole: { __type: 'CommissionEarnerRole!' },
    endDate: { __type: 'String' },
    managerScope: { __type: 'CommissionManagerScope' },
    overrides: { __type: 'JSONObject!' },
    siteIds: { __type: '[ID!]!' },
    staffUserId: { __type: 'ID!' },
    startDate: { __type: 'String!' },
    teamStaffUserIds: { __type: '[ID!]!' },
  },
  CommissionAttributionHistoryEntry: {
    __typename: { __type: 'String!' },
    changedBy: { __type: 'String' },
    effectiveFrom: { __type: 'String!' },
    mode: { __type: 'String!' },
    reason: { __type: 'String' },
    sellerStaffUserId: { __type: 'ID' },
    source: { __type: 'String!' },
  },
  CommissionAttributionResolutionInput: {
    serviceId: { __type: 'ID!' },
    staffUserId: { __type: 'ID!' },
  },
  CommissionAttributionResolutionResult: {
    __typename: { __type: 'String!' },
    resolved: { __type: 'Int!' },
    skipped: { __type: '[ID!]!' },
  },
  CommissionCard: {
    __typename: { __type: 'String!' },
    carriedFromServiceId: { __type: 'ID' },
    chainRootServiceId: { __type: 'ID!' },
    committedCycles: { __type: 'Int' },
    contractValue: { __type: 'String' },
    earners: { __type: '[CommissionCardEarner!]!' },
    history: { __type: '[CommissionAttributionHistoryEntry!]!' },
    ownerStaffUserId: { __type: 'ID' },
    paidToDate: { __type: 'String!' },
    serviceId: { __type: 'ID!' },
    since: { __type: 'String!' },
    source: { __type: 'String!' },
    upfront: { __type: 'CommissionUpfront' },
  },
  CommissionCardEarner: {
    __typename: { __type: 'String!' },
    earnerRole: { __type: 'String!' },
    staffUserId: { __type: 'ID!' },
    total: { __type: 'String!' },
  },
  CommissionDashboard: {
    __typename: { __type: 'String!' },
    appliedSiteIds: { __type: '[String!]!' },
    categoryOptions: { __type: '[String!]!' },
    current: { __type: 'CommissionDashboardTotals!' },
    employees: { __type: '[CommissionDashboardEmployee!]!' },
    period: { __type: 'CommissionDashboardPeriod' },
    periods: { __type: '[CommissionDashboardPeriod!]!' },
    plans: { __type: '[CommissionDashboardPlan!]!' },
    previous: { __type: 'CommissionDashboardTotals' },
    previousPeriod: { __type: 'CommissionDashboardPeriod' },
    sites: { __type: '[CommissionDashboardSite!]!' },
    staffOptions: { __type: '[CommissionDashboardStaffOption!]!' },
    transactions: { __type: '[CommissionDashboardTransaction!]!' },
    transactionsTruncated: { __type: 'Boolean!' },
  },
  CommissionDashboardCategory: {
    __typename: { __type: 'String!' },
    category: { __type: 'String!' },
    commission: { __type: 'Float!' },
    commissionableSales: { __type: 'Float!' },
  },
  CommissionDashboardEmployee: {
    __typename: { __type: 'String!' },
    adjustments: { __type: 'Float!' },
    carried: { __type: 'Float!' },
    categories: { __type: '[CommissionDashboardCategory!]!' },
    clawbacks: { __type: 'Float!' },
    commissionableSales: { __type: 'Float!' },
    earned: { __type: 'Float!' },
    earnerRoles: { __type: '[String!]!' },
    effectiveRate: { __type: 'Float' },
    lateLines: { __type: 'Float!' },
    name: { __type: 'String!' },
    planNames: { __type: '[String!]!' },
    projectedTierAdjustment: { __type: 'Float!' },
    reviewReasons: { __type: '[CommissionDashboardReviewReason!]!' },
    staffUserId: { __type: 'String!' },
    status: { __type: 'CommissionDashboardEmployeeStatus!' },
    tierAdjustment: { __type: 'Float!' },
    totalCommission: { __type: 'Float!' },
    transactions: { __type: 'Float!' },
  },
  CommissionDashboardInput: {
    category: { __type: 'String' },
    commissionPeriodId: { __type: 'String' },
    siteIds: { __type: '[ID!]' },
    staffUserId: { __type: 'ID' },
  },
  CommissionDashboardPeriod: {
    __typename: { __type: 'String!' },
    commissionPeriodId: { __type: 'String!' },
    endDate: { __type: 'String!' },
    hasLines: { __type: 'Boolean!' },
    startDate: { __type: 'String!' },
    status: { __type: 'String!' },
  },
  CommissionDashboardPlan: {
    __typename: { __type: 'String!' },
    assignedStaff: { __type: 'Float!' },
    commissionPlanId: { __type: 'String!' },
    earnerRole: { __type: 'String!' },
    name: { __type: 'String!' },
    rates: { __type: '[CommissionDashboardPlanRate!]!' },
    scope: { __type: 'String!' },
  },
  CommissionDashboardPlanRate: {
    __typename: { __type: 'String!' },
    category: { __type: 'String!' },
    type: { __type: 'String!' },
    value: { __type: 'Float' },
  },
  CommissionDashboardSite: {
    __typename: { __type: 'String!' },
    name: { __type: 'String!' },
    siteId: { __type: 'String!' },
  },
  CommissionDashboardStaffOption: {
    __typename: { __type: 'String!' },
    name: { __type: 'String!' },
    staffUserId: { __type: 'String!' },
  },
  CommissionDashboardTotals: {
    __typename: { __type: 'String!' },
    averageRate: { __type: 'Float' },
    blockedEvents: { __type: 'Float!' },
    commissionableSales: { __type: 'Float!' },
    needsReview: { __type: 'Float!' },
    projectedTierAdjustment: { __type: 'Float!' },
    totalCommission: { __type: 'Float!' },
    unattributedSales: { __type: 'Float!' },
  },
  CommissionDashboardTransaction: {
    __typename: { __type: 'String!' },
    amount: { __type: 'Float!' },
    baseAmount: { __type: 'Float!' },
    category: { __type: 'String!' },
    clientName: { __type: 'String' },
    commissionLineId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    earnerRole: { __type: 'String!' },
    invoiceId: { __type: 'String' },
    isLate: { __type: 'Boolean!' },
    kind: { __type: 'String!' },
    planName: { __type: 'String' },
    rateType: { __type: 'String' },
    rateValue: { __type: 'Float' },
    reason: { __type: 'String' },
    siteName: { __type: 'String' },
    siteTimezone: { __type: 'String!' },
    source: { __type: 'String' },
    staffName: { __type: 'String!' },
    staffUserId: { __type: 'String!' },
  },
  CommissionEligibility: {
    __typename: { __type: 'String!' },
    commissionRolePolicyId: { __type: 'ID' },
    endDate: { __type: 'String' },
    staffUserId: { __type: 'ID!' },
    startDate: { __type: 'String!' },
  },
  CommissionEnablement: {
    __typename: { __type: 'String!' },
    effectiveFrom: { __type: 'String' },
    enabled: { __type: 'Boolean!' },
    graceUntil: { __type: 'String' },
    reason: { __type: 'CommissionEnablementReason' },
  },
  CommissionEventSummary: {
    __typename: { __type: 'String!' },
    attempts: { __type: 'Int!' },
    commissionEventId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    eventTime: { __type: 'String!' },
    kind: { __type: 'CommissionEventKind!' },
    reason: { __type: 'String' },
    siteId: { __type: 'ID!' },
    sourceId: { __type: 'String!' },
    status: { __type: 'CommissionEventStatus!' },
  },
  CommissionExportRevisionSummary: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'String' },
    gcsPath: { __type: 'String' },
    revision: { __type: 'Int!' },
  },
  CommissionItemRefInput: {
    itemId: { __type: 'String!' },
    itemType: { __type: 'CommissionItemType!' },
  },
  CommissionItemSetting: {
    __typename: { __type: 'String!' },
    isCommissionable: { __type: 'Boolean!' },
    itemId: { __type: 'String!' },
    itemType: { __type: 'CommissionItemType!' },
    requireSoldBy: { __type: 'Boolean!' },
    source: { __type: 'CommissionItemSettingSource!' },
  },
  CommissionJobRun: {
    __typename: { __type: 'String!' },
    commissionJobRunId: { __type: 'ID!' },
    createdBy: { __type: 'String' },
    finishedAt: { __type: 'String' },
    gcsPath: { __type: 'String' },
    kind: { __type: 'String!' },
    startedAt: { __type: 'String!' },
    status: { __type: 'String!' },
    summary: { __type: 'JSONObject' },
  },
  CommissionLine: {
    __typename: { __type: 'String!' },
    amount: { __type: 'String!' },
    category: { __type: 'CommissionCategory' },
    commissionLineId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'String' },
    earnedPeriodId: { __type: 'ID!' },
    earnerRole: { __type: 'String!' },
    invoiceItemId: { __type: 'ID' },
    isLate: { __type: 'Boolean!' },
    kind: { __type: 'CommissionLineKind!' },
    periodId: { __type: 'ID!' },
    reason: { __type: 'String' },
    serviceId: { __type: 'ID' },
    siteId: { __type: 'ID!' },
    staffUserId: { __type: 'ID!' },
  },
  CommissionPeriod: {
    __typename: { __type: 'String!' },
    autoCloseAt: { __type: 'String!' },
    closedAt: { __type: 'String' },
    closedBy: { __type: 'String' },
    closingRevision: { __type: 'Int' },
    commissionPeriodId: { __type: 'ID!' },
    endAt: { __type: 'String!' },
    gate: { __type: 'CommissionPeriodGate' },
    label: { __type: 'String!' },
    latestRevision: { __type: 'Int!' },
    paidAt: { __type: 'String' },
    paidBy: { __type: 'String' },
    paidRevision: { __type: 'Int' },
    reopenedAt: { __type: 'String' },
    reopenedBy: { __type: 'String' },
    revisions: { __type: '[CommissionExportRevisionSummary!]' },
    startAt: { __type: 'String!' },
    status: { __type: 'CommissionPeriodStatus!' },
    timezone: { __type: 'String!' },
  },
  CommissionPeriodGate: {
    __typename: { __type: 'String!' },
    blockingEvents: { __type: 'Int!' },
    passed: { __type: 'Boolean!' },
    reconciledAfterEnd: { __type: 'Boolean!' },
  },
  CommissionPlan: {
    __typename: { __type: 'String!' },
    commissionPlanId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    currentVersion: { __type: 'CommissionPlanVersion' },
    duplicatedFromPlanId: { __type: 'ID' },
    earnerRole: { __type: 'CommissionEarnerRole!' },
    name: { __type: 'String!' },
    readOnly: { __type: 'Boolean!' },
    scope: { __type: 'CommissionPlanScope!' },
    siteIds: { __type: '[ID!]!' },
    status: { __type: 'CommissionPlanStatus!' },
    upcomingVersions: { __type: '[CommissionPlanVersion!]!' },
    updatedAt: { __type: 'String!' },
  },
  CommissionPlanAvailabilityChange: {
    __typename: { __type: 'String!' },
    plan: { __type: 'CommissionPlan!' },
    stillAssignedStaffUserIds: { __type: '[ID!]!' },
  },
  CommissionPlanVersion: {
    __typename: { __type: 'String!' },
    commissionPlanVersionId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'String' },
    data: { __type: 'JSONObject!' },
    effectiveFrom: { __type: 'String!' },
  },
  CommissionPreflight: {
    __typename: { __type: 'String!' },
    activeAgreements: { __type: 'Int!' },
    blockedReason: { __type: 'String' },
    currencies: { __type: '[String!]!' },
    referrerShare: { __type: 'String!' },
    withReferrer: { __type: 'Int!' },
  },
  CommissionRecalcSummary: {
    __typename: { __type: 'String!' },
    linesReversed: { __type: 'Int!' },
    linesWritten: { __type: 'Int!' },
    paymentsRecalculated: { __type: 'Int!' },
    recalcRevision: { __type: 'ID' },
  },
  CommissionRoleDefault: {
    __typename: { __type: 'String!' },
    commissionPlanId: { __type: 'ID!' },
    endDate: { __type: 'String' },
    scopeKey: { __type: 'String!' },
    staffAccessPolicyId: { __type: 'ID!' },
    startDate: { __type: 'String!' },
  },
  CommissionSettings: {
    __typename: { __type: 'String!' },
    accountCreditEarns: { __type: 'Boolean!' },
    activationDate: { __type: 'String' },
    anchorDate: { __type: 'String!' },
    attributionSource: { __type: 'CommissionAttributionSourceSetting!' },
    autoCloseDays: { __type: 'Float!' },
    base: { __type: 'CommissionBase!' },
    clawbackDays: { __type: 'Float' },
    configured: { __type: 'Boolean!' },
    contractMonthsOpenEnded: { __type: 'Float!' },
    enforceSoldByOnServer: { __type: 'Boolean!' },
    leaverRule: { __type: 'CommissionLeaverRule!' },
    managerDoubleEarn: { __type: 'Boolean!' },
    netNegativeBalances: { __type: 'Boolean!' },
    periodLength: { __type: 'CommissionPeriodLength!' },
    rolePriority: { __type: '[ID!]!' },
    timezone: { __type: 'String!' },
  },
  CommissionSiteSettings: {
    __typename: { __type: 'String!' },
    onlineDefaultSellerStaffUserId: { __type: 'ID' },
    siteId: { __type: 'ID!' },
  },
  CommissionStaffEntry: {
    __typename: { __type: 'String!' },
    assignments: { __type: '[CommissionAssignment!]!' },
    commissionRolePolicyId: { __type: 'ID' },
    commissionRolePolicyName: { __type: 'String' },
    eligibilityEndDate: { __type: 'String' },
    eligibilityStartDate: { __type: 'String' },
    holdsMultipleCommissionRoles: { __type: 'Boolean!' },
    isActive: { __type: 'Boolean!' },
    isServiceAccount: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    payrollId: { __type: 'String' },
    planId: { __type: 'ID' },
    planName: { __type: 'String' },
    planSource: { __type: 'CommissionPlanSource!' },
    siteIds: { __type: '[ID!]!' },
    staffUserId: { __type: 'ID!' },
  },
  CommissionUnresolvedAttribution: {
    __typename: { __type: 'String!' },
    chainRootServiceId: { __type: 'ID!' },
    clientName: { __type: 'String' },
    effectiveFrom: { __type: 'String!' },
    itemName: { __type: 'String' },
    purchasedAt: { __type: 'String' },
    serviceId: { __type: 'ID!' },
    siteId: { __type: 'ID!' },
    source: { __type: 'String!' },
  },
  CommissionUpfront: {
    __typename: { __type: 'String!' },
    amount: { __type: 'String!' },
    recovered: { __type: 'String!' },
  },
  CommunicationTemplate: {
    __typename: { __type: 'String!' },
    alias: { __type: 'CommunicationTemplateAliases!' },
    allowedPlaceholders: { __type: '[CommunicationTemplatePlaceholders!]!' },
    communicationTemplateId: { __type: 'String!' },
    createdAt: { __type: 'String' },
    emailBody: { __type: 'String!' },
    emailCcEmail: { __type: 'String' },
    emailCcLocation: { __type: 'Boolean!' },
    emailCopyEmployee: { __type: 'EmailCopyEmployee!' },
    emailDefaultOn: { __type: 'Boolean!' },
    emailEnabled: { __type: 'Boolean!' },
    emailReplyToEmail: { __type: 'String' },
    emailReplyToName: { __type: 'String' },
    emailSendBefore: { __type: 'Float' },
    emailSendBeforeUnit: { __type: 'EmailSendBeforeUnit' },
    emailSendCalendarAttachment: { __type: 'Boolean!' },
    emailSendEmailAs: { __type: 'EmailSendAs!' },
    emailSendOnlyToActiveClients: { __type: 'Boolean!' },
    emailSubject: { __type: 'String!' },
    name: { __type: 'String!' },
    pushNotificationDefaultOn: { __type: 'Boolean!' },
    pushNotificationEnabled: { __type: 'Boolean!' },
    pushNotificationMessage: { __type: 'String' },
    pushNotificationTitle: { __type: 'String' },
    readOnly: { __type: 'Boolean!' },
    smsDefaultOn: { __type: 'Boolean!' },
    smsEnabled: { __type: 'Boolean!' },
    smsMessage: { __type: 'String' },
    updatedAt: { __type: 'String' },
  },
  CommunicationTemplatePaginationResultSchema: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'CommunicationTemplatePaginationResultSchemaPageInfo!' },
    results: { __type: '[CommunicationTemplatePaginationResultSchemaResults!]!' },
  },
  CommunicationTemplatePaginationResultSchemaPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  CommunicationTemplatePaginationResultSchemaResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'CommunicationTemplate!' },
  },
  CompleteClientFileUploadResponse: {
    __typename: { __type: 'String!' },
    fileId: { __type: 'ID!' },
    success: { __type: 'Boolean!' },
  },
  CompleteMediaUploadInputInput: {
    blurhash: { __type: 'String' },
    contentMediaId: { __type: 'ID!' },
    duration: { __type: 'Float' },
    height: { __type: 'Float' },
    width: { __type: 'Float' },
  },
  CompletionConfig: { __typename: { __type: 'String!' }, $on: { __type: '$CompletionConfig!' } },
  ComplianceOverrideInput: { reason: { __type: 'String!' } },
  ComputedAlertItem: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'String!' },
    colorsOverride: { __type: 'ComputedAlertItemColorsOverride' },
    data: { __type: 'JSONObject' },
    requiresFetch: { __type: 'Boolean' },
    type: { __type: 'String!' },
  },
  ComputedAlertItemColorsOverride: {
    __typename: { __type: 'String!' },
    bg: { __type: 'String!' },
    icon: { __type: 'String!' },
  },
  ComputedAlertsResponse: {
    __typename: { __type: 'String!' },
    alerts: { __type: '[ComputedAlertItem!]!' },
  },
  ConfiguredLanguages: { __typename: { __type: 'String!' }, languages: { __type: '[String!]!' } },
  ConfirmBrandStoreAsset: {
    __typename: { __type: 'String!' },
    assetId: { __type: 'String!' },
    assetType: { __type: 'BrandStoreAssetType!' },
    brandId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    deviceClass: { __type: 'String' },
    filename: { __type: 'String!' },
    gcsPath: { __type: 'String!' },
    height: { __type: 'Float' },
    locale: { __type: 'String!' },
    platform: { __type: 'BrandPlatform!' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'String' },
    validationError: { __type: 'String' },
    validationStatus: { __type: 'BrandStoreAssetStatus!' },
    width: { __type: 'Float' },
  },
  ConnectApnsKeyResult: {
    __typename: { __type: 'String!' },
    keyId: { __type: 'String!' },
    outcomes: { __type: '[BrandProvisioningOutcome!]!' },
    success: { __type: 'Boolean!' },
  },
  ConnectAppleApi: {
    __typename: { __type: 'String!' },
    message: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  ContentEngagementSummary: {
    __typename: { __type: 'String!' },
    avgCompletionRate: { __type: 'Float!' },
    completedContentCount: { __type: 'Float!' },
    totalContentViews: { __type: 'Float!' },
    totalFavorites: { __type: 'Float!' },
    totalPublishedContent: { __type: 'Float!' },
  },
  ContentEntries: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'ContentEntriesPageInfo!' },
    results: { __type: '[ContentEntriesResults!]!' },
  },
  ContentEntriesFiltersInput: {
    categoryEntryId: { __type: 'ID' },
    contentTypeGroup: { __type: 'ContentTypeGroup' },
    contentTypeId: { __type: 'ID' },
    createdAtLevel: { __type: 'ContentEntryLevel' },
    createdAtSiteId: { __type: 'ID' },
    excludeStatus: { __type: 'ContentStatus' },
    source: { __type: 'CmsContentEntrySource' },
    status: { __type: 'ContentStatus' },
  },
  ContentEntriesOrderByInput: {
    column: { __type: 'ContentEntryOrderBy!' },
    direction: { __type: 'OrderByDirection!' },
  },
  ContentEntriesPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  ContentEntriesResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'CmsContentEntry!' },
  },
  ContentLibraryCategory: {
    __typename: { __type: 'String!' },
    category: { __type: 'String!' },
    titleCount: { __type: 'Float!' },
  },
  ContentLibraryDisableResult: {
    __typename: { __type: 'String!' },
    publishedEntriesAffected: { __type: 'Float!' },
    sitesDisabled: { __type: 'Float!' },
  },
  ContentLibraryEntryOverrideState: {
    __typename: { __type: 'String!' },
    externalRef: { __type: 'String!' },
    overriddenPaths: { __type: '[String!]!' },
    syncState: { __type: 'String!' },
  },
  ContentLibraryPreviewStream: {
    __typename: { __type: 'String!' },
    expiresAt: { __type: 'String' },
    hlsUrl: { __type: 'String!' },
  },
  ContentLibraryResetOverrideResult: {
    __typename: { __type: 'String!' },
    restored: { __type: 'Boolean!' },
  },
  ContentLibrarySiteEnablement: {
    __typename: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
    enabledAt: { __type: 'String' },
    siteId: { __type: 'ID!' },
  },
  ContentLibraryStatus: {
    __typename: { __type: 'String!' },
    allLocations: { __type: 'Boolean!' },
    archivedEntries: { __type: 'Float!' },
    categories: { __type: '[String!]!' },
    corporateId: { __type: 'ID!' },
    draftEntries: { __type: 'Float!' },
    publishedEntries: { __type: 'Float!' },
    sites: { __type: '[ContentLibrarySiteEnablement!]!' },
    status: { __type: 'String' },
    subscribed: { __type: 'Boolean!' },
  },
  ContentLibraryTaxonomyMapping: {
    __typename: { __type: 'String!' },
    canonicalTerm: { __type: 'String!' },
    contentEntryId: { __type: 'ID!' },
    mappingSource: { __type: 'String!' },
    sourceValue: { __type: 'String!' },
    taxonomyKind: { __type: 'String!' },
  },
  ContentMediaLibrary: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'ContentMediaLibraryPageInfo!' },
    results: { __type: '[ContentMediaLibraryResults!]!' },
  },
  ContentMediaLibraryFiltersInput: {
    folder: { __type: 'String' },
    mediaType: { __type: 'MediaType' },
    mediaTypes: { __type: '[MediaType!]' },
    mimeType: { __type: 'String' },
    tags: { __type: '[String!]' },
  },
  ContentMediaLibraryOrderByInput: {
    column: { __type: 'MediaOrderBy!' },
    direction: { __type: 'OrderByDirection!' },
  },
  ContentMediaLibraryPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  ContentMediaLibraryResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'CmsContentMedia!' },
  },
  ContentTaxonomyOption: {
    __typename: { __type: 'String!' },
    childIds: { __type: '[String!]!' },
    id: { __type: 'String!' },
    name: { __type: 'String!' },
  },
  ContentTaxonomyOptionGroup: {
    __typename: { __type: 'String!' },
    options: { __type: '[ContentTaxonomyOption!]!' },
    slug: { __type: 'String!' },
  },
  CoreUsersWithoutPayrollTier: {
    __typename: { __type: 'String!' },
    id: { __type: 'ID!' },
    isInstructor: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    siteNames: { __type: '[String!]!' },
  },
  Corporate: {
    __typename: { __type: 'String!' },
    adminConfigurations: { __type: 'CorporateAdminConfigurations' },
    bigqueryDataset: { __type: 'String' },
    bigqueryRawDataset: { __type: 'String' },
    clientTenantId: { __type: 'String' },
    communicationSettings: { __type: 'CorporateCommunicationSettings' },
    corporateId: { __type: 'String!' },
    createdAt: { __type: 'String' },
    createdBy: { __type: 'String' },
    currency: { __type: 'String' },
    customIntegrations: { __type: '[CorporateCustomIntegrationItem!]' },
    customization: { __type: 'CorporateCustomization' },
    dashboardHeroImage: {
      __type: 'ImagePublicSignedUrl',
      __args: { input: 'ImagePublicSignedUrlInput!' },
    },
    dashboardHeroImageTemp: { __type: 'String' },
    description: { __type: 'String' },
    email: { __type: 'String' },
    integrations: { __type: 'CorporateIntegrations' },
    isOnboarding: { __type: 'Boolean' },
    language: { __type: 'String' },
    leadSource: { __type: 'String' },
    logoImage: { __type: 'ImagePublicSignedUrl', __args: { input: 'ImagePublicSignedUrlInput!' } },
    logoImageTemp: { __type: 'String' },
    memberMovementConfig: { __type: 'MemberMovementConfig!' },
    migrationStatus: { __type: 'String' },
    name: { __type: 'String!' },
    onboardingCompletedAt: { __type: 'String' },
    paymentAuthorisationConfig: { __type: 'CorporatePaymentAuthorisationConfig' },
    phone: { __type: 'String' },
    planTier: { __type: 'ProductPlanTier' },
    region: { __type: 'String' },
    sitesCount: { __type: 'Float!' },
    slug: { __type: 'String' },
    spannerDatabaseId: { __type: 'String' },
    spannerInstanceId: { __type: 'String' },
    staffTenantId: { __type: 'String' },
    status: { __type: 'String' },
    subdomain: { __type: 'String' },
    tier: { __type: 'String' },
    timezone: { __type: 'String' },
    trialConvertedAt: { __type: 'String' },
    trialExpiresAt: { __type: 'String' },
    trialStartedAt: { __type: 'String' },
    trialStatus: { __type: 'String' },
    updatedAt: { __type: 'String' },
    updatedBy: { __type: 'String' },
    urlPrefix: { __type: 'String' },
    webhooks: { __type: '[CorporateWebhook!]!' },
    website: { __type: 'String' },
  },
  CorporateAddOn: {
    __typename: { __type: 'String!' },
    assignedSiteGroupIds: { __type: '[ID!]' },
    assignedSiteIds: { __type: '[ID!]' },
    config: { __type: 'BrandAddOnConfig!' },
    corporateId: { __type: 'ID' },
    corporateServiceTemplateId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    deletedAt: { __type: 'String' },
    firstActivatedAt: { __type: 'String' },
    isAllLocations: { __type: 'Boolean!' },
    lockedSections: { __type: '[BrandServiceTemplateSection!]' },
    name: { __type: 'String!' },
    scheduleAuthorTimezone: { __type: 'String' },
    scheduleClock: { __type: 'BrandScheduleClock' },
    scheduleWallTime: { __type: 'String' },
    status: { __type: 'CorporateServiceTemplateStatus!' },
    type: { __type: 'String!' },
    updatedAt: { __type: 'String!' },
    version: { __type: 'Float!' },
  },
  CorporateAddOnArchiveManyResult: {
    __typename: { __type: 'String!' },
    archived: { __type: '[CorporateAddOnRolloutResult!]!' },
    skipped: { __type: '[BrandServiceTemplateArchiveSkip!]!' },
  },
  CorporateAddOnDryRunInput: {
    assignedSiteGroupIds: { __type: '[ID!]' },
    assignedSiteIds: { __type: '[ID!]' },
    config: { __type: 'BrandAddOnConfigInput!' },
    corporateServiceTemplateId: { __type: 'ID' },
    isAllLocations: { __type: 'Boolean!' },
    lockedSections: { __type: '[BrandServiceTemplateSection!]' },
    selectedGroupKeys: { __type: '[String!]' },
  },
  CorporateAddOnListItem: {
    __typename: { __type: 'String!' },
    activeClientCount: { __type: 'Float!' },
    assignedSiteGroupIds: { __type: '[ID!]' },
    assignedSiteIds: { __type: '[ID!]' },
    config: { __type: 'BrandAddOnConfig!' },
    corporateId: { __type: 'ID' },
    corporateServiceTemplateId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    deletedAt: { __type: 'String' },
    firstActivatedAt: { __type: 'String' },
    isAllLocations: { __type: 'Boolean!' },
    lockedSections: { __type: '[BrandServiceTemplateSection!]' },
    name: { __type: 'String!' },
    scheduleAuthorTimezone: { __type: 'String' },
    scheduleClock: { __type: 'BrandScheduleClock' },
    scheduleWallTime: { __type: 'String' },
    status: { __type: 'CorporateServiceTemplateStatus!' },
    type: { __type: 'String!' },
    updatedAt: { __type: 'String!' },
    version: { __type: 'Float!' },
  },
  CorporateAddOnRolloutResult: {
    __typename: { __type: 'String!' },
    addOn: { __type: 'CorporateAddOn!' },
    rollout: { __type: 'BrandServiceTemplateRollout!' },
  },
  CorporateAddOnScheduleResult: {
    __typename: { __type: 'String!' },
    addOn: { __type: 'CorporateAddOn!' },
    sites: { __type: '[BrandServiceTemplateScheduledSite!]!' },
  },
  CorporateAdminConfigurations: {
    __typename: { __type: 'String!' },
    appSettings: { __type: 'CorporateAdminConfigurationsAppSettings' },
    customization: { __type: 'CorporateCustomization' },
    hubspot: { __type: 'CorporateAdminConfigurationsHubspot' },
    paymentRouting: { __type: 'CorporateAdminConfigurationsPaymentRouting' },
    publicApi: { __type: 'CorporateAdminConfigurationsPublicApi' },
    system: { __type: 'CorporateAdminConfigurationsSystem' },
  },
  CorporateAdminConfigurationsAppSettings: {
    __typename: { __type: 'String!' },
    androidVersion: { __type: 'String' },
    classTimeFilter: { __type: 'Boolean' },
    clientSelfServiceSuspension: {
      __type: 'CorporateAdminConfigurationsAppSettingsClientSelfServiceSuspension',
    },
    displayInstructor: { __type: 'Boolean' },
    displayPackageDescription: { __type: 'Boolean' },
    displayProfilePicture: { __type: 'Boolean' },
    displayTodayClasses: { __type: 'Boolean' },
    forceUpdateAndroid: { __type: 'Boolean' },
    forceUpdateIOS: { __type: 'Boolean' },
    iosVersion: { __type: 'String' },
    privatesAnyAvailable: { __type: 'Boolean' },
    purchaseRedirect: { __type: 'String' },
    pushProvider: { __type: 'PushProvider' },
    redirectUrl: { __type: 'String' },
    signUpRedirect: { __type: 'String' },
    signUpToggle: { __type: 'Boolean' },
  },
  CorporateAdminConfigurationsAppSettingsClientSelfServiceSuspension: {
    __typename: { __type: 'String!' },
    enabled: { __type: 'Boolean' },
    maxSuspensionDays: { __type: 'Float' },
    minSuspensionDays: { __type: 'Float' },
    totalCalendarYearSuspensionDays: { __type: 'Float' },
  },
  CorporateAdminConfigurationsHubspot: {
    __typename: { __type: 'String!' },
    companyId: { __type: 'String' },
    companyName: { __type: 'String' },
  },
  CorporateAdminConfigurationsPaymentRouting: {
    __typename: { __type: 'String!' },
    chargeRouting: { __type: 'PaymentRoutingMode' },
    pipeline: { __type: 'CorporateAdminConfigurationsPaymentRoutingPipeline' },
  },
  CorporateAdminConfigurationsPaymentRoutingPipeline: {
    __typename: { __type: 'String!' },
    mode: { __type: 'PaymentsPipelineMode' },
  },
  CorporateAdminConfigurationsPublicApi: {
    __typename: { __type: 'String!' },
    logLevel: { __type: 'PublicApiLogLevel' },
  },
  CorporateAdminConfigurationsSystem: {
    __typename: { __type: 'String!' },
    blockWhenClientOwesAtAnyLocation: { __type: 'Boolean' },
    classicDashboardsEnabled: { __type: 'Boolean' },
    connectedSiteForPassportAccess: { __type: 'Boolean' },
    corporateClientLookup: { __type: 'Boolean' },
    generateAttendanceStatisticsPerSessionTemplate: { __type: 'Boolean' },
  },
  CorporateCommunicationEmailSettings: {
    __typename: { __type: 'String!' },
    defaultFromEmail: { __type: 'String' },
    defaultFromName: { __type: 'String' },
  },
  CorporateCommunicationSettings: {
    __typename: { __type: 'String!' },
    email: { __type: 'CorporateCommunicationEmailSettings' },
  },
  CorporateCommunicationTemplate: {
    __typename: { __type: 'String!' },
    alias: { __type: 'CommunicationTemplateAliases!' },
    allowedPlaceholders: { __type: '[String!]' },
    corporateCommunicationTemplateId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    emailBody: { __type: 'String' },
    emailCcEmail: { __type: 'String' },
    emailCcLocation: { __type: 'Boolean' },
    emailCopyEmployee: { __type: 'EmailCopyEmployee' },
    emailReplyToEmail: { __type: 'String' },
    emailReplyToName: { __type: 'String' },
    emailSendBefore: { __type: 'Float' },
    emailSendBeforeUnit: { __type: 'EmailSendBeforeUnit' },
    emailSendCalendarAttachment: { __type: 'Boolean' },
    emailSendEmailAs: { __type: 'EmailSendAs' },
    emailSendOnlyToActiveClients: { __type: 'Boolean' },
    emailSubject: { __type: 'String' },
    emailUseHapanaLayout: { __type: 'Boolean' },
    enableEmail: { __type: 'Boolean!' },
    enablePush: { __type: 'Boolean' },
    enableSms: { __type: 'Boolean' },
    ignoredSitesIds: { __type: '[String!]' },
    isCustomized: { __type: 'Boolean' },
    name: { __type: 'String!' },
    pushMessage: { __type: 'String' },
    pushTitle: { __type: 'String' },
    smsMessage: { __type: 'String' },
    targetedServiceTemplateIds: { __type: '[ID!]' },
    updatedAt: { __type: 'String!' },
  },
  CorporateCommunicationTemplatePaginationResultSchema: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'CorporateCommunicationTemplatePaginationResultSchemaPageInfo!' },
    results: { __type: '[CorporateCommunicationTemplatePaginationResultSchemaResults!]!' },
  },
  CorporateCommunicationTemplatePaginationResultSchemaPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  CorporateCommunicationTemplatePaginationResultSchemaResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'CorporateCommunicationTemplate!' },
  },
  CorporateCommunicationTemplateUpdateInput: {
    alias: { __type: 'CommunicationTemplateAliases!' },
    emailBody: { __type: 'String' },
    emailCcEmail: { __type: 'String' },
    emailCcLocation: { __type: 'Boolean' },
    emailCopyEmployee: { __type: 'EmailCopyEmployee' },
    emailReplyToEmail: { __type: 'String' },
    emailReplyToName: { __type: 'String' },
    emailSendBefore: { __type: 'Float' },
    emailSendBeforeUnit: { __type: 'EmailSendBeforeUnit' },
    emailSendCalendarAttachment: { __type: 'Boolean' },
    emailSendEmailAs: { __type: 'EmailSendAs' },
    emailSendOnlyToActiveClients: { __type: 'Boolean' },
    emailSubject: { __type: 'String' },
    emailUseHapanaLayout: { __type: 'Boolean' },
    enableEmail: { __type: 'Boolean' },
    enablePush: { __type: 'Boolean' },
    enableSms: { __type: 'Boolean' },
    ignoredSitesIds: { __type: '[ID!]' },
    pushMessage: { __type: 'String' },
    pushTitle: { __type: 'String' },
    smsMessage: { __type: 'String' },
    targetedServiceTemplateIds: { __type: '[ID!]' },
  },
  CorporateCommunicationTemplateVersion: {
    __typename: { __type: 'String!' },
    assignedSiteGroups: { __type: '[String!]' },
    assignedSites: { __type: '[String!]' },
    corporateCommunicationTemplateId: { __type: 'String!' },
    corporateCommunicationTemplateVersionId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    emailBody: { __type: 'String' },
    emailCcEmail: { __type: 'String' },
    emailCcLocation: { __type: 'Boolean' },
    emailCopyEmployee: { __type: 'EmailCopyEmployee' },
    emailReplyToEmail: { __type: 'String' },
    emailReplyToName: { __type: 'String' },
    emailSendBefore: { __type: 'Float' },
    emailSendBeforeUnit: { __type: 'EmailSendBeforeUnit' },
    emailSendCalendarAttachment: { __type: 'Boolean' },
    emailSendEmailAs: { __type: 'EmailSendAs' },
    emailSendOnlyToActiveClients: { __type: 'Boolean' },
    emailSubject: { __type: 'String' },
    name: { __type: 'String!' },
    pushMessage: { __type: 'String' },
    pushTitle: { __type: 'String' },
    smsMessage: { __type: 'String' },
    targetedServiceTemplateIds: { __type: '[ID!]' },
    updatedAt: { __type: 'String!' },
  },
  CorporateCommunicationTemplateVersionUpdateInput: {
    assignedSiteGroups: { __type: '[String!]' },
    assignedSites: { __type: '[String!]' },
    emailBody: { __type: 'String' },
    emailCcEmail: { __type: 'String' },
    emailCcLocation: { __type: 'Boolean' },
    emailCopyEmployee: { __type: 'EmailCopyEmployee' },
    emailReplyToEmail: { __type: 'String' },
    emailReplyToName: { __type: 'String' },
    emailSendBefore: { __type: 'Float' },
    emailSendBeforeUnit: { __type: 'EmailSendBeforeUnit' },
    emailSendCalendarAttachment: { __type: 'Boolean' },
    emailSendEmailAs: { __type: 'EmailSendAs' },
    emailSendOnlyToActiveClients: { __type: 'Boolean' },
    emailSubject: { __type: 'String' },
    name: { __type: 'String' },
    pushMessage: { __type: 'String' },
    pushTitle: { __type: 'String' },
    smsMessage: { __type: 'String' },
    targetedServiceTemplateIds: { __type: '[ID!]' },
  },
  CorporateCustomIntegrationItem: {
    __typename: { __type: 'String!' },
    integrationId: { __type: 'String!' },
    keyValues: { __type: '[CorporateCustomIntegrationItemKeyValues!]!' },
  },
  CorporateCustomIntegrationItemKeyValues: {
    __typename: { __type: 'String!' },
    key: { __type: 'String!' },
    value: { __type: 'String' },
  },
  CorporateCustomization: {
    __typename: { __type: 'String!' },
    buttonStyle: { __type: 'String' },
    colorSchema: { __type: 'CorporateCustomizationColorSchema' },
    customCssLink: { __type: 'String' },
  },
  CorporateCustomizationColorSchema: {
    __typename: { __type: 'String!' },
    backgroundColor: { __type: 'String' },
    primaryColor: { __type: 'String' },
    primaryTextColor: { __type: 'String' },
    secondaryColor: { __type: 'String' },
    secondaryTextColor: { __type: 'String' },
  },
  CorporateEmailDomain: {
    __typename: { __type: 'String!' },
    corporateId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    createdByStaffUserId: { __type: 'String' },
    customReturnPath: { __type: 'String' },
    dnsRecords: { __type: '[DnsRecord!]!' },
    domain: { __type: 'String!' },
    fromLocalPart: { __type: 'String!' },
    isPlatformDefault: { __type: 'Boolean' },
    recommendedRecords: { __type: '[RecommendedDnsRecord!]' },
    region: { __type: 'String' },
    resendDomainId: { __type: 'String!' },
    status: { __type: 'EmailDomainStatus!' },
    updatedAt: { __type: 'String!' },
    updatedByStaffUserId: { __type: 'String' },
    verifiedAt: { __type: 'String' },
  },
  CorporateFaq: {
    __typename: { __type: 'String!' },
    corporateFaqId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    displayOrder: { __type: 'Float!' },
    heading: { __type: 'String!' },
    response: { __type: 'String!' },
    status: { __type: 'CorporateFaqStatus!' },
    updatedAt: { __type: 'String!' },
  },
  CorporateIntegrations: {
    __typename: { __type: 'String!' },
    classPass: { __type: 'ClassPassSettings' },
    contentfulKeys: { __type: 'CorporateIntegrationsContentfulKeys' },
    deeplinking: { __type: 'CorporateIntegrationsDeeplinking' },
    egym: { __type: 'EgymSettings' },
    grow: { __type: 'CorporateIntegrationsGrow' },
    jwPlayer: { __type: 'CorporateIntegrationsJwPlayer' },
    pushNotificationKeys: { __type: 'CorporateIntegrationsPushNotificationKeys' },
    zapier: { __type: 'CorporateIntegrationsZapier' },
  },
  CorporateIntegrationsContentfulKeys: {
    __typename: { __type: 'String!' },
    accessToken: { __type: 'String' },
    contentApiBaseUrl: { __type: 'String' },
    contentApiKey: { __type: 'String' },
    contentApiKeyStatus: { __type: 'ContentApiKeyStatus' },
    managementAccessToken: { __type: 'String' },
    previewToken: { __type: 'String' },
    spaceId: { __type: 'String' },
    useNativeContent: { __type: 'Boolean' },
  },
  CorporateIntegrationsDeeplinking: {
    __typename: { __type: 'String!' },
    androidPackageName: { __type: 'String' },
    dynamicDomainLink: { __type: 'String' },
    iosAppStoreId: { __type: 'String' },
    iosBundleId: { __type: 'String' },
    webApiKey: { __type: 'String' },
  },
  CorporateIntegrationsGrow: {
    __typename: { __type: 'String!' },
    enableHqLocationSync: { __type: 'Boolean' },
    enableHqSyncAllLocationsScheduleId: { __type: 'String' },
    enableHqsScheduleId: { __type: 'String' },
    enableSitesScheduleId: { __type: 'String' },
    enabled: { __type: 'Boolean' },
    hqLocationIds: { __type: '[String!]' },
    lastCollect: { __type: 'GrowLastCollect' },
    syncDndAndChannels: { __type: 'Boolean' },
    useCheckinCounters: { __type: 'Boolean' },
  },
  CorporateIntegrationsJwPlayer: {
    __typename: { __type: 'String!' },
    androidSdk: { __type: 'String' },
    apiKey: { __type: 'String' },
    apiSecret: { __type: 'String' },
    iosSdk: { __type: 'String' },
    player8: { __type: 'String' },
    playerId: { __type: 'String' },
  },
  CorporateIntegrationsPushNotificationKeys: {
    __typename: { __type: 'String!' },
    id: { __type: 'String' },
    key: { __type: 'String' },
  },
  CorporateIntegrationsZapier: {
    __typename: { __type: 'String!' },
    enabled: { __type: 'Boolean' },
  },
  CorporatePaymentAuthorisationConfig: {
    __typename: { __type: 'String!' },
    bankDebitAuthorisation: { __type: 'CorporatePaymentAuthorisationConfigBankDebitAuthorisation' },
    cancellationPolicy: { __type: 'String!' },
    customerServiceContact: { __type: 'String!' },
    depositNote: { __type: 'String' },
    legalEntityName: { __type: 'String' },
    salesTaxNote: { __type: 'String' },
    template: { __type: 'String' },
  },
  CorporatePaymentAuthorisationConfigBankDebitAuthorisation: {
    __typename: { __type: 'String!' },
    coversLocationsFrom: { __type: 'String!' },
    evidenceReference: { __type: 'String!' },
    originatorName: { __type: 'String!' },
  },
  CorporatePayoutAccount: {
    __typename: { __type: 'String!' },
    corporateId: { __type: 'String!' },
    corporatePayoutAccountId: { __type: 'String!' },
    country: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'String' },
    currency: { __type: 'StripePayoutCurrency!' },
    currencyConversionFeeEnabled: { __type: 'Boolean!' },
    currencyConversionFeeRate: { __type: 'Numeric' },
    isSandbox: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    payoutFeeEnabled: { __type: 'Boolean!' },
    payoutFeeRate: { __type: 'Numeric' },
    rebateTemplateCount: { __type: 'Float' },
    royaltiesTemplateCount: { __type: 'Float' },
    stripeId: { __type: 'String!' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'String' },
  },
  CorporatePayoutAccountInput: {
    currency: { __type: 'StripePayoutCurrency!' },
    currencyConversionFee: { __type: 'CorporatePayoutAccountPayoutFeeInput!' },
    name: { __type: 'String!' },
    payoutFee: { __type: 'CorporatePayoutAccountPayoutFeeInput!' },
    stripeId: { __type: 'String!' },
  },
  CorporatePayoutAccountPayoutFeeInput: {
    enabled: { __type: 'Boolean!' },
    rate: { __type: 'Numeric' },
  },
  CorporatePayoutAccounts: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'CorporatePayoutAccountsPageInfo!' },
    results: { __type: '[CorporatePayoutAccountsResults!]!' },
  },
  CorporatePayoutAccountsOrderByInput: {
    column: { __type: 'CorporatePayoutAccountOrderBy!' },
    direction: { __type: 'OrderByDirection!' },
  },
  CorporatePayoutAccountsPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  CorporatePayoutAccountsResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'CorporatePayoutAccount!' },
  },
  CorporateProvisioningPreview: {
    __typename: { __type: 'String!' },
    clientTenantDisplayName: { __type: 'String!' },
    corporateId: { __type: 'String!' },
    existingClientTenantId: { __type: 'String' },
    existingStaffTenantId: { __type: 'String' },
    region: { __type: 'String!' },
    spannerDatabaseId: { __type: 'String!' },
    spannerInstanceId: { __type: 'String!' },
    staffTenantDisplayName: { __type: 'String!' },
  },
  CorporateServiceTemplateSummary: {
    __typename: { __type: 'String!' },
    corporateServiceTemplateId: { __type: 'ID!' },
    name: { __type: 'String!' },
    status: { __type: 'CorporateServiceTemplateStatus!' },
    type: { __type: 'CorporateServiceTemplateType!' },
  },
  CorporateServiceTemplateVersionInput: {
    corporateServiceTemplateId: { __type: 'ID!' },
    expectedVersion: { __type: 'Float!' },
  },
  CorporateSessionType: {
    __typename: { __type: 'String!' },
    allowEditingSessionType: { __type: 'Boolean!' },
    allowMultiLocationAccess: { __type: 'Boolean!' },
    assignedSiteGroupIds: { __type: '[ID!]' },
    assignedSiteIds: { __type: '[ID!]' },
    color: { __type: 'String!' },
    corporateId: { __type: 'ID' },
    corporateSessionTypeId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    deletedAt: { __type: 'String' },
    isAllLocations: { __type: 'Boolean!' },
    lockedSections: { __type: '[SessionGroupSection!]' },
    name: { __type: 'String!' },
    updatedAt: { __type: 'String!' },
  },
  CorporateSessionTypeAdoption: {
    __typename: { __type: 'String!' },
    color: { __type: 'String' },
    name: { __type: 'String!' },
    siteId: { __type: 'ID!' },
    siteName: { __type: 'String!' },
    siteSessionTypeId: { __type: 'String!' },
  },
  CorporateSessionTypeAmbiguousSite: {
    __typename: { __type: 'String!' },
    matchCount: { __type: 'Float!' },
    siteId: { __type: 'ID!' },
    siteName: { __type: 'String!' },
  },
  CorporateSessionTypeLinkedTemplates: {
    __typename: { __type: 'String!' },
    names: { __type: '[String!]!' },
    total: { __type: 'Float!' },
  },
  CorporateSessionTypeListItem: {
    __typename: { __type: 'String!' },
    allowEditingSessionType: { __type: 'Boolean!' },
    allowMultiLocationAccess: { __type: 'Boolean!' },
    assignedGroupCount: { __type: 'Float!' },
    assignedSiteGroupIds: { __type: '[ID!]' },
    assignedSiteIds: { __type: '[ID!]' },
    color: { __type: 'String!' },
    corporateId: { __type: 'ID' },
    corporateSessionTypeId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    deletedAt: { __type: 'String' },
    isAllLocations: { __type: 'Boolean!' },
    linkedTemplates: { __type: 'CorporateSessionTypeLinkedTemplates!' },
    lockedSections: { __type: '[SessionGroupSection!]' },
    name: { __type: 'String!' },
    receivingSiteCount: { __type: 'Float!' },
    updatedAt: { __type: 'String!' },
  },
  CorporateSessionTypeSyncPreview: {
    __typename: { __type: 'String!' },
    adoptionSiteIds: { __type: '[ID!]!' },
    adoptions: { __type: '[CorporateSessionTypeAdoption!]!' },
    adoptionsHasMore: { __type: 'Boolean!' },
    ambiguousSites: { __type: '[CorporateSessionTypeAmbiguousSite!]!' },
    ambiguousSitesHasMore: { __type: 'Boolean!' },
    locationAuthoredCount: { __type: 'Float!' },
    nameClash: { __type: 'CorporateSessionTypeNameClash' },
    receivingSiteCount: { __type: 'Float!' },
    withdrawals: { __type: '[CorporateSessionTypeWithdrawal!]!' },
    withdrawalsHasMore: { __type: 'Boolean!' },
  },
  CorporateSessionTypeSyncPreviewInput: {
    assignedSiteGroupIds: { __type: '[ID!]!' },
    assignedSiteIds: { __type: '[ID!]!' },
    corporateSessionTypeId: { __type: 'ID' },
    isAllLocations: { __type: 'Boolean!' },
    name: { __type: 'String!' },
  },
  CorporateSessionTypeWithdrawal: {
    __typename: { __type: 'String!' },
    creditTemplateCount: { __type: 'Float!' },
    equipmentCount: { __type: 'Float!' },
    futureSessionCount: { __type: 'Float!' },
    inUse: { __type: 'Boolean!' },
    recurringSessionCount: { __type: 'Float!' },
    sessionTemplateCount: { __type: 'Float!' },
    siteId: { __type: 'ID!' },
    siteName: { __type: 'String!' },
    siteSessionTypeId: { __type: 'String!' },
  },
  CorporateTaxSetting: {
    __typename: { __type: 'String!' },
    assignedSiteGroupIds: { __type: '[ID!]' },
    assignedSiteIds: { __type: '[ID!]' },
    corporateId: { __type: 'ID' },
    corporateTaxSettingId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    deletedAt: { __type: 'String' },
    enabled: { __type: 'Boolean!' },
    isLocked: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    rate: { __type: 'String!' },
    setting: { __type: 'TaxSettingType!' },
    updatedAt: { __type: 'String!' },
  },
  CorporateTaxSettingUsage: {
    __typename: { __type: 'String!' },
    serviceTemplateId: { __type: 'ID!' },
    siteId: { __type: 'ID!' },
    siteName: { __type: 'String!' },
    templateName: { __type: 'String!' },
  },
  CorporateTaxSettingUsageResult: {
    __typename: { __type: 'String!' },
    hasMore: { __type: 'Boolean!' },
    usages: { __type: '[CorporateTaxSettingUsage!]!' },
  },
  CorporateThemeSubscription: {
    __typename: { __type: 'String!' },
    activatedAt: { __type: 'String' },
    billingCycleAmount: { __type: 'Float' },
    cancelledAt: { __type: 'String' },
    corporateId: { __type: 'ID!' },
    corporateThemeSubscriptionId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    currency: { __type: 'String!' },
    effectiveCancelAt: { __type: 'String' },
    expiresAt: { __type: 'String' },
    gracePeriodEndsAt: { __type: 'String' },
    lastBilledAt: { __type: 'String' },
    metadata: { __type: 'JSONObject' },
    nextBillingDate: { __type: 'String' },
    status: { __type: 'ThemeSubscriptionStatus!' },
    subscribedAt: { __type: 'String!' },
    themeId: { __type: 'ID!' },
    trialEndsAt: { __type: 'String' },
    updatedAt: { __type: 'String!' },
  },
  CorporateWebhook: {
    __typename: { __type: 'String!' },
    allSites: { __type: 'Boolean!' },
    consecutiveFailures: { __type: 'Float!' },
    corporateId: { __type: 'String!' },
    corporateWebhookId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
    events: { __type: '[String!]!' },
    headerKey: { __type: 'String' },
    headerValue: { __type: 'String' },
    lastDeliveryAt: { __type: 'String' },
    lastSuccessAt: { __type: 'String' },
    name: { __type: 'String!' },
    secret: { __type: 'String' },
    siteIds: { __type: '[String!]' },
    status: { __type: 'CorporateWebhookStatus!' },
    updatedAt: { __type: 'String!' },
    url: { __type: 'String!' },
  },
  CorporateWebhookDelivery: {
    __typename: { __type: 'String!' },
    attempt: { __type: 'Float!' },
    corporateWebhookId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    delivered: { __type: 'Boolean!' },
    deliveryId: { __type: 'String!' },
    error: { __type: 'String' },
    eventId: { __type: 'String' },
    eventType: { __type: 'String' },
    latencyMs: { __type: 'Float' },
    maxAttempts: { __type: 'Float!' },
    responseStatus: { __type: 'Float' },
    siteId: { __type: 'String' },
    willRetry: { __type: 'Boolean!' },
  },
  Corporates: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'CorporatesPageInfo!' },
    results: { __type: '[CorporatesResults!]!' },
  },
  CorporatesPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  CorporatesResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'Corporate!' },
  },
  CorpusResyncResult: {
    __typename: { __type: 'String!' },
    articlesCreated: { __type: 'Int!' },
    articlesDeleted: { __type: 'Int!' },
    articlesFailed: { __type: 'Int!' },
    errors: { __type: '[String!]!' },
    success: { __type: 'Boolean!' },
  },
  Countries: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'CountriesPageInfo!' },
    results: { __type: '[CountriesResults!]!' },
  },
  CountriesFilterInput: { currencyCode: { __type: 'String' }, isoCode: { __type: 'String' } },
  CountriesOrderByInput: {
    column: { __type: 'CountriesOrderBy!' },
    direction: { __type: 'OrderByDirection!' },
  },
  CountriesPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  CountriesResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'Country!' },
  },
  Country: {
    __typename: { __type: 'String!' },
    countryId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    currencyCode: { __type: 'String' },
    isoCode: { __type: 'String' },
    isoCodeExtended: { __type: 'String' },
    name: { __type: 'String' },
    phoneCode: { __type: 'Float' },
    updatedAt: { __type: 'String!' },
  },
  CoverClaimView: {
    __typename: { __type: 'String!' },
    coverClaimId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    decidedAt: { __type: 'String' },
    eligible: { __type: 'Boolean' },
    failureReason: { __type: 'String' },
    name: { __type: 'String!' },
    reasons: { __type: '[CoverIneligibilityReason!]!' },
    staffUserId: { __type: 'String!' },
    status: { __type: 'CoverClaimStatus!' },
    via: { __type: 'CoverClaimVia!' },
    warnings: { __type: '[CoverEligibilityWarning!]!' },
  },
  CoverClassType: {
    __typename: { __type: 'String!' },
    name: { __type: 'String!' },
    siteSessionTypeId: { __type: 'String!' },
  },
  CoverCommunicationLogBatch: {
    __typename: { __type: 'String!' },
    batchId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    kind: { __type: 'CoverCommunicationKind!' },
    messagePreview: { __type: 'String' },
    recipients: { __type: '[CoverCommunicationLogRecipient!]!' },
    sentBy: { __type: 'CoverStaffRef' },
    templateAlias: { __type: 'String!' },
  },
  CoverCommunicationLogPage: {
    __typename: { __type: 'String!' },
    entries: { __type: '[CoverCommunicationLogBatch!]!' },
    nextCursor: { __type: 'String' },
  },
  CoverCommunicationLogRecipient: {
    __typename: { __type: 'String!' },
    channel: { __type: 'CoverCommunicationChannel!' },
    failureReason: { __type: 'String' },
    name: { __type: 'String!' },
    skipReason: { __type: 'CoverCommunicationSkipReason' },
    staffUserId: { __type: 'String!' },
    status: { __type: 'CoverCommunicationStatus!' },
  },
  CoverConflict: {
    __typename: { __type: 'String!' },
    endTime: { __type: 'String!' },
    name: { __type: 'String!' },
    sessionId: { __type: 'String!' },
    siteId: { __type: 'String!' },
    startTime: { __type: 'String!' },
  },
  CoverEligibility: {
    __typename: { __type: 'String!' },
    conflicts: { __type: '[CoverConflict!]!' },
    eligible: { __type: 'Boolean!' },
    isCrossSite: { __type: 'Boolean!' },
    isPreferred: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    reasons: { __type: '[CoverIneligibilityReason!]!' },
    staffUserId: { __type: 'String!' },
    warnings: { __type: '[CoverEligibilityWarning!]!' },
  },
  CoverImagePosition: {
    __typename: { __type: 'String!' },
    x: { __type: 'Float!' },
    y: { __type: 'Float!' },
  },
  CoverImagePositionInput: { x: { __type: 'Float!' }, y: { __type: 'Float!' } },
  CoverImageUploadUrl: {
    __typename: { __type: 'String!' },
    expiresAt: { __type: 'String!' },
    publicUrl: { __type: 'String!' },
    uploadUrl: { __type: 'String!' },
  },
  CoverMessageAudienceMember: {
    __typename: { __type: 'String!' },
    canReceiveSms: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    recipientModes: { __type: '[CoverMessageRecipientMode!]!' },
    role: { __type: 'CoverMessageAudienceRole!' },
    staffUserId: { __type: 'String!' },
  },
  CoverMessageView: {
    __typename: { __type: 'String!' },
    author: { __type: 'CoverStaffRef!' },
    body: { __type: 'String!' },
    bodyJson: { __type: 'JSON' },
    channels: { __type: '[CoverMessageChannel!]!' },
    coverMessageId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    isBroadcast: { __type: 'Boolean!' },
    recipientCount: { __type: 'Int' },
    recipientMode: { __type: 'CoverMessageRecipientMode!' },
  },
  CoverMyOfferView: {
    __typename: { __type: 'String!' },
    isMyTurn: { __type: 'Boolean!' },
    respondByAt: { __type: 'String' },
    status: { __type: 'CoverOfferStatus!' },
  },
  CoverOfferTurnView: {
    __typename: { __type: 'String!' },
    name: { __type: 'String!' },
    offeredAt: { __type: 'String' },
    rank: { __type: 'Float' },
    respondByAt: { __type: 'String' },
    respondedAt: { __type: 'String' },
    staffUserId: { __type: 'String!' },
    status: { __type: 'CoverOfferStatus!' },
  },
  CoverPreferredSubInput: {
    rank: { __type: 'Float!' },
    sessionTypeId: { __type: 'ID' },
    staffUserId: { __type: 'ID!' },
  },
  CoverPreferredSubView: {
    __typename: { __type: 'String!' },
    name: { __type: 'String!' },
    rank: { __type: 'Float!' },
    sessionTypeId: { __type: 'String' },
    staffUserId: { __type: 'String!' },
  },
  CoverRequestView: {
    __typename: { __type: 'String!' },
    approvalMode: { __type: 'CoverApprovalMode!' },
    blastAt: { __type: 'String' },
    blastedAt: { __type: 'String' },
    cancelReason: { __type: 'CoverCancelReason' },
    claims: { __type: '[CoverClaimView!]!' },
    coverGroupId: { __type: 'String' },
    coverRequestId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    deadlineAt: { __type: 'String' },
    escalatedAt: { __type: 'String' },
    filledAt: { __type: 'String' },
    filledBy: { __type: 'CoverStaffRef' },
    filledVia: { __type: 'CoverFilledVia' },
    isAwaitingRelease: { __type: 'Boolean!' },
    isClaimable: { __type: 'Boolean!' },
    isInWaterfall: { __type: 'Boolean!' },
    isLastMinute: { __type: 'Boolean!' },
    locationName: { __type: 'String' },
    myClaimStatus: { __type: 'CoverClaimStatus' },
    myOffer: { __type: 'CoverMyOfferView' },
    noteToSubs: { __type: 'String' },
    notifyMembersByDefault: { __type: 'Boolean!' },
    offerStrategy: { __type: 'CoverOfferStrategy' },
    offerTurns: { __type: '[CoverOfferTurnView!]!' },
    originalInstructor: { __type: 'CoverStaffRef!' },
    parentCoverRequestId: { __type: 'String' },
    reason: { __type: 'String' },
    requestedBy: { __type: 'CoverStaffRef!' },
    sessionEndTime: { __type: 'String!' },
    sessionId: { __type: 'String!' },
    sessionName: { __type: 'String!' },
    sessionStartTime: { __type: 'String!' },
    sessionTypeId: { __type: 'String' },
    sessionTypeName: { __type: 'String' },
    siteId: { __type: 'String!' },
    siteName: { __type: 'String' },
    status: { __type: 'CoverRequestStatus!' },
    timezone: { __type: 'String!' },
    viewerCanMessage: { __type: 'Boolean!' },
  },
  CoverSessionBadge: {
    __typename: { __type: 'String!' },
    coverRequestId: { __type: 'String!' },
    isLastMinute: { __type: 'Boolean!' },
    originalStaffUserId: { __type: 'String!' },
    sessionId: { __type: 'String!' },
    status: { __type: 'CoverRequestStatus!' },
  },
  CoverSettings: {
    __typename: { __type: 'String!' },
    approvalMode: { __type: 'CoverApprovalMode!' },
    crossSiteCoversEnabled: { __type: 'Boolean!' },
    escalateBeforeStartMinutes: { __type: 'Float!' },
    lastMinuteThresholdMinutes: { __type: 'Float!' },
    memberNotification: { __type: 'CoverMemberNotification!' },
    offerStrategy: { __type: 'CoverOfferStrategy!' },
    offerWindowMinutes: { __type: 'Float!' },
    quietHoursEnd: { __type: 'String!' },
    quietHoursStart: { __type: 'String!' },
    reminderEnabled: { __type: 'Boolean!' },
    selfServeCutoffMinutes: { __type: 'Float!' },
    showSubMarkerToMembers: { __type: 'Boolean!' },
    smsEnabled: { __type: 'Boolean!' },
    tier1WindowMinutes: { __type: 'Float!' },
    tier2WindowMinutes: { __type: 'Float!' },
    travelBufferMinutes: { __type: 'Float!' },
  },
  CoverSettingsInput: {
    approvalMode: { __type: 'CoverApprovalMode' },
    crossSiteCoversEnabled: { __type: 'Boolean' },
    escalateBeforeStartMinutes: { __type: 'Float' },
    lastMinuteThresholdMinutes: { __type: 'Float' },
    memberNotification: { __type: 'CoverMemberNotification' },
    offerStrategy: { __type: 'CoverOfferStrategy' },
    offerWindowMinutes: { __type: 'Float' },
    quietHoursEnd: { __type: 'String' },
    quietHoursStart: { __type: 'String' },
    reminderEnabled: { __type: 'Boolean' },
    selfServeCutoffMinutes: { __type: 'Float' },
    showSubMarkerToMembers: { __type: 'Boolean' },
    smsEnabled: { __type: 'Boolean' },
    travelBufferMinutes: { __type: 'Float' },
  },
  CoverSettingsOverrides: {
    __typename: { __type: 'String!' },
    approvalMode: { __type: 'CoverApprovalMode' },
    crossSiteCoversEnabled: { __type: 'Boolean' },
    escalateBeforeStartMinutes: { __type: 'Float' },
    lastMinuteThresholdMinutes: { __type: 'Float' },
    memberNotification: { __type: 'CoverMemberNotification' },
    offerStrategy: { __type: 'CoverOfferStrategy' },
    offerWindowMinutes: { __type: 'Float' },
    quietHoursEnd: { __type: 'String' },
    quietHoursStart: { __type: 'String' },
    reminderEnabled: { __type: 'Boolean' },
    selfServeCutoffMinutes: { __type: 'Float' },
    showSubMarkerToMembers: { __type: 'Boolean' },
    smsEnabled: { __type: 'Boolean' },
    travelBufferMinutes: { __type: 'Float' },
  },
  CoverStaffQualifications: {
    __typename: { __type: 'String!' },
    siteSessionTypeIds: { __type: '[String!]!' },
    staffUserId: { __type: 'String!' },
  },
  CoverStaffQualificationsInput: {
    siteSessionTypeIds: { __type: '[ID!]!' },
    staffUserId: { __type: 'ID!' },
  },
  CoverStaffRef: {
    __typename: { __type: 'String!' },
    name: { __type: 'String!' },
    staffUserId: { __type: 'String!' },
  },
  CreateAddOnPriceGroupInput: {
    name: { __type: 'String!' },
    siteId: { __type: 'ID!' },
    siteSessionTypeIds: { __type: '[ID!]!' },
    taxSettingIds: { __type: '[ID!]' },
  },
  CreateAddonInvoiceInput: {
    clientId: { __type: 'String!' },
    equipmentId: { __type: 'String!' },
    siteId: { __type: 'String!' },
    siteSessionTypeId: { __type: 'String' },
  },
  CreateAddonInvoiceResult: { __typename: { __type: 'String!' }, invoiceId: { __type: 'String!' } },
  CreateAdminAccessGroupInputInput: {
    corporates: { __type: '[String!]!' },
    description: { __type: 'String' },
    isAllCorporates: { __type: 'Boolean!' },
    isRestricted: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    password: { __type: 'String' },
    permissions: { __type: '[AdminUserPermissions!]!' },
  },
  CreateAdminUserImpersonationSessionInput: {
    corporateId: { __type: 'String!' },
    siteId: { __type: 'String' },
    staffUserId: { __type: 'String!' },
    urlPrefix: { __type: 'String!' },
  },
  CreateAdminUserInputInput: {
    accessGroupId: { __type: 'ID!' },
    accessGroupPassword: { __type: 'String' },
    email: { __type: 'String!' },
    firstName: { __type: 'String!' },
    lastName: { __type: 'String!' },
    phone: { __type: 'String!' },
  },
  CreateAuditEventDetailsChangesInput: {
    displayName: { __type: 'String' },
    field: { __type: 'String!' },
    fieldType: { __type: 'String' },
    newValue: { __type: 'String' },
    oldValue: { __type: 'String' },
  },
  CreateAuditEventDetailsInput: {
    changes: { __type: '[CreateAuditEventDetailsChangesInput!]' },
    contextJson: { __type: 'String' },
    metadataJson: { __type: 'String' },
    newValueJson: { __type: 'String' },
    previousValueJson: { __type: 'String' },
    reason: { __type: 'String' },
    summary: { __type: 'String' },
  },
  CreateAuditEventInputInput: {
    accessPointId: { __type: 'String' },
    action: { __type: 'AuditAction!' },
    affectedUserEmail: { __type: 'String' },
    affectedUserFirstName: { __type: 'String' },
    affectedUserId: { __type: 'String' },
    affectedUserLastName: { __type: 'String' },
    browserName: { __type: 'String' },
    browserVersion: { __type: 'String' },
    corporateId: { __type: 'String!' },
    corporateName: { __type: 'String' },
    corporateSlug: { __type: 'String' },
    details: { __type: 'CreateAuditEventDetailsInput' },
    deviceType: { __type: 'AuditDeviceType' },
    doorId: { __type: 'String' },
    emailDomain: { __type: 'String' },
    ipAddress: { __type: 'String' },
    language: { __type: 'String' },
    memberId: { __type: 'String' },
    osName: { __type: 'String' },
    osVersion: { __type: 'String' },
    pageName: { __type: 'String' },
    pageUrl: { __type: 'String' },
    platform: { __type: 'AuditPlatform' },
    resource: { __type: 'AuditResource!' },
    resourceId: { __type: 'String' },
    screenHeight: { __type: 'Float' },
    screenWidth: { __type: 'Float' },
    sessionId: { __type: 'String' },
    severity: { __type: 'AuditSeverity!' },
    siteId: { __type: 'String' },
    siteName: { __type: 'String' },
    source: { __type: 'AuditSource!' },
    timezone: { __type: 'String' },
    userAgent: { __type: 'String' },
    userEmail: { __type: 'String' },
    userFirstName: { __type: 'String' },
    userId: { __type: 'String' },
    userLastName: { __type: 'String' },
    userRoles: { __type: '[String!]' },
    visibility: { __type: 'AuditVisibility!' },
  },
  CreateCarouselGroupInput: { name: { __type: 'String!' } },
  CreateClientAddressInput: {
    city: { __type: 'String' },
    country: { __type: 'String' },
    state: { __type: 'String' },
    streetAddress: { __type: 'String' },
    streetNumber: { __type: 'String' },
    unit: { __type: 'String' },
    zipCode: { __type: 'String' },
  },
  CreateClientAlertInputInput: {
    clientId: { __type: 'String!' },
    description: { __type: 'String' },
    endDate: { __type: 'String' },
    startDate: { __type: 'String' },
    title: { __type: 'String!' },
  },
  CreateClientCustomPropertiesInput: {
    siteCustomPropertyId: { __type: 'String!' },
    value: { __type: 'String!' },
  },
  CreateClientEmergencyContactAddressInput: {
    city: { __type: 'String' },
    country: { __type: 'String' },
    state: { __type: 'String' },
    street: { __type: 'String' },
    streetNumber: { __type: 'String' },
    unit: { __type: 'String' },
    zipCode: { __type: 'String' },
  },
  CreateClientEmergencyContactInput: {
    address: { __type: 'CreateClientEmergencyContactAddressInput' },
    email: { __type: 'String' },
    name: { __type: 'String' },
    phone: { __type: 'String' },
    relationship: { __type: 'String' },
  },
  CreateClientFamilyInput: {
    email: { __type: 'String!' },
    name: { __type: 'String!' },
    relationship: { __type: 'ClientFamilyRelationship!' },
  },
  CreateClientFileInput: { fileName: { __type: 'String!' }, format: { __type: 'String!' } },
  CreateClientFileResponse: { __typename: { __type: 'String!' }, fileId: { __type: 'ID!' } },
  CreateClientInput: {
    activePackagesCount: { __type: 'Float' },
    address: { __type: 'CreateClientAddressInput' },
    barcodeId: { __type: 'String' },
    customProperties: { __type: '[CreateClientCustomPropertiesInput!]' },
    customerId: { __type: 'String' },
    dateOfBirth: { __type: 'String' },
    email: { __type: 'String!' },
    emergencyContact: { __type: 'CreateClientEmergencyContactInput' },
    enrollmentSource: { __type: 'String' },
    firebaseId: { __type: 'String' },
    firstName: { __type: 'String!' },
    gender: { __type: 'String' },
    homeLocationIds: { __type: '[String!]' },
    homePhoneNumber: { __type: 'String' },
    homeSiteId: { __type: 'String' },
    isProspect: { __type: 'Boolean' },
    lastName: { __type: 'String!' },
    mobilePhoneNumber: { __type: 'String' },
    occupation: { __type: 'String' },
    questionnaireAnswers: { __type: '[SubmitClientFormsQuestionnaireAnswersInput!]' },
    recentSiteId: { __type: 'String' },
    sendWelcomeEmail: { __type: 'Boolean' },
    source: { __type: 'ClientSource' },
  },
  CreateClientNoteResponse: {
    __typename: { __type: 'String!' },
    message: { __type: 'String' },
    note: { __type: 'ClientNote' },
    success: { __type: 'Boolean!' },
  },
  CreateClientResponse: { __typename: { __type: 'String!' }, id: { __type: 'String!' } },
  CreateCorporateAddOnDraftInput: {
    assignedSiteGroupIds: { __type: '[ID!]' },
    assignedSiteIds: { __type: '[ID!]' },
    config: { __type: 'BrandAddOnConfigInput!' },
    isAllLocations: { __type: 'Boolean!' },
    lockedSections: { __type: '[BrandServiceTemplateSection!]' },
  },
  CreateCorporateHubspotInput: {
    companyId: { __type: 'String' },
    companyName: { __type: 'String' },
  },
  CreateCorporateSessionTypeInput: {
    acknowledgedAdoptionSiteIds: { __type: '[ID!]' },
    allowEditingSessionType: { __type: 'Boolean!' },
    allowMultiLocationAccess: { __type: 'Boolean!' },
    assignedSiteGroupIds: { __type: '[ID!]' },
    assignedSiteIds: { __type: '[ID!]' },
    color: { __type: 'String!' },
    isAllLocations: { __type: 'Boolean!' },
    lockedSections: { __type: '[SessionGroupSection!]' },
    name: { __type: 'String!' },
  },
  CreateCorporateTaxSettingInput: {
    assignedSiteGroupIds: { __type: '[ID!]' },
    assignedSiteIds: { __type: '[ID!]' },
    enabled: { __type: 'Boolean!' },
    isLocked: { __type: 'Boolean' },
    name: { __type: 'String!' },
    rate: { __type: 'String!' },
    setting: { __type: 'TaxSettingType!' },
  },
  CreateCorporateWebhookInputInput: {
    allSites: { __type: 'Boolean' },
    enabled: { __type: 'Boolean' },
    events: { __type: '[String!]!' },
    headerKey: { __type: 'String' },
    headerValue: { __type: 'String' },
    name: { __type: 'String!' },
    siteIds: { __type: '[String!]' },
    url: { __type: 'String!' },
  },
  CreateEquipmentAssignmentInput: {
    checkInId: { __type: 'String' },
    clientId: { __type: 'String' },
    complianceOverride: { __type: 'ComplianceOverrideInput' },
    delayMinutes: { __type: 'Int!' },
    equipmentId: { __type: 'String!' },
    guardianPresenceAttested: { __type: 'Boolean' },
    isOverride: { __type: 'Boolean' },
    owedBalanceOverride: { __type: 'OwedBalanceOverrideInput' },
    regulationOverrides: { __type: '[TanningRegulationOverrideInput!]' },
    siteId: { __type: 'String!' },
    siteSessionTypeId: { __type: 'String' },
    timerMinutes: { __type: 'Int!' },
  },
  CreateEquipmentInput: {
    category: { __type: 'EquipmentCategory!' },
    copyImageFromEquipmentId: { __type: 'ID' },
    defaultDelayMinutes: { __type: 'Int' },
    defaultTimerMinutes: { __type: 'Int' },
    description: { __type: 'String' },
    manufacturer: { __type: 'String' },
    maxDelayMinutes: { __type: 'Int' },
    maxTimerMinutes: { __type: 'Int' },
    minDelayMinutes: { __type: 'Int' },
    minTimerMinutes: { __type: 'Int' },
    name: { __type: 'String!' },
    nonUvCategory: { __type: 'NonUvCategory' },
    qualityCategory: { __type: 'EquipmentQualityCategory' },
    siteId: { __type: 'String!' },
    siteSessionTypeIds: { __type: '[String!]' },
    timerId: { __type: 'Int!' },
  },
  CreateEquipmentRegulationInput: {
    equipmentCategory: { __type: 'EquipmentCategory!' },
    rules: { __type: 'CreateEquipmentRegulationRulesInput!' },
    siteId: { __type: 'String!' },
  },
  CreateEquipmentRegulationRulesCustomerAgeMaxFrequencyAfterNoCategoryTanInput: {
    afterXDaysOfNoCategoryTan: { __type: 'Float!' },
    enabled: { __type: 'Boolean!' },
    everyXDays: { __type: 'Float!' },
    forTheFirstXDays: { __type: 'Float!' },
    maxAge: { __type: 'Float!' },
    maxUses: { __type: 'Float!' },
  },
  CreateEquipmentRegulationRulesCustomerAgeMaxFrequencyInput: {
    enabled: { __type: 'Boolean!' },
    everyXDays: { __type: 'Float!' },
    maxAge: { __type: 'Float!' },
    maxUses: { __type: 'Float!' },
  },
  CreateEquipmentRegulationRulesHoursBetweenUsesFromStartOfPreviousInput: {
    enabled: { __type: 'Boolean!' },
    hours: { __type: 'Float!' },
  },
  CreateEquipmentRegulationRulesInput: {
    allowOverride: { __type: 'Boolean!' },
    customerAgeMaxFrequency: {
      __type: 'CreateEquipmentRegulationRulesCustomerAgeMaxFrequencyInput!',
    },
    customerAgeMaxFrequencyAfterNoCategoryTan: {
      __type: 'CreateEquipmentRegulationRulesCustomerAgeMaxFrequencyAfterNoCategoryTanInput!',
    },
    hoursBetweenUsesFromStartOfPrevious: {
      __type: 'CreateEquipmentRegulationRulesHoursBetweenUsesFromStartOfPreviousInput!',
    },
    minimumDaysBetweenUses: {
      __type: 'CreateEquipmentRegulationRulesMinimumDaysBetweenUsesInput!',
    },
    minimumHoursBetweenUses: {
      __type: 'CreateEquipmentRegulationRulesMinimumHoursBetweenUsesInput!',
    },
    nonUvAgeRules: { __type: 'CreateEquipmentRegulationRulesNonUvAgeRulesInput' },
    skinTypeRequired: { __type: 'CreateEquipmentRegulationRulesSkinTypeRequiredInput' },
    uvAgeRules: { __type: 'CreateEquipmentRegulationRulesUvAgeRulesInput' },
  },
  CreateEquipmentRegulationRulesMinimumDaysBetweenUsesInput: {
    days: { __type: 'Float!' },
    enabled: { __type: 'Boolean!' },
  },
  CreateEquipmentRegulationRulesMinimumHoursBetweenUsesInput: {
    enabled: { __type: 'Boolean!' },
    hours: { __type: 'Float!' },
  },
  CreateEquipmentRegulationRulesNonUvAgeRulesByCategoryInput: {
    red_light: { __type: 'CreateEquipmentRegulationRulesUvAgeRulesInput' },
    spa: { __type: 'CreateEquipmentRegulationRulesUvAgeRulesInput!' },
    spray: { __type: 'CreateEquipmentRegulationRulesUvAgeRulesInput!' },
    wellness: { __type: 'CreateEquipmentRegulationRulesUvAgeRulesInput!' },
  },
  CreateEquipmentRegulationRulesNonUvAgeRulesInput: {
    byCategory: { __type: 'CreateEquipmentRegulationRulesNonUvAgeRulesByCategoryInput' },
    categoryBased: { __type: 'Boolean!' },
    general: { __type: 'CreateEquipmentRegulationRulesUvAgeRulesInput' },
  },
  CreateEquipmentRegulationRulesSkinTypeRequiredInput: {
    allowOverride: { __type: 'Boolean!' },
    autoSend: { __type: 'Boolean!' },
    autoSendDeviceTokenId: { __type: 'String' },
    mode: { __type: 'SkinTypeRequirementMode!' },
    resurveyInterval: { __type: 'ResurveyInterval!' },
    skinTypeFormId: { __type: 'String' },
  },
  CreateEquipmentRegulationRulesUvAgeRulesInput: {
    doctorsNote: {
      __type: 'CreateEquipmentRegulationRulesUvAgeRulesMinorWithParentalConsentInput',
    },
    minimumAge: { __type: 'CreateEquipmentRegulationRulesUvAgeRulesMinimumAgeInput!' },
    minorWithParentalConsent: {
      __type: 'CreateEquipmentRegulationRulesUvAgeRulesMinorWithParentalConsentInput!',
    },
  },
  CreateEquipmentRegulationRulesUvAgeRulesMinimumAgeInput: {
    enabled: { __type: 'Boolean!' },
    enforceNoOverride: { __type: 'Boolean!' },
    value: { __type: 'Float!' },
  },
  CreateEquipmentRegulationRulesUvAgeRulesMinorWithParentalConsentInput: {
    enabled: { __type: 'Boolean!' },
    max: { __type: 'Float!' },
    min: { __type: 'Float!' },
  },
  CreateExternalMediaAssetInputInput: {
    fileName: { __type: 'String!' },
    folder: { __type: 'String' },
    mimeType: { __type: 'ExternalVideoMimeType!' },
    url: { __type: 'String!' },
  },
  CreateGoalInput: { name: { __type: 'String!' } },
  CreateInvoiceInputInput: {
    beneficiaryId: { __type: 'ID' },
    clientId: { __type: 'ID' },
    currency: { __type: 'Currency!' },
    items: { __type: '[CreateInvoiceItemsInput!]!' },
    source: { __type: 'InvoiceSource!' },
  },
  CreateInvoiceItemsBillableItemInput: {
    addAsAccountCredits: { __type: 'Boolean!' },
    description: { __type: 'String!' },
    invoiceDate: { __type: 'String!' },
    price: { __type: 'Numeric!' },
    revenueTagId: { __type: 'ID' },
    serviceTemplateId: { __type: 'ID' },
    taxSettingsIds: { __type: '[ID!]!' },
  },
  CreateInvoiceItemsBookingInput: {
    bookingId: { __type: 'ID!' },
    dropInPrice: { __type: 'Numeric!' },
    revenueTagId: { __type: 'String' },
    sessionId: { __type: 'ID!' },
    sessionName: { __type: 'String!' },
    sessionStartTime: { __type: 'String!' },
    taxSettingIds: { __type: '[String!]!' },
  },
  CreateInvoiceItemsDestinationFeeInput: {
    metadata: { __type: 'CreateInvoiceItemsDestinationFeeMetadataInput!' },
  },
  CreateInvoiceItemsDestinationFeeMetadataInput: {
    itemType: { __type: 'String!' },
    siteId: { __type: 'ID!' },
  },
  CreateInvoiceItemsGiftCardInput: {
    customId: { __type: 'String!' },
    deliveryDate: { __type: 'String' },
    designId: { __type: 'String' },
    expiryDate: { __type: 'String' },
    expiryMode: { __type: 'GiftCardExpiryMode' },
    giftCardTemplateId: { __type: 'ID!' },
    personalMessage: { __type: 'String' },
    purchaserEmail: { __type: 'String!' },
    purchaserName: { __type: 'String!' },
    recipientEmail: { __type: 'String' },
    recipientFullName: { __type: 'String' },
    recipientName: { __type: 'String!' },
    sendToRecipient: { __type: 'Boolean!' },
    value: { __type: 'Numeric!' },
  },
  CreateInvoiceItemsInput: {
    billableItem: { __type: 'CreateInvoiceItemsBillableItemInput' },
    booking: { __type: 'CreateInvoiceItemsBookingInput' },
    destinationFee: { __type: 'CreateInvoiceItemsDestinationFeeInput' },
    discountReason: { __type: 'String' },
    discountType: { __type: 'DiscountType' },
    discountValue: { __type: 'Numeric' },
    giftCard: { __type: 'CreateInvoiceItemsGiftCardInput' },
    itemType: { __type: 'SaleItemType!' },
    lateCancelFee: { __type: 'CreateInvoiceItemsLateCancelFeeInput' },
    noShowFee: { __type: 'CreateInvoiceItemsNoShowFeeInput' },
    product: { __type: 'CreateInvoiceItemsProductInput' },
    promoCodeId: { __type: 'ID' },
    quantity: { __type: 'Float!' },
    recurringServicePayment: { __type: 'CreateInvoiceItemsRecurringServicePaymentInput' },
    referredByStaffUserId: { __type: 'ID' },
    scheduleDateAdjustment: { __type: 'CreateInvoiceItemsScheduleDateAdjustmentInput' },
    service: { __type: 'CreateInvoiceItemsServiceInput' },
    serviceActionFee: { __type: 'CreateInvoiceItemsServiceActionFeeInput' },
  },
  CreateInvoiceItemsLateCancelFeeInput: {
    metadata: { __type: 'CreateInvoiceItemsLateCancelFeeMetadataInput!' },
  },
  CreateInvoiceItemsLateCancelFeeMetadataInput: {
    bookingId: { __type: 'ID!' },
    itemType: { __type: 'String!' },
    lateCancelFeeId: { __type: 'String' },
    lateCancelFeeName: { __type: 'String' },
    sessionDate: { __type: 'String!' },
    sessionId: { __type: 'ID!' },
    sessionName: { __type: 'String!' },
    sessionTime: { __type: 'String!' },
    sessionTypeId: { __type: 'ID!' },
    sessionTypeName: { __type: 'String!' },
  },
  CreateInvoiceItemsNoShowFeeInput: {
    metadata: { __type: 'CreateInvoiceItemsNoShowFeeMetadataInput!' },
  },
  CreateInvoiceItemsNoShowFeeMetadataInput: {
    bookingId: { __type: 'ID!' },
    itemType: { __type: 'String!' },
    noShowFeeId: { __type: 'String' },
    noShowFeeName: { __type: 'String' },
    sessionDate: { __type: 'String!' },
    sessionId: { __type: 'ID!' },
    sessionName: { __type: 'String!' },
    sessionTime: { __type: 'String!' },
    sessionTypeId: { __type: 'ID!' },
    sessionTypeName: { __type: 'String!' },
  },
  CreateInvoiceItemsProductInput: {
    productId: { __type: 'ID!' },
    productTemplateId: { __type: 'ID!' },
  },
  CreateInvoiceItemsRecurringServicePaymentInput: {
    amount: { __type: 'Numeric!' },
    beneficiaryClientId: { __type: 'ID' },
    description: { __type: 'String!' },
    invoiceDate: { __type: 'String!' },
    metadata: { __type: 'CreateInvoiceItemsRecurringServicePaymentMetadataInput!' },
    proratedCredits: { __type: 'Float' },
    prorationEndDate: { __type: 'String' },
    prorationStartDate: { __type: 'String' },
    serviceId: { __type: 'ID!' },
    totalCredits: { __type: 'Float' },
  },
  CreateInvoiceItemsRecurringServicePaymentMetadataInput: {
    isSecondaryFee: { __type: 'Boolean' },
    itemType: { __type: 'String!' },
    recurringInvoiceId: { __type: 'ID!' },
    recurringInvoiceName: { __type: 'String!' },
    sequenceNumber: { __type: 'Float!' },
    serviceTemplateName: { __type: 'String!' },
  },
  CreateInvoiceItemsScheduleDateAdjustmentInput: {
    amount: { __type: 'String!' },
    description: { __type: 'String!' },
    metadata: { __type: 'CreateInvoiceItemsScheduleDateAdjustmentMetadataInput!' },
  },
  CreateInvoiceItemsScheduleDateAdjustmentMetadataInput: {
    itemType: { __type: 'String!' },
    newStartDate: { __type: 'String!' },
    oldStartDate: { __type: 'String!' },
    serviceId: { __type: 'ID!' },
    sourceInvoiceId: { __type: 'ID!' },
  },
  CreateInvoiceItemsServiceActionFeeInput: {
    amount: { __type: 'String!' },
    description: { __type: 'String!' },
    metadata: { __type: 'CreateInvoiceItemsServiceActionFeeMetadataInput!' },
    taxSettingsSnapshot: {
      __type: '[CreateInvoiceItemsServiceActionFeeTaxSettingsSnapshotInput!]',
    },
  },
  CreateInvoiceItemsServiceActionFeeMetadataInput: {
    actionType: { __type: 'ServiceActionType!' },
    itemType: { __type: 'String!' },
    serviceCancellationId: { __type: 'String' },
    serviceId: { __type: 'ID!' },
    serviceSuspensionId: { __type: 'String' },
    withdrawnAt: { __type: 'String' },
  },
  CreateInvoiceItemsServiceActionFeeTaxSettingsSnapshotInput: {
    amount: { __type: 'Numeric!' },
    name: { __type: 'String!' },
    taxSettingId: { __type: 'String!' },
    type: { __type: 'TaxSettingType!' },
  },
  CreateInvoiceItemsServiceInput: {
    addOnAttachment: { __type: 'CalculateCartItemsAddOnAttachmentInput' },
    beneficiaryClientId: { __type: 'ID' },
    chargeSetupFeeUpFront: { __type: 'Boolean' },
    creditValidUntilDate: { __type: 'String' },
    discountAppliesToAllPayments: { __type: 'Boolean' },
    discountScope: { __type: 'AddOnDiscountScope' },
    enableAutoRenew: { __type: 'Boolean!' },
    oneTimeSetupFee: { __type: 'Numeric' },
    paidInFullCycles: { __type: 'Float' },
    payUpFront: { __type: 'Boolean' },
    proratedAmount: { __type: 'Numeric' },
    prorationEndDate: { __type: 'String' },
    prorationStartDate: { __type: 'String' },
    serviceFirstBillingDate: { __type: 'String!' },
    serviceStartDate: { __type: 'String!' },
    serviceTemplateId: { __type: 'ID!' },
    signedClientAgreementId: { __type: 'ID' },
    signedClientAgreementIds: { __type: '[ID!]' },
  },
  CreateLeaderboardConfigInputInput: {
    autoRollover: { __type: 'Boolean!' },
    config: { __type: 'JSONObject!' },
    customEndDate: { __type: 'String' },
    customStartDate: { __type: 'String' },
    description: { __type: 'String' },
    imageUrl: { __type: 'String' },
    leaderboardType: { __type: 'LeaderboardType!' },
    memberDisplayFormat: { __type: 'MemberDisplayFormat!' },
    minParticipants: { __type: 'Float!' },
    name: { __type: 'String!' },
    rankingDirection: { __type: 'RankingDirection!' },
    refreshFrequency: { __type: 'RefreshFrequency!' },
    scope: { __type: 'LeaderboardScope!' },
    scoreType: { __type: 'ScoreType!' },
    siteIds: { __type: '[String!]' },
    timePeriodType: { __type: 'TimePeriodType!' },
    visibility: { __type: 'LeaderboardVisibility!' },
  },
  CreateManualRefundInputInput: {
    amount: { __type: 'Numeric!' },
    paymentId: { __type: 'ID!' },
    reason: { __type: 'String!' },
    refundMethod: { __type: 'RefundType!' },
  },
  CreateMemberMovementRunInput: {
    attestation: { __type: 'MemberMovementAttestationInput' },
    config: { __type: 'MemberMovementConfigInput' },
    corporateId: { __type: 'ID!' },
    mode: { __type: 'MemberMovementRunMode' },
    periodEnd: { __type: 'String' },
    periodStart: { __type: 'String' },
    timezone: { __type: 'String' },
  },
  CreateOrganisationInput: {
    billingEmail: { __type: 'String!' },
    companyName: { __type: 'String!' },
    phone: { __type: 'String' },
    taxIdentifier: { __type: 'String' },
  },
  CreatePaymentsInputInput: {
    amount: { __type: 'Numeric!' },
    canCompleteCardChallenge: { __type: 'Boolean' },
    canRecoverCardChallengeRemotely: { __type: 'Boolean' },
    clientPaymentMethodId: { __type: 'ID' },
    customPaymentMethodLabel: { __type: 'String' },
    paymentMethodType: { __type: 'PaymentMethodType!' },
    saveForFutureUse: { __type: 'Boolean' },
    terminalReaderId: { __type: 'ID' },
    useTerminalCardForRecurring: { __type: 'Boolean' },
  },
  CreatePosCategoryInput: {
    description: { __type: 'String' },
    displayOrder: { __type: 'Int' },
    name: { __type: 'String!' },
    revenueTagId: { __type: 'String' },
    status: { __type: 'PosCategoryStatus!' },
  },
  CreatePosCategoryResponse: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'ID!' },
    description: { __type: 'String' },
    displayOrder: { __type: 'Int' },
    name: { __type: 'String!' },
    posCategoryId: { __type: 'ID!' },
    revenueTagId: { __type: 'String' },
    siteId: { __type: 'ID!' },
    status: { __type: 'PosCategoryStatus!' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'ID' },
  },
  CreatePosProductInput: {
    categoryId: { __type: 'ID' },
    description: { __type: 'String' },
    productName: { __type: 'String!' },
    revenueTag: { __type: 'ID' },
    supplierId: { __type: 'ID' },
    variables: { __type: '[PosProductVariableInput!]!' },
  },
  CreatePosProductResponse: { __typename: { __type: 'String!' }, posProductId: { __type: 'ID!' } },
  CreateRegionInputInput: {
    countryId: { __type: 'ID!' },
    latitude: { __type: 'Float' },
    longitude: { __type: 'Float' },
    name: { __type: 'String!' },
    zoneId: { __type: 'ID' },
  },
  CreateSavedReportCategory: {
    __typename: { __type: 'String!' },
    corporateId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    createdAtLevel: { __type: 'CreatedAtLevel!' },
    createdAtSiteId: { __type: 'String' },
    createdBy: { __type: 'String!' },
    name: { __type: 'String!' },
    savedReportCategoryId: { __type: 'String!' },
    sortOrder: { __type: 'Float!' },
    updatedAt: { __type: 'String!' },
    visibilityScope: { __type: 'VisibilityScope!' },
  },
  CreateSavedReportInputInput: {
    baseReportName: { __type: 'ReportName!' },
    categoryId: { __type: 'String' },
    columnLabels: { __type: 'JSONObject' },
    description: { __type: 'String' },
    name: { __type: 'String!' },
    savedColumns: { __type: '[String!]' },
    savedDateRange: { __type: 'CreateSavedReportSavedDateRangeInput' },
    savedFilters: { __type: 'JSONObject' },
    savedSiteIds: { __type: '[String!]' },
    savedSort: { __type: '[CreateSavedReportSavedSortInput!]' },
    siteId: { __type: 'String' },
  },
  CreateSavedReportSavedDateRangeInput: {
    from: { __type: 'String' },
    to: { __type: 'String' },
    type: { __type: 'DateRangeType!' },
    value: { __type: 'String' },
  },
  CreateSavedReportSavedSortInput: {
    column: { __type: 'String!' },
    direction: { __type: 'SortDirection!' },
  },
  CreateScheduledPushSendInput: {
    audienceType: { __type: 'ScheduledPushAudienceType!' },
    message: { __type: 'String!' },
    sendAtLocal: { __type: 'String' },
    sessionId: { __type: 'ID' },
    siteId: { __type: 'ID!' },
    title: { __type: 'String!' },
  },
  CreateServiceTemplateCancellationFeeScheduleInput: {
    basis: { __type: 'CancellationTierBasis!' },
    enabled: { __type: 'Boolean!' },
    tiers: { __type: '[CreateServiceTemplateCancellationFeeScheduleTiersInput!]!' },
  },
  CreateServiceTemplateCancellationFeeScheduleTiersInput: {
    amount: { __type: 'Numeric' },
    kind: { __type: 'CancellationFeeValueKind!' },
    percent: { __type: 'Float' },
    until: { __type: 'Float!' },
  },
  CreateServiceTemplateCancellationInput: {
    effectiveDateRule: { __type: 'CancellationEffectiveDateRule' },
    feeSchedule: { __type: 'CreateServiceTemplateCancellationFeeScheduleInput' },
    isEnabledForClient: { __type: 'Boolean!' },
    minimumTerm: { __type: 'CreateServiceTemplateCancellationMinimumTermInput' },
    noticePeriodDays: { __type: 'Float' },
  },
  CreateServiceTemplateCancellationMinimumTermAfterInput: {
    amount: { __type: 'Float!' },
    unit: { __type: 'MinimumTermAfterUnit!' },
  },
  CreateServiceTemplateCancellationMinimumTermChargeInput: {
    amount: { __type: 'Numeric!' },
    isTaxEnabled: { __type: 'Boolean!' },
    taxSettingIds: { __type: '[ID!]!' },
  },
  CreateServiceTemplateCancellationMinimumTermInput: {
    after: { __type: 'CreateServiceTemplateCancellationMinimumTermAfterInput' },
    charge: { __type: 'CreateServiceTemplateCancellationMinimumTermChargeInput' },
    enabled: { __type: 'Boolean!' },
  },
  CreateServiceTemplateCategoryInput: {
    description: { __type: 'String' },
    displayOrder: { __type: 'Float' },
    name: { __type: 'String!' },
    status: { __type: 'ServiceTemplateCategoryStatus!' },
  },
  CreateServiceTemplateCategoryResponse: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'String!' },
    description: { __type: 'String' },
    displayOrder: { __type: 'Float' },
    name: { __type: 'String!' },
    serviceTemplateCategoryId: { __type: 'String!' },
    siteId: { __type: 'String!' },
    status: { __type: 'ServiceTemplateCategoryStatus!' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'String' },
  },
  CreateServiceTemplateCreditsInput: {
    amount: { __type: 'Float' },
    creditsType: { __type: 'CreditType!' },
    expirationAmount: { __type: 'Float' },
    expirationEnabled: { __type: 'Boolean!' },
    expirationType: { __type: 'CreditExpirationType' },
    expirationUnit: { __type: 'CreditExpirationUnit' },
    order: { __type: 'Float!' },
    serviceCreditTemplateId: { __type: 'String' },
    siteSessionTypeIds: { __type: '[String!]!' },
  },
  CreateServiceTemplateFeeRevenueTagsInput: {
    cancellationFee: { __type: 'ID' },
    oneTimeSetupFee: { __type: 'ID' },
    secondaryRecurringFee: { __type: 'ID' },
    suspensionFee: { __type: 'ID' },
  },
  CreateServiceTemplateFirstCreditAllocationDateInput: {
    enabled: { __type: 'Boolean!' },
    firstCreditAllocationDateType: { __type: 'FirstCreditAllocationDateType' },
    onDate: { __type: 'String' },
  },
  CreateServiceTemplateGuestPassAllowanceCreditLinesInput: {
    credits: { __type: 'Float!' },
    serviceCreditTemplateId: { __type: 'ID' },
    siteSessionTypeIds: { __type: '[ID!]!' },
  },
  CreateServiceTemplateGuestPassAllowanceInput: {
    carryForwardCap: { __type: 'Float' },
    companionTemplateId: { __type: 'ID' },
    creditLines: { __type: '[CreateServiceTemplateGuestPassAllowanceCreditLinesInput!]' },
    enabled: { __type: 'Boolean!' },
    expiryBehaviour: { __type: 'GuestPassExpiryBehaviour' },
    intervalAmount: { __type: 'Float' },
    intervalUnit: { __type: 'BillingCycleUnit' },
    newClientsOnlyEnabled: { __type: 'Boolean' },
    passesPerInterval: { __type: 'Float' },
    siteSessionTypeIds: { __type: '[ID!]' },
  },
  CreateServiceTemplateInputInput: {
    accessSchedule: { __type: 'JSONObject' },
    accountCodeId: { __type: 'String' },
    agreementEnabled: { __type: 'Boolean' },
    agreementSendConfirmation: { __type: 'Boolean' },
    agreementText: { __type: 'String' },
    autoConvertTo: { __type: 'String' },
    autoConvertTrigger: { __type: 'AutoConvertTrigger' },
    autoRenewEnabled: { __type: 'Boolean' },
    autoRenewType: { __type: 'AutoRenewType' },
    billingAnchorDate: { __type: 'String' },
    billingCycleAmount: { __type: 'Float' },
    billingCycleUnit: { __type: 'BillingCycleUnit' },
    billingDay: { __type: 'Float' },
    cancellation: { __type: 'CreateServiceTemplateCancellationInput' },
    cancellationNoticePeriodAmount: { __type: 'Float' },
    cancellationNoticePeriodUnit: { __type: 'CancellationNoticePeriodUnit' },
    categoryId: { __type: 'String' },
    categoryName: { __type: 'String' },
    changePlanEnabled: { __type: 'Boolean' },
    chargeSetupFeeUpFront: { __type: 'Boolean' },
    clientOnlinePurchaseExpiryDate: { __type: 'String' },
    clientOnlinePurchaseExpiryEnabled: { __type: 'Boolean' },
    creditRolloverPolicy: { __type: 'CreditRolloverPolicy' },
    creditWindowEndDate: { __type: 'String' },
    credits: { __type: '[CreateServiceTemplateCreditsInput!]' },
    description: { __type: 'String' },
    displayOrder: { __type: 'Float' },
    dynamicDisplayServiceTemplateIds: { __type: '[String!]' },
    earlyAccessDurationAmount: { __type: 'Float' },
    earlyAccessDurationUnit: { __type: 'EarlyAccessDurationUnit' },
    expiryAlertInDays: { __type: 'Float' },
    extraBookingWindow: { __type: 'Float' },
    familyShareable: { __type: 'Boolean' },
    feeRevenueTags: { __type: 'CreateServiceTemplateFeeRevenueTagsInput' },
    firstCreditAllocationDate: { __type: 'CreateServiceTemplateFirstCreditAllocationDateInput' },
    futureStartDate: { __type: 'String' },
    guestPassAllowance: { __type: 'CreateServiceTemplateGuestPassAllowanceInput' },
    inheritAgreementsOnConvert: { __type: 'Boolean' },
    isAllSharedSites: { __type: 'Boolean!' },
    isClientControlEnabled: { __type: 'Boolean' },
    isDefaultForTransferredClient: { __type: 'Boolean' },
    isEnabledForCMS: { __type: 'Boolean!' },
    isFeatured: { __type: 'Boolean' },
    isIntroOffer: { __type: 'Boolean!' },
    isRestricted: { __type: 'Boolean!' },
    lengthAmount: { __type: 'Float' },
    lengthType: { __type: 'ServiceLengthType' },
    lengthUnit: { __type: 'ServiceLengthUnit' },
    limitSale: { __type: 'CreateServiceTemplateLimitSaleInput' },
    maxSharingCredits: { __type: 'Float' },
    maxSharingRecipients: { __type: 'Float' },
    minimumHomeUsageInDays: { __type: 'Float' },
    multiplePaymentOptions: { __type: 'CreateServiceTemplateMultiplePaymentOptionsInput' },
    name: { __type: 'String!' },
    newSaleDynamicDisplayServiceTemplateIds: { __type: '[String!]' },
    oneActivePerFamily: { __type: 'Boolean' },
    oneTimeSetupFee: { __type: 'Numeric' },
    oneTimeSetupFeeTaxEnabled: { __type: 'Boolean' },
    oneTimeSetupFeeTaxSettingIds: { __type: '[ID!]' },
    onlineSaleEnabled: { __type: 'Boolean!' },
    onlineSaleStartDate: { __type: 'String' },
    payUpFrontEnabled: { __type: 'Boolean' },
    price: { __type: 'Numeric!' },
    revenueTag: { __type: 'String' },
    saleAvailableFromDate: { __type: 'String' },
    saleAvailableUntilDate: { __type: 'String' },
    secondaryRecurringFee: { __type: 'CreateServiceTemplateSecondaryRecurringFeeInput' },
    selfServicePause: { __type: 'CreateServiceTemplateSelfServicePauseInput' },
    serviceFirstBillingDate: { __type: 'CreateServiceTemplateServiceFirstBillingDateInput' },
    sharedSiteIds: { __type: '[String!]!' },
    sharingCreditsAmount: { __type: 'Float' },
    sharingCreditsEnabled: { __type: 'Boolean' },
    siteAgreementTemplateId: { __type: 'String' },
    siteId: { __type: 'String!' },
    taxEnabled: { __type: 'Boolean!' },
    taxSettingIds: { __type: '[ID!]' },
    tierOrder: { __type: 'Float' },
    toServiceTemplateId: { __type: 'String' },
    type: { __type: 'ServiceTemplateType!' },
  },
  CreateServiceTemplateLimitSaleInput: {
    perAccount: { __type: 'Float' },
    perClient: { __type: 'Float' },
  },
  CreateServiceTemplateMultiplePaymentOptionsInput: {
    payNowMode: { __type: 'PaymentMode!' },
    recurringMode: { __type: 'PaymentMode!' },
  },
  CreateServiceTemplateSecondaryRecurringFeeInput: {
    amount: { __type: 'Numeric!' },
    billingCycleAmount: { __type: 'Float' },
    billingCycleUnit: { __type: 'BillingCycleUnit' },
    enabled: { __type: 'Boolean!' },
    serviceFirstBillingDate: { __type: 'CreateServiceTemplateServiceFirstBillingDateInput' },
    taxEnabled: { __type: 'Boolean' },
    taxSettingIds: { __type: '[ID!]' },
  },
  CreateServiceTemplateSelfServicePauseFeeCadenceInput: {
    amount: { __type: 'Float!' },
    unit: { __type: 'SelfServicePauseCadenceUnit!' },
  },
  CreateServiceTemplateSelfServicePauseFeeInput: {
    amount: { __type: 'Numeric' },
    cadence: { __type: 'CreateServiceTemplateSelfServicePauseFeeCadenceInput' },
    chargeMode: { __type: 'SelfServicePauseChargeMode!' },
  },
  CreateServiceTemplateSelfServicePauseInput: {
    enabled: { __type: 'Boolean!' },
    fee: { __type: 'CreateServiceTemplateSelfServicePauseFeeInput!' },
    noticePeriodDays: { __type: 'Float' },
    suspensionType: { __type: 'ServiceSuspensionType!' },
  },
  CreateServiceTemplateServiceFirstBillingDateAfterInput: {
    amount: { __type: 'Float!' },
    unit: { __type: 'FirstPaymentAfterUnit!' },
  },
  CreateServiceTemplateServiceFirstBillingDateInput: {
    after: { __type: 'CreateServiceTemplateServiceFirstBillingDateAfterInput' },
    enabled: { __type: 'Boolean!' },
    onDate: { __type: 'String' },
  },
  CreateServiceTemplateSessionTypeAddOnInput: {
    addOnName: { __type: 'String' },
    equipmentId: { __type: 'ID' },
    fromServiceTemplateId: { __type: 'ID!' },
    price: { __type: 'Numeric!' },
    siteId: { __type: 'ID!' },
    siteSessionTypeId: { __type: 'ID!' },
    taxSettingIds: { __type: '[ID!]' },
  },
  CreateSharedCreditInviteInput: {
    allocatedCredits: { __type: 'Float' },
    recipientClientId: { __type: 'ID' },
    serviceId: { __type: 'ID!' },
  },
  CreateSiteAccountCodeInput: {
    code: { __type: 'String!' },
    description: { __type: 'String' },
    title: { __type: 'String!' },
  },
  CreateSiteAdminConfigurationsFeesInput: {
    brandRebatesTemplateIds: { __type: '[String!]' },
    clientFeesTemplateId: { __type: 'String' },
    hapanaFeesTemplateId: { __type: 'String' },
    royaltiesAndFeesTemplateId: { __type: 'String' },
  },
  CreateSiteAdminConfigurationsFobCredentialFormatInput: {
    byteOrder: { __type: 'FobByteOrder!' },
    controller: { __type: 'FobController!' },
    readerFormat: { __type: 'FobReaderFormat!' },
    serialNotation: { __type: 'FobSerialNotation' },
  },
  CreateSiteAdminConfigurationsInput: {
    allowToEnableClientMultiplePaymentMethods: { __type: 'Boolean' },
    bankAccountCapabilities: { __type: 'Boolean' },
    displayAccountCreditsTab: { __type: 'Boolean' },
    displayStripeConnectPaymentGateway: { __type: 'Boolean' },
    enableAddOns: { __type: 'Boolean' },
    enableAppAndWebsiteWidgets: { __type: 'Boolean' },
    enableCorporateDashboardAndPublicApi: { __type: 'Boolean' },
    enableDigitalLocations: { __type: 'Boolean' },
    enableDoorAccess: { __type: 'Boolean' },
    enableMembershipPlanChange: { __type: 'Boolean' },
    enableOfflineDoorSync: { __type: 'Boolean' },
    enableSharedSites: { __type: 'Boolean' },
    enableTanningFeatures: { __type: 'Boolean' },
    fees: { __type: 'CreateSiteAdminConfigurationsFeesInput' },
    fobCredentialFormat: { __type: 'CreateSiteAdminConfigurationsFobCredentialFormatInput' },
    hasBankAccountCapabilities: { __type: 'Boolean' },
    hasBankAccountRefundCapabilities: { __type: 'Boolean' },
    monthlySmsCredits: { __type: 'Float' },
    paymentGateway: { __type: 'CreateSiteAdminConfigurationsPaymentGatewayInput' },
    processingFees: { __type: 'CreateSiteAdminConfigurationsProcessingFeesInput' },
    sms: { __type: 'CreateSiteAdminConfigurationsSmsInput' },
  },
  CreateSiteAdminConfigurationsPaymentGatewayInput: {
    accountCodesEnabled: { __type: 'Boolean' },
    applePayEnabled: { __type: 'Boolean' },
    enableTerminals: { __type: 'Boolean' },
    ezypayDisplayAccountingCode: { __type: 'String' },
    googlePayEnabled: { __type: 'Boolean' },
    introOfferDefaultAccountCodeId: { __type: 'String' },
    stripeId: { __type: 'String' },
    transactionLimitAmount: { __type: 'Float' },
  },
  CreateSiteAdminConfigurationsProcessingFeesInput: {
    amexCardProcessingFlatFee: { __type: 'Float' },
    amexCardProcessingPercentageFee: { __type: 'Float' },
    bankProcessingFlatFee: { __type: 'Float' },
    bankProcessingPercentageFee: { __type: 'Float' },
    cardProcessingFlatFee: { __type: 'Float' },
    cardProcessingPercentageFee: { __type: 'Float' },
  },
  CreateSiteAdminConfigurationsSmsInput: {
    fromName: { __type: 'String' },
    twilioSubaccount: { __type: 'CreateSiteAdminConfigurationsSmsTwilioSubaccountInput' },
  },
  CreateSiteAdminConfigurationsSmsTwilioSubaccountInput: {
    id: { __type: 'String' },
    token: { __type: 'String' },
  },
  CreateSiteAlertInput: {
    amenityId: { __type: 'ID' },
    body: { __type: 'String' },
    endsAt: { __type: 'String' },
    linkLabel: { __type: 'String' },
    linkUrl: { __type: 'String' },
    marksLocationClosed: { __type: 'Boolean!' },
    showAsPopup: { __type: 'Boolean!' },
    siteId: { __type: 'ID!' },
    startsAt: { __type: 'String' },
    theme: { __type: 'SiteAlertTheme!' },
    title: { __type: 'String!' },
  },
  CreateSiteBusinessHoursCustomHoursInput: {
    friday: { __type: 'CreateSiteBusinessHoursCustomHoursMondayInput' },
    monday: { __type: 'CreateSiteBusinessHoursCustomHoursMondayInput' },
    saturday: { __type: 'CreateSiteBusinessHoursCustomHoursMondayInput' },
    sunday: { __type: 'CreateSiteBusinessHoursCustomHoursMondayInput' },
    thursday: { __type: 'CreateSiteBusinessHoursCustomHoursMondayInput' },
    tuesday: { __type: 'CreateSiteBusinessHoursCustomHoursMondayInput' },
    wednesday: { __type: 'CreateSiteBusinessHoursCustomHoursMondayInput' },
  },
  CreateSiteBusinessHoursCustomHoursMondayInput: {
    endTime: { __type: 'String!' },
    startTime: { __type: 'String!' },
  },
  CreateSiteBusinessHoursExceptionsInput: {
    date: { __type: 'String!' },
    id: { __type: 'ID!' },
    isClosed: { __type: 'Boolean!' },
    label: { __type: 'String!' },
    ranges: { __type: '[CreateSiteBusinessHoursWeeklyMondayRangesInput!]!' },
  },
  CreateSiteBusinessHoursInput: {
    customHours: { __type: 'CreateSiteBusinessHoursCustomHoursInput' },
    endTime: { __type: 'String' },
    exceptions: { __type: '[CreateSiteBusinessHoursExceptionsInput!]' },
    hasCustomHours: { __type: 'Boolean!' },
    is24x7: { __type: 'Boolean' },
    startTime: { __type: 'String' },
    weekly: { __type: 'CreateSiteBusinessHoursWeeklyInput' },
  },
  CreateSiteBusinessHoursWeeklyInput: {
    friday: { __type: 'CreateSiteBusinessHoursWeeklyMondayInput!' },
    monday: { __type: 'CreateSiteBusinessHoursWeeklyMondayInput!' },
    saturday: { __type: 'CreateSiteBusinessHoursWeeklyMondayInput!' },
    sunday: { __type: 'CreateSiteBusinessHoursWeeklyMondayInput!' },
    thursday: { __type: 'CreateSiteBusinessHoursWeeklyMondayInput!' },
    tuesday: { __type: 'CreateSiteBusinessHoursWeeklyMondayInput!' },
    wednesday: { __type: 'CreateSiteBusinessHoursWeeklyMondayInput!' },
  },
  CreateSiteBusinessHoursWeeklyMondayInput: {
    isClosed: { __type: 'Boolean!' },
    ranges: { __type: '[CreateSiteBusinessHoursWeeklyMondayRangesInput!]!' },
  },
  CreateSiteBusinessHoursWeeklyMondayRangesInput: {
    closesAt: { __type: 'String!' },
    opensAt: { __type: 'String!' },
  },
  CreateSiteCustomIntegrationsInput: {
    integrationId: { __type: 'ID!' },
    keyValues: { __type: '[CreateSiteCustomIntegrationsKeyValuesInput!]!' },
  },
  CreateSiteCustomIntegrationsKeyValuesInput: {
    key: { __type: 'ID!' },
    value: { __type: 'String' },
  },
  CreateSiteFormInputInput: { description: { __type: 'String!' }, name: { __type: 'String!' } },
  CreateSiteGroupInputInput: { name: { __type: 'String!' }, siteIds: { __type: '[ID!]!' } },
  CreateSiteInputInput: {
    addressCity: { __type: 'String' },
    addressCountry: { __type: 'String' },
    addressPostalCode: { __type: 'String' },
    addressState: { __type: 'String' },
    addressStreet: { __type: 'String' },
    addressStreet2: { __type: 'String' },
    adminConfigurations: { __type: 'CreateSiteAdminConfigurationsInput' },
    appName: { __type: 'String' },
    businessEmail: { __type: 'String' },
    businessHours: { __type: 'CreateSiteBusinessHoursInput' },
    capacity: { __type: 'Float' },
    clientFeesTemplateId: { __type: 'String' },
    connectedSharedSiteIds: { __type: '[String!]' },
    corePlanLevel: { __type: 'CorePlanLevel' },
    countryId: { __type: 'ID' },
    customIntegrations: { __type: '[CreateSiteCustomIntegrationsInput!]' },
    description: { __type: 'String' },
    displayBusinessHours: { __type: 'Boolean!' },
    email: { __type: 'String' },
    gatewayCurrentPaymentMethodId: { __type: 'String' },
    gatewayCustomerId: { __type: 'String' },
    hapanaFeesTemplateId: { __type: 'ID' },
    integrations: { __type: 'CreateSiteIntegrationsInput' },
    isDigital: { __type: 'Boolean' },
    membersCount: { __type: 'Float' },
    name: { __type: 'String!' },
    openDate: { __type: 'String' },
    phone: { __type: 'String' },
    phonePrefix: { __type: 'String' },
    rebateTemplateIds: { __type: '[ID!]' },
    regionId: { __type: 'ID' },
    royaltiesTemplateId: { __type: 'ID' },
    stateId: { __type: 'String' },
    timezone: { __type: 'String' },
    v1EncryptedId: { __type: 'String' },
    website: { __type: 'String' },
    workshopType: { __type: 'SiteWorkshopType!' },
  },
  CreateSiteIntegrationsBarcodeUrlInput: { barcodeCheckInUrl: { __type: 'String' } },
  CreateSiteIntegrationsCalendarSyncCalendarsInput: {
    calendarId: { __type: 'String!' },
    calendarLink: { __type: 'String!' },
    calendarName: { __type: 'String!' },
  },
  CreateSiteIntegrationsCalendarSyncInput: {
    calendars: { __type: '[CreateSiteIntegrationsCalendarSyncCalendarsInput!]' },
  },
  CreateSiteIntegrationsEgymInput: {
    activeMembershipType: { __type: 'EgymMembershipType!' },
    consecutiveFailures: { __type: 'Float' },
    enabled: { __type: 'Boolean!' },
    lastError: { __type: 'String' },
    lastFailureAt: { __type: 'String' },
    lastSuccessAt: { __type: 'String' },
  },
  CreateSiteIntegrationsFitnessPassportInput: {
    deviceTokenSuffix: { __type: 'String' },
    enabled: { __type: 'Boolean!' },
    failurePolicy: { __type: 'FitnessPassportFailurePolicy!' },
    lastTestError: { __type: 'String' },
    lastTestOutcome: { __type: 'FitnessPassportConnectionState' },
    lastTestedAt: { __type: 'String' },
    siteTokenSuffix: { __type: 'String' },
  },
  CreateSiteIntegrationsFrontDeskKioskBetaVersionInput: {
    classCheckInEnabled: { __type: 'Boolean' },
    classCheckInRequirePolicies: { __type: 'Boolean' },
    classCheckInSpotBooking: { __type: 'Boolean' },
    enabled: { __type: 'Boolean' },
    introOffersEnabled: { __type: 'Boolean' },
    kioskPinHash: { __type: 'String' },
    kioskPinSetAt: { __type: 'String' },
    kioskSessionId: { __type: 'String' },
    kioskSessionValidityDays: { __type: 'Float' },
    kioskUrlV2: { __type: 'String' },
    packagesMembershipsEnabled: { __type: 'Boolean' },
  },
  CreateSiteIntegrationsFrontDeskKioskInput: {
    betaVersion: { __type: 'CreateSiteIntegrationsFrontDeskKioskBetaVersionInput' },
    kioskDefaults: { __type: 'CreateSiteIntegrationsFrontDeskKioskKioskDefaultsInput' },
    kioskUrlV1: { __type: 'String' },
  },
  CreateSiteIntegrationsFrontDeskKioskKioskDefaultsInput: {
    checkIn: { __type: 'Boolean' },
    classCheckIn: { __type: 'Boolean' },
    forms: { __type: 'Boolean' },
    introOffers: { __type: 'Boolean' },
    manageAccount: { __type: 'Boolean' },
    packages: { __type: 'Boolean' },
  },
  CreateSiteIntegrationsGrowAuthenticationInput: {
    accessToken: { __type: 'String!' },
    expiresAt: { __type: 'String!' },
    refreshToken: { __type: 'String!' },
  },
  CreateSiteIntegrationsGrowInput: {
    authentication: { __type: 'CreateSiteIntegrationsGrowAuthenticationInput' },
    enabled: { __type: 'Boolean!' },
    growLocationId: { __type: 'String' },
    hqId: { __type: 'String' },
    lastCollect: { __type: 'CreateSiteIntegrationsGrowLastCollectInput' },
  },
  CreateSiteIntegrationsGrowLastCollectInput: {
    full: { __type: 'String' },
    partial: { __type: 'String' },
  },
  CreateSiteIntegrationsHapanaApiKeyInput: { apiKey: { __type: 'String' } },
  CreateSiteIntegrationsImportClientsInput: {
    enabled: { __type: 'Boolean' },
    lastImportDate: { __type: 'String' },
  },
  CreateSiteIntegrationsInput: {
    accessControls: { __type: 'UpdateAccessControlsInputInput' },
    accuroFit: { __type: 'UpdateAccuroFitInputInput' },
    barcodeUrl: { __type: 'CreateSiteIntegrationsBarcodeUrlInput' },
    calendarSync: { __type: 'CreateSiteIntegrationsCalendarSyncInput' },
    classPass: { __type: 'UpdateClassPassInputInput' },
    egym: { __type: 'CreateSiteIntegrationsEgymInput' },
    externalFeedbackLink: { __type: 'UpdateExternalFeedbackLinkInputInput' },
    facebookPixel: { __type: 'UpdateFacebookPixelInputInput' },
    fitnessPassport: { __type: 'CreateSiteIntegrationsFitnessPassportInput' },
    frontDeskKiosk: { __type: 'CreateSiteIntegrationsFrontDeskKioskInput' },
    googleTagManager: { __type: 'UpdateGoogleTagManagerInputInput' },
    grow: { __type: 'CreateSiteIntegrationsGrowInput' },
    hapanaAccessController: { __type: 'UpdateHapanaAccessControllerInputInput' },
    hapanaApiKey: { __type: 'CreateSiteIntegrationsHapanaApiKeyInput' },
    importClients: { __type: 'CreateSiteIntegrationsImportClientsInput' },
    spivi: { __type: 'UpdateSpiviInputInput' },
    tanning: { __type: 'CreateSiteIntegrationsTanningInput' },
    tanningHealth: { __type: 'CreateSiteIntegrationsTanningHealthInput' },
    topaz: { __type: 'UpdateTopazInputInput' },
    wellhub: { __type: 'CreateSiteIntegrationsWellhubInput' },
    zapier: { __type: 'UpdateZapierInputInput' },
    zoom: { __type: 'CreateSiteIntegrationsZoomInput' },
  },
  CreateSiteIntegrationsTanningHealthInput: {
    consecutiveStartFailures: { __type: 'Float' },
    lastBedUpdateAt: { __type: 'String' },
    lastRegisteredAt: { __type: 'String' },
    lastStartError: { __type: 'CreateSiteIntegrationsTanningHealthLastStartErrorInput' },
    lastStartFailureAt: { __type: 'String' },
    lastStartSuccessAt: { __type: 'String' },
  },
  CreateSiteIntegrationsTanningHealthLastStartErrorInput: {
    connectorCode: { __type: 'String' },
    kind: { __type: 'TanningConnectorErrorKind!' },
    message: { __type: 'String!' },
  },
  CreateSiteIntegrationsTanningInput: {
    apiKey: { __type: 'String' },
    externalApiKey: { __type: 'String' },
    externalApiUrl: { __type: 'String' },
    maintenanceEmail: { __type: 'String' },
  },
  CreateSiteIntegrationsWellhubInput: {
    connectedAt: { __type: 'String' },
    enabled: { __type: 'Boolean!' },
    gymId: { __type: 'String' },
    gymName: { __type: 'String' },
  },
  CreateSiteIntegrationsZoomAuthenticationInput: {
    accessToken: { __type: 'String!' },
    expiresAt: { __type: 'String!' },
    refreshToken: { __type: 'String!' },
  },
  CreateSiteIntegrationsZoomInput: {
    accountId: { __type: 'String' },
    authentication: { __type: 'CreateSiteIntegrationsZoomAuthenticationInput' },
    authorized: { __type: 'Boolean!' },
    connectedAt: { __type: 'String' },
    connectedUserEmail: { __type: 'String' },
    connectedUserId: { __type: 'String' },
    userId: { __type: 'String' },
  },
  CreateSiteLocationInput: {
    addressLine1: { __type: 'String' },
    addressLine2: { __type: 'String' },
    channelId: { __type: 'String' },
    city: { __type: 'String' },
    country: { __type: 'String' },
    isDefault: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    postalCode: { __type: 'String' },
    rooms: { __type: '[CreateSiteLocationRoomInput!]' },
    state: { __type: 'String' },
    type: { __type: 'SiteLocationType!' },
  },
  CreateSiteLocationResponse: {
    __typename: { __type: 'String!' },
    locationId: { __type: 'String' },
    message: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  CreateSiteLocationRoomCustomHoursInput: {
    friday: { __type: 'CreateSiteLocationRoomCustomHoursMondayInput' },
    monday: { __type: 'CreateSiteLocationRoomCustomHoursMondayInput' },
    saturday: { __type: 'CreateSiteLocationRoomCustomHoursMondayInput' },
    sunday: { __type: 'CreateSiteLocationRoomCustomHoursMondayInput' },
    thursday: { __type: 'CreateSiteLocationRoomCustomHoursMondayInput' },
    tuesday: { __type: 'CreateSiteLocationRoomCustomHoursMondayInput' },
    wednesday: { __type: 'CreateSiteLocationRoomCustomHoursMondayInput' },
  },
  CreateSiteLocationRoomCustomHoursMondayInput: {
    endTime: { __type: 'String!' },
    startTime: { __type: 'String!' },
  },
  CreateSiteLocationRoomInput: {
    allowOverlapping: { __type: 'Boolean!' },
    customHours: { __type: 'CreateSiteLocationRoomCustomHoursInput' },
    endTime: { __type: 'String' },
    hasResourceBooking: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    roomResourceTemplateId: { __type: 'String' },
    sameHoursAsLocation: { __type: 'Boolean!' },
    startTime: { __type: 'String' },
  },
  CreateSitePayrollTier: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    deletedAt: { __type: 'String' },
    name: { __type: 'String!' },
    siteId: { __type: 'ID!' },
    sitePayrollTierId: { __type: 'ID!' },
    updatedAt: { __type: 'String!' },
  },
  CreateSitePayrollTierConfiguration: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    deletedAt: { __type: 'String' },
    payrollTierConfigurationId: { __type: 'ID!' },
    payrollType: { __type: 'PayrollType!' },
    rates: { __type: 'SitePayrollTierConfigurationsRates!' },
    siteId: { __type: 'ID!' },
    sitePayrollTierId: { __type: 'ID!' },
    siteSessionTypeId: { __type: 'ID' },
    siteSessionTypeName: { __type: 'String' },
    type: { __type: 'PayrollTierType!' },
    updatedAt: { __type: 'String!' },
  },
  CreateSitePayrollTierConfigurationInputInput: {
    payrollType: { __type: 'PayrollType!' },
    rates: { __type: 'CreateSitePayrollTierConfigurationRatesInput!' },
    siteSessionTypeId: { __type: 'ID' },
    type: { __type: 'PayrollTierType!' },
  },
  CreateSitePayrollTierConfigurationRatesInput: {
    bonusClassFull: { __type: 'Float' },
    bonusFlat: { __type: 'Float' },
    bonusPerClient: { __type: 'Float' },
    clientOver: { __type: 'Float' },
    flat: { __type: 'Float' },
    hourly: { __type: 'Float' },
    perHead: { __type: 'Float' },
    percentage: { __type: 'Float' },
    unlimitedFixed: { __type: 'Float' },
  },
  CreateSitePayrollTierInputInput: { name: { __type: 'String!' } },
  CreateSitePolicyInputInput: {
    acceptanceMethod: { __type: 'PolicyAcceptanceMethod' },
    content: { __type: 'String!' },
    equipmentScope: { __type: '[PolicyEquipmentScope!]' },
    guardianInPersonOnly: { __type: 'Boolean' },
    isRequiredToAgree: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    renewalMonths: { __type: 'Float' },
    requiredForEquipmentUse: { __type: 'Boolean' },
    signerRule: { __type: 'PolicySignerRule' },
  },
  CreateSiteRoomResourceTemplateInput: {
    bookingProperties: { __type: '[CreateSiteRoomResourceTemplatePropertyInput!]' },
    boxId: { __type: 'Float' },
    description: { __type: 'String' },
    isDefault: { __type: 'Boolean!' },
    isDraft: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    spotHeight: { __type: 'Float' },
    spotWidth: { __type: 'Float' },
    spots: { __type: '[CreateSiteRoomResourceTemplateSpotsInput!]!' },
  },
  CreateSiteRoomResourceTemplatePropertyInput: {
    defaultValue: { __type: 'String' },
    isRequired: { __type: 'Boolean!' },
    name: { __type: 'String' },
    orderIndex: { __type: 'Float!' },
    primaryPropertyType: { __type: 'RoomResourceTemplateBookingPropertyTypes' },
    siteCustomPropertyId: { __type: 'String' },
    type: { __type: 'SiteRoomResourceTemplatePropertyTypes!' },
  },
  CreateSiteRoomResourceTemplateSpotsInput: {
    enabled: { __type: 'Boolean!' },
    equipmentType: { __type: 'EquipmentType!' },
    height: { __type: 'Float!' },
    name: { __type: 'String!' },
    position: { __type: 'String!' },
    width: { __type: 'Float!' },
    x: { __type: 'Float!' },
    y: { __type: 'Float!' },
  },
  CreateSiteSettingsCustomizationColorInputInput: { color: { __type: 'String!' } },
  CreateSiteSupplierInput: {
    address: { __type: 'String' },
    name: { __type: 'String!' },
    phone: { __type: 'String' },
    status: { __type: 'SiteSupplierStatus!' },
  },
  CreateSiteSupplierResponse: {
    __typename: { __type: 'String!' },
    address: { __type: 'String' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'String!' },
    name: { __type: 'String!' },
    phone: { __type: 'String' },
    siteId: { __type: 'String!' },
    siteSupplierId: { __type: 'String!' },
    status: { __type: 'SiteSupplierStatus!' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'String' },
  },
  CreateSiteWebhook: {
    __typename: { __type: 'String!' },
    consecutiveFailures: { __type: 'Float!' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'String' },
    events: { __type: '[String!]!' },
    headerKey: { __type: 'String' },
    headerValue: { __type: 'String' },
    lastDeliveryAt: { __type: 'String' },
    lastSuccessAt: { __type: 'String' },
    name: { __type: 'String!' },
    secret: { __type: 'String' },
    secretHash: { __type: 'String!' },
    siteWebhookId: { __type: 'String!' },
    status: { __type: 'SiteWebhookStatus!' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'String' },
    url: { __type: 'String!' },
    v1EncryptedId: { __type: 'String!' },
  },
  CreateSiteWebhookInputInput: {
    events: { __type: '[String!]!' },
    headerKey: { __type: 'String' },
    headerValue: { __type: 'String' },
    name: { __type: 'String!' },
    url: { __type: 'String!' },
  },
  CreateSoapNoteResponse: {
    __typename: { __type: 'String!' },
    message: { __type: 'String' },
    note: { __type: 'SoapNote' },
    success: { __type: 'Boolean!' },
  },
  CreateStaffAccessPolicyInputInput: {
    accessPermissions: { __type: '[AccessPermissions!]' },
    allowedNetworkIds: { __type: '[ID!]' },
    corporatePermissions: { __type: '[CorporatePermissions!]' },
    name: { __type: 'String!' },
    sitePermissions: { __type: '[SitePermissions!]' },
  },
  CreateStaffAllowedNetworkInputInput: {
    address: { __type: 'String!' },
    label: { __type: 'String!' },
    notes: { __type: 'String' },
    siteId: { __type: 'ID' },
  },
  CreateStaffUserDataInput: {
    isInstructor: { __type: 'Boolean' },
    payrollId: { __type: 'String' },
    siteId: { __type: 'ID' },
    workingHours: { __type: 'UpdateWorkingHoursWorkingHoursInput' },
  },
  CreateStaffUserInputInput: {
    about: { __type: 'String!' },
    allowedNetworkIds: { __type: '[ID!]' },
    allowedNetworksSiteId: { __type: 'ID' },
    data: { __type: 'CreateStaffUserDataInput' },
    dateOfBirth: { __type: 'String' },
    email: { __type: 'String!' },
    employeeNumber: { __type: 'Float' },
    firstName: { __type: 'String!' },
    gender: { __type: 'String' },
    hobbies: { __type: 'String!' },
    instagramHandle: { __type: 'String!' },
    lastName: { __type: 'String!' },
    phone: { __type: 'String!' },
    rules: { __type: '[AddAccessRuleInputInput!]!' },
    siteData: { __type: 'CreateStaffUserDataInput' },
    status: { __type: 'StaffUserStatus!' },
  },
  CreateStaffUserSmartGroupFiltersInput: {
    ageRange: { __type: 'ClientFiltersAgeRangeInput' },
    attendanceMilestone: { __type: 'ClientFiltersNoShowLateCancelAccrualInput' },
    birthMonth: { __type: 'ClientFiltersGenderInput' },
    clientStatus: { __type: 'ClientFiltersGenderInput' },
    contractStatus: { __type: 'ClientFiltersGenderInput' },
    contractType: { __type: 'ClientFiltersGenderInput' },
    daysAbsent: { __type: 'ClientFiltersAgeRangeInput' },
    daysInactive: { __type: 'ClientFiltersAgeRangeInput' },
    email: { __type: 'ClientFiltersFirstNameInput' },
    emailOptIn: { __type: 'ClientFiltersGenderInput' },
    failedPaymentsCount: { __type: 'ClientFiltersNoShowLateCancelAccrualInput' },
    firstName: { __type: 'ClientFiltersFirstNameInput' },
    fullName: { __type: 'ClientFiltersFirstNameInput' },
    gender: { __type: 'ClientFiltersGenderInput' },
    hasCreditsForSessionType: { __type: 'ClientFiltersHasCreditsForSessionTypeInput' },
    isSuspended: { __type: 'ClientFiltersGenderInput' },
    joinDate: { __type: 'ClientFiltersJoinDateInput' },
    lastAttendanceDate: { __type: 'ClientFiltersJoinDateInput' },
    lastName: { __type: 'ClientFiltersFirstNameInput' },
    lastPaymentDate: { __type: 'ClientFiltersJoinDateInput' },
    lastVisitDate: { __type: 'ClientFiltersJoinDateInput' },
    locationStatus: { __type: 'ClientFiltersGenderInput' },
    masterUnsubscribe: { __type: 'ClientFiltersGenderInput' },
    noShowLateCancelAccrual: { __type: 'ClientFiltersNoShowLateCancelAccrualInput' },
    phone: { __type: 'ClientFiltersFirstNameInput' },
    profileCreatedDate: { __type: 'ClientFiltersJoinDateInput' },
    sessionFrequency: { __type: 'ClientFiltersGenderInput' },
    smsOptIn: { __type: 'ClientFiltersGenderInput' },
  },
  CreateStaffUserSmartGroupInputInput: {
    filters: { __type: 'CreateStaffUserSmartGroupFiltersInput' },
    isVisible: { __type: 'Boolean!' },
    name: { __type: 'String!' },
  },
  CreateStripeAccountSession: {
    __typename: { __type: 'String!' },
    clientSecret: { __type: 'String!' },
    expiresAt: { __type: 'Float!' },
  },
  CreateSupportTicketInput: {
    brandId: { __type: 'String' },
    brandName: { __type: 'String' },
    chatHistory: { __type: '[TicketChatMessageInput!]' },
    chatId: { __type: 'String' },
    corporateId: { __type: 'String' },
    corporateName: { __type: 'String' },
    currentUrl: { __type: 'String' },
    description: { __type: 'String!' },
    email: { __type: 'String!' },
    environment: { __type: 'String' },
    fields: { __type: '[SupportTicketFieldInput!]' },
    firstName: { __type: 'String!' },
    issueType: { __type: 'SupportIssueType' },
    lastName: { __type: 'String!' },
    locationId: { __type: 'String' },
    locationName: { __type: 'String' },
    pageName: { __type: 'String' },
    pathname: { __type: 'String' },
    planTier: { __type: 'String' },
    posthogDistinctId: { __type: 'String' },
    posthogSessionUrl: { __type: 'String' },
    screenshots: { __type: '[ScreenshotInput!]' },
    siteId: { __type: 'String' },
    siteName: { __type: 'String' },
    subject: { __type: 'String' },
    userId: { __type: 'String' },
    userRole: { __type: 'String' },
  },
  CreateTaxSettingInputInput: {
    enabled: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    rate: { __type: 'String!' },
    setting: { __type: 'TaxSettingType!' },
  },
  CreateTerminalHandoffRequestAgreementsInput: {
    agreementId: { __type: 'ID' },
    inlineContent: { __type: 'String' },
    inlineName: { __type: 'String' },
    reference: { __type: 'String!' },
    siteAgreementTemplateId: { __type: 'ID' },
  },
  CreateTerminalHandoffRequestInput: {
    agreements: { __type: '[CreateTerminalHandoffRequestAgreementsInput!]!' },
    clientId: { __type: 'ID!' },
    fields: { __type: '[TerminalHandoffField!]!' },
    siteId: { __type: 'ID!' },
    siteTerminalReaderId: { __type: 'ID!' },
    sourceSurface: { __type: 'TerminalHandoffSourceSurface!' },
  },
  CredentialField: {
    __typename: { __type: 'String!' },
    key: { __type: 'String!' },
    label: { __type: 'String!' },
    required: { __type: 'Boolean!' },
    type: { __type: 'CredentialFieldType!' },
  },
  CreditAdjustmentNote: {
    __typename: { __type: 'String!' },
    amount: { __type: 'Float!' },
    authorId: { __type: 'String' },
    direction: { __type: 'ServiceCreditLedgerDirection!' },
    note: { __type: 'String!' },
    timestamp: { __type: 'String!' },
  },
  CreditAdjustmentNotesResult: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasMore: { __type: 'Boolean!' },
    notes: { __type: '[CreditAdjustmentNote!]!' },
  },
  CreditBalanceAllocationSnapshot: {
    __typename: { __type: 'String!' },
    activateOnFirstUse: { __type: 'Boolean' },
    allocated: { __type: 'Float' },
    allocationId: { __type: 'String!' },
    balance: { __type: 'Float' },
    consumed: { __type: 'Float!' },
    creditType: { __type: 'CreditType!' },
    expirationAmount: { __type: 'Float' },
    expirationUnit: { __type: 'String' },
    expiresAt: { __type: 'String' },
    sessionTypeId: { __type: 'String' },
    sessionTypeIds: { __type: '[String!]' },
    sessionTypeName: { __type: 'String' },
    validFrom: { __type: 'String' },
    validTo: { __type: 'String' },
  },
  CreditBalanceSnapshot: {
    __typename: { __type: 'String!' },
    allocations: { __type: '[CreditBalanceAllocationSnapshot!]!' },
    hasUnlimited: { __type: 'Boolean!' },
    lastUpdated: { __type: 'String!' },
    totalBalance: { __type: 'Float' },
  },
  CreditBalanceSnapshotOutput: {
    __typename: { __type: 'String!' },
    allocations: { __type: '[CreditBalanceSnapshotOutputAllocations!]' },
    hasUnlimited: { __type: 'Boolean!' },
    lastUpdated: { __type: 'String' },
    totalBalance: { __type: 'Float' },
  },
  CreditBalanceSnapshotOutputAllocations: {
    __typename: { __type: 'String!' },
    activateOnFirstUse: { __type: 'Boolean' },
    allocated: { __type: 'Float' },
    allocationId: { __type: 'String!' },
    balance: { __type: 'Float' },
    consumed: { __type: 'Float!' },
    creditType: { __type: 'String!' },
    expirationAmount: { __type: 'Float' },
    expirationUnit: { __type: 'String' },
    expiresAt: { __type: 'String' },
    sessionTypeId: { __type: 'String' },
    sessionTypeIds: { __type: '[String!]' },
    sessionTypeName: { __type: 'String' },
    validFrom: { __type: 'String' },
    validTo: { __type: 'String' },
  },
  CreditSummaryPeriod: {
    __typename: { __type: 'String!' },
    activationExpiryDescription: { __type: 'String' },
    creditExpiresAtDate: { __type: 'String' },
    creditsAllocated: { __type: 'Float!' },
    creditsConsumed: { __type: 'Float!' },
    hasRefund: { __type: 'Boolean!' },
    isActivationPending: { __type: 'Boolean' },
    isActive: { __type: 'Boolean' },
    isMaterialized: { __type: 'Boolean!' },
    isUnlimited: { __type: 'Boolean!' },
    periodEndDate: { __type: 'String' },
    periodId: { __type: 'String!' },
    periodNumber: { __type: 'Float!' },
    periodStartDate: { __type: 'String' },
    sessionTypeBreakdown: { __type: '[CreditSummaryPeriodSessionTypeBreakdown!]' },
  },
  CreditSummaryPeriodSessionTypeBreakdown: {
    __typename: { __type: 'String!' },
    creditsAllocated: { __type: 'Float!' },
    creditsConsumed: { __type: 'Float!' },
    creditsRemaining: { __type: 'Float!' },
    isUnlimited: { __type: 'Boolean!' },
    sessionTypeName: { __type: 'String' },
    siteSessionTypeIds: { __type: '[String!]!' },
  },
  CreditSummaryResult: {
    __typename: { __type: 'String!' },
    periods: { __type: '[CreditSummaryPeriod!]!' },
    totalPeriods: { __type: 'Float!' },
  },
  CreditUsageEntry: {
    __typename: { __type: 'String!' },
    amount: { __type: 'Float' },
    bookingId: { __type: 'String' },
    bookingStatus: { __type: 'BookingStatus' },
    createdAt: { __type: 'String!' },
    direction: { __type: 'ServiceCreditLedgerDirection!' },
    isBuddyBooking: { __type: 'Boolean' },
    isSharedBooking: { __type: 'Boolean' },
    isWaitlistEntry: { __type: 'Boolean' },
    ledgerId: { __type: 'String!' },
    notes: { __type: 'String' },
    sessionDate: { __type: 'String' },
    sessionName: { __type: 'String' },
    sessionStartTime: { __type: 'String' },
    sessionTypeName: { __type: 'String' },
    siteId: { __type: 'String!' },
    siteName: { __type: 'String' },
    siteSessionTypeId: { __type: 'String' },
    transactionType: { __type: 'ServiceCreditLedgerTransactionType!' },
    usedByClientName: { __type: 'String' },
  },
  CreditUsageHistoryResult: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'CreditUsageHistoryResultPageInfo!' },
    results: { __type: '[CreditUsageHistoryResultResults!]!' },
    totalCreditsUsed: { __type: 'Float!' },
  },
  CreditUsageHistoryResultPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  CreditUsageHistoryResultResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'CreditUsageEntry!' },
  },
  CreditsCoverSessionResult: {
    __typename: { __type: 'String!' },
    creditsAvailable: { __type: 'Float!' },
    hasCredits: { __type: 'Boolean!' },
    packages: { __type: '[ClientBookingPackage!]!' },
  },
  CrossCategoryScheduledPlanChange: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'ID!' },
    clientName: { __type: 'String!' },
    effectiveDate: { __type: 'String!' },
    fromServiceTemplateName: { __type: 'String!' },
    serviceId: { __type: 'ID!' },
    servicePlanChangeId: { __type: 'ID!' },
    status: { __type: 'ServicePlanChangeStatus!' },
    toServiceTemplateName: { __type: 'String!' },
  },
  CustomLink: {
    __typename: { __type: 'String!' },
    customLinkId: { __type: 'String!' },
    icon: { __type: 'String!' },
    isVisible: { __type: 'Boolean!' },
    label: { __type: 'String!' },
    openingMethod: { __type: 'CustomLinkOpeningMethod!' },
    order: { __type: 'Float!' },
    url: { __type: 'String!' },
  },
  CustomProperty: {
    __typename: { __type: 'String!' },
    alerts: { __type: '[CustomPropertyAlerts!]' },
    category: { __type: 'CustomPropertyCategory!' },
    createdAt: { __type: 'String' },
    deletedAt: { __type: 'String' },
    enableClientEditing: { __type: 'Boolean!' },
    growId: { __type: 'String' },
    hasSubtext: { __type: 'Boolean!' },
    id: { __type: 'String!' },
    name: { __type: 'String!' },
    options: { __type: '[CustomPropertyOptions!]' },
    siteId: { __type: 'String!' },
    subtext: { __type: 'String' },
    type: { __type: 'CustomPropertyType!' },
    updatedAt: { __type: 'String' },
  },
  CustomPropertyAlertCreateInput: {
    isDisplayPropertyValueAsAlert: { __type: 'Boolean!' },
    operator: { __type: 'AlertOperator!' },
    text: { __type: 'String' },
    value: { __type: 'String' },
  },
  CustomPropertyAlertUpdateInput: {
    isDisplayPropertyValueAsAlert: { __type: 'Boolean' },
    operator: { __type: 'AlertOperator' },
    text: { __type: 'String' },
    value: { __type: 'String' },
  },
  CustomPropertyAlerts: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String' },
    deletedAt: { __type: 'String' },
    id: { __type: 'String' },
    isDisplayPropertyValueAsAlert: { __type: 'Boolean!' },
    operator: { __type: 'AlertOperator!' },
    propertyId: { __type: 'String' },
    text: { __type: 'String' },
    updatedAt: { __type: 'String' },
    value: { __type: 'String' },
  },
  CustomPropertyCreateInput: {
    category: { __type: 'CustomPropertyCategory!' },
    enableClientEditing: { __type: 'Boolean!' },
    growId: { __type: 'String' },
    hasSubtext: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    options: { __type: '[CustomPropertyCreateOptionsInput!]' },
    subtext: { __type: 'String' },
    type: { __type: 'CustomPropertyType!' },
  },
  CustomPropertyCreateOptionsInput: {
    displayOrder: { __type: 'Float' },
    option: { __type: 'String!' },
  },
  CustomPropertyOptions: {
    __typename: { __type: 'String!' },
    displayOrder: { __type: 'Float' },
    id: { __type: 'String' },
    option: { __type: 'String!' },
  },
  CustomPropertyUpdateInput: {
    category: { __type: 'CustomPropertyCategory' },
    enableClientEditing: { __type: 'Boolean' },
    growId: { __type: 'String' },
    hasSubtext: { __type: 'Boolean' },
    name: { __type: 'String' },
    options: { __type: '[CustomPropertyCreateOptionsInput!]' },
    subtext: { __type: 'String' },
    type: { __type: 'CustomPropertyType' },
  },
  CustomPropertyWithClientValue: {
    __typename: { __type: 'String!' },
    alerts: { __type: '[CustomPropertyWithClientValueAlerts!]' },
    category: { __type: 'String!' },
    clientValue: { __type: 'CustomPropertyWithClientValueClientValue' },
    createdAt: { __type: 'String' },
    deletedAt: { __type: 'String' },
    enableClientEditing: { __type: 'Boolean!' },
    growId: { __type: 'String' },
    hasSubtext: { __type: 'Boolean!' },
    id: { __type: 'String!' },
    name: { __type: 'String!' },
    options: { __type: '[CustomPropertyWithClientValueOptions!]' },
    siteId: { __type: 'String!' },
    subtext: { __type: 'String' },
    type: { __type: 'String!' },
    updatedAt: { __type: 'String' },
  },
  CustomPropertyWithClientValueAlerts: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String' },
    id: { __type: 'String' },
    isDisplayPropertyValueAsAlert: { __type: 'Boolean!' },
    operator: { __type: 'String!' },
    propertyId: { __type: 'String' },
    text: { __type: 'String' },
    value: { __type: 'String' },
  },
  CustomPropertyWithClientValueClientValue: {
    __typename: { __type: 'String!' },
    customPropertyValueId: { __type: 'String!' },
    updatedAt: { __type: 'String!' },
    value: { __type: 'String' },
  },
  CustomPropertyWithClientValueOptions: {
    __typename: { __type: 'String!' },
    displayOrder: { __type: 'Float' },
    id: { __type: 'String' },
    option: { __type: 'String!' },
  },
  CustomizationStats: {
    __typename: { __type: 'String!' },
    configuredLanguages: { __type: '[String!]!' },
    customizationsByLanguage: { __type: 'JSONObject!' },
    totalCustomizations: { __type: 'Float!' },
  },
  DashboardInput: {
    endDate: { __type: 'String' },
    locationId: { __type: 'String' },
    startDate: { __type: 'String' },
  },
  DashboardKpisResponse: {
    __typename: { __type: 'String!' },
    activeMembers: { __type: 'Float!' },
    currency: { __type: 'String!' },
    newMembers: { __type: 'Float!' },
    newMembersPrevious: { __type: 'Float!' },
    totalRevenue: { __type: 'Float!' },
    totalRevenuePrevious: { __type: 'Float!' },
    totalVisits: { __type: 'Float!' },
    totalVisitsPrevious: { __type: 'Float!' },
  },
  DashboardMobile: {
    __typename: { __type: 'String!' },
    barcode: { __type: 'String' },
    failedPayments: { __type: '[MobileFailedPayment!]' },
    introOffer: { __type: '[MobileIntroOffer!]' },
    joinDate: { __type: 'String' },
    nextBooking: { __type: '[NextBooking!]' },
    outstandingPayments: { __type: '[MobileOutstandingPayment!]' },
    pendingForms: { __type: '[MemberPendingForm!]' },
    pendingPolicies: { __type: '[MobilePendingPolicy!]' },
    statsLast30: { __type: 'Float' },
    statsLifetime: { __type: 'Float' },
    statsWeekly: { __type: 'Float' },
  },
  DateRange: { end: { __type: 'String!' }, start: { __type: 'String!' } },
  DaySessionsPage: {
    __typename: { __type: 'String!' },
    hasNextPage: { __type: 'Boolean!' },
    nextCursor: { __type: 'String' },
    sessions: { __type: '[MonthViewSession!]!' },
    totalCount: { __type: 'Float!' },
  },
  DeclineSharedCreditsInput: {
    inviteToken: { __type: 'String' },
    ownerClientId: { __type: 'ID!' },
    serviceId: { __type: 'ID!' },
  },
  DeepLink: {
    __typename: { __type: 'String!' },
    branchLinkId: { __type: 'String' },
    branchUrl: { __type: 'String' },
    campaign: { __type: 'String' },
    canonicalIdentifier: { __type: 'String!' },
    corporateId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'String' },
    deepLinkId: { __type: 'String!' },
    description: { __type: 'String' },
    feature: { __type: 'String' },
    name: { __type: 'String!' },
    ogDescription: { __type: 'String' },
    ogImageUrl: { __type: 'String' },
    ogTitle: { __type: 'String' },
    tags: { __type: '[String!]' },
    targetParams: { __type: 'JSONObject' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'String' },
    version: { __type: 'Float!' },
  },
  DeepLinkDestinations: {
    __typename: { __type: 'String!' },
    canonicalIdentifier: { __type: 'String!' },
    description: { __type: 'String!' },
    label: { __type: 'String!' },
    optionalParams: { __type: '[String!]!' },
    requiredParams: { __type: '[String!]!' },
  },
  DeepLinkSettings: {
    __typename: { __type: 'String!' },
    androidUrl: { __type: 'String' },
    desktopUrl: { __type: 'String' },
    fallbackUrl: { __type: 'String' },
    iosUrl: { __type: 'String' },
  },
  DeepLinks: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'DeepLinksPageInfo!' },
    results: { __type: '[DeepLinksResults!]!' },
  },
  DeepLinksPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  DeepLinksResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'DeepLink!' },
  },
  DefaultText: {
    __typename: { __type: 'String!' },
    defaultText: { __type: 'String' },
    key: { __type: 'String!' },
    language: { __type: 'String!' },
  },
  DeleteAggregatorProvider: { __typename: { __type: 'String!' }, success: { __type: 'Boolean!' } },
  DeleteClientBuddy: { __typename: { __type: 'String!' }, success: { __type: 'Boolean!' } },
  DeleteClientCustomPropertyValuesResponse: {
    __typename: { __type: 'String!' },
    message: { __type: 'String' },
    success: { __type: 'Boolean!' },
  },
  DeleteClientFileResponse: { __typename: { __type: 'String!' }, success: { __type: 'Boolean!' } },
  DeleteClientNoteResponse: {
    __typename: { __type: 'String!' },
    message: { __type: 'String' },
    success: { __type: 'Boolean!' },
  },
  DeleteClientRelation: { __typename: { __type: 'String!' }, success: { __type: 'Boolean!' } },
  DeleteClientResponse: { __typename: { __type: 'String!' }, result: { __type: 'Client!' } },
  DeleteDeepLink: { __typename: { __type: 'String!' }, success: { __type: 'Boolean!' } },
  DeleteFormSubmissionResponse: {
    __typename: { __type: 'String!' },
    message: { __type: 'String' },
    success: { __type: 'Boolean!' },
  },
  DeleteGiftCardExpiryRule: { __typename: { __type: 'String!' }, success: { __type: 'Boolean!' } },
  DeleteMigration: { __typename: { __type: 'String!' }, success: { __type: 'Boolean!' } },
  DeleteMobileAppBranding: { __typename: { __type: 'String!' }, success: { __type: 'Boolean!' } },
  DeleteMobileAppChannels: { __typename: { __type: 'String!' }, success: { __type: 'Boolean!' } },
  DeleteMobileAppProfile: { __typename: { __type: 'String!' }, success: { __type: 'Boolean!' } },
  DeletePosCategoryResponse: { __typename: { __type: 'String!' }, success: { __type: 'Boolean!' } },
  DeletePosProductVariableResponse: {
    __typename: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  DeleteSavedReport: { __typename: { __type: 'String!' }, success: { __type: 'Boolean!' } },
  DeleteServiceTemplateCategoryResponse: {
    __typename: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  DeleteSessionFeedback: { __typename: { __type: 'String!' }, success: { __type: 'Boolean!' } },
  DeleteSessionOccurrencesInput: {
    includeDownstreamSplits: { __type: 'Boolean' },
    includeModifiedSessions: { __type: 'Boolean' },
    message: { __type: 'String' },
    notificationMethods: { __type: '[NotificationMethod!]!' },
    scope: { __type: 'CancelSessionScope!' },
    sessionId: { __type: 'String!' },
    siteId: { __type: 'String!' },
    subject: { __type: 'String' },
  },
  DeleteSessionOccurrencesResult: {
    __typename: { __type: 'String!' },
    affectedMemberCount: { __type: 'Float!' },
    cancelledCount: { __type: 'Float!' },
    deletedCount: { __type: 'Float!' },
    patternsEnded: { __type: 'Float!' },
  },
  DeleteSiteSupplierResponse: {
    __typename: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  DeleteSoapNoteResponse: {
    __typename: { __type: 'String!' },
    message: { __type: 'String' },
    success: { __type: 'Boolean!' },
  },
  DeleteTestMember: { __typename: { __type: 'String!' }, clientId: { __type: 'String!' } },
  DeleteThirdPartyIntegration: {
    __typename: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  DeleteThirdPartyIntegrationKey: {
    __typename: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  DeletedKnowledgeArticlesResponse: {
    __typename: { __type: 'String!' },
    articles: { __type: '[KnowledgeArticle!]!' },
    hasMore: { __type: 'Boolean!' },
    totalCount: { __type: 'Int!' },
  },
  DemoSeedingConfig: {
    __typename: { __type: 'String!' },
    density: { __type: 'DemoSeedingDensity' },
    locationCount: { __type: 'Float!' },
    timeRangeMonths: { __type: 'Float!' },
  },
  DemoSeedingConfigInput: {
    density: { __type: 'DemoSeedingDensity' },
    locationCount: { __type: 'Float!' },
    timeRangeMonths: { __type: 'Float!' },
  },
  DemoSeedingDeletedCounts: {
    __typename: { __type: 'String!' },
    attendance: { __type: 'Float' },
    bookings: { __type: 'Float' },
    checkIns: { __type: 'Float' },
    clientAccountCreditsEntries: { __type: 'Float' },
    clientSites: { __type: 'Float' },
    clients: { __type: 'Float' },
    invoiceItems: { __type: 'Float' },
    invoiceStatusLogs: { __type: 'Float' },
    invoices: { __type: 'Float' },
    locations: { __type: 'Float' },
    payments: { __type: 'Float' },
    promoCodeUses: { __type: 'Float' },
    promoCodes: { __type: 'Float' },
    rooms: { __type: 'Float' },
    serviceCreditTemplates: { __type: 'Float' },
    serviceTemplates: { __type: 'Float' },
    sessionFilters: { __type: 'Float' },
    sessionTemplates: { __type: 'Float' },
    sessionTypes: { __type: 'Float' },
    sessions: { __type: 'Float' },
    sites: { __type: 'Float' },
    smartGroups: { __type: 'Float' },
    staff: { __type: 'Float' },
    staffUserSites: { __type: 'Float' },
    waitlistEntries: { __type: 'Float' },
  },
  DemoSeedingGenerationStats: {
    __typename: { __type: 'String!' },
    accountCredits: { __type: 'Float' },
    attendance: { __type: 'Float' },
    bookings: { __type: 'Float' },
    checkIns: { __type: 'Float' },
    clientSites: { __type: 'Float' },
    clients: { __type: 'Float' },
    invoiceItems: { __type: 'Float' },
    invoices: { __type: 'Float' },
    locations: { __type: 'Float' },
    payments: { __type: 'Float' },
    promoCodes: { __type: 'Float' },
    rooms: { __type: 'Float' },
    serviceTemplates: { __type: 'Float' },
    sessionFilters: { __type: 'Float' },
    sessionTemplates: { __type: 'Float' },
    sessionTypes: { __type: 'Float' },
    sessions: { __type: 'Float' },
    sites: { __type: 'Float' },
    smartGroups: { __type: 'Float' },
    staff: { __type: 'Float' },
    waitlistEntries: { __type: 'Float' },
  },
  DemoSeedingInsertedCounts: {
    __typename: { __type: 'String!' },
    accountCredits: { __type: 'Float' },
    attendance: { __type: 'Float' },
    bookings: { __type: 'Float' },
    checkIns: { __type: 'Float' },
    clientSites: { __type: 'Float' },
    clients: { __type: 'Float' },
    invoiceItems: { __type: 'Float' },
    invoices: { __type: 'Float' },
    locations: { __type: 'Float' },
    payments: { __type: 'Float' },
    promoCodes: { __type: 'Float' },
    rooms: { __type: 'Float' },
    serviceTemplates: { __type: 'Float' },
    sessionFilters: { __type: 'Float' },
    sessionTemplates: { __type: 'Float' },
    sessionTypes: { __type: 'Float' },
    sessions: { __type: 'Float' },
    sites: { __type: 'Float' },
    smartGroups: { __type: 'Float' },
    staff: { __type: 'Float' },
    waitlistEntries: { __type: 'Float' },
  },
  DemoSeedingJob: {
    __typename: { __type: 'String!' },
    completedAt: { __type: 'String' },
    config: { __type: 'DemoSeedingConfig!' },
    corporateId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'String!' },
    createdByName: { __type: 'String' },
    error: { __type: 'String' },
    jobId: { __type: 'String!' },
    persona: { __type: 'DemoSeedingPersona!' },
    progress: { __type: 'Float' },
    progressDetails: { __type: 'DemoSeedingProgressDetails' },
    siteIds: { __type: '[String!]' },
    siteNames: { __type: '[String!]' },
    startedAt: { __type: 'String' },
    status: { __type: 'DemoSeedingJobStatus!' },
    updatedAt: { __type: 'String!' },
  },
  DemoSeedingProgressDetails: {
    __typename: { __type: 'String!' },
    attendance: { __type: 'Float' },
    bookings: { __type: 'Float' },
    currentPhase: { __type: 'String' },
    deleted: { __type: 'DemoSeedingDeletedCounts' },
    entitiesGenerated: { __type: 'Float' },
    inserted: { __type: 'DemoSeedingInsertedCounts' },
    members: { __type: 'Float' },
    memberships: { __type: 'Float' },
    payments: { __type: 'Float' },
    percent: { __type: 'Float' },
    phase: { __type: 'String' },
    schedules: { __type: 'Float' },
    stats: { __type: 'DemoSeedingGenerationStats' },
    verificationDiscrepancies: { __type: '[String!]' },
    verificationRemaining: { __type: '[String!]' },
    verified: { __type: 'Boolean' },
  },
  DestinationFeeChargeStatus: {
    __typename: { __type: 'String!' },
    alreadyChargedToday: { __type: 'Boolean!' },
    chargedInvoiceId: { __type: 'String' },
    chargedInvoiceStatus: { __type: 'InvoiceStatus' },
  },
  DetectImportType: {
    __typename: { __type: 'String!' },
    bestMatch: { __type: 'String' },
    matches: { __type: '[DetectImportTypeMatches!]!' },
  },
  DetectImportTypeMatches: {
    __typename: { __type: 'String!' },
    allRequiredPresent: { __type: 'Boolean!' },
    importType: { __type: 'String!' },
    matchedColumnCount: { __type: 'Float!' },
    missingRequired: { __type: '[String!]!' },
    requiredFieldCount: { __type: 'Float!' },
  },
  DirectUploadConfirmInput: {
    id: { __type: 'ID!' },
    originalFilename: { __type: 'String' },
    target: { __type: 'DirectUploadTarget!' },
    uploadRef: { __type: 'String!' },
  },
  DirectUploadImage: { __typename: { __type: 'String!' }, url: { __type: 'String!' } },
  DirectUploadUrlInput: {
    format: { __type: 'DirectUploadFormat!' },
    id: { __type: 'ID!' },
    target: { __type: 'DirectUploadTarget!' },
  },
  DirectUploadUrlResponse: {
    __typename: { __type: 'String!' },
    fileUrl: { __type: 'String!' },
    uploadRef: { __type: 'String!' },
    uploadUrl: { __type: 'String!' },
  },
  DismissBlockedMovementInput: {
    corporateId: { __type: 'ID!' },
    movementId: { __type: 'ID!' },
    note: { __type: 'String' },
  },
  DismissBlockedMovementResult: {
    __typename: { __type: 'String!' },
    dismissed: { __type: 'Boolean!' },
    memberMovementId: { __type: 'ID!' },
  },
  DismissIncomingMovementInput: {
    memberMovementId: { __type: 'ID!' },
    reason: { __type: 'String' },
  },
  DisplayedPolicyRevisionInput: {
    policyRevisionId: { __type: 'ID!' },
    revisionSha256: { __type: 'String' },
    sitePolicyId: { __type: 'ID!' },
  },
  DisplayedSitePolicyRevision: {
    __typename: { __type: 'String!' },
    content: { __type: 'String!' },
    name: { __type: 'String!' },
    policyRevisionId: { __type: 'ID!' },
    revisionSha256: { __type: 'String!' },
    sitePolicyId: { __type: 'ID!' },
  },
  Dispute: {
    __typename: { __type: 'String!' },
    amount: { __type: 'Numeric!' },
    createdAt: { __type: 'String!' },
    disputeId: { __type: 'ID!' },
    evidenceDueDate: { __type: 'String' },
    externalAttemptId: { __type: 'String!' },
    externalDisputeId: { __type: 'String!' },
    externalPaymentId: { __type: 'String!' },
    gatewayType: { __type: 'GatewayType!' },
    openedAt: { __type: 'String' },
    paymentGatewayTransactionId: { __type: 'ID!' },
    paymentId: { __type: 'ID!' },
    providerAccountId: { __type: 'String!' },
    reason: { __type: 'String' },
    refundId: { __type: 'ID' },
    siteId: { __type: 'ID!' },
    status: { __type: 'DisputeStatus!' },
    wonAt: { __type: 'String' },
  },
  DnsRecord: {
    __typename: { __type: 'String!' },
    name: { __type: 'String!' },
    priority: { __type: 'Float' },
    status: { __type: 'DnsRecordStatus!' },
    ttl: { __type: 'String' },
    type: { __type: 'DnsRecordType!' },
    value: { __type: 'String!' },
  },
  DocumentFileVersion: {
    __typename: { __type: 'String!' },
    format: { __type: 'DocumentFileVersionFormat!' },
    size: { __type: 'Float' },
    type: { __type: 'DocumentFileVersionType!' },
    url: { __type: 'String!' },
  },
  DoorAccessEvent: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'String' },
    createdAt: { __type: 'String!' },
    credentialType: { __type: 'DoorAccessCredentialType!' },
    deniedBy: { __type: 'DoorAccessEventDeniedBy' },
    doorAccessEventId: { __type: 'String!' },
    failReason: { __type: 'String' },
    outcome: { __type: 'DoorAccessOutcome!' },
    provider: { __type: 'AccessProvider' },
    siteAccessPointId: { __type: 'String' },
    siteAccessZoneId: { __type: 'String' },
    siteAccessZoneName: { __type: 'String' },
    siteId: { __type: 'String!' },
    source: { __type: 'CheckInSource!' },
  },
  DoorHealthCheckResult: {
    __typename: { __type: 'String!' },
    failureReason: { __type: 'DoorConnectionFailureReason' },
    healthy: { __type: 'Boolean!' },
    message: { __type: 'String' },
  },
  DownloadBigQueryExportInput: {
    dateRange: { __type: 'DateRange' },
    exportName: { __type: 'BigQueryExportName!' },
    filters: { __type: 'ExportFilters' },
    locationId: { __type: 'String' },
  },
  DownloadBigQueryExportResponse: {
    __typename: { __type: 'String!' },
    contentType: { __type: 'String!' },
    downloadUrl: { __type: 'String!' },
    expiresAt: { __type: 'String!' },
    filename: { __type: 'String!' },
    generatedAt: { __type: 'String!' },
  },
  DuplicateCorporateServiceTemplateInput: {
    corporateServiceTemplateId: { __type: 'ID!' },
    name: { __type: 'String!' },
  },
  EarlyAccessTimeline: {
    __typename: { __type: 'String!' },
    bridge: { __type: 'EarlyAccessTimelineBridge' },
    credits: { __type: 'Float' },
    days: { __type: 'Float!' },
    endDate: { __type: 'String!' },
    firstFullAmount: { __type: 'String!' },
    firstFullBillingDate: { __type: 'String!' },
    firstFullTotalAmount: { __type: 'String!' },
    firstPaidDate: { __type: 'String!' },
    startDate: { __type: 'String!' },
  },
  EarlyAccessTimelineBridge: {
    __typename: { __type: 'String!' },
    amount: { __type: 'String!' },
    credits: { __type: 'Float' },
    endDate: { __type: 'String!' },
    startDate: { __type: 'String!' },
    totalAmount: { __type: 'String!' },
  },
  EgymBackfillResult: { __typename: { __type: 'String!' }, enqueued: { __type: 'Float!' } },
  EgymClientLink: {
    __typename: { __type: 'String!' },
    accountId: { __type: 'String' },
    lastSyncedAt: { __type: 'String' },
    membershipId: { __type: 'String!' },
    status: { __type: 'MemberLinkStatus' },
  },
  EgymHasAccounts: { __typename: { __type: 'String!' }, hasAccounts: { __type: 'Boolean!' } },
  EgymSettings: { __typename: { __type: 'String!' }, enabled: { __type: 'Boolean' } },
  EgymSiteEnabled: { __typename: { __type: 'String!' }, enabled: { __type: 'Boolean!' } },
  EgymSiteKeyStatus: { __typename: { __type: 'String!' }, hasApiKey: { __type: 'Boolean!' } },
  EgymSyncActive: { __typename: { __type: 'String!' }, active: { __type: 'Boolean!' } },
  ElectronicConsentWithdrawalResult: {
    __typename: { __type: 'String!' },
    signerId: { __type: 'ID!' },
    withdrawnConsentIds: { __type: '[ID!]!' },
  },
  EligibilityAge: {
    __typename: { __type: 'String!' },
    doctorsNoteRequired: { __type: 'Boolean!' },
    minimumViolated: { __type: 'Boolean!' },
    parentalConsentRequired: { __type: 'Boolean!' },
  },
  EligibilityFrequency: {
    __typename: { __type: 'String!' },
    allowedAt: { __type: 'String' },
    violated: { __type: 'Boolean!' },
  },
  EligibilitySkinType: {
    __typename: { __type: 'String!' },
    assessedAt: { __type: 'String' },
    completedAt: { __type: 'String' },
    dueAt: { __type: 'String' },
    permittedActions: { __type: '[SkinTypePermittedAction!]!' },
    resultLabel: { __type: 'String' },
    resultSource: { __type: 'FormExternalResultSource' },
    sourceSubmissionId: { __type: 'String' },
    status: { __type: 'SkinTypeEligibilityStatus!' },
  },
  EligibilityTiming: {
    __typename: { __type: 'String!' },
    allowedAt: { __type: 'String' },
    minutesUntilAllowed: { __type: 'Float' },
    violated: { __type: 'Boolean!' },
  },
  EmailFormSubmissionCopyResponse: {
    __typename: { __type: 'String!' },
    message: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  EmbedSetupResponse: {
    __typename: { __type: 'String!' },
    data: { __type: 'EmbedSetupResponseData' },
    errors: { __type: 'EmbedSetupResponseErrors' },
    message: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  EmbedSetupResponseData: {
    __typename: { __type: 'String!' },
    appConfig: { __type: 'EmbedSetupResponseDataAppConfig!' },
    customization: { __type: 'EmbedSetupResponseDataCustomization' },
    progress: { __type: 'EmbedSetupResponseDataProgress!' },
    websiteWidgets: { __type: 'EmbedSetupResponseDataWebsiteWidgets' },
  },
  EmbedSetupResponseDataAppConfig: {
    __typename: { __type: 'String!' },
    corporateId: { __type: 'String!' },
    id: { __type: 'String!' },
    lastUpdated: { __type: 'String!' },
    version: { __type: 'String!' },
    widgetName: { __type: 'String!' },
  },
  EmbedSetupResponseDataCustomization: {
    __typename: { __type: 'String!' },
    advanced: { __type: 'EmbedSetupResponseDataCustomizationAdvanced!' },
    appearance: { __type: 'EmbedSetupResponseDataCustomizationAppearance!' },
    branding: { __type: 'EmbedSetupResponseDataCustomizationBranding!' },
    colors: { __type: 'EmbedSetupResponseDataCustomizationColors!' },
    customText: { __type: 'EmbedSetupResponseDataCustomizationCustomText!' },
    layout: { __type: 'EmbedSetupResponseDataCustomizationLayout!' },
    modules: { __type: 'EmbedSetupResponseDataCustomizationModules!' },
  },
  EmbedSetupResponseDataCustomizationAdvanced: {
    __typename: { __type: 'String!' },
    buttonStyle: { __type: 'EmbedButtonStyle!' },
    classTimeFilter: { __type: 'Boolean!' },
    customCssLink: { __type: 'String!' },
    displayInstructor: { __type: 'Boolean!' },
    displayPackageDescription: { __type: 'Boolean!' },
    displayProfilePicture: { __type: 'Boolean!' },
    filterOptions: { __type: 'EmbedSetupResponseDataCustomizationAdvancedFilterOptions!' },
    privatesAnyAvailable: { __type: 'Boolean!' },
    redirectUrl: { __type: 'String!' },
    showFilters: { __type: 'Boolean!' },
    signUpEnabled: { __type: 'Boolean!' },
  },
  EmbedSetupResponseDataCustomizationAdvancedFilterOptions: {
    __typename: { __type: 'String!' },
    category: { __type: 'Boolean!' },
    duration: { __type: 'Boolean!' },
    instructor: { __type: 'Boolean!' },
    location: { __type: 'Boolean!' },
    time: { __type: 'Boolean!' },
  },
  EmbedSetupResponseDataCustomizationAppearance: {
    __typename: { __type: 'String!' },
    borderRadius: { __type: 'Float!' },
    buttonStyle: { __type: 'EmbedAppearanceButtonStyle!' },
    fontFamily: { __type: 'String!' },
    fontSize: { __type: 'Float!' },
  },
  EmbedSetupResponseDataCustomizationBranding: {
    __typename: { __type: 'String!' },
    appName: { __type: 'String!' },
    faviconUrl: { __type: 'String!' },
    logoUrl: { __type: 'String!' },
  },
  EmbedSetupResponseDataCustomizationColors: {
    __typename: { __type: 'String!' },
    backgroundColor: { __type: 'String!' },
    primaryColor: { __type: 'String!' },
    primaryTextColor: { __type: 'String!' },
    secondaryColor: { __type: 'String!' },
    secondaryTextColor: { __type: 'String!' },
  },
  EmbedSetupResponseDataCustomizationCustomText: {
    __typename: { __type: 'String!' },
    defaultLanguage: { __type: 'String!' },
    translations: { __type: 'JSONObject!' },
  },
  EmbedSetupResponseDataCustomizationLayout: {
    __typename: { __type: 'String!' },
    footerVisible: { __type: 'Boolean!' },
    headerVisible: { __type: 'Boolean!' },
    sidebarPosition: { __type: 'EmbedSidebarPosition!' },
  },
  EmbedSetupResponseDataCustomizationModules: {
    __typename: { __type: 'String!' },
    classes: { __type: 'Boolean!' },
    dashboard: { __type: 'Boolean!' },
    packages: { __type: 'Boolean!' },
    payments: { __type: 'Boolean!' },
    privates: { __type: 'Boolean!' },
    profile: { __type: 'Boolean!' },
    schedule: { __type: 'Boolean!' },
    workshops: { __type: 'Boolean!' },
  },
  EmbedSetupResponseDataProgress: {
    __typename: { __type: 'String!' },
    activeTabsInSteps: { __type: 'EmbedSetupResponseDataProgressActiveTabsInSteps!' },
    completedSteps: { __type: '[Float!]!' },
    currentStep: { __type: 'Float!' },
    customizationCompleted: { __type: 'Boolean!' },
    websiteWidgetsCompleted: { __type: 'Boolean!' },
  },
  EmbedSetupResponseDataProgressActiveTabsInSteps: {
    __typename: { __type: 'String!' },
    step1: { __type: 'Float' },
    step2: { __type: 'Float' },
  },
  EmbedSetupResponseDataWebsiteWidgets: {
    __typename: { __type: 'String!' },
    selectedWidgets: { __type: '[String!]!' },
    widgetSettings: { __type: 'JSONObject!' },
  },
  EmbedSetupResponseErrors: {
    __typename: { __type: 'String!' },
    customization: { __type: '[String!]' },
    general: { __type: '[String!]' },
    websiteWidgets: { __type: '[String!]' },
  },
  EmergencyStopMemberMovementResult: {
    __typename: { __type: 'String!' },
    cancelledRunIds: { __type: '[ID!]!' },
    corporateId: { __type: 'ID!' },
    stopped: { __type: 'Boolean!' },
  },
  EmployeeLinkInput: {
    email: { __type: 'String!' },
    firstName: { __type: 'String!' },
    lastName: { __type: 'String!' },
  },
  EmployeeLinkResult: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'String' },
    email: { __type: 'String!' },
    outcome: { __type: 'EmployeeLinkOutcome!' },
    reason: { __type: 'String' },
  },
  EnabledFilter: {
    __typename: { __type: 'String!' },
    category: { __type: 'String!' },
    displayValue: { __type: 'String!' },
    label: { __type: 'String!' },
    operator: { __type: 'String!' },
    type: { __type: 'String!' },
  },
  EnabledFilters: {
    __typename: { __type: 'String!' },
    filters: { __type: '[EnabledFilter!]!' },
    totalCount: { __type: 'Float!' },
  },
  Entity: {
    __typename: { __type: 'String!' },
    confidence: { __type: 'Float!' },
    name: { __type: 'String!' },
    type: { __type: 'String!' },
    value: { __type: 'String!' },
  },
  Equipment: {
    __typename: { __type: 'String!' },
    assignments: {
      __type: '[EquipmentAssignment!]',
      __args: { clientId: 'String', last: 'Boolean', status: 'String' },
    },
    category: { __type: 'EquipmentCategory!' },
    createdAt: { __type: 'String!' },
    currentError: { __type: 'EquipmentCurrentError' },
    defaultDelayMinutes: { __type: 'Int' },
    defaultTimerMinutes: { __type: 'Int' },
    deletedAt: { __type: 'String' },
    description: { __type: 'String' },
    equipmentId: { __type: 'String!' },
    facialLampLifeHours: { __type: 'Int' },
    facialLampTrackingEnabled: { __type: 'Boolean' },
    facialLampWarningHours: { __type: 'Int' },
    image: { __type: 'EquipmentImage' },
    lampLifeHours: { __type: 'Int' },
    lampTrackingEnabled: { __type: 'Boolean' },
    lampWarningHours: { __type: 'Int' },
    lastAvailableAt: { __type: 'String' },
    lastDelayAt: { __type: 'String' },
    lastDirtyAt: { __type: 'String' },
    lastError: { __type: 'EquipmentCurrentError' },
    lastInUseAt: { __type: 'String' },
    manufacturer: { __type: 'String' },
    maxDelayMinutes: { __type: 'Int' },
    maxTimerMinutes: { __type: 'Int' },
    minDelayMinutes: { __type: 'Int' },
    minTimerMinutes: { __type: 'Int' },
    name: { __type: 'String!' },
    nonUvCategory: { __type: 'NonUvCategory' },
    qualityCategory: { __type: 'EquipmentQualityCategory' },
    queue: { __type: '[EquipmentQueue!]' },
    site: { __type: 'SitePreview!' },
    siteId: { __type: 'String!' },
    siteSessionTypeIds: { __type: '[String!]' },
    status: { __type: 'EquipmentStatus!' },
    timerId: { __type: 'Int!' },
    updatedAt: { __type: 'String!' },
  },
  EquipmentActivityDay: {
    __typename: { __type: 'String!' },
    date: { __type: 'String!' },
    items: { __type: '[EquipmentActivityItem!]!' },
  },
  EquipmentActivityItem: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'String' },
    durationMinutes: { __type: 'Float!' },
    equipmentId: { __type: 'String!' },
    equipmentName: { __type: 'String!' },
    siteSessionTypeId: { __type: 'String' },
  },
  EquipmentAssignment: {
    __typename: { __type: 'String!' },
    addOnAmount: { __type: 'Numeric' },
    addOnInvoiceId: { __type: 'ID' },
    assignedAt: { __type: 'String!' },
    attendanceId: { __type: 'ID' },
    cancelledAt: { __type: 'String' },
    checkInId: { __type: 'String' },
    client: { __type: 'Client' },
    clientId: { __type: 'String' },
    complianceOverrideBy: { __type: 'String' },
    complianceOverrideReason: { __type: 'String' },
    complianceWarnings: { __type: '[EquipmentComplianceWarning!]!' },
    createdAt: { __type: 'String!' },
    creditLedgerEntryIds: { __type: '[ID!]' },
    delayMinutes: { __type: 'Int!' },
    doneAt: { __type: 'String' },
    elapsedMinutes: { __type: 'Int' },
    equipment: { __type: 'Equipment!' },
    equipmentAssignmentId: { __type: 'String!' },
    equipmentId: { __type: 'String!' },
    id: { __type: 'String!' },
    isTestTimeOverride: { __type: 'Boolean' },
    lampMinutesBeforeRestart: { __type: 'Int' },
    lampsSwitchedOn: { __type: 'Boolean' },
    regulationOverrides: { __type: '[EquipmentAssignmentRegulationOverride!]!' },
    restartPendingAt: { __type: 'String' },
    restartedAt: { __type: 'String' },
    reversedAt: { __type: 'String' },
    reversedByStaffUserId: { __type: 'ID' },
    siteId: { __type: 'String!' },
    siteSessionTypeId: { __type: 'String' },
    skinTypeAtStart: { __type: 'String' },
    skinTypeBandId: { __type: 'String' },
    skinTypeCompletedAt: { __type: 'String' },
    skinTypeFormRevision: { __type: 'Int' },
    skinTypeSubmissionId: { __type: 'String' },
    startedByStaffName: { __type: 'String' },
    startedByStaffUserId: { __type: 'ID' },
    status: { __type: 'EquipmentAssignmentStatus!' },
    timerId: { __type: 'Int!' },
    timerMinutes: { __type: 'Int!' },
    updatedAt: { __type: 'String!' },
    voidedAt: { __type: 'String' },
  },
  EquipmentAssignmentRegulationOverride: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    note: { __type: 'String!' },
    rule: { __type: 'TanningRegulationRule!' },
    staffName: { __type: 'String' },
    staffUserId: { __type: 'ID' },
  },
  EquipmentComplianceCategory: {
    __typename: { __type: 'String!' },
    blockingItems: { __type: '[EquipmentComplianceItem!]!' },
    decision: { __type: 'EquipmentStartDecision!' },
    equipmentCategory: { __type: 'PolicyEquipmentScope!' },
    reasonCodes: { __type: '[ReadinessReasonCode!]!' },
    renewalItems: { __type: '[EquipmentComplianceItem!]!' },
    status: { __type: 'EquipmentComplianceStatus!' },
  },
  EquipmentComplianceItem: {
    __typename: { __type: 'String!' },
    dueOn: { __type: 'String' },
    kind: { __type: 'PendingItemKind!' },
    reasonCode: { __type: 'ReadinessReasonCode!' },
    title: { __type: 'String!' },
  },
  EquipmentComplianceReport: {
    __typename: { __type: 'String!' },
    categories: { __type: '[PolicyEquipmentScope!]!' },
    evaluatedAt: { __type: 'String!' },
    limit: { __type: 'Float!' },
    offset: { __type: 'Float!' },
    redacted: { __type: 'Boolean!' },
    rows: { __type: '[EquipmentComplianceRow!]!' },
    siteId: { __type: 'ID!' },
    summary: { __type: 'EquipmentComplianceSummary!' },
    totalCount: { __type: 'Float!' },
  },
  EquipmentComplianceReportFilterInput: {
    equipmentCategory: { __type: 'PolicyEquipmentScope' },
    search: { __type: 'String' },
    statuses: { __type: '[EquipmentComplianceStatus!]' },
  },
  EquipmentComplianceReportPageInput: { limit: { __type: 'Float!' }, offset: { __type: 'Float!' } },
  EquipmentComplianceRow: {
    __typename: { __type: 'String!' },
    categories: { __type: '[EquipmentComplianceCategory!]!' },
    clientId: { __type: 'ID!' },
    firstName: { __type: 'String' },
    lastName: { __type: 'String' },
    lastVisitAt: { __type: 'String!' },
    status: { __type: 'EquipmentComplianceStatus!' },
  },
  EquipmentComplianceSummary: {
    __typename: { __type: 'String!' },
    blocked: { __type: 'Float!' },
    ready: { __type: 'Float!' },
    renewalDue: { __type: 'Float!' },
    total: { __type: 'Float!' },
  },
  EquipmentComplianceWarning: {
    __typename: { __type: 'String!' },
    code: { __type: 'EquipmentComplianceWarningCode!' },
  },
  EquipmentCurrentError: {
    __typename: { __type: 'String!' },
    errorAt: { __type: 'String!' },
    errorCode: { __type: 'String!' },
    errorMessage: { __type: 'String!' },
  },
  EquipmentExposureGuidance: {
    __typename: { __type: 'String!' },
    beyondSchedule: { __type: 'Boolean!' },
    minutes: { __type: 'Numeric!' },
    note: { __type: 'String' },
    resultLabel: { __type: 'String' },
    sessionNumber: { __type: 'Int!' },
  },
  EquipmentExposureScheduleRow: {
    __typename: { __type: 'String!' },
    bandId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    equipmentId: { __type: 'ID!' },
    formRevision: { __type: 'Int!' },
    minutes: { __type: 'Numeric!' },
    note: { __type: 'String' },
    scheduleId: { __type: 'ID!' },
    sessionNumber: { __type: 'Int!' },
    siteId: { __type: 'ID!' },
    updatedAt: { __type: 'String!' },
  },
  EquipmentExposureScheduleRowInput: {
    bandId: { __type: 'ID!' },
    minutes: { __type: 'Numeric!' },
    sessionNumber: { __type: 'Int!' },
  },
  EquipmentImage: {
    __typename: { __type: 'String!' },
    db: { __type: 'String' },
    medium: { __type: 'String' },
    thumbnail: { __type: 'String' },
  },
  EquipmentJurisdictionRule: {
    __typename: { __type: 'String!' },
    ageBands: { __type: '[JurisdictionAgeBand!]!' },
    ageEvidenceRequired: { __type: 'AgeEvidenceRequired!' },
    createdAt: { __type: 'String!' },
    createdByStaffUserId: { __type: 'ID' },
    effectiveFrom: { __type: 'String!' },
    effectiveTo: { __type: 'String' },
    equipmentScope: { __type: '[PolicyEquipmentScope!]!' },
    jurisdictionCode: { __type: 'String!' },
    notes: { __type: 'String' },
    ruleId: { __type: 'ID!' },
    ruleRevision: { __type: 'Float!' },
    siteId: { __type: 'ID!' },
    status: { __type: 'JurisdictionRuleStatus!' },
  },
  EquipmentJurisdictionRuleInput: {
    ageBands: { __type: '[JurisdictionAgeBandInput!]!' },
    ageEvidenceRequired: { __type: 'AgeEvidenceRequired!' },
    effectiveFrom: { __type: 'String!' },
    effectiveTo: { __type: 'String' },
    equipmentScope: { __type: '[PolicyEquipmentScope!]!' },
    jurisdictionCode: { __type: 'String!' },
    notes: { __type: 'String' },
  },
  EquipmentLampLog: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'String!' },
    createdByName: { __type: 'String!' },
    deltaMinutes: { __type: 'Int' },
    effectiveAt: { __type: 'String!' },
    equipmentId: { __type: 'ID!' },
    equipmentLampLogId: { __type: 'ID!' },
    eventType: { __type: 'EquipmentLampLogEventType!' },
    lampSet: { __type: 'EquipmentLampSet!' },
    newMinutes: { __type: 'Int!' },
    notes: { __type: 'String' },
    previousMinutes: { __type: 'Int' },
    siteId: { __type: 'ID!' },
  },
  EquipmentLampLogPage: {
    __typename: { __type: 'String!' },
    items: { __type: '[EquipmentLampLog!]!' },
    nextCursor: { __type: 'String' },
  },
  EquipmentLampLogsInput: {
    cursor: { __type: 'String' },
    equipmentId: { __type: 'ID!' },
    lampSet: { __type: 'EquipmentLampSet' },
    limit: { __type: 'Int' },
  },
  EquipmentLampSetStatus: {
    __typename: { __type: 'String!' },
    baselineAt: { __type: 'String!' },
    currentMinutes: { __type: 'Int!' },
    lampLifeHours: { __type: 'Int!' },
    lampWarningHours: { __type: 'Int!' },
    lastLampChangeAt: { __type: 'String' },
    state: { __type: 'EquipmentLampState!' },
    uncountedCodedSessions: { __type: 'Int!' },
  },
  EquipmentLampSiteStatus: {
    __typename: { __type: 'String!' },
    equipment: { __type: '[EquipmentLampStatus!]!' },
    siteToday: { __type: 'String!' },
    timezone: { __type: 'String!' },
  },
  EquipmentLampStatus: {
    __typename: { __type: 'String!' },
    body: { __type: 'EquipmentLampSetStatus' },
    equipmentId: { __type: 'ID!' },
    facial: { __type: 'EquipmentLampSetStatus' },
    state: { __type: 'EquipmentLampState!' },
  },
  EquipmentQueue: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    regulationOverrides: { __type: '[QueuedTanningRegulationOverride!]' },
    siteSessionTypeId: { __type: 'ID' },
  },
  EquipmentQueuePosition: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    equipmentId: { __type: 'String!' },
    position: { __type: 'Float!' },
    siteSessionTypeId: { __type: 'ID' },
  },
  EquipmentReadinessRequestInput: { clientId: { __type: 'ID!' }, equipmentId: { __type: 'ID!' } },
  EquipmentReadinessView: {
    __typename: { __type: 'String!' },
    actionableItems: { __type: '[ReadinessItem!]!' },
    age: { __type: 'ReadinessDimensionResult!' },
    blockingItems: { __type: '[ReadinessItem!]!' },
    clientId: { __type: 'ID!' },
    detail: { __type: 'ReadinessEvidenceDetail' },
    equipmentCategory: { __type: 'PolicyEquipmentScope' },
    equipmentId: { __type: 'ID' },
    evaluatedSiteLocalDate: { __type: 'String!' },
    operational: { __type: 'ReadinessDimensionResult!' },
    policy: { __type: 'ReadinessDimensionResult!' },
    siteId: { __type: 'ID!' },
    skinType: { __type: 'ReadinessDimensionResult!' },
    upcomingItems: { __type: '[ReadinessItem!]!' },
  },
  EquipmentRegulation: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    equipmentCategory: { __type: 'EquipmentCategory!' },
    equipmentRegulationId: { __type: 'String!' },
    id: { __type: 'String!' },
    rules: { __type: 'EquipmentRegulationRules!' },
    siteId: { __type: 'String!' },
    updatedAt: { __type: 'String!' },
  },
  EquipmentRegulationRules: {
    __typename: { __type: 'String!' },
    allowOverride: { __type: 'Boolean!' },
    customerAgeMaxFrequency: { __type: 'EquipmentRegulationRulesCustomerAgeMaxFrequency!' },
    customerAgeMaxFrequencyAfterNoCategoryTan: {
      __type: 'EquipmentRegulationRulesCustomerAgeMaxFrequencyAfterNoCategoryTan!',
    },
    hoursBetweenUsesFromStartOfPrevious: {
      __type: 'EquipmentRegulationRulesHoursBetweenUsesFromStartOfPrevious!',
    },
    minimumDaysBetweenUses: { __type: 'EquipmentRegulationRulesMinimumDaysBetweenUses!' },
    minimumHoursBetweenUses: { __type: 'EquipmentRegulationRulesMinimumHoursBetweenUses!' },
    nonUvAgeRules: { __type: 'EquipmentRegulationRulesNonUvAgeRules' },
    skinTypeRequired: { __type: 'EquipmentRegulationRulesSkinTypeRequired' },
    uvAgeRules: { __type: 'EquipmentRegulationRulesUvAgeRules' },
  },
  EquipmentRegulationRulesCustomerAgeMaxFrequency: {
    __typename: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
    everyXDays: { __type: 'Float!' },
    maxAge: { __type: 'Float!' },
    maxUses: { __type: 'Float!' },
  },
  EquipmentRegulationRulesCustomerAgeMaxFrequencyAfterNoCategoryTan: {
    __typename: { __type: 'String!' },
    afterXDaysOfNoCategoryTan: { __type: 'Float!' },
    enabled: { __type: 'Boolean!' },
    everyXDays: { __type: 'Float!' },
    forTheFirstXDays: { __type: 'Float!' },
    maxAge: { __type: 'Float!' },
    maxUses: { __type: 'Float!' },
  },
  EquipmentRegulationRulesHoursBetweenUsesFromStartOfPrevious: {
    __typename: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
    hours: { __type: 'Float!' },
  },
  EquipmentRegulationRulesMinimumDaysBetweenUses: {
    __typename: { __type: 'String!' },
    days: { __type: 'Float!' },
    enabled: { __type: 'Boolean!' },
  },
  EquipmentRegulationRulesMinimumHoursBetweenUses: {
    __typename: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
    hours: { __type: 'Float!' },
  },
  EquipmentRegulationRulesNonUvAgeRules: {
    __typename: { __type: 'String!' },
    byCategory: { __type: 'EquipmentRegulationRulesNonUvAgeRulesByCategory' },
    categoryBased: { __type: 'Boolean!' },
    general: { __type: 'EquipmentRegulationRulesUvAgeRules' },
  },
  EquipmentRegulationRulesNonUvAgeRulesByCategory: {
    __typename: { __type: 'String!' },
    red_light: { __type: 'EquipmentRegulationRulesUvAgeRules' },
    spa: { __type: 'EquipmentRegulationRulesUvAgeRules!' },
    spray: { __type: 'EquipmentRegulationRulesUvAgeRules!' },
    wellness: { __type: 'EquipmentRegulationRulesUvAgeRules!' },
  },
  EquipmentRegulationRulesSkinTypeRequired: {
    __typename: { __type: 'String!' },
    allowOverride: { __type: 'Boolean!' },
    autoSend: { __type: 'Boolean!' },
    autoSendDeviceTokenId: { __type: 'String' },
    mode: { __type: 'SkinTypeRequirementMode!' },
    resurveyInterval: { __type: 'ResurveyInterval!' },
    skinTypeFormId: { __type: 'String' },
  },
  EquipmentRegulationRulesUvAgeRules: {
    __typename: { __type: 'String!' },
    doctorsNote: { __type: 'EquipmentRegulationRulesUvAgeRulesMinorWithParentalConsent' },
    minimumAge: { __type: 'EquipmentRegulationRulesUvAgeRulesMinimumAge!' },
    minorWithParentalConsent: {
      __type: 'EquipmentRegulationRulesUvAgeRulesMinorWithParentalConsent!',
    },
  },
  EquipmentRegulationRulesUvAgeRulesMinimumAge: {
    __typename: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
    enforceNoOverride: { __type: 'Boolean!' },
    value: { __type: 'Float!' },
  },
  EquipmentRegulationRulesUvAgeRulesMinorWithParentalConsent: {
    __typename: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
    max: { __type: 'Float!' },
    min: { __type: 'Float!' },
  },
  EquipmentSessionTypeAvailability: {
    __typename: { __type: 'String!' },
    addOnPrice: { __type: 'String' },
    availability: { __type: 'EquipmentSessionTypeAvailabilityKind!' },
    blockReason: { __type: 'EquipmentSessionTypeBlockReason' },
    currency: { __type: 'String' },
    siteSessionTypeId: { __type: 'ID!' },
  },
  ExecuteMemberMovementManualTransferInput: {
    attestation: { __type: 'MemberMovementAttestationInput!' },
    input: { __type: 'MemberMovementManualTransferInput!' },
  },
  ExperienceDashboard: {
    __typename: { __type: 'String!' },
    activeStreaks: { __type: 'Float!' },
    awards: { __type: 'AwardsSummary!' },
    challengeOverview: { __type: 'ChallengeOverview!' },
    contentEngagement: { __type: 'ContentEngagementSummary!' },
    metricTracking: { __type: 'MetricTrackingSummary!' },
    totalMilestones: { __type: 'Float!' },
  },
  ExportCustomText: {
    __typename: { __type: 'String!' },
    corporateId: { __type: 'String!' },
    customTextData: { __type: 'JSONObject!' },
    defaultLanguage: { __type: 'String!' },
    enabledLanguages: { __type: '[String!]!' },
    exportedAt: { __type: 'String!' },
  },
  ExportFilters: {
    locationIds: { __type: '[String!]' },
    membershipType: { __type: 'String' },
    paymentStatus: { __type: 'String' },
    serviceType: { __type: 'String' },
  },
  ExportJobStatus: {
    __typename: { __type: 'String!' },
    error: { __type: 'String' },
    jobId: { __type: 'String!' },
    result: { __type: 'ExportJobStatusResult' },
    rowsProcessed: { __type: 'Float!' },
    status: { __type: 'ExportJobStatusEnum!' },
    totalRows: { __type: 'Float!' },
  },
  ExportJobStatusResult: {
    __typename: { __type: 'String!' },
    contentType: { __type: 'String!' },
    downloadUrl: { __type: 'String!' },
    expiresAt: { __type: 'String!' },
    filename: { __type: 'String!' },
    generatedAt: { __type: 'String!' },
    isTruncated: { __type: 'Boolean' },
    maxExportRows: { __type: 'Float' },
    piiRedacted: { __type: 'Boolean' },
    rowCount: { __type: 'Float!' },
  },
  ExportReportInputInput: {
    columnFilters: { __type: 'JSONObject' },
    columns: { __type: '[String!]' },
    dateFormat: { __type: 'String' },
    dateFrom: { __type: 'String' },
    dateTo: { __type: 'String' },
    filters: { __type: 'JSONObject' },
    format: { __type: 'ExportFormat' },
    numberFormat: { __type: 'String' },
    orderBy: { __type: '[RunReportOrderByInput!]' },
    reportName: { __type: 'ReportName' },
    savedReportId: { __type: 'String' },
    searchTerm: { __type: 'String' },
    siteIds: { __type: '[String!]' },
    timeFormat: { __type: 'String' },
  },
  ExportSettlementInput: {
    dateFrom: { __type: 'String' },
    dateTo: { __type: 'String' },
    exportType: { __type: 'SettlementExportType!' },
    siteIds: { __type: '[String!]!' },
    sitePayoutId: { __type: 'String' },
    sitePayoutIds: { __type: '[String!]' },
  },
  ExportSettlementResponse: {
    __typename: { __type: 'String!' },
    contentType: { __type: 'String!' },
    downloadUrl: { __type: 'String!' },
    expiresAt: { __type: 'String!' },
    filename: { __type: 'String!' },
    generatedAt: { __type: 'String!' },
    itemCount: { __type: 'Float!' },
    payoutCount: { __type: 'Float!' },
  },
  ExtendServiceInput: {
    durationAmount: { __type: 'Float!' },
    durationUnit: { __type: 'ServiceExtensionUnit!' },
    serviceId: { __type: 'ID!' },
    siteId: { __type: 'ID!' },
  },
  ExtendServiceResult: {
    __typename: { __type: 'String!' },
    newExpiresAt: { __type: 'String!' },
    restoredCredits: { __type: 'Float!' },
    type: { __type: 'ServiceExtensionType!' },
  },
  EzypayCompletionConfig: {
    __typename: { __type: 'String!' },
    accessToken: { __type: 'String!' },
    currencySymbol: { __type: 'String!' },
    customerId: { __type: 'String!' },
    customerPaidFees: { __type: '[EzypayCustomerPaidFee!]!' },
    hppUrl: { __type: 'String!' },
    paymentMethods: { __type: 'String!' },
    type: { __type: 'String!' },
  },
  EzypayCustomerPaidFee: {
    __typename: { __type: 'String!' },
    amount: { __type: 'Float!' },
    appliesTo: { __type: '[String!]!' },
    chargingOption: { __type: 'String!' },
    description: { __type: 'String' },
    percentage: { __type: 'Float!' },
    pricingCode: { __type: 'String!' },
  },
  EzypayCustomerPaidFeeEstimateRequest: {
    cardBrand: { __type: 'String' },
    clientId: { __type: 'ID' },
    paymentMethodType: { __type: 'PaymentMethodType!' },
    serviceTemplateId: { __type: 'ID' },
    siteId: { __type: 'ID!' },
    subtotalAmount: { __type: 'Numeric!' },
  },
  EzypayCustomerPaidFeeEstimateResult: {
    __typename: { __type: 'String!' },
    hasAnyFee: { __type: 'Boolean!' },
    loadFee: { __type: 'Numeric!' },
    skippedLoadFeeBecausePriorSettlement: { __type: 'Boolean!' },
    transactionFee: { __type: 'Numeric!' },
  },
  EzypayGateway: {
    __typename: { __type: 'String!' },
    countryCode: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    isActive: { __type: 'Boolean!' },
    isSandbox: { __type: 'Boolean!' },
    merchantUsername: { __type: 'String' },
    onboardingStatus: { __type: 'SitePaymentGatewayOnboardingStatus!' },
    paymentContactEmail: { __type: 'String' },
    siteGatewayAccountId: { __type: 'String!' },
    siteId: { __type: 'ID!' },
    sitePaymentGatewayId: { __type: 'ID!' },
    sitePaymentGatewayType: { __type: 'SupportedPaymentGateway!' },
    updatedAt: { __type: 'String!' },
  },
  EzypayGatewayLogItem: {
    __typename: { __type: 'String!' },
    amount: { __type: 'Float!' },
    currency: { __type: 'String!' },
    description: { __type: 'String' },
    type: { __type: 'String!' },
  },
  EzypayGatewayLogs: {
    __typename: { __type: 'String!' },
    currency: { __type: 'String!' },
    date: { __type: 'String' },
    items: { __type: '[EzypayGatewayLogItem!]!' },
    status: { __type: 'String!' },
    totalAmount: { __type: 'Float!' },
  },
  Family: {
    __typename: { __type: 'String!' },
    corporateId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    familyId: { __type: 'ID!' },
    familyPackageActive: { __type: 'Boolean!' },
    inviteLinks: { __type: '[FamilyOpenInviteLink!]!' },
    members: { __type: '[FamilyMember!]!' },
    name: { __type: 'String' },
    status: { __type: 'FamilyStatus!' },
  },
  FamilyInvite: {
    __typename: { __type: 'String!' },
    canBook: { __type: 'Boolean!' },
    expiresAt: { __type: 'String!' },
    familyId: { __type: 'ID!' },
    familyName: { __type: 'String' },
    familyPackageActive: { __type: 'Boolean!' },
    inviteToken: { __type: 'String!' },
    inviterFirstName: { __type: 'String' },
    inviterLastInitial: { __type: 'String' },
    inviterProfileImageUrl: { __type: 'String' },
    role: { __type: 'FamilyMemberRole!' },
  },
  FamilyInviteContext: {
    __typename: { __type: 'String!' },
    canBook: { __type: 'Boolean!' },
    expiresAt: { __type: 'String!' },
    familyId: { __type: 'ID!' },
    familyName: { __type: 'String' },
    familyPackageActive: { __type: 'Boolean!' },
    inviterFirstName: { __type: 'String' },
    inviterLastInitial: { __type: 'String' },
    inviterProfileImageUrl: { __type: 'String' },
    role: { __type: 'FamilyMemberRole!' },
  },
  FamilyInviteLink: {
    __typename: { __type: 'String!' },
    expiresAt: { __type: 'String!' },
    inviteLinkId: { __type: 'String!' },
    inviteToken: { __type: 'String!' },
  },
  FamilyMember: {
    __typename: { __type: 'String!' },
    age: { __type: 'Float' },
    canBook: { __type: 'Boolean!' },
    clientId: { __type: 'ID!' },
    email: { __type: 'String' },
    familyId: { __type: 'ID!' },
    firstName: { __type: 'String' },
    inviteExpiresAt: { __type: 'String' },
    invitedAt: { __type: 'String' },
    joinedAt: { __type: 'String' },
    lastName: { __type: 'String' },
    profileImageUrl: { __type: 'String' },
    role: { __type: 'FamilyMemberRole!' },
    status: { __type: 'FamilyMemberStatus!' },
  },
  FamilyMemberCandidate: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'ID!' },
    email: { __type: 'String' },
    firstName: { __type: 'String' },
    lastInitial: { __type: 'String' },
    lastName: { __type: 'String' },
    mobilePhoneNumber: { __type: 'String' },
    profileImageUrl: { __type: 'String' },
  },
  FamilyOpenInviteLink: {
    __typename: { __type: 'String!' },
    canBook: { __type: 'Boolean!' },
    expiresAt: { __type: 'String!' },
    familyId: { __type: 'ID!' },
    inviteLinkId: { __type: 'String!' },
    inviteToken: { __type: 'String' },
    invitedAt: { __type: 'String!' },
    invitedByClientId: { __type: 'ID' },
    invitedByFirstName: { __type: 'String' },
    invitedByLastName: { __type: 'String' },
    role: { __type: 'FamilyMemberRole!' },
  },
  FamilyPackage: {
    __typename: { __type: 'String!' },
    allocations: { __type: '[FamilyPackageAllocation!]!' },
    billing: { __type: 'FamilyPackageBilling' },
    buyerClientId: { __type: 'ID!' },
    buyerFirstName: { __type: 'String' },
    buyerLastName: { __type: 'String' },
    creditsRemaining: { __type: 'Float' },
    familyShareable: { __type: 'Boolean!' },
    multiLocationSessionTypeIds: { __type: '[String!]!' },
    myAllocation: { __type: 'FamilyPackageAllocation' },
    onHold: { __type: 'Boolean!' },
    serviceId: { __type: 'ID!' },
    sessionTypeIds: { __type: '[String!]' },
    siteId: { __type: 'ID!' },
    status: { __type: 'ServiceStatus!' },
    templateName: { __type: 'String!' },
    templateType: { __type: 'ServiceTemplateType!' },
  },
  FamilyPackageAllocation: {
    __typename: { __type: 'String!' },
    allocatedCredits: { __type: 'Float' },
    clientId: { __type: 'ID!' },
    consumedCredits: { __type: 'Float!' },
    firstName: { __type: 'String' },
    lastName: { __type: 'String' },
    remainingCredits: { __type: 'Float' },
    sharedOn: { __type: 'String' },
  },
  FamilyPackageBilling: {
    __typename: { __type: 'String!' },
    amount: { __type: 'String' },
    currency: { __type: 'String' },
    holdReason: { __type: 'String' },
    paymentMethod: { __type: 'FamilyPackagePaymentMethod' },
  },
  FamilyPackagePaymentMethod: {
    __typename: { __type: 'String!' },
    brand: { __type: 'String' },
    last4: { __type: 'String' },
    type: { __type: 'ClientPaymentMethodType!' },
  },
  FamilySettings: {
    __typename: { __type: 'String!' },
    adminsPerFamily: { __type: 'Float!' },
    corporateId: { __type: 'ID!' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'ID' },
  },
  FeatureDataRefreshStatus: {
    __typename: { __type: 'String!' },
    corporateId: { __type: 'ID!' },
    createdAt: { __type: 'String' },
    error: { __type: 'String' },
    id: { __type: 'ID!' },
    jobExecution: { __type: 'String' },
    previousDatabase: { __type: 'String' },
    slug: { __type: 'String' },
    sourceBackup: { __type: 'String' },
    state: { __type: 'FeatureDataRefreshState!' },
    step: { __type: 'String' },
    targetDatabase: { __type: 'String' },
    triggeredBy: { __type: 'String' },
    updatedAt: { __type: 'String' },
  },
  FeatureEnvEmailSettings: {
    __typename: { __type: 'String!' },
    branchName: { __type: 'String!' },
    ccEmails: { __type: '[String!]!' },
    owner: { __type: 'String!' },
    slug: { __type: 'String!' },
  },
  FeeCalculationRequest: {
    clientPaymentMethodId: { __type: 'ID' },
    invoiceId: { __type: 'ID' },
    paymentMethodType: { __type: 'PaymentMethodType!' },
    siteId: { __type: 'ID!' },
    subtotalAmount: { __type: 'Numeric!' },
  },
  FeeCalculationResult: {
    __typename: { __type: 'String!' },
    clientFeeAmount: { __type: 'Numeric' },
    feeCalculationSnapshot: { __type: 'FeeCalculationSnapshot!' },
    platformFeeAmount: { __type: 'Numeric' },
  },
  FeeCalculationSnapshot: {
    __typename: { __type: 'String!' },
    calculatedAt: { __type: 'String!' },
    clientFees: { __type: 'FeeCalculationSnapshotClientFees!' },
    feeClassification: { __type: 'FeeClassificationTypes!' },
    paymentMethodClassification: { __type: 'String!' },
    paymentMethodType: { __type: 'PaymentMethodType!' },
    platformFees: { __type: 'FeeCalculationSnapshotPlatformFees!' },
    siteFeeConfig: { __type: 'SiteFeeConfig!' },
    subtotalAmount: { __type: 'Float!' },
    totalClientFeeAmount: { __type: 'Float!' },
    totalPlatformFeeAmount: { __type: 'Float!' },
  },
  FeeCalculationSnapshotClientFees: {
    __typename: { __type: 'String!' },
    appliedFees: { __type: '[AppliedFee!]!' },
    summary: { __type: 'FeeSummary!' },
  },
  FeeCalculationSnapshotPlatformFees: {
    __typename: { __type: 'String!' },
    appliedFees: { __type: '[AppliedFee!]!' },
    summary: { __type: 'FeeSummary!' },
  },
  FeeConfiguration: {
    __typename: { __type: 'String!' },
    accountType: { __type: 'FeeAccountType!' },
    description: { __type: 'String' },
    enabled: { __type: 'Boolean!' },
    eventType: { __type: 'FeeEventType!' },
    feeConfigurationId: { __type: 'String!' },
    name: { __type: 'String!' },
    paymentGateway: { __type: 'PaymentGateway' },
    rate: { __type: 'Numeric!' },
    rateType: { __type: 'FeeRateType!' },
    webhookEndpoint: { __type: 'String' },
    webhookType: { __type: 'String' },
  },
  FeeConfigurations: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'FeeConfigurationsPageInfo!' },
    results: { __type: '[FeeConfigurationsResults!]!' },
  },
  FeeConfigurationsOrderByInput: {
    column: { __type: 'FeeConfigurationOrderBy!' },
    direction: { __type: 'OrderByDirection!' },
  },
  FeeConfigurationsPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  FeeConfigurationsResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'FeeConfiguration!' },
  },
  FeeSummary: {
    __typename: { __type: 'String!' },
    feeCount: { __type: 'Float!' },
    flatFees: { __type: 'Float!' },
    percentFees: { __type: 'Float!' },
    totalAmount: { __type: 'Float!' },
  },
  FeeTemplateFeesInput: {
    enabled: { __type: 'Boolean' },
    feeId: { __type: 'String!' },
    rate: { __type: 'Float' },
  },
  FeeTemplateInput: { fees: { __type: '[FeeTemplateFeesInput!]!' }, name: { __type: 'String!' } },
  FeedbackQuestion: {
    __typename: { __type: 'String!' },
    answerType: { __type: 'SessionFeedbackAnswerType' },
    characterLimit: { __type: 'Float' },
    helperText: { __type: 'String' },
    maxLabel: { __type: 'String' },
    minLabel: { __type: 'String' },
    options: { __type: '[String!]' },
    questionId: { __type: 'ID!' },
    questionText: { __type: 'String!' },
    questionType: { __type: 'FeedbackQuestionType!' },
    required: { __type: 'Boolean!' },
    scaleMax: { __type: 'Float' },
    sliderMax: { __type: 'Float' },
    sliderMin: { __type: 'Float' },
    sortOrder: { __type: 'Float!' },
  },
  FeedbackQuestions: {
    __typename: { __type: 'String!' },
    questions: { __type: '[FeedbackQuestion!]!' },
  },
  FinalisePublicSigningResult: {
    __typename: { __type: 'String!' },
    invoiceStatus: { __type: 'String' },
    ok: { __type: 'Boolean!' },
    pendingClientAction: { __type: 'PublicSigningPendingClientAction' },
    reason: { __type: 'String' },
    totalAmount: { __type: 'String' },
  },
  FinalizeCustomFont: { __typename: { __type: 'String!' }, success: { __type: 'Boolean!' } },
  FinalizeCustomFontFontInput: {
    displayName: { __type: 'String' },
    format: { __type: 'FontFormat!' },
    name: { __type: 'String!' },
    uploadedAt: { __type: 'String!' },
    uploadedBy: { __type: 'String' },
    url: { __type: 'String!' },
  },
  FindClientFeesTemplatesSortOptions: {
    direction: { __type: 'SortDirection' },
    field: { __type: 'FindClientFeesTemplatesSortFields' },
  },
  FindClientsSortOptions: {
    direction: { __type: 'SortDirection' },
    field: { __type: 'FindClientsSortFields' },
  },
  FindCorporatesSortOptions: {
    direction: { __type: 'SortDirection' },
    field: { __type: 'FindCorporatesSortFields' },
  },
  FindFeesTemplatesSortOptions: {
    direction: { __type: 'SortDirection' },
    field: { __type: 'FindFeesTemplatesSortFields' },
  },
  FindStaffUsers: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'FindStaffUsersPageInfo!' },
    results: { __type: '[FindStaffUsersResults!]!' },
  },
  FindStaffUsersOrderByInput: {
    column: { __type: 'StaffUserOrderBy!' },
    direction: { __type: 'OrderByDirection!' },
  },
  FindStaffUsersPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  FindStaffUsersResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'StaffUser!' },
  },
  FirebaseAppProjectCapacity: {
    __typename: { __type: 'String!' },
    cap: { __type: 'Float!' },
    countError: { __type: 'String' },
    projectId: { __type: 'String!' },
    registrations: { __type: 'Float' },
    status: { __type: 'FirebaseAppProjectStatus!' },
  },
  FirebaseAppProjectPool: {
    __typename: { __type: 'String!' },
    environment: { __type: 'FirebaseAppProjectEnvironment!' },
    projects: { __type: '[FirebaseAppProjectCapacity!]!' },
  },
  FirstCycleSettlement: {
    __typename: { __type: 'String!' },
    amount: { __type: 'String' },
    currency: { __type: 'String' },
    invoiceDueDate: { __type: 'String' },
    kind: { __type: 'FirstCycleSettlementKind!' },
    refundMethods: { __type: '[RefundType!]!' },
  },
  FitnessPassportConnectionTest: {
    __typename: { __type: 'String!' },
    reason: { __type: 'String' },
    state: { __type: 'String!' },
  },
  FitnessPassportLinkView: {
    __typename: { __type: 'String!' },
    fpMemberId: { __type: 'String!' },
    lastCheckedAt: { __type: 'String' },
    lastCheckedOutcome: { __type: 'FitnessPassportCheckOutcome' },
    lastMessage: { __type: 'String' },
    status: { __type: 'FitnessPassportLinkStatus!' },
  },
  FitnessPassportRetrySummary: {
    __typename: { __type: 'String!' },
    considered: { __type: 'Float!' },
    declined: { __type: 'Float!' },
    duplicates: { __type: 'Float!' },
    exhausted: { __type: 'Float!' },
    registered: { __type: 'Float!' },
    skipped: { __type: 'Float!' },
    stillPending: { __type: 'Float!' },
  },
  FitnessPassportSiteEnabled: {
    __typename: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
  },
  FitnessPassportVisitRow: {
    __typename: { __type: 'String!' },
    attemptCount: { __type: 'Float!' },
    checkInId: { __type: 'String' },
    clientId: { __type: 'String!' },
    clientName: { __type: 'String' },
    fitnessPassportVisitId: { __type: 'String!' },
    fpErrorMessage: { __type: 'String' },
    fpMemberId: { __type: 'String!' },
    fpStatus: { __type: 'String' },
    occurredAt: { __type: 'String!' },
    outcome: { __type: 'FitnessPassportVisitOutcome!' },
    requestedAt: { __type: 'String' },
  },
  FitnessPassportVisitsSummary: {
    __typename: { __type: 'String!' },
    notAdmitted: { __type: 'Float!' },
    overClaimed: { __type: 'Float!' },
    pending: { __type: 'Float!' },
    potentialDuplicate: { __type: 'Float!' },
    refused: { __type: 'Float!' },
    registered: { __type: 'Float!' },
    unrecorded: { __type: 'Float!' },
  },
  FobCaptureHolder: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'ID!' },
    name: { __type: 'String!' },
  },
  FobCaptureRequest: {
    __typename: { __type: 'String!' },
    attemptCount: { __type: 'Float!' },
    clientId: { __type: 'ID!' },
    deviceTokenId: { __type: 'ID!' },
    expiresAt: { __type: 'String!' },
    holders: { __type: '[FobCaptureHolder!]!' },
    requestId: { __type: 'ID!' },
    resultCode: { __type: 'FobCaptureResultCode' },
    siteId: { __type: 'ID!' },
    status: { __type: 'FobCaptureStatus!' },
  },
  FobDerivationConfigInput: {
    byteOrder: { __type: 'FobByteOrder!' },
    controller: { __type: 'FobController!' },
    readerFormat: { __type: 'FobReaderFormat!' },
    serialNotation: { __type: 'FobSerialNotation' },
  },
  FobReDerivationMember: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'String!' },
    name: { __type: 'String!' },
  },
  FobReDerivationPreview: {
    __typename: { __type: 'String!' },
    collisions: { __type: '[FobReDerivationMember!]!' },
    needsRescan: { __type: '[FobReDerivationMember!]!' },
    reDerivable: { __type: 'Float!' },
    total: { __type: 'Float!' },
    unchanged: { __type: 'Float!' },
  },
  FormHandoff: {
    __typename: { __type: 'String!' },
    answeredCount: { __type: 'Float' },
    channel: { __type: 'FormHandoffChannel!' },
    clientId: { __type: 'String!' },
    completedAt: { __type: 'String' },
    createdAt: { __type: 'String!' },
    deviceTokenId: { __type: 'String' },
    expiresAt: { __type: 'String!' },
    formSubmissionId: { __type: 'String!' },
    handoffId: { __type: 'String!' },
    identityConfirmedAt: { __type: 'String' },
    identityFailedAttempts: { __type: 'Float!' },
    questionCount: { __type: 'Float' },
    resultCode: { __type: 'FormHandoffResultCode' },
    siteId: { __type: 'String!' },
    status: { __type: 'FormHandoffStatus!' },
    statusVersion: { __type: 'Float!' },
    updatedAt: { __type: 'String!' },
  },
  FormSignatureAsset: {
    __typename: { __type: 'String!' },
    byteCount: { __type: 'Float' },
    checksumSha256: { __type: 'String' },
    signatureAssetId: { __type: 'String!' },
    status: { __type: 'String!' },
  },
  FormSignatureReadUrl: {
    __typename: { __type: 'String!' },
    expiresAt: { __type: 'String!' },
    url: { __type: 'String!' },
  },
  FormSignatureUploadHeader: {
    __typename: { __type: 'String!' },
    name: { __type: 'String!' },
    value: { __type: 'String!' },
  },
  FormSignatureUploadTicket: {
    __typename: { __type: 'String!' },
    expiresAt: { __type: 'String!' },
    uploadHeaders: { __type: '[FormSignatureUploadHeader!]!' },
    uploadId: { __type: 'String!' },
    uploadUrl: { __type: 'String!' },
  },
  FormWorkflowEffectFailure: {
    __typename: { __type: 'String!' },
    attemptCount: { __type: 'Float!' },
    clientId: { __type: 'String!' },
    effectId: { __type: 'String!' },
    effectType: { __type: 'String!' },
    formSubmissionId: { __type: 'String' },
    lastErrorCode: { __type: 'String' },
    updatedAt: { __type: 'String!' },
  },
  FormerFamilyMemberBookings: {
    __typename: { __type: 'String!' },
    bookingIds: { __type: '[ID!]!' },
    clientId: { __type: 'ID!' },
    firstName: { __type: 'String' },
    lastName: { __type: 'String' },
    status: { __type: 'FamilyMemberStatus!' },
  },
  GatewayFeeBreakdown: {
    __typename: { __type: 'String!' },
    currency: { __type: 'Currency' },
    failedPaymentFee: { __type: 'Numeric' },
    loadFee: { __type: 'Numeric' },
    transactionFee: { __type: 'Numeric' },
  },
  GatewayMetadata: {
    __typename: { __type: 'String!' },
    ezypay: { __type: 'GatewayMetadataEzypay' },
  },
  GatewayMetadataEzypay: {
    __typename: { __type: 'String!' },
    feeBreakdown: { __type: 'GatewayFeeBreakdown' },
  },
  GenerateCertificateSigningRequest: {
    __typename: { __type: 'String!' },
    csrPem: { __type: 'String!' },
  },
  GenerateClientFileUploadUrlResponse: {
    __typename: { __type: 'String!' },
    fileId: { __type: 'ID!' },
    requestedBy: { __type: 'ID!' },
    tempUrl: { __type: 'String!' },
    userType: { __type: 'UserType!' },
  },
  GenerateCoverImageUploadUrlInput: {
    contentType: { __type: 'String!' },
    filename: { __type: 'String!' },
    knowledgeArticleId: { __type: 'ID!' },
  },
  GenerateDevicePairingCode: {
    __typename: { __type: 'String!' },
    expiresAt: { __type: 'String!' },
    pairingCode: { __type: 'String!' },
    shortCode: { __type: 'String' },
    siteName: { __type: 'String!' },
  },
  GenerateFileSignedUrlResponse: {
    __typename: { __type: 'String!' },
    format: { __type: 'ImageFileVersionFormat' },
    height: { __type: 'Int' },
    type: { __type: 'ImageFileVersionType!' },
    url: { __type: 'String!' },
    width: { __type: 'Int' },
  },
  GenerateFileUploadUrlInput: {
    clientId: { __type: 'String' },
    fileName: { __type: 'String!' },
    format: { __type: 'String!' },
    id: { __type: 'ID!' },
    metadata: { __type: 'JSONObject' },
    siteId: { __type: 'String' },
    table: { __type: 'String!' },
  },
  GenerateFileUploadUrlResponse: {
    __typename: { __type: 'String!' },
    requestedBy: { __type: 'ID!' },
    tempUrl: { __type: 'String!' },
    userType: { __type: 'UserType!' },
  },
  GenerateFileUrlInput: {
    fileName: { __type: 'String!' },
    formats: { __type: '[String!]!' },
    id: { __type: 'ID!' },
    table: { __type: 'String!' },
    variants: { __type: '[String!]!' },
  },
  GenerateFontUploadSignedUrl: {
    __typename: { __type: 'String!' },
    expiresAt: { __type: 'String!' },
    publicUrl: { __type: 'String!' },
    requiredHeaders: { __type: 'JSONObject' },
    uploadUrl: { __type: 'String!' },
  },
  GenerateImagePublicSignedUrlInput: { format: { __type: 'ImageFileVersionFormat!' } },
  GiftCardDesign: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    deletedAt: { __type: 'String' },
    designImage: { __type: 'ImageFileConfigField!' },
    designImageUrl: {
      __type: 'ImagePublicSignedUrl',
      __args: { input: 'ImagePublicSignedUrlInput!' },
    },
    giftCardDesignId: { __type: 'ID!' },
    siteId: { __type: 'ID!' },
  },
  GiftCardDesignCreateInput: { siteId: { __type: 'ID!' } },
  GiftCardExpiryJurisdictionPreview: {
    __typename: { __type: 'String!' },
    asOfDate: { __type: 'String!' },
    jurisdictionCode: { __type: 'String' },
    jurisdictionName: { __type: 'String' },
    policy: { __type: 'ResolvedGiftCardExpiryPolicy!' },
    stateRequired: { __type: 'Boolean!' },
  },
  GiftCardExpiryRule: {
    __typename: { __type: 'String!' },
    countryId: { __type: 'String!' },
    countryIsoCode: { __type: 'String!' },
    countryName: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    disclosureRequired: { __type: 'Boolean!' },
    effectiveFrom: { __type: 'String!' },
    expiryPolicy: { __type: 'GiftCardExpiryPolicy!' },
    giftCardExpiryRuleId: { __type: 'ID!' },
    legalCitation: { __type: 'String' },
    maximumTermMonths: { __type: 'Float' },
    minimumTermMonths: { __type: 'Float' },
    notes: { __type: 'String' },
    reviewStatus: { __type: 'GiftCardExpiryRuleReviewStatus!' },
    reviewedAt: { __type: 'String' },
    reviewedByEmail: { __type: 'String' },
    reviewedByUserId: { __type: 'String' },
    sourceUrl: { __type: 'String' },
    updatedAt: { __type: 'String!' },
    updatedByUserId: { __type: 'String' },
    zoneCode: { __type: 'String' },
    zoneId: { __type: 'String' },
    zoneName: { __type: 'String' },
  },
  GiftCardExpiryRuleHistoryEntry: {
    __typename: { __type: 'String!' },
    action: { __type: 'GiftCardExpiryRuleHistoryAction!' },
    actorEmail: { __type: 'String' },
    actorUserId: { __type: 'String' },
    after: { __type: 'String' },
    before: { __type: 'String' },
    createdAt: { __type: 'String!' },
    giftCardExpiryRuleHistoryId: { __type: 'ID!' },
    giftCardExpiryRuleId: { __type: 'ID!' },
  },
  GiftCardExpiryRuleRecord: {
    __typename: { __type: 'String!' },
    countryId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    disclosureRequired: { __type: 'Boolean!' },
    effectiveFrom: { __type: 'String!' },
    expiryPolicy: { __type: 'GiftCardExpiryPolicy!' },
    giftCardExpiryRuleId: { __type: 'ID!' },
    legalCitation: { __type: 'String' },
    maximumTermMonths: { __type: 'Float' },
    minimumTermMonths: { __type: 'Float' },
    notes: { __type: 'String' },
    reviewStatus: { __type: 'GiftCardExpiryRuleReviewStatus!' },
    reviewedAt: { __type: 'String' },
    reviewedByEmail: { __type: 'String' },
    reviewedByUserId: { __type: 'String' },
    sourceUrl: { __type: 'String' },
    updatedAt: { __type: 'String!' },
    updatedByUserId: { __type: 'String' },
    zoneId: { __type: 'String' },
  },
  GiftCardExpirySiteOption: {
    __typename: { __type: 'String!' },
    name: { __type: 'String!' },
    siteId: { __type: 'String!' },
    status: { __type: 'String' },
  },
  GiftCardExpirySitePreview: {
    __typename: { __type: 'String!' },
    asOfDate: { __type: 'String!' },
    jurisdictionCode: { __type: 'String' },
    jurisdictionName: { __type: 'String' },
    policy: { __type: 'ResolvedGiftCardExpiryPolicy!' },
    siteId: { __type: 'ID!' },
    siteName: { __type: 'String!' },
    stateRequired: { __type: 'Boolean!' },
    timezone: { __type: 'String!' },
  },
  GiftCardFilter: { search: { __type: 'String' }, type: { __type: 'GiftCardFilterType' } },
  GiftCardSiteListFilter: {
    dateFrom: { __type: 'String' },
    dateTo: { __type: 'String' },
    limit: { __type: 'Float' },
    offset: { __type: 'Float' },
    search: { __type: 'String' },
    status: { __type: 'GiftCardStatus' },
  },
  GiftCardSiteListItem: {
    __typename: { __type: 'String!' },
    buyerEmail: { __type: 'String!' },
    buyerName: { __type: 'String!' },
    clientId: { __type: 'ID' },
    code: { __type: 'String!' },
    currency: { __type: 'String' },
    currentBalance: { __type: 'Numeric!' },
    expiredAt: { __type: 'String' },
    expiresAt: { __type: 'String' },
    giftCardId: { __type: 'ID!' },
    giftCardTemplateId: { __type: 'ID!' },
    initialValue: { __type: 'Numeric!' },
    isImported: { __type: 'Boolean!' },
    lastRedemptionDate: { __type: 'String' },
    locationName: { __type: 'String' },
    purchaseDate: { __type: 'String!' },
    redemptionCount: { __type: 'Float!' },
    status: { __type: 'GiftCardStatus!' },
    templateName: { __type: 'String!' },
  },
  GiftCardSiteListResponse: {
    __typename: { __type: 'String!' },
    records: { __type: '[GiftCardSiteListItem!]!' },
    totalCount: { __type: 'Float!' },
  },
  GiftCardTemplate: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    description: { __type: 'String' },
    expiryEnabled: { __type: 'Boolean!' },
    expiryMonths: { __type: 'Float' },
    expiryMonthsAtSite: { __type: 'Float', __args: { siteId: 'ID!' } },
    fixedAmount: { __type: 'Numeric' },
    fixedValue: { __type: 'Numeric' },
    fixedValueEnabled: { __type: 'Boolean!' },
    giftCardDesignId: { __type: 'ID' },
    giftCardTemplateId: { __type: 'ID!' },
    isAllSharedSites: { __type: 'Boolean!' },
    isOnlineSaleEnabled: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    restrictedMembershipTemplateIds: { __type: '[ID!]!' },
    restrictedPackageTemplateIds: { __type: '[ID!]!' },
    restrictedSaleEnabled: { __type: 'Boolean!' },
    revenueTagId: { __type: 'String' },
    sharedSiteIds: { __type: '[ID!]!' },
    siteId: { __type: 'ID!' },
    status: { __type: 'GiftCardTemplateStatus!' },
    totalClaimed: { __type: 'Float' },
    totalIssued: { __type: 'Float' },
    updatedAt: { __type: 'String!' },
  },
  GiftCardTemplateCreateInput: {
    description: { __type: 'String' },
    expiryEnabled: { __type: 'Boolean' },
    expiryMonths: { __type: 'Float' },
    fixedAmount: { __type: 'Numeric' },
    fixedValue: { __type: 'Numeric' },
    fixedValueEnabled: { __type: 'Boolean!' },
    giftCardDesignId: { __type: 'ID' },
    isAllSharedSites: { __type: 'Boolean!' },
    isOnlineSaleEnabled: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    restrictedMembershipTemplateIds: { __type: '[ID!]!' },
    restrictedPackageTemplateIds: { __type: '[ID!]!' },
    restrictedSaleEnabled: { __type: 'Boolean!' },
    revenueTagId: { __type: 'String' },
    sharedSiteIds: { __type: '[ID!]!' },
  },
  GiftCardTemplateFilter: {
    fixedValueEnabled: { __type: 'Boolean' },
    isOnlineSaleEnabled: { __type: 'Boolean' },
    restrictedSaleEnabled: { __type: 'Boolean' },
    search: { __type: 'String' },
    status: { __type: 'GiftCardTemplateStatus' },
  },
  GiftCardTemplateSort: {
    direction: { __type: 'SortDirection!' },
    field: { __type: 'GiftCardTemplateSortFields!' },
  },
  GiftCardTemplateUpdateInput: {
    description: { __type: 'String' },
    expiryEnabled: { __type: 'Boolean' },
    expiryMonths: { __type: 'Float' },
    fixedAmount: { __type: 'Numeric' },
    fixedValue: { __type: 'Numeric' },
    fixedValueEnabled: { __type: 'Boolean' },
    giftCardDesignId: { __type: 'ID' },
    isAllSharedSites: { __type: 'Boolean' },
    isOnlineSaleEnabled: { __type: 'Boolean' },
    name: { __type: 'String' },
    restrictedMembershipTemplateIds: { __type: '[ID!]' },
    restrictedPackageTemplateIds: { __type: '[ID!]' },
    restrictedSaleEnabled: { __type: 'Boolean' },
    revenueTagId: { __type: 'String' },
    sharedSiteIds: { __type: '[ID!]' },
  },
  GiftCardTemplates: {
    __typename: { __type: 'String!' },
    records: { __type: '[GiftCardTemplate!]!' },
    totalCount: { __type: 'Float!' },
  },
  GiftCardTemplatesPaginationInput: { limit: { __type: 'Float' }, offset: { __type: 'Float' } },
  GiftCards: {
    __typename: { __type: 'String!' },
    records: { __type: '[GiftCardsRecords!]!' },
    totalCount: { __type: 'Float!' },
  },
  GiftCardsRecords: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'ID' },
    code: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    currentBalance: { __type: 'Numeric!' },
    deliveryDate: { __type: 'String' },
    expiredAt: { __type: 'String' },
    expiresAt: { __type: 'String' },
    expiryJurisdiction: { __type: 'String' },
    giftCardDesignId: { __type: 'ID' },
    giftCardId: { __type: 'ID!' },
    giftCardTemplateId: { __type: 'ID!' },
    initialValue: { __type: 'Numeric!' },
    isImported: { __type: 'Boolean!' },
    personalMessage: { __type: 'String' },
    purchaserEmail: { __type: 'String' },
    purchaserName: { __type: 'String' },
    recipientEmail: { __type: 'String' },
    recipientEmailScheduledFor: { __type: 'String' },
    recipientEmailSentAt: { __type: 'String' },
    recipientName: { __type: 'String' },
    redeemerName: { __type: 'String' },
    restrictedMembershipTemplateIds: { __type: '[ID!]!' },
    restrictedPackageTemplateIds: { __type: '[ID!]!' },
    restrictedSaleEnabled: { __type: 'Boolean!' },
    updatedAt: { __type: 'String!' },
  },
  GrowClientLocation: {
    __typename: { __type: 'String!' },
    siteId: { __type: 'String' },
    siteName: { __type: 'String' },
    status: { __type: 'ClientGrowSyncStatus!' },
  },
  GrowContactLocationStatus: {
    __typename: { __type: 'String!' },
    customFields: { __type: '[GrowRecordField!]!' },
    failCode: { __type: 'String' },
    failError: { __type: 'String' },
    failedAt: { __type: 'String' },
    growContactId: { __type: 'String' },
    growLocationId: { __type: 'String!' },
    lastCollectedAt: { __type: 'String' },
    lastSyncedAt: { __type: 'String' },
    siteId: { __type: 'String' },
    siteName: { __type: 'String' },
    status: { __type: 'ClientGrowSyncStatus!' },
    syncedFields: { __type: '[GrowRecordField!]!' },
    tags: { __type: '[String!]!' },
  },
  GrowHq: {
    __typename: { __type: 'String!' },
    growLocationId: { __type: 'String' },
    id: { __type: 'String!' },
    isAuthenticated: { __type: 'Boolean' },
    lastSyncError: { __type: 'String' },
    lastSyncedAt: { __type: 'String' },
    linkedSiteIds: { __type: '[String!]' },
    name: { __type: 'String!' },
    syncAttempts: { __type: 'Float' },
    syncStatus: { __type: 'SyncStatus' },
    tokenExpiresAt: { __type: 'String' },
  },
  GrowLastCollect: { __typename: { __type: 'String!' }, full: { __type: 'String' } },
  GrowLocation: {
    __typename: { __type: 'String!' },
    growLocationId: { __type: 'String!' },
    hqId: { __type: 'String' },
    lastSyncError: { __type: 'String' },
    lastSyncedAt: { __type: 'String' },
    siteId: { __type: 'String!' },
    siteName: { __type: 'String!' },
    syncAttempts: { __type: 'Float' },
    syncStatus: { __type: 'SyncStatus' },
  },
  GrowRecordField: {
    __typename: { __type: 'String!' },
    clientValue: { __type: 'String' },
    label: { __type: 'String!' },
    mismatch: { __type: 'Boolean!' },
    value: { __type: 'String!' },
  },
  GuardianAuthorityRevocationResult: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'ID!' },
    guardianClientId: { __type: 'ID!' },
    revokedRelationCount: { __type: 'Float!' },
  },
  GuardianPermissionWithdrawal: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'ID!' },
    guardianSignerId: { __type: 'ID!' },
    reason: { __type: 'String' },
    recordedByStaffUserId: { __type: 'ID' },
    source: { __type: 'ConsentWithdrawalSource!' },
    withdrawalId: { __type: 'ID!' },
    withdrawnAt: { __type: 'String!' },
  },
  GuestPass: {
    __typename: { __type: 'String!' },
    acceptedAt: { __type: 'String' },
    bookingId: { __type: 'ID' },
    checkInId: { __type: 'ID' },
    claimUrl: { __type: 'String' },
    claimedAllocationId: { __type: 'ID' },
    claimedServiceId: { __type: 'ID' },
    corporateId: { __type: 'ID' },
    createdAt: { __type: 'String!' },
    expiresAt: { __type: 'String' },
    guestPassAllocationId: { __type: 'ID!' },
    guestPassId: { __type: 'ID!' },
    inviteEmailSentAt: { __type: 'String' },
    inviteToken: { __type: 'String!' },
    recipientClientId: { __type: 'ID' },
    recipientEmail: { __type: 'String' },
    recipientName: { __type: 'String' },
    recipientPhone: { __type: 'String' },
    revokedAt: { __type: 'String' },
    senderClientId: { __type: 'ID!' },
    sentAt: { __type: 'String!' },
    serviceId: { __type: 'ID!' },
    siteId: { __type: 'ID!' },
    siteSessionTypeId: { __type: 'ID' },
    status: { __type: 'GuestPassStatus!' },
    updatedAt: { __type: 'String!' },
    usedAt: { __type: 'String' },
  },
  GuestPassAllocationSummary: {
    __typename: { __type: 'String!' },
    carriedForward: { __type: 'Float!' },
    expiresAtDate: { __type: 'String' },
    nextAllocationDate: { __type: 'String' },
    remainingPasses: { __type: 'Float!' },
    serviceId: { __type: 'ID!' },
    totalPasses: { __type: 'Float!' },
  },
  GuestPassAllowanceImpact: {
    __typename: { __type: 'String!' },
    activeMembers: { __type: 'Float!' },
    membersWithOpenPasses: { __type: 'Float!' },
    unclaimedInvites: { __type: 'Float!' },
  },
  GuestPassByTokenResult: {
    __typename: { __type: 'String!' },
    errorCode: { __type: 'GuestPassByTokenError' },
    expiresAt: { __type: 'String' },
    recipientEmailMasked: { __type: 'String' },
    senderName: { __type: 'String' },
    siteId: { __type: 'ID' },
    siteName: { __type: 'String' },
  },
  GuestPassCreditLineUsage: {
    __typename: { __type: 'String!' },
    creditsRemaining: { __type: 'Float!' },
    creditsTotal: { __type: 'Float!' },
    sessionTypeNames: { __type: '[String!]!' },
  },
  GuestPassVisit: {
    __typename: { __type: 'String!' },
    bookingId: { __type: 'ID' },
    checkInId: { __type: 'ID' },
    credits: { __type: 'Float!' },
    guestPassId: { __type: 'ID!' },
    recipientName: { __type: 'String' },
    sessionName: { __type: 'String' },
    sessionStartTime: { __type: 'String' },
    sessionTypeName: { __type: 'String' },
    usedAt: { __type: 'String!' },
  },
  GuestPassWithSession: {
    __typename: { __type: 'String!' },
    acceptedAt: { __type: 'String' },
    bookingId: { __type: 'ID' },
    checkInId: { __type: 'ID' },
    claimUrl: { __type: 'String' },
    claimedAllocationId: { __type: 'ID' },
    claimedServiceId: { __type: 'ID' },
    corporateId: { __type: 'ID' },
    createdAt: { __type: 'String!' },
    creditLines: { __type: '[GuestPassCreditLineUsage!]!' },
    expiresAt: { __type: 'String' },
    guestPassAllocationId: { __type: 'ID!' },
    guestPassId: { __type: 'ID!' },
    inviteEmailSentAt: { __type: 'String' },
    inviteToken: { __type: 'String!' },
    recipientClientId: { __type: 'ID' },
    recipientEmail: { __type: 'String' },
    recipientName: { __type: 'String' },
    recipientPhone: { __type: 'String' },
    revokedAt: { __type: 'String' },
    senderClientId: { __type: 'ID!' },
    senderName: { __type: 'String' },
    sentAt: { __type: 'String!' },
    serviceId: { __type: 'ID!' },
    sessionName: { __type: 'String' },
    sessionStartTime: { __type: 'String' },
    sessionTypeName: { __type: 'String' },
    siteId: { __type: 'ID!' },
    siteSessionTypeId: { __type: 'ID' },
    status: { __type: 'GuestPassStatus!' },
    updatedAt: { __type: 'String!' },
    usedAt: { __type: 'String' },
    visits: { __type: '[GuestPassVisit!]!' },
  },
  GuestPassesFilterInput: {
    recipientClientId: { __type: 'ID' },
    senderClientId: { __type: 'ID' },
    serviceId: { __type: 'ID' },
    status: { __type: 'GuestPassStatus' },
  },
  HapanaFeesTemplate: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    failedPaymentFeeScope: { __type: 'FailedPaymentFeeScope!' },
    fees: { __type: '[HapanaFeesTemplateFees!]!' },
    hapanaFeesTemplateId: { __type: 'String!' },
    name: { __type: 'String!' },
    sites: { __type: '[Site!]!' },
    updatedAt: { __type: 'String!' },
  },
  HapanaFeesTemplateFees: {
    __typename: { __type: 'String!' },
    enabled: { __type: 'Boolean' },
    feeId: { __type: 'String!' },
    rate: { __type: 'Float' },
  },
  HapanaFeesTemplatesBasePageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    hasPreviousPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Float!' },
  },
  HapanaFeesTemplatesPageInfo: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'HapanaFeesTemplatesBasePageInfo!' },
    results: { __type: '[HapanaFeesTemplate!]!' },
  },
  HeldPaymentReleaseResult: {
    __typename: { __type: 'String!' },
    outcome: { __type: 'HeldPaymentReleaseOutcome!' },
  },
  HelpDoc: {
    __typename: { __type: 'String!' },
    announcedIn: { __type: '[ReleaseHubNote!]!' },
    category: { __type: 'String' },
    contentMarkdown: { __type: 'String!' },
    coverImageUrl: { __type: 'String' },
    knowledgeArticleId: { __type: 'ID!' },
    publishedAt: { __type: 'String' },
    slug: { __type: 'String!' },
    subtitle: { __type: 'String' },
    summary: { __type: 'String' },
    tierTags: { __type: '[String!]!' },
    title: { __type: 'String!' },
    updatedAt: { __type: 'String!' },
  },
  HelpDocCategory: {
    __typename: { __type: 'String!' },
    articleCount: { __type: 'Int!' },
    color: { __type: 'String' },
    icon: { __type: 'String' },
    knowledgeArticleCategoryId: { __type: 'ID!' },
    name: { __type: 'String!' },
    slug: { __type: 'String!' },
    sortOrder: { __type: 'Int!' },
  },
  HelpDocSummary: {
    __typename: { __type: 'String!' },
    category: { __type: 'String' },
    coverImageUrl: { __type: 'String' },
    createdAt: { __type: 'String!' },
    knowledgeArticleId: { __type: 'ID!' },
    publishedAt: { __type: 'String' },
    slug: { __type: 'String!' },
    subtitle: { __type: 'String' },
    summary: { __type: 'String' },
    tierTags: { __type: '[String!]!' },
    title: { __type: 'String!' },
    updatedAt: { __type: 'String!' },
  },
  HubSpotCompaniesSearchResult: {
    __typename: { __type: 'String!' },
    paging: { __type: 'HubSpotCompaniesSearchResultPaging' },
    results: { __type: '[HubSpotCompany!]!' },
    total: { __type: 'Float!' },
  },
  HubSpotCompaniesSearchResultPaging: {
    __typename: { __type: 'String!' },
    next: { __type: 'HubSpotCompaniesSearchResultPagingNext' },
  },
  HubSpotCompaniesSearchResultPagingNext: {
    __typename: { __type: 'String!' },
    after: { __type: 'String!' },
  },
  HubSpotCompany: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    id: { __type: 'String!' },
    properties: { __type: 'HubSpotCompanyProperties!' },
    updatedAt: { __type: 'String!' },
  },
  HubSpotCompanyContactsResult: {
    __typename: { __type: 'String!' },
    contacts: { __type: '[HubSpotContact!]!' },
  },
  HubSpotCompanyProperties: {
    __typename: { __type: 'String!' },
    domain: { __type: 'String' },
    name: { __type: 'String' },
    website: { __type: 'String' },
  },
  HubSpotContact: {
    __typename: { __type: 'String!' },
    email: { __type: 'String' },
    firstName: { __type: 'String' },
    id: { __type: 'String!' },
    lastName: { __type: 'String' },
  },
  ImageFileConfigField: {
    __typename: { __type: 'String!' },
    lastFailure: { __type: 'RoomResourceTemplateImageLastFailure' },
    pending: { __type: 'RoomResourceTemplateImagePending' },
    status: { __type: 'FileUploadConfigFieldStatus!' },
    versions: { __type: '[ImageFileVersion!]' },
  },
  ImageFileVersion: {
    __typename: { __type: 'String!' },
    byteSize: { __type: 'Float' },
    format: { __type: 'ImageFileVersionFormat!' },
    height: { __type: 'Int' },
    sha256: { __type: 'String' },
    type: { __type: 'ImageFileVersionType!' },
    url: { __type: 'String!' },
    width: { __type: 'Int' },
  },
  ImagePublicSignedUrl: {
    __typename: { __type: 'String!' },
    byteSize: { __type: 'Float' },
    height: { __type: 'Int' },
    sha256: { __type: 'String' },
    type: { __type: 'ImageFileVersionType!' },
    url: { __type: 'String!' },
    width: { __type: 'Int' },
  },
  ImagePublicSignedUrlInput: {
    format: { __type: 'ImageFileVersionFormat!' },
    type: { __type: 'ImageSupportedVariant!' },
  },
  ImportAuditCsvUrl: { __typename: { __type: 'String!' }, url: { __type: 'String' } },
  ImportClientsInput: { csvContent: { __type: 'String!' } },
  ImportCustomText: {
    __typename: { __type: 'String!' },
    errorsByLanguage: { __type: 'JSONObject' },
    importedLanguages: { __type: '[String!]' },
    success: { __type: 'Boolean!' },
  },
  ImportDistinctLocationIds: {
    __typename: { __type: 'String!' },
    locationIds: { __type: '[String!]!' },
  },
  ImportFailuresAuditCsvUrl: { __typename: { __type: 'String!' }, url: { __type: 'String' } },
  ImportPrerequisites: {
    __typename: { __type: 'String!' },
    prerequisites: { __type: '[ImportPrerequisitesPrerequisites!]!' },
  },
  ImportPrerequisitesPrerequisites: {
    __typename: { __type: 'String!' },
    existsInDb: { __type: 'Boolean!' },
    importType: { __type: 'String!' },
  },
  ImportPreview: {
    __typename: { __type: 'String!' },
    fieldMetadata: { __type: '[ImportPreviewFieldMetadata!]' },
    invalidCount: { __type: 'Float!' },
    pendingCount: { __type: 'Float!' },
    rows: { __type: '[ImportPreviewRows!]!' },
    skippedCount: { __type: 'Float!' },
    totalErrorCount: { __type: 'Float!' },
    totalRows: { __type: 'Float!' },
    validCount: { __type: 'Float!' },
    warningCount: { __type: 'Float!' },
  },
  ImportPreviewFieldMetadata: {
    __typename: { __type: 'String!' },
    allowedValues: { __type: '[String!]' },
    displayName: { __type: 'String' },
    fieldName: { __type: 'String!' },
    fieldType: { __type: 'String!' },
  },
  ImportPreviewRows: {
    __typename: { __type: 'String!' },
    csvData: { __type: 'String!' },
    errorMessage: { __type: 'String' },
    processingStatus: { __type: 'String' },
    rowIndex: { __type: 'Float!' },
    skippedAt: { __type: 'String' },
    skippedBy: { __type: 'String' },
    validationErrors: { __type: '[ImportPreviewRowsValidationErrors!]' },
    validationStatus: { __type: 'String!' },
  },
  ImportPreviewRowsValidationErrors: {
    __typename: { __type: 'String!' },
    code: { __type: 'String!' },
    field: { __type: 'String!' },
    message: { __type: 'String!' },
    severity: { __type: 'String!' },
  },
  ImportReferenceDataExportXlsx: {
    __typename: { __type: 'String!' },
    fileContentBase64: { __type: 'String!' },
    fileName: { __type: 'String!' },
  },
  ImportSession: {
    __typename: { __type: 'String!' },
    auditCsvUrl: { __type: 'String' },
    bytesProcessed: { __type: 'Float' },
    completedAt: { __type: 'String' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'String!' },
    defaultSiteId: { __type: 'String' },
    failedRowCount: { __type: 'Float' },
    failuresAuditCsvUrl: { __type: 'String' },
    failuresSourceFileUrl: { __type: 'String' },
    fileName: { __type: 'String!' },
    fileSize: { __type: 'Float!' },
    gcsUrl: { __type: 'String!' },
    importSessionId: { __type: 'ID!' },
    importType: { __type: 'String!' },
    invalidRowCount: { __type: 'Float' },
    lastProgressAt: { __type: 'String' },
    mappedHeaders: { __type: 'String' },
    membershipImportSummary: { __type: 'MembershipImportSummary' },
    migrationId: { __type: 'ID' },
    migrationName: { __type: 'String' },
    orderedHeaders: { __type: 'String' },
    postImportChecks: { __type: 'ImportSessionPostImportChecks' },
    processedAuditCsvUrl: { __type: 'String' },
    processedRowCount: { __type: 'Float' },
    siteId: { __type: 'String' },
    skippedAuditCsvUrl: { __type: 'String' },
    skippedSourceFileUrl: { __type: 'String' },
    sourceSystem: { __type: 'String' },
    status: { __type: 'String!' },
    successRowCount: { __type: 'Float' },
    targetEnvironment: { __type: 'String' },
    templateVersion: { __type: 'String' },
    totalRows: { __type: 'Float!' },
    validRowCount: { __type: 'Float' },
    validSiteIds: { __type: 'String' },
  },
  ImportSessionPostImportChecks: {
    __typename: { __type: 'String!' },
    cpmSiteMismatch: { __type: 'ImportSessionPostImportChecksServiceRiStatusPair' },
    membershipMissingNextBillingDate: {
      __type: 'ImportSessionPostImportChecksServiceRiStatusPair',
    },
    membershipStatusCounts: { __type: '[MembershipStatusCount!]' },
    membershipStatusMismatch: { __type: 'ImportSessionPostImportChecksServiceRiStatusPair' },
    nextDatePairMismatch: { __type: 'ImportSessionPostImportChecksServiceRiStatusPair' },
    scheduledInvoiceMissingCpm: { __type: 'ImportSessionPostImportChecksServiceRiStatusPair' },
    serviceRiStatusPair: { __type: 'ImportSessionPostImportChecksServiceRiStatusPair' },
    zeroRiWithAmountDue: { __type: 'ImportSessionPostImportChecksServiceRiStatusPair' },
  },
  ImportSessionPostImportChecksServiceRiStatusPair: {
    __typename: { __type: 'String!' },
    samples: { __type: '[String!]!' },
    violationCount: { __type: 'Float!' },
  },
  ImportSitesExportCsv: {
    __typename: { __type: 'String!' },
    csvContent: { __type: 'String!' },
    fileName: { __type: 'String!' },
  },
  ImportSourceFileUrl: { __typename: { __type: 'String!' }, url: { __type: 'String' } },
  ImportTemplateCsv: {
    __typename: { __type: 'String!' },
    csvContent: { __type: 'String!' },
    fileName: { __type: 'String!' },
    importType: { __type: 'String!' },
  },
  InceptionPanelSettings: {
    __typename: { __type: 'String!' },
    doorId: { __type: 'String!' },
    rootUrl: { __type: 'String!' },
    serialNumber: { __type: 'String!' },
    username: { __type: 'String!' },
  },
  IncomingApprovalDecisionInput: {
    destinationServiceTemplateId: { __type: 'ID' },
    expectedDestinationServiceTemplateId: { __type: 'ID' },
    movementId: { __type: 'ID!' },
    reason: { __type: 'String' },
  },
  IncomingApprovalDecisionResult: {
    __typename: { __type: 'String!' },
    accepted: { __type: 'Boolean!' },
    memberMovementId: { __type: 'ID!' },
  },
  InitSignupSignatureUploadIntendedClientInput: {
    dateOfBirth: { __type: 'String' },
    email: { __type: 'String' },
    firstName: { __type: 'String!' },
    lastName: { __type: 'String!' },
  },
  InitializeVideoUploadInput: {
    contentType: { __type: 'String!' },
    fileName: { __type: 'String!' },
    fileSize: { __type: 'Int!' },
    knowledgeArticleId: { __type: 'ID!' },
    origin: { __type: 'String!' },
  },
  InitiateCSVUpload: {
    __typename: { __type: 'String!' },
    importSessionId: { __type: 'ID!' },
    tempUrl: { __type: 'String!' },
    userId: { __type: 'String!' },
    userType: { __type: 'String!' },
  },
  InitiateMediaUploadInputInput: {
    description: { __type: 'String' },
    fileName: { __type: 'String!' },
    fileSize: { __type: 'Float' },
    folder: { __type: 'String' },
    mimeType: { __type: 'String!' },
    title: { __type: 'String' },
  },
  InitiatePaymentMethodResponse: {
    __typename: { __type: 'String!' },
    applePayAvailable: { __type: 'Boolean!' },
    clientPaymentMethodId: { __type: 'ID!' },
    completionConfig: { __type: 'CompletionConfig!' },
    currencyCode: { __type: 'String' },
    disableWallets: { __type: 'Boolean!' },
    googlePayAvailable: { __type: 'Boolean!' },
  },
  InitiateTerminalPaymentMethodSetup: {
    __typename: { __type: 'String!' },
    clientPaymentMethodId: { __type: 'String!' },
    setupIntentId: { __type: 'String!' },
    status: { __type: 'String!' },
  },
  InitiateZIPUpload: {
    __typename: { __type: 'String!' },
    importSessionId: { __type: 'ID!' },
    tempUrl: { __type: 'String!' },
    userId: { __type: 'String!' },
    userType: { __type: 'String!' },
  },
  InstructorForSite: {
    __typename: { __type: 'String!' },
    email: { __type: 'String!' },
    firstName: { __type: 'String!' },
    lastName: { __type: 'String!' },
    staffUserId: { __type: 'String!' },
    status: { __type: 'String!' },
    workingHours: { __type: 'StaffUserDataWorkingHours' },
  },
  InstructorListInfo: {
    __typename: { __type: 'String!' },
    instructorID: { __type: 'String!' },
    instructorName: { __type: 'String!' },
    instructorProfile: { __type: 'String' },
  },
  InviteStaffMember: {
    __typename: { __type: 'String!' },
    invitationId: { __type: 'ID!' },
    token: { __type: 'String!' },
  },
  InviteStaffMemberInvitationInput: {
    email: { __type: 'String!' },
    firstName: { __type: 'String' },
    lastName: { __type: 'String' },
    permissionPolicyIds: { __type: '[String!]' },
    role: { __type: 'InvitationRole!' },
    siteId: { __type: 'ID' },
  },
  Invoice: {
    __typename: { __type: 'String!' },
    addonConfigId: { __type: 'ID' },
    amountDue: { __type: 'Numeric!' },
    beneficiary: { __type: 'Client' },
    beneficiaryId: { __type: 'ID' },
    cancellationSource: { __type: 'InvoiceCancellationSource' },
    cancelledAt: { __type: 'String' },
    cancelledByStaffUserId: { __type: 'String' },
    client: { __type: 'Client' },
    clientId: { __type: 'ID' },
    clientName: { __type: 'String' },
    createdAt: { __type: 'String!' },
    createdByRecurringInvoiceId: { __type: 'ID' },
    currency: { __type: 'Currency!' },
    customPaymentMethodLabel: { __type: 'String' },
    description: { __type: 'String' },
    dueDate: { __type: 'String!' },
    exclusiveTaxTotal: { __type: 'Numeric!' },
    fullyPaidDate: { __type: 'String' },
    giftCardCode: { __type: 'String' },
    giftCardId: { __type: 'String' },
    giftCardName: { __type: 'String' },
    hasDisputeLoss: { __type: 'Boolean!' },
    hasRefundFailed: { __type: 'Boolean!' },
    hasRequiredClientAction: { __type: 'Boolean!' },
    inclusiveTaxTotal: { __type: 'Numeric!' },
    invoiceId: { __type: 'ID!' },
    invoiceTypes: { __type: '[InvoiceType!]!' },
    isFailurePath: { __type: 'Boolean!' },
    isImported: { __type: 'Boolean!' },
    isPresaleInitial: { __type: 'Boolean' },
    isRecurring: { __type: 'Boolean!' },
    itemDiscountTotal: { __type: 'Numeric!' },
    items: { __type: '[InvoiceItems!]!' },
    membershipName: { __type: 'String' },
    paymentMethodTypes: { __type: '[PaymentMethodType!]' },
    payments: { __type: '[Payment!]!' },
    pendingChange: { __type: 'PendingChange' },
    pendingReason: { __type: 'InvoicePendingReason' },
    processedAt: { __type: 'String' },
    productName: { __type: 'String' },
    recurringInvoiceId: { __type: 'ID' },
    recurringInvoiceSequence: { __type: 'Float' },
    recurringInvoiceStatus: { __type: 'String' },
    recurringInvoiceSuspendedUntil: { __type: 'String' },
    recurringSequence: { __type: 'Float' },
    recurringServiceId: { __type: 'ID' },
    redeemedAt: { __type: 'String' },
    redeemedAtSiteId: { __type: 'String' },
    redeemedAtSiteName: { __type: 'String' },
    refunds: { __type: '[Refund!]!' },
    reinstatedAt: { __type: 'String' },
    reinstatedByStaffUserId: { __type: 'String' },
    saleDate: { __type: 'String!' },
    saleId: { __type: 'String!' },
    scheduledClientPaymentMethodId: { __type: 'ID' },
    scheduledProcessingAt: { __type: 'String' },
    site: { __type: 'InvoiceSite' },
    siteId: { __type: 'String!' },
    source: { __type: 'InvoiceSource!' },
    staffUserId: { __type: 'String' },
    status: { __type: 'InvoiceStatus!' },
    totalAmount: { __type: 'Numeric!' },
    totalValue: { __type: 'Numeric!' },
    updatedAt: { __type: 'String!' },
    usedByEquipmentAssignmentId: { __type: 'ID' },
  },
  InvoiceAgreementSigningLinksResult: {
    __typename: { __type: 'String!' },
    errors: { __type: '[String!]!' },
    success: { __type: 'Boolean!' },
    urls: { __type: '[String!]!' },
  },
  InvoiceFailureInfo: {
    __typename: { __type: 'String!' },
    attemptCount: { __type: 'Float!' },
    failureCategory: { __type: 'FailureCategory' },
    fallbackCardBrand: { __type: 'String' },
    fallbackCardLast4: { __type: 'String' },
    fallbackReason: { __type: 'PaymentFallbackReason' },
    fallbackState: { __type: 'PaymentFallbackState' },
    lastFailedAt: { __type: 'String' },
    nextAttemptDate: { __type: 'String' },
    rawErrorCode: { __type: 'String' },
    rawErrorMessage: { __type: 'String' },
  },
  InvoiceItemMetadata: {
    __typename: { __type: 'String!' },
    actionType: { __type: 'String' },
    appliedRules: { __type: 'InvoiceItemMetadataAppliedRules' },
    attemptSequence: { __type: 'Float' },
    bookingId: { __type: 'String' },
    feeAmount: { __type: 'String' },
    feeDate: { __type: 'String' },
    feePercentage: { __type: 'String' },
    feeRound: { __type: 'Float' },
    isSecondaryFee: { __type: 'Boolean' },
    itemType: { __type: 'String' },
    lateCancelFeeId: { __type: 'String' },
    lateCancelFeeName: { __type: 'String' },
    noShowFeeId: { __type: 'String' },
    noShowFeeName: { __type: 'String' },
    paymentGatewayTransactionId: { __type: 'String' },
    paymentId: { __type: 'String' },
    paymentMethodType: { __type: 'String' },
    recurringInvoiceId: { __type: 'String' },
    recurringInvoiceName: { __type: 'String' },
    rules: { __type: '[String!]' },
    sequenceNumber: { __type: 'Float' },
    serviceCancellationId: { __type: 'String' },
    serviceId: { __type: 'String' },
    serviceSuspensionId: { __type: 'String' },
    serviceTemplateName: { __type: 'String' },
    sessionDate: { __type: 'String' },
    sessionId: { __type: 'String' },
    sessionName: { __type: 'String' },
    sessionTime: { __type: 'String' },
    sessionTypeId: { __type: 'String' },
    sessionTypeName: { __type: 'String' },
    siteId: { __type: 'String' },
    withdrawnAt: { __type: 'String' },
  },
  InvoiceItemMetadataAppliedRules: {
    __typename: { __type: 'String!' },
    all_attempts: { __type: 'String' },
    first_attempt: { __type: 'String' },
    second_attempt: { __type: 'String' },
    third_attempt: { __type: 'String' },
  },
  InvoiceItems: {
    __typename: { __type: 'String!' },
    amount: { __type: 'Numeric!' },
    autoRenewServiceTemplateName: { __type: 'String' },
    beneficiaryClientId: { __type: 'ID' },
    beneficiaryNote: { __type: 'String' },
    billableItemId: { __type: 'ID' },
    bookingId: { __type: 'ID' },
    createdAt: { __type: 'String!' },
    deletedAt: { __type: 'String' },
    description: { __type: 'String!' },
    discountAmount: { __type: 'Numeric!' },
    discountReason: { __type: 'String' },
    discountType: { __type: 'DiscountType' },
    discountValue: { __type: 'Numeric' },
    earlyAccess: { __type: 'EarlyAccessTimeline' },
    exclusiveTaxAmount: { __type: 'Numeric!' },
    giftCardCode: { __type: 'String' },
    giftCardId: { __type: 'ID' },
    giftCardTemplateId: { __type: 'ID' },
    inclusiveTaxAmount: { __type: 'Numeric!' },
    invoiceId: { __type: 'ID!' },
    invoiceItemId: { __type: 'ID!' },
    isAddOn: { __type: 'Boolean!' },
    itemDetails: { __type: 'InvoiceItemsItemDetails' },
    itemType: { __type: 'InvoiceItemType!' },
    metadata: { __type: 'InvoiceItemMetadata' },
    paymentId: { __type: 'ID' },
    preTaxAmount: { __type: 'Numeric!' },
    productId: { __type: 'ID' },
    productTemplateId: { __type: 'ID' },
    promoCode: { __type: 'String' },
    promoCodeId: { __type: 'ID' },
    quantity: { __type: 'Float!' },
    referredByStaffUserId: { __type: 'ID' },
    revenueTagGlCode: { __type: 'String' },
    revenueTagId: { __type: 'ID' },
    revenueTagName: { __type: 'String' },
    serviceAutoRenew: { __type: 'Boolean' },
    serviceId: { __type: 'ID' },
    serviceTemplateId: { __type: 'ID' },
    sessionId: { __type: 'ID' },
    siteId: { __type: 'ID!' },
    taxCalculations: { __type: '[InvoiceItemsTaxCalculations!]!' },
    totalValue: { __type: 'Numeric!' },
    unitPrice: { __type: 'Numeric!' },
    updatedAt: { __type: 'String!' },
  },
  InvoiceItemsItemDetails: {
    __typename: { __type: 'String!' },
    addOnJoinsInvoiceId: { __type: 'ID' },
    addOnParentServiceId: { __type: 'ID' },
    addOnParentServiceTemplateId: { __type: 'ID' },
    addOnPaymentType: { __type: 'ServiceTemplateAddOnPaymentType' },
    addOnRecurringAmount: { __type: 'String' },
    addOnTaxEnabled: { __type: 'Boolean' },
    addOnTaxSettingIds: { __type: '[String!]' },
    chargeSetupFeeUpFront: { __type: 'Boolean' },
    creditValidUntilDate: { __type: 'String' },
    creditValidUntilSetByStaff: { __type: 'Boolean' },
    deferredForInvoiceItemId: { __type: 'ID' },
    discountAppliesToAllPayments: { __type: 'Boolean' },
    earlyAccessEndDate: { __type: 'String' },
    earlyAccessStartDate: { __type: 'String' },
    enableAutoRenew: { __type: 'Boolean' },
    giftCardCustomId: { __type: 'ID' },
    giftCardDeliveryDate: { __type: 'String' },
    giftCardDesignId: { __type: 'ID' },
    giftCardExpiryDate: { __type: 'String' },
    giftCardExpiryMode: { __type: 'GiftCardExpiryMode' },
    giftCardPersonalMessage: { __type: 'String' },
    giftCardPurchaserEmail: { __type: 'String' },
    giftCardPurchaserName: { __type: 'String' },
    giftCardRecipientEmail: { __type: 'String' },
    giftCardRecipientFullName: { __type: 'String' },
    giftCardRecipientName: { __type: 'String' },
    giftCardSendToRecipient: { __type: 'Boolean' },
    giftCardValue: { __type: 'String' },
    oneTimeSetupFee: { __type: 'String' },
    paidInFullCycles: { __type: 'Float' },
    payUpFront: { __type: 'Boolean' },
    proratedAmount: { __type: 'String' },
    proratedCredits: { __type: 'Float' },
    prorationEndDate: { __type: 'String' },
    prorationStartDate: { __type: 'String' },
    serviceFirstBillingDate: { __type: 'String' },
    serviceStartDate: { __type: 'String' },
    serviceTemplateAddOnId: { __type: 'ID' },
    signedClientAgreementId: { __type: 'ID' },
    signedClientAgreementIds: { __type: '[ID!]' },
    totalCredits: { __type: 'Float' },
  },
  InvoiceItemsTaxCalculations: {
    __typename: { __type: 'String!' },
    amount: { __type: 'Numeric!' },
    taxSetting: { __type: 'InvoiceItemsTaxCalculationsTaxSetting!' },
  },
  InvoiceItemsTaxCalculationsTaxSetting: {
    __typename: { __type: 'String!' },
    amount: { __type: 'Numeric!' },
    name: { __type: 'String!' },
    taxSettingId: { __type: 'String!' },
    type: { __type: 'TaxSettingType!' },
  },
  InvoiceRevenueDailyPoint: {
    __typename: { __type: 'String!' },
    amount: { __type: 'Float!' },
    date: { __type: 'String!' },
  },
  InvoiceRevenueSummary: {
    __typename: { __type: 'String!' },
    graph: { __type: '[InvoiceRevenueDailyPoint!]!' },
    netRevenueCurrent: { __type: 'Float!' },
    netRevenuePrevious: { __type: 'Float!' },
    paidTotalCurrent: { __type: 'Float!' },
    refundTotalCurrent: { __type: 'Float!' },
    windowDays: { __type: 'Float!' },
  },
  InvoiceRow: {
    __typename: { __type: 'String!' },
    addonConfigId: { __type: 'ID' },
    amountDue: { __type: 'Numeric!' },
    beneficiary: { __type: 'Client' },
    beneficiaryId: { __type: 'ID' },
    cancellationSource: { __type: 'InvoiceCancellationSource' },
    cancelledAt: { __type: 'String' },
    cancelledByStaffUserId: { __type: 'String' },
    client: { __type: 'Client' },
    clientId: { __type: 'ID' },
    clientName: { __type: 'String' },
    createdAt: { __type: 'String!' },
    createdByRecurringInvoiceId: { __type: 'ID' },
    currency: { __type: 'Currency!' },
    customPaymentMethodLabel: { __type: 'String' },
    description: { __type: 'String' },
    dueDate: { __type: 'String!' },
    estimatedGatewayFailedPaymentFee: { __type: 'Numeric' },
    exclusiveTaxTotal: { __type: 'Numeric!' },
    failureInfo: { __type: 'InvoiceFailureInfo' },
    fullyPaidDate: { __type: 'String' },
    giftCardCode: { __type: 'String' },
    giftCardId: { __type: 'String' },
    giftCardName: { __type: 'String' },
    hasDisputeLoss: { __type: 'Boolean!' },
    hasRefundFailed: { __type: 'Boolean!' },
    hasRequiredClientAction: { __type: 'Boolean!' },
    inclusiveTaxTotal: { __type: 'Numeric!' },
    invoiceId: { __type: 'ID!' },
    invoiceTypes: { __type: '[InvoiceType!]!' },
    isFailurePath: { __type: 'Boolean!' },
    isImported: { __type: 'Boolean!' },
    isRecurring: { __type: 'Boolean!' },
    itemDiscountTotal: { __type: 'Numeric!' },
    items: { __type: '[InvoiceItems!]!' },
    membershipName: { __type: 'String' },
    paymentMethodTypes: { __type: '[PaymentMethodType!]' },
    payments: { __type: '[Payment!]!' },
    pendingReason: { __type: 'InvoicePendingReason' },
    processedAt: { __type: 'String' },
    productName: { __type: 'String' },
    recurringInvoiceId: { __type: 'ID' },
    recurringInvoiceSequence: { __type: 'Float' },
    recurringServiceId: { __type: 'ID' },
    redeemedAt: { __type: 'String' },
    redeemedAtSiteId: { __type: 'String' },
    redeemedAtSiteName: { __type: 'String' },
    refunds: { __type: '[Refund!]!' },
    reinstatedAt: { __type: 'String' },
    reinstatedByStaffUserId: { __type: 'String' },
    saleDate: { __type: 'String!' },
    saleId: { __type: 'String!' },
    scheduledClientPaymentMethodId: { __type: 'ID' },
    scheduledProcessingAt: { __type: 'String' },
    site: { __type: 'InvoiceSite' },
    siteId: { __type: 'String!' },
    source: { __type: 'InvoiceSource!' },
    staffUserId: { __type: 'String' },
    status: { __type: 'InvoiceStatus!' },
    totalAmount: { __type: 'Numeric!' },
    totalValue: { __type: 'Numeric!' },
    updatedAt: { __type: 'String!' },
    usedByEquipmentAssignmentId: { __type: 'ID' },
  },
  InvoiceSite: { __typename: { __type: 'String!' }, countryCode: { __type: 'String' } },
  Invoices: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'InvoicesPageInfo!' },
    results: { __type: '[InvoicesResults!]!' },
  },
  InvoicesFilterCreatedAtInput: { from: { __type: 'String' }, to: { __type: 'String' } },
  InvoicesFilterInput: {
    clientId: { __type: 'String' },
    createdAt: { __type: 'InvoicesFilterCreatedAtInput' },
    invoiceTypes: { __type: '[InvoiceType!]' },
    saleDate: { __type: 'InvoicesFilterSaleDateInput' },
    status: { __type: 'InvoiceStatus' },
    statuses: { __type: '[InvoiceStatus!]' },
  },
  InvoicesFilterSaleDateInput: { from: { __type: 'String' }, to: { __type: 'String' } },
  InvoicesOrderByInput: {
    column: { __type: 'InvoicesOrderBy!' },
    direction: { __type: 'OrderByDirection!' },
  },
  InvoicesPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  InvoicesResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'InvoiceRow!' },
  },
  IosUsageDescriptionState: {
    __typename: { __type: 'String!' },
    key: { __type: 'IosUsageDescriptionKey!' },
    locked: { __type: 'Boolean!' },
    source: { __type: 'NativePermissionSource!' },
    text: { __type: 'String!' },
  },
  IsClientAtSite: { __typename: { __type: 'String!' }, isAtSite: { __type: 'Boolean!' } },
  JurisdictionAgeBand: {
    __typename: { __type: 'String!' },
    maxAge: { __type: 'Float' },
    minAge: { __type: 'Float!' },
    outcome: { __type: 'AgeBandOutcome!' },
  },
  JurisdictionAgeBandInput: {
    maxAge: { __type: 'Float' },
    minAge: { __type: 'Float!' },
    outcome: { __type: 'AgeBandOutcome!' },
  },
  KioskAppMetadata: {
    __typename: { __type: 'String!' },
    corporateId: { __type: 'String!' },
    id: { __type: 'String!' },
    lastUpdated: { __type: 'String!' },
    version: { __type: 'String!' },
  },
  KioskBooking: {
    __typename: { __type: 'String!' },
    bookingId: { __type: 'String!' },
    bookingSource: { __type: 'String' },
    clientId: { __type: 'String!' },
    clientName: { __type: 'String' },
    paymentStatus: { __type: 'String' },
    spotId: { __type: 'Float' },
    status: { __type: 'String!' },
  },
  KioskBranding: {
    __typename: { __type: 'String!' },
    primaryColor: { __type: 'String' },
    secondaryColor: { __type: 'String' },
  },
  KioskClientPolicy: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'String!' },
    hasPending: { __type: 'Boolean!' },
  },
  KioskDefaults: {
    __typename: { __type: 'String!' },
    checkIn: { __type: 'Boolean!' },
    classCheckIn: { __type: 'Boolean!' },
    forms: { __type: 'Boolean!' },
    introOffers: { __type: 'Boolean!' },
    manageAccount: { __type: 'Boolean!' },
    packages: { __type: 'Boolean!' },
  },
  KioskImageUrls: {
    __typename: { __type: 'String!' },
    backgroundImageUrl: { __type: 'String' },
    logoUrl: { __type: 'String' },
  },
  KioskInstructor: {
    __typename: { __type: 'String!' },
    firstName: { __type: 'String!' },
    lastName: { __type: 'String!' },
    staffUserId: { __type: 'String!' },
  },
  KioskPinStatus: {
    __typename: { __type: 'String!' },
    hasPinSet: { __type: 'Boolean!' },
    pinSetAt: { __type: 'String' },
    sessionValidityDays: { __type: 'Float!' },
  },
  KioskResourceTemplate: {
    __typename: { __type: 'String!' },
    imageUrl: { __type: 'String!' },
    name: { __type: 'String!' },
    roomResourceTemplateId: { __type: 'String!' },
    spotHeight: { __type: 'Float!' },
    spotWidth: { __type: 'Float!' },
    spots: { __type: '[KioskSpot!]!' },
  },
  KioskRoom: {
    __typename: { __type: 'String!' },
    hasResourceBooking: { __type: 'Boolean!' },
    name: { __type: 'String' },
    roomResourceTemplateId: { __type: 'String' },
  },
  KioskSession: {
    __typename: { __type: 'String!' },
    bookedCount: { __type: 'Float' },
    disabledSpotIds: { __type: '[Float!]!' },
    endTime: { __type: 'String!' },
    name: { __type: 'String!' },
    sessionId: { __type: 'String!' },
    size: { __type: 'Float' },
    startTime: { __type: 'String!' },
    status: { __type: 'String!' },
  },
  KioskSessionBookings: {
    __typename: { __type: 'String!' },
    bookings: { __type: '[KioskBooking!]!' },
    clientPolicies: { __type: '[KioskClientPolicy!]!' },
    instructor: { __type: 'KioskInstructor' },
    resourceTemplate: { __type: 'KioskResourceTemplate' },
    room: { __type: 'KioskRoom' },
    session: { __type: 'KioskSession!' },
  },
  KioskSetupResponse: {
    __typename: { __type: 'String!' },
    data: { __type: 'KioskSetupResponseData' },
    message: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  KioskSetupResponseData: {
    __typename: { __type: 'String!' },
    appConfig: { __type: 'KioskAppMetadata!' },
    branding: { __type: 'KioskBranding' },
    images: { __type: 'KioskImageUrls' },
  },
  KioskSpot: {
    __typename: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    x: { __type: 'Float!' },
    y: { __type: 'Float!' },
  },
  KnowledgeArticle: {
    __typename: { __type: 'String!' },
    category: { __type: 'String' },
    contentMarkdown: { __type: 'String!' },
    coverImagePosition: { __type: 'CoverImagePosition' },
    coverImageUrl: { __type: 'String' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'String!' },
    deletedAt: { __type: 'String' },
    knowledgeArticleId: { __type: 'ID!' },
    metaDescription: { __type: 'String' },
    metaTitle: { __type: 'String' },
    permissionTags: { __type: '[String!]' },
    publishedAt: { __type: 'String' },
    roleTags: { __type: '[String!]' },
    slug: { __type: 'String!' },
    status: { __type: 'KnowledgeArticleStatus!' },
    subtitle: { __type: 'String' },
    summary: { __type: 'String' },
    tags: { __type: '[String!]' },
    tierTags: { __type: '[String!]' },
    title: { __type: 'String!' },
    translations: { __type: '[KnowledgeArticleTranslation!]' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'String' },
    version: { __type: 'Int!' },
  },
  KnowledgeArticleCategory: {
    __typename: { __type: 'String!' },
    articleCount: { __type: 'Int' },
    color: { __type: 'String' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'String!' },
    deletedAt: { __type: 'String' },
    draftCount: { __type: 'Int' },
    icon: { __type: 'String' },
    knowledgeArticleCategoryId: { __type: 'ID!' },
    name: { __type: 'String!' },
    slug: { __type: 'String!' },
    sortOrder: { __type: 'Int!' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'String' },
  },
  KnowledgeArticleCategoryCreateInput: {
    color: { __type: 'String' },
    icon: { __type: 'String' },
    name: { __type: 'String!' },
    slug: { __type: 'String' },
    sortOrder: { __type: 'Int' },
  },
  KnowledgeArticleCategoryUpdateInput: {
    color: { __type: 'String' },
    icon: { __type: 'String' },
    name: { __type: 'String' },
    slug: { __type: 'String' },
    sortOrder: { __type: 'Int' },
  },
  KnowledgeArticleCreateInput: {
    category: { __type: 'String' },
    contentMarkdown: { __type: 'String!' },
    coverImagePosition: { __type: 'CoverImagePositionInput' },
    coverImageUrl: { __type: 'String' },
    metaDescription: { __type: 'String' },
    metaTitle: { __type: 'String' },
    permissionTags: { __type: '[String!]' },
    roleTags: { __type: '[String!]' },
    slug: { __type: 'String!' },
    status: { __type: 'KnowledgeArticleStatus' },
    subtitle: { __type: 'String' },
    summary: { __type: 'String' },
    tags: { __type: '[String!]' },
    tierTags: { __type: '[String!]' },
    title: { __type: 'String!' },
  },
  KnowledgeArticleFilterInput: {
    category: { __type: 'String' },
    includeDeleted: { __type: 'Boolean' },
    permissionTags: { __type: '[String!]' },
    roleTags: { __type: '[String!]' },
    search: { __type: 'String' },
    status: { __type: 'KnowledgeArticleStatus' },
    tags: { __type: '[String!]' },
    tierTags: { __type: '[String!]' },
  },
  KnowledgeArticleRevision: {
    __typename: { __type: 'String!' },
    aiChangeSummary: { __type: 'String' },
    baseVersion: { __type: 'Int' },
    changeType: { __type: 'RevisionChangeType!' },
    confidence: { __type: 'Float' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'String!' },
    knowledgeArticleId: { __type: 'ID' },
    proposedCategory: { __type: 'String' },
    proposedContentMarkdown: { __type: 'String!' },
    proposedRoleTags: { __type: '[String!]' },
    proposedSlug: { __type: 'String' },
    proposedSubtitle: { __type: 'String' },
    proposedSummary: { __type: 'String' },
    proposedTags: { __type: '[String!]' },
    proposedTierTags: { __type: '[String!]' },
    proposedTitle: { __type: 'String!' },
    reviewNotes: { __type: 'String' },
    reviewState: { __type: 'RevisionReviewState!' },
    reviewedAt: { __type: 'String' },
    reviewedBy: { __type: 'String' },
    revisionId: { __type: 'ID!' },
    sourceBranch: { __type: 'String' },
    sourceCommitSha: { __type: 'String' },
    sourceFiles: { __type: '[String!]' },
    sourceLinearIssueId: { __type: 'String' },
    sourceLinearIssueUrl: { __type: 'String' },
    updatedAt: { __type: 'String!' },
  },
  KnowledgeArticleRevisionContentInput: {
    proposedCategory: { __type: 'String' },
    proposedContentMarkdown: { __type: 'String' },
    proposedSubtitle: { __type: 'String' },
    proposedSummary: { __type: 'String' },
    proposedTitle: { __type: 'String' },
  },
  KnowledgeArticleRevisionFilterInput: {
    changeType: { __type: 'RevisionChangeType' },
    knowledgeArticleId: { __type: 'ID' },
    reviewState: { __type: 'RevisionReviewState' },
  },
  KnowledgeArticleRevisionsResponse: {
    __typename: { __type: 'String!' },
    revisions: { __type: '[KnowledgeArticleRevision!]!' },
    total: { __type: 'Int!' },
  },
  KnowledgeArticleStats: {
    __typename: { __type: 'String!' },
    byStatus: { __type: 'JSON!' },
    total: { __type: 'Int!' },
  },
  KnowledgeArticleTranslation: {
    __typename: { __type: 'String!' },
    contentMarkdown: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    knowledgeArticleId: { __type: 'String!' },
    locale: { __type: 'String!' },
    metaDescription: { __type: 'String' },
    metaTitle: { __type: 'String' },
    needsRetranslation: { __type: 'Boolean!' },
    reviewedAt: { __type: 'String' },
    reviewedBy: { __type: 'String' },
    sourceVersion: { __type: 'Int!' },
    status: { __type: 'TranslationStatus!' },
    subtitle: { __type: 'String' },
    summary: { __type: 'String' },
    title: { __type: 'String!' },
    translatedAt: { __type: 'String' },
    translationId: { __type: 'ID!' },
    updatedAt: { __type: 'String!' },
  },
  KnowledgeArticleTranslationInput: {
    contentMarkdown: { __type: 'String!' },
    locale: { __type: 'String!' },
    metaDescription: { __type: 'String' },
    metaTitle: { __type: 'String' },
    subtitle: { __type: 'String' },
    summary: { __type: 'String' },
    title: { __type: 'String!' },
  },
  KnowledgeArticleUpdateInput: {
    category: { __type: 'String' },
    contentMarkdown: { __type: 'String' },
    coverImagePosition: { __type: 'CoverImagePositionInput' },
    coverImageUrl: { __type: 'String' },
    metaDescription: { __type: 'String' },
    metaTitle: { __type: 'String' },
    permissionTags: { __type: '[String!]' },
    roleTags: { __type: '[String!]' },
    slug: { __type: 'String' },
    status: { __type: 'KnowledgeArticleStatus' },
    subtitle: { __type: 'String' },
    summary: { __type: 'String' },
    tags: { __type: '[String!]' },
    tierTags: { __type: '[String!]' },
    title: { __type: 'String' },
  },
  KnowledgeArticlesByCategoryResponse: {
    __typename: { __type: 'String!' },
    articles: { __type: '[KnowledgeArticle!]!' },
    hasMore: { __type: 'Boolean!' },
    totalCount: { __type: 'Int!' },
  },
  KnowledgeArticlesResponse: {
    __typename: { __type: 'String!' },
    articles: { __type: '[KnowledgeArticle!]!' },
    total: { __type: 'Int!' },
  },
  KnowledgeDocument: {
    __typename: { __type: 'String!' },
    category: { __type: 'String!' },
    content: { __type: 'String!' },
    corporateId: { __type: 'String!' },
    id: { __type: 'ID!' },
    lastUpdated: { __type: 'String!' },
    siteId: { __type: 'String' },
    source: { __type: 'String!' },
    tags: { __type: '[String!]!' },
    title: { __type: 'String!' },
  },
  KnowledgeDocumentInput: {
    category: { __type: 'String!' },
    content: { __type: 'String!' },
    corporateId: { __type: 'String!' },
    siteId: { __type: 'String' },
    source: { __type: 'String!' },
    tags: { __type: '[String!]!' },
    title: { __type: 'String!' },
  },
  KnowledgeSearchInput: {
    category: { __type: 'String' },
    corporateId: { __type: 'String!' },
    limit: { __type: 'Int' },
    planTier: { __type: 'String' },
    query: { __type: 'String!' },
    scopeLevel: { __type: 'String' },
    userRole: { __type: 'String' },
  },
  KnowledgeSearchResponse: {
    __typename: { __type: 'String!' },
    query: { __type: 'String!' },
    results: { __type: '[SearchResult!]!' },
    suggestions: { __type: '[String!]!' },
    total: { __type: 'Int!' },
  },
  LampSetSettingsInput: {
    enabled: { __type: 'Boolean!' },
    lifeHours: { __type: 'Int' },
    startingAsOf: { __type: 'String' },
    startingHours: { __type: 'Float' },
    warningHours: { __type: 'Int' },
  },
  LastAttendanceFeedback: {
    __typename: { __type: 'String!' },
    attendanceDate: { __type: 'String!' },
    bookingId: { __type: 'String' },
    bookingStatus: { __type: 'String' },
    creditsRequired: { __type: 'Float' },
    dropInPrice: { __type: 'Float' },
    durationMinutes: { __type: 'Float' },
    feedbackSubmitted: { __type: 'Boolean!' },
    instructorName: { __type: 'String!' },
    roomName: { __type: 'String' },
    sessionDate: { __type: 'String!' },
    sessionId: { __type: 'String!' },
    sessionName: { __type: 'String!' },
    siteId: { __type: 'String' },
    siteIsDigital: { __type: 'Boolean' },
    siteName: { __type: 'String' },
    siteTimezone: { __type: 'String' },
    startTime: { __type: 'String' },
  },
  LeadSourcesBulkUpdateInput: { leadSources: { __type: '[String!]!' } },
  LeaderboardAttendanceAggregation: {
    __typename: { __type: 'String!' },
    attendanceCount: { __type: 'Float!' },
    clientId: { __type: 'String!' },
    firstCheckInAt: { __type: 'String!' },
  },
  LeaderboardConfig: {
    __typename: { __type: 'String!' },
    autoRollover: { __type: 'Boolean!' },
    config: { __type: 'JSONObject!' },
    corporateId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'String!' },
    customEndDate: { __type: 'String' },
    customStartDate: { __type: 'String' },
    deletedAt: { __type: 'String' },
    description: { __type: 'String' },
    entryCount: { __type: 'Float!' },
    imageUrl: { __type: 'String' },
    lastMaterializedAt: { __type: 'String' },
    leaderboardConfigId: { __type: 'String!' },
    leaderboardType: { __type: 'String!' },
    memberDisplayFormat: { __type: 'String!' },
    minParticipants: { __type: 'Float!' },
    name: { __type: 'String!' },
    rankingDirection: { __type: 'String!' },
    refreshFrequency: { __type: 'String!' },
    scope: { __type: 'String!' },
    scoreType: { __type: 'String!' },
    siteIds: { __type: '[String!]' },
    status: { __type: 'String!' },
    timePeriodType: { __type: 'String!' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'String' },
    visibility: { __type: 'String!' },
  },
  LeaderboardConfigConnection: {
    __typename: { __type: 'String!' },
    hasMore: { __type: 'Boolean!' },
    results: { __type: '[LeaderboardConfig!]!' },
    totalCount: { __type: 'Float!' },
  },
  LeaderboardDashboard: {
    __typename: { __type: 'String!' },
    entryCount: { __type: 'Float!' },
    lastMaterializedAt: { __type: 'String' },
    leaderboardConfigId: { __type: 'String!' },
    leaderboardType: { __type: 'String!' },
    name: { __type: 'String!' },
    snapshotTopScore: { __type: 'Float' },
    snapshotTotalParticipants: { __type: 'Float' },
    status: { __type: 'String!' },
  },
  LeaderboardSnapshot: {
    __typename: { __type: 'String!' },
    averageScore: { __type: 'Float!' },
    corporateId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    droppedOut: { __type: 'Float!' },
    leaderboardConfigId: { __type: 'String!' },
    medianScore: { __type: 'Float' },
    newEntrants: { __type: 'Float!' },
    periodKey: { __type: 'String!' },
    snapshotDate: { __type: 'String!' },
    snapshotId: { __type: 'String!' },
    topEntries: { __type: 'JSONObject!' },
    topScore: { __type: 'Float!' },
    totalParticipants: { __type: 'Float!' },
  },
  LeaderboardSummaryItem: {
    __typename: { __type: 'String!' },
    entryCount: { __type: 'Float!' },
    leaderboardConfigId: { __type: 'String!' },
    leaderboardType: { __type: 'String!' },
    name: { __type: 'String!' },
    topClientName: { __type: 'String' },
    topScore: { __type: 'Float' },
  },
  LegacyInceptionConfig: {
    __typename: { __type: 'String!' },
    doorId: { __type: 'String' },
    rootUrl: { __type: 'String' },
    serialNumber: { __type: 'String' },
    username: { __type: 'String' },
  },
  LinkCorporatePushAppInput: {
    id: { __type: 'String!' },
    key: { __type: 'String!' },
    replacesAppIds: { __type: '[String!]' },
  },
  LinkSiteToHqResponse: { __typename: { __type: 'String!' }, success: { __type: 'Boolean!' } },
  ListAllClients: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'ListAllClientsPageInfo!' },
    results: { __type: '[ListAllClientsResults!]!' },
  },
  ListAllClientsPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  ListAllClientsResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'ClientAdmin!' },
  },
  ListAllScheduledInvoicesFilterDateRangeInput: {
    from: { __type: 'String' },
    to: { __type: 'String' },
  },
  ListAllScheduledInvoicesFilterInput: {
    clientId: { __type: 'ID' },
    dateRange: { __type: 'ListAllScheduledInvoicesFilterDateRangeInput' },
    serviceId: { __type: 'ID' },
    type: { __type: 'ScheduledInvoiceType' },
  },
  ListAllScheduledInvoicesInput: {
    filter: { __type: 'ListAllScheduledInvoicesFilterInput' },
    lookAheadMonths: { __type: 'Float!' },
    page: { __type: 'Float!' },
    pageSize: { __type: 'Float!' },
    search: { __type: 'String' },
  },
  ListAllScheduledInvoicesResult: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'ScheduledInvoicesPageInfo!' },
    results: { __type: '[Invoice!]!' },
  },
  ListCancelledInvoicesFilterDateRangeInput: {
    from: { __type: 'String' },
    to: { __type: 'String' },
  },
  ListCancelledInvoicesFilterInput: {
    clientId: { __type: 'ID' },
    dateRange: { __type: 'ListCancelledInvoicesFilterDateRangeInput' },
    invoiceTypes: { __type: '[InvoiceType!]' },
  },
  ListCancelledInvoicesInput: {
    filter: { __type: 'ListCancelledInvoicesFilterInput' },
    page: { __type: 'Float!' },
    pageSize: { __type: 'Float!' },
    search: { __type: 'String' },
  },
  ListCancelledInvoicesResult: {
    __typename: { __type: 'String!' },
    earliestReinstateDate: { __type: 'String!' },
    pageInfo: { __type: 'ScheduledInvoicesPageInfo!' },
    results: { __type: '[CancelledInvoiceRow!]!' },
  },
  ListGcsBundlePrefixes: {
    __typename: { __type: 'String!' },
    bucket: { __type: 'String!' },
    folders: { __type: '[ListGcsBundlePrefixesFolders!]!' },
    prefix: { __type: 'String!' },
    truncated: { __type: 'Boolean!' },
    zipCount: { __type: 'Float!' },
  },
  ListGcsBundlePrefixesFolders: {
    __typename: { __type: 'String!' },
    gcsPrefix: { __type: 'String!' },
    name: { __type: 'String!' },
    prefix: { __type: 'String!' },
  },
  ListGcsBundleZips: {
    __typename: { __type: 'String!' },
    bucket: { __type: 'String!' },
    prefix: { __type: 'String!' },
    truncated: { __type: 'Boolean!' },
    zips: { __type: '[ListGcsBundleZipsZips!]!' },
  },
  ListGcsBundleZipsZips: {
    __typename: { __type: 'String!' },
    gcsUrl: { __type: 'String!' },
    name: { __type: 'String!' },
    objectPath: { __type: 'String!' },
    sizeBytes: { __type: 'Float!' },
  },
  ListPastInvoicesByService: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'ListPastInvoicesByServicePageInfo!' },
    results: { __type: '[ListPastInvoicesByServiceResults!]!' },
  },
  ListPastInvoicesByServiceArgs: {
    cursor: { __type: 'String' },
    orderBy: { __type: '[ListPastInvoicesByServiceArgsOrderByInput!]' },
    pageSize: { __type: 'Float' },
    serviceId: { __type: 'ID!' },
  },
  ListPastInvoicesByServiceArgsOrderByInput: {
    column: { __type: 'RecurringInvoiceOrderBy!' },
    direction: { __type: 'OrderByDirection!' },
  },
  ListPastInvoicesByServicePageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  ListPastInvoicesByServiceResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'InvoiceRow!' },
  },
  ListRecurringInvoicesFilterInput: {
    excludeSecondaryFees: { __type: 'Boolean' },
    status: { __type: 'RecurringInvoiceStatus' },
    statuses: { __type: '[RecurringInvoiceStatus!]' },
  },
  ListRecurringInvoicesInput: {
    cursor: { __type: 'String' },
    filter: { __type: 'ListRecurringInvoicesFilterInput' },
    pageSize: { __type: 'Float' },
    search: { __type: 'String' },
  },
  ListScheduledInvoicesByServiceArgs: {
    lookAheadMonths: { __type: 'Float' },
    orderBy: { __type: '[ListScheduledInvoicesByServiceArgsOrderByInput!]' },
    page: { __type: 'Float!' },
    pageSize: { __type: 'Float!' },
    serviceId: { __type: 'ID!' },
  },
  ListScheduledInvoicesByServiceArgsOrderByInput: {
    column: { __type: 'RecurringInvoiceOrderBy!' },
    direction: { __type: 'OrderByDirection!' },
  },
  ListScheduledInvoicesByServiceResult: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'ListScheduledInvoicesByServiceResultPageInfo!' },
    results: { __type: '[VirtualInvoice!]!' },
  },
  ListScheduledInvoicesByServiceResultPageInfo: {
    __typename: { __type: 'String!' },
    currentPage: { __type: 'Float!' },
    hasNextPage: { __type: 'Boolean!' },
    hasPreviousPage: { __type: 'Boolean!' },
    pageSize: { __type: 'Float!' },
    totalPages: { __type: 'Float!' },
    totalRecords: { __type: 'Float!' },
  },
  ListScheduledJobRunsPaginateInput: { limit: { __type: 'Float!' }, offset: { __type: 'Float!' } },
  ListServicesByTemplateTypeFilterInput: {
    status: { __type: 'ServiceStatus' },
    statuses: { __type: '[ServiceStatus!]' },
  },
  ListServicesByTemplateTypeInput: {
    cursor: { __type: 'String' },
    filter: { __type: 'ListServicesByTemplateTypeFilterInput' },
    pageSize: { __type: 'Float' },
    search: { __type: 'String' },
    templateType: { __type: 'ServiceTemplateType!' },
  },
  LocationOperationsCounts: {
    __typename: { __type: 'String!' },
    availableClientsTabsCount: { __type: 'Float!' },
    blockingReasonsCount: { __type: 'Float!' },
    cancellationReasonsCount: { __type: 'Float!' },
    customPropertiesCount: { __type: 'Float!' },
    leadSourcesCount: { __type: 'Float!' },
    policiesCount: { __type: 'Float!' },
    questionnaireFormsCount: { __type: 'Float!' },
    refundReasonsCount: { __type: 'Float!' },
    sessionFeedbackQuestionsCount: { __type: 'Float!' },
    siteId: { __type: 'String!' },
    suspensionReasonsCount: { __type: 'Float!' },
    tabsDisplayedCount: { __type: 'Float!' },
  },
  LogEquipmentLampChangeInput: {
    changedAt: { __type: 'String!' },
    equipmentId: { __type: 'ID!' },
    lampSets: { __type: '[EquipmentLampSet!]!' },
    newHours: { __type: 'Float' },
    notes: { __type: 'String' },
  },
  MediaFolder: {
    __typename: { __type: 'String!' },
    assetCount: { __type: 'Float!' },
    children: { __type: '[MediaFolderChild!]!' },
    name: { __type: 'String!' },
    path: { __type: 'String!' },
  },
  MediaFolderChild: {
    __typename: { __type: 'String!' },
    assetCount: { __type: 'Float!' },
    name: { __type: 'String!' },
    path: { __type: 'String!' },
  },
  MediaUsageItem: {
    __typename: { __type: 'String!' },
    contentEntryId: { __type: 'String!' },
    contentTypeSlug: { __type: 'String!' },
    role: { __type: 'String!' },
    status: { __type: 'String!' },
    title: { __type: 'String!' },
  },
  MemberApiAuditLog: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    errorCode: { __type: 'String' },
    latencyMs: { __type: 'Float!' },
    memberId: { __type: 'String' },
    method: { __type: 'String!' },
    path: { __type: 'String!' },
    queryParams: { __type: 'String' },
    remoteIp: { __type: 'String' },
    requestBody: { __type: 'String' },
    requestId: { __type: 'String!' },
    responseBody: { __type: 'String' },
    siteId: { __type: 'String' },
    status: { __type: 'Float!' },
    userAgent: { __type: 'String' },
  },
  MemberExperienceBranding: {
    __typename: { __type: 'String!' },
    appName: { __type: 'String' },
    backgroundColor: { __type: 'String!' },
    corporateId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'String' },
    darkBackgroundColor: { __type: 'String' },
    darkPrimaryColor: { __type: 'String' },
    darkPrimaryTextColor: { __type: 'String' },
    darkSecondaryBackgroundColor: { __type: 'String' },
    darkSecondaryColor: { __type: 'String' },
    darkSecondaryTextColor: { __type: 'String' },
    faviconUrl: { __type: 'String' },
    logoUrl: { __type: 'String' },
    primaryColor: { __type: 'String!' },
    primaryTextColor: { __type: 'String!' },
    secondaryBackgroundColor: { __type: 'String' },
    secondaryColor: { __type: 'String!' },
    secondaryTextColor: { __type: 'String!' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'String' },
    version: { __type: 'Float!' },
  },
  MemberExperienceFonts: {
    __typename: { __type: 'String!' },
    corporateId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'String' },
    customFonts: { __type: '[MemberExperienceFontsCustomFonts!]!' },
    customHeadingFonts: { __type: '[MemberExperienceFontsCustomFonts!]!' },
    fontFamily: { __type: 'String!' },
    fontScale: { __type: 'Float!' },
    fontSource: { __type: 'FontSource!' },
    fontUrl: { __type: 'String' },
    headingFontFamily: { __type: 'String' },
    headingFontSource: { __type: 'HeadingFontSource' },
    headingFontUrl: { __type: 'String' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'String' },
    useCustomHeadingFont: { __type: 'Boolean!' },
    version: { __type: 'Float!' },
  },
  MemberExperienceFontsCustomFonts: {
    __typename: { __type: 'String!' },
    displayName: { __type: 'String' },
    format: { __type: 'FontFormat!' },
    name: { __type: 'String!' },
    uploadedAt: { __type: 'String!' },
    uploadedBy: { __type: 'String' },
    url: { __type: 'String!' },
  },
  MemberExperienceRuntime: {
    __typename: { __type: 'String!' },
    colours: { __type: 'MemberExperienceRuntimeColours!' },
    customText: { __type: 'JSONObject!' },
    customTextOverrides: { __type: 'JSONObject!' },
    fonts: { __type: 'MemberExperienceRuntimeFonts!' },
    images: { __type: 'MemberExperienceRuntimeImages!' },
    language: { __type: 'String!' },
    settings: { __type: 'MemberExperienceRuntimeSettings!' },
    source: { __type: 'String!' },
    surface: { __type: 'MemberExperienceSurface!' },
  },
  MemberExperienceRuntimeColours: {
    __typename: { __type: 'String!' },
    configured: { __type: 'Boolean!' },
    dark: { __type: 'MemberExperienceRuntimeColoursDark' },
    light: { __type: 'MemberExperienceRuntimeColoursLight!' },
  },
  MemberExperienceRuntimeColoursDark: {
    __typename: { __type: 'String!' },
    backgroundColor: { __type: 'String' },
    primaryColor: { __type: 'String' },
    primaryTextColor: { __type: 'String' },
    secondaryBackgroundColor: { __type: 'String' },
    secondaryColor: { __type: 'String' },
    secondaryTextColor: { __type: 'String' },
  },
  MemberExperienceRuntimeColoursLight: {
    __typename: { __type: 'String!' },
    backgroundColor: { __type: 'String!' },
    primaryColor: { __type: 'String!' },
    primaryTextColor: { __type: 'String!' },
    secondaryBackgroundColor: { __type: 'String' },
    secondaryColor: { __type: 'String!' },
    secondaryTextColor: { __type: 'String!' },
  },
  MemberExperienceRuntimeFonts: {
    __typename: { __type: 'String!' },
    configured: { __type: 'Boolean!' },
    fontFamily: { __type: 'String!' },
    fontScale: { __type: 'Float!' },
    fontSource: { __type: 'FontSource!' },
    fontUrl: { __type: 'String' },
  },
  MemberExperienceRuntimeImages: {
    __typename: { __type: 'String!' },
    appName: { __type: 'String' },
    faviconUrl: { __type: 'String' },
    loginImageUrl: { __type: 'String' },
    logoUrl: { __type: 'String' },
  },
  MemberExperienceRuntimeSettings: {
    __typename: { __type: 'String!' },
    awardsEnabled: { __type: 'Boolean' },
    barcodeEnabled: { __type: 'Boolean' },
    borderRadius: { __type: 'Float' },
    brandLogoEnabled: { __type: 'Boolean' },
    buttonStyle: { __type: 'String' },
    callUsEnabled: { __type: 'Boolean' },
    challengesEnabled: { __type: 'Boolean' },
    classTimeFilter: { __type: 'Boolean' },
    contactlessCheckin: { __type: 'Boolean' },
    customCssLink: { __type: 'String' },
    darkMode: { __type: 'MemberExperienceDarkMode' },
    darkModeSupport: { __type: 'Boolean' },
    displayInstructor: { __type: 'Boolean' },
    displayPackageDescription: { __type: 'Boolean' },
    displayProfilePicture: { __type: 'Boolean' },
    doorCheckin: { __type: 'Boolean' },
    dynamicImagesEnabled: { __type: 'Boolean' },
    editFieldsAddress: { __type: 'Boolean' },
    editFieldsDob: { __type: 'Boolean' },
    editFieldsEnabled: { __type: 'Boolean' },
    editFieldsName: { __type: 'Boolean' },
    editFieldsPhone: { __type: 'Boolean' },
    filterOptions: { __type: 'MemberExperienceSettingsFilterOptions' },
    fontSize: { __type: 'Float' },
    footerVisible: { __type: 'Boolean' },
    headerVisible: { __type: 'Boolean' },
    moduleClasses: { __type: 'Boolean' },
    moduleDashboard: { __type: 'Boolean' },
    modulePackages: { __type: 'Boolean' },
    modulePayments: { __type: 'Boolean' },
    modulePrivates: { __type: 'Boolean' },
    moduleProfile: { __type: 'Boolean' },
    moduleSchedule: { __type: 'Boolean' },
    moduleWorkshops: { __type: 'Boolean' },
    newsFeedAvailable: { __type: 'Boolean' },
    privatesAnyAvailable: { __type: 'Boolean' },
    redirectUrl: { __type: 'String' },
    showBilling: { __type: 'Boolean' },
    showFilters: { __type: 'Boolean' },
    shownCommPref: { __type: 'Boolean' },
    sidebarPosition: { __type: 'String' },
    signUpEnabled: { __type: 'Boolean' },
    statsAvailable: { __type: 'Boolean' },
    streakScope: { __type: 'MemberExperienceStreakScope' },
    tabDigitalEnabled: { __type: 'Boolean' },
    tabPurchaseEnabled: { __type: 'Boolean' },
  },
  MemberExperienceSettings: {
    __typename: { __type: 'String!' },
    awardsEnabled: { __type: 'Boolean!' },
    barcodeEnabled: { __type: 'Boolean!' },
    borderRadius: { __type: 'Float!' },
    brandLogoEnabled: { __type: 'Boolean!' },
    buttonStyle: { __type: 'WidgetButtonStyle!' },
    callUsEnabled: { __type: 'Boolean!' },
    challengesEnabled: { __type: 'Boolean!' },
    classTimeFilter: { __type: 'Boolean!' },
    contactlessCheckin: { __type: 'Boolean!' },
    corporateId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'String' },
    customCssLink: { __type: 'String!' },
    darkMode: { __type: 'MemberExperienceDarkMode!' },
    darkModeSupport: { __type: 'Boolean!' },
    displayInstructor: { __type: 'Boolean!' },
    displayPackageDescription: { __type: 'Boolean!' },
    displayProfilePicture: { __type: 'Boolean!' },
    doorCheckin: { __type: 'Boolean!' },
    dynamicImagesEnabled: { __type: 'Boolean!' },
    editFieldsAddress: { __type: 'Boolean!' },
    editFieldsDob: { __type: 'Boolean!' },
    editFieldsEnabled: { __type: 'Boolean!' },
    editFieldsName: { __type: 'Boolean!' },
    editFieldsPhone: { __type: 'Boolean!' },
    facebookAppId: { __type: 'String!' },
    facebookClientToken: { __type: 'String!' },
    facebookDisplayName: { __type: 'String!' },
    filterOptions: { __type: 'MemberExperienceSettingsFilterOptions!' },
    fontSize: { __type: 'Float!' },
    footerVisible: { __type: 'Boolean!' },
    headerVisible: { __type: 'Boolean!' },
    moduleClasses: { __type: 'Boolean!' },
    moduleDashboard: { __type: 'Boolean!' },
    modulePackages: { __type: 'Boolean!' },
    modulePayments: { __type: 'Boolean!' },
    modulePrivates: { __type: 'Boolean!' },
    moduleProfile: { __type: 'Boolean!' },
    moduleSchedule: { __type: 'Boolean!' },
    moduleWorkshops: { __type: 'Boolean!' },
    newsFeedAvailable: { __type: 'Boolean!' },
    privatesAnyAvailable: { __type: 'Boolean!' },
    redirectUrl: { __type: 'String!' },
    showBilling: { __type: 'Boolean!' },
    showFilters: { __type: 'Boolean!' },
    shownCommPref: { __type: 'Boolean!' },
    sidebarPosition: { __type: 'SidebarPosition!' },
    signUpEnabled: { __type: 'Boolean!' },
    statsAvailable: { __type: 'Boolean!' },
    streakScope: { __type: 'MemberExperienceStreakScope!' },
    tabDigitalEnabled: { __type: 'Boolean!' },
    tabPurchaseEnabled: { __type: 'Boolean!' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'String' },
    version: { __type: 'Float!' },
  },
  MemberExperienceSettingsFilterOptions: {
    __typename: { __type: 'String!' },
    category: { __type: 'Boolean!' },
    duration: { __type: 'Boolean!' },
    instructor: { __type: 'Boolean!' },
    location: { __type: 'Boolean!' },
    room: { __type: 'Boolean!' },
    sessionType: { __type: 'Boolean!' },
    time: { __type: 'Boolean!' },
  },
  MemberExperienceSurfaceBranding: {
    __typename: { __type: 'String!' },
    backgroundColor: { __type: 'String' },
    corporateId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'String' },
    darkBackgroundColor: { __type: 'String' },
    darkPrimaryColor: { __type: 'String' },
    darkPrimaryTextColor: { __type: 'String' },
    darkSecondaryBackgroundColor: { __type: 'String' },
    darkSecondaryColor: { __type: 'String' },
    darkSecondaryTextColor: { __type: 'String' },
    inheritsGlobal: { __type: 'Boolean!' },
    primaryColor: { __type: 'String' },
    primaryTextColor: { __type: 'String' },
    secondaryBackgroundColor: { __type: 'String' },
    secondaryColor: { __type: 'String' },
    secondaryTextColor: { __type: 'String' },
    surface: { __type: 'MemberExperienceSurface!' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'String' },
    version: { __type: 'Float' },
  },
  MemberExperienceSurfaceIntegration: {
    __typename: { __type: 'String!' },
    appId: { __type: 'String' },
    clientToken: { __type: 'String' },
    corporateId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'String' },
    displayName: { __type: 'String' },
    provider: { __type: 'MemberExperienceSurfaceIntegrationProvider!' },
    surface: { __type: 'MemberExperienceSurface!' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'String' },
  },
  MemberExperienceTheme: {
    __typename: { __type: 'String!' },
    backgroundColor: { __type: 'String!' },
    corporateId: { __type: 'String!' },
    darkBackgroundColor: { __type: 'String' },
    darkPrimaryColor: { __type: 'String' },
    darkPrimaryTextColor: { __type: 'String' },
    darkSecondaryBackgroundColor: { __type: 'String' },
    darkSecondaryColor: { __type: 'String' },
    darkSecondaryTextColor: { __type: 'String' },
    primaryColor: { __type: 'String!' },
    primaryTextColor: { __type: 'String!' },
    secondaryBackgroundColor: { __type: 'String' },
    secondaryColor: { __type: 'String!' },
    secondaryTextColor: { __type: 'String!' },
    source: { __type: 'ThemeValueSource!' },
    surface: { __type: 'MemberExperienceSurface!' },
  },
  MemberFeedbackAnswerInput: { answer: { __type: 'String!' }, questionId: { __type: 'ID!' } },
  MemberFormAnswerInput: {
    answer: { __type: 'String' },
    siteFormQuestionId: { __type: 'String!' },
  },
  MemberFormCompletion: {
    __typename: { __type: 'String!' },
    completedAt: { __type: 'String!' },
    formSubmissionId: { __type: 'String!' },
    result: { __type: 'MemberFormResult' },
  },
  MemberFormDetail: {
    __typename: { __type: 'String!' },
    assignedAt: { __type: 'String!' },
    description: { __type: 'String' },
    formSubmissionId: { __type: 'String!' },
    name: { __type: 'String!' },
    questionCount: { __type: 'Float!' },
    questions: { __type: '[MemberFormQuestion!]!' },
    requiredBefore: { __type: 'FormRequiredBefore' },
    revision: { __type: 'Float!' },
    siteFormId: { __type: 'String!' },
    siteId: { __type: 'String!' },
  },
  MemberFormProgress: {
    __typename: { __type: 'String!' },
    answeredCount: { __type: 'Float!' },
    formSubmissionId: { __type: 'String!' },
  },
  MemberFormQuestion: {
    __typename: { __type: 'String!' },
    blurbText: { __type: 'String' },
    mustAnswerYes: { __type: 'Boolean!' },
    options: { __type: '[String!]!' },
    required: { __type: 'Boolean!' },
    siteFormQuestionId: { __type: 'String!' },
    title: { __type: 'String!' },
    type: { __type: 'String!' },
  },
  MemberFormResult: {
    __typename: { __type: 'String!' },
    description: { __type: 'String' },
    label: { __type: 'String!' },
  },
  MemberGiftCard: {
    __typename: { __type: 'String!' },
    code: { __type: 'String!' },
    currency: { __type: 'String' },
    currentBalance: { __type: 'Numeric!' },
    expiredAt: { __type: 'String' },
    expiresAt: { __type: 'String' },
    giftCardId: { __type: 'ID!' },
    initialValue: { __type: 'Numeric!' },
    isRedeemableHere: { __type: 'Boolean!' },
    locationName: { __type: 'String' },
    purchaseDate: { __type: 'String!' },
    recipientName: { __type: 'String' },
    status: { __type: 'GiftCardStatus!' },
    templateName: { __type: 'String!' },
    timezone: { __type: 'String' },
  },
  MemberLocationInformation: {
    __typename: { __type: 'String!' },
    amenities: { __type: 'MemberSiteAmenities' },
    blocks: { __type: '[MemberSiteInfoBlock!]!' },
    description: { __type: 'String' },
    heading: { __type: 'String!' },
    isTemporarilyClosed: { __type: 'Boolean!' },
    openingHours: { __type: 'MemberOpeningHours' },
    staffedHours: { __type: 'MemberStaffedHours' },
  },
  MemberMovementApprovalReadiness: {
    __typename: { __type: 'String!' },
    approved: { __type: 'Float!' },
    unresolved: { __type: 'Float!' },
  },
  MemberMovementApprovalReadinessInput: {
    corporateId: { __type: 'ID!' },
    runId: { __type: 'ID!' },
  },
  MemberMovementAttestation: {
    __typename: { __type: 'String!' },
    corporateId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    disclaimerText: { __type: 'String!' },
    disclaimerVersion: { __type: 'String!' },
    ipAddress: { __type: 'String' },
    memberMovementAttestationId: { __type: 'ID!' },
    referenceId: { __type: 'String!' },
    scope: { __type: 'MemberMovementAttestationScope!' },
    staffUserId: { __type: 'ID!' },
    typedName: { __type: 'String!' },
  },
  MemberMovementAttestationInput: {
    disclaimerVersion: { __type: 'String!' },
    typedName: { __type: 'String!' },
  },
  MemberMovementAttestationRegisterInput: {
    corporateId: { __type: 'ID!' },
    scope: { __type: 'String' },
  },
  MemberMovementAttestationRegisterResult: {
    __typename: { __type: 'String!' },
    items: { __type: '[MemberMovementAttestation!]!' },
  },
  MemberMovementBlockedQueueInput: {
    blockedReason: { __type: 'MemberMovementBlockedReason' },
    corporateId: { __type: 'ID!' },
    cursor: { __type: 'String' },
    destinationSiteId: { __type: 'ID' },
    pageSize: { __type: 'Float' },
    runId: { __type: 'ID' },
    sourceSiteId: { __type: 'ID' },
    trigger: { __type: 'MemberMovementTrigger' },
  },
  MemberMovementBrandPosture: {
    __typename: { __type: 'String!' },
    rollingApprovalLocked: { __type: 'Boolean!' },
    rollingApprovalType: { __type: 'MemberMovementRollingApprovalType!' },
  },
  MemberMovementConfig: {
    __typename: { __type: 'String!' },
    allowArchivedDestinations: { __type: 'Boolean!' },
    billingAmountStrategy: { __type: 'MemberMovementBillingAmountStrategy!' },
    blockedNotificationCadence: { __type: 'MemberMovementBlockedNotificationCadence!' },
    candidateHomeExclusion: { __type: 'MemberMovementCandidateHomeExclusion!' },
    declineCooldownDays: { __type: 'Float!' },
    emergencyStopped: { __type: 'Boolean!' },
    enabled: { __type: 'Boolean!' },
    excludeScheduledCancellations: { __type: 'Boolean!' },
    excludeSuspendedMemberships: { __type: 'Boolean!' },
    excludedClientIds: { __type: '[ID!]!' },
    excludedPackageCategoryIds: { __type: '[ID!]!' },
    growTransferTag: { __type: 'String!' },
    includedSiteIds: { __type: '[ID!]!' },
    incomingApprovalExpiryDays: { __type: 'Float' },
    incomingApprovalNotifiers: { __type: '[MemberMovementIncomingApprover!]!' },
    maxMovementsPerCycle: { __type: 'MemberMovementMaxMovementsPerCycle!' },
    minMembershipPrice: { __type: 'Float!' },
    minNonHomeVisits: { __type: 'Float!' },
    minPaidAmountInPeriod: { __type: 'Float!' },
    minTenure: { __type: 'MemberMovementDurationConfig' },
    minTenureCutoffDate: { __type: 'String' },
    minVisitPercentAtCandidate: { __type: 'Float!' },
    minVisits: { __type: 'Float!' },
    minVisitsScope: { __type: 'MemberMovementVisitsScope!' },
    movementManagerStaffUserIds: { __type: '[ID!]!' },
    operatingMode: { __type: 'MemberMovementOperatingMode!' },
    postMovementGracePeriodDays: { __type: 'Float!' },
    rollingApprovalLocked: { __type: 'Boolean!' },
    rollingApprovalOverrides: { __type: '[MemberMovementLocationApprovalOverride!]!' },
    rollingApprovalType: { __type: 'MemberMovementRollingApprovalType!' },
    rollingSchedule: { __type: 'MemberMovementRollingSchedule' },
    rollingSchedulerSyncPending: { __type: 'Boolean!' },
    templateMappingMode: { __type: 'MemberMovementTemplateMappingMode!' },
    visitScope: { __type: 'MemberMovementConfigVisitScope!' },
    visitWindowHours: { __type: 'Float!' },
  },
  MemberMovementConfigInput: {
    allowArchivedDestinations: { __type: 'Boolean' },
    billingAmountStrategy: { __type: 'MemberMovementBillingAmountStrategy' },
    blockedNotificationCadence: { __type: 'MemberMovementBlockedNotificationCadence' },
    candidateHomeExclusion: { __type: 'MemberMovementCandidateHomeExclusion' },
    declineCooldownDays: { __type: 'Float' },
    excludeScheduledCancellations: { __type: 'Boolean' },
    excludeSuspendedMemberships: { __type: 'Boolean' },
    excludedClientIds: { __type: '[ID!]' },
    excludedPackageCategoryIds: { __type: '[ID!]' },
    growTransferTag: { __type: 'String' },
    includedSiteIds: { __type: '[ID!]' },
    incomingApprovalExpiryDays: { __type: 'Float' },
    incomingApprovalNotifiers: { __type: '[MemberMovementIncomingApproverInput!]' },
    maxMovementsPerCycle: { __type: 'MemberMovementMaxMovementsPerCycleInput' },
    minMembershipPrice: { __type: 'Float' },
    minNonHomeVisits: { __type: 'Float' },
    minPaidAmountInPeriod: { __type: 'Float' },
    minTenure: { __type: 'MemberMovementDurationConfigInput' },
    minTenureCutoffDate: { __type: 'String' },
    minVisitPercentAtCandidate: { __type: 'Float' },
    minVisits: { __type: 'Float' },
    minVisitsScope: { __type: 'MemberMovementVisitsScope' },
    movementManagerStaffUserIds: { __type: '[ID!]' },
    operatingMode: { __type: 'MemberMovementOperatingMode' },
    postMovementGracePeriodDays: { __type: 'Float' },
    rollingApprovalLocked: { __type: 'Boolean' },
    rollingApprovalType: { __type: 'MemberMovementRollingApprovalType' },
    rollingSchedule: { __type: 'MemberMovementConfigRollingScheduleInput' },
    templateMappingMode: { __type: 'MemberMovementTemplateMappingMode' },
    visitScope: { __type: 'MemberMovementConfigVisitScopeInput' },
    visitWindowHours: { __type: 'Float' },
  },
  MemberMovementConfigRollingScheduleInput: {
    evaluationWindow: { __type: 'MemberMovementDurationConfigInput!' },
    frequency: { __type: 'MemberMovementDurationConfigInput!' },
    previewWindowHours: { __type: 'Float!' },
  },
  MemberMovementConfigVisitScope: {
    __typename: { __type: 'String!' },
    class: { __type: 'Boolean!' },
    general: { __type: 'Boolean!' },
  },
  MemberMovementConfigVisitScopeInput: {
    class: { __type: 'Boolean!' },
    general: { __type: 'Boolean!' },
  },
  MemberMovementConnection: {
    __typename: { __type: 'String!' },
    items: { __type: '[MemberMovementListItem!]!' },
    pageInfo: { __type: 'MemberMovementPageInfo!' },
  },
  MemberMovementDeleteResult: {
    __typename: { __type: 'String!' },
    deleted: { __type: 'Boolean!' },
  },
  MemberMovementDestinationCharge: {
    __typename: { __type: 'String!' },
    amount: { __type: 'String!' },
    currency: { __type: 'String' },
    invoiceId: { __type: 'ID!' },
    paidAt: { __type: 'String' },
    status: { __type: 'String!' },
  },
  MemberMovementDestinationTemplate: {
    __typename: { __type: 'String!' },
    archived: { __type: 'Boolean!' },
    billingCycleAmount: { __type: 'Float' },
    billingCycleUnit: { __type: 'String' },
    name: { __type: 'String!' },
    price: { __type: 'String!' },
    serviceTemplateId: { __type: 'ID!' },
  },
  MemberMovementDetail: {
    __typename: { __type: 'String!' },
    approvedAt: { __type: 'String' },
    approvedByName: { __type: 'String' },
    approvedByStaffUserId: { __type: 'String' },
    attestationId: { __type: 'ID' },
    blockedReason: { __type: 'MemberMovementBlockedReason' },
    candidateSiteName: { __type: 'String' },
    clientEmail: { __type: 'String' },
    clientId: { __type: 'ID!' },
    clientName: { __type: 'String' },
    corporateId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    declineReason: { __type: 'String' },
    declinedAt: { __type: 'String' },
    declinedByName: { __type: 'String' },
    declinedByStaffUserId: { __type: 'String' },
    destinationAmount: { __type: 'Float' },
    destinationChosenAt: { __type: 'String' },
    destinationChosenByName: { __type: 'String' },
    destinationChosenByStaffUserId: { __type: 'ID' },
    destinationCurrency: { __type: 'String' },
    destinationOverridden: { __type: 'Boolean!' },
    destinationServiceId: { __type: 'ID' },
    destinationServiceTemplateId: { __type: 'ID' },
    destinationSiteId: { __type: 'ID' },
    destinationTemplateArchived: { __type: 'Boolean' },
    destinationTemplateName: { __type: 'String' },
    error: { __type: 'String' },
    executedAt: { __type: 'String' },
    forceIncluded: { __type: 'Boolean' },
    gateResults: { __type: '[MemberMovementGateResult!]' },
    homeSiteName: { __type: 'String' },
    memberMovementId: { __type: 'ID!' },
    memberMovementRunId: { __type: 'ID' },
    membershipName: { __type: 'String' },
    membershipPrice: { __type: 'Float' },
    paidAtHomeAmount: { __type: 'Float' },
    paymentCollected: { __type: 'Boolean' },
    paymentMigrationReason: { __type: 'MemberMovementPaymentMigrationReason' },
    paymentMigrationStatus: { __type: 'MemberMovementPaymentMigrationStatus' },
    reasonCode: { __type: 'MemberMovementReasonCode' },
    replayOfMovementId: { __type: 'ID' },
    revertReason: { __type: 'String' },
    revertedAt: { __type: 'String' },
    revertedByName: { __type: 'String' },
    revertedByStaffUserId: { __type: 'ID' },
    reviewNote: { __type: 'String' },
    reviewStatus: { __type: 'MemberMovementReviewStatus' },
    sourceAmount: { __type: 'Float' },
    sourceCurrency: { __type: 'String' },
    sourceServiceId: { __type: 'ID!' },
    sourceServiceTemplateId: { __type: 'ID!' },
    sourceSiteId: { __type: 'ID!' },
    sourceStateSnapshot: { __type: 'JSONObject' },
    status: { __type: 'MemberMovementStatus!' },
    totalVisits: { __type: 'Float' },
    trigger: { __type: 'MemberMovementTrigger!' },
    updatedAt: { __type: 'String!' },
    visitCount: { __type: 'Float' },
    visitPercent: { __type: 'Float' },
    visitScopeUsed: { __type: 'MemberMovementVisitsScope' },
  },
  MemberMovementDurationConfig: {
    __typename: { __type: 'String!' },
    unit: { __type: 'MemberMovementDurationUnit!' },
    value: { __type: 'Float!' },
  },
  MemberMovementDurationConfigInput: {
    unit: { __type: 'MemberMovementDurationUnit!' },
    value: { __type: 'Float!' },
  },
  MemberMovementEligibilityCheckInput: {
    clientId: { __type: 'ID!' },
    corporateId: { __type: 'ID!' },
    serviceId: { __type: 'ID' },
  },
  MemberMovementEligibilityResult: {
    __typename: { __type: 'String!' },
    candidateSiteId: { __type: 'ID' },
    candidateVisits: { __type: 'Float!' },
    clientId: { __type: 'ID!' },
    gateResults: { __type: '[MemberMovementGateResult!]!' },
    homeSiteId: { __type: 'ID!' },
    membershipPrice: { __type: 'Float!' },
    paidAtHomeAmount: { __type: 'Float!' },
    qualified: { __type: 'Boolean!' },
    reasonCode: { __type: 'MemberMovementReasonCode' },
    serviceId: { __type: 'ID!' },
    status: { __type: 'String!' },
    totalVisits: { __type: 'Float!' },
    visitPercent: { __type: 'Float' },
  },
  MemberMovementEntitlementInput: { enabled: { __type: 'Boolean' } },
  MemberMovementGateResult: {
    __typename: { __type: 'String!' },
    gate: { __type: 'Float!' },
    key: { __type: 'MemberMovementGateKey!' },
    measured: { __type: 'String' },
    reasonCode: { __type: 'MemberMovementReasonCode' },
    status: { __type: 'MemberMovementGateStatus!' },
    threshold: { __type: 'String' },
  },
  MemberMovementHeldMovement: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'ID!' },
    holdingMovementId: { __type: 'ID!' },
    holdingRunId: { __type: 'ID' },
    holdingRunStatus: { __type: 'String' },
    memberMovementId: { __type: 'ID!' },
    sourceServiceId: { __type: 'ID!' },
  },
  MemberMovementHomeSiteRecoveryInput: {
    corporateId: { __type: 'ID!' },
    cursor: { __type: 'String' },
    pageSize: { __type: 'Float' },
  },
  MemberMovementIncomingApprovalQueueInput: {
    cursor: { __type: 'String' },
    destinationSiteId: { __type: 'ID' },
    pageSize: { __type: 'Float' },
  },
  MemberMovementIncomingApprover: {
    __typename: { __type: 'String!' },
    siteId: { __type: 'ID!' },
    staffUserIds: { __type: '[ID!]!' },
  },
  MemberMovementIncomingApproverInput: {
    siteId: { __type: 'ID!' },
    staffUserIds: { __type: '[ID!]!' },
  },
  MemberMovementIncomingConnection: {
    __typename: { __type: 'String!' },
    items: { __type: '[MemberMovementListItem!]!' },
    pageInfo: { __type: 'MemberMovementPageInfo!' },
    sites: { __type: '[MemberMovementIncomingSite!]!' },
  },
  MemberMovementIncomingDestinationTemplate: {
    __typename: { __type: 'String!' },
    archived: { __type: 'Boolean!' },
    billedPrice: { __type: 'String' },
    billedPriceCurrency: { __type: 'String' },
    billingAmountStrategy: { __type: 'MemberMovementBillingAmountStrategy!' },
    billingCycleAmount: { __type: 'Float' },
    billingCycleUnit: { __type: 'String' },
    currency: { __type: 'String' },
    lengthType: { __type: 'String' },
    name: { __type: 'String!' },
    price: { __type: 'String!' },
    serviceTemplateId: { __type: 'ID!' },
  },
  MemberMovementIncomingDestinationTemplatesInput: { memberMovementId: { __type: 'ID!' } },
  MemberMovementIncomingMovement: {
    __typename: { __type: 'String!' },
    approvedAt: { __type: 'String' },
    approvedByName: { __type: 'String' },
    approvedByStaffUserId: { __type: 'String' },
    attestationId: { __type: 'ID' },
    billedPrice: { __type: 'String' },
    billedPriceCurrency: { __type: 'String' },
    billingAmountStrategy: { __type: 'MemberMovementBillingAmountStrategy!' },
    blockedReason: { __type: 'MemberMovementBlockedReason' },
    candidateSiteName: { __type: 'String' },
    clientEmail: { __type: 'String' },
    clientId: { __type: 'ID!' },
    clientName: { __type: 'String' },
    corporateId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    declineReason: { __type: 'String' },
    declinedAt: { __type: 'String' },
    declinedByName: { __type: 'String' },
    declinedByStaffUserId: { __type: 'String' },
    destinationAmount: { __type: 'Float' },
    destinationChosenAt: { __type: 'String' },
    destinationChosenByName: { __type: 'String' },
    destinationChosenByStaffUserId: { __type: 'ID' },
    destinationCurrency: { __type: 'String' },
    destinationOverridden: { __type: 'Boolean!' },
    destinationPrice: { __type: 'String' },
    destinationPriceCurrency: { __type: 'String' },
    destinationServiceId: { __type: 'ID' },
    destinationServiceTemplateId: { __type: 'ID' },
    destinationSiteCurrency: { __type: 'String' },
    destinationSiteId: { __type: 'ID' },
    destinationSiteName: { __type: 'String' },
    destinationSiteTimezone: { __type: 'String' },
    destinationTemplateArchived: { __type: 'Boolean' },
    destinationTemplateName: { __type: 'String' },
    error: { __type: 'String' },
    executedAt: { __type: 'String' },
    forceIncluded: { __type: 'Boolean' },
    homeSiteName: { __type: 'String' },
    memberMovementId: { __type: 'ID!' },
    memberMovementRunId: { __type: 'ID' },
    membershipName: { __type: 'String' },
    membershipPrice: { __type: 'Float' },
    paidAtHomeAmount: { __type: 'Float' },
    paymentCollected: { __type: 'Boolean' },
    paymentMigrationReason: { __type: 'MemberMovementPaymentMigrationReason' },
    paymentMigrationStatus: { __type: 'MemberMovementPaymentMigrationStatus' },
    permissions: { __type: 'MemberMovementIncomingPermissions!' },
    reasonCode: { __type: 'MemberMovementReasonCode' },
    replayOfMovementId: { __type: 'ID' },
    revertReason: { __type: 'String' },
    revertedAt: { __type: 'String' },
    revertedByName: { __type: 'String' },
    revertedByStaffUserId: { __type: 'ID' },
    reviewNote: { __type: 'String' },
    reviewStatus: { __type: 'MemberMovementReviewStatus' },
    sourceAmount: { __type: 'Float' },
    sourceCurrency: { __type: 'String' },
    sourceNextBillingDate: { __type: 'String' },
    sourcePrice: { __type: 'String' },
    sourcePriceCurrency: { __type: 'String' },
    sourceServiceId: { __type: 'ID!' },
    sourceServiceTemplateId: { __type: 'ID!' },
    sourceSiteCurrency: { __type: 'String' },
    sourceSiteId: { __type: 'ID!' },
    sourceSiteName: { __type: 'String' },
    sourceSiteTimezone: { __type: 'String' },
    sourceTemplateName: { __type: 'String' },
    status: { __type: 'MemberMovementStatus!' },
    totalVisits: { __type: 'Float' },
    trigger: { __type: 'MemberMovementTrigger!' },
    updatedAt: { __type: 'String!' },
    visitCount: { __type: 'Float' },
    visitPercent: { __type: 'Float' },
    visitScopeUsed: { __type: 'MemberMovementVisitsScope' },
  },
  MemberMovementIncomingMovementInput: { memberMovementId: { __type: 'ID!' } },
  MemberMovementIncomingNotifier: {
    __typename: { __type: 'String!' },
    name: { __type: 'String' },
    staffUserId: { __type: 'ID!' },
  },
  MemberMovementIncomingNotifierCandidate: {
    __typename: { __type: 'String!' },
    name: { __type: 'String!' },
    roleOrTitle: { __type: 'String' },
    staffUserId: { __type: 'ID!' },
  },
  MemberMovementIncomingNotifierCandidatesInput: { siteId: { __type: 'ID!' } },
  MemberMovementIncomingPermissions: {
    __typename: { __type: 'String!' },
    canDecide: { __type: 'Boolean!' },
    canDismiss: { __type: 'Boolean!' },
    canManage: { __type: 'Boolean!' },
    canSaveAsBrandMapping: { __type: 'Boolean!' },
  },
  MemberMovementIncomingQueueInput: {
    cursor: { __type: 'String' },
    destinationSiteId: { __type: 'ID' },
    pageSize: { __type: 'Float' },
    search: { __type: 'String' },
    segment: { __type: 'MemberMovementIncomingSegment!' },
  },
  MemberMovementIncomingSite: {
    __typename: { __type: 'String!' },
    currency: { __type: 'String' },
    name: { __type: 'String!' },
    siteId: { __type: 'ID!' },
    timezone: { __type: 'String' },
  },
  MemberMovementIncomingSummary: {
    __typename: { __type: 'String!' },
    awaiting: { __type: 'Float!' },
    declineCooldownDays: { __type: 'Float' },
    failed: { __type: 'Float!' },
    incomingApprovalExpiryDays: { __type: 'Float' },
    unmatched: { __type: 'Float!' },
  },
  MemberMovementIncomingSummaryInput: { destinationSiteId: { __type: 'ID' } },
  MemberMovementListItem: {
    __typename: { __type: 'String!' },
    approvedAt: { __type: 'String' },
    approvedByName: { __type: 'String' },
    approvedByStaffUserId: { __type: 'String' },
    attestationId: { __type: 'ID' },
    blockedReason: { __type: 'MemberMovementBlockedReason' },
    candidateSiteName: { __type: 'String' },
    clientEmail: { __type: 'String' },
    clientId: { __type: 'ID!' },
    clientName: { __type: 'String' },
    corporateId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    declineReason: { __type: 'String' },
    declinedAt: { __type: 'String' },
    declinedByName: { __type: 'String' },
    declinedByStaffUserId: { __type: 'String' },
    destinationAmount: { __type: 'Float' },
    destinationChosenAt: { __type: 'String' },
    destinationChosenByName: { __type: 'String' },
    destinationChosenByStaffUserId: { __type: 'ID' },
    destinationCurrency: { __type: 'String' },
    destinationOverridden: { __type: 'Boolean!' },
    destinationServiceId: { __type: 'ID' },
    destinationServiceTemplateId: { __type: 'ID' },
    destinationSiteId: { __type: 'ID' },
    destinationTemplateArchived: { __type: 'Boolean' },
    destinationTemplateName: { __type: 'String' },
    error: { __type: 'String' },
    executedAt: { __type: 'String' },
    forceIncluded: { __type: 'Boolean' },
    homeSiteName: { __type: 'String' },
    memberMovementId: { __type: 'ID!' },
    memberMovementRunId: { __type: 'ID' },
    membershipName: { __type: 'String' },
    membershipPrice: { __type: 'Float' },
    paidAtHomeAmount: { __type: 'Float' },
    paymentCollected: { __type: 'Boolean' },
    paymentMigrationReason: { __type: 'MemberMovementPaymentMigrationReason' },
    paymentMigrationStatus: { __type: 'MemberMovementPaymentMigrationStatus' },
    reasonCode: { __type: 'MemberMovementReasonCode' },
    replayOfMovementId: { __type: 'ID' },
    revertReason: { __type: 'String' },
    revertedAt: { __type: 'String' },
    revertedByName: { __type: 'String' },
    revertedByStaffUserId: { __type: 'ID' },
    reviewNote: { __type: 'String' },
    reviewStatus: { __type: 'MemberMovementReviewStatus' },
    sourceAmount: { __type: 'Float' },
    sourceCurrency: { __type: 'String' },
    sourceServiceId: { __type: 'ID!' },
    sourceServiceTemplateId: { __type: 'ID!' },
    sourceSiteId: { __type: 'ID!' },
    status: { __type: 'MemberMovementStatus!' },
    totalVisits: { __type: 'Float' },
    trigger: { __type: 'MemberMovementTrigger!' },
    updatedAt: { __type: 'String!' },
    visitCount: { __type: 'Float' },
    visitPercent: { __type: 'Float' },
    visitScopeUsed: { __type: 'MemberMovementVisitsScope' },
  },
  MemberMovementLocationApprovalOverride: {
    __typename: { __type: 'String!' },
    rollingApprovalType: { __type: 'MemberMovementRollingApprovalType!' },
    siteId: { __type: 'ID!' },
  },
  MemberMovementLocationPosture: {
    __typename: { __type: 'String!' },
    canConfigure: { __type: 'Boolean!' },
    effectiveRollingApprovalType: { __type: 'MemberMovementRollingApprovalType!' },
    notifierStaffUserIds: { __type: '[ID!]!' },
    notifiers: { __type: '[MemberMovementIncomingNotifier!]!' },
    override: { __type: 'MemberMovementRollingApprovalType' },
    siteId: { __type: 'ID!' },
    siteName: { __type: 'String!' },
    source: { __type: 'MemberMovementApprovalPostureSource!' },
  },
  MemberMovementLocationPostures: {
    __typename: { __type: 'String!' },
    brand: { __type: 'MemberMovementBrandPosture!' },
    locations: { __type: '[MemberMovementLocationPosture!]!' },
  },
  MemberMovementLocationPosturesInput: { siteIds: { __type: '[ID!]' } },
  MemberMovementLocationResolution: {
    __typename: { __type: 'String!' },
    chosenCount: { __type: 'Float!' },
    destinationServiceTemplateId: { __type: 'ID!' },
    destinationSiteId: { __type: 'ID!' },
    destinationSiteName: { __type: 'String' },
    destinationTemplateName: { __type: 'String' },
    lastChosenAt: { __type: 'String' },
    lastChosenByName: { __type: 'String' },
    lastChosenByStaffUserId: { __type: 'String' },
    pendingUnmatchedCount: { __type: 'Float!' },
    sourceServiceTemplateId: { __type: 'ID!' },
    sourceSiteId: { __type: 'ID!' },
    sourceSiteName: { __type: 'String' },
    sourceTemplateName: { __type: 'String' },
  },
  MemberMovementLocationResolutionConnection: {
    __typename: { __type: 'String!' },
    items: { __type: '[MemberMovementLocationResolution!]!' },
    pageInfo: { __type: 'MemberMovementPageInfo!' },
  },
  MemberMovementLocationResolutionsInput: {
    cursor: { __type: 'String' },
    pageSize: { __type: 'Float' },
  },
  MemberMovementManualTransferInput: {
    clientId: { __type: 'ID!' },
    corporateId: { __type: 'ID!' },
    destinationServiceTemplateId: { __type: 'ID' },
    destinationSiteId: { __type: 'ID!' },
    sourceServiceId: { __type: 'ID!' },
  },
  MemberMovementManualTransferPreview: {
    __typename: { __type: 'String!' },
    agreementCarried: { __type: 'Boolean!' },
    carriedAnchorDate: { __type: 'String' },
    carriedNextInvoiceDate: { __type: 'String' },
    clientId: { __type: 'ID!' },
    crossCurrency: { __type: 'Boolean!' },
    destinationCurrency: { __type: 'String' },
    destinationOverridden: { __type: 'Boolean!' },
    destinationServiceTemplateId: { __type: 'ID' },
    destinationServiceTemplateName: { __type: 'String' },
    destinationSiteId: { __type: 'ID!' },
    paymentOutlook: { __type: 'MemberMovementPaymentTransferPairOutlook!' },
    secondaryFeeOutcome: { __type: 'String!' },
    sourceAmount: { __type: 'String' },
    sourceCurrency: { __type: 'String' },
    sourceServiceId: { __type: 'ID!' },
    sourceServiceTemplateId: { __type: 'ID!' },
    sourceSiteId: { __type: 'ID!' },
    templateResolved: { __type: 'Boolean!' },
  },
  MemberMovementManualTransferResult: {
    __typename: { __type: 'String!' },
    blockedReason: { __type: 'String' },
    destinationServiceId: { __type: 'ID' },
    memberMovementId: { __type: 'ID!' },
    outcome: { __type: 'String!' },
  },
  MemberMovementMaxMovementsPerCycle: {
    __typename: { __type: 'String!' },
    absolute: { __type: 'Float' },
    percentOfActiveMembers: { __type: 'Float!' },
  },
  MemberMovementMaxMovementsPerCycleInput: {
    absolute: { __type: 'Float' },
    percentOfActiveMembers: { __type: 'Float!' },
  },
  MemberMovementOverlappingRun: {
    __typename: { __type: 'String!' },
    isDeletable: { __type: 'Boolean!' },
    memberMovementRunId: { __type: 'ID!' },
    periodEnd: { __type: 'String' },
    periodStart: { __type: 'String' },
    qualifiedCount: { __type: 'Float!' },
    status: { __type: 'String!' },
  },
  MemberMovementPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    page: { __type: 'Float' },
    pageSize: { __type: 'Float' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Float!' },
  },
  MemberMovementPaymentCollectionInput: {
    corporateId: { __type: 'ID!' },
    cursor: { __type: 'String' },
    destinationSiteId: { __type: 'ID' },
    includeCollected: { __type: 'Boolean' },
    pageSize: { __type: 'Float' },
    runId: { __type: 'ID' },
    trigger: { __type: 'MemberMovementTrigger' },
  },
  MemberMovementPaymentTransferMatrix: {
    __typename: { __type: 'String!' },
    pairs: { __type: '[MemberMovementPaymentTransferPairOutlook!]!' },
    sites: { __type: '[MemberMovementPaymentTransferSiteDescriptor!]!' },
    truncated: { __type: 'Boolean!' },
  },
  MemberMovementPaymentTransferPairOutlook: {
    __typename: { __type: 'String!' },
    destinationSiteId: { __type: 'ID!' },
    feasible: { __type: 'Boolean!' },
    method: { __type: 'String!' },
    reason: { __type: 'String' },
    sourceSiteId: { __type: 'ID!' },
  },
  MemberMovementPaymentTransferSiteDescriptor: {
    __typename: { __type: 'String!' },
    countryCode: { __type: 'String' },
    gatewayType: { __type: 'String' },
    siteId: { __type: 'ID!' },
    siteName: { __type: 'String!' },
    stripePlatform: { __type: 'String' },
  },
  MemberMovementReplayMappingFixInput: {
    destinationServiceTemplateId: { __type: 'ID!' },
    destinationSiteId: { __type: 'ID!' },
    sourceServiceTemplateId: { __type: 'ID!' },
    sourceSiteId: { __type: 'ID!' },
  },
  MemberMovementRevertLogInput: {
    corporateId: { __type: 'ID!' },
    cursor: { __type: 'String' },
    pageSize: { __type: 'Float' },
    runId: { __type: 'ID' },
    trigger: { __type: 'MemberMovementTrigger' },
  },
  MemberMovementReviewDecisionInput: {
    destinationServiceTemplateId: { __type: 'ID' },
    destinationSiteId: { __type: 'ID' },
    forceInclude: { __type: 'Boolean' },
    movementId: { __type: 'ID!' },
    note: { __type: 'String' },
    reviewStatus: { __type: 'MemberMovementReviewStatus!' },
  },
  MemberMovementRollingSchedule: {
    __typename: { __type: 'String!' },
    evaluationWindow: { __type: 'MemberMovementDurationConfig!' },
    frequency: { __type: 'MemberMovementDurationConfig!' },
    previewWindowHours: { __type: 'Float!' },
  },
  MemberMovementRollingSchedulerStatus: {
    __typename: { __type: 'String!' },
    nextRunAt: { __type: 'String' },
    rollingEnabled: { __type: 'Boolean!' },
    schedulerRegistered: { __type: 'Boolean!' },
  },
  MemberMovementRun: {
    __typename: { __type: 'String!' },
    approvalAttestationId: { __type: 'ID' },
    approvedAt: { __type: 'String' },
    approvedCount: { __type: 'Float!' },
    blockedCount: { __type: 'Float!' },
    bullmqJobId: { __type: 'String' },
    configSnapshot: { __type: 'JSONObject' },
    corporateId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    createdByStaffUserId: { __type: 'ID' },
    dataNotes: { __type: 'JSONObject' },
    evaluatedAt: { __type: 'String' },
    evaluatedCount: { __type: 'Float!' },
    executedAt: { __type: 'String' },
    failedCount: { __type: 'Float!' },
    memberMovementRunId: { __type: 'ID!' },
    mode: { __type: 'MemberMovementRunMode!' },
    movedCount: { __type: 'Float!' },
    periodEnd: { __type: 'String' },
    periodStart: { __type: 'String' },
    qualifiedCount: { __type: 'Float!' },
    removedCount: { __type: 'Float!' },
    revertedCount: { __type: 'Float!' },
    scheduledExecutionAt: { __type: 'String' },
    status: { __type: 'MemberMovementRunStatus!' },
    timezone: { __type: 'String' },
    updatedAt: { __type: 'String!' },
  },
  MemberMovementRunConnection: {
    __typename: { __type: 'String!' },
    items: { __type: '[MemberMovementRun!]!' },
    pageInfo: { __type: 'MemberMovementPageInfo!' },
  },
  MemberMovementRunsInput: {
    corporateId: { __type: 'ID!' },
    cursor: { __type: 'String' },
    pageSize: { __type: 'Float' },
  },
  MemberMovementTemplateMapping: {
    __typename: { __type: 'String!' },
    corporateId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    createdByStaffUserId: { __type: 'ID' },
    destinationServiceTemplateId: { __type: 'ID!' },
    destinationSiteId: { __type: 'ID!' },
    isStale: { __type: 'Boolean!' },
    matchType: { __type: 'MemberMovementMappingMatchType!' },
    memberMovementTemplateMappingId: { __type: 'ID!' },
    sourceServiceTemplateId: { __type: 'ID!' },
    sourceSiteId: { __type: 'ID!' },
    updatedAt: { __type: 'String!' },
  },
  MemberMovementTransferableMembership: {
    __typename: { __type: 'String!' },
    currency: { __type: 'String' },
    expiresAt: { __type: 'String' },
    nextBillingDate: { __type: 'String' },
    price: { __type: 'String' },
    serviceId: { __type: 'ID!' },
    serviceTemplateId: { __type: 'ID!' },
    serviceTemplateName: { __type: 'String' },
    siteId: { __type: 'ID!' },
    startsAt: { __type: 'String' },
    status: { __type: 'String!' },
  },
  MemberMovementsFilterInput: {
    corporateId: { __type: 'ID!' },
    cursor: { __type: 'String' },
    destinationSiteId: { __type: 'ID' },
    mappingState: { __type: 'MemberMovementMappingStateFilter' },
    page: { __type: 'Float' },
    pageSize: { __type: 'Float' },
    reasonCode: { __type: 'String' },
    runId: { __type: 'ID' },
    search: { __type: 'String' },
    siteId: { __type: 'ID' },
    sourceSiteId: { __type: 'ID' },
    status: { __type: 'MemberMovementStatus' },
    statuses: { __type: '[MemberMovementStatus!]' },
    trigger: { __type: 'String' },
  },
  MemberNotificationInput: {
    channels: { __type: '[MessageType!]!' },
    message: { __type: 'String' },
  },
  MemberOpeningHours: {
    __typename: { __type: 'String!' },
    is24x7: { __type: 'Boolean!' },
    isOpenNow: { __type: 'Boolean!' },
    today: { __type: 'ResolvedOpeningDay!' },
    upcomingExceptions: { __type: '[UpcomingOpeningException!]!' },
    week: { __type: '[ResolvedOpeningDay!]!' },
  },
  MemberPauseAllowance: {
    __typename: { __type: 'String!' },
    limit: { __type: 'Float!' },
    remaining: { __type: 'Float!' },
    resetDate: { __type: 'String!' },
    unit: { __type: 'MemberPauseAllowanceUnit!' },
    used: { __type: 'Float!' },
  },
  MemberPauseCommitment: {
    __typename: { __type: 'String!' },
    after: { __type: 'String!' },
    before: { __type: 'String!' },
  },
  MemberPauseDatedAmount: {
    __typename: { __type: 'String!' },
    amount: { __type: 'String!' },
    date: { __type: 'String!' },
  },
  MemberPauseEntryCredit: {
    __typename: { __type: 'String!' },
    amount: { __type: 'String!' },
    unusedCredits: { __type: 'Float' },
    unusedDays: { __type: 'Float' },
  },
  MemberPauseFee: {
    __typename: { __type: 'String!' },
    amount: { __type: 'String' },
    cadenceAmount: { __type: 'Float' },
    cadenceUnit: { __type: 'String' },
    chargeMode: { __type: 'ServiceSuspensionChargeMode!' },
  },
  MemberPauseFeeQuote: {
    __typename: { __type: 'String!' },
    chargeMode: { __type: 'ServiceSuspensionChargeMode!' },
    occurrences: { __type: '[MemberPauseDatedAmount!]!' },
    total: { __type: 'String!' },
    truncated: { __type: 'Boolean!' },
  },
  MemberPauseFirstInvoice: {
    __typename: { __type: 'String!' },
    date: { __type: 'String!' },
    grossAmount: { __type: 'String!' },
    isReturnStub: { __type: 'Boolean!' },
    netAmount: { __type: 'String!' },
  },
  MemberPauseInput: {
    endDate: { __type: 'String!' },
    reasonId: { __type: 'String' },
    source: { __type: 'MemberServiceSuspensionSource!' },
    startDate: { __type: 'String!' },
  },
  MemberPauseLinkedAddOn: {
    __typename: { __type: 'String!' },
    amount: { __type: 'String!' },
    cadenceAmount: { __type: 'Float' },
    cadenceUnit: { __type: 'String' },
    name: { __type: 'String!' },
    serviceId: { __type: 'ID!' },
  },
  MemberPauseOptions: {
    __typename: { __type: 'String!' },
    allowance: { __type: 'MemberPauseAllowance' },
    blockers: { __type: '[MemberPauseBlocker!]!' },
    enabled: { __type: 'Boolean!' },
    fee: { __type: 'MemberPauseFee' },
    linkedAddOns: { __type: '[MemberPauseLinkedAddOn!]!' },
    reasonMandatory: { __type: 'Boolean!' },
    reasons: { __type: '[MemberPauseReason!]!' },
    rules: { __type: 'MemberPauseRules' },
    suspensionType: { __type: 'ServiceSuspensionType' },
  },
  MemberPausePreview: {
    __typename: { __type: 'String!' },
    addOns: { __type: '[MemberPauseLinkedAddOn!]!' },
    blockers: { __type: '[MemberPauseBlocker!]!' },
    chargedWhilePausedTotal: { __type: 'String!' },
    commitmentEndDate: { __type: 'MemberPauseCommitment' },
    cyclesPaused: { __type: 'Float' },
    daysPaused: { __type: 'Float!' },
    endDate: { __type: 'String!' },
    entryCredit: { __type: 'MemberPauseEntryCredit' },
    fee: { __type: 'MemberPauseFeeQuote' },
    firstInvoiceAfterResume: { __type: 'MemberPauseFirstInvoice' },
    paymentsSkipped: { __type: '[MemberPauseDatedAmount!]!' },
    resumeDate: { __type: 'String!' },
    secondaryFeesContinueTotal: { __type: 'String' },
    skippedTotal: { __type: 'String!' },
    startDate: { __type: 'String!' },
  },
  MemberPauseReason: {
    __typename: { __type: 'String!' },
    id: { __type: 'String!' },
    reason: { __type: 'String!' },
  },
  MemberPauseRules: {
    __typename: { __type: 'String!' },
    alignToBillingCycle: { __type: 'Boolean!' },
    billingDates: { __type: '[String!]!' },
    earliestStartDate: { __type: 'String!' },
    maxPauseDays: { __type: 'Float' },
    minPauseDays: { __type: 'Float' },
  },
  MemberPauseWindowInput: {
    endDate: { __type: 'String!' },
    reasonId: { __type: 'String' },
    startDate: { __type: 'String!' },
  },
  MemberPendingForm: {
    __typename: { __type: 'String!' },
    assignedAt: { __type: 'String!' },
    bookingGateMode: { __type: 'FormBookingGateMode!' },
    description: { __type: 'String' },
    formSubmissionId: { __type: 'String!' },
    name: { __type: 'String!' },
    questionCount: { __type: 'Float!' },
    requiredBefore: { __type: 'FormRequiredBefore' },
    siteId: { __type: 'String!' },
  },
  MemberPendingFormsPage: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    items: { __type: '[MemberPendingForm!]!' },
  },
  MemberPreviewSessionResult: {
    __typename: { __type: 'String!' },
    kioskToken: { __type: 'String!' },
    memberToken: { __type: 'String!' },
    previewKioskUserId: { __type: 'String!' },
    previewMemberId: { __type: 'String!' },
  },
  MemberSessionFeedbackInput: {
    answers: { __type: '[MemberFeedbackAnswerInput!]!' },
    clientId: { __type: 'ID!' },
    comments: { __type: 'String' },
    sessionId: { __type: 'ID!' },
    siteId: { __type: 'ID!' },
  },
  MemberSiteAmenities: {
    __typename: { __type: 'String!' },
    items: { __type: '[MemberSiteAmenity!]!' },
    maxVisible: { __type: 'Int!' },
  },
  MemberSiteAmenity: {
    __typename: { __type: 'String!' },
    amenityKey: { __type: 'SiteAmenityKey' },
    customName: { __type: 'String' },
    group: { __type: 'SiteAmenityGroup!' },
    hasActiveAlert: { __type: 'Boolean!' },
    icon: { __type: 'SiteInfoIcon!' },
    id: { __type: 'ID!' },
    label: { __type: 'String!' },
    note: { __type: 'String' },
    status: { __type: 'SiteAmenityStatus!' },
    todayRanges: { __type: '[ResolvedOpeningRange!]' },
    week: { __type: '[ResolvedOpeningDay!]' },
  },
  MemberSiteInfo: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'String!' },
    email: { __type: 'String' },
    firstName: { __type: 'String' },
    homeSiteId: { __type: 'String' },
    homeSiteName: { __type: 'String' },
    lastName: { __type: 'String' },
  },
  MemberSiteInfoBlock: {
    __typename: { __type: 'String!' },
    body: { __type: 'String!' },
    icon: { __type: 'SiteInfoBlockIcon' },
    id: { __type: 'ID!' },
    linkLabel: { __type: 'String' },
    linkUrl: { __type: 'String' },
    title: { __type: 'String!' },
  },
  MemberStaffedHours: {
    __typename: { __type: 'String!' },
    label: { __type: 'String!' },
    today: { __type: 'ResolvedOpeningDay!' },
    week: { __type: '[ResolvedOpeningDay!]!' },
  },
  MemberVisitForecast: {
    __typename: { __type: 'String!' },
    days: { __type: '[VisitForecastDay!]!' },
    hasSufficientData: { __type: 'Boolean!' },
  },
  MembershipActiveCount: {
    __typename: { __type: 'String!' },
    activeCount: { __type: 'Float!' },
    serviceTemplateId: { __type: 'ID!' },
  },
  MembershipActiveCountsResult: {
    __typename: { __type: 'String!' },
    counts: { __type: '[MembershipActiveCount!]!' },
  },
  MembershipActiveMember: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'ID!' },
    creditsUsed: { __type: 'Float!' },
    email: { __type: 'String' },
    endDate: { __type: 'String' },
    firstName: { __type: 'String' },
    hasUnlimited: { __type: 'Boolean!' },
    lastName: { __type: 'String' },
    serviceId: { __type: 'ID!' },
    startDate: { __type: 'String' },
  },
  MembershipActiveMembersResult: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'MembershipActiveMembersResultPageInfo!' },
    results: { __type: '[MembershipActiveMembersResultResults!]!' },
  },
  MembershipActiveMembersResultPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  MembershipActiveMembersResultResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'MembershipActiveMember!' },
  },
  MembershipImportBlockingIssue: {
    __typename: { __type: 'String!' },
    code: { __type: 'MembershipImportBlockingIssueCode!' },
    message: { __type: 'String!' },
  },
  MembershipImportFirstBillBeforeCardSummary: {
    __typename: { __type: 'String!' },
    count: { __type: 'Float!' },
    earliestFirstPaymentDate: { __type: 'String' },
  },
  MembershipImportInactiveSummary: {
    __typename: { __type: 'String!' },
    count: { __type: 'Float!' },
    earliestStartDate: { __type: 'String' },
  },
  MembershipImportSummary: {
    __typename: { __type: 'String!' },
    blockingIssues: { __type: '[MembershipImportBlockingIssue!]!' },
    computedAt: { __type: 'String!' },
    firstBillBeforeCard: { __type: 'MembershipImportFirstBillBeforeCardSummary!' },
    inactive: { __type: 'MembershipImportInactiveSummary!' },
    totalRows: { __type: 'Float!' },
  },
  MembershipMember: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'ID!' },
    creditsPurchased: { __type: 'Float!' },
    creditsUnused: { __type: 'Float' },
    creditsUsed: { __type: 'Float!' },
    email: { __type: 'String' },
    endDate: { __type: 'String' },
    firstName: { __type: 'String' },
    hasUnlimited: { __type: 'Boolean!' },
    lastName: { __type: 'String' },
    purchaseDate: { __type: 'String' },
    serviceId: { __type: 'ID!' },
    startDate: { __type: 'String' },
    status: { __type: 'ServiceStatus!' },
  },
  MembershipMemberStatusCounts: {
    __typename: { __type: 'String!' },
    active: { __type: 'Float!' },
    expired: { __type: 'Float!' },
    total: { __type: 'Float!' },
  },
  MembershipMembersResult: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'MembershipMembersResultPageInfo!' },
    results: { __type: '[MembershipMembersResultResults!]!' },
  },
  MembershipMembersResultPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  MembershipMembersResultResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'MembershipMember!' },
  },
  MembershipStatusCount: {
    __typename: { __type: 'String!' },
    count: { __type: 'Float!' },
    status: { __type: 'String!' },
  },
  MergeAffectedRecord: {
    __typename: { __type: 'String!' },
    count: { __type: 'Float!' },
    entityType: { __type: 'String!' },
    siteId: { __type: 'String!' },
  },
  MergeAffectedSite: {
    __typename: { __type: 'String!' },
    siteId: { __type: 'String!' },
    siteName: { __type: 'String!' },
    sourceHasData: { __type: 'Boolean!' },
    targetHasData: { __type: 'Boolean!' },
    willCreateClientSite: { __type: 'Boolean!' },
  },
  MergeClientsInput: {
    mergeScope: { __type: 'MergeScope!' },
    profileChoices: { __type: 'MergeProfileChoicesInput!' },
    siteId: { __type: 'ID!' },
    sourceClientId: { __type: 'ID!' },
    targetClientId: { __type: 'ID!' },
  },
  MergeClientsPreview: {
    __typename: { __type: 'String!' },
    affectedSites: { __type: '[MergeAffectedSite!]!' },
    customPropertyConflicts: { __type: '[MergeCustomPropertyConflict!]!' },
    mergeScope: { __type: 'MergeScope!' },
    profileConflicts: { __type: '[MergeProfileConflict!]!' },
    recordCounts: { __type: '[MergeRecordCount!]!' },
    sourceClient: { __type: 'ClientProfileSnapshot!' },
    targetClient: { __type: 'ClientProfileSnapshot!' },
    totalRecordsToMove: { __type: 'Float!' },
    warnings: { __type: '[String!]!' },
  },
  MergeClientsPreviewInput: {
    mergeScope: { __type: 'MergeScope!' },
    siteId: { __type: 'ID!' },
    sourceClientId: { __type: 'ID!' },
    targetClientId: { __type: 'ID!' },
  },
  MergeClientsResult: {
    __typename: { __type: 'String!' },
    affectedRecords: { __type: '[MergeAffectedRecord!]!' },
    mergeLogId: { __type: 'String!' },
    success: { __type: 'Boolean!' },
    targetClientId: { __type: 'String!' },
    totalRecordsMoved: { __type: 'Float!' },
    warnings: { __type: '[String!]!' },
  },
  MergeCustomPropertyChoice: {
    keepSource: { __type: 'Boolean!' },
    siteCustomPropertyId: { __type: 'String!' },
  },
  MergeCustomPropertyConflict: {
    __typename: { __type: 'String!' },
    propertyName: { __type: 'String!' },
    siteCustomPropertyId: { __type: 'String!' },
    siteId: { __type: 'String!' },
    sourceValue: { __type: 'String' },
    targetValue: { __type: 'String' },
  },
  MergeProfileChoicesInput: {
    customPropertyChoices: { __type: '[MergeCustomPropertyChoice!]!' },
    keepSourceAddress: { __type: 'Boolean!' },
    keepSourceBarcodeId: { __type: 'Boolean!' },
    keepSourceCustomerId: { __type: 'Boolean!' },
    keepSourceDateOfBirth: { __type: 'Boolean!' },
    keepSourceEmail: { __type: 'Boolean!' },
    keepSourceEmergencyContact: { __type: 'Boolean!' },
    keepSourceFirstName: { __type: 'Boolean!' },
    keepSourceFobNumber: { __type: 'Boolean!' },
    keepSourceGender: { __type: 'Boolean!' },
    keepSourceLastName: { __type: 'Boolean!' },
    keepSourcePhone: { __type: 'Boolean!' },
    keepSourceProfileImage: { __type: 'Boolean!' },
  },
  MergeProfileConflict: {
    __typename: { __type: 'String!' },
    field: { __type: 'String!' },
    hasConflict: { __type: 'Boolean!' },
    sourceValue: { __type: 'String' },
    targetValue: { __type: 'String' },
  },
  MergeRecordCount: {
    __typename: { __type: 'String!' },
    count: { __type: 'Float!' },
    entityType: { __type: 'String!' },
    siteId: { __type: 'String!' },
  },
  MergedClientInfo: {
    __typename: { __type: 'String!' },
    isMerged: { __type: 'Boolean!' },
    mergedAt: { __type: 'String' },
    sourceClientId: { __type: 'String!' },
    targetClientId: { __type: 'String' },
    targetClientName: { __type: 'String' },
  },
  MetricTrackingSummary: {
    __typename: { __type: 'String!' },
    avgEntriesPerTracker: { __type: 'Float!' },
    personalBestsSet: { __type: 'Float!' },
    totalMetricEntries: { __type: 'Float!' },
    uniqueTrackers: { __type: 'Float!' },
  },
  MigrationSessions: {
    __typename: { __type: 'String!' },
    sessions: { __type: '[ImportSession!]!' },
  },
  Migrations: {
    __typename: { __type: 'String!' },
    migrations: { __type: '[MigrationsMigrations!]!' },
  },
  MigrationsMigrations: {
    __typename: { __type: 'String!' },
    completedAt: { __type: 'String' },
    migrationId: { __type: 'ID!' },
    migrationName: { __type: 'String' },
    sessionCount: { __type: 'Float!' },
    siteId: { __type: 'String' },
    sourceSystem: { __type: 'String' },
    startedAt: { __type: 'String!' },
    statuses: { __type: '[String!]!' },
    targetEnvironment: { __type: 'String' },
  },
  MissingPermissions: {
    __typename: { __type: 'String!' },
    accessPermissions: { __type: '[AccessPermissions!]!' },
    corporatePermissions: { __type: '[CorporatePermissions!]!' },
    sitePermissions: { __type: '[SitePermissions!]!' },
  },
  MobileAppBranding: {
    __typename: { __type: 'String!' },
    accentColor: { __type: 'String' },
    appIconUrl: { __type: 'String' },
    backgroundColor: { __type: 'String' },
    corporateId: { __type: 'String!' },
    faviconUrl: { __type: 'String' },
    fontConfig: { __type: 'JSONObject' },
    fontFamily: { __type: 'String' },
    logoUrl: { __type: 'String' },
    modulesConfig: { __type: 'JSONObject' },
    primaryColor: { __type: 'String' },
    secondaryColor: { __type: 'String' },
    splashScreenDarkUrl: { __type: 'String' },
    splashScreenUrl: { __type: 'String' },
    textColor: { __type: 'String' },
  },
  MobileAppBuildOverview: {
    __typename: { __type: 'String!' },
    changes: { __type: '[MobileAppBuildOverviewChanges!]!' },
    states: { __type: '[MobileAppBuildOverviewStates!]!' },
  },
  MobileAppBuildOverviewChanges: {
    __typename: { __type: 'String!' },
    brandId: { __type: 'String!' },
    changeId: { __type: 'String!' },
    changedFields: { __type: '[MobileAppChangeField!]!' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'String' },
    impact: { __type: 'MobileAppChangeImpact!' },
    platforms: { __type: '[BrandPlatform!]!' },
    revision: { __type: 'Float!' },
  },
  MobileAppBuildOverviewStates: {
    __typename: { __type: 'String!' },
    brandId: { __type: 'String!' },
    currentNativeRevision: { __type: 'Float!' },
    lastBuiltRevision: { __type: 'Float!' },
    lastReleasedRevision: { __type: 'Float!' },
    lastSubmittedRevision: { __type: 'Float!' },
    latestReleaseId: { __type: 'String' },
    platform: { __type: 'BrandPlatform!' },
    updatedAt: { __type: 'String!' },
  },
  MobileAppChannels: {
    __typename: { __type: 'String!' },
    androidConfig: { __type: 'JSONObject' },
    androidEnabled: { __type: 'Boolean!' },
    androidLastBuiltFontVersion: { __type: 'Float' },
    androidMinVersion: { __type: 'String' },
    androidPackageName: { __type: 'String' },
    androidPlayStoreUrl: { __type: 'String' },
    androidVersion: { __type: 'String' },
    channels: { __type: 'JSONObject' },
    corporateId: { __type: 'String!' },
    deployment: { __type: 'JSONObject' },
    deploymentStatus: { __type: 'String' },
    iosAppStoreUrl: { __type: 'String' },
    iosBundleId: { __type: 'String' },
    iosConfig: { __type: 'JSONObject' },
    iosEnabled: { __type: 'Boolean!' },
    iosLastBuiltFontVersion: { __type: 'Float' },
    iosMinVersion: { __type: 'String' },
    iosVersion: { __type: 'String' },
    lastDeployedAt: { __type: 'String' },
  },
  MobileAppMetadata: {
    __typename: { __type: 'String!' },
    appName: { __type: 'String!' },
    brandId: { __type: 'String!' },
    id: { __type: 'String!' },
    lastUpdated: { __type: 'String!' },
    version: { __type: 'String!' },
  },
  MobileAppProfile: {
    __typename: { __type: 'String!' },
    address: { __type: 'String' },
    appDescription: { __type: 'String' },
    appName: { __type: 'String!' },
    appShortDescription: { __type: 'String' },
    branchIoKey: { __type: 'String' },
    branchIoLiveKey: { __type: 'String' },
    branchIoSecret: { __type: 'String' },
    businessName: { __type: 'String' },
    contentfulAccessToken: { __type: 'String' },
    contentfulPreviewToken: { __type: 'String' },
    contentfulSpaceId: { __type: 'String' },
    corporateId: { __type: 'String!' },
    description: { __type: 'String' },
    distributionCountries: { __type: '[String!]' },
    email: { __type: 'String' },
    evoltApiKey: { __type: 'String' },
    facebookUrl: { __type: 'String' },
    instagramUrl: { __type: 'String' },
    jwPlayerApiKey: { __type: 'String' },
    linkedinUrl: { __type: 'String' },
    oneSignalApiKey: { __type: 'String' },
    oneSignalAppId: { __type: 'String' },
    phone: { __type: 'String' },
    privacyPolicyUrl: { __type: 'String' },
    socialLinks: { __type: 'JSONObject' },
    supportEmail: { __type: 'String' },
    supportUrl: { __type: 'String' },
    tagline: { __type: 'String' },
    termsAndConditionsUrl: { __type: 'String' },
    twitterUrl: { __type: 'String' },
    website: { __type: 'String' },
    youtubeUrl: { __type: 'String' },
  },
  MobileAppProgress: {
    __typename: { __type: 'String!' },
    activeTabsInSteps: { __type: 'MobileAppProgressActiveTabsInSteps!' },
    channelsCompleted: { __type: 'Boolean!' },
    completedSteps: { __type: '[Float!]!' },
    currentStep: { __type: 'Float!' },
    customizationCompleted: { __type: 'Boolean!' },
    deploymentCompleted: { __type: 'Boolean!' },
    profileCompleted: { __type: 'Boolean!' },
  },
  MobileAppProgressActiveTabsInSteps: {
    __typename: { __type: 'String!' },
    channels: { __type: 'Float' },
    customization: { __type: 'Float' },
    profile: { __type: 'Float' },
    step1: { __type: 'Float' },
    step2: { __type: 'Float' },
    step3: { __type: 'Float' },
  },
  MobileChannelsComplete: {
    __typename: { __type: 'String!' },
    analytics: { __type: 'MobileChannelsCompleteAnalytics!' },
    android: { __type: 'MobileChannelsCompleteAndroid!' },
    deepLink: { __type: 'MobileChannelsCompleteDeepLink!' },
    ios: { __type: 'MobileChannelsCompleteIos!' },
  },
  MobileChannelsCompleteAnalytics: {
    __typename: { __type: 'String!' },
    customEvents: { __type: 'MobileChannelsCompleteAnalyticsCustomEvents' },
    enabled: { __type: 'Boolean!' },
    onesignal: { __type: 'String' },
    trackingId: { __type: 'String' },
  },
  MobileChannelsCompleteAnalyticsCustomEvents: {
    __typename: { __type: 'String!' },
    purchaseComplete: { __type: 'String' },
    sessionStart: { __type: 'String' },
    userLogin: { __type: 'String' },
    userRegistration: { __type: 'String' },
  },
  MobileChannelsCompleteAndroid: {
    __typename: { __type: 'String!' },
    certificates: { __type: '[MobileChannelsCompleteAndroidCertificates!]!' },
    enabled: { __type: 'Boolean!' },
    googlePlayId: { __type: 'String' },
    packageName: { __type: 'String!' },
    status: { __type: 'String!' },
  },
  MobileChannelsCompleteAndroidCertificates: {
    __typename: { __type: 'String!' },
    expiryDate: { __type: 'String!' },
    id: { __type: 'String!' },
    platform: { __type: 'String!' },
    status: { __type: 'String!' },
    type: { __type: 'String!' },
  },
  MobileChannelsCompleteDeepLink: {
    __typename: { __type: 'String!' },
    domains: { __type: '[String!]!' },
    scheme: { __type: 'String!' },
    universalLink: { __type: 'String!' },
  },
  MobileChannelsCompleteIos: {
    __typename: { __type: 'String!' },
    appStoreId: { __type: 'String' },
    bundleId: { __type: 'String!' },
    certificates: { __type: '[MobileChannelsCompleteIosCertificates!]!' },
    enabled: { __type: 'Boolean!' },
    status: { __type: 'String!' },
    teamId: { __type: 'String' },
  },
  MobileChannelsCompleteIosCertificates: {
    __typename: { __type: 'String!' },
    expiryDate: { __type: 'String!' },
    id: { __type: 'String!' },
    platform: { __type: 'String!' },
    status: { __type: 'String!' },
    type: { __type: 'String!' },
  },
  MobileCustomizationAdvancedFeaturesDarkModeInput: {
    adjustmentStrategy: { __type: 'DarkModeStrategy!' },
    auto: { __type: 'Boolean!' },
    overrides: { __type: 'MobileCustomizationAdvancedFeaturesDarkModeOverridesInput' },
  },
  MobileCustomizationAdvancedFeaturesDarkModeOverridesInput: {
    background: { __type: 'String' },
    primary: { __type: 'String' },
    secondary: { __type: 'String' },
    surface: { __type: 'String' },
  },
  MobileCustomizationAdvancedFeaturesInput: {
    barcodeEnabled: { __type: 'Boolean!' },
    callUsEnabled: { __type: 'Boolean!' },
    challenge: { __type: 'Boolean!' },
    contactlessCheckin: { __type: 'Boolean!' },
    darkMode: { __type: 'MobileCustomizationAdvancedFeaturesDarkModeInput!' },
    darkModeSupport: { __type: 'Boolean!' },
    displayInstructor: { __type: 'Boolean!' },
    editFieldsEnable: { __type: 'Boolean!' },
    evoltIntegrationEnabled: { __type: 'Boolean!' },
    filterTimeAvailable: { __type: 'Boolean!' },
    isAnyAvailable: { __type: 'Boolean!' },
    isDynamicImages: { __type: 'Boolean!' },
    isSquareButton: { __type: 'Boolean!' },
    newsFeedAvailable: { __type: 'Boolean!' },
    profilePhoto: { __type: 'Boolean!' },
    sessionDisplay: { __type: 'SessionDisplayType!' },
    showBilling: { __type: 'Boolean!' },
    shownCommPref: { __type: 'Boolean!' },
    statsAvailable: { __type: 'Boolean!' },
  },
  MobileCustomizationBrandingInput: {
    appIcon: { __type: 'String' },
    loginBackground: { __type: 'String' },
    logo: { __type: 'String' },
    splashScreen: { __type: 'String' },
  },
  MobileCustomizationColorsInput: {
    accent: { __type: 'String' },
    background: { __type: 'String' },
    error: { __type: 'String' },
    info: { __type: 'String' },
    primary: { __type: 'String!' },
    secondary: { __type: 'String!' },
    success: { __type: 'String' },
    surface: { __type: 'String' },
    text: { __type: 'String' },
    textSecondary: { __type: 'String' },
    warning: { __type: 'String' },
  },
  MobileCustomizationComplete: {
    __typename: { __type: 'String!' },
    advancedFeatures: { __type: 'MobileCustomizationCompleteAdvancedFeatures!' },
    branding: { __type: 'MobileCustomizationCompleteBranding!' },
    colors: { __type: 'MobileCustomizationCompleteColors!' },
    coreFeatures: { __type: 'MobileCustomizationCompleteCoreFeatures!' },
    fonts: { __type: 'MobileCustomizationCompleteFonts!' },
    sessionFilters: { __type: 'MobileCustomizationCompleteSessionFilters!' },
    theme: { __type: 'MobileCustomizationCompleteTheme!' },
  },
  MobileCustomizationCompleteAdvancedFeatures: {
    __typename: { __type: 'String!' },
    barcodeEnabled: { __type: 'Boolean!' },
    callUsEnabled: { __type: 'Boolean!' },
    challenge: { __type: 'Boolean!' },
    contactlessCheckin: { __type: 'Boolean!' },
    darkMode: { __type: 'MobileCustomizationCompleteAdvancedFeaturesDarkMode!' },
    darkModeSupport: { __type: 'Boolean!' },
    displayInstructor: { __type: 'Boolean!' },
    editFieldsEnable: { __type: 'Boolean!' },
    evoltIntegrationEnabled: { __type: 'Boolean!' },
    filterTimeAvailable: { __type: 'Boolean!' },
    isAnyAvailable: { __type: 'Boolean!' },
    isDynamicImages: { __type: 'Boolean!' },
    isSquareButton: { __type: 'Boolean!' },
    newsFeedAvailable: { __type: 'Boolean!' },
    profilePhoto: { __type: 'Boolean!' },
    sessionDisplay: { __type: 'SessionDisplayType!' },
    showBilling: { __type: 'Boolean!' },
    shownCommPref: { __type: 'Boolean!' },
    statsAvailable: { __type: 'Boolean!' },
  },
  MobileCustomizationCompleteAdvancedFeaturesDarkMode: {
    __typename: { __type: 'String!' },
    adjustmentStrategy: { __type: 'DarkModeStrategy!' },
    auto: { __type: 'Boolean!' },
    overrides: { __type: 'MobileCustomizationCompleteAdvancedFeaturesDarkModeOverrides' },
  },
  MobileCustomizationCompleteAdvancedFeaturesDarkModeOverrides: {
    __typename: { __type: 'String!' },
    background: { __type: 'String' },
    primary: { __type: 'String' },
    secondary: { __type: 'String' },
    surface: { __type: 'String' },
  },
  MobileCustomizationCompleteBranding: {
    __typename: { __type: 'String!' },
    appIcon: { __type: 'String' },
    loginBackground: { __type: 'String' },
    logo: { __type: 'String' },
    splashScreen: { __type: 'String' },
  },
  MobileCustomizationCompleteColors: {
    __typename: { __type: 'String!' },
    accent: { __type: 'String' },
    background: { __type: 'String' },
    error: { __type: 'String' },
    info: { __type: 'String' },
    primary: { __type: 'String!' },
    secondary: { __type: 'String!' },
    success: { __type: 'String' },
    surface: { __type: 'String' },
    text: { __type: 'String' },
    textSecondary: { __type: 'String' },
    warning: { __type: 'String' },
  },
  MobileCustomizationCompleteCoreFeatures: {
    __typename: { __type: 'String!' },
    digital: { __type: 'Boolean!' },
    explore: { __type: 'Boolean!' },
    purchase: { __type: 'Boolean!' },
    schedule: { __type: 'Boolean!' },
    workouts: { __type: 'Boolean!' },
  },
  MobileCustomizationCompleteFonts: {
    __typename: { __type: 'String!' },
    defaultLanguage: { __type: 'MobileSupportedLanguage!' },
    languageFonts: { __type: 'MobileCustomizationCompleteFontsLanguageFonts' },
    supportedLanguages: { __type: '[MobileSupportedLanguage!]!' },
  },
  MobileCustomizationCompleteFontsLanguageFonts: {
    __typename: { __type: 'String!' },
    EN: { __type: 'MobileCustomizationCompleteFontsLanguageFontsEN' },
    ES: { __type: 'MobileCustomizationCompleteFontsLanguageFontsEN' },
  },
  MobileCustomizationCompleteFontsLanguageFontsEN: {
    __typename: { __type: 'String!' },
    customFonts: { __type: '[String!]!' },
    fontFamily: { __type: 'String!' },
    language: { __type: 'MobileSupportedLanguage!' },
    letterSpacing: { __type: 'MobileCustomizationCompleteFontsLanguageFontsENLetterSpacing' },
    lineHeight: { __type: 'MobileCustomizationCompleteFontsLanguageFontsENLineHeight' },
    sizes: { __type: 'MobileCustomizationCompleteFontsLanguageFontsENSizes!' },
  },
  MobileCustomizationCompleteFontsLanguageFontsENLetterSpacing: {
    __typename: { __type: 'String!' },
    normal: { __type: 'Float!' },
    tight: { __type: 'Float!' },
    wide: { __type: 'Float!' },
  },
  MobileCustomizationCompleteFontsLanguageFontsENLineHeight: {
    __typename: { __type: 'String!' },
    lg: { __type: 'Float!' },
    md: { __type: 'Float!' },
    sm: { __type: 'Float!' },
    xl: { __type: 'Float!' },
    xs: { __type: 'Float!' },
    xxl: { __type: 'Float!' },
  },
  MobileCustomizationCompleteFontsLanguageFontsENSizes: {
    __typename: { __type: 'String!' },
    lg: { __type: 'Float!' },
    md: { __type: 'Float!' },
    sm: { __type: 'Float!' },
    xl: { __type: 'Float!' },
    xs: { __type: 'Float!' },
    xxl: { __type: 'Float!' },
  },
  MobileCustomizationCompleteSessionFilters: {
    __typename: { __type: 'String!' },
    category: { __type: 'Boolean!' },
    duration: { __type: 'Boolean!' },
    instructors: { __type: 'Boolean!' },
    room: { __type: 'Boolean!' },
    sessionTemplate: { __type: 'Boolean!' },
    sessionTime: { __type: 'Boolean!' },
  },
  MobileCustomizationCompleteTheme: {
    __typename: { __type: 'String!' },
    borderRadius: { __type: 'MobileCustomizationCompleteThemeBorderRadius!' },
    spacing: { __type: 'MobileCustomizationCompleteThemeSpacing!' },
  },
  MobileCustomizationCompleteThemeBorderRadius: {
    __typename: { __type: 'String!' },
    lg: { __type: 'Float!' },
    md: { __type: 'Float!' },
    sm: { __type: 'Float!' },
    xl: { __type: 'Float!' },
  },
  MobileCustomizationCompleteThemeSpacing: {
    __typename: { __type: 'String!' },
    lg: { __type: 'Float!' },
    md: { __type: 'Float!' },
    sm: { __type: 'Float!' },
    xl: { __type: 'Float!' },
    xs: { __type: 'Float!' },
    xxl: { __type: 'Float!' },
  },
  MobileCustomizationCoreFeaturesInput: {
    digital: { __type: 'Boolean!' },
    explore: { __type: 'Boolean!' },
    purchase: { __type: 'Boolean!' },
    schedule: { __type: 'Boolean!' },
    workouts: { __type: 'Boolean!' },
  },
  MobileCustomizationFontsInput: {
    defaultLanguage: { __type: 'MobileSupportedLanguage!' },
    languageFonts: { __type: 'MobileCustomizationFontsLanguageFontsInput' },
    supportedLanguages: { __type: '[MobileSupportedLanguage!]!' },
  },
  MobileCustomizationFontsLanguageFontsENInput: {
    customFonts: { __type: '[String!]!' },
    fontFamily: { __type: 'String!' },
    language: { __type: 'MobileSupportedLanguage!' },
    letterSpacing: { __type: 'MobileCustomizationFontsLanguageFontsENLetterSpacingInput' },
    lineHeight: { __type: 'MobileCustomizationFontsLanguageFontsENLineHeightInput' },
    sizes: { __type: 'MobileCustomizationFontsLanguageFontsENSizesInput!' },
  },
  MobileCustomizationFontsLanguageFontsENLetterSpacingInput: {
    normal: { __type: 'Float!' },
    tight: { __type: 'Float!' },
    wide: { __type: 'Float!' },
  },
  MobileCustomizationFontsLanguageFontsENLineHeightInput: {
    lg: { __type: 'Float!' },
    md: { __type: 'Float!' },
    sm: { __type: 'Float!' },
    xl: { __type: 'Float!' },
    xs: { __type: 'Float!' },
    xxl: { __type: 'Float!' },
  },
  MobileCustomizationFontsLanguageFontsENSizesInput: {
    lg: { __type: 'Float!' },
    md: { __type: 'Float!' },
    sm: { __type: 'Float!' },
    xl: { __type: 'Float!' },
    xs: { __type: 'Float!' },
    xxl: { __type: 'Float!' },
  },
  MobileCustomizationFontsLanguageFontsInput: {
    EN: { __type: 'MobileCustomizationFontsLanguageFontsENInput' },
    ES: { __type: 'MobileCustomizationFontsLanguageFontsENInput' },
  },
  MobileCustomizationInput: {
    advancedFeatures: { __type: 'MobileCustomizationAdvancedFeaturesInput' },
    branding: { __type: 'MobileCustomizationBrandingInput' },
    colors: { __type: 'MobileCustomizationColorsInput' },
    coreFeatures: { __type: 'MobileCustomizationCoreFeaturesInput' },
    fontFamily: { __type: 'String' },
    fonts: { __type: 'MobileCustomizationFontsInput' },
    logoUrl: { __type: 'String' },
    primaryColor: { __type: 'String' },
    secondaryColor: { __type: 'String' },
    sessionFilters: { __type: 'MobileCustomizationSessionFiltersInput' },
    theme: { __type: 'MobileCustomizationThemeInput' },
  },
  MobileCustomizationSessionFiltersInput: {
    category: { __type: 'Boolean!' },
    duration: { __type: 'Boolean!' },
    instructors: { __type: 'Boolean!' },
    room: { __type: 'Boolean!' },
    sessionTemplate: { __type: 'Boolean!' },
    sessionTime: { __type: 'Boolean!' },
  },
  MobileCustomizationThemeBorderRadiusInput: {
    lg: { __type: 'Float!' },
    md: { __type: 'Float!' },
    sm: { __type: 'Float!' },
    xl: { __type: 'Float!' },
  },
  MobileCustomizationThemeInput: {
    borderRadius: { __type: 'MobileCustomizationThemeBorderRadiusInput!' },
    spacing: { __type: 'MobileCustomizationThemeSpacingInput!' },
  },
  MobileCustomizationThemeSpacingInput: {
    lg: { __type: 'Float!' },
    md: { __type: 'Float!' },
    sm: { __type: 'Float!' },
    xl: { __type: 'Float!' },
    xs: { __type: 'Float!' },
    xxl: { __type: 'Float!' },
  },
  MobileFailedPayment: {
    __typename: { __type: 'String!' },
    invoiceID: { __type: 'String!' },
    paymentAmount: { __type: 'Float!' },
    paymentDate: { __type: 'String!' },
    paymentDescription: { __type: 'String!' },
    paymentMethod: { __type: 'MobileFailedPaymentMethod!' },
    siteID: { __type: 'String!' },
    siteName: { __type: 'String!' },
  },
  MobileFailedPaymentMethod: {
    __typename: { __type: 'String!' },
    dbPaymentMethodID: { __type: 'String!' },
    paymentMethodExpiry: { __type: 'String!' },
    paymentMethodLast4: { __type: 'String!' },
    paymentMethodType: { __type: 'String!' },
  },
  MobileIntroOffer: {
    __typename: { __type: 'String!' },
    packageCategory: { __type: 'String!' },
    packageDescription: { __type: 'String!' },
    packageID: { __type: 'String!' },
    packageName: { __type: 'String!' },
    packagePrice: { __type: 'Float!' },
  },
  MobileOutstandingPayment: {
    __typename: { __type: 'String!' },
    paymentAmount: { __type: 'Float!' },
    paymentDate: { __type: 'String!' },
    paymentDescription: { __type: 'String!' },
    paymentID: { __type: 'String!' },
    paymentType: { __type: 'String!' },
    siteID: { __type: 'String!' },
    siteName: { __type: 'String!' },
  },
  MobilePendingPolicy: {
    __typename: { __type: 'String!' },
    policyID: { __type: 'String!' },
    policyName: { __type: 'String!' },
    siteID: { __type: 'String' },
    siteName: { __type: 'String' },
  },
  MobileProfileRead: {
    __typename: { __type: 'String!' },
    appDescription: { __type: 'String' },
    appName: { __type: 'String' },
    brandId: { __type: 'String' },
    businessName: { __type: 'String' },
    email: { __type: 'String' },
    evoltApiKey: { __type: 'String' },
    facebookUrl: { __type: 'String' },
    firstName: { __type: 'String' },
    instagramHandle: { __type: 'String' },
    lastName: { __type: 'String' },
    localization: { __type: 'MobileProfileReadLocalization' },
    phone: { __type: 'String' },
    privacyUrl: { __type: 'String' },
    supportEmail: { __type: 'String' },
    supportPhone: { __type: 'String' },
    termsUrl: { __type: 'String' },
    tiktokHandle: { __type: 'String' },
    twitterUrl: { __type: 'String' },
    website: { __type: 'String' },
    youtubeUrl: { __type: 'String' },
  },
  MobileProfileReadLocalization: {
    __typename: { __type: 'String!' },
    customStrings: { __type: 'MobileProfileReadLocalizationCustomStrings' },
    defaultLanguage: { __type: 'String!' },
    fallbackLanguage: { __type: 'String!' },
    rtlLanguages: { __type: '[String!]' },
    supportedLanguages: { __type: '[String!]!' },
  },
  MobileProfileReadLocalizationCustomStrings: {
    __typename: { __type: 'String!' },
    login: { __type: 'String' },
    logout: { __type: 'String' },
    profile: { __type: 'String' },
    settings: { __type: 'String' },
    welcome: { __type: 'String' },
  },
  MobileSetupErrors: {
    __typename: { __type: 'String!' },
    channels: { __type: '[String!]' },
    customization: { __type: '[String!]' },
    general: { __type: '[String!]' },
    profile: { __type: '[String!]' },
  },
  MobileSetupResponse: {
    __typename: { __type: 'String!' },
    data: { __type: 'MobileSetupResponseData' },
    errors: { __type: 'MobileSetupErrors' },
    message: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  MobileSetupResponseData: {
    __typename: { __type: 'String!' },
    appConfig: { __type: 'MobileAppMetadata!' },
    channels: { __type: 'MobileChannelsComplete' },
    customization: { __type: 'MobileCustomizationComplete' },
    profile: { __type: 'MobileProfileRead' },
    progress: { __type: 'MobileAppProgress!' },
    themes: { __type: 'JSONObject' },
  },
  ModifySuspensionEndDate: {
    __typename: { __type: 'String!' },
    canceledFeeInvoiceIds: { __type: '[String!]!' },
    cyclesAdjusted: { __type: 'Float!' },
  },
  MonthViewDay: {
    __typename: { __type: 'String!' },
    date: { __type: 'String!' },
    sessions: { __type: '[MonthViewSession!]!' },
    totalCount: { __type: 'Float!' },
  },
  MonthViewSession: {
    __typename: { __type: 'String!' },
    bookedCount: { __type: 'Float' },
    color: { __type: 'String' },
    instructor: { __type: '[CalendarSessionInstructor!]' },
    isBlockSlot: { __type: 'Boolean!' },
    isFullyPaid: { __type: 'Boolean!' },
    isPublishedToWellhub: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    sessionId: { __type: 'String!' },
    size: { __type: 'Float!' },
    startTime: { __type: 'String!' },
    status: { __type: 'SessionStatus' },
  },
  MonthlyAttendance: {
    __typename: { __type: 'String!' },
    count: { __type: 'Float!' },
    month: { __type: 'String!' },
  },
  MultipleReservationInput: {
    clientIds: { __type: '[ID!]!' },
    sendInviteEmail: { __type: 'Boolean!' },
    sessionIds: { __type: '[String!]!' },
  },
  MultipleReservationResult: {
    __typename: { __type: 'String!' },
    results: { __type: '[SessionBookingResult!]!' },
    totalFailed: { __type: 'Float!' },
    totalRequested: { __type: 'Float!' },
    totalSucceeded: { __type: 'Float!' },
    totalWaitlisted: { __type: 'Float!' },
  },
  MyCommission: {
    __typename: { __type: 'String!' },
    commissionPeriodId: { __type: 'ID!' },
    label: { __type: 'String!' },
    lines: { __type: '[CommissionLine!]!' },
    status: { __type: 'String!' },
    total: { __type: 'String!' },
  },
  MyCoverPreferences: {
    __typename: { __type: 'String!' },
    emailOffersEnabled: { __type: 'Boolean!' },
    hasPhone: { __type: 'Boolean!' },
    smsOptIn: { __type: 'Boolean!' },
    smsOptInAt: { __type: 'String' },
    smsOptOutAt: { __type: 'String' },
  },
  MyPendingItemsLink: {
    __typename: { __type: 'String!' },
    expiresAt: { __type: 'String!' },
    handoffId: { __type: 'ID!' },
    url: { __type: 'String!' },
  },
  MyPendingPerson: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'ID!' },
    firstName: { __type: 'String' },
    items: { __type: '[MyPendingPolicyItem!]!' },
    lastName: { __type: 'String' },
    relationship: { __type: 'MyPendingRelationship!' },
  },
  MyPendingPolicies: {
    __typename: { __type: 'String!' },
    blockingCount: { __type: 'Float!' },
    people: { __type: '[MyPendingPerson!]!' },
    siteId: { __type: 'ID!' },
    totalCount: { __type: 'Float!' },
  },
  MyPendingPolicyItem: {
    __typename: { __type: 'String!' },
    acceptanceMethod: { __type: 'PolicyAcceptanceMethod!' },
    blocking: { __type: 'Boolean!' },
    content: { __type: 'String' },
    dueOn: { __type: 'String' },
    itemKey: { __type: 'String!' },
    nativeAccept: { __type: 'Boolean!' },
    policyRevisionId: { __type: 'ID!' },
    requiredForEquipment: { __type: 'Boolean!' },
    revisionSha256: { __type: 'String!' },
    signerCapacity: { __type: 'SignerCapacity!' },
    sitePolicyId: { __type: 'ID!' },
    title: { __type: 'String!' },
  },
  MyPolicyRefusal: {
    __typename: { __type: 'String!' },
    code: { __type: 'MyPolicyRefusalCode!' },
    itemKey: { __type: 'String!' },
  },
  MySharedPackage: {
    __typename: { __type: 'String!' },
    allocatedCredits: { __type: 'Float' },
    consumedCredits: { __type: 'Float!' },
    maxSharingCredits: { __type: 'Float' },
    ownerClientId: { __type: 'ID!' },
    ownerFirstName: { __type: 'String' },
    ownerLastName: { __type: 'String' },
    packageConsumedCredits: { __type: 'Float!' },
    remainingCredits: { __type: 'Float' },
    serviceId: { __type: 'ID!' },
    sharedOn: { __type: 'String' },
  },
  NLPAnalysis: {
    __typename: { __type: 'String!' },
    confidence: { __type: 'Float!' },
    entities: { __type: '[Entity!]!' },
    intent: { __type: 'String!' },
    keywords: { __type: '[String!]!' },
    language: { __type: 'String!' },
    sentiment: { __type: 'Sentiment!' },
    topics: { __type: '[String!]!' },
  },
  NLPAnalysisInput: {
    analysisType: { __type: 'String' },
    corporateId: { __type: 'String!' },
    text: { __type: 'String!' },
  },
  NextBooking: {
    __typename: { __type: 'String!' },
    bookingID: { __type: 'String!' },
    bookingStatus: { __type: 'String!' },
    casualRate: { __type: 'Float!' },
    checkinStatus: { __type: 'Boolean!' },
    creditsRequired: { __type: 'Float!' },
    digitalLocation: { __type: 'Boolean!' },
    duration: { __type: 'String!' },
    endTime: { __type: 'String!' },
    instructorData: { __type: '[InstructorListInfo!]!' },
    instructorName: { __type: 'String!' },
    mediaType: { __type: 'String!' },
    paymentPending: { __type: 'Boolean!' },
    roomName: { __type: 'String!' },
    sessionDate: { __type: 'String!' },
    sessionID: { __type: 'String!' },
    sessionImage: { __type: 'String!' },
    sessionLocationType: { __type: 'String!' },
    sessionName: { __type: 'String!' },
    siteID: { __type: 'String!' },
    siteName: { __type: 'String!' },
    spotID: { __type: 'Float!' },
    spotName: { __type: 'String!' },
    startTime: { __type: 'String!' },
    timezone: { __type: 'String!' },
    waitlistNumber: { __type: 'Float!' },
    zoomJoinURL: { __type: 'String' },
  },
  NextOpening: {
    __typename: { __type: 'String!' },
    date: { __type: 'String!' },
    daysFromToday: { __type: 'Int!' },
    time: { __type: 'String!' },
  },
  OnboardBrandBranchCredentialsInput: {
    branchLiveKey: { __type: 'String!' },
    branchSecret: { __type: 'String!' },
    branchTestKey: { __type: 'String' },
  },
  OnboardingChecklistItem: {
    __typename: { __type: 'String!' },
    category: { __type: 'OnboardingCategory!' },
    checklistId: { __type: 'ID!' },
    completedAt: { __type: 'String' },
    completedByUserId: { __type: 'ID' },
    corporateId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    isCompleted: { __type: 'Boolean!' },
    metadata: { __type: 'JSONObject' },
    sortOrder: { __type: 'Float!' },
    stepDescription: { __type: 'String' },
    stepKey: { __type: 'OnboardingStepKey!' },
    stepLabel: { __type: 'String!' },
    updatedAt: { __type: 'String' },
  },
  OnboardingLinkResult: {
    __typename: { __type: 'String!' },
    expiresAt: { __type: 'Float!' },
    url: { __type: 'String!' },
  },
  OnboardingProgress: {
    __typename: { __type: 'String!' },
    completedSteps: { __type: 'Float!' },
    items: { __type: '[OnboardingChecklistItem!]!' },
    progressPct: { __type: 'Float!' },
    totalSteps: { __type: 'Float!' },
  },
  OrganisationBillingPreview: {
    __typename: { __type: 'String!' },
    employeeCount: { __type: 'Float!' },
    invoiceEmail: { __type: 'String' },
    nextChargeAmountBeforeTax: { __type: 'String' },
    nextChargeDate: { __type: 'String' },
    nextChargeEmployeeCount: { __type: 'Float!' },
    paymentMethodBrand: { __type: 'String' },
    paymentMethodLast4: { __type: 'String' },
  },
  OrganisationEmployee: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'String!' },
    email: { __type: 'String' },
    firstName: { __type: 'String' },
    lastName: { __type: 'String' },
    linkedAt: { __type: 'String' },
  },
  OrganisationInvoiceInput: {
    employeeClientIds: { __type: '[ID!]!' },
    organisationClientId: { __type: 'ID!' },
    paidInFullCycles: { __type: 'Float' },
    serviceTemplateId: { __type: 'ID!' },
    startDate: { __type: 'String!' },
  },
  OwedBalanceOverrideInput: { reason: { __type: 'String!' } },
  PaginationInput: {
    cursor: { __type: 'String' },
    limit: { __type: 'Float' },
    offset: { __type: 'Float' },
    page: { __type: 'Float' },
    pageSize: { __type: 'Float' },
  },
  PaperFormApprover: {
    __typename: { __type: 'String!' },
    firstName: { __type: 'String' },
    lastName: { __type: 'String' },
    staffUserId: { __type: 'ID!' },
  },
  PaperPolicyFormResult: {
    __typename: { __type: 'String!' },
    acceptances: { __type: '[PolicyEvidenceAcceptanceResult!]!' },
    approvedByStaffUserId: { __type: 'ID!' },
    paperRecordId: { __type: 'ID!' },
  },
  PaperPolicyFormSlotInput: {
    policyRevisionId: { __type: 'ID!' },
    signedOn: { __type: 'String!' },
    signerCapacity: { __type: 'SignerCapacity!' },
    signerId: { __type: 'ID!' },
    signerName: { __type: 'String!' },
  },
  PaperScanUploadHeader: {
    __typename: { __type: 'String!' },
    name: { __type: 'String!' },
    value: { __type: 'String!' },
  },
  PaperScanUploadTicket: {
    __typename: { __type: 'String!' },
    expiresAt: { __type: 'String!' },
    headers: { __type: '[PaperScanUploadHeader!]!' },
    uploadId: { __type: 'ID!' },
    uploadUrl: { __type: 'String!' },
  },
  Payment: {
    __typename: { __type: 'String!' },
    amount: { __type: 'Numeric!' },
    applicationFeeAmount: { __type: 'Numeric' },
    autoRetryAttempts: { __type: 'Float!' },
    autoRetryClientPaymentMethodId: { __type: 'ID' },
    autoRetryNextDate: { __type: 'String!' },
    cashDrawerSessionId: { __type: 'ID' },
    clientActionExpiresAt: { __type: 'String' },
    clientFeeAmount: { __type: 'Numeric' },
    clientId: { __type: 'ID' },
    clientPaymentMethod: { __type: 'ClientPaymentMethod' },
    clientPaymentMethodId: { __type: 'ID' },
    createdAt: { __type: 'String!' },
    createdByClientId: { __type: 'ID' },
    createdByStaffUserId: { __type: 'ID' },
    currency: { __type: 'Currency!' },
    customPaymentMethodLabel: { __type: 'String' },
    disputeState: { __type: 'PaymentDisputeState!' },
    disputedAmount: { __type: 'Numeric' },
    fallbackAttemptedMethodIds: { __type: '[ID!]' },
    fallbackFromClientPaymentMethodId: { __type: 'ID' },
    fallbackReason: { __type: 'PaymentFallbackReason' },
    fallbackRetryMethodIds: { __type: '[ID!]' },
    fallbackState: { __type: 'PaymentFallbackState' },
    gatewayMetadata: { __type: 'GatewayMetadata' },
    gatewaySettledAt: { __type: 'String' },
    idempotencyKey: { __type: 'String!' },
    invoiceId: { __type: 'ID!' },
    isAutoRetryable: { __type: 'Boolean!' },
    isClientActionRequired: { __type: 'Boolean!' },
    originalBilledAmount: { __type: 'Numeric' },
    originalPaymentId: { __type: 'ID' },
    paymentId: { __type: 'ID!' },
    paymentMethodType: { __type: 'PaymentMethodType!' },
    platformFeeAmount: { __type: 'Numeric' },
    reasonNotAutoRetryable: { __type: 'ReasonsNotAutoRetryable!' },
    rebateCalculationSnapshot: { __type: 'PaymentRebateCalculationSnapshot' },
    rebateFeeAmount: { __type: 'Numeric' },
    royaltyAmount: { __type: 'Numeric' },
    siteId: { __type: 'ID!' },
    sitePaymentGatewayId: { __type: 'ID' },
    status: { __type: 'PaymentStatus!' },
    succeedAt: { __type: 'String' },
    terminalPaymentMethodDetails: { __type: 'TerminalPaymentMethodDetails' },
    terminalReaderId: { __type: 'ID' },
    transactions: { __type: '[PaymentGatewayTransaction!]!' },
    updatedAt: { __type: 'String!' },
  },
  PaymentAuthenticationEmailResult: {
    __typename: { __type: 'String!' },
    deliveryState: { __type: 'PaymentApprovalDeliveryState!' },
    expiresAt: { __type: 'String!' },
    maskedEmail: { __type: 'String!' },
  },
  PaymentClientSecret: {
    __typename: { __type: 'String!' },
    actionType: { __type: 'String' },
    clientSecret: { __type: 'String!' },
    paymentIntentId: { __type: 'String!' },
  },
  PaymentGatewayTransaction: {
    __typename: { __type: 'String!' },
    actionPayload: { __type: 'PaymentGatewayTransactionActionPayload' },
    actionType: { __type: 'String' },
    amount: { __type: 'Numeric!' },
    attemptSequence: { __type: 'Float!' },
    createdAt: { __type: 'String!' },
    createdByStaffUserId: { __type: 'ID' },
    currency: { __type: 'Currency!' },
    dishonorFeeApplied: { __type: 'Boolean!' },
    dishonorFeeReason: { __type: 'String' },
    externalAttemptId: { __type: 'String' },
    externalPaymentId: { __type: 'String' },
    failureCategory: { __type: 'FailureCategory' },
    gatewayType: { __type: 'GatewayType!' },
    isAutomated: { __type: 'Boolean!' },
    isTerminalPayment: { __type: 'Boolean!' },
    paymentGatewayTransactionId: { __type: 'ID!' },
    paymentId: { __type: 'ID!' },
    processingFees: { __type: 'Numeric' },
    providerAccountId: { __type: 'String!' },
    rawErrorCode: { __type: 'String' },
    rawErrorDeclineCode: { __type: 'String' },
    rawErrorMessage: { __type: 'String' },
    rawHttpStatus: { __type: 'Float' },
    retryOfPaymentGatewayTransactionId: { __type: 'ID' },
    siteId: { __type: 'ID!' },
    sitePaymentGatewayId: { __type: 'ID!' },
    status: { __type: 'PaymentGatewayTransactionStatus!' },
  },
  PaymentGatewayTransactionActionPayload: {
    __typename: { __type: 'String!' },
    redirectUrl: { __type: 'String' },
    type: { __type: 'String!' },
  },
  PaymentMethodRemovalEligibility: {
    __typename: { __type: 'String!' },
    blockingReasons: { __type: '[PaymentMethodRemovalBlockReason!]!' },
    canRemove: { __type: 'Boolean!' },
  },
  PaymentRebateCalculationSnapshot: {
    __typename: { __type: 'String!' },
    appliedRebates: { __type: '[PaymentRebateCalculationSnapshotAppliedRebates!]!' },
    calculatedAt: { __type: 'String!' },
    rebateBaseAmount: { __type: 'Float!' },
    rebateTemplates: { __type: '[PaymentRebateCalculationSnapshotRebateTemplates!]!' },
    siteId: { __type: 'String!' },
    siteName: { __type: 'String!' },
    summary: { __type: 'FeeSummary!' },
    totalRebateAmount: { __type: 'Float!' },
  },
  PaymentRebateCalculationSnapshotAppliedRebates: {
    __typename: { __type: 'String!' },
    calculatedAmount: { __type: 'Float!' },
    corporatePayoutAccountId: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
    feeId: { __type: 'String!' },
    feeName: { __type: 'String!' },
    flatAmount: { __type: 'Float' },
    percentRate: { __type: 'Float' },
    rebateTemplateId: { __type: 'String!' },
    rebateTemplateName: { __type: 'String!' },
  },
  PaymentRebateCalculationSnapshotRebateTemplates: {
    __typename: { __type: 'String!' },
    corporatePayoutAccountId: { __type: 'String!' },
    rebateTemplateId: { __type: 'String!' },
    rebateTemplateName: { __type: 'String!' },
  },
  PaymentRecovery: {
    __typename: { __type: 'String!' },
    canEmail: { __type: 'Boolean!' },
    canUseTerminal: { __type: 'Boolean!' },
    expiresAt: { __type: 'String' },
    hasLaterInvoices: { __type: 'Boolean!' },
    isHeld: { __type: 'Boolean!' },
    linkState: { __type: 'PaymentApprovalLinkState!' },
    maskedEmail: { __type: 'String' },
    secondsUntilExpiry: { __type: 'Float' },
    soleTerminalReaderId: { __type: 'String' },
  },
  PaymentRecoveryStatus: {
    __typename: { __type: 'String!' },
    state: { __type: 'PaymentRecoveryState!' },
  },
  PayrollTimeClock: {
    __typename: { __type: 'String!' },
    clockDate: { __type: 'String!' },
    clockInTime: { __type: 'String!' },
    clockOutTime: { __type: 'String' },
    clockStatus: { __type: 'ClockStatus!' },
    clockedInByStaffUserId: { __type: 'ID' },
    clockedOutByStaffUserId: { __type: 'ID' },
    createdAt: { __type: 'String!' },
    entryType: { __type: 'String!' },
    notes: { __type: 'String' },
    payrollTimeClockId: { __type: 'ID!' },
    siteId: { __type: 'ID!' },
    staffUserId: { __type: 'ID!' },
    updatedAt: { __type: 'String!' },
  },
  PendingAgreement: {
    __typename: { __type: 'String!' },
    invoiceId: { __type: 'String' },
    invoiceTotal: { __type: 'Float!' },
    packageID: { __type: 'String!' },
    packageName: { __type: 'String!' },
    packageSubscriptionID: { __type: 'String!' },
    siteID: { __type: 'String!' },
    siteName: { __type: 'String!' },
  },
  PendingBookingRequest: {
    __typename: { __type: 'String!' },
    bookingId: { __type: 'String!' },
    bookingSource: { __type: 'BookingSource' },
    clientFirstName: { __type: 'String!' },
    clientId: { __type: 'String!' },
    clientLastName: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    instructorName: { __type: 'String' },
    paymentStatus: { __type: 'String' },
    sessionEndTime: { __type: 'String!' },
    sessionId: { __type: 'String!' },
    sessionName: { __type: 'String!' },
    sessionStartTime: { __type: 'String!' },
    sessionTypeName: { __type: 'String' },
    siteLocationId: { __type: 'String' },
  },
  PendingCashDrawerPayout: {
    __typename: { __type: 'String!' },
    amount: { __type: 'Numeric!' },
    clientId: { __type: 'ID' },
    clientName: { __type: 'String' },
    createdAt: { __type: 'String!' },
    invoiceId: { __type: 'ID!' },
    paymentId: { __type: 'ID!' },
    refundId: { __type: 'ID!' },
  },
  PendingChange: {
    __typename: { __type: 'String!' },
    effectiveDate: { __type: 'String!' },
    projectedAmount: { __type: 'Numeric' },
    projectedDate: { __type: 'String' },
    suspensionRowState: { __type: 'SuspensionRowState' },
    toServiceTemplateId: { __type: 'ID' },
    toServiceTemplateName: { __type: 'String' },
    type: { __type: 'PendingChangeType!' },
  },
  PendingGuestPassForEmail: {
    __typename: { __type: 'String!' },
    expiresAt: { __type: 'String' },
    guestPassId: { __type: 'ID!' },
    inviteToken: { __type: 'String!' },
    senderName: { __type: 'String' },
    siteId: { __type: 'ID!' },
    siteName: { __type: 'String' },
  },
  PendingItemsHandoff: {
    __typename: { __type: 'String!' },
    channel: { __type: 'PendingItemsChannel!' },
    clientId: { __type: 'ID!' },
    completedAt: { __type: 'String' },
    createdAt: { __type: 'String!' },
    doneCount: { __type: 'Float' },
    expiresAt: { __type: 'String!' },
    handoffId: { __type: 'ID!' },
    items: { __type: '[PendingItemsHandoffItem!]!' },
    presenceBinding: { __type: 'String' },
    publicUrl: { __type: 'String' },
    recipientCapacity: { __type: 'SignerCapacity!' },
    recipientSignerId: { __type: 'ID!' },
    resultCode: { __type: 'String' },
    siteId: { __type: 'ID!' },
    status: { __type: 'PendingItemsHandoffStatus!' },
    statusVersion: { __type: 'Float!' },
    totalCount: { __type: 'Float' },
    updatedAt: { __type: 'String!' },
  },
  PendingItemsHandoffItem: {
    __typename: { __type: 'String!' },
    capability: { __type: 'PendingItemHandoffCapability!' },
    countsTowardCompletion: { __type: 'Boolean!' },
    done: { __type: 'Boolean!' },
    itemKey: { __type: 'String!' },
    kind: { __type: 'PendingItemKind!' },
    signerCapacity: { __type: 'SignerCapacity' },
    sitePolicyId: { __type: 'ID' },
    title: { __type: 'String!' },
  },
  PendingItemsRecipient: {
    __typename: { __type: 'String!' },
    dobVerified: { __type: 'Boolean!' },
    guardianClientId: { __type: 'ID' },
    hasAppDevice: { __type: 'Boolean!' },
    hasTextConsent: { __type: 'Boolean!' },
    hasValidMobile: { __type: 'Boolean!' },
    items: { __type: '[PendingItemsRecipientItem!]!' },
    maskedMobile: { __type: 'String' },
    name: { __type: 'String!' },
    signerId: { __type: 'ID!' },
  },
  PendingItemsRecipientItem: {
    __typename: { __type: 'String!' },
    blocking: { __type: 'Boolean!' },
    itemKey: { __type: 'String!' },
    kind: { __type: 'PendingItemKind!' },
    requiredForEquipment: { __type: 'Boolean!' },
    signerCapacity: { __type: 'SignerCapacity!' },
    title: { __type: 'String!' },
  },
  PendingPolicy: {
    __typename: { __type: 'String!' },
    policyID: { __type: 'String!' },
    policyName: { __type: 'String!' },
  },
  PlanOption: {
    __typename: { __type: 'String!' },
    direction: { __type: 'PlanChangeDirection!' },
    meetsNewSaleDynamicDisplay: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    price: { __type: 'String!' },
    priceDelta: { __type: 'String!' },
    saleAvailabilityState: { __type: 'SaleAvailabilityState!' },
    serviceTemplateId: { __type: 'ID!' },
    tierOrder: { __type: 'Float' },
  },
  PlanYourVisitWidget: {
    __typename: { __type: 'String!' },
    forecast: { __type: 'MemberVisitForecast' },
    isTemporarilyClosed: { __type: 'Boolean!' },
    live: { __type: 'SiteLiveOccupancy' },
    title: { __type: 'String!' },
  },
  PolicyAcceptanceVoidResult: {
    __typename: { __type: 'String!' },
    acceptanceState: { __type: 'PolicyAcceptanceState!' },
    agreementId: { __type: 'ID!' },
  },
  PolicyBulkSendPreview: {
    __typename: { __type: 'String!' },
    availableCredits: { __type: 'Float!' },
    cap: { __type: 'Float!' },
    estimatedCredits: { __type: 'Float!' },
    estimatedSegments: { __type: 'Float!' },
    exceedsCap: { __type: 'Boolean!' },
    matchedClients: { __type: 'Float!' },
    recipients: { __type: 'Float!' },
    segmentsPerMessage: { __type: 'Float!' },
    siteId: { __type: 'ID!' },
    skipReasons: { __type: '[PolicyBulkSendSkipCount!]!' },
    skipped: { __type: 'Float!' },
    toGuardians: { __type: 'Float!' },
  },
  PolicyBulkSendRun: {
    __typename: { __type: 'String!' },
    cancelledAt: { __type: 'String' },
    completedAt: { __type: 'String' },
    createdAt: { __type: 'String!' },
    estimatedCredits: { __type: 'Float!' },
    estimatedSegments: { __type: 'Float!' },
    processedCount: { __type: 'Float!' },
    queuedCount: { __type: 'Float!' },
    requestedByStaffUserId: { __type: 'ID!' },
    runId: { __type: 'ID!' },
    siteId: { __type: 'ID!' },
    skipReasons: { __type: '[PolicyBulkSendSkipCount!]!' },
    skippedCount: { __type: 'Float!' },
    status: { __type: 'PolicyBulkSendStatus!' },
    totalCount: { __type: 'Float!' },
  },
  PolicyBulkSendSkipCount: {
    __typename: { __type: 'String!' },
    count: { __type: 'Float!' },
    reason: { __type: 'PendingItemsAutoSendSkipReason!' },
  },
  PolicyComplianceSettings: {
    __typename: { __type: 'String!' },
    allowQueueBeforePoliciesSigned: { __type: 'Boolean!' },
    allowRemoteGuardianSigning: { __type: 'Boolean!' },
    autoSendPendingItemsLink: { __type: 'Boolean!' },
    eSignConsentProfile: { __type: 'ESignConsentProfile!' },
    guardianConsentAge: { __type: 'Float!' },
    pendingItemsLinkTtlHours: { __type: 'Float' },
    renewalReminderDays: { __type: 'Float!' },
    sendOnHomeLocationChange: { __type: 'Boolean!' },
    sendOnPlanPurchase: { __type: 'Boolean!' },
    sendPushForPendingPolicies: { __type: 'Boolean!' },
    siteId: { __type: 'ID!' },
  },
  PolicyComplianceSettingsInput: {
    allowQueueBeforePoliciesSigned: { __type: 'Boolean' },
    allowRemoteGuardianSigning: { __type: 'Boolean' },
    autoSendPendingItemsLink: { __type: 'Boolean' },
    eSignConsentProfile: { __type: 'ESignConsentProfile' },
    guardianConsentAge: { __type: 'Float' },
    pendingItemsLinkTtlHours: { __type: 'Float' },
    renewalReminderDays: { __type: 'Float' },
    sendOnHomeLocationChange: { __type: 'Boolean' },
    sendOnPlanPurchase: { __type: 'Boolean' },
    sendPushForPendingPolicies: { __type: 'Boolean' },
  },
  PolicyEvidenceAcceptanceResult: {
    __typename: { __type: 'String!' },
    acceptanceState: { __type: 'PolicyAcceptanceState!' },
    agreementId: { __type: 'ID!' },
    policyRevisionId: { __type: 'ID!' },
    signerCapacity: { __type: 'SignerCapacity!' },
    slotIndex: { __type: 'Float!' },
  },
  PolicyEvidenceExport: {
    __typename: { __type: 'String!' },
    completedAt: { __type: 'String' },
    createdAt: { __type: 'String!' },
    downloadCount: { __type: 'Float!' },
    expiresAt: { __type: 'String' },
    exportId: { __type: 'ID!' },
    includeScans: { __type: 'Boolean!' },
    itemCount: { __type: 'Float' },
    requestedBy: { __type: 'ID!' },
    revokedAt: { __type: 'String' },
    signedFrom: { __type: 'String!' },
    signedTo: { __type: 'String!' },
    siteId: { __type: 'ID!' },
    status: { __type: 'PolicyEvidenceExportStatus!' },
  },
  PolicyEvidenceExportDownload: {
    __typename: { __type: 'String!' },
    expiresAt: { __type: 'String!' },
    exportId: { __type: 'ID!' },
    url: { __type: 'String!' },
  },
  PosProductActivityLogWithStaff: {
    __typename: { __type: 'String!' },
    activityCategory: { __type: 'PosActivityCategory' },
    activityType: { __type: 'PosActivityType!' },
    fieldName: { __type: 'String' },
    metadata: { __type: 'String' },
    newValue: { __type: 'String' },
    oldValue: { __type: 'String' },
    performedAt: { __type: 'String!' },
    performedBy: { __type: 'ID!' },
    posProductActivityLogId: { __type: 'ID!' },
    posProductId: { __type: 'ID!' },
    siteId: { __type: 'ID!' },
    staffUser: { __type: 'PosProductActivityLogWithStaffStaffUser' },
  },
  PosProductActivityLogWithStaffStaffUser: {
    __typename: { __type: 'String!' },
    email: { __type: 'String!' },
    firstName: { __type: 'String!' },
    lastName: { __type: 'String!' },
  },
  PosProductVariableAttribute: {
    __typename: { __type: 'String!' },
    attributeName: { __type: 'String!' },
    attributeValue: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    displayOrder: { __type: 'Int' },
    posProductId: { __type: 'ID!' },
    posProductVariableAttributeId: { __type: 'ID!' },
    posProductVariableId: { __type: 'ID!' },
    siteId: { __type: 'ID!' },
  },
  PosProductVariableAttributeInput: {
    attributeName: { __type: 'String!' },
    attributeValue: { __type: 'String!' },
    displayOrder: { __type: 'Int' },
  },
  PosProductVariableFlat: {
    __typename: { __type: 'String!' },
    barcode: { __type: 'String' },
    categoryId: { __type: 'ID' },
    categoryName: { __type: 'String' },
    createdAt: { __type: 'String!' },
    currentStock: { __type: 'Int!' },
    imageJSON: { __type: 'ImageFileConfigField' },
    isEnabledForSale: { __type: 'Boolean!' },
    isFeatured: { __type: 'Boolean!' },
    posProductId: { __type: 'ID!' },
    posProductVariableId: { __type: 'ID!' },
    price: { __type: 'Numeric!' },
    productImage: {
      __type: 'ImagePublicSignedUrl',
      __args: { input: 'ImagePublicSignedUrlInput!' },
    },
    productName: { __type: 'String!' },
    siteId: { __type: 'ID!' },
    sku: { __type: 'String' },
    status: { __type: 'PosProductStatus!' },
    taxSettingIds: { __type: '[String!]' },
    trackStock: { __type: 'Boolean!' },
    updatedAt: { __type: 'String!' },
    variableName: { __type: 'String!' },
  },
  PosProductVariableInput: {
    attributes: { __type: '[PosProductVariableAttributeInput!]!' },
    barcode: { __type: 'String' },
    cost: { __type: 'String' },
    currentStock: { __type: 'Int' },
    isDefault: { __type: 'Boolean!' },
    isEnabledForSale: { __type: 'Boolean!' },
    isFeatured: { __type: 'Boolean!' },
    maxStockLevel: { __type: 'Int' },
    minStockLevel: { __type: 'Int' },
    price: { __type: 'String!' },
    sku: { __type: 'String' },
    sortOrder: { __type: 'Int!' },
    taxSettingIds: { __type: '[ID!]' },
    trackStock: { __type: 'Boolean!' },
    variableName: { __type: 'String!' },
  },
  PosProductVariableWithAttributes: {
    __typename: { __type: 'String!' },
    attributes: { __type: '[PosProductVariableAttribute!]!' },
    barcode: { __type: 'String' },
    cost: { __type: 'Numeric' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'ID!' },
    currentStock: { __type: 'Int!' },
    isDefault: { __type: 'Boolean!' },
    isEnabledForSale: { __type: 'Boolean!' },
    isFeatured: { __type: 'Boolean!' },
    maxStockLevel: { __type: 'Int' },
    minStockLevel: { __type: 'Int' },
    posProductId: { __type: 'ID!' },
    posProductVariableId: { __type: 'ID!' },
    price: { __type: 'Numeric!' },
    siteId: { __type: 'ID!' },
    sku: { __type: 'String' },
    sortOrder: { __type: 'Int!' },
    status: { __type: 'PosProductStatus!' },
    taxSettingIds: { __type: '[String!]' },
    trackStock: { __type: 'Boolean!' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'ID' },
    variableName: { __type: 'String!' },
  },
  PosProductVariablesFlat: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'PosProductVariablesFlatPageInfo!' },
    results: { __type: '[PosProductVariablesFlatResults!]!' },
  },
  PosProductVariablesFlatPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  PosProductVariablesFlatResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'PosProductVariableFlat!' },
  },
  PosProducts: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'PosProductsPageInfo!' },
    results: { __type: '[PosProductsResults!]!' },
  },
  PosProductsPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  PosProductsResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'UpdatePosProductResponse!' },
  },
  PosStockAdjustment: {
    __typename: { __type: 'String!' },
    adjustedAt: { __type: 'String!' },
    adjustedBy: { __type: 'ID!' },
    adjustmentType: { __type: 'PosStockAdjusmentType!' },
    posProductId: { __type: 'ID!' },
    posProductVariableId: { __type: 'ID!' },
    posStockAdjustmentId: { __type: 'ID!' },
    quantityAdjustment: { __type: 'Int!' },
    quantityAfter: { __type: 'Int!' },
    quantityBefore: { __type: 'Int!' },
    reason: { __type: 'String' },
    referenceId: { __type: 'ID' },
    siteId: { __type: 'ID!' },
  },
  PresaleDateShiftPreview: {
    __typename: { __type: 'String!' },
    overpayment: { __type: 'Numeric' },
    shortfall: { __type: 'Numeric' },
  },
  PreviewGcsBundleMatch: {
    __typename: { __type: 'String!' },
    matchRate: { __type: 'Float!' },
    matchedEntries: { __type: 'Float!' },
    sampleUnmatchedExternalIds: { __type: '[String!]!' },
    totalEntries: { __type: 'Float!' },
    unmatchedEntries: { __type: 'Float!' },
  },
  PreviewMembershipPlanChangeResult: {
    __typename: { __type: 'String!' },
    firstCycleSettlement: { __type: 'FirstCycleSettlement' },
    proratedAmount: { __type: 'String' },
  },
  PreviewPresaleDateShiftInput: {
    invoiceDate: { __type: 'String!' },
    invoiceId: { __type: 'ID!' },
  },
  PreviewProratedSuspensionResult: {
    __typename: { __type: 'String!' },
    commitmentExtensionDays: { __type: 'Float' },
    convertsToAccountCredit: { __type: 'Boolean' },
    creditAmount: { __type: 'String' },
    creditMethod: { __type: 'ServiceSuspensionCreditMethod' },
    cycleAmountAfterCredit: { __type: 'String' },
    cycleAmountBeforeCredit: { __type: 'String' },
    cyclesDeferred: { __type: 'Float' },
    daysInCycle: { __type: 'Float' },
    entryInvoicePaid: { __type: 'Boolean!' },
    nextBillingDate: { __type: 'String' },
    noCreditReason: { __type: 'String' },
    unusedCredits: { __type: 'Float' },
    unusedDays: { __type: 'Float' },
  },
  PreviewServiceCancellationCharge: {
    __typename: { __type: 'String!' },
    amount: { __type: 'String!' },
    dueDate: { __type: 'String!' },
    serviceId: { __type: 'String!' },
    serviceName: { __type: 'String!' },
  },
  PreviewServiceCancellationResult: {
    __typename: { __type: 'String!' },
    addOnsEndingWithMembership: { __type: '[String!]!' },
    blocker: { __type: 'CancellationPreviewBlocker' },
    canCancel: { __type: 'Boolean!' },
    cancelAt: { __type: 'String!' },
    chargesBeforeEffectiveDate: { __type: '[PreviewServiceCancellationCharge!]!' },
    chargesTotal: { __type: 'String!' },
    currency: { __type: 'String' },
    earliestCancelDate: { __type: 'String' },
    effectiveDate: { __type: 'String!' },
    effectiveDateRule: { __type: 'CancellationEffectiveDateRule!' },
    feeAmount: { __type: 'String!' },
    feeBreakdown: { __type: 'CancellationFeeBreakdown' },
    feeExclusiveTaxPercent: { __type: 'String!' },
    feeIsTaxEnabled: { __type: 'Boolean!' },
    feeSource: { __type: 'CancellationFeeSource!' },
    feeTaxAmount: { __type: 'String!' },
    feeTaxSettingIds: { __type: '[String!]!' },
    feeTierIndex: { __type: 'Float' },
    feeTotal: { __type: 'String!' },
    noticePeriodDays: { __type: 'Float!' },
    serviceId: { __type: 'String!' },
    serviceName: { __type: 'String!' },
    tenure: { __type: 'PreviewServiceCancellationTenure' },
    totalDueBeforeCancellation: { __type: 'String!' },
  },
  PreviewServiceCancellationTenure: {
    __typename: { __type: 'String!' },
    basis: { __type: 'CancellationTierBasis!' },
    elapsed: { __type: 'Float!' },
    termEnd: { __type: 'String' },
  },
  PreviewServiceResumeResult: {
    __typename: { __type: 'String!' },
    convertsToAccountCredit: { __type: 'Boolean!' },
    creditApplied: { __type: 'String' },
    creditRemainingAfter: { __type: 'String' },
    netAmount: { __type: 'String' },
    stubDays: { __type: 'Float' },
    stubGrossAmount: { __type: 'String' },
    suspensionType: { __type: 'ServiceSuspensionType' },
    terminatesRecurringFee: { __type: 'Boolean!' },
  },
  PreviewSuspensionFeeResult: {
    __typename: { __type: 'String!' },
    billingDates: { __type: '[String!]!' },
    chargeAmount: { __type: 'String!' },
    firstBillingDate: { __type: 'String!' },
    lastBillingDate: { __type: 'String' },
    occurrences: { __type: 'Float' },
    totalAmount: { __type: 'String' },
  },
  PreviewSuspensionPlanPause: {
    __typename: { __type: 'String!' },
    fee: { __type: 'PreviewSuspensionFeeResult' },
    index: { __type: 'Float!' },
    isEstimate: { __type: 'Boolean!' },
    prorated: { __type: 'PreviewProratedSuspensionResult' },
    secondaryFee: { __type: 'PreviewSuspensionSecondaryFeeResult' },
    timeShift: { __type: 'PreviewTimeShiftSuspensionResult' },
  },
  PreviewSuspensionPlanPauseInput: {
    chargeAmount: { __type: 'String' },
    chargeMode: { __type: 'ServiceSuspensionChargeMode' },
    endDate: { __type: 'String' },
    feeBillingCycleAmount: { __type: 'Float' },
    feeBillingCycleUnit: { __type: 'String' },
    startDate: { __type: 'String!' },
    suspensionType: { __type: 'ServiceSuspensionType' },
  },
  PreviewSuspensionPlanResult: {
    __typename: { __type: 'String!' },
    pauses: { __type: '[PreviewSuspensionPlanPause!]!' },
  },
  PreviewSuspensionSecondaryFeeResult: {
    __typename: { __type: 'String!' },
    amount: { __type: 'String!' },
    continuesDuringPause: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    nextBillingDate: { __type: 'String!' },
    projectedNextBillingDate: { __type: 'String' },
  },
  PreviewTimeShiftSuspensionResult: {
    __typename: { __type: 'String!' },
    commitmentExtensionDays: { __type: 'Float' },
    nextBillingDate: { __type: 'String' },
  },
  PrivateBookingCreateInput: {
    bookedByClientId: { __type: 'String' },
    bookingSource: { __type: 'BookingSource' },
    clientId: { __type: 'String!' },
    date: { __type: 'String!' },
    forFamilyMember: { __type: 'Boolean' },
    notes: { __type: 'String' },
    owedBalanceOverride: { __type: 'OwedBalanceOverrideInput' },
    serviceId: { __type: 'String' },
    sessionTemplateId: { __type: 'String!' },
    sharedServiceId: { __type: 'String' },
    staffUserIds: { __type: '[String!]' },
    startTime: { __type: 'String!' },
  },
  ProcessCSVImport: {
    __typename: { __type: 'String!' },
    errors: { __type: '[String!]' },
    gcsUrl: { __type: 'String!' },
    importSessionId: { __type: 'ID!' },
    status: { __type: 'ProcessCSVImportStatus!' },
    totalRows: { __type: 'Float!' },
  },
  ProcessZIPImport: {
    __typename: { __type: 'String!' },
    errors: { __type: '[String!]' },
    gcsUrl: { __type: 'String!' },
    importSessionId: { __type: 'ID!' },
    status: { __type: 'ProcessZIPImportStatus!' },
    totalFiles: { __type: 'Float!' },
  },
  ProcessZIPImportFromGcs: {
    __typename: { __type: 'String!' },
    errors: { __type: '[String!]' },
    migrationId: { __type: 'String' },
    sessions: { __type: '[ProcessZIPImportFromGcsSessions!]!' },
  },
  ProcessZIPImportFromGcsSessions: {
    __typename: { __type: 'String!' },
    fileName: { __type: 'String!' },
    gcsUrl: { __type: 'String!' },
    importSessionId: { __type: 'ID!' },
    objectPath: { __type: 'String!' },
    reused: { __type: 'Boolean!' },
    status: { __type: 'ImportSessionStatusEnum!' },
  },
  PromoCode: {
    __typename: { __type: 'String!' },
    clientUseLimit: { __type: 'Float' },
    code: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    currentGlobalUses: { __type: 'Float!' },
    discountType: { __type: 'PromoCodeDiscountType!' },
    discountValue: { __type: 'Numeric!' },
    endDate: { __type: 'String' },
    globalUseLimit: { __type: 'Float' },
    isAvailableAfterIntroOffer: { __type: 'Boolean!' },
    isAvailableBeforeIntroOffer: { __type: 'Boolean!' },
    isAvailableForOnlineSale: { __type: 'Boolean!' },
    isDiscountFutureInvoices: { __type: 'Boolean!' },
    membershipIds: { __type: '[ID!]' },
    name: { __type: 'String!' },
    packageIds: { __type: '[ID!]' },
    productIds: { __type: '[ID!]' },
    promoCodeId: { __type: 'ID!' },
    siteId: { __type: 'ID!' },
    startDate: { __type: 'String!' },
    status: { __type: 'PromoCodeStatus!' },
    updatedAt: { __type: 'String!' },
  },
  PromoCodeCreateInput: {
    clientUseLimit: { __type: 'Float' },
    code: { __type: 'String!' },
    discountType: { __type: 'PromoCodeDiscountType!' },
    discountValue: { __type: 'Numeric!' },
    endDate: { __type: 'String' },
    globalUseLimit: { __type: 'Float' },
    isAvailableAfterIntroOffer: { __type: 'Boolean!' },
    isAvailableBeforeIntroOffer: { __type: 'Boolean!' },
    isAvailableForOnlineSale: { __type: 'Boolean!' },
    isDiscountFutureInvoices: { __type: 'Boolean!' },
    membershipIds: { __type: '[ID!]!' },
    name: { __type: 'String!' },
    packageIds: { __type: '[ID!]!' },
    productIds: { __type: '[ID!]!' },
    startDate: { __type: 'String!' },
  },
  PromoCodeDuplicateInput: { newCode: { __type: 'String!' }, newName: { __type: 'String' } },
  PromoCodeSort: {
    direction: { __type: 'SortDirection!' },
    field: { __type: 'PromoCodeSortFields!' },
  },
  PromoCodeUpdateInput: {
    clientUseLimit: { __type: 'Float' },
    code: { __type: 'String' },
    discountType: { __type: 'PromoCodeDiscountType' },
    discountValue: { __type: 'Numeric' },
    endDate: { __type: 'String' },
    globalUseLimit: { __type: 'Float' },
    isAvailableAfterIntroOffer: { __type: 'Boolean' },
    isAvailableBeforeIntroOffer: { __type: 'Boolean' },
    isAvailableForOnlineSale: { __type: 'Boolean' },
    isDiscountFutureInvoices: { __type: 'Boolean' },
    membershipIds: { __type: '[ID!]' },
    name: { __type: 'String' },
    packageIds: { __type: '[ID!]' },
    productIds: { __type: '[ID!]' },
    startDate: { __type: 'String' },
  },
  PromoCodeUsageInput: { promoCodeId: { __type: 'ID!' } },
  PromoCodeValidationInput: {
    beneficiaryId: { __type: 'ID' },
    clientId: { __type: 'ID' },
    code: { __type: 'String!' },
    isOnlineSale: { __type: 'Boolean' },
    itemId: { __type: 'ID' },
    itemType: { __type: 'PromoCodeItemType' },
  },
  PromoCodes: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'PromoCodesPageInfo!' },
    results: { __type: '[PromoCodesResults!]!' },
  },
  PromoCodesPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  PromoCodesResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'PromoCode!' },
  },
  PromoteProspect: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'ID!' },
    firebaseId: { __type: 'String!' },
    promoted: { __type: 'Boolean!' },
  },
  ProspectInput: {
    email: { __type: 'String!' },
    firstName: { __type: 'String' },
    lastName: { __type: 'String' },
    role: { __type: 'String' },
  },
  ProviderInfo: {
    __typename: { __type: 'String!' },
    isAvailable: { __type: 'Boolean!' },
    isConfigured: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    type: { __type: 'String!' },
  },
  ProvisionTrialAccessResponse: {
    __typename: { __type: 'String!' },
    corporateId: { __type: 'String!' },
    staffUserId: { __type: 'String!' },
    urlPrefix: { __type: 'String!' },
  },
  PublicSigningPendingClientAction: {
    __typename: { __type: 'String!' },
    clientSecret: { __type: 'String!' },
    paymentId: { __type: 'String!' },
    paymentIntentId: { __type: 'String!' },
  },
  PublishCorporateAddOnChangesInput: {
    assignedSiteGroupIds: { __type: '[ID!]' },
    assignedSiteIds: { __type: '[ID!]' },
    config: { __type: 'BrandAddOnConfigInput!' },
    corporateServiceTemplateId: { __type: 'ID!' },
    expectedVersion: { __type: 'Float!' },
    isAllLocations: { __type: 'Boolean!' },
    lockedSections: { __type: '[BrandServiceTemplateSection!]' },
    memberImpact: { __type: 'BrandServiceTemplateMemberImpact!' },
    selectedGroupKeys: { __type: '[String!]!' },
  },
  PublishEntitlementCatalogResult: {
    __typename: { __type: 'String!' },
    brandsSignalled: { __type: 'Float!' },
    catalogVersion: { __type: 'String!' },
    created: { __type: 'Boolean!' },
  },
  PurchaseCreditsResult: {
    __typename: { __type: 'String!' },
    ledgerEntry: { __type: 'SmsCreditsLedgerEntry!' },
    message: { __type: 'String!' },
    newBalance: { __type: 'Float!' },
    success: { __type: 'Boolean!' },
  },
  QueuedTanningRegulationOverride: {
    __typename: { __type: 'String!' },
    note: { __type: 'String!' },
    rule: { __type: 'TanningRegulationRule!' },
    staffUserId: { __type: 'ID' },
  },
  ReDeriveSiteFobsResult: {
    __typename: { __type: 'String!' },
    failed: { __type: 'Float!' },
    skipped: { __type: 'Float!' },
    updated: { __type: 'Float!' },
  },
  ReadinessDimensionResult: {
    __typename: { __type: 'String!' },
    reasonCodes: { __type: '[ReadinessReasonCode!]!' },
    status: { __type: 'ReadinessStatus!' },
  },
  ReadinessEvidenceDetail: {
    __typename: { __type: 'String!' },
    acceptedAgreementIds: { __type: '[ID!]!' },
    jurisdictionRuleRevision: { __type: 'String' },
    revisionIds: { __type: '[ID!]!' },
  },
  ReadinessItem: {
    __typename: { __type: 'String!' },
    dueOn: { __type: 'String' },
    itemKey: { __type: 'String!' },
    kind: { __type: 'PendingItemKind!' },
    policyRevisionId: { __type: 'ID' },
    reasonCode: { __type: 'ReadinessReasonCode!' },
    signerCapacity: { __type: 'SignerCapacity' },
    signerId: { __type: 'ID' },
    sitePolicyId: { __type: 'ID' },
    timing: { __type: 'ReadinessItemTiming' },
    title: { __type: 'String!' },
    validUntil: { __type: 'String' },
  },
  RebateTemplate: {
    __typename: { __type: 'String!' },
    corporatePayoutAccountId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'ID' },
    fees: { __type: '[RebateTemplateFees!]' },
    name: { __type: 'String!' },
    rebateTemplateId: { __type: 'ID!' },
    sites: { __type: '[SitePreview!]!' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'ID' },
  },
  RebateTemplateFees: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
    feeId: { __type: 'ID!' },
    rate: { __type: 'Numeric!' },
    rebateTemplateFeeId: { __type: 'ID!' },
    rebateTemplateId: { __type: 'ID!' },
  },
  RebateTemplateFeesInput: {
    enabled: { __type: 'Boolean!' },
    feeId: { __type: 'ID!' },
    rate: { __type: 'Numeric!' },
  },
  RebateTemplateInput: {
    corporatePayoutAccountId: { __type: 'ID!' },
    fees: { __type: '[RebateTemplateFeesInput!]' },
    name: { __type: 'String!' },
  },
  RebateTemplateUpdate: {
    corporatePayoutAccountId: { __type: 'ID' },
    fees: { __type: '[RebateTemplateFeesInput!]' },
    name: { __type: 'String' },
  },
  RebateTemplates: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'RebateTemplatesPageInfo!' },
    results: { __type: '[RebateTemplatesResults!]!' },
  },
  RebateTemplatesOrderByInput: {
    column: { __type: 'RebateTemplateOrderBy!' },
    direction: { __type: 'OrderByDirection!' },
  },
  RebateTemplatesPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  RebateTemplatesResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'RebateTemplate!' },
  },
  RecalculateClientSiteAggregates: {
    __typename: { __type: 'String!' },
    clientSitesUpdated: { __type: 'Float!' },
    durationMs: { __type: 'Float!' },
  },
  RecalculateClientSiteAggregatesInputInput: { siteIds: { __type: '[String!]!' } },
  RecommendedDnsRecord: {
    __typename: { __type: 'String!' },
    name: { __type: 'String!' },
    type: { __type: 'DnsRecordType!' },
    value: { __type: 'String!' },
  },
  RecurringInvoice: {
    __typename: { __type: 'String!' },
    amount: { __type: 'Numeric!' },
    anchorDate: { __type: 'String' },
    beneficiaryId: { __type: 'ID' },
    billingCycleAmount: { __type: 'Float!' },
    billingCycleUnit: { __type: 'String!' },
    canceledAt: { __type: 'String' },
    clientId: { __type: 'ID!' },
    clientPaymentMethodId: { __type: 'ID' },
    createdAt: { __type: 'String!' },
    currency: { __type: 'Currency!' },
    discountType: { __type: 'DiscountType' },
    discountValue: { __type: 'Numeric' },
    endDate: { __type: 'String' },
    initialInvoiceId: { __type: 'String!' },
    isImported: { __type: 'Boolean!' },
    lastGeneratedSequence: { __type: 'Float' },
    lastInvoiceDate: { __type: 'String' },
    lastInvoiceId: { __type: 'ID' },
    name: { __type: 'String!' },
    nextInvoiceDate: { __type: 'String!' },
    promoCodeDiscountSnapshot: { __type: 'RecurringInvoiceWithClientPromoCodeDiscountSnapshot' },
    promoCodeId: { __type: 'ID' },
    recurringInvoiceId: { __type: 'ID!' },
    serviceId: { __type: 'ID!' },
    siteId: { __type: 'ID!' },
    status: { __type: 'RecurringInvoiceStatus!' },
    suspendedUntil: { __type: 'String' },
    taxSettingIds: { __type: '[ID!]' },
    taxSettingsSnapshot: { __type: '[InvoiceItemsTaxCalculationsTaxSetting!]' },
    type: { __type: 'RecurringInvoiceType!' },
  },
  RecurringInvoiceResultRow: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'RecurringInvoiceWithClient!' },
  },
  RecurringInvoiceWithClient: {
    __typename: { __type: 'String!' },
    addOnAmount: { __type: 'Numeric' },
    amount: { __type: 'Numeric!' },
    anchorDate: { __type: 'String' },
    beneficiaryId: { __type: 'ID' },
    billingCycleAmount: { __type: 'Float!' },
    billingCycleUnit: { __type: 'String!' },
    canceledAt: { __type: 'String' },
    client: { __type: 'RecurringInvoiceWithClientClient' },
    clientId: { __type: 'ID!' },
    clientPaymentMethodId: { __type: 'ID' },
    createdAt: { __type: 'String!' },
    currency: { __type: 'Currency!' },
    discountType: { __type: 'DiscountType' },
    discountValue: { __type: 'Numeric' },
    endDate: { __type: 'String' },
    initialInvoiceId: { __type: 'String!' },
    isImported: { __type: 'Boolean!' },
    isIndefinitelySuspended: { __type: 'Boolean' },
    lastGeneratedSequence: { __type: 'Float' },
    lastInvoiceDate: { __type: 'String' },
    lastInvoiceId: { __type: 'ID' },
    name: { __type: 'String!' },
    netAmount: { __type: 'Numeric' },
    nextInvoiceDate: { __type: 'String!' },
    nextPaymentDate: { __type: 'String' },
    nextSecondaryFeeAmount: { __type: 'Numeric' },
    nextSecondaryFeeDate: { __type: 'String' },
    promoCodeDiscountSnapshot: { __type: 'RecurringInvoiceWithClientPromoCodeDiscountSnapshot' },
    promoCodeId: { __type: 'ID' },
    recurringInvoiceId: { __type: 'ID!' },
    serviceId: { __type: 'ID!' },
    serviceOnHold: { __type: 'Boolean' },
    siteId: { __type: 'ID!' },
    status: { __type: 'RecurringInvoiceStatus!' },
    suspendedUntil: { __type: 'String' },
    taxSettingIds: { __type: '[ID!]' },
    taxSettingsSnapshot: { __type: '[InvoiceItemsTaxCalculationsTaxSetting!]' },
    type: { __type: 'RecurringInvoiceType!' },
  },
  RecurringInvoiceWithClientClient: {
    __typename: { __type: 'String!' },
    alerts: { __type: '[RecurringInvoiceWithClientClientAlerts!]' },
    clientId: { __type: 'ID!' },
    email: { __type: 'String' },
    firstName: { __type: 'String' },
    lastName: { __type: 'String' },
  },
  RecurringInvoiceWithClientClientAlerts: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'String!' },
    data: { __type: 'JSONObject' },
    requiresFetch: { __type: 'Boolean!' },
    type: { __type: 'String!' },
  },
  RecurringInvoiceWithClientPromoCodeDiscountSnapshot: {
    __typename: { __type: 'String!' },
    discountType: { __type: 'PromoCodeDiscountType!' },
    discountValue: { __type: 'String!' },
  },
  RecurringInvoicesPaginationResult: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'RecurringInvoicesPaginationResultPageInfo!' },
    results: { __type: '[RecurringInvoiceResultRow!]!' },
  },
  RecurringInvoicesPaginationResultPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  RecurringPatternBoundaries: {
    __typename: { __type: 'String!' },
    boundedSegmentEndDate: { __type: 'String' },
    clickedDate: { __type: 'String!' },
    downstreamSplits: { __type: '[RecurringPatternBoundariesDownstreamSplits!]!' },
    hasDownstreamSplits: { __type: 'Boolean!' },
    modifiedDownstreamSessionCount: { __type: 'Float!' },
    modifiedFutureSessionCount: { __type: 'Float!' },
    rootEndDate: { __type: 'String' },
  },
  RecurringPatternBoundariesDownstreamSplits: {
    __typename: { __type: 'String!' },
    durationMinutes: { __type: 'Float!' },
    endDate: { __type: 'String' },
    endTime: { __type: 'String!' },
    recurringSessionsId: { __type: 'String!' },
    startDate: { __type: 'String!' },
    startTime: { __type: 'String!' },
  },
  RecurringPaymentStats: {
    __typename: { __type: 'String!' },
    failedAmount: { __type: 'String!' },
    failedCount: { __type: 'Float!' },
    successfulAmount: { __type: 'String!' },
    successfulCount: { __type: 'Float!' },
  },
  RecurringServiceDetail: {
    __typename: { __type: 'String!' },
    activeSuspension: { __type: 'RecurringServiceDetailActiveSuspension' },
    activeSuspensions: { __type: '[RecurringServiceDetailActiveSuspensions!]' },
    amount: { __type: 'String' },
    autoRenew: { __type: 'Boolean!' },
    autoRenewServiceTemplateName: { __type: 'String' },
    bankLast4: { __type: 'String' },
    bankName: { __type: 'String' },
    beneficiaryId: { __type: 'ID' },
    billingCycleAmount: { __type: 'Float' },
    billingCycleUnit: { __type: 'String' },
    cardBrand: { __type: 'String' },
    cardLast4: { __type: 'String' },
    clientEmail: { __type: 'String' },
    clientFirstName: { __type: 'String' },
    clientId: { __type: 'ID!' },
    clientLastName: { __type: 'String' },
    createdByInvoiceId: { __type: 'ID' },
    currency: { __type: 'String!' },
    discountAmount: { __type: 'String' },
    discountReason: { __type: 'String' },
    earliestCancelDate: { __type: 'String' },
    expiresAt: { __type: 'String' },
    inclusiveTaxAmount: { __type: 'String' },
    itemOriginalAmount: { __type: 'String' },
    itemTotalAmount: { __type: 'String' },
    lastInvoiceDate: { __type: 'String' },
    nextInvoiceDate: { __type: 'String' },
    onHold: { __type: 'Boolean' },
    payerClientId: { __type: 'ID' },
    payerName: { __type: 'String' },
    planChangedByStaffName: { __type: 'String' },
    processedByStaffName: { __type: 'String' },
    processedByStaffUserId: { __type: 'ID' },
    purchasedAt: { __type: 'String!' },
    recurringInvoiceId: { __type: 'ID' },
    recurringInvoiceStatus: { __type: 'String' },
    referredByStaffName: { __type: 'String' },
    referredByStaffUserId: { __type: 'ID' },
    scheduledCancellation: { __type: 'RecurringServiceDetailScheduledCancellation' },
    scheduledFeeInvoices: { __type: '[RecurringServiceDetailScheduledFeeInvoices!]' },
    scheduledSuspension: { __type: 'RecurringServiceDetailScheduledSuspension' },
    scheduledSuspensions: { __type: '[RecurringServiceDetailScheduledSuspensions!]' },
    secondaryFee: { __type: 'RecurringServiceDetailSecondaryFee' },
    serviceFirstBillingDate: { __type: 'String' },
    serviceId: { __type: 'ID!' },
    serviceName: { __type: 'String!' },
    serviceStatus: { __type: 'String!' },
    serviceTemplateId: { __type: 'ID!' },
    setupFee: { __type: 'String' },
    setupFeeExclusiveTaxAmount: { __type: 'String' },
    setupFeeInclusiveTaxAmount: { __type: 'String' },
    siteId: { __type: 'ID!' },
    siteSessionTypeIds: { __type: '[ID!]' },
    siteTimezone: { __type: 'String' },
    soldBillingCycleUnit: { __type: 'String' },
    soldBillingDay: { __type: 'Float' },
    startsAt: { __type: 'String!' },
    taxAmount: { __type: 'String' },
    wallet: { __type: 'PaymentWallet' },
  },
  RecurringServiceDetailActiveSuspension: {
    __typename: { __type: 'String!' },
    endDate: { __type: 'String' },
    scheduledRestartDate: { __type: 'String' },
    serviceSuspensionId: { __type: 'ID!' },
    startDate: { __type: 'String!' },
    suspensionReason: { __type: 'String' },
    suspensionType: { __type: 'ServiceSuspensionType!' },
  },
  RecurringServiceDetailActiveSuspensions: {
    __typename: { __type: 'String!' },
    endDate: { __type: 'String' },
    scheduledRestartDate: { __type: 'String' },
    serviceSuspensionId: { __type: 'ID!' },
    startDate: { __type: 'String!' },
    suspensionReason: { __type: 'String' },
    suspensionType: { __type: 'ServiceSuspensionType!' },
  },
  RecurringServiceDetailScheduledCancellation: {
    __typename: { __type: 'String!' },
    cancellationDate: { __type: 'String!' },
    cancellationReason: { __type: 'String' },
    serviceCancellationId: { __type: 'ID!' },
  },
  RecurringServiceDetailScheduledFeeInvoices: {
    __typename: { __type: 'String!' },
    actionType: { __type: 'ServiceActionType!' },
    amount: { __type: 'String!' },
    currency: { __type: 'String!' },
    dueDate: { __type: 'String!' },
    invoiceId: { __type: 'ID!' },
  },
  RecurringServiceDetailScheduledSuspension: {
    __typename: { __type: 'String!' },
    endDate: { __type: 'String' },
    serviceSuspensionId: { __type: 'ID!' },
    startDate: { __type: 'String!' },
    suspensionReason: { __type: 'String' },
    suspensionType: { __type: 'ServiceSuspensionType!' },
  },
  RecurringServiceDetailScheduledSuspensions: {
    __typename: { __type: 'String!' },
    endDate: { __type: 'String' },
    serviceSuspensionId: { __type: 'ID!' },
    startDate: { __type: 'String!' },
    suspensionReason: { __type: 'String' },
    suspensionType: { __type: 'ServiceSuspensionType!' },
  },
  RecurringServiceDetailSecondaryFee: {
    __typename: { __type: 'String!' },
    amount: { __type: 'String!' },
    billingCycleAmount: { __type: 'Float!' },
    billingCycleUnit: { __type: 'String!' },
    currency: { __type: 'String!' },
    name: { __type: 'String!' },
    recurringInvoiceId: { __type: 'ID!' },
    status: { __type: 'String!' },
  },
  RecurringSession: {
    __typename: { __type: 'String!' },
    allowOverlappingSessions: { __type: 'Boolean' },
    category: { __type: 'SessionCategory!' },
    createdAt: { __type: 'String!' },
    creditsRequired: { __type: 'Float!' },
    customFields: { __type: '[SessionTemplateCustomFields!]' },
    deletedAt: { __type: 'String' },
    description: { __type: 'String' },
    dropinPrice: { __type: 'Numeric!' },
    durationMinutes: { __type: 'Float!' },
    endAfterOccurrences: { __type: 'Float' },
    endDate: { __type: 'String' },
    endTime: { __type: 'String!' },
    isPaymentRequired: { __type: 'Boolean!' },
    isRequestBookingEnabled: { __type: 'Boolean!' },
    isRequiredSessionFeedback: { __type: 'Boolean!' },
    isRequiredTwoPartAuthentication: { __type: 'Boolean!' },
    isRoomResourceEnabled: { __type: 'Boolean!' },
    itemsSupplied: { __type: 'String' },
    itemsToBring: { __type: 'String' },
    lastGeneratedUntilDate: { __type: 'String' },
    lateCancelFeeId: { __type: 'String' },
    lateCancelFeeMode: { __type: 'SessionFeeMode!' },
    name: { __type: 'String!' },
    noShowFeeId: { __type: 'String' },
    noShowFeeMode: { __type: 'SessionFeeMode!' },
    recurrenceDayOfMonth: { __type: 'Float' },
    recurrenceDaysOfWeek: { __type: '[DayOfWeek!]' },
    recurrenceInterval: { __type: 'Float!' },
    recurrenceType: { __type: 'RecurrenceType!' },
    recurringSessionsId: { __type: 'String!' },
    revenueTagId: { __type: 'String' },
    rootRecurringSessionsId: { __type: 'String' },
    sessionImage: { __type: 'SessionTemplateSessionImage' },
    sessionTemplateId: { __type: 'String' },
    siteId: { __type: 'String!' },
    siteLocationId: { __type: 'String!' },
    siteLocationRoomId: { __type: 'String' },
    siteSessionTypeId: { __type: 'String!' },
    size: { __type: 'Float!' },
    staffUserIds: { __type: '[String!]' },
    startDate: { __type: 'String!' },
    startTime: { __type: 'String!' },
    status: { __type: 'RecurringSessionStatus!' },
    taxEnabled: { __type: 'Boolean!' },
    taxSettingIds: { __type: '[String!]' },
    updatedAt: { __type: 'String!' },
    waitlistEnabled: { __type: 'Boolean!' },
    waitlistSize: { __type: 'Float' },
  },
  RecurringSessionCreateFromTemplateInput: {
    durationMinutes: { __type: 'Float' },
    endAfterOccurrences: { __type: 'Float' },
    endDate: { __type: 'String' },
    endTime: { __type: 'String' },
    isRoomResourceEnabled: { __type: 'Boolean' },
    lateCancelFeeId: { __type: 'String' },
    lateCancelFeeMode: { __type: 'SessionFeeMode' },
    noShowFeeId: { __type: 'String' },
    noShowFeeMode: { __type: 'SessionFeeMode' },
    recurrenceDayOfMonth: { __type: 'Float' },
    recurrenceDaysOfWeek: { __type: '[DayOfWeek!]' },
    recurrenceInterval: { __type: 'Float!' },
    recurrenceType: { __type: 'RecurrenceType!' },
    revenueTagId: { __type: 'String' },
    sessionTemplateId: { __type: 'String!' },
    siteId: { __type: 'String!' },
    siteLocationId: { __type: 'String' },
    siteLocationRoomId: { __type: 'String' },
    size: { __type: 'Float' },
    staffUserIds: { __type: '[String!]' },
    startDate: { __type: 'String!' },
    startTime: { __type: 'String!' },
    status: { __type: 'RecurringSessionStatus' },
  },
  RecurringSessionCreateInput: {
    allowOverlappingSessions: { __type: 'Boolean' },
    category: { __type: 'SessionCategory!' },
    creditsRequired: { __type: 'Float!' },
    customFields: { __type: '[SessionTemplateCustomFieldsInput!]' },
    description: { __type: 'String' },
    dropinPrice: { __type: 'Numeric!' },
    durationMinutes: { __type: 'Float!' },
    endAfterOccurrences: { __type: 'Float' },
    endDate: { __type: 'String' },
    endTime: { __type: 'String!' },
    isPaymentRequired: { __type: 'Boolean!' },
    isRequestBookingEnabled: { __type: 'Boolean!' },
    isRequiredSessionFeedback: { __type: 'Boolean!' },
    isRequiredTwoPartAuthentication: { __type: 'Boolean!' },
    isRoomResourceEnabled: { __type: 'Boolean' },
    itemsSupplied: { __type: 'String' },
    itemsToBring: { __type: 'String' },
    lateCancelFeeId: { __type: 'String' },
    lateCancelFeeMode: { __type: 'SessionFeeMode' },
    name: { __type: 'String!' },
    noShowFeeId: { __type: 'String' },
    noShowFeeMode: { __type: 'SessionFeeMode' },
    recurrenceDayOfMonth: { __type: 'Float' },
    recurrenceDaysOfWeek: { __type: '[DayOfWeek!]' },
    recurrenceInterval: { __type: 'Float!' },
    recurrenceType: { __type: 'RecurrenceType!' },
    revenueTagId: { __type: 'String' },
    rootRecurringSessionsId: { __type: 'String' },
    sessionImage: { __type: 'SessionTemplateSessionImageInput' },
    sessionTemplateId: { __type: 'String' },
    siteId: { __type: 'String!' },
    siteLocationId: { __type: 'String!' },
    siteLocationRoomId: { __type: 'String' },
    siteSessionTypeId: { __type: 'String!' },
    size: { __type: 'Float!' },
    staffUserIds: { __type: '[String!]' },
    startDate: { __type: 'String!' },
    startTime: { __type: 'String!' },
    status: { __type: 'RecurringSessionStatus!' },
    taxEnabled: { __type: 'Boolean!' },
    taxSettingIds: { __type: '[String!]' },
    waitlistEnabled: { __type: 'Boolean!' },
    waitlistSize: { __type: 'Float' },
  },
  RecurringSessionInstance: {
    __typename: { __type: 'String!' },
    availableSpots: { __type: 'Float!' },
    capacity: { __type: 'Float!' },
    currentBooked: { __type: 'Float!' },
    currentWaitlisted: { __type: 'Float!' },
    date: { __type: 'String!' },
    dayOfWeek: { __type: 'String!' },
    endTime: { __type: 'String!' },
    isBookable: { __type: 'Boolean!' },
    sessionId: { __type: 'String!' },
    startTime: { __type: 'String!' },
    waitlistEnabled: { __type: 'Boolean!' },
    waitlistSize: { __type: 'Float' },
  },
  RecurringSessionInstancesResponse: {
    __typename: { __type: 'String!' },
    instances: { __type: '[RecurringSessionInstance!]!' },
    recurrenceDaysOfWeek: { __type: '[String!]!' },
  },
  RedeemGiftCard: {
    __typename: { __type: 'String!' },
    giftCardId: { __type: 'String!' },
    newAccountBalance: { __type: 'String!' },
    redeemedAmount: { __type: 'String!' },
  },
  RedriveMemberMovementHomeSiteResult: {
    __typename: { __type: 'String!' },
    homeSiteResolved: { __type: 'Boolean!' },
    memberMovementId: { __type: 'ID!' },
    status: { __type: 'String!' },
  },
  ReferredBy: { __typename: { __type: 'String!' }, referredByClientId: { __type: 'String' } },
  RefreshArticlesOnlyResult: {
    __typename: { __type: 'String!' },
    articleRefresh: { __type: 'ArticleRefreshStats!' },
    durationMs: { __type: 'Int!' },
    errors: { __type: '[String!]!' },
    success: { __type: 'Boolean!' },
  },
  RefreshCodebaseResult: {
    __typename: { __type: 'String!' },
    articleRefresh: { __type: 'ArticleRefreshStats!' },
    codebaseSync: { __type: 'CodebaseSyncStats!' },
    durationMs: { __type: 'Int!' },
    errors: { __type: '[String!]!' },
    success: { __type: 'Boolean!' },
    vertexImport: { __type: 'VertexImportStats!' },
  },
  RefreshStripeStatusResult: {
    __typename: { __type: 'String!' },
    sitePaymentGateway: { __type: 'RefreshStripeStatusResultSitePaymentGateway!' },
  },
  RefreshStripeStatusResultSitePaymentGateway: {
    __typename: { __type: 'String!' },
    onboardingStatus: { __type: 'SitePaymentGatewayOnboardingStatus!' },
    sitePaymentGatewayId: { __type: 'ID!' },
  },
  Refund: {
    __typename: { __type: 'String!' },
    allocationMethod: { __type: 'RefundAllocationMethod' },
    amount: { __type: 'Numeric!' },
    attemptNumber: { __type: 'Float!' },
    cashDrawerSessionId: { __type: 'ID' },
    clientId: { __type: 'ID' },
    connectedAccountRefundId: { __type: 'String' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'String' },
    currency: { __type: 'Currency!' },
    disputeId: { __type: 'ID' },
    externalRefundId: { __type: 'String' },
    failureCategory: { __type: 'FailureCategory' },
    feeItemsRefunded: { __type: '[RefundedFeeItem!]!' },
    gatewayType: { __type: 'SupportedPaymentGateway' },
    idempotencyKey: { __type: 'ID' },
    invoiceId: { __type: 'ID!' },
    itemAllocations: { __type: '[RefundItemAllocation!]!' },
    origin: { __type: 'RefundOrigin!' },
    paymentGatewayTransactionId: { __type: 'ID' },
    paymentId: { __type: 'ID!' },
    processedAt: { __type: 'String' },
    providerAccountId: { __type: 'ID' },
    rawErrorCode: { __type: 'String' },
    rawErrorMessage: { __type: 'String' },
    reason: { __type: 'String!' },
    refundId: { __type: 'ID!' },
    refundMethod: { __type: 'RefundType!' },
    requiresPayout: { __type: 'Boolean' },
    retryOfRefundId: { __type: 'ID' },
    siteId: { __type: 'ID!' },
    status: { __type: 'RefundStatus!' },
    taxAmount: { __type: 'Numeric' },
    updatedAt: { __type: 'String!' },
  },
  RefundItemAllocation: {
    __typename: { __type: 'String!' },
    amount: { __type: 'Numeric!' },
    createdAt: { __type: 'String!' },
    currency: { __type: 'Currency!' },
    exTaxAmount: { __type: 'Numeric!' },
    invoiceId: { __type: 'ID!' },
    invoiceItemId: { __type: 'ID!' },
    refundId: { __type: 'ID!' },
    refundItemAllocationId: { __type: 'ID!' },
    siteId: { __type: 'ID!' },
    taxAmount: { __type: 'Numeric!' },
    taxCalculations: { __type: '[RefundItemAllocationTaxCalculation!]!' },
  },
  RefundItemAllocationTaxCalculation: {
    __typename: { __type: 'String!' },
    amount: { __type: 'Numeric!' },
    taxSetting: { __type: 'RefundItemAllocationTaxSetting!' },
  },
  RefundItemAllocationTaxSetting: {
    __typename: { __type: 'String!' },
    amount: { __type: 'Numeric!' },
    name: { __type: 'String!' },
    taxSettingId: { __type: 'String!' },
    type: { __type: 'TaxSettingType!' },
  },
  RefundReasonsBulkUpdateInput: {
    refundReasons: { __type: '[RefundReasonsBulkUpdateRefundReasonsInput!]!' },
  },
  RefundReasonsBulkUpdateRefundReasonsInput: {
    createdAt: { __type: 'String' },
    enabled: { __type: 'Boolean!' },
    id: { __type: 'String' },
    reason: { __type: 'String!' },
    updatedAt: { __type: 'String' },
  },
  RefundedFeeItem: {
    __typename: { __type: 'String!' },
    amount: { __type: 'Numeric!' },
    pricingCode: { __type: 'RefundableGatewayFeeCode!' },
  },
  Regions: {
    __typename: { __type: 'String!' },
    country: { __type: 'RegionsCountry' },
    countryId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    latitude: { __type: 'Float' },
    longitude: { __type: 'Float' },
    name: { __type: 'String!' },
    regionId: { __type: 'ID!' },
    sitesCount: { __type: 'Float!' },
    updatedAt: { __type: 'String!' },
    zone: { __type: 'RegionsZone' },
    zoneId: { __type: 'ID' },
  },
  RegionsCountry: {
    __typename: { __type: 'String!' },
    countryId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    currencyCode: { __type: 'String' },
    isoCode: { __type: 'String' },
    isoCodeExtended: { __type: 'String' },
    name: { __type: 'String' },
    phoneCode: { __type: 'Float' },
    stripeConfig: { __type: 'RegionsCountryStripeConfig' },
    updatedAt: { __type: 'String!' },
  },
  RegionsCountryStripeConfig: {
    __typename: { __type: 'String!' },
    agreementType: { __type: 'StripeAgreementType!' },
    onBehalfOf: { __type: 'Boolean!' },
  },
  RegionsZone: {
    __typename: { __type: 'String!' },
    code: { __type: 'String!' },
    countryId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    name: { __type: 'String!' },
    timezone: { __type: 'String' },
    updatedAt: { __type: 'String!' },
    zoneId: { __type: 'ID!' },
  },
  RegisterDeviceTokenInput: {
    appVersion: { __type: 'String' },
    deviceInfo: { __type: 'String' },
    deviceToken: { __type: 'String!' },
    platform: { __type: 'DevicePlatform!' },
  },
  RegisterDeviceTokenResponse: {
    __typename: { __type: 'String!' },
    deviceTokenId: { __type: 'String' },
    error: { __type: 'String' },
    success: { __type: 'Boolean!' },
  },
  RegisterDomainInput: {
    customReturnPath: { __type: 'String' },
    domain: { __type: 'String!' },
    fromLocalPart: { __type: 'String!' },
    region: { __type: 'String' },
  },
  ReinitiateIncomingMovementInput: {
    destinationServiceTemplateId: { __type: 'ID' },
    memberMovementId: { __type: 'ID!' },
  },
  ReinitiateIncomingMovementResult: {
    __typename: { __type: 'String!' },
    blockedReason: { __type: 'MemberMovementBlockedReason' },
    error: { __type: 'String' },
    memberMovementId: { __type: 'ID!' },
    outcome: { __type: 'String!' },
  },
  ReinstateInvoiceInput: { invoiceId: { __type: 'ID!' }, newDueDate: { __type: 'String' } },
  ReleaseHubAvailability: {
    __typename: { __type: 'String!' },
    kind: { __type: 'ReleaseHubAvailabilityKind!' },
    requiredPlan: { __type: 'String' },
    requiredTheme: { __type: 'String' },
  },
  ReleaseHubMonthCount: {
    __typename: { __type: 'String!' },
    count: { __type: 'Int!' },
    month: { __type: 'String!' },
  },
  ReleaseHubNote: {
    __typename: { __type: 'String!' },
    area: { __type: 'String' },
    articles: { __type: '[HelpDocSummary!]!' },
    availability: { __type: 'ReleaseHubAvailability!' },
    bullets: { __type: '[String!]!' },
    capabilityKey: { __type: 'String' },
    highlights: { __type: '[String!]!' },
    lead: { __type: 'String' },
    related: { __type: '[ReleaseHubNote!]!' },
    releaseNoteId: { __type: 'ID!' },
    releaseType: { __type: 'ReleaseHubType!' },
    releasedAt: { __type: 'String' },
    scopeLevel: { __type: 'ReleaseHubScope!' },
    screenshots: { __type: '[ReleaseHubScreenshot!]!' },
    slug: { __type: 'String!' },
    stage: { __type: 'ReleaseHubStage!' },
    title: { __type: 'String!' },
    tldr: { __type: 'String!' },
    whoImpacted: { __type: 'String' },
  },
  ReleaseHubRail: {
    __typename: { __type: 'String!' },
    comingSoonCount: { __type: 'Int!' },
    months: { __type: '[ReleaseHubMonthCount!]!' },
  },
  ReleaseHubScreenshot: {
    __typename: { __type: 'String!' },
    alt: { __type: 'String!' },
    caption: { __type: 'String!' },
    url: { __type: 'String!' },
  },
  ReleaseNote: {
    __typename: { __type: 'String!' },
    contentMarkdown: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'String!' },
    isRead: { __type: 'Boolean' },
    permissionTags: { __type: '[String!]' },
    publishedAt: { __type: 'String' },
    releaseNoteId: { __type: 'ID!' },
    releaseType: { __type: 'ReleaseNoteType!' },
    roleTags: { __type: '[String!]' },
    slug: { __type: 'String!' },
    status: { __type: 'ReleaseNoteStatus!' },
    summary: { __type: 'String' },
    tags: { __type: '[String!]' },
    tierTags: { __type: '[String!]' },
    title: { __type: 'String!' },
    translations: { __type: '[ReleaseNoteTranslation!]' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'String' },
    version: { __type: 'String' },
  },
  ReleaseNoteCreateInput: {
    contentMarkdown: { __type: 'String!' },
    permissionTags: { __type: '[String!]' },
    releaseType: { __type: 'ReleaseNoteType!' },
    roleTags: { __type: '[String!]' },
    slug: { __type: 'String!' },
    status: { __type: 'ReleaseNoteStatus' },
    summary: { __type: 'String' },
    tags: { __type: '[String!]' },
    tierTags: { __type: '[String!]' },
    title: { __type: 'String!' },
    version: { __type: 'String' },
  },
  ReleaseNoteFilterInput: {
    includeDeleted: { __type: 'Boolean' },
    permissionTags: { __type: '[String!]' },
    releaseType: { __type: 'ReleaseNoteType' },
    roleTags: { __type: '[String!]' },
    search: { __type: 'String' },
    status: { __type: 'ReleaseNoteStatus' },
    tags: { __type: '[String!]' },
    tierTags: { __type: '[String!]' },
  },
  ReleaseNoteReadStatus: {
    __typename: { __type: 'String!' },
    readAt: { __type: 'String!' },
    releaseNoteId: { __type: 'String!' },
    userId: { __type: 'String!' },
  },
  ReleaseNoteStats: {
    __typename: { __type: 'String!' },
    byStatus: { __type: 'JSON!' },
    total: { __type: 'Int!' },
  },
  ReleaseNoteTranslation: {
    __typename: { __type: 'String!' },
    contentMarkdown: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    locale: { __type: 'String!' },
    releaseNoteId: { __type: 'String!' },
    status: { __type: 'ReleaseNoteTranslationStatus!' },
    summary: { __type: 'String' },
    title: { __type: 'String!' },
    translatedAt: { __type: 'String' },
    translationId: { __type: 'ID!' },
    updatedAt: { __type: 'String!' },
  },
  ReleaseNoteTranslationInput: {
    contentMarkdown: { __type: 'String!' },
    locale: { __type: 'String!' },
    summary: { __type: 'String' },
    title: { __type: 'String!' },
  },
  ReleaseNoteUpdateInput: {
    contentMarkdown: { __type: 'String' },
    permissionTags: { __type: '[String!]' },
    releaseType: { __type: 'ReleaseNoteType' },
    roleTags: { __type: '[String!]' },
    slug: { __type: 'String' },
    status: { __type: 'ReleaseNoteStatus' },
    summary: { __type: 'String' },
    tags: { __type: '[String!]' },
    tierTags: { __type: '[String!]' },
    title: { __type: 'String' },
    version: { __type: 'String' },
  },
  ReleaseNotesResponse: {
    __typename: { __type: 'String!' },
    releaseNotes: { __type: '[ReleaseNote!]!' },
    total: { __type: 'Int!' },
  },
  ReleaseTerminalPayment: {
    __typename: { __type: 'String!' },
    outcome: { __type: 'ReleaseTerminalPaymentOutcome!' },
  },
  RemapMemberMovementsLikeForLikeInput: {
    corporateId: { __type: 'ID!' },
    destinationServiceTemplateId: { __type: 'ID!' },
    persistMapping: { __type: 'Boolean' },
    runId: { __type: 'ID!' },
    sourceMovementId: { __type: 'ID!' },
  },
  RemapMemberMovementsLikeForLikeResult: {
    __typename: { __type: 'String!' },
    mappingSaved: { __type: 'Boolean!' },
    movementIds: { __type: '[ID!]!' },
    reviewed: { __type: 'Float!' },
  },
  RemoveBrandStoreTester: {
    __typename: { __type: 'String!' },
    brandId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    email: { __type: 'String!' },
    name: { __type: 'String' },
    platforms: { __type: '[BrandPlatform!]!' },
    source: { __type: 'BrandStoreTesterSource!' },
    testerId: { __type: 'String!' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'String' },
  },
  RemoveClientFromSiteResponse: {
    __typename: { __type: 'String!' },
    message: { __type: 'String' },
    success: { __type: 'Boolean!' },
  },
  RemoveEmailDomain: { __typename: { __type: 'String!' }, success: { __type: 'Boolean!' } },
  RemoveMySharedCreditRecipientInput: {
    recipientClientId: { __type: 'ID!' },
    serviceId: { __type: 'ID!' },
  },
  RemoveSmsPackage: { __typename: { __type: 'String!' }, success: { __type: 'Boolean!' } },
  RenameDevice: {
    __typename: { __type: 'String!' },
    deviceTokenId: { __type: 'String!' },
    label: { __type: 'String' },
  },
  ReorderCorporateFaqInput: {
    corporateFaqId: { __type: 'String!' },
    displayOrder: { __type: 'Float!' },
  },
  ReorderCorporateFaqsInput: { faqs: { __type: '[ReorderCorporateFaqInput!]!' } },
  ReorderCorporateFaqsResponse: {
    __typename: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  ReorderPosCategoriesInput: { categories: { __type: '[ReorderPosCategoryInput!]!' } },
  ReorderPosCategoriesResponse: {
    __typename: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  ReorderPosCategoryInput: { displayOrder: { __type: 'Int!' }, posCategoryId: { __type: 'ID!' } },
  ReorderServiceTemplateCategoriesInput: {
    categories: { __type: '[ReorderServiceTemplateCategoryInput!]!' },
  },
  ReorderServiceTemplateCategoriesResponse: {
    __typename: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  ReorderServiceTemplateCategoryInput: {
    displayOrder: { __type: 'Int!' },
    serviceTemplateCategoryId: { __type: 'ID!' },
  },
  ReorderSessionTemplatesInput: {
    offset: { __type: 'Float!' },
    sessionTemplateIds: { __type: '[String!]!' },
  },
  ReorderSessionTemplatesResult: {
    __typename: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  ReorderSiteSessionTypeInput: {
    displayOrder: { __type: 'Float!' },
    siteSessionTypeId: { __type: 'String!' },
  },
  ReorderSiteSessionTypesInput: { sessionTypes: { __type: '[ReorderSiteSessionTypeInput!]!' } },
  ReorderSiteSessionTypesResponse: {
    __typename: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  ReplaceExternalMediaAssetInputInput: {
    contentMediaId: { __type: 'ID!' },
    fileName: { __type: 'String!' },
    mimeType: { __type: 'ReplaceExternalVideoMimeType!' },
    url: { __type: 'String!' },
  },
  ReplaceMediaAssetInputInput: {
    contentMediaId: { __type: 'ID!' },
    fileName: { __type: 'String!' },
    fileSize: { __type: 'Float' },
    mimeType: { __type: 'String!' },
  },
  ReplayBlockedMovementItemResult: {
    __typename: { __type: 'String!' },
    blockedReason: { __type: 'String' },
    memberMovementId: { __type: 'ID!' },
    outcome: { __type: 'String!' },
  },
  ReplayBlockedMovementsInput: {
    corporateId: { __type: 'ID!' },
    mappingFix: { __type: '[MemberMovementReplayMappingFixInput!]' },
    movementIds: { __type: '[ID!]!' },
  },
  ReplayBlockedMovementsResult: {
    __typename: { __type: 'String!' },
    replayed: { __type: 'Float!' },
    results: { __type: '[ReplayBlockedMovementItemResult!]!' },
    skipped: { __type: 'Float!' },
    stillBlocked: { __type: 'Float!' },
    total: { __type: 'Float!' },
  },
  ReportDefinition: {
    __typename: { __type: 'String!' },
    allowFutureDates: { __type: 'Boolean' },
    brandOnly: { __type: 'Boolean' },
    columns: { __type: '[ReportDefinitionColumns!]!' },
    dateRangeDirection: { __type: 'DateRangeDirection' },
    defaultDateRangeDays: { __type: 'Float' },
    description: { __type: 'String!' },
    disablePast: { __type: 'Boolean' },
    filters: { __type: '[ReportDefinitionFilters!]!' },
    isAggregated: { __type: 'Boolean!' },
    label: { __type: 'String!' },
    locked: { __type: 'Boolean' },
    lockedFeatureKey: { __type: 'String' },
    name: { __type: 'ReportName!' },
    permissionCategory: { __type: 'ReportPermissionCategory!' },
    requiresDateRange: { __type: 'Boolean!' },
  },
  ReportDefinitionColumns: {
    __typename: { __type: 'String!' },
    companionOf: { __type: 'String' },
    defaultVisible: { __type: 'Boolean!' },
    filterable: { __type: 'Boolean' },
    format: { __type: 'ColumnFormat' },
    isRedacted: { __type: 'Boolean' },
    key: { __type: 'String!' },
    label: { __type: 'String!' },
    piiClassification: { __type: 'PiiClassification' },
    sortable: { __type: 'Boolean!' },
    tooltip: { __type: 'String' },
    type: { __type: 'String!' },
  },
  ReportDefinitionFilters: {
    __typename: { __type: 'String!' },
    defaultValue: { __type: 'String' },
    key: { __type: 'String!' },
    label: { __type: 'String!' },
    multiple: { __type: 'Boolean' },
    options: { __type: '[ReportDefinitionFiltersOptions!]' },
    required: { __type: 'Boolean' },
    templateTypes: { __type: '[String!]' },
    type: { __type: 'String!' },
  },
  ReportDefinitionFiltersOptions: {
    __typename: { __type: 'String!' },
    label: { __type: 'String!' },
    value: { __type: 'String!' },
  },
  ReportDefinitionInputInput: {
    filters: { __type: 'JSONObject' },
    reportName: { __type: 'ReportName!' },
    siteIds: { __type: '[String!]' },
  },
  ReportNotice: {
    __typename: { __type: 'String!' },
    code: { __type: 'String!' },
    level: { __type: 'ReportNoticeLevel!' },
    message: { __type: 'String!' },
  },
  ReportRowGroup: {
    __typename: { __type: 'String!' },
    breakdowns: { __type: '[ReportRowSegment!]!' },
    continuesFromPreviousPage: { __type: 'Boolean!' },
    continuesOnNextPage: { __type: 'Boolean!' },
    endIndex: { __type: 'Float!' },
    key: { __type: 'String!' },
    label: { __type: 'String!' },
    rowCount: { __type: 'Float!' },
    startIndex: { __type: 'Float!' },
    sublabel: { __type: 'String' },
    totals: { __type: 'JSONObject' },
  },
  ReportRowSegment: {
    __typename: { __type: 'String!' },
    continuesFromPreviousPage: { __type: 'Boolean!' },
    continuesOnNextPage: { __type: 'Boolean!' },
    endIndex: { __type: 'Float!' },
    key: { __type: 'String!' },
    label: { __type: 'String!' },
    rowCount: { __type: 'Float!' },
    startIndex: { __type: 'Float!' },
    totals: { __type: 'JSONObject' },
  },
  RequestFobCaptureInput: {
    clientId: { __type: 'ID!' },
    siteId: { __type: 'ID!' },
    widgetDeviceId: { __type: 'String!' },
  },
  RequestFobCaptureResult: {
    __typename: { __type: 'String!' },
    deviceTokenId: { __type: 'ID!' },
    expiresAt: { __type: 'String!' },
    requestId: { __type: 'ID!' },
  },
  ResetMemberExperienceBranding: {
    __typename: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  ResetMemberExperienceFonts: {
    __typename: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  ResetMemberExperienceSettings: {
    __typename: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  ResetToDefaults: { __typename: { __type: 'String!' }, success: { __type: 'Boolean!' } },
  ResolveMovementTemplate: {
    __typename: { __type: 'String!' },
    destinationServiceTemplateId: { __type: 'ID' },
    matchType: { __type: 'MemberMovementMappingMatchType' },
    unresolved: { __type: 'Boolean!' },
  },
  ResolvedCustomText: {
    __typename: { __type: 'String!' },
    customizationCount: { __type: 'Float!' },
    customizedKeys: { __type: '[String!]!' },
    language: { __type: 'String!' },
    overrides: { __type: 'JSONObject!' },
    totalCount: { __type: 'Float!' },
    translations: { __type: 'JSONObject!' },
  },
  ResolvedGiftCardExpiryPolicy: {
    __typename: { __type: 'String!' },
    countryId: { __type: 'String' },
    disclosureRequired: { __type: 'Boolean!' },
    expiryPermitted: { __type: 'Boolean!' },
    giftCardExpiryRuleId: { __type: 'ID' },
    legalCitation: { __type: 'String' },
    maximumTermMonths: { __type: 'Float' },
    minimumTermMonths: { __type: 'Float' },
    pendingReview: { __type: 'Boolean!' },
    source: { __type: 'GiftCardExpiryRuleSource!' },
    zoneId: { __type: 'String' },
  },
  ResolvedOpeningDay: {
    __typename: { __type: 'String!' },
    date: { __type: 'String!' },
    dayOfWeek: { __type: 'Int!' },
    exceptionLabel: { __type: 'String' },
    isClosed: { __type: 'Boolean!' },
    isOpen24Hours: { __type: 'Boolean!' },
    ranges: { __type: '[ResolvedOpeningRange!]!' },
  },
  ResolvedOpeningRange: {
    __typename: { __type: 'String!' },
    closesAt: { __type: 'String!' },
    opensAt: { __type: 'String!' },
  },
  RestartEquipmentAssignmentResult: {
    __typename: { __type: 'String!' },
    assignment: { __type: 'EquipmentAssignment!' },
    complianceWarnings: { __type: '[EquipmentComplianceWarning!]!' },
    equipment: { __type: 'Equipment!' },
    outcome: { __type: 'RestartEquipmentAssignmentOutcome!' },
  },
  RetryFormWorkflowEffectsResponse: {
    __typename: { __type: 'String!' },
    retriedCount: { __type: 'Float!' },
  },
  RetryMemberMovementPaymentMigrationInput: {
    corporateId: { __type: 'ID!' },
    memberMovementId: { __type: 'ID!' },
  },
  RetryMemberMovementPaymentMigrationResult: {
    __typename: { __type: 'String!' },
    paymentMigrationReason: { __type: 'String' },
    paymentMigrationStatus: { __type: 'String' },
  },
  RetryPayments: {
    __typename: { __type: 'String!' },
    originalPaymentId: { __type: 'ID!' },
    payment: { __type: 'Payment!' },
  },
  RetryPaymentsInputInput: { retries: { __type: '[RetryPaymentsRetriesInput!]!' } },
  RetryPaymentsRetriesInput: {
    amount: { __type: 'Numeric!' },
    canCompleteCardChallenge: { __type: 'Boolean' },
    canRecoverCardChallengeRemotely: { __type: 'Boolean' },
    clientPaymentMethodId: { __type: 'ID' },
    customPaymentMethodLabel: { __type: 'String' },
    paymentId: { __type: 'ID' },
    paymentMethodType: { __type: 'PaymentMethodType!' },
    saveForFutureUse: { __type: 'Boolean' },
    terminalReaderId: { __type: 'ID' },
    useTerminalCardForRecurring: { __type: 'Boolean' },
  },
  RevenueTagSnapshot: {
    __typename: { __type: 'String!' },
    revenueTagGlCode: { __type: 'String' },
    revenueTagId: { __type: 'ID' },
    revenueTagName: { __type: 'String' },
  },
  ReverseEquipmentAssignmentResult: {
    __typename: { __type: 'String!' },
    agentResetError: { __type: 'String' },
    assignment: { __type: 'EquipmentAssignment!' },
  },
  RevertMemberMovementResult: {
    __typename: { __type: 'String!' },
    destinationChargesTaken: { __type: '[MemberMovementDestinationCharge!]!' },
    destinationServiceId: { __type: 'ID' },
    homeSiteRestored: { __type: 'Boolean!' },
    memberMovementId: { __type: 'ID!' },
    reverted: { __type: 'Boolean!' },
    sourceServiceId: { __type: 'ID!' },
    status: { __type: 'String!' },
  },
  ReviewMemberMovementsInput: {
    corporateId: { __type: 'ID!' },
    decisions: { __type: '[MemberMovementReviewDecisionInput!]!' },
    runId: { __type: 'ID!' },
  },
  ReviewMemberMovementsResult: {
    __typename: { __type: 'String!' },
    reviewed: { __type: 'Float!' },
  },
  RevokeDevice: { __typename: { __type: 'String!' }, deviceTokenId: { __type: 'String!' } },
  RevokeFamilyAllocationInput: { clientId: { __type: 'ID!' }, serviceId: { __type: 'ID!' } },
  RevokeKioskSessions: { __typename: { __type: 'String!' }, kioskSessionId: { __type: 'String!' } },
  RolloverExpiredCreditsInput: {
    credits: { __type: 'Float!' },
    note: { __type: 'String' },
    siteId: { __type: 'ID!' },
    sourceServiceId: { __type: 'ID!' },
    targetServiceId: { __type: 'ID!' },
  },
  RolloverExpiredCreditsResult: {
    __typename: { __type: 'String!' },
    remainingExpiredCredits: { __type: 'Float!' },
    rolledOverCredits: { __type: 'Float!' },
    targetBalance: { __type: 'Float!' },
  },
  RoomResourceTemplateImage: {
    __typename: { __type: 'String!' },
    lastFailure: { __type: 'RoomResourceTemplateImageLastFailure' },
    pending: { __type: 'RoomResourceTemplateImagePending' },
    status: { __type: 'FileUploadConfigFieldStatus!' },
    versions: { __type: '[ImageFileVersion!]' },
  },
  RoomResourceTemplateImageLastFailure: {
    __typename: { __type: 'String!' },
    errorMessage: { __type: 'String!' },
    failedAt: { __type: 'String!' },
    tempUrl: { __type: 'String!' },
    uploadRequestedBy: { __type: 'ID!' },
  },
  RoomResourceTemplateImagePending: {
    __typename: { __type: 'String!' },
    status: { __type: 'FileUploadConfigFieldPendingStatus!' },
    tempUrl: { __type: 'String!' },
    uploadRequestedAt: { __type: 'String!' },
    uploadRequestedBy: { __type: 'ID!' },
  },
  RotateSiteWebhookSecret: { __typename: { __type: 'String!' }, secret: { __type: 'String!' } },
  RoyaltiesAndFeesTemplate: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'ID' },
    marketingFeeEnabled: { __type: 'Boolean!' },
    marketingFeePayoutAccountId: { __type: 'ID' },
    marketingFeeRate: { __type: 'Numeric' },
    name: { __type: 'String!' },
    royaltiesAndFeesTemplateId: { __type: 'ID!' },
    royaltyBaseMode: { __type: 'RoyaltyBaseMode' },
    royaltyFee1Enabled: { __type: 'Boolean!' },
    royaltyFee1PayoutAccountId: { __type: 'ID' },
    royaltyFee1Rate: { __type: 'Numeric' },
    royaltyFee2Enabled: { __type: 'Boolean!' },
    royaltyFee2PayoutAccountId: { __type: 'ID' },
    royaltyFee2Rate: { __type: 'Numeric' },
    sites: { __type: '[SitePreview!]!' },
    softwareFeeEnabled: { __type: 'Boolean!' },
    softwareFeePayoutAccountId: { __type: 'ID' },
    softwareFeeRate: { __type: 'Numeric' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'ID' },
  },
  RoyaltiesAndFeesTemplateInput: {
    marketingFee: { __type: 'RoyaltiesAndFeesTemplateRoyaltyFee1Input!' },
    name: { __type: 'String!' },
    royaltyBaseMode: { __type: 'RoyaltyBaseMode' },
    royaltyFee1: { __type: 'RoyaltiesAndFeesTemplateRoyaltyFee1Input!' },
    royaltyFee2: { __type: 'RoyaltiesAndFeesTemplateRoyaltyFee1Input!' },
    softwareFee: { __type: 'RoyaltiesAndFeesTemplateRoyaltyFee1Input!' },
  },
  RoyaltiesAndFeesTemplateRoyaltyFee1Input: {
    enabled: { __type: 'Boolean!' },
    payoutAccountId: { __type: 'ID' },
    rate: { __type: 'Numeric' },
  },
  RoyaltiesAndFeesTemplateUpdate: {
    marketingFee: { __type: 'RoyaltiesAndFeesTemplateRoyaltyFee1Input' },
    name: { __type: 'String' },
    royaltyBaseMode: { __type: 'RoyaltyBaseMode' },
    royaltyFee1: { __type: 'RoyaltiesAndFeesTemplateRoyaltyFee1Input' },
    royaltyFee2: { __type: 'RoyaltiesAndFeesTemplateRoyaltyFee1Input' },
    softwareFee: { __type: 'RoyaltiesAndFeesTemplateRoyaltyFee1Input' },
  },
  RoyaltiesAndFeesTemplates: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'RoyaltiesAndFeesTemplatesPageInfo!' },
    results: { __type: '[RoyaltiesAndFeesTemplatesResults!]!' },
  },
  RoyaltiesAndFeesTemplatesOrderByInput: {
    column: { __type: 'RoyaltiesAndFeesTemplateOrderBy!' },
    direction: { __type: 'OrderByDirection!' },
  },
  RoyaltiesAndFeesTemplatesPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  RoyaltiesAndFeesTemplatesResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'RoyaltiesAndFeesTemplate!' },
  },
  RunReport: {
    __typename: { __type: 'String!' },
    columns: { __type: '[ReportDefinitionColumns!]!' },
    dataAsOf: { __type: 'String' },
    isTruncated: { __type: 'Boolean' },
    maxExportRows: { __type: 'Float' },
    notices: { __type: '[ReportNotice!]' },
    pageInfo: { __type: 'RunReportPageInfo!' },
    piiRedactionApplied: { __type: 'Boolean' },
    redactedColumnKeys: { __type: '[String!]' },
    reportName: { __type: 'String!' },
    results: { __type: '[RunReportResults!]!' },
    rowGroups: { __type: '[ReportRowGroup!]' },
    totalsRow: { __type: 'JSONObject' },
  },
  RunReportInputInput: {
    columnFilters: { __type: 'JSONObject' },
    columns: { __type: '[String!]' },
    cursor: { __type: 'String' },
    dateFormat: { __type: 'String' },
    dateFrom: { __type: 'String' },
    dateTo: { __type: 'String' },
    filters: { __type: 'JSONObject' },
    numberFormat: { __type: 'String' },
    orderBy: { __type: '[RunReportOrderByInput!]' },
    page: { __type: 'Float' },
    pageSize: { __type: 'Float!' },
    reportName: { __type: 'ReportName' },
    savedReportId: { __type: 'String' },
    searchTerm: { __type: 'String' },
    siteIds: { __type: '[String!]' },
    timeFormat: { __type: 'String' },
  },
  RunReportOrderByInput: { column: { __type: 'String!' }, direction: { __type: 'SortDirection!' } },
  RunReportPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Float!' },
  },
  RunReportResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String' },
    row: { __type: 'JSONObject!' },
  },
  SaleFollowUpInput: {
    clientPaymentMethodId: { __type: 'ID!' },
    followsReaderCard: { __type: 'Boolean' },
    heldClientPaymentMethodId: { __type: 'ID' },
    heldPaymentId: { __type: 'ID' },
    joinInvoiceIds: { __type: '[ID!]!' },
    scheduleInvoiceIds: { __type: '[ID!]!' },
  },
  SandboxBrands: {
    __typename: { __type: 'String!' },
    hasNextPage: { __type: 'Boolean!' },
    results: { __type: '[SandboxBrandsResults!]!' },
    totalRecords: { __type: 'Float!' },
  },
  SandboxBrandsResults: {
    __typename: { __type: 'String!' },
    corporateId: { __type: 'String!' },
    hasSandbox: { __type: 'Boolean!' },
    isOrphaned: { __type: 'Boolean' },
    lastJobId: { __type: 'String' },
    lastJobKind: { __type: 'SandboxJobKind' },
    lastJobStatus: { __type: 'SandboxJobStatus' },
    lastMigratedAt: { __type: 'String' },
    name: { __type: 'String!' },
    sandboxDbId: { __type: 'String' },
    sandboxUrl: { __type: 'String' },
    status: { __type: 'String!' },
    urlPrefix: { __type: 'String!' },
  },
  SandboxMigrationJob: {
    __typename: { __type: 'String!' },
    brandName: { __type: 'String!' },
    brandSlug: { __type: 'String!' },
    completedAt: { __type: 'String' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'String!' },
    currentStep: { __type: 'SandboxStepName' },
    error: { __type: 'String' },
    jobId: { __type: 'String!' },
    startedAt: { __type: 'String' },
    status: { __type: 'SandboxJobStatus!' },
    steps: { __type: '[SandboxMigrationJobSteps!]!' },
    updatedAt: { __type: 'String!' },
  },
  SandboxMigrationJobSteps: {
    __typename: { __type: 'String!' },
    completedAt: { __type: 'String' },
    error: { __type: 'String' },
    name: { __type: 'SandboxStepName!' },
    progress: { __type: 'Float' },
    queuedAhead: { __type: 'Float' },
    queuedBehind: { __type: 'String' },
    report: { __type: 'SandboxStepReport' },
    startedAt: { __type: 'String' },
    status: { __type: 'SandboxStepStatus!' },
  },
  SandboxStepReport: {
    __typename: { __type: 'String!' },
    clientCounts: { __type: 'SandboxStepReportClientCounts!' },
    clients: { __type: '[SandboxStepReportClient!]!' },
    clientsTruncated: { __type: 'Boolean!' },
    corporateIdPatched: { __type: '[SandboxStepReportPatchedTable!]!' },
    corporateIdUnpatched: { __type: '[SandboxStepReportUnpatchedTable!]!' },
    warnings: { __type: '[String!]!' },
  },
  SandboxStepReportClient: {
    __typename: { __type: 'String!' },
    action: { __type: 'SandboxReportClientAction!' },
    clientId: { __type: 'ID!' },
    createdAt: { __type: 'String' },
    patchedColumns: { __type: '[SandboxAnonymisedClientColumn!]!' },
    source: { __type: 'ClientSource' },
  },
  SandboxStepReportClientCounts: {
    __typename: { __type: 'String!' },
    anonymisedCopyWritten: { __type: 'Float!' },
    anonymisedNonTestDomain: { __type: 'Float!' },
    keptTestAccount: { __type: 'Float!' },
  },
  SandboxStepReportPatchedTable: {
    __typename: { __type: 'String!' },
    copyWrittenCount: { __type: 'Float!' },
    copyWrittenIds: { __type: '[String!]!' },
    idsTruncated: { __type: 'Boolean!' },
    sandboxCreatedCount: { __type: 'Float!' },
    sandboxCreatedIds: { __type: '[String!]!' },
    table: { __type: 'String!' },
  },
  SandboxStepReportUnpatchedTable: {
    __typename: { __type: 'String!' },
    count: { __type: 'Float!' },
    ids: { __type: '[String!]!' },
    idsTruncated: { __type: 'Boolean!' },
    table: { __type: 'String!' },
  },
  SaveEquipmentExposureScheduleInput: {
    equipmentId: { __type: 'ID!' },
    formRevision: { __type: 'Int!' },
    note: { __type: 'String' },
    rows: { __type: '[EquipmentExposureScheduleRowInput!]!' },
  },
  SaveMovementTemplateMappingsMappingsInput: {
    destinationServiceTemplateId: { __type: 'ID!' },
    destinationSiteId: { __type: 'ID!' },
    sourceServiceTemplateId: { __type: 'ID!' },
    sourceSiteId: { __type: 'ID!' },
  },
  SaveScoredSiteFormFormInput: {
    defaultRequiredBefore: { __type: 'FormRequiredBefore!' },
    description: { __type: 'String!' },
    name: { __type: 'String!' },
    resultCustomPropertyId: { __type: 'ID' },
    resultPropertyMapping: { __type: 'JSONObject' },
    scoreBands: { __type: '[SaveScoredSiteFormFormScoreBandsInput!]' },
    scoringEnabled: { __type: 'Boolean!' },
    showResultOnProfile: { __type: 'Boolean!' },
    showResultToClient: { __type: 'Boolean!' },
  },
  SaveScoredSiteFormFormScoreBandsInput: {
    bandId: { __type: 'ID!' },
    description: { __type: 'String' },
    label: { __type: 'String!' },
    max: { __type: 'Float!' },
    min: { __type: 'Float!' },
  },
  SaveScoredSiteFormQuestionsInput: {
    excludeFromScore: { __type: 'Boolean!' },
    mustAnswerYes: { __type: 'Boolean!' },
    optionScores: { __type: '[Float!]' },
    options: { __type: '[String!]' },
    required: { __type: 'Boolean!' },
    siteCustomPropertyId: { __type: 'ID' },
    siteFormQuestionId: { __type: 'String' },
    title: { __type: 'String!' },
    type: { __type: 'SiteFormQuestionType!' },
  },
  SaveScoredSiteFormResult: {
    __typename: { __type: 'String!' },
    form: { __type: 'SiteForm!' },
    reissueCount: { __type: 'Float!' },
    revision: { __type: 'Float!' },
  },
  SavedBrandConfigVersion: {
    __typename: { __type: 'String!' },
    nativeFields: { __type: '[String!]!' },
    publicPayloadHash: { __type: 'String!' },
    requiresNativeRelease: { __type: 'Boolean!' },
    versionId: { __type: 'String!' },
  },
  SavedReport: {
    __typename: { __type: 'String!' },
    baseReportAvailable: { __type: 'Boolean!' },
    baseReportName: { __type: 'ReportName!' },
    categoryId: { __type: 'String' },
    columnLabels: { __type: 'JSONObject' },
    corporateId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    createdAtLevel: { __type: 'CreatedAtLevel!' },
    createdAtSiteId: { __type: 'String' },
    createdBy: { __type: 'String!' },
    description: { __type: 'String' },
    name: { __type: 'String!' },
    savedColumns: { __type: '[String!]' },
    savedDateRange: { __type: 'SavedReportsSavedDateRange' },
    savedFilters: { __type: 'JSONObject' },
    savedReportId: { __type: 'String!' },
    savedSiteIds: { __type: '[String!]' },
    savedSort: { __type: '[SavedReportsSavedSort!]' },
    sortOrder: { __type: 'Float!' },
    updatedAt: { __type: 'String!' },
    visibility: { __type: 'SavedReportVisibility!' },
    visibilityScope: { __type: 'VisibilityScope!' },
  },
  SavedReportCategories: {
    __typename: { __type: 'String!' },
    corporateId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    createdAtLevel: { __type: 'CreatedAtLevel!' },
    createdAtSiteId: { __type: 'String' },
    createdBy: { __type: 'String!' },
    name: { __type: 'String!' },
    savedReportCategoryId: { __type: 'String!' },
    sortOrder: { __type: 'Float!' },
    targeting: { __type: 'SavedReportsTargeting' },
    updatedAt: { __type: 'String!' },
    visibilityScope: { __type: 'VisibilityScope!' },
  },
  SavedReports: {
    __typename: { __type: 'String!' },
    baseReportAvailable: { __type: 'Boolean!' },
    baseReportName: { __type: 'ReportName!' },
    categoryId: { __type: 'String' },
    columnLabels: { __type: 'JSONObject' },
    corporateId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    createdAtLevel: { __type: 'CreatedAtLevel!' },
    createdAtSiteId: { __type: 'String' },
    createdBy: { __type: 'String!' },
    description: { __type: 'String' },
    name: { __type: 'String!' },
    savedColumns: { __type: '[String!]' },
    savedDateRange: { __type: 'SavedReportsSavedDateRange' },
    savedFilters: { __type: 'JSONObject' },
    savedReportId: { __type: 'String!' },
    savedSiteIds: { __type: '[String!]' },
    savedSort: { __type: '[SavedReportsSavedSort!]' },
    sortOrder: { __type: 'Float!' },
    targeting: { __type: 'SavedReportsTargeting' },
    updatedAt: { __type: 'String!' },
    visibility: { __type: 'SavedReportVisibility!' },
    visibilityScope: { __type: 'VisibilityScope!' },
  },
  SavedReportsSavedDateRange: {
    __typename: { __type: 'String!' },
    from: { __type: 'String' },
    to: { __type: 'String' },
    type: { __type: 'DateRangeType!' },
    value: { __type: 'String' },
  },
  SavedReportsSavedSort: {
    __typename: { __type: 'String!' },
    column: { __type: 'String!' },
    direction: { __type: 'SortDirection!' },
  },
  SavedReportsTargeting: {
    __typename: { __type: 'String!' },
    resolvedSiteCount: { __type: 'Float' },
    targets: { __type: '[SavedReportsTargetingTargets!]!' },
    visibilityScope: { __type: 'VisibilityScope!' },
  },
  SavedReportsTargetingTargets: {
    __typename: { __type: 'String!' },
    targetId: { __type: 'String!' },
    targetName: { __type: 'String' },
    targetType: { __type: 'TargetType!' },
  },
  ScanAuthorizationResult: {
    __typename: { __type: 'String!' },
    accessOnly: { __type: 'Boolean!' },
    allow: { __type: 'Boolean!' },
    checkInType: { __type: 'CheckInType' },
    failReason: { __type: 'CheckInAuditFailReason' },
    isReCheckin: { __type: 'Boolean!' },
  },
  ScheduleCorporateServiceTemplateInput: {
    corporateServiceTemplateId: { __type: 'ID!' },
    expectedVersion: { __type: 'Float!' },
    scheduleAuthorTimezone: { __type: 'String' },
    scheduleClock: { __type: 'BrandScheduleClock!' },
    scheduleWallTime: { __type: 'String!' },
  },
  ScheduleInvoiceInput: {
    accountCreditAmount: { __type: 'Numeric' },
    attachPaymentMethodOnly: { __type: 'Boolean' },
    clientPaymentMethodId: { __type: 'ID!' },
  },
  ScheduledInvoicesPageInfo: {
    __typename: { __type: 'String!' },
    currentPage: { __type: 'Float!' },
    hasNextPage: { __type: 'Boolean!' },
    hasPreviousPage: { __type: 'Boolean!' },
    pageSize: { __type: 'Float!' },
    totalPages: { __type: 'Float!' },
    totalRecords: { __type: 'Float!' },
  },
  ScheduledJob: {
    __typename: { __type: 'String!' },
    acceptsPayload: { __type: 'Boolean!' },
    cronExpression: { __type: 'String!' },
    description: { __type: 'String!' },
    handlerName: { __type: 'String!' },
    hasFlowChildren: { __type: 'Boolean!' },
    jobKey: { __type: 'String!' },
    lastRun: { __type: 'ScheduledJobRunSummary' },
    level: { __type: 'ScheduledJobLevel!' },
    manualTriggerSafety: { __type: 'ScheduledJobTriggerSafety!' },
    name: { __type: 'String!' },
    nextRun: { __type: 'String' },
    payloadSchema: { __type: 'String' },
    queueName: { __type: 'String!' },
    registered: { __type: 'Boolean!' },
    timezone: { __type: 'String!' },
  },
  ScheduledJobRun: {
    __typename: { __type: 'String!' },
    attempts: { __type: 'Float' },
    cloudLogsUrl: { __type: 'String!' },
    completedAt: { __type: 'String' },
    corporateId: { __type: 'String' },
    durationMs: { __type: 'Float' },
    error: { __type: 'String' },
    eventName: { __type: 'String!' },
    jobId: { __type: 'String!' },
    jobKey: { __type: 'String' },
    level: { __type: 'ScheduledJobLevel' },
    metadata: { __type: 'String' },
    parentJobId: { __type: 'String' },
    payload: { __type: 'String' },
    pipelineMode: { __type: 'String' },
    pipelineRunKey: { __type: 'String' },
    pipelineStep: { __type: 'String' },
    siteId: { __type: 'String' },
    startedAt: { __type: 'String!' },
    status: { __type: 'ScheduledJobRunStatus!' },
    triggerSource: { __type: 'ScheduledJobTriggerSource' },
  },
  ScheduledJobRunSummary: {
    __typename: { __type: 'String!' },
    attempts: { __type: 'Float' },
    completedAt: { __type: 'String' },
    durationMs: { __type: 'Float' },
    jobId: { __type: 'String!' },
    startedAt: { __type: 'String!' },
    status: { __type: 'ScheduledJobRunStatus!' },
  },
  ScheduledJobRunsResult: {
    __typename: { __type: 'String!' },
    runs: { __type: '[ScheduledJobRun!]!' },
    total: { __type: 'Float!' },
  },
  ScheduledJobStatus: {
    __typename: { __type: 'String!' },
    cron: { __type: 'String' },
    nextRun: { __type: 'String' },
    registered: { __type: 'Boolean!' },
    timezone: { __type: 'String' },
  },
  ScheduledPushAudiencePreview: {
    __typename: { __type: 'String!' },
    recipientCount: { __type: 'Float!' },
  },
  ScheduledPushSend: {
    __typename: { __type: 'String!' },
    audienceType: { __type: 'ScheduledPushAudienceType!' },
    createdAt: { __type: 'String!' },
    estimatedRecipientCount: { __type: 'Float!' },
    failureReason: { __type: 'ScheduledPushFailureReason' },
    message: { __type: 'String!' },
    recipientCount: { __type: 'Float' },
    scheduledPushSendId: { __type: 'ID!' },
    sendAt: { __type: 'String!' },
    sessionDate: { __type: 'String' },
    sessionId: { __type: 'ID' },
    siteId: { __type: 'ID!' },
    status: { __type: 'ScheduledPushSendStatus!' },
    timezone: { __type: 'String!' },
    title: { __type: 'String!' },
  },
  ScoringConversionPreview: {
    __typename: { __type: 'String!' },
    completedSubmissionCount: { __type: 'Float!' },
    pendingAssignmentCount: { __type: 'Float!' },
    siteFormId: { __type: 'String!' },
  },
  ScreenshotInput: {
    base64Data: { __type: 'String!' },
    contentType: { __type: 'String!' },
    filename: { __type: 'String!' },
  },
  SearchGoogleFonts: {
    __typename: { __type: 'String!' },
    fonts: { __type: '[SearchGoogleFontsFonts!]!' },
    limit: { __type: 'Float!' },
    offset: { __type: 'Float!' },
    total: { __type: 'Float!' },
  },
  SearchGoogleFontsFonts: {
    __typename: { __type: 'String!' },
    category: { __type: 'String!' },
    family: { __type: 'String!' },
    files: { __type: 'JSONObject!' },
    lastModified: { __type: 'String!' },
    subsets: { __type: '[String!]!' },
    variants: { __type: '[String!]!' },
    version: { __type: 'String!' },
  },
  SearchResult: {
    __typename: { __type: 'String!' },
    document: { __type: 'KnowledgeDocument!' },
    relevantSnippet: { __type: 'String!' },
    score: { __type: 'Float!' },
  },
  Self: {
    __typename: { __type: 'String!' },
    adminPermissions: { __type: '[AdminUserPermissions!]' },
    data: { __type: 'StaffUserData' },
    dateOfBirth: { __type: 'String' },
    email: { __type: 'String!' },
    favoriteReportNames: { __type: '[String!]' },
    favoriteSavedReportIds: { __type: '[ID!]' },
    favoriteSiteIds: { __type: '[ID!]' },
    firstName: { __type: 'String!' },
    gender: { __type: 'String' },
    id: { __type: 'String!' },
    lastName: { __type: 'String!' },
    phone: { __type: 'String' },
    profileImage: {
      __type: 'ImagePublicSignedUrl',
      __args: { input: 'ImagePublicSignedUrlInput!' },
    },
    siteData: { __type: 'SelfSiteData', __args: { siteId: 'ID!' } },
    staffUserPermissions: { __type: 'String' },
    type: { __type: 'UserType!' },
    updateProfileImage: {
      __type: 'GenerateFileUploadUrlResponse!',
      __args: { input: 'GenerateImagePublicSignedUrlInput!' },
    },
  },
  SelfSiteData: {
    __typename: { __type: 'String!' },
    defaultScheduleView: { __type: 'String' },
    isInstructor: { __type: 'Boolean!' },
    myScheduleRangeDays: { __type: 'Int' },
    workingHours: { __type: 'StaffUserDataWorkingHours' },
  },
  SendAgreementResponse: {
    __typename: { __type: 'String!' },
    message: { __type: 'String!' },
    publicUrl: { __type: 'String' },
    success: { __type: 'Boolean!' },
  },
  SendGuestPassInput: {
    recipientEmail: { __type: 'String' },
    recipientName: { __type: 'String' },
    recipientPhone: { __type: 'String' },
    serviceId: { __type: 'ID!' },
  },
  SendMessageEmailOptionsInput: {
    from: { __type: 'String' },
    headers: { __type: 'JSONObject' },
    replyTo: { __type: 'String' },
    tags: { __type: '[SendMessageEmailOptionsTagsInput!]' },
  },
  SendMessageEmailOptionsTagsInput: { name: { __type: 'String!' }, value: { __type: 'String!' } },
  SendMessageInput: {
    clientIds: { __type: '[String!]' },
    content: { __type: 'String!' },
    emailOptions: { __type: 'SendMessageEmailOptionsInput' },
    isTransactional: { __type: 'Boolean' },
    messageType: { __type: 'MessageType!' },
    recipients: { __type: '[String!]!' },
    siteId: { __type: 'String!' },
    smsFrom: { __type: 'String' },
    smsStatusCallback: { __type: 'String' },
    subject: { __type: 'String' },
    templateAlias: { __type: 'String' },
  },
  SendMessageResponse: {
    __typename: { __type: 'String!' },
    error: { __type: 'String' },
    messageId: { __type: 'String' },
    messagesFailed: { __type: 'Float!' },
    messagesSent: { __type: 'Float!' },
    providerUsed: { __type: 'String!' },
    skippedDueToBlackout: { __type: 'Float' },
    skippedOptOut: { __type: 'Float' },
    success: { __type: 'Boolean!' },
  },
  SendPaymentReminder: {
    __typename: { __type: 'String!' },
    channels: { __type: 'SendPaymentReminderChannels!' },
    skippedChannels: { __type: '[MessageType!]!' },
    skippedDueToBlackout: { __type: 'Boolean' },
    skippedDueToCredits: { __type: 'Boolean!' },
    success: { __type: 'Boolean!' },
    templateSource: { __type: 'TemplateSource' },
  },
  SendPaymentReminderChannels: {
    __typename: { __type: 'String!' },
    email: { __type: 'SendMessageResponse' },
    push: { __type: 'SendMessageResponse' },
    sms: { __type: 'SendMessageResponse' },
  },
  Sentiment: {
    __typename: { __type: 'String!' },
    label: { __type: 'String!' },
    magnitude: { __type: 'Float!' },
    score: { __type: 'Float!' },
  },
  Service: {
    __typename: { __type: 'String!' },
    activatedStartDate: { __type: 'String' },
    autoRenew: { __type: 'Boolean!' },
    autoRenewedAt: { __type: 'String' },
    autoRenewedToServiceId: { __type: 'String' },
    billingCycleAmount: { __type: 'Float' },
    billingCycleUnit: { __type: 'String' },
    canceledAt: { __type: 'String' },
    canceledByClientId: { __type: 'String' },
    canceledByStaffUserId: { __type: 'String' },
    cancellationReason: { __type: 'String' },
    clientId: { __type: 'String!' },
    contractSignedAt: { __type: 'String' },
    createdAt: { __type: 'String!' },
    createdByInvoiceId: { __type: 'ID' },
    creditAllocationStartDate: { __type: 'String' },
    creditBalanceSnapshot: { __type: 'CreditBalanceSnapshot' },
    creditValidOverrideEndDate: { __type: 'String' },
    expiresAt: { __type: 'String' },
    invoiceItemId: { __type: 'String' },
    isAllSharedSites: { __type: 'Boolean!' },
    lastAllocationDate: { __type: 'String' },
    manualExpiresAt: { __type: 'String' },
    nextBillingDate: { __type: 'String' },
    onHold: { __type: 'Boolean!' },
    originalPrice: { __type: 'Numeric' },
    parentServiceId: { __type: 'ID' },
    purchasedAt: { __type: 'String!' },
    serviceCreditAllocationSnapshot: { __type: 'String' },
    serviceFirstBillingDate: { __type: 'String' },
    serviceId: { __type: 'String!' },
    serviceTemplateId: { __type: 'String!' },
    serviceTemplateSnapshot: { __type: 'String' },
    sharedSiteIds: { __type: '[String!]!' },
    signedClientAgreementId: { __type: 'String' },
    siteId: { __type: 'String!' },
    soldCurrency: { __type: 'String' },
    soldPrice: { __type: 'Numeric' },
    startsAt: { __type: 'String!' },
    status: { __type: 'ServiceStatus!' },
    updatedAt: { __type: 'String!' },
  },
  ServiceCancellation: {
    __typename: { __type: 'String!' },
    canceledAt: { __type: 'String' },
    canceledByClientId: { __type: 'String' },
    canceledByStaffUserId: { __type: 'String' },
    cancellationDate: { __type: 'String!' },
    cancellationReason: { __type: 'String' },
    cancellationType: { __type: 'String' },
    chargeAmount: { __type: 'Numeric' },
    chargeMode: { __type: 'ServiceSuspensionChargeMode' },
    createdAt: { __type: 'String!' },
    createdByClientId: { __type: 'String' },
    createdByStaffUserId: { __type: 'String' },
    executedAt: { __type: 'String' },
    failedInvoiceIds: { __type: '[String!]' },
    serviceCancellationId: { __type: 'String!' },
    serviceId: { __type: 'String!' },
    status: { __type: 'ServiceCancellationStatus!' },
  },
  ServiceCreditShareAddRecipientInput: {
    allocatedCredits: { __type: 'Float' },
    recipientClientId: { __type: 'ID!' },
    serviceId: { __type: 'ID!' },
  },
  ServiceCreditShareMutationResult: {
    __typename: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  ServiceCreditShareRemoveInput: {
    recipientClientId: { __type: 'ID!' },
    serviceId: { __type: 'ID!' },
  },
  ServiceCreditTemplate: {
    __typename: { __type: 'String!' },
    amount: { __type: 'Float' },
    corporateCreditLineId: { __type: 'ID' },
    createdAt: { __type: 'String!' },
    creditsType: { __type: 'CreditType!' },
    expirationAmount: { __type: 'Float' },
    expirationEnabled: { __type: 'Boolean!' },
    expirationType: { __type: 'CreditExpirationType' },
    expirationUnit: { __type: 'CreditExpirationUnit' },
    locationEditedFields: { __type: '[BrandAddOnField!]' },
    order: { __type: 'Float!' },
    serviceCreditTemplateId: { __type: 'String!' },
    serviceTemplateId: { __type: 'String!' },
    siteSessionTypeIds: { __type: '[String!]!' },
  },
  ServiceExtensionSummary: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    newExpiresAt: { __type: 'String!' },
    type: { __type: 'ServiceExtensionType!' },
  },
  ServiceResultRow: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'ServiceWithTemplateAndClient!' },
  },
  ServiceTemplate: {
    __typename: { __type: 'String!' },
    accessSchedule: { __type: 'JSONObject' },
    accountCodeId: { __type: 'String' },
    agreementEnabled: { __type: 'Boolean' },
    agreementSendConfirmation: { __type: 'Boolean' },
    agreementText: { __type: 'String' },
    autoConvertTo: { __type: 'String' },
    autoConvertTrigger: { __type: 'AutoConvertTrigger' },
    autoRenewEnabled: { __type: 'Boolean' },
    autoRenewType: { __type: 'AutoRenewType' },
    billingAnchorDate: { __type: 'String' },
    billingCycleAmount: { __type: 'Float' },
    billingCycleUnit: { __type: 'BillingCycleUnit' },
    billingDay: { __type: 'Float' },
    cancellation: { __type: 'ServiceTemplateCancellation' },
    cancellationNoticePeriodAmount: { __type: 'Float' },
    cancellationNoticePeriodUnit: { __type: 'CancellationNoticePeriodUnit' },
    categoryId: { __type: 'String' },
    categoryName: { __type: 'String' },
    changePlanEnabled: { __type: 'Boolean!' },
    chargeSetupFeeUpFront: { __type: 'Boolean' },
    clientOnlinePurchaseExpiryDate: { __type: 'String' },
    clientOnlinePurchaseExpiryEnabled: { __type: 'Boolean!' },
    corporateServiceTemplateId: { __type: 'ID' },
    createdAt: { __type: 'String!' },
    creditRolloverPolicy: { __type: 'CreditRolloverPolicy' },
    creditWindowEndDate: { __type: 'String' },
    credits: { __type: '[ServiceCreditTemplate!]' },
    description: { __type: 'String' },
    displayOrder: { __type: 'Float' },
    dynamicDisplayServiceTemplateIds: { __type: '[String!]!' },
    earlyAccessDurationAmount: { __type: 'Float' },
    earlyAccessDurationUnit: { __type: 'EarlyAccessDurationUnit' },
    expiryAlertInDays: { __type: 'Float' },
    extraBookingWindow: { __type: 'Float!' },
    familyShareable: { __type: 'Boolean!' },
    feeRevenueTags: { __type: 'ServiceTemplateFeeRevenueTags' },
    firstCreditAllocationDate: { __type: 'ServiceTemplateFirstCreditAllocationDate' },
    futureStartDate: { __type: 'String' },
    guestPassAllowance: { __type: 'ServiceTemplateGuestPassAllowance' },
    inheritAgreementsOnConvert: { __type: 'Boolean' },
    isAllSharedSites: { __type: 'Boolean!' },
    isClientControlEnabled: { __type: 'Boolean' },
    isDefaultForTransferredClient: { __type: 'Boolean' },
    isEnabledForCMS: { __type: 'Boolean!' },
    isFeatured: { __type: 'Boolean!' },
    isIntroOffer: { __type: 'Boolean!' },
    isRestricted: { __type: 'Boolean!' },
    lengthAmount: { __type: 'Float' },
    lengthType: { __type: 'ServiceLengthType' },
    lengthUnit: { __type: 'ServiceLengthUnit' },
    limitSale: { __type: 'ServiceTemplateLimitSale' },
    locationEditedFields: { __type: '[BrandAddOnField!]' },
    lockedSections: { __type: '[BrandServiceTemplateSection!]' },
    maxSharingCredits: { __type: 'Float' },
    maxSharingRecipients: { __type: 'Float' },
    minimumHomeUsageInDays: { __type: 'Float' },
    multiplePaymentOptions: { __type: 'ServiceTemplateMultiplePaymentOptions' },
    name: { __type: 'String!' },
    newSaleDynamicDisplayServiceTemplateIds: { __type: '[String!]!' },
    oneActivePerFamily: { __type: 'Boolean!' },
    oneTimeSetupFee: { __type: 'Numeric' },
    oneTimeSetupFeeTaxEnabled: { __type: 'Boolean' },
    oneTimeSetupFeeTaxSettingIds: { __type: '[ID!]' },
    onlineSaleEnabled: { __type: 'Boolean!' },
    onlineSaleStartDate: { __type: 'String' },
    payUpFrontEnabled: { __type: 'Boolean' },
    price: { __type: 'Numeric!' },
    revenueTag: { __type: 'String' },
    saleAvailableFromDate: { __type: 'String' },
    saleAvailableUntilDate: { __type: 'String' },
    secondaryRecurringFee: { __type: 'ServiceTemplateSecondaryRecurringFee' },
    selfServicePause: { __type: 'ServiceTemplateSelfServicePause' },
    serviceFirstBillingDate: { __type: 'ServiceTemplateFirstPaymentDate' },
    serviceTemplateId: { __type: 'String!' },
    sharedSiteIds: { __type: '[String!]!' },
    sharingCreditsAmount: { __type: 'Float' },
    sharingCreditsEnabled: { __type: 'Boolean!' },
    siteAgreementTemplateId: { __type: 'String' },
    siteId: { __type: 'String!' },
    status: { __type: 'ServiceTemplateStatus!' },
    taxEnabled: { __type: 'Boolean!' },
    taxSettingIds: { __type: '[ID!]' },
    tierOrder: { __type: 'Float' },
    toServiceTemplateId: { __type: 'String' },
    type: { __type: 'ServiceTemplateType!' },
    updatedAt: { __type: 'String!' },
  },
  ServiceTemplateAddOn: {
    __typename: { __type: 'String!' },
    addOnServiceTemplateId: { __type: 'ID!' },
    corporatePricePointId: { __type: 'ID' },
    createdAt: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
    locationEditedFields: { __type: '[BrandAddOnField!]' },
    parentServiceTemplateId: { __type: 'ID!' },
    paymentType: { __type: 'ServiceTemplateAddOnPaymentType!' },
    price: { __type: 'Numeric!' },
    serviceTemplateAddOnId: { __type: 'ID!' },
    siteId: { __type: 'ID!' },
    taxEnabled: { __type: 'Boolean!' },
    taxSettingIds: { __type: '[ID!]' },
    updatedAt: { __type: 'String!' },
  },
  ServiceTemplateAddOnEligibleParent: {
    __typename: { __type: 'String!' },
    addOnServiceTemplateId: { __type: 'ID!' },
    parentName: { __type: 'String!' },
    parentServiceTemplateId: { __type: 'ID!' },
  },
  ServiceTemplateAddOnForParent: {
    __typename: { __type: 'String!' },
    addOnServiceTemplateId: { __type: 'ID!' },
    agreementEnabled: { __type: 'Boolean' },
    categoryId: { __type: 'String' },
    corporatePricePointId: { __type: 'ID' },
    createdAt: { __type: 'String!' },
    credits: { __type: '[ServiceCreditTemplate!]!' },
    description: { __type: 'String' },
    enabled: { __type: 'Boolean!' },
    isFeatured: { __type: 'Boolean!' },
    locationEditedFields: { __type: '[BrandAddOnField!]' },
    name: { __type: 'String!' },
    parentServiceTemplateId: { __type: 'ID!' },
    paymentType: { __type: 'ServiceTemplateAddOnPaymentType!' },
    price: { __type: 'Numeric!' },
    serviceTemplateAddOnId: { __type: 'ID!' },
    siteId: { __type: 'ID!' },
    taxEnabled: { __type: 'Boolean!' },
    taxSettingIds: { __type: '[ID!]' },
    updatedAt: { __type: 'String!' },
  },
  ServiceTemplateAddOnPriceGroupPriceInput: {
    addOnPriceGroupId: { __type: 'ID!' },
    price: { __type: 'Numeric' },
  },
  ServiceTemplateAddOnSummary: {
    __typename: { __type: 'String!' },
    activeClientCount: { __type: 'Float!' },
    addOnServiceTemplateId: { __type: 'ID!' },
    parents: { __type: '[ServiceTemplateAddOn!]!' },
  },
  ServiceTemplateCancellation: {
    __typename: { __type: 'String!' },
    effectiveDateRule: { __type: 'CancellationEffectiveDateRule' },
    feeSchedule: { __type: 'ServiceTemplateCancellationFeeSchedule' },
    isEnabledForClient: { __type: 'Boolean!' },
    minimumTerm: { __type: 'ServiceTemplateCancellationMinimumTerm' },
    noticePeriodDays: { __type: 'Float' },
  },
  ServiceTemplateCancellationFeeSchedule: {
    __typename: { __type: 'String!' },
    basis: { __type: 'CancellationTierBasis!' },
    enabled: { __type: 'Boolean!' },
    tiers: { __type: '[ServiceTemplateCancellationFeeScheduleTiers!]!' },
  },
  ServiceTemplateCancellationFeeScheduleTiers: {
    __typename: { __type: 'String!' },
    amount: { __type: 'Numeric' },
    kind: { __type: 'CancellationFeeValueKind!' },
    percent: { __type: 'Float' },
    until: { __type: 'Float!' },
  },
  ServiceTemplateCancellationMinimumTerm: {
    __typename: { __type: 'String!' },
    after: { __type: 'ServiceTemplateCancellationMinimumTermAfter' },
    charge: { __type: 'ServiceTemplateCancellationMinimumTermCharge' },
    enabled: { __type: 'Boolean!' },
  },
  ServiceTemplateCancellationMinimumTermAfter: {
    __typename: { __type: 'String!' },
    amount: { __type: 'Float!' },
    unit: { __type: 'MinimumTermAfterUnit!' },
  },
  ServiceTemplateCancellationMinimumTermCharge: {
    __typename: { __type: 'String!' },
    amount: { __type: 'Numeric!' },
    isTaxEnabled: { __type: 'Boolean!' },
    taxSettingIds: { __type: '[ID!]!' },
  },
  ServiceTemplateFeeRevenueTags: {
    __typename: { __type: 'String!' },
    cancellationFee: { __type: 'ID' },
    oneTimeSetupFee: { __type: 'ID' },
    secondaryRecurringFee: { __type: 'ID' },
    suspensionFee: { __type: 'ID' },
  },
  ServiceTemplateFilterOption: {
    __typename: { __type: 'String!' },
    name: { __type: 'String!' },
    serviceTemplateId: { __type: 'String!' },
    status: { __type: 'ServiceTemplateStatus!' },
    type: { __type: 'ServiceTemplateType!' },
  },
  ServiceTemplateFirstCreditAllocationDate: {
    __typename: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
    firstCreditAllocationDateType: { __type: 'FirstCreditAllocationDateType' },
    onDate: { __type: 'String' },
  },
  ServiceTemplateFirstPaymentDate: {
    __typename: { __type: 'String!' },
    after: { __type: 'ServiceTemplateFirstPaymentDateAfter' },
    enabled: { __type: 'Boolean!' },
    onDate: { __type: 'String' },
  },
  ServiceTemplateFirstPaymentDateAfter: {
    __typename: { __type: 'String!' },
    amount: { __type: 'Float!' },
    unit: { __type: 'FirstPaymentAfterUnit!' },
  },
  ServiceTemplateGuestPassAllowance: {
    __typename: { __type: 'String!' },
    amountPerCycle: { __type: 'Float' },
    carryForwardCap: { __type: 'Float' },
    companionTemplateId: { __type: 'ID' },
    creditLines: { __type: '[ServiceTemplateGuestPassCreditLine!]' },
    enabled: { __type: 'Boolean!' },
    expiryBehaviour: { __type: 'GuestPassExpiryBehaviour' },
    intervalAmount: { __type: 'Float' },
    intervalUnit: { __type: 'BillingCycleUnit' },
    newClientsOnlyEnabled: { __type: 'Boolean!' },
    passesPerInterval: { __type: 'Float' },
    siteSessionTypeIds: { __type: '[ID!]' },
  },
  ServiceTemplateGuestPassCreditLine: {
    __typename: { __type: 'String!' },
    credits: { __type: 'Float!' },
    serviceCreditTemplateId: { __type: 'ID' },
    siteSessionTypeIds: { __type: '[ID!]!' },
  },
  ServiceTemplateLimitSale: {
    __typename: { __type: 'String!' },
    perAccount: { __type: 'Float' },
    perClient: { __type: 'Float' },
  },
  ServiceTemplateMultiplePaymentOptions: {
    __typename: { __type: 'String!' },
    payNowMode: { __type: 'PaymentMode!' },
    recurringMode: { __type: 'PaymentMode!' },
  },
  ServiceTemplateOption: {
    __typename: { __type: 'String!' },
    categoryId: { __type: 'String' },
    categoryName: { __type: 'String' },
    name: { __type: 'String!' },
    serviceTemplateId: { __type: 'String!' },
    siteId: { __type: 'String!' },
    siteName: { __type: 'String' },
    type: { __type: 'ServiceTemplateType!' },
  },
  ServiceTemplateSecondaryRecurringFee: {
    __typename: { __type: 'String!' },
    amount: { __type: 'Numeric!' },
    billingCycleAmount: { __type: 'Float' },
    billingCycleUnit: { __type: 'BillingCycleUnit' },
    enabled: { __type: 'Boolean!' },
    serviceFirstBillingDate: { __type: 'ServiceTemplateFirstPaymentDate' },
    taxEnabled: { __type: 'Boolean!' },
    taxSettingIds: { __type: '[ID!]' },
  },
  ServiceTemplateSelfServicePause: {
    __typename: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
    fee: { __type: 'ServiceTemplateSelfServicePauseFee!' },
    noticePeriodDays: { __type: 'Float' },
    suspensionType: { __type: 'ServiceSuspensionType!' },
  },
  ServiceTemplateSelfServicePauseFee: {
    __typename: { __type: 'String!' },
    amount: { __type: 'Numeric' },
    cadence: { __type: 'ServiceTemplateSelfServicePauseFeeCadence' },
    chargeMode: { __type: 'SelfServicePauseChargeMode!' },
  },
  ServiceTemplateSelfServicePauseFeeCadence: {
    __typename: { __type: 'String!' },
    amount: { __type: 'Float!' },
    unit: { __type: 'SelfServicePauseCadenceUnit!' },
  },
  ServiceTemplateSessionTypeAddOn: {
    __typename: { __type: 'String!' },
    addOnName: { __type: 'String' },
    addOnPriceGroupId: { __type: 'ID' },
    createdAt: { __type: 'String!' },
    equipmentId: { __type: 'ID' },
    fromServiceTemplateId: { __type: 'ID!' },
    price: { __type: 'Numeric!' },
    serviceTemplateSessionTypeAddOnId: { __type: 'ID!' },
    siteId: { __type: 'ID!' },
    siteSessionTypeId: { __type: 'ID!' },
    taxSettingIds: { __type: '[ID!]' },
    updatedAt: { __type: 'String!' },
  },
  ServiceTemplatesPaginated: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'ServiceTemplatesPaginatedPageInfo!' },
    results: { __type: '[ServiceTemplatesPaginatedResults!]!' },
  },
  ServiceTemplatesPaginatedOrderByInput: {
    column: { __type: 'ServiceTemplateOrderBy!' },
    direction: { __type: 'OrderByDirection!' },
  },
  ServiceTemplatesPaginatedPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  ServiceTemplatesPaginatedResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'ServiceTemplate!' },
  },
  ServiceWithTemplateAndClient: {
    __typename: { __type: 'String!' },
    activatedStartDate: { __type: 'String' },
    autoRenew: { __type: 'Boolean!' },
    billingCycleAmount: { __type: 'Float' },
    billingCycleUnit: { __type: 'String' },
    canceledAt: { __type: 'String' },
    canceledByStaffUserId: { __type: 'String' },
    cancellationReason: { __type: 'String' },
    client: { __type: 'ServiceWithTemplateAndClientClient' },
    clientId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    createdByInvoiceId: { __type: 'ID' },
    creditBalanceSnapshot: { __type: 'CreditBalanceSnapshotOutput' },
    expiresAt: { __type: 'String' },
    invoiceItemId: { __type: 'String' },
    lastAllocationDate: { __type: 'String' },
    nextBillingDate: { __type: 'String' },
    onHold: { __type: 'Boolean!' },
    purchasedAt: { __type: 'String!' },
    serviceId: { __type: 'String!' },
    serviceTemplate: { __type: 'ServiceWithTemplateAndClientServiceTemplate' },
    serviceTemplateId: { __type: 'String!' },
    siteId: { __type: 'String!' },
    startsAt: { __type: 'String!' },
    status: { __type: 'ServiceStatus!' },
    updatedAt: { __type: 'String!' },
  },
  ServiceWithTemplateAndClientClient: {
    __typename: { __type: 'String!' },
    alerts: { __type: '[ServiceWithTemplateAndClientClientAlerts!]' },
    clientId: { __type: 'ID!' },
    email: { __type: 'String' },
    firstName: { __type: 'String' },
    lastName: { __type: 'String' },
  },
  ServiceWithTemplateAndClientClientAlerts: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'String!' },
    data: { __type: 'JSONObject' },
    requiresFetch: { __type: 'Boolean!' },
    type: { __type: 'String!' },
  },
  ServiceWithTemplateAndClientServiceTemplate: {
    __typename: { __type: 'String!' },
    name: { __type: 'String!' },
    type: { __type: 'ServiceTemplateType!' },
  },
  ServicesPaginationResult: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'ServicesPaginationResultPageInfo!' },
    results: { __type: '[ServiceResultRow!]!' },
  },
  ServicesPaginationResultPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Float!' },
  },
  ServicesSoldItem: {
    __typename: { __type: 'String!' },
    count: { __type: 'Float!' },
    date: { __type: 'String!' },
    serviceType: { __type: 'String!' },
  },
  Session: {
    __typename: { __type: 'String!' },
    aggregatorConfigs: { __type: '[SessionAggregatorConfig!]!' },
    allowOverlappingSessions: { __type: 'Boolean!' },
    bookedCount: { __type: 'Float' },
    bookingAvailability: { __type: 'BookingAvailability!' },
    bookings: { __type: '[Booking!]!' },
    category: { __type: 'SessionCategory!' },
    createdAt: { __type: 'String' },
    creditsRequired: { __type: 'Float!' },
    customCancelPolicy: { __type: 'SessionTemplateCustomCancelPolicy' },
    customFields: { __type: '[SessionTemplateCustomFields!]' },
    customReleaseSchedule: { __type: 'SessionTemplateCustomReleaseSchedule' },
    date: { __type: 'String!' },
    deletedAt: { __type: 'String' },
    deletedBy: { __type: 'String' },
    description: { __type: 'String' },
    disabledSpotIds: { __type: '[Float!]' },
    dropinPrice: { __type: 'Numeric!' },
    duration: { __type: 'SessionDuration!' },
    endTime: { __type: 'String!' },
    instructor: { __type: '[SessionInstructor!]!' },
    isBeyondBookingWindow: { __type: 'Boolean!' },
    isBlockSlot: { __type: 'Boolean!' },
    isImported: { __type: 'Boolean!' },
    isModified: { __type: 'Boolean!' },
    isPaymentRequired: { __type: 'Boolean!' },
    isRequestBookingEnabled: { __type: 'Boolean!' },
    isRequiredSessionFeedback: { __type: 'Boolean!' },
    isRequiredTwoPartAuthentication: { __type: 'Boolean!' },
    isRoomResourceEnabled: { __type: 'Boolean!' },
    isVirtualized: { __type: 'Boolean!' },
    itemsSupplied: { __type: 'String' },
    itemsToBring: { __type: 'String' },
    lateCancelFeeId: { __type: 'String' },
    lateCancelFeeMode: { __type: 'SessionFeeMode' },
    location: { __type: 'SessionLocation' },
    locationName: { __type: 'String' },
    name: { __type: 'String!' },
    noShowFeeId: { __type: 'String' },
    noShowFeeMode: { __type: 'SessionFeeMode' },
    recurrenceDate: { __type: 'String' },
    recurringSession: { __type: 'RecurringSession' },
    recurringSessionsId: { __type: 'String' },
    revenueTagId: { __type: 'String' },
    room: { __type: 'SessionRoom' },
    roomHasResourceBooking: { __type: 'Boolean' },
    roomName: { __type: 'String' },
    roomResourceTemplateId: { __type: 'String' },
    sessionId: { __type: 'String!' },
    sessionImage: {
      __type: 'SessionTemplateSessionImage',
      __args: { formats: '[String!]', variants: '[String!]' },
    },
    sessionTemplateId: { __type: 'String' },
    sessionTypeColor: { __type: 'String' },
    sessionTypeName: { __type: 'String' },
    siteId: { __type: 'String!' },
    siteLocationId: { __type: 'String!' },
    siteLocationRoomId: { __type: 'String' },
    siteSessionType: { __type: 'SessionSiteSessionType' },
    siteSessionTypeId: { __type: 'String!' },
    size: { __type: 'Float!' },
    staffUserIds: { __type: '[String!]!' },
    startTime: { __type: 'String!' },
    status: { __type: 'SessionStatus!' },
    taxEnabled: { __type: 'Boolean!' },
    taxSettingIds: { __type: '[String!]' },
    updatedAt: { __type: 'String' },
    waitlistBatchSize: { __type: 'Float' },
    waitlistEnabled: { __type: 'Boolean!' },
    waitlistInvitationStrategy: { __type: 'WaitlistInvitationStrategy' },
    waitlistInvitationTimeout: { __type: 'Float' },
    waitlistSize: { __type: 'Float' },
    zoomJoinUrl: { __type: 'String' },
    zoomMeetingId: { __type: 'String' },
    zoomStartUrl: { __type: 'String' },
  },
  SessionAggregatorConfig: {
    __typename: { __type: 'String!' },
    aggregatorProviderId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    externalClassId: { __type: 'String' },
    externalSlotId: { __type: 'String' },
    isEnabled: { __type: 'Boolean!' },
    sessionId: { __type: 'String!' },
    spotLimit: { __type: 'Float' },
    updatedAt: { __type: 'String!' },
  },
  SessionAggregatorConfigInput: {
    aggregatorProviderId: { __type: 'String!' },
    isEnabled: { __type: 'Boolean!' },
    spotLimit: { __type: 'Float' },
  },
  SessionBookingResult: {
    __typename: { __type: 'String!' },
    clientResults: { __type: '[ClientBookingResult!]!' },
    date: { __type: 'String!' },
    sessionId: { __type: 'String!' },
  },
  SessionCreateCustomInput: {
    aggregatorConfigs: { __type: '[SessionAggregatorConfigInput!]' },
    allowOverlappingSessions: { __type: 'Boolean' },
    category: { __type: 'SessionCategory!' },
    creditsRequired: { __type: 'Float!' },
    customCancelPolicy: { __type: 'SessionTemplateCustomCancelPolicyInput' },
    customFields: { __type: '[SessionTemplateCustomFieldsInput!]!' },
    customReleaseSchedule: { __type: 'SessionTemplateCustomReleaseScheduleInput' },
    date: { __type: 'String!' },
    description: { __type: 'String' },
    disabledSpotIds: { __type: '[Float!]' },
    dropinPrice: { __type: 'Numeric!' },
    endTime: { __type: 'String!' },
    isBlockSlot: { __type: 'Boolean!' },
    isModified: { __type: 'Boolean!' },
    isPaymentRequired: { __type: 'Boolean!' },
    isRequestBookingEnabled: { __type: 'Boolean!' },
    isRequiredSessionFeedback: { __type: 'Boolean!' },
    isRequiredTwoPartAuthentication: { __type: 'Boolean!' },
    isRoomResourceEnabled: { __type: 'Boolean' },
    itemsSupplied: { __type: 'String' },
    itemsToBring: { __type: 'String' },
    lateCancelFeeId: { __type: 'String' },
    lateCancelFeeMode: { __type: 'SessionFeeMode' },
    name: { __type: 'String!' },
    noShowFeeId: { __type: 'String' },
    noShowFeeMode: { __type: 'SessionFeeMode' },
    recurrenceDate: { __type: 'String' },
    recurringSessionsId: { __type: 'String' },
    revenueTagId: { __type: 'String' },
    sessionImage: { __type: 'SessionTemplateSessionImageInput' },
    sessionTemplateId: { __type: 'String' },
    siteLocationId: { __type: 'String!' },
    siteLocationRoomId: { __type: 'String' },
    siteSessionTypeId: { __type: 'String!' },
    size: { __type: 'Float!' },
    staffUserIds: { __type: '[String!]' },
    startTime: { __type: 'String!' },
    status: { __type: 'SessionStatus!' },
    taxEnabled: { __type: 'Boolean!' },
    taxSettingIds: { __type: '[String!]' },
    waitlistBatchSize: { __type: 'Float' },
    waitlistEnabled: { __type: 'Boolean!' },
    waitlistInvitationStrategy: { __type: 'WaitlistInvitationStrategy' },
    waitlistInvitationTimeout: { __type: 'Float' },
    waitlistSize: { __type: 'Float' },
  },
  SessionCreateFromTemplateInput: {
    aggregatorConfigs: { __type: '[SessionAggregatorConfigInput!]' },
    creditsRequired: { __type: 'Float' },
    date: { __type: 'String!' },
    description: { __type: 'String' },
    dropinPrice: { __type: 'Numeric' },
    endTime: { __type: 'String' },
    isModified: { __type: 'Boolean!' },
    isRoomResourceEnabled: { __type: 'Boolean' },
    lateCancelFeeId: { __type: 'String' },
    lateCancelFeeMode: { __type: 'SessionFeeMode' },
    name: { __type: 'String' },
    noShowFeeId: { __type: 'String' },
    noShowFeeMode: { __type: 'SessionFeeMode' },
    recurrenceDate: { __type: 'String' },
    recurringSessionsId: { __type: 'String' },
    revenueTagId: { __type: 'String' },
    sessionTemplateId: { __type: 'String!' },
    siteLocationId: { __type: 'String' },
    siteLocationRoomId: { __type: 'String' },
    size: { __type: 'Float' },
    staffUserIds: { __type: '[String!]' },
    startTime: { __type: 'String!' },
  },
  SessionDeletionPreview: {
    __typename: { __type: 'String!' },
    activeBookingCount: { __type: 'Float!' },
    bookedMemberCount: { __type: 'Float!' },
    endsSeries: { __type: 'Boolean!' },
    sessionCount: { __type: 'Float!' },
    waitlistCount: { __type: 'Float!' },
  },
  SessionDeletionPreviewInput: {
    includeModifiedSessions: { __type: 'Boolean' },
    scope: { __type: 'CancelSessionScope!' },
    sessionId: { __type: 'String!' },
    siteId: { __type: 'String!' },
  },
  SessionDuration: {
    __typename: { __type: 'String!' },
    hours: { __type: 'Float!' },
    minutes: { __type: 'Float!' },
  },
  SessionFee: {
    __typename: { __type: 'String!' },
    feeId: { __type: 'ID' },
    name: { __type: 'String' },
    price: { __type: 'String!' },
    source: { __type: 'SessionFeeSource!' },
    unlimitedCreditsOnly: { __type: 'Boolean!' },
  },
  SessionFeedback: {
    __typename: { __type: 'String!' },
    attendanceId: { __type: 'String!' },
    clientId: { __type: 'String!' },
    comments: { __type: 'String' },
    createdAt: { __type: 'String!' },
    deletedAt: { __type: 'String' },
    feedbackAnswers: { __type: '[SessionFeedbackFeedbackAnswers!]' },
    overallRating: { __type: 'Float' },
    sessionFeedbackId: { __type: 'String!' },
    sessionId: { __type: 'String!' },
    siteId: { __type: 'String!' },
    submittedAt: { __type: 'String!' },
    updatedAt: { __type: 'String!' },
  },
  SessionFeedbackFeedbackAnswers: {
    __typename: { __type: 'String!' },
    answer: { __type: 'String!' },
    questionId: { __type: 'String!' },
    questionText: { __type: 'String!' },
  },
  SessionFeedbackQuestion: {
    __typename: { __type: 'String!' },
    active: { __type: 'Boolean!' },
    answerType: { __type: 'SessionFeedbackAnswerType!' },
    characterLimit: { __type: 'Float' },
    createdAt: { __type: 'String!' },
    deletedAt: { __type: 'String' },
    helperText: { __type: 'String' },
    maxLabel: { __type: 'String' },
    minLabel: { __type: 'String' },
    orderIndex: { __type: 'Float!' },
    presetKey: { __type: 'String' },
    questionText: { __type: 'String!' },
    required: { __type: 'Boolean!' },
    scaleMax: { __type: 'Float' },
    sessionFeedbackQuestionId: { __type: 'String!' },
    siteId: { __type: 'String!' },
    sliderMax: { __type: 'Float' },
    sliderMin: { __type: 'Float' },
    updatedAt: { __type: 'String!' },
  },
  SessionFeedbackQuestionCreateInput: {
    active: { __type: 'Boolean!' },
    answerType: { __type: 'SessionFeedbackAnswerType!' },
    characterLimit: { __type: 'Float' },
    helperText: { __type: 'String' },
    maxLabel: { __type: 'String' },
    minLabel: { __type: 'String' },
    presetKey: { __type: 'String' },
    questionText: { __type: 'String!' },
    required: { __type: 'Boolean!' },
    scaleMax: { __type: 'Float' },
    sliderMax: { __type: 'Float' },
    sliderMin: { __type: 'Float' },
  },
  SessionFeedbackQuestionDeleteResponse: {
    __typename: { __type: 'String!' },
    deleted: { __type: 'Boolean!' },
  },
  SessionFeedbackQuestionReorderResponse: {
    __typename: { __type: 'String!' },
    updatedCount: { __type: 'Float!' },
  },
  SessionFeedbackQuestionUpdateInput: {
    active: { __type: 'Boolean' },
    answerType: { __type: 'SessionFeedbackAnswerType' },
    characterLimit: { __type: 'Float' },
    helperText: { __type: 'String' },
    maxLabel: { __type: 'String' },
    minLabel: { __type: 'String' },
    questionText: { __type: 'String' },
    required: { __type: 'Boolean' },
    scaleMax: { __type: 'Float' },
    sliderMax: { __type: 'Float' },
    sliderMin: { __type: 'Float' },
  },
  SessionFeedbackStatusEntry: {
    __typename: { __type: 'String!' },
    sessionId: { __type: 'ID!' },
    status: { __type: 'SessionFeedbackStatus!' },
  },
  SessionFees: {
    __typename: { __type: 'String!' },
    lateCancel: { __type: 'SessionFee' },
    noShow: { __type: 'SessionFee' },
  },
  SessionFilter: {
    __typename: { __type: 'String!' },
    calendarMode: { __type: 'SessionFilterCalendarMode' },
    createdBy: { __type: 'String' },
    filters: { __type: 'JSONObject' },
    id: { __type: 'String!' },
    isDefault: { __type: 'Boolean!' },
    isVisible: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    siteId: { __type: 'String!' },
    sortOrder: { __type: 'Float!' },
    visibility: { __type: 'SessionFilterVisibility!' },
  },
  SessionFilterCreateInput: {
    calendarMode: { __type: 'SessionFilterCalendarMode' },
    filters: { __type: 'JSONObject' },
    isDefault: { __type: 'Boolean!' },
    isVisible: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    visibility: { __type: 'SessionFilterVisibility!' },
  },
  SessionFilterUpdateInput: {
    calendarMode: { __type: 'SessionFilterCalendarMode' },
    filters: { __type: 'JSONObject' },
    isDefault: { __type: 'Boolean' },
    isVisible: { __type: 'Boolean' },
    name: { __type: 'String' },
    visibility: { __type: 'SessionFilterVisibility' },
  },
  SessionInstructor: {
    __typename: { __type: 'String!' },
    firstName: { __type: 'String!' },
    lastName: { __type: 'String!' },
    name: { __type: 'String!' },
    role: { __type: 'String!' },
    staffUserId: { __type: 'String!' },
  },
  SessionLocation: { __typename: { __type: 'String!' }, name: { __type: 'String!' } },
  SessionQueryFiltersInput: {
    categories: { __type: '[SessionCategory!]' },
    clientIds: { __type: '[String!]' },
    excludeStartedSessions: { __type: 'Boolean' },
    includeCancelled: { __type: 'Boolean' },
    recurringSessionsId: { __type: 'String' },
    siteLocationIds: { __type: '[String!]' },
    siteLocationRoomIds: { __type: '[String!]' },
    siteSessionTypeIds: { __type: '[String!]' },
    staffUserIds: { __type: '[String!]' },
  },
  SessionRoom: {
    __typename: { __type: 'String!' },
    hasResourceBooking: { __type: 'Boolean' },
    name: { __type: 'String!' },
    roomResourceTemplateId: { __type: 'String' },
  },
  SessionSiteSessionType: {
    __typename: { __type: 'String!' },
    color: { __type: 'String' },
    name: { __type: 'String!' },
  },
  SessionTemplate: {
    __typename: { __type: 'String!' },
    allowOverlappingSessions: { __type: 'Boolean!' },
    availableForStaffUserIds: { __type: '[String!]' },
    category: { __type: 'SessionCategory!' },
    createdAt: { __type: 'String!' },
    creditsRequired: { __type: 'Float!' },
    customCancelPolicy: { __type: 'SessionTemplateCustomCancelPolicy' },
    customFields: { __type: '[SessionTemplateCustomFields!]!' },
    customReleaseSchedule: { __type: 'SessionTemplateCustomReleaseSchedule' },
    deletedAt: { __type: 'String' },
    description: { __type: 'String' },
    displayOrder: { __type: 'Float' },
    dropInPrice: { __type: 'Numeric!' },
    durationHours: { __type: 'Float!' },
    durationMinutes: { __type: 'Float!' },
    isPaymentRequired: { __type: 'Boolean!' },
    isRequestBookingEnabled: { __type: 'Boolean!' },
    isRequiredSessionFeedback: { __type: 'Boolean!' },
    isRequiredTwoPartAuthentication: { __type: 'Boolean!' },
    isRoomResourceEnabled: { __type: 'Boolean!' },
    itemsSupplied: { __type: 'String' },
    itemsToBring: { __type: 'String' },
    lateCancelFeeId: { __type: 'String' },
    lateCancelFeeMode: { __type: 'SessionFeeMode' },
    name: { __type: 'String!' },
    noShowFeeId: { __type: 'String' },
    noShowFeeMode: { __type: 'SessionFeeMode' },
    revenueTagId: { __type: 'String' },
    sessionImage: {
      __type: 'SessionTemplateSessionImage',
      __args: { formats: '[String!]', variants: '[String!]' },
    },
    sessionTemplateId: { __type: 'String!' },
    siteId: { __type: 'String!' },
    siteLocation: { __type: 'SiteLocation' },
    siteLocationId: { __type: 'String!' },
    siteLocationRoomId: { __type: 'String' },
    siteSessionType: { __type: 'SiteSessionType' },
    siteSessionTypeId: { __type: 'String!' },
    size: { __type: 'Float!' },
    taxEnabled: { __type: 'Boolean!' },
    taxSettingIds: { __type: '[String!]' },
    updatedAt: { __type: 'String!' },
    waitlistEnabled: { __type: 'Boolean!' },
    waitlistSize: { __type: 'Float' },
  },
  SessionTemplateCustomCancelPolicy: {
    __typename: { __type: 'String!' },
    days: { __type: 'Float!' },
    hours: { __type: 'Float!' },
    minutes: { __type: 'Float!' },
  },
  SessionTemplateCustomCancelPolicyInput: {
    days: { __type: 'Float!' },
    hours: { __type: 'Float!' },
    minutes: { __type: 'Float!' },
  },
  SessionTemplateCustomFields: {
    __typename: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
    id: { __type: 'String' },
    information: { __type: 'String' },
    name: { __type: 'String' },
    title: { __type: 'String' },
    value: { __type: 'String' },
  },
  SessionTemplateCustomFieldsInput: {
    enabled: { __type: 'Boolean!' },
    id: { __type: 'String' },
    information: { __type: 'String' },
    name: { __type: 'String' },
    title: { __type: 'String' },
    value: { __type: 'String' },
  },
  SessionTemplateCustomReleaseSchedule: {
    __typename: { __type: 'String!' },
    bookingAdvanceDays: { __type: 'Float!' },
    bookingAdvanceHours: { __type: 'Float!' },
    dayOfWeek: { __type: 'String' },
    hoursBeforeStart: { __type: 'Float' },
    intervalType: { __type: 'String' },
    intervalValue: { __type: 'Float' },
    releaseType: { __type: 'String!' },
    time: { __type: 'String' },
  },
  SessionTemplateCustomReleaseScheduleInput: {
    bookingAdvanceDays: { __type: 'Float!' },
    bookingAdvanceHours: { __type: 'Float!' },
    dayOfWeek: { __type: 'String' },
    hoursBeforeStart: { __type: 'Float' },
    intervalType: { __type: 'String' },
    intervalValue: { __type: 'Float' },
    releaseType: { __type: 'String!' },
    time: { __type: 'String' },
  },
  SessionTemplateInput: {
    allowOverlappingSessions: { __type: 'Boolean' },
    availableForStaffUserIds: { __type: '[String!]' },
    category: { __type: 'SessionCategory!' },
    creditsRequired: { __type: 'Float!' },
    customCancelPolicy: { __type: 'SessionTemplateCustomCancelPolicyInput' },
    customFields: { __type: '[SessionTemplateCustomFieldsInput!]!' },
    customReleaseSchedule: { __type: 'SessionTemplateCustomReleaseScheduleInput' },
    description: { __type: 'String' },
    dropInPrice: { __type: 'Numeric!' },
    durationHours: { __type: 'Float!' },
    durationMinutes: { __type: 'Float!' },
    isPaymentRequired: { __type: 'Boolean!' },
    isRequestBookingEnabled: { __type: 'Boolean!' },
    isRequiredSessionFeedback: { __type: 'Boolean!' },
    isRequiredTwoPartAuthentication: { __type: 'Boolean!' },
    isRoomResourceEnabled: { __type: 'Boolean' },
    itemsSupplied: { __type: 'String' },
    itemsToBring: { __type: 'String' },
    lateCancelFeeId: { __type: 'String' },
    lateCancelFeeMode: { __type: 'SessionFeeMode' },
    name: { __type: 'String!' },
    noShowFeeId: { __type: 'String' },
    noShowFeeMode: { __type: 'SessionFeeMode' },
    revenueTagId: { __type: 'String' },
    sessionImage: { __type: 'SessionTemplateSessionImageInput' },
    siteLocationId: { __type: 'String!' },
    siteLocationRoomId: { __type: 'String' },
    siteSessionTypeId: { __type: 'String!' },
    size: { __type: 'Float!' },
    taxEnabled: { __type: 'Boolean!' },
    taxSettingIds: { __type: '[String!]' },
    waitlistEnabled: { __type: 'Boolean!' },
    waitlistSize: { __type: 'Float' },
  },
  SessionTemplatePaginationResult: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'SessionTemplatePaginationResultPageInfo!' },
    results: { __type: '[SessionTemplatePaginationResultResults!]!' },
  },
  SessionTemplatePaginationResultPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  SessionTemplatePaginationResultResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'SessionTemplate!' },
  },
  SessionTemplateSessionImage: {
    __typename: { __type: 'String!' },
    lastFailure: { __type: 'RoomResourceTemplateImageLastFailure' },
    pending: { __type: 'RoomResourceTemplateImagePending' },
    status: { __type: 'FileUploadConfigFieldStatus' },
    versions: { __type: '[SessionTemplateSessionImageVersions!]' },
  },
  SessionTemplateSessionImageInput: {
    lastFailure: { __type: 'SessionTemplateSessionImageLastFailureInput' },
    pending: { __type: 'SessionTemplateSessionImagePendingInput' },
    status: { __type: 'FileUploadConfigFieldStatus' },
    versions: { __type: '[SessionTemplateSessionImageVersionsInput!]' },
  },
  SessionTemplateSessionImageLastFailureInput: {
    errorMessage: { __type: 'String!' },
    failedAt: { __type: 'String!' },
    tempUrl: { __type: 'String!' },
    uploadRequestedBy: { __type: 'ID!' },
  },
  SessionTemplateSessionImagePendingInput: {
    status: { __type: 'FileUploadConfigFieldPendingStatus!' },
    tempUrl: { __type: 'String!' },
    uploadRequestedAt: { __type: 'String!' },
    uploadRequestedBy: { __type: 'ID!' },
  },
  SessionTemplateSessionImageVersions: {
    __typename: { __type: 'String!' },
    format: { __type: 'String' },
    height: { __type: 'Float' },
    type: { __type: 'String!' },
    url: { __type: 'String!' },
    width: { __type: 'Float' },
  },
  SessionTemplateSessionImageVersionsInput: {
    format: { __type: 'String' },
    height: { __type: 'Float' },
    type: { __type: 'String!' },
    url: { __type: 'String!' },
    width: { __type: 'Float' },
  },
  SessionTemplateStaffUserInput: { staffUserId: { __type: 'String!' } },
  SessionTemplateUpdateInput: {
    allowOverlappingSessions: { __type: 'Boolean' },
    category: { __type: 'SessionCategory' },
    creditsRequired: { __type: 'Float' },
    customCancelPolicy: { __type: 'SessionTemplateCustomCancelPolicyInput' },
    customFields: { __type: '[SessionTemplateCustomFieldsInput!]' },
    customReleaseSchedule: { __type: 'SessionTemplateCustomReleaseScheduleInput' },
    description: { __type: 'String' },
    dropInPrice: { __type: 'Numeric' },
    durationHours: { __type: 'Float' },
    durationMinutes: { __type: 'Float' },
    isPaymentRequired: { __type: 'Boolean' },
    isRequestBookingEnabled: { __type: 'Boolean' },
    isRequiredSessionFeedback: { __type: 'Boolean' },
    isRequiredTwoPartAuthentication: { __type: 'Boolean' },
    isRoomResourceEnabled: { __type: 'Boolean' },
    itemsSupplied: { __type: 'String' },
    itemsToBring: { __type: 'String' },
    lateCancelFeeId: { __type: 'String' },
    lateCancelFeeMode: { __type: 'SessionFeeMode' },
    name: { __type: 'String' },
    noShowFeeId: { __type: 'String' },
    noShowFeeMode: { __type: 'SessionFeeMode' },
    revenueTagId: { __type: 'String' },
    sessionImage: { __type: 'SessionTemplateSessionImageInput' },
    siteLocationRoomId: { __type: 'String' },
    siteSessionTypeId: { __type: 'String' },
    size: { __type: 'Float' },
    taxEnabled: { __type: 'Boolean' },
    taxSettingIds: { __type: '[String!]' },
    waitlistEnabled: { __type: 'Boolean' },
    waitlistSize: { __type: 'Float' },
  },
  SessionUpdateInput: {
    aggregatorConfigs: { __type: '[SessionAggregatorConfigInput!]' },
    allowOverlappingSessions: { __type: 'Boolean' },
    category: { __type: 'SessionCategory' },
    creditsRequired: { __type: 'Float' },
    customCancelPolicy: { __type: 'SessionTemplateCustomCancelPolicyInput' },
    customFields: { __type: '[SessionTemplateCustomFieldsInput!]' },
    customReleaseSchedule: { __type: 'SessionTemplateCustomReleaseScheduleInput' },
    date: { __type: 'String' },
    description: { __type: 'String' },
    disabledSpotIds: { __type: '[Float!]' },
    dropinPrice: { __type: 'Numeric' },
    endTime: { __type: 'String' },
    isBlockSlot: { __type: 'Boolean' },
    isModified: { __type: 'Boolean' },
    isPaymentRequired: { __type: 'Boolean' },
    isRequestBookingEnabled: { __type: 'Boolean' },
    isRequiredSessionFeedback: { __type: 'Boolean' },
    isRequiredTwoPartAuthentication: { __type: 'Boolean' },
    isRoomResourceEnabled: { __type: 'Boolean' },
    itemsSupplied: { __type: 'String' },
    itemsToBring: { __type: 'String' },
    lateCancelFeeId: { __type: 'String' },
    lateCancelFeeMode: { __type: 'SessionFeeMode' },
    name: { __type: 'String' },
    noShowFeeId: { __type: 'String' },
    noShowFeeMode: { __type: 'SessionFeeMode' },
    recurrenceDate: { __type: 'String' },
    recurringSessionsId: { __type: 'String' },
    revenueTagId: { __type: 'String' },
    sessionImage: { __type: 'SessionTemplateSessionImageInput' },
    sessionTemplateId: { __type: 'String' },
    siteLocationId: { __type: 'String' },
    siteLocationRoomId: { __type: 'String' },
    siteSessionTypeId: { __type: 'String' },
    size: { __type: 'Float' },
    staffUserIds: { __type: '[String!]' },
    startTime: { __type: 'String' },
    status: { __type: 'SessionStatus' },
    taxEnabled: { __type: 'Boolean' },
    taxSettingIds: { __type: '[String!]' },
    waitlistBatchSize: { __type: 'Float' },
    waitlistEnabled: { __type: 'Boolean' },
    waitlistInvitationStrategy: { __type: 'WaitlistInvitationStrategy' },
    waitlistInvitationTimeout: { __type: 'Float' },
    waitlistSize: { __type: 'Float' },
  },
  SessionUpdateResult: {
    __typename: { __type: 'String!' },
    session: { __type: 'Session!' },
    spotMoves: { __type: '[SpotMove!]!' },
  },
  SessionWaitlistEntry: {
    __typename: { __type: 'String!' },
    bookedByClientId: { __type: 'ID' },
    client: { __type: 'SessionWaitlistEntryClient' },
    clientFirstName: { __type: 'String' },
    clientId: { __type: 'ID!' },
    clientLastName: { __type: 'String' },
    clientMobilePhoneNumber: { __type: 'String' },
    convertedBookingId: { __type: 'ID' },
    creditLedgerEntryIds: { __type: '[ID!]' },
    deletedAt: { __type: 'String' },
    guestServiceId: { __type: 'ID' },
    invitationExpiresAt: { __type: 'String' },
    invitationRound: { __type: 'Float' },
    invitedAt: { __type: 'String' },
    invitedByStaffUserId: { __type: 'String' },
    isFamilyEntry: { __type: 'Boolean' },
    isProcessing: { __type: 'Boolean!' },
    joinedAt: { __type: 'String!' },
    originalBookingId: { __type: 'ID' },
    position: { __type: 'Float!' },
    respondedAt: { __type: 'String' },
    session: { __type: 'ClientBookingSession' },
    sessionId: { __type: 'ID!' },
    sessionName: { __type: 'String' },
    sessionStartTime: { __type: 'String' },
    sessionWaitlistEntryId: { __type: 'String!' },
    siteId: { __type: 'ID!' },
    status: { __type: 'WaitlistEntryStatus!' },
    updatedAt: { __type: 'String!' },
  },
  SessionWaitlistEntryClient: {
    __typename: { __type: 'String!' },
    alerts: { __type: '[ClientAlert!]!' },
    email: { __type: 'String' },
    firstName: { __type: 'String' },
    id: { __type: 'String!' },
    lastName: { __type: 'String' },
    mobilePhoneNumber: { __type: 'String' },
    name: { __type: 'String' },
    siteId: { __type: 'String' },
  },
  SessionsPage: {
    __typename: { __type: 'String!' },
    sessions: { __type: '[Session!]!' },
    totalCount: { __type: 'Float!' },
  },
  SetContentTargetingInputInput: {
    targets: { __type: '[CmsContentTargetCreateInput!]' },
    visibilityScope: { __type: 'VisibilityScope!' },
  },
  SetDeviceInputMode: {
    __typename: { __type: 'String!' },
    deviceTokenId: { __type: 'String!' },
    inputMode: { __type: 'DeviceInputMode!' },
  },
  SetDevicePairingCodeLabel: { __typename: { __type: 'String!' }, ok: { __type: 'Boolean!' } },
  SetDeviceScopes: {
    __typename: { __type: 'String!' },
    capabilities: { __type: '[DeviceCapability!]!' },
    deviceTokenId: { __type: 'String!' },
  },
  SetKioskPin: {
    __typename: { __type: 'String!' },
    kioskPinSetAt: { __type: 'String!' },
    kioskSessionId: { __type: 'String!' },
  },
  SetMemberMovementIncomingNotifiersInput: {
    siteId: { __type: 'ID!' },
    staffUserIds: { __type: '[ID!]!' },
  },
  SetMemberMovementLocationPostureInput: {
    rollingApprovalType: { __type: 'MemberMovementRollingApprovalType' },
    siteId: { __type: 'ID!' },
  },
  SetRollingModeInput: {
    attestation: { __type: 'MemberMovementAttestationInput' },
    corporateId: { __type: 'ID!' },
    enabled: { __type: 'Boolean!' },
  },
  SetRollingModeResult: {
    __typename: { __type: 'String!' },
    corporateId: { __type: 'ID!' },
    enabled: { __type: 'Boolean!' },
    operatingMode: { __type: 'String!' },
  },
  SetSavedReportCategoryTargeting: {
    __typename: { __type: 'String!' },
    corporateId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    createdAtLevel: { __type: 'CreatedAtLevel!' },
    createdAtSiteId: { __type: 'String' },
    createdBy: { __type: 'String!' },
    name: { __type: 'String!' },
    savedReportCategoryId: { __type: 'String!' },
    sortOrder: { __type: 'Float!' },
    targeting: { __type: 'SavedReportsTargeting!' },
    updatedAt: { __type: 'String!' },
    visibilityScope: { __type: 'VisibilityScope!' },
  },
  SetSavedReportCategoryTargetingTargetsInput: {
    targetId: { __type: 'String!' },
    targetType: { __type: 'TargetType!' },
  },
  SetSavedReportTargeting: {
    __typename: { __type: 'String!' },
    baseReportAvailable: { __type: 'Boolean!' },
    baseReportName: { __type: 'ReportName!' },
    categoryId: { __type: 'String' },
    columnLabels: { __type: 'JSONObject' },
    corporateId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    createdAtLevel: { __type: 'CreatedAtLevel!' },
    createdAtSiteId: { __type: 'String' },
    createdBy: { __type: 'String!' },
    description: { __type: 'String' },
    name: { __type: 'String!' },
    savedColumns: { __type: '[String!]' },
    savedDateRange: { __type: 'SavedReportsSavedDateRange' },
    savedFilters: { __type: 'JSONObject' },
    savedReportId: { __type: 'String!' },
    savedSiteIds: { __type: '[String!]' },
    savedSort: { __type: '[SavedReportsSavedSort!]' },
    sortOrder: { __type: 'Float!' },
    targeting: { __type: 'SavedReportsTargeting!' },
    updatedAt: { __type: 'String!' },
    visibility: { __type: 'SavedReportVisibility!' },
    visibilityScope: { __type: 'VisibilityScope!' },
  },
  SetSavedReportTargetingTargetsInput: {
    targetId: { __type: 'String!' },
    targetType: { __type: 'TargetType!' },
  },
  SetServiceTemplateAddOnPriceGroupPricesInput: {
    prices: { __type: '[ServiceTemplateAddOnPriceGroupPriceInput!]!' },
    serviceTemplateId: { __type: 'ID!' },
    siteId: { __type: 'ID!' },
  },
  SetSessionTemplateFeedbackQuestions: {
    __typename: { __type: 'String!' },
    count: { __type: 'Float!' },
  },
  SetSessionTemplateFeedbackQuestionsInputInput: {
    questions: { __type: '[SetSessionTemplateFeedbackQuestionsQuestionsInput!]!' },
  },
  SetSessionTemplateFeedbackQuestionsQuestionsInput: {
    active: { __type: 'Boolean!' },
    sessionFeedbackQuestionId: { __type: 'ID!' },
  },
  SetSiteAuthenticationResponse: {
    __typename: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  SetSiteGrowEnabledResponse: {
    __typename: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
    success: { __type: 'Boolean!' },
  },
  SetSitesPlanOverrideAllowedResult: {
    __typename: { __type: 'String!' },
    allowedSiteIds: { __type: '[ID!]!' },
  },
  SetupEzypayGatewayInput: {
    isSandbox: { __type: 'Boolean!' },
    merchantId: { __type: 'ID' },
    merchantPassword: { __type: 'String' },
    merchantUsername: { __type: 'String' },
    paymentContactEmail: { __type: 'String' },
    siteId: { __type: 'ID!' },
  },
  SetupEzypayGatewayPayload: {
    __typename: { __type: 'String!' },
    sitePaymentGateway: { __type: 'EzypayGateway!' },
  },
  ShareableClient: {
    __typename: { __type: 'String!' },
    email: { __type: 'String' },
    firstName: { __type: 'String' },
    id: { __type: 'String!' },
    lastName: { __type: 'String' },
  },
  SharedCreditInviteContext: {
    __typename: { __type: 'String!' },
    ownerClientId: { __type: 'ID' },
    ownerFirstName: { __type: 'String' },
    ownerLastName: { __type: 'String' },
    ownerProfileImageUrl: { __type: 'String' },
    valid: { __type: 'Boolean!' },
  },
  SharedCreditInviteTokenResult: {
    __typename: { __type: 'String!' },
    expiresAt: { __type: 'String!' },
    inviteToken: { __type: 'String!' },
  },
  SharedCreditRecipientEligibility: {
    __typename: { __type: 'String!' },
    alreadyShared: { __type: 'Boolean!' },
    clientId: { __type: 'ID!' },
    eligible: { __type: 'Boolean!' },
  },
  SharedCreditsDetail: {
    __typename: { __type: 'String!' },
    allocatedCredits: { __type: 'Float' },
    consumedCredits: { __type: 'Float!' },
    email: { __type: 'String' },
    firstName: { __type: 'String' },
    lastName: { __type: 'String' },
    ownerClientId: { __type: 'ID!' },
    profileImageUrl: { __type: 'String' },
    recipientClientId: { __type: 'ID!' },
    remainingCredits: { __type: 'Float' },
    serviceId: { __type: 'ID!' },
    sharedOn: { __type: 'String' },
    status: { __type: 'ServiceCreditShareStatus!' },
  },
  SharedPackageDetails: {
    __typename: { __type: 'String!' },
    consumedCredits: { __type: 'Float!' },
    isOwner: { __type: 'Boolean!' },
    maxSharingCredits: { __type: 'Float' },
    ownerClientId: { __type: 'ID!' },
    recipients: { __type: '[SharedPackageRecipient!]!' },
    remainingCredits: { __type: 'Float' },
    serviceId: { __type: 'ID!' },
    usage: { __type: '[SharedPackageUsageEntry!]!' },
  },
  SharedPackageRecipient: {
    __typename: { __type: 'String!' },
    allocatedCredits: { __type: 'Float' },
    consumedCredits: { __type: 'Float!' },
    firstName: { __type: 'String' },
    lastName: { __type: 'String' },
    profileImageUrl: { __type: 'String' },
    recipientClientId: { __type: 'ID!' },
    sharedOn: { __type: 'String' },
  },
  SharedPackageUsageEntry: {
    __typename: { __type: 'String!' },
    profileImageUrl: { __type: 'String' },
    sessionName: { __type: 'String' },
    sessionStartTime: { __type: 'String' },
    siteName: { __type: 'String' },
    siteTimezone: { __type: 'String' },
    usedByClientId: { __type: 'ID!' },
    usedByFirstName: { __type: 'String' },
    usedByLastName: { __type: 'String' },
    usedCredits: { __type: 'Float!' },
  },
  SharedRelationActivityEntry: {
    __typename: { __type: 'String!' },
    credits: { __type: 'Float!' },
    occurredAt: { __type: 'String!' },
    packageName: { __type: 'String' },
    platform: { __type: 'String' },
    sessionName: { __type: 'String' },
    sessionStartTime: { __type: 'String' },
    type: { __type: 'SharedRelationActivityType!' },
    usedByClientId: { __type: 'ID' },
    usedByName: { __type: 'String' },
  },
  ShiftRecurringInvoicesResult: {
    __typename: { __type: 'String!' },
    shifted: { __type: 'Float!' },
    skipped: { __type: '[ShiftRecurringInvoicesSkipped!]!' },
  },
  ShiftRecurringInvoicesSkipped: {
    __typename: { __type: 'String!' },
    reason: { __type: 'String!' },
    recurringInvoiceId: { __type: 'ID!' },
  },
  SignedPolicyAgreements: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    signedAt: { __type: 'String' },
    siteAgreementTemplateId: { __type: 'String!' },
  },
  SignupSignatureUploadTicket: {
    __typename: { __type: 'String!' },
    attemptExpiresAt: { __type: 'String!' },
    expiresAt: { __type: 'String!' },
    reservedSubmissionId: { __type: 'String!' },
    signupAttemptId: { __type: 'String!' },
    uploadHeaders: { __type: '[FormSignatureUploadHeader!]!' },
    uploadId: { __type: 'String!' },
    uploadUrl: { __type: 'String!' },
  },
  Site: {
    __typename: { __type: 'String!' },
    activeSessionCategories: { __type: '[SessionCategory!]!' },
    addressCity: { __type: 'String' },
    addressCountry: { __type: 'String' },
    addressPostalCode: { __type: 'String' },
    addressState: { __type: 'String' },
    addressStreet: { __type: 'String' },
    addressStreet2: { __type: 'String' },
    adminConfigurations: { __type: 'SiteAdminConfigurations' },
    appName: { __type: 'String' },
    businessEmail: { __type: 'String' },
    businessHours: { __type: 'SiteBusinessHours' },
    capacity: { __type: 'Float' },
    clientFeesTemplateId: { __type: 'String' },
    connectedSharedSiteIds: { __type: '[String!]' },
    corePlanLevel: { __type: 'CorePlanLevel' },
    country: { __type: 'Country' },
    countryId: { __type: 'ID' },
    createdAt: { __type: 'String!' },
    currency: { __type: 'Currency' },
    customIntegrations: { __type: '[SiteCustomIntegrations!]' },
    deletedAt: { __type: 'String' },
    description: { __type: 'String' },
    displayBusinessHours: { __type: 'Boolean!' },
    email: { __type: 'String' },
    gatewayCurrentPaymentMethodId: { __type: 'String' },
    gatewayCustomerId: { __type: 'String' },
    hapanaFeesTemplateId: { __type: 'ID' },
    integrations: { __type: 'SiteIntegrations' },
    isDigital: { __type: 'Boolean' },
    isGooglePayReleased: { __type: 'Boolean!' },
    isV2Enabled: { __type: 'Boolean' },
    logoImage: { __type: 'ImagePublicSignedUrl', __args: { input: 'ImagePublicSignedUrlInput!' } },
    membersCount: { __type: 'Float' },
    name: { __type: 'String!' },
    openDate: { __type: 'String' },
    paymentGateway: { __type: 'SitePaymentGatewayField' },
    paymentGatewayOnboardingStatus: { __type: 'SitePaymentGatewayOnboardingStatusInfo' },
    phone: { __type: 'String' },
    phonePrefix: { __type: 'String' },
    planOverrideAllowed: { __type: 'Boolean' },
    planTierOverride: { __type: 'ProductPlanTier' },
    posCategories: { __type: '[CreatePosCategoryResponse!]!' },
    rebateTemplateIds: { __type: '[ID!]' },
    regionId: { __type: 'ID' },
    royaltiesTemplateId: { __type: 'ID' },
    serviceTemplateCategories: { __type: '[CreateServiceTemplateCategoryResponse!]!' },
    settings: { __type: 'SiteSettings' },
    siteId: { __type: 'ID!' },
    smsCreditsBalance: { __type: 'SmsCreditsBalance!' },
    stateId: { __type: 'String' },
    status: { __type: 'SiteStatus!' },
    suppliers: { __type: '[CreateSiteSupplierResponse!]!' },
    timezone: { __type: 'String' },
    updatedAt: { __type: 'String!' },
    v1EncryptedId: { __type: 'String' },
    website: { __type: 'String' },
    workshopType: { __type: 'SiteWorkshopType' },
  },
  SiteAccessPoint: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    deletedAt: { __type: 'String' },
    internalConfig: { __type: 'SiteAccessPointInternalConfig' },
    lastReconcileAt: { __type: 'String' },
    lastReconcileStatus: { __type: 'DoorReconcileStatus' },
    name: { __type: 'String!' },
    provider: { __type: 'AccessProvider!' },
    provisionData: { __type: 'JSONObject' },
    qrCodeGeneratedAt: { __type: 'String' },
    qrCodeUrl: { __type: 'String' },
    reconcileConsecutiveFailures: { __type: 'Float!' },
    siteAccessPointId: { __type: 'String!' },
    siteAccessZoneId: { __type: 'String' },
    siteId: { __type: 'String!' },
    status: { __type: 'SiteAccessPointStatus!' },
    updatedAt: { __type: 'String!' },
  },
  SiteAccessPointCreateInput: {
    externalConfig: { __type: 'JSONObject' },
    internalConfig: { __type: 'SiteAccessPointInternalConfigInput' },
    name: { __type: 'String!' },
    provider: { __type: 'AccessProvider!' },
    provisionData: { __type: 'JSONObject' },
    siteAccessZoneId: { __type: 'String' },
  },
  SiteAccessPointDeviceStatus: {
    __typename: { __type: 'String!' },
    reachability: { __type: 'DeviceReachability!' },
    siteAccessPointId: { __type: 'String!' },
  },
  SiteAccessPointInternalConfig: {
    __typename: { __type: 'String!' },
    accessMode: { __type: 'AccessMode' },
    doorType: { __type: 'DoorType' },
    readerType: { __type: 'ReaderType' },
    timerSeconds: { __type: 'Float' },
  },
  SiteAccessPointInternalConfigInput: {
    accessMode: { __type: 'AccessMode' },
    doorType: { __type: 'DoorType' },
    readerType: { __type: 'ReaderType' },
    timerSeconds: { __type: 'Float' },
  },
  SiteAccessPointLiveDeviceConfig: {
    __typename: { __type: 'String!' },
    lastSeen: { __type: 'String' },
    reachability: { __type: 'DeviceReachability!' },
    readerType: { __type: 'ReaderType' },
    relayTriggerTimeMs: { __type: 'Float' },
    siteAccessPointId: { __type: 'String!' },
  },
  SiteAccessPointUpdateInput: {
    externalConfig: { __type: 'JSONObject' },
    internalConfig: { __type: 'SiteAccessPointInternalConfigInput' },
    name: { __type: 'String' },
    provisionData: { __type: 'JSONObject' },
    qrCodeGeneratedAt: { __type: 'String' },
    qrCodeUrl: { __type: 'String' },
    siteAccessZoneId: { __type: 'String' },
    status: { __type: 'SiteAccessPointStatus' },
  },
  SiteAccessZone: {
    __typename: { __type: 'String!' },
    config: { __type: 'JSONObject' },
    createdAt: { __type: 'String!' },
    isMainZone: { __type: 'Boolean' },
    metadata: { __type: 'JSONObject' },
    name: { __type: 'String!' },
    siteAccessZoneId: { __type: 'String!' },
    siteId: { __type: 'String!' },
    updatedAt: { __type: 'String!' },
  },
  SiteAccessZoneCreateInput: {
    metadata: { __type: 'JSONObject' },
    name: { __type: 'String!' },
    siteId: { __type: 'String!' },
  },
  SiteAccessZoneUpdateInput: {
    config: { __type: 'JSONObject' },
    metadata: { __type: 'JSONObject' },
    name: { __type: 'String' },
  },
  SiteAccountCode: {
    __typename: { __type: 'String!' },
    accountCodeId: { __type: 'ID!' },
    code: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    createdById: { __type: 'ID' },
    deletedAt: { __type: 'String' },
    description: { __type: 'String' },
    siteId: { __type: 'ID!' },
    status: { __type: 'SiteAccountCodeStatus!' },
    title: { __type: 'String!' },
    updatedAt: { __type: 'String!' },
    updatedById: { __type: 'ID' },
  },
  SiteAccountCodeConfig: {
    __typename: { __type: 'String!' },
    accountCodesEnabled: { __type: 'Boolean!' },
    introOfferDefaultAccountCodeId: { __type: 'String' },
  },
  SiteAccountCodeConfigInput: {
    accountCodesEnabled: { __type: 'Boolean' },
    introOfferDefaultAccountCodeId: { __type: 'ID' },
  },
  SiteActiveAlerts: {
    __typename: { __type: 'String!' },
    alerts: { __type: '[ActiveSiteAlert!]!' },
    alertsVersion: { __type: 'String!' },
  },
  SiteAdminConfigPaymentGatewayInput: {
    accountCodesEnabled: { __type: 'Boolean' },
    applePayEnabled: { __type: 'Boolean' },
    enableTerminals: { __type: 'Boolean' },
    ezypayDisplayAccountingCode: { __type: 'String' },
    googlePayEnabled: { __type: 'Boolean' },
    introOfferDefaultAccountCodeId: { __type: 'String' },
    stripeId: { __type: 'String' },
    transactionLimitAmount: { __type: 'Float' },
  },
  SiteAdminConfigurations: {
    __typename: { __type: 'String!' },
    allowToEnableClientMultiplePaymentMethods: { __type: 'Boolean' },
    bankAccountCapabilities: { __type: 'Boolean' },
    displayAccountCreditsTab: { __type: 'Boolean' },
    displayStripeConnectPaymentGateway: { __type: 'Boolean' },
    enableAddOns: { __type: 'Boolean' },
    enableAppAndWebsiteWidgets: { __type: 'Boolean' },
    enableCorporateDashboardAndPublicApi: { __type: 'Boolean' },
    enableDigitalLocations: { __type: 'Boolean' },
    enableDoorAccess: { __type: 'Boolean' },
    enableMembershipPlanChange: { __type: 'Boolean' },
    enableOfflineDoorSync: { __type: 'Boolean' },
    enableSharedSites: { __type: 'Boolean' },
    enableTanningFeatures: { __type: 'Boolean' },
    fees: { __type: 'SiteAdminConfigurationsFees' },
    fobCredentialFormat: { __type: 'SiteAdminConfigurationsFobCredentialFormat' },
    hasBankAccountCapabilities: { __type: 'Boolean' },
    hasBankAccountRefundCapabilities: { __type: 'Boolean' },
    monthlySmsCredits: { __type: 'Float' },
    paymentGateway: { __type: 'SiteAdminConfigurationsPaymentGateway' },
    processingFees: { __type: 'SiteAdminConfigurationsProcessingFees' },
    sms: { __type: 'SiteAdminConfigurationsSms' },
  },
  SiteAdminConfigurationsFees: {
    __typename: { __type: 'String!' },
    brandRebatesTemplateIds: { __type: '[String!]' },
    clientFeesTemplateId: { __type: 'String' },
    hapanaFeesTemplateId: { __type: 'String' },
    royaltiesAndFeesTemplateId: { __type: 'String' },
  },
  SiteAdminConfigurationsFobCredentialFormat: {
    __typename: { __type: 'String!' },
    byteOrder: { __type: 'FobByteOrder!' },
    controller: { __type: 'FobController!' },
    readerFormat: { __type: 'FobReaderFormat!' },
    serialNotation: { __type: 'FobSerialNotation' },
  },
  SiteAdminConfigurationsPaymentGateway: {
    __typename: { __type: 'String!' },
    accountCodesEnabled: { __type: 'Boolean' },
    applePayEnabled: { __type: 'Boolean' },
    enableTerminals: { __type: 'Boolean' },
    ezypayDisplayAccountingCode: { __type: 'String' },
    googlePayEnabled: { __type: 'Boolean' },
    introOfferDefaultAccountCodeId: { __type: 'String' },
    stripeId: { __type: 'String' },
    transactionLimitAmount: { __type: 'Float' },
  },
  SiteAdminConfigurationsProcessingFees: {
    __typename: { __type: 'String!' },
    amexCardProcessingFlatFee: { __type: 'Float' },
    amexCardProcessingPercentageFee: { __type: 'Float' },
    bankProcessingFlatFee: { __type: 'Float' },
    bankProcessingPercentageFee: { __type: 'Float' },
    cardProcessingFlatFee: { __type: 'Float' },
    cardProcessingPercentageFee: { __type: 'Float' },
  },
  SiteAdminConfigurationsSms: {
    __typename: { __type: 'String!' },
    fromName: { __type: 'String' },
    twilioSubaccount: { __type: 'SiteAdminConfigurationsSmsTwilioSubaccount' },
  },
  SiteAdminConfigurationsSmsTwilioSubaccount: {
    __typename: { __type: 'String!' },
    id: { __type: 'String' },
    token: { __type: 'String' },
  },
  SiteAdminConfigurationsUpdateInput: {
    allowToEnableClientMultiplePaymentMethods: { __type: 'Boolean' },
    bankAccountCapabilities: { __type: 'Boolean' },
    displayAccountCreditsTab: { __type: 'Boolean' },
    displayStripeConnectPaymentGateway: { __type: 'Boolean' },
    enableAddOns: { __type: 'Boolean' },
    enableAppAndWebsiteWidgets: { __type: 'Boolean' },
    enableCorporateDashboardAndPublicApi: { __type: 'Boolean' },
    enableDigitalLocations: { __type: 'Boolean' },
    enableDoorAccess: { __type: 'Boolean' },
    enableMembershipPlanChange: { __type: 'Boolean' },
    enableOfflineDoorSync: { __type: 'Boolean' },
    enableSharedSites: { __type: 'Boolean' },
    enableTanningFeatures: { __type: 'Boolean' },
    fees: { __type: 'CreateSiteAdminConfigurationsFeesInput' },
    fobCredentialFormat: { __type: 'CreateSiteAdminConfigurationsFobCredentialFormatInput' },
    hasBankAccountCapabilities: { __type: 'Boolean' },
    hasBankAccountRefundCapabilities: { __type: 'Boolean' },
    monthlySmsCredits: { __type: 'Float' },
    paymentGateway: { __type: 'CreateSiteAdminConfigurationsPaymentGatewayInput' },
    processingFees: { __type: 'CreateSiteAdminConfigurationsProcessingFeesInput' },
    sms: { __type: 'CreateSiteAdminConfigurationsSmsInput' },
  },
  SiteAgreementTemplate: {
    __typename: { __type: 'String!' },
    content: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    effectiveDate: { __type: 'String' },
    isActive: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    requiresSignature: { __type: 'Boolean!' },
    siteAgreementTemplateId: { __type: 'ID!' },
    siteId: { __type: 'ID!' },
    templateUrl: { __type: 'String' },
    type: { __type: 'AgreementType!' },
    updatedAt: { __type: 'String!' },
    validityDays: { __type: 'Float' },
    version: { __type: 'String!' },
  },
  SiteAlertLink: {
    __typename: { __type: 'String!' },
    label: { __type: 'String!' },
    url: { __type: 'String!' },
  },
  SiteAlertListItem: {
    __typename: { __type: 'String!' },
    amenityId: { __type: 'ID' },
    amenityLabel: { __type: 'String' },
    body: { __type: 'String' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'String!' },
    createdByName: { __type: 'String' },
    deletedAt: { __type: 'String' },
    endedAt: { __type: 'String' },
    endedBy: { __type: 'String' },
    endedByName: { __type: 'String' },
    endsAt: { __type: 'String' },
    linkLabel: { __type: 'String' },
    linkUrl: { __type: 'String' },
    marksLocationClosed: { __type: 'Boolean!' },
    showAsPopup: { __type: 'Boolean!' },
    siteAlertId: { __type: 'ID!' },
    siteId: { __type: 'ID!' },
    startsAt: { __type: 'String!' },
    status: { __type: 'SiteAlertStatus!' },
    theme: { __type: 'SiteAlertTheme!' },
    title: { __type: 'String!' },
    updatedAt: { __type: 'String!' },
  },
  SiteAssignability: {
    __typename: { __type: 'String!' },
    isAssignable: { __type: 'Boolean!' },
    missing: { __type: 'MissingPermissions!' },
    missingCount: { __type: 'Int!' },
    name: { __type: 'String!' },
    siteId: { __type: 'ID!' },
  },
  SiteAuditEventsFilterInput: {
    actions: { __type: '[AuditAction!]' },
    affectedUserId: { __type: 'String' },
    corporateId: { __type: 'String' },
    dateRange: { __type: 'AuditEventsFilterDateRangeInput' },
    excludeActions: { __type: '[AuditAction!]' },
    memberId: { __type: 'String' },
    resources: { __type: '[AuditResource!]' },
    searchText: { __type: 'String' },
    severity: { __type: '[AuditSeverity!]' },
    siteId: { __type: 'String' },
    source: { __type: '[AuditSource!]' },
    systemOnly: { __type: 'Boolean' },
    userId: { __type: 'String' },
    visibility: { __type: '[AuditVisibility!]' },
  },
  SiteBusinessHours: {
    __typename: { __type: 'String!' },
    customHours: { __type: 'SiteBusinessHoursCustomHours' },
    endTime: { __type: 'String' },
    exceptions: {
      __type: '[SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleExceptions!]',
    },
    hasCustomHours: { __type: 'Boolean!' },
    is24x7: { __type: 'Boolean' },
    startTime: { __type: 'String' },
    weekly: {
      __type: 'SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleWeekly',
    },
  },
  SiteBusinessHoursCustomHours: {
    __typename: { __type: 'String!' },
    friday: { __type: 'SiteBusinessHoursCustomHoursMonday' },
    monday: { __type: 'SiteBusinessHoursCustomHoursMonday' },
    saturday: { __type: 'SiteBusinessHoursCustomHoursMonday' },
    sunday: { __type: 'SiteBusinessHoursCustomHoursMonday' },
    thursday: { __type: 'SiteBusinessHoursCustomHoursMonday' },
    tuesday: { __type: 'SiteBusinessHoursCustomHoursMonday' },
    wednesday: { __type: 'SiteBusinessHoursCustomHoursMonday' },
  },
  SiteBusinessHoursCustomHoursMonday: {
    __typename: { __type: 'String!' },
    endTime: { __type: 'String!' },
    startTime: { __type: 'String!' },
  },
  SiteChallengeOverview: {
    __typename: { __type: 'String!' },
    activeChallenges: { __type: 'Float!' },
    completionRate: { __type: 'Float!' },
    topChallengeId: { __type: 'String' },
    topChallengeTitle: { __type: 'String' },
    totalActiveEnrollments: { __type: 'Float!' },
  },
  SiteClientsResponse: {
    __typename: { __type: 'String!' },
    clients: { __type: '[SiteClientsResponseClients!]!' },
  },
  SiteClientsResponseClients: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    creditAccountBalance: { __type: 'String' },
    favoriteInstructorIds: { __type: '[String!]' },
    joinDate: { __type: 'String!' },
    lastAttendanceDate: { __type: 'String' },
    lastBillingDate: { __type: 'String' },
    lastBookingDate: { __type: 'String' },
    siteSpecificData: { __type: 'ClientSiteRelationshipSiteSpecificData' },
    updatedAt: { __type: 'String!' },
  },
  SiteCloneAreaCount: {
    __typename: { __type: 'String!' },
    area: { __type: 'SiteCloneArea!' },
    count: { __type: 'Float!' },
    skipped: { __type: 'Float!' },
  },
  SiteCloneImageFailure: {
    __typename: { __type: 'String!' },
    message: { __type: 'String!' },
    sourceId: { __type: 'String!' },
    table: { __type: 'String!' },
  },
  SiteCloneIncludeInput: {
    accountCodes: { __type: 'Boolean!' },
    addOns: { __type: 'Boolean!' },
    agreements: { __type: 'Boolean!' },
    equipmentRegulations: { __type: 'Boolean!' },
    fees: { __type: 'Boolean!' },
    images: { __type: 'Boolean!' },
    integrations: { __type: 'Boolean!' },
    planOverride: { __type: 'Boolean!' },
    productVariableAttributes: { __type: 'Boolean!' },
    promoCodes: { __type: 'Boolean!' },
    rooms: { __type: 'Boolean!' },
    sessionFilters: { __type: 'Boolean!' },
  },
  SiteCloneJob: {
    __typename: { __type: 'String!' },
    areaCounts: { __type: '[SiteCloneAreaCount!]' },
    completedAt: { __type: 'String' },
    createdAt: { __type: 'String!' },
    currentStep: { __type: 'SiteCloneJobStep' },
    errorCode: { __type: 'SiteDuplicateErrorCode' },
    errorMessage: { __type: 'String' },
    imageFailures: { __type: '[SiteCloneImageFailure!]' },
    siteCloneJobId: { __type: 'ID!' },
    sourceSiteId: { __type: 'ID!' },
    status: { __type: 'SiteCloneJobStatus!' },
    targetSiteId: { __type: 'ID' },
    targetSiteName: { __type: 'String!' },
  },
  SiteCloneManifest: {
    __typename: { __type: 'String!' },
    areas: { __type: '[SiteCloneAreaCount!]!' },
    siteId: { __type: 'ID!' },
  },
  SiteClosure: {
    __typename: { __type: 'String!' },
    body: { __type: 'String' },
    closedDates: { __type: '[String!]!' },
    endsAt: { __type: 'String' },
    siteAlertId: { __type: 'ID!' },
    startsAt: { __type: 'String!' },
    status: { __type: 'SiteAlertStatus!' },
    title: { __type: 'String!' },
  },
  SiteClosureSession: {
    __typename: { __type: 'String!' },
    bookedCount: { __type: 'Int!' },
    date: { __type: 'String!' },
    endTime: { __type: 'String!' },
    instructorNames: { __type: '[String!]!' },
    name: { __type: 'String!' },
    sessionId: { __type: 'String!' },
    startTime: { __type: 'String!' },
    waitlistCount: { __type: 'Int!' },
  },
  SiteCommunicationTemplate: {
    __typename: { __type: 'String!' },
    alias: { __type: 'CommunicationTemplateAliases!' },
    allowedPlaceholders: { __type: '[CommunicationTemplatePlaceholders!]!' },
    createdAt: { __type: 'String!' },
    emailBody: { __type: 'String!' },
    emailCcEmail: { __type: 'String' },
    emailCcLocation: { __type: 'Boolean!' },
    emailCopyEmployee: { __type: 'EmailCopyEmployee!' },
    emailDefaultOn: { __type: 'Boolean!' },
    emailEnabled: { __type: 'Boolean!' },
    emailLockedByBrand: { __type: 'Boolean!' },
    emailReplyToEmail: { __type: 'String' },
    emailReplyToName: { __type: 'String' },
    emailSendBefore: { __type: 'Float' },
    emailSendBeforeUnit: { __type: 'EmailSendBeforeUnit' },
    emailSendCalendarAttachment: { __type: 'Boolean!' },
    emailSendEmailAs: { __type: 'EmailSendAs!' },
    emailSendOnlyToActiveClients: { __type: 'Boolean!' },
    emailSubject: { __type: 'String!' },
    emailUseHapanaLayout: { __type: 'Boolean' },
    name: { __type: 'String!' },
    pushLockedByBrand: { __type: 'Boolean!' },
    pushNotificationDefaultOn: { __type: 'Boolean!' },
    pushNotificationEnabled: { __type: 'Boolean!' },
    pushNotificationMessage: { __type: 'String' },
    pushNotificationTitle: { __type: 'String' },
    readOnly: { __type: 'Boolean!' },
    siteCommunicationTemplateId: { __type: 'ID!' },
    siteId: { __type: 'ID!' },
    smsDefaultOn: { __type: 'Boolean!' },
    smsEnabled: { __type: 'Boolean!' },
    smsLockedByBrand: { __type: 'Boolean!' },
    smsMessage: { __type: 'String' },
    targetedServiceTemplateIds: { __type: '[ID!]' },
    updatedAt: { __type: 'String!' },
  },
  SiteCommunicationTemplateById: {
    __typename: { __type: 'String!' },
    alias: { __type: 'CommunicationTemplateAliases!' },
    allowedPlaceholders: { __type: '[CommunicationTemplatePlaceholders!]!' },
    createdAt: { __type: 'String!' },
    emailBody: { __type: 'String!' },
    emailCcEmail: { __type: 'String' },
    emailCcLocation: { __type: 'Boolean!' },
    emailCopyEmployee: { __type: 'EmailCopyEmployee!' },
    emailDefaultOn: { __type: 'Boolean!' },
    emailEnabled: { __type: 'Boolean!' },
    emailLockedByBrand: { __type: 'Boolean!' },
    emailReplyToEmail: { __type: 'String' },
    emailReplyToName: { __type: 'String' },
    emailSendBefore: { __type: 'Float' },
    emailSendBeforeUnit: { __type: 'EmailSendBeforeUnit' },
    emailSendCalendarAttachment: { __type: 'Boolean!' },
    emailSendEmailAs: { __type: 'EmailSendAs!' },
    emailSendOnlyToActiveClients: { __type: 'Boolean!' },
    emailSubject: { __type: 'String!' },
    emailUseHapanaLayout: { __type: 'Boolean' },
    pushLockedByBrand: { __type: 'Boolean!' },
    pushNotificationDefaultOn: { __type: 'Boolean!' },
    pushNotificationEnabled: { __type: 'Boolean!' },
    pushNotificationMessage: { __type: 'String' },
    pushNotificationTitle: { __type: 'String' },
    readOnly: { __type: 'Boolean!' },
    siteCommunicationTemplateId: { __type: 'ID!' },
    siteId: { __type: 'ID!' },
    smsDefaultOn: { __type: 'Boolean!' },
    smsEnabled: { __type: 'Boolean!' },
    smsLockedByBrand: { __type: 'Boolean!' },
    smsMessage: { __type: 'String' },
    targetedServiceTemplateIds: { __type: '[ID!]' },
    updatedAt: { __type: 'String!' },
  },
  SiteCommunicationTemplateEmailPreview: {
    __typename: { __type: 'String!' },
    html: { __type: 'String!' },
    source: { __type: 'TemplateSource!' },
    subject: { __type: 'String!' },
    wrapped: { __type: 'Boolean!' },
  },
  SiteCommunicationTemplatePaginationResultSchema: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'SiteCommunicationTemplatePaginationResultSchemaPageInfo!' },
    results: { __type: '[SiteCommunicationTemplatePaginationResultSchemaResults!]!' },
  },
  SiteCommunicationTemplatePaginationResultSchemaPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  SiteCommunicationTemplatePaginationResultSchemaResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'SiteCommunicationTemplate!' },
  },
  SiteCommunicationTemplateUpdateInput: {
    allowedPlaceholders: { __type: '[CommunicationTemplatePlaceholders!]' },
    emailBody: { __type: 'String' },
    emailCcEmail: { __type: 'String' },
    emailCcLocation: { __type: 'Boolean' },
    emailCopyEmployee: { __type: 'EmailCopyEmployee' },
    emailDefaultOn: { __type: 'Boolean' },
    emailEnabled: { __type: 'Boolean' },
    emailReplyToEmail: { __type: 'String' },
    emailReplyToName: { __type: 'String' },
    emailSendBefore: { __type: 'Float' },
    emailSendBeforeUnit: { __type: 'EmailSendBeforeUnit' },
    emailSendCalendarAttachment: { __type: 'Boolean' },
    emailSendEmailAs: { __type: 'EmailSendAs' },
    emailSendOnlyToActiveClients: { __type: 'Boolean' },
    emailSubject: { __type: 'String' },
    emailUseHapanaLayout: { __type: 'Boolean' },
    pushNotificationDefaultOn: { __type: 'Boolean' },
    pushNotificationEnabled: { __type: 'Boolean' },
    pushNotificationMessage: { __type: 'String' },
    pushNotificationTitle: { __type: 'String' },
    readOnly: { __type: 'Boolean' },
    smsDefaultOn: { __type: 'Boolean' },
    smsEnabled: { __type: 'Boolean' },
    smsMessage: { __type: 'String' },
    targetedServiceTemplateIds: { __type: '[ID!]' },
  },
  SiteCommunicationTemplatesActiveCommunicationTypeInput: {
    operator: { __type: 'String!' },
    value: { __type: 'String!' },
  },
  SiteCoverSettings: {
    __typename: { __type: 'String!' },
    brand: { __type: 'CoverSettingsOverrides!' },
    effective: { __type: 'CoverSettings!' },
    site: { __type: 'CoverSettingsOverrides!' },
    siteId: { __type: 'String!' },
  },
  SiteCustomIntegrations: {
    __typename: { __type: 'String!' },
    integrationId: { __type: 'ID!' },
    keyValues: { __type: '[SiteCustomIntegrationsKeyValues!]!' },
  },
  SiteCustomIntegrationsKeyValues: {
    __typename: { __type: 'String!' },
    key: { __type: 'ID!' },
    value: { __type: 'String' },
  },
  SiteDevices: { __typename: { __type: 'String!' }, devices: { __type: '[SiteDevicesDevices!]!' } },
  SiteDevicesDevices: {
    __typename: { __type: 'String!' },
    busy: { __type: 'Boolean!' },
    busyReason: { __type: 'DeviceBusyReason' },
    busyUntil: { __type: 'String' },
    capabilities: { __type: '[DeviceCapability!]!' },
    createdAt: { __type: 'String!' },
    deviceKind: { __type: 'DeviceKind!' },
    deviceTokenId: { __type: 'String!' },
    inputMode: { __type: 'DeviceInputMode!' },
    label: { __type: 'String' },
    lastSeenAt: { __type: 'String' },
    liveness: { __type: 'DeviceLiveness!' },
    pinFeatures: { __type: 'SiteDevicesDevicesPinFeatures' },
    status: { __type: 'String!' },
  },
  SiteDevicesDevicesPinFeatures: {
    __typename: { __type: 'String!' },
    checkIn: { __type: 'Boolean!' },
    classCheckIn: { __type: 'Boolean!' },
    purchases: { __type: 'Boolean!' },
  },
  SiteDoorAccessEvents: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'SiteDoorAccessEventsPageInfo!' },
    results: { __type: '[SiteDoorAccessEventsResults!]!' },
  },
  SiteDoorAccessEventsPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  SiteDoorAccessEventsResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'DoorAccessEvent!' },
  },
  SiteDuplicateInput: {
    addressCity: { __type: 'String' },
    addressPostalCode: { __type: 'String' },
    addressStreet: { __type: 'String' },
    appName: { __type: 'String' },
    countryId: { __type: 'ID!' },
    email: { __type: 'String!' },
    enableV2: { __type: 'Boolean!' },
    idempotencyKey: { __type: 'ID!' },
    include: { __type: 'SiteCloneIncludeInput!' },
    name: { __type: 'String!' },
    phone: { __type: 'String' },
    regionId: { __type: 'ID' },
    sourceSiteId: { __type: 'ID!' },
    timezone: { __type: 'String!' },
    zoneId: { __type: 'ID!' },
  },
  SiteEntitlements: {
    __typename: { __type: 'String!' },
    activeThemes: { __type: '[ThemeKey!]!' },
    effectivePlan: { __type: 'ProductPlanTier!' },
    eligibleThemes: { __type: '[ThemeKey!]!' },
    entitledFeatures: { __type: '[String!]!' },
  },
  SiteFeeConfig: {
    __typename: { __type: 'String!' },
    clientFeesTemplateId: { __type: 'String' },
    clientFeesTemplateName: { __type: 'String' },
    hapanaFeesTemplateId: { __type: 'String' },
    hapanaFeesTemplateName: { __type: 'String' },
    rebateTemplates: { __type: '[SiteFeeConfigRebateTemplates!]!' },
    siteId: { __type: 'String!' },
    siteName: { __type: 'String!' },
    transactionFeePreference: { __type: 'TransactionFeePreference!' },
  },
  SiteFeeConfigRebateTemplates: {
    __typename: { __type: 'String!' },
    corporatePayoutAccountId: { __type: 'String!' },
    rebateTemplateId: { __type: 'String!' },
    rebateTemplateName: { __type: 'String!' },
  },
  SiteForm: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String' },
    defaultRequiredBefore: { __type: 'FormRequiredBefore' },
    deletedAt: { __type: 'String' },
    description: { __type: 'String!' },
    name: { __type: 'String!' },
    questions: { __type: '[SiteFormQuestion!]!' },
    resultCustomPropertyId: { __type: 'String' },
    resultPropertyMapping: { __type: 'JSON' },
    revision: { __type: 'Float' },
    scoreBands: { __type: '[SiteFormScoreBands!]' },
    scoringEnabled: { __type: 'Boolean' },
    showResultOnProfile: { __type: 'Boolean' },
    showResultToClient: { __type: 'Boolean' },
    siteFormId: { __type: 'String!' },
    siteId: { __type: 'String!' },
    templateKey: { __type: 'String' },
    updatedAt: { __type: 'String' },
  },
  SiteFormDeleteResponse: { __typename: { __type: 'String!' }, deleted: { __type: 'Boolean!' } },
  SiteFormMutationResponse: { __typename: { __type: 'String!' }, updated: { __type: 'Boolean!' } },
  SiteFormQuestion: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String' },
    deletedAt: { __type: 'String' },
    excludeFromScore: { __type: 'Boolean' },
    mustAnswerYes: { __type: 'Boolean' },
    optionScores: { __type: '[Float!]' },
    options: { __type: '[String!]' },
    orderIndex: { __type: 'Float!' },
    required: { __type: 'Boolean' },
    siteCustomPropertyId: { __type: 'String' },
    siteFormId: { __type: 'String!' },
    siteFormQuestionId: { __type: 'String!' },
    title: { __type: 'String!' },
    type: { __type: 'SiteFormQuestionType!' },
    updatedAt: { __type: 'String' },
  },
  SiteFormQuestionCreateInput: {
    options: { __type: '[String!]' },
    siteCustomPropertyId: { __type: 'ID' },
    title: { __type: 'String!' },
    type: { __type: 'SiteFormQuestionType!' },
  },
  SiteFormQuestionOrderResponse: {
    __typename: { __type: 'String!' },
    orderIndex: { __type: 'Float!' },
  },
  SiteFormQuestionUpdateInput: {
    options: { __type: '[String!]' },
    siteCustomPropertyId: { __type: 'ID' },
    title: { __type: 'String' },
    type: { __type: 'SiteFormQuestionType' },
  },
  SiteFormReorderResponse: {
    __typename: { __type: 'String!' },
    updatedCount: { __type: 'Float!' },
  },
  SiteFormScoreBands: {
    __typename: { __type: 'String!' },
    bandId: { __type: 'ID!' },
    description: { __type: 'String' },
    label: { __type: 'String!' },
    max: { __type: 'Float!' },
    min: { __type: 'Float!' },
  },
  SiteFormTemplate: {
    __typename: { __type: 'String!' },
    bandCount: { __type: 'Float!' },
    description: { __type: 'String!' },
    key: { __type: 'String!' },
    name: { __type: 'String!' },
    questionCount: { __type: 'Float!' },
    source: { __type: 'String!' },
  },
  SiteFormUpdateInput: { description: { __type: 'String' }, name: { __type: 'String' } },
  SiteGiftCardExpiryPolicy: {
    __typename: { __type: 'String!' },
    jurisdictionCode: { __type: 'String' },
    jurisdictionName: { __type: 'String' },
    policy: { __type: 'ResolvedGiftCardExpiryPolicy!' },
    siteId: { __type: 'ID!' },
    siteName: { __type: 'String!' },
    stateRequired: { __type: 'Boolean!' },
    timezone: { __type: 'String!' },
  },
  SiteGroup: {
    __typename: { __type: 'String!' },
    corporateId: { __type: 'ID' },
    createdAt: { __type: 'String!' },
    isAllSites: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    siteGroupId: { __type: 'ID!' },
    siteIds: { __type: '[ID!]' },
    sites: { __type: '[SiteReference!]!' },
    updatedAt: { __type: 'String!' },
  },
  SiteGroupAssignability: {
    __typename: { __type: 'String!' },
    isAssignable: { __type: 'Boolean!' },
    missing: { __type: 'MissingPermissions!' },
    missingCount: { __type: 'Int!' },
    name: { __type: 'String!' },
    siteGroupId: { __type: 'ID!' },
  },
  SiteGroups: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'SiteGroupsPageInfo!' },
    results: { __type: '[SiteGroupsResults!]!' },
  },
  SiteGroupsOrderByInput: {
    column: { __type: 'SiteGroupOrderBy!' },
    direction: { __type: 'OrderByDirection!' },
  },
  SiteGroupsPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  SiteGroupsResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'SiteGroup!' },
  },
  SiteGrowStatus: {
    __typename: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
    growLocationId: { __type: 'String' },
    hasAuthentication: { __type: 'Boolean!' },
    hqId: { __type: 'String' },
    isV2Enabled: { __type: 'Boolean!' },
    lastSyncedAt: { __type: 'String' },
    syncStatus: { __type: 'SyncStatus' },
  },
  SiteIntegrations: {
    __typename: { __type: 'String!' },
    accessControls: { __type: 'SiteIntegrationsAccessControls' },
    accuroFit: { __type: 'SiteIntegrationsAccuroFit' },
    barcodeUrl: { __type: 'SiteIntegrationsBarcodeUrl' },
    calendarSync: { __type: 'SiteIntegrationsCalendarSync' },
    classPass: { __type: 'SiteIntegrationsClassPass' },
    egym: { __type: 'SiteIntegrationsEgym' },
    externalFeedbackLink: { __type: 'SiteIntegrationsExternalFeedbackLink' },
    facebookPixel: { __type: 'SiteIntegrationsFacebookPixel' },
    fitnessPassport: { __type: 'SiteIntegrationsFitnessPassport' },
    frontDeskKiosk: { __type: 'SiteIntegrationsFrontDeskKiosk' },
    googleTagManager: { __type: 'SiteIntegrationsGoogleTagManager' },
    grow: { __type: 'SiteIntegrationsGrow' },
    hapanaAccessController: { __type: 'SiteIntegrationsHapanaAccessController' },
    hapanaApiKey: { __type: 'SiteIntegrationsHapanaApiKey' },
    importClients: { __type: 'SiteIntegrationsImportClients' },
    spivi: { __type: 'SiteIntegrationsSpivi' },
    tanning: { __type: 'SiteIntegrationsTanning' },
    tanningHealth: { __type: 'SiteIntegrationsTanningHealth' },
    topaz: { __type: 'SiteIntegrationsTopaz' },
    wellhub: { __type: 'SiteIntegrationsWellhub' },
    zapier: { __type: 'SiteIntegrationsZapier' },
    zoom: { __type: 'SiteIntegrationsZoom' },
  },
  SiteIntegrationsAccessControls: {
    __typename: { __type: 'String!' },
    doors: { __type: '[SiteIntegrationsAccessControlsDoors!]' },
  },
  SiteIntegrationsAccessControlsDoors: {
    __typename: { __type: 'String!' },
    accessGroupId: { __type: 'String' },
    accessHours: { __type: 'Boolean!' },
    doorId: { __type: 'String!' },
    endTime: { __type: 'String' },
    label: { __type: 'String!' },
    provider: { __type: 'AccessControlProvider!' },
    sessionTypes: { __type: '[String!]!' },
    startTime: { __type: 'String' },
  },
  SiteIntegrationsAccuroFit: { __typename: { __type: 'String!' }, clientId: { __type: 'String' } },
  SiteIntegrationsBarcodeUrl: {
    __typename: { __type: 'String!' },
    barcodeCheckInUrl: { __type: 'String' },
  },
  SiteIntegrationsCalendarSync: {
    __typename: { __type: 'String!' },
    calendars: { __type: '[SiteIntegrationsCalendarSyncCalendars!]' },
  },
  SiteIntegrationsCalendarSyncCalendars: {
    __typename: { __type: 'String!' },
    calendarId: { __type: 'String!' },
    calendarLink: { __type: 'String!' },
    calendarName: { __type: 'String!' },
  },
  SiteIntegrationsClassPass: {
    __typename: { __type: 'String!' },
    classPassSpotsPerSession: { __type: 'Float' },
    enabled: { __type: 'Boolean!' },
  },
  SiteIntegrationsEgym: {
    __typename: { __type: 'String!' },
    activeMembershipType: { __type: 'EgymMembershipType!' },
    consecutiveFailures: { __type: 'Float' },
    enabled: { __type: 'Boolean!' },
    lastError: { __type: 'String' },
    lastFailureAt: { __type: 'String' },
    lastSuccessAt: { __type: 'String' },
  },
  SiteIntegrationsExternalFeedbackLink: {
    __typename: { __type: 'String!' },
    url: { __type: 'String' },
  },
  SiteIntegrationsFacebookPixel: {
    __typename: { __type: 'String!' },
    events: { __type: '[SiteIntegrationsFacebookPixelEvents!]' },
    pixelId: { __type: 'String' },
  },
  SiteIntegrationsFacebookPixelEvents: {
    __typename: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
    facebookEventName: { __type: 'String!' },
    name: { __type: 'String!' },
  },
  SiteIntegrationsFitnessPassport: {
    __typename: { __type: 'String!' },
    deviceTokenSuffix: { __type: 'String' },
    enabled: { __type: 'Boolean!' },
    failurePolicy: { __type: 'FitnessPassportFailurePolicy!' },
    lastTestError: { __type: 'String' },
    lastTestOutcome: { __type: 'FitnessPassportConnectionState' },
    lastTestedAt: { __type: 'String' },
    siteTokenSuffix: { __type: 'String' },
  },
  SiteIntegrationsFrontDeskKiosk: {
    __typename: { __type: 'String!' },
    betaVersion: { __type: 'SiteIntegrationsFrontDeskKioskBetaVersion' },
    kioskDefaults: { __type: 'SiteIntegrationsFrontDeskKioskKioskDefaults' },
    kioskUrlV1: { __type: 'String' },
  },
  SiteIntegrationsFrontDeskKioskBetaVersion: {
    __typename: { __type: 'String!' },
    classCheckInEnabled: { __type: 'Boolean' },
    classCheckInRequirePolicies: { __type: 'Boolean' },
    classCheckInSpotBooking: { __type: 'Boolean' },
    enabled: { __type: 'Boolean' },
    introOffersEnabled: { __type: 'Boolean' },
    kioskPinHash: { __type: 'String' },
    kioskPinSetAt: { __type: 'String' },
    kioskSessionId: { __type: 'String' },
    kioskSessionValidityDays: { __type: 'Float' },
    kioskUrlV2: { __type: 'String' },
    packagesMembershipsEnabled: { __type: 'Boolean' },
  },
  SiteIntegrationsFrontDeskKioskKioskDefaults: {
    __typename: { __type: 'String!' },
    checkIn: { __type: 'Boolean' },
    classCheckIn: { __type: 'Boolean' },
    forms: { __type: 'Boolean' },
    introOffers: { __type: 'Boolean' },
    manageAccount: { __type: 'Boolean' },
    packages: { __type: 'Boolean' },
  },
  SiteIntegrationsGoogleTagManager: {
    __typename: { __type: 'String!' },
    gtmId: { __type: 'String' },
  },
  SiteIntegrationsGrow: {
    __typename: { __type: 'String!' },
    authentication: { __type: 'SiteIntegrationsGrowAuthentication' },
    enabled: { __type: 'Boolean!' },
    growLocationId: { __type: 'String' },
    hqId: { __type: 'String' },
    lastCollect: { __type: 'SiteIntegrationsGrowLastCollect' },
  },
  SiteIntegrationsGrowAuthentication: {
    __typename: { __type: 'String!' },
    accessToken: { __type: 'String!' },
    expiresAt: { __type: 'String!' },
    refreshToken: { __type: 'String!' },
  },
  SiteIntegrationsGrowLastCollect: {
    __typename: { __type: 'String!' },
    full: { __type: 'String' },
    partial: { __type: 'String' },
  },
  SiteIntegrationsHapanaAccessController: {
    __typename: { __type: 'String!' },
    accessPoints: { __type: '[SiteIntegrationsHapanaAccessControllerAccessPoints!]' },
    groups: { __type: '[SiteIntegrationsHapanaAccessControllerGroups!]' },
  },
  SiteIntegrationsHapanaAccessControllerAccessPoints: {
    __typename: { __type: 'String!' },
    accessPointId: { __type: 'String' },
    accessPointName: { __type: 'String!' },
    groupName: { __type: 'String!' },
    provisionCode: { __type: 'String!' },
  },
  SiteIntegrationsHapanaAccessControllerGroups: {
    __typename: { __type: 'String!' },
    groupId: { __type: 'String' },
    groupName: { __type: 'String!' },
  },
  SiteIntegrationsHapanaApiKey: { __typename: { __type: 'String!' }, apiKey: { __type: 'String' } },
  SiteIntegrationsImportClients: {
    __typename: { __type: 'String!' },
    enabled: { __type: 'Boolean' },
    lastImportDate: { __type: 'String' },
  },
  SiteIntegrationsSpivi: {
    __typename: { __type: 'String!' },
    boxId: { __type: 'String' },
    password: { __type: 'String' },
    publicKey: { __type: 'String' },
    siteId: { __type: 'String' },
    sourceName: { __type: 'String' },
  },
  SiteIntegrationsTanning: {
    __typename: { __type: 'String!' },
    apiKey: { __type: 'String' },
    externalApiKey: { __type: 'String' },
    externalApiUrl: { __type: 'String' },
    maintenanceEmail: { __type: 'String' },
  },
  SiteIntegrationsTanningHealth: {
    __typename: { __type: 'String!' },
    consecutiveStartFailures: { __type: 'Float' },
    lastBedUpdateAt: { __type: 'String' },
    lastRegisteredAt: { __type: 'String' },
    lastStartError: { __type: 'SiteIntegrationsTanningHealthLastStartError' },
    lastStartFailureAt: { __type: 'String' },
    lastStartSuccessAt: { __type: 'String' },
  },
  SiteIntegrationsTanningHealthLastStartError: {
    __typename: { __type: 'String!' },
    connectorCode: { __type: 'String' },
    kind: { __type: 'TanningConnectorErrorKind!' },
    message: { __type: 'String!' },
  },
  SiteIntegrationsTopaz: { __typename: { __type: 'String!' }, enabled: { __type: 'Boolean!' } },
  SiteIntegrationsWellhub: {
    __typename: { __type: 'String!' },
    connectedAt: { __type: 'String' },
    enabled: { __type: 'Boolean!' },
    gymId: { __type: 'String' },
    gymName: { __type: 'String' },
  },
  SiteIntegrationsZapier: {
    __typename: { __type: 'String!' },
    webhooks: { __type: 'SiteIntegrationsZapierWebhooks' },
  },
  SiteIntegrationsZapierWebhooks: {
    __typename: { __type: 'String!' },
    client: { __type: 'String' },
    clientCheckIn: { __type: 'String' },
    firstSessionBooking: { __type: 'String' },
    lead: { __type: 'String' },
    membershipCancellation: { __type: 'String' },
    membershipSuspension: { __type: 'String' },
    packagePurchase: { __type: 'String' },
    sessionBooking: { __type: 'String' },
  },
  SiteIntegrationsZoom: {
    __typename: { __type: 'String!' },
    accountId: { __type: 'String' },
    authorized: { __type: 'Boolean!' },
    connectedAt: { __type: 'String' },
    connectedUserEmail: { __type: 'String' },
    connectedUserId: { __type: 'String' },
    userId: { __type: 'String' },
  },
  SiteLateCancelFee: {
    __typename: { __type: 'String!' },
    automaticCharge: { __type: 'Boolean!' },
    createdAt: { __type: 'String!' },
    creditRefund: { __type: 'Boolean!' },
    deletedAt: { __type: 'String' },
    lateCancelFeeId: { __type: 'ID!' },
    name: { __type: 'String!' },
    price: { __type: 'Numeric!' },
    revenueTagId: { __type: 'ID' },
    siteId: { __type: 'ID!' },
    taxSettingIds: { __type: '[ID!]' },
    unlimitedCreditsOnly: { __type: 'Boolean!' },
    updatedAt: { __type: 'String!' },
  },
  SiteLateCancelFeeSaveInput: {
    automaticCharge: { __type: 'Boolean!' },
    creditRefund: { __type: 'Boolean!' },
    lateCancelFeeId: { __type: 'ID' },
    name: { __type: 'String!' },
    price: { __type: 'Numeric!' },
    revenueTagId: { __type: 'ID' },
    taxSettingIds: { __type: '[ID!]' },
    unlimitedCreditsOnly: { __type: 'Boolean!' },
  },
  SiteLateCancelFeeUsage: {
    __typename: { __type: 'String!' },
    recurringSessions: { __type: '[SiteLateCancelFeeUsageRecurringSession!]!' },
    sessionTemplates: { __type: '[SiteLateCancelFeeUsageTemplate!]!' },
    sessions: { __type: '[SiteLateCancelFeeUsageSession!]!' },
  },
  SiteLateCancelFeeUsageEntry: {
    __typename: { __type: 'String!' },
    lateCancelFeeId: { __type: 'ID!' },
    usage: { __type: 'SiteLateCancelFeeUsage!' },
  },
  SiteLateCancelFeeUsageRecurringSession: {
    __typename: { __type: 'String!' },
    daysOfWeek: { __type: '[String!]!' },
    name: { __type: 'String!' },
    recurringSessionsId: { __type: 'ID!' },
    startTime: { __type: 'String!' },
  },
  SiteLateCancelFeeUsageSession: {
    __typename: { __type: 'String!' },
    date: { __type: 'String!' },
    name: { __type: 'String!' },
    sessionId: { __type: 'ID!' },
    startTime: { __type: 'String!' },
  },
  SiteLateCancelFeeUsageTemplate: {
    __typename: { __type: 'String!' },
    name: { __type: 'String!' },
    sessionTemplateId: { __type: 'ID!' },
  },
  SiteLiveOccupancy: {
    __typename: { __type: 'String!' },
    alertsVersion: { __type: 'String!' },
    isVisibleToGuests: { __type: 'Boolean!' },
    labelKey: { __type: 'LiveOccupancyLabelKey!' },
    nextOpening: { __type: 'NextOpening' },
    status: { __type: 'LiveOccupancyStatus!' },
    updatedAt: { __type: 'String!' },
    value: { __type: 'Int' },
  },
  SiteLocation: {
    __typename: { __type: 'String!' },
    addressLine1: { __type: 'String' },
    addressLine2: { __type: 'String' },
    channelId: { __type: 'String' },
    city: { __type: 'String' },
    country: { __type: 'String' },
    createdAt: { __type: 'String!' },
    deletedAt: { __type: 'String' },
    isDefault: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    postalCode: { __type: 'String' },
    rooms: { __type: '[SiteLocationRoom!]' },
    siteId: { __type: 'String!' },
    siteLocationId: { __type: 'String!' },
    state: { __type: 'String' },
    type: { __type: 'SiteLocationType!' },
    updatedAt: { __type: 'String!' },
  },
  SiteLocationRoom: {
    __typename: { __type: 'String!' },
    allowOverlapping: { __type: 'Boolean!' },
    createdAt: { __type: 'String!' },
    customHours: { __type: 'SiteLocationRoomCustomHours' },
    deletedAt: { __type: 'String' },
    endTime: { __type: 'String' },
    hasResourceBooking: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    roomResourceTemplateId: { __type: 'String' },
    sameHoursAsLocation: { __type: 'Boolean!' },
    siteId: { __type: 'String!' },
    siteLocationId: { __type: 'String!' },
    siteLocationRoomId: { __type: 'String!' },
    startTime: { __type: 'String' },
    updatedAt: { __type: 'String!' },
  },
  SiteLocationRoomCustomHours: {
    __typename: { __type: 'String!' },
    friday: { __type: 'SiteLocationRoomCustomHoursMonday' },
    monday: { __type: 'SiteLocationRoomCustomHoursMonday' },
    saturday: { __type: 'SiteLocationRoomCustomHoursMonday' },
    sunday: { __type: 'SiteLocationRoomCustomHoursMonday' },
    thursday: { __type: 'SiteLocationRoomCustomHoursMonday' },
    tuesday: { __type: 'SiteLocationRoomCustomHoursMonday' },
    wednesday: { __type: 'SiteLocationRoomCustomHoursMonday' },
  },
  SiteLocationRoomCustomHoursMonday: {
    __typename: { __type: 'String!' },
    endTime: { __type: 'String!' },
    startTime: { __type: 'String!' },
  },
  SiteMemberAppSettingsResult: {
    __typename: { __type: 'String!' },
    settings: { __type: 'SiteMemberAppSettingsResultSettings!' },
    staffInsights: { __type: 'SiteMemberAppStaffInsights!' },
  },
  SiteMemberAppSettingsResultSettings: {
    __typename: { __type: 'String!' },
    locationInformation: { __type: 'SiteMemberAppSettingsResultSettingsLocationInformation!' },
    planYourVisit: { __type: 'SiteMemberAppSettingsResultSettingsPlanYourVisit!' },
  },
  SiteMemberAppSettingsResultSettingsLocationInformation: {
    __typename: { __type: 'String!' },
    amenities: { __type: 'SiteMemberAppSettingsResultSettingsLocationInformationAmenities!' },
    blocks: { __type: '[SiteSettingsLocationMemberAppLocationInformationBlocks!]!' },
    heading: { __type: 'String!' },
    isEnabled: { __type: 'Boolean!' },
    staffedHours: { __type: 'SiteMemberAppSettingsResultSettingsLocationInformationStaffedHours!' },
  },
  SiteMemberAppSettingsResultSettingsLocationInformationAmenities: {
    __typename: { __type: 'String!' },
    isEnabled: { __type: 'Boolean!' },
    items: { __type: '[SiteSettingsLocationMemberAppLocationInformationAmenitiesItems!]!' },
    maxVisible: { __type: 'Int!' },
  },
  SiteMemberAppSettingsResultSettingsLocationInformationStaffedHours: {
    __typename: { __type: 'String!' },
    isEnabled: { __type: 'Boolean!' },
    label: { __type: 'String!' },
    schedule: { __type: 'SiteSettingsLocationMemberAppLocationInformationStaffedHoursSchedule!' },
  },
  SiteMemberAppSettingsResultSettingsPlanYourVisit: {
    __typename: { __type: 'String!' },
    forecast: { __type: 'SiteMemberAppSettingsResultSettingsPlanYourVisitForecast!' },
    isEnabled: { __type: 'Boolean!' },
    isVisibleToGuests: { __type: 'Boolean!' },
    liveOccupancy: { __type: 'SiteMemberAppSettingsResultSettingsPlanYourVisitLiveOccupancy!' },
    title: { __type: 'String!' },
  },
  SiteMemberAppSettingsResultSettingsPlanYourVisitForecast: {
    __typename: { __type: 'String!' },
    chartEndHour: { __type: 'Int' },
    chartStartHour: { __type: 'Int' },
    isEnabled: { __type: 'Boolean!' },
    lookbackWeeks: { __type: 'Int!' },
  },
  SiteMemberAppSettingsResultSettingsPlanYourVisitLiveOccupancy: {
    __typename: { __type: 'String!' },
    averageVisitMinutes: { __type: 'Int!' },
    bandSize: { __type: 'Int!' },
    displayMode: { __type: 'OccupancyDisplayMode!' },
    hideWhenClosed: { __type: 'Boolean!' },
    isEnabled: { __type: 'Boolean!' },
    privacyFloor: { __type: 'Int!' },
  },
  SiteMemberAppStaffInsights: {
    __typename: { __type: 'String!' },
    forecast: { __type: 'SiteVisitForecastInsights' },
    liveEstimate: { __type: 'Int' },
    liveWindowMinutes: { __type: 'Int!' },
  },
  SiteNoShowFee: {
    __typename: { __type: 'String!' },
    automaticCharge: { __type: 'Boolean!' },
    createdAt: { __type: 'String!' },
    creditRefund: { __type: 'Boolean!' },
    deletedAt: { __type: 'String' },
    name: { __type: 'String!' },
    noShowFeeId: { __type: 'ID!' },
    price: { __type: 'Numeric!' },
    revenueTagId: { __type: 'ID' },
    siteId: { __type: 'ID!' },
    taxSettingIds: { __type: '[ID!]' },
    unlimitedCreditsOnly: { __type: 'Boolean!' },
    updatedAt: { __type: 'String!' },
  },
  SiteNoShowFeeSaveInput: {
    automaticCharge: { __type: 'Boolean!' },
    creditRefund: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    noShowFeeId: { __type: 'ID' },
    price: { __type: 'Numeric!' },
    revenueTagId: { __type: 'ID' },
    taxSettingIds: { __type: '[ID!]' },
    unlimitedCreditsOnly: { __type: 'Boolean!' },
  },
  SiteNoShowFeeUsage: {
    __typename: { __type: 'String!' },
    recurringSessions: { __type: '[SiteNoShowFeeUsageRecurringSession!]!' },
    sessionTemplates: { __type: '[SiteNoShowFeeUsageTemplate!]!' },
    sessions: { __type: '[SiteNoShowFeeUsageSession!]!' },
  },
  SiteNoShowFeeUsageEntry: {
    __typename: { __type: 'String!' },
    noShowFeeId: { __type: 'ID!' },
    usage: { __type: 'SiteNoShowFeeUsage!' },
  },
  SiteNoShowFeeUsageRecurringSession: {
    __typename: { __type: 'String!' },
    daysOfWeek: { __type: '[String!]!' },
    name: { __type: 'String!' },
    recurringSessionsId: { __type: 'ID!' },
    startTime: { __type: 'String!' },
  },
  SiteNoShowFeeUsageSession: {
    __typename: { __type: 'String!' },
    date: { __type: 'String!' },
    name: { __type: 'String!' },
    sessionId: { __type: 'ID!' },
    startTime: { __type: 'String!' },
  },
  SiteNoShowFeeUsageTemplate: {
    __typename: { __type: 'String!' },
    name: { __type: 'String!' },
    sessionTemplateId: { __type: 'ID!' },
  },
  SitePaymentAuthorisationConfig: {
    __typename: { __type: 'String!' },
    bankDebitAuthorisation: { __type: 'SitePaymentAuthorisationConfigBankDebitAuthorisation' },
    cancellationPolicy: { __type: 'String' },
    customerServiceContact: { __type: 'String' },
    depositNote: { __type: 'String' },
    legalEntityName: { __type: 'String' },
    salesTaxNote: { __type: 'String' },
    template: { __type: 'String' },
  },
  SitePaymentAuthorisationConfigBankDebitAuthorisation: {
    __typename: { __type: 'String!' },
    coversLocationsFrom: { __type: 'String!' },
    evidenceReference: { __type: 'String!' },
    originatorName: { __type: 'String!' },
  },
  SitePaymentGatewayEzypayField: {
    __typename: { __type: 'String!' },
    isSandbox: { __type: 'Boolean' },
    merchantId: { __type: 'String' },
    merchantUsername: { __type: 'String' },
    paymentContactEmail: { __type: 'String' },
    sitePaymentGatewayId: { __type: 'ID' },
  },
  SitePaymentGatewayField: {
    __typename: { __type: 'String!' },
    current: { __type: 'String' },
    ezypay: { __type: 'SitePaymentGatewayEzypayField' },
    isSandbox: { __type: 'Boolean' },
    stripeConnect: { __type: 'SitePaymentGatewayStripeConnectField' },
  },
  SitePaymentGatewayInfo: {
    __typename: { __type: 'String!' },
    countryCode: { __type: 'String' },
    gatewayBankMethodName: { __type: 'String' },
    gatewayManagesFailedPaymentFees: { __type: 'Boolean!' },
    hasBankAccountCapabilities: { __type: 'Boolean!' },
    hasBankAccountRefundCapabilities: { __type: 'Boolean!' },
    paymentGatewayPublishableKey: { __type: 'String' },
    paymentGatewayType: { __type: 'String' },
    siteId: { __type: 'ID!' },
    supportsAccountCodes: { __type: 'Boolean!' },
  },
  SitePaymentGatewayOnboardingStatusInfo: {
    __typename: { __type: 'String!' },
    hasEventuallyDueRequirements: { __type: 'Boolean!' },
    onboardingStatus: { __type: 'String' },
    requiresAttention: { __type: 'Boolean!' },
  },
  SitePaymentGatewayStripeConnectField: {
    __typename: { __type: 'String!' },
    chargesEnabled: { __type: 'Boolean' },
    connectionStatus: { __type: 'String' },
    detailsSubmitted: { __type: 'Boolean' },
    isLegacySharedAccount: { __type: 'Boolean' },
    isSandbox: { __type: 'Boolean' },
    paymentContactEmail: { __type: 'String' },
    payoutFrequency: { __type: 'SitePaymentGatewayStripeConnectFieldPayoutFrequency' },
    payoutsEnabled: { __type: 'Boolean' },
    requirements: { __type: 'SitePaymentGatewayStripeConnectRequirements' },
    siteGatewayAccountId: { __type: 'String' },
  },
  SitePaymentGatewayStripeConnectFieldPayoutFrequency: {
    __typename: { __type: 'String!' },
    current: { __type: 'String' },
    onStripe: { __type: 'String' },
  },
  SitePaymentGatewayStripeConnectRequirements: {
    __typename: { __type: 'String!' },
    currentDeadline: { __type: 'Float' },
    currentlyDue: { __type: '[String!]!' },
    disabledReason: { __type: 'String' },
    eventuallyDue: { __type: '[String!]!' },
    pastDue: { __type: '[String!]!' },
    pendingVerification: { __type: '[String!]!' },
  },
  SitePaymentMethodDetails: {
    __typename: { __type: 'String!' },
    brand: { __type: 'String!' },
    expMonth: { __type: 'Float!' },
    expYear: { __type: 'Float!' },
    last4: { __type: 'String!' },
    paymentMethodId: { __type: 'String!' },
  },
  SitePayrollTier: {
    __typename: { __type: 'String!' },
    assignments: { __type: '[SitePayrollTierAssignments!]!' },
    configurations: { __type: '[SitePayrollTierConfigurations!]!' },
    createdAt: { __type: 'String!' },
    deletedAt: { __type: 'String' },
    name: { __type: 'String!' },
    siteId: { __type: 'ID!' },
    sitePayrollTierId: { __type: 'ID!' },
    updatedAt: { __type: 'String!' },
  },
  SitePayrollTierAssignments: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    createdByStaffUserId: { __type: 'ID' },
    endDate: { __type: 'String' },
    futureAssignmentDate: { __type: 'String' },
    payrollTierAssignmentId: { __type: 'ID!' },
    siteId: { __type: 'ID!' },
    sitePayrollTierId: { __type: 'ID!' },
    staffUserId: { __type: 'ID!' },
    staffUserName: { __type: 'String' },
    startDate: { __type: 'String!' },
    updatedAt: { __type: 'String!' },
  },
  SitePayrollTierConfigurations: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    deletedAt: { __type: 'String' },
    payrollTierConfigurationId: { __type: 'ID!' },
    payrollType: { __type: 'PayrollType!' },
    rates: { __type: 'SitePayrollTierConfigurationsRates!' },
    siteId: { __type: 'ID!' },
    sitePayrollTierId: { __type: 'ID!' },
    siteSessionTypeId: { __type: 'ID' },
    siteSessionTypeName: { __type: 'String' },
    type: { __type: 'PayrollTierType!' },
    updatedAt: { __type: 'String!' },
  },
  SitePayrollTierConfigurationsRates: {
    __typename: { __type: 'String!' },
    bonusClassFull: { __type: 'Float' },
    bonusFlat: { __type: 'Float' },
    bonusPerClient: { __type: 'Float' },
    clientOver: { __type: 'Float' },
    flat: { __type: 'Float' },
    hourly: { __type: 'Float' },
    perHead: { __type: 'Float' },
    percentage: { __type: 'Float' },
    unlimitedFixed: { __type: 'Float' },
  },
  SitePayrollTiers: {
    __typename: { __type: 'String!' },
    id: { __type: 'ID!' },
    name: { __type: 'String!' },
  },
  SitePlanYourVisit: {
    __typename: { __type: 'String!' },
    isVisibleToGuests: { __type: 'Boolean!' },
    locationInformation: { __type: 'MemberLocationInformation' },
    planYourVisit: { __type: 'PlanYourVisitWidget' },
    siteId: { __type: 'ID!' },
    timezone: { __type: 'String!' },
  },
  SitePolicy: {
    __typename: { __type: 'String!' },
    acceptanceMethod: { __type: 'PolicyAcceptanceMethod!' },
    content: { __type: 'String!' },
    createdAt: { __type: 'String' },
    deletedAt: { __type: 'String' },
    equipmentScope: { __type: '[PolicyEquipmentScope!]!' },
    guardianInPersonOnly: { __type: 'Boolean!' },
    isRequiredToAgree: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    renewalMonths: { __type: 'Float' },
    requiredForEquipmentUse: { __type: 'Boolean!' },
    signerRule: { __type: 'PolicySignerRule!' },
    siteId: { __type: 'String!' },
    sitePolicyId: { __type: 'String!' },
    updatedAt: { __type: 'String' },
    updatedByStaffUserId: { __type: 'String' },
    updatedByStaffUserName: { __type: 'String' },
  },
  SitePolicyPublishResult: {
    __typename: { __type: 'String!' },
    cancelledRevisionIds: { __type: '[ID!]!' },
    impactCount: { __type: 'Float!' },
    revision: { __type: 'SitePolicyRevision!' },
  },
  SitePolicyRevision: {
    __typename: { __type: 'String!' },
    acceptanceGeneration: { __type: 'Float!' },
    acceptanceMethod: { __type: 'PolicyAcceptanceMethod!' },
    attestationRevisionId: { __type: 'ID' },
    cancelledAt: { __type: 'String' },
    cancelledByStaffUserId: { __type: 'ID' },
    content: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    disclosureRevisionId: { __type: 'ID' },
    effectiveFrom: { __type: 'String' },
    equipmentScope: { __type: '[PolicyEquipmentScope!]!' },
    guardianInPersonOnly: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    publishedAt: { __type: 'String!' },
    publishedByStaffUserId: { __type: 'ID' },
    renewalMonths: { __type: 'Float' },
    requiredForEquipmentUse: { __type: 'Boolean!' },
    revisionId: { __type: 'ID!' },
    revisionNumber: { __type: 'Float!' },
    revisionSha256: { __type: 'String!' },
    signerRule: { __type: 'PolicySignerRule!' },
    siteId: { __type: 'ID!' },
    sitePolicyId: { __type: 'ID!' },
    status: { __type: 'PolicyRevisionStatus!' },
  },
  SitePolicyUpdateInput: {
    acceptanceMethod: { __type: 'PolicyAcceptanceMethod' },
    content: { __type: 'String' },
    effectiveFrom: { __type: 'String' },
    equipmentScope: { __type: '[PolicyEquipmentScope!]' },
    guardianInPersonOnly: { __type: 'Boolean' },
    isRequiredToAgree: { __type: 'Boolean' },
    name: { __type: 'String' },
    renewalMonths: { __type: 'Float' },
    requireReacceptance: { __type: 'Boolean' },
    requiredForEquipmentUse: { __type: 'Boolean' },
    signerRule: { __type: 'PolicySignerRule' },
  },
  SitePolicyUpdateResult: {
    __typename: { __type: 'String!' },
    acceptanceMethod: { __type: 'PolicyAcceptanceMethod!' },
    content: { __type: 'String!' },
    createdAt: { __type: 'String' },
    deletedAt: { __type: 'String' },
    equipmentScope: { __type: '[PolicyEquipmentScope!]!' },
    guardianInPersonOnly: { __type: 'Boolean!' },
    isRequiredToAgree: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    publishResult: { __type: 'SitePolicyPublishResult' },
    renewalMonths: { __type: 'Float' },
    requiredForEquipmentUse: { __type: 'Boolean!' },
    signerRule: { __type: 'PolicySignerRule!' },
    siteId: { __type: 'String!' },
    sitePolicyId: { __type: 'String!' },
    updatedAt: { __type: 'String' },
    updatedByStaffUserId: { __type: 'String' },
    updatedByStaffUserName: { __type: 'String' },
  },
  SitePreview: {
    __typename: { __type: 'String!' },
    name: { __type: 'String!' },
    siteId: { __type: 'ID!' },
  },
  SiteRecurringWorkshop: {
    __typename: { __type: 'String!' },
    name: { __type: 'String!' },
    recurrenceDaysOfWeek: { __type: '[DayOfWeek!]' },
    recurrenceInterval: { __type: 'Float!' },
    recurrenceType: { __type: 'RecurrenceType!' },
    recurringSessionsId: { __type: 'String!' },
    startTime: { __type: 'String!' },
  },
  SiteReference: {
    __typename: { __type: 'String!' },
    name: { __type: 'String!' },
    siteId: { __type: 'ID!' },
  },
  SiteRoomResourceTemplateProperty: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    defaultValue: { __type: 'String' },
    isRequired: { __type: 'Boolean!' },
    name: { __type: 'String' },
    orderIndex: { __type: 'Float!' },
    primaryPropertyType: { __type: 'RoomResourceTemplateBookingPropertyTypes' },
    roomResourceTemplateId: { __type: 'String!' },
    siteCustomPropertyId: { __type: 'String' },
    siteId: { __type: 'String!' },
    siteRoomResourceTemplatePropertyId: { __type: 'String!' },
    type: { __type: 'SiteRoomResourceTemplatePropertyTypes!' },
  },
  SiteRoomResourceTemplateResponse: {
    __typename: { __type: 'String!' },
    bookingProperties: { __type: '[SiteRoomResourceTemplateProperty!]' },
    boxId: { __type: 'Float' },
    createdAt: { __type: 'String!' },
    deletedAt: { __type: 'String' },
    description: { __type: 'String' },
    isDefault: { __type: 'Boolean!' },
    isDraft: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    roomResourceTemplateId: { __type: 'String!' },
    siteId: { __type: 'String!' },
    spotHeight: { __type: 'Float' },
    spotWidth: { __type: 'Float' },
    spots: { __type: '[SiteRoomResourceTemplateResponseSpots!]!' },
    templateImage: { __type: 'RoomResourceTemplateImage' },
    updatedAt: { __type: 'String!' },
  },
  SiteRoomResourceTemplateResponseSpots: {
    __typename: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
    equipmentType: { __type: 'EquipmentType!' },
    height: { __type: 'Float!' },
    name: { __type: 'String!' },
    position: { __type: 'String!' },
    width: { __type: 'Float!' },
    x: { __type: 'Float!' },
    y: { __type: 'Float!' },
  },
  SiteSessionType: {
    __typename: { __type: 'String!' },
    allowEditingSessionType: { __type: 'Boolean!' },
    allowMultiLocationAccess: { __type: 'Boolean!' },
    category: { __type: 'String' },
    code: { __type: 'Float' },
    color: { __type: 'String' },
    corporateSessionTypeId: { __type: 'ID' },
    createdAt: { __type: 'String!' },
    customColors: { __type: '[SiteSessionTypeCustomColors!]' },
    deletedAt: { __type: 'String' },
    displayOrder: { __type: 'Float' },
    isSystemManaged: { __type: 'Boolean!' },
    lockedSections: { __type: '[SessionGroupSection!]' },
    name: { __type: 'String!' },
    siteId: { __type: 'String!' },
    siteSessionTypeId: { __type: 'String!' },
    updatedAt: { __type: 'String!' },
  },
  SiteSessionTypeCustomColors: {
    __typename: { __type: 'String!' },
    colorName: { __type: 'String!' },
    hexCode: { __type: 'String!' },
  },
  SiteSessionTypeCustomColorsInput: {
    colorName: { __type: 'String!' },
    hexCode: { __type: 'String!' },
  },
  SiteSessionTypeInput: {
    allowEditingSessionType: { __type: 'Boolean!' },
    allowMultiLocationAccess: { __type: 'Boolean!' },
    category: { __type: 'String' },
    code: { __type: 'Float' },
    color: { __type: 'String!' },
    customColors: { __type: '[SiteSessionTypeCustomColorsInput!]' },
    displayOrder: { __type: 'Float' },
    name: { __type: 'String!' },
  },
  SiteSessionTypeUpdateInput: {
    allowEditingSessionType: { __type: 'Boolean' },
    allowMultiLocationAccess: { __type: 'Boolean' },
    category: { __type: 'String' },
    code: { __type: 'Float' },
    color: { __type: 'String' },
    customColors: { __type: '[SiteSessionTypeCustomColorsInput!]' },
    displayOrder: { __type: 'Float' },
    name: { __type: 'String' },
  },
  SiteSettings: {
    __typename: { __type: 'String!' },
    account: { __type: 'SiteSettingsAccount' },
    customization: { __type: 'SiteSettingsCustomization' },
    embed: { __type: 'SiteSettingsEmbed' },
    location: { __type: 'SiteSettingsLocation' },
    retail: { __type: 'SiteSettingsRetail' },
    scheduler: { __type: 'SiteSettingsScheduler' },
    updatedAt: { __type: 'String' },
  },
  SiteSettingsAccount: {
    __typename: { __type: 'String!' },
    billing: { __type: 'SiteSettingsAccountBilling' },
    invoice: { __type: 'SiteSettingsAccountInvoice' },
    payroll: { __type: 'SiteSettingsAccountPayroll' },
    pointOfSale: { __type: 'SiteSettingsAccountPointOfSale' },
    tax: { __type: 'SiteSettingsAccountTax' },
  },
  SiteSettingsAccountBilling: {
    __typename: { __type: 'String!' },
    enabled: { __type: 'Boolean' },
    retryFailedPayments: { __type: 'SiteSettingsAccountBillingRetryFailedPayments' },
    transactionFeePreference: { __type: 'TransactionFeePreference' },
  },
  SiteSettingsAccountBillingRetryFailedPayments: {
    __typename: { __type: 'String!' },
    bankFailoverToCard: {
      __type: 'SiteSettingsAccountBillingRetryFailedPaymentsBankFailoverToCard',
    },
    enabled: { __type: 'Boolean' },
    intervalInDays: { __type: 'Float!' },
    maxAttempts: { __type: 'Float!' },
    maxFailoversPerDay: { __type: 'Float' },
  },
  SiteSettingsAccountBillingRetryFailedPaymentsBankFailoverToCard: {
    __typename: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
  },
  SiteSettingsAccountInvoice: {
    __typename: { __type: 'String!' },
    email: { __type: 'String' },
    label: { __type: 'String' },
  },
  SiteSettingsAccountPayroll: {
    __typename: { __type: 'String!' },
    additionalTypes: { __type: '[PayrollAdditionalTypes!]' },
  },
  SiteSettingsAccountPointOfSale: {
    __typename: { __type: 'String!' },
    enableCashDrawer: { __type: 'Boolean' },
    itemTypes: { __type: '[NewSaleItemTypes!]' },
  },
  SiteSettingsAccountTax: { __typename: { __type: 'String!' }, enabled: { __type: 'Boolean' } },
  SiteSettingsCustomization: {
    __typename: { __type: 'String!' },
    colors: { __type: '[SiteSettingsCustomizationColors!]' },
  },
  SiteSettingsCustomizationColors: {
    __typename: { __type: 'String!' },
    color: { __type: 'String!' },
    id: { __type: 'String!' },
  },
  SiteSettingsEmbed: {
    __typename: { __type: 'String!' },
    exploreTabs: { __type: '[SiteSettingsEmbedExploreTabs!]' },
  },
  SiteSettingsEmbedExploreTabs: {
    __typename: { __type: 'String!' },
    isDefault: { __type: 'Boolean' },
    key: { __type: 'String!' },
    label: { __type: 'String!' },
    sessionTypeIds: { __type: '[String!]' },
    source: { __type: 'String!' },
  },
  SiteSettingsLocation: {
    __typename: { __type: 'String!' },
    businessInformation: { __type: 'SiteSettingsLocationBusinessInformation' },
    checkIn: { __type: 'SiteSettingsLocationCheckIn' },
    communications: { __type: 'SiteSettingsLocationCommunications' },
    configurations: { __type: 'SiteSettingsLocationConfigurations' },
    forms: { __type: 'SiteSettingsLocationForms' },
    memberApp: { __type: 'SiteSettingsLocationMemberApp' },
    operations: { __type: 'SiteSettingsLocationOperations' },
    socialMedia: { __type: 'SiteSettingsLocationSocialMedia' },
    tools: { __type: 'SiteSettingsLocationTools' },
  },
  SiteSettingsLocationBusinessInformation: {
    __typename: { __type: 'String!' },
    address: { __type: 'SiteSettingsLocationBusinessInformationAddress' },
    description: { __type: 'String' },
    name: { __type: 'String' },
    phone: { __type: 'String' },
  },
  SiteSettingsLocationBusinessInformationAddress: {
    __typename: { __type: 'String!' },
    city: { __type: 'String' },
    coordinates: { __type: 'SiteSettingsLocationBusinessInformationAddressCoordinates' },
    country: { __type: 'String' },
    postalCode: { __type: 'String' },
    state: { __type: 'String' },
    street: { __type: 'String' },
  },
  SiteSettingsLocationBusinessInformationAddressCoordinates: {
    __typename: { __type: 'String!' },
    latitude: { __type: 'Float' },
    longitude: { __type: 'Float' },
  },
  SiteSettingsLocationCheckIn: {
    __typename: { __type: 'String!' },
    barcodeCheckInScreenRefreshPeriodInSeconds: { __type: 'Float!' },
    checkInEndTime: { __type: 'Float' },
    checkInMarksAttendance: { __type: 'Boolean' },
    checkInStartTime: { __type: 'Float' },
    contactlessCheckIn: { __type: 'SiteSettingsLocationCheckInContactlessCheckIn!' },
    enableCheckInPopups: { __type: 'Boolean!' },
    enableCheckInSoundAlerts: { __type: 'Boolean!' },
    enableCheckInWidget: { __type: 'Boolean!' },
    enableGeneralCheckIn: { __type: 'Boolean!' },
    enableMobileClientCheckIn: { __type: 'Boolean!' },
    enableReEntryGracePeriod: { __type: 'Boolean!' },
    failOpenOffline: { __type: 'Boolean' },
    reEntryGracePeriodInSeconds: { __type: 'Float' },
  },
  SiteSettingsLocationCheckInContactlessCheckIn: {
    __typename: { __type: 'String!' },
    enableDoorAccess: { __type: 'Boolean!' },
    enableForm: { __type: 'Boolean!' },
    enableQRCodeDeeplink: { __type: 'Boolean!' },
    enabled: { __type: 'Boolean!' },
    formQuestions: { __type: '[SiteSettingsLocationCheckInContactlessCheckInFormQuestions!]' },
    policies: { __type: '[SiteSettingsLocationCheckInContactlessCheckInPolicies!]!' },
    policyIds: { __type: '[String!]!' },
    skipCheckInQuestions: { __type: 'Boolean!' },
  },
  SiteSettingsLocationCheckInContactlessCheckInFormQuestions: {
    __typename: { __type: 'String!' },
    allowCheckInIfBelowOrEqualTo: { __type: 'Float' },
    favorite: { __type: 'Boolean' },
    id: { __type: 'String!' },
    options: { __type: '[SiteSettingsLocationCheckInContactlessCheckInFormQuestionsOptions!]' },
    order: { __type: 'Float' },
    question: { __type: 'String!' },
    type: { __type: 'ContactlessCheckInFormQuestionType!' },
  },
  SiteSettingsLocationCheckInContactlessCheckInFormQuestionsOptions: {
    __typename: { __type: 'String!' },
    allowCheckIn: { __type: 'Boolean!' },
    id: { __type: 'String!' },
    order: { __type: 'Float' },
    text: { __type: 'String!' },
  },
  SiteSettingsLocationCheckInContactlessCheckInPolicies: {
    __typename: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
    order: { __type: 'Float!' },
    sitePolicyId: { __type: 'String!' },
  },
  SiteSettingsLocationCommunications: {
    __typename: { __type: 'String!' },
    blackoutTime: { __type: 'SiteSettingsLocationCommunicationsBlackoutTime' },
    customShortCodes: { __type: 'SiteSettingsLocationCommunicationsCustomShortCodes' },
    emailDefaultFrom: { __type: 'String' },
    emailDefaultFromName: { __type: 'String' },
    smsDefaultFromName: { __type: 'String' },
  },
  SiteSettingsLocationCommunicationsBlackoutTime: {
    __typename: { __type: 'String!' },
    endTime: { __type: 'Float' },
    startTime: { __type: 'Float' },
  },
  SiteSettingsLocationCommunicationsCustomShortCodes: {
    __typename: { __type: 'String!' },
    androidApp: { __type: 'String' },
    androidAppDownload: { __type: 'String' },
    classes: { __type: 'String' },
    dashboard: { __type: 'String' },
    iOSApp: { __type: 'String' },
    iOSAppDownload: { __type: 'String' },
    packages: { __type: 'String' },
    workshops: { __type: 'String' },
  },
  SiteSettingsLocationConfigurations: {
    __typename: { __type: 'String!' },
    currency: { __type: 'String' },
    dashboardRevenuePeriod: { __type: 'String' },
    dateFormat: { __type: 'String' },
    numberFormat: { __type: 'String' },
    timeFormat: { __type: 'String' },
    timezone: { __type: 'String' },
  },
  SiteSettingsLocationForms: {
    __typename: { __type: 'String!' },
    bookingGateMode: { __type: 'FormBookingGateMode' },
  },
  SiteSettingsLocationMemberApp: {
    __typename: { __type: 'String!' },
    locationInformation: { __type: 'SiteSettingsLocationMemberAppLocationInformation' },
    planYourVisit: { __type: 'SiteSettingsLocationMemberAppPlanYourVisit' },
  },
  SiteSettingsLocationMemberAppLocationInformation: {
    __typename: { __type: 'String!' },
    amenities: { __type: 'SiteSettingsLocationMemberAppLocationInformationAmenities' },
    blocks: { __type: '[SiteSettingsLocationMemberAppLocationInformationBlocks!]' },
    heading: { __type: 'String' },
    isEnabled: { __type: 'Boolean' },
    staffedHours: { __type: 'SiteSettingsLocationMemberAppLocationInformationStaffedHours' },
  },
  SiteSettingsLocationMemberAppLocationInformationAmenities: {
    __typename: { __type: 'String!' },
    isEnabled: { __type: 'Boolean' },
    items: { __type: '[SiteSettingsLocationMemberAppLocationInformationAmenitiesItems!]' },
    maxVisible: { __type: 'Int' },
  },
  SiteSettingsLocationMemberAppLocationInformationAmenitiesItems: {
    __typename: { __type: 'String!' },
    amenityKey: { __type: 'SiteAmenityKey' },
    customIcon: { __type: 'SiteInfoBlockIcon' },
    customName: { __type: 'String' },
    id: { __type: 'ID!' },
    isVisible: { __type: 'Boolean!' },
    note: { __type: 'String' },
    schedule: { __type: 'SiteSettingsLocationMemberAppLocationInformationStaffedHoursSchedule' },
  },
  SiteSettingsLocationMemberAppLocationInformationBlocks: {
    __typename: { __type: 'String!' },
    body: { __type: 'String!' },
    icon: { __type: 'SiteInfoBlockIcon' },
    id: { __type: 'ID!' },
    isVisible: { __type: 'Boolean!' },
    linkLabel: { __type: 'String' },
    linkUrl: { __type: 'String' },
    title: { __type: 'String!' },
  },
  SiteSettingsLocationMemberAppLocationInformationStaffedHours: {
    __typename: { __type: 'String!' },
    isEnabled: { __type: 'Boolean' },
    label: { __type: 'String' },
    schedule: { __type: 'SiteSettingsLocationMemberAppLocationInformationStaffedHoursSchedule' },
  },
  SiteSettingsLocationMemberAppLocationInformationStaffedHoursSchedule: {
    __typename: { __type: 'String!' },
    exceptions: {
      __type: '[SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleExceptions!]!',
    },
    is24x7: { __type: 'Boolean!' },
    weekly: {
      __type: 'SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleWeekly!',
    },
  },
  SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleExceptions: {
    __typename: { __type: 'String!' },
    date: { __type: 'String!' },
    id: { __type: 'ID!' },
    isClosed: { __type: 'Boolean!' },
    label: { __type: 'String!' },
    ranges: {
      __type:
        '[SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleWeeklyMondayRanges!]!',
    },
  },
  SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleWeekly: {
    __typename: { __type: 'String!' },
    friday: {
      __type: 'SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleWeeklyMonday!',
    },
    monday: {
      __type: 'SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleWeeklyMonday!',
    },
    saturday: {
      __type: 'SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleWeeklyMonday!',
    },
    sunday: {
      __type: 'SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleWeeklyMonday!',
    },
    thursday: {
      __type: 'SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleWeeklyMonday!',
    },
    tuesday: {
      __type: 'SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleWeeklyMonday!',
    },
    wednesday: {
      __type: 'SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleWeeklyMonday!',
    },
  },
  SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleWeeklyMonday: {
    __typename: { __type: 'String!' },
    isClosed: { __type: 'Boolean!' },
    ranges: {
      __type:
        '[SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleWeeklyMondayRanges!]!',
    },
  },
  SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleWeeklyMondayRanges: {
    __typename: { __type: 'String!' },
    closesAt: { __type: 'String!' },
    opensAt: { __type: 'String!' },
  },
  SiteSettingsLocationMemberAppPlanYourVisit: {
    __typename: { __type: 'String!' },
    forecast: { __type: 'SiteSettingsLocationMemberAppPlanYourVisitForecast' },
    isEnabled: { __type: 'Boolean' },
    isVisibleToGuests: { __type: 'Boolean' },
    liveOccupancy: { __type: 'SiteSettingsLocationMemberAppPlanYourVisitLiveOccupancy' },
    title: { __type: 'String' },
  },
  SiteSettingsLocationMemberAppPlanYourVisitForecast: {
    __typename: { __type: 'String!' },
    chartEndHour: { __type: 'Int' },
    chartStartHour: { __type: 'Int' },
    isEnabled: { __type: 'Boolean' },
    lookbackWeeks: { __type: 'Int' },
  },
  SiteSettingsLocationMemberAppPlanYourVisitLiveOccupancy: {
    __typename: { __type: 'String!' },
    averageVisitMinutes: { __type: 'Int' },
    bandSize: { __type: 'Int' },
    displayMode: { __type: 'OccupancyDisplayMode' },
    hideWhenClosed: { __type: 'Boolean' },
    isEnabled: { __type: 'Boolean' },
    privacyFloor: { __type: 'Int' },
  },
  SiteSettingsLocationOperations: {
    __typename: { __type: 'String!' },
    autoLogout: { __type: 'Boolean' },
    autoLogoutMinutes: { __type: 'AutoLogoutMinutes' },
    blockingReasons: { __type: '[SiteSettingsLocationOperationsCancellationReasons!]' },
    businessSignUpFields: { __type: 'SiteSettingsLocationOperationsBusinessSignUpFields' },
    cancellationReasons: { __type: '[SiteSettingsLocationOperationsCancellationReasons!]' },
    clientSignUpFields: { __type: 'SiteSettingsLocationOperationsClientSignUpFields' },
    enableBookABuddy: { __type: 'Boolean' },
    enableBuddySessionSharingVisibility: { __type: 'Boolean' },
    enableClientsToSignUp: { __type: 'Boolean' },
    leadSources: { __type: '[String!]' },
    preventDuplicatePhoneSignUp: { __type: 'Boolean' },
    refundReasons: { __type: '[SiteSettingsLocationOperationsRefundReasons!]' },
    suspensionReasons: { __type: '[SiteSettingsLocationOperationsCancellationReasons!]' },
    systemPreferences: { __type: 'SiteSettingsLocationOperationsSystemPreferences' },
  },
  SiteSettingsLocationOperationsBusinessSignUpFields: {
    __typename: { __type: 'String!' },
    customProperties: {
      __type: '[SiteSettingsLocationOperationsBusinessSignUpFieldsCustomProperties!]!',
    },
    emergencyContact: {
      __type: 'SiteSettingsLocationOperationsBusinessSignUpFieldsEmergencyContact!',
    },
    formIds: { __type: '[String!]!' },
    primaryProfile: { __type: 'SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfile!' },
  },
  SiteSettingsLocationOperationsBusinessSignUpFieldsCustomProperties: {
    __typename: { __type: 'String!' },
    customPropertyId: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
    required: { __type: 'Boolean!' },
  },
  SiteSettingsLocationOperationsBusinessSignUpFieldsEmergencyContact: {
    __typename: { __type: 'String!' },
    emergencyContactAddress: {
      __type: 'SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName',
    },
    emergencyContactEmail: {
      __type: 'SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName',
    },
    emergencyContactName: {
      __type: 'SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName',
    },
    emergencyContactPhone: {
      __type: 'SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName',
    },
    emergencyContactRelation: {
      __type: 'SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName',
    },
  },
  SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfile: {
    __typename: { __type: 'String!' },
    address: {
      __type: 'SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName',
    },
    barcode: {
      __type: 'SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName',
    },
    birthday: {
      __type: 'SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName',
    },
    confirmPassword: {
      __type: 'SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName',
    },
    email: { __type: 'SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName' },
    firstName: {
      __type: 'SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName',
    },
    gender: { __type: 'SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName' },
    howDidYouHeadAboutUs: {
      __type: 'SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName',
    },
    lastName: {
      __type: 'SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName',
    },
    occupation: {
      __type: 'SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName',
    },
    password: {
      __type: 'SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName',
    },
    phone: { __type: 'SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName' },
    zipCode: {
      __type: 'SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName',
    },
  },
  SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName: {
    __typename: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
    required: { __type: 'Boolean!' },
  },
  SiteSettingsLocationOperationsCancellationReasons: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String' },
    enabled: { __type: 'Boolean' },
    id: { __type: 'String' },
    reason: { __type: 'String' },
    updatedAt: { __type: 'String' },
  },
  SiteSettingsLocationOperationsClientSignUpFields: {
    __typename: { __type: 'String!' },
    customProperties: {
      __type: '[SiteSettingsLocationOperationsBusinessSignUpFieldsCustomProperties!]!',
    },
    emergencyContact: {
      __type: 'SiteSettingsLocationOperationsBusinessSignUpFieldsEmergencyContact!',
    },
    formIds: { __type: '[String!]!' },
    policyIds: { __type: '[String!]!' },
    primaryProfile: { __type: 'SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfile!' },
  },
  SiteSettingsLocationOperationsRefundReasons: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String' },
    enabled: { __type: 'Boolean!' },
    id: { __type: 'String' },
    reason: { __type: 'String!' },
    updatedAt: { __type: 'String' },
  },
  SiteSettingsLocationOperationsSystemPreferences: {
    __typename: { __type: 'String!' },
    availableClientsTabs: {
      __type: 'SiteSettingsLocationOperationsSystemPreferencesAvailableClientsTabs',
    },
    defaultAllLocationsSearch: { __type: 'Boolean' },
    defaultBusinessProfileTab: { __type: 'BusinessProfileTab' },
    defaultClientTab: { __type: 'ClientProfileTab' },
    showBusinessInfo: { __type: 'Boolean' },
    tabsDisplayed: { __type: 'SiteSettingsLocationOperationsSystemPreferencesTabsDisplayed' },
  },
  SiteSettingsLocationOperationsSystemPreferencesAvailableClientsTabs: {
    __typename: { __type: 'String!' },
    assessment: { __type: 'Boolean' },
    information: { __type: 'Boolean' },
    notes: { __type: 'Boolean' },
    payment: { __type: 'Boolean' },
    schedule: { __type: 'Boolean' },
  },
  SiteSettingsLocationOperationsSystemPreferencesTabsDisplayed: {
    __typename: { __type: 'String!' },
    classes: { __type: 'Boolean' },
    packages: { __type: 'Boolean' },
    requestBooking: { __type: 'Boolean' },
    workshops: { __type: 'Boolean' },
  },
  SiteSettingsLocationSocialMedia: {
    __typename: { __type: 'String!' },
    facebook: { __type: 'String' },
    instagram: { __type: 'String' },
    website: { __type: 'String' },
    x: { __type: 'String' },
  },
  SiteSettingsLocationTools: {
    __typename: { __type: 'String!' },
    barcodeCheckIn: { __type: 'SiteSettingsLocationToolsBarcodeCheckIn' },
    frontDeskKiosk: { __type: 'SiteSettingsLocationToolsFrontDeskKiosk' },
  },
  SiteSettingsLocationToolsBarcodeCheckIn: {
    __typename: { __type: 'String!' },
    customUrl: { __type: 'String' },
    isActive: { __type: 'Boolean' },
    url: { __type: 'String' },
  },
  SiteSettingsLocationToolsFrontDeskKiosk: {
    __typename: { __type: 'String!' },
    betaVersionEnabled: { __type: 'Boolean' },
    customUrl: { __type: 'String' },
    enabledModules: { __type: 'SiteSettingsLocationToolsFrontDeskKioskEnabledModules' },
    isActive: { __type: 'Boolean' },
    url: { __type: 'String' },
  },
  SiteSettingsLocationToolsFrontDeskKioskEnabledModules: {
    __typename: { __type: 'String!' },
    account: { __type: 'Boolean' },
    checkIn: { __type: 'Boolean' },
    classCheckIn: { __type: 'Boolean' },
    forms: { __type: 'Boolean' },
    introOffers: { __type: 'Boolean' },
    packages: { __type: 'Boolean' },
  },
  SiteSettingsRetail: {
    __typename: { __type: 'String!' },
    additionalBillingTypes: { __type: 'SiteSettingsRetailAdditionalBillingTypes!' },
    fees: { __type: 'SiteSettingsRetailFees' },
    general: { __type: 'SiteSettingsRetailGeneral' },
    giftcards: { __type: 'SiteSettingsRetailGiftcards' },
    memberships: { __type: 'SiteSettingsRetailMemberships' },
    sales: { __type: 'SiteSettingsRetailSales' },
    suspensions: { __type: 'SiteSettingsRetailSuspensions' },
  },
  SiteSettingsRetailAdditionalBillingTypes: {
    __typename: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
    types: { __type: '[SiteSettingsRetailAdditionalBillingTypesTypes!]' },
  },
  SiteSettingsRetailAdditionalBillingTypesTypes: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
    id: { __type: 'ID!' },
    name: { __type: 'String!' },
    type: { __type: 'AddtionalBillingType!' },
    updatedAt: { __type: 'String' },
  },
  SiteSettingsRetailFees: {
    __typename: { __type: 'String!' },
    customLateCancelFeesEnabled: { __type: 'Boolean' },
    customNoShowFeesEnabled: { __type: 'Boolean' },
    destination: { __type: 'SiteSettingsRetailFeesDestination' },
    dishonor: { __type: 'SiteSettingsRetailFeesDishonor!' },
    lateCancel: { __type: 'SiteSettingsRetailFeesNoShow' },
    noShow: { __type: 'SiteSettingsRetailFeesNoShow' },
  },
  SiteSettingsRetailFeesDestination: {
    __typename: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
    price: { __type: 'String' },
    revenueTagId: { __type: 'ID' },
    taxSettings: { __type: '[String!]' },
  },
  SiteSettingsRetailFeesDishonor: {
    __typename: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
    onAllAttempts: { __type: 'String' },
    onDelinquentDays: { __type: 'SiteSettingsRetailFeesDishonorOnDelinquentDays' },
    onFirstAttempt: { __type: 'String' },
    onSecondAttempt: { __type: 'String' },
    onThirdAttempt: { __type: 'String' },
    taxSettings: { __type: '[String!]' },
  },
  SiteSettingsRetailFeesDishonorOnDelinquentDays: {
    __typename: { __type: 'String!' },
    amount: { __type: 'String!' },
    days: { __type: 'Float!' },
  },
  SiteSettingsRetailFeesNoShow: {
    __typename: { __type: 'String!' },
    automatic: { __type: 'SiteSettingsRetailFeesNoShowAutomatic' },
    creditRefund: { __type: 'Boolean' },
    enabled: { __type: 'Boolean!' },
    price: { __type: 'String' },
    revenueTagId: { __type: 'String' },
    taxSettings: { __type: '[String!]' },
    unlimitedCreditsOnly: { __type: 'Boolean' },
  },
  SiteSettingsRetailFeesNoShowAutomatic: {
    __typename: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
  },
  SiteSettingsRetailGeneral: {
    __typename: { __type: 'String!' },
    credits: { __type: 'SiteSettingsRetailGeneralCredits' },
    sales: { __type: 'SiteSettingsRetailGeneralSales' },
  },
  SiteSettingsRetailGeneralCredits: {
    __typename: { __type: 'String!' },
    enableCreditsOnHoldIfClientHadFailedPayment: { __type: 'Boolean!' },
    enableCreditsOnHoldIfClientHadTerminalFailedPayment: { __type: 'Boolean' },
    enableCreditsOnHoldIfClientHasProcessingPayment: { __type: 'Boolean!' },
    referrals: { __type: 'SiteSettingsRetailGeneralCreditsReferrals!' },
  },
  SiteSettingsRetailGeneralCreditsReferrals: {
    __typename: { __type: 'String!' },
    creditsExistingClient: { __type: 'Float!' },
    creditsToNewClient: { __type: 'Float!' },
    existingClientEnabled: { __type: 'Boolean' },
    newClientEnabled: { __type: 'Boolean' },
  },
  SiteSettingsRetailGeneralSales: {
    __typename: { __type: 'String!' },
    additionalSortOfPackages: { __type: 'SiteSettingsRetailGeneralSalesAdditionalSortOfPackages' },
    allowChangeOfProcessedByAtSale: { __type: 'Boolean!' },
    allowMembershipSalesWithDuplicateCreditOrSessionTypes: { __type: 'Boolean!' },
    allowSessionPackageSalesWithDuplicateCreditOrSessionTypes: { __type: 'Boolean!' },
    autoAssignClientBarcodeNumber: { __type: 'Boolean!' },
    autoRenewExhaustedSessionPackages: { __type: 'Boolean!' },
    defaultAutoRenewToggleEnabledAtSale: { __type: 'Boolean!' },
    enableAllMembershipsSoldOnlineToBeCancelledByMember: { __type: 'Boolean!' },
    enableRestrictedPackages: { __type: 'Boolean!' },
    redirectAfterPackagePayment: { __type: 'RedirectAfterPackagePayment!' },
    revenueTagDefaults: { __type: 'JSONObject!' },
    revenueTagging: { __type: '[SiteSettingsRetailGeneralSalesRevenueTagging!]!' },
  },
  SiteSettingsRetailGeneralSalesAdditionalSortOfPackages: {
    __typename: { __type: 'String!' },
    direction: { __type: 'SortPackageDirection!' },
    field: { __type: 'SortPackageField!' },
  },
  SiteSettingsRetailGeneralSalesRevenueTagging: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    description: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
    glCode: { __type: 'String!' },
    id: { __type: 'ID!' },
    mapping: { __type: 'RevenueTagMapping' },
    name: { __type: 'String!' },
    updatedAt: { __type: 'String' },
  },
  SiteSettingsRetailGiftcards: {
    __typename: { __type: 'String!' },
    enableSharedSites: { __type: 'Boolean' },
  },
  SiteSettingsRetailMemberships: {
    __typename: { __type: 'String!' },
    restrictPlanChangesToCategory: { __type: 'Boolean' },
  },
  SiteSettingsRetailSales: {
    __typename: { __type: 'String!' },
    miniumSignUpAge: { __type: 'Float' },
    printPosReceipt: { __type: 'Float' },
    requireRecipientForGiftCardSales: { __type: 'Boolean' },
  },
  SiteSettingsRetailSuspensions: {
    __typename: { __type: 'String!' },
    secondaryFeesContinueDuringSuspension: { __type: 'Boolean' },
    selfServicePause: { __type: 'SiteSettingsRetailSuspensionsSelfServicePause' },
  },
  SiteSettingsRetailSuspensionsSelfServicePause: {
    __typename: { __type: 'String!' },
    alignToBillingCycle: { __type: 'Boolean' },
    enabled: { __type: 'Boolean!' },
    maxPerCalendarYear: {
      __type: 'SiteSettingsRetailSuspensionsSelfServicePauseMaxPerCalendarYear',
    },
    noticePeriodDays: { __type: 'Float' },
    reasonIds: { __type: '[String!]' },
    reasonMandatory: { __type: 'Boolean' },
  },
  SiteSettingsRetailSuspensionsSelfServicePauseMaxPerCalendarYear: {
    __typename: { __type: 'String!' },
    amount: { __type: 'Float!' },
    unit: { __type: 'SelfServicePauseDurationUnit!' },
  },
  SiteSettingsScheduler: {
    __typename: { __type: 'String!' },
    calendar: { __type: 'SiteSettingsSchedulerCalendar' },
    calendarConfigurations: { __type: 'SiteSettingsSchedulerCalendarConfigurations' },
    daysInAdvance: { __type: 'SiteSettingsSchedulerDaysInAdvance' },
    rules: { __type: 'SiteSettingsSchedulerRules' },
    sessionTypes: { __type: '[SiteSettingsSchedulerSessionTypes!]' },
  },
  SiteSettingsSchedulerCalendar: {
    __typename: { __type: 'String!' },
    defaultView: { __type: 'ScheduleDefaultView' },
    showCapacity: { __type: 'Boolean' },
    showInstructorNames: { __type: 'Boolean' },
  },
  SiteSettingsSchedulerCalendarConfigurations: {
    __typename: { __type: 'String!' },
    calendarInterval: { __type: 'Float' },
    calendarMaxTime: { __type: 'String' },
    calendarMinTime: { __type: 'String' },
    calendarStartDay: { __type: 'String' },
    defaultBookedListOrder: { __type: 'String' },
    defaultCalendarView: { __type: 'String' },
    enableContinuousEvents: { __type: 'Boolean' },
    enableDragAndDrop: { __type: 'Boolean' },
    hideRoomFromRoomView: { __type: 'Boolean' },
    hideTeamMemberFromTeamView: { __type: 'Boolean' },
  },
  SiteSettingsSchedulerDaysInAdvance: {
    __typename: { __type: 'String!' },
    appointments: { __type: 'Float!' },
    classes: { __type: 'Float!' },
    workshops: { __type: 'Float!' },
  },
  SiteSettingsSchedulerRules: {
    __typename: { __type: 'String!' },
    bookings: { __type: 'SiteSettingsSchedulerRulesBookings' },
    cancellations: { __type: 'SiteSettingsSchedulerRulesCancellations' },
    classes: { __type: 'SiteSettingsSchedulerRulesClasses' },
    privates: { __type: 'SiteSettingsSchedulerRulesPrivates' },
    reservations: { __type: 'SiteSettingsSchedulerRulesReservations' },
    sessionFeedback: { __type: 'SiteSettingsSchedulerRulesSessionFeedback' },
    waitlist: { __type: 'SiteSettingsSchedulerRulesWaitlist' },
    workshops: { __type: 'SiteSettingsSchedulerRulesWorkshops' },
  },
  SiteSettingsSchedulerRulesBookings: {
    __typename: { __type: 'String!' },
    allowMemberOverlappingSessions: { __type: 'Boolean' },
    allowStaffOverbooking: { __type: 'Boolean' },
    autoConfirmRequests: { __type: 'Boolean' },
    autoDeductCredits: { __type: 'Boolean' },
    bookingNotifications: { __type: 'Boolean' },
    enableBookABuddy: { __type: 'Boolean' },
    enableBookingRequests: { __type: 'Boolean' },
    enforceFixedBookingSlotIntervals: {
      __type: 'SiteSettingsSchedulerRulesBookingsEnforceFixedBookingSlotIntervals',
    },
    enforceFixedBookingSlotIntervalsDuration: { __type: 'SchedulerTimeSlotDuration' },
    requestTimeSlots: { __type: 'SiteSettingsSchedulerRulesBookingsRequestTimeSlots' },
    requestTimeSlotsDuration: { __type: 'SchedulerTimeSlotDuration' },
  },
  SiteSettingsSchedulerRulesBookingsEnforceFixedBookingSlotIntervals: {
    __typename: { __type: 'String!' },
    duration: { __type: 'Float' },
  },
  SiteSettingsSchedulerRulesBookingsRequestTimeSlots: {
    __typename: { __type: 'String!' },
    duration: { __type: 'Float' },
  },
  SiteSettingsSchedulerRulesCancellations: {
    __typename: { __type: 'String!' },
    allowClientDeclineAndCancelSessions: { __type: 'Boolean' },
    allowClientsToDeclineAndCancel: { __type: 'Boolean' },
    policies: { __type: 'SiteSettingsSchedulerRulesCancellationsPolicies' },
  },
  SiteSettingsSchedulerRulesCancellationsPolicies: {
    __typename: { __type: 'String!' },
    classes: { __type: 'SiteSettingsSchedulerRulesCancellationsPoliciesClasses' },
    privates: { __type: 'SiteSettingsSchedulerRulesCancellationsPoliciesClasses' },
    workshops: { __type: 'SiteSettingsSchedulerRulesCancellationsPoliciesClasses' },
  },
  SiteSettingsSchedulerRulesCancellationsPoliciesClasses: {
    __typename: { __type: 'String!' },
    days: { __type: 'Float!' },
    hours: { __type: 'Float!' },
    minutes: { __type: 'Float!' },
  },
  SiteSettingsSchedulerRulesClasses: {
    __typename: { __type: 'String!' },
    daysInAdvance: { __type: 'Float' },
    defaultColor: { __type: 'String' },
    displayClassSize: { __type: 'Boolean' },
    displayCompletedClasses: { __type: 'Boolean' },
    displayPriceColumn: { __type: 'Boolean' },
    instructorTypeFilter: { __type: 'Boolean' },
    roomTypeFilter: { __type: 'Boolean' },
    sessionTypeFilter: { __type: 'Boolean' },
    soapNotes: { __type: 'Boolean' },
  },
  SiteSettingsSchedulerRulesPrivates: {
    __typename: { __type: 'String!' },
    daysInAdvance: { __type: 'Float' },
  },
  SiteSettingsSchedulerRulesReservations: {
    __typename: { __type: 'String!' },
    daysInAdvance: { __type: 'SiteSettingsSchedulerRulesReservationsDaysInAdvance' },
    multipleReservations: { __type: 'Boolean' },
    overrides: { __type: 'SiteSettingsSchedulerRulesReservationsOverrides' },
  },
  SiteSettingsSchedulerRulesReservationsDaysInAdvance: {
    __typename: { __type: 'String!' },
    releaseType: { __type: 'ReleaseType' },
    rolling: { __type: 'SiteSettingsSchedulerRulesReservationsDaysInAdvanceRolling' },
    timed: { __type: 'SiteSettingsSchedulerRulesReservationsDaysInAdvanceTimed' },
  },
  SiteSettingsSchedulerRulesReservationsDaysInAdvanceRolling: {
    __typename: { __type: 'String!' },
    classesBookedUpTo: { __type: 'Float' },
    periodOfTime: { __type: 'PeriodOfTime' },
    time: { __type: 'String' },
    upTo: { __type: 'Float' },
  },
  SiteSettingsSchedulerRulesReservationsDaysInAdvanceTimed: {
    __typename: { __type: 'String!' },
    dayOfWeek: { __type: 'DayOfWeek' },
    hoursAfter: { __type: 'Float' },
    numberOfWeeks: { __type: 'Float' },
    time: { __type: 'String' },
  },
  SiteSettingsSchedulerRulesReservationsOverrides: {
    __typename: { __type: 'String!' },
    byCategory: { __type: 'JSONObject' },
    bySessionType: { __type: 'JSONObject' },
  },
  SiteSettingsSchedulerRulesSessionFeedback: {
    __typename: { __type: 'String!' },
    sendRequestEmails: { __type: 'Boolean' },
  },
  SiteSettingsSchedulerRulesWaitlist: {
    __typename: { __type: 'String!' },
    autoConfirmClients: { __type: 'Boolean' },
    firstToClaim: { __type: 'SiteSettingsSchedulerRulesWaitlistFirstToClaim' },
    lockPeriod: { __type: 'SiteSettingsSchedulerRulesWaitlistLockPeriod' },
    manualMovements: { __type: 'Boolean' },
    promotion: { __type: 'SiteSettingsSchedulerRulesWaitlistPromotion' },
    restrictions: { __type: 'SiteSettingsSchedulerRulesWaitlistRestrictions' },
    strategy: { __type: 'WaitlistStrategy' },
    topNBatchSize: { __type: 'Float' },
  },
  SiteSettingsSchedulerRulesWaitlistFirstToClaim: {
    __typename: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
    windowHours: { __type: 'Float!' },
  },
  SiteSettingsSchedulerRulesWaitlistLockPeriod: {
    __typename: { __type: 'String!' },
    periodOfTime: { __type: 'PeriodOfTime' },
    value: { __type: 'Float' },
  },
  SiteSettingsSchedulerRulesWaitlistPromotion: {
    __typename: { __type: 'String!' },
    confirmationWindow: { __type: 'SiteSettingsSchedulerRulesWaitlistPromotionConfirmationWindow' },
    method: { __type: 'WaitlistPromotionMethod' },
    periodOfTime: { __type: 'PeriodOfTime' },
    value: { __type: 'Float' },
  },
  SiteSettingsSchedulerRulesWaitlistPromotionConfirmationWindow: {
    __typename: { __type: 'String!' },
    periodOfTime: { __type: 'PeriodOfTime' },
    value: { __type: 'Float' },
  },
  SiteSettingsSchedulerRulesWaitlistRestrictions: {
    __typename: { __type: 'String!' },
    type: { __type: 'WaitlistRestrictionType' },
  },
  SiteSettingsSchedulerRulesWorkshops: {
    __typename: { __type: 'String!' },
    daysInAdvance: { __type: 'Float' },
  },
  SiteSettingsSchedulerSessionTypes: {
    __typename: { __type: 'String!' },
    color: { __type: 'String' },
    description: { __type: 'String' },
    duration: { __type: 'Float' },
    id: { __type: 'String!' },
    name: { __type: 'String!' },
    settings: { __type: 'String' },
    type: { __type: 'String' },
  },
  SiteSetupIntentResponse: {
    __typename: { __type: 'String!' },
    publishableKey: { __type: 'String!' },
    setupIntentClientSecret: { __type: 'String!' },
    setupIntentId: { __type: 'String!' },
  },
  SiteTerminalHandoffSettingsView: {
    __typename: { __type: 'String!' },
    agreementConsentTexts: { __type: '[SiteTerminalHandoffSettingsViewAgreementConsentTexts!]!' },
    consentText: { __type: 'String!' },
    eligibleFields: { __type: '[TerminalHandoffField!]!' },
    emailConsentToggle: { __type: 'SiteTerminalHandoffSettingsViewEmailConsentToggle!' },
    fallback: { __type: 'TerminalSignatureFallback!' },
    fieldCaptureEnabled: { __type: 'Boolean!' },
    isSaved: { __type: 'Boolean!' },
    signAllLocations: { __type: 'Boolean!' },
    signatureDevice: { __type: 'TerminalSignatureDevice!' },
    smsConsentToggle: { __type: 'SiteTerminalHandoffSettingsViewEmailConsentToggle!' },
  },
  SiteTerminalHandoffSettingsViewAgreementConsentTexts: {
    __typename: { __type: 'String!' },
    siteAgreementTemplateId: { __type: 'ID!' },
    text: { __type: 'String!' },
  },
  SiteTerminalHandoffSettingsViewEmailConsentToggle: {
    __typename: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
    title: { __type: 'String!' },
  },
  SiteTerminalReader: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    deletedAt: { __type: 'String' },
    gatewayId: { __type: 'String!' },
    isActive: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    provider: { __type: 'GatewayType!' },
    registrationCode: { __type: 'String!' },
    siteId: { __type: 'ID!' },
    siteTerminalReaderId: { __type: 'ID!' },
    updatedAt: { __type: 'String!' },
  },
  SiteTerminalReaderPaginationResult: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'SiteTerminalReaderPaginationResultPageInfo!' },
    results: { __type: '[SiteTerminalReaderPaginationResultResults!]!' },
  },
  SiteTerminalReaderPaginationResultPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Float!' },
  },
  SiteTerminalReaderPaginationResultResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'SiteTerminalReader!' },
  },
  SiteTerminalReaderRegistrationReadiness: {
    __typename: { __type: 'String!' },
    missingAddressFields: { __type: '[TerminalLocationAddressField!]!' },
  },
  SiteTerminalReadersOrderByInput: {
    column: { __type: 'SiteTerminalReaderOrderByField!' },
    direction: { __type: 'OrderByDirection!' },
  },
  SiteThemeStatusRow: {
    __typename: { __type: 'String!' },
    active: { __type: 'Boolean!' },
    brandActive: { __type: 'Boolean!' },
    siteEnabled: { __type: 'Boolean!' },
    slug: { __type: 'String!' },
    status: { __type: 'SiteThemeStatus' },
    themeName: { __type: 'String!' },
  },
  SiteThemeSubscription: {
    __typename: { __type: 'String!' },
    corporateId: { __type: 'ID!' },
    corporateThemeSubscriptionId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    disabledAt: { __type: 'String' },
    enabledAt: { __type: 'String!' },
    enabledBy: { __type: 'ID!' },
    siteId: { __type: 'ID!' },
    siteThemeSubscriptionId: { __type: 'ID!' },
    status: { __type: 'SiteThemeStatus!' },
    themeId: { __type: 'ID!' },
    updatedAt: { __type: 'String!' },
  },
  SiteVisitForecastBucket: {
    __typename: { __type: 'String!' },
    dayOfWeek: { __type: 'Int!' },
    estimate: { __type: 'Float!' },
    hour: { __type: 'Int!' },
    level: { __type: 'Int!' },
  },
  SiteVisitForecastInsights: {
    __typename: { __type: 'String!' },
    buckets: { __type: '[SiteVisitForecastBucket!]!' },
    computedAt: { __type: 'String' },
    hasSufficientData: { __type: 'Boolean!' },
    peakEstimate: { __type: 'Float!' },
    sampleDays: { __type: 'Int!' },
    skippedImportedVisits: { __type: 'Int!' },
  },
  SiteWebhook: {
    __typename: { __type: 'String!' },
    consecutiveFailures: { __type: 'Float!' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'String' },
    events: { __type: '[String!]!' },
    headerKey: { __type: 'String' },
    headerValue: { __type: 'String' },
    lastDeliveryAt: { __type: 'String' },
    lastSuccessAt: { __type: 'String' },
    name: { __type: 'String!' },
    secretHash: { __type: 'String!' },
    siteWebhookId: { __type: 'String!' },
    status: { __type: 'SiteWebhookStatus!' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'String' },
    url: { __type: 'String!' },
    v1EncryptedId: { __type: 'String!' },
  },
  SiteWebhookDelivery: {
    __typename: { __type: 'String!' },
    attemptNumber: { __type: 'Float!' },
    createdAt: { __type: 'String!' },
    deliveryId: { __type: 'String!' },
    errorMessage: { __type: 'String' },
    eventId: { __type: 'String!' },
    eventType: { __type: 'String!' },
    latencyMs: { __type: 'Float' },
    responseBody: { __type: 'String' },
    responseCode: { __type: 'Float' },
    siteWebhookId: { __type: 'String!' },
    status: { __type: 'SiteWebhookDeliveryStatus!' },
    url: { __type: 'String!' },
    v1EncryptedId: { __type: 'String!' },
  },
  SiteWebhookTestResult: {
    __typename: { __type: 'String!' },
    deliveryId: { __type: 'String!' },
    error: { __type: 'String' },
    eventType: { __type: 'String!' },
    latencyMs: { __type: 'Float!' },
    responseBody: { __type: 'String' },
    responseCode: { __type: 'Float' },
    success: { __type: 'Boolean!' },
  },
  SiteWorkshop: {
    __typename: { __type: 'String!' },
    date: { __type: 'String!' },
    name: { __type: 'String!' },
    sessionId: { __type: 'String!' },
    startTime: { __type: 'String!' },
  },
  Sites: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'SitesPageInfo!' },
    results: { __type: '[SitesResults!]!' },
  },
  SitesFilterCreatedAtInput: { from: { __type: 'String' }, to: { __type: 'String' } },
  SitesFilterInput: {
    createdAt: { __type: 'SitesFilterCreatedAtInput' },
    isDigital: { __type: 'Boolean' },
    isV2Enabled: { __type: 'Boolean' },
    status: { __type: 'SiteStatus' },
  },
  SitesOrderByInput: {
    column: { __type: 'SitesOrderBy!' },
    direction: { __type: 'OrderByDirection!' },
  },
  SitesPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  SitesPlanOverrideSelection: {
    __typename: { __type: 'String!' },
    allowedSiteIds: { __type: '[ID!]!' },
    totalSiteCount: { __type: 'Float!' },
  },
  SitesResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'Site!' },
  },
  SkipAllErrors: {
    __typename: { __type: 'String!' },
    results: { __type: '[SkipAllErrorsResults!]!' },
    totalSkippedCount: { __type: 'Float!' },
  },
  SkipAllErrorsResults: {
    __typename: { __type: 'String!' },
    error: { __type: 'String' },
    importSessionId: { __type: 'ID!' },
    skippedCount: { __type: 'Float!' },
  },
  SkipImportRows: {
    __typename: { __type: 'String!' },
    skippedCount: { __type: 'Float!' },
    summary: { __type: 'SkipImportRowsSummary!' },
    updatedRowIndexes: { __type: '[Float!]!' },
  },
  SkipImportRowsSummary: {
    __typename: { __type: 'String!' },
    invalid: { __type: 'Float!' },
    pending: { __type: 'Float!' },
    skipped: { __type: 'Float!' },
    total: { __type: 'Float!' },
    totalErrorCount: { __type: 'Float!' },
    valid: { __type: 'Float!' },
    warning: { __type: 'Float!' },
  },
  SmsCreditsBalance: {
    __typename: { __type: 'String!' },
    asOf: { __type: 'String!' },
    balance: { __type: 'Float!' },
    includedBalance: { __type: 'Float!' },
    includedUsed: { __type: 'Float!' },
    purchasedBalance: { __type: 'Float!' },
    purchasedUsed: { __type: 'Float!' },
    siteId: { __type: 'String!' },
  },
  SmsCreditsHistory: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'SmsCreditsHistoryPageInfo!' },
    results: { __type: '[SmsCreditsHistoryResults!]!' },
  },
  SmsCreditsHistoryPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  SmsCreditsHistoryResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'SmsCreditsLedgerEntry!' },
  },
  SmsCreditsLedgerEntry: {
    __typename: { __type: 'String!' },
    allocationRef: { __type: 'ID' },
    amount: { __type: 'Float!' },
    createdAt: { __type: 'String!' },
    direction: { __type: 'SmsCreditsDirection!' },
    expirationDate: { __type: 'String' },
    ledgerId: { __type: 'ID!' },
    metadata: { __type: 'JSONObject' },
    reason: { __type: 'SmsCreditsReason!' },
    siteId: { __type: 'String!' },
  },
  SmsPackage: {
    __typename: { __type: 'String!' },
    country: { __type: 'String' },
    countryId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    currency: { __type: 'SmsAllowedCurrencies!' },
    deletedAt: { __type: 'String' },
    options: { __type: '[SmsPackageOptions!]!' },
    smsPackageId: { __type: 'ID!' },
    updatedAt: { __type: 'String!' },
  },
  SmsPackageOptions: {
    __typename: { __type: 'String!' },
    count: { __type: 'Float!' },
    createdAt: { __type: 'String!' },
    deletedAt: { __type: 'String' },
    optionId: { __type: 'ID!' },
    price: { __type: 'Float!' },
    smsPackageId: { __type: 'ID!' },
    updatedAt: { __type: 'String!' },
  },
  SmsPackages: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'SmsPackagesPageInfo!' },
    results: { __type: '[SmsPackagesResults!]!' },
  },
  SmsPackagesFilterInput: {
    countryId: { __type: 'ID' },
    currency: { __type: 'SmsAllowedCurrencies' },
  },
  SmsPackagesOrderByInput: {
    column: { __type: 'SmsPackagesOrderBy!' },
    direction: { __type: 'OrderByDirection!' },
  },
  SmsPackagesPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  SmsPackagesResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'SmsPackage!' },
  },
  SoapNote: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'String!' },
    content: { __type: 'SoapNoteContent!' },
    createdAt: { __type: 'String!' },
    createdByName: { __type: 'String!' },
    modifiedAt: { __type: 'String' },
    modifiedBy: { __type: 'String' },
    modifiedByName: { __type: 'String' },
    sessionId: { __type: 'String!' },
    siteId: { __type: 'String!' },
    soapNoteId: { __type: 'String!' },
    staffUserId: { __type: 'String!' },
  },
  SoapNoteContent: {
    __typename: { __type: 'String!' },
    assessment: { __type: 'String' },
    objective: { __type: 'String' },
    plan: { __type: 'String' },
    sessionDate: { __type: 'String!' },
    sessionTitle: { __type: 'String!' },
    subjective: { __type: 'String' },
    trainerName: { __type: 'String!' },
  },
  SoapNoteCreateContentInput: {
    assessment: { __type: 'String' },
    objective: { __type: 'String' },
    plan: { __type: 'String' },
    sessionDate: { __type: 'String!' },
    sessionTitle: { __type: 'String!' },
    subjective: { __type: 'String' },
    trainerName: { __type: 'String!' },
  },
  SoapNoteCreateInput: {
    clientId: { __type: 'String!' },
    content: { __type: 'SoapNoteCreateContentInput!' },
    sessionId: { __type: 'String!' },
  },
  SoapNoteUpdateInput: { content: { __type: 'SoapNoteCreateContentInput' } },
  SoapNotesResponse: { __typename: { __type: 'String!' }, notes: { __type: '[SoapNote!]!' } },
  SpotMove: {
    __typename: { __type: 'String!' },
    bookingId: { __type: 'String!' },
    clientId: { __type: 'String!' },
    clientName: { __type: 'String' },
    nextSpotLabel: { __type: 'String' },
    previousSpotLabel: { __type: 'String' },
    sessionId: { __type: 'String!' },
    sessionName: { __type: 'String!' },
    sessionStartTime: { __type: 'String!' },
  },
  StaffAccessPolicies: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'StaffAccessPoliciesPageInfo!' },
    results: { __type: '[StaffAccessPoliciesResults!]!' },
  },
  StaffAccessPoliciesOrderByInput: {
    column: { __type: 'StaffAccessPolicyOrderBy!' },
    direction: { __type: 'OrderByDirection!' },
  },
  StaffAccessPoliciesPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  StaffAccessPoliciesResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'StaffAccessPolicy!' },
  },
  StaffAccessPolicy: {
    __typename: { __type: 'String!' },
    accessPermissions: { __type: '[AccessPermissions!]' },
    allowedNetworkIds: { __type: '[ID!]' },
    corporatePermissions: { __type: '[CorporatePermissions!]' },
    createdAt: { __type: 'String!' },
    name: { __type: 'String!' },
    sitePermissions: { __type: '[SitePermissions!]' },
    staffAccessPolicyId: { __type: 'ID!' },
    updatedAt: { __type: 'String!' },
    usersCount: { __type: 'Int' },
  },
  StaffAccessPolicyAssignability: {
    __typename: { __type: 'String!' },
    siteGroups: { __type: '[SiteGroupAssignability!]!' },
    siteGroupsBlockedReason: { __type: 'AssignabilityBlockedReason' },
    sites: { __type: '[SiteAssignability!]!' },
    staffAccessPolicyId: { __type: 'ID!' },
  },
  StaffAccessPolicyAssignabilitySummary: {
    __typename: { __type: 'String!' },
    assignableSiteCount: { __type: 'Int!' },
    assignableSiteGroupCount: { __type: 'Int!' },
    fewestMissingCount: { __type: 'Int!' },
    name: { __type: 'String!' },
    staffAccessPolicyId: { __type: 'ID!' },
    totalSiteCount: { __type: 'Int!' },
    totalSiteGroupCount: { __type: 'Int!' },
  },
  StaffAccessRule: {
    __typename: { __type: 'String!' },
    assignmentType: { __type: 'StaffAccessRuleAssignmentType!' },
    corporateId: { __type: 'ID' },
    createdAt: { __type: 'String!' },
    policy: { __type: 'StaffAccessRulePolicy!' },
    siteGroupIds: { __type: '[ID!]' },
    siteGroups: { __type: '[SiteGroup!]!' },
    siteIds: { __type: '[ID!]' },
    sites: { __type: '[StaffAccessRuleSites!]!' },
    staffAccessPolicyId: { __type: 'ID!' },
    staffAccessRuleId: { __type: 'ID!' },
    staffUserId: { __type: 'ID!' },
    updatedAt: { __type: 'String!' },
  },
  StaffAccessRulePolicy: {
    __typename: { __type: 'String!' },
    accessPermissions: { __type: '[String!]' },
    allowedNetworkIds: { __type: '[ID!]' },
    corporateId: { __type: 'ID' },
    corporatePermissions: { __type: '[String!]' },
    createdAt: { __type: 'String!' },
    name: { __type: 'String!' },
    sitePermissions: { __type: '[String!]' },
    staffAccessPolicyId: { __type: 'ID!' },
    updatedAt: { __type: 'String!' },
  },
  StaffAccessRuleSites: {
    __typename: { __type: 'String!' },
    name: { __type: 'String!' },
    siteId: { __type: 'ID!' },
  },
  StaffAllowedNetwork: {
    __typename: { __type: 'String!' },
    cidr: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    ipVersion: { __type: 'Int!' },
    label: { __type: 'String!' },
    notes: { __type: 'String' },
    site: { __type: 'SiteReference' },
    siteId: { __type: 'ID' },
    staffAllowedNetworkId: { __type: 'ID!' },
    updatedAt: { __type: 'String!' },
    usage: { __type: 'StaffAllowedNetworkUsage!' },
  },
  StaffAllowedNetworkUsage: {
    __typename: { __type: 'String!' },
    staffAccessPolicyCount: { __type: 'Int!' },
    staffUserCount: { __type: 'Int!' },
  },
  StaffInvitation: {
    __typename: { __type: 'String!' },
    acceptedAt: { __type: 'String' },
    corporateId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    email: { __type: 'String!' },
    expiresAt: { __type: 'String!' },
    firstName: { __type: 'String' },
    invitationId: { __type: 'ID!' },
    invitedByUserId: { __type: 'ID!' },
    lastName: { __type: 'String' },
    permissionPolicyIds: { __type: '[String!]' },
    role: { __type: 'InvitationRole!' },
    siteId: { __type: 'ID' },
    status: { __type: 'InvitationStatus!' },
    updatedAt: { __type: 'String' },
  },
  StaffNetworkAccess: {
    __typename: { __type: 'String!' },
    effectiveAllowedNetworkIds: { __type: '[ID!]!' },
    inheritedAllowedNetworkIds: { __type: '[ID!]!' },
    isExempt: { __type: 'Boolean!' },
    isRestricted: { __type: 'Boolean!' },
  },
  StaffSessionAssignment: {
    __typename: { __type: 'String!' },
    assignedAt: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    deletedAt: { __type: 'String' },
    role: { __type: 'StaffSessionRole!' },
    sessionId: { __type: 'String!' },
    staffSessionAssignmentId: { __type: 'String!' },
    staffUserId: { __type: 'String!' },
    substitutingForStaffUserId: { __type: 'String' },
    updatedAt: { __type: 'String' },
  },
  StaffSessionAssignmentCreateInput: {
    role: { __type: 'StaffSessionRole' },
    sessionId: { __type: 'String!' },
    siteId: { __type: 'String' },
    staffUserId: { __type: 'String!' },
  },
  StaffSessionAssignmentPaginationResult: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'StaffSessionAssignmentPaginationResultPageInfo!' },
    results: { __type: '[StaffSessionAssignmentPaginationResultResults!]!' },
  },
  StaffSessionAssignmentPaginationResultPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Float!' },
  },
  StaffSessionAssignmentPaginationResultResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'StaffSessionAssignment!' },
  },
  StaffSessionAssignmentUpdateInput: { role: { __type: 'StaffSessionRole!' } },
  StaffSessionPolicy: {
    __typename: { __type: 'String!' },
    allowLocationIdleTimeout: { __type: 'Boolean!' },
    brandIdleTimeoutMinutes: { __type: 'Int' },
    maxSessionHours: { __type: 'Int' },
  },
  StaffTimeClockActivityLog: {
    __typename: { __type: 'String!' },
    events: { __type: '[StaffTimeClockEvent!]!' },
    hasNextPage: { __type: 'Boolean!' },
  },
  StaffTimeClockEvent: {
    __typename: { __type: 'String!' },
    at: { __type: 'String!' },
    byName: { __type: 'String' },
    byStaffUserId: { __type: 'ID' },
    incomplete: { __type: 'Boolean!' },
    payrollTimeClockId: { __type: 'ID!' },
    type: { __type: 'ClockStatus!' },
  },
  StaffTimeClockStatus: {
    __typename: { __type: 'String!' },
    clockInTime: { __type: 'String' },
    openShiftId: { __type: 'ID' },
    staffUserId: { __type: 'ID!' },
    status: { __type: 'ClockStatus!' },
  },
  StaffUser: {
    __typename: { __type: 'String!' },
    about: { __type: 'String!' },
    accessLevel: { __type: '[StaffUserAccessLevel!]!' },
    allowedNetworkIds: { __type: '[ID!]' },
    corporateId: { __type: 'ID' },
    createdAt: { __type: 'String!' },
    data: { __type: 'StaffUserData' },
    dateOfBirth: { __type: 'String' },
    email: { __type: 'String!' },
    employeeNumber: { __type: 'Float' },
    favoriteReportNames: { __type: '[String!]' },
    favoriteSavedReportIds: { __type: '[ID!]' },
    favoriteSiteIds: { __type: '[ID!]' },
    firebaseId: { __type: 'String!' },
    firstName: { __type: 'String!' },
    gender: { __type: 'String' },
    hobbies: { __type: 'String!' },
    instagramHandle: { __type: 'String!' },
    isInstructor: { __type: 'Boolean!', __args: { siteId: 'ID' } },
    lastName: { __type: 'String!' },
    networkAccess: { __type: 'StaffNetworkAccess!' },
    phone: { __type: 'String!' },
    profileImage: {
      __type: 'ImagePublicSignedUrl',
      __args: { input: 'ImagePublicSignedUrlInput!' },
    },
    profileImageUrl: { __type: 'String' },
    rules: { __type: '[StaffAccessRule!]!' },
    siteData: { __type: 'StaffUserSiteData', __args: { siteId: 'ID!' } },
    staffUserId: { __type: 'ID!' },
    status: { __type: 'StaffUserStatus!' },
    updatedAt: { __type: 'String!' },
  },
  StaffUserData: {
    __typename: { __type: 'String!' },
    isInstructor: { __type: 'Boolean' },
    payrollId: { __type: 'String' },
    siteId: { __type: 'ID' },
    workingHours: { __type: 'StaffUserDataWorkingHours' },
  },
  StaffUserDataWorkingHours: {
    __typename: { __type: 'String!' },
    customHoursEnabled: { __type: 'Boolean!' },
    friday: { __type: 'StaffUserDataWorkingHoursMonday' },
    monday: { __type: 'StaffUserDataWorkingHoursMonday' },
    saturday: { __type: 'StaffUserDataWorkingHoursMonday' },
    sunday: { __type: 'StaffUserDataWorkingHoursMonday' },
    thursday: { __type: 'StaffUserDataWorkingHoursMonday' },
    tuesday: { __type: 'StaffUserDataWorkingHoursMonday' },
    wednesday: { __type: 'StaffUserDataWorkingHoursMonday' },
  },
  StaffUserDataWorkingHoursMonday: {
    __typename: { __type: 'String!' },
    endTime: { __type: 'String!' },
    startTime: { __type: 'String!' },
  },
  StaffUserOption: {
    __typename: { __type: 'String!' },
    firstName: { __type: 'String' },
    lastName: { __type: 'String' },
    siteNames: { __type: '[String!]' },
    staffUserId: { __type: 'String!' },
  },
  StaffUserReference: {
    __typename: { __type: 'String!' },
    email: { __type: 'String!' },
    firstName: { __type: 'String!' },
    lastName: { __type: 'String!' },
    staffUserId: { __type: 'ID!' },
  },
  StaffUserSiteData: {
    __typename: { __type: 'String!' },
    isInstructor: { __type: 'Boolean' },
    workingHours: { __type: 'StaffUserDataWorkingHours' },
  },
  StaffUserSmartGroup: {
    __typename: { __type: 'String!' },
    filters: { __type: 'StaffUserSmartGroupFilters' },
    id: { __type: 'String!' },
    isVisible: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    sortOrder: { __type: 'Float!' },
    staffUserId: { __type: 'String!' },
  },
  StaffUserSmartGroupFilters: {
    __typename: { __type: 'String!' },
    ageRange: { __type: 'StaffUserSmartGroupFiltersAgeRange' },
    attendanceMilestone: { __type: 'StaffUserSmartGroupFiltersNoShowLateCancelAccrual' },
    birthMonth: { __type: 'StaffUserSmartGroupFiltersGender' },
    clientStatus: { __type: 'StaffUserSmartGroupFiltersGender' },
    contractStatus: { __type: 'StaffUserSmartGroupFiltersGender' },
    contractType: { __type: 'StaffUserSmartGroupFiltersGender' },
    daysAbsent: { __type: 'StaffUserSmartGroupFiltersAgeRange' },
    daysInactive: { __type: 'StaffUserSmartGroupFiltersAgeRange' },
    email: { __type: 'StaffUserSmartGroupFiltersFirstName' },
    emailOptIn: { __type: 'StaffUserSmartGroupFiltersGender' },
    failedPaymentsCount: { __type: 'StaffUserSmartGroupFiltersNoShowLateCancelAccrual' },
    firstName: { __type: 'StaffUserSmartGroupFiltersFirstName' },
    fullName: { __type: 'StaffUserSmartGroupFiltersFirstName' },
    gender: { __type: 'StaffUserSmartGroupFiltersGender' },
    hasCreditsForSessionType: { __type: 'StaffUserSmartGroupFiltersHasCreditsForSessionType' },
    isSuspended: { __type: 'StaffUserSmartGroupFiltersGender' },
    joinDate: { __type: 'StaffUserSmartGroupFiltersJoinDate' },
    lastAttendanceDate: { __type: 'StaffUserSmartGroupFiltersJoinDate' },
    lastName: { __type: 'StaffUserSmartGroupFiltersFirstName' },
    lastPaymentDate: { __type: 'StaffUserSmartGroupFiltersJoinDate' },
    lastVisitDate: { __type: 'StaffUserSmartGroupFiltersJoinDate' },
    locationStatus: { __type: 'StaffUserSmartGroupFiltersGender' },
    masterUnsubscribe: { __type: 'StaffUserSmartGroupFiltersGender' },
    noShowLateCancelAccrual: { __type: 'StaffUserSmartGroupFiltersNoShowLateCancelAccrual' },
    phone: { __type: 'StaffUserSmartGroupFiltersFirstName' },
    profileCreatedDate: { __type: 'StaffUserSmartGroupFiltersJoinDate' },
    sessionFrequency: { __type: 'StaffUserSmartGroupFiltersGender' },
    smsOptIn: { __type: 'StaffUserSmartGroupFiltersGender' },
  },
  StaffUserSmartGroupFiltersAgeRange: {
    __typename: { __type: 'String!' },
    logicalOperator: { __type: 'LogicalOperator!' },
    orderIndex: { __type: 'Float' },
    using: { __type: '[StaffUserSmartGroupFiltersAgeRangeUsing!]!' },
  },
  StaffUserSmartGroupFiltersAgeRangeUsing: {
    __typename: { __type: 'String!' },
    max: { __type: 'String' },
    min: { __type: 'String' },
    operator: { __type: 'NumericToDateFilterOperator!' },
    value: { __type: 'String' },
  },
  StaffUserSmartGroupFiltersFirstName: {
    __typename: { __type: 'String!' },
    logicalOperator: { __type: 'LogicalOperator!' },
    orderIndex: { __type: 'Float' },
    using: { __type: '[StaffUserSmartGroupFiltersFirstNameUsing!]!' },
  },
  StaffUserSmartGroupFiltersFirstNameUsing: {
    __typename: { __type: 'String!' },
    operator: { __type: 'TextFilterOperator!' },
    value: { __type: 'String!' },
  },
  StaffUserSmartGroupFiltersGender: {
    __typename: { __type: 'String!' },
    logicalOperator: { __type: 'LogicalOperator!' },
    orderIndex: { __type: 'Float' },
    using: { __type: '[StaffUserSmartGroupFiltersGenderUsing!]!' },
  },
  StaffUserSmartGroupFiltersGenderUsing: {
    __typename: { __type: 'String!' },
    operator: { __type: 'SelectFilterOperator!' },
    value: { __type: '[String!]!' },
  },
  StaffUserSmartGroupFiltersHasCreditsForSessionType: {
    __typename: { __type: 'String!' },
    bookingDate: { __type: 'String' },
    siteSessionTypeId: { __type: 'ID!' },
  },
  StaffUserSmartGroupFiltersJoinDate: {
    __typename: { __type: 'String!' },
    logicalOperator: { __type: 'LogicalOperator!' },
    orderIndex: { __type: 'Float' },
    using: { __type: '[StaffUserSmartGroupFiltersJoinDateUsing!]!' },
  },
  StaffUserSmartGroupFiltersJoinDateUsing: {
    __typename: { __type: 'String!' },
    from: { __type: 'String' },
    operator: { __type: 'DateFilterOperator!' },
    to: { __type: 'String' },
    value: { __type: 'String' },
  },
  StaffUserSmartGroupFiltersNoShowLateCancelAccrual: {
    __typename: { __type: 'String!' },
    logicalOperator: { __type: 'LogicalOperator!' },
    orderIndex: { __type: 'Float' },
    using: { __type: '[StaffUserSmartGroupFiltersNoShowLateCancelAccrualUsing!]!' },
  },
  StaffUserSmartGroupFiltersNoShowLateCancelAccrualUsing: {
    __typename: { __type: 'String!' },
    max: { __type: 'Float' },
    min: { __type: 'Float' },
    operator: { __type: 'NumericFilterOperator!' },
    value: { __type: 'Float' },
  },
  StageDestinationFeeResult: {
    __typename: { __type: 'String!' },
    amount: { __type: 'String!' },
    invoiceId: { __type: 'String!' },
    status: { __type: 'String!' },
  },
  StartExportJob: {
    __typename: { __type: 'String!' },
    jobId: { __type: 'String!' },
    totalRows: { __type: 'Float!' },
  },
  StartImportValidation: { __typename: { __type: 'String!' }, startedCount: { __type: 'Float!' } },
  StartStripeConnectOnboardingInput: {
    isSandbox: { __type: 'Boolean!' },
    paymentContactEmail: { __type: 'String' },
    siteId: { __type: 'ID!' },
  },
  StartStripeOnboardingResult: {
    __typename: { __type: 'String!' },
    onboardingUrl: { __type: 'String' },
    onboardingUrlExpiresAt: { __type: 'Float' },
    sitePaymentGateway: { __type: 'StartStripeOnboardingResultSitePaymentGateway!' },
  },
  StartStripeOnboardingResultSitePaymentGateway: {
    __typename: { __type: 'String!' },
    isSandbox: { __type: 'Boolean!' },
    onboardingStatus: { __type: 'SitePaymentGatewayOnboardingStatus!' },
    siteGatewayAccountId: { __type: 'String!' },
    sitePaymentGatewayId: { __type: 'ID!' },
  },
  StartSupportChatInput: {
    initialMessage: { __type: 'String!' },
    locale: { __type: 'String' },
    locationId: { __type: 'String' },
    locationName: { __type: 'String' },
    pageContextMeta: { __type: 'JSON' },
    pageName: { __type: 'String' },
    pathname: { __type: 'String' },
    planTier: { __type: 'String' },
    scopeLevel: { __type: 'String' },
    scopeName: { __type: 'String' },
    siteId: { __type: 'String' },
    siteName: { __type: 'String' },
    source: { __type: 'SupportChatSource' },
    suggestedQuickQuestionId: { __type: 'String' },
    timezone: { __type: 'String' },
    userId: { __type: 'String!' },
    userRole: { __type: 'String' },
  },
  StartSupportChatStreamResult: {
    __typename: { __type: 'String!' },
    chatId: { __type: 'String!' },
    streamId: { __type: 'String!' },
    userMessageId: { __type: 'String!' },
  },
  StreamSupportMessageInput: {
    locale: { __type: 'String' },
    locationId: { __type: 'String' },
    locationName: { __type: 'String' },
    pageContextMeta: { __type: 'JSON' },
    siteId: { __type: 'String' },
    siteName: { __type: 'String' },
    streamId: { __type: 'String!' },
    supportChatId: { __type: 'String!' },
    text: { __type: 'String!' },
    timezone: { __type: 'String' },
  },
  StreamSupportMessageResult: {
    __typename: { __type: 'String!' },
    messageId: { __type: 'String!' },
    streamId: { __type: 'String!' },
    success: { __type: 'Boolean!' },
    supportChatId: { __type: 'String!' },
  },
  StripeCompletionConfig: {
    __typename: { __type: 'String!' },
    clientSecret: { __type: 'String!' },
    type: { __type: 'String!' },
  },
  StripeConnectAccount: {
    __typename: { __type: 'String!' },
    email: { __type: 'String!' },
    id: { __type: 'String!' },
    inUse: { __type: 'Boolean!' },
    name: { __type: 'String' },
  },
  SubmitClientFormsQuestionnaireAnswersInput: {
    answer: { __type: 'String!' },
    expectedRevision: { __type: 'Float' },
    formId: { __type: 'String!' },
    formName: { __type: 'String!' },
    question: { __type: 'String!' },
    questionId: { __type: 'String!' },
    signupAttemptId: { __type: 'ID' },
    type: { __type: 'String!' },
  },
  SubmitClientFormsResponse: {
    __typename: { __type: 'String!' },
    message: { __type: 'String' },
    resultVisibleToClient: { __type: 'Boolean' },
    success: { __type: 'Boolean!' },
  },
  SubmitFormAnswersAnswersInput: {
    answer: { __type: 'String!' },
    siteFormQuestionId: { __type: 'String!' },
  },
  SubmitSessionFeedback: {
    __typename: { __type: 'String!' },
    message: { __type: 'String!' },
    sessionFeedbackId: { __type: 'String' },
    success: { __type: 'Boolean!' },
  },
  SubmitSessionFeedbackFeedbackAnswersInput: {
    answer: { __type: 'String!' },
    questionId: { __type: 'String!' },
    questionText: { __type: 'String!' },
  },
  SubmitSessionFeedbackInputInput: {
    attendanceId: { __type: 'String!' },
    clientId: { __type: 'String!' },
    comments: { __type: 'String' },
    feedbackAnswers: { __type: '[SubmitSessionFeedbackFeedbackAnswersInput!]!' },
    overallRating: { __type: 'Float' },
    sessionId: { __type: 'String!' },
    siteId: { __type: 'String!' },
  },
  SubstituteInstructorInput: {
    instructorToRemoveId: { __type: 'String!' },
    sessionId: { __type: 'String!' },
    substituteInstructorId: { __type: 'String!' },
  },
  SupportChat: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    evalScore: { __type: 'Float' },
    messages: { __type: '[SupportChatMessage!]' },
    pageContextMeta: { __type: 'JSON' },
    pageName: { __type: 'String' },
    pathname: { __type: 'String' },
    planTier: { __type: 'String' },
    previewText: { __type: 'String!' },
    rawUserText: { __type: 'String!' },
    responseLatencyMs: { __type: 'Int' },
    scopeLevel: { __type: 'String' },
    scopeName: { __type: 'String' },
    source: { __type: 'SupportChatSource!' },
    status: { __type: 'SupportChatStatus!' },
    suggestedQuickQuestionId: { __type: 'String' },
    supportChatId: { __type: 'ID!' },
    updatedAt: { __type: 'String!' },
    userId: { __type: 'String!' },
    userRole: { __type: 'String' },
  },
  SupportChatMessage: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    feedback: { __type: 'Boolean' },
    html: { __type: 'String' },
    metadata: { __type: 'JSON' },
    pageContextMeta: { __type: 'JSON' },
    role: { __type: 'SupportMessageRole!' },
    supportChatId: { __type: 'String!' },
    supportChatMessageId: { __type: 'ID!' },
    text: { __type: 'String!' },
    thinkingText: { __type: 'String' },
  },
  SupportChatWithMessages: {
    __typename: { __type: 'String!' },
    chat: { __type: 'SupportChat!' },
    messages: { __type: '[SupportChatMessage!]!' },
  },
  SupportMessageFeedbackInput: {
    feedback: { __type: 'Boolean' },
    pageName: { __type: 'String' },
    pathname: { __type: 'String' },
    siteId: { __type: 'String' },
    supportChatId: { __type: 'String!' },
    supportChatMessageId: { __type: 'String!' },
  },
  SupportTicket: {
    __typename: { __type: 'String!' },
    contactId: { __type: 'String' },
    ticketId: { __type: 'ID!' },
    ticketUrl: { __type: 'String!' },
  },
  SupportTicketFieldInput: {
    key: { __type: 'String!' },
    label: { __type: 'String!' },
    value: { __type: 'String!' },
  },
  SuspendServiceBatchPauseInput: {
    chargeAmount: { __type: 'Numeric' },
    chargeMode: { __type: 'ServiceSuspensionChargeMode' },
    endDate: { __type: 'String' },
    feeBillingCycleAmount: { __type: 'Float' },
    feeBillingCycleUnit: { __type: 'String' },
    reason: { __type: 'String' },
    startDate: { __type: 'String' },
    suspensionType: { __type: 'ServiceSuspensionType' },
  },
  SuspendServiceBatchResult: {
    __typename: { __type: 'String!' },
    error: { __type: 'String' },
    failedPauseIndex: { __type: 'Float' },
    serviceSuspensionIds: { __type: '[ID!]!' },
  },
  SyncBrandStoreListingsFromProviders: {
    __typename: { __type: 'String!' },
    appName: { __type: 'String' },
    brandId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    description: { __type: 'String' },
    keywords: { __type: 'String' },
    locale: { __type: 'String!' },
    marketingUrl: { __type: 'String' },
    platform: { __type: 'BrandPlatform!' },
    privacyPolicyUrl: { __type: 'String' },
    releaseNotes: { __type: 'String' },
    shortDescription: { __type: 'String' },
    subtitle: { __type: 'String' },
    supportUrl: { __type: 'String' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'String' },
  },
  SyncClientsToGrowResponse: {
    __typename: { __type: 'String!' },
    message: { __type: 'String!' },
    queued: { __type: 'Float!' },
    skipped: { __type: 'Float!' },
    success: { __type: 'Boolean!' },
  },
  SyncServiceTemplateAddOnParentInput: {
    corporatePricePointId: { __type: 'ID' },
    enabled: { __type: 'Boolean!' },
    parentServiceTemplateId: { __type: 'ID!' },
    paymentType: { __type: 'ServiceTemplateAddOnPaymentType!' },
    price: { __type: 'Numeric!' },
    taxEnabled: { __type: 'Boolean!' },
    taxSettingIds: { __type: '[ID!]' },
  },
  SyncServiceTemplateAddOnParentsInput: {
    addOnServiceTemplateId: { __type: 'ID!' },
    parents: { __type: '[SyncServiceTemplateAddOnParentInput!]!' },
  },
  SyncSmsPackageOptionsInputInput: { options: { __type: '[SyncSmsPackageOptionsOptionsInput!]!' } },
  SyncSmsPackageOptionsOptionsInput: {
    count: { __type: 'Float!' },
    optionId: { __type: 'ID' },
    price: { __type: 'Float!' },
  },
  SyncToVertexResult: {
    __typename: { __type: 'String!' },
    documentsIndexed: { __type: 'Int!' },
    durationMs: { __type: 'Int!' },
    errors: { __type: '[String!]!' },
    success: { __type: 'Boolean!' },
  },
  TanningAgentDownloadUrl: { __typename: { __type: 'String!' }, url: { __type: 'String!' } },
  TanningConnectorError: {
    __typename: { __type: 'String!' },
    connectorCode: { __type: 'String' },
    kind: { __type: 'TanningConnectorErrorKind!' },
    message: { __type: 'String!' },
  },
  TanningConnectorHealth: {
    __typename: { __type: 'String!' },
    connectorUrl: { __type: 'String' },
    consecutiveStartFailures: { __type: 'Int!' },
    diagnostics: { __type: 'AgentDiagnostics' },
    lastBedUpdateAt: { __type: 'String' },
    lastRegisteredAt: { __type: 'String' },
    lastStartError: { __type: 'TanningConnectorError' },
    lastStartFailureAt: { __type: 'String' },
    lastStartSuccessAt: { __type: 'String' },
    liveCheck: { __type: 'TanningConnectorLiveCheck' },
    reasons: { __type: '[TanningConnectorHealthReason!]!' },
    sharedWithSites: { __type: '[TanningConnectorSharedSite!]!' },
    verdict: { __type: 'TanningConnectorVerdict!' },
  },
  TanningConnectorLiveCheck: {
    __typename: { __type: 'String!' },
    checkedAt: { __type: 'String!' },
    error: { __type: 'TanningConnectorError' },
  },
  TanningConnectorSharedSite: {
    __typename: { __type: 'String!' },
    name: { __type: 'String!' },
    siteId: { __type: 'ID!' },
  },
  TanningEligibility: {
    __typename: { __type: 'String!' },
    customerAgeMaxFrequency: { __type: 'EligibilityFrequency!' },
    customerAgeMaxFrequencyAfterNoCategoryTan: { __type: 'EligibilityFrequency!' },
    eligible: { __type: 'Boolean!' },
    hoursBetweenUsesFromStartOfPrevious: { __type: 'EligibilityTiming!' },
    minimumDaysBetweenUses: { __type: 'EligibilityTiming!' },
    minimumHoursBetweenUses: { __type: 'EligibilityTiming!' },
    minutesUntilAllowed: { __type: 'Float!' },
    nextAllowedAt: { __type: 'String!' },
    nonUvAge: { __type: 'EligibilityAge!' },
    skinType: { __type: 'EligibilitySkinType' },
    uvAge: { __type: 'EligibilityAge!' },
  },
  TanningPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Float!' },
  },
  TanningRegulationOverrideInput: {
    note: { __type: 'String!' },
    rule: { __type: 'TanningRegulationRule!' },
  },
  TaxSetting: {
    __typename: { __type: 'String!' },
    corporateTaxSettingId: { __type: 'ID' },
    createdAt: { __type: 'String!' },
    deletedAt: { __type: 'String' },
    enabled: { __type: 'Boolean!' },
    isLocked: { __type: 'Boolean' },
    name: { __type: 'String!' },
    rate: { __type: 'String!' },
    setting: { __type: 'TaxSettingType!' },
    siteId: { __type: 'ID!' },
    taxSettingId: { __type: 'ID!' },
    taxSettingVersionId: { __type: 'ID!' },
    updatedAt: { __type: 'String!' },
    version: { __type: 'Float!' },
  },
  TemplateCreditSessionType: {
    __typename: { __type: 'String!' },
    name: { __type: 'String!' },
    siteSessionTypeId: { __type: 'ID!' },
    siteSessionTypeIds: { __type: '[ID!]!' },
  },
  TemplateUsingAccountCode: {
    __typename: { __type: 'String!' },
    name: { __type: 'String!' },
    serviceTemplateId: { __type: 'String!' },
  },
  TemplatesUsingAccountCodeResult: {
    __typename: { __type: 'String!' },
    count: { __type: 'Float!' },
    templates: { __type: '[TemplateUsingAccountCode!]!' },
  },
  TerminalHandoffMissingField: {
    __typename: { __type: 'String!' },
    field: { __type: 'TerminalHandoffField!' },
    inputType: { __type: 'TerminalReaderInputType!' },
  },
  TerminalHandoffPlan: {
    __typename: { __type: 'String!' },
    fallback: { __type: 'TerminalSignatureFallback!' },
    fieldCaptureEnabled: { __type: 'Boolean!' },
    missingFields: { __type: '[TerminalHandoffMissingField!]!' },
    readers: { __type: '[TerminalHandoffReaderOption!]!' },
    signatureCaptureEnabled: { __type: 'Boolean!' },
    signatureDevice: { __type: 'TerminalSignatureDevice!' },
  },
  TerminalHandoffReaderOption: {
    __typename: { __type: 'String!' },
    name: { __type: 'String!' },
    siteTerminalReaderId: { __type: 'ID!' },
    supportsHandoff: { __type: 'Boolean!' },
    unsupportedReason: { __type: 'TerminalReaderUnsupportedReason' },
  },
  TerminalHandoffRequest: {
    __typename: { __type: 'String!' },
    appliedAt: { __type: 'String' },
    batchCount: { __type: 'Float!' },
    canRetry: { __type: 'Boolean!' },
    clientId: { __type: 'ID' },
    createdAt: { __type: 'String!' },
    currentBatchIndex: { __type: 'Float!' },
    failureCode: { __type: 'TerminalHandoffFailureCode' },
    readerLabel: { __type: 'String' },
    roundTripMs: { __type: 'Float' },
    sentAt: { __type: 'String' },
    siteId: { __type: 'ID!' },
    siteTerminalReaderId: { __type: 'ID!' },
    sourceSurface: { __type: 'TerminalHandoffSourceSurface!' },
    status: { __type: 'TerminalHandoffStatus!' },
    steps: { __type: '[TerminalHandoffStep!]!' },
    terminalHandoffRequestId: { __type: 'ID!' },
    underAgeCosignRequired: { __type: 'Boolean!' },
  },
  TerminalHandoffStep: {
    __typename: { __type: 'String!' },
    agreementId: { __type: 'ID' },
    agreementName: { __type: 'String' },
    agreementVersion: { __type: 'String' },
    appliedAt: { __type: 'String' },
    batchIndex: { __type: 'Float!' },
    capturedAt: { __type: 'String' },
    capturedValue: { __type: 'String' },
    field: { __type: 'TerminalHandoffField' },
    holdReason: { __type: 'TerminalHandoffHoldReason' },
    inputType: { __type: 'TerminalReaderInputType!' },
    kind: { __type: 'TerminalHandoffStepKind!' },
    padCount: { __type: 'Float' },
    padIndex: { __type: 'Float' },
    readerText: { __type: 'String' },
    reference: { __type: 'String' },
    required: { __type: 'Boolean!' },
    state: { __type: 'TerminalHandoffStepState!' },
    stepKey: { __type: 'String!' },
  },
  TerminalPaymentMethodDetails: {
    __typename: { __type: 'String!' },
    brand: { __type: 'String' },
    last4: { __type: 'String' },
    type: { __type: 'TerminalPaymentMethodType!' },
  },
  TestAppleApiConnection: {
    __typename: { __type: 'String!' },
    message: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  TestEzypayConnectionPayload: {
    __typename: { __type: 'String!' },
    message: { __type: 'String' },
    ok: { __type: 'Boolean!' },
  },
  TestHqAuthResponse: {
    __typename: { __type: 'String!' },
    message: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  TestMember: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    email: { __type: 'String!' },
    firebaseId: { __type: 'String' },
    firstName: { __type: 'String' },
    homeSiteId: { __type: 'String' },
    homeSiteName: { __type: 'String' },
    lastName: { __type: 'String' },
  },
  TestMemberWithCredentials: {
    __typename: { __type: 'String!' },
    clientId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    email: { __type: 'String!' },
    firebaseId: { __type: 'String' },
    firstName: { __type: 'String' },
    homeSiteId: { __type: 'String' },
    homeSiteName: { __type: 'String' },
    lastName: { __type: 'String' },
    password: { __type: 'String!' },
  },
  TestSiteAuthResponse: {
    __typename: { __type: 'String!' },
    message: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  ThemeDeploymentResult: {
    __typename: { __type: 'String!' },
    deployedSiteIds: { __type: '[ID!]!' },
    skipped: { __type: '[ThemeDeploymentResultSkipped!]!' },
    slug: { __type: 'ThemeKey!' },
  },
  ThemeDeploymentResultSkipped: {
    __typename: { __type: 'String!' },
    reason: { __type: 'String!' },
    siteId: { __type: 'ID!' },
  },
  ThemeDeploymentRow: {
    __typename: { __type: 'String!' },
    deployedSiteIds: { __type: '[ID!]!' },
    slug: { __type: 'String!' },
    themeName: { __type: 'String!' },
  },
  ThemeEntitlementResult: {
    __typename: { __type: 'String!' },
    active: { __type: 'Boolean!' },
    features: { __type: 'JSONObject!' },
    status: { __type: 'ThemeSubscriptionStatus' },
    trialEndsAt: { __type: 'String' },
  },
  ThemeSubscription: {
    __typename: { __type: 'String!' },
    activatedAt: { __type: 'String' },
    billingCycleAmount: { __type: 'Float' },
    cancelledAt: { __type: 'String' },
    corporateId: { __type: 'ID!' },
    corporateThemeSubscriptionId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    currency: { __type: 'String!' },
    effectiveCancelAt: { __type: 'String' },
    expiresAt: { __type: 'String' },
    gracePeriodEndsAt: { __type: 'String' },
    lastBilledAt: { __type: 'String' },
    metadata: { __type: 'JSONObject' },
    nextBillingDate: { __type: 'String' },
    slug: { __type: 'String!' },
    status: { __type: 'ThemeSubscriptionStatus!' },
    subscribedAt: { __type: 'String!' },
    themeId: { __type: 'ID!' },
    themeName: { __type: 'String!' },
    trialEndsAt: { __type: 'String' },
    updatedAt: { __type: 'String!' },
  },
  ThirdPartyIntegrationCreateInput: {
    description: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
    name: { __type: 'String!' },
  },
  ThirdPartyIntegrationKey: {
    __typename: { __type: 'String!' },
    availableFor: { __type: 'ThirdPartyIntegrationAvailableFor!' },
    createdAt: { __type: 'String!' },
    deletedAt: { __type: 'String' },
    name: { __type: 'String!' },
    thirdPartyIntegrationId: { __type: 'ID!' },
    thirdPartyIntegrationKeyId: { __type: 'ID!' },
    uniqueAcross: { __type: 'ThirdPartyIntegrationUniqueAcross' },
    updatedAt: { __type: 'String!' },
    visibilityAt: { __type: 'ThirdPartyIntegrationVisibilityAt!' },
  },
  ThirdPartyIntegrationKeyCreateInput: {
    availableFor: { __type: 'ThirdPartyIntegrationAvailableFor!' },
    name: { __type: 'String!' },
    uniqueAcross: { __type: 'ThirdPartyIntegrationUniqueAcross' },
    visibilityAt: { __type: 'ThirdPartyIntegrationVisibilityAt!' },
  },
  ThirdPartyIntegrationKeyUpdateInput: {
    availableFor: { __type: 'ThirdPartyIntegrationAvailableFor' },
    name: { __type: 'String' },
    uniqueAcross: { __type: 'ThirdPartyIntegrationUniqueAcross' },
    visibilityAt: { __type: 'ThirdPartyIntegrationVisibilityAt' },
  },
  ThirdPartyIntegrationUpdateInput: {
    description: { __type: 'String' },
    enabled: { __type: 'Boolean' },
    name: { __type: 'String' },
  },
  ThirdPartyIntegrationWithKeys: {
    __typename: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    deletedAt: { __type: 'String' },
    description: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
    keys: { __type: '[ThirdPartyIntegrationKey!]!' },
    name: { __type: 'String!' },
    thirdPartyIntegrationId: { __type: 'ID!' },
    updatedAt: { __type: 'String!' },
  },
  ThumbnailUploadUrlResult: {
    __typename: { __type: 'String!' },
    thumbnailUrl: { __type: 'String!' },
    uploadUrl: { __type: 'String!' },
  },
  TicketChatMessageInput: {
    content: { __type: 'String!' },
    role: { __type: 'String!' },
    timestamp: { __type: 'String' },
  },
  TokenRefreshResponse: {
    __typename: { __type: 'String!' },
    failedCount: { __type: 'Float' },
    message: { __type: 'String!' },
    refreshedCount: { __type: 'Float' },
    success: { __type: 'Boolean!' },
  },
  TopServiceItem: {
    __typename: { __type: 'String!' },
    rank: { __type: 'Float!' },
    serviceName: { __type: 'String!' },
    visitCount: { __type: 'Float!' },
  },
  TopVideoItem: {
    __typename: { __type: 'String!' },
    avgWatchTimeSeconds: { __type: 'Float!' },
    completionRate: { __type: 'Float!' },
    contentMediaId: { __type: 'String!' },
    totalViews: { __type: 'Float!' },
    uniqueViewers: { __type: 'Float!' },
  },
  TransferClientResponse: {
    __typename: { __type: 'String!' },
    message: { __type: 'String' },
    success: { __type: 'Boolean!' },
  },
  TrialPipelineItem: {
    __typename: { __type: 'String!' },
    corporateId: { __type: 'String!' },
    createdByName: { __type: 'String' },
    daysRemaining: { __type: 'Float' },
    hasSeedingData: { __type: 'Boolean!' },
    healthScore: { __type: 'Float!' },
    leadSource: { __type: 'String' },
    name: { __type: 'String!' },
    onboardingProgressPct: { __type: 'Float!' },
    salesOwnerId: { __type: 'String' },
    salesOwnerName: { __type: 'String' },
    trialCloseNotes: { __type: 'String' },
    trialCloseReason: { __type: 'String' },
    trialExpiresAt: { __type: 'String' },
    trialStartedAt: { __type: 'String' },
    trialStatus: { __type: 'String' },
    urlPrefix: { __type: 'String!' },
  },
  TrialStatusResponse: {
    __typename: { __type: 'String!' },
    daysRemaining: { __type: 'Float' },
    onboardingProgress: { __type: 'OnboardingProgress!' },
    trialConvertedAt: { __type: 'String' },
    trialExpiresAt: { __type: 'String' },
    trialStartedAt: { __type: 'String' },
    trialStatus: { __type: 'TrialStatus' },
  },
  TriggerGrowHqCustomFieldsSyncResponse: {
    __typename: { __type: 'String!' },
    fieldCount: { __type: 'Float!' },
    message: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  TriggerGrowSiteCustomFieldsSyncResponse: {
    __typename: { __type: 'String!' },
    failed: { __type: 'Float!' },
    message: { __type: 'String!' },
    skipped: { __type: 'Float!' },
    success: { __type: 'Boolean!' },
    synced: { __type: 'Float!' },
  },
  TriggerHqSyncResponse: { __typename: { __type: 'String!' }, success: { __type: 'Boolean!' } },
  TriggerSiteSyncResponse: {
    __typename: { __type: 'String!' },
    jobId: { __type: 'String' },
    message: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  UndoCheckinResult: {
    __typename: { __type: 'String!' },
    message: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  UpcomingOpeningException: {
    __typename: { __type: 'String!' },
    date: { __type: 'String!' },
    isClosed: { __type: 'Boolean!' },
    label: { __type: 'String!' },
    ranges: { __type: '[ResolvedOpeningRange!]!' },
  },
  UpdateAccessControlsDoorsInput: {
    accessGroupId: { __type: 'String' },
    accessHours: { __type: 'Boolean!' },
    doorId: { __type: 'String!' },
    endTime: { __type: 'String' },
    label: { __type: 'String!' },
    provider: { __type: 'AccessControlProvider!' },
    sessionTypes: { __type: '[String!]!' },
    startTime: { __type: 'String' },
  },
  UpdateAccessControlsInputInput: { doors: { __type: '[UpdateAccessControlsDoorsInput!]' } },
  UpdateAccessRuleInputInput: {
    assignmentType: { __type: 'StaffAccessRuleAssignmentType' },
    siteGroupIds: { __type: '[ID!]' },
    siteIds: { __type: '[ID!]' },
    staffAccessPolicyId: { __type: 'ID' },
  },
  UpdateAccuroFitInputInput: { clientId: { __type: 'String' } },
  UpdateAddOnPriceGroupInput: {
    addOnPriceGroupId: { __type: 'ID!' },
    name: { __type: 'String' },
    siteSessionTypeIds: { __type: '[ID!]' },
    taxSettingIds: { __type: '[ID!]' },
  },
  UpdateAdminUserInputInput: {
    accessGroupId: { __type: 'ID!' },
    accessGroupPassword: { __type: 'String' },
    firstName: { __type: 'String!' },
    lastName: { __type: 'String!' },
    phone: { __type: 'String!' },
  },
  UpdateAppStoreCredentials: {
    __typename: { __type: 'String!' },
    credentials: { __type: 'AppStoreCredentials' },
    success: { __type: 'Boolean!' },
  },
  UpdateAppStoreCredentialsInputInput: {
    apnsAuthKey: { __type: 'String' },
    apnsKeyId: { __type: 'String' },
    appleAccountName: { __type: 'String' },
    appleIssuerId: { __type: 'String' },
    appleKeyId: { __type: 'String' },
    applePrivateKey: { __type: 'String' },
    appleTeamId: { __type: 'String' },
    bundleId: { __type: 'String' },
    firebaseAndroidConfig: { __type: 'String' },
    firebaseIosConfig: { __type: 'String' },
    googleServiceAccountEmail: { __type: 'String' },
    googleServiceAccountJson: { __type: 'String' },
    jwPlayerLicenseKey: { __type: 'String' },
    packageName: { __type: 'String' },
    userId: { __type: 'String' },
  },
  UpdateBrandIdentityIdentityInput: {
    appleId: { __type: 'String' },
    appleItcTeamId: { __type: 'String' },
    appleTeamId: { __type: 'String' },
    ascAppId: { __type: 'String' },
    bundleIdIos: { __type: 'String' },
    packageAndroid: { __type: 'String' },
    playStoreId: { __type: 'String' },
    scheme: { __type: 'String' },
  },
  UpdateBrandNativePermissionsIosUsageDescriptionsInput: {
    key: { __type: 'IosUsageDescriptionKey!' },
    text: { __type: 'String!' },
  },
  UpdateCarouselGroupInput: { name: { __type: 'String' } },
  UpdateClassPassInputInput: {
    classPassSpotsPerSession: { __type: 'Float' },
    enabled: { __type: 'Boolean!' },
  },
  UpdateClientAccountBalancePreference: {
    __typename: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  UpdateClientAlertInputInput: {
    alertId: { __type: 'String!' },
    description: { __type: 'String' },
    endDate: { __type: 'String' },
    startDate: { __type: 'String' },
    title: { __type: 'String' },
  },
  UpdateClientCommunicationPreferencesInput: {
    email: { __type: 'Boolean' },
    notifications: { __type: 'Boolean' },
    phone: { __type: 'Boolean' },
    sms: { __type: 'Boolean' },
  },
  UpdateClientCustomPropertyValueResponse: {
    __typename: { __type: 'String!' },
    message: { __type: 'String' },
    success: { __type: 'Boolean!' },
  },
  UpdateClientCustomPropertyValuesResponse: {
    __typename: { __type: 'String!' },
    lockedSiteCustomPropertyIds: { __type: '[String!]' },
    message: { __type: 'String' },
    success: { __type: 'Boolean!' },
    values: { __type: '[ClientCustomPropertyValue!]' },
  },
  UpdateClientCustomPropertyValuesValuesInput: {
    siteCustomPropertyId: { __type: 'String!' },
    value: { __type: 'String' },
  },
  UpdateClientFamilyInput: {
    email: { __type: 'String' },
    name: { __type: 'String' },
    relationship: { __type: 'ClientFamilyRelationship' },
  },
  UpdateClientFileNameResponse: {
    __typename: { __type: 'String!' },
    message: { __type: 'String' },
    success: { __type: 'Boolean!' },
  },
  UpdateClientInput: {
    activePackagesCount: { __type: 'Float' },
    address: { __type: 'CreateClientAddressInput' },
    barcode: { __type: 'String' },
    communicationPreferences: { __type: 'UpdateClientCommunicationPreferencesInput' },
    confirmFobReassign: { __type: 'Boolean' },
    csn: { __type: 'String' },
    customerId: { __type: 'String' },
    dateOfBirth: { __type: 'String' },
    email: { __type: 'String' },
    emergencyContact: { __type: 'CreateClientEmergencyContactInput' },
    favoriteSiteIds: { __type: '[String!]' },
    firebaseId: { __type: 'String' },
    firstName: { __type: 'String' },
    fobNumber: { __type: 'String' },
    gender: { __type: 'String' },
    homeLocationIds: { __type: '[String!]' },
    homePhoneNumber: { __type: 'String' },
    homeSiteId: { __type: 'String' },
    homeSiteName: { __type: 'String' },
    isProspect: { __type: 'Boolean' },
    lastName: { __type: 'String' },
    mobilePhoneNumber: { __type: 'String' },
    occupation: { __type: 'String' },
    recentSiteId: { __type: 'String' },
    source: { __type: 'ClientSource' },
  },
  UpdateClientNoteResponse: {
    __typename: { __type: 'String!' },
    message: { __type: 'String' },
    note: { __type: 'ClientNote' },
    success: { __type: 'Boolean!' },
  },
  UpdateClientRecentSite: { __typename: { __type: 'String!' }, success: { __type: 'Boolean!' } },
  UpdateClientResponse: { __typename: { __type: 'String!' }, success: { __type: 'Boolean!' } },
  UpdateClientSiteDataResponse: {
    __typename: { __type: 'String!' },
    message: { __type: 'String' },
    success: { __type: 'Boolean!' },
  },
  UpdateCommunicationEmailInput: {
    defaultFromEmail: { __type: 'String' },
    defaultFromName: { __type: 'String' },
  },
  UpdateCommunicationTemplateCommunicationTemplateInput: {
    emailBody: { __type: 'String' },
    emailEnabled: { __type: 'Boolean' },
    emailSubject: { __type: 'String' },
    name: { __type: 'String' },
    pushNotificationEnabled: { __type: 'Boolean' },
    pushNotificationMessage: { __type: 'String' },
    pushNotificationTitle: { __type: 'String' },
    smsEnabled: { __type: 'Boolean' },
    smsMessage: { __type: 'String' },
  },
  UpdateCorporateAddOnDraftInput: {
    assignedSiteGroupIds: { __type: '[ID!]' },
    assignedSiteIds: { __type: '[ID!]' },
    config: { __type: 'BrandAddOnConfigInput!' },
    corporateServiceTemplateId: { __type: 'ID!' },
    expectedVersion: { __type: 'Float!' },
    isAllLocations: { __type: 'Boolean!' },
    lockedSections: { __type: '[BrandServiceTemplateSection!]' },
  },
  UpdateCorporateAdminConfigurationsAppSettingsClientSelfServiceSuspensionInput: {
    enabled: { __type: 'Boolean' },
    maxSuspensionDays: { __type: 'Float' },
    minSuspensionDays: { __type: 'Float' },
    totalCalendarYearSuspensionDays: { __type: 'Float' },
  },
  UpdateCorporateAdminConfigurationsAppSettingsInput: {
    androidVersion: { __type: 'String' },
    classTimeFilter: { __type: 'Boolean' },
    clientSelfServiceSuspension: {
      __type: 'UpdateCorporateAdminConfigurationsAppSettingsClientSelfServiceSuspensionInput',
    },
    displayInstructor: { __type: 'Boolean' },
    displayPackageDescription: { __type: 'Boolean' },
    displayProfilePicture: { __type: 'Boolean' },
    displayTodayClasses: { __type: 'Boolean' },
    forceUpdateAndroid: { __type: 'Boolean' },
    forceUpdateIOS: { __type: 'Boolean' },
    iosVersion: { __type: 'String' },
    privatesAnyAvailable: { __type: 'Boolean' },
    purchaseRedirect: { __type: 'String' },
    pushProvider: { __type: 'PushProvider' },
    redirectUrl: { __type: 'String' },
    signUpRedirect: { __type: 'String' },
    signUpToggle: { __type: 'Boolean' },
  },
  UpdateCorporateAdminConfigurationsInput: {
    appSettings: { __type: 'UpdateCorporateAdminConfigurationsAppSettingsInput' },
    customization: { __type: 'UpdateCorporateCustomizationInput' },
    hubspot: { __type: 'CreateCorporateHubspotInput' },
    paymentRouting: { __type: 'UpdateCorporateAdminConfigurationsPaymentRoutingInput' },
    publicApi: { __type: 'UpdateCorporateAdminConfigurationsPublicApiInput' },
    system: { __type: 'UpdateCorporateAdminConfigurationsSystemInput' },
  },
  UpdateCorporateAdminConfigurationsPaymentRoutingInput: {
    chargeRouting: { __type: 'PaymentRoutingMode' },
    pipeline: { __type: 'UpdateCorporateAdminConfigurationsPaymentRoutingPipelineInput' },
  },
  UpdateCorporateAdminConfigurationsPaymentRoutingPipelineInput: {
    mode: { __type: 'PaymentsPipelineMode' },
  },
  UpdateCorporateAdminConfigurationsPublicApiInput: { logLevel: { __type: 'PublicApiLogLevel' } },
  UpdateCorporateAdminConfigurationsSystemInput: {
    blockWhenClientOwesAtAnyLocation: { __type: 'Boolean' },
    classicDashboardsEnabled: { __type: 'Boolean' },
    connectedSiteForPassportAccess: { __type: 'Boolean' },
    corporateClientLookup: { __type: 'Boolean' },
    generateAttendanceStatisticsPerSessionTemplate: { __type: 'Boolean' },
  },
  UpdateCorporateCommunicationSettingsInput: { email: { __type: 'UpdateCommunicationEmailInput' } },
  UpdateCorporateCustomThirdPartyIntegrationInput: {
    keyValues: { __type: '[UpdateCorporateCustomThirdPartyIntegrationKeyValuesInput!]!' },
    thirdPartyIntegrationId: { __type: 'String!' },
  },
  UpdateCorporateCustomThirdPartyIntegrationKeyValuesInput: {
    key: { __type: 'String!' },
    value: { __type: 'String' },
  },
  UpdateCorporateCustomizationColorSchemaInput: {
    backgroundColor: { __type: 'String' },
    primaryColor: { __type: 'String' },
    primaryTextColor: { __type: 'String' },
    secondaryColor: { __type: 'String' },
    secondaryTextColor: { __type: 'String' },
  },
  UpdateCorporateCustomizationInput: {
    buttonStyle: { __type: 'String' },
    colorSchema: { __type: 'UpdateCorporateCustomizationColorSchemaInput' },
    customCssLink: { __type: 'String' },
  },
  UpdateCorporateFaqInput: {
    heading: { __type: 'String' },
    response: { __type: 'String' },
    status: { __type: 'CorporateFaqStatus' },
  },
  UpdateCorporateInput: {
    adminConfigurations: { __type: 'UpdateCorporateAdminConfigurationsInput' },
    clientTenantId: { __type: 'String' },
    createdBy: { __type: 'String' },
    currency: { __type: 'String' },
    customization: { __type: 'UpdateCorporateCustomizationInput' },
    dashboardHeroImage: { __type: 'UpdateCorporateLogoImageInput' },
    dashboardHeroImageTemp: { __type: 'String' },
    description: { __type: 'String' },
    email: { __type: 'String' },
    embedWidgetConfig: { __type: 'JSONObject' },
    isOnboarding: { __type: 'Boolean' },
    language: { __type: 'String' },
    leadSource: { __type: 'String' },
    logoImage: { __type: 'UpdateCorporateLogoImageInput' },
    logoImageTemp: { __type: 'String' },
    migrationStatus: { __type: 'String' },
    name: { __type: 'String' },
    onboardingCompletedAt: { __type: 'String' },
    paymentAuthorisationConfig: { __type: 'UpdateCorporatePaymentAuthorisationConfigInput' },
    phone: { __type: 'String' },
    planTier: { __type: 'ProductPlanTier' },
    region: { __type: 'String' },
    sitesCount: { __type: 'Float' },
    slug: { __type: 'String' },
    staffTenantId: { __type: 'String' },
    status: { __type: 'String' },
    subdomain: { __type: 'String' },
    tier: { __type: 'String' },
    timezone: { __type: 'String' },
    trialConvertedAt: { __type: 'String' },
    trialExpiresAt: { __type: 'String' },
    trialStartedAt: { __type: 'String' },
    trialStatus: { __type: 'String' },
    updatedBy: { __type: 'String' },
    urlPrefix: { __type: 'String' },
    website: { __type: 'String' },
  },
  UpdateCorporateIntegrationsContentfulInput: {
    accessToken: { __type: 'String' },
    contentApiBaseUrl: { __type: 'String' },
    managementAccessToken: { __type: 'String' },
    previewToken: { __type: 'String' },
    spaceId: { __type: 'String' },
    useNativeContent: { __type: 'Boolean' },
  },
  UpdateCorporateIntegrationsDeeplinkingInput: {
    androidPackageName: { __type: 'String' },
    dynamicDomainLink: { __type: 'String' },
    iosAppStoreId: { __type: 'String' },
    iosBundleId: { __type: 'String' },
    webApiKey: { __type: 'String' },
  },
  UpdateCorporateIntegrationsEgymInput: { enabled: { __type: 'Boolean' } },
  UpdateCorporateIntegrationsGrowInput: {
    enableHqLocationSync: { __type: 'Boolean' },
    enabled: { __type: 'Boolean' },
    syncDndAndChannels: { __type: 'Boolean' },
  },
  UpdateCorporateIntegrationsPushNotificationInput: {
    id: { __type: 'String!' },
    key: { __type: 'String!' },
  },
  UpdateCorporateIntegrationsZapierInput: { enabled: { __type: 'Boolean' } },
  UpdateCorporateLogoImageInput: { url: { __type: 'String' } },
  UpdateCorporatePaymentAuthorisationConfigBankDebitAuthorisationInput: {
    coversLocationsFrom: { __type: 'String!' },
    evidenceReference: { __type: 'String!' },
    originatorName: { __type: 'String!' },
  },
  UpdateCorporatePaymentAuthorisationConfigInput: {
    bankDebitAuthorisation: {
      __type: 'UpdateCorporatePaymentAuthorisationConfigBankDebitAuthorisationInput',
    },
    cancellationPolicy: { __type: 'String!' },
    customerServiceContact: { __type: 'String!' },
    depositNote: { __type: 'String' },
    legalEntityName: { __type: 'String' },
    salesTaxNote: { __type: 'String' },
    template: { __type: 'String' },
  },
  UpdateCorporatePayoutAccountInputInput: {
    currency: { __type: 'StripePayoutCurrency' },
    currencyConversionFee: { __type: 'CorporatePayoutAccountPayoutFeeInput' },
    name: { __type: 'String' },
    payoutFee: { __type: 'CorporatePayoutAccountPayoutFeeInput' },
    stripeId: { __type: 'String' },
  },
  UpdateCorporateSessionTypeInput: {
    acknowledgedAdoptionSiteIds: { __type: '[ID!]' },
    allowEditingSessionType: { __type: 'Boolean' },
    allowMultiLocationAccess: { __type: 'Boolean' },
    assignedSiteGroupIds: { __type: '[ID!]' },
    assignedSiteIds: { __type: '[ID!]' },
    color: { __type: 'String' },
    isAllLocations: { __type: 'Boolean' },
    lockedSections: { __type: '[SessionGroupSection!]' },
    name: { __type: 'String' },
    withdrawMode: { __type: 'CorporateSessionTypeWithdrawMode' },
  },
  UpdateCorporateTaxSettingInput: {
    assignedSiteGroupIds: { __type: '[ID!]' },
    assignedSiteIds: { __type: '[ID!]' },
    enabled: { __type: 'Boolean' },
    isLocked: { __type: 'Boolean' },
    name: { __type: 'String' },
    rate: { __type: 'String' },
    setting: { __type: 'TaxSettingType' },
  },
  UpdateCorporateWebhookInputInput: {
    allSites: { __type: 'Boolean' },
    events: { __type: '[String!]' },
    headerKey: { __type: 'String' },
    headerValue: { __type: 'String' },
    name: { __type: 'String' },
    siteIds: { __type: '[String!]' },
    url: { __type: 'String' },
  },
  UpdateCustomPropertyAlert: { __typename: { __type: 'String!' }, success: { __type: 'Boolean!' } },
  UpdateCustomText: {
    __typename: { __type: 'String!' },
    customizationCount: { __type: 'Float' },
    errors: { __type: '[UpdateCustomTextErrors!]' },
    success: { __type: 'Boolean!' },
  },
  UpdateCustomTextErrors: {
    __typename: { __type: 'String!' },
    actual: { __type: 'Float' },
    error: { __type: 'String!' },
    expected: { __type: 'Float' },
    key: { __type: 'String!' },
  },
  UpdateEgymIntegrationInput: {
    activeMembershipType: { __type: 'EgymMembershipType!' },
    apiKey: { __type: 'String' },
    enabled: { __type: 'Boolean!' },
  },
  UpdateEmbedCustomizationCustomizationAdvancedFilterOptionsInput: {
    category: { __type: 'Boolean!' },
    duration: { __type: 'Boolean!' },
    instructor: { __type: 'Boolean!' },
    location: { __type: 'Boolean!' },
    time: { __type: 'Boolean!' },
  },
  UpdateEmbedCustomizationCustomizationAdvancedInput: {
    buttonStyle: { __type: 'EmbedButtonStyle!' },
    classTimeFilter: { __type: 'Boolean!' },
    customCssLink: { __type: 'String!' },
    displayInstructor: { __type: 'Boolean!' },
    displayPackageDescription: { __type: 'Boolean!' },
    displayProfilePicture: { __type: 'Boolean!' },
    filterOptions: { __type: 'UpdateEmbedCustomizationCustomizationAdvancedFilterOptionsInput!' },
    privatesAnyAvailable: { __type: 'Boolean!' },
    redirectUrl: { __type: 'String!' },
    showFilters: { __type: 'Boolean!' },
    signUpEnabled: { __type: 'Boolean!' },
  },
  UpdateEmbedCustomizationCustomizationAppearanceInput: {
    borderRadius: { __type: 'Float!' },
    buttonStyle: { __type: 'EmbedAppearanceButtonStyle!' },
    fontFamily: { __type: 'String!' },
    fontSize: { __type: 'Float!' },
  },
  UpdateEmbedCustomizationCustomizationBrandingInput: {
    appName: { __type: 'String!' },
    faviconUrl: { __type: 'String!' },
    logoUrl: { __type: 'String!' },
  },
  UpdateEmbedCustomizationCustomizationColorsInput: {
    backgroundColor: { __type: 'String!' },
    primaryColor: { __type: 'String!' },
    primaryTextColor: { __type: 'String!' },
    secondaryColor: { __type: 'String!' },
    secondaryTextColor: { __type: 'String!' },
  },
  UpdateEmbedCustomizationCustomizationCustomTextInput: {
    defaultLanguage: { __type: 'String!' },
    translations: { __type: 'JSONObject!' },
  },
  UpdateEmbedCustomizationCustomizationInput: {
    advanced: { __type: 'UpdateEmbedCustomizationCustomizationAdvancedInput' },
    appearance: { __type: 'UpdateEmbedCustomizationCustomizationAppearanceInput' },
    branding: { __type: 'UpdateEmbedCustomizationCustomizationBrandingInput' },
    colors: { __type: 'UpdateEmbedCustomizationCustomizationColorsInput' },
    customText: { __type: 'UpdateEmbedCustomizationCustomizationCustomTextInput' },
    layout: { __type: 'UpdateEmbedCustomizationCustomizationLayoutInput' },
    modules: { __type: 'UpdateEmbedCustomizationCustomizationModulesInput' },
  },
  UpdateEmbedCustomizationCustomizationLayoutInput: {
    footerVisible: { __type: 'Boolean!' },
    headerVisible: { __type: 'Boolean!' },
    sidebarPosition: { __type: 'EmbedSidebarPosition!' },
  },
  UpdateEmbedCustomizationCustomizationModulesInput: {
    classes: { __type: 'Boolean!' },
    dashboard: { __type: 'Boolean!' },
    packages: { __type: 'Boolean!' },
    payments: { __type: 'Boolean!' },
    privates: { __type: 'Boolean!' },
    profile: { __type: 'Boolean!' },
    schedule: { __type: 'Boolean!' },
    workshops: { __type: 'Boolean!' },
  },
  UpdateEmbedWebsiteWidgetsWebsiteWidgetsInput: {
    selectedWidgets: { __type: '[String!]' },
    widgetSettings: { __type: 'JSONObject' },
  },
  UpdateEquipmentInput: {
    category: { __type: 'EquipmentCategory' },
    defaultDelayMinutes: { __type: 'Int' },
    defaultTimerMinutes: { __type: 'Int' },
    description: { __type: 'String' },
    manufacturer: { __type: 'String' },
    maxDelayMinutes: { __type: 'Int' },
    maxTimerMinutes: { __type: 'Int' },
    minDelayMinutes: { __type: 'Int' },
    minTimerMinutes: { __type: 'Int' },
    name: { __type: 'String' },
    nonUvCategory: { __type: 'NonUvCategory' },
    qualityCategory: { __type: 'EquipmentQualityCategory' },
    siteSessionTypeIds: { __type: '[String!]' },
    timerId: { __type: 'Int' },
  },
  UpdateEquipmentLampSettingsInput: {
    body: { __type: 'LampSetSettingsInput' },
    equipmentId: { __type: 'ID!' },
    facial: { __type: 'LampSetSettingsInput' },
  },
  UpdateEquipmentRegulationInput: {
    equipmentCategory: { __type: 'EquipmentCategory' },
    rules: { __type: 'CreateEquipmentRegulationRulesInput' },
  },
  UpdateExternalFeedbackLinkInputInput: { url: { __type: 'String' } },
  UpdateEzypayGatewayInput: {
    merchantId: { __type: 'ID' },
    merchantPassword: { __type: 'String' },
    merchantUsername: { __type: 'String' },
    paymentContactEmail: { __type: 'String' },
    sitePaymentGatewayId: { __type: 'ID!' },
  },
  UpdateEzypayGatewayPayload: {
    __typename: { __type: 'String!' },
    sitePaymentGateway: { __type: 'EzypayGateway!' },
  },
  UpdateFacebookPixelEventsInput: {
    enabled: { __type: 'Boolean!' },
    facebookEventName: { __type: 'String!' },
    name: { __type: 'String!' },
  },
  UpdateFacebookPixelInputInput: {
    events: { __type: '[UpdateFacebookPixelEventsInput!]' },
    pixelId: { __type: 'String' },
  },
  UpdateFamilySettingsInputInput: { adminsPerFamily: { __type: 'Float!' } },
  UpdateFeeConfigurationInputInput: {
    accountType: { __type: 'FeeAccountType' },
    description: { __type: 'String' },
    enabled: { __type: 'Boolean' },
    eventType: { __type: 'FeeEventType' },
    name: { __type: 'String' },
    paymentGateway: { __type: 'PaymentGateway' },
    rate: { __type: 'Numeric' },
    rateType: { __type: 'FeeRateType' },
    webhookEndpoint: { __type: 'String' },
    webhookType: { __type: 'String' },
  },
  UpdateFitnessPassportInput: {
    deviceToken: { __type: 'String' },
    enabled: { __type: 'Boolean!' },
    failurePolicy: { __type: 'FitnessPassportFailurePolicy!' },
    siteToken: { __type: 'String' },
  },
  UpdateFrontDeskKioskBetaVersionInput: {
    classCheckInEnabled: { __type: 'Boolean' },
    classCheckInRequirePolicies: { __type: 'Boolean' },
    classCheckInSpotBooking: { __type: 'Boolean' },
    enabled: { __type: 'Boolean' },
    introOffersEnabled: { __type: 'Boolean' },
    packagesMembershipsEnabled: { __type: 'Boolean' },
  },
  UpdateFrontDeskKioskInput: {
    betaVersion: { __type: 'UpdateFrontDeskKioskBetaVersionInput' },
    kioskDefaults: { __type: 'UpdateFrontDeskKioskKioskDefaultsInput' },
  },
  UpdateFrontDeskKioskKioskDefaultsInput: {
    checkIn: { __type: 'Boolean' },
    classCheckIn: { __type: 'Boolean' },
    forms: { __type: 'Boolean' },
    introOffers: { __type: 'Boolean' },
    manageAccount: { __type: 'Boolean' },
    packages: { __type: 'Boolean' },
  },
  UpdateGiftCardExpiryResult: {
    __typename: { __type: 'String!' },
    expiredAt: { __type: 'String' },
    expiresAt: { __type: 'String' },
    giftCardId: { __type: 'ID!' },
  },
  UpdateGiftCardTemplatesSharedSitesInput: {
    isAllSharedSites: { __type: 'Boolean!' },
    sharedSiteIds: { __type: '[ID!]!' },
    siteId: { __type: 'ID!' },
  },
  UpdateGoalInput: { name: { __type: 'String' }, sortOrder: { __type: 'Float' } },
  UpdateGoogleTagManagerInputInput: { gtmId: { __type: 'String' } },
  UpdateGrowAuthenticationInput: {
    accessToken: { __type: 'String!' },
    expiresAt: { __type: 'String!' },
    refreshToken: { __type: 'String!' },
  },
  UpdateGrowHqInput: { name: { __type: 'String' } },
  UpdateGrowInput: {
    authentication: { __type: 'UpdateGrowAuthenticationInput' },
    enabled: { __type: 'Boolean' },
    growLocationId: { __type: 'String' },
    hqId: { __type: 'String' },
    lastCollect: { __type: 'UpdateGrowLastCollectInput' },
  },
  UpdateGrowLastCollectInput: { full: { __type: 'String' }, partial: { __type: 'String' } },
  UpdateHapanaAccessControllerAccessPointsInput: {
    accessPointId: { __type: 'String' },
    accessPointName: { __type: 'String!' },
    groupName: { __type: 'String!' },
    provisionCode: { __type: 'String!' },
  },
  UpdateHapanaAccessControllerGroupsInput: {
    groupId: { __type: 'String' },
    groupName: { __type: 'String!' },
  },
  UpdateHapanaAccessControllerInputInput: {
    accessPoints: { __type: '[UpdateHapanaAccessControllerAccessPointsInput!]' },
    groups: { __type: '[UpdateHapanaAccessControllerGroupsInput!]' },
  },
  UpdateImportRow: {
    __typename: { __type: 'String!' },
    errorMessage: { __type: 'String' },
    processingStatus: { __type: 'String' },
    rowIndex: { __type: 'Float!' },
    validationErrors: { __type: '[ImportPreviewRowsValidationErrors!]' },
    validationStatus: { __type: 'String!' },
  },
  UpdateImportSession: { __typename: { __type: 'String!' }, importSessionId: { __type: 'ID!' } },
  UpdateKioskDefaultsInput: {
    checkIn: { __type: 'Boolean' },
    classCheckIn: { __type: 'Boolean' },
    forms: { __type: 'Boolean' },
    introOffers: { __type: 'Boolean' },
    manageAccount: { __type: 'Boolean' },
    packages: { __type: 'Boolean' },
  },
  UpdateLeaderboardConfigInputInput: {
    autoRollover: { __type: 'Boolean' },
    config: { __type: 'JSONObject' },
    customEndDate: { __type: 'String' },
    customStartDate: { __type: 'String' },
    description: { __type: 'String' },
    imageUrl: { __type: 'String' },
    memberDisplayFormat: { __type: 'MemberDisplayFormat' },
    minParticipants: { __type: 'Float' },
    name: { __type: 'String' },
    rankingDirection: { __type: 'RankingDirection' },
    refreshFrequency: { __type: 'RefreshFrequency' },
    scope: { __type: 'LeaderboardScope' },
    siteIds: { __type: '[String!]' },
    timePeriodType: { __type: 'TimePeriodType' },
    visibility: { __type: 'LeaderboardVisibility' },
  },
  UpdateMeInputInput: {
    dateOfBirth: { __type: 'String' },
    email: { __type: 'String' },
    firstName: { __type: 'String' },
    gender: { __type: 'String' },
    lastName: { __type: 'String' },
    phone: { __type: 'String' },
  },
  UpdateMemberExperienceBranding: {
    __typename: { __type: 'String!' },
    branding: { __type: 'MemberExperienceBranding' },
    success: { __type: 'Boolean!' },
  },
  UpdateMemberExperienceFonts: {
    __typename: { __type: 'String!' },
    fonts: { __type: 'MemberExperienceFonts' },
    success: { __type: 'Boolean!' },
  },
  UpdateMemberExperienceSettings: {
    __typename: { __type: 'String!' },
    settings: { __type: 'MemberExperienceSettings' },
    success: { __type: 'Boolean!' },
  },
  UpdateMemberExperienceSettingsFilterOptionsInput: {
    category: { __type: 'Boolean!' },
    duration: { __type: 'Boolean!' },
    instructor: { __type: 'Boolean!' },
    location: { __type: 'Boolean!' },
    room: { __type: 'Boolean!' },
    sessionType: { __type: 'Boolean!' },
    time: { __type: 'Boolean!' },
  },
  UpdateMemberExperienceSurfaceBrandingResponse: {
    __typename: { __type: 'String!' },
    success: { __type: 'Boolean!' },
    surfaceBranding: { __type: 'MemberExperienceSurfaceBranding' },
  },
  UpdateMemberMovementRunConfigInput: {
    attestation: { __type: 'MemberMovementAttestationInput!' },
    config: { __type: 'MemberMovementConfigInput!' },
    runId: { __type: 'ID!' },
  },
  UpdateMembershipTierOrdersInput: {
    orderedTemplateIds: { __type: '[ID!]!' },
    restrictPlanChangesToCategory: { __type: 'Boolean' },
    siteId: { __type: 'ID!' },
  },
  UpdateMobileAppBranding: {
    __typename: { __type: 'String!' },
    branding: { __type: 'MobileAppBranding' },
    success: { __type: 'Boolean!' },
  },
  UpdateMobileAppChannels: {
    __typename: { __type: 'String!' },
    channels: { __type: 'MobileAppChannels' },
    success: { __type: 'Boolean!' },
  },
  UpdateMobileAppProfile: {
    __typename: { __type: 'String!' },
    profile: { __type: 'MobileAppProfile' },
    success: { __type: 'Boolean!' },
  },
  UpdatePosCategoryInput: {
    description: { __type: 'String' },
    displayOrder: { __type: 'Int' },
    name: { __type: 'String' },
    revenueTagId: { __type: 'String' },
    status: { __type: 'PosCategoryStatus' },
  },
  UpdatePosCategoryResponse: { __typename: { __type: 'String!' }, success: { __type: 'Boolean!' } },
  UpdatePosProductInput: {
    categoryId: { __type: 'ID' },
    description: { __type: 'String' },
    productName: { __type: 'String' },
    revenueTag: { __type: 'ID' },
    supplierId: { __type: 'ID' },
    variables: { __type: '[UpdatePosProductVariableInput!]' },
  },
  UpdatePosProductResponse: {
    __typename: { __type: 'String!' },
    category: { __type: 'CreatePosCategoryResponse' },
    categoryId: { __type: 'ID' },
    createdAt: { __type: 'String!' },
    createdBy: { __type: 'ID!' },
    description: { __type: 'String' },
    imageJSON: { __type: 'ImageFileConfigField' },
    posProductId: { __type: 'ID!' },
    productImage: {
      __type: 'ImagePublicSignedUrl',
      __args: { input: 'ImagePublicSignedUrlInput!' },
    },
    productName: { __type: 'String!' },
    revenueTag: { __type: 'String' },
    siteId: { __type: 'ID!' },
    status: { __type: 'PosProductStatus!' },
    supplierId: { __type: 'ID' },
    totalStock: { __type: 'Int!' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'ID' },
    variables: { __type: '[PosProductVariableWithAttributes!]!' },
  },
  UpdatePosProductVariableFeaturedResponse: {
    __typename: { __type: 'String!' },
    isFeatured: { __type: 'Boolean!' },
    success: { __type: 'Boolean!' },
  },
  UpdatePosProductVariableInput: {
    attributes: { __type: '[PosProductVariableAttributeInput!]' },
    barcode: { __type: 'String' },
    cost: { __type: 'String' },
    currentStock: { __type: 'Int' },
    isDefault: { __type: 'Boolean' },
    isEnabledForSale: { __type: 'Boolean' },
    isFeatured: { __type: 'Boolean' },
    maxStockLevel: { __type: 'Int' },
    minStockLevel: { __type: 'Int' },
    posProductVariableId: { __type: 'ID' },
    price: { __type: 'String' },
    sku: { __type: 'String' },
    sortOrder: { __type: 'Int' },
    taxSettingIds: { __type: '[ID!]' },
    trackStock: { __type: 'Boolean' },
    variableName: { __type: 'String' },
  },
  UpdatePresaleInitialInvoiceAmountInput: {
    invoiceId: { __type: 'ID!' },
    totalAmount: { __type: 'Numeric!' },
  },
  UpdatePresaleInitialInvoiceDateInput: {
    invoiceDate: { __type: 'String!' },
    invoiceId: { __type: 'ID!' },
    memberNotification: { __type: 'MemberNotificationInput' },
    shortfallAction: { __type: 'PresaleShortfallAction' },
  },
  UpdateRegionInputInput: {
    countryId: { __type: 'ID' },
    latitude: { __type: 'Float' },
    longitude: { __type: 'Float' },
    name: { __type: 'String' },
    zoneId: { __type: 'ID' },
  },
  UpdateSavedReportInputInput: {
    categoryId: { __type: 'String' },
    columnLabels: { __type: 'JSONObject' },
    description: { __type: 'String' },
    expectedUpdatedAt: { __type: 'String' },
    name: { __type: 'String' },
    savedColumns: { __type: '[String!]' },
    savedDateRange: { __type: 'CreateSavedReportSavedDateRangeInput' },
    savedFilters: { __type: 'JSONObject' },
    savedReportId: { __type: 'String!' },
    savedSiteIds: { __type: '[String!]' },
    savedSort: { __type: '[UpdateSavedReportSavedSortInput!]' },
  },
  UpdateSavedReportSavedSortInput: {
    column: { __type: 'String!' },
    direction: { __type: 'SortDirection!' },
  },
  UpdateScheduledInvoiceDateInput: {
    invoiceDate: { __type: 'String!' },
    invoiceId: { __type: 'String!' },
  },
  UpdateScheduledPushSendInput: {
    audienceType: { __type: 'ScheduledPushAudienceType!' },
    message: { __type: 'String!' },
    scheduledPushSendId: { __type: 'ID!' },
    sendAtLocal: { __type: 'String' },
    sessionId: { __type: 'ID' },
    siteId: { __type: 'ID!' },
    title: { __type: 'String!' },
  },
  UpdateServiceTemplateCategoryInput: {
    description: { __type: 'String' },
    displayOrder: { __type: 'Float' },
    name: { __type: 'String' },
    status: { __type: 'ServiceTemplateCategoryStatus' },
  },
  UpdateServiceTemplateCategoryResponse: {
    __typename: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  UpdateServiceTemplateFeaturedResponse: {
    __typename: { __type: 'String!' },
    isFeatured: { __type: 'Boolean!' },
    success: { __type: 'Boolean!' },
  },
  UpdateServiceTemplateInputInput: {
    accessSchedule: { __type: 'JSONObject' },
    accountCodeId: { __type: 'String' },
    agreementEnabled: { __type: 'Boolean' },
    agreementSendConfirmation: { __type: 'Boolean' },
    agreementText: { __type: 'String' },
    applyGuestPassAllowanceToActiveMembers: { __type: 'Boolean' },
    autoConvertTo: { __type: 'String' },
    autoConvertTrigger: { __type: 'AutoConvertTrigger' },
    autoRenewEnabled: { __type: 'Boolean' },
    autoRenewType: { __type: 'AutoRenewType' },
    billingAnchorDate: { __type: 'String' },
    billingCycleAmount: { __type: 'Float' },
    billingCycleUnit: { __type: 'BillingCycleUnit' },
    billingDay: { __type: 'Float' },
    cancellation: { __type: 'CreateServiceTemplateCancellationInput' },
    cancellationNoticePeriodAmount: { __type: 'Float' },
    cancellationNoticePeriodUnit: { __type: 'CancellationNoticePeriodUnit' },
    categoryId: { __type: 'String' },
    categoryName: { __type: 'String' },
    changePlanEnabled: { __type: 'Boolean' },
    chargeSetupFeeUpFront: { __type: 'Boolean' },
    clientOnlinePurchaseExpiryDate: { __type: 'String' },
    clientOnlinePurchaseExpiryEnabled: { __type: 'Boolean' },
    creditRolloverPolicy: { __type: 'CreditRolloverPolicy' },
    creditWindowEndDate: { __type: 'String' },
    credits: { __type: '[CreateServiceTemplateCreditsInput!]' },
    description: { __type: 'String' },
    displayOrder: { __type: 'Float' },
    dynamicDisplayServiceTemplateIds: { __type: '[String!]' },
    earlyAccessApplyTo: { __type: 'EarlyAccessApplyTo' },
    earlyAccessDurationAmount: { __type: 'Float' },
    earlyAccessDurationUnit: { __type: 'EarlyAccessDurationUnit' },
    expiryAlertInDays: { __type: 'Float' },
    extraBookingWindow: { __type: 'Float' },
    familyShareable: { __type: 'Boolean' },
    feeRevenueTags: { __type: 'CreateServiceTemplateFeeRevenueTagsInput' },
    firstCreditAllocationDate: { __type: 'CreateServiceTemplateFirstCreditAllocationDateInput' },
    futureStartDate: { __type: 'String' },
    guestPassAllowance: { __type: 'CreateServiceTemplateGuestPassAllowanceInput' },
    inheritAgreementsOnConvert: { __type: 'Boolean' },
    isAllSharedSites: { __type: 'Boolean' },
    isClientControlEnabled: { __type: 'Boolean' },
    isDefaultForTransferredClient: { __type: 'Boolean' },
    isEnabledForCMS: { __type: 'Boolean' },
    isFeatured: { __type: 'Boolean' },
    isIntroOffer: { __type: 'Boolean' },
    isRestricted: { __type: 'Boolean' },
    lengthAmount: { __type: 'Float' },
    lengthType: { __type: 'ServiceLengthType' },
    lengthUnit: { __type: 'ServiceLengthUnit' },
    limitSale: { __type: 'CreateServiceTemplateLimitSaleInput' },
    maxSharingCredits: { __type: 'Float' },
    maxSharingRecipients: { __type: 'Float' },
    minimumHomeUsageInDays: { __type: 'Float' },
    multiplePaymentOptions: { __type: 'CreateServiceTemplateMultiplePaymentOptionsInput' },
    name: { __type: 'String' },
    newSaleDynamicDisplayServiceTemplateIds: { __type: '[String!]' },
    oneActivePerFamily: { __type: 'Boolean' },
    oneTimeSetupFee: { __type: 'Numeric' },
    oneTimeSetupFeeTaxEnabled: { __type: 'Boolean' },
    oneTimeSetupFeeTaxSettingIds: { __type: '[ID!]' },
    onlineSaleEnabled: { __type: 'Boolean' },
    onlineSaleStartDate: { __type: 'String' },
    payUpFrontEnabled: { __type: 'Boolean' },
    price: { __type: 'Numeric' },
    revenueTag: { __type: 'String' },
    saleAvailableFromDate: { __type: 'String' },
    saleAvailableUntilDate: { __type: 'String' },
    secondaryRecurringFee: { __type: 'CreateServiceTemplateSecondaryRecurringFeeInput' },
    selfServicePause: { __type: 'CreateServiceTemplateSelfServicePauseInput' },
    serviceFirstBillingDate: { __type: 'CreateServiceTemplateServiceFirstBillingDateInput' },
    serviceTemplateId: { __type: 'String' },
    sharedSiteIds: { __type: '[String!]' },
    sharingCreditsAmount: { __type: 'Float' },
    sharingCreditsEnabled: { __type: 'Boolean' },
    siteAgreementTemplateId: { __type: 'String' },
    siteId: { __type: 'String' },
    status: { __type: 'ServiceTemplateStatus' },
    taxEnabled: { __type: 'Boolean' },
    taxSettingIds: { __type: '[ID!]' },
    tierOrder: { __type: 'Float' },
    toServiceTemplateId: { __type: 'String' },
    type: { __type: 'ServiceTemplateType' },
  },
  UpdateServiceTemplateSessionTypeAddOnInput: {
    addOnName: { __type: 'String' },
    price: { __type: 'Numeric' },
    serviceTemplateSessionTypeAddOnId: { __type: 'ID!' },
    taxSettingIds: { __type: '[ID!]' },
  },
  UpdateSiteAccountCodeInput: {
    code: { __type: 'String' },
    description: { __type: 'String' },
    title: { __type: 'String' },
  },
  UpdateSiteAlertInput: {
    amenityId: { __type: 'ID' },
    body: { __type: 'String' },
    endsAt: { __type: 'String' },
    linkLabel: { __type: 'String' },
    linkUrl: { __type: 'String' },
    marksLocationClosed: { __type: 'Boolean!' },
    showAsPopup: { __type: 'Boolean!' },
    siteAlertId: { __type: 'ID!' },
    startsAt: { __type: 'String' },
    theme: { __type: 'SiteAlertTheme!' },
    title: { __type: 'String!' },
  },
  UpdateSiteCommunicationTemplate: {
    __typename: { __type: 'String!' },
    alias: { __type: 'CommunicationTemplateAliases!' },
    allowedPlaceholders: { __type: '[CommunicationTemplatePlaceholders!]!' },
    createdAt: { __type: 'String!' },
    emailBody: { __type: 'String!' },
    emailCcEmail: { __type: 'String' },
    emailCcLocation: { __type: 'Boolean!' },
    emailCopyEmployee: { __type: 'EmailCopyEmployee!' },
    emailDefaultOn: { __type: 'Boolean!' },
    emailEnabled: { __type: 'Boolean!' },
    emailLockedByBrand: { __type: 'Boolean!' },
    emailReplyToEmail: { __type: 'String' },
    emailReplyToName: { __type: 'String' },
    emailSendBefore: { __type: 'Float' },
    emailSendBeforeUnit: { __type: 'EmailSendBeforeUnit' },
    emailSendCalendarAttachment: { __type: 'Boolean!' },
    emailSendEmailAs: { __type: 'EmailSendAs!' },
    emailSendOnlyToActiveClients: { __type: 'Boolean!' },
    emailSubject: { __type: 'String!' },
    emailUseHapanaLayout: { __type: 'Boolean' },
    pushLockedByBrand: { __type: 'Boolean!' },
    pushNotificationDefaultOn: { __type: 'Boolean!' },
    pushNotificationEnabled: { __type: 'Boolean!' },
    pushNotificationMessage: { __type: 'String' },
    pushNotificationTitle: { __type: 'String' },
    readOnly: { __type: 'Boolean!' },
    siteCommunicationTemplateId: { __type: 'ID!' },
    siteId: { __type: 'ID!' },
    smsDefaultOn: { __type: 'Boolean!' },
    smsEnabled: { __type: 'Boolean!' },
    smsLockedByBrand: { __type: 'Boolean!' },
    smsMessage: { __type: 'String' },
    targetedServiceTemplateIds: { __type: '[ID!]' },
    updatedAt: { __type: 'String!' },
  },
  UpdateSiteCommunicationTemplateEmailStatus: {
    __typename: { __type: 'String!' },
    alias: { __type: 'CommunicationTemplateAliases!' },
    allowedPlaceholders: { __type: '[CommunicationTemplatePlaceholders!]!' },
    createdAt: { __type: 'String!' },
    emailBody: { __type: 'String!' },
    emailCcEmail: { __type: 'String' },
    emailCcLocation: { __type: 'Boolean!' },
    emailCopyEmployee: { __type: 'EmailCopyEmployee!' },
    emailDefaultOn: { __type: 'Boolean!' },
    emailEnabled: { __type: 'Boolean!' },
    emailLockedByBrand: { __type: 'Boolean!' },
    emailReplyToEmail: { __type: 'String' },
    emailReplyToName: { __type: 'String' },
    emailSendBefore: { __type: 'Float' },
    emailSendBeforeUnit: { __type: 'EmailSendBeforeUnit' },
    emailSendCalendarAttachment: { __type: 'Boolean!' },
    emailSendEmailAs: { __type: 'EmailSendAs!' },
    emailSendOnlyToActiveClients: { __type: 'Boolean!' },
    emailSubject: { __type: 'String!' },
    emailUseHapanaLayout: { __type: 'Boolean' },
    pushLockedByBrand: { __type: 'Boolean!' },
    pushNotificationDefaultOn: { __type: 'Boolean!' },
    pushNotificationEnabled: { __type: 'Boolean!' },
    pushNotificationMessage: { __type: 'String' },
    pushNotificationTitle: { __type: 'String' },
    readOnly: { __type: 'Boolean!' },
    siteCommunicationTemplateId: { __type: 'ID!' },
    siteId: { __type: 'ID!' },
    smsDefaultOn: { __type: 'Boolean!' },
    smsEnabled: { __type: 'Boolean!' },
    smsLockedByBrand: { __type: 'Boolean!' },
    smsMessage: { __type: 'String' },
    targetedServiceTemplateIds: { __type: '[ID!]' },
    updatedAt: { __type: 'String!' },
  },
  UpdateSiteCommunicationTemplatePushNotificationStatus: {
    __typename: { __type: 'String!' },
    alias: { __type: 'CommunicationTemplateAliases!' },
    allowedPlaceholders: { __type: '[CommunicationTemplatePlaceholders!]!' },
    createdAt: { __type: 'String!' },
    emailBody: { __type: 'String!' },
    emailCcEmail: { __type: 'String' },
    emailCcLocation: { __type: 'Boolean!' },
    emailCopyEmployee: { __type: 'EmailCopyEmployee!' },
    emailDefaultOn: { __type: 'Boolean!' },
    emailEnabled: { __type: 'Boolean!' },
    emailLockedByBrand: { __type: 'Boolean!' },
    emailReplyToEmail: { __type: 'String' },
    emailReplyToName: { __type: 'String' },
    emailSendBefore: { __type: 'Float' },
    emailSendBeforeUnit: { __type: 'EmailSendBeforeUnit' },
    emailSendCalendarAttachment: { __type: 'Boolean!' },
    emailSendEmailAs: { __type: 'EmailSendAs!' },
    emailSendOnlyToActiveClients: { __type: 'Boolean!' },
    emailSubject: { __type: 'String!' },
    emailUseHapanaLayout: { __type: 'Boolean' },
    pushLockedByBrand: { __type: 'Boolean!' },
    pushNotificationDefaultOn: { __type: 'Boolean!' },
    pushNotificationEnabled: { __type: 'Boolean!' },
    pushNotificationMessage: { __type: 'String' },
    pushNotificationTitle: { __type: 'String' },
    readOnly: { __type: 'Boolean!' },
    siteCommunicationTemplateId: { __type: 'ID!' },
    siteId: { __type: 'ID!' },
    smsDefaultOn: { __type: 'Boolean!' },
    smsEnabled: { __type: 'Boolean!' },
    smsLockedByBrand: { __type: 'Boolean!' },
    smsMessage: { __type: 'String' },
    targetedServiceTemplateIds: { __type: '[ID!]' },
    updatedAt: { __type: 'String!' },
  },
  UpdateSiteCommunicationTemplateSmsStatus: {
    __typename: { __type: 'String!' },
    alias: { __type: 'CommunicationTemplateAliases!' },
    allowedPlaceholders: { __type: '[CommunicationTemplatePlaceholders!]!' },
    createdAt: { __type: 'String!' },
    emailBody: { __type: 'String!' },
    emailCcEmail: { __type: 'String' },
    emailCcLocation: { __type: 'Boolean!' },
    emailCopyEmployee: { __type: 'EmailCopyEmployee!' },
    emailDefaultOn: { __type: 'Boolean!' },
    emailEnabled: { __type: 'Boolean!' },
    emailLockedByBrand: { __type: 'Boolean!' },
    emailReplyToEmail: { __type: 'String' },
    emailReplyToName: { __type: 'String' },
    emailSendBefore: { __type: 'Float' },
    emailSendBeforeUnit: { __type: 'EmailSendBeforeUnit' },
    emailSendCalendarAttachment: { __type: 'Boolean!' },
    emailSendEmailAs: { __type: 'EmailSendAs!' },
    emailSendOnlyToActiveClients: { __type: 'Boolean!' },
    emailSubject: { __type: 'String!' },
    emailUseHapanaLayout: { __type: 'Boolean' },
    pushLockedByBrand: { __type: 'Boolean!' },
    pushNotificationDefaultOn: { __type: 'Boolean!' },
    pushNotificationEnabled: { __type: 'Boolean!' },
    pushNotificationMessage: { __type: 'String' },
    pushNotificationTitle: { __type: 'String' },
    readOnly: { __type: 'Boolean!' },
    siteCommunicationTemplateId: { __type: 'ID!' },
    siteId: { __type: 'ID!' },
    smsDefaultOn: { __type: 'Boolean!' },
    smsEnabled: { __type: 'Boolean!' },
    smsLockedByBrand: { __type: 'Boolean!' },
    smsMessage: { __type: 'String' },
    targetedServiceTemplateIds: { __type: '[ID!]' },
    updatedAt: { __type: 'String!' },
  },
  UpdateSiteCommunicationsSettingsUpdatesBlackoutTimeInput: {
    endTime: { __type: 'Float' },
    startTime: { __type: 'Float' },
  },
  UpdateSiteCommunicationsSettingsUpdatesCustomShortCodesInput: {
    androidApp: { __type: 'String' },
    androidAppDownload: { __type: 'String' },
    classes: { __type: 'String' },
    dashboard: { __type: 'String' },
    iOSApp: { __type: 'String' },
    iOSAppDownload: { __type: 'String' },
    packages: { __type: 'String' },
    workshops: { __type: 'String' },
  },
  UpdateSiteCommunicationsSettingsUpdatesInput: {
    blackoutTime: { __type: 'UpdateSiteCommunicationsSettingsUpdatesBlackoutTimeInput' },
    customShortCodes: { __type: 'UpdateSiteCommunicationsSettingsUpdatesCustomShortCodesInput' },
    emailDefaultFrom: { __type: 'String' },
    emailDefaultFromName: { __type: 'String' },
    smsDefaultFromName: { __type: 'String' },
  },
  UpdateSiteCustomThirdPartyIntegrationInput: {
    keyValues: { __type: '[CreateSiteCustomIntegrationsKeyValuesInput!]!' },
    thirdPartyIntegrationId: { __type: 'ID!' },
  },
  UpdateSiteGroupInputInput: { name: { __type: 'String' }, siteIds: { __type: '[ID!]' } },
  UpdateSiteInputInput: {
    addressCity: { __type: 'String' },
    addressCountry: { __type: 'String' },
    addressPostalCode: { __type: 'String' },
    addressState: { __type: 'String' },
    addressStreet: { __type: 'String' },
    addressStreet2: { __type: 'String' },
    adminConfigurations: { __type: 'CreateSiteAdminConfigurationsInput' },
    appName: { __type: 'String' },
    businessEmail: { __type: 'String' },
    businessHours: { __type: 'CreateSiteBusinessHoursInput' },
    capacity: { __type: 'Float' },
    clientFeesTemplateId: { __type: 'String' },
    connectedSharedSiteIds: { __type: '[String!]' },
    corePlanLevel: { __type: 'CorePlanLevel' },
    countryId: { __type: 'ID' },
    customIntegrations: { __type: '[CreateSiteCustomIntegrationsInput!]' },
    description: { __type: 'String' },
    displayBusinessHours: { __type: 'Boolean' },
    email: { __type: 'String' },
    gatewayCurrentPaymentMethodId: { __type: 'String' },
    gatewayCustomerId: { __type: 'String' },
    hapanaFeesTemplateId: { __type: 'ID' },
    integrations: { __type: 'CreateSiteIntegrationsInput' },
    isDigital: { __type: 'Boolean' },
    membersCount: { __type: 'Float' },
    name: { __type: 'String' },
    openDate: { __type: 'String' },
    phone: { __type: 'String' },
    phonePrefix: { __type: 'String' },
    rebateTemplateIds: { __type: '[ID!]' },
    regionId: { __type: 'ID' },
    royaltiesTemplateId: { __type: 'ID' },
    stateId: { __type: 'String' },
    status: { __type: 'SiteStatus' },
    timezone: { __type: 'String' },
    v1EncryptedId: { __type: 'String' },
    website: { __type: 'String' },
    workshopType: { __type: 'SiteWorkshopType' },
  },
  UpdateSiteLocationInput: {
    addressLine1: { __type: 'String' },
    addressLine2: { __type: 'String' },
    channelId: { __type: 'String' },
    city: { __type: 'String' },
    country: { __type: 'String' },
    isDefault: { __type: 'Boolean' },
    name: { __type: 'String' },
    postalCode: { __type: 'String' },
    rooms: { __type: '[CreateSiteLocationRoomInput!]' },
    state: { __type: 'String' },
    type: { __type: 'SiteLocationType' },
  },
  UpdateSiteLocationRoomInput: {
    allowOverlapping: { __type: 'Boolean' },
    customHours: { __type: 'CreateSiteLocationRoomCustomHoursInput' },
    endTime: { __type: 'String' },
    hasResourceBooking: { __type: 'Boolean' },
    name: { __type: 'String' },
    roomResourceTemplateId: { __type: 'String' },
    sameHoursAsLocation: { __type: 'Boolean' },
    startTime: { __type: 'String' },
  },
  UpdateSiteMemberAppSettingsInput: {
    settings: { __type: 'UpdateSiteMemberAppSettingsSettingsInput!' },
    siteId: { __type: 'ID!' },
  },
  UpdateSiteMemberAppSettingsSettingsInput: {
    locationInformation: { __type: 'UpdateSiteMemberAppSettingsSettingsLocationInformationInput!' },
    planYourVisit: { __type: 'UpdateSiteMemberAppSettingsSettingsPlanYourVisitInput!' },
  },
  UpdateSiteMemberAppSettingsSettingsLocationInformationAmenitiesInput: {
    isEnabled: { __type: 'Boolean!' },
    items: {
      __type: '[UpdateSiteMemberAppSettingsSettingsLocationInformationAmenitiesItemsInput!]!',
    },
    maxVisible: { __type: 'Int!' },
  },
  UpdateSiteMemberAppSettingsSettingsLocationInformationAmenitiesItemsInput: {
    amenityKey: { __type: 'SiteAmenityKey' },
    customIcon: { __type: 'SiteInfoBlockIcon' },
    customName: { __type: 'String' },
    id: { __type: 'ID!' },
    isVisible: { __type: 'Boolean!' },
    note: { __type: 'String' },
    schedule: {
      __type: 'UpdateSiteMemberAppSettingsSettingsLocationInformationStaffedHoursScheduleInput',
    },
  },
  UpdateSiteMemberAppSettingsSettingsLocationInformationBlocksInput: {
    body: { __type: 'String!' },
    icon: { __type: 'SiteInfoBlockIcon' },
    id: { __type: 'ID!' },
    isVisible: { __type: 'Boolean!' },
    linkLabel: { __type: 'String' },
    linkUrl: { __type: 'String' },
    title: { __type: 'String!' },
  },
  UpdateSiteMemberAppSettingsSettingsLocationInformationInput: {
    amenities: { __type: 'UpdateSiteMemberAppSettingsSettingsLocationInformationAmenitiesInput!' },
    blocks: { __type: '[UpdateSiteMemberAppSettingsSettingsLocationInformationBlocksInput!]!' },
    heading: { __type: 'String!' },
    isEnabled: { __type: 'Boolean!' },
    staffedHours: {
      __type: 'UpdateSiteMemberAppSettingsSettingsLocationInformationStaffedHoursInput!',
    },
  },
  UpdateSiteMemberAppSettingsSettingsLocationInformationStaffedHoursInput: {
    isEnabled: { __type: 'Boolean!' },
    label: { __type: 'String!' },
    schedule: {
      __type: 'UpdateSiteMemberAppSettingsSettingsLocationInformationStaffedHoursScheduleInput!',
    },
  },
  UpdateSiteMemberAppSettingsSettingsLocationInformationStaffedHoursScheduleInput: {
    exceptions: { __type: '[CreateSiteBusinessHoursExceptionsInput!]!' },
    is24x7: { __type: 'Boolean!' },
    weekly: { __type: 'CreateSiteBusinessHoursWeeklyInput!' },
  },
  UpdateSiteMemberAppSettingsSettingsPlanYourVisitForecastInput: {
    chartEndHour: { __type: 'Int' },
    chartStartHour: { __type: 'Int' },
    isEnabled: { __type: 'Boolean!' },
    lookbackWeeks: { __type: 'Int!' },
  },
  UpdateSiteMemberAppSettingsSettingsPlanYourVisitInput: {
    forecast: { __type: 'UpdateSiteMemberAppSettingsSettingsPlanYourVisitForecastInput!' },
    isEnabled: { __type: 'Boolean!' },
    isVisibleToGuests: { __type: 'Boolean!' },
    liveOccupancy: {
      __type: 'UpdateSiteMemberAppSettingsSettingsPlanYourVisitLiveOccupancyInput!',
    },
    title: { __type: 'String!' },
  },
  UpdateSiteMemberAppSettingsSettingsPlanYourVisitLiveOccupancyInput: {
    averageVisitMinutes: { __type: 'Int!' },
    bandSize: { __type: 'Int!' },
    displayMode: { __type: 'OccupancyDisplayMode!' },
    hideWhenClosed: { __type: 'Boolean!' },
    isEnabled: { __type: 'Boolean!' },
    privacyFloor: { __type: 'Int!' },
  },
  UpdateSiteOpeningHoursInput: {
    displayBusinessHours: { __type: 'Boolean!' },
    schedule: {
      __type: 'UpdateSiteMemberAppSettingsSettingsLocationInformationStaffedHoursScheduleInput!',
    },
    siteId: { __type: 'ID!' },
  },
  UpdateSitePayrollTierConfigurationInputInput: {
    payrollType: { __type: 'PayrollType' },
    rates: { __type: 'CreateSitePayrollTierConfigurationRatesInput' },
    siteSessionTypeId: { __type: 'ID' },
    type: { __type: 'PayrollTierType' },
  },
  UpdateSitePayrollTierInputInput: { name: { __type: 'String!' } },
  UpdateSitePlanOverrideInput: {
    planOverrideAllowed: { __type: 'Boolean' },
    planTierOverride: { __type: 'ProductPlanTier' },
  },
  UpdateSiteRoomResourceTemplateInput: {
    bookingProperties: { __type: '[CreateSiteRoomResourceTemplatePropertyInput!]' },
    boxId: { __type: 'Float' },
    description: { __type: 'String' },
    isDefault: { __type: 'Boolean' },
    isDraft: { __type: 'Boolean' },
    name: { __type: 'String' },
    spotHeight: { __type: 'Float' },
    spotWidth: { __type: 'Float' },
    spots: { __type: '[CreateSiteRoomResourceTemplateSpotsInput!]' },
  },
  UpdateSiteSettingsAccountBilling: {
    __typename: { __type: 'String!' },
    addressCity: { __type: 'String' },
    addressCountry: { __type: 'String' },
    addressPostalCode: { __type: 'String' },
    addressState: { __type: 'String' },
    addressStreet: { __type: 'String' },
    addressStreet2: { __type: 'String' },
    adminConfigurations: { __type: 'SiteAdminConfigurations' },
    appName: { __type: 'String' },
    businessEmail: { __type: 'String' },
    businessHours: { __type: 'SiteBusinessHours' },
    capacity: { __type: 'Float' },
    clientFeesTemplateId: { __type: 'String' },
    connectedSharedSiteIds: { __type: '[String!]' },
    corePlanLevel: { __type: 'CorePlanLevel' },
    countryId: { __type: 'ID' },
    createdAt: { __type: 'String!' },
    customIntegrations: { __type: '[SiteCustomIntegrations!]' },
    deletedAt: { __type: 'String' },
    description: { __type: 'String' },
    displayBusinessHours: { __type: 'Boolean!' },
    email: { __type: 'String' },
    gatewayCurrentPaymentMethodId: { __type: 'String' },
    gatewayCustomerId: { __type: 'String' },
    hapanaFeesTemplateId: { __type: 'ID' },
    integrations: { __type: 'UpdateSiteSettingsAccountBillingIntegrations' },
    isDigital: { __type: 'Boolean' },
    logoImage: { __type: 'ImageFileConfigField' },
    membersCount: { __type: 'Float' },
    name: { __type: 'String!' },
    openDate: { __type: 'String' },
    phone: { __type: 'String' },
    phonePrefix: { __type: 'String' },
    planOverrideAllowed: { __type: 'Boolean' },
    planTierOverride: { __type: 'ProductPlanTier' },
    rebateTemplateIds: { __type: '[ID!]' },
    regionId: { __type: 'ID' },
    royaltiesTemplateId: { __type: 'ID' },
    settings: { __type: 'SiteSettings' },
    siteId: { __type: 'ID!' },
    stateId: { __type: 'String' },
    status: { __type: 'SiteStatus!' },
    timezone: { __type: 'String' },
    updatedAt: { __type: 'String!' },
    v1EncryptedId: { __type: 'String' },
    website: { __type: 'String' },
    workshopType: { __type: 'SiteWorkshopType' },
  },
  UpdateSiteSettingsAccountBillingInputInput: {
    enabled: { __type: 'Boolean' },
    retryFailedPayments: { __type: 'UpdateSiteSettingsAccountBillingRetryFailedPaymentsInput' },
    transactionFeePreference: { __type: 'TransactionFeePreference' },
  },
  UpdateSiteSettingsAccountBillingIntegrations: {
    __typename: { __type: 'String!' },
    accessControls: { __type: 'SiteIntegrationsAccessControls' },
    accuroFit: { __type: 'SiteIntegrationsAccuroFit' },
    barcodeUrl: { __type: 'SiteIntegrationsBarcodeUrl' },
    calendarSync: { __type: 'SiteIntegrationsCalendarSync' },
    classPass: { __type: 'SiteIntegrationsClassPass' },
    egym: { __type: 'SiteIntegrationsEgym' },
    externalFeedbackLink: { __type: 'SiteIntegrationsExternalFeedbackLink' },
    facebookPixel: { __type: 'SiteIntegrationsFacebookPixel' },
    fitnessPassport: { __type: 'SiteIntegrationsFitnessPassport' },
    frontDeskKiosk: { __type: 'SiteIntegrationsFrontDeskKiosk' },
    googleTagManager: { __type: 'SiteIntegrationsGoogleTagManager' },
    grow: { __type: 'SiteIntegrationsGrow' },
    hapanaAccessController: { __type: 'SiteIntegrationsHapanaAccessController' },
    hapanaApiKey: { __type: 'SiteIntegrationsHapanaApiKey' },
    importClients: { __type: 'SiteIntegrationsImportClients' },
    spivi: { __type: 'SiteIntegrationsSpivi' },
    tanning: { __type: 'SiteIntegrationsTanning' },
    tanningHealth: { __type: 'SiteIntegrationsTanningHealth' },
    topaz: { __type: 'SiteIntegrationsTopaz' },
    wellhub: { __type: 'SiteIntegrationsWellhub' },
    zapier: { __type: 'SiteIntegrationsZapier' },
    zoom: { __type: 'UpdateSiteSettingsAccountBillingIntegrationsZoom' },
  },
  UpdateSiteSettingsAccountBillingIntegrationsZoom: {
    __typename: { __type: 'String!' },
    accountId: { __type: 'String' },
    authentication: { __type: 'UpdateSiteSettingsAccountBillingIntegrationsZoomAuthentication' },
    authorized: { __type: 'Boolean!' },
    connectedAt: { __type: 'String' },
    connectedUserEmail: { __type: 'String' },
    connectedUserId: { __type: 'String' },
    userId: { __type: 'String' },
  },
  UpdateSiteSettingsAccountBillingIntegrationsZoomAuthentication: {
    __typename: { __type: 'String!' },
    accessToken: { __type: 'String!' },
    expiresAt: { __type: 'String!' },
    refreshToken: { __type: 'String!' },
  },
  UpdateSiteSettingsAccountBillingRetryFailedPaymentsInput: {
    enabled: { __type: 'Boolean' },
    intervalInDays: { __type: 'Float' },
    maxAttempts: { __type: 'Float' },
    maxFailoversPerDay: { __type: 'Float' },
  },
  UpdateSiteSettingsAccountInvoiceInputInput: {
    email: { __type: 'String' },
    label: { __type: 'String' },
  },
  UpdateSiteSettingsAccountPayrollInputInput: {
    additionalTypes: { __type: '[PayrollAdditionalTypes!]' },
  },
  UpdateSiteSettingsAccountPointOfSaleInputInput: {
    enableCashDrawer: { __type: 'Boolean' },
    itemTypes: { __type: '[NewSaleItemTypes!]' },
  },
  UpdateSiteSettingsAccountTaxInputInput: { enabled: { __type: 'Boolean' } },
  UpdateSiteSettingsBlockingReasonsInputInput: {
    blockingReasons: { __type: '[UpdateSiteSettingsSuspensionReasonsSuspensionReasonsInput!]!' },
  },
  UpdateSiteSettingsBusinessCustomizationAddressCoordinatesInput: {
    latitude: { __type: 'Float' },
    longitude: { __type: 'Float' },
  },
  UpdateSiteSettingsBusinessCustomizationAddressInput: {
    city: { __type: 'String' },
    coordinates: { __type: 'UpdateSiteSettingsBusinessCustomizationAddressCoordinatesInput' },
    country: { __type: 'String' },
    postalCode: { __type: 'String' },
    state: { __type: 'String' },
    street: { __type: 'String' },
  },
  UpdateSiteSettingsBusinessCustomizationColorsInput: { color: { __type: 'String!' } },
  UpdateSiteSettingsBusinessCustomizationInputInput: {
    address: { __type: 'UpdateSiteSettingsBusinessCustomizationAddressInput' },
    colors: { __type: '[UpdateSiteSettingsBusinessCustomizationColorsInput!]' },
    dashboardRevenuePeriod: { __type: 'String' },
    description: { __type: 'String' },
    logoImage: { __type: 'String' },
    logoImageTemp: { __type: 'String' },
    phone: { __type: 'String' },
  },
  UpdateSiteSettingsBusinessLocationsInputInput: {
    businessHours: { __type: 'CreateSiteBusinessHoursInput' },
    displayBusinessHours: { __type: 'Boolean' },
  },
  UpdateSiteSettingsCalendarConfigurationsInputInput: {
    calendarInterval: { __type: 'Float' },
    calendarMaxTime: { __type: 'String' },
    calendarMinTime: { __type: 'String' },
    calendarStartDay: { __type: 'String' },
    defaultBookedListOrder: { __type: 'String' },
    defaultCalendarView: { __type: 'String' },
    enableContinuousEvents: { __type: 'Boolean' },
    enableDragAndDrop: { __type: 'Boolean' },
    hideRoomFromRoomView: { __type: 'Boolean' },
    hideTeamMemberFromTeamView: { __type: 'Boolean' },
  },
  UpdateSiteSettingsCancellationReasonsInputInput: {
    cancellationReasons: {
      __type: '[UpdateSiteSettingsSuspensionReasonsSuspensionReasonsInput!]!',
    },
  },
  UpdateSiteSettingsCheckInContactlessCheckInFormQuestionsInput: {
    allowCheckInIfBelowOrEqualTo: { __type: 'Float' },
    favorite: { __type: 'Boolean' },
    id: { __type: 'String!' },
    options: { __type: '[UpdateSiteSettingsCheckInContactlessCheckInFormQuestionsOptionsInput!]' },
    order: { __type: 'Float' },
    question: { __type: 'String!' },
    type: { __type: 'ContactlessCheckInFormQuestionType!' },
  },
  UpdateSiteSettingsCheckInContactlessCheckInFormQuestionsOptionsInput: {
    allowCheckIn: { __type: 'Boolean!' },
    id: { __type: 'String!' },
    order: { __type: 'Float' },
    text: { __type: 'String!' },
  },
  UpdateSiteSettingsCheckInContactlessCheckInInput: {
    enableDoorAccess: { __type: 'Boolean' },
    enableForm: { __type: 'Boolean' },
    enableQRCodeDeeplink: { __type: 'Boolean' },
    enabled: { __type: 'Boolean' },
    formQuestions: { __type: '[UpdateSiteSettingsCheckInContactlessCheckInFormQuestionsInput!]' },
    policies: { __type: '[UpdateSiteSettingsCheckInContactlessCheckInPoliciesInput!]' },
    policyIds: { __type: '[String!]' },
    skipCheckInQuestions: { __type: 'Boolean' },
  },
  UpdateSiteSettingsCheckInContactlessCheckInPoliciesInput: {
    enabled: { __type: 'Boolean!' },
    order: { __type: 'Float!' },
    sitePolicyId: { __type: 'String!' },
  },
  UpdateSiteSettingsCheckInInputInput: {
    barcodeCheckInScreenRefreshPeriodInSeconds: { __type: 'Float' },
    bookingGateMode: { __type: 'FormBookingGateMode' },
    checkInEndTime: { __type: 'Float' },
    checkInMarksAttendance: { __type: 'Boolean' },
    checkInStartTime: { __type: 'Float' },
    contactlessCheckIn: { __type: 'UpdateSiteSettingsCheckInContactlessCheckInInput' },
    enableCheckInPopups: { __type: 'Boolean' },
    enableCheckInSoundAlerts: { __type: 'Boolean' },
    enableCheckInWidget: { __type: 'Boolean' },
    enableGeneralCheckIn: { __type: 'Boolean' },
    enableMobileClientCheckIn: { __type: 'Boolean' },
    enableReEntryGracePeriod: { __type: 'Boolean' },
    failOpenOffline: { __type: 'Boolean' },
    reEntryGracePeriodInSeconds: { __type: 'Float' },
  },
  UpdateSiteSettingsContactlessCheckInFormQuestionsInputInput: {
    questions: { __type: '[UpdateSiteSettingsCheckInContactlessCheckInFormQuestionsInput!]!' },
  },
  UpdateSiteSettingsContactlessCheckInInputInput: {
    enableDoorAccess: { __type: 'Boolean' },
    enableForm: { __type: 'Boolean' },
    enableQRCodeDeeplink: { __type: 'Boolean' },
    enabled: { __type: 'Boolean' },
    formQuestions: { __type: '[UpdateSiteSettingsCheckInContactlessCheckInFormQuestionsInput!]' },
    policies: { __type: '[UpdateSiteSettingsContactlessCheckInPoliciesInput!]' },
    policyIds: { __type: '[String!]' },
    skipCheckInQuestions: { __type: 'Boolean' },
  },
  UpdateSiteSettingsContactlessCheckInPoliciesInput: {
    enabled: { __type: 'Boolean!' },
    order: { __type: 'Float!' },
    sitePolicyId: { __type: 'String!' },
  },
  UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsCustomPropertiesInput:
    {
      customPropertyId: { __type: 'String!' },
      enabled: { __type: 'Boolean' },
      required: { __type: 'Boolean' },
    },
  UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsEmergencyContactInput:
    {
      emergencyContactAddress: {
        __type:
          'UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput!',
      },
      emergencyContactEmail: {
        __type:
          'UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput!',
      },
      emergencyContactName: {
        __type:
          'UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput!',
      },
      emergencyContactPhone: {
        __type:
          'UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput!',
      },
      emergencyContactRelation: {
        __type:
          'UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput!',
      },
    },
  UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsInput: {
    customProperties: {
      __type:
        '[UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsCustomPropertiesInput]',
    },
    emergencyContact: {
      __type:
        'UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsEmergencyContactInput!',
    },
    formIds: { __type: '[String!]' },
    primaryProfile: {
      __type:
        'UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileInput!',
    },
  },
  UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput:
    { enabled: { __type: 'Boolean' }, required: { __type: 'Boolean' } },
  UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileInput: {
    address: {
      __type:
        'UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput!',
    },
    barcode: {
      __type:
        'UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput!',
    },
    birthday: {
      __type:
        'UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput!',
    },
    confirmPassword: {
      __type:
        'UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput!',
    },
    email: {
      __type:
        'UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput!',
    },
    firstName: {
      __type:
        'UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput!',
    },
    gender: {
      __type:
        'UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput!',
    },
    howDidYouHeadAboutUs: {
      __type:
        'UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput!',
    },
    lastName: {
      __type:
        'UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput!',
    },
    occupation: {
      __type:
        'UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput!',
    },
    password: {
      __type:
        'UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput!',
    },
    phone: {
      __type:
        'UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput!',
    },
    zipCode: {
      __type:
        'UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileFirstNameInput!',
    },
  },
  UpdateSiteSettingsLocationOperationBusinessSignUpFieldsInputInput: {
    businessSignUpFields: {
      __type: 'UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsInput!',
    },
  },
  UpdateSiteSettingsLocationOperationClientSignUpFieldsClientSignUpFieldsInput: {
    customProperties: {
      __type:
        '[UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsCustomPropertiesInput]',
    },
    emergencyContact: {
      __type:
        'UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsEmergencyContactInput!',
    },
    formIds: { __type: '[String!]' },
    policyIds: { __type: '[String!]' },
    primaryProfile: {
      __type:
        'UpdateSiteSettingsLocationOperationBusinessSignUpFieldsBusinessSignUpFieldsPrimaryProfileInput!',
    },
  },
  UpdateSiteSettingsLocationOperationClientSignUpFieldsInputInput: {
    clientSignUpFields: {
      __type: 'UpdateSiteSettingsLocationOperationClientSignUpFieldsClientSignUpFieldsInput!',
    },
  },
  UpdateSiteSettingsLocationOperationsMainInputInput: {
    autoLogout: { __type: 'Boolean' },
    autoLogoutMinutes: { __type: 'AutoLogoutMinutes' },
    enableBookABuddy: { __type: 'Boolean' },
    enableBuddySessionSharingVisibility: { __type: 'Boolean' },
    enableClientsToSignUp: { __type: 'Boolean' },
    preventDuplicatePhoneSignUp: { __type: 'Boolean' },
  },
  UpdateSiteSettingsRegionalCommunicationInputInput: {
    currency: { __type: 'String' },
    dateFormat: { __type: 'String' },
    numberFormat: { __type: 'String' },
    timeFormat: { __type: 'String' },
  },
  UpdateSiteSettingsRetailAdditionalBillingTypesInputInput: {
    enabled: { __type: 'Boolean' },
    types: { __type: '[UpdateSiteSettingsRetailAdditionalBillingTypesTypesInput!]' },
  },
  UpdateSiteSettingsRetailAdditionalBillingTypesTypesInput: {
    createdAt: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
    id: { __type: 'ID!' },
    name: { __type: 'String!' },
    type: { __type: 'AddtionalBillingType!' },
    updatedAt: { __type: 'String' },
  },
  UpdateSiteSettingsRetailCreditsInputInput: {
    enableCreditsOnHoldIfClientHadFailedPayment: { __type: 'Boolean' },
    enableCreditsOnHoldIfClientHadTerminalFailedPayment: { __type: 'Boolean' },
    enableCreditsOnHoldIfClientHasProcessingPayment: { __type: 'Boolean' },
    referrals: { __type: 'UpdateSiteSettingsRetailCreditsReferralsInput' },
  },
  UpdateSiteSettingsRetailCreditsReferralsInput: {
    creditsExistingClient: { __type: 'Float' },
    creditsToNewClient: { __type: 'Float' },
    existingClientEnabled: { __type: 'Boolean' },
    newClientEnabled: { __type: 'Boolean' },
  },
  UpdateSiteSettingsRetailFeesDestinationInput: {
    enabled: { __type: 'Boolean' },
    price: { __type: 'String' },
    revenueTagId: { __type: 'ID' },
    taxSettings: { __type: '[String!]' },
  },
  UpdateSiteSettingsRetailFeesDishonorInput: {
    enabled: { __type: 'Boolean' },
    onAllAttempts: { __type: 'String' },
    onDelinquentDays: { __type: 'UpdateSiteSettingsRetailFeesDishonorOnDelinquentDaysInput' },
    onFirstAttempt: { __type: 'String' },
    onSecondAttempt: { __type: 'String' },
    onThirdAttempt: { __type: 'String' },
    taxSettings: { __type: '[String!]' },
  },
  UpdateSiteSettingsRetailFeesDishonorOnDelinquentDaysInput: {
    amount: { __type: 'String!' },
    days: { __type: 'Float!' },
  },
  UpdateSiteSettingsRetailFeesInputInput: {
    customLateCancelFeesEnabled: { __type: 'Boolean' },
    customNoShowFeesEnabled: { __type: 'Boolean' },
    destination: { __type: 'UpdateSiteSettingsRetailFeesDestinationInput' },
    dishonor: { __type: 'UpdateSiteSettingsRetailFeesDishonorInput' },
    lateCancel: { __type: 'UpdateSiteSettingsRetailFeesNoShowInput' },
    noShow: { __type: 'UpdateSiteSettingsRetailFeesNoShowInput' },
  },
  UpdateSiteSettingsRetailFeesNoShowAutomaticInput: { enabled: { __type: 'Boolean!' } },
  UpdateSiteSettingsRetailFeesNoShowInput: {
    automatic: { __type: 'UpdateSiteSettingsRetailFeesNoShowAutomaticInput' },
    creditRefund: { __type: 'Boolean' },
    enabled: { __type: 'Boolean' },
    price: { __type: 'String' },
    revenueTagId: { __type: 'String' },
    taxSettings: { __type: '[String!]' },
    unlimitedCreditsOnly: { __type: 'Boolean' },
  },
  UpdateSiteSettingsRetailGeneralSalesAdditionalSortOfPackagesInput: {
    direction: { __type: 'SortPackageDirection!' },
    field: { __type: 'SortPackageField!' },
  },
  UpdateSiteSettingsRetailGeneralSalesInputInput: {
    additionalSortOfPackages: {
      __type: 'UpdateSiteSettingsRetailGeneralSalesAdditionalSortOfPackagesInput',
    },
    allowChangeOfProcessedByAtSale: { __type: 'Boolean' },
    allowMembershipSalesWithDuplicateCreditOrSessionTypes: { __type: 'Boolean' },
    allowSessionPackageSalesWithDuplicateCreditOrSessionTypes: { __type: 'Boolean' },
    autoAssignClientBarcodeNumber: { __type: 'Boolean' },
    autoRenewExhaustedSessionPackages: { __type: 'Boolean' },
    defaultAutoRenewToggleEnabledAtSale: { __type: 'Boolean' },
    enableAllMembershipsSoldOnlineToBeCancelledByMember: { __type: 'Boolean' },
    enableRestrictedPackages: { __type: 'Boolean' },
    redirectAfterPackagePayment: { __type: 'RedirectAfterPackagePayment' },
    revenueTagDefaults: { __type: 'JSONObject' },
    revenueTagging: { __type: '[UpdateSiteSettingsRetailGeneralSalesRevenueTaggingInput!]' },
  },
  UpdateSiteSettingsRetailGeneralSalesRevenueTaggingInput: {
    createdAt: { __type: 'String!' },
    description: { __type: 'String!' },
    enabled: { __type: 'Boolean!' },
    glCode: { __type: 'String!' },
    id: { __type: 'ID!' },
    mapping: { __type: 'RevenueTagMapping' },
    name: { __type: 'String!' },
    updatedAt: { __type: 'String' },
  },
  UpdateSiteSettingsRetailGiftcardsInputInput: {
    requireRecipientForGiftCardSales: { __type: 'Boolean' },
  },
  UpdateSiteSettingsRetailSalesSettingsInputInput: {
    miniumSignUpAge: { __type: 'Float' },
    printPosReceipt: { __type: 'Float' },
    requireRecipientForGiftCardSales: { __type: 'Boolean' },
    suppliers: { __type: '[UpdateSiteSettingsRetailSalesSettingsSuppliersInput!]' },
  },
  UpdateSiteSettingsRetailSalesSettingsSuppliersInput: {
    address: { __type: 'String' },
    id: { __type: 'ID!' },
    name: { __type: 'String!' },
    phone: { __type: 'String' },
    status: { __type: 'SiteSupplierStatus!' },
  },
  UpdateSiteSettingsRetailSuspensionsInputInput: {
    secondaryFeesContinueDuringSuspension: { __type: 'Boolean' },
    selfServicePause: { __type: 'UpdateSiteSettingsRetailSuspensionsSelfServicePauseInput' },
  },
  UpdateSiteSettingsRetailSuspensionsSelfServicePauseInput: {
    alignToBillingCycle: { __type: 'Boolean' },
    enabled: { __type: 'Boolean!' },
    maxPerCalendarYear: {
      __type: 'UpdateSiteSettingsRetailSuspensionsSelfServicePauseMaxPerCalendarYearInput',
    },
    noticePeriodDays: { __type: 'Float' },
    reasonIds: { __type: '[String!]' },
    reasonMandatory: { __type: 'Boolean' },
  },
  UpdateSiteSettingsRetailSuspensionsSelfServicePauseMaxPerCalendarYearInput: {
    amount: { __type: 'Float!' },
    unit: { __type: 'SelfServicePauseDurationUnit!' },
  },
  UpdateSiteSettingsSchedulerBookingRulesEnforceFixedBookingSlotIntervalsInput: {
    duration: { __type: 'Float' },
  },
  UpdateSiteSettingsSchedulerBookingRulesInputInput: {
    allowMemberOverlappingSessions: { __type: 'Boolean' },
    allowStaffOverbooking: { __type: 'Boolean' },
    autoConfirmRequests: { __type: 'Boolean' },
    autoDeductCredits: { __type: 'Boolean' },
    bookingNotifications: { __type: 'Boolean' },
    enableBookABuddy: { __type: 'Boolean' },
    enableBookingRequests: { __type: 'Boolean' },
    enforceFixedBookingSlotIntervals: {
      __type: 'UpdateSiteSettingsSchedulerBookingRulesEnforceFixedBookingSlotIntervalsInput',
    },
    enforceFixedBookingSlotIntervalsDuration: { __type: 'SchedulerTimeSlotDuration' },
    requestTimeSlots: { __type: 'UpdateSiteSettingsSchedulerBookingRulesRequestTimeSlotsInput' },
    requestTimeSlotsDuration: { __type: 'SchedulerTimeSlotDuration' },
  },
  UpdateSiteSettingsSchedulerBookingRulesRequestTimeSlotsInput: { duration: { __type: 'Float' } },
  UpdateSiteSettingsSchedulerCancellationRulesInputInput: {
    allowClientDeclineAndCancelSessions: { __type: 'Boolean' },
    allowClientsToDeclineAndCancel: { __type: 'Boolean' },
    policies: { __type: 'UpdateSiteSettingsSchedulerCancellationRulesPoliciesInput' },
  },
  UpdateSiteSettingsSchedulerCancellationRulesPoliciesClassesInput: {
    days: { __type: 'Float!' },
    hours: { __type: 'Float!' },
    minutes: { __type: 'Float!' },
  },
  UpdateSiteSettingsSchedulerCancellationRulesPoliciesInput: {
    classes: { __type: 'UpdateSiteSettingsSchedulerCancellationRulesPoliciesClassesInput' },
    privates: { __type: 'UpdateSiteSettingsSchedulerCancellationRulesPoliciesClassesInput' },
    workshops: { __type: 'UpdateSiteSettingsSchedulerCancellationRulesPoliciesClassesInput' },
  },
  UpdateSiteSettingsSchedulerClassesRulesInputInput: {
    daysInAdvance: { __type: 'Float' },
    defaultColor: { __type: 'String' },
    displayClassSize: { __type: 'Boolean' },
    displayCompletedClasses: { __type: 'Boolean' },
    displayPriceColumn: { __type: 'Boolean' },
    instructorTypeFilter: { __type: 'Boolean' },
    roomTypeFilter: { __type: 'Boolean' },
    sessionTypeFilter: { __type: 'Boolean' },
    soapNotes: { __type: 'Boolean' },
  },
  UpdateSiteSettingsSchedulerPrivatesRulesInputInput: { daysInAdvance: { __type: 'Float' } },
  UpdateSiteSettingsSchedulerReservationsRulesDaysInAdvanceInput: {
    releaseType: { __type: 'ReleaseType' },
    rolling: { __type: 'UpdateSiteSettingsSchedulerReservationsRulesDaysInAdvanceRollingInput' },
    timed: { __type: 'UpdateSiteSettingsSchedulerReservationsRulesDaysInAdvanceTimedInput' },
  },
  UpdateSiteSettingsSchedulerReservationsRulesDaysInAdvanceRollingInput: {
    classesBookedUpTo: { __type: 'Float' },
    periodOfTime: { __type: 'PeriodOfTime' },
    time: { __type: 'String' },
    upTo: { __type: 'Float' },
  },
  UpdateSiteSettingsSchedulerReservationsRulesDaysInAdvanceTimedInput: {
    dayOfWeek: { __type: 'DayOfWeek' },
    hoursAfter: { __type: 'Float' },
    numberOfWeeks: { __type: 'Float' },
    time: { __type: 'String' },
  },
  UpdateSiteSettingsSchedulerReservationsRulesInputInput: {
    daysInAdvance: { __type: 'UpdateSiteSettingsSchedulerReservationsRulesDaysInAdvanceInput' },
    multipleReservations: { __type: 'Boolean' },
    overrides: { __type: 'UpdateSiteSettingsSchedulerReservationsRulesOverridesInput' },
  },
  UpdateSiteSettingsSchedulerReservationsRulesOverridesInput: {
    byCategory: { __type: 'JSONObject' },
    bySessionType: { __type: 'JSONObject' },
  },
  UpdateSiteSettingsSchedulerWaitlistRulesFirstToClaimInput: {
    enabled: { __type: 'Boolean!' },
    windowHours: { __type: 'Float!' },
  },
  UpdateSiteSettingsSchedulerWaitlistRulesInputInput: {
    autoConfirmClients: { __type: 'Boolean' },
    firstToClaim: { __type: 'UpdateSiteSettingsSchedulerWaitlistRulesFirstToClaimInput' },
    lockPeriod: { __type: 'UpdateSiteSettingsSchedulerWaitlistRulesLockPeriodInput' },
    manualMovements: { __type: 'Boolean' },
    promotion: { __type: 'UpdateSiteSettingsSchedulerWaitlistRulesPromotionInput' },
    restrictions: { __type: 'UpdateSiteSettingsSchedulerWaitlistRulesRestrictionsInput' },
    strategy: { __type: 'WaitlistStrategy' },
    topNBatchSize: { __type: 'Float' },
  },
  UpdateSiteSettingsSchedulerWaitlistRulesLockPeriodInput: {
    periodOfTime: { __type: 'PeriodOfTime' },
    value: { __type: 'Float' },
  },
  UpdateSiteSettingsSchedulerWaitlistRulesPromotionConfirmationWindowInput: {
    periodOfTime: { __type: 'PeriodOfTime' },
    value: { __type: 'Float' },
  },
  UpdateSiteSettingsSchedulerWaitlistRulesPromotionInput: {
    confirmationWindow: {
      __type: 'UpdateSiteSettingsSchedulerWaitlistRulesPromotionConfirmationWindowInput',
    },
    method: { __type: 'WaitlistPromotionMethod' },
    periodOfTime: { __type: 'PeriodOfTime' },
    value: { __type: 'Float' },
  },
  UpdateSiteSettingsSchedulerWaitlistRulesRestrictionsInput: {
    type: { __type: 'WaitlistRestrictionType' },
  },
  UpdateSiteSettingsSchedulerWorkshopsRulesInputInput: { daysInAdvance: { __type: 'Float' } },
  UpdateSiteSettingsSocialMediaInputInput: {
    facebook: { __type: 'String' },
    instagram: { __type: 'String' },
    website: { __type: 'String' },
    x: { __type: 'String' },
  },
  UpdateSiteSettingsSuspensionReasonsInputInput: {
    suspensionReasons: { __type: '[UpdateSiteSettingsSuspensionReasonsSuspensionReasonsInput!]!' },
  },
  UpdateSiteSettingsSuspensionReasonsSuspensionReasonsInput: {
    createdAt: { __type: 'String' },
    enabled: { __type: 'Boolean' },
    id: { __type: 'String' },
    reason: { __type: 'String' },
    updatedAt: { __type: 'String' },
  },
  UpdateSiteSupplierInput: {
    address: { __type: 'String' },
    name: { __type: 'String' },
    phone: { __type: 'String' },
    status: { __type: 'SiteSupplierStatus' },
  },
  UpdateSiteSupplierResponse: {
    __typename: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  UpdateSiteTerminalHandoffSettingsAgreementConsentTextsInput: {
    siteAgreementTemplateId: { __type: 'ID!' },
    text: { __type: 'String!' },
  },
  UpdateSiteTerminalHandoffSettingsEmailConsentToggleInput: {
    enabled: { __type: 'Boolean!' },
    title: { __type: 'String!' },
  },
  UpdateSiteTerminalHandoffSettingsInput: {
    agreementConsentTexts: {
      __type: '[UpdateSiteTerminalHandoffSettingsAgreementConsentTextsInput!]!',
    },
    consentText: { __type: 'String!' },
    eligibleFields: { __type: '[TerminalHandoffField!]!' },
    emailConsentToggle: { __type: 'UpdateSiteTerminalHandoffSettingsEmailConsentToggleInput!' },
    fallback: { __type: 'TerminalSignatureFallback!' },
    fieldCaptureEnabled: { __type: 'Boolean!' },
    signAllLocations: { __type: 'Boolean!' },
    signatureDevice: { __type: 'TerminalSignatureDevice!' },
    smsConsentToggle: { __type: 'UpdateSiteTerminalHandoffSettingsEmailConsentToggleInput!' },
  },
  UpdateSiteTerminalReaderInputInput: {
    isActive: { __type: 'Boolean' },
    name: { __type: 'String' },
  },
  UpdateSiteWebhookInputInput: {
    events: { __type: '[String!]' },
    headerKey: { __type: 'String' },
    headerValue: { __type: 'String' },
    name: { __type: 'String' },
    status: { __type: 'SiteWebhookStatusInput' },
    url: { __type: 'String' },
  },
  UpdateSmsPackageOptionInputInput: { count: { __type: 'Float' }, price: { __type: 'Float' } },
  UpdateSoapNoteResponse: {
    __typename: { __type: 'String!' },
    message: { __type: 'String' },
    note: { __type: 'SoapNote' },
    success: { __type: 'Boolean!' },
  },
  UpdateSpiviInputInput: {
    boxId: { __type: 'String' },
    password: { __type: 'String' },
    publicKey: { __type: 'String' },
    siteId: { __type: 'String' },
    sourceName: { __type: 'String' },
  },
  UpdateStaffAccessPolicyInputInput: {
    accessPermissions: { __type: '[AccessPermissions!]' },
    allowedNetworkIds: { __type: '[ID!]' },
    corporatePermissions: { __type: '[CorporatePermissions!]' },
    name: { __type: 'String' },
    sitePermissions: { __type: '[SitePermissions!]' },
  },
  UpdateStaffAllowedNetworkInputInput: {
    address: { __type: 'String' },
    label: { __type: 'String' },
    notes: { __type: 'String' },
    siteId: { __type: 'ID' },
  },
  UpdateStaffSessionPolicyInputInput: {
    allowLocationIdleTimeout: { __type: 'Boolean!' },
    brandIdleTimeoutMinutes: { __type: 'Int' },
    maxSessionHours: { __type: 'Int' },
  },
  UpdateStaffUserInputInput: {
    about: { __type: 'String' },
    accessLevel: { __type: '[StaffUserAccessLevel!]' },
    data: { __type: 'CreateStaffUserDataInput' },
    dateOfBirth: { __type: 'String' },
    email: { __type: 'String' },
    employeeNumber: { __type: 'Float' },
    favoriteReportNames: { __type: '[String!]' },
    favoriteSavedReportIds: { __type: '[ID!]' },
    favoriteSiteIds: { __type: '[ID!]' },
    firstName: { __type: 'String' },
    gender: { __type: 'String' },
    hobbies: { __type: 'String' },
    instagramHandle: { __type: 'String' },
    lastName: { __type: 'String' },
    phone: { __type: 'String' },
    siteData: { __type: 'CreateStaffUserDataInput' },
  },
  UpdateStaffUserSmartGroupInputInput: {
    filters: { __type: 'CreateStaffUserSmartGroupFiltersInput' },
    isVisible: { __type: 'Boolean' },
    name: { __type: 'String' },
  },
  UpdateStaffUserStatusInputInput: { status: { __type: 'StaffUserStatus!' } },
  UpdateSupportChatInput: {
    evalScore: { __type: 'Float' },
    responseLatencyMs: { __type: 'Int' },
    status: { __type: 'SupportChatStatus' },
  },
  UpdateSystemPreferencesInputInput: {
    systemPreferences: { __type: 'UpdateSystemPreferencesSystemPreferencesInput!' },
  },
  UpdateSystemPreferencesSystemPreferencesAvailableClientsTabsInput: {
    assessment: { __type: 'Boolean' },
    information: { __type: 'Boolean' },
    notes: { __type: 'Boolean' },
    payment: { __type: 'Boolean' },
    schedule: { __type: 'Boolean' },
  },
  UpdateSystemPreferencesSystemPreferencesInput: {
    availableClientsTabs: {
      __type: 'UpdateSystemPreferencesSystemPreferencesAvailableClientsTabsInput',
    },
    defaultAllLocationsSearch: { __type: 'Boolean' },
    defaultBusinessProfileTab: { __type: 'BusinessProfileTab' },
    defaultClientTab: { __type: 'ClientProfileTab' },
    showBusinessInfo: { __type: 'Boolean' },
    tabsDisplayed: { __type: 'UpdateSystemPreferencesSystemPreferencesTabsDisplayedInput' },
  },
  UpdateSystemPreferencesSystemPreferencesTabsDisplayedInput: {
    classes: { __type: 'Boolean' },
    packages: { __type: 'Boolean' },
    requestBooking: { __type: 'Boolean' },
    workshops: { __type: 'Boolean' },
  },
  UpdateTanningIntegrationInput: {
    apiKey: { __type: 'String' },
    externalApiKey: { __type: 'String' },
    externalApiUrl: { __type: 'String' },
    maintenanceEmail: { __type: 'String' },
  },
  UpdateTaxSettingInputInput: {
    enabled: { __type: 'Boolean' },
    name: { __type: 'String' },
    rate: { __type: 'String' },
    setting: { __type: 'TaxSettingType' },
  },
  UpdateTopazInputInput: { enabled: { __type: 'Boolean!' } },
  UpdateVirtualInvoiceInput: {
    amount: { __type: 'Numeric' },
    discountReason: { __type: 'String' },
    discountType: { __type: 'DiscountType' },
    discountValue: { __type: 'Numeric' },
    invoiceDate: { __type: 'String' },
    recurringInvoiceId: { __type: 'ID!' },
    sequenceNumber: { __type: 'Float!' },
  },
  UpdateWorkingHoursWorkingHoursInput: {
    customHoursEnabled: { __type: 'Boolean!' },
    friday: { __type: 'UpdateWorkingHoursWorkingHoursMondayInput' },
    monday: { __type: 'UpdateWorkingHoursWorkingHoursMondayInput' },
    saturday: { __type: 'UpdateWorkingHoursWorkingHoursMondayInput' },
    sunday: { __type: 'UpdateWorkingHoursWorkingHoursMondayInput' },
    thursday: { __type: 'UpdateWorkingHoursWorkingHoursMondayInput' },
    tuesday: { __type: 'UpdateWorkingHoursWorkingHoursMondayInput' },
    wednesday: { __type: 'UpdateWorkingHoursWorkingHoursMondayInput' },
  },
  UpdateWorkingHoursWorkingHoursMondayInput: {
    endTime: { __type: 'String!' },
    startTime: { __type: 'String!' },
  },
  UpdateZapierInputInput: { webhooks: { __type: 'UpdateZapierWebhooksInput' } },
  UpdateZapierWebhooksInput: {
    client: { __type: 'String' },
    clientCheckIn: { __type: 'String' },
    firstSessionBooking: { __type: 'String' },
    lead: { __type: 'String' },
    membershipCancellation: { __type: 'String' },
    membershipSuspension: { __type: 'String' },
    packagePurchase: { __type: 'String' },
    sessionBooking: { __type: 'String' },
  },
  UpdateZoomInput: { authorized: { __type: 'Boolean' }, userId: { __type: 'String' } },
  UploadCustomFont: {
    __typename: { __type: 'String!' },
    font: { __type: 'MemberExperienceFontsCustomFonts!' },
    fontUrl: { __type: 'String!' },
    success: { __type: 'Boolean!' },
  },
  UpsertBrandStoreAsset: {
    __typename: { __type: 'String!' },
    assetId: { __type: 'String!' },
    assetType: { __type: 'BrandStoreAssetType!' },
    brandId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    deviceClass: { __type: 'String' },
    filename: { __type: 'String!' },
    gcsPath: { __type: 'String!' },
    height: { __type: 'Float' },
    locale: { __type: 'String!' },
    platform: { __type: 'BrandPlatform!' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'String' },
    validationError: { __type: 'String' },
    validationStatus: { __type: 'BrandStoreAssetStatus!' },
    width: { __type: 'Float' },
  },
  UpsertBrandStoreListing: {
    __typename: { __type: 'String!' },
    appName: { __type: 'String' },
    brandId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    description: { __type: 'String' },
    keywords: { __type: 'String' },
    locale: { __type: 'String!' },
    marketingUrl: { __type: 'String' },
    platform: { __type: 'BrandPlatform!' },
    privacyPolicyUrl: { __type: 'String' },
    releaseNotes: { __type: 'String' },
    shortDescription: { __type: 'String' },
    subtitle: { __type: 'String' },
    supportUrl: { __type: 'String' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'String' },
  },
  UpsertBrandStoreTester: {
    __typename: { __type: 'String!' },
    brandId: { __type: 'String!' },
    createdAt: { __type: 'String!' },
    email: { __type: 'String!' },
    name: { __type: 'String' },
    platforms: { __type: '[BrandPlatform!]!' },
    source: { __type: 'BrandStoreTesterSource!' },
    testerId: { __type: 'String!' },
    updatedAt: { __type: 'String!' },
    updatedBy: { __type: 'String' },
  },
  UserContextInput: {
    permissions: { __type: '[String!]' },
    role: { __type: 'String' },
    tier: { __type: 'String' },
    userId: { __type: 'String!' },
  },
  ValidateGiftCardResult: {
    __typename: { __type: 'String!' },
    balance: { __type: 'String!' },
    expiresAt: { __type: 'String' },
    isValid: { __type: 'Boolean!' },
    message: { __type: 'String' },
    reason: { __type: 'GiftCardValidationReason' },
  },
  ValidatePromoCode: {
    __typename: { __type: 'String!' },
    isValid: { __type: 'Boolean!' },
    promoCode: { __type: 'PromoCode' },
    reason: { __type: 'String' },
  },
  VerifySessionResponse: {
    __typename: { __type: 'String!' },
    corporateId: { __type: 'String!' },
    planId: { __type: 'String!' },
    status: { __type: 'String!' },
  },
  VertexImportStats: {
    __typename: { __type: 'String!' },
    documentsImported: { __type: 'Int!' },
    success: { __type: 'Boolean!' },
  },
  VideoAnalytics: {
    __typename: { __type: 'String!' },
    androidViews: { __type: 'Float!' },
    avgCompletionPercent: { __type: 'Float!' },
    avgWatchTimeSeconds: { __type: 'Float!' },
    completedPast75Pct: { __type: 'Float!' },
    completionRate: { __type: 'Float!' },
    completions: { __type: 'Float!' },
    droppedBefore25Pct: { __type: 'Float!' },
    droppedBefore50Pct: { __type: 'Float!' },
    droppedBefore75Pct: { __type: 'Float!' },
    iosViews: { __type: 'Float!' },
    totalViews: { __type: 'Float!' },
    totalWatchTimeSeconds: { __type: 'Float!' },
    uniqueViewers: { __type: 'Float!' },
    webViews: { __type: 'Float!' },
  },
  VideoEngagementTrendPoint: {
    __typename: { __type: 'String!' },
    avgWatchTimeSeconds: { __type: 'Float!' },
    completions: { __type: 'Float!' },
    periodStart: { __type: 'String!' },
    totalViews: { __type: 'Float!' },
    uniqueViewers: { __type: 'Float!' },
  },
  VideoQualityUrl: {
    __typename: { __type: 'String!' },
    quality: { __type: 'String!' },
    url: { __type: 'String!' },
  },
  VideoStatus: {
    __typename: { __type: 'String!' },
    error: { __type: 'String' },
    originalDuration: { __type: 'Float' },
    originalFileName: { __type: 'String!' },
    originalFileSize: { __type: 'Int!' },
    rawVideoUrl: { __type: 'String' },
    streamingUrl: { __type: 'String' },
    thumbnailUrl: { __type: 'String' },
    transcodingStatus: { __type: 'VideoTranscodingStatus' },
    uploadProgress: { __type: 'Float' },
    uploadStatus: { __type: 'VideoUploadStatus!' },
    videoId: { __type: 'ID!' },
  },
  VideoStreamingUrls: {
    __typename: { __type: 'String!' },
    duration: { __type: 'Float!' },
    expiresAt: { __type: 'String!' },
    hlsUrl: { __type: 'String!' },
    mp4Urls: { __type: '[VideoQualityUrl!]!' },
    thumbnailUrl: { __type: 'String!' },
    videoId: { __type: 'ID!' },
  },
  VideoUploadSession: {
    __typename: { __type: 'String!' },
    expiresAt: { __type: 'String!' },
    uploadSessionUri: { __type: 'String!' },
    videoId: { __type: 'ID!' },
  },
  VirtualInvoice: {
    __typename: { __type: 'String!' },
    amount: { __type: 'Numeric!' },
    clientId: { __type: 'ID!' },
    currency: { __type: 'String!' },
    invoiceDate: { __type: 'String!' },
    invoiceId: { __type: 'ID' },
    isPendingActivation: { __type: 'Boolean' },
    isVirtual: { __type: 'Boolean!' },
    pendingChange: { __type: 'PendingChange' },
    recurringInvoiceId: { __type: 'ID!' },
    sequenceNumber: { __type: 'Float!' },
    siteId: { __type: 'String!' },
    type: { __type: 'RecurringInvoiceType!' },
  },
  VisitForecastBar: {
    __typename: { __type: 'String!' },
    hour: { __type: 'Int!' },
    level: { __type: 'Int!' },
  },
  VisitForecastDay: {
    __typename: { __type: 'String!' },
    bars: { __type: '[VisitForecastBar!]!' },
    dayOfWeek: { __type: 'Int!' },
    isClosed: { __type: 'Boolean!' },
    windowEnd: { __type: 'Int' },
    windowStart: { __type: 'Int' },
  },
  VoidEquipmentAssignmentInput: {
    assignmentId: { __type: 'ID!' },
    markEquipmentUnavailable: { __type: 'Boolean!' },
    note: { __type: 'String' },
    reason: { __type: 'TanningSessionVoidReason!' },
  },
  VoidPolicyImportResult: {
    __typename: { __type: 'String!' },
    batchId: { __type: 'ID!' },
    voidedAgreements: { __type: 'Float!' },
  },
  WeekViewDay: {
    __typename: { __type: 'String!' },
    date: { __type: 'String!' },
    overflowSessions: { __type: '[WeekViewOverflowSession!]!' },
    sessions: { __type: '[CalendarSession!]!' },
    totalCount: { __type: 'Float!' },
  },
  WeekViewOverflowSession: {
    __typename: { __type: 'String!' },
    bookedCount: { __type: 'Float' },
    color: { __type: 'String' },
    endTime: { __type: 'String!' },
    isBlockSlot: { __type: 'Boolean!' },
    name: { __type: 'String!' },
    sessionId: { __type: 'String!' },
    size: { __type: 'Float!' },
    startTime: { __type: 'String!' },
    status: { __type: 'SessionStatus' },
    waitlistEnabled: { __type: 'Boolean!' },
  },
  WellhubDivergenceCounts: {
    __typename: { __type: 'String!' },
    capacityUnchecked: { __type: 'Int!' },
    mappings: { __type: 'Int!' },
    sessions: { __type: 'Int!' },
    unreferencedClasses: { __type: 'Int!' },
    wellhubSlots: { __type: 'Int!' },
  },
  WellhubDivergenceFinding: {
    __typename: { __type: 'String!' },
    detail: { __type: 'String!' },
    kind: { __type: 'WellhubDivergenceKind!' },
    remedy: { __type: 'String!' },
    subject: { __type: 'String!' },
  },
  WellhubDivergenceReport: {
    __typename: { __type: 'String!' },
    counts: { __type: 'WellhubDivergenceCounts!' },
    findings: { __type: '[WellhubDivergenceFinding!]!' },
    gymId: { __type: 'String!' },
    isConnectionEnabled: { __type: 'Boolean!' },
    siteId: { __type: 'String!' },
    windowEnd: { __type: 'String!' },
    windowStart: { __type: 'String!' },
  },
  WellhubProductEntry: {
    __typename: { __type: 'String!' },
    name: { __type: 'String' },
    productId: { __type: 'String!' },
  },
  WellhubProductMapping: {
    __typename: { __type: 'String!' },
    externalClassId: { __type: 'String' },
    externalProductId: { __type: 'String!' },
    siteSessionTypeId: { __type: 'String!' },
  },
  WellhubSessionTypePublishCounts: {
    __typename: { __type: 'String!' },
    publishableCount: { __type: 'Float!' },
    publishedCount: { __type: 'Float!' },
    siteSessionTypeId: { __type: 'String!' },
  },
  ZapierStatus: {
    __typename: { __type: 'String!' },
    connected: { __type: 'Boolean!' },
    subscriptions: { __type: '[String!]!' },
  },
  Zone: {
    __typename: { __type: 'String!' },
    code: { __type: 'String!' },
    countryId: { __type: 'ID!' },
    createdAt: { __type: 'String!' },
    name: { __type: 'String!' },
    timezone: { __type: 'String' },
    updatedAt: { __type: 'String!' },
    zoneId: { __type: 'ID!' },
  },
  Zones: {
    __typename: { __type: 'String!' },
    pageInfo: { __type: 'ZonesPageInfo!' },
    results: { __type: '[ZonesResults!]!' },
  },
  ZonesFilterInput: { countryId: { __type: 'String' }, timezone: { __type: 'String' } },
  ZonesOrderByInput: {
    column: { __type: 'ZonesOrderBy!' },
    direction: { __type: 'OrderByDirection!' },
  },
  ZonesPageInfo: {
    __typename: { __type: 'String!' },
    endCursor: { __type: 'String' },
    hasNextPage: { __type: 'Boolean!' },
    startCursor: { __type: 'String' },
    totalRecords: { __type: 'Int!' },
  },
  ZonesResults: {
    __typename: { __type: 'String!' },
    cursor: { __type: 'String!' },
    row: { __type: 'Zone!' },
  },
  ZoomAccountUser: {
    __typename: { __type: 'String!' },
    displayName: { __type: 'String!' },
    email: { __type: 'String!' },
    id: { __type: 'String!' },
  },
  ZoomConnectionStatus: {
    __typename: { __type: 'String!' },
    authorized: { __type: 'Boolean!' },
    connectedAt: { __type: 'String' },
    connectedUserEmail: { __type: 'String' },
    userId: { __type: 'String' },
  },
  mutation: {
    __typename: { __type: 'String!' },
    abandonCheckoutBooking: { __type: 'Booking!', __args: { id: 'ID!' } },
    acceptBookingBuddy: {
      __type: 'BookingBuddyMutationResult!',
      __args: { buddyClientId: 'ID!', clientId: 'ID!', inviteToken: 'String', siteId: 'ID' },
    },
    acceptFamilyInvite: { __type: 'Family!', __args: { inviteToken: 'String!', siteId: 'ID!' } },
    acceptIncomingMovement: {
      __type: 'IncomingApprovalDecisionResult!',
      __args: { input: 'IncomingApprovalDecisionInput!' },
    },
    acceptInvitation: {
      __type: 'AcceptInvitation!',
      __args: { firstName: 'String!', lastName: 'String!', password: 'String!', token: 'String!' },
    },
    acceptMyPolicies: {
      __type: 'AcceptMyPoliciesResult!',
      __args: { clientId: 'ID!', items: '[AcceptMyPolicyItemInput!]!', siteId: 'ID!' },
    },
    acceptPolicies: {
      __type: 'AcceptPolicies!',
      __args: { clientId: 'ID!', policyIds: '[String!]!', siteId: 'ID!' },
    },
    acceptSharedCredits: {
      __type: 'ServiceCreditShareMutationResult!',
      __args: { input: 'AcceptSharedCreditsInput!' },
    },
    acceptSitePolicies: {
      __type: 'AcceptSitePolicies!',
      __args: {
        clientId: 'ID!',
        displayedRevisions: '[DisplayedPolicyRevisionInput!]',
        policyIds: '[ID!]!',
        siteId: 'ID!',
      },
    },
    acknowledgeFontDeployment: {
      __type: 'AcknowledgeFontDeployment!',
      __args: { corporateId: 'String!', fontVersion: 'Float!', platform: 'MobileAppPlatform!' },
    },
    activateAgreement: {
      __type: 'ClientAgreement!',
      __args: {
        agreementId: 'ID!',
        clientId: 'ID!',
        signedSource: 'AgreementSignedSource',
        siteId: 'ID!',
      },
    },
    activateCommissions: {
      __type: 'CommissionActivationResult!',
      __args: { activationDate: 'String!' },
    },
    activateGiftCardTemplate: {
      __type: 'GiftCardTemplate!',
      __args: { giftCardTemplateId: 'ID!' },
    },
    activateLeaderboard: {
      __type: 'LeaderboardConfig!',
      __args: { leaderboardConfigId: 'String!' },
    },
    activatePromoCode: { __type: 'PromoCode!', __args: { promoCodeId: 'ID!' } },
    activateServiceTemplate: {
      __type: 'ServiceTemplate!',
      __args: { serviceTemplateId: 'String!' },
    },
    activateSiteAccountCode: {
      __type: 'SiteAccountCode!',
      __args: { accountCodeId: 'ID!', siteId: 'ID!' },
    },
    activateThemeSubscription: {
      __type: 'CorporateThemeSubscription!',
      __args: {
        billingCycleAmount: 'Float',
        corporateId: 'ID!',
        currency: 'String',
        metadata: 'JSONObject',
        themeSlug: 'String!',
      },
    },
    addAccessRule: {
      __type: 'StaffAccessRule!',
      __args: { input: 'AddAccessRuleInputInput!', staffUserId: 'ID!' },
    },
    addClientRelation: {
      __type: 'ClientRelationMutationResult!',
      __args: {
        clientId: 'ID!',
        counterpartyClientId: 'ID!',
        relationshipSubtype: 'ClientFamilyRelationship',
        siteId: 'ID!',
        status: 'ClientRelationStatus',
        type: 'ClientRelationType!',
      },
    },
    addClientToEquipmentQueue: {
      __type: 'Equipment!',
      __args: {
        clientId: 'String!',
        equipmentId: 'String!',
        isOverride: 'Boolean',
        owedBalanceOverride: 'OwedBalanceOverrideInput',
        regulationOverrides: '[TanningRegulationOverrideInput!]',
        siteSessionTypeId: 'String',
      },
    },
    addClientToSite: {
      __type: 'AddClientToSiteResponse!',
      __args: {
        clientId: 'String!',
        siteId: 'String!',
        siteSpecificData: 'AddClientToSiteSiteSpecificDataInput',
      },
    },
    addCommissionAdjustment: {
      __type: 'CommissionLine!',
      __args: {
        adjustmentId: 'ID!',
        amount: 'String!',
        category: 'CommissionCategory',
        commissionPeriodId: 'ID!',
        reason: 'String!',
        siteId: 'ID!',
        staffUserId: 'ID!',
      },
    },
    addCustomPropertyAlert: {
      __type: 'AddCustomPropertyAlert!',
      __args: { input: 'CustomPropertyAlertCreateInput!', propertyId: 'String!', siteId: 'ID!' },
    },
    addFamilyMember: {
      __type: 'Family!',
      __args: {
        canBook: 'Boolean!',
        clientId: 'ID!',
        familyId: 'ID',
        role: 'FamilyMemberRole!',
        siteId: 'ID!',
      },
    },
    addFavoriteInstructor: {
      __type: 'Boolean!',
      __args: { clientId: 'String!', instructorId: 'String!', siteId: 'String!' },
    },
    addFavoriteSite: { __type: 'Boolean!', __args: { clientId: 'String!', siteId: 'String!' } },
    addKnowledgeArticleTranslation: {
      __type: 'KnowledgeArticleTranslation!',
      __args: { input: 'KnowledgeArticleTranslationInput!', knowledgeArticleId: 'ID!' },
    },
    addKnowledgeDocument: {
      __type: 'KnowledgeDocument!',
      __args: { input: 'KnowledgeDocumentInput!' },
    },
    addManualScheduledPayment: {
      __type: 'ID!',
      __args: {
        amount: 'String!',
        invoiceDate: 'String!',
        recurringInvoiceId: 'ID!',
        siteId: 'ID!',
      },
    },
    addManualTimeClockEntry: {
      __type: 'PayrollTimeClock!',
      __args: {
        clockInTime: 'String!',
        clockOutTime: 'String!',
        notes: 'String',
        siteId: 'ID!',
        staffUserId: 'ID!',
      },
    },
    addReferral: {
      __type: 'AddReferral!',
      __args: { receiverId: 'String!', referralId: 'String!', siteId: 'String!' },
    },
    addReferralBonus: {
      __type: 'AddReferralBonus!',
      __args: { receiverId: 'String!', referralId: 'String!', siteId: 'String!' },
    },
    addReleaseNoteTranslation: {
      __type: 'ReleaseNoteTranslation!',
      __args: { input: 'ReleaseNoteTranslationInput!', releaseNoteId: 'ID!' },
    },
    addSessionFeedbackQuestion: {
      __type: 'SessionFeedbackQuestion!',
      __args: { input: 'SessionFeedbackQuestionCreateInput!', siteId: 'ID!' },
    },
    addSharedCreditRecipient: {
      __type: 'ServiceCreditShareMutationResult!',
      __args: { input: 'ServiceCreditShareAddRecipientInput!' },
    },
    addSiteFormQuestion: {
      __type: 'SiteFormQuestionOrderResponse!',
      __args: { input: 'SiteFormQuestionCreateInput!', siteFormId: 'String!', siteId: 'ID!' },
    },
    addSmsPackageOption: {
      __type: 'SmsPackage!',
      __args: { input: 'AddSmsPackageOptionInputInput!', smsPackageId: 'ID!' },
    },
    addStaffUserToSessionTemplate: {
      __type: 'SessionTemplate!',
      __args: { id: 'String!', input: 'SessionTemplateStaffUserInput!', siteId: 'String!' },
    },
    addSupportMessage: {
      __type: 'SupportChatMessage!',
      __args: { input: 'AddSupportMessageInput!' },
    },
    addToWaitlist: {
      __type: 'SessionWaitlistEntry!',
      __args: {
        clientId: 'String!',
        forFamilyMember: 'Boolean',
        guestServiceId: 'ID',
        sessionId: 'String!',
        siteId: 'String!',
      },
    },
    adjustEquipmentLampHours: {
      __type: 'EquipmentLampLog!',
      __args: { input: 'AdjustEquipmentLampHoursInput!' },
    },
    adjustPackageExpiry: {
      __type: 'Boolean!',
      __args: { expiresAtDate: 'String!', serviceId: 'String!', siteId: 'String!' },
    },
    adjustPosStock: {
      __type: 'AdjustStockResponse!',
      __args: { input: 'AdjustStockInput!', posProductId: 'ID!', siteId: 'ID!' },
    },
    adjustServiceCredits: { __type: 'String!', __args: { input: 'AdjustCreditsInput!' } },
    adminBackfillSiteIndex: { __type: '[String!]!', __args: { corporateId: 'ID!' } },
    adminBulkSetSitesAdminConfigurationsFeesBrandRebatesTemplates: {
      __type: 'BulkUpdateSites!',
      __args: { rebateTemplateIds: '[String!]!', siteIds: '[String!]!' },
    },
    adminBulkSetSitesAdminConfigurationsFeesRoyaltiesAndFeesTemplate: {
      __type: 'BulkUpdateSites!',
      __args: { royaltiesAndFeesTemplateId: 'String!', siteIds: '[String!]!' },
    },
    adminCloneSite: { __type: 'Site!', __args: { countryId: 'ID!', siteId: 'ID!', zoneId: 'ID!' } },
    adminCreateCorporateWebhook: {
      __type: 'CorporateWebhook!',
      __args: { corporateId: 'ID!', input: 'CreateCorporateWebhookInputInput!' },
    },
    adminDeleteCorporateWebhook: {
      __type: 'Boolean!',
      __args: { corporateId: 'ID!', webhookId: 'ID!' },
    },
    adminDuplicateSite: { __type: 'SiteCloneJob!', __args: { input: 'SiteDuplicateInput!' } },
    adminGenerateCorporateContentApiKey: {
      __type: 'Corporate!',
      __args: { corporateId: 'String!' },
    },
    adminLinkCorporatePushApp: {
      __type: 'Corporate!',
      __args: { corporateId: 'String!', corporateInput: 'LinkCorporatePushAppInput!' },
    },
    adminRunStripeMetadataBackfill: { __type: '[String!]!', __args: { siteId: 'String!' } },
    adminSetSiteAdminConfigurationsFeesBrandRebatesTemplates: {
      __type: 'Site!',
      __args: { rebateTemplateIds: '[String!]!', siteId: 'String!' },
    },
    adminSetSiteAdminConfigurationsFeesClientFeesTemplate: {
      __type: 'Site!',
      __args: { id: 'String!', siteId: 'String!' },
    },
    adminSetSiteAdminConfigurationsFeesHapanaFeesTemplate: {
      __type: 'Site!',
      __args: { id: 'String!', siteId: 'String!' },
    },
    adminSetSiteAdminConfigurationsFeesRoyaltiesAndFeesTemplate: {
      __type: 'Site!',
      __args: { royaltiesAndFeesTemplateId: 'String', siteId: 'String!' },
    },
    adminSetSiteConnectedSharedSites: {
      __type: 'Site!',
      __args: { siteId: 'ID!', siteIds: '[String!]!' },
    },
    adminSetSiteGrowEnabled: {
      __type: 'SetSiteGrowEnabledResponse!',
      __args: { enabled: 'Boolean!', siteId: 'String!' },
    },
    adminSiteIntegrationsGrowClearAuthentication: {
      __type: 'SetSiteAuthenticationResponse!',
      __args: { id: 'String!' },
    },
    adminSiteIntegrationsGrowSetAuthentication: {
      __type: 'SetSiteAuthenticationResponse!',
      __args: { code: 'String!', id: 'String!' },
    },
    adminSwitchEzypayWebhooksToV2: {
      __type: '[String!]!',
      __args: { recreate: 'Boolean!', siteId: 'ID!' },
    },
    adminUpdateCorporateAggregatorIntegration: {
      __type: 'AdminUpdateCorporateAggregatorIntegration!',
      __args: { aggregatorProviderId: 'String!', corporateId: 'String!', enabled: 'Boolean!' },
    },
    adminUpdateCorporateAggregatorProviderSites: {
      __type: 'AdminUpdateCorporateAggregatorProviderSites!',
      __args: { aggregatorProviderId: 'String!', corporateId: 'String!', siteIds: '[String!]!' },
    },
    adminUpdateCorporateIntegrationsClassPass: {
      __type: 'Corporate!',
      __args: { corporateId: 'String!', enabled: 'Boolean!', siteIds: '[String!]!' },
    },
    adminUpdateCorporateIntegrationsContentful: {
      __type: 'Corporate!',
      __args: {
        corporateId: 'String!',
        corporateInput: 'UpdateCorporateIntegrationsContentfulInput!',
      },
    },
    adminUpdateCorporateIntegrationsDeeplinking: {
      __type: 'Corporate!',
      __args: {
        corporateId: 'String!',
        corporateInput: 'UpdateCorporateIntegrationsDeeplinkingInput!',
      },
    },
    adminUpdateCorporateIntegrationsEgym: {
      __type: 'Corporate!',
      __args: { corporateId: 'String!', corporateInput: 'UpdateCorporateIntegrationsEgymInput!' },
    },
    adminUpdateCorporateIntegrationsGrow: {
      __type: 'Corporate!',
      __args: { corporateId: 'String!', corporateInput: 'UpdateCorporateIntegrationsGrowInput!' },
    },
    adminUpdateCorporateIntegrationsPushNotification: {
      __type: 'Corporate!',
      __args: {
        corporateId: 'String!',
        corporateInput: 'UpdateCorporateIntegrationsPushNotificationInput!',
      },
    },
    adminUpdateCorporateIntegrationsZapier: {
      __type: 'Corporate!',
      __args: { corporateId: 'String!', corporateInput: 'UpdateCorporateIntegrationsZapierInput!' },
    },
    adminUpdateCorporateWebhook: {
      __type: 'CorporateWebhook!',
      __args: { corporateId: 'ID!', input: 'UpdateCorporateWebhookInputInput!', webhookId: 'ID!' },
    },
    adminUpdateMemberMovementEntitlement: {
      __type: 'MemberMovementConfig!',
      __args: { corporateId: 'String!', input: 'MemberMovementEntitlementInput!' },
    },
    adminUpdateSiteAdminConfigurations: {
      __type: 'Site!',
      __args: { input: 'SiteAdminConfigurationsUpdateInput!', siteId: 'ID!' },
    },
    adminUpdateSiteAdminConfigurationsPaymentGateway: {
      __type: 'Site!',
      __args: { payload: 'SiteAdminConfigPaymentGatewayInput!', siteId: 'String!' },
    },
    adminUpdateSiteIntegrationsClassPass: {
      __type: 'Site!',
      __args: { enabled: 'Boolean!', siteId: 'String!' },
    },
    adminUpdateSiteIntegrationsGrow: {
      __type: 'Site!',
      __args: { growInput: 'UpdateGrowInput!', siteId: 'String!' },
    },
    adminUpdateSiteV2Enabled: {
      __type: 'AdminUpdateSiteV2Enabled!',
      __args: { isV2Enabled: 'Boolean!', siteId: 'String!' },
    },
    adoptMemberMovementLocationResolution: {
      __type: 'AdoptMemberMovementLocationResolutionResult!',
      __args: { input: 'AdoptMemberMovementLocationResolutionInput!' },
    },
    allocateFamilyPackage: {
      __type: 'ServiceCreditShareMutationResult!',
      __args: { input: 'AllocateFamilyPackageInput!' },
    },
    anonymiseClient: {
      __type: 'AnonymiseClientResponse!',
      __args: { clientId: 'String!', siteId: 'String!' },
    },
    appendSignatureToAgreement: {
      __type: 'AppendSignatureToAgreement!',
      __args: {
        agreementId: 'ID!',
        clientId: 'ID!',
        expectedLinkedInvoiceId: 'ID',
        ipAddress: 'String',
        pendingCheckout: 'Boolean',
        signature: 'String!',
        signedSource: 'AgreementSignedSource',
        siteId: 'ID!',
        slotKey: 'String',
        userAgent: 'String',
      },
    },
    applyHeldTerminalHandoffValue: {
      __type: 'TerminalHandoffRequest!',
      __args: { siteId: 'ID!', stepKey: 'String!', terminalHandoffRequestId: 'ID!' },
    },
    applySessionTemplateToFutureSessions: {
      __type: 'ApplySessionTemplateResult!',
      __args: {
        id: 'String!',
        includeModifiedSessions: 'Boolean',
        input: 'SessionTemplateUpdateInput!',
        siteId: 'String!',
      },
    },
    approveAllImports: { __type: 'ApproveAllImports!', __args: { importSessionIds: '[ID!]!' } },
    approveCheckin: {
      __type: 'ApproveCheckinResult!',
      __args: { bookingId: 'String', clientId: 'String!', sessionId: 'String!', siteId: 'String!' },
    },
    approveCoverClaim: {
      __type: 'CoverRequestView!',
      __args: {
        coverClaimId: 'ID!',
        coverRequestId: 'ID!',
        notifyMembers: 'Boolean',
        siteId: 'ID!',
      },
    },
    approveGiftCardExpiryRule: {
      __type: 'GiftCardExpiryRuleRecord!',
      __args: { giftCardExpiryRuleId: 'ID!' },
    },
    approveImport: { __type: 'ApproveImport!', __args: { importSessionId: 'ID!' } },
    approveKnowledgeArticleRevision: { __type: 'KnowledgeArticle!', __args: { revisionId: 'ID!' } },
    approveMemberMovementRun: {
      __type: 'MemberMovementRun!',
      __args: { input: 'ApproveMemberMovementRunInput!' },
    },
    archiveCommissionPlan: { __type: 'CommissionPlan!', __args: { commissionPlanId: 'ID!' } },
    archiveContentEntry: { __type: 'CmsContentEntry!', __args: { contentEntryId: 'ID!' } },
    archiveCorporateAddOn: {
      __type: 'CorporateAddOnRolloutResult!',
      __args: { input: 'CorporateServiceTemplateVersionInput!' },
    },
    archiveCorporateAddOns: {
      __type: 'CorporateAddOnArchiveManyResult!',
      __args: { input: 'ArchiveCorporateServiceTemplatesInput!' },
    },
    archiveGiftCardTemplate: { __type: 'GiftCardTemplate!', __args: { giftCardTemplateId: 'ID!' } },
    archiveKnowledgeArticle: { __type: 'KnowledgeArticle!', __args: { knowledgeArticleId: 'ID!' } },
    archiveLeaderboard: {
      __type: 'LeaderboardConfig!',
      __args: { leaderboardConfigId: 'String!' },
    },
    archivePosProduct: {
      __type: 'ArchiveProductResponse!',
      __args: { posProductId: 'ID!', siteId: 'ID!' },
    },
    archivePromoCode: { __type: 'PromoCode!', __args: { promoCodeId: 'ID!' } },
    archiveServiceTemplate: {
      __type: 'ServiceTemplate!',
      __args: { serviceTemplateId: 'String!' },
    },
    assignAgreementToClient: {
      __type: 'ClientAgreement!',
      __args: { clientId: 'ID!', siteAgreementTemplateId: 'ID!', siteId: 'ID!' },
    },
    assignClientSiteStaff: {
      __type: 'AssignClientSiteStaffResponse!',
      __args: { clientId: 'String!', siteId: 'String!', staffUserId: 'String' },
    },
    assignCommissionPlan: {
      __type: 'CommissionAssignment!',
      __args: {
        commissionPlanId: 'ID!',
        earnerRole: 'CommissionEarnerRole!',
        endDate: 'String',
        managerScope: 'CommissionManagerScope',
        overrides: 'JSONObject',
        siteIds: '[ID!]!',
        staffUserId: 'ID!',
        startDate: 'String!',
        teamStaffUserIds: '[ID!]',
      },
    },
    assignCoverDirectly: {
      __type: 'CoverRequestView!',
      __args: {
        coverRequestId: 'ID!',
        notifyMembers: 'Boolean',
        siteId: 'ID!',
        staffUserId: 'ID!',
      },
    },
    assignFormToClient: {
      __type: 'AssignFormResponse!',
      __args: {
        clientId: 'String!',
        requiredBefore: 'FormRequiredBefore',
        sendEmail: 'Boolean',
        siteFormId: 'String!',
        siteId: 'String!',
      },
    },
    assignSitePayrollTier: {
      __type: 'AssignSitePayrollTier!',
      __args: {
        coreUserId: 'ID!',
        effectiveDate: 'String',
        endDate: 'String',
        payrollTierId: 'ID!',
        siteId: 'ID!',
      },
    },
    assignTrialOwner: { __type: 'Boolean!', __args: { corporateId: 'ID!', salesOwnerId: 'ID' } },
    attachSessionZoomUrl: {
      __type: 'Session!',
      __args: { id: 'String!', siteId: 'String!', url: 'String!' },
    },
    attestBrandSetupStep: {
      __type: '[BrandSetupStepView!]!',
      __args: { brandId: 'String!', note: 'String', step: 'BrandSetupStep!' },
    },
    attestProvisioningStep: {
      __type: '[BrandProvisioningOutcome!]!',
      __args: { brandId: 'String!', note: 'String', step: 'BrandProvisionStep!' },
    },
    authorizeFobScanCheckIn: {
      __type: 'ScanAuthorizationResult!',
      __args: { fobNumber: 'String!', siteAccessPointId: 'String!', siteId: 'String!' },
    },
    authorizeQrScanCheckIn: {
      __type: 'ScanAuthorizationResult!',
      __args: {
        clientId: 'String!',
        contactlessCheckInAnswers: 'JSONObject',
        noQuestionnaireCheckin: 'Boolean',
        siteAccessPointId: 'String!',
        siteId: 'String!',
      },
    },
    biDeleteDashboard: {
      __type: 'BiTenantDashboardsResponse!',
      __args: { input: 'BiDeleteDashboardInput!' },
    },
    biPublishDashboard: {
      __type: 'BiTenantDashboardsResponse!',
      __args: { input: 'BiPublishDashboardInput!' },
    },
    biSaveDashboard: {
      __type: 'BiTenantDashboardsResponse!',
      __args: { input: 'BiPublishDashboardInput!' },
    },
    biSetAccess: { __type: 'BiTenantDashboardsResponse!', __args: { input: 'BiSetAccessInput!' } },
    biSetDefaultDashboard: {
      __type: 'BiTenantDashboardsResponse!',
      __args: { input: 'BiSetDefaultDashboardInput!' },
    },
    biSetMigrationConfig: {
      __type: 'BiMigrationConfig!',
      __args: { input: 'BiSetMigrationConfigInput!' },
    },
    blockClientAtSite: {
      __type: 'BlockClientResponse!',
      __args: {
        blockEndDate: 'String',
        blockReason: 'String',
        blockStartDate: 'String',
        clientId: 'String!',
        siteId: 'String!',
      },
    },
    brandArtworkUploadUrl: {
      __type: 'BrandArtworkUploadUrl!',
      __args: { brandId: 'String!', field: 'BrandArtworkField!', format: 'BrandArtworkFormat!' },
    },
    brandNavigationArtworkUploadUrl: {
      __type: 'BrandArtworkUploadUrl!',
      __args: { brandId: 'String!', field: 'BrandNavigationArtworkField!' },
    },
    broadcastCoverMessage: {
      __type: 'CoverMessageView!',
      __args: { body: 'String!', coverRequestId: 'ID!', siteId: 'ID!' },
    },
    bulkAddSmsPackageOptions: {
      __type: 'SmsPackage!',
      __args: { input: 'BulkAddSmsPackageOptionsInputInput!', smsPackageId: 'ID!' },
    },
    bulkAddToWaitlist: {
      __type: '[SessionWaitlistEntry!]!',
      __args: { clientIds: '[String!]!', sessionId: 'String!', siteId: 'String!' },
    },
    bulkInviteStaff: {
      __type: '[BulkInviteStaff!]!',
      __args: { corporateId: 'ID!', invitations: '[InviteStaffMemberInvitationInput!]!' },
    },
    bulkReinstateInvoices: {
      __type: 'BulkUpdateInvoicesResult!',
      __args: { items: '[ReinstateInvoiceInput!]!', siteId: 'ID!' },
    },
    bulkRemoveFromWaitlist: {
      __type: 'Float!',
      __args: { sessionWaitlistEntryIds: '[String!]!', siteId: 'String!' },
    },
    bulkRevertMemberMovements: {
      __type: 'BulkRevertMemberMovementsResult!',
      __args: { reason: 'String', runId: 'ID!' },
    },
    bulkSetSitesFeesClientFeesTemplate: {
      __type: 'BulkUpdateSites!',
      __args: { clientFeeTemplateId: 'String!', siteIds: '[String!]!' },
    },
    bulkSetSitesFeesHapanaFeesTemplate: {
      __type: 'BulkUpdateSites!',
      __args: { hapanaFeeTemplateId: 'String!', siteIds: '[String!]!' },
    },
    bulkUpdateContentEntryStatus: {
      __type: 'BulkUpdateContentEntryStatus!',
      __args: { action: 'ContentBulkAction!', contentEntryIds: '[ID!]!' },
    },
    bulkUpdateInvoiceScheduleDates: {
      __type: 'BulkUpdateInvoicesResult!',
      __args: { input: 'BulkUpdateInvoiceScheduleDatesInput!', siteId: 'ID!' },
    },
    bulkUpdateInvoices: {
      __type: 'BulkUpdateInvoicesResult!',
      __args: { input: 'BulkUpdateInvoicesInput!', siteId: 'ID!' },
    },
    bulkUpdateScheduledAmounts: {
      __type: 'BulkUpdateInvoicesResult!',
      __args: { input: 'BulkUpdateScheduledAmountsInput!', siteId: 'ID!' },
    },
    bulkUpdateScheduledDates: {
      __type: 'BulkUpdateInvoicesResult!',
      __args: { input: 'BulkUpdateScheduledDatesInput!', siteId: 'ID!' },
    },
    calculateMemberMovementRun: {
      __type: 'MemberMovementRun!',
      __args: { acknowledgeOverlap: 'Boolean', runId: 'ID!' },
    },
    cancelBooking: {
      __type: 'Booking!',
      __args: {
        feeRefundMethod: 'DropInRefundMethod',
        id: 'ID!',
        refundMethod: 'DropInRefundMethod',
        staffRemoval: 'Boolean',
      },
    },
    cancelContentSchedule: { __type: 'Boolean!', __args: { contentScheduleId: 'ID!' } },
    cancelCoverRequest: {
      __type: 'CoverRequestView!',
      __args: { coverRequestId: 'ID!', siteId: 'ID!' },
    },
    cancelDemoSeedingJob: { __type: 'DemoSeedingJob!', __args: { jobId: 'String!' } },
    cancelEquipmentAssignment: {
      __type: 'EquipmentAssignment!',
      __args: { assignmentId: 'String!' },
    },
    cancelFailedInvoice: {
      __type: '[Invoice!]!',
      __args: {
        cancellationReason: 'String!',
        invoiceId: 'ID',
        invoiceIds: '[ID!]',
        sendToCollections: 'Boolean!',
        siteId: 'ID!',
      },
    },
    cancelFobCapture: { __type: 'FobCaptureRequest!', __args: { requestId: 'ID!', siteId: 'ID!' } },
    cancelFormAssignment: {
      __type: 'CancelFormAssignmentResponse!',
      __args: { formSubmissionId: 'String!', reason: 'String!', siteId: 'String!' },
    },
    cancelFormHandoff: { __type: 'FormHandoff!', __args: { handoffId: 'ID!', siteId: 'String!' } },
    cancelImportSession: { __type: 'CancelImportSession!', __args: { importSessionId: 'ID!' } },
    cancelInvoice: {
      __type: 'Invoice!',
      __args: { cancellationReason: 'String!', invoiceId: 'String!', siteId: 'ID!' },
    },
    cancelMemberMovementRun: { __type: 'MemberMovementRun!', __args: { runId: 'ID!' } },
    cancelPendingClientAction: {
      __type: 'CancelPendingClientActionResult!',
      __args: { invoiceId: 'ID!', paymentId: 'ID!', siteId: 'ID!' },
    },
    cancelPendingItemsHandoff: {
      __type: 'PendingItemsHandoff!',
      __args: { handoffId: 'ID!', siteId: 'ID!' },
    },
    cancelPendingPayment: {
      __type: 'CancelPendingPaymentResult!',
      __args: { paymentId: 'ID!', reason: 'PendingPaymentCancellationReason!', siteId: 'ID!' },
    },
    cancelPendingPaymentPlanChange: {
      __type: 'Boolean!',
      __args: { input: 'CancelPendingPaymentPlanChangeInput!' },
    },
    cancelPolicyBulkSend: { __type: 'PolicyBulkSendRun!', __args: { runId: 'ID!', siteId: 'ID!' } },
    cancelScheduledCancellation: {
      __type: 'Boolean!',
      __args: { reason: 'String', serviceCancellationId: 'String!' },
    },
    cancelScheduledPlanChange: {
      __type: 'Boolean!',
      __args: { input: 'CancelScheduledPlanChangeInput!' },
    },
    cancelScheduledPushSend: {
      __type: 'ScheduledPushSend!',
      __args: { scheduledPushSendId: 'ID!', siteId: 'ID!' },
    },
    cancelScheduledSitePolicyRevision: {
      __type: 'SitePolicyRevision!',
      __args: { siteId: 'ID!', sitePolicyId: 'ID!' },
    },
    cancelScheduledSuspension: {
      __type: 'Boolean!',
      __args: { reason: 'String', serviceSuspensionId: 'String!', siteId: 'String!' },
    },
    cancelService: {
      __type: 'String',
      __args: {
        bookingIds: '[String!]',
        cancelAt: 'String',
        chargeAmount: 'Numeric',
        chargeMode: 'ServiceSuspensionChargeMode',
        collectChargeNow: 'Boolean',
        failedInvoiceIds: '[String!]',
        reason: 'String',
        serviceId: 'String!',
        siteId: 'String!',
      },
    },
    cancelSession: { __type: 'Session!', __args: { input: 'CancelSessionInput!' } },
    cancelSessions: { __type: '[Session!]!', __args: { input: 'CancelSessionsBatchInput!' } },
    cancelSessionsForClosure: {
      __type: '[ClosureSessionCancellationResult!]!',
      __args: { input: 'CancelSessionsForClosureInput!' },
    },
    cancelTerminalAction: {
      __type: 'CancelTerminalAction!',
      __args: { siteId: 'ID!', terminalReaderId: 'ID!' },
    },
    cancelTerminalHandoffRequest: {
      __type: 'TerminalHandoffRequest!',
      __args: { siteId: 'ID!', terminalHandoffRequestId: 'ID!' },
    },
    cancelThemeSubscription: {
      __type: 'Boolean!',
      __args: { corporateId: 'ID!', reason: 'String', subscriptionId: 'ID!' },
    },
    changeAdminUserStatus: {
      __type: 'AdminUser!',
      __args: { adminUserId: 'ID!', status: 'AdminUserStatus!' },
    },
    changeBookingCreditPackage: {
      __type: 'Booking!',
      __args: { additionalServiceIds: '[ID!]', bookingId: 'ID!', serviceId: 'ID!' },
    },
    changeClientPassword: {
      __type: 'Boolean!',
      __args: { clientId: 'String!', password: 'String!' },
    },
    changeMembershipPlan: {
      __type: 'ChangeMembershipPlanResult!',
      __args: { input: 'ChangeMembershipPlanInput!' },
    },
    changeMembershipStartDate: {
      __type: 'Boolean!',
      __args: {
        memberNotification: 'MemberNotificationInput',
        newStartDate: 'String!',
        serviceId: 'String!',
        siteId: 'String!',
      },
    },
    changeRecurringInvoicePaymentMethod: {
      __type: 'Boolean!',
      __args: { clientPaymentMethodId: 'ID!', recurringInvoiceId: 'ID!', siteId: 'ID!' },
    },
    chargeBookingFee: {
      __type: 'Booking!',
      __args: { bookingId: 'String!', feeType: 'BookingFeeType!' },
    },
    checkIn: {
      __type: 'CheckInByBookingResult!',
      __args: { bookingId: 'String!', clientId: 'String!', siteId: 'String' },
    },
    chooseIncomingMovementDestination: {
      __type: 'MemberMovementListItem!',
      __args: { input: 'ChooseIncomingMovementDestinationInput!' },
    },
    claimCover: { __type: 'CoverRequestView!', __args: { coverRequestId: 'ID!', siteId: 'ID!' } },
    claimGuestPass: {
      __type: 'ClaimGuestPassResult!',
      __args: { firebaseId: 'String!', input: 'ClaimGuestPassInput!', verifiedEmail: 'String' },
    },
    cleanupOrphanedCarouselGroups: { __type: 'CleanupOrphanedCarouselGroupsResult!' },
    clearBackupPaymentMethod: { __type: 'Boolean!', __args: { clientId: 'ID!', siteId: 'ID!' } },
    clearBrandReleaseHold: { __type: 'BrandReleaseHold!', __args: { brandId: 'String!' } },
    clearCommissionItemLocationOverride: {
      __type: 'CommissionItemSetting!',
      __args: { itemId: 'String!', itemType: 'CommissionItemType!', siteId: 'ID!' },
    },
    clearEmergencyStopMemberMovement: {
      __type: 'EmergencyStopMemberMovementResult!',
      __args: { corporateId: 'ID!' },
    },
    clearGrowHqAuthentication: {
      __type: 'ClearGrowHqAuthentication!',
      __args: { hqId: 'String!' },
    },
    clearSandboxJobs: { __type: 'Boolean!', __args: { brandSlug: 'String!' } },
    clearTrialDemoData: { __type: 'Boolean!', __args: { corporateId: 'ID!' } },
    clockInStaffUser: {
      __type: 'PayrollTimeClock!',
      __args: { notes: 'String', siteId: 'ID!', staffUserId: 'ID!' },
    },
    clockOutStaffUser: {
      __type: 'PayrollTimeClock!',
      __args: { notes: 'String', siteId: 'ID!', staffUserId: 'ID!' },
    },
    closeCashDrawerSession: {
      __type: 'CashDrawerSession!',
      __args: { actualCash: 'Numeric!', cashDrawerSessionId: 'ID!', siteId: 'ID!' },
    },
    closeTrial: {
      __type: 'Boolean!',
      __args: { closeNotes: 'String', closeReason: 'CloseReason!', corporateId: 'ID!' },
    },
    cmsImportRunAdvance: { __type: 'CmsImportRun!', __args: { importRunId: 'String!' } },
    cmsImportRunCancel: { __type: 'CmsImportRun!', __args: { importRunId: 'String!' } },
    cmsImportRunConnectJWPlayer: {
      __type: 'CmsImportRun!',
      __args: { importRunId: 'String!', siteId: 'String!' },
    },
    cmsImportRunConnectMongoDB: {
      __type: 'CmsImportRun!',
      __args: { importRunId: 'String!', legacyCorporateId: 'String' },
    },
    cmsImportRunConnectV1Aurora: {
      __type: 'CmsImportRun!',
      __args: { importRunId: 'String!', v1CorporateId: 'Int' },
    },
    cmsImportRunCreate: {
      __type: 'CmsImportRun!',
      __args: { importMode: 'CmsImportMode!', sources: 'JSONObject' },
    },
    cmsImportRunDisableNativeContent: {
      __type: 'CmsImportRun!',
      __args: { importRunId: 'String!' },
    },
    cmsImportRunEnableNativeContent: {
      __type: 'CmsImportRun!',
      __args: { importRunId: 'String!' },
    },
    cmsImportRunExecute: { __type: 'CmsImportRun!', __args: { importRunId: 'String!' } },
    cmsImportRunExportContentful: {
      __type: 'CmsImportRun!',
      __args: { environment: 'String', importRunId: 'String!', spaceId: 'String!' },
    },
    cmsImportRunGeneratePreview: { __type: 'CmsImportRun!', __args: { importRunId: 'String!' } },
    cmsImportRunGenerateUploadUrl: {
      __type: 'CmsImportRunGenerateUploadUrl!',
      __args: { importRunId: 'String!' },
    },
    cmsImportRunMatchMember: {
      __type: 'CmsImportRunPreview!',
      __args: { clientId: 'ID!', importRunId: 'ID!', previewId: 'ID!' },
    },
    cmsImportRunPreviewOverride: {
      __type: 'CmsImportRunPreview!',
      __args: { importRunId: 'String!', override: 'JSONObject!', previewId: 'String!' },
    },
    cmsImportRunResetToConfiguring: { __type: 'CmsImportRun!', __args: { importRunId: 'String!' } },
    cmsImportRunRollback: { __type: 'CmsImportRun!', __args: { importRunId: 'String!' } },
    cmsImportRunRollbackStep: {
      __type: 'CmsImportRun!',
      __args: { importRunId: 'String!', stepType: 'String!' },
    },
    cmsImportRunSetOptions: {
      __type: 'CmsImportRun!',
      __args: { importRunId: 'String!', options: 'CmsImportOptionsInput!' },
    },
    cmsImportRunSetStepMode: {
      __type: 'CmsImportRun!',
      __args: { importRunId: 'String!', stepByStep: 'Boolean!' },
    },
    cmsImportRunStepPause: {
      __type: 'CmsImportRunStep!',
      __args: { importRunId: 'String!', importRunStepId: 'String!' },
    },
    cmsImportRunStepResume: {
      __type: 'CmsImportRunStep!',
      __args: { importRunId: 'String!', importRunStepId: 'String!' },
    },
    cmsImportRunStepRetryFailed: {
      __type: 'CmsImportRunStep!',
      __args: { importRunId: 'String!', importRunStepId: 'String!' },
    },
    cmsImportRunUploadContentful: {
      __type: 'CmsImportRun!',
      __args: { fileUrl: 'String!', importRunId: 'String!' },
    },
    cmsImportRunVerify: { __type: 'CmsImportRun!', __args: { importRunId: 'String!' } },
    cmsImportSaveContentfulKeys: {
      __type: 'CmsImportContentfulConfig!',
      __args: { managementToken: 'String!', spaceId: 'String!' },
    },
    cmsImportSaveJwPlayerKey: {
      __type: 'CmsImportJwPlayerSitesResult!',
      __args: { apiKey: 'String!' },
    },
    completeClientFileUpload: {
      __type: 'CompleteClientFileUploadResponse!',
      __args: { clientId: 'ID!', fileId: 'ID!', siteId: 'ID!' },
    },
    completeClientPaymentMethod: {
      __type: 'ClientPaymentMethod!',
      __args: { clientId: 'ID', clientPaymentMethodId: 'ID!', siteId: 'ID!', token: 'String' },
    },
    completeMediaUpload: {
      __type: 'CmsContentMedia!',
      __args: { input: 'CompleteMediaUploadInputInput!' },
    },
    completeOnboardingStep: {
      __type: 'Boolean!',
      __args: { completedByUserId: 'ID', corporateId: 'ID!', stepKey: 'OnboardingStepKey!' },
    },
    completeSitePaymentMethodSetup: {
      __type: 'SitePaymentMethodDetails!',
      __args: { setupIntentId: 'String!', siteId: 'String!' },
    },
    confirmBookingRequest: {
      __type: 'Booking!',
      __args: { bookingId: 'String!', rescheduled: 'Boolean' },
    },
    confirmBrandArtworkUpload: {
      __type: 'BrandArtwork!',
      __args: { brandId: 'String!', field: 'BrandArtworkField!', uploadRef: 'String!' },
    },
    confirmBrandNavigationArtworkUpload: {
      __type: 'BrandNavigationArtwork!',
      __args: { brandId: 'String!', field: 'BrandNavigationArtworkField!', uploadRef: 'String!' },
    },
    confirmBrandStoreAsset: {
      __type: '[ConfirmBrandStoreAsset!]!',
      __args: {
        assetType: 'BrandStoreAssetType!',
        brandId: 'String!',
        deviceClass: 'String',
        filename: 'String!',
        locale: 'String!',
        platform: 'BrandPlatform!',
        uploadRef: 'String!',
      },
    },
    confirmDirectUpload: {
      __type: 'DirectUploadImage!',
      __args: { input: 'DirectUploadConfirmInput!' },
    },
    confirmFobCaptureReassign: {
      __type: 'FobCaptureRequest!',
      __args: { requestId: 'ID!', siteId: 'ID!' },
    },
    connectApnsKey: {
      __type: 'ConnectApnsKeyResult!',
      __args: { brandId: 'String!', keyId: 'String!', privateKey: 'String!', teamId: 'String' },
    },
    connectAppleAccount: { __type: 'AppleAccountSession!', __args: { password: 'String' } },
    connectAppleApi: {
      __type: 'ConnectAppleApi!',
      __args: { brandId: 'String!', issuerId: 'String!', keyId: 'String!', privateKey: 'String!' },
    },
    convertTrial: { __type: 'Boolean!', __args: { corporateId: 'ID!' } },
    convertWaitlistToBooking: {
      __type: 'Booking!',
      __args: {
        allowOverCapacity: 'Boolean',
        sessionWaitlistEntryId: 'String!',
        siteId: 'String!',
      },
    },
    correctClientDob: {
      __type: 'ClientAgeVerification!',
      __args: { clientId: 'ID!', dateOfBirth: 'String!', reason: 'String', siteId: 'ID!' },
    },
    createAddOnPriceGroup: {
      __type: 'AddOnPriceGroup!',
      __args: { input: 'CreateAddOnPriceGroupInput!' },
    },
    createAddonInvoice: {
      __type: 'CreateAddonInvoiceResult!',
      __args: { input: 'CreateAddonInvoiceInput!' },
    },
    createAdminAccessGroup: {
      __type: 'AdminAccessGroup!',
      __args: { input: 'CreateAdminAccessGroupInputInput!' },
    },
    createAdminUser: { __type: 'AdminUser!', __args: { input: 'CreateAdminUserInputInput!' } },
    createAggregatorProvider: {
      __type: 'AggregatorProvider!',
      __args: { input: 'AggregatorProviderCreateInput!' },
    },
    createAndSignAgreement: {
      __type: 'ClientAgreement!',
      __args: {
        agreementContent: 'String!',
        agreementMethod: 'AgreementMethod!',
        agreementName: 'String!',
        agreementVersion: 'String',
        clientId: 'ID!',
        ipAddress: 'String',
        pendingCheckout: 'Boolean',
        signatures: '[String!]!',
        siteAgreementTemplateId: 'ID',
        siteId: 'ID!',
        userAgent: 'String',
      },
    },
    createAndStreamKnowledgeArticle: {
      __type: 'AIArticleStreamResult!',
      __args: { input: 'AIArticleStreamInput!' },
    },
    createApiCredential: {
      __type: 'ApiCredentialWithSecret!',
      __args: { input: 'ApiCredentialCreateInput!' },
    },
    createAuditEvent: { __type: 'AuditEvent!', __args: { input: 'CreateAuditEventInputInput!' } },
    createAuditEventBatch: {
      __type: '[AuditEvent!]!',
      __args: { events: '[CreateAuditEventInputInput!]!' },
    },
    createBlockSlot: {
      __type: 'Session!',
      __args: { input: 'BlockSlotCreateInput!', siteId: 'String!' },
    },
    createBooking: {
      __type: 'Booking!',
      __args: { input: 'BookingCreateInput!', siteId: 'String!' },
    },
    createBookingActivityLog: {
      __type: 'BookingActivityLog!',
      __args: { input: 'BookingActivityLogCreateInput!' },
    },
    createBookingDropInInvoice: { __type: 'Invoice!', __args: { bookingId: 'ID!', siteId: 'ID!' } },
    createBookings: {
      __type: '[Booking!]!',
      __args: { allowOverCapacity: 'Boolean', inputs: '[BookingCreateInput!]!', siteId: 'String!' },
    },
    createBrandStoreAssetUploadUrl: {
      __type: 'BrandStoreAssetUploadUrl!',
      __args: {
        assetType: 'BrandStoreAssetType!',
        brandId: 'String!',
        deviceClass: 'String',
        format: 'BrandStoreAssetFormat!',
        locale: 'String!',
        platform: 'BrandPlatform!',
      },
    },
    createBuddyInviteToken: {
      __type: 'BuddyInviteTokenResult!',
      __args: { inviterClientId: 'ID!', siteId: 'ID' },
    },
    createCarouselGroup: {
      __type: 'CmsCarouselGroup!',
      __args: { input: 'CreateCarouselGroupInput!' },
    },
    createCheckIn: {
      __type: 'CheckIn!',
      __args: {
        clientId: 'ID!',
        contactlessCheckInAnswers: 'JSONObject',
        noQuestionnaireCheckin: 'Boolean',
        owedBalanceOverride: 'OwedBalanceOverrideInput',
        siteId: 'ID!',
        source: 'CheckInSource!',
      },
    },
    createCheckoutSession: {
      __type: 'CheckoutSessionResponse!',
      __args: {
        cancelUrl: 'String!',
        corporateId: 'ID!',
        planId: 'String!',
        successUrl: 'String!',
      },
    },
    createClient: {
      __type: 'CreateClientResponse!',
      __args: { input: 'CreateClientInput!', siteId: 'String!' },
    },
    createClientAlert: {
      __type: 'ClientCustomAlertMutationResponse!',
      __args: { input: 'CreateClientAlertInputInput!', siteId: 'String!' },
    },
    createClientBuddy: {
      __type: 'ClientBookingBuddy!',
      __args: { buddyClientId: 'String!', clientId: 'String!', siteId: 'String!' },
    },
    createClientFeesTemplate: {
      __type: 'ClientFeesTemplate!',
      __args: { input: 'FeeTemplateInput!' },
    },
    createClientFile: {
      __type: 'CreateClientFileResponse!',
      __args: { clientId: 'ID!', input: 'CreateClientFileInput!', siteId: 'ID!' },
    },
    createClientNote: {
      __type: 'CreateClientNoteResponse!',
      __args: { input: 'ClientNoteCreateInput!', siteId: 'String!' },
    },
    createClientRelation: {
      __type: 'ClientFamily!',
      __args: { clientId: 'String!', input: 'CreateClientFamilyInput!', siteId: 'String!' },
    },
    createCommissionPlan: {
      __type: 'CommissionPlan!',
      __args: {
        data: 'JSONObject!',
        earnerRole: 'CommissionEarnerRole!',
        name: 'String!',
        siteId: 'ID',
        siteIds: '[ID!]',
      },
    },
    createContentEntry: {
      __type: 'CmsContentEntry!',
      __args: { input: 'CmsContentEntryCreateInput!' },
    },
    createContentSchedule: {
      __type: 'CmsContentSchedule!',
      __args: { input: 'CmsContentScheduleCreateInput!' },
    },
    createCorporate: {
      __type: 'Corporate!',
      __args: {
        accessGroupsIds: '[String!]',
        addons: '[ThemeKey!]',
        businessType: 'BusinessType',
        databaseType: 'DatabaseType',
        hubspot: 'CreateCorporateHubspotInput',
        name: 'String!',
        prospect: 'ProspectInput',
        prospects: '[ProspectInput!]',
        region: 'String',
        seedDemoData: 'Boolean',
        startTrial: 'Boolean',
        tier: 'CorporateTier',
        urlPrefix: 'String!',
        websiteUrl: 'String',
      },
    },
    createCorporateAddOnDraft: {
      __type: 'CorporateAddOn!',
      __args: { input: 'CreateCorporateAddOnDraftInput!' },
    },
    createCorporateCommunicationTemplate: {
      __type: 'CorporateCommunicationTemplate!',
      __args: {
        alias: 'CommunicationTemplateAliases!',
        emailBody: 'String',
        emailCcEmail: 'String',
        emailCcLocation: 'Boolean',
        emailCopyEmployee: 'EmailCopyEmployee',
        emailReplyToEmail: 'String',
        emailReplyToName: 'String',
        emailSendBefore: 'Float',
        emailSendBeforeUnit: 'EmailSendBeforeUnit',
        emailSendCalendarAttachment: 'Boolean',
        emailSendEmailAs: 'EmailSendAs',
        emailSendOnlyToActiveClients: 'Boolean',
        emailSubject: 'String',
        emailUseHapanaLayout: 'Boolean',
        enableEmail: 'Boolean!',
        enablePush: 'Boolean',
        enableSms: 'Boolean',
        ignoredSitesIds: '[ID!]',
        pushMessage: 'String',
        pushTitle: 'String',
        smsMessage: 'String',
        targetedServiceTemplateIds: '[ID!]',
      },
    },
    createCorporateCommunicationTemplateVersion: {
      __type: 'CorporateCommunicationTemplateVersion!',
      __args: {
        assignedSiteGroups: '[String!]',
        assignedSites: '[String!]',
        corporateCommunicationTemplateId: 'String!',
        emailBody: 'String',
        emailCcEmail: 'String',
        emailCcLocation: 'Boolean',
        emailCopyEmployee: 'EmailCopyEmployee',
        emailReplyToEmail: 'String',
        emailReplyToName: 'String',
        emailSendBefore: 'Float',
        emailSendBeforeUnit: 'EmailSendBeforeUnit',
        emailSendCalendarAttachment: 'Boolean',
        emailSendEmailAs: 'EmailSendAs',
        emailSendOnlyToActiveClients: 'Boolean',
        emailSubject: 'String',
        name: 'String!',
        pushMessage: 'String',
        pushTitle: 'String',
        smsMessage: 'String',
        targetedServiceTemplateIds: '[ID!]',
      },
    },
    createCorporateFaq: {
      __type: 'CorporateFaq!',
      __args: { heading: 'String!', response: 'String!', status: 'CorporateFaqStatus' },
    },
    createCorporatePayoutAccount: {
      __type: 'CorporatePayoutAccount!',
      __args: { corporateId: 'ID!', input: 'CorporatePayoutAccountInput!' },
    },
    createCorporateSessionType: {
      __type: 'CorporateSessionType!',
      __args: { input: 'CreateCorporateSessionTypeInput!' },
    },
    createCorporateTaxSetting: {
      __type: 'CorporateTaxSetting!',
      __args: { input: 'CreateCorporateTaxSettingInput!' },
    },
    createCorporateWebhook: {
      __type: 'CorporateWebhook!',
      __args: { corporateId: 'ID!', input: 'CreateCorporateWebhookInputInput!' },
    },
    createCustomProperty: {
      __type: 'CustomProperty!',
      __args: { input: 'CustomPropertyCreateInput!', siteId: 'ID!' },
    },
    createDeepLink: {
      __type: 'DeepLink!',
      __args: {
        campaign: 'String',
        canonicalIdentifier: 'DeepLinkDestination!',
        corporateId: 'String!',
        description: 'String',
        feature: 'String',
        name: 'String!',
        ogDescription: 'String',
        ogImageUrl: 'String',
        ogTitle: 'String',
        tags: '[String!]',
        targetParams: 'JSONObject',
      },
    },
    createDigitalChannel: {
      __type: 'SiteLocation!',
      __args: { input: 'CreateSiteLocationInput!', siteId: 'ID!' },
    },
    createEquipment: {
      __type: 'Equipment!',
      __args: { input: 'CreateEquipmentInput!', siteId: 'String!' },
    },
    createEquipmentAssignment: {
      __type: 'EquipmentAssignment!',
      __args: { input: 'CreateEquipmentAssignmentInput!' },
    },
    createEquipmentRegulation: {
      __type: 'EquipmentRegulation!',
      __args: { input: 'CreateEquipmentRegulationInput!' },
    },
    createExternalMediaAsset: {
      __type: 'CmsContentMedia!',
      __args: { input: 'CreateExternalMediaAssetInputInput!' },
    },
    createFamily: { __type: 'Family!', __args: { name: 'String', siteId: 'ID!' } },
    createFamilyForClient: {
      __type: 'Family!',
      __args: { clientId: 'ID!', name: 'String', siteId: 'ID!' },
    },
    createFamilyInviteLink: {
      __type: 'FamilyInviteLink!',
      __args: { canBook: 'Boolean!', role: 'FamilyMemberRole!', siteId: 'ID!' },
    },
    createFeeConfiguration: {
      __type: 'FeeConfiguration!',
      __args: {
        accountType: 'FeeAccountType!',
        description: 'String!',
        enabled: 'Boolean!',
        eventType: 'FeeEventType!',
        name: 'String!',
        paymentGateway: 'PaymentGateway',
        rate: 'Numeric!',
        rateType: 'FeeRateType!',
        webhookEndpoint: 'String',
        webhookType: 'String',
      },
    },
    createFormHandoff: {
      __type: 'FormHandoff!',
      __args: {
        channel: 'FormHandoffChannel!',
        clientId: 'String!',
        deviceTokenId: 'String',
        formSubmissionId: 'String',
        idempotencyKey: 'String!',
        requiredBefore: 'FormRequiredBefore',
        siteFormId: 'String',
        siteId: 'String!',
      },
    },
    createGiftCardDesign: {
      __type: 'GiftCardDesign!',
      __args: { input: 'GiftCardDesignCreateInput!' },
    },
    createGiftCardExpiryRule: {
      __type: 'GiftCardExpiryRuleRecord!',
      __args: {
        countryId: 'String!',
        disclosureRequired: 'Boolean!',
        effectiveFrom: 'String!',
        expiryPolicy: 'GiftCardExpiryPolicy!',
        legalCitation: 'String',
        maximumTermMonths: 'Float',
        minimumTermMonths: 'Float',
        notes: 'String',
        sourceUrl: 'String',
        zoneId: 'String',
      },
    },
    createGiftCardTemplate: {
      __type: 'GiftCardTemplate!',
      __args: { input: 'GiftCardTemplateCreateInput!', siteId: 'ID!' },
    },
    createGoal: { __type: 'CmsGoal!', __args: { input: 'CreateGoalInput!' } },
    createGrowHq: { __type: 'GrowHq!', __args: { code: 'String!', name: 'String!' } },
    createGrowSiteLocation: {
      __type: 'CreateSiteLocationResponse!',
      __args: { hqId: 'String!', siteId: 'String!' },
    },
    createHapanaFeesTemplate: {
      __type: 'HapanaFeesTemplate!',
      __args: { failedPaymentFeeScope: 'FailedPaymentFeeScope', input: 'FeeTemplateInput!' },
    },
    createImpersonationSession: {
      __type: 'AdminUserImpersonationSessionResponse!',
      __args: { input: 'CreateAdminUserImpersonationSessionInput!' },
    },
    createInvoice: {
      __type: '[Invoice!]!',
      __args: { input: 'CreateInvoiceInputInput!', siteId: 'ID!' },
    },
    createInvoiceAgreementSigningLinks: {
      __type: 'InvoiceAgreementSigningLinksResult!',
      __args: { invoiceId: 'ID!', siteId: 'ID!' },
    },
    createKnowledgeArticle: {
      __type: 'KnowledgeArticle!',
      __args: { input: 'KnowledgeArticleCreateInput!' },
    },
    createKnowledgeArticleCategory: {
      __type: 'KnowledgeArticleCategory!',
      __args: { input: 'KnowledgeArticleCategoryCreateInput!' },
    },
    createLeaderboardConfig: {
      __type: 'LeaderboardConfig!',
      __args: { input: 'CreateLeaderboardConfigInputInput!' },
    },
    createManualRefund: {
      __type: 'Refund!',
      __args: { input: 'CreateManualRefundInputInput!', siteId: 'ID!' },
    },
    createMediaFolder: { __type: 'MediaFolderChild!', __args: { path: 'String!' } },
    createMemberMovementRun: {
      __type: 'MemberMovementRun!',
      __args: { input: 'CreateMemberMovementRunInput!' },
    },
    createMemberPreviewSession: {
      __type: 'MemberPreviewSessionResult!',
      __args: { corporateId: 'ID!' },
    },
    createMobileAppForCorporate: { __type: 'BrandIdentity', __args: { corporateId: 'String!' } },
    createMultipleReservations: {
      __type: 'MultipleReservationResult!',
      __args: { input: 'MultipleReservationInput!', siteId: 'String!' },
    },
    createMultipleStaffSessionAssignments: {
      __type: '[StaffSessionAssignment!]!',
      __args: { assignments: '[StaffSessionAssignmentCreateInput!]!' },
    },
    createMyPendingItemsLink: {
      __type: 'MyPendingItemsLink!',
      __args: { forClientId: 'ID', siteId: 'ID!' },
    },
    createOrganisation: {
      __type: 'CreateClientResponse!',
      __args: { input: 'CreateOrganisationInput!', siteId: 'String!' },
    },
    createPaperScanUpload: {
      __type: 'PaperScanUploadTicket!',
      __args: { clientId: 'ID!', siteId: 'ID!' },
    },
    createPayments: {
      __type: '[Payment!]!',
      __args: {
        input: '[CreatePaymentsInputInput!]!',
        invoiceId: 'ID!',
        promoCodeUsages: '[PromoCodeUsageInput!]!',
        siteId: 'ID!',
      },
    },
    createPendingItemsHandoff: {
      __type: 'PendingItemsHandoff!',
      __args: {
        channel: 'PendingItemsChannel!',
        clientId: 'ID!',
        deviceTokenId: 'ID',
        guardianClientId: 'ID',
        guardianIdChecked: 'Boolean',
        idempotencyKey: 'String!',
        mobileOverride: 'String',
        recipientCapacity: 'SignerCapacity!',
        siteId: 'ID!',
        smsConsentAttested: 'Boolean',
      },
    },
    createPosCategory: {
      __type: 'CreatePosCategoryResponse!',
      __args: { input: 'CreatePosCategoryInput!', siteId: 'ID!' },
    },
    createPosProduct: {
      __type: 'CreatePosProductResponse!',
      __args: { input: 'CreatePosProductInput!', siteId: 'ID!' },
    },
    createPrivateBooking: {
      __type: 'Booking!',
      __args: { input: 'PrivateBookingCreateInput!', siteId: 'String!' },
    },
    createPromoCode: {
      __type: 'PromoCode!',
      __args: { input: 'PromoCodeCreateInput!', siteId: 'ID!' },
    },
    createRebateTemplate: { __type: 'RebateTemplate!', __args: { input: 'RebateTemplateInput!' } },
    createRecurringSession: {
      __type: 'RecurringSession!',
      __args: { input: 'RecurringSessionCreateInput!' },
    },
    createRecurringSessionFromTemplate: {
      __type: 'RecurringSession!',
      __args: { input: 'RecurringSessionCreateFromTemplateInput!' },
    },
    createRegion: { __type: 'Regions!', __args: { input: 'CreateRegionInputInput!' } },
    createReleaseNote: { __type: 'ReleaseNote!', __args: { input: 'ReleaseNoteCreateInput!' } },
    createRoomCustomPropertyRequirements: {
      __type: '[SiteRoomResourceTemplateProperty!]!',
      __args: {
        inputs: '[CreateSiteRoomResourceTemplatePropertyInput!]!',
        roomResourceTemplateId: 'String!',
        siteId: 'String!',
      },
    },
    createRoomResourceTemplate: {
      __type: 'SiteRoomResourceTemplateResponse!',
      __args: { input: 'CreateSiteRoomResourceTemplateInput!', siteId: 'String!' },
    },
    createRoyaltiesAndFeesTemplate: {
      __type: 'RoyaltiesAndFeesTemplate!',
      __args: { input: 'RoyaltiesAndFeesTemplateInput!' },
    },
    createSavedReport: {
      __type: 'SavedReport!',
      __args: { input: 'CreateSavedReportInputInput!' },
    },
    createSavedReportCategory: {
      __type: 'CreateSavedReportCategory!',
      __args: { name: 'String!', siteId: 'String' },
    },
    createScheduledPushSend: {
      __type: 'ScheduledPushSend!',
      __args: { input: 'CreateScheduledPushSendInput!' },
    },
    createServiceTemplate: {
      __type: 'ServiceTemplate!',
      __args: {
        copyAddOnPricingFromServiceTemplateId: 'ID',
        input: 'CreateServiceTemplateInputInput!',
      },
    },
    createServiceTemplateCategory: {
      __type: 'CreateServiceTemplateCategoryResponse!',
      __args: { input: 'CreateServiceTemplateCategoryInput!', siteId: 'String!' },
    },
    createServiceTemplateSessionTypeAddOn: {
      __type: 'ServiceTemplateSessionTypeAddOn!',
      __args: { input: 'CreateServiceTemplateSessionTypeAddOnInput!' },
    },
    createSessionCustom: {
      __type: 'Session!',
      __args: { input: 'SessionCreateCustomInput!', siteId: 'String!' },
    },
    createSessionFilter: {
      __type: 'SessionFilter!',
      __args: { input: 'SessionFilterCreateInput!', siteId: 'String!' },
    },
    createSessionFromTemplate: {
      __type: 'Session!',
      __args: { input: 'SessionCreateFromTemplateInput!', siteId: 'String!' },
    },
    createSessionTemplate: {
      __type: 'SessionTemplate!',
      __args: { input: 'SessionTemplateInput!', siteId: 'String!' },
    },
    createSessionZoomMeeting: { __type: 'Session!', __args: { id: 'String!', siteId: 'String!' } },
    createSharedCreditInviteToken: {
      __type: 'SharedCreditInviteTokenResult!',
      __args: { input: 'CreateSharedCreditInviteInput!' },
    },
    createSite: { __type: 'Site!', __args: { input: 'CreateSiteInputInput!' } },
    createSiteAccessPoint: {
      __type: 'SiteAccessPoint!',
      __args: { input: 'SiteAccessPointCreateInput!', siteId: 'String!' },
    },
    createSiteAccessZone: {
      __type: 'SiteAccessZone!',
      __args: { input: 'SiteAccessZoneCreateInput!' },
    },
    createSiteAccountCode: {
      __type: 'SiteAccountCode!',
      __args: { input: 'CreateSiteAccountCodeInput!', siteId: 'ID!' },
    },
    createSiteAgreementTemplate: {
      __type: 'SiteAgreementTemplate!',
      __args: {
        content: 'String!',
        effectiveDate: 'String',
        name: 'String!',
        requiresSignature: 'Boolean',
        siteId: 'ID!',
        templateUrl: 'String!',
        type: 'AgreementType!',
        validityDays: 'Float',
        version: 'String!',
      },
    },
    createSiteAlert: { __type: 'SiteAlertListItem!', __args: { input: 'CreateSiteAlertInput!' } },
    createSiteForm: {
      __type: 'SiteForm!',
      __args: { input: 'CreateSiteFormInputInput!', siteId: 'ID!' },
    },
    createSiteFormFromTemplate: {
      __type: 'SaveScoredSiteFormResult!',
      __args: { siteId: 'ID!', templateKey: 'SiteFormTemplateKey!' },
    },
    createSiteGroup: { __type: 'SiteGroup!', __args: { input: 'CreateSiteGroupInputInput!' } },
    createSiteLocation: {
      __type: 'SiteLocation!',
      __args: { input: 'CreateSiteLocationInput!', siteId: 'ID!' },
    },
    createSiteLocationRoom: {
      __type: 'SiteLocationRoom!',
      __args: { input: 'CreateSiteLocationRoomInput!', siteId: 'ID!', siteLocationId: 'ID!' },
    },
    createSitePayrollTier: {
      __type: 'CreateSitePayrollTier!',
      __args: { input: 'CreateSitePayrollTierInputInput!', siteId: 'ID!' },
    },
    createSitePayrollTierConfiguration: {
      __type: 'CreateSitePayrollTierConfiguration!',
      __args: {
        input: 'CreateSitePayrollTierConfigurationInputInput!',
        siteId: 'ID!',
        sitePayrollTierId: 'ID!',
      },
    },
    createSitePolicy: {
      __type: 'SitePolicy!',
      __args: { input: 'CreateSitePolicyInputInput!', siteId: 'String!' },
    },
    createSiteSessionType: {
      __type: 'SiteSessionType!',
      __args: { input: 'SiteSessionTypeInput!', siteId: 'String!' },
    },
    createSiteSettingsCustomizationColor: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'CreateSiteSettingsCustomizationColorInputInput!', siteId: 'ID!' },
    },
    createSiteSupplier: {
      __type: 'CreateSiteSupplierResponse!',
      __args: { input: 'CreateSiteSupplierInput!', siteId: 'String!' },
    },
    createSiteWebhook: {
      __type: 'CreateSiteWebhook!',
      __args: { input: 'CreateSiteWebhookInputInput!', siteId: 'String!' },
    },
    createSmsPackage: { __type: 'SmsPackage!', __args: { countryId: 'ID!' } },
    createSoapNote: {
      __type: 'CreateSoapNoteResponse!',
      __args: { input: 'SoapNoteCreateInput!', siteId: 'String!' },
    },
    createStaffAccessPolicy: {
      __type: 'StaffAccessPolicy!',
      __args: { input: 'CreateStaffAccessPolicyInputInput!' },
    },
    createStaffAllowedNetwork: {
      __type: 'StaffAllowedNetwork!',
      __args: { input: 'CreateStaffAllowedNetworkInputInput!' },
    },
    createStaffSessionAssignment: {
      __type: 'StaffSessionAssignment!',
      __args: { input: 'StaffSessionAssignmentCreateInput!' },
    },
    createStaffUser: { __type: 'StaffUser!', __args: { input: 'CreateStaffUserInputInput!' } },
    createStaffUserSmartGroup: {
      __type: 'StaffUserSmartGroup!',
      __args: {
        input: 'CreateStaffUserSmartGroupInputInput!',
        siteId: 'String!',
        staffUserId: 'String!',
      },
    },
    createStripeAccountSession: {
      __type: 'CreateStripeAccountSession!',
      __args: { siteId: 'ID!' },
    },
    createStripeCapitalSession: {
      __type: 'CreateStripeAccountSession!',
      __args: { siteId: 'ID!' },
    },
    createStripeTerminalHardwareSession: {
      __type: 'CreateStripeAccountSession!',
      __args: { siteId: 'ID!' },
    },
    createSupportTicket: {
      __type: 'SupportTicket!',
      __args: { input: 'CreateSupportTicketInput!' },
    },
    createTanningCheckIn: {
      __type: 'CheckIn!',
      __args: {
        clientId: 'ID!',
        owedBalanceOverride: 'OwedBalanceOverrideInput',
        siteId: 'ID!',
        source: 'CheckInSource!',
      },
    },
    createTaxSetting: {
      __type: 'TaxSetting!',
      __args: { input: 'CreateTaxSettingInputInput!', siteId: 'ID!' },
    },
    createTerminalHandoffRequest: {
      __type: 'TerminalHandoffRequest!',
      __args: { input: 'CreateTerminalHandoffRequestInput!' },
    },
    createTestMember: {
      __type: 'TestMemberWithCredentials!',
      __args: { firstName: 'String', lastName: 'String', siteId: 'String' },
    },
    createThirdPartyIntegration: {
      __type: 'ThirdPartyIntegrationWithKeys!',
      __args: { input: 'ThirdPartyIntegrationCreateInput!' },
    },
    createThirdPartyIntegrationKey: {
      __type: 'ThirdPartyIntegrationKey!',
      __args: { input: 'ThirdPartyIntegrationKeyCreateInput!', thirdPartyIntegrationId: 'ID!' },
    },
    deactivateSiteAccountCode: {
      __type: 'SiteAccountCode!',
      __args: { accountCodeId: 'ID!', siteId: 'ID!' },
    },
    declineBookingBuddy: {
      __type: 'BookingBuddyMutationResult!',
      __args: { buddyClientId: 'ID!', clientId: 'ID!' },
    },
    declineBookingRequest: { __type: 'Booking!', __args: { bookingId: 'String!' } },
    declineCoverOffer: {
      __type: 'CoverRequestView!',
      __args: { coverRequestId: 'ID!', siteId: 'ID!' },
    },
    declineFamilyInvite: { __type: 'Boolean!', __args: { inviteToken: 'String!' } },
    declineIncomingMovement: {
      __type: 'IncomingApprovalDecisionResult!',
      __args: { input: 'IncomingApprovalDecisionInput!' },
    },
    declineSharedCredits: {
      __type: 'ServiceCreditShareMutationResult!',
      __args: { input: 'DeclineSharedCreditsInput!' },
    },
    deferSaleFollowUp: {
      __type: 'Boolean!',
      __args: { input: 'SaleFollowUpInput!', invoiceId: 'ID!', siteId: 'ID!' },
    },
    deleteAddOnPriceGroup: { __type: 'Boolean!', __args: { addOnPriceGroupId: 'ID!' } },
    deleteAdminAccessGroup: { __type: 'AdminAccessGroup!', __args: { id: 'ID!' } },
    deleteAggregatorProvider: {
      __type: 'DeleteAggregatorProvider!',
      __args: { aggregatorProviderId: 'String!' },
    },
    deleteBlockingReason: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { id: 'String!', siteId: 'ID!' },
    },
    deleteBooking: { __type: 'Boolean!', __args: { id: 'String!' } },
    deleteCancellationReason: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { id: 'String!', siteId: 'ID!' },
    },
    deleteCancelledSessionsByRecurrences: {
      __type: 'Float!',
      __args: { recurringSessionsIds: '[String!]!', siteId: 'String!' },
    },
    deleteCarouselGroup: { __type: 'Boolean!', __args: { carouselGroupId: 'ID!' } },
    deleteCheckIn: { __type: 'Boolean!', __args: { checkInId: 'String!' } },
    deleteClient: { __type: 'DeleteClientResponse!', __args: { id: 'String!', siteId: 'String!' } },
    deleteClientAlert: {
      __type: 'ClientCustomAlertMutationResponse!',
      __args: { alertId: 'String!', siteId: 'String!' },
    },
    deleteClientBuddy: {
      __type: 'DeleteClientBuddy!',
      __args: { buddyClientId: 'String!', clientId: 'String!', siteId: 'String!' },
    },
    deleteClientCustomPropertyValues: {
      __type: 'DeleteClientCustomPropertyValuesResponse!',
      __args: { clientId: 'String!', siteId: 'String!' },
    },
    deleteClientFeesTemplate: { __type: 'ClientFeesTemplate!', __args: { id: 'String!' } },
    deleteClientFile: {
      __type: 'DeleteClientFileResponse!',
      __args: { clientId: 'String!', fileId: 'String!', siteId: 'String!' },
    },
    deleteClientNote: {
      __type: 'DeleteClientNoteResponse!',
      __args: { clientId: 'String!', noteId: 'String!', siteId: 'String!' },
    },
    deleteClientProfileImage: { __type: 'Boolean!', __args: { clientId: 'ID!' } },
    deleteClientRelation: {
      __type: 'DeleteClientRelation!',
      __args: { clientId: 'String!', familyMemberClientId: 'String!', siteId: 'String!' },
    },
    deleteContentEntry: { __type: 'Boolean!', __args: { contentEntryId: 'ID!' } },
    deleteCorporateAddOn: {
      __type: 'CorporateAddOn!',
      __args: { input: 'CorporateServiceTemplateVersionInput!' },
    },
    deleteCorporateCommunicationTemplateVersion: {
      __type: 'Boolean!',
      __args: {
        corporateCommunicationTemplateId: 'String!',
        corporateCommunicationTemplateVersionId: 'String!',
      },
    },
    deleteCorporateFaq: { __type: 'CorporateFaq!', __args: { corporateFaqId: 'ID!' } },
    deleteCorporatePayoutAccount: { __type: 'Boolean!', __args: { corporateId: 'ID!', id: 'ID!' } },
    deleteCorporateSessionType: {
      __type: 'CorporateSessionType!',
      __args: { corporateSessionTypeId: 'ID!', withdrawMode: 'CorporateSessionTypeWithdrawMode!' },
    },
    deleteCorporateTaxSetting: {
      __type: 'CorporateTaxSetting!',
      __args: { corporateTaxSettingId: 'ID!' },
    },
    deleteCorporateWebhook: {
      __type: 'Boolean!',
      __args: { corporateId: 'ID!', webhookId: 'ID!' },
    },
    deleteCustomFont: {
      __type: 'UpdateMemberExperienceFonts!',
      __args: { corporateId: 'String!', fontName: 'String!' },
    },
    deleteCustomProperty: { __type: 'CustomProperty!', __args: { id: 'String!', siteId: 'ID!' } },
    deleteCustomPropertyAlert: {
      __type: 'Boolean!',
      __args: { alertId: 'String!', propertyId: 'String!', siteId: 'ID!' },
    },
    deleteDeepLink: {
      __type: 'DeleteDeepLink!',
      __args: { corporateId: 'String!', deepLinkId: 'String!' },
    },
    deleteDigitalChannel: {
      __type: 'SiteLocation!',
      __args: { siteId: 'ID!', siteLocationId: 'ID!' },
    },
    deleteEquipment: { __type: 'Boolean!', __args: { equipmentId: 'String!' } },
    deleteFormSubmission: {
      __type: 'DeleteFormSubmissionResponse!',
      __args: { siteId: 'String!', submissionId: 'String!' },
    },
    deleteGiftCardDesign: { __type: 'GiftCardDesign!', __args: { giftCardDesignId: 'ID!' } },
    deleteGiftCardExpiryRule: {
      __type: 'DeleteGiftCardExpiryRule!',
      __args: { giftCardExpiryRuleId: 'ID!' },
    },
    deleteGoal: { __type: 'Boolean!', __args: { goalId: 'ID!' } },
    deleteGrowHq: { __type: 'GrowHq!', __args: { growHqId: 'String!' } },
    deleteHapanaFeesTemplate: { __type: 'HapanaFeesTemplate!', __args: { id: 'String!' } },
    deleteKnowledgeArticle: { __type: 'Boolean!', __args: { knowledgeArticleId: 'ID!' } },
    deleteKnowledgeArticleCategory: {
      __type: 'Boolean!',
      __args: { knowledgeArticleCategoryId: 'ID!' },
    },
    deleteLeaderboardConfig: { __type: 'Boolean!', __args: { leaderboardConfigId: 'String!' } },
    deleteMediaAsset: { __type: 'Boolean!', __args: { contentMediaId: 'ID!' } },
    deleteMediaFolder: { __type: 'Boolean!', __args: { path: 'String!' } },
    deleteMemberMovementRun: { __type: 'MemberMovementDeleteResult!', __args: { runId: 'ID!' } },
    deleteMigration: { __type: 'DeleteMigration!', __args: { migrationId: 'ID!' } },
    deleteMobileAppBranding: {
      __type: 'DeleteMobileAppBranding!',
      __args: { corporateId: 'String!' },
    },
    deleteMobileAppChannels: {
      __type: 'DeleteMobileAppChannels!',
      __args: { corporateId: 'String!' },
    },
    deleteMobileAppProfile: {
      __type: 'DeleteMobileAppProfile!',
      __args: { corporateId: 'String!' },
    },
    deleteMovementTemplateMapping: {
      __type: 'Boolean!',
      __args: { memberMovementTemplateMappingId: 'ID!' },
    },
    deleteMyProfileImage: { __type: 'Boolean!' },
    deleteOrphanedSandbox: { __type: 'String!', __args: { sandboxDbId: 'String!' } },
    deletePosCategory: {
      __type: 'DeletePosCategoryResponse!',
      __args: { posCategoryId: 'ID!', siteId: 'ID!' },
    },
    deletePosProductVariable: {
      __type: 'DeletePosProductVariableResponse!',
      __args: { posProductId: 'ID!', posProductVariableId: 'ID!', siteId: 'ID!' },
    },
    deleteProfileImage: { __type: 'Boolean!', __args: { staffUserId: 'ID!' } },
    deleteRebateTemplate: { __type: 'Boolean!', __args: { id: 'ID!' } },
    deleteRefundReason: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { id: 'String!', siteId: 'ID!' },
    },
    deleteRegion: { __type: 'Regions!', __args: { regionId: 'ID!' } },
    deleteReleaseNote: { __type: 'Boolean!', __args: { releaseNoteId: 'ID!' } },
    deleteRoomCustomPropertyRequirement: {
      __type: 'SiteRoomResourceTemplateProperty!',
      __args: {
        roomResourceTemplateId: 'String!',
        siteId: 'String!',
        siteRoomResourceTemplatePropertyId: 'String!',
      },
    },
    deleteRoomResourceTemplate: {
      __type: 'SiteRoomResourceTemplateResponse!',
      __args: { id: 'String!', siteId: 'String!' },
    },
    deleteRoyaltiesAndFeesTemplate: { __type: 'Boolean!', __args: { id: 'ID!' } },
    deleteSandbox: { __type: 'String!', __args: { brandSlug: 'String!' } },
    deleteSavedReport: { __type: 'DeleteSavedReport!', __args: { savedReportId: 'String!' } },
    deleteSavedReportCategory: {
      __type: 'DeleteSavedReport!',
      __args: { savedReportCategoryId: 'String!' },
    },
    deleteServiceTemplateCategory: {
      __type: 'DeleteServiceTemplateCategoryResponse!',
      __args: { serviceTemplateCategoryId: 'String!', siteId: 'String!' },
    },
    deleteServiceTemplateSessionTypeAddOn: {
      __type: 'Boolean!',
      __args: { serviceTemplateSessionTypeAddOnId: 'ID!' },
    },
    deleteSession: {
      __type: 'Boolean!',
      __args: { id: 'String!', scope: 'RecurringSessionEditScope', siteId: 'String!' },
    },
    deleteSessionFeedback: {
      __type: 'DeleteSessionFeedback!',
      __args: { sessionFeedbackId: 'ID!', siteId: 'ID!' },
    },
    deleteSessionFeedbackQuestion: {
      __type: 'SessionFeedbackQuestionDeleteResponse!',
      __args: { questionId: 'ID!', siteId: 'ID!' },
    },
    deleteSessionFilter: {
      __type: 'Boolean!',
      __args: { sessionFilterId: 'String!', siteId: 'String!' },
    },
    deleteSessionOccurrences: {
      __type: 'DeleteSessionOccurrencesResult!',
      __args: { input: 'DeleteSessionOccurrencesInput!' },
    },
    deleteSessionTemplate: {
      __type: 'SessionTemplate!',
      __args: { id: 'String!', siteId: 'String!' },
    },
    deleteSite: { __type: 'Site!', __args: { siteId: 'ID!' } },
    deleteSiteAccessPoint: {
      __type: 'SiteAccessPoint!',
      __args: { siteAccessPointId: 'String!', siteId: 'String!' },
    },
    deleteSiteAccessZone: {
      __type: 'SiteAccessZone!',
      __args: { siteAccessZoneId: 'String!', siteId: 'String!' },
    },
    deleteSiteAlert: {
      __type: 'SiteAlertListItem!',
      __args: { siteAlertId: 'String!', siteId: 'String!' },
    },
    deleteSiteForm: { __type: 'SiteForm!', __args: { id: 'String!', siteId: 'ID!' } },
    deleteSiteFormQuestion: {
      __type: 'SiteFormDeleteResponse!',
      __args: { questionId: 'String!', siteFormId: 'String!', siteId: 'ID!' },
    },
    deleteSiteGroup: {
      __type: 'SiteGroup!',
      __args: {
        acknowledgedWithdrawals: '[BrandServiceTemplateWithdrawalAcknowledgementInput!]',
        siteGroupId: 'ID!',
      },
    },
    deleteSiteLocation: { __type: 'Boolean!', __args: { siteId: 'ID!', siteLocationId: 'ID!' } },
    deleteSiteLocationRoom: {
      __type: 'SiteLocationRoom!',
      __args: { siteId: 'ID!', siteLocationId: 'ID!', siteLocationRoomId: 'ID!' },
    },
    deleteSitePayrollTierConfiguration: {
      __type: 'CreateSitePayrollTierConfiguration!',
      __args: { siteId: 'ID!', sitePayrollTierConfigurationId: 'ID!', sitePayrollTierId: 'ID!' },
    },
    deleteSitePolicy: { __type: 'SitePolicy!', __args: { id: 'String!', siteId: 'String!' } },
    deleteSiteSessionType: {
      __type: 'SiteSessionType!',
      __args: { id: 'String!', siteId: 'String!' },
    },
    deleteSiteSettingsCustomizationColor: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { colorId: 'String!', siteId: 'ID!' },
    },
    deleteSiteSupplier: {
      __type: 'DeleteSiteSupplierResponse!',
      __args: { siteId: 'String!', siteSupplierId: 'String!' },
    },
    deleteSiteTerminalReader: {
      __type: 'Boolean!',
      __args: { siteId: 'ID!', siteTerminalReaderId: 'ID!' },
    },
    deleteSiteWebhook: { __type: 'Boolean!', __args: { siteId: 'String!', webhookId: 'String!' } },
    deleteSoapNote: {
      __type: 'DeleteSoapNoteResponse!',
      __args: { siteId: 'String!', soapNoteId: 'String!' },
    },
    deleteStaffAccessPolicy: {
      __type: 'StaffAccessPolicy!',
      __args: { staffAccessPolicyId: 'ID!' },
    },
    deleteStaffAllowedNetwork: {
      __type: 'StaffAllowedNetwork!',
      __args: { staffAllowedNetworkId: 'ID!' },
    },
    deleteStaffSessionAssignment: {
      __type: 'Boolean!',
      __args: { staffSessionAssignmentId: 'ID!' },
    },
    deleteStaffSessionAssignmentsBySession: { __type: 'Boolean!', __args: { sessionId: 'ID!' } },
    deleteStaffUserSmartGroup: {
      __type: 'Boolean!',
      __args: { siteId: 'String!', staffUserId: 'String!', staffUserSmartGroupId: 'String!' },
    },
    deleteSuspensionReason: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { id: 'String!', siteId: 'ID!' },
    },
    deleteTaxSetting: { __type: 'TaxSetting!', __args: { siteId: 'ID!', taxSettingId: 'ID!' } },
    deleteTestMember: { __type: 'DeleteTestMember!', __args: { clientId: 'String!' } },
    deleteThirdPartyIntegration: {
      __type: 'DeleteThirdPartyIntegration!',
      __args: { thirdPartyIntegrationId: 'ID!' },
    },
    deleteThirdPartyIntegrationKey: {
      __type: 'DeleteThirdPartyIntegrationKey!',
      __args: { thirdPartyIntegrationId: 'ID!', thirdPartyIntegrationKeyId: 'ID!' },
    },
    deleteVideo: { __type: 'Boolean!', __args: { videoId: 'ID!' } },
    deleteWellhubProductMapping: {
      __type: 'Boolean!',
      __args: { siteId: 'ID!', siteSessionTypeId: 'ID!' },
    },
    detectAppStoreRecord: { __type: '[BrandSetupStepView!]!', __args: { brandId: 'String!' } },
    directUploadUrl: {
      __type: 'DirectUploadUrlResponse!',
      __args: { input: 'DirectUploadUrlInput!' },
    },
    disableContentLibrary: {
      __type: 'ContentLibraryDisableResult!',
      __args: { corporateId: 'ID!' },
    },
    disableEquipment: { __type: 'Equipment!', __args: { equipmentId: 'String!' } },
    disableSiteTheme: {
      __type: 'Boolean!',
      __args: { corporateId: 'ID!', siteId: 'ID!', themeSlug: 'ThemeKey!' },
    },
    disconnectZoom: { __type: 'Site!', __args: { siteId: 'ID!' } },
    dismissBlockedMemberMovement: {
      __type: 'DismissBlockedMovementResult!',
      __args: { input: 'DismissBlockedMovementInput!' },
    },
    dismissIncomingMovement: {
      __type: 'MemberMovementListItem!',
      __args: { input: 'DismissIncomingMovementInput!' },
    },
    downloadBigQueryExport: {
      __type: 'DownloadBigQueryExportResponse!',
      __args: { input: 'DownloadBigQueryExportInput!' },
    },
    downloadPolicyEvidenceExport: {
      __type: 'PolicyEvidenceExportDownload!',
      __args: { exportId: 'ID!', siteId: 'ID!' },
    },
    duplicateCommissionPlan: {
      __type: 'CommissionPlan!',
      __args: { commissionPlanId: 'ID!', name: 'String', siteId: 'ID' },
    },
    duplicateContentEntry: { __type: 'CmsContentEntry!', __args: { contentEntryId: 'ID!' } },
    duplicateCorporateAddOn: {
      __type: 'CorporateAddOn!',
      __args: { input: 'DuplicateCorporateServiceTemplateInput!' },
    },
    duplicateLeaderboard: {
      __type: 'LeaderboardConfig!',
      __args: { leaderboardConfigId: 'String!' },
    },
    duplicatePromoCode: {
      __type: 'PromoCode!',
      __args: { input: 'PromoCodeDuplicateInput!', promoCodeId: 'ID!' },
    },
    duplicateSavedReport: {
      __type: 'SavedReport!',
      __args: { name: 'String!', savedReportId: 'String!' },
    },
    editClientRelation: {
      __type: 'ClientRelationMutationResult!',
      __args: {
        clientId: 'ID!',
        counterpartyClientId: 'ID!',
        newCounterpartyClientId: 'ID!',
        newType: 'ClientRelationType!',
        siteId: 'ID!',
        status: 'ClientRelationStatus',
        type: 'ClientRelationType!',
      },
    },
    egymBackfill: { __type: 'EgymBackfillResult!', __args: { siteId: 'ID!' } },
    emailFormSubmissionCopy: {
      __type: 'EmailFormSubmissionCopyResponse!',
      __args: { formSubmissionId: 'String!', siteId: 'String!' },
    },
    emailMyFormCopy: {
      __type: 'EmailFormSubmissionCopyResponse!',
      __args: { formSubmissionId: 'String!' },
    },
    emergencyStopMemberMovement: {
      __type: 'EmergencyStopMemberMovementResult!',
      __args: { corporateId: 'ID!' },
    },
    enableContentLibrary: {
      __type: 'ContentLibraryStatus!',
      __args: {
        allLocations: 'Boolean',
        categories: '[String!]',
        corporateId: 'ID!',
        siteIds: '[ID!]!',
      },
    },
    enableCorporateWebhook: {
      __type: 'CorporateWebhook!',
      __args: { corporateId: 'ID!', webhookId: 'ID!' },
    },
    enableEquipment: { __type: 'Equipment!', __args: { equipmentId: 'String!' } },
    enableSiteTheme: {
      __type: 'SiteThemeSubscription!',
      __args: { corporateId: 'ID!', siteId: 'ID!', themeSlug: 'ThemeKey!' },
    },
    enableSiteWebhook: {
      __type: 'SiteWebhook!',
      __args: { siteId: 'String!', webhookId: 'String!' },
    },
    endCommissionAssignment: {
      __type: 'CommissionAssignment!',
      __args: { commissionAssignmentId: 'ID!', endDate: 'String!' },
    },
    endSiteAlert: {
      __type: 'SiteAlertListItem!',
      __args: { siteAlertId: 'String!', siteId: 'String!' },
    },
    endSupportChat: { __type: 'SupportChat!', __args: { supportChatId: 'ID!' } },
    ensureMainSiteAccessZone: { __type: 'SiteAccessZone!', __args: { siteId: 'String!' } },
    executeBrandStoreOperation: {
      __type: 'BrandStoreOperationsOverview!',
      __args: {
        action: 'BrandStoreOperationAction!',
        brandId: 'String!',
        confirmLiveChange: 'Boolean',
        confirmation: 'String',
        platform: 'BrandPlatform!',
      },
    },
    executeMemberMovementManualTransfer: {
      __type: 'MemberMovementManualTransferResult!',
      __args: { input: 'ExecuteMemberMovementManualTransferInput!' },
    },
    expireTrial: { __type: 'Boolean!', __args: { corporateId: 'ID!' } },
    exportReport: {
      __type: 'ExportJobStatusResult!',
      __args: { input: 'ExportReportInputInput!' },
    },
    exportSettlement: {
      __type: 'ExportSettlementResponse!',
      __args: { input: 'ExportSettlementInput!' },
    },
    extendService: { __type: 'ExtendServiceResult!', __args: { input: 'ExtendServiceInput!' } },
    extendTrial: { __type: 'Boolean!', __args: { additionalDays: 'Float!', corporateId: 'ID!' } },
    failStalledMemberMovementRun: { __type: 'MemberMovementRun!', __args: { runId: 'ID!' } },
    finaliseInvoiceAfterPublicSigning: {
      __type: 'FinalisePublicSigningResult!',
      __args: {
        accountCreditsUsed: 'String',
        agreementId: 'ID!',
        canCompleteCardChallenge: 'Boolean',
        clientId: 'ID!',
        clientPaymentMethodId: 'ID!',
        invoiceId: 'ID!',
        paymentMethodType: 'PublicSigningPaymentMethodType!',
        siteAgreementTemplateId: 'ID!',
        siteId: 'ID!',
        siteTimezone: 'String!',
        useCredits: 'Boolean',
      },
    },
    finalizeCustomFont: {
      __type: 'FinalizeCustomFont!',
      __args: {
        corporateId: 'ID!',
        font: 'FinalizeCustomFontFontInput!',
        isHeadingFont: 'Boolean!',
        userId: 'String!',
      },
    },
    finalizeFormSignatureUpload: {
      __type: 'FormSignatureAsset!',
      __args: { signatureImageBase64: 'String', uploadId: 'String!' },
    },
    generateBrandingImageUploadUrl: {
      __type: 'GenerateFileUploadUrlResponse!',
      __args: { corporateId: 'String!', fieldName: 'BrandingImageFieldName!', format: 'String!' },
    },
    generateCertificateSigningRequest: {
      __type: 'GenerateCertificateSigningRequest!',
      __args: { corporateId: 'ID!', organization: 'String!', userId: 'String' },
    },
    generateClientFileUploadUrl: {
      __type: 'GenerateClientFileUploadUrlResponse!',
      __args: { clientId: 'String!', input: 'CreateClientFileInput!', siteId: 'String!' },
    },
    generateContactlessCheckinDeepLink: {
      __type: 'String',
      __args: { corporateId: 'String!', siteId: 'String!' },
    },
    generateCoverImageUploadUrl: {
      __type: 'CoverImageUploadUrl!',
      __args: { input: 'GenerateCoverImageUploadUrlInput!' },
    },
    generateDevicePairingCode: {
      __type: 'GenerateDevicePairingCode!',
      __args: {
        capabilities: '[DeviceCapability!]',
        deviceKind: 'DeviceKind',
        inputMode: 'DeviceInputMode',
        siteId: 'String!',
        widgetDeviceId: 'String',
      },
    },
    generateDoorAccessDeepLink: {
      __type: 'String',
      __args: { corporateId: 'String!', siteAccessPointId: 'String!', siteId: 'String!' },
    },
    generateEquipmentImagePresignedUrl: {
      __type: 'GenerateFileUploadUrlResponse!',
      __args: { equipmentId: 'String!', fileExtension: 'String!', siteId: 'String!' },
    },
    generateFileSignedUrl: {
      __type: '[GenerateFileSignedUrlResponse!]!',
      __args: { input: 'GenerateFileUrlInput!' },
    },
    generateFileUploadSignedUrl: {
      __type: 'GenerateFileUploadUrlResponse!',
      __args: { input: 'GenerateFileUploadUrlInput!' },
    },
    generateInlineImageUploadUrl: {
      __type: 'CoverImageUploadUrl!',
      __args: { input: 'GenerateCoverImageUploadUrlInput!' },
    },
    generateKioskBackgroundImageUploadUrl: {
      __type: 'GenerateFileUploadUrlResponse!',
      __args: { corporateId: 'String!', fileExtension: 'String!' },
    },
    generateKioskLogoUploadUrl: {
      __type: 'GenerateFileUploadUrlResponse!',
      __args: { corporateId: 'String!', fileExtension: 'String!' },
    },
    generateKnowledgeArticleWithAI: {
      __type: 'AIGeneratedArticle!',
      __args: { input: 'AIArticleGenerateInput!' },
    },
    generateMemberMovementWorkbook: { __type: 'MemberMovementRun!', __args: { runId: 'ID!' } },
    generateProductImageUploadUrl: {
      __type: 'GenerateFileUploadUrlResponse!',
      __args: { input: 'GenerateImagePublicSignedUrlInput!', posProductId: 'ID!', siteId: 'ID!' },
    },
    generateRoomResourceTemplateImageSignedUrl: {
      __type: 'ImagePublicSignedUrl',
      __args: { input: 'ImagePublicSignedUrlInput!', roomResourceTemplateId: 'ID!', siteId: 'ID!' },
    },
    generateRoomResourceTemplateImageUploadUrl: {
      __type: 'GenerateFileUploadUrlResponse!',
      __args: {
        input: 'GenerateImagePublicSignedUrlInput!',
        roomResourceTemplateId: 'ID!',
        siteId: 'ID!',
      },
    },
    generateSiteAccessPointQRCode: {
      __type: 'SiteAccessPoint!',
      __args: { siteAccessPointId: 'String!', siteId: 'String!' },
    },
    generateSiteLogoUploadSignedUrl: {
      __type: 'GenerateFileUploadUrlResponse!',
      __args: { input: 'GenerateFileUploadUrlInput!' },
    },
    generateStripeLoginLink: { __type: 'String!', __args: { siteId: 'ID!' } },
    generateStripeOnboardingLink: { __type: 'OnboardingLinkResult!', __args: { siteId: 'ID!' } },
    generateTanningApiKey: { __type: 'String!', __args: { siteId: 'String!' } },
    generateThumbnailUploadUrl: {
      __type: 'ThumbnailUploadUrlResult!',
      __args: { contentMediaId: 'ID!' },
    },
    getCorporateDashboardHeroImagePresignedUrl: {
      __type: 'String!',
      __args: { corporateId: 'String!', fileExtension: 'String!' },
    },
    getCorporateLogoImagePresignedUrl: {
      __type: 'String!',
      __args: { corporateId: 'String!', fileExtension: 'String!' },
    },
    importClientsFromCSV: {
      __type: 'ClientImportResult!',
      __args: { input: 'ImportClientsInput!', siteId: 'ID!' },
    },
    importCustomText: {
      __type: 'ImportCustomText!',
      __args: {
        corporateId: 'String!',
        customTextData: 'JSONObject!',
        sanitize: 'Boolean!',
        userId: 'String',
      },
    },
    initFormSignatureUpload: {
      __type: 'FormSignatureUploadTicket!',
      __args: {
        formSubmissionId: 'String!',
        format: 'FormSignatureFormat',
        siteFormQuestionId: 'String!',
      },
    },
    initSignupSignatureUpload: {
      __type: 'SignupSignatureUploadTicket!',
      __args: {
        expectedRevision: 'Float!',
        intendedClient: 'InitSignupSignatureUploadIntendedClientInput!',
        signupAttemptId: 'ID',
        siteFormId: 'String!',
        siteFormQuestionId: 'String!',
        siteId: 'String!',
      },
    },
    initializeOnboarding: { __type: 'Boolean!', __args: { corporateId: 'ID!' } },
    initializeVideoUpload: {
      __type: 'VideoUploadSession!',
      __args: { input: 'InitializeVideoUploadInput!' },
    },
    initiateCSVUpload: {
      __type: 'InitiateCSVUpload!',
      __args: {
        corporateId: 'ID!',
        fileName: 'String!',
        importType: 'String!',
        migrationId: 'ID',
        migrationName: 'String',
        sourceSystem: 'String',
        targetEnvironment: 'String',
      },
    },
    initiateClientPaymentMethod: {
      __type: 'InitiatePaymentMethodResponse!',
      __args: { clientId: 'ID', paymentModeType: 'Float', siteId: 'ID!' },
    },
    initiateMediaUpload: {
      __type: 'CmsContentMedia!',
      __args: { input: 'InitiateMediaUploadInputInput!' },
    },
    initiateMemberMovementRun: {
      __type: 'MemberMovementRun!',
      __args: { runId: 'ID!', scheduledAt: 'String' },
    },
    initiateSitePaymentMethodSetup: {
      __type: 'SiteSetupIntentResponse!',
      __args: { siteId: 'String!' },
    },
    initiateTerminalPaymentMethodSetup: {
      __type: 'InitiateTerminalPaymentMethodSetup!',
      __args: { clientId: 'ID!', siteId: 'ID!', terminalReaderId: 'ID!' },
    },
    initiateZIPUpload: {
      __type: 'InitiateZIPUpload!',
      __args: {
        corporateId: 'ID!',
        fileName: 'String!',
        importType: 'String!',
        migrationId: 'ID',
        migrationName: 'String',
        siteId: 'ID',
        sourceSystem: 'String',
        targetEnvironment: 'String',
      },
    },
    invalidateProfileImageCache: { __type: 'Boolean!' },
    inviteStaffMember: {
      __type: 'InviteStaffMember!',
      __args: { corporateId: 'ID!', invitation: 'InviteStaffMemberInvitationInput!' },
    },
    joinPresaleInvoice: { __type: 'Invoice!', __args: { invoiceId: 'ID!', siteId: 'ID!' } },
    leaveFamily: { __type: 'Boolean!', __args: { siteId: 'ID!' } },
    linkFitnessPassportMember: {
      __type: 'FitnessPassportLinkView!',
      __args: { clientId: 'ID!', fpMemberId: 'String!', siteId: 'ID!' },
    },
    linkOrganisationEmployees: {
      __type: '[EmployeeLinkResult!]!',
      __args: { employees: '[EmployeeLinkInput!]!', organisationClientId: 'ID!', siteId: 'ID!' },
    },
    linkSiteToGrowHq: {
      __type: 'LinkSiteToHqResponse!',
      __args: { enabled: 'Boolean', hqId: 'String!', siteId: 'String!' },
    },
    logEquipmentLampChange: {
      __type: '[EquipmentLampLog!]!',
      __args: { input: 'LogEquipmentLampChangeInput!' },
    },
    loginAsAdmin: {
      __type: 'AdminUser!',
      __args: { displayName: 'String', email: 'String!', photoURL: 'String', uid: 'String!' },
    },
    markAllReleaseNotesAsRead: { __type: 'Int!', __args: { userContext: 'UserContextInput!' } },
    markReleaseNoteAsRead: {
      __type: 'ReleaseNoteReadStatus!',
      __args: { releaseNoteId: 'ID!', userId: 'String!' },
    },
    markVideoUploadComplete: {
      __type: 'VideoStatus!',
      __args: { knowledgeArticleId: 'ID!', videoId: 'ID!' },
    },
    materializeVirtualInvoice: {
      __type: 'ID!',
      __args: { recurringInvoiceId: 'ID!', sequenceNumber: 'Float!' },
    },
    mergeClients: { __type: 'MergeClientsResult!', __args: { input: 'MergeClientsInput!' } },
    modifyScheduledSuspension: {
      __type: 'Boolean!',
      __args: {
        chargeAmount: 'String',
        chargeMode: 'ServiceSuspensionChargeMode',
        endDate: 'String',
        feeBillingCycleAmount: 'Float',
        feeBillingCycleUnit: 'String',
        reason: 'String',
        serviceSuspensionId: 'ID!',
        siteId: 'ID!',
        startDate: 'String',
        suspensionType: 'ServiceSuspensionType',
      },
    },
    modifySuspensionEndDate: {
      __type: 'ModifySuspensionEndDate!',
      __args: { endDate: 'String!', serviceSuspensionId: 'ID!', siteId: 'ID!' },
    },
    myFormProgress: {
      __type: 'MemberFormProgress!',
      __args: { answeredCount: 'Float!', formSubmissionId: 'String!' },
    },
    notifyClientInEquipmentQueue: {
      __type: 'Equipment!',
      __args: { clientId: 'String!', equipmentId: 'String!', siteId: 'String!' },
    },
    onboardBrand: {
      __type: '[BrandProvisionOutcome!]!',
      __args: {
        branchCredentials: 'OnboardBrandBranchCredentialsInput',
        brandId: 'String!',
        platform: 'BrandPlatform',
      },
    },
    openCashDrawerSession: {
      __type: 'CashDrawerSession!',
      __args: { siteId: 'ID!', startingCash: 'Numeric!' },
    },
    openSiteAccessPoint: {
      __type: 'Boolean!',
      __args: { siteAccessPointId: 'String!', siteId: 'String!' },
    },
    pauseMyMembership: {
      __type: 'ID!',
      __args: { input: 'MemberPauseInput!', serviceId: 'ID!', siteId: 'ID!' },
    },
    permanentlyDeleteContentEntry: { __type: 'Boolean!', __args: { contentEntryId: 'ID!' } },
    postCoverMessage: {
      __type: 'CoverMessageView!',
      __args: {
        body: 'String!',
        bodyJson: 'JSON',
        coverRequestId: 'ID!',
        recipientMode: 'CoverMessageRecipientMode',
        recipientStaffUserIds: '[ID!]',
        sendSms: 'Boolean',
        siteId: 'ID!',
      },
    },
    previewCommissionOwnerChange: {
      __type: 'ID!',
      __args: { from: 'String!', serviceId: 'ID!', staffUserId: 'ID!' },
    },
    previewCommissionPlanVersion: {
      __type: 'ID!',
      __args: { commissionPeriodId: 'ID!', commissionPlanId: 'ID!', data: 'JSONObject!' },
    },
    processCSVImport: { __type: 'ProcessCSVImport!', __args: { importSessionId: 'ID!' } },
    processScheduledInvoiceNow: {
      __type: 'String!',
      __args: { invoiceId: 'String!', siteId: 'ID!' },
    },
    processZIPImport: { __type: 'ProcessZIPImport!', __args: { importSessionId: 'ID!' } },
    processZIPImportFromGcs: {
      __type: 'ProcessZIPImportFromGcs!',
      __args: {
        corporateId: 'ID!',
        gcsUrls: '[String!]!',
        importType: 'String!',
        migrationId: 'ID',
        migrationName: 'String',
        sourceSystem: 'String',
        targetEnvironment: 'String',
      },
    },
    promoteProspect: { __type: 'PromoteProspect!', __args: { clientId: 'ID!', siteId: 'ID!' } },
    provideSupportMessageFeedback: {
      __type: 'SupportChatMessage!',
      __args: { input: 'SupportMessageFeedbackInput!' },
    },
    provisionBrandFirebaseApps: { __type: 'BrandFirebaseApps!', __args: { brandId: 'String!' } },
    provisionCorporateDatabase: {
      __type: 'Corporate!',
      __args: { corporateId: 'ID!', requiresMigration: 'Boolean' },
    },
    provisionTrialAccess: {
      __type: 'ProvisionTrialAccessResponse!',
      __args: { corporateId: 'ID!' },
    },
    publishContentEntry: { __type: 'CmsContentEntry!', __args: { contentEntryId: 'ID!' } },
    publishCorporateAddOn: {
      __type: 'CorporateAddOnRolloutResult!',
      __args: { input: 'CorporateServiceTemplateVersionInput!' },
    },
    publishCorporateAddOnChanges: {
      __type: 'CorporateAddOnRolloutResult!',
      __args: { input: 'PublishCorporateAddOnChangesInput!' },
    },
    publishEntitlementCatalog: {
      __type: 'PublishEntitlementCatalogResult!',
      __args: { snapshot: 'String!' },
    },
    publishKnowledgeArticle: { __type: 'KnowledgeArticle!', __args: { knowledgeArticleId: 'ID!' } },
    publishReleaseNote: { __type: 'ReleaseNote!', __args: { releaseNoteId: 'ID!' } },
    publishSitePolicyRevision: {
      __type: 'SitePolicyPublishResult!',
      __args: {
        effectiveFrom: 'String',
        requireReacceptance: 'Boolean',
        siteId: 'ID!',
        sitePolicyId: 'ID!',
      },
    },
    purchaseSmsPackage: {
      __type: 'PurchaseCreditsResult!',
      __args: {
        optionId: 'String!',
        paymentMethodId: 'String!',
        siteId: 'String!',
        smsPackageId: 'String!',
      },
    },
    raiseOrganisationInvoice: {
      __type: 'Invoice!',
      __args: { input: 'OrganisationInvoiceInput!', siteId: 'ID!' },
    },
    reDeriveSiteFobs: { __type: 'ReDeriveSiteFobsResult!', __args: { siteId: 'ID!' } },
    reactivateClientAtSite: {
      __type: 'BlockClientResponse!',
      __args: { clientId: 'String!', siteId: 'String!' },
    },
    recalculateClientSiteAggregates: {
      __type: 'RecalculateClientSiteAggregates!',
      __args: { input: 'RecalculateClientSiteAggregatesInputInput!' },
    },
    recordBrandReleaseStoreVerdict: {
      __type: 'BrandNativeRelease!',
      __args: {
        brandId: 'String!',
        note: 'String',
        releaseId: 'String!',
        verdict: 'BrandReleaseStoreVerdict!',
      },
    },
    recordCashDrawerPayouts: {
      __type: 'CashDrawerSession!',
      __args: { cashDrawerSessionId: 'ID!', refundIds: '[ID!]!', siteId: 'ID!' },
    },
    recordExternalFormResult: {
      __type: 'ClientFormResult!',
      __args: {
        assessedAt: 'String!',
        bandId: 'ID!',
        clientId: 'String!',
        note: 'String',
        siteFormId: 'String!',
        siteId: 'String!',
        source: 'FormExternalResultSource!',
      },
    },
    recordPaperPolicyForm: {
      __type: 'PaperPolicyFormResult!',
      __args: {
        approverPin: 'String!',
        approverStaffUserId: 'ID!',
        attestationRevisionId: 'ID',
        clientId: 'ID!',
        scanUploadId: 'ID!',
        siteId: 'ID!',
        slots: '[PaperPolicyFormSlotInput!]!',
      },
    },
    redeemGiftCard: {
      __type: 'RedeemGiftCard!',
      __args: { clientId: 'ID!', code: 'String!', siteId: 'ID!' },
    },
    redeliverWebhookEvent: {
      __type: 'SiteWebhookTestResult!',
      __args: { deliveryId: 'String!', siteId: 'String!', webhookId: 'String!' },
    },
    redriveMemberMovementHomeSite: {
      __type: 'RedriveMemberMovementHomeSiteResult!',
      __args: { movementId: 'ID!' },
    },
    refreshAllGrowHqTokens: { __type: 'TokenRefreshResponse!' },
    refreshAppleTeamCompliance: { __type: 'AppleTeamCompliance', __args: { brandId: 'String!' } },
    refreshArticlesOnly: { __type: 'RefreshArticlesOnlyResult!' },
    refreshAuditView: { __type: 'Boolean!' },
    refreshCodebaseAndArticles: { __type: 'RefreshCodebaseResult!' },
    refreshEmailDomainStatus: {
      __type: 'CorporateEmailDomain!',
      __args: { corporateId: 'String!' },
    },
    refreshFitnessPassportMember: {
      __type: 'FitnessPassportLinkView!',
      __args: { clientId: 'ID!', siteId: 'ID!' },
    },
    refreshGrowHqToken: { __type: 'TokenRefreshResponse!', __args: { hqId: 'String!' } },
    refreshStripeStatus: { __type: 'RefreshStripeStatusResult!', __args: { siteId: 'ID!' } },
    registerAppleBundleId: {
      __type: '[BrandSetupStepView!]!',
      __args: { brandId: 'String!', bundleIdIos: 'String!', force: 'Boolean', scheme: 'String!' },
    },
    registerDeviceToken: {
      __type: 'RegisterDeviceTokenResponse!',
      __args: { input: 'RegisterDeviceTokenInput!' },
    },
    registerEmailDomain: {
      __type: 'CorporateEmailDomain!',
      __args: { corporateId: 'String!', input: 'RegisterDomainInput!' },
    },
    registerSiteTerminalReader: {
      __type: 'SiteTerminalReader!',
      __args: { name: 'String!', registrationCode: 'String!', siteId: 'ID!' },
    },
    registerTanningExternalAgent: {
      __type: 'Boolean!',
      __args: { externalApiKey: 'String!', externalApiUrl: 'String!', siteId: 'String!' },
    },
    reinitiateIncomingMovement: {
      __type: 'ReinitiateIncomingMovementResult!',
      __args: { input: 'ReinitiateIncomingMovementInput!' },
    },
    reinstateInvoice: {
      __type: 'Invoice!',
      __args: { input: 'ReinstateInvoiceInput!', siteId: 'ID!' },
    },
    rejectKnowledgeArticleRevision: {
      __type: 'KnowledgeArticleRevision!',
      __args: { notes: 'String', revisionId: 'ID!' },
    },
    rejoinSession: { __type: 'Booking!', __args: { bookingId: 'String!', siteId: 'String!' } },
    releaseCoverRequest: {
      __type: 'CoverRequestView!',
      __args: { coverRequestId: 'ID!', siteId: 'ID!' },
    },
    releaseHeldPayment: {
      __type: 'HeldPaymentReleaseResult!',
      __args: {
        invoiceId: 'ID!',
        paymentId: 'ID!',
        reason: 'HeldPaymentReleaseReason!',
        siteId: 'ID!',
      },
    },
    releaseMemberMovementRequiresReviewRun: {
      __type: 'MemberMovementRun!',
      __args: { attestation: 'MemberMovementAttestationInput!', runId: 'ID!' },
    },
    releaseTerminalPayment: {
      __type: 'ReleaseTerminalPayment!',
      __args: { invoiceId: 'ID!', paymentId: 'ID', siteId: 'ID!' },
    },
    remapMemberMovementsLikeForLike: {
      __type: 'RemapMemberMovementsLikeForLikeResult!',
      __args: { input: 'RemapMemberMovementsLikeForLikeInput!' },
    },
    removeAccessRule: {
      __type: 'StaffAccessRule!',
      __args: { staffAccessRuleId: 'ID!', staffUserId: 'ID!' },
    },
    removeAssignedSitePayrollTier: {
      __type: 'AssignSitePayrollTier!',
      __args: { coreUserId: 'ID!', payrollTierId: 'ID!', siteId: 'ID!' },
    },
    removeBrandStoreTester: {
      __type: '[RemoveBrandStoreTester!]!',
      __args: { brandId: 'String!', testerId: 'String!' },
    },
    removeClientFromEquipmentQueue: {
      __type: 'Equipment!',
      __args: { clientId: 'String!', equipmentId: 'String!' },
    },
    removeClientFromSite: {
      __type: 'RemoveClientFromSiteResponse!',
      __args: { clientId: 'String!', siteId: 'String!' },
    },
    removeClientPaymentMethod: {
      __type: 'Boolean!',
      __args: {
        clientId: 'ID!',
        clientPaymentMethodId: 'ID!',
        replacementClientPaymentMethodId: 'ID',
        siteId: 'ID!',
      },
    },
    removeClientRelation: {
      __type: 'ClientRelationMutationResult!',
      __args: {
        clientId: 'ID!',
        counterpartyClientId: 'ID!',
        siteId: 'ID!',
        type: 'ClientRelationType!',
      },
    },
    removeDishonorFee: {
      __type: '[Invoice!]!',
      __args: { paymentId: 'ID', paymentIds: '[ID!]', siteId: 'ID!' },
    },
    removeEmailDomain: { __type: 'RemoveEmailDomain!', __args: { corporateId: 'String!' } },
    removeFamilyMember: { __type: 'Family', __args: { clientId: 'ID!', siteId: 'ID!' } },
    removeFavoriteInstructor: {
      __type: 'Boolean!',
      __args: { clientId: 'String!', instructorId: 'String!', siteId: 'String!' },
    },
    removeFavoriteSite: { __type: 'Boolean!', __args: { clientId: 'String!', siteId: 'String!' } },
    removeFromWaitlist: {
      __type: 'Boolean!',
      __args: { sessionWaitlistEntryId: 'String!', siteId: 'String!' },
    },
    removeKnowledgeDocument: { __type: 'Boolean!', __args: { id: 'ID!' } },
    removeMySharedCreditRecipient: {
      __type: 'ServiceCreditShareMutationResult!',
      __args: { input: 'RemoveMySharedCreditRecipientInput!' },
    },
    removeSessionZoomMeeting: { __type: 'Session!', __args: { id: 'String!', siteId: 'String!' } },
    removeSharedCreditRecipient: {
      __type: 'ServiceCreditShareMutationResult!',
      __args: { input: 'ServiceCreditShareRemoveInput!' },
    },
    removeSitePayrollTier: {
      __type: 'CreateSitePayrollTier!',
      __args: { id: 'ID!', siteId: 'ID!' },
    },
    removeSmsPackage: { __type: 'RemoveSmsPackage!', __args: { smsPackageId: 'ID!' } },
    removeSmsPackageOption: {
      __type: 'SmsPackage!',
      __args: { optionId: 'ID!', smsPackageId: 'ID!' },
    },
    removeStaffUserFromSessionTemplate: {
      __type: 'SessionTemplate!',
      __args: { id: 'String!', input: 'SessionTemplateStaffUserInput!', siteId: 'String!' },
    },
    renameApiCredential: {
      __type: 'ApiCredential!',
      __args: { apiCredentialId: 'ID!', input: 'ApiCredentialRenameInput!' },
    },
    renameCommissionPlan: {
      __type: 'CommissionPlan!',
      __args: { commissionPlanId: 'ID!', name: 'String!' },
    },
    renameDevice: {
      __type: 'RenameDevice!',
      __args: { deviceTokenId: 'String!', label: 'String!', siteId: 'String!' },
    },
    renameMediaFolder: {
      __type: 'MediaFolderChild!',
      __args: { newPath: 'String!', oldPath: 'String!' },
    },
    reopenTrial: { __type: 'Boolean!', __args: { corporateId: 'ID!', daysToExtend: 'Float!' } },
    reorderContentEntries: {
      __type: 'Boolean!',
      __args: { contentTypeId: 'ID!', orderedIds: '[ID!]!' },
    },
    reorderCorporateFaqs: {
      __type: 'ReorderCorporateFaqsResponse!',
      __args: { input: 'ReorderCorporateFaqsInput!' },
    },
    reorderKnowledgeArticleCategories: { __type: 'Boolean!', __args: { orderedIds: '[ID!]!' } },
    reorderMediaFolders: { __type: 'Boolean!', __args: { orderedPaths: '[String!]!' } },
    reorderPosCategories: {
      __type: 'ReorderPosCategoriesResponse!',
      __args: { input: 'ReorderPosCategoriesInput!', siteId: 'ID!' },
    },
    reorderSavedReportCategories: {
      __type: 'DeleteSavedReport!',
      __args: { orderedIds: '[String!]!' },
    },
    reorderSavedReports: {
      __type: 'DeleteSavedReport!',
      __args: { categoryId: 'String', orderedIds: '[String!]!' },
    },
    reorderServiceTemplateCategories: {
      __type: 'ReorderServiceTemplateCategoriesResponse!',
      __args: { input: 'ReorderServiceTemplateCategoriesInput!', siteId: 'String!' },
    },
    reorderSessionFeedbackQuestion: {
      __type: 'SessionFeedbackQuestionReorderResponse!',
      __args: { newOrder: 'Int!', questionId: 'ID!', siteId: 'ID!' },
    },
    reorderSessionFilter: {
      __type: 'Boolean!',
      __args: {
        newOrder: 'Float!',
        oldOrder: 'Float!',
        sessionFilterId: 'String!',
        siteId: 'String!',
      },
    },
    reorderSessionTemplates: {
      __type: 'ReorderSessionTemplatesResult!',
      __args: { input: 'ReorderSessionTemplatesInput!', siteId: 'String!' },
    },
    reorderSiteFormQuestion: {
      __type: 'SiteFormReorderResponse!',
      __args: { newOrder: 'Float!', questionId: 'String!', siteFormId: 'String!', siteId: 'ID!' },
    },
    reorderSiteSessionTypes: {
      __type: 'ReorderSiteSessionTypesResponse!',
      __args: { input: 'ReorderSiteSessionTypesInput!', siteId: 'String!' },
    },
    reorderStaffUserSmartGroup: {
      __type: 'Float!',
      __args: {
        newOrder: 'Float!',
        oldOrder: 'Float!',
        siteId: 'String!',
        staffUserId: 'String!',
        staffUserSmartGroupId: 'String!',
      },
    },
    replaceExternalMediaAsset: {
      __type: 'CmsContentMedia!',
      __args: { input: 'ReplaceExternalMediaAssetInputInput!' },
    },
    replaceMediaAsset: {
      __type: 'CmsContentMedia!',
      __args: { input: 'ReplaceMediaAssetInputInput!' },
    },
    replayBlockedMovements: {
      __type: 'ReplayBlockedMovementsResult!',
      __args: { input: 'ReplayBlockedMovementsInput!' },
    },
    requestAccountDeletion: {
      __type: 'AccountDeletionRequestResult!',
      __args: { input: 'AccountDeletionRequestInput!' },
    },
    requestBrandRelease: {
      __type: 'BrandNativeRelease!',
      __args: {
        appVersion: 'String',
        brandId: 'String!',
        platform: 'BrandPlatform!',
        reason: 'BrandNativeReleaseReason',
        submitToReviewRequested: 'Boolean',
      },
    },
    requestCover: {
      __type: 'CoverRequestView!',
      __args: {
        coverGroupId: 'ID',
        noteToSubs: 'String',
        originalStaffUserId: 'ID',
        reason: 'String',
        sessionId: 'String!',
        siteId: 'ID!',
      },
    },
    requestFobCapture: {
      __type: 'RequestFobCaptureResult!',
      __args: { input: 'RequestFobCaptureInput!' },
    },
    requestMaintenance: {
      __type: 'Boolean!',
      __args: {
        bodyHtml: 'String!',
        equipmentId: 'String!',
        siteId: 'String!',
        subject: 'String!',
      },
    },
    requestPolicyEvidenceExport: {
      __type: 'PolicyEvidenceExport!',
      __args: {
        includeScans: 'Boolean!',
        signedFrom: 'String!',
        signedTo: 'String!',
        siteId: 'ID!',
        sitePolicyIds: '[ID!]',
      },
    },
    requestUpgrade: {
      __type: 'Boolean!',
      __args: { corporateId: 'ID!', requestedByEmail: 'String', requestedByName: 'String' },
    },
    rerouteFormHandoff: {
      __type: 'FormHandoff!',
      __args: { channel: 'FormHandoffChannel!', handoffId: 'ID!', siteId: 'String!' },
    },
    resendGuestPass: { __type: 'GuestPass!', __args: { guestPassId: 'ID!' } },
    resendInvitation: { __type: 'Boolean!', __args: { invitationId: 'ID!' } },
    resendInvoice: { __type: 'SendPaymentReminder!', __args: { invoiceId: 'ID!', siteId: 'ID!' } },
    resetAllCustomText: { __type: 'ResetToDefaults!', __args: { corporateId: 'String!' } },
    resetContentLibraryFieldOverride: {
      __type: 'ContentLibraryResetOverrideResult!',
      __args: { contentEntryId: 'ID!', corporateId: 'ID', path: 'String!' },
    },
    resetEquipment: { __type: 'Equipment!', __args: { equipmentId: 'String!' } },
    resetMemberExperienceBranding: {
      __type: 'ResetMemberExperienceBranding!',
      __args: { corporateId: 'String!' },
    },
    resetMemberExperienceFonts: {
      __type: 'ResetMemberExperienceFonts!',
      __args: { corporateId: 'String!' },
    },
    resetMemberExperienceSettings: {
      __type: 'ResetMemberExperienceSettings!',
      __args: { corporateId: 'String!' },
    },
    resetMyCalendarFeedUrl: { __type: 'String!', __args: { siteId: 'String!' } },
    resetToDefaults: {
      __type: 'ResetToDefaults!',
      __args: { corporateId: 'String!', keys: '[String!]!', language: 'String!', userId: 'String' },
    },
    resolveCommissionAttributions: {
      __type: 'CommissionAttributionResolutionResult!',
      __args: { items: '[CommissionAttributionResolutionInput!]!' },
    },
    restartEquipmentAssignment: {
      __type: 'RestartEquipmentAssignmentResult!',
      __args: { assignmentId: 'ID!', complianceOverride: 'ComplianceOverrideInput' },
    },
    restoreContentEntryVersion: {
      __type: 'CmsContentEntry!',
      __args: { contentEntryId: 'ID!', contentVersionId: 'ID!' },
    },
    restoreKnowledgeArticle: { __type: 'KnowledgeArticle!', __args: { knowledgeArticleId: 'ID!' } },
    restoreService: {
      __type: 'Boolean!',
      __args: { notes: 'String', serviceId: 'String!', siteId: 'String!' },
    },
    resumeMyMembership: { __type: 'Boolean!', __args: { serviceId: 'ID!', siteId: 'ID!' } },
    resumeService: {
      __type: 'Boolean!',
      __args: { notes: 'String', restartDate: 'String', serviceId: 'String!', siteId: 'String!' },
    },
    resyncArticlesFromCorpus: { __type: 'CorpusResyncResult!' },
    resyncEquipment: { __type: 'Equipment!', __args: { equipmentId: 'String!' } },
    resyncEquipments: { __type: '[Equipment!]!', __args: { siteId: 'String!' } },
    resyncKnowledgeArticleCategoryCounts: { __type: 'Boolean!' },
    retireEquipmentJurisdictionRule: {
      __type: 'EquipmentJurisdictionRule!',
      __args: { reason: 'String!', ruleId: 'ID!', siteId: 'ID!' },
    },
    retryDeepLinkGeneration: {
      __type: 'DeepLink!',
      __args: { corporateId: 'String!', deepLinkId: 'String!' },
    },
    retryFitnessPassportVisits: {
      __type: 'FitnessPassportRetrySummary!',
      __args: { batchSize: 'Float', siteId: 'ID!' },
    },
    retryFormWorkflowEffects: {
      __type: 'RetryFormWorkflowEffectsResponse!',
      __args: { effectIds: '[String!]!', siteId: 'String!' },
    },
    retryMemberMovementPaymentMigration: {
      __type: 'RetryMemberMovementPaymentMigrationResult!',
      __args: { input: 'RetryMemberMovementPaymentMigrationInput!' },
    },
    retryPayments: {
      __type: '[RetryPayments!]!',
      __args: { input: 'RetryPaymentsInputInput!', invoiceId: 'ID!', siteId: 'ID!' },
    },
    retryTerminalHandoffRequest: {
      __type: 'TerminalHandoffRequest!',
      __args: { siteId: 'ID!', terminalHandoffRequestId: 'ID!' },
    },
    reverseEquipmentAssignment: {
      __type: 'ReverseEquipmentAssignmentResult!',
      __args: { assignmentId: 'ID!' },
    },
    revertMemberMovement: {
      __type: 'RevertMemberMovementResult!',
      __args: { movementId: 'ID!', reason: 'String' },
    },
    reviewMemberMovements: {
      __type: 'ReviewMemberMovementsResult!',
      __args: { input: 'ReviewMemberMovementsInput!' },
    },
    revokeApiCredential: { __type: 'ApiCredential!', __args: { apiCredentialId: 'ID!' } },
    revokeBookingBuddy: {
      __type: 'BookingBuddyMutationResult!',
      __args: { buddyClientId: 'ID!', clientId: 'ID!' },
    },
    revokeBrandSetupStep: {
      __type: '[BrandSetupStepView!]!',
      __args: { brandId: 'String!', step: 'BrandSetupStep!' },
    },
    revokeDevice: {
      __type: 'RevokeDevice!',
      __args: { deviceTokenId: 'String!', siteId: 'String!' },
    },
    revokeFamilyAllocation: {
      __type: 'ServiceCreditShareMutationResult!',
      __args: { input: 'RevokeFamilyAllocationInput!' },
    },
    revokeFamilyInvite: {
      __type: 'Family!',
      __args: {
        clientId: 'ID',
        familyId: 'ID',
        inviteLinkId: 'String',
        inviteToken: 'String',
        siteId: 'ID!',
      },
    },
    revokeGiftCardExpiryRule: {
      __type: 'GiftCardExpiryRuleRecord!',
      __args: { giftCardExpiryRuleId: 'ID!' },
    },
    revokeGuardianAuthority: {
      __type: 'GuardianAuthorityRevocationResult!',
      __args: { clientId: 'ID!', guardianClientId: 'ID!', reason: 'String', siteId: 'ID!' },
    },
    revokeGuestPass: { __type: 'GuestPass!', __args: { guestPassId: 'ID!' } },
    revokeInvitation: { __type: 'Boolean!', __args: { invitationId: 'ID!' } },
    revokeKioskSessions: { __type: 'RevokeKioskSessions!', __args: { siteId: 'String!' } },
    revokeMemberMovementRunApproval: { __type: 'MemberMovementRun!', __args: { runId: 'ID!' } },
    revokePolicyEvidenceExport: {
      __type: 'PolicyEvidenceExport!',
      __args: { exportId: 'ID!', siteId: 'ID!' },
    },
    revokeStaffUserSessions: { __type: 'Boolean!', __args: { staffUserId: 'ID!' } },
    revokeZapierConnection: { __type: 'Boolean!', __args: { siteId: 'ID!' } },
    rollbackBrandConfig: {
      __type: 'SavedBrandConfigVersion!',
      __args: { brandId: 'String!', expectedVersionId: 'String', targetVersionId: 'String!' },
    },
    rolloverExpiredCredits: {
      __type: 'RolloverExpiredCreditsResult!',
      __args: { input: 'RolloverExpiredCreditsInput!' },
    },
    rotateApiCredential: { __type: 'ApiCredentialWithSecret!', __args: { apiCredentialId: 'ID!' } },
    rotateCorporateWebhookSecret: {
      __type: 'CorporateWebhook!',
      __args: { corporateId: 'ID!', webhookId: 'ID!' },
    },
    rotateSiteWebhookSecret: {
      __type: 'RotateSiteWebhookSecret!',
      __args: { siteId: 'String!', webhookId: 'String!' },
    },
    runCommissionBackfill: { __type: 'ID!', __args: { fromDate: 'String!' } },
    runCommissionDryRun: {
      __type: 'ID!',
      __args: { commissionPeriodId: 'ID!', comparisonCsv: 'String' },
    },
    saveBrandCoverSettings: {
      __type: 'CoverSettingsOverrides!',
      __args: { settings: 'CoverSettingsInput!' },
    },
    saveCommissionPlanVersion: {
      __type: 'CommissionPlan!',
      __args: { commissionPlanId: 'ID!', data: 'JSONObject!', effectiveFrom: 'String!' },
    },
    saveCoverPreferredSubs: {
      __type: '[CoverPreferredSubView!]!',
      __args: { siteId: 'ID!', subs: '[CoverPreferredSubInput!]!' },
    },
    saveCoverQualifications: {
      __type: '[CoverStaffQualifications!]!',
      __args: { siteId: 'ID!', staff: '[CoverStaffQualificationsInput!]!' },
    },
    saveEquipmentExposureSchedule: {
      __type: '[EquipmentExposureScheduleRow!]!',
      __args: { input: 'SaveEquipmentExposureScheduleInput!' },
    },
    saveEquipmentJurisdictionRule: {
      __type: 'EquipmentJurisdictionRule!',
      __args: { input: 'EquipmentJurisdictionRuleInput!', ruleId: 'ID', siteId: 'ID!' },
    },
    saveMovementTemplateMappings: {
      __type: '[MemberMovementTemplateMapping!]!',
      __args: {
        corporateId: 'ID!',
        mappings: '[SaveMovementTemplateMappingsMappingsInput!]!',
        persist: 'Boolean!',
      },
    },
    saveScoredSiteForm: {
      __type: 'SaveScoredSiteFormResult!',
      __args: {
        expectedRevision: 'Float!',
        form: 'SaveScoredSiteFormFormInput!',
        questions: '[SaveScoredSiteFormQuestionsInput!]!',
        siteFormId: 'String',
        siteId: 'ID!',
      },
    },
    saveSiteCoverSettings: {
      __type: 'SiteCoverSettings!',
      __args: { settings: 'CoverSettingsInput!', siteId: 'ID!' },
    },
    saveSiteLateCancelFees: {
      __type: '[SiteLateCancelFee!]!',
      __args: { fees: '[SiteLateCancelFeeSaveInput!]!', siteId: 'ID!' },
    },
    saveSiteNoShowFees: {
      __type: '[SiteNoShowFee!]!',
      __args: { fees: '[SiteNoShowFeeSaveInput!]!', siteId: 'ID!' },
    },
    scheduleCorporateAddOn: {
      __type: 'CorporateAddOnScheduleResult!',
      __args: { input: 'ScheduleCorporateServiceTemplateInput!' },
    },
    scheduleInvoice: {
      __type: 'Invoice!',
      __args: { clientId: 'ID', input: 'ScheduleInvoiceInput!', invoiceId: 'ID!', siteId: 'ID!' },
    },
    seedCommissionAttributions: { __type: 'ID!' },
    sendAgreementToClient: {
      __type: 'SendAgreementResponse!',
      __args: { agreementId: 'ID!', clientId: 'ID!', siteId: 'ID!', skipEmail: 'Boolean' },
    },
    sendGuestPass: { __type: 'GuestPass!', __args: { input: 'SendGuestPassInput!' } },
    sendMessage: { __type: 'SendMessageResponse!', __args: { input: 'SendMessageInput!' } },
    sendPasswordResetEmail: {
      __type: 'Boolean!',
      __args: { clientId: 'String!', siteId: 'String!' },
    },
    sendPaymentAuthenticationEmail: {
      __type: 'PaymentAuthenticationEmailResult!',
      __args: { invoiceId: 'ID!', paymentId: 'ID!', siteId: 'ID!' },
    },
    sendPaymentReminder: {
      __type: 'SendPaymentReminder!',
      __args: {
        customMessageHtml: 'String',
        invoiceId: 'ID!',
        sendForSignatureAndPayment: 'Boolean',
        signatureOnly: 'Boolean',
        siteId: 'ID!',
      },
    },
    sendStaffPasswordResetEmail: {
      __type: 'Boolean!',
      __args: { ignorePreviousDeliveryFailure: 'Boolean', staffUserId: 'ID!' },
    },
    sendTestEquipmentPushNotification: { __type: 'Boolean!', __args: { siteId: 'ID!' } },
    sendTestPushNotification: { __type: 'Boolean!', __args: { fcmToken: 'String' } },
    sendTestWebhookEvent: {
      __type: 'SiteWebhookTestResult!',
      __args: { eventType: 'String!', siteId: 'String!', webhookId: 'String!' },
    },
    sendWelcomeEmail: {
      __type: 'Boolean!',
      __args: { ignorePreviousDeliveryFailure: 'Boolean', staffUserId: 'ID!' },
    },
    setAppleTeamMembershipExpiry: {
      __type: 'AppleTeamCompliance',
      __args: { brandId: 'String!', membershipExpiresAt: 'String!' },
    },
    setBackupPaymentMethod: {
      __type: 'Boolean!',
      __args: { clientId: 'ID!', clientPaymentMethodId: 'ID!', siteId: 'ID!' },
    },
    setBrandReleaseHold: {
      __type: 'BrandReleaseHold!',
      __args: { brandId: 'String!', reason: 'String!' },
    },
    setCommissionEligibility: {
      __type: 'CommissionEligibility!',
      __args: {
        clearEndDate: 'Boolean',
        commissionRolePolicyId: 'ID',
        endDate: 'String',
        reason: 'String',
        staffUserId: 'ID!',
        startDate: 'String',
      },
    },
    setCommissionLineSeller: {
      __type: 'CommissionRecalcSummary!',
      __args: { invoiceItemId: 'ID!', reason: 'String!', staffUserId: 'ID!' },
    },
    setCommissionOwner: {
      __type: 'CommissionRecalcSummary!',
      __args: {
        effectiveDate: 'String!',
        mode: 'CommissionOwnerChangeMode!',
        reason: 'String!',
        serviceId: 'ID!',
        staffUserId: 'ID!',
      },
    },
    setCommissionRoleDefault: {
      __type: '[CommissionRoleDefault!]!',
      __args: {
        commissionPlanId: 'ID',
        siteId: 'ID',
        staffAccessPolicyId: 'ID!',
        startDate: 'String',
      },
    },
    setCommissionRolePriority: { __type: '[ID!]!', __args: { staffAccessPolicyIds: '[ID!]!' } },
    setCommissionsEnabled: { __type: 'CommissionEnablement!', __args: { enabled: 'Boolean!' } },
    setContentLibraryAllLocations: {
      __type: 'ContentLibraryStatus!',
      __args: { corporateId: 'ID!', enabled: 'Boolean!' },
    },
    setContentLibraryCategoryScope: {
      __type: 'ContentLibraryStatus!',
      __args: { categories: '[String!]!', corporateId: 'ID!' },
    },
    setContentLibrarySiteEnablement: {
      __type: 'ContentLibraryStatus!',
      __args: { corporateId: 'ID!', enabled: 'Boolean!', siteId: 'ID!' },
    },
    setContentTargeting: {
      __type: 'CmsContentEntry!',
      __args: { contentEntryId: 'ID!', input: 'SetContentTargetingInputInput!' },
    },
    setCorporateClientLookupEnabled: {
      __type: 'Boolean!',
      __args: { corporateId: 'ID!', enabled: 'Boolean!' },
    },
    setCorporateIsOnboarding: {
      __type: 'Corporate!',
      __args: { corporateId: 'ID!', isOnboarding: 'Boolean!' },
    },
    setCorporateOwedBalanceBlockEnabled: {
      __type: 'Boolean!',
      __args: { corporateId: 'ID!', enabled: 'Boolean!' },
    },
    setDefaultPaymentMethod: {
      __type: 'Boolean!',
      __args: {
        applyToRecurringPayments: 'Boolean',
        clientId: 'ID!',
        clientPaymentMethodId: 'ID!',
        siteId: 'ID!',
      },
    },
    setDeviceInputMode: {
      __type: 'SetDeviceInputMode!',
      __args: { deviceTokenId: 'ID!', inputMode: 'DeviceInputMode!', siteId: 'ID!' },
    },
    setDevicePairingCodeLabel: {
      __type: 'SetDevicePairingCodeLabel!',
      __args: { label: 'String!', siteId: 'String!' },
    },
    setDeviceScopes: {
      __type: 'SetDeviceScopes!',
      __args: { capabilities: '[DeviceCapability!]!', deviceTokenId: 'ID!', siteId: 'ID!' },
    },
    setGrowHqAuthentication: {
      __type: 'GrowHq!',
      __args: { code: 'String!', growHqId: 'String!' },
    },
    setKioskPin: {
      __type: 'SetKioskPin!',
      __args: { pin: 'String!', sessionValidityDays: 'Float', siteId: 'String!' },
    },
    setMemberMovementIncomingNotifiers: {
      __type: 'MemberMovementLocationPosture!',
      __args: { input: 'SetMemberMovementIncomingNotifiersInput!' },
    },
    setMemberMovementLocationPosture: {
      __type: 'MemberMovementLocationPosture!',
      __args: { input: 'SetMemberMovementLocationPostureInput!' },
    },
    setMemberMovementRollingMode: {
      __type: 'SetRollingModeResult!',
      __args: { input: 'SetRollingModeInput!' },
    },
    setMyApprovalPin: {
      __type: 'ApprovalPinStatus!',
      __args: { currentPin: 'String', pin: 'String!' },
    },
    setMyDefaultScheduleView: { __type: 'String', __args: { siteId: 'ID!', viewRef: 'String' } },
    setMyScheduleRangeDays: { __type: 'Int', __args: { rangeDays: 'Int', siteId: 'ID!' } },
    setSavedReportCategoryTargeting: {
      __type: 'SetSavedReportCategoryTargeting!',
      __args: {
        savedReportCategoryId: 'String!',
        targets: '[SetSavedReportCategoryTargetingTargetsInput!]',
        visibilityScope: 'VisibilityScope!',
      },
    },
    setSavedReportTargeting: {
      __type: 'SetSavedReportTargeting!',
      __args: {
        savedReportId: 'String!',
        targets: '[SetSavedReportTargetingTargetsInput!]',
        visibilityScope: 'VisibilityScope!',
      },
    },
    setScheduledJobActive: {
      __type: 'Boolean!',
      __args: { active: 'Boolean!', corporateId: 'ID', jobKey: 'String!', siteId: 'ID' },
    },
    setServiceTemplateAddOnPriceGroupPrices: {
      __type: '[AddOnPriceGroupPrice!]!',
      __args: { input: 'SetServiceTemplateAddOnPriceGroupPricesInput!' },
    },
    setSessionTemplateFeedbackQuestions: {
      __type: 'SetSessionTemplateFeedbackQuestions!',
      __args: {
        input: 'SetSessionTemplateFeedbackQuestionsInputInput!',
        sessionTemplateId: 'ID!',
        siteId: 'ID!',
      },
    },
    setSiteWebhooksEnabled: {
      __type: 'Corporate!',
      __args: { corporateId: 'ID!', enabled: 'Boolean!' },
    },
    setStaffUserAllowedNetworks: {
      __type: 'StaffUser!',
      __args: {
        allowedNetworkIds: '[ID!]!',
        previousAllowedNetworkIds: '[ID!]',
        siteId: 'ID',
        staffUserId: 'ID!',
      },
    },
    setThemeDeployment: {
      __type: 'ThemeDeploymentResult!',
      __args: { corporateId: 'ID!', siteIds: '[ID!]!', themeSlug: 'ThemeKey!' },
    },
    setWellhubProductMapping: {
      __type: 'Boolean!',
      __args: { externalProductId: 'String!', siteId: 'ID!', siteSessionTypeId: 'ID!' },
    },
    setupEzypayGateway: {
      __type: 'SetupEzypayGatewayPayload!',
      __args: { input: 'SetupEzypayGatewayInput!' },
    },
    shiftRecurringInvoiceDates: {
      __type: 'Boolean!',
      __args: {
        applyTo: 'ShiftDatesApplyTo!',
        recurringInvoiceId: 'ID!',
        shiftDays: 'Float!',
        siteId: 'ID!',
      },
    },
    shiftRecurringInvoicesToPaymentMethod: {
      __type: 'ShiftRecurringInvoicesResult!',
      __args: { clientId: 'ID!', clientPaymentMethodId: 'ID!', siteId: 'ID!' },
    },
    signClientAgreement: {
      __type: 'ClientAgreement!',
      __args: {
        agreementId: 'ID!',
        agreementMethod: 'AgreementMethod!',
        clientId: 'ID!',
        ipAddress: 'String',
        signatures: '[String!]!',
        siteId: 'ID!',
        userAgent: 'String',
      },
    },
    skipAllErrors: { __type: 'SkipAllErrors!', __args: { importSessionIds: '[ID!]!' } },
    skipImportRows: {
      __type: 'SkipImportRows!',
      __args: { allWithErrors: 'Boolean', importSessionId: 'ID!', rowIndexes: '[Float!]' },
    },
    skipOnboardingStep: {
      __type: 'Boolean!',
      __args: { corporateId: 'ID!', stepKey: 'OnboardingStepKey!' },
    },
    softDeleteKnowledgeArticle: {
      __type: 'KnowledgeArticle!',
      __args: { knowledgeArticleId: 'ID!' },
    },
    stageDestinationFee: {
      __type: 'StageDestinationFeeResult!',
      __args: { bookingId: 'ID', clientId: 'ID!', siteId: 'ID!' },
    },
    startDemoClear: { __type: 'DemoSeedingJob!', __args: { corporateId: 'String!' } },
    startDemoSeed: {
      __type: 'DemoSeedingJob!',
      __args: {
        config: 'DemoSeedingConfigInput',
        corporateId: 'String!',
        persona: 'DemoSeedingPersona',
      },
    },
    startExportJob: { __type: 'StartExportJob!', __args: { input: 'ExportReportInputInput!' } },
    startImportValidation: {
      __type: 'StartImportValidation!',
      __args: { force: 'Boolean', migrationId: 'String!' },
    },
    startPolicyBulkSend: {
      __type: 'PolicyBulkSendRun!',
      __args: {
        clientIds: '[ID!]',
        equipmentCategory: 'PolicyEquipmentScope',
        search: 'String',
        siteId: 'ID!',
        statuses: '[EquipmentComplianceStatus!]',
      },
    },
    startStripeOnboarding: {
      __type: 'StartStripeOnboardingResult!',
      __args: { input: 'StartStripeConnectOnboardingInput!' },
    },
    startSupportChat: {
      __type: 'SupportChatWithMessages!',
      __args: { input: 'StartSupportChatInput!' },
    },
    startSupportChatStream: {
      __type: 'StartSupportChatStreamResult!',
      __args: { input: 'StartSupportChatInput!' },
    },
    startTrial: {
      __type: 'Boolean!',
      __args: { corporateId: 'ID!', durationDays: 'Float!', leadSource: 'LeadSource' },
    },
    streamSupportMessage: {
      __type: 'StreamSupportMessageResult!',
      __args: { input: 'StreamSupportMessageInput!' },
    },
    submitAppleTwoFactorCode: { __type: 'AppleAccountSession!', __args: { code: 'String!' } },
    submitClientForms: {
      __type: 'SubmitClientFormsResponse!',
      __args: {
        clientId: 'String!',
        questionnaireAnswers: '[SubmitClientFormsQuestionnaireAnswersInput!]!',
        siteId: 'String!',
      },
    },
    submitFormAnswers: {
      __type: 'SubmitClientFormsResponse!',
      __args: {
        answers: '[SubmitFormAnswersAnswersInput!]!',
        formSubmissionId: 'String!',
        signature: 'String',
        siteId: 'String!',
      },
    },
    submitMemberSessionFeedback: {
      __type: 'SubmitSessionFeedback!',
      __args: { input: 'MemberSessionFeedbackInput!' },
    },
    submitMyForm: {
      __type: 'MemberFormCompletion!',
      __args: {
        answers: '[MemberFormAnswerInput!]!',
        channel: 'MemberFormChannel',
        formSubmissionId: 'String!',
      },
    },
    submitSessionFeedback: {
      __type: 'SubmitSessionFeedback!',
      __args: { input: 'SubmitSessionFeedbackInputInput!' },
    },
    subscribeToStaffCheckInAlerts: {
      __type: 'Boolean!',
      __args: { fcmToken: 'String!', siteId: 'ID!' },
    },
    subscribeToStaffEquipmentAlerts: {
      __type: 'Boolean!',
      __args: { fcmToken: 'String!', siteId: 'ID!' },
    },
    subscribeToStaffTerminalAlerts: {
      __type: 'Boolean!',
      __args: { fcmToken: 'String!', siteId: 'ID!' },
    },
    subscribeToUserTopic: { __type: 'Boolean!', __args: { fcmToken: 'String!' } },
    substituteInstructor: {
      __type: 'Session!',
      __args: { input: 'SubstituteInstructorInput!', siteId: 'String!' },
    },
    suspendService: {
      __type: 'String!',
      __args: {
        bookingIds: '[String!]',
        chargeAmount: 'Numeric',
        chargeMode: 'ServiceSuspensionChargeMode',
        endDate: 'String',
        failedInvoiceIds: '[String!]',
        feeBillingCycleAmount: 'Float',
        feeBillingCycleUnit: 'String',
        reason: 'String',
        serviceId: 'String!',
        siteId: 'String!',
        startDate: 'String',
        suspensionType: 'ServiceSuspensionType',
      },
    },
    suspendServiceBatch: {
      __type: 'SuspendServiceBatchResult!',
      __args: {
        bookingIds: '[ID!]',
        failedInvoiceIds: '[ID!]',
        pauses: '[SuspendServiceBatchPauseInput!]!',
        serviceId: 'ID!',
        siteId: 'ID!',
      },
    },
    switchBookingToCredit: {
      __type: 'Booking!',
      __args: { additionalServiceIds: '[ID!]', bookingId: 'ID!', serviceId: 'ID!' },
    },
    switchBookingToDropIn: { __type: 'Booking!', __args: { bookingId: 'ID!' } },
    syncBrandStoreListingsFromProviders: {
      __type: '[SyncBrandStoreListingsFromProviders!]!',
      __args: { brandId: 'String!' },
    },
    syncBrandStoreProviderStatus: {
      __type: 'BrandStoreOperationsOverview!',
      __args: { brandId: 'String!' },
    },
    syncClientsToGrow: {
      __type: 'SyncClientsToGrowResponse!',
      __args: { clientIds: '[String!]!' },
    },
    syncKnowledgeArticlesToVertexSearch: { __type: 'SyncToVertexResult!' },
    syncServiceTemplateAddOnParents: {
      __type: '[ServiceTemplateAddOn!]!',
      __args: { input: 'SyncServiceTemplateAddOnParentsInput!' },
    },
    syncSmsPackageOptions: {
      __type: 'SmsPackage!',
      __args: { input: 'SyncSmsPackageOptionsInputInput!', smsPackageId: 'ID!' },
    },
    tanningAgentDownloadUrl: { __type: 'TanningAgentDownloadUrl!' },
    terminateImpersonationSession: { __type: 'Boolean!', __args: { sessionId: 'String!' } },
    testAppleApiConnection: { __type: 'TestAppleApiConnection!', __args: { brandId: 'String!' } },
    testEzypayConnection: { __type: 'TestEzypayConnectionPayload!', __args: { siteId: 'ID!' } },
    testFitnessPassportConnection: {
      __type: 'FitnessPassportConnectionTest!',
      __args: { siteId: 'ID!' },
    },
    testGrowHqAuth: { __type: 'TestHqAuthResponse!', __args: { hqId: 'String!' } },
    testGrowLocationAuth: { __type: 'TestSiteAuthResponse!', __args: { siteId: 'String!' } },
    testSiteAccessPointConnection: {
      __type: 'DoorHealthCheckResult!',
      __args: {
        externalConfig: 'JSONObject!',
        provider: 'DoorProvider!',
        siteAccessPointId: 'String',
        siteId: 'String!',
      },
    },
    testTerminalHandoff: {
      __type: 'TerminalHandoffRequest!',
      __args: { siteId: 'ID!', siteTerminalReaderId: 'ID!' },
    },
    toggleFavoriteReport: { __type: 'Boolean!', __args: { reportName: 'String!' } },
    toggleFavoriteSavedReport: { __type: 'Boolean!', __args: { savedReportId: 'String!' } },
    toggleFrontDeskKioskBeta: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { enabled: 'Boolean!', siteId: 'ID!' },
    },
    toggleSiteFavorite: { __type: 'Boolean!', __args: { siteId: 'String!' } },
    transferClient: {
      __type: 'TransferClientResponse!',
      __args: {
        clientId: 'String!',
        fromSiteId: 'String!',
        newSiteSpecificData: 'AddClientToSiteSiteSpecificDataInput',
        toSiteId: 'String!',
      },
    },
    transitionCommissionPeriod: {
      __type: 'CommissionPeriod!',
      __args: {
        commissionPeriodId: 'ID!',
        revision: 'Int',
        to: 'CommissionPeriodTransitionTarget!',
      },
    },
    triggerFeatureDataRefresh: {
      __type: 'FeatureDataRefreshStatus!',
      __args: { corporateId: 'ID!' },
    },
    triggerGrowHqCustomFieldsSync: {
      __type: 'TriggerGrowHqCustomFieldsSyncResponse!',
      __args: { hqId: 'String!' },
    },
    triggerGrowLocationCustomFieldsSync: {
      __type: 'TriggerGrowSiteCustomFieldsSyncResponse!',
      __args: { siteId: 'String!' },
    },
    triggerHqSync: {
      __type: 'TriggerHqSyncResponse!',
      __args: { forceRecalculate: 'Boolean', migratedTag: 'Boolean!' },
    },
    triggerHqSyncById: {
      __type: 'TriggerSiteSyncResponse!',
      __args: { forceRecalculate: 'Boolean', hqId: 'String!' },
    },
    triggerSandboxMigration: { __type: 'SandboxMigrationJob!', __args: { brandSlug: 'String!' } },
    triggerSandboxResync: { __type: 'SandboxMigrationJob!', __args: { brandSlug: 'String!' } },
    triggerScheduledJob: {
      __type: 'String!',
      __args: { body: 'String', corporateId: 'ID', jobKey: 'String!', siteId: 'ID' },
    },
    triggerSiteSync: {
      __type: 'TriggerSiteSyncResponse!',
      __args: { forceFullSync: 'Boolean!', forceRecalculate: 'Boolean', siteId: 'String!' },
    },
    unblockClientAtSite: {
      __type: 'BlockClientResponse!',
      __args: { clientId: 'String!', siteId: 'String!' },
    },
    undoCheckin: {
      __type: 'UndoCheckinResult!',
      __args: { bookingId: 'String!', siteId: 'String!' },
    },
    unlinkFitnessPassportMember: { __type: 'Boolean!', __args: { clientId: 'ID!', siteId: 'ID!' } },
    unlinkOrganisationEmployee: {
      __type: 'ClientRelationMutationResult!',
      __args: { employeeClientId: 'ID!', organisationClientId: 'ID!', siteId: 'ID!' },
    },
    unlinkSiteFromGrowHq: { __type: 'LinkSiteToHqResponse!', __args: { siteId: 'String!' } },
    unpublishContentEntry: { __type: 'CmsContentEntry!', __args: { contentEntryId: 'ID!' } },
    unscheduleCorporateAddOn: {
      __type: 'CorporateAddOn!',
      __args: { input: 'CorporateServiceTemplateVersionInput!' },
    },
    unskipImportRows: {
      __type: 'SkipImportRows!',
      __args: { importSessionId: 'ID!', rowIndexes: '[Float!]!' },
    },
    unsubscribeFromStaffCheckInAlerts: {
      __type: 'Boolean!',
      __args: { fcmToken: 'String!', siteId: 'ID!' },
    },
    unsubscribeFromStaffEquipmentAlerts: {
      __type: 'Boolean!',
      __args: { fcmToken: 'String!', siteId: 'ID!' },
    },
    unsubscribeFromStaffTerminalAlerts: {
      __type: 'Boolean!',
      __args: { fcmToken: 'String!', siteId: 'ID!' },
    },
    unsubscribeFromUserTopic: { __type: 'Boolean!', __args: { fcmToken: 'String!' } },
    updateAccessControls: {
      __type: 'Site!',
      __args: { input: 'UpdateAccessControlsInputInput', siteId: 'ID!' },
    },
    updateAccessRule: {
      __type: 'StaffAccessRule!',
      __args: {
        input: 'UpdateAccessRuleInputInput!',
        staffAccessRuleId: 'ID!',
        staffUserId: 'ID!',
      },
    },
    updateAccuroFit: {
      __type: 'Site!',
      __args: { input: 'UpdateAccuroFitInputInput', siteId: 'ID!' },
    },
    updateAddOnPriceGroup: {
      __type: 'AddOnPriceGroup!',
      __args: { input: 'UpdateAddOnPriceGroupInput!' },
    },
    updateAdminAccessGroup: {
      __type: 'AdminAccessGroup!',
      __args: { id: 'ID!', input: 'CreateAdminAccessGroupInputInput!' },
    },
    updateAdminUser: {
      __type: 'ID!',
      __args: { adminUserId: 'ID!', input: 'UpdateAdminUserInputInput!' },
    },
    updateAdminUserProfileImage: {
      __type: 'GenerateFileUploadUrlResponse!',
      __args: { adminUserId: 'ID!', input: 'GenerateImagePublicSignedUrlInput!' },
    },
    updateAggregatorAutoAssignSpot: {
      __type: 'Boolean!',
      __args: { aggregatorProviderId: 'String!', autoAssignSpot: 'Boolean!', siteId: 'ID!' },
    },
    updateAggregatorProvider: {
      __type: 'AggregatorProvider!',
      __args: { aggregatorProviderId: 'String!', input: 'AggregatorProviderUpdateInput!' },
    },
    updateAggregatorVenueSync: {
      __type: 'Boolean!',
      __args: { aggregatorProviderId: 'String!', enabled: 'Boolean!', siteId: 'ID!' },
    },
    updateApiCredentialScopes: {
      __type: 'ApiCredential!',
      __args: { apiCredentialId: 'ID!', input: 'ApiCredentialUpdateScopesInput!' },
    },
    updateAppStoreCredentials: {
      __type: 'UpdateAppStoreCredentials!',
      __args: {
        corporateId: 'ID!',
        input: 'UpdateAppStoreCredentialsInputInput!',
        platform: 'String!',
      },
    },
    updateBooking: { __type: 'Booking!', __args: { id: 'String!', input: 'BookingUpdateInput!' } },
    updateBookingAttendance: {
      __type: 'Booking!',
      __args: { id: 'String!', status: 'AttendanceStatus!' },
    },
    updateBrandBuildProfile: {
      __type: 'BrandBuildProfile',
      __args: {
        branchLiveKey: 'String',
        branchTestKey: 'String',
        brandId: 'String!',
        expoOwner: 'String',
        facebook: 'BrandFacebookConfigInput',
        plugins: 'JSONObject',
        translations: 'JSONObject',
      },
    },
    updateBrandConfig: {
      __type: 'SavedBrandConfigVersion!',
      __args: { brandId: 'String!', expectedVersionId: 'String', payload: 'String!' },
    },
    updateBrandIdentity: {
      __type: '[BrandSetupStepView!]!',
      __args: {
        brandId: 'String!',
        force: 'Boolean',
        identity: 'UpdateBrandIdentityIdentityInput!',
      },
    },
    updateBrandNativePermissions: {
      __type: 'BrandNativePermissions!',
      __args: {
        androidPermissions: '[AndroidPermission!]!',
        brandId: 'String!',
        iosUsageDescriptions: '[UpdateBrandNativePermissionsIosUsageDescriptionsInput!]!',
      },
    },
    updateBrandUpdateChannel: {
      __type: 'BrandUpdateChannel!',
      __args: { brandId: 'String!', updateChannel: 'BrandUpdateChannel!' },
    },
    updateCarouselGroup: {
      __type: 'CmsCarouselGroup!',
      __args: { carouselGroupId: 'ID!', input: 'UpdateCarouselGroupInput!' },
    },
    updateClassPass: {
      __type: 'Site!',
      __args: { input: 'UpdateClassPassInputInput', siteId: 'ID!' },
    },
    updateClient: {
      __type: 'UpdateClientResponse!',
      __args: {
        commPrefsSource: 'CommPrefsSource',
        id: 'String!',
        input: 'UpdateClientInput!',
        siteId: 'String!',
      },
    },
    updateClientAccountBalancePreference: {
      __type: 'UpdateClientAccountBalancePreference!',
      __args: {
        clientId: 'String!',
        siteId: 'String!',
        useAccountCreditsOnRecurringInvoices: 'Boolean!',
      },
    },
    updateClientAdmin: {
      __type: 'UpdateClientResponse!',
      __args: { id: 'String!', input: 'UpdateClientInput!' },
    },
    updateClientAlert: {
      __type: 'ClientCustomAlertMutationResponse!',
      __args: { input: 'UpdateClientAlertInputInput!', siteId: 'String!' },
    },
    updateClientCustomPropertyValue: {
      __type: 'UpdateClientCustomPropertyValueResponse!',
      __args: { customPropertyValueId: 'String!', siteId: 'String!', value: 'String!' },
    },
    updateClientCustomPropertyValues: {
      __type: 'UpdateClientCustomPropertyValuesResponse!',
      __args: {
        clientId: 'String!',
        siteId: 'String!',
        values: '[UpdateClientCustomPropertyValuesValuesInput!]!',
      },
    },
    updateClientFeesTemplate: {
      __type: 'ClientFeesTemplate!',
      __args: { id: 'String!', input: 'FeeTemplateInput!' },
    },
    updateClientFileName: {
      __type: 'UpdateClientFileNameResponse!',
      __args: { clientId: 'String!', fileId: 'String!', newFileName: 'String!', siteId: 'String!' },
    },
    updateClientNote: {
      __type: 'UpdateClientNoteResponse!',
      __args: {
        clientId: 'String!',
        input: 'ClientNoteUpdateInput!',
        noteId: 'String!',
        siteId: 'String!',
      },
    },
    updateClientProfileImage: {
      __type: 'GenerateFileUploadUrlResponse!',
      __args: { clientId: 'ID!', input: 'GenerateImagePublicSignedUrlInput!' },
    },
    updateClientRecentSite: {
      __type: 'UpdateClientRecentSite!',
      __args: { clientId: 'String!', siteId: 'String!' },
    },
    updateClientRelation: {
      __type: 'ClientFamily!',
      __args: {
        clientId: 'String!',
        familyMemberClientId: 'String!',
        input: 'UpdateClientFamilyInput!',
        siteId: 'String!',
      },
    },
    updateClientSiteData: {
      __type: 'UpdateClientSiteDataResponse!',
      __args: {
        clientId: 'String!',
        siteId: 'String!',
        siteSpecificData: 'AddClientToSiteSiteSpecificDataInput!',
      },
    },
    updateCommissionItemSetting: {
      __type: 'CommissionItemSetting!',
      __args: {
        isCommissionable: 'Boolean',
        itemId: 'String!',
        itemType: 'CommissionItemType!',
        requireSoldBy: 'Boolean',
        siteId: 'ID',
      },
    },
    updateCommissionPlanAvailability: {
      __type: 'CommissionPlanAvailabilityChange!',
      __args: { commissionPlanId: 'ID!', effectiveFrom: 'String', siteIds: '[ID!]!' },
    },
    updateCommissionSettings: {
      __type: 'CommissionSettings!',
      __args: { effectiveFrom: 'String', patch: 'JSONObject!' },
    },
    updateCommissionSiteSettings: {
      __type: 'CommissionSiteSettings!',
      __args: { onlineDefaultSellerStaffUserId: 'ID', siteId: 'ID!' },
    },
    updateCommunicationTemplate: {
      __type: 'CommunicationTemplate!',
      __args: {
        communicationTemplate: 'UpdateCommunicationTemplateCommunicationTemplateInput!',
        communicationTemplateId: 'ID!',
      },
    },
    updateContentEntry: {
      __type: 'CmsContentEntry!',
      __args: {
        changeNote: 'String',
        contentEntryId: 'ID!',
        expectedVersion: 'Float!',
        input: 'CmsContentEntryUpdateInput!',
      },
    },
    updateCorporate: {
      __type: 'Corporate!',
      __args: { corporateId: 'String!', input: 'UpdateCorporateInput!' },
    },
    updateCorporateAddOnDraft: {
      __type: 'CorporateAddOn!',
      __args: { input: 'UpdateCorporateAddOnDraftInput!' },
    },
    updateCorporateClassPass: {
      __type: 'Corporate!',
      __args: { corporateId: 'String!', siteIds: '[String!]!' },
    },
    updateCorporateCommunicationSettings: {
      __type: 'Corporate!',
      __args: { corporateId: 'ID!', input: 'UpdateCorporateCommunicationSettingsInput!' },
    },
    updateCorporateCommunicationTemplate: {
      __type: 'CorporateCommunicationTemplate!',
      __args: {
        corporateCommunicationTemplateId: 'ID!',
        input: 'CorporateCommunicationTemplateUpdateInput!',
      },
    },
    updateCorporateCommunicationTemplateEnableEmail: {
      __type: 'CorporateCommunicationTemplate!',
      __args: {
        alias: 'CommunicationTemplateAliases!',
        corporateCommunicationTemplateId: 'String!',
        enableEmail: 'Boolean!',
      },
    },
    updateCorporateCommunicationTemplateEnablePush: {
      __type: 'CorporateCommunicationTemplate!',
      __args: {
        alias: 'CommunicationTemplateAliases!',
        corporateCommunicationTemplateId: 'ID!',
        enablePush: 'Boolean',
      },
    },
    updateCorporateCommunicationTemplateEnableSms: {
      __type: 'CorporateCommunicationTemplate!',
      __args: {
        alias: 'CommunicationTemplateAliases!',
        corporateCommunicationTemplateId: 'String!',
        enableSms: 'Boolean',
      },
    },
    updateCorporateCommunicationTemplateVersion: {
      __type: 'CorporateCommunicationTemplateVersion!',
      __args: {
        corporateCommunicationTemplateId: 'ID!',
        corporateCommunicationTemplateVersionId: 'ID!',
        input: 'CorporateCommunicationTemplateVersionUpdateInput!',
      },
    },
    updateCorporateCustomThirdPartyIntegration: {
      __type: 'Corporate!',
      __args: { corporateId: 'ID!', input: 'UpdateCorporateCustomThirdPartyIntegrationInput!' },
    },
    updateCorporateFaq: {
      __type: 'CorporateFaq!',
      __args: { corporateFaqId: 'ID!', input: 'UpdateCorporateFaqInput!' },
    },
    updateCorporatePayoutAccount: {
      __type: 'CorporatePayoutAccount!',
      __args: { corporateId: 'ID!', id: 'ID!', input: 'UpdateCorporatePayoutAccountInputInput!' },
    },
    updateCorporateSessionType: {
      __type: 'CorporateSessionType!',
      __args: { corporateSessionTypeId: 'ID!', input: 'UpdateCorporateSessionTypeInput!' },
    },
    updateCorporateTaxSetting: {
      __type: 'CorporateTaxSetting!',
      __args: { corporateTaxSettingId: 'ID!', input: 'UpdateCorporateTaxSettingInput!' },
    },
    updateCorporateWebhook: {
      __type: 'CorporateWebhook!',
      __args: { corporateId: 'ID!', input: 'UpdateCorporateWebhookInputInput!', webhookId: 'ID!' },
    },
    updateCustomProperty: {
      __type: 'CustomProperty!',
      __args: { id: 'String!', input: 'CustomPropertyUpdateInput!', siteId: 'ID!' },
    },
    updateCustomPropertyAlert: {
      __type: 'UpdateCustomPropertyAlert!',
      __args: {
        alertId: 'String!',
        input: 'CustomPropertyAlertUpdateInput!',
        propertyId: 'String!',
        siteId: 'ID!',
      },
    },
    updateCustomText: {
      __type: 'UpdateCustomText!',
      __args: {
        corporateId: 'String!',
        language: 'String!',
        sanitize: 'Boolean!',
        translations: 'JSONObject!',
        userId: 'String',
      },
    },
    updateDeepLinkSettings: {
      __type: 'DeepLinkSettings!',
      __args: {
        androidUrl: 'String',
        corporateId: 'String!',
        desktopUrl: 'String',
        fallbackUrl: 'String',
        iosUrl: 'String',
      },
    },
    updateDigitalChannel: {
      __type: 'SiteLocation!',
      __args: { input: 'UpdateSiteLocationInput!', siteId: 'ID!', siteLocationId: 'ID!' },
    },
    updateDishonorFee: {
      __type: '[Invoice!]!',
      __args: { newFeeAmount: 'String!', paymentId: 'ID', paymentIds: '[ID!]', siteId: 'ID!' },
    },
    updateEgymIntegration: {
      __type: 'Site!',
      __args: { input: 'UpdateEgymIntegrationInput!', siteId: 'ID!' },
    },
    updateEmbedCustomization: {
      __type: 'EmbedSetupResponse!',
      __args: {
        corporateId: 'String!',
        customization: 'UpdateEmbedCustomizationCustomizationInput!',
      },
    },
    updateEmbedWebsiteWidgets: {
      __type: 'EmbedSetupResponse!',
      __args: {
        corporateId: 'String!',
        websiteWidgets: 'UpdateEmbedWebsiteWidgetsWebsiteWidgetsInput!',
      },
    },
    updateEquipment: {
      __type: 'Equipment!',
      __args: { equipmentId: 'String!', input: 'UpdateEquipmentInput!' },
    },
    updateEquipmentLampSettings: {
      __type: 'Equipment!',
      __args: { input: 'UpdateEquipmentLampSettingsInput!' },
    },
    updateEquipmentRegulation: {
      __type: 'EquipmentRegulation!',
      __args: { input: 'UpdateEquipmentRegulationInput!', regulationId: 'String!' },
    },
    updateEquipmentStatus: {
      __type: 'Equipment!',
      __args: { equipmentId: 'String!', status: 'EquipmentStatus!' },
    },
    updateEquipmentStatusByTimerId: {
      __type: 'Equipment',
      __args: { agentStatus: 'AgentStatus!', siteId: 'String!', timerId: 'Int!' },
    },
    updateExternalFeedbackLink: {
      __type: 'Site!',
      __args: { input: 'UpdateExternalFeedbackLinkInputInput', siteId: 'ID!' },
    },
    updateEzypayGateway: {
      __type: 'UpdateEzypayGatewayPayload!',
      __args: { input: 'UpdateEzypayGatewayInput!' },
    },
    updateFacebookPixel: {
      __type: 'Site!',
      __args: { input: 'UpdateFacebookPixelInputInput', siteId: 'ID!' },
    },
    updateFamilyMemberPermission: {
      __type: 'Family!',
      __args: { canBook: 'Boolean!', clientId: 'ID!', siteId: 'ID!' },
    },
    updateFamilyMemberRole: {
      __type: 'Family!',
      __args: { clientId: 'ID!', role: 'FamilyMemberRole!', siteId: 'ID!' },
    },
    updateFamilySettings: {
      __type: 'FamilySettings!',
      __args: { input: 'UpdateFamilySettingsInputInput!' },
    },
    updateFeatureEnvCcEmails: {
      __type: 'FeatureEnvEmailSettings!',
      __args: { ccEmails: '[String!]!' },
    },
    updateFeeConfiguration: {
      __type: 'FeeConfiguration!',
      __args: { id: 'String!', input: 'UpdateFeeConfigurationInputInput!' },
    },
    updateFitnessPassport: {
      __type: 'Site!',
      __args: { input: 'UpdateFitnessPassportInput!', siteId: 'ID!' },
    },
    updateFrontDeskKiosk: {
      __type: 'Site!',
      __args: { input: 'UpdateFrontDeskKioskInput!', siteId: 'ID!' },
    },
    updateGiftCardExpiry: {
      __type: 'UpdateGiftCardExpiryResult!',
      __args: { expiryDate: 'String', giftCardId: 'ID!', siteId: 'ID!' },
    },
    updateGiftCardExpiryRule: {
      __type: 'GiftCardExpiryRuleRecord!',
      __args: {
        disclosureRequired: 'Boolean!',
        effectiveFrom: 'String!',
        expiryPolicy: 'GiftCardExpiryPolicy!',
        giftCardExpiryRuleId: 'ID!',
        legalCitation: 'String',
        maximumTermMonths: 'Float',
        minimumTermMonths: 'Float',
        notes: 'String',
        sourceUrl: 'String',
      },
    },
    updateGiftCardTemplate: {
      __type: 'GiftCardTemplate!',
      __args: { giftCardTemplateId: 'ID!', input: 'GiftCardTemplateUpdateInput!' },
    },
    updateGiftCardTemplatesSharedSites: {
      __type: 'Boolean!',
      __args: { input: 'UpdateGiftCardTemplatesSharedSitesInput!' },
    },
    updateGoal: { __type: 'CmsGoal!', __args: { goalId: 'ID!', input: 'UpdateGoalInput!' } },
    updateGoogleTagManager: {
      __type: 'Site!',
      __args: { input: 'UpdateGoogleTagManagerInputInput', siteId: 'ID!' },
    },
    updateGrowHq: {
      __type: 'GrowHq!',
      __args: { growHqId: 'String!', growHqInput: 'UpdateGrowHqInput!' },
    },
    updateHapanaAccessController: {
      __type: 'Site!',
      __args: { input: 'UpdateHapanaAccessControllerInputInput', siteId: 'ID!' },
    },
    updateHapanaFeesTemplate: {
      __type: 'HapanaFeesTemplate!',
      __args: {
        failedPaymentFeeScope: 'FailedPaymentFeeScope',
        id: 'String!',
        input: 'FeeTemplateInput!',
      },
    },
    updateImportRow: {
      __type: 'UpdateImportRow!',
      __args: { fieldUpdates: 'String!', importSessionId: 'ID!', rowIndex: 'Float!' },
    },
    updateImportSession: {
      __type: 'UpdateImportSession!',
      __args: {
        defaultSiteId: 'ID',
        importSessionId: 'ID!',
        locationSiteMap: 'String',
        validSiteIds: 'String',
      },
    },
    updateInvoice: {
      __type: 'Invoice!',
      __args: { input: 'CreateInvoiceInputInput!', invoiceId: 'ID!', siteId: 'ID!' },
    },
    updateInvoiceClient: {
      __type: 'Invoice!',
      __args: { beneficiaryId: 'ID', clientId: 'ID', invoiceId: 'ID!', siteId: 'ID!' },
    },
    updateKioskDefaults: {
      __type: 'KioskDefaults!',
      __args: { corporateId: 'String!', input: 'UpdateKioskDefaultsInput!' },
    },
    updateKnowledgeArticle: {
      __type: 'KnowledgeArticle!',
      __args: { input: 'KnowledgeArticleUpdateInput!', knowledgeArticleId: 'ID!' },
    },
    updateKnowledgeArticleCategory: {
      __type: 'KnowledgeArticleCategory!',
      __args: { input: 'KnowledgeArticleCategoryUpdateInput!', knowledgeArticleCategoryId: 'ID!' },
    },
    updateKnowledgeArticleRevision: {
      __type: 'KnowledgeArticleRevision!',
      __args: { input: 'KnowledgeArticleRevisionContentInput!', revisionId: 'ID!' },
    },
    updateKnowledgeDocument: {
      __type: 'KnowledgeDocument!',
      __args: { id: 'ID!', input: 'KnowledgeDocumentInput!' },
    },
    updateLeaderboardConfig: {
      __type: 'LeaderboardConfig!',
      __args: { input: 'UpdateLeaderboardConfigInputInput!', leaderboardConfigId: 'String!' },
    },
    updateMe: { __type: 'Self!', __args: { input: 'UpdateMeInputInput!' } },
    updateMediaAsset: {
      __type: 'CmsContentMedia!',
      __args: { contentMediaId: 'ID!', input: 'CmsContentMediaUpdateInput!' },
    },
    updateMemberExperienceBranding: {
      __type: 'UpdateMemberExperienceBranding!',
      __args: {
        appName: 'String',
        backgroundColor: 'String',
        corporateId: 'String!',
        darkBackgroundColor: 'String',
        darkPrimaryColor: 'String',
        darkPrimaryTextColor: 'String',
        darkSecondaryBackgroundColor: 'String',
        darkSecondaryColor: 'String',
        darkSecondaryTextColor: 'String',
        faviconUrl: 'String',
        logoUrl: 'String',
        primaryColor: 'String',
        primaryTextColor: 'String',
        secondaryBackgroundColor: 'String',
        secondaryColor: 'String',
        secondaryTextColor: 'String',
        userId: 'String',
      },
    },
    updateMemberExperienceFonts: {
      __type: 'UpdateMemberExperienceFonts!',
      __args: {
        corporateId: 'String!',
        customFonts: '[FinalizeCustomFontFontInput!]',
        customHeadingFonts: '[FinalizeCustomFontFontInput!]',
        fontFamily: 'String!',
        fontScale: 'Float',
        fontSource: 'FontSource!',
        fontUrl: 'String',
        headingFontFamily: 'String',
        headingFontSource: 'HeadingFontSource',
        headingFontUrl: 'String',
        useCustomHeadingFont: 'Boolean',
        userId: 'String',
      },
    },
    updateMemberExperienceSettings: {
      __type: 'UpdateMemberExperienceSettings!',
      __args: {
        awardsEnabled: 'Boolean',
        barcodeEnabled: 'Boolean',
        borderRadius: 'Float',
        brandLogoEnabled: 'Boolean',
        buttonStyle: 'WidgetButtonStyle',
        callUsEnabled: 'Boolean',
        challengesEnabled: 'Boolean',
        classTimeFilter: 'Boolean',
        contactlessCheckin: 'Boolean',
        corporateId: 'String!',
        customCssLink: 'String',
        darkMode: 'MemberExperienceDarkMode',
        darkModeSupport: 'Boolean',
        displayInstructor: 'Boolean',
        displayPackageDescription: 'Boolean',
        displayProfilePicture: 'Boolean',
        doorCheckin: 'Boolean',
        dynamicImagesEnabled: 'Boolean',
        editFieldsAddress: 'Boolean',
        editFieldsDob: 'Boolean',
        editFieldsEnabled: 'Boolean',
        editFieldsName: 'Boolean',
        editFieldsPhone: 'Boolean',
        facebookAppId: 'String',
        facebookClientToken: 'String',
        facebookDisplayName: 'String',
        filterOptions: 'UpdateMemberExperienceSettingsFilterOptionsInput',
        fontSize: 'Float',
        footerVisible: 'Boolean',
        headerVisible: 'Boolean',
        moduleClasses: 'Boolean',
        moduleDashboard: 'Boolean',
        modulePackages: 'Boolean',
        modulePayments: 'Boolean',
        modulePrivates: 'Boolean',
        moduleProfile: 'Boolean',
        moduleSchedule: 'Boolean',
        moduleWorkshops: 'Boolean',
        newsFeedAvailable: 'Boolean',
        privatesAnyAvailable: 'Boolean',
        redirectUrl: 'String',
        showBilling: 'Boolean',
        showFilters: 'Boolean',
        shownCommPref: 'Boolean',
        sidebarPosition: 'SidebarPosition',
        signUpEnabled: 'Boolean',
        statsAvailable: 'Boolean',
        streakScope: 'MemberExperienceStreakScope',
        tabDigitalEnabled: 'Boolean',
        tabPurchaseEnabled: 'Boolean',
        userId: 'String',
      },
    },
    updateMemberExperienceSurfaceBranding: {
      __type: 'UpdateMemberExperienceSurfaceBrandingResponse!',
      __args: {
        backgroundColor: 'String',
        corporateId: 'String!',
        darkBackgroundColor: 'String',
        darkPrimaryColor: 'String',
        darkPrimaryTextColor: 'String',
        darkSecondaryBackgroundColor: 'String',
        darkSecondaryColor: 'String',
        darkSecondaryTextColor: 'String',
        inheritsGlobal: 'Boolean!',
        primaryColor: 'String',
        primaryTextColor: 'String',
        secondaryBackgroundColor: 'String',
        secondaryColor: 'String',
        secondaryTextColor: 'String',
        surface: 'MemberExperienceSurface!',
        userId: 'String',
      },
    },
    updateMemberMovementConfig: {
      __type: 'MemberMovementConfig!',
      __args: {
        attestation: 'MemberMovementAttestationInput!',
        corporateId: 'String!',
        input: 'MemberMovementConfigInput!',
      },
    },
    updateMemberMovementRunConfig: {
      __type: 'MemberMovementRun!',
      __args: { input: 'UpdateMemberMovementRunConfigInput!' },
    },
    updateMembershipTierOrders: {
      __type: 'Boolean!',
      __args: { input: 'UpdateMembershipTierOrdersInput!' },
    },
    updateMobileAppBranding: {
      __type: 'UpdateMobileAppBranding!',
      __args: {
        accentColor: 'String',
        appIconUrl: 'String',
        backgroundColor: 'String',
        corporateId: 'String!',
        faviconUrl: 'String',
        fontConfig: 'JSONObject',
        fontFamily: 'String',
        logoUrl: 'String',
        modulesConfig: 'JSONObject',
        primaryColor: 'String',
        secondaryColor: 'String',
        splashScreenDarkUrl: 'String',
        splashScreenUrl: 'String',
        textColor: 'String',
        userId: 'String',
      },
    },
    updateMobileAppChannels: {
      __type: 'UpdateMobileAppChannels!',
      __args: {
        androidConfig: 'JSONObject',
        androidEnabled: 'Boolean',
        androidMinVersion: 'String',
        androidPackageName: 'String',
        androidPlayStoreUrl: 'String',
        androidVersion: 'String',
        channels: 'JSONObject',
        corporateId: 'String!',
        deployment: 'JSONObject',
        deploymentStatus: 'String',
        iosAppStoreUrl: 'String',
        iosBundleId: 'String',
        iosConfig: 'JSONObject',
        iosEnabled: 'Boolean',
        iosMinVersion: 'String',
        iosVersion: 'String',
        lastDeployedAt: 'String',
        userId: 'String',
      },
    },
    updateMobileAppCustomization: {
      __type: 'MobileSetupResponse!',
      __args: { corporateId: 'String!', customization: 'MobileCustomizationInput!' },
    },
    updateMobileAppProfile: {
      __type: 'UpdateMobileAppProfile!',
      __args: {
        address: 'String',
        appDescription: 'String',
        appName: 'String!',
        appShortDescription: 'String',
        branchIoKey: 'String',
        branchIoLiveKey: 'String',
        branchIoSecret: 'String',
        businessName: 'String',
        contentfulAccessToken: 'String',
        contentfulPreviewToken: 'String',
        contentfulSpaceId: 'String',
        corporateId: 'String!',
        description: 'String',
        distributionCountries: '[String!]',
        email: 'String',
        evoltApiKey: 'String',
        facebookUrl: 'String',
        instagramUrl: 'String',
        jwPlayerApiKey: 'String',
        linkedinUrl: 'String',
        oneSignalApiKey: 'String',
        oneSignalAppId: 'String',
        phone: 'String',
        privacyPolicyUrl: 'String',
        socialLinks: 'JSONObject',
        supportEmail: 'String',
        supportUrl: 'String',
        tagline: 'String',
        termsAndConditionsUrl: 'String',
        twitterUrl: 'String',
        userId: 'String',
        website: 'String',
        youtubeUrl: 'String',
      },
    },
    updateMyCoverPreferences: {
      __type: 'MyCoverPreferences!',
      __args: { emailOffersEnabled: 'Boolean', smsOptIn: 'Boolean' },
    },
    updatePaymentContactEmail: { __type: 'Boolean!', __args: { email: 'String!', siteId: 'ID!' } },
    updatePosCategory: {
      __type: 'UpdatePosCategoryResponse!',
      __args: { input: 'UpdatePosCategoryInput!', posCategoryId: 'ID!', siteId: 'ID!' },
    },
    updatePosProduct: {
      __type: 'UpdatePosProductResponse!',
      __args: { input: 'UpdatePosProductInput!', posProductId: 'ID!', siteId: 'ID!' },
    },
    updatePosProductVariableFeatured: {
      __type: 'UpdatePosProductVariableFeaturedResponse!',
      __args: { posProductId: 'ID!', posProductVariableId: 'ID!', siteId: 'ID!' },
    },
    updatePresaleInitialInvoiceAmount: {
      __type: 'Invoice!',
      __args: { input: 'UpdatePresaleInitialInvoiceAmountInput!', siteId: 'ID!' },
    },
    updatePresaleInitialInvoiceDate: {
      __type: 'Invoice!',
      __args: { input: 'UpdatePresaleInitialInvoiceDateInput!', siteId: 'ID!' },
    },
    updateProfileImage: {
      __type: 'GenerateFileUploadUrlResponse!',
      __args: { input: 'GenerateImagePublicSignedUrlInput!', staffUserId: 'ID!' },
    },
    updatePromoCode: {
      __type: 'PromoCode!',
      __args: { input: 'PromoCodeUpdateInput!', promoCodeId: 'ID!' },
    },
    updateRebateTemplate: {
      __type: 'RebateTemplate!',
      __args: { id: 'ID!', input: 'RebateTemplateUpdate!' },
    },
    updateRegion: {
      __type: 'Regions!',
      __args: { input: 'UpdateRegionInputInput!', regionId: 'ID!' },
    },
    updateReleaseNote: {
      __type: 'ReleaseNote!',
      __args: { input: 'ReleaseNoteUpdateInput!', releaseNoteId: 'ID!' },
    },
    updateRoomResourceTemplate: {
      __type: 'SiteRoomResourceTemplateResponse!',
      __args: { id: 'String!', input: 'UpdateSiteRoomResourceTemplateInput!', siteId: 'String!' },
    },
    updateRoyaltiesAndFeesTemplate: {
      __type: 'RoyaltiesAndFeesTemplate!',
      __args: { id: 'ID!', input: 'RoyaltiesAndFeesTemplateUpdate!' },
    },
    updateSavedReport: {
      __type: 'SavedReport!',
      __args: { input: 'UpdateSavedReportInputInput!' },
    },
    updateSavedReportCategory: {
      __type: 'CreateSavedReportCategory!',
      __args: { name: 'String!', savedReportCategoryId: 'String!' },
    },
    updateScheduledInvoiceDate: {
      __type: 'Invoice!',
      __args: { input: 'UpdateScheduledInvoiceDateInput!', siteId: 'ID!' },
    },
    updateScheduledPushSend: {
      __type: 'ScheduledPushSend!',
      __args: { input: 'UpdateScheduledPushSendInput!' },
    },
    updateSelfWorkingHours: {
      __type: 'Self!',
      __args: { siteId: 'ID!', workingHours: 'UpdateWorkingHoursWorkingHoursInput!' },
    },
    updateServiceAutoRenew: {
      __type: 'Boolean!',
      __args: { autoRenew: 'Boolean!', serviceId: 'String!' },
    },
    updateServiceTemplate: {
      __type: 'ServiceTemplate!',
      __args: { input: 'UpdateServiceTemplateInputInput!', serviceTemplateId: 'String!' },
    },
    updateServiceTemplateAccountCode: {
      __type: 'ServiceTemplate!',
      __args: { accountCodeId: 'ID', serviceTemplateId: 'String!', siteId: 'ID!' },
    },
    updateServiceTemplateCategory: {
      __type: 'UpdateServiceTemplateCategoryResponse!',
      __args: {
        input: 'UpdateServiceTemplateCategoryInput!',
        serviceTemplateCategoryId: 'String!',
        siteId: 'String!',
      },
    },
    updateServiceTemplateFeatured: {
      __type: 'UpdateServiceTemplateFeaturedResponse!',
      __args: { serviceTemplateId: 'ID!', siteId: 'ID!' },
    },
    updateServiceTemplateSessionTypeAddOn: {
      __type: 'ServiceTemplateSessionTypeAddOn!',
      __args: { input: 'UpdateServiceTemplateSessionTypeAddOnInput!' },
    },
    updateSession: {
      __type: 'Session!',
      __args: {
        id: 'String!',
        input: 'SessionUpdateInput!',
        overrideDownstreamSplits: 'Boolean',
        scope: 'RecurringSessionEditScope',
        siteId: 'String!',
      },
    },
    updateSessionFeedbackQuestion: {
      __type: 'SessionFeedbackQuestion!',
      __args: { input: 'SessionFeedbackQuestionUpdateInput!', questionId: 'ID!', siteId: 'ID!' },
    },
    updateSessionFilter: {
      __type: 'SessionFilter!',
      __args: { input: 'SessionFilterUpdateInput!', sessionFilterId: 'String!', siteId: 'String!' },
    },
    updateSessionTemplate: {
      __type: 'SessionTemplate!',
      __args: { id: 'String!', input: 'SessionTemplateUpdateInput!', siteId: 'String!' },
    },
    updateSessionWithResult: {
      __type: 'SessionUpdateResult!',
      __args: {
        id: 'String!',
        includeModifiedSessions: 'Boolean',
        input: 'SessionUpdateInput!',
        overrideDownstreamSplits: 'Boolean',
        scope: 'RecurringSessionEditScope',
        siteId: 'String!',
      },
    },
    updateSite: { __type: 'Site!', __args: { input: 'UpdateSiteInputInput!', siteId: 'ID!' } },
    updateSiteAccessPoint: {
      __type: 'SiteAccessPoint!',
      __args: {
        input: 'SiteAccessPointUpdateInput!',
        siteAccessPointId: 'String!',
        siteId: 'String!',
      },
    },
    updateSiteAccessZone: {
      __type: 'SiteAccessZone!',
      __args: {
        input: 'SiteAccessZoneUpdateInput!',
        siteAccessZoneId: 'String!',
        siteId: 'String!',
      },
    },
    updateSiteAccountCode: {
      __type: 'SiteAccountCode!',
      __args: { accountCodeId: 'ID!', input: 'UpdateSiteAccountCodeInput!', siteId: 'ID!' },
    },
    updateSiteAccountCodeConfig: {
      __type: 'SiteAccountCodeConfig!',
      __args: { input: 'SiteAccountCodeConfigInput!', siteId: 'ID!' },
    },
    updateSiteAlert: { __type: 'SiteAlertListItem!', __args: { input: 'UpdateSiteAlertInput!' } },
    updateSiteCommunicationTemplate: {
      __type: 'UpdateSiteCommunicationTemplate!',
      __args: {
        alias: 'CommunicationTemplateAliases!',
        payload: 'SiteCommunicationTemplateUpdateInput!',
        siteId: 'ID!',
      },
    },
    updateSiteCommunicationTemplateEmailStatus: {
      __type: 'UpdateSiteCommunicationTemplateEmailStatus!',
      __args: { alias: 'CommunicationTemplateAliases!', enabled: 'Boolean!', siteId: 'ID!' },
    },
    updateSiteCommunicationTemplatePushNotificationStatus: {
      __type: 'UpdateSiteCommunicationTemplatePushNotificationStatus!',
      __args: { alias: 'CommunicationTemplateAliases!', enabled: 'Boolean!', siteId: 'ID!' },
    },
    updateSiteCommunicationTemplateSmsStatus: {
      __type: 'UpdateSiteCommunicationTemplateSmsStatus!',
      __args: { alias: 'CommunicationTemplateAliases!', enabled: 'Boolean!', siteId: 'ID!' },
    },
    updateSiteCommunicationsSettings: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { siteId: 'ID!', updates: 'UpdateSiteCommunicationsSettingsUpdatesInput!' },
    },
    updateSiteCustomThirdPartyIntegration: {
      __type: 'Site!',
      __args: { input: 'UpdateSiteCustomThirdPartyIntegrationInput!', siteId: 'ID!' },
    },
    updateSiteForm: {
      __type: 'SiteForm!',
      __args: { id: 'String!', input: 'SiteFormUpdateInput!', siteId: 'ID!' },
    },
    updateSiteFormQuestion: {
      __type: 'SiteFormMutationResponse!',
      __args: {
        input: 'SiteFormQuestionUpdateInput!',
        questionId: 'String!',
        siteFormId: 'String!',
        siteId: 'ID!',
      },
    },
    updateSiteGroup: {
      __type: 'SiteGroup!',
      __args: {
        acknowledgedWithdrawals: '[BrandServiceTemplateWithdrawalAcknowledgementInput!]',
        input: 'UpdateSiteGroupInputInput!',
        siteGroupId: 'ID!',
      },
    },
    updateSiteLocation: {
      __type: 'SiteLocation!',
      __args: { input: 'UpdateSiteLocationInput!', siteId: 'ID!', siteLocationId: 'ID!' },
    },
    updateSiteLocationRoom: {
      __type: 'SiteLocationRoom!',
      __args: {
        input: 'UpdateSiteLocationRoomInput!',
        siteId: 'ID!',
        siteLocationId: 'ID!',
        siteLocationRoomId: 'ID!',
      },
    },
    updateSiteMemberAppSettings: {
      __type: 'SiteMemberAppSettingsResult!',
      __args: { input: 'UpdateSiteMemberAppSettingsInput!' },
    },
    updateSiteName: { __type: 'Site!', __args: { name: 'String!', siteId: 'ID!' } },
    updateSiteOpeningHours: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'UpdateSiteOpeningHoursInput!' },
    },
    updateSitePaymentAuthorisationConfig: {
      __type: 'SitePaymentAuthorisationConfig!',
      __args: {
        bankDebitCoversLocationsFrom: 'String',
        bankDebitEvidenceReference: 'String',
        bankDebitOriginatorName: 'String',
        cancellationPolicy: 'String',
        customerServiceContact: 'String',
        depositNote: 'String',
        legalEntityName: 'String',
        salesTaxNote: 'String',
        siteId: 'ID!',
        template: 'String',
      },
    },
    updateSitePayrollTier: {
      __type: 'CreateSitePayrollTier!',
      __args: { id: 'ID!', input: 'UpdateSitePayrollTierInputInput!', siteId: 'ID!' },
    },
    updateSitePayrollTierConfiguration: {
      __type: 'CreateSitePayrollTierConfiguration!',
      __args: {
        input: 'UpdateSitePayrollTierConfigurationInputInput!',
        siteId: 'ID!',
        sitePayrollTierConfigurationId: 'ID!',
        sitePayrollTierId: 'ID!',
      },
    },
    updateSitePlanOverride: {
      __type: 'Site!',
      __args: { input: 'UpdateSitePlanOverrideInput!', siteId: 'ID!' },
    },
    updateSitePolicy: {
      __type: 'SitePolicyUpdateResult!',
      __args: { id: 'String!', input: 'SitePolicyUpdateInput!', siteId: 'String!' },
    },
    updateSitePolicyComplianceSettings: {
      __type: 'PolicyComplianceSettings!',
      __args: { input: 'PolicyComplianceSettingsInput!', siteId: 'ID!' },
    },
    updateSiteSessionType: {
      __type: 'SiteSessionType!',
      __args: { id: 'String!', input: 'SiteSessionTypeUpdateInput!', siteId: 'String!' },
    },
    updateSiteSettingsAccountBankFailoverToCard: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { enabled: 'Boolean!', siteId: 'ID!' },
    },
    updateSiteSettingsAccountBilling: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'UpdateSiteSettingsAccountBillingInputInput!', siteId: 'ID!' },
    },
    updateSiteSettingsAccountInvoice: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'UpdateSiteSettingsAccountInvoiceInputInput!', siteId: 'ID!' },
    },
    updateSiteSettingsAccountPayroll: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'UpdateSiteSettingsAccountPayrollInputInput!', siteId: 'ID!' },
    },
    updateSiteSettingsAccountPointOfSale: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'UpdateSiteSettingsAccountPointOfSaleInputInput!', siteId: 'ID!' },
    },
    updateSiteSettingsAccountTax: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'UpdateSiteSettingsAccountTaxInputInput!', siteId: 'ID!' },
    },
    updateSiteSettingsBlockingReasons: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'UpdateSiteSettingsBlockingReasonsInputInput!', siteId: 'ID!' },
    },
    updateSiteSettingsBusinessCustomization: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'UpdateSiteSettingsBusinessCustomizationInputInput!', siteId: 'ID!' },
    },
    updateSiteSettingsBusinessLocations: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'UpdateSiteSettingsBusinessLocationsInputInput!', siteId: 'ID!' },
    },
    updateSiteSettingsCalendarConfigurations: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'UpdateSiteSettingsCalendarConfigurationsInputInput!', siteId: 'ID!' },
    },
    updateSiteSettingsCancellationReasons: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'UpdateSiteSettingsCancellationReasonsInputInput!', siteId: 'ID!' },
    },
    updateSiteSettingsCheckIn: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'UpdateSiteSettingsCheckInInputInput!', siteId: 'ID!' },
    },
    updateSiteSettingsContactlessCheckIn: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'UpdateSiteSettingsContactlessCheckInInputInput!', siteId: 'ID!' },
    },
    updateSiteSettingsContactlessCheckInFormQuestions: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: {
        input: 'UpdateSiteSettingsContactlessCheckInFormQuestionsInputInput!',
        siteId: 'ID!',
      },
    },
    updateSiteSettingsCustomizationColor: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: {
        colorId: 'String!',
        input: 'CreateSiteSettingsCustomizationColorInputInput!',
        siteId: 'ID!',
      },
    },
    updateSiteSettingsLeadSources: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'LeadSourcesBulkUpdateInput!', siteId: 'ID!' },
    },
    updateSiteSettingsLocationOperationBusinessSignUpFields: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: {
        input: 'UpdateSiteSettingsLocationOperationBusinessSignUpFieldsInputInput!',
        siteId: 'ID!',
      },
    },
    updateSiteSettingsLocationOperationClientSignUpFields: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: {
        input: 'UpdateSiteSettingsLocationOperationClientSignUpFieldsInputInput!',
        siteId: 'ID!',
      },
    },
    updateSiteSettingsLocationOperationsMain: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'UpdateSiteSettingsLocationOperationsMainInputInput!', siteId: 'ID!' },
    },
    updateSiteSettingsRefundReasons: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'RefundReasonsBulkUpdateInput!', siteId: 'ID!' },
    },
    updateSiteSettingsRegionalCommunication: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'UpdateSiteSettingsRegionalCommunicationInputInput!', siteId: 'ID!' },
    },
    updateSiteSettingsRetailAdditionalBillingTypes: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'UpdateSiteSettingsRetailAdditionalBillingTypesInputInput!', siteId: 'ID!' },
    },
    updateSiteSettingsRetailCredits: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'UpdateSiteSettingsRetailCreditsInputInput!', siteId: 'ID!' },
    },
    updateSiteSettingsRetailFees: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'UpdateSiteSettingsRetailFeesInputInput!', siteId: 'ID!' },
    },
    updateSiteSettingsRetailGeneralSales: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'UpdateSiteSettingsRetailGeneralSalesInputInput!', siteId: 'ID!' },
    },
    updateSiteSettingsRetailGiftcards: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'UpdateSiteSettingsRetailGiftcardsInputInput!', siteId: 'ID!' },
    },
    updateSiteSettingsRetailSalesSettings: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'UpdateSiteSettingsRetailSalesSettingsInputInput!', siteId: 'ID!' },
    },
    updateSiteSettingsRetailSuspensions: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'UpdateSiteSettingsRetailSuspensionsInputInput!', siteId: 'ID!' },
    },
    updateSiteSettingsSchedulerBookingRules: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'UpdateSiteSettingsSchedulerBookingRulesInputInput!', siteId: 'ID!' },
    },
    updateSiteSettingsSchedulerCancellationRules: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'UpdateSiteSettingsSchedulerCancellationRulesInputInput!', siteId: 'ID!' },
    },
    updateSiteSettingsSchedulerClassesRules: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'UpdateSiteSettingsSchedulerClassesRulesInputInput!', siteId: 'ID!' },
    },
    updateSiteSettingsSchedulerPrivatesRules: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'UpdateSiteSettingsSchedulerPrivatesRulesInputInput!', siteId: 'ID!' },
    },
    updateSiteSettingsSchedulerReservationsRules: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'UpdateSiteSettingsSchedulerReservationsRulesInputInput!', siteId: 'ID!' },
    },
    updateSiteSettingsSchedulerWaitlistRules: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'UpdateSiteSettingsSchedulerWaitlistRulesInputInput!', siteId: 'ID!' },
    },
    updateSiteSettingsSchedulerWorkshopsRules: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'UpdateSiteSettingsSchedulerWorkshopsRulesInputInput!', siteId: 'ID!' },
    },
    updateSiteSettingsSocialMedia: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'UpdateSiteSettingsSocialMediaInputInput!', siteId: 'ID!' },
    },
    updateSiteSettingsSuspensionReasons: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'UpdateSiteSettingsSuspensionReasonsInputInput!', siteId: 'ID!' },
    },
    updateSiteSupplier: {
      __type: 'UpdateSiteSupplierResponse!',
      __args: { input: 'UpdateSiteSupplierInput!', siteId: 'String!', siteSupplierId: 'String!' },
    },
    updateSiteTerminalHandoffSettings: {
      __type: 'SiteTerminalHandoffSettingsView!',
      __args: { input: 'UpdateSiteTerminalHandoffSettingsInput!', siteId: 'ID!' },
    },
    updateSiteTerminalReader: {
      __type: 'SiteTerminalReader!',
      __args: {
        input: 'UpdateSiteTerminalReaderInputInput!',
        siteId: 'ID!',
        siteTerminalReaderId: 'ID!',
      },
    },
    updateSiteTimezone: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { siteId: 'ID!', timezone: 'String!' },
    },
    updateSiteWebhook: {
      __type: 'SiteWebhook!',
      __args: { input: 'UpdateSiteWebhookInputInput!', siteId: 'String!', webhookId: 'String!' },
    },
    updateSitesPlanOverrideAllowed: {
      __type: 'SetSitesPlanOverrideAllowedResult!',
      __args: { allowAll: 'Boolean', allowedSiteIds: '[ID!]!' },
    },
    updateSmsPackageOption: {
      __type: 'SmsPackage!',
      __args: { input: 'UpdateSmsPackageOptionInputInput!', optionId: 'ID!', smsPackageId: 'ID!' },
    },
    updateSoapNote: {
      __type: 'UpdateSoapNoteResponse!',
      __args: { input: 'SoapNoteUpdateInput!', siteId: 'String!', soapNoteId: 'String!' },
    },
    updateSpivi: { __type: 'Site!', __args: { input: 'UpdateSpiviInputInput', siteId: 'ID!' } },
    updateStaffAccessPolicy: {
      __type: 'ID!',
      __args: { input: 'UpdateStaffAccessPolicyInputInput!', staffAccessPolicyId: 'ID!' },
    },
    updateStaffAllowedNetwork: {
      __type: 'StaffAllowedNetwork!',
      __args: { input: 'UpdateStaffAllowedNetworkInputInput!', staffAllowedNetworkId: 'ID!' },
    },
    updateStaffPayrollId: { __type: 'String', __args: { payrollId: 'String', staffUserId: 'ID!' } },
    updateStaffSessionAssignment: {
      __type: 'StaffSessionAssignment!',
      __args: { data: 'StaffSessionAssignmentUpdateInput!', staffSessionAssignmentId: 'ID!' },
    },
    updateStaffSessionPolicy: {
      __type: 'StaffSessionPolicy!',
      __args: { input: 'UpdateStaffSessionPolicyInputInput!' },
    },
    updateStaffUser: {
      __type: 'StaffUser!',
      __args: { input: 'UpdateStaffUserInputInput!', staffUserId: 'ID!' },
    },
    updateStaffUserSmartGroup: {
      __type: 'StaffUserSmartGroup!',
      __args: {
        input: 'UpdateStaffUserSmartGroupInputInput!',
        siteId: 'String!',
        staffUserId: 'String!',
        staffUserSmartGroupId: 'String!',
      },
    },
    updateStaffUserStatus: {
      __type: 'ID!',
      __args: { input: 'UpdateStaffUserStatusInputInput!', staffUserId: 'ID!' },
    },
    updateSupportChat: {
      __type: 'SupportChat!',
      __args: { input: 'UpdateSupportChatInput!', supportChatId: 'ID!' },
    },
    updateSystemPreferences: {
      __type: 'UpdateSiteSettingsAccountBilling!',
      __args: { input: 'UpdateSystemPreferencesInputInput!', siteId: 'ID!' },
    },
    updateTanningIntegration: {
      __type: 'Site!',
      __args: { input: 'UpdateTanningIntegrationInput!', siteId: 'ID!' },
    },
    updateTaxSetting: {
      __type: 'TaxSetting!',
      __args: { input: 'UpdateTaxSettingInputInput!', siteId: 'ID!', taxSettingId: 'ID!' },
    },
    updateThirdPartyIntegration: {
      __type: 'ThirdPartyIntegrationWithKeys!',
      __args: { input: 'ThirdPartyIntegrationUpdateInput!', thirdPartyIntegrationId: 'ID!' },
    },
    updateThirdPartyIntegrationKey: {
      __type: 'ThirdPartyIntegrationKey!',
      __args: {
        input: 'ThirdPartyIntegrationKeyUpdateInput!',
        thirdPartyIntegrationId: 'ID!',
        thirdPartyIntegrationKeyId: 'ID!',
      },
    },
    updateTopaz: { __type: 'Site!', __args: { input: 'UpdateTopazInputInput', siteId: 'ID!' } },
    updateVirtualInvoice: {
      __type: 'ID',
      __args: { input: 'UpdateVirtualInvoiceInput!', siteId: 'ID!' },
    },
    updateWaitlistPosition: {
      __type: 'SessionWaitlistEntry!',
      __args: { newPosition: 'Float!', sessionWaitlistEntryId: 'String!', siteId: 'String!' },
    },
    updateWorkingHours: {
      __type: 'Boolean!',
      __args: {
        siteId: 'ID!',
        staffUserId: 'ID!',
        workingHours: 'UpdateWorkingHoursWorkingHoursInput',
      },
    },
    updateZapier: { __type: 'Site!', __args: { input: 'UpdateZapierInputInput', siteId: 'ID!' } },
    updateZoom: { __type: 'Site!', __args: { input: 'UpdateZoomInput!', siteId: 'ID!' } },
    uploadCustomFont: {
      __type: 'UploadCustomFont!',
      __args: {
        corporateId: 'String!',
        fontFile: 'String!',
        fontName: 'String!',
        userId: 'String',
      },
    },
    upsertBrandAppAvailability: {
      __type: 'BrandAppAvailability!',
      __args: {
        availableInNewTerritories: 'Boolean',
        baseTerritory: 'String',
        brandId: 'String!',
        platform: 'BrandPlatform!',
        territories: '[String!]!',
      },
    },
    upsertBrandAppInformation: {
      __type: 'BrandAppInformation!',
      __args: {
        ageRatingInfoUrl: 'String',
        brandId: 'String!',
        contentRightsDeclaration: 'AppleContentRightsDeclaration',
        copyright: 'String',
        platform: 'BrandPlatform!',
        primaryCategory: 'String',
        secondaryCategory: 'String',
      },
    },
    upsertBrandStoreAsset: {
      __type: '[UpsertBrandStoreAsset!]!',
      __args: {
        assetType: 'BrandStoreAssetType!',
        brandId: 'String!',
        deviceClass: 'String',
        filename: 'String!',
        gcsPath: 'String!',
        locale: 'String!',
        platform: 'BrandPlatform!',
      },
    },
    upsertBrandStoreListing: {
      __type: '[UpsertBrandStoreListing!]!',
      __args: {
        appName: 'String',
        brandId: 'String!',
        description: 'String',
        keywords: 'String',
        locale: 'String!',
        marketingUrl: 'String',
        platform: 'BrandPlatform!',
        privacyPolicyUrl: 'String',
        releaseNotes: 'String',
        shortDescription: 'String',
        subtitle: 'String',
        supportUrl: 'String',
      },
    },
    upsertBrandStoreReviewDetail: {
      __type: 'BrandStoreReviewDetail!',
      __args: {
        brandId: 'String!',
        contactEmail: 'String',
        contactFirstName: 'String',
        contactLastName: 'String',
        contactPhone: 'String',
        demoAccountName: 'String',
        demoAccountPassword: 'String',
        demoAccountRequired: 'Boolean',
        notes: 'String',
        platform: 'BrandPlatform!',
      },
    },
    upsertBrandStoreTester: {
      __type: '[UpsertBrandStoreTester!]!',
      __args: {
        brandId: 'String!',
        email: 'String!',
        name: 'String',
        platforms: '[BrandPlatform!]!',
        source: 'BrandStoreTesterSource!',
      },
    },
    upsertMemberExperienceSurfaceIntegration: {
      __type: '[MemberExperienceSurfaceIntegration!]!',
      __args: {
        appId: 'String',
        clientToken: 'String',
        corporateId: 'String!',
        displayName: 'String',
        provider: 'MemberExperienceSurfaceIntegrationProvider!',
        surface: 'MemberExperienceSurface!',
        userId: 'String',
      },
    },
    verifyAppleAccountSession: { __type: 'AppleAccountSession!' },
    verifyClientAge: {
      __type: 'ClientAgeVerification!',
      __args: {
        clientId: 'ID!',
        dateOfBirth: 'String!',
        method: 'AgeVerificationMethod!',
        siteId: 'ID!',
      },
    },
    verifyEmailDomain: { __type: 'CorporateEmailDomain!', __args: { corporateId: 'String!' } },
    verifyMyApprovalPin: { __type: 'ApprovalPinStatus!', __args: { pin: 'String!', siteId: 'ID' } },
    voidAgreement: {
      __type: 'ClientAgreement!',
      __args: { agreementId: 'ID!', clientId: 'ID!', reason: 'String', siteId: 'ID!' },
    },
    voidEquipmentAssignment: {
      __type: 'ReverseEquipmentAssignmentResult!',
      __args: { input: 'VoidEquipmentAssignmentInput!' },
    },
    voidPolicyAcceptance: {
      __type: 'PolicyAcceptanceVoidResult!',
      __args: { agreementId: 'ID!', reason: 'String!', siteId: 'ID!' },
    },
    voidPolicyImportBatch: {
      __type: 'VoidPolicyImportResult!',
      __args: { batchId: 'ID!', reason: 'String!', siteId: 'ID!' },
    },
    voidPolicyImportRow: {
      __type: 'VoidPolicyImportResult!',
      __args: { agreementId: 'ID!', batchId: 'ID!', reason: 'String!', siteId: 'ID!' },
    },
    withdrawCoverClaim: {
      __type: 'CoverRequestView!',
      __args: { coverRequestId: 'ID!', siteId: 'ID!' },
    },
    withdrawElectronicConsent: {
      __type: 'ElectronicConsentWithdrawalResult!',
      __args: { clientId: 'ID!', signerId: 'ID!', siteId: 'ID!' },
    },
    withdrawGuardianPermission: {
      __type: 'GuardianPermissionWithdrawal!',
      __args: { clientId: 'ID!', guardianSignerId: 'ID!', reason: 'String', siteId: 'ID!' },
    },
  },
  query: {
    __typename: { __type: 'String!' },
    activePendingItemsHandoffs: {
      __type: '[PendingItemsHandoff!]!',
      __args: { clientId: 'ID!', siteId: 'ID!' },
    },
    addOnPriceGroupSessionTypes: {
      __type: '[AddOnPriceGroupSessionTypeOption!]!',
      __args: { siteId: 'ID!' },
    },
    addOnPriceGroups: { __type: '[AddOnPriceGroup!]!', __args: { siteId: 'ID!' } },
    adminAccessGroup: { __type: 'AdminAccessGroup!', __args: { id: 'ID!' } },
    adminAccessGroups: { __type: '[AdminAccessGroup!]!' },
    adminAggregatorLocationSummary: {
      __type: 'AdminAggregatorLocationSummary!',
      __args: {
        aggregatorProviderId: 'String!',
        endDate: 'String!',
        siteId: 'String!',
        startDate: 'String!',
      },
    },
    adminAggregatorSessions: {
      __type: 'AdminAggregatorSessionsResponse!',
      __args: {
        aggregatorProviderId: 'String!',
        endDate: 'String!',
        onlyWithBookings: 'Boolean',
        page: 'Float',
        pageSize: 'Float',
        search: 'String',
        siteId: 'String!',
        sort: 'AdminAggregatorSessionSort',
        startDate: 'String!',
      },
    },
    adminAuditEvents: {
      __type: 'AuditQueryResult!',
      __args: {
        filter: 'AdminAuditEventsFilterInput',
        pagination: 'AuditEventsPaginationInput',
        sort: 'AuditEventsSortInput',
      },
    },
    adminCheckEzypayWebhooks: { __type: '[String!]!', __args: { siteId: 'ID!' } },
    adminCheckSiteIndex: {
      __type: '[String!]!',
      __args: { corporateId: 'ID!', includeInactive: 'Boolean!' },
    },
    adminCheckStripeMetadata: { __type: '[String!]!', __args: { siteId: 'String!' } },
    adminMobileFleet: {
      __type: 'AdminMobileFleet!',
      __args: {
        platform: 'AdminMobileFleetPlatformFilter!',
        quickFilter: 'AdminMobileFleetQuickFilter!',
        search: 'String',
        status: 'AdminMobileFleetStatusFilter!',
      },
    },
    adminUser: { __type: 'AdminUser!', __args: { adminUserId: 'ID!' } },
    adminUsers: {
      __type: 'AdminUsers!',
      __args: {
        cursor: 'String',
        filter: 'AdminUsersFilterInput',
        orderBy: '[AdminUsersOrderByInput!]!',
        pageSize: 'Float',
        search: 'String',
      },
    },
    aggregateAuditEvents: {
      __type: 'AuditAggregationResult!',
      __args: {
        filter: 'AuditEventsFilterInput!',
        groupBy: 'AuditAggregationGroupBy!',
        sortDirection: 'AuditSortDirection!',
        topN: 'Float!',
      },
    },
    aggregatorProvider: {
      __type: 'AggregatorProvider!',
      __args: { aggregatorProviderId: 'String!' },
    },
    aggregatorProviders: { __type: '[AggregatorProvider!]!' },
    allDefaults: { __type: 'AllDefaults!', __args: { language: 'String!' } },
    analyticsV2CustomerCatalog: { __type: 'AnalyticsV2CubeSchemaMetaResponse!' },
    analyticsV2QueryMeasure: {
      __type: 'AnalyticsV2QueryMeasureResponse!',
      __args: { input: 'AnalyticsV2QueryMeasureInput!' },
    },
    analyticsV2QuerySql: {
      __type: 'AnalyticsV2QuerySqlResponse!',
      __args: { input: 'AnalyticsV2QueryMeasureInput!' },
    },
    analyticsV2SchemaMeta: { __type: 'AnalyticsV2CubeSchemaMetaResponse!' },
    analyzeText: { __type: 'NLPAnalysis!', __args: { input: 'NLPAnalysisInput!' } },
    apiCallLog: {
      __type: 'ApiCallLog',
      __args: { corporateId: 'ID!', id: 'ID!', occurredAt: 'String' },
    },
    apiCallLogs: {
      __type: 'ApiCallLogPage!',
      __args: {
        corporateId: 'ID!',
        cursor: 'String',
        filter: 'ApiCallLogFilterInput',
        pageSize: 'Int',
      },
    },
    apiCredential: { __type: 'ApiCredential', __args: { apiCredentialId: 'ID!' } },
    apiCredentials: { __type: '[ApiCredential!]!' },
    appStoreCredentials: {
      __type: 'AppStoreCredentials',
      __args: { corporateId: 'ID!', platform: 'String!' },
    },
    appleAccountSession: { __type: 'AppleAccountSession!' },
    appleAutomationStatus: { __type: 'AppleAutomationStatus!', __args: { brandId: 'String!' } },
    appleTeamCandidates: {
      __type: '[AppleTeamCandidate!]!',
      __args: { appleTeamId: 'String', brandId: 'String!' },
    },
    appleTeamComplianceForBrand: { __type: 'AppleTeamCompliance', __args: { brandId: 'String!' } },
    attendance: { __type: 'Attendance', __args: { attendanceId: 'String!' } },
    attendanceByBookingId: { __type: 'Attendance', __args: { bookingId: 'String!' } },
    attendanceByClientId: {
      __type: '[Attendance!]!',
      __args: { clientId: 'String!', includeReversed: 'Boolean', limit: 'Float' },
    },
    attendanceBySessionId: {
      __type: '[Attendance!]!',
      __args: { includeReversed: 'Boolean', sessionId: 'String!' },
    },
    auditEvents: {
      __type: 'AuditQueryResult!',
      __args: {
        filter: 'AuditEventsFilterInput!',
        pagination: 'AuditEventsPaginationInput',
        sort: 'AuditEventsSortInput',
      },
    },
    availableAdminCorporateThirdPartyIntegrations: { __type: '[ThirdPartyIntegrationWithKeys!]!' },
    availableAdminSiteThirdPartyIntegrations: { __type: '[ThirdPartyIntegrationWithKeys!]!' },
    availableClientTabs: { __type: 'AvailableClientTabsResponse!', __args: { siteId: 'String!' } },
    availableCorporateUserThirdPartyIntegrations: { __type: '[ThirdPartyIntegrationWithKeys!]!' },
    availableEquipments: { __type: '[Equipment!]!', __args: { siteId: 'String!' } },
    availablePlanOptions: {
      __type: '[PlanOption!]!',
      __args: { serviceId: 'ID!', siteId: 'ID!', siteSessionTypeId: 'ID' },
    },
    availableReports: {
      __type: 'AvailableReports!',
      __args: { input: 'AvailableReportsInputInput' },
    },
    availableSiteThirdPartyIntegrations: {
      __type: '[ThirdPartyIntegrationWithKeys!]!',
      __args: { siteId: 'ID!' },
    },
    availableToAssignRegions: {
      __type: '[Regions!]!',
      __args: { filter: 'AvailableToAssignRegionsFilterInput' },
    },
    availableZapierLocations: {
      __type: '[AvailableZapierLocations!]!',
      __args: { corporateId: 'ID!' },
    },
    biMigrationConfig: { __type: 'BiMigrationConfig!' },
    biParityCheckMeasure: {
      __type: 'BiParityCheckResult!',
      __args: { input: 'BiParityCheckInput!' },
    },
    biTenantDashboards: { __type: 'BiTenantDashboardsResponse!' },
    booking: { __type: 'Booking', __args: { id: 'String!' } },
    bookingActivityLogs: { __type: '[BookingActivityLog!]!', __args: { bookingId: 'String!' } },
    bookingActivityLogsByClientId: {
      __type: '[BookingActivityLog!]!',
      __args: { clientId: 'String!', limit: 'Float' },
    },
    bookingActivityLogsBySiteId: {
      __type: '[BookingActivityLog!]!',
      __args: { limit: 'Float', siteId: 'String!' },
    },
    bookingCreditPackageOptions: {
      __type: 'BookingCreditPackageOptions!',
      __args: { bookingId: 'ID!' },
    },
    bookingCreditShortfalls: {
      __type: '[BookingCreditShortfall!]!',
      __args: { bookingIds: '[ID!]!', siteId: 'ID!' },
    },
    bookings: {
      __type: 'BookingPaginationResult!',
      __args: {
        after: 'String',
        before: 'String',
        clientId: 'String',
        pageSize: 'Float!',
        sessionId: 'String',
        siteId: 'String!',
        status: 'BookingStatus',
      },
    },
    bookingsBySessionId: {
      __type: '[Booking!]!',
      __args: { includeAttendanceCounts: 'Boolean', sessionId: 'ID!', siteId: 'ID!' },
    },
    branchConfigStatus: { __type: 'BranchConfigStatus!', __args: { corporateId: 'String!' } },
    brandAddOnPricePoints: {
      __type: '[BrandAddOnLocationPricePoint!]!',
      __args: { serviceTemplateId: 'ID!' },
    },
    brandAppAvailability: {
      __type: 'BrandAppAvailability',
      __args: { brandId: 'String!', platform: 'BrandPlatform!' },
    },
    brandAppInformation: {
      __type: 'BrandAppInformation',
      __args: { brandId: 'String!', platform: 'BrandPlatform!' },
    },
    brandArtwork: { __type: 'BrandArtwork!', __args: { brandId: 'String!' } },
    brandBuildConfigView: { __type: 'BrandBuildConfigView!', __args: { brandId: 'String!' } },
    brandBuildProfile: { __type: 'BrandBuildProfile', __args: { brandId: 'String!' } },
    brandConfig: { __type: 'BrandConfig', __args: { brandId: 'String!' } },
    brandConfigVersions: {
      __type: '[BrandConfigVersionSummary!]!',
      __args: { brandId: 'String!', limit: 'Float' },
    },
    brandCoverSettings: { __type: 'CoverSettingsOverrides!' },
    brandFirebaseApps: { __type: 'BrandFirebaseApps', __args: { brandId: 'String!' } },
    brandFirebaseConfigFiles: {
      __type: '[BrandFirebaseConfigFile!]!',
      __args: { brandId: 'String!' },
    },
    brandIdentity: { __type: 'BrandIdentity', __args: { brandId: 'String!' } },
    brandNativePermissions: { __type: 'BrandNativePermissions!', __args: { brandId: 'String!' } },
    brandNativeReleases: {
      __type: '[BrandNativeRelease!]!',
      __args: { brandId: 'String!', limit: 'Float', platform: 'BrandPlatform' },
    },
    brandNavigationArtwork: { __type: 'BrandNavigationArtwork!', __args: { brandId: 'String!' } },
    brandProvisioningOutcomes: {
      __type: '[BrandProvisioningOutcome!]!',
      __args: { brandId: 'String!' },
    },
    brandPushSettings: { __type: 'BrandPushSettings', __args: { brandId: 'String!' } },
    brandReleaseReadiness: {
      __type: 'BrandReleaseReadiness!',
      __args: { brandId: 'String!', platform: 'BrandPlatform!' },
    },
    brandReleaseStatus: {
      __type: 'BrandReleaseStatus!',
      __args: { brandId: 'String!', platform: 'BrandPlatform!' },
    },
    brandSetupSteps: { __type: '[BrandSetupStepView!]!', __args: { brandId: 'String!' } },
    brandStoreAssets: { __type: '[BrandStoreAssets!]!', __args: { brandId: 'String!' } },
    brandStoreListingIconPublicationStatus: {
      __type: 'BrandStoreListingPublicationView!',
      __args: { brandId: 'String!' },
    },
    brandStoreListingPublicationStatus: {
      __type: '[BrandStoreListingPublicationView!]!',
      __args: { brandId: 'String!' },
    },
    brandStoreListings: { __type: '[BrandStoreListings!]!', __args: { brandId: 'String!' } },
    brandStoreOperationsOverview: {
      __type: 'BrandStoreOperationsOverview!',
      __args: { brandId: 'String!' },
    },
    brandStoreReviewDemoPassword: {
      __type: 'String',
      __args: { brandId: 'String!', platform: 'BrandPlatform!' },
    },
    brandStoreReviewDetail: {
      __type: 'BrandStoreReviewDetail',
      __args: { brandId: 'String!', platform: 'BrandPlatform!' },
    },
    brandStoreTesters: { __type: '[BrandStoreTesters!]!', __args: { brandId: 'String!' } },
    brandsForCurrentCorporate: { __type: '[BrandSummary!]!' },
    buddyInviteContext: {
      __type: 'BuddyInviteContext!',
      __args: { inviteToken: 'String!', inviterClientId: 'ID!' },
    },
    buddyInviteTokenValid: {
      __type: 'Boolean!',
      __args: { inviteToken: 'String!', inviterClientId: 'ID!' },
    },
    builtinFonts: { __type: '[String!]!' },
    calculateCart: {
      __type: 'CalculateCart!',
      __args: { items: '[CalculateCartItemsInput!]!', siteId: 'String!' },
    },
    calculateFees: {
      __type: 'FeeCalculationResult!',
      __args: { request: 'FeeCalculationRequest!' },
    },
    calendarSessions: {
      __type: '[CalendarSession!]!',
      __args: {
        endDate: 'String!',
        filters: 'SessionQueryFiltersInput',
        siteId: 'String!',
        startDate: 'String!',
        status: 'String',
      },
    },
    cancellationNoticePreview: {
      __type: 'CancellationNoticePreview',
      __args: { cancelAt: 'String', serviceId: 'ID!', siteId: 'ID!' },
    },
    cancelledInvoices: {
      __type: 'ListCancelledInvoicesResult!',
      __args: { input: 'ListCancelledInvoicesInput!', siteId: 'ID!' },
    },
    carouselGroup: { __type: 'CmsCarouselGroup', __args: { carouselGroupId: 'ID!' } },
    carouselGroupBySlug: { __type: 'CmsCarouselGroup', __args: { slug: 'String!' } },
    carouselGroups: { __type: '[CmsCarouselGroup!]!' },
    cashDrawerSession: { __type: 'CashDrawerSession', __args: { siteId: 'ID!' } },
    cashDrawerSessionTransactions: {
      __type: 'CashDrawerSessionTransactions!',
      __args: { cashDrawerSessionId: 'ID!', cursor: 'String', pageSize: 'Float', siteId: 'ID!' },
    },
    cashDrawerSessions: {
      __type: 'CashDrawerSessions!',
      __args: {
        cursor: 'String',
        from: 'String',
        pageSize: 'Float',
        siteId: 'ID!',
        status: 'CashDrawerSessionStatus',
        to: 'String',
      },
    },
    challengeAnalytics: {
      __type: 'ChallengeAnalytics!',
      __args: { contentEntryId: 'ID!', siteId: 'ID' },
    },
    challengeCatalog: {
      __type: 'ChallengeCatalog!',
      __args: { cursor: 'String', includeArchived: 'Boolean', pageSize: 'Float', siteId: 'ID' },
    },
    challengeDetail: { __type: 'ChallengeDetail', __args: { contentEntryId: 'ID!' } },
    challengeLeaderboard: {
      __type: '[ChallengeLeaderboardEntry!]!',
      __args: { contentEntryId: 'ID!', limit: 'Float', metric: 'LeaderboardMetric!' },
    },
    challengeParticipationTimeline: {
      __type: 'ChallengeParticipationTimeline!',
      __args: { contentEntryId: 'ID!' },
    },
    checkClientPaymentMethodRemovalEligibility: {
      __type: 'PaymentMethodRemovalEligibility!',
      __args: { clientId: 'ID!', clientPaymentMethodId: 'ID!', siteId: 'ID!' },
    },
    checkInAttempts: {
      __type: 'CheckInAttemptsPaginationResult!',
      __args: { cursor: 'String', limit: 'Float', siteId: 'String!' },
    },
    checkIns: {
      __type: 'CheckInsPaginationResult!',
      __args: {
        after: 'String',
        before: 'String',
        clientId: 'ID',
        endDate: 'String',
        pageSize: 'Float!',
        siteId: 'ID!',
        startDate: 'String',
        status: 'CheckInStatus',
        type: 'CheckInType',
      },
    },
    checkInsByClientId: { __type: '[CheckIn!]!', __args: { clientId: 'String!', limit: 'Float' } },
    checkInsBySessionId: {
      __type: '[CheckIn!]!',
      __args: { sessionId: 'String!', siteId: 'String!' },
    },
    checkInsBySiteId: {
      __type: '[CheckIn!]!',
      __args: { endDate: 'String', limit: 'Float', siteId: 'String!', startDate: 'String' },
    },
    checkScheduledJobStatus: {
      __type: 'ScheduledJobStatus!',
      __args: { corporateId: 'ID', jobKey: 'String!', siteId: 'ID' },
    },
    checkin: { __type: 'CheckIn', __args: { id: 'String!' } },
    client: { __type: 'ClientResult!', __args: { id: 'String!', siteId: 'String' } },
    clientAccountBalance: { __type: 'String!', __args: { clientId: 'ID!', siteId: 'ID!' } },
    clientActivityFeedPaginated: {
      __type: 'ClientActivityFeedPaginationResult!',
      __args: {
        activityType: 'BookingActivityType',
        clientId: 'String!',
        cursor: 'String',
        orderBy: '[ClientActivityStreamPaginatedOrderByInput!]',
        pageSize: 'Float',
        search: 'String',
        siteId: 'String!',
      },
    },
    clientActivityStreamPaginated: {
      __type: 'ActivityStreamPaginationResult!',
      __args: {
        activityType: 'BookingActivityType',
        clientId: 'String!',
        cursor: 'String',
        orderBy: '[ClientActivityStreamPaginatedOrderByInput!]',
        pageSize: 'Float',
        search: 'String',
        siteId: 'String!',
      },
    },
    clientAgreement: {
      __type: 'ClientAgreement',
      __args: { agreementId: 'ID!', clientId: 'ID!', siteId: 'ID!' },
    },
    clientAgreementsWithPagination: {
      __type: 'ClientAgreementsWithPagination!',
      __args: {
        clientId: 'String!',
        cursor: 'String',
        filters: 'ClientAgreementsWithPaginationFiltersInput',
        includeHeldAgreements: 'Boolean',
        pageSize: 'Float',
        search: 'String',
        siteId: 'String',
      },
    },
    clientAlerts: {
      __type: 'ClientCustomAlertsResponse!',
      __args: { clientId: 'String!', siteId: 'String!' },
    },
    clientAllPastBookingsPaginated: {
      __type: 'ClientBookingsPaginationResult!',
      __args: {
        clientId: 'String!',
        cursor: 'String',
        endDate: 'String',
        includeTanning: 'Boolean',
        includeWaitlist: 'Boolean',
        orderBy: '[ClientBookingsPaginatedOrderByInput!]',
        pageSize: 'Float',
        paymentStatus: 'PaymentStatusFilter',
        search: 'String',
        siteId: 'String',
        siteSessionTypeIds: '[String!]',
        startDate: 'String',
      },
    },
    clientAttendanceStats: {
      __type: 'ClientAttendanceStats!',
      __args: { allSites: 'Boolean', clientId: 'String!', siteId: 'String!' },
    },
    clientBookingBuddyLinkedAccounts: {
      __type: '[BookingBuddyLinkedAccount!]!',
      __args: { clientId: 'ID!', sessionId: 'ID', siteId: 'ID' },
    },
    clientBookingsPaginated: {
      __type: 'ClientBookingsPaginationResult!',
      __args: {
        clientId: 'String!',
        cursor: 'String',
        endDate: 'String',
        includeTanning: 'Boolean',
        includeWaitlist: 'Boolean',
        orderBy: '[ClientBookingsPaginatedOrderByInput!]',
        pageSize: 'Float',
        paymentStatus: 'PaymentStatusFilter',
        search: 'String',
        siteId: 'String',
        siteSessionTypeIds: '[String!]',
        startDate: 'String',
      },
    },
    clientByEmail: { __type: 'Client', __args: { email: 'String!', siteId: 'String!' } },
    clientByFirebaseUid: {
      __type: 'Client',
      __args: { firebaseUid: 'String!', siteId: 'String!' },
    },
    clientByFirebaseUidOnly: { __type: 'Client', __args: { firebaseUid: 'String!' } },
    clientCancelledBookingsPaginated: {
      __type: 'ClientBookingsPaginationResult!',
      __args: {
        clientId: 'String!',
        cursor: 'String',
        endDate: 'String',
        includeTanning: 'Boolean',
        includeWaitlist: 'Boolean',
        orderBy: '[ClientBookingsPaginatedOrderByInput!]',
        pageSize: 'Float',
        paymentStatus: 'PaymentStatusFilter',
        search: 'String',
        siteId: 'String',
        siteSessionTypeIds: '[String!]',
        startDate: 'String',
      },
    },
    clientCancelledTanningSessionsPaginated: {
      __type: 'ClientTanningSessionsPaginationResult!',
      __args: { clientId: 'String!', cursor: 'String', pageSize: 'Float', siteId: 'String' },
    },
    clientContactLogs: {
      __type: 'ClientContactLogs!',
      __args: {
        clientId: 'String!',
        cursor: 'String',
        filters: 'ClientContactLogsFiltersInput',
        pageSize: 'Float',
        siteId: 'String!',
      },
    },
    clientCustomPropertyValueHistory: {
      __type: 'ClientCustomPropertyValueHistoryPage!',
      __args: {
        after: 'String',
        clientId: 'String!',
        first: 'Float',
        siteCustomPropertyId: 'String!',
        siteId: 'String!',
      },
    },
    clientEmailStatus: {
      __type: 'ClientEmailStatus!',
      __args: { email: 'String!', siteId: 'ID!' },
    },
    clientEquipmentAssignments: {
      __type: '[EquipmentAssignment!]!',
      __args: {
        clientId: 'String!',
        equipmentId: 'String',
        last: 'Boolean',
        status: 'EquipmentAssignmentStatus',
      },
    },
    clientFamily: { __type: 'Family', __args: { clientId: 'ID!', siteId: 'ID!' } },
    clientFamilyPackages: {
      __type: '[FamilyPackage!]!',
      __args: { clientId: 'ID!', siteId: 'ID!' },
    },
    clientFavoriteInstructors: {
      __type: '[ClientFavoriteInstructor!]!',
      __args: { clientId: 'String!', siteId: 'String!' },
    },
    clientFeesTemplate: { __type: 'ClientFeesTemplate!', __args: { id: 'String!' } },
    clientFeesTemplates: {
      __type: 'ClientFeesTemplatesPageInfo!',
      __args: {
        paginate: 'PaginationInput!',
        search: 'String',
        sort: 'FindClientFeesTemplatesSortOptions',
      },
    },
    clientFiles: { __type: '[ClientFile!]!', __args: { clientId: 'String!', siteId: 'String!' } },
    clientFilesWithPagination: {
      __type: 'ClientFilesWithPagination!',
      __args: {
        clientId: 'String!',
        cursor: 'String',
        filters: 'ClientFilesWithPaginationFiltersInput',
        pageSize: 'Float',
        search: 'String',
        siteId: 'String!',
      },
    },
    clientFormHandoffs: {
      __type: '[FormHandoff!]!',
      __args: { clientId: 'String!', siteId: 'String!' },
    },
    clientFormResult: {
      __type: 'ClientFormResult',
      __args: { clientId: 'String!', siteFormId: 'String!', siteId: 'String!' },
    },
    clientFormSubmissions: {
      __type: 'ClientFormSubmissionsResponse!',
      __args: { clientId: 'String!', siteId: 'String' },
    },
    clientFormSubmissionsWithPagination: {
      __type: 'ClientFormSubmissionsWithPagination!',
      __args: {
        clientId: 'String!',
        cursor: 'String',
        filters: 'ClientFormSubmissionsWithPaginationFiltersInput',
        pageSize: 'Float',
        search: 'String',
        siteId: 'String!',
      },
    },
    clientGrowLocations: {
      __type: '[ClientGrowLocationsSummary!]!',
      __args: { clientIds: '[String!]!' },
    },
    clientGrowStatus: {
      __type: 'ClientGrowStatus!',
      __args: { clientId: 'String!', siteId: 'String' },
    },
    clientGrowStatuses: {
      __type: '[ClientGrowStatusSummary!]!',
      __args: { clientIds: '[String!]!', siteId: 'String!' },
    },
    clientIpInfo: { __type: 'ClientIpInfo!' },
    clientLifetimeSpend: {
      __type: 'ClientLifetimeSpend',
      __args: { clientId: 'ID!', siteId: 'ID!' },
    },
    clientMembershipScheduledInvoices: {
      __type: 'ClientUpcomingInvoicesResult!',
      __args: { clientId: 'ID!', serviceId: 'ID!', siteId: 'ID!' },
    },
    clientNextBilling: { __type: 'ClientNextBilling', __args: { clientId: 'ID!', siteId: 'ID!' } },
    clientNote: {
      __type: 'ClientNote',
      __args: { clientId: 'String!', noteId: 'String!', siteId: 'String!' },
    },
    clientNotes: {
      __type: 'ClientNotesResponse!',
      __args: { clientId: 'String!', siteId: 'String!' },
    },
    clientPastBookingsPaginated: {
      __type: 'ClientBookingsPaginationResult!',
      __args: {
        clientId: 'String!',
        cursor: 'String',
        endDate: 'String',
        includeTanning: 'Boolean',
        includeWaitlist: 'Boolean',
        orderBy: '[ClientBookingsPaginatedOrderByInput!]',
        pageSize: 'Float',
        paymentStatus: 'PaymentStatusFilter',
        search: 'String',
        siteId: 'String',
        siteSessionTypeIds: '[String!]',
        startDate: 'String',
      },
    },
    clientPastTanningSessionsPaginated: {
      __type: 'ClientTanningSessionsPaginationResult!',
      __args: { clientId: 'String!', cursor: 'String', pageSize: 'Float', siteId: 'String' },
    },
    clientPaymentMethod: {
      __type: 'ClientPaymentMethod',
      __args: { clientId: 'ID!', clientPaymentMethodId: 'ID!', siteId: 'ID!' },
    },
    clientPaymentMethods: {
      __type: '[ClientPaymentMethod!]!',
      __args: { clientId: 'ID', clientPaymentMethodIds: '[ID!]', siteId: 'ID' },
    },
    clientPendingAgreements: {
      __type: '[PendingAgreement!]!',
      __args: { clientId: 'ID!', siteId: 'ID' },
    },
    clientPolicyCompliance: {
      __type: 'ClientPolicyCompliance!',
      __args: { clientId: 'ID!', siteId: 'ID!' },
    },
    clientPurchasedServiceTemplateIds: {
      __type: '[String!]!',
      __args: { clientId: 'ID!', siteId: 'ID!' },
    },
    clientRelations: {
      __type: '[ClientRelationView!]!',
      __args: { clientId: 'ID!', siteId: 'ID!' },
    },
    clientServices: {
      __type: 'ClientServicesPaginationResult!',
      __args: {
        clientId: 'String!',
        cursor: 'String',
        includeAddOns: 'Boolean',
        includeExpiredCreditsForRollover: 'Boolean',
        includeSharedWithClient: 'Boolean',
        pageSize: 'Float',
        search: 'String',
        serviceIds: '[String!]',
        sharedSiteIds: '[String!]',
        siteId: 'String',
        siteSessionTypeId: 'String',
        sortBy: 'ClientServicesSortBy',
        sortOrder: 'SortOrder',
        status: '[ServiceStatus!]',
        type: '[String!]',
      },
    },
    clientSite: { __type: 'ClientSite', __args: { clientId: 'String!', siteId: 'String!' } },
    clientSiteAssignedStaff: {
      __type: 'ClientSiteAssignedStaff!',
      __args: { clientId: 'String!', siteId: 'String!' },
    },
    clientSiteAssignedStaffHistory: {
      __type: 'AssignedStaffHistory!',
      __args: { clientId: 'String!', siteId: 'String!' },
    },
    clientSites: { __type: 'ClientSitesResponse!', __args: { clientId: 'String!' } },
    clientStats: { __type: 'ClientStats!', __args: { clientId: 'String!' } },
    clientTerminalHandoffRequests: {
      __type: '[TerminalHandoffRequest!]!',
      __args: { clientId: 'ID!', siteId: 'ID!' },
    },
    clientTimeline: {
      __type: 'ClientTimelineResult!',
      __args: {
        clientId: 'String!',
        cursor: 'String',
        endDate: 'String',
        eventTypes: '[ClientTimelineEventType!]',
        limit: 'Float',
        siteId: 'String!',
        startDate: 'String',
        timezone: 'String',
      },
    },
    clientWaitlistEntries: {
      __type: '[SessionWaitlistEntry!]!',
      __args: { clientId: 'String!', siteId: 'String' },
    },
    clientWaitlistEntry: {
      __type: 'SessionWaitlistEntry',
      __args: { clientId: 'String!', sessionId: 'String!', siteId: 'String!' },
    },
    clients: {
      __type: 'ClientsResult!',
      __args: {
        crossSiteSearch: 'Boolean',
        cursor: 'String',
        email: 'String',
        filters: 'ClientFilters',
        firstName: 'String',
        includeSharedSiteVisitors: 'Boolean',
        lastName: 'String',
        orderBy: '[ClientsOrderByInput!]',
        pageSize: 'Float',
        phone: 'String',
        search: 'String',
        showDeactivated: 'Boolean',
        showProspects: 'Boolean',
        siteId: 'String',
      },
    },
    clientsByIds: { __type: '[Client!]!', __args: { clientIds: '[String!]!', siteId: 'String!' } },
    cmsAwardsSummary: {
      __type: 'AwardsSummary!',
      __args: { input: 'CmsAnalyticsDateRangeInput!' },
    },
    cmsChallengeOverview: {
      __type: 'ChallengeOverview!',
      __args: { input: 'CmsAnalyticsDateRangeInput!' },
    },
    cmsContentEngagementSummary: {
      __type: 'ContentEngagementSummary!',
      __args: { input: 'CmsAnalyticsDateRangeInput!' },
    },
    cmsExperienceDashboard: {
      __type: 'ExperienceDashboard!',
      __args: { input: 'CmsAnalyticsDateRangeInput!' },
    },
    cmsImportContentfulDefaultSpace: { __type: 'CmsImportContentfulConfig!' },
    cmsImportContentfulSpaces: { __type: '[CmsImportContentfulSpace!]!' },
    cmsImportJwPlayerSites: { __type: 'CmsImportJwPlayerSitesResult!' },
    cmsImportLegacyMongoBrands: { __type: 'CmsImportLegacyMongoBrandOptions!' },
    cmsImportRun: { __type: 'CmsImportRunWithSteps', __args: { importRunId: 'String!' } },
    cmsImportRunPreviews: {
      __type: 'CmsImportRunPreviews!',
      __args: {
        importRunId: 'String!',
        limit: 'Float',
        mappingStatus: 'CmsImportMappingStatus',
        offset: 'Float',
        search: 'String',
        sourceSystem: 'String',
      },
    },
    cmsImportRunSteps: { __type: '[CmsImportRunStep!]!', __args: { importRunId: 'String!' } },
    cmsImportRuns: { __type: '[CmsImportRun!]!', __args: { limit: 'Float', offset: 'Float' } },
    cmsImportV1AuroraBrands: { __type: 'CmsImportV1AuroraBrandOptions!' },
    cmsLeaderboardSummary: {
      __type: '[LeaderboardSummaryItem!]!',
      __args: { input: 'CmsAnalyticsSiteInput!' },
    },
    cmsMetricTrackingSummary: {
      __type: 'MetricTrackingSummary!',
      __args: { input: 'CmsAnalyticsDateRangeInput!' },
    },
    cmsTopVideos: { __type: '[TopVideoItem!]!', __args: { input: 'CmsTopVideosInput!' } },
    cmsVideoAnalytics: { __type: 'VideoAnalytics!', __args: { input: 'CmsVideoAnalyticsInput!' } },
    cmsVideoEngagementTrend: {
      __type: '[VideoEngagementTrendPoint!]!',
      __args: { input: 'CmsVideoEngagementTrendInput!' },
    },
    commissionAdjustmentStaff: {
      __type: '[CommissionAdjustmentStaff!]!',
      __args: { siteId: 'ID!' },
    },
    commissionAttribution: { __type: 'CommissionCard', __args: { serviceId: 'ID!' } },
    commissionCheckoutItemSettings: {
      __type: '[CommissionItemSetting!]!',
      __args: { items: '[CommissionItemRefInput!]!', siteId: 'ID!' },
    },
    commissionDashboard: {
      __type: 'CommissionDashboard!',
      __args: { input: 'CommissionDashboardInput!' },
    },
    commissionEnablement: { __type: 'CommissionEnablement!' },
    commissionEvents: {
      __type: '[CommissionEventSummary!]!',
      __args: { commissionPeriodId: 'ID!', status: 'CommissionEventStatus' },
    },
    commissionItemSettings: {
      __type: '[CommissionItemSetting!]!',
      __args: { items: '[CommissionItemRefInput!]!', siteId: 'ID' },
    },
    commissionJobRun: { __type: 'CommissionJobRun!', __args: { commissionJobRunId: 'ID!' } },
    commissionJobRuns: { __type: '[CommissionJobRun!]!' },
    commissionLinesForInvoice: { __type: '[CommissionLine!]!', __args: { invoiceId: 'ID!' } },
    commissionPeriod: { __type: 'CommissionPeriod!', __args: { commissionPeriodId: 'ID!' } },
    commissionPeriods: { __type: '[CommissionPeriod!]!' },
    commissionPlan: {
      __type: 'CommissionPlan!',
      __args: { commissionPlanId: 'ID!', siteId: 'ID' },
    },
    commissionPlans: {
      __type: '[CommissionPlan!]!',
      __args: { includeArchived: 'Boolean', siteId: 'ID' },
    },
    commissionPreflight: { __type: 'CommissionPreflight!' },
    commissionRoleDefaults: { __type: '[CommissionRoleDefault!]!', __args: { siteId: 'ID' } },
    commissionSettings: { __type: 'CommissionSettings!', __args: { siteId: 'ID' } },
    commissionSiteSettings: { __type: 'CommissionSiteSettings!', __args: { siteId: 'ID!' } },
    commissionStaff: {
      __type: '[CommissionStaffEntry!]!',
      __args: { includeDeactivated: 'Boolean', siteId: 'ID' },
    },
    commissionUnresolvedAttributions: { __type: '[CommissionUnresolvedAttribution!]!' },
    communicationTemplate: { __type: 'CommunicationTemplate!', __args: { id: 'ID!' } },
    communicationTemplates: {
      __type: 'CommunicationTemplatePaginationResultSchema!',
      __args: {
        alias: 'String',
        cursor: 'String',
        emailEnabled: 'Boolean',
        pageSize: 'Float',
        pushNotificationEnabled: 'Boolean',
        readOnly: 'Boolean',
        search: 'String',
        smsEnabled: 'Boolean',
      },
    },
    computedAlerts: {
      __type: 'ComputedAlertsResponse!',
      __args: { clientId: 'String!', siteId: 'String!' },
    },
    comunicationTemplatesPlaceholders: { __type: '[String!]!' },
    configuredLanguages: { __type: 'ConfiguredLanguages!', __args: { corporateId: 'String!' } },
    contentCatalog: {
      __type: 'CmsCatalogResult!',
      __args: {
        categoryId: 'ID',
        contentTypeGroup: 'ContentTypeGroup',
        contentTypeId: 'ID',
        contentTypeIds: '[ID!]',
        cursor: 'String',
        instructorId: 'ID',
        memberPackageNames: '[String!]',
        orderBy: 'CatalogOrderBy',
        packageContext: '[ID!]',
        pageSize: 'Float',
        search: 'String',
        siteId: 'ID',
        subcategoryId: 'ID',
        tags: '[String!]',
        tagsMatch: 'TagMatch',
      },
    },
    contentCatalogBanners: {
      __type: '[CmsContentEntry!]!',
      __args: {
        memberPackageNames: '[String!]',
        packageContext: '[ID!]',
        siteId: 'ID!',
        tags: '[String!]',
        tagsMatch: 'TagMatch',
        type: 'String',
        types: '[String!]',
      },
    },
    contentCatalogCategories: {
      __type: '[CmsCatalogCategory!]!',
      __args: {
        memberPackageNames: '[String!]',
        packageContext: '[ID!]',
        siteId: 'ID!',
        tags: '[String!]',
        tagsMatch: 'TagMatch',
      },
    },
    contentCatalogEntry: {
      __type: 'CmsContentEntry',
      __args: {
        contentEntryId: 'ID!',
        memberPackageNames: '[String!]',
        packageContext: '[ID!]',
        siteId: 'ID!',
        tags: '[String!]',
        tagsMatch: 'TagMatch',
      },
    },
    contentCustomEntryNames: { __type: '[String!]!', __args: { kind: 'CmsCustomEntryKind!' } },
    contentEntries: {
      __type: 'ContentEntries!',
      __args: {
        callerSiteId: 'ID',
        cursor: 'String',
        filters: 'ContentEntriesFiltersInput',
        orderBy: '[ContentEntriesOrderByInput!]',
        pageSize: 'Float',
        search: 'String',
      },
    },
    contentEntry: { __type: 'CmsContentEntry', __args: { contentEntryId: 'ID!' } },
    contentEntryVersions: { __type: '[CmsContentVersion!]!', __args: { contentEntryId: 'ID!' } },
    contentLibraryCategories: { __type: '[ContentLibraryCategory!]!' },
    contentLibraryEntryOverrides: {
      __type: 'ContentLibraryEntryOverrideState',
      __args: { contentEntryId: 'ID!', corporateId: 'ID' },
    },
    contentLibraryPreviewStream: {
      __type: 'ContentLibraryPreviewStream!',
      __args: { contentMediaId: 'ID!' },
    },
    contentLibraryStatus: { __type: 'ContentLibraryStatus!', __args: { corporateId: 'ID!' } },
    contentLibraryTaxonomyMappings: {
      __type: '[ContentLibraryTaxonomyMapping!]!',
      __args: { corporateId: 'ID!' },
    },
    contentMediaAsset: { __type: 'CmsContentMedia', __args: { contentMediaId: 'ID!' } },
    contentMediaLibrary: {
      __type: 'ContentMediaLibrary!',
      __args: {
        cursor: 'String',
        filters: 'ContentMediaLibraryFiltersInput',
        orderBy: '[ContentMediaLibraryOrderByInput!]',
        pageSize: 'Float',
        search: 'String',
      },
    },
    contentMediaUsageItems: { __type: '[MediaUsageItem!]!', __args: { contentMediaId: 'ID!' } },
    contentSchedules: { __type: '[CmsContentSchedule!]!', __args: { contentEntryId: 'ID!' } },
    contentTargets: { __type: '[CmsContentTarget!]!', __args: { contentEntryId: 'ID!' } },
    contentTaxonomyOptions: {
      __type: '[ContentTaxonomyOptionGroup!]!',
      __args: { slugs: '[String!]!' },
    },
    contentTypes: { __type: '[CmsContentType!]!' },
    coreUsersWithoutPayrollTier: {
      __type: '[CoreUsersWithoutPayrollTier!]!',
      __args: { allSites: 'Boolean', siteId: 'ID!' },
    },
    corporate: { __type: 'Corporate', __args: { corporateId: 'String!' } },
    corporateAddOn: { __type: 'CorporateAddOn', __args: { corporateServiceTemplateId: 'ID!' } },
    corporateAddOnDryRun: {
      __type: 'BrandAddOnDryRun!',
      __args: { input: 'CorporateAddOnDryRunInput!' },
    },
    corporateAddOnParentOptions: { __type: '[CorporateServiceTemplateSummary!]!' },
    corporateAddOns: { __type: '[CorporateAddOnListItem!]!' },
    corporateAggregatorProviderEnabledSiteIds: {
      __type: '[String!]!',
      __args: { aggregatorProviderId: 'String!', corporateId: 'String!' },
    },
    corporateBySubdomain: { __type: 'Corporate', __args: { subdomain: 'String!' } },
    corporateClients: {
      __type: 'ListAllClients!',
      __args: {
        cursor: 'String',
        email: 'String',
        firstName: 'String',
        lastName: 'String',
        pageSize: 'Float',
        phone: 'String',
        siteId: 'String',
      },
    },
    corporateCommunicationTemplate: {
      __type: 'CorporateCommunicationTemplate',
      __args: { alias: 'CommunicationTemplateAliases!' },
    },
    corporateCommunicationTemplateById: {
      __type: 'CorporateCommunicationTemplate',
      __args: { corporateCommunicationTemplateId: 'ID!' },
    },
    corporateCommunicationTemplatePlaceholders: { __type: '[String!]!' },
    corporateCommunicationTemplateVersion: {
      __type: 'CorporateCommunicationTemplateVersion',
      __args: {
        corporateCommunicationTemplateId: 'ID!',
        corporateCommunicationTemplateVersionId: 'ID!',
      },
    },
    corporateCommunicationTemplateVersions: {
      __type: '[CorporateCommunicationTemplateVersion!]!',
      __args: { corporateCommunicationTemplateId: 'ID!' },
    },
    corporateCommunicationTemplateVersionsByAlias: {
      __type: '[CorporateCommunicationTemplateVersion!]!',
      __args: { alias: 'CommunicationTemplateAliases!' },
    },
    corporateCommunicationTemplates: {
      __type: 'CorporateCommunicationTemplatePaginationResultSchema!',
      __args: {
        alias: 'CommunicationTemplateAliases',
        cursor: 'String',
        messageType: 'CommunicationType',
        pageSize: 'Float',
        search: 'String',
      },
    },
    corporateCustomIntegrations: {
      __type: '[CorporateCustomIntegrationItem!]!',
      __args: { corporateId: 'ID!' },
    },
    corporateEmailDomain: { __type: 'CorporateEmailDomain', __args: { corporateId: 'String!' } },
    corporateEnabledAggregatorProviderIds: {
      __type: '[String!]!',
      __args: { corporateId: 'String!' },
    },
    corporateEntitlements: { __type: 'SiteEntitlements!' },
    corporateFaq: { __type: 'CorporateFaq', __args: { corporateFaqId: 'ID!' } },
    corporateFaqs: { __type: '[CorporateFaq!]!' },
    corporateFaqsClient: { __type: '[CorporateFaq!]!' },
    corporatePayoutAccount: { __type: 'CorporatePayoutAccount', __args: { id: 'ID!' } },
    corporatePayoutAccounts: {
      __type: 'CorporatePayoutAccounts!',
      __args: {
        corporateId: 'ID!',
        cursor: 'String',
        orderBy: '[CorporatePayoutAccountsOrderByInput!]!',
        pageSize: 'Float',
        search: 'String',
      },
    },
    corporateProvisioningPreview: {
      __type: 'CorporateProvisioningPreview!',
      __args: { corporateId: 'ID!' },
    },
    corporateSessionType: {
      __type: 'CorporateSessionType',
      __args: { corporateSessionTypeId: 'ID!' },
    },
    corporateSessionTypeSyncPreview: {
      __type: 'CorporateSessionTypeSyncPreview!',
      __args: { input: 'CorporateSessionTypeSyncPreviewInput!' },
    },
    corporateSessionTypes: { __type: '[CorporateSessionTypeListItem!]!' },
    corporateTaxSetting: {
      __type: 'CorporateTaxSetting',
      __args: { corporateTaxSettingId: 'ID!' },
    },
    corporateTaxSettingUsage: {
      __type: 'CorporateTaxSettingUsageResult!',
      __args: { corporateTaxSettingId: 'ID!' },
    },
    corporateTaxSettings: { __type: '[CorporateTaxSetting!]!' },
    corporateWebhookDeliveries: {
      __type: '[CorporateWebhookDelivery!]!',
      __args: { corporateId: 'ID!', limit: 'Int', webhookId: 'ID!' },
    },
    corporateWebhooks: { __type: '[CorporateWebhook!]!', __args: { corporateId: 'ID!' } },
    corporates: {
      __type: 'Corporates!',
      __args: {
        limit: 'Float',
        offset: 'Float',
        paginate: 'PaginationInput',
        search: 'String',
        sort: 'FindCorporatesSortOptions',
      },
    },
    countCancelledSessionsByRecurrences: {
      __type: 'Float!',
      __args: { recurringSessionsIds: '[String!]!', siteId: 'String!' },
    },
    countries: {
      __type: 'Countries!',
      __args: {
        cursor: 'String',
        filter: 'CountriesFilterInput',
        orderBy: '[CountriesOrderByInput!]',
        pageSize: 'Float',
        search: 'String',
      },
    },
    country: { __type: 'Country!', __args: { countryId: 'ID!' } },
    coverClassTypes: { __type: '[CoverClassType!]!', __args: { siteId: 'ID!' } },
    coverCommunicationLog: {
      __type: 'CoverCommunicationLogPage!',
      __args: {
        channel: 'CoverCommunicationChannel',
        coverRequestId: 'ID!',
        cursor: 'String',
        limit: 'Int',
        onlyFailed: 'Boolean',
        siteId: 'ID!',
      },
    },
    coverEligibility: {
      __type: '[CoverEligibility!]!',
      __args: { originalStaffUserId: 'ID!', sessionId: 'String!', siteId: 'ID!' },
    },
    coverMessageAudience: {
      __type: '[CoverMessageAudienceMember!]!',
      __args: { coverRequestId: 'ID!', siteId: 'ID!' },
    },
    coverMessages: {
      __type: '[CoverMessageView!]!',
      __args: { coverRequestId: 'ID!', siteId: 'ID!' },
    },
    coverPreferredSubs: { __type: '[CoverPreferredSubView!]!', __args: { siteId: 'ID!' } },
    coverQualifications: { __type: '[CoverStaffQualifications!]!', __args: { siteId: 'ID!' } },
    coverQueue: {
      __type: '[CoverRequestView!]!',
      __args: { from: 'String', siteIds: '[ID!]', statuses: '[CoverRequestStatus!]', to: 'String' },
    },
    coverRequest: { __type: 'CoverRequestView!', __args: { coverRequestId: 'ID!', siteId: 'ID!' } },
    coverRequestsForSessions: {
      __type: '[CoverSessionBadge!]!',
      __args: { sessionIds: '[String!]!', siteId: 'ID!' },
    },
    creditsCoverSession: {
      __type: 'CreditsCoverSessionResult!',
      __args: {
        bookingDate: 'String!',
        clientId: 'String!',
        guestPassPoolOnly: 'Boolean',
        siteId: 'String!',
        siteSessionTypeId: 'String!',
        siteTimezone: 'String',
      },
    },
    crossCategoryScheduledPlanChanges: {
      __type: '[CrossCategoryScheduledPlanChange!]!',
      __args: { siteId: 'ID!' },
    },
    customLink: { __type: 'CustomLink!', __args: { customLinkId: 'ID!' } },
    customLinks: { __type: '[CustomLink!]!' },
    customProperties: { __type: '[CustomProperty!]!', __args: { siteId: 'ID!' } },
    customProperty: { __type: 'CustomProperty', __args: { id: 'String!', siteId: 'ID!' } },
    customizationStats: { __type: 'CustomizationStats!', __args: { corporateId: 'String!' } },
    dashboardMobile: {
      __type: 'DashboardMobile!',
      __args: { clientId: 'String!', siteId: 'String!' },
    },
    deepLink: { __type: 'DeepLink!', __args: { corporateId: 'String!', deepLinkId: 'String!' } },
    deepLinkDestinations: {
      __type: '[DeepLinkDestinations!]!',
      __args: { corporateId: 'String!' },
    },
    deepLinkSettings: { __type: 'DeepLinkSettings!', __args: { corporateId: 'String!' } },
    deepLinks: {
      __type: 'DeepLinks!',
      __args: {
        canonicalIdentifier: 'DeepLinkDestination',
        corporateId: 'String!',
        cursor: 'String',
        pageSize: 'Float',
        search: 'String',
      },
    },
    defaultText: { __type: 'DefaultText!', __args: { key: 'String!', language: 'String!' } },
    deletedKnowledgeArticles: {
      __type: 'DeletedKnowledgeArticlesResponse!',
      __args: { limit: 'Int', offset: 'Int' },
    },
    demoSeedingJob: { __type: 'DemoSeedingJob', __args: { corporateId: 'String!' } },
    demoSeedingJobById: { __type: 'DemoSeedingJob', __args: { jobId: 'String!' } },
    demoSeedingJobs: {
      __type: '[DemoSeedingJob!]!',
      __args: { corporateId: 'String!', limit: 'Float' },
    },
    destinationFeeChargeStatus: {
      __type: 'DestinationFeeChargeStatus!',
      __args: { clientId: 'ID!', siteId: 'ID!' },
    },
    detectImportType: { __type: 'DetectImportType!', __args: { headers: '[String!]!' } },
    digitalChannels: { __type: '[SiteLocation!]!', __args: { siteId: 'ID!' } },
    displayedSitePolicyRevisions: {
      __type: '[DisplayedSitePolicyRevision!]!',
      __args: { siteId: 'ID!', sitePolicyIds: '[ID!]!' },
    },
    dispute: { __type: 'Dispute!', __args: { disputeId: 'ID!', siteId: 'ID!' } },
    disputes: { __type: '[Dispute!]!', __args: { paymentId: 'ID!', siteId: 'ID!' } },
    draftKnowledgeArticles: {
      __type: 'KnowledgeArticlesByCategoryResponse!',
      __args: { category: 'String', limit: 'Int', offset: 'Int' },
    },
    dropInBookingCreditPackageOptions: {
      __type: 'BookingCreditPackageOptions!',
      __args: { bookingId: 'ID!' },
    },
    earlyAccessRecutEligibleCount: { __type: 'Float!', __args: { serviceTemplateId: 'String!' } },
    egymClientLink: { __type: 'EgymClientLink!', __args: { clientId: 'ID!', siteId: 'ID!' } },
    egymHasAccounts: { __type: 'EgymHasAccounts!', __args: { siteId: 'ID!' } },
    egymMemberCsvExport: { __type: 'String!', __args: { siteId: 'ID!' } },
    egymSiteEnabled: { __type: 'EgymSiteEnabled!', __args: { siteId: 'ID!' } },
    egymSiteHasKey: { __type: 'EgymSiteKeyStatus!', __args: { siteId: 'ID!' } },
    egymSyncActive: { __type: 'EgymSyncActive!', __args: { siteId: 'ID!' } },
    embedWidgetConfig: { __type: 'EmbedSetupResponse!', __args: { corporateId: 'String!' } },
    enabledFeeConfigurations: {
      __type: '[FeeConfiguration!]!',
      __args: { accountType: 'FeeAccountType!' },
    },
    enabledServiceTemplates: { __type: '[ServiceTemplate!]!', __args: { siteId: 'String!' } },
    enabledServiceTemplatesBySites: {
      __type: '[ServiceTemplateFilterOption!]!',
      __args: { siteIds: '[String!]!', templateTypes: '[String!]' },
    },
    equipment: { __type: 'Equipment!', __args: { equipmentId: 'String!' } },
    equipmentActivity: {
      __type: '[EquipmentActivityDay!]!',
      __args: { clientId: 'String', endDate: 'String', siteId: 'String!', startDate: 'String' },
    },
    equipmentAssignmentsByClientId: {
      __type: '[EquipmentAssignment!]!',
      __args: {
        clientId: 'String!',
        countsTowardsRegulations: 'Boolean',
        last: 'Boolean',
        siteId: 'String!',
        status: '[EquipmentAssignmentStatus!]',
      },
    },
    equipmentComplianceReport: {
      __type: 'EquipmentComplianceReport!',
      __args: {
        filter: 'EquipmentComplianceReportFilterInput',
        page: 'EquipmentComplianceReportPageInput',
        siteId: 'ID!',
        sort: 'EquipmentComplianceSort',
        sortDirection: 'EquipmentComplianceSortDirection',
      },
    },
    equipmentDiagnostics: { __type: 'AgentDiagnostics!', __args: { siteId: 'String!' } },
    equipmentExposureGuidance: {
      __type: 'EquipmentExposureGuidance',
      __args: { clientId: 'ID!', equipmentId: 'ID!' },
    },
    equipmentExposureSchedule: {
      __type: '[EquipmentExposureScheduleRow!]!',
      __args: { equipmentId: 'ID!' },
    },
    equipmentJurisdictionRules: {
      __type: '[EquipmentJurisdictionRule!]!',
      __args: { siteId: 'ID!' },
    },
    equipmentJurisdictionRulesInForce: {
      __type: '[EquipmentJurisdictionRule!]!',
      __args: { siteId: 'ID!' },
    },
    equipmentLampLogs: {
      __type: 'EquipmentLampLogPage!',
      __args: { input: 'EquipmentLampLogsInput!' },
    },
    equipmentLampStatuses: { __type: 'EquipmentLampSiteStatus!', __args: { siteId: 'ID!' } },
    equipmentQueueClients: {
      __type: '[EquipmentQueuePosition!]!',
      __args: { equipmentId: 'String', siteId: 'String!' },
    },
    equipmentReadiness: {
      __type: 'EquipmentReadinessView!',
      __args: { clientId: 'ID!', equipmentId: 'ID!', siteId: 'ID!' },
    },
    equipmentReadinessBatch: {
      __type: '[EquipmentReadinessView!]!',
      __args: { requests: '[EquipmentReadinessRequestInput!]!', siteId: 'ID!' },
    },
    equipmentRegulation: {
      __type: 'EquipmentRegulation',
      __args: { equipmentCategory: 'EquipmentCategory!', siteId: 'String!' },
    },
    equipmentRegulations: { __type: '[EquipmentRegulation!]!', __args: { siteId: 'String!' } },
    equipmentSessionTypeAvailability: {
      __type: '[EquipmentSessionTypeAvailability!]!',
      __args: { clientId: 'String!', equipmentId: 'String!', siteId: 'String!' },
    },
    equipments: {
      __type: '[Equipment!]!',
      __args: { search: 'String', siteId: 'String!', siteSessionTypeId: 'String' },
    },
    estimateEzypayCustomerPaidFees: {
      __type: 'EzypayCustomerPaidFeeEstimateResult!',
      __args: { request: 'EzypayCustomerPaidFeeEstimateRequest!' },
    },
    expiredCreditsAvailableForRollover: {
      __type: 'Float!',
      __args: { serviceId: 'ID!', siteId: 'ID!' },
    },
    exportCustomText: { __type: 'ExportCustomText!', __args: { corporateId: 'String!' } },
    exportJobStatus: { __type: 'ExportJobStatus!', __args: { jobId: 'String!' } },
    ezypayInvoiceGatewayLogs: {
      __type: 'EzypayGatewayLogs',
      __args: { invoiceId: 'ID!', siteId: 'ID!' },
    },
    familyInviteContext: { __type: 'FamilyInviteContext!', __args: { inviteToken: 'String!' } },
    familyMemberCandidate: {
      __type: 'FamilyMemberCandidate',
      __args: { query: 'String!', siteId: 'ID!' },
    },
    familyMemberCandidates: {
      __type: '[FamilyMemberCandidate!]!',
      __args: { query: 'String!', siteId: 'ID!' },
    },
    familyPackages: { __type: '[FamilyPackage!]!', __args: { siteId: 'ID!' } },
    familySettings: { __type: 'FamilySettings!' },
    featureDataRefreshStatus: {
      __type: 'FeatureDataRefreshStatus',
      __args: { corporateId: 'ID!' },
    },
    featureEnvEmailSettings: { __type: 'FeatureEnvEmailSettings' },
    feeConfiguration: { __type: 'FeeConfiguration!', __args: { id: 'String!' } },
    feeConfigurations: {
      __type: 'FeeConfigurations!',
      __args: {
        cursor: 'String',
        eventType: 'FeeEventType',
        orderBy: '[FeeConfigurationsOrderByInput!]!',
        pageSize: 'Float',
        paymentGateway: 'PaymentGateway',
        rateType: 'FeeRateType',
        search: 'String',
      },
    },
    feedbackQuestions: {
      __type: 'FeedbackQuestions!',
      __args: { bookingId: 'String', sessionId: 'String!', siteId: 'String!' },
    },
    findStaffUsers: {
      __type: 'FindStaffUsers!',
      __args: {
        accessLevel: '[StaffUserAccessLevel!]',
        cursor: 'String',
        orderBy: '[FindStaffUsersOrderByInput!]!',
        pageSize: 'Float',
        search: 'String',
        siteGroupIds: '[ID!]',
        siteIds: '[ID!]',
        staffAccessPolicyIds: '[ID!]',
        status: 'StaffUserStatus',
      },
    },
    firebaseAppProjectPool: { __type: 'FirebaseAppProjectPool!' },
    fitnessPassportLink: {
      __type: 'FitnessPassportLinkView',
      __args: { clientId: 'ID!', siteId: 'ID!' },
    },
    fitnessPassportSiteEnabled: {
      __type: 'FitnessPassportSiteEnabled!',
      __args: { siteId: 'ID!' },
    },
    fitnessPassportVisits: {
      __type: '[FitnessPassportVisitRow!]!',
      __args: {
        from: 'String!',
        limit: 'Float',
        outcomes: '[FitnessPassportVisitOutcome!]',
        siteId: 'ID!',
        to: 'String!',
      },
    },
    fitnessPassportVisitsCsv: {
      __type: 'String!',
      __args: { from: 'String!', siteId: 'ID!', to: 'String!' },
    },
    fitnessPassportVisitsSummary: {
      __type: 'FitnessPassportVisitsSummary!',
      __args: { from: 'String!', siteId: 'ID!', to: 'String!' },
    },
    fobCaptureRequest: {
      __type: 'FobCaptureRequest!',
      __args: { requestId: 'ID!', siteId: 'ID!' },
    },
    fobReDerivationPreview: {
      __type: 'FobReDerivationPreview!',
      __args: { config: 'FobDerivationConfigInput', siteId: 'ID!' },
    },
    formHandoff: { __type: 'FormHandoff!', __args: { handoffId: 'ID!' } },
    formSignatureReadUrl: {
      __type: 'FormSignatureReadUrl!',
      __args: { signatureAssetId: 'String!' },
    },
    formSubmission: {
      __type: 'ClientFormSubmissionWithClient',
      __args: { submissionId: 'String!' },
    },
    formWorkflowEffectFailures: {
      __type: '[FormWorkflowEffectFailure!]!',
      __args: { siteId: 'String!' },
    },
    generateFontUploadSignedUrl: {
      __type: 'GenerateFontUploadSignedUrl!',
      __args: { corporateId: 'String!', fieldName: 'FontFieldName!', fontName: 'String!' },
    },
    getAgreementTemplateUrl: {
      __type: 'ClientFileUrl!',
      __args: { siteAgreementTemplateId: 'ID!', siteId: 'ID!' },
    },
    getAvailableBigQueryExports: { __type: '[AvailableExport!]!' },
    getBusinessClientSignUpFields: {
      __type: 'BusinessClientSignUpFields!',
      __args: { siteId: 'ID!' },
    },
    getClientCustomPropertyValues: {
      __type: 'ClientCustomPropertyValuesResponse!',
      __args: { clientId: 'String!', siteId: 'String!' },
    },
    getClientFileUrl: {
      __type: 'ClientFileUrl!',
      __args: { clientId: 'String!', fileId: 'String!', siteId: 'String!' },
    },
    getDashboardKpis: { __type: 'DashboardKpisResponse!', __args: { input: 'DashboardInput!' } },
    getRecurringPaymentStats: {
      __type: 'RecurringPaymentStats!',
      __args: { serviceId: 'ID!', siteId: 'ID!' },
    },
    getRecurringServiceDetail: {
      __type: 'RecurringServiceDetail!',
      __args: { serviceId: 'ID!', siteId: 'ID!' },
    },
    getScheduledJob: {
      __type: 'ScheduledJob',
      __args: { corporateId: 'ID', jobKey: 'String!', siteId: 'ID' },
    },
    getScheduledJobRun: { __type: 'ScheduledJobRun', __args: { jobId: 'String!' } },
    getServicesSoldTrend: { __type: '[ServicesSoldItem!]!', __args: { input: 'DashboardInput!' } },
    getTopServicesByVisits: { __type: '[TopServiceItem!]!', __args: { input: 'DashboardInput!' } },
    getVideoStatus: { __type: 'VideoStatus!', __args: { videoId: 'ID!' } },
    getVideoStreamingUrls: { __type: 'VideoStreamingUrls!', __args: { videoId: 'ID!' } },
    getVideosByArticle: { __type: '[VideoStatus!]!', __args: { knowledgeArticleId: 'ID!' } },
    giftCardDesign: { __type: 'GiftCardDesign', __args: { giftCardDesignId: 'ID!' } },
    giftCardDesigns: { __type: '[GiftCardDesign!]!', __args: { siteId: 'ID!' } },
    giftCardExpiryJurisdictionPreview: {
      __type: 'GiftCardExpiryJurisdictionPreview!',
      __args: { asOfDate: 'String', countryId: 'String!', zoneId: 'String' },
    },
    giftCardExpiryPolicies: {
      __type: '[SiteGiftCardExpiryPolicy!]!',
      __args: { siteIds: '[ID!]!' },
    },
    giftCardExpiryRuleHistory: {
      __type: '[GiftCardExpiryRuleHistoryEntry!]!',
      __args: { giftCardExpiryRuleId: 'ID!' },
    },
    giftCardExpiryRules: { __type: '[GiftCardExpiryRule!]!' },
    giftCardExpirySiteOptions: {
      __type: '[GiftCardExpirySiteOption!]!',
      __args: { corporateId: 'String!' },
    },
    giftCardExpirySitePreview: {
      __type: 'GiftCardExpirySitePreview!',
      __args: { asOfDate: 'String', corporateId: 'String!', siteId: 'String!' },
    },
    giftCardTemplate: { __type: 'GiftCardTemplate', __args: { giftCardTemplateId: 'ID!' } },
    giftCardTemplates: {
      __type: 'GiftCardTemplates!',
      __args: {
        filters: 'GiftCardTemplateFilter',
        pagination: 'GiftCardTemplatesPaginationInput',
        siteId: 'ID!',
        sort: 'GiftCardTemplateSort',
      },
    },
    giftCards: {
      __type: 'GiftCards!',
      __args: { filters: 'GiftCardFilter', giftCardTemplateId: 'ID!' },
    },
    giftCardsBySite: {
      __type: 'GiftCardSiteListResponse!',
      __args: { filters: 'GiftCardSiteListFilter', siteId: 'ID!' },
    },
    goal: { __type: 'CmsGoal', __args: { goalId: 'ID!' } },
    goals: { __type: '[CmsGoal!]!' },
    googleFonts: { __type: '[String!]!' },
    growHq: { __type: 'GrowHq', __args: { growHqId: 'String!' } },
    growHqs: { __type: '[GrowHq!]!' },
    growLocations: { __type: '[GrowLocation!]!' },
    guestPassAllocationSummary: {
      __type: 'GuestPassAllocationSummary',
      __args: { serviceId: 'ID!' },
    },
    guestPassAllowanceImpact: {
      __type: 'GuestPassAllowanceImpact!',
      __args: { serviceTemplateId: 'ID!' },
    },
    guestPassByToken: { __type: 'GuestPassByTokenResult!', __args: { token: 'String!' } },
    guestPassSummaryPeriods: { __type: 'CreditSummaryResult!', __args: { serviceId: 'ID!' } },
    guestPassVisits: { __type: '[GuestPassVisit!]!', __args: { serviceId: 'ID!' } },
    guestPasses: {
      __type: '[GuestPassWithSession!]!',
      __args: { filter: 'GuestPassesFilterInput!' },
    },
    hapanaFeesTemplate: { __type: 'HapanaFeesTemplate!', __args: { id: 'String!' } },
    hapanaFeesTemplates: {
      __type: 'HapanaFeesTemplatesPageInfo!',
      __args: {
        paginate: 'PaginationInput!',
        search: 'String',
        sort: 'FindFeesTemplatesSortOptions',
      },
    },
    hasFamilyShareablePackage: { __type: 'Boolean!', __args: { siteId: 'ID!' } },
    hasFeedback: {
      __type: 'Boolean!',
      __args: { attendanceId: 'ID!', clientId: 'ID!', siteId: 'ID!' },
    },
    hasServiceAtSite: { __type: 'Boolean!', __args: { clientId: 'ID!', siteId: 'ID!' } },
    helpDoc: { __type: 'HelpDoc', __args: { siteId: 'ID', slug: 'String!' } },
    helpDocCategories: { __type: '[HelpDocCategory!]!', __args: { siteId: 'ID' } },
    helpDocs: {
      __type: '[HelpDocSummary!]!',
      __args: {
        categorySlug: 'String',
        limit: 'Int',
        offset: 'Int',
        search: 'String',
        siteId: 'ID',
      },
    },
    hubSpotCompanyContacts: {
      __type: 'HubSpotCompanyContactsResult!',
      __args: { companyId: 'String!' },
    },
    importAuditCsvUrl: { __type: 'ImportAuditCsvUrl!', __args: { importSessionId: 'ID!' } },
    importBulkClassesTemplateXlsx: { __type: 'ImportReferenceDataExportXlsx!' },
    importClientUpdateTemplateXlsx: { __type: 'ImportReferenceDataExportXlsx!' },
    importClientsExportCsv: { __type: 'ImportSitesExportCsv!' },
    importCustomPropertiesExportCsv: { __type: 'ImportSitesExportCsv!' },
    importDistinctLocationIds: {
      __type: 'ImportDistinctLocationIds!',
      __args: { migrationId: 'ID!' },
    },
    importFailuresAuditCsvUrl: {
      __type: 'ImportFailuresAuditCsvUrl!',
      __args: { importSessionId: 'ID!' },
    },
    importFailuresSourceFileUrl: {
      __type: 'ImportFailuresAuditCsvUrl!',
      __args: { importSessionId: 'ID!' },
    },
    importFutureSessionsExportCsv: { __type: 'ImportSitesExportCsv!' },
    importGiftCardsExportCsv: { __type: 'ImportSitesExportCsv!' },
    importManualMigrationWorkbookXlsx: {
      __type: 'ImportReferenceDataExportXlsx!',
      __args: { siteId: 'ID' },
    },
    importMembershipPlanChangeTemplateXlsx: { __type: 'ImportReferenceDataExportXlsx!' },
    importMembershipPriceTemplateXlsx: { __type: 'ImportReferenceDataExportXlsx!' },
    importMembershipSuspendTemplateXlsx: { __type: 'ImportReferenceDataExportXlsx!' },
    importMissingMethodsExportXlsx: { __type: 'ImportReferenceDataExportXlsx!' },
    importOutstandingBalancesTemplateXlsx: { __type: 'ImportReferenceDataExportXlsx!' },
    importPackagesExportCsv: { __type: 'ImportSitesExportCsv!' },
    importPaidByUpdateTemplateXlsx: { __type: 'ImportReferenceDataExportXlsx!' },
    importPaymentMethodsExportCsv: { __type: 'ImportSitesExportCsv!' },
    importPrerequisites: { __type: 'ImportPrerequisites!', __args: { siteId: 'ID!' } },
    importPreview: {
      __type: 'ImportPreview!',
      __args: {
        filterBy: 'ImportPreviewFilterBy!',
        importSessionId: 'ID!',
        page: 'Float!',
        pageSize: 'Float!',
        search: 'String',
      },
    },
    importProcessedAuditCsvUrl: {
      __type: 'ImportFailuresAuditCsvUrl!',
      __args: { importSessionId: 'ID!' },
    },
    importReferenceDataExportXlsx: { __type: 'ImportReferenceDataExportXlsx!' },
    importScheduleTemplatesExportCsv: { __type: 'ImportSitesExportCsv!' },
    importSession: { __type: 'ImportSession!', __args: { importSessionId: 'ID!' } },
    importSitesExportCsv: { __type: 'ImportSitesExportCsv!' },
    importSkippedAuditCsvUrl: {
      __type: 'ImportFailuresAuditCsvUrl!',
      __args: { importSessionId: 'ID!' },
    },
    importSkippedSourceFileUrl: {
      __type: 'ImportFailuresAuditCsvUrl!',
      __args: { importSessionId: 'ID!' },
    },
    importSourceFileUrl: { __type: 'ImportSourceFileUrl!', __args: { importSessionId: 'ID!' } },
    importTemplateCsv: { __type: 'ImportTemplateCsv!', __args: { importType: 'String!' } },
    inceptionPanelSettings: {
      __type: 'InceptionPanelSettings!',
      __args: { siteAccessPointId: 'String!', siteId: 'String!' },
    },
    instructorOptions: { __type: '[StaffUserOption!]!' },
    instructors: { __type: '[InstructorForSite!]!', __args: { siteId: 'String!' } },
    invoice: { __type: 'Invoice!', __args: { invoiceId: 'String!', siteId: 'ID!' } },
    invoiceRevenueSummary: { __type: 'InvoiceRevenueSummary!', __args: { siteId: 'ID!' } },
    invoices: {
      __type: 'Invoices!',
      __args: {
        cursor: 'String',
        filter: 'InvoicesFilterInput',
        orderBy: '[InvoicesOrderByInput!]',
        pageSize: 'Float',
        search: 'String',
        siteId: 'ID',
      },
    },
    isClientAtSite: {
      __type: 'IsClientAtSite!',
      __args: { clientId: 'String!', siteId: 'String!' },
    },
    isInvoiceRefundAllowed: { __type: 'Boolean!', __args: { invoiceId: 'ID!', siteId: 'ID!' } },
    kioskConfig: { __type: 'KioskSetupResponse!', __args: { corporateId: 'String!' } },
    kioskDefaults: { __type: 'KioskDefaults!', __args: { corporateId: 'String!' } },
    kioskPinStatus: { __type: 'KioskPinStatus!', __args: { siteId: 'String!' } },
    kioskSessionBookings: {
      __type: 'KioskSessionBookings',
      __args: { sessionId: 'String!', siteId: 'String!' },
    },
    knowledgeArticle: {
      __type: 'KnowledgeArticle',
      __args: { includeDeleted: 'Boolean', knowledgeArticleId: 'ID', slug: 'String' },
    },
    knowledgeArticleCategories: {
      __type: '[KnowledgeArticleCategory!]!',
      __args: { includeDeleted: 'Boolean' },
    },
    knowledgeArticleCategory: {
      __type: 'KnowledgeArticleCategory',
      __args: { knowledgeArticleCategoryId: 'ID', slug: 'String' },
    },
    knowledgeArticleRevision: { __type: 'KnowledgeArticleRevision', __args: { revisionId: 'ID!' } },
    knowledgeArticleRevisions: {
      __type: 'KnowledgeArticleRevisionsResponse!',
      __args: { filter: 'KnowledgeArticleRevisionFilterInput', pagination: 'PaginationInput' },
    },
    knowledgeArticleStats: { __type: 'KnowledgeArticleStats!' },
    knowledgeArticleTranslation: {
      __type: 'KnowledgeArticleTranslation',
      __args: { knowledgeArticleId: 'ID!', locale: 'String!' },
    },
    knowledgeArticleTranslations: {
      __type: '[KnowledgeArticleTranslation!]!',
      __args: { knowledgeArticleId: 'ID!' },
    },
    knowledgeArticles: {
      __type: 'KnowledgeArticlesResponse!',
      __args: { filter: 'KnowledgeArticleFilterInput', pagination: 'PaginationInput' },
    },
    knowledgeArticlesByCategory: {
      __type: 'KnowledgeArticlesByCategoryResponse!',
      __args: {
        categorySlug: 'String!',
        limit: 'Int',
        offset: 'Int',
        status: 'KnowledgeArticleStatus',
      },
    },
    knowledgeArticlesForUser: {
      __type: '[KnowledgeArticle!]!',
      __args: {
        category: 'String',
        locale: 'String',
        pagination: 'PaginationInput',
        userContext: 'UserContextInput!',
      },
    },
    knowledgeDocument: { __type: 'KnowledgeDocument', __args: { id: 'ID!' } },
    knowledgeDocuments: {
      __type: '[KnowledgeDocument!]!',
      __args: { category: 'String', corporateId: 'String!', pagination: 'PaginationInput' },
    },
    lastAttendanceFeedback: {
      __type: 'LastAttendanceFeedback',
      __args: { clientId: 'String!', siteId: 'String!' },
    },
    latestTanningCheckIn: { __type: 'CheckIn', __args: { clientId: 'ID!', siteId: 'ID!' } },
    leaderboardAttendanceAggregation: {
      __type: '[LeaderboardAttendanceAggregation!]!',
      __args: {
        periodEnd: 'String!',
        periodStart: 'String!',
        sessionTypeIds: '[String!]',
        siteIds: '[String!]!',
      },
    },
    leaderboardConfig: { __type: 'LeaderboardConfig', __args: { leaderboardConfigId: 'String!' } },
    leaderboardConfigs: {
      __type: 'LeaderboardConfigConnection!',
      __args: {
        afterCursor: 'String',
        leaderboardType: 'LeaderboardType',
        limit: 'Float!',
        scope: 'LeaderboardScope',
        search: 'String',
        status: 'LeaderboardStatus',
      },
    },
    leaderboardDashboard: { __type: '[LeaderboardDashboard!]!' },
    leaderboardSnapshots: {
      __type: '[LeaderboardSnapshot!]!',
      __args: { endDate: 'String!', leaderboardConfigId: 'String!', startDate: 'String!' },
    },
    legacyInceptionConfig: { __type: 'LegacyInceptionConfig', __args: { siteId: 'String!' } },
    listAllClients: {
      __type: 'ListAllClients!',
      __args: {
        growStatus: 'GrowStatusFilter',
        limit: 'Float',
        offset: 'Float',
        paginate: 'PaginationInput',
        search: 'String',
        siteId: 'String',
        sort: 'FindClientsSortOptions',
      },
    },
    listGcsBundlePrefixes: { __type: 'ListGcsBundlePrefixes!', __args: { root: 'String' } },
    listGcsBundleZips: { __type: 'ListGcsBundleZips!', __args: { prefix: 'String!' } },
    listInvoicesByService: {
      __type: '[VirtualInvoice!]!',
      __args: { lookAheadMonths: 'Float', serviceId: 'ID!', siteId: 'ID!' },
    },
    listPastInvoicesByService: {
      __type: 'ListPastInvoicesByService!',
      __args: { args: 'ListPastInvoicesByServiceArgs!', siteId: 'ID!' },
    },
    listRecurringInvoices: {
      __type: 'RecurringInvoicesPaginationResult!',
      __args: { input: 'ListRecurringInvoicesInput!', siteId: 'ID!' },
    },
    listScheduledInvoicesByService: {
      __type: 'ListScheduledInvoicesByServiceResult!',
      __args: { args: 'ListScheduledInvoicesByServiceArgs!', siteId: 'ID!' },
    },
    listScheduledJobRuns: {
      __type: 'ScheduledJobRunsResult!',
      __args: {
        corporateId: 'ID',
        jobKey: 'String!',
        paginate: 'ListScheduledJobRunsPaginateInput!',
        siteId: 'ID',
        status: 'ScheduledJobRunStatus',
      },
    },
    listScheduledJobs: {
      __type: '[ScheduledJob!]!',
      __args: { corporateId: 'ID', level: 'ScheduledJobLevel', siteId: 'ID' },
    },
    listServicesByTemplateType: {
      __type: 'ServicesPaginationResult!',
      __args: { input: 'ListServicesByTemplateTypeInput!', siteId: 'ID!' },
    },
    locationOperationsCounts: { __type: 'LocationOperationsCounts!', __args: { siteId: 'ID!' } },
    maintenanceEmailConfigured: { __type: 'Boolean!', __args: { siteId: 'ID!' } },
    me: { __type: 'Self!' },
    mediaFolders: { __type: '[MediaFolder!]!', __args: { mediaType: 'MediaType' } },
    memberApiAuditLogs: {
      __type: '[MemberApiAuditLog!]!',
      __args: {
        limit: 'Float!',
        method: 'String',
        offset: 'Float!',
        pathContains: 'String',
        siteId: 'String',
        status: 'Float',
      },
    },
    memberAuditEvents: {
      __type: 'AuditQueryResult!',
      __args: {
        corporateId: 'String!',
        memberId: 'String!',
        pagination: 'AuditEventsPaginationInput',
      },
    },
    memberExperienceBranding: {
      __type: 'MemberExperienceBranding!',
      __args: { corporateId: 'String!' },
    },
    memberExperienceFonts: { __type: 'MemberExperienceFonts!', __args: { corporateId: 'String!' } },
    memberExperienceRuntime: {
      __type: 'MemberExperienceRuntime!',
      __args: { corporateId: 'ID!', language: 'String!', surface: 'MemberExperienceSurface!' },
    },
    memberExperienceSettings: {
      __type: 'MemberExperienceSettings!',
      __args: { corporateId: 'String!' },
    },
    memberExperienceSurfaceBranding: {
      __type: 'MemberExperienceSurfaceBranding',
      __args: { corporateId: 'String!', surface: 'MemberExperienceSurface!' },
    },
    memberExperienceSurfaceIntegrations: {
      __type: '[MemberExperienceSurfaceIntegration!]!',
      __args: { corporateId: 'String!' },
    },
    memberExperienceTheme: {
      __type: 'MemberExperienceTheme!',
      __args: { corporateId: 'String!', surface: 'MemberExperienceSurface!' },
    },
    memberMovement: { __type: 'MemberMovementDetail', __args: { movementId: 'ID!' } },
    memberMovementAttestationRegister: {
      __type: 'MemberMovementAttestationRegisterResult!',
      __args: { input: 'MemberMovementAttestationRegisterInput!' },
    },
    memberMovementBlockedQueue: {
      __type: 'MemberMovementConnection!',
      __args: { input: 'MemberMovementBlockedQueueInput!' },
    },
    memberMovementDestinationTemplates: {
      __type: '[MemberMovementDestinationTemplate!]!',
      __args: { siteId: 'ID!' },
    },
    memberMovementEligibilityCheck: {
      __type: 'MemberMovementEligibilityResult!',
      __args: { input: 'MemberMovementEligibilityCheckInput!' },
    },
    memberMovementHeldMovements: {
      __type: '[MemberMovementHeldMovement!]!',
      __args: { runId: 'ID!' },
    },
    memberMovementHomeSiteRecoveryQueue: {
      __type: 'MemberMovementConnection!',
      __args: { input: 'MemberMovementHomeSiteRecoveryInput!' },
    },
    memberMovementIncomingApprovals: {
      __type: 'MemberMovementConnection!',
      __args: { input: 'MemberMovementIncomingApprovalQueueInput!' },
    },
    memberMovementIncomingDestinationTemplates: {
      __type: '[MemberMovementIncomingDestinationTemplate!]!',
      __args: { input: 'MemberMovementIncomingDestinationTemplatesInput!' },
    },
    memberMovementIncomingMovement: {
      __type: 'MemberMovementIncomingMovement!',
      __args: { input: 'MemberMovementIncomingMovementInput!' },
    },
    memberMovementIncomingNotifierCandidates: {
      __type: '[MemberMovementIncomingNotifierCandidate!]!',
      __args: { input: 'MemberMovementIncomingNotifierCandidatesInput!' },
    },
    memberMovementIncomingQueue: {
      __type: 'MemberMovementIncomingConnection!',
      __args: { input: 'MemberMovementIncomingQueueInput!' },
    },
    memberMovementIncomingSummary: {
      __type: 'MemberMovementIncomingSummary!',
      __args: { input: 'MemberMovementIncomingSummaryInput!' },
    },
    memberMovementLocationPostures: {
      __type: 'MemberMovementLocationPostures!',
      __args: { input: 'MemberMovementLocationPosturesInput!' },
    },
    memberMovementLocationResolutions: {
      __type: 'MemberMovementLocationResolutionConnection!',
      __args: { input: 'MemberMovementLocationResolutionsInput!' },
    },
    memberMovementManualTransferPreview: {
      __type: 'MemberMovementManualTransferPreview!',
      __args: { input: 'MemberMovementManualTransferInput!' },
    },
    memberMovementOverlappingRuns: {
      __type: '[MemberMovementOverlappingRun!]!',
      __args: { runId: 'ID!' },
    },
    memberMovementPaymentCollection: {
      __type: 'MemberMovementConnection!',
      __args: { input: 'MemberMovementPaymentCollectionInput!' },
    },
    memberMovementPaymentTransferMatrix: {
      __type: 'MemberMovementPaymentTransferMatrix!',
      __args: { corporateId: 'ID!' },
    },
    memberMovementRevertLog: {
      __type: 'MemberMovementConnection!',
      __args: { input: 'MemberMovementRevertLogInput!' },
    },
    memberMovementRollingSchedulerStatus: {
      __type: 'MemberMovementRollingSchedulerStatus!',
      __args: { corporateId: 'ID!' },
    },
    memberMovementRun: { __type: 'MemberMovementRun', __args: { runId: 'ID!' } },
    memberMovementRunApprovalReadiness: {
      __type: 'MemberMovementApprovalReadiness!',
      __args: { input: 'MemberMovementApprovalReadinessInput!' },
    },
    memberMovementRuns: {
      __type: 'MemberMovementRunConnection!',
      __args: { input: 'MemberMovementRunsInput!' },
    },
    memberMovementTemplateMappings: {
      __type: '[MemberMovementTemplateMapping!]!',
      __args: { corporateId: 'ID!' },
    },
    memberMovementTransferableMemberships: {
      __type: '[MemberMovementTransferableMembership!]!',
      __args: { clientId: 'ID!', corporateId: 'ID!' },
    },
    memberMovementWorkbookUrl: { __type: 'String', __args: { runId: 'ID!' } },
    memberMovements: {
      __type: 'MemberMovementConnection!',
      __args: { filter: 'MemberMovementsFilterInput!' },
    },
    memberNotificationChannels: { __type: '[MessageType!]!', __args: { siteId: 'ID!' } },
    memberSiteByEmail: { __type: 'MemberSiteInfo', __args: { email: 'String!' } },
    membershipActiveCounts: {
      __type: 'MembershipActiveCountsResult!',
      __args: { serviceTemplateIds: '[ID!]!', siteId: 'ID!' },
    },
    membershipActiveMembers: {
      __type: 'MembershipActiveMembersResult!',
      __args: { cursor: 'String', pageSize: 'Float', serviceTemplateId: 'ID!', siteId: 'ID!' },
    },
    membershipMemberStatusCounts: {
      __type: 'MembershipMemberStatusCounts!',
      __args: { serviceTemplateId: 'ID!', siteId: 'ID!' },
    },
    membershipMembers: {
      __type: 'MembershipMembersResult!',
      __args: {
        cursor: 'String',
        pageSize: 'Float',
        serviceTemplateId: 'ID!',
        siteId: 'ID!',
        status: 'MembershipMemberStatusFilter!',
      },
    },
    mergeClientsPreview: {
      __type: 'MergeClientsPreview!',
      __args: { input: 'MergeClientsPreviewInput!' },
    },
    mergedClientInfo: { __type: 'MergedClientInfo!', __args: { clientId: 'String!' } },
    messagingProviders: { __type: '[ProviderInfo!]!' },
    migrationSessions: { __type: 'MigrationSessions!', __args: { migrationId: 'ID!' } },
    migrations: { __type: 'Migrations!', __args: { corporateId: 'ID!' } },
    mobileAppBranding: { __type: 'MobileAppBranding!', __args: { corporateId: 'String!' } },
    mobileAppBuildOverview: { __type: 'MobileAppBuildOverview!', __args: { brandId: 'String!' } },
    mobileAppChannels: { __type: 'MobileAppChannels!', __args: { corporateId: 'String!' } },
    mobileAppConfig: { __type: 'MobileSetupResponse!', __args: { corporateId: 'String!' } },
    mobileAppCreateEnabled: { __type: 'Boolean!', __args: { corporateId: 'String!' } },
    mobileAppProfile: { __type: 'MobileAppProfile', __args: { corporateId: 'String!' } },
    monthViewSessions: {
      __type: '[MonthViewDay!]!',
      __args: {
        endDate: 'String!',
        filters: 'SessionQueryFiltersInput',
        sessionsPerDay: 'Float',
        siteId: 'String!',
        startDate: 'String!',
        status: 'String',
        timezone: 'String',
      },
    },
    myApprovalPinStatus: { __type: 'ApprovalPinStatus!' },
    myCalendarFeedUrl: { __type: 'String', __args: { siteId: 'String!' } },
    myCommission: { __type: 'MyCommission', __args: { commissionPeriodId: 'ID' } },
    myCoverPreferences: { __type: 'MyCoverPreferences!' },
    myCoverRequests: { __type: '[CoverRequestView!]!' },
    myFamily: { __type: 'Family', __args: { siteId: 'ID!' } },
    myFamilyInvites: { __type: '[FamilyInvite!]!', __args: { siteId: 'ID!' } },
    myFormSubmission: { __type: 'MemberFormDetail!', __args: { formSubmissionId: 'String!' } },
    myFormerFamilyMemberBookings: {
      __type: '[FormerFamilyMemberBookings!]!',
      __args: { siteId: 'ID!' },
    },
    myGiftCards: { __type: '[MemberGiftCard!]!', __args: { siteId: 'ID!' } },
    myMembershipPauseOptions: {
      __type: 'MemberPauseOptions!',
      __args: { serviceId: 'ID!', siteId: 'ID!' },
    },
    myPendingForms: {
      __type: 'MemberPendingFormsPage!',
      __args: { after: 'String', first: 'Float', siteId: 'String!' },
    },
    myPendingPolicies: { __type: 'MyPendingPolicies!', __args: { siteId: 'ID!' } },
    mySharedPackages: { __type: '[MySharedPackage!]!' },
    onboardingProgress: { __type: 'OnboardingProgress!', __args: { corporateId: 'ID!' } },
    openCoversForMe: { __type: '[CoverRequestView!]!', __args: { siteIds: '[ID!]' } },
    organisationBillingPreview: {
      __type: 'OrganisationBillingPreview!',
      __args: { organisationClientId: 'ID!', siteId: 'ID!' },
    },
    organisationEmployees: {
      __type: '[OrganisationEmployee!]!',
      __args: { organisationClientId: 'ID!', siteId: 'ID!' },
    },
    paperFormApprovers: { __type: '[PaperFormApprover!]!', __args: { siteId: 'ID!' } },
    payment: { __type: 'Payment!', __args: { paymentId: 'ID!', siteId: 'ID!' } },
    paymentClientSecret: {
      __type: 'PaymentClientSecret!',
      __args: { clientId: 'ID!', invoiceId: 'ID!', paymentId: 'ID!', siteId: 'ID!' },
    },
    paymentRecovery: {
      __type: 'PaymentRecovery!',
      __args: { invoiceId: 'ID!', paymentId: 'ID!', siteId: 'ID!' },
    },
    paymentRecoveryStatus: {
      __type: 'PaymentRecoveryStatus!',
      __args: { invoiceId: 'ID!', paymentId: 'ID!', siteId: 'ID!' },
    },
    pendingBookingRequests: { __type: '[PendingBookingRequest!]!', __args: { siteId: 'ID!' } },
    pendingBookingRequestsCount: { __type: 'Float!', __args: { siteId: 'ID!' } },
    pendingCashDrawerPayouts: { __type: '[PendingCashDrawerPayout!]!', __args: { siteId: 'ID!' } },
    pendingGuestPassesForEmail: {
      __type: '[PendingGuestPassForEmail!]!',
      __args: { verifiedEmail: 'String' },
    },
    pendingItemsHandoff: { __type: 'PendingItemsHandoff!', __args: { handoffId: 'ID!' } },
    pendingItemsRecipients: {
      __type: '[PendingItemsRecipient!]!',
      __args: { clientId: 'ID!', siteId: 'ID!' },
    },
    pendingKnowledgeArticleRevisionCount: { __type: 'Int!' },
    pendingKnowledgeArticleRevisionForArticle: {
      __type: 'KnowledgeArticleRevision',
      __args: { knowledgeArticleId: 'ID!' },
    },
    pendingPolicies: {
      __type: '[SiteAgreementTemplate!]!',
      __args: { clientId: 'ID!', siteId: 'ID!' },
    },
    physicalLocations: { __type: '[SiteLocation!]!', __args: { siteId: 'ID!' } },
    policyBulkSendPreview: {
      __type: 'PolicyBulkSendPreview!',
      __args: {
        clientIds: '[ID!]',
        equipmentCategory: 'PolicyEquipmentScope',
        search: 'String',
        siteId: 'ID!',
        statuses: '[EquipmentComplianceStatus!]',
      },
    },
    policyBulkSendRun: { __type: 'PolicyBulkSendRun!', __args: { runId: 'ID!', siteId: 'ID!' } },
    policyEvidenceExports: { __type: '[PolicyEvidenceExport!]!', __args: { siteId: 'ID!' } },
    posCategories: { __type: '[CreatePosCategoryResponse!]!', __args: { siteId: 'ID!' } },
    posProduct: {
      __type: 'UpdatePosProductResponse!',
      __args: { posProductId: 'ID!', siteId: 'ID!' },
    },
    posProductActivityLogs: {
      __type: '[PosProductActivityLogWithStaff!]!',
      __args: { limit: 'Int!', posProductId: 'ID!', siteId: 'ID!' },
    },
    posProductByCode: {
      __type: 'UpdatePosProductResponse',
      __args: { code: 'String!', siteId: 'ID!' },
    },
    posProductVariablesFlat: {
      __type: 'PosProductVariablesFlat!',
      __args: {
        categoryId: 'ID',
        cursor: 'String',
        featured: 'Boolean',
        isEnabledForSale: 'Boolean',
        limit: 'Int!',
        search: 'String',
        siteId: 'ID!',
        status: 'PosProductStatus',
      },
    },
    posProducts: {
      __type: 'PosProducts!',
      __args: {
        categoryId: 'ID',
        cursor: 'String',
        featured: 'Boolean',
        isEnabledForSale: 'Boolean',
        limit: 'Int!',
        search: 'String',
        siteId: 'ID!',
        status: 'PosProductStatus',
      },
    },
    posStockAdjustments: {
      __type: '[PosStockAdjustment!]!',
      __args: { limit: 'Int!', posProductVariableId: 'ID!', siteId: 'ID!' },
    },
    previewGcsBundleMatch: {
      __type: 'PreviewGcsBundleMatch!',
      __args: { corporateId: 'ID!', gcsUrls: '[String!]!', importType: 'String!' },
    },
    previewMembershipPlanChange: {
      __type: 'PreviewMembershipPlanChangeResult!',
      __args: {
        customPrice: 'String',
        serviceId: 'ID!',
        siteId: 'ID!',
        toServiceTemplateId: 'ID!',
      },
    },
    previewMyMembershipPause: {
      __type: 'MemberPausePreview!',
      __args: { input: 'MemberPauseWindowInput!', serviceId: 'ID!', siteId: 'ID!' },
    },
    previewMyMembershipResume: {
      __type: 'PreviewServiceResumeResult',
      __args: { serviceId: 'ID!', siteId: 'ID!' },
    },
    previewPresaleDateShift: {
      __type: 'PresaleDateShiftPreview!',
      __args: { input: 'PreviewPresaleDateShiftInput!', siteId: 'ID!' },
    },
    previewProratedSuspension: {
      __type: 'PreviewProratedSuspensionResult',
      __args: { endDate: 'String', serviceId: 'ID!', siteId: 'ID!', startDate: 'String!' },
    },
    previewServiceCancellation: {
      __type: 'PreviewServiceCancellationResult!',
      __args: {
        asOf: 'String',
        cancelAt: 'String',
        effectiveDate: 'String',
        serviceId: 'ID!',
        siteId: 'ID!',
      },
    },
    previewServiceResume: {
      __type: 'PreviewServiceResumeResult',
      __args: { restartDate: 'String', serviceId: 'ID!', siteId: 'ID!' },
    },
    previewSuspensionFee: {
      __type: 'PreviewSuspensionFeeResult',
      __args: {
        chargeAmount: 'String!',
        endDate: 'String',
        feeBillingCycleAmount: 'Float',
        feeBillingCycleUnit: 'String',
        serviceId: 'ID!',
        siteId: 'ID!',
        startDate: 'String!',
      },
    },
    previewSuspensionPlan: {
      __type: 'PreviewSuspensionPlanResult!',
      __args: { pauses: '[PreviewSuspensionPlanPauseInput!]!', serviceId: 'ID!', siteId: 'ID!' },
    },
    previewSuspensionSecondaryFee: {
      __type: 'PreviewSuspensionSecondaryFeeResult',
      __args: {
        endDate: 'String',
        serviceId: 'ID!',
        siteId: 'ID!',
        startDate: 'String!',
        suspensionType: 'ServiceSuspensionType',
      },
    },
    previewTimeShiftSuspension: {
      __type: 'PreviewTimeShiftSuspensionResult',
      __args: { endDate: 'String', serviceId: 'ID!', siteId: 'ID!', startDate: 'String!' },
    },
    promoCode: { __type: 'PromoCode', __args: { promoCodeId: 'ID!' } },
    promoCodeByCode: { __type: 'PromoCode', __args: { code: 'String!', siteId: 'ID!' } },
    promoCodes: {
      __type: 'PromoCodes!',
      __args: {
        cursor: 'String',
        discountType: 'PromoCodeDiscountType',
        endDateFrom: 'String',
        endDateTo: 'String',
        limit: 'Int!',
        search: 'String',
        siteId: 'ID!',
        sort: 'PromoCodeSort',
        startDateFrom: 'String',
        startDateTo: 'String',
        status: 'PromoCodeStatus',
      },
    },
    rebateTemplate: { __type: 'RebateTemplate!', __args: { id: 'ID!' } },
    rebateTemplates: {
      __type: 'RebateTemplates!',
      __args: {
        cursor: 'String',
        orderBy: '[RebateTemplatesOrderByInput!]!',
        pageSize: 'Float',
        search: 'String',
      },
    },
    recentWebhookDeliveries: {
      __type: 'AuditQueryResult!',
      __args: {
        corporateId: 'String!',
        pagination: 'AuditEventsPaginationInput',
        siteId: 'String',
      },
    },
    recurringPatternBoundaries: {
      __type: 'RecurringPatternBoundaries',
      __args: { sessionId: 'String!', siteId: 'String!' },
    },
    recurringSessionInstances: {
      __type: 'RecurringSessionInstancesResponse!',
      __args: { recurringSessionsId: 'String!', siteId: 'String!' },
    },
    referredBy: { __type: 'ReferredBy', __args: { clientId: 'String!', siteId: 'String!' } },
    refund: { __type: 'Refund!', __args: { refundId: 'ID!', siteId: 'ID!' } },
    region: { __type: 'Regions', __args: { regionId: 'ID!' } },
    regions: { __type: '[Regions!]!' },
    releaseHubNote: { __type: 'ReleaseHubNote', __args: { siteId: 'ID', slug: 'String!' } },
    releaseHubNotes: {
      __type: '[ReleaseHubNote!]!',
      __args: { includeComingSoon: 'Boolean', months: '[String!]!', siteId: 'ID' },
    },
    releaseHubRail: { __type: 'ReleaseHubRail!', __args: { siteId: 'ID' } },
    releaseNote: { __type: 'ReleaseNote', __args: { releaseNoteId: 'ID', slug: 'String' } },
    releaseNoteStats: { __type: 'ReleaseNoteStats!' },
    releaseNoteTranslation: {
      __type: 'ReleaseNoteTranslation',
      __args: { locale: 'String!', releaseNoteId: 'ID!' },
    },
    releaseNoteTranslations: {
      __type: '[ReleaseNoteTranslation!]!',
      __args: { releaseNoteId: 'ID!' },
    },
    releaseNotes: {
      __type: 'ReleaseNotesResponse!',
      __args: { filter: 'ReleaseNoteFilterInput', pagination: 'PaginationInput' },
    },
    releaseNotesForUser: {
      __type: '[ReleaseNote!]!',
      __args: {
        includeReadStatus: 'Boolean',
        pagination: 'PaginationInput',
        releaseType: 'ReleaseNoteType',
        userContext: 'UserContextInput!',
      },
    },
    reportDefinition: {
      __type: 'ReportDefinition!',
      __args: { input: 'ReportDefinitionInputInput!' },
    },
    resolveMovementTemplate: {
      __type: 'ResolveMovementTemplate!',
      __args: { destinationSiteId: 'ID!', sourceServiceTemplateId: 'ID!' },
    },
    resolvedCustomText: {
      __type: 'ResolvedCustomText!',
      __args: { corporateId: 'String!', language: 'String!' },
    },
    roomCustomPropertyRequirement: {
      __type: 'SiteRoomResourceTemplateProperty',
      __args: {
        roomResourceTemplateId: 'String!',
        siteId: 'String!',
        siteRoomResourceTemplatePropertyId: 'String!',
      },
    },
    roomCustomPropertyRequirements: {
      __type: '[SiteRoomResourceTemplateProperty!]!',
      __args: { roomResourceTemplateId: 'String!', siteId: 'String!' },
    },
    roomResourceTemplate: {
      __type: 'SiteRoomResourceTemplateResponse',
      __args: { id: 'String!', siteId: 'String!' },
    },
    roomResourceTemplateForSession: {
      __type: 'SiteRoomResourceTemplateResponse',
      __args: { id: 'String!', siteId: 'String!' },
    },
    roomResourceTemplates: {
      __type: '[SiteRoomResourceTemplateResponse!]!',
      __args: { siteId: 'String!' },
    },
    royaltiesAndFeesTemplate: { __type: 'RoyaltiesAndFeesTemplate!', __args: { id: 'ID!' } },
    royaltiesAndFeesTemplates: {
      __type: 'RoyaltiesAndFeesTemplates!',
      __args: {
        cursor: 'String',
        orderBy: '[RoyaltiesAndFeesTemplatesOrderByInput!]!',
        pageSize: 'Float',
        search: 'String',
      },
    },
    runReport: { __type: 'RunReport!', __args: { input: 'RunReportInputInput!' } },
    sandboxBrands: {
      __type: 'SandboxBrands!',
      __args: {
        brandStatus: 'BrandStatus',
        offset: 'Float!',
        pageSize: 'Float!',
        sandboxStatus: 'SandboxStatusFilter',
        search: 'String',
      },
    },
    sandboxLatestJob: { __type: 'SandboxMigrationJob', __args: { brandSlug: 'String!' } },
    sandboxMigrationJob: { __type: 'SandboxMigrationJob', __args: { jobId: 'String!' } },
    savedReport: { __type: 'SavedReport!', __args: { savedReportId: 'String!' } },
    savedReportCategories: { __type: '[SavedReportCategories!]!', __args: { siteId: 'String' } },
    savedReports: { __type: '[SavedReports!]!', __args: { siteId: 'String' } },
    scheduledInvoices: {
      __type: 'ListAllScheduledInvoicesResult!',
      __args: { input: 'ListAllScheduledInvoicesInput!', siteId: 'ID!' },
    },
    scheduledPushAudiencePreview: {
      __type: 'ScheduledPushAudiencePreview!',
      __args: { audienceType: 'ScheduledPushAudienceType!', sessionId: 'ID', siteId: 'ID!' },
    },
    scheduledPushSends: { __type: '[ScheduledPushSend!]!', __args: { siteId: 'ID!' } },
    scoringConversionPreview: {
      __type: 'ScoringConversionPreview!',
      __args: { siteFormId: 'String!', siteId: 'ID!' },
    },
    searchGoogleFonts: {
      __type: 'SearchGoogleFonts!',
      __args: { limit: 'Float!', offset: 'Float!', search: 'String!' },
    },
    searchHubSpotCompanies: {
      __type: 'HubSpotCompaniesSearchResult!',
      __args: { limit: 'Int', query: 'String' },
    },
    searchKnowledge: {
      __type: 'KnowledgeSearchResponse!',
      __args: { input: 'KnowledgeSearchInput!' },
    },
    searchKnowledgeArticles: {
      __type: '[KnowledgeArticle!]!',
      __args: { limit: 'Int', publishedOnly: 'Boolean', search: 'String!' },
    },
    service: { __type: 'Service', __args: { serviceId: 'String!' } },
    serviceCreditAdjustmentNotes: {
      __type: 'CreditAdjustmentNotesResult!',
      __args: { cursor: 'String', pageSize: 'Float', serviceId: 'String!' },
    },
    serviceCreditSummaryPeriods: {
      __type: 'CreditSummaryResult!',
      __args: {
        serviceId: 'String!',
        siteSessionTypeId: 'String',
        siteSessionTypeIds: '[String!]',
      },
    },
    serviceCreditUsageHistory: {
      __type: 'CreditUsageHistoryResult!',
      __args: { cursor: 'String', pageSize: 'Float', serviceId: 'String!' },
    },
    serviceTemplate: { __type: 'ServiceTemplate', __args: { serviceTemplateId: 'String!' } },
    serviceTemplateAddOnEligibleParents: {
      __type: '[ServiceTemplateAddOnEligibleParent!]!',
      __args: { addOnServiceTemplateIds: '[ID!]!', siteId: 'ID!' },
    },
    serviceTemplateAddOnParents: {
      __type: '[ServiceTemplateAddOn!]!',
      __args: { addOnServiceTemplateId: 'String!' },
    },
    serviceTemplateAddOnPriceGroupPrices: {
      __type: '[AddOnPriceGroupPrice!]!',
      __args: { serviceTemplateId: 'ID!', siteId: 'ID!' },
    },
    serviceTemplateAddOnSummaries: {
      __type: '[ServiceTemplateAddOnSummary!]!',
      __args: { addOnServiceTemplateIds: '[String!]!', siteId: 'String!' },
    },
    serviceTemplateAddOnsForParents: {
      __type: '[ServiceTemplateAddOnForParent!]!',
      __args: { parentServiceTemplateIds: '[ID!]!', siteId: 'ID!' },
    },
    serviceTemplateCategories: {
      __type: '[CreateServiceTemplateCategoryResponse!]!',
      __args: { siteId: 'String!' },
    },
    serviceTemplateOptions: {
      __type: '[ServiceTemplateOption!]!',
      __args: { siteIds: '[String!]' },
    },
    serviceTemplateSessionTypeAddOns: {
      __type: '[ServiceTemplateSessionTypeAddOn!]!',
      __args: { siteId: 'ID!' },
    },
    serviceTemplates: {
      __type: '[ServiceTemplate!]!',
      __args: {
        categoryId: 'String',
        isIntroOffer: 'Boolean',
        search: 'String',
        serviceTemplateIds: '[String!]',
        siteIds: '[String!]',
        status: 'ServiceTemplateStatus',
        type: 'ServiceTemplateType',
      },
    },
    serviceTemplatesPaginated: {
      __type: 'ServiceTemplatesPaginated!',
      __args: {
        categoryId: 'String',
        cursor: 'String',
        isIntroOffer: 'Boolean',
        orderBy: '[ServiceTemplatesPaginatedOrderByInput!]',
        pageSize: 'Float',
        search: 'String',
        siteId: 'String',
        siteIds: '[String!]',
        status: 'ServiceTemplateStatus',
        type: 'ServiceTemplateType',
      },
    },
    session: { __type: 'Session', __args: { id: 'String!', siteId: 'String!' } },
    sessionDeletionPreview: {
      __type: 'SessionDeletionPreview!',
      __args: { input: 'SessionDeletionPreviewInput!' },
    },
    sessionFeedback: {
      __type: 'SessionFeedback',
      __args: { sessionFeedbackId: 'ID!', siteId: 'ID!' },
    },
    sessionFeedbackByAttendanceId: {
      __type: 'SessionFeedback',
      __args: { attendanceId: 'ID!', siteId: 'ID!' },
    },
    sessionFeedbackByClientId: {
      __type: '[SessionFeedback!]!',
      __args: { clientId: 'ID!', limit: 'Float', siteId: 'ID!' },
    },
    sessionFeedbackBySessionId: {
      __type: '[SessionFeedback!]!',
      __args: { sessionId: 'ID!', siteId: 'ID!' },
    },
    sessionFeedbackQuestions: { __type: '[SessionFeedbackQuestion!]!', __args: { siteId: 'ID!' } },
    sessionFeedbackStatuses: {
      __type: '[SessionFeedbackStatusEntry!]!',
      __args: { clientId: 'ID!', sessionIds: '[ID!]!' },
    },
    sessionFees: { __type: 'SessionFees!', __args: { sessionId: 'ID!', siteId: 'ID!' } },
    sessionFilter: {
      __type: 'SessionFilter',
      __args: { sessionFilterId: 'String!', siteId: 'String!' },
    },
    sessionFilters: { __type: '[SessionFilter!]!', __args: { siteId: 'String!' } },
    sessionTemplate: { __type: 'SessionTemplate', __args: { id: 'String!', siteId: 'String!' } },
    sessionTemplateFeedbackQuestions: {
      __type: '[SessionFeedbackQuestion!]!',
      __args: { sessionTemplateId: 'ID!', siteId: 'ID!' },
    },
    sessionTemplates: {
      __type: 'SessionTemplatePaginationResult!',
      __args: {
        category: 'SessionCategory',
        cursor: 'String',
        pageSize: 'Float',
        search: 'String',
        siteId: 'String!',
        siteSessionTypeId: 'String',
        sortByDisplayOrder: 'Boolean',
      },
    },
    sessionWaitlistCount: { __type: 'Float!', __args: { sessionId: 'String!', siteId: 'String!' } },
    sessionWaitlistEntries: {
      __type: '[SessionWaitlistEntry!]!',
      __args: { sessionId: 'String!', siteId: 'String!' },
    },
    sessions: {
      __type: '[Session!]!',
      __args: {
        endDate: 'String!',
        filters: 'SessionQueryFiltersInput',
        limit: 'Float',
        offset: 'Float',
        siteId: 'String!',
        startDate: 'String!',
        status: 'String',
      },
    },
    sessionsForDay: {
      __type: 'DaySessionsPage!',
      __args: {
        cursor: 'String',
        date: 'String!',
        filters: 'SessionQueryFiltersInput',
        limit: 'Float',
        siteId: 'String!',
        status: 'String',
        timezone: 'String',
      },
    },
    sessionsInTimeRange: {
      __type: '[Session!]!',
      __args: {
        endTime: 'String!',
        siteId: 'String!',
        siteLocationRoomId: 'String',
        staffUserIds: '[String!]',
        startTime: 'String!',
      },
    },
    sessionsPaginated: {
      __type: 'SessionsPage!',
      __args: {
        endDate: 'String!',
        filters: 'SessionQueryFiltersInput',
        limit: 'Float!',
        offset: 'Float!',
        siteId: 'String!',
        startDate: 'String!',
        status: 'String',
      },
    },
    shareableClients: {
      __type: '[ShareableClient!]!',
      __args: { search: 'String!', siteId: 'ID!' },
    },
    sharedCreditInviteContext: {
      __type: 'SharedCreditInviteContext!',
      __args: { inviteToken: 'String!' },
    },
    sharedCreditRecipientEligibility: {
      __type: '[SharedCreditRecipientEligibility!]!',
      __args: { clientIds: '[ID!]!', serviceId: 'ID!' },
    },
    sharedCreditsDetails: { __type: '[SharedCreditsDetail!]!', __args: { serviceId: 'ID!' } },
    sharedPackageDetails: { __type: 'SharedPackageDetails!', __args: { serviceId: 'ID!' } },
    sharedRelationActivity: {
      __type: '[SharedRelationActivityEntry!]!',
      __args: { clientId: 'ID!', counterpartyClientId: 'ID!', siteId: 'ID!' },
    },
    signedAgreementPdfUrl: {
      __type: 'String',
      __args: { agreementId: 'ID!', clientId: 'ID!', siteId: 'ID!' },
    },
    signedPolicyAgreements: {
      __type: '[SignedPolicyAgreements!]!',
      __args: { clientId: 'ID!', siteId: 'ID!' },
    },
    site: { __type: 'Site', __args: { siteId: 'ID!' } },
    siteAccessPoint: {
      __type: 'SiteAccessPoint!',
      __args: { siteAccessPointId: 'String!', siteId: 'String!' },
    },
    siteAccessPointCredentialSchema: {
      __type: '[CredentialField!]!',
      __args: { provider: 'DoorProvider!', siteId: 'String!' },
    },
    siteAccessPointDeviceStatuses: {
      __type: '[SiteAccessPointDeviceStatus!]!',
      __args: { siteId: 'String!' },
    },
    siteAccessPointLiveDeviceConfig: {
      __type: 'SiteAccessPointLiveDeviceConfig!',
      __args: { siteAccessPointId: 'String!', siteId: 'String!' },
    },
    siteAccessPoints: { __type: '[SiteAccessPoint!]!', __args: { siteId: 'String!' } },
    siteAccessZones: { __type: '[SiteAccessZone!]!', __args: { siteId: 'String!' } },
    siteAccountCode: { __type: 'SiteAccountCode', __args: { accountCodeId: 'ID!', siteId: 'ID!' } },
    siteAccountCodeTemplatesInUse: {
      __type: 'TemplatesUsingAccountCodeResult!',
      __args: { accountCodeId: 'ID!', siteId: 'ID!' },
    },
    siteAccountCodes: { __type: '[SiteAccountCode!]!', __args: { siteId: 'ID!' } },
    siteActiveAlerts: { __type: 'SiteActiveAlerts!', __args: { siteId: 'String!' } },
    siteActiveTerminalReaders: { __type: '[SiteTerminalReader!]!', __args: { siteId: 'ID!' } },
    siteAggregatorAutoAssignSpot: {
      __type: 'Boolean!',
      __args: { aggregatorProviderId: 'String!', siteId: 'ID!' },
    },
    siteAgreementTemplates: { __type: '[SiteAgreementTemplate!]!', __args: { siteId: 'ID!' } },
    siteAlerts: { __type: '[SiteAlertListItem!]!', __args: { siteId: 'String!' } },
    siteAuditEvents: {
      __type: 'AuditQueryResult!',
      __args: {
        corporateId: 'String!',
        filter: 'SiteAuditEventsFilterInput',
        pagination: 'AuditEventsPaginationInput',
        siteId: 'String!',
        sort: 'AuditEventsSortInput',
      },
    },
    siteChallengeOverview: { __type: 'SiteChallengeOverview!', __args: { siteId: 'ID!' } },
    siteClientStats: { __type: 'ClientSiteStatsResponse!', __args: { siteId: 'String!' } },
    siteClients: { __type: 'SiteClientsResponse!', __args: { siteId: 'String!' } },
    siteCloneJob: { __type: 'SiteCloneJob!', __args: { siteCloneJobId: 'ID!' } },
    siteCloneManifest: { __type: 'SiteCloneManifest!', __args: { siteId: 'ID!' } },
    siteClosureSessionsPreview: {
      __type: '[SiteClosureSession!]!',
      __args: { from: 'String!', siteId: 'String!', to: 'String!' },
    },
    siteClosures: {
      __type: '[SiteClosure!]!',
      __args: { endDate: 'String!', siteId: 'String!', startDate: 'String!' },
    },
    siteCommunicationTemplate: {
      __type: 'SiteCommunicationTemplate!',
      __args: { alias: 'CommunicationTemplateAliases!', siteId: 'ID!' },
    },
    siteCommunicationTemplateById: {
      __type: 'SiteCommunicationTemplateById',
      __args: { siteCommunicationTemplateId: 'ID!', siteId: 'ID!' },
    },
    siteCommunicationTemplateEmailPreview: {
      __type: 'SiteCommunicationTemplateEmailPreview!',
      __args: {
        alias: 'CommunicationTemplateAliases!',
        emailBody: 'String',
        emailSubject: 'String',
        emailUseHapanaLayout: 'Boolean',
        siteId: 'ID!',
      },
    },
    siteCommunicationTemplatePlaceholders: { __type: '[String!]!', __args: { siteId: 'ID!' } },
    siteCommunicationTemplates: {
      __type: 'SiteCommunicationTemplatePaginationResultSchema!',
      __args: {
        activeCommunicationType: 'SiteCommunicationTemplatesActiveCommunicationTypeInput',
        alias: 'CommunicationTemplateAliases',
        cursor: 'String',
        pageSize: 'Float',
        search: 'String',
        siteId: 'ID!',
      },
    },
    siteCoverSettings: { __type: 'SiteCoverSettings!', __args: { siteId: 'ID!' } },
    siteCustomIntegrations: { __type: '[SiteCustomIntegrations!]!', __args: { siteId: 'ID!' } },
    siteDevices: { __type: 'SiteDevices!', __args: { siteId: 'String!' } },
    siteDoorAccessEvents: {
      __type: 'SiteDoorAccessEvents!',
      __args: {
        clientId: 'String',
        cursor: 'String',
        endDate: 'String',
        pageSize: 'Float',
        search: 'String',
        siteAccessPointId: 'String',
        siteAccessZoneId: 'String',
        siteId: 'String!',
        sortDirection: 'SortDirection',
        sortField: 'DoorAccessEventSortField',
        startDate: 'String',
      },
    },
    siteEnabledAggregatorProviderIds: { __type: '[String!]!', __args: { siteId: 'ID!' } },
    siteEntitlements: { __type: 'SiteEntitlements!', __args: { siteId: 'ID!' } },
    siteForm: { __type: 'SiteForm', __args: { id: 'String!', siteId: 'ID!' } },
    siteFormTemplates: { __type: '[SiteFormTemplate!]!', __args: { siteId: 'ID!' } },
    siteForms: { __type: '[SiteForm!]!', __args: { siteId: 'ID!' } },
    siteGroup: { __type: 'SiteGroup!', __args: { siteGroupId: 'ID!' } },
    siteGroupBrandServiceTemplateNames: {
      __type: '[BrandServiceTemplateName!]!',
      __args: { siteGroupId: 'ID!' },
    },
    siteGroupBrandServiceTemplateWithdrawals: {
      __type: '[BrandServiceTemplateWithdrawal!]!',
      __args: { siteGroupId: 'ID!', siteIds: '[ID!]' },
    },
    siteGroupBrandSessionGroupNames: { __type: '[String!]!', __args: { siteGroupId: 'ID!' } },
    siteGroupBrandTaxSettingNames: { __type: '[String!]!', __args: { siteGroupId: 'ID!' } },
    siteGroups: {
      __type: 'SiteGroups!',
      __args: {
        cursor: 'String',
        orderBy: '[SiteGroupsOrderByInput!]!',
        pageSize: 'Float',
        search: 'String',
      },
    },
    siteGroupsAvailableToAssign: {
      __type: '[SiteGroup!]!',
      __args: { staffAccessPolicyId: 'ID!' },
    },
    siteGroupsBySite: { __type: '[SiteGroup!]!', __args: { siteId: 'ID!' } },
    siteGrowStatus: { __type: 'SiteGrowStatus!', __args: { siteId: 'String!' } },
    siteLateCancelFeeUsage: {
      __type: '[SiteLateCancelFeeUsageEntry!]!',
      __args: { lateCancelFeeIds: '[ID!]!', siteId: 'ID!' },
    },
    siteLateCancelFees: { __type: '[SiteLateCancelFee!]!', __args: { siteId: 'ID!' } },
    siteLiveOccupancy: { __type: 'SiteLiveOccupancy', __args: { siteId: 'String!' } },
    siteLocation: { __type: 'SiteLocation', __args: { siteId: 'ID!', siteLocationId: 'ID!' } },
    siteLocationRoom: {
      __type: 'SiteLocationRoom',
      __args: { siteId: 'ID!', siteLocationId: 'ID!', siteLocationRoomId: 'ID!' },
    },
    siteLocations: { __type: '[SiteLocation!]!', __args: { siteId: 'ID!' } },
    siteMemberAppSettings: {
      __type: 'SiteMemberAppSettingsResult!',
      __args: { siteId: 'String!' },
    },
    siteNextAlertChange: { __type: 'String', __args: { siteId: 'String!' } },
    siteNoShowFeeUsage: {
      __type: '[SiteNoShowFeeUsageEntry!]!',
      __args: { noShowFeeIds: '[ID!]!', siteId: 'ID!' },
    },
    siteNoShowFees: { __type: '[SiteNoShowFee!]!', __args: { siteId: 'ID!' } },
    sitePaymentAuthorisationConfig: {
      __type: 'SitePaymentAuthorisationConfig!',
      __args: { siteId: 'ID!' },
    },
    sitePaymentGateway: { __type: 'SitePaymentGatewayInfo!', __args: { siteId: 'ID!' } },
    sitePaymentMethod: { __type: 'SitePaymentMethodDetails', __args: { siteId: 'String!' } },
    sitePayrollTier: {
      __type: 'SitePayrollTier',
      __args: {
        assignmentsSearch: 'String',
        configurationsSearch: 'String',
        id: 'ID!',
        siteId: 'ID!',
      },
    },
    sitePayrollTiers: { __type: '[SitePayrollTiers!]!', __args: { siteId: 'ID!' } },
    sitePlanYourVisit: { __type: 'SitePlanYourVisit', __args: { siteId: 'String!' } },
    sitePolicies: { __type: '[SitePolicy!]!', __args: { siteId: 'String!' } },
    sitePolicy: { __type: 'SitePolicy', __args: { id: 'String!', siteId: 'String!' } },
    sitePolicyComplianceSettings: {
      __type: 'PolicyComplianceSettings!',
      __args: { siteId: 'ID!' },
    },
    sitePolicyRevisions: {
      __type: '[SitePolicyRevision!]!',
      __args: { siteId: 'ID!', sitePolicyId: 'ID!' },
    },
    siteRecurringWorkshops: { __type: '[SiteRecurringWorkshop!]!', __args: { siteId: 'String!' } },
    siteSessionType: { __type: 'SiteSessionType', __args: { id: 'String!', siteId: 'String!' } },
    siteSessionTypes: {
      __type: '[SiteSessionType!]!',
      __args: { search: 'String', siteId: 'String!' },
    },
    siteSessionTypesByIds: {
      __type: '[SiteSessionType!]!',
      __args: { siteId: 'String!', siteSessionTypeIds: '[String!]!' },
    },
    siteSuppliers: { __type: '[CreateSiteSupplierResponse!]!', __args: { siteId: 'String!' } },
    siteTerminalHandoffRequiredFields: {
      __type: '[TerminalHandoffField!]!',
      __args: { siteId: 'ID!' },
    },
    siteTerminalHandoffSettings: {
      __type: 'SiteTerminalHandoffSettingsView!',
      __args: { siteId: 'ID!' },
    },
    siteTerminalReader: {
      __type: 'SiteTerminalReader!',
      __args: { siteId: 'ID!', siteTerminalReaderId: 'ID!' },
    },
    siteTerminalReaderRegistrationReadiness: {
      __type: 'SiteTerminalReaderRegistrationReadiness!',
      __args: { siteId: 'ID!' },
    },
    siteTerminalReaders: {
      __type: 'SiteTerminalReaderPaginationResult!',
      __args: {
        cursor: 'String',
        orderBy: '[SiteTerminalReadersOrderByInput!]',
        pageSize: 'Float',
        search: 'String',
        siteId: 'ID!',
      },
    },
    siteThemeStatus: {
      __type: 'ThemeEntitlementResult!',
      __args: { corporateId: 'ID!', siteId: 'ID!', themeSlug: 'String!' },
    },
    siteThemeStatuses: {
      __type: '[SiteThemeStatusRow!]!',
      __args: { corporateId: 'ID!', siteId: 'ID!' },
    },
    siteWebhook: { __type: 'SiteWebhook', __args: { siteId: 'String!', webhookId: 'String!' } },
    siteWebhookDeliveries: {
      __type: '[SiteWebhookDelivery!]!',
      __args: {
        limit: 'Float',
        offset: 'Float',
        siteId: 'String!',
        status: 'SiteWebhookDeliveryStatus',
        webhookId: 'String!',
      },
    },
    siteWebhookDelivery: {
      __type: 'SiteWebhookDelivery',
      __args: { deliveryId: 'String!', siteId: 'String!', webhookId: 'String!' },
    },
    siteWebhooks: {
      __type: '[SiteWebhook!]!',
      __args: {
        endingBefore: 'String',
        limit: 'Float',
        siteId: 'String!',
        startingAfter: 'String',
        status: 'SiteWebhookStatus',
      },
    },
    siteWebhooksCount: {
      __type: 'Float!',
      __args: { siteId: 'String!', status: 'SiteWebhookStatus' },
    },
    siteWebhooksEnabled: { __type: 'Boolean!', __args: { corporateId: 'ID!' } },
    siteWorkshops: {
      __type: '[SiteWorkshop!]!',
      __args: { siteId: 'String!', type: 'SiteWorkshopTypes!' },
    },
    sites: {
      __type: 'Sites!',
      __args: {
        cursor: 'String',
        filter: 'SitesFilterInput',
        orderBy: '[SitesOrderByInput!]',
        pageSize: 'Float',
        search: 'String',
      },
    },
    sitesAvailableToAssign: { __type: '[SiteReference!]!', __args: { staffAccessPolicyId: 'ID!' } },
    sitesPlanOverrideSelection: { __type: 'SitesPlanOverrideSelection!' },
    smsCreditsHistory: {
      __type: 'SmsCreditsHistory!',
      __args: {
        cursor: 'String',
        direction: 'SmsCreditsDirection',
        endDate: 'String',
        pageSize: 'Float',
        reason: 'SmsCreditsReason',
        siteId: 'String!',
        startDate: 'String',
      },
    },
    smsPackage: { __type: 'SmsPackage!', __args: { smsPackageId: 'ID!' } },
    smsPackages: {
      __type: 'SmsPackages!',
      __args: {
        cursor: 'String',
        filter: 'SmsPackagesFilterInput',
        orderBy: '[SmsPackagesOrderByInput!]!',
        pageSize: 'Float',
        search: 'String',
      },
    },
    smsPackagesByCountry: { __type: 'SmsPackage', __args: { countryId: 'String!' } },
    soapNote: { __type: 'SoapNote', __args: { siteId: 'String!', soapNoteId: 'String!' } },
    soapNotes: { __type: 'SoapNotesResponse!', __args: { clientId: 'String!', siteId: 'String!' } },
    soapNotesBySession: {
      __type: 'SoapNotesResponse!',
      __args: { sessionId: 'String!', siteId: 'String!' },
    },
    staffAccessPolicies: {
      __type: 'StaffAccessPolicies!',
      __args: {
        cursor: 'String',
        orderBy: '[StaffAccessPoliciesOrderByInput!]!',
        pageSize: 'Float',
        search: 'String',
      },
    },
    staffAccessPoliciesAvailableToAssign: { __type: '[StaffAccessPolicy!]!' },
    staffAccessPolicy: { __type: 'StaffAccessPolicy!', __args: { staffAccessPolicyId: 'ID!' } },
    staffAccessPolicyAssignability: {
      __type: 'StaffAccessPolicyAssignability!',
      __args: { staffAccessPolicyId: 'ID!' },
    },
    staffAccessPolicyAssignabilitySummary: { __type: '[StaffAccessPolicyAssignabilitySummary!]!' },
    staffAccessPolicyIdsGrantable: { __type: '[ID!]!' },
    staffAllowedNetwork: {
      __type: 'StaffAllowedNetwork!',
      __args: { staffAllowedNetworkId: 'ID!' },
    },
    staffAllowedNetworks: { __type: '[StaffAllowedNetwork!]!', __args: { siteId: 'ID' } },
    staffInvitationsList: {
      __type: '[StaffInvitation!]!',
      __args: { corporateId: 'ID!', limit: 'Float', offset: 'Float', status: 'InvitationStatus' },
    },
    staffOptions: { __type: '[StaffUserOption!]!' },
    staffOptionsBySite: { __type: '[StaffUserOption!]!', __args: { siteId: 'ID!' } },
    staffSessionAssignment: {
      __type: 'StaffSessionAssignment',
      __args: { staffSessionAssignmentId: 'ID!' },
    },
    staffSessionAssignments: {
      __type: 'StaffSessionAssignmentPaginationResult!',
      __args: { cursor: 'String', pageSize: 'Float', sessionId: 'String', staffUserId: 'String' },
    },
    staffSessionAssignmentsBySession: {
      __type: '[StaffSessionAssignment!]!',
      __args: { sessionId: 'ID!' },
    },
    staffSessionAssignmentsByStaffUser: {
      __type: '[StaffSessionAssignment!]!',
      __args: { staffUserId: 'ID!' },
    },
    staffSessionPolicy: { __type: 'StaffSessionPolicy!' },
    staffTimeClockActivityLog: {
      __type: 'StaffTimeClockActivityLog!',
      __args: { limit: 'Float', offset: 'Float', siteId: 'ID!', staffUserId: 'ID!' },
    },
    staffTimeClockStatuses: {
      __type: '[StaffTimeClockStatus!]!',
      __args: { siteId: 'ID!', staffUserIds: '[ID!]!' },
    },
    staffUser: { __type: 'StaffUser!', __args: { staffUserId: 'ID!' } },
    staffUserSmartGroups: {
      __type: '[StaffUserSmartGroup!]!',
      __args: { siteId: 'String!', staffUserId: 'String!' },
    },
    staffUsers: { __type: '[StaffUser!]!' },
    stripeConnectAccounts: { __type: '[StripeConnectAccount!]!' },
    supportChat: { __type: 'SupportChat', __args: { supportChatId: 'ID!' } },
    supportChatMessages: {
      __type: '[SupportChatMessage!]!',
      __args: { pagination: 'PaginationInput', supportChatId: 'String!' },
    },
    supportChatWithMessages: {
      __type: 'SupportChatWithMessages',
      __args: { supportChatId: 'ID!' },
    },
    tanningConnectorHealth: { __type: 'TanningConnectorHealth!', __args: { siteId: 'ID!' } },
    tanningEligibility: {
      __type: 'TanningEligibility!',
      __args: {
        category: 'EquipmentCategory!',
        clientId: 'String!',
        equipmentId: 'ID',
        siteId: 'String!',
      },
    },
    taxSetting: { __type: 'TaxSetting', __args: { siteId: 'ID!', taxSettingId: 'ID!' } },
    taxSettings: { __type: '[TaxSetting!]', __args: { enabled: 'Boolean', siteId: 'ID!' } },
    taxSettingsByIds: {
      __type: '[TaxSetting!]!',
      __args: { siteId: 'ID!', taxSettingIds: '[ID!]!' },
    },
    taxSettingsCount: { __type: 'Float!', __args: { siteId: 'ID!' } },
    terminalHandoffPlan: {
      __type: 'TerminalHandoffPlan!',
      __args: { clientId: 'ID', siteId: 'ID!' },
    },
    terminalHandoffRequest: {
      __type: 'TerminalHandoffRequest!',
      __args: { siteId: 'ID!', terminalHandoffRequestId: 'ID!' },
    },
    testMembers: { __type: '[TestMember!]!' },
    themeDeployments: { __type: '[ThemeDeploymentRow!]!', __args: { corporateId: 'ID!' } },
    themeSubscription: {
      __type: 'ThemeSubscription',
      __args: { corporateId: 'ID!', themeSlug: 'String!' },
    },
    themeSubscriptions: { __type: '[ThemeSubscription!]!', __args: { corporateId: 'ID!' } },
    thirdPartyIntegration: {
      __type: 'ThirdPartyIntegrationWithKeys!',
      __args: { thirdPartyIntegrationId: 'ID!' },
    },
    thirdPartyIntegrations: { __type: '[ThirdPartyIntegrationWithKeys!]!' },
    trialPipeline: { __type: '[TrialPipelineItem!]!' },
    trialStatus: { __type: 'TrialStatusResponse!', __args: { corporateId: 'ID!' } },
    unreadReleaseNotes: {
      __type: '[ReleaseNote!]!',
      __args: { limit: 'Int', userContext: 'UserContextInput!' },
    },
    unreadReleaseNotesCount: { __type: 'Int!', __args: { userContext: 'UserContextInput!' } },
    userSupportChats: {
      __type: '[SupportChat!]!',
      __args: { pagination: 'PaginationInput', status: 'SupportChatStatus', userId: 'String!' },
    },
    usersAssignedToPolicy: {
      __type: '[StaffUserReference!]!',
      __args: { search: 'String', staffAccessPolicyId: 'ID!' },
    },
    validateGiftCard: { __type: 'ValidateGiftCardResult!', __args: { code: 'String!' } },
    validatePromoCode: {
      __type: 'ValidatePromoCode!',
      __args: { input: 'PromoCodeValidationInput!', siteId: 'ID!' },
    },
    validateSiteIds: { __type: 'Boolean!', __args: { siteIds: '[ID!]!' } },
    verifyCheckoutSession: { __type: 'VerifySessionResponse!', __args: { sessionId: 'String!' } },
    visibleCustomLinks: { __type: '[CustomLink!]!' },
    webhookDeliveryHistory: {
      __type: 'AuditQueryResult!',
      __args: {
        corporateId: 'String!',
        pagination: 'AuditEventsPaginationInput',
        siteId: 'String',
        webhookId: 'String!',
        webhookType: 'WebhookType',
      },
    },
    weekViewSessions: {
      __type: '[WeekViewDay!]!',
      __args: {
        endDate: 'String!',
        filters: 'SessionQueryFiltersInput',
        siteId: 'String!',
        startDate: 'String!',
        status: 'String',
        timezone: 'String',
        visiblePerDay: 'Float',
      },
    },
    wellhubDivergenceReport: { __type: 'WellhubDivergenceReport!', __args: { siteId: 'ID!' } },
    wellhubProductMappings: { __type: '[WellhubProductMapping!]!', __args: { siteId: 'ID!' } },
    wellhubProducts: { __type: '[WellhubProductEntry!]!', __args: { siteId: 'ID!' } },
    wellhubSessionTypePublishCounts: {
      __type: '[WellhubSessionTypePublishCounts!]!',
      __args: { siteId: 'ID!' },
    },
    zapierStatus: { __type: 'ZapierStatus!', __args: { siteId: 'ID!' } },
    zone: { __type: 'Zone!', __args: { countryId: 'ID!', zoneId: 'ID!' } },
    zones: {
      __type: 'Zones!',
      __args: {
        cursor: 'String',
        filter: 'ZonesFilterInput',
        orderBy: '[ZonesOrderByInput!]',
        pageSize: 'Float',
        search: 'String',
      },
    },
    zoomConnectionStatus: { __type: 'ZoomConnectionStatus!', __args: { siteId: 'ID!' } },
    zoomUsers: { __type: '[ZoomAccountUser!]!', __args: { siteId: 'ID!' } },
  },
  subscription: {},
  [SchemaUnionsKey]: { CompletionConfig: ['EzypayCompletionConfig', 'StripeCompletionConfig'] },
} as const

export interface AIArticleStreamResult {
  __typename?: 'AIArticleStreamResult'
  articleId: ScalarsEnums['String']
  streamId: ScalarsEnums['String']
  success: ScalarsEnums['Boolean']
}

export interface AIGeneratedArticle {
  __typename?: 'AIGeneratedArticle'
  citations: Array<ArticleCitation>
  confidence: ScalarsEnums['Float']
  contentMarkdown: ScalarsEnums['String']
  subtitle: ScalarsEnums['String']
  suggestedSlug: ScalarsEnums['String']
  suggestedTags: Array<ScalarsEnums['String']>
  summary: ScalarsEnums['String']
  title: ScalarsEnums['String']
}

export interface AcceptInvitation {
  __typename?: 'AcceptInvitation'
  invitation: AcceptInvitationInvitation
}

export interface AcceptInvitationInvitation {
  __typename?: 'AcceptInvitationInvitation'
  corporateId: ScalarsEnums['ID']
  email: ScalarsEnums['String']
  invitationId: ScalarsEnums['ID']
  permissionPolicyIds?: Maybe<Array<ScalarsEnums['String']>>
  role: ScalarsEnums['String']
  siteId?: Maybe<ScalarsEnums['ID']>
}

/**
 * Which policies a native accept recorded and which it refused
 */
export interface AcceptMyPoliciesResult {
  __typename?: 'AcceptMyPoliciesResult'
  acceptedItemKeys: Array<ScalarsEnums['String']>
  refusals: Array<MyPolicyRefusal>
  refusedItemKeys: Array<ScalarsEnums['String']>
}

export interface AcceptPolicies {
  __typename?: 'AcceptPolicies'
  acceptedCount: ScalarsEnums['Float']
  message: ScalarsEnums['String']
  success: ScalarsEnums['Boolean']
}

export interface AcceptSitePolicies {
  __typename?: 'AcceptSitePolicies'
  acceptedPolicyIds: Array<ScalarsEnums['String']>
  skippedPolicyIds: Array<ScalarsEnums['String']>
}

/**
 * Result of a member-initiated account deletion request
 */
export interface AccountDeletionRequestResult {
  __typename?: 'AccountDeletionRequestResult'
  message: ScalarsEnums['String']
  requestId: ScalarsEnums['String']
  success: ScalarsEnums['Boolean']
}

export interface AcknowledgeFontDeployment {
  __typename?: 'AcknowledgeFontDeployment'
  channels: MobileAppChannels
  success: ScalarsEnums['Boolean']
}

export interface ActiveSiteAlert {
  __typename?: 'ActiveSiteAlert'
  amenityId?: Maybe<ScalarsEnums['ID']>
  body?: Maybe<ScalarsEnums['String']>
  endsAt?: Maybe<ScalarsEnums['String']>
  link?: Maybe<SiteAlertLink>
  marksLocationClosed: ScalarsEnums['Boolean']
  showAsPopup: ScalarsEnums['Boolean']
  siteAlertId: ScalarsEnums['ID']
  startsAt: ScalarsEnums['String']
  theme: ScalarsEnums['SiteAlertTheme']
  title: ScalarsEnums['String']
  updatedAt: ScalarsEnums['String']
}

/**
 * A single activity stream item with booking, session, and activity details
 */
export interface ActivityStreamItem {
  __typename?: 'ActivityStreamItem'
  activity?: Maybe<ActivityStreamItemActivity>
  booking: ActivityStreamItemBooking
  session: ActivityStreamItemSession
}

export interface ActivityStreamItemActivity {
  __typename?: 'ActivityStreamItemActivity'
  byName: ScalarsEnums['String']
  statusDate: ScalarsEnums['String']
  type: ScalarsEnums['BookingActivityType']
}

export interface ActivityStreamItemBooking {
  __typename?: 'ActivityStreamItemBooking'
  bookingId: ScalarsEnums['String']
  status: ScalarsEnums['BookingStatus']
}

export interface ActivityStreamItemSession {
  __typename?: 'ActivityStreamItemSession'
  endTime?: Maybe<ScalarsEnums['String']>
  instructors: Array<ActivityStreamItemSessionInstructors>
  name: ScalarsEnums['String']
  sessionId: ScalarsEnums['String']
  startTime?: Maybe<ScalarsEnums['String']>
}

export interface ActivityStreamItemSessionInstructors {
  __typename?: 'ActivityStreamItemSessionInstructors'
  firstName: ScalarsEnums['String']
  lastName: ScalarsEnums['String']
}

/**
 * Paginated activity stream result
 */
export interface ActivityStreamPaginationResult {
  __typename?: 'ActivityStreamPaginationResult'
  pageInfo: ClientBookingsPageInfo
  results: Array<ActivityStreamResultItem>
}

/**
 * A single activity stream result with cursor
 */
export interface ActivityStreamResultItem {
  __typename?: 'ActivityStreamResultItem'
  cursor: ScalarsEnums['String']
  row: ActivityStreamItem
}

/**
 * Response for adding client to site
 */
export interface AddClientToSiteResponse {
  __typename?: 'AddClientToSiteResponse'
  message?: Maybe<ScalarsEnums['String']>
  success: ScalarsEnums['Boolean']
}

export interface AddCustomPropertyAlert {
  __typename?: 'AddCustomPropertyAlert'
  success: ScalarsEnums['Boolean']
}

/**
 * A set of session types at a location that share one add-on price per plan; each session type joins at most one group
 */
export interface AddOnPriceGroup {
  __typename?: 'AddOnPriceGroup'
  addOnPriceGroupId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  name: ScalarsEnums['String']
  priceCount: ScalarsEnums['Int']
  siteId: ScalarsEnums['ID']
  siteSessionTypeIds: Array<ScalarsEnums['ID']>
  taxSettingIds?: Maybe<Array<ScalarsEnums['ID']>>
  updatedAt: ScalarsEnums['String']
}

/**
 * A plan's add-on price for every session type in a price group, charged on top of a credit from that plan
 */
export interface AddOnPriceGroupPrice {
  __typename?: 'AddOnPriceGroupPrice'
  addOnPriceGroupId: ScalarsEnums['ID']
  addOnPriceGroupPriceId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  price: ScalarsEnums['Numeric']
  serviceTemplateId: ScalarsEnums['ID']
  siteId: ScalarsEnums['ID']
  updatedAt: ScalarsEnums['String']
}

/**
 * A live session type at a location that a price group can hold
 */
export interface AddOnPriceGroupSessionTypeOption {
  __typename?: 'AddOnPriceGroupSessionTypeOption'
  code?: Maybe<ScalarsEnums['Float']>
  name: ScalarsEnums['String']
  siteSessionTypeId: ScalarsEnums['String']
}

export interface AddReferral {
  __typename?: 'AddReferral'
  message: ScalarsEnums['String']
  showReferralMsg: ScalarsEnums['Boolean']
  success: ScalarsEnums['Boolean']
}

export interface AddReferralBonus {
  __typename?: 'AddReferralBonus'
  message: ScalarsEnums['String']
  success: ScalarsEnums['Boolean']
}

/**
 * Response containing stock adjustment details
 */
export interface AdjustStockResponse {
  __typename?: 'AdjustStockResponse'
  posStockAdjustmentId: ScalarsEnums['ID']
  quantityAfter: ScalarsEnums['Int']
}

/**
 * Admin access group for managing admin user permissions
 */
export interface AdminAccessGroup {
  __typename?: 'AdminAccessGroup'
  corporates: Array<ScalarsEnums['String']>
  createdAt: ScalarsEnums['String']
  createdBy: ScalarsEnums['String']
  description?: Maybe<ScalarsEnums['String']>
  groupId: ScalarsEnums['ID']
  isAllCorporates: ScalarsEnums['Boolean']
  isDefault: ScalarsEnums['Boolean']
  isRestricted: ScalarsEnums['Boolean']
  name: ScalarsEnums['String']
  permissions: Array<ScalarsEnums['AdminUserPermissions']>
  updatedAt: ScalarsEnums['String']
}

/**
 * Partner booking counts by outcome. booked excludes cancelled and late-cancelled; withSpot counts booked rows holding a bed/spot
 */
export interface AdminAggregatorBookingTotals {
  __typename?: 'AdminAggregatorBookingTotals'
  attended: ScalarsEnums['Float']
  booked: ScalarsEnums['Float']
  cancelled: ScalarsEnums['Float']
  lateCancelled: ScalarsEnums['Float']
  noShow: ScalarsEnums['Float']
  upcoming: ScalarsEnums['Float']
  withSpot: ScalarsEnums['Float']
}

/**
 * Partner booking counts for one site-local session date
 */
export interface AdminAggregatorDayTotals {
  __typename?: 'AdminAggregatorDayTotals'
  attended: ScalarsEnums['Float']
  booked: ScalarsEnums['Float']
  cancelled: ScalarsEnums['Float']
  lateCancelled: ScalarsEnums['Float']
  noShow: ScalarsEnums['Float']
  upcoming: ScalarsEnums['Float']
  withSpot: ScalarsEnums['Float']
  date: ScalarsEnums['String']
  sessionCount: ScalarsEnums['Float']
}

/**
 * Partner booking totals for one site and provider over a session-date range, with a per-day breakdown
 */
export interface AdminAggregatorLocationSummary {
  __typename?: 'AdminAggregatorLocationSummary'
  days: Array<AdminAggregatorDayTotals>
  sessionCount: ScalarsEnums['Float']
  siteName?: Maybe<ScalarsEnums['String']>
  siteTimezone?: Maybe<ScalarsEnums['String']>
  totals: AdminAggregatorBookingTotals
}

/**
 * Aggregator session data for admin view
 */
export interface AdminAggregatorSession {
  __typename?: 'AdminAggregatorSession'
  aggregatorAttendedCount?: Maybe<ScalarsEnums['Float']>
  aggregatorBookedCount?: Maybe<ScalarsEnums['Float']>
  aggregatorCancelledCount?: Maybe<ScalarsEnums['Float']>
  aggregatorLateCancelledCount?: Maybe<ScalarsEnums['Float']>
  aggregatorNoShowCount?: Maybe<ScalarsEnums['Float']>
  aggregatorWithSpotCount?: Maybe<ScalarsEnums['Float']>
  availableSpots: ScalarsEnums['Float']
  bookedCount: ScalarsEnums['Float']
  instructors: Array<AggregatorSessionInstructor>
  locationName?: Maybe<ScalarsEnums['String']>
  room?: Maybe<AggregatorSessionRoom>
  sessionCategory?: Maybe<ScalarsEnums['String']>
  sessionEndTime: ScalarsEnums['String']
  sessionId: ScalarsEnums['String']
  sessionName: ScalarsEnums['String']
  sessionStartTime: ScalarsEnums['String']
  size: ScalarsEnums['Float']
  status: ScalarsEnums['String']
}

/**
 * Paginated response of aggregator sessions
 */
export interface AdminAggregatorSessionsResponse {
  __typename?: 'AdminAggregatorSessionsResponse'
  sessions: Array<AdminAggregatorSession>
  siteTimezone?: Maybe<ScalarsEnums['String']>
  totalCount: ScalarsEnums['Float']
}

export interface AdminMobileFleet {
  __typename?: 'AdminMobileFleet'
  brands: Array<AdminMobileFleetBrand>
  credentials: AdminMobileFleetCredentials
  summary: AdminMobileFleetSummary
}

export interface AdminMobileFleetActivity {
  __typename?: 'AdminMobileFleetActivity'
  description?: Maybe<ScalarsEnums['String']>
  severity: ScalarsEnums['AdminMobileFleetSeverity']
  timestamp?: Maybe<ScalarsEnums['String']>
  title: ScalarsEnums['String']
}

export interface AdminMobileFleetAppleSession {
  __typename?: 'AdminMobileFleetAppleSession'
  action?: Maybe<ScalarsEnums['AdminMobileFleetAppleSessionAction']>
  lastVerifiedAt?: Maybe<ScalarsEnums['String']>
  needsAction: ScalarsEnums['Boolean']
  state: ScalarsEnums['AdminMobileFleetCredentialState']
  status: ScalarsEnums['AppleAccountSessionStatus']
  trustExpiresAt?: Maybe<ScalarsEnums['String']>
}

export interface AdminMobileFleetAppleTeam {
  __typename?: 'AdminMobileFleetAppleTeam'
  agreementsPending?: Maybe<ScalarsEnums['Boolean']>
  appleTeamId: ScalarsEnums['String']
  brandCount: ScalarsEnums['Float']
  checkedAt?: Maybe<ScalarsEnums['String']>
  corporateId?: Maybe<ScalarsEnums['String']>
  hasAscKey?: Maybe<ScalarsEnums['Boolean']>
  issues: Array<ScalarsEnums['AdminMobileFleetAppleTeamIssue']>
  membershipExpiresAt?: Maybe<ScalarsEnums['String']>
  name?: Maybe<ScalarsEnums['String']>
  state: ScalarsEnums['AdminMobileFleetCredentialState']
}

export interface AdminMobileFleetBrand {
  __typename?: 'AdminMobileFleetBrand'
  android: AdminMobileFleetPlatform
  appName?: Maybe<ScalarsEnums['String']>
  blockers: Array<ScalarsEnums['AdminMobileFleetBlocker']>
  brandId: ScalarsEnums['String']
  brandName: ScalarsEnums['String']
  corporateId?: Maybe<ScalarsEnums['String']>
  environment: ScalarsEnums['BrandEnvironment']
  ios: AdminMobileFleetPlatform
  latestActivity: AdminMobileFleetActivity
  nextAction: AdminMobileFleetNextAction
  operations: AdminMobileFleetOperations
  prerequisites: Array<AdminMobileFleetPrerequisite>
  releaseHold?: Maybe<BrandReleaseHold>
  setup: AdminMobileFleetSetup
  setupProgress: ScalarsEnums['Float']
  updatedAt?: Maybe<ScalarsEnums['String']>
}

export interface AdminMobileFleetCredentials {
  __typename?: 'AdminMobileFleetCredentials'
  appleSession: AdminMobileFleetAppleSession
  appleTeams: Array<AdminMobileFleetAppleTeam>
  easTokenPresent: ScalarsEnums['Boolean']
  githubTokenPresent: ScalarsEnums['Boolean']
  playPublisherConfigured: ScalarsEnums['Boolean']
}

export interface AdminMobileFleetNextAction {
  __typename?: 'AdminMobileFleetNextAction'
  description: ScalarsEnums['String']
  kind: ScalarsEnums['AdminMobileFleetNextActionKind']
  platforms: Array<ScalarsEnums['BrandPlatform']>
  primaryAction?: Maybe<ScalarsEnums['String']>
  severity: ScalarsEnums['AdminMobileFleetSeverity']
  title: ScalarsEnums['String']
}

export interface AdminMobileFleetOperations {
  __typename?: 'AdminMobileFleetOperations'
  failedCount: ScalarsEnums['Float']
  lastAction?: Maybe<ScalarsEnums['BrandStoreOperationAction']>
  lastError?: Maybe<ScalarsEnums['String']>
  lastPlatform?: Maybe<ScalarsEnums['BrandPlatform']>
  lastStatus?: Maybe<ScalarsEnums['BrandStoreOperationStatus']>
  lastUpdatedAt?: Maybe<ScalarsEnums['String']>
  runningCount: ScalarsEnums['Float']
}

export interface AdminMobileFleetPlatform {
  __typename?: 'AdminMobileFleetPlatform'
  appStoreId?: Maybe<ScalarsEnums['String']>
  bundleId?: Maybe<ScalarsEnums['String']>
  ciRunUrl?: Maybe<ScalarsEnums['String']>
  completedAt?: Maybe<ScalarsEnums['String']>
  credentialsStatus: ScalarsEnums['AdminMobileFleetCredentialsStatus']
  dispatchedAt?: Maybe<ScalarsEnums['String']>
  easBuildUrl?: Maybe<ScalarsEnums['String']>
  failureReason?: Maybe<ScalarsEnums['String']>
  inReviewDays?: Maybe<ScalarsEnums['Float']>
  latestBuildNumber?: Maybe<ScalarsEnums['Float']>
  latestVersion?: Maybe<ScalarsEnums['String']>
  packageName?: Maybe<ScalarsEnums['String']>
  performance: BrandObservePerformance
  platform: ScalarsEnums['BrandPlatform']
  playStoreId?: Maybe<ScalarsEnums['String']>
  providerBuildNumber?: Maybe<ScalarsEnums['Float']>
  providerError?: Maybe<ScalarsEnums['String']>
  providerStateSince?: Maybe<ScalarsEnums['String']>
  providerStatus?: Maybe<ScalarsEnums['BrandStoreSnapshotStatus']>
  providerSyncedAt?: Maybe<ScalarsEnums['String']>
  providerUpdatedAt?: Maybe<ScalarsEnums['String']>
  providerVersion?: Maybe<ScalarsEnums['String']>
  rawProviderState?: Maybe<ScalarsEnums['String']>
  rejection?: Maybe<AdminMobileFleetRejection>
  releaseId?: Maybe<ScalarsEnums['String']>
  releaseStatus?: Maybe<ScalarsEnums['BrandNativeReleaseStatus']>
  releasedBy?: Maybe<AdminMobileFleetReleasedBy>
  requestedAt?: Maybe<ScalarsEnums['String']>
  requestedBy?: Maybe<AdminMobileFleetRequestedBy>
  reviewSince?: Maybe<ScalarsEnums['String']>
  rolloutPercentage?: Maybe<ScalarsEnums['Float']>
  secondaryLabel?: Maybe<ScalarsEnums['String']>
  stage: ScalarsEnums['AdminMobileFleetReleaseStage']
  statusLabel: ScalarsEnums['String']
  storeUrl?: Maybe<ScalarsEnums['String']>
  testUrl?: Maybe<ScalarsEnums['String']>
  track?: Maybe<ScalarsEnums['String']>
}

export interface AdminMobileFleetPrerequisite {
  __typename?: 'AdminMobileFleetPrerequisite'
  kind: ScalarsEnums['StoreBlockerKind']
  platform: ScalarsEnums['BrandPlatform']
  since?: Maybe<ScalarsEnums['String']>
}

export interface AdminMobileFleetRejection {
  __typename?: 'AdminMobileFleetRejection'
  reason?: Maybe<ScalarsEnums['String']>
  reviewUrl?: Maybe<ScalarsEnums['String']>
  since?: Maybe<ScalarsEnums['String']>
}

export interface AdminMobileFleetReleasedBy {
  __typename?: 'AdminMobileFleetReleasedBy'
  at?: Maybe<ScalarsEnums['String']>
  name?: Maybe<ScalarsEnums['String']>
}

export interface AdminMobileFleetRequestedBy {
  __typename?: 'AdminMobileFleetRequestedBy'
  at?: Maybe<ScalarsEnums['String']>
  email?: Maybe<ScalarsEnums['String']>
  name?: Maybe<ScalarsEnums['String']>
}

export interface AdminMobileFleetSetup {
  __typename?: 'AdminMobileFleetSetup'
  blockers: Array<ScalarsEnums['AdminMobileFleetBlocker']>
  complete: ScalarsEnums['Boolean']
  missingCount: ScalarsEnums['Float']
  satisfiedCount: ScalarsEnums['Float']
  totalCount: ScalarsEnums['Float']
}

export interface AdminMobileFleetSummary {
  __typename?: 'AdminMobileFleetSummary'
  buildsRunning: ScalarsEnums['Float']
  failedOperations: ScalarsEnums['Float']
  inReview: ScalarsEnums['Float']
  lastStoreSyncAt?: Maybe<ScalarsEnums['String']>
  live: ScalarsEnums['Float']
  missingCredentials: ScalarsEnums['Float']
  needsAttention: ScalarsEnums['Float']
  readyToRelease: ScalarsEnums['Float']
  readyToSubmit: ScalarsEnums['Float']
  rejected: ScalarsEnums['Float']
  storeSyncStale: ScalarsEnums['Boolean']
  totalBrands: ScalarsEnums['Float']
  waitingOnClient: ScalarsEnums['Float']
}

export interface AdminUpdateCorporateAggregatorIntegration {
  __typename?: 'AdminUpdateCorporateAggregatorIntegration'
  success: ScalarsEnums['Boolean']
}

export interface AdminUpdateCorporateAggregatorProviderSites {
  __typename?: 'AdminUpdateCorporateAggregatorProviderSites'
  success: ScalarsEnums['Boolean']
}

export interface AdminUpdateSiteV2Enabled {
  __typename?: 'AdminUpdateSiteV2Enabled'
  isV2Enabled: ScalarsEnums['Boolean']
  siteId: ScalarsEnums['String']
}

/**
 * Hapana Admin Users
 */
export interface AdminUser {
  __typename?: 'AdminUser'
  accessGroupId: ScalarsEnums['ID']
  /**
   * Access group for this admin user
   */
  adminAccessGroup?: Maybe<AdminAccessGroup>
  adminUserId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  createdBy: ScalarsEnums['String']
  email: ScalarsEnums['String']
  firebaseId: ScalarsEnums['String']
  firstName: ScalarsEnums['String']
  lastName: ScalarsEnums['String']
  name: ScalarsEnums['String']
  phone: ScalarsEnums['String']
  /**
   * Profile image of the admin user
   */
  profileImage: (args: { input: ImagePublicSignedUrlInput }) => Maybe<ImagePublicSignedUrl>
  provisionedAt: ScalarsEnums['String']
  status: ScalarsEnums['AdminUserStatus']
  updatedAt: ScalarsEnums['String']
}

/**
 * Response from creating an admin user impersonation session
 */
export interface AdminUserImpersonationSessionResponse {
  __typename?: 'AdminUserImpersonationSessionResponse'
  redirectUrl: ScalarsEnums['String']
  sessionId: ScalarsEnums['String']
}

export interface AdminUsers {
  __typename?: 'AdminUsers'
  pageInfo: AdminUsersPageInfo
  results: Array<AdminUsersResults>
}

export interface AdminUsersPageInfo {
  __typename?: 'AdminUsersPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface AdminUsersResults {
  __typename?: 'AdminUsersResults'
  cursor: ScalarsEnums['String']
  row: AdminUser
}

export interface AdoptMemberMovementLocationResolutionResult {
  __typename?: 'AdoptMemberMovementLocationResolutionResult'
  mappingSaved: ScalarsEnums['Boolean']
  rowsResolved: ScalarsEnums['Float']
}

/**
 * Diagnostic information from the external tanning hardware agent
 */
export interface AgentDiagnostics {
  __typename?: 'AgentDiagnostics'
  commPort?: Maybe<ScalarsEnums['String']>
  connected: ScalarsEnums['Boolean']
  healthy: ScalarsEnums['Boolean']
  maxRooms?: Maybe<ScalarsEnums['Float']>
  version?: Maybe<ScalarsEnums['String']>
}

/**
 * Third-party booking aggregator provider (ClassPass, GymPass, etc.)
 */
export interface AggregatorProvider {
  __typename?: 'AggregatorProvider'
  aggregatorProviderId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  deletedAt?: Maybe<ScalarsEnums['String']>
  displayName: ScalarsEnums['String']
  inboundSecretName?: Maybe<ScalarsEnums['String']>
  isActive: ScalarsEnums['Boolean']
  logoUrl?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  secretName: ScalarsEnums['String']
  setupInstructions?: Maybe<ScalarsEnums['String']>
  updatedAt: ScalarsEnums['String']
  webhookUrl?: Maybe<ScalarsEnums['String']>
}

/**
 * Instructor assigned to an aggregator session
 */
export interface AggregatorSessionInstructor {
  __typename?: 'AggregatorSessionInstructor'
  firstName: ScalarsEnums['String']
  lastName: ScalarsEnums['String']
  role: ScalarsEnums['String']
  staffUserId: ScalarsEnums['String']
}

/**
 * Room for an aggregator session
 */
export interface AggregatorSessionRoom {
  __typename?: 'AggregatorSessionRoom'
  roomId: ScalarsEnums['String']
  roomName: ScalarsEnums['String']
}

export interface AllDefaults {
  __typename?: 'AllDefaults'
  defaults: ScalarsEnums['JSONObject']
  language: ScalarsEnums['String']
}

/**
 * Cube semantic-layer meta for a single dimension
 */
export interface AnalyticsV2CubeDimensionMeta {
  __typename?: 'AnalyticsV2CubeDimensionMeta'
  description?: Maybe<ScalarsEnums['String']>
  meta?: Maybe<ScalarsEnums['JSONObject']>
  name: ScalarsEnums['String']
  shown?: Maybe<ScalarsEnums['Boolean']>
  title: ScalarsEnums['String']
  type: ScalarsEnums['String']
}

/**
 * Cube semantic-layer meta for a single cube
 */
export interface AnalyticsV2CubeEntityMeta {
  __typename?: 'AnalyticsV2CubeEntityMeta'
  description?: Maybe<ScalarsEnums['String']>
  dimensions: Array<AnalyticsV2CubeDimensionMeta>
  measures: Array<AnalyticsV2CubeMeasureMeta>
  name: ScalarsEnums['String']
  segments: Array<AnalyticsV2CubeSegmentMeta>
  title: ScalarsEnums['String']
}

/**
 * Cube semantic-layer meta for a single measure
 */
export interface AnalyticsV2CubeMeasureMeta {
  __typename?: 'AnalyticsV2CubeMeasureMeta'
  description?: Maybe<ScalarsEnums['String']>
  meta?: Maybe<ScalarsEnums['JSONObject']>
  name: ScalarsEnums['String']
  title: ScalarsEnums['String']
  type: ScalarsEnums['String']
}

/**
 * Full Cube semantic-layer meta for staff/admin surfaces
 */
export interface AnalyticsV2CubeSchemaMetaResponse {
  __typename?: 'AnalyticsV2CubeSchemaMetaResponse'
  cubes: Array<AnalyticsV2CubeEntityMeta>
}

/**
 * Cube semantic-layer meta for a single segment
 */
export interface AnalyticsV2CubeSegmentMeta {
  __typename?: 'AnalyticsV2CubeSegmentMeta'
  name: ScalarsEnums['String']
  title: ScalarsEnums['String']
}

/**
 * Result of a Cube measure query plus provenance metadata
 */
export interface AnalyticsV2QueryMeasureResponse {
  __typename?: 'AnalyticsV2QueryMeasureResponse'
  queryDurationMs: ScalarsEnums['Float']
  rows: Array<ScalarsEnums['JSONObject']>
  totalRows: ScalarsEnums['Float']
  transparency: AnalyticsV2TransparencyBlock
  trustTier: ScalarsEnums['AnalyticsV2TrustTier']
}

/**
 * The BigQuery SQL a Cube query compiles to (tenancy filters included)
 */
export interface AnalyticsV2QuerySqlResponse {
  __typename?: 'AnalyticsV2QuerySqlResponse'
  sql: ScalarsEnums['String']
}

/**
 * Surfaced alongside every measure response so the UI can show provenance
 */
export interface AnalyticsV2TransparencyBlock {
  __typename?: 'AnalyticsV2TransparencyBlock'
  dataFreshness: ScalarsEnums['String']
  dimensionsUsed: Array<ScalarsEnums['String']>
  measureUsed: ScalarsEnums['String']
  scopeApplied: ScalarsEnums['String']
  timeRange?: Maybe<ScalarsEnums['String']>
}

export interface AndroidPermissionState {
  __typename?: 'AndroidPermissionState'
  locked: ScalarsEnums['Boolean']
  permission: ScalarsEnums['AndroidPermission']
  source: ScalarsEnums['NativePermissionSource']
}

/**
 * Response for anonymising a client
 */
export interface AnonymiseClientResponse {
  __typename?: 'AnonymiseClientResponse'
  message?: Maybe<ScalarsEnums['String']>
  success: ScalarsEnums['Boolean']
}

/**
 * A logged call with its full (redacted) request and response
 */
export interface ApiCallLog {
  __typename?: 'ApiCallLog'
  attempt?: Maybe<ScalarsEnums['Int']>
  clientId?: Maybe<ScalarsEnums['String']>
  corporateId: ScalarsEnums['String']
  credentialId?: Maybe<ScalarsEnums['String']>
  credentialLabel?: Maybe<ScalarsEnums['String']>
  credentialType?: Maybe<ScalarsEnums['ApiCallLogCredentialType']>
  durationMs: ScalarsEnums['Int']
  error?: Maybe<ScalarsEnums['String']>
  eventId?: Maybe<ScalarsEnums['String']>
  eventType?: Maybe<ScalarsEnums['String']>
  id: ScalarsEnums['String']
  maxAttempts?: Maybe<ScalarsEnums['Int']>
  method: ScalarsEnums['String']
  occurredAt: ScalarsEnums['String']
  path: ScalarsEnums['String']
  remoteIp?: Maybe<ScalarsEnums['String']>
  requestBody?: Maybe<ScalarsEnums['String']>
  requestBodyBytes?: Maybe<ScalarsEnums['Int']>
  requestBodyTruncated: ScalarsEnums['Boolean']
  requestHeaders?: Maybe<ScalarsEnums['String']>
  requestId?: Maybe<ScalarsEnums['String']>
  requestQuery?: Maybe<ScalarsEnums['String']>
  responseBody?: Maybe<ScalarsEnums['String']>
  responseBodyBytes?: Maybe<ScalarsEnums['Int']>
  responseBodyTruncated: ScalarsEnums['Boolean']
  responseHeaders?: Maybe<ScalarsEnums['String']>
  route?: Maybe<ScalarsEnums['String']>
  searchIds: Array<ScalarsEnums['String']>
  siteId?: Maybe<ScalarsEnums['String']>
  siteName?: Maybe<ScalarsEnums['String']>
  statusCode?: Maybe<ScalarsEnums['Int']>
  truncated: ScalarsEnums['Boolean']
  type: ScalarsEnums['ApiCallLogType']
  userAgent?: Maybe<ScalarsEnums['String']>
}

export interface ApiCallLogPage {
  __typename?: 'ApiCallLogPage'
  from: ScalarsEnums['String']
  nextCursor?: Maybe<ScalarsEnums['String']>
  rows: Array<ApiCallLogSummary>
  to: ScalarsEnums['String']
}

/**
 * A logged business API call, member API call or webhook delivery attempt
 */
export interface ApiCallLogSummary {
  __typename?: 'ApiCallLogSummary'
  attempt?: Maybe<ScalarsEnums['Int']>
  clientId?: Maybe<ScalarsEnums['String']>
  corporateId: ScalarsEnums['String']
  credentialId?: Maybe<ScalarsEnums['String']>
  credentialLabel?: Maybe<ScalarsEnums['String']>
  credentialType?: Maybe<ScalarsEnums['ApiCallLogCredentialType']>
  durationMs: ScalarsEnums['Int']
  error?: Maybe<ScalarsEnums['String']>
  eventId?: Maybe<ScalarsEnums['String']>
  eventType?: Maybe<ScalarsEnums['String']>
  id: ScalarsEnums['String']
  maxAttempts?: Maybe<ScalarsEnums['Int']>
  method: ScalarsEnums['String']
  occurredAt: ScalarsEnums['String']
  path: ScalarsEnums['String']
  requestId?: Maybe<ScalarsEnums['String']>
  route?: Maybe<ScalarsEnums['String']>
  siteId?: Maybe<ScalarsEnums['String']>
  siteName?: Maybe<ScalarsEnums['String']>
  statusCode?: Maybe<ScalarsEnums['Int']>
  type: ScalarsEnums['ApiCallLogType']
}

/**
 * Brand-developer API key (admin / server-to-server).
 */
export interface ApiCredential {
  __typename?: 'ApiCredential'
  apiCredentialId: ScalarsEnums['ID']
  corporateId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  createdBy?: Maybe<ScalarsEnums['ID']>
  env: ScalarsEnums['ApiCredentialEnv']
  keyPrefix: ScalarsEnums['String']
  kind: ScalarsEnums['ApiCredentialKind']
  lastUsedAt?: Maybe<ScalarsEnums['String']>
  lastUsedIp?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  replacedByCredId?: Maybe<ScalarsEnums['ID']>
  revokedAt?: Maybe<ScalarsEnums['String']>
  rotatesAt?: Maybe<ScalarsEnums['String']>
  scopes: Array<ScalarsEnums['String']>
  siteBindings?: Maybe<Array<ApiCredentialSiteBinding>>
  status: ScalarsEnums['ApiCredentialStatus']
  updatedAt: ScalarsEnums['String']
}

/**
 * A site a migrated V1 API credential is bound to.
 */
export interface ApiCredentialSiteBinding {
  __typename?: 'ApiCredentialSiteBinding'
  siteId: ScalarsEnums['ID']
  v1EncryptedId: ScalarsEnums['String']
}

/**
 * API credential plus its cleartext secret (only returned once).
 */
export interface ApiCredentialWithSecret {
  __typename?: 'ApiCredentialWithSecret'
  apiCredentialId: ScalarsEnums['ID']
  cleartextSecret: ScalarsEnums['String']
  corporateId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  createdBy?: Maybe<ScalarsEnums['ID']>
  env: ScalarsEnums['ApiCredentialEnv']
  keyPrefix: ScalarsEnums['String']
  kind: ScalarsEnums['ApiCredentialKind']
  lastUsedAt?: Maybe<ScalarsEnums['String']>
  lastUsedIp?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  replacedByCredId?: Maybe<ScalarsEnums['ID']>
  revokedAt?: Maybe<ScalarsEnums['String']>
  rotatesAt?: Maybe<ScalarsEnums['String']>
  scopes: Array<ScalarsEnums['String']>
  siteBindings?: Maybe<Array<ApiCredentialSiteBinding>>
  status: ScalarsEnums['ApiCredentialStatus']
  updatedAt: ScalarsEnums['String']
}

export interface AppStoreCredentials {
  __typename?: 'AppStoreCredentials'
  apnsKeyId?: Maybe<ScalarsEnums['String']>
  appleAccountName?: Maybe<ScalarsEnums['String']>
  appleIssuerId?: Maybe<ScalarsEnums['String']>
  appleKeyId?: Maybe<ScalarsEnums['String']>
  appleTeamId?: Maybe<ScalarsEnums['String']>
  bundleId?: Maybe<ScalarsEnums['String']>
  corporateId: ScalarsEnums['String']
  googleServiceAccountEmail?: Maybe<ScalarsEnums['String']>
  hasApnsAuthKey: ScalarsEnums['Boolean']
  hasApplePrivateKey: ScalarsEnums['Boolean']
  hasFirebaseAndroidConfig: ScalarsEnums['Boolean']
  hasFirebaseIosConfig: ScalarsEnums['Boolean']
  hasGoogleServiceAccountJson: ScalarsEnums['Boolean']
  jwPlayerLicenseKey?: Maybe<ScalarsEnums['String']>
  packageName?: Maybe<ScalarsEnums['String']>
  /**
   * Mobile platform (IOS or ANDROID)
   */
  platform: ScalarsEnums['String']
}

export interface AppendSignatureToAgreement {
  __typename?: 'AppendSignatureToAgreement'
  agreementId: ScalarsEnums['String']
  signatureCount: ScalarsEnums['Float']
  status: ScalarsEnums['String']
}

/**
 * The shared Apple ID's App Store Connect session and what it needs next
 */
export interface AppleAccountSession {
  __typename?: 'AppleAccountSession'
  appleId: ScalarsEnums['String']
  codeRequestedAt?: Maybe<ScalarsEnums['String']>
  connectedAt?: Maybe<ScalarsEnums['String']>
  hasStoredPassword: ScalarsEnums['Boolean']
  lastError?: Maybe<ScalarsEnums['String']>
  lastVerifiedAt?: Maybe<ScalarsEnums['String']>
  mode?: Maybe<ScalarsEnums['AppleAccountSessionMode']>
  requestedAt?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['AppleAccountSessionStatus']
  trustExpiresAt?: Maybe<ScalarsEnums['String']>
}

/**
 * Whether App Store Connect automation can run for this brand
 */
export interface AppleAutomationStatus {
  __typename?: 'AppleAutomationStatus'
  available: ScalarsEnums['Boolean']
  keyId?: Maybe<ScalarsEnums['String']>
  reason?: Maybe<ScalarsEnums['AppleAutomationReason']>
  source?: Maybe<ScalarsEnums['AppleAutomationSource']>
}

/**
 * A possible match for a brand's App Store Connect team id, to be confirmed by a person
 */
export interface AppleTeamCandidate {
  __typename?: 'AppleTeamCandidate'
  contentProviderId: ScalarsEnums['String']
  name: ScalarsEnums['String']
}

/**
 * The compliance facts for one Apple developer team
 */
export interface AppleTeamCompliance {
  __typename?: 'AppleTeamCompliance'
  agreementsPending?: Maybe<ScalarsEnums['Boolean']>
  appleTeamId: ScalarsEnums['String']
  checkError?: Maybe<ScalarsEnums['String']>
  checkedAt?: Maybe<ScalarsEnums['String']>
  earliestCertExpiresAt?: Maybe<ScalarsEnums['String']>
  membershipExpiresAt?: Maybe<ScalarsEnums['String']>
  name?: Maybe<ScalarsEnums['String']>
}

export interface AppliedFee {
  __typename?: 'AppliedFee'
  calculatedAmount: ScalarsEnums['Float']
  enabled: ScalarsEnums['Boolean']
  feeId: ScalarsEnums['String']
  feeName: ScalarsEnums['String']
  flatAmount?: Maybe<ScalarsEnums['Float']>
  percentRate?: Maybe<ScalarsEnums['Float']>
}

/**
 * Result of applying template changes to future sessions
 */
export interface ApplySessionTemplateResult {
  __typename?: 'ApplySessionTemplateResult'
  sessionTemplate: SessionTemplate
  skippedSessionCount: ScalarsEnums['Float']
  spotMoves: Array<SpotMove>
  updatedRecurringPatternCount: ScalarsEnums['Float']
  updatedSessionCount: ScalarsEnums['Float']
}

export interface ApprovalPinStatus {
  __typename?: 'ApprovalPinStatus'
  isSet: ScalarsEnums['Boolean']
  lockedUntil?: Maybe<ScalarsEnums['String']>
  setAt?: Maybe<ScalarsEnums['String']>
}

export interface ApproveAllImports {
  __typename?: 'ApproveAllImports'
  results: Array<ApproveAllImportsResults>
}

export interface ApproveAllImportsResults {
  __typename?: 'ApproveAllImportsResults'
  error?: Maybe<ScalarsEnums['String']>
  importSessionId: ScalarsEnums['ID']
  status: ScalarsEnums['String']
  totalValidRows: ScalarsEnums['Float']
}

export interface ApproveCheckinResult {
  __typename?: 'ApproveCheckinResult'
  checkinFlag: ScalarsEnums['Float']
  checkinId?: Maybe<ScalarsEnums['String']>
  message: ScalarsEnums['String']
  success: ScalarsEnums['Boolean']
}

export interface ApproveImport {
  __typename?: 'ApproveImport'
  importSessionId: ScalarsEnums['ID']
  status: ScalarsEnums['String']
  totalValidRows: ScalarsEnums['Float']
}

/**
 * Response indicating success of product archival
 */
export interface ArchiveProductResponse {
  __typename?: 'ArchiveProductResponse'
  success: ScalarsEnums['Boolean']
}

export interface ArticleCitation {
  __typename?: 'ArticleCitation'
  snippet?: Maybe<ScalarsEnums['String']>
  source: ScalarsEnums['String']
  title: ScalarsEnums['String']
  url?: Maybe<ScalarsEnums['String']>
}

export interface ArticleRefreshStats {
  __typename?: 'ArticleRefreshStats'
  articlesCreated: ScalarsEnums['Int']
  articlesFailed: ScalarsEnums['Int']
  articlesUnchanged: ScalarsEnums['Int']
  articlesUpdated: ScalarsEnums['Int']
}

/**
 * Response for assigning or clearing a client-site assigned staff member; changed is false when the request was a no-op
 */
export interface AssignClientSiteStaffResponse {
  __typename?: 'AssignClientSiteStaffResponse'
  changed: ScalarsEnums['Boolean']
  success: ScalarsEnums['Boolean']
}

/**
 * Response for assigning a form
 */
export interface AssignFormResponse {
  __typename?: 'AssignFormResponse'
  formSubmissionId: ScalarsEnums['String']
  message?: Maybe<ScalarsEnums['String']>
  success: ScalarsEnums['Boolean']
}

export interface AssignSitePayrollTier {
  __typename?: 'AssignSitePayrollTier'
  createdAt: ScalarsEnums['String']
  createdByStaffUserId?: Maybe<ScalarsEnums['ID']>
  endDate?: Maybe<ScalarsEnums['String']>
  futureAssignmentDate?: Maybe<ScalarsEnums['String']>
  payrollTierAssignmentId: ScalarsEnums['ID']
  siteId: ScalarsEnums['ID']
  sitePayrollTierId: ScalarsEnums['ID']
  staffUserId: ScalarsEnums['ID']
  staffUserName?: Maybe<ScalarsEnums['String']>
  startDate: ScalarsEnums['String']
  updatedAt: ScalarsEnums['String']
}

/**
 * One interval of a client-site assigned staff history; a null staffUserId is an unassigned gap
 */
export interface AssignedStaffEntry {
  __typename?: 'AssignedStaffEntry'
  changedByName?: Maybe<ScalarsEnums['String']>
  endedAt?: Maybe<ScalarsEnums['String']>
  historyId: ScalarsEnums['String']
  isStaffActive?: Maybe<ScalarsEnums['Boolean']>
  source: ScalarsEnums['AssignedStaffSource']
  sourceInvoiceId?: Maybe<ScalarsEnums['String']>
  staffName?: Maybe<ScalarsEnums['String']>
  staffUserId?: Maybe<ScalarsEnums['String']>
  startedAt: ScalarsEnums['String']
}

/**
 * A page of a client-site assigned staff history, newest first; hasMore is true when older intervals exist beyond the returned window
 */
export interface AssignedStaffHistory {
  __typename?: 'AssignedStaffHistory'
  entries: Array<AssignedStaffEntry>
  hasMore: ScalarsEnums['Boolean']
}

/**
 * An attendance record for a session
 */
export interface Attendance {
  __typename?: 'Attendance'
  attendanceId: ScalarsEnums['ID']
  attendanceSource: ScalarsEnums['AttendanceSource']
  attendanceType: ScalarsEnums['AttendanceType']
  attendedAt?: Maybe<ScalarsEnums['String']>
  bookingId?: Maybe<ScalarsEnums['ID']>
  checkInId?: Maybe<ScalarsEnums['ID']>
  clientId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  equipmentId?: Maybe<ScalarsEnums['ID']>
  invoiceId?: Maybe<ScalarsEnums['ID']>
  isImported: ScalarsEnums['Boolean']
  isReversed: ScalarsEnums['Boolean']
  markedBy?: Maybe<ScalarsEnums['ID']>
  refundInvoiceId?: Maybe<ScalarsEnums['ID']>
  reversalNote?: Maybe<ScalarsEnums['String']>
  reversalReason?: Maybe<ScalarsEnums['ReversalReason']>
  reversedAt?: Maybe<ScalarsEnums['String']>
  reversedBy?: Maybe<ScalarsEnums['ID']>
  sessionId?: Maybe<ScalarsEnums['ID']>
  totalCreditsUsed: ScalarsEnums['Float']
  updatedAt: ScalarsEnums['String']
}

export interface AuditAggregationGroup {
  __typename?: 'AuditAggregationGroup'
  /**
   * Number of events in this group
   */
  count: ScalarsEnums['Float']
  /**
   * Raw value of the grouped field
   */
  groupKey: ScalarsEnums['String']
  /**
   * Human-readable label for the group
   */
  groupLabel: ScalarsEnums['String']
}

export interface AuditAggregationResult {
  __typename?: 'AuditAggregationResult'
  /**
   * The field that was grouped by
   */
  groupBy: ScalarsEnums['String']
  groups: Array<AuditAggregationGroup>
  /**
   * Total matching events across all groups
   */
  totalCount: ScalarsEnums['Float']
}

export interface AuditEvent {
  __typename?: 'AuditEvent'
  accessPointId?: Maybe<ScalarsEnums['String']>
  action: ScalarsEnums['AuditAction']
  /**
   * Email of affected user (denormalized)
   */
  affectedUserEmail?: Maybe<ScalarsEnums['String']>
  /**
   * First name of affected user (denormalized)
   */
  affectedUserFirstName?: Maybe<ScalarsEnums['String']>
  /**
   * Staff user who was affected by the action (e.g. user being edited/deleted)
   */
  affectedUserId?: Maybe<ScalarsEnums['String']>
  /**
   * Last name of affected user (denormalized)
   */
  affectedUserLastName?: Maybe<ScalarsEnums['String']>
  /**
   * Browser name (Chrome, Firefox, Safari, etc.)
   */
  browserName?: Maybe<ScalarsEnums['String']>
  /**
   * Browser version
   */
  browserVersion?: Maybe<ScalarsEnums['String']>
  corporateId: ScalarsEnums['String']
  /**
   * Corporate/brand name (denormalized)
   */
  corporateName?: Maybe<ScalarsEnums['String']>
  corporateSlug?: Maybe<ScalarsEnums['String']>
  details?: Maybe<AuditEventDetails>
  /**
   * Device type (mobile, tablet, desktop)
   */
  deviceType?: Maybe<ScalarsEnums['AuditDeviceType']>
  doorId?: Maybe<ScalarsEnums['String']>
  /**
   * Email domain without username (e.g., "hapana.com")
   */
  emailDomain?: Maybe<ScalarsEnums['String']>
  /**
   * City from IP lookup (e.g., "Sydney")
   */
  geoCity?: Maybe<ScalarsEnums['String']>
  /**
   * Country code from IP lookup (e.g., "AU")
   */
  geoCountry?: Maybe<ScalarsEnums['String']>
  /**
   * Country name from IP lookup (e.g., "Australia")
   */
  geoCountryName?: Maybe<ScalarsEnums['String']>
  /**
   * Whether IP is in EU (for GDPR)
   */
  geoIsEU?: Maybe<ScalarsEnums['Boolean']>
  /**
   * Latitude from IP lookup
   */
  geoLatitude?: Maybe<ScalarsEnums['Float']>
  /**
   * Longitude from IP lookup
   */
  geoLongitude?: Maybe<ScalarsEnums['Float']>
  /**
   * Region/state from IP lookup (e.g., "NSW")
   */
  geoRegion?: Maybe<ScalarsEnums['String']>
  /**
   * Timezone from IP lookup (e.g., "Australia/Sydney")
   */
  geoTimezone?: Maybe<ScalarsEnums['String']>
  id: ScalarsEnums['String']
  ipAddress?: Maybe<ScalarsEnums['String']>
  /**
   * Browser language (e.g., "en-US")
   */
  language?: Maybe<ScalarsEnums['String']>
  /**
   * Member/customer affected
   */
  memberId?: Maybe<ScalarsEnums['String']>
  /**
   * Operating system name (Windows, macOS, iOS, Android, etc.)
   */
  osName?: Maybe<ScalarsEnums['String']>
  /**
   * Operating system version
   */
  osVersion?: Maybe<ScalarsEnums['String']>
  pageName?: Maybe<ScalarsEnums['String']>
  pageUrl?: Maybe<ScalarsEnums['String']>
  /**
   * Platform/OS (iOS, Android, Web)
   */
  platform?: Maybe<ScalarsEnums['AuditPlatform']>
  requestId?: Maybe<ScalarsEnums['String']>
  resource: ScalarsEnums['AuditResource']
  resourceId?: Maybe<ScalarsEnums['String']>
  schemaVersion: ScalarsEnums['Float']
  /**
   * Screen height in pixels
   */
  screenHeight?: Maybe<ScalarsEnums['Float']>
  /**
   * Screen width in pixels
   */
  screenWidth?: Maybe<ScalarsEnums['Float']>
  sessionId?: Maybe<ScalarsEnums['String']>
  severity: ScalarsEnums['AuditSeverity']
  siteId?: Maybe<ScalarsEnums['String']>
  /**
   * Site/location name (denormalized)
   */
  siteName?: Maybe<ScalarsEnums['String']>
  source: ScalarsEnums['AuditSource']
  timestamp: ScalarsEnums['String']
  /**
   * User timezone (e.g., "Australia/Sydney")
   */
  timezone?: Maybe<ScalarsEnums['String']>
  userAgent?: Maybe<ScalarsEnums['String']>
  /**
   * Email of user who performed action (denormalized)
   */
  userEmail?: Maybe<ScalarsEnums['String']>
  /**
   * First name of user who performed action (denormalized)
   */
  userFirstName?: Maybe<ScalarsEnums['String']>
  /**
   * Staff/system user who performed action
   */
  userId?: Maybe<ScalarsEnums['String']>
  /**
   * Last name of user who performed action (denormalized)
   */
  userLastName?: Maybe<ScalarsEnums['String']>
  /**
   * User roles/permissions at time of action
   */
  userRoles?: Maybe<Array<ScalarsEnums['String']>>
  visibility: ScalarsEnums['AuditVisibility']
}

export interface AuditEventDetails {
  __typename?: 'AuditEventDetails'
  /**
   * List of individual field changes
   */
  changes?: Maybe<Array<AuditFieldChange>>
  /**
   * Additional context information (JSON string)
   */
  contextJson?: Maybe<ScalarsEnums['String']>
  /**
   * Additional event-specific metadata (JSON string)
   */
  metadataJson?: Maybe<ScalarsEnums['String']>
  /**
   * Complete object state after change (JSON string)
   */
  newValueJson?: Maybe<ScalarsEnums['String']>
  /**
   * Complete object state before change (JSON string)
   */
  previousValueJson?: Maybe<ScalarsEnums['String']>
  /**
   * Reason for the action (if applicable)
   */
  reason?: Maybe<ScalarsEnums['String']>
  /**
   * Human-readable summary of changes
   */
  summary?: Maybe<ScalarsEnums['String']>
}

export interface AuditFieldChange {
  __typename?: 'AuditFieldChange'
  /**
   * Human-readable field name
   */
  displayName?: Maybe<ScalarsEnums['String']>
  /**
   * Field name that changed
   */
  field: ScalarsEnums['String']
  /**
   * Type hint (string, number, boolean, etc.)
   */
  fieldType?: Maybe<ScalarsEnums['String']>
  /**
   * New value (stringified)
   */
  newValue?: Maybe<ScalarsEnums['String']>
  /**
   * Previous value (stringified)
   */
  oldValue?: Maybe<ScalarsEnums['String']>
}

export interface AuditPaginationResult {
  __typename?: 'AuditPaginationResult'
  currentPage: ScalarsEnums['Float']
  hasNextPage: ScalarsEnums['Boolean']
  hasPreviousPage: ScalarsEnums['Boolean']
  pageSize: ScalarsEnums['Float']
  totalCount: ScalarsEnums['Float']
  totalPages: ScalarsEnums['Float']
}

export interface AuditQueryResult {
  __typename?: 'AuditQueryResult'
  events: Array<AuditEvent>
  pagination: AuditPaginationResult
}

/**
 * Available client tabs for filtering
 */
export interface AvailableClientTabsResponse {
  __typename?: 'AvailableClientTabsResponse'
  tabs: Array<ClientTab>
}

/**
 * An available BigQuery export report
 */
export interface AvailableExport {
  __typename?: 'AvailableExport'
  category: ScalarsEnums['String']
  label: ScalarsEnums['String']
  name: ScalarsEnums['BigQueryExportName']
  spannerSupported: ScalarsEnums['Boolean']
}

export interface AvailableReports {
  __typename?: 'AvailableReports'
  reports: Array<ReportDefinition>
}

export interface AvailableZapierLocations {
  __typename?: 'AvailableZapierLocations'
  alreadyConnected: ScalarsEnums['Boolean']
  name: ScalarsEnums['String']
  siteId: ScalarsEnums['String']
}

/**
 * Summary of award distribution
 */
export interface AwardsSummary {
  __typename?: 'AwardsSummary'
  mostEarnedAwardCount: ScalarsEnums['Float']
  mostEarnedAwardName?: Maybe<ScalarsEnums['String']>
  pendingAwards: ScalarsEnums['Float']
  totalAwardsEarned: ScalarsEnums['Float']
  uniqueRecipients: ScalarsEnums['Float']
}

/**
 * One site-scoped capability grant on a BI dashboard or widget
 */
export interface BiAccessGrantEntry {
  __typename?: 'BiAccessGrantEntry'
  capability: ScalarsEnums['String']
  principalId?: Maybe<ScalarsEnums['String']>
  scopeType: ScalarsEnums['String']
  siteId?: Maybe<ScalarsEnums['String']>
}

/**
 * The corporate's persisted DashView workspace mapping for parity and migration
 */
export interface BiMigrationConfig {
  __typename?: 'BiMigrationConfig'
  classicDashboardsEnabled: ScalarsEnums['Boolean']
  updatedAt?: Maybe<ScalarsEnums['String']>
  updatedBy?: Maybe<ScalarsEnums['String']>
  workspaceId?: Maybe<ScalarsEnums['String']>
}

/**
 * Side-by-side Cube vs GoodData values with the tolerance verdict
 */
export interface BiParityCheckResult {
  __typename?: 'BiParityCheckResult'
  checkedBy: ScalarsEnums['String']
  corporateId: ScalarsEnums['String']
  cubeDurationMs: ScalarsEnums['Float']
  cubeValue?: Maybe<ScalarsEnums['Float']>
  delta?: Maybe<ScalarsEnums['Float']>
  deltaPct?: Maybe<ScalarsEnums['Float']>
  gooddataValue?: Maybe<ScalarsEnums['Float']>
  status: ScalarsEnums['BiParityStatus']
  tolerancePct: ScalarsEnums['Float']
}

/**
 * Visibility and grants for one BI dashboard or widget
 */
export interface BiSubjectAccess {
  __typename?: 'BiSubjectAccess'
  createdBy: ScalarsEnums['String']
  grants: Array<BiAccessGrantEntry>
  subjectId: ScalarsEnums['String']
  subjectType: ScalarsEnums['String']
  visibility: ScalarsEnums['String']
}

/**
 * One tenant-published dashboard: metadata plus the serialized, schema-validated bundle
 */
export interface BiTenantDashboardBundle {
  __typename?: 'BiTenantDashboardBundle'
  biDashboardId: ScalarsEnums['String']
  bundleJson: ScalarsEnums['String']
  canEdit: ScalarsEnums['Boolean']
  createdBy: ScalarsEnums['String']
  dashboardId: ScalarsEnums['String']
  origin: ScalarsEnums['String']
  sortOrder: ScalarsEnums['Float']
  title: ScalarsEnums['String']
  updatedAt: ScalarsEnums['String']
  visibility: ScalarsEnums['String']
}

/**
 * All published dashboards for the calling corporate, in sidebar order
 */
export interface BiTenantDashboardsResponse {
  __typename?: 'BiTenantDashboardsResponse'
  access: Array<BiSubjectAccess>
  bundles: Array<BiTenantDashboardBundle>
  canAuthor: ScalarsEnums['Boolean']
  canManageAccess: ScalarsEnums['Boolean']
  classicDashboardsEnabled: ScalarsEnums['Boolean']
  defaultDashboardId?: Maybe<ScalarsEnums['String']>
  viewer: BiViewerContext
}

/**
 * The calling user as the access evaluators see them, so the client can gate repo-shipped masters with the same logic
 */
export interface BiViewerContext {
  __typename?: 'BiViewerContext'
  identifier?: Maybe<ScalarsEnums['String']>
  isAllSites: ScalarsEnums['Boolean']
  policyIds: Array<ScalarsEnums['String']>
  siteIds: Array<ScalarsEnums['String']>
  staffUserId?: Maybe<ScalarsEnums['String']>
}

/**
 * Response for blocking or unblocking a client at a site
 */
export interface BlockClientResponse {
  __typename?: 'BlockClientResponse'
  message?: Maybe<ScalarsEnums['String']>
  success: ScalarsEnums['Boolean']
}

/**
 * A booking for a session
 */
export interface Booking {
  __typename?: 'Booking'
  aggregatorProviderId?: Maybe<ScalarsEnums['String']>
  bookedByClientId?: Maybe<ScalarsEnums['ID']>
  bookingId: ScalarsEnums['ID']
  bookingSource?: Maybe<ScalarsEnums['BookingSource']>
  cancelledAt?: Maybe<ScalarsEnums['String']>
  cancelledBy?: Maybe<ScalarsEnums['ID']>
  /**
   * The client associated with this booking, with computed alerts
   */
  client?: Maybe<BookingClient>
  clientId: ScalarsEnums['ID']
  clientName?: Maybe<ScalarsEnums['String']>
  confirmedAt?: Maybe<ScalarsEnums['String']>
  createdAt: ScalarsEnums['String']
  /**
   * Package/membership names whose credits paid for this booking, if any
   */
  creditSourceNames?: Maybe<Array<ScalarsEnums['String']>>
  destinationFeeEligible?: Maybe<ScalarsEnums['Boolean']>
  destinationFeeInvoiceId?: Maybe<ScalarsEnums['ID']>
  /**
   * Status of the Holiday Destination Fee invoice staged from this booking, if one exists
   */
  destinationFeeInvoiceStatus?: Maybe<ScalarsEnums['InvoiceStatus']>
  dropInAmount?: Maybe<ScalarsEnums['Numeric']>
  dropInInvoiceId?: Maybe<ScalarsEnums['ID']>
  externalReferenceId?: Maybe<ScalarsEnums['String']>
  externalUserId?: Maybe<ScalarsEnums['String']>
  invitationAcceptedAt?: Maybe<ScalarsEnums['String']>
  invitationSentAt?: Maybe<ScalarsEnums['String']>
  invitedByStaffUserId?: Maybe<ScalarsEnums['ID']>
  isFamilyBooking?: Maybe<ScalarsEnums['Boolean']>
  isFirstVisit?: Maybe<ScalarsEnums['Boolean']>
  isImported: ScalarsEnums['Boolean']
  isVisitingLocation?: Maybe<ScalarsEnums['Boolean']>
  lateCancelCreditsKept?: Maybe<ScalarsEnums['Float']>
  lateCancelFeeInvoiceId?: Maybe<ScalarsEnums['ID']>
  /**
   * Status of the late-cancel fee invoice, if one exists
   */
  lateCancelFeeInvoiceStatus?: Maybe<ScalarsEnums['InvoiceStatus']>
  noShowFeeInvoiceId?: Maybe<ScalarsEnums['ID']>
  /**
   * Status of the no-show fee invoice, if one exists
   */
  noShowFeeInvoiceStatus?: Maybe<ScalarsEnums['InvoiceStatus']>
  notes?: Maybe<ScalarsEnums['String']>
  /**
   * How this booking was paid, for the Session Details payment column
   */
  paymentMethod?: Maybe<BookingPaymentMethod>
  paymentStatus?: Maybe<ScalarsEnums['BookingPaymentStatus']>
  sessionId: ScalarsEnums['ID']
  sharedCreditOwnerClientId?: Maybe<ScalarsEnums['ID']>
  sharedCreditOwnerName?: Maybe<ScalarsEnums['String']>
  siteAttendanceCount?: Maybe<ScalarsEnums['Float']>
  siteId: ScalarsEnums['ID']
  source: ScalarsEnums['Source']
  spotId?: Maybe<ScalarsEnums['Float']>
  status: ScalarsEnums['BookingStatus']
  totalAttendanceCount?: Maybe<ScalarsEnums['Float']>
  totalCreditsRequired: ScalarsEnums['Float']
  updatedAt: ScalarsEnums['String']
  usedUnlimitedCredit?: Maybe<ScalarsEnums['Boolean']>
}

/**
 * Activity log entry for booking changes
 */
export interface BookingActivityLog {
  __typename?: 'BookingActivityLog'
  activityType: ScalarsEnums['BookingActivityType']
  bookingActivityLogId: ScalarsEnums['String']
  bookingId: ScalarsEnums['String']
  clientFirstName?: Maybe<ScalarsEnums['String']>
  clientId: ScalarsEnums['String']
  clientLastName?: Maybe<ScalarsEnums['String']>
  createdAt: ScalarsEnums['String']
  createdBy?: Maybe<ScalarsEnums['String']>
  createdByFirstName?: Maybe<ScalarsEnums['String']>
  createdByLastName?: Maybe<ScalarsEnums['String']>
  createdByName?: Maybe<ScalarsEnums['String']>
  createdByType?: Maybe<ScalarsEnums['CreatedByType']>
  sessionName?: Maybe<ScalarsEnums['String']>
  sessionStartTime?: Maybe<ScalarsEnums['String']>
  siteId: ScalarsEnums['String']
  /**
   * Name of who triggered this activity (staff user, client, or Automated)
   */
  triggeredByName?: Maybe<ScalarsEnums['String']>
  value?: Maybe<ScalarsEnums['String']>
}

/**
 * A buddy relationship row with the counterparty display fields
 */
export interface BookingBuddyLinkedAccount {
  __typename?: 'BookingBuddyLinkedAccount'
  acceptedAt?: Maybe<ScalarsEnums['String']>
  buddyClientId: ScalarsEnums['ID']
  clientId: ScalarsEnums['ID']
  email?: Maybe<ScalarsEnums['String']>
  firstName?: Maybe<ScalarsEnums['String']>
  initiatedBy?: Maybe<ScalarsEnums['ID']>
  lastName?: Maybe<ScalarsEnums['String']>
  profileImageUrl?: Maybe<ScalarsEnums['String']>
  sessionBookingSource?: Maybe<ScalarsEnums['String']>
  sessionBookingStatus?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['ClientBookingBuddyStatus']
}

/**
 * Result of a booking-buddy mutation
 */
export interface BookingBuddyMutationResult {
  __typename?: 'BookingBuddyMutationResult'
  message: ScalarsEnums['String']
  success: ScalarsEnums['Boolean']
}

export interface BookingClient {
  __typename?: 'BookingClient'
  alerts: Array<ClientAlert>
  email?: Maybe<ScalarsEnums['String']>
  firstName?: Maybe<ScalarsEnums['String']>
  id: ScalarsEnums['String']
  lastName?: Maybe<ScalarsEnums['String']>
  mobilePhoneNumber?: Maybe<ScalarsEnums['String']>
  name?: Maybe<ScalarsEnums['String']>
  siteId?: Maybe<ScalarsEnums['String']>
}

/**
 * One of the member's own or shared packages, and whether a booking's credit can move to it
 */
export interface BookingCreditPackageOption {
  __typename?: 'BookingCreditPackageOption'
  /**
   * The member's own active package can be combined with others to cover the class's cost
   */
  canCombine: ScalarsEnums['Boolean']
  creditsRemaining?: Maybe<ScalarsEnums['Float']>
  expiryDate?: Maybe<ScalarsEnums['String']>
  ineligibleReason?: Maybe<ScalarsEnums['BookingCreditPackageIneligibleReason']>
  isCurrent: ScalarsEnums['Boolean']
  isUnlimited: ScalarsEnums['Boolean']
  packageName: ScalarsEnums['String']
  /**
   * Moving the credit here, alone or as part of a split, uses its last credit and triggers an auto-renew charge
   */
  renewsWhenUsed: ScalarsEnums['Boolean']
  serviceId: ScalarsEnums['ID']
  /**
   * The member who owns this package when it is shared with the attendee
   */
  sharedCreditOwnerClientId?: Maybe<ScalarsEnums['ID']>
  sharedCreditOwnerName?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['ServiceStatus']
}

/**
 * The member's own and shared packages a credit-paid booking can be moved to
 */
export interface BookingCreditPackageOptions {
  __typename?: 'BookingCreditPackageOptions'
  bookingId: ScalarsEnums['ID']
  /**
   * The class's current credit cost, charged to the package(s) the credit moves to
   */
  creditsRequired: ScalarsEnums['Float']
  /**
   * The credits the booking paid, returned to the package(s) that paid them
   */
  creditsToRefund: ScalarsEnums['Float']
  options: Array<BookingCreditPackageOption>
  /**
   * The credit returns to a package that has expired, so it cannot be used again
   */
  originalPackageExpired: ScalarsEnums['Boolean']
}

export interface BookingCreditShortfall {
  __typename?: 'BookingCreditShortfall'
  bookingId: ScalarsEnums['ID']
  clientId: ScalarsEnums['ID']
  reason?: Maybe<ScalarsEnums['CreditShortfallReason']>
}

/**
 * Result of booking pagination
 */
export interface BookingPaginationResult {
  __typename?: 'BookingPaginationResult'
  pageInfo: BookingPaginationResultPageInfo
  results: Array<BookingPaginationResultResults>
}

export interface BookingPaginationResultPageInfo {
  __typename?: 'BookingPaginationResultPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Float']
}

export interface BookingPaginationResultResults {
  __typename?: 'BookingPaginationResultResults'
  cursor: ScalarsEnums['String']
  row: Booking
}

/**
 * How a booking was paid, for the Session Details payment column
 */
export interface BookingPaymentMethod {
  __typename?: 'BookingPaymentMethod'
  brand?: Maybe<ScalarsEnums['String']>
  kind: ScalarsEnums['BookingPaymentMethodKind']
  last4?: Maybe<ScalarsEnums['String']>
}

export interface BranchConfigStatus {
  __typename?: 'BranchConfigStatus'
  appLink?: Maybe<ScalarsEnums['String']>
  hasKey: ScalarsEnums['Boolean']
  hasSecret: ScalarsEnums['Boolean']
  isConfigured: ScalarsEnums['Boolean']
  message?: Maybe<ScalarsEnums['String']>
}

/**
 * What a brand add-on pushes to its locations.
 */
export interface BrandAddOnConfig {
  __typename?: 'BrandAddOnConfig'
  agreementEnabled: ScalarsEnums['Boolean']
  agreementSendConfirmation?: Maybe<ScalarsEnums['Boolean']>
  agreementText?: Maybe<ScalarsEnums['String']>
  credits: Array<BrandAddOnCreditLine>
  currency?: Maybe<ScalarsEnums['Currency']>
  description?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  pricePoints: Array<BrandAddOnPricePoint>
}

/**
 * A credit line of a brand add-on, scoped to brand session groups.
 */
export interface BrandAddOnCreditLine {
  __typename?: 'BrandAddOnCreditLine'
  amount?: Maybe<ScalarsEnums['Float']>
  corporateSessionTypeIds: Array<ScalarsEnums['ID']>
  creditLineId: ScalarsEnums['ID']
  creditsType: ScalarsEnums['CreditType']
}

/**
 * At a location a brand add-on is leaving: the brand memberships it is sold with, and how many links the location made itself.
 */
export interface BrandAddOnDependents {
  __typename?: 'BrandAddOnDependents'
  brandParentNames: Array<ScalarsEnums['String']>
  locationLinkCount: ScalarsEnums['Float']
  siteId: ScalarsEnums['ID']
}

/**
 * What publishing a brand add-on would do, without writing anything. receivingSiteCount counts the locations with no blocked reason; any refusal stops the whole publish.
 */
export interface BrandAddOnDryRun {
  __typename?: 'BrandAddOnDryRun'
  dependents: Array<BrandAddOnDependents>
  locationAuthoredCount: ScalarsEnums['Float']
  receivingSiteCount: ScalarsEnums['Float']
  refusals: Array<BrandServiceTemplateRefusal>
  sites: Array<BrandAddOnDryRunSite>
  unlinkedPricePointCount: ScalarsEnums['Float']
}

/**
 * What a brand add-on publish does at one location: why it is blocked, what it creates first, which links it skips and which location changes it keeps.
 */
export interface BrandAddOnDryRunSite {
  __typename?: 'BrandAddOnDryRunSite'
  autoCreate: BrandServiceTemplateAutoCreate
  blockedReasons: Array<BrandServiceTemplateBlockedReason>
  keptLocalFields: Array<ScalarsEnums['BrandAddOnField']>
  siteId: ScalarsEnums['ID']
  skippedLinks: Array<BrandAddOnSkippedLink>
}

/**
 * A brand add-on's price as a location attaches it to its own memberships: tax in this location's settings, and whether a link here already carries it, the brand's or one the location made from it.
 */
export interface BrandAddOnLocationPricePoint {
  __typename?: 'BrandAddOnLocationPricePoint'
  isLinkedHere: ScalarsEnums['Boolean']
  paymentType: ScalarsEnums['ServiceTemplateAddOnPaymentType']
  price: ScalarsEnums['Numeric']
  pricePointId: ScalarsEnums['ID']
  taxEnabled: ScalarsEnums['Boolean']
  taxSettingIds?: Maybe<Array<ScalarsEnums['ID']>>
}

/**
 * A price of a brand add-on and the brand memberships it is sold with. With no parents, locations attach their own.
 */
export interface BrandAddOnPricePoint {
  __typename?: 'BrandAddOnPricePoint'
  corporateTaxSettingIds?: Maybe<Array<ScalarsEnums['ID']>>
  parentCorporateServiceTemplateIds: Array<ScalarsEnums['ID']>
  paymentType: ScalarsEnums['ServiceTemplateAddOnPaymentType']
  price: ScalarsEnums['Numeric']
  pricePointId: ScalarsEnums['ID']
  taxEnabled: ScalarsEnums['Boolean']
}

/**
 * A membership or package a brand add-on price lists that is not linked at a location. It is linked once it is live there.
 */
export interface BrandAddOnSkippedLink {
  __typename?: 'BrandAddOnSkippedLink'
  parentCorporateServiceTemplateId: ScalarsEnums['ID']
  parentName: ScalarsEnums['String']
  pricePointId: ScalarsEnums['ID']
  reason: ScalarsEnums['BrandAddOnSkippedLinkReason']
}

/**
 * The territories a brand's app is sold in, and the territory its price is set from
 */
export interface BrandAppAvailability {
  __typename?: 'BrandAppAvailability'
  availableInNewTerritories: ScalarsEnums['Boolean']
  baseTerritory: ScalarsEnums['String']
  brandId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  platform: ScalarsEnums['BrandPlatform']
  territories: Array<ScalarsEnums['String']>
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['String']>
}

/**
 * The App Information App Store Connect holds for a brand's app
 */
export interface BrandAppInformation {
  __typename?: 'BrandAppInformation'
  ageRatingInfoUrl?: Maybe<ScalarsEnums['String']>
  brandId: ScalarsEnums['String']
  contentRightsDeclaration: ScalarsEnums['AppleContentRightsDeclaration']
  copyright?: Maybe<ScalarsEnums['String']>
  createdAt: ScalarsEnums['String']
  platform: ScalarsEnums['BrandPlatform']
  primaryCategory: ScalarsEnums['String']
  secondaryCategory?: Maybe<ScalarsEnums['String']>
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['String']>
}

/**
 * A brand's current app icon, login logo and splash screen, as Control Hub holds them
 */
export interface BrandArtwork {
  __typename?: 'BrandArtwork'
  appIconUrl?: Maybe<ScalarsEnums['String']>
  loginLogoUrl?: Maybe<ScalarsEnums['String']>
  splashScreenUrl?: Maybe<ScalarsEnums['String']>
}

/**
 * Where to PUT one brand artwork file, and how to name it when confirming
 */
export interface BrandArtworkUploadUrl {
  __typename?: 'BrandArtworkUploadUrl'
  /**
   * URL the image will be readable at once the PUT completes
   */
  fileUrl: ScalarsEnums['String']
  /**
   * Opaque reference to the uploaded object, echoed back from the upload URL response
   */
  uploadRef: ScalarsEnums['String']
  /**
   * Short-lived signed URL to PUT the image to
   */
  uploadUrl: ScalarsEnums['String']
}

export interface BrandBuildConfigView {
  __typename?: 'BrandBuildConfigView'
  brandId: ScalarsEnums['String']
  configJson?: Maybe<ScalarsEnums['String']>
  missingFields: Array<ScalarsEnums['String']>
  sources: Array<BuildConfigSourceEntry>
  status: ScalarsEnums['BrandBuildConfigViewStatus']
  unreadableCoreKeys: Array<ScalarsEnums['CoreAppServiceKeyName']>
}

/**
 * The build-time half of a brand's mobile configuration
 */
export interface BrandBuildProfile {
  __typename?: 'BrandBuildProfile'
  branchLiveKey?: Maybe<ScalarsEnums['String']>
  branchTestKey?: Maybe<ScalarsEnums['String']>
  brandId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  expoOwner?: Maybe<ScalarsEnums['String']>
  facebook?: Maybe<BrandFacebookConfig>
  googleSupportClientId?: Maybe<ScalarsEnums['String']>
  isV2Api: ScalarsEnums['Boolean']
  platformAndroid?: Maybe<ScalarsEnums['JSONObject']>
  platformIos?: Maybe<ScalarsEnums['JSONObject']>
  plugins?: Maybe<ScalarsEnums['JSONObject']>
  streakScope?: Maybe<ScalarsEnums['String']>
  translations?: Maybe<ScalarsEnums['JSONObject']>
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['String']>
}

/**
 * A brand's published config
 */
export interface BrandConfig {
  __typename?: 'BrandConfig'
  payload: ScalarsEnums['String']
  publicPayloadHash: ScalarsEnums['String']
  versionId: ScalarsEnums['String']
}

/**
 * A config version in the history
 */
export interface BrandConfigVersionSummary {
  __typename?: 'BrandConfigVersionSummary'
  createdAt: ScalarsEnums['String']
  isCurrent: ScalarsEnums['Boolean']
  savedBy?: Maybe<ScalarsEnums['String']>
  savedByPersona?: Maybe<ScalarsEnums['BrandConfigSavedByPersona']>
  versionId: ScalarsEnums['String']
}

export interface BrandFacebookConfig {
  __typename?: 'BrandFacebookConfig'
  appId: ScalarsEnums['String']
  clientToken: ScalarsEnums['String']
  displayName: ScalarsEnums['String']
}

export interface BrandFirebaseApp {
  __typename?: 'BrandFirebaseApp'
  appId: ScalarsEnums['String']
  identifier: ScalarsEnums['String']
  platform: ScalarsEnums['BrandPlatform']
}

/**
 * The Firebase apps registered for a brand's iOS and Android identifiers
 */
export interface BrandFirebaseApps {
  __typename?: 'BrandFirebaseApps'
  android?: Maybe<BrandFirebaseApp>
  ios?: Maybe<BrandFirebaseApp>
  projectId: ScalarsEnums['String']
}

/**
 * A Firebase config file, fetched live and never stored
 */
export interface BrandFirebaseConfigFile {
  __typename?: 'BrandFirebaseConfigFile'
  contents: ScalarsEnums['String']
  filename: ScalarsEnums['String']
}

/**
 * The store-facing identifiers recorded on a registry brand
 */
export interface BrandIdentity {
  __typename?: 'BrandIdentity'
  appleId?: Maybe<ScalarsEnums['String']>
  appleItcTeamId?: Maybe<ScalarsEnums['String']>
  appleTeamId?: Maybe<ScalarsEnums['String']>
  ascAppId?: Maybe<ScalarsEnums['String']>
  brandId: ScalarsEnums['String']
  bundleIdIos?: Maybe<ScalarsEnums['String']>
  packageAndroid?: Maybe<ScalarsEnums['String']>
  playStoreId?: Maybe<ScalarsEnums['String']>
  scheme?: Maybe<ScalarsEnums['String']>
}

export interface BrandNativePermissions {
  __typename?: 'BrandNativePermissions'
  android: Array<AndroidPermissionState>
  brandId: ScalarsEnums['String']
  ios: Array<IosUsageDescriptionState>
}

/**
 * A per-brand-per-platform native build/release record (the build-number ledger)
 */
export interface BrandNativeRelease {
  __typename?: 'BrandNativeRelease'
  appVersion?: Maybe<ScalarsEnums['String']>
  brandId: ScalarsEnums['String']
  buildNumber: ScalarsEnums['Float']
  ciRunUrl?: Maybe<ScalarsEnums['String']>
  completedAt?: Maybe<ScalarsEnums['String']>
  dispatchedAt?: Maybe<ScalarsEnums['String']>
  easBuildId?: Maybe<ScalarsEnums['String']>
  easBuildUrl?: Maybe<ScalarsEnums['String']>
  failureReason?: Maybe<ScalarsEnums['String']>
  nativeRevision?: Maybe<ScalarsEnums['Float']>
  platform: ScalarsEnums['BrandPlatform']
  reason: ScalarsEnums['BrandNativeReleaseReason']
  releaseId: ScalarsEnums['String']
  requestedAt: ScalarsEnums['String']
  requestedBy?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['BrandNativeReleaseStatus']
  storeBuildNumber?: Maybe<ScalarsEnums['Float']>
  storeSubmissionId?: Maybe<ScalarsEnums['String']>
  submitToReviewRequested: ScalarsEnums['Boolean']
}

/**
 * A brand's uploaded home logo and tab icons; null where the folder or fleet default applies
 */
export interface BrandNavigationArtwork {
  __typename?: 'BrandNavigationArtwork'
  homeLogoUrl?: Maybe<ScalarsEnums['String']>
  tabBookingsUrl?: Maybe<ScalarsEnums['String']>
  tabExploreUrl?: Maybe<ScalarsEnums['String']>
  tabHomeUrl?: Maybe<ScalarsEnums['String']>
  tabMoreUrl?: Maybe<ScalarsEnums['String']>
  tabPackagesUrl?: Maybe<ScalarsEnums['String']>
}

/**
 * How a brand latest release performs against the version before it
 */
export interface BrandObservePerformance {
  __typename?: 'BrandObservePerformance'
  appVersion?: Maybe<ScalarsEnums['String']>
  capturedAt?: Maybe<ScalarsEnums['String']>
  coldLaunchMedianMs?: Maybe<ScalarsEnums['Float']>
  previousAppVersion?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['BrandObservePerfStatus']
  ttiMedianMs?: Maybe<ScalarsEnums['Float']>
  worstChangeRatio?: Maybe<ScalarsEnums['Float']>
}

/**
 * One provisioning step's result: what ran, what it did, or what a human must do.
 */
export interface BrandProvisionOutcome {
  __typename?: 'BrandProvisionOutcome'
  detail: ScalarsEnums['String']
  owner?: Maybe<ScalarsEnums['BrandProvisioningOwner']>
  status: ScalarsEnums['BrandProvisionStatus']
  step: ScalarsEnums['BrandProvisionStep']
}

/**
 * The latest persisted result of one provisioning step: its state, who must act, and who ran it when.
 */
export interface BrandProvisioningOutcome {
  __typename?: 'BrandProvisioningOutcome'
  actorId: ScalarsEnums['String']
  detail: ScalarsEnums['String']
  owner: ScalarsEnums['BrandProvisioningOwner']
  platform?: Maybe<ScalarsEnums['BrandPlatform']>
  recordedAt: ScalarsEnums['String']
  runId: ScalarsEnums['String']
  status: ScalarsEnums['BrandProvisioningStepStatus']
  step: ScalarsEnums['BrandProvisionStep']
}

/**
 * Which push service a brand's app uses, the app id it registers devices under, and the Firebase project that delivers it.
 */
export interface BrandPushSettings {
  __typename?: 'BrandPushSettings'
  appId?: Maybe<ScalarsEnums['String']>
  brandId: ScalarsEnums['String']
  configuredProvider?: Maybe<ScalarsEnums['PushProvider']>
  firebaseProjectId?: Maybe<ScalarsEnums['String']>
  path: ScalarsEnums['BrandPushPath']
}

export interface BrandReleaseHold {
  __typename?: 'BrandReleaseHold'
  brandId: ScalarsEnums['String']
  reason?: Maybe<ScalarsEnums['String']>
  setAt?: Maybe<ScalarsEnums['String']>
  setByName?: Maybe<ScalarsEnums['String']>
}

/**
 * Whether a brand has everything it needs for a build on one platform
 */
export interface BrandReleaseReadiness {
  __typename?: 'BrandReleaseReadiness'
  missing: Array<BrandReleaseRequirementDetail>
  platform: ScalarsEnums['BrandPlatform']
  ready: ScalarsEnums['Boolean']
  warnings: Array<BrandReleaseRequirementDetail>
}

/**
 * One prerequisite a brand must satisfy before a native build can be requested
 */
export interface BrandReleaseRequirementDetail {
  __typename?: 'BrandReleaseRequirementDetail'
  detail?: Maybe<ScalarsEnums['String']>
  label: ScalarsEnums['String']
  requirement: ScalarsEnums['BrandReleaseRequirement']
  source: ScalarsEnums['String']
}

/**
 * The current release state of one of a brand's platforms
 */
export interface BrandReleaseStatus {
  __typename?: 'BrandReleaseStatus'
  currentAppVersion?: Maybe<ScalarsEnums['String']>
  latestRelease?: Maybe<BrandNativeRelease>
  platform: ScalarsEnums['BrandPlatform']
  testingLink?: Maybe<ScalarsEnums['String']>
}

/**
 * One a bulk archive left alone, and why.
 */
export interface BrandServiceTemplateArchiveSkip {
  __typename?: 'BrandServiceTemplateArchiveSkip'
  corporateServiceTemplateId: ScalarsEnums['ID']
  reason: ScalarsEnums['BrandServiceTemplateArchiveSkipReason']
}

/**
 * Brand session groups and tax settings a publish adds at a location first.
 */
export interface BrandServiceTemplateAutoCreate {
  __typename?: 'BrandServiceTemplateAutoCreate'
  corporateSessionTypeIds: Array<ScalarsEnums['ID']>
  corporateTaxSettingIds: Array<ScalarsEnums['ID']>
}

/**
 * Why one location cannot receive a brand membership, package or add-on.
 */
export interface BrandServiceTemplateBlockedReason {
  __typename?: 'BrandServiceTemplateBlockedReason'
  code: ScalarsEnums['BrandServiceTemplateBlockedReasonCode']
  message: ScalarsEnums['String']
}

/**
 * A brand membership, package or add-on by kind and name.
 */
export interface BrandServiceTemplateName {
  __typename?: 'BrandServiceTemplateName'
  name: ScalarsEnums['String']
  type: ScalarsEnums['CorporateServiceTemplateType']
}

/**
 * Why a brand membership, package or add-on cannot be published, and the credit line or price it concerns.
 */
export interface BrandServiceTemplateRefusal {
  __typename?: 'BrandServiceTemplateRefusal'
  code: ScalarsEnums['BrandServiceTemplateRefusalCode']
  itemId?: Maybe<ScalarsEnums['ID']>
  message: ScalarsEnums['String']
  siteIds?: Maybe<Array<ScalarsEnums['ID']>>
}

/**
 * How far a brand write has reached its locations, location by location.
 */
export interface BrandServiceTemplateRollout {
  __typename?: 'BrandServiceTemplateRollout'
  changeSetId: ScalarsEnums['ID']
  kind: ScalarsEnums['BrandServiceTemplateChangeSetKind']
  sites: Array<BrandServiceTemplateRolloutSite>
  status: ScalarsEnums['BrandServiceTemplateChangeSetStatus']
}

/**
 * What a brand write did at one location: the location row it wrote, or why it did not. A failed location is retried by the sweep.
 */
export interface BrandServiceTemplateRolloutSite {
  __typename?: 'BrandServiceTemplateRolloutSite'
  action: ScalarsEnums['BrandServiceTemplateSiteAction']
  error?: Maybe<ScalarsEnums['String']>
  resultServiceTemplateId?: Maybe<ScalarsEnums['String']>
  siteId: ScalarsEnums['ID']
  status: ScalarsEnums['BrandServiceTemplateChangeSetSiteStatus']
}

/**
 * When a scheduled brand membership, package or add-on goes live at one location, and the timezone the time was read in. isUtcFallback marks a location with no usable timezone, read as UTC.
 */
export interface BrandServiceTemplateScheduledSite {
  __typename?: 'BrandServiceTemplateScheduledSite'
  activateAt: ScalarsEnums['String']
  isUtcFallback: ScalarsEnums['Boolean']
  siteId: ScalarsEnums['ID']
  timezone: ScalarsEnums['String']
}

/**
 * A live brand membership, package or add-on a location-group change takes off sale at some of its locations.
 */
export interface BrandServiceTemplateWithdrawal {
  __typename?: 'BrandServiceTemplateWithdrawal'
  corporateServiceTemplateId: ScalarsEnums['ID']
  name: ScalarsEnums['String']
  sites: Array<BrandServiceTemplateWithdrawalSite>
  type: ScalarsEnums['CorporateServiceTemplateType']
}

/**
 * A location a change takes a brand item off, and its active clients, who keep it.
 */
export interface BrandServiceTemplateWithdrawalSite {
  __typename?: 'BrandServiceTemplateWithdrawalSite'
  activeClientCount: ScalarsEnums['Float']
  siteId: ScalarsEnums['ID']
}

/**
 * A person asserting that an unobservable onboarding step is done
 */
export interface BrandSetupAttestation {
  __typename?: 'BrandSetupAttestation'
  attestedAt: ScalarsEnums['String']
  attestedBy: ScalarsEnums['String']
  note?: Maybe<ScalarsEnums['String']>
  step: ScalarsEnums['BrandSetupStep']
}

/**
 * One onboarding step, resolved against what is currently known
 */
export interface BrandSetupStepView {
  __typename?: 'BrandSetupStepView'
  attestation?: Maybe<BrandSetupAttestation>
  blockedBy: Array<ScalarsEnums['BrandSetupStep']>
  evidence: ScalarsEnums['BrandSetupEvidence']
  label: ScalarsEnums['String']
  requirements: Array<ScalarsEnums['BrandReleaseRequirement']>
  source: ScalarsEnums['String']
  state: ScalarsEnums['BrandSetupStepState']
  step: ScalarsEnums['BrandSetupStep']
}

export interface BrandStoreAssetUploadUrl {
  __typename?: 'BrandStoreAssetUploadUrl'
  gcsPath: ScalarsEnums['String']
  uploadRef: ScalarsEnums['String']
  uploadUrl: ScalarsEnums['String']
}

export interface BrandStoreAssets {
  __typename?: 'BrandStoreAssets'
  assetId: ScalarsEnums['String']
  assetType: ScalarsEnums['BrandStoreAssetType']
  brandId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  deviceClass?: Maybe<ScalarsEnums['String']>
  filename: ScalarsEnums['String']
  gcsPath: ScalarsEnums['String']
  height?: Maybe<ScalarsEnums['Float']>
  locale: ScalarsEnums['String']
  platform: ScalarsEnums['BrandPlatform']
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['String']>
  validationError?: Maybe<ScalarsEnums['String']>
  validationStatus: ScalarsEnums['BrandStoreAssetStatus']
  width?: Maybe<ScalarsEnums['Float']>
}

export interface BrandStoreListingPublicationView {
  __typename?: 'BrandStoreListingPublicationView'
  checkedAt: ScalarsEnums['String']
  detail?: Maybe<ScalarsEnums['String']>
  platform: ScalarsEnums['BrandPlatform']
  status: ScalarsEnums['BrandStoreListingPublicationStatus']
  submittedAt?: Maybe<ScalarsEnums['String']>
}

export interface BrandStoreListings {
  __typename?: 'BrandStoreListings'
  appName?: Maybe<ScalarsEnums['String']>
  brandId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  description?: Maybe<ScalarsEnums['String']>
  keywords?: Maybe<ScalarsEnums['String']>
  locale: ScalarsEnums['String']
  marketingUrl?: Maybe<ScalarsEnums['String']>
  platform: ScalarsEnums['BrandPlatform']
  privacyPolicyUrl?: Maybe<ScalarsEnums['String']>
  releaseNotes?: Maybe<ScalarsEnums['String']>
  shortDescription?: Maybe<ScalarsEnums['String']>
  subtitle?: Maybe<ScalarsEnums['String']>
  supportUrl?: Maybe<ScalarsEnums['String']>
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['String']>
}

export interface BrandStoreOperationsOverview {
  __typename?: 'BrandStoreOperationsOverview'
  operations: Array<BrandStoreOperationsOverviewOperations>
  snapshots: Array<BrandStoreOperationsOverviewSnapshots>
}

export interface BrandStoreOperationsOverviewOperations {
  __typename?: 'BrandStoreOperationsOverviewOperations'
  action: ScalarsEnums['BrandStoreOperationAction']
  brandId: ScalarsEnums['String']
  completedAt?: Maybe<ScalarsEnums['String']>
  createdAt: ScalarsEnums['String']
  error?: Maybe<ScalarsEnums['String']>
  idempotencyKey: ScalarsEnums['String']
  operationId: ScalarsEnums['String']
  platform: ScalarsEnums['BrandPlatform']
  provider: ScalarsEnums['BrandStoreProvider']
  requestedBy?: Maybe<ScalarsEnums['String']>
  startedAt?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['BrandStoreOperationStatus']
  updatedAt: ScalarsEnums['String']
}

export interface BrandStoreOperationsOverviewSnapshots {
  __typename?: 'BrandStoreOperationsOverviewSnapshots'
  blockerKind?: Maybe<ScalarsEnums['StoreBlockerKind']>
  brandId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  error?: Maybe<ScalarsEnums['String']>
  platform: ScalarsEnums['BrandPlatform']
  provider: ScalarsEnums['BrandStoreProvider']
  providerBuildNumber?: Maybe<ScalarsEnums['Float']>
  providerUpdatedAt?: Maybe<ScalarsEnums['String']>
  providerVersion?: Maybe<ScalarsEnums['String']>
  rawReleaseState?: Maybe<ScalarsEnums['String']>
  remoteAppId?: Maybe<ScalarsEnums['String']>
  rolloutPercentage?: Maybe<ScalarsEnums['Float']>
  status: ScalarsEnums['BrandStoreSnapshotStatus']
  statusSince?: Maybe<ScalarsEnums['String']>
  syncedAt?: Maybe<ScalarsEnums['String']>
  track?: Maybe<ScalarsEnums['String']>
  updatedAt: ScalarsEnums['String']
}

/**
 * The App Review information Apple needs before it will review a brand's build
 */
export interface BrandStoreReviewDetail {
  __typename?: 'BrandStoreReviewDetail'
  brandId: ScalarsEnums['String']
  contactEmail?: Maybe<ScalarsEnums['String']>
  contactFirstName?: Maybe<ScalarsEnums['String']>
  contactLastName?: Maybe<ScalarsEnums['String']>
  contactPhone?: Maybe<ScalarsEnums['String']>
  createdAt: ScalarsEnums['String']
  demoAccountName?: Maybe<ScalarsEnums['String']>
  demoAccountRequired: ScalarsEnums['Boolean']
  hasDemoAccountPassword: ScalarsEnums['Boolean']
  notes?: Maybe<ScalarsEnums['String']>
  platform: ScalarsEnums['BrandPlatform']
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['String']>
}

export interface BrandStoreTesters {
  __typename?: 'BrandStoreTesters'
  brandId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  email: ScalarsEnums['String']
  name?: Maybe<ScalarsEnums['String']>
  platforms: Array<ScalarsEnums['BrandPlatform']>
  source: ScalarsEnums['BrandStoreTesterSource']
  testerId: ScalarsEnums['String']
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['String']>
}

/**
 * A brand in the registry, identified well enough to pick between them
 */
export interface BrandSummary {
  __typename?: 'BrandSummary'
  brandId: ScalarsEnums['String']
  environment: ScalarsEnums['BrandEnvironment']
  name: ScalarsEnums['String']
  status: ScalarsEnums['BrandRegistryStatus']
}

/**
 * Read-only share-link check plus the inviter display fields the accept sheet renders; the image is a freshly signed URL because the one embedded in the link expires
 */
export interface BuddyInviteContext {
  __typename?: 'BuddyInviteContext'
  inviterFirstName?: Maybe<ScalarsEnums['String']>
  inviterLastName?: Maybe<ScalarsEnums['String']>
  inviterProfileImageUrl?: Maybe<ScalarsEnums['String']>
  valid: ScalarsEnums['Boolean']
}

/**
 * A minted single-use buddy share-link invite token
 */
export interface BuddyInviteTokenResult {
  __typename?: 'BuddyInviteTokenResult'
  inviteToken: ScalarsEnums['String']
}

export interface BuildConfigSourceEntry {
  __typename?: 'BuildConfigSourceEntry'
  path: ScalarsEnums['String']
  source: ScalarsEnums['BuildConfigSource']
}

export interface BulkInviteStaff {
  __typename?: 'BulkInviteStaff'
  email: ScalarsEnums['String']
  invitationId: ScalarsEnums['ID']
  token: ScalarsEnums['String']
}

export interface BulkRevertMemberMovementItemResult {
  __typename?: 'BulkRevertMemberMovementItemResult'
  destinationChargesTaken: Array<MemberMovementDestinationCharge>
  error?: Maybe<ScalarsEnums['String']>
  memberMovementId: ScalarsEnums['ID']
  reverted: ScalarsEnums['Boolean']
}

export interface BulkRevertMemberMovementsResult {
  __typename?: 'BulkRevertMemberMovementsResult'
  failed: ScalarsEnums['Float']
  memberMovementRunId: ScalarsEnums['ID']
  results: Array<BulkRevertMemberMovementItemResult>
  reverted: ScalarsEnums['Float']
  total: ScalarsEnums['Float']
}

export interface BulkUpdateContentEntryStatus {
  __typename?: 'BulkUpdateContentEntryStatus'
  failureCount: ScalarsEnums['Float']
  successCount: ScalarsEnums['Float']
}

/**
 * Result for a single invoice in bulk update operation
 */
export interface BulkUpdateInvoiceResult {
  __typename?: 'BulkUpdateInvoiceResult'
  error?: Maybe<ScalarsEnums['String']>
  invoiceId: ScalarsEnums['String']
  success: ScalarsEnums['Boolean']
  wasMaterialized?: Maybe<ScalarsEnums['Boolean']>
}

/**
 * Result for bulk invoice update operation
 */
export interface BulkUpdateInvoicesResult {
  __typename?: 'BulkUpdateInvoicesResult'
  results: Array<BulkUpdateInvoiceResult>
  totalFailed: ScalarsEnums['Float']
  totalRequested: ScalarsEnums['Float']
  totalSucceeded: ScalarsEnums['Float']
}

/**
 * Result of bulk update operation with successful and failed sites
 */
export interface BulkUpdateSites {
  __typename?: 'BulkUpdateSites'
  failedSites: Array<Site>
  successSites: Array<Site>
}

/**
 * Fields required for business client sign-up
 */
export interface BusinessClientSignUpFields {
  __typename?: 'BusinessClientSignUpFields'
  customProperties: Array<BusinessClientSignUpFieldsCustomProperties>
  questionnaires: Array<BusinessClientSignUpFieldsQuestionnaires>
  static: Array<BusinessClientSignUpFieldsStatic>
}

export interface BusinessClientSignUpFieldsCustomProperties {
  __typename?: 'BusinessClientSignUpFieldsCustomProperties'
  alerts: Array<BusinessClientSignUpFieldsCustomPropertiesAlerts>
  category: ScalarsEnums['String']
  enableClientEditing: ScalarsEnums['Boolean']
  hasSubtext: ScalarsEnums['Boolean']
  id: ScalarsEnums['String']
  name: ScalarsEnums['String']
  options: Array<BusinessClientSignUpFieldsCustomPropertiesOptions>
  required: ScalarsEnums['Boolean']
  subtext?: Maybe<ScalarsEnums['String']>
  type: ScalarsEnums['String']
}

export interface BusinessClientSignUpFieldsCustomPropertiesAlerts {
  __typename?: 'BusinessClientSignUpFieldsCustomPropertiesAlerts'
  id: ScalarsEnums['String']
  isDisplayPropertyValueAsAlert: ScalarsEnums['Boolean']
  operator: ScalarsEnums['String']
  text?: Maybe<ScalarsEnums['String']>
  value?: Maybe<ScalarsEnums['String']>
}

export interface BusinessClientSignUpFieldsCustomPropertiesOptions {
  __typename?: 'BusinessClientSignUpFieldsCustomPropertiesOptions'
  label: ScalarsEnums['String']
  value: ScalarsEnums['String']
}

export interface BusinessClientSignUpFieldsQuestionnaires {
  __typename?: 'BusinessClientSignUpFieldsQuestionnaires'
  description: ScalarsEnums['String']
  id: ScalarsEnums['String']
  name: ScalarsEnums['String']
  questions: Array<BusinessClientSignUpFieldsQuestionnairesQuestions>
  revision?: Maybe<ScalarsEnums['Float']>
  scoringEnabled?: Maybe<ScalarsEnums['Boolean']>
}

export interface BusinessClientSignUpFieldsQuestionnairesQuestions {
  __typename?: 'BusinessClientSignUpFieldsQuestionnairesQuestions'
  answerType: ScalarsEnums['String']
  id: ScalarsEnums['String']
  options: Array<ScalarsEnums['String']>
  order: ScalarsEnums['Float']
  placeholder: ScalarsEnums['String']
  question: ScalarsEnums['String']
}

export interface BusinessClientSignUpFieldsStatic {
  __typename?: 'BusinessClientSignUpFieldsStatic'
  required: ScalarsEnums['Boolean']
  type: ScalarsEnums['String']
}

export interface CalculateCart {
  __typename?: 'CalculateCart'
  dueToday: ScalarsEnums['String']
  futurePayments: ScalarsEnums['String']
  items: Array<CalculateCartItems>
  preTaxTotal: ScalarsEnums['String']
  secondaryRecurringFeeFuturePayments: ScalarsEnums['String']
  subtotal: ScalarsEnums['String']
  taxBreakdown: Array<CalculateCartTaxBreakdown>
  totalAmount: ScalarsEnums['String']
  totalDiscount: ScalarsEnums['String']
  totalExclusiveTax: ScalarsEnums['String']
  totalInclusiveTax: ScalarsEnums['String']
  totalTax: ScalarsEnums['String']
}

export interface CalculateCartItems {
  __typename?: 'CalculateCartItems'
  additionalCreditsAmount?: Maybe<ScalarsEnums['String']>
  discountAmount: ScalarsEnums['String']
  earlyAccess?: Maybe<EarlyAccessTimeline>
  exclusiveTaxAmount: ScalarsEnums['String']
  inclusiveTaxAmount: ScalarsEnums['String']
  invoiceDate?: Maybe<ScalarsEnums['String']>
  itemId: ScalarsEnums['String']
  joinsPresaleInvoice?: Maybe<ScalarsEnums['Boolean']>
  preTaxAmount: ScalarsEnums['String']
  proratedAmount?: Maybe<ScalarsEnums['String']>
  proratedCredits?: Maybe<ScalarsEnums['Float']>
  proratedDays?: Maybe<ScalarsEnums['Float']>
  proratedTotalAmount?: Maybe<ScalarsEnums['String']>
  prorationEndDate?: Maybe<ScalarsEnums['String']>
  prorationStartDate?: Maybe<ScalarsEnums['String']>
  quantity: ScalarsEnums['Float']
  revenueTag?: Maybe<RevenueTagSnapshot>
  secondaryRecurringFeeTaxes: Array<CalculateCartItemsTaxes>
  secondaryRecurringFeeTotalBillingCycles?: Maybe<ScalarsEnums['Float']>
  setupFeeChargedToday?: Maybe<ScalarsEnums['Boolean']>
  taxes: Array<CalculateCartItemsTaxes>
  totalAmount: ScalarsEnums['String']
  totalBillingCycles?: Maybe<ScalarsEnums['Float']>
  totalCredits?: Maybe<ScalarsEnums['Float']>
  totalValue: ScalarsEnums['String']
  unitPrice: ScalarsEnums['String']
}

export interface CalculateCartItemsTaxes {
  __typename?: 'CalculateCartItemsTaxes'
  amount: ScalarsEnums['String']
  name: ScalarsEnums['String']
  rate: ScalarsEnums['String']
  taxSettingId: ScalarsEnums['String']
  type: ScalarsEnums['TaxType']
}

export interface CalculateCartTaxBreakdown {
  __typename?: 'CalculateCartTaxBreakdown'
  name: ScalarsEnums['String']
  rate: ScalarsEnums['String']
  taxSettingId: ScalarsEnums['String']
  totalAmount: ScalarsEnums['String']
  type: ScalarsEnums['TaxType']
}

/**
 * Lightweight session data optimized for calendar/scheduler display
 */
export interface CalendarSession {
  __typename?: 'CalendarSession'
  bookedCount?: Maybe<ScalarsEnums['Float']>
  bookings?: Maybe<Array<CalendarSessionBooking>>
  description?: Maybe<ScalarsEnums['String']>
  endTime: ScalarsEnums['String']
  instructor?: Maybe<Array<CalendarSessionInstructor>>
  isBlockSlot: ScalarsEnums['Boolean']
  isFullyPaid: ScalarsEnums['Boolean']
  isPublishedToWellhub: ScalarsEnums['Boolean']
  name: ScalarsEnums['String']
  roomName?: Maybe<ScalarsEnums['String']>
  sessionId: ScalarsEnums['String']
  sessionTypeColor?: Maybe<ScalarsEnums['String']>
  siteLocationRoomId?: Maybe<ScalarsEnums['String']>
  size: ScalarsEnums['Float']
  staffUserIds?: Maybe<Array<ScalarsEnums['String']>>
  startTime: ScalarsEnums['String']
  status: ScalarsEnums['SessionStatus']
  waitlistCount: ScalarsEnums['Float']
  waitlistEnabled: ScalarsEnums['Boolean']
}

/**
 * Minimal booking data for private session display
 */
export interface CalendarSessionBooking {
  __typename?: 'CalendarSessionBooking'
  clientName?: Maybe<ScalarsEnums['String']>
}

/**
 * Lightweight instructor data for calendar display
 */
export interface CalendarSessionInstructor {
  __typename?: 'CalendarSessionInstructor'
  name?: Maybe<ScalarsEnums['String']>
  staffUserId: ScalarsEnums['String']
}

/**
 * Response for withdrawing a form assignment
 */
export interface CancelFormAssignmentResponse {
  __typename?: 'CancelFormAssignmentResponse'
  message?: Maybe<ScalarsEnums['String']>
  success: ScalarsEnums['Boolean']
}

export interface CancelImportSession {
  __typename?: 'CancelImportSession'
  importSessionId: ScalarsEnums['ID']
  status: ScalarsEnums['ImportSessionStatusEnum']
}

/**
 * The result of a member dismissing an inline bank authentication challenge
 */
export interface CancelPendingClientActionResult {
  __typename?: 'CancelPendingClientActionResult'
  outcome: ScalarsEnums['CancelPendingClientActionOutcome']
}

/**
 * The result of cancelling an in-flight payment
 */
export interface CancelPendingPaymentResult {
  __typename?: 'CancelPendingPaymentResult'
  outcome: ScalarsEnums['PendingPaymentCancellationOutcome']
  paymentId: ScalarsEnums['String']
  status: ScalarsEnums['PaymentStatus']
}

export interface CancelTerminalAction {
  __typename?: 'CancelTerminalAction'
  success: ScalarsEnums['Boolean']
}

export interface CancellationFeeBreakdown {
  __typename?: 'CancellationFeeBreakdown'
  cycleAmount?: Maybe<ScalarsEnums['String']>
  kind: ScalarsEnums['CancellationFeeBreakdownKind']
  percent?: Maybe<ScalarsEnums['Float']>
  remainingCycles?: Maybe<ScalarsEnums['Float']>
}

/**
 * A payment the member still owes before the cancellation takes effect. description is the billing series name, null for a pause fee that is projected but not yet created.
 */
export interface CancellationNoticePaymentDue {
  __typename?: 'CancellationNoticePaymentDue'
  amount: ScalarsEnums['String']
  currency: ScalarsEnums['String']
  description?: Maybe<ScalarsEnums['String']>
  invoiceDate: ScalarsEnums['String']
  type: ScalarsEnums['RecurringInvoiceType']
}

/**
 * The earliest date a cancellation can take effect under the membership cancellation notice period, the last active day, and the payments still due before the cancellation date
 */
export interface CancellationNoticePreview {
  __typename?: 'CancellationNoticePreview'
  lastActiveDate: ScalarsEnums['String']
  noticeCancelDate: ScalarsEnums['String']
  noticePeriodAmount: ScalarsEnums['Float']
  noticePeriodUnit: ScalarsEnums['CancellationNoticePeriodUnit']
  paymentsDue: Array<CancellationNoticePaymentDue>
  requestDate: ScalarsEnums['String']
}

/**
 * A staff-cancelled invoice with what a reinstate of it would need
 */
export interface CancelledInvoiceRow {
  __typename?: 'CancelledInvoiceRow'
  cancelledByStaffName?: Maybe<ScalarsEnums['String']>
  invoice: Invoice
  latestReinstateDate?: Maybe<ScalarsEnums['String']>
  reinstateBlockedReason?: Maybe<ScalarsEnums['ReinstateBlockedReason']>
  requiresNewDate: ScalarsEnums['Boolean']
}

/**
 * Sales and voided totals for one additional billing type of a session
 */
export interface CashDrawerBillingTypeTotal {
  __typename?: 'CashDrawerBillingTypeTotal'
  label: ScalarsEnums['String']
  sales: ScalarsEnums['Numeric']
  voided: ScalarsEnums['Numeric']
}

/**
 * A cash drawer session
 */
export interface CashDrawerSession {
  __typename?: 'CashDrawerSession'
  actualCash?: Maybe<ScalarsEnums['Numeric']>
  /**
   * Sales and voided totals per additional (custom) billing type taken during this session, for open and closed sessions — cash is excluded (it has dedicated fields)
   */
  additionalBillingTypeTotals: Array<CashDrawerBillingTypeTotal>
  /**
   * Void and payout cash-outs attributed to this session — live while open, snapshot once closed
   */
  cashAdjustments: ScalarsEnums['Numeric']
  cashDrawerSessionId: ScalarsEnums['ID']
  /**
   * Cash refunds attributed to this session — live while open, snapshot once closed
   */
  cashRefunds: ScalarsEnums['Numeric']
  /**
   * Cash sales attributed to this session — live while open, snapshot once closed
   */
  cashSales: ScalarsEnums['Numeric']
  closedAt?: Maybe<ScalarsEnums['String']>
  closedByStaffUserId?: Maybe<ScalarsEnums['ID']>
  createdAt: ScalarsEnums['String']
  difference?: Maybe<ScalarsEnums['Numeric']>
  expectedCash?: Maybe<ScalarsEnums['Numeric']>
  /**
   * Expected takings across all stamped billing types: startingCash + cash and additional-billing-type sales − cashRefunds − cashAdjustments − additional-billing-type voids — live while open, the expectedCash snapshot once closed
   */
  expectedInDrawer: ScalarsEnums['Numeric']
  openedAt: ScalarsEnums['String']
  openedByStaffUserId: ScalarsEnums['ID']
  siteId: ScalarsEnums['ID']
  startingCash: ScalarsEnums['Numeric']
  status: ScalarsEnums['CashDrawerSessionStatus']
  updatedAt: ScalarsEnums['String']
}

export interface CashDrawerSessionTransactions {
  __typename?: 'CashDrawerSessionTransactions'
  pageInfo: CashDrawerSessionTransactionsPageInfo
  results: Array<CashDrawerSessionTransactionsResults>
}

export interface CashDrawerSessionTransactionsPageInfo {
  __typename?: 'CashDrawerSessionTransactionsPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface CashDrawerSessionTransactionsResults {
  __typename?: 'CashDrawerSessionTransactionsResults'
  cursor: ScalarsEnums['String']
  row: CashDrawerTransaction
}

export interface CashDrawerSessions {
  __typename?: 'CashDrawerSessions'
  pageInfo: CashDrawerSessionsPageInfo
  results: Array<CashDrawerSessionsResults>
}

export interface CashDrawerSessionsPageInfo {
  __typename?: 'CashDrawerSessionsPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface CashDrawerSessionsResults {
  __typename?: 'CashDrawerSessionsResults'
  cursor: ScalarsEnums['String']
  row: CashDrawerSession
}

/**
 * A payment, refund or adjustment attributed to a cash drawer session
 */
export interface CashDrawerTransaction {
  __typename?: 'CashDrawerTransaction'
  amount: ScalarsEnums['Numeric']
  billingType: ScalarsEnums['String']
  clientName?: Maybe<ScalarsEnums['String']>
  description: ScalarsEnums['String']
  kind: ScalarsEnums['CashDrawerTransactionKind']
  occurredAt: ScalarsEnums['String']
  sourceId: ScalarsEnums['ID']
}

export interface ChallengeAnalytics {
  __typename?: 'ChallengeAnalytics'
  articleCompletionRate: ScalarsEnums['Float']
  assessmentCompletionRate: ScalarsEnums['Float']
  averageAttendanceRate: ScalarsEnums['Float']
  averageGoalCompletionRate: ScalarsEnums['Float']
  totalActive: ScalarsEnums['Float']
  totalCompleted: ScalarsEnums['Float']
  totalEnrolled: ScalarsEnums['Float']
  totalExpired: ScalarsEnums['Float']
  totalWithdrawn: ScalarsEnums['Float']
}

export interface ChallengeCatalog {
  __typename?: 'ChallengeCatalog'
  data: Array<ChallengeDetail>
  hasMore: ScalarsEnums['Boolean']
  totalCount: ScalarsEnums['Float']
}

export interface ChallengeDetail {
  __typename?: 'ChallengeDetail'
  contentEntryId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  description?: Maybe<ScalarsEnums['String']>
  fields: ScalarsEnums['JSONObject']
  imageUrl?: Maybe<ScalarsEnums['String']>
  publishedAt?: Maybe<ScalarsEnums['String']>
  slug: ScalarsEnums['String']
  status: ScalarsEnums['String']
  title: ScalarsEnums['String']
}

/**
 * Single entry in a challenge leaderboard
 */
export interface ChallengeLeaderboardEntry {
  __typename?: 'ChallengeLeaderboardEntry'
  client: ChallengeLeaderboardEntryClient
  clientId: ScalarsEnums['String']
  rank: ScalarsEnums['Float']
  score: ScalarsEnums['Float']
}

export interface ChallengeLeaderboardEntryClient {
  __typename?: 'ChallengeLeaderboardEntryClient'
  firstName: ScalarsEnums['String']
  lastName: ScalarsEnums['String']
  profileImage?: Maybe<ScalarsEnums['String']>
}

/**
 * Overview of challenge participation and completion
 */
export interface ChallengeOverview {
  __typename?: 'ChallengeOverview'
  activeChallenges: ScalarsEnums['Float']
  avgAttendanceProgress: ScalarsEnums['Float']
  completedEnrollments: ScalarsEnums['Float']
  completionRate: ScalarsEnums['Float']
  totalEnrollments: ScalarsEnums['Float']
}

export interface ChallengeParticipationTimeline {
  __typename?: 'ChallengeParticipationTimeline'
  buckets: Array<ChallengeParticipationTimelineBuckets>
}

export interface ChallengeParticipationTimelineBuckets {
  __typename?: 'ChallengeParticipationTimelineBuckets'
  completed: ScalarsEnums['Float']
  date: ScalarsEnums['String']
  enrolled: ScalarsEnums['Float']
  withdrawn: ScalarsEnums['Float']
}

/**
 * Result of initiating a membership plan change
 */
export interface ChangeMembershipPlanResult {
  __typename?: 'ChangeMembershipPlanResult'
  proratedInvoiceId?: Maybe<ScalarsEnums['ID']>
  servicePlanChangeId: ScalarsEnums['ID']
}

/**
 * A client check-in record
 */
export interface CheckIn {
  __typename?: 'CheckIn'
  accessProviderId?: Maybe<ScalarsEnums['String']>
  checkInId: ScalarsEnums['ID']
  client?: Maybe<Client>
  clientId: ScalarsEnums['ID']
  contactlessCheckInAnswers?: Maybe<ScalarsEnums['JSONObject']>
  createdAt: ScalarsEnums['String']
  dateTime: ScalarsEnums['String']
  deletedAt?: Maybe<ScalarsEnums['String']>
  destinationFee?: Maybe<CheckInDestinationFee>
  externalEventId?: Maybe<ScalarsEnums['String']>
  externalFailCode?: Maybe<ScalarsEnums['String']>
  failReason?: Maybe<ScalarsEnums['CheckInFailReason']>
  failedInvoices?: Maybe<Array<CheckInFailedInvoices>>
  holdOwnerFirstName?: Maybe<ScalarsEnums['String']>
  nextSession?: Maybe<CheckInNextSession>
  service?: Maybe<CheckInService>
  site: SitePreview
  siteAccessZoneId?: Maybe<ScalarsEnums['String']>
  siteId: ScalarsEnums['ID']
  source: ScalarsEnums['CheckInSource']
  sourceId?: Maybe<ScalarsEnums['String']>
  stagedInvoices?: Maybe<Array<CheckInStagedInvoices>>
  status: ScalarsEnums['CheckInStatus']
  type: ScalarsEnums['CheckInType']
}

/**
 * A single barcode/check-in scan attempt (recognised or not).
 */
export interface CheckInAttempt {
  __typename?: 'CheckInAttempt'
  attemptId: ScalarsEnums['String']
  barcode?: Maybe<ScalarsEnums['String']>
  checkInId?: Maybe<ScalarsEnums['String']>
  clientId?: Maybe<ScalarsEnums['String']>
  createdAt: ScalarsEnums['String']
  failReason?: Maybe<ScalarsEnums['String']>
  firstName?: Maybe<ScalarsEnums['String']>
  lastName?: Maybe<ScalarsEnums['String']>
  siteId: ScalarsEnums['String']
  source: ScalarsEnums['String']
  status: ScalarsEnums['CheckInAttemptStatus']
}

export interface CheckInAttemptsPaginationResult {
  __typename?: 'CheckInAttemptsPaginationResult'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  items: Array<CheckInAttempt>
}

export interface CheckInByBookingResult {
  __typename?: 'CheckInByBookingResult'
  booking: CheckInByBookingResultBooking
  checkinFlag: ScalarsEnums['Float']
  message: ScalarsEnums['String']
  success: ScalarsEnums['Boolean']
}

export interface CheckInByBookingResultBooking {
  __typename?: 'CheckInByBookingResultBooking'
  checkedIn: ScalarsEnums['Boolean']
  checkinTime: ScalarsEnums['String']
  id: ScalarsEnums['String']
}

export interface CheckInDestinationFee {
  __typename?: 'CheckInDestinationFee'
  alreadyChargedToday: ScalarsEnums['Boolean']
  amount: ScalarsEnums['String']
  currency: ScalarsEnums['String']
  existingStagedInvoiceId?: Maybe<ScalarsEnums['String']>
  label: ScalarsEnums['String']
  membershipName?: Maybe<ScalarsEnums['String']>
  siteName: ScalarsEnums['String']
  taxAmount?: Maybe<ScalarsEnums['String']>
}

export interface CheckInFailedInvoices {
  __typename?: 'CheckInFailedInvoices'
  amount: ScalarsEnums['String']
  description?: Maybe<ScalarsEnums['String']>
  dueDate?: Maybe<ScalarsEnums['String']>
  hasFailureHistory?: Maybe<ScalarsEnums['Boolean']>
  invoiceId: ScalarsEnums['ID']
  siteId?: Maybe<ScalarsEnums['ID']>
  siteName?: Maybe<ScalarsEnums['String']>
  status?: Maybe<ScalarsEnums['InvoiceStatus']>
}

export interface CheckInNextSession {
  __typename?: 'CheckInNextSession'
  bookingId?: Maybe<ScalarsEnums['ID']>
  sessionDateTime?: Maybe<ScalarsEnums['String']>
  sessionId: ScalarsEnums['ID']
  sessionName?: Maybe<ScalarsEnums['String']>
}

export interface CheckInService {
  __typename?: 'CheckInService'
  creditsRemaining?: Maybe<ScalarsEnums['Float']>
  isGuestPass?: Maybe<ScalarsEnums['Boolean']>
  serviceId: ScalarsEnums['ID']
  serviceName?: Maybe<ScalarsEnums['String']>
  serviceType?: Maybe<ScalarsEnums['String']>
}

export interface CheckInStagedInvoices {
  __typename?: 'CheckInStagedInvoices'
  amount: ScalarsEnums['String']
  description?: Maybe<ScalarsEnums['String']>
  dueDate?: Maybe<ScalarsEnums['String']>
  invoiceId: ScalarsEnums['ID']
}

/**
 * Pagination information for check-ins
 */
export interface CheckInsPageInfo {
  __typename?: 'CheckInsPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  hasPreviousPage?: Maybe<ScalarsEnums['Boolean']>
  startCursor?: Maybe<ScalarsEnums['String']>
}

/**
 * Paginated list of check-ins
 */
export interface CheckInsPaginationResult {
  __typename?: 'CheckInsPaginationResult'
  items: Array<CheckIn>
  pageInfo: CheckInsPageInfo
  totalCount?: Maybe<ScalarsEnums['Float']>
}

export interface CheckoutSessionResponse {
  __typename?: 'CheckoutSessionResponse'
  checkoutUrl: ScalarsEnums['String']
}

/**
 * The linked guest client and the accepted pass after a successful claim
 */
export interface ClaimGuestPassResult {
  __typename?: 'ClaimGuestPassResult'
  clientId: ScalarsEnums['ID']
  guestPass: GuestPass
  isExisting: ScalarsEnums['Boolean']
}

/**
 * ClassPass integration settings
 */
export interface ClassPassSettings {
  __typename?: 'ClassPassSettings'
  enabled: ScalarsEnums['Boolean']
  siteIds: Array<ScalarsEnums['String']>
}

export interface CleanupOrphanedCarouselGroupsResult {
  __typename?: 'CleanupOrphanedCarouselGroupsResult'
  deletedCount: ScalarsEnums['Float']
}

export interface ClearGrowHqAuthentication {
  __typename?: 'ClearGrowHqAuthentication'
  success: ScalarsEnums['Boolean']
}

/**
 * A gym client/member
 */
export interface Client {
  __typename?: 'Client'
  activePackagesCount?: Maybe<ScalarsEnums['Float']>
  address?: Maybe<ClientAddress>
  alerts: Array<ClientAlert>
  attendanceCount: ScalarsEnums['Float']
  barcode?: Maybe<ScalarsEnums['String']>
  billingEmail?: Maybe<ScalarsEnums['String']>
  blockReason?: Maybe<ScalarsEnums['String']>
  buddies: Array<Client>
  clientSiteStatus?: Maybe<ScalarsEnums['String']>
  clientType?: Maybe<ScalarsEnums['ClientType']>
  communicationPreferences?: Maybe<ClientCommunicationPreferences>
  companyName?: Maybe<ScalarsEnums['String']>
  corporateId?: Maybe<ScalarsEnums['String']>
  createdAt: ScalarsEnums['String']
  customProperties?: Maybe<Array<CustomPropertyWithClientValue>>
  customerId?: Maybe<ScalarsEnums['String']>
  dateOfBirth?: Maybe<ScalarsEnums['String']>
  doorCredential?: Maybe<ClientDoorCredential>
  email?: Maybe<ScalarsEnums['String']>
  emergencyContact?: Maybe<ClientEmergencyContact>
  favoriteSiteIds?: Maybe<Array<ScalarsEnums['String']>>
  firebaseId?: Maybe<ScalarsEnums['String']>
  firstName?: Maybe<ScalarsEnums['String']>
  fobNumber?: Maybe<ScalarsEnums['String']>
  gender?: Maybe<ScalarsEnums['String']>
  homeLocationIds?: Maybe<Array<ScalarsEnums['String']>>
  homePhoneNumber?: Maybe<ScalarsEnums['String']>
  homeSiteId?: Maybe<ScalarsEnums['String']>
  homeSiteName?: Maybe<ScalarsEnums['String']>
  id: ScalarsEnums['String']
  introOffersClaimed: Array<ClientIntroOffersClaimed>
  isProspect?: Maybe<ScalarsEnums['Boolean']>
  isSuspended?: Maybe<ScalarsEnums['Boolean']>
  joinDate?: Maybe<ScalarsEnums['String']>
  lastBooking?: Maybe<ScalarsEnums['String']>
  lastName?: Maybe<ScalarsEnums['String']>
  lastVisit?: Maybe<ScalarsEnums['String']>
  /**
   * Membership status at each of the client's active locations (corporate search stacked cells)
   */
  locationStatuses: Array<ClientLocationStatus>
  membershipStatus: ScalarsEnums['String']
  mobilePhoneNumber?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  /**
   * Sites where the client has one or more notes — feeds the note alert indicator
   */
  notes: Array<ClientNoteSite>
  occupation?: Maybe<ScalarsEnums['String']>
  /**
   * Pending agreements requiring client signature
   */
  pendingAgreements: Array<PendingAgreement>
  /**
   * Forms the client still has to complete at a location, required-before first
   */
  pendingForms: (args?: { siteId?: Maybe<ScalarsEnums['String']> }) => Array<MemberPendingForm>
  /**
   * Pending policies requiring client acknowledgment
   */
  pendingPolicies: Array<PendingPolicy>
  profile?: Maybe<ScalarsEnums['String']>
  /**
   * Profile image of the client
   */
  profileImage: (args: { input: ImagePublicSignedUrlInput }) => Maybe<ImagePublicSignedUrl>
  recentSiteId?: Maybe<ScalarsEnums['String']>
  relations: Array<ClientFamily>
  siteId?: Maybe<ScalarsEnums['String']>
  siteInformation: Array<ClientSiteInfo>
  siteRelationships: Array<ClientSiteRelationship>
  smartGroups: Array<StaffUserSmartGroup>
  source?: Maybe<ScalarsEnums['ClientSource']>
  taxIdentifier?: Maybe<ScalarsEnums['String']>
  totalCheckInCount: ScalarsEnums['Float']
  updatedAt: ScalarsEnums['String']
}

/**
 * A booking-less check-in shown in the client activity feed
 */
export interface ClientActivityFeedCheckIn {
  __typename?: 'ClientActivityFeedCheckIn'
  checkInId: ScalarsEnums['String']
  dateTime: ScalarsEnums['String']
  doorName?: Maybe<ScalarsEnums['String']>
  type: ScalarsEnums['CheckInType']
  zoneName?: Maybe<ScalarsEnums['String']>
}

/**
 * A client activity feed row: a booking with its latest activity, or a zone check-in
 */
export interface ClientActivityFeedItem {
  __typename?: 'ClientActivityFeedItem'
  activity?: Maybe<ActivityStreamItemActivity>
  booking?: Maybe<ActivityStreamItemBooking>
  checkIn?: Maybe<ClientActivityFeedCheckIn>
  kind: ScalarsEnums['ClientActivityFeedKind']
  session?: Maybe<ActivityStreamItemSession>
}

/**
 * Paginated client activity feed result
 */
export interface ClientActivityFeedPaginationResult {
  __typename?: 'ClientActivityFeedPaginationResult'
  pageInfo: ClientBookingsPageInfo
  results: Array<ClientActivityFeedResultItem>
}

/**
 * A single client activity feed result with cursor
 */
export interface ClientActivityFeedResultItem {
  __typename?: 'ClientActivityFeedResultItem'
  cursor: ScalarsEnums['String']
  row: ClientActivityFeedItem
}

export interface ClientAddress {
  __typename?: 'ClientAddress'
  city?: Maybe<ScalarsEnums['String']>
  country?: Maybe<ScalarsEnums['String']>
  state?: Maybe<ScalarsEnums['String']>
  streetAddress?: Maybe<ScalarsEnums['String']>
  streetNumber?: Maybe<ScalarsEnums['String']>
  unit?: Maybe<ScalarsEnums['String']>
  zipCode?: Maybe<ScalarsEnums['String']>
}

/**
 * A gym client/member (admin view with clientId)
 */
export interface ClientAdmin {
  __typename?: 'ClientAdmin'
  activePackagesCount?: Maybe<ScalarsEnums['Float']>
  address?: Maybe<ClientAddress>
  alerts?: Maybe<Array<ClientAlert>>
  attendanceCount: ScalarsEnums['Float']
  barcode?: Maybe<ScalarsEnums['String']>
  billingEmail?: Maybe<ScalarsEnums['String']>
  clientId: ScalarsEnums['String']
  clientType?: Maybe<ScalarsEnums['ClientType']>
  communicationPreferences?: Maybe<ClientCommunicationPreferences>
  companyName?: Maybe<ScalarsEnums['String']>
  corporateId?: Maybe<ScalarsEnums['String']>
  createdAt: ScalarsEnums['String']
  customerId?: Maybe<ScalarsEnums['String']>
  dateOfBirth?: Maybe<ScalarsEnums['String']>
  email?: Maybe<ScalarsEnums['String']>
  emergencyContact?: Maybe<ClientEmergencyContact>
  favoriteSiteIds?: Maybe<Array<ScalarsEnums['String']>>
  firebaseId?: Maybe<ScalarsEnums['String']>
  firstName: ScalarsEnums['String']
  fobNumber?: Maybe<ScalarsEnums['String']>
  gender?: Maybe<ScalarsEnums['String']>
  homeLocationIds?: Maybe<Array<ScalarsEnums['String']>>
  homePhoneNumber?: Maybe<ScalarsEnums['String']>
  homeSiteId?: Maybe<ScalarsEnums['String']>
  homeSiteName?: Maybe<ScalarsEnums['String']>
  id?: Maybe<ScalarsEnums['String']>
  introOffersClaimed?: Maybe<Array<ClientIntroOffersClaimed>>
  isProspect?: Maybe<ScalarsEnums['Boolean']>
  joinDate: ScalarsEnums['String']
  lastBooking?: Maybe<ScalarsEnums['String']>
  lastName: ScalarsEnums['String']
  lastVisit?: Maybe<ScalarsEnums['String']>
  membershipStatus?: Maybe<ScalarsEnums['String']>
  mobilePhoneNumber?: Maybe<ScalarsEnums['String']>
  name?: Maybe<ScalarsEnums['String']>
  notes?: Maybe<Array<ScalarsEnums['String']>>
  occupation?: Maybe<ScalarsEnums['String']>
  profile?: Maybe<ScalarsEnums['String']>
  recentSiteId?: Maybe<ScalarsEnums['String']>
  siteRelationships?: Maybe<Array<ClientSiteRelationship>>
  smartGroups?: Maybe<Array<StaffUserSmartGroup>>
  source?: Maybe<ScalarsEnums['ClientSource']>
  taxIdentifier?: Maybe<ScalarsEnums['String']>
  updatedAt: ScalarsEnums['String']
}

/**
 * A client's date of birth and how it was verified, with the acceptances a correction stopped counting
 */
export interface ClientAgeVerification {
  __typename?: 'ClientAgeVerification'
  ageVerificationMethod?: Maybe<ScalarsEnums['AgeVerificationMethod']>
  ageVerifiedAt?: Maybe<ScalarsEnums['String']>
  ageVerifiedByStaffUserId?: Maybe<ScalarsEnums['ID']>
  capacityMismatchAgreementIds: Array<ScalarsEnums['ID']>
  clientId: ScalarsEnums['ID']
  dateOfBirth?: Maybe<ScalarsEnums['String']>
}

export interface ClientAgreement {
  __typename?: 'ClientAgreement'
  agreementContent: ScalarsEnums['String']
  agreementId: ScalarsEnums['ID']
  agreementMethod?: Maybe<ScalarsEnums['AgreementMethod']>
  agreementName: ScalarsEnums['String']
  agreementVersion: ScalarsEnums['String']
  clientId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  expiresAt?: Maybe<ScalarsEnums['String']>
  ipAddress?: Maybe<ScalarsEnums['String']>
  linkedInvoiceId?: Maybe<ScalarsEnums['ID']>
  nativeSignatureUrls?: Maybe<Array<ScalarsEnums['String']>>
  publicAccessLinkId?: Maybe<ScalarsEnums['ID']>
  /**
   * Agreement content with communication placeholders (e.g. <CLIENT_NAME>, <BUSINESS_NAME>) replaced by actual values. Use this for display; use agreementContent for signing.
   */
  renderedContent?: Maybe<ScalarsEnums['String']>
  sentAt?: Maybe<ScalarsEnums['String']>
  sentByStaffUserId?: Maybe<ScalarsEnums['ID']>
  serviceId?: Maybe<ScalarsEnums['ID']>
  /**
   * Signed URLs for agreement signature images. Returns GCS signed URLs when signatures exist, null otherwise.
   */
  signatureImageUrls?: Maybe<Array<ScalarsEnums['String']>>
  signatureOnly?: Maybe<ScalarsEnums['Boolean']>
  signedAt?: Maybe<ScalarsEnums['String']>
  signedPdfGcsUri?: Maybe<ScalarsEnums['String']>
  signedPdfSha256?: Maybe<ScalarsEnums['String']>
  signedViewLinkId?: Maybe<ScalarsEnums['ID']>
  siteAgreementTemplateId?: Maybe<ScalarsEnums['ID']>
  siteId: ScalarsEnums['ID']
  status: ScalarsEnums['AgreementStatus']
  terminalHandoffRequestId?: Maybe<ScalarsEnums['ID']>
  type: ScalarsEnums['AgreementType']
  userAgent?: Maybe<ScalarsEnums['String']>
  voidReason?: Maybe<ScalarsEnums['String']>
  voidedAt?: Maybe<ScalarsEnums['String']>
  voidedByStaffUserId?: Maybe<ScalarsEnums['ID']>
}

export interface ClientAgreementsWithPagination {
  __typename?: 'ClientAgreementsWithPagination'
  pageInfo: ClientAgreementsWithPaginationPageInfo
  results: Array<ClientAgreementsWithPaginationResults>
}

export interface ClientAgreementsWithPaginationPageInfo {
  __typename?: 'ClientAgreementsWithPaginationPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface ClientAgreementsWithPaginationResults {
  __typename?: 'ClientAgreementsWithPaginationResults'
  cursor: ScalarsEnums['String']
  row: ClientAgreement
}

/**
 * Client alert with dynamic data based on type
 */
export interface ClientAlert {
  __typename?: 'ClientAlert'
  clientId: ScalarsEnums['String']
  data?: Maybe<ClientAlertData>
  requiresFetch: ScalarsEnums['Boolean']
  type: ScalarsEnums['String']
}

/**
 * Data payload for client alerts
 */
export interface ClientAlertData {
  __typename?: 'ClientAlertData'
  address?: Maybe<ScalarsEnums['String']>
  alertId?: Maybe<ScalarsEnums['String']>
  count?: Maybe<ScalarsEnums['Float']>
  dateOfBirth?: Maybe<ScalarsEnums['String']>
  description?: Maybe<ScalarsEnums['String']>
  endDate?: Maybe<ScalarsEnums['String']>
  failed?: Maybe<ScalarsEnums['Float']>
  homeSiteName?: Maybe<ScalarsEnums['String']>
  isSuspended?: Maybe<ScalarsEnums['Boolean']>
  items?: Maybe<Array<ClientAlertItem>>
  notes?: Maybe<ScalarsEnums['Float']>
  outstanding?: Maybe<ScalarsEnums['Float']>
  properties?: Maybe<ScalarsEnums['Float']>
  startDate?: Maybe<ScalarsEnums['String']>
  title?: Maybe<ScalarsEnums['String']>
}

/**
 * A single alert within an aggregated alert icon (e.g. one custom alert)
 */
export interface ClientAlertItem {
  __typename?: 'ClientAlertItem'
  alertId?: Maybe<ScalarsEnums['String']>
  description?: Maybe<ScalarsEnums['String']>
  endDate?: Maybe<ScalarsEnums['String']>
  startDate?: Maybe<ScalarsEnums['String']>
  title?: Maybe<ScalarsEnums['String']>
}

/**
 * Attendance statistics for a client at a site, including aggregate counts and monthly breakdown
 */
export interface ClientAttendanceStats {
  __typename?: 'ClientAttendanceStats'
  attendedLast30Days: ScalarsEnums['Float']
  lastAttendanceDate?: Maybe<ScalarsEnums['String']>
  monthlyAttendance: Array<MonthlyAttendance>
  noShowCount: ScalarsEnums['Float']
  siteJoinDate?: Maybe<ScalarsEnums['String']>
  totalAttendedCount: ScalarsEnums['Float']
  upcomingCount: ScalarsEnums['Float']
}

/**
 * A session booked for a client with relevant booking and session details
 */
export interface ClientBookedSession {
  __typename?: 'ClientBookedSession'
  booking: ClientBookedSessionBooking
  invoice?: Maybe<ClientBookingInvoice>
  /**
   * Package/membership names used to pay for this booking with credits
   */
  packagesUsed?: Maybe<Array<ScalarsEnums['String']>>
  session: ClientBookingSession
  tanning?: Maybe<ClientBookingTanning>
}

export interface ClientBookedSessionBooking {
  __typename?: 'ClientBookedSessionBooking'
  aggregatorProviderDisplayName?: Maybe<ScalarsEnums['String']>
  aggregatorProviderId?: Maybe<ScalarsEnums['String']>
  bookedBy: ClientBookedSessionBookingBookedBy
  bookedByClientId?: Maybe<ScalarsEnums['ID']>
  bookingId: ScalarsEnums['ID']
  bookingSource?: Maybe<ScalarsEnums['BookingSource']>
  cancelledAt?: Maybe<ScalarsEnums['String']>
  cancelledByName?: Maybe<ClientBookedSessionBookingCancelledByName>
  invitedByStaffUserId?: Maybe<ScalarsEnums['ID']>
  isImportedVisit?: Maybe<ScalarsEnums['Boolean']>
  paymentStatus?: Maybe<ScalarsEnums['BookingPaymentStatus']>
  sharedCreditOwnerClientId?: Maybe<ScalarsEnums['ID']>
  spotId?: Maybe<ScalarsEnums['Float']>
  status: ScalarsEnums['BookingStatus']
  waitlistPosition?: Maybe<ScalarsEnums['Float']>
}

export interface ClientBookedSessionBookingBookedBy {
  __typename?: 'ClientBookedSessionBookingBookedBy'
  firstName: ScalarsEnums['String']
  lastName: ScalarsEnums['String']
}

export interface ClientBookedSessionBookingCancelledByName {
  __typename?: 'ClientBookedSessionBookingCancelledByName'
  firstName: ScalarsEnums['String']
  lastName: ScalarsEnums['String']
}

/**
 * Client booking buddy relationship record
 */
export interface ClientBookingBuddy {
  __typename?: 'ClientBookingBuddy'
  acceptedAt?: Maybe<ScalarsEnums['String']>
  buddyClientId: ScalarsEnums['String']
  clientId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  initiatedBy: ScalarsEnums['String']
  invitedAt: ScalarsEnums['String']
  revokedAt?: Maybe<ScalarsEnums['String']>
  revokedBy?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['ClientBookingBuddyStatus']
  updatedAt: ScalarsEnums['String']
}

/**
 * Instructor details within a client booking session
 */
export interface ClientBookingInstructor {
  __typename?: 'ClientBookingInstructor'
  firstName: ScalarsEnums['String']
  lastName: ScalarsEnums['String']
  profileImageUrl?: Maybe<ScalarsEnums['String']>
  staffUserId?: Maybe<ScalarsEnums['String']>
}

/**
 * Invoice details within a client booking session
 */
export interface ClientBookingInvoice {
  __typename?: 'ClientBookingInvoice'
  fullyPaidDate?: Maybe<ScalarsEnums['String']>
  invoiceId: ScalarsEnums['String']
  paidBy?: Maybe<ClientBookingInvoicePaidBy>
  staffUserId?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['String']
}

export interface ClientBookingInvoicePaidBy {
  __typename?: 'ClientBookingInvoicePaidBy'
  firstName: ScalarsEnums['String']
  lastName: ScalarsEnums['String']
}

/**
 * Per-package booking-context data returned by creditsCoverSession for the requested booking date
 */
export interface ClientBookingPackage {
  __typename?: 'ClientBookingPackage'
  canceledAt?: Maybe<ScalarsEnums['String']>
  creditDetails: Array<ClientBookingPackageCreditDetails>
  creditsRemaining: ScalarsEnums['Float']
  expiryDate?: Maybe<ScalarsEnums['String']>
  packageAgreementAccepted: ScalarsEnums['Boolean']
  packageCategory?: Maybe<ScalarsEnums['String']>
  packageId: ScalarsEnums['String']
  packageName: ScalarsEnums['String']
  packageStatus: ScalarsEnums['String']
  packageSubscriptionId: ScalarsEnums['String']
  suspensionPeriod: Array<ClientBookingPackageSuspensionPeriod>
}

export interface ClientBookingPackageCreditDetails {
  __typename?: 'ClientBookingPackageCreditDetails'
  endDate: ScalarsEnums['String']
  startDate: ScalarsEnums['String']
  totalCreditsRemaining: ScalarsEnums['Float']
}

export interface ClientBookingPackageSuspensionPeriod {
  __typename?: 'ClientBookingPackageSuspensionPeriod'
  endDate: ScalarsEnums['String']
  startDate: ScalarsEnums['String']
}

/**
 * Result of attempting to book a single client into a session
 */
export interface ClientBookingResult {
  __typename?: 'ClientBookingResult'
  bookingId?: Maybe<ScalarsEnums['ID']>
  clientId: ScalarsEnums['ID']
  error?: Maybe<ScalarsEnums['String']>
  outcome: ScalarsEnums['MultipleReservationOutcome']
  success: ScalarsEnums['Boolean']
  waitlistEntryId?: Maybe<ScalarsEnums['ID']>
}

/**
 * A single client booking result with cursor
 */
export interface ClientBookingResultItem {
  __typename?: 'ClientBookingResultItem'
  cursor: ScalarsEnums['String']
  row: ClientBookedSession
}

/**
 * Room details within a client booking session
 */
export interface ClientBookingRoom {
  __typename?: 'ClientBookingRoom'
  name: ScalarsEnums['String']
  roomId: ScalarsEnums['String']
  roomResourceTemplateId?: Maybe<ScalarsEnums['String']>
}

/**
 * Session details within a client booking, with resolver-based room/site/instructor fields
 */
export interface ClientBookingSession {
  __typename?: 'ClientBookingSession'
  category: ScalarsEnums['SessionCategory']
  creditsRequired?: Maybe<ScalarsEnums['Float']>
  /**
   * Custom cancellation policy — returns session-level policy, falling back to template-level policy
   */
  customCancelPolicy?: Maybe<SessionTemplateCustomCancelPolicy>
  dropinPrice?: Maybe<ScalarsEnums['Float']>
  endTime: ScalarsEnums['String']
  /**
   * Instructors assigned to this session
   */
  instructors: Array<ClientBookingInstructor>
  isRequiredSessionFeedback?: Maybe<ScalarsEnums['Boolean']>
  name: ScalarsEnums['String']
  /**
   * Room details for this session
   */
  room?: Maybe<ClientBookingRoom>
  sessionId: ScalarsEnums['String']
  sessionImage?: Maybe<ScalarsEnums['String']>
  sessionTemplateId?: Maybe<ScalarsEnums['String']>
  /**
   * Site details for this session
   */
  site?: Maybe<ClientBookingSite>
  siteId: ScalarsEnums['String']
  siteLocationId: ScalarsEnums['String']
  siteLocationRoomId?: Maybe<ScalarsEnums['String']>
  startTime: ScalarsEnums['String']
  zoomJoinUrl?: Maybe<ScalarsEnums['String']>
}

/**
 * Site details within a client booking session
 */
export interface ClientBookingSite {
  __typename?: 'ClientBookingSite'
  name: ScalarsEnums['String']
  timezone: ScalarsEnums['String']
}

/**
 * Equipment assignment details when a client booked session row is a tanning bed session
 */
export interface ClientBookingTanning {
  __typename?: 'ClientBookingTanning'
  addOnInvoiceId?: Maybe<ScalarsEnums['String']>
  cancelledAt?: Maybe<ScalarsEnums['String']>
  checkInId?: Maybe<ScalarsEnums['String']>
  doneAt?: Maybe<ScalarsEnums['String']>
  equipmentAssignmentId: ScalarsEnums['String']
  equipmentCategory: ScalarsEnums['EquipmentCategory']
  equipmentName: ScalarsEnums['String']
  nonUvCategory?: Maybe<ScalarsEnums['NonUvCategory']>
  siteSessionTypeName?: Maybe<ScalarsEnums['String']>
  timerMinutes: ScalarsEnums['Float']
}

/**
 * Pagination information for client bookings
 */
export interface ClientBookingsPageInfo {
  __typename?: 'ClientBookingsPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Float']
}

/**
 * Paginated client bookings result
 */
export interface ClientBookingsPaginationResult {
  __typename?: 'ClientBookingsPaginationResult'
  pageInfo: ClientBookingsPageInfo
  results: Array<ClientBookingResultItem>
}

export interface ClientCommunicationPreferences {
  __typename?: 'ClientCommunicationPreferences'
  email?: Maybe<ScalarsEnums['Boolean']>
  notifications?: Maybe<ScalarsEnums['Boolean']>
  phone?: Maybe<ScalarsEnums['Boolean']>
  sms?: Maybe<ScalarsEnums['Boolean']>
}

/**
 * A contact log entry for a client
 */
export interface ClientContactLog {
  __typename?: 'ClientContactLog'
  bouncedAt?: Maybe<ScalarsEnums['String']>
  channel: ScalarsEnums['String']
  communicationsLogId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  failureReason?: Maybe<ScalarsEnums['String']>
  renderedContent?: Maybe<ScalarsEnums['String']>
  renderedSubject?: Maybe<ScalarsEnums['String']>
  sentAt?: Maybe<ScalarsEnums['String']>
  status?: Maybe<ScalarsEnums['String']>
}

export interface ClientContactLogs {
  __typename?: 'ClientContactLogs'
  pageInfo: ClientContactLogsPageInfo
  results: Array<ClientContactLogsResults>
}

export interface ClientContactLogsPageInfo {
  __typename?: 'ClientContactLogsPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface ClientContactLogsResults {
  __typename?: 'ClientContactLogsResults'
  cursor: ScalarsEnums['String']
  row: ClientContactLog
}

export interface ClientCustomAlert {
  __typename?: 'ClientCustomAlert'
  alertId: ScalarsEnums['String']
  clientId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  createdBy: ScalarsEnums['String']
  createdByName?: Maybe<ScalarsEnums['String']>
  description?: Maybe<ScalarsEnums['String']>
  endDate?: Maybe<ScalarsEnums['String']>
  siteId: ScalarsEnums['String']
  startDate?: Maybe<ScalarsEnums['String']>
  title: ScalarsEnums['String']
  updatedAt: ScalarsEnums['String']
}

export interface ClientCustomAlertMutationResponse {
  __typename?: 'ClientCustomAlertMutationResponse'
  alert?: Maybe<ClientCustomAlert>
  message: ScalarsEnums['String']
  success: ScalarsEnums['Boolean']
}

export interface ClientCustomAlertsResponse {
  __typename?: 'ClientCustomAlertsResponse'
  alerts: Array<ClientCustomAlert>
}

/**
 * A client custom property value
 */
export interface ClientCustomPropertyValue {
  __typename?: 'ClientCustomPropertyValue'
  changedBy?: Maybe<ScalarsEnums['String']>
  changedByType?: Maybe<ScalarsEnums['CustomPropertyChangedByType']>
  clientId: ScalarsEnums['String']
  customPropertyValueId: ScalarsEnums['String']
  siteCustomPropertyId: ScalarsEnums['String']
  siteId: ScalarsEnums['String']
  updatedAt: ScalarsEnums['String']
  value?: Maybe<ScalarsEnums['String']>
  version?: Maybe<ScalarsEnums['Float']>
}

/**
 * One recorded value of a client custom property
 */
export interface ClientCustomPropertyValueHistoryEntry {
  __typename?: 'ClientCustomPropertyValueHistoryEntry'
  changedAt: ScalarsEnums['String']
  changedByType: ScalarsEnums['CustomPropertyChangedByType']
  historyId: ScalarsEnums['String']
  sourceFormSubmissionId?: Maybe<ScalarsEnums['String']>
  value?: Maybe<ScalarsEnums['String']>
}

/**
 * A page of a client custom property value history, newest first
 */
export interface ClientCustomPropertyValueHistoryPage {
  __typename?: 'ClientCustomPropertyValueHistoryPage'
  endCursor?: Maybe<ScalarsEnums['String']>
  entries: Array<ClientCustomPropertyValueHistoryEntry>
  hasNextPage: ScalarsEnums['Boolean']
}

/**
 * Response containing client custom property values
 */
export interface ClientCustomPropertyValuesResponse {
  __typename?: 'ClientCustomPropertyValuesResponse'
  /**
   * Properties whose value the calling client may read but not change, such as a form result shown to clients
   */
  lockedSiteCustomPropertyIds: Array<ScalarsEnums['String']>
  values: Array<ClientCustomPropertyValue>
  /**
   * Properties that hold a value the calling client may not read, such as a form result hidden from clients
   */
  withheldSiteCustomPropertyIds: Array<ScalarsEnums['String']>
}

/**
 * A member's active door credential — the card serial behind their door code
 */
export interface ClientDoorCredential {
  __typename?: 'ClientDoorCredential'
  serial?: Maybe<ScalarsEnums['String']>
}

/**
 * Status of a client email lookup within a corporate
 */
export interface ClientEmailStatus {
  __typename?: 'ClientEmailStatus'
  clientId?: Maybe<ScalarsEnums['ID']>
  email?: Maybe<ScalarsEnums['String']>
  exists: ScalarsEnums['Boolean']
  firstName?: Maybe<ScalarsEnums['String']>
  homeSiteName?: Maybe<ScalarsEnums['String']>
  lastName?: Maybe<ScalarsEnums['String']>
}

export interface ClientEmergencyContact {
  __typename?: 'ClientEmergencyContact'
  address?: Maybe<ClientEmergencyContactAddress>
  email?: Maybe<ScalarsEnums['String']>
  name?: Maybe<ScalarsEnums['String']>
  phone?: Maybe<ScalarsEnums['String']>
  relationship?: Maybe<ScalarsEnums['String']>
}

export interface ClientEmergencyContactAddress {
  __typename?: 'ClientEmergencyContactAddress'
  city?: Maybe<ScalarsEnums['String']>
  country?: Maybe<ScalarsEnums['String']>
  state?: Maybe<ScalarsEnums['String']>
  street?: Maybe<ScalarsEnums['String']>
  streetNumber?: Maybe<ScalarsEnums['String']>
  unit?: Maybe<ScalarsEnums['String']>
  zipCode?: Maybe<ScalarsEnums['String']>
}

/**
 * Client family relation record
 */
export interface ClientFamily {
  __typename?: 'ClientFamily'
  clientId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  email?: Maybe<ScalarsEnums['String']>
  familyMemberClientId: ScalarsEnums['String']
  isPrimaryAccountHolder: ScalarsEnums['Boolean']
  linkedClientId?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  relationship: ScalarsEnums['ClientFamilyRelationship']
  relationshipInverse: ScalarsEnums['ClientFamilyRelationship']
  updatedAt: ScalarsEnums['String']
}

/**
 * Client favorite instructor reference
 */
export interface ClientFavoriteInstructor {
  __typename?: 'ClientFavoriteInstructor'
  instructorId: ScalarsEnums['String']
}

export interface ClientFeesTemplate {
  __typename?: 'ClientFeesTemplate'
  clientFeesTemplateId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  fees: Array<HapanaFeesTemplateFees>
  name: ScalarsEnums['String']
  /**
   * The sites associated with the client fees template
   */
  sites: Array<Site>
  updatedAt: ScalarsEnums['String']
}

export interface ClientFeesTemplatesPageInfo {
  __typename?: 'ClientFeesTemplatesPageInfo'
  pageInfo: HapanaFeesTemplatesBasePageInfo
  results: Array<ClientFeesTemplate>
}

export interface ClientFile {
  __typename?: 'ClientFile'
  clientId: ScalarsEnums['String']
  createdAt?: Maybe<ScalarsEnums['String']>
  fileId: ScalarsEnums['String']
  fileJSON: ClientFileFileJSON
  fileName: ScalarsEnums['String']
  fileType: ScalarsEnums['String']
  siteId: ScalarsEnums['String']
  uploadedAt: ScalarsEnums['String']
  url: ScalarsEnums['String']
}

export interface ClientFileFileJSON {
  __typename?: 'ClientFileFileJSON'
  lastFailure?: Maybe<ClientFileFileJSONLastFailure>
  pending?: Maybe<ClientFileFileJSONPending>
  status: ScalarsEnums['FileUploadConfigFieldStatus']
  versions?: Maybe<Array<DocumentFileVersion>>
}

export interface ClientFileFileJSONLastFailure {
  __typename?: 'ClientFileFileJSONLastFailure'
  errorMessage: ScalarsEnums['String']
  failedAt: ScalarsEnums['String']
  tempUrl: ScalarsEnums['String']
  uploadRequestedBy: ScalarsEnums['ID']
}

export interface ClientFileFileJSONPending {
  __typename?: 'ClientFileFileJSONPending'
  status: ScalarsEnums['FileUploadConfigFieldPendingStatus']
  tempUrl: ScalarsEnums['String']
  uploadRequestedAt: ScalarsEnums['String']
  uploadRequestedBy: ScalarsEnums['ID']
}

export interface ClientFileUrl {
  __typename?: 'ClientFileUrl'
  url: ScalarsEnums['String']
}

export interface ClientFilesWithPagination {
  __typename?: 'ClientFilesWithPagination'
  pageInfo: ClientFilesWithPaginationPageInfo
  results: Array<ClientFilesWithPaginationResults>
}

export interface ClientFilesWithPaginationPageInfo {
  __typename?: 'ClientFilesWithPaginationPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface ClientFilesWithPaginationResults {
  __typename?: 'ClientFilesWithPaginationResults'
  cursor: ScalarsEnums['String']
  row: ClientFile
}

/**
 * A client form answer
 */
export interface ClientFormAnswer {
  __typename?: 'ClientFormAnswer'
  answer: ScalarsEnums['String']
  answeredAt: ScalarsEnums['String']
  formSubmissionId: ScalarsEnums['String']
  siteFormQuestionId: ScalarsEnums['String']
}

/**
 * The client's current scored result for a form at a site
 */
export interface ClientFormResult {
  __typename?: 'ClientFormResult'
  assessedAt?: Maybe<ScalarsEnums['String']>
  clientId: ScalarsEnums['String']
  completedAt?: Maybe<ScalarsEnums['String']>
  completedVia?: Maybe<ScalarsEnums['FormCompletedVia']>
  completionSequence?: Maybe<ScalarsEnums['Float']>
  formSubmissionId: ScalarsEnums['String']
  resultBandId?: Maybe<ScalarsEnums['String']>
  resultBandIndex?: Maybe<ScalarsEnums['Float']>
  resultDescription?: Maybe<ScalarsEnums['String']>
  resultLabel?: Maybe<ScalarsEnums['String']>
  resultSource?: Maybe<ScalarsEnums['FormExternalResultSource']>
  siteFormId: ScalarsEnums['String']
  siteId: ScalarsEnums['String']
  totalScore?: Maybe<ScalarsEnums['Float']>
}

/**
 * A client form submission with answers
 */
export interface ClientFormSubmission {
  __typename?: 'ClientFormSubmission'
  answers?: Maybe<Array<ClientFormAnswer>>
  assignedAt: ScalarsEnums['String']
  assignedBy?: Maybe<ScalarsEnums['String']>
  cancellationReason?: Maybe<ScalarsEnums['String']>
  cancelledAt?: Maybe<ScalarsEnums['String']>
  clientId: ScalarsEnums['String']
  completedAt?: Maybe<ScalarsEnums['String']>
  completedDeviceTokenId?: Maybe<ScalarsEnums['String']>
  completedVia?: Maybe<ScalarsEnums['FormCompletedVia']>
  formName: ScalarsEnums['String']
  /**
   * Staff only: the form definition pinned when the form was assigned
   */
  formSnapshot?: Maybe<ScalarsEnums['JSON']>
  formSubmissionId: ScalarsEnums['String']
  handoffId?: Maybe<ScalarsEnums['String']>
  isCurrentResult?: Maybe<ScalarsEnums['Boolean']>
  purgeReason?: Maybe<ScalarsEnums['String']>
  purgedAt?: Maybe<ScalarsEnums['String']>
  requiredBefore?: Maybe<ScalarsEnums['FormRequiredBefore']>
  resultBandId?: Maybe<ScalarsEnums['String']>
  resultBandIndex?: Maybe<ScalarsEnums['Float']>
  resultLabel?: Maybe<ScalarsEnums['String']>
  /**
   * Staff only: the points awarded and the band chosen at completion
   */
  scoringSnapshot?: Maybe<ScalarsEnums['JSON']>
  siteFormId: ScalarsEnums['String']
  siteId: ScalarsEnums['String']
  status: ScalarsEnums['FormSubmissionStatus']
  supersededAt?: Maybe<ScalarsEnums['String']>
  totalScore?: Maybe<ScalarsEnums['Float']>
}

/**
 * A client form submission with client ID and answers
 */
export interface ClientFormSubmissionWithClient {
  __typename?: 'ClientFormSubmissionWithClient'
  answers: Array<ClientFormAnswer>
  assignedAt: ScalarsEnums['String']
  assignedBy?: Maybe<ScalarsEnums['String']>
  cancellationReason?: Maybe<ScalarsEnums['String']>
  cancelledAt?: Maybe<ScalarsEnums['String']>
  clientId: ScalarsEnums['String']
  completedAt?: Maybe<ScalarsEnums['String']>
  completedDeviceTokenId?: Maybe<ScalarsEnums['String']>
  completedVia?: Maybe<ScalarsEnums['FormCompletedVia']>
  /**
   * Staff only: the form definition pinned when the form was assigned
   */
  formSnapshot?: Maybe<ScalarsEnums['JSON']>
  formSubmissionId: ScalarsEnums['String']
  handoffId?: Maybe<ScalarsEnums['String']>
  isCurrentResult?: Maybe<ScalarsEnums['Boolean']>
  purgeReason?: Maybe<ScalarsEnums['String']>
  purgedAt?: Maybe<ScalarsEnums['String']>
  requiredBefore?: Maybe<ScalarsEnums['FormRequiredBefore']>
  resultBandId?: Maybe<ScalarsEnums['String']>
  resultBandIndex?: Maybe<ScalarsEnums['Float']>
  resultLabel?: Maybe<ScalarsEnums['String']>
  /**
   * Staff only: the points awarded and the band chosen at completion
   */
  scoringSnapshot?: Maybe<ScalarsEnums['JSON']>
  siteFormId: ScalarsEnums['String']
  siteId: ScalarsEnums['String']
  status: ScalarsEnums['FormSubmissionStatus']
  supersededAt?: Maybe<ScalarsEnums['String']>
  totalScore?: Maybe<ScalarsEnums['Float']>
}

/**
 * Response containing client form submissions
 */
export interface ClientFormSubmissionsResponse {
  __typename?: 'ClientFormSubmissionsResponse'
  submissions: Array<ClientFormSubmission>
}

export interface ClientFormSubmissionsWithPagination {
  __typename?: 'ClientFormSubmissionsWithPagination'
  pageInfo: ClientFormSubmissionsWithPaginationPageInfo
  results: Array<ClientFormSubmissionsWithPaginationResults>
}

export interface ClientFormSubmissionsWithPaginationPageInfo {
  __typename?: 'ClientFormSubmissionsWithPaginationPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface ClientFormSubmissionsWithPaginationResults {
  __typename?: 'ClientFormSubmissionsWithPaginationResults'
  cursor: ScalarsEnums['String']
  row: ClientFormSubmission
}

/**
 * The Grow-connected locations for a client (brand-level clients list)
 */
export interface ClientGrowLocationsSummary {
  __typename?: 'ClientGrowLocationsSummary'
  clientId: ScalarsEnums['String']
  locations: Array<GrowClientLocation>
}

/**
 * Aggregate + per-location Grow sync status for a client
 */
export interface ClientGrowStatus {
  __typename?: 'ClientGrowStatus'
  clientId: ScalarsEnums['String']
  locations: Array<GrowContactLocationStatus>
  overallStatus: ScalarsEnums['ClientGrowSyncStatus']
}

/**
 * Lightweight per-client Grow sync status for list views
 */
export interface ClientGrowStatusSummary {
  __typename?: 'ClientGrowStatusSummary'
  clientId: ScalarsEnums['String']
  status: ScalarsEnums['ClientGrowSyncStatus']
}

/**
 * Result of a client import operation
 */
export interface ClientImportResult {
  __typename?: 'ClientImportResult'
  errors: Array<ClientImportResultErrors>
  failedImports: ScalarsEnums['Float']
  successfulImports: ScalarsEnums['Float']
  totalRows: ScalarsEnums['Float']
}

export interface ClientImportResultErrors {
  __typename?: 'ClientImportResultErrors'
  error: ScalarsEnums['String']
  row: ScalarsEnums['Float']
}

export interface ClientIntroOffersClaimed {
  __typename?: 'ClientIntroOffersClaimed'
  claimedAt: ScalarsEnums['String']
  offerId: ScalarsEnums['String']
  siteId?: Maybe<ScalarsEnums['String']>
  usedAt?: Maybe<ScalarsEnums['String']>
}

/**
 * The IP address the platform sees for the current request
 */
export interface ClientIpInfo {
  __typename?: 'ClientIpInfo'
  ipAddress?: Maybe<ScalarsEnums['String']>
  isPublic: ScalarsEnums['Boolean']
}

export interface ClientLifetimeSpend {
  __typename?: 'ClientLifetimeSpend'
  currency: ScalarsEnums['String']
  netSpend: ScalarsEnums['String']
}

/**
 * A client's computed membership status at one of their connected locations
 */
export interface ClientLocationStatus {
  __typename?: 'ClientLocationStatus'
  siteId: ScalarsEnums['String']
  siteName?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['String']
}

export interface ClientNextBilling {
  __typename?: 'ClientNextBilling'
  amount: ScalarsEnums['String']
  currency: ScalarsEnums['String']
  nextInvoiceDate: ScalarsEnums['String']
}

/**
 * A note associated with a client
 */
export interface ClientNote {
  __typename?: 'ClientNote'
  clientId: ScalarsEnums['String']
  content?: Maybe<ScalarsEnums['String']>
  createdAt: ScalarsEnums['String']
  createdBy: ScalarsEnums['String']
  createdByEmail?: Maybe<ScalarsEnums['String']>
  createdByName?: Maybe<ScalarsEnums['String']>
  noteId: ScalarsEnums['String']
  siteId: ScalarsEnums['String']
}

/**
 * A site at which the client has one or more notes
 */
export interface ClientNoteSite {
  __typename?: 'ClientNoteSite'
  id: ScalarsEnums['String']
  siteId: ScalarsEnums['String']
}

/**
 * Response containing client notes
 */
export interface ClientNotesResponse {
  __typename?: 'ClientNotesResponse'
  notes: Array<ClientNote>
}

/**
 * A client payment method
 */
export interface ClientPaymentMethod {
  __typename?: 'ClientPaymentMethod'
  bankAccountType?: Maybe<ScalarsEnums['String']>
  bankCode?: Maybe<ScalarsEnums['String']>
  bankFingerprint?: Maybe<ScalarsEnums['String']>
  bankHolderType?: Maybe<ScalarsEnums['String']>
  bankLast4?: Maybe<ScalarsEnums['String']>
  bankName?: Maybe<ScalarsEnums['String']>
  cardBrand?: Maybe<ScalarsEnums['String']>
  cardBrandProduct?: Maybe<ScalarsEnums['String']>
  cardCountry?: Maybe<ScalarsEnums['String']>
  cardExpMonth?: Maybe<ScalarsEnums['String']>
  cardExpYear?: Maybe<ScalarsEnums['String']>
  cardFingerprint?: Maybe<ScalarsEnums['String']>
  cardFunding?: Maybe<ScalarsEnums['CardFunding']>
  cardLast4?: Maybe<ScalarsEnums['String']>
  clientId?: Maybe<ScalarsEnums['ID']>
  clientPaymentMethodId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  createdBy?: Maybe<ScalarsEnums['ID']>
  deletedAt?: Maybe<ScalarsEnums['String']>
  deletedBy?: Maybe<ScalarsEnums['ID']>
  gatewayCustomerId?: Maybe<ScalarsEnums['String']>
  gatewayPaymentIntentId?: Maybe<ScalarsEnums['String']>
  gatewayPaymentMethodId?: Maybe<ScalarsEnums['String']>
  gatewaySetupIntentId?: Maybe<ScalarsEnums['String']>
  isBackup?: Maybe<ScalarsEnums['Boolean']>
  isDefault: ScalarsEnums['Boolean']
  isLive: ScalarsEnums['Boolean']
  mandateAcceptedAt?: Maybe<ScalarsEnums['String']>
  mandateAuthorisationAgreementId?: Maybe<ScalarsEnums['ID']>
  mandateId?: Maybe<ScalarsEnums['String']>
  mandateStatus?: Maybe<ScalarsEnums['String']>
  mandateUrl?: Maybe<ScalarsEnums['String']>
  /**
   * Whether this payment method can be removed, with the billing-obligation categories blocking it if not
   */
  removalEligibility?: Maybe<PaymentMethodRemovalEligibility>
  siteId: ScalarsEnums['ID']
  sitePaymentGatewayId: ScalarsEnums['ID']
  sitePaymentGatewayType: ScalarsEnums['SupportedPaymentGateway']
  status: ScalarsEnums['ClientPaymentMethodStatus']
  type: ScalarsEnums['ClientPaymentMethodType']
  updatedAt: ScalarsEnums['String']
  wallet?: Maybe<ScalarsEnums['PaymentWallet']>
}

/**
 * Client permissions for the current user
 */
export interface ClientPermissions {
  __typename?: 'ClientPermissions'
  canChangePassword: ScalarsEnums['Boolean']
  canDelete: ScalarsEnums['Boolean']
  canEdit: ScalarsEnums['Boolean']
}

/**
 * Readiness of a client for every equipment category the location runs
 */
export interface ClientPolicyCompliance {
  __typename?: 'ClientPolicyCompliance'
  /**
   * How the date of birth was verified; null when it never was
   */
  ageVerificationMethod?: Maybe<ScalarsEnums['AgeVerificationMethod']>
  ageVerifiedAt?: Maybe<ScalarsEnums['String']>
  categories: Array<EquipmentReadinessView>
  clientId: ScalarsEnums['ID']
  /**
   * The client has a date of birth with a recorded verification, so QR and kiosk are open
   */
  dobVerified: ScalarsEnums['Boolean']
  siteId: ScalarsEnums['ID']
}

/**
 * Snapshot of a client profile for merge preview comparison
 */
export interface ClientProfileSnapshot {
  __typename?: 'ClientProfileSnapshot'
  address?: Maybe<ScalarsEnums['String']>
  communicationPreferences?: Maybe<ScalarsEnums['String']>
  customerId?: Maybe<ScalarsEnums['String']>
  dateOfBirth?: Maybe<ScalarsEnums['String']>
  email?: Maybe<ScalarsEnums['String']>
  emergencyContact?: Maybe<ScalarsEnums['String']>
  firstName?: Maybe<ScalarsEnums['String']>
  fobNumber?: Maybe<ScalarsEnums['String']>
  gender?: Maybe<ScalarsEnums['String']>
  homePhoneNumber?: Maybe<ScalarsEnums['String']>
  homeSiteId?: Maybe<ScalarsEnums['String']>
  homeSiteName?: Maybe<ScalarsEnums['String']>
  id: ScalarsEnums['String']
  lastName?: Maybe<ScalarsEnums['String']>
  mobilePhoneNumber?: Maybe<ScalarsEnums['String']>
  occupation?: Maybe<ScalarsEnums['String']>
  profileImageJSON?: Maybe<ScalarsEnums['String']>
}

/**
 * Result of a client-relation add/remove mutation
 */
export interface ClientRelationMutationResult {
  __typename?: 'ClientRelationMutationResult'
  success: ScalarsEnums['Boolean']
}

/**
 * A relation in the unified Relations view (Family/Buddy/Shared/Other)
 */
export interface ClientRelationView {
  __typename?: 'ClientRelationView'
  allocatedCredits?: Maybe<ScalarsEnums['Float']>
  counterpartyClientId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  email?: Maybe<ScalarsEnums['String']>
  imageUrl?: Maybe<ScalarsEnums['String']>
  isOwner?: Maybe<ScalarsEnums['Boolean']>
  name: ScalarsEnums['String']
  phone?: Maybe<ScalarsEnums['String']>
  relationshipSubtype?: Maybe<ScalarsEnums['String']>
  serviceId?: Maybe<ScalarsEnums['ID']>
  status: ScalarsEnums['ClientRelationStatus']
  type: ScalarsEnums['ClientRelationViewType']
}

/**
 * Individual client result with user permissions
 */
export interface ClientResult {
  __typename?: 'ClientResult'
  client?: Maybe<Client>
  permissions: ClientPermissions
}

/**
 * Client service with template info for UI display
 */
export interface ClientService {
  __typename?: 'ClientService'
  activatedStartDate?: Maybe<ScalarsEnums['String']>
  activeSuspension?: Maybe<ClientServiceActiveSuspension>
  addOns?: Maybe<Array<ClientServiceAddOn>>
  autoRenew: ScalarsEnums['Boolean']
  billingCycleAmount?: Maybe<ScalarsEnums['Float']>
  billingCycleUnit?: Maybe<ScalarsEnums['String']>
  canceledAt?: Maybe<ScalarsEnums['String']>
  cancellationReason?: Maybe<ScalarsEnums['String']>
  changePlanEnabled?: Maybe<ScalarsEnums['Boolean']>
  clientId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  createdByInvoiceId?: Maybe<ScalarsEnums['ID']>
  /**
   * Status of the invoice this service was created from (null when the service has no originating invoice). Distinguishes a pre-sold service already paid in full from one whose invoice is still scheduled.
   */
  createdByInvoiceStatus?: Maybe<ScalarsEnums['String']>
  creditBalanceSnapshot?: Maybe<CreditBalanceSnapshotOutput>
  currency?: Maybe<ScalarsEnums['String']>
  expiredCreditsAvailableForRollover?: Maybe<ScalarsEnums['Float']>
  expiresAt?: Maybe<ScalarsEnums['String']>
  isAllSharedSites?: Maybe<ScalarsEnums['Boolean']>
  isRefunded?: Maybe<ScalarsEnums['Boolean']>
  /**
   * Most recent executed plan change for this service (if any)
   */
  lastExecutedPlanChange?: Maybe<ClientServiceLastExecutedPlanChange>
  /**
   * The most recent staff extension or reactivation of this service, if any
   */
  latestExtension?: Maybe<ServiceExtensionSummary>
  minimumHomeUsageInDays?: Maybe<ScalarsEnums['Float']>
  netPrice?: Maybe<ScalarsEnums['Float']>
  nextBillingDate?: Maybe<ScalarsEnums['String']>
  /**
   * Next invoice date from the primary recurring invoice for this service
   */
  nextInvoiceDate?: Maybe<ScalarsEnums['String']>
  onHold: ScalarsEnums['Boolean']
  parentServiceId?: Maybe<ScalarsEnums['String']>
  pendingPaymentPlanChange?: Maybe<ClientServicePendingPaymentPlanChange>
  price?: Maybe<ScalarsEnums['Float']>
  purchasedAt: ScalarsEnums['String']
  /**
   * All recurring invoices for this service (primary + secondary fees). Use to detect and display secondary recurring fees.
   */
  recurringInvoices: Array<RecurringInvoice>
  /**
   * Name of the staff user who referred the client for this service
   */
  referredByStaffName?: Maybe<ScalarsEnums['String']>
  scheduledCancellation?: Maybe<ServiceCancellation>
  scheduledPlanChange?: Maybe<ClientServiceScheduledPlanChange>
  scheduledSuspension?: Maybe<ClientServiceScheduledSuspension>
  serviceId: ScalarsEnums['String']
  serviceTemplateId: ScalarsEnums['String']
  serviceTemplateName?: Maybe<ScalarsEnums['String']>
  serviceTemplateType?: Maybe<ScalarsEnums['String']>
  sharedCredits?: Maybe<ClientServiceSharedCredits>
  sharedHomeUsageUnlockDate?: Maybe<ScalarsEnums['String']>
  sharedSiteIds?: Maybe<Array<ScalarsEnums['String']>>
  signedClientAgreementId?: Maybe<ScalarsEnums['String']>
  siteId: ScalarsEnums['String']
  startsAt: ScalarsEnums['String']
  status: ScalarsEnums['ServiceStatus']
  templateCreditSessionTypes?: Maybe<Array<TemplateCreditSessionType>>
  updatedAt: ScalarsEnums['String']
}

export interface ClientServiceActiveSuspension {
  __typename?: 'ClientServiceActiveSuspension'
  endDate?: Maybe<ScalarsEnums['String']>
}

/**
 * An add-on child service attached to a client-profile parent service
 */
export interface ClientServiceAddOn {
  __typename?: 'ClientServiceAddOn'
  amount?: Maybe<ScalarsEnums['Float']>
  canceledAt?: Maybe<ScalarsEnums['String']>
  currency?: Maybe<ScalarsEnums['String']>
  description?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  paymentType: ScalarsEnums['ServiceTemplateAddOnPaymentType']
  scheduledCancellation?: Maybe<ClientServiceAddOnScheduledCancellation>
  serviceId: ScalarsEnums['ID']
  serviceTemplateId: ScalarsEnums['ID']
  startsAt: ScalarsEnums['String']
  status: ScalarsEnums['ServiceStatus']
}

/**
 * An add-on's own scheduled cancellation, independent of its membership's
 */
export interface ClientServiceAddOnScheduledCancellation {
  __typename?: 'ClientServiceAddOnScheduledCancellation'
  cancellationDate: ScalarsEnums['String']
  chargeAmount?: Maybe<ScalarsEnums['Numeric']>
  chargeMode?: Maybe<ScalarsEnums['ServiceSuspensionChargeMode']>
  serviceCancellationId: ScalarsEnums['String']
}

export interface ClientServiceLastExecutedPlanChange {
  __typename?: 'ClientServiceLastExecutedPlanChange'
  executedAt?: Maybe<ScalarsEnums['String']>
  fromServiceTemplateName?: Maybe<ScalarsEnums['String']>
  initiatedByStaffName?: Maybe<ScalarsEnums['String']>
  servicePlanChangeId: ScalarsEnums['ID']
}

/**
 * A membership plan change held until its pro-rated invoice is paid at checkout
 */
export interface ClientServicePendingPaymentPlanChange {
  __typename?: 'ClientServicePendingPaymentPlanChange'
  effectiveDate: ScalarsEnums['String']
  proratedInvoiceId: ScalarsEnums['ID']
  proratedInvoiceStatus: ScalarsEnums['InvoiceStatus']
  servicePlanChangeId: ScalarsEnums['ID']
  toServiceTemplateId: ScalarsEnums['ID']
  toServiceTemplateName?: Maybe<ScalarsEnums['String']>
}

export interface ClientServiceScheduledPlanChange {
  __typename?: 'ClientServiceScheduledPlanChange'
  effectiveDate: ScalarsEnums['String']
  servicePlanChangeId: ScalarsEnums['ID']
  status: ScalarsEnums['String']
  toServiceTemplateId: ScalarsEnums['ID']
  toServiceTemplateName?: Maybe<ScalarsEnums['String']>
}

export interface ClientServiceScheduledSuspension {
  __typename?: 'ClientServiceScheduledSuspension'
  endDate?: Maybe<ScalarsEnums['String']>
  startDate: ScalarsEnums['String']
}

export interface ClientServiceSharedCredits {
  __typename?: 'ClientServiceSharedCredits'
  allocatedCredits?: Maybe<ScalarsEnums['Float']>
  consumedCredits?: Maybe<ScalarsEnums['Float']>
  isOwner: ScalarsEnums['Boolean']
  maxSharingCredits?: Maybe<ScalarsEnums['Float']>
  ownerClientId: ScalarsEnums['String']
  ownerName?: Maybe<ScalarsEnums['String']>
  recipientNames?: Maybe<Array<ScalarsEnums['String']>>
  remainingCredits?: Maybe<ScalarsEnums['Float']>
}

/**
 * Paginated client services result
 */
export interface ClientServicesPaginationResult {
  __typename?: 'ClientServicesPaginationResult'
  pageInfo: ClientServicesPaginationResultPageInfo
  results: Array<ClientServicesPaginationResultResults>
}

export interface ClientServicesPaginationResultPageInfo {
  __typename?: 'ClientServicesPaginationResultPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface ClientServicesPaginationResultResults {
  __typename?: 'ClientServicesPaginationResultResults'
  cursor: ScalarsEnums['String']
  row: ClientService
}

/**
 * A client-site relationship
 */
export interface ClientSite {
  __typename?: 'ClientSite'
  clientId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  creditAccountBalance?: Maybe<ScalarsEnums['String']>
  favoriteInstructorIds?: Maybe<Array<ScalarsEnums['String']>>
  joinDate: ScalarsEnums['String']
  lastAttendanceDate?: Maybe<ScalarsEnums['String']>
  lastBillingDate?: Maybe<ScalarsEnums['String']>
  lastBookingDate?: Maybe<ScalarsEnums['String']>
  siteId: ScalarsEnums['String']
  siteSpecificData?: Maybe<ClientSiteRelationshipSiteSpecificData>
  updatedAt: ScalarsEnums['String']
}

/**
 * Assigned staff for a client at a site: the open interval and the one before it
 */
export interface ClientSiteAssignedStaff {
  __typename?: 'ClientSiteAssignedStaff'
  current?: Maybe<AssignedStaffEntry>
  previous?: Maybe<AssignedStaffEntry>
}

/**
 * Client site information with site details
 */
export interface ClientSiteInfo {
  __typename?: 'ClientSiteInfo'
  checkInCount: ScalarsEnums['Float']
  joinDate?: Maybe<ScalarsEnums['String']>
  lastCheckInOn?: Maybe<ScalarsEnums['String']>
  site: ClientSiteInfoSite
  siteId: ScalarsEnums['String']
}

export interface ClientSiteInfoSite {
  __typename?: 'ClientSiteInfoSite'
  name: ScalarsEnums['String']
}

/**
 * Client relationship to a specific site
 */
export interface ClientSiteRelationship {
  __typename?: 'ClientSiteRelationship'
  createdAt: ScalarsEnums['String']
  creditAccountBalance?: Maybe<ScalarsEnums['String']>
  joinDate: ScalarsEnums['String']
  lastAttendanceDate?: Maybe<ScalarsEnums['String']>
  lastBillingDate?: Maybe<ScalarsEnums['String']>
  lastBookingDate?: Maybe<ScalarsEnums['String']>
  siteId: ScalarsEnums['String']
  siteSpecificData?: Maybe<ClientSiteRelationshipSiteSpecificData>
  updatedAt: ScalarsEnums['String']
}

export interface ClientSiteRelationshipSiteSpecificData {
  __typename?: 'ClientSiteRelationshipSiteSpecificData'
  enrollmentSource?: Maybe<ScalarsEnums['String']>
  linkSource?: Maybe<ScalarsEnums['ClientSiteLinkSource']>
  membershipType?: Maybe<ScalarsEnums['String']>
  notes?: Maybe<ScalarsEnums['String']>
  preferences?: Maybe<ClientSiteRelationshipSiteSpecificDataPreferences>
  useAccountCreditsOnRecurringInvoices?: Maybe<ScalarsEnums['Boolean']>
}

export interface ClientSiteRelationshipSiteSpecificDataPreferences {
  __typename?: 'ClientSiteRelationshipSiteSpecificDataPreferences'
  communications?: Maybe<ScalarsEnums['String']>
  notifications?: Maybe<ScalarsEnums['Boolean']>
}

/**
 * Response containing client site statistics
 */
export interface ClientSiteStatsResponse {
  __typename?: 'ClientSiteStatsResponse'
  totalClients: ScalarsEnums['Float']
}

/**
 * Response containing client sites
 */
export interface ClientSitesResponse {
  __typename?: 'ClientSitesResponse'
  sites: Array<ClientSitesResponseSites>
}

export interface ClientSitesResponseSites {
  __typename?: 'ClientSitesResponseSites'
  createdAt: ScalarsEnums['String']
  creditAccountBalance?: Maybe<ScalarsEnums['String']>
  favoriteInstructorIds?: Maybe<Array<ScalarsEnums['String']>>
  joinDate: ScalarsEnums['String']
  lastAttendanceDate?: Maybe<ScalarsEnums['String']>
  lastBillingDate?: Maybe<ScalarsEnums['String']>
  lastBookingDate?: Maybe<ScalarsEnums['String']>
  siteId: ScalarsEnums['String']
  siteSpecificData?: Maybe<ClientSiteRelationshipSiteSpecificData>
  updatedAt: ScalarsEnums['String']
}

/**
 * Client attendance and booking statistics
 */
export interface ClientStats {
  __typename?: 'ClientStats'
  /**
   * Date the client joined (ISO format YYYY-MM-DD)
   */
  joinDate: ScalarsEnums['String']
  /**
   * Number of attended sessions in last 30 days
   */
  statsLast30: ScalarsEnums['Float']
  /**
   * Total number of attended sessions (lifetime)
   */
  statsLifetime: ScalarsEnums['Float']
  /**
   * Number of attended sessions in last 7 days
   */
  statsWeekly: ScalarsEnums['Float']
  /**
   * Number of distinct instructors taken classes with
   */
  totalInstructors: ScalarsEnums['Float']
  /**
   * Number of distinct studios/locations visited
   */
  totalLocations: ScalarsEnums['Float']
}

/**
 * Client tab for filtering
 */
export interface ClientTab {
  __typename?: 'ClientTab'
  count: ScalarsEnums['Float']
  description?: Maybe<ScalarsEnums['String']>
  enabled: ScalarsEnums['Boolean']
  id: ScalarsEnums['String']
  label: ScalarsEnums['String']
  name: ScalarsEnums['String']
  value: ScalarsEnums['String']
}

export interface ClientTanningSessionItem {
  __typename?: 'ClientTanningSessionItem'
  cancelledAt?: Maybe<ScalarsEnums['String']>
  checkInId?: Maybe<ScalarsEnums['String']>
  clientId: ScalarsEnums['String']
  dateTime: ScalarsEnums['String']
  doneAt?: Maybe<ScalarsEnums['String']>
  equipmentAssignmentId: ScalarsEnums['String']
  equipmentCategory: ScalarsEnums['String']
  equipmentId: ScalarsEnums['String']
  equipmentName: ScalarsEnums['String']
  siteId: ScalarsEnums['String']
  siteSessionTypeName?: Maybe<ScalarsEnums['String']>
  source?: Maybe<ScalarsEnums['CheckInSource']>
  status: ScalarsEnums['EquipmentAssignmentStatus']
  timerMinutes: ScalarsEnums['Float']
}

export interface ClientTanningSessionResultItem {
  __typename?: 'ClientTanningSessionResultItem'
  cursor: ScalarsEnums['String']
  row: ClientTanningSessionItem
}

export interface ClientTanningSessionsPaginationResult {
  __typename?: 'ClientTanningSessionsPaginationResult'
  pageInfo: TanningPageInfo
  results: Array<ClientTanningSessionResultItem>
}

/**
 * Actor that initiated the timeline event
 */
export interface ClientTimelineActor {
  __typename?: 'ClientTimelineActor'
  email?: Maybe<ScalarsEnums['String']>
  id?: Maybe<ScalarsEnums['String']>
  name?: Maybe<ScalarsEnums['String']>
  type: ScalarsEnums['ClientTimelineActorType']
}

/**
 * Single client timeline event
 */
export interface ClientTimelineEvent {
  __typename?: 'ClientTimelineEvent'
  actor?: Maybe<ClientTimelineActor>
  eventId: ScalarsEnums['String']
  eventType: ScalarsEnums['ClientTimelineEventType']
  occurredAt: ScalarsEnums['String']
  payload?: Maybe<ClientTimelinePayload>
  source: ScalarsEnums['ClientTimelineSource']
}

/**
 * Operational metadata for timeline response
 */
export interface ClientTimelineMetadata {
  __typename?: 'ClientTimelineMetadata'
  durationMs: ScalarsEnums['Float']
  sourcesSkipped: Array<ScalarsEnums['ClientTimelineSource']>
  sourcesUsed: Array<ScalarsEnums['ClientTimelineSource']>
}

/**
 * Pagination metadata for client timeline
 */
export interface ClientTimelinePageInfo {
  __typename?: 'ClientTimelinePageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Float']
}

/**
 * Partial data metadata for timeline response
 */
export interface ClientTimelinePartialData {
  __typename?: 'ClientTimelinePartialData'
  generatedAt: ScalarsEnums['String']
  isPartial: ScalarsEnums['Boolean']
  unavailableSources: Array<ScalarsEnums['ClientTimelineSource']>
}

/**
 * Normalized payload for timeline event details
 */
export interface ClientTimelinePayload {
  __typename?: 'ClientTimelinePayload'
  amount?: Maybe<ScalarsEnums['String']>
  bookingId?: Maybe<ScalarsEnums['String']>
  channel?: Maybe<ScalarsEnums['String']>
  communicationId?: Maybe<ScalarsEnums['String']>
  currency?: Maybe<ScalarsEnums['String']>
  invoiceId?: Maybe<ScalarsEnums['String']>
  location?: Maybe<ScalarsEnums['String']>
  messagePreview?: Maybe<ScalarsEnums['String']>
  messageSubject?: Maybe<ScalarsEnums['String']>
  metadataJson?: Maybe<ScalarsEnums['String']>
  noteId?: Maybe<ScalarsEnums['String']>
  notePreview?: Maybe<ScalarsEnums['String']>
  paymentId?: Maybe<ScalarsEnums['String']>
  platform?: Maybe<ScalarsEnums['ClientTimelinePlatform']>
  platformRaw?: Maybe<ScalarsEnums['String']>
  reason?: Maybe<ScalarsEnums['String']>
  sessionId?: Maybe<ScalarsEnums['String']>
  sessionName?: Maybe<ScalarsEnums['String']>
  sessionStartTime?: Maybe<ScalarsEnums['String']>
  status?: Maybe<ScalarsEnums['String']>
  summary?: Maybe<ScalarsEnums['String']>
  waitlistEntryId?: Maybe<ScalarsEnums['String']>
}

/**
 * Paginated client timeline result
 */
export interface ClientTimelineResult {
  __typename?: 'ClientTimelineResult'
  appliedEventTypes: Array<ScalarsEnums['ClientTimelineEventType']>
  availableEventTypes: Array<ScalarsEnums['ClientTimelineEventType']>
  events: Array<ClientTimelineEvent>
  metadata: ClientTimelineMetadata
  pageInfo: ClientTimelinePageInfo
  partialData: ClientTimelinePartialData
}

/**
 * Lightweight upcoming invoice entry for client membership detail view
 */
export interface ClientUpcomingInvoice {
  __typename?: 'ClientUpcomingInvoice'
  dueDate: ScalarsEnums['String']
  invoiceId: ScalarsEnums['String']
  pendingChange?: Maybe<PendingChange>
  recurringInvoiceId?: Maybe<ScalarsEnums['ID']>
  recurringInvoiceStatus?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['String']
  totalAmount: ScalarsEnums['String']
}

/**
 * Result for client upcoming invoices query
 */
export interface ClientUpcomingInvoicesResult {
  __typename?: 'ClientUpcomingInvoicesResult'
  results: Array<ClientUpcomingInvoice>
}

/**
 * Paginated clients result with user permissions and enabled filters
 */
export interface ClientsResult {
  __typename?: 'ClientsResult'
  enabledFilters?: Maybe<EnabledFilters>
  hasAnyBarcode?: Maybe<ScalarsEnums['Boolean']>
  pageInfo: ClientsResultPageInfo
  permissions: ClientPermissions
  results: Array<ClientsResultResults>
}

export interface ClientsResultPageInfo {
  __typename?: 'ClientsResultPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface ClientsResultResults {
  __typename?: 'ClientsResultResults'
  cursor: ScalarsEnums['String']
  row: Client
}

/**
 * The outcome of cancelling one session for a closure; failures never stop the rest
 */
export interface ClosureSessionCancellationResult {
  __typename?: 'ClosureSessionCancellationResult'
  errorCode?: Maybe<ScalarsEnums['String']>
  errorMessage?: Maybe<ScalarsEnums['String']>
  isCancelled: ScalarsEnums['Boolean']
  sessionId: ScalarsEnums['String']
}

/**
 * Carousel group definition for organizing content entries into slideshows
 */
export interface CmsCarouselGroup {
  __typename?: 'CmsCarouselGroup'
  carouselGroupId: ScalarsEnums['ID']
  corporateId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  name: ScalarsEnums['String']
  slug: ScalarsEnums['String']
  updatedAt: ScalarsEnums['String']
}

/**
 * Category tree node with subcategories and content counts
 */
export interface CmsCatalogCategory {
  __typename?: 'CmsCatalogCategory'
  contentCount: ScalarsEnums['Float']
  id: ScalarsEnums['ID']
  sortOrder: ScalarsEnums['Float']
  subcategories: Array<CmsCatalogCategorySubcategories>
  tags: Array<ScalarsEnums['String']>
  title: ScalarsEnums['String']
}

export interface CmsCatalogCategorySubcategories {
  __typename?: 'CmsCatalogCategorySubcategories'
  contentCount: ScalarsEnums['Float']
  description?: Maybe<ScalarsEnums['String']>
  id: ScalarsEnums['String']
  image?: Maybe<CmsCatalogCategorySubcategoriesImage>
  sortOrder: ScalarsEnums['Float']
  title: ScalarsEnums['String']
}

export interface CmsCatalogCategorySubcategoriesImage {
  __typename?: 'CmsCatalogCategorySubcategoriesImage'
  alt?: Maybe<ScalarsEnums['String']>
  url: ScalarsEnums['String']
}

/**
 * Flat paginated result for published content catalog queries
 */
export interface CmsCatalogResult {
  __typename?: 'CmsCatalogResult'
  cursor?: Maybe<ScalarsEnums['String']>
  hasMore: ScalarsEnums['Boolean']
  items: Array<CmsContentEntry>
  totalCount: ScalarsEnums['Float']
}

/**
 * Polymorphic content entry storing all 25 content types
 */
export interface CmsContentEntry {
  __typename?: 'CmsContentEntry'
  bodyHtml?: Maybe<ScalarsEnums['String']>
  bodyMarkdown?: Maybe<ScalarsEnums['String']>
  contentEntryId: ScalarsEnums['ID']
  contentTypeId: ScalarsEnums['ID']
  corporateId: ScalarsEnums['ID']
  coverMediaId?: Maybe<ScalarsEnums['ID']>
  createdAt: ScalarsEnums['String']
  createdAtLevel: ScalarsEnums['ContentEntryLevel']
  createdAtSiteId?: Maybe<ScalarsEnums['ID']>
  createdBy: ScalarsEnums['ID']
  createdByName?: Maybe<ScalarsEnums['String']>
  deletedAt?: Maybe<ScalarsEnums['String']>
  excludedRegionIds?: Maybe<Array<ScalarsEnums['ID']>>
  excludedSiteIds?: Maybe<Array<ScalarsEnums['ID']>>
  externalSource?: Maybe<ScalarsEnums['String']>
  fields?: Maybe<ScalarsEnums['JSONObject']>
  imageAlt?: Maybe<ScalarsEnums['String']>
  imageMetadata?: Maybe<CmsContentEntryImageMetadata>
  imageUrl?: Maybe<ScalarsEnums['String']>
  includedRegionIds?: Maybe<Array<ScalarsEnums['ID']>>
  includedSiteIds?: Maybe<Array<ScalarsEnums['ID']>>
  instructorIds?: Maybe<Array<ScalarsEnums['ID']>>
  packageExclusionIds?: Maybe<Array<ScalarsEnums['ID']>>
  packageExclusionNames?: Maybe<Array<ScalarsEnums['String']>>
  packageIds?: Maybe<Array<ScalarsEnums['ID']>>
  packageNames?: Maybe<Array<ScalarsEnums['String']>>
  publishedAt?: Maybe<ScalarsEnums['String']>
  publishedByName?: Maybe<ScalarsEnums['String']>
  publishedVersionId?: Maybe<ScalarsEnums['ID']>
  slug?: Maybe<ScalarsEnums['String']>
  sortOrder: ScalarsEnums['Float']
  status: ScalarsEnums['ContentStatus']
  title: ScalarsEnums['String']
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['ID']>
  updatedByName?: Maybe<ScalarsEnums['String']>
  version: ScalarsEnums['Float']
  visibilityScope: ScalarsEnums['VisibilityScope']
}

export interface CmsContentEntryImageMetadata {
  __typename?: 'CmsContentEntryImageMetadata'
  focalPoint?: Maybe<CmsContentEntryImageMetadataFocalPoint>
  format?: Maybe<ScalarsEnums['String']>
  gcsPath?: Maybe<ScalarsEnums['String']>
  height?: Maybe<ScalarsEnums['Float']>
  variants?: Maybe<ScalarsEnums['JSONObject']>
  width?: Maybe<ScalarsEnums['Float']>
}

export interface CmsContentEntryImageMetadataFocalPoint {
  __typename?: 'CmsContentEntryImageMetadataFocalPoint'
  x: ScalarsEnums['Float']
  y: ScalarsEnums['Float']
}

/**
 * Media asset in the content library (image, video, audio, or document)
 */
export interface CmsContentMedia {
  __typename?: 'CmsContentMedia'
  blurhash?: Maybe<ScalarsEnums['String']>
  contentMediaId: ScalarsEnums['ID']
  corporateId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  createdByStaffUserId: ScalarsEnums['ID']
  createdByStaffUserName?: Maybe<ScalarsEnums['String']>
  deletedAt?: Maybe<ScalarsEnums['String']>
  description?: Maybe<ScalarsEnums['String']>
  duration?: Maybe<ScalarsEnums['Float']>
  fileName: ScalarsEnums['String']
  fileSize?: Maybe<ScalarsEnums['Float']>
  focalPoint?: Maybe<CmsContentEntryImageMetadataFocalPoint>
  folder?: Maybe<ScalarsEnums['String']>
  gcsPath?: Maybe<ScalarsEnums['String']>
  height?: Maybe<ScalarsEnums['Float']>
  hlsManifestUrl?: Maybe<ScalarsEnums['String']>
  mimeType: ScalarsEnums['String']
  mp4Url?: Maybe<ScalarsEnums['String']>
  processingStatus?: Maybe<ScalarsEnums['String']>
  source?: Maybe<ScalarsEnums['ContentVideoSource']>
  thumbnailUrl?: Maybe<ScalarsEnums['String']>
  title?: Maybe<ScalarsEnums['String']>
  transcoderJobId?: Maybe<ScalarsEnums['String']>
  updatedAt?: Maybe<ScalarsEnums['String']>
  updatedByStaffUserId?: Maybe<ScalarsEnums['ID']>
  updatedByStaffUserName?: Maybe<ScalarsEnums['String']>
  uploadUrl?: Maybe<ScalarsEnums['String']>
  url?: Maybe<ScalarsEnums['String']>
  usageCount?: Maybe<ScalarsEnums['Float']>
  variants?: Maybe<ScalarsEnums['JSONObject']>
  width?: Maybe<ScalarsEnums['Float']>
}

/**
 * Scheduled publish or unpublish action for a content entry
 */
export interface CmsContentSchedule {
  __typename?: 'CmsContentSchedule'
  action: ScalarsEnums['ScheduleAction']
  contentEntryId: ScalarsEnums['ID']
  contentScheduleId: ScalarsEnums['ID']
  contentVersionId?: Maybe<ScalarsEnums['ID']>
  corporateId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  createdBy: ScalarsEnums['ID']
  createdByName?: Maybe<ScalarsEnums['String']>
  executedAt?: Maybe<ScalarsEnums['String']>
  scheduledAt: ScalarsEnums['String']
}

/**
 * Target entity for content entry visibility (site, site group, or region)
 */
export interface CmsContentTarget {
  __typename?: 'CmsContentTarget'
  contentEntryId: ScalarsEnums['ID']
  contentTargetId: ScalarsEnums['ID']
  corporateId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  targetId: ScalarsEnums['ID']
  targetType: ScalarsEnums['TargetType']
}

/**
 * System-defined content type with field schema for validation and UI rendering
 */
export interface CmsContentType {
  __typename?: 'CmsContentType'
  contentTypeId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  defaultFields?: Maybe<ScalarsEnums['JSONObject']>
  fieldSchema: ScalarsEnums['JSONObject']
  groupName: ScalarsEnums['ContentTypeGroup']
  iconName?: Maybe<ScalarsEnums['String']>
  isSystem: ScalarsEnums['Boolean']
  name: ScalarsEnums['String']
  slug: ScalarsEnums['String']
  sortOrder: ScalarsEnums['Float']
  updatedAt: ScalarsEnums['String']
}

/**
 * Immutable version snapshot of a content entry
 */
export interface CmsContentVersion {
  __typename?: 'CmsContentVersion'
  bodyHtml?: Maybe<ScalarsEnums['String']>
  bodyMarkdown?: Maybe<ScalarsEnums['String']>
  changeNote?: Maybe<ScalarsEnums['String']>
  contentEntryId: ScalarsEnums['ID']
  contentVersionId: ScalarsEnums['ID']
  corporateId: ScalarsEnums['ID']
  coverMediaId?: Maybe<ScalarsEnums['ID']>
  createdAt: ScalarsEnums['String']
  createdBy: ScalarsEnums['ID']
  createdByName?: Maybe<ScalarsEnums['String']>
  excludedRegionIds?: Maybe<Array<ScalarsEnums['ID']>>
  excludedSiteIds?: Maybe<Array<ScalarsEnums['ID']>>
  fields?: Maybe<ScalarsEnums['JSONObject']>
  imageMetadata?: Maybe<CmsContentEntryImageMetadata>
  imageUrl?: Maybe<ScalarsEnums['String']>
  includedRegionIds?: Maybe<Array<ScalarsEnums['ID']>>
  includedSiteIds?: Maybe<Array<ScalarsEnums['ID']>>
  instructorIds?: Maybe<Array<ScalarsEnums['ID']>>
  packageExclusionIds?: Maybe<Array<ScalarsEnums['ID']>>
  packageExclusionNames?: Maybe<Array<ScalarsEnums['String']>>
  packageIds?: Maybe<Array<ScalarsEnums['ID']>>
  packageNames?: Maybe<Array<ScalarsEnums['String']>>
  sortOrder?: Maybe<ScalarsEnums['Float']>
  title: ScalarsEnums['String']
  versionNumber: ScalarsEnums['Float']
  visibilityScope?: Maybe<ScalarsEnums['VisibilityScope']>
}

/**
 * Goal definition for challenge daily goals
 */
export interface CmsGoal {
  __typename?: 'CmsGoal'
  corporateId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  goalId: ScalarsEnums['ID']
  name: ScalarsEnums['String']
  sortOrder: ScalarsEnums['Float']
  updatedAt: ScalarsEnums['String']
}

/**
 * Whether Contentful has a stored management token, and its default space id
 */
export interface CmsImportContentfulConfig {
  __typename?: 'CmsImportContentfulConfig'
  configured: ScalarsEnums['Boolean']
  spaceId?: Maybe<ScalarsEnums['String']>
}

/**
 * A Contentful space available to export from
 */
export interface CmsImportContentfulSpace {
  __typename?: 'CmsImportContentfulSpace'
  id: ScalarsEnums['String']
  name: ScalarsEnums['String']
}

/**
 * A JW Player property/site available to import from
 */
export interface CmsImportJwPlayerSite {
  __typename?: 'CmsImportJwPlayerSite'
  id: ScalarsEnums['String']
  name: ScalarsEnums['String']
}

/**
 * Whether JW Player has a stored key, and its available properties
 */
export interface CmsImportJwPlayerSitesResult {
  __typename?: 'CmsImportJwPlayerSitesResult'
  configured: ScalarsEnums['Boolean']
  sites: Array<CmsImportJwPlayerSite>
}

/**
 * A brand available to migrate from the legacy MongoDB
 */
export interface CmsImportLegacyMongoBrand {
  __typename?: 'CmsImportLegacyMongoBrand'
  challengesV1: ScalarsEnums['Float']
  challengesV2: ScalarsEnums['Float']
  legacyCorporateId: ScalarsEnums['String']
  legacyCorporateName?: Maybe<ScalarsEnums['String']>
}

/**
 * Legacy MongoDB brands available to this corporate, with the saved link and auto-matched suggestion
 */
export interface CmsImportLegacyMongoBrandOptions {
  __typename?: 'CmsImportLegacyMongoBrandOptions'
  brands: Array<CmsImportLegacyMongoBrand>
  savedLegacyCorporateId?: Maybe<ScalarsEnums['String']>
  suggestedLegacyCorporateId?: Maybe<ScalarsEnums['String']>
}

/**
 * A content import run tracking the migration from legacy systems
 */
export interface CmsImportRun {
  __typename?: 'CmsImportRun'
  completedAt?: Maybe<ScalarsEnums['String']>
  corporateId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  createdBy: ScalarsEnums['String']
  createdByName?: Maybe<ScalarsEnums['String']>
  importMode: ScalarsEnums['CmsImportMode']
  importRunId: ScalarsEnums['String']
  rolledBackAt?: Maybe<ScalarsEnums['String']>
  sources?: Maybe<ScalarsEnums['JSONObject']>
  startedAt?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['CmsImportRunStatus']
  summary?: Maybe<ScalarsEnums['JSONObject']>
  updatedAt: ScalarsEnums['String']
}

export interface CmsImportRunGenerateUploadUrl {
  __typename?: 'CmsImportRunGenerateUploadUrl'
  gcsPath: ScalarsEnums['String']
  uploadUrl: ScalarsEnums['String']
}

/**
 * A preview item showing how source data maps to native content
 */
export interface CmsImportRunPreview {
  __typename?: 'CmsImportRunPreview'
  changeType?: Maybe<ScalarsEnums['CmsImportChangeType']>
  createdAt: ScalarsEnums['String']
  importRunId: ScalarsEnums['String']
  manualOverride?: Maybe<ScalarsEnums['JSONObject']>
  mappedData?: Maybe<ScalarsEnums['JSONObject']>
  mappingNotes?: Maybe<Array<ScalarsEnums['JSONObject']>>
  mappingStatus: ScalarsEnums['CmsImportMappingStatus']
  previewId: ScalarsEnums['String']
  sourceData?: Maybe<ScalarsEnums['JSONObject']>
  sourceId: ScalarsEnums['String']
  sourceSystem: ScalarsEnums['String']
  sourceType?: Maybe<ScalarsEnums['String']>
}

export interface CmsImportRunPreviews {
  __typename?: 'CmsImportRunPreviews'
  items: Array<CmsImportRunPreview>
  total: ScalarsEnums['Float']
}

/**
 * A single step within a content import run
 */
export interface CmsImportRunStep {
  __typename?: 'CmsImportRunStep'
  completedAt?: Maybe<ScalarsEnums['String']>
  createdAt: ScalarsEnums['String']
  currentItem?: Maybe<ScalarsEnums['String']>
  errors?: Maybe<Array<CmsImportRunStepErrors>>
  failedItems?: Maybe<ScalarsEnums['Float']>
  importRunId: ScalarsEnums['String']
  importRunStepId: ScalarsEnums['String']
  processedItems?: Maybe<ScalarsEnums['Float']>
  skippedItems?: Maybe<ScalarsEnums['Float']>
  sortOrder: ScalarsEnums['Float']
  startedAt?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['CmsImportStepStatus']
  stepType: ScalarsEnums['CmsImportStepType']
  totalItems?: Maybe<ScalarsEnums['Float']>
  updatedAt: ScalarsEnums['String']
  warnings?: Maybe<Array<CmsImportRunStepWarnings>>
}

export interface CmsImportRunStepErrors {
  __typename?: 'CmsImportRunStepErrors'
  attempt?: Maybe<ScalarsEnums['Float']>
  category?: Maybe<ScalarsEnums['String']>
  error: ScalarsEnums['String']
  itemId: ScalarsEnums['String']
  timestamp: ScalarsEnums['String']
}

export interface CmsImportRunStepWarnings {
  __typename?: 'CmsImportRunStepWarnings'
  itemId: ScalarsEnums['String']
  message: ScalarsEnums['String']
  timestamp: ScalarsEnums['String']
}

/**
 * A content import run with its steps attached
 */
export interface CmsImportRunWithSteps {
  __typename?: 'CmsImportRunWithSteps'
  completedAt?: Maybe<ScalarsEnums['String']>
  corporateId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  createdBy: ScalarsEnums['String']
  createdByName?: Maybe<ScalarsEnums['String']>
  importMode: ScalarsEnums['CmsImportMode']
  importRunId: ScalarsEnums['String']
  rollbackInProgress: ScalarsEnums['Boolean']
  rollbackProcessedCount?: Maybe<ScalarsEnums['Float']>
  rollbackTotalCount?: Maybe<ScalarsEnums['Float']>
  rolledBackAt?: Maybe<ScalarsEnums['String']>
  sources?: Maybe<ScalarsEnums['JSONObject']>
  startedAt?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['CmsImportRunStatus']
  steps: Array<CmsImportRunStep>
  summary?: Maybe<ScalarsEnums['JSONObject']>
  updatedAt: ScalarsEnums['String']
}

/**
 * A brand available to migrate from the V1 Aurora database
 */
export interface CmsImportV1AuroraBrand {
  __typename?: 'CmsImportV1AuroraBrand'
  connectedSiteCount: ScalarsEnums['Int']
  isActive: ScalarsEnums['Boolean']
  name?: Maybe<ScalarsEnums['String']>
  slug?: Maybe<ScalarsEnums['String']>
  streaksEnabled: ScalarsEnums['Boolean']
  v1CorporateId: ScalarsEnums['Int']
}

/**
 * V1 Aurora brands available to this corporate, with the saved link and auto-matched suggestion
 */
export interface CmsImportV1AuroraBrandOptions {
  __typename?: 'CmsImportV1AuroraBrandOptions'
  brands: Array<CmsImportV1AuroraBrand>
  savedV1CorporateId?: Maybe<ScalarsEnums['Int']>
  suggestedV1CorporateId?: Maybe<ScalarsEnums['Int']>
}

export interface CodebaseSyncStats {
  __typename?: 'CodebaseSyncStats'
  documentsFailed: ScalarsEnums['Int']
  documentsProcessed: ScalarsEnums['Int']
  documentsStored: ScalarsEnums['Int']
}

export interface CommissionActivationResult {
  __typename?: 'CommissionActivationResult'
  activationDate: ScalarsEnums['String']
  firstPeriodId: ScalarsEnums['ID']
  schedulersRegistered: ScalarsEnums['Boolean']
}

export interface CommissionAdjustmentStaff {
  __typename?: 'CommissionAdjustmentStaff'
  name: ScalarsEnums['String']
  staffUserId: ScalarsEnums['ID']
}

export interface CommissionAssignment {
  __typename?: 'CommissionAssignment'
  commissionAssignmentId: ScalarsEnums['ID']
  commissionPlanId: ScalarsEnums['ID']
  earnerRole: ScalarsEnums['CommissionEarnerRole']
  endDate?: Maybe<ScalarsEnums['String']>
  managerScope?: Maybe<ScalarsEnums['CommissionManagerScope']>
  overrides: ScalarsEnums['JSONObject']
  siteIds: Array<ScalarsEnums['ID']>
  staffUserId: ScalarsEnums['ID']
  startDate: ScalarsEnums['String']
  teamStaffUserIds: Array<ScalarsEnums['ID']>
}

export interface CommissionAttributionHistoryEntry {
  __typename?: 'CommissionAttributionHistoryEntry'
  changedBy?: Maybe<ScalarsEnums['String']>
  effectiveFrom: ScalarsEnums['String']
  mode: ScalarsEnums['String']
  reason?: Maybe<ScalarsEnums['String']>
  sellerStaffUserId?: Maybe<ScalarsEnums['ID']>
  source: ScalarsEnums['String']
}

export interface CommissionAttributionResolutionResult {
  __typename?: 'CommissionAttributionResolutionResult'
  resolved: ScalarsEnums['Int']
  skipped: Array<ScalarsEnums['ID']>
}

export interface CommissionCard {
  __typename?: 'CommissionCard'
  carriedFromServiceId?: Maybe<ScalarsEnums['ID']>
  chainRootServiceId: ScalarsEnums['ID']
  committedCycles?: Maybe<ScalarsEnums['Int']>
  contractValue?: Maybe<ScalarsEnums['String']>
  earners: Array<CommissionCardEarner>
  history: Array<CommissionAttributionHistoryEntry>
  ownerStaffUserId?: Maybe<ScalarsEnums['ID']>
  paidToDate: ScalarsEnums['String']
  serviceId: ScalarsEnums['ID']
  since: ScalarsEnums['String']
  source: ScalarsEnums['String']
  upfront?: Maybe<CommissionUpfront>
}

export interface CommissionCardEarner {
  __typename?: 'CommissionCardEarner'
  earnerRole: ScalarsEnums['String']
  staffUserId: ScalarsEnums['ID']
  total: ScalarsEnums['String']
}

/**
 * Commission dashboard for one pay period, compared with the period before it
 */
export interface CommissionDashboard {
  __typename?: 'CommissionDashboard'
  appliedSiteIds: Array<ScalarsEnums['String']>
  categoryOptions: Array<ScalarsEnums['String']>
  current: CommissionDashboardTotals
  employees: Array<CommissionDashboardEmployee>
  period?: Maybe<CommissionDashboardPeriod>
  periods: Array<CommissionDashboardPeriod>
  plans: Array<CommissionDashboardPlan>
  previous?: Maybe<CommissionDashboardTotals>
  previousPeriod?: Maybe<CommissionDashboardPeriod>
  sites: Array<CommissionDashboardSite>
  staffOptions: Array<CommissionDashboardStaffOption>
  transactions: Array<CommissionDashboardTransaction>
  transactionsTruncated: ScalarsEnums['Boolean']
}

export interface CommissionDashboardCategory {
  __typename?: 'CommissionDashboardCategory'
  category: ScalarsEnums['String']
  commission: ScalarsEnums['Float']
  commissionableSales: ScalarsEnums['Float']
}

/**
 * One staff member’s commission for the selected pay period
 */
export interface CommissionDashboardEmployee {
  __typename?: 'CommissionDashboardEmployee'
  adjustments: ScalarsEnums['Float']
  carried: ScalarsEnums['Float']
  categories: Array<CommissionDashboardCategory>
  clawbacks: ScalarsEnums['Float']
  commissionableSales: ScalarsEnums['Float']
  earned: ScalarsEnums['Float']
  earnerRoles: Array<ScalarsEnums['String']>
  effectiveRate?: Maybe<ScalarsEnums['Float']>
  lateLines: ScalarsEnums['Float']
  name: ScalarsEnums['String']
  planNames: Array<ScalarsEnums['String']>
  projectedTierAdjustment: ScalarsEnums['Float']
  reviewReasons: Array<ScalarsEnums['CommissionDashboardReviewReason']>
  staffUserId: ScalarsEnums['String']
  status: ScalarsEnums['CommissionDashboardEmployeeStatus']
  tierAdjustment: ScalarsEnums['Float']
  totalCommission: ScalarsEnums['Float']
  transactions: ScalarsEnums['Float']
}

/**
 * A pay period with its first and last local dates
 */
export interface CommissionDashboardPeriod {
  __typename?: 'CommissionDashboardPeriod'
  commissionPeriodId: ScalarsEnums['String']
  endDate: ScalarsEnums['String']
  hasLines: ScalarsEnums['Boolean']
  startDate: ScalarsEnums['String']
  status: ScalarsEnums['String']
}

/**
 * An active commission plan and the rates in its current version
 */
export interface CommissionDashboardPlan {
  __typename?: 'CommissionDashboardPlan'
  assignedStaff: ScalarsEnums['Float']
  commissionPlanId: ScalarsEnums['String']
  earnerRole: ScalarsEnums['String']
  name: ScalarsEnums['String']
  rates: Array<CommissionDashboardPlanRate>
  scope: ScalarsEnums['String']
}

export interface CommissionDashboardPlanRate {
  __typename?: 'CommissionDashboardPlanRate'
  category: ScalarsEnums['String']
  type: ScalarsEnums['String']
  value?: Maybe<ScalarsEnums['Float']>
}

export interface CommissionDashboardSite {
  __typename?: 'CommissionDashboardSite'
  name: ScalarsEnums['String']
  siteId: ScalarsEnums['String']
}

export interface CommissionDashboardStaffOption {
  __typename?: 'CommissionDashboardStaffOption'
  name: ScalarsEnums['String']
  staffUserId: ScalarsEnums['String']
}

/**
 * Headline figures for one pay period
 */
export interface CommissionDashboardTotals {
  __typename?: 'CommissionDashboardTotals'
  averageRate?: Maybe<ScalarsEnums['Float']>
  blockedEvents: ScalarsEnums['Float']
  commissionableSales: ScalarsEnums['Float']
  needsReview: ScalarsEnums['Float']
  projectedTierAdjustment: ScalarsEnums['Float']
  totalCommission: ScalarsEnums['Float']
  unattributedSales: ScalarsEnums['Float']
}

/**
 * One commission line in the selected pay period
 */
export interface CommissionDashboardTransaction {
  __typename?: 'CommissionDashboardTransaction'
  amount: ScalarsEnums['Float']
  baseAmount: ScalarsEnums['Float']
  category: ScalarsEnums['String']
  clientName?: Maybe<ScalarsEnums['String']>
  commissionLineId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  earnerRole: ScalarsEnums['String']
  invoiceId?: Maybe<ScalarsEnums['String']>
  isLate: ScalarsEnums['Boolean']
  kind: ScalarsEnums['String']
  planName?: Maybe<ScalarsEnums['String']>
  rateType?: Maybe<ScalarsEnums['String']>
  rateValue?: Maybe<ScalarsEnums['Float']>
  reason?: Maybe<ScalarsEnums['String']>
  siteName?: Maybe<ScalarsEnums['String']>
  siteTimezone: ScalarsEnums['String']
  source?: Maybe<ScalarsEnums['String']>
  staffName: ScalarsEnums['String']
  staffUserId: ScalarsEnums['String']
}

export interface CommissionEligibility {
  __typename?: 'CommissionEligibility'
  commissionRolePolicyId?: Maybe<ScalarsEnums['ID']>
  endDate?: Maybe<ScalarsEnums['String']>
  staffUserId: ScalarsEnums['ID']
  startDate: ScalarsEnums['String']
}

export interface CommissionEnablement {
  __typename?: 'CommissionEnablement'
  effectiveFrom?: Maybe<ScalarsEnums['String']>
  enabled: ScalarsEnums['Boolean']
  graceUntil?: Maybe<ScalarsEnums['String']>
  reason?: Maybe<ScalarsEnums['CommissionEnablementReason']>
}

export interface CommissionEventSummary {
  __typename?: 'CommissionEventSummary'
  attempts: ScalarsEnums['Int']
  commissionEventId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  eventTime: ScalarsEnums['String']
  kind: ScalarsEnums['CommissionEventKind']
  reason?: Maybe<ScalarsEnums['String']>
  siteId: ScalarsEnums['ID']
  sourceId: ScalarsEnums['String']
  status: ScalarsEnums['CommissionEventStatus']
}

export interface CommissionExportRevisionSummary {
  __typename?: 'CommissionExportRevisionSummary'
  createdAt: ScalarsEnums['String']
  createdBy?: Maybe<ScalarsEnums['String']>
  gcsPath?: Maybe<ScalarsEnums['String']>
  revision: ScalarsEnums['Int']
}

export interface CommissionItemSetting {
  __typename?: 'CommissionItemSetting'
  isCommissionable: ScalarsEnums['Boolean']
  itemId: ScalarsEnums['String']
  itemType: ScalarsEnums['CommissionItemType']
  requireSoldBy: ScalarsEnums['Boolean']
  source: ScalarsEnums['CommissionItemSettingSource']
}

export interface CommissionJobRun {
  __typename?: 'CommissionJobRun'
  commissionJobRunId: ScalarsEnums['ID']
  createdBy?: Maybe<ScalarsEnums['String']>
  finishedAt?: Maybe<ScalarsEnums['String']>
  gcsPath?: Maybe<ScalarsEnums['String']>
  kind: ScalarsEnums['String']
  startedAt: ScalarsEnums['String']
  status: ScalarsEnums['String']
  summary?: Maybe<ScalarsEnums['JSONObject']>
}

export interface CommissionLine {
  __typename?: 'CommissionLine'
  amount: ScalarsEnums['String']
  category?: Maybe<ScalarsEnums['CommissionCategory']>
  commissionLineId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  createdBy?: Maybe<ScalarsEnums['String']>
  earnedPeriodId: ScalarsEnums['ID']
  earnerRole: ScalarsEnums['String']
  invoiceItemId?: Maybe<ScalarsEnums['ID']>
  isLate: ScalarsEnums['Boolean']
  kind: ScalarsEnums['CommissionLineKind']
  periodId: ScalarsEnums['ID']
  reason?: Maybe<ScalarsEnums['String']>
  serviceId?: Maybe<ScalarsEnums['ID']>
  siteId: ScalarsEnums['ID']
  staffUserId: ScalarsEnums['ID']
}

export interface CommissionPeriod {
  __typename?: 'CommissionPeriod'
  autoCloseAt: ScalarsEnums['String']
  closedAt?: Maybe<ScalarsEnums['String']>
  closedBy?: Maybe<ScalarsEnums['String']>
  closingRevision?: Maybe<ScalarsEnums['Int']>
  commissionPeriodId: ScalarsEnums['ID']
  endAt: ScalarsEnums['String']
  gate?: Maybe<CommissionPeriodGate>
  label: ScalarsEnums['String']
  latestRevision: ScalarsEnums['Int']
  paidAt?: Maybe<ScalarsEnums['String']>
  paidBy?: Maybe<ScalarsEnums['String']>
  paidRevision?: Maybe<ScalarsEnums['Int']>
  reopenedAt?: Maybe<ScalarsEnums['String']>
  reopenedBy?: Maybe<ScalarsEnums['String']>
  revisions?: Maybe<Array<CommissionExportRevisionSummary>>
  startAt: ScalarsEnums['String']
  status: ScalarsEnums['CommissionPeriodStatus']
  timezone: ScalarsEnums['String']
}

export interface CommissionPeriodGate {
  __typename?: 'CommissionPeriodGate'
  blockingEvents: ScalarsEnums['Int']
  passed: ScalarsEnums['Boolean']
  reconciledAfterEnd: ScalarsEnums['Boolean']
}

export interface CommissionPlan {
  __typename?: 'CommissionPlan'
  commissionPlanId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  currentVersion?: Maybe<CommissionPlanVersion>
  duplicatedFromPlanId?: Maybe<ScalarsEnums['ID']>
  earnerRole: ScalarsEnums['CommissionEarnerRole']
  name: ScalarsEnums['String']
  readOnly: ScalarsEnums['Boolean']
  scope: ScalarsEnums['CommissionPlanScope']
  siteIds: Array<ScalarsEnums['ID']>
  status: ScalarsEnums['CommissionPlanStatus']
  upcomingVersions: Array<CommissionPlanVersion>
  updatedAt: ScalarsEnums['String']
}

export interface CommissionPlanAvailabilityChange {
  __typename?: 'CommissionPlanAvailabilityChange'
  plan: CommissionPlan
  stillAssignedStaffUserIds: Array<ScalarsEnums['ID']>
}

export interface CommissionPlanVersion {
  __typename?: 'CommissionPlanVersion'
  commissionPlanVersionId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  createdBy?: Maybe<ScalarsEnums['String']>
  data: ScalarsEnums['JSONObject']
  effectiveFrom: ScalarsEnums['String']
}

export interface CommissionPreflight {
  __typename?: 'CommissionPreflight'
  activeAgreements: ScalarsEnums['Int']
  blockedReason?: Maybe<ScalarsEnums['String']>
  currencies: Array<ScalarsEnums['String']>
  referrerShare: ScalarsEnums['String']
  withReferrer: ScalarsEnums['Int']
}

export interface CommissionRecalcSummary {
  __typename?: 'CommissionRecalcSummary'
  linesReversed: ScalarsEnums['Int']
  linesWritten: ScalarsEnums['Int']
  paymentsRecalculated: ScalarsEnums['Int']
  recalcRevision?: Maybe<ScalarsEnums['ID']>
}

export interface CommissionRoleDefault {
  __typename?: 'CommissionRoleDefault'
  commissionPlanId: ScalarsEnums['ID']
  endDate?: Maybe<ScalarsEnums['String']>
  scopeKey: ScalarsEnums['String']
  staffAccessPolicyId: ScalarsEnums['ID']
  startDate: ScalarsEnums['String']
}

export interface CommissionSettings {
  __typename?: 'CommissionSettings'
  accountCreditEarns: ScalarsEnums['Boolean']
  activationDate?: Maybe<ScalarsEnums['String']>
  anchorDate: ScalarsEnums['String']
  attributionSource: ScalarsEnums['CommissionAttributionSourceSetting']
  autoCloseDays: ScalarsEnums['Float']
  base: ScalarsEnums['CommissionBase']
  clawbackDays?: Maybe<ScalarsEnums['Float']>
  configured: ScalarsEnums['Boolean']
  contractMonthsOpenEnded: ScalarsEnums['Float']
  enforceSoldByOnServer: ScalarsEnums['Boolean']
  leaverRule: ScalarsEnums['CommissionLeaverRule']
  managerDoubleEarn: ScalarsEnums['Boolean']
  netNegativeBalances: ScalarsEnums['Boolean']
  periodLength: ScalarsEnums['CommissionPeriodLength']
  rolePriority: Array<ScalarsEnums['ID']>
  timezone: ScalarsEnums['String']
}

export interface CommissionSiteSettings {
  __typename?: 'CommissionSiteSettings'
  onlineDefaultSellerStaffUserId?: Maybe<ScalarsEnums['ID']>
  siteId: ScalarsEnums['ID']
}

export interface CommissionStaffEntry {
  __typename?: 'CommissionStaffEntry'
  assignments: Array<CommissionAssignment>
  commissionRolePolicyId?: Maybe<ScalarsEnums['ID']>
  commissionRolePolicyName?: Maybe<ScalarsEnums['String']>
  eligibilityEndDate?: Maybe<ScalarsEnums['String']>
  eligibilityStartDate?: Maybe<ScalarsEnums['String']>
  holdsMultipleCommissionRoles: ScalarsEnums['Boolean']
  isActive: ScalarsEnums['Boolean']
  isServiceAccount: ScalarsEnums['Boolean']
  name: ScalarsEnums['String']
  payrollId?: Maybe<ScalarsEnums['String']>
  planId?: Maybe<ScalarsEnums['ID']>
  planName?: Maybe<ScalarsEnums['String']>
  planSource: ScalarsEnums['CommissionPlanSource']
  siteIds: Array<ScalarsEnums['ID']>
  staffUserId: ScalarsEnums['ID']
}

export interface CommissionUnresolvedAttribution {
  __typename?: 'CommissionUnresolvedAttribution'
  chainRootServiceId: ScalarsEnums['ID']
  clientName?: Maybe<ScalarsEnums['String']>
  effectiveFrom: ScalarsEnums['String']
  itemName?: Maybe<ScalarsEnums['String']>
  purchasedAt?: Maybe<ScalarsEnums['String']>
  serviceId: ScalarsEnums['ID']
  siteId: ScalarsEnums['ID']
  source: ScalarsEnums['String']
}

export interface CommissionUpfront {
  __typename?: 'CommissionUpfront'
  amount: ScalarsEnums['String']
  recovered: ScalarsEnums['String']
}

/**
 * A communication template for admin messaging
 */
export interface CommunicationTemplate {
  __typename?: 'CommunicationTemplate'
  alias: ScalarsEnums['CommunicationTemplateAliases']
  allowedPlaceholders: Array<ScalarsEnums['CommunicationTemplatePlaceholders']>
  communicationTemplateId: ScalarsEnums['String']
  createdAt?: Maybe<ScalarsEnums['String']>
  emailBody: ScalarsEnums['String']
  emailCcEmail?: Maybe<ScalarsEnums['String']>
  emailCcLocation: ScalarsEnums['Boolean']
  emailCopyEmployee: ScalarsEnums['EmailCopyEmployee']
  emailDefaultOn: ScalarsEnums['Boolean']
  emailEnabled: ScalarsEnums['Boolean']
  emailReplyToEmail?: Maybe<ScalarsEnums['String']>
  emailReplyToName?: Maybe<ScalarsEnums['String']>
  emailSendBefore?: Maybe<ScalarsEnums['Float']>
  emailSendBeforeUnit?: Maybe<ScalarsEnums['EmailSendBeforeUnit']>
  emailSendCalendarAttachment: ScalarsEnums['Boolean']
  emailSendEmailAs: ScalarsEnums['EmailSendAs']
  emailSendOnlyToActiveClients: ScalarsEnums['Boolean']
  emailSubject: ScalarsEnums['String']
  name: ScalarsEnums['String']
  pushNotificationDefaultOn: ScalarsEnums['Boolean']
  pushNotificationEnabled: ScalarsEnums['Boolean']
  pushNotificationMessage?: Maybe<ScalarsEnums['String']>
  pushNotificationTitle?: Maybe<ScalarsEnums['String']>
  readOnly: ScalarsEnums['Boolean']
  smsDefaultOn: ScalarsEnums['Boolean']
  smsEnabled: ScalarsEnums['Boolean']
  smsMessage?: Maybe<ScalarsEnums['String']>
  updatedAt?: Maybe<ScalarsEnums['String']>
}

/**
 * Result of paginated communication templates query
 */
export interface CommunicationTemplatePaginationResultSchema {
  __typename?: 'CommunicationTemplatePaginationResultSchema'
  pageInfo: CommunicationTemplatePaginationResultSchemaPageInfo
  results: Array<CommunicationTemplatePaginationResultSchemaResults>
}

export interface CommunicationTemplatePaginationResultSchemaPageInfo {
  __typename?: 'CommunicationTemplatePaginationResultSchemaPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface CommunicationTemplatePaginationResultSchemaResults {
  __typename?: 'CommunicationTemplatePaginationResultSchemaResults'
  cursor: ScalarsEnums['String']
  row: CommunicationTemplate
}

export interface CompleteClientFileUploadResponse {
  __typename?: 'CompleteClientFileUploadResponse'
  fileId: ScalarsEnums['ID']
  success: ScalarsEnums['Boolean']
}

export interface CompletionConfig {
  __typename?: 'EzypayCompletionConfig' | 'StripeCompletionConfig'
  $on: $CompletionConfig
}

export interface ComputedAlertItem {
  __typename?: 'ComputedAlertItem'
  clientId: ScalarsEnums['String']
  colorsOverride?: Maybe<ComputedAlertItemColorsOverride>
  data?: Maybe<ScalarsEnums['JSONObject']>
  requiresFetch?: Maybe<ScalarsEnums['Boolean']>
  type: ScalarsEnums['String']
}

export interface ComputedAlertItemColorsOverride {
  __typename?: 'ComputedAlertItemColorsOverride'
  bg: ScalarsEnums['String']
  icon: ScalarsEnums['String']
}

export interface ComputedAlertsResponse {
  __typename?: 'ComputedAlertsResponse'
  alerts: Array<ComputedAlertItem>
}

export interface ConfiguredLanguages {
  __typename?: 'ConfiguredLanguages'
  languages: Array<ScalarsEnums['String']>
}

export interface ConfirmBrandStoreAsset {
  __typename?: 'ConfirmBrandStoreAsset'
  assetId: ScalarsEnums['String']
  assetType: ScalarsEnums['BrandStoreAssetType']
  brandId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  deviceClass?: Maybe<ScalarsEnums['String']>
  filename: ScalarsEnums['String']
  gcsPath: ScalarsEnums['String']
  height?: Maybe<ScalarsEnums['Float']>
  locale: ScalarsEnums['String']
  platform: ScalarsEnums['BrandPlatform']
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['String']>
  validationError?: Maybe<ScalarsEnums['String']>
  validationStatus: ScalarsEnums['BrandStoreAssetStatus']
  width?: Maybe<ScalarsEnums['Float']>
}

/**
 * The APNs key id now stored for the brand and every provisioning step's latest outcome after the push handoff reran.
 */
export interface ConnectApnsKeyResult {
  __typename?: 'ConnectApnsKeyResult'
  keyId: ScalarsEnums['String']
  outcomes: Array<BrandProvisioningOutcome>
  success: ScalarsEnums['Boolean']
}

export interface ConnectAppleApi {
  __typename?: 'ConnectAppleApi'
  message: ScalarsEnums['String']
  success: ScalarsEnums['Boolean']
}

/**
 * Summary of content engagement across all content types
 */
export interface ContentEngagementSummary {
  __typename?: 'ContentEngagementSummary'
  avgCompletionRate: ScalarsEnums['Float']
  completedContentCount: ScalarsEnums['Float']
  totalContentViews: ScalarsEnums['Float']
  totalFavorites: ScalarsEnums['Float']
  totalPublishedContent: ScalarsEnums['Float']
}

export interface ContentEntries {
  __typename?: 'ContentEntries'
  pageInfo: ContentEntriesPageInfo
  results: Array<ContentEntriesResults>
}

export interface ContentEntriesPageInfo {
  __typename?: 'ContentEntriesPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface ContentEntriesResults {
  __typename?: 'ContentEntriesResults'
  cursor: ScalarsEnums['String']
  row: CmsContentEntry
}

/**
 * One catalogue category and how many titles it holds
 */
export interface ContentLibraryCategory {
  __typename?: 'ContentLibraryCategory'
  category: ScalarsEnums['String']
  titleCount: ScalarsEnums['Float']
}

/**
 * What turning Content Library off actually affected
 */
export interface ContentLibraryDisableResult {
  __typename?: 'ContentLibraryDisableResult'
  publishedEntriesAffected: ScalarsEnums['Float']
  sitesDisabled: ScalarsEnums['Float']
}

/**
 * Which fields of a licensed entry the brand has edited
 */
export interface ContentLibraryEntryOverrideState {
  __typename?: 'ContentLibraryEntryOverrideState'
  externalRef: ScalarsEnums['String']
  overriddenPaths: Array<ScalarsEnums['String']>
  syncState: ScalarsEnums['String']
}

/**
 * A short-lived playable stream of a library video for a staff preview
 */
export interface ContentLibraryPreviewStream {
  __typename?: 'ContentLibraryPreviewStream'
  expiresAt?: Maybe<ScalarsEnums['String']>
  hlsUrl: ScalarsEnums['String']
}

/**
 * Whether a field was handed back to the library default
 */
export interface ContentLibraryResetOverrideResult {
  __typename?: 'ContentLibraryResetOverrideResult'
  restored: ScalarsEnums['Boolean']
}

/**
 * Whether one location has Content Library switched on
 */
export interface ContentLibrarySiteEnablement {
  __typename?: 'ContentLibrarySiteEnablement'
  enabled: ScalarsEnums['Boolean']
  enabledAt?: Maybe<ScalarsEnums['String']>
  siteId: ScalarsEnums['ID']
}

/**
 * Content Library entitlement and provisioning state for a brand
 */
export interface ContentLibraryStatus {
  __typename?: 'ContentLibraryStatus'
  allLocations: ScalarsEnums['Boolean']
  archivedEntries: ScalarsEnums['Float']
  categories: Array<ScalarsEnums['String']>
  corporateId: ScalarsEnums['ID']
  draftEntries: ScalarsEnums['Float']
  publishedEntries: ScalarsEnums['Float']
  sites: Array<ContentLibrarySiteEnablement>
  status?: Maybe<ScalarsEnums['String']>
  subscribed: ScalarsEnums['Boolean']
}

/**
 * How one catalogue vocabulary term resolved onto a brand taxonomy entry
 */
export interface ContentLibraryTaxonomyMapping {
  __typename?: 'ContentLibraryTaxonomyMapping'
  canonicalTerm: ScalarsEnums['String']
  contentEntryId: ScalarsEnums['ID']
  mappingSource: ScalarsEnums['String']
  sourceValue: ScalarsEnums['String']
  taxonomyKind: ScalarsEnums['String']
}

export interface ContentMediaLibrary {
  __typename?: 'ContentMediaLibrary'
  pageInfo: ContentMediaLibraryPageInfo
  results: Array<ContentMediaLibraryResults>
}

export interface ContentMediaLibraryPageInfo {
  __typename?: 'ContentMediaLibraryPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface ContentMediaLibraryResults {
  __typename?: 'ContentMediaLibraryResults'
  cursor: ScalarsEnums['String']
  row: CmsContentMedia
}

export interface ContentTaxonomyOption {
  __typename?: 'ContentTaxonomyOption'
  childIds: Array<ScalarsEnums['String']>
  id: ScalarsEnums['String']
  name: ScalarsEnums['String']
}

export interface ContentTaxonomyOptionGroup {
  __typename?: 'ContentTaxonomyOptionGroup'
  options: Array<ContentTaxonomyOption>
  slug: ScalarsEnums['String']
}

export interface CoreUsersWithoutPayrollTier {
  __typename?: 'CoreUsersWithoutPayrollTier'
  id: ScalarsEnums['ID']
  isInstructor: ScalarsEnums['Boolean']
  name: ScalarsEnums['String']
  siteNames: Array<ScalarsEnums['String']>
}

/**
 * Corporate/Brand Entity (Tenant Root)
 */
export interface Corporate {
  __typename?: 'Corporate'
  adminConfigurations?: Maybe<CorporateAdminConfigurations>
  bigqueryDataset?: Maybe<ScalarsEnums['String']>
  bigqueryRawDataset?: Maybe<ScalarsEnums['String']>
  clientTenantId?: Maybe<ScalarsEnums['String']>
  /**
   * Corporate communication settings including email defaults
   */
  communicationSettings?: Maybe<CorporateCommunicationSettings>
  corporateId: ScalarsEnums['String']
  createdAt?: Maybe<ScalarsEnums['String']>
  createdBy?: Maybe<ScalarsEnums['String']>
  currency?: Maybe<ScalarsEnums['String']>
  customIntegrations?: Maybe<Array<CorporateCustomIntegrationItem>>
  customization?: Maybe<CorporateCustomization>
  /**
   * Corporate dashboard hero image with signed URLs
   */
  dashboardHeroImage: (args: { input: ImagePublicSignedUrlInput }) => Maybe<ImagePublicSignedUrl>
  dashboardHeroImageTemp?: Maybe<ScalarsEnums['String']>
  description?: Maybe<ScalarsEnums['String']>
  email?: Maybe<ScalarsEnums['String']>
  /**
   * Corporate integrations (ClassPass, grow, push notifications, etc.)
   */
  integrations?: Maybe<CorporateIntegrations>
  isOnboarding?: Maybe<ScalarsEnums['Boolean']>
  language?: Maybe<ScalarsEnums['String']>
  leadSource?: Maybe<ScalarsEnums['String']>
  /**
   * Corporate logo image with signed URLs
   */
  logoImage: (args: { input: ImagePublicSignedUrlInput }) => Maybe<ImagePublicSignedUrl>
  logoImageTemp?: Maybe<ScalarsEnums['String']>
  /**
   * Member Movement (OC-554) corporate configuration
   */
  memberMovementConfig: MemberMovementConfig
  migrationStatus?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  onboardingCompletedAt?: Maybe<ScalarsEnums['String']>
  paymentAuthorisationConfig?: Maybe<CorporatePaymentAuthorisationConfig>
  phone?: Maybe<ScalarsEnums['String']>
  planTier?: Maybe<ScalarsEnums['ProductPlanTier']>
  region?: Maybe<ScalarsEnums['String']>
  /**
   * Number of sites/locations for this corporate
   */
  sitesCount: ScalarsEnums['Float']
  slug?: Maybe<ScalarsEnums['String']>
  spannerDatabaseId?: Maybe<ScalarsEnums['String']>
  spannerInstanceId?: Maybe<ScalarsEnums['String']>
  staffTenantId?: Maybe<ScalarsEnums['String']>
  status?: Maybe<ScalarsEnums['String']>
  subdomain?: Maybe<ScalarsEnums['String']>
  tier?: Maybe<ScalarsEnums['String']>
  timezone?: Maybe<ScalarsEnums['String']>
  trialConvertedAt?: Maybe<ScalarsEnums['String']>
  trialExpiresAt?: Maybe<ScalarsEnums['String']>
  trialStartedAt?: Maybe<ScalarsEnums['String']>
  trialStatus?: Maybe<ScalarsEnums['String']>
  updatedAt?: Maybe<ScalarsEnums['String']>
  updatedBy?: Maybe<ScalarsEnums['String']>
  urlPrefix?: Maybe<ScalarsEnums['String']>
  /**
   * Get all webhooks for a corporate
   */
  webhooks: Array<CorporateWebhook>
  website?: Maybe<ScalarsEnums['String']>
}

/**
 * An add-on authored at brand level and distributed to locations.
 */
export interface CorporateAddOn {
  __typename?: 'CorporateAddOn'
  assignedSiteGroupIds?: Maybe<Array<ScalarsEnums['ID']>>
  assignedSiteIds?: Maybe<Array<ScalarsEnums['ID']>>
  config: BrandAddOnConfig
  corporateId?: Maybe<ScalarsEnums['ID']>
  corporateServiceTemplateId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  deletedAt?: Maybe<ScalarsEnums['String']>
  firstActivatedAt?: Maybe<ScalarsEnums['String']>
  isAllLocations: ScalarsEnums['Boolean']
  lockedSections?: Maybe<Array<ScalarsEnums['BrandServiceTemplateSection']>>
  name: ScalarsEnums['String']
  scheduleAuthorTimezone?: Maybe<ScalarsEnums['String']>
  scheduleClock?: Maybe<ScalarsEnums['BrandScheduleClock']>
  scheduleWallTime?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['CorporateServiceTemplateStatus']
  type: ScalarsEnums['String']
  updatedAt: ScalarsEnums['String']
  version: ScalarsEnums['Float']
}

/**
 * What a bulk archive of brand add-ons did: each archived add-on with what happened at its locations, and each one left alone with the reason.
 */
export interface CorporateAddOnArchiveManyResult {
  __typename?: 'CorporateAddOnArchiveManyResult'
  archived: Array<CorporateAddOnRolloutResult>
  skipped: Array<BrandServiceTemplateArchiveSkip>
}

/**
 * A brand add-on on the brand list. activeClientCount counts its active sales at every location, including on forked rows.
 */
export interface CorporateAddOnListItem {
  __typename?: 'CorporateAddOnListItem'
  activeClientCount: ScalarsEnums['Float']
  assignedSiteGroupIds?: Maybe<Array<ScalarsEnums['ID']>>
  assignedSiteIds?: Maybe<Array<ScalarsEnums['ID']>>
  config: BrandAddOnConfig
  corporateId?: Maybe<ScalarsEnums['ID']>
  corporateServiceTemplateId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  deletedAt?: Maybe<ScalarsEnums['String']>
  firstActivatedAt?: Maybe<ScalarsEnums['String']>
  isAllLocations: ScalarsEnums['Boolean']
  lockedSections?: Maybe<Array<ScalarsEnums['BrandServiceTemplateSection']>>
  name: ScalarsEnums['String']
  scheduleAuthorTimezone?: Maybe<ScalarsEnums['String']>
  scheduleClock?: Maybe<ScalarsEnums['BrandScheduleClock']>
  scheduleWallTime?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['CorporateServiceTemplateStatus']
  type: ScalarsEnums['String']
  updatedAt: ScalarsEnums['String']
  version: ScalarsEnums['Float']
}

/**
 * A brand add-on after a write that reaches its locations, and what it did at each.
 */
export interface CorporateAddOnRolloutResult {
  __typename?: 'CorporateAddOnRolloutResult'
  addOn: CorporateAddOn
  rollout: BrandServiceTemplateRollout
}

/**
 * A scheduled brand add-on and when it goes live at each of its locations.
 */
export interface CorporateAddOnScheduleResult {
  __typename?: 'CorporateAddOnScheduleResult'
  addOn: CorporateAddOn
  sites: Array<BrandServiceTemplateScheduledSite>
}

export interface CorporateAdminConfigurations {
  __typename?: 'CorporateAdminConfigurations'
  appSettings?: Maybe<CorporateAdminConfigurationsAppSettings>
  customization?: Maybe<CorporateCustomization>
  hubspot?: Maybe<CorporateAdminConfigurationsHubspot>
  paymentRouting?: Maybe<CorporateAdminConfigurationsPaymentRouting>
  publicApi?: Maybe<CorporateAdminConfigurationsPublicApi>
  system?: Maybe<CorporateAdminConfigurationsSystem>
}

export interface CorporateAdminConfigurationsAppSettings {
  __typename?: 'CorporateAdminConfigurationsAppSettings'
  androidVersion?: Maybe<ScalarsEnums['String']>
  classTimeFilter?: Maybe<ScalarsEnums['Boolean']>
  clientSelfServiceSuspension?: Maybe<CorporateAdminConfigurationsAppSettingsClientSelfServiceSuspension>
  displayInstructor?: Maybe<ScalarsEnums['Boolean']>
  displayPackageDescription?: Maybe<ScalarsEnums['Boolean']>
  displayProfilePicture?: Maybe<ScalarsEnums['Boolean']>
  displayTodayClasses?: Maybe<ScalarsEnums['Boolean']>
  forceUpdateAndroid?: Maybe<ScalarsEnums['Boolean']>
  forceUpdateIOS?: Maybe<ScalarsEnums['Boolean']>
  iosVersion?: Maybe<ScalarsEnums['String']>
  privatesAnyAvailable?: Maybe<ScalarsEnums['Boolean']>
  purchaseRedirect?: Maybe<ScalarsEnums['String']>
  pushProvider?: Maybe<ScalarsEnums['PushProvider']>
  redirectUrl?: Maybe<ScalarsEnums['String']>
  signUpRedirect?: Maybe<ScalarsEnums['String']>
  signUpToggle?: Maybe<ScalarsEnums['Boolean']>
}

export interface CorporateAdminConfigurationsAppSettingsClientSelfServiceSuspension {
  __typename?: 'CorporateAdminConfigurationsAppSettingsClientSelfServiceSuspension'
  enabled?: Maybe<ScalarsEnums['Boolean']>
  maxSuspensionDays?: Maybe<ScalarsEnums['Float']>
  minSuspensionDays?: Maybe<ScalarsEnums['Float']>
  totalCalendarYearSuspensionDays?: Maybe<ScalarsEnums['Float']>
}

export interface CorporateAdminConfigurationsHubspot {
  __typename?: 'CorporateAdminConfigurationsHubspot'
  companyId?: Maybe<ScalarsEnums['String']>
  companyName?: Maybe<ScalarsEnums['String']>
}

export interface CorporateAdminConfigurationsPaymentRouting {
  __typename?: 'CorporateAdminConfigurationsPaymentRouting'
  chargeRouting?: Maybe<ScalarsEnums['PaymentRoutingMode']>
  pipeline?: Maybe<CorporateAdminConfigurationsPaymentRoutingPipeline>
}

export interface CorporateAdminConfigurationsPaymentRoutingPipeline {
  __typename?: 'CorporateAdminConfigurationsPaymentRoutingPipeline'
  mode?: Maybe<ScalarsEnums['PaymentsPipelineMode']>
}

export interface CorporateAdminConfigurationsPublicApi {
  __typename?: 'CorporateAdminConfigurationsPublicApi'
  logLevel?: Maybe<ScalarsEnums['PublicApiLogLevel']>
}

export interface CorporateAdminConfigurationsSystem {
  __typename?: 'CorporateAdminConfigurationsSystem'
  blockWhenClientOwesAtAnyLocation?: Maybe<ScalarsEnums['Boolean']>
  classicDashboardsEnabled?: Maybe<ScalarsEnums['Boolean']>
  connectedSiteForPassportAccess?: Maybe<ScalarsEnums['Boolean']>
  corporateClientLookup?: Maybe<ScalarsEnums['Boolean']>
  generateAttendanceStatisticsPerSessionTemplate?: Maybe<ScalarsEnums['Boolean']>
}

/**
 * Email settings for corporate communications
 */
export interface CorporateCommunicationEmailSettings {
  __typename?: 'CorporateCommunicationEmailSettings'
  defaultFromEmail?: Maybe<ScalarsEnums['String']>
  defaultFromName?: Maybe<ScalarsEnums['String']>
}

/**
 * Corporate communication settings including email defaults
 */
export interface CorporateCommunicationSettings {
  __typename?: 'CorporateCommunicationSettings'
  email?: Maybe<CorporateCommunicationEmailSettings>
}

/**
 * A corporate-level communication template
 */
export interface CorporateCommunicationTemplate {
  __typename?: 'CorporateCommunicationTemplate'
  alias: ScalarsEnums['CommunicationTemplateAliases']
  allowedPlaceholders?: Maybe<Array<ScalarsEnums['String']>>
  corporateCommunicationTemplateId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  emailBody?: Maybe<ScalarsEnums['String']>
  emailCcEmail?: Maybe<ScalarsEnums['String']>
  emailCcLocation?: Maybe<ScalarsEnums['Boolean']>
  emailCopyEmployee?: Maybe<ScalarsEnums['EmailCopyEmployee']>
  emailReplyToEmail?: Maybe<ScalarsEnums['String']>
  emailReplyToName?: Maybe<ScalarsEnums['String']>
  emailSendBefore?: Maybe<ScalarsEnums['Float']>
  emailSendBeforeUnit?: Maybe<ScalarsEnums['EmailSendBeforeUnit']>
  emailSendCalendarAttachment?: Maybe<ScalarsEnums['Boolean']>
  emailSendEmailAs?: Maybe<ScalarsEnums['EmailSendAs']>
  emailSendOnlyToActiveClients?: Maybe<ScalarsEnums['Boolean']>
  emailSubject?: Maybe<ScalarsEnums['String']>
  emailUseHapanaLayout?: Maybe<ScalarsEnums['Boolean']>
  enableEmail: ScalarsEnums['Boolean']
  enablePush?: Maybe<ScalarsEnums['Boolean']>
  enableSms?: Maybe<ScalarsEnums['Boolean']>
  ignoredSitesIds?: Maybe<Array<ScalarsEnums['String']>>
  isCustomized?: Maybe<ScalarsEnums['Boolean']>
  name: ScalarsEnums['String']
  pushMessage?: Maybe<ScalarsEnums['String']>
  pushTitle?: Maybe<ScalarsEnums['String']>
  smsMessage?: Maybe<ScalarsEnums['String']>
  targetedServiceTemplateIds?: Maybe<Array<ScalarsEnums['ID']>>
  updatedAt: ScalarsEnums['String']
}

/**
 * Result of paginated corporate communication templates query
 */
export interface CorporateCommunicationTemplatePaginationResultSchema {
  __typename?: 'CorporateCommunicationTemplatePaginationResultSchema'
  pageInfo: CorporateCommunicationTemplatePaginationResultSchemaPageInfo
  results: Array<CorporateCommunicationTemplatePaginationResultSchemaResults>
}

export interface CorporateCommunicationTemplatePaginationResultSchemaPageInfo {
  __typename?: 'CorporateCommunicationTemplatePaginationResultSchemaPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface CorporateCommunicationTemplatePaginationResultSchemaResults {
  __typename?: 'CorporateCommunicationTemplatePaginationResultSchemaResults'
  cursor: ScalarsEnums['String']
  row: CorporateCommunicationTemplate
}

/**
 * A version of a corporate communication template with site assignments
 */
export interface CorporateCommunicationTemplateVersion {
  __typename?: 'CorporateCommunicationTemplateVersion'
  assignedSiteGroups?: Maybe<Array<ScalarsEnums['String']>>
  assignedSites?: Maybe<Array<ScalarsEnums['String']>>
  corporateCommunicationTemplateId: ScalarsEnums['String']
  corporateCommunicationTemplateVersionId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  emailBody?: Maybe<ScalarsEnums['String']>
  emailCcEmail?: Maybe<ScalarsEnums['String']>
  emailCcLocation?: Maybe<ScalarsEnums['Boolean']>
  emailCopyEmployee?: Maybe<ScalarsEnums['EmailCopyEmployee']>
  emailReplyToEmail?: Maybe<ScalarsEnums['String']>
  emailReplyToName?: Maybe<ScalarsEnums['String']>
  emailSendBefore?: Maybe<ScalarsEnums['Float']>
  emailSendBeforeUnit?: Maybe<ScalarsEnums['EmailSendBeforeUnit']>
  emailSendCalendarAttachment?: Maybe<ScalarsEnums['Boolean']>
  emailSendEmailAs?: Maybe<ScalarsEnums['EmailSendAs']>
  emailSendOnlyToActiveClients?: Maybe<ScalarsEnums['Boolean']>
  emailSubject?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  pushMessage?: Maybe<ScalarsEnums['String']>
  pushTitle?: Maybe<ScalarsEnums['String']>
  smsMessage?: Maybe<ScalarsEnums['String']>
  targetedServiceTemplateIds?: Maybe<Array<ScalarsEnums['ID']>>
  updatedAt: ScalarsEnums['String']
}

/**
 * A single custom third-party integration configuration
 */
export interface CorporateCustomIntegrationItem {
  __typename?: 'CorporateCustomIntegrationItem'
  integrationId: ScalarsEnums['String']
  keyValues: Array<CorporateCustomIntegrationItemKeyValues>
}

export interface CorporateCustomIntegrationItemKeyValues {
  __typename?: 'CorporateCustomIntegrationItemKeyValues'
  key: ScalarsEnums['String']
  value?: Maybe<ScalarsEnums['String']>
}

export interface CorporateCustomization {
  __typename?: 'CorporateCustomization'
  buttonStyle?: Maybe<ScalarsEnums['String']>
  colorSchema?: Maybe<CorporateCustomizationColorSchema>
  customCssLink?: Maybe<ScalarsEnums['String']>
}

export interface CorporateCustomizationColorSchema {
  __typename?: 'CorporateCustomizationColorSchema'
  backgroundColor?: Maybe<ScalarsEnums['String']>
  primaryColor?: Maybe<ScalarsEnums['String']>
  primaryTextColor?: Maybe<ScalarsEnums['String']>
  secondaryColor?: Maybe<ScalarsEnums['String']>
  secondaryTextColor?: Maybe<ScalarsEnums['String']>
}

/**
 * Custom email domain configuration for a corporate
 */
export interface CorporateEmailDomain {
  __typename?: 'CorporateEmailDomain'
  corporateId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  createdByStaffUserId?: Maybe<ScalarsEnums['String']>
  customReturnPath?: Maybe<ScalarsEnums['String']>
  dnsRecords: Array<DnsRecord>
  domain: ScalarsEnums['String']
  fromLocalPart: ScalarsEnums['String']
  isPlatformDefault?: Maybe<ScalarsEnums['Boolean']>
  recommendedRecords?: Maybe<Array<RecommendedDnsRecord>>
  region?: Maybe<ScalarsEnums['String']>
  resendDomainId: ScalarsEnums['String']
  status: ScalarsEnums['EmailDomainStatus']
  updatedAt: ScalarsEnums['String']
  updatedByStaffUserId?: Maybe<ScalarsEnums['String']>
  verifiedAt?: Maybe<ScalarsEnums['String']>
}

/**
 * A corporate FAQ entry
 */
export interface CorporateFaq {
  __typename?: 'CorporateFaq'
  corporateFaqId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  displayOrder: ScalarsEnums['Float']
  heading: ScalarsEnums['String']
  response: ScalarsEnums['String']
  status: ScalarsEnums['CorporateFaqStatus']
  updatedAt: ScalarsEnums['String']
}

/**
 * Corporate integration settings
 */
export interface CorporateIntegrations {
  __typename?: 'CorporateIntegrations'
  classPass?: Maybe<ClassPassSettings>
  contentfulKeys?: Maybe<CorporateIntegrationsContentfulKeys>
  deeplinking?: Maybe<CorporateIntegrationsDeeplinking>
  egym?: Maybe<EgymSettings>
  grow?: Maybe<CorporateIntegrationsGrow>
  jwPlayer?: Maybe<CorporateIntegrationsJwPlayer>
  pushNotificationKeys?: Maybe<CorporateIntegrationsPushNotificationKeys>
  zapier?: Maybe<CorporateIntegrationsZapier>
}

export interface CorporateIntegrationsContentfulKeys {
  __typename?: 'CorporateIntegrationsContentfulKeys'
  accessToken?: Maybe<ScalarsEnums['String']>
  contentApiBaseUrl?: Maybe<ScalarsEnums['String']>
  contentApiKey?: Maybe<ScalarsEnums['String']>
  contentApiKeyStatus?: Maybe<ScalarsEnums['ContentApiKeyStatus']>
  managementAccessToken?: Maybe<ScalarsEnums['String']>
  previewToken?: Maybe<ScalarsEnums['String']>
  spaceId?: Maybe<ScalarsEnums['String']>
  useNativeContent?: Maybe<ScalarsEnums['Boolean']>
}

export interface CorporateIntegrationsDeeplinking {
  __typename?: 'CorporateIntegrationsDeeplinking'
  androidPackageName?: Maybe<ScalarsEnums['String']>
  dynamicDomainLink?: Maybe<ScalarsEnums['String']>
  iosAppStoreId?: Maybe<ScalarsEnums['String']>
  iosBundleId?: Maybe<ScalarsEnums['String']>
  webApiKey?: Maybe<ScalarsEnums['String']>
}

export interface CorporateIntegrationsGrow {
  __typename?: 'CorporateIntegrationsGrow'
  enableHqLocationSync?: Maybe<ScalarsEnums['Boolean']>
  enableHqSyncAllLocationsScheduleId?: Maybe<ScalarsEnums['String']>
  enableHqsScheduleId?: Maybe<ScalarsEnums['String']>
  enableSitesScheduleId?: Maybe<ScalarsEnums['String']>
  enabled?: Maybe<ScalarsEnums['Boolean']>
  hqLocationIds?: Maybe<Array<ScalarsEnums['String']>>
  lastCollect?: Maybe<GrowLastCollect>
  syncDndAndChannels?: Maybe<ScalarsEnums['Boolean']>
  useCheckinCounters?: Maybe<ScalarsEnums['Boolean']>
}

export interface CorporateIntegrationsJwPlayer {
  __typename?: 'CorporateIntegrationsJwPlayer'
  androidSdk?: Maybe<ScalarsEnums['String']>
  apiKey?: Maybe<ScalarsEnums['String']>
  apiSecret?: Maybe<ScalarsEnums['String']>
  iosSdk?: Maybe<ScalarsEnums['String']>
  player8?: Maybe<ScalarsEnums['String']>
  playerId?: Maybe<ScalarsEnums['String']>
}

export interface CorporateIntegrationsPushNotificationKeys {
  __typename?: 'CorporateIntegrationsPushNotificationKeys'
  id?: Maybe<ScalarsEnums['String']>
  key?: Maybe<ScalarsEnums['String']>
}

export interface CorporateIntegrationsZapier {
  __typename?: 'CorporateIntegrationsZapier'
  enabled?: Maybe<ScalarsEnums['Boolean']>
}

export interface CorporatePaymentAuthorisationConfig {
  __typename?: 'CorporatePaymentAuthorisationConfig'
  bankDebitAuthorisation?: Maybe<CorporatePaymentAuthorisationConfigBankDebitAuthorisation>
  cancellationPolicy: ScalarsEnums['String']
  customerServiceContact: ScalarsEnums['String']
  depositNote?: Maybe<ScalarsEnums['String']>
  legalEntityName?: Maybe<ScalarsEnums['String']>
  salesTaxNote?: Maybe<ScalarsEnums['String']>
  template?: Maybe<ScalarsEnums['String']>
}

export interface CorporatePaymentAuthorisationConfigBankDebitAuthorisation {
  __typename?: 'CorporatePaymentAuthorisationConfigBankDebitAuthorisation'
  coversLocationsFrom: ScalarsEnums['String']
  evidenceReference: ScalarsEnums['String']
  originatorName: ScalarsEnums['String']
}

/**
 * Corporate payout account configuration
 */
export interface CorporatePayoutAccount {
  __typename?: 'CorporatePayoutAccount'
  corporateId: ScalarsEnums['String']
  corporatePayoutAccountId: ScalarsEnums['String']
  country: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  createdBy?: Maybe<ScalarsEnums['String']>
  currency: ScalarsEnums['StripePayoutCurrency']
  currencyConversionFeeEnabled: ScalarsEnums['Boolean']
  currencyConversionFeeRate?: Maybe<ScalarsEnums['Numeric']>
  isSandbox: ScalarsEnums['Boolean']
  name: ScalarsEnums['String']
  payoutFeeEnabled: ScalarsEnums['Boolean']
  payoutFeeRate?: Maybe<ScalarsEnums['Numeric']>
  rebateTemplateCount?: Maybe<ScalarsEnums['Float']>
  royaltiesTemplateCount?: Maybe<ScalarsEnums['Float']>
  stripeId: ScalarsEnums['String']
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['String']>
}

export interface CorporatePayoutAccounts {
  __typename?: 'CorporatePayoutAccounts'
  pageInfo: CorporatePayoutAccountsPageInfo
  results: Array<CorporatePayoutAccountsResults>
}

export interface CorporatePayoutAccountsPageInfo {
  __typename?: 'CorporatePayoutAccountsPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface CorporatePayoutAccountsResults {
  __typename?: 'CorporatePayoutAccountsResults'
  cursor: ScalarsEnums['String']
  row: CorporatePayoutAccount
}

/**
 * Planned identifiers for an un-provisioned corporate, surfaced before commit.
 */
export interface CorporateProvisioningPreview {
  __typename?: 'CorporateProvisioningPreview'
  clientTenantDisplayName: ScalarsEnums['String']
  corporateId: ScalarsEnums['String']
  existingClientTenantId?: Maybe<ScalarsEnums['String']>
  existingStaffTenantId?: Maybe<ScalarsEnums['String']>
  region: ScalarsEnums['String']
  spannerDatabaseId: ScalarsEnums['String']
  spannerInstanceId: ScalarsEnums['String']
  staffTenantDisplayName: ScalarsEnums['String']
}

/**
 * A brand membership, package or add-on by name, kind and status.
 */
export interface CorporateServiceTemplateSummary {
  __typename?: 'CorporateServiceTemplateSummary'
  corporateServiceTemplateId: ScalarsEnums['ID']
  name: ScalarsEnums['String']
  status: ScalarsEnums['CorporateServiceTemplateStatus']
  type: ScalarsEnums['CorporateServiceTemplateType']
}

/**
 * A session group authored at brand level and distributed to locations.
 */
export interface CorporateSessionType {
  __typename?: 'CorporateSessionType'
  allowEditingSessionType: ScalarsEnums['Boolean']
  allowMultiLocationAccess: ScalarsEnums['Boolean']
  assignedSiteGroupIds?: Maybe<Array<ScalarsEnums['ID']>>
  assignedSiteIds?: Maybe<Array<ScalarsEnums['ID']>>
  color: ScalarsEnums['String']
  corporateId?: Maybe<ScalarsEnums['ID']>
  corporateSessionTypeId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  deletedAt?: Maybe<ScalarsEnums['String']>
  isAllLocations: ScalarsEnums['Boolean']
  lockedSections?: Maybe<Array<ScalarsEnums['SessionGroupSection']>>
  name: ScalarsEnums['String']
  updatedAt: ScalarsEnums['String']
}

/**
 * A location-authored session type with the same name that the brand session group would take over.
 */
export interface CorporateSessionTypeAdoption {
  __typename?: 'CorporateSessionTypeAdoption'
  color?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  siteId: ScalarsEnums['ID']
  siteName: ScalarsEnums['String']
  siteSessionTypeId: ScalarsEnums['String']
}

/**
 * A location with more than one same-named session type, which the brand session group skips.
 */
export interface CorporateSessionTypeAmbiguousSite {
  __typename?: 'CorporateSessionTypeAmbiguousSite'
  matchCount: ScalarsEnums['Float']
  siteId: ScalarsEnums['ID']
  siteName: ScalarsEnums['String']
}

/**
 * The session templates at receiving locations that use a brand session group: the first names and the total.
 */
export interface CorporateSessionTypeLinkedTemplates {
  __typename?: 'CorporateSessionTypeLinkedTemplates'
  names: Array<ScalarsEnums['String']>
  total: ScalarsEnums['Float']
}

/**
 * A brand session group with the counts its list row shows.
 */
export interface CorporateSessionTypeListItem {
  __typename?: 'CorporateSessionTypeListItem'
  allowEditingSessionType: ScalarsEnums['Boolean']
  allowMultiLocationAccess: ScalarsEnums['Boolean']
  assignedGroupCount: ScalarsEnums['Float']
  assignedSiteGroupIds?: Maybe<Array<ScalarsEnums['ID']>>
  assignedSiteIds?: Maybe<Array<ScalarsEnums['ID']>>
  color: ScalarsEnums['String']
  corporateId?: Maybe<ScalarsEnums['ID']>
  corporateSessionTypeId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  deletedAt?: Maybe<ScalarsEnums['String']>
  isAllLocations: ScalarsEnums['Boolean']
  linkedTemplates: CorporateSessionTypeLinkedTemplates
  lockedSections?: Maybe<Array<ScalarsEnums['SessionGroupSection']>>
  name: ScalarsEnums['String']
  receivingSiteCount: ScalarsEnums['Float']
  updatedAt: ScalarsEnums['String']
}

/**
 * What saving a brand session group would do: how many locations receive it, which same-named session types it adopts or skips, and which locations it is withdrawn from. Detail lists are capped; adoptionSiteIds is complete.
 */
export interface CorporateSessionTypeSyncPreview {
  __typename?: 'CorporateSessionTypeSyncPreview'
  adoptionSiteIds: Array<ScalarsEnums['ID']>
  adoptions: Array<CorporateSessionTypeAdoption>
  adoptionsHasMore: ScalarsEnums['Boolean']
  ambiguousSites: Array<CorporateSessionTypeAmbiguousSite>
  ambiguousSitesHasMore: ScalarsEnums['Boolean']
  locationAuthoredCount: ScalarsEnums['Float']
  nameClash?: Maybe<ScalarsEnums['CorporateSessionTypeNameClash']>
  receivingSiteCount: ScalarsEnums['Float']
  withdrawals: Array<CorporateSessionTypeWithdrawal>
  withdrawalsHasMore: ScalarsEnums['Boolean']
}

/**
 * A location that would stop receiving a brand session group, and what still uses its session type there.
 */
export interface CorporateSessionTypeWithdrawal {
  __typename?: 'CorporateSessionTypeWithdrawal'
  creditTemplateCount: ScalarsEnums['Float']
  equipmentCount: ScalarsEnums['Float']
  futureSessionCount: ScalarsEnums['Float']
  inUse: ScalarsEnums['Boolean']
  recurringSessionCount: ScalarsEnums['Float']
  sessionTemplateCount: ScalarsEnums['Float']
  siteId: ScalarsEnums['ID']
  siteName: ScalarsEnums['String']
  siteSessionTypeId: ScalarsEnums['String']
}

/**
 * A tax type authored at brand level and distributed to assigned locations.
 */
export interface CorporateTaxSetting {
  __typename?: 'CorporateTaxSetting'
  assignedSiteGroupIds?: Maybe<Array<ScalarsEnums['ID']>>
  assignedSiteIds?: Maybe<Array<ScalarsEnums['ID']>>
  corporateId?: Maybe<ScalarsEnums['ID']>
  corporateTaxSettingId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  deletedAt?: Maybe<ScalarsEnums['String']>
  enabled: ScalarsEnums['Boolean']
  isLocked: ScalarsEnums['Boolean']
  name: ScalarsEnums['String']
  rate: ScalarsEnums['String']
  setting: ScalarsEnums['TaxSettingType']
  updatedAt: ScalarsEnums['String']
}

/**
 * One membership or package at one location that references a brand tax type.
 */
export interface CorporateTaxSettingUsage {
  __typename?: 'CorporateTaxSettingUsage'
  serviceTemplateId: ScalarsEnums['ID']
  siteId: ScalarsEnums['ID']
  siteName: ScalarsEnums['String']
  templateName: ScalarsEnums['String']
}

/**
 * The memberships and packages that reference a brand tax type, capped; hasMore is true when some were left out.
 */
export interface CorporateTaxSettingUsageResult {
  __typename?: 'CorporateTaxSettingUsageResult'
  hasMore: ScalarsEnums['Boolean']
  usages: Array<CorporateTaxSettingUsage>
}

/**
 * Corporate-level subscription to a theme with billing lifecycle
 */
export interface CorporateThemeSubscription {
  __typename?: 'CorporateThemeSubscription'
  activatedAt?: Maybe<ScalarsEnums['String']>
  billingCycleAmount?: Maybe<ScalarsEnums['Float']>
  cancelledAt?: Maybe<ScalarsEnums['String']>
  corporateId: ScalarsEnums['ID']
  corporateThemeSubscriptionId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  currency: ScalarsEnums['String']
  effectiveCancelAt?: Maybe<ScalarsEnums['String']>
  expiresAt?: Maybe<ScalarsEnums['String']>
  gracePeriodEndsAt?: Maybe<ScalarsEnums['String']>
  lastBilledAt?: Maybe<ScalarsEnums['String']>
  metadata?: Maybe<ScalarsEnums['JSONObject']>
  nextBillingDate?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['ThemeSubscriptionStatus']
  subscribedAt: ScalarsEnums['String']
  themeId: ScalarsEnums['ID']
  trialEndsAt?: Maybe<ScalarsEnums['String']>
  updatedAt: ScalarsEnums['String']
}

/**
 * Corporate webhook configuration
 */
export interface CorporateWebhook {
  __typename?: 'CorporateWebhook'
  allSites: ScalarsEnums['Boolean']
  consecutiveFailures: ScalarsEnums['Float']
  corporateId: ScalarsEnums['String']
  corporateWebhookId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  enabled: ScalarsEnums['Boolean']
  events: Array<ScalarsEnums['String']>
  headerKey?: Maybe<ScalarsEnums['String']>
  headerValue?: Maybe<ScalarsEnums['String']>
  lastDeliveryAt?: Maybe<ScalarsEnums['String']>
  lastSuccessAt?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  secret?: Maybe<ScalarsEnums['String']>
  siteIds?: Maybe<Array<ScalarsEnums['String']>>
  status: ScalarsEnums['CorporateWebhookStatus']
  updatedAt: ScalarsEnums['String']
  url: ScalarsEnums['String']
}

/**
 * One delivery attempt to a brand webhook
 */
export interface CorporateWebhookDelivery {
  __typename?: 'CorporateWebhookDelivery'
  attempt: ScalarsEnums['Float']
  corporateWebhookId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  delivered: ScalarsEnums['Boolean']
  deliveryId: ScalarsEnums['String']
  error?: Maybe<ScalarsEnums['String']>
  eventId?: Maybe<ScalarsEnums['String']>
  eventType?: Maybe<ScalarsEnums['String']>
  latencyMs?: Maybe<ScalarsEnums['Float']>
  maxAttempts: ScalarsEnums['Float']
  responseStatus?: Maybe<ScalarsEnums['Float']>
  siteId?: Maybe<ScalarsEnums['String']>
  willRetry: ScalarsEnums['Boolean']
}

export interface Corporates {
  __typename?: 'Corporates'
  pageInfo: CorporatesPageInfo
  results: Array<CorporatesResults>
}

export interface CorporatesPageInfo {
  __typename?: 'CorporatesPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface CorporatesResults {
  __typename?: 'CorporatesResults'
  cursor: ScalarsEnums['String']
  row: Corporate
}

export interface CorpusResyncResult {
  __typename?: 'CorpusResyncResult'
  articlesCreated: ScalarsEnums['Int']
  articlesDeleted: ScalarsEnums['Int']
  articlesFailed: ScalarsEnums['Int']
  errors: Array<ScalarsEnums['String']>
  success: ScalarsEnums['Boolean']
}

export interface Countries {
  __typename?: 'Countries'
  pageInfo: CountriesPageInfo
  results: Array<CountriesResults>
}

export interface CountriesPageInfo {
  __typename?: 'CountriesPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface CountriesResults {
  __typename?: 'CountriesResults'
  cursor: ScalarsEnums['String']
  row: Country
}

/**
 * A country reference with ISO codes and currency
 */
export interface Country {
  __typename?: 'Country'
  countryId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  currencyCode?: Maybe<ScalarsEnums['String']>
  /**
   * ISO 3166-1 alpha-2 (US, CA, GB) - null for virtual locations
   */
  isoCode?: Maybe<ScalarsEnums['String']>
  /**
   * ISO 3166-1 alpha-3 (USA, CAN, GBR) - null for virtual locations
   */
  isoCodeExtended?: Maybe<ScalarsEnums['String']>
  name?: Maybe<ScalarsEnums['String']>
  phoneCode?: Maybe<ScalarsEnums['Float']>
  updatedAt: ScalarsEnums['String']
}

/**
 * A claim on a cover, with whether the claimant can still take the class
 */
export interface CoverClaimView {
  __typename?: 'CoverClaimView'
  coverClaimId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  decidedAt?: Maybe<ScalarsEnums['String']>
  eligible?: Maybe<ScalarsEnums['Boolean']>
  failureReason?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  reasons: Array<ScalarsEnums['CoverIneligibilityReason']>
  staffUserId: ScalarsEnums['String']
  status: ScalarsEnums['CoverClaimStatus']
  via: ScalarsEnums['CoverClaimVia']
  warnings: Array<ScalarsEnums['CoverEligibilityWarning']>
}

/**
 * A class type that cover qualifications and preferred subs can name
 */
export interface CoverClassType {
  __typename?: 'CoverClassType'
  name: ScalarsEnums['String']
  siteSessionTypeId: ScalarsEnums['String']
}

/**
 * One cover notification event and everyone it went to
 */
export interface CoverCommunicationLogBatch {
  __typename?: 'CoverCommunicationLogBatch'
  batchId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  kind: ScalarsEnums['CoverCommunicationKind']
  messagePreview?: Maybe<ScalarsEnums['String']>
  recipients: Array<CoverCommunicationLogRecipient>
  sentBy?: Maybe<CoverStaffRef>
  templateAlias: ScalarsEnums['String']
}

/**
 * A page of the communication log for a cover, newest first
 */
export interface CoverCommunicationLogPage {
  __typename?: 'CoverCommunicationLogPage'
  entries: Array<CoverCommunicationLogBatch>
  nextCursor?: Maybe<ScalarsEnums['String']>
}

/**
 * What happened on one channel for one recipient of a cover notification
 */
export interface CoverCommunicationLogRecipient {
  __typename?: 'CoverCommunicationLogRecipient'
  channel: ScalarsEnums['CoverCommunicationChannel']
  failureReason?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  skipReason?: Maybe<ScalarsEnums['CoverCommunicationSkipReason']>
  staffUserId: ScalarsEnums['String']
  status: ScalarsEnums['CoverCommunicationStatus']
}

/**
 * A class that clashes with the class being covered
 */
export interface CoverConflict {
  __typename?: 'CoverConflict'
  endTime: ScalarsEnums['String']
  name: ScalarsEnums['String']
  sessionId: ScalarsEnums['String']
  siteId: ScalarsEnums['String']
  startTime: ScalarsEnums['String']
}

/**
 * Whether an instructor would be offered a cover, and why not
 */
export interface CoverEligibility {
  __typename?: 'CoverEligibility'
  conflicts: Array<CoverConflict>
  eligible: ScalarsEnums['Boolean']
  isCrossSite: ScalarsEnums['Boolean']
  isPreferred: ScalarsEnums['Boolean']
  name: ScalarsEnums['String']
  reasons: Array<ScalarsEnums['CoverIneligibilityReason']>
  staffUserId: ScalarsEnums['String']
  warnings: Array<ScalarsEnums['CoverEligibilityWarning']>
}

export interface CoverImagePosition {
  __typename?: 'CoverImagePosition'
  x: ScalarsEnums['Float']
  y: ScalarsEnums['Float']
}

export interface CoverImageUploadUrl {
  __typename?: 'CoverImageUploadUrl'
  expiresAt: ScalarsEnums['String']
  publicUrl: ScalarsEnums['String']
  uploadUrl: ScalarsEnums['String']
}

/**
 * Someone a manager can send a cover message to
 */
export interface CoverMessageAudienceMember {
  __typename?: 'CoverMessageAudienceMember'
  canReceiveSms: ScalarsEnums['Boolean']
  name: ScalarsEnums['String']
  recipientModes: Array<ScalarsEnums['CoverMessageRecipientMode']>
  role: ScalarsEnums['CoverMessageAudienceRole']
  staffUserId: ScalarsEnums['String']
}

/**
 * A message on a cover thread
 */
export interface CoverMessageView {
  __typename?: 'CoverMessageView'
  author: CoverStaffRef
  body: ScalarsEnums['String']
  /**
   * The message as rich-text editor JSON; null for a plain-text message
   */
  bodyJson?: Maybe<ScalarsEnums['JSON']>
  channels: Array<ScalarsEnums['CoverMessageChannel']>
  coverMessageId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  isBroadcast: ScalarsEnums['Boolean']
  recipientCount?: Maybe<ScalarsEnums['Int']>
  recipientMode: ScalarsEnums['CoverMessageRecipientMode']
}

/**
 * The signed-in instructor’s own one-at-a-time offer for a cover
 */
export interface CoverMyOfferView {
  __typename?: 'CoverMyOfferView'
  isMyTurn: ScalarsEnums['Boolean']
  respondByAt?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['CoverOfferStatus']
}

/**
 * One step of a one-at-a-time cover offer: who it went to and how they responded
 */
export interface CoverOfferTurnView {
  __typename?: 'CoverOfferTurnView'
  name: ScalarsEnums['String']
  offeredAt?: Maybe<ScalarsEnums['String']>
  rank?: Maybe<ScalarsEnums['Float']>
  respondByAt?: Maybe<ScalarsEnums['String']>
  respondedAt?: Maybe<ScalarsEnums['String']>
  staffUserId: ScalarsEnums['String']
  status: ScalarsEnums['CoverOfferStatus']
}

/**
 * A ranked preferred sub for a location, optionally for one class type
 */
export interface CoverPreferredSubView {
  __typename?: 'CoverPreferredSubView'
  name: ScalarsEnums['String']
  rank: ScalarsEnums['Float']
  sessionTypeId?: Maybe<ScalarsEnums['String']>
  staffUserId: ScalarsEnums['String']
}

/**
 * A class cover request
 */
export interface CoverRequestView {
  __typename?: 'CoverRequestView'
  approvalMode: ScalarsEnums['CoverApprovalMode']
  blastAt?: Maybe<ScalarsEnums['String']>
  blastedAt?: Maybe<ScalarsEnums['String']>
  cancelReason?: Maybe<ScalarsEnums['CoverCancelReason']>
  claims: Array<CoverClaimView>
  coverGroupId?: Maybe<ScalarsEnums['String']>
  coverRequestId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  deadlineAt?: Maybe<ScalarsEnums['String']>
  escalatedAt?: Maybe<ScalarsEnums['String']>
  filledAt?: Maybe<ScalarsEnums['String']>
  filledBy?: Maybe<CoverStaffRef>
  filledVia?: Maybe<ScalarsEnums['CoverFilledVia']>
  isAwaitingRelease: ScalarsEnums['Boolean']
  isClaimable: ScalarsEnums['Boolean']
  isInWaterfall: ScalarsEnums['Boolean']
  isLastMinute: ScalarsEnums['Boolean']
  locationName?: Maybe<ScalarsEnums['String']>
  myClaimStatus?: Maybe<ScalarsEnums['CoverClaimStatus']>
  myOffer?: Maybe<CoverMyOfferView>
  noteToSubs?: Maybe<ScalarsEnums['String']>
  notifyMembersByDefault: ScalarsEnums['Boolean']
  offerStrategy?: Maybe<ScalarsEnums['CoverOfferStrategy']>
  offerTurns: Array<CoverOfferTurnView>
  originalInstructor: CoverStaffRef
  parentCoverRequestId?: Maybe<ScalarsEnums['String']>
  reason?: Maybe<ScalarsEnums['String']>
  requestedBy: CoverStaffRef
  sessionEndTime: ScalarsEnums['String']
  sessionId: ScalarsEnums['String']
  sessionName: ScalarsEnums['String']
  sessionStartTime: ScalarsEnums['String']
  sessionTypeId?: Maybe<ScalarsEnums['String']>
  sessionTypeName?: Maybe<ScalarsEnums['String']>
  siteId: ScalarsEnums['String']
  siteName?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['CoverRequestStatus']
  timezone: ScalarsEnums['String']
  viewerCanMessage: ScalarsEnums['Boolean']
}

/**
 * The latest cover request on a scheduled class, for schedule badges
 */
export interface CoverSessionBadge {
  __typename?: 'CoverSessionBadge'
  coverRequestId: ScalarsEnums['String']
  isLastMinute: ScalarsEnums['Boolean']
  originalStaffUserId: ScalarsEnums['String']
  sessionId: ScalarsEnums['String']
  status: ScalarsEnums['CoverRequestStatus']
}

/**
 * Class cover settings after applying code defaults, then the brand default row, then the site row
 */
export interface CoverSettings {
  __typename?: 'CoverSettings'
  approvalMode: ScalarsEnums['CoverApprovalMode']
  crossSiteCoversEnabled: ScalarsEnums['Boolean']
  escalateBeforeStartMinutes: ScalarsEnums['Float']
  lastMinuteThresholdMinutes: ScalarsEnums['Float']
  memberNotification: ScalarsEnums['CoverMemberNotification']
  offerStrategy: ScalarsEnums['CoverOfferStrategy']
  offerWindowMinutes: ScalarsEnums['Float']
  quietHoursEnd: ScalarsEnums['String']
  quietHoursStart: ScalarsEnums['String']
  reminderEnabled: ScalarsEnums['Boolean']
  selfServeCutoffMinutes: ScalarsEnums['Float']
  showSubMarkerToMembers: ScalarsEnums['Boolean']
  smsEnabled: ScalarsEnums['Boolean']
  tier1WindowMinutes: ScalarsEnums['Float']
  tier2WindowMinutes: ScalarsEnums['Float']
  travelBufferMinutes: ScalarsEnums['Float']
}

/**
 * Stored class cover settings for a site or the brand default; an empty field inherits the next level up
 */
export interface CoverSettingsOverrides {
  __typename?: 'CoverSettingsOverrides'
  approvalMode?: Maybe<ScalarsEnums['CoverApprovalMode']>
  crossSiteCoversEnabled?: Maybe<ScalarsEnums['Boolean']>
  escalateBeforeStartMinutes?: Maybe<ScalarsEnums['Float']>
  lastMinuteThresholdMinutes?: Maybe<ScalarsEnums['Float']>
  memberNotification?: Maybe<ScalarsEnums['CoverMemberNotification']>
  offerStrategy?: Maybe<ScalarsEnums['CoverOfferStrategy']>
  offerWindowMinutes?: Maybe<ScalarsEnums['Float']>
  quietHoursEnd?: Maybe<ScalarsEnums['String']>
  quietHoursStart?: Maybe<ScalarsEnums['String']>
  reminderEnabled?: Maybe<ScalarsEnums['Boolean']>
  selfServeCutoffMinutes?: Maybe<ScalarsEnums['Float']>
  showSubMarkerToMembers?: Maybe<ScalarsEnums['Boolean']>
  smsEnabled?: Maybe<ScalarsEnums['Boolean']>
  travelBufferMinutes?: Maybe<ScalarsEnums['Float']>
}

/**
 * The class types a staff member is qualified to cover at a location
 */
export interface CoverStaffQualifications {
  __typename?: 'CoverStaffQualifications'
  siteSessionTypeIds: Array<ScalarsEnums['String']>
  staffUserId: ScalarsEnums['String']
}

/**
 * A staff member on a class cover
 */
export interface CoverStaffRef {
  __typename?: 'CoverStaffRef'
  name: ScalarsEnums['String']
  staffUserId: ScalarsEnums['String']
}

/**
 * Result of pre-creating a staged add-on invoice
 */
export interface CreateAddonInvoiceResult {
  __typename?: 'CreateAddonInvoiceResult'
  invoiceId: ScalarsEnums['String']
}

export interface CreateClientFileResponse {
  __typename?: 'CreateClientFileResponse'
  /**
   * ID of the created record, to upload the document against
   */
  fileId: ScalarsEnums['ID']
}

/**
 * Response for creating a client note
 */
export interface CreateClientNoteResponse {
  __typename?: 'CreateClientNoteResponse'
  message?: Maybe<ScalarsEnums['String']>
  note?: Maybe<ClientNote>
  success: ScalarsEnums['Boolean']
}

/**
 * Response for client creation
 */
export interface CreateClientResponse {
  __typename?: 'CreateClientResponse'
  id: ScalarsEnums['String']
}

/**
 * Response containing the newly created category
 */
export interface CreatePosCategoryResponse {
  __typename?: 'CreatePosCategoryResponse'
  createdAt: ScalarsEnums['String']
  createdBy: ScalarsEnums['ID']
  description?: Maybe<ScalarsEnums['String']>
  displayOrder?: Maybe<ScalarsEnums['Int']>
  name: ScalarsEnums['String']
  posCategoryId: ScalarsEnums['ID']
  revenueTagId?: Maybe<ScalarsEnums['String']>
  siteId: ScalarsEnums['ID']
  status: ScalarsEnums['PosCategoryStatus']
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['ID']>
}

/**
 * Response containing the ID of the newly created product
 */
export interface CreatePosProductResponse {
  __typename?: 'CreatePosProductResponse'
  posProductId: ScalarsEnums['ID']
}

export interface CreateSavedReportCategory {
  __typename?: 'CreateSavedReportCategory'
  corporateId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  createdAtLevel: ScalarsEnums['CreatedAtLevel']
  createdAtSiteId?: Maybe<ScalarsEnums['String']>
  createdBy: ScalarsEnums['String']
  name: ScalarsEnums['String']
  savedReportCategoryId: ScalarsEnums['String']
  sortOrder: ScalarsEnums['Float']
  updatedAt: ScalarsEnums['String']
  visibilityScope: ScalarsEnums['VisibilityScope']
}

/**
 * Response containing the newly created service template category
 */
export interface CreateServiceTemplateCategoryResponse {
  __typename?: 'CreateServiceTemplateCategoryResponse'
  createdAt: ScalarsEnums['String']
  createdBy: ScalarsEnums['String']
  description?: Maybe<ScalarsEnums['String']>
  displayOrder?: Maybe<ScalarsEnums['Float']>
  name: ScalarsEnums['String']
  serviceTemplateCategoryId: ScalarsEnums['String']
  siteId: ScalarsEnums['String']
  status: ScalarsEnums['ServiceTemplateCategoryStatus']
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['String']>
}

/**
 * Response from creating a Grow location
 */
export interface CreateSiteLocationResponse {
  __typename?: 'CreateSiteLocationResponse'
  locationId?: Maybe<ScalarsEnums['String']>
  message: ScalarsEnums['String']
  success: ScalarsEnums['Boolean']
}

export interface CreateSitePayrollTier {
  __typename?: 'CreateSitePayrollTier'
  createdAt: ScalarsEnums['String']
  deletedAt?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  siteId: ScalarsEnums['ID']
  sitePayrollTierId: ScalarsEnums['ID']
  updatedAt: ScalarsEnums['String']
}

export interface CreateSitePayrollTierConfiguration {
  __typename?: 'CreateSitePayrollTierConfiguration'
  createdAt: ScalarsEnums['String']
  deletedAt?: Maybe<ScalarsEnums['String']>
  payrollTierConfigurationId: ScalarsEnums['ID']
  payrollType: ScalarsEnums['PayrollType']
  rates: SitePayrollTierConfigurationsRates
  siteId: ScalarsEnums['ID']
  sitePayrollTierId: ScalarsEnums['ID']
  siteSessionTypeId?: Maybe<ScalarsEnums['ID']>
  siteSessionTypeName?: Maybe<ScalarsEnums['String']>
  type: ScalarsEnums['PayrollTierType']
  updatedAt: ScalarsEnums['String']
}

/**
 * Response containing the newly created site supplier
 */
export interface CreateSiteSupplierResponse {
  __typename?: 'CreateSiteSupplierResponse'
  address?: Maybe<ScalarsEnums['String']>
  createdAt: ScalarsEnums['String']
  createdBy: ScalarsEnums['String']
  name: ScalarsEnums['String']
  phone?: Maybe<ScalarsEnums['String']>
  siteId: ScalarsEnums['String']
  siteSupplierId: ScalarsEnums['String']
  status: ScalarsEnums['SiteSupplierStatus']
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['String']>
}

export interface CreateSiteWebhook {
  __typename?: 'CreateSiteWebhook'
  consecutiveFailures: ScalarsEnums['Float']
  createdAt: ScalarsEnums['String']
  createdBy?: Maybe<ScalarsEnums['String']>
  events: Array<ScalarsEnums['String']>
  headerKey?: Maybe<ScalarsEnums['String']>
  headerValue?: Maybe<ScalarsEnums['String']>
  lastDeliveryAt?: Maybe<ScalarsEnums['String']>
  lastSuccessAt?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  secret?: Maybe<ScalarsEnums['String']>
  secretHash: ScalarsEnums['String']
  siteWebhookId: ScalarsEnums['String']
  status: ScalarsEnums['SiteWebhookStatus']
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['String']>
  url: ScalarsEnums['String']
  v1EncryptedId: ScalarsEnums['String']
}

/**
 * Response for creating a SOAP note
 */
export interface CreateSoapNoteResponse {
  __typename?: 'CreateSoapNoteResponse'
  message?: Maybe<ScalarsEnums['String']>
  note?: Maybe<SoapNote>
  success: ScalarsEnums['Boolean']
}

/**
 * A short-lived Stripe Account Session for Connect embedded components
 */
export interface CreateStripeAccountSession {
  __typename?: 'CreateStripeAccountSession'
  clientSecret: ScalarsEnums['String']
  expiresAt: ScalarsEnums['Float']
}

/**
 * A field definition for door provider credentials
 */
export interface CredentialField {
  __typename?: 'CredentialField'
  key: ScalarsEnums['String']
  label: ScalarsEnums['String']
  required: ScalarsEnums['Boolean']
  type: ScalarsEnums['CredentialFieldType']
}

/**
 * A credit adjustment note entry
 */
export interface CreditAdjustmentNote {
  __typename?: 'CreditAdjustmentNote'
  amount: ScalarsEnums['Float']
  authorId?: Maybe<ScalarsEnums['String']>
  direction: ScalarsEnums['ServiceCreditLedgerDirection']
  note: ScalarsEnums['String']
  timestamp: ScalarsEnums['String']
}

/**
 * Paginated credit adjustment notes result
 */
export interface CreditAdjustmentNotesResult {
  __typename?: 'CreditAdjustmentNotesResult'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasMore: ScalarsEnums['Boolean']
  notes: Array<CreditAdjustmentNote>
}

/**
 * Individual allocation balance snapshot for UI rendering
 */
export interface CreditBalanceAllocationSnapshot {
  __typename?: 'CreditBalanceAllocationSnapshot'
  activateOnFirstUse?: Maybe<ScalarsEnums['Boolean']>
  allocated?: Maybe<ScalarsEnums['Float']>
  allocationId: ScalarsEnums['String']
  balance?: Maybe<ScalarsEnums['Float']>
  consumed: ScalarsEnums['Float']
  creditType: ScalarsEnums['CreditType']
  expirationAmount?: Maybe<ScalarsEnums['Float']>
  expirationUnit?: Maybe<ScalarsEnums['String']>
  expiresAt?: Maybe<ScalarsEnums['String']>
  sessionTypeId?: Maybe<ScalarsEnums['String']>
  sessionTypeIds?: Maybe<Array<ScalarsEnums['String']>>
  sessionTypeName?: Maybe<ScalarsEnums['String']>
  validFrom?: Maybe<ScalarsEnums['String']>
  validTo?: Maybe<ScalarsEnums['String']>
}

/**
 * Optimized credit balance structure for UI rendering
 */
export interface CreditBalanceSnapshot {
  __typename?: 'CreditBalanceSnapshot'
  allocations: Array<CreditBalanceAllocationSnapshot>
  hasUnlimited: ScalarsEnums['Boolean']
  lastUpdated: ScalarsEnums['String']
  totalBalance?: Maybe<ScalarsEnums['Float']>
}

/**
 * Credit balance snapshot for a service
 */
export interface CreditBalanceSnapshotOutput {
  __typename?: 'CreditBalanceSnapshotOutput'
  allocations?: Maybe<Array<CreditBalanceSnapshotOutputAllocations>>
  hasUnlimited: ScalarsEnums['Boolean']
  lastUpdated?: Maybe<ScalarsEnums['String']>
  totalBalance?: Maybe<ScalarsEnums['Float']>
}

export interface CreditBalanceSnapshotOutputAllocations {
  __typename?: 'CreditBalanceSnapshotOutputAllocations'
  activateOnFirstUse?: Maybe<ScalarsEnums['Boolean']>
  allocated?: Maybe<ScalarsEnums['Float']>
  allocationId: ScalarsEnums['String']
  balance?: Maybe<ScalarsEnums['Float']>
  consumed: ScalarsEnums['Float']
  creditType: ScalarsEnums['String']
  expirationAmount?: Maybe<ScalarsEnums['Float']>
  expirationUnit?: Maybe<ScalarsEnums['String']>
  expiresAt?: Maybe<ScalarsEnums['String']>
  sessionTypeId?: Maybe<ScalarsEnums['String']>
  sessionTypeIds?: Maybe<Array<ScalarsEnums['String']>>
  sessionTypeName?: Maybe<ScalarsEnums['String']>
  validFrom?: Maybe<ScalarsEnums['String']>
  validTo?: Maybe<ScalarsEnums['String']>
}

/**
 * Individual billing period with credit allocation data for credits summary
 */
export interface CreditSummaryPeriod {
  __typename?: 'CreditSummaryPeriod'
  activationExpiryDescription?: Maybe<ScalarsEnums['String']>
  creditExpiresAtDate?: Maybe<ScalarsEnums['String']>
  creditsAllocated: ScalarsEnums['Float']
  creditsConsumed: ScalarsEnums['Float']
  hasRefund: ScalarsEnums['Boolean']
  isActivationPending?: Maybe<ScalarsEnums['Boolean']>
  isActive?: Maybe<ScalarsEnums['Boolean']>
  isMaterialized: ScalarsEnums['Boolean']
  isUnlimited: ScalarsEnums['Boolean']
  periodEndDate?: Maybe<ScalarsEnums['String']>
  periodId: ScalarsEnums['String']
  periodNumber: ScalarsEnums['Float']
  periodStartDate?: Maybe<ScalarsEnums['String']>
  sessionTypeBreakdown?: Maybe<Array<CreditSummaryPeriodSessionTypeBreakdown>>
}

/**
 * Per-session-type credit allocation breakdown within a period
 */
export interface CreditSummaryPeriodSessionTypeBreakdown {
  __typename?: 'CreditSummaryPeriodSessionTypeBreakdown'
  creditsAllocated: ScalarsEnums['Float']
  creditsConsumed: ScalarsEnums['Float']
  creditsRemaining: ScalarsEnums['Float']
  isUnlimited: ScalarsEnums['Boolean']
  sessionTypeName?: Maybe<ScalarsEnums['String']>
  siteSessionTypeIds: Array<ScalarsEnums['String']>
}

/**
 * All billing periods with credit data for a service
 */
export interface CreditSummaryResult {
  __typename?: 'CreditSummaryResult'
  periods: Array<CreditSummaryPeriod>
  totalPeriods: ScalarsEnums['Float']
}

/**
 * Credit usage entry for visits history
 */
export interface CreditUsageEntry {
  __typename?: 'CreditUsageEntry'
  amount?: Maybe<ScalarsEnums['Float']>
  bookingId?: Maybe<ScalarsEnums['String']>
  bookingStatus?: Maybe<ScalarsEnums['BookingStatus']>
  createdAt: ScalarsEnums['String']
  direction: ScalarsEnums['ServiceCreditLedgerDirection']
  /**
   * True when the booking belongs to a client other than the credit owner
   */
  isBuddyBooking?: Maybe<ScalarsEnums['Boolean']>
  /**
   * True when the credits were consumed via a shared-credit booking
   */
  isSharedBooking?: Maybe<ScalarsEnums['Boolean']>
  /**
   * True when the credits were charged for a waitlist entry that has no booking
   */
  isWaitlistEntry?: Maybe<ScalarsEnums['Boolean']>
  ledgerId: ScalarsEnums['String']
  notes?: Maybe<ScalarsEnums['String']>
  /**
   * Date of the session (YYYY-MM-DD)
   */
  sessionDate?: Maybe<ScalarsEnums['String']>
  /**
   * Name of the session associated with this credit usage
   */
  sessionName?: Maybe<ScalarsEnums['String']>
  /**
   * Start time of the session
   */
  sessionStartTime?: Maybe<ScalarsEnums['String']>
  /**
   * Name of the session type associated with this credit usage
   */
  sessionTypeName?: Maybe<ScalarsEnums['String']>
  siteId: ScalarsEnums['String']
  /**
   * Name of the site where the credits were used — the "Shared location" hover
   */
  siteName?: Maybe<ScalarsEnums['String']>
  siteSessionTypeId?: Maybe<ScalarsEnums['String']>
  transactionType: ScalarsEnums['ServiceCreditLedgerTransactionType']
  /**
   * Attendee display name for buddy/shared bookings — the visits "Used by" hover
   */
  usedByClientName?: Maybe<ScalarsEnums['String']>
}

/**
 * Paginated credit usage history result
 */
export interface CreditUsageHistoryResult {
  __typename?: 'CreditUsageHistoryResult'
  pageInfo: CreditUsageHistoryResultPageInfo
  results: Array<CreditUsageHistoryResultResults>
  /**
   * Booking credits used across the whole history, net of refunded credits
   */
  totalCreditsUsed: ScalarsEnums['Float']
}

export interface CreditUsageHistoryResultPageInfo {
  __typename?: 'CreditUsageHistoryResultPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface CreditUsageHistoryResultResults {
  __typename?: 'CreditUsageHistoryResultResults'
  cursor: ScalarsEnums['String']
  row: CreditUsageEntry
}

/**
 * Booking-gate result for a client + session + booking date, with rich per-package detail
 */
export interface CreditsCoverSessionResult {
  __typename?: 'CreditsCoverSessionResult'
  creditsAvailable: ScalarsEnums['Float']
  hasCredits: ScalarsEnums['Boolean']
  packages: Array<ClientBookingPackage>
}

/**
 * A scheduled or awaiting-payment plan change that moves a member to a membership in a different category
 */
export interface CrossCategoryScheduledPlanChange {
  __typename?: 'CrossCategoryScheduledPlanChange'
  clientId: ScalarsEnums['ID']
  clientName: ScalarsEnums['String']
  effectiveDate: ScalarsEnums['String']
  fromServiceTemplateName: ScalarsEnums['String']
  serviceId: ScalarsEnums['ID']
  servicePlanChangeId: ScalarsEnums['ID']
  status: ScalarsEnums['ServicePlanChangeStatus']
  toServiceTemplateName: ScalarsEnums['String']
}

/**
 * Admin navigation custom links
 */
export interface CustomLink {
  __typename?: 'CustomLink'
  customLinkId: ScalarsEnums['String']
  icon: ScalarsEnums['String']
  isVisible: ScalarsEnums['Boolean']
  label: ScalarsEnums['String']
  openingMethod: ScalarsEnums['CustomLinkOpeningMethod']
  order: ScalarsEnums['Float']
  url: ScalarsEnums['String']
}

/**
 * A custom property for collecting additional site data
 */
export interface CustomProperty {
  __typename?: 'CustomProperty'
  alerts?: Maybe<Array<CustomPropertyAlerts>>
  category: ScalarsEnums['CustomPropertyCategory']
  createdAt?: Maybe<ScalarsEnums['String']>
  deletedAt?: Maybe<ScalarsEnums['String']>
  enableClientEditing: ScalarsEnums['Boolean']
  growId?: Maybe<ScalarsEnums['String']>
  hasSubtext: ScalarsEnums['Boolean']
  id: ScalarsEnums['String']
  name: ScalarsEnums['String']
  options?: Maybe<Array<CustomPropertyOptions>>
  siteId: ScalarsEnums['String']
  subtext?: Maybe<ScalarsEnums['String']>
  type: ScalarsEnums['CustomPropertyType']
  updatedAt?: Maybe<ScalarsEnums['String']>
}

export interface CustomPropertyAlerts {
  __typename?: 'CustomPropertyAlerts'
  createdAt?: Maybe<ScalarsEnums['String']>
  deletedAt?: Maybe<ScalarsEnums['String']>
  id?: Maybe<ScalarsEnums['String']>
  isDisplayPropertyValueAsAlert: ScalarsEnums['Boolean']
  operator: ScalarsEnums['AlertOperator']
  propertyId?: Maybe<ScalarsEnums['String']>
  text?: Maybe<ScalarsEnums['String']>
  updatedAt?: Maybe<ScalarsEnums['String']>
  value?: Maybe<ScalarsEnums['String']>
}

export interface CustomPropertyOptions {
  __typename?: 'CustomPropertyOptions'
  displayOrder?: Maybe<ScalarsEnums['Float']>
  id?: Maybe<ScalarsEnums['String']>
  option: ScalarsEnums['String']
}

/**
 * A site custom property definition with optional client value
 */
export interface CustomPropertyWithClientValue {
  __typename?: 'CustomPropertyWithClientValue'
  alerts?: Maybe<Array<CustomPropertyWithClientValueAlerts>>
  category: ScalarsEnums['String']
  clientValue?: Maybe<CustomPropertyWithClientValueClientValue>
  createdAt?: Maybe<ScalarsEnums['String']>
  deletedAt?: Maybe<ScalarsEnums['String']>
  enableClientEditing: ScalarsEnums['Boolean']
  growId?: Maybe<ScalarsEnums['String']>
  hasSubtext: ScalarsEnums['Boolean']
  id: ScalarsEnums['String']
  name: ScalarsEnums['String']
  options?: Maybe<Array<CustomPropertyWithClientValueOptions>>
  siteId: ScalarsEnums['String']
  subtext?: Maybe<ScalarsEnums['String']>
  type: ScalarsEnums['String']
  updatedAt?: Maybe<ScalarsEnums['String']>
}

export interface CustomPropertyWithClientValueAlerts {
  __typename?: 'CustomPropertyWithClientValueAlerts'
  createdAt?: Maybe<ScalarsEnums['String']>
  id?: Maybe<ScalarsEnums['String']>
  isDisplayPropertyValueAsAlert: ScalarsEnums['Boolean']
  operator: ScalarsEnums['String']
  propertyId?: Maybe<ScalarsEnums['String']>
  text?: Maybe<ScalarsEnums['String']>
  value?: Maybe<ScalarsEnums['String']>
}

export interface CustomPropertyWithClientValueClientValue {
  __typename?: 'CustomPropertyWithClientValueClientValue'
  customPropertyValueId: ScalarsEnums['String']
  updatedAt: ScalarsEnums['String']
  value?: Maybe<ScalarsEnums['String']>
}

export interface CustomPropertyWithClientValueOptions {
  __typename?: 'CustomPropertyWithClientValueOptions'
  displayOrder?: Maybe<ScalarsEnums['Float']>
  id?: Maybe<ScalarsEnums['String']>
  option: ScalarsEnums['String']
}

export interface CustomizationStats {
  __typename?: 'CustomizationStats'
  configuredLanguages: Array<ScalarsEnums['String']>
  customizationsByLanguage: ScalarsEnums['JSONObject']
  totalCustomizations: ScalarsEnums['Float']
}

/**
 * Dashboard KPI card data with period-over-period comparison
 */
export interface DashboardKpisResponse {
  __typename?: 'DashboardKpisResponse'
  activeMembers: ScalarsEnums['Float']
  currency: ScalarsEnums['String']
  newMembers: ScalarsEnums['Float']
  newMembersPrevious: ScalarsEnums['Float']
  totalRevenue: ScalarsEnums['Float']
  totalRevenuePrevious: ScalarsEnums['Float']
  totalVisits: ScalarsEnums['Float']
  totalVisitsPrevious: ScalarsEnums['Float']
}

/**
 * Mobile dashboard data matching HomeInfo interface
 */
export interface DashboardMobile {
  __typename?: 'DashboardMobile'
  barcode?: Maybe<ScalarsEnums['String']>
  failedPayments?: Maybe<Array<MobileFailedPayment>>
  introOffer?: Maybe<Array<MobileIntroOffer>>
  joinDate?: Maybe<ScalarsEnums['String']>
  nextBooking?: Maybe<Array<NextBooking>>
  outstandingPayments?: Maybe<Array<MobileOutstandingPayment>>
  pendingForms?: Maybe<Array<MemberPendingForm>>
  pendingPolicies?: Maybe<Array<MobilePendingPolicy>>
  statsLast30?: Maybe<ScalarsEnums['Float']>
  statsLifetime?: Maybe<ScalarsEnums['Float']>
  statsWeekly?: Maybe<ScalarsEnums['Float']>
}

/**
 * Paginated sessions for a single day
 */
export interface DaySessionsPage {
  __typename?: 'DaySessionsPage'
  hasNextPage: ScalarsEnums['Boolean']
  nextCursor?: Maybe<ScalarsEnums['String']>
  sessions: Array<MonthViewSession>
  totalCount: ScalarsEnums['Float']
}

export interface DeepLink {
  __typename?: 'DeepLink'
  branchLinkId?: Maybe<ScalarsEnums['String']>
  branchUrl?: Maybe<ScalarsEnums['String']>
  campaign?: Maybe<ScalarsEnums['String']>
  canonicalIdentifier: ScalarsEnums['String']
  corporateId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  createdBy?: Maybe<ScalarsEnums['String']>
  deepLinkId: ScalarsEnums['String']
  description?: Maybe<ScalarsEnums['String']>
  feature?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  ogDescription?: Maybe<ScalarsEnums['String']>
  ogImageUrl?: Maybe<ScalarsEnums['String']>
  ogTitle?: Maybe<ScalarsEnums['String']>
  tags?: Maybe<Array<ScalarsEnums['String']>>
  targetParams?: Maybe<ScalarsEnums['JSONObject']>
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['String']>
  version: ScalarsEnums['Float']
}

export interface DeepLinkDestinations {
  __typename?: 'DeepLinkDestinations'
  canonicalIdentifier: ScalarsEnums['String']
  description: ScalarsEnums['String']
  label: ScalarsEnums['String']
  optionalParams: Array<ScalarsEnums['String']>
  requiredParams: Array<ScalarsEnums['String']>
}

export interface DeepLinkSettings {
  __typename?: 'DeepLinkSettings'
  androidUrl?: Maybe<ScalarsEnums['String']>
  desktopUrl?: Maybe<ScalarsEnums['String']>
  fallbackUrl?: Maybe<ScalarsEnums['String']>
  iosUrl?: Maybe<ScalarsEnums['String']>
}

export interface DeepLinks {
  __typename?: 'DeepLinks'
  pageInfo: DeepLinksPageInfo
  results: Array<DeepLinksResults>
}

export interface DeepLinksPageInfo {
  __typename?: 'DeepLinksPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface DeepLinksResults {
  __typename?: 'DeepLinksResults'
  cursor: ScalarsEnums['String']
  row: DeepLink
}

export interface DefaultText {
  __typename?: 'DefaultText'
  defaultText?: Maybe<ScalarsEnums['String']>
  key: ScalarsEnums['String']
  language: ScalarsEnums['String']
}

export interface DeleteAggregatorProvider {
  __typename?: 'DeleteAggregatorProvider'
  success: ScalarsEnums['Boolean']
}

export interface DeleteClientBuddy {
  __typename?: 'DeleteClientBuddy'
  success: ScalarsEnums['Boolean']
}

/**
 * Response for deleting client custom property values
 */
export interface DeleteClientCustomPropertyValuesResponse {
  __typename?: 'DeleteClientCustomPropertyValuesResponse'
  message?: Maybe<ScalarsEnums['String']>
  success: ScalarsEnums['Boolean']
}

export interface DeleteClientFileResponse {
  __typename?: 'DeleteClientFileResponse'
  success: ScalarsEnums['Boolean']
}

/**
 * Response for deleting a client note
 */
export interface DeleteClientNoteResponse {
  __typename?: 'DeleteClientNoteResponse'
  message?: Maybe<ScalarsEnums['String']>
  success: ScalarsEnums['Boolean']
}

export interface DeleteClientRelation {
  __typename?: 'DeleteClientRelation'
  success: ScalarsEnums['Boolean']
}

/**
 * Response for client deletion
 */
export interface DeleteClientResponse {
  __typename?: 'DeleteClientResponse'
  result: Client
}

export interface DeleteDeepLink {
  __typename?: 'DeleteDeepLink'
  success: ScalarsEnums['Boolean']
}

/**
 * Response for form submission deletion
 */
export interface DeleteFormSubmissionResponse {
  __typename?: 'DeleteFormSubmissionResponse'
  message?: Maybe<ScalarsEnums['String']>
  success: ScalarsEnums['Boolean']
}

export interface DeleteGiftCardExpiryRule {
  __typename?: 'DeleteGiftCardExpiryRule'
  success: ScalarsEnums['Boolean']
}

export interface DeleteMigration {
  __typename?: 'DeleteMigration'
  success: ScalarsEnums['Boolean']
}

export interface DeleteMobileAppBranding {
  __typename?: 'DeleteMobileAppBranding'
  success: ScalarsEnums['Boolean']
}

export interface DeleteMobileAppChannels {
  __typename?: 'DeleteMobileAppChannels'
  success: ScalarsEnums['Boolean']
}

export interface DeleteMobileAppProfile {
  __typename?: 'DeleteMobileAppProfile'
  success: ScalarsEnums['Boolean']
}

/**
 * Response indicating success of category deletion
 */
export interface DeletePosCategoryResponse {
  __typename?: 'DeletePosCategoryResponse'
  success: ScalarsEnums['Boolean']
}

/**
 * Response indicating success of product variable deletion
 */
export interface DeletePosProductVariableResponse {
  __typename?: 'DeletePosProductVariableResponse'
  success: ScalarsEnums['Boolean']
}

export interface DeleteSavedReport {
  __typename?: 'DeleteSavedReport'
  success: ScalarsEnums['Boolean']
}

/**
 * Response indicating success of service template category deletion
 */
export interface DeleteServiceTemplateCategoryResponse {
  __typename?: 'DeleteServiceTemplateCategoryResponse'
  success: ScalarsEnums['Boolean']
}

export interface DeleteSessionFeedback {
  __typename?: 'DeleteSessionFeedback'
  success: ScalarsEnums['Boolean']
}

/**
 * Outcome of deleting sessions
 */
export interface DeleteSessionOccurrencesResult {
  __typename?: 'DeleteSessionOccurrencesResult'
  affectedMemberCount: ScalarsEnums['Float']
  cancelledCount: ScalarsEnums['Float']
  deletedCount: ScalarsEnums['Float']
  patternsEnded: ScalarsEnums['Float']
}

/**
 * Response indicating success of site supplier deletion
 */
export interface DeleteSiteSupplierResponse {
  __typename?: 'DeleteSiteSupplierResponse'
  success: ScalarsEnums['Boolean']
}

/**
 * Response for deleting a SOAP note
 */
export interface DeleteSoapNoteResponse {
  __typename?: 'DeleteSoapNoteResponse'
  message?: Maybe<ScalarsEnums['String']>
  success: ScalarsEnums['Boolean']
}

export interface DeleteTestMember {
  __typename?: 'DeleteTestMember'
  clientId: ScalarsEnums['String']
}

export interface DeleteThirdPartyIntegration {
  __typename?: 'DeleteThirdPartyIntegration'
  success: ScalarsEnums['Boolean']
}

export interface DeleteThirdPartyIntegrationKey {
  __typename?: 'DeleteThirdPartyIntegrationKey'
  success: ScalarsEnums['Boolean']
}

export interface DeletedKnowledgeArticlesResponse {
  __typename?: 'DeletedKnowledgeArticlesResponse'
  articles: Array<KnowledgeArticle>
  hasMore: ScalarsEnums['Boolean']
  totalCount: ScalarsEnums['Int']
}

/**
 * Configuration options for demo seeding
 */
export interface DemoSeedingConfig {
  __typename?: 'DemoSeedingConfig'
  density?: Maybe<ScalarsEnums['DemoSeedingDensity']>
  locationCount: ScalarsEnums['Float']
  timeRangeMonths: ScalarsEnums['Float']
}

/**
 * Counts of deleted entities by type
 */
export interface DemoSeedingDeletedCounts {
  __typename?: 'DemoSeedingDeletedCounts'
  attendance?: Maybe<ScalarsEnums['Float']>
  bookings?: Maybe<ScalarsEnums['Float']>
  checkIns?: Maybe<ScalarsEnums['Float']>
  clientAccountCreditsEntries?: Maybe<ScalarsEnums['Float']>
  clientSites?: Maybe<ScalarsEnums['Float']>
  clients?: Maybe<ScalarsEnums['Float']>
  invoiceItems?: Maybe<ScalarsEnums['Float']>
  invoiceStatusLogs?: Maybe<ScalarsEnums['Float']>
  invoices?: Maybe<ScalarsEnums['Float']>
  locations?: Maybe<ScalarsEnums['Float']>
  payments?: Maybe<ScalarsEnums['Float']>
  promoCodeUses?: Maybe<ScalarsEnums['Float']>
  promoCodes?: Maybe<ScalarsEnums['Float']>
  rooms?: Maybe<ScalarsEnums['Float']>
  serviceCreditTemplates?: Maybe<ScalarsEnums['Float']>
  serviceTemplates?: Maybe<ScalarsEnums['Float']>
  sessionFilters?: Maybe<ScalarsEnums['Float']>
  sessionTemplates?: Maybe<ScalarsEnums['Float']>
  sessionTypes?: Maybe<ScalarsEnums['Float']>
  sessions?: Maybe<ScalarsEnums['Float']>
  sites?: Maybe<ScalarsEnums['Float']>
  smartGroups?: Maybe<ScalarsEnums['Float']>
  staff?: Maybe<ScalarsEnums['Float']>
  staffUserSites?: Maybe<ScalarsEnums['Float']>
  waitlistEntries?: Maybe<ScalarsEnums['Float']>
}

/**
 * Statistics from data generation phase
 */
export interface DemoSeedingGenerationStats {
  __typename?: 'DemoSeedingGenerationStats'
  accountCredits?: Maybe<ScalarsEnums['Float']>
  attendance?: Maybe<ScalarsEnums['Float']>
  bookings?: Maybe<ScalarsEnums['Float']>
  checkIns?: Maybe<ScalarsEnums['Float']>
  clientSites?: Maybe<ScalarsEnums['Float']>
  clients?: Maybe<ScalarsEnums['Float']>
  invoiceItems?: Maybe<ScalarsEnums['Float']>
  invoices?: Maybe<ScalarsEnums['Float']>
  locations?: Maybe<ScalarsEnums['Float']>
  payments?: Maybe<ScalarsEnums['Float']>
  promoCodes?: Maybe<ScalarsEnums['Float']>
  rooms?: Maybe<ScalarsEnums['Float']>
  serviceTemplates?: Maybe<ScalarsEnums['Float']>
  sessionFilters?: Maybe<ScalarsEnums['Float']>
  sessionTemplates?: Maybe<ScalarsEnums['Float']>
  sessionTypes?: Maybe<ScalarsEnums['Float']>
  sessions?: Maybe<ScalarsEnums['Float']>
  sites?: Maybe<ScalarsEnums['Float']>
  smartGroups?: Maybe<ScalarsEnums['Float']>
  staff?: Maybe<ScalarsEnums['Float']>
  waitlistEntries?: Maybe<ScalarsEnums['Float']>
}

/**
 * Counts of inserted entities by type
 */
export interface DemoSeedingInsertedCounts {
  __typename?: 'DemoSeedingInsertedCounts'
  accountCredits?: Maybe<ScalarsEnums['Float']>
  attendance?: Maybe<ScalarsEnums['Float']>
  bookings?: Maybe<ScalarsEnums['Float']>
  checkIns?: Maybe<ScalarsEnums['Float']>
  clientSites?: Maybe<ScalarsEnums['Float']>
  clients?: Maybe<ScalarsEnums['Float']>
  invoiceItems?: Maybe<ScalarsEnums['Float']>
  invoices?: Maybe<ScalarsEnums['Float']>
  locations?: Maybe<ScalarsEnums['Float']>
  payments?: Maybe<ScalarsEnums['Float']>
  promoCodes?: Maybe<ScalarsEnums['Float']>
  rooms?: Maybe<ScalarsEnums['Float']>
  serviceTemplates?: Maybe<ScalarsEnums['Float']>
  sessionFilters?: Maybe<ScalarsEnums['Float']>
  sessionTemplates?: Maybe<ScalarsEnums['Float']>
  sessionTypes?: Maybe<ScalarsEnums['Float']>
  sessions?: Maybe<ScalarsEnums['Float']>
  sites?: Maybe<ScalarsEnums['Float']>
  smartGroups?: Maybe<ScalarsEnums['Float']>
  staff?: Maybe<ScalarsEnums['Float']>
  waitlistEntries?: Maybe<ScalarsEnums['Float']>
}

/**
 * Demo seeding job record
 */
export interface DemoSeedingJob {
  __typename?: 'DemoSeedingJob'
  completedAt?: Maybe<ScalarsEnums['String']>
  config: DemoSeedingConfig
  corporateId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  createdBy: ScalarsEnums['String']
  createdByName?: Maybe<ScalarsEnums['String']>
  error?: Maybe<ScalarsEnums['String']>
  jobId: ScalarsEnums['String']
  persona: ScalarsEnums['DemoSeedingPersona']
  progress?: Maybe<ScalarsEnums['Float']>
  progressDetails?: Maybe<DemoSeedingProgressDetails>
  siteIds?: Maybe<Array<ScalarsEnums['String']>>
  siteNames?: Maybe<Array<ScalarsEnums['String']>>
  startedAt?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['DemoSeedingJobStatus']
  updatedAt: ScalarsEnums['String']
}

/**
 * Progress breakdown by entity type
 */
export interface DemoSeedingProgressDetails {
  __typename?: 'DemoSeedingProgressDetails'
  attendance?: Maybe<ScalarsEnums['Float']>
  bookings?: Maybe<ScalarsEnums['Float']>
  currentPhase?: Maybe<ScalarsEnums['String']>
  deleted?: Maybe<DemoSeedingDeletedCounts>
  entitiesGenerated?: Maybe<ScalarsEnums['Float']>
  inserted?: Maybe<DemoSeedingInsertedCounts>
  members?: Maybe<ScalarsEnums['Float']>
  memberships?: Maybe<ScalarsEnums['Float']>
  payments?: Maybe<ScalarsEnums['Float']>
  percent?: Maybe<ScalarsEnums['Float']>
  phase?: Maybe<ScalarsEnums['String']>
  schedules?: Maybe<ScalarsEnums['Float']>
  stats?: Maybe<DemoSeedingGenerationStats>
  verificationDiscrepancies?: Maybe<Array<ScalarsEnums['String']>>
  verificationRemaining?: Maybe<Array<ScalarsEnums['String']>>
  verified?: Maybe<ScalarsEnums['Boolean']>
}

export interface DestinationFeeChargeStatus {
  __typename?: 'DestinationFeeChargeStatus'
  alreadyChargedToday: ScalarsEnums['Boolean']
  chargedInvoiceId?: Maybe<ScalarsEnums['String']>
  chargedInvoiceStatus?: Maybe<ScalarsEnums['InvoiceStatus']>
}

export interface DetectImportType {
  __typename?: 'DetectImportType'
  bestMatch?: Maybe<ScalarsEnums['String']>
  matches: Array<DetectImportTypeMatches>
}

export interface DetectImportTypeMatches {
  __typename?: 'DetectImportTypeMatches'
  allRequiredPresent: ScalarsEnums['Boolean']
  importType: ScalarsEnums['String']
  matchedColumnCount: ScalarsEnums['Float']
  missingRequired: Array<ScalarsEnums['String']>
  requiredFieldCount: ScalarsEnums['Float']
}

export interface DirectUploadImage {
  __typename?: 'DirectUploadImage'
  /**
   * Ready-to-use image URL: public, or signed for private targets
   */
  url: ScalarsEnums['String']
}

export interface DirectUploadUrlResponse {
  __typename?: 'DirectUploadUrlResponse'
  /**
   * URL the image will be readable at once the PUT completes
   */
  fileUrl: ScalarsEnums['String']
  /**
   * Opaque reference to the uploaded object, echoed back from the upload URL response
   */
  uploadRef: ScalarsEnums['String']
  /**
   * Short-lived signed URL to PUT the image to
   */
  uploadUrl: ScalarsEnums['String']
}

export interface DismissBlockedMovementResult {
  __typename?: 'DismissBlockedMovementResult'
  dismissed: ScalarsEnums['Boolean']
  memberMovementId: ScalarsEnums['ID']
}

/**
 * The revision of a site policy in force now, which every reader shows
 */
export interface DisplayedSitePolicyRevision {
  __typename?: 'DisplayedSitePolicyRevision'
  content: ScalarsEnums['String']
  name: ScalarsEnums['String']
  policyRevisionId: ScalarsEnums['ID']
  revisionSha256: ScalarsEnums['String']
  sitePolicyId: ScalarsEnums['ID']
}

/**
 * A payment dispute raised by a customer or payment gateway
 */
export interface Dispute {
  __typename?: 'Dispute'
  amount: ScalarsEnums['Numeric']
  createdAt: ScalarsEnums['String']
  disputeId: ScalarsEnums['ID']
  evidenceDueDate?: Maybe<ScalarsEnums['String']>
  externalAttemptId: ScalarsEnums['String']
  externalDisputeId: ScalarsEnums['String']
  externalPaymentId: ScalarsEnums['String']
  gatewayType: ScalarsEnums['GatewayType']
  openedAt?: Maybe<ScalarsEnums['String']>
  paymentGatewayTransactionId: ScalarsEnums['ID']
  paymentId: ScalarsEnums['ID']
  providerAccountId: ScalarsEnums['String']
  reason?: Maybe<ScalarsEnums['String']>
  refundId?: Maybe<ScalarsEnums['ID']>
  siteId: ScalarsEnums['ID']
  status: ScalarsEnums['DisputeStatus']
  wonAt?: Maybe<ScalarsEnums['String']>
}

/**
 * DNS record for email domain verification
 */
export interface DnsRecord {
  __typename?: 'DnsRecord'
  name: ScalarsEnums['String']
  priority?: Maybe<ScalarsEnums['Float']>
  status: ScalarsEnums['DnsRecordStatus']
  ttl?: Maybe<ScalarsEnums['String']>
  type: ScalarsEnums['DnsRecordType']
  value: ScalarsEnums['String']
}

export interface DocumentFileVersion {
  __typename?: 'DocumentFileVersion'
  format: ScalarsEnums['DocumentFileVersionFormat']
  size?: Maybe<ScalarsEnums['Float']>
  type: ScalarsEnums['DocumentFileVersionType']
  url: ScalarsEnums['String']
}

/**
 * One door access attempt: who, where, and the gate that allowed or denied it
 */
export interface DoorAccessEvent {
  __typename?: 'DoorAccessEvent'
  clientId?: Maybe<ScalarsEnums['String']>
  createdAt: ScalarsEnums['String']
  credentialType: ScalarsEnums['DoorAccessCredentialType']
  deniedBy?: Maybe<ScalarsEnums['DoorAccessEventDeniedBy']>
  doorAccessEventId: ScalarsEnums['String']
  failReason?: Maybe<ScalarsEnums['String']>
  outcome: ScalarsEnums['DoorAccessOutcome']
  provider?: Maybe<ScalarsEnums['AccessProvider']>
  siteAccessPointId?: Maybe<ScalarsEnums['String']>
  siteAccessZoneId?: Maybe<ScalarsEnums['String']>
  siteAccessZoneName?: Maybe<ScalarsEnums['String']>
  siteId: ScalarsEnums['String']
  source: ScalarsEnums['CheckInSource']
}

/**
 * Result of a door provider health check
 */
export interface DoorHealthCheckResult {
  __typename?: 'DoorHealthCheckResult'
  failureReason?: Maybe<ScalarsEnums['DoorConnectionFailureReason']>
  healthy: ScalarsEnums['Boolean']
  message?: Maybe<ScalarsEnums['String']>
}

/**
 * BigQuery export download response with presigned URL
 */
export interface DownloadBigQueryExportResponse {
  __typename?: 'DownloadBigQueryExportResponse'
  contentType: ScalarsEnums['String']
  downloadUrl: ScalarsEnums['String']
  expiresAt: ScalarsEnums['String']
  filename: ScalarsEnums['String']
  generatedAt: ScalarsEnums['String']
}

export interface EarlyAccessTimeline {
  __typename?: 'EarlyAccessTimeline'
  bridge?: Maybe<EarlyAccessTimelineBridge>
  credits?: Maybe<ScalarsEnums['Float']>
  days: ScalarsEnums['Float']
  endDate: ScalarsEnums['String']
  firstFullAmount: ScalarsEnums['String']
  firstFullBillingDate: ScalarsEnums['String']
  firstFullTotalAmount: ScalarsEnums['String']
  firstPaidDate: ScalarsEnums['String']
  startDate: ScalarsEnums['String']
}

export interface EarlyAccessTimelineBridge {
  __typename?: 'EarlyAccessTimelineBridge'
  amount: ScalarsEnums['String']
  credits?: Maybe<ScalarsEnums['Float']>
  endDate: ScalarsEnums['String']
  startDate: ScalarsEnums['String']
  totalAmount: ScalarsEnums['String']
}

/**
 * Result of a location-wide eGym sync — count of reconcile jobs enqueued.
 */
export interface EgymBackfillResult {
  __typename?: 'EgymBackfillResult'
  enqueued: ScalarsEnums['Float']
}

/**
 * A client's eGym link for the client profile: the eGym accountId and last-synced state (Hapana clientId = eGym membershipId).
 */
export interface EgymClientLink {
  __typename?: 'EgymClientLink'
  accountId?: Maybe<ScalarsEnums['String']>
  lastSyncedAt?: Maybe<ScalarsEnums['String']>
  membershipId: ScalarsEnums['String']
  status?: Maybe<ScalarsEnums['MemberLinkStatus']>
}

/**
 * Whether the eGym gym holds any accounts yet (drives the CSV export gate).
 */
export interface EgymHasAccounts {
  __typename?: 'EgymHasAccounts'
  hasAccounts: ScalarsEnums['Boolean']
}

/**
 * Corporate-level eGym master enable (availability for the brand's locations; the API key is per-location)
 */
export interface EgymSettings {
  __typename?: 'EgymSettings'
  enabled?: Maybe<ScalarsEnums['Boolean']>
}

/**
 * Whether eGym is on for a site: the brand master enable and the site opt-in are both on.
 */
export interface EgymSiteEnabled {
  __typename?: 'EgymSiteEnabled'
  enabled: ScalarsEnums['Boolean']
}

/**
 * Whether a site has an eGym API key configured (the key itself is write-only).
 */
export interface EgymSiteKeyStatus {
  __typename?: 'EgymSiteKeyStatus'
  hasApiKey: ScalarsEnums['Boolean']
}

/**
 * Whether an eGym sync is currently in progress (jobs pending on the queue).
 */
export interface EgymSyncActive {
  __typename?: 'EgymSyncActive'
  active: ScalarsEnums['Boolean']
}

/**
 * The electronic consents a withdrawal closed for one signer
 */
export interface ElectronicConsentWithdrawalResult {
  __typename?: 'ElectronicConsentWithdrawalResult'
  signerId: ScalarsEnums['ID']
  withdrawnConsentIds: Array<ScalarsEnums['ID']>
}

export interface EligibilityAge {
  __typename?: 'EligibilityAge'
  doctorsNoteRequired: ScalarsEnums['Boolean']
  minimumViolated: ScalarsEnums['Boolean']
  parentalConsentRequired: ScalarsEnums['Boolean']
}

export interface EligibilityFrequency {
  __typename?: 'EligibilityFrequency'
  allowedAt?: Maybe<ScalarsEnums['String']>
  violated: ScalarsEnums['Boolean']
}

/**
 * The client's skin type assessment against the location's UV requirement. A current result never clears the other tanning rules
 */
export interface EligibilitySkinType {
  __typename?: 'EligibilitySkinType'
  assessedAt?: Maybe<ScalarsEnums['String']>
  completedAt?: Maybe<ScalarsEnums['String']>
  dueAt?: Maybe<ScalarsEnums['String']>
  permittedActions: Array<ScalarsEnums['SkinTypePermittedAction']>
  resultLabel?: Maybe<ScalarsEnums['String']>
  resultSource?: Maybe<ScalarsEnums['FormExternalResultSource']>
  sourceSubmissionId?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['SkinTypeEligibilityStatus']
}

export interface EligibilityTiming {
  __typename?: 'EligibilityTiming'
  allowedAt?: Maybe<ScalarsEnums['String']>
  minutesUntilAllowed?: Maybe<ScalarsEnums['Float']>
  violated: ScalarsEnums['Boolean']
}

/**
 * Outcome of emailing a client a copy of their completed form
 */
export interface EmailFormSubmissionCopyResponse {
  __typename?: 'EmailFormSubmissionCopyResponse'
  message: ScalarsEnums['String']
  success: ScalarsEnums['Boolean']
}

/**
 * Response for embed setup API operations
 */
export interface EmbedSetupResponse {
  __typename?: 'EmbedSetupResponse'
  data?: Maybe<EmbedSetupResponseData>
  errors?: Maybe<EmbedSetupResponseErrors>
  message: ScalarsEnums['String']
  success: ScalarsEnums['Boolean']
}

export interface EmbedSetupResponseData {
  __typename?: 'EmbedSetupResponseData'
  appConfig: EmbedSetupResponseDataAppConfig
  customization?: Maybe<EmbedSetupResponseDataCustomization>
  progress: EmbedSetupResponseDataProgress
  websiteWidgets?: Maybe<EmbedSetupResponseDataWebsiteWidgets>
}

export interface EmbedSetupResponseDataAppConfig {
  __typename?: 'EmbedSetupResponseDataAppConfig'
  corporateId: ScalarsEnums['String']
  id: ScalarsEnums['String']
  lastUpdated: ScalarsEnums['String']
  version: ScalarsEnums['String']
  widgetName: ScalarsEnums['String']
}

export interface EmbedSetupResponseDataCustomization {
  __typename?: 'EmbedSetupResponseDataCustomization'
  advanced: EmbedSetupResponseDataCustomizationAdvanced
  appearance: EmbedSetupResponseDataCustomizationAppearance
  branding: EmbedSetupResponseDataCustomizationBranding
  colors: EmbedSetupResponseDataCustomizationColors
  customText: EmbedSetupResponseDataCustomizationCustomText
  layout: EmbedSetupResponseDataCustomizationLayout
  modules: EmbedSetupResponseDataCustomizationModules
}

export interface EmbedSetupResponseDataCustomizationAdvanced {
  __typename?: 'EmbedSetupResponseDataCustomizationAdvanced'
  buttonStyle: ScalarsEnums['EmbedButtonStyle']
  classTimeFilter: ScalarsEnums['Boolean']
  customCssLink: ScalarsEnums['String']
  displayInstructor: ScalarsEnums['Boolean']
  displayPackageDescription: ScalarsEnums['Boolean']
  displayProfilePicture: ScalarsEnums['Boolean']
  filterOptions: EmbedSetupResponseDataCustomizationAdvancedFilterOptions
  privatesAnyAvailable: ScalarsEnums['Boolean']
  redirectUrl: ScalarsEnums['String']
  showFilters: ScalarsEnums['Boolean']
  signUpEnabled: ScalarsEnums['Boolean']
}

export interface EmbedSetupResponseDataCustomizationAdvancedFilterOptions {
  __typename?: 'EmbedSetupResponseDataCustomizationAdvancedFilterOptions'
  category: ScalarsEnums['Boolean']
  duration: ScalarsEnums['Boolean']
  instructor: ScalarsEnums['Boolean']
  location: ScalarsEnums['Boolean']
  time: ScalarsEnums['Boolean']
}

export interface EmbedSetupResponseDataCustomizationAppearance {
  __typename?: 'EmbedSetupResponseDataCustomizationAppearance'
  borderRadius: ScalarsEnums['Float']
  buttonStyle: ScalarsEnums['EmbedAppearanceButtonStyle']
  fontFamily: ScalarsEnums['String']
  fontSize: ScalarsEnums['Float']
}

export interface EmbedSetupResponseDataCustomizationBranding {
  __typename?: 'EmbedSetupResponseDataCustomizationBranding'
  appName: ScalarsEnums['String']
  faviconUrl: ScalarsEnums['String']
  logoUrl: ScalarsEnums['String']
}

export interface EmbedSetupResponseDataCustomizationColors {
  __typename?: 'EmbedSetupResponseDataCustomizationColors'
  backgroundColor: ScalarsEnums['String']
  primaryColor: ScalarsEnums['String']
  primaryTextColor: ScalarsEnums['String']
  secondaryColor: ScalarsEnums['String']
  secondaryTextColor: ScalarsEnums['String']
}

export interface EmbedSetupResponseDataCustomizationCustomText {
  __typename?: 'EmbedSetupResponseDataCustomizationCustomText'
  defaultLanguage: ScalarsEnums['String']
  translations: ScalarsEnums['JSONObject']
}

export interface EmbedSetupResponseDataCustomizationLayout {
  __typename?: 'EmbedSetupResponseDataCustomizationLayout'
  footerVisible: ScalarsEnums['Boolean']
  headerVisible: ScalarsEnums['Boolean']
  sidebarPosition: ScalarsEnums['EmbedSidebarPosition']
}

export interface EmbedSetupResponseDataCustomizationModules {
  __typename?: 'EmbedSetupResponseDataCustomizationModules'
  classes: ScalarsEnums['Boolean']
  dashboard: ScalarsEnums['Boolean']
  packages: ScalarsEnums['Boolean']
  payments: ScalarsEnums['Boolean']
  privates: ScalarsEnums['Boolean']
  profile: ScalarsEnums['Boolean']
  schedule: ScalarsEnums['Boolean']
  workshops: ScalarsEnums['Boolean']
}

export interface EmbedSetupResponseDataProgress {
  __typename?: 'EmbedSetupResponseDataProgress'
  activeTabsInSteps: EmbedSetupResponseDataProgressActiveTabsInSteps
  completedSteps: Array<ScalarsEnums['Float']>
  currentStep: ScalarsEnums['Float']
  customizationCompleted: ScalarsEnums['Boolean']
  websiteWidgetsCompleted: ScalarsEnums['Boolean']
}

export interface EmbedSetupResponseDataProgressActiveTabsInSteps {
  __typename?: 'EmbedSetupResponseDataProgressActiveTabsInSteps'
  step1?: Maybe<ScalarsEnums['Float']>
  step2?: Maybe<ScalarsEnums['Float']>
}

export interface EmbedSetupResponseDataWebsiteWidgets {
  __typename?: 'EmbedSetupResponseDataWebsiteWidgets'
  selectedWidgets: Array<ScalarsEnums['String']>
  widgetSettings: ScalarsEnums['JSONObject']
}

export interface EmbedSetupResponseErrors {
  __typename?: 'EmbedSetupResponseErrors'
  customization?: Maybe<Array<ScalarsEnums['String']>>
  general?: Maybe<Array<ScalarsEnums['String']>>
  websiteWidgets?: Maybe<Array<ScalarsEnums['String']>>
}

export interface EmergencyStopMemberMovementResult {
  __typename?: 'EmergencyStopMemberMovementResult'
  cancelledRunIds: Array<ScalarsEnums['ID']>
  corporateId: ScalarsEnums['ID']
  stopped: ScalarsEnums['Boolean']
}

/**
 * What happened to one employee row
 */
export interface EmployeeLinkResult {
  __typename?: 'EmployeeLinkResult'
  clientId?: Maybe<ScalarsEnums['String']>
  email: ScalarsEnums['String']
  outcome: ScalarsEnums['EmployeeLinkOutcome']
  reason?: Maybe<ScalarsEnums['String']>
}

/**
 * Information about currently enabled filters
 */
export interface EnabledFilter {
  __typename?: 'EnabledFilter'
  category: ScalarsEnums['String']
  displayValue: ScalarsEnums['String']
  label: ScalarsEnums['String']
  operator: ScalarsEnums['String']
  type: ScalarsEnums['String']
}

/**
 * Currently enabled filters information
 */
export interface EnabledFilters {
  __typename?: 'EnabledFilters'
  filters: Array<EnabledFilter>
  totalCount: ScalarsEnums['Float']
}

export interface Entity {
  __typename?: 'Entity'
  confidence: ScalarsEnums['Float']
  name: ScalarsEnums['String']
  type: ScalarsEnums['String']
  value: ScalarsEnums['String']
}

/**
 * A tanning bed or wellness equipment unit at a site
 */
export interface Equipment {
  __typename?: 'Equipment'
  assignments: (args?: {
    clientId?: Maybe<ScalarsEnums['String']>
    last?: Maybe<ScalarsEnums['Boolean']>
    status?: Maybe<ScalarsEnums['String']>
  }) => Maybe<Array<EquipmentAssignment>>
  category: ScalarsEnums['EquipmentCategory']
  createdAt: ScalarsEnums['String']
  currentError?: Maybe<EquipmentCurrentError>
  defaultDelayMinutes?: Maybe<ScalarsEnums['Int']>
  defaultTimerMinutes?: Maybe<ScalarsEnums['Int']>
  deletedAt?: Maybe<ScalarsEnums['String']>
  description?: Maybe<ScalarsEnums['String']>
  equipmentId: ScalarsEnums['String']
  facialLampLifeHours?: Maybe<ScalarsEnums['Int']>
  facialLampTrackingEnabled?: Maybe<ScalarsEnums['Boolean']>
  facialLampWarningHours?: Maybe<ScalarsEnums['Int']>
  image?: Maybe<EquipmentImage>
  lampLifeHours?: Maybe<ScalarsEnums['Int']>
  lampTrackingEnabled?: Maybe<ScalarsEnums['Boolean']>
  lampWarningHours?: Maybe<ScalarsEnums['Int']>
  lastAvailableAt?: Maybe<ScalarsEnums['String']>
  lastDelayAt?: Maybe<ScalarsEnums['String']>
  lastDirtyAt?: Maybe<ScalarsEnums['String']>
  lastError?: Maybe<EquipmentCurrentError>
  lastInUseAt?: Maybe<ScalarsEnums['String']>
  manufacturer?: Maybe<ScalarsEnums['String']>
  maxDelayMinutes?: Maybe<ScalarsEnums['Int']>
  maxTimerMinutes?: Maybe<ScalarsEnums['Int']>
  minDelayMinutes?: Maybe<ScalarsEnums['Int']>
  minTimerMinutes?: Maybe<ScalarsEnums['Int']>
  name: ScalarsEnums['String']
  nonUvCategory?: Maybe<ScalarsEnums['NonUvCategory']>
  qualityCategory?: Maybe<ScalarsEnums['EquipmentQualityCategory']>
  queue?: Maybe<Array<EquipmentQueue>>
  site: SitePreview
  siteId: ScalarsEnums['String']
  siteSessionTypeIds?: Maybe<Array<ScalarsEnums['String']>>
  status: ScalarsEnums['EquipmentStatus']
  timerId: ScalarsEnums['Int']
  updatedAt: ScalarsEnums['String']
}

/**
 * Equipment usage activity grouped by day
 */
export interface EquipmentActivityDay {
  __typename?: 'EquipmentActivityDay'
  date: ScalarsEnums['String']
  items: Array<EquipmentActivityItem>
}

export interface EquipmentActivityItem {
  __typename?: 'EquipmentActivityItem'
  clientId?: Maybe<ScalarsEnums['String']>
  durationMinutes: ScalarsEnums['Float']
  equipmentId: ScalarsEnums['String']
  equipmentName: ScalarsEnums['String']
  siteSessionTypeId?: Maybe<ScalarsEnums['String']>
}

/**
 * A record of a client using a tanning bed / equipment unit
 */
export interface EquipmentAssignment {
  __typename?: 'EquipmentAssignment'
  addOnAmount?: Maybe<ScalarsEnums['Numeric']>
  addOnInvoiceId?: Maybe<ScalarsEnums['ID']>
  assignedAt: ScalarsEnums['String']
  attendanceId?: Maybe<ScalarsEnums['ID']>
  cancelledAt?: Maybe<ScalarsEnums['String']>
  checkInId?: Maybe<ScalarsEnums['String']>
  client?: Maybe<Client>
  clientId?: Maybe<ScalarsEnums['String']>
  complianceOverrideBy?: Maybe<ScalarsEnums['String']>
  complianceOverrideReason?: Maybe<ScalarsEnums['String']>
  /**
   * Location requirements that were not met but did not stop the session; returned by the call that started it, empty elsewhere
   */
  complianceWarnings: Array<EquipmentComplianceWarning>
  createdAt: ScalarsEnums['String']
  creditLedgerEntryIds?: Maybe<Array<ScalarsEnums['ID']>>
  delayMinutes: ScalarsEnums['Int']
  doneAt?: Maybe<ScalarsEnums['String']>
  elapsedMinutes?: Maybe<ScalarsEnums['Int']>
  equipment: Equipment
  equipmentAssignmentId: ScalarsEnums['String']
  equipmentId: ScalarsEnums['String']
  id: ScalarsEnums['String']
  isTestTimeOverride?: Maybe<ScalarsEnums['Boolean']>
  lampMinutesBeforeRestart?: Maybe<ScalarsEnums['Int']>
  lampsSwitchedOn?: Maybe<ScalarsEnums['Boolean']>
  /**
   * Staff notes for each tanning regulation overridden when this session started
   */
  regulationOverrides: Array<EquipmentAssignmentRegulationOverride>
  restartPendingAt?: Maybe<ScalarsEnums['String']>
  restartedAt?: Maybe<ScalarsEnums['String']>
  reversedAt?: Maybe<ScalarsEnums['String']>
  reversedByStaffUserId?: Maybe<ScalarsEnums['ID']>
  siteId: ScalarsEnums['String']
  siteSessionTypeId?: Maybe<ScalarsEnums['String']>
  skinTypeAtStart?: Maybe<ScalarsEnums['String']>
  skinTypeBandId?: Maybe<ScalarsEnums['String']>
  skinTypeCompletedAt?: Maybe<ScalarsEnums['String']>
  skinTypeFormRevision?: Maybe<ScalarsEnums['Int']>
  skinTypeSubmissionId?: Maybe<ScalarsEnums['String']>
  /**
   * Full name of the staff member who started this assignment, if a staff member did
   */
  startedByStaffName?: Maybe<ScalarsEnums['String']>
  startedByStaffUserId?: Maybe<ScalarsEnums['ID']>
  status: ScalarsEnums['EquipmentAssignmentStatus']
  timerId: ScalarsEnums['Int']
  timerMinutes: ScalarsEnums['Int']
  updatedAt: ScalarsEnums['String']
  voidedAt?: Maybe<ScalarsEnums['String']>
}

/**
 * Staff note for one tanning regulation overridden when the session started
 */
export interface EquipmentAssignmentRegulationOverride {
  __typename?: 'EquipmentAssignmentRegulationOverride'
  createdAt: ScalarsEnums['String']
  note: ScalarsEnums['String']
  rule: ScalarsEnums['TanningRegulationRule']
  staffName?: Maybe<ScalarsEnums['String']>
  staffUserId?: Maybe<ScalarsEnums['ID']>
}

/**
 * One equipment category for a client, computed by the same evaluator the start uses
 */
export interface EquipmentComplianceCategory {
  __typename?: 'EquipmentComplianceCategory'
  blockingItems: Array<EquipmentComplianceItem>
  decision: ScalarsEnums['EquipmentStartDecision']
  equipmentCategory: ScalarsEnums['PolicyEquipmentScope']
  reasonCodes: Array<ScalarsEnums['ReadinessReasonCode']>
  renewalItems: Array<EquipmentComplianceItem>
  status: ScalarsEnums['EquipmentComplianceStatus']
}

/**
 * An outstanding item on the compliance report, without evidence or signer detail
 */
export interface EquipmentComplianceItem {
  __typename?: 'EquipmentComplianceItem'
  dueOn?: Maybe<ScalarsEnums['String']>
  kind: ScalarsEnums['PendingItemKind']
  reasonCode: ScalarsEnums['ReadinessReasonCode']
  title: ScalarsEnums['String']
}

/**
 * Equipment compliance report for a location (R71)
 */
export interface EquipmentComplianceReport {
  __typename?: 'EquipmentComplianceReport'
  categories: Array<ScalarsEnums['PolicyEquipmentScope']>
  evaluatedAt: ScalarsEnums['String']
  limit: ScalarsEnums['Float']
  offset: ScalarsEnums['Float']
  redacted: ScalarsEnums['Boolean']
  rows: Array<EquipmentComplianceRow>
  siteId: ScalarsEnums['ID']
  summary: EquipmentComplianceSummary
  totalCount: ScalarsEnums['Float']
}

/**
 * A client who used equipment at the location in the last 90 days
 */
export interface EquipmentComplianceRow {
  __typename?: 'EquipmentComplianceRow'
  categories: Array<EquipmentComplianceCategory>
  clientId: ScalarsEnums['ID']
  firstName?: Maybe<ScalarsEnums['String']>
  lastName?: Maybe<ScalarsEnums['String']>
  lastVisitAt: ScalarsEnums['String']
  status: ScalarsEnums['EquipmentComplianceStatus']
}

export interface EquipmentComplianceSummary {
  __typename?: 'EquipmentComplianceSummary'
  blocked: ScalarsEnums['Float']
  ready: ScalarsEnums['Float']
  renewalDue: ScalarsEnums['Float']
  total: ScalarsEnums['Float']
}

/**
 * A location requirement that was not met but did not stop the session, because the location only warns
 */
export interface EquipmentComplianceWarning {
  __typename?: 'EquipmentComplianceWarning'
  code: ScalarsEnums['EquipmentComplianceWarningCode']
}

export interface EquipmentCurrentError {
  __typename?: 'EquipmentCurrentError'
  errorAt: ScalarsEnums['String']
  errorCode: ScalarsEnums['String']
  errorMessage: ScalarsEnums['String']
}

/**
 * The exposure schedule line for a client's next session on a UV bed. Reference only; the timer is never set from it
 */
export interface EquipmentExposureGuidance {
  __typename?: 'EquipmentExposureGuidance'
  beyondSchedule: ScalarsEnums['Boolean']
  minutes: ScalarsEnums['Numeric']
  note?: Maybe<ScalarsEnums['String']>
  resultLabel?: Maybe<ScalarsEnums['String']>
  sessionNumber: ScalarsEnums['Int']
}

/**
 * One line of a UV bed's manufacturer exposure schedule: minutes for a skin type band at a session number. Reference only; never applied to a timer
 */
export interface EquipmentExposureScheduleRow {
  __typename?: 'EquipmentExposureScheduleRow'
  bandId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  equipmentId: ScalarsEnums['ID']
  formRevision: ScalarsEnums['Int']
  minutes: ScalarsEnums['Numeric']
  note?: Maybe<ScalarsEnums['String']>
  scheduleId: ScalarsEnums['ID']
  sessionNumber: ScalarsEnums['Int']
  siteId: ScalarsEnums['ID']
  updatedAt: ScalarsEnums['String']
}

export interface EquipmentImage {
  __typename?: 'EquipmentImage'
  db?: Maybe<ScalarsEnums['String']>
  medium?: Maybe<ScalarsEnums['String']>
  thumbnail?: Maybe<ScalarsEnums['String']>
}

/**
 * The latest revision of a jurisdiction age rule: which equipment it covers, from when, and what each age band requires
 */
export interface EquipmentJurisdictionRule {
  __typename?: 'EquipmentJurisdictionRule'
  ageBands: Array<JurisdictionAgeBand>
  ageEvidenceRequired: ScalarsEnums['AgeEvidenceRequired']
  createdAt: ScalarsEnums['String']
  createdByStaffUserId?: Maybe<ScalarsEnums['ID']>
  effectiveFrom: ScalarsEnums['String']
  effectiveTo?: Maybe<ScalarsEnums['String']>
  equipmentScope: Array<ScalarsEnums['PolicyEquipmentScope']>
  jurisdictionCode: ScalarsEnums['String']
  notes?: Maybe<ScalarsEnums['String']>
  ruleId: ScalarsEnums['ID']
  ruleRevision: ScalarsEnums['Float']
  siteId: ScalarsEnums['ID']
  status: ScalarsEnums['JurisdictionRuleStatus']
}

/**
 * One entry in a bed lamp set history. TRACKING_ENABLED and LAMP_CHANGE rows are baselines; ADJUSTMENT rows add deltaMinutes
 */
export interface EquipmentLampLog {
  __typename?: 'EquipmentLampLog'
  createdAt: ScalarsEnums['String']
  createdBy: ScalarsEnums['String']
  createdByName: ScalarsEnums['String']
  deltaMinutes?: Maybe<ScalarsEnums['Int']>
  effectiveAt: ScalarsEnums['String']
  equipmentId: ScalarsEnums['ID']
  equipmentLampLogId: ScalarsEnums['ID']
  eventType: ScalarsEnums['EquipmentLampLogEventType']
  lampSet: ScalarsEnums['EquipmentLampSet']
  newMinutes: ScalarsEnums['Int']
  notes?: Maybe<ScalarsEnums['String']>
  previousMinutes?: Maybe<ScalarsEnums['Int']>
  siteId: ScalarsEnums['ID']
}

/**
 * One page of a bed lamp history
 */
export interface EquipmentLampLogPage {
  __typename?: 'EquipmentLampLogPage'
  items: Array<EquipmentLampLog>
  nextCursor?: Maybe<ScalarsEnums['String']>
}

/**
 * Current hours of one tracked lamp set, derived from its latest baseline
 */
export interface EquipmentLampSetStatus {
  __typename?: 'EquipmentLampSetStatus'
  baselineAt: ScalarsEnums['String']
  currentMinutes: ScalarsEnums['Int']
  lampLifeHours: ScalarsEnums['Int']
  lampWarningHours: ScalarsEnums['Int']
  lastLampChangeAt?: Maybe<ScalarsEnums['String']>
  state: ScalarsEnums['EquipmentLampState']
  uncountedCodedSessions: ScalarsEnums['Int']
}

/**
 * Lamp hours of every tracked bed at a site, with the site timezone and today at the site so date pickers match server validation
 */
export interface EquipmentLampSiteStatus {
  __typename?: 'EquipmentLampSiteStatus'
  equipment: Array<EquipmentLampStatus>
  siteToday: ScalarsEnums['String']
  timezone: ScalarsEnums['String']
}

/**
 * Lamp hours of every tracked lamp set on a bed; state is the worse of the sets
 */
export interface EquipmentLampStatus {
  __typename?: 'EquipmentLampStatus'
  body?: Maybe<EquipmentLampSetStatus>
  equipmentId: ScalarsEnums['ID']
  facial?: Maybe<EquipmentLampSetStatus>
  state: ScalarsEnums['EquipmentLampState']
}

export interface EquipmentQueue {
  __typename?: 'EquipmentQueue'
  clientId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  regulationOverrides?: Maybe<Array<QueuedTanningRegulationOverride>>
  siteSessionTypeId?: Maybe<ScalarsEnums['ID']>
}

/**
 * A client in the queue for a tanning bed, with their position
 */
export interface EquipmentQueuePosition {
  __typename?: 'EquipmentQueuePosition'
  clientId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  equipmentId: ScalarsEnums['String']
  position: ScalarsEnums['Float']
  siteSessionTypeId?: Maybe<ScalarsEnums['ID']>
}

/**
 * Readiness of a client for one equipment unit or category, with reasons redacted to codes (D-12)
 */
export interface EquipmentReadinessView {
  __typename?: 'EquipmentReadinessView'
  actionableItems: Array<ReadinessItem>
  age: ReadinessDimensionResult
  blockingItems: Array<ReadinessItem>
  clientId: ScalarsEnums['ID']
  detail?: Maybe<ReadinessEvidenceDetail>
  equipmentCategory?: Maybe<ScalarsEnums['PolicyEquipmentScope']>
  equipmentId?: Maybe<ScalarsEnums['ID']>
  evaluatedSiteLocalDate: ScalarsEnums['String']
  operational: ReadinessDimensionResult
  policy: ReadinessDimensionResult
  siteId: ScalarsEnums['ID']
  skinType: ReadinessDimensionResult
  upcomingItems: Array<ReadinessItem>
}

/**
 * Tanning safety regulations per equipment category at a site
 */
export interface EquipmentRegulation {
  __typename?: 'EquipmentRegulation'
  createdAt: ScalarsEnums['String']
  equipmentCategory: ScalarsEnums['EquipmentCategory']
  equipmentRegulationId: ScalarsEnums['String']
  id: ScalarsEnums['String']
  rules: EquipmentRegulationRules
  siteId: ScalarsEnums['String']
  updatedAt: ScalarsEnums['String']
}

export interface EquipmentRegulationRules {
  __typename?: 'EquipmentRegulationRules'
  allowOverride: ScalarsEnums['Boolean']
  customerAgeMaxFrequency: EquipmentRegulationRulesCustomerAgeMaxFrequency
  customerAgeMaxFrequencyAfterNoCategoryTan: EquipmentRegulationRulesCustomerAgeMaxFrequencyAfterNoCategoryTan
  hoursBetweenUsesFromStartOfPrevious: EquipmentRegulationRulesHoursBetweenUsesFromStartOfPrevious
  minimumDaysBetweenUses: EquipmentRegulationRulesMinimumDaysBetweenUses
  minimumHoursBetweenUses: EquipmentRegulationRulesMinimumHoursBetweenUses
  nonUvAgeRules?: Maybe<EquipmentRegulationRulesNonUvAgeRules>
  skinTypeRequired?: Maybe<EquipmentRegulationRulesSkinTypeRequired>
  uvAgeRules?: Maybe<EquipmentRegulationRulesUvAgeRules>
}

export interface EquipmentRegulationRulesCustomerAgeMaxFrequency {
  __typename?: 'EquipmentRegulationRulesCustomerAgeMaxFrequency'
  enabled: ScalarsEnums['Boolean']
  everyXDays: ScalarsEnums['Float']
  maxAge: ScalarsEnums['Float']
  maxUses: ScalarsEnums['Float']
}

export interface EquipmentRegulationRulesCustomerAgeMaxFrequencyAfterNoCategoryTan {
  __typename?: 'EquipmentRegulationRulesCustomerAgeMaxFrequencyAfterNoCategoryTan'
  afterXDaysOfNoCategoryTan: ScalarsEnums['Float']
  enabled: ScalarsEnums['Boolean']
  everyXDays: ScalarsEnums['Float']
  forTheFirstXDays: ScalarsEnums['Float']
  maxAge: ScalarsEnums['Float']
  maxUses: ScalarsEnums['Float']
}

export interface EquipmentRegulationRulesHoursBetweenUsesFromStartOfPrevious {
  __typename?: 'EquipmentRegulationRulesHoursBetweenUsesFromStartOfPrevious'
  enabled: ScalarsEnums['Boolean']
  hours: ScalarsEnums['Float']
}

export interface EquipmentRegulationRulesMinimumDaysBetweenUses {
  __typename?: 'EquipmentRegulationRulesMinimumDaysBetweenUses'
  days: ScalarsEnums['Float']
  enabled: ScalarsEnums['Boolean']
}

export interface EquipmentRegulationRulesMinimumHoursBetweenUses {
  __typename?: 'EquipmentRegulationRulesMinimumHoursBetweenUses'
  enabled: ScalarsEnums['Boolean']
  hours: ScalarsEnums['Float']
}

export interface EquipmentRegulationRulesNonUvAgeRules {
  __typename?: 'EquipmentRegulationRulesNonUvAgeRules'
  byCategory?: Maybe<EquipmentRegulationRulesNonUvAgeRulesByCategory>
  categoryBased: ScalarsEnums['Boolean']
  general?: Maybe<EquipmentRegulationRulesUvAgeRules>
}

export interface EquipmentRegulationRulesNonUvAgeRulesByCategory {
  __typename?: 'EquipmentRegulationRulesNonUvAgeRulesByCategory'
  red_light?: Maybe<EquipmentRegulationRulesUvAgeRules>
  spa: EquipmentRegulationRulesUvAgeRules
  spray: EquipmentRegulationRulesUvAgeRules
  wellness: EquipmentRegulationRulesUvAgeRules
}

export interface EquipmentRegulationRulesSkinTypeRequired {
  __typename?: 'EquipmentRegulationRulesSkinTypeRequired'
  allowOverride: ScalarsEnums['Boolean']
  autoSend: ScalarsEnums['Boolean']
  autoSendDeviceTokenId?: Maybe<ScalarsEnums['String']>
  mode: ScalarsEnums['SkinTypeRequirementMode']
  resurveyInterval: ScalarsEnums['ResurveyInterval']
  skinTypeFormId?: Maybe<ScalarsEnums['String']>
}

export interface EquipmentRegulationRulesUvAgeRules {
  __typename?: 'EquipmentRegulationRulesUvAgeRules'
  doctorsNote?: Maybe<EquipmentRegulationRulesUvAgeRulesMinorWithParentalConsent>
  minimumAge: EquipmentRegulationRulesUvAgeRulesMinimumAge
  minorWithParentalConsent: EquipmentRegulationRulesUvAgeRulesMinorWithParentalConsent
}

export interface EquipmentRegulationRulesUvAgeRulesMinimumAge {
  __typename?: 'EquipmentRegulationRulesUvAgeRulesMinimumAge'
  enabled: ScalarsEnums['Boolean']
  enforceNoOverride: ScalarsEnums['Boolean']
  value: ScalarsEnums['Float']
}

export interface EquipmentRegulationRulesUvAgeRulesMinorWithParentalConsent {
  __typename?: 'EquipmentRegulationRulesUvAgeRulesMinorWithParentalConsent'
  enabled: ScalarsEnums['Boolean']
  max: ScalarsEnums['Float']
  min: ScalarsEnums['Float']
}

/**
 * Whether a client can use one of an equipment unit's session types right now
 */
export interface EquipmentSessionTypeAvailability {
  __typename?: 'EquipmentSessionTypeAvailability'
  addOnPrice?: Maybe<ScalarsEnums['String']>
  availability: ScalarsEnums['EquipmentSessionTypeAvailabilityKind']
  blockReason?: Maybe<ScalarsEnums['EquipmentSessionTypeBlockReason']>
  currency?: Maybe<ScalarsEnums['String']>
  siteSessionTypeId: ScalarsEnums['ID']
}

/**
 * Unified experience dashboard with all CMS analytics
 */
export interface ExperienceDashboard {
  __typename?: 'ExperienceDashboard'
  activeStreaks: ScalarsEnums['Float']
  awards: AwardsSummary
  challengeOverview: ChallengeOverview
  contentEngagement: ContentEngagementSummary
  metricTracking: MetricTrackingSummary
  totalMilestones: ScalarsEnums['Float']
}

export interface ExportCustomText {
  __typename?: 'ExportCustomText'
  corporateId: ScalarsEnums['String']
  customTextData: ScalarsEnums['JSONObject']
  defaultLanguage: ScalarsEnums['String']
  enabledLanguages: Array<ScalarsEnums['String']>
  exportedAt: ScalarsEnums['String']
}

export interface ExportJobStatus {
  __typename?: 'ExportJobStatus'
  error?: Maybe<ScalarsEnums['String']>
  jobId: ScalarsEnums['String']
  result?: Maybe<ExportJobStatusResult>
  rowsProcessed: ScalarsEnums['Float']
  status: ScalarsEnums['ExportJobStatusEnum']
  totalRows: ScalarsEnums['Float']
}

export interface ExportJobStatusResult {
  __typename?: 'ExportJobStatusResult'
  contentType: ScalarsEnums['String']
  downloadUrl: ScalarsEnums['String']
  expiresAt: ScalarsEnums['String']
  filename: ScalarsEnums['String']
  generatedAt: ScalarsEnums['String']
  isTruncated?: Maybe<ScalarsEnums['Boolean']>
  maxExportRows?: Maybe<ScalarsEnums['Float']>
  piiRedacted?: Maybe<ScalarsEnums['Boolean']>
  rowCount: ScalarsEnums['Float']
}

/**
 * Settlement export download response with pre-signed URL
 */
export interface ExportSettlementResponse {
  __typename?: 'ExportSettlementResponse'
  /**
   * MIME type — application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
   */
  contentType: ScalarsEnums['String']
  /**
   * Pre-signed GCS download URL
   */
  downloadUrl: ScalarsEnums['String']
  /**
   * ISO timestamp when the download URL expires
   */
  expiresAt: ScalarsEnums['String']
  /**
   * Generated filename
   */
  filename: ScalarsEnums['String']
  /**
   * ISO timestamp of generation
   */
  generatedAt: ScalarsEnums['String']
  /**
   * Total line items across all payouts
   */
  itemCount: ScalarsEnums['Float']
  /**
   * Number of payouts included
   */
  payoutCount: ScalarsEnums['Float']
}

/**
 * Outcome of extending or reactivating a plan
 */
export interface ExtendServiceResult {
  __typename?: 'ExtendServiceResult'
  newExpiresAt: ScalarsEnums['String']
  restoredCredits: ScalarsEnums['Float']
  type: ScalarsEnums['ServiceExtensionType']
}

/**
 * Ezypay-specific completion configuration with HPP details
 */
export interface EzypayCompletionConfig {
  __typename?: 'EzypayCompletionConfig'
  accessToken: ScalarsEnums['String']
  currencySymbol: ScalarsEnums['String']
  customerId: ScalarsEnums['String']
  customerPaidFees: Array<EzypayCustomerPaidFee>
  hppUrl: ScalarsEnums['String']
  paymentMethods: ScalarsEnums['String']
  type: ScalarsEnums['String']
}

/**
 * A customer-paid fee from the Ezypay merchant fee schedule, for capture-page display
 */
export interface EzypayCustomerPaidFee {
  __typename?: 'EzypayCustomerPaidFee'
  amount: ScalarsEnums['Float']
  appliesTo: Array<ScalarsEnums['String']>
  chargingOption: ScalarsEnums['String']
  description?: Maybe<ScalarsEnums['String']>
  percentage: ScalarsEnums['Float']
  pricingCode: ScalarsEnums['String']
}

export interface EzypayCustomerPaidFeeEstimateResult {
  __typename?: 'EzypayCustomerPaidFeeEstimateResult'
  hasAnyFee: ScalarsEnums['Boolean']
  loadFee: ScalarsEnums['Numeric']
  skippedLoadFeeBecausePriorSettlement: ScalarsEnums['Boolean']
  transactionFee: ScalarsEnums['Numeric']
}

/**
 * Site Ezypay gateway (sanitized — never exposes merchantPassword)
 */
export interface EzypayGateway {
  __typename?: 'EzypayGateway'
  countryCode: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  isActive: ScalarsEnums['Boolean']
  isSandbox: ScalarsEnums['Boolean']
  merchantUsername?: Maybe<ScalarsEnums['String']>
  onboardingStatus: ScalarsEnums['SitePaymentGatewayOnboardingStatus']
  paymentContactEmail?: Maybe<ScalarsEnums['String']>
  siteGatewayAccountId: ScalarsEnums['String']
  siteId: ScalarsEnums['ID']
  sitePaymentGatewayId: ScalarsEnums['ID']
  sitePaymentGatewayType: ScalarsEnums['SupportedPaymentGateway']
  updatedAt: ScalarsEnums['String']
}

export interface EzypayGatewayLogItem {
  __typename?: 'EzypayGatewayLogItem'
  amount: ScalarsEnums['Float']
  currency: ScalarsEnums['String']
  description?: Maybe<ScalarsEnums['String']>
  type: ScalarsEnums['String']
}

export interface EzypayGatewayLogs {
  __typename?: 'EzypayGatewayLogs'
  currency: ScalarsEnums['String']
  date?: Maybe<ScalarsEnums['String']>
  items: Array<EzypayGatewayLogItem>
  status: ScalarsEnums['String']
  totalAmount: ScalarsEnums['Float']
}

export interface Family {
  __typename?: 'Family'
  corporateId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  familyId: ScalarsEnums['ID']
  /**
   * True when an active admin of the family holds an active, not on hold, package that is family shareable or still shared with the family; the member app keeps the family visible and disables booking for family and package sharing while it is false
   */
  familyPackageActive: ScalarsEnums['Boolean']
  inviteLinks: Array<FamilyOpenInviteLink>
  members: Array<FamilyMember>
  name?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['FamilyStatus']
}

/**
 * A pending invitation for the signed-in member to join a family
 */
export interface FamilyInvite {
  __typename?: 'FamilyInvite'
  canBook: ScalarsEnums['Boolean']
  expiresAt: ScalarsEnums['String']
  familyId: ScalarsEnums['ID']
  familyName?: Maybe<ScalarsEnums['String']>
  /**
   * True when an active admin of the family holds an active, not on hold, package that is family shareable or still shared with the family; the member app keeps the family visible and disables booking for family and package sharing while it is false
   */
  familyPackageActive: ScalarsEnums['Boolean']
  inviteToken: ScalarsEnums['String']
  inviterFirstName?: Maybe<ScalarsEnums['String']>
  inviterLastInitial?: Maybe<ScalarsEnums['String']>
  inviterProfileImageUrl?: Maybe<ScalarsEnums['String']>
  role: ScalarsEnums['FamilyMemberRole']
}

/**
 * What an invite token offers, for the accept screen: the family and who invited, by first name and initial only
 */
export interface FamilyInviteContext {
  __typename?: 'FamilyInviteContext'
  canBook: ScalarsEnums['Boolean']
  expiresAt: ScalarsEnums['String']
  familyId: ScalarsEnums['ID']
  familyName?: Maybe<ScalarsEnums['String']>
  /**
   * True when an active admin of the family holds an active, not on hold, package that is family shareable or still shared with the family; the member app still offers the join screen while it is false
   */
  familyPackageActive: ScalarsEnums['Boolean']
  inviterFirstName?: Maybe<ScalarsEnums['String']>
  inviterLastInitial?: Maybe<ScalarsEnums['String']>
  inviterProfileImageUrl?: Maybe<ScalarsEnums['String']>
  role: ScalarsEnums['FamilyMemberRole']
}

/**
 * A single-use invite link token a family admin shares with the person to add; it carries the role and Book sessions they will join with
 */
export interface FamilyInviteLink {
  __typename?: 'FamilyInviteLink'
  expiresAt: ScalarsEnums['String']
  inviteLinkId: ScalarsEnums['String']
  inviteToken: ScalarsEnums['String']
}

export interface FamilyMember {
  __typename?: 'FamilyMember'
  age?: Maybe<ScalarsEnums['Float']>
  canBook: ScalarsEnums['Boolean']
  clientId: ScalarsEnums['ID']
  email?: Maybe<ScalarsEnums['String']>
  familyId: ScalarsEnums['ID']
  firstName?: Maybe<ScalarsEnums['String']>
  inviteExpiresAt?: Maybe<ScalarsEnums['String']>
  invitedAt?: Maybe<ScalarsEnums['String']>
  joinedAt?: Maybe<ScalarsEnums['String']>
  lastName?: Maybe<ScalarsEnums['String']>
  profileImageUrl?: Maybe<ScalarsEnums['String']>
  role: ScalarsEnums['FamilyMemberRole']
  status: ScalarsEnums['FamilyMemberStatus']
}

/**
 * A client who can be added to a family; lastName, email and mobilePhoneNumber are filled only by the staff list familyMemberCandidates and are always null from the single familyMemberCandidate lookup
 */
export interface FamilyMemberCandidate {
  __typename?: 'FamilyMemberCandidate'
  clientId: ScalarsEnums['ID']
  email?: Maybe<ScalarsEnums['String']>
  firstName?: Maybe<ScalarsEnums['String']>
  lastInitial?: Maybe<ScalarsEnums['String']>
  lastName?: Maybe<ScalarsEnums['String']>
  mobilePhoneNumber?: Maybe<ScalarsEnums['String']>
  profileImageUrl?: Maybe<ScalarsEnums['String']>
}

/**
 * An invite link nobody has accepted yet; inviteLinkId is stable and safe to show, inviteToken is only returned to a client admin of the family
 */
export interface FamilyOpenInviteLink {
  __typename?: 'FamilyOpenInviteLink'
  canBook: ScalarsEnums['Boolean']
  expiresAt: ScalarsEnums['String']
  familyId: ScalarsEnums['ID']
  inviteLinkId: ScalarsEnums['String']
  inviteToken?: Maybe<ScalarsEnums['String']>
  invitedAt: ScalarsEnums['String']
  invitedByClientId?: Maybe<ScalarsEnums['ID']>
  invitedByFirstName?: Maybe<ScalarsEnums['String']>
  invitedByLastName?: Maybe<ScalarsEnums['String']>
  role: ScalarsEnums['FamilyMemberRole']
}

/**
 * A family-shareable package held by a member of the family, with who it is allocated to
 */
export interface FamilyPackage {
  __typename?: 'FamilyPackage'
  allocations: Array<FamilyPackageAllocation>
  billing?: Maybe<FamilyPackageBilling>
  buyerClientId: ScalarsEnums['ID']
  buyerFirstName?: Maybe<ScalarsEnums['String']>
  buyerLastName?: Maybe<ScalarsEnums['String']>
  creditsRemaining?: Maybe<ScalarsEnums['Float']>
  familyShareable: ScalarsEnums['Boolean']
  multiLocationSessionTypeIds: Array<ScalarsEnums['String']>
  myAllocation?: Maybe<FamilyPackageAllocation>
  onHold: ScalarsEnums['Boolean']
  serviceId: ScalarsEnums['ID']
  sessionTypeIds?: Maybe<Array<ScalarsEnums['String']>>
  siteId: ScalarsEnums['ID']
  status: ScalarsEnums['ServiceStatus']
  templateName: ScalarsEnums['String']
  templateType: ScalarsEnums['ServiceTemplateType']
}

/**
 * One family member allocated credits from a family package
 */
export interface FamilyPackageAllocation {
  __typename?: 'FamilyPackageAllocation'
  allocatedCredits?: Maybe<ScalarsEnums['Float']>
  clientId: ScalarsEnums['ID']
  consumedCredits: ScalarsEnums['Float']
  firstName?: Maybe<ScalarsEnums['String']>
  lastName?: Maybe<ScalarsEnums['String']>
  remainingCredits?: Maybe<ScalarsEnums['Float']>
  sharedOn?: Maybe<ScalarsEnums['String']>
}

/**
 * What the package costs and how it is paid; only the payer is shown this
 */
export interface FamilyPackageBilling {
  __typename?: 'FamilyPackageBilling'
  amount?: Maybe<ScalarsEnums['String']>
  currency?: Maybe<ScalarsEnums['String']>
  holdReason?: Maybe<ScalarsEnums['String']>
  paymentMethod?: Maybe<FamilyPackagePaymentMethod>
}

export interface FamilyPackagePaymentMethod {
  __typename?: 'FamilyPackagePaymentMethod'
  brand?: Maybe<ScalarsEnums['String']>
  last4?: Maybe<ScalarsEnums['String']>
  type: ScalarsEnums['ClientPaymentMethodType']
}

export interface FamilySettings {
  __typename?: 'FamilySettings'
  adminsPerFamily: ScalarsEnums['Float']
  corporateId: ScalarsEnums['ID']
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['ID']>
}

/**
 * QA tooling: status of a feature env brand-data refresh run
 */
export interface FeatureDataRefreshStatus {
  __typename?: 'FeatureDataRefreshStatus'
  /**
   * Corporate whose brand DB is being refreshed
   */
  corporateId: ScalarsEnums['ID']
  /**
   * Run creation timestamp (ISO)
   */
  createdAt?: Maybe<ScalarsEnums['String']>
  /**
   * Failure detail when state is FAILED
   */
  error?: Maybe<ScalarsEnums['String']>
  /**
   * Refresh run id (uuid)
   */
  id: ScalarsEnums['ID']
  /**
   * Cloud Run Job execution id
   */
  jobExecution?: Maybe<ScalarsEnums['String']>
  /**
   * Brand DB replaced by this run
   */
  previousDatabase?: Maybe<ScalarsEnums['String']>
  /**
   * Feature env slug, if known
   */
  slug?: Maybe<ScalarsEnums['String']>
  /**
   * Golden backup the run restores from
   */
  sourceBackup?: Maybe<ScalarsEnums['String']>
  /**
   * Current lifecycle state
   */
  state: ScalarsEnums['FeatureDataRefreshState']
  /**
   * Human-readable progress message
   */
  step?: Maybe<ScalarsEnums['String']>
  /**
   * New brand DB the run restores into
   */
  targetDatabase?: Maybe<ScalarsEnums['String']>
  /**
   * User who triggered the run
   */
  triggeredBy?: Maybe<ScalarsEnums['String']>
  /**
   * Last update timestamp (ISO)
   */
  updatedAt?: Maybe<ScalarsEnums['String']>
}

/**
 * QA tooling: feature-env email redirect target and CC list
 */
export interface FeatureEnvEmailSettings {
  __typename?: 'FeatureEnvEmailSettings'
  /**
   * Git branch this env was deployed from
   */
  branchName: ScalarsEnums['String']
  /**
   * Extra addresses CC’d on every redirected email (QA watchers)
   */
  ccEmails: Array<ScalarsEnums['String']>
  /**
   * Deploy owner — every outbound email in the env is redirected here
   */
  owner: ScalarsEnums['String']
  /**
   * Feature env slug (*.<slug>.hapana-feature.com)
   */
  slug: ScalarsEnums['String']
}

export interface FeeCalculationResult {
  __typename?: 'FeeCalculationResult'
  clientFeeAmount?: Maybe<ScalarsEnums['Numeric']>
  feeCalculationSnapshot: FeeCalculationSnapshot
  platformFeeAmount?: Maybe<ScalarsEnums['Numeric']>
}

export interface FeeCalculationSnapshot {
  __typename?: 'FeeCalculationSnapshot'
  calculatedAt: ScalarsEnums['String']
  clientFees: FeeCalculationSnapshotClientFees
  feeClassification: ScalarsEnums['FeeClassificationTypes']
  paymentMethodClassification: ScalarsEnums['String']
  paymentMethodType: ScalarsEnums['PaymentMethodType']
  platformFees: FeeCalculationSnapshotPlatformFees
  siteFeeConfig: SiteFeeConfig
  subtotalAmount: ScalarsEnums['Float']
  totalClientFeeAmount: ScalarsEnums['Float']
  totalPlatformFeeAmount: ScalarsEnums['Float']
}

export interface FeeCalculationSnapshotClientFees {
  __typename?: 'FeeCalculationSnapshotClientFees'
  appliedFees: Array<AppliedFee>
  summary: FeeSummary
}

export interface FeeCalculationSnapshotPlatformFees {
  __typename?: 'FeeCalculationSnapshotPlatformFees'
  appliedFees: Array<AppliedFee>
  summary: FeeSummary
}

export interface FeeConfiguration {
  __typename?: 'FeeConfiguration'
  accountType: ScalarsEnums['FeeAccountType']
  description?: Maybe<ScalarsEnums['String']>
  enabled: ScalarsEnums['Boolean']
  eventType: ScalarsEnums['FeeEventType']
  feeConfigurationId: ScalarsEnums['String']
  name: ScalarsEnums['String']
  paymentGateway?: Maybe<ScalarsEnums['PaymentGateway']>
  rate: ScalarsEnums['Numeric']
  rateType: ScalarsEnums['FeeRateType']
  webhookEndpoint?: Maybe<ScalarsEnums['String']>
  webhookType?: Maybe<ScalarsEnums['String']>
}

export interface FeeConfigurations {
  __typename?: 'FeeConfigurations'
  pageInfo: FeeConfigurationsPageInfo
  results: Array<FeeConfigurationsResults>
}

export interface FeeConfigurationsPageInfo {
  __typename?: 'FeeConfigurationsPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface FeeConfigurationsResults {
  __typename?: 'FeeConfigurationsResults'
  cursor: ScalarsEnums['String']
  row: FeeConfiguration
}

export interface FeeSummary {
  __typename?: 'FeeSummary'
  feeCount: ScalarsEnums['Float']
  flatFees: ScalarsEnums['Float']
  percentFees: ScalarsEnums['Float']
  totalAmount: ScalarsEnums['Float']
}

/**
 * A session feedback question as a member is asked it
 */
export interface FeedbackQuestion {
  __typename?: 'FeedbackQuestion'
  answerType?: Maybe<ScalarsEnums['SessionFeedbackAnswerType']>
  characterLimit?: Maybe<ScalarsEnums['Float']>
  helperText?: Maybe<ScalarsEnums['String']>
  maxLabel?: Maybe<ScalarsEnums['String']>
  minLabel?: Maybe<ScalarsEnums['String']>
  options?: Maybe<Array<ScalarsEnums['String']>>
  questionId: ScalarsEnums['ID']
  questionText: ScalarsEnums['String']
  questionType: ScalarsEnums['FeedbackQuestionType']
  required: ScalarsEnums['Boolean']
  scaleMax?: Maybe<ScalarsEnums['Float']>
  sliderMax?: Maybe<ScalarsEnums['Float']>
  sliderMin?: Maybe<ScalarsEnums['Float']>
  sortOrder: ScalarsEnums['Float']
}

export interface FeedbackQuestions {
  __typename?: 'FeedbackQuestions'
  questions: Array<FeedbackQuestion>
}

/**
 * Outcome of finalising a Staged invoice after its linked agreement was signed. ok=false carries the structured reject reason (non-Staged status, ownership mismatch, charge failure). ok=true with pendingClientAction means the first payment waits on a bank challenge the client must complete.
 */
export interface FinalisePublicSigningResult {
  __typename?: 'FinalisePublicSigningResult'
  invoiceStatus?: Maybe<ScalarsEnums['String']>
  ok: ScalarsEnums['Boolean']
  pendingClientAction?: Maybe<PublicSigningPendingClientAction>
  reason?: Maybe<ScalarsEnums['String']>
  totalAmount?: Maybe<ScalarsEnums['String']>
}

export interface FinalizeCustomFont {
  __typename?: 'FinalizeCustomFont'
  success: ScalarsEnums['Boolean']
}

export interface FindStaffUsers {
  __typename?: 'FindStaffUsers'
  pageInfo: FindStaffUsersPageInfo
  results: Array<FindStaffUsersResults>
}

export interface FindStaffUsersPageInfo {
  __typename?: 'FindStaffUsersPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface FindStaffUsersResults {
  __typename?: 'FindStaffUsersResults'
  cursor: ScalarsEnums['String']
  row: StaffUser
}

/**
 * One Firebase project new brands can be registered into, with its app registrations counted live from Firebase.
 */
export interface FirebaseAppProjectCapacity {
  __typename?: 'FirebaseAppProjectCapacity'
  cap: ScalarsEnums['Float']
  countError?: Maybe<ScalarsEnums['String']>
  projectId: ScalarsEnums['String']
  registrations?: Maybe<ScalarsEnums['Float']>
  status: ScalarsEnums['FirebaseAppProjectStatus']
}

/**
 * This deployment's Firebase projects for brand apps and how full each one is.
 */
export interface FirebaseAppProjectPool {
  __typename?: 'FirebaseAppProjectPool'
  environment: ScalarsEnums['FirebaseAppProjectEnvironment']
  projects: Array<FirebaseAppProjectCapacity>
}

/**
 * How the first cycle invoice of a pending start date membership is settled by a plan change
 */
export interface FirstCycleSettlement {
  __typename?: 'FirstCycleSettlement'
  amount?: Maybe<ScalarsEnums['String']>
  currency?: Maybe<ScalarsEnums['String']>
  invoiceDueDate?: Maybe<ScalarsEnums['String']>
  kind: ScalarsEnums['FirstCycleSettlementKind']
  refundMethods: Array<ScalarsEnums['RefundType']>
}

/**
 * Result of re-proving a location's stored Fitness Passport tokens
 */
export interface FitnessPassportConnectionTest {
  __typename?: 'FitnessPassportConnectionTest'
  reason?: Maybe<ScalarsEnums['String']>
  state: ScalarsEnums['String']
}

/**
 * A member's Fitness Passport link as shown on the client file
 */
export interface FitnessPassportLinkView {
  __typename?: 'FitnessPassportLinkView'
  fpMemberId: ScalarsEnums['String']
  lastCheckedAt?: Maybe<ScalarsEnums['String']>
  lastCheckedOutcome?: Maybe<ScalarsEnums['FitnessPassportCheckOutcome']>
  lastMessage?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['FitnessPassportLinkStatus']
}

/**
 * What one replay pass did with the visits a location still owes Fitness Passport
 */
export interface FitnessPassportRetrySummary {
  __typename?: 'FitnessPassportRetrySummary'
  considered: ScalarsEnums['Float']
  declined: ScalarsEnums['Float']
  duplicates: ScalarsEnums['Float']
  exhausted: ScalarsEnums['Float']
  registered: ScalarsEnums['Float']
  skipped: ScalarsEnums['Float']
  stillPending: ScalarsEnums['Float']
}

export interface FitnessPassportSiteEnabled {
  __typename?: 'FitnessPassportSiteEnabled'
  enabled: ScalarsEnums['Boolean']
}

/**
 * One Fitness Passport call, as the visits report lists it
 */
export interface FitnessPassportVisitRow {
  __typename?: 'FitnessPassportVisitRow'
  attemptCount: ScalarsEnums['Float']
  checkInId?: Maybe<ScalarsEnums['String']>
  clientId: ScalarsEnums['String']
  clientName?: Maybe<ScalarsEnums['String']>
  fitnessPassportVisitId: ScalarsEnums['String']
  fpErrorMessage?: Maybe<ScalarsEnums['String']>
  fpMemberId: ScalarsEnums['String']
  fpStatus?: Maybe<ScalarsEnums['String']>
  occurredAt: ScalarsEnums['String']
  outcome: ScalarsEnums['FitnessPassportVisitOutcome']
  requestedAt?: Maybe<ScalarsEnums['String']>
}

/**
 * Outcome tiles for a location's Fitness Passport visits over a date range
 */
export interface FitnessPassportVisitsSummary {
  __typename?: 'FitnessPassportVisitsSummary'
  notAdmitted: ScalarsEnums['Float']
  overClaimed: ScalarsEnums['Float']
  pending: ScalarsEnums['Float']
  potentialDuplicate: ScalarsEnums['Float']
  refused: ScalarsEnums['Float']
  registered: ScalarsEnums['Float']
  unrecorded: ScalarsEnums['Float']
}

/**
 * A member who already holds the captured fob
 */
export interface FobCaptureHolder {
  __typename?: 'FobCaptureHolder'
  clientId: ScalarsEnums['ID']
  name: ScalarsEnums['String']
}

/**
 * A request to register the next fob a paired Check-In Agent reads onto a member
 */
export interface FobCaptureRequest {
  __typename?: 'FobCaptureRequest'
  attemptCount: ScalarsEnums['Float']
  clientId: ScalarsEnums['ID']
  deviceTokenId: ScalarsEnums['ID']
  expiresAt: ScalarsEnums['String']
  holders: Array<FobCaptureHolder>
  requestId: ScalarsEnums['ID']
  resultCode?: Maybe<ScalarsEnums['FobCaptureResultCode']>
  siteId: ScalarsEnums['ID']
  status: ScalarsEnums['FobCaptureStatus']
}

/**
 * A member named in a re-derivation preview
 */
export interface FobReDerivationMember {
  __typename?: 'FobReDerivationMember'
  clientId: ScalarsEnums['String']
  name: ScalarsEnums['String']
}

/**
 * Impact of applying a credential format to the fobs already enrolled
 */
export interface FobReDerivationPreview {
  __typename?: 'FobReDerivationPreview'
  collisions: Array<FobReDerivationMember>
  needsRescan: Array<FobReDerivationMember>
  reDerivable: ScalarsEnums['Float']
  total: ScalarsEnums['Float']
  unchanged: ScalarsEnums['Float']
}

/**
 * One delivery attempt of a form assignment, with its live status
 */
export interface FormHandoff {
  __typename?: 'FormHandoff'
  answeredCount?: Maybe<ScalarsEnums['Float']>
  channel: ScalarsEnums['FormHandoffChannel']
  clientId: ScalarsEnums['String']
  completedAt?: Maybe<ScalarsEnums['String']>
  createdAt: ScalarsEnums['String']
  deviceTokenId?: Maybe<ScalarsEnums['String']>
  expiresAt: ScalarsEnums['String']
  formSubmissionId: ScalarsEnums['String']
  handoffId: ScalarsEnums['String']
  identityConfirmedAt?: Maybe<ScalarsEnums['String']>
  identityFailedAttempts: ScalarsEnums['Float']
  questionCount?: Maybe<ScalarsEnums['Float']>
  resultCode?: Maybe<ScalarsEnums['FormHandoffResultCode']>
  siteId: ScalarsEnums['String']
  status: ScalarsEnums['FormHandoffStatus']
  statusVersion: ScalarsEnums['Float']
  updatedAt: ScalarsEnums['String']
}

/**
 * A verified signature image held as private form evidence
 */
export interface FormSignatureAsset {
  __typename?: 'FormSignatureAsset'
  byteCount?: Maybe<ScalarsEnums['Float']>
  checksumSha256?: Maybe<ScalarsEnums['String']>
  signatureAssetId: ScalarsEnums['String']
  status: ScalarsEnums['String']
}

/**
 * A short-lived URL for viewing a signature image
 */
export interface FormSignatureReadUrl {
  __typename?: 'FormSignatureReadUrl'
  expiresAt: ScalarsEnums['String']
  url: ScalarsEnums['String']
}

/**
 * A header the signature upload request must carry
 */
export interface FormSignatureUploadHeader {
  __typename?: 'FormSignatureUploadHeader'
  name: ScalarsEnums['String']
  value: ScalarsEnums['String']
}

/**
 * A short-lived URL for uploading one signature image; send it back as signatureAssetId
 */
export interface FormSignatureUploadTicket {
  __typename?: 'FormSignatureUploadTicket'
  expiresAt: ScalarsEnums['String']
  uploadHeaders: Array<FormSignatureUploadHeader>
  uploadId: ScalarsEnums['String']
  uploadUrl: ScalarsEnums['String']
}

/**
 * A form follow-up action that stopped retrying and needs attention
 */
export interface FormWorkflowEffectFailure {
  __typename?: 'FormWorkflowEffectFailure'
  attemptCount: ScalarsEnums['Float']
  clientId: ScalarsEnums['String']
  effectId: ScalarsEnums['String']
  effectType: ScalarsEnums['String']
  formSubmissionId?: Maybe<ScalarsEnums['String']>
  lastErrorCode?: Maybe<ScalarsEnums['String']>
  updatedAt: ScalarsEnums['String']
}

/**
 * A member who has left or been removed from the family, with their confirmed future bookings paid with a family package
 */
export interface FormerFamilyMemberBookings {
  __typename?: 'FormerFamilyMemberBookings'
  bookingIds: Array<ScalarsEnums['ID']>
  clientId: ScalarsEnums['ID']
  firstName?: Maybe<ScalarsEnums['String']>
  lastName?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['FamilyMemberStatus']
}

/**
 * Per-gateway fee breakdown at settlement time
 */
export interface GatewayFeeBreakdown {
  __typename?: 'GatewayFeeBreakdown'
  currency?: Maybe<ScalarsEnums['Currency']>
  failedPaymentFee?: Maybe<ScalarsEnums['Numeric']>
  loadFee?: Maybe<ScalarsEnums['Numeric']>
  transactionFee?: Maybe<ScalarsEnums['Numeric']>
}

/**
 * Gateway-namespaced metadata envelope on Payment
 */
export interface GatewayMetadata {
  __typename?: 'GatewayMetadata'
  ezypay?: Maybe<GatewayMetadataEzypay>
}

export interface GatewayMetadataEzypay {
  __typename?: 'GatewayMetadataEzypay'
  feeBreakdown?: Maybe<GatewayFeeBreakdown>
}

export interface GenerateCertificateSigningRequest {
  __typename?: 'GenerateCertificateSigningRequest'
  csrPem: ScalarsEnums['String']
}

export interface GenerateClientFileUploadUrlResponse {
  __typename?: 'GenerateClientFileUploadUrlResponse'
  fileId: ScalarsEnums['ID']
  /**
   * Value the server signed into x-goog-meta-requested-by. Client MUST echo this exact value as the header on PUT — any drift fails the V4 signature verification.
   */
  requestedBy: ScalarsEnums['ID']
  /**
   * Signed URL of the temporary path
   */
  tempUrl: ScalarsEnums['String']
  userType: ScalarsEnums['UserType']
}

export interface GenerateDevicePairingCode {
  __typename?: 'GenerateDevicePairingCode'
  expiresAt: ScalarsEnums['String']
  pairingCode: ScalarsEnums['String']
  shortCode?: Maybe<ScalarsEnums['String']>
  siteName: ScalarsEnums['String']
}

export interface GenerateFileSignedUrlResponse {
  __typename?: 'GenerateFileSignedUrlResponse'
  format?: Maybe<ScalarsEnums['ImageFileVersionFormat']>
  height?: Maybe<ScalarsEnums['Int']>
  type: ScalarsEnums['ImageFileVersionType']
  url: ScalarsEnums['String']
  width?: Maybe<ScalarsEnums['Int']>
}

export interface GenerateFileUploadUrlResponse {
  __typename?: 'GenerateFileUploadUrlResponse'
  /**
   * Value the server signed into x-goog-meta-requested-by. Client MUST echo this exact value as the header on PUT — any drift fails the V4 signature verification.
   */
  requestedBy: ScalarsEnums['ID']
  /**
   * Signed URL of the temporary path
   */
  tempUrl: ScalarsEnums['String']
  userType: ScalarsEnums['UserType']
}

export interface GenerateFontUploadSignedUrl {
  __typename?: 'GenerateFontUploadSignedUrl'
  expiresAt: ScalarsEnums['String']
  publicUrl: ScalarsEnums['String']
  requiredHeaders?: Maybe<ScalarsEnums['JSONObject']>
  uploadUrl: ScalarsEnums['String']
}

/**
 * A gift card design template
 */
export interface GiftCardDesign {
  __typename?: 'GiftCardDesign'
  createdAt: ScalarsEnums['String']
  deletedAt?: Maybe<ScalarsEnums['String']>
  designImage: ImageFileConfigField
  /**
   * Resolved design image URL for display (public URL for gift card designs)
   */
  designImageUrl: (args: { input: ImagePublicSignedUrlInput }) => Maybe<ImagePublicSignedUrl>
  giftCardDesignId: ScalarsEnums['ID']
  siteId: ScalarsEnums['ID']
}

/**
 * The gift card expiry policy a jurisdiction resolves to on a given date
 */
export interface GiftCardExpiryJurisdictionPreview {
  __typename?: 'GiftCardExpiryJurisdictionPreview'
  asOfDate: ScalarsEnums['String']
  jurisdictionCode?: Maybe<ScalarsEnums['String']>
  jurisdictionName?: Maybe<ScalarsEnums['String']>
  policy: ResolvedGiftCardExpiryPolicy
  stateRequired: ScalarsEnums['Boolean']
}

/**
 * A legal rule deciding whether gift cards sold in a jurisdiction may expire
 */
export interface GiftCardExpiryRule {
  __typename?: 'GiftCardExpiryRule'
  countryId: ScalarsEnums['String']
  countryIsoCode: ScalarsEnums['String']
  countryName: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  disclosureRequired: ScalarsEnums['Boolean']
  effectiveFrom: ScalarsEnums['String']
  expiryPolicy: ScalarsEnums['GiftCardExpiryPolicy']
  giftCardExpiryRuleId: ScalarsEnums['ID']
  legalCitation?: Maybe<ScalarsEnums['String']>
  maximumTermMonths?: Maybe<ScalarsEnums['Float']>
  minimumTermMonths?: Maybe<ScalarsEnums['Float']>
  notes?: Maybe<ScalarsEnums['String']>
  reviewStatus: ScalarsEnums['GiftCardExpiryRuleReviewStatus']
  reviewedAt?: Maybe<ScalarsEnums['String']>
  reviewedByEmail?: Maybe<ScalarsEnums['String']>
  reviewedByUserId?: Maybe<ScalarsEnums['String']>
  sourceUrl?: Maybe<ScalarsEnums['String']>
  updatedAt: ScalarsEnums['String']
  updatedByUserId?: Maybe<ScalarsEnums['String']>
  zoneCode?: Maybe<ScalarsEnums['String']>
  zoneId?: Maybe<ScalarsEnums['String']>
  zoneName?: Maybe<ScalarsEnums['String']>
}

/**
 * One audited change to a gift card expiry rule, with the rule as JSON before and after
 */
export interface GiftCardExpiryRuleHistoryEntry {
  __typename?: 'GiftCardExpiryRuleHistoryEntry'
  action: ScalarsEnums['GiftCardExpiryRuleHistoryAction']
  actorEmail?: Maybe<ScalarsEnums['String']>
  actorUserId?: Maybe<ScalarsEnums['String']>
  after?: Maybe<ScalarsEnums['String']>
  before?: Maybe<ScalarsEnums['String']>
  createdAt: ScalarsEnums['String']
  giftCardExpiryRuleHistoryId: ScalarsEnums['ID']
  giftCardExpiryRuleId: ScalarsEnums['ID']
}

/**
 * A gift card expiry rule as stored, without its jurisdiction names
 */
export interface GiftCardExpiryRuleRecord {
  __typename?: 'GiftCardExpiryRuleRecord'
  countryId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  disclosureRequired: ScalarsEnums['Boolean']
  effectiveFrom: ScalarsEnums['String']
  expiryPolicy: ScalarsEnums['GiftCardExpiryPolicy']
  giftCardExpiryRuleId: ScalarsEnums['ID']
  legalCitation?: Maybe<ScalarsEnums['String']>
  maximumTermMonths?: Maybe<ScalarsEnums['Float']>
  minimumTermMonths?: Maybe<ScalarsEnums['Float']>
  notes?: Maybe<ScalarsEnums['String']>
  reviewStatus: ScalarsEnums['GiftCardExpiryRuleReviewStatus']
  reviewedAt?: Maybe<ScalarsEnums['String']>
  reviewedByEmail?: Maybe<ScalarsEnums['String']>
  reviewedByUserId?: Maybe<ScalarsEnums['String']>
  sourceUrl?: Maybe<ScalarsEnums['String']>
  updatedAt: ScalarsEnums['String']
  updatedByUserId?: Maybe<ScalarsEnums['String']>
  zoneId?: Maybe<ScalarsEnums['String']>
}

/**
 * A location that can be previewed for its gift card expiry policy
 */
export interface GiftCardExpirySiteOption {
  __typename?: 'GiftCardExpirySiteOption'
  name: ScalarsEnums['String']
  siteId: ScalarsEnums['String']
  status?: Maybe<ScalarsEnums['String']>
}

/**
 * The gift card expiry policy a location gets, resolved exactly as a sale there would be
 */
export interface GiftCardExpirySitePreview {
  __typename?: 'GiftCardExpirySitePreview'
  asOfDate: ScalarsEnums['String']
  jurisdictionCode?: Maybe<ScalarsEnums['String']>
  jurisdictionName?: Maybe<ScalarsEnums['String']>
  policy: ResolvedGiftCardExpiryPolicy
  siteId: ScalarsEnums['ID']
  siteName: ScalarsEnums['String']
  stateRequired: ScalarsEnums['Boolean']
  timezone: ScalarsEnums['String']
}

/**
 * A gift card row for the site-scoped Retail Dashboard list
 */
export interface GiftCardSiteListItem {
  __typename?: 'GiftCardSiteListItem'
  buyerEmail: ScalarsEnums['String']
  buyerName: ScalarsEnums['String']
  clientId?: Maybe<ScalarsEnums['ID']>
  code: ScalarsEnums['String']
  currency?: Maybe<ScalarsEnums['String']>
  currentBalance: ScalarsEnums['Numeric']
  expiredAt?: Maybe<ScalarsEnums['String']>
  expiresAt?: Maybe<ScalarsEnums['String']>
  giftCardId: ScalarsEnums['ID']
  giftCardTemplateId: ScalarsEnums['ID']
  initialValue: ScalarsEnums['Numeric']
  isImported: ScalarsEnums['Boolean']
  lastRedemptionDate?: Maybe<ScalarsEnums['String']>
  locationName?: Maybe<ScalarsEnums['String']>
  purchaseDate: ScalarsEnums['String']
  redemptionCount: ScalarsEnums['Float']
  status: ScalarsEnums['GiftCardStatus']
  templateName: ScalarsEnums['String']
}

/**
 * Paginated site-scoped gift card list response
 */
export interface GiftCardSiteListResponse {
  __typename?: 'GiftCardSiteListResponse'
  records: Array<GiftCardSiteListItem>
  totalCount: ScalarsEnums['Float']
}

/**
 * A gift card template that defines gift card properties
 */
export interface GiftCardTemplate {
  __typename?: 'GiftCardTemplate'
  createdAt: ScalarsEnums['String']
  description?: Maybe<ScalarsEnums['String']>
  expiryEnabled: ScalarsEnums['Boolean']
  expiryMonths?: Maybe<ScalarsEnums['Float']>
  /**
   * Months a card from this template stays valid when sold at the site, or null when it will not expire there
   */
  expiryMonthsAtSite: (args: { siteId: ScalarsEnums['ID'] }) => Maybe<ScalarsEnums['Float']>
  fixedAmount?: Maybe<ScalarsEnums['Numeric']>
  fixedValue?: Maybe<ScalarsEnums['Numeric']>
  fixedValueEnabled: ScalarsEnums['Boolean']
  giftCardDesignId?: Maybe<ScalarsEnums['ID']>
  giftCardTemplateId: ScalarsEnums['ID']
  isAllSharedSites: ScalarsEnums['Boolean']
  isOnlineSaleEnabled: ScalarsEnums['Boolean']
  name: ScalarsEnums['String']
  restrictedMembershipTemplateIds: Array<ScalarsEnums['ID']>
  restrictedPackageTemplateIds: Array<ScalarsEnums['ID']>
  restrictedSaleEnabled: ScalarsEnums['Boolean']
  revenueTagId?: Maybe<ScalarsEnums['String']>
  sharedSiteIds: Array<ScalarsEnums['ID']>
  siteId: ScalarsEnums['ID']
  status: ScalarsEnums['GiftCardTemplateStatus']
  totalClaimed?: Maybe<ScalarsEnums['Float']>
  totalIssued?: Maybe<ScalarsEnums['Float']>
  updatedAt: ScalarsEnums['String']
}

export interface GiftCardTemplates {
  __typename?: 'GiftCardTemplates'
  records: Array<GiftCardTemplate>
  totalCount: ScalarsEnums['Float']
}

export interface GiftCards {
  __typename?: 'GiftCards'
  records: Array<GiftCardsRecords>
  totalCount: ScalarsEnums['Float']
}

export interface GiftCardsRecords {
  __typename?: 'GiftCardsRecords'
  clientId?: Maybe<ScalarsEnums['ID']>
  code: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  currentBalance: ScalarsEnums['Numeric']
  deliveryDate?: Maybe<ScalarsEnums['String']>
  expiredAt?: Maybe<ScalarsEnums['String']>
  expiresAt?: Maybe<ScalarsEnums['String']>
  expiryJurisdiction?: Maybe<ScalarsEnums['String']>
  giftCardDesignId?: Maybe<ScalarsEnums['ID']>
  giftCardId: ScalarsEnums['ID']
  giftCardTemplateId: ScalarsEnums['ID']
  initialValue: ScalarsEnums['Numeric']
  isImported: ScalarsEnums['Boolean']
  personalMessage?: Maybe<ScalarsEnums['String']>
  purchaserEmail?: Maybe<ScalarsEnums['String']>
  purchaserName?: Maybe<ScalarsEnums['String']>
  recipientEmail?: Maybe<ScalarsEnums['String']>
  recipientEmailScheduledFor?: Maybe<ScalarsEnums['String']>
  recipientEmailSentAt?: Maybe<ScalarsEnums['String']>
  recipientName?: Maybe<ScalarsEnums['String']>
  redeemerName?: Maybe<ScalarsEnums['String']>
  restrictedMembershipTemplateIds: Array<ScalarsEnums['ID']>
  restrictedPackageTemplateIds: Array<ScalarsEnums['ID']>
  restrictedSaleEnabled: ScalarsEnums['Boolean']
  updatedAt: ScalarsEnums['String']
}

/**
 * A location a client is connected to in Grow, with its sync status
 */
export interface GrowClientLocation {
  __typename?: 'GrowClientLocation'
  siteId?: Maybe<ScalarsEnums['String']>
  siteName?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['ClientGrowSyncStatus']
}

/**
 * Per-location Grow sync status for a client
 */
export interface GrowContactLocationStatus {
  __typename?: 'GrowContactLocationStatus'
  customFields: Array<GrowRecordField>
  failCode?: Maybe<ScalarsEnums['String']>
  failError?: Maybe<ScalarsEnums['String']>
  failedAt?: Maybe<ScalarsEnums['String']>
  growContactId?: Maybe<ScalarsEnums['String']>
  growLocationId: ScalarsEnums['String']
  lastCollectedAt?: Maybe<ScalarsEnums['String']>
  lastSyncedAt?: Maybe<ScalarsEnums['String']>
  siteId?: Maybe<ScalarsEnums['String']>
  siteName?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['ClientGrowSyncStatus']
  syncedFields: Array<GrowRecordField>
  tags: Array<ScalarsEnums['String']>
}

/**
 * Grow HQ configuration
 */
export interface GrowHq {
  __typename?: 'GrowHq'
  growLocationId?: Maybe<ScalarsEnums['String']>
  id: ScalarsEnums['String']
  isAuthenticated?: Maybe<ScalarsEnums['Boolean']>
  lastSyncError?: Maybe<ScalarsEnums['String']>
  lastSyncedAt?: Maybe<ScalarsEnums['String']>
  linkedSiteIds?: Maybe<Array<ScalarsEnums['String']>>
  name: ScalarsEnums['String']
  syncAttempts?: Maybe<ScalarsEnums['Float']>
  syncStatus?: Maybe<ScalarsEnums['SyncStatus']>
  tokenExpiresAt?: Maybe<ScalarsEnums['String']>
}

/**
 * Last collection timestamps for grow sync operations
 */
export interface GrowLastCollect {
  __typename?: 'GrowLastCollect'
  full?: Maybe<ScalarsEnums['String']>
}

/**
 * Grow sync status for a site location
 */
export interface GrowLocation {
  __typename?: 'GrowLocation'
  growLocationId: ScalarsEnums['String']
  hqId?: Maybe<ScalarsEnums['String']>
  lastSyncError?: Maybe<ScalarsEnums['String']>
  lastSyncedAt?: Maybe<ScalarsEnums['String']>
  siteId: ScalarsEnums['String']
  siteName: ScalarsEnums['String']
  syncAttempts?: Maybe<ScalarsEnums['Float']>
  syncStatus?: Maybe<ScalarsEnums['SyncStatus']>
}

/**
 * A display-ready label/value from the Grow payload, with the current client value and whether they differ
 */
export interface GrowRecordField {
  __typename?: 'GrowRecordField'
  clientValue?: Maybe<ScalarsEnums['String']>
  label: ScalarsEnums['String']
  mismatch: ScalarsEnums['Boolean']
  value: ScalarsEnums['String']
}

/**
 * The outcome of revoking a guardian's authority for one child
 */
export interface GuardianAuthorityRevocationResult {
  __typename?: 'GuardianAuthorityRevocationResult'
  clientId: ScalarsEnums['ID']
  guardianClientId: ScalarsEnums['ID']
  revokedRelationCount: ScalarsEnums['Float']
}

/**
 * A guardian's withdrawal of permission for one child to use equipment (D-04)
 */
export interface GuardianPermissionWithdrawal {
  __typename?: 'GuardianPermissionWithdrawal'
  clientId: ScalarsEnums['ID']
  guardianSignerId: ScalarsEnums['ID']
  reason?: Maybe<ScalarsEnums['String']>
  recordedByStaffUserId?: Maybe<ScalarsEnums['ID']>
  source: ScalarsEnums['ConsentWithdrawalSource']
  withdrawalId: ScalarsEnums['ID']
  withdrawnAt: ScalarsEnums['String']
}

/**
 * An individual guest pass with its send/claim/redeem lifecycle
 */
export interface GuestPass {
  __typename?: 'GuestPass'
  acceptedAt?: Maybe<ScalarsEnums['String']>
  bookingId?: Maybe<ScalarsEnums['ID']>
  checkInId?: Maybe<ScalarsEnums['ID']>
  claimUrl?: Maybe<ScalarsEnums['String']>
  claimedAllocationId?: Maybe<ScalarsEnums['ID']>
  claimedServiceId?: Maybe<ScalarsEnums['ID']>
  corporateId?: Maybe<ScalarsEnums['ID']>
  createdAt: ScalarsEnums['String']
  expiresAt?: Maybe<ScalarsEnums['String']>
  guestPassAllocationId: ScalarsEnums['ID']
  guestPassId: ScalarsEnums['ID']
  inviteEmailSentAt?: Maybe<ScalarsEnums['String']>
  inviteToken: ScalarsEnums['String']
  recipientClientId?: Maybe<ScalarsEnums['ID']>
  recipientEmail?: Maybe<ScalarsEnums['String']>
  recipientName?: Maybe<ScalarsEnums['String']>
  recipientPhone?: Maybe<ScalarsEnums['String']>
  revokedAt?: Maybe<ScalarsEnums['String']>
  senderClientId: ScalarsEnums['ID']
  sentAt: ScalarsEnums['String']
  serviceId: ScalarsEnums['ID']
  siteId: ScalarsEnums['ID']
  siteSessionTypeId?: Maybe<ScalarsEnums['ID']>
  status: ScalarsEnums['GuestPassStatus']
  updatedAt: ScalarsEnums['String']
  usedAt?: Maybe<ScalarsEnums['String']>
}

/**
 * Aggregated guest pass balance for a member's service
 */
export interface GuestPassAllocationSummary {
  __typename?: 'GuestPassAllocationSummary'
  carriedForward: ScalarsEnums['Float']
  expiresAtDate?: Maybe<ScalarsEnums['String']>
  nextAllocationDate?: Maybe<ScalarsEnums['String']>
  remainingPasses: ScalarsEnums['Float']
  serviceId: ScalarsEnums['ID']
  totalPasses: ScalarsEnums['Float']
}

/**
 * Members and invites a guest pass allowance change on a membership reaches: active members for Apply, open allocations and unclaimed invites for turning guest passes off
 */
export interface GuestPassAllowanceImpact {
  __typename?: 'GuestPassAllowanceImpact'
  activeMembers: ScalarsEnums['Float']
  membersWithOpenPasses: ScalarsEnums['Float']
  unclaimedInvites: ScalarsEnums['Float']
}

/**
 * Invite context (or typed error) for a guest pass invite token
 */
export interface GuestPassByTokenResult {
  __typename?: 'GuestPassByTokenResult'
  errorCode?: Maybe<ScalarsEnums['GuestPassByTokenError']>
  expiresAt?: Maybe<ScalarsEnums['String']>
  recipientEmailMasked?: Maybe<ScalarsEnums['String']>
  senderName?: Maybe<ScalarsEnums['String']>
  siteId?: Maybe<ScalarsEnums['ID']>
  siteName?: Maybe<ScalarsEnums['String']>
}

/**
 * Credits a claimed guest pass gave for one credit line, and how many are left
 */
export interface GuestPassCreditLineUsage {
  __typename?: 'GuestPassCreditLineUsage'
  creditsRemaining: ScalarsEnums['Float']
  creditsTotal: ScalarsEnums['Float']
  sessionTypeNames: Array<ScalarsEnums['String']>
}

/**
 * A booking or check-in paid with guest pass credits, net of refunds
 */
export interface GuestPassVisit {
  __typename?: 'GuestPassVisit'
  bookingId?: Maybe<ScalarsEnums['ID']>
  checkInId?: Maybe<ScalarsEnums['ID']>
  credits: ScalarsEnums['Float']
  guestPassId: ScalarsEnums['ID']
  recipientName?: Maybe<ScalarsEnums['String']>
  sessionName?: Maybe<ScalarsEnums['String']>
  sessionStartTime?: Maybe<ScalarsEnums['String']>
  sessionTypeName?: Maybe<ScalarsEnums['String']>
  usedAt: ScalarsEnums['String']
}

/**
 * A guest pass with display fields for the session it was used for
 */
export interface GuestPassWithSession {
  __typename?: 'GuestPassWithSession'
  acceptedAt?: Maybe<ScalarsEnums['String']>
  bookingId?: Maybe<ScalarsEnums['ID']>
  checkInId?: Maybe<ScalarsEnums['ID']>
  claimUrl?: Maybe<ScalarsEnums['String']>
  claimedAllocationId?: Maybe<ScalarsEnums['ID']>
  claimedServiceId?: Maybe<ScalarsEnums['ID']>
  corporateId?: Maybe<ScalarsEnums['ID']>
  createdAt: ScalarsEnums['String']
  creditLines: Array<GuestPassCreditLineUsage>
  expiresAt?: Maybe<ScalarsEnums['String']>
  guestPassAllocationId: ScalarsEnums['ID']
  guestPassId: ScalarsEnums['ID']
  inviteEmailSentAt?: Maybe<ScalarsEnums['String']>
  inviteToken: ScalarsEnums['String']
  recipientClientId?: Maybe<ScalarsEnums['ID']>
  recipientEmail?: Maybe<ScalarsEnums['String']>
  recipientName?: Maybe<ScalarsEnums['String']>
  recipientPhone?: Maybe<ScalarsEnums['String']>
  revokedAt?: Maybe<ScalarsEnums['String']>
  senderClientId: ScalarsEnums['ID']
  senderName?: Maybe<ScalarsEnums['String']>
  sentAt: ScalarsEnums['String']
  serviceId: ScalarsEnums['ID']
  sessionName?: Maybe<ScalarsEnums['String']>
  sessionStartTime?: Maybe<ScalarsEnums['String']>
  sessionTypeName?: Maybe<ScalarsEnums['String']>
  siteId: ScalarsEnums['ID']
  siteSessionTypeId?: Maybe<ScalarsEnums['ID']>
  status: ScalarsEnums['GuestPassStatus']
  updatedAt: ScalarsEnums['String']
  usedAt?: Maybe<ScalarsEnums['String']>
  visits: Array<GuestPassVisit>
}

export interface HapanaFeesTemplate {
  __typename?: 'HapanaFeesTemplate'
  createdAt: ScalarsEnums['String']
  failedPaymentFeeScope: ScalarsEnums['FailedPaymentFeeScope']
  fees: Array<HapanaFeesTemplateFees>
  hapanaFeesTemplateId: ScalarsEnums['String']
  name: ScalarsEnums['String']
  /**
   * The sites associated with the hapana fees template
   */
  sites: Array<Site>
  updatedAt: ScalarsEnums['String']
}

export interface HapanaFeesTemplateFees {
  __typename?: 'HapanaFeesTemplateFees'
  enabled?: Maybe<ScalarsEnums['Boolean']>
  feeId: ScalarsEnums['String']
  rate?: Maybe<ScalarsEnums['Float']>
}

export interface HapanaFeesTemplatesBasePageInfo {
  __typename?: 'HapanaFeesTemplatesBasePageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  hasPreviousPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Float']
}

export interface HapanaFeesTemplatesPageInfo {
  __typename?: 'HapanaFeesTemplatesPageInfo'
  pageInfo: HapanaFeesTemplatesBasePageInfo
  results: Array<HapanaFeesTemplate>
}

/**
 * Outcome of releasing a payment held for remote 3DS approval
 */
export interface HeldPaymentReleaseResult {
  __typename?: 'HeldPaymentReleaseResult'
  outcome: ScalarsEnums['HeldPaymentReleaseOutcome']
}

export interface HelpDoc {
  __typename?: 'HelpDoc'
  announcedIn: Array<ReleaseHubNote>
  category?: Maybe<ScalarsEnums['String']>
  contentMarkdown: ScalarsEnums['String']
  coverImageUrl?: Maybe<ScalarsEnums['String']>
  knowledgeArticleId: ScalarsEnums['ID']
  publishedAt?: Maybe<ScalarsEnums['String']>
  slug: ScalarsEnums['String']
  subtitle?: Maybe<ScalarsEnums['String']>
  summary?: Maybe<ScalarsEnums['String']>
  tierTags: Array<ScalarsEnums['String']>
  title: ScalarsEnums['String']
  updatedAt: ScalarsEnums['String']
}

export interface HelpDocCategory {
  __typename?: 'HelpDocCategory'
  articleCount: ScalarsEnums['Int']
  color?: Maybe<ScalarsEnums['String']>
  icon?: Maybe<ScalarsEnums['String']>
  knowledgeArticleCategoryId: ScalarsEnums['ID']
  name: ScalarsEnums['String']
  slug: ScalarsEnums['String']
  sortOrder: ScalarsEnums['Int']
}

export interface HelpDocSummary {
  __typename?: 'HelpDocSummary'
  category?: Maybe<ScalarsEnums['String']>
  coverImageUrl?: Maybe<ScalarsEnums['String']>
  createdAt: ScalarsEnums['String']
  knowledgeArticleId: ScalarsEnums['ID']
  publishedAt?: Maybe<ScalarsEnums['String']>
  slug: ScalarsEnums['String']
  subtitle?: Maybe<ScalarsEnums['String']>
  summary?: Maybe<ScalarsEnums['String']>
  tierTags: Array<ScalarsEnums['String']>
  title: ScalarsEnums['String']
  updatedAt: ScalarsEnums['String']
}

/**
 * HubSpot companies search result
 */
export interface HubSpotCompaniesSearchResult {
  __typename?: 'HubSpotCompaniesSearchResult'
  paging?: Maybe<HubSpotCompaniesSearchResultPaging>
  results: Array<HubSpotCompany>
  total: ScalarsEnums['Float']
}

export interface HubSpotCompaniesSearchResultPaging {
  __typename?: 'HubSpotCompaniesSearchResultPaging'
  next?: Maybe<HubSpotCompaniesSearchResultPagingNext>
}

export interface HubSpotCompaniesSearchResultPagingNext {
  __typename?: 'HubSpotCompaniesSearchResultPagingNext'
  after: ScalarsEnums['String']
}

/**
 * HubSpot company information
 */
export interface HubSpotCompany {
  __typename?: 'HubSpotCompany'
  createdAt: ScalarsEnums['String']
  id: ScalarsEnums['String']
  properties: HubSpotCompanyProperties
  updatedAt: ScalarsEnums['String']
}

/**
 * Contacts associated with a HubSpot company
 */
export interface HubSpotCompanyContactsResult {
  __typename?: 'HubSpotCompanyContactsResult'
  contacts: Array<HubSpotContact>
}

export interface HubSpotCompanyProperties {
  __typename?: 'HubSpotCompanyProperties'
  domain?: Maybe<ScalarsEnums['String']>
  name?: Maybe<ScalarsEnums['String']>
  website?: Maybe<ScalarsEnums['String']>
}

/**
 * HubSpot contact information
 */
export interface HubSpotContact {
  __typename?: 'HubSpotContact'
  email?: Maybe<ScalarsEnums['String']>
  firstName?: Maybe<ScalarsEnums['String']>
  id: ScalarsEnums['String']
  lastName?: Maybe<ScalarsEnums['String']>
}

export interface ImageFileConfigField {
  __typename?: 'ImageFileConfigField'
  lastFailure?: Maybe<RoomResourceTemplateImageLastFailure>
  pending?: Maybe<RoomResourceTemplateImagePending>
  status: ScalarsEnums['FileUploadConfigFieldStatus']
  versions?: Maybe<Array<ImageFileVersion>>
}

export interface ImageFileVersion {
  __typename?: 'ImageFileVersion'
  byteSize?: Maybe<ScalarsEnums['Float']>
  format: ScalarsEnums['ImageFileVersionFormat']
  height?: Maybe<ScalarsEnums['Int']>
  sha256?: Maybe<ScalarsEnums['String']>
  type: ScalarsEnums['ImageFileVersionType']
  url: ScalarsEnums['String']
  width?: Maybe<ScalarsEnums['Int']>
}

export interface ImagePublicSignedUrl {
  __typename?: 'ImagePublicSignedUrl'
  byteSize?: Maybe<ScalarsEnums['Float']>
  height?: Maybe<ScalarsEnums['Int']>
  sha256?: Maybe<ScalarsEnums['String']>
  type: ScalarsEnums['ImageFileVersionType']
  url: ScalarsEnums['String']
  width?: Maybe<ScalarsEnums['Int']>
}

export interface ImportAuditCsvUrl {
  __typename?: 'ImportAuditCsvUrl'
  url?: Maybe<ScalarsEnums['String']>
}

export interface ImportCustomText {
  __typename?: 'ImportCustomText'
  errorsByLanguage?: Maybe<ScalarsEnums['JSONObject']>
  importedLanguages?: Maybe<Array<ScalarsEnums['String']>>
  success: ScalarsEnums['Boolean']
}

export interface ImportDistinctLocationIds {
  __typename?: 'ImportDistinctLocationIds'
  locationIds: Array<ScalarsEnums['String']>
}

export interface ImportFailuresAuditCsvUrl {
  __typename?: 'ImportFailuresAuditCsvUrl'
  url?: Maybe<ScalarsEnums['String']>
}

export interface ImportPrerequisites {
  __typename?: 'ImportPrerequisites'
  prerequisites: Array<ImportPrerequisitesPrerequisites>
}

export interface ImportPrerequisitesPrerequisites {
  __typename?: 'ImportPrerequisitesPrerequisites'
  existsInDb: ScalarsEnums['Boolean']
  importType: ScalarsEnums['String']
}

export interface ImportPreview {
  __typename?: 'ImportPreview'
  fieldMetadata?: Maybe<Array<ImportPreviewFieldMetadata>>
  invalidCount: ScalarsEnums['Float']
  pendingCount: ScalarsEnums['Float']
  rows: Array<ImportPreviewRows>
  skippedCount: ScalarsEnums['Float']
  totalErrorCount: ScalarsEnums['Float']
  totalRows: ScalarsEnums['Float']
  validCount: ScalarsEnums['Float']
  warningCount: ScalarsEnums['Float']
}

export interface ImportPreviewFieldMetadata {
  __typename?: 'ImportPreviewFieldMetadata'
  allowedValues?: Maybe<Array<ScalarsEnums['String']>>
  displayName?: Maybe<ScalarsEnums['String']>
  fieldName: ScalarsEnums['String']
  fieldType: ScalarsEnums['String']
}

export interface ImportPreviewRows {
  __typename?: 'ImportPreviewRows'
  csvData: ScalarsEnums['String']
  errorMessage?: Maybe<ScalarsEnums['String']>
  processingStatus?: Maybe<ScalarsEnums['String']>
  rowIndex: ScalarsEnums['Float']
  skippedAt?: Maybe<ScalarsEnums['String']>
  skippedBy?: Maybe<ScalarsEnums['String']>
  validationErrors?: Maybe<Array<ImportPreviewRowsValidationErrors>>
  validationStatus: ScalarsEnums['String']
}

export interface ImportPreviewRowsValidationErrors {
  __typename?: 'ImportPreviewRowsValidationErrors'
  code: ScalarsEnums['String']
  field: ScalarsEnums['String']
  message: ScalarsEnums['String']
  severity: ScalarsEnums['String']
}

export interface ImportReferenceDataExportXlsx {
  __typename?: 'ImportReferenceDataExportXlsx'
  fileContentBase64: ScalarsEnums['String']
  fileName: ScalarsEnums['String']
}

export interface ImportSession {
  __typename?: 'ImportSession'
  auditCsvUrl?: Maybe<ScalarsEnums['String']>
  bytesProcessed?: Maybe<ScalarsEnums['Float']>
  completedAt?: Maybe<ScalarsEnums['String']>
  createdAt: ScalarsEnums['String']
  createdBy: ScalarsEnums['String']
  defaultSiteId?: Maybe<ScalarsEnums['String']>
  failedRowCount?: Maybe<ScalarsEnums['Float']>
  failuresAuditCsvUrl?: Maybe<ScalarsEnums['String']>
  failuresSourceFileUrl?: Maybe<ScalarsEnums['String']>
  fileName: ScalarsEnums['String']
  fileSize: ScalarsEnums['Float']
  gcsUrl: ScalarsEnums['String']
  importSessionId: ScalarsEnums['ID']
  importType: ScalarsEnums['String']
  invalidRowCount?: Maybe<ScalarsEnums['Float']>
  lastProgressAt?: Maybe<ScalarsEnums['String']>
  mappedHeaders?: Maybe<ScalarsEnums['String']>
  membershipImportSummary?: Maybe<MembershipImportSummary>
  migrationId?: Maybe<ScalarsEnums['ID']>
  migrationName?: Maybe<ScalarsEnums['String']>
  orderedHeaders?: Maybe<ScalarsEnums['String']>
  postImportChecks?: Maybe<ImportSessionPostImportChecks>
  processedAuditCsvUrl?: Maybe<ScalarsEnums['String']>
  processedRowCount?: Maybe<ScalarsEnums['Float']>
  siteId?: Maybe<ScalarsEnums['String']>
  skippedAuditCsvUrl?: Maybe<ScalarsEnums['String']>
  skippedSourceFileUrl?: Maybe<ScalarsEnums['String']>
  sourceSystem?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['String']
  successRowCount?: Maybe<ScalarsEnums['Float']>
  targetEnvironment?: Maybe<ScalarsEnums['String']>
  templateVersion?: Maybe<ScalarsEnums['String']>
  totalRows: ScalarsEnums['Float']
  validRowCount?: Maybe<ScalarsEnums['Float']>
  validSiteIds?: Maybe<ScalarsEnums['String']>
}

export interface ImportSessionPostImportChecks {
  __typename?: 'ImportSessionPostImportChecks'
  cpmSiteMismatch?: Maybe<ImportSessionPostImportChecksServiceRiStatusPair>
  membershipMissingNextBillingDate?: Maybe<ImportSessionPostImportChecksServiceRiStatusPair>
  membershipStatusCounts?: Maybe<Array<MembershipStatusCount>>
  membershipStatusMismatch?: Maybe<ImportSessionPostImportChecksServiceRiStatusPair>
  nextDatePairMismatch?: Maybe<ImportSessionPostImportChecksServiceRiStatusPair>
  scheduledInvoiceMissingCpm?: Maybe<ImportSessionPostImportChecksServiceRiStatusPair>
  serviceRiStatusPair?: Maybe<ImportSessionPostImportChecksServiceRiStatusPair>
  zeroRiWithAmountDue?: Maybe<ImportSessionPostImportChecksServiceRiStatusPair>
}

export interface ImportSessionPostImportChecksServiceRiStatusPair {
  __typename?: 'ImportSessionPostImportChecksServiceRiStatusPair'
  samples: Array<ScalarsEnums['String']>
  violationCount: ScalarsEnums['Float']
}

export interface ImportSitesExportCsv {
  __typename?: 'ImportSitesExportCsv'
  csvContent: ScalarsEnums['String']
  fileName: ScalarsEnums['String']
}

export interface ImportSourceFileUrl {
  __typename?: 'ImportSourceFileUrl'
  url?: Maybe<ScalarsEnums['String']>
}

export interface ImportTemplateCsv {
  __typename?: 'ImportTemplateCsv'
  csvContent: ScalarsEnums['String']
  fileName: ScalarsEnums['String']
  importType: ScalarsEnums['String']
}

/**
 * Non-secret Inception settings stored on an access point, used to prefill the edit form
 */
export interface InceptionPanelSettings {
  __typename?: 'InceptionPanelSettings'
  doorId: ScalarsEnums['String']
  rootUrl: ScalarsEnums['String']
  serialNumber: ScalarsEnums['String']
  username: ScalarsEnums['String']
}

export interface IncomingApprovalDecisionResult {
  __typename?: 'IncomingApprovalDecisionResult'
  accepted: ScalarsEnums['Boolean']
  memberMovementId: ScalarsEnums['ID']
}

export interface InitiateCSVUpload {
  __typename?: 'InitiateCSVUpload'
  importSessionId: ScalarsEnums['ID']
  tempUrl: ScalarsEnums['String']
  userId: ScalarsEnums['String']
  userType: ScalarsEnums['String']
}

/**
 * Response from initiating a payment method setup
 */
export interface InitiatePaymentMethodResponse {
  __typename?: 'InitiatePaymentMethodResponse'
  applePayAvailable: ScalarsEnums['Boolean']
  clientPaymentMethodId: ScalarsEnums['ID']
  completionConfig: CompletionConfig
  currencyCode?: Maybe<ScalarsEnums['String']>
  disableWallets: ScalarsEnums['Boolean']
  googlePayAvailable: ScalarsEnums['Boolean']
}

export interface InitiateTerminalPaymentMethodSetup {
  __typename?: 'InitiateTerminalPaymentMethodSetup'
  clientPaymentMethodId: ScalarsEnums['String']
  setupIntentId: ScalarsEnums['String']
  status: ScalarsEnums['String']
}

export interface InitiateZIPUpload {
  __typename?: 'InitiateZIPUpload'
  importSessionId: ScalarsEnums['ID']
  tempUrl: ScalarsEnums['String']
  userId: ScalarsEnums['String']
  userType: ScalarsEnums['String']
}

/**
 * Staff user who can be assigned as an instructor for a site
 */
export interface InstructorForSite {
  __typename?: 'InstructorForSite'
  email: ScalarsEnums['String']
  firstName: ScalarsEnums['String']
  lastName: ScalarsEnums['String']
  staffUserId: ScalarsEnums['String']
  status: ScalarsEnums['String']
  workingHours?: Maybe<StaffUserDataWorkingHours>
}

/**
 * Instructor information for mobile booking
 */
export interface InstructorListInfo {
  __typename?: 'InstructorListInfo'
  instructorID: ScalarsEnums['String']
  instructorName: ScalarsEnums['String']
  instructorProfile?: Maybe<ScalarsEnums['String']>
}

export interface InviteStaffMember {
  __typename?: 'InviteStaffMember'
  invitationId: ScalarsEnums['ID']
  token: ScalarsEnums['String']
}

/**
 * An invoice with items
 */
export interface Invoice {
  __typename?: 'Invoice'
  addonConfigId?: Maybe<ScalarsEnums['ID']>
  amountDue: ScalarsEnums['Numeric']
  /**
   * Beneficiary client who receives the service/product (when different from payer/clientId)
   */
  beneficiary?: Maybe<Client>
  beneficiaryId?: Maybe<ScalarsEnums['ID']>
  cancellationSource?: Maybe<ScalarsEnums['InvoiceCancellationSource']>
  cancelledAt?: Maybe<ScalarsEnums['String']>
  cancelledByStaffUserId?: Maybe<ScalarsEnums['String']>
  /**
   * Client associated with this invoice (payer)
   */
  client?: Maybe<Client>
  clientId?: Maybe<ScalarsEnums['ID']>
  clientName?: Maybe<ScalarsEnums['String']>
  createdAt: ScalarsEnums['String']
  createdByRecurringInvoiceId?: Maybe<ScalarsEnums['ID']>
  currency: ScalarsEnums['Currency']
  customPaymentMethodLabel?: Maybe<ScalarsEnums['String']>
  description?: Maybe<ScalarsEnums['String']>
  dueDate: ScalarsEnums['String']
  exclusiveTaxTotal: ScalarsEnums['Numeric']
  fullyPaidDate?: Maybe<ScalarsEnums['String']>
  giftCardCode?: Maybe<ScalarsEnums['String']>
  /**
   * ID of the gift card (calculated from InvoiceItem.giftCardId or InvoiceItem.giftCardTemplateId)
   */
  giftCardId?: Maybe<ScalarsEnums['String']>
  /**
   * Name of the gift card (calculated from GiftCardTemplate.name)
   */
  giftCardName?: Maybe<ScalarsEnums['String']>
  hasDisputeLoss: ScalarsEnums['Boolean']
  hasRefundFailed: ScalarsEnums['Boolean']
  hasRequiredClientAction: ScalarsEnums['Boolean']
  inclusiveTaxTotal: ScalarsEnums['Numeric']
  invoiceId: ScalarsEnums['ID']
  invoiceTypes: Array<ScalarsEnums['InvoiceType']>
  /**
   * Whether this invoice has been through a failure path (has failed/failed_retry status history or failed automated payments). Determines which cancellation dialog to show.
   */
  isFailurePath: ScalarsEnums['Boolean']
  isImported: ScalarsEnums['Boolean']
  isPresaleInitial?: Maybe<ScalarsEnums['Boolean']>
  /**
   * Whether this invoice was created from a recurring invoice
   */
  isRecurring: ScalarsEnums['Boolean']
  itemDiscountTotal: ScalarsEnums['Numeric']
  /**
   * Invoice line items with live service auto-renew status
   */
  items: Array<InvoiceItems>
  /**
   * Name of the membership (calculated from InvoiceItem.description for service/recurring_service_payment items)
   */
  membershipName?: Maybe<ScalarsEnums['String']>
  paymentMethodTypes?: Maybe<Array<ScalarsEnums['PaymentMethodType']>>
  /**
   * Payments associated with this invoice
   */
  payments: Array<Payment>
  pendingChange?: Maybe<PendingChange>
  /**
   * What a draft (staged) invoice is still waiting on: agreement signature, payment, or both. Null for every other status.
   */
  pendingReason?: Maybe<ScalarsEnums['InvoicePendingReason']>
  processedAt?: Maybe<ScalarsEnums['String']>
  /**
   * Name of the product (calculated from PosProductVariable.variableName or PosProduct.productName)
   */
  productName?: Maybe<ScalarsEnums['String']>
  /**
   * ID of the recurring invoice that created this invoice (if applicable)
   */
  recurringInvoiceId?: Maybe<ScalarsEnums['ID']>
  recurringInvoiceSequence?: Maybe<ScalarsEnums['Float']>
  recurringInvoiceStatus?: Maybe<ScalarsEnums['String']>
  recurringInvoiceSuspendedUntil?: Maybe<ScalarsEnums['String']>
  /**
   * Sequence number of this invoice in the recurring series (if applicable)
   */
  recurringSequence?: Maybe<ScalarsEnums['Float']>
  /**
   * Service ID for this recurring invoice (if applicable)
   */
  recurringServiceId?: Maybe<ScalarsEnums['ID']>
  /**
   * Date when the gift card was redeemed (calculated from InvoiceItem.redeemedAt)
   */
  redeemedAt?: Maybe<ScalarsEnums['String']>
  /**
   * Site ID where the gift card was redeemed (calculated from InvoiceItem.redeemedAtSiteId)
   */
  redeemedAtSiteId?: Maybe<ScalarsEnums['String']>
  /**
   * Site name where the gift card was redeemed (calculated from Site.name via InvoiceItem.redeemedAtSiteId)
   */
  redeemedAtSiteName?: Maybe<ScalarsEnums['String']>
  /**
   * Refunds associated with this invoice
   */
  refunds: Array<Refund>
  reinstatedAt?: Maybe<ScalarsEnums['String']>
  reinstatedByStaffUserId?: Maybe<ScalarsEnums['String']>
  saleDate: ScalarsEnums['String']
  saleId: ScalarsEnums['String']
  scheduledClientPaymentMethodId?: Maybe<ScalarsEnums['ID']>
  scheduledProcessingAt?: Maybe<ScalarsEnums['String']>
  /**
   * Minimal site projection for the site that owns this invoice. Currently used by the UI to country-gate display (e.g. AU-only Ezypay fee line items).
   */
  site?: Maybe<InvoiceSite>
  siteId: ScalarsEnums['String']
  source: ScalarsEnums['InvoiceSource']
  staffUserId?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['InvoiceStatus']
  totalAmount: ScalarsEnums['Numeric']
  totalValue: ScalarsEnums['Numeric']
  updatedAt: ScalarsEnums['String']
  usedByEquipmentAssignmentId?: Maybe<ScalarsEnums['ID']>
}

/**
 * Signing links minted (without email) for the agreement-required items of a draft invoice.
 */
export interface InvoiceAgreementSigningLinksResult {
  __typename?: 'InvoiceAgreementSigningLinksResult'
  errors: Array<ScalarsEnums['String']>
  success: ScalarsEnums['Boolean']
  urls: Array<ScalarsEnums['String']>
}

/**
 * Failure information for an invoice derived from payment transactions
 */
export interface InvoiceFailureInfo {
  __typename?: 'InvoiceFailureInfo'
  attemptCount: ScalarsEnums['Float']
  failureCategory?: Maybe<ScalarsEnums['FailureCategory']>
  fallbackCardBrand?: Maybe<ScalarsEnums['String']>
  fallbackCardLast4?: Maybe<ScalarsEnums['String']>
  fallbackReason?: Maybe<ScalarsEnums['PaymentFallbackReason']>
  fallbackState?: Maybe<ScalarsEnums['PaymentFallbackState']>
  lastFailedAt?: Maybe<ScalarsEnums['String']>
  nextAttemptDate?: Maybe<ScalarsEnums['String']>
  rawErrorCode?: Maybe<ScalarsEnums['String']>
  rawErrorMessage?: Maybe<ScalarsEnums['String']>
}

/**
 * Metadata for invoice items (fees, etc.) - all fields are optional
 */
export interface InvoiceItemMetadata {
  __typename?: 'InvoiceItemMetadata'
  actionType?: Maybe<ScalarsEnums['String']>
  appliedRules?: Maybe<InvoiceItemMetadataAppliedRules>
  attemptSequence?: Maybe<ScalarsEnums['Float']>
  bookingId?: Maybe<ScalarsEnums['String']>
  feeAmount?: Maybe<ScalarsEnums['String']>
  feeDate?: Maybe<ScalarsEnums['String']>
  feePercentage?: Maybe<ScalarsEnums['String']>
  feeRound?: Maybe<ScalarsEnums['Float']>
  isSecondaryFee?: Maybe<ScalarsEnums['Boolean']>
  itemType?: Maybe<ScalarsEnums['String']>
  lateCancelFeeId?: Maybe<ScalarsEnums['String']>
  lateCancelFeeName?: Maybe<ScalarsEnums['String']>
  noShowFeeId?: Maybe<ScalarsEnums['String']>
  noShowFeeName?: Maybe<ScalarsEnums['String']>
  paymentGatewayTransactionId?: Maybe<ScalarsEnums['String']>
  paymentId?: Maybe<ScalarsEnums['String']>
  paymentMethodType?: Maybe<ScalarsEnums['String']>
  recurringInvoiceId?: Maybe<ScalarsEnums['String']>
  recurringInvoiceName?: Maybe<ScalarsEnums['String']>
  rules?: Maybe<Array<ScalarsEnums['String']>>
  sequenceNumber?: Maybe<ScalarsEnums['Float']>
  serviceCancellationId?: Maybe<ScalarsEnums['String']>
  serviceId?: Maybe<ScalarsEnums['String']>
  serviceSuspensionId?: Maybe<ScalarsEnums['String']>
  serviceTemplateName?: Maybe<ScalarsEnums['String']>
  sessionDate?: Maybe<ScalarsEnums['String']>
  sessionId?: Maybe<ScalarsEnums['String']>
  sessionName?: Maybe<ScalarsEnums['String']>
  sessionTime?: Maybe<ScalarsEnums['String']>
  sessionTypeId?: Maybe<ScalarsEnums['String']>
  sessionTypeName?: Maybe<ScalarsEnums['String']>
  siteId?: Maybe<ScalarsEnums['String']>
  withdrawnAt?: Maybe<ScalarsEnums['String']>
}

export interface InvoiceItemMetadataAppliedRules {
  __typename?: 'InvoiceItemMetadataAppliedRules'
  all_attempts?: Maybe<ScalarsEnums['String']>
  first_attempt?: Maybe<ScalarsEnums['String']>
  second_attempt?: Maybe<ScalarsEnums['String']>
  third_attempt?: Maybe<ScalarsEnums['String']>
}

export interface InvoiceItems {
  __typename?: 'InvoiceItems'
  amount: ScalarsEnums['Numeric']
  autoRenewServiceTemplateName?: Maybe<ScalarsEnums['String']>
  beneficiaryClientId?: Maybe<ScalarsEnums['ID']>
  beneficiaryNote?: Maybe<ScalarsEnums['String']>
  billableItemId?: Maybe<ScalarsEnums['ID']>
  bookingId?: Maybe<ScalarsEnums['ID']>
  createdAt: ScalarsEnums['String']
  deletedAt?: Maybe<ScalarsEnums['String']>
  description: ScalarsEnums['String']
  discountAmount: ScalarsEnums['Numeric']
  discountReason?: Maybe<ScalarsEnums['String']>
  discountType?: Maybe<ScalarsEnums['DiscountType']>
  discountValue?: Maybe<ScalarsEnums['Numeric']>
  earlyAccess?: Maybe<EarlyAccessTimeline>
  exclusiveTaxAmount: ScalarsEnums['Numeric']
  giftCardCode?: Maybe<ScalarsEnums['String']>
  giftCardId?: Maybe<ScalarsEnums['ID']>
  giftCardTemplateId?: Maybe<ScalarsEnums['ID']>
  inclusiveTaxAmount: ScalarsEnums['Numeric']
  invoiceId: ScalarsEnums['ID']
  invoiceItemId: ScalarsEnums['ID']
  isAddOn: ScalarsEnums['Boolean']
  itemDetails?: Maybe<InvoiceItemsItemDetails>
  itemType: ScalarsEnums['InvoiceItemType']
  metadata?: Maybe<InvoiceItemMetadata>
  paymentId?: Maybe<ScalarsEnums['ID']>
  preTaxAmount: ScalarsEnums['Numeric']
  productId?: Maybe<ScalarsEnums['ID']>
  productTemplateId?: Maybe<ScalarsEnums['ID']>
  promoCode?: Maybe<ScalarsEnums['String']>
  promoCodeId?: Maybe<ScalarsEnums['ID']>
  quantity: ScalarsEnums['Float']
  referredByStaffUserId?: Maybe<ScalarsEnums['ID']>
  revenueTagGlCode?: Maybe<ScalarsEnums['String']>
  revenueTagId?: Maybe<ScalarsEnums['ID']>
  revenueTagName?: Maybe<ScalarsEnums['String']>
  serviceAutoRenew?: Maybe<ScalarsEnums['Boolean']>
  serviceId?: Maybe<ScalarsEnums['ID']>
  serviceTemplateId?: Maybe<ScalarsEnums['ID']>
  sessionId?: Maybe<ScalarsEnums['ID']>
  siteId: ScalarsEnums['ID']
  taxCalculations: Array<InvoiceItemsTaxCalculations>
  totalValue: ScalarsEnums['Numeric']
  unitPrice: ScalarsEnums['Numeric']
  updatedAt: ScalarsEnums['String']
}

export interface InvoiceItemsItemDetails {
  __typename?: 'InvoiceItemsItemDetails'
  addOnJoinsInvoiceId?: Maybe<ScalarsEnums['ID']>
  addOnParentServiceId?: Maybe<ScalarsEnums['ID']>
  addOnParentServiceTemplateId?: Maybe<ScalarsEnums['ID']>
  addOnPaymentType?: Maybe<ScalarsEnums['ServiceTemplateAddOnPaymentType']>
  addOnRecurringAmount?: Maybe<ScalarsEnums['String']>
  addOnTaxEnabled?: Maybe<ScalarsEnums['Boolean']>
  addOnTaxSettingIds?: Maybe<Array<ScalarsEnums['String']>>
  chargeSetupFeeUpFront?: Maybe<ScalarsEnums['Boolean']>
  creditValidUntilDate?: Maybe<ScalarsEnums['String']>
  creditValidUntilSetByStaff?: Maybe<ScalarsEnums['Boolean']>
  deferredForInvoiceItemId?: Maybe<ScalarsEnums['ID']>
  discountAppliesToAllPayments?: Maybe<ScalarsEnums['Boolean']>
  earlyAccessEndDate?: Maybe<ScalarsEnums['String']>
  earlyAccessStartDate?: Maybe<ScalarsEnums['String']>
  enableAutoRenew?: Maybe<ScalarsEnums['Boolean']>
  giftCardCustomId?: Maybe<ScalarsEnums['ID']>
  giftCardDeliveryDate?: Maybe<ScalarsEnums['String']>
  giftCardDesignId?: Maybe<ScalarsEnums['ID']>
  giftCardExpiryDate?: Maybe<ScalarsEnums['String']>
  giftCardExpiryMode?: Maybe<ScalarsEnums['GiftCardExpiryMode']>
  giftCardPersonalMessage?: Maybe<ScalarsEnums['String']>
  giftCardPurchaserEmail?: Maybe<ScalarsEnums['String']>
  giftCardPurchaserName?: Maybe<ScalarsEnums['String']>
  giftCardRecipientEmail?: Maybe<ScalarsEnums['String']>
  giftCardRecipientFullName?: Maybe<ScalarsEnums['String']>
  giftCardRecipientName?: Maybe<ScalarsEnums['String']>
  giftCardSendToRecipient?: Maybe<ScalarsEnums['Boolean']>
  giftCardValue?: Maybe<ScalarsEnums['String']>
  oneTimeSetupFee?: Maybe<ScalarsEnums['String']>
  paidInFullCycles?: Maybe<ScalarsEnums['Float']>
  payUpFront?: Maybe<ScalarsEnums['Boolean']>
  proratedAmount?: Maybe<ScalarsEnums['String']>
  proratedCredits?: Maybe<ScalarsEnums['Float']>
  prorationEndDate?: Maybe<ScalarsEnums['String']>
  prorationStartDate?: Maybe<ScalarsEnums['String']>
  serviceFirstBillingDate?: Maybe<ScalarsEnums['String']>
  serviceStartDate?: Maybe<ScalarsEnums['String']>
  serviceTemplateAddOnId?: Maybe<ScalarsEnums['ID']>
  signedClientAgreementId?: Maybe<ScalarsEnums['ID']>
  signedClientAgreementIds?: Maybe<Array<ScalarsEnums['ID']>>
  totalCredits?: Maybe<ScalarsEnums['Float']>
}

export interface InvoiceItemsTaxCalculations {
  __typename?: 'InvoiceItemsTaxCalculations'
  amount: ScalarsEnums['Numeric']
  taxSetting: InvoiceItemsTaxCalculationsTaxSetting
}

export interface InvoiceItemsTaxCalculationsTaxSetting {
  __typename?: 'InvoiceItemsTaxCalculationsTaxSetting'
  amount: ScalarsEnums['Numeric']
  name: ScalarsEnums['String']
  taxSettingId: ScalarsEnums['String']
  type: ScalarsEnums['TaxSettingType']
}

/**
 * Net revenue (paid − completed refunds) for a single UTC calendar day
 */
export interface InvoiceRevenueDailyPoint {
  __typename?: 'InvoiceRevenueDailyPoint'
  amount: ScalarsEnums['Float']
  date: ScalarsEnums['String']
}

/**
 * Aggregate net revenue (successful payments, amount − tax) for the trailing 30-day window plus the prior window, bucketed by site-local day to match the Net Revenue report; refunds are reported separately, not netted. Includes a daily series for the graph
 */
export interface InvoiceRevenueSummary {
  __typename?: 'InvoiceRevenueSummary'
  graph: Array<InvoiceRevenueDailyPoint>
  netRevenueCurrent: ScalarsEnums['Float']
  netRevenuePrevious: ScalarsEnums['Float']
  /**
   * Gross successful-payment total (Payment.amount, tax-inclusive) for the current window
   */
  paidTotalCurrent: ScalarsEnums['Float']
  /**
   * Completed-refund total for the current window; reported separately, not netted into net revenue
   */
  refundTotalCurrent: ScalarsEnums['Float']
  windowDays: ScalarsEnums['Float']
}

/**
 * An invoice row (base schema)
 */
export interface InvoiceRow {
  __typename?: 'InvoiceRow'
  addonConfigId?: Maybe<ScalarsEnums['ID']>
  amountDue: ScalarsEnums['Numeric']
  /**
   * Beneficiary client who receives the service/product (when different from payer/clientId)
   */
  beneficiary?: Maybe<Client>
  beneficiaryId?: Maybe<ScalarsEnums['ID']>
  cancellationSource?: Maybe<ScalarsEnums['InvoiceCancellationSource']>
  cancelledAt?: Maybe<ScalarsEnums['String']>
  cancelledByStaffUserId?: Maybe<ScalarsEnums['String']>
  /**
   * Client associated with this invoice (payer)
   */
  client?: Maybe<Client>
  clientId?: Maybe<ScalarsEnums['ID']>
  clientName?: Maybe<ScalarsEnums['String']>
  createdAt: ScalarsEnums['String']
  createdByRecurringInvoiceId?: Maybe<ScalarsEnums['ID']>
  currency: ScalarsEnums['Currency']
  customPaymentMethodLabel?: Maybe<ScalarsEnums['String']>
  description?: Maybe<ScalarsEnums['String']>
  dueDate: ScalarsEnums['String']
  /**
   * Estimated failed-payment fee the gateway will charge the member for this failed invoice, from the gateway's fee schedule. Null when the gateway levies none or the invoice is not failed.
   */
  estimatedGatewayFailedPaymentFee?: Maybe<ScalarsEnums['Numeric']>
  exclusiveTaxTotal: ScalarsEnums['Numeric']
  /**
   * Failure information from the latest failed payment transaction
   */
  failureInfo?: Maybe<InvoiceFailureInfo>
  fullyPaidDate?: Maybe<ScalarsEnums['String']>
  giftCardCode?: Maybe<ScalarsEnums['String']>
  giftCardId?: Maybe<ScalarsEnums['String']>
  giftCardName?: Maybe<ScalarsEnums['String']>
  hasDisputeLoss: ScalarsEnums['Boolean']
  hasRefundFailed: ScalarsEnums['Boolean']
  hasRequiredClientAction: ScalarsEnums['Boolean']
  inclusiveTaxTotal: ScalarsEnums['Numeric']
  invoiceId: ScalarsEnums['ID']
  invoiceTypes: Array<ScalarsEnums['InvoiceType']>
  /**
   * Whether this invoice has been through a failure path (has failed/failed_retry status history or failed automated payments).
   */
  isFailurePath: ScalarsEnums['Boolean']
  isImported: ScalarsEnums['Boolean']
  /**
   * Whether this invoice was created from a recurring invoice
   */
  isRecurring: ScalarsEnums['Boolean']
  itemDiscountTotal: ScalarsEnums['Numeric']
  /**
   * Invoice line items with live service auto-renew status
   */
  items: Array<InvoiceItems>
  membershipName?: Maybe<ScalarsEnums['String']>
  paymentMethodTypes?: Maybe<Array<ScalarsEnums['PaymentMethodType']>>
  /**
   * Payments associated with this invoice
   */
  payments: Array<Payment>
  /**
   * What a draft (staged) invoice is still waiting on: agreement signature, payment, or both. Null for every other status.
   */
  pendingReason?: Maybe<ScalarsEnums['InvoicePendingReason']>
  processedAt?: Maybe<ScalarsEnums['String']>
  productName?: Maybe<ScalarsEnums['String']>
  /**
   * ID of the recurring invoice that created this invoice (if applicable)
   */
  recurringInvoiceId?: Maybe<ScalarsEnums['ID']>
  recurringInvoiceSequence?: Maybe<ScalarsEnums['Float']>
  /**
   * Service ID for this recurring invoice (if applicable)
   */
  recurringServiceId?: Maybe<ScalarsEnums['ID']>
  redeemedAt?: Maybe<ScalarsEnums['String']>
  redeemedAtSiteId?: Maybe<ScalarsEnums['String']>
  redeemedAtSiteName?: Maybe<ScalarsEnums['String']>
  /**
   * Refunds associated with this invoice
   */
  refunds: Array<Refund>
  reinstatedAt?: Maybe<ScalarsEnums['String']>
  reinstatedByStaffUserId?: Maybe<ScalarsEnums['String']>
  saleDate: ScalarsEnums['String']
  saleId: ScalarsEnums['String']
  scheduledClientPaymentMethodId?: Maybe<ScalarsEnums['ID']>
  scheduledProcessingAt?: Maybe<ScalarsEnums['String']>
  /**
   * Minimal site projection for the site that owns this invoice. Currently used by the UI to country-gate display (e.g. AU-only Ezypay fee line items).
   */
  site?: Maybe<InvoiceSite>
  siteId: ScalarsEnums['String']
  source: ScalarsEnums['InvoiceSource']
  staffUserId?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['InvoiceStatus']
  totalAmount: ScalarsEnums['Numeric']
  totalValue: ScalarsEnums['Numeric']
  updatedAt: ScalarsEnums['String']
  usedByEquipmentAssignmentId?: Maybe<ScalarsEnums['ID']>
}

/**
 * Minimal site projection exposed on an invoice (for country-aware UI gating)
 */
export interface InvoiceSite {
  __typename?: 'InvoiceSite'
  countryCode?: Maybe<ScalarsEnums['String']>
}

export interface Invoices {
  __typename?: 'Invoices'
  pageInfo: InvoicesPageInfo
  results: Array<InvoicesResults>
}

export interface InvoicesPageInfo {
  __typename?: 'InvoicesPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface InvoicesResults {
  __typename?: 'InvoicesResults'
  cursor: ScalarsEnums['String']
  row: InvoiceRow
}

export interface IosUsageDescriptionState {
  __typename?: 'IosUsageDescriptionState'
  key: ScalarsEnums['IosUsageDescriptionKey']
  locked: ScalarsEnums['Boolean']
  source: ScalarsEnums['NativePermissionSource']
  text: ScalarsEnums['String']
}

export interface IsClientAtSite {
  __typename?: 'IsClientAtSite'
  isAtSite: ScalarsEnums['Boolean']
}

/**
 * An inclusive age range and what the rule requires for it
 */
export interface JurisdictionAgeBand {
  __typename?: 'JurisdictionAgeBand'
  maxAge?: Maybe<ScalarsEnums['Float']>
  minAge: ScalarsEnums['Float']
  outcome: ScalarsEnums['AgeBandOutcome']
}

/**
 * Kiosk app configuration metadata
 */
export interface KioskAppMetadata {
  __typename?: 'KioskAppMetadata'
  corporateId: ScalarsEnums['String']
  id: ScalarsEnums['String']
  lastUpdated: ScalarsEnums['String']
  version: ScalarsEnums['String']
}

export interface KioskBooking {
  __typename?: 'KioskBooking'
  bookingId: ScalarsEnums['String']
  bookingSource?: Maybe<ScalarsEnums['String']>
  clientId: ScalarsEnums['String']
  clientName?: Maybe<ScalarsEnums['String']>
  paymentStatus?: Maybe<ScalarsEnums['String']>
  spotId?: Maybe<ScalarsEnums['Float']>
  status: ScalarsEnums['String']
}

/**
 * Kiosk branding configuration (non-image settings)
 */
export interface KioskBranding {
  __typename?: 'KioskBranding'
  primaryColor?: Maybe<ScalarsEnums['String']>
  secondaryColor?: Maybe<ScalarsEnums['String']>
}

export interface KioskClientPolicy {
  __typename?: 'KioskClientPolicy'
  clientId: ScalarsEnums['String']
  hasPending: ScalarsEnums['Boolean']
}

/**
 * Corporate-level default settings for kiosk devices across all locations
 */
export interface KioskDefaults {
  __typename?: 'KioskDefaults'
  /**
   * Enable general facility check-in
   */
  checkIn: ScalarsEnums['Boolean']
  /**
   * Enable class check-in functionality
   */
  classCheckIn: ScalarsEnums['Boolean']
  /**
   * Display waivers, agreements, and other forms
   */
  forms: ScalarsEnums['Boolean']
  /**
   * Display intro offers for new members
   */
  introOffers: ScalarsEnums['Boolean']
  /**
   * Allow members to update profile and account settings
   */
  manageAccount: ScalarsEnums['Boolean']
  /**
   * Allow purchasing packages and memberships
   */
  packages: ScalarsEnums['Boolean']
}

/**
 * Resolved public URLs for kiosk images
 */
export interface KioskImageUrls {
  __typename?: 'KioskImageUrls'
  backgroundImageUrl?: Maybe<ScalarsEnums['String']>
  logoUrl?: Maybe<ScalarsEnums['String']>
}

export interface KioskInstructor {
  __typename?: 'KioskInstructor'
  firstName: ScalarsEnums['String']
  lastName: ScalarsEnums['String']
  staffUserId: ScalarsEnums['String']
}

export interface KioskPinStatus {
  __typename?: 'KioskPinStatus'
  hasPinSet: ScalarsEnums['Boolean']
  pinSetAt?: Maybe<ScalarsEnums['String']>
  sessionValidityDays: ScalarsEnums['Float']
}

export interface KioskResourceTemplate {
  __typename?: 'KioskResourceTemplate'
  imageUrl: ScalarsEnums['String']
  name: ScalarsEnums['String']
  roomResourceTemplateId: ScalarsEnums['String']
  spotHeight: ScalarsEnums['Float']
  spotWidth: ScalarsEnums['Float']
  spots: Array<KioskSpot>
}

export interface KioskRoom {
  __typename?: 'KioskRoom'
  hasResourceBooking: ScalarsEnums['Boolean']
  name?: Maybe<ScalarsEnums['String']>
  roomResourceTemplateId?: Maybe<ScalarsEnums['String']>
}

export interface KioskSession {
  __typename?: 'KioskSession'
  bookedCount?: Maybe<ScalarsEnums['Float']>
  disabledSpotIds: Array<ScalarsEnums['Float']>
  endTime: ScalarsEnums['String']
  name: ScalarsEnums['String']
  sessionId: ScalarsEnums['String']
  size?: Maybe<ScalarsEnums['Float']>
  startTime: ScalarsEnums['String']
  status: ScalarsEnums['String']
}

export interface KioskSessionBookings {
  __typename?: 'KioskSessionBookings'
  bookings: Array<KioskBooking>
  clientPolicies: Array<KioskClientPolicy>
  instructor?: Maybe<KioskInstructor>
  resourceTemplate?: Maybe<KioskResourceTemplate>
  room?: Maybe<KioskRoom>
  session: KioskSession
}

/**
 * Response for kiosk setup API operations
 */
export interface KioskSetupResponse {
  __typename?: 'KioskSetupResponse'
  data?: Maybe<KioskSetupResponseData>
  message: ScalarsEnums['String']
  success: ScalarsEnums['Boolean']
}

export interface KioskSetupResponseData {
  __typename?: 'KioskSetupResponseData'
  appConfig: KioskAppMetadata
  branding?: Maybe<KioskBranding>
  images?: Maybe<KioskImageUrls>
}

export interface KioskSpot {
  __typename?: 'KioskSpot'
  enabled: ScalarsEnums['Boolean']
  name: ScalarsEnums['String']
  x: ScalarsEnums['Float']
  y: ScalarsEnums['Float']
}

export interface KnowledgeArticle {
  __typename?: 'KnowledgeArticle'
  category?: Maybe<ScalarsEnums['String']>
  contentMarkdown: ScalarsEnums['String']
  coverImagePosition?: Maybe<CoverImagePosition>
  coverImageUrl?: Maybe<ScalarsEnums['String']>
  createdAt: ScalarsEnums['String']
  createdBy: ScalarsEnums['String']
  deletedAt?: Maybe<ScalarsEnums['String']>
  knowledgeArticleId: ScalarsEnums['ID']
  metaDescription?: Maybe<ScalarsEnums['String']>
  metaTitle?: Maybe<ScalarsEnums['String']>
  permissionTags?: Maybe<Array<ScalarsEnums['String']>>
  publishedAt?: Maybe<ScalarsEnums['String']>
  roleTags?: Maybe<Array<ScalarsEnums['String']>>
  slug: ScalarsEnums['String']
  status: ScalarsEnums['KnowledgeArticleStatus']
  subtitle?: Maybe<ScalarsEnums['String']>
  summary?: Maybe<ScalarsEnums['String']>
  tags?: Maybe<Array<ScalarsEnums['String']>>
  tierTags?: Maybe<Array<ScalarsEnums['String']>>
  title: ScalarsEnums['String']
  translations?: Maybe<Array<KnowledgeArticleTranslation>>
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['String']>
  version: ScalarsEnums['Int']
}

export interface KnowledgeArticleCategory {
  __typename?: 'KnowledgeArticleCategory'
  articleCount?: Maybe<ScalarsEnums['Int']>
  color?: Maybe<ScalarsEnums['String']>
  createdAt: ScalarsEnums['String']
  createdBy: ScalarsEnums['String']
  deletedAt?: Maybe<ScalarsEnums['String']>
  draftCount?: Maybe<ScalarsEnums['Int']>
  icon?: Maybe<ScalarsEnums['String']>
  knowledgeArticleCategoryId: ScalarsEnums['ID']
  name: ScalarsEnums['String']
  slug: ScalarsEnums['String']
  sortOrder: ScalarsEnums['Int']
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['String']>
}

export interface KnowledgeArticleRevision {
  __typename?: 'KnowledgeArticleRevision'
  aiChangeSummary?: Maybe<ScalarsEnums['String']>
  baseVersion?: Maybe<ScalarsEnums['Int']>
  changeType: ScalarsEnums['RevisionChangeType']
  confidence?: Maybe<ScalarsEnums['Float']>
  createdAt: ScalarsEnums['String']
  createdBy: ScalarsEnums['String']
  knowledgeArticleId?: Maybe<ScalarsEnums['ID']>
  proposedCategory?: Maybe<ScalarsEnums['String']>
  proposedContentMarkdown: ScalarsEnums['String']
  proposedRoleTags?: Maybe<Array<ScalarsEnums['String']>>
  proposedSlug?: Maybe<ScalarsEnums['String']>
  proposedSubtitle?: Maybe<ScalarsEnums['String']>
  proposedSummary?: Maybe<ScalarsEnums['String']>
  proposedTags?: Maybe<Array<ScalarsEnums['String']>>
  proposedTierTags?: Maybe<Array<ScalarsEnums['String']>>
  proposedTitle: ScalarsEnums['String']
  reviewNotes?: Maybe<ScalarsEnums['String']>
  reviewState: ScalarsEnums['RevisionReviewState']
  reviewedAt?: Maybe<ScalarsEnums['String']>
  reviewedBy?: Maybe<ScalarsEnums['String']>
  revisionId: ScalarsEnums['ID']
  sourceBranch?: Maybe<ScalarsEnums['String']>
  sourceCommitSha?: Maybe<ScalarsEnums['String']>
  sourceFiles?: Maybe<Array<ScalarsEnums['String']>>
  sourceLinearIssueId?: Maybe<ScalarsEnums['String']>
  sourceLinearIssueUrl?: Maybe<ScalarsEnums['String']>
  updatedAt: ScalarsEnums['String']
}

export interface KnowledgeArticleRevisionsResponse {
  __typename?: 'KnowledgeArticleRevisionsResponse'
  revisions: Array<KnowledgeArticleRevision>
  total: ScalarsEnums['Int']
}

export interface KnowledgeArticleStats {
  __typename?: 'KnowledgeArticleStats'
  byStatus: ScalarsEnums['JSON']
  total: ScalarsEnums['Int']
}

export interface KnowledgeArticleTranslation {
  __typename?: 'KnowledgeArticleTranslation'
  contentMarkdown: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  knowledgeArticleId: ScalarsEnums['String']
  locale: ScalarsEnums['String']
  metaDescription?: Maybe<ScalarsEnums['String']>
  metaTitle?: Maybe<ScalarsEnums['String']>
  needsRetranslation: ScalarsEnums['Boolean']
  reviewedAt?: Maybe<ScalarsEnums['String']>
  reviewedBy?: Maybe<ScalarsEnums['String']>
  sourceVersion: ScalarsEnums['Int']
  status: ScalarsEnums['TranslationStatus']
  subtitle?: Maybe<ScalarsEnums['String']>
  summary?: Maybe<ScalarsEnums['String']>
  title: ScalarsEnums['String']
  translatedAt?: Maybe<ScalarsEnums['String']>
  translationId: ScalarsEnums['ID']
  updatedAt: ScalarsEnums['String']
}

export interface KnowledgeArticlesByCategoryResponse {
  __typename?: 'KnowledgeArticlesByCategoryResponse'
  articles: Array<KnowledgeArticle>
  hasMore: ScalarsEnums['Boolean']
  totalCount: ScalarsEnums['Int']
}

export interface KnowledgeArticlesResponse {
  __typename?: 'KnowledgeArticlesResponse'
  articles: Array<KnowledgeArticle>
  total: ScalarsEnums['Int']
}

export interface KnowledgeDocument {
  __typename?: 'KnowledgeDocument'
  category: ScalarsEnums['String']
  content: ScalarsEnums['String']
  corporateId: ScalarsEnums['String']
  id: ScalarsEnums['ID']
  lastUpdated: ScalarsEnums['String']
  siteId?: Maybe<ScalarsEnums['String']>
  source: ScalarsEnums['String']
  tags: Array<ScalarsEnums['String']>
  title: ScalarsEnums['String']
}

export interface KnowledgeSearchResponse {
  __typename?: 'KnowledgeSearchResponse'
  query: ScalarsEnums['String']
  results: Array<SearchResult>
  suggestions: Array<ScalarsEnums['String']>
  total: ScalarsEnums['Int']
}

export interface LastAttendanceFeedback {
  __typename?: 'LastAttendanceFeedback'
  attendanceDate: ScalarsEnums['String']
  bookingId?: Maybe<ScalarsEnums['String']>
  bookingStatus?: Maybe<ScalarsEnums['String']>
  creditsRequired?: Maybe<ScalarsEnums['Float']>
  dropInPrice?: Maybe<ScalarsEnums['Float']>
  durationMinutes?: Maybe<ScalarsEnums['Float']>
  feedbackSubmitted: ScalarsEnums['Boolean']
  instructorName: ScalarsEnums['String']
  roomName?: Maybe<ScalarsEnums['String']>
  sessionDate: ScalarsEnums['String']
  sessionId: ScalarsEnums['String']
  sessionName: ScalarsEnums['String']
  siteId?: Maybe<ScalarsEnums['String']>
  siteIsDigital?: Maybe<ScalarsEnums['Boolean']>
  siteName?: Maybe<ScalarsEnums['String']>
  siteTimezone?: Maybe<ScalarsEnums['String']>
  startTime?: Maybe<ScalarsEnums['String']>
}

export interface LeaderboardAttendanceAggregation {
  __typename?: 'LeaderboardAttendanceAggregation'
  attendanceCount: ScalarsEnums['Float']
  clientId: ScalarsEnums['String']
  firstCheckInAt: ScalarsEnums['String']
}

/**
 * Admin-configured leaderboard definition
 */
export interface LeaderboardConfig {
  __typename?: 'LeaderboardConfig'
  autoRollover: ScalarsEnums['Boolean']
  config: ScalarsEnums['JSONObject']
  corporateId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  createdBy: ScalarsEnums['String']
  customEndDate?: Maybe<ScalarsEnums['String']>
  customStartDate?: Maybe<ScalarsEnums['String']>
  deletedAt?: Maybe<ScalarsEnums['String']>
  description?: Maybe<ScalarsEnums['String']>
  entryCount: ScalarsEnums['Float']
  imageUrl?: Maybe<ScalarsEnums['String']>
  lastMaterializedAt?: Maybe<ScalarsEnums['String']>
  leaderboardConfigId: ScalarsEnums['String']
  leaderboardType: ScalarsEnums['String']
  memberDisplayFormat: ScalarsEnums['String']
  minParticipants: ScalarsEnums['Float']
  name: ScalarsEnums['String']
  rankingDirection: ScalarsEnums['String']
  refreshFrequency: ScalarsEnums['String']
  scope: ScalarsEnums['String']
  scoreType: ScalarsEnums['String']
  siteIds?: Maybe<Array<ScalarsEnums['String']>>
  status: ScalarsEnums['String']
  timePeriodType: ScalarsEnums['String']
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['String']>
  visibility: ScalarsEnums['String']
}

/**
 * Paginated list of leaderboard configurations
 */
export interface LeaderboardConfigConnection {
  __typename?: 'LeaderboardConfigConnection'
  hasMore: ScalarsEnums['Boolean']
  results: Array<LeaderboardConfig>
  totalCount: ScalarsEnums['Float']
}

export interface LeaderboardDashboard {
  __typename?: 'LeaderboardDashboard'
  entryCount: ScalarsEnums['Float']
  lastMaterializedAt?: Maybe<ScalarsEnums['String']>
  leaderboardConfigId: ScalarsEnums['String']
  leaderboardType: ScalarsEnums['String']
  name: ScalarsEnums['String']
  snapshotTopScore?: Maybe<ScalarsEnums['Float']>
  snapshotTotalParticipants?: Maybe<ScalarsEnums['Float']>
  status: ScalarsEnums['String']
}

/**
 * Periodic snapshot of leaderboard rankings for historical comparison
 */
export interface LeaderboardSnapshot {
  __typename?: 'LeaderboardSnapshot'
  averageScore: ScalarsEnums['Float']
  corporateId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  droppedOut: ScalarsEnums['Float']
  leaderboardConfigId: ScalarsEnums['String']
  medianScore?: Maybe<ScalarsEnums['Float']>
  newEntrants: ScalarsEnums['Float']
  periodKey: ScalarsEnums['String']
  snapshotDate: ScalarsEnums['String']
  snapshotId: ScalarsEnums['String']
  topEntries: ScalarsEnums['JSONObject']
  topScore: ScalarsEnums['Float']
  totalParticipants: ScalarsEnums['Float']
}

/**
 * Summary of a single leaderboard
 */
export interface LeaderboardSummaryItem {
  __typename?: 'LeaderboardSummaryItem'
  entryCount: ScalarsEnums['Float']
  leaderboardConfigId: ScalarsEnums['String']
  leaderboardType: ScalarsEnums['String']
  name: ScalarsEnums['String']
  topClientName?: Maybe<ScalarsEnums['String']>
  topScore?: Maybe<ScalarsEnums['Float']>
}

/**
 * Non-secret Inception settings migrated from V1, used to prefill a new access point
 */
export interface LegacyInceptionConfig {
  __typename?: 'LegacyInceptionConfig'
  doorId?: Maybe<ScalarsEnums['String']>
  rootUrl?: Maybe<ScalarsEnums['String']>
  serialNumber?: Maybe<ScalarsEnums['String']>
  username?: Maybe<ScalarsEnums['String']>
}

/**
 * Response from linking a site to an HQ
 */
export interface LinkSiteToHqResponse {
  __typename?: 'LinkSiteToHqResponse'
  success: ScalarsEnums['Boolean']
}

export interface ListAllClients {
  __typename?: 'ListAllClients'
  pageInfo: ListAllClientsPageInfo
  results: Array<ListAllClientsResults>
}

export interface ListAllClientsPageInfo {
  __typename?: 'ListAllClientsPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface ListAllClientsResults {
  __typename?: 'ListAllClientsResults'
  cursor: ScalarsEnums['String']
  row: ClientAdmin
}

/**
 * Paginated result for all scheduled invoices (materialized and virtual)
 */
export interface ListAllScheduledInvoicesResult {
  __typename?: 'ListAllScheduledInvoicesResult'
  pageInfo: ScheduledInvoicesPageInfo
  results: Array<Invoice>
}

/**
 * Paginated staff-cancelled invoices
 */
export interface ListCancelledInvoicesResult {
  __typename?: 'ListCancelledInvoicesResult'
  earliestReinstateDate: ScalarsEnums['String']
  pageInfo: ScheduledInvoicesPageInfo
  results: Array<CancelledInvoiceRow>
}

export interface ListGcsBundlePrefixes {
  __typename?: 'ListGcsBundlePrefixes'
  bucket: ScalarsEnums['String']
  folders: Array<ListGcsBundlePrefixesFolders>
  prefix: ScalarsEnums['String']
  truncated: ScalarsEnums['Boolean']
  zipCount: ScalarsEnums['Float']
}

export interface ListGcsBundlePrefixesFolders {
  __typename?: 'ListGcsBundlePrefixesFolders'
  gcsPrefix: ScalarsEnums['String']
  name: ScalarsEnums['String']
  prefix: ScalarsEnums['String']
}

export interface ListGcsBundleZips {
  __typename?: 'ListGcsBundleZips'
  bucket: ScalarsEnums['String']
  prefix: ScalarsEnums['String']
  truncated: ScalarsEnums['Boolean']
  zips: Array<ListGcsBundleZipsZips>
}

export interface ListGcsBundleZipsZips {
  __typename?: 'ListGcsBundleZipsZips'
  gcsUrl: ScalarsEnums['String']
  name: ScalarsEnums['String']
  objectPath: ScalarsEnums['String']
  sizeBytes: ScalarsEnums['Float']
}

export interface ListPastInvoicesByService {
  __typename?: 'ListPastInvoicesByService'
  pageInfo: ListPastInvoicesByServicePageInfo
  results: Array<ListPastInvoicesByServiceResults>
}

export interface ListPastInvoicesByServicePageInfo {
  __typename?: 'ListPastInvoicesByServicePageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface ListPastInvoicesByServiceResults {
  __typename?: 'ListPastInvoicesByServiceResults'
  cursor: ScalarsEnums['String']
  row: InvoiceRow
}

/**
 * Paginated result for scheduled/future recurring invoices
 */
export interface ListScheduledInvoicesByServiceResult {
  __typename?: 'ListScheduledInvoicesByServiceResult'
  pageInfo: ListScheduledInvoicesByServiceResultPageInfo
  results: Array<VirtualInvoice>
}

export interface ListScheduledInvoicesByServiceResultPageInfo {
  __typename?: 'ListScheduledInvoicesByServiceResultPageInfo'
  currentPage: ScalarsEnums['Float']
  hasNextPage: ScalarsEnums['Boolean']
  hasPreviousPage: ScalarsEnums['Boolean']
  pageSize: ScalarsEnums['Float']
  totalPages: ScalarsEnums['Float']
  totalRecords: ScalarsEnums['Float']
}

export interface LocationOperationsCounts {
  __typename?: 'LocationOperationsCounts'
  availableClientsTabsCount: ScalarsEnums['Float']
  blockingReasonsCount: ScalarsEnums['Float']
  cancellationReasonsCount: ScalarsEnums['Float']
  customPropertiesCount: ScalarsEnums['Float']
  leadSourcesCount: ScalarsEnums['Float']
  policiesCount: ScalarsEnums['Float']
  questionnaireFormsCount: ScalarsEnums['Float']
  refundReasonsCount: ScalarsEnums['Float']
  sessionFeedbackQuestionsCount: ScalarsEnums['Float']
  siteId: ScalarsEnums['String']
  suspensionReasonsCount: ScalarsEnums['Float']
  tabsDisplayedCount: ScalarsEnums['Float']
}

export interface MediaFolder {
  __typename?: 'MediaFolder'
  assetCount: ScalarsEnums['Float']
  children: Array<MediaFolderChild>
  name: ScalarsEnums['String']
  path: ScalarsEnums['String']
}

export interface MediaFolderChild {
  __typename?: 'MediaFolderChild'
  assetCount: ScalarsEnums['Float']
  name: ScalarsEnums['String']
  path: ScalarsEnums['String']
}

export interface MediaUsageItem {
  __typename?: 'MediaUsageItem'
  contentEntryId: ScalarsEnums['String']
  contentTypeSlug: ScalarsEnums['String']
  role: ScalarsEnums['String']
  status: ScalarsEnums['String']
  title: ScalarsEnums['String']
}

/**
 * A single Member API request/response audit record (PII-masked).
 */
export interface MemberApiAuditLog {
  __typename?: 'MemberApiAuditLog'
  createdAt: ScalarsEnums['String']
  errorCode?: Maybe<ScalarsEnums['String']>
  latencyMs: ScalarsEnums['Float']
  memberId?: Maybe<ScalarsEnums['String']>
  method: ScalarsEnums['String']
  path: ScalarsEnums['String']
  queryParams?: Maybe<ScalarsEnums['String']>
  remoteIp?: Maybe<ScalarsEnums['String']>
  requestBody?: Maybe<ScalarsEnums['String']>
  requestId: ScalarsEnums['String']
  responseBody?: Maybe<ScalarsEnums['String']>
  siteId?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['Float']
  userAgent?: Maybe<ScalarsEnums['String']>
}

export interface MemberExperienceBranding {
  __typename?: 'MemberExperienceBranding'
  appName?: Maybe<ScalarsEnums['String']>
  backgroundColor: ScalarsEnums['String']
  corporateId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  createdBy?: Maybe<ScalarsEnums['String']>
  darkBackgroundColor?: Maybe<ScalarsEnums['String']>
  darkPrimaryColor?: Maybe<ScalarsEnums['String']>
  darkPrimaryTextColor?: Maybe<ScalarsEnums['String']>
  darkSecondaryBackgroundColor?: Maybe<ScalarsEnums['String']>
  darkSecondaryColor?: Maybe<ScalarsEnums['String']>
  darkSecondaryTextColor?: Maybe<ScalarsEnums['String']>
  faviconUrl?: Maybe<ScalarsEnums['String']>
  logoUrl?: Maybe<ScalarsEnums['String']>
  primaryColor: ScalarsEnums['String']
  primaryTextColor: ScalarsEnums['String']
  secondaryBackgroundColor?: Maybe<ScalarsEnums['String']>
  secondaryColor: ScalarsEnums['String']
  secondaryTextColor: ScalarsEnums['String']
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['String']>
  version: ScalarsEnums['Float']
}

export interface MemberExperienceFonts {
  __typename?: 'MemberExperienceFonts'
  corporateId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  createdBy?: Maybe<ScalarsEnums['String']>
  customFonts: Array<MemberExperienceFontsCustomFonts>
  customHeadingFonts: Array<MemberExperienceFontsCustomFonts>
  fontFamily: ScalarsEnums['String']
  fontScale: ScalarsEnums['Float']
  fontSource: ScalarsEnums['FontSource']
  fontUrl?: Maybe<ScalarsEnums['String']>
  headingFontFamily?: Maybe<ScalarsEnums['String']>
  headingFontSource?: Maybe<ScalarsEnums['HeadingFontSource']>
  headingFontUrl?: Maybe<ScalarsEnums['String']>
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['String']>
  useCustomHeadingFont: ScalarsEnums['Boolean']
  version: ScalarsEnums['Float']
}

export interface MemberExperienceFontsCustomFonts {
  __typename?: 'MemberExperienceFontsCustomFonts'
  displayName?: Maybe<ScalarsEnums['String']>
  format: ScalarsEnums['FontFormat']
  name: ScalarsEnums['String']
  uploadedAt: ScalarsEnums['String']
  uploadedBy?: Maybe<ScalarsEnums['String']>
  url: ScalarsEnums['String']
}

export interface MemberExperienceRuntime {
  __typename?: 'MemberExperienceRuntime'
  colours: MemberExperienceRuntimeColours
  customText: ScalarsEnums['JSONObject']
  customTextOverrides: ScalarsEnums['JSONObject']
  fonts: MemberExperienceRuntimeFonts
  images: MemberExperienceRuntimeImages
  language: ScalarsEnums['String']
  settings: MemberExperienceRuntimeSettings
  source: ScalarsEnums['String']
  surface: ScalarsEnums['MemberExperienceSurface']
}

export interface MemberExperienceRuntimeColours {
  __typename?: 'MemberExperienceRuntimeColours'
  configured: ScalarsEnums['Boolean']
  dark?: Maybe<MemberExperienceRuntimeColoursDark>
  light: MemberExperienceRuntimeColoursLight
}

export interface MemberExperienceRuntimeColoursDark {
  __typename?: 'MemberExperienceRuntimeColoursDark'
  backgroundColor?: Maybe<ScalarsEnums['String']>
  primaryColor?: Maybe<ScalarsEnums['String']>
  primaryTextColor?: Maybe<ScalarsEnums['String']>
  secondaryBackgroundColor?: Maybe<ScalarsEnums['String']>
  secondaryColor?: Maybe<ScalarsEnums['String']>
  secondaryTextColor?: Maybe<ScalarsEnums['String']>
}

export interface MemberExperienceRuntimeColoursLight {
  __typename?: 'MemberExperienceRuntimeColoursLight'
  backgroundColor: ScalarsEnums['String']
  primaryColor: ScalarsEnums['String']
  primaryTextColor: ScalarsEnums['String']
  secondaryBackgroundColor?: Maybe<ScalarsEnums['String']>
  secondaryColor: ScalarsEnums['String']
  secondaryTextColor: ScalarsEnums['String']
}

export interface MemberExperienceRuntimeFonts {
  __typename?: 'MemberExperienceRuntimeFonts'
  configured: ScalarsEnums['Boolean']
  fontFamily: ScalarsEnums['String']
  fontScale: ScalarsEnums['Float']
  fontSource: ScalarsEnums['FontSource']
  fontUrl?: Maybe<ScalarsEnums['String']>
}

export interface MemberExperienceRuntimeImages {
  __typename?: 'MemberExperienceRuntimeImages'
  appName?: Maybe<ScalarsEnums['String']>
  faviconUrl?: Maybe<ScalarsEnums['String']>
  loginImageUrl?: Maybe<ScalarsEnums['String']>
  logoUrl?: Maybe<ScalarsEnums['String']>
}

export interface MemberExperienceRuntimeSettings {
  __typename?: 'MemberExperienceRuntimeSettings'
  awardsEnabled?: Maybe<ScalarsEnums['Boolean']>
  barcodeEnabled?: Maybe<ScalarsEnums['Boolean']>
  borderRadius?: Maybe<ScalarsEnums['Float']>
  brandLogoEnabled?: Maybe<ScalarsEnums['Boolean']>
  buttonStyle?: Maybe<ScalarsEnums['String']>
  callUsEnabled?: Maybe<ScalarsEnums['Boolean']>
  challengesEnabled?: Maybe<ScalarsEnums['Boolean']>
  classTimeFilter?: Maybe<ScalarsEnums['Boolean']>
  contactlessCheckin?: Maybe<ScalarsEnums['Boolean']>
  customCssLink?: Maybe<ScalarsEnums['String']>
  darkMode?: Maybe<ScalarsEnums['MemberExperienceDarkMode']>
  darkModeSupport?: Maybe<ScalarsEnums['Boolean']>
  displayInstructor?: Maybe<ScalarsEnums['Boolean']>
  displayPackageDescription?: Maybe<ScalarsEnums['Boolean']>
  displayProfilePicture?: Maybe<ScalarsEnums['Boolean']>
  doorCheckin?: Maybe<ScalarsEnums['Boolean']>
  dynamicImagesEnabled?: Maybe<ScalarsEnums['Boolean']>
  editFieldsAddress?: Maybe<ScalarsEnums['Boolean']>
  editFieldsDob?: Maybe<ScalarsEnums['Boolean']>
  editFieldsEnabled?: Maybe<ScalarsEnums['Boolean']>
  editFieldsName?: Maybe<ScalarsEnums['Boolean']>
  editFieldsPhone?: Maybe<ScalarsEnums['Boolean']>
  filterOptions?: Maybe<MemberExperienceSettingsFilterOptions>
  fontSize?: Maybe<ScalarsEnums['Float']>
  footerVisible?: Maybe<ScalarsEnums['Boolean']>
  headerVisible?: Maybe<ScalarsEnums['Boolean']>
  moduleClasses?: Maybe<ScalarsEnums['Boolean']>
  moduleDashboard?: Maybe<ScalarsEnums['Boolean']>
  modulePackages?: Maybe<ScalarsEnums['Boolean']>
  modulePayments?: Maybe<ScalarsEnums['Boolean']>
  modulePrivates?: Maybe<ScalarsEnums['Boolean']>
  moduleProfile?: Maybe<ScalarsEnums['Boolean']>
  moduleSchedule?: Maybe<ScalarsEnums['Boolean']>
  moduleWorkshops?: Maybe<ScalarsEnums['Boolean']>
  newsFeedAvailable?: Maybe<ScalarsEnums['Boolean']>
  privatesAnyAvailable?: Maybe<ScalarsEnums['Boolean']>
  redirectUrl?: Maybe<ScalarsEnums['String']>
  showBilling?: Maybe<ScalarsEnums['Boolean']>
  showFilters?: Maybe<ScalarsEnums['Boolean']>
  shownCommPref?: Maybe<ScalarsEnums['Boolean']>
  sidebarPosition?: Maybe<ScalarsEnums['String']>
  signUpEnabled?: Maybe<ScalarsEnums['Boolean']>
  statsAvailable?: Maybe<ScalarsEnums['Boolean']>
  streakScope?: Maybe<ScalarsEnums['MemberExperienceStreakScope']>
  tabDigitalEnabled?: Maybe<ScalarsEnums['Boolean']>
  tabPurchaseEnabled?: Maybe<ScalarsEnums['Boolean']>
}

export interface MemberExperienceSettings {
  __typename?: 'MemberExperienceSettings'
  awardsEnabled: ScalarsEnums['Boolean']
  barcodeEnabled: ScalarsEnums['Boolean']
  borderRadius: ScalarsEnums['Float']
  brandLogoEnabled: ScalarsEnums['Boolean']
  buttonStyle: ScalarsEnums['WidgetButtonStyle']
  callUsEnabled: ScalarsEnums['Boolean']
  challengesEnabled: ScalarsEnums['Boolean']
  classTimeFilter: ScalarsEnums['Boolean']
  contactlessCheckin: ScalarsEnums['Boolean']
  corporateId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  createdBy?: Maybe<ScalarsEnums['String']>
  customCssLink: ScalarsEnums['String']
  darkMode: ScalarsEnums['MemberExperienceDarkMode']
  darkModeSupport: ScalarsEnums['Boolean']
  displayInstructor: ScalarsEnums['Boolean']
  displayPackageDescription: ScalarsEnums['Boolean']
  displayProfilePicture: ScalarsEnums['Boolean']
  doorCheckin: ScalarsEnums['Boolean']
  dynamicImagesEnabled: ScalarsEnums['Boolean']
  editFieldsAddress: ScalarsEnums['Boolean']
  editFieldsDob: ScalarsEnums['Boolean']
  editFieldsEnabled: ScalarsEnums['Boolean']
  editFieldsName: ScalarsEnums['Boolean']
  editFieldsPhone: ScalarsEnums['Boolean']
  facebookAppId: ScalarsEnums['String']
  facebookClientToken: ScalarsEnums['String']
  facebookDisplayName: ScalarsEnums['String']
  filterOptions: MemberExperienceSettingsFilterOptions
  fontSize: ScalarsEnums['Float']
  footerVisible: ScalarsEnums['Boolean']
  headerVisible: ScalarsEnums['Boolean']
  moduleClasses: ScalarsEnums['Boolean']
  moduleDashboard: ScalarsEnums['Boolean']
  modulePackages: ScalarsEnums['Boolean']
  modulePayments: ScalarsEnums['Boolean']
  modulePrivates: ScalarsEnums['Boolean']
  moduleProfile: ScalarsEnums['Boolean']
  moduleSchedule: ScalarsEnums['Boolean']
  moduleWorkshops: ScalarsEnums['Boolean']
  newsFeedAvailable: ScalarsEnums['Boolean']
  privatesAnyAvailable: ScalarsEnums['Boolean']
  redirectUrl: ScalarsEnums['String']
  showBilling: ScalarsEnums['Boolean']
  showFilters: ScalarsEnums['Boolean']
  shownCommPref: ScalarsEnums['Boolean']
  sidebarPosition: ScalarsEnums['SidebarPosition']
  signUpEnabled: ScalarsEnums['Boolean']
  statsAvailable: ScalarsEnums['Boolean']
  streakScope: ScalarsEnums['MemberExperienceStreakScope']
  tabDigitalEnabled: ScalarsEnums['Boolean']
  tabPurchaseEnabled: ScalarsEnums['Boolean']
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['String']>
  version: ScalarsEnums['Float']
}

export interface MemberExperienceSettingsFilterOptions {
  __typename?: 'MemberExperienceSettingsFilterOptions'
  category: ScalarsEnums['Boolean']
  duration: ScalarsEnums['Boolean']
  instructor: ScalarsEnums['Boolean']
  location: ScalarsEnums['Boolean']
  room: ScalarsEnums['Boolean']
  sessionType: ScalarsEnums['Boolean']
  time: ScalarsEnums['Boolean']
}

export interface MemberExperienceSurfaceBranding {
  __typename?: 'MemberExperienceSurfaceBranding'
  backgroundColor?: Maybe<ScalarsEnums['String']>
  corporateId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  createdBy?: Maybe<ScalarsEnums['String']>
  darkBackgroundColor?: Maybe<ScalarsEnums['String']>
  darkPrimaryColor?: Maybe<ScalarsEnums['String']>
  darkPrimaryTextColor?: Maybe<ScalarsEnums['String']>
  darkSecondaryBackgroundColor?: Maybe<ScalarsEnums['String']>
  darkSecondaryColor?: Maybe<ScalarsEnums['String']>
  darkSecondaryTextColor?: Maybe<ScalarsEnums['String']>
  inheritsGlobal: ScalarsEnums['Boolean']
  primaryColor?: Maybe<ScalarsEnums['String']>
  primaryTextColor?: Maybe<ScalarsEnums['String']>
  secondaryBackgroundColor?: Maybe<ScalarsEnums['String']>
  secondaryColor?: Maybe<ScalarsEnums['String']>
  secondaryTextColor?: Maybe<ScalarsEnums['String']>
  surface: ScalarsEnums['MemberExperienceSurface']
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['String']>
  version?: Maybe<ScalarsEnums['Float']>
}

export interface MemberExperienceSurfaceIntegration {
  __typename?: 'MemberExperienceSurfaceIntegration'
  appId?: Maybe<ScalarsEnums['String']>
  clientToken?: Maybe<ScalarsEnums['String']>
  corporateId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  createdBy?: Maybe<ScalarsEnums['String']>
  displayName?: Maybe<ScalarsEnums['String']>
  provider: ScalarsEnums['MemberExperienceSurfaceIntegrationProvider']
  surface: ScalarsEnums['MemberExperienceSurface']
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['String']>
}

export interface MemberExperienceTheme {
  __typename?: 'MemberExperienceTheme'
  backgroundColor: ScalarsEnums['String']
  corporateId: ScalarsEnums['String']
  darkBackgroundColor?: Maybe<ScalarsEnums['String']>
  darkPrimaryColor?: Maybe<ScalarsEnums['String']>
  darkPrimaryTextColor?: Maybe<ScalarsEnums['String']>
  darkSecondaryBackgroundColor?: Maybe<ScalarsEnums['String']>
  darkSecondaryColor?: Maybe<ScalarsEnums['String']>
  darkSecondaryTextColor?: Maybe<ScalarsEnums['String']>
  primaryColor: ScalarsEnums['String']
  primaryTextColor: ScalarsEnums['String']
  secondaryBackgroundColor?: Maybe<ScalarsEnums['String']>
  secondaryColor: ScalarsEnums['String']
  secondaryTextColor: ScalarsEnums['String']
  source: ScalarsEnums['ThemeValueSource']
  surface: ScalarsEnums['MemberExperienceSurface']
}

/**
 * Receipt for a form the signed-in member completed
 */
export interface MemberFormCompletion {
  __typename?: 'MemberFormCompletion'
  completedAt: ScalarsEnums['String']
  formSubmissionId: ScalarsEnums['String']
  result?: Maybe<MemberFormResult>
}

/**
 * An outstanding form for the signed-in member to fill in
 */
export interface MemberFormDetail {
  __typename?: 'MemberFormDetail'
  assignedAt: ScalarsEnums['String']
  description?: Maybe<ScalarsEnums['String']>
  formSubmissionId: ScalarsEnums['String']
  name: ScalarsEnums['String']
  questionCount: ScalarsEnums['Float']
  questions: Array<MemberFormQuestion>
  requiredBefore?: Maybe<ScalarsEnums['FormRequiredBefore']>
  revision: ScalarsEnums['Float']
  siteFormId: ScalarsEnums['String']
  siteId: ScalarsEnums['String']
}

/**
 * How many questions the member has answered so far
 */
export interface MemberFormProgress {
  __typename?: 'MemberFormProgress'
  answeredCount: ScalarsEnums['Float']
  formSubmissionId: ScalarsEnums['String']
}

/**
 * A question as the member sees it, without points or results
 */
export interface MemberFormQuestion {
  __typename?: 'MemberFormQuestion'
  blurbText?: Maybe<ScalarsEnums['String']>
  mustAnswerYes: ScalarsEnums['Boolean']
  options: Array<ScalarsEnums['String']>
  required: ScalarsEnums['Boolean']
  siteFormQuestionId: ScalarsEnums['String']
  title: ScalarsEnums['String']
  type: ScalarsEnums['String']
}

/**
 * The result of a scored form, shown only when the location allows it
 */
export interface MemberFormResult {
  __typename?: 'MemberFormResult'
  description?: Maybe<ScalarsEnums['String']>
  label: ScalarsEnums['String']
}

/**
 * A gift card owned by the signed-in member, with its balance, status and expiry
 */
export interface MemberGiftCard {
  __typename?: 'MemberGiftCard'
  code: ScalarsEnums['String']
  currency?: Maybe<ScalarsEnums['String']>
  currentBalance: ScalarsEnums['Numeric']
  expiredAt?: Maybe<ScalarsEnums['String']>
  expiresAt?: Maybe<ScalarsEnums['String']>
  giftCardId: ScalarsEnums['ID']
  initialValue: ScalarsEnums['Numeric']
  isRedeemableHere: ScalarsEnums['Boolean']
  locationName?: Maybe<ScalarsEnums['String']>
  purchaseDate: ScalarsEnums['String']
  recipientName?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['GiftCardStatus']
  templateName: ScalarsEnums['String']
  timezone?: Maybe<ScalarsEnums['String']>
}

export interface MemberLocationInformation {
  __typename?: 'MemberLocationInformation'
  amenities?: Maybe<MemberSiteAmenities>
  blocks: Array<MemberSiteInfoBlock>
  description?: Maybe<ScalarsEnums['String']>
  heading: ScalarsEnums['String']
  isTemporarilyClosed: ScalarsEnums['Boolean']
  openingHours?: Maybe<MemberOpeningHours>
  staffedHours?: Maybe<MemberStaffedHours>
}

export interface MemberMovementApprovalReadiness {
  __typename?: 'MemberMovementApprovalReadiness'
  approved: ScalarsEnums['Float']
  unresolved: ScalarsEnums['Float']
}

/**
 * Immutable, insert-only liability attestation record
 */
export interface MemberMovementAttestation {
  __typename?: 'MemberMovementAttestation'
  corporateId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  disclaimerText: ScalarsEnums['String']
  disclaimerVersion: ScalarsEnums['String']
  ipAddress?: Maybe<ScalarsEnums['String']>
  memberMovementAttestationId: ScalarsEnums['ID']
  referenceId: ScalarsEnums['String']
  scope: ScalarsEnums['MemberMovementAttestationScope']
  staffUserId: ScalarsEnums['ID']
  typedName: ScalarsEnums['String']
}

export interface MemberMovementAttestationRegisterResult {
  __typename?: 'MemberMovementAttestationRegisterResult'
  items: Array<MemberMovementAttestation>
}

export interface MemberMovementBrandPosture {
  __typename?: 'MemberMovementBrandPosture'
  rollingApprovalLocked: ScalarsEnums['Boolean']
  rollingApprovalType: ScalarsEnums['MemberMovementRollingApprovalType']
}

/**
 * Corporate-level Member Movement configuration (PRD §6.1)
 */
export interface MemberMovementConfig {
  __typename?: 'MemberMovementConfig'
  allowArchivedDestinations: ScalarsEnums['Boolean']
  billingAmountStrategy: ScalarsEnums['MemberMovementBillingAmountStrategy']
  blockedNotificationCadence: ScalarsEnums['MemberMovementBlockedNotificationCadence']
  candidateHomeExclusion: ScalarsEnums['MemberMovementCandidateHomeExclusion']
  declineCooldownDays: ScalarsEnums['Float']
  emergencyStopped: ScalarsEnums['Boolean']
  enabled: ScalarsEnums['Boolean']
  excludeScheduledCancellations: ScalarsEnums['Boolean']
  excludeSuspendedMemberships: ScalarsEnums['Boolean']
  excludedClientIds: Array<ScalarsEnums['ID']>
  excludedPackageCategoryIds: Array<ScalarsEnums['ID']>
  growTransferTag: ScalarsEnums['String']
  includedSiteIds: Array<ScalarsEnums['ID']>
  incomingApprovalExpiryDays?: Maybe<ScalarsEnums['Float']>
  incomingApprovalNotifiers: Array<MemberMovementIncomingApprover>
  maxMovementsPerCycle: MemberMovementMaxMovementsPerCycle
  minMembershipPrice: ScalarsEnums['Float']
  /**
   * Visits at the candidate (non-home) site before a member is considered at all. Never below 1: with no non-home visits there is no destination to move to.
   */
  minNonHomeVisits: ScalarsEnums['Float']
  minPaidAmountInPeriod: ScalarsEnums['Float']
  minTenure?: Maybe<MemberMovementDurationConfig>
  minTenureCutoffDate?: Maybe<ScalarsEnums['String']>
  minVisitPercentAtCandidate: ScalarsEnums['Float']
  minVisits: ScalarsEnums['Float']
  minVisitsScope: ScalarsEnums['MemberMovementVisitsScope']
  movementManagerStaffUserIds: Array<ScalarsEnums['ID']>
  operatingMode: ScalarsEnums['MemberMovementOperatingMode']
  postMovementGracePeriodDays: ScalarsEnums['Float']
  rollingApprovalLocked: ScalarsEnums['Boolean']
  rollingApprovalOverrides: Array<MemberMovementLocationApprovalOverride>
  rollingApprovalType: ScalarsEnums['MemberMovementRollingApprovalType']
  rollingSchedule?: Maybe<MemberMovementRollingSchedule>
  rollingSchedulerSyncPending: ScalarsEnums['Boolean']
  templateMappingMode: ScalarsEnums['MemberMovementTemplateMappingMode']
  visitScope: MemberMovementConfigVisitScope
  visitWindowHours: ScalarsEnums['Float']
}

export interface MemberMovementConfigVisitScope {
  __typename?: 'MemberMovementConfigVisitScope'
  class: ScalarsEnums['Boolean']
  general: ScalarsEnums['Boolean']
}

export interface MemberMovementConnection {
  __typename?: 'MemberMovementConnection'
  items: Array<MemberMovementListItem>
  pageInfo: MemberMovementPageInfo
}

export interface MemberMovementDeleteResult {
  __typename?: 'MemberMovementDeleteResult'
  deleted: ScalarsEnums['Boolean']
}

export interface MemberMovementDestinationCharge {
  __typename?: 'MemberMovementDestinationCharge'
  amount: ScalarsEnums['String']
  currency?: Maybe<ScalarsEnums['String']>
  invoiceId: ScalarsEnums['ID']
  paidAt?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['String']
}

export interface MemberMovementDestinationTemplate {
  __typename?: 'MemberMovementDestinationTemplate'
  archived: ScalarsEnums['Boolean']
  billingCycleAmount?: Maybe<ScalarsEnums['Float']>
  billingCycleUnit?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  price: ScalarsEnums['String']
  serviceTemplateId: ScalarsEnums['ID']
}

/**
 * Detail projection of a MemberMovement row — includes gateResults + sourceStateSnapshot (Issue 5 row expansion)
 */
export interface MemberMovementDetail {
  __typename?: 'MemberMovementDetail'
  approvedAt?: Maybe<ScalarsEnums['String']>
  approvedByName?: Maybe<ScalarsEnums['String']>
  approvedByStaffUserId?: Maybe<ScalarsEnums['String']>
  attestationId?: Maybe<ScalarsEnums['ID']>
  blockedReason?: Maybe<ScalarsEnums['MemberMovementBlockedReason']>
  candidateSiteName?: Maybe<ScalarsEnums['String']>
  clientEmail?: Maybe<ScalarsEnums['String']>
  clientId: ScalarsEnums['ID']
  clientName?: Maybe<ScalarsEnums['String']>
  corporateId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  declineReason?: Maybe<ScalarsEnums['String']>
  declinedAt?: Maybe<ScalarsEnums['String']>
  declinedByName?: Maybe<ScalarsEnums['String']>
  declinedByStaffUserId?: Maybe<ScalarsEnums['String']>
  destinationAmount?: Maybe<ScalarsEnums['Float']>
  destinationChosenAt?: Maybe<ScalarsEnums['String']>
  destinationChosenByName?: Maybe<ScalarsEnums['String']>
  destinationChosenByStaffUserId?: Maybe<ScalarsEnums['ID']>
  destinationCurrency?: Maybe<ScalarsEnums['String']>
  destinationOverridden: ScalarsEnums['Boolean']
  destinationServiceId?: Maybe<ScalarsEnums['ID']>
  destinationServiceTemplateId?: Maybe<ScalarsEnums['ID']>
  destinationSiteId?: Maybe<ScalarsEnums['ID']>
  destinationTemplateArchived?: Maybe<ScalarsEnums['Boolean']>
  destinationTemplateName?: Maybe<ScalarsEnums['String']>
  error?: Maybe<ScalarsEnums['String']>
  executedAt?: Maybe<ScalarsEnums['String']>
  forceIncluded?: Maybe<ScalarsEnums['Boolean']>
  gateResults?: Maybe<Array<MemberMovementGateResult>>
  homeSiteName?: Maybe<ScalarsEnums['String']>
  memberMovementId: ScalarsEnums['ID']
  memberMovementRunId?: Maybe<ScalarsEnums['ID']>
  membershipName?: Maybe<ScalarsEnums['String']>
  membershipPrice?: Maybe<ScalarsEnums['Float']>
  paidAtHomeAmount?: Maybe<ScalarsEnums['Float']>
  paymentCollected?: Maybe<ScalarsEnums['Boolean']>
  paymentMigrationReason?: Maybe<ScalarsEnums['MemberMovementPaymentMigrationReason']>
  paymentMigrationStatus?: Maybe<ScalarsEnums['MemberMovementPaymentMigrationStatus']>
  reasonCode?: Maybe<ScalarsEnums['MemberMovementReasonCode']>
  replayOfMovementId?: Maybe<ScalarsEnums['ID']>
  revertReason?: Maybe<ScalarsEnums['String']>
  revertedAt?: Maybe<ScalarsEnums['String']>
  revertedByName?: Maybe<ScalarsEnums['String']>
  revertedByStaffUserId?: Maybe<ScalarsEnums['ID']>
  reviewNote?: Maybe<ScalarsEnums['String']>
  reviewStatus?: Maybe<ScalarsEnums['MemberMovementReviewStatus']>
  sourceAmount?: Maybe<ScalarsEnums['Float']>
  sourceCurrency?: Maybe<ScalarsEnums['String']>
  sourceServiceId: ScalarsEnums['ID']
  sourceServiceTemplateId: ScalarsEnums['ID']
  sourceSiteId: ScalarsEnums['ID']
  sourceStateSnapshot?: Maybe<ScalarsEnums['JSONObject']>
  status: ScalarsEnums['MemberMovementStatus']
  totalVisits?: Maybe<ScalarsEnums['Float']>
  trigger: ScalarsEnums['MemberMovementTrigger']
  updatedAt: ScalarsEnums['String']
  visitCount?: Maybe<ScalarsEnums['Float']>
  visitPercent?: Maybe<ScalarsEnums['Float']>
  visitScopeUsed?: Maybe<ScalarsEnums['MemberMovementVisitsScope']>
}

/**
 * A relative duration (unit + value) used by rolling schedule / tenure fields
 */
export interface MemberMovementDurationConfig {
  __typename?: 'MemberMovementDurationConfig'
  unit: ScalarsEnums['MemberMovementDurationUnit']
  value: ScalarsEnums['Float']
}

export interface MemberMovementEligibilityResult {
  __typename?: 'MemberMovementEligibilityResult'
  candidateSiteId?: Maybe<ScalarsEnums['ID']>
  candidateVisits: ScalarsEnums['Float']
  clientId: ScalarsEnums['ID']
  gateResults: Array<MemberMovementGateResult>
  homeSiteId: ScalarsEnums['ID']
  membershipPrice: ScalarsEnums['Float']
  paidAtHomeAmount: ScalarsEnums['Float']
  qualified: ScalarsEnums['Boolean']
  reasonCode?: Maybe<ScalarsEnums['MemberMovementReasonCode']>
  serviceId: ScalarsEnums['ID']
  status: ScalarsEnums['String']
  totalVisits: ScalarsEnums['Float']
  visitPercent?: Maybe<ScalarsEnums['Float']>
}

/**
 * A single per-gate PASS/FAIL evaluation result with measured value vs threshold
 */
export interface MemberMovementGateResult {
  __typename?: 'MemberMovementGateResult'
  gate: ScalarsEnums['Float']
  key: ScalarsEnums['MemberMovementGateKey']
  measured?: Maybe<ScalarsEnums['String']>
  reasonCode?: Maybe<ScalarsEnums['MemberMovementReasonCode']>
  status: ScalarsEnums['MemberMovementGateStatus']
  threshold?: Maybe<ScalarsEnums['String']>
}

export interface MemberMovementHeldMovement {
  __typename?: 'MemberMovementHeldMovement'
  clientId: ScalarsEnums['ID']
  holdingMovementId: ScalarsEnums['ID']
  holdingRunId?: Maybe<ScalarsEnums['ID']>
  holdingRunStatus?: Maybe<ScalarsEnums['String']>
  memberMovementId: ScalarsEnums['ID']
  sourceServiceId: ScalarsEnums['ID']
}

/**
 * Staff users notified when a member qualifies to move into one site
 */
export interface MemberMovementIncomingApprover {
  __typename?: 'MemberMovementIncomingApprover'
  siteId: ScalarsEnums['ID']
  staffUserIds: Array<ScalarsEnums['ID']>
}

/**
 * A page of incoming movements plus every source and destination location on it
 */
export interface MemberMovementIncomingConnection {
  __typename?: 'MemberMovementIncomingConnection'
  items: Array<MemberMovementListItem>
  pageInfo: MemberMovementPageInfo
  sites: Array<MemberMovementIncomingSite>
}

export interface MemberMovementIncomingDestinationTemplate {
  __typename?: 'MemberMovementIncomingDestinationTemplate'
  archived: ScalarsEnums['Boolean']
  billedPrice?: Maybe<ScalarsEnums['String']>
  billedPriceCurrency?: Maybe<ScalarsEnums['String']>
  billingAmountStrategy: ScalarsEnums['MemberMovementBillingAmountStrategy']
  billingCycleAmount?: Maybe<ScalarsEnums['Float']>
  billingCycleUnit?: Maybe<ScalarsEnums['String']>
  currency?: Maybe<ScalarsEnums['String']>
  lengthType?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  price: ScalarsEnums['String']
  serviceTemplateId: ScalarsEnums['ID']
}

/**
 * One incoming movement with the live source billing and the caller’s permissions
 */
export interface MemberMovementIncomingMovement {
  __typename?: 'MemberMovementIncomingMovement'
  approvedAt?: Maybe<ScalarsEnums['String']>
  approvedByName?: Maybe<ScalarsEnums['String']>
  approvedByStaffUserId?: Maybe<ScalarsEnums['String']>
  attestationId?: Maybe<ScalarsEnums['ID']>
  billedPrice?: Maybe<ScalarsEnums['String']>
  billedPriceCurrency?: Maybe<ScalarsEnums['String']>
  billingAmountStrategy: ScalarsEnums['MemberMovementBillingAmountStrategy']
  blockedReason?: Maybe<ScalarsEnums['MemberMovementBlockedReason']>
  candidateSiteName?: Maybe<ScalarsEnums['String']>
  clientEmail?: Maybe<ScalarsEnums['String']>
  clientId: ScalarsEnums['ID']
  clientName?: Maybe<ScalarsEnums['String']>
  corporateId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  declineReason?: Maybe<ScalarsEnums['String']>
  declinedAt?: Maybe<ScalarsEnums['String']>
  declinedByName?: Maybe<ScalarsEnums['String']>
  declinedByStaffUserId?: Maybe<ScalarsEnums['String']>
  destinationAmount?: Maybe<ScalarsEnums['Float']>
  destinationChosenAt?: Maybe<ScalarsEnums['String']>
  destinationChosenByName?: Maybe<ScalarsEnums['String']>
  destinationChosenByStaffUserId?: Maybe<ScalarsEnums['ID']>
  destinationCurrency?: Maybe<ScalarsEnums['String']>
  destinationOverridden: ScalarsEnums['Boolean']
  destinationPrice?: Maybe<ScalarsEnums['String']>
  destinationPriceCurrency?: Maybe<ScalarsEnums['String']>
  destinationServiceId?: Maybe<ScalarsEnums['ID']>
  destinationServiceTemplateId?: Maybe<ScalarsEnums['ID']>
  destinationSiteCurrency?: Maybe<ScalarsEnums['String']>
  destinationSiteId?: Maybe<ScalarsEnums['ID']>
  destinationSiteName?: Maybe<ScalarsEnums['String']>
  destinationSiteTimezone?: Maybe<ScalarsEnums['String']>
  destinationTemplateArchived?: Maybe<ScalarsEnums['Boolean']>
  destinationTemplateName?: Maybe<ScalarsEnums['String']>
  error?: Maybe<ScalarsEnums['String']>
  executedAt?: Maybe<ScalarsEnums['String']>
  forceIncluded?: Maybe<ScalarsEnums['Boolean']>
  homeSiteName?: Maybe<ScalarsEnums['String']>
  memberMovementId: ScalarsEnums['ID']
  memberMovementRunId?: Maybe<ScalarsEnums['ID']>
  membershipName?: Maybe<ScalarsEnums['String']>
  membershipPrice?: Maybe<ScalarsEnums['Float']>
  paidAtHomeAmount?: Maybe<ScalarsEnums['Float']>
  paymentCollected?: Maybe<ScalarsEnums['Boolean']>
  paymentMigrationReason?: Maybe<ScalarsEnums['MemberMovementPaymentMigrationReason']>
  paymentMigrationStatus?: Maybe<ScalarsEnums['MemberMovementPaymentMigrationStatus']>
  permissions: MemberMovementIncomingPermissions
  reasonCode?: Maybe<ScalarsEnums['MemberMovementReasonCode']>
  replayOfMovementId?: Maybe<ScalarsEnums['ID']>
  revertReason?: Maybe<ScalarsEnums['String']>
  revertedAt?: Maybe<ScalarsEnums['String']>
  revertedByName?: Maybe<ScalarsEnums['String']>
  revertedByStaffUserId?: Maybe<ScalarsEnums['ID']>
  reviewNote?: Maybe<ScalarsEnums['String']>
  reviewStatus?: Maybe<ScalarsEnums['MemberMovementReviewStatus']>
  sourceAmount?: Maybe<ScalarsEnums['Float']>
  sourceCurrency?: Maybe<ScalarsEnums['String']>
  sourceNextBillingDate?: Maybe<ScalarsEnums['String']>
  sourcePrice?: Maybe<ScalarsEnums['String']>
  sourcePriceCurrency?: Maybe<ScalarsEnums['String']>
  sourceServiceId: ScalarsEnums['ID']
  sourceServiceTemplateId: ScalarsEnums['ID']
  sourceSiteCurrency?: Maybe<ScalarsEnums['String']>
  sourceSiteId: ScalarsEnums['ID']
  sourceSiteName?: Maybe<ScalarsEnums['String']>
  sourceSiteTimezone?: Maybe<ScalarsEnums['String']>
  sourceTemplateName?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['MemberMovementStatus']
  totalVisits?: Maybe<ScalarsEnums['Float']>
  trigger: ScalarsEnums['MemberMovementTrigger']
  updatedAt: ScalarsEnums['String']
  visitCount?: Maybe<ScalarsEnums['Float']>
  visitPercent?: Maybe<ScalarsEnums['Float']>
  visitScopeUsed?: Maybe<ScalarsEnums['MemberMovementVisitsScope']>
}

/**
 * A staff member a location emails about incoming movements, with their name
 */
export interface MemberMovementIncomingNotifier {
  __typename?: 'MemberMovementIncomingNotifier'
  name?: Maybe<ScalarsEnums['String']>
  staffUserId: ScalarsEnums['ID']
}

export interface MemberMovementIncomingNotifierCandidate {
  __typename?: 'MemberMovementIncomingNotifierCandidate'
  name: ScalarsEnums['String']
  roleOrTitle?: Maybe<ScalarsEnums['String']>
  staffUserId: ScalarsEnums['ID']
}

export interface MemberMovementIncomingPermissions {
  __typename?: 'MemberMovementIncomingPermissions'
  canDecide: ScalarsEnums['Boolean']
  canDismiss: ScalarsEnums['Boolean']
  canManage: ScalarsEnums['Boolean']
  canSaveAsBrandMapping: ScalarsEnums['Boolean']
}

/**
 * A location on an incoming movement page, with what its dates and money render in
 */
export interface MemberMovementIncomingSite {
  __typename?: 'MemberMovementIncomingSite'
  currency?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  siteId: ScalarsEnums['ID']
  timezone?: Maybe<ScalarsEnums['String']>
}

export interface MemberMovementIncomingSummary {
  __typename?: 'MemberMovementIncomingSummary'
  awaiting: ScalarsEnums['Float']
  declineCooldownDays?: Maybe<ScalarsEnums['Float']>
  failed: ScalarsEnums['Float']
  incomingApprovalExpiryDays?: Maybe<ScalarsEnums['Float']>
  unmatched: ScalarsEnums['Float']
}

/**
 * List/grid projection of a MemberMovement row — excludes JSON blob columns
 */
export interface MemberMovementListItem {
  __typename?: 'MemberMovementListItem'
  approvedAt?: Maybe<ScalarsEnums['String']>
  approvedByName?: Maybe<ScalarsEnums['String']>
  approvedByStaffUserId?: Maybe<ScalarsEnums['String']>
  attestationId?: Maybe<ScalarsEnums['ID']>
  blockedReason?: Maybe<ScalarsEnums['MemberMovementBlockedReason']>
  candidateSiteName?: Maybe<ScalarsEnums['String']>
  clientEmail?: Maybe<ScalarsEnums['String']>
  clientId: ScalarsEnums['ID']
  clientName?: Maybe<ScalarsEnums['String']>
  corporateId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  declineReason?: Maybe<ScalarsEnums['String']>
  declinedAt?: Maybe<ScalarsEnums['String']>
  declinedByName?: Maybe<ScalarsEnums['String']>
  declinedByStaffUserId?: Maybe<ScalarsEnums['String']>
  destinationAmount?: Maybe<ScalarsEnums['Float']>
  destinationChosenAt?: Maybe<ScalarsEnums['String']>
  destinationChosenByName?: Maybe<ScalarsEnums['String']>
  destinationChosenByStaffUserId?: Maybe<ScalarsEnums['ID']>
  destinationCurrency?: Maybe<ScalarsEnums['String']>
  destinationOverridden: ScalarsEnums['Boolean']
  destinationServiceId?: Maybe<ScalarsEnums['ID']>
  destinationServiceTemplateId?: Maybe<ScalarsEnums['ID']>
  destinationSiteId?: Maybe<ScalarsEnums['ID']>
  destinationTemplateArchived?: Maybe<ScalarsEnums['Boolean']>
  destinationTemplateName?: Maybe<ScalarsEnums['String']>
  error?: Maybe<ScalarsEnums['String']>
  executedAt?: Maybe<ScalarsEnums['String']>
  forceIncluded?: Maybe<ScalarsEnums['Boolean']>
  homeSiteName?: Maybe<ScalarsEnums['String']>
  memberMovementId: ScalarsEnums['ID']
  memberMovementRunId?: Maybe<ScalarsEnums['ID']>
  membershipName?: Maybe<ScalarsEnums['String']>
  membershipPrice?: Maybe<ScalarsEnums['Float']>
  paidAtHomeAmount?: Maybe<ScalarsEnums['Float']>
  paymentCollected?: Maybe<ScalarsEnums['Boolean']>
  paymentMigrationReason?: Maybe<ScalarsEnums['MemberMovementPaymentMigrationReason']>
  paymentMigrationStatus?: Maybe<ScalarsEnums['MemberMovementPaymentMigrationStatus']>
  reasonCode?: Maybe<ScalarsEnums['MemberMovementReasonCode']>
  replayOfMovementId?: Maybe<ScalarsEnums['ID']>
  revertReason?: Maybe<ScalarsEnums['String']>
  revertedAt?: Maybe<ScalarsEnums['String']>
  revertedByName?: Maybe<ScalarsEnums['String']>
  revertedByStaffUserId?: Maybe<ScalarsEnums['ID']>
  reviewNote?: Maybe<ScalarsEnums['String']>
  reviewStatus?: Maybe<ScalarsEnums['MemberMovementReviewStatus']>
  sourceAmount?: Maybe<ScalarsEnums['Float']>
  sourceCurrency?: Maybe<ScalarsEnums['String']>
  sourceServiceId: ScalarsEnums['ID']
  sourceServiceTemplateId: ScalarsEnums['ID']
  sourceSiteId: ScalarsEnums['ID']
  status: ScalarsEnums['MemberMovementStatus']
  totalVisits?: Maybe<ScalarsEnums['Float']>
  trigger: ScalarsEnums['MemberMovementTrigger']
  updatedAt: ScalarsEnums['String']
  visitCount?: Maybe<ScalarsEnums['Float']>
  visitPercent?: Maybe<ScalarsEnums['Float']>
  visitScopeUsed?: Maybe<ScalarsEnums['MemberMovementVisitsScope']>
}

/**
 * A location's own rolling approval posture, overriding the brand default
 */
export interface MemberMovementLocationApprovalOverride {
  __typename?: 'MemberMovementLocationApprovalOverride'
  rollingApprovalType: ScalarsEnums['MemberMovementRollingApprovalType']
  siteId: ScalarsEnums['ID']
}

export interface MemberMovementLocationPosture {
  __typename?: 'MemberMovementLocationPosture'
  canConfigure: ScalarsEnums['Boolean']
  effectiveRollingApprovalType: ScalarsEnums['MemberMovementRollingApprovalType']
  notifierStaffUserIds: Array<ScalarsEnums['ID']>
  notifiers: Array<MemberMovementIncomingNotifier>
  override?: Maybe<ScalarsEnums['MemberMovementRollingApprovalType']>
  siteId: ScalarsEnums['ID']
  siteName: ScalarsEnums['String']
  source: ScalarsEnums['MemberMovementApprovalPostureSource']
}

export interface MemberMovementLocationPostures {
  __typename?: 'MemberMovementLocationPostures'
  brand: MemberMovementBrandPosture
  locations: Array<MemberMovementLocationPosture>
}

export interface MemberMovementLocationResolution {
  __typename?: 'MemberMovementLocationResolution'
  chosenCount: ScalarsEnums['Float']
  destinationServiceTemplateId: ScalarsEnums['ID']
  destinationSiteId: ScalarsEnums['ID']
  destinationSiteName?: Maybe<ScalarsEnums['String']>
  destinationTemplateName?: Maybe<ScalarsEnums['String']>
  lastChosenAt?: Maybe<ScalarsEnums['String']>
  lastChosenByName?: Maybe<ScalarsEnums['String']>
  lastChosenByStaffUserId?: Maybe<ScalarsEnums['String']>
  pendingUnmatchedCount: ScalarsEnums['Float']
  sourceServiceTemplateId: ScalarsEnums['ID']
  sourceSiteId: ScalarsEnums['ID']
  sourceSiteName?: Maybe<ScalarsEnums['String']>
  sourceTemplateName?: Maybe<ScalarsEnums['String']>
}

export interface MemberMovementLocationResolutionConnection {
  __typename?: 'MemberMovementLocationResolutionConnection'
  items: Array<MemberMovementLocationResolution>
  pageInfo: MemberMovementPageInfo
}

export interface MemberMovementManualTransferPreview {
  __typename?: 'MemberMovementManualTransferPreview'
  agreementCarried: ScalarsEnums['Boolean']
  carriedAnchorDate?: Maybe<ScalarsEnums['String']>
  carriedNextInvoiceDate?: Maybe<ScalarsEnums['String']>
  clientId: ScalarsEnums['ID']
  crossCurrency: ScalarsEnums['Boolean']
  destinationCurrency?: Maybe<ScalarsEnums['String']>
  destinationOverridden: ScalarsEnums['Boolean']
  destinationServiceTemplateId?: Maybe<ScalarsEnums['ID']>
  destinationServiceTemplateName?: Maybe<ScalarsEnums['String']>
  destinationSiteId: ScalarsEnums['ID']
  paymentOutlook: MemberMovementPaymentTransferPairOutlook
  secondaryFeeOutcome: ScalarsEnums['String']
  sourceAmount?: Maybe<ScalarsEnums['String']>
  sourceCurrency?: Maybe<ScalarsEnums['String']>
  sourceServiceId: ScalarsEnums['ID']
  sourceServiceTemplateId: ScalarsEnums['ID']
  sourceSiteId: ScalarsEnums['ID']
  templateResolved: ScalarsEnums['Boolean']
}

export interface MemberMovementManualTransferResult {
  __typename?: 'MemberMovementManualTransferResult'
  blockedReason?: Maybe<ScalarsEnums['String']>
  destinationServiceId?: Maybe<ScalarsEnums['ID']>
  memberMovementId: ScalarsEnums['ID']
  outcome: ScalarsEnums['String']
}

/**
 * Circuit-breaker cap on qualified movements per run/cycle
 */
export interface MemberMovementMaxMovementsPerCycle {
  __typename?: 'MemberMovementMaxMovementsPerCycle'
  absolute?: Maybe<ScalarsEnums['Float']>
  percentOfActiveMembers: ScalarsEnums['Float']
}

export interface MemberMovementOverlappingRun {
  __typename?: 'MemberMovementOverlappingRun'
  isDeletable: ScalarsEnums['Boolean']
  memberMovementRunId: ScalarsEnums['ID']
  periodEnd?: Maybe<ScalarsEnums['String']>
  periodStart?: Maybe<ScalarsEnums['String']>
  qualifiedCount: ScalarsEnums['Float']
  status: ScalarsEnums['String']
}

export interface MemberMovementPageInfo {
  __typename?: 'MemberMovementPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  page?: Maybe<ScalarsEnums['Float']>
  pageSize?: Maybe<ScalarsEnums['Float']>
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Float']
}

export interface MemberMovementPaymentTransferMatrix {
  __typename?: 'MemberMovementPaymentTransferMatrix'
  pairs: Array<MemberMovementPaymentTransferPairOutlook>
  sites: Array<MemberMovementPaymentTransferSiteDescriptor>
  truncated: ScalarsEnums['Boolean']
}

export interface MemberMovementPaymentTransferPairOutlook {
  __typename?: 'MemberMovementPaymentTransferPairOutlook'
  destinationSiteId: ScalarsEnums['ID']
  feasible: ScalarsEnums['Boolean']
  method: ScalarsEnums['String']
  reason?: Maybe<ScalarsEnums['String']>
  sourceSiteId: ScalarsEnums['ID']
}

export interface MemberMovementPaymentTransferSiteDescriptor {
  __typename?: 'MemberMovementPaymentTransferSiteDescriptor'
  countryCode?: Maybe<ScalarsEnums['String']>
  gatewayType?: Maybe<ScalarsEnums['String']>
  siteId: ScalarsEnums['ID']
  siteName: ScalarsEnums['String']
  stripePlatform?: Maybe<ScalarsEnums['String']>
}

/**
 * Rolling-mode cadence, lookback window, and preview-notification window
 */
export interface MemberMovementRollingSchedule {
  __typename?: 'MemberMovementRollingSchedule'
  evaluationWindow: MemberMovementDurationConfig
  frequency: MemberMovementDurationConfig
  previewWindowHours: ScalarsEnums['Float']
}

/**
 * Live registration and next fire time of a corporate rolling-evaluation cron
 */
export interface MemberMovementRollingSchedulerStatus {
  __typename?: 'MemberMovementRollingSchedulerStatus'
  nextRunAt?: Maybe<ScalarsEnums['String']>
  rollingEnabled: ScalarsEnums['Boolean']
  schedulerRegistered: ScalarsEnums['Boolean']
}

/**
 * A Period Run or rolling-cycle grouping of Member Movement evaluations
 */
export interface MemberMovementRun {
  __typename?: 'MemberMovementRun'
  approvalAttestationId?: Maybe<ScalarsEnums['ID']>
  approvedAt?: Maybe<ScalarsEnums['String']>
  approvedCount: ScalarsEnums['Float']
  blockedCount: ScalarsEnums['Float']
  bullmqJobId?: Maybe<ScalarsEnums['String']>
  configSnapshot?: Maybe<ScalarsEnums['JSONObject']>
  corporateId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  createdByStaffUserId?: Maybe<ScalarsEnums['ID']>
  dataNotes?: Maybe<ScalarsEnums['JSONObject']>
  evaluatedAt?: Maybe<ScalarsEnums['String']>
  evaluatedCount: ScalarsEnums['Float']
  executedAt?: Maybe<ScalarsEnums['String']>
  failedCount: ScalarsEnums['Float']
  memberMovementRunId: ScalarsEnums['ID']
  mode: ScalarsEnums['MemberMovementRunMode']
  movedCount: ScalarsEnums['Float']
  periodEnd?: Maybe<ScalarsEnums['String']>
  periodStart?: Maybe<ScalarsEnums['String']>
  qualifiedCount: ScalarsEnums['Float']
  removedCount: ScalarsEnums['Float']
  revertedCount: ScalarsEnums['Float']
  scheduledExecutionAt?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['MemberMovementRunStatus']
  timezone?: Maybe<ScalarsEnums['String']>
  updatedAt: ScalarsEnums['String']
}

export interface MemberMovementRunConnection {
  __typename?: 'MemberMovementRunConnection'
  items: Array<MemberMovementRun>
  pageInfo: MemberMovementPageInfo
}

/**
 * A persisted corporate source→destination service-template mapping
 */
export interface MemberMovementTemplateMapping {
  __typename?: 'MemberMovementTemplateMapping'
  corporateId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  createdByStaffUserId?: Maybe<ScalarsEnums['ID']>
  destinationServiceTemplateId: ScalarsEnums['ID']
  destinationSiteId: ScalarsEnums['ID']
  isStale: ScalarsEnums['Boolean']
  matchType: ScalarsEnums['MemberMovementMappingMatchType']
  memberMovementTemplateMappingId: ScalarsEnums['ID']
  sourceServiceTemplateId: ScalarsEnums['ID']
  sourceSiteId: ScalarsEnums['ID']
  updatedAt: ScalarsEnums['String']
}

export interface MemberMovementTransferableMembership {
  __typename?: 'MemberMovementTransferableMembership'
  currency?: Maybe<ScalarsEnums['String']>
  expiresAt?: Maybe<ScalarsEnums['String']>
  nextBillingDate?: Maybe<ScalarsEnums['String']>
  price?: Maybe<ScalarsEnums['String']>
  serviceId: ScalarsEnums['ID']
  serviceTemplateId: ScalarsEnums['ID']
  serviceTemplateName?: Maybe<ScalarsEnums['String']>
  siteId: ScalarsEnums['ID']
  startsAt?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['String']
}

/**
 * week holds seven site-local dates starting today, exceptions applied
 */
export interface MemberOpeningHours {
  __typename?: 'MemberOpeningHours'
  is24x7: ScalarsEnums['Boolean']
  isOpenNow: ScalarsEnums['Boolean']
  today: ResolvedOpeningDay
  upcomingExceptions: Array<UpcomingOpeningException>
  week: Array<ResolvedOpeningDay>
}

/**
 * How much of the calendar-year pause allowance the member has used on this membership, in the unit the operator configured (days, or billing cycles when pauses are aligned to the billing grid), and the date it resets.
 */
export interface MemberPauseAllowance {
  __typename?: 'MemberPauseAllowance'
  limit: ScalarsEnums['Float']
  remaining: ScalarsEnums['Float']
  resetDate: ScalarsEnums['String']
  unit: ScalarsEnums['MemberPauseAllowanceUnit']
  used: ScalarsEnums['Float']
}

/**
 * The earliest cancellation date before and after the pause, when a minimum term applies.
 */
export interface MemberPauseCommitment {
  __typename?: 'MemberPauseCommitment'
  after: ScalarsEnums['String']
  before: ScalarsEnums['String']
}

export interface MemberPauseDatedAmount {
  __typename?: 'MemberPauseDatedAmount'
  amount: ScalarsEnums['String']
  date: ScalarsEnums['String']
}

/**
 * The credit for the paid part of the current cycle the member will not use, applied to the first invoice after they resume.
 */
export interface MemberPauseEntryCredit {
  __typename?: 'MemberPauseEntryCredit'
  amount: ScalarsEnums['String']
  unusedCredits?: Maybe<ScalarsEnums['Float']>
  unusedDays?: Maybe<ScalarsEnums['Float']>
}

/**
 * The pause fee the operator configured on this membership: none, a flat amount charged once, or a recurring amount charged on its own cadence while paused.
 */
export interface MemberPauseFee {
  __typename?: 'MemberPauseFee'
  amount?: Maybe<ScalarsEnums['String']>
  cadenceAmount?: Maybe<ScalarsEnums['Float']>
  cadenceUnit?: Maybe<ScalarsEnums['String']>
  chargeMode: ScalarsEnums['ServiceSuspensionChargeMode']
}

/**
 * What the pause fee will charge: each date and amount for a recurring fee (capped, with truncated set when more dates exist), one entry for a flat fee, none when there is no fee.
 */
export interface MemberPauseFeeQuote {
  __typename?: 'MemberPauseFeeQuote'
  chargeMode: ScalarsEnums['ServiceSuspensionChargeMode']
  occurrences: Array<MemberPauseDatedAmount>
  total: ScalarsEnums['String']
  truncated: ScalarsEnums['Boolean']
}

/**
 * The first charge after the pause: the next billing-grid invoice net of any credit, or, when the resume lands mid-cycle, a part-cycle charge for the days until the next billing date.
 */
export interface MemberPauseFirstInvoice {
  __typename?: 'MemberPauseFirstInvoice'
  date: ScalarsEnums['String']
  grossAmount: ScalarsEnums['String']
  isReturnStub: ScalarsEnums['Boolean']
  netAmount: ScalarsEnums['String']
}

/**
 * An add-on billed with this membership that pauses and resumes with it.
 */
export interface MemberPauseLinkedAddOn {
  __typename?: 'MemberPauseLinkedAddOn'
  amount: ScalarsEnums['String']
  cadenceAmount?: Maybe<ScalarsEnums['Float']>
  cadenceUnit?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  serviceId: ScalarsEnums['ID']
}

/**
 * Everything the app needs before the member picks dates: whether self-service pause applies to this membership, the blockers that already apply, the yearly allowance, the date rules, the reasons the operator allows, the fee and pause type the template sets, and the add-ons that pause with it. When enabled is false the other fields are null or empty and blockers says why.
 */
export interface MemberPauseOptions {
  __typename?: 'MemberPauseOptions'
  allowance?: Maybe<MemberPauseAllowance>
  blockers: Array<ScalarsEnums['MemberPauseBlocker']>
  enabled: ScalarsEnums['Boolean']
  fee?: Maybe<MemberPauseFee>
  linkedAddOns: Array<MemberPauseLinkedAddOn>
  reasonMandatory: ScalarsEnums['Boolean']
  reasons: Array<MemberPauseReason>
  rules?: Maybe<MemberPauseRules>
  suspensionType?: Maybe<ScalarsEnums['ServiceSuspensionType']>
}

/**
 * What this pause means for the member’s billing, quoted from the same engine that will create it. When blockers is not empty the money fields are zero or null and the pause cannot be confirmed.
 */
export interface MemberPausePreview {
  __typename?: 'MemberPausePreview'
  addOns: Array<MemberPauseLinkedAddOn>
  blockers: Array<ScalarsEnums['MemberPauseBlocker']>
  chargedWhilePausedTotal: ScalarsEnums['String']
  commitmentEndDate?: Maybe<MemberPauseCommitment>
  cyclesPaused?: Maybe<ScalarsEnums['Float']>
  daysPaused: ScalarsEnums['Float']
  endDate: ScalarsEnums['String']
  entryCredit?: Maybe<MemberPauseEntryCredit>
  fee?: Maybe<MemberPauseFeeQuote>
  firstInvoiceAfterResume?: Maybe<MemberPauseFirstInvoice>
  paymentsSkipped: Array<MemberPauseDatedAmount>
  resumeDate: ScalarsEnums['String']
  secondaryFeesContinueTotal?: Maybe<ScalarsEnums['String']>
  skippedTotal: ScalarsEnums['String']
  startDate: ScalarsEnums['String']
}

export interface MemberPauseReason {
  __typename?: 'MemberPauseReason'
  id: ScalarsEnums['String']
  reason: ScalarsEnums['String']
}

/**
 * The date rules the member must satisfy: the first selectable start after the notice period, whether start and resume must land on billing dates (and which dates those are, for the next thirteen months), and the shortest and longest single pause the brand allows.
 */
export interface MemberPauseRules {
  __typename?: 'MemberPauseRules'
  alignToBillingCycle: ScalarsEnums['Boolean']
  billingDates: Array<ScalarsEnums['String']>
  earliestStartDate: ScalarsEnums['String']
  maxPauseDays?: Maybe<ScalarsEnums['Float']>
  minPauseDays?: Maybe<ScalarsEnums['Float']>
}

/**
 * A form the signed-in member still has to complete at a location
 */
export interface MemberPendingForm {
  __typename?: 'MemberPendingForm'
  assignedAt: ScalarsEnums['String']
  bookingGateMode: ScalarsEnums['FormBookingGateMode']
  description?: Maybe<ScalarsEnums['String']>
  formSubmissionId: ScalarsEnums['String']
  name: ScalarsEnums['String']
  questionCount: ScalarsEnums['Float']
  requiredBefore?: Maybe<ScalarsEnums['FormRequiredBefore']>
  siteId: ScalarsEnums['String']
}

/**
 * One page of the signed-in member's outstanding forms
 */
export interface MemberPendingFormsPage {
  __typename?: 'MemberPendingFormsPage'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  items: Array<MemberPendingForm>
}

export interface MemberPreviewSessionResult {
  __typename?: 'MemberPreviewSessionResult'
  kioskToken: ScalarsEnums['String']
  memberToken: ScalarsEnums['String']
  previewKioskUserId: ScalarsEnums['String']
  previewMemberId: ScalarsEnums['String']
}

export interface MemberSiteAmenities {
  __typename?: 'MemberSiteAmenities'
  items: Array<MemberSiteAmenity>
  maxVisible: ScalarsEnums['Int']
}

/**
 * label is the custom name or the catalog default label for apps that lack the key
 */
export interface MemberSiteAmenity {
  __typename?: 'MemberSiteAmenity'
  amenityKey?: Maybe<ScalarsEnums['SiteAmenityKey']>
  customName?: Maybe<ScalarsEnums['String']>
  group: ScalarsEnums['SiteAmenityGroup']
  hasActiveAlert: ScalarsEnums['Boolean']
  icon: ScalarsEnums['SiteInfoIcon']
  id: ScalarsEnums['ID']
  label: ScalarsEnums['String']
  note?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['SiteAmenityStatus']
  todayRanges?: Maybe<Array<ResolvedOpeningRange>>
  week?: Maybe<Array<ResolvedOpeningDay>>
}

/**
 * An existing member's home site, for the X-Site-ID header.
 */
export interface MemberSiteInfo {
  __typename?: 'MemberSiteInfo'
  clientId: ScalarsEnums['String']
  email?: Maybe<ScalarsEnums['String']>
  firstName?: Maybe<ScalarsEnums['String']>
  homeSiteId?: Maybe<ScalarsEnums['String']>
  homeSiteName?: Maybe<ScalarsEnums['String']>
  lastName?: Maybe<ScalarsEnums['String']>
}

export interface MemberSiteInfoBlock {
  __typename?: 'MemberSiteInfoBlock'
  body: ScalarsEnums['String']
  icon?: Maybe<ScalarsEnums['SiteInfoBlockIcon']>
  id: ScalarsEnums['ID']
  linkLabel?: Maybe<ScalarsEnums['String']>
  linkUrl?: Maybe<ScalarsEnums['String']>
  title: ScalarsEnums['String']
}

export interface MemberStaffedHours {
  __typename?: 'MemberStaffedHours'
  label: ScalarsEnums['String']
  today: ResolvedOpeningDay
  week: Array<ResolvedOpeningDay>
}

export interface MemberVisitForecast {
  __typename?: 'MemberVisitForecast'
  days: Array<VisitForecastDay>
  hasSufficientData: ScalarsEnums['Boolean']
}

/**
 * Active member count for a single membership template
 */
export interface MembershipActiveCount {
  __typename?: 'MembershipActiveCount'
  activeCount: ScalarsEnums['Float']
  serviceTemplateId: ScalarsEnums['ID']
}

/**
 * Active member counts for a set of membership templates
 */
export interface MembershipActiveCountsResult {
  __typename?: 'MembershipActiveCountsResult'
  counts: Array<MembershipActiveCount>
}

/**
 * An active member on a membership template with credit usage
 */
export interface MembershipActiveMember {
  __typename?: 'MembershipActiveMember'
  clientId: ScalarsEnums['ID']
  creditsUsed: ScalarsEnums['Float']
  email?: Maybe<ScalarsEnums['String']>
  endDate?: Maybe<ScalarsEnums['String']>
  firstName?: Maybe<ScalarsEnums['String']>
  hasUnlimited: ScalarsEnums['Boolean']
  lastName?: Maybe<ScalarsEnums['String']>
  serviceId: ScalarsEnums['ID']
  startDate?: Maybe<ScalarsEnums['String']>
}

/**
 * Paginated list of active members on a membership template
 */
export interface MembershipActiveMembersResult {
  __typename?: 'MembershipActiveMembersResult'
  pageInfo: MembershipActiveMembersResultPageInfo
  results: Array<MembershipActiveMembersResultResults>
}

export interface MembershipActiveMembersResultPageInfo {
  __typename?: 'MembershipActiveMembersResultPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface MembershipActiveMembersResultResults {
  __typename?: 'MembershipActiveMembersResultResults'
  cursor: ScalarsEnums['String']
  row: MembershipActiveMember
}

export interface MembershipImportBlockingIssue {
  __typename?: 'MembershipImportBlockingIssue'
  code: ScalarsEnums['MembershipImportBlockingIssueCode']
  message: ScalarsEnums['String']
}

export interface MembershipImportFirstBillBeforeCardSummary {
  __typename?: 'MembershipImportFirstBillBeforeCardSummary'
  count: ScalarsEnums['Float']
  earliestFirstPaymentDate?: Maybe<ScalarsEnums['String']>
}

export interface MembershipImportInactiveSummary {
  __typename?: 'MembershipImportInactiveSummary'
  count: ScalarsEnums['Float']
  earliestStartDate?: Maybe<ScalarsEnums['String']>
}

export interface MembershipImportSummary {
  __typename?: 'MembershipImportSummary'
  blockingIssues: Array<MembershipImportBlockingIssue>
  computedAt: ScalarsEnums['String']
  firstBillBeforeCard: MembershipImportFirstBillBeforeCardSummary
  inactive: MembershipImportInactiveSummary
  totalRows: ScalarsEnums['Float']
}

/**
 * A client who bought a membership or package template, with ledger credit usage
 */
export interface MembershipMember {
  __typename?: 'MembershipMember'
  clientId: ScalarsEnums['ID']
  creditsPurchased: ScalarsEnums['Float']
  creditsUnused?: Maybe<ScalarsEnums['Float']>
  creditsUsed: ScalarsEnums['Float']
  email?: Maybe<ScalarsEnums['String']>
  endDate?: Maybe<ScalarsEnums['String']>
  firstName?: Maybe<ScalarsEnums['String']>
  hasUnlimited: ScalarsEnums['Boolean']
  lastName?: Maybe<ScalarsEnums['String']>
  purchaseDate?: Maybe<ScalarsEnums['String']>
  serviceId: ScalarsEnums['ID']
  startDate?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['ServiceStatus']
}

/**
 * Buyer counts of a membership or package template per status tab
 */
export interface MembershipMemberStatusCounts {
  __typename?: 'MembershipMemberStatusCounts'
  active: ScalarsEnums['Float']
  expired: ScalarsEnums['Float']
  total: ScalarsEnums['Float']
}

/**
 * Paginated buyers of a membership or package template, filtered by status
 */
export interface MembershipMembersResult {
  __typename?: 'MembershipMembersResult'
  pageInfo: MembershipMembersResultPageInfo
  results: Array<MembershipMembersResultResults>
}

export interface MembershipMembersResultPageInfo {
  __typename?: 'MembershipMembersResultPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface MembershipMembersResultResults {
  __typename?: 'MembershipMembersResultResults'
  cursor: ScalarsEnums['String']
  row: MembershipMember
}

export interface MembershipStatusCount {
  __typename?: 'MembershipStatusCount'
  count: ScalarsEnums['Float']
  status: ScalarsEnums['String']
}

/**
 * Count of records affected for a specific entity type at a specific site
 */
export interface MergeAffectedRecord {
  __typename?: 'MergeAffectedRecord'
  count: ScalarsEnums['Float']
  entityType: ScalarsEnums['String']
  siteId: ScalarsEnums['String']
}

/**
 * Information about a site affected by a merge
 */
export interface MergeAffectedSite {
  __typename?: 'MergeAffectedSite'
  siteId: ScalarsEnums['String']
  siteName: ScalarsEnums['String']
  sourceHasData: ScalarsEnums['Boolean']
  targetHasData: ScalarsEnums['Boolean']
  willCreateClientSite: ScalarsEnums['Boolean']
}

/**
 * Preview of what a client merge operation will do
 */
export interface MergeClientsPreview {
  __typename?: 'MergeClientsPreview'
  affectedSites: Array<MergeAffectedSite>
  customPropertyConflicts: Array<MergeCustomPropertyConflict>
  mergeScope: ScalarsEnums['MergeScope']
  profileConflicts: Array<MergeProfileConflict>
  recordCounts: Array<MergeRecordCount>
  sourceClient: ClientProfileSnapshot
  targetClient: ClientProfileSnapshot
  totalRecordsToMove: ScalarsEnums['Float']
  warnings: Array<ScalarsEnums['String']>
}

/**
 * Result of a client merge operation
 */
export interface MergeClientsResult {
  __typename?: 'MergeClientsResult'
  affectedRecords: Array<MergeAffectedRecord>
  mergeLogId: ScalarsEnums['String']
  success: ScalarsEnums['Boolean']
  targetClientId: ScalarsEnums['String']
  totalRecordsMoved: ScalarsEnums['Float']
  warnings: Array<ScalarsEnums['String']>
}

/**
 * A custom property value conflict between source and target clients
 */
export interface MergeCustomPropertyConflict {
  __typename?: 'MergeCustomPropertyConflict'
  propertyName: ScalarsEnums['String']
  siteCustomPropertyId: ScalarsEnums['String']
  siteId: ScalarsEnums['String']
  sourceValue?: Maybe<ScalarsEnums['String']>
  targetValue?: Maybe<ScalarsEnums['String']>
}

/**
 * A profile field conflict between source and target clients
 */
export interface MergeProfileConflict {
  __typename?: 'MergeProfileConflict'
  field: ScalarsEnums['String']
  hasConflict: ScalarsEnums['Boolean']
  sourceValue?: Maybe<ScalarsEnums['String']>
  targetValue?: Maybe<ScalarsEnums['String']>
}

/**
 * Count of records for a specific entity type at a specific site
 */
export interface MergeRecordCount {
  __typename?: 'MergeRecordCount'
  count: ScalarsEnums['Float']
  entityType: ScalarsEnums['String']
  siteId: ScalarsEnums['String']
}

/**
 * Information about a merged client, used to show a redirect banner on the source client profile
 */
export interface MergedClientInfo {
  __typename?: 'MergedClientInfo'
  isMerged: ScalarsEnums['Boolean']
  mergedAt?: Maybe<ScalarsEnums['String']>
  sourceClientId: ScalarsEnums['String']
  targetClientId?: Maybe<ScalarsEnums['String']>
  targetClientName?: Maybe<ScalarsEnums['String']>
}

/**
 * Summary of performance metric tracking activity
 */
export interface MetricTrackingSummary {
  __typename?: 'MetricTrackingSummary'
  avgEntriesPerTracker: ScalarsEnums['Float']
  personalBestsSet: ScalarsEnums['Float']
  totalMetricEntries: ScalarsEnums['Float']
  uniqueTrackers: ScalarsEnums['Float']
}

export interface MigrationSessions {
  __typename?: 'MigrationSessions'
  sessions: Array<ImportSession>
}

export interface Migrations {
  __typename?: 'Migrations'
  migrations: Array<MigrationsMigrations>
}

export interface MigrationsMigrations {
  __typename?: 'MigrationsMigrations'
  completedAt?: Maybe<ScalarsEnums['String']>
  migrationId: ScalarsEnums['ID']
  migrationName?: Maybe<ScalarsEnums['String']>
  sessionCount: ScalarsEnums['Float']
  siteId?: Maybe<ScalarsEnums['String']>
  sourceSystem?: Maybe<ScalarsEnums['String']>
  startedAt: ScalarsEnums['String']
  statuses: Array<ScalarsEnums['String']>
  targetEnvironment?: Maybe<ScalarsEnums['String']>
}

/**
 * The permissions of a policy that the caller does not hold at one location or location group
 */
export interface MissingPermissions {
  __typename?: 'MissingPermissions'
  accessPermissions: Array<ScalarsEnums['AccessPermissions']>
  corporatePermissions: Array<ScalarsEnums['CorporatePermissions']>
  sitePermissions: Array<ScalarsEnums['SitePermissions']>
}

export interface MobileAppBranding {
  __typename?: 'MobileAppBranding'
  accentColor?: Maybe<ScalarsEnums['String']>
  appIconUrl?: Maybe<ScalarsEnums['String']>
  backgroundColor?: Maybe<ScalarsEnums['String']>
  corporateId: ScalarsEnums['String']
  faviconUrl?: Maybe<ScalarsEnums['String']>
  fontConfig?: Maybe<ScalarsEnums['JSONObject']>
  fontFamily?: Maybe<ScalarsEnums['String']>
  logoUrl?: Maybe<ScalarsEnums['String']>
  modulesConfig?: Maybe<ScalarsEnums['JSONObject']>
  primaryColor?: Maybe<ScalarsEnums['String']>
  secondaryColor?: Maybe<ScalarsEnums['String']>
  splashScreenDarkUrl?: Maybe<ScalarsEnums['String']>
  splashScreenUrl?: Maybe<ScalarsEnums['String']>
  textColor?: Maybe<ScalarsEnums['String']>
}

export interface MobileAppBuildOverview {
  __typename?: 'MobileAppBuildOverview'
  changes: Array<MobileAppBuildOverviewChanges>
  states: Array<MobileAppBuildOverviewStates>
}

export interface MobileAppBuildOverviewChanges {
  __typename?: 'MobileAppBuildOverviewChanges'
  brandId: ScalarsEnums['String']
  changeId: ScalarsEnums['String']
  changedFields: Array<ScalarsEnums['MobileAppChangeField']>
  createdAt: ScalarsEnums['String']
  createdBy?: Maybe<ScalarsEnums['String']>
  impact: ScalarsEnums['MobileAppChangeImpact']
  platforms: Array<ScalarsEnums['BrandPlatform']>
  revision: ScalarsEnums['Float']
}

export interface MobileAppBuildOverviewStates {
  __typename?: 'MobileAppBuildOverviewStates'
  brandId: ScalarsEnums['String']
  currentNativeRevision: ScalarsEnums['Float']
  lastBuiltRevision: ScalarsEnums['Float']
  lastReleasedRevision: ScalarsEnums['Float']
  lastSubmittedRevision: ScalarsEnums['Float']
  latestReleaseId?: Maybe<ScalarsEnums['String']>
  platform: ScalarsEnums['BrandPlatform']
  updatedAt: ScalarsEnums['String']
}

export interface MobileAppChannels {
  __typename?: 'MobileAppChannels'
  androidConfig?: Maybe<ScalarsEnums['JSONObject']>
  androidEnabled: ScalarsEnums['Boolean']
  androidLastBuiltFontVersion?: Maybe<ScalarsEnums['Float']>
  androidMinVersion?: Maybe<ScalarsEnums['String']>
  androidPackageName?: Maybe<ScalarsEnums['String']>
  androidPlayStoreUrl?: Maybe<ScalarsEnums['String']>
  androidVersion?: Maybe<ScalarsEnums['String']>
  channels?: Maybe<ScalarsEnums['JSONObject']>
  corporateId: ScalarsEnums['String']
  deployment?: Maybe<ScalarsEnums['JSONObject']>
  deploymentStatus?: Maybe<ScalarsEnums['String']>
  iosAppStoreUrl?: Maybe<ScalarsEnums['String']>
  iosBundleId?: Maybe<ScalarsEnums['String']>
  iosConfig?: Maybe<ScalarsEnums['JSONObject']>
  iosEnabled: ScalarsEnums['Boolean']
  iosLastBuiltFontVersion?: Maybe<ScalarsEnums['Float']>
  iosMinVersion?: Maybe<ScalarsEnums['String']>
  iosVersion?: Maybe<ScalarsEnums['String']>
  lastDeployedAt?: Maybe<ScalarsEnums['String']>
}

/**
 * Mobile app configuration metadata
 */
export interface MobileAppMetadata {
  __typename?: 'MobileAppMetadata'
  appName: ScalarsEnums['String']
  brandId: ScalarsEnums['String']
  id: ScalarsEnums['String']
  lastUpdated: ScalarsEnums['String']
  version: ScalarsEnums['String']
}

export interface MobileAppProfile {
  __typename?: 'MobileAppProfile'
  address?: Maybe<ScalarsEnums['String']>
  appDescription?: Maybe<ScalarsEnums['String']>
  appName: ScalarsEnums['String']
  appShortDescription?: Maybe<ScalarsEnums['String']>
  branchIoKey?: Maybe<ScalarsEnums['String']>
  branchIoLiveKey?: Maybe<ScalarsEnums['String']>
  branchIoSecret?: Maybe<ScalarsEnums['String']>
  businessName?: Maybe<ScalarsEnums['String']>
  contentfulAccessToken?: Maybe<ScalarsEnums['String']>
  contentfulPreviewToken?: Maybe<ScalarsEnums['String']>
  contentfulSpaceId?: Maybe<ScalarsEnums['String']>
  corporateId: ScalarsEnums['String']
  description?: Maybe<ScalarsEnums['String']>
  distributionCountries?: Maybe<Array<ScalarsEnums['String']>>
  email?: Maybe<ScalarsEnums['String']>
  evoltApiKey?: Maybe<ScalarsEnums['String']>
  facebookUrl?: Maybe<ScalarsEnums['String']>
  instagramUrl?: Maybe<ScalarsEnums['String']>
  jwPlayerApiKey?: Maybe<ScalarsEnums['String']>
  linkedinUrl?: Maybe<ScalarsEnums['String']>
  oneSignalApiKey?: Maybe<ScalarsEnums['String']>
  oneSignalAppId?: Maybe<ScalarsEnums['String']>
  phone?: Maybe<ScalarsEnums['String']>
  privacyPolicyUrl?: Maybe<ScalarsEnums['String']>
  socialLinks?: Maybe<ScalarsEnums['JSONObject']>
  supportEmail?: Maybe<ScalarsEnums['String']>
  supportUrl?: Maybe<ScalarsEnums['String']>
  tagline?: Maybe<ScalarsEnums['String']>
  termsAndConditionsUrl?: Maybe<ScalarsEnums['String']>
  twitterUrl?: Maybe<ScalarsEnums['String']>
  website?: Maybe<ScalarsEnums['String']>
  youtubeUrl?: Maybe<ScalarsEnums['String']>
}

/**
 * Mobile app setup progress tracking
 */
export interface MobileAppProgress {
  __typename?: 'MobileAppProgress'
  activeTabsInSteps: MobileAppProgressActiveTabsInSteps
  channelsCompleted: ScalarsEnums['Boolean']
  completedSteps: Array<ScalarsEnums['Float']>
  currentStep: ScalarsEnums['Float']
  customizationCompleted: ScalarsEnums['Boolean']
  deploymentCompleted: ScalarsEnums['Boolean']
  profileCompleted: ScalarsEnums['Boolean']
}

export interface MobileAppProgressActiveTabsInSteps {
  __typename?: 'MobileAppProgressActiveTabsInSteps'
  channels?: Maybe<ScalarsEnums['Float']>
  customization?: Maybe<ScalarsEnums['Float']>
  profile?: Maybe<ScalarsEnums['Float']>
  step1?: Maybe<ScalarsEnums['Float']>
  step2?: Maybe<ScalarsEnums['Float']>
  step3?: Maybe<ScalarsEnums['Float']>
}

/**
 * Complete mobile app channels configuration
 */
export interface MobileChannelsComplete {
  __typename?: 'MobileChannelsComplete'
  analytics: MobileChannelsCompleteAnalytics
  android: MobileChannelsCompleteAndroid
  deepLink: MobileChannelsCompleteDeepLink
  ios: MobileChannelsCompleteIos
}

export interface MobileChannelsCompleteAnalytics {
  __typename?: 'MobileChannelsCompleteAnalytics'
  customEvents?: Maybe<MobileChannelsCompleteAnalyticsCustomEvents>
  enabled: ScalarsEnums['Boolean']
  onesignal?: Maybe<ScalarsEnums['String']>
  trackingId?: Maybe<ScalarsEnums['String']>
}

export interface MobileChannelsCompleteAnalyticsCustomEvents {
  __typename?: 'MobileChannelsCompleteAnalyticsCustomEvents'
  purchaseComplete?: Maybe<ScalarsEnums['String']>
  sessionStart?: Maybe<ScalarsEnums['String']>
  userLogin?: Maybe<ScalarsEnums['String']>
  userRegistration?: Maybe<ScalarsEnums['String']>
}

export interface MobileChannelsCompleteAndroid {
  __typename?: 'MobileChannelsCompleteAndroid'
  certificates: Array<MobileChannelsCompleteAndroidCertificates>
  enabled: ScalarsEnums['Boolean']
  googlePlayId?: Maybe<ScalarsEnums['String']>
  packageName: ScalarsEnums['String']
  status: ScalarsEnums['String']
}

export interface MobileChannelsCompleteAndroidCertificates {
  __typename?: 'MobileChannelsCompleteAndroidCertificates'
  expiryDate: ScalarsEnums['String']
  id: ScalarsEnums['String']
  platform: ScalarsEnums['String']
  status: ScalarsEnums['String']
  type: ScalarsEnums['String']
}

export interface MobileChannelsCompleteDeepLink {
  __typename?: 'MobileChannelsCompleteDeepLink'
  domains: Array<ScalarsEnums['String']>
  scheme: ScalarsEnums['String']
  universalLink: ScalarsEnums['String']
}

export interface MobileChannelsCompleteIos {
  __typename?: 'MobileChannelsCompleteIos'
  appStoreId?: Maybe<ScalarsEnums['String']>
  bundleId: ScalarsEnums['String']
  certificates: Array<MobileChannelsCompleteIosCertificates>
  enabled: ScalarsEnums['Boolean']
  status: ScalarsEnums['String']
  teamId?: Maybe<ScalarsEnums['String']>
}

export interface MobileChannelsCompleteIosCertificates {
  __typename?: 'MobileChannelsCompleteIosCertificates'
  expiryDate: ScalarsEnums['String']
  id: ScalarsEnums['String']
  platform: ScalarsEnums['String']
  status: ScalarsEnums['String']
  type: ScalarsEnums['String']
}

/**
 * Complete mobile app customization configuration
 */
export interface MobileCustomizationComplete {
  __typename?: 'MobileCustomizationComplete'
  advancedFeatures: MobileCustomizationCompleteAdvancedFeatures
  branding: MobileCustomizationCompleteBranding
  colors: MobileCustomizationCompleteColors
  coreFeatures: MobileCustomizationCompleteCoreFeatures
  fonts: MobileCustomizationCompleteFonts
  sessionFilters: MobileCustomizationCompleteSessionFilters
  theme: MobileCustomizationCompleteTheme
}

export interface MobileCustomizationCompleteAdvancedFeatures {
  __typename?: 'MobileCustomizationCompleteAdvancedFeatures'
  barcodeEnabled: ScalarsEnums['Boolean']
  callUsEnabled: ScalarsEnums['Boolean']
  challenge: ScalarsEnums['Boolean']
  contactlessCheckin: ScalarsEnums['Boolean']
  darkMode: MobileCustomizationCompleteAdvancedFeaturesDarkMode
  darkModeSupport: ScalarsEnums['Boolean']
  displayInstructor: ScalarsEnums['Boolean']
  editFieldsEnable: ScalarsEnums['Boolean']
  evoltIntegrationEnabled: ScalarsEnums['Boolean']
  filterTimeAvailable: ScalarsEnums['Boolean']
  isAnyAvailable: ScalarsEnums['Boolean']
  isDynamicImages: ScalarsEnums['Boolean']
  isSquareButton: ScalarsEnums['Boolean']
  newsFeedAvailable: ScalarsEnums['Boolean']
  profilePhoto: ScalarsEnums['Boolean']
  sessionDisplay: ScalarsEnums['SessionDisplayType']
  showBilling: ScalarsEnums['Boolean']
  shownCommPref: ScalarsEnums['Boolean']
  statsAvailable: ScalarsEnums['Boolean']
}

export interface MobileCustomizationCompleteAdvancedFeaturesDarkMode {
  __typename?: 'MobileCustomizationCompleteAdvancedFeaturesDarkMode'
  adjustmentStrategy: ScalarsEnums['DarkModeStrategy']
  auto: ScalarsEnums['Boolean']
  overrides?: Maybe<MobileCustomizationCompleteAdvancedFeaturesDarkModeOverrides>
}

export interface MobileCustomizationCompleteAdvancedFeaturesDarkModeOverrides {
  __typename?: 'MobileCustomizationCompleteAdvancedFeaturesDarkModeOverrides'
  background?: Maybe<ScalarsEnums['String']>
  primary?: Maybe<ScalarsEnums['String']>
  secondary?: Maybe<ScalarsEnums['String']>
  surface?: Maybe<ScalarsEnums['String']>
}

export interface MobileCustomizationCompleteBranding {
  __typename?: 'MobileCustomizationCompleteBranding'
  appIcon?: Maybe<ScalarsEnums['String']>
  loginBackground?: Maybe<ScalarsEnums['String']>
  logo?: Maybe<ScalarsEnums['String']>
  splashScreen?: Maybe<ScalarsEnums['String']>
}

export interface MobileCustomizationCompleteColors {
  __typename?: 'MobileCustomizationCompleteColors'
  accent?: Maybe<ScalarsEnums['String']>
  background?: Maybe<ScalarsEnums['String']>
  error?: Maybe<ScalarsEnums['String']>
  info?: Maybe<ScalarsEnums['String']>
  primary: ScalarsEnums['String']
  secondary: ScalarsEnums['String']
  success?: Maybe<ScalarsEnums['String']>
  surface?: Maybe<ScalarsEnums['String']>
  text?: Maybe<ScalarsEnums['String']>
  textSecondary?: Maybe<ScalarsEnums['String']>
  warning?: Maybe<ScalarsEnums['String']>
}

export interface MobileCustomizationCompleteCoreFeatures {
  __typename?: 'MobileCustomizationCompleteCoreFeatures'
  digital: ScalarsEnums['Boolean']
  explore: ScalarsEnums['Boolean']
  purchase: ScalarsEnums['Boolean']
  schedule: ScalarsEnums['Boolean']
  workouts: ScalarsEnums['Boolean']
}

export interface MobileCustomizationCompleteFonts {
  __typename?: 'MobileCustomizationCompleteFonts'
  defaultLanguage: ScalarsEnums['MobileSupportedLanguage']
  languageFonts?: Maybe<MobileCustomizationCompleteFontsLanguageFonts>
  supportedLanguages: Array<ScalarsEnums['MobileSupportedLanguage']>
}

export interface MobileCustomizationCompleteFontsLanguageFonts {
  __typename?: 'MobileCustomizationCompleteFontsLanguageFonts'
  EN?: Maybe<MobileCustomizationCompleteFontsLanguageFontsEN>
  ES?: Maybe<MobileCustomizationCompleteFontsLanguageFontsEN>
}

export interface MobileCustomizationCompleteFontsLanguageFontsEN {
  __typename?: 'MobileCustomizationCompleteFontsLanguageFontsEN'
  customFonts: Array<ScalarsEnums['String']>
  fontFamily: ScalarsEnums['String']
  language: ScalarsEnums['MobileSupportedLanguage']
  letterSpacing?: Maybe<MobileCustomizationCompleteFontsLanguageFontsENLetterSpacing>
  lineHeight?: Maybe<MobileCustomizationCompleteFontsLanguageFontsENLineHeight>
  sizes: MobileCustomizationCompleteFontsLanguageFontsENSizes
}

export interface MobileCustomizationCompleteFontsLanguageFontsENLetterSpacing {
  __typename?: 'MobileCustomizationCompleteFontsLanguageFontsENLetterSpacing'
  normal: ScalarsEnums['Float']
  tight: ScalarsEnums['Float']
  wide: ScalarsEnums['Float']
}

export interface MobileCustomizationCompleteFontsLanguageFontsENLineHeight {
  __typename?: 'MobileCustomizationCompleteFontsLanguageFontsENLineHeight'
  lg: ScalarsEnums['Float']
  md: ScalarsEnums['Float']
  sm: ScalarsEnums['Float']
  xl: ScalarsEnums['Float']
  xs: ScalarsEnums['Float']
  xxl: ScalarsEnums['Float']
}

export interface MobileCustomizationCompleteFontsLanguageFontsENSizes {
  __typename?: 'MobileCustomizationCompleteFontsLanguageFontsENSizes'
  lg: ScalarsEnums['Float']
  md: ScalarsEnums['Float']
  sm: ScalarsEnums['Float']
  xl: ScalarsEnums['Float']
  xs: ScalarsEnums['Float']
  xxl: ScalarsEnums['Float']
}

export interface MobileCustomizationCompleteSessionFilters {
  __typename?: 'MobileCustomizationCompleteSessionFilters'
  category: ScalarsEnums['Boolean']
  duration: ScalarsEnums['Boolean']
  instructors: ScalarsEnums['Boolean']
  room: ScalarsEnums['Boolean']
  sessionTemplate: ScalarsEnums['Boolean']
  sessionTime: ScalarsEnums['Boolean']
}

export interface MobileCustomizationCompleteTheme {
  __typename?: 'MobileCustomizationCompleteTheme'
  borderRadius: MobileCustomizationCompleteThemeBorderRadius
  spacing: MobileCustomizationCompleteThemeSpacing
}

export interface MobileCustomizationCompleteThemeBorderRadius {
  __typename?: 'MobileCustomizationCompleteThemeBorderRadius'
  lg: ScalarsEnums['Float']
  md: ScalarsEnums['Float']
  sm: ScalarsEnums['Float']
  xl: ScalarsEnums['Float']
}

export interface MobileCustomizationCompleteThemeSpacing {
  __typename?: 'MobileCustomizationCompleteThemeSpacing'
  lg: ScalarsEnums['Float']
  md: ScalarsEnums['Float']
  sm: ScalarsEnums['Float']
  xl: ScalarsEnums['Float']
  xs: ScalarsEnums['Float']
  xxl: ScalarsEnums['Float']
}

/**
 * Failed payment for mobile
 */
export interface MobileFailedPayment {
  __typename?: 'MobileFailedPayment'
  invoiceID: ScalarsEnums['String']
  paymentAmount: ScalarsEnums['Float']
  paymentDate: ScalarsEnums['String']
  paymentDescription: ScalarsEnums['String']
  paymentMethod: MobileFailedPaymentMethod
  siteID: ScalarsEnums['String']
  siteName: ScalarsEnums['String']
}

/**
 * Payment method for mobile failed payment
 */
export interface MobileFailedPaymentMethod {
  __typename?: 'MobileFailedPaymentMethod'
  dbPaymentMethodID: ScalarsEnums['String']
  paymentMethodExpiry: ScalarsEnums['String']
  paymentMethodLast4: ScalarsEnums['String']
  paymentMethodType: ScalarsEnums['String']
}

/**
 * Intro offer for mobile
 */
export interface MobileIntroOffer {
  __typename?: 'MobileIntroOffer'
  packageCategory: ScalarsEnums['String']
  packageDescription: ScalarsEnums['String']
  packageID: ScalarsEnums['String']
  packageName: ScalarsEnums['String']
  packagePrice: ScalarsEnums['Float']
}

/**
 * Outstanding payment for mobile
 */
export interface MobileOutstandingPayment {
  __typename?: 'MobileOutstandingPayment'
  paymentAmount: ScalarsEnums['Float']
  paymentDate: ScalarsEnums['String']
  paymentDescription: ScalarsEnums['String']
  paymentID: ScalarsEnums['String']
  paymentType: ScalarsEnums['String']
  siteID: ScalarsEnums['String']
  siteName: ScalarsEnums['String']
}

/**
 * Pending policy for mobile
 */
export interface MobilePendingPolicy {
  __typename?: 'MobilePendingPolicy'
  policyID: ScalarsEnums['String']
  policyName: ScalarsEnums['String']
  siteID?: Maybe<ScalarsEnums['String']>
  siteName?: Maybe<ScalarsEnums['String']>
}

/**
 * Mobile app profile data for reading (all fields optional for progressive setup)
 */
export interface MobileProfileRead {
  __typename?: 'MobileProfileRead'
  appDescription?: Maybe<ScalarsEnums['String']>
  appName?: Maybe<ScalarsEnums['String']>
  brandId?: Maybe<ScalarsEnums['String']>
  businessName?: Maybe<ScalarsEnums['String']>
  email?: Maybe<ScalarsEnums['String']>
  evoltApiKey?: Maybe<ScalarsEnums['String']>
  facebookUrl?: Maybe<ScalarsEnums['String']>
  firstName?: Maybe<ScalarsEnums['String']>
  instagramHandle?: Maybe<ScalarsEnums['String']>
  lastName?: Maybe<ScalarsEnums['String']>
  localization?: Maybe<MobileProfileReadLocalization>
  phone?: Maybe<ScalarsEnums['String']>
  privacyUrl?: Maybe<ScalarsEnums['String']>
  supportEmail?: Maybe<ScalarsEnums['String']>
  supportPhone?: Maybe<ScalarsEnums['String']>
  termsUrl?: Maybe<ScalarsEnums['String']>
  tiktokHandle?: Maybe<ScalarsEnums['String']>
  twitterUrl?: Maybe<ScalarsEnums['String']>
  website?: Maybe<ScalarsEnums['String']>
  youtubeUrl?: Maybe<ScalarsEnums['String']>
}

export interface MobileProfileReadLocalization {
  __typename?: 'MobileProfileReadLocalization'
  customStrings?: Maybe<MobileProfileReadLocalizationCustomStrings>
  defaultLanguage: ScalarsEnums['String']
  fallbackLanguage: ScalarsEnums['String']
  rtlLanguages?: Maybe<Array<ScalarsEnums['String']>>
  supportedLanguages: Array<ScalarsEnums['String']>
}

export interface MobileProfileReadLocalizationCustomStrings {
  __typename?: 'MobileProfileReadLocalizationCustomStrings'
  login?: Maybe<ScalarsEnums['String']>
  logout?: Maybe<ScalarsEnums['String']>
  profile?: Maybe<ScalarsEnums['String']>
  settings?: Maybe<ScalarsEnums['String']>
  welcome?: Maybe<ScalarsEnums['String']>
}

/**
 * Validation errors for mobile setup operations
 */
export interface MobileSetupErrors {
  __typename?: 'MobileSetupErrors'
  channels?: Maybe<Array<ScalarsEnums['String']>>
  customization?: Maybe<Array<ScalarsEnums['String']>>
  general?: Maybe<Array<ScalarsEnums['String']>>
  profile?: Maybe<Array<ScalarsEnums['String']>>
}

/**
 * Response for mobile setup API operations
 */
export interface MobileSetupResponse {
  __typename?: 'MobileSetupResponse'
  data?: Maybe<MobileSetupResponseData>
  errors?: Maybe<MobileSetupErrors>
  message: ScalarsEnums['String']
  success: ScalarsEnums['Boolean']
}

export interface MobileSetupResponseData {
  __typename?: 'MobileSetupResponseData'
  appConfig: MobileAppMetadata
  channels?: Maybe<MobileChannelsComplete>
  customization?: Maybe<MobileCustomizationComplete>
  profile?: Maybe<MobileProfileRead>
  progress: MobileAppProgress
  themes?: Maybe<ScalarsEnums['JSONObject']>
}

export interface ModifySuspensionEndDate {
  __typename?: 'ModifySuspensionEndDate'
  canceledFeeInvoiceIds: Array<ScalarsEnums['String']>
  cyclesAdjusted: ScalarsEnums['Float']
}

/**
 * Day with sessions and total count for month view
 */
export interface MonthViewDay {
  __typename?: 'MonthViewDay'
  date: ScalarsEnums['String']
  sessions: Array<MonthViewSession>
  totalCount: ScalarsEnums['Float']
}

/**
 * Minimal session data for month view display
 */
export interface MonthViewSession {
  __typename?: 'MonthViewSession'
  bookedCount?: Maybe<ScalarsEnums['Float']>
  color?: Maybe<ScalarsEnums['String']>
  instructor?: Maybe<Array<CalendarSessionInstructor>>
  isBlockSlot: ScalarsEnums['Boolean']
  isFullyPaid: ScalarsEnums['Boolean']
  isPublishedToWellhub: ScalarsEnums['Boolean']
  name: ScalarsEnums['String']
  sessionId: ScalarsEnums['String']
  size: ScalarsEnums['Float']
  startTime: ScalarsEnums['String']
  status?: Maybe<ScalarsEnums['SessionStatus']>
}

/**
 * Monthly attendance count for a specific month
 */
export interface MonthlyAttendance {
  __typename?: 'MonthlyAttendance'
  count: ScalarsEnums['Float']
  month: ScalarsEnums['String']
}

/**
 * Results of multiple reservation booking operation with per-session, per-client outcomes
 */
export interface MultipleReservationResult {
  __typename?: 'MultipleReservationResult'
  results: Array<SessionBookingResult>
  totalFailed: ScalarsEnums['Float']
  totalRequested: ScalarsEnums['Float']
  totalSucceeded: ScalarsEnums['Float']
  totalWaitlisted: ScalarsEnums['Float']
}

export interface MyCommission {
  __typename?: 'MyCommission'
  commissionPeriodId: ScalarsEnums['ID']
  label: ScalarsEnums['String']
  lines: Array<CommissionLine>
  status: ScalarsEnums['String']
  total: ScalarsEnums['String']
}

/**
 * How the signed-in instructor receives cover offers
 */
export interface MyCoverPreferences {
  __typename?: 'MyCoverPreferences'
  emailOffersEnabled: ScalarsEnums['Boolean']
  hasPhone: ScalarsEnums['Boolean']
  smsOptIn: ScalarsEnums['Boolean']
  smsOptInAt?: Maybe<ScalarsEnums['String']>
  smsOptOutAt?: Maybe<ScalarsEnums['String']>
}

/**
 * A short-lived hosted-page link the app opens in its in-app browser
 */
export interface MyPendingItemsLink {
  __typename?: 'MyPendingItemsLink'
  expiresAt: ScalarsEnums['String']
  handoffId: ScalarsEnums['ID']
  url: ScalarsEnums['String']
}

/**
 * The member or one dependant, with the policies outstanding for them
 */
export interface MyPendingPerson {
  __typename?: 'MyPendingPerson'
  clientId: ScalarsEnums['ID']
  firstName?: Maybe<ScalarsEnums['String']>
  items: Array<MyPendingPolicyItem>
  lastName?: Maybe<ScalarsEnums['String']>
  relationship: ScalarsEnums['MyPendingRelationship']
}

/**
 * Outstanding policies for the signed-in member and their dependants at a location
 */
export interface MyPendingPolicies {
  __typename?: 'MyPendingPolicies'
  blockingCount: ScalarsEnums['Float']
  people: Array<MyPendingPerson>
  siteId: ScalarsEnums['ID']
  totalCount: ScalarsEnums['Float']
}

/**
 * One policy the signed-in member, or a dependant, still has to accept or sign
 */
export interface MyPendingPolicyItem {
  __typename?: 'MyPendingPolicyItem'
  acceptanceMethod: ScalarsEnums['PolicyAcceptanceMethod']
  /**
   * Blocks equipment use now, rather than a renewal coming due
   */
  blocking: ScalarsEnums['Boolean']
  /**
   * Policy HTML, shown with a native checkbox
   */
  content?: Maybe<ScalarsEnums['String']>
  /**
   * Site-local date a renewal falls due
   */
  dueOn?: Maybe<ScalarsEnums['String']>
  itemKey: ScalarsEnums['String']
  /**
   * The app or widget may accept this with a tick; otherwise open the hosted page
   */
  nativeAccept: ScalarsEnums['Boolean']
  policyRevisionId: ScalarsEnums['ID']
  requiredForEquipment: ScalarsEnums['Boolean']
  /**
   * Hash of the revision shown; send it back when accepting
   */
  revisionSha256: ScalarsEnums['String']
  signerCapacity: ScalarsEnums['SignerCapacity']
  sitePolicyId: ScalarsEnums['ID']
  title: ScalarsEnums['String']
}

/**
 * One policy a native accept refused, and why
 */
export interface MyPolicyRefusal {
  __typename?: 'MyPolicyRefusal'
  code: ScalarsEnums['MyPolicyRefusalCode']
  itemKey: ScalarsEnums['String']
}

/**
 * A credit-based package shared with the authenticated member
 */
export interface MySharedPackage {
  __typename?: 'MySharedPackage'
  allocatedCredits?: Maybe<ScalarsEnums['Float']>
  consumedCredits: ScalarsEnums['Float']
  maxSharingCredits?: Maybe<ScalarsEnums['Float']>
  ownerClientId: ScalarsEnums['ID']
  ownerFirstName?: Maybe<ScalarsEnums['String']>
  ownerLastName?: Maybe<ScalarsEnums['String']>
  packageConsumedCredits: ScalarsEnums['Float']
  remainingCredits?: Maybe<ScalarsEnums['Float']>
  serviceId: ScalarsEnums['ID']
  sharedOn?: Maybe<ScalarsEnums['String']>
}

export interface NLPAnalysis {
  __typename?: 'NLPAnalysis'
  confidence: ScalarsEnums['Float']
  entities: Array<Entity>
  intent: ScalarsEnums['String']
  keywords: Array<ScalarsEnums['String']>
  language: ScalarsEnums['String']
  sentiment: Sentiment
  topics: Array<ScalarsEnums['String']>
}

/**
 * Future booking for mobile with full field parity
 */
export interface NextBooking {
  __typename?: 'NextBooking'
  bookingID: ScalarsEnums['String']
  bookingStatus: ScalarsEnums['String']
  casualRate: ScalarsEnums['Float']
  checkinStatus: ScalarsEnums['Boolean']
  creditsRequired: ScalarsEnums['Float']
  digitalLocation: ScalarsEnums['Boolean']
  duration: ScalarsEnums['String']
  endTime: ScalarsEnums['String']
  instructorData: Array<InstructorListInfo>
  instructorName: ScalarsEnums['String']
  mediaType: ScalarsEnums['String']
  paymentPending: ScalarsEnums['Boolean']
  roomName: ScalarsEnums['String']
  sessionDate: ScalarsEnums['String']
  sessionID: ScalarsEnums['String']
  sessionImage: ScalarsEnums['String']
  sessionLocationType: ScalarsEnums['String']
  sessionName: ScalarsEnums['String']
  siteID: ScalarsEnums['String']
  siteName: ScalarsEnums['String']
  spotID: ScalarsEnums['Float']
  spotName: ScalarsEnums['String']
  startTime: ScalarsEnums['String']
  timezone: ScalarsEnums['String']
  waitlistNumber: ScalarsEnums['Float']
  zoomJoinURL?: Maybe<ScalarsEnums['String']>
}

/**
 * Site-local date and time the location next opens
 */
export interface NextOpening {
  __typename?: 'NextOpening'
  date: ScalarsEnums['String']
  daysFromToday: ScalarsEnums['Int']
  time: ScalarsEnums['String']
}

export interface OnboardingChecklistItem {
  __typename?: 'OnboardingChecklistItem'
  category: ScalarsEnums['OnboardingCategory']
  checklistId: ScalarsEnums['ID']
  completedAt?: Maybe<ScalarsEnums['String']>
  completedByUserId?: Maybe<ScalarsEnums['ID']>
  corporateId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  isCompleted: ScalarsEnums['Boolean']
  metadata?: Maybe<ScalarsEnums['JSONObject']>
  sortOrder: ScalarsEnums['Float']
  stepDescription?: Maybe<ScalarsEnums['String']>
  stepKey: ScalarsEnums['OnboardingStepKey']
  stepLabel: ScalarsEnums['String']
  updatedAt?: Maybe<ScalarsEnums['String']>
}

/**
 * A generated Stripe onboarding link
 */
export interface OnboardingLinkResult {
  __typename?: 'OnboardingLinkResult'
  expiresAt: ScalarsEnums['Float']
  url: ScalarsEnums['String']
}

export interface OnboardingProgress {
  __typename?: 'OnboardingProgress'
  completedSteps: ScalarsEnums['Float']
  items: Array<OnboardingChecklistItem>
  progressPct: ScalarsEnums['Float']
  totalSteps: ScalarsEnums['Float']
}

/**
 * The organisation's next consolidated charge: the earliest date its employees' memberships fall due, how many bill that day and their total before tax, and the card it will use.
 */
export interface OrganisationBillingPreview {
  __typename?: 'OrganisationBillingPreview'
  employeeCount: ScalarsEnums['Float']
  invoiceEmail?: Maybe<ScalarsEnums['String']>
  nextChargeAmountBeforeTax?: Maybe<ScalarsEnums['String']>
  nextChargeDate?: Maybe<ScalarsEnums['String']>
  nextChargeEmployeeCount: ScalarsEnums['Float']
  paymentMethodBrand?: Maybe<ScalarsEnums['String']>
  paymentMethodLast4?: Maybe<ScalarsEnums['String']>
}

/**
 * A client an organisation pays for
 */
export interface OrganisationEmployee {
  __typename?: 'OrganisationEmployee'
  clientId: ScalarsEnums['String']
  email?: Maybe<ScalarsEnums['String']>
  firstName?: Maybe<ScalarsEnums['String']>
  lastName?: Maybe<ScalarsEnums['String']>
  linkedAt?: Maybe<ScalarsEnums['String']>
}

export interface PaperFormApprover {
  __typename?: 'PaperFormApprover'
  firstName?: Maybe<ScalarsEnums['String']>
  lastName?: Maybe<ScalarsEnums['String']>
  staffUserId: ScalarsEnums['ID']
}

export interface PaperPolicyFormResult {
  __typename?: 'PaperPolicyFormResult'
  acceptances: Array<PolicyEvidenceAcceptanceResult>
  approvedByStaffUserId: ScalarsEnums['ID']
  paperRecordId: ScalarsEnums['ID']
}

export interface PaperScanUploadHeader {
  __typename?: 'PaperScanUploadHeader'
  name: ScalarsEnums['String']
  value: ScalarsEnums['String']
}

export interface PaperScanUploadTicket {
  __typename?: 'PaperScanUploadTicket'
  expiresAt: ScalarsEnums['String']
  headers: Array<PaperScanUploadHeader>
  uploadId: ScalarsEnums['ID']
  uploadUrl: ScalarsEnums['String']
}

/**
 * A payment with its gateway transactions
 */
export interface Payment {
  __typename?: 'Payment'
  amount: ScalarsEnums['Numeric']
  applicationFeeAmount?: Maybe<ScalarsEnums['Numeric']>
  autoRetryAttempts: ScalarsEnums['Float']
  autoRetryClientPaymentMethodId?: Maybe<ScalarsEnums['ID']>
  autoRetryNextDate: ScalarsEnums['String']
  cashDrawerSessionId?: Maybe<ScalarsEnums['ID']>
  clientActionExpiresAt?: Maybe<ScalarsEnums['String']>
  clientFeeAmount?: Maybe<ScalarsEnums['Numeric']>
  clientId?: Maybe<ScalarsEnums['ID']>
  /**
   * The client payment method used for this payment (card/bank details)
   */
  clientPaymentMethod?: Maybe<ClientPaymentMethod>
  clientPaymentMethodId?: Maybe<ScalarsEnums['ID']>
  createdAt: ScalarsEnums['String']
  createdByClientId?: Maybe<ScalarsEnums['ID']>
  createdByStaffUserId?: Maybe<ScalarsEnums['ID']>
  currency: ScalarsEnums['Currency']
  customPaymentMethodLabel?: Maybe<ScalarsEnums['String']>
  disputeState: ScalarsEnums['PaymentDisputeState']
  disputedAmount?: Maybe<ScalarsEnums['Numeric']>
  fallbackAttemptedMethodIds?: Maybe<Array<ScalarsEnums['ID']>>
  fallbackFromClientPaymentMethodId?: Maybe<ScalarsEnums['ID']>
  fallbackReason?: Maybe<ScalarsEnums['PaymentFallbackReason']>
  fallbackRetryMethodIds?: Maybe<Array<ScalarsEnums['ID']>>
  fallbackState?: Maybe<ScalarsEnums['PaymentFallbackState']>
  gatewayMetadata?: Maybe<GatewayMetadata>
  gatewaySettledAt?: Maybe<ScalarsEnums['String']>
  idempotencyKey: ScalarsEnums['String']
  invoiceId: ScalarsEnums['ID']
  isAutoRetryable: ScalarsEnums['Boolean']
  isClientActionRequired: ScalarsEnums['Boolean']
  originalBilledAmount?: Maybe<ScalarsEnums['Numeric']>
  originalPaymentId?: Maybe<ScalarsEnums['ID']>
  paymentId: ScalarsEnums['ID']
  paymentMethodType: ScalarsEnums['PaymentMethodType']
  platformFeeAmount?: Maybe<ScalarsEnums['Numeric']>
  reasonNotAutoRetryable: ScalarsEnums['ReasonsNotAutoRetryable']
  rebateCalculationSnapshot?: Maybe<PaymentRebateCalculationSnapshot>
  rebateFeeAmount?: Maybe<ScalarsEnums['Numeric']>
  royaltyAmount?: Maybe<ScalarsEnums['Numeric']>
  siteId: ScalarsEnums['ID']
  sitePaymentGatewayId?: Maybe<ScalarsEnums['ID']>
  status: ScalarsEnums['PaymentStatus']
  succeedAt?: Maybe<ScalarsEnums['String']>
  terminalPaymentMethodDetails?: Maybe<TerminalPaymentMethodDetails>
  terminalReaderId?: Maybe<ScalarsEnums['ID']>
  transactions: Array<PaymentGatewayTransaction>
  updatedAt: ScalarsEnums['String']
}

/**
 * Outcome of sending or resending the payment approval email
 */
export interface PaymentAuthenticationEmailResult {
  __typename?: 'PaymentAuthenticationEmailResult'
  deliveryState: ScalarsEnums['PaymentApprovalDeliveryState']
  expiresAt: ScalarsEnums['String']
  maskedEmail: ScalarsEnums['String']
}

/**
 * Client secret for completing 3DS authentication
 */
export interface PaymentClientSecret {
  __typename?: 'PaymentClientSecret'
  actionType?: Maybe<ScalarsEnums['String']>
  clientSecret: ScalarsEnums['String']
  paymentIntentId: ScalarsEnums['String']
}

/**
 * A payment gateway transaction attempt for async payment processing
 */
export interface PaymentGatewayTransaction {
  __typename?: 'PaymentGatewayTransaction'
  actionPayload?: Maybe<PaymentGatewayTransactionActionPayload>
  actionType?: Maybe<ScalarsEnums['String']>
  amount: ScalarsEnums['Numeric']
  attemptSequence: ScalarsEnums['Float']
  createdAt: ScalarsEnums['String']
  createdByStaffUserId?: Maybe<ScalarsEnums['ID']>
  currency: ScalarsEnums['Currency']
  dishonorFeeApplied: ScalarsEnums['Boolean']
  dishonorFeeReason?: Maybe<ScalarsEnums['String']>
  externalAttemptId?: Maybe<ScalarsEnums['String']>
  externalPaymentId?: Maybe<ScalarsEnums['String']>
  failureCategory?: Maybe<ScalarsEnums['FailureCategory']>
  gatewayType: ScalarsEnums['GatewayType']
  isAutomated: ScalarsEnums['Boolean']
  isTerminalPayment: ScalarsEnums['Boolean']
  paymentGatewayTransactionId: ScalarsEnums['ID']
  paymentId: ScalarsEnums['ID']
  processingFees?: Maybe<ScalarsEnums['Numeric']>
  providerAccountId: ScalarsEnums['String']
  rawErrorCode?: Maybe<ScalarsEnums['String']>
  rawErrorDeclineCode?: Maybe<ScalarsEnums['String']>
  rawErrorMessage?: Maybe<ScalarsEnums['String']>
  rawHttpStatus?: Maybe<ScalarsEnums['Float']>
  retryOfPaymentGatewayTransactionId?: Maybe<ScalarsEnums['ID']>
  siteId: ScalarsEnums['ID']
  sitePaymentGatewayId: ScalarsEnums['ID']
  status: ScalarsEnums['PaymentGatewayTransactionStatus']
}

export interface PaymentGatewayTransactionActionPayload {
  __typename?: 'PaymentGatewayTransactionActionPayload'
  redirectUrl?: Maybe<ScalarsEnums['String']>
  type: ScalarsEnums['String']
}

/**
 * Whether a client payment method may be removed, with the billing-obligation categories blocking it when it may not
 */
export interface PaymentMethodRemovalEligibility {
  __typename?: 'PaymentMethodRemovalEligibility'
  blockingReasons: Array<ScalarsEnums['PaymentMethodRemovalBlockReason']>
  canRemove: ScalarsEnums['Boolean']
}

export interface PaymentRebateCalculationSnapshot {
  __typename?: 'PaymentRebateCalculationSnapshot'
  appliedRebates: Array<PaymentRebateCalculationSnapshotAppliedRebates>
  calculatedAt: ScalarsEnums['String']
  rebateBaseAmount: ScalarsEnums['Float']
  rebateTemplates: Array<PaymentRebateCalculationSnapshotRebateTemplates>
  siteId: ScalarsEnums['String']
  siteName: ScalarsEnums['String']
  summary: FeeSummary
  totalRebateAmount: ScalarsEnums['Float']
}

export interface PaymentRebateCalculationSnapshotAppliedRebates {
  __typename?: 'PaymentRebateCalculationSnapshotAppliedRebates'
  calculatedAmount: ScalarsEnums['Float']
  corporatePayoutAccountId: ScalarsEnums['String']
  enabled: ScalarsEnums['Boolean']
  feeId: ScalarsEnums['String']
  feeName: ScalarsEnums['String']
  flatAmount?: Maybe<ScalarsEnums['Float']>
  percentRate?: Maybe<ScalarsEnums['Float']>
  rebateTemplateId: ScalarsEnums['String']
  rebateTemplateName: ScalarsEnums['String']
}

export interface PaymentRebateCalculationSnapshotRebateTemplates {
  __typename?: 'PaymentRebateCalculationSnapshotRebateTemplates'
  corporatePayoutAccountId: ScalarsEnums['String']
  rebateTemplateId: ScalarsEnums['String']
  rebateTemplateName: ScalarsEnums['String']
}

/**
 * Recovery options for a payment held for remote 3DS approval
 */
export interface PaymentRecovery {
  __typename?: 'PaymentRecovery'
  canEmail: ScalarsEnums['Boolean']
  canUseTerminal: ScalarsEnums['Boolean']
  expiresAt?: Maybe<ScalarsEnums['String']>
  hasLaterInvoices: ScalarsEnums['Boolean']
  isHeld: ScalarsEnums['Boolean']
  linkState: ScalarsEnums['PaymentApprovalLinkState']
  maskedEmail?: Maybe<ScalarsEnums['String']>
  secondsUntilExpiry?: Maybe<ScalarsEnums['Float']>
  soleTerminalReaderId?: Maybe<ScalarsEnums['String']>
}

/**
 * Polling status of a payment held for remote 3DS approval
 */
export interface PaymentRecoveryStatus {
  __typename?: 'PaymentRecoveryStatus'
  state: ScalarsEnums['PaymentRecoveryState']
}

/**
 * A staff time-clock shift record
 */
export interface PayrollTimeClock {
  __typename?: 'PayrollTimeClock'
  clockDate: ScalarsEnums['String']
  clockInTime: ScalarsEnums['String']
  clockOutTime?: Maybe<ScalarsEnums['String']>
  clockStatus: ScalarsEnums['ClockStatus']
  clockedInByStaffUserId?: Maybe<ScalarsEnums['ID']>
  clockedOutByStaffUserId?: Maybe<ScalarsEnums['ID']>
  createdAt: ScalarsEnums['String']
  entryType: ScalarsEnums['String']
  notes?: Maybe<ScalarsEnums['String']>
  payrollTimeClockId: ScalarsEnums['ID']
  siteId: ScalarsEnums['ID']
  staffUserId: ScalarsEnums['ID']
  updatedAt: ScalarsEnums['String']
}

/**
 * Pending agreement requiring signature
 */
export interface PendingAgreement {
  __typename?: 'PendingAgreement'
  invoiceId?: Maybe<ScalarsEnums['String']>
  invoiceTotal: ScalarsEnums['Float']
  packageID: ScalarsEnums['String']
  packageName: ScalarsEnums['String']
  packageSubscriptionID: ScalarsEnums['String']
  siteID: ScalarsEnums['String']
  siteName: ScalarsEnums['String']
}

/**
 * A booking request awaiting staff confirmation (auto-confirm disabled)
 */
export interface PendingBookingRequest {
  __typename?: 'PendingBookingRequest'
  bookingId: ScalarsEnums['String']
  bookingSource?: Maybe<ScalarsEnums['BookingSource']>
  clientFirstName: ScalarsEnums['String']
  clientId: ScalarsEnums['String']
  clientLastName: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  instructorName?: Maybe<ScalarsEnums['String']>
  paymentStatus?: Maybe<ScalarsEnums['String']>
  sessionEndTime: ScalarsEnums['String']
  sessionId: ScalarsEnums['String']
  sessionName: ScalarsEnums['String']
  sessionStartTime: ScalarsEnums['String']
  sessionTypeName?: Maybe<ScalarsEnums['String']>
  siteLocationId?: Maybe<ScalarsEnums['String']>
}

/**
 * A client-cancellation cash refund awaiting physical payout at the counter
 */
export interface PendingCashDrawerPayout {
  __typename?: 'PendingCashDrawerPayout'
  amount: ScalarsEnums['Numeric']
  clientId?: Maybe<ScalarsEnums['ID']>
  clientName?: Maybe<ScalarsEnums['String']>
  createdAt: ScalarsEnums['String']
  invoiceId: ScalarsEnums['ID']
  paymentId: ScalarsEnums['ID']
  refundId: ScalarsEnums['ID']
}

/**
 * Read-side projection of a scheduled change affecting an upcoming invoice occurrence
 */
export interface PendingChange {
  __typename?: 'PendingChange'
  effectiveDate: ScalarsEnums['String']
  projectedAmount?: Maybe<ScalarsEnums['Numeric']>
  projectedDate?: Maybe<ScalarsEnums['String']>
  suspensionRowState?: Maybe<ScalarsEnums['SuspensionRowState']>
  toServiceTemplateId?: Maybe<ScalarsEnums['ID']>
  toServiceTemplateName?: Maybe<ScalarsEnums['String']>
  type: ScalarsEnums['PendingChangeType']
}

/**
 * A pending guest pass sent to a verified email, with its invite token
 */
export interface PendingGuestPassForEmail {
  __typename?: 'PendingGuestPassForEmail'
  expiresAt?: Maybe<ScalarsEnums['String']>
  guestPassId: ScalarsEnums['ID']
  inviteToken: ScalarsEnums['String']
  senderName?: Maybe<ScalarsEnums['String']>
  siteId: ScalarsEnums['ID']
  siteName?: Maybe<ScalarsEnums['String']>
}

/**
 * One delivery of pending items to one signer through one channel
 */
export interface PendingItemsHandoff {
  __typename?: 'PendingItemsHandoff'
  channel: ScalarsEnums['PendingItemsChannel']
  clientId: ScalarsEnums['ID']
  completedAt?: Maybe<ScalarsEnums['String']>
  createdAt: ScalarsEnums['String']
  doneCount?: Maybe<ScalarsEnums['Float']>
  expiresAt: ScalarsEnums['String']
  handoffId: ScalarsEnums['ID']
  items: Array<PendingItemsHandoffItem>
  /**
   * Desk handoffs only, returned once to the staff session that created it: the signing tab sends it with the token exchange
   */
  presenceBinding?: Maybe<ScalarsEnums['String']>
  publicUrl?: Maybe<ScalarsEnums['String']>
  recipientCapacity: ScalarsEnums['SignerCapacity']
  recipientSignerId: ScalarsEnums['ID']
  resultCode?: Maybe<ScalarsEnums['String']>
  siteId: ScalarsEnums['ID']
  status: ScalarsEnums['PendingItemsHandoffStatus']
  statusVersion: ScalarsEnums['Float']
  totalCount?: Maybe<ScalarsEnums['Float']>
  updatedAt: ScalarsEnums['String']
}

/**
 * One item frozen into a handoff, and whether it is now done
 */
export interface PendingItemsHandoffItem {
  __typename?: 'PendingItemsHandoffItem'
  capability: ScalarsEnums['PendingItemHandoffCapability']
  countsTowardCompletion: ScalarsEnums['Boolean']
  done: ScalarsEnums['Boolean']
  itemKey: ScalarsEnums['String']
  kind: ScalarsEnums['PendingItemKind']
  signerCapacity?: Maybe<ScalarsEnums['SignerCapacity']>
  sitePolicyId?: Maybe<ScalarsEnums['ID']>
  title: ScalarsEnums['String']
}

/**
 * A person the pending-items send panel can address: the client or one of their guardians
 */
export interface PendingItemsRecipient {
  __typename?: 'PendingItemsRecipient'
  /**
   * The signer has a date of birth with a recorded verification, so QR and kiosk are open
   */
  dobVerified: ScalarsEnums['Boolean']
  guardianClientId?: Maybe<ScalarsEnums['ID']>
  /**
   * The signer has the member app on a device that can receive a push
   */
  hasAppDevice: ScalarsEnums['Boolean']
  /**
   * The mobile on file already agreed to receive compliance texts
   */
  hasTextConsent: ScalarsEnums['Boolean']
  hasValidMobile: ScalarsEnums['Boolean']
  /**
   * What a link sent to this recipient would count, read the same way the link is built
   */
  items: Array<PendingItemsRecipientItem>
  /**
   * The last digits of the mobile on file; the full number is never returned
   */
  maskedMobile?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  signerId: ScalarsEnums['ID']
}

/**
 * One item a link sent to this recipient in this capacity would count
 */
export interface PendingItemsRecipientItem {
  __typename?: 'PendingItemsRecipientItem'
  /**
   * The item must be done before the next session
   */
  blocking: ScalarsEnums['Boolean']
  itemKey: ScalarsEnums['String']
  kind: ScalarsEnums['PendingItemKind']
  /**
   * The item gates equipment use, not only the next session
   */
  requiredForEquipment: ScalarsEnums['Boolean']
  signerCapacity: ScalarsEnums['SignerCapacity']
  title: ScalarsEnums['String']
}

/**
 * Pending policy requiring acknowledgment
 */
export interface PendingPolicy {
  __typename?: 'PendingPolicy'
  policyID: ScalarsEnums['String']
  policyName: ScalarsEnums['String']
}

/**
 * An available plan option for a membership plan change
 */
export interface PlanOption {
  __typename?: 'PlanOption'
  direction: ScalarsEnums['PlanChangeDirection']
  meetsNewSaleDynamicDisplay: ScalarsEnums['Boolean']
  name: ScalarsEnums['String']
  price: ScalarsEnums['String']
  priceDelta: ScalarsEnums['String']
  saleAvailabilityState: ScalarsEnums['SaleAvailabilityState']
  serviceTemplateId: ScalarsEnums['ID']
  tierOrder?: Maybe<ScalarsEnums['Float']>
}

export interface PlanYourVisitWidget {
  __typename?: 'PlanYourVisitWidget'
  forecast?: Maybe<MemberVisitForecast>
  isTemporarilyClosed: ScalarsEnums['Boolean']
  live?: Maybe<SiteLiveOccupancy>
  title: ScalarsEnums['String']
}

/**
 * A voided policy acceptance; the evidence row is kept
 */
export interface PolicyAcceptanceVoidResult {
  __typename?: 'PolicyAcceptanceVoidResult'
  acceptanceState: ScalarsEnums['PolicyAcceptanceState']
  agreementId: ScalarsEnums['ID']
}

/**
 * Who a bulk send would text and what it would cost: recipients x segments x SMS credits
 */
export interface PolicyBulkSendPreview {
  __typename?: 'PolicyBulkSendPreview'
  availableCredits: ScalarsEnums['Float']
  cap: ScalarsEnums['Float']
  estimatedCredits: ScalarsEnums['Float']
  estimatedSegments: ScalarsEnums['Float']
  exceedsCap: ScalarsEnums['Boolean']
  matchedClients: ScalarsEnums['Float']
  recipients: ScalarsEnums['Float']
  segmentsPerMessage: ScalarsEnums['Float']
  siteId: ScalarsEnums['ID']
  skipReasons: Array<PolicyBulkSendSkipCount>
  skipped: ScalarsEnums['Float']
  toGuardians: ScalarsEnums['Float']
}

/**
 * Progress of one bulk pending-items send
 */
export interface PolicyBulkSendRun {
  __typename?: 'PolicyBulkSendRun'
  cancelledAt?: Maybe<ScalarsEnums['String']>
  completedAt?: Maybe<ScalarsEnums['String']>
  createdAt: ScalarsEnums['String']
  estimatedCredits: ScalarsEnums['Float']
  estimatedSegments: ScalarsEnums['Float']
  processedCount: ScalarsEnums['Float']
  queuedCount: ScalarsEnums['Float']
  requestedByStaffUserId: ScalarsEnums['ID']
  runId: ScalarsEnums['ID']
  siteId: ScalarsEnums['ID']
  skipReasons: Array<PolicyBulkSendSkipCount>
  skippedCount: ScalarsEnums['Float']
  status: ScalarsEnums['PolicyBulkSendStatus']
  totalCount: ScalarsEnums['Float']
}

export interface PolicyBulkSendSkipCount {
  __typename?: 'PolicyBulkSendSkipCount'
  count: ScalarsEnums['Float']
  reason: ScalarsEnums['PendingItemsAutoSendSkipReason']
}

/**
 * A location's equipment policy settings, with defaults filled in for anything never saved
 */
export interface PolicyComplianceSettings {
  __typename?: 'PolicyComplianceSettings'
  allowQueueBeforePoliciesSigned: ScalarsEnums['Boolean']
  allowRemoteGuardianSigning: ScalarsEnums['Boolean']
  autoSendPendingItemsLink: ScalarsEnums['Boolean']
  eSignConsentProfile: ScalarsEnums['ESignConsentProfile']
  guardianConsentAge: ScalarsEnums['Float']
  pendingItemsLinkTtlHours?: Maybe<ScalarsEnums['Float']>
  renewalReminderDays: ScalarsEnums['Float']
  sendOnHomeLocationChange: ScalarsEnums['Boolean']
  sendOnPlanPurchase: ScalarsEnums['Boolean']
  sendPushForPendingPolicies: ScalarsEnums['Boolean']
  siteId: ScalarsEnums['ID']
}

export interface PolicyEvidenceAcceptanceResult {
  __typename?: 'PolicyEvidenceAcceptanceResult'
  acceptanceState: ScalarsEnums['PolicyAcceptanceState']
  agreementId: ScalarsEnums['ID']
  policyRevisionId: ScalarsEnums['ID']
  signerCapacity: ScalarsEnums['SignerCapacity']
  slotIndex: ScalarsEnums['Float']
}

/**
 * A bulk policy evidence export: a zip of signed PDFs and a CSV manifest
 */
export interface PolicyEvidenceExport {
  __typename?: 'PolicyEvidenceExport'
  completedAt?: Maybe<ScalarsEnums['String']>
  createdAt: ScalarsEnums['String']
  downloadCount: ScalarsEnums['Float']
  expiresAt?: Maybe<ScalarsEnums['String']>
  exportId: ScalarsEnums['ID']
  includeScans: ScalarsEnums['Boolean']
  itemCount?: Maybe<ScalarsEnums['Float']>
  requestedBy: ScalarsEnums['ID']
  revokedAt?: Maybe<ScalarsEnums['String']>
  signedFrom: ScalarsEnums['String']
  signedTo: ScalarsEnums['String']
  siteId: ScalarsEnums['ID']
  status: ScalarsEnums['PolicyEvidenceExportStatus']
}

/**
 * A signed URL for one download click, valid for 15 minutes
 */
export interface PolicyEvidenceExportDownload {
  __typename?: 'PolicyEvidenceExportDownload'
  expiresAt: ScalarsEnums['String']
  exportId: ScalarsEnums['ID']
  url: ScalarsEnums['String']
}

/**
 * Activity log with staff user information
 */
export interface PosProductActivityLogWithStaff {
  __typename?: 'PosProductActivityLogWithStaff'
  activityCategory?: Maybe<ScalarsEnums['PosActivityCategory']>
  activityType: ScalarsEnums['PosActivityType']
  fieldName?: Maybe<ScalarsEnums['String']>
  metadata?: Maybe<ScalarsEnums['String']>
  newValue?: Maybe<ScalarsEnums['String']>
  oldValue?: Maybe<ScalarsEnums['String']>
  performedAt: ScalarsEnums['String']
  performedBy: ScalarsEnums['ID']
  posProductActivityLogId: ScalarsEnums['ID']
  posProductId: ScalarsEnums['ID']
  siteId: ScalarsEnums['ID']
  staffUser?: Maybe<PosProductActivityLogWithStaffStaffUser>
}

export interface PosProductActivityLogWithStaffStaffUser {
  __typename?: 'PosProductActivityLogWithStaffStaffUser'
  email: ScalarsEnums['String']
  firstName: ScalarsEnums['String']
  lastName: ScalarsEnums['String']
}

/**
 * An attribute of a product variant (e.g., color, size)
 */
export interface PosProductVariableAttribute {
  __typename?: 'PosProductVariableAttribute'
  attributeName: ScalarsEnums['String']
  attributeValue: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  displayOrder?: Maybe<ScalarsEnums['Int']>
  posProductId: ScalarsEnums['ID']
  posProductVariableAttributeId: ScalarsEnums['ID']
  posProductVariableId: ScalarsEnums['ID']
  siteId: ScalarsEnums['ID']
}

/**
 * Flattened product-variable pair for table display
 */
export interface PosProductVariableFlat {
  __typename?: 'PosProductVariableFlat'
  barcode?: Maybe<ScalarsEnums['String']>
  categoryId?: Maybe<ScalarsEnums['ID']>
  categoryName?: Maybe<ScalarsEnums['String']>
  createdAt: ScalarsEnums['String']
  currentStock: ScalarsEnums['Int']
  imageJSON?: Maybe<ImageFileConfigField>
  isEnabledForSale: ScalarsEnums['Boolean']
  isFeatured: ScalarsEnums['Boolean']
  posProductId: ScalarsEnums['ID']
  posProductVariableId: ScalarsEnums['ID']
  price: ScalarsEnums['Numeric']
  /**
   * Product image with signed URL
   */
  productImage: (args: { input: ImagePublicSignedUrlInput }) => Maybe<ImagePublicSignedUrl>
  productName: ScalarsEnums['String']
  siteId: ScalarsEnums['ID']
  sku?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['PosProductStatus']
  taxSettingIds?: Maybe<Array<ScalarsEnums['String']>>
  trackStock: ScalarsEnums['Boolean']
  updatedAt: ScalarsEnums['String']
  variableName: ScalarsEnums['String']
}

/**
 * A product variant with its attributes
 */
export interface PosProductVariableWithAttributes {
  __typename?: 'PosProductVariableWithAttributes'
  attributes: Array<PosProductVariableAttribute>
  barcode?: Maybe<ScalarsEnums['String']>
  cost?: Maybe<ScalarsEnums['Numeric']>
  createdAt: ScalarsEnums['String']
  createdBy: ScalarsEnums['ID']
  currentStock: ScalarsEnums['Int']
  isDefault: ScalarsEnums['Boolean']
  isEnabledForSale: ScalarsEnums['Boolean']
  isFeatured: ScalarsEnums['Boolean']
  maxStockLevel?: Maybe<ScalarsEnums['Int']>
  minStockLevel?: Maybe<ScalarsEnums['Int']>
  posProductId: ScalarsEnums['ID']
  posProductVariableId: ScalarsEnums['ID']
  price: ScalarsEnums['Numeric']
  siteId: ScalarsEnums['ID']
  sku?: Maybe<ScalarsEnums['String']>
  sortOrder: ScalarsEnums['Int']
  status: ScalarsEnums['PosProductStatus']
  taxSettingIds?: Maybe<Array<ScalarsEnums['String']>>
  trackStock: ScalarsEnums['Boolean']
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['ID']>
  variableName: ScalarsEnums['String']
}

export interface PosProductVariablesFlat {
  __typename?: 'PosProductVariablesFlat'
  pageInfo: PosProductVariablesFlatPageInfo
  results: Array<PosProductVariablesFlatResults>
}

export interface PosProductVariablesFlatPageInfo {
  __typename?: 'PosProductVariablesFlatPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface PosProductVariablesFlatResults {
  __typename?: 'PosProductVariablesFlatResults'
  cursor: ScalarsEnums['String']
  row: PosProductVariableFlat
}

export interface PosProducts {
  __typename?: 'PosProducts'
  pageInfo: PosProductsPageInfo
  results: Array<PosProductsResults>
}

export interface PosProductsPageInfo {
  __typename?: 'PosProductsPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface PosProductsResults {
  __typename?: 'PosProductsResults'
  cursor: ScalarsEnums['String']
  row: UpdatePosProductResponse
}

/**
 * A record of stock quantity adjustments for a product variant
 */
export interface PosStockAdjustment {
  __typename?: 'PosStockAdjustment'
  adjustedAt: ScalarsEnums['String']
  adjustedBy: ScalarsEnums['ID']
  adjustmentType: ScalarsEnums['PosStockAdjusmentType']
  posProductId: ScalarsEnums['ID']
  posProductVariableId: ScalarsEnums['ID']
  posStockAdjustmentId: ScalarsEnums['ID']
  quantityAdjustment: ScalarsEnums['Int']
  quantityAfter: ScalarsEnums['Int']
  quantityBefore: ScalarsEnums['Int']
  reason?: Maybe<ScalarsEnums['String']>
  referenceId?: Maybe<ScalarsEnums['ID']>
  siteId: ScalarsEnums['ID']
}

/**
 * The money consequence of moving a collected pre-sale opening date, computed without applying the move. At most one of shortfall/overpayment is set; both absent means the move costs nothing.
 */
export interface PresaleDateShiftPreview {
  __typename?: 'PresaleDateShiftPreview'
  overpayment?: Maybe<ScalarsEnums['Numeric']>
  shortfall?: Maybe<ScalarsEnums['Numeric']>
}

export interface PreviewGcsBundleMatch {
  __typename?: 'PreviewGcsBundleMatch'
  matchRate: ScalarsEnums['Float']
  matchedEntries: ScalarsEnums['Float']
  sampleUnmatchedExternalIds: Array<ScalarsEnums['String']>
  totalEntries: ScalarsEnums['Float']
  unmatchedEntries: ScalarsEnums['Float']
}

/**
 * Preview of the proration amount for an immediate membership plan change
 */
export interface PreviewMembershipPlanChangeResult {
  __typename?: 'PreviewMembershipPlanChangeResult'
  firstCycleSettlement?: Maybe<FirstCycleSettlement>
  proratedAmount?: Maybe<ScalarsEnums['String']>
}

/**
 * Preview of a PRORATED pause before it is created: the entry-cycle credit it would generate, whether the entry-cycle invoice is paid (no credit is given from an unpaid cycle), the grid-aligned date the next charge moves to, how many whole billing cycles the schedule defers by, and the basis the Pause summary renders — the credit method, the unused days or credits it was sized from, the first invoice after resume before and after the credit lands, and whether any leftover credit converts to account credit. A null creditAmount with a noCreditReason means the pause generates no credit and says why; a null on any summary field means that figure is not determinable for this pause.
 */
export interface PreviewProratedSuspensionResult {
  __typename?: 'PreviewProratedSuspensionResult'
  commitmentExtensionDays?: Maybe<ScalarsEnums['Float']>
  convertsToAccountCredit?: Maybe<ScalarsEnums['Boolean']>
  creditAmount?: Maybe<ScalarsEnums['String']>
  creditMethod?: Maybe<ScalarsEnums['ServiceSuspensionCreditMethod']>
  cycleAmountAfterCredit?: Maybe<ScalarsEnums['String']>
  cycleAmountBeforeCredit?: Maybe<ScalarsEnums['String']>
  cyclesDeferred?: Maybe<ScalarsEnums['Float']>
  daysInCycle?: Maybe<ScalarsEnums['Float']>
  entryInvoicePaid: ScalarsEnums['Boolean']
  nextBillingDate?: Maybe<ScalarsEnums['String']>
  noCreditReason?: Maybe<ScalarsEnums['String']>
  unusedCredits?: Maybe<ScalarsEnums['Float']>
  unusedDays?: Maybe<ScalarsEnums['Float']>
}

export interface PreviewServiceCancellationCharge {
  __typename?: 'PreviewServiceCancellationCharge'
  amount: ScalarsEnums['String']
  dueDate: ScalarsEnums['String']
  serviceId: ScalarsEnums['String']
  serviceName: ScalarsEnums['String']
}

export interface PreviewServiceCancellationResult {
  __typename?: 'PreviewServiceCancellationResult'
  addOnsEndingWithMembership: Array<ScalarsEnums['String']>
  blocker?: Maybe<ScalarsEnums['CancellationPreviewBlocker']>
  canCancel: ScalarsEnums['Boolean']
  cancelAt: ScalarsEnums['String']
  chargesBeforeEffectiveDate: Array<PreviewServiceCancellationCharge>
  chargesTotal: ScalarsEnums['String']
  currency?: Maybe<ScalarsEnums['String']>
  earliestCancelDate?: Maybe<ScalarsEnums['String']>
  effectiveDate: ScalarsEnums['String']
  effectiveDateRule: ScalarsEnums['CancellationEffectiveDateRule']
  feeAmount: ScalarsEnums['String']
  feeBreakdown?: Maybe<CancellationFeeBreakdown>
  feeExclusiveTaxPercent: ScalarsEnums['String']
  feeIsTaxEnabled: ScalarsEnums['Boolean']
  feeSource: ScalarsEnums['CancellationFeeSource']
  feeTaxAmount: ScalarsEnums['String']
  feeTaxSettingIds: Array<ScalarsEnums['String']>
  feeTierIndex?: Maybe<ScalarsEnums['Float']>
  feeTotal: ScalarsEnums['String']
  noticePeriodDays: ScalarsEnums['Float']
  serviceId: ScalarsEnums['String']
  serviceName: ScalarsEnums['String']
  tenure?: Maybe<PreviewServiceCancellationTenure>
  totalDueBeforeCancellation: ScalarsEnums['String']
}

export interface PreviewServiceCancellationTenure {
  __typename?: 'PreviewServiceCancellationTenure'
  basis: ScalarsEnums['CancellationTierBasis']
  elapsed: ScalarsEnums['Float']
  termEnd?: Maybe<ScalarsEnums['String']>
}

/**
 * What resuming a membership will charge and settle, quoted before staff confirm: the prorated re-entry charge, the credit applied to it, what remains, and whether that remainder converts to account credit.
 */
export interface PreviewServiceResumeResult {
  __typename?: 'PreviewServiceResumeResult'
  convertsToAccountCredit: ScalarsEnums['Boolean']
  creditApplied?: Maybe<ScalarsEnums['String']>
  creditRemainingAfter?: Maybe<ScalarsEnums['String']>
  netAmount?: Maybe<ScalarsEnums['String']>
  stubDays?: Maybe<ScalarsEnums['Float']>
  stubGrossAmount?: Maybe<ScalarsEnums['String']>
  suspensionType?: Maybe<ScalarsEnums['ServiceSuspensionType']>
  terminatesRecurringFee: ScalarsEnums['Boolean']
}

/**
 * Preview of a RECURRING suspension fee: every date it bills on, the per-charge amount and the total. A null result means the pause crosses no billing date and so costs nothing. Null occurrences and totalAmount, with an empty billingDates, mean the pause is indefinite, so the count is not yet knowable.
 */
export interface PreviewSuspensionFeeResult {
  __typename?: 'PreviewSuspensionFeeResult'
  billingDates: Array<ScalarsEnums['String']>
  chargeAmount: ScalarsEnums['String']
  firstBillingDate: ScalarsEnums['String']
  lastBillingDate?: Maybe<ScalarsEnums['String']>
  occurrences?: Maybe<ScalarsEnums['Float']>
  totalAmount?: Maybe<ScalarsEnums['String']>
}

/**
 * One pause's quote. Exactly one of prorated / timeShift is populated, matching the pause type; fee is null unless the pause carries a RECURRING charge; secondaryFee is null unless the membership has one.
 */
export interface PreviewSuspensionPlanPause {
  __typename?: 'PreviewSuspensionPlanPause'
  fee?: Maybe<PreviewSuspensionFeeResult>
  index: ScalarsEnums['Float']
  isEstimate: ScalarsEnums['Boolean']
  prorated?: Maybe<PreviewProratedSuspensionResult>
  secondaryFee?: Maybe<PreviewSuspensionSecondaryFeeResult>
  timeShift?: Maybe<PreviewTimeShiftSuspensionResult>
}

/**
 * Every pause in a composed set, each quoted against the billing schedule the pauses before it leave behind. Returned in the order the caller sent them; empty when the membership has no primary recurring invoice.
 */
export interface PreviewSuspensionPlanResult {
  __typename?: 'PreviewSuspensionPlanResult'
  pauses: Array<PreviewSuspensionPlanPause>
}

/**
 * OC-863 preview of what a pause does to the membership's secondary recurring fee. A null result means the membership has no secondary fee. A null projectedNextBillingDate means the pause is indefinite, so the shifted date is not yet knowable.
 */
export interface PreviewSuspensionSecondaryFeeResult {
  __typename?: 'PreviewSuspensionSecondaryFeeResult'
  amount: ScalarsEnums['String']
  continuesDuringPause: ScalarsEnums['Boolean']
  name: ScalarsEnums['String']
  nextBillingDate: ScalarsEnums['String']
  projectedNextBillingDate?: Maybe<ScalarsEnums['String']>
}

/**
 * Preview of a TIME_SHIFT pause before it is created: the date the next charge moves to, and how many days the pause pushes out the earliest date the membership can be cancelled. Returns null when the membership has no primary recurring invoice. A null nextBillingDate means the pause is indefinite, so the shifted date is not yet knowable; a null commitmentExtensionDays means the membership has no minimum term, or the pause is indefinite.
 */
export interface PreviewTimeShiftSuspensionResult {
  __typename?: 'PreviewTimeShiftSuspensionResult'
  commitmentExtensionDays?: Maybe<ScalarsEnums['Float']>
  nextBillingDate?: Maybe<ScalarsEnums['String']>
}

export interface ProcessCSVImport {
  __typename?: 'ProcessCSVImport'
  errors?: Maybe<Array<ScalarsEnums['String']>>
  gcsUrl: ScalarsEnums['String']
  importSessionId: ScalarsEnums['ID']
  status: ScalarsEnums['ProcessCSVImportStatus']
  totalRows: ScalarsEnums['Float']
}

export interface ProcessZIPImport {
  __typename?: 'ProcessZIPImport'
  errors?: Maybe<Array<ScalarsEnums['String']>>
  gcsUrl: ScalarsEnums['String']
  importSessionId: ScalarsEnums['ID']
  status: ScalarsEnums['ProcessZIPImportStatus']
  totalFiles: ScalarsEnums['Float']
}

export interface ProcessZIPImportFromGcs {
  __typename?: 'ProcessZIPImportFromGcs'
  errors?: Maybe<Array<ScalarsEnums['String']>>
  migrationId?: Maybe<ScalarsEnums['String']>
  sessions: Array<ProcessZIPImportFromGcsSessions>
}

export interface ProcessZIPImportFromGcsSessions {
  __typename?: 'ProcessZIPImportFromGcsSessions'
  fileName: ScalarsEnums['String']
  gcsUrl: ScalarsEnums['String']
  importSessionId: ScalarsEnums['ID']
  objectPath: ScalarsEnums['String']
  reused: ScalarsEnums['Boolean']
  status: ScalarsEnums['ImportSessionStatusEnum']
}

/**
 * A promotional code for discounts
 */
export interface PromoCode {
  __typename?: 'PromoCode'
  clientUseLimit?: Maybe<ScalarsEnums['Float']>
  code: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  currentGlobalUses: ScalarsEnums['Float']
  discountType: ScalarsEnums['PromoCodeDiscountType']
  discountValue: ScalarsEnums['Numeric']
  endDate?: Maybe<ScalarsEnums['String']>
  globalUseLimit?: Maybe<ScalarsEnums['Float']>
  isAvailableAfterIntroOffer: ScalarsEnums['Boolean']
  isAvailableBeforeIntroOffer: ScalarsEnums['Boolean']
  isAvailableForOnlineSale: ScalarsEnums['Boolean']
  isDiscountFutureInvoices: ScalarsEnums['Boolean']
  membershipIds?: Maybe<Array<ScalarsEnums['ID']>>
  name: ScalarsEnums['String']
  packageIds?: Maybe<Array<ScalarsEnums['ID']>>
  productIds?: Maybe<Array<ScalarsEnums['ID']>>
  promoCodeId: ScalarsEnums['ID']
  siteId: ScalarsEnums['ID']
  startDate: ScalarsEnums['String']
  status: ScalarsEnums['PromoCodeStatus']
  updatedAt: ScalarsEnums['String']
}

export interface PromoCodes {
  __typename?: 'PromoCodes'
  pageInfo: PromoCodesPageInfo
  results: Array<PromoCodesResults>
}

export interface PromoCodesPageInfo {
  __typename?: 'PromoCodesPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface PromoCodesResults {
  __typename?: 'PromoCodesResults'
  cursor: ScalarsEnums['String']
  row: PromoCode
}

export interface PromoteProspect {
  __typename?: 'PromoteProspect'
  clientId: ScalarsEnums['ID']
  firebaseId: ScalarsEnums['String']
  promoted: ScalarsEnums['Boolean']
}

/**
 * Information about a messaging provider
 */
export interface ProviderInfo {
  __typename?: 'ProviderInfo'
  isAvailable: ScalarsEnums['Boolean']
  isConfigured: ScalarsEnums['Boolean']
  name: ScalarsEnums['String']
  type: ScalarsEnums['String']
}

export interface ProvisionTrialAccessResponse {
  __typename?: 'ProvisionTrialAccessResponse'
  corporateId: ScalarsEnums['String']
  staffUserId: ScalarsEnums['String']
  urlPrefix: ScalarsEnums['String']
}

/**
 * A first payment parked on a bank authentication challenge after public signing; the client completes it with the secret.
 */
export interface PublicSigningPendingClientAction {
  __typename?: 'PublicSigningPendingClientAction'
  clientSecret: ScalarsEnums['String']
  paymentId: ScalarsEnums['String']
  paymentIntentId: ScalarsEnums['String']
}

export interface PublishEntitlementCatalogResult {
  __typename?: 'PublishEntitlementCatalogResult'
  brandsSignalled: ScalarsEnums['Float']
  catalogVersion: ScalarsEnums['String']
  created: ScalarsEnums['Boolean']
}

/**
 * Result of purchasing SMS credits
 */
export interface PurchaseCreditsResult {
  __typename?: 'PurchaseCreditsResult'
  ledgerEntry: SmsCreditsLedgerEntry
  message: ScalarsEnums['String']
  newBalance: ScalarsEnums['Float']
  success: ScalarsEnums['Boolean']
}

/**
 * Staff note written when the client was added to the waitline, for one rule
 */
export interface QueuedTanningRegulationOverride {
  __typename?: 'QueuedTanningRegulationOverride'
  note: ScalarsEnums['String']
  rule: ScalarsEnums['TanningRegulationRule']
  staffUserId?: Maybe<ScalarsEnums['ID']>
}

/**
 * Outcome of re-deriving a location's stored fobs after a format change
 */
export interface ReDeriveSiteFobsResult {
  __typename?: 'ReDeriveSiteFobsResult'
  failed: ScalarsEnums['Float']
  skipped: ScalarsEnums['Float']
  updated: ScalarsEnums['Float']
}

/**
 * Status and reason codes of one readiness dimension
 */
export interface ReadinessDimensionResult {
  __typename?: 'ReadinessDimensionResult'
  reasonCodes: Array<ScalarsEnums['ReadinessReasonCode']>
  status: ScalarsEnums['ReadinessStatus']
}

/**
 * The acceptances and revisions a readiness result relied on; evidence viewers only
 */
export interface ReadinessEvidenceDetail {
  __typename?: 'ReadinessEvidenceDetail'
  acceptedAgreementIds: Array<ScalarsEnums['ID']>
  jurisdictionRuleRevision?: Maybe<ScalarsEnums['String']>
  revisionIds: Array<ScalarsEnums['ID']>
}

/**
 * One obligation a client must, can or will need to complete before equipment use
 */
export interface ReadinessItem {
  __typename?: 'ReadinessItem'
  dueOn?: Maybe<ScalarsEnums['String']>
  itemKey: ScalarsEnums['String']
  kind: ScalarsEnums['PendingItemKind']
  policyRevisionId?: Maybe<ScalarsEnums['ID']>
  reasonCode: ScalarsEnums['ReadinessReasonCode']
  signerCapacity?: Maybe<ScalarsEnums['SignerCapacity']>
  signerId?: Maybe<ScalarsEnums['ID']>
  sitePolicyId?: Maybe<ScalarsEnums['ID']>
  timing?: Maybe<ScalarsEnums['ReadinessItemTiming']>
  title: ScalarsEnums['String']
  validUntil?: Maybe<ScalarsEnums['String']>
}

/**
 * Template for rebate configuration with associated fees
 */
export interface RebateTemplate {
  __typename?: 'RebateTemplate'
  corporatePayoutAccountId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  createdBy?: Maybe<ScalarsEnums['ID']>
  fees?: Maybe<Array<RebateTemplateFees>>
  name: ScalarsEnums['String']
  rebateTemplateId: ScalarsEnums['ID']
  /**
   * Get sites associated with this rebate template
   */
  sites: Array<SitePreview>
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['ID']>
}

export interface RebateTemplateFees {
  __typename?: 'RebateTemplateFees'
  createdAt: ScalarsEnums['String']
  enabled: ScalarsEnums['Boolean']
  feeId: ScalarsEnums['ID']
  rate: ScalarsEnums['Numeric']
  rebateTemplateFeeId: ScalarsEnums['ID']
  rebateTemplateId: ScalarsEnums['ID']
}

export interface RebateTemplates {
  __typename?: 'RebateTemplates'
  pageInfo: RebateTemplatesPageInfo
  results: Array<RebateTemplatesResults>
}

export interface RebateTemplatesPageInfo {
  __typename?: 'RebateTemplatesPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface RebateTemplatesResults {
  __typename?: 'RebateTemplatesResults'
  cursor: ScalarsEnums['String']
  row: RebateTemplate
}

export interface RecalculateClientSiteAggregates {
  __typename?: 'RecalculateClientSiteAggregates'
  clientSitesUpdated: ScalarsEnums['Float']
  durationMs: ScalarsEnums['Float']
}

/**
 * DNS record Hapana recommends for deliverability (DMARC). Not part of the Resend verifiable set: never verified and never blocks domain verification.
 */
export interface RecommendedDnsRecord {
  __typename?: 'RecommendedDnsRecord'
  name: ScalarsEnums['String']
  type: ScalarsEnums['DnsRecordType']
  value: ScalarsEnums['String']
}

/**
 * Recurring billing schedule for auto-renewing services
 */
export interface RecurringInvoice {
  __typename?: 'RecurringInvoice'
  amount: ScalarsEnums['Numeric']
  anchorDate?: Maybe<ScalarsEnums['String']>
  beneficiaryId?: Maybe<ScalarsEnums['ID']>
  billingCycleAmount: ScalarsEnums['Float']
  billingCycleUnit: ScalarsEnums['String']
  canceledAt?: Maybe<ScalarsEnums['String']>
  clientId: ScalarsEnums['ID']
  clientPaymentMethodId?: Maybe<ScalarsEnums['ID']>
  createdAt: ScalarsEnums['String']
  currency: ScalarsEnums['Currency']
  discountType?: Maybe<ScalarsEnums['DiscountType']>
  discountValue?: Maybe<ScalarsEnums['Numeric']>
  endDate?: Maybe<ScalarsEnums['String']>
  initialInvoiceId: ScalarsEnums['String']
  isImported: ScalarsEnums['Boolean']
  lastGeneratedSequence?: Maybe<ScalarsEnums['Float']>
  lastInvoiceDate?: Maybe<ScalarsEnums['String']>
  lastInvoiceId?: Maybe<ScalarsEnums['ID']>
  name: ScalarsEnums['String']
  nextInvoiceDate: ScalarsEnums['String']
  promoCodeDiscountSnapshot?: Maybe<RecurringInvoiceWithClientPromoCodeDiscountSnapshot>
  promoCodeId?: Maybe<ScalarsEnums['ID']>
  recurringInvoiceId: ScalarsEnums['ID']
  serviceId: ScalarsEnums['ID']
  siteId: ScalarsEnums['ID']
  status: ScalarsEnums['RecurringInvoiceStatus']
  suspendedUntil?: Maybe<ScalarsEnums['String']>
  taxSettingIds?: Maybe<Array<ScalarsEnums['ID']>>
  taxSettingsSnapshot?: Maybe<Array<InvoiceItemsTaxCalculationsTaxSetting>>
  type: ScalarsEnums['RecurringInvoiceType']
}

/**
 * Single result row with recurring invoice data and cursor
 */
export interface RecurringInvoiceResultRow {
  __typename?: 'RecurringInvoiceResultRow'
  cursor: ScalarsEnums['String']
  row: RecurringInvoiceWithClient
}

/**
 * Recurring invoice with associated client information
 */
export interface RecurringInvoiceWithClient {
  __typename?: 'RecurringInvoiceWithClient'
  addOnAmount?: Maybe<ScalarsEnums['Numeric']>
  amount: ScalarsEnums['Numeric']
  anchorDate?: Maybe<ScalarsEnums['String']>
  beneficiaryId?: Maybe<ScalarsEnums['ID']>
  billingCycleAmount: ScalarsEnums['Float']
  billingCycleUnit: ScalarsEnums['String']
  canceledAt?: Maybe<ScalarsEnums['String']>
  /**
   * Client associated with this recurring invoice
   */
  client?: Maybe<RecurringInvoiceWithClientClient>
  clientId: ScalarsEnums['ID']
  clientPaymentMethodId?: Maybe<ScalarsEnums['ID']>
  createdAt: ScalarsEnums['String']
  currency: ScalarsEnums['Currency']
  discountType?: Maybe<ScalarsEnums['DiscountType']>
  discountValue?: Maybe<ScalarsEnums['Numeric']>
  endDate?: Maybe<ScalarsEnums['String']>
  initialInvoiceId: ScalarsEnums['String']
  isImported: ScalarsEnums['Boolean']
  isIndefinitelySuspended?: Maybe<ScalarsEnums['Boolean']>
  lastGeneratedSequence?: Maybe<ScalarsEnums['Float']>
  lastInvoiceDate?: Maybe<ScalarsEnums['String']>
  lastInvoiceId?: Maybe<ScalarsEnums['ID']>
  name: ScalarsEnums['String']
  netAmount?: Maybe<ScalarsEnums['Numeric']>
  nextInvoiceDate: ScalarsEnums['String']
  nextPaymentDate?: Maybe<ScalarsEnums['String']>
  nextSecondaryFeeAmount?: Maybe<ScalarsEnums['Numeric']>
  nextSecondaryFeeDate?: Maybe<ScalarsEnums['String']>
  promoCodeDiscountSnapshot?: Maybe<RecurringInvoiceWithClientPromoCodeDiscountSnapshot>
  promoCodeId?: Maybe<ScalarsEnums['ID']>
  recurringInvoiceId: ScalarsEnums['ID']
  serviceId: ScalarsEnums['ID']
  serviceOnHold?: Maybe<ScalarsEnums['Boolean']>
  siteId: ScalarsEnums['ID']
  status: ScalarsEnums['RecurringInvoiceStatus']
  suspendedUntil?: Maybe<ScalarsEnums['String']>
  taxSettingIds?: Maybe<Array<ScalarsEnums['ID']>>
  taxSettingsSnapshot?: Maybe<Array<InvoiceItemsTaxCalculationsTaxSetting>>
  type: ScalarsEnums['RecurringInvoiceType']
}

export interface RecurringInvoiceWithClientClient {
  __typename?: 'RecurringInvoiceWithClientClient'
  alerts?: Maybe<Array<RecurringInvoiceWithClientClientAlerts>>
  clientId: ScalarsEnums['ID']
  email?: Maybe<ScalarsEnums['String']>
  firstName?: Maybe<ScalarsEnums['String']>
  lastName?: Maybe<ScalarsEnums['String']>
}

export interface RecurringInvoiceWithClientClientAlerts {
  __typename?: 'RecurringInvoiceWithClientClientAlerts'
  clientId: ScalarsEnums['String']
  data?: Maybe<ScalarsEnums['JSONObject']>
  requiresFetch: ScalarsEnums['Boolean']
  type: ScalarsEnums['String']
}

export interface RecurringInvoiceWithClientPromoCodeDiscountSnapshot {
  __typename?: 'RecurringInvoiceWithClientPromoCodeDiscountSnapshot'
  discountType: ScalarsEnums['PromoCodeDiscountType']
  discountValue: ScalarsEnums['String']
}

/**
 * Paginated list of recurring invoices for a site
 */
export interface RecurringInvoicesPaginationResult {
  __typename?: 'RecurringInvoicesPaginationResult'
  pageInfo: RecurringInvoicesPaginationResultPageInfo
  results: Array<RecurringInvoiceResultRow>
}

export interface RecurringInvoicesPaginationResultPageInfo {
  __typename?: 'RecurringInvoicesPaginationResultPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

/**
 * Summary of the clicked session pattern and any downstream split siblings, used to render the bounded vs unbounded THIS_AND_FUTURE option.
 */
export interface RecurringPatternBoundaries {
  __typename?: 'RecurringPatternBoundaries'
  boundedSegmentEndDate?: Maybe<ScalarsEnums['String']>
  clickedDate: ScalarsEnums['String']
  downstreamSplits: Array<RecurringPatternBoundariesDownstreamSplits>
  hasDownstreamSplits: ScalarsEnums['Boolean']
  modifiedDownstreamSessionCount: ScalarsEnums['Float']
  modifiedFutureSessionCount: ScalarsEnums['Float']
  rootEndDate?: Maybe<ScalarsEnums['String']>
}

export interface RecurringPatternBoundariesDownstreamSplits {
  __typename?: 'RecurringPatternBoundariesDownstreamSplits'
  durationMinutes: ScalarsEnums['Float']
  endDate?: Maybe<ScalarsEnums['String']>
  endTime: ScalarsEnums['String']
  recurringSessionsId: ScalarsEnums['String']
  startDate: ScalarsEnums['String']
  startTime: ScalarsEnums['String']
}

/**
 * Payment statistics for recurring invoices (successful/failed counts and amounts)
 */
export interface RecurringPaymentStats {
  __typename?: 'RecurringPaymentStats'
  failedAmount: ScalarsEnums['String']
  failedCount: ScalarsEnums['Float']
  successfulAmount: ScalarsEnums['String']
  successfulCount: ScalarsEnums['Float']
}

/**
 * Combined service detail with recurring invoice information for detail page
 */
export interface RecurringServiceDetail {
  __typename?: 'RecurringServiceDetail'
  activeSuspension?: Maybe<RecurringServiceDetailActiveSuspension>
  activeSuspensions?: Maybe<Array<RecurringServiceDetailActiveSuspensions>>
  amount?: Maybe<ScalarsEnums['String']>
  autoRenew: ScalarsEnums['Boolean']
  autoRenewServiceTemplateName?: Maybe<ScalarsEnums['String']>
  bankLast4?: Maybe<ScalarsEnums['String']>
  bankName?: Maybe<ScalarsEnums['String']>
  beneficiaryId?: Maybe<ScalarsEnums['ID']>
  billingCycleAmount?: Maybe<ScalarsEnums['Float']>
  billingCycleUnit?: Maybe<ScalarsEnums['String']>
  cardBrand?: Maybe<ScalarsEnums['String']>
  cardLast4?: Maybe<ScalarsEnums['String']>
  clientEmail?: Maybe<ScalarsEnums['String']>
  clientFirstName?: Maybe<ScalarsEnums['String']>
  clientId: ScalarsEnums['ID']
  clientLastName?: Maybe<ScalarsEnums['String']>
  createdByInvoiceId?: Maybe<ScalarsEnums['ID']>
  currency: ScalarsEnums['String']
  discountAmount?: Maybe<ScalarsEnums['String']>
  discountReason?: Maybe<ScalarsEnums['String']>
  earliestCancelDate?: Maybe<ScalarsEnums['String']>
  expiresAt?: Maybe<ScalarsEnums['String']>
  inclusiveTaxAmount?: Maybe<ScalarsEnums['String']>
  itemOriginalAmount?: Maybe<ScalarsEnums['String']>
  itemTotalAmount?: Maybe<ScalarsEnums['String']>
  lastInvoiceDate?: Maybe<ScalarsEnums['String']>
  nextInvoiceDate?: Maybe<ScalarsEnums['String']>
  onHold?: Maybe<ScalarsEnums['Boolean']>
  payerClientId?: Maybe<ScalarsEnums['ID']>
  payerName?: Maybe<ScalarsEnums['String']>
  planChangedByStaffName?: Maybe<ScalarsEnums['String']>
  processedByStaffName?: Maybe<ScalarsEnums['String']>
  processedByStaffUserId?: Maybe<ScalarsEnums['ID']>
  purchasedAt: ScalarsEnums['String']
  recurringInvoiceId?: Maybe<ScalarsEnums['ID']>
  recurringInvoiceStatus?: Maybe<ScalarsEnums['String']>
  referredByStaffName?: Maybe<ScalarsEnums['String']>
  referredByStaffUserId?: Maybe<ScalarsEnums['ID']>
  scheduledCancellation?: Maybe<RecurringServiceDetailScheduledCancellation>
  scheduledFeeInvoices?: Maybe<Array<RecurringServiceDetailScheduledFeeInvoices>>
  scheduledSuspension?: Maybe<RecurringServiceDetailScheduledSuspension>
  scheduledSuspensions?: Maybe<Array<RecurringServiceDetailScheduledSuspensions>>
  secondaryFee?: Maybe<RecurringServiceDetailSecondaryFee>
  serviceFirstBillingDate?: Maybe<ScalarsEnums['String']>
  serviceId: ScalarsEnums['ID']
  serviceName: ScalarsEnums['String']
  serviceStatus: ScalarsEnums['String']
  serviceTemplateId: ScalarsEnums['ID']
  setupFee?: Maybe<ScalarsEnums['String']>
  setupFeeExclusiveTaxAmount?: Maybe<ScalarsEnums['String']>
  setupFeeInclusiveTaxAmount?: Maybe<ScalarsEnums['String']>
  siteId: ScalarsEnums['ID']
  siteSessionTypeIds?: Maybe<Array<ScalarsEnums['ID']>>
  siteTimezone?: Maybe<ScalarsEnums['String']>
  soldBillingCycleUnit?: Maybe<ScalarsEnums['String']>
  soldBillingDay?: Maybe<ScalarsEnums['Float']>
  startsAt: ScalarsEnums['String']
  taxAmount?: Maybe<ScalarsEnums['String']>
  wallet?: Maybe<ScalarsEnums['PaymentWallet']>
}

export interface RecurringServiceDetailActiveSuspension {
  __typename?: 'RecurringServiceDetailActiveSuspension'
  endDate?: Maybe<ScalarsEnums['String']>
  scheduledRestartDate?: Maybe<ScalarsEnums['String']>
  serviceSuspensionId: ScalarsEnums['ID']
  startDate: ScalarsEnums['String']
  suspensionReason?: Maybe<ScalarsEnums['String']>
  suspensionType: ScalarsEnums['ServiceSuspensionType']
}

export interface RecurringServiceDetailActiveSuspensions {
  __typename?: 'RecurringServiceDetailActiveSuspensions'
  endDate?: Maybe<ScalarsEnums['String']>
  scheduledRestartDate?: Maybe<ScalarsEnums['String']>
  serviceSuspensionId: ScalarsEnums['ID']
  startDate: ScalarsEnums['String']
  suspensionReason?: Maybe<ScalarsEnums['String']>
  suspensionType: ScalarsEnums['ServiceSuspensionType']
}

export interface RecurringServiceDetailScheduledCancellation {
  __typename?: 'RecurringServiceDetailScheduledCancellation'
  cancellationDate: ScalarsEnums['String']
  cancellationReason?: Maybe<ScalarsEnums['String']>
  serviceCancellationId: ScalarsEnums['ID']
}

export interface RecurringServiceDetailScheduledFeeInvoices {
  __typename?: 'RecurringServiceDetailScheduledFeeInvoices'
  actionType: ScalarsEnums['ServiceActionType']
  amount: ScalarsEnums['String']
  currency: ScalarsEnums['String']
  dueDate: ScalarsEnums['String']
  invoiceId: ScalarsEnums['ID']
}

export interface RecurringServiceDetailScheduledSuspension {
  __typename?: 'RecurringServiceDetailScheduledSuspension'
  endDate?: Maybe<ScalarsEnums['String']>
  serviceSuspensionId: ScalarsEnums['ID']
  startDate: ScalarsEnums['String']
  suspensionReason?: Maybe<ScalarsEnums['String']>
  suspensionType: ScalarsEnums['ServiceSuspensionType']
}

export interface RecurringServiceDetailScheduledSuspensions {
  __typename?: 'RecurringServiceDetailScheduledSuspensions'
  endDate?: Maybe<ScalarsEnums['String']>
  serviceSuspensionId: ScalarsEnums['ID']
  startDate: ScalarsEnums['String']
  suspensionReason?: Maybe<ScalarsEnums['String']>
  suspensionType: ScalarsEnums['ServiceSuspensionType']
}

export interface RecurringServiceDetailSecondaryFee {
  __typename?: 'RecurringServiceDetailSecondaryFee'
  amount: ScalarsEnums['String']
  billingCycleAmount: ScalarsEnums['Float']
  billingCycleUnit: ScalarsEnums['String']
  currency: ScalarsEnums['String']
  name: ScalarsEnums['String']
  recurringInvoiceId: ScalarsEnums['ID']
  status: ScalarsEnums['String']
}

/**
 * A recurring session pattern that generates scheduled sessions
 */
export interface RecurringSession {
  __typename?: 'RecurringSession'
  allowOverlappingSessions?: Maybe<ScalarsEnums['Boolean']>
  category: ScalarsEnums['SessionCategory']
  createdAt: ScalarsEnums['String']
  creditsRequired: ScalarsEnums['Float']
  customFields?: Maybe<Array<SessionTemplateCustomFields>>
  deletedAt?: Maybe<ScalarsEnums['String']>
  description?: Maybe<ScalarsEnums['String']>
  dropinPrice: ScalarsEnums['Numeric']
  durationMinutes: ScalarsEnums['Float']
  endAfterOccurrences?: Maybe<ScalarsEnums['Float']>
  endDate?: Maybe<ScalarsEnums['String']>
  endTime: ScalarsEnums['String']
  isPaymentRequired: ScalarsEnums['Boolean']
  isRequestBookingEnabled: ScalarsEnums['Boolean']
  isRequiredSessionFeedback: ScalarsEnums['Boolean']
  isRequiredTwoPartAuthentication: ScalarsEnums['Boolean']
  isRoomResourceEnabled: ScalarsEnums['Boolean']
  itemsSupplied?: Maybe<ScalarsEnums['String']>
  itemsToBring?: Maybe<ScalarsEnums['String']>
  lastGeneratedUntilDate?: Maybe<ScalarsEnums['String']>
  lateCancelFeeId?: Maybe<ScalarsEnums['String']>
  lateCancelFeeMode: ScalarsEnums['SessionFeeMode']
  name: ScalarsEnums['String']
  noShowFeeId?: Maybe<ScalarsEnums['String']>
  noShowFeeMode: ScalarsEnums['SessionFeeMode']
  recurrenceDayOfMonth?: Maybe<ScalarsEnums['Float']>
  recurrenceDaysOfWeek?: Maybe<Array<ScalarsEnums['DayOfWeek']>>
  recurrenceInterval: ScalarsEnums['Float']
  recurrenceType: ScalarsEnums['RecurrenceType']
  recurringSessionsId: ScalarsEnums['String']
  revenueTagId?: Maybe<ScalarsEnums['String']>
  rootRecurringSessionsId?: Maybe<ScalarsEnums['String']>
  sessionImage?: Maybe<SessionTemplateSessionImage>
  sessionTemplateId?: Maybe<ScalarsEnums['String']>
  siteId: ScalarsEnums['String']
  siteLocationId: ScalarsEnums['String']
  siteLocationRoomId?: Maybe<ScalarsEnums['String']>
  siteSessionTypeId: ScalarsEnums['String']
  size: ScalarsEnums['Float']
  staffUserIds?: Maybe<Array<ScalarsEnums['String']>>
  startDate: ScalarsEnums['String']
  startTime: ScalarsEnums['String']
  status: ScalarsEnums['RecurringSessionStatus']
  taxEnabled: ScalarsEnums['Boolean']
  taxSettingIds?: Maybe<Array<ScalarsEnums['String']>>
  updatedAt: ScalarsEnums['String']
  waitlistEnabled: ScalarsEnums['Boolean']
  waitlistSize?: Maybe<ScalarsEnums['Float']>
}

/**
 * A single occurrence of a recurring session pattern
 */
export interface RecurringSessionInstance {
  __typename?: 'RecurringSessionInstance'
  availableSpots: ScalarsEnums['Float']
  capacity: ScalarsEnums['Float']
  currentBooked: ScalarsEnums['Float']
  currentWaitlisted: ScalarsEnums['Float']
  date: ScalarsEnums['String']
  dayOfWeek: ScalarsEnums['String']
  endTime: ScalarsEnums['String']
  isBookable: ScalarsEnums['Boolean']
  sessionId: ScalarsEnums['String']
  startTime: ScalarsEnums['String']
  waitlistEnabled: ScalarsEnums['Boolean']
  waitlistSize?: Maybe<ScalarsEnums['Float']>
}

/**
 * Response containing recurring session pattern metadata and bookable instances
 */
export interface RecurringSessionInstancesResponse {
  __typename?: 'RecurringSessionInstancesResponse'
  instances: Array<RecurringSessionInstance>
  recurrenceDaysOfWeek: Array<ScalarsEnums['String']>
}

export interface RedeemGiftCard {
  __typename?: 'RedeemGiftCard'
  giftCardId: ScalarsEnums['String']
  newAccountBalance: ScalarsEnums['String']
  redeemedAmount: ScalarsEnums['String']
}

export interface RedriveMemberMovementHomeSiteResult {
  __typename?: 'RedriveMemberMovementHomeSiteResult'
  homeSiteResolved: ScalarsEnums['Boolean']
  memberMovementId: ScalarsEnums['ID']
  status: ScalarsEnums['String']
}

export interface ReferredBy {
  __typename?: 'ReferredBy'
  referredByClientId?: Maybe<ScalarsEnums['String']>
}

export interface RefreshArticlesOnlyResult {
  __typename?: 'RefreshArticlesOnlyResult'
  articleRefresh: ArticleRefreshStats
  durationMs: ScalarsEnums['Int']
  errors: Array<ScalarsEnums['String']>
  success: ScalarsEnums['Boolean']
}

export interface RefreshCodebaseResult {
  __typename?: 'RefreshCodebaseResult'
  articleRefresh: ArticleRefreshStats
  codebaseSync: CodebaseSyncStats
  durationMs: ScalarsEnums['Int']
  errors: Array<ScalarsEnums['String']>
  success: ScalarsEnums['Boolean']
  vertexImport: VertexImportStats
}

/**
 * Result of refreshing Stripe Connect status
 */
export interface RefreshStripeStatusResult {
  __typename?: 'RefreshStripeStatusResult'
  sitePaymentGateway: RefreshStripeStatusResultSitePaymentGateway
}

export interface RefreshStripeStatusResultSitePaymentGateway {
  __typename?: 'RefreshStripeStatusResultSitePaymentGateway'
  onboardingStatus: ScalarsEnums['SitePaymentGatewayOnboardingStatus']
  sitePaymentGatewayId: ScalarsEnums['ID']
}

/**
 * A refund
 */
export interface Refund {
  __typename?: 'Refund'
  allocationMethod?: Maybe<ScalarsEnums['RefundAllocationMethod']>
  amount: ScalarsEnums['Numeric']
  attemptNumber: ScalarsEnums['Float']
  cashDrawerSessionId?: Maybe<ScalarsEnums['ID']>
  clientId?: Maybe<ScalarsEnums['ID']>
  connectedAccountRefundId?: Maybe<ScalarsEnums['String']>
  createdAt: ScalarsEnums['String']
  createdBy?: Maybe<ScalarsEnums['String']>
  currency: ScalarsEnums['Currency']
  disputeId?: Maybe<ScalarsEnums['ID']>
  externalRefundId?: Maybe<ScalarsEnums['String']>
  failureCategory?: Maybe<ScalarsEnums['FailureCategory']>
  /**
   * Gateway fee items a partial refund returned in full. Full refunds return every fee and are not itemised, so they list none.
   */
  feeItemsRefunded: Array<RefundedFeeItem>
  gatewayType?: Maybe<ScalarsEnums['SupportedPaymentGateway']>
  idempotencyKey?: Maybe<ScalarsEnums['ID']>
  invoiceId: ScalarsEnums['ID']
  /**
   * How the refund was split across the invoice items it returned, with the tax refunded on each. Empty until the refund completes.
   */
  itemAllocations: Array<RefundItemAllocation>
  origin: ScalarsEnums['RefundOrigin']
  paymentGatewayTransactionId?: Maybe<ScalarsEnums['ID']>
  paymentId: ScalarsEnums['ID']
  processedAt?: Maybe<ScalarsEnums['String']>
  providerAccountId?: Maybe<ScalarsEnums['ID']>
  rawErrorCode?: Maybe<ScalarsEnums['String']>
  rawErrorMessage?: Maybe<ScalarsEnums['String']>
  reason: ScalarsEnums['String']
  refundId: ScalarsEnums['ID']
  refundMethod: ScalarsEnums['RefundType']
  requiresPayout?: Maybe<ScalarsEnums['Boolean']>
  retryOfRefundId?: Maybe<ScalarsEnums['ID']>
  siteId: ScalarsEnums['ID']
  status: ScalarsEnums['RefundStatus']
  taxAmount?: Maybe<ScalarsEnums['Numeric']>
  updatedAt: ScalarsEnums['String']
}

/**
 * The part of a refund that returned one invoice item, split into ex-tax and tax
 */
export interface RefundItemAllocation {
  __typename?: 'RefundItemAllocation'
  amount: ScalarsEnums['Numeric']
  createdAt: ScalarsEnums['String']
  currency: ScalarsEnums['Currency']
  exTaxAmount: ScalarsEnums['Numeric']
  invoiceId: ScalarsEnums['ID']
  invoiceItemId: ScalarsEnums['ID']
  refundId: ScalarsEnums['ID']
  refundItemAllocationId: ScalarsEnums['ID']
  siteId: ScalarsEnums['ID']
  taxAmount: ScalarsEnums['Numeric']
  taxCalculations: Array<RefundItemAllocationTaxCalculation>
}

/**
 * Tax refunded under one tax setting
 */
export interface RefundItemAllocationTaxCalculation {
  __typename?: 'RefundItemAllocationTaxCalculation'
  amount: ScalarsEnums['Numeric']
  taxSetting: RefundItemAllocationTaxSetting
}

/**
 * The tax setting a refunded tax amount was charged under
 */
export interface RefundItemAllocationTaxSetting {
  __typename?: 'RefundItemAllocationTaxSetting'
  amount: ScalarsEnums['Numeric']
  name: ScalarsEnums['String']
  taxSettingId: ScalarsEnums['String']
  type: ScalarsEnums['TaxSettingType']
}

/**
 * A gateway fee item a refund returned in full
 */
export interface RefundedFeeItem {
  __typename?: 'RefundedFeeItem'
  amount: ScalarsEnums['Numeric']
  pricingCode: ScalarsEnums['RefundableGatewayFeeCode']
}

export interface Regions {
  __typename?: 'Regions'
  country?: Maybe<RegionsCountry>
  countryId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  latitude?: Maybe<ScalarsEnums['Float']>
  longitude?: Maybe<ScalarsEnums['Float']>
  name: ScalarsEnums['String']
  regionId: ScalarsEnums['ID']
  sitesCount: ScalarsEnums['Float']
  updatedAt: ScalarsEnums['String']
  zone?: Maybe<RegionsZone>
  zoneId?: Maybe<ScalarsEnums['ID']>
}

export interface RegionsCountry {
  __typename?: 'RegionsCountry'
  countryId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  currencyCode?: Maybe<ScalarsEnums['String']>
  /**
   * ISO 3166-1 alpha-2 (US, CA, GB) - null for virtual locations
   */
  isoCode?: Maybe<ScalarsEnums['String']>
  /**
   * ISO 3166-1 alpha-3 (USA, CAN, GBR) - null for virtual locations
   */
  isoCodeExtended?: Maybe<ScalarsEnums['String']>
  name?: Maybe<ScalarsEnums['String']>
  phoneCode?: Maybe<ScalarsEnums['Float']>
  stripeConfig?: Maybe<RegionsCountryStripeConfig>
  updatedAt: ScalarsEnums['String']
}

export interface RegionsCountryStripeConfig {
  __typename?: 'RegionsCountryStripeConfig'
  agreementType: ScalarsEnums['StripeAgreementType']
  /**
   * Whether to use on_behalf_of parameter in Stripe API calls - true for local acquiring, false for direct charges
   */
  onBehalfOf: ScalarsEnums['Boolean']
}

export interface RegionsZone {
  __typename?: 'RegionsZone'
  /**
   * State/Province code (e.g., CA, NY, QC) - can be full name for some countries
   */
  code: ScalarsEnums['String']
  countryId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  name: ScalarsEnums['String']
  /**
   * IANA timezone (e.g., America/New_York)
   */
  timezone?: Maybe<ScalarsEnums['String']>
  updatedAt: ScalarsEnums['String']
  zoneId: ScalarsEnums['ID']
}

/**
 * Response from registering a device token
 */
export interface RegisterDeviceTokenResponse {
  __typename?: 'RegisterDeviceTokenResponse'
  deviceTokenId?: Maybe<ScalarsEnums['String']>
  error?: Maybe<ScalarsEnums['String']>
  success: ScalarsEnums['Boolean']
}

export interface ReinitiateIncomingMovementResult {
  __typename?: 'ReinitiateIncomingMovementResult'
  blockedReason?: Maybe<ScalarsEnums['MemberMovementBlockedReason']>
  error?: Maybe<ScalarsEnums['String']>
  memberMovementId: ScalarsEnums['ID']
  outcome: ScalarsEnums['String']
}

export interface ReleaseHubAvailability {
  __typename?: 'ReleaseHubAvailability'
  kind: ScalarsEnums['ReleaseHubAvailabilityKind']
  requiredPlan?: Maybe<ScalarsEnums['String']>
  requiredTheme?: Maybe<ScalarsEnums['String']>
}

export interface ReleaseHubMonthCount {
  __typename?: 'ReleaseHubMonthCount'
  count: ScalarsEnums['Int']
  month: ScalarsEnums['String']
}

export interface ReleaseHubNote {
  __typename?: 'ReleaseHubNote'
  area?: Maybe<ScalarsEnums['String']>
  articles: Array<HelpDocSummary>
  availability: ReleaseHubAvailability
  bullets: Array<ScalarsEnums['String']>
  capabilityKey?: Maybe<ScalarsEnums['String']>
  highlights: Array<ScalarsEnums['String']>
  lead?: Maybe<ScalarsEnums['String']>
  related: Array<ReleaseHubNote>
  releaseNoteId: ScalarsEnums['ID']
  releaseType: ScalarsEnums['ReleaseHubType']
  releasedAt?: Maybe<ScalarsEnums['String']>
  scopeLevel: ScalarsEnums['ReleaseHubScope']
  screenshots: Array<ReleaseHubScreenshot>
  slug: ScalarsEnums['String']
  stage: ScalarsEnums['ReleaseHubStage']
  title: ScalarsEnums['String']
  tldr: ScalarsEnums['String']
  whoImpacted?: Maybe<ScalarsEnums['String']>
}

export interface ReleaseHubRail {
  __typename?: 'ReleaseHubRail'
  comingSoonCount: ScalarsEnums['Int']
  months: Array<ReleaseHubMonthCount>
}

export interface ReleaseHubScreenshot {
  __typename?: 'ReleaseHubScreenshot'
  alt: ScalarsEnums['String']
  caption: ScalarsEnums['String']
  url: ScalarsEnums['String']
}

export interface ReleaseNote {
  __typename?: 'ReleaseNote'
  contentMarkdown: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  createdBy: ScalarsEnums['String']
  isRead?: Maybe<ScalarsEnums['Boolean']>
  permissionTags?: Maybe<Array<ScalarsEnums['String']>>
  publishedAt?: Maybe<ScalarsEnums['String']>
  releaseNoteId: ScalarsEnums['ID']
  releaseType: ScalarsEnums['ReleaseNoteType']
  roleTags?: Maybe<Array<ScalarsEnums['String']>>
  slug: ScalarsEnums['String']
  status: ScalarsEnums['ReleaseNoteStatus']
  summary?: Maybe<ScalarsEnums['String']>
  tags?: Maybe<Array<ScalarsEnums['String']>>
  tierTags?: Maybe<Array<ScalarsEnums['String']>>
  title: ScalarsEnums['String']
  translations?: Maybe<Array<ReleaseNoteTranslation>>
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['String']>
  version?: Maybe<ScalarsEnums['String']>
}

export interface ReleaseNoteReadStatus {
  __typename?: 'ReleaseNoteReadStatus'
  readAt: ScalarsEnums['String']
  releaseNoteId: ScalarsEnums['String']
  userId: ScalarsEnums['String']
}

export interface ReleaseNoteStats {
  __typename?: 'ReleaseNoteStats'
  byStatus: ScalarsEnums['JSON']
  total: ScalarsEnums['Int']
}

export interface ReleaseNoteTranslation {
  __typename?: 'ReleaseNoteTranslation'
  contentMarkdown: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  locale: ScalarsEnums['String']
  releaseNoteId: ScalarsEnums['String']
  status: ScalarsEnums['ReleaseNoteTranslationStatus']
  summary?: Maybe<ScalarsEnums['String']>
  title: ScalarsEnums['String']
  translatedAt?: Maybe<ScalarsEnums['String']>
  translationId: ScalarsEnums['ID']
  updatedAt: ScalarsEnums['String']
}

export interface ReleaseNotesResponse {
  __typename?: 'ReleaseNotesResponse'
  releaseNotes: Array<ReleaseNote>
  total: ScalarsEnums['Int']
}

export interface ReleaseTerminalPayment {
  __typename?: 'ReleaseTerminalPayment'
  outcome: ScalarsEnums['ReleaseTerminalPaymentOutcome']
}

export interface RemapMemberMovementsLikeForLikeResult {
  __typename?: 'RemapMemberMovementsLikeForLikeResult'
  mappingSaved: ScalarsEnums['Boolean']
  movementIds: Array<ScalarsEnums['ID']>
  reviewed: ScalarsEnums['Float']
}

export interface RemoveBrandStoreTester {
  __typename?: 'RemoveBrandStoreTester'
  brandId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  email: ScalarsEnums['String']
  name?: Maybe<ScalarsEnums['String']>
  platforms: Array<ScalarsEnums['BrandPlatform']>
  source: ScalarsEnums['BrandStoreTesterSource']
  testerId: ScalarsEnums['String']
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['String']>
}

/**
 * Response for removing client from site
 */
export interface RemoveClientFromSiteResponse {
  __typename?: 'RemoveClientFromSiteResponse'
  message?: Maybe<ScalarsEnums['String']>
  success: ScalarsEnums['Boolean']
}

export interface RemoveEmailDomain {
  __typename?: 'RemoveEmailDomain'
  success: ScalarsEnums['Boolean']
}

export interface RemoveSmsPackage {
  __typename?: 'RemoveSmsPackage'
  success: ScalarsEnums['Boolean']
}

export interface RenameDevice {
  __typename?: 'RenameDevice'
  deviceTokenId: ScalarsEnums['String']
  label?: Maybe<ScalarsEnums['String']>
}

/**
 * Response indicating success of FAQ reordering
 */
export interface ReorderCorporateFaqsResponse {
  __typename?: 'ReorderCorporateFaqsResponse'
  success: ScalarsEnums['Boolean']
}

/**
 * Response indicating success of category reordering
 */
export interface ReorderPosCategoriesResponse {
  __typename?: 'ReorderPosCategoriesResponse'
  success: ScalarsEnums['Boolean']
}

/**
 * Response indicating success of service template category reordering
 */
export interface ReorderServiceTemplateCategoriesResponse {
  __typename?: 'ReorderServiceTemplateCategoriesResponse'
  success: ScalarsEnums['Boolean']
}

/**
 * Result of reordering session templates
 */
export interface ReorderSessionTemplatesResult {
  __typename?: 'ReorderSessionTemplatesResult'
  success: ScalarsEnums['Boolean']
}

/**
 * Response for reordering site session types
 */
export interface ReorderSiteSessionTypesResponse {
  __typename?: 'ReorderSiteSessionTypesResponse'
  success: ScalarsEnums['Boolean']
}

export interface ReplayBlockedMovementItemResult {
  __typename?: 'ReplayBlockedMovementItemResult'
  blockedReason?: Maybe<ScalarsEnums['String']>
  memberMovementId: ScalarsEnums['ID']
  outcome: ScalarsEnums['String']
}

export interface ReplayBlockedMovementsResult {
  __typename?: 'ReplayBlockedMovementsResult'
  replayed: ScalarsEnums['Float']
  results: Array<ReplayBlockedMovementItemResult>
  skipped: ScalarsEnums['Float']
  stillBlocked: ScalarsEnums['Float']
  total: ScalarsEnums['Float']
}

export interface ReportDefinition {
  __typename?: 'ReportDefinition'
  allowFutureDates?: Maybe<ScalarsEnums['Boolean']>
  brandOnly?: Maybe<ScalarsEnums['Boolean']>
  columns: Array<ReportDefinitionColumns>
  dateRangeDirection?: Maybe<ScalarsEnums['DateRangeDirection']>
  defaultDateRangeDays?: Maybe<ScalarsEnums['Float']>
  description: ScalarsEnums['String']
  disablePast?: Maybe<ScalarsEnums['Boolean']>
  filters: Array<ReportDefinitionFilters>
  isAggregated: ScalarsEnums['Boolean']
  label: ScalarsEnums['String']
  locked?: Maybe<ScalarsEnums['Boolean']>
  lockedFeatureKey?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['ReportName']
  permissionCategory: ScalarsEnums['ReportPermissionCategory']
  requiresDateRange: ScalarsEnums['Boolean']
}

export interface ReportDefinitionColumns {
  __typename?: 'ReportDefinitionColumns'
  companionOf?: Maybe<ScalarsEnums['String']>
  defaultVisible: ScalarsEnums['Boolean']
  filterable?: Maybe<ScalarsEnums['Boolean']>
  format?: Maybe<ScalarsEnums['ColumnFormat']>
  isRedacted?: Maybe<ScalarsEnums['Boolean']>
  key: ScalarsEnums['String']
  label: ScalarsEnums['String']
  piiClassification?: Maybe<ScalarsEnums['PiiClassification']>
  sortable: ScalarsEnums['Boolean']
  tooltip?: Maybe<ScalarsEnums['String']>
  type: ScalarsEnums['String']
}

export interface ReportDefinitionFilters {
  __typename?: 'ReportDefinitionFilters'
  defaultValue?: Maybe<ScalarsEnums['String']>
  key: ScalarsEnums['String']
  label: ScalarsEnums['String']
  multiple?: Maybe<ScalarsEnums['Boolean']>
  options?: Maybe<Array<ReportDefinitionFiltersOptions>>
  required?: Maybe<ScalarsEnums['Boolean']>
  templateTypes?: Maybe<Array<ScalarsEnums['String']>>
  type: ScalarsEnums['String']
}

export interface ReportDefinitionFiltersOptions {
  __typename?: 'ReportDefinitionFiltersOptions'
  label: ScalarsEnums['String']
  value: ScalarsEnums['String']
}

export interface ReportNotice {
  __typename?: 'ReportNotice'
  code: ScalarsEnums['String']
  level: ScalarsEnums['ReportNoticeLevel']
  message: ScalarsEnums['String']
}

export interface ReportRowGroup {
  __typename?: 'ReportRowGroup'
  breakdowns: Array<ReportRowSegment>
  continuesFromPreviousPage: ScalarsEnums['Boolean']
  continuesOnNextPage: ScalarsEnums['Boolean']
  endIndex: ScalarsEnums['Float']
  key: ScalarsEnums['String']
  label: ScalarsEnums['String']
  rowCount: ScalarsEnums['Float']
  startIndex: ScalarsEnums['Float']
  sublabel?: Maybe<ScalarsEnums['String']>
  totals?: Maybe<ScalarsEnums['JSONObject']>
}

export interface ReportRowSegment {
  __typename?: 'ReportRowSegment'
  continuesFromPreviousPage: ScalarsEnums['Boolean']
  continuesOnNextPage: ScalarsEnums['Boolean']
  endIndex: ScalarsEnums['Float']
  key: ScalarsEnums['String']
  label: ScalarsEnums['String']
  rowCount: ScalarsEnums['Float']
  startIndex: ScalarsEnums['Float']
  totals?: Maybe<ScalarsEnums['JSONObject']>
}

/**
 * The armed capture request, the terminal it armed, and when it lapses
 */
export interface RequestFobCaptureResult {
  __typename?: 'RequestFobCaptureResult'
  deviceTokenId: ScalarsEnums['ID']
  expiresAt: ScalarsEnums['String']
  requestId: ScalarsEnums['ID']
}

export interface ResetMemberExperienceBranding {
  __typename?: 'ResetMemberExperienceBranding'
  success: ScalarsEnums['Boolean']
}

export interface ResetMemberExperienceFonts {
  __typename?: 'ResetMemberExperienceFonts'
  success: ScalarsEnums['Boolean']
}

export interface ResetMemberExperienceSettings {
  __typename?: 'ResetMemberExperienceSettings'
  success: ScalarsEnums['Boolean']
}

export interface ResetToDefaults {
  __typename?: 'ResetToDefaults'
  success: ScalarsEnums['Boolean']
}

export interface ResolveMovementTemplate {
  __typename?: 'ResolveMovementTemplate'
  destinationServiceTemplateId?: Maybe<ScalarsEnums['ID']>
  matchType?: Maybe<ScalarsEnums['MemberMovementMappingMatchType']>
  unresolved: ScalarsEnums['Boolean']
}

export interface ResolvedCustomText {
  __typename?: 'ResolvedCustomText'
  customizationCount: ScalarsEnums['Float']
  customizedKeys: Array<ScalarsEnums['String']>
  language: ScalarsEnums['String']
  overrides: ScalarsEnums['JSONObject']
  totalCount: ScalarsEnums['Float']
  translations: ScalarsEnums['JSONObject']
}

/**
 * The gift card expiry policy in force for a jurisdiction today, after state/province overrides and the platform default
 */
export interface ResolvedGiftCardExpiryPolicy {
  __typename?: 'ResolvedGiftCardExpiryPolicy'
  countryId?: Maybe<ScalarsEnums['String']>
  disclosureRequired: ScalarsEnums['Boolean']
  expiryPermitted: ScalarsEnums['Boolean']
  giftCardExpiryRuleId?: Maybe<ScalarsEnums['ID']>
  legalCitation?: Maybe<ScalarsEnums['String']>
  maximumTermMonths?: Maybe<ScalarsEnums['Float']>
  minimumTermMonths?: Maybe<ScalarsEnums['Float']>
  pendingReview: ScalarsEnums['Boolean']
  source: ScalarsEnums['GiftCardExpiryRuleSource']
  zoneId?: Maybe<ScalarsEnums['String']>
}

/**
 * One site-local date with exceptions applied. dayOfWeek 0 is Monday.
 */
export interface ResolvedOpeningDay {
  __typename?: 'ResolvedOpeningDay'
  date: ScalarsEnums['String']
  dayOfWeek: ScalarsEnums['Int']
  exceptionLabel?: Maybe<ScalarsEnums['String']>
  isClosed: ScalarsEnums['Boolean']
  isOpen24Hours: ScalarsEnums['Boolean']
  ranges: Array<ResolvedOpeningRange>
}

/**
 * closesAt at or before opensAt means the range closes the next day
 */
export interface ResolvedOpeningRange {
  __typename?: 'ResolvedOpeningRange'
  closesAt: ScalarsEnums['String']
  opensAt: ScalarsEnums['String']
}

/**
 * Outcome of restarting a running tanning session on the same bed: the assignment and bed after the restart, and whether the bed started again or is cooling down
 */
export interface RestartEquipmentAssignmentResult {
  __typename?: 'RestartEquipmentAssignmentResult'
  assignment: EquipmentAssignment
  complianceWarnings: Array<EquipmentComplianceWarning>
  equipment: Equipment
  outcome: ScalarsEnums['RestartEquipmentAssignmentOutcome']
}

/**
 * How many failed form follow-up actions were queued again
 */
export interface RetryFormWorkflowEffectsResponse {
  __typename?: 'RetryFormWorkflowEffectsResponse'
  retriedCount: ScalarsEnums['Float']
}

export interface RetryMemberMovementPaymentMigrationResult {
  __typename?: 'RetryMemberMovementPaymentMigrationResult'
  paymentMigrationReason?: Maybe<ScalarsEnums['String']>
  paymentMigrationStatus?: Maybe<ScalarsEnums['String']>
}

export interface RetryPayments {
  __typename?: 'RetryPayments'
  originalPaymentId: ScalarsEnums['ID']
  payment: Payment
}

export interface RevenueTagSnapshot {
  __typename?: 'RevenueTagSnapshot'
  revenueTagGlCode?: Maybe<ScalarsEnums['String']>
  revenueTagId?: Maybe<ScalarsEnums['ID']>
  revenueTagName?: Maybe<ScalarsEnums['String']>
}

/**
 * Outcome of reversing a tanning session: the reversed assignment, plus the hardware agent error when the bed could not be reset after the reversal was committed
 */
export interface ReverseEquipmentAssignmentResult {
  __typename?: 'ReverseEquipmentAssignmentResult'
  agentResetError?: Maybe<ScalarsEnums['String']>
  assignment: EquipmentAssignment
}

export interface RevertMemberMovementResult {
  __typename?: 'RevertMemberMovementResult'
  destinationChargesTaken: Array<MemberMovementDestinationCharge>
  destinationServiceId?: Maybe<ScalarsEnums['ID']>
  homeSiteRestored: ScalarsEnums['Boolean']
  memberMovementId: ScalarsEnums['ID']
  reverted: ScalarsEnums['Boolean']
  sourceServiceId: ScalarsEnums['ID']
  status: ScalarsEnums['String']
}

export interface ReviewMemberMovementsResult {
  __typename?: 'ReviewMemberMovementsResult'
  reviewed: ScalarsEnums['Float']
}

export interface RevokeDevice {
  __typename?: 'RevokeDevice'
  deviceTokenId: ScalarsEnums['String']
}

export interface RevokeKioskSessions {
  __typename?: 'RevokeKioskSessions'
  kioskSessionId: ScalarsEnums['String']
}

/**
 * Outcome of rolling expired credits onto another pack
 */
export interface RolloverExpiredCreditsResult {
  __typename?: 'RolloverExpiredCreditsResult'
  remainingExpiredCredits: ScalarsEnums['Float']
  rolledOverCredits: ScalarsEnums['Float']
  targetBalance: ScalarsEnums['Float']
}

export interface RoomResourceTemplateImage {
  __typename?: 'RoomResourceTemplateImage'
  lastFailure?: Maybe<RoomResourceTemplateImageLastFailure>
  pending?: Maybe<RoomResourceTemplateImagePending>
  status: ScalarsEnums['FileUploadConfigFieldStatus']
  versions?: Maybe<Array<ImageFileVersion>>
}

export interface RoomResourceTemplateImageLastFailure {
  __typename?: 'RoomResourceTemplateImageLastFailure'
  errorMessage: ScalarsEnums['String']
  failedAt: ScalarsEnums['String']
  tempUrl: ScalarsEnums['String']
  uploadRequestedBy: ScalarsEnums['ID']
}

export interface RoomResourceTemplateImagePending {
  __typename?: 'RoomResourceTemplateImagePending'
  status: ScalarsEnums['FileUploadConfigFieldPendingStatus']
  tempUrl: ScalarsEnums['String']
  uploadRequestedAt: ScalarsEnums['String']
  uploadRequestedBy: ScalarsEnums['ID']
}

export interface RotateSiteWebhookSecret {
  __typename?: 'RotateSiteWebhookSecret'
  secret: ScalarsEnums['String']
}

/**
 * Template for royalties and fees configuration
 */
export interface RoyaltiesAndFeesTemplate {
  __typename?: 'RoyaltiesAndFeesTemplate'
  createdAt: ScalarsEnums['String']
  createdBy?: Maybe<ScalarsEnums['ID']>
  marketingFeeEnabled: ScalarsEnums['Boolean']
  marketingFeePayoutAccountId?: Maybe<ScalarsEnums['ID']>
  marketingFeeRate?: Maybe<ScalarsEnums['Numeric']>
  name: ScalarsEnums['String']
  royaltiesAndFeesTemplateId: ScalarsEnums['ID']
  royaltyBaseMode?: Maybe<ScalarsEnums['RoyaltyBaseMode']>
  royaltyFee1Enabled: ScalarsEnums['Boolean']
  royaltyFee1PayoutAccountId?: Maybe<ScalarsEnums['ID']>
  royaltyFee1Rate?: Maybe<ScalarsEnums['Numeric']>
  royaltyFee2Enabled: ScalarsEnums['Boolean']
  royaltyFee2PayoutAccountId?: Maybe<ScalarsEnums['ID']>
  royaltyFee2Rate?: Maybe<ScalarsEnums['Numeric']>
  /**
   * Get sites associated with this royalties and fees template
   */
  sites: Array<SitePreview>
  softwareFeeEnabled: ScalarsEnums['Boolean']
  softwareFeePayoutAccountId?: Maybe<ScalarsEnums['ID']>
  softwareFeeRate?: Maybe<ScalarsEnums['Numeric']>
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['ID']>
}

export interface RoyaltiesAndFeesTemplates {
  __typename?: 'RoyaltiesAndFeesTemplates'
  pageInfo: RoyaltiesAndFeesTemplatesPageInfo
  results: Array<RoyaltiesAndFeesTemplatesResults>
}

export interface RoyaltiesAndFeesTemplatesPageInfo {
  __typename?: 'RoyaltiesAndFeesTemplatesPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface RoyaltiesAndFeesTemplatesResults {
  __typename?: 'RoyaltiesAndFeesTemplatesResults'
  cursor: ScalarsEnums['String']
  row: RoyaltiesAndFeesTemplate
}

export interface RunReport {
  __typename?: 'RunReport'
  columns: Array<ReportDefinitionColumns>
  dataAsOf?: Maybe<ScalarsEnums['String']>
  isTruncated?: Maybe<ScalarsEnums['Boolean']>
  maxExportRows?: Maybe<ScalarsEnums['Float']>
  notices?: Maybe<Array<ReportNotice>>
  pageInfo: RunReportPageInfo
  piiRedactionApplied?: Maybe<ScalarsEnums['Boolean']>
  redactedColumnKeys?: Maybe<Array<ScalarsEnums['String']>>
  reportName: ScalarsEnums['String']
  results: Array<RunReportResults>
  rowGroups?: Maybe<Array<ReportRowGroup>>
  totalsRow?: Maybe<ScalarsEnums['JSONObject']>
}

export interface RunReportPageInfo {
  __typename?: 'RunReportPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Float']
}

export interface RunReportResults {
  __typename?: 'RunReportResults'
  cursor?: Maybe<ScalarsEnums['String']>
  row: ScalarsEnums['JSONObject']
}

export interface SandboxBrands {
  __typename?: 'SandboxBrands'
  hasNextPage: ScalarsEnums['Boolean']
  results: Array<SandboxBrandsResults>
  totalRecords: ScalarsEnums['Float']
}

export interface SandboxBrandsResults {
  __typename?: 'SandboxBrandsResults'
  corporateId: ScalarsEnums['String']
  hasSandbox: ScalarsEnums['Boolean']
  isOrphaned?: Maybe<ScalarsEnums['Boolean']>
  lastJobId?: Maybe<ScalarsEnums['String']>
  lastJobKind?: Maybe<ScalarsEnums['SandboxJobKind']>
  lastJobStatus?: Maybe<ScalarsEnums['SandboxJobStatus']>
  lastMigratedAt?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  sandboxDbId?: Maybe<ScalarsEnums['String']>
  sandboxUrl?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['String']
  urlPrefix: ScalarsEnums['String']
}

export interface SandboxMigrationJob {
  __typename?: 'SandboxMigrationJob'
  brandName: ScalarsEnums['String']
  brandSlug: ScalarsEnums['String']
  completedAt?: Maybe<ScalarsEnums['String']>
  createdAt: ScalarsEnums['String']
  createdBy: ScalarsEnums['String']
  currentStep?: Maybe<ScalarsEnums['SandboxStepName']>
  error?: Maybe<ScalarsEnums['String']>
  jobId: ScalarsEnums['String']
  startedAt?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['SandboxJobStatus']
  steps: Array<SandboxMigrationJobSteps>
  updatedAt: ScalarsEnums['String']
}

export interface SandboxMigrationJobSteps {
  __typename?: 'SandboxMigrationJobSteps'
  completedAt?: Maybe<ScalarsEnums['String']>
  error?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['SandboxStepName']
  progress?: Maybe<ScalarsEnums['Float']>
  queuedAhead?: Maybe<ScalarsEnums['Float']>
  queuedBehind?: Maybe<ScalarsEnums['String']>
  report?: Maybe<SandboxStepReport>
  startedAt?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['SandboxStepStatus']
}

/**
 * What the data_copy step patched or kept in the sandbox; clients is a sample per action when clientsTruncated
 */
export interface SandboxStepReport {
  __typename?: 'SandboxStepReport'
  clientCounts: SandboxStepReportClientCounts
  clients: Array<SandboxStepReportClient>
  clientsTruncated: ScalarsEnums['Boolean']
  corporateIdPatched: Array<SandboxStepReportPatchedTable>
  corporateIdUnpatched: Array<SandboxStepReportUnpatchedTable>
  warnings: Array<ScalarsEnums['String']>
}

/**
 * A Client row the data_copy patch anonymised or kept
 */
export interface SandboxStepReportClient {
  __typename?: 'SandboxStepReportClient'
  action: ScalarsEnums['SandboxReportClientAction']
  clientId: ScalarsEnums['ID']
  createdAt?: Maybe<ScalarsEnums['String']>
  patchedColumns: Array<ScalarsEnums['SandboxAnonymisedClientColumn']>
  source?: Maybe<ScalarsEnums['ClientSource']>
}

/**
 * Client totals per data_copy patch action
 */
export interface SandboxStepReportClientCounts {
  __typename?: 'SandboxStepReportClientCounts'
  anonymisedCopyWritten: ScalarsEnums['Float']
  anonymisedNonTestDomain: ScalarsEnums['Float']
  keptTestAccount: ScalarsEnums['Float']
}

/**
 * Rows whose corporateId was set to the sandbox id, split by who wrote them; ids are a sample when idsTruncated
 */
export interface SandboxStepReportPatchedTable {
  __typename?: 'SandboxStepReportPatchedTable'
  copyWrittenCount: ScalarsEnums['Float']
  copyWrittenIds: Array<ScalarsEnums['String']>
  idsTruncated: ScalarsEnums['Boolean']
  sandboxCreatedCount: ScalarsEnums['Float']
  sandboxCreatedIds: Array<ScalarsEnums['String']>
  table: ScalarsEnums['String']
}

/**
 * Rows with a wrong corporateId that could not be patched (corporateId is a key); ids are a sample when idsTruncated
 */
export interface SandboxStepReportUnpatchedTable {
  __typename?: 'SandboxStepReportUnpatchedTable'
  count: ScalarsEnums['Float']
  ids: Array<ScalarsEnums['String']>
  idsTruncated: ScalarsEnums['Boolean']
  table: ScalarsEnums['String']
}

/**
 * The saved form, its new revision and how many unscored pending assignments were withdrawn
 */
export interface SaveScoredSiteFormResult {
  __typename?: 'SaveScoredSiteFormResult'
  form: SiteForm
  reissueCount: ScalarsEnums['Float']
  revision: ScalarsEnums['Float']
}

/**
 * The result of publishing a config version
 */
export interface SavedBrandConfigVersion {
  __typename?: 'SavedBrandConfigVersion'
  nativeFields: Array<ScalarsEnums['String']>
  publicPayloadHash: ScalarsEnums['String']
  requiresNativeRelease: ScalarsEnums['Boolean']
  versionId: ScalarsEnums['String']
}

export interface SavedReport {
  __typename?: 'SavedReport'
  baseReportAvailable: ScalarsEnums['Boolean']
  baseReportName: ScalarsEnums['ReportName']
  categoryId?: Maybe<ScalarsEnums['String']>
  columnLabels?: Maybe<ScalarsEnums['JSONObject']>
  corporateId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  createdAtLevel: ScalarsEnums['CreatedAtLevel']
  createdAtSiteId?: Maybe<ScalarsEnums['String']>
  createdBy: ScalarsEnums['String']
  description?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  savedColumns?: Maybe<Array<ScalarsEnums['String']>>
  savedDateRange?: Maybe<SavedReportsSavedDateRange>
  savedFilters?: Maybe<ScalarsEnums['JSONObject']>
  savedReportId: ScalarsEnums['String']
  savedSiteIds?: Maybe<Array<ScalarsEnums['String']>>
  savedSort?: Maybe<Array<SavedReportsSavedSort>>
  sortOrder: ScalarsEnums['Float']
  updatedAt: ScalarsEnums['String']
  visibility: ScalarsEnums['SavedReportVisibility']
  visibilityScope: ScalarsEnums['VisibilityScope']
}

export interface SavedReportCategories {
  __typename?: 'SavedReportCategories'
  corporateId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  createdAtLevel: ScalarsEnums['CreatedAtLevel']
  createdAtSiteId?: Maybe<ScalarsEnums['String']>
  createdBy: ScalarsEnums['String']
  name: ScalarsEnums['String']
  savedReportCategoryId: ScalarsEnums['String']
  sortOrder: ScalarsEnums['Float']
  targeting?: Maybe<SavedReportsTargeting>
  updatedAt: ScalarsEnums['String']
  visibilityScope: ScalarsEnums['VisibilityScope']
}

export interface SavedReports {
  __typename?: 'SavedReports'
  baseReportAvailable: ScalarsEnums['Boolean']
  baseReportName: ScalarsEnums['ReportName']
  categoryId?: Maybe<ScalarsEnums['String']>
  columnLabels?: Maybe<ScalarsEnums['JSONObject']>
  corporateId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  createdAtLevel: ScalarsEnums['CreatedAtLevel']
  createdAtSiteId?: Maybe<ScalarsEnums['String']>
  createdBy: ScalarsEnums['String']
  description?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  savedColumns?: Maybe<Array<ScalarsEnums['String']>>
  savedDateRange?: Maybe<SavedReportsSavedDateRange>
  savedFilters?: Maybe<ScalarsEnums['JSONObject']>
  savedReportId: ScalarsEnums['String']
  savedSiteIds?: Maybe<Array<ScalarsEnums['String']>>
  savedSort?: Maybe<Array<SavedReportsSavedSort>>
  sortOrder: ScalarsEnums['Float']
  targeting?: Maybe<SavedReportsTargeting>
  updatedAt: ScalarsEnums['String']
  visibility: ScalarsEnums['SavedReportVisibility']
  visibilityScope: ScalarsEnums['VisibilityScope']
}

export interface SavedReportsSavedDateRange {
  __typename?: 'SavedReportsSavedDateRange'
  from?: Maybe<ScalarsEnums['String']>
  to?: Maybe<ScalarsEnums['String']>
  type: ScalarsEnums['DateRangeType']
  value?: Maybe<ScalarsEnums['String']>
}

export interface SavedReportsSavedSort {
  __typename?: 'SavedReportsSavedSort'
  column: ScalarsEnums['String']
  direction: ScalarsEnums['SortDirection']
}

export interface SavedReportsTargeting {
  __typename?: 'SavedReportsTargeting'
  resolvedSiteCount?: Maybe<ScalarsEnums['Float']>
  targets: Array<SavedReportsTargetingTargets>
  visibilityScope: ScalarsEnums['VisibilityScope']
}

export interface SavedReportsTargetingTargets {
  __typename?: 'SavedReportsTargetingTargets'
  targetId: ScalarsEnums['String']
  targetName?: Maybe<ScalarsEnums['String']>
  targetType: ScalarsEnums['TargetType']
}

export interface ScanAuthorizationResult {
  __typename?: 'ScanAuthorizationResult'
  accessOnly: ScalarsEnums['Boolean']
  allow: ScalarsEnums['Boolean']
  checkInType?: Maybe<ScalarsEnums['CheckInType']>
  failReason?: Maybe<ScalarsEnums['CheckInAuditFailReason']>
  isReCheckin: ScalarsEnums['Boolean']
}

/**
 * Page information for scheduled invoices pagination
 */
export interface ScheduledInvoicesPageInfo {
  __typename?: 'ScheduledInvoicesPageInfo'
  currentPage: ScalarsEnums['Float']
  hasNextPage: ScalarsEnums['Boolean']
  hasPreviousPage: ScalarsEnums['Boolean']
  pageSize: ScalarsEnums['Float']
  totalPages: ScalarsEnums['Float']
  totalRecords: ScalarsEnums['Float']
}

/**
 * A scheduled job template with live registration state and last run
 */
export interface ScheduledJob {
  __typename?: 'ScheduledJob'
  /**
   * True when the job template takes a non-empty body
   */
  acceptsPayload: ScalarsEnums['Boolean']
  cronExpression: ScalarsEnums['String']
  description: ScalarsEnums['String']
  /**
   * Handler/processor identifier (1:1 with the job name)
   */
  handlerName: ScalarsEnums['String']
  /**
   * True for FlowProducer parents whose child work runs on another queue/consumer
   */
  hasFlowChildren: ScalarsEnums['Boolean']
  /**
   * Template key, e.g. `process-scheduled-invoices-{siteId}`
   */
  jobKey: ScalarsEnums['String']
  lastRun?: Maybe<ScheduledJobRunSummary>
  level: ScalarsEnums['ScheduledJobLevel']
  manualTriggerSafety: ScalarsEnums['ScheduledJobTriggerSafety']
  /**
   * Human-readable job name
   */
  name: ScalarsEnums['String']
  /**
   * Next scheduled fire time, if registered
   */
  nextRun?: Maybe<ScalarsEnums['String']>
  /**
   * JSON-stringified schema of the job body, for rendering a trigger form
   */
  payloadSchema?: Maybe<ScalarsEnums['String']>
  /**
   * BullMQ queue the job is published to
   */
  queueName: ScalarsEnums['String']
  /**
   * Whether the job is currently registered in BullMQ
   */
  registered: ScalarsEnums['Boolean']
  timezone: ScalarsEnums['String']
}

/**
 * Full detail of a single scheduled-job run
 */
export interface ScheduledJobRun {
  __typename?: 'ScheduledJobRun'
  attempts?: Maybe<ScalarsEnums['Float']>
  /**
   * GCP Logs Explorer deep-link for this run
   */
  cloudLogsUrl: ScalarsEnums['String']
  completedAt?: Maybe<ScalarsEnums['String']>
  corporateId?: Maybe<ScalarsEnums['String']>
  durationMs?: Maybe<ScalarsEnums['Float']>
  error?: Maybe<ScalarsEnums['String']>
  /**
   * Recorded job/handler name
   */
  eventName: ScalarsEnums['String']
  jobId: ScalarsEnums['String']
  jobKey?: Maybe<ScalarsEnums['String']>
  level?: Maybe<ScalarsEnums['ScheduledJobLevel']>
  /**
   * JSON-stringified run metadata
   */
  metadata?: Maybe<ScalarsEnums['String']>
  /**
   * Job id of this node's parent in the flow tree
   */
  parentJobId?: Maybe<ScalarsEnums['String']>
  /**
   * JSON-stringified job payload
   */
  payload?: Maybe<ScalarsEnums['String']>
  /**
   * Mode the run was pinned to when it was created: shadow or flow
   */
  pipelineMode?: Maybe<ScalarsEnums['String']>
  /**
   * Run this row belongs to: `<siteId>:<runDate>` (`:m<id>` for a manual re-run)
   */
  pipelineRunKey?: Maybe<ScalarsEnums['String']>
  /**
   * Which node of the run this row is: `build` for the anchor, else the step name
   */
  pipelineStep?: Maybe<ScalarsEnums['String']>
  siteId?: Maybe<ScalarsEnums['String']>
  startedAt: ScalarsEnums['String']
  status: ScalarsEnums['ScheduledJobRunStatus']
  triggerSource?: Maybe<ScalarsEnums['ScheduledJobTriggerSource']>
}

/**
 * Summary of the latest run of a scheduled job
 */
export interface ScheduledJobRunSummary {
  __typename?: 'ScheduledJobRunSummary'
  attempts?: Maybe<ScalarsEnums['Float']>
  completedAt?: Maybe<ScalarsEnums['String']>
  durationMs?: Maybe<ScalarsEnums['Float']>
  /**
   * BullMQ job id (or `manual-<uuid>` for manual triggers)
   */
  jobId: ScalarsEnums['String']
  startedAt: ScalarsEnums['String']
  status: ScalarsEnums['ScheduledJobRunStatus']
}

/**
 * A page of scheduled-job runs plus the total match count
 */
export interface ScheduledJobRunsResult {
  __typename?: 'ScheduledJobRunsResult'
  runs: Array<ScheduledJobRun>
  /**
   * Total matching runs (for pagination)
   */
  total: ScalarsEnums['Float']
}

/**
 * Live registration status of a scheduled job
 */
export interface ScheduledJobStatus {
  __typename?: 'ScheduledJobStatus'
  cron?: Maybe<ScalarsEnums['String']>
  nextRun?: Maybe<ScalarsEnums['String']>
  registered: ScalarsEnums['Boolean']
  timezone?: Maybe<ScalarsEnums['String']>
}

export interface ScheduledPushAudiencePreview {
  __typename?: 'ScheduledPushAudiencePreview'
  recipientCount: ScalarsEnums['Float']
}

/**
 * A push notification scheduled for a site, resolved and sent at sendAt
 */
export interface ScheduledPushSend {
  __typename?: 'ScheduledPushSend'
  audienceType: ScalarsEnums['ScheduledPushAudienceType']
  createdAt: ScalarsEnums['String']
  estimatedRecipientCount: ScalarsEnums['Float']
  failureReason?: Maybe<ScalarsEnums['ScheduledPushFailureReason']>
  message: ScalarsEnums['String']
  recipientCount?: Maybe<ScalarsEnums['Float']>
  scheduledPushSendId: ScalarsEnums['ID']
  sendAt: ScalarsEnums['String']
  /**
   * Local date (yyyy-MM-dd) of the targeted session, so an edit reopens the session's day
   */
  sessionDate?: Maybe<ScalarsEnums['String']>
  sessionId?: Maybe<ScalarsEnums['ID']>
  siteId: ScalarsEnums['ID']
  status: ScalarsEnums['ScheduledPushSendStatus']
  timezone: ScalarsEnums['String']
  title: ScalarsEnums['String']
}

/**
 * Pending unscored assignments that turning on scoring would withdraw, and completed submissions that keep their past scoring
 */
export interface ScoringConversionPreview {
  __typename?: 'ScoringConversionPreview'
  completedSubmissionCount: ScalarsEnums['Float']
  pendingAssignmentCount: ScalarsEnums['Float']
  siteFormId: ScalarsEnums['String']
}

export interface SearchGoogleFonts {
  __typename?: 'SearchGoogleFonts'
  fonts: Array<SearchGoogleFontsFonts>
  limit: ScalarsEnums['Float']
  offset: ScalarsEnums['Float']
  total: ScalarsEnums['Float']
}

export interface SearchGoogleFontsFonts {
  __typename?: 'SearchGoogleFontsFonts'
  category: ScalarsEnums['String']
  family: ScalarsEnums['String']
  files: ScalarsEnums['JSONObject']
  lastModified: ScalarsEnums['String']
  subsets: Array<ScalarsEnums['String']>
  variants: Array<ScalarsEnums['String']>
  version: ScalarsEnums['String']
}

export interface SearchResult {
  __typename?: 'SearchResult'
  document: KnowledgeDocument
  relevantSnippet: ScalarsEnums['String']
  score: ScalarsEnums['Float']
}

/**
 * Self data
 */
export interface Self {
  __typename?: 'Self'
  adminPermissions?: Maybe<Array<ScalarsEnums['AdminUserPermissions']>>
  data?: Maybe<StaffUserData>
  dateOfBirth?: Maybe<ScalarsEnums['String']>
  email: ScalarsEnums['String']
  favoriteReportNames?: Maybe<Array<ScalarsEnums['String']>>
  favoriteSavedReportIds?: Maybe<Array<ScalarsEnums['ID']>>
  favoriteSiteIds?: Maybe<Array<ScalarsEnums['ID']>>
  firstName: ScalarsEnums['String']
  gender?: Maybe<ScalarsEnums['String']>
  id: ScalarsEnums['String']
  lastName: ScalarsEnums['String']
  phone?: Maybe<ScalarsEnums['String']>
  /**
   * Profile image of the user
   */
  profileImage: (args: { input: ImagePublicSignedUrlInput }) => Maybe<ImagePublicSignedUrl>
  /**
   * Site-specific data for the current user at one site: working hours, instructor status, and their default Schedule view
   */
  siteData: (args: { siteId: ScalarsEnums['ID'] }) => Maybe<SelfSiteData>
  staffUserPermissions?: Maybe<ScalarsEnums['String']>
  type: ScalarsEnums['UserType']
  /**
   * Updates the profile image
   */
  updateProfileImage: (args: {
    input: GenerateImagePublicSignedUrlInput
  }) => GenerateFileUploadUrlResponse
}

/**
 * Site-specific data for the current user
 */
export interface SelfSiteData {
  __typename?: 'SelfSiteData'
  defaultScheduleView?: Maybe<ScalarsEnums['String']>
  isInstructor: ScalarsEnums['Boolean']
  myScheduleRangeDays?: Maybe<ScalarsEnums['Int']>
  workingHours?: Maybe<StaffUserDataWorkingHours>
}

/**
 * Response for sending agreement notification email
 */
export interface SendAgreementResponse {
  __typename?: 'SendAgreementResponse'
  message: ScalarsEnums['String']
  publicUrl?: Maybe<ScalarsEnums['String']>
  success: ScalarsEnums['Boolean']
}

/**
 * Response from sending a message
 */
export interface SendMessageResponse {
  __typename?: 'SendMessageResponse'
  error?: Maybe<ScalarsEnums['String']>
  messageId?: Maybe<ScalarsEnums['String']>
  messagesFailed: ScalarsEnums['Float']
  messagesSent: ScalarsEnums['Float']
  providerUsed: ScalarsEnums['String']
  skippedDueToBlackout?: Maybe<ScalarsEnums['Float']>
  skippedOptOut?: Maybe<ScalarsEnums['Float']>
  success: ScalarsEnums['Boolean']
}

export interface SendPaymentReminder {
  __typename?: 'SendPaymentReminder'
  channels: SendPaymentReminderChannels
  skippedChannels: Array<ScalarsEnums['MessageType']>
  skippedDueToBlackout?: Maybe<ScalarsEnums['Boolean']>
  skippedDueToCredits: ScalarsEnums['Boolean']
  success: ScalarsEnums['Boolean']
  templateSource?: Maybe<ScalarsEnums['TemplateSource']>
}

export interface SendPaymentReminderChannels {
  __typename?: 'SendPaymentReminderChannels'
  email?: Maybe<SendMessageResponse>
  push?: Maybe<SendMessageResponse>
  sms?: Maybe<SendMessageResponse>
}

export interface Sentiment {
  __typename?: 'Sentiment'
  label: ScalarsEnums['String']
  magnitude: ScalarsEnums['Float']
  score: ScalarsEnums['Float']
}

/**
 * Instance of purchased service/membership for a client
 */
export interface Service {
  __typename?: 'Service'
  activatedStartDate?: Maybe<ScalarsEnums['String']>
  autoRenew: ScalarsEnums['Boolean']
  autoRenewedAt?: Maybe<ScalarsEnums['String']>
  autoRenewedToServiceId?: Maybe<ScalarsEnums['String']>
  billingCycleAmount?: Maybe<ScalarsEnums['Float']>
  billingCycleUnit?: Maybe<ScalarsEnums['String']>
  canceledAt?: Maybe<ScalarsEnums['String']>
  canceledByClientId?: Maybe<ScalarsEnums['String']>
  canceledByStaffUserId?: Maybe<ScalarsEnums['String']>
  cancellationReason?: Maybe<ScalarsEnums['String']>
  clientId: ScalarsEnums['String']
  contractSignedAt?: Maybe<ScalarsEnums['String']>
  createdAt: ScalarsEnums['String']
  createdByInvoiceId?: Maybe<ScalarsEnums['ID']>
  creditAllocationStartDate?: Maybe<ScalarsEnums['String']>
  creditBalanceSnapshot?: Maybe<CreditBalanceSnapshot>
  creditValidOverrideEndDate?: Maybe<ScalarsEnums['String']>
  expiresAt?: Maybe<ScalarsEnums['String']>
  invoiceItemId?: Maybe<ScalarsEnums['String']>
  isAllSharedSites: ScalarsEnums['Boolean']
  lastAllocationDate?: Maybe<ScalarsEnums['String']>
  manualExpiresAt?: Maybe<ScalarsEnums['String']>
  nextBillingDate?: Maybe<ScalarsEnums['String']>
  onHold: ScalarsEnums['Boolean']
  originalPrice?: Maybe<ScalarsEnums['Numeric']>
  parentServiceId?: Maybe<ScalarsEnums['ID']>
  purchasedAt: ScalarsEnums['String']
  serviceCreditAllocationSnapshot?: Maybe<ScalarsEnums['String']>
  serviceFirstBillingDate?: Maybe<ScalarsEnums['String']>
  serviceId: ScalarsEnums['String']
  serviceTemplateId: ScalarsEnums['String']
  serviceTemplateSnapshot?: Maybe<ScalarsEnums['String']>
  sharedSiteIds: Array<ScalarsEnums['String']>
  signedClientAgreementId?: Maybe<ScalarsEnums['String']>
  siteId: ScalarsEnums['String']
  soldCurrency?: Maybe<ScalarsEnums['String']>
  soldPrice?: Maybe<ScalarsEnums['Numeric']>
  startsAt: ScalarsEnums['String']
  status: ScalarsEnums['ServiceStatus']
  updatedAt: ScalarsEnums['String']
}

/**
 * Tracks scheduled cancellations for services
 */
export interface ServiceCancellation {
  __typename?: 'ServiceCancellation'
  canceledAt?: Maybe<ScalarsEnums['String']>
  canceledByClientId?: Maybe<ScalarsEnums['String']>
  canceledByStaffUserId?: Maybe<ScalarsEnums['String']>
  cancellationDate: ScalarsEnums['String']
  cancellationReason?: Maybe<ScalarsEnums['String']>
  cancellationType?: Maybe<ScalarsEnums['String']>
  chargeAmount?: Maybe<ScalarsEnums['Numeric']>
  chargeMode?: Maybe<ScalarsEnums['ServiceSuspensionChargeMode']>
  createdAt: ScalarsEnums['String']
  createdByClientId?: Maybe<ScalarsEnums['String']>
  createdByStaffUserId?: Maybe<ScalarsEnums['String']>
  executedAt?: Maybe<ScalarsEnums['String']>
  failedInvoiceIds?: Maybe<Array<ScalarsEnums['String']>>
  serviceCancellationId: ScalarsEnums['String']
  serviceId: ScalarsEnums['String']
  status: ScalarsEnums['ServiceCancellationStatus']
}

export interface ServiceCreditShareMutationResult {
  __typename?: 'ServiceCreditShareMutationResult'
  success: ScalarsEnums['Boolean']
}

export interface ServiceCreditTemplate {
  __typename?: 'ServiceCreditTemplate'
  amount?: Maybe<ScalarsEnums['Float']>
  corporateCreditLineId?: Maybe<ScalarsEnums['ID']>
  createdAt: ScalarsEnums['String']
  creditsType: ScalarsEnums['CreditType']
  expirationAmount?: Maybe<ScalarsEnums['Float']>
  expirationEnabled: ScalarsEnums['Boolean']
  expirationType?: Maybe<ScalarsEnums['CreditExpirationType']>
  expirationUnit?: Maybe<ScalarsEnums['CreditExpirationUnit']>
  locationEditedFields?: Maybe<Array<ScalarsEnums['BrandAddOnField']>>
  order: ScalarsEnums['Float']
  serviceCreditTemplateId: ScalarsEnums['String']
  serviceTemplateId: ScalarsEnums['String']
  siteSessionTypeIds: Array<ScalarsEnums['String']>
}

/**
 * The most recent staff extension or reactivation of a plan
 */
export interface ServiceExtensionSummary {
  __typename?: 'ServiceExtensionSummary'
  createdAt: ScalarsEnums['String']
  newExpiresAt: ScalarsEnums['String']
  type: ScalarsEnums['ServiceExtensionType']
}

/**
 * Single result row with service data and cursor
 */
export interface ServiceResultRow {
  __typename?: 'ServiceResultRow'
  cursor: ScalarsEnums['String']
  row: ServiceWithTemplateAndClient
}

/**
 * Defines a sellable service (package or membership)
 */
export interface ServiceTemplate {
  __typename?: 'ServiceTemplate'
  accessSchedule?: Maybe<ScalarsEnums['JSONObject']>
  accountCodeId?: Maybe<ScalarsEnums['String']>
  agreementEnabled?: Maybe<ScalarsEnums['Boolean']>
  agreementSendConfirmation?: Maybe<ScalarsEnums['Boolean']>
  agreementText?: Maybe<ScalarsEnums['String']>
  autoConvertTo?: Maybe<ScalarsEnums['String']>
  autoConvertTrigger?: Maybe<ScalarsEnums['AutoConvertTrigger']>
  autoRenewEnabled?: Maybe<ScalarsEnums['Boolean']>
  autoRenewType?: Maybe<ScalarsEnums['AutoRenewType']>
  billingAnchorDate?: Maybe<ScalarsEnums['String']>
  billingCycleAmount?: Maybe<ScalarsEnums['Float']>
  billingCycleUnit?: Maybe<ScalarsEnums['BillingCycleUnit']>
  billingDay?: Maybe<ScalarsEnums['Float']>
  cancellation?: Maybe<ServiceTemplateCancellation>
  cancellationNoticePeriodAmount?: Maybe<ScalarsEnums['Float']>
  cancellationNoticePeriodUnit?: Maybe<ScalarsEnums['CancellationNoticePeriodUnit']>
  categoryId?: Maybe<ScalarsEnums['String']>
  categoryName?: Maybe<ScalarsEnums['String']>
  changePlanEnabled: ScalarsEnums['Boolean']
  chargeSetupFeeUpFront?: Maybe<ScalarsEnums['Boolean']>
  clientOnlinePurchaseExpiryDate?: Maybe<ScalarsEnums['String']>
  clientOnlinePurchaseExpiryEnabled: ScalarsEnums['Boolean']
  corporateServiceTemplateId?: Maybe<ScalarsEnums['ID']>
  createdAt: ScalarsEnums['String']
  creditRolloverPolicy?: Maybe<ScalarsEnums['CreditRolloverPolicy']>
  creditWindowEndDate?: Maybe<ScalarsEnums['String']>
  credits?: Maybe<Array<ServiceCreditTemplate>>
  description?: Maybe<ScalarsEnums['String']>
  displayOrder?: Maybe<ScalarsEnums['Float']>
  dynamicDisplayServiceTemplateIds: Array<ScalarsEnums['String']>
  earlyAccessDurationAmount?: Maybe<ScalarsEnums['Float']>
  earlyAccessDurationUnit?: Maybe<ScalarsEnums['EarlyAccessDurationUnit']>
  expiryAlertInDays?: Maybe<ScalarsEnums['Float']>
  extraBookingWindow: ScalarsEnums['Float']
  familyShareable: ScalarsEnums['Boolean']
  feeRevenueTags?: Maybe<ServiceTemplateFeeRevenueTags>
  firstCreditAllocationDate?: Maybe<ServiceTemplateFirstCreditAllocationDate>
  futureStartDate?: Maybe<ScalarsEnums['String']>
  guestPassAllowance?: Maybe<ServiceTemplateGuestPassAllowance>
  inheritAgreementsOnConvert?: Maybe<ScalarsEnums['Boolean']>
  isAllSharedSites: ScalarsEnums['Boolean']
  isClientControlEnabled?: Maybe<ScalarsEnums['Boolean']>
  isDefaultForTransferredClient?: Maybe<ScalarsEnums['Boolean']>
  isEnabledForCMS: ScalarsEnums['Boolean']
  isFeatured: ScalarsEnums['Boolean']
  isIntroOffer: ScalarsEnums['Boolean']
  isRestricted: ScalarsEnums['Boolean']
  lengthAmount?: Maybe<ScalarsEnums['Float']>
  lengthType?: Maybe<ScalarsEnums['ServiceLengthType']>
  lengthUnit?: Maybe<ScalarsEnums['ServiceLengthUnit']>
  limitSale?: Maybe<ServiceTemplateLimitSale>
  locationEditedFields?: Maybe<Array<ScalarsEnums['BrandAddOnField']>>
  lockedSections?: Maybe<Array<ScalarsEnums['BrandServiceTemplateSection']>>
  maxSharingCredits?: Maybe<ScalarsEnums['Float']>
  maxSharingRecipients?: Maybe<ScalarsEnums['Float']>
  minimumHomeUsageInDays?: Maybe<ScalarsEnums['Float']>
  multiplePaymentOptions?: Maybe<ServiceTemplateMultiplePaymentOptions>
  name: ScalarsEnums['String']
  newSaleDynamicDisplayServiceTemplateIds: Array<ScalarsEnums['String']>
  oneActivePerFamily: ScalarsEnums['Boolean']
  oneTimeSetupFee?: Maybe<ScalarsEnums['Numeric']>
  oneTimeSetupFeeTaxEnabled?: Maybe<ScalarsEnums['Boolean']>
  oneTimeSetupFeeTaxSettingIds?: Maybe<Array<ScalarsEnums['ID']>>
  onlineSaleEnabled: ScalarsEnums['Boolean']
  onlineSaleStartDate?: Maybe<ScalarsEnums['String']>
  payUpFrontEnabled?: Maybe<ScalarsEnums['Boolean']>
  price: ScalarsEnums['Numeric']
  revenueTag?: Maybe<ScalarsEnums['String']>
  saleAvailableFromDate?: Maybe<ScalarsEnums['String']>
  saleAvailableUntilDate?: Maybe<ScalarsEnums['String']>
  secondaryRecurringFee?: Maybe<ServiceTemplateSecondaryRecurringFee>
  selfServicePause?: Maybe<ServiceTemplateSelfServicePause>
  serviceFirstBillingDate?: Maybe<ServiceTemplateFirstPaymentDate>
  serviceTemplateId: ScalarsEnums['String']
  sharedSiteIds: Array<ScalarsEnums['String']>
  sharingCreditsAmount?: Maybe<ScalarsEnums['Float']>
  sharingCreditsEnabled: ScalarsEnums['Boolean']
  siteAgreementTemplateId?: Maybe<ScalarsEnums['String']>
  siteId: ScalarsEnums['String']
  status: ScalarsEnums['ServiceTemplateStatus']
  taxEnabled: ScalarsEnums['Boolean']
  taxSettingIds?: Maybe<Array<ScalarsEnums['ID']>>
  tierOrder?: Maybe<ScalarsEnums['Float']>
  toServiceTemplateId?: Maybe<ScalarsEnums['String']>
  type: ScalarsEnums['ServiceTemplateType']
  updatedAt: ScalarsEnums['String']
}

/**
 * Attachment config linking an add-on template to a parent service template
 */
export interface ServiceTemplateAddOn {
  __typename?: 'ServiceTemplateAddOn'
  addOnServiceTemplateId: ScalarsEnums['ID']
  corporatePricePointId?: Maybe<ScalarsEnums['ID']>
  createdAt: ScalarsEnums['String']
  enabled: ScalarsEnums['Boolean']
  locationEditedFields?: Maybe<Array<ScalarsEnums['BrandAddOnField']>>
  parentServiceTemplateId: ScalarsEnums['ID']
  paymentType: ScalarsEnums['ServiceTemplateAddOnPaymentType']
  price: ScalarsEnums['Numeric']
  serviceTemplateAddOnId: ScalarsEnums['ID']
  siteId: ScalarsEnums['ID']
  taxEnabled: ScalarsEnums['Boolean']
  taxSettingIds?: Maybe<Array<ScalarsEnums['ID']>>
  updatedAt: ScalarsEnums['String']
}

/**
 * An ACTIVE parent template an add-on template is enabled on, with its name
 */
export interface ServiceTemplateAddOnEligibleParent {
  __typename?: 'ServiceTemplateAddOnEligibleParent'
  addOnServiceTemplateId: ScalarsEnums['ID']
  parentName: ScalarsEnums['String']
  parentServiceTemplateId: ScalarsEnums['ID']
}

/**
 * An enabled add-on attachment enriched with the add-on template's display fields
 */
export interface ServiceTemplateAddOnForParent {
  __typename?: 'ServiceTemplateAddOnForParent'
  addOnServiceTemplateId: ScalarsEnums['ID']
  agreementEnabled?: Maybe<ScalarsEnums['Boolean']>
  categoryId?: Maybe<ScalarsEnums['String']>
  corporatePricePointId?: Maybe<ScalarsEnums['ID']>
  createdAt: ScalarsEnums['String']
  credits: Array<ServiceCreditTemplate>
  description?: Maybe<ScalarsEnums['String']>
  enabled: ScalarsEnums['Boolean']
  isFeatured: ScalarsEnums['Boolean']
  locationEditedFields?: Maybe<Array<ScalarsEnums['BrandAddOnField']>>
  name: ScalarsEnums['String']
  parentServiceTemplateId: ScalarsEnums['ID']
  paymentType: ScalarsEnums['ServiceTemplateAddOnPaymentType']
  price: ScalarsEnums['Numeric']
  serviceTemplateAddOnId: ScalarsEnums['ID']
  siteId: ScalarsEnums['ID']
  taxEnabled: ScalarsEnums['Boolean']
  taxSettingIds?: Maybe<Array<ScalarsEnums['ID']>>
  updatedAt: ScalarsEnums['String']
}

/**
 * An add-on template's parent attachments and active-instance count
 */
export interface ServiceTemplateAddOnSummary {
  __typename?: 'ServiceTemplateAddOnSummary'
  activeClientCount: ScalarsEnums['Float']
  addOnServiceTemplateId: ScalarsEnums['ID']
  parents: Array<ServiceTemplateAddOn>
}

export interface ServiceTemplateCancellation {
  __typename?: 'ServiceTemplateCancellation'
  effectiveDateRule?: Maybe<ScalarsEnums['CancellationEffectiveDateRule']>
  feeSchedule?: Maybe<ServiceTemplateCancellationFeeSchedule>
  isEnabledForClient: ScalarsEnums['Boolean']
  minimumTerm?: Maybe<ServiceTemplateCancellationMinimumTerm>
  noticePeriodDays?: Maybe<ScalarsEnums['Float']>
}

export interface ServiceTemplateCancellationFeeSchedule {
  __typename?: 'ServiceTemplateCancellationFeeSchedule'
  basis: ScalarsEnums['CancellationTierBasis']
  enabled: ScalarsEnums['Boolean']
  tiers: Array<ServiceTemplateCancellationFeeScheduleTiers>
}

export interface ServiceTemplateCancellationFeeScheduleTiers {
  __typename?: 'ServiceTemplateCancellationFeeScheduleTiers'
  amount?: Maybe<ScalarsEnums['Numeric']>
  kind: ScalarsEnums['CancellationFeeValueKind']
  percent?: Maybe<ScalarsEnums['Float']>
  until: ScalarsEnums['Float']
}

export interface ServiceTemplateCancellationMinimumTerm {
  __typename?: 'ServiceTemplateCancellationMinimumTerm'
  after?: Maybe<ServiceTemplateCancellationMinimumTermAfter>
  charge?: Maybe<ServiceTemplateCancellationMinimumTermCharge>
  enabled: ScalarsEnums['Boolean']
}

export interface ServiceTemplateCancellationMinimumTermAfter {
  __typename?: 'ServiceTemplateCancellationMinimumTermAfter'
  amount: ScalarsEnums['Float']
  unit: ScalarsEnums['MinimumTermAfterUnit']
}

export interface ServiceTemplateCancellationMinimumTermCharge {
  __typename?: 'ServiceTemplateCancellationMinimumTermCharge'
  amount: ScalarsEnums['Numeric']
  isTaxEnabled: ScalarsEnums['Boolean']
  taxSettingIds: Array<ScalarsEnums['ID']>
}

export interface ServiceTemplateFeeRevenueTags {
  __typename?: 'ServiceTemplateFeeRevenueTags'
  cancellationFee?: Maybe<ScalarsEnums['ID']>
  oneTimeSetupFee?: Maybe<ScalarsEnums['ID']>
  secondaryRecurringFee?: Maybe<ScalarsEnums['ID']>
  suspensionFee?: Maybe<ScalarsEnums['ID']>
}

export interface ServiceTemplateFilterOption {
  __typename?: 'ServiceTemplateFilterOption'
  name: ScalarsEnums['String']
  serviceTemplateId: ScalarsEnums['String']
  status: ScalarsEnums['ServiceTemplateStatus']
  type: ScalarsEnums['ServiceTemplateType']
}

export interface ServiceTemplateFirstCreditAllocationDate {
  __typename?: 'ServiceTemplateFirstCreditAllocationDate'
  enabled: ScalarsEnums['Boolean']
  firstCreditAllocationDateType?: Maybe<ScalarsEnums['FirstCreditAllocationDateType']>
  onDate?: Maybe<ScalarsEnums['String']>
}

export interface ServiceTemplateFirstPaymentDate {
  __typename?: 'ServiceTemplateFirstPaymentDate'
  after?: Maybe<ServiceTemplateFirstPaymentDateAfter>
  enabled: ScalarsEnums['Boolean']
  onDate?: Maybe<ScalarsEnums['String']>
}

export interface ServiceTemplateFirstPaymentDateAfter {
  __typename?: 'ServiceTemplateFirstPaymentDateAfter'
  amount: ScalarsEnums['Float']
  unit: ScalarsEnums['FirstPaymentAfterUnit']
}

export interface ServiceTemplateGuestPassAllowance {
  __typename?: 'ServiceTemplateGuestPassAllowance'
  amountPerCycle?: Maybe<ScalarsEnums['Float']>
  carryForwardCap?: Maybe<ScalarsEnums['Float']>
  companionTemplateId?: Maybe<ScalarsEnums['ID']>
  creditLines?: Maybe<Array<ServiceTemplateGuestPassCreditLine>>
  enabled: ScalarsEnums['Boolean']
  expiryBehaviour?: Maybe<ScalarsEnums['GuestPassExpiryBehaviour']>
  intervalAmount?: Maybe<ScalarsEnums['Float']>
  intervalUnit?: Maybe<ScalarsEnums['BillingCycleUnit']>
  newClientsOnlyEnabled: ScalarsEnums['Boolean']
  passesPerInterval?: Maybe<ScalarsEnums['Float']>
  siteSessionTypeIds?: Maybe<Array<ScalarsEnums['ID']>>
}

export interface ServiceTemplateGuestPassCreditLine {
  __typename?: 'ServiceTemplateGuestPassCreditLine'
  credits: ScalarsEnums['Float']
  serviceCreditTemplateId?: Maybe<ScalarsEnums['ID']>
  siteSessionTypeIds: Array<ScalarsEnums['ID']>
}

export interface ServiceTemplateLimitSale {
  __typename?: 'ServiceTemplateLimitSale'
  perAccount?: Maybe<ScalarsEnums['Float']>
  perClient?: Maybe<ScalarsEnums['Float']>
}

export interface ServiceTemplateMultiplePaymentOptions {
  __typename?: 'ServiceTemplateMultiplePaymentOptions'
  payNowMode: ScalarsEnums['PaymentMode']
  recurringMode: ScalarsEnums['PaymentMode']
}

export interface ServiceTemplateOption {
  __typename?: 'ServiceTemplateOption'
  categoryId?: Maybe<ScalarsEnums['String']>
  categoryName?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  serviceTemplateId: ScalarsEnums['String']
  siteId: ScalarsEnums['String']
  siteName?: Maybe<ScalarsEnums['String']>
  type: ScalarsEnums['ServiceTemplateType']
}

export interface ServiceTemplateSecondaryRecurringFee {
  __typename?: 'ServiceTemplateSecondaryRecurringFee'
  amount: ScalarsEnums['Numeric']
  billingCycleAmount?: Maybe<ScalarsEnums['Float']>
  billingCycleUnit?: Maybe<ScalarsEnums['BillingCycleUnit']>
  enabled: ScalarsEnums['Boolean']
  serviceFirstBillingDate?: Maybe<ServiceTemplateFirstPaymentDate>
  taxEnabled: ScalarsEnums['Boolean']
  taxSettingIds?: Maybe<Array<ScalarsEnums['ID']>>
}

export interface ServiceTemplateSelfServicePause {
  __typename?: 'ServiceTemplateSelfServicePause'
  enabled: ScalarsEnums['Boolean']
  fee: ServiceTemplateSelfServicePauseFee
  noticePeriodDays?: Maybe<ScalarsEnums['Float']>
  suspensionType: ScalarsEnums['ServiceSuspensionType']
}

export interface ServiceTemplateSelfServicePauseFee {
  __typename?: 'ServiceTemplateSelfServicePauseFee'
  amount?: Maybe<ScalarsEnums['Numeric']>
  cadence?: Maybe<ServiceTemplateSelfServicePauseFeeCadence>
  chargeMode: ScalarsEnums['SelfServicePauseChargeMode']
}

export interface ServiceTemplateSelfServicePauseFeeCadence {
  __typename?: 'ServiceTemplateSelfServicePauseFeeCadence'
  amount: ScalarsEnums['Float']
  unit: ScalarsEnums['SelfServicePauseCadenceUnit']
}

/**
 * Add-on pricing row: per-session charge when client has no service credits (membership or package)
 */
export interface ServiceTemplateSessionTypeAddOn {
  __typename?: 'ServiceTemplateSessionTypeAddOn'
  addOnName?: Maybe<ScalarsEnums['String']>
  /**
   * The price group that wrote this price; null for a price set by hand, which no group changes
   */
  addOnPriceGroupId?: Maybe<ScalarsEnums['ID']>
  createdAt: ScalarsEnums['String']
  /**
   * Retired (OC-857): a price applies to every machine offering the session type. Always null; ignored on input.
   */
  equipmentId?: Maybe<ScalarsEnums['ID']>
  fromServiceTemplateId: ScalarsEnums['ID']
  price: ScalarsEnums['Numeric']
  serviceTemplateSessionTypeAddOnId: ScalarsEnums['ID']
  siteId: ScalarsEnums['ID']
  siteSessionTypeId: ScalarsEnums['ID']
  taxSettingIds?: Maybe<Array<ScalarsEnums['ID']>>
  updatedAt: ScalarsEnums['String']
}

export interface ServiceTemplatesPaginated {
  __typename?: 'ServiceTemplatesPaginated'
  pageInfo: ServiceTemplatesPaginatedPageInfo
  results: Array<ServiceTemplatesPaginatedResults>
}

export interface ServiceTemplatesPaginatedPageInfo {
  __typename?: 'ServiceTemplatesPaginatedPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface ServiceTemplatesPaginatedResults {
  __typename?: 'ServiceTemplatesPaginatedResults'
  cursor: ScalarsEnums['String']
  row: ServiceTemplate
}

/**
 * Service with associated template and client information
 */
export interface ServiceWithTemplateAndClient {
  __typename?: 'ServiceWithTemplateAndClient'
  activatedStartDate?: Maybe<ScalarsEnums['String']>
  autoRenew: ScalarsEnums['Boolean']
  billingCycleAmount?: Maybe<ScalarsEnums['Float']>
  billingCycleUnit?: Maybe<ScalarsEnums['String']>
  canceledAt?: Maybe<ScalarsEnums['String']>
  canceledByStaffUserId?: Maybe<ScalarsEnums['String']>
  cancellationReason?: Maybe<ScalarsEnums['String']>
  /**
   * Client associated with this service
   */
  client?: Maybe<ServiceWithTemplateAndClientClient>
  clientId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  createdByInvoiceId?: Maybe<ScalarsEnums['ID']>
  creditBalanceSnapshot?: Maybe<CreditBalanceSnapshotOutput>
  expiresAt?: Maybe<ScalarsEnums['String']>
  invoiceItemId?: Maybe<ScalarsEnums['String']>
  lastAllocationDate?: Maybe<ScalarsEnums['String']>
  nextBillingDate?: Maybe<ScalarsEnums['String']>
  onHold: ScalarsEnums['Boolean']
  purchasedAt: ScalarsEnums['String']
  serviceId: ScalarsEnums['String']
  serviceTemplate?: Maybe<ServiceWithTemplateAndClientServiceTemplate>
  serviceTemplateId: ScalarsEnums['String']
  siteId: ScalarsEnums['String']
  startsAt: ScalarsEnums['String']
  status: ScalarsEnums['ServiceStatus']
  updatedAt: ScalarsEnums['String']
}

export interface ServiceWithTemplateAndClientClient {
  __typename?: 'ServiceWithTemplateAndClientClient'
  alerts?: Maybe<Array<ServiceWithTemplateAndClientClientAlerts>>
  clientId: ScalarsEnums['ID']
  email?: Maybe<ScalarsEnums['String']>
  firstName?: Maybe<ScalarsEnums['String']>
  lastName?: Maybe<ScalarsEnums['String']>
}

export interface ServiceWithTemplateAndClientClientAlerts {
  __typename?: 'ServiceWithTemplateAndClientClientAlerts'
  clientId: ScalarsEnums['String']
  data?: Maybe<ScalarsEnums['JSONObject']>
  requiresFetch: ScalarsEnums['Boolean']
  type: ScalarsEnums['String']
}

export interface ServiceWithTemplateAndClientServiceTemplate {
  __typename?: 'ServiceWithTemplateAndClientServiceTemplate'
  name: ScalarsEnums['String']
  type: ScalarsEnums['ServiceTemplateType']
}

/**
 * Paginated list of services
 */
export interface ServicesPaginationResult {
  __typename?: 'ServicesPaginationResult'
  pageInfo: ServicesPaginationResultPageInfo
  results: Array<ServiceResultRow>
}

export interface ServicesPaginationResultPageInfo {
  __typename?: 'ServicesPaginationResultPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Float']
}

/**
 * A single data point for services sold trend
 */
export interface ServicesSoldItem {
  __typename?: 'ServicesSoldItem'
  count: ScalarsEnums['Float']
  date: ScalarsEnums['String']
  serviceType: ScalarsEnums['String']
}

/**
 * A scheduled session
 */
export interface Session {
  __typename?: 'Session'
  /**
   * Per-provider aggregator configurations for this session
   */
  aggregatorConfigs: Array<SessionAggregatorConfig>
  allowOverlappingSessions: ScalarsEnums['Boolean']
  bookedCount?: Maybe<ScalarsEnums['Float']>
  /**
   * Computed booking availability based on session status, capacity, time, and site booking window rules (rolling/timed release, waitlist lock period). Member-aware: for an authenticated client, the rolling-release horizon is widened by the largest advanced-booking bonus granted by their active memberships at this site
   */
  bookingAvailability: ScalarsEnums['BookingAvailability']
  /**
   * All bookings for this session
   */
  bookings: Array<Booking>
  category: ScalarsEnums['SessionCategory']
  createdAt?: Maybe<ScalarsEnums['String']>
  creditsRequired: ScalarsEnums['Float']
  customCancelPolicy?: Maybe<SessionTemplateCustomCancelPolicy>
  customFields?: Maybe<Array<SessionTemplateCustomFields>>
  customReleaseSchedule?: Maybe<SessionTemplateCustomReleaseSchedule>
  date: ScalarsEnums['String']
  deletedAt?: Maybe<ScalarsEnums['String']>
  deletedBy?: Maybe<ScalarsEnums['String']>
  description?: Maybe<ScalarsEnums['String']>
  disabledSpotIds?: Maybe<Array<ScalarsEnums['Float']>>
  dropinPrice: ScalarsEnums['Numeric']
  /**
   * Session duration in hours and minutes
   */
  duration: SessionDuration
  endTime: ScalarsEnums['String']
  /**
   * Staff user details for session instructors
   */
  instructor: Array<SessionInstructor>
  /**
   * True when the session has not been released for booking yet: beyond the rolling-release horizon (widened by the caller's advanced booking window when the caller is a member) or the timed release. Workshops are never beyond the window. Member booking paths reject these sessions
   */
  isBeyondBookingWindow: ScalarsEnums['Boolean']
  isBlockSlot: ScalarsEnums['Boolean']
  isImported: ScalarsEnums['Boolean']
  isModified: ScalarsEnums['Boolean']
  isPaymentRequired: ScalarsEnums['Boolean']
  isRequestBookingEnabled: ScalarsEnums['Boolean']
  isRequiredSessionFeedback: ScalarsEnums['Boolean']
  isRequiredTwoPartAuthentication: ScalarsEnums['Boolean']
  isRoomResourceEnabled: ScalarsEnums['Boolean']
  /**
   * Indicates whether this session is virtual (calculated from a recurring pattern) or materialized (stored in database)
   */
  isVirtualized: ScalarsEnums['Boolean']
  itemsSupplied?: Maybe<ScalarsEnums['String']>
  itemsToBring?: Maybe<ScalarsEnums['String']>
  lateCancelFeeId?: Maybe<ScalarsEnums['String']>
  lateCancelFeeMode?: Maybe<ScalarsEnums['SessionFeeMode']>
  /**
   * Location details
   */
  location?: Maybe<SessionLocation>
  locationName?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  noShowFeeId?: Maybe<ScalarsEnums['String']>
  noShowFeeMode?: Maybe<ScalarsEnums['SessionFeeMode']>
  recurrenceDate?: Maybe<ScalarsEnums['String']>
  /**
   * The recurring session pattern this session belongs to
   */
  recurringSession?: Maybe<RecurringSession>
  recurringSessionsId?: Maybe<ScalarsEnums['String']>
  revenueTagId?: Maybe<ScalarsEnums['String']>
  /**
   * Room details
   */
  room?: Maybe<SessionRoom>
  roomHasResourceBooking?: Maybe<ScalarsEnums['Boolean']>
  roomName?: Maybe<ScalarsEnums['String']>
  roomResourceTemplateId?: Maybe<ScalarsEnums['String']>
  sessionId: ScalarsEnums['String']
  /**
   * Session image with presigned URLs
   */
  sessionImage: (args?: {
    formats?: Maybe<Array<ScalarsEnums['String']>>
    variants?: Maybe<Array<ScalarsEnums['String']>>
  }) => Maybe<SessionTemplateSessionImage>
  sessionTemplateId?: Maybe<ScalarsEnums['String']>
  sessionTypeColor?: Maybe<ScalarsEnums['String']>
  sessionTypeName?: Maybe<ScalarsEnums['String']>
  siteId: ScalarsEnums['String']
  siteLocationId: ScalarsEnums['String']
  siteLocationRoomId?: Maybe<ScalarsEnums['String']>
  /**
   * Session type details
   */
  siteSessionType?: Maybe<SessionSiteSessionType>
  siteSessionTypeId: ScalarsEnums['String']
  size: ScalarsEnums['Float']
  /**
   * Array of staff user IDs assigned to this session
   */
  staffUserIds: Array<ScalarsEnums['String']>
  startTime: ScalarsEnums['String']
  status: ScalarsEnums['SessionStatus']
  taxEnabled: ScalarsEnums['Boolean']
  taxSettingIds?: Maybe<Array<ScalarsEnums['String']>>
  updatedAt?: Maybe<ScalarsEnums['String']>
  waitlistBatchSize?: Maybe<ScalarsEnums['Float']>
  waitlistEnabled: ScalarsEnums['Boolean']
  waitlistInvitationStrategy?: Maybe<ScalarsEnums['WaitlistInvitationStrategy']>
  waitlistInvitationTimeout?: Maybe<ScalarsEnums['Float']>
  waitlistSize?: Maybe<ScalarsEnums['Float']>
  /**
   * Member Zoom join link — staff/admin see it directly; a client sees it only for an occurrence they hold an active booking on
   */
  zoomJoinUrl?: Maybe<ScalarsEnums['String']>
  /**
   * Zoom meeting id — staff/admin only; never exposed to members
   */
  zoomMeetingId?: Maybe<ScalarsEnums['String']>
  /**
   * Zoom HOST start link (grants host control) — staff/admin only; never exposed to members
   */
  zoomStartUrl?: Maybe<ScalarsEnums['String']>
}

/**
 * Per-provider spot allocation configuration for a session
 */
export interface SessionAggregatorConfig {
  __typename?: 'SessionAggregatorConfig'
  aggregatorProviderId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  externalClassId?: Maybe<ScalarsEnums['String']>
  externalSlotId?: Maybe<ScalarsEnums['String']>
  isEnabled: ScalarsEnums['Boolean']
  sessionId: ScalarsEnums['String']
  spotLimit?: Maybe<ScalarsEnums['Float']>
  updatedAt: ScalarsEnums['String']
}

/**
 * Booking results for all clients in a single session
 */
export interface SessionBookingResult {
  __typename?: 'SessionBookingResult'
  clientResults: Array<ClientBookingResult>
  date: ScalarsEnums['String']
  sessionId: ScalarsEnums['String']
}

/**
 * What a delete would remove: scheduled sessions, active bookings, distinct booked members and waitlist entries; endsSeries means later, not-yet-generated occurrences are removed too
 */
export interface SessionDeletionPreview {
  __typename?: 'SessionDeletionPreview'
  activeBookingCount: ScalarsEnums['Float']
  bookedMemberCount: ScalarsEnums['Float']
  endsSeries: ScalarsEnums['Boolean']
  sessionCount: ScalarsEnums['Float']
  waitlistCount: ScalarsEnums['Float']
}

export interface SessionDuration {
  __typename?: 'SessionDuration'
  hours: ScalarsEnums['Float']
  minutes: ScalarsEnums['Float']
}

/**
 * The fee a session charges for one fee type, after modes and custom fees apply
 */
export interface SessionFee {
  __typename?: 'SessionFee'
  feeId?: Maybe<ScalarsEnums['ID']>
  name?: Maybe<ScalarsEnums['String']>
  price: ScalarsEnums['String']
  source: ScalarsEnums['SessionFeeSource']
  unlimitedCreditsOnly: ScalarsEnums['Boolean']
}

export interface SessionFeedback {
  __typename?: 'SessionFeedback'
  attendanceId: ScalarsEnums['String']
  clientId: ScalarsEnums['String']
  comments?: Maybe<ScalarsEnums['String']>
  createdAt: ScalarsEnums['String']
  deletedAt?: Maybe<ScalarsEnums['String']>
  feedbackAnswers?: Maybe<Array<SessionFeedbackFeedbackAnswers>>
  overallRating?: Maybe<ScalarsEnums['Float']>
  sessionFeedbackId: ScalarsEnums['String']
  sessionId: ScalarsEnums['String']
  siteId: ScalarsEnums['String']
  submittedAt: ScalarsEnums['String']
  updatedAt: ScalarsEnums['String']
}

export interface SessionFeedbackFeedbackAnswers {
  __typename?: 'SessionFeedbackFeedbackAnswers'
  answer: ScalarsEnums['String']
  questionId: ScalarsEnums['String']
  questionText: ScalarsEnums['String']
}

/**
 * A configured question in a site's session feedback form
 */
export interface SessionFeedbackQuestion {
  __typename?: 'SessionFeedbackQuestion'
  active: ScalarsEnums['Boolean']
  answerType: ScalarsEnums['SessionFeedbackAnswerType']
  characterLimit?: Maybe<ScalarsEnums['Float']>
  createdAt: ScalarsEnums['String']
  deletedAt?: Maybe<ScalarsEnums['String']>
  helperText?: Maybe<ScalarsEnums['String']>
  maxLabel?: Maybe<ScalarsEnums['String']>
  minLabel?: Maybe<ScalarsEnums['String']>
  orderIndex: ScalarsEnums['Float']
  presetKey?: Maybe<ScalarsEnums['String']>
  questionText: ScalarsEnums['String']
  required: ScalarsEnums['Boolean']
  scaleMax?: Maybe<ScalarsEnums['Float']>
  sessionFeedbackQuestionId: ScalarsEnums['String']
  siteId: ScalarsEnums['String']
  sliderMax?: Maybe<ScalarsEnums['Float']>
  sliderMin?: Maybe<ScalarsEnums['Float']>
  updatedAt: ScalarsEnums['String']
}

/**
 * Response for a session feedback question delete
 */
export interface SessionFeedbackQuestionDeleteResponse {
  __typename?: 'SessionFeedbackQuestionDeleteResponse'
  deleted: ScalarsEnums['Boolean']
}

/**
 * Response containing the count of reordered questions
 */
export interface SessionFeedbackQuestionReorderResponse {
  __typename?: 'SessionFeedbackQuestionReorderResponse'
  updatedCount: ScalarsEnums['Float']
}

/**
 * A session's feedback status for one member
 */
export interface SessionFeedbackStatusEntry {
  __typename?: 'SessionFeedbackStatusEntry'
  sessionId: ScalarsEnums['ID']
  status: ScalarsEnums['SessionFeedbackStatus']
}

/**
 * The resolved no-show and late-cancel fees of a session; null means no fee
 */
export interface SessionFees {
  __typename?: 'SessionFees'
  lateCancel?: Maybe<SessionFee>
  noShow?: Maybe<SessionFee>
}

/**
 * Session filter with filter criteria
 */
export interface SessionFilter {
  __typename?: 'SessionFilter'
  calendarMode?: Maybe<ScalarsEnums['SessionFilterCalendarMode']>
  createdBy?: Maybe<ScalarsEnums['String']>
  filters?: Maybe<ScalarsEnums['JSONObject']>
  id: ScalarsEnums['String']
  isDefault: ScalarsEnums['Boolean']
  isVisible: ScalarsEnums['Boolean']
  name: ScalarsEnums['String']
  siteId: ScalarsEnums['String']
  sortOrder: ScalarsEnums['Float']
  visibility: ScalarsEnums['SessionFilterVisibility']
}

export interface SessionInstructor {
  __typename?: 'SessionInstructor'
  firstName: ScalarsEnums['String']
  lastName: ScalarsEnums['String']
  name: ScalarsEnums['String']
  role: ScalarsEnums['String']
  staffUserId: ScalarsEnums['String']
}

/**
 * Simplified location for session field resolver
 */
export interface SessionLocation {
  __typename?: 'SessionLocation'
  name: ScalarsEnums['String']
}

/**
 * Simplified room for session field resolver
 */
export interface SessionRoom {
  __typename?: 'SessionRoom'
  hasResourceBooking?: Maybe<ScalarsEnums['Boolean']>
  name: ScalarsEnums['String']
  roomResourceTemplateId?: Maybe<ScalarsEnums['String']>
}

/**
 * Simplified session type for session field resolver
 */
export interface SessionSiteSessionType {
  __typename?: 'SessionSiteSessionType'
  color?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['String']
}

/**
 * A session template for creating sessions
 */
export interface SessionTemplate {
  __typename?: 'SessionTemplate'
  allowOverlappingSessions: ScalarsEnums['Boolean']
  availableForStaffUserIds?: Maybe<Array<ScalarsEnums['String']>>
  category: ScalarsEnums['SessionCategory']
  createdAt: ScalarsEnums['String']
  creditsRequired: ScalarsEnums['Float']
  customCancelPolicy?: Maybe<SessionTemplateCustomCancelPolicy>
  customFields: Array<SessionTemplateCustomFields>
  customReleaseSchedule?: Maybe<SessionTemplateCustomReleaseSchedule>
  deletedAt?: Maybe<ScalarsEnums['String']>
  description?: Maybe<ScalarsEnums['String']>
  displayOrder?: Maybe<ScalarsEnums['Float']>
  dropInPrice: ScalarsEnums['Numeric']
  durationHours: ScalarsEnums['Float']
  durationMinutes: ScalarsEnums['Float']
  isPaymentRequired: ScalarsEnums['Boolean']
  isRequestBookingEnabled: ScalarsEnums['Boolean']
  isRequiredSessionFeedback: ScalarsEnums['Boolean']
  isRequiredTwoPartAuthentication: ScalarsEnums['Boolean']
  isRoomResourceEnabled: ScalarsEnums['Boolean']
  itemsSupplied?: Maybe<ScalarsEnums['String']>
  itemsToBring?: Maybe<ScalarsEnums['String']>
  lateCancelFeeId?: Maybe<ScalarsEnums['String']>
  lateCancelFeeMode?: Maybe<ScalarsEnums['SessionFeeMode']>
  name: ScalarsEnums['String']
  noShowFeeId?: Maybe<ScalarsEnums['String']>
  noShowFeeMode?: Maybe<ScalarsEnums['SessionFeeMode']>
  revenueTagId?: Maybe<ScalarsEnums['String']>
  /**
   * Session template image with presigned URLs
   */
  sessionImage: (args?: {
    formats?: Maybe<Array<ScalarsEnums['String']>>
    variants?: Maybe<Array<ScalarsEnums['String']>>
  }) => Maybe<SessionTemplateSessionImage>
  sessionTemplateId: ScalarsEnums['String']
  siteId: ScalarsEnums['String']
  /**
   * The site location for this template
   */
  siteLocation?: Maybe<SiteLocation>
  siteLocationId: ScalarsEnums['String']
  siteLocationRoomId?: Maybe<ScalarsEnums['String']>
  /**
   * The site session type for this template
   */
  siteSessionType?: Maybe<SiteSessionType>
  siteSessionTypeId: ScalarsEnums['String']
  size: ScalarsEnums['Float']
  taxEnabled: ScalarsEnums['Boolean']
  taxSettingIds?: Maybe<Array<ScalarsEnums['String']>>
  updatedAt: ScalarsEnums['String']
  waitlistEnabled: ScalarsEnums['Boolean']
  waitlistSize?: Maybe<ScalarsEnums['Float']>
}

export interface SessionTemplateCustomCancelPolicy {
  __typename?: 'SessionTemplateCustomCancelPolicy'
  days: ScalarsEnums['Float']
  hours: ScalarsEnums['Float']
  minutes: ScalarsEnums['Float']
}

export interface SessionTemplateCustomFields {
  __typename?: 'SessionTemplateCustomFields'
  enabled: ScalarsEnums['Boolean']
  id?: Maybe<ScalarsEnums['String']>
  information?: Maybe<ScalarsEnums['String']>
  name?: Maybe<ScalarsEnums['String']>
  title?: Maybe<ScalarsEnums['String']>
  value?: Maybe<ScalarsEnums['String']>
}

export interface SessionTemplateCustomReleaseSchedule {
  __typename?: 'SessionTemplateCustomReleaseSchedule'
  bookingAdvanceDays: ScalarsEnums['Float']
  bookingAdvanceHours: ScalarsEnums['Float']
  dayOfWeek?: Maybe<ScalarsEnums['String']>
  hoursBeforeStart?: Maybe<ScalarsEnums['Float']>
  intervalType?: Maybe<ScalarsEnums['String']>
  intervalValue?: Maybe<ScalarsEnums['Float']>
  releaseType: ScalarsEnums['String']
  time?: Maybe<ScalarsEnums['String']>
}

/**
 * Paginated result for session templates
 */
export interface SessionTemplatePaginationResult {
  __typename?: 'SessionTemplatePaginationResult'
  pageInfo: SessionTemplatePaginationResultPageInfo
  results: Array<SessionTemplatePaginationResultResults>
}

export interface SessionTemplatePaginationResultPageInfo {
  __typename?: 'SessionTemplatePaginationResultPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface SessionTemplatePaginationResultResults {
  __typename?: 'SessionTemplatePaginationResultResults'
  cursor: ScalarsEnums['String']
  row: SessionTemplate
}

export interface SessionTemplateSessionImage {
  __typename?: 'SessionTemplateSessionImage'
  lastFailure?: Maybe<RoomResourceTemplateImageLastFailure>
  pending?: Maybe<RoomResourceTemplateImagePending>
  status?: Maybe<ScalarsEnums['FileUploadConfigFieldStatus']>
  versions?: Maybe<Array<SessionTemplateSessionImageVersions>>
}

export interface SessionTemplateSessionImageVersions {
  __typename?: 'SessionTemplateSessionImageVersions'
  format?: Maybe<ScalarsEnums['String']>
  height?: Maybe<ScalarsEnums['Float']>
  type: ScalarsEnums['String']
  url: ScalarsEnums['String']
  width?: Maybe<ScalarsEnums['Float']>
}

/**
 * The updated session and the clients whose spot changed because of the update
 */
export interface SessionUpdateResult {
  __typename?: 'SessionUpdateResult'
  session: Session
  spotMoves: Array<SpotMove>
}

/**
 * A client on a session waitlist
 */
export interface SessionWaitlistEntry {
  __typename?: 'SessionWaitlistEntry'
  bookedByClientId?: Maybe<ScalarsEnums['ID']>
  /**
   * The client associated with this waitlist entry, with computed alerts
   */
  client?: Maybe<SessionWaitlistEntryClient>
  clientFirstName?: Maybe<ScalarsEnums['String']>
  clientId: ScalarsEnums['ID']
  clientLastName?: Maybe<ScalarsEnums['String']>
  clientMobilePhoneNumber?: Maybe<ScalarsEnums['String']>
  convertedBookingId?: Maybe<ScalarsEnums['ID']>
  creditLedgerEntryIds?: Maybe<Array<ScalarsEnums['ID']>>
  deletedAt?: Maybe<ScalarsEnums['String']>
  guestServiceId?: Maybe<ScalarsEnums['ID']>
  invitationExpiresAt?: Maybe<ScalarsEnums['String']>
  invitationRound?: Maybe<ScalarsEnums['Float']>
  invitedAt?: Maybe<ScalarsEnums['String']>
  invitedByStaffUserId?: Maybe<ScalarsEnums['String']>
  isFamilyEntry?: Maybe<ScalarsEnums['Boolean']>
  isProcessing: ScalarsEnums['Boolean']
  joinedAt: ScalarsEnums['String']
  originalBookingId?: Maybe<ScalarsEnums['ID']>
  position: ScalarsEnums['Float']
  respondedAt?: Maybe<ScalarsEnums['String']>
  /**
   * Session details for this waitlist entry
   */
  session?: Maybe<ClientBookingSession>
  sessionId: ScalarsEnums['ID']
  sessionName?: Maybe<ScalarsEnums['String']>
  sessionStartTime?: Maybe<ScalarsEnums['String']>
  sessionWaitlistEntryId: ScalarsEnums['String']
  siteId: ScalarsEnums['ID']
  status: ScalarsEnums['WaitlistEntryStatus']
  updatedAt: ScalarsEnums['String']
}

export interface SessionWaitlistEntryClient {
  __typename?: 'SessionWaitlistEntryClient'
  alerts: Array<ClientAlert>
  email?: Maybe<ScalarsEnums['String']>
  firstName?: Maybe<ScalarsEnums['String']>
  id: ScalarsEnums['String']
  lastName?: Maybe<ScalarsEnums['String']>
  mobilePhoneNumber?: Maybe<ScalarsEnums['String']>
  name?: Maybe<ScalarsEnums['String']>
  siteId?: Maybe<ScalarsEnums['String']>
}

/**
 * Paginated sessions with total count for offset-based pagination
 */
export interface SessionsPage {
  __typename?: 'SessionsPage'
  sessions: Array<Session>
  totalCount: ScalarsEnums['Float']
}

export interface SetDeviceInputMode {
  __typename?: 'SetDeviceInputMode'
  deviceTokenId: ScalarsEnums['String']
  inputMode: ScalarsEnums['DeviceInputMode']
}

export interface SetDevicePairingCodeLabel {
  __typename?: 'SetDevicePairingCodeLabel'
  ok: ScalarsEnums['Boolean']
}

export interface SetDeviceScopes {
  __typename?: 'SetDeviceScopes'
  capabilities: Array<ScalarsEnums['DeviceCapability']>
  deviceTokenId: ScalarsEnums['String']
}

export interface SetKioskPin {
  __typename?: 'SetKioskPin'
  kioskPinSetAt: ScalarsEnums['String']
  kioskSessionId: ScalarsEnums['String']
}

export interface SetRollingModeResult {
  __typename?: 'SetRollingModeResult'
  corporateId: ScalarsEnums['ID']
  enabled: ScalarsEnums['Boolean']
  operatingMode: ScalarsEnums['String']
}

export interface SetSavedReportCategoryTargeting {
  __typename?: 'SetSavedReportCategoryTargeting'
  corporateId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  createdAtLevel: ScalarsEnums['CreatedAtLevel']
  createdAtSiteId?: Maybe<ScalarsEnums['String']>
  createdBy: ScalarsEnums['String']
  name: ScalarsEnums['String']
  savedReportCategoryId: ScalarsEnums['String']
  sortOrder: ScalarsEnums['Float']
  targeting: SavedReportsTargeting
  updatedAt: ScalarsEnums['String']
  visibilityScope: ScalarsEnums['VisibilityScope']
}

export interface SetSavedReportTargeting {
  __typename?: 'SetSavedReportTargeting'
  baseReportAvailable: ScalarsEnums['Boolean']
  baseReportName: ScalarsEnums['ReportName']
  categoryId?: Maybe<ScalarsEnums['String']>
  columnLabels?: Maybe<ScalarsEnums['JSONObject']>
  corporateId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  createdAtLevel: ScalarsEnums['CreatedAtLevel']
  createdAtSiteId?: Maybe<ScalarsEnums['String']>
  createdBy: ScalarsEnums['String']
  description?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  savedColumns?: Maybe<Array<ScalarsEnums['String']>>
  savedDateRange?: Maybe<SavedReportsSavedDateRange>
  savedFilters?: Maybe<ScalarsEnums['JSONObject']>
  savedReportId: ScalarsEnums['String']
  savedSiteIds?: Maybe<Array<ScalarsEnums['String']>>
  savedSort?: Maybe<Array<SavedReportsSavedSort>>
  sortOrder: ScalarsEnums['Float']
  targeting: SavedReportsTargeting
  updatedAt: ScalarsEnums['String']
  visibility: ScalarsEnums['SavedReportVisibility']
  visibilityScope: ScalarsEnums['VisibilityScope']
}

export interface SetSessionTemplateFeedbackQuestions {
  __typename?: 'SetSessionTemplateFeedbackQuestions'
  count: ScalarsEnums['Float']
}

/**
 * Response from setting site authentication
 */
export interface SetSiteAuthenticationResponse {
  __typename?: 'SetSiteAuthenticationResponse'
  success: ScalarsEnums['Boolean']
}

/**
 * Result of toggling site-level Grow enablement
 */
export interface SetSiteGrowEnabledResponse {
  __typename?: 'SetSiteGrowEnabledResponse'
  enabled: ScalarsEnums['Boolean']
  success: ScalarsEnums['Boolean']
}

/**
 * The locations a brand now permits to override its plan
 */
export interface SetSitesPlanOverrideAllowedResult {
  __typename?: 'SetSitesPlanOverrideAllowedResult'
  allowedSiteIds: Array<ScalarsEnums['ID']>
}

/**
 * Result of setupEzypayGateway
 */
export interface SetupEzypayGatewayPayload {
  __typename?: 'SetupEzypayGatewayPayload'
  sitePaymentGateway: EzypayGateway
}

/**
 * A client a member can pick as a shared-credit recipient
 */
export interface ShareableClient {
  __typename?: 'ShareableClient'
  email?: Maybe<ScalarsEnums['String']>
  firstName?: Maybe<ScalarsEnums['String']>
  id: ScalarsEnums['String']
  lastName?: Maybe<ScalarsEnums['String']>
}

/**
 * Read-only share-link check plus the owner display fields the accept sheet renders; the image is a freshly signed URL because the one embedded in the link expires
 */
export interface SharedCreditInviteContext {
  __typename?: 'SharedCreditInviteContext'
  ownerClientId?: Maybe<ScalarsEnums['ID']>
  ownerFirstName?: Maybe<ScalarsEnums['String']>
  ownerLastName?: Maybe<ScalarsEnums['String']>
  ownerProfileImageUrl?: Maybe<ScalarsEnums['String']>
  valid: ScalarsEnums['Boolean']
}

export interface SharedCreditInviteTokenResult {
  __typename?: 'SharedCreditInviteTokenResult'
  expiresAt: ScalarsEnums['String']
  inviteToken: ScalarsEnums['String']
}

export interface SharedCreditRecipientEligibility {
  __typename?: 'SharedCreditRecipientEligibility'
  alreadyShared: ScalarsEnums['Boolean']
  clientId: ScalarsEnums['ID']
  eligible: ScalarsEnums['Boolean']
}

export interface SharedCreditsDetail {
  __typename?: 'SharedCreditsDetail'
  allocatedCredits?: Maybe<ScalarsEnums['Float']>
  consumedCredits: ScalarsEnums['Float']
  email?: Maybe<ScalarsEnums['String']>
  firstName?: Maybe<ScalarsEnums['String']>
  lastName?: Maybe<ScalarsEnums['String']>
  ownerClientId: ScalarsEnums['ID']
  profileImageUrl?: Maybe<ScalarsEnums['String']>
  recipientClientId: ScalarsEnums['ID']
  remainingCredits?: Maybe<ScalarsEnums['Float']>
  serviceId: ScalarsEnums['ID']
  sharedOn?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['ServiceCreditShareStatus']
}

export interface SharedPackageDetails {
  __typename?: 'SharedPackageDetails'
  consumedCredits: ScalarsEnums['Float']
  isOwner: ScalarsEnums['Boolean']
  maxSharingCredits?: Maybe<ScalarsEnums['Float']>
  ownerClientId: ScalarsEnums['ID']
  recipients: Array<SharedPackageRecipient>
  remainingCredits?: Maybe<ScalarsEnums['Float']>
  serviceId: ScalarsEnums['ID']
  usage: Array<SharedPackageUsageEntry>
}

export interface SharedPackageRecipient {
  __typename?: 'SharedPackageRecipient'
  allocatedCredits?: Maybe<ScalarsEnums['Float']>
  consumedCredits: ScalarsEnums['Float']
  firstName?: Maybe<ScalarsEnums['String']>
  lastName?: Maybe<ScalarsEnums['String']>
  profileImageUrl?: Maybe<ScalarsEnums['String']>
  recipientClientId: ScalarsEnums['ID']
  sharedOn?: Maybe<ScalarsEnums['String']>
}

export interface SharedPackageUsageEntry {
  __typename?: 'SharedPackageUsageEntry'
  profileImageUrl?: Maybe<ScalarsEnums['String']>
  sessionName?: Maybe<ScalarsEnums['String']>
  sessionStartTime?: Maybe<ScalarsEnums['String']>
  siteName?: Maybe<ScalarsEnums['String']>
  siteTimezone?: Maybe<ScalarsEnums['String']>
  usedByClientId: ScalarsEnums['ID']
  usedByFirstName?: Maybe<ScalarsEnums['String']>
  usedByLastName?: Maybe<ScalarsEnums['String']>
  usedCredits: ScalarsEnums['Float']
}

/**
 * Shared-credit activity entry between two related clients
 */
export interface SharedRelationActivityEntry {
  __typename?: 'SharedRelationActivityEntry'
  credits: ScalarsEnums['Float']
  occurredAt: ScalarsEnums['String']
  packageName?: Maybe<ScalarsEnums['String']>
  platform?: Maybe<ScalarsEnums['String']>
  sessionName?: Maybe<ScalarsEnums['String']>
  sessionStartTime?: Maybe<ScalarsEnums['String']>
  type: ScalarsEnums['SharedRelationActivityType']
  usedByClientId?: Maybe<ScalarsEnums['ID']>
  usedByName?: Maybe<ScalarsEnums['String']>
}

/**
 * Result of shifting active and suspended recurring invoices to a new payment method
 */
export interface ShiftRecurringInvoicesResult {
  __typename?: 'ShiftRecurringInvoicesResult'
  shifted: ScalarsEnums['Float']
  skipped: Array<ShiftRecurringInvoicesSkipped>
}

/**
 * A recurring invoice that could not be shifted to the new payment method
 */
export interface ShiftRecurringInvoicesSkipped {
  __typename?: 'ShiftRecurringInvoicesSkipped'
  reason: ScalarsEnums['String']
  recurringInvoiceId: ScalarsEnums['ID']
}

export interface SignedPolicyAgreements {
  __typename?: 'SignedPolicyAgreements'
  createdAt: ScalarsEnums['String']
  signedAt?: Maybe<ScalarsEnums['String']>
  siteAgreementTemplateId: ScalarsEnums['String']
}

/**
 * A short-lived URL for a signature captured while adding a client; pass signupAttemptId with the sign-up answers
 */
export interface SignupSignatureUploadTicket {
  __typename?: 'SignupSignatureUploadTicket'
  attemptExpiresAt: ScalarsEnums['String']
  expiresAt: ScalarsEnums['String']
  reservedSubmissionId: ScalarsEnums['String']
  signupAttemptId: ScalarsEnums['String']
  uploadHeaders: Array<FormSignatureUploadHeader>
  uploadId: ScalarsEnums['String']
  uploadUrl: ScalarsEnums['String']
}

/**
 * A physical or digital location belonging to a corporate
 */
export interface Site {
  __typename?: 'Site'
  /**
   * Session categories (CLASS, WORKSHOP, PRIVATE) the site has upcoming sessions in
   */
  activeSessionCategories: Array<ScalarsEnums['SessionCategory']>
  addressCity?: Maybe<ScalarsEnums['String']>
  addressCountry?: Maybe<ScalarsEnums['String']>
  addressPostalCode?: Maybe<ScalarsEnums['String']>
  addressState?: Maybe<ScalarsEnums['String']>
  addressStreet?: Maybe<ScalarsEnums['String']>
  addressStreet2?: Maybe<ScalarsEnums['String']>
  adminConfigurations?: Maybe<SiteAdminConfigurations>
  appName?: Maybe<ScalarsEnums['String']>
  businessEmail?: Maybe<ScalarsEnums['String']>
  businessHours?: Maybe<SiteBusinessHours>
  capacity?: Maybe<ScalarsEnums['Float']>
  clientFeesTemplateId?: Maybe<ScalarsEnums['String']>
  /**
   * Connected shared site IDs for package reciprocity
   */
  connectedSharedSiteIds?: Maybe<Array<ScalarsEnums['String']>>
  corePlanLevel?: Maybe<ScalarsEnums['CorePlanLevel']>
  /**
   * Country reference resolved via federation from corporates service
   */
  country?: Maybe<Country>
  countryId?: Maybe<ScalarsEnums['ID']>
  createdAt: ScalarsEnums['String']
  /**
   * Site currency (resolved from settings.location.configurations.currency)
   */
  currency?: Maybe<ScalarsEnums['Currency']>
  customIntegrations?: Maybe<Array<SiteCustomIntegrations>>
  deletedAt?: Maybe<ScalarsEnums['String']>
  description?: Maybe<ScalarsEnums['String']>
  displayBusinessHours: ScalarsEnums['Boolean']
  email?: Maybe<ScalarsEnums['String']>
  gatewayCurrentPaymentMethodId?: Maybe<ScalarsEnums['String']>
  gatewayCustomerId?: Maybe<ScalarsEnums['String']>
  hapanaFeesTemplateId?: Maybe<ScalarsEnums['ID']>
  integrations?: Maybe<SiteIntegrations>
  isDigital?: Maybe<ScalarsEnums['Boolean']>
  /**
   * Whether the Google Pay release flag is on for this site. Admin offers the Google Pay switch only when it is.
   */
  isGooglePayReleased: ScalarsEnums['Boolean']
  /**
   * Whether V2 is enabled for this site (from admin DB SiteIndex). Null means no SiteIndex record exists.
   */
  isV2Enabled?: Maybe<ScalarsEnums['Boolean']>
  /**
   * Site logo image with signed URLs
   */
  logoImage: (args: { input: ImagePublicSignedUrlInput }) => Maybe<ImagePublicSignedUrl>
  membersCount?: Maybe<ScalarsEnums['Float']>
  name: ScalarsEnums['String']
  openDate?: Maybe<ScalarsEnums['String']>
  /**
   * Current active payment gateway for the site
   */
  paymentGateway?: Maybe<SitePaymentGatewayField>
  /**
   * Onboarding status for payment gateway (for core app banners)
   */
  paymentGatewayOnboardingStatus?: Maybe<SitePaymentGatewayOnboardingStatusInfo>
  phone?: Maybe<ScalarsEnums['String']>
  phonePrefix?: Maybe<ScalarsEnums['String']>
  planOverrideAllowed?: Maybe<ScalarsEnums['Boolean']>
  planTierOverride?: Maybe<ScalarsEnums['ProductPlanTier']>
  /**
   * Get POS categories for this site
   */
  posCategories: Array<CreatePosCategoryResponse>
  rebateTemplateIds?: Maybe<Array<ScalarsEnums['ID']>>
  regionId?: Maybe<ScalarsEnums['ID']>
  royaltiesTemplateId?: Maybe<ScalarsEnums['ID']>
  /**
   * Get service template categories (package categories) for this site
   */
  serviceTemplateCategories: Array<CreateServiceTemplateCategoryResponse>
  settings?: Maybe<SiteSettings>
  siteId: ScalarsEnums['ID']
  /**
   * Get current SMS credits balance for this site
   */
  smsCreditsBalance: SmsCreditsBalance
  stateId?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['SiteStatus']
  /**
   * Get suppliers for this site
   */
  suppliers: Array<CreateSiteSupplierResponse>
  timezone?: Maybe<ScalarsEnums['String']>
  updatedAt: ScalarsEnums['String']
  v1EncryptedId?: Maybe<ScalarsEnums['String']>
  website?: Maybe<ScalarsEnums['String']>
  workshopType?: Maybe<ScalarsEnums['SiteWorkshopType']>
}

/**
 * A physical access point (door, gate, turnstile) at a site
 */
export interface SiteAccessPoint {
  __typename?: 'SiteAccessPoint'
  createdAt: ScalarsEnums['String']
  deletedAt?: Maybe<ScalarsEnums['String']>
  internalConfig?: Maybe<SiteAccessPointInternalConfig>
  lastReconcileAt?: Maybe<ScalarsEnums['String']>
  lastReconcileStatus?: Maybe<ScalarsEnums['DoorReconcileStatus']>
  name: ScalarsEnums['String']
  provider: ScalarsEnums['AccessProvider']
  provisionData?: Maybe<ScalarsEnums['JSONObject']>
  qrCodeGeneratedAt?: Maybe<ScalarsEnums['String']>
  qrCodeUrl?: Maybe<ScalarsEnums['String']>
  reconcileConsecutiveFailures: ScalarsEnums['Float']
  siteAccessPointId: ScalarsEnums['String']
  siteAccessZoneId?: Maybe<ScalarsEnums['String']>
  siteId: ScalarsEnums['String']
  status: ScalarsEnums['SiteAccessPointStatus']
  updatedAt: ScalarsEnums['String']
}

/**
 * Live reachability status for a single site access point
 */
export interface SiteAccessPointDeviceStatus {
  __typename?: 'SiteAccessPointDeviceStatus'
  reachability: ScalarsEnums['DeviceReachability']
  siteAccessPointId: ScalarsEnums['String']
}

/**
 * Internal configuration for a site access point
 */
export interface SiteAccessPointInternalConfig {
  __typename?: 'SiteAccessPointInternalConfig'
  accessMode?: Maybe<ScalarsEnums['AccessMode']>
  doorType?: Maybe<ScalarsEnums['DoorType']>
  readerType?: Maybe<ScalarsEnums['ReaderType']>
  timerSeconds?: Maybe<ScalarsEnums['Float']>
}

/**
 * Configuration currently active on the physical access point device
 */
export interface SiteAccessPointLiveDeviceConfig {
  __typename?: 'SiteAccessPointLiveDeviceConfig'
  lastSeen?: Maybe<ScalarsEnums['String']>
  reachability: ScalarsEnums['DeviceReachability']
  readerType?: Maybe<ScalarsEnums['ReaderType']>
  relayTriggerTimeMs?: Maybe<ScalarsEnums['Float']>
  siteAccessPointId: ScalarsEnums['String']
}

/**
 * A named access zone within a site (e.g. Main, Premium Area)
 */
export interface SiteAccessZone {
  __typename?: 'SiteAccessZone'
  config?: Maybe<ScalarsEnums['JSONObject']>
  createdAt: ScalarsEnums['String']
  isMainZone?: Maybe<ScalarsEnums['Boolean']>
  metadata?: Maybe<ScalarsEnums['JSONObject']>
  name: ScalarsEnums['String']
  siteAccessZoneId: ScalarsEnums['String']
  siteId: ScalarsEnums['String']
  updatedAt: ScalarsEnums['String']
}

/**
 * A per-site accounting code used to tag service-template sales
 */
export interface SiteAccountCode {
  __typename?: 'SiteAccountCode'
  accountCodeId: ScalarsEnums['ID']
  code: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  createdById?: Maybe<ScalarsEnums['ID']>
  deletedAt?: Maybe<ScalarsEnums['String']>
  description?: Maybe<ScalarsEnums['String']>
  siteId: ScalarsEnums['ID']
  status: ScalarsEnums['SiteAccountCodeStatus']
  title: ScalarsEnums['String']
  updatedAt: ScalarsEnums['String']
  updatedById?: Maybe<ScalarsEnums['ID']>
}

/**
 * The per-site accounting-code feature configuration
 */
export interface SiteAccountCodeConfig {
  __typename?: 'SiteAccountCodeConfig'
  accountCodesEnabled: ScalarsEnums['Boolean']
  introOfferDefaultAccountCodeId?: Maybe<ScalarsEnums['String']>
}

/**
 * Active alerts only, URGENT first then newest
 */
export interface SiteActiveAlerts {
  __typename?: 'SiteActiveAlerts'
  alerts: Array<ActiveSiteAlert>
  alertsVersion: ScalarsEnums['String']
}

export interface SiteAdminConfigurations {
  __typename?: 'SiteAdminConfigurations'
  allowToEnableClientMultiplePaymentMethods?: Maybe<ScalarsEnums['Boolean']>
  bankAccountCapabilities?: Maybe<ScalarsEnums['Boolean']>
  displayAccountCreditsTab?: Maybe<ScalarsEnums['Boolean']>
  displayStripeConnectPaymentGateway?: Maybe<ScalarsEnums['Boolean']>
  enableAddOns?: Maybe<ScalarsEnums['Boolean']>
  enableAppAndWebsiteWidgets?: Maybe<ScalarsEnums['Boolean']>
  enableCorporateDashboardAndPublicApi?: Maybe<ScalarsEnums['Boolean']>
  enableDigitalLocations?: Maybe<ScalarsEnums['Boolean']>
  enableDoorAccess?: Maybe<ScalarsEnums['Boolean']>
  enableMembershipPlanChange?: Maybe<ScalarsEnums['Boolean']>
  enableOfflineDoorSync?: Maybe<ScalarsEnums['Boolean']>
  enableSharedSites?: Maybe<ScalarsEnums['Boolean']>
  enableTanningFeatures?: Maybe<ScalarsEnums['Boolean']>
  fees?: Maybe<SiteAdminConfigurationsFees>
  fobCredentialFormat?: Maybe<SiteAdminConfigurationsFobCredentialFormat>
  hasBankAccountCapabilities?: Maybe<ScalarsEnums['Boolean']>
  hasBankAccountRefundCapabilities?: Maybe<ScalarsEnums['Boolean']>
  monthlySmsCredits?: Maybe<ScalarsEnums['Float']>
  paymentGateway?: Maybe<SiteAdminConfigurationsPaymentGateway>
  processingFees?: Maybe<SiteAdminConfigurationsProcessingFees>
  sms?: Maybe<SiteAdminConfigurationsSms>
}

export interface SiteAdminConfigurationsFees {
  __typename?: 'SiteAdminConfigurationsFees'
  brandRebatesTemplateIds?: Maybe<Array<ScalarsEnums['String']>>
  clientFeesTemplateId?: Maybe<ScalarsEnums['String']>
  hapanaFeesTemplateId?: Maybe<ScalarsEnums['String']>
  royaltiesAndFeesTemplateId?: Maybe<ScalarsEnums['String']>
}

export interface SiteAdminConfigurationsFobCredentialFormat {
  __typename?: 'SiteAdminConfigurationsFobCredentialFormat'
  byteOrder: ScalarsEnums['FobByteOrder']
  controller: ScalarsEnums['FobController']
  readerFormat: ScalarsEnums['FobReaderFormat']
  serialNotation?: Maybe<ScalarsEnums['FobSerialNotation']>
}

export interface SiteAdminConfigurationsPaymentGateway {
  __typename?: 'SiteAdminConfigurationsPaymentGateway'
  accountCodesEnabled?: Maybe<ScalarsEnums['Boolean']>
  applePayEnabled?: Maybe<ScalarsEnums['Boolean']>
  enableTerminals?: Maybe<ScalarsEnums['Boolean']>
  ezypayDisplayAccountingCode?: Maybe<ScalarsEnums['String']>
  googlePayEnabled?: Maybe<ScalarsEnums['Boolean']>
  introOfferDefaultAccountCodeId?: Maybe<ScalarsEnums['String']>
  stripeId?: Maybe<ScalarsEnums['String']>
  transactionLimitAmount?: Maybe<ScalarsEnums['Float']>
}

export interface SiteAdminConfigurationsProcessingFees {
  __typename?: 'SiteAdminConfigurationsProcessingFees'
  amexCardProcessingFlatFee?: Maybe<ScalarsEnums['Float']>
  amexCardProcessingPercentageFee?: Maybe<ScalarsEnums['Float']>
  bankProcessingFlatFee?: Maybe<ScalarsEnums['Float']>
  bankProcessingPercentageFee?: Maybe<ScalarsEnums['Float']>
  cardProcessingFlatFee?: Maybe<ScalarsEnums['Float']>
  cardProcessingPercentageFee?: Maybe<ScalarsEnums['Float']>
}

export interface SiteAdminConfigurationsSms {
  __typename?: 'SiteAdminConfigurationsSms'
  fromName?: Maybe<ScalarsEnums['String']>
  twilioSubaccount?: Maybe<SiteAdminConfigurationsSmsTwilioSubaccount>
}

export interface SiteAdminConfigurationsSmsTwilioSubaccount {
  __typename?: 'SiteAdminConfigurationsSmsTwilioSubaccount'
  id?: Maybe<ScalarsEnums['String']>
  token?: Maybe<ScalarsEnums['String']>
}

export interface SiteAgreementTemplate {
  __typename?: 'SiteAgreementTemplate'
  content: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  effectiveDate?: Maybe<ScalarsEnums['String']>
  isActive: ScalarsEnums['Boolean']
  name: ScalarsEnums['String']
  requiresSignature: ScalarsEnums['Boolean']
  siteAgreementTemplateId: ScalarsEnums['ID']
  siteId: ScalarsEnums['ID']
  templateUrl?: Maybe<ScalarsEnums['String']>
  type: ScalarsEnums['AgreementType']
  updatedAt: ScalarsEnums['String']
  validityDays?: Maybe<ScalarsEnums['Float']>
  version: ScalarsEnums['String']
}

export interface SiteAlertLink {
  __typename?: 'SiteAlertLink'
  label: ScalarsEnums['String']
  url: ScalarsEnums['String']
}

/**
 * A location alert with its resolved status and the staff who posted and ended it
 */
export interface SiteAlertListItem {
  __typename?: 'SiteAlertListItem'
  amenityId?: Maybe<ScalarsEnums['ID']>
  amenityLabel?: Maybe<ScalarsEnums['String']>
  body?: Maybe<ScalarsEnums['String']>
  createdAt: ScalarsEnums['String']
  createdBy: ScalarsEnums['String']
  createdByName?: Maybe<ScalarsEnums['String']>
  deletedAt?: Maybe<ScalarsEnums['String']>
  endedAt?: Maybe<ScalarsEnums['String']>
  endedBy?: Maybe<ScalarsEnums['String']>
  endedByName?: Maybe<ScalarsEnums['String']>
  endsAt?: Maybe<ScalarsEnums['String']>
  linkLabel?: Maybe<ScalarsEnums['String']>
  linkUrl?: Maybe<ScalarsEnums['String']>
  marksLocationClosed: ScalarsEnums['Boolean']
  showAsPopup: ScalarsEnums['Boolean']
  siteAlertId: ScalarsEnums['ID']
  siteId: ScalarsEnums['ID']
  startsAt: ScalarsEnums['String']
  status: ScalarsEnums['SiteAlertStatus']
  theme: ScalarsEnums['SiteAlertTheme']
  title: ScalarsEnums['String']
  updatedAt: ScalarsEnums['String']
}

/**
 * Whether the caller can assign a staff access policy at one location
 */
export interface SiteAssignability {
  __typename?: 'SiteAssignability'
  isAssignable: ScalarsEnums['Boolean']
  missing: MissingPermissions
  missingCount: ScalarsEnums['Int']
  name: ScalarsEnums['String']
  siteId: ScalarsEnums['ID']
}

export interface SiteBusinessHours {
  __typename?: 'SiteBusinessHours'
  customHours?: Maybe<SiteBusinessHoursCustomHours>
  endTime?: Maybe<ScalarsEnums['String']>
  exceptions?: Maybe<
    Array<SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleExceptions>
  >
  hasCustomHours: ScalarsEnums['Boolean']
  is24x7?: Maybe<ScalarsEnums['Boolean']>
  startTime?: Maybe<ScalarsEnums['String']>
  weekly?: Maybe<SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleWeekly>
}

export interface SiteBusinessHoursCustomHours {
  __typename?: 'SiteBusinessHoursCustomHours'
  friday?: Maybe<SiteBusinessHoursCustomHoursMonday>
  monday?: Maybe<SiteBusinessHoursCustomHoursMonday>
  saturday?: Maybe<SiteBusinessHoursCustomHoursMonday>
  sunday?: Maybe<SiteBusinessHoursCustomHoursMonday>
  thursday?: Maybe<SiteBusinessHoursCustomHoursMonday>
  tuesday?: Maybe<SiteBusinessHoursCustomHoursMonday>
  wednesday?: Maybe<SiteBusinessHoursCustomHoursMonday>
}

export interface SiteBusinessHoursCustomHoursMonday {
  __typename?: 'SiteBusinessHoursCustomHoursMonday'
  endTime: ScalarsEnums['String']
  startTime: ScalarsEnums['String']
}

export interface SiteChallengeOverview {
  __typename?: 'SiteChallengeOverview'
  activeChallenges: ScalarsEnums['Float']
  completionRate: ScalarsEnums['Float']
  topChallengeId?: Maybe<ScalarsEnums['String']>
  topChallengeTitle?: Maybe<ScalarsEnums['String']>
  totalActiveEnrollments: ScalarsEnums['Float']
}

/**
 * Response containing site clients
 */
export interface SiteClientsResponse {
  __typename?: 'SiteClientsResponse'
  clients: Array<SiteClientsResponseClients>
}

export interface SiteClientsResponseClients {
  __typename?: 'SiteClientsResponseClients'
  clientId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  creditAccountBalance?: Maybe<ScalarsEnums['String']>
  favoriteInstructorIds?: Maybe<Array<ScalarsEnums['String']>>
  joinDate: ScalarsEnums['String']
  lastAttendanceDate?: Maybe<ScalarsEnums['String']>
  lastBillingDate?: Maybe<ScalarsEnums['String']>
  lastBookingDate?: Maybe<ScalarsEnums['String']>
  siteSpecificData?: Maybe<ClientSiteRelationshipSiteSpecificData>
  updatedAt: ScalarsEnums['String']
}

/**
 * How many rows of one configuration area a duplicate copies or copied
 */
export interface SiteCloneAreaCount {
  __typename?: 'SiteCloneAreaCount'
  area: ScalarsEnums['SiteCloneArea']
  count: ScalarsEnums['Float']
  skipped: ScalarsEnums['Float']
}

/**
 * An image that could not be copied onto the new site
 */
export interface SiteCloneImageFailure {
  __typename?: 'SiteCloneImageFailure'
  message: ScalarsEnums['String']
  sourceId: ScalarsEnums['String']
  table: ScalarsEnums['String']
}

/**
 * A request to duplicate a site, and how far it has got
 */
export interface SiteCloneJob {
  __typename?: 'SiteCloneJob'
  areaCounts?: Maybe<Array<SiteCloneAreaCount>>
  completedAt?: Maybe<ScalarsEnums['String']>
  createdAt: ScalarsEnums['String']
  currentStep?: Maybe<ScalarsEnums['SiteCloneJobStep']>
  errorCode?: Maybe<ScalarsEnums['SiteDuplicateErrorCode']>
  errorMessage?: Maybe<ScalarsEnums['String']>
  imageFailures?: Maybe<Array<SiteCloneImageFailure>>
  siteCloneJobId: ScalarsEnums['ID']
  sourceSiteId: ScalarsEnums['ID']
  status: ScalarsEnums['SiteCloneJobStatus']
  targetSiteId?: Maybe<ScalarsEnums['ID']>
  targetSiteName: ScalarsEnums['String']
}

/**
 * How many rows of each configuration area a duplicate of this site would copy
 */
export interface SiteCloneManifest {
  __typename?: 'SiteCloneManifest'
  areas: Array<SiteCloneAreaCount>
  siteId: ScalarsEnums['ID']
}

/**
 * An active or scheduled temporarily-closed alert; closedDates are the site-local dates it covers inside the requested range
 */
export interface SiteClosure {
  __typename?: 'SiteClosure'
  body?: Maybe<ScalarsEnums['String']>
  closedDates: Array<ScalarsEnums['String']>
  endsAt?: Maybe<ScalarsEnums['String']>
  siteAlertId: ScalarsEnums['ID']
  startsAt: ScalarsEnums['String']
  status: ScalarsEnums['SiteAlertStatus']
  title: ScalarsEnums['String']
}

/**
 * A session that would be cancelled while a location is temporarily closed
 */
export interface SiteClosureSession {
  __typename?: 'SiteClosureSession'
  bookedCount: ScalarsEnums['Int']
  date: ScalarsEnums['String']
  endTime: ScalarsEnums['String']
  instructorNames: Array<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  sessionId: ScalarsEnums['String']
  startTime: ScalarsEnums['String']
  waitlistCount: ScalarsEnums['Int']
}

/**
 * A communication template for site-specific messaging
 */
export interface SiteCommunicationTemplate {
  __typename?: 'SiteCommunicationTemplate'
  alias: ScalarsEnums['CommunicationTemplateAliases']
  allowedPlaceholders: Array<ScalarsEnums['CommunicationTemplatePlaceholders']>
  createdAt: ScalarsEnums['String']
  emailBody: ScalarsEnums['String']
  emailCcEmail?: Maybe<ScalarsEnums['String']>
  emailCcLocation: ScalarsEnums['Boolean']
  emailCopyEmployee: ScalarsEnums['EmailCopyEmployee']
  emailDefaultOn: ScalarsEnums['Boolean']
  emailEnabled: ScalarsEnums['Boolean']
  emailLockedByBrand: ScalarsEnums['Boolean']
  emailReplyToEmail?: Maybe<ScalarsEnums['String']>
  emailReplyToName?: Maybe<ScalarsEnums['String']>
  emailSendBefore?: Maybe<ScalarsEnums['Float']>
  emailSendBeforeUnit?: Maybe<ScalarsEnums['EmailSendBeforeUnit']>
  emailSendCalendarAttachment: ScalarsEnums['Boolean']
  emailSendEmailAs: ScalarsEnums['EmailSendAs']
  emailSendOnlyToActiveClients: ScalarsEnums['Boolean']
  emailSubject: ScalarsEnums['String']
  emailUseHapanaLayout?: Maybe<ScalarsEnums['Boolean']>
  name: ScalarsEnums['String']
  pushLockedByBrand: ScalarsEnums['Boolean']
  pushNotificationDefaultOn: ScalarsEnums['Boolean']
  pushNotificationEnabled: ScalarsEnums['Boolean']
  pushNotificationMessage?: Maybe<ScalarsEnums['String']>
  pushNotificationTitle?: Maybe<ScalarsEnums['String']>
  readOnly: ScalarsEnums['Boolean']
  siteCommunicationTemplateId: ScalarsEnums['ID']
  siteId: ScalarsEnums['ID']
  smsDefaultOn: ScalarsEnums['Boolean']
  smsEnabled: ScalarsEnums['Boolean']
  smsLockedByBrand: ScalarsEnums['Boolean']
  smsMessage?: Maybe<ScalarsEnums['String']>
  targetedServiceTemplateIds?: Maybe<Array<ScalarsEnums['ID']>>
  updatedAt: ScalarsEnums['String']
}

export interface SiteCommunicationTemplateById {
  __typename?: 'SiteCommunicationTemplateById'
  alias: ScalarsEnums['CommunicationTemplateAliases']
  allowedPlaceholders: Array<ScalarsEnums['CommunicationTemplatePlaceholders']>
  createdAt: ScalarsEnums['String']
  emailBody: ScalarsEnums['String']
  emailCcEmail?: Maybe<ScalarsEnums['String']>
  emailCcLocation: ScalarsEnums['Boolean']
  emailCopyEmployee: ScalarsEnums['EmailCopyEmployee']
  emailDefaultOn: ScalarsEnums['Boolean']
  emailEnabled: ScalarsEnums['Boolean']
  emailLockedByBrand: ScalarsEnums['Boolean']
  emailReplyToEmail?: Maybe<ScalarsEnums['String']>
  emailReplyToName?: Maybe<ScalarsEnums['String']>
  emailSendBefore?: Maybe<ScalarsEnums['Float']>
  emailSendBeforeUnit?: Maybe<ScalarsEnums['EmailSendBeforeUnit']>
  emailSendCalendarAttachment: ScalarsEnums['Boolean']
  emailSendEmailAs: ScalarsEnums['EmailSendAs']
  emailSendOnlyToActiveClients: ScalarsEnums['Boolean']
  emailSubject: ScalarsEnums['String']
  emailUseHapanaLayout?: Maybe<ScalarsEnums['Boolean']>
  pushLockedByBrand: ScalarsEnums['Boolean']
  pushNotificationDefaultOn: ScalarsEnums['Boolean']
  pushNotificationEnabled: ScalarsEnums['Boolean']
  pushNotificationMessage?: Maybe<ScalarsEnums['String']>
  pushNotificationTitle?: Maybe<ScalarsEnums['String']>
  readOnly: ScalarsEnums['Boolean']
  siteCommunicationTemplateId: ScalarsEnums['ID']
  siteId: ScalarsEnums['ID']
  smsDefaultOn: ScalarsEnums['Boolean']
  smsEnabled: ScalarsEnums['Boolean']
  smsLockedByBrand: ScalarsEnums['Boolean']
  smsMessage?: Maybe<ScalarsEnums['String']>
  targetedServiceTemplateIds?: Maybe<Array<ScalarsEnums['ID']>>
  updatedAt: ScalarsEnums['String']
}

/**
 * The final email a site communication template would send, rendered with sample placeholder values
 */
export interface SiteCommunicationTemplateEmailPreview {
  __typename?: 'SiteCommunicationTemplateEmailPreview'
  html: ScalarsEnums['String']
  source: ScalarsEnums['TemplateSource']
  subject: ScalarsEnums['String']
  wrapped: ScalarsEnums['Boolean']
}

/**
 * Result of paginated site communication templates query
 */
export interface SiteCommunicationTemplatePaginationResultSchema {
  __typename?: 'SiteCommunicationTemplatePaginationResultSchema'
  pageInfo: SiteCommunicationTemplatePaginationResultSchemaPageInfo
  results: Array<SiteCommunicationTemplatePaginationResultSchemaResults>
}

export interface SiteCommunicationTemplatePaginationResultSchemaPageInfo {
  __typename?: 'SiteCommunicationTemplatePaginationResultSchemaPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface SiteCommunicationTemplatePaginationResultSchemaResults {
  __typename?: 'SiteCommunicationTemplatePaginationResultSchemaResults'
  cursor: ScalarsEnums['String']
  row: SiteCommunicationTemplate
}

/**
 * Class cover settings for a location: what applies, what the location overrides, and the brand defaults
 */
export interface SiteCoverSettings {
  __typename?: 'SiteCoverSettings'
  brand: CoverSettingsOverrides
  effective: CoverSettings
  site: CoverSettingsOverrides
  siteId: ScalarsEnums['String']
}

export interface SiteCustomIntegrations {
  __typename?: 'SiteCustomIntegrations'
  integrationId: ScalarsEnums['ID']
  keyValues: Array<SiteCustomIntegrationsKeyValues>
}

export interface SiteCustomIntegrationsKeyValues {
  __typename?: 'SiteCustomIntegrationsKeyValues'
  key: ScalarsEnums['ID']
  value?: Maybe<ScalarsEnums['String']>
}

export interface SiteDevices {
  __typename?: 'SiteDevices'
  devices: Array<SiteDevicesDevices>
}

export interface SiteDevicesDevices {
  __typename?: 'SiteDevicesDevices'
  busy: ScalarsEnums['Boolean']
  busyReason?: Maybe<ScalarsEnums['DeviceBusyReason']>
  busyUntil?: Maybe<ScalarsEnums['String']>
  capabilities: Array<ScalarsEnums['DeviceCapability']>
  createdAt: ScalarsEnums['String']
  deviceKind: ScalarsEnums['DeviceKind']
  deviceTokenId: ScalarsEnums['String']
  inputMode: ScalarsEnums['DeviceInputMode']
  label?: Maybe<ScalarsEnums['String']>
  lastSeenAt?: Maybe<ScalarsEnums['String']>
  liveness: ScalarsEnums['DeviceLiveness']
  pinFeatures?: Maybe<SiteDevicesDevicesPinFeatures>
  status: ScalarsEnums['String']
}

export interface SiteDevicesDevicesPinFeatures {
  __typename?: 'SiteDevicesDevicesPinFeatures'
  checkIn: ScalarsEnums['Boolean']
  classCheckIn: ScalarsEnums['Boolean']
  purchases: ScalarsEnums['Boolean']
}

export interface SiteDoorAccessEvents {
  __typename?: 'SiteDoorAccessEvents'
  pageInfo: SiteDoorAccessEventsPageInfo
  results: Array<SiteDoorAccessEventsResults>
}

export interface SiteDoorAccessEventsPageInfo {
  __typename?: 'SiteDoorAccessEventsPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface SiteDoorAccessEventsResults {
  __typename?: 'SiteDoorAccessEventsResults'
  cursor: ScalarsEnums['String']
  row: DoorAccessEvent
}

export interface SiteEntitlements {
  __typename?: 'SiteEntitlements'
  activeThemes: Array<ScalarsEnums['ThemeKey']>
  effectivePlan: ScalarsEnums['ProductPlanTier']
  eligibleThemes: Array<ScalarsEnums['ThemeKey']>
  entitledFeatures: Array<ScalarsEnums['String']>
}

export interface SiteFeeConfig {
  __typename?: 'SiteFeeConfig'
  clientFeesTemplateId?: Maybe<ScalarsEnums['String']>
  clientFeesTemplateName?: Maybe<ScalarsEnums['String']>
  hapanaFeesTemplateId?: Maybe<ScalarsEnums['String']>
  hapanaFeesTemplateName?: Maybe<ScalarsEnums['String']>
  rebateTemplates: Array<SiteFeeConfigRebateTemplates>
  siteId: ScalarsEnums['String']
  siteName: ScalarsEnums['String']
  transactionFeePreference: ScalarsEnums['TransactionFeePreference']
}

export interface SiteFeeConfigRebateTemplates {
  __typename?: 'SiteFeeConfigRebateTemplates'
  corporatePayoutAccountId: ScalarsEnums['String']
  rebateTemplateId: ScalarsEnums['String']
  rebateTemplateName: ScalarsEnums['String']
}

/**
 * A form template for collecting data at a site
 */
export interface SiteForm {
  __typename?: 'SiteForm'
  createdAt?: Maybe<ScalarsEnums['String']>
  defaultRequiredBefore?: Maybe<ScalarsEnums['FormRequiredBefore']>
  deletedAt?: Maybe<ScalarsEnums['String']>
  description: ScalarsEnums['String']
  name: ScalarsEnums['String']
  questions: Array<SiteFormQuestion>
  resultCustomPropertyId?: Maybe<ScalarsEnums['String']>
  /**
   * Band id to select-option text for a mapped select property; null otherwise
   */
  resultPropertyMapping?: Maybe<ScalarsEnums['JSON']>
  revision?: Maybe<ScalarsEnums['Float']>
  scoreBands?: Maybe<Array<SiteFormScoreBands>>
  scoringEnabled?: Maybe<ScalarsEnums['Boolean']>
  showResultOnProfile?: Maybe<ScalarsEnums['Boolean']>
  showResultToClient?: Maybe<ScalarsEnums['Boolean']>
  siteFormId: ScalarsEnums['String']
  siteId: ScalarsEnums['String']
  templateKey?: Maybe<ScalarsEnums['String']>
  updatedAt?: Maybe<ScalarsEnums['String']>
}

/**
 * Response for site form delete operations
 */
export interface SiteFormDeleteResponse {
  __typename?: 'SiteFormDeleteResponse'
  deleted: ScalarsEnums['Boolean']
}

/**
 * Response for site form mutation operations
 */
export interface SiteFormMutationResponse {
  __typename?: 'SiteFormMutationResponse'
  updated: ScalarsEnums['Boolean']
}

/**
 * A question within a site form
 */
export interface SiteFormQuestion {
  __typename?: 'SiteFormQuestion'
  createdAt?: Maybe<ScalarsEnums['String']>
  deletedAt?: Maybe<ScalarsEnums['String']>
  excludeFromScore?: Maybe<ScalarsEnums['Boolean']>
  mustAnswerYes?: Maybe<ScalarsEnums['Boolean']>
  optionScores?: Maybe<Array<ScalarsEnums['Float']>>
  options?: Maybe<Array<ScalarsEnums['String']>>
  orderIndex: ScalarsEnums['Float']
  required?: Maybe<ScalarsEnums['Boolean']>
  siteCustomPropertyId?: Maybe<ScalarsEnums['String']>
  siteFormId: ScalarsEnums['String']
  siteFormQuestionId: ScalarsEnums['String']
  title: ScalarsEnums['String']
  type: ScalarsEnums['SiteFormQuestionType']
  updatedAt?: Maybe<ScalarsEnums['String']>
}

/**
 * Response containing the order index of a question
 */
export interface SiteFormQuestionOrderResponse {
  __typename?: 'SiteFormQuestionOrderResponse'
  orderIndex: ScalarsEnums['Float']
}

/**
 * Response containing the count of updated questions
 */
export interface SiteFormReorderResponse {
  __typename?: 'SiteFormReorderResponse'
  updatedCount: ScalarsEnums['Float']
}

export interface SiteFormScoreBands {
  __typename?: 'SiteFormScoreBands'
  bandId: ScalarsEnums['ID']
  description?: Maybe<ScalarsEnums['String']>
  label: ScalarsEnums['String']
  max: ScalarsEnums['Float']
  min: ScalarsEnums['Float']
}

/**
 * A Hapana-provided form a location can create an editable copy of
 */
export interface SiteFormTemplate {
  __typename?: 'SiteFormTemplate'
  bandCount: ScalarsEnums['Float']
  description: ScalarsEnums['String']
  key: ScalarsEnums['String']
  name: ScalarsEnums['String']
  questionCount: ScalarsEnums['Float']
  source: ScalarsEnums['String']
}

/**
 * The gift card expiry policy that applies to sales made at a site
 */
export interface SiteGiftCardExpiryPolicy {
  __typename?: 'SiteGiftCardExpiryPolicy'
  jurisdictionCode?: Maybe<ScalarsEnums['String']>
  jurisdictionName?: Maybe<ScalarsEnums['String']>
  policy: ResolvedGiftCardExpiryPolicy
  siteId: ScalarsEnums['ID']
  siteName: ScalarsEnums['String']
  stateRequired: ScalarsEnums['Boolean']
  timezone: ScalarsEnums['String']
}

/**
 * Group of sites for managing staff access permissions
 */
export interface SiteGroup {
  __typename?: 'SiteGroup'
  corporateId?: Maybe<ScalarsEnums['ID']>
  createdAt: ScalarsEnums['String']
  isAllSites: ScalarsEnums['Boolean']
  name: ScalarsEnums['String']
  siteGroupId: ScalarsEnums['ID']
  siteIds?: Maybe<Array<ScalarsEnums['ID']>>
  /**
   * Sites of this site group
   */
  sites: Array<SiteReference>
  updatedAt: ScalarsEnums['String']
}

/**
 * Whether the caller can assign a staff access policy at one location group
 */
export interface SiteGroupAssignability {
  __typename?: 'SiteGroupAssignability'
  isAssignable: ScalarsEnums['Boolean']
  missing: MissingPermissions
  missingCount: ScalarsEnums['Int']
  name: ScalarsEnums['String']
  siteGroupId: ScalarsEnums['ID']
}

export interface SiteGroups {
  __typename?: 'SiteGroups'
  pageInfo: SiteGroupsPageInfo
  results: Array<SiteGroupsResults>
}

export interface SiteGroupsPageInfo {
  __typename?: 'SiteGroupsPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface SiteGroupsResults {
  __typename?: 'SiteGroupsResults'
  cursor: ScalarsEnums['String']
  row: SiteGroup
}

/**
 * Site Grow integration status with HQ link and sync info
 */
export interface SiteGrowStatus {
  __typename?: 'SiteGrowStatus'
  enabled: ScalarsEnums['Boolean']
  growLocationId?: Maybe<ScalarsEnums['String']>
  hasAuthentication: ScalarsEnums['Boolean']
  hqId?: Maybe<ScalarsEnums['String']>
  isV2Enabled: ScalarsEnums['Boolean']
  lastSyncedAt?: Maybe<ScalarsEnums['String']>
  syncStatus?: Maybe<ScalarsEnums['SyncStatus']>
}

export interface SiteIntegrations {
  __typename?: 'SiteIntegrations'
  accessControls?: Maybe<SiteIntegrationsAccessControls>
  accuroFit?: Maybe<SiteIntegrationsAccuroFit>
  barcodeUrl?: Maybe<SiteIntegrationsBarcodeUrl>
  calendarSync?: Maybe<SiteIntegrationsCalendarSync>
  classPass?: Maybe<SiteIntegrationsClassPass>
  egym?: Maybe<SiteIntegrationsEgym>
  externalFeedbackLink?: Maybe<SiteIntegrationsExternalFeedbackLink>
  facebookPixel?: Maybe<SiteIntegrationsFacebookPixel>
  fitnessPassport?: Maybe<SiteIntegrationsFitnessPassport>
  frontDeskKiosk?: Maybe<SiteIntegrationsFrontDeskKiosk>
  googleTagManager?: Maybe<SiteIntegrationsGoogleTagManager>
  grow?: Maybe<SiteIntegrationsGrow>
  /**
   * WIP: This schema needs to be revisited based on final implementation requirements
   */
  hapanaAccessController?: Maybe<SiteIntegrationsHapanaAccessController>
  hapanaApiKey?: Maybe<SiteIntegrationsHapanaApiKey>
  importClients?: Maybe<SiteIntegrationsImportClients>
  spivi?: Maybe<SiteIntegrationsSpivi>
  tanning?: Maybe<SiteIntegrationsTanning>
  tanningHealth?: Maybe<SiteIntegrationsTanningHealth>
  topaz?: Maybe<SiteIntegrationsTopaz>
  wellhub?: Maybe<SiteIntegrationsWellhub>
  zapier?: Maybe<SiteIntegrationsZapier>
  zoom?: Maybe<SiteIntegrationsZoom>
}

export interface SiteIntegrationsAccessControls {
  __typename?: 'SiteIntegrationsAccessControls'
  doors?: Maybe<Array<SiteIntegrationsAccessControlsDoors>>
}

export interface SiteIntegrationsAccessControlsDoors {
  __typename?: 'SiteIntegrationsAccessControlsDoors'
  accessGroupId?: Maybe<ScalarsEnums['String']>
  accessHours: ScalarsEnums['Boolean']
  doorId: ScalarsEnums['String']
  endTime?: Maybe<ScalarsEnums['String']>
  label: ScalarsEnums['String']
  provider: ScalarsEnums['AccessControlProvider']
  sessionTypes: Array<ScalarsEnums['String']>
  startTime?: Maybe<ScalarsEnums['String']>
}

export interface SiteIntegrationsAccuroFit {
  __typename?: 'SiteIntegrationsAccuroFit'
  clientId?: Maybe<ScalarsEnums['String']>
}

export interface SiteIntegrationsBarcodeUrl {
  __typename?: 'SiteIntegrationsBarcodeUrl'
  barcodeCheckInUrl?: Maybe<ScalarsEnums['String']>
}

export interface SiteIntegrationsCalendarSync {
  __typename?: 'SiteIntegrationsCalendarSync'
  calendars?: Maybe<Array<SiteIntegrationsCalendarSyncCalendars>>
}

export interface SiteIntegrationsCalendarSyncCalendars {
  __typename?: 'SiteIntegrationsCalendarSyncCalendars'
  calendarId: ScalarsEnums['String']
  calendarLink: ScalarsEnums['String']
  calendarName: ScalarsEnums['String']
}

export interface SiteIntegrationsClassPass {
  __typename?: 'SiteIntegrationsClassPass'
  classPassSpotsPerSession?: Maybe<ScalarsEnums['Float']>
  enabled: ScalarsEnums['Boolean']
}

export interface SiteIntegrationsEgym {
  __typename?: 'SiteIntegrationsEgym'
  activeMembershipType: ScalarsEnums['EgymMembershipType']
  consecutiveFailures?: Maybe<ScalarsEnums['Float']>
  enabled: ScalarsEnums['Boolean']
  lastError?: Maybe<ScalarsEnums['String']>
  lastFailureAt?: Maybe<ScalarsEnums['String']>
  lastSuccessAt?: Maybe<ScalarsEnums['String']>
}

export interface SiteIntegrationsExternalFeedbackLink {
  __typename?: 'SiteIntegrationsExternalFeedbackLink'
  url?: Maybe<ScalarsEnums['String']>
}

export interface SiteIntegrationsFacebookPixel {
  __typename?: 'SiteIntegrationsFacebookPixel'
  events?: Maybe<Array<SiteIntegrationsFacebookPixelEvents>>
  pixelId?: Maybe<ScalarsEnums['String']>
}

export interface SiteIntegrationsFacebookPixelEvents {
  __typename?: 'SiteIntegrationsFacebookPixelEvents'
  enabled: ScalarsEnums['Boolean']
  facebookEventName: ScalarsEnums['String']
  name: ScalarsEnums['String']
}

export interface SiteIntegrationsFitnessPassport {
  __typename?: 'SiteIntegrationsFitnessPassport'
  deviceTokenSuffix?: Maybe<ScalarsEnums['String']>
  enabled: ScalarsEnums['Boolean']
  failurePolicy: ScalarsEnums['FitnessPassportFailurePolicy']
  lastTestError?: Maybe<ScalarsEnums['String']>
  lastTestOutcome?: Maybe<ScalarsEnums['FitnessPassportConnectionState']>
  lastTestedAt?: Maybe<ScalarsEnums['String']>
  siteTokenSuffix?: Maybe<ScalarsEnums['String']>
}

export interface SiteIntegrationsFrontDeskKiosk {
  __typename?: 'SiteIntegrationsFrontDeskKiosk'
  betaVersion?: Maybe<SiteIntegrationsFrontDeskKioskBetaVersion>
  kioskDefaults?: Maybe<SiteIntegrationsFrontDeskKioskKioskDefaults>
  kioskUrlV1?: Maybe<ScalarsEnums['String']>
}

export interface SiteIntegrationsFrontDeskKioskBetaVersion {
  __typename?: 'SiteIntegrationsFrontDeskKioskBetaVersion'
  classCheckInEnabled?: Maybe<ScalarsEnums['Boolean']>
  classCheckInRequirePolicies?: Maybe<ScalarsEnums['Boolean']>
  classCheckInSpotBooking?: Maybe<ScalarsEnums['Boolean']>
  enabled?: Maybe<ScalarsEnums['Boolean']>
  introOffersEnabled?: Maybe<ScalarsEnums['Boolean']>
  kioskPinHash?: Maybe<ScalarsEnums['String']>
  kioskPinSetAt?: Maybe<ScalarsEnums['String']>
  kioskSessionId?: Maybe<ScalarsEnums['String']>
  kioskSessionValidityDays?: Maybe<ScalarsEnums['Float']>
  kioskUrlV2?: Maybe<ScalarsEnums['String']>
  packagesMembershipsEnabled?: Maybe<ScalarsEnums['Boolean']>
}

export interface SiteIntegrationsFrontDeskKioskKioskDefaults {
  __typename?: 'SiteIntegrationsFrontDeskKioskKioskDefaults'
  checkIn?: Maybe<ScalarsEnums['Boolean']>
  classCheckIn?: Maybe<ScalarsEnums['Boolean']>
  forms?: Maybe<ScalarsEnums['Boolean']>
  introOffers?: Maybe<ScalarsEnums['Boolean']>
  manageAccount?: Maybe<ScalarsEnums['Boolean']>
  packages?: Maybe<ScalarsEnums['Boolean']>
}

export interface SiteIntegrationsGoogleTagManager {
  __typename?: 'SiteIntegrationsGoogleTagManager'
  gtmId?: Maybe<ScalarsEnums['String']>
}

export interface SiteIntegrationsGrow {
  __typename?: 'SiteIntegrationsGrow'
  authentication?: Maybe<SiteIntegrationsGrowAuthentication>
  enabled: ScalarsEnums['Boolean']
  growLocationId?: Maybe<ScalarsEnums['String']>
  hqId?: Maybe<ScalarsEnums['String']>
  lastCollect?: Maybe<SiteIntegrationsGrowLastCollect>
}

export interface SiteIntegrationsGrowAuthentication {
  __typename?: 'SiteIntegrationsGrowAuthentication'
  accessToken: ScalarsEnums['String']
  expiresAt: ScalarsEnums['String']
  refreshToken: ScalarsEnums['String']
}

export interface SiteIntegrationsGrowLastCollect {
  __typename?: 'SiteIntegrationsGrowLastCollect'
  full?: Maybe<ScalarsEnums['String']>
  partial?: Maybe<ScalarsEnums['String']>
}

export interface SiteIntegrationsHapanaAccessController {
  __typename?: 'SiteIntegrationsHapanaAccessController'
  accessPoints?: Maybe<Array<SiteIntegrationsHapanaAccessControllerAccessPoints>>
  groups?: Maybe<Array<SiteIntegrationsHapanaAccessControllerGroups>>
}

export interface SiteIntegrationsHapanaAccessControllerAccessPoints {
  __typename?: 'SiteIntegrationsHapanaAccessControllerAccessPoints'
  accessPointId?: Maybe<ScalarsEnums['String']>
  accessPointName: ScalarsEnums['String']
  groupName: ScalarsEnums['String']
  provisionCode: ScalarsEnums['String']
}

export interface SiteIntegrationsHapanaAccessControllerGroups {
  __typename?: 'SiteIntegrationsHapanaAccessControllerGroups'
  groupId?: Maybe<ScalarsEnums['String']>
  groupName: ScalarsEnums['String']
}

export interface SiteIntegrationsHapanaApiKey {
  __typename?: 'SiteIntegrationsHapanaApiKey'
  apiKey?: Maybe<ScalarsEnums['String']>
}

export interface SiteIntegrationsImportClients {
  __typename?: 'SiteIntegrationsImportClients'
  enabled?: Maybe<ScalarsEnums['Boolean']>
  lastImportDate?: Maybe<ScalarsEnums['String']>
}

export interface SiteIntegrationsSpivi {
  __typename?: 'SiteIntegrationsSpivi'
  boxId?: Maybe<ScalarsEnums['String']>
  password?: Maybe<ScalarsEnums['String']>
  publicKey?: Maybe<ScalarsEnums['String']>
  siteId?: Maybe<ScalarsEnums['String']>
  sourceName?: Maybe<ScalarsEnums['String']>
}

export interface SiteIntegrationsTanning {
  __typename?: 'SiteIntegrationsTanning'
  apiKey?: Maybe<ScalarsEnums['String']>
  externalApiKey?: Maybe<ScalarsEnums['String']>
  externalApiUrl?: Maybe<ScalarsEnums['String']>
  maintenanceEmail?: Maybe<ScalarsEnums['String']>
}

export interface SiteIntegrationsTanningHealth {
  __typename?: 'SiteIntegrationsTanningHealth'
  consecutiveStartFailures?: Maybe<ScalarsEnums['Float']>
  lastBedUpdateAt?: Maybe<ScalarsEnums['String']>
  lastRegisteredAt?: Maybe<ScalarsEnums['String']>
  lastStartError?: Maybe<SiteIntegrationsTanningHealthLastStartError>
  lastStartFailureAt?: Maybe<ScalarsEnums['String']>
  lastStartSuccessAt?: Maybe<ScalarsEnums['String']>
}

export interface SiteIntegrationsTanningHealthLastStartError {
  __typename?: 'SiteIntegrationsTanningHealthLastStartError'
  connectorCode?: Maybe<ScalarsEnums['String']>
  kind: ScalarsEnums['TanningConnectorErrorKind']
  message: ScalarsEnums['String']
}

export interface SiteIntegrationsTopaz {
  __typename?: 'SiteIntegrationsTopaz'
  enabled: ScalarsEnums['Boolean']
}

export interface SiteIntegrationsWellhub {
  __typename?: 'SiteIntegrationsWellhub'
  connectedAt?: Maybe<ScalarsEnums['String']>
  enabled: ScalarsEnums['Boolean']
  gymId?: Maybe<ScalarsEnums['String']>
  gymName?: Maybe<ScalarsEnums['String']>
}

export interface SiteIntegrationsZapier {
  __typename?: 'SiteIntegrationsZapier'
  webhooks?: Maybe<SiteIntegrationsZapierWebhooks>
}

export interface SiteIntegrationsZapierWebhooks {
  __typename?: 'SiteIntegrationsZapierWebhooks'
  client?: Maybe<ScalarsEnums['String']>
  clientCheckIn?: Maybe<ScalarsEnums['String']>
  firstSessionBooking?: Maybe<ScalarsEnums['String']>
  lead?: Maybe<ScalarsEnums['String']>
  membershipCancellation?: Maybe<ScalarsEnums['String']>
  membershipSuspension?: Maybe<ScalarsEnums['String']>
  packagePurchase?: Maybe<ScalarsEnums['String']>
  sessionBooking?: Maybe<ScalarsEnums['String']>
}

export interface SiteIntegrationsZoom {
  __typename?: 'SiteIntegrationsZoom'
  accountId?: Maybe<ScalarsEnums['String']>
  authorized: ScalarsEnums['Boolean']
  connectedAt?: Maybe<ScalarsEnums['String']>
  connectedUserEmail?: Maybe<ScalarsEnums['String']>
  connectedUserId?: Maybe<ScalarsEnums['String']>
  userId?: Maybe<ScalarsEnums['String']>
}

/**
 * A named custom late-cancel fee that can override the general late-cancel fee
 */
export interface SiteLateCancelFee {
  __typename?: 'SiteLateCancelFee'
  automaticCharge: ScalarsEnums['Boolean']
  createdAt: ScalarsEnums['String']
  creditRefund: ScalarsEnums['Boolean']
  deletedAt?: Maybe<ScalarsEnums['String']>
  lateCancelFeeId: ScalarsEnums['ID']
  name: ScalarsEnums['String']
  price: ScalarsEnums['Numeric']
  revenueTagId?: Maybe<ScalarsEnums['ID']>
  siteId: ScalarsEnums['ID']
  taxSettingIds?: Maybe<Array<ScalarsEnums['ID']>>
  unlimitedCreditsOnly: ScalarsEnums['Boolean']
  updatedAt: ScalarsEnums['String']
}

/**
 * Templates, recurring series and standalone sessions currently assigned to a custom late-cancel fee
 */
export interface SiteLateCancelFeeUsage {
  __typename?: 'SiteLateCancelFeeUsage'
  recurringSessions: Array<SiteLateCancelFeeUsageRecurringSession>
  sessionTemplates: Array<SiteLateCancelFeeUsageTemplate>
  sessions: Array<SiteLateCancelFeeUsageSession>
}

/**
 * A custom late-cancel fee paired with what it is currently applied to
 */
export interface SiteLateCancelFeeUsageEntry {
  __typename?: 'SiteLateCancelFeeUsageEntry'
  lateCancelFeeId: ScalarsEnums['ID']
  usage: SiteLateCancelFeeUsage
}

export interface SiteLateCancelFeeUsageRecurringSession {
  __typename?: 'SiteLateCancelFeeUsageRecurringSession'
  daysOfWeek: Array<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  recurringSessionsId: ScalarsEnums['ID']
  startTime: ScalarsEnums['String']
}

export interface SiteLateCancelFeeUsageSession {
  __typename?: 'SiteLateCancelFeeUsageSession'
  date: ScalarsEnums['String']
  name: ScalarsEnums['String']
  sessionId: ScalarsEnums['ID']
  startTime: ScalarsEnums['String']
}

export interface SiteLateCancelFeeUsageTemplate {
  __typename?: 'SiteLateCancelFeeUsageTemplate'
  name: ScalarsEnums['String']
  sessionTemplateId: ScalarsEnums['ID']
}

/**
 * value is set only for LIVE_FEWER_THAN (the privacy floor) and LIVE_ABOUT (the band); the raw count never leaves the service
 */
export interface SiteLiveOccupancy {
  __typename?: 'SiteLiveOccupancy'
  alertsVersion: ScalarsEnums['String']
  isVisibleToGuests: ScalarsEnums['Boolean']
  labelKey: ScalarsEnums['LiveOccupancyLabelKey']
  nextOpening?: Maybe<NextOpening>
  status: ScalarsEnums['LiveOccupancyStatus']
  updatedAt: ScalarsEnums['String']
  value?: Maybe<ScalarsEnums['Int']>
}

/**
 * A physical or digital location for a site
 */
export interface SiteLocation {
  __typename?: 'SiteLocation'
  addressLine1?: Maybe<ScalarsEnums['String']>
  addressLine2?: Maybe<ScalarsEnums['String']>
  channelId?: Maybe<ScalarsEnums['String']>
  city?: Maybe<ScalarsEnums['String']>
  country?: Maybe<ScalarsEnums['String']>
  createdAt: ScalarsEnums['String']
  deletedAt?: Maybe<ScalarsEnums['String']>
  isDefault: ScalarsEnums['Boolean']
  name: ScalarsEnums['String']
  postalCode?: Maybe<ScalarsEnums['String']>
  rooms?: Maybe<Array<SiteLocationRoom>>
  siteId: ScalarsEnums['String']
  siteLocationId: ScalarsEnums['String']
  state?: Maybe<ScalarsEnums['String']>
  type: ScalarsEnums['SiteLocationType']
  updatedAt: ScalarsEnums['String']
}

/**
 * A room within a site location
 */
export interface SiteLocationRoom {
  __typename?: 'SiteLocationRoom'
  allowOverlapping: ScalarsEnums['Boolean']
  createdAt: ScalarsEnums['String']
  customHours?: Maybe<SiteLocationRoomCustomHours>
  deletedAt?: Maybe<ScalarsEnums['String']>
  endTime?: Maybe<ScalarsEnums['String']>
  hasResourceBooking: ScalarsEnums['Boolean']
  name: ScalarsEnums['String']
  roomResourceTemplateId?: Maybe<ScalarsEnums['String']>
  sameHoursAsLocation: ScalarsEnums['Boolean']
  siteId: ScalarsEnums['String']
  siteLocationId: ScalarsEnums['String']
  siteLocationRoomId: ScalarsEnums['String']
  startTime?: Maybe<ScalarsEnums['String']>
  updatedAt: ScalarsEnums['String']
}

export interface SiteLocationRoomCustomHours {
  __typename?: 'SiteLocationRoomCustomHours'
  friday?: Maybe<SiteLocationRoomCustomHoursMonday>
  monday?: Maybe<SiteLocationRoomCustomHoursMonday>
  saturday?: Maybe<SiteLocationRoomCustomHoursMonday>
  sunday?: Maybe<SiteLocationRoomCustomHoursMonday>
  thursday?: Maybe<SiteLocationRoomCustomHoursMonday>
  tuesday?: Maybe<SiteLocationRoomCustomHoursMonday>
  wednesday?: Maybe<SiteLocationRoomCustomHoursMonday>
}

export interface SiteLocationRoomCustomHoursMonday {
  __typename?: 'SiteLocationRoomCustomHoursMonday'
  endTime: ScalarsEnums['String']
  startTime: ScalarsEnums['String']
}

/**
 * A location’s Plan your visit configuration resolved with defaults
 */
export interface SiteMemberAppSettingsResult {
  __typename?: 'SiteMemberAppSettingsResult'
  settings: SiteMemberAppSettingsResultSettings
  staffInsights: SiteMemberAppStaffInsights
}

export interface SiteMemberAppSettingsResultSettings {
  __typename?: 'SiteMemberAppSettingsResultSettings'
  locationInformation: SiteMemberAppSettingsResultSettingsLocationInformation
  planYourVisit: SiteMemberAppSettingsResultSettingsPlanYourVisit
}

export interface SiteMemberAppSettingsResultSettingsLocationInformation {
  __typename?: 'SiteMemberAppSettingsResultSettingsLocationInformation'
  amenities: SiteMemberAppSettingsResultSettingsLocationInformationAmenities
  blocks: Array<SiteSettingsLocationMemberAppLocationInformationBlocks>
  heading: ScalarsEnums['String']
  isEnabled: ScalarsEnums['Boolean']
  staffedHours: SiteMemberAppSettingsResultSettingsLocationInformationStaffedHours
}

export interface SiteMemberAppSettingsResultSettingsLocationInformationAmenities {
  __typename?: 'SiteMemberAppSettingsResultSettingsLocationInformationAmenities'
  isEnabled: ScalarsEnums['Boolean']
  items: Array<SiteSettingsLocationMemberAppLocationInformationAmenitiesItems>
  maxVisible: ScalarsEnums['Int']
}

export interface SiteMemberAppSettingsResultSettingsLocationInformationStaffedHours {
  __typename?: 'SiteMemberAppSettingsResultSettingsLocationInformationStaffedHours'
  isEnabled: ScalarsEnums['Boolean']
  label: ScalarsEnums['String']
  schedule: SiteSettingsLocationMemberAppLocationInformationStaffedHoursSchedule
}

export interface SiteMemberAppSettingsResultSettingsPlanYourVisit {
  __typename?: 'SiteMemberAppSettingsResultSettingsPlanYourVisit'
  forecast: SiteMemberAppSettingsResultSettingsPlanYourVisitForecast
  isEnabled: ScalarsEnums['Boolean']
  isVisibleToGuests: ScalarsEnums['Boolean']
  liveOccupancy: SiteMemberAppSettingsResultSettingsPlanYourVisitLiveOccupancy
  title: ScalarsEnums['String']
}

export interface SiteMemberAppSettingsResultSettingsPlanYourVisitForecast {
  __typename?: 'SiteMemberAppSettingsResultSettingsPlanYourVisitForecast'
  chartEndHour?: Maybe<ScalarsEnums['Int']>
  chartStartHour?: Maybe<ScalarsEnums['Int']>
  isEnabled: ScalarsEnums['Boolean']
  lookbackWeeks: ScalarsEnums['Int']
}

export interface SiteMemberAppSettingsResultSettingsPlanYourVisitLiveOccupancy {
  __typename?: 'SiteMemberAppSettingsResultSettingsPlanYourVisitLiveOccupancy'
  averageVisitMinutes: ScalarsEnums['Int']
  bandSize: ScalarsEnums['Int']
  displayMode: ScalarsEnums['OccupancyDisplayMode']
  hideWhenClosed: ScalarsEnums['Boolean']
  isEnabled: ScalarsEnums['Boolean']
  privacyFloor: ScalarsEnums['Int']
}

/**
 * Staff-only calibration read-outs. liveEstimate is the raw distinct-visitor count members never see.
 */
export interface SiteMemberAppStaffInsights {
  __typename?: 'SiteMemberAppStaffInsights'
  forecast?: Maybe<SiteVisitForecastInsights>
  liveEstimate?: Maybe<ScalarsEnums['Int']>
  liveWindowMinutes: ScalarsEnums['Int']
}

/**
 * A named custom no-show fee that can override the general no-show fee
 */
export interface SiteNoShowFee {
  __typename?: 'SiteNoShowFee'
  automaticCharge: ScalarsEnums['Boolean']
  createdAt: ScalarsEnums['String']
  creditRefund: ScalarsEnums['Boolean']
  deletedAt?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  noShowFeeId: ScalarsEnums['ID']
  price: ScalarsEnums['Numeric']
  revenueTagId?: Maybe<ScalarsEnums['ID']>
  siteId: ScalarsEnums['ID']
  taxSettingIds?: Maybe<Array<ScalarsEnums['ID']>>
  unlimitedCreditsOnly: ScalarsEnums['Boolean']
  updatedAt: ScalarsEnums['String']
}

/**
 * Templates, recurring series and standalone sessions currently assigned to a custom no-show fee
 */
export interface SiteNoShowFeeUsage {
  __typename?: 'SiteNoShowFeeUsage'
  recurringSessions: Array<SiteNoShowFeeUsageRecurringSession>
  sessionTemplates: Array<SiteNoShowFeeUsageTemplate>
  sessions: Array<SiteNoShowFeeUsageSession>
}

/**
 * A custom no-show fee paired with what it is currently applied to
 */
export interface SiteNoShowFeeUsageEntry {
  __typename?: 'SiteNoShowFeeUsageEntry'
  noShowFeeId: ScalarsEnums['ID']
  usage: SiteNoShowFeeUsage
}

export interface SiteNoShowFeeUsageRecurringSession {
  __typename?: 'SiteNoShowFeeUsageRecurringSession'
  daysOfWeek: Array<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  recurringSessionsId: ScalarsEnums['ID']
  startTime: ScalarsEnums['String']
}

export interface SiteNoShowFeeUsageSession {
  __typename?: 'SiteNoShowFeeUsageSession'
  date: ScalarsEnums['String']
  name: ScalarsEnums['String']
  sessionId: ScalarsEnums['ID']
  startTime: ScalarsEnums['String']
}

export interface SiteNoShowFeeUsageTemplate {
  __typename?: 'SiteNoShowFeeUsageTemplate'
  name: ScalarsEnums['String']
  sessionTemplateId: ScalarsEnums['ID']
}

/**
 * Brand payment-authorisation copy (cancellation policy, support contact, legal entity)
 */
export interface SitePaymentAuthorisationConfig {
  __typename?: 'SitePaymentAuthorisationConfig'
  bankDebitAuthorisation?: Maybe<SitePaymentAuthorisationConfigBankDebitAuthorisation>
  cancellationPolicy?: Maybe<ScalarsEnums['String']>
  customerServiceContact?: Maybe<ScalarsEnums['String']>
  depositNote?: Maybe<ScalarsEnums['String']>
  legalEntityName?: Maybe<ScalarsEnums['String']>
  salesTaxNote?: Maybe<ScalarsEnums['String']>
  template?: Maybe<ScalarsEnums['String']>
}

export interface SitePaymentAuthorisationConfigBankDebitAuthorisation {
  __typename?: 'SitePaymentAuthorisationConfigBankDebitAuthorisation'
  coversLocationsFrom: ScalarsEnums['String']
  evidenceReference: ScalarsEnums['String']
  originatorName: ScalarsEnums['String']
}

/**
 * Ezypay details for a site payment gateway (NEVER exposes merchantPassword)
 */
export interface SitePaymentGatewayEzypayField {
  __typename?: 'SitePaymentGatewayEzypayField'
  isSandbox?: Maybe<ScalarsEnums['Boolean']>
  merchantId?: Maybe<ScalarsEnums['String']>
  merchantUsername?: Maybe<ScalarsEnums['String']>
  paymentContactEmail?: Maybe<ScalarsEnums['String']>
  sitePaymentGatewayId?: Maybe<ScalarsEnums['ID']>
}

/**
 * Current active payment gateway for a site
 */
export interface SitePaymentGatewayField {
  __typename?: 'SitePaymentGatewayField'
  current?: Maybe<ScalarsEnums['String']>
  ezypay?: Maybe<SitePaymentGatewayEzypayField>
  isSandbox?: Maybe<ScalarsEnums['Boolean']>
  stripeConnect?: Maybe<SitePaymentGatewayStripeConnectField>
}

/**
 * Payment gateway information for a site including bank capabilities
 */
export interface SitePaymentGatewayInfo {
  __typename?: 'SitePaymentGatewayInfo'
  countryCode?: Maybe<ScalarsEnums['String']>
  gatewayBankMethodName?: Maybe<ScalarsEnums['String']>
  gatewayManagesFailedPaymentFees: ScalarsEnums['Boolean']
  hasBankAccountCapabilities: ScalarsEnums['Boolean']
  hasBankAccountRefundCapabilities: ScalarsEnums['Boolean']
  paymentGatewayPublishableKey?: Maybe<ScalarsEnums['String']>
  paymentGatewayType?: Maybe<ScalarsEnums['String']>
  siteId: ScalarsEnums['ID']
  supportsAccountCodes: ScalarsEnums['Boolean']
}

/**
 * Onboarding status info for payment gateway banners
 */
export interface SitePaymentGatewayOnboardingStatusInfo {
  __typename?: 'SitePaymentGatewayOnboardingStatusInfo'
  hasEventuallyDueRequirements: ScalarsEnums['Boolean']
  onboardingStatus?: Maybe<ScalarsEnums['String']>
  requiresAttention: ScalarsEnums['Boolean']
}

/**
 * Stripe Connect details for a site payment gateway
 */
export interface SitePaymentGatewayStripeConnectField {
  __typename?: 'SitePaymentGatewayStripeConnectField'
  chargesEnabled?: Maybe<ScalarsEnums['Boolean']>
  connectionStatus?: Maybe<ScalarsEnums['String']>
  detailsSubmitted?: Maybe<ScalarsEnums['Boolean']>
  isLegacySharedAccount?: Maybe<ScalarsEnums['Boolean']>
  isSandbox?: Maybe<ScalarsEnums['Boolean']>
  paymentContactEmail?: Maybe<ScalarsEnums['String']>
  payoutFrequency?: Maybe<SitePaymentGatewayStripeConnectFieldPayoutFrequency>
  payoutsEnabled?: Maybe<ScalarsEnums['Boolean']>
  requirements?: Maybe<SitePaymentGatewayStripeConnectRequirements>
  siteGatewayAccountId?: Maybe<ScalarsEnums['String']>
}

export interface SitePaymentGatewayStripeConnectFieldPayoutFrequency {
  __typename?: 'SitePaymentGatewayStripeConnectFieldPayoutFrequency'
  current?: Maybe<ScalarsEnums['String']>
  onStripe?: Maybe<ScalarsEnums['String']>
}

export interface SitePaymentGatewayStripeConnectRequirements {
  __typename?: 'SitePaymentGatewayStripeConnectRequirements'
  currentDeadline?: Maybe<ScalarsEnums['Float']>
  currentlyDue: Array<ScalarsEnums['String']>
  disabledReason?: Maybe<ScalarsEnums['String']>
  eventuallyDue: Array<ScalarsEnums['String']>
  pastDue: Array<ScalarsEnums['String']>
  pendingVerification: Array<ScalarsEnums['String']>
}

/**
 * Details of a saved payment method for a site
 */
export interface SitePaymentMethodDetails {
  __typename?: 'SitePaymentMethodDetails'
  brand: ScalarsEnums['String']
  expMonth: ScalarsEnums['Float']
  expYear: ScalarsEnums['Float']
  last4: ScalarsEnums['String']
  paymentMethodId: ScalarsEnums['String']
}

export interface SitePayrollTier {
  __typename?: 'SitePayrollTier'
  assignments: Array<SitePayrollTierAssignments>
  configurations: Array<SitePayrollTierConfigurations>
  createdAt: ScalarsEnums['String']
  deletedAt?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  siteId: ScalarsEnums['ID']
  sitePayrollTierId: ScalarsEnums['ID']
  updatedAt: ScalarsEnums['String']
}

export interface SitePayrollTierAssignments {
  __typename?: 'SitePayrollTierAssignments'
  createdAt: ScalarsEnums['String']
  createdByStaffUserId?: Maybe<ScalarsEnums['ID']>
  endDate?: Maybe<ScalarsEnums['String']>
  futureAssignmentDate?: Maybe<ScalarsEnums['String']>
  payrollTierAssignmentId: ScalarsEnums['ID']
  siteId: ScalarsEnums['ID']
  sitePayrollTierId: ScalarsEnums['ID']
  staffUserId: ScalarsEnums['ID']
  staffUserName?: Maybe<ScalarsEnums['String']>
  startDate: ScalarsEnums['String']
  updatedAt: ScalarsEnums['String']
}

export interface SitePayrollTierConfigurations {
  __typename?: 'SitePayrollTierConfigurations'
  createdAt: ScalarsEnums['String']
  deletedAt?: Maybe<ScalarsEnums['String']>
  payrollTierConfigurationId: ScalarsEnums['ID']
  payrollType: ScalarsEnums['PayrollType']
  rates: SitePayrollTierConfigurationsRates
  siteId: ScalarsEnums['ID']
  sitePayrollTierId: ScalarsEnums['ID']
  siteSessionTypeId?: Maybe<ScalarsEnums['ID']>
  siteSessionTypeName?: Maybe<ScalarsEnums['String']>
  type: ScalarsEnums['PayrollTierType']
  updatedAt: ScalarsEnums['String']
}

export interface SitePayrollTierConfigurationsRates {
  __typename?: 'SitePayrollTierConfigurationsRates'
  bonusClassFull?: Maybe<ScalarsEnums['Float']>
  bonusFlat?: Maybe<ScalarsEnums['Float']>
  bonusPerClient?: Maybe<ScalarsEnums['Float']>
  clientOver?: Maybe<ScalarsEnums['Float']>
  flat?: Maybe<ScalarsEnums['Float']>
  hourly?: Maybe<ScalarsEnums['Float']>
  perHead?: Maybe<ScalarsEnums['Float']>
  percentage?: Maybe<ScalarsEnums['Float']>
  unlimitedFixed?: Maybe<ScalarsEnums['Float']>
}

export interface SitePayrollTiers {
  __typename?: 'SitePayrollTiers'
  id: ScalarsEnums['ID']
  name: ScalarsEnums['String']
}

/**
 * Member-facing Plan your visit payload; open/closed and today are resolved in the site timezone
 */
export interface SitePlanYourVisit {
  __typename?: 'SitePlanYourVisit'
  isVisibleToGuests: ScalarsEnums['Boolean']
  locationInformation?: Maybe<MemberLocationInformation>
  planYourVisit?: Maybe<PlanYourVisitWidget>
  siteId: ScalarsEnums['ID']
  timezone: ScalarsEnums['String']
}

/**
 * A policy document associated with a site
 */
export interface SitePolicy {
  __typename?: 'SitePolicy'
  acceptanceMethod: ScalarsEnums['PolicyAcceptanceMethod']
  content: ScalarsEnums['String']
  createdAt?: Maybe<ScalarsEnums['String']>
  deletedAt?: Maybe<ScalarsEnums['String']>
  equipmentScope: Array<ScalarsEnums['PolicyEquipmentScope']>
  guardianInPersonOnly: ScalarsEnums['Boolean']
  isRequiredToAgree: ScalarsEnums['Boolean']
  name: ScalarsEnums['String']
  renewalMonths?: Maybe<ScalarsEnums['Float']>
  requiredForEquipmentUse: ScalarsEnums['Boolean']
  signerRule: ScalarsEnums['PolicySignerRule']
  siteId: ScalarsEnums['String']
  sitePolicyId: ScalarsEnums['String']
  updatedAt?: Maybe<ScalarsEnums['String']>
  updatedByStaffUserId?: Maybe<ScalarsEnums['String']>
  updatedByStaffUserName?: Maybe<ScalarsEnums['String']>
}

/**
 * The revision a publish created, how many clients must accept again, and any scheduled revision it cancelled
 */
export interface SitePolicyPublishResult {
  __typename?: 'SitePolicyPublishResult'
  cancelledRevisionIds: Array<ScalarsEnums['ID']>
  impactCount: ScalarsEnums['Float']
  revision: SitePolicyRevision
}

/**
 * An immutable published revision of a site policy (D-02)
 */
export interface SitePolicyRevision {
  __typename?: 'SitePolicyRevision'
  acceptanceGeneration: ScalarsEnums['Float']
  acceptanceMethod: ScalarsEnums['PolicyAcceptanceMethod']
  attestationRevisionId?: Maybe<ScalarsEnums['ID']>
  cancelledAt?: Maybe<ScalarsEnums['String']>
  cancelledByStaffUserId?: Maybe<ScalarsEnums['ID']>
  content: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  disclosureRevisionId?: Maybe<ScalarsEnums['ID']>
  effectiveFrom?: Maybe<ScalarsEnums['String']>
  equipmentScope: Array<ScalarsEnums['PolicyEquipmentScope']>
  guardianInPersonOnly: ScalarsEnums['Boolean']
  name: ScalarsEnums['String']
  publishedAt: ScalarsEnums['String']
  publishedByStaffUserId?: Maybe<ScalarsEnums['ID']>
  renewalMonths?: Maybe<ScalarsEnums['Float']>
  requiredForEquipmentUse: ScalarsEnums['Boolean']
  revisionId: ScalarsEnums['ID']
  revisionNumber: ScalarsEnums['Float']
  revisionSha256: ScalarsEnums['String']
  signerRule: ScalarsEnums['PolicySignerRule']
  siteId: ScalarsEnums['ID']
  sitePolicyId: ScalarsEnums['ID']
  status: ScalarsEnums['PolicyRevisionStatus']
}

/**
 * The updated site policy and, when the change published a revision, how many clients must accept again
 */
export interface SitePolicyUpdateResult {
  __typename?: 'SitePolicyUpdateResult'
  acceptanceMethod: ScalarsEnums['PolicyAcceptanceMethod']
  content: ScalarsEnums['String']
  createdAt?: Maybe<ScalarsEnums['String']>
  deletedAt?: Maybe<ScalarsEnums['String']>
  equipmentScope: Array<ScalarsEnums['PolicyEquipmentScope']>
  guardianInPersonOnly: ScalarsEnums['Boolean']
  isRequiredToAgree: ScalarsEnums['Boolean']
  name: ScalarsEnums['String']
  /**
   * The revision this update published, or null when nothing changed
   */
  publishResult?: Maybe<SitePolicyPublishResult>
  renewalMonths?: Maybe<ScalarsEnums['Float']>
  requiredForEquipmentUse: ScalarsEnums['Boolean']
  signerRule: ScalarsEnums['PolicySignerRule']
  siteId: ScalarsEnums['String']
  sitePolicyId: ScalarsEnums['String']
  updatedAt?: Maybe<ScalarsEnums['String']>
  updatedByStaffUserId?: Maybe<ScalarsEnums['String']>
  updatedByStaffUserName?: Maybe<ScalarsEnums['String']>
}

/**
 * The preview of a physical or digital location belonging to a corporate
 */
export interface SitePreview {
  __typename?: 'SitePreview'
  name: ScalarsEnums['String']
  siteId: ScalarsEnums['ID']
}

/**
 * Recurring workshop series used to populate the Website Widgets dropdown
 */
export interface SiteRecurringWorkshop {
  __typename?: 'SiteRecurringWorkshop'
  name: ScalarsEnums['String']
  recurrenceDaysOfWeek?: Maybe<Array<ScalarsEnums['DayOfWeek']>>
  recurrenceInterval: ScalarsEnums['Float']
  recurrenceType: ScalarsEnums['RecurrenceType']
  recurringSessionsId: ScalarsEnums['String']
  startTime: ScalarsEnums['String']
}

export interface SiteReference {
  __typename?: 'SiteReference'
  name: ScalarsEnums['String']
  siteId: ScalarsEnums['ID']
}

/**
 * Unified property requirement for a room resource template (primary or custom)
 */
export interface SiteRoomResourceTemplateProperty {
  __typename?: 'SiteRoomResourceTemplateProperty'
  createdAt: ScalarsEnums['String']
  defaultValue?: Maybe<ScalarsEnums['String']>
  isRequired: ScalarsEnums['Boolean']
  name?: Maybe<ScalarsEnums['String']>
  orderIndex: ScalarsEnums['Float']
  primaryPropertyType?: Maybe<ScalarsEnums['RoomResourceTemplateBookingPropertyTypes']>
  roomResourceTemplateId: ScalarsEnums['String']
  siteCustomPropertyId?: Maybe<ScalarsEnums['String']>
  siteId: ScalarsEnums['String']
  siteRoomResourceTemplatePropertyId: ScalarsEnums['String']
  type: ScalarsEnums['SiteRoomResourceTemplatePropertyTypes']
}

/**
 * A resource template response with booking properties included
 */
export interface SiteRoomResourceTemplateResponse {
  __typename?: 'SiteRoomResourceTemplateResponse'
  bookingProperties?: Maybe<Array<SiteRoomResourceTemplateProperty>>
  boxId?: Maybe<ScalarsEnums['Float']>
  createdAt: ScalarsEnums['String']
  deletedAt?: Maybe<ScalarsEnums['String']>
  description?: Maybe<ScalarsEnums['String']>
  isDefault: ScalarsEnums['Boolean']
  isDraft: ScalarsEnums['Boolean']
  name: ScalarsEnums['String']
  roomResourceTemplateId: ScalarsEnums['String']
  siteId: ScalarsEnums['String']
  spotHeight?: Maybe<ScalarsEnums['Float']>
  spotWidth?: Maybe<ScalarsEnums['Float']>
  spots: Array<SiteRoomResourceTemplateResponseSpots>
  templateImage?: Maybe<RoomResourceTemplateImage>
  updatedAt: ScalarsEnums['String']
}

export interface SiteRoomResourceTemplateResponseSpots {
  __typename?: 'SiteRoomResourceTemplateResponseSpots'
  enabled: ScalarsEnums['Boolean']
  equipmentType: ScalarsEnums['EquipmentType']
  height: ScalarsEnums['Float']
  name: ScalarsEnums['String']
  position: ScalarsEnums['String']
  width: ScalarsEnums['Float']
  x: ScalarsEnums['Float']
  y: ScalarsEnums['Float']
}

/**
 * A session type for a site
 */
export interface SiteSessionType {
  __typename?: 'SiteSessionType'
  allowEditingSessionType: ScalarsEnums['Boolean']
  allowMultiLocationAccess: ScalarsEnums['Boolean']
  category?: Maybe<ScalarsEnums['String']>
  code?: Maybe<ScalarsEnums['Float']>
  color?: Maybe<ScalarsEnums['String']>
  corporateSessionTypeId?: Maybe<ScalarsEnums['ID']>
  createdAt: ScalarsEnums['String']
  customColors?: Maybe<Array<SiteSessionTypeCustomColors>>
  deletedAt?: Maybe<ScalarsEnums['String']>
  displayOrder?: Maybe<ScalarsEnums['Float']>
  isSystemManaged: ScalarsEnums['Boolean']
  lockedSections?: Maybe<Array<ScalarsEnums['SessionGroupSection']>>
  name: ScalarsEnums['String']
  siteId: ScalarsEnums['String']
  siteSessionTypeId: ScalarsEnums['String']
  updatedAt: ScalarsEnums['String']
}

export interface SiteSessionTypeCustomColors {
  __typename?: 'SiteSessionTypeCustomColors'
  colorName: ScalarsEnums['String']
  hexCode: ScalarsEnums['String']
}

export interface SiteSettings {
  __typename?: 'SiteSettings'
  account?: Maybe<SiteSettingsAccount>
  customization?: Maybe<SiteSettingsCustomization>
  embed?: Maybe<SiteSettingsEmbed>
  location?: Maybe<SiteSettingsLocation>
  retail?: Maybe<SiteSettingsRetail>
  scheduler?: Maybe<SiteSettingsScheduler>
  updatedAt?: Maybe<ScalarsEnums['String']>
}

export interface SiteSettingsAccount {
  __typename?: 'SiteSettingsAccount'
  billing?: Maybe<SiteSettingsAccountBilling>
  invoice?: Maybe<SiteSettingsAccountInvoice>
  payroll?: Maybe<SiteSettingsAccountPayroll>
  pointOfSale?: Maybe<SiteSettingsAccountPointOfSale>
  tax?: Maybe<SiteSettingsAccountTax>
}

export interface SiteSettingsAccountBilling {
  __typename?: 'SiteSettingsAccountBilling'
  enabled?: Maybe<ScalarsEnums['Boolean']>
  retryFailedPayments?: Maybe<SiteSettingsAccountBillingRetryFailedPayments>
  transactionFeePreference?: Maybe<ScalarsEnums['TransactionFeePreference']>
}

export interface SiteSettingsAccountBillingRetryFailedPayments {
  __typename?: 'SiteSettingsAccountBillingRetryFailedPayments'
  bankFailoverToCard?: Maybe<SiteSettingsAccountBillingRetryFailedPaymentsBankFailoverToCard>
  enabled?: Maybe<ScalarsEnums['Boolean']>
  intervalInDays: ScalarsEnums['Float']
  maxAttempts: ScalarsEnums['Float']
  maxFailoversPerDay?: Maybe<ScalarsEnums['Float']>
}

export interface SiteSettingsAccountBillingRetryFailedPaymentsBankFailoverToCard {
  __typename?: 'SiteSettingsAccountBillingRetryFailedPaymentsBankFailoverToCard'
  enabled: ScalarsEnums['Boolean']
}

export interface SiteSettingsAccountInvoice {
  __typename?: 'SiteSettingsAccountInvoice'
  email?: Maybe<ScalarsEnums['String']>
  label?: Maybe<ScalarsEnums['String']>
}

export interface SiteSettingsAccountPayroll {
  __typename?: 'SiteSettingsAccountPayroll'
  additionalTypes?: Maybe<Array<ScalarsEnums['PayrollAdditionalTypes']>>
}

export interface SiteSettingsAccountPointOfSale {
  __typename?: 'SiteSettingsAccountPointOfSale'
  enableCashDrawer?: Maybe<ScalarsEnums['Boolean']>
  itemTypes?: Maybe<Array<ScalarsEnums['NewSaleItemTypes']>>
}

export interface SiteSettingsAccountTax {
  __typename?: 'SiteSettingsAccountTax'
  enabled?: Maybe<ScalarsEnums['Boolean']>
}

export interface SiteSettingsCustomization {
  __typename?: 'SiteSettingsCustomization'
  colors?: Maybe<Array<SiteSettingsCustomizationColors>>
}

export interface SiteSettingsCustomizationColors {
  __typename?: 'SiteSettingsCustomizationColors'
  color: ScalarsEnums['String']
  id: ScalarsEnums['String']
}

export interface SiteSettingsEmbed {
  __typename?: 'SiteSettingsEmbed'
  exploreTabs?: Maybe<Array<SiteSettingsEmbedExploreTabs>>
}

export interface SiteSettingsEmbedExploreTabs {
  __typename?: 'SiteSettingsEmbedExploreTabs'
  isDefault?: Maybe<ScalarsEnums['Boolean']>
  key: ScalarsEnums['String']
  label: ScalarsEnums['String']
  sessionTypeIds?: Maybe<Array<ScalarsEnums['String']>>
  source: ScalarsEnums['String']
}

export interface SiteSettingsLocation {
  __typename?: 'SiteSettingsLocation'
  businessInformation?: Maybe<SiteSettingsLocationBusinessInformation>
  checkIn?: Maybe<SiteSettingsLocationCheckIn>
  communications?: Maybe<SiteSettingsLocationCommunications>
  configurations?: Maybe<SiteSettingsLocationConfigurations>
  forms?: Maybe<SiteSettingsLocationForms>
  memberApp?: Maybe<SiteSettingsLocationMemberApp>
  operations?: Maybe<SiteSettingsLocationOperations>
  socialMedia?: Maybe<SiteSettingsLocationSocialMedia>
  tools?: Maybe<SiteSettingsLocationTools>
}

export interface SiteSettingsLocationBusinessInformation {
  __typename?: 'SiteSettingsLocationBusinessInformation'
  address?: Maybe<SiteSettingsLocationBusinessInformationAddress>
  description?: Maybe<ScalarsEnums['String']>
  name?: Maybe<ScalarsEnums['String']>
  phone?: Maybe<ScalarsEnums['String']>
}

export interface SiteSettingsLocationBusinessInformationAddress {
  __typename?: 'SiteSettingsLocationBusinessInformationAddress'
  city?: Maybe<ScalarsEnums['String']>
  coordinates?: Maybe<SiteSettingsLocationBusinessInformationAddressCoordinates>
  country?: Maybe<ScalarsEnums['String']>
  postalCode?: Maybe<ScalarsEnums['String']>
  state?: Maybe<ScalarsEnums['String']>
  street?: Maybe<ScalarsEnums['String']>
}

export interface SiteSettingsLocationBusinessInformationAddressCoordinates {
  __typename?: 'SiteSettingsLocationBusinessInformationAddressCoordinates'
  latitude?: Maybe<ScalarsEnums['Float']>
  longitude?: Maybe<ScalarsEnums['Float']>
}

export interface SiteSettingsLocationCheckIn {
  __typename?: 'SiteSettingsLocationCheckIn'
  barcodeCheckInScreenRefreshPeriodInSeconds: ScalarsEnums['Float']
  checkInEndTime?: Maybe<ScalarsEnums['Float']>
  checkInMarksAttendance?: Maybe<ScalarsEnums['Boolean']>
  checkInStartTime?: Maybe<ScalarsEnums['Float']>
  contactlessCheckIn: SiteSettingsLocationCheckInContactlessCheckIn
  enableCheckInPopups: ScalarsEnums['Boolean']
  enableCheckInSoundAlerts: ScalarsEnums['Boolean']
  enableCheckInWidget: ScalarsEnums['Boolean']
  enableGeneralCheckIn: ScalarsEnums['Boolean']
  enableMobileClientCheckIn: ScalarsEnums['Boolean']
  enableReEntryGracePeriod: ScalarsEnums['Boolean']
  failOpenOffline?: Maybe<ScalarsEnums['Boolean']>
  reEntryGracePeriodInSeconds?: Maybe<ScalarsEnums['Float']>
}

export interface SiteSettingsLocationCheckInContactlessCheckIn {
  __typename?: 'SiteSettingsLocationCheckInContactlessCheckIn'
  enableDoorAccess: ScalarsEnums['Boolean']
  enableForm: ScalarsEnums['Boolean']
  enableQRCodeDeeplink: ScalarsEnums['Boolean']
  enabled: ScalarsEnums['Boolean']
  formQuestions?: Maybe<Array<SiteSettingsLocationCheckInContactlessCheckInFormQuestions>>
  policies: Array<SiteSettingsLocationCheckInContactlessCheckInPolicies>
  policyIds: Array<ScalarsEnums['String']>
  skipCheckInQuestions: ScalarsEnums['Boolean']
}

export interface SiteSettingsLocationCheckInContactlessCheckInFormQuestions {
  __typename?: 'SiteSettingsLocationCheckInContactlessCheckInFormQuestions'
  allowCheckInIfBelowOrEqualTo?: Maybe<ScalarsEnums['Float']>
  favorite?: Maybe<ScalarsEnums['Boolean']>
  id: ScalarsEnums['String']
  options?: Maybe<Array<SiteSettingsLocationCheckInContactlessCheckInFormQuestionsOptions>>
  order?: Maybe<ScalarsEnums['Float']>
  question: ScalarsEnums['String']
  type: ScalarsEnums['ContactlessCheckInFormQuestionType']
}

export interface SiteSettingsLocationCheckInContactlessCheckInFormQuestionsOptions {
  __typename?: 'SiteSettingsLocationCheckInContactlessCheckInFormQuestionsOptions'
  allowCheckIn: ScalarsEnums['Boolean']
  id: ScalarsEnums['String']
  order?: Maybe<ScalarsEnums['Float']>
  text: ScalarsEnums['String']
}

export interface SiteSettingsLocationCheckInContactlessCheckInPolicies {
  __typename?: 'SiteSettingsLocationCheckInContactlessCheckInPolicies'
  enabled: ScalarsEnums['Boolean']
  order: ScalarsEnums['Float']
  sitePolicyId: ScalarsEnums['String']
}

export interface SiteSettingsLocationCommunications {
  __typename?: 'SiteSettingsLocationCommunications'
  blackoutTime?: Maybe<SiteSettingsLocationCommunicationsBlackoutTime>
  customShortCodes?: Maybe<SiteSettingsLocationCommunicationsCustomShortCodes>
  emailDefaultFrom?: Maybe<ScalarsEnums['String']>
  emailDefaultFromName?: Maybe<ScalarsEnums['String']>
  smsDefaultFromName?: Maybe<ScalarsEnums['String']>
}

export interface SiteSettingsLocationCommunicationsBlackoutTime {
  __typename?: 'SiteSettingsLocationCommunicationsBlackoutTime'
  endTime?: Maybe<ScalarsEnums['Float']>
  startTime?: Maybe<ScalarsEnums['Float']>
}

export interface SiteSettingsLocationCommunicationsCustomShortCodes {
  __typename?: 'SiteSettingsLocationCommunicationsCustomShortCodes'
  androidApp?: Maybe<ScalarsEnums['String']>
  androidAppDownload?: Maybe<ScalarsEnums['String']>
  classes?: Maybe<ScalarsEnums['String']>
  dashboard?: Maybe<ScalarsEnums['String']>
  iOSApp?: Maybe<ScalarsEnums['String']>
  iOSAppDownload?: Maybe<ScalarsEnums['String']>
  packages?: Maybe<ScalarsEnums['String']>
  workshops?: Maybe<ScalarsEnums['String']>
}

export interface SiteSettingsLocationConfigurations {
  __typename?: 'SiteSettingsLocationConfigurations'
  currency?: Maybe<ScalarsEnums['String']>
  dashboardRevenuePeriod?: Maybe<ScalarsEnums['String']>
  dateFormat?: Maybe<ScalarsEnums['String']>
  numberFormat?: Maybe<ScalarsEnums['String']>
  timeFormat?: Maybe<ScalarsEnums['String']>
  timezone?: Maybe<ScalarsEnums['String']>
}

export interface SiteSettingsLocationForms {
  __typename?: 'SiteSettingsLocationForms'
  bookingGateMode?: Maybe<ScalarsEnums['FormBookingGateMode']>
}

export interface SiteSettingsLocationMemberApp {
  __typename?: 'SiteSettingsLocationMemberApp'
  locationInformation?: Maybe<SiteSettingsLocationMemberAppLocationInformation>
  planYourVisit?: Maybe<SiteSettingsLocationMemberAppPlanYourVisit>
}

export interface SiteSettingsLocationMemberAppLocationInformation {
  __typename?: 'SiteSettingsLocationMemberAppLocationInformation'
  amenities?: Maybe<SiteSettingsLocationMemberAppLocationInformationAmenities>
  blocks?: Maybe<Array<SiteSettingsLocationMemberAppLocationInformationBlocks>>
  heading?: Maybe<ScalarsEnums['String']>
  isEnabled?: Maybe<ScalarsEnums['Boolean']>
  staffedHours?: Maybe<SiteSettingsLocationMemberAppLocationInformationStaffedHours>
}

export interface SiteSettingsLocationMemberAppLocationInformationAmenities {
  __typename?: 'SiteSettingsLocationMemberAppLocationInformationAmenities'
  isEnabled?: Maybe<ScalarsEnums['Boolean']>
  items?: Maybe<Array<SiteSettingsLocationMemberAppLocationInformationAmenitiesItems>>
  maxVisible?: Maybe<ScalarsEnums['Int']>
}

export interface SiteSettingsLocationMemberAppLocationInformationAmenitiesItems {
  __typename?: 'SiteSettingsLocationMemberAppLocationInformationAmenitiesItems'
  amenityKey?: Maybe<ScalarsEnums['SiteAmenityKey']>
  customIcon?: Maybe<ScalarsEnums['SiteInfoBlockIcon']>
  customName?: Maybe<ScalarsEnums['String']>
  id: ScalarsEnums['ID']
  isVisible: ScalarsEnums['Boolean']
  note?: Maybe<ScalarsEnums['String']>
  schedule?: Maybe<SiteSettingsLocationMemberAppLocationInformationStaffedHoursSchedule>
}

export interface SiteSettingsLocationMemberAppLocationInformationBlocks {
  __typename?: 'SiteSettingsLocationMemberAppLocationInformationBlocks'
  body: ScalarsEnums['String']
  icon?: Maybe<ScalarsEnums['SiteInfoBlockIcon']>
  id: ScalarsEnums['ID']
  isVisible: ScalarsEnums['Boolean']
  linkLabel?: Maybe<ScalarsEnums['String']>
  linkUrl?: Maybe<ScalarsEnums['String']>
  title: ScalarsEnums['String']
}

export interface SiteSettingsLocationMemberAppLocationInformationStaffedHours {
  __typename?: 'SiteSettingsLocationMemberAppLocationInformationStaffedHours'
  isEnabled?: Maybe<ScalarsEnums['Boolean']>
  label?: Maybe<ScalarsEnums['String']>
  schedule?: Maybe<SiteSettingsLocationMemberAppLocationInformationStaffedHoursSchedule>
}

export interface SiteSettingsLocationMemberAppLocationInformationStaffedHoursSchedule {
  __typename?: 'SiteSettingsLocationMemberAppLocationInformationStaffedHoursSchedule'
  exceptions: Array<SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleExceptions>
  is24x7: ScalarsEnums['Boolean']
  weekly: SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleWeekly
}

export interface SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleExceptions {
  __typename?: 'SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleExceptions'
  date: ScalarsEnums['String']
  id: ScalarsEnums['ID']
  isClosed: ScalarsEnums['Boolean']
  label: ScalarsEnums['String']
  ranges: Array<SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleWeeklyMondayRanges>
}

export interface SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleWeekly {
  __typename?: 'SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleWeekly'
  friday: SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleWeeklyMonday
  monday: SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleWeeklyMonday
  saturday: SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleWeeklyMonday
  sunday: SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleWeeklyMonday
  thursday: SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleWeeklyMonday
  tuesday: SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleWeeklyMonday
  wednesday: SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleWeeklyMonday
}

export interface SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleWeeklyMonday {
  __typename?: 'SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleWeeklyMonday'
  isClosed: ScalarsEnums['Boolean']
  ranges: Array<SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleWeeklyMondayRanges>
}

export interface SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleWeeklyMondayRanges {
  __typename?: 'SiteSettingsLocationMemberAppLocationInformationStaffedHoursScheduleWeeklyMondayRanges'
  closesAt: ScalarsEnums['String']
  opensAt: ScalarsEnums['String']
}

export interface SiteSettingsLocationMemberAppPlanYourVisit {
  __typename?: 'SiteSettingsLocationMemberAppPlanYourVisit'
  forecast?: Maybe<SiteSettingsLocationMemberAppPlanYourVisitForecast>
  isEnabled?: Maybe<ScalarsEnums['Boolean']>
  isVisibleToGuests?: Maybe<ScalarsEnums['Boolean']>
  liveOccupancy?: Maybe<SiteSettingsLocationMemberAppPlanYourVisitLiveOccupancy>
  title?: Maybe<ScalarsEnums['String']>
}

export interface SiteSettingsLocationMemberAppPlanYourVisitForecast {
  __typename?: 'SiteSettingsLocationMemberAppPlanYourVisitForecast'
  chartEndHour?: Maybe<ScalarsEnums['Int']>
  chartStartHour?: Maybe<ScalarsEnums['Int']>
  isEnabled?: Maybe<ScalarsEnums['Boolean']>
  lookbackWeeks?: Maybe<ScalarsEnums['Int']>
}

export interface SiteSettingsLocationMemberAppPlanYourVisitLiveOccupancy {
  __typename?: 'SiteSettingsLocationMemberAppPlanYourVisitLiveOccupancy'
  averageVisitMinutes?: Maybe<ScalarsEnums['Int']>
  bandSize?: Maybe<ScalarsEnums['Int']>
  displayMode?: Maybe<ScalarsEnums['OccupancyDisplayMode']>
  hideWhenClosed?: Maybe<ScalarsEnums['Boolean']>
  isEnabled?: Maybe<ScalarsEnums['Boolean']>
  privacyFloor?: Maybe<ScalarsEnums['Int']>
}

export interface SiteSettingsLocationOperations {
  __typename?: 'SiteSettingsLocationOperations'
  autoLogout?: Maybe<ScalarsEnums['Boolean']>
  autoLogoutMinutes?: Maybe<ScalarsEnums['AutoLogoutMinutes']>
  blockingReasons?: Maybe<Array<SiteSettingsLocationOperationsCancellationReasons>>
  businessSignUpFields?: Maybe<SiteSettingsLocationOperationsBusinessSignUpFields>
  cancellationReasons?: Maybe<Array<SiteSettingsLocationOperationsCancellationReasons>>
  clientSignUpFields?: Maybe<SiteSettingsLocationOperationsClientSignUpFields>
  enableBookABuddy?: Maybe<ScalarsEnums['Boolean']>
  enableBuddySessionSharingVisibility?: Maybe<ScalarsEnums['Boolean']>
  enableClientsToSignUp?: Maybe<ScalarsEnums['Boolean']>
  leadSources?: Maybe<Array<ScalarsEnums['String']>>
  preventDuplicatePhoneSignUp?: Maybe<ScalarsEnums['Boolean']>
  refundReasons?: Maybe<Array<SiteSettingsLocationOperationsRefundReasons>>
  suspensionReasons?: Maybe<Array<SiteSettingsLocationOperationsCancellationReasons>>
  systemPreferences?: Maybe<SiteSettingsLocationOperationsSystemPreferences>
}

export interface SiteSettingsLocationOperationsBusinessSignUpFields {
  __typename?: 'SiteSettingsLocationOperationsBusinessSignUpFields'
  customProperties: Array<SiteSettingsLocationOperationsBusinessSignUpFieldsCustomProperties>
  emergencyContact: SiteSettingsLocationOperationsBusinessSignUpFieldsEmergencyContact
  formIds: Array<ScalarsEnums['String']>
  primaryProfile: SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfile
}

export interface SiteSettingsLocationOperationsBusinessSignUpFieldsCustomProperties {
  __typename?: 'SiteSettingsLocationOperationsBusinessSignUpFieldsCustomProperties'
  customPropertyId: ScalarsEnums['String']
  enabled: ScalarsEnums['Boolean']
  required: ScalarsEnums['Boolean']
}

export interface SiteSettingsLocationOperationsBusinessSignUpFieldsEmergencyContact {
  __typename?: 'SiteSettingsLocationOperationsBusinessSignUpFieldsEmergencyContact'
  emergencyContactAddress?: Maybe<SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName>
  emergencyContactEmail?: Maybe<SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName>
  emergencyContactName?: Maybe<SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName>
  emergencyContactPhone?: Maybe<SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName>
  emergencyContactRelation?: Maybe<SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName>
}

export interface SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfile {
  __typename?: 'SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfile'
  address?: Maybe<SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName>
  barcode?: Maybe<SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName>
  birthday?: Maybe<SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName>
  confirmPassword?: Maybe<SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName>
  email?: Maybe<SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName>
  firstName?: Maybe<SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName>
  gender?: Maybe<SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName>
  howDidYouHeadAboutUs?: Maybe<SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName>
  lastName?: Maybe<SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName>
  occupation?: Maybe<SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName>
  password?: Maybe<SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName>
  phone?: Maybe<SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName>
  zipCode?: Maybe<SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName>
}

export interface SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName {
  __typename?: 'SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfileFirstName'
  enabled: ScalarsEnums['Boolean']
  required: ScalarsEnums['Boolean']
}

export interface SiteSettingsLocationOperationsCancellationReasons {
  __typename?: 'SiteSettingsLocationOperationsCancellationReasons'
  createdAt?: Maybe<ScalarsEnums['String']>
  enabled?: Maybe<ScalarsEnums['Boolean']>
  id?: Maybe<ScalarsEnums['String']>
  reason?: Maybe<ScalarsEnums['String']>
  updatedAt?: Maybe<ScalarsEnums['String']>
}

export interface SiteSettingsLocationOperationsClientSignUpFields {
  __typename?: 'SiteSettingsLocationOperationsClientSignUpFields'
  customProperties: Array<SiteSettingsLocationOperationsBusinessSignUpFieldsCustomProperties>
  emergencyContact: SiteSettingsLocationOperationsBusinessSignUpFieldsEmergencyContact
  formIds: Array<ScalarsEnums['String']>
  policyIds: Array<ScalarsEnums['String']>
  primaryProfile: SiteSettingsLocationOperationsBusinessSignUpFieldsPrimaryProfile
}

export interface SiteSettingsLocationOperationsRefundReasons {
  __typename?: 'SiteSettingsLocationOperationsRefundReasons'
  createdAt?: Maybe<ScalarsEnums['String']>
  enabled: ScalarsEnums['Boolean']
  id?: Maybe<ScalarsEnums['String']>
  reason: ScalarsEnums['String']
  updatedAt?: Maybe<ScalarsEnums['String']>
}

export interface SiteSettingsLocationOperationsSystemPreferences {
  __typename?: 'SiteSettingsLocationOperationsSystemPreferences'
  availableClientsTabs?: Maybe<SiteSettingsLocationOperationsSystemPreferencesAvailableClientsTabs>
  defaultAllLocationsSearch?: Maybe<ScalarsEnums['Boolean']>
  defaultBusinessProfileTab?: Maybe<ScalarsEnums['BusinessProfileTab']>
  defaultClientTab?: Maybe<ScalarsEnums['ClientProfileTab']>
  showBusinessInfo?: Maybe<ScalarsEnums['Boolean']>
  tabsDisplayed?: Maybe<SiteSettingsLocationOperationsSystemPreferencesTabsDisplayed>
}

export interface SiteSettingsLocationOperationsSystemPreferencesAvailableClientsTabs {
  __typename?: 'SiteSettingsLocationOperationsSystemPreferencesAvailableClientsTabs'
  assessment?: Maybe<ScalarsEnums['Boolean']>
  information?: Maybe<ScalarsEnums['Boolean']>
  notes?: Maybe<ScalarsEnums['Boolean']>
  payment?: Maybe<ScalarsEnums['Boolean']>
  schedule?: Maybe<ScalarsEnums['Boolean']>
}

export interface SiteSettingsLocationOperationsSystemPreferencesTabsDisplayed {
  __typename?: 'SiteSettingsLocationOperationsSystemPreferencesTabsDisplayed'
  classes?: Maybe<ScalarsEnums['Boolean']>
  packages?: Maybe<ScalarsEnums['Boolean']>
  requestBooking?: Maybe<ScalarsEnums['Boolean']>
  workshops?: Maybe<ScalarsEnums['Boolean']>
}

export interface SiteSettingsLocationSocialMedia {
  __typename?: 'SiteSettingsLocationSocialMedia'
  facebook?: Maybe<ScalarsEnums['String']>
  instagram?: Maybe<ScalarsEnums['String']>
  website?: Maybe<ScalarsEnums['String']>
  x?: Maybe<ScalarsEnums['String']>
}

export interface SiteSettingsLocationTools {
  __typename?: 'SiteSettingsLocationTools'
  barcodeCheckIn?: Maybe<SiteSettingsLocationToolsBarcodeCheckIn>
  frontDeskKiosk?: Maybe<SiteSettingsLocationToolsFrontDeskKiosk>
}

export interface SiteSettingsLocationToolsBarcodeCheckIn {
  __typename?: 'SiteSettingsLocationToolsBarcodeCheckIn'
  customUrl?: Maybe<ScalarsEnums['String']>
  isActive?: Maybe<ScalarsEnums['Boolean']>
  url?: Maybe<ScalarsEnums['String']>
}

export interface SiteSettingsLocationToolsFrontDeskKiosk {
  __typename?: 'SiteSettingsLocationToolsFrontDeskKiosk'
  betaVersionEnabled?: Maybe<ScalarsEnums['Boolean']>
  customUrl?: Maybe<ScalarsEnums['String']>
  enabledModules?: Maybe<SiteSettingsLocationToolsFrontDeskKioskEnabledModules>
  isActive?: Maybe<ScalarsEnums['Boolean']>
  url?: Maybe<ScalarsEnums['String']>
}

export interface SiteSettingsLocationToolsFrontDeskKioskEnabledModules {
  __typename?: 'SiteSettingsLocationToolsFrontDeskKioskEnabledModules'
  account?: Maybe<ScalarsEnums['Boolean']>
  checkIn?: Maybe<ScalarsEnums['Boolean']>
  classCheckIn?: Maybe<ScalarsEnums['Boolean']>
  forms?: Maybe<ScalarsEnums['Boolean']>
  introOffers?: Maybe<ScalarsEnums['Boolean']>
  packages?: Maybe<ScalarsEnums['Boolean']>
}

export interface SiteSettingsRetail {
  __typename?: 'SiteSettingsRetail'
  additionalBillingTypes: SiteSettingsRetailAdditionalBillingTypes
  fees?: Maybe<SiteSettingsRetailFees>
  general?: Maybe<SiteSettingsRetailGeneral>
  giftcards?: Maybe<SiteSettingsRetailGiftcards>
  memberships?: Maybe<SiteSettingsRetailMemberships>
  sales?: Maybe<SiteSettingsRetailSales>
  suspensions?: Maybe<SiteSettingsRetailSuspensions>
}

export interface SiteSettingsRetailAdditionalBillingTypes {
  __typename?: 'SiteSettingsRetailAdditionalBillingTypes'
  enabled: ScalarsEnums['Boolean']
  types?: Maybe<Array<SiteSettingsRetailAdditionalBillingTypesTypes>>
}

export interface SiteSettingsRetailAdditionalBillingTypesTypes {
  __typename?: 'SiteSettingsRetailAdditionalBillingTypesTypes'
  createdAt: ScalarsEnums['String']
  enabled: ScalarsEnums['Boolean']
  id: ScalarsEnums['ID']
  name: ScalarsEnums['String']
  type: ScalarsEnums['AddtionalBillingType']
  updatedAt?: Maybe<ScalarsEnums['String']>
}

export interface SiteSettingsRetailFees {
  __typename?: 'SiteSettingsRetailFees'
  customLateCancelFeesEnabled?: Maybe<ScalarsEnums['Boolean']>
  customNoShowFeesEnabled?: Maybe<ScalarsEnums['Boolean']>
  destination?: Maybe<SiteSettingsRetailFeesDestination>
  dishonor: SiteSettingsRetailFeesDishonor
  lateCancel?: Maybe<SiteSettingsRetailFeesNoShow>
  noShow?: Maybe<SiteSettingsRetailFeesNoShow>
}

export interface SiteSettingsRetailFeesDestination {
  __typename?: 'SiteSettingsRetailFeesDestination'
  enabled: ScalarsEnums['Boolean']
  price?: Maybe<ScalarsEnums['String']>
  revenueTagId?: Maybe<ScalarsEnums['ID']>
  taxSettings?: Maybe<Array<ScalarsEnums['String']>>
}

export interface SiteSettingsRetailFeesDishonor {
  __typename?: 'SiteSettingsRetailFeesDishonor'
  enabled: ScalarsEnums['Boolean']
  onAllAttempts?: Maybe<ScalarsEnums['String']>
  onDelinquentDays?: Maybe<SiteSettingsRetailFeesDishonorOnDelinquentDays>
  onFirstAttempt?: Maybe<ScalarsEnums['String']>
  onSecondAttempt?: Maybe<ScalarsEnums['String']>
  onThirdAttempt?: Maybe<ScalarsEnums['String']>
  taxSettings?: Maybe<Array<ScalarsEnums['String']>>
}

export interface SiteSettingsRetailFeesDishonorOnDelinquentDays {
  __typename?: 'SiteSettingsRetailFeesDishonorOnDelinquentDays'
  amount: ScalarsEnums['String']
  days: ScalarsEnums['Float']
}

export interface SiteSettingsRetailFeesNoShow {
  __typename?: 'SiteSettingsRetailFeesNoShow'
  automatic?: Maybe<SiteSettingsRetailFeesNoShowAutomatic>
  creditRefund?: Maybe<ScalarsEnums['Boolean']>
  enabled: ScalarsEnums['Boolean']
  price?: Maybe<ScalarsEnums['String']>
  revenueTagId?: Maybe<ScalarsEnums['String']>
  taxSettings?: Maybe<Array<ScalarsEnums['String']>>
  unlimitedCreditsOnly?: Maybe<ScalarsEnums['Boolean']>
}

export interface SiteSettingsRetailFeesNoShowAutomatic {
  __typename?: 'SiteSettingsRetailFeesNoShowAutomatic'
  enabled: ScalarsEnums['Boolean']
}

export interface SiteSettingsRetailGeneral {
  __typename?: 'SiteSettingsRetailGeneral'
  credits?: Maybe<SiteSettingsRetailGeneralCredits>
  sales?: Maybe<SiteSettingsRetailGeneralSales>
}

export interface SiteSettingsRetailGeneralCredits {
  __typename?: 'SiteSettingsRetailGeneralCredits'
  enableCreditsOnHoldIfClientHadFailedPayment: ScalarsEnums['Boolean']
  enableCreditsOnHoldIfClientHadTerminalFailedPayment?: Maybe<ScalarsEnums['Boolean']>
  enableCreditsOnHoldIfClientHasProcessingPayment: ScalarsEnums['Boolean']
  referrals: SiteSettingsRetailGeneralCreditsReferrals
}

export interface SiteSettingsRetailGeneralCreditsReferrals {
  __typename?: 'SiteSettingsRetailGeneralCreditsReferrals'
  creditsExistingClient: ScalarsEnums['Float']
  creditsToNewClient: ScalarsEnums['Float']
  existingClientEnabled?: Maybe<ScalarsEnums['Boolean']>
  newClientEnabled?: Maybe<ScalarsEnums['Boolean']>
}

export interface SiteSettingsRetailGeneralSales {
  __typename?: 'SiteSettingsRetailGeneralSales'
  additionalSortOfPackages?: Maybe<SiteSettingsRetailGeneralSalesAdditionalSortOfPackages>
  allowChangeOfProcessedByAtSale: ScalarsEnums['Boolean']
  allowMembershipSalesWithDuplicateCreditOrSessionTypes: ScalarsEnums['Boolean']
  allowSessionPackageSalesWithDuplicateCreditOrSessionTypes: ScalarsEnums['Boolean']
  autoAssignClientBarcodeNumber: ScalarsEnums['Boolean']
  autoRenewExhaustedSessionPackages: ScalarsEnums['Boolean']
  defaultAutoRenewToggleEnabledAtSale: ScalarsEnums['Boolean']
  enableAllMembershipsSoldOnlineToBeCancelledByMember: ScalarsEnums['Boolean']
  enableRestrictedPackages: ScalarsEnums['Boolean']
  redirectAfterPackagePayment: ScalarsEnums['RedirectAfterPackagePayment']
  revenueTagDefaults: ScalarsEnums['JSONObject']
  revenueTagging: Array<SiteSettingsRetailGeneralSalesRevenueTagging>
}

export interface SiteSettingsRetailGeneralSalesAdditionalSortOfPackages {
  __typename?: 'SiteSettingsRetailGeneralSalesAdditionalSortOfPackages'
  direction: ScalarsEnums['SortPackageDirection']
  field: ScalarsEnums['SortPackageField']
}

export interface SiteSettingsRetailGeneralSalesRevenueTagging {
  __typename?: 'SiteSettingsRetailGeneralSalesRevenueTagging'
  createdAt: ScalarsEnums['String']
  description: ScalarsEnums['String']
  enabled: ScalarsEnums['Boolean']
  glCode: ScalarsEnums['String']
  id: ScalarsEnums['ID']
  mapping?: Maybe<ScalarsEnums['RevenueTagMapping']>
  name: ScalarsEnums['String']
  updatedAt?: Maybe<ScalarsEnums['String']>
}

export interface SiteSettingsRetailGiftcards {
  __typename?: 'SiteSettingsRetailGiftcards'
  enableSharedSites?: Maybe<ScalarsEnums['Boolean']>
}

export interface SiteSettingsRetailMemberships {
  __typename?: 'SiteSettingsRetailMemberships'
  restrictPlanChangesToCategory?: Maybe<ScalarsEnums['Boolean']>
}

export interface SiteSettingsRetailSales {
  __typename?: 'SiteSettingsRetailSales'
  miniumSignUpAge?: Maybe<ScalarsEnums['Float']>
  printPosReceipt?: Maybe<ScalarsEnums['Float']>
  requireRecipientForGiftCardSales?: Maybe<ScalarsEnums['Boolean']>
}

export interface SiteSettingsRetailSuspensions {
  __typename?: 'SiteSettingsRetailSuspensions'
  secondaryFeesContinueDuringSuspension?: Maybe<ScalarsEnums['Boolean']>
  selfServicePause?: Maybe<SiteSettingsRetailSuspensionsSelfServicePause>
}

export interface SiteSettingsRetailSuspensionsSelfServicePause {
  __typename?: 'SiteSettingsRetailSuspensionsSelfServicePause'
  alignToBillingCycle?: Maybe<ScalarsEnums['Boolean']>
  enabled: ScalarsEnums['Boolean']
  maxPerCalendarYear?: Maybe<SiteSettingsRetailSuspensionsSelfServicePauseMaxPerCalendarYear>
  noticePeriodDays?: Maybe<ScalarsEnums['Float']>
  reasonIds?: Maybe<Array<ScalarsEnums['String']>>
  reasonMandatory?: Maybe<ScalarsEnums['Boolean']>
}

export interface SiteSettingsRetailSuspensionsSelfServicePauseMaxPerCalendarYear {
  __typename?: 'SiteSettingsRetailSuspensionsSelfServicePauseMaxPerCalendarYear'
  amount: ScalarsEnums['Float']
  unit: ScalarsEnums['SelfServicePauseDurationUnit']
}

export interface SiteSettingsScheduler {
  __typename?: 'SiteSettingsScheduler'
  calendar?: Maybe<SiteSettingsSchedulerCalendar>
  calendarConfigurations?: Maybe<SiteSettingsSchedulerCalendarConfigurations>
  daysInAdvance?: Maybe<SiteSettingsSchedulerDaysInAdvance>
  rules?: Maybe<SiteSettingsSchedulerRules>
  sessionTypes?: Maybe<Array<SiteSettingsSchedulerSessionTypes>>
}

export interface SiteSettingsSchedulerCalendar {
  __typename?: 'SiteSettingsSchedulerCalendar'
  defaultView?: Maybe<ScalarsEnums['ScheduleDefaultView']>
  showCapacity?: Maybe<ScalarsEnums['Boolean']>
  showInstructorNames?: Maybe<ScalarsEnums['Boolean']>
}

export interface SiteSettingsSchedulerCalendarConfigurations {
  __typename?: 'SiteSettingsSchedulerCalendarConfigurations'
  calendarInterval?: Maybe<ScalarsEnums['Float']>
  calendarMaxTime?: Maybe<ScalarsEnums['String']>
  calendarMinTime?: Maybe<ScalarsEnums['String']>
  calendarStartDay?: Maybe<ScalarsEnums['String']>
  defaultBookedListOrder?: Maybe<ScalarsEnums['String']>
  defaultCalendarView?: Maybe<ScalarsEnums['String']>
  enableContinuousEvents?: Maybe<ScalarsEnums['Boolean']>
  enableDragAndDrop?: Maybe<ScalarsEnums['Boolean']>
  hideRoomFromRoomView?: Maybe<ScalarsEnums['Boolean']>
  hideTeamMemberFromTeamView?: Maybe<ScalarsEnums['Boolean']>
}

export interface SiteSettingsSchedulerDaysInAdvance {
  __typename?: 'SiteSettingsSchedulerDaysInAdvance'
  appointments: ScalarsEnums['Float']
  classes: ScalarsEnums['Float']
  workshops: ScalarsEnums['Float']
}

export interface SiteSettingsSchedulerRules {
  __typename?: 'SiteSettingsSchedulerRules'
  bookings?: Maybe<SiteSettingsSchedulerRulesBookings>
  cancellations?: Maybe<SiteSettingsSchedulerRulesCancellations>
  classes?: Maybe<SiteSettingsSchedulerRulesClasses>
  privates?: Maybe<SiteSettingsSchedulerRulesPrivates>
  reservations?: Maybe<SiteSettingsSchedulerRulesReservations>
  sessionFeedback?: Maybe<SiteSettingsSchedulerRulesSessionFeedback>
  waitlist?: Maybe<SiteSettingsSchedulerRulesWaitlist>
  workshops?: Maybe<SiteSettingsSchedulerRulesWorkshops>
}

export interface SiteSettingsSchedulerRulesBookings {
  __typename?: 'SiteSettingsSchedulerRulesBookings'
  allowMemberOverlappingSessions?: Maybe<ScalarsEnums['Boolean']>
  allowStaffOverbooking?: Maybe<ScalarsEnums['Boolean']>
  autoConfirmRequests?: Maybe<ScalarsEnums['Boolean']>
  autoDeductCredits?: Maybe<ScalarsEnums['Boolean']>
  bookingNotifications?: Maybe<ScalarsEnums['Boolean']>
  enableBookABuddy?: Maybe<ScalarsEnums['Boolean']>
  enableBookingRequests?: Maybe<ScalarsEnums['Boolean']>
  enforceFixedBookingSlotIntervals?: Maybe<SiteSettingsSchedulerRulesBookingsEnforceFixedBookingSlotIntervals>
  enforceFixedBookingSlotIntervalsDuration?: Maybe<ScalarsEnums['SchedulerTimeSlotDuration']>
  requestTimeSlots?: Maybe<SiteSettingsSchedulerRulesBookingsRequestTimeSlots>
  requestTimeSlotsDuration?: Maybe<ScalarsEnums['SchedulerTimeSlotDuration']>
}

export interface SiteSettingsSchedulerRulesBookingsEnforceFixedBookingSlotIntervals {
  __typename?: 'SiteSettingsSchedulerRulesBookingsEnforceFixedBookingSlotIntervals'
  duration?: Maybe<ScalarsEnums['Float']>
}

export interface SiteSettingsSchedulerRulesBookingsRequestTimeSlots {
  __typename?: 'SiteSettingsSchedulerRulesBookingsRequestTimeSlots'
  duration?: Maybe<ScalarsEnums['Float']>
}

export interface SiteSettingsSchedulerRulesCancellations {
  __typename?: 'SiteSettingsSchedulerRulesCancellations'
  allowClientDeclineAndCancelSessions?: Maybe<ScalarsEnums['Boolean']>
  allowClientsToDeclineAndCancel?: Maybe<ScalarsEnums['Boolean']>
  policies?: Maybe<SiteSettingsSchedulerRulesCancellationsPolicies>
}

export interface SiteSettingsSchedulerRulesCancellationsPolicies {
  __typename?: 'SiteSettingsSchedulerRulesCancellationsPolicies'
  classes?: Maybe<SiteSettingsSchedulerRulesCancellationsPoliciesClasses>
  privates?: Maybe<SiteSettingsSchedulerRulesCancellationsPoliciesClasses>
  workshops?: Maybe<SiteSettingsSchedulerRulesCancellationsPoliciesClasses>
}

export interface SiteSettingsSchedulerRulesCancellationsPoliciesClasses {
  __typename?: 'SiteSettingsSchedulerRulesCancellationsPoliciesClasses'
  days: ScalarsEnums['Float']
  hours: ScalarsEnums['Float']
  minutes: ScalarsEnums['Float']
}

export interface SiteSettingsSchedulerRulesClasses {
  __typename?: 'SiteSettingsSchedulerRulesClasses'
  daysInAdvance?: Maybe<ScalarsEnums['Float']>
  defaultColor?: Maybe<ScalarsEnums['String']>
  displayClassSize?: Maybe<ScalarsEnums['Boolean']>
  displayCompletedClasses?: Maybe<ScalarsEnums['Boolean']>
  displayPriceColumn?: Maybe<ScalarsEnums['Boolean']>
  instructorTypeFilter?: Maybe<ScalarsEnums['Boolean']>
  roomTypeFilter?: Maybe<ScalarsEnums['Boolean']>
  sessionTypeFilter?: Maybe<ScalarsEnums['Boolean']>
  soapNotes?: Maybe<ScalarsEnums['Boolean']>
}

export interface SiteSettingsSchedulerRulesPrivates {
  __typename?: 'SiteSettingsSchedulerRulesPrivates'
  daysInAdvance?: Maybe<ScalarsEnums['Float']>
}

export interface SiteSettingsSchedulerRulesReservations {
  __typename?: 'SiteSettingsSchedulerRulesReservations'
  daysInAdvance?: Maybe<SiteSettingsSchedulerRulesReservationsDaysInAdvance>
  multipleReservations?: Maybe<ScalarsEnums['Boolean']>
  overrides?: Maybe<SiteSettingsSchedulerRulesReservationsOverrides>
}

export interface SiteSettingsSchedulerRulesReservationsDaysInAdvance {
  __typename?: 'SiteSettingsSchedulerRulesReservationsDaysInAdvance'
  releaseType?: Maybe<ScalarsEnums['ReleaseType']>
  rolling?: Maybe<SiteSettingsSchedulerRulesReservationsDaysInAdvanceRolling>
  timed?: Maybe<SiteSettingsSchedulerRulesReservationsDaysInAdvanceTimed>
}

export interface SiteSettingsSchedulerRulesReservationsDaysInAdvanceRolling {
  __typename?: 'SiteSettingsSchedulerRulesReservationsDaysInAdvanceRolling'
  classesBookedUpTo?: Maybe<ScalarsEnums['Float']>
  periodOfTime?: Maybe<ScalarsEnums['PeriodOfTime']>
  time?: Maybe<ScalarsEnums['String']>
  upTo?: Maybe<ScalarsEnums['Float']>
}

export interface SiteSettingsSchedulerRulesReservationsDaysInAdvanceTimed {
  __typename?: 'SiteSettingsSchedulerRulesReservationsDaysInAdvanceTimed'
  dayOfWeek?: Maybe<ScalarsEnums['DayOfWeek']>
  hoursAfter?: Maybe<ScalarsEnums['Float']>
  numberOfWeeks?: Maybe<ScalarsEnums['Float']>
  time?: Maybe<ScalarsEnums['String']>
}

export interface SiteSettingsSchedulerRulesReservationsOverrides {
  __typename?: 'SiteSettingsSchedulerRulesReservationsOverrides'
  byCategory?: Maybe<ScalarsEnums['JSONObject']>
  bySessionType?: Maybe<ScalarsEnums['JSONObject']>
}

export interface SiteSettingsSchedulerRulesSessionFeedback {
  __typename?: 'SiteSettingsSchedulerRulesSessionFeedback'
  sendRequestEmails?: Maybe<ScalarsEnums['Boolean']>
}

export interface SiteSettingsSchedulerRulesWaitlist {
  __typename?: 'SiteSettingsSchedulerRulesWaitlist'
  autoConfirmClients?: Maybe<ScalarsEnums['Boolean']>
  firstToClaim?: Maybe<SiteSettingsSchedulerRulesWaitlistFirstToClaim>
  lockPeriod?: Maybe<SiteSettingsSchedulerRulesWaitlistLockPeriod>
  manualMovements?: Maybe<ScalarsEnums['Boolean']>
  promotion?: Maybe<SiteSettingsSchedulerRulesWaitlistPromotion>
  restrictions?: Maybe<SiteSettingsSchedulerRulesWaitlistRestrictions>
  strategy?: Maybe<ScalarsEnums['WaitlistStrategy']>
  topNBatchSize?: Maybe<ScalarsEnums['Float']>
}

export interface SiteSettingsSchedulerRulesWaitlistFirstToClaim {
  __typename?: 'SiteSettingsSchedulerRulesWaitlistFirstToClaim'
  enabled: ScalarsEnums['Boolean']
  windowHours: ScalarsEnums['Float']
}

export interface SiteSettingsSchedulerRulesWaitlistLockPeriod {
  __typename?: 'SiteSettingsSchedulerRulesWaitlistLockPeriod'
  periodOfTime?: Maybe<ScalarsEnums['PeriodOfTime']>
  value?: Maybe<ScalarsEnums['Float']>
}

export interface SiteSettingsSchedulerRulesWaitlistPromotion {
  __typename?: 'SiteSettingsSchedulerRulesWaitlistPromotion'
  confirmationWindow?: Maybe<SiteSettingsSchedulerRulesWaitlistPromotionConfirmationWindow>
  method?: Maybe<ScalarsEnums['WaitlistPromotionMethod']>
  periodOfTime?: Maybe<ScalarsEnums['PeriodOfTime']>
  value?: Maybe<ScalarsEnums['Float']>
}

export interface SiteSettingsSchedulerRulesWaitlistPromotionConfirmationWindow {
  __typename?: 'SiteSettingsSchedulerRulesWaitlistPromotionConfirmationWindow'
  periodOfTime?: Maybe<ScalarsEnums['PeriodOfTime']>
  value?: Maybe<ScalarsEnums['Float']>
}

export interface SiteSettingsSchedulerRulesWaitlistRestrictions {
  __typename?: 'SiteSettingsSchedulerRulesWaitlistRestrictions'
  type?: Maybe<ScalarsEnums['WaitlistRestrictionType']>
}

export interface SiteSettingsSchedulerRulesWorkshops {
  __typename?: 'SiteSettingsSchedulerRulesWorkshops'
  daysInAdvance?: Maybe<ScalarsEnums['Float']>
}

export interface SiteSettingsSchedulerSessionTypes {
  __typename?: 'SiteSettingsSchedulerSessionTypes'
  color?: Maybe<ScalarsEnums['String']>
  description?: Maybe<ScalarsEnums['String']>
  duration?: Maybe<ScalarsEnums['Float']>
  id: ScalarsEnums['String']
  name: ScalarsEnums['String']
  settings?: Maybe<ScalarsEnums['String']>
  type?: Maybe<ScalarsEnums['String']>
}

/**
 * Response from initiating a setup intent for site payment method
 */
export interface SiteSetupIntentResponse {
  __typename?: 'SiteSetupIntentResponse'
  publishableKey: ScalarsEnums['String']
  setupIntentClientSecret: ScalarsEnums['String']
  setupIntentId: ScalarsEnums['String']
}

/**
 * Saved terminal hand-off settings for a location, or the defaults when none are saved
 */
export interface SiteTerminalHandoffSettingsView {
  __typename?: 'SiteTerminalHandoffSettingsView'
  agreementConsentTexts: Array<SiteTerminalHandoffSettingsViewAgreementConsentTexts>
  consentText: ScalarsEnums['String']
  eligibleFields: Array<ScalarsEnums['TerminalHandoffField']>
  emailConsentToggle: SiteTerminalHandoffSettingsViewEmailConsentToggle
  fallback: ScalarsEnums['TerminalSignatureFallback']
  fieldCaptureEnabled: ScalarsEnums['Boolean']
  isSaved: ScalarsEnums['Boolean']
  signAllLocations: ScalarsEnums['Boolean']
  signatureDevice: ScalarsEnums['TerminalSignatureDevice']
  smsConsentToggle: SiteTerminalHandoffSettingsViewEmailConsentToggle
}

export interface SiteTerminalHandoffSettingsViewAgreementConsentTexts {
  __typename?: 'SiteTerminalHandoffSettingsViewAgreementConsentTexts'
  siteAgreementTemplateId: ScalarsEnums['ID']
  text: ScalarsEnums['String']
}

export interface SiteTerminalHandoffSettingsViewEmailConsentToggle {
  __typename?: 'SiteTerminalHandoffSettingsViewEmailConsentToggle'
  enabled: ScalarsEnums['Boolean']
  title: ScalarsEnums['String']
}

/**
 * A physical terminal reader device for processing in-person payments
 */
export interface SiteTerminalReader {
  __typename?: 'SiteTerminalReader'
  createdAt: ScalarsEnums['String']
  deletedAt?: Maybe<ScalarsEnums['String']>
  gatewayId: ScalarsEnums['String']
  isActive: ScalarsEnums['Boolean']
  name: ScalarsEnums['String']
  provider: ScalarsEnums['GatewayType']
  registrationCode: ScalarsEnums['String']
  siteId: ScalarsEnums['ID']
  siteTerminalReaderId: ScalarsEnums['ID']
  updatedAt: ScalarsEnums['String']
}

/**
 * Paginated result for terminal readers
 */
export interface SiteTerminalReaderPaginationResult {
  __typename?: 'SiteTerminalReaderPaginationResult'
  pageInfo: SiteTerminalReaderPaginationResultPageInfo
  results: Array<SiteTerminalReaderPaginationResultResults>
}

export interface SiteTerminalReaderPaginationResultPageInfo {
  __typename?: 'SiteTerminalReaderPaginationResultPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Float']
}

export interface SiteTerminalReaderPaginationResultResults {
  __typename?: 'SiteTerminalReaderPaginationResultResults'
  cursor: ScalarsEnums['String']
  row: SiteTerminalReader
}

/**
 * Site address fields still needed before the first terminal reader can be registered
 */
export interface SiteTerminalReaderRegistrationReadiness {
  __typename?: 'SiteTerminalReaderRegistrationReadiness'
  missingAddressFields: Array<ScalarsEnums['TerminalLocationAddressField']>
}

/**
 * Per-site enablement of one brand add-on subscription
 */
export interface SiteThemeStatusRow {
  __typename?: 'SiteThemeStatusRow'
  active: ScalarsEnums['Boolean']
  brandActive: ScalarsEnums['Boolean']
  siteEnabled: ScalarsEnums['Boolean']
  slug: ScalarsEnums['String']
  status?: Maybe<ScalarsEnums['SiteThemeStatus']>
  themeName: ScalarsEnums['String']
}

/**
 * Per-site enablement of a theme within a corporate subscription
 */
export interface SiteThemeSubscription {
  __typename?: 'SiteThemeSubscription'
  corporateId: ScalarsEnums['ID']
  corporateThemeSubscriptionId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  disabledAt?: Maybe<ScalarsEnums['String']>
  enabledAt: ScalarsEnums['String']
  enabledBy: ScalarsEnums['ID']
  siteId: ScalarsEnums['ID']
  siteThemeSubscriptionId: ScalarsEnums['ID']
  status: ScalarsEnums['SiteThemeStatus']
  themeId: ScalarsEnums['ID']
  updatedAt: ScalarsEnums['String']
}

/**
 * dayOfWeek 0 is Monday. estimate is staff-only and never sent to members.
 */
export interface SiteVisitForecastBucket {
  __typename?: 'SiteVisitForecastBucket'
  dayOfWeek: ScalarsEnums['Int']
  estimate: ScalarsEnums['Float']
  hour: ScalarsEnums['Int']
  level: ScalarsEnums['Int']
}

/**
 * Staff-only view of the stored forecast, including absolute estimates
 */
export interface SiteVisitForecastInsights {
  __typename?: 'SiteVisitForecastInsights'
  buckets: Array<SiteVisitForecastBucket>
  computedAt?: Maybe<ScalarsEnums['String']>
  hasSufficientData: ScalarsEnums['Boolean']
  peakEstimate: ScalarsEnums['Float']
  sampleDays: ScalarsEnums['Int']
  skippedImportedVisits: ScalarsEnums['Int']
}

/**
 * Site-level webhook configuration for receiving location-specific events
 */
export interface SiteWebhook {
  __typename?: 'SiteWebhook'
  consecutiveFailures: ScalarsEnums['Float']
  createdAt: ScalarsEnums['String']
  createdBy?: Maybe<ScalarsEnums['String']>
  events: Array<ScalarsEnums['String']>
  headerKey?: Maybe<ScalarsEnums['String']>
  headerValue?: Maybe<ScalarsEnums['String']>
  lastDeliveryAt?: Maybe<ScalarsEnums['String']>
  lastSuccessAt?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  secretHash: ScalarsEnums['String']
  siteWebhookId: ScalarsEnums['String']
  status: ScalarsEnums['SiteWebhookStatus']
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['String']>
  url: ScalarsEnums['String']
  v1EncryptedId: ScalarsEnums['String']
}

/**
 * Webhook delivery history record
 */
export interface SiteWebhookDelivery {
  __typename?: 'SiteWebhookDelivery'
  attemptNumber: ScalarsEnums['Float']
  createdAt: ScalarsEnums['String']
  deliveryId: ScalarsEnums['String']
  errorMessage?: Maybe<ScalarsEnums['String']>
  eventId: ScalarsEnums['String']
  eventType: ScalarsEnums['String']
  latencyMs?: Maybe<ScalarsEnums['Float']>
  responseBody?: Maybe<ScalarsEnums['String']>
  responseCode?: Maybe<ScalarsEnums['Float']>
  siteWebhookId: ScalarsEnums['String']
  status: ScalarsEnums['SiteWebhookDeliveryStatus']
  url: ScalarsEnums['String']
  v1EncryptedId: ScalarsEnums['String']
}

/**
 * Result of sending a test webhook event
 */
export interface SiteWebhookTestResult {
  __typename?: 'SiteWebhookTestResult'
  deliveryId: ScalarsEnums['String']
  error?: Maybe<ScalarsEnums['String']>
  eventType: ScalarsEnums['String']
  latencyMs: ScalarsEnums['Float']
  responseBody?: Maybe<ScalarsEnums['String']>
  responseCode?: Maybe<ScalarsEnums['Float']>
  success: ScalarsEnums['Boolean']
}

/**
 * Upcoming workshop occurrence used to populate the Website Widgets dropdown
 */
export interface SiteWorkshop {
  __typename?: 'SiteWorkshop'
  date: ScalarsEnums['String']
  name: ScalarsEnums['String']
  sessionId: ScalarsEnums['String']
  startTime: ScalarsEnums['String']
}

export interface Sites {
  __typename?: 'Sites'
  pageInfo: SitesPageInfo
  results: Array<SitesResults>
}

export interface SitesPageInfo {
  __typename?: 'SitesPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

/**
 * Every location of a brand, and which of them may override the brand plan
 */
export interface SitesPlanOverrideSelection {
  __typename?: 'SitesPlanOverrideSelection'
  allowedSiteIds: Array<ScalarsEnums['ID']>
  totalSiteCount: ScalarsEnums['Float']
}

export interface SitesResults {
  __typename?: 'SitesResults'
  cursor: ScalarsEnums['String']
  row: Site
}

export interface SkipAllErrors {
  __typename?: 'SkipAllErrors'
  results: Array<SkipAllErrorsResults>
  totalSkippedCount: ScalarsEnums['Float']
}

export interface SkipAllErrorsResults {
  __typename?: 'SkipAllErrorsResults'
  error?: Maybe<ScalarsEnums['String']>
  importSessionId: ScalarsEnums['ID']
  skippedCount: ScalarsEnums['Float']
}

export interface SkipImportRows {
  __typename?: 'SkipImportRows'
  skippedCount: ScalarsEnums['Float']
  summary: SkipImportRowsSummary
  updatedRowIndexes: Array<ScalarsEnums['Float']>
}

export interface SkipImportRowsSummary {
  __typename?: 'SkipImportRowsSummary'
  invalid: ScalarsEnums['Float']
  pending: ScalarsEnums['Float']
  skipped: ScalarsEnums['Float']
  total: ScalarsEnums['Float']
  totalErrorCount: ScalarsEnums['Float']
  valid: ScalarsEnums['Float']
  warning: ScalarsEnums['Float']
}

/**
 * Current SMS credits balance for a site with included/purchased breakdown
 */
export interface SmsCreditsBalance {
  __typename?: 'SmsCreditsBalance'
  asOf: ScalarsEnums['String']
  balance: ScalarsEnums['Float']
  includedBalance: ScalarsEnums['Float']
  includedUsed: ScalarsEnums['Float']
  purchasedBalance: ScalarsEnums['Float']
  purchasedUsed: ScalarsEnums['Float']
  siteId: ScalarsEnums['String']
}

export interface SmsCreditsHistory {
  __typename?: 'SmsCreditsHistory'
  pageInfo: SmsCreditsHistoryPageInfo
  results: Array<SmsCreditsHistoryResults>
}

export interface SmsCreditsHistoryPageInfo {
  __typename?: 'SmsCreditsHistoryPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface SmsCreditsHistoryResults {
  __typename?: 'SmsCreditsHistoryResults'
  cursor: ScalarsEnums['String']
  row: SmsCreditsLedgerEntry
}

/**
 * A single entry in the SMS credits ledger
 */
export interface SmsCreditsLedgerEntry {
  __typename?: 'SmsCreditsLedgerEntry'
  allocationRef?: Maybe<ScalarsEnums['ID']>
  amount: ScalarsEnums['Float']
  createdAt: ScalarsEnums['String']
  direction: ScalarsEnums['SmsCreditsDirection']
  expirationDate?: Maybe<ScalarsEnums['String']>
  ledgerId: ScalarsEnums['ID']
  metadata?: Maybe<ScalarsEnums['JSONObject']>
  reason: ScalarsEnums['SmsCreditsReason']
  siteId: ScalarsEnums['String']
}

export interface SmsPackage {
  __typename?: 'SmsPackage'
  /**
   * Country name for display
   */
  country?: Maybe<ScalarsEnums['String']>
  countryId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  currency: ScalarsEnums['SmsAllowedCurrencies']
  /**
   * Soft delete timestamp
   */
  deletedAt?: Maybe<ScalarsEnums['String']>
  options: Array<SmsPackageOptions>
  smsPackageId: ScalarsEnums['ID']
  updatedAt: ScalarsEnums['String']
}

export interface SmsPackageOptions {
  __typename?: 'SmsPackageOptions'
  /**
   * Number of SMS credits in this package
   */
  count: ScalarsEnums['Float']
  createdAt: ScalarsEnums['String']
  /**
   * Soft delete timestamp
   */
  deletedAt?: Maybe<ScalarsEnums['String']>
  optionId: ScalarsEnums['ID']
  /**
   * Price for this SMS package option
   */
  price: ScalarsEnums['Float']
  smsPackageId: ScalarsEnums['ID']
  updatedAt: ScalarsEnums['String']
}

export interface SmsPackages {
  __typename?: 'SmsPackages'
  pageInfo: SmsPackagesPageInfo
  results: Array<SmsPackagesResults>
}

export interface SmsPackagesPageInfo {
  __typename?: 'SmsPackagesPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface SmsPackagesResults {
  __typename?: 'SmsPackagesResults'
  cursor: ScalarsEnums['String']
  row: SmsPackage
}

/**
 * A SOAP session note
 */
export interface SoapNote {
  __typename?: 'SoapNote'
  clientId: ScalarsEnums['String']
  content: SoapNoteContent
  createdAt: ScalarsEnums['String']
  createdByName: ScalarsEnums['String']
  modifiedAt?: Maybe<ScalarsEnums['String']>
  modifiedBy?: Maybe<ScalarsEnums['String']>
  modifiedByName?: Maybe<ScalarsEnums['String']>
  sessionId: ScalarsEnums['String']
  siteId: ScalarsEnums['String']
  soapNoteId: ScalarsEnums['String']
  staffUserId: ScalarsEnums['String']
}

export interface SoapNoteContent {
  __typename?: 'SoapNoteContent'
  assessment?: Maybe<ScalarsEnums['String']>
  objective?: Maybe<ScalarsEnums['String']>
  plan?: Maybe<ScalarsEnums['String']>
  sessionDate: ScalarsEnums['String']
  sessionTitle: ScalarsEnums['String']
  subjective?: Maybe<ScalarsEnums['String']>
  trainerName: ScalarsEnums['String']
}

/**
 * Response containing SOAP notes
 */
export interface SoapNotesResponse {
  __typename?: 'SoapNotesResponse'
  notes: Array<SoapNote>
}

/**
 * A booking whose spot label changed, or that was left without a spot, because its session changed room
 */
export interface SpotMove {
  __typename?: 'SpotMove'
  bookingId: ScalarsEnums['String']
  clientId: ScalarsEnums['String']
  clientName?: Maybe<ScalarsEnums['String']>
  nextSpotLabel?: Maybe<ScalarsEnums['String']>
  previousSpotLabel?: Maybe<ScalarsEnums['String']>
  sessionId: ScalarsEnums['String']
  sessionName: ScalarsEnums['String']
  sessionStartTime: ScalarsEnums['String']
}

export interface StaffAccessPolicies {
  __typename?: 'StaffAccessPolicies'
  pageInfo: StaffAccessPoliciesPageInfo
  results: Array<StaffAccessPoliciesResults>
}

export interface StaffAccessPoliciesPageInfo {
  __typename?: 'StaffAccessPoliciesPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface StaffAccessPoliciesResults {
  __typename?: 'StaffAccessPoliciesResults'
  cursor: ScalarsEnums['String']
  row: StaffAccessPolicy
}

/**
 * Access policy defining permissions for staff users
 */
export interface StaffAccessPolicy {
  __typename?: 'StaffAccessPolicy'
  accessPermissions?: Maybe<Array<ScalarsEnums['AccessPermissions']>>
  allowedNetworkIds?: Maybe<Array<ScalarsEnums['ID']>>
  corporatePermissions?: Maybe<Array<ScalarsEnums['CorporatePermissions']>>
  createdAt: ScalarsEnums['String']
  name: ScalarsEnums['String']
  sitePermissions?: Maybe<Array<ScalarsEnums['SitePermissions']>>
  staffAccessPolicyId: ScalarsEnums['ID']
  updatedAt: ScalarsEnums['String']
  usersCount?: Maybe<ScalarsEnums['Int']>
}

/**
 * Where the caller can assign a staff access policy, and what is missing where they cannot
 */
export interface StaffAccessPolicyAssignability {
  __typename?: 'StaffAccessPolicyAssignability'
  siteGroups: Array<SiteGroupAssignability>
  siteGroupsBlockedReason?: Maybe<ScalarsEnums['AssignabilityBlockedReason']>
  sites: Array<SiteAssignability>
  staffAccessPolicyId: ScalarsEnums['ID']
}

/**
 * How many of the locations and location groups the caller can reach accept a staff access policy
 */
export interface StaffAccessPolicyAssignabilitySummary {
  __typename?: 'StaffAccessPolicyAssignabilitySummary'
  assignableSiteCount: ScalarsEnums['Int']
  assignableSiteGroupCount: ScalarsEnums['Int']
  fewestMissingCount: ScalarsEnums['Int']
  name: ScalarsEnums['String']
  staffAccessPolicyId: ScalarsEnums['ID']
  totalSiteCount: ScalarsEnums['Int']
  totalSiteGroupCount: ScalarsEnums['Int']
}

/**
 * Links a staff user to an access policy with site assignments
 */
export interface StaffAccessRule {
  __typename?: 'StaffAccessRule'
  assignmentType: ScalarsEnums['StaffAccessRuleAssignmentType']
  corporateId?: Maybe<ScalarsEnums['ID']>
  createdAt: ScalarsEnums['String']
  /**
   * The access policy associated with this rule
   */
  policy: StaffAccessRulePolicy
  siteGroupIds?: Maybe<Array<ScalarsEnums['ID']>>
  /**
   * The site groups associated with this rule
   */
  siteGroups: Array<SiteGroup>
  siteIds?: Maybe<Array<ScalarsEnums['ID']>>
  /**
   * The sites directly assigned to this rule
   */
  sites: Array<StaffAccessRuleSites>
  staffAccessPolicyId: ScalarsEnums['ID']
  staffAccessRuleId: ScalarsEnums['ID']
  staffUserId: ScalarsEnums['ID']
  updatedAt: ScalarsEnums['String']
}

export interface StaffAccessRulePolicy {
  __typename?: 'StaffAccessRulePolicy'
  accessPermissions?: Maybe<Array<ScalarsEnums['String']>>
  allowedNetworkIds?: Maybe<Array<ScalarsEnums['ID']>>
  corporateId?: Maybe<ScalarsEnums['ID']>
  corporatePermissions?: Maybe<Array<ScalarsEnums['String']>>
  createdAt: ScalarsEnums['String']
  name: ScalarsEnums['String']
  sitePermissions?: Maybe<Array<ScalarsEnums['String']>>
  staffAccessPolicyId: ScalarsEnums['ID']
  updatedAt: ScalarsEnums['String']
}

export interface StaffAccessRuleSites {
  __typename?: 'StaffAccessRuleSites'
  name: ScalarsEnums['String']
  siteId: ScalarsEnums['ID']
}

/**
 * An approved public IP address or CIDR range, with a label, that team members can be restricted to
 */
export interface StaffAllowedNetwork {
  __typename?: 'StaffAllowedNetwork'
  cidr: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  ipVersion: ScalarsEnums['Int']
  label: ScalarsEnums['String']
  notes?: Maybe<ScalarsEnums['String']>
  /**
   * The location this network belongs to, if any
   */
  site?: Maybe<SiteReference>
  siteId?: Maybe<ScalarsEnums['ID']>
  staffAllowedNetworkId: ScalarsEnums['ID']
  updatedAt: ScalarsEnums['String']
  /**
   * How many team members and access policies reference this network
   */
  usage: StaffAllowedNetworkUsage
}

/**
 * How many team members and access policies reference an allowed network
 */
export interface StaffAllowedNetworkUsage {
  __typename?: 'StaffAllowedNetworkUsage'
  staffAccessPolicyCount: ScalarsEnums['Int']
  staffUserCount: ScalarsEnums['Int']
}

export interface StaffInvitation {
  __typename?: 'StaffInvitation'
  acceptedAt?: Maybe<ScalarsEnums['String']>
  corporateId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  email: ScalarsEnums['String']
  expiresAt: ScalarsEnums['String']
  firstName?: Maybe<ScalarsEnums['String']>
  invitationId: ScalarsEnums['ID']
  invitedByUserId: ScalarsEnums['ID']
  lastName?: Maybe<ScalarsEnums['String']>
  permissionPolicyIds?: Maybe<Array<ScalarsEnums['String']>>
  role: ScalarsEnums['InvitationRole']
  siteId?: Maybe<ScalarsEnums['ID']>
  status: ScalarsEnums['InvitationStatus']
  updatedAt?: Maybe<ScalarsEnums['String']>
}

/**
 * Where a team member is allowed to sign in from
 */
export interface StaffNetworkAccess {
  __typename?: 'StaffNetworkAccess'
  /**
   * Own allowed networks plus those inherited from every assigned access policy
   */
  effectiveAllowedNetworkIds: Array<ScalarsEnums['ID']>
  /**
   * Allowed networks inherited from assigned access policies
   */
  inheritedAllowedNetworkIds: Array<ScalarsEnums['ID']>
  /**
   * Holds the All Access policy, so is never IP restricted
   */
  isExempt: ScalarsEnums['Boolean']
  /**
   * Can only sign in from the effective allowed networks
   */
  isRestricted: ScalarsEnums['Boolean']
}

/**
 * Assignment of a staff member to a session
 */
export interface StaffSessionAssignment {
  __typename?: 'StaffSessionAssignment'
  assignedAt: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  deletedAt?: Maybe<ScalarsEnums['String']>
  role: ScalarsEnums['StaffSessionRole']
  sessionId: ScalarsEnums['String']
  staffSessionAssignmentId: ScalarsEnums['String']
  staffUserId: ScalarsEnums['String']
  substitutingForStaffUserId?: Maybe<ScalarsEnums['String']>
  updatedAt?: Maybe<ScalarsEnums['String']>
}

/**
 * Result of staff session assignment pagination
 */
export interface StaffSessionAssignmentPaginationResult {
  __typename?: 'StaffSessionAssignmentPaginationResult'
  pageInfo: StaffSessionAssignmentPaginationResultPageInfo
  results: Array<StaffSessionAssignmentPaginationResultResults>
}

export interface StaffSessionAssignmentPaginationResultPageInfo {
  __typename?: 'StaffSessionAssignmentPaginationResultPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Float']
}

export interface StaffSessionAssignmentPaginationResultResults {
  __typename?: 'StaffSessionAssignmentPaginationResultResults'
  cursor: ScalarsEnums['String']
  row: StaffSessionAssignment
}

/**
 * The brand's staff session rules: idle timeout and maximum session length
 */
export interface StaffSessionPolicy {
  __typename?: 'StaffSessionPolicy'
  /**
   * Whether a location's own auto-logout setting may apply on its pages
   */
  allowLocationIdleTimeout: ScalarsEnums['Boolean']
  /**
   * Sign staff out after this many idle minutes on brand-level pages; null for never
   */
  brandIdleTimeoutMinutes?: Maybe<ScalarsEnums['Int']>
  /**
   * Force a fresh sign-in once a session is this many hours old; null for never
   */
  maxSessionHours?: Maybe<ScalarsEnums['Int']>
}

/**
 * Paginated clock-in/out history for a staff user at a site
 */
export interface StaffTimeClockActivityLog {
  __typename?: 'StaffTimeClockActivityLog'
  events: Array<StaffTimeClockEvent>
  hasNextPage: ScalarsEnums['Boolean']
}

/**
 * A single clock-in or clock-out event
 */
export interface StaffTimeClockEvent {
  __typename?: 'StaffTimeClockEvent'
  at: ScalarsEnums['String']
  byName?: Maybe<ScalarsEnums['String']>
  byStaffUserId?: Maybe<ScalarsEnums['ID']>
  incomplete: ScalarsEnums['Boolean']
  payrollTimeClockId: ScalarsEnums['ID']
  type: ScalarsEnums['ClockStatus']
}

/**
 * A staff user's current clock status at a site
 */
export interface StaffTimeClockStatus {
  __typename?: 'StaffTimeClockStatus'
  clockInTime?: Maybe<ScalarsEnums['String']>
  openShiftId?: Maybe<ScalarsEnums['ID']>
  staffUserId: ScalarsEnums['ID']
  status: ScalarsEnums['ClockStatus']
}

export interface StaffUser {
  __typename?: 'StaffUser'
  about: ScalarsEnums['String']
  accessLevel: Array<ScalarsEnums['StaffUserAccessLevel']>
  allowedNetworkIds?: Maybe<Array<ScalarsEnums['ID']>>
  corporateId?: Maybe<ScalarsEnums['ID']>
  createdAt: ScalarsEnums['String']
  data?: Maybe<StaffUserData>
  dateOfBirth?: Maybe<ScalarsEnums['String']>
  email: ScalarsEnums['String']
  employeeNumber?: Maybe<ScalarsEnums['Float']>
  favoriteReportNames?: Maybe<Array<ScalarsEnums['String']>>
  favoriteSavedReportIds?: Maybe<Array<ScalarsEnums['ID']>>
  favoriteSiteIds?: Maybe<Array<ScalarsEnums['ID']>>
  firebaseId: ScalarsEnums['String']
  firstName: ScalarsEnums['String']
  gender?: Maybe<ScalarsEnums['String']>
  hobbies: ScalarsEnums['String']
  instagramHandle: ScalarsEnums['String']
  /**
   * Whether this staff member has Is Instructor ticked at the given location, or at any location when siteId is omitted
   */
  isInstructor: (args?: { siteId?: Maybe<ScalarsEnums['ID']> }) => ScalarsEnums['Boolean']
  lastName: ScalarsEnums['String']
  /**
   * Where this team member may sign in from: own and inherited allowed networks
   */
  networkAccess: StaffNetworkAccess
  phone: ScalarsEnums['String']
  /**
   * Profile image of the staff user
   */
  profileImage: (args: { input: ImagePublicSignedUrlInput }) => Maybe<ImagePublicSignedUrl>
  /**
   * Public URL of the staff user profile image, parsed from the stored image config (cheap — no signed URL). Used by the public Business/Member APIs.
   */
  profileImageUrl?: Maybe<ScalarsEnums['String']>
  /**
   * Access rules for this staff user
   */
  rules: Array<StaffAccessRule>
  /**
   * Site-specific data (working hours, instructor status) for staff user
   */
  siteData: (args: { siteId: ScalarsEnums['ID'] }) => Maybe<StaffUserSiteData>
  staffUserId: ScalarsEnums['ID']
  status: ScalarsEnums['StaffUserStatus']
  updatedAt: ScalarsEnums['String']
}

export interface StaffUserData {
  __typename?: 'StaffUserData'
  isInstructor?: Maybe<ScalarsEnums['Boolean']>
  payrollId?: Maybe<ScalarsEnums['String']>
  siteId?: Maybe<ScalarsEnums['ID']>
  workingHours?: Maybe<StaffUserDataWorkingHours>
}

export interface StaffUserDataWorkingHours {
  __typename?: 'StaffUserDataWorkingHours'
  customHoursEnabled: ScalarsEnums['Boolean']
  friday?: Maybe<StaffUserDataWorkingHoursMonday>
  monday?: Maybe<StaffUserDataWorkingHoursMonday>
  saturday?: Maybe<StaffUserDataWorkingHoursMonday>
  sunday?: Maybe<StaffUserDataWorkingHoursMonday>
  thursday?: Maybe<StaffUserDataWorkingHoursMonday>
  tuesday?: Maybe<StaffUserDataWorkingHoursMonday>
  wednesday?: Maybe<StaffUserDataWorkingHoursMonday>
}

export interface StaffUserDataWorkingHoursMonday {
  __typename?: 'StaffUserDataWorkingHoursMonday'
  endTime: ScalarsEnums['String']
  startTime: ScalarsEnums['String']
}

export interface StaffUserOption {
  __typename?: 'StaffUserOption'
  firstName?: Maybe<ScalarsEnums['String']>
  lastName?: Maybe<ScalarsEnums['String']>
  siteNames?: Maybe<Array<ScalarsEnums['String']>>
  staffUserId: ScalarsEnums['String']
}

/**
 * Reference to a staff user with basic info
 */
export interface StaffUserReference {
  __typename?: 'StaffUserReference'
  email: ScalarsEnums['String']
  firstName: ScalarsEnums['String']
  lastName: ScalarsEnums['String']
  staffUserId: ScalarsEnums['ID']
}

export interface StaffUserSiteData {
  __typename?: 'StaffUserSiteData'
  isInstructor?: Maybe<ScalarsEnums['Boolean']>
  workingHours?: Maybe<StaffUserDataWorkingHours>
}

/**
 * Staff user smart group with filters
 */
export interface StaffUserSmartGroup {
  __typename?: 'StaffUserSmartGroup'
  filters?: Maybe<StaffUserSmartGroupFilters>
  id: ScalarsEnums['String']
  isVisible: ScalarsEnums['Boolean']
  name: ScalarsEnums['String']
  sortOrder: ScalarsEnums['Float']
  staffUserId: ScalarsEnums['String']
}

export interface StaffUserSmartGroupFilters {
  __typename?: 'StaffUserSmartGroupFilters'
  ageRange?: Maybe<StaffUserSmartGroupFiltersAgeRange>
  attendanceMilestone?: Maybe<StaffUserSmartGroupFiltersNoShowLateCancelAccrual>
  birthMonth?: Maybe<StaffUserSmartGroupFiltersGender>
  clientStatus?: Maybe<StaffUserSmartGroupFiltersGender>
  contractStatus?: Maybe<StaffUserSmartGroupFiltersGender>
  contractType?: Maybe<StaffUserSmartGroupFiltersGender>
  daysAbsent?: Maybe<StaffUserSmartGroupFiltersAgeRange>
  daysInactive?: Maybe<StaffUserSmartGroupFiltersAgeRange>
  email?: Maybe<StaffUserSmartGroupFiltersFirstName>
  emailOptIn?: Maybe<StaffUserSmartGroupFiltersGender>
  failedPaymentsCount?: Maybe<StaffUserSmartGroupFiltersNoShowLateCancelAccrual>
  firstName?: Maybe<StaffUserSmartGroupFiltersFirstName>
  fullName?: Maybe<StaffUserSmartGroupFiltersFirstName>
  gender?: Maybe<StaffUserSmartGroupFiltersGender>
  hasCreditsForSessionType?: Maybe<StaffUserSmartGroupFiltersHasCreditsForSessionType>
  isSuspended?: Maybe<StaffUserSmartGroupFiltersGender>
  joinDate?: Maybe<StaffUserSmartGroupFiltersJoinDate>
  lastAttendanceDate?: Maybe<StaffUserSmartGroupFiltersJoinDate>
  lastName?: Maybe<StaffUserSmartGroupFiltersFirstName>
  lastPaymentDate?: Maybe<StaffUserSmartGroupFiltersJoinDate>
  lastVisitDate?: Maybe<StaffUserSmartGroupFiltersJoinDate>
  locationStatus?: Maybe<StaffUserSmartGroupFiltersGender>
  masterUnsubscribe?: Maybe<StaffUserSmartGroupFiltersGender>
  noShowLateCancelAccrual?: Maybe<StaffUserSmartGroupFiltersNoShowLateCancelAccrual>
  phone?: Maybe<StaffUserSmartGroupFiltersFirstName>
  profileCreatedDate?: Maybe<StaffUserSmartGroupFiltersJoinDate>
  sessionFrequency?: Maybe<StaffUserSmartGroupFiltersGender>
  smsOptIn?: Maybe<StaffUserSmartGroupFiltersGender>
}

export interface StaffUserSmartGroupFiltersAgeRange {
  __typename?: 'StaffUserSmartGroupFiltersAgeRange'
  logicalOperator: ScalarsEnums['LogicalOperator']
  orderIndex?: Maybe<ScalarsEnums['Float']>
  using: Array<StaffUserSmartGroupFiltersAgeRangeUsing>
}

export interface StaffUserSmartGroupFiltersAgeRangeUsing {
  __typename?: 'StaffUserSmartGroupFiltersAgeRangeUsing'
  max?: Maybe<ScalarsEnums['String']>
  min?: Maybe<ScalarsEnums['String']>
  operator: ScalarsEnums['NumericToDateFilterOperator']
  value?: Maybe<ScalarsEnums['String']>
}

export interface StaffUserSmartGroupFiltersFirstName {
  __typename?: 'StaffUserSmartGroupFiltersFirstName'
  logicalOperator: ScalarsEnums['LogicalOperator']
  orderIndex?: Maybe<ScalarsEnums['Float']>
  using: Array<StaffUserSmartGroupFiltersFirstNameUsing>
}

export interface StaffUserSmartGroupFiltersFirstNameUsing {
  __typename?: 'StaffUserSmartGroupFiltersFirstNameUsing'
  operator: ScalarsEnums['TextFilterOperator']
  value: ScalarsEnums['String']
}

export interface StaffUserSmartGroupFiltersGender {
  __typename?: 'StaffUserSmartGroupFiltersGender'
  logicalOperator: ScalarsEnums['LogicalOperator']
  orderIndex?: Maybe<ScalarsEnums['Float']>
  using: Array<StaffUserSmartGroupFiltersGenderUsing>
}

export interface StaffUserSmartGroupFiltersGenderUsing {
  __typename?: 'StaffUserSmartGroupFiltersGenderUsing'
  operator: ScalarsEnums['SelectFilterOperator']
  value: Array<ScalarsEnums['String']>
}

export interface StaffUserSmartGroupFiltersHasCreditsForSessionType {
  __typename?: 'StaffUserSmartGroupFiltersHasCreditsForSessionType'
  bookingDate?: Maybe<ScalarsEnums['String']>
  siteSessionTypeId: ScalarsEnums['ID']
}

export interface StaffUserSmartGroupFiltersJoinDate {
  __typename?: 'StaffUserSmartGroupFiltersJoinDate'
  logicalOperator: ScalarsEnums['LogicalOperator']
  orderIndex?: Maybe<ScalarsEnums['Float']>
  using: Array<StaffUserSmartGroupFiltersJoinDateUsing>
}

export interface StaffUserSmartGroupFiltersJoinDateUsing {
  __typename?: 'StaffUserSmartGroupFiltersJoinDateUsing'
  from?: Maybe<ScalarsEnums['String']>
  operator: ScalarsEnums['DateFilterOperator']
  to?: Maybe<ScalarsEnums['String']>
  value?: Maybe<ScalarsEnums['String']>
}

export interface StaffUserSmartGroupFiltersNoShowLateCancelAccrual {
  __typename?: 'StaffUserSmartGroupFiltersNoShowLateCancelAccrual'
  logicalOperator: ScalarsEnums['LogicalOperator']
  orderIndex?: Maybe<ScalarsEnums['Float']>
  using: Array<StaffUserSmartGroupFiltersNoShowLateCancelAccrualUsing>
}

export interface StaffUserSmartGroupFiltersNoShowLateCancelAccrualUsing {
  __typename?: 'StaffUserSmartGroupFiltersNoShowLateCancelAccrualUsing'
  max?: Maybe<ScalarsEnums['Float']>
  min?: Maybe<ScalarsEnums['Float']>
  operator: ScalarsEnums['NumericFilterOperator']
  value?: Maybe<ScalarsEnums['Float']>
}

export interface StageDestinationFeeResult {
  __typename?: 'StageDestinationFeeResult'
  amount: ScalarsEnums['String']
  invoiceId: ScalarsEnums['String']
  status: ScalarsEnums['String']
}

export interface StartExportJob {
  __typename?: 'StartExportJob'
  jobId: ScalarsEnums['String']
  totalRows: ScalarsEnums['Float']
}

export interface StartImportValidation {
  __typename?: 'StartImportValidation'
  startedCount: ScalarsEnums['Float']
}

/**
 * Result of starting Stripe Connect onboarding
 */
export interface StartStripeOnboardingResult {
  __typename?: 'StartStripeOnboardingResult'
  onboardingUrl?: Maybe<ScalarsEnums['String']>
  onboardingUrlExpiresAt?: Maybe<ScalarsEnums['Float']>
  sitePaymentGateway: StartStripeOnboardingResultSitePaymentGateway
}

export interface StartStripeOnboardingResultSitePaymentGateway {
  __typename?: 'StartStripeOnboardingResultSitePaymentGateway'
  isSandbox: ScalarsEnums['Boolean']
  onboardingStatus: ScalarsEnums['SitePaymentGatewayOnboardingStatus']
  siteGatewayAccountId: ScalarsEnums['String']
  sitePaymentGatewayId: ScalarsEnums['ID']
}

export interface StartSupportChatStreamResult {
  __typename?: 'StartSupportChatStreamResult'
  chatId: ScalarsEnums['String']
  streamId: ScalarsEnums['String']
  userMessageId: ScalarsEnums['String']
}

export interface StreamSupportMessageResult {
  __typename?: 'StreamSupportMessageResult'
  messageId: ScalarsEnums['String']
  streamId: ScalarsEnums['String']
  success: ScalarsEnums['Boolean']
  supportChatId: ScalarsEnums['String']
}

/**
 * Stripe-specific completion configuration with client secret
 */
export interface StripeCompletionConfig {
  __typename?: 'StripeCompletionConfig'
  clientSecret: ScalarsEnums['String']
  type: ScalarsEnums['String']
}

/**
 * Stripe Connect account information
 */
export interface StripeConnectAccount {
  __typename?: 'StripeConnectAccount'
  email: ScalarsEnums['String']
  id: ScalarsEnums['String']
  inUse: ScalarsEnums['Boolean']
  name?: Maybe<ScalarsEnums['String']>
}

/**
 * Response for client form submission
 */
export interface SubmitClientFormsResponse {
  __typename?: 'SubmitClientFormsResponse'
  message?: Maybe<ScalarsEnums['String']>
  resultVisibleToClient?: Maybe<ScalarsEnums['Boolean']>
  success: ScalarsEnums['Boolean']
}

export interface SubmitSessionFeedback {
  __typename?: 'SubmitSessionFeedback'
  message: ScalarsEnums['String']
  sessionFeedbackId?: Maybe<ScalarsEnums['String']>
  success: ScalarsEnums['Boolean']
}

export interface SupportChat {
  __typename?: 'SupportChat'
  createdAt: ScalarsEnums['String']
  evalScore?: Maybe<ScalarsEnums['Float']>
  messages?: Maybe<Array<SupportChatMessage>>
  pageContextMeta?: Maybe<ScalarsEnums['JSON']>
  pageName?: Maybe<ScalarsEnums['String']>
  pathname?: Maybe<ScalarsEnums['String']>
  planTier?: Maybe<ScalarsEnums['String']>
  previewText: ScalarsEnums['String']
  rawUserText: ScalarsEnums['String']
  responseLatencyMs?: Maybe<ScalarsEnums['Int']>
  scopeLevel?: Maybe<ScalarsEnums['String']>
  scopeName?: Maybe<ScalarsEnums['String']>
  source: ScalarsEnums['SupportChatSource']
  status: ScalarsEnums['SupportChatStatus']
  suggestedQuickQuestionId?: Maybe<ScalarsEnums['String']>
  supportChatId: ScalarsEnums['ID']
  updatedAt: ScalarsEnums['String']
  userId: ScalarsEnums['String']
  userRole?: Maybe<ScalarsEnums['String']>
}

export interface SupportChatMessage {
  __typename?: 'SupportChatMessage'
  createdAt: ScalarsEnums['String']
  feedback?: Maybe<ScalarsEnums['Boolean']>
  html?: Maybe<ScalarsEnums['String']>
  metadata?: Maybe<ScalarsEnums['JSON']>
  pageContextMeta?: Maybe<ScalarsEnums['JSON']>
  role: ScalarsEnums['SupportMessageRole']
  supportChatId: ScalarsEnums['String']
  supportChatMessageId: ScalarsEnums['ID']
  text: ScalarsEnums['String']
  thinkingText?: Maybe<ScalarsEnums['String']>
}

export interface SupportChatWithMessages {
  __typename?: 'SupportChatWithMessages'
  chat: SupportChat
  messages: Array<SupportChatMessage>
}

export interface SupportTicket {
  __typename?: 'SupportTicket'
  contactId?: Maybe<ScalarsEnums['String']>
  ticketId: ScalarsEnums['ID']
  ticketUrl: ScalarsEnums['String']
}

/**
 * The pauses created, and — when one failed — its index and the reason. Pauses before the failure are real and are undone with cancelScheduledSuspension.
 */
export interface SuspendServiceBatchResult {
  __typename?: 'SuspendServiceBatchResult'
  error?: Maybe<ScalarsEnums['String']>
  failedPauseIndex?: Maybe<ScalarsEnums['Float']>
  serviceSuspensionIds: Array<ScalarsEnums['ID']>
}

export interface SyncBrandStoreListingsFromProviders {
  __typename?: 'SyncBrandStoreListingsFromProviders'
  appName?: Maybe<ScalarsEnums['String']>
  brandId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  description?: Maybe<ScalarsEnums['String']>
  keywords?: Maybe<ScalarsEnums['String']>
  locale: ScalarsEnums['String']
  marketingUrl?: Maybe<ScalarsEnums['String']>
  platform: ScalarsEnums['BrandPlatform']
  privacyPolicyUrl?: Maybe<ScalarsEnums['String']>
  releaseNotes?: Maybe<ScalarsEnums['String']>
  shortDescription?: Maybe<ScalarsEnums['String']>
  subtitle?: Maybe<ScalarsEnums['String']>
  supportUrl?: Maybe<ScalarsEnums['String']>
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['String']>
}

/**
 * Response from queuing a bulk client Grow re-sync
 */
export interface SyncClientsToGrowResponse {
  __typename?: 'SyncClientsToGrowResponse'
  message: ScalarsEnums['String']
  queued: ScalarsEnums['Float']
  skipped: ScalarsEnums['Float']
  success: ScalarsEnums['Boolean']
}

export interface SyncToVertexResult {
  __typename?: 'SyncToVertexResult'
  documentsIndexed: ScalarsEnums['Int']
  durationMs: ScalarsEnums['Int']
  errors: Array<ScalarsEnums['String']>
  success: ScalarsEnums['Boolean']
}

export interface TanningAgentDownloadUrl {
  __typename?: 'TanningAgentDownloadUrl'
  url: ScalarsEnums['String']
}

/**
 * A failed call to the tanning connector
 */
export interface TanningConnectorError {
  __typename?: 'TanningConnectorError'
  connectorCode?: Maybe<ScalarsEnums['String']>
  kind: ScalarsEnums['TanningConnectorErrorKind']
  message: ScalarsEnums['String']
}

/**
 * Health of a site's tanning connector for the Manage equipments page
 */
export interface TanningConnectorHealth {
  __typename?: 'TanningConnectorHealth'
  connectorUrl?: Maybe<ScalarsEnums['String']>
  consecutiveStartFailures: ScalarsEnums['Int']
  diagnostics?: Maybe<AgentDiagnostics>
  lastBedUpdateAt?: Maybe<ScalarsEnums['String']>
  lastRegisteredAt?: Maybe<ScalarsEnums['String']>
  lastStartError?: Maybe<TanningConnectorError>
  lastStartFailureAt?: Maybe<ScalarsEnums['String']>
  lastStartSuccessAt?: Maybe<ScalarsEnums['String']>
  liveCheck?: Maybe<TanningConnectorLiveCheck>
  reasons: Array<ScalarsEnums['TanningConnectorHealthReason']>
  sharedWithSites: Array<TanningConnectorSharedSite>
  verdict: ScalarsEnums['TanningConnectorVerdict']
}

/**
 * Result of calling the tanning connector while building the health report
 */
export interface TanningConnectorLiveCheck {
  __typename?: 'TanningConnectorLiveCheck'
  checkedAt: ScalarsEnums['String']
  error?: Maybe<TanningConnectorError>
}

/**
 * Another site of the brand linked to the same tanning connector address
 */
export interface TanningConnectorSharedSite {
  __typename?: 'TanningConnectorSharedSite'
  name: ScalarsEnums['String']
  siteId: ScalarsEnums['ID']
}

/**
 * Whether a client is eligible to use tanning equipment at this moment
 */
export interface TanningEligibility {
  __typename?: 'TanningEligibility'
  customerAgeMaxFrequency: EligibilityFrequency
  customerAgeMaxFrequencyAfterNoCategoryTan: EligibilityFrequency
  eligible: ScalarsEnums['Boolean']
  hoursBetweenUsesFromStartOfPrevious: EligibilityTiming
  minimumDaysBetweenUses: EligibilityTiming
  minimumHoursBetweenUses: EligibilityTiming
  minutesUntilAllowed: ScalarsEnums['Float']
  nextAllowedAt: ScalarsEnums['String']
  nonUvAge: EligibilityAge
  skinType?: Maybe<EligibilitySkinType>
  uvAge: EligibilityAge
}

export interface TanningPageInfo {
  __typename?: 'TanningPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Float']
}

export interface TaxSetting {
  __typename?: 'TaxSetting'
  corporateTaxSettingId?: Maybe<ScalarsEnums['ID']>
  createdAt: ScalarsEnums['String']
  deletedAt?: Maybe<ScalarsEnums['String']>
  enabled: ScalarsEnums['Boolean']
  isLocked?: Maybe<ScalarsEnums['Boolean']>
  name: ScalarsEnums['String']
  rate: ScalarsEnums['String']
  setting: ScalarsEnums['TaxSettingType']
  siteId: ScalarsEnums['ID']
  taxSettingId: ScalarsEnums['ID']
  taxSettingVersionId: ScalarsEnums['ID']
  updatedAt: ScalarsEnums['String']
  version: ScalarsEnums['Float']
}

export interface TemplateCreditSessionType {
  __typename?: 'TemplateCreditSessionType'
  name: ScalarsEnums['String']
  siteSessionTypeId: ScalarsEnums['ID']
  siteSessionTypeIds: Array<ScalarsEnums['ID']>
}

/**
 * A service template referencing an account code
 */
export interface TemplateUsingAccountCode {
  __typename?: 'TemplateUsingAccountCode'
  name: ScalarsEnums['String']
  serviceTemplateId: ScalarsEnums['String']
}

/**
 * Count + list of service templates referencing an account code
 */
export interface TemplatesUsingAccountCodeResult {
  __typename?: 'TemplatesUsingAccountCodeResult'
  count: ScalarsEnums['Float']
  templates: Array<TemplateUsingAccountCode>
}

/**
 * A required profile detail the client does not have yet
 */
export interface TerminalHandoffMissingField {
  __typename?: 'TerminalHandoffMissingField'
  field: ScalarsEnums['TerminalHandoffField']
  inputType: ScalarsEnums['TerminalReaderInputType']
}

/**
 * What a reader hand-off can collect for a client at a location right now
 */
export interface TerminalHandoffPlan {
  __typename?: 'TerminalHandoffPlan'
  fallback: ScalarsEnums['TerminalSignatureFallback']
  fieldCaptureEnabled: ScalarsEnums['Boolean']
  missingFields: Array<TerminalHandoffMissingField>
  readers: Array<TerminalHandoffReaderOption>
  signatureCaptureEnabled: ScalarsEnums['Boolean']
  signatureDevice: ScalarsEnums['TerminalSignatureDevice']
}

export interface TerminalHandoffReaderOption {
  __typename?: 'TerminalHandoffReaderOption'
  name: ScalarsEnums['String']
  siteTerminalReaderId: ScalarsEnums['ID']
  supportsHandoff: ScalarsEnums['Boolean']
  unsupportedReason?: Maybe<ScalarsEnums['TerminalReaderUnsupportedReason']>
}

/**
 * A hand-off sent to a Stripe reader for a member to enter details and sign
 */
export interface TerminalHandoffRequest {
  __typename?: 'TerminalHandoffRequest'
  appliedAt?: Maybe<ScalarsEnums['String']>
  batchCount: ScalarsEnums['Float']
  canRetry: ScalarsEnums['Boolean']
  clientId?: Maybe<ScalarsEnums['ID']>
  createdAt: ScalarsEnums['String']
  currentBatchIndex: ScalarsEnums['Float']
  failureCode?: Maybe<ScalarsEnums['TerminalHandoffFailureCode']>
  readerLabel?: Maybe<ScalarsEnums['String']>
  roundTripMs?: Maybe<ScalarsEnums['Float']>
  sentAt?: Maybe<ScalarsEnums['String']>
  siteId: ScalarsEnums['ID']
  siteTerminalReaderId: ScalarsEnums['ID']
  sourceSurface: ScalarsEnums['TerminalHandoffSourceSurface']
  status: ScalarsEnums['TerminalHandoffStatus']
  steps: Array<TerminalHandoffStep>
  terminalHandoffRequestId: ScalarsEnums['ID']
  underAgeCosignRequired: ScalarsEnums['Boolean']
}

/**
 * One screen of a reader hand-off: a profile detail or an agreement signature
 */
export interface TerminalHandoffStep {
  __typename?: 'TerminalHandoffStep'
  agreementId?: Maybe<ScalarsEnums['ID']>
  agreementName?: Maybe<ScalarsEnums['String']>
  agreementVersion?: Maybe<ScalarsEnums['String']>
  appliedAt?: Maybe<ScalarsEnums['String']>
  batchIndex: ScalarsEnums['Float']
  capturedAt?: Maybe<ScalarsEnums['String']>
  capturedValue?: Maybe<ScalarsEnums['String']>
  field?: Maybe<ScalarsEnums['TerminalHandoffField']>
  holdReason?: Maybe<ScalarsEnums['TerminalHandoffHoldReason']>
  inputType: ScalarsEnums['TerminalReaderInputType']
  kind: ScalarsEnums['TerminalHandoffStepKind']
  padCount?: Maybe<ScalarsEnums['Float']>
  padIndex?: Maybe<ScalarsEnums['Float']>
  readerText?: Maybe<ScalarsEnums['String']>
  reference?: Maybe<ScalarsEnums['String']>
  required: ScalarsEnums['Boolean']
  state: ScalarsEnums['TerminalHandoffStepState']
  stepKey: ScalarsEnums['String']
}

export interface TerminalPaymentMethodDetails {
  __typename?: 'TerminalPaymentMethodDetails'
  brand?: Maybe<ScalarsEnums['String']>
  last4?: Maybe<ScalarsEnums['String']>
  type: ScalarsEnums['TerminalPaymentMethodType']
}

export interface TestAppleApiConnection {
  __typename?: 'TestAppleApiConnection'
  message: ScalarsEnums['String']
  success: ScalarsEnums['Boolean']
}

/**
 * Diagnostic result of testEzypayConnection
 */
export interface TestEzypayConnectionPayload {
  __typename?: 'TestEzypayConnectionPayload'
  message?: Maybe<ScalarsEnums['String']>
  ok: ScalarsEnums['Boolean']
}

/**
 * Response from testing HQ authentication
 */
export interface TestHqAuthResponse {
  __typename?: 'TestHqAuthResponse'
  message: ScalarsEnums['String']
  success: ScalarsEnums['Boolean']
}

/**
 * A Developer-API test member (Firebase user + Client row).
 */
export interface TestMember {
  __typename?: 'TestMember'
  clientId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  email: ScalarsEnums['String']
  firebaseId?: Maybe<ScalarsEnums['String']>
  firstName?: Maybe<ScalarsEnums['String']>
  homeSiteId?: Maybe<ScalarsEnums['String']>
  homeSiteName?: Maybe<ScalarsEnums['String']>
  lastName?: Maybe<ScalarsEnums['String']>
}

/**
 * A newly created test member, including its one-time password.
 */
export interface TestMemberWithCredentials {
  __typename?: 'TestMemberWithCredentials'
  clientId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  email: ScalarsEnums['String']
  firebaseId?: Maybe<ScalarsEnums['String']>
  firstName?: Maybe<ScalarsEnums['String']>
  homeSiteId?: Maybe<ScalarsEnums['String']>
  homeSiteName?: Maybe<ScalarsEnums['String']>
  lastName?: Maybe<ScalarsEnums['String']>
  password: ScalarsEnums['String']
}

/**
 * Response from testing site authentication
 */
export interface TestSiteAuthResponse {
  __typename?: 'TestSiteAuthResponse'
  message: ScalarsEnums['String']
  success: ScalarsEnums['Boolean']
}

/**
 * The locations one of a brand's add-ons ended up deployed to, and any it could not
 */
export interface ThemeDeploymentResult {
  __typename?: 'ThemeDeploymentResult'
  deployedSiteIds: Array<ScalarsEnums['ID']>
  skipped: Array<ThemeDeploymentResultSkipped>
  slug: ScalarsEnums['ThemeKey']
}

export interface ThemeDeploymentResultSkipped {
  __typename?: 'ThemeDeploymentResultSkipped'
  reason: ScalarsEnums['String']
  siteId: ScalarsEnums['ID']
}

/**
 * The locations one of a brand's add-ons is currently deployed to
 */
export interface ThemeDeploymentRow {
  __typename?: 'ThemeDeploymentRow'
  deployedSiteIds: Array<ScalarsEnums['ID']>
  slug: ScalarsEnums['String']
  themeName: ScalarsEnums['String']
}

/**
 * Result of a theme entitlement check for a site
 */
export interface ThemeEntitlementResult {
  __typename?: 'ThemeEntitlementResult'
  active: ScalarsEnums['Boolean']
  features: ScalarsEnums['JSONObject']
  status?: Maybe<ScalarsEnums['ThemeSubscriptionStatus']>
  trialEndsAt?: Maybe<ScalarsEnums['String']>
}

export interface ThemeSubscription {
  __typename?: 'ThemeSubscription'
  activatedAt?: Maybe<ScalarsEnums['String']>
  billingCycleAmount?: Maybe<ScalarsEnums['Float']>
  cancelledAt?: Maybe<ScalarsEnums['String']>
  corporateId: ScalarsEnums['ID']
  corporateThemeSubscriptionId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  currency: ScalarsEnums['String']
  effectiveCancelAt?: Maybe<ScalarsEnums['String']>
  expiresAt?: Maybe<ScalarsEnums['String']>
  gracePeriodEndsAt?: Maybe<ScalarsEnums['String']>
  lastBilledAt?: Maybe<ScalarsEnums['String']>
  metadata?: Maybe<ScalarsEnums['JSONObject']>
  nextBillingDate?: Maybe<ScalarsEnums['String']>
  slug: ScalarsEnums['String']
  status: ScalarsEnums['ThemeSubscriptionStatus']
  subscribedAt: ScalarsEnums['String']
  themeId: ScalarsEnums['ID']
  themeName: ScalarsEnums['String']
  trialEndsAt?: Maybe<ScalarsEnums['String']>
  updatedAt: ScalarsEnums['String']
}

/**
 * A key within a third party integration
 */
export interface ThirdPartyIntegrationKey {
  __typename?: 'ThirdPartyIntegrationKey'
  availableFor: ScalarsEnums['ThirdPartyIntegrationAvailableFor']
  createdAt: ScalarsEnums['String']
  deletedAt?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  thirdPartyIntegrationId: ScalarsEnums['ID']
  thirdPartyIntegrationKeyId: ScalarsEnums['ID']
  uniqueAcross?: Maybe<ScalarsEnums['ThirdPartyIntegrationUniqueAcross']>
  updatedAt: ScalarsEnums['String']
  visibilityAt: ScalarsEnums['ThirdPartyIntegrationVisibilityAt']
}

/**
 * A third party integration with its keys
 */
export interface ThirdPartyIntegrationWithKeys {
  __typename?: 'ThirdPartyIntegrationWithKeys'
  createdAt: ScalarsEnums['String']
  deletedAt?: Maybe<ScalarsEnums['String']>
  description: ScalarsEnums['String']
  enabled: ScalarsEnums['Boolean']
  keys: Array<ThirdPartyIntegrationKey>
  name: ScalarsEnums['String']
  thirdPartyIntegrationId: ScalarsEnums['ID']
  updatedAt: ScalarsEnums['String']
}

/**
 * Signed URL for uploading a video thumbnail and the resulting public URL
 */
export interface ThumbnailUploadUrlResult {
  __typename?: 'ThumbnailUploadUrlResult'
  thumbnailUrl: ScalarsEnums['String']
  uploadUrl: ScalarsEnums['String']
}

/**
 * Response from token refresh operations
 */
export interface TokenRefreshResponse {
  __typename?: 'TokenRefreshResponse'
  failedCount?: Maybe<ScalarsEnums['Float']>
  message: ScalarsEnums['String']
  refreshedCount?: Maybe<ScalarsEnums['Float']>
  success: ScalarsEnums['Boolean']
}

/**
 * A ranked service by visit count
 */
export interface TopServiceItem {
  __typename?: 'TopServiceItem'
  rank: ScalarsEnums['Float']
  serviceName: ScalarsEnums['String']
  visitCount: ScalarsEnums['Float']
}

/**
 * A single video in the top videos ranking
 */
export interface TopVideoItem {
  __typename?: 'TopVideoItem'
  avgWatchTimeSeconds: ScalarsEnums['Float']
  completionRate: ScalarsEnums['Float']
  contentMediaId: ScalarsEnums['String']
  totalViews: ScalarsEnums['Float']
  uniqueViewers: ScalarsEnums['Float']
}

/**
 * Response for transferring client between sites
 */
export interface TransferClientResponse {
  __typename?: 'TransferClientResponse'
  message?: Maybe<ScalarsEnums['String']>
  success: ScalarsEnums['Boolean']
}

export interface TrialPipelineItem {
  __typename?: 'TrialPipelineItem'
  corporateId: ScalarsEnums['String']
  createdByName?: Maybe<ScalarsEnums['String']>
  daysRemaining?: Maybe<ScalarsEnums['Float']>
  hasSeedingData: ScalarsEnums['Boolean']
  healthScore: ScalarsEnums['Float']
  leadSource?: Maybe<ScalarsEnums['String']>
  name: ScalarsEnums['String']
  onboardingProgressPct: ScalarsEnums['Float']
  salesOwnerId?: Maybe<ScalarsEnums['String']>
  salesOwnerName?: Maybe<ScalarsEnums['String']>
  trialCloseNotes?: Maybe<ScalarsEnums['String']>
  trialCloseReason?: Maybe<ScalarsEnums['String']>
  trialExpiresAt?: Maybe<ScalarsEnums['String']>
  trialStartedAt?: Maybe<ScalarsEnums['String']>
  trialStatus?: Maybe<ScalarsEnums['String']>
  urlPrefix: ScalarsEnums['String']
}

export interface TrialStatusResponse {
  __typename?: 'TrialStatusResponse'
  daysRemaining?: Maybe<ScalarsEnums['Float']>
  onboardingProgress: OnboardingProgress
  trialConvertedAt?: Maybe<ScalarsEnums['String']>
  trialExpiresAt?: Maybe<ScalarsEnums['String']>
  trialStartedAt?: Maybe<ScalarsEnums['String']>
  trialStatus?: Maybe<ScalarsEnums['TrialStatus']>
}

export interface TriggerGrowHqCustomFieldsSyncResponse {
  __typename?: 'TriggerGrowHqCustomFieldsSyncResponse'
  fieldCount: ScalarsEnums['Float']
  message: ScalarsEnums['String']
  success: ScalarsEnums['Boolean']
}

export interface TriggerGrowSiteCustomFieldsSyncResponse {
  __typename?: 'TriggerGrowSiteCustomFieldsSyncResponse'
  failed: ScalarsEnums['Float']
  message: ScalarsEnums['String']
  skipped: ScalarsEnums['Float']
  success: ScalarsEnums['Boolean']
  synced: ScalarsEnums['Float']
}

export interface TriggerHqSyncResponse {
  __typename?: 'TriggerHqSyncResponse'
  success: ScalarsEnums['Boolean']
}

/**
 * Response from triggering site sync job
 */
export interface TriggerSiteSyncResponse {
  __typename?: 'TriggerSiteSyncResponse'
  jobId?: Maybe<ScalarsEnums['String']>
  message: ScalarsEnums['String']
  success: ScalarsEnums['Boolean']
}

export interface UndoCheckinResult {
  __typename?: 'UndoCheckinResult'
  message: ScalarsEnums['String']
  success: ScalarsEnums['Boolean']
}

export interface UpcomingOpeningException {
  __typename?: 'UpcomingOpeningException'
  date: ScalarsEnums['String']
  isClosed: ScalarsEnums['Boolean']
  label: ScalarsEnums['String']
  ranges: Array<ResolvedOpeningRange>
}

export interface UpdateAppStoreCredentials {
  __typename?: 'UpdateAppStoreCredentials'
  credentials?: Maybe<AppStoreCredentials>
  success: ScalarsEnums['Boolean']
}

export interface UpdateClientAccountBalancePreference {
  __typename?: 'UpdateClientAccountBalancePreference'
  success: ScalarsEnums['Boolean']
}

/**
 * Response for updating client custom property value
 */
export interface UpdateClientCustomPropertyValueResponse {
  __typename?: 'UpdateClientCustomPropertyValueResponse'
  message?: Maybe<ScalarsEnums['String']>
  success: ScalarsEnums['Boolean']
}

/**
 * Response for bulk updating client custom property values
 */
export interface UpdateClientCustomPropertyValuesResponse {
  __typename?: 'UpdateClientCustomPropertyValuesResponse'
  /**
   * Properties in the request left unchanged because the calling client may not change them, such as a form result
   */
  lockedSiteCustomPropertyIds?: Maybe<Array<ScalarsEnums['String']>>
  message?: Maybe<ScalarsEnums['String']>
  success: ScalarsEnums['Boolean']
  values?: Maybe<Array<ClientCustomPropertyValue>>
}

export interface UpdateClientFileNameResponse {
  __typename?: 'UpdateClientFileNameResponse'
  message?: Maybe<ScalarsEnums['String']>
  success: ScalarsEnums['Boolean']
}

/**
 * Response for updating a client note
 */
export interface UpdateClientNoteResponse {
  __typename?: 'UpdateClientNoteResponse'
  message?: Maybe<ScalarsEnums['String']>
  note?: Maybe<ClientNote>
  success: ScalarsEnums['Boolean']
}

export interface UpdateClientRecentSite {
  __typename?: 'UpdateClientRecentSite'
  success: ScalarsEnums['Boolean']
}

/**
 * Response for client update
 */
export interface UpdateClientResponse {
  __typename?: 'UpdateClientResponse'
  success: ScalarsEnums['Boolean']
}

/**
 * Response for updating client site data
 */
export interface UpdateClientSiteDataResponse {
  __typename?: 'UpdateClientSiteDataResponse'
  message?: Maybe<ScalarsEnums['String']>
  success: ScalarsEnums['Boolean']
}

export interface UpdateCustomPropertyAlert {
  __typename?: 'UpdateCustomPropertyAlert'
  success: ScalarsEnums['Boolean']
}

export interface UpdateCustomText {
  __typename?: 'UpdateCustomText'
  customizationCount?: Maybe<ScalarsEnums['Float']>
  errors?: Maybe<Array<UpdateCustomTextErrors>>
  success: ScalarsEnums['Boolean']
}

export interface UpdateCustomTextErrors {
  __typename?: 'UpdateCustomTextErrors'
  actual?: Maybe<ScalarsEnums['Float']>
  error: ScalarsEnums['String']
  expected?: Maybe<ScalarsEnums['Float']>
  key: ScalarsEnums['String']
}

/**
 * Result of updateEzypayGateway
 */
export interface UpdateEzypayGatewayPayload {
  __typename?: 'UpdateEzypayGatewayPayload'
  sitePaymentGateway: EzypayGateway
}

/**
 * The expiry of a gift card after a staff change
 */
export interface UpdateGiftCardExpiryResult {
  __typename?: 'UpdateGiftCardExpiryResult'
  expiredAt?: Maybe<ScalarsEnums['String']>
  expiresAt?: Maybe<ScalarsEnums['String']>
  giftCardId: ScalarsEnums['ID']
}

export interface UpdateImportRow {
  __typename?: 'UpdateImportRow'
  errorMessage?: Maybe<ScalarsEnums['String']>
  processingStatus?: Maybe<ScalarsEnums['String']>
  rowIndex: ScalarsEnums['Float']
  validationErrors?: Maybe<Array<ImportPreviewRowsValidationErrors>>
  validationStatus: ScalarsEnums['String']
}

export interface UpdateImportSession {
  __typename?: 'UpdateImportSession'
  importSessionId: ScalarsEnums['ID']
}

export interface UpdateMemberExperienceBranding {
  __typename?: 'UpdateMemberExperienceBranding'
  branding?: Maybe<MemberExperienceBranding>
  success: ScalarsEnums['Boolean']
}

export interface UpdateMemberExperienceFonts {
  __typename?: 'UpdateMemberExperienceFonts'
  fonts?: Maybe<MemberExperienceFonts>
  success: ScalarsEnums['Boolean']
}

export interface UpdateMemberExperienceSettings {
  __typename?: 'UpdateMemberExperienceSettings'
  settings?: Maybe<MemberExperienceSettings>
  success: ScalarsEnums['Boolean']
}

export interface UpdateMemberExperienceSurfaceBrandingResponse {
  __typename?: 'UpdateMemberExperienceSurfaceBrandingResponse'
  success: ScalarsEnums['Boolean']
  surfaceBranding?: Maybe<MemberExperienceSurfaceBranding>
}

export interface UpdateMobileAppBranding {
  __typename?: 'UpdateMobileAppBranding'
  branding?: Maybe<MobileAppBranding>
  success: ScalarsEnums['Boolean']
}

export interface UpdateMobileAppChannels {
  __typename?: 'UpdateMobileAppChannels'
  channels?: Maybe<MobileAppChannels>
  success: ScalarsEnums['Boolean']
}

export interface UpdateMobileAppProfile {
  __typename?: 'UpdateMobileAppProfile'
  profile?: Maybe<MobileAppProfile>
  success: ScalarsEnums['Boolean']
}

/**
 * Response indicating success of category update
 */
export interface UpdatePosCategoryResponse {
  __typename?: 'UpdatePosCategoryResponse'
  success: ScalarsEnums['Boolean']
}

/**
 * Updated product with all fields
 */
export interface UpdatePosProductResponse {
  __typename?: 'UpdatePosProductResponse'
  /**
   * Product category
   */
  category?: Maybe<CreatePosCategoryResponse>
  categoryId?: Maybe<ScalarsEnums['ID']>
  createdAt: ScalarsEnums['String']
  createdBy: ScalarsEnums['ID']
  description?: Maybe<ScalarsEnums['String']>
  imageJSON?: Maybe<ImageFileConfigField>
  posProductId: ScalarsEnums['ID']
  /**
   * Product image with signed URL
   */
  productImage: (args: { input: ImagePublicSignedUrlInput }) => Maybe<ImagePublicSignedUrl>
  productName: ScalarsEnums['String']
  revenueTag?: Maybe<ScalarsEnums['String']>
  siteId: ScalarsEnums['ID']
  status: ScalarsEnums['PosProductStatus']
  supplierId?: Maybe<ScalarsEnums['ID']>
  /**
   * Total stock across all variants
   */
  totalStock: ScalarsEnums['Int']
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['ID']>
  /**
   * Product variants with attributes
   */
  variables: Array<PosProductVariableWithAttributes>
}

/**
 * Response indicating success of updating featured status
 */
export interface UpdatePosProductVariableFeaturedResponse {
  __typename?: 'UpdatePosProductVariableFeaturedResponse'
  isFeatured: ScalarsEnums['Boolean']
  success: ScalarsEnums['Boolean']
}

/**
 * Response indicating success of service template category update
 */
export interface UpdateServiceTemplateCategoryResponse {
  __typename?: 'UpdateServiceTemplateCategoryResponse'
  success: ScalarsEnums['Boolean']
}

/**
 * Result of toggling a service template's New Sale featured flag
 */
export interface UpdateServiceTemplateFeaturedResponse {
  __typename?: 'UpdateServiceTemplateFeaturedResponse'
  isFeatured: ScalarsEnums['Boolean']
  success: ScalarsEnums['Boolean']
}

export interface UpdateSiteCommunicationTemplate {
  __typename?: 'UpdateSiteCommunicationTemplate'
  alias: ScalarsEnums['CommunicationTemplateAliases']
  allowedPlaceholders: Array<ScalarsEnums['CommunicationTemplatePlaceholders']>
  createdAt: ScalarsEnums['String']
  emailBody: ScalarsEnums['String']
  emailCcEmail?: Maybe<ScalarsEnums['String']>
  emailCcLocation: ScalarsEnums['Boolean']
  emailCopyEmployee: ScalarsEnums['EmailCopyEmployee']
  emailDefaultOn: ScalarsEnums['Boolean']
  emailEnabled: ScalarsEnums['Boolean']
  emailLockedByBrand: ScalarsEnums['Boolean']
  emailReplyToEmail?: Maybe<ScalarsEnums['String']>
  emailReplyToName?: Maybe<ScalarsEnums['String']>
  emailSendBefore?: Maybe<ScalarsEnums['Float']>
  emailSendBeforeUnit?: Maybe<ScalarsEnums['EmailSendBeforeUnit']>
  emailSendCalendarAttachment: ScalarsEnums['Boolean']
  emailSendEmailAs: ScalarsEnums['EmailSendAs']
  emailSendOnlyToActiveClients: ScalarsEnums['Boolean']
  emailSubject: ScalarsEnums['String']
  emailUseHapanaLayout?: Maybe<ScalarsEnums['Boolean']>
  pushLockedByBrand: ScalarsEnums['Boolean']
  pushNotificationDefaultOn: ScalarsEnums['Boolean']
  pushNotificationEnabled: ScalarsEnums['Boolean']
  pushNotificationMessage?: Maybe<ScalarsEnums['String']>
  pushNotificationTitle?: Maybe<ScalarsEnums['String']>
  readOnly: ScalarsEnums['Boolean']
  siteCommunicationTemplateId: ScalarsEnums['ID']
  siteId: ScalarsEnums['ID']
  smsDefaultOn: ScalarsEnums['Boolean']
  smsEnabled: ScalarsEnums['Boolean']
  smsLockedByBrand: ScalarsEnums['Boolean']
  smsMessage?: Maybe<ScalarsEnums['String']>
  targetedServiceTemplateIds?: Maybe<Array<ScalarsEnums['ID']>>
  updatedAt: ScalarsEnums['String']
}

export interface UpdateSiteCommunicationTemplateEmailStatus {
  __typename?: 'UpdateSiteCommunicationTemplateEmailStatus'
  alias: ScalarsEnums['CommunicationTemplateAliases']
  allowedPlaceholders: Array<ScalarsEnums['CommunicationTemplatePlaceholders']>
  createdAt: ScalarsEnums['String']
  emailBody: ScalarsEnums['String']
  emailCcEmail?: Maybe<ScalarsEnums['String']>
  emailCcLocation: ScalarsEnums['Boolean']
  emailCopyEmployee: ScalarsEnums['EmailCopyEmployee']
  emailDefaultOn: ScalarsEnums['Boolean']
  emailEnabled: ScalarsEnums['Boolean']
  emailLockedByBrand: ScalarsEnums['Boolean']
  emailReplyToEmail?: Maybe<ScalarsEnums['String']>
  emailReplyToName?: Maybe<ScalarsEnums['String']>
  emailSendBefore?: Maybe<ScalarsEnums['Float']>
  emailSendBeforeUnit?: Maybe<ScalarsEnums['EmailSendBeforeUnit']>
  emailSendCalendarAttachment: ScalarsEnums['Boolean']
  emailSendEmailAs: ScalarsEnums['EmailSendAs']
  emailSendOnlyToActiveClients: ScalarsEnums['Boolean']
  emailSubject: ScalarsEnums['String']
  emailUseHapanaLayout?: Maybe<ScalarsEnums['Boolean']>
  pushLockedByBrand: ScalarsEnums['Boolean']
  pushNotificationDefaultOn: ScalarsEnums['Boolean']
  pushNotificationEnabled: ScalarsEnums['Boolean']
  pushNotificationMessage?: Maybe<ScalarsEnums['String']>
  pushNotificationTitle?: Maybe<ScalarsEnums['String']>
  readOnly: ScalarsEnums['Boolean']
  siteCommunicationTemplateId: ScalarsEnums['ID']
  siteId: ScalarsEnums['ID']
  smsDefaultOn: ScalarsEnums['Boolean']
  smsEnabled: ScalarsEnums['Boolean']
  smsLockedByBrand: ScalarsEnums['Boolean']
  smsMessage?: Maybe<ScalarsEnums['String']>
  targetedServiceTemplateIds?: Maybe<Array<ScalarsEnums['ID']>>
  updatedAt: ScalarsEnums['String']
}

export interface UpdateSiteCommunicationTemplatePushNotificationStatus {
  __typename?: 'UpdateSiteCommunicationTemplatePushNotificationStatus'
  alias: ScalarsEnums['CommunicationTemplateAliases']
  allowedPlaceholders: Array<ScalarsEnums['CommunicationTemplatePlaceholders']>
  createdAt: ScalarsEnums['String']
  emailBody: ScalarsEnums['String']
  emailCcEmail?: Maybe<ScalarsEnums['String']>
  emailCcLocation: ScalarsEnums['Boolean']
  emailCopyEmployee: ScalarsEnums['EmailCopyEmployee']
  emailDefaultOn: ScalarsEnums['Boolean']
  emailEnabled: ScalarsEnums['Boolean']
  emailLockedByBrand: ScalarsEnums['Boolean']
  emailReplyToEmail?: Maybe<ScalarsEnums['String']>
  emailReplyToName?: Maybe<ScalarsEnums['String']>
  emailSendBefore?: Maybe<ScalarsEnums['Float']>
  emailSendBeforeUnit?: Maybe<ScalarsEnums['EmailSendBeforeUnit']>
  emailSendCalendarAttachment: ScalarsEnums['Boolean']
  emailSendEmailAs: ScalarsEnums['EmailSendAs']
  emailSendOnlyToActiveClients: ScalarsEnums['Boolean']
  emailSubject: ScalarsEnums['String']
  emailUseHapanaLayout?: Maybe<ScalarsEnums['Boolean']>
  pushLockedByBrand: ScalarsEnums['Boolean']
  pushNotificationDefaultOn: ScalarsEnums['Boolean']
  pushNotificationEnabled: ScalarsEnums['Boolean']
  pushNotificationMessage?: Maybe<ScalarsEnums['String']>
  pushNotificationTitle?: Maybe<ScalarsEnums['String']>
  readOnly: ScalarsEnums['Boolean']
  siteCommunicationTemplateId: ScalarsEnums['ID']
  siteId: ScalarsEnums['ID']
  smsDefaultOn: ScalarsEnums['Boolean']
  smsEnabled: ScalarsEnums['Boolean']
  smsLockedByBrand: ScalarsEnums['Boolean']
  smsMessage?: Maybe<ScalarsEnums['String']>
  targetedServiceTemplateIds?: Maybe<Array<ScalarsEnums['ID']>>
  updatedAt: ScalarsEnums['String']
}

export interface UpdateSiteCommunicationTemplateSmsStatus {
  __typename?: 'UpdateSiteCommunicationTemplateSmsStatus'
  alias: ScalarsEnums['CommunicationTemplateAliases']
  allowedPlaceholders: Array<ScalarsEnums['CommunicationTemplatePlaceholders']>
  createdAt: ScalarsEnums['String']
  emailBody: ScalarsEnums['String']
  emailCcEmail?: Maybe<ScalarsEnums['String']>
  emailCcLocation: ScalarsEnums['Boolean']
  emailCopyEmployee: ScalarsEnums['EmailCopyEmployee']
  emailDefaultOn: ScalarsEnums['Boolean']
  emailEnabled: ScalarsEnums['Boolean']
  emailLockedByBrand: ScalarsEnums['Boolean']
  emailReplyToEmail?: Maybe<ScalarsEnums['String']>
  emailReplyToName?: Maybe<ScalarsEnums['String']>
  emailSendBefore?: Maybe<ScalarsEnums['Float']>
  emailSendBeforeUnit?: Maybe<ScalarsEnums['EmailSendBeforeUnit']>
  emailSendCalendarAttachment: ScalarsEnums['Boolean']
  emailSendEmailAs: ScalarsEnums['EmailSendAs']
  emailSendOnlyToActiveClients: ScalarsEnums['Boolean']
  emailSubject: ScalarsEnums['String']
  emailUseHapanaLayout?: Maybe<ScalarsEnums['Boolean']>
  pushLockedByBrand: ScalarsEnums['Boolean']
  pushNotificationDefaultOn: ScalarsEnums['Boolean']
  pushNotificationEnabled: ScalarsEnums['Boolean']
  pushNotificationMessage?: Maybe<ScalarsEnums['String']>
  pushNotificationTitle?: Maybe<ScalarsEnums['String']>
  readOnly: ScalarsEnums['Boolean']
  siteCommunicationTemplateId: ScalarsEnums['ID']
  siteId: ScalarsEnums['ID']
  smsDefaultOn: ScalarsEnums['Boolean']
  smsEnabled: ScalarsEnums['Boolean']
  smsLockedByBrand: ScalarsEnums['Boolean']
  smsMessage?: Maybe<ScalarsEnums['String']>
  targetedServiceTemplateIds?: Maybe<Array<ScalarsEnums['ID']>>
  updatedAt: ScalarsEnums['String']
}

export interface UpdateSiteSettingsAccountBilling {
  __typename?: 'UpdateSiteSettingsAccountBilling'
  addressCity?: Maybe<ScalarsEnums['String']>
  addressCountry?: Maybe<ScalarsEnums['String']>
  addressPostalCode?: Maybe<ScalarsEnums['String']>
  addressState?: Maybe<ScalarsEnums['String']>
  addressStreet?: Maybe<ScalarsEnums['String']>
  addressStreet2?: Maybe<ScalarsEnums['String']>
  adminConfigurations?: Maybe<SiteAdminConfigurations>
  appName?: Maybe<ScalarsEnums['String']>
  businessEmail?: Maybe<ScalarsEnums['String']>
  businessHours?: Maybe<SiteBusinessHours>
  capacity?: Maybe<ScalarsEnums['Float']>
  clientFeesTemplateId?: Maybe<ScalarsEnums['String']>
  connectedSharedSiteIds?: Maybe<Array<ScalarsEnums['String']>>
  corePlanLevel?: Maybe<ScalarsEnums['CorePlanLevel']>
  countryId?: Maybe<ScalarsEnums['ID']>
  createdAt: ScalarsEnums['String']
  customIntegrations?: Maybe<Array<SiteCustomIntegrations>>
  deletedAt?: Maybe<ScalarsEnums['String']>
  description?: Maybe<ScalarsEnums['String']>
  displayBusinessHours: ScalarsEnums['Boolean']
  email?: Maybe<ScalarsEnums['String']>
  gatewayCurrentPaymentMethodId?: Maybe<ScalarsEnums['String']>
  gatewayCustomerId?: Maybe<ScalarsEnums['String']>
  hapanaFeesTemplateId?: Maybe<ScalarsEnums['ID']>
  integrations?: Maybe<UpdateSiteSettingsAccountBillingIntegrations>
  isDigital?: Maybe<ScalarsEnums['Boolean']>
  logoImage?: Maybe<ImageFileConfigField>
  membersCount?: Maybe<ScalarsEnums['Float']>
  name: ScalarsEnums['String']
  openDate?: Maybe<ScalarsEnums['String']>
  phone?: Maybe<ScalarsEnums['String']>
  phonePrefix?: Maybe<ScalarsEnums['String']>
  planOverrideAllowed?: Maybe<ScalarsEnums['Boolean']>
  planTierOverride?: Maybe<ScalarsEnums['ProductPlanTier']>
  rebateTemplateIds?: Maybe<Array<ScalarsEnums['ID']>>
  regionId?: Maybe<ScalarsEnums['ID']>
  royaltiesTemplateId?: Maybe<ScalarsEnums['ID']>
  settings?: Maybe<SiteSettings>
  siteId: ScalarsEnums['ID']
  stateId?: Maybe<ScalarsEnums['String']>
  status: ScalarsEnums['SiteStatus']
  timezone?: Maybe<ScalarsEnums['String']>
  updatedAt: ScalarsEnums['String']
  v1EncryptedId?: Maybe<ScalarsEnums['String']>
  website?: Maybe<ScalarsEnums['String']>
  workshopType?: Maybe<ScalarsEnums['SiteWorkshopType']>
}

export interface UpdateSiteSettingsAccountBillingIntegrations {
  __typename?: 'UpdateSiteSettingsAccountBillingIntegrations'
  accessControls?: Maybe<SiteIntegrationsAccessControls>
  accuroFit?: Maybe<SiteIntegrationsAccuroFit>
  barcodeUrl?: Maybe<SiteIntegrationsBarcodeUrl>
  calendarSync?: Maybe<SiteIntegrationsCalendarSync>
  classPass?: Maybe<SiteIntegrationsClassPass>
  egym?: Maybe<SiteIntegrationsEgym>
  externalFeedbackLink?: Maybe<SiteIntegrationsExternalFeedbackLink>
  facebookPixel?: Maybe<SiteIntegrationsFacebookPixel>
  fitnessPassport?: Maybe<SiteIntegrationsFitnessPassport>
  frontDeskKiosk?: Maybe<SiteIntegrationsFrontDeskKiosk>
  googleTagManager?: Maybe<SiteIntegrationsGoogleTagManager>
  grow?: Maybe<SiteIntegrationsGrow>
  /**
   * WIP: This schema needs to be revisited based on final implementation requirements
   */
  hapanaAccessController?: Maybe<SiteIntegrationsHapanaAccessController>
  hapanaApiKey?: Maybe<SiteIntegrationsHapanaApiKey>
  importClients?: Maybe<SiteIntegrationsImportClients>
  spivi?: Maybe<SiteIntegrationsSpivi>
  tanning?: Maybe<SiteIntegrationsTanning>
  tanningHealth?: Maybe<SiteIntegrationsTanningHealth>
  topaz?: Maybe<SiteIntegrationsTopaz>
  wellhub?: Maybe<SiteIntegrationsWellhub>
  zapier?: Maybe<SiteIntegrationsZapier>
  zoom?: Maybe<UpdateSiteSettingsAccountBillingIntegrationsZoom>
}

export interface UpdateSiteSettingsAccountBillingIntegrationsZoom {
  __typename?: 'UpdateSiteSettingsAccountBillingIntegrationsZoom'
  accountId?: Maybe<ScalarsEnums['String']>
  authentication?: Maybe<UpdateSiteSettingsAccountBillingIntegrationsZoomAuthentication>
  authorized: ScalarsEnums['Boolean']
  connectedAt?: Maybe<ScalarsEnums['String']>
  connectedUserEmail?: Maybe<ScalarsEnums['String']>
  connectedUserId?: Maybe<ScalarsEnums['String']>
  userId?: Maybe<ScalarsEnums['String']>
}

export interface UpdateSiteSettingsAccountBillingIntegrationsZoomAuthentication {
  __typename?: 'UpdateSiteSettingsAccountBillingIntegrationsZoomAuthentication'
  accessToken: ScalarsEnums['String']
  expiresAt: ScalarsEnums['String']
  refreshToken: ScalarsEnums['String']
}

/**
 * Response indicating success of site supplier update
 */
export interface UpdateSiteSupplierResponse {
  __typename?: 'UpdateSiteSupplierResponse'
  success: ScalarsEnums['Boolean']
}

/**
 * Response for updating a SOAP note
 */
export interface UpdateSoapNoteResponse {
  __typename?: 'UpdateSoapNoteResponse'
  message?: Maybe<ScalarsEnums['String']>
  note?: Maybe<SoapNote>
  success: ScalarsEnums['Boolean']
}

export interface UploadCustomFont {
  __typename?: 'UploadCustomFont'
  font: MemberExperienceFontsCustomFonts
  fontUrl: ScalarsEnums['String']
  success: ScalarsEnums['Boolean']
}

export interface UpsertBrandStoreAsset {
  __typename?: 'UpsertBrandStoreAsset'
  assetId: ScalarsEnums['String']
  assetType: ScalarsEnums['BrandStoreAssetType']
  brandId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  deviceClass?: Maybe<ScalarsEnums['String']>
  filename: ScalarsEnums['String']
  gcsPath: ScalarsEnums['String']
  height?: Maybe<ScalarsEnums['Float']>
  locale: ScalarsEnums['String']
  platform: ScalarsEnums['BrandPlatform']
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['String']>
  validationError?: Maybe<ScalarsEnums['String']>
  validationStatus: ScalarsEnums['BrandStoreAssetStatus']
  width?: Maybe<ScalarsEnums['Float']>
}

export interface UpsertBrandStoreListing {
  __typename?: 'UpsertBrandStoreListing'
  appName?: Maybe<ScalarsEnums['String']>
  brandId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  description?: Maybe<ScalarsEnums['String']>
  keywords?: Maybe<ScalarsEnums['String']>
  locale: ScalarsEnums['String']
  marketingUrl?: Maybe<ScalarsEnums['String']>
  platform: ScalarsEnums['BrandPlatform']
  privacyPolicyUrl?: Maybe<ScalarsEnums['String']>
  releaseNotes?: Maybe<ScalarsEnums['String']>
  shortDescription?: Maybe<ScalarsEnums['String']>
  subtitle?: Maybe<ScalarsEnums['String']>
  supportUrl?: Maybe<ScalarsEnums['String']>
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['String']>
}

export interface UpsertBrandStoreTester {
  __typename?: 'UpsertBrandStoreTester'
  brandId: ScalarsEnums['String']
  createdAt: ScalarsEnums['String']
  email: ScalarsEnums['String']
  name?: Maybe<ScalarsEnums['String']>
  platforms: Array<ScalarsEnums['BrandPlatform']>
  source: ScalarsEnums['BrandStoreTesterSource']
  testerId: ScalarsEnums['String']
  updatedAt: ScalarsEnums['String']
  updatedBy?: Maybe<ScalarsEnums['String']>
}

export interface ValidateGiftCardResult {
  __typename?: 'ValidateGiftCardResult'
  balance: ScalarsEnums['String']
  expiresAt?: Maybe<ScalarsEnums['String']>
  isValid: ScalarsEnums['Boolean']
  message?: Maybe<ScalarsEnums['String']>
  reason?: Maybe<ScalarsEnums['GiftCardValidationReason']>
}

export interface ValidatePromoCode {
  __typename?: 'ValidatePromoCode'
  isValid: ScalarsEnums['Boolean']
  promoCode?: Maybe<PromoCode>
  reason?: Maybe<ScalarsEnums['String']>
}

export interface VerifySessionResponse {
  __typename?: 'VerifySessionResponse'
  corporateId: ScalarsEnums['String']
  planId: ScalarsEnums['String']
  status: ScalarsEnums['String']
}

export interface VertexImportStats {
  __typename?: 'VertexImportStats'
  documentsImported: ScalarsEnums['Int']
  success: ScalarsEnums['Boolean']
}

/**
 * Detailed analytics for a single video
 */
export interface VideoAnalytics {
  __typename?: 'VideoAnalytics'
  androidViews: ScalarsEnums['Float']
  avgCompletionPercent: ScalarsEnums['Float']
  avgWatchTimeSeconds: ScalarsEnums['Float']
  completedPast75Pct: ScalarsEnums['Float']
  completionRate: ScalarsEnums['Float']
  completions: ScalarsEnums['Float']
  droppedBefore25Pct: ScalarsEnums['Float']
  droppedBefore50Pct: ScalarsEnums['Float']
  droppedBefore75Pct: ScalarsEnums['Float']
  iosViews: ScalarsEnums['Float']
  totalViews: ScalarsEnums['Float']
  totalWatchTimeSeconds: ScalarsEnums['Float']
  uniqueViewers: ScalarsEnums['Float']
  webViews: ScalarsEnums['Float']
}

/**
 * Video engagement for a single time period
 */
export interface VideoEngagementTrendPoint {
  __typename?: 'VideoEngagementTrendPoint'
  avgWatchTimeSeconds: ScalarsEnums['Float']
  completions: ScalarsEnums['Float']
  periodStart: ScalarsEnums['String']
  totalViews: ScalarsEnums['Float']
  uniqueViewers: ScalarsEnums['Float']
}

export interface VideoQualityUrl {
  __typename?: 'VideoQualityUrl'
  quality: ScalarsEnums['String']
  url: ScalarsEnums['String']
}

export interface VideoStatus {
  __typename?: 'VideoStatus'
  error?: Maybe<ScalarsEnums['String']>
  originalDuration?: Maybe<ScalarsEnums['Float']>
  originalFileName: ScalarsEnums['String']
  originalFileSize: ScalarsEnums['Int']
  /**
   * Direct GCS URL for immediate playback before transcoding completes
   */
  rawVideoUrl?: Maybe<ScalarsEnums['String']>
  streamingUrl?: Maybe<ScalarsEnums['String']>
  thumbnailUrl?: Maybe<ScalarsEnums['String']>
  transcodingStatus?: Maybe<ScalarsEnums['VideoTranscodingStatus']>
  uploadProgress?: Maybe<ScalarsEnums['Float']>
  uploadStatus: ScalarsEnums['VideoUploadStatus']
  videoId: ScalarsEnums['ID']
}

export interface VideoStreamingUrls {
  __typename?: 'VideoStreamingUrls'
  duration: ScalarsEnums['Float']
  expiresAt: ScalarsEnums['String']
  hlsUrl: ScalarsEnums['String']
  mp4Urls: Array<VideoQualityUrl>
  thumbnailUrl: ScalarsEnums['String']
  videoId: ScalarsEnums['ID']
}

export interface VideoUploadSession {
  __typename?: 'VideoUploadSession'
  expiresAt: ScalarsEnums['String']
  uploadSessionUri: ScalarsEnums['String']
  videoId: ScalarsEnums['ID']
}

/**
 * A virtual invoice representing a future occurrence of a recurring invoice
 */
export interface VirtualInvoice {
  __typename?: 'VirtualInvoice'
  amount: ScalarsEnums['Numeric']
  clientId: ScalarsEnums['ID']
  currency: ScalarsEnums['String']
  invoiceDate: ScalarsEnums['String']
  invoiceId?: Maybe<ScalarsEnums['ID']>
  isPendingActivation?: Maybe<ScalarsEnums['Boolean']>
  isVirtual: ScalarsEnums['Boolean']
  pendingChange?: Maybe<PendingChange>
  recurringInvoiceId: ScalarsEnums['ID']
  sequenceNumber: ScalarsEnums['Float']
  siteId: ScalarsEnums['String']
  type: ScalarsEnums['RecurringInvoiceType']
}

export interface VisitForecastBar {
  __typename?: 'VisitForecastBar'
  hour: ScalarsEnums['Int']
  level: ScalarsEnums['Int']
}

export interface VisitForecastDay {
  __typename?: 'VisitForecastDay'
  bars: Array<VisitForecastBar>
  dayOfWeek: ScalarsEnums['Int']
  isClosed: ScalarsEnums['Boolean']
  windowEnd?: Maybe<ScalarsEnums['Int']>
  windowStart?: Maybe<ScalarsEnums['Int']>
}

export interface VoidPolicyImportResult {
  __typename?: 'VoidPolicyImportResult'
  batchId: ScalarsEnums['ID']
  voidedAgreements: ScalarsEnums['Float']
}

/**
 * Day with visible sessions (full) and overflow sessions (minimal) for week view
 */
export interface WeekViewDay {
  __typename?: 'WeekViewDay'
  date: ScalarsEnums['String']
  overflowSessions: Array<WeekViewOverflowSession>
  sessions: Array<CalendarSession>
  totalCount: ScalarsEnums['Float']
}

/**
 * Minimal session data for week view overflow display
 */
export interface WeekViewOverflowSession {
  __typename?: 'WeekViewOverflowSession'
  bookedCount?: Maybe<ScalarsEnums['Float']>
  color?: Maybe<ScalarsEnums['String']>
  endTime: ScalarsEnums['String']
  isBlockSlot: ScalarsEnums['Boolean']
  name: ScalarsEnums['String']
  sessionId: ScalarsEnums['String']
  size: ScalarsEnums['Float']
  startTime: ScalarsEnums['String']
  status?: Maybe<ScalarsEnums['SessionStatus']>
  waitlistEnabled: ScalarsEnums['Boolean']
}

/**
 * What the comparison covered, so an empty findings list can be read as coverage
 */
export interface WellhubDivergenceCounts {
  __typename?: 'WellhubDivergenceCounts'
  /**
   * Sessions whose capacity was not compared because the provider holds a spot limit. Reported so a clean run is not mistaken for a complete one
   */
  capacityUnchecked: ScalarsEnums['Int']
  /**
   * Product mappings compared for this site
   */
  mappings: ScalarsEnums['Int']
  /**
   * Hapana sessions inside the window
   */
  sessions: ScalarsEnums['Int']
  /**
   * Wellhub classes carrying no reference, or one this site does not own. Never a finding: classes cannot be deleted, so probes and other systems leave them on the gym forever
   */
  unreferencedClasses: ScalarsEnums['Int']
  /**
   * Distinct Wellhub slots listed inside the window
   */
  wellhubSlots: ScalarsEnums['Int']
}

/**
 * One disagreement between the Hapana schedule and the Wellhub catalog
 */
export interface WellhubDivergenceFinding {
  __typename?: 'WellhubDivergenceFinding'
  /**
   * The disagreement stated in full, with both sides of the numbers
   */
  detail: ScalarsEnums['String']
  /**
   * What kind of disagreement this is
   */
  kind: ScalarsEnums['WellhubDivergenceKind']
  /**
   * The action an operator takes to resolve it. Never applied automatically; some remedies delete a Wellhub slot, which cancels and notifies every member holding it
   */
  remedy: ScalarsEnums['String']
  /**
   * What the finding is about: a session id, a session type id, or a Wellhub slot id
   */
  subject: ScalarsEnums['String']
}

/**
 * Where the Hapana schedule and the Wellhub catalog disagree for one site, inside the site materialization window (INT-141 slice 5)
 */
export interface WellhubDivergenceReport {
  __typename?: 'WellhubDivergenceReport'
  counts: WellhubDivergenceCounts
  /**
   * Every disagreement found. Empty means the two sides agree across the window
   */
  findings: Array<WellhubDivergenceFinding>
  /**
   * The Wellhub gym id the site is mapped to
   */
  gymId: ScalarsEnums['String']
  /**
   * Whether the Wellhub venue mapping is switched on. The report runs either way, because its main use is before a cutover
   */
  isConnectionEnabled: ScalarsEnums['Boolean']
  /**
   * The Hapana site the report was run for
   */
  siteId: ScalarsEnums['String']
  /**
   * End of the compared window, exclusive, ISO 8601 UTC
   */
  windowEnd: ScalarsEnums['String']
  /**
   * Start of the compared window, ISO 8601 UTC. The site materialization window
   */
  windowStart: ScalarsEnums['String']
}

/**
 * A Wellhub commercial product available for session-type mapping
 */
export interface WellhubProductEntry {
  __typename?: 'WellhubProductEntry'
  name?: Maybe<ScalarsEnums['String']>
  productId: ScalarsEnums['String']
}

/**
 * Wellhub product mapped to a Hapana site session type
 */
export interface WellhubProductMapping {
  __typename?: 'WellhubProductMapping'
  externalClassId?: Maybe<ScalarsEnums['String']>
  externalProductId: ScalarsEnums['String']
  siteSessionTypeId: ScalarsEnums['String']
}

/**
 * Sessions of one session type that Wellhub publishing affects
 */
export interface WellhubSessionTypePublishCounts {
  __typename?: 'WellhubSessionTypePublishCounts'
  publishableCount: ScalarsEnums['Float']
  publishedCount: ScalarsEnums['Float']
  siteSessionTypeId: ScalarsEnums['String']
}

export interface ZapierStatus {
  __typename?: 'ZapierStatus'
  connected: ScalarsEnums['Boolean']
  subscriptions: Array<ScalarsEnums['String']>
}

export interface Zone {
  __typename?: 'Zone'
  /**
   * State/Province code (e.g., CA, NY, QC) - can be full name for some countries
   */
  code: ScalarsEnums['String']
  countryId: ScalarsEnums['ID']
  createdAt: ScalarsEnums['String']
  name: ScalarsEnums['String']
  /**
   * IANA timezone (e.g., America/New_York)
   */
  timezone?: Maybe<ScalarsEnums['String']>
  updatedAt: ScalarsEnums['String']
  zoneId: ScalarsEnums['ID']
}

export interface Zones {
  __typename?: 'Zones'
  pageInfo: ZonesPageInfo
  results: Array<ZonesResults>
}

export interface ZonesPageInfo {
  __typename?: 'ZonesPageInfo'
  endCursor?: Maybe<ScalarsEnums['String']>
  hasNextPage: ScalarsEnums['Boolean']
  startCursor?: Maybe<ScalarsEnums['String']>
  totalRecords: ScalarsEnums['Int']
}

export interface ZonesResults {
  __typename?: 'ZonesResults'
  cursor: ScalarsEnums['String']
  row: Zone
}

/**
 * A Zoom user on the connected Zoom account
 */
export interface ZoomAccountUser {
  __typename?: 'ZoomAccountUser'
  displayName: ScalarsEnums['String']
  email: ScalarsEnums['String']
  id: ScalarsEnums['String']
}

/**
 * Zoom integration connection status for a site
 */
export interface ZoomConnectionStatus {
  __typename?: 'ZoomConnectionStatus'
  authorized: ScalarsEnums['Boolean']
  connectedAt?: Maybe<ScalarsEnums['String']>
  connectedUserEmail?: Maybe<ScalarsEnums['String']>
  userId?: Maybe<ScalarsEnums['String']>
}

export interface Mutation {
  __typename?: 'Mutation'
  /**
   * Cancel the caller's own unpaid PENDING booking after its checkout failed. Always CANCELLED, never LATE_CANCELLED, and refused once any payment on the booking succeeded or is still processing.
   */
  abandonCheckoutBooking: (args: { id: ScalarsEnums['ID'] }) => Booking
  /**
   * Accept a buddy invite (PENDING → ACTIVE) or link via a share-link invite token — atomic
   */
  acceptBookingBuddy: (args: {
    buddyClientId: ScalarsEnums['ID']
    clientId: ScalarsEnums['ID']
    inviteToken?: Maybe<ScalarsEnums['String']>
    siteId?: Maybe<ScalarsEnums['ID']>
  }) => BookingBuddyMutationResult
  /**
   * Accept a family invitation addressed to the signed-in member, or join through an invite link, which binds to the first member who accepts it
   */
  acceptFamilyInvite: (args: {
    inviteToken: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => Family
  /**
   * Accept one incoming movement (OC-1461) — starts that member’s transfer immediately. Site-scoped to the destination; corporate + per-site guards live in IncomingApprovalService. With the location posture flag on, destinationServiceTemplateId chooses the membership first (needs member_movement__manage_incoming).
   */
  acceptIncomingMovement: (args: {
    input: IncomingApprovalDecisionInput
  }) => IncomingApprovalDecisionResult
  /**
   * Accept a staff invitation using the token from the email link
   */
  acceptInvitation: (args: {
    firstName: ScalarsEnums['String']
    lastName: ScalarsEnums['String']
    password: ScalarsEnums['String']
    token: ScalarsEnums['String']
  }) => AcceptInvitation
  /**
   * Accept the signed-in member's own checkbox policies natively; signatures and guardian slots are refused and need the hosted page
   */
  acceptMyPolicies: (args: {
    clientId: ScalarsEnums['ID']
    items: Array<AcceptMyPolicyItemInput>
    siteId: ScalarsEnums['ID']
  }) => AcceptMyPoliciesResult
  /**
   * Accept site policies for a client (creates ACTIVE agreements with ELECTRONIC method)
   */
  acceptPolicies: (args: {
    clientId: ScalarsEnums['ID']
    policyIds: Array<ScalarsEnums['String']>
    siteId: ScalarsEnums['ID']
  }) => AcceptPolicies
  /**
   * Accept an invite to share a credit-based package (recipient)
   */
  acceptSharedCredits: (args: {
    input: AcceptSharedCreditsInput
  }) => ServiceCreditShareMutationResult
  /**
   * Accept one or more SitePolicies for the client (self-scoped for member tokens); refused with POLICY_VERSION_CHANGED when a displayed revision is no longer the one in force
   */
  acceptSitePolicies: (args: {
    clientId: ScalarsEnums['ID']
    displayedRevisions?: Maybe<Array<DisplayedPolicyRevisionInput>>
    policyIds: Array<ScalarsEnums['ID']>
    siteId: ScalarsEnums['ID']
  }) => AcceptSitePolicies
  /**
   * Acknowledge that a font deployment has been completed for a platform
   */
  acknowledgeFontDeployment: (args: {
    corporateId: ScalarsEnums['String']
    fontVersion: ScalarsEnums['Float']
    platform: MobileAppPlatform
  }) => AcknowledgeFontDeployment
  /**
   * Activate a signed PENDING agreement (PENDING → ACTIVE). Called after successful checkout to make the agreement visible.
   */
  activateAgreement: (args: {
    agreementId: ScalarsEnums['ID']
    clientId: ScalarsEnums['ID']
    signedSource?: Maybe<AgreementSignedSource>
    siteId: ScalarsEnums['ID']
  }) => ClientAgreement
  /**
   * Activate commissions from a date: settings, first period and schedulers
   */
  activateCommissions: (args: {
    activationDate: ScalarsEnums['String']
  }) => CommissionActivationResult
  /**
   * Activate an archived gift card template
   */
  activateGiftCardTemplate: (args: { giftCardTemplateId: ScalarsEnums['ID'] }) => GiftCardTemplate
  /**
   * Transition leaderboard from DRAFT/ARCHIVED to ACTIVE
   */
  activateLeaderboard: (args: { leaderboardConfigId: ScalarsEnums['String'] }) => LeaderboardConfig
  /**
   * Activate an archived promo code
   */
  activatePromoCode: (args: { promoCodeId: ScalarsEnums['ID'] }) => PromoCode
  /**
   * Activate a service template (set status to ACTIVE)
   */
  activateServiceTemplate: (args: { serviceTemplateId: ScalarsEnums['String'] }) => ServiceTemplate
  /**
   * Activate an accounting code (make it selectable again)
   */
  activateSiteAccountCode: (args: {
    accountCodeId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => SiteAccountCode
  /**
   * Activate a new theme subscription for a corporate. A Hapana admin may do this for any brand; a brand admin holding write_controls may do it for their own (OC-320 self service).
   */
  activateThemeSubscription: (args: {
    billingCycleAmount?: Maybe<ScalarsEnums['Float']>
    corporateId: ScalarsEnums['ID']
    currency?: Maybe<ScalarsEnums['String']>
    metadata?: Maybe<ScalarsEnums['JSONObject']>
    themeSlug: ScalarsEnums['String']
  }) => CorporateThemeSubscription
  /**
   * Add an access rule to a staff user
   */
  addAccessRule: (args: {
    input: AddAccessRuleInputInput
    staffUserId: ScalarsEnums['ID']
  }) => StaffAccessRule
  /**
   * Add a relation to an existing counterparty client
   */
  addClientRelation: (args: {
    clientId: ScalarsEnums['ID']
    counterpartyClientId: ScalarsEnums['ID']
    relationshipSubtype?: Maybe<ClientFamilyRelationship>
    siteId: ScalarsEnums['ID']
    status?: Maybe<ClientRelationStatus>
    type: ClientRelationType
  }) => ClientRelationMutationResult
  /**
   * Add a client to the waiting queue for an equipment unit
   */
  addClientToEquipmentQueue: (args: {
    clientId: ScalarsEnums['String']
    equipmentId: ScalarsEnums['String']
    isOverride?: Maybe<ScalarsEnums['Boolean']>
    owedBalanceOverride?: Maybe<OwedBalanceOverrideInput>
    regulationOverrides?: Maybe<Array<TanningRegulationOverrideInput>>
    siteSessionTypeId?: Maybe<ScalarsEnums['String']>
  }) => Equipment
  /**
   * Add a client to a site
   */
  addClientToSite: (args: {
    clientId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
    siteSpecificData?: Maybe<AddClientToSiteSiteSpecificDataInput>
  }) => AddClientToSiteResponse
  /**
   * Add a manual commission adjustment with a reason to an open period
   */
  addCommissionAdjustment: (args: {
    adjustmentId: ScalarsEnums['ID']
    amount: ScalarsEnums['String']
    category?: Maybe<CommissionCategory>
    commissionPeriodId: ScalarsEnums['ID']
    reason: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
    staffUserId: ScalarsEnums['ID']
  }) => CommissionLine
  /**
   * Add an alert to a custom property
   */
  addCustomPropertyAlert: (args: {
    input: CustomPropertyAlertCreateInput
    propertyId: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => AddCustomPropertyAlert
  /**
   * Staff and API callers add an existing client straight into a family as an admin or a dependent; members invite by link and are refused
   */
  addFamilyMember: (args: {
    canBook: ScalarsEnums['Boolean']
    clientId: ScalarsEnums['ID']
    familyId?: Maybe<ScalarsEnums['ID']>
    role: FamilyMemberRole
    siteId: ScalarsEnums['ID']
  }) => Family
  /**
   * Add instructor to client favorites at specific site
   */
  addFavoriteInstructor: (args: {
    clientId: ScalarsEnums['String']
    instructorId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => ScalarsEnums['Boolean']
  /**
   * Add site to client favorites
   */
  addFavoriteSite: (args: {
    clientId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => ScalarsEnums['Boolean']
  addKnowledgeArticleTranslation: (args: {
    input: KnowledgeArticleTranslationInput
    knowledgeArticleId: ScalarsEnums['ID']
  }) => KnowledgeArticleTranslation
  addKnowledgeDocument: (args: { input: KnowledgeDocumentInput }) => KnowledgeDocument
  /**
   * Add a manual scheduled payment to a recurring invoice. Returns the created invoice ID.
   */
  addManualScheduledPayment: (args: {
    amount: ScalarsEnums['String']
    invoiceDate: ScalarsEnums['String']
    recurringInvoiceId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => ScalarsEnums['ID']
  /**
   * Add a manual (retrospective) time-clock entry, creating a closed shift.
   */
  addManualTimeClockEntry: (args: {
    clockInTime: ScalarsEnums['String']
    clockOutTime: ScalarsEnums['String']
    notes?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['ID']
    staffUserId: ScalarsEnums['ID']
  }) => PayrollTimeClock
  /**
   * Record a referral and award account credits to the referred client (creditsToNewClient)
   */
  addReferral: (args: {
    receiverId: ScalarsEnums['String']
    referralId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => AddReferral
  /**
   * Award account credits to the referrer after the referred client completes a qualifying action (creditsExistingClient)
   */
  addReferralBonus: (args: {
    receiverId: ScalarsEnums['String']
    referralId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => AddReferralBonus
  addReleaseNoteTranslation: (args: {
    input: ReleaseNoteTranslationInput
    releaseNoteId: ScalarsEnums['ID']
  }) => ReleaseNoteTranslation
  /**
   * Add a session feedback question
   */
  addSessionFeedbackQuestion: (args: {
    input: SessionFeedbackQuestionCreateInput
    siteId: ScalarsEnums['ID']
  }) => SessionFeedbackQuestion
  /**
   * Share a credit-based package with a recipient (staff), allocating credits
   */
  addSharedCreditRecipient: (args: {
    input: ServiceCreditShareAddRecipientInput
  }) => ServiceCreditShareMutationResult
  /**
   * Add a question to a site form
   */
  addSiteFormQuestion: (args: {
    input: SiteFormQuestionCreateInput
    siteFormId: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => SiteFormQuestionOrderResponse
  /**
   * Add new pricing tier to an SMS package
   */
  addSmsPackageOption: (args: {
    input: AddSmsPackageOptionInputInput
    smsPackageId: ScalarsEnums['ID']
  }) => SmsPackage
  /**
   * Add a staff user to a session template
   */
  addStaffUserToSessionTemplate: (args: {
    id: ScalarsEnums['String']
    input: SessionTemplateStaffUserInput
    siteId: ScalarsEnums['String']
  }) => SessionTemplate
  addSupportMessage: (args: { input: AddSupportMessageInput }) => SupportChatMessage
  /**
   * Add a client to a session waitlist
   */
  addToWaitlist: (args: {
    clientId: ScalarsEnums['String']
    forFamilyMember?: Maybe<ScalarsEnums['Boolean']>
    guestServiceId?: Maybe<ScalarsEnums['ID']>
    sessionId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => SessionWaitlistEntry
  /**
   * Add or remove lamp hours on a bed lamp set, with a reason
   */
  adjustEquipmentLampHours: (args: { input: AdjustEquipmentLampHoursInput }) => EquipmentLampLog
  /**
   * Adjust the expiry date for a package service. Updates Service.expiresAt and all non-MANUAL credit allocation expiry dates.
   */
  adjustPackageExpiry: (args: {
    expiresAtDate: ScalarsEnums['String']
    serviceId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => ScalarsEnums['Boolean']
  /**
   * Adjust stock for a product variant (increase or decrease)
   */
  adjustPosStock: (args: {
    input: AdjustStockInput
    posProductId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => AdjustStockResponse
  /**
   * Manually adjust credits for a service. Returns the ledger entry ID.
   */
  adjustServiceCredits: (args: { input: AdjustCreditsInput }) => ScalarsEnums['String']
  /**
   * Insert the SiteIndex rows missing for this corporate (isV2Enabled=false, no gateway ids), then re-check
   */
  adminBackfillSiteIndex: (args: {
    corporateId: ScalarsEnums['ID']
  }) => Array<ScalarsEnums['String']>
  /**
   * Bulk set sites rebate templates
   */
  adminBulkSetSitesAdminConfigurationsFeesBrandRebatesTemplates: (args: {
    rebateTemplateIds: Array<ScalarsEnums['String']>
    siteIds: Array<ScalarsEnums['String']>
  }) => BulkUpdateSites
  /**
   * Bulk set sites royalties and fees template
   */
  adminBulkSetSitesAdminConfigurationsFeesRoyaltiesAndFeesTemplate: (args: {
    royaltiesAndFeesTemplateId: ScalarsEnums['String']
    siteIds: Array<ScalarsEnums['String']>
  }) => BulkUpdateSites
  /**
   * Duplicate a location: replicates Admin + Core settings from the source site with the selected country/state/currency. The new site is created inactive with go-live flags off. Excludes clients, team, sessions/bookings, payments, integrations, media.
   */
  adminCloneSite: (args: {
    countryId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
    zoneId: ScalarsEnums['ID']
  }) => Site
  /**
   * Create a new corporate webhook (admin)
   */
  adminCreateCorporateWebhook: (args: {
    corporateId: ScalarsEnums['ID']
    input: CreateCorporateWebhookInputInput
  }) => CorporateWebhook
  /**
   * Delete a corporate webhook (admin)
   */
  adminDeleteCorporateWebhook: (args: {
    corporateId: ScalarsEnums['ID']
    webhookId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Duplicate a V2 site of this brand into a new, inactive site. Queues the copy and returns the job to poll; a repeat with the same idempotencyKey returns the same job.
   */
  adminDuplicateSite: (args: { input: SiteDuplicateInput }) => SiteCloneJob
  /**
   * Generate or rotate the per-corporate public content API key (embed widget)
   */
  adminGenerateCorporateContentApiKey: (args: { corporateId: ScalarsEnums['String'] }) => Corporate
  /**
   * Link a Hapana Push app to the corporate: push keys, push provider and the mobile app profile in one operation
   */
  adminLinkCorporatePushApp: (args: {
    corporateId: ScalarsEnums['String']
    corporateInput: LinkCorporatePushAppInput
  }) => Corporate
  /**
   * Backfill Stripe Customer and PaymentMethod metadata for a site, then verify
   */
  adminRunStripeMetadataBackfill: (args: {
    siteId: ScalarsEnums['String']
  }) => Array<ScalarsEnums['String']>
  /**
   * Set brand rebates templates for a site
   */
  adminSetSiteAdminConfigurationsFeesBrandRebatesTemplates: (args: {
    rebateTemplateIds: Array<ScalarsEnums['String']>
    siteId: ScalarsEnums['String']
  }) => Site
  /**
   * Set client fees template for a site
   */
  adminSetSiteAdminConfigurationsFeesClientFeesTemplate: (args: {
    id: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Site
  /**
   * Set hapana fees template for a site
   */
  adminSetSiteAdminConfigurationsFeesHapanaFeesTemplate: (args: {
    id: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Site
  /**
   * Set royalties and fees template for a site
   */
  adminSetSiteAdminConfigurationsFeesRoyaltiesAndFeesTemplate: (args: {
    royaltiesAndFeesTemplateId?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['String']
  }) => Site
  /**
   * Set connected shared sites for package reciprocity
   */
  adminSetSiteConnectedSharedSites: (args: {
    siteId: ScalarsEnums['ID']
    siteIds: Array<ScalarsEnums['String']>
  }) => Site
  /**
   * Enable or disable Grow sync for a single site (gates event-driven syncs)
   */
  adminSetSiteGrowEnabled: (args: {
    enabled: ScalarsEnums['Boolean']
    siteId: ScalarsEnums['String']
  }) => SetSiteGrowEnabledResponse
  /**
   * Clear Grow authentication for a site, freeing the GHL location for reassignment
   */
  adminSiteIntegrationsGrowClearAuthentication: (args: {
    id: ScalarsEnums['String']
  }) => SetSiteAuthenticationResponse
  /**
   * Set OAuth authentication for a site
   */
  adminSiteIntegrationsGrowSetAuthentication: (args: {
    code: ScalarsEnums['String']
    id: ScalarsEnums['String']
  }) => SetSiteAuthenticationResponse
  /**
   * Index the merchant id, register the site's V2 Ezypay webhook subscription, delete the V1 ones, then verify
   */
  adminSwitchEzypayWebhooksToV2: (args: {
    recreate: ScalarsEnums['Boolean']
    siteId: ScalarsEnums['ID']
  }) => Array<ScalarsEnums['String']>
  /**
   * Enable or disable an aggregator provider for all sites in a corporate (admin)
   */
  adminUpdateCorporateAggregatorIntegration: (args: {
    aggregatorProviderId: ScalarsEnums['String']
    corporateId: ScalarsEnums['String']
    enabled: ScalarsEnums['Boolean']
  }) => AdminUpdateCorporateAggregatorIntegration
  /**
   * Update which sites are enabled for a specific aggregator provider in a corporate
   */
  adminUpdateCorporateAggregatorProviderSites: (args: {
    aggregatorProviderId: ScalarsEnums['String']
    corporateId: ScalarsEnums['String']
    siteIds: Array<ScalarsEnums['String']>
  }) => AdminUpdateCorporateAggregatorProviderSites
  /**
   * Update ClassPass integration for a corporate (admin)
   */
  adminUpdateCorporateIntegrationsClassPass: (args: {
    corporateId: ScalarsEnums['String']
    enabled: ScalarsEnums['Boolean']
    siteIds: Array<ScalarsEnums['String']>
  }) => Corporate
  /**
   * Update corporate Contentful / native content (V2 Content Suite) settings
   */
  adminUpdateCorporateIntegrationsContentful: (args: {
    corporateId: ScalarsEnums['String']
    corporateInput: UpdateCorporateIntegrationsContentfulInput
  }) => Corporate
  /**
   * Update corporate deeplinking (Branch.io) integration settings
   */
  adminUpdateCorporateIntegrationsDeeplinking: (args: {
    corporateId: ScalarsEnums['String']
    corporateInput: UpdateCorporateIntegrationsDeeplinkingInput
  }) => Corporate
  /**
   * Update corporate eGym integration settings (chain API key + enabled flag)
   */
  adminUpdateCorporateIntegrationsEgym: (args: {
    corporateId: ScalarsEnums['String']
    corporateInput: UpdateCorporateIntegrationsEgymInput
  }) => Corporate
  /**
   * Update corporate grow (GoHighLevel CRM) integration settings
   */
  adminUpdateCorporateIntegrationsGrow: (args: {
    corporateId: ScalarsEnums['String']
    corporateInput: UpdateCorporateIntegrationsGrowInput
  }) => Corporate
  /**
   * Update corporate push notification keys (OneSignal)
   */
  adminUpdateCorporateIntegrationsPushNotification: (args: {
    corporateId: ScalarsEnums['String']
    corporateInput: UpdateCorporateIntegrationsPushNotificationInput
  }) => Corporate
  /**
   * Update corporate Zapier integration settings (enabled flag)
   */
  adminUpdateCorporateIntegrationsZapier: (args: {
    corporateId: ScalarsEnums['String']
    corporateInput: UpdateCorporateIntegrationsZapierInput
  }) => Corporate
  /**
   * Update a corporate webhook (admin)
   */
  adminUpdateCorporateWebhook: (args: {
    corporateId: ScalarsEnums['ID']
    input: UpdateCorporateWebhookInputInput
    webhookId: ScalarsEnums['ID']
  }) => CorporateWebhook
  /**
   * Hapana-Admin-only Member Movement (OC-554) force-off switch (enabled, on by default). Audit-only — no attestation.
   */
  adminUpdateMemberMovementEntitlement: (args: {
    corporateId: ScalarsEnums['String']
    input: MemberMovementEntitlementInput
  }) => MemberMovementConfig
  /**
   * Update site admin configurations
   */
  adminUpdateSiteAdminConfigurations: (args: {
    input: SiteAdminConfigurationsUpdateInput
    siteId: ScalarsEnums['ID']
  }) => Site
  /**
   * Update site admin payment gateway configuration
   */
  adminUpdateSiteAdminConfigurationsPaymentGateway: (args: {
    payload: SiteAdminConfigPaymentGatewayInput
    siteId: ScalarsEnums['String']
  }) => Site
  /**
   * Enable or disable ClassPass integration for a site (admin)
   */
  adminUpdateSiteIntegrationsClassPass: (args: {
    enabled: ScalarsEnums['Boolean']
    siteId: ScalarsEnums['String']
  }) => Site
  /**
   * Update Grow integration configuration for a site
   */
  adminUpdateSiteIntegrationsGrow: (args: {
    growInput: UpdateGrowInput
    siteId: ScalarsEnums['String']
  }) => Site
  /**
   * Toggle V2 enabled status for a site in admin DB SiteIndex
   */
  adminUpdateSiteV2Enabled: (args: {
    isV2Enabled: ScalarsEnums['Boolean']
    siteId: ScalarsEnums['String']
  }) => AdminUpdateSiteV2Enabled
  /**
   * Save a location’s choice as the brand mapping and give it to members still waiting unmatched on the same pair (OC-2075). Corporate member_movement__configure.
   */
  adoptMemberMovementLocationResolution: (args: {
    input: AdoptMemberMovementLocationResolutionInput
  }) => AdoptMemberMovementLocationResolutionResult
  /**
   * Give a family member access to a family-shareable package, optionally capped at a number of credits (family admin or staff)
   */
  allocateFamilyPackage: (args: {
    input: AllocateFamilyPackageInput
  }) => ServiceCreditShareMutationResult
  /**
   * Irreversibly anonymise a client (scrub PII across the brand)
   */
  anonymiseClient: (args: {
    clientId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => AnonymiseClientResponse
  /**
   * Append a signature image to an existing PENDING or ACTIVE agreement. Used during multi-signature flows where signatures are collected one at a time.
   */
  appendSignatureToAgreement: (args: {
    agreementId: ScalarsEnums['ID']
    clientId: ScalarsEnums['ID']
    expectedLinkedInvoiceId?: Maybe<ScalarsEnums['ID']>
    ipAddress?: Maybe<ScalarsEnums['String']>
    pendingCheckout?: Maybe<ScalarsEnums['Boolean']>
    signature: ScalarsEnums['String']
    signedSource?: Maybe<AgreementSignedSource>
    siteId: ScalarsEnums['ID']
    slotKey?: Maybe<ScalarsEnums['String']>
    userAgent?: Maybe<ScalarsEnums['String']>
  }) => AppendSignatureToAgreement
  /**
   * Save a detail from the reader over the value already on the client profile, after staff confirm it
   */
  applyHeldTerminalHandoffValue: (args: {
    siteId: ScalarsEnums['ID']
    stepKey: ScalarsEnums['String']
    terminalHandoffRequestId: ScalarsEnums['ID']
  }) => TerminalHandoffRequest
  /**
   * Update session template and propagate changes to all future scheduled sessions
   */
  applySessionTemplateToFutureSessions: (args: {
    id: ScalarsEnums['String']
    includeModifiedSessions?: Maybe<ScalarsEnums['Boolean']>
    input: SessionTemplateUpdateInput
    siteId: ScalarsEnums['String']
  }) => ApplySessionTemplateResult
  /**
   * Approve all import sessions in parallel — transitions all READY → PROCESSING
   */
  approveAllImports: (args: { importSessionIds: Array<ScalarsEnums['ID']> }) => ApproveAllImports
  /**
   * Kiosk check-in: approve a client for a session by bookingId or clientId+sessionId
   */
  approveCheckin: (args: {
    bookingId?: Maybe<ScalarsEnums['String']>
    clientId: ScalarsEnums['String']
    sessionId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => ApproveCheckinResult
  /**
   * Pick a pending claim to fill a cover
   */
  approveCoverClaim: (args: {
    coverClaimId: ScalarsEnums['ID']
    coverRequestId: ScalarsEnums['ID']
    notifyMembers?: Maybe<ScalarsEnums['Boolean']>
    siteId: ScalarsEnums['ID']
  }) => CoverRequestView
  /**
   * Approve a draft gift card expiry rule so it is enforced from its effective date
   */
  approveGiftCardExpiryRule: (args: {
    giftCardExpiryRuleId: ScalarsEnums['ID']
  }) => GiftCardExpiryRuleRecord
  /**
   * Approve import session for execution — transitions READY → PROCESSING
   */
  approveImport: (args: { importSessionId: ScalarsEnums['ID'] }) => ApproveImport
  approveKnowledgeArticleRevision: (args: { revisionId: ScalarsEnums['ID'] }) => KnowledgeArticle
  /**
   * Approve + freeze a REVIEW run (RUN_APPROVAL attestation; blocks on unresolved mappings)
   */
  approveMemberMovementRun: (args: { input: ApproveMemberMovementRunInput }) => MemberMovementRun
  /**
   * Archive a plan that nobody is assigned to
   */
  archiveCommissionPlan: (args: { commissionPlanId: ScalarsEnums['ID'] }) => CommissionPlan
  /**
   * Archive a content entry with soft archive
   */
  archiveContentEntry: (args: { contentEntryId: ScalarsEnums['ID'] }) => CmsContentEntry
  /**
   * Take a live brand add-on off sale at every location; existing clients keep it
   */
  archiveCorporateAddOn: (args: {
    input: CorporateServiceTemplateVersionInput
  }) => CorporateAddOnRolloutResult
  /**
   * Archive several live brand add-ons, skipping the others with a reason
   */
  archiveCorporateAddOns: (args: {
    input: ArchiveCorporateServiceTemplatesInput
  }) => CorporateAddOnArchiveManyResult
  /**
   * Archive a gift card template (soft delete)
   */
  archiveGiftCardTemplate: (args: { giftCardTemplateId: ScalarsEnums['ID'] }) => GiftCardTemplate
  archiveKnowledgeArticle: (args: { knowledgeArticleId: ScalarsEnums['ID'] }) => KnowledgeArticle
  /**
   * Transition leaderboard from ACTIVE to ARCHIVED
   */
  archiveLeaderboard: (args: { leaderboardConfigId: ScalarsEnums['String'] }) => LeaderboardConfig
  /**
   * Archive a POS product (soft delete - sets status to archived)
   */
  archivePosProduct: (args: {
    posProductId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => ArchiveProductResponse
  /**
   * Archive a promo code (soft delete)
   */
  archivePromoCode: (args: { promoCodeId: ScalarsEnums['ID'] }) => PromoCode
  /**
   * Archive a service template (set status to ARCHIVED)
   */
  archiveServiceTemplate: (args: { serviceTemplateId: ScalarsEnums['String'] }) => ServiceTemplate
  /**
   * Assign agreement template to client (creates PENDING agreement)
   */
  assignAgreementToClient: (args: {
    clientId: ScalarsEnums['ID']
    siteAgreementTemplateId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => ClientAgreement
  /**
   * Assign, replace or clear the assigned staff member for a client at a site
   */
  assignClientSiteStaff: (args: {
    clientId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
    staffUserId?: Maybe<ScalarsEnums['String']>
  }) => AssignClientSiteStaffResponse
  /**
   * Give a staff member an individual plan at chosen locations
   */
  assignCommissionPlan: (args: {
    commissionPlanId: ScalarsEnums['ID']
    earnerRole: CommissionEarnerRole
    endDate?: Maybe<ScalarsEnums['String']>
    managerScope?: Maybe<CommissionManagerScope>
    overrides?: Maybe<ScalarsEnums['JSONObject']>
    siteIds: Array<ScalarsEnums['ID']>
    staffUserId: ScalarsEnums['ID']
    startDate: ScalarsEnums['String']
    teamStaffUserIds?: Maybe<Array<ScalarsEnums['ID']>>
  }) => CommissionAssignment
  /**
   * Fill a cover with an instructor of the manager’s choosing
   */
  assignCoverDirectly: (args: {
    coverRequestId: ScalarsEnums['ID']
    notifyMembers?: Maybe<ScalarsEnums['Boolean']>
    siteId: ScalarsEnums['ID']
    staffUserId: ScalarsEnums['ID']
  }) => CoverRequestView
  /**
   * Assign a form to a client
   */
  assignFormToClient: (args: {
    clientId: ScalarsEnums['String']
    requiredBefore?: Maybe<FormRequiredBefore>
    sendEmail?: Maybe<ScalarsEnums['Boolean']>
    siteFormId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => AssignFormResponse
  /**
   * Assign a staff user to a payroll tier
   */
  assignSitePayrollTier: (args: {
    coreUserId: ScalarsEnums['ID']
    effectiveDate?: Maybe<ScalarsEnums['String']>
    endDate?: Maybe<ScalarsEnums['String']>
    payrollTierId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => AssignSitePayrollTier
  /**
   * Assign or unassign a sales owner (admin user) to a trial corporate
   */
  assignTrialOwner: (args: {
    corporateId: ScalarsEnums['ID']
    salesOwnerId?: Maybe<ScalarsEnums['ID']>
  }) => ScalarsEnums['Boolean']
  /**
   * Attach an externally-created Zoom join URL to a session occurrence (MA-77)
   */
  attachSessionZoomUrl: (args: {
    id: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
    url: ScalarsEnums['String']
  }) => Session
  /**
   * Record that a staff member has done an onboarding step nothing can observe
   */
  attestBrandSetupStep: (args: {
    brandId: ScalarsEnums['String']
    note?: Maybe<ScalarsEnums['String']>
    step: BrandSetupStep
  }) => Array<BrandSetupStepView>
  /**
   * Record that a staff member has done a provisioning step only a person can do, such as uploading the APNs key into Firebase; returns the persisted outcomes
   */
  attestProvisioningStep: (args: {
    brandId: ScalarsEnums['String']
    note?: Maybe<ScalarsEnums['String']>
    step: BrandProvisionStep
  }) => Array<BrandProvisioningOutcome>
  /**
   * Read-only door authorization for a FOB scan. Returns the eligibility verdict (allow) for VIVA immediately and runs the check-in writes detached server-side.
   */
  authorizeFobScanCheckIn: (args: {
    fobNumber: ScalarsEnums['String']
    siteAccessPointId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => ScanAuthorizationResult
  /**
   * Read-only door authorization for a QR scan. Returns the eligibility verdict (allow) immediately and runs the check-in writes detached server-side. Pass contactlessCheckInAnswers and noQuestionnaireCheckin to enforce the per-site contactless questionnaire.
   */
  authorizeQrScanCheckIn: (args: {
    clientId: ScalarsEnums['String']
    contactlessCheckInAnswers?: Maybe<ScalarsEnums['JSONObject']>
    noQuestionnaireCheckin?: Maybe<ScalarsEnums['Boolean']>
    siteAccessPointId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => ScanAuthorizationResult
  /**
   * Soft-delete one tenant dashboard for the calling corporate — requires the bi_explorer permission
   */
  biDeleteDashboard: (args: { input: BiDeleteDashboardInput }) => BiTenantDashboardsResponse
  /**
   * Publish (upsert) a validated dashboard bundle for the calling corporate — Hapana staff only
   */
  biPublishDashboard: (args: { input: BiPublishDashboardInput }) => BiTenantDashboardsResponse
  /**
   * Save (upsert) a customer-authored dashboard bundle for the calling corporate — requires the bi_explorer permission
   */
  biSaveDashboard: (args: { input: BiPublishDashboardInput }) => BiTenantDashboardsResponse
  /**
   * Replace visibility and grants for one BI dashboard or widget — requires bi_admin or ownership
   */
  biSetAccess: (args: { input: BiSetAccessInput }) => BiTenantDashboardsResponse
  /**
   * Set or clear the calling user's default BI dashboard
   */
  biSetDefaultDashboard: (args: { input: BiSetDefaultDashboardInput }) => BiTenantDashboardsResponse
  /**
   * Persist the DashView workspace id for the calling corporate (Hapana staff only)
   */
  biSetMigrationConfig: (args: { input: BiSetMigrationConfigInput }) => BiMigrationConfig
  /**
   * Block a client from logging in at a specific site
   */
  blockClientAtSite: (args: {
    blockEndDate?: Maybe<ScalarsEnums['String']>
    blockReason?: Maybe<ScalarsEnums['String']>
    blockStartDate?: Maybe<ScalarsEnums['String']>
    clientId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => BlockClientResponse
  /**
   * Signed URL for uploading one brand artwork file during onboarding
   */
  brandArtworkUploadUrl: (args: {
    brandId: ScalarsEnums['String']
    field: BrandArtworkField
    format: BrandArtworkFormat
  }) => BrandArtworkUploadUrl
  /**
   * Signed URL for uploading one PNG home logo or tab icon; staff only
   */
  brandNavigationArtworkUploadUrl: (args: {
    brandId: ScalarsEnums['String']
    field: BrandNavigationArtworkField
  }) => BrandArtworkUploadUrl
  /**
   * Send a nudge about a cover to every instructor who could take it
   */
  broadcastCoverMessage: (args: {
    body: ScalarsEnums['String']
    coverRequestId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => CoverMessageView
  /**
   * Add multiple pricing tiers to an SMS package in a single transaction
   */
  bulkAddSmsPackageOptions: (args: {
    input: BulkAddSmsPackageOptionsInputInput
    smsPackageId: ScalarsEnums['ID']
  }) => SmsPackage
  /**
   * Add multiple clients to a session waitlist
   */
  bulkAddToWaitlist: (args: {
    clientIds: Array<ScalarsEnums['String']>
    sessionId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Array<SessionWaitlistEntry>
  /**
   * Bulk invite multiple staff members
   */
  bulkInviteStaff: (args: {
    corporateId: ScalarsEnums['ID']
    invitations: Array<InviteStaffMemberInvitationInput>
  }) => Array<BulkInviteStaff>
  /**
   * Reinstate several staff-cancelled invoices. Per-item error isolation: a failure leaves that invoice cancelled and does not roll back the others.
   */
  bulkReinstateInvoices: (args: {
    items: Array<ReinstateInvoiceInput>
    siteId: ScalarsEnums['ID']
  }) => BulkUpdateInvoicesResult
  /**
   * Remove multiple clients from a session waitlist
   */
  bulkRemoveFromWaitlist: (args: {
    sessionWaitlistEntryIds: Array<ScalarsEnums['String']>
    siteId: ScalarsEnums['String']
  }) => ScalarsEnums['Float']
  /**
   * Bulk-revert every MOVED movement in a run (Issue 9) — Hapana Admin only; individual failures are isolated and reported per movement.
   */
  bulkRevertMemberMovements: (args: {
    reason?: Maybe<ScalarsEnums['String']>
    runId: ScalarsEnums['ID']
  }) => BulkRevertMemberMovementsResult
  /**
   * Bulk set sites client fees template
   */
  bulkSetSitesFeesClientFeesTemplate: (args: {
    clientFeeTemplateId: ScalarsEnums['String']
    siteIds: Array<ScalarsEnums['String']>
  }) => BulkUpdateSites
  /**
   * Bulk set sites hapana fees template
   */
  bulkSetSitesFeesHapanaFeesTemplate: (args: {
    hapanaFeeTemplateId: ScalarsEnums['String']
    siteIds: Array<ScalarsEnums['String']>
  }) => BulkUpdateSites
  /**
   * Bulk publish, unpublish, archive, or delete multiple content entries
   */
  bulkUpdateContentEntryStatus: (args: {
    action: ContentBulkAction
    contentEntryIds: Array<ScalarsEnums['ID']>
  }) => BulkUpdateContentEntryStatus
  /**
   * Bulk shift invoice dates by a delta (days). Each invoice includes its known currentDate from the FE so the backend uses that as the base rather than re-reading saleDate from a freshly materialized invoice (which would cause all invoices to land on the same date). Virtual invoices are materialized first, then updated to currentDate + delta. Materialized invoices must be in scheduled status. New date must not be in the past. All updates are atomic — if any fails, the entire batch is rolled back.
   */
  bulkUpdateInvoiceScheduleDates: (args: {
    input: BulkUpdateInvoiceScheduleDatesInput
    siteId: ScalarsEnums['ID']
  }) => BulkUpdateInvoicesResult
  /**
   * Bulk update invoice amounts for scheduled invoices. Handles both virtual invoices (which get materialized) and already-materialized invoices. All updates happen atomically - if any fails, the entire batch is rolled back.
   */
  bulkUpdateInvoices: (args: {
    input: BulkUpdateInvoicesInput
    siteId: ScalarsEnums['ID']
  }) => BulkUpdateInvoicesResult
  /**
   * Smart bulk amount update for a mixed selection of scheduled invoices. Routes pre-sale, single, and recurring invoices to their correct service methods. Per-item error isolation — a failure in one item does not roll back others. Setting totalAmount to 0 applies a full discount to pre-sale invoices.
   */
  bulkUpdateScheduledAmounts: (args: {
    input: BulkUpdateScheduledAmountsInput
    siteId: ScalarsEnums['ID']
  }) => BulkUpdateInvoicesResult
  /**
   * Smart bulk date shift for a mixed selection of scheduled invoices. Routes pre-sale, single, and recurring invoices to their correct service methods. Per-item error isolation — a failure in one item does not roll back others.
   */
  bulkUpdateScheduledDates: (args: {
    input: BulkUpdateScheduledDatesInput
    siteId: ScalarsEnums['ID']
  }) => BulkUpdateInvoicesResult
  /**
   * DRAFT/REVIEW → CALCULATING and enqueue the evaluate-run job
   */
  calculateMemberMovementRun: (args: {
    acknowledgeOverlap?: Maybe<ScalarsEnums['Boolean']>
    runId: ScalarsEnums['ID']
  }) => MemberMovementRun
  /**
   * Cancel a booking. Status is automatically determined based on cancellation policies: CANCELLED (early) or LATE_CANCELLED (late). For paid DROP_IN bookings, refundMethod is required to specify where to send the refund. For override cancellations (LATE_CANCELLED/NO_SHOW), feeRefundMethod specifies how to refund any charged fee invoice.
   */
  cancelBooking: (args: {
    feeRefundMethod?: Maybe<DropInRefundMethod>
    id: ScalarsEnums['ID']
    refundMethod?: Maybe<DropInRefundMethod>
    staffRemoval?: Maybe<ScalarsEnums['Boolean']>
  }) => Booking
  /**
   * Cancel a pending content schedule
   */
  cancelContentSchedule: (args: {
    contentScheduleId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Cancel a cover request; the original instructor keeps the class
   */
  cancelCoverRequest: (args: {
    coverRequestId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => CoverRequestView
  /**
   * Cancel an active demo seeding job
   */
  cancelDemoSeedingJob: (args: { jobId: ScalarsEnums['String'] }) => DemoSeedingJob
  /**
   * Cancel an active tanning session assignment
   */
  cancelEquipmentAssignment: (args: { assignmentId: ScalarsEnums['String'] }) => EquipmentAssignment
  /**
   * Cancel one or more failed invoices, transitioning each to failed_canceled or collections status. Accepts a single invoiceId or a list of invoiceIds.
   */
  cancelFailedInvoice: (args: {
    cancellationReason: ScalarsEnums['String']
    invoiceId?: Maybe<ScalarsEnums['ID']>
    invoiceIds?: Maybe<Array<ScalarsEnums['ID']>>
    sendToCollections: ScalarsEnums['Boolean']
    siteId: ScalarsEnums['ID']
  }) => Array<Invoice>
  /**
   * Cancel a fob registration that is still waiting for a tap.
   */
  cancelFobCapture: (args: {
    requestId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => FobCaptureRequest
  /**
   * Withdraw a form assignment the client has not completed
   */
  cancelFormAssignment: (args: {
    formSubmissionId: ScalarsEnums['String']
    reason: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => CancelFormAssignmentResponse
  /**
   * Stop one delivery of a form; the client still has the form to complete
   */
  cancelFormHandoff: (args: {
    handoffId: ScalarsEnums['ID']
    siteId: ScalarsEnums['String']
  }) => FormHandoff
  /**
   * Cancel a validation-stage import session — flips status to CANCELLED so a replacement upload is allowed and downstream waves do not block
   */
  cancelImportSession: (args: { importSessionId: ScalarsEnums['ID'] }) => CancelImportSession
  /**
   * Cancel an invoice and all associated pending/processing payments
   */
  cancelInvoice: (args: {
    cancellationReason: ScalarsEnums['String']
    invoiceId: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => Invoice
  /**
   * Cancel a run mid-flight (Issue 7a, E3) — executed movements stand, rest never run
   */
  cancelMemberMovementRun: (args: { runId: ScalarsEnums['ID'] }) => MemberMovementRun
  /**
   * Release a payment the member parked by dismissing the inline bank authentication challenge: cancel the PaymentIntent and drop the invoice out of processing so another card can be tried. Idempotent, scoped to the calling member, and never cancels a charge the bank has already approved.
   */
  cancelPendingClientAction: (args: {
    invoiceId: ScalarsEnums['ID']
    paymentId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => CancelPendingClientActionResult
  /**
   * Stop one pending-items link; the items stay outstanding
   */
  cancelPendingItemsHandoff: (args: {
    handoffId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => PendingItemsHandoff
  /**
   * Cancel an in-flight card or bank payment at the gateway before it settles, so it never captures and needs no refund. Asks the gateway first, so a payment that already settled is reported rather than voided. Refused for gateways that cannot cancel (Ezypay) and for a payment the gateway has already taken.
   */
  cancelPendingPayment: (args: {
    paymentId: ScalarsEnums['ID']
    reason: PendingPaymentCancellationReason
    siteId: ScalarsEnums['ID']
  }) => CancelPendingPaymentResult
  /**
   * Cancel a membership plan change that is awaiting payment, together with its unpaid pro-rated invoice.
   */
  cancelPendingPaymentPlanChange: (args: {
    input: CancelPendingPaymentPlanChangeInput
  }) => ScalarsEnums['Boolean']
  /**
   * Stop a bulk pending-items send before its next client and withdraw its texts still waiting to go out
   */
  cancelPolicyBulkSend: (args: {
    runId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => PolicyBulkSendRun
  /**
   * Cancel a scheduled cancellation before it executes
   */
  cancelScheduledCancellation: (args: {
    reason?: Maybe<ScalarsEnums['String']>
    serviceCancellationId: ScalarsEnums['String']
  }) => ScalarsEnums['Boolean']
  /**
   * Cancel a SCHEDULED membership plan change before it executes.
   */
  cancelScheduledPlanChange: (args: {
    input: CancelScheduledPlanChangeInput
  }) => ScalarsEnums['Boolean']
  /**
   * Cancel a push notification that has not been sent yet
   */
  cancelScheduledPushSend: (args: {
    scheduledPushSendId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => ScheduledPushSend
  /**
   * Cancel the scheduled revision of a site policy before it takes effect
   */
  cancelScheduledSitePolicyRevision: (args: {
    siteId: ScalarsEnums['ID']
    sitePolicyId: ScalarsEnums['ID']
  }) => SitePolicyRevision
  /**
   * Cancel a scheduled suspension before it activates.
   */
  cancelScheduledSuspension: (args: {
    reason?: Maybe<ScalarsEnums['String']>
    serviceSuspensionId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => ScalarsEnums['Boolean']
  /**
   * Cancel an active service. Can schedule for future date or cancel immediately. Returns serviceCancellationId if scheduled.
   */
  cancelService: (args: {
    bookingIds?: Maybe<Array<ScalarsEnums['String']>>
    cancelAt?: Maybe<ScalarsEnums['String']>
    chargeAmount?: Maybe<ScalarsEnums['Numeric']>
    chargeMode?: Maybe<ServiceSuspensionChargeMode>
    collectChargeNow?: Maybe<ScalarsEnums['Boolean']>
    failedInvoiceIds?: Maybe<Array<ScalarsEnums['String']>>
    reason?: Maybe<ScalarsEnums['String']>
    serviceId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Maybe<ScalarsEnums['String']>
  /**
   * Cancel a session and notify booked clients
   */
  cancelSession: (args: { input: CancelSessionInput }) => Session
  /**
   * Cancel multiple sessions and notify booked clients (batch operation)
   */
  cancelSessions: (args: { input: CancelSessionsBatchInput }) => Array<Session>
  /**
   * Cancel sessions for a temporary closure through the standard cancellation path, reporting each one
   */
  cancelSessionsForClosure: (args: {
    input: CancelSessionsForClosureInput
  }) => Array<ClosureSessionCancellationResult>
  /**
   * Cancel the current action on a terminal reader. Best-effort operation.
   */
  cancelTerminalAction: (args: {
    siteId: ScalarsEnums['ID']
    terminalReaderId: ScalarsEnums['ID']
  }) => CancelTerminalAction
  /**
   * Stop a reader hand-off and free the reader. Details already entered are kept.
   */
  cancelTerminalHandoffRequest: (args: {
    siteId: ScalarsEnums['ID']
    terminalHandoffRequestId: ScalarsEnums['ID']
  }) => TerminalHandoffRequest
  /**
   * Cancel a theme subscription. Takes effect at end of billing period. A Hapana admin may do this for any brand; a brand admin holding write_controls may do it for their own (OC-320 self service).
   */
  cancelThemeSubscription: (args: {
    corporateId: ScalarsEnums['ID']
    reason?: Maybe<ScalarsEnums['String']>
    subscriptionId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Change admin user status
   */
  changeAdminUserStatus: (args: {
    adminUserId: ScalarsEnums['ID']
    status: AdminUserStatus
  }) => AdminUser
  /**
   * Move a credit-paid booking's credit to another of the member's packages without cancelling it: the credits it paid return to the original package, and the class's current credit cost is taken from the selected package, or split across the selected member's own packages in the order given. The session, spot and status are unchanged
   */
  changeBookingCreditPackage: (args: {
    additionalServiceIds?: Maybe<Array<ScalarsEnums['ID']>>
    bookingId: ScalarsEnums['ID']
    serviceId: ScalarsEnums['ID']
  }) => Booking
  /**
   * Set a client's login password directly (internal admin only)
   */
  changeClientPassword: (args: {
    clientId: ScalarsEnums['String']
    password: ScalarsEnums['String']
  }) => ScalarsEnums['Boolean']
  /**
   * Initiate an immediate or scheduled membership plan change. Returns the servicePlanChangeId, plus the proratedInvoiceId to pay when collectAtCheckout holds the change.
   */
  changeMembershipPlan: (args: { input: ChangeMembershipPlanInput }) => ChangeMembershipPlanResult
  /**
   * Change a pending membership's start date and shift its whole scheduled billing schedule by the same delta.
   */
  changeMembershipStartDate: (args: {
    memberNotification?: Maybe<MemberNotificationInput>
    newStartDate: ScalarsEnums['String']
    serviceId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => ScalarsEnums['Boolean']
  /**
   * Change the payment method for a recurring invoice and all its scheduled materialized invoices
   */
  changeRecurringInvoicePaymentMethod: (args: {
    clientPaymentMethodId: ScalarsEnums['ID']
    recurringInvoiceId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Manually charge a no-show or late-cancel fee for a booking. Creates and charges the fee invoice. Booking must be in the correct attendance status.
   */
  chargeBookingFee: (args: {
    bookingId: ScalarsEnums['String']
    feeType: BookingFeeType
  }) => Booking
  /**
   * Check in a client for a specific booking by booking ID
   */
  checkIn: (args: {
    bookingId: ScalarsEnums['String']
    clientId: ScalarsEnums['String']
    siteId?: Maybe<ScalarsEnums['String']>
  }) => CheckInByBookingResult
  /**
   * Choose the membership a member will hold at the receiving location (OC-2075). Needs member_movement__manage_incoming at the location or corporate member_movement__approve; saveAsBrandMapping also needs corporate member_movement__configure.
   */
  chooseIncomingMovementDestination: (args: {
    input: ChooseIncomingMovementDestinationInput
  }) => MemberMovementListItem
  /**
   * Claim a class cover as the signed-in instructor; fills it at once unless a manager picks
   */
  claimCover: (args: {
    coverRequestId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => CoverRequestView
  /**
   * Claim an invite token: create/link the guest client and accept the pass. Called via the servers/api claim endpoint with a verified Firebase identity; verifiedEmail is the email on the Firebase token and must match a pass sent by email.
   */
  claimGuestPass: (args: {
    firebaseId: ScalarsEnums['String']
    input: ClaimGuestPassInput
    verifiedEmail?: Maybe<ScalarsEnums['String']>
  }) => ClaimGuestPassResult
  /**
   * Delete carousel groups that are no longer referenced by any content entry
   */
  cleanupOrphanedCarouselGroups: CleanupOrphanedCarouselGroupsResult
  /**
   * Clear the client's backup payment method for this site. Staff only. Automatic failover then falls through to the client's default card, and to their remaining valid cards.
   */
  clearBackupPaymentMethod: (args: {
    clientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Clear a brand's release hold so it can be released to the stores again
   */
  clearBrandReleaseHold: (args: { brandId: ScalarsEnums['String'] }) => BrandReleaseHold
  /**
   * Make a location follow the brand item switches again
   */
  clearCommissionItemLocationOverride: (args: {
    itemId: ScalarsEnums['String']
    itemType: CommissionItemType
    siteId: ScalarsEnums['ID']
  }) => CommissionItemSetting
  /**
   * Clear the Member Movement emergency stop so rolling can resume (Issue 7b). Does not re-open cancelled runs. member_movement__approve + assert-corporate.
   */
  clearEmergencyStopMemberMovement: (args: {
    corporateId: ScalarsEnums['ID']
  }) => EmergencyStopMemberMovementResult
  /**
   * Clear authentication for an HQ, freeing it for re-authentication
   */
  clearGrowHqAuthentication: (args: { hqId: ScalarsEnums['String'] }) => ClearGrowHqAuthentication
  /**
   * Clear a brand’s sandbox migration job history (e.g. dismiss a failed attempt). Does NOT touch any created sandbox DB.
   */
  clearSandboxJobs: (args: { brandSlug: ScalarsEnums['String'] }) => ScalarsEnums['Boolean']
  /**
   * Clear seeded demo data from a trial corporate
   */
  clearTrialDemoData: (args: { corporateId: ScalarsEnums['ID'] }) => ScalarsEnums['Boolean']
  /**
   * Clock a staff user in at a site, opening a new shift record.
   */
  clockInStaffUser: (args: {
    notes?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['ID']
    staffUserId: ScalarsEnums['ID']
  }) => PayrollTimeClock
  /**
   * Clock a staff user out, closing their open shift at the site.
   */
  clockOutStaffUser: (args: {
    notes?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['ID']
    staffUserId: ScalarsEnums['ID']
  }) => PayrollTimeClock
  /**
   * Close a cash drawer session: snapshots cash sales/refunds, expected takings across all billing types vs actual counted and the difference
   */
  closeCashDrawerSession: (args: {
    actualCash: ScalarsEnums['Numeric']
    cashDrawerSessionId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => CashDrawerSession
  /**
   * Close a trial — sales intentionally closing the trial. Deactivates the corporate.
   */
  closeTrial: (args: {
    closeNotes?: Maybe<ScalarsEnums['String']>
    closeReason: CloseReason
    corporateId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Advance a step-by-step run to the next step after verifying the current one
   */
  cmsImportRunAdvance: (args: { importRunId: ScalarsEnums['String'] }) => CmsImportRun
  /**
   * Cancel an import run
   */
  cmsImportRunCancel: (args: { importRunId: ScalarsEnums['String'] }) => CmsImportRun
  /**
   * Test JW Player connection (stored API key) and store media inventory count
   */
  cmsImportRunConnectJWPlayer: (args: {
    importRunId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => CmsImportRun
  /**
   * Connect to the legacy MongoDB using the configured secret and store collection document counts
   */
  cmsImportRunConnectMongoDB: (args: {
    importRunId: ScalarsEnums['String']
    legacyCorporateId?: Maybe<ScalarsEnums['String']>
  }) => CmsImportRun
  /**
   * Check BigQuery V1 Aurora access for the linked brand and store record counts
   */
  cmsImportRunConnectV1Aurora: (args: {
    importRunId: ScalarsEnums['String']
    v1CorporateId?: Maybe<ScalarsEnums['Int']>
  }) => CmsImportRun
  /**
   * Create a new import run (enforces one active per brand)
   */
  cmsImportRunCreate: (args: {
    importMode: CmsImportMode
    sources?: Maybe<ScalarsEnums['JSONObject']>
  }) => CmsImportRun
  /**
   * Disable native content (rollback to Contentful)
   */
  cmsImportRunDisableNativeContent: (args: { importRunId: ScalarsEnums['String'] }) => CmsImportRun
  /**
   * Enable native content for this brand (flip useNativeContent flag)
   */
  cmsImportRunEnableNativeContent: (args: { importRunId: ScalarsEnums['String'] }) => CmsImportRun
  /**
   * Start import execution
   */
  cmsImportRunExecute: (args: { importRunId: ScalarsEnums['String'] }) => CmsImportRun
  /**
   * Export a Contentful space server-side (stored token) and parse it
   */
  cmsImportRunExportContentful: (args: {
    environment?: Maybe<ScalarsEnums['String']>
    importRunId: ScalarsEnums['String']
    spaceId: ScalarsEnums['String']
  }) => CmsImportRun
  /**
   * Trigger preview generation (publishes BullMQ job)
   */
  cmsImportRunGeneratePreview: (args: { importRunId: ScalarsEnums['String'] }) => CmsImportRun
  /**
   * Generate a presigned upload URL for the Contentful JSON export file
   */
  cmsImportRunGenerateUploadUrl: (args: {
    importRunId: ScalarsEnums['String']
  }) => CmsImportRunGenerateUploadUrl
  /**
   * Pair an unmatched legacy member with a client record by hand
   */
  cmsImportRunMatchMember: (args: {
    clientId: ScalarsEnums['ID']
    importRunId: ScalarsEnums['ID']
    previewId: ScalarsEnums['ID']
  }) => CmsImportRunPreview
  /**
   * Save a manual override for a preview item
   */
  cmsImportRunPreviewOverride: (args: {
    importRunId: ScalarsEnums['String']
    override: ScalarsEnums['JSONObject']
    previewId: ScalarsEnums['String']
  }) => CmsImportRunPreview
  /**
   * Reset a PREVIEWING run back to CONFIGURING to edit sources
   */
  cmsImportRunResetToConfiguring: (args: { importRunId: ScalarsEnums['String'] }) => CmsImportRun
  /**
   * Delete all records from a failed/completed run
   */
  cmsImportRunRollback: (args: { importRunId: ScalarsEnums['String'] }) => CmsImportRun
  /**
   * Roll back a single step's data and reset it to PENDING, leaving the rest intact
   */
  cmsImportRunRollbackStep: (args: {
    importRunId: ScalarsEnums['String']
    stepType: ScalarsEnums['String']
  }) => CmsImportRun
  /**
   * Set skip options and import mode
   */
  cmsImportRunSetOptions: (args: {
    importRunId: ScalarsEnums['String']
    options: CmsImportOptionsInput
  }) => CmsImportRun
  /**
   * Toggle auto-advance vs. pause-after-each-step during a run (resumes if enabling auto-advance while paused)
   */
  cmsImportRunSetStepMode: (args: {
    importRunId: ScalarsEnums['String']
    stepByStep: ScalarsEnums['Boolean']
  }) => CmsImportRun
  /**
   * Pause a running step
   */
  cmsImportRunStepPause: (args: {
    importRunId: ScalarsEnums['String']
    importRunStepId: ScalarsEnums['String']
  }) => CmsImportRunStep
  /**
   * Resume a paused step
   */
  cmsImportRunStepResume: (args: {
    importRunId: ScalarsEnums['String']
    importRunStepId: ScalarsEnums['String']
  }) => CmsImportRunStep
  /**
   * Retry failed items for a step
   */
  cmsImportRunStepRetryFailed: (args: {
    importRunId: ScalarsEnums['String']
    importRunStepId: ScalarsEnums['String']
  }) => CmsImportRunStep
  /**
   * Parse an uploaded Contentful export JSON and store validation results
   */
  cmsImportRunUploadContentful: (args: {
    fileUrl: ScalarsEnums['String']
    importRunId: ScalarsEnums['String']
  }) => CmsImportRun
  /**
   * Trigger verification checks
   */
  cmsImportRunVerify: (args: { importRunId: ScalarsEnums['String'] }) => CmsImportRun
  /**
   * Save Contentful space id + management token to the stored integration
   */
  cmsImportSaveContentfulKeys: (args: {
    managementToken: ScalarsEnums['String']
    spaceId: ScalarsEnums['String']
  }) => CmsImportContentfulConfig
  /**
   * Save a JW Player API key to the stored integration and list its properties
   */
  cmsImportSaveJwPlayerKey: (args: {
    apiKey: ScalarsEnums['String']
  }) => CmsImportJwPlayerSitesResult
  /**
   * Finalise a client file upload once the signed-URL PUT has landed
   */
  completeClientFileUpload: (args: {
    clientId: ScalarsEnums['ID']
    fileId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => CompleteClientFileUploadResponse
  /**
   * Complete the payment method setup. Token is optional for Stripe (uses setupIntentId), required for Ezypay (HPP token from postMessage).
   */
  completeClientPaymentMethod: (args: {
    clientId?: Maybe<ScalarsEnums['ID']>
    clientPaymentMethodId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
    token?: Maybe<ScalarsEnums['String']>
  }) => ClientPaymentMethod
  /**
   * Complete a media upload by updating metadata after the file has been uploaded to GCS
   */
  completeMediaUpload: (args: { input: CompleteMediaUploadInputInput }) => CmsContentMedia
  /**
   * Mark an onboarding step as completed
   */
  completeOnboardingStep: (args: {
    completedByUserId?: Maybe<ScalarsEnums['ID']>
    corporateId: ScalarsEnums['ID']
    stepKey: OnboardingStepKey
  }) => ScalarsEnums['Boolean']
  /**
   * Complete site payment method setup and save as default
   */
  completeSitePaymentMethodSetup: (args: {
    setupIntentId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => SitePaymentMethodDetails
  /**
   * OC-7: accept a booking request awaiting staff confirmation (PENDING → CONFIRMED) and notify the member. Used by the scheduler banner when auto-confirm is off.
   */
  confirmBookingRequest: (args: {
    bookingId: ScalarsEnums['String']
    rescheduled?: Maybe<ScalarsEnums['Boolean']>
  }) => Booking
  /**
   * Record an uploaded brand artwork file against the brand, returning the artwork as it now stands; the icon is validated and resized for the stores here, so this is where a source Apple would refuse is rejected
   */
  confirmBrandArtworkUpload: (args: {
    brandId: ScalarsEnums['String']
    field: BrandArtworkField
    /**
     * Opaque reference to the uploaded object, echoed back from the upload URL response
     */
    uploadRef: ScalarsEnums['String']
  }) => BrandArtwork
  /**
   * Record an uploaded home logo or tab icon, returning the navigation artwork as it now stands; a file that is not a square PNG within the size range is rejected here
   */
  confirmBrandNavigationArtworkUpload: (args: {
    brandId: ScalarsEnums['String']
    field: BrandNavigationArtworkField
    /**
     * Opaque reference to the uploaded object, echoed back from the upload URL response
     */
    uploadRef: ScalarsEnums['String']
  }) => BrandNavigationArtwork
  /**
   * Register an uploaded store asset once its bytes have landed in storage
   */
  confirmBrandStoreAsset: (args: {
    assetType: BrandStoreAssetType
    brandId: ScalarsEnums['String']
    deviceClass?: Maybe<ScalarsEnums['String']>
    filename: ScalarsEnums['String']
    locale: ScalarsEnums['String']
    platform: BrandPlatform
    uploadRef: ScalarsEnums['String']
  }) => Array<ConfirmBrandStoreAsset>
  /**
   * Record an uploaded file against its entity and return its ready-to-use URL
   */
  confirmDirectUpload: (args: { input: DirectUploadConfirmInput }) => DirectUploadImage
  /**
   * Move a fob that collided with another member onto the requested member, revoking it from its previous holders.
   */
  confirmFobCaptureReassign: (args: {
    requestId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => FobCaptureRequest
  /**
   * Store a brand's APNs .p8 key and key id in Core, then rerun the Hapana Push handoff so iOS goes straight to Apple; staff only, and the fallback when the automatic key create cannot run
   */
  connectApnsKey: (args: {
    brandId: ScalarsEnums['String']
    keyId: ScalarsEnums['String']
    privateKey: ScalarsEnums['String']
    teamId?: Maybe<ScalarsEnums['String']>
  }) => ConnectApnsKeyResult
  /**
   * Start a server-side Apple sign-in, reusing the stored password unless a new one is given; Apple then sends a code to every trusted device and phone on the account
   */
  connectAppleAccount: (args?: { password?: Maybe<ScalarsEnums['String']> }) => AppleAccountSession
  /**
   * Store an App Store Connect API key for this brand and verify it against Apple; staff enter it here because for a customer-owned team they generate it themselves in that account
   */
  connectAppleApi: (args: {
    brandId: ScalarsEnums['String']
    issuerId: ScalarsEnums['String']
    keyId: ScalarsEnums['String']
    privateKey: ScalarsEnums['String']
  }) => ConnectAppleApi
  /**
   * Convert a trial to a paid account
   */
  convertTrial: (args: { corporateId: ScalarsEnums['ID'] }) => ScalarsEnums['Boolean']
  /**
   * Convert a waitlist entry to a confirmed booking
   */
  convertWaitlistToBooking: (args: {
    allowOverCapacity?: Maybe<ScalarsEnums['Boolean']>
    sessionWaitlistEntryId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Booking
  /**
   * Correct a client's date of birth; acceptances signed in the wrong capacity become CAPACITY_MISMATCH
   */
  correctClientDob: (args: {
    clientId: ScalarsEnums['ID']
    dateOfBirth: ScalarsEnums['String']
    reason?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['ID']
  }) => ClientAgeVerification
  /**
   * Create a price group; its session types take the add-on price each plan sets for the group
   */
  createAddOnPriceGroup: (args: { input: CreateAddOnPriceGroupInput }) => AddOnPriceGroup
  /**
   * Pre-create a staged add-on invoice before equipment assignment
   */
  createAddonInvoice: (args: { input: CreateAddonInvoiceInput }) => CreateAddonInvoiceResult
  /**
   * Create a new admin access group
   */
  createAdminAccessGroup: (args: { input: CreateAdminAccessGroupInputInput }) => AdminAccessGroup
  /**
   * Create a new admin user
   */
  createAdminUser: (args: { input: CreateAdminUserInputInput }) => AdminUser
  /**
   * Create a new aggregator provider
   */
  createAggregatorProvider: (args: { input: AggregatorProviderCreateInput }) => AggregatorProvider
  /**
   * Create and sign an agreement in one step from inline agreement text. Used during checkout when the service template has agreementText but no SiteAgreementTemplate.
   */
  createAndSignAgreement: (args: {
    agreementContent: ScalarsEnums['String']
    agreementMethod: AgreementMethod
    agreementName: ScalarsEnums['String']
    agreementVersion?: Maybe<ScalarsEnums['String']>
    clientId: ScalarsEnums['ID']
    ipAddress?: Maybe<ScalarsEnums['String']>
    pendingCheckout?: Maybe<ScalarsEnums['Boolean']>
    signatures: Array<ScalarsEnums['String']>
    siteAgreementTemplateId?: Maybe<ScalarsEnums['ID']>
    siteId: ScalarsEnums['ID']
    userAgent?: Maybe<ScalarsEnums['String']>
  }) => ClientAgreement
  createAndStreamKnowledgeArticle: (args: { input: AIArticleStreamInput }) => AIArticleStreamResult
  /**
   * Create a new API credential. Returns the cleartext secret EXACTLY ONCE — Hapana stores only the hash.
   */
  createApiCredential: (args: { input: ApiCredentialCreateInput }) => ApiCredentialWithSecret
  /**
   * Create a new audit event
   */
  createAuditEvent: (args: { input: CreateAuditEventInputInput }) => AuditEvent
  /**
   * Create multiple audit events in batch
   */
  createAuditEventBatch: (args: { events: Array<CreateAuditEventInputInput> }) => Array<AuditEvent>
  /**
   * Create a block slot to prevent session creation during a time period
   */
  createBlockSlot: (args: {
    input: BlockSlotCreateInput
    siteId: ScalarsEnums['String']
  }) => Session
  /**
   * Create a new booking
   */
  createBooking: (args: { input: BookingCreateInput; siteId: ScalarsEnums['String'] }) => Booking
  /**
   * Create a booking activity log entry
   */
  createBookingActivityLog: (args: { input: BookingActivityLogCreateInput }) => BookingActivityLog
  /**
   * Create an invoice for a drop-in session booking. The booking must have bookingSource=DROP_IN and paymentStatus=pending. This is idempotent - it returns the invoice already linked to the booking, unless that invoice was cancelled, failed-cancelled or voided, in which case it creates a fresh invoice and links it instead.
   */
  createBookingDropInInvoice: (args: {
    bookingId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Invoice
  /**
   * Create multiple bookings with sequential spot assignment
   */
  createBookings: (args: {
    allowOverCapacity?: Maybe<ScalarsEnums['Boolean']>
    inputs: Array<BookingCreateInput>
    siteId: ScalarsEnums['String']
  }) => Array<Booking>
  /**
   * Issue a signed URL for uploading a store screenshot directly to storage
   */
  createBrandStoreAssetUploadUrl: (args: {
    assetType: BrandStoreAssetType
    brandId: ScalarsEnums['String']
    deviceClass?: Maybe<ScalarsEnums['String']>
    format: BrandStoreAssetFormat
    locale: ScalarsEnums['String']
    platform: BrandPlatform
  }) => BrandStoreAssetUploadUrl
  /**
   * Mint a single-use, expiring buddy share-link invite token bound to the inviter
   */
  createBuddyInviteToken: (args: {
    inviterClientId: ScalarsEnums['ID']
    siteId?: Maybe<ScalarsEnums['ID']>
  }) => BuddyInviteTokenResult
  /**
   * Create a new carousel group
   */
  createCarouselGroup: (args: { input: CreateCarouselGroupInput }) => CmsCarouselGroup
  /**
   * Create a new check-in - automatically determines type based on upcoming bookings
   */
  createCheckIn: (args: {
    clientId: ScalarsEnums['ID']
    contactlessCheckInAnswers?: Maybe<ScalarsEnums['JSONObject']>
    noQuestionnaireCheckin?: Maybe<ScalarsEnums['Boolean']>
    owedBalanceOverride?: Maybe<OwedBalanceOverrideInput>
    siteId: ScalarsEnums['ID']
    source: CheckInSource
  }) => CheckIn
  /**
   * Create a Stripe Checkout Session for trial-to-paid upgrade
   */
  createCheckoutSession: (args: {
    cancelUrl: ScalarsEnums['String']
    corporateId: ScalarsEnums['ID']
    planId: ScalarsEnums['String']
    successUrl: ScalarsEnums['String']
  }) => CheckoutSessionResponse
  createClient: (args: {
    input: CreateClientInput
    siteId: ScalarsEnums['String']
  }) => CreateClientResponse
  /**
   * Create new client alert
   */
  createClientAlert: (args: {
    input: CreateClientAlertInputInput
    siteId: ScalarsEnums['String']
  }) => ClientCustomAlertMutationResponse
  /**
   * Create a new client booking buddy relationship
   */
  createClientBuddy: (args: {
    buddyClientId: ScalarsEnums['String']
    clientId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => ClientBookingBuddy
  /**
   * Create a new client fees template
   */
  createClientFeesTemplate: (args: { input: FeeTemplateInput }) => ClientFeesTemplate
  /**
   * Create the record a client document is uploaded against
   */
  createClientFile: (args: {
    clientId: ScalarsEnums['ID']
    input: CreateClientFileInput
    siteId: ScalarsEnums['ID']
  }) => CreateClientFileResponse
  /**
   * Create a new client note
   */
  createClientNote: (args: {
    input: ClientNoteCreateInput
    siteId: ScalarsEnums['String']
  }) => CreateClientNoteResponse
  /**
   * Create a new client family relation
   */
  createClientRelation: (args: {
    clientId: ScalarsEnums['String']
    input: CreateClientFamilyInput
    siteId: ScalarsEnums['String']
  }) => ClientFamily
  /**
   * Create a brand plan, or a location plan when siteId is given
   */
  createCommissionPlan: (args: {
    data: ScalarsEnums['JSONObject']
    earnerRole: CommissionEarnerRole
    name: ScalarsEnums['String']
    siteId?: Maybe<ScalarsEnums['ID']>
    siteIds?: Maybe<Array<ScalarsEnums['ID']>>
  }) => CommissionPlan
  /**
   * Create a new content entry as a draft
   */
  createContentEntry: (args: { input: CmsContentEntryCreateInput }) => CmsContentEntry
  /**
   * Schedule a publish or unpublish action for a content entry
   */
  createContentSchedule: (args: { input: CmsContentScheduleCreateInput }) => CmsContentSchedule
  /**
   * Create new corporate/brand
   */
  createCorporate: (args: {
    accessGroupsIds?: Maybe<Array<ScalarsEnums['String']>>
    addons?: Maybe<Array<ThemeKey>>
    businessType?: Maybe<BusinessType>
    databaseType?: Maybe<DatabaseType>
    hubspot?: Maybe<CreateCorporateHubspotInput>
    name: ScalarsEnums['String']
    prospect?: Maybe<ProspectInput>
    prospects?: Maybe<Array<ProspectInput>>
    region?: Maybe<ScalarsEnums['String']>
    seedDemoData?: Maybe<ScalarsEnums['Boolean']>
    startTrial?: Maybe<ScalarsEnums['Boolean']>
    tier?: Maybe<CorporateTier>
    urlPrefix: ScalarsEnums['String']
    websiteUrl?: Maybe<ScalarsEnums['String']>
  }) => Corporate
  /**
   * Save a new brand add-on as a draft
   */
  createCorporateAddOnDraft: (args: { input: CreateCorporateAddOnDraftInput }) => CorporateAddOn
  /**
   * Create a new corporate communication template
   */
  createCorporateCommunicationTemplate: (args: {
    alias: CommunicationTemplateAliases
    emailBody?: Maybe<ScalarsEnums['String']>
    emailCcEmail?: Maybe<ScalarsEnums['String']>
    emailCcLocation?: Maybe<ScalarsEnums['Boolean']>
    emailCopyEmployee?: Maybe<EmailCopyEmployee>
    emailReplyToEmail?: Maybe<ScalarsEnums['String']>
    emailReplyToName?: Maybe<ScalarsEnums['String']>
    emailSendBefore?: Maybe<ScalarsEnums['Float']>
    emailSendBeforeUnit?: Maybe<EmailSendBeforeUnit>
    emailSendCalendarAttachment?: Maybe<ScalarsEnums['Boolean']>
    emailSendEmailAs?: Maybe<EmailSendAs>
    emailSendOnlyToActiveClients?: Maybe<ScalarsEnums['Boolean']>
    emailSubject?: Maybe<ScalarsEnums['String']>
    emailUseHapanaLayout?: Maybe<ScalarsEnums['Boolean']>
    enableEmail: ScalarsEnums['Boolean']
    enablePush?: Maybe<ScalarsEnums['Boolean']>
    enableSms?: Maybe<ScalarsEnums['Boolean']>
    ignoredSitesIds?: Maybe<Array<ScalarsEnums['ID']>>
    pushMessage?: Maybe<ScalarsEnums['String']>
    pushTitle?: Maybe<ScalarsEnums['String']>
    smsMessage?: Maybe<ScalarsEnums['String']>
    targetedServiceTemplateIds?: Maybe<Array<ScalarsEnums['ID']>>
  }) => CorporateCommunicationTemplate
  /**
   * Create a new version for a corporate communication template
   */
  createCorporateCommunicationTemplateVersion: (args: {
    assignedSiteGroups?: Maybe<Array<ScalarsEnums['String']>>
    assignedSites?: Maybe<Array<ScalarsEnums['String']>>
    corporateCommunicationTemplateId: ScalarsEnums['String']
    emailBody?: Maybe<ScalarsEnums['String']>
    emailCcEmail?: Maybe<ScalarsEnums['String']>
    emailCcLocation?: Maybe<ScalarsEnums['Boolean']>
    emailCopyEmployee?: Maybe<EmailCopyEmployee>
    emailReplyToEmail?: Maybe<ScalarsEnums['String']>
    emailReplyToName?: Maybe<ScalarsEnums['String']>
    emailSendBefore?: Maybe<ScalarsEnums['Float']>
    emailSendBeforeUnit?: Maybe<EmailSendBeforeUnit>
    emailSendCalendarAttachment?: Maybe<ScalarsEnums['Boolean']>
    emailSendEmailAs?: Maybe<EmailSendAs>
    emailSendOnlyToActiveClients?: Maybe<ScalarsEnums['Boolean']>
    emailSubject?: Maybe<ScalarsEnums['String']>
    name: ScalarsEnums['String']
    pushMessage?: Maybe<ScalarsEnums['String']>
    pushTitle?: Maybe<ScalarsEnums['String']>
    smsMessage?: Maybe<ScalarsEnums['String']>
    targetedServiceTemplateIds?: Maybe<Array<ScalarsEnums['ID']>>
  }) => CorporateCommunicationTemplateVersion
  /**
   * Create a new corporate FAQ
   */
  createCorporateFaq: (args: {
    heading: ScalarsEnums['String']
    response: ScalarsEnums['String']
    status?: Maybe<CorporateFaqStatus>
  }) => CorporateFaq
  /**
   * Create new corporate payout account
   */
  createCorporatePayoutAccount: (args: {
    corporateId: ScalarsEnums['ID']
    input: CorporatePayoutAccountInput
  }) => CorporatePayoutAccount
  /**
   * Create a brand session group and distribute it to its locations
   */
  createCorporateSessionType: (args: {
    input: CreateCorporateSessionTypeInput
  }) => CorporateSessionType
  /**
   * Create a brand tax type and distribute it to its assigned locations
   */
  createCorporateTaxSetting: (args: {
    input: CreateCorporateTaxSettingInput
  }) => CorporateTaxSetting
  /**
   * Create a new corporate webhook
   */
  createCorporateWebhook: (args: {
    corporateId: ScalarsEnums['ID']
    input: CreateCorporateWebhookInputInput
  }) => CorporateWebhook
  /**
   * Create a new custom property
   */
  createCustomProperty: (args: {
    input: CustomPropertyCreateInput
    siteId: ScalarsEnums['ID']
  }) => CustomProperty
  /**
   * Create a new deep link with Branch.io URL generation
   */
  createDeepLink: (args: {
    campaign?: Maybe<ScalarsEnums['String']>
    canonicalIdentifier: DeepLinkDestination
    corporateId: ScalarsEnums['String']
    description?: Maybe<ScalarsEnums['String']>
    feature?: Maybe<ScalarsEnums['String']>
    name: ScalarsEnums['String']
    ogDescription?: Maybe<ScalarsEnums['String']>
    ogImageUrl?: Maybe<ScalarsEnums['String']>
    ogTitle?: Maybe<ScalarsEnums['String']>
    tags?: Maybe<Array<ScalarsEnums['String']>>
    targetParams?: Maybe<ScalarsEnums['JSONObject']>
  }) => DeepLink
  /**
   * Create a new digital channel
   */
  createDigitalChannel: (args: {
    input: CreateSiteLocationInput
    siteId: ScalarsEnums['ID']
  }) => SiteLocation
  /**
   * Create a new equipment unit for a site
   */
  createEquipment: (args: {
    input: CreateEquipmentInput
    siteId: ScalarsEnums['String']
  }) => Equipment
  /**
   * Start a tanning session by assigning a client to an equipment unit
   */
  createEquipmentAssignment: (args: {
    input: CreateEquipmentAssignmentInput
  }) => EquipmentAssignment
  /**
   * Create tanning safety regulations for an equipment category at a site
   */
  createEquipmentRegulation: (args: {
    input: CreateEquipmentRegulationInput
  }) => EquipmentRegulation
  /**
   * Create a media asset record from an external video URL (YouTube, Vimeo, Wistia, direct .mp4/.webm/.m3u8) without any GCS upload
   */
  createExternalMediaAsset: (args: { input: CreateExternalMediaAssetInputInput }) => CmsContentMedia
  /**
   * Create a family with the signed-in member as its first admin
   */
  createFamily: (args: {
    name?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['ID']
  }) => Family
  /**
   * Create a family with this client as its first admin, by staff with access__clients or by the client
   */
  createFamilyForClient: (args: {
    clientId: ScalarsEnums['ID']
    name?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['ID']
  }) => Family
  /**
   * Create a single-use invite link to the signed-in admin's family, to share with the person to add; whoever accepts joins with this role and Book sessions, and the link expires after 24 hours
   */
  createFamilyInviteLink: (args: {
    canBook: ScalarsEnums['Boolean']
    role: FamilyMemberRole
    siteId: ScalarsEnums['ID']
  }) => FamilyInviteLink
  /**
   * Create a new fee configuration
   */
  createFeeConfiguration: (args: {
    accountType: FeeAccountType
    description: ScalarsEnums['String']
    enabled: ScalarsEnums['Boolean']
    eventType: FeeEventType
    name: ScalarsEnums['String']
    paymentGateway?: Maybe<PaymentGateway>
    rate: ScalarsEnums['Numeric']
    rateType: FeeRateType
    webhookEndpoint?: Maybe<ScalarsEnums['String']>
    webhookType?: Maybe<ScalarsEnums['String']>
  }) => FeeConfiguration
  /**
   * Send a scored form to a client on a kiosk, in the app, as a secure link or on this screen
   */
  createFormHandoff: (args: {
    channel: FormHandoffChannel
    clientId: ScalarsEnums['String']
    deviceTokenId?: Maybe<ScalarsEnums['String']>
    formSubmissionId?: Maybe<ScalarsEnums['String']>
    idempotencyKey: ScalarsEnums['String']
    requiredBefore?: Maybe<FormRequiredBefore>
    siteFormId?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['String']
  }) => FormHandoff
  /**
   * Create a new gift card design with a placeholder image
   */
  createGiftCardDesign: (args: { input: GiftCardDesignCreateInput }) => GiftCardDesign
  /**
   * Create a gift card expiry rule as a draft; it is not enforced until approved
   */
  createGiftCardExpiryRule: (args: {
    countryId: ScalarsEnums['String']
    disclosureRequired: ScalarsEnums['Boolean']
    effectiveFrom: ScalarsEnums['String']
    expiryPolicy: GiftCardExpiryPolicy
    legalCitation?: Maybe<ScalarsEnums['String']>
    maximumTermMonths?: Maybe<ScalarsEnums['Float']>
    minimumTermMonths?: Maybe<ScalarsEnums['Float']>
    notes?: Maybe<ScalarsEnums['String']>
    sourceUrl?: Maybe<ScalarsEnums['String']>
    zoneId?: Maybe<ScalarsEnums['String']>
  }) => GiftCardExpiryRuleRecord
  /**
   * Create a new gift card template
   */
  createGiftCardTemplate: (args: {
    input: GiftCardTemplateCreateInput
    siteId: ScalarsEnums['ID']
  }) => GiftCardTemplate
  /**
   * Create a new goal
   */
  createGoal: (args: { input: CreateGoalInput }) => CmsGoal
  /**
   * Create a new GrowHq
   */
  createGrowHq: (args: { code: ScalarsEnums['String']; name: ScalarsEnums['String'] }) => GrowHq
  /**
   * Create a Grow location for a site using HQ authentication
   */
  createGrowSiteLocation: (args: {
    hqId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => CreateSiteLocationResponse
  /**
   * Create a new hapana fees template
   */
  createHapanaFeesTemplate: (args: {
    failedPaymentFeeScope?: Maybe<FailedPaymentFeeScope>
    input: FeeTemplateInput
  }) => HapanaFeesTemplate
  /**
   * Create an impersonation session for a StaffUser
   */
  createImpersonationSession: (args: {
    input: CreateAdminUserImpersonationSessionInput
  }) => AdminUserImpersonationSessionResponse
  /**
   * Create new invoices based on a sale
   */
  createInvoice: (args: {
    input: CreateInvoiceInputInput
    siteId: ScalarsEnums['ID']
  }) => Array<Invoice>
  /**
   * Mint pending-agreement signing links for a draft invoice WITHOUT sending Hapana email — the staff "copy pending agreement link" action. Ensures a PENDING agreement per agreement-required line item, revokes prior links, and returns the fresh URLs. The CRM pending-agreement property resyncs as a side effect.
   */
  createInvoiceAgreementSigningLinks: (args: {
    invoiceId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => InvoiceAgreementSigningLinksResult
  createKnowledgeArticle: (args: { input: KnowledgeArticleCreateInput }) => KnowledgeArticle
  createKnowledgeArticleCategory: (args: {
    input: KnowledgeArticleCategoryCreateInput
  }) => KnowledgeArticleCategory
  /**
   * Create a new leaderboard config as DRAFT
   */
  createLeaderboardConfig: (args: { input: CreateLeaderboardConfigInputInput }) => LeaderboardConfig
  /**
   * Create a manual refund for a payment
   */
  createManualRefund: (args: {
    input: CreateManualRefundInputInput
    siteId: ScalarsEnums['ID']
  }) => Refund
  /**
   * Create a virtual media folder. The folder materializes when assets are assigned to it.
   */
  createMediaFolder: (args: { path: ScalarsEnums['String'] }) => MediaFolderChild
  /**
   * Create a DRAFT Member Movement run (config snapshot from defaults + overrides)
   */
  createMemberMovementRun: (args: { input: CreateMemberMovementRunInput }) => MemberMovementRun
  /**
   * Create Firebase custom tokens for the Member Mirror preview. Returns a memberToken (client tenant, for widget + mobile) and a kioskToken (staff tenant, for the kiosk). Both are valid for 60 minutes.
   */
  createMemberPreviewSession: (args: {
    corporateId: ScalarsEnums['ID']
  }) => MemberPreviewSessionResult
  /**
   * Register the mobile brand for a business created before the brand registry existed, the same way creating a business does; a business that already has one is left alone
   */
  createMobileAppForCorporate: (args: {
    corporateId: ScalarsEnums['String']
  }) => Maybe<BrandIdentity>
  /**
   * Book multiple clients into multiple sessions with partial success support. Each client-session combination is booked independently with per-client error handling. Returns aggregated results with per-session, per-client outcomes.
   */
  createMultipleReservations: (args: {
    input: MultipleReservationInput
    siteId: ScalarsEnums['String']
  }) => MultipleReservationResult
  /**
   * Create multiple staff session assignments
   */
  createMultipleStaffSessionAssignments: (args: {
    assignments: Array<StaffSessionAssignmentCreateInput>
  }) => Array<StaffSessionAssignment>
  /**
   * Mint a short-lived hosted-page link for the signed-in member, or for a dependant they are the guardian of, to open in the in-app browser
   */
  createMyPendingItemsLink: (args: {
    forClientId?: Maybe<ScalarsEnums['ID']>
    siteId: ScalarsEnums['ID']
  }) => MyPendingItemsLink
  /**
   * Create an organisation client that pays for its employees
   */
  createOrganisation: (args: {
    input: CreateOrganisationInput
    siteId: ScalarsEnums['String']
  }) => CreateClientResponse
  /**
   * Get a signed upload URL for the scan of a paper policy form
   */
  createPaperScanUpload: (args: {
    clientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => PaperScanUploadTicket
  /**
   * Create new payments
   */
  createPayments: (args: {
    input: Array<CreatePaymentsInputInput>
    invoiceId: ScalarsEnums['ID']
    promoCodeUsages: Array<PromoCodeUsageInput>
    siteId: ScalarsEnums['ID']
  }) => Array<Payment>
  /**
   * Send one signer's outstanding equipment documents by text or QR code, or open them on this screen; supersedes that signer's earlier link
   */
  createPendingItemsHandoff: (args: {
    channel: PendingItemsChannel
    clientId: ScalarsEnums['ID']
    deviceTokenId?: Maybe<ScalarsEnums['ID']>
    guardianClientId?: Maybe<ScalarsEnums['ID']>
    guardianIdChecked?: Maybe<ScalarsEnums['Boolean']>
    idempotencyKey: ScalarsEnums['String']
    mobileOverride?: Maybe<ScalarsEnums['String']>
    recipientCapacity: SignerCapacity
    siteId: ScalarsEnums['ID']
    smsConsentAttested?: Maybe<ScalarsEnums['Boolean']>
  }) => PendingItemsHandoff
  /**
   * Create a new POS category
   */
  createPosCategory: (args: {
    input: CreatePosCategoryInput
    siteId: ScalarsEnums['ID']
  }) => CreatePosCategoryResponse
  /**
   * Create a new POS product with variants and attributes
   */
  createPosProduct: (args: {
    input: CreatePosProductInput
    siteId: ScalarsEnums['ID']
  }) => CreatePosProductResponse
  /**
   * Create a private session from a template and book the client atomically. Payment strategy is determined automatically: credits consumed if available, otherwise created as drop-in with pending payment.
   */
  createPrivateBooking: (args: {
    input: PrivateBookingCreateInput
    siteId: ScalarsEnums['String']
  }) => Booking
  /**
   * Create a new promo code
   */
  createPromoCode: (args: { input: PromoCodeCreateInput; siteId: ScalarsEnums['ID'] }) => PromoCode
  /**
   * Create new rebate template
   */
  createRebateTemplate: (args: { input: RebateTemplateInput }) => RebateTemplate
  /**
   * Create a new recurring session pattern and materialize initial sessions within the booking window
   */
  createRecurringSession: (args: { input: RecurringSessionCreateInput }) => RecurringSession
  /**
   * Create a new recurring session pattern from a template with scheduling and recurrence configuration
   */
  createRecurringSessionFromTemplate: (args: {
    input: RecurringSessionCreateFromTemplateInput
  }) => RecurringSession
  /**
   * Create new region
   */
  createRegion: (args: { input: CreateRegionInputInput }) => Regions
  createReleaseNote: (args: { input: ReleaseNoteCreateInput }) => ReleaseNote
  /**
   * Create room custom property requirements
   */
  createRoomCustomPropertyRequirements: (args: {
    inputs: Array<CreateSiteRoomResourceTemplatePropertyInput>
    roomResourceTemplateId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Array<SiteRoomResourceTemplateProperty>
  /**
   * Create a new room resource template
   */
  createRoomResourceTemplate: (args: {
    input: CreateSiteRoomResourceTemplateInput
    siteId: ScalarsEnums['String']
  }) => SiteRoomResourceTemplateResponse
  /**
   * Create new royalties and fees template
   */
  createRoyaltiesAndFeesTemplate: (args: {
    input: RoyaltiesAndFeesTemplateInput
  }) => RoyaltiesAndFeesTemplate
  /**
   * Create a new saved report configuration
   */
  createSavedReport: (args: { input: CreateSavedReportInputInput }) => SavedReport
  /**
   * Create a custom saved report category
   */
  createSavedReportCategory: (args: {
    name: ScalarsEnums['String']
    siteId?: Maybe<ScalarsEnums['String']>
  }) => CreateSavedReportCategory
  /**
   * Schedule a push notification for a site, or send it now when sendAtLocal is null. The time is the site's wall-clock time; the audience is resolved again at send time.
   */
  createScheduledPushSend: (args: { input: CreateScheduledPushSendInput }) => ScheduledPushSend
  /**
   * Create a new service template
   */
  createServiceTemplate: (args: {
    copyAddOnPricingFromServiceTemplateId?: Maybe<ScalarsEnums['ID']>
    input: CreateServiceTemplateInputInput
  }) => ServiceTemplate
  /**
   * Create a new service template category
   */
  createServiceTemplateCategory: (args: {
    input: CreateServiceTemplateCategoryInput
    siteId: ScalarsEnums['String']
  }) => CreateServiceTemplateCategoryResponse
  /**
   * Create an add-on pricing configuration for a session type and service template (membership or package)
   */
  createServiceTemplateSessionTypeAddOn: (args: {
    input: CreateServiceTemplateSessionTypeAddOnInput
  }) => ServiceTemplateSessionTypeAddOn
  /**
   * Create a new custom session
   */
  createSessionCustom: (args: {
    input: SessionCreateCustomInput
    siteId: ScalarsEnums['String']
  }) => Session
  /**
   * Create a new session filter
   */
  createSessionFilter: (args: {
    input: SessionFilterCreateInput
    siteId: ScalarsEnums['String']
  }) => SessionFilter
  /**
   * Create a new session from a template
   */
  createSessionFromTemplate: (args: {
    input: SessionCreateFromTemplateInput
    siteId: ScalarsEnums['String']
  }) => Session
  /**
   * Create a new session template
   */
  createSessionTemplate: (args: {
    input: SessionTemplateInput
    siteId: ScalarsEnums['String']
  }) => SessionTemplate
  /**
   * Create a Zoom meeting for a session occurrence under the site Zoom integration (MA-77)
   */
  createSessionZoomMeeting: (args: {
    id: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Session
  /**
   * Mint a single-use, expiring share link for a package you own (owner, mobile)
   */
  createSharedCreditInviteToken: (args: {
    input: CreateSharedCreditInviteInput
  }) => SharedCreditInviteTokenResult
  /**
   * Create a new site
   */
  createSite: (args: { input: CreateSiteInputInput }) => Site
  /**
   * Create a new site access point
   */
  createSiteAccessPoint: (args: {
    input: SiteAccessPointCreateInput
    siteId: ScalarsEnums['String']
  }) => SiteAccessPoint
  /**
   * Create an access zone
   */
  createSiteAccessZone: (args: { input: SiteAccessZoneCreateInput }) => SiteAccessZone
  /**
   * Create a new accounting code for a site
   */
  createSiteAccountCode: (args: {
    input: CreateSiteAccountCodeInput
    siteId: ScalarsEnums['ID']
  }) => SiteAccountCode
  /**
   * Create agreement template for testing/admin
   */
  createSiteAgreementTemplate: (args: {
    content: ScalarsEnums['String']
    effectiveDate?: Maybe<ScalarsEnums['String']>
    name: ScalarsEnums['String']
    requiresSignature?: Maybe<ScalarsEnums['Boolean']>
    siteId: ScalarsEnums['ID']
    templateUrl: ScalarsEnums['String']
    type: AgreementType
    validityDays?: Maybe<ScalarsEnums['Float']>
    version: ScalarsEnums['String']
  }) => SiteAgreementTemplate
  /**
   * Post a location alert now or schedule it
   */
  createSiteAlert: (args: { input: CreateSiteAlertInput }) => SiteAlertListItem
  /**
   * Create a new site form
   */
  createSiteForm: (args: {
    input: CreateSiteFormInputInput
    siteId: ScalarsEnums['ID']
  }) => SiteForm
  /**
   * Create an editable form at a location from a Hapana template
   */
  createSiteFormFromTemplate: (args: {
    siteId: ScalarsEnums['ID']
    templateKey: SiteFormTemplateKey
  }) => SaveScoredSiteFormResult
  /**
   * Create a new site group
   */
  createSiteGroup: (args: { input: CreateSiteGroupInputInput }) => SiteGroup
  /**
   * Create a new site location
   */
  createSiteLocation: (args: {
    input: CreateSiteLocationInput
    siteId: ScalarsEnums['ID']
  }) => SiteLocation
  /**
   * Create a new room in a site location
   */
  createSiteLocationRoom: (args: {
    input: CreateSiteLocationRoomInput
    siteId: ScalarsEnums['ID']
    siteLocationId: ScalarsEnums['ID']
  }) => SiteLocationRoom
  /**
   * Create a new payroll tier
   */
  createSitePayrollTier: (args: {
    input: CreateSitePayrollTierInputInput
    siteId: ScalarsEnums['ID']
  }) => CreateSitePayrollTier
  /**
   * Create a new payroll tier configuration
   */
  createSitePayrollTierConfiguration: (args: {
    input: CreateSitePayrollTierConfigurationInputInput
    siteId: ScalarsEnums['ID']
    sitePayrollTierId: ScalarsEnums['ID']
  }) => CreateSitePayrollTierConfiguration
  /**
   * Create a new site policy
   */
  createSitePolicy: (args: {
    input: CreateSitePolicyInputInput
    siteId: ScalarsEnums['String']
  }) => SitePolicy
  /**
   * Create a new site session type
   */
  createSiteSessionType: (args: {
    input: SiteSessionTypeInput
    siteId: ScalarsEnums['String']
  }) => SiteSessionType
  /**
   * Create site customization color
   */
  createSiteSettingsCustomizationColor: (args: {
    input: CreateSiteSettingsCustomizationColorInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Create a new site supplier
   */
  createSiteSupplier: (args: {
    input: CreateSiteSupplierInput
    siteId: ScalarsEnums['String']
  }) => CreateSiteSupplierResponse
  /**
   * Create a new site webhook. Returns the webhook with the secret (only shown once).
   */
  createSiteWebhook: (args: {
    input: CreateSiteWebhookInputInput
    siteId: ScalarsEnums['String']
  }) => CreateSiteWebhook
  /**
   * Create new SMS package for a country (currency is auto-assigned based on country)
   */
  createSmsPackage: (args: {
    /**
     * Country ID for this SMS package
     */
    countryId: ScalarsEnums['ID']
  }) => SmsPackage
  /**
   * Create a new SOAP note
   */
  createSoapNote: (args: {
    input: SoapNoteCreateInput
    siteId: ScalarsEnums['String']
  }) => CreateSoapNoteResponse
  /**
   * Create a new staff access policy
   */
  createStaffAccessPolicy: (args: { input: CreateStaffAccessPolicyInputInput }) => StaffAccessPolicy
  /**
   * Add a labelled IP address or range to the allowed networks
   */
  createStaffAllowedNetwork: (args: {
    input: CreateStaffAllowedNetworkInputInput
  }) => StaffAllowedNetwork
  /**
   * Create a new staff session assignment
   */
  createStaffSessionAssignment: (args: {
    input: StaffSessionAssignmentCreateInput
  }) => StaffSessionAssignment
  /**
   * Create a new staff user
   */
  createStaffUser: (args: { input: CreateStaffUserInputInput }) => StaffUser
  createStaffUserSmartGroup: (args: {
    input: CreateStaffUserSmartGroupInputInput
    siteId: ScalarsEnums['String']
    staffUserId: ScalarsEnums['String']
  }) => StaffUserSmartGroup
  /**
   * Create Stripe Account Session for embedded disputes component
   */
  createStripeAccountSession: (args: { siteId: ScalarsEnums['ID'] }) => CreateStripeAccountSession
  /**
   * Create Stripe Account Session for the Capital financing components
   */
  createStripeCapitalSession: (args: { siteId: ScalarsEnums['ID'] }) => CreateStripeAccountSession
  /**
   * Create Stripe Account Session for the terminal hardware shop and orders
   */
  createStripeTerminalHardwareSession: (args: {
    siteId: ScalarsEnums['ID']
  }) => CreateStripeAccountSession
  createSupportTicket: (args: { input: CreateSupportTicketInput }) => SupportTicket
  /**
   * Record a client tanning arrival without consuming credits. Returns a checkInId to pass to createEquipmentAssignment.
   */
  createTanningCheckIn: (args: {
    clientId: ScalarsEnums['ID']
    owedBalanceOverride?: Maybe<OwedBalanceOverrideInput>
    siteId: ScalarsEnums['ID']
    source: CheckInSource
  }) => CheckIn
  /**
   * Create a new tax setting
   */
  createTaxSetting: (args: {
    input: CreateTaxSettingInputInput
    siteId: ScalarsEnums['ID']
  }) => TaxSetting
  /**
   * Send missing profile details and agreement signatures to a Stripe reader for the member to complete
   */
  createTerminalHandoffRequest: (args: {
    input: CreateTerminalHandoffRequestInput
  }) => TerminalHandoffRequest
  /**
   * Provision a test member (Firebase user + Client row). Returns the one-time password. Disabled in production.
   */
  createTestMember: (args?: {
    firstName?: Maybe<ScalarsEnums['String']>
    lastName?: Maybe<ScalarsEnums['String']>
    siteId?: Maybe<ScalarsEnums['String']>
  }) => TestMemberWithCredentials
  /**
   * Create a new third party integration
   */
  createThirdPartyIntegration: (args: {
    input: ThirdPartyIntegrationCreateInput
  }) => ThirdPartyIntegrationWithKeys
  /**
   * Create a new key for a third party integration
   */
  createThirdPartyIntegrationKey: (args: {
    input: ThirdPartyIntegrationKeyCreateInput
    thirdPartyIntegrationId: ScalarsEnums['ID']
  }) => ThirdPartyIntegrationKey
  /**
   * Deactivate an accounting code. Always succeeds even if in use (DD-009).
   */
  deactivateSiteAccountCode: (args: {
    accountCodeId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => SiteAccountCode
  /**
   * Decline a PENDING buddy invite; an already-linked pair is left untouched (use revokeBookingBuddy to unlink)
   */
  declineBookingBuddy: (args: {
    buddyClientId: ScalarsEnums['ID']
    clientId: ScalarsEnums['ID']
  }) => BookingBuddyMutationResult
  /**
   * OC-7: decline a booking request awaiting staff confirmation (PENDING → DECLINED), reverse any consumed credit / void the pending drop-in invoice, and notify the member.
   */
  declineBookingRequest: (args: { bookingId: ScalarsEnums['String'] }) => Booking
  /**
   * Turn down a cover offered to you one at a time, so it goes straight to the next instructor
   */
  declineCoverOffer: (args: {
    coverRequestId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => CoverRequestView
  /**
   * Decline a family invitation addressed to the signed-in member
   */
  declineFamilyInvite: (args: { inviteToken: ScalarsEnums['String'] }) => ScalarsEnums['Boolean']
  /**
   * Decline one incoming movement (OC-1461) — the member stays at their home site and the row leaves the queue. Same guards as acceptIncomingMovement.
   */
  declineIncomingMovement: (args: {
    input: IncomingApprovalDecisionInput
  }) => IncomingApprovalDecisionResult
  /**
   * Decline an invite to share a credit-based package (recipient)
   */
  declineSharedCredits: (args: {
    input: DeclineSharedCreditsInput
  }) => ServiceCreditShareMutationResult
  /**
   * Keep the later invoices of a sale waiting on this invoice's payment, which is held for 3DS approval. Once this invoice is paid they are scheduled with the given card, or joined onto the pending membership, exactly as checkout does after a successful payment.
   */
  deferSaleFollowUp: (args: {
    input: SaleFollowUpInput
    invoiceId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Delete a price group; the prices it wrote stay as prices set by hand
   */
  deleteAddOnPriceGroup: (args: {
    addOnPriceGroupId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Delete an admin access group
   */
  deleteAdminAccessGroup: (args: { id: ScalarsEnums['ID'] }) => AdminAccessGroup
  /**
   * Delete an aggregator provider (soft delete)
   */
  deleteAggregatorProvider: (args: {
    aggregatorProviderId: ScalarsEnums['String']
  }) => DeleteAggregatorProvider
  /**
   * Delete a specific blocking reason from site settings
   */
  deleteBlockingReason: (args: {
    id: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Delete a booking
   */
  deleteBooking: (args: { id: ScalarsEnums['String'] }) => ScalarsEnums['Boolean']
  /**
   * Delete a specific cancellation reason from site settings
   */
  deleteCancellationReason: (args: {
    id: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Soft-delete every cancelled session instance tied to the given recurring patterns, ignoring date range. Returns the number deleted.
   */
  deleteCancelledSessionsByRecurrences: (args: {
    recurringSessionsIds: Array<ScalarsEnums['String']>
    siteId: ScalarsEnums['String']
  }) => ScalarsEnums['Float']
  /**
   * Delete a carousel group
   */
  deleteCarouselGroup: (args: { carouselGroupId: ScalarsEnums['ID'] }) => ScalarsEnums['Boolean']
  /**
   * Soft delete a check-in
   */
  deleteCheckIn: (args: { checkInId: ScalarsEnums['String'] }) => ScalarsEnums['Boolean']
  deleteClient: (args: {
    id: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => DeleteClientResponse
  /**
   * Delete client alert
   */
  deleteClientAlert: (args: {
    alertId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => ClientCustomAlertMutationResponse
  /**
   * Soft delete a client booking buddy relationship
   */
  deleteClientBuddy: (args: {
    buddyClientId: ScalarsEnums['String']
    clientId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => DeleteClientBuddy
  /**
   * Delete all custom property values for a client
   */
  deleteClientCustomPropertyValues: (args: {
    clientId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => DeleteClientCustomPropertyValuesResponse
  /**
   * Delete a client fees template
   */
  deleteClientFeesTemplate: (args: { id: ScalarsEnums['String'] }) => ClientFeesTemplate
  /**
   * Delete client file
   */
  deleteClientFile: (args: {
    clientId: ScalarsEnums['String']
    fileId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => DeleteClientFileResponse
  /**
   * Delete a client note
   */
  deleteClientNote: (args: {
    clientId: ScalarsEnums['String']
    noteId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => DeleteClientNoteResponse
  /**
   * Deletes a client's profile image and purges it from storage
   */
  deleteClientProfileImage: (args: { clientId: ScalarsEnums['ID'] }) => ScalarsEnums['Boolean']
  /**
   * Soft delete a client family relation
   */
  deleteClientRelation: (args: {
    clientId: ScalarsEnums['String']
    familyMemberClientId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => DeleteClientRelation
  /**
   * Soft-delete a content entry, null slug, and cancel pending schedules
   */
  deleteContentEntry: (args: { contentEntryId: ScalarsEnums['ID'] }) => ScalarsEnums['Boolean']
  /**
   * Delete a brand add-on that was never sold, with its location rows
   */
  deleteCorporateAddOn: (args: { input: CorporateServiceTemplateVersionInput }) => CorporateAddOn
  /**
   * Delete a corporate communication template version
   */
  deleteCorporateCommunicationTemplateVersion: (args: {
    corporateCommunicationTemplateId: ScalarsEnums['String']
    corporateCommunicationTemplateVersionId: ScalarsEnums['String']
  }) => ScalarsEnums['Boolean']
  /**
   * Delete a corporate FAQ
   */
  deleteCorporateFaq: (args: { corporateFaqId: ScalarsEnums['ID'] }) => CorporateFaq
  /**
   * Delete corporate payout account
   */
  deleteCorporatePayoutAccount: (args: {
    corporateId: ScalarsEnums['ID']
    id: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Delete a brand session group, removing or handing over the session type at each location
   */
  deleteCorporateSessionType: (args: {
    corporateSessionTypeId: ScalarsEnums['ID']
    withdrawMode: CorporateSessionTypeWithdrawMode
  }) => CorporateSessionType
  /**
   * Delete a brand tax type and the rows it created at each assigned location
   */
  deleteCorporateTaxSetting: (args: {
    corporateTaxSettingId: ScalarsEnums['ID']
  }) => CorporateTaxSetting
  /**
   * Delete a corporate webhook
   */
  deleteCorporateWebhook: (args: {
    corporateId: ScalarsEnums['ID']
    webhookId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Delete a custom font from the configuration
   */
  deleteCustomFont: (args: {
    corporateId: ScalarsEnums['String']
    fontName: ScalarsEnums['String']
  }) => UpdateMemberExperienceFonts
  /**
   * Delete a custom property
   */
  deleteCustomProperty: (args: {
    id: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => CustomProperty
  /**
   * Delete a custom property alert
   */
  deleteCustomPropertyAlert: (args: {
    alertId: ScalarsEnums['String']
    propertyId: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Delete a deep link
   */
  deleteDeepLink: (args: {
    corporateId: ScalarsEnums['String']
    deepLinkId: ScalarsEnums['String']
  }) => DeleteDeepLink
  /**
   * Delete a digital channel
   */
  deleteDigitalChannel: (args: {
    siteId: ScalarsEnums['ID']
    siteLocationId: ScalarsEnums['ID']
  }) => SiteLocation
  /**
   * Soft delete an equipment unit (must be available)
   */
  deleteEquipment: (args: { equipmentId: ScalarsEnums['String'] }) => ScalarsEnums['Boolean']
  /**
   * Delete a form submission and all its answers
   */
  deleteFormSubmission: (args: {
    siteId: ScalarsEnums['String']
    submissionId: ScalarsEnums['String']
  }) => DeleteFormSubmissionResponse
  /**
   * Delete a gift card design (soft delete)
   */
  deleteGiftCardDesign: (args: { giftCardDesignId: ScalarsEnums['ID'] }) => GiftCardDesign
  /**
   * Delete a gift card expiry rule; its audit history is kept
   */
  deleteGiftCardExpiryRule: (args: {
    giftCardExpiryRuleId: ScalarsEnums['ID']
  }) => DeleteGiftCardExpiryRule
  /**
   * Delete a goal
   */
  deleteGoal: (args: { goalId: ScalarsEnums['ID'] }) => ScalarsEnums['Boolean']
  /**
   * Delete a GrowHq
   */
  deleteGrowHq: (args: { growHqId: ScalarsEnums['String'] }) => GrowHq
  /**
   * Delete a hapana fees template
   */
  deleteHapanaFeesTemplate: (args: { id: ScalarsEnums['String'] }) => HapanaFeesTemplate
  deleteKnowledgeArticle: (args: {
    knowledgeArticleId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  deleteKnowledgeArticleCategory: (args: {
    knowledgeArticleCategoryId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Soft-delete a leaderboard config (must be DRAFT or ARCHIVED)
   */
  deleteLeaderboardConfig: (args: {
    leaderboardConfigId: ScalarsEnums['String']
  }) => ScalarsEnums['Boolean']
  /**
   * Soft-delete a media asset
   */
  deleteMediaAsset: (args: { contentMediaId: ScalarsEnums['ID'] }) => ScalarsEnums['Boolean']
  /**
   * Delete a virtual media folder by un-assigning all assets from it. Assets remain in the library.
   */
  deleteMediaFolder: (args: { path: ScalarsEnums['String'] }) => ScalarsEnums['Boolean']
  /**
   * Delete a pre-execution run and its movements
   */
  deleteMemberMovementRun: (args: { runId: ScalarsEnums['ID'] }) => MemberMovementDeleteResult
  /**
   * Delete all sessions and preview rows for a migration. Only allowed before execution starts.
   */
  deleteMigration: (args: { migrationId: ScalarsEnums['ID'] }) => DeleteMigration
  /**
   * Delete mobile app branding configuration
   */
  deleteMobileAppBranding: (args: {
    corporateId: ScalarsEnums['String']
  }) => DeleteMobileAppBranding
  /**
   * Delete mobile app channels configuration
   */
  deleteMobileAppChannels: (args: {
    corporateId: ScalarsEnums['String']
  }) => DeleteMobileAppChannels
  /**
   * Delete mobile app profile configuration
   */
  deleteMobileAppProfile: (args: { corporateId: ScalarsEnums['String'] }) => DeleteMobileAppProfile
  /**
   * Delete a persisted Member Movement source->destination service-template mapping
   */
  deleteMovementTemplateMapping: (args: {
    memberMovementTemplateMappingId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Deletes the current user's profile image and purges it from storage
   */
  deleteMyProfileImage: ScalarsEnums['Boolean']
  /**
   * Delete an ORPHANED sandbox database (exists on Spanner with no Corporates row pointing at it). Cleanup is pinned to the actual database id and instance. Returns the tracked cleanup jobId.
   */
  deleteOrphanedSandbox: (args: { sandboxDbId: ScalarsEnums['String'] }) => ScalarsEnums['String']
  /**
   * Delete a POS category (hard delete - only if not used by products)
   */
  deletePosCategory: (args: {
    posCategoryId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => DeletePosCategoryResponse
  /**
   * Delete a product variable/variant (soft delete - the row is kept as deleted so invoice history still resolves it, it is hidden from POS, and its SKU is released)
   */
  deletePosProductVariable: (args: {
    posProductId: ScalarsEnums['ID']
    posProductVariableId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => DeletePosProductVariableResponse
  /**
   * Deletes a staff user's profile image and purges it from storage
   */
  deleteProfileImage: (args: { staffUserId: ScalarsEnums['ID'] }) => ScalarsEnums['Boolean']
  /**
   * Delete rebate template
   */
  deleteRebateTemplate: (args: { id: ScalarsEnums['ID'] }) => ScalarsEnums['Boolean']
  /**
   * Delete a specific refund reason from site settings
   */
  deleteRefundReason: (args: {
    id: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Delete region
   */
  deleteRegion: (args: { regionId: ScalarsEnums['ID'] }) => Regions
  deleteReleaseNote: (args: { releaseNoteId: ScalarsEnums['ID'] }) => ScalarsEnums['Boolean']
  /**
   * Delete a room custom property requirement
   */
  deleteRoomCustomPropertyRequirement: (args: {
    roomResourceTemplateId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
    siteRoomResourceTemplatePropertyId: ScalarsEnums['String']
  }) => SiteRoomResourceTemplateProperty
  /**
   * Delete a room resource template
   */
  deleteRoomResourceTemplate: (args: {
    id: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => SiteRoomResourceTemplateResponse
  /**
   * Delete royalties and fees template
   */
  deleteRoyaltiesAndFeesTemplate: (args: { id: ScalarsEnums['ID'] }) => ScalarsEnums['Boolean']
  /**
   * Delete a sandbox: drop the <brand>_sandbox DB and remove its admin records (Corporates / TenantRouting / SiteIndex). Returns the tracked cleanup jobId.
   */
  deleteSandbox: (args: { brandSlug: ScalarsEnums['String'] }) => ScalarsEnums['String']
  /**
   * Soft-delete a saved report
   */
  deleteSavedReport: (args: { savedReportId: ScalarsEnums['String'] }) => DeleteSavedReport
  /**
   * Soft-delete a category (rejects if category still contains reports)
   */
  deleteSavedReportCategory: (args: {
    savedReportCategoryId: ScalarsEnums['String']
  }) => DeleteSavedReport
  /**
   * Delete a service template category (hard delete - only if not used by templates)
   */
  deleteServiceTemplateCategory: (args: {
    serviceTemplateCategoryId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => DeleteServiceTemplateCategoryResponse
  /**
   * Delete an add-on pricing configuration
   */
  deleteServiceTemplateSessionTypeAddOn: (args: {
    serviceTemplateSessionTypeAddOnId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Delete a session. For recurring sessions, optionally specify scope to delete future occurrences.
   */
  deleteSession: (args: {
    id: ScalarsEnums['String']
    scope?: Maybe<RecurringSessionEditScope>
    siteId: ScalarsEnums['String']
  }) => ScalarsEnums['Boolean']
  /**
   * Soft-delete session feedback at a site; staff only, requires session-feedback-config-enabled
   */
  deleteSessionFeedback: (args: {
    sessionFeedbackId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => DeleteSessionFeedback
  /**
   * Delete a session feedback question
   */
  deleteSessionFeedbackQuestion: (args: {
    questionId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => SessionFeedbackQuestionDeleteResponse
  /**
   * Delete a session filter
   */
  deleteSessionFilter: (args: {
    sessionFilterId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => ScalarsEnums['Boolean']
  /**
   * Delete a session (scope single) or it and every later occurrence of its series (scope future): cancel, refund and notify its bookings, then remove the sessions from the schedule and the member app
   */
  deleteSessionOccurrences: (args: {
    input: DeleteSessionOccurrencesInput
  }) => DeleteSessionOccurrencesResult
  /**
   * Delete a session template
   */
  deleteSessionTemplate: (args: {
    id: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => SessionTemplate
  /**
   * Delete a site (soft delete)
   */
  deleteSite: (args: { siteId: ScalarsEnums['ID'] }) => Site
  /**
   * Soft-delete a site access point
   */
  deleteSiteAccessPoint: (args: {
    siteAccessPointId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => SiteAccessPoint
  /**
   * Delete an access zone
   */
  deleteSiteAccessZone: (args: {
    siteAccessZoneId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => SiteAccessZone
  /**
   * Delete a location alert
   */
  deleteSiteAlert: (args: {
    siteAlertId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => SiteAlertListItem
  /**
   * Delete a site form
   */
  deleteSiteForm: (args: { id: ScalarsEnums['String']; siteId: ScalarsEnums['ID'] }) => SiteForm
  /**
   * Delete a site form question
   */
  deleteSiteFormQuestion: (args: {
    questionId: ScalarsEnums['String']
    siteFormId: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => SiteFormDeleteResponse
  /**
   * Delete a site group. A delete that takes brand items off sale needs acknowledgedWithdrawals to name each one
   */
  deleteSiteGroup: (args: {
    acknowledgedWithdrawals?: Maybe<Array<BrandServiceTemplateWithdrawalAcknowledgementInput>>
    siteGroupId: ScalarsEnums['ID']
  }) => SiteGroup
  /**
   * Delete a site location (soft delete)
   */
  deleteSiteLocation: (args: {
    siteId: ScalarsEnums['ID']
    siteLocationId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Delete a room from a site location (soft delete)
   */
  deleteSiteLocationRoom: (args: {
    siteId: ScalarsEnums['ID']
    siteLocationId: ScalarsEnums['ID']
    siteLocationRoomId: ScalarsEnums['ID']
  }) => SiteLocationRoom
  /**
   * Delete a payroll tier configuration (soft delete)
   */
  deleteSitePayrollTierConfiguration: (args: {
    siteId: ScalarsEnums['ID']
    sitePayrollTierConfigurationId: ScalarsEnums['ID']
    sitePayrollTierId: ScalarsEnums['ID']
  }) => CreateSitePayrollTierConfiguration
  /**
   * Delete a site policy
   */
  deleteSitePolicy: (args: {
    id: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => SitePolicy
  /**
   * Delete a site session type
   */
  deleteSiteSessionType: (args: {
    id: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => SiteSessionType
  /**
   * Delete site customization color
   */
  deleteSiteSettingsCustomizationColor: (args: {
    colorId: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Delete a site supplier
   */
  deleteSiteSupplier: (args: {
    siteId: ScalarsEnums['String']
    siteSupplierId: ScalarsEnums['String']
  }) => DeleteSiteSupplierResponse
  /**
   * Delete a terminal reader
   */
  deleteSiteTerminalReader: (args: {
    siteId: ScalarsEnums['ID']
    siteTerminalReaderId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Delete a site webhook
   */
  deleteSiteWebhook: (args: {
    siteId: ScalarsEnums['String']
    webhookId: ScalarsEnums['String']
  }) => ScalarsEnums['Boolean']
  /**
   * Delete a SOAP note
   */
  deleteSoapNote: (args: {
    siteId: ScalarsEnums['String']
    soapNoteId: ScalarsEnums['String']
  }) => DeleteSoapNoteResponse
  /**
   * Delete a staff access policy
   */
  deleteStaffAccessPolicy: (args: { staffAccessPolicyId: ScalarsEnums['ID'] }) => StaffAccessPolicy
  /**
   * Remove an allowed network that no team member or access policy uses
   */
  deleteStaffAllowedNetwork: (args: {
    staffAllowedNetworkId: ScalarsEnums['ID']
  }) => StaffAllowedNetwork
  /**
   * Delete a staff session assignment
   */
  deleteStaffSessionAssignment: (args: {
    staffSessionAssignmentId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Delete all staff session assignments for a specific session
   */
  deleteStaffSessionAssignmentsBySession: (args: {
    sessionId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  deleteStaffUserSmartGroup: (args: {
    siteId: ScalarsEnums['String']
    staffUserId: ScalarsEnums['String']
    staffUserSmartGroupId: ScalarsEnums['String']
  }) => ScalarsEnums['Boolean']
  /**
   * Delete a specific suspension reason from site settings
   */
  deleteSuspensionReason: (args: {
    id: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Delete a tax setting
   */
  deleteTaxSetting: (args: {
    siteId: ScalarsEnums['ID']
    taxSettingId: ScalarsEnums['ID']
  }) => TaxSetting
  /**
   * Remove a test member (deletes the Firebase user + soft-deletes the Client row)
   */
  deleteTestMember: (args: { clientId: ScalarsEnums['String'] }) => DeleteTestMember
  /**
   * Delete a third party integration (soft delete)
   */
  deleteThirdPartyIntegration: (args: {
    thirdPartyIntegrationId: ScalarsEnums['ID']
  }) => DeleteThirdPartyIntegration
  /**
   * Delete a third party integration key (soft delete)
   */
  deleteThirdPartyIntegrationKey: (args: {
    thirdPartyIntegrationId: ScalarsEnums['ID']
    thirdPartyIntegrationKeyId: ScalarsEnums['ID']
  }) => DeleteThirdPartyIntegrationKey
  deleteVideo: (args: { videoId: ScalarsEnums['ID'] }) => ScalarsEnums['Boolean']
  /**
   * Remove the Wellhub product mapping of a site session type (INT-139)
   */
  deleteWellhubProductMapping: (args: {
    siteId: ScalarsEnums['ID']
    siteSessionTypeId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Read back the App Store Connect app id for a brand whose record a person already created
   */
  detectAppStoreRecord: (args: { brandId: ScalarsEnums['String'] }) => Array<BrandSetupStepView>
  /**
   * Get a short-lived URL to upload one file straight to its final location
   */
  directUploadUrl: (args: { input: DirectUploadUrlInput }) => DirectUploadUrlResponse
  /**
   * Switch Content Library off for a brand. Entries, edits and usage history are retained.
   */
  disableContentLibrary: (args: { corporateId: ScalarsEnums['ID'] }) => ContentLibraryDisableResult
  /**
   * Disable an equipment unit (must be available)
   */
  disableEquipment: (args: { equipmentId: ScalarsEnums['String'] }) => Equipment
  /**
   * Disable a theme for a specific location. A Hapana admin may do this for any brand; a brand admin holding write_controls may do it for their own locations (OC-320 self service).
   */
  disableSiteTheme: (args: {
    corporateId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
    themeSlug: ThemeKey
  }) => ScalarsEnums['Boolean']
  /**
   * Disconnect the Zoom integration for a site (MA-77)
   */
  disconnectZoom: (args: { siteId: ScalarsEnums['ID'] }) => Site
  /**
   * Decline a blocked/failed movement (Issue 7b, PRD §9) — CAS BLOCKED|MOVE_FAILED → DISMISSED so it leaves the queue and is never re-executed; the member stays at their home site. member_movement__approve + H-1 tenant guard (inherited from BlockedReplayService).
   */
  dismissBlockedMemberMovement: (args: {
    input: DismissBlockedMovementInput
  }) => DismissBlockedMovementResult
  /**
   * Decline a failed incoming movement the location cannot complete (OC-2075): the member stays where they are and the row moves to History. Same permission as reinitiateIncomingMovement.
   */
  dismissIncomingMovement: (args: { input: DismissIncomingMovementInput }) => MemberMovementListItem
  /**
   * Download a CSV export from BigQuery
   */
  downloadBigQueryExport: (args: {
    input: DownloadBigQueryExportInput
  }) => DownloadBigQueryExportResponse
  /**
   * Issue a signed download URL for one export, valid for 15 minutes; the permission is re-checked against the export location on every click
   */
  downloadPolicyEvidenceExport: (args: {
    exportId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => PolicyEvidenceExportDownload
  /**
   * Copy a plan, as a location plan when siteId is given
   */
  duplicateCommissionPlan: (args: {
    commissionPlanId: ScalarsEnums['ID']
    name?: Maybe<ScalarsEnums['String']>
    siteId?: Maybe<ScalarsEnums['ID']>
  }) => CommissionPlan
  /**
   * Clone an existing content entry as a new draft
   */
  duplicateContentEntry: (args: { contentEntryId: ScalarsEnums['ID'] }) => CmsContentEntry
  /**
   * Copy a brand add-on into a new draft with the name sent
   */
  duplicateCorporateAddOn: (args: {
    input: DuplicateCorporateServiceTemplateInput
  }) => CorporateAddOn
  /**
   * Clone a leaderboard config as a new DRAFT
   */
  duplicateLeaderboard: (args: { leaderboardConfigId: ScalarsEnums['String'] }) => LeaderboardConfig
  /**
   * Duplicate a promo code with a new code
   */
  duplicatePromoCode: (args: {
    input: PromoCodeDuplicateInput
    promoCodeId: ScalarsEnums['ID']
  }) => PromoCode
  /**
   * Clone a saved report with a new name (targeting is NOT duplicated — defaults to ALL)
   */
  duplicateSavedReport: (args: {
    name: ScalarsEnums['String']
    savedReportId: ScalarsEnums['String']
  }) => SavedReport
  /**
   * Edit a relation — change its counterparty and/or type (replace)
   */
  editClientRelation: (args: {
    clientId: ScalarsEnums['ID']
    counterpartyClientId: ScalarsEnums['ID']
    newCounterpartyClientId: ScalarsEnums['ID']
    newType: ClientRelationType
    siteId: ScalarsEnums['ID']
    status?: Maybe<ClientRelationStatus>
    type: ClientRelationType
  }) => ClientRelationMutationResult
  /**
   * Location-wide eGym sync ("Sync all members"): enqueue a reconcile job for every qualifying member of the site.
   */
  egymBackfill: (args: { siteId: ScalarsEnums['ID'] }) => EgymBackfillResult
  /**
   * Email the client a copy of their completed form, without points or totals
   */
  emailFormSubmissionCopy: (args: {
    formSubmissionId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => EmailFormSubmissionCopyResponse
  /**
   * Email the signed-in member a copy of a form they completed, without points or totals
   */
  emailMyFormCopy: (args: {
    formSubmissionId: ScalarsEnums['String']
  }) => EmailFormSubmissionCopyResponse
  /**
   * Kill switch (Issue 7b, PRD §15.1) — halt every in-flight run (→ CANCELLED, executed stand) and set the corporate-level stop flag issue-13’s scheduler checks. member_movement__approve + assert-corporate (admin-type deferred to issue-15; see EmergencyStopService).
   */
  emergencyStopMemberMovement: (args: {
    corporateId: ScalarsEnums['ID']
  }) => EmergencyStopMemberMovementResult
  /**
   * Switch Content Library on for a brand and begin filling its Content Suite
   */
  enableContentLibrary: (args: {
    allLocations?: Maybe<ScalarsEnums['Boolean']>
    categories?: Maybe<Array<ScalarsEnums['String']>>
    corporateId: ScalarsEnums['ID']
    siteIds: Array<ScalarsEnums['ID']>
  }) => ContentLibraryStatus
  /**
   * Re-enable a disabled corporate webhook
   */
  enableCorporateWebhook: (args: {
    corporateId: ScalarsEnums['ID']
    webhookId: ScalarsEnums['ID']
  }) => CorporateWebhook
  /**
   * Re-enable a disabled equipment unit
   */
  enableEquipment: (args: { equipmentId: ScalarsEnums['String'] }) => Equipment
  /**
   * Enable a theme for a specific location within the brand subscription. A Hapana admin may do this for any brand; a brand admin holding write_controls may do it for their own locations (OC-320 self service).
   */
  enableSiteTheme: (args: {
    corporateId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
    themeSlug: ThemeKey
  }) => SiteThemeSubscription
  /**
   * Re-enable a disabled webhook
   */
  enableSiteWebhook: (args: {
    siteId: ScalarsEnums['String']
    webhookId: ScalarsEnums['String']
  }) => SiteWebhook
  /**
   * End an individual plan assignment
   */
  endCommissionAssignment: (args: {
    commissionAssignmentId: ScalarsEnums['ID']
    endDate: ScalarsEnums['String']
  }) => CommissionAssignment
  /**
   * End a location alert now
   */
  endSiteAlert: (args: {
    siteAlertId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => SiteAlertListItem
  endSupportChat: (args: { supportChatId: ScalarsEnums['ID'] }) => SupportChat
  /**
   * Return the site's main access zone, creating it if it does not exist yet
   */
  ensureMainSiteAccessZone: (args: { siteId: ScalarsEnums['String'] }) => SiteAccessZone
  /**
   * Run a provider-specific store operation for a brand
   */
  executeBrandStoreOperation: (args: {
    action: BrandStoreOperationAction
    brandId: ScalarsEnums['String']
    confirmLiveChange?: Maybe<ScalarsEnums['Boolean']>
    confirmation?: Maybe<ScalarsEnums['String']>
    platform: BrandPlatform
  }) => BrandStoreOperationsOverview
  /**
   * Execute a manual transfer (PRD §12) — gates SKIPPED, pre-flight ENFORCED, MANUAL_TRANSFER attestation required, executes through the identical issue-7a single-movement pipeline (trigger=MANUAL). member_movement__approve + tenant guard (both on ManualTransferService).
   */
  executeMemberMovementManualTransfer: (args: {
    input: ExecuteMemberMovementManualTransferInput
  }) => MemberMovementManualTransferResult
  /**
   * Manually expire a trial
   */
  expireTrial: (args: { corporateId: ScalarsEnums['ID'] }) => ScalarsEnums['Boolean']
  /**
   * Export a report as CSV and return a signed download URL
   */
  exportReport: (args: { input: ExportReportInputInput }) => ExportJobStatusResult
  /**
   * Generate and download a settlement export (XLSX)
   */
  exportSettlement: (args: { input: ExportSettlementInput }) => ExportSettlementResponse
  /**
   * Extend an active paid-in-full package or membership by a duration from its expiry date, or reactivate an expired one from today and restore the credits that expired with it.
   */
  extendService: (args: { input: ExtendServiceInput }) => ExtendServiceResult
  /**
   * Extend a trial by adding additional days
   */
  extendTrial: (args: {
    additionalDays: ScalarsEnums['Float']
    corporateId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Watchdog: fail a wedged CALCULATING run (no progress past the timeout) so it can be re-calculated
   */
  failStalledMemberMovementRun: (args: { runId: ScalarsEnums['ID'] }) => MemberMovementRun
  /**
   * MEM-51 — Finalise a Staged invoice after the client signed its linked agreement (staff "Send for signature and payment" → public web page, or the mobile pending-agreement checkout via the legacy api). Links the signed agreement to the gated invoice items, then charges due-today invoices and schedules future-dated ones on the given payment method. Replay-safe: rejects with ok=false when the invoice is no longer Staged.
   */
  finaliseInvoiceAfterPublicSigning: (args: {
    accountCreditsUsed?: Maybe<ScalarsEnums['String']>
    agreementId: ScalarsEnums['ID']
    canCompleteCardChallenge?: Maybe<ScalarsEnums['Boolean']>
    clientId: ScalarsEnums['ID']
    clientPaymentMethodId: ScalarsEnums['ID']
    invoiceId: ScalarsEnums['ID']
    paymentMethodType: PublicSigningPaymentMethodType
    siteAgreementTemplateId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
    siteTimezone: ScalarsEnums['String']
    useCredits?: Maybe<ScalarsEnums['Boolean']>
  }) => FinalisePublicSigningResult
  /**
   * Add a processed custom font to the member experience configuration
   */
  finalizeCustomFont: (args: {
    corporateId: ScalarsEnums['ID']
    font: FinalizeCustomFontFontInput
    isHeadingFont: ScalarsEnums['Boolean']
    userId: ScalarsEnums['String']
  }) => FinalizeCustomFont
  /**
   * Verify an uploaded signature image and keep it as private form evidence
   */
  finalizeFormSignatureUpload: (args: {
    signatureImageBase64?: Maybe<ScalarsEnums['String']>
    uploadId: ScalarsEnums['String']
  }) => FormSignatureAsset
  /**
   * Generate a presigned URL for uploading a mobile app branding image
   */
  generateBrandingImageUploadUrl: (args: {
    corporateId: ScalarsEnums['String']
    fieldName: BrandingImageFieldName
    format: ScalarsEnums['String']
  }) => GenerateFileUploadUrlResponse
  /**
   * Generate a Certificate Signing Request (CSR) for iOS distribution certificate
   */
  generateCertificateSigningRequest: (args: {
    corporateId: ScalarsEnums['ID']
    organization: ScalarsEnums['String']
    userId?: Maybe<ScalarsEnums['String']>
  }) => GenerateCertificateSigningRequest
  /**
   * Generate signed URL for client file upload
   */
  generateClientFileUploadUrl: (args: {
    clientId: ScalarsEnums['String']
    input: CreateClientFileInput
    siteId: ScalarsEnums['String']
  }) => GenerateClientFileUploadUrlResponse
  /**
   * Generate a Branch.io short deep link for contactless check-in QR code
   */
  generateContactlessCheckinDeepLink: (args: {
    corporateId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Maybe<ScalarsEnums['String']>
  generateCoverImageUploadUrl: (args: {
    input: GenerateCoverImageUploadUrlInput
  }) => CoverImageUploadUrl
  /**
   * Generate a single-use pairing code for a site (~15 min TTL): the full payload for a barcode or QR, plus a short typeable code. Pass deviceKind KIOSK to pair a kiosk.
   */
  generateDevicePairingCode: (args: {
    capabilities?: Maybe<Array<DeviceCapability>>
    deviceKind?: Maybe<DeviceKind>
    inputMode?: Maybe<DeviceInputMode>
    siteId: ScalarsEnums['String']
    widgetDeviceId?: Maybe<ScalarsEnums['String']>
  }) => GenerateDevicePairingCode
  /**
   * Generate a Branch.io short deep link for a door access point QR code
   */
  generateDoorAccessDeepLink: (args: {
    corporateId: ScalarsEnums['String']
    siteAccessPointId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Maybe<ScalarsEnums['String']>
  /**
   * Generate a GCS signed URL for uploading an equipment profile image
   */
  generateEquipmentImagePresignedUrl: (args: {
    equipmentId: ScalarsEnums['String']
    fileExtension: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => GenerateFileUploadUrlResponse
  /**
   * Generate a signed URL for file access
   */
  generateFileSignedUrl: (args: {
    input: GenerateFileUrlInput
  }) => Array<GenerateFileSignedUrlResponse>
  /**
   * Generate a pre-signed URL for file upload
   */
  generateFileUploadSignedUrl: (args: {
    input: GenerateFileUploadUrlInput
  }) => GenerateFileUploadUrlResponse
  generateInlineImageUploadUrl: (args: {
    input: GenerateCoverImageUploadUrlInput
  }) => CoverImageUploadUrl
  /**
   * Generate a signed upload URL for kiosk background image
   */
  generateKioskBackgroundImageUploadUrl: (args: {
    corporateId: ScalarsEnums['String']
    fileExtension: ScalarsEnums['String']
  }) => GenerateFileUploadUrlResponse
  /**
   * Generate a signed upload URL for kiosk logo image
   */
  generateKioskLogoUploadUrl: (args: {
    corporateId: ScalarsEnums['String']
    fileExtension: ScalarsEnums['String']
  }) => GenerateFileUploadUrlResponse
  generateKnowledgeArticleWithAI: (args: { input: AIArticleGenerateInput }) => AIGeneratedArticle
  /**
   * Enqueue the 9-sheet XLSX workbook build for a run (Issue 11) — off the request path; poll memberMovementWorkbookUrl for the signed download. member_movement__view + H-1 tenant guard.
   */
  generateMemberMovementWorkbook: (args: { runId: ScalarsEnums['ID'] }) => MemberMovementRun
  /**
   * Generate signed URL for uploading product image
   */
  generateProductImageUploadUrl: (args: {
    input: GenerateImagePublicSignedUrlInput
    posProductId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => GenerateFileUploadUrlResponse
  /**
   * Generate signed URL for reading room resource template image
   */
  generateRoomResourceTemplateImageSignedUrl: (args: {
    input: ImagePublicSignedUrlInput
    roomResourceTemplateId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Maybe<ImagePublicSignedUrl>
  /**
   * Generate signed URL for uploading room resource template image
   */
  generateRoomResourceTemplateImageUploadUrl: (args: {
    input: GenerateImagePublicSignedUrlInput
    roomResourceTemplateId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => GenerateFileUploadUrlResponse
  /**
   * Generate QR code for a site access point
   */
  generateSiteAccessPointQRCode: (args: {
    siteAccessPointId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => SiteAccessPoint
  /**
   * Generate a pre-signed URL for site logo upload
   */
  generateSiteLogoUploadSignedUrl: (args: {
    input: GenerateFileUploadUrlInput
  }) => GenerateFileUploadUrlResponse
  /**
   * Generate a Stripe Express Dashboard login link
   */
  generateStripeLoginLink: (args: { siteId: ScalarsEnums['ID'] }) => ScalarsEnums['String']
  /**
   * Generate a fresh Stripe Account Link for an existing connected account
   */
  generateStripeOnboardingLink: (args: { siteId: ScalarsEnums['ID'] }) => OnboardingLinkResult
  /**
   * Generate a new API key for the tanning hardware agent and store its hash
   */
  generateTanningApiKey: (args: { siteId: ScalarsEnums['String'] }) => ScalarsEnums['String']
  /**
   * Generate a signed upload URL for a video thumbnail extracted client-side
   */
  generateThumbnailUploadUrl: (args: {
    contentMediaId: ScalarsEnums['ID']
  }) => ThumbnailUploadUrlResult
  /**
   * Generate presigned URL for uploading corporate dashboard hero image
   */
  getCorporateDashboardHeroImagePresignedUrl: (args: {
    corporateId: ScalarsEnums['String']
    fileExtension: ScalarsEnums['String']
  }) => ScalarsEnums['String']
  /**
   * Generate presigned URL for uploading corporate logo image
   */
  getCorporateLogoImagePresignedUrl: (args: {
    corporateId: ScalarsEnums['String']
    fileExtension: ScalarsEnums['String']
  }) => ScalarsEnums['String']
  /**
   * Import clients from CSV file and return results
   */
  importClientsFromCSV: (args: {
    input: ImportClientsInput
    siteId: ScalarsEnums['ID']
  }) => ClientImportResult
  /**
   * Import custom text configuration from JSON with validation
   */
  importCustomText: (args: {
    corporateId: ScalarsEnums['String']
    customTextData: ScalarsEnums['JSONObject']
    sanitize: ScalarsEnums['Boolean']
    userId?: Maybe<ScalarsEnums['String']>
  }) => ImportCustomText
  /**
   * Get a short-lived URL for uploading the signature for one form question
   */
  initFormSignatureUpload: (args: {
    formSubmissionId: ScalarsEnums['String']
    format?: Maybe<FormSignatureFormat>
    siteFormQuestionId: ScalarsEnums['String']
  }) => FormSignatureUploadTicket
  /**
   * Get a short-lived URL for a signature captured while adding a client, bound to the client being added
   */
  initSignupSignatureUpload: (args: {
    expectedRevision: ScalarsEnums['Float']
    intendedClient: InitSignupSignatureUploadIntendedClientInput
    signupAttemptId?: Maybe<ScalarsEnums['ID']>
    siteFormId: ScalarsEnums['String']
    siteFormQuestionId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => SignupSignatureUploadTicket
  /**
   * Initialize onboarding checklist for a corporate (idempotent)
   */
  initializeOnboarding: (args: { corporateId: ScalarsEnums['ID'] }) => ScalarsEnums['Boolean']
  initializeVideoUpload: (args: { input: InitializeVideoUploadInput }) => VideoUploadSession
  /**
   * Create an ImportSession and generate signed URL for CSV upload
   */
  initiateCSVUpload: (args: {
    corporateId: ScalarsEnums['ID']
    fileName: ScalarsEnums['String']
    importType: ScalarsEnums['String']
    migrationId?: Maybe<ScalarsEnums['ID']>
    migrationName?: Maybe<ScalarsEnums['String']>
    sourceSystem?: Maybe<ScalarsEnums['String']>
    targetEnvironment?: Maybe<ScalarsEnums['String']>
  }) => InitiateCSVUpload
  /**
   * Initiate a new payment method setup for a client. ClientId can be null for guest checkout.
   */
  initiateClientPaymentMethod: (args: {
    clientId?: Maybe<ScalarsEnums['ID']>
    paymentModeType?: Maybe<ScalarsEnums['Float']>
    siteId: ScalarsEnums['ID']
  }) => InitiatePaymentMethodResponse
  /**
   * Create a media asset record and return a signed upload URL
   */
  initiateMediaUpload: (args: { input: InitiateMediaUploadInputInput }) => CmsContentMedia
  /**
   * Initiate execution of an APPROVED run (Issue 7a) — optionally scheduled (billing-window fenced)
   */
  initiateMemberMovementRun: (args: {
    runId: ScalarsEnums['ID']
    scheduledAt?: Maybe<ScalarsEnums['String']>
  }) => MemberMovementRun
  /**
   * Initialize setup intent for site payment method
   */
  initiateSitePaymentMethodSetup: (args: {
    siteId: ScalarsEnums['String']
  }) => SiteSetupIntentResponse
  /**
   * Initiate saving a payment method via a physical terminal reader. The reader will prompt the customer to tap/insert their card.
   */
  initiateTerminalPaymentMethodSetup: (args: {
    clientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
    terminalReaderId: ScalarsEnums['ID']
  }) => InitiateTerminalPaymentMethodSetup
  /**
   * Create an ImportSession and generate signed URL for ZIP upload
   */
  initiateZIPUpload: (args: {
    corporateId: ScalarsEnums['ID']
    fileName: ScalarsEnums['String']
    importType: ScalarsEnums['String']
    migrationId?: Maybe<ScalarsEnums['ID']>
    migrationName?: Maybe<ScalarsEnums['String']>
    siteId?: Maybe<ScalarsEnums['ID']>
    sourceSystem?: Maybe<ScalarsEnums['String']>
    targetEnvironment?: Maybe<ScalarsEnums['String']>
  }) => InitiateZIPUpload
  /**
   * Invalidate cached profile image URLs after new image upload
   */
  invalidateProfileImageCache: ScalarsEnums['Boolean']
  /**
   * Invite a staff member to join the corporate
   */
  inviteStaffMember: (args: {
    corporateId: ScalarsEnums['ID']
    invitation: InviteStaffMemberInvitationInput
  }) => InviteStaffMember
  /**
   * Complete checkout for a staged invoice holding add-ons sold on a pending membership. Moves the add-on lines onto the membership's scheduled first invoice so they are charged together on the start date, and cancels the staged invoice. Returns the membership's first invoice.
   */
  joinPresaleInvoice: (args: {
    invoiceId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Invoice
  /**
   * Leave the family the signed-in member belongs to; the last admin cannot leave while other members remain
   */
  leaveFamily: (args: { siteId: ScalarsEnums['ID'] }) => ScalarsEnums['Boolean']
  /**
   * Save a member's Fitness Passport number, checking it with validateOnly (records no visit)
   */
  linkFitnessPassportMember: (args: {
    clientId: ScalarsEnums['ID']
    fpMemberId: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => FitnessPassportLinkView
  /**
   * Link a list of employees to an organisation; each row reports its outcome
   */
  linkOrganisationEmployees: (args: {
    employees: Array<EmployeeLinkInput>
    organisationClientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Array<EmployeeLinkResult>
  /**
   * Link a site to an HQ (creates/updates GrowLocation record)
   */
  linkSiteToGrowHq: (args: {
    enabled?: Maybe<ScalarsEnums['Boolean']>
    hqId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => LinkSiteToHqResponse
  /**
   * Record a lamp change on a bed, restarting the lamp hours of the changed sets
   */
  logEquipmentLampChange: (args: { input: LogEquipmentLampChangeInput }) => Array<EquipmentLampLog>
  /**
   * Login as admin
   */
  loginAsAdmin: (args: {
    displayName?: Maybe<ScalarsEnums['String']>
    email: ScalarsEnums['String']
    photoURL?: Maybe<ScalarsEnums['String']>
    uid: ScalarsEnums['String']
  }) => AdminUser
  markAllReleaseNotesAsRead: (args: { userContext: UserContextInput }) => ScalarsEnums['Int']
  markReleaseNoteAsRead: (args: {
    releaseNoteId: ScalarsEnums['ID']
    userId: ScalarsEnums['String']
  }) => ReleaseNoteReadStatus
  /**
   * Mark a video upload as complete and trigger background transcoding
   */
  markVideoUploadComplete: (args: {
    knowledgeArticleId: ScalarsEnums['ID']
    videoId: ScalarsEnums['ID']
  }) => VideoStatus
  /**
   * Materialize a virtual recurring invoice into a real Invoice record. Returns the materialized invoice ID.
   */
  materializeVirtualInvoice: (args: {
    recurringInvoiceId: ScalarsEnums['ID']
    sequenceNumber: ScalarsEnums['Float']
  }) => ScalarsEnums['ID']
  /**
   * Execute a client merge: move all data from source to target within a single transaction
   */
  mergeClients: (args: { input: MergeClientsInput }) => MergeClientsResult
  /**
   * Edit a suspension that has not started yet. A SCHEDULED pause has applied nothing, so this is a row update and activation re-derives every consequence from it. Start date and type are editable here and nowhere else.
   */
  modifyScheduledSuspension: (args: {
    chargeAmount?: Maybe<ScalarsEnums['String']>
    chargeMode?: Maybe<ServiceSuspensionChargeMode>
    endDate?: Maybe<ScalarsEnums['String']>
    feeBillingCycleAmount?: Maybe<ScalarsEnums['Float']>
    feeBillingCycleUnit?: Maybe<ScalarsEnums['String']>
    reason?: Maybe<ScalarsEnums['String']>
    serviceSuspensionId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
    startDate?: Maybe<ScalarsEnums['String']>
    suspensionType?: Maybe<ServiceSuspensionType>
  }) => ScalarsEnums['Boolean']
  /**
   * Change the end date of an ACTIVE suspension. Re-derives the prorated deferral against the new window and applies only the difference, reconciles the recurring suspension fee's schedule, and appends a MODIFIED audit event.
   */
  modifySuspensionEndDate: (args: {
    endDate: ScalarsEnums['String']
    serviceSuspensionId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => ModifySuspensionEndDate
  /**
   * Record how many questions the signed-in member has answered on a form
   */
  myFormProgress: (args: {
    answeredCount: ScalarsEnums['Float']
    formSubmissionId: ScalarsEnums['String']
  }) => MemberFormProgress
  /**
   * Notify the next client in the queue that the equipment is ready
   */
  notifyClientInEquipmentQueue: (args: {
    clientId: ScalarsEnums['String']
    equipmentId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Equipment
  /**
   * Run every automatable provisioning step for a brand — Firebase apps, OneSignal, Branch wiring — and report per-step what ran, what was already done, and what still needs a human
   */
  onboardBrand: (args: {
    branchCredentials?: Maybe<OnboardBrandBranchCredentialsInput>
    brandId: ScalarsEnums['String']
    platform?: Maybe<BrandPlatform>
  }) => Array<BrandProvisionOutcome>
  /**
   * Open a cash drawer session with a counted starting float
   */
  openCashDrawerSession: (args: {
    siteId: ScalarsEnums['ID']
    startingCash: ScalarsEnums['Numeric']
  }) => CashDrawerSession
  /**
   * Trigger a staff-initiated remote unlock of an access point
   */
  openSiteAccessPoint: (args: {
    siteAccessPointId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => ScalarsEnums['Boolean']
  /**
   * Pause the calling member's own membership over the given dates, with the fee and billing model the operator configured on the membership. Returns the suspension id. Refused with MEMBER_PAUSE_BLOCKED and the list of blockers when a rule fails.
   */
  pauseMyMembership: (args: {
    input: MemberPauseInput
    serviceId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => ScalarsEnums['ID']
  /**
   * Permanently remove an archived content entry and all related data from the database
   */
  permanentlyDeleteContentEntry: (args: {
    contentEntryId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Post a message on a class cover thread; a manager can choose who it goes to and also send it by SMS
   */
  postCoverMessage: (args: {
    body: ScalarsEnums['String']
    bodyJson?: Maybe<ScalarsEnums['JSON']>
    coverRequestId: ScalarsEnums['ID']
    recipientMode?: Maybe<CoverMessageRecipientMode>
    recipientStaffUserIds?: Maybe<Array<ScalarsEnums['ID']>>
    sendSms?: Maybe<ScalarsEnums['Boolean']>
    siteId: ScalarsEnums['ID']
  }) => CoverMessageView
  /**
   * Start a preview of moving an agreement to another seller; returns the job id
   */
  previewCommissionOwnerChange: (args: {
    from: ScalarsEnums['String']
    serviceId: ScalarsEnums['ID']
    staffUserId: ScalarsEnums['ID']
  }) => ScalarsEnums['ID']
  /**
   * Start a preview of a plan version replayed over a period; returns the job id
   */
  previewCommissionPlanVersion: (args: {
    commissionPeriodId: ScalarsEnums['ID']
    commissionPlanId: ScalarsEnums['ID']
    data: ScalarsEnums['JSONObject']
  }) => ScalarsEnums['ID']
  /**
   * Validate uploaded CSV and trigger BullMQ parsing job for import processing
   */
  processCSVImport: (args: { importSessionId: ScalarsEnums['ID'] }) => ProcessCSVImport
  /**
   * Process a scheduled invoice immediately, ahead of its scheduled date. Handles both materialized and virtual recurring invoices (materializes first if needed). Returns the processed invoice ID.
   */
  processScheduledInvoiceNow: (args: {
    invoiceId: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => ScalarsEnums['String']
  /**
   * Validate uploaded ZIP and trigger BullMQ manifest extraction job for import processing
   */
  processZIPImport: (args: { importSessionId: ScalarsEnums['ID'] }) => ProcessZIPImport
  /**
   * Create a session per selected GCS-bundle ZIP and run the existing ZIP pipeline
   */
  processZIPImportFromGcs: (args: {
    corporateId: ScalarsEnums['ID']
    gcsUrls: Array<ScalarsEnums['String']>
    importType: ScalarsEnums['String']
    migrationId?: Maybe<ScalarsEnums['ID']>
    migrationName?: Maybe<ScalarsEnums['String']>
    sourceSystem?: Maybe<ScalarsEnums['String']>
    targetEnvironment?: Maybe<ScalarsEnums['String']>
  }) => ProcessZIPImportFromGcs
  /**
   * Promotes a prospect into a full client, creating (or adopting) their login. Returns promoted=false when the client was never a prospect.
   */
  promoteProspect: (args: {
    clientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => PromoteProspect
  provideSupportMessageFeedback: (args: {
    input: SupportMessageFeedbackInput
  }) => SupportChatMessage
  /**
   * Create whichever of the brand's Firebase apps are missing
   */
  provisionBrandFirebaseApps: (args: { brandId: ScalarsEnums['String'] }) => BrandFirebaseApps
  /**
   * Provision the V2 Spanner database and Firebase tenants for an existing corporate that is missing infrastructure (e.g. a legacy V1 brand awaiting V1→V2 migration). Idempotent: re-runs are safe when only some IDs are populated. When `requiresMigration` is true, marks the corporate as awaitingMigration so the migrations repo can pick it up.
   */
  provisionCorporateDatabase: (args: {
    corporateId: ScalarsEnums['ID']
    requiresMigration?: Maybe<ScalarsEnums['Boolean']>
  }) => Corporate
  /**
   * Provision admin access to a trial corporate. Creates a StaffUser in the demo shared DB so the admin can impersonate into the platform.
   */
  provisionTrialAccess: (args: { corporateId: ScalarsEnums['ID'] }) => ProvisionTrialAccessResponse
  /**
   * Immediately publish a content entry
   */
  publishContentEntry: (args: { contentEntryId: ScalarsEnums['ID'] }) => CmsContentEntry
  /**
   * Publish a draft brand add-on to its locations now
   */
  publishCorporateAddOn: (args: {
    input: CorporateServiceTemplateVersionInput
  }) => CorporateAddOnRolloutResult
  /**
   * Save & publish the chosen changes of a live brand add-on, and its locations, to every location
   */
  publishCorporateAddOnChanges: (args: {
    input: PublishCorporateAddOnChangesInput
  }) => CorporateAddOnRolloutResult
  /**
   * Store a published tier catalog in this environment and tell every open Core session to re-read its entitlements. Called by the internal platform when product tier definitions are published.
   */
  publishEntitlementCatalog: (args: {
    snapshot: ScalarsEnums['String']
  }) => PublishEntitlementCatalogResult
  publishKnowledgeArticle: (args: { knowledgeArticleId: ScalarsEnums['ID'] }) => KnowledgeArticle
  publishReleaseNote: (args: { releaseNoteId: ScalarsEnums['ID'] }) => ReleaseNote
  /**
   * Publish the current policy draft as a new immutable revision, immediately or from a site-local date
   */
  publishSitePolicyRevision: (args: {
    effectiveFrom?: Maybe<ScalarsEnums['String']>
    requireReacceptance?: Maybe<ScalarsEnums['Boolean']>
    siteId: ScalarsEnums['ID']
    sitePolicyId: ScalarsEnums['ID']
  }) => SitePolicyPublishResult
  /**
   * Purchase SMS package with specified option
   */
  purchaseSmsPackage: (args: {
    optionId: ScalarsEnums['String']
    paymentMethodId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
    smsPackageId: ScalarsEnums['String']
  }) => PurchaseCreditsResult
  /**
   * Raise one invoice to an organisation with a membership or pack line for each employee
   */
  raiseOrganisationInvoice: (args: {
    input: OrganisationInvoiceInput
    siteId: ScalarsEnums['ID']
  }) => Invoice
  /**
   * Recomputes every stored fob at a location from its saved card serial, after the location's credential format changed
   */
  reDeriveSiteFobs: (args: { siteId: ScalarsEnums['ID'] }) => ReDeriveSiteFobsResult
  /**
   * Restore a member deactivated under the legacy soft-delete flow (clears deletedAt)
   */
  reactivateClientAtSite: (args: {
    clientId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => BlockClientResponse
  /**
   * Admin: recompute the cached ClientSite computed fields for every client on the given sites (drift repair)
   */
  recalculateClientSiteAggregates: (args: {
    input: RecalculateClientSiteAggregatesInputInput
  }) => RecalculateClientSiteAggregates
  /**
   * Record the store's verdict on a submitted release, unlocking the next build
   */
  recordBrandReleaseStoreVerdict: (args: {
    brandId: ScalarsEnums['String']
    note?: Maybe<ScalarsEnums['String']>
    releaseId: ScalarsEnums['String']
    verdict: BrandReleaseStoreVerdict
  }) => BrandNativeRelease
  /**
   * Record pending payouts as cash leaving the given open drawer session
   */
  recordCashDrawerPayouts: (args: {
    cashDrawerSessionId: ScalarsEnums['ID']
    refundIds: Array<ScalarsEnums['ID']>
    siteId: ScalarsEnums['ID']
  }) => CashDrawerSession
  /**
   * Record a client's result assessed outside Hapana, such as a migration or a paper assessment, as their current result
   */
  recordExternalFormResult: (args: {
    assessedAt: ScalarsEnums['String']
    bandId: ScalarsEnums['ID']
    clientId: ScalarsEnums['String']
    note?: Maybe<ScalarsEnums['String']>
    siteFormId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
    source: FormExternalResultSource
  }) => ClientFormResult
  /**
   * Record a scanned paper policy form, one entry per signed slot, approved by a different staff member with their approval PIN
   */
  recordPaperPolicyForm: (args: {
    approverPin: ScalarsEnums['String']
    approverStaffUserId: ScalarsEnums['ID']
    attestationRevisionId?: Maybe<ScalarsEnums['ID']>
    clientId: ScalarsEnums['ID']
    scanUploadId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
    slots: Array<PaperPolicyFormSlotInput>
  }) => PaperPolicyFormResult
  /**
   * Redeem a gift card and add the balance to client account credits
   */
  redeemGiftCard: (args: {
    clientId: ScalarsEnums['ID']
    code: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => RedeemGiftCard
  /**
   * Redeliver a previous webhook event
   */
  redeliverWebhookEvent: (args: {
    deliveryId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
    webhookId: ScalarsEnums['String']
  }) => SiteWebhookTestResult
  /**
   * Re-drive the outstanding homeSiteId sync for a MOVED_PENDING_HOMESITE movement (→ MOVED) or a REVERTED movement with a pending home-site marker (Issue 7b deliverable 3). member_movement__approve + H-1 tenant guard (both inherited from BlockedReplayService).
   */
  redriveMemberMovementHomeSite: (args: {
    movementId: ScalarsEnums['ID']
  }) => RedriveMemberMovementHomeSiteResult
  /**
   * Refresh tokens for all HQs expiring soon (scheduled job endpoint)
   */
  refreshAllGrowHqTokens: TokenRefreshResponse
  /**
   * Check the brand's Apple team agreements and certificates against App Store Connect now
   */
  refreshAppleTeamCompliance: (args: {
    brandId: ScalarsEnums['String']
  }) => Maybe<AppleTeamCompliance>
  refreshArticlesOnly: RefreshArticlesOnlyResult
  /**
   * Refresh the audit_all_corporates view to include new corporates
   */
  refreshAuditView: ScalarsEnums['Boolean']
  refreshCodebaseAndArticles: RefreshCodebaseResult
  /**
   * Refresh the DNS verification status of a registered email domain
   */
  refreshEmailDomainStatus: (args: { corporateId: ScalarsEnums['String'] }) => CorporateEmailDomain
  /**
   * Re-check a saved Fitness Passport number on demand (validateOnly — records no visit)
   */
  refreshFitnessPassportMember: (args: {
    clientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => FitnessPassportLinkView
  /**
   * Manually refresh tokens for a specific HQ
   */
  refreshGrowHqToken: (args: { hqId: ScalarsEnums['String'] }) => TokenRefreshResponse
  /**
   * Fetch current Stripe account state and update DB (webhook fallback)
   */
  refreshStripeStatus: (args: { siteId: ScalarsEnums['ID'] }) => RefreshStripeStatusResult
  /**
   * Register the bundle id with Apple, enable the standard capabilities, and record it; idempotent, so re-running against a registered id changes nothing
   */
  registerAppleBundleId: (args: {
    brandId: ScalarsEnums['String']
    bundleIdIos: ScalarsEnums['String']
    force?: Maybe<ScalarsEnums['Boolean']>
    scheme: ScalarsEnums['String']
  }) => Array<BrandSetupStepView>
  /**
   * Register a device token for push notifications
   */
  registerDeviceToken: (args: { input: RegisterDeviceTokenInput }) => RegisterDeviceTokenResponse
  /**
   * Register a custom email domain for a corporate
   */
  registerEmailDomain: (args: {
    corporateId: ScalarsEnums['String']
    input: RegisterDomainInput
  }) => CorporateEmailDomain
  /**
   * Register a new terminal reader for a site
   */
  registerSiteTerminalReader: (args: {
    name: ScalarsEnums['String']
    registrationCode: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => SiteTerminalReader
  /**
   * Register the tanning hardware agent external credentials (called from gateway PATCH /api/tanning/register — no staff auth required)
   */
  registerTanningExternalAgent: (args: {
    externalApiKey: ScalarsEnums['String']
    externalApiUrl: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => ScalarsEnums['Boolean']
  /**
   * Re-run one failed incoming movement (OC-2075), optionally with a membership chosen for this member only. Same permission as chooseIncomingMovementDestination.
   */
  reinitiateIncomingMovement: (args: {
    input: ReinitiateIncomingMovementInput
  }) => ReinitiateIncomingMovementResult
  /**
   * Reinstate an invoice staff cancelled back to Scheduled, on its original date or on newDueDate when the original date has passed.
   */
  reinstateInvoice: (args: { input: ReinstateInvoiceInput; siteId: ScalarsEnums['ID'] }) => Invoice
  rejectKnowledgeArticleRevision: (args: {
    notes?: Maybe<ScalarsEnums['String']>
    revisionId: ScalarsEnums['ID']
  }) => KnowledgeArticleRevision
  /**
   * Rejoin a session after late cancellation. Restores the booking to CONFIRMED status. Only valid when the session has available capacity.
   */
  rejoinSession: (args: {
    bookingId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Booking
  /**
   * Approve a cover request that needs manager approval so it is offered to subs
   */
  releaseCoverRequest: (args: {
    coverRequestId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => CoverRequestView
  /**
   * Release a payment held for remote 3DS approval so another payment method or the card reader can be used. Asks the gateway first and reports succeeded when the member already approved; sends no failed-payment email.
   */
  releaseHeldPayment: (args: {
    invoiceId: ScalarsEnums['ID']
    paymentId: ScalarsEnums['ID']
    reason: HeldPaymentReleaseReason
    siteId: ScalarsEnums['ID']
  }) => HeldPaymentReleaseResult
  /**
   * Release a circuit-breaker REQUIRES_REVIEW run (RUN_APPROVAL attestation)
   */
  releaseMemberMovementRequiresReviewRun: (args: {
    attestation: MemberMovementAttestationInput
    runId: ScalarsEnums['ID']
  }) => MemberMovementRun
  /**
   * Release the in-flight terminal payment on an invoice: cancel the attempt, leave any successful payments untouched, and drop the invoice to requires_action so it can be retried. Asks the gateway first, so a tap that already landed is settled rather than voided.
   */
  releaseTerminalPayment: (args: {
    invoiceId: ScalarsEnums['ID']
    paymentId?: Maybe<ScalarsEnums['ID']>
    siteId: ScalarsEnums['ID']
  }) => ReleaseTerminalPayment
  /**
   * Remap every reviewable movement in the run sharing the source movement's source-site, source-template and destination-site triple to one destination template
   */
  remapMemberMovementsLikeForLike: (args: {
    input: RemapMemberMovementsLikeForLikeInput
  }) => RemapMemberMovementsLikeForLikeResult
  /**
   * Remove an access rule from a staff user
   */
  removeAccessRule: (args: {
    staffAccessRuleId: ScalarsEnums['ID']
    staffUserId: ScalarsEnums['ID']
  }) => StaffAccessRule
  /**
   * Remove a staff user assignment from a payroll tier
   */
  removeAssignedSitePayrollTier: (args: {
    coreUserId: ScalarsEnums['ID']
    payrollTierId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => AssignSitePayrollTier
  /**
   * Remove a tester from the store testing roster
   */
  removeBrandStoreTester: (args: {
    brandId: ScalarsEnums['String']
    testerId: ScalarsEnums['String']
  }) => Array<RemoveBrandStoreTester>
  /**
   * Remove a client from the waiting queue for an equipment unit
   */
  removeClientFromEquipmentQueue: (args: {
    clientId: ScalarsEnums['String']
    equipmentId: ScalarsEnums['String']
  }) => Equipment
  /**
   * Remove a client from a site
   */
  removeClientFromSite: (args: {
    clientId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => RemoveClientFromSiteResponse
  /**
   * Remove a client payment method (soft delete)
   */
  removeClientPaymentMethod: (args: {
    clientId: ScalarsEnums['ID']
    clientPaymentMethodId: ScalarsEnums['ID']
    replacementClientPaymentMethodId?: Maybe<ScalarsEnums['ID']>
    siteId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Remove a relation (soft-delete; SHARED removes the sharing candidate only)
   */
  removeClientRelation: (args: {
    clientId: ScalarsEnums['ID']
    counterpartyClientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
    type: ClientRelationType
  }) => ClientRelationMutationResult
  /**
   * Remove the dishonor fee from one or more payments. Soft deletes the fee line item and updates invoice totals. Accepts a single paymentId or a list of paymentIds.
   */
  removeDishonorFee: (args: {
    paymentId?: Maybe<ScalarsEnums['ID']>
    paymentIds?: Maybe<Array<ScalarsEnums['ID']>>
    siteId: ScalarsEnums['ID']
  }) => Array<Invoice>
  /**
   * Remove a custom email domain from a corporate
   */
  removeEmailDomain: (args: { corporateId: ScalarsEnums['String'] }) => RemoveEmailDomain
  /**
   * Remove a member from their family, by an admin of the family or by staff; null when the family was dissolved because no member remained
   */
  removeFamilyMember: (args: {
    clientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Maybe<Family>
  /**
   * Remove instructor from client favorites at specific site
   */
  removeFavoriteInstructor: (args: {
    clientId: ScalarsEnums['String']
    instructorId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => ScalarsEnums['Boolean']
  /**
   * Remove site from client favorites
   */
  removeFavoriteSite: (args: {
    clientId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => ScalarsEnums['Boolean']
  /**
   * Remove a client from a session waitlist
   */
  removeFromWaitlist: (args: {
    sessionWaitlistEntryId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => ScalarsEnums['Boolean']
  removeKnowledgeDocument: (args: { id: ScalarsEnums['ID'] }) => ScalarsEnums['Boolean']
  /**
   * Remove a recipient from a package you own (owner, mobile)
   */
  removeMySharedCreditRecipient: (args: {
    input: RemoveMySharedCreditRecipientInput
  }) => ServiceCreditShareMutationResult
  /**
   * Remove a session occurrence Zoom meeting — deletes API-created meetings on Zoom (MA-77)
   */
  removeSessionZoomMeeting: (args: {
    id: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Session
  /**
   * Revoke a recipient’s shared access to a package (history preserved)
   */
  removeSharedCreditRecipient: (args: {
    input: ServiceCreditShareRemoveInput
  }) => ServiceCreditShareMutationResult
  /**
   * Remove a payroll tier (soft delete)
   */
  removeSitePayrollTier: (args: {
    id: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => CreateSitePayrollTier
  /**
   * Soft delete SMS package and all its pricing options
   */
  removeSmsPackage: (args: { smsPackageId: ScalarsEnums['ID'] }) => RemoveSmsPackage
  /**
   * Soft delete pricing tier from an SMS package
   */
  removeSmsPackageOption: (args: {
    optionId: ScalarsEnums['ID']
    smsPackageId: ScalarsEnums['ID']
  }) => SmsPackage
  /**
   * Remove a staff user from a session template
   */
  removeStaffUserFromSessionTemplate: (args: {
    id: ScalarsEnums['String']
    input: SessionTemplateStaffUserInput
    siteId: ScalarsEnums['String']
  }) => SessionTemplate
  /**
   * Rename an API credential. The key, its prefix and its scopes are unchanged.
   */
  renameApiCredential: (args: {
    apiCredentialId: ScalarsEnums['ID']
    input: ApiCredentialRenameInput
  }) => ApiCredential
  /**
   * Rename a plan
   */
  renameCommissionPlan: (args: {
    commissionPlanId: ScalarsEnums['ID']
    name: ScalarsEnums['String']
  }) => CommissionPlan
  /**
   * Rename a paired device (empty clears the label back to Unnamed).
   */
  renameDevice: (args: {
    deviceTokenId: ScalarsEnums['String']
    label: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => RenameDevice
  /**
   * Rename a virtual media folder and all nested sub-folders
   */
  renameMediaFolder: (args: {
    newPath: ScalarsEnums['String']
    oldPath: ScalarsEnums['String']
  }) => MediaFolderChild
  /**
   * Reopen a closed trial — clears close reason, re-activates the corporate, extends expiry if needed
   */
  reopenTrial: (args: {
    corporateId: ScalarsEnums['ID']
    daysToExtend: ScalarsEnums['Float']
  }) => ScalarsEnums['Boolean']
  /**
   * Bulk update sortOrder for entries of a given content type (drag-and-drop reorder)
   */
  reorderContentEntries: (args: {
    contentTypeId: ScalarsEnums['ID']
    orderedIds: Array<ScalarsEnums['ID']>
  }) => ScalarsEnums['Boolean']
  /**
   * Reorder corporate FAQs by updating their display order
   */
  reorderCorporateFaqs: (args: { input: ReorderCorporateFaqsInput }) => ReorderCorporateFaqsResponse
  reorderKnowledgeArticleCategories: (args: {
    orderedIds: Array<ScalarsEnums['ID']>
  }) => ScalarsEnums['Boolean']
  /**
   * Reorder media folders by providing an ordered array of folder paths
   */
  reorderMediaFolders: (args: {
    orderedPaths: Array<ScalarsEnums['String']>
  }) => ScalarsEnums['Boolean']
  /**
   * Reorder POS categories by updating their display order
   */
  reorderPosCategories: (args: {
    input: ReorderPosCategoriesInput
    siteId: ScalarsEnums['ID']
  }) => ReorderPosCategoriesResponse
  /**
   * Batch reorder categories in a single transaction
   */
  reorderSavedReportCategories: (args: {
    orderedIds: Array<ScalarsEnums['String']>
  }) => DeleteSavedReport
  /**
   * Batch reorder saved reports within a category (categoryId may be null for uncategorized)
   */
  reorderSavedReports: (args: {
    categoryId?: Maybe<ScalarsEnums['String']>
    orderedIds: Array<ScalarsEnums['String']>
  }) => DeleteSavedReport
  /**
   * Reorder service template categories by updating their display order
   */
  reorderServiceTemplateCategories: (args: {
    input: ReorderServiceTemplateCategoriesInput
    siteId: ScalarsEnums['String']
  }) => ReorderServiceTemplateCategoriesResponse
  /**
   * Reorder a session feedback question
   */
  reorderSessionFeedbackQuestion: (args: {
    newOrder: ScalarsEnums['Int']
    questionId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => SessionFeedbackQuestionReorderResponse
  /**
   * Move a site filter view within the site group. oldOrder and newOrder are zero-based indices into the ordered list of site views, not sortOrder values
   */
  reorderSessionFilter: (args: {
    newOrder: ScalarsEnums['Float']
    oldOrder: ScalarsEnums['Float']
    sessionFilterId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => ScalarsEnums['Boolean']
  /**
   * Set the display order of session templates from one page of the Core list
   */
  reorderSessionTemplates: (args: {
    input: ReorderSessionTemplatesInput
    siteId: ScalarsEnums['String']
  }) => ReorderSessionTemplatesResult
  /**
   * Reorder a site form question
   */
  reorderSiteFormQuestion: (args: {
    newOrder: ScalarsEnums['Float']
    questionId: ScalarsEnums['String']
    siteFormId: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => SiteFormReorderResponse
  /**
   * Reorder site session types by updating their display order
   */
  reorderSiteSessionTypes: (args: {
    input: ReorderSiteSessionTypesInput
    siteId: ScalarsEnums['String']
  }) => ReorderSiteSessionTypesResponse
  reorderStaffUserSmartGroup: (args: {
    newOrder: ScalarsEnums['Float']
    oldOrder: ScalarsEnums['Float']
    siteId: ScalarsEnums['String']
    staffUserId: ScalarsEnums['String']
    staffUserSmartGroupId: ScalarsEnums['String']
  }) => ScalarsEnums['Float']
  /**
   * Replace an external video asset URL (YouTube, Vimeo, Wistia, direct .mp4/.webm/.m3u8)
   */
  replaceExternalMediaAsset: (args: {
    input: ReplaceExternalMediaAssetInputInput
  }) => CmsContentMedia
  /**
   * Replace an existing media asset file
   */
  replaceMediaAsset: (args: { input: ReplaceMediaAssetInputInput }) => CmsContentMedia
  /**
   * Replay blocked movements through the idempotent 7a execution engine (Issue 7b, PRD §9.4) — optional mappingFix resolves TEMPLATE_UNRESOLVED and persists to the corporate matrix. member_movement__approve + per-movement tenant guard; individual failures return to the queue.
   */
  replayBlockedMovements: (args: {
    input: ReplayBlockedMovementsInput
  }) => ReplayBlockedMovementsResult
  /**
   * Record a member-initiated request to delete their account
   */
  requestAccountDeletion: (args: {
    input: AccountDeletionRequestInput
  }) => AccountDeletionRequestResult
  /**
   * Allocate a build number and start a native build for one platform
   */
  requestBrandRelease: (args: {
    appVersion?: Maybe<ScalarsEnums['String']>
    brandId: ScalarsEnums['String']
    platform: BrandPlatform
    reason?: Maybe<BrandNativeReleaseReason>
    submitToReviewRequested?: Maybe<ScalarsEnums['Boolean']>
  }) => BrandNativeRelease
  /**
   * Ask for a cover on a class; a not-yet-materialised recurring occurrence is materialised first
   */
  requestCover: (args: {
    coverGroupId?: Maybe<ScalarsEnums['ID']>
    noteToSubs?: Maybe<ScalarsEnums['String']>
    originalStaffUserId?: Maybe<ScalarsEnums['ID']>
    reason?: Maybe<ScalarsEnums['String']>
    sessionId: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => CoverRequestView
  /**
   * Arm the RFID / fob terminal paired from the calling browser to register the next fob it reads onto a member. Expires after 60 seconds; arming again replaces the terminal's previous request.
   */
  requestFobCapture: (args: { input: RequestFobCaptureInput }) => RequestFobCaptureResult
  /**
   * Send a maintenance request email for an equipment unit
   */
  requestMaintenance: (args: {
    bodyHtml: ScalarsEnums['String']
    equipmentId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
    subject: ScalarsEnums['String']
  }) => ScalarsEnums['Boolean']
  /**
   * Queue a zip of signed policy documents and a CSV manifest for a date range; the requester is emailed a Core link when it is ready
   */
  requestPolicyEvidenceExport: (args: {
    includeScans: ScalarsEnums['Boolean']
    signedFrom: ScalarsEnums['String']
    signedTo: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
    sitePolicyIds?: Maybe<Array<ScalarsEnums['ID']>>
  }) => PolicyEvidenceExport
  /**
   * Send a Slack notification when a trial user requests to upgrade (temporary)
   */
  requestUpgrade: (args: {
    corporateId: ScalarsEnums['ID']
    requestedByEmail?: Maybe<ScalarsEnums['String']>
    requestedByName?: Maybe<ScalarsEnums['String']>
  }) => ScalarsEnums['Boolean']
  /**
   * End a delivery of a form and send the same form another way
   */
  rerouteFormHandoff: (args: {
    channel: FormHandoffChannel
    handoffId: ScalarsEnums['ID']
    siteId: ScalarsEnums['String']
  }) => FormHandoff
  /**
   * Reissue the invite link for a PENDING guest pass (same token)
   */
  resendGuestPass: (args: { guestPassId: ScalarsEnums['ID'] }) => GuestPass
  /**
   * Resend an invitation email with a fresh token and extended expiry
   */
  resendInvitation: (args: { invitationId: ScalarsEnums['ID'] }) => ScalarsEnums['Boolean']
  /**
   * Resend an invoice notification to the client. For paid invoices, sends a payment receipt. For processing invoices, sends a payment request. Sends via all enabled channels (email, SMS, push).
   */
  resendInvoice: (args: {
    invoiceId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => SendPaymentReminder
  /**
   * Reset all custom text for all languages
   */
  resetAllCustomText: (args: { corporateId: ScalarsEnums['String'] }) => ResetToDefaults
  /**
   * Hand one field back to the library default, undoing a brand edit
   */
  resetContentLibraryFieldOverride: (args: {
    contentEntryId: ScalarsEnums['ID']
    corporateId?: Maybe<ScalarsEnums['ID']>
    path: ScalarsEnums['String']
  }) => ContentLibraryResetOverrideResult
  /**
   * Reset an equipment unit: cancels any active assignment, sets status to available, and calls the hardware agent if integration is configured
   */
  resetEquipment: (args: { equipmentId: ScalarsEnums['String'] }) => Equipment
  /**
   * Reset branding configuration to system defaults
   */
  resetMemberExperienceBranding: (args: {
    corporateId: ScalarsEnums['String']
  }) => ResetMemberExperienceBranding
  /**
   * Reset fonts configuration to system defaults
   */
  resetMemberExperienceFonts: (args: {
    corporateId: ScalarsEnums['String']
  }) => ResetMemberExperienceFonts
  /**
   * Reset settings configuration to system defaults
   */
  resetMemberExperienceSettings: (args: {
    corporateId: ScalarsEnums['String']
  }) => ResetMemberExperienceSettings
  /**
   * Replaces the signed-in staff member's iCal feed URL for a location. The previous URL stops working.
   */
  resetMyCalendarFeedUrl: (args: { siteId: ScalarsEnums['String'] }) => ScalarsEnums['String']
  /**
   * Reset specific keys (or entire language) to member.json defaults
   */
  resetToDefaults: (args: {
    corporateId: ScalarsEnums['String']
    keys: Array<ScalarsEnums['String']>
    language: ScalarsEnums['String']
    userId?: Maybe<ScalarsEnums['String']>
  }) => ResetToDefaults
  /**
   * Give unresolved agreements a seller in bulk
   */
  resolveCommissionAttributions: (args: {
    items: Array<CommissionAttributionResolutionInput>
  }) => CommissionAttributionResolutionResult
  /**
   * Restart a running tanning session on the same bed: resend the original delay and tan time to the hardware agent without charging a new credit
   */
  restartEquipmentAssignment: (args: {
    assignmentId: ScalarsEnums['ID']
    complianceOverride?: Maybe<ComplianceOverrideInput>
  }) => RestartEquipmentAssignmentResult
  /**
   * Restore a content entry to a previous version snapshot, creating a new version record
   */
  restoreContentEntryVersion: (args: {
    contentEntryId: ScalarsEnums['ID']
    contentVersionId: ScalarsEnums['ID']
  }) => CmsContentEntry
  restoreKnowledgeArticle: (args: { knowledgeArticleId: ScalarsEnums['ID'] }) => KnowledgeArticle
  /**
   * Restore a canceled service back to active status.
   */
  restoreService: (args: {
    notes?: Maybe<ScalarsEnums['String']>
    serviceId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => ScalarsEnums['Boolean']
  /**
   * Resume the calling member's own paused membership today.
   */
  resumeMyMembership: (args: {
    serviceId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Resume a suspended service. Restores billing and credit usage.
   */
  resumeService: (args: {
    notes?: Maybe<ScalarsEnums['String']>
    restartDate?: Maybe<ScalarsEnums['String']>
    serviceId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => ScalarsEnums['Boolean']
  resyncArticlesFromCorpus: CorpusResyncResult
  /**
   * Resync status of a single equipment unit from the hardware agent
   */
  resyncEquipment: (args: { equipmentId: ScalarsEnums['String'] }) => Equipment
  /**
   * Resync status of all equipment units at a site from the hardware agent
   */
  resyncEquipments: (args: { siteId: ScalarsEnums['String'] }) => Array<Equipment>
  resyncKnowledgeArticleCategoryCounts: ScalarsEnums['Boolean']
  /**
   * Retire a jurisdiction age rule so it stops applying; its revisions are kept as history
   */
  retireEquipmentJurisdictionRule: (args: {
    reason: ScalarsEnums['String']
    ruleId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => EquipmentJurisdictionRule
  /**
   * Retry Branch.io URL generation for a deep link that failed initial creation
   */
  retryDeepLinkGeneration: (args: {
    corporateId: ScalarsEnums['String']
    deepLinkId: ScalarsEnums['String']
  }) => DeepLink
  /**
   * Push this location's unconfirmed Fitness Passport visits, as FP recommends after an outage
   */
  retryFitnessPassportVisits: (args: {
    batchSize?: Maybe<ScalarsEnums['Float']>
    siteId: ScalarsEnums['ID']
  }) => FitnessPassportRetrySummary
  /**
   * Queue failed form follow-up actions at a location to run again
   */
  retryFormWorkflowEffects: (args: {
    effectIds: Array<ScalarsEnums['String']>
    siteId: ScalarsEnums['String']
  }) => RetryFormWorkflowEffectsResponse
  /**
   * Re-attempt the payment-method migration for one executed movement (Payment Collection register retry). Idempotent — a destination that already has a bound method returns EXISTING_METHOD without creating a second gateway customer
   */
  retryMemberMovementPaymentMigration: (args: {
    input: RetryMemberMovementPaymentMigrationInput
  }) => RetryMemberMovementPaymentMigrationResult
  /**
   * Retry failed payments with same or different payment methods
   */
  retryPayments: (args: {
    input: RetryPaymentsInputInput
    invoiceId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Array<RetryPayments>
  /**
   * Send only the steps a stopped hand-off did not finish back to the reader
   */
  retryTerminalHandoffRequest: (args: {
    siteId: ScalarsEnums['ID']
    terminalHandoffRequestId: ScalarsEnums['ID']
  }) => TerminalHandoffRequest
  /**
   * Reverse a running tanning session: cancel it, restore the credit, reverse attendance, release a paid add-on and free the bed
   */
  reverseEquipmentAssignment: (args: {
    assignmentId: ScalarsEnums['ID']
  }) => ReverseEquipmentAssignmentResult
  /**
   * Revert a completed movement within 14 days (Issue 9) — cancels destination, uncancels source, restores homeSiteId; surfaces any destination charge taken for manual refund. member_movement__approve.
   */
  revertMemberMovement: (args: {
    movementId: ScalarsEnums['ID']
    reason?: Maybe<ScalarsEnums['String']>
  }) => RevertMemberMovementResult
  /**
   * Bulk approval-grid review decisions (APPROVE/REMOVE/REMAP) over a REVIEW run
   */
  reviewMemberMovements: (args: {
    input: ReviewMemberMovementsInput
  }) => ReviewMemberMovementsResult
  /**
   * Revoke an API credential. The credential row, its service user and its Firebase user are all deactivated at once, and an invalidation marker drops the edge's cached resolution on its next request, so the key stops authenticating within seconds. Only if that marker cannot be published does the edge's 30-second cache window apply.
   */
  revokeApiCredential: (args: { apiCredentialId: ScalarsEnums['ID'] }) => ApiCredential
  /**
   * Revoke/remove a buddy relationship (either party may remove it)
   */
  revokeBookingBuddy: (args: {
    buddyClientId: ScalarsEnums['ID']
    clientId: ScalarsEnums['ID']
  }) => BookingBuddyMutationResult
  /**
   * Withdraw an onboarding attestation that is no longer true
   */
  revokeBrandSetupStep: (args: {
    brandId: ScalarsEnums['String']
    step: BrandSetupStep
  }) => Array<BrandSetupStepView>
  /**
   * Revoke a Device Token — the device must re-pair.
   */
  revokeDevice: (args: {
    deviceTokenId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => RevokeDevice
  /**
   * Remove a family member's access to a family package; history is kept (package holder, family admin or staff)
   */
  revokeFamilyAllocation: (args: {
    input: RevokeFamilyAllocationInput
  }) => ServiceCreditShareMutationResult
  /**
   * Cancel a pending invite to a family by exactly one of the invited client, the invite link token or the invite link id, by an admin of the family or by staff; works with the feature off
   */
  revokeFamilyInvite: (args: {
    clientId?: Maybe<ScalarsEnums['ID']>
    familyId?: Maybe<ScalarsEnums['ID']>
    inviteLinkId?: Maybe<ScalarsEnums['String']>
    inviteToken?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['ID']
  }) => Family
  /**
   * Return an approved gift card expiry rule to draft so it stops being enforced
   */
  revokeGiftCardExpiryRule: (args: {
    giftCardExpiryRuleId: ScalarsEnums['ID']
  }) => GiftCardExpiryRuleRecord
  /**
   * Revoke a guardian's authority for the client; their acceptances stop counting and their open links are revoked
   */
  revokeGuardianAuthority: (args: {
    clientId: ScalarsEnums['ID']
    guardianClientId: ScalarsEnums['ID']
    reason?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['ID']
  }) => GuardianAuthorityRevocationResult
  /**
   * Revoke a PENDING guest pass, returning its slot to the allocation
   */
  revokeGuestPass: (args: { guestPassId: ScalarsEnums['ID'] }) => GuestPass
  /**
   * Revoke a pending staff invitation
   */
  revokeInvitation: (args: { invitationId: ScalarsEnums['ID'] }) => ScalarsEnums['Boolean']
  /**
   * Revoke all kiosk sessions for a site without changing the PIN.
   */
  revokeKioskSessions: (args: { siteId: ScalarsEnums['String'] }) => RevokeKioskSessions
  /**
   * Revoke approval of an APPROVED (not-yet-executing) run — returns it to REVIEW for editing
   */
  revokeMemberMovementRunApproval: (args: { runId: ScalarsEnums['ID'] }) => MemberMovementRun
  /**
   * Delete an export so it can no longer be downloaded
   */
  revokePolicyEvidenceExport: (args: {
    exportId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => PolicyEvidenceExport
  /**
   * Sign a team member out of every device and browser they are signed in on
   */
  revokeStaffUserSessions: (args: { staffUserId: ScalarsEnums['ID'] }) => ScalarsEnums['Boolean']
  /**
   * Revoke all Zapier tokens and deactivate subscriptions for a location
   */
  revokeZapierConnection: (args: { siteId: ScalarsEnums['ID'] }) => ScalarsEnums['Boolean']
  /**
   * Roll back to an earlier version (publishes a new version copying it)
   */
  rollbackBrandConfig: (args: {
    brandId: ScalarsEnums['String']
    expectedVersionId?: Maybe<ScalarsEnums['String']>
    targetVersionId: ScalarsEnums['String']
  }) => SavedBrandConfigVersion
  /**
   * Take credits that expired on a pack off it and add them to an active pack of the same client, in one transaction.
   */
  rolloverExpiredCredits: (args: {
    input: RolloverExpiredCreditsInput
  }) => RolloverExpiredCreditsResult
  /**
   * Rotate an API credential, replacing its secret in place. Returns the NEW cleartext secret once. The previous secret stops authenticating within seconds: the edge caches a resolved credential for 30 seconds, but rotation publishes an invalidation marker that drops the cached entry on the next request. Only if that marker cannot be published does the full 30-second window apply.
   */
  rotateApiCredential: (args: { apiCredentialId: ScalarsEnums['ID'] }) => ApiCredentialWithSecret
  /**
   * Rotate the secret for a corporate webhook
   */
  rotateCorporateWebhookSecret: (args: {
    corporateId: ScalarsEnums['ID']
    webhookId: ScalarsEnums['ID']
  }) => CorporateWebhook
  /**
   * Rotate the webhook secret. Returns the new secret (only shown once).
   */
  rotateSiteWebhookSecret: (args: {
    siteId: ScalarsEnums['String']
    webhookId: ScalarsEnums['String']
  }) => RotateSiteWebhookSecret
  /**
   * Record commission events for payments collected since a date
   */
  runCommissionBackfill: (args: { fromDate: ScalarsEnums['String'] }) => ScalarsEnums['ID']
  /**
   * Start a dry run of a period, optionally diffed against a spreadsheet CSV
   */
  runCommissionDryRun: (args: {
    commissionPeriodId: ScalarsEnums['ID']
    comparisonCsv?: Maybe<ScalarsEnums['String']>
  }) => ScalarsEnums['ID']
  /**
   * Save brand-wide default class cover settings
   */
  saveBrandCoverSettings: (args: { settings: CoverSettingsInput }) => CoverSettingsOverrides
  /**
   * Save new rates for a plan, in force from a date
   */
  saveCommissionPlanVersion: (args: {
    commissionPlanId: ScalarsEnums['ID']
    data: ScalarsEnums['JSONObject']
    effectiveFrom: ScalarsEnums['String']
  }) => CommissionPlan
  /**
   * Replace the ranked preferred subs for a location
   */
  saveCoverPreferredSubs: (args: {
    siteId: ScalarsEnums['ID']
    subs: Array<CoverPreferredSubInput>
  }) => Array<CoverPreferredSubView>
  /**
   * Replace the class types the given staff members are qualified to cover at a location; other staff are untouched
   */
  saveCoverQualifications: (args: {
    siteId: ScalarsEnums['ID']
    staff: Array<CoverStaffQualificationsInput>
  }) => Array<CoverStaffQualifications>
  /**
   * Replace a UV bed's whole manufacturer exposure schedule
   */
  saveEquipmentExposureSchedule: (args: {
    input: SaveEquipmentExposureScheduleInput
  }) => Array<EquipmentExposureScheduleRow>
  /**
   * Add a jurisdiction age rule, or save a change to one as a new revision; the age bands must cover every age with no gaps or overlaps
   */
  saveEquipmentJurisdictionRule: (args: {
    input: EquipmentJurisdictionRuleInput
    ruleId?: Maybe<ScalarsEnums['ID']>
    siteId: ScalarsEnums['ID']
  }) => EquipmentJurisdictionRule
  /**
   * Save Member Movement source->destination service-template mappings, optionally persisting them to the corporate mapping matrix for future runs
   */
  saveMovementTemplateMappings: (args: {
    corporateId: ScalarsEnums['ID']
    mappings: Array<SaveMovementTemplateMappingsMappingsInput>
    persist: ScalarsEnums['Boolean']
  }) => Array<MemberMovementTemplateMapping>
  /**
   * Save a whole form (settings, questions, points and result bands) in one revision
   */
  saveScoredSiteForm: (args: {
    expectedRevision: ScalarsEnums['Float']
    form: SaveScoredSiteFormFormInput
    questions: Array<SaveScoredSiteFormQuestionsInput>
    siteFormId?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['ID']
  }) => SaveScoredSiteFormResult
  /**
   * Save class cover settings for a location; empty fields inherit the brand default
   */
  saveSiteCoverSettings: (args: {
    settings: CoverSettingsInput
    siteId: ScalarsEnums['ID']
  }) => SiteCoverSettings
  /**
   * Replace a site's custom late-cancel fees in one transaction — entries without an id are created, entries with one updated, and omitted fees soft deleted
   */
  saveSiteLateCancelFees: (args: {
    fees: Array<SiteLateCancelFeeSaveInput>
    siteId: ScalarsEnums['ID']
  }) => Array<SiteLateCancelFee>
  /**
   * Replace a site's custom no-show fees in one transaction — entries without an id are created, entries with one updated, and omitted fees soft deleted
   */
  saveSiteNoShowFees: (args: {
    fees: Array<SiteNoShowFeeSaveInput>
    siteId: ScalarsEnums['ID']
  }) => Array<SiteNoShowFee>
  /**
   * Schedule a draft brand add-on to go live at its locations later
   */
  scheduleCorporateAddOn: (args: {
    input: ScheduleCorporateServiceTemplateInput
  }) => CorporateAddOnScheduleResult
  /**
   * Schedule a staged invoice for future payment. Attaches a payment method and updates status to Scheduled. Used for future single payments and future packages/memberships.
   */
  scheduleInvoice: (args: {
    clientId?: Maybe<ScalarsEnums['ID']>
    input: ScheduleInvoiceInput
    invoiceId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Invoice
  /**
   * Start the job that seeds sellers for active agreements; returns the job id
   */
  seedCommissionAttributions: ScalarsEnums['ID']
  /**
   * Send agreement notification email to client. With skipEmail, mints a fresh signing link (revoking prior ones) and returns it WITHOUT emailing — the "copy signing link" staff action.
   */
  sendAgreementToClient: (args: {
    agreementId: ScalarsEnums['ID']
    clientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
    skipEmail?: Maybe<ScalarsEnums['Boolean']>
  }) => SendAgreementResponse
  /**
   * Reserve and send a guest pass from the service's current allocation
   */
  sendGuestPass: (args: { input: SendGuestPassInput }) => GuestPass
  /**
   * Send a message to multiple recipients
   */
  sendMessage: (args: { input: SendMessageInput }) => SendMessageResponse
  sendPasswordResetEmail: (args: {
    clientId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => ScalarsEnums['Boolean']
  /**
   * Email, or resend, the approval link for a held payment to the invoice client's current email. The first email the provider accepts extends the hold to 24 hours; a resend reuses the same link and never extends it.
   */
  sendPaymentAuthenticationEmail: (args: {
    invoiceId: ScalarsEnums['ID']
    paymentId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => PaymentAuthenticationEmailResult
  /**
   * Send a payment reminder notification to the client for an invoice. For failed invoices, sends a failed payment notification with the failure reason. For staged/scheduled invoices, sends a payment request reminder. When sendForSignatureAndPayment=true (the staff retail "Send for signature and payment" toggle), suppresses the generic payment-request email and only sends the agreement-signing emails — the public signing page collects signature AND payment method, so the legacy "please pay your invoice" email is misleading in that context. When signatureOnly=true, only sends the agreement-signing emails for a draft invoice and the signing page collects no payment method, for a sale paid at the desk. Sends via all enabled channels (email, SMS, push).
   */
  sendPaymentReminder: (args: {
    customMessageHtml?: Maybe<ScalarsEnums['String']>
    invoiceId: ScalarsEnums['ID']
    sendForSignatureAndPayment?: Maybe<ScalarsEnums['Boolean']>
    signatureOnly?: Maybe<ScalarsEnums['Boolean']>
    siteId: ScalarsEnums['ID']
  }) => SendPaymentReminder
  /**
   * Send password reset email to a staff user
   */
  sendStaffPasswordResetEmail: (args: {
    ignorePreviousDeliveryFailure?: Maybe<ScalarsEnums['Boolean']>
    staffUserId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Send a test equipment status notification to a site equipment alerts topic. For local dev only.
   */
  sendTestEquipmentPushNotification: (args: {
    siteId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Send a test push notification to the current user topic. For local dev only.
   */
  sendTestPushNotification: (args?: {
    fcmToken?: Maybe<ScalarsEnums['String']>
  }) => ScalarsEnums['Boolean']
  /**
   * Send a test event to a webhook endpoint to verify it is working
   */
  sendTestWebhookEvent: (args: {
    eventType: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
    webhookId: ScalarsEnums['String']
  }) => SiteWebhookTestResult
  /**
   * Resend welcome email to a staff user
   */
  sendWelcomeEmail: (args: {
    ignorePreviousDeliveryFailure?: Maybe<ScalarsEnums['Boolean']>
    staffUserId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Record the Apple Developer Program membership expiry, which has no API
   */
  setAppleTeamMembershipExpiry: (args: {
    brandId: ScalarsEnums['String']
    membershipExpiresAt: ScalarsEnums['String']
  }) => Maybe<AppleTeamCompliance>
  /**
   * Set a card as the client's backup payment method for this site. Charged automatically when the membership's bank or card payment is declined. Staff only — at most one backup per client and site, cards only, and never the method that is already the default.
   */
  setBackupPaymentMethod: (args: {
    clientId: ScalarsEnums['ID']
    clientPaymentMethodId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Hold a brand so nobody can release it to the stores until the hold is cleared
   */
  setBrandReleaseHold: (args: {
    brandId: ScalarsEnums['String']
    reason: ScalarsEnums['String']
  }) => BrandReleaseHold
  /**
   * Set when a staff member can earn commission, or end it
   */
  setCommissionEligibility: (args: {
    clearEndDate?: Maybe<ScalarsEnums['Boolean']>
    commissionRolePolicyId?: Maybe<ScalarsEnums['ID']>
    endDate?: Maybe<ScalarsEnums['String']>
    reason?: Maybe<ScalarsEnums['String']>
    staffUserId: ScalarsEnums['ID']
    startDate?: Maybe<ScalarsEnums['String']>
  }) => CommissionEligibility
  /**
   * Change the seller of a one-off sale line and recalculate its commission
   */
  setCommissionLineSeller: (args: {
    invoiceItemId: ScalarsEnums['ID']
    reason: ScalarsEnums['String']
    staffUserId: ScalarsEnums['ID']
  }) => CommissionRecalcSummary
  /**
   * Change who earns on an agreement from a date, going forward or recalculated
   */
  setCommissionOwner: (args: {
    effectiveDate: ScalarsEnums['String']
    mode: CommissionOwnerChangeMode
    reason: ScalarsEnums['String']
    serviceId: ScalarsEnums['ID']
    staffUserId: ScalarsEnums['ID']
  }) => CommissionRecalcSummary
  /**
   * Set or clear the plan a staff role uses, for the brand or one location
   */
  setCommissionRoleDefault: (args: {
    commissionPlanId?: Maybe<ScalarsEnums['ID']>
    siteId?: Maybe<ScalarsEnums['ID']>
    staffAccessPolicyId: ScalarsEnums['ID']
    startDate?: Maybe<ScalarsEnums['String']>
  }) => Array<CommissionRoleDefault>
  /**
   * Order the staff roles that carry a commission plan
   */
  setCommissionRolePriority: (args: {
    staffAccessPolicyIds: Array<ScalarsEnums['ID']>
  }) => Array<ScalarsEnums['ID']>
  /**
   * Switch commissions on or off for the brand
   */
  setCommissionsEnabled: (args: { enabled: ScalarsEnums['Boolean'] }) => CommissionEnablement
  /**
   * Switch Content Library on for every location of a brand, including new ones, or stop doing so
   */
  setContentLibraryAllLocations: (args: {
    corporateId: ScalarsEnums['ID']
    enabled: ScalarsEnums['Boolean']
  }) => ContentLibraryStatus
  /**
   * Choose which catalogue categories are provisioned for a brand
   */
  setContentLibraryCategoryScope: (args: {
    categories: Array<ScalarsEnums['String']>
    corporateId: ScalarsEnums['ID']
  }) => ContentLibraryStatus
  /**
   * Switch Content Library on or off for a single location
   */
  setContentLibrarySiteEnablement: (args: {
    corporateId: ScalarsEnums['ID']
    enabled: ScalarsEnums['Boolean']
    siteId: ScalarsEnums['ID']
  }) => ContentLibraryStatus
  /**
   * Full-replace visibility targeting for a content entry — deletes all existing targets and inserts new ones
   */
  setContentTargeting: (args: {
    contentEntryId: ScalarsEnums['ID']
    input: SetContentTargetingInputInput
  }) => CmsContentEntry
  /**
   * Enable/disable corporate-wide client lookup (adminConfigurations.system.corporateClientLookup) — required for cross-site member search such as the Member Movement Eligibility Explorer. Requires the write_controls corporate permission.
   */
  setCorporateClientLookupEnabled: (args: {
    corporateId: ScalarsEnums['ID']
    enabled: ScalarsEnums['Boolean']
  }) => ScalarsEnums['Boolean']
  /**
   * Mark a corporate as in onboarding. Support tickets raised from Core for an in-onboarding brand are tagged in HubSpot so the onboarding team sees them first.
   */
  setCorporateIsOnboarding: (args: {
    corporateId: ScalarsEnums['ID']
    isOnboarding: ScalarsEnums['Boolean']
  }) => Corporate
  /**
   * Enable/disable blocking check-in, bookings and tans at every location while the client owes at any location (adminConfigurations.system.blockWhenClientOwesAtAnyLocation). Requires the write_controls corporate permission.
   */
  setCorporateOwedBalanceBlockEnabled: (args: {
    corporateId: ScalarsEnums['ID']
    enabled: ScalarsEnums['Boolean']
  }) => ScalarsEnums['Boolean']
  /**
   * Set a payment method as the default for a client. When applyToRecurringPayments is true, also repoint every existing recurring/scheduled invoice to the new card (atomically).
   */
  setDefaultPaymentMethod: (args: {
    applyToRecurringPayments?: Maybe<ScalarsEnums['Boolean']>
    clientId: ScalarsEnums['ID']
    clientPaymentMethodId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Set which credential a paired device reads: BARCODE, or FOB for an RFID fob/card reader (INT-578).
   */
  setDeviceInputMode: (args: {
    deviceTokenId: ScalarsEnums['ID']
    inputMode: DeviceInputMode
    siteId: ScalarsEnums['ID']
  }) => SetDeviceInputMode
  /**
   * Attach the staff-typed device name to a site's active Pairing Barcode.
   */
  setDevicePairingCodeLabel: (args: {
    label: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => SetDevicePairingCodeLabel
  /**
   * Set the optional capabilities of a paired kiosk (FORMS lets it show forms sent from Core).
   */
  setDeviceScopes: (args: {
    capabilities: Array<DeviceCapability>
    deviceTokenId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => SetDeviceScopes
  /**
   * Set GHL authentication for a GrowHq
   */
  setGrowHqAuthentication: (args: {
    code: ScalarsEnums['String']
    growHqId: ScalarsEnums['String']
  }) => GrowHq
  /**
   * Set or update the PIN for a site kiosk. Invalidates all existing kiosk sessions.
   */
  setKioskPin: (args: {
    pin: ScalarsEnums['String']
    sessionValidityDays?: Maybe<ScalarsEnums['Float']>
    siteId: ScalarsEnums['String']
  }) => SetKioskPin
  /**
   * Replace the staff notified when members qualify to move into a location (OC-2075). Same guard as setMemberMovementLocationPosture.
   */
  setMemberMovementIncomingNotifiers: (args: {
    input: SetMemberMovementIncomingNotifiersInput
  }) => MemberMovementLocationPosture
  /**
   * Set or clear (null) a location’s rolling approval override (OC-2075). Needs member_movement__manage_incoming at the location or corporate member_movement__configure.
   */
  setMemberMovementLocationPosture: (args: {
    input: SetMemberMovementLocationPostureInput
  }) => MemberMovementLocationPosture
  /**
   * Turn rolling mode on/off for a corporate (Issue 13). ENABLE registers the rolling-evaluation (+ optional daily blocked-digest) crons and requires a ROLLING_ENABLE attestation; DISABLE deregisters them. member_movement__approve + assert-corporate tenant guard.
   */
  setMemberMovementRollingMode: (args: { input: SetRollingModeInput }) => SetRollingModeResult
  /**
   * Set or change the signed-in staff member’s paper form approval PIN
   */
  setMyApprovalPin: (args: {
    currentPin?: Maybe<ScalarsEnums['String']>
    pin: ScalarsEnums['String']
  }) => ApprovalPinStatus
  /**
   * Set or clear the current staff user's personal default schedule view for a site
   */
  setMyDefaultScheduleView: (args: {
    siteId: ScalarsEnums['ID']
    viewRef?: Maybe<ScalarsEnums['String']>
  }) => Maybe<ScalarsEnums['String']>
  /**
   * Set or clear the current staff user's My Schedule range window (days) for a site
   */
  setMyScheduleRangeDays: (args: {
    rangeDays?: Maybe<ScalarsEnums['Int']>
    siteId: ScalarsEnums['ID']
  }) => Maybe<ScalarsEnums['Int']>
  /**
   * Set location targeting for a saved report category (full-replace pattern). Corporate admin only.
   */
  setSavedReportCategoryTargeting: (args: {
    savedReportCategoryId: ScalarsEnums['String']
    targets?: Maybe<Array<SetSavedReportCategoryTargetingTargetsInput>>
    visibilityScope: VisibilityScope
  }) => SetSavedReportCategoryTargeting
  /**
   * Set location targeting for a saved report (full-replace pattern). Corporate admin only.
   */
  setSavedReportTargeting: (args: {
    savedReportId: ScalarsEnums['String']
    targets?: Maybe<Array<SetSavedReportTargetingTargetsInput>>
    visibilityScope: VisibilityScope
  }) => SetSavedReportTargeting
  /**
   * Activate (register) or deactivate (remove) a scheduled job; returns the resulting registered state
   */
  setScheduledJobActive: (args: {
    active: ScalarsEnums['Boolean']
    corporateId?: Maybe<ScalarsEnums['ID']>
    jobKey: ScalarsEnums['String']
    siteId?: Maybe<ScalarsEnums['ID']>
  }) => ScalarsEnums['Boolean']
  /**
   * Set a membership's or package's add-on price per price group; an empty or zero price removes it
   */
  setServiceTemplateAddOnPriceGroupPrices: (args: {
    input: SetServiceTemplateAddOnPriceGroupPricesInput
  }) => Array<AddOnPriceGroupPrice>
  /**
   * Replace a schedule template's session-feedback question selection
   */
  setSessionTemplateFeedbackQuestions: (args: {
    input: SetSessionTemplateFeedbackQuestionsInputInput
    sessionTemplateId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => SetSessionTemplateFeedbackQuestions
  /**
   * Enable or disable site-level webhooks for a corporate. When disabled, only corporate-level webhooks receive events.
   */
  setSiteWebhooksEnabled: (args: {
    corporateId: ScalarsEnums['ID']
    enabled: ScalarsEnums['Boolean']
  }) => Corporate
  /**
   * Replace the allowed networks a team member can sign in from. With siteId, only that location's networks are replaced
   */
  setStaffUserAllowedNetworks: (args: {
    allowedNetworkIds: Array<ScalarsEnums['ID']>
    previousAllowedNetworkIds?: Maybe<Array<ScalarsEnums['ID']>>
    siteId?: Maybe<ScalarsEnums['ID']>
    staffUserId: ScalarsEnums['ID']
  }) => StaffUser
  /**
   * Deploy one add-on to exactly this set of the brand's locations, disabling the rest — the add-ons panel expresses a desired set, and resolving it against the brand's real locations has to happen server-side. A Hapana admin may do this for any brand; a brand admin holding write_controls may do it for their own (OC-320 self service).
   */
  setThemeDeployment: (args: {
    corporateId: ScalarsEnums['ID']
    siteIds: Array<ScalarsEnums['ID']>
    themeSlug: ThemeKey
  }) => ThemeDeploymentResult
  /**
   * Map a site session type to a Wellhub product; remapping to a different product resets the synced Wellhub class (INT-139)
   */
  setWellhubProductMapping: (args: {
    externalProductId: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
    siteSessionTypeId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Validate Ezypay credentials, encrypt the password via KMS, and persist a SitePaymentGateway row
   */
  setupEzypayGateway: (args: { input: SetupEzypayGatewayInput }) => SetupEzypayGatewayPayload
  /**
   * Shift all future invoice dates of a recurring invoice forward by X days. Updates nextInvoiceDate and all materialized scheduled invoices.
   */
  shiftRecurringInvoiceDates: (args: {
    applyTo: ShiftDatesApplyTo
    recurringInvoiceId: ScalarsEnums['ID']
    shiftDays: ScalarsEnums['Float']
    siteId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Move the client's active and suspended recurring invoices onto the given payment method. Returns how many were shifted and any that were skipped (e.g. bank/card-only template restrictions).
   */
  shiftRecurringInvoicesToPaymentMethod: (args: {
    clientId: ScalarsEnums['ID']
    clientPaymentMethodId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => ShiftRecurringInvoicesResult
  /**
   * Sign a client agreement (PENDING → ACTIVE). Requires one signature per {{SIGNATURE}} tag.
   */
  signClientAgreement: (args: {
    agreementId: ScalarsEnums['ID']
    agreementMethod: AgreementMethod
    clientId: ScalarsEnums['ID']
    ipAddress?: Maybe<ScalarsEnums['String']>
    signatures: Array<ScalarsEnums['String']>
    siteId: ScalarsEnums['ID']
    userAgent?: Maybe<ScalarsEnums['String']>
  }) => ClientAgreement
  /**
   * Skip every error row across multiple import sessions in one operation (reversible per-session via unskipImportRows)
   */
  skipAllErrors: (args: { importSessionIds: Array<ScalarsEnums['ID']> }) => SkipAllErrors
  /**
   * Mark rows excluded from import execution (reversible via unskipImportRows)
   */
  skipImportRows: (args: {
    allWithErrors?: Maybe<ScalarsEnums['Boolean']>
    importSessionId: ScalarsEnums['ID']
    rowIndexes?: Maybe<Array<ScalarsEnums['Float']>>
  }) => SkipImportRows
  /**
   * Skip an onboarding step
   */
  skipOnboardingStep: (args: {
    corporateId: ScalarsEnums['ID']
    stepKey: OnboardingStepKey
  }) => ScalarsEnums['Boolean']
  softDeleteKnowledgeArticle: (args: { knowledgeArticleId: ScalarsEnums['ID'] }) => KnowledgeArticle
  /**
   * Stage a Holiday Destination Fee invoice for a visiting client (no charge)
   */
  stageDestinationFee: (args: {
    bookingId?: Maybe<ScalarsEnums['ID']>
    clientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => StageDestinationFeeResult
  /**
   * Start a job to clear previously seeded demo data for a corporate
   */
  startDemoClear: (args: { corporateId: ScalarsEnums['String'] }) => DemoSeedingJob
  /**
   * Start a new demo data seeding job for a corporate
   */
  startDemoSeed: (args: {
    config?: Maybe<DemoSeedingConfigInput>
    corporateId: ScalarsEnums['String']
    persona?: Maybe<DemoSeedingPersona>
  }) => DemoSeedingJob
  /**
   * Start an async CSV export job and return a jobId for polling progress
   */
  startExportJob: (args: { input: ExportReportInputInput }) => StartExportJob
  /**
   * Start (or force re-run) validation for a migration’s import sessions
   */
  startImportValidation: (args: {
    force?: Maybe<ScalarsEnums['Boolean']>
    migrationId: ScalarsEnums['String']
  }) => StartImportValidation
  /**
   * Start texting pending-items links to the selected report clients, at most 5,000, through the normal consent, opt-out and quiet-hours rules
   */
  startPolicyBulkSend: (args: {
    clientIds?: Maybe<Array<ScalarsEnums['ID']>>
    equipmentCategory?: Maybe<PolicyEquipmentScope>
    search?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['ID']
    statuses?: Maybe<Array<EquipmentComplianceStatus>>
  }) => PolicyBulkSendRun
  /**
   * Create a Stripe Express connected account and generate the first onboarding link
   */
  startStripeOnboarding: (args: {
    input: StartStripeConnectOnboardingInput
  }) => StartStripeOnboardingResult
  startSupportChat: (args: { input: StartSupportChatInput }) => SupportChatWithMessages
  startSupportChatStream: (args: { input: StartSupportChatInput }) => StartSupportChatStreamResult
  /**
   * Start a trial for a corporate (typically called after demo creation)
   */
  startTrial: (args: {
    corporateId: ScalarsEnums['ID']
    durationDays: ScalarsEnums['Float']
    leadSource?: Maybe<LeadSource>
  }) => ScalarsEnums['Boolean']
  streamSupportMessage: (args: { input: StreamSupportMessageInput }) => StreamSupportMessageResult
  /**
   * Hand the six-digit code Apple sent to the sign-in that is waiting for it
   */
  submitAppleTwoFactorCode: (args: { code: ScalarsEnums['String'] }) => AppleAccountSession
  /**
   * Submit questionnaire forms for a client
   */
  submitClientForms: (args: {
    clientId: ScalarsEnums['String']
    questionnaireAnswers: Array<SubmitClientFormsQuestionnaireAnswersInput>
    siteId: ScalarsEnums['String']
  }) => SubmitClientFormsResponse
  /**
   * Submit form answers
   */
  submitFormAnswers: (args: {
    answers: Array<SubmitFormAnswersAnswersInput>
    formSubmissionId: ScalarsEnums['String']
    signature?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['String']
  }) => SubmitClientFormsResponse
  /**
   * Submit a member's answers to the feedback questions their attended session asks; requires session-feedback-config-enabled
   */
  submitMemberSessionFeedback: (args: {
    input: MemberSessionFeedbackInput
  }) => SubmitSessionFeedback
  /**
   * Complete an outstanding form as the signed-in member
   */
  submitMyForm: (args: {
    answers: Array<MemberFormAnswerInput>
    channel?: Maybe<MemberFormChannel>
    formSubmissionId: ScalarsEnums['String']
  }) => MemberFormCompletion
  /**
   * Submit feedback for a session
   */
  submitSessionFeedback: (args: { input: SubmitSessionFeedbackInputInput }) => SubmitSessionFeedback
  /**
   * Subscribe FCM token to staff check-in alerts for a specific site.
   */
  subscribeToStaffCheckInAlerts: (args: {
    fcmToken: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Subscribe FCM token to staff equipment alerts for a specific site.
   */
  subscribeToStaffEquipmentAlerts: (args: {
    fcmToken: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Subscribe FCM token to staff terminal alerts for a specific site.
   */
  subscribeToStaffTerminalAlerts: (args: {
    fcmToken: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Subscribe FCM token to user-specific topic for push notifications.
   */
  subscribeToUserTopic: (args: { fcmToken: ScalarsEnums['String'] }) => ScalarsEnums['Boolean']
  /**
   * Substitute an instructor in a session
   */
  substituteInstructor: (args: {
    input: SubstituteInstructorInput
    siteId: ScalarsEnums['String']
  }) => Session
  /**
   * Suspend a service. If startDate is in the future, creates a scheduled suspension.
   */
  suspendService: (args: {
    bookingIds?: Maybe<Array<ScalarsEnums['String']>>
    chargeAmount?: Maybe<ScalarsEnums['Numeric']>
    chargeMode?: Maybe<ServiceSuspensionChargeMode>
    endDate?: Maybe<ScalarsEnums['String']>
    failedInvoiceIds?: Maybe<Array<ScalarsEnums['String']>>
    feeBillingCycleAmount?: Maybe<ScalarsEnums['Float']>
    feeBillingCycleUnit?: Maybe<ScalarsEnums['String']>
    reason?: Maybe<ScalarsEnums['String']>
    serviceId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
    startDate?: Maybe<ScalarsEnums['String']>
    suspensionType?: Maybe<ServiceSuspensionType>
  }) => ScalarsEnums['String']
  /**
   * Create several non-overlapping pauses for one membership. The whole set is validated first — pairwise, and against every ACTIVE or SCHEDULED pause the service already holds — and refused before anything is written if any window collides. The pauses are then created one at a time, because the suspend path moves money after its own commit and so cannot share a transaction: on a failure the result names the pause that failed and lists the ones that were created, which cancelScheduledSuspension undoes. Refused outright when multiple-pauses-enabled is off and more than one pause is sent.
   */
  suspendServiceBatch: (args: {
    bookingIds?: Maybe<Array<ScalarsEnums['ID']>>
    failedInvoiceIds?: Maybe<Array<ScalarsEnums['ID']>>
    pauses: Array<SuspendServiceBatchPauseInput>
    serviceId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => SuspendServiceBatchResult
  /**
   * Switch an upcoming drop-in booking to paying with credits: the class credit cost is taken from the selected package, or split across the member own packages in order, and the drop-in invoice is voided when unpaid or refunded to the original payment method
   */
  switchBookingToCredit: (args: {
    additionalServiceIds?: Maybe<Array<ScalarsEnums['ID']>>
    bookingId: ScalarsEnums['ID']
    serviceId: ScalarsEnums['ID']
  }) => Booking
  /**
   * Switch a confirmed, upcoming credit booking to the class drop-in rate: its credits go back to the package(s) that paid them and the booking becomes an unpaid drop-in the member pays before check-in. Only for classes that take both credits and a drop-in rate
   */
  switchBookingToDropIn: (args: { bookingId: ScalarsEnums['ID'] }) => Booking
  /**
   * Replace staged listing metadata with the current Apple and Google listings
   */
  syncBrandStoreListingsFromProviders: (args: {
    brandId: ScalarsEnums['String']
  }) => Array<SyncBrandStoreListingsFromProviders>
  /**
   * Refresh Apple App Store Connect and Google Play connectivity for a brand
   */
  syncBrandStoreProviderStatus: (args: {
    brandId: ScalarsEnums['String']
  }) => BrandStoreOperationsOverview
  /**
   * Sync one or more clients to Grow (full per-client refresh across all their locations incl. linked HQ)
   */
  syncClientsToGrow: (args: {
    clientIds: Array<ScalarsEnums['String']>
  }) => SyncClientsToGrowResponse
  syncKnowledgeArticlesToVertexSearch: SyncToVertexResult
  /**
   * Replace an add-on template's full set of parent attachments (empty array detaches all). The 'recurring requires an active parent RecurringInvoice' rule is enforced at purchase (OC-880), not here.
   */
  syncServiceTemplateAddOnParents: (args: {
    input: SyncServiceTemplateAddOnParentsInput
  }) => Array<ServiceTemplateAddOn>
  /**
   * Sync all SMS package options in one transaction - handles add, update, and delete automatically
   */
  syncSmsPackageOptions: (args: {
    input: SyncSmsPackageOptionsInputInput
    smsPackageId: ScalarsEnums['ID']
  }) => SmsPackage
  /**
   * Generate a signed download URL for the tanning agent installer
   */
  tanningAgentDownloadUrl: TanningAgentDownloadUrl
  /**
   * Terminate an active impersonation session
   */
  terminateImpersonationSession: (args: {
    sessionId: ScalarsEnums['String']
  }) => ScalarsEnums['Boolean']
  /**
   * Call Apple with the brand's credentials to prove they are actually accepted
   */
  testAppleApiConnection: (args: { brandId: ScalarsEnums['String'] }) => TestAppleApiConnection
  /**
   * Run an OAuth + merchant probe against the saved Ezypay gateway
   */
  testEzypayConnection: (args: { siteId: ScalarsEnums['ID'] }) => TestEzypayConnectionPayload
  /**
   * Re-prove the stored Fitness Passport tokens without changing configuration
   */
  testFitnessPassportConnection: (args: {
    siteId: ScalarsEnums['ID']
  }) => FitnessPassportConnectionTest
  /**
   * Test HQ authentication by making a test API call to Grow
   */
  testGrowHqAuth: (args: { hqId: ScalarsEnums['String'] }) => TestHqAuthResponse
  /**
   * Test site authentication by making a test API call to Grow using HQ credentials
   */
  testGrowLocationAuth: (args: { siteId: ScalarsEnums['String'] }) => TestSiteAuthResponse
  /**
   * Test an access point provider connection; pass siteAccessPointId to reuse the stored password when the submitted one is blank
   */
  testSiteAccessPointConnection: (args: {
    externalConfig: ScalarsEnums['JSONObject']
    provider: DoorProvider
    siteAccessPointId?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['String']
  }) => DoorHealthCheckResult
  /**
   * Send a sample email and signature screen to a reader to check it can show forms
   */
  testTerminalHandoff: (args: {
    siteId: ScalarsEnums['ID']
    siteTerminalReaderId: ScalarsEnums['ID']
  }) => TerminalHandoffRequest
  /**
   * Toggle report favorite status for current user
   */
  toggleFavoriteReport: (args: { reportName: ScalarsEnums['String'] }) => ScalarsEnums['Boolean']
  /**
   * Toggle saved report favorite status for current user
   */
  toggleFavoriteSavedReport: (args: {
    savedReportId: ScalarsEnums['String']
  }) => ScalarsEnums['Boolean']
  /**
   * Toggle front desk kiosk beta
   */
  toggleFrontDeskKioskBeta: (args: {
    enabled: ScalarsEnums['Boolean']
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Toggle site favorite status for current user
   */
  toggleSiteFavorite: (args: { siteId: ScalarsEnums['String'] }) => ScalarsEnums['Boolean']
  /**
   * Transfer a client from one site to another
   */
  transferClient: (args: {
    clientId: ScalarsEnums['String']
    fromSiteId: ScalarsEnums['String']
    newSiteSpecificData?: Maybe<AddClientToSiteSiteSpecificDataInput>
    toSiteId: ScalarsEnums['String']
  }) => TransferClientResponse
  /**
   * Close, reopen or mark paid a commission period
   */
  transitionCommissionPeriod: (args: {
    commissionPeriodId: ScalarsEnums['ID']
    revision?: Maybe<ScalarsEnums['Int']>
    to: CommissionPeriodTransitionTarget
  }) => CommissionPeriod
  /**
   * QA tooling: recreate this feature env brand DB from the latest golden backup and repoint it (no restart). Feature/local + admin only.
   */
  triggerFeatureDataRefresh: (args: { corporateId: ScalarsEnums['ID'] }) => FeatureDataRefreshStatus
  /**
   * Fetch and update GHL custom field mappings for an HQ location
   */
  triggerGrowHqCustomFieldsSync: (args: {
    hqId: ScalarsEnums['String']
  }) => TriggerGrowHqCustomFieldsSyncResponse
  /**
   * Sync unsynced SiteCustomProperty definitions to GHL as custom fields for a site
   */
  triggerGrowLocationCustomFieldsSync: (args: {
    siteId: ScalarsEnums['String']
  }) => TriggerGrowSiteCustomFieldsSyncResponse
  /**
   * Trigger HQ sync job (publishes via Cloud Tasks and returns immediately)
   */
  triggerHqSync: (args: {
    forceRecalculate?: Maybe<ScalarsEnums['Boolean']>
    migratedTag: ScalarsEnums['Boolean']
  }) => TriggerHqSyncResponse
  /**
   * Trigger a sync job for a specific HQ and all its linked sites
   */
  triggerHqSyncById: (args: {
    forceRecalculate?: Maybe<ScalarsEnums['Boolean']>
    hqId: ScalarsEnums['String']
  }) => TriggerSiteSyncResponse
  /**
   * Trigger full sandbox creation: data copy (anonymised) → admin DB → Firebase → Stripe → site index → verify
   */
  triggerSandboxMigration: (args: { brandSlug: ScalarsEnums['String'] }) => SandboxMigrationJob
  /**
   * Resync an existing sandbox (lean refresh): data copy (anonymised) → Firebase (new users) → Stripe → site index → verify.
   */
  triggerSandboxResync: (args: { brandSlug: ScalarsEnums['String'] }) => SandboxMigrationJob
  /**
   * Trigger a scheduled job once now (the repeatable schedule is untouched); returns the triggered job id
   */
  triggerScheduledJob: (args: {
    /**
     * JSON-stringified job body; re-validated against the template
     */
    body?: Maybe<ScalarsEnums['String']>
    corporateId?: Maybe<ScalarsEnums['ID']>
    jobKey: ScalarsEnums['String']
    siteId?: Maybe<ScalarsEnums['ID']>
  }) => ScalarsEnums['String']
  /**
   * Trigger a site sync job (publishes via Cloud Tasks and returns immediately)
   */
  triggerSiteSync: (args: {
    forceFullSync: ScalarsEnums['Boolean']
    forceRecalculate?: Maybe<ScalarsEnums['Boolean']>
    siteId: ScalarsEnums['String']
  }) => TriggerSiteSyncResponse
  /**
   * Remove a client block at a specific site
   */
  unblockClientAtSite: (args: {
    clientId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => BlockClientResponse
  /**
   * Undo a kiosk check-in: revert booking from ATTENDED to CONFIRMED
   */
  undoCheckin: (args: {
    bookingId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => UndoCheckinResult
  /**
   * Remove a member's Fitness Passport number, keeping the link history
   */
  unlinkFitnessPassportMember: (args: {
    clientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Stop an organisation paying for an employee
   */
  unlinkOrganisationEmployee: (args: {
    employeeClientId: ScalarsEnums['ID']
    organisationClientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => ClientRelationMutationResult
  /**
   * Unlink a site from its HQ — clears hqId without removing auth or location config
   */
  unlinkSiteFromGrowHq: (args: { siteId: ScalarsEnums['String'] }) => LinkSiteToHqResponse
  /**
   * Unpublish a content entry and move it back to DRAFT status
   */
  unpublishContentEntry: (args: { contentEntryId: ScalarsEnums['ID'] }) => CmsContentEntry
  /**
   * Take a scheduled brand add-on back to a draft
   */
  unscheduleCorporateAddOn: (args: {
    input: CorporateServiceTemplateVersionInput
  }) => CorporateAddOn
  /**
   * Restore previously skipped rows to PENDING
   */
  unskipImportRows: (args: {
    importSessionId: ScalarsEnums['ID']
    rowIndexes: Array<ScalarsEnums['Float']>
  }) => SkipImportRows
  /**
   * Unsubscribe FCM token from staff check-in alerts for a specific site.
   */
  unsubscribeFromStaffCheckInAlerts: (args: {
    fcmToken: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Unsubscribe FCM token from staff equipment alerts for a specific site.
   */
  unsubscribeFromStaffEquipmentAlerts: (args: {
    fcmToken: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Unsubscribe FCM token from staff terminal alerts for a specific site.
   */
  unsubscribeFromStaffTerminalAlerts: (args: {
    fcmToken: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Unsubscribe FCM token from user-specific topic.
   */
  unsubscribeFromUserTopic: (args: { fcmToken: ScalarsEnums['String'] }) => ScalarsEnums['Boolean']
  /**
   * Update Access Controls integration configuration
   */
  updateAccessControls: (args: {
    input?: Maybe<UpdateAccessControlsInputInput>
    siteId: ScalarsEnums['ID']
  }) => Site
  /**
   * Update an existing staff access rule
   */
  updateAccessRule: (args: {
    input: UpdateAccessRuleInputInput
    staffAccessRuleId: ScalarsEnums['ID']
    staffUserId: ScalarsEnums['ID']
  }) => StaffAccessRule
  /**
   * Update AccuroFit integration configuration
   */
  updateAccuroFit: (args: {
    input?: Maybe<UpdateAccuroFitInputInput>
    siteId: ScalarsEnums['ID']
  }) => Site
  /**
   * Rename a price group, change its tax or its session types, and reprice its plans' rows
   */
  updateAddOnPriceGroup: (args: { input: UpdateAddOnPriceGroupInput }) => AddOnPriceGroup
  /**
   * Update an admin access group
   */
  updateAdminAccessGroup: (args: {
    id: ScalarsEnums['ID']
    input: CreateAdminAccessGroupInputInput
  }) => AdminAccessGroup
  /**
   * Update an admin user
   */
  updateAdminUser: (args: {
    adminUserId: ScalarsEnums['ID']
    input: UpdateAdminUserInputInput
  }) => ScalarsEnums['ID']
  /**
   * Updates the profile image for an admin user
   */
  updateAdminUserProfileImage: (args: {
    adminUserId: ScalarsEnums['ID']
    input: GenerateImagePublicSignedUrlInput
  }) => GenerateFileUploadUrlResponse
  /**
   * Turn automatic spot assignment on or off for an aggregator provider at a site venue
   */
  updateAggregatorAutoAssignSpot: (args: {
    aggregatorProviderId: ScalarsEnums['String']
    autoAssignSpot: ScalarsEnums['Boolean']
    siteId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Update an aggregator provider
   */
  updateAggregatorProvider: (args: {
    aggregatorProviderId: ScalarsEnums['String']
    input: AggregatorProviderUpdateInput
  }) => AggregatorProvider
  /**
   * Enable or disable an aggregator provider for a site venue
   */
  updateAggregatorVenueSync: (args: {
    aggregatorProviderId: ScalarsEnums['String']
    enabled: ScalarsEnums['Boolean']
    siteId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Update the scope set granted to an existing API credential
   */
  updateApiCredentialScopes: (args: {
    apiCredentialId: ScalarsEnums['ID']
    input: ApiCredentialUpdateScopesInput
  }) => ApiCredential
  /**
   * Update app store credentials with encryption
   */
  updateAppStoreCredentials: (args: {
    corporateId: ScalarsEnums['ID']
    input: UpdateAppStoreCredentialsInputInput
    /**
     * Mobile platform (IOS or ANDROID)
     */
    platform: ScalarsEnums['String']
  }) => UpdateAppStoreCredentials
  /**
   * Update a booking
   */
  updateBooking: (args: { id: ScalarsEnums['String']; input: BookingUpdateInput }) => Booking
  /**
   * Update booking attendance status
   */
  updateBookingAttendance: (args: {
    id: ScalarsEnums['String']
    status: AttendanceStatus
  }) => Booking
  /**
   * Save a brand's translations, Facebook, plugins, Expo owner or Branch keys; an omitted field is left alone, null clears it; applies on its next native build or OTA
   */
  updateBrandBuildProfile: (args: {
    branchLiveKey?: Maybe<ScalarsEnums['String']>
    branchTestKey?: Maybe<ScalarsEnums['String']>
    brandId: ScalarsEnums['String']
    expoOwner?: Maybe<ScalarsEnums['String']>
    facebook?: Maybe<BrandFacebookConfigInput>
    plugins?: Maybe<ScalarsEnums['JSONObject']>
    translations?: Maybe<ScalarsEnums['JSONObject']>
  }) => Maybe<BrandBuildProfile>
  /**
   * Publish a new config version for a brand (CAS on expectedVersionId)
   */
  updateBrandConfig: (args: {
    brandId: ScalarsEnums['String']
    expectedVersionId?: Maybe<ScalarsEnums['String']>
    payload: ScalarsEnums['String']
  }) => SavedBrandConfigVersion
  /**
   * Record the store-facing identifiers a staff member collected from the Apple and Google consoles; returns the recomputed setup steps, which flip by evidence
   */
  updateBrandIdentity: (args: {
    brandId: ScalarsEnums['String']
    force?: Maybe<ScalarsEnums['Boolean']>
    identity: UpdateBrandIdentityIdentityInput
  }) => Array<BrandSetupStepView>
  /**
   * Save a brand's Android permissions and iOS permission prompts; applies on its next store build
   */
  updateBrandNativePermissions: (args: {
    androidPermissions: Array<AndroidPermission>
    brandId: ScalarsEnums['String']
    iosUsageDescriptions: Array<UpdateBrandNativePermissionsIosUsageDescriptionsInput>
  }) => BrandNativePermissions
  /**
   * Set the EAS update channel a brand's builds listen on; applies on its next build
   */
  updateBrandUpdateChannel: (args: {
    brandId: ScalarsEnums['String']
    updateChannel: BrandUpdateChannel
  }) => ScalarsEnums['BrandUpdateChannel']
  /**
   * Update an existing carousel group
   */
  updateCarouselGroup: (args: {
    carouselGroupId: ScalarsEnums['ID']
    input: UpdateCarouselGroupInput
  }) => CmsCarouselGroup
  /**
   * Update ClassPass integration configuration
   */
  updateClassPass: (args: {
    input?: Maybe<UpdateClassPassInputInput>
    siteId: ScalarsEnums['ID']
  }) => Site
  updateClient: (args: {
    commPrefsSource?: Maybe<CommPrefsSource>
    id: ScalarsEnums['String']
    input: UpdateClientInput
    siteId: ScalarsEnums['String']
  }) => UpdateClientResponse
  /**
   * Update client account balance display preference
   */
  updateClientAccountBalancePreference: (args: {
    clientId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
    useAccountCreditsOnRecurringInvoices: ScalarsEnums['Boolean']
  }) => UpdateClientAccountBalancePreference
  updateClientAdmin: (args: {
    id: ScalarsEnums['String']
    input: UpdateClientInput
  }) => UpdateClientResponse
  /**
   * Update existing client alert
   */
  updateClientAlert: (args: {
    input: UpdateClientAlertInputInput
    siteId: ScalarsEnums['String']
  }) => ClientCustomAlertMutationResponse
  /**
   * Update a single custom property value for a client
   */
  updateClientCustomPropertyValue: (args: {
    customPropertyValueId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
    value: ScalarsEnums['String']
  }) => UpdateClientCustomPropertyValueResponse
  /**
   * Bulk update custom property values for a client
   */
  updateClientCustomPropertyValues: (args: {
    clientId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
    values: Array<UpdateClientCustomPropertyValuesValuesInput>
  }) => UpdateClientCustomPropertyValuesResponse
  /**
   * Update a client fees template
   */
  updateClientFeesTemplate: (args: {
    id: ScalarsEnums['String']
    input: FeeTemplateInput
  }) => ClientFeesTemplate
  /**
   * Update client file name
   */
  updateClientFileName: (args: {
    clientId: ScalarsEnums['String']
    fileId: ScalarsEnums['String']
    newFileName: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => UpdateClientFileNameResponse
  /**
   * Update a client note
   */
  updateClientNote: (args: {
    clientId: ScalarsEnums['String']
    input: ClientNoteUpdateInput
    noteId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => UpdateClientNoteResponse
  /**
   * Updates the profile image for a client
   */
  updateClientProfileImage: (args: {
    clientId: ScalarsEnums['ID']
    input: GenerateImagePublicSignedUrlInput
  }) => GenerateFileUploadUrlResponse
  /**
   * Update client recentSiteId - tracks most recently visited site
   */
  updateClientRecentSite: (args: {
    clientId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => UpdateClientRecentSite
  /**
   * Update an existing client family relation
   */
  updateClientRelation: (args: {
    clientId: ScalarsEnums['String']
    familyMemberClientId: ScalarsEnums['String']
    input: UpdateClientFamilyInput
    siteId: ScalarsEnums['String']
  }) => ClientFamily
  /**
   * Update site-specific data for a client-site relationship
   */
  updateClientSiteData: (args: {
    clientId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
    siteSpecificData: AddClientToSiteSiteSpecificDataInput
  }) => UpdateClientSiteDataResponse
  /**
   * Change an item switch for the brand, or for one location
   */
  updateCommissionItemSetting: (args: {
    isCommissionable?: Maybe<ScalarsEnums['Boolean']>
    itemId: ScalarsEnums['String']
    itemType: CommissionItemType
    requireSoldBy?: Maybe<ScalarsEnums['Boolean']>
    siteId?: Maybe<ScalarsEnums['ID']>
  }) => CommissionItemSetting
  /**
   * Choose the locations a brand plan is available at
   */
  updateCommissionPlanAvailability: (args: {
    commissionPlanId: ScalarsEnums['ID']
    effectiveFrom?: Maybe<ScalarsEnums['String']>
    siteIds: Array<ScalarsEnums['ID']>
  }) => CommissionPlanAvailabilityChange
  /**
   * Save a brand commission settings change (only the supplied keys)
   */
  updateCommissionSettings: (args: {
    effectiveFrom?: Maybe<ScalarsEnums['String']>
    patch: ScalarsEnums['JSONObject']
  }) => CommissionSettings
  /**
   * Set the location default seller for online sales
   */
  updateCommissionSiteSettings: (args: {
    onlineDefaultSellerStaffUserId?: Maybe<ScalarsEnums['ID']>
    siteId: ScalarsEnums['ID']
  }) => CommissionSiteSettings
  updateCommunicationTemplate: (args: {
    communicationTemplate: UpdateCommunicationTemplateCommunicationTemplateInput
    communicationTemplateId: ScalarsEnums['ID']
  }) => CommunicationTemplate
  /**
   * Update an existing content entry and auto-create a version snapshot
   */
  updateContentEntry: (args: {
    changeNote?: Maybe<ScalarsEnums['String']>
    contentEntryId: ScalarsEnums['ID']
    expectedVersion: ScalarsEnums['Float']
    input: CmsContentEntryUpdateInput
  }) => CmsContentEntry
  /**
   * Update corporate
   */
  updateCorporate: (args: {
    corporateId: ScalarsEnums['String']
    input: UpdateCorporateInput
  }) => Corporate
  /**
   * Replace a draft or scheduled brand add-on with the values sent
   */
  updateCorporateAddOnDraft: (args: { input: UpdateCorporateAddOnDraftInput }) => CorporateAddOn
  /**
   * Update ClassPass integration settings for a corporate (member-facing)
   */
  updateCorporateClassPass: (args: {
    corporateId: ScalarsEnums['String']
    siteIds: Array<ScalarsEnums['String']>
  }) => Corporate
  /**
   * Update corporate communication settings (email defaults)
   */
  updateCorporateCommunicationSettings: (args: {
    corporateId: ScalarsEnums['ID']
    input: UpdateCorporateCommunicationSettingsInput
  }) => Corporate
  /**
   * Update a corporate communication template
   */
  updateCorporateCommunicationTemplate: (args: {
    corporateCommunicationTemplateId: ScalarsEnums['ID']
    input: CorporateCommunicationTemplateUpdateInput
  }) => CorporateCommunicationTemplate
  /**
   * Update enableEmail status for a corporate communication template
   */
  updateCorporateCommunicationTemplateEnableEmail: (args: {
    alias: CommunicationTemplateAliases
    corporateCommunicationTemplateId: ScalarsEnums['String']
    enableEmail: ScalarsEnums['Boolean']
  }) => CorporateCommunicationTemplate
  /**
   * Update enablePush status for a corporate communication template
   */
  updateCorporateCommunicationTemplateEnablePush: (args: {
    alias: CommunicationTemplateAliases
    corporateCommunicationTemplateId: ScalarsEnums['ID']
    enablePush?: Maybe<ScalarsEnums['Boolean']>
  }) => CorporateCommunicationTemplate
  /**
   * Update enableSms status for a corporate communication template
   */
  updateCorporateCommunicationTemplateEnableSms: (args: {
    alias: CommunicationTemplateAliases
    corporateCommunicationTemplateId: ScalarsEnums['String']
    enableSms?: Maybe<ScalarsEnums['Boolean']>
  }) => CorporateCommunicationTemplate
  /**
   * Update a corporate communication template version
   */
  updateCorporateCommunicationTemplateVersion: (args: {
    corporateCommunicationTemplateId: ScalarsEnums['ID']
    corporateCommunicationTemplateVersionId: ScalarsEnums['ID']
    input: CorporateCommunicationTemplateVersionUpdateInput
  }) => CorporateCommunicationTemplateVersion
  /**
   * Update a custom third-party integration configuration for a corporate
   */
  updateCorporateCustomThirdPartyIntegration: (args: {
    corporateId: ScalarsEnums['ID']
    input: UpdateCorporateCustomThirdPartyIntegrationInput
  }) => Corporate
  /**
   * Update an existing corporate FAQ
   */
  updateCorporateFaq: (args: {
    corporateFaqId: ScalarsEnums['ID']
    input: UpdateCorporateFaqInput
  }) => CorporateFaq
  /**
   * Update corporate payout account
   */
  updateCorporatePayoutAccount: (args: {
    corporateId: ScalarsEnums['ID']
    id: ScalarsEnums['ID']
    input: UpdateCorporatePayoutAccountInputInput
  }) => CorporatePayoutAccount
  /**
   * Update a brand session group and propagate the change to every receiving location
   */
  updateCorporateSessionType: (args: {
    corporateSessionTypeId: ScalarsEnums['ID']
    input: UpdateCorporateSessionTypeInput
  }) => CorporateSessionType
  /**
   * Update a brand tax type and propagate the change to every assigned location
   */
  updateCorporateTaxSetting: (args: {
    corporateTaxSettingId: ScalarsEnums['ID']
    input: UpdateCorporateTaxSettingInput
  }) => CorporateTaxSetting
  /**
   * Update a corporate webhook
   */
  updateCorporateWebhook: (args: {
    corporateId: ScalarsEnums['ID']
    input: UpdateCorporateWebhookInputInput
    webhookId: ScalarsEnums['ID']
  }) => CorporateWebhook
  /**
   * Update a custom property
   */
  updateCustomProperty: (args: {
    id: ScalarsEnums['String']
    input: CustomPropertyUpdateInput
    siteId: ScalarsEnums['ID']
  }) => CustomProperty
  /**
   * Update a custom property alert
   */
  updateCustomPropertyAlert: (args: {
    alertId: ScalarsEnums['String']
    input: CustomPropertyAlertUpdateInput
    propertyId: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => UpdateCustomPropertyAlert
  /**
   * Update custom text for a language with validation
   */
  updateCustomText: (args: {
    corporateId: ScalarsEnums['String']
    language: ScalarsEnums['String']
    sanitize: ScalarsEnums['Boolean']
    translations: ScalarsEnums['JSONObject']
    userId?: Maybe<ScalarsEnums['String']>
  }) => UpdateCustomText
  /**
   * Update account-level deep link settings (fallback URLs)
   */
  updateDeepLinkSettings: (args: {
    androidUrl?: Maybe<ScalarsEnums['String']>
    corporateId: ScalarsEnums['String']
    desktopUrl?: Maybe<ScalarsEnums['String']>
    fallbackUrl?: Maybe<ScalarsEnums['String']>
    iosUrl?: Maybe<ScalarsEnums['String']>
  }) => DeepLinkSettings
  /**
   * Update a digital channel
   */
  updateDigitalChannel: (args: {
    input: UpdateSiteLocationInput
    siteId: ScalarsEnums['ID']
    siteLocationId: ScalarsEnums['ID']
  }) => SiteLocation
  /**
   * Update the dishonor fee amount for one or more payments. Recalculates taxes and updates invoice totals. Accepts a single paymentId or a list of paymentIds.
   */
  updateDishonorFee: (args: {
    newFeeAmount: ScalarsEnums['String']
    paymentId?: Maybe<ScalarsEnums['ID']>
    paymentIds?: Maybe<Array<ScalarsEnums['ID']>>
    siteId: ScalarsEnums['ID']
  }) => Array<Invoice>
  /**
   * Update eGym integration configuration
   */
  updateEgymIntegration: (args: {
    input: UpdateEgymIntegrationInput
    siteId: ScalarsEnums['ID']
  }) => Site
  /**
   * Update embed widget customization configuration
   */
  updateEmbedCustomization: (args: {
    corporateId: ScalarsEnums['String']
    customization: UpdateEmbedCustomizationCustomizationInput
  }) => EmbedSetupResponse
  /**
   * Update embed widget website widgets configuration
   */
  updateEmbedWebsiteWidgets: (args: {
    corporateId: ScalarsEnums['String']
    websiteWidgets: UpdateEmbedWebsiteWidgetsWebsiteWidgetsInput
  }) => EmbedSetupResponse
  /**
   * Update an equipment unit
   */
  updateEquipment: (args: {
    equipmentId: ScalarsEnums['String']
    input: UpdateEquipmentInput
  }) => Equipment
  /**
   * Turn lamp hour tracking on or off for a bed lamp set and set its lamp life
   */
  updateEquipmentLampSettings: (args: { input: UpdateEquipmentLampSettingsInput }) => Equipment
  /**
   * Update tanning safety regulations
   */
  updateEquipmentRegulation: (args: {
    input: UpdateEquipmentRegulationInput
    regulationId: ScalarsEnums['String']
  }) => EquipmentRegulation
  /**
   * Directly update the status of an equipment unit (staff override)
   */
  updateEquipmentStatus: (args: {
    equipmentId: ScalarsEnums['String']
    status: EquipmentStatus
  }) => Equipment
  /**
   * Update equipment status from hardware agent callback (called by gateway REST endpoint)
   */
  updateEquipmentStatusByTimerId: (args: {
    agentStatus: AgentStatus
    siteId: ScalarsEnums['String']
    timerId: ScalarsEnums['Int']
  }) => Maybe<Equipment>
  /**
   * Update External Feedback Link integration configuration
   */
  updateExternalFeedbackLink: (args: {
    input?: Maybe<UpdateExternalFeedbackLinkInputInput>
    siteId: ScalarsEnums['ID']
  }) => Site
  /**
   * Update Ezypay gateway credentials, re-validating against Ezypay before persist
   */
  updateEzypayGateway: (args: { input: UpdateEzypayGatewayInput }) => UpdateEzypayGatewayPayload
  /**
   * Update Facebook Pixel integration configuration
   */
  updateFacebookPixel: (args: {
    input?: Maybe<UpdateFacebookPixelInputInput>
    siteId: ScalarsEnums['ID']
  }) => Site
  /**
   * Turn Book sessions on or off for a dependent, by an admin of the family or by staff
   */
  updateFamilyMemberPermission: (args: {
    canBook: ScalarsEnums['Boolean']
    clientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Family
  /**
   * Make a member an admin or a dependent, by an admin of the family or by staff; refused past the brand admin limit or when it would leave no admin
   */
  updateFamilyMemberRole: (args: {
    clientId: ScalarsEnums['ID']
    role: FamilyMemberRole
    siteId: ScalarsEnums['ID']
  }) => Family
  /**
   * Set how many admins a family may have, by staff with write_controls; the limit is enforced when a member is promoted
   */
  updateFamilySettings: (args: { input: UpdateFamilySettingsInputInput }) => FamilySettings
  /**
   * QA tooling: replace the CC list applied to every comms-guard-redirected email. Feature envs + admin only.
   */
  updateFeatureEnvCcEmails: (args: {
    ccEmails: Array<ScalarsEnums['String']>
  }) => FeatureEnvEmailSettings
  /**
   * Update a fee configuration
   */
  updateFeeConfiguration: (args: {
    id: ScalarsEnums['String']
    input: UpdateFeeConfigurationInputInput
  }) => FeeConfiguration
  /**
   * Update Fitness Passport integration configuration
   */
  updateFitnessPassport: (args: {
    input: UpdateFitnessPassportInput
    siteId: ScalarsEnums['ID']
  }) => Site
  /**
   * Update Front Desk Kiosk integration configuration
   */
  updateFrontDeskKiosk: (args: {
    input: UpdateFrontDeskKioskInput
    siteId: ScalarsEnums['ID']
  }) => Site
  /**
   * Extend, remove or reinstate the expiry of a gift card, never earlier than the legal minimum
   */
  updateGiftCardExpiry: (args: {
    expiryDate?: Maybe<ScalarsEnums['String']>
    giftCardId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => UpdateGiftCardExpiryResult
  /**
   * Edit a gift card expiry rule; any edit returns it to draft until approved again
   */
  updateGiftCardExpiryRule: (args: {
    disclosureRequired: ScalarsEnums['Boolean']
    effectiveFrom: ScalarsEnums['String']
    expiryPolicy: GiftCardExpiryPolicy
    giftCardExpiryRuleId: ScalarsEnums['ID']
    legalCitation?: Maybe<ScalarsEnums['String']>
    maximumTermMonths?: Maybe<ScalarsEnums['Float']>
    minimumTermMonths?: Maybe<ScalarsEnums['Float']>
    notes?: Maybe<ScalarsEnums['String']>
    sourceUrl?: Maybe<ScalarsEnums['String']>
  }) => GiftCardExpiryRuleRecord
  /**
   * Update an existing gift card template
   */
  updateGiftCardTemplate: (args: {
    giftCardTemplateId: ScalarsEnums['ID']
    input: GiftCardTemplateUpdateInput
  }) => GiftCardTemplate
  /**
   * Update shared site settings across all gift card templates for a site
   */
  updateGiftCardTemplatesSharedSites: (args: {
    input: UpdateGiftCardTemplatesSharedSitesInput
  }) => ScalarsEnums['Boolean']
  /**
   * Update an existing goal
   */
  updateGoal: (args: { goalId: ScalarsEnums['ID']; input: UpdateGoalInput }) => CmsGoal
  /**
   * Update Google Tag Manager integration configuration
   */
  updateGoogleTagManager: (args: {
    input?: Maybe<UpdateGoogleTagManagerInputInput>
    siteId: ScalarsEnums['ID']
  }) => Site
  /**
   * Update a GrowHq
   */
  updateGrowHq: (args: {
    growHqId: ScalarsEnums['String']
    growHqInput: UpdateGrowHqInput
  }) => GrowHq
  /**
   * Update Hapana Access Controller integration configuration
   */
  updateHapanaAccessController: (args: {
    input?: Maybe<UpdateHapanaAccessControllerInputInput>
    siteId: ScalarsEnums['ID']
  }) => Site
  /**
   * Update a hapana fees template
   */
  updateHapanaFeesTemplate: (args: {
    failedPaymentFeeScope?: Maybe<FailedPaymentFeeScope>
    id: ScalarsEnums['String']
    input: FeeTemplateInput
  }) => HapanaFeesTemplate
  /**
   * Update a row field values and re-validate inline
   */
  updateImportRow: (args: {
    fieldUpdates: ScalarsEnums['String']
    importSessionId: ScalarsEnums['ID']
    rowIndex: ScalarsEnums['Float']
  }) => UpdateImportRow
  /**
   * Patch validSiteIds / defaultSiteId / locationSiteMap on an ImportSession for location mapping
   */
  updateImportSession: (args: {
    defaultSiteId?: Maybe<ScalarsEnums['ID']>
    importSessionId: ScalarsEnums['ID']
    locationSiteMap?: Maybe<ScalarsEnums['String']>
    validSiteIds?: Maybe<ScalarsEnums['String']>
  }) => UpdateImportSession
  /**
   * Update a staged invoice with new sale items. Replaces all existing invoice items. Only works for invoices in Staged status.
   */
  updateInvoice: (args: {
    input: CreateInvoiceInputInput
    invoiceId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Invoice
  /**
   * Update only the client fields (clientId and beneficiaryId) on a staged invoice. This is a simpler update that does not re-process items - used when setting the payer before processing payment.
   */
  updateInvoiceClient: (args: {
    beneficiaryId?: Maybe<ScalarsEnums['ID']>
    clientId?: Maybe<ScalarsEnums['ID']>
    invoiceId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Invoice
  /**
   * Update kiosk default settings for a corporate
   */
  updateKioskDefaults: (args: {
    corporateId: ScalarsEnums['String']
    input: UpdateKioskDefaultsInput
  }) => KioskDefaults
  updateKnowledgeArticle: (args: {
    input: KnowledgeArticleUpdateInput
    knowledgeArticleId: ScalarsEnums['ID']
  }) => KnowledgeArticle
  updateKnowledgeArticleCategory: (args: {
    input: KnowledgeArticleCategoryUpdateInput
    knowledgeArticleCategoryId: ScalarsEnums['ID']
  }) => KnowledgeArticleCategory
  updateKnowledgeArticleRevision: (args: {
    input: KnowledgeArticleRevisionContentInput
    revisionId: ScalarsEnums['ID']
  }) => KnowledgeArticleRevision
  updateKnowledgeDocument: (args: {
    id: ScalarsEnums['ID']
    input: KnowledgeDocumentInput
  }) => KnowledgeDocument
  /**
   * Update an existing leaderboard config
   */
  updateLeaderboardConfig: (args: {
    input: UpdateLeaderboardConfigInputInput
    leaderboardConfigId: ScalarsEnums['String']
  }) => LeaderboardConfig
  /**
   * Update the current user profile
   */
  updateMe: (args: { input: UpdateMeInputInput }) => Self
  /**
   * Update metadata for an existing media asset
   */
  updateMediaAsset: (args: {
    contentMediaId: ScalarsEnums['ID']
    input: CmsContentMediaUpdateInput
  }) => CmsContentMedia
  /**
   * Update branding configuration with validation
   */
  updateMemberExperienceBranding: (args: {
    appName?: Maybe<ScalarsEnums['String']>
    backgroundColor?: Maybe<ScalarsEnums['String']>
    corporateId: ScalarsEnums['String']
    darkBackgroundColor?: Maybe<ScalarsEnums['String']>
    darkPrimaryColor?: Maybe<ScalarsEnums['String']>
    darkPrimaryTextColor?: Maybe<ScalarsEnums['String']>
    darkSecondaryBackgroundColor?: Maybe<ScalarsEnums['String']>
    darkSecondaryColor?: Maybe<ScalarsEnums['String']>
    darkSecondaryTextColor?: Maybe<ScalarsEnums['String']>
    faviconUrl?: Maybe<ScalarsEnums['String']>
    logoUrl?: Maybe<ScalarsEnums['String']>
    primaryColor?: Maybe<ScalarsEnums['String']>
    primaryTextColor?: Maybe<ScalarsEnums['String']>
    secondaryBackgroundColor?: Maybe<ScalarsEnums['String']>
    secondaryColor?: Maybe<ScalarsEnums['String']>
    secondaryTextColor?: Maybe<ScalarsEnums['String']>
    userId?: Maybe<ScalarsEnums['String']>
  }) => UpdateMemberExperienceBranding
  /**
   * Update fonts configuration with validation
   */
  updateMemberExperienceFonts: (args: {
    corporateId: ScalarsEnums['String']
    customFonts?: Maybe<Array<FinalizeCustomFontFontInput>>
    customHeadingFonts?: Maybe<Array<FinalizeCustomFontFontInput>>
    fontFamily: ScalarsEnums['String']
    fontScale?: Maybe<ScalarsEnums['Float']>
    fontSource: FontSource
    fontUrl?: Maybe<ScalarsEnums['String']>
    headingFontFamily?: Maybe<ScalarsEnums['String']>
    headingFontSource?: Maybe<HeadingFontSource>
    headingFontUrl?: Maybe<ScalarsEnums['String']>
    useCustomHeadingFont?: Maybe<ScalarsEnums['Boolean']>
    userId?: Maybe<ScalarsEnums['String']>
  }) => UpdateMemberExperienceFonts
  /**
   * Update settings configuration with validation
   */
  updateMemberExperienceSettings: (args: {
    awardsEnabled?: Maybe<ScalarsEnums['Boolean']>
    barcodeEnabled?: Maybe<ScalarsEnums['Boolean']>
    borderRadius?: Maybe<ScalarsEnums['Float']>
    brandLogoEnabled?: Maybe<ScalarsEnums['Boolean']>
    buttonStyle?: Maybe<WidgetButtonStyle>
    callUsEnabled?: Maybe<ScalarsEnums['Boolean']>
    challengesEnabled?: Maybe<ScalarsEnums['Boolean']>
    classTimeFilter?: Maybe<ScalarsEnums['Boolean']>
    contactlessCheckin?: Maybe<ScalarsEnums['Boolean']>
    corporateId: ScalarsEnums['String']
    customCssLink?: Maybe<ScalarsEnums['String']>
    darkMode?: Maybe<MemberExperienceDarkMode>
    darkModeSupport?: Maybe<ScalarsEnums['Boolean']>
    displayInstructor?: Maybe<ScalarsEnums['Boolean']>
    displayPackageDescription?: Maybe<ScalarsEnums['Boolean']>
    displayProfilePicture?: Maybe<ScalarsEnums['Boolean']>
    doorCheckin?: Maybe<ScalarsEnums['Boolean']>
    dynamicImagesEnabled?: Maybe<ScalarsEnums['Boolean']>
    editFieldsAddress?: Maybe<ScalarsEnums['Boolean']>
    editFieldsDob?: Maybe<ScalarsEnums['Boolean']>
    editFieldsEnabled?: Maybe<ScalarsEnums['Boolean']>
    editFieldsName?: Maybe<ScalarsEnums['Boolean']>
    editFieldsPhone?: Maybe<ScalarsEnums['Boolean']>
    facebookAppId?: Maybe<ScalarsEnums['String']>
    facebookClientToken?: Maybe<ScalarsEnums['String']>
    facebookDisplayName?: Maybe<ScalarsEnums['String']>
    filterOptions?: Maybe<UpdateMemberExperienceSettingsFilterOptionsInput>
    fontSize?: Maybe<ScalarsEnums['Float']>
    footerVisible?: Maybe<ScalarsEnums['Boolean']>
    headerVisible?: Maybe<ScalarsEnums['Boolean']>
    moduleClasses?: Maybe<ScalarsEnums['Boolean']>
    moduleDashboard?: Maybe<ScalarsEnums['Boolean']>
    modulePackages?: Maybe<ScalarsEnums['Boolean']>
    modulePayments?: Maybe<ScalarsEnums['Boolean']>
    modulePrivates?: Maybe<ScalarsEnums['Boolean']>
    moduleProfile?: Maybe<ScalarsEnums['Boolean']>
    moduleSchedule?: Maybe<ScalarsEnums['Boolean']>
    moduleWorkshops?: Maybe<ScalarsEnums['Boolean']>
    newsFeedAvailable?: Maybe<ScalarsEnums['Boolean']>
    privatesAnyAvailable?: Maybe<ScalarsEnums['Boolean']>
    redirectUrl?: Maybe<ScalarsEnums['String']>
    showBilling?: Maybe<ScalarsEnums['Boolean']>
    showFilters?: Maybe<ScalarsEnums['Boolean']>
    shownCommPref?: Maybe<ScalarsEnums['Boolean']>
    sidebarPosition?: Maybe<SidebarPosition>
    signUpEnabled?: Maybe<ScalarsEnums['Boolean']>
    statsAvailable?: Maybe<ScalarsEnums['Boolean']>
    streakScope?: Maybe<MemberExperienceStreakScope>
    tabDigitalEnabled?: Maybe<ScalarsEnums['Boolean']>
    tabPurchaseEnabled?: Maybe<ScalarsEnums['Boolean']>
    userId?: Maybe<ScalarsEnums['String']>
  }) => UpdateMemberExperienceSettings
  /**
   * Set whether a surface inherits the global theme, and its override colours
   */
  updateMemberExperienceSurfaceBranding: (args: {
    backgroundColor?: Maybe<ScalarsEnums['String']>
    corporateId: ScalarsEnums['String']
    darkBackgroundColor?: Maybe<ScalarsEnums['String']>
    darkPrimaryColor?: Maybe<ScalarsEnums['String']>
    darkPrimaryTextColor?: Maybe<ScalarsEnums['String']>
    darkSecondaryBackgroundColor?: Maybe<ScalarsEnums['String']>
    darkSecondaryColor?: Maybe<ScalarsEnums['String']>
    darkSecondaryTextColor?: Maybe<ScalarsEnums['String']>
    inheritsGlobal: ScalarsEnums['Boolean']
    primaryColor?: Maybe<ScalarsEnums['String']>
    primaryTextColor?: Maybe<ScalarsEnums['String']>
    secondaryBackgroundColor?: Maybe<ScalarsEnums['String']>
    secondaryColor?: Maybe<ScalarsEnums['String']>
    secondaryTextColor?: Maybe<ScalarsEnums['String']>
    surface: MemberExperienceSurface
    userId?: Maybe<ScalarsEnums['String']>
  }) => UpdateMemberExperienceSurfaceBrandingResponse
  /**
   * Update Member Movement (OC-554) staff-editable configuration (criteria/mapping/managers). Entitlement fields are excluded — see adminUpdateMemberMovementEntitlement. Requires a CONFIG-scope attestation.
   */
  updateMemberMovementConfig: (args: {
    attestation: MemberMovementAttestationInput
    corporateId: ScalarsEnums['String']
    input: MemberMovementConfigInput
  }) => MemberMovementConfig
  /**
   * Edit a DRAFT/REVIEW run config (invalidates results, CONFIG attestation)
   */
  updateMemberMovementRunConfig: (args: {
    input: UpdateMemberMovementRunConfigInput
  }) => MemberMovementRun
  /**
   * Set the tier ordering ladder for membership plan changes at a site. Position 0 = lowest tier, last position = highest tier. Templates omitted from the array are unranked (tierOrder = NULL).
   */
  updateMembershipTierOrders: (args: {
    input: UpdateMembershipTierOrdersInput
  }) => ScalarsEnums['Boolean']
  /**
   * Update mobile app branding configuration with validation
   */
  updateMobileAppBranding: (args: {
    accentColor?: Maybe<ScalarsEnums['String']>
    appIconUrl?: Maybe<ScalarsEnums['String']>
    backgroundColor?: Maybe<ScalarsEnums['String']>
    corporateId: ScalarsEnums['String']
    faviconUrl?: Maybe<ScalarsEnums['String']>
    fontConfig?: Maybe<ScalarsEnums['JSONObject']>
    fontFamily?: Maybe<ScalarsEnums['String']>
    logoUrl?: Maybe<ScalarsEnums['String']>
    modulesConfig?: Maybe<ScalarsEnums['JSONObject']>
    primaryColor?: Maybe<ScalarsEnums['String']>
    secondaryColor?: Maybe<ScalarsEnums['String']>
    splashScreenDarkUrl?: Maybe<ScalarsEnums['String']>
    splashScreenUrl?: Maybe<ScalarsEnums['String']>
    textColor?: Maybe<ScalarsEnums['String']>
    userId?: Maybe<ScalarsEnums['String']>
  }) => UpdateMobileAppBranding
  /**
   * Update mobile app channels configuration with validation
   */
  updateMobileAppChannels: (args: {
    androidConfig?: Maybe<ScalarsEnums['JSONObject']>
    androidEnabled?: Maybe<ScalarsEnums['Boolean']>
    androidMinVersion?: Maybe<ScalarsEnums['String']>
    androidPackageName?: Maybe<ScalarsEnums['String']>
    androidPlayStoreUrl?: Maybe<ScalarsEnums['String']>
    androidVersion?: Maybe<ScalarsEnums['String']>
    channels?: Maybe<ScalarsEnums['JSONObject']>
    corporateId: ScalarsEnums['String']
    deployment?: Maybe<ScalarsEnums['JSONObject']>
    deploymentStatus?: Maybe<ScalarsEnums['String']>
    iosAppStoreUrl?: Maybe<ScalarsEnums['String']>
    iosBundleId?: Maybe<ScalarsEnums['String']>
    iosConfig?: Maybe<ScalarsEnums['JSONObject']>
    iosEnabled?: Maybe<ScalarsEnums['Boolean']>
    iosMinVersion?: Maybe<ScalarsEnums['String']>
    iosVersion?: Maybe<ScalarsEnums['String']>
    lastDeployedAt?: Maybe<ScalarsEnums['String']>
    userId?: Maybe<ScalarsEnums['String']>
  }) => UpdateMobileAppChannels
  /**
   * Update mobile app customization (step 1)
   */
  updateMobileAppCustomization: (args: {
    corporateId: ScalarsEnums['String']
    customization: MobileCustomizationInput
  }) => MobileSetupResponse
  /**
   * Update mobile app profile configuration with validation
   */
  updateMobileAppProfile: (args: {
    address?: Maybe<ScalarsEnums['String']>
    appDescription?: Maybe<ScalarsEnums['String']>
    appName: ScalarsEnums['String']
    appShortDescription?: Maybe<ScalarsEnums['String']>
    branchIoKey?: Maybe<ScalarsEnums['String']>
    branchIoLiveKey?: Maybe<ScalarsEnums['String']>
    branchIoSecret?: Maybe<ScalarsEnums['String']>
    businessName?: Maybe<ScalarsEnums['String']>
    contentfulAccessToken?: Maybe<ScalarsEnums['String']>
    contentfulPreviewToken?: Maybe<ScalarsEnums['String']>
    contentfulSpaceId?: Maybe<ScalarsEnums['String']>
    corporateId: ScalarsEnums['String']
    description?: Maybe<ScalarsEnums['String']>
    distributionCountries?: Maybe<Array<ScalarsEnums['String']>>
    email?: Maybe<ScalarsEnums['String']>
    evoltApiKey?: Maybe<ScalarsEnums['String']>
    facebookUrl?: Maybe<ScalarsEnums['String']>
    instagramUrl?: Maybe<ScalarsEnums['String']>
    jwPlayerApiKey?: Maybe<ScalarsEnums['String']>
    linkedinUrl?: Maybe<ScalarsEnums['String']>
    oneSignalApiKey?: Maybe<ScalarsEnums['String']>
    oneSignalAppId?: Maybe<ScalarsEnums['String']>
    phone?: Maybe<ScalarsEnums['String']>
    privacyPolicyUrl?: Maybe<ScalarsEnums['String']>
    socialLinks?: Maybe<ScalarsEnums['JSONObject']>
    supportEmail?: Maybe<ScalarsEnums['String']>
    supportUrl?: Maybe<ScalarsEnums['String']>
    tagline?: Maybe<ScalarsEnums['String']>
    termsAndConditionsUrl?: Maybe<ScalarsEnums['String']>
    twitterUrl?: Maybe<ScalarsEnums['String']>
    userId?: Maybe<ScalarsEnums['String']>
    website?: Maybe<ScalarsEnums['String']>
    youtubeUrl?: Maybe<ScalarsEnums['String']>
  }) => UpdateMobileAppProfile
  /**
   * Opt in or out of class cover offers by SMS, recording consent, and turn offer emails on or off
   */
  updateMyCoverPreferences: (args?: {
    emailOffersEnabled?: Maybe<ScalarsEnums['Boolean']>
    smsOptIn?: Maybe<ScalarsEnums['Boolean']>
  }) => MyCoverPreferences
  /**
   * Update the payment contact email for a site payment gateway
   */
  updatePaymentContactEmail: (args: {
    email: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Update a POS category
   */
  updatePosCategory: (args: {
    input: UpdatePosCategoryInput
    posCategoryId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => UpdatePosCategoryResponse
  /**
   * Update POS product base information
   */
  updatePosProduct: (args: {
    input: UpdatePosProductInput
    posProductId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => UpdatePosProductResponse
  /**
   * Update the isFeatured flag for a product variable
   */
  updatePosProductVariableFeatured: (args: {
    posProductId: ScalarsEnums['ID']
    posProductVariableId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => UpdatePosProductVariableFeaturedResponse
  /**
   * Update the amount of a pre-sale initial scheduled invoice. Setting totalAmount to 0 applies a full discount. Only operates on pre-sale invoices (SCHEDULED status, no recurring parent, PENDING_START_DATE service).
   */
  updatePresaleInitialInvoiceAmount: (args: {
    input: UpdatePresaleInitialInvoiceAmountInput
    siteId: ScalarsEnums['ID']
  }) => Invoice
  /**
   * Update the date of a pre-sale initial scheduled invoice. Cascades the delta to the service start date, recurring invoice next date, all materialized future recurring invoices, and all service credit allocation validity windows.
   */
  updatePresaleInitialInvoiceDate: (args: {
    input: UpdatePresaleInitialInvoiceDateInput
    siteId: ScalarsEnums['ID']
  }) => Invoice
  /**
   * Updates the profile image for a staff user
   */
  updateProfileImage: (args: {
    input: GenerateImagePublicSignedUrlInput
    staffUserId: ScalarsEnums['ID']
  }) => GenerateFileUploadUrlResponse
  /**
   * Update an existing promo code
   */
  updatePromoCode: (args: {
    input: PromoCodeUpdateInput
    promoCodeId: ScalarsEnums['ID']
  }) => PromoCode
  /**
   * Update rebate template
   */
  updateRebateTemplate: (args: {
    id: ScalarsEnums['ID']
    input: RebateTemplateUpdate
  }) => RebateTemplate
  /**
   * Update existing region
   */
  updateRegion: (args: { input: UpdateRegionInputInput; regionId: ScalarsEnums['ID'] }) => Regions
  updateReleaseNote: (args: {
    input: ReleaseNoteUpdateInput
    releaseNoteId: ScalarsEnums['ID']
  }) => ReleaseNote
  /**
   * Update a room resource template
   */
  updateRoomResourceTemplate: (args: {
    id: ScalarsEnums['String']
    input: UpdateSiteRoomResourceTemplateInput
    siteId: ScalarsEnums['String']
  }) => SiteRoomResourceTemplateResponse
  /**
   * Update royalties and fees template
   */
  updateRoyaltiesAndFeesTemplate: (args: {
    id: ScalarsEnums['ID']
    input: RoyaltiesAndFeesTemplateUpdate
  }) => RoyaltiesAndFeesTemplate
  /**
   * Update a saved report configuration (baseReportName is immutable)
   */
  updateSavedReport: (args: { input: UpdateSavedReportInputInput }) => SavedReport
  /**
   * Rename a saved report category
   */
  updateSavedReportCategory: (args: {
    name: ScalarsEnums['String']
    savedReportCategoryId: ScalarsEnums['String']
  }) => CreateSavedReportCategory
  /**
   * Update the date of a single scheduled invoice. Handles virtual invoices (materializes first) and materialized invoices. Preserves payment terms by adjusting dueDate relative to saleDate.
   */
  updateScheduledInvoiceDate: (args: {
    input: UpdateScheduledInvoiceDateInput
    siteId: ScalarsEnums['ID']
  }) => Invoice
  /**
   * Edit a push notification that has not been sent yet
   */
  updateScheduledPushSend: (args: { input: UpdateScheduledPushSendInput }) => ScheduledPushSend
  /**
   * Update working hours for current user at specific site
   */
  updateSelfWorkingHours: (args: {
    siteId: ScalarsEnums['ID']
    workingHours: UpdateWorkingHoursWorkingHoursInput
  }) => Self
  /**
   * Toggle auto-renew for a service. Updates Service.autoRenew field.
   */
  updateServiceAutoRenew: (args: {
    autoRenew: ScalarsEnums['Boolean']
    serviceId: ScalarsEnums['String']
  }) => ScalarsEnums['Boolean']
  /**
   * Update a service template
   */
  updateServiceTemplate: (args: {
    input: UpdateServiceTemplateInputInput
    serviceTemplateId: ScalarsEnums['String']
  }) => ServiceTemplate
  /**
   * Assign an account code to a service template, or unassign it by passing a null accountCodeId
   */
  updateServiceTemplateAccountCode: (args: {
    accountCodeId?: Maybe<ScalarsEnums['ID']>
    serviceTemplateId: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => ServiceTemplate
  /**
   * Update a service template category
   */
  updateServiceTemplateCategory: (args: {
    input: UpdateServiceTemplateCategoryInput
    serviceTemplateCategoryId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => UpdateServiceTemplateCategoryResponse
  /**
   * Toggle a service template's site-wide New Sale featured flag (server-side toggle, OC-880)
   */
  updateServiceTemplateFeatured: (args: {
    serviceTemplateId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => UpdateServiceTemplateFeaturedResponse
  /**
   * Update an add-on pricing configuration
   */
  updateServiceTemplateSessionTypeAddOn: (args: {
    input: UpdateServiceTemplateSessionTypeAddOnInput
  }) => ServiceTemplateSessionTypeAddOn
  /**
   * Update a session. For recurring sessions, optionally specify scope to update future occurrences. Pass overrideDownstreamSplits=true with scope=THIS_AND_FUTURE to also replace any later split segments from the lineage.
   */
  updateSession: (args: {
    id: ScalarsEnums['String']
    input: SessionUpdateInput
    overrideDownstreamSplits?: Maybe<ScalarsEnums['Boolean']>
    scope?: Maybe<RecurringSessionEditScope>
    siteId: ScalarsEnums['String']
  }) => Session
  /**
   * Update a session feedback question
   */
  updateSessionFeedbackQuestion: (args: {
    input: SessionFeedbackQuestionUpdateInput
    questionId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => SessionFeedbackQuestion
  /**
   * Update a session filter
   */
  updateSessionFilter: (args: {
    input: SessionFilterUpdateInput
    sessionFilterId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => SessionFilter
  /**
   * Update a session template
   */
  updateSessionTemplate: (args: {
    id: ScalarsEnums['String']
    input: SessionTemplateUpdateInput
    siteId: ScalarsEnums['String']
  }) => SessionTemplate
  /**
   * Update a session like updateSession and report the clients whose spot changed because the room changed. Pass includeModifiedSessions=true with scope=THIS_AND_FUTURE to also apply the changed fields to sessions edited on their own; that option requires the apply-to-edited-sessions flag and fails with APPLY_TO_EDITED_SESSIONS_DISABLED when it is off.
   */
  updateSessionWithResult: (args: {
    id: ScalarsEnums['String']
    includeModifiedSessions?: Maybe<ScalarsEnums['Boolean']>
    input: SessionUpdateInput
    overrideDownstreamSplits?: Maybe<ScalarsEnums['Boolean']>
    scope?: Maybe<RecurringSessionEditScope>
    siteId: ScalarsEnums['String']
  }) => SessionUpdateResult
  /**
   * Update a site
   */
  updateSite: (args: { input: UpdateSiteInputInput; siteId: ScalarsEnums['ID'] }) => Site
  /**
   * Update a site access point
   */
  updateSiteAccessPoint: (args: {
    input: SiteAccessPointUpdateInput
    siteAccessPointId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => SiteAccessPoint
  /**
   * Update an access zone
   */
  updateSiteAccessZone: (args: {
    input: SiteAccessZoneUpdateInput
    siteAccessZoneId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => SiteAccessZone
  /**
   * Update an accounting code (partial). Never blocks on in-use (DD-009).
   */
  updateSiteAccountCode: (args: {
    accountCodeId: ScalarsEnums['ID']
    input: UpdateSiteAccountCodeInput
    siteId: ScalarsEnums['ID']
  }) => SiteAccountCode
  /**
   * Update the site's accounting-code configuration (feature toggle and/or intro-offer default)
   */
  updateSiteAccountCodeConfig: (args: {
    input: SiteAccountCodeConfigInput
    siteId: ScalarsEnums['ID']
  }) => SiteAccountCodeConfig
  /**
   * Replace the editable fields of an active or scheduled location alert
   */
  updateSiteAlert: (args: { input: UpdateSiteAlertInput }) => SiteAlertListItem
  /**
   * Update site communication template content
   */
  updateSiteCommunicationTemplate: (args: {
    alias: CommunicationTemplateAliases
    payload: SiteCommunicationTemplateUpdateInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteCommunicationTemplate
  /**
   * Toggle email status for site communication template
   */
  updateSiteCommunicationTemplateEmailStatus: (args: {
    alias: CommunicationTemplateAliases
    enabled: ScalarsEnums['Boolean']
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteCommunicationTemplateEmailStatus
  /**
   * Toggle push notification status for site communication template
   */
  updateSiteCommunicationTemplatePushNotificationStatus: (args: {
    alias: CommunicationTemplateAliases
    enabled: ScalarsEnums['Boolean']
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteCommunicationTemplatePushNotificationStatus
  /**
   * Toggle SMS status for site communication template
   */
  updateSiteCommunicationTemplateSmsStatus: (args: {
    alias: CommunicationTemplateAliases
    enabled: ScalarsEnums['Boolean']
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteCommunicationTemplateSmsStatus
  /**
   * Update multiple site communication settings
   */
  updateSiteCommunicationsSettings: (args: {
    siteId: ScalarsEnums['ID']
    updates: UpdateSiteCommunicationsSettingsUpdatesInput
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update a third-party integration configuration for a site
   */
  updateSiteCustomThirdPartyIntegration: (args: {
    input: UpdateSiteCustomThirdPartyIntegrationInput
    siteId: ScalarsEnums['ID']
  }) => Site
  /**
   * Update a site form
   */
  updateSiteForm: (args: {
    id: ScalarsEnums['String']
    input: SiteFormUpdateInput
    siteId: ScalarsEnums['ID']
  }) => SiteForm
  /**
   * Update a site form question
   */
  updateSiteFormQuestion: (args: {
    input: SiteFormQuestionUpdateInput
    questionId: ScalarsEnums['String']
    siteFormId: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => SiteFormMutationResponse
  /**
   * Update a site group. A change that takes brand items off sale needs acknowledgedWithdrawals to name each one
   */
  updateSiteGroup: (args: {
    acknowledgedWithdrawals?: Maybe<Array<BrandServiceTemplateWithdrawalAcknowledgementInput>>
    input: UpdateSiteGroupInputInput
    siteGroupId: ScalarsEnums['ID']
  }) => SiteGroup
  /**
   * Update a site location
   */
  updateSiteLocation: (args: {
    input: UpdateSiteLocationInput
    siteId: ScalarsEnums['ID']
    siteLocationId: ScalarsEnums['ID']
  }) => SiteLocation
  /**
   * Update a room in a site location
   */
  updateSiteLocationRoom: (args: {
    input: UpdateSiteLocationRoomInput
    siteId: ScalarsEnums['ID']
    siteLocationId: ScalarsEnums['ID']
    siteLocationRoomId: ScalarsEnums['ID']
  }) => SiteLocationRoom
  /**
   * Replace a location’s Plan your visit configuration
   */
  updateSiteMemberAppSettings: (args: {
    input: UpdateSiteMemberAppSettingsInput
  }) => SiteMemberAppSettingsResult
  /**
   * Update site name
   */
  updateSiteName: (args: { name: ScalarsEnums['String']; siteId: ScalarsEnums['ID'] }) => Site
  /**
   * Replace a location’s opening hours and whether the member app shows them
   */
  updateSiteOpeningHours: (args: {
    input: UpdateSiteOpeningHoursInput
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Save the brand payment-authorisation config for a site (all fields optional).
   */
  updateSitePaymentAuthorisationConfig: (args: {
    bankDebitCoversLocationsFrom?: Maybe<ScalarsEnums['String']>
    bankDebitEvidenceReference?: Maybe<ScalarsEnums['String']>
    bankDebitOriginatorName?: Maybe<ScalarsEnums['String']>
    cancellationPolicy?: Maybe<ScalarsEnums['String']>
    customerServiceContact?: Maybe<ScalarsEnums['String']>
    depositNote?: Maybe<ScalarsEnums['String']>
    legalEntityName?: Maybe<ScalarsEnums['String']>
    salesTaxNote?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['ID']
    template?: Maybe<ScalarsEnums['String']>
  }) => SitePaymentAuthorisationConfig
  /**
   * Update a payroll tier
   */
  updateSitePayrollTier: (args: {
    id: ScalarsEnums['ID']
    input: UpdateSitePayrollTierInputInput
    siteId: ScalarsEnums['ID']
  }) => CreateSitePayrollTier
  /**
   * Update a payroll tier configuration
   */
  updateSitePayrollTierConfiguration: (args: {
    input: UpdateSitePayrollTierConfigurationInputInput
    siteId: ScalarsEnums['ID']
    sitePayrollTierConfigurationId: ScalarsEnums['ID']
    sitePayrollTierId: ScalarsEnums['ID']
  }) => CreateSitePayrollTierConfiguration
  /**
   * Set whether a location may depart from its brand's product plan, and which plan it holds (OC-320)
   */
  updateSitePlanOverride: (args: {
    input: UpdateSitePlanOverrideInput
    siteId: ScalarsEnums['ID']
  }) => Site
  /**
   * Update a site policy; when the change publishes a revision the result says how many clients must accept again
   */
  updateSitePolicy: (args: {
    id: ScalarsEnums['String']
    input: SitePolicyUpdateInput
    siteId: ScalarsEnums['String']
  }) => SitePolicyUpdateResult
  /**
   * Change the location's equipment policy settings; omitted fields keep their saved value
   */
  updateSitePolicyComplianceSettings: (args: {
    input: PolicyComplianceSettingsInput
    siteId: ScalarsEnums['ID']
  }) => PolicyComplianceSettings
  /**
   * Update a site session type
   */
  updateSiteSessionType: (args: {
    id: ScalarsEnums['String']
    input: SiteSessionTypeUpdateInput
    siteId: ScalarsEnums['String']
  }) => SiteSessionType
  /**
   * Hapana admin only: enable or disable failing a declined bank debit over to the backup card for a site
   */
  updateSiteSettingsAccountBankFailoverToCard: (args: {
    enabled: ScalarsEnums['Boolean']
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site billing settings
   */
  updateSiteSettingsAccountBilling: (args: {
    input: UpdateSiteSettingsAccountBillingInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site invoice settings
   */
  updateSiteSettingsAccountInvoice: (args: {
    input: UpdateSiteSettingsAccountInvoiceInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site payroll settings
   */
  updateSiteSettingsAccountPayroll: (args: {
    input: UpdateSiteSettingsAccountPayrollInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site point of sale settings
   */
  updateSiteSettingsAccountPointOfSale: (args: {
    input: UpdateSiteSettingsAccountPointOfSaleInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site tax settings
   */
  updateSiteSettingsAccountTax: (args: {
    input: UpdateSiteSettingsAccountTaxInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site blocking reasons settings
   */
  updateSiteSettingsBlockingReasons: (args: {
    input: UpdateSiteSettingsBlockingReasonsInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site business customization settings
   */
  updateSiteSettingsBusinessCustomization: (args: {
    input: UpdateSiteSettingsBusinessCustomizationInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site business locations settings
   */
  updateSiteSettingsBusinessLocations: (args: {
    input: UpdateSiteSettingsBusinessLocationsInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site calendar configurations
   */
  updateSiteSettingsCalendarConfigurations: (args: {
    input: UpdateSiteSettingsCalendarConfigurationsInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site cancellation reasons settings
   */
  updateSiteSettingsCancellationReasons: (args: {
    input: UpdateSiteSettingsCancellationReasonsInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site check-in settings (supports all check-in and contactless fields)
   */
  updateSiteSettingsCheckIn: (args: {
    input: UpdateSiteSettingsCheckInInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site contactless check-in settings
   */
  updateSiteSettingsContactlessCheckIn: (args: {
    input: UpdateSiteSettingsContactlessCheckInInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site contactless check-in form questions
   */
  updateSiteSettingsContactlessCheckInFormQuestions: (args: {
    input: UpdateSiteSettingsContactlessCheckInFormQuestionsInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site customization color
   */
  updateSiteSettingsCustomizationColor: (args: {
    colorId: ScalarsEnums['String']
    input: CreateSiteSettingsCustomizationColorInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site lead sources settings
   */
  updateSiteSettingsLeadSources: (args: {
    input: LeadSourcesBulkUpdateInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site location operations business sign up fields configuration
   */
  updateSiteSettingsLocationOperationBusinessSignUpFields: (args: {
    input: UpdateSiteSettingsLocationOperationBusinessSignUpFieldsInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site location operations client sign up fields configuration
   */
  updateSiteSettingsLocationOperationClientSignUpFields: (args: {
    input: UpdateSiteSettingsLocationOperationClientSignUpFieldsInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update basic site location operations settings (autoLogout and enableClientsToSignUp)
   */
  updateSiteSettingsLocationOperationsMain: (args: {
    input: UpdateSiteSettingsLocationOperationsMainInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site refund reasons settings
   */
  updateSiteSettingsRefundReasons: (args: {
    input: RefundReasonsBulkUpdateInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site regional communication settings
   */
  updateSiteSettingsRegionalCommunication: (args: {
    input: UpdateSiteSettingsRegionalCommunicationInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site retail additional billing types settings
   */
  updateSiteSettingsRetailAdditionalBillingTypes: (args: {
    input: UpdateSiteSettingsRetailAdditionalBillingTypesInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site retail credits settings
   */
  updateSiteSettingsRetailCredits: (args: {
    input: UpdateSiteSettingsRetailCreditsInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site retail fees settings
   */
  updateSiteSettingsRetailFees: (args: {
    input: UpdateSiteSettingsRetailFeesInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site retail general sales settings
   */
  updateSiteSettingsRetailGeneralSales: (args: {
    input: UpdateSiteSettingsRetailGeneralSalesInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site retail giftcards settings
   */
  updateSiteSettingsRetailGiftcards: (args: {
    input: UpdateSiteSettingsRetailGiftcardsInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site retail sales settings
   */
  updateSiteSettingsRetailSalesSettings: (args: {
    input: UpdateSiteSettingsRetailSalesSettingsInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site retail suspension settings
   */
  updateSiteSettingsRetailSuspensions: (args: {
    input: UpdateSiteSettingsRetailSuspensionsInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site scheduler booking rules
   */
  updateSiteSettingsSchedulerBookingRules: (args: {
    input: UpdateSiteSettingsSchedulerBookingRulesInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site scheduler cancellation rules
   */
  updateSiteSettingsSchedulerCancellationRules: (args: {
    input: UpdateSiteSettingsSchedulerCancellationRulesInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site scheduler classes rules
   */
  updateSiteSettingsSchedulerClassesRules: (args: {
    input: UpdateSiteSettingsSchedulerClassesRulesInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site scheduler privates rules
   */
  updateSiteSettingsSchedulerPrivatesRules: (args: {
    input: UpdateSiteSettingsSchedulerPrivatesRulesInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site scheduler reservations rules
   */
  updateSiteSettingsSchedulerReservationsRules: (args: {
    input: UpdateSiteSettingsSchedulerReservationsRulesInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site scheduler waitlist rules
   */
  updateSiteSettingsSchedulerWaitlistRules: (args: {
    input: UpdateSiteSettingsSchedulerWaitlistRulesInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site scheduler workshops rules
   */
  updateSiteSettingsSchedulerWorkshopsRules: (args: {
    input: UpdateSiteSettingsSchedulerWorkshopsRulesInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site social media settings
   */
  updateSiteSettingsSocialMedia: (args: {
    input: UpdateSiteSettingsSocialMediaInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update site location operations suspension reasons
   */
  updateSiteSettingsSuspensionReasons: (args: {
    input: UpdateSiteSettingsSuspensionReasonsInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update a site supplier
   */
  updateSiteSupplier: (args: {
    input: UpdateSiteSupplierInput
    siteId: ScalarsEnums['String']
    siteSupplierId: ScalarsEnums['String']
  }) => UpdateSiteSupplierResponse
  /**
   * Save how a location uses its Stripe readers for signatures and member details
   */
  updateSiteTerminalHandoffSettings: (args: {
    input: UpdateSiteTerminalHandoffSettingsInput
    siteId: ScalarsEnums['ID']
  }) => SiteTerminalHandoffSettingsView
  /**
   * Update a terminal reader name or active status
   */
  updateSiteTerminalReader: (args: {
    input: UpdateSiteTerminalReaderInputInput
    siteId: ScalarsEnums['ID']
    siteTerminalReaderId: ScalarsEnums['ID']
  }) => SiteTerminalReader
  /**
   * Update site timezone and re-register scheduled jobs
   */
  updateSiteTimezone: (args: {
    siteId: ScalarsEnums['ID']
    timezone: ScalarsEnums['String']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update an existing site webhook
   */
  updateSiteWebhook: (args: {
    input: UpdateSiteWebhookInputInput
    siteId: ScalarsEnums['String']
    webhookId: ScalarsEnums['String']
  }) => SiteWebhook
  /**
   * Set brand-wide which locations may override the brand plan; all others return to inheriting (OC-320)
   */
  updateSitesPlanOverrideAllowed: (args: {
    allowAll?: Maybe<ScalarsEnums['Boolean']>
    allowedSiteIds: Array<ScalarsEnums['ID']>
  }) => SetSitesPlanOverrideAllowedResult
  /**
   * Update existing pricing tier in an SMS package
   */
  updateSmsPackageOption: (args: {
    input: UpdateSmsPackageOptionInputInput
    optionId: ScalarsEnums['ID']
    smsPackageId: ScalarsEnums['ID']
  }) => SmsPackage
  /**
   * Update a SOAP note
   */
  updateSoapNote: (args: {
    input: SoapNoteUpdateInput
    siteId: ScalarsEnums['String']
    soapNoteId: ScalarsEnums['String']
  }) => UpdateSoapNoteResponse
  /**
   * Update Spivi integration configuration
   */
  updateSpivi: (args: { input?: Maybe<UpdateSpiviInputInput>; siteId: ScalarsEnums['ID'] }) => Site
  /**
   * Update a staff access policy
   */
  updateStaffAccessPolicy: (args: {
    input: UpdateStaffAccessPolicyInputInput
    staffAccessPolicyId: ScalarsEnums['ID']
  }) => ScalarsEnums['ID']
  /**
   * Update an allowed network
   */
  updateStaffAllowedNetwork: (args: {
    input: UpdateStaffAllowedNetworkInputInput
    staffAllowedNetworkId: ScalarsEnums['ID']
  }) => StaffAllowedNetwork
  /**
   * Set the payroll ID exported with commissions and payroll for a staff user
   */
  updateStaffPayrollId: (args: {
    payrollId?: Maybe<ScalarsEnums['String']>
    staffUserId: ScalarsEnums['ID']
  }) => Maybe<ScalarsEnums['String']>
  /**
   * Update a staff session assignment
   */
  updateStaffSessionAssignment: (args: {
    data: StaffSessionAssignmentUpdateInput
    staffSessionAssignmentId: ScalarsEnums['ID']
  }) => StaffSessionAssignment
  /**
   * Update the brand's staff session policy
   */
  updateStaffSessionPolicy: (args: {
    input: UpdateStaffSessionPolicyInputInput
  }) => StaffSessionPolicy
  /**
   * Update an staff user
   */
  updateStaffUser: (args: {
    input: UpdateStaffUserInputInput
    staffUserId: ScalarsEnums['ID']
  }) => StaffUser
  updateStaffUserSmartGroup: (args: {
    input: UpdateStaffUserSmartGroupInputInput
    siteId: ScalarsEnums['String']
    staffUserId: ScalarsEnums['String']
    staffUserSmartGroupId: ScalarsEnums['String']
  }) => StaffUserSmartGroup
  /**
   * Update a staff user status
   */
  updateStaffUserStatus: (args: {
    input: UpdateStaffUserStatusInputInput
    staffUserId: ScalarsEnums['ID']
  }) => ScalarsEnums['ID']
  updateSupportChat: (args: {
    input: UpdateSupportChatInput
    supportChatId: ScalarsEnums['ID']
  }) => SupportChat
  /**
   * Update system preferences for location operations
   */
  updateSystemPreferences: (args: {
    input: UpdateSystemPreferencesInputInput
    siteId: ScalarsEnums['ID']
  }) => UpdateSiteSettingsAccountBilling
  /**
   * Update tanning hardware integration configuration for a site
   */
  updateTanningIntegration: (args: {
    input: UpdateTanningIntegrationInput
    siteId: ScalarsEnums['ID']
  }) => Site
  /**
   * Update a tax setting
   */
  updateTaxSetting: (args: {
    input: UpdateTaxSettingInputInput
    siteId: ScalarsEnums['ID']
    taxSettingId: ScalarsEnums['ID']
  }) => TaxSetting
  /**
   * Update a third party integration
   */
  updateThirdPartyIntegration: (args: {
    input: ThirdPartyIntegrationUpdateInput
    thirdPartyIntegrationId: ScalarsEnums['ID']
  }) => ThirdPartyIntegrationWithKeys
  /**
   * Update a third party integration key
   */
  updateThirdPartyIntegrationKey: (args: {
    input: ThirdPartyIntegrationKeyUpdateInput
    thirdPartyIntegrationId: ScalarsEnums['ID']
    thirdPartyIntegrationKeyId: ScalarsEnums['ID']
  }) => ThirdPartyIntegrationKey
  /**
   * Update Topaz integration configuration
   */
  updateTopaz: (args: { input?: Maybe<UpdateTopazInputInput>; siteId: ScalarsEnums['ID'] }) => Site
  /**
   * Update a future recurring invoice occurrence (amount, discount, or date)
   */
  updateVirtualInvoice: (args: {
    input: UpdateVirtualInvoiceInput
    siteId: ScalarsEnums['ID']
  }) => Maybe<ScalarsEnums['ID']>
  /**
   * Update the position of a waitlist entry
   */
  updateWaitlistPosition: (args: {
    newPosition: ScalarsEnums['Float']
    sessionWaitlistEntryId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => SessionWaitlistEntry
  /**
   * Update working hours for staff user at specific site
   */
  updateWorkingHours: (args: {
    siteId: ScalarsEnums['ID']
    staffUserId: ScalarsEnums['ID']
    workingHours?: Maybe<UpdateWorkingHoursWorkingHoursInput>
  }) => ScalarsEnums['Boolean']
  /**
   * Update Zapier integration configuration
   */
  updateZapier: (args: {
    input?: Maybe<UpdateZapierInputInput>
    siteId: ScalarsEnums['ID']
  }) => Site
  /**
   * Update Zoom integration configuration
   */
  updateZoom: (args: { input: UpdateZoomInput; siteId: ScalarsEnums['ID'] }) => Site
  /**
   * Upload a custom font file to Google Cloud Storage and add to configuration
   */
  uploadCustomFont: (args: {
    corporateId: ScalarsEnums['String']
    fontFile: ScalarsEnums['String']
    fontName: ScalarsEnums['String']
    userId?: Maybe<ScalarsEnums['String']>
  }) => UploadCustomFont
  /**
   * Save the territories and base territory for a brand platform
   */
  upsertBrandAppAvailability: (args: {
    availableInNewTerritories?: Maybe<ScalarsEnums['Boolean']>
    baseTerritory?: Maybe<ScalarsEnums['String']>
    brandId: ScalarsEnums['String']
    platform: BrandPlatform
    territories: Array<ScalarsEnums['String']>
  }) => BrandAppAvailability
  /**
   * Save the categories, content rights and age rating info for a brand platform
   */
  upsertBrandAppInformation: (args: {
    ageRatingInfoUrl?: Maybe<ScalarsEnums['String']>
    brandId: ScalarsEnums['String']
    contentRightsDeclaration?: Maybe<AppleContentRightsDeclaration>
    copyright?: Maybe<ScalarsEnums['String']>
    platform: BrandPlatform
    primaryCategory?: Maybe<ScalarsEnums['String']>
    secondaryCategory?: Maybe<ScalarsEnums['String']>
  }) => BrandAppInformation
  /**
   * Save store asset metadata for upload readiness
   */
  upsertBrandStoreAsset: (args: {
    assetType: BrandStoreAssetType
    brandId: ScalarsEnums['String']
    deviceClass?: Maybe<ScalarsEnums['String']>
    filename: ScalarsEnums['String']
    gcsPath: ScalarsEnums['String']
    locale: ScalarsEnums['String']
    platform: BrandPlatform
  }) => Array<UpsertBrandStoreAsset>
  /**
   * Save store listing metadata for a brand platform and locale
   */
  upsertBrandStoreListing: (args: {
    appName?: Maybe<ScalarsEnums['String']>
    brandId: ScalarsEnums['String']
    description?: Maybe<ScalarsEnums['String']>
    keywords?: Maybe<ScalarsEnums['String']>
    locale: ScalarsEnums['String']
    marketingUrl?: Maybe<ScalarsEnums['String']>
    platform: BrandPlatform
    privacyPolicyUrl?: Maybe<ScalarsEnums['String']>
    releaseNotes?: Maybe<ScalarsEnums['String']>
    shortDescription?: Maybe<ScalarsEnums['String']>
    subtitle?: Maybe<ScalarsEnums['String']>
    supportUrl?: Maybe<ScalarsEnums['String']>
  }) => Array<UpsertBrandStoreListing>
  /**
   * Save the App Review demo account and contact details for a brand platform
   */
  upsertBrandStoreReviewDetail: (args: {
    brandId: ScalarsEnums['String']
    contactEmail?: Maybe<ScalarsEnums['String']>
    contactFirstName?: Maybe<ScalarsEnums['String']>
    contactLastName?: Maybe<ScalarsEnums['String']>
    contactPhone?: Maybe<ScalarsEnums['String']>
    demoAccountName?: Maybe<ScalarsEnums['String']>
    demoAccountPassword?: Maybe<ScalarsEnums['String']>
    demoAccountRequired?: Maybe<ScalarsEnums['Boolean']>
    notes?: Maybe<ScalarsEnums['String']>
    platform: BrandPlatform
  }) => BrandStoreReviewDetail
  /**
   * Save a tester for store testing channels
   */
  upsertBrandStoreTester: (args: {
    brandId: ScalarsEnums['String']
    email: ScalarsEnums['String']
    name?: Maybe<ScalarsEnums['String']>
    platforms: Array<BrandPlatform>
    source: BrandStoreTesterSource
  }) => Array<UpsertBrandStoreTester>
  /**
   * Save integration credentials for one surface and provider
   */
  upsertMemberExperienceSurfaceIntegration: (args: {
    appId?: Maybe<ScalarsEnums['String']>
    clientToken?: Maybe<ScalarsEnums['String']>
    corporateId: ScalarsEnums['String']
    displayName?: Maybe<ScalarsEnums['String']>
    provider: MemberExperienceSurfaceIntegrationProvider
    surface: MemberExperienceSurface
    userId?: Maybe<ScalarsEnums['String']>
  }) => Array<MemberExperienceSurfaceIntegration>
  /**
   * Ask Apple whether the stored session is still alive, renewing it if not
   */
  verifyAppleAccountSession: AppleAccountSession
  /**
   * Record a client's date of birth and how it was verified, such as a staff ID check
   */
  verifyClientAge: (args: {
    clientId: ScalarsEnums['ID']
    dateOfBirth: ScalarsEnums['String']
    method: AgeVerificationMethod
    siteId: ScalarsEnums['ID']
  }) => ClientAgeVerification
  /**
   * Trigger DNS verification for a registered email domain
   */
  verifyEmailDomain: (args: { corporateId: ScalarsEnums['String'] }) => CorporateEmailDomain
  /**
   * Check the signed-in staff member’s approval PIN, for example to unlock a desk-mode screen; wrong PINs count toward the lockout
   */
  verifyMyApprovalPin: (args: {
    pin: ScalarsEnums['String']
    siteId?: Maybe<ScalarsEnums['ID']>
  }) => ApprovalPinStatus
  /**
   * Void a client agreement. Revokes any outstanding public-link tokens and marks the agreement as REVOKED. Staff action.
   */
  voidAgreement: (args: {
    agreementId: ScalarsEnums['ID']
    clientId: ScalarsEnums['ID']
    reason?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['ID']
  }) => ClientAgreement
  /**
   * Void a running tanning session without moving it: cancel it, restore the credit, reverse attendance, release a paid add-on, and free or disable the bed
   */
  voidEquipmentAssignment: (args: {
    input: VoidEquipmentAssignmentInput
  }) => ReverseEquipmentAssignmentResult
  /**
   * Void a policy acceptance with a reason; the evidence is kept and stops counting
   */
  voidPolicyAcceptance: (args: {
    agreementId: ScalarsEnums['ID']
    reason: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => PolicyAcceptanceVoidResult
  /**
   * Void every acceptance written by one signed-policy import batch; evidence is kept
   */
  voidPolicyImportBatch: (args: {
    batchId: ScalarsEnums['ID']
    reason: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => VoidPolicyImportResult
  /**
   * Void one acceptance written by a signed-policy import batch; evidence is kept
   */
  voidPolicyImportRow: (args: {
    agreementId: ScalarsEnums['ID']
    batchId: ScalarsEnums['ID']
    reason: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => VoidPolicyImportResult
  /**
   * Withdraw the signed-in instructor's pending claim on a cover
   */
  withdrawCoverClaim: (args: {
    coverRequestId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => CoverRequestView
  /**
   * Withdraw a signer's electronic consent; their open links are revoked and existing acceptances keep counting
   */
  withdrawElectronicConsent: (args: {
    clientId: ScalarsEnums['ID']
    signerId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => ElectronicConsentWithdrawalResult
  /**
   * Record a guardian withdrawing permission for the client to use equipment; that guardian's acceptances stop counting
   */
  withdrawGuardianPermission: (args: {
    clientId: ScalarsEnums['ID']
    guardianSignerId: ScalarsEnums['ID']
    reason?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['ID']
  }) => GuardianPermissionWithdrawal
}

export interface Query {
  __typename?: 'Query'
  /**
   * List the open pending-items links for a client at a location, newest first
   */
  activePendingItemsHandoffs: (args: {
    clientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Array<PendingItemsHandoff>
  /**
   * List the live session types at a location a price group can hold; empty when price groups are not available there
   */
  addOnPriceGroupSessionTypes: (args: {
    siteId: ScalarsEnums['ID']
  }) => Array<AddOnPriceGroupSessionTypeOption>
  /**
   * List the add-on price groups at a location; empty when price groups are not available there
   */
  addOnPriceGroups: (args: { siteId: ScalarsEnums['ID'] }) => Array<AddOnPriceGroup>
  /**
   * Get an admin access group by its ID
   */
  adminAccessGroup: (args: { id: ScalarsEnums['ID'] }) => AdminAccessGroup
  /**
   * List all admin access groups
   */
  adminAccessGroups: Array<AdminAccessGroup>
  /**
   * Partner booking totals for a site and provider over a session-date range, with a per-day breakdown (admin)
   */
  adminAggregatorLocationSummary: (args: {
    aggregatorProviderId: ScalarsEnums['String']
    endDate: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
    startDate: ScalarsEnums['String']
  }) => AdminAggregatorLocationSummary
  /**
   * Get aggregator sessions for a site and provider with pagination (admin)
   */
  adminAggregatorSessions: (args: {
    aggregatorProviderId: ScalarsEnums['String']
    endDate: ScalarsEnums['String']
    onlyWithBookings?: Maybe<ScalarsEnums['Boolean']>
    page?: Maybe<ScalarsEnums['Float']>
    pageSize?: Maybe<ScalarsEnums['Float']>
    search?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['String']
    sort?: Maybe<ScalarsEnums['AdminAggregatorSessionSort']>
    startDate: ScalarsEnums['String']
  }) => AdminAggregatorSessionsResponse
  /**
   * Query audit events across all corporates (Admin-only, uses wildcard tables)
   */
  adminAuditEvents: (args?: {
    filter?: Maybe<AdminAuditEventsFilterInput>
    pagination?: Maybe<AuditEventsPaginationInput>
    sort?: Maybe<AuditEventsSortInput>
  }) => AuditQueryResult
  /**
   * Report a site's Ezypay webhook subscriptions and V2 routing readiness (verify-only, no writes)
   */
  adminCheckEzypayWebhooks: (args: { siteId: ScalarsEnums['ID'] }) => Array<ScalarsEnums['String']>
  /**
   * Compare the corporate's SiteIndex rows against its V1 sites in BigQuery (read-only)
   */
  adminCheckSiteIndex: (args: {
    corporateId: ScalarsEnums['ID']
    includeInactive: ScalarsEnums['Boolean']
  }) => Array<ScalarsEnums['String']>
  /**
   * Verify Stripe Customer and PaymentMethod metadata for a site (verify-only, no writes)
   */
  adminCheckStripeMetadata: (args: {
    siteId: ScalarsEnums['String']
  }) => Array<ScalarsEnums['String']>
  /**
   * List mobile app status across active brands for Hapana Admin operators
   */
  adminMobileFleet: (args: {
    platform: AdminMobileFleetPlatformFilter
    quickFilter: AdminMobileFleetQuickFilter
    search?: Maybe<ScalarsEnums['String']>
    status: AdminMobileFleetStatusFilter
  }) => AdminMobileFleet
  /**
   * Get an admin user by ID
   */
  adminUser: (args: { adminUserId: ScalarsEnums['ID'] }) => AdminUser
  /**
   * Find admin users
   */
  adminUsers: (args: {
    cursor?: Maybe<ScalarsEnums['String']>
    filter?: Maybe<AdminUsersFilterInput>
    orderBy: Array<AdminUsersOrderByInput>
    pageSize?: Maybe<ScalarsEnums['Float']>
    search?: Maybe<ScalarsEnums['String']>
  }) => AdminUsers
  /**
   * Aggregate audit events with GROUP BY for summary statistics
   */
  aggregateAuditEvents: (args: {
    filter: AuditEventsFilterInput
    groupBy: AuditAggregationGroupBy
    sortDirection: AuditSortDirection
    topN: ScalarsEnums['Float']
  }) => AuditAggregationResult
  /**
   * Get an aggregator provider by ID
   */
  aggregatorProvider: (args: { aggregatorProviderId: ScalarsEnums['String'] }) => AggregatorProvider
  /**
   * List all aggregator providers
   */
  aggregatorProviders: Array<AggregatorProvider>
  /**
   * Get all default text values for a language from member.json
   */
  allDefaults: (args: { language: ScalarsEnums['String'] }) => AllDefaults
  /**
   * Customer-visible semantic-layer catalog for the BI Analyze builder
   */
  analyticsV2CustomerCatalog: AnalyticsV2CubeSchemaMetaResponse
  /**
   * Execute a measure query with server-enforced tenant scoping
   */
  analyticsV2QueryMeasure: (args: {
    input: AnalyticsV2QueryMeasureInput
  }) => AnalyticsV2QueryMeasureResponse
  /**
   * Compile a Cube query to its tenancy-scoped SQL without executing it
   */
  analyticsV2QuerySql: (args: {
    input: AnalyticsV2QueryMeasureInput
  }) => AnalyticsV2QuerySqlResponse
  /**
   * Return the full Cube semantic-layer meta (staff/admin only)
   */
  analyticsV2SchemaMeta: AnalyticsV2CubeSchemaMetaResponse
  analyzeText: (args: { input: NLPAnalysisInput }) => NLPAnalysis
  /**
   * One logged call with its full (redacted) request and response. Pass the row occurredAt to keep the lookup cheap.
   */
  apiCallLog: (args: {
    corporateId: ScalarsEnums['ID']
    id: ScalarsEnums['ID']
    occurredAt?: Maybe<ScalarsEnums['String']>
  }) => Maybe<ApiCallLog>
  /**
   * Business API calls, member API calls and webhook deliveries for a brand, newest first. Defaults to the last 24 hours.
   */
  apiCallLogs: (args: {
    corporateId: ScalarsEnums['ID']
    cursor?: Maybe<ScalarsEnums['String']>
    filter?: Maybe<ApiCallLogFilterInput>
    pageSize?: Maybe<ScalarsEnums['Int']>
  }) => ApiCallLogPage
  /**
   * Get a single API credential by id (scoped to the caller corporate)
   */
  apiCredential: (args: { apiCredentialId: ScalarsEnums['ID'] }) => Maybe<ApiCredential>
  /**
   * List all API credentials for the authenticated corporate
   */
  apiCredentials: Array<ApiCredential>
  /**
   * Get app store credentials for a corporate and platform
   */
  appStoreCredentials: (args: {
    corporateId: ScalarsEnums['ID']
    /**
     * Mobile platform (IOS or ANDROID)
     */
    platform: ScalarsEnums['String']
  }) => Maybe<AppStoreCredentials>
  /**
   * The shared Apple ID's App Store Connect session and what it needs next
   */
  appleAccountSession: AppleAccountSession
  /**
   * Whether App Store Connect automation can act for this brand, and why not if it cannot
   */
  appleAutomationStatus: (args: { brandId: ScalarsEnums['String'] }) => AppleAutomationStatus
  /**
   * Candidates for a brand's numeric App Store Connect team id — an exact match by the team's API key issuer when one is connected, otherwise ranked name matches; always a list for a person to confirm. `appleTeamId` lets the value typed in the form be used before it is saved.
   */
  appleTeamCandidates: (args: {
    appleTeamId?: Maybe<ScalarsEnums['String']>
    brandId: ScalarsEnums['String']
  }) => Array<AppleTeamCandidate>
  /**
   * The Apple team compliance facts behind a brand's iOS builds
   */
  appleTeamComplianceForBrand: (args: {
    brandId: ScalarsEnums['String']
  }) => Maybe<AppleTeamCompliance>
  /**
   * Get an attendance record by ID
   */
  attendance: (args: { attendanceId: ScalarsEnums['String'] }) => Maybe<Attendance>
  /**
   * Get attendance record for a booking
   */
  attendanceByBookingId: (args: { bookingId: ScalarsEnums['String'] }) => Maybe<Attendance>
  /**
   * Get attendance records for a client
   */
  attendanceByClientId: (args: {
    clientId: ScalarsEnums['String']
    includeReversed?: Maybe<ScalarsEnums['Boolean']>
    limit?: Maybe<ScalarsEnums['Float']>
  }) => Array<Attendance>
  /**
   * Get attendance records for a session
   */
  attendanceBySessionId: (args: {
    includeReversed?: Maybe<ScalarsEnums['Boolean']>
    sessionId: ScalarsEnums['String']
  }) => Array<Attendance>
  /**
   * Query audit events with filters and pagination
   */
  auditEvents: (args: {
    filter: AuditEventsFilterInput
    pagination?: Maybe<AuditEventsPaginationInput>
    sort?: Maybe<AuditEventsSortInput>
  }) => AuditQueryResult
  /**
   * List third party integrations available for admin corporate users
   */
  availableAdminCorporateThirdPartyIntegrations: Array<ThirdPartyIntegrationWithKeys>
  /**
   * List third party integrations available for admin site users
   */
  availableAdminSiteThirdPartyIntegrations: Array<ThirdPartyIntegrationWithKeys>
  availableClientTabs: (args: { siteId: ScalarsEnums['String'] }) => AvailableClientTabsResponse
  /**
   * List third party integrations available for corporate users
   */
  availableCorporateUserThirdPartyIntegrations: Array<ThirdPartyIntegrationWithKeys>
  /**
   * List equipment units that are currently available at a site
   */
  availableEquipments: (args: { siteId: ScalarsEnums['String'] }) => Array<Equipment>
  /**
   * List available membership plan options for a service. Returns templates with changePlanEnabled=true, excluding the current plan. Optionally filtered to templates that cover a specific session type.
   */
  availablePlanOptions: (args: {
    serviceId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
    siteSessionTypeId?: Maybe<ScalarsEnums['ID']>
  }) => Array<PlanOption>
  /**
   * List all available reports with metadata, columns, and filters
   */
  availableReports: (args?: { input?: Maybe<AvailableReportsInputInput> }) => AvailableReports
  /**
   * List third-party integrations available for site users to configure
   */
  availableSiteThirdPartyIntegrations: (args: {
    siteId: ScalarsEnums['ID']
  }) => Array<ThirdPartyIntegrationWithKeys>
  /**
   * Get regions available to assign based on user permissions
   */
  availableToAssignRegions: (args?: {
    filter?: Maybe<AvailableToAssignRegionsFilterInput>
  }) => Array<Regions>
  /**
   * List V2-enabled active locations for a corporate. Sites with an existing Zapier connection are returned with alreadyConnected=true so the picker can warn that re-connecting will replace the existing link (the confirm step revokes any prior connection).
   */
  availableZapierLocations: (args: {
    corporateId: ScalarsEnums['ID']
  }) => Array<AvailableZapierLocations>
  /**
   * Persisted DashView workspace mapping for the calling corporate (Hapana staff only)
   */
  biMigrationConfig: BiMigrationConfig
  /**
   * Compare a Cube measure with its GoodData counterpart for a corporate (Hapana staff only)
   */
  biParityCheckMeasure: (args: { input: BiParityCheckInput }) => BiParityCheckResult
  /**
   * Published BI dashboard bundles for the calling corporate, in sidebar order
   */
  biTenantDashboards: BiTenantDashboardsResponse
  /**
   * Get a booking by ID
   */
  booking: (args: { id: ScalarsEnums['String'] }) => Maybe<Booking>
  /**
   * Get activity logs for a booking
   */
  bookingActivityLogs: (args: { bookingId: ScalarsEnums['String'] }) => Array<BookingActivityLog>
  /**
   * Get activity logs for a client
   */
  bookingActivityLogsByClientId: (args: {
    clientId: ScalarsEnums['String']
    limit?: Maybe<ScalarsEnums['Float']>
  }) => Array<BookingActivityLog>
  /**
   * Get activity logs for a site
   */
  bookingActivityLogsBySiteId: (args: {
    limit?: Maybe<ScalarsEnums['Float']>
    siteId: ScalarsEnums['String']
  }) => Array<BookingActivityLog>
  /**
   * List the member's packages for a confirmed, upcoming credit-paid booking, marking which ones its credit can be moved to and why the others cannot
   */
  bookingCreditPackageOptions: (args: {
    bookingId: ScalarsEnums['ID']
  }) => BookingCreditPackageOptions
  /**
   * OC-1176: why each pending drop-in booking could not be paid with credits, so staff see the reason alongside the drop-in rate. Bookings that are not pending drop-ins are omitted.
   */
  bookingCreditShortfalls: (args: {
    bookingIds: Array<ScalarsEnums['ID']>
    siteId: ScalarsEnums['ID']
  }) => Array<BookingCreditShortfall>
  /**
   * List bookings with cursor-based pagination
   */
  bookings: (args: {
    after?: Maybe<ScalarsEnums['String']>
    before?: Maybe<ScalarsEnums['String']>
    clientId?: Maybe<ScalarsEnums['String']>
    pageSize: ScalarsEnums['Float']
    sessionId?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['String']
    status?: Maybe<BookingStatus>
  }) => BookingPaginationResult
  /**
   * Get all bookings for a specific session
   */
  bookingsBySessionId: (args: {
    includeAttendanceCounts?: Maybe<ScalarsEnums['Boolean']>
    sessionId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Array<Booking>
  /**
   * Validate Branch.io configuration for a corporate
   */
  branchConfigStatus: (args: { corporateId: ScalarsEnums['String'] }) => BranchConfigStatus
  /**
   * A brand add-on's prices for a location to attach to its own memberships, tax in the location's settings
   */
  brandAddOnPricePoints: (args: {
    serviceTemplateId: ScalarsEnums['ID']
  }) => Array<BrandAddOnLocationPricePoint>
  /**
   * The territories a brand sells in, and the territory its price is set from
   */
  brandAppAvailability: (args: {
    brandId: ScalarsEnums['String']
    platform: BrandPlatform
  }) => Maybe<BrandAppAvailability>
  /**
   * The App Information App Store Connect holds for a brand platform
   */
  brandAppInformation: (args: {
    brandId: ScalarsEnums['String']
    platform: BrandPlatform
  }) => Maybe<BrandAppInformation>
  /**
   * A brand's current app icon and login logo, read from the same Control Hub branding record its own operator edits
   */
  brandArtwork: (args: { brandId: ScalarsEnums['String'] }) => BrandArtwork
  /**
   * The config the next native build of this brand will receive, with secrets masked and the source of each value
   */
  brandBuildConfigView: (args: { brandId: ScalarsEnums['String'] }) => BrandBuildConfigView
  /**
   * A brand's stored build profile with the Branch keys and Facebook client token masked; null when the brand has none yet
   */
  brandBuildProfile: (args: { brandId: ScalarsEnums['String'] }) => Maybe<BrandBuildProfile>
  /**
   * Get a brand's currently-published config
   */
  brandConfig: (args: { brandId: ScalarsEnums['String'] }) => Maybe<BrandConfig>
  /**
   * List a brand's config version history, newest first
   */
  brandConfigVersions: (args: {
    brandId: ScalarsEnums['String']
    limit?: Maybe<ScalarsEnums['Float']>
  }) => Array<BrandConfigVersionSummary>
  /**
   * Brand-wide default class cover settings
   */
  brandCoverSettings: CoverSettingsOverrides
  /**
   * The Firebase apps registered for a brand's identifiers
   */
  brandFirebaseApps: (args: { brandId: ScalarsEnums['String'] }) => Maybe<BrandFirebaseApps>
  /**
   * The Firebase config files for a brand, fetched live and never stored
   */
  brandFirebaseConfigFiles: (args: {
    brandId: ScalarsEnums['String']
  }) => Array<BrandFirebaseConfigFile>
  /**
   * A brand's stored store-facing identifiers, or null when no registry brand exists
   */
  brandIdentity: (args: { brandId: ScalarsEnums['String'] }) => Maybe<BrandIdentity>
  /**
   * A brand's Android permissions and iOS permission prompts: fleet defaults plus its own
   */
  brandNativePermissions: (args: { brandId: ScalarsEnums['String'] }) => BrandNativePermissions
  /**
   * List a brand's native build/release history, newest first
   */
  brandNativeReleases: (args: {
    brandId: ScalarsEnums['String']
    limit?: Maybe<ScalarsEnums['Float']>
    platform?: Maybe<BrandPlatform>
  }) => Array<BrandNativeRelease>
  /**
   * A brand's uploaded home logo and tab icons; staff only. A null slot means the build keeps the brand folder or fleet default
   */
  brandNavigationArtwork: (args: { brandId: ScalarsEnums['String'] }) => BrandNavigationArtwork
  /**
   * The latest persisted outcome of each of a brand's provisioning steps — what happened, what is blocking, who must act, and who ran it when — so a reload or another seat sees it
   */
  brandProvisioningOutcomes: (args: {
    brandId: ScalarsEnums['String']
  }) => Array<BrandProvisioningOutcome>
  /**
   * Which push service a brand's app uses, the app id its devices register under, and the Firebase project that delivers it
   */
  brandPushSettings: (args: { brandId: ScalarsEnums['String'] }) => Maybe<BrandPushSettings>
  /**
   * What a brand still needs before a native build can be requested
   */
  brandReleaseReadiness: (args: {
    brandId: ScalarsEnums['String']
    platform: BrandPlatform
  }) => BrandReleaseReadiness
  /**
   * The latest release and tester link for one of a brand's platforms
   */
  brandReleaseStatus: (args: {
    brandId: ScalarsEnums['String']
    platform: BrandPlatform
  }) => BrandReleaseStatus
  /**
   * A brand's onboarding steps, resolved against what is currently known
   */
  brandSetupSteps: (args: { brandId: ScalarsEnums['String'] }) => Array<BrandSetupStepView>
  /**
   * Store assets staged for provider upload
   */
  brandStoreAssets: (args: { brandId: ScalarsEnums['String'] }) => Array<BrandStoreAssets>
  /**
   * Check the submitted Google Play listing icon against the public store icon
   */
  brandStoreListingIconPublicationStatus: (args: {
    brandId: ScalarsEnums['String']
  }) => BrandStoreListingPublicationView
  /**
   * Check submitted listing metadata against the public Apple and Google stores
   */
  brandStoreListingPublicationStatus: (args: {
    brandId: ScalarsEnums['String']
  }) => Array<BrandStoreListingPublicationView>
  /**
   * Store listing metadata staged for provider sync
   */
  brandStoreListings: (args: { brandId: ScalarsEnums['String'] }) => Array<BrandStoreListings>
  /**
   * The latest store-provider state and recent operations for a brand
   */
  brandStoreOperationsOverview: (args: {
    brandId: ScalarsEnums['String']
  }) => BrandStoreOperationsOverview
  /**
   * Reveal the stored App Review demo account password so it can be verified
   */
  brandStoreReviewDemoPassword: (args: {
    brandId: ScalarsEnums['String']
    platform: BrandPlatform
  }) => Maybe<ScalarsEnums['String']>
  /**
   * The App Review information Apple needs before reviewing a build
   */
  brandStoreReviewDetail: (args: {
    brandId: ScalarsEnums['String']
    platform: BrandPlatform
  }) => Maybe<BrandStoreReviewDetail>
  /**
   * Tester roster used for TestFlight and Google Play sync
   */
  brandStoreTesters: (args: { brandId: ScalarsEnums['String'] }) => Array<BrandStoreTesters>
  /**
   * List the registry brands owned by the caller's corporate
   */
  brandsForCurrentCorporate: Array<BrandSummary>
  /**
   * Read-only share-link check (does NOT consume the token) plus the inviter name and a freshly signed profile image
   */
  buddyInviteContext: (args: {
    inviteToken: ScalarsEnums['String']
    inviterClientId: ScalarsEnums['ID']
  }) => BuddyInviteContext
  /**
   * Read-only share-link invite token check (does NOT consume the token)
   */
  buddyInviteTokenValid: (args: {
    inviteToken: ScalarsEnums['String']
    inviterClientId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Get list of available built-in fonts
   */
  builtinFonts: Array<ScalarsEnums['String']>
  /**
   * Calculate cart totals with taxes and discounts. Use this for frontend cart display to ensure consistent calculations with invoice creation.
   */
  calculateCart: (args: {
    items: Array<CalculateCartItemsInput>
    siteId: ScalarsEnums['String']
  }) => CalculateCart
  /**
   * Calculate fees for a payment including platform fees, royalties, rebates, and client pass-through fees
   */
  calculateFees: (args: { request: FeeCalculationRequest }) => FeeCalculationResult
  /**
   * Get lightweight session data optimized for calendar/scheduler display
   */
  calendarSessions: (args: {
    endDate: ScalarsEnums['String']
    filters?: Maybe<SessionQueryFiltersInput>
    siteId: ScalarsEnums['String']
    startDate: ScalarsEnums['String']
    status?: Maybe<ScalarsEnums['String']>
  }) => Array<CalendarSession>
  /**
   * The earliest date a membership cancellation can take effect under its cancellation notice period, the last active day, and the payments still due before the cancellation date (cancelAt when given, otherwise the earliest date). Returns null when the membership has no notice period or the feature is off for the site.
   */
  cancellationNoticePreview: (args: {
    cancelAt?: Maybe<ScalarsEnums['String']>
    serviceId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Maybe<CancellationNoticePreview>
  /**
   * List invoices staff cancelled from a scheduled state, newest cancellation first, with what reinstating each would need. Pass filter.clientId for the client profile.
   */
  cancelledInvoices: (args: {
    input: ListCancelledInvoicesInput
    siteId: ScalarsEnums['ID']
  }) => ListCancelledInvoicesResult
  /**
   * Get a single carousel group by ID
   */
  carouselGroup: (args: { carouselGroupId: ScalarsEnums['ID'] }) => Maybe<CmsCarouselGroup>
  /**
   * Get a carousel group by its slug
   */
  carouselGroupBySlug: (args: { slug: ScalarsEnums['String'] }) => Maybe<CmsCarouselGroup>
  /**
   * List all carousel groups for the current corporate
   */
  carouselGroups: Array<CmsCarouselGroup>
  /**
   * The currently open cash drawer session for a site, if any
   */
  cashDrawerSession: (args: { siteId: ScalarsEnums['ID'] }) => Maybe<CashDrawerSession>
  /**
   * Stamped payments (positive), refunds (negative) and void/payout adjustments (negative) attributed to a session, newest first, each labeled with its billing type
   */
  cashDrawerSessionTransactions: (args: {
    cashDrawerSessionId: ScalarsEnums['ID']
    cursor?: Maybe<ScalarsEnums['String']>
    pageSize?: Maybe<ScalarsEnums['Float']>
    siteId: ScalarsEnums['ID']
  }) => CashDrawerSessionTransactions
  /**
   * Cash drawer sessions for a site filtered by openedAt date range (site-local days) and optional status, newest first
   */
  cashDrawerSessions: (args: {
    cursor?: Maybe<ScalarsEnums['String']>
    from?: Maybe<ScalarsEnums['String']>
    pageSize?: Maybe<ScalarsEnums['Float']>
    siteId: ScalarsEnums['ID']
    status?: Maybe<CashDrawerSessionStatus>
    to?: Maybe<ScalarsEnums['String']>
  }) => CashDrawerSessions
  /**
   * Get aggregate analytics for a single challenge
   */
  challengeAnalytics: (args: {
    contentEntryId: ScalarsEnums['ID']
    siteId?: Maybe<ScalarsEnums['ID']>
  }) => ChallengeAnalytics
  /**
   * List available challenges for a corporate with optional site filtering
   */
  challengeCatalog: (args?: {
    cursor?: Maybe<ScalarsEnums['String']>
    includeArchived?: Maybe<ScalarsEnums['Boolean']>
    pageSize?: Maybe<ScalarsEnums['Float']>
    siteId?: Maybe<ScalarsEnums['ID']>
  }) => ChallengeCatalog
  /**
   * Get a single challenge definition by ID
   */
  challengeDetail: (args: { contentEntryId: ScalarsEnums['ID'] }) => Maybe<ChallengeDetail>
  /**
   * Get leaderboard for a challenge ranked by attendance or goal completion
   */
  challengeLeaderboard: (args: {
    contentEntryId: ScalarsEnums['ID']
    limit?: Maybe<ScalarsEnums['Float']>
    metric: LeaderboardMetric
  }) => Array<ChallengeLeaderboardEntry>
  /**
   * Get enrollment participation timeline grouped by week
   */
  challengeParticipationTimeline: (args: {
    contentEntryId: ScalarsEnums['ID']
  }) => ChallengeParticipationTimeline
  /**
   * Check whether a specific client payment method can be removed, and the billing-obligation categories blocking it if not
   */
  checkClientPaymentMethodRemovalEligibility: (args: {
    clientId: ScalarsEnums['ID']
    clientPaymentMethodId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => PaymentMethodRemovalEligibility
  /**
   * Paginated check-in scan attempts for a site, incl. unrecognised barcodes
   */
  checkInAttempts: (args: {
    cursor?: Maybe<ScalarsEnums['String']>
    limit?: Maybe<ScalarsEnums['Float']>
    siteId: ScalarsEnums['String']
  }) => CheckInAttemptsPaginationResult
  /**
   * Get paginated check-ins for a site with optional filters
   */
  checkIns: (args: {
    after?: Maybe<ScalarsEnums['String']>
    before?: Maybe<ScalarsEnums['String']>
    clientId?: Maybe<ScalarsEnums['ID']>
    endDate?: Maybe<ScalarsEnums['String']>
    pageSize: ScalarsEnums['Float']
    siteId: ScalarsEnums['ID']
    startDate?: Maybe<ScalarsEnums['String']>
    status?: Maybe<CheckInStatus>
    type?: Maybe<CheckInType>
  }) => CheckInsPaginationResult
  /**
   * Get check-ins for a client
   */
  checkInsByClientId: (args: {
    clientId: ScalarsEnums['String']
    limit?: Maybe<ScalarsEnums['Float']>
  }) => Array<CheckIn>
  /**
   * Get check-ins for a session
   */
  checkInsBySessionId: (args: {
    sessionId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Array<CheckIn>
  /**
   * Get check-ins for a site
   */
  checkInsBySiteId: (args: {
    endDate?: Maybe<ScalarsEnums['String']>
    limit?: Maybe<ScalarsEnums['Float']>
    siteId: ScalarsEnums['String']
    startDate?: Maybe<ScalarsEnums['String']>
  }) => Array<CheckIn>
  /**
   * Live BullMQ registration status of a scheduled job
   */
  checkScheduledJobStatus: (args: {
    corporateId?: Maybe<ScalarsEnums['ID']>
    jobKey: ScalarsEnums['String']
    siteId?: Maybe<ScalarsEnums['ID']>
  }) => ScheduledJobStatus
  /**
   * Get a single check-in by ID
   */
  checkin: (args: { id: ScalarsEnums['String'] }) => Maybe<CheckIn>
  client: (args: {
    id: ScalarsEnums['String']
    siteId?: Maybe<ScalarsEnums['String']>
  }) => ClientResult
  /**
   * Get the current account credit balance for a client at a specific site
   */
  clientAccountBalance: (args: {
    clientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => ScalarsEnums['String']
  /**
   * Get the activity feed for a client — bookings with their latest activity plus zone check-ins — with cursor-based pagination
   */
  clientActivityFeedPaginated: (args: {
    activityType?: Maybe<BookingActivityType>
    clientId: ScalarsEnums['String']
    cursor?: Maybe<ScalarsEnums['String']>
    orderBy?: Maybe<Array<ClientActivityStreamPaginatedOrderByInput>>
    pageSize?: Maybe<ScalarsEnums['Float']>
    search?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['String']
  }) => ClientActivityFeedPaginationResult
  /**
   * Get activity stream for a client with cursor-based pagination
   */
  clientActivityStreamPaginated: (args: {
    activityType?: Maybe<BookingActivityType>
    clientId: ScalarsEnums['String']
    cursor?: Maybe<ScalarsEnums['String']>
    orderBy?: Maybe<Array<ClientActivityStreamPaginatedOrderByInput>>
    pageSize?: Maybe<ScalarsEnums['Float']>
    search?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['String']
  }) => ActivityStreamPaginationResult
  /**
   * Get a specific client agreement by ID
   */
  clientAgreement: (args: {
    agreementId: ScalarsEnums['ID']
    clientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Maybe<ClientAgreement>
  /**
   * Get client agreements with cursor-based pagination, filters, and search
   */
  clientAgreementsWithPagination: (args: {
    clientId: ScalarsEnums['String']
    cursor?: Maybe<ScalarsEnums['String']>
    filters?: Maybe<ClientAgreementsWithPaginationFiltersInput>
    includeHeldAgreements?: Maybe<ScalarsEnums['Boolean']>
    pageSize?: Maybe<ScalarsEnums['Float']>
    search?: Maybe<ScalarsEnums['String']>
    siteId?: Maybe<ScalarsEnums['String']>
  }) => ClientAgreementsWithPagination
  /**
   * Get all alerts for a client at a specific site
   */
  clientAlerts: (args: {
    clientId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => ClientCustomAlertsResponse
  /**
   * Get all past bookings for a client regardless of status (visit history)
   */
  clientAllPastBookingsPaginated: (args: {
    clientId: ScalarsEnums['String']
    cursor?: Maybe<ScalarsEnums['String']>
    endDate?: Maybe<ScalarsEnums['String']>
    includeTanning?: Maybe<ScalarsEnums['Boolean']>
    includeWaitlist?: Maybe<ScalarsEnums['Boolean']>
    orderBy?: Maybe<Array<ClientBookingsPaginatedOrderByInput>>
    pageSize?: Maybe<ScalarsEnums['Float']>
    paymentStatus?: Maybe<PaymentStatusFilter>
    search?: Maybe<ScalarsEnums['String']>
    siteId?: Maybe<ScalarsEnums['String']>
    siteSessionTypeIds?: Maybe<Array<ScalarsEnums['String']>>
    startDate?: Maybe<ScalarsEnums['String']>
  }) => ClientBookingsPaginationResult
  /**
   * Get attendance statistics for a client at a site, or across all sites when allSites is true
   */
  clientAttendanceStats: (args: {
    allSites?: Maybe<ScalarsEnums['Boolean']>
    clientId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => ClientAttendanceStats
  /**
   * ACTIVE buddy relationships for a client (both legs) with counterparty display fields; optionally site-membership filtered and annotated with the buddy booking on a session
   */
  clientBookingBuddyLinkedAccounts: (args: {
    clientId: ScalarsEnums['ID']
    sessionId?: Maybe<ScalarsEnums['ID']>
    siteId?: Maybe<ScalarsEnums['ID']>
  }) => Array<BookingBuddyLinkedAccount>
  /**
   * Get upcoming bookings for a client with cursor-based pagination
   */
  clientBookingsPaginated: (args: {
    clientId: ScalarsEnums['String']
    cursor?: Maybe<ScalarsEnums['String']>
    endDate?: Maybe<ScalarsEnums['String']>
    includeTanning?: Maybe<ScalarsEnums['Boolean']>
    includeWaitlist?: Maybe<ScalarsEnums['Boolean']>
    orderBy?: Maybe<Array<ClientBookingsPaginatedOrderByInput>>
    pageSize?: Maybe<ScalarsEnums['Float']>
    paymentStatus?: Maybe<PaymentStatusFilter>
    search?: Maybe<ScalarsEnums['String']>
    siteId?: Maybe<ScalarsEnums['String']>
    siteSessionTypeIds?: Maybe<Array<ScalarsEnums['String']>>
    startDate?: Maybe<ScalarsEnums['String']>
  }) => ClientBookingsPaginationResult
  clientByEmail: (args: {
    email: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Maybe<Client>
  /**
   * Get a client by Firebase UID - used for member authentication
   */
  clientByFirebaseUid: (args: {
    firebaseUid: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Maybe<Client>
  /**
   * Get a client by Firebase UID without requiring siteId - used for mobile auth when siteId is unavailable
   */
  clientByFirebaseUidOnly: (args: { firebaseUid: ScalarsEnums['String'] }) => Maybe<Client>
  /**
   * Get cancelled bookings for a client with cursor-based pagination
   */
  clientCancelledBookingsPaginated: (args: {
    clientId: ScalarsEnums['String']
    cursor?: Maybe<ScalarsEnums['String']>
    endDate?: Maybe<ScalarsEnums['String']>
    includeTanning?: Maybe<ScalarsEnums['Boolean']>
    includeWaitlist?: Maybe<ScalarsEnums['Boolean']>
    orderBy?: Maybe<Array<ClientBookingsPaginatedOrderByInput>>
    pageSize?: Maybe<ScalarsEnums['Float']>
    paymentStatus?: Maybe<PaymentStatusFilter>
    search?: Maybe<ScalarsEnums['String']>
    siteId?: Maybe<ScalarsEnums['String']>
    siteSessionTypeIds?: Maybe<Array<ScalarsEnums['String']>>
    startDate?: Maybe<ScalarsEnums['String']>
  }) => ClientBookingsPaginationResult
  /**
   * Get cancelled tanning sessions for a client with cursor-based pagination
   */
  clientCancelledTanningSessionsPaginated: (args: {
    clientId: ScalarsEnums['String']
    cursor?: Maybe<ScalarsEnums['String']>
    pageSize?: Maybe<ScalarsEnums['Float']>
    siteId?: Maybe<ScalarsEnums['String']>
  }) => ClientTanningSessionsPaginationResult
  clientContactLogs: (args: {
    clientId: ScalarsEnums['String']
    cursor?: Maybe<ScalarsEnums['String']>
    filters?: Maybe<ClientContactLogsFiltersInput>
    pageSize?: Maybe<ScalarsEnums['Float']>
    siteId: ScalarsEnums['String']
  }) => ClientContactLogs
  /**
   * Recorded values of one client custom property, newest first
   */
  clientCustomPropertyValueHistory: (args: {
    after?: Maybe<ScalarsEnums['String']>
    clientId: ScalarsEnums['String']
    first?: Maybe<ScalarsEnums['Float']>
    siteCustomPropertyId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => ClientCustomPropertyValueHistoryPage
  /**
   * Check if a client email already exists in the corporate (for add-client flow)
   */
  clientEmailStatus: (args: {
    email: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => ClientEmailStatus
  /**
   * Get equipment assignments for a client across all sites
   */
  clientEquipmentAssignments: (args: {
    clientId: ScalarsEnums['String']
    equipmentId?: Maybe<ScalarsEnums['String']>
    last?: Maybe<ScalarsEnums['Boolean']>
    status?: Maybe<EquipmentAssignmentStatus>
  }) => Array<EquipmentAssignment>
  /**
   * The ACTIVE family a client belongs to, read by staff with access__clients or by the client
   */
  clientFamily: (args: {
    clientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Maybe<Family>
  /**
   * Family-shareable packages held by a client's family, with each allocation (staff, access__clients)
   */
  clientFamilyPackages: (args: {
    clientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Array<FamilyPackage>
  /**
   * Get list of client favorite instructors at specific site
   */
  clientFavoriteInstructors: (args: {
    clientId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Array<ClientFavoriteInstructor>
  /**
   * Get a client fees template by ID
   */
  clientFeesTemplate: (args: { id: ScalarsEnums['String'] }) => ClientFeesTemplate
  /**
   * Get all client fees templates
   */
  clientFeesTemplates: (args: {
    paginate: PaginationInput
    search?: Maybe<ScalarsEnums['String']>
    sort?: Maybe<FindClientFeesTemplatesSortOptions>
  }) => ClientFeesTemplatesPageInfo
  /**
   * Get all files for a client
   */
  clientFiles: (args: {
    clientId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Array<ClientFile>
  /**
   * Get client files with cursor-based pagination
   */
  clientFilesWithPagination: (args: {
    clientId: ScalarsEnums['String']
    cursor?: Maybe<ScalarsEnums['String']>
    filters?: Maybe<ClientFilesWithPaginationFiltersInput>
    pageSize?: Maybe<ScalarsEnums['Float']>
    search?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['String']
  }) => ClientFilesWithPagination
  /**
   * List the form deliveries sent to a client at a location, newest first
   */
  clientFormHandoffs: (args: {
    clientId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Array<FormHandoff>
  /**
   * Get the client's current scored result for a form at a site
   */
  clientFormResult: (args: {
    clientId: ScalarsEnums['String']
    siteFormId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Maybe<ClientFormResult>
  /**
   * Get all form submissions for a client
   */
  clientFormSubmissions: (args: {
    clientId: ScalarsEnums['String']
    siteId?: Maybe<ScalarsEnums['String']>
  }) => ClientFormSubmissionsResponse
  /**
   * Get client form submissions with cursor-based pagination
   */
  clientFormSubmissionsWithPagination: (args: {
    clientId: ScalarsEnums['String']
    cursor?: Maybe<ScalarsEnums['String']>
    filters?: Maybe<ClientFormSubmissionsWithPaginationFiltersInput>
    pageSize?: Maybe<ScalarsEnums['Float']>
    search?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['String']
  }) => ClientFormSubmissionsWithPagination
  /**
   * Grow-connected locations for many clients (brand-level clients list)
   */
  clientGrowLocations: (args: {
    clientIds: Array<ScalarsEnums['String']>
  }) => Array<ClientGrowLocationsSummary>
  /**
   * Per-client Grow (GHL) sync status derived from GrowContact
   */
  clientGrowStatus: (args: {
    clientId: ScalarsEnums['String']
    siteId?: Maybe<ScalarsEnums['String']>
  }) => ClientGrowStatus
  /**
   * Lightweight Grow sync status for many clients at a site (list-view column)
   */
  clientGrowStatuses: (args: {
    clientIds: Array<ScalarsEnums['String']>
    siteId: ScalarsEnums['String']
  }) => Array<ClientGrowStatusSummary>
  /**
   * The IP address the platform sees for this request, as enforcement will see it
   */
  clientIpInfo: ClientIpInfo
  /**
   * Get the lifetime spend for a client at a site. Returns the net amount received (successful payments minus completed refunds), or null if no payments exist.
   */
  clientLifetimeSpend: (args: {
    clientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Maybe<ClientLifetimeSpend>
  /**
   * Get upcoming virtual invoices for a client membership. Client-accessible — enforces selfOnly so clients can only query their own data. Returns up to the next 9 upcoming billing entries by date; the look-ahead window adapts to the billing cycle so longer cycles (e.g. 11-month) still surface 9 entries (matches V1 PHP behavior).
   */
  clientMembershipScheduledInvoices: (args: {
    clientId: ScalarsEnums['ID']
    serviceId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => ClientUpcomingInvoicesResult
  /**
   * Get the next billing date and amount for a client at a site. Returns the earliest upcoming charge from active recurring invoices, or null if none.
   */
  clientNextBilling: (args: {
    clientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Maybe<ClientNextBilling>
  /**
   * Get a client note by ID
   */
  clientNote: (args: {
    clientId: ScalarsEnums['String']
    noteId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Maybe<ClientNote>
  /**
   * Get all notes for a client
   */
  clientNotes: (args: {
    clientId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => ClientNotesResponse
  /**
   * Get past bookings for a client with cursor-based pagination
   */
  clientPastBookingsPaginated: (args: {
    clientId: ScalarsEnums['String']
    cursor?: Maybe<ScalarsEnums['String']>
    endDate?: Maybe<ScalarsEnums['String']>
    includeTanning?: Maybe<ScalarsEnums['Boolean']>
    includeWaitlist?: Maybe<ScalarsEnums['Boolean']>
    orderBy?: Maybe<Array<ClientBookingsPaginatedOrderByInput>>
    pageSize?: Maybe<ScalarsEnums['Float']>
    paymentStatus?: Maybe<PaymentStatusFilter>
    search?: Maybe<ScalarsEnums['String']>
    siteId?: Maybe<ScalarsEnums['String']>
    siteSessionTypeIds?: Maybe<Array<ScalarsEnums['String']>>
    startDate?: Maybe<ScalarsEnums['String']>
  }) => ClientBookingsPaginationResult
  /**
   * Get completed tanning sessions for a client with cursor-based pagination
   */
  clientPastTanningSessionsPaginated: (args: {
    clientId: ScalarsEnums['String']
    cursor?: Maybe<ScalarsEnums['String']>
    pageSize?: Maybe<ScalarsEnums['Float']>
    siteId?: Maybe<ScalarsEnums['String']>
  }) => ClientTanningSessionsPaginationResult
  /**
   * Get a specific payment method
   */
  clientPaymentMethod: (args: {
    clientId: ScalarsEnums['ID']
    clientPaymentMethodId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Maybe<ClientPaymentMethod>
  /**
   * List payment methods. Either provide clientId to get all methods for a client, or provide clientPaymentMethodIds to fetch specific methods (for guest checkout).
   */
  clientPaymentMethods: (args?: {
    clientId?: Maybe<ScalarsEnums['ID']>
    clientPaymentMethodIds?: Maybe<Array<ScalarsEnums['ID']>>
    siteId?: Maybe<ScalarsEnums['ID']>
  }) => Array<ClientPaymentMethod>
  /**
   * Agreements awaiting the client's signature (self-scoped for member tokens)
   */
  clientPendingAgreements: (args: {
    clientId: ScalarsEnums['ID']
    siteId?: Maybe<ScalarsEnums['ID']>
  }) => Array<PendingAgreement>
  /**
   * Readiness of a client for every equipment category the location runs, reasons redacted to codes
   */
  clientPolicyCompliance: (args: {
    clientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => ClientPolicyCompliance
  /**
   * Distinct service templates a client has bought at a site, in any status. Used by Core New Sale to check Dynamic Display eligibility.
   */
  clientPurchasedServiceTemplateIds: (args: {
    clientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Array<ScalarsEnums['String']>
  /**
   * Unified relations (Family/Buddy/Shared/Other) for a client
   */
  clientRelations: (args: {
    clientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Array<ClientRelationView>
  /**
   * List services for a client with pagination, search, and filtering. Used by Client Profile Packages tab.
   */
  clientServices: (args: {
    clientId: ScalarsEnums['String']
    cursor?: Maybe<ScalarsEnums['String']>
    includeAddOns?: Maybe<ScalarsEnums['Boolean']>
    includeExpiredCreditsForRollover?: Maybe<ScalarsEnums['Boolean']>
    includeSharedWithClient?: Maybe<ScalarsEnums['Boolean']>
    pageSize?: Maybe<ScalarsEnums['Float']>
    search?: Maybe<ScalarsEnums['String']>
    serviceIds?: Maybe<Array<ScalarsEnums['String']>>
    sharedSiteIds?: Maybe<Array<ScalarsEnums['String']>>
    siteId?: Maybe<ScalarsEnums['String']>
    siteSessionTypeId?: Maybe<ScalarsEnums['String']>
    sortBy?: Maybe<ClientServicesSortBy>
    sortOrder?: Maybe<SortOrder>
    status?: Maybe<Array<ServiceStatus>>
    type?: Maybe<Array<ScalarsEnums['String']>>
  }) => ClientServicesPaginationResult
  /**
   * Get a specific client-site relationship
   */
  clientSite: (args: {
    clientId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Maybe<ClientSite>
  /**
   * Get the current and previous assigned staff for a client at a site
   */
  clientSiteAssignedStaff: (args: {
    clientId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => ClientSiteAssignedStaff
  /**
   * Get a page of the assigned staff history for a client at a site, newest first, with hasMore set when older intervals were truncated
   */
  clientSiteAssignedStaffHistory: (args: {
    clientId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => AssignedStaffHistory
  /**
   * Get all sites for a client
   */
  clientSites: (args: { clientId: ScalarsEnums['String'] }) => ClientSitesResponse
  /**
   * Get client attendance and booking statistics
   */
  clientStats: (args: {
    /**
     * Client ID to get stats for
     */
    clientId: ScalarsEnums['String']
  }) => ClientStats
  /**
   * A client's most recent reader hand-offs at a location, newest first
   */
  clientTerminalHandoffRequests: (args: {
    clientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Array<TerminalHandoffRequest>
  /**
   * Get a paginated, multi-source timeline for a client
   */
  clientTimeline: (args: {
    clientId: ScalarsEnums['String']
    cursor?: Maybe<ScalarsEnums['String']>
    endDate?: Maybe<ScalarsEnums['String']>
    eventTypes?: Maybe<Array<ClientTimelineEventType>>
    limit?: Maybe<ScalarsEnums['Float']>
    siteId: ScalarsEnums['String']
    startDate?: Maybe<ScalarsEnums['String']>
    timezone?: Maybe<ScalarsEnums['String']>
  }) => ClientTimelineResult
  /**
   * Get all active waitlist entries for a client (client-accessible)
   */
  clientWaitlistEntries: (args: {
    clientId: ScalarsEnums['String']
    siteId?: Maybe<ScalarsEnums['String']>
  }) => Array<SessionWaitlistEntry>
  /**
   * Get the current client waitlist entry for a session (client-accessible)
   */
  clientWaitlistEntry: (args: {
    clientId: ScalarsEnums['String']
    sessionId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Maybe<SessionWaitlistEntry>
  /**
   * Find clients with cursor-based pagination
   */
  clients: (args?: {
    crossSiteSearch?: Maybe<ScalarsEnums['Boolean']>
    cursor?: Maybe<ScalarsEnums['String']>
    email?: Maybe<ScalarsEnums['String']>
    filters?: Maybe<ClientFilters>
    firstName?: Maybe<ScalarsEnums['String']>
    includeSharedSiteVisitors?: Maybe<ScalarsEnums['Boolean']>
    lastName?: Maybe<ScalarsEnums['String']>
    orderBy?: Maybe<Array<ClientsOrderByInput>>
    pageSize?: Maybe<ScalarsEnums['Float']>
    phone?: Maybe<ScalarsEnums['String']>
    search?: Maybe<ScalarsEnums['String']>
    showDeactivated?: Maybe<ScalarsEnums['Boolean']>
    showProspects?: Maybe<ScalarsEnums['Boolean']>
    siteId?: Maybe<ScalarsEnums['String']>
  }) => ClientsResult
  /**
   * Get multiple clients by their IDs
   */
  clientsByIds: (args: {
    clientIds: Array<ScalarsEnums['String']>
    siteId: ScalarsEnums['String']
  }) => Array<Client>
  /**
   * Awards summary: earned, recipients, pending, most earned
   */
  cmsAwardsSummary: (args: { input: CmsAnalyticsDateRangeInput }) => AwardsSummary
  /**
   * Challenge overview: active challenges, enrollments, completion rates
   */
  cmsChallengeOverview: (args: { input: CmsAnalyticsDateRangeInput }) => ChallengeOverview
  /**
   * Content engagement summary: published count, favorites, views, completion
   */
  cmsContentEngagementSummary: (args: {
    input: CmsAnalyticsDateRangeInput
  }) => ContentEngagementSummary
  /**
   * Unified experience dashboard combining all CMS analytics
   */
  cmsExperienceDashboard: (args: { input: CmsAnalyticsDateRangeInput }) => ExperienceDashboard
  /**
   * Contentful config status + default space id from the stored integration
   */
  cmsImportContentfulDefaultSpace: CmsImportContentfulConfig
  /**
   * Contentful spaces the corporate's stored management token can access
   */
  cmsImportContentfulSpaces: Array<CmsImportContentfulSpace>
  /**
   * JW Player config status + properties for the corporate's stored key
   */
  cmsImportJwPlayerSites: CmsImportJwPlayerSitesResult
  /**
   * List brands available in the legacy MongoDB, with the saved link and an auto-matched suggestion
   */
  cmsImportLegacyMongoBrands: CmsImportLegacyMongoBrandOptions
  /**
   * Get a single import run with its steps
   */
  cmsImportRun: (args: { importRunId: ScalarsEnums['String'] }) => Maybe<CmsImportRunWithSteps>
  /**
   * List preview items for an import run with pagination and filters
   */
  cmsImportRunPreviews: (args: {
    importRunId: ScalarsEnums['String']
    limit?: Maybe<ScalarsEnums['Float']>
    mappingStatus?: Maybe<CmsImportMappingStatus>
    offset?: Maybe<ScalarsEnums['Float']>
    search?: Maybe<ScalarsEnums['String']>
    sourceSystem?: Maybe<ScalarsEnums['String']>
  }) => CmsImportRunPreviews
  /**
   * List steps for an import run
   */
  cmsImportRunSteps: (args: { importRunId: ScalarsEnums['String'] }) => Array<CmsImportRunStep>
  /**
   * List all import runs for a corporate
   */
  cmsImportRuns: (args?: {
    limit?: Maybe<ScalarsEnums['Float']>
    offset?: Maybe<ScalarsEnums['Float']>
  }) => Array<CmsImportRun>
  /**
   * List brands available in the V1 Aurora database, with the saved link and an auto-matched suggestion
   */
  cmsImportV1AuroraBrands: CmsImportV1AuroraBrandOptions
  /**
   * Active leaderboards with entry counts and top participant
   */
  cmsLeaderboardSummary: (args: { input: CmsAnalyticsSiteInput }) => Array<LeaderboardSummaryItem>
  /**
   * Metric tracking summary: entries, trackers, personal bests
   */
  cmsMetricTrackingSummary: (args: { input: CmsAnalyticsDateRangeInput }) => MetricTrackingSummary
  /**
   * Top 10 videos by views, unique viewers, completion rate, or watch time
   */
  cmsTopVideos: (args: { input: CmsTopVideosInput }) => Array<TopVideoItem>
  /**
   * Detailed analytics for a specific video: views, completion, drop-off, platform
   */
  cmsVideoAnalytics: (args: { input: CmsVideoAnalyticsInput }) => VideoAnalytics
  /**
   * Video engagement trend over time (daily, weekly, or monthly)
   */
  cmsVideoEngagementTrend: (args: {
    input: CmsVideoEngagementTrendInput
  }) => Array<VideoEngagementTrendPoint>
  /**
   * Staff who can receive a commission adjustment at a location
   */
  commissionAdjustmentStaff: (args: {
    siteId: ScalarsEnums['ID']
  }) => Array<CommissionAdjustmentStaff>
  /**
   * Commission owner, history, upfront and earnings for one agreement
   */
  commissionAttribution: (args: { serviceId: ScalarsEnums['ID'] }) => Maybe<CommissionCard>
  /**
   * Item switches checkout needs to decide whether Sold by is required
   */
  commissionCheckoutItemSettings: (args: {
    items: Array<CommissionItemRefInput>
    siteId: ScalarsEnums['ID']
  }) => Array<CommissionItemSetting>
  /**
   * Commission dashboard for one pay period: headline figures against the previous period, per-employee totals, commission lines and active plans
   */
  commissionDashboard: (args: { input: CommissionDashboardInput }) => CommissionDashboard
  /**
   * Whether commissions are switched on for the brand
   */
  commissionEnablement: CommissionEnablement
  /**
   * Commission event outcomes whose source time falls in a period
   */
  commissionEvents: (args: {
    commissionPeriodId: ScalarsEnums['ID']
    status?: Maybe<CommissionEventStatus>
  }) => Array<CommissionEventSummary>
  /**
   * Commissionable and Require Sold by switches for items, resolved for a location
   */
  commissionItemSettings: (args: {
    items: Array<CommissionItemRefInput>
    siteId?: Maybe<ScalarsEnums['ID']>
  }) => Array<CommissionItemSetting>
  /**
   * One commission job run, polled while a seed, dry run or preview runs
   */
  commissionJobRun: (args: { commissionJobRunId: ScalarsEnums['ID'] }) => CommissionJobRun
  /**
   * Recent commission job runs (reconcile, period tick, seed, backfill)
   */
  commissionJobRuns: Array<CommissionJobRun>
  /**
   * Commission lines written for an invoice
   */
  commissionLinesForInvoice: (args: { invoiceId: ScalarsEnums['ID'] }) => Array<CommissionLine>
  /**
   * One commission period with its close gate and export revisions
   */
  commissionPeriod: (args: { commissionPeriodId: ScalarsEnums['ID'] }) => CommissionPeriod
  /**
   * Commission periods for the brand, newest first, with the close gate when due
   */
  commissionPeriods: Array<CommissionPeriod>
  /**
   * One commission plan
   */
  commissionPlan: (args: {
    commissionPlanId: ScalarsEnums['ID']
    siteId?: Maybe<ScalarsEnums['ID']>
  }) => CommissionPlan
  /**
   * Commission plans, or those available at one location
   */
  commissionPlans: (args?: {
    includeArchived?: Maybe<ScalarsEnums['Boolean']>
    siteId?: Maybe<ScalarsEnums['ID']>
  }) => Array<CommissionPlan>
  /**
   * Pre-activation checks: currencies and the share of agreements with a seller
   */
  commissionPreflight: CommissionPreflight
  /**
   * Role default plans for the brand, and overrides at a location
   */
  commissionRoleDefaults: (args?: {
    siteId?: Maybe<ScalarsEnums['ID']>
  }) => Array<CommissionRoleDefault>
  /**
   * Commission settings for the brand, as in force now
   */
  commissionSettings: (args?: { siteId?: Maybe<ScalarsEnums['ID']> }) => CommissionSettings
  /**
   * Location-level commission settings
   */
  commissionSiteSettings: (args: { siteId: ScalarsEnums['ID'] }) => CommissionSiteSettings
  /**
   * Staff with their commission role, plan and assignments
   */
  commissionStaff: (args?: {
    includeDeactivated?: Maybe<ScalarsEnums['Boolean']>
    siteId?: Maybe<ScalarsEnums['ID']>
  }) => Array<CommissionStaffEntry>
  /**
   * Agreements that seeding could not give a seller
   */
  commissionUnresolvedAttributions: Array<CommissionUnresolvedAttribution>
  communicationTemplate: (args: { id: ScalarsEnums['ID'] }) => CommunicationTemplate
  /**
   * Find communication templates with cursor-based pagination
   */
  communicationTemplates: (args?: {
    alias?: Maybe<ScalarsEnums['String']>
    cursor?: Maybe<ScalarsEnums['String']>
    emailEnabled?: Maybe<ScalarsEnums['Boolean']>
    pageSize?: Maybe<ScalarsEnums['Float']>
    pushNotificationEnabled?: Maybe<ScalarsEnums['Boolean']>
    readOnly?: Maybe<ScalarsEnums['Boolean']>
    search?: Maybe<ScalarsEnums['String']>
    smsEnabled?: Maybe<ScalarsEnums['Boolean']>
  }) => CommunicationTemplatePaginationResultSchema
  /**
   * Get all computed alerts for a client (payment, forms, days absent, etc.)
   */
  computedAlerts: (args: {
    /**
     * Client ID
     */
    clientId: ScalarsEnums['String']
    /**
     * Site ID
     */
    siteId: ScalarsEnums['String']
  }) => ComputedAlertsResponse
  /**
   * Get available placeholders for communication templates
   */
  comunicationTemplatesPlaceholders: Array<ScalarsEnums['String']>
  /**
   * Get languages that have custom text configured
   */
  configuredLanguages: (args: { corporateId: ScalarsEnums['String'] }) => ConfiguredLanguages
  /**
   * Published content catalog for a site with targeting pre-applied and dynamic fields resolved
   */
  contentCatalog: (args?: {
    categoryId?: Maybe<ScalarsEnums['ID']>
    contentTypeGroup?: Maybe<ContentTypeGroup>
    contentTypeId?: Maybe<ScalarsEnums['ID']>
    contentTypeIds?: Maybe<Array<ScalarsEnums['ID']>>
    cursor?: Maybe<ScalarsEnums['String']>
    instructorId?: Maybe<ScalarsEnums['ID']>
    memberPackageNames?: Maybe<Array<ScalarsEnums['String']>>
    orderBy?: Maybe<CatalogOrderBy>
    packageContext?: Maybe<Array<ScalarsEnums['ID']>>
    pageSize?: Maybe<ScalarsEnums['Float']>
    search?: Maybe<ScalarsEnums['String']>
    siteId?: Maybe<ScalarsEnums['ID']>
    subcategoryId?: Maybe<ScalarsEnums['ID']>
    tags?: Maybe<Array<ScalarsEnums['String']>>
    tagsMatch?: Maybe<TagMatch>
  }) => CmsCatalogResult
  /**
   * Published banners for a site filtered by content type and package context
   */
  contentCatalogBanners: (args: {
    memberPackageNames?: Maybe<Array<ScalarsEnums['String']>>
    packageContext?: Maybe<Array<ScalarsEnums['ID']>>
    siteId: ScalarsEnums['ID']
    tags?: Maybe<Array<ScalarsEnums['String']>>
    tagsMatch?: Maybe<TagMatch>
    type?: Maybe<ScalarsEnums['String']>
    types?: Maybe<Array<ScalarsEnums['String']>>
  }) => Array<CmsContentEntry>
  /**
   * Category tree with content counts for published content at a site
   */
  contentCatalogCategories: (args: {
    memberPackageNames?: Maybe<Array<ScalarsEnums['String']>>
    packageContext?: Maybe<Array<ScalarsEnums['ID']>>
    siteId: ScalarsEnums['ID']
    tags?: Maybe<Array<ScalarsEnums['String']>>
    tagsMatch?: Maybe<TagMatch>
  }) => Array<CmsCatalogCategory>
  /**
   * Single published content entry with resolved FK references
   */
  contentCatalogEntry: (args: {
    contentEntryId: ScalarsEnums['ID']
    memberPackageNames?: Maybe<Array<ScalarsEnums['String']>>
    packageContext?: Maybe<Array<ScalarsEnums['ID']>>
    siteId: ScalarsEnums['ID']
    tags?: Maybe<Array<ScalarsEnums['String']>>
    tagsMatch?: Maybe<TagMatch>
  }) => Maybe<CmsContentEntry>
  /**
   * The brand's author-created (custom) names of a given kind (package | tag | instructor) — the editor merges these with the catalog so a name created on one content item is offered on every other
   */
  contentCustomEntryNames: (args: { kind: CmsCustomEntryKind }) => Array<ScalarsEnums['String']>
  /**
   * List content entries with cursor-based pagination, filtering, and search
   */
  contentEntries: (args?: {
    callerSiteId?: Maybe<ScalarsEnums['ID']>
    cursor?: Maybe<ScalarsEnums['String']>
    filters?: Maybe<ContentEntriesFiltersInput>
    orderBy?: Maybe<Array<ContentEntriesOrderByInput>>
    pageSize?: Maybe<ScalarsEnums['Float']>
    search?: Maybe<ScalarsEnums['String']>
  }) => ContentEntries
  /**
   * Get a single content entry by ID
   */
  contentEntry: (args: { contentEntryId: ScalarsEnums['ID'] }) => Maybe<CmsContentEntry>
  /**
   * List version history for a content entry, ordered by most recent first
   */
  contentEntryVersions: (args: { contentEntryId: ScalarsEnums['ID'] }) => Array<CmsContentVersion>
  /**
   * Catalogue categories available to scope a brand to, with title counts
   */
  contentLibraryCategories: Array<ContentLibraryCategory>
  /**
   * Which fields of one entry the brand has edited; null if not library-backed
   */
  contentLibraryEntryOverrides: (args: {
    contentEntryId: ScalarsEnums['ID']
    corporateId?: Maybe<ScalarsEnums['ID']>
  }) => Maybe<ContentLibraryEntryOverrideState>
  /**
   * Mint a short-lived stream so staff can preview a library video in the editor
   */
  contentLibraryPreviewStream: (args: {
    contentMediaId: ScalarsEnums['ID']
  }) => ContentLibraryPreviewStream
  /**
   * Content Library entitlement, location enablement and entry counts for a brand
   */
  contentLibraryStatus: (args: { corporateId: ScalarsEnums['ID'] }) => ContentLibraryStatus
  /**
   * How each catalogue vocabulary term resolved onto this brand’s taxonomy
   */
  contentLibraryTaxonomyMappings: (args: {
    corporateId: ScalarsEnums['ID']
  }) => Array<ContentLibraryTaxonomyMapping>
  /**
   * Get a single media asset by ID
   */
  contentMediaAsset: (args: { contentMediaId: ScalarsEnums['ID'] }) => Maybe<CmsContentMedia>
  /**
   * Paginated media asset listing for the media picker modal, filterable by type, folder, and tags
   */
  contentMediaLibrary: (args?: {
    cursor?: Maybe<ScalarsEnums['String']>
    filters?: Maybe<ContentMediaLibraryFiltersInput>
    orderBy?: Maybe<Array<ContentMediaLibraryOrderByInput>>
    pageSize?: Maybe<ScalarsEnums['Float']>
    search?: Maybe<ScalarsEnums['String']>
  }) => ContentMediaLibrary
  /**
   * List content entries that reference a specific media asset
   */
  contentMediaUsageItems: (args: { contentMediaId: ScalarsEnums['ID'] }) => Array<MediaUsageItem>
  /**
   * List all schedules (pending and executed) for a content entry
   */
  contentSchedules: (args: { contentEntryId: ScalarsEnums['ID'] }) => Array<CmsContentSchedule>
  /**
   * List all visibility targets for a content entry
   */
  contentTargets: (args: { contentEntryId: ScalarsEnums['ID'] }) => Array<CmsContentTarget>
  /**
   * Lightweight {id, name, childIds} options per taxonomy slug in one query — used by the content editor instead of paging full entries per slug
   */
  contentTaxonomyOptions: (args: {
    slugs: Array<ScalarsEnums['String']>
  }) => Array<ContentTaxonomyOptionGroup>
  /**
   * List all system-defined content types with their field schemas
   */
  contentTypes: Array<CmsContentType>
  /**
   * List core users (staff) that do not have an active payroll tier assignment. Scoped to staff of the site unless allSites is true
   */
  coreUsersWithoutPayrollTier: (args: {
    allSites?: Maybe<ScalarsEnums['Boolean']>
    siteId: ScalarsEnums['ID']
  }) => Array<CoreUsersWithoutPayrollTier>
  /**
   * Get corporate by ID
   */
  corporate: (args: { corporateId: ScalarsEnums['String'] }) => Maybe<Corporate>
  /**
   * Get a brand add-on by ID
   */
  corporateAddOn: (args: {
    corporateServiceTemplateId: ScalarsEnums['ID']
  }) => Maybe<CorporateAddOn>
  /**
   * What publishing a brand add-on as the form holds it would do at each location, without writing anything
   */
  corporateAddOnDryRun: (args: { input: CorporateAddOnDryRunInput }) => BrandAddOnDryRun
  /**
   * The live brand memberships a brand add-on price can be sold with
   */
  corporateAddOnParentOptions: Array<CorporateServiceTemplateSummary>
  /**
   * List the brand add-ons of the current brand, with their active sales
   */
  corporateAddOns: Array<CorporateAddOnListItem>
  /**
   * Get site IDs where a specific aggregator provider is enabled for a corporate
   */
  corporateAggregatorProviderEnabledSiteIds: (args: {
    aggregatorProviderId: ScalarsEnums['String']
    corporateId: ScalarsEnums['String']
  }) => Array<ScalarsEnums['String']>
  /**
   * Get corporate by subdomain
   */
  corporateBySubdomain: (args: { subdomain: ScalarsEnums['String'] }) => Maybe<Corporate>
  /**
   * Find clients across all corporate locations
   */
  corporateClients: (args?: {
    cursor?: Maybe<ScalarsEnums['String']>
    email?: Maybe<ScalarsEnums['String']>
    firstName?: Maybe<ScalarsEnums['String']>
    lastName?: Maybe<ScalarsEnums['String']>
    pageSize?: Maybe<ScalarsEnums['Float']>
    phone?: Maybe<ScalarsEnums['String']>
    siteId?: Maybe<ScalarsEnums['String']>
  }) => ListAllClients
  /**
   * Get a corporate communication template by alias
   */
  corporateCommunicationTemplate: (args: {
    alias: CommunicationTemplateAliases
  }) => Maybe<CorporateCommunicationTemplate>
  /**
   * Get a corporate communication template by ID
   */
  corporateCommunicationTemplateById: (args: {
    corporateCommunicationTemplateId: ScalarsEnums['ID']
  }) => Maybe<CorporateCommunicationTemplate>
  /**
   * Get available placeholders for corporate communication templates
   */
  corporateCommunicationTemplatePlaceholders: Array<ScalarsEnums['String']>
  /**
   * Get a specific corporate communication template version
   */
  corporateCommunicationTemplateVersion: (args: {
    corporateCommunicationTemplateId: ScalarsEnums['ID']
    corporateCommunicationTemplateVersionId: ScalarsEnums['ID']
  }) => Maybe<CorporateCommunicationTemplateVersion>
  /**
   * Get all versions for a corporate communication template
   */
  corporateCommunicationTemplateVersions: (args: {
    corporateCommunicationTemplateId: ScalarsEnums['ID']
  }) => Array<CorporateCommunicationTemplateVersion>
  /**
   * Get all versions for a corporate communication template by alias
   */
  corporateCommunicationTemplateVersionsByAlias: (args: {
    alias: CommunicationTemplateAliases
  }) => Array<CorporateCommunicationTemplateVersion>
  /**
   * List corporate communication templates with pagination
   */
  corporateCommunicationTemplates: (args?: {
    alias?: Maybe<CommunicationTemplateAliases>
    cursor?: Maybe<ScalarsEnums['String']>
    messageType?: Maybe<CommunicationType>
    pageSize?: Maybe<ScalarsEnums['Float']>
    search?: Maybe<ScalarsEnums['String']>
  }) => CorporateCommunicationTemplatePaginationResultSchema
  /**
   * Get custom third-party integrations for a corporate
   */
  corporateCustomIntegrations: (args: {
    corporateId: ScalarsEnums['ID']
  }) => Array<CorporateCustomIntegrationItem>
  /**
   * Get the custom email domain configuration for a corporate
   */
  corporateEmailDomain: (args: {
    corporateId: ScalarsEnums['String']
  }) => Maybe<CorporateEmailDomain>
  /**
   * Get aggregator provider IDs enabled for at least one site in the corporate
   */
  corporateEnabledAggregatorProviderIds: (args: {
    corporateId: ScalarsEnums['String']
  }) => Array<ScalarsEnums['String']>
  /**
   * What the BRAND is entitled to: its plan tier and the features that tier grants, with no location override — what corporate-level surfaces gate on. Reports everything enabled while product tiering is switched off for the brand.
   */
  corporateEntitlements: SiteEntitlements
  /**
   * Get a corporate FAQ by ID
   */
  corporateFaq: (args: { corporateFaqId: ScalarsEnums['ID'] }) => Maybe<CorporateFaq>
  /**
   * List all corporate FAQs ordered by displayOrder
   */
  corporateFaqs: Array<CorporateFaq>
  /**
   * List published corporate FAQs for client/mobile use
   */
  corporateFaqsClient: Array<CorporateFaq>
  /**
   * Get corporate payout account by ID
   */
  corporatePayoutAccount: (args: { id: ScalarsEnums['ID'] }) => Maybe<CorporatePayoutAccount>
  /**
   * Get all corporate payout accounts with pagination
   */
  corporatePayoutAccounts: (args: {
    corporateId: ScalarsEnums['ID']
    cursor?: Maybe<ScalarsEnums['String']>
    orderBy: Array<CorporatePayoutAccountsOrderByInput>
    pageSize?: Maybe<ScalarsEnums['Float']>
    search?: Maybe<ScalarsEnums['String']>
  }) => CorporatePayoutAccounts
  /**
   * Dry-run of provisionCorporateDatabase: returns the Spanner instance/DB IDs that would be assigned and which Firebase tenants would be reused. Does not write anything.
   */
  corporateProvisioningPreview: (args: {
    corporateId: ScalarsEnums['ID']
  }) => CorporateProvisioningPreview
  /**
   * Get a brand session group by ID
   */
  corporateSessionType: (args: {
    corporateSessionTypeId: ScalarsEnums['ID']
  }) => Maybe<CorporateSessionType>
  /**
   * What saving a brand session group with this name and distribution would do at each location, without writing anything
   */
  corporateSessionTypeSyncPreview: (args: {
    input: CorporateSessionTypeSyncPreviewInput
  }) => CorporateSessionTypeSyncPreview
  /**
   * List the brand session groups for the current brand, with the counts each list row shows
   */
  corporateSessionTypes: Array<CorporateSessionTypeListItem>
  /**
   * Get a brand tax type by ID
   */
  corporateTaxSetting: (args: {
    corporateTaxSettingId: ScalarsEnums['ID']
  }) => Maybe<CorporateTaxSetting>
  /**
   * The memberships and packages that reference a brand tax type, per location — the payload the delete confirmation enumerates
   */
  corporateTaxSettingUsage: (args: {
    corporateTaxSettingId: ScalarsEnums['ID']
  }) => CorporateTaxSettingUsageResult
  /**
   * List the brand tax types for the current brand
   */
  corporateTaxSettings: Array<CorporateTaxSetting>
  /**
   * Most recent delivery attempts to a brand webhook (kept 30 days)
   */
  corporateWebhookDeliveries: (args: {
    corporateId: ScalarsEnums['ID']
    limit?: Maybe<ScalarsEnums['Int']>
    webhookId: ScalarsEnums['ID']
  }) => Array<CorporateWebhookDelivery>
  /**
   * Get all webhooks for a corporate
   */
  corporateWebhooks: (args: { corporateId: ScalarsEnums['ID'] }) => Array<CorporateWebhook>
  /**
   * Get all corporates with pagination
   */
  corporates: (args?: {
    limit?: Maybe<ScalarsEnums['Float']>
    offset?: Maybe<ScalarsEnums['Float']>
    paginate?: Maybe<PaginationInput>
    search?: Maybe<ScalarsEnums['String']>
    sort?: Maybe<FindCorporatesSortOptions>
  }) => Corporates
  /**
   * Count every cancelled session instance tied to the given recurring patterns, across all dates — backs the confirmation for a date-range-free bulk delete.
   */
  countCancelledSessionsByRecurrences: (args: {
    recurringSessionsIds: Array<ScalarsEnums['String']>
    siteId: ScalarsEnums['String']
  }) => ScalarsEnums['Float']
  /**
   * Find countries with pagination, search, and filtering
   */
  countries: (args?: {
    cursor?: Maybe<ScalarsEnums['String']>
    filter?: Maybe<CountriesFilterInput>
    orderBy?: Maybe<Array<CountriesOrderByInput>>
    pageSize?: Maybe<ScalarsEnums['Float']>
    search?: Maybe<ScalarsEnums['String']>
  }) => Countries
  /**
   * Get country by ID
   */
  country: (args: { countryId: ScalarsEnums['ID'] }) => Country
  /**
   * Class types at a location, for choosing cover qualifications and preferred subs
   */
  coverClassTypes: (args: { siteId: ScalarsEnums['ID'] }) => Array<CoverClassType>
  /**
   * Every notification sent about a cover, grouped by send and newest first, for managers
   */
  coverCommunicationLog: (args: {
    channel?: Maybe<CoverCommunicationChannel>
    coverRequestId: ScalarsEnums['ID']
    cursor?: Maybe<ScalarsEnums['String']>
    limit?: Maybe<ScalarsEnums['Int']>
    onlyFailed?: Maybe<ScalarsEnums['Boolean']>
    siteId: ScalarsEnums['ID']
  }) => CoverCommunicationLogPage
  /**
   * Who would be offered a cover for an instructor on a class, and why others would not
   */
  coverEligibility: (args: {
    originalStaffUserId: ScalarsEnums['ID']
    sessionId: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => Array<CoverEligibility>
  /**
   * Everyone a manager can send a cover message to: the instructor being covered, claimants, offered and eligible subs, and the assigned sub
   */
  coverMessageAudience: (args: {
    coverRequestId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Array<CoverMessageAudienceMember>
  /**
   * The message thread on a class cover
   */
  coverMessages: (args: {
    coverRequestId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Array<CoverMessageView>
  /**
   * Ranked preferred subs for a location
   */
  coverPreferredSubs: (args: { siteId: ScalarsEnums['ID'] }) => Array<CoverPreferredSubView>
  /**
   * Class types each staff member is qualified to cover at a location; a location with none set treats everyone as qualified
   */
  coverQualifications: (args: { siteId: ScalarsEnums['ID'] }) => Array<CoverStaffQualifications>
  /**
   * Class cover requests at the given locations (or every location the caller manages covers for), for the manager cover queue
   */
  coverQueue: (args?: {
    from?: Maybe<ScalarsEnums['String']>
    siteIds?: Maybe<Array<ScalarsEnums['ID']>>
    statuses?: Maybe<Array<CoverRequestStatus>>
    to?: Maybe<ScalarsEnums['String']>
  }) => Array<CoverRequestView>
  /**
   * One class cover request, with the claims the caller is allowed to see
   */
  coverRequest: (args: {
    coverRequestId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => CoverRequestView
  /**
   * The current cover request on each of the given classes, for schedule badges
   */
  coverRequestsForSessions: (args: {
    sessionIds: Array<ScalarsEnums['String']>
    siteId: ScalarsEnums['ID']
  }) => Array<CoverSessionBadge>
  /**
   * Check if a client has credits for a given session date and type. Uses the same validation path as the booking mutation — single source of truth.
   */
  creditsCoverSession: (args: {
    bookingDate: ScalarsEnums['String']
    clientId: ScalarsEnums['String']
    guestPassPoolOnly?: Maybe<ScalarsEnums['Boolean']>
    siteId: ScalarsEnums['String']
    siteSessionTypeId: ScalarsEnums['String']
    siteTimezone?: Maybe<ScalarsEnums['String']>
  }) => CreditsCoverSessionResult
  /**
   * Scheduled and awaiting-payment plan changes at a site that move a member to a membership in a different category. Shown before the 'Only allow plan changes within the same membership category' setting is turned on, since they still go through.
   */
  crossCategoryScheduledPlanChanges: (args: {
    siteId: ScalarsEnums['ID']
  }) => Array<CrossCategoryScheduledPlanChange>
  /**
   * Get an custom link by its ID
   */
  customLink: (args: { customLinkId: ScalarsEnums['ID'] }) => CustomLink
  /**
   * List all custom links
   */
  customLinks: Array<CustomLink>
  /**
   * List all custom properties for a site
   */
  customProperties: (args: { siteId: ScalarsEnums['ID'] }) => Array<CustomProperty>
  /**
   * Get a custom property by ID
   */
  customProperty: (args: {
    id: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => Maybe<CustomProperty>
  /**
   * Get statistics about custom text configuration
   */
  customizationStats: (args: { corporateId: ScalarsEnums['String'] }) => CustomizationStats
  /**
   * Get mobile dashboard data matching HomeInfo interface
   */
  dashboardMobile: (args: {
    clientId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => DashboardMobile
  /**
   * Get a single deep link by corporate and deep link ID
   */
  deepLink: (args: {
    corporateId: ScalarsEnums['String']
    deepLinkId: ScalarsEnums['String']
  }) => DeepLink
  /**
   * Get available deep link destinations with parameter requirements
   */
  deepLinkDestinations: (args: {
    corporateId: ScalarsEnums['String']
  }) => Array<DeepLinkDestinations>
  /**
   * Get account-level deep link settings (fallback URLs)
   */
  deepLinkSettings: (args: { corporateId: ScalarsEnums['String'] }) => DeepLinkSettings
  /**
   * List deep links with cursor-based pagination and optional filters
   */
  deepLinks: (args: {
    canonicalIdentifier?: Maybe<DeepLinkDestination>
    corporateId: ScalarsEnums['String']
    cursor?: Maybe<ScalarsEnums['String']>
    pageSize?: Maybe<ScalarsEnums['Float']>
    search?: Maybe<ScalarsEnums['String']>
  }) => DeepLinks
  /**
   * Get default text value for a specific key from member.json
   */
  defaultText: (args: {
    key: ScalarsEnums['String']
    language: ScalarsEnums['String']
  }) => DefaultText
  deletedKnowledgeArticles: (args?: {
    limit?: Maybe<ScalarsEnums['Int']>
    offset?: Maybe<ScalarsEnums['Int']>
  }) => DeletedKnowledgeArticlesResponse
  /**
   * Get current/latest demo seeding job for a corporate
   */
  demoSeedingJob: (args: { corporateId: ScalarsEnums['String'] }) => Maybe<DemoSeedingJob>
  /**
   * Get a specific demo seeding job by ID
   */
  demoSeedingJobById: (args: { jobId: ScalarsEnums['String'] }) => Maybe<DemoSeedingJob>
  /**
   * List all demo seeding jobs for a corporate, ordered by most recent first
   */
  demoSeedingJobs: (args: {
    corporateId: ScalarsEnums['String']
    limit?: Maybe<ScalarsEnums['Float']>
  }) => Array<DemoSeedingJob>
  /**
   * Whether a Holiday Destination Fee was already charged (paid or in-flight) for the client at the site today (site timezone)
   */
  destinationFeeChargeStatus: (args: {
    clientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => DestinationFeeChargeStatus
  /**
   * Identify the best-matching import type from a CSV header row
   */
  detectImportType: (args: { headers: Array<ScalarsEnums['String']> }) => DetectImportType
  /**
   * Get digital channels for a site
   */
  digitalChannels: (args: { siteId: ScalarsEnums['ID'] }) => Array<SiteLocation>
  /**
   * The revision in force for each named site policy, with its id and hash, for readers that display policy text before a member accepts it
   */
  displayedSitePolicyRevisions: (args: {
    siteId: ScalarsEnums['ID']
    sitePolicyIds: Array<ScalarsEnums['ID']>
  }) => Array<DisplayedSitePolicyRevision>
  /**
   * Retrieve a dispute by its ID
   */
  dispute: (args: { disputeId: ScalarsEnums['ID']; siteId: ScalarsEnums['ID'] }) => Dispute
  /**
   * Retrieve all disputes for a specific payment
   */
  disputes: (args: { paymentId: ScalarsEnums['ID']; siteId: ScalarsEnums['ID'] }) => Array<Dispute>
  draftKnowledgeArticles: (args?: {
    category?: Maybe<ScalarsEnums['String']>
    limit?: Maybe<ScalarsEnums['Int']>
    offset?: Maybe<ScalarsEnums['Int']>
  }) => KnowledgeArticlesByCategoryResponse
  /**
   * List the member's packages an upcoming drop-in booking can switch to paying with credits from, for a class that takes both credits and a drop-in rate, at the class's credit cost
   */
  dropInBookingCreditPackageOptions: (args: {
    bookingId: ScalarsEnums['ID']
  }) => BookingCreditPackageOptions
  /**
   * Count the not-yet-started pre-sale memberships an Early Access change on this template can apply to
   */
  earlyAccessRecutEligibleCount: (args: {
    serviceTemplateId: ScalarsEnums['String']
  }) => ScalarsEnums['Float']
  /**
   * A client's eGym link for the client profile — the eGym accountId and last-synced state (Hapana clientId = eGym membershipId).
   */
  egymClientLink: (args: {
    clientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => EgymClientLink
  /**
   * Whether eGym already holds any accounts for this site's key — gates the CSV export (empty → run the sync first).
   */
  egymHasAccounts: (args: { siteId: ScalarsEnums['ID'] }) => EgymHasAccounts
  /**
   * Member CSV export for a site (eGym's pre-enablement data cleanse) — one row per qualifying member.
   */
  egymMemberCsvExport: (args: { siteId: ScalarsEnums['ID'] }) => ScalarsEnums['String']
  /**
   * Whether eGym is on for a site (brand master enable AND site opt-in) — gates the client-profile eGym section.
   */
  egymSiteEnabled: (args: { siteId: ScalarsEnums['ID'] }) => EgymSiteEnabled
  /**
   * Whether a site has its eGym API key configured — the config dialog’s "key set" indicator (the key itself is write-only).
   */
  egymSiteHasKey: (args: { siteId: ScalarsEnums['ID'] }) => EgymSiteKeyStatus
  /**
   * Whether an eGym sync is currently in progress (any pending job on the egym-sync queue) — drives the config dialog spinner and disables re-triggering a backfill.
   */
  egymSyncActive: (args: { siteId: ScalarsEnums['ID'] }) => EgymSyncActive
  /**
   * Get embed widget configuration for corporate
   */
  embedWidgetConfig: (args: { corporateId: ScalarsEnums['String'] }) => EmbedSetupResponse
  /**
   * Get all enabled fee configurations
   */
  enabledFeeConfigurations: (args: { accountType: FeeAccountType }) => Array<FeeConfiguration>
  /**
   * List enabled (ACTIVE) service templates by site ID
   */
  enabledServiceTemplates: (args: { siteId: ScalarsEnums['String'] }) => Array<ServiceTemplate>
  /**
   * Service templates across one or more sites (id/name/type/status only) for report filter dropdowns — defaults to ACTIVE memberships and packages; pass templateTypes to widen it, e.g. ADD_ON, which is returned archived as well as active
   */
  enabledServiceTemplatesBySites: (args: {
    siteIds: Array<ScalarsEnums['String']>
    templateTypes?: Maybe<Array<ScalarsEnums['String']>>
  }) => Array<ServiceTemplateFilterOption>
  /**
   * Get a single equipment unit by ID
   */
  equipment: (args: { equipmentId: ScalarsEnums['String'] }) => Equipment
  /**
   * Get equipment usage activity grouped by day for a site
   */
  equipmentActivity: (args: {
    clientId?: Maybe<ScalarsEnums['String']>
    endDate?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['String']
    startDate?: Maybe<ScalarsEnums['String']>
  }) => Array<EquipmentActivityDay>
  /**
   * Get equipment assignments for a client at a site, ordered by most recent first. With countsTowardsRegulations, returns only the sessions the tanning regulation check counts (running, and finished, stopped or reversed after the lamps switched on), ignoring status
   */
  equipmentAssignmentsByClientId: (args: {
    clientId: ScalarsEnums['String']
    countsTowardsRegulations?: Maybe<ScalarsEnums['Boolean']>
    last?: Maybe<ScalarsEnums['Boolean']>
    siteId: ScalarsEnums['String']
    status?: Maybe<Array<EquipmentAssignmentStatus>>
  }) => Array<EquipmentAssignment>
  /**
   * Clients who used equipment at the location in the last 90 days, with the age and policy readiness of each equipment category as the start evaluator decides it, filtered, sorted and paginated server-side. The status excludes the skin type check and operational checks (equipment status, credits and add-ons, frequency regulations), which the start still applies
   */
  equipmentComplianceReport: (args: {
    filter?: Maybe<EquipmentComplianceReportFilterInput>
    page?: Maybe<EquipmentComplianceReportPageInput>
    siteId: ScalarsEnums['ID']
    sort?: Maybe<EquipmentComplianceSort>
    sortDirection?: Maybe<EquipmentComplianceSortDirection>
  }) => EquipmentComplianceReport
  /**
   * Fetch live diagnostics from the external tanning hardware agent
   */
  equipmentDiagnostics: (args: { siteId: ScalarsEnums['String'] }) => AgentDiagnostics
  /**
   * The exposure schedule line for a client's next session on a UV bed, or null when the client has no current skin type or the bed has no line for it. Never applied to the timer
   */
  equipmentExposureGuidance: (args: {
    clientId: ScalarsEnums['ID']
    equipmentId: ScalarsEnums['ID']
  }) => Maybe<EquipmentExposureGuidance>
  /**
   * A UV bed's manufacturer exposure schedule, ordered by skin type band then session. Reference only
   */
  equipmentExposureSchedule: (args: {
    equipmentId: ScalarsEnums['ID']
  }) => Array<EquipmentExposureScheduleRow>
  /**
   * The latest revision of every jurisdiction age rule at the location, active and retired
   */
  equipmentJurisdictionRules: (args: {
    siteId: ScalarsEnums['ID']
  }) => Array<EquipmentJurisdictionRule>
  /**
   * The revision of every active jurisdiction age rule that applies today at the location; a saved edit with a later start date is not in force yet
   */
  equipmentJurisdictionRulesInForce: (args: {
    siteId: ScalarsEnums['ID']
  }) => Array<EquipmentJurisdictionRule>
  /**
   * Lamp change, adjustment and tracking history of a bed, newest first
   */
  equipmentLampLogs: (args: { input: EquipmentLampLogsInput }) => EquipmentLampLogPage
  /**
   * Current lamp hours of every bed with lamp tracking enabled at a site
   */
  equipmentLampStatuses: (args: { siteId: ScalarsEnums['ID'] }) => EquipmentLampSiteStatus
  /**
   * Get the interleaved queue of clients waiting across all equipment units at a site
   */
  equipmentQueueClients: (args: {
    equipmentId?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['String']
  }) => Array<EquipmentQueuePosition>
  /**
   * Readiness of a client to start one equipment unit: the four D-01 dimensions and the blocking, actionable and upcoming items, reasons redacted to codes
   */
  equipmentReadiness: (args: {
    clientId: ScalarsEnums['ID']
    equipmentId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => EquipmentReadinessView
  /**
   * Readiness of up to 50 client and equipment pairs at one location in a single read, for the waitline; pairs whose client is not active at the location are left out, and every view carries its clientId and equipmentId
   */
  equipmentReadinessBatch: (args: {
    requests: Array<EquipmentReadinessRequestInput>
    siteId: ScalarsEnums['ID']
  }) => Array<EquipmentReadinessView>
  /**
   * Get the tanning safety regulation for a specific equipment category at a site
   */
  equipmentRegulation: (args: {
    equipmentCategory: EquipmentCategory
    siteId: ScalarsEnums['String']
  }) => Maybe<EquipmentRegulation>
  /**
   * List all tanning safety regulations for a site
   */
  equipmentRegulations: (args: { siteId: ScalarsEnums['String'] }) => Array<EquipmentRegulation>
  /**
   * Session types on an equipment unit and whether the client can use each one
   */
  equipmentSessionTypeAvailability: (args: {
    clientId: ScalarsEnums['String']
    equipmentId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Array<EquipmentSessionTypeAvailability>
  /**
   * List all equipment units for a site
   */
  equipments: (args: {
    search?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['String']
    siteSessionTypeId?: Maybe<ScalarsEnums['String']>
  }) => Array<Equipment>
  /**
   * CORE-1313: pre-payment estimate of Ezypay customer-paid fees (load + transaction) for AU checkout display. Estimate only — settlement values come from the Ezypay invoice resource post-debit.
   */
  estimateEzypayCustomerPaidFees: (args: {
    request: EzypayCustomerPaidFeeEstimateRequest
  }) => EzypayCustomerPaidFeeEstimateResult
  /**
   * Credits that expired on a pack and can still be rolled over onto another pack of the same client.
   */
  expiredCreditsAvailableForRollover: (args: {
    serviceId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => ScalarsEnums['Float']
  /**
   * Export custom text configuration as JSON for backup
   */
  exportCustomText: (args: { corporateId: ScalarsEnums['String'] }) => ExportCustomText
  /**
   * Poll the status of an async export job
   */
  exportJobStatus: (args: { jobId: ScalarsEnums['String'] }) => ExportJobStatus
  /**
   * Live read of the Ezypay payment-gateway fee/charge breakdown for an invoice (the "Payment Gateway Logs" inspector behind the Ezypay icon). Returns null when the invoice wasn't processed through Ezypay.
   */
  ezypayInvoiceGatewayLogs: (args: {
    invoiceId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Maybe<EzypayGatewayLogs>
  /**
   * What an invite token offers the signed-in member, for the accept screen; a coded error for an unknown, used or expired token
   */
  familyInviteContext: (args: { inviteToken: ScalarsEnums['String'] }) => FamilyInviteContext
  /**
   * The one client of this brand an exact email, phone or barcode matches, for staff adding a family member; members invite by link and are refused; null for no match, several matches, or a client already in a family
   */
  familyMemberCandidate: (args: {
    query: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => Maybe<FamilyMemberCandidate>
  /**
   * Up to ten active clients of this site whose name, email, phone or barcode contains the query, ordered by first then last name, for staff adding a family member; excludes anyone already in a family; members add family through invites and may not call this
   */
  familyMemberCandidates: (args: {
    query: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => Array<FamilyMemberCandidate>
  /**
   * Family-shareable packages held by the authenticated member's family, with each allocation (member)
   */
  familyPackages: (args: { siteId: ScalarsEnums['ID'] }) => Array<FamilyPackage>
  /**
   * The brand-wide family settings, read by any staff user or Hapana admin; admins per family defaults to 2 until it is saved
   */
  familySettings: FamilySettings
  /**
   * QA tooling: latest Feature Data Refresh status for a corporate. Feature/local environments only.
   */
  featureDataRefreshStatus: (args: {
    corporateId: ScalarsEnums['ID']
  }) => Maybe<FeatureDataRefreshStatus>
  /**
   * QA tooling: this feature env’s email redirect owner + CC list. Null outside feature envs.
   */
  featureEnvEmailSettings?: Maybe<FeatureEnvEmailSettings>
  /**
   * Get a fee configuration by ID
   */
  feeConfiguration: (args: { id: ScalarsEnums['String'] }) => FeeConfiguration
  /**
   * Get all fee configurations with cursor-based pagination
   */
  feeConfigurations: (args: {
    cursor?: Maybe<ScalarsEnums['String']>
    eventType?: Maybe<FeeEventType>
    orderBy: Array<FeeConfigurationsOrderByInput>
    pageSize?: Maybe<ScalarsEnums['Float']>
    paymentGateway?: Maybe<PaymentGateway>
    rateType?: Maybe<FeeRateType>
    search?: Maybe<ScalarsEnums['String']>
  }) => FeeConfigurations
  /**
   * List the feedback questions a member is asked for a session, in order
   */
  feedbackQuestions: (args: {
    bookingId?: Maybe<ScalarsEnums['String']>
    sessionId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => FeedbackQuestions
  /**
   * Find staff users
   */
  findStaffUsers: (args: {
    accessLevel?: Maybe<Array<StaffUserAccessLevel>>
    cursor?: Maybe<ScalarsEnums['String']>
    orderBy: Array<FindStaffUsersOrderByInput>
    pageSize?: Maybe<ScalarsEnums['Float']>
    search?: Maybe<ScalarsEnums['String']>
    siteGroupIds?: Maybe<Array<ScalarsEnums['ID']>>
    siteIds?: Maybe<Array<ScalarsEnums['ID']>>
    staffAccessPolicyIds?: Maybe<Array<ScalarsEnums['ID']>>
    status?: Maybe<StaffUserStatus>
  }) => FindStaffUsers
  /**
   * This deployment's Firebase projects for brand apps, with each project's app registrations counted live
   */
  firebaseAppProjectPool: FirebaseAppProjectPool
  /**
   * A member's Fitness Passport number and the state of the last check
   */
  fitnessPassportLink: (args: {
    clientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Maybe<FitnessPassportLinkView>
  /**
   * Whether Fitness Passport is configured and switched on at this location
   */
  fitnessPassportSiteEnabled: (args: { siteId: ScalarsEnums['ID'] }) => FitnessPassportSiteEnabled
  /**
   * One row per Fitness Passport call, newest first
   */
  fitnessPassportVisits: (args: {
    from: ScalarsEnums['String']
    limit?: Maybe<ScalarsEnums['Float']>
    outcomes?: Maybe<Array<FitnessPassportVisitOutcome>>
    siteId: ScalarsEnums['ID']
    to: ScalarsEnums['String']
  }) => Array<FitnessPassportVisitRow>
  /**
   * The visits report as CSV, for reconciliation against Fitness Passport
   */
  fitnessPassportVisitsCsv: (args: {
    from: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
    to: ScalarsEnums['String']
  }) => ScalarsEnums['String']
  /**
   * Outcome tiles for a location's Fitness Passport visits over a date range
   */
  fitnessPassportVisitsSummary: (args: {
    from: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
    to: ScalarsEnums['String']
  }) => FitnessPassportVisitsSummary
  /**
   * A request to register a fob from a Check-In Agent terminal, with the members already holding the fob after a collision.
   */
  fobCaptureRequest: (args: {
    requestId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => FobCaptureRequest
  /**
   * What applying a credential format would do to the fobs already enrolled at a location
   */
  fobReDerivationPreview: (args: {
    config?: Maybe<FobDerivationConfigInput>
    siteId: ScalarsEnums['ID']
  }) => FobReDerivationPreview
  /**
   * Get the live status of one form delivery
   */
  formHandoff: (args: { handoffId: ScalarsEnums['ID'] }) => FormHandoff
  /**
   * Get a short-lived URL for viewing a form signature image
   */
  formSignatureReadUrl: (args: { signatureAssetId: ScalarsEnums['String'] }) => FormSignatureReadUrl
  /**
   * Get a specific form submission by ID
   */
  formSubmission: (args: {
    submissionId: ScalarsEnums['String']
  }) => Maybe<ClientFormSubmissionWithClient>
  /**
   * List form follow-up actions at a location that stopped retrying
   */
  formWorkflowEffectFailures: (args: {
    siteId: ScalarsEnums['String']
  }) => Array<FormWorkflowEffectFailure>
  /**
   * Generate a signed URL for uploading a custom font directly to GCS (5-minute expiration)
   */
  generateFontUploadSignedUrl: (args: {
    corporateId: ScalarsEnums['String']
    fieldName: FontFieldName
    fontName: ScalarsEnums['String']
  }) => GenerateFontUploadSignedUrl
  /**
   * Get signed URL for an agreement template (for PENDING agreements)
   */
  getAgreementTemplateUrl: (args: {
    siteAgreementTemplateId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => ClientFileUrl
  /**
   * Get list of available BigQuery export reports
   */
  getAvailableBigQueryExports: Array<AvailableExport>
  /**
   * Get business client sign up fields configuration for a site
   */
  getBusinessClientSignUpFields: (args: {
    siteId: ScalarsEnums['ID']
  }) => BusinessClientSignUpFields
  /**
   * Get all custom property values for a client
   */
  getClientCustomPropertyValues: (args: {
    clientId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => ClientCustomPropertyValuesResponse
  /**
   * Get signed URL for client file
   */
  getClientFileUrl: (args: {
    clientId: ScalarsEnums['String']
    fileId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => ClientFileUrl
  /**
   * Get dashboard KPI card data (active members, new members, visits, revenue)
   */
  getDashboardKpis: (args: { input: DashboardInput }) => DashboardKpisResponse
  /**
   * Get payment statistics (successful/failed counts and amounts) for a service
   */
  getRecurringPaymentStats: (args: {
    serviceId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => RecurringPaymentStats
  /**
   * Get service detail with recurring invoice information for detail page
   */
  getRecurringServiceDetail: (args: {
    serviceId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => RecurringServiceDetail
  /**
   * Get a single scheduled job by key with live status and last run
   */
  getScheduledJob: (args: {
    corporateId?: Maybe<ScalarsEnums['ID']>
    jobKey: ScalarsEnums['String']
    siteId?: Maybe<ScalarsEnums['ID']>
  }) => Maybe<ScheduledJob>
  /**
   * Get full detail of a single scheduled-job run
   */
  getScheduledJobRun: (args: { jobId: ScalarsEnums['String'] }) => Maybe<ScheduledJobRun>
  /**
   * Get services sold trend data for the last 4 weeks by service type
   */
  getServicesSoldTrend: (args: { input: DashboardInput }) => Array<ServicesSoldItem>
  /**
   * Get top 5 services by visit count in the last 30 days
   */
  getTopServicesByVisits: (args: { input: DashboardInput }) => Array<TopServiceItem>
  getVideoStatus: (args: { videoId: ScalarsEnums['ID'] }) => VideoStatus
  getVideoStreamingUrls: (args: { videoId: ScalarsEnums['ID'] }) => VideoStreamingUrls
  getVideosByArticle: (args: { knowledgeArticleId: ScalarsEnums['ID'] }) => Array<VideoStatus>
  /**
   * Get a gift card design by ID
   */
  giftCardDesign: (args: { giftCardDesignId: ScalarsEnums['ID'] }) => Maybe<GiftCardDesign>
  /**
   * List all gift card designs for a site
   */
  giftCardDesigns: (args: { siteId: ScalarsEnums['ID'] }) => Array<GiftCardDesign>
  /**
   * The gift card expiry policy a country or state/province resolves to, after overrides and the platform default
   */
  giftCardExpiryJurisdictionPreview: (args: {
    asOfDate?: Maybe<ScalarsEnums['String']>
    countryId: ScalarsEnums['String']
    zoneId?: Maybe<ScalarsEnums['String']>
  }) => GiftCardExpiryJurisdictionPreview
  /**
   * The gift card expiry policy in force today for each site, from the Hapana jurisdiction rules
   */
  giftCardExpiryPolicies: (args: {
    siteIds: Array<ScalarsEnums['ID']>
  }) => Array<SiteGiftCardExpiryPolicy>
  /**
   * The audited change history of one gift card expiry rule, newest first
   */
  giftCardExpiryRuleHistory: (args: {
    giftCardExpiryRuleId: ScalarsEnums['ID']
  }) => Array<GiftCardExpiryRuleHistoryEntry>
  /**
   * Every gift card expiry rule, with its country and state/province names
   */
  giftCardExpiryRules: Array<GiftCardExpiryRule>
  /**
   * The locations of a brand, for previewing the gift card expiry policy of one
   */
  giftCardExpirySiteOptions: (args: {
    corporateId: ScalarsEnums['String']
  }) => Array<GiftCardExpirySiteOption>
  /**
   * The gift card expiry policy a location gets, resolved from its country and state exactly as a sale there would be
   */
  giftCardExpirySitePreview: (args: {
    asOfDate?: Maybe<ScalarsEnums['String']>
    corporateId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => GiftCardExpirySitePreview
  /**
   * Get a gift card template by ID
   */
  giftCardTemplate: (args: { giftCardTemplateId: ScalarsEnums['ID'] }) => Maybe<GiftCardTemplate>
  /**
   * List gift card templates for a site with filtering, sorting, and pagination
   */
  giftCardTemplates: (args: {
    filters?: Maybe<GiftCardTemplateFilter>
    pagination?: Maybe<GiftCardTemplatesPaginationInput>
    siteId: ScalarsEnums['ID']
    sort?: Maybe<GiftCardTemplateSort>
  }) => GiftCardTemplates
  /**
   * List gift card instances for a template with optional issued/claimed filtering
   */
  giftCards: (args: {
    filters?: Maybe<GiftCardFilter>
    giftCardTemplateId: ScalarsEnums['ID']
  }) => GiftCards
  /**
   * List all gift cards for a site (imported / POS / online / app) for the Retail Dashboard, with search, status, date-range and pagination filters
   */
  giftCardsBySite: (args: {
    filters?: Maybe<GiftCardSiteListFilter>
    siteId: ScalarsEnums['ID']
  }) => GiftCardSiteListResponse
  /**
   * Get a single goal by ID
   */
  goal: (args: { goalId: ScalarsEnums['ID'] }) => Maybe<CmsGoal>
  /**
   * List all goals for the current corporate
   */
  goals: Array<CmsGoal>
  /**
   * Get list of curated Google Fonts
   */
  googleFonts: Array<ScalarsEnums['String']>
  /**
   * Get a single GrowHq by ID
   */
  growHq: (args: { growHqId: ScalarsEnums['String'] }) => Maybe<GrowHq>
  /**
   * List all GrowHqs for the current corporate
   */
  growHqs: Array<GrowHq>
  /**
   * List all Grow-enabled site locations with sync status for the current corporate
   */
  growLocations: Array<GrowLocation>
  /**
   * Aggregated 'X of N used' guest pass balance for the service's current allocation period
   */
  guestPassAllocationSummary: (args: {
    serviceId: ScalarsEnums['ID']
  }) => Maybe<GuestPassAllocationSummary>
  /**
   * Count who a guest pass change on this template reaches: active members for Apply, members with unused passes and unclaimed invites for turning guest passes off
   */
  guestPassAllowanceImpact: (args: {
    serviceTemplateId: ScalarsEnums['ID']
  }) => GuestPassAllowanceImpact
  /**
   * Pre-claim invite context for an invite token (typed error when not claimable). No PII beyond sender name and studio.
   */
  guestPassByToken: (args: { token: ScalarsEnums['String'] }) => GuestPassByTokenResult
  /**
   * Period-by-period guest pass summary in the CreditSummaryResult shape
   */
  guestPassSummaryPeriods: (args: { serviceId: ScalarsEnums['ID'] }) => CreditSummaryResult
  /**
   * Every visit paid with guest pass credits across the passes a membership sent, newest first
   */
  guestPassVisits: (args: { serviceId: ScalarsEnums['ID'] }) => Array<GuestPassVisit>
  /**
   * Guest pass lifecycle list (sent/received) with session display fields. Ordered acceptedAt ASC, sentAt ASC (oldest claimed first).
   */
  guestPasses: (args: { filter: GuestPassesFilterInput }) => Array<GuestPassWithSession>
  /**
   * Get a hapana fees template by ID
   */
  hapanaFeesTemplate: (args: { id: ScalarsEnums['String'] }) => HapanaFeesTemplate
  /**
   * Get all hapana fees templates
   */
  hapanaFeesTemplates: (args: {
    paginate: PaginationInput
    search?: Maybe<ScalarsEnums['String']>
    sort?: Maybe<FindFeesTemplatesSortOptions>
  }) => HapanaFeesTemplatesPageInfo
  /**
   * Whether the signed-in member holds an active, not on hold service on a family-shareable template anywhere in the brand: the member app shows "Set up your family" on it
   */
  hasFamilyShareablePackage: (args: { siteId: ScalarsEnums['ID'] }) => ScalarsEnums['Boolean']
  /**
   * Whether the client has submitted feedback for an attendance at a site; staff or the member themselves, requires session-feedback-config-enabled
   */
  hasFeedback: (args: {
    attendanceId: ScalarsEnums['ID']
    clientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Check if a client has ever had a purchasable (non-guest-pass) service (package or membership) at a site
   */
  hasServiceAtSite: (args: {
    clientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * One published external help doc with the release notes that announced it
   */
  helpDoc: (args: {
    siteId?: Maybe<ScalarsEnums['ID']>
    slug: ScalarsEnums['String']
  }) => Maybe<HelpDoc>
  /**
   * Help doc categories that contain at least one published external article
   */
  helpDocCategories: (args?: { siteId?: Maybe<ScalarsEnums['ID']> }) => Array<HelpDocCategory>
  /**
   * Published external help docs, filtered by category and search text
   */
  helpDocs: (args?: {
    categorySlug?: Maybe<ScalarsEnums['String']>
    limit?: Maybe<ScalarsEnums['Int']>
    offset?: Maybe<ScalarsEnums['Int']>
    search?: Maybe<ScalarsEnums['String']>
    siteId?: Maybe<ScalarsEnums['ID']>
  }) => Array<HelpDocSummary>
  /**
   * Get contacts associated with a HubSpot company
   */
  hubSpotCompanyContacts: (args: {
    companyId: ScalarsEnums['String']
  }) => HubSpotCompanyContactsResult
  /**
   * Generate a short-lived signed URL for downloading the audit CSV
   */
  importAuditCsvUrl: (args: { importSessionId: ScalarsEnums['ID'] }) => ImportAuditCsvUrl
  /**
   * Download the BulkClassesSessions workbook: the fill-in sheet plus PRE-FILLED reference tabs of every valid lookup value (schedule template names, locations & rooms, instructors) and the currently scheduled future sessions. The filled workbook re-uploads to the Bulk Classes / Sessions row
   */
  importBulkClassesTemplateXlsx: ImportReferenceDataExportXlsx
  /**
   * Download the UpdateClient fill-in workbook, PRE-FILLED with every client's current profile values (one row per client per site). Operators edit only the cells to change — untouched rows are skipped as no-ops by the import's diff check — and re-upload it to the Update Client Information bulk-update row
   */
  importClientUpdateTemplateXlsx: ImportReferenceDataExportXlsx
  /**
   * Download a master reference CSV of every client across all locations (clientId, externalId, email, name) for mapping client-linked imports
   */
  importClientsExportCsv: ImportSitesExportCsv
  /**
   * Download a reference CSV of the corporate's custom property definitions by site, for the CustomProperties import's Property ID / Property Name columns
   */
  importCustomPropertiesExportCsv: ImportSitesExportCsv
  /**
   * Get distinct locationId values from CSV rows across all sessions in a migration
   */
  importDistinctLocationIds: (args: {
    migrationId: ScalarsEnums['ID']
  }) => ImportDistinctLocationIds
  /**
   * Signed URL for the FAILED-rows-only audit CSV (gated by import__download_audit)
   */
  importFailuresAuditCsvUrl: (args: {
    importSessionId: ScalarsEnums['ID']
  }) => ImportFailuresAuditCsvUrl
  /**
   * Signed URL for the original source rows that FAILED (gated by import__download_source)
   */
  importFailuresSourceFileUrl: (args: {
    importSessionId: ScalarsEnums['ID']
  }) => ImportFailuresAuditCsvUrl
  /**
   * Download a reference CSV of the corporate's upcoming sessions (template, date, time by site) for mapping FutureBookings rows to real sessions
   */
  importFutureSessionsExportCsv: ImportSitesExportCsv
  /**
   * Download a reference CSV of the corporate's gift card templates by site, for the ClientGiftCards import's Gift Card Template ID column
   */
  importGiftCardsExportCsv: ImportSitesExportCsv
  /**
   * Download the Manual Migration master workbook: a formatted fill-in sheet per client & transaction import type (headers matching the CSV templates, per-site dependent dropdowns, auto-filled ID columns) plus all reference tabs and a Start Here guide — for brands entering their data by hand when there is no previous provider. Scoped to one site via siteId, or all accessible locations when omitted
   */
  importManualMigrationWorkbookXlsx: (args?: {
    siteId?: Maybe<ScalarsEnums['ID']>
  }) => ImportReferenceDataExportXlsx
  /**
   * Download the BulkMembershipPlanChange fill-in workbook, PRE-FILLED with every ACTIVE membership and its current template + recurring amount, plus a Memberships reference tab of valid targets. Operators fill in New Membership Name (and optionally the ID) only on rows to correct — blank rows are no-ops — and re-upload it to the Bulk Membership Plan Change bulk-update row
   */
  importMembershipPlanChangeTemplateXlsx: ImportReferenceDataExportXlsx
  /**
   * Download the BulkUpdatedPriceMembership fill-in workbook, PRE-FILLED with every ACTIVE or SUSPENDED membership and its current recurring price/discount — the Membership Status column says which, and a suspended membership reprices now and resumes on the new price. Operators fill in New Membership Price only on rows to change — blank rows are no-ops — and re-upload it to the Bulk Updated Price Membership bulk-update row
   */
  importMembershipPriceTemplateXlsx: ImportReferenceDataExportXlsx
  /**
   * Download the BulkSuspendMembership fill-in workbook, PRE-FILLED with every ACTIVE membership that can still be frozen (already-frozen and freeze-scheduled memberships are excluded). Operators delete the rows they do not want frozen and fill in the freeze dates/reason on the rest, then re-upload it to the Bulk Membership Suspend bulk-update row
   */
  importMembershipSuspendTemplateXlsx: ImportReferenceDataExportXlsx
  /**
   * Download the Missing Methods report: recurring charges the billing run will take in the next 60 days across accessible sites (one row per recurring payment), classified against the method that will be charged (the attached method, or the payer's default when none is attached) as OK, At risk (card expires before the charge) or Will fail, with member vs payer columns and an Imported Data flag
   */
  importMissingMethodsExportXlsx: ImportReferenceDataExportXlsx
  /**
   * Download the UpdateOutstandingBalances fill-in workbook, PRE-FILLED with every imported invoice still outstanding (failed-family status, across all import sessions) and its current value/status. Operators set New Amount (blank = no change, 0 = remove entirely, other = corrected failed amount) and re-upload it to the Update Outstanding Balances bulk-update row
   */
  importOutstandingBalancesTemplateXlsx: ImportReferenceDataExportXlsx
  /**
   * Download a reference CSV of the corporate's packages and memberships (service templates joined with site details)
   */
  importPackagesExportCsv: ImportSitesExportCsv
  /**
   * Download the UpdatePaidBy fill-in workbook, PRE-FILLED with every ACTIVE recurring payment (member, current payer, method status). Operators fill in the New Paid By columns only on rows to change — blank rows are no-ops — and re-upload it to the Update Paid By bulk-update row
   */
  importPaidByUpdateTemplateXlsx: ImportReferenceDataExportXlsx
  /**
   * Download a reference CSV of the corporate's client payment methods by site (CPM UUID = the MembershipPayment import's Card ID, plus gateway customer id, token, brand, last4, expiry) for binding cards to memberships after the payment-method data lands
   */
  importPaymentMethodsExportCsv: ImportSitesExportCsv
  /**
   * Check which prerequisite import types have existing data in the DB for a site (GAP-36)
   */
  importPrerequisites: (args: { siteId: ScalarsEnums['ID'] }) => ImportPrerequisites
  /**
   * Get paginated import preview rows with validation errors
   */
  importPreview: (args: {
    filterBy: ImportPreviewFilterBy
    importSessionId: ScalarsEnums['ID']
    page: ScalarsEnums['Float']
    pageSize: ScalarsEnums['Float']
    search?: Maybe<ScalarsEnums['String']>
  }) => ImportPreview
  /**
   * Signed URL for the COMPLETED-rows-only audit CSV (gated by import__download_audit)
   */
  importProcessedAuditCsvUrl: (args: {
    importSessionId: ScalarsEnums['ID']
  }) => ImportFailuresAuditCsvUrl
  /**
   * Download all reference data (sites, packages, gift cards, schedule templates, future sessions, custom properties) as one styled XLSX workbook with a sheet per dataset
   */
  importReferenceDataExportXlsx: ImportReferenceDataExportXlsx
  /**
   * Download a reference CSV of the corporate's schedule (session) templates by site, for the FutureBookings import's TemplateName column
   */
  importScheduleTemplatesExportCsv: ImportSitesExportCsv
  /**
   * Get import session status and counts for frontend polling
   */
  importSession: (args: { importSessionId: ScalarsEnums['ID'] }) => ImportSession
  /**
   * Download a reference CSV of the corporate's sites (siteIds + business metadata) for filling import templates
   */
  importSitesExportCsv: ImportSitesExportCsv
  /**
   * Signed URL for the SKIPPED-rows-only audit CSV (gated by import__download_audit)
   */
  importSkippedAuditCsvUrl: (args: {
    importSessionId: ScalarsEnums['ID']
  }) => ImportFailuresAuditCsvUrl
  /**
   * Signed URL for the original source rows that were SKIPPED (gated by import__download_source)
   */
  importSkippedSourceFileUrl: (args: {
    importSessionId: ScalarsEnums['ID']
  }) => ImportFailuresAuditCsvUrl
  /**
   * Generate a short-lived signed URL for downloading the original source CSV
   */
  importSourceFileUrl: (args: { importSessionId: ScalarsEnums['ID'] }) => ImportSourceFileUrl
  /**
   * Generate a sample CSV template with headers and example row for an import type
   */
  importTemplateCsv: (args: { importType: ScalarsEnums['String'] }) => ImportTemplateCsv
  /**
   * Non-secret Inception settings stored on an access point; the panel password is never returned
   */
  inceptionPanelSettings: (args: {
    siteAccessPointId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => InceptionPanelSettings
  /**
   * The staffOptions list narrowed to staff with Is Instructor ticked at one or more locations, for instructor pickers such as the Content Suite editor.
   */
  instructorOptions: Array<StaffUserOption>
  /**
   * Get active staff users who can be assigned as instructors for a site
   */
  instructors: (args: { siteId: ScalarsEnums['String'] }) => Array<InstructorForSite>
  /**
   * Get an invoice by ID
   */
  invoice: (args: { invoiceId: ScalarsEnums['String']; siteId: ScalarsEnums['ID'] }) => Invoice
  /**
   * Aggregate net revenue (successful payments, amount − tax) for a site over the trailing 30 days plus the prior 30-day window, bucketed by the site-local day and computed with the same formula as the Net Revenue report. Refunds are reported separately, not netted. Computed in SQL over the full dataset rather than a paged sample, so a bulk import cannot skew it to zero.
   */
  invoiceRevenueSummary: (args: { siteId: ScalarsEnums['ID'] }) => InvoiceRevenueSummary
  /**
   * List invoices with pagination, search, sorting, and filtering
   */
  invoices: (args?: {
    cursor?: Maybe<ScalarsEnums['String']>
    filter?: Maybe<InvoicesFilterInput>
    orderBy?: Maybe<Array<InvoicesOrderByInput>>
    pageSize?: Maybe<ScalarsEnums['Float']>
    search?: Maybe<ScalarsEnums['String']>
    siteId?: Maybe<ScalarsEnums['ID']>
  }) => Invoices
  /**
   * Check if a client is associated with a specific site
   */
  isClientAtSite: (args: {
    clientId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => IsClientAtSite
  /**
   * Whether the fee charged on an invoice may be refunded, per that fee's refund setting
   */
  isInvoiceRefundAllowed: (args: {
    invoiceId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * Get kiosk configuration for corporate
   */
  kioskConfig: (args: { corporateId: ScalarsEnums['String'] }) => KioskSetupResponse
  /**
   * Get kiosk default settings for a corporate
   */
  kioskDefaults: (args: { corporateId: ScalarsEnums['String'] }) => KioskDefaults
  /**
   * Get PIN configuration status for a site (without revealing the hash).
   */
  kioskPinStatus: (args: { siteId: ScalarsEnums['String'] }) => KioskPinStatus
  /**
   * Fetch session bookings data for kiosk attendee list
   */
  kioskSessionBookings: (args: {
    sessionId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Maybe<KioskSessionBookings>
  knowledgeArticle: (args?: {
    includeDeleted?: Maybe<ScalarsEnums['Boolean']>
    knowledgeArticleId?: Maybe<ScalarsEnums['ID']>
    slug?: Maybe<ScalarsEnums['String']>
  }) => Maybe<KnowledgeArticle>
  knowledgeArticleCategories: (args?: {
    includeDeleted?: Maybe<ScalarsEnums['Boolean']>
  }) => Array<KnowledgeArticleCategory>
  knowledgeArticleCategory: (args?: {
    knowledgeArticleCategoryId?: Maybe<ScalarsEnums['ID']>
    slug?: Maybe<ScalarsEnums['String']>
  }) => Maybe<KnowledgeArticleCategory>
  knowledgeArticleRevision: (args: {
    revisionId: ScalarsEnums['ID']
  }) => Maybe<KnowledgeArticleRevision>
  knowledgeArticleRevisions: (args?: {
    filter?: Maybe<KnowledgeArticleRevisionFilterInput>
    pagination?: Maybe<PaginationInput>
  }) => KnowledgeArticleRevisionsResponse
  knowledgeArticleStats: KnowledgeArticleStats
  knowledgeArticleTranslation: (args: {
    knowledgeArticleId: ScalarsEnums['ID']
    locale: ScalarsEnums['String']
  }) => Maybe<KnowledgeArticleTranslation>
  knowledgeArticleTranslations: (args: {
    knowledgeArticleId: ScalarsEnums['ID']
  }) => Array<KnowledgeArticleTranslation>
  knowledgeArticles: (args?: {
    filter?: Maybe<KnowledgeArticleFilterInput>
    pagination?: Maybe<PaginationInput>
  }) => KnowledgeArticlesResponse
  knowledgeArticlesByCategory: (args: {
    categorySlug: ScalarsEnums['String']
    limit?: Maybe<ScalarsEnums['Int']>
    offset?: Maybe<ScalarsEnums['Int']>
    status?: Maybe<KnowledgeArticleStatus>
  }) => KnowledgeArticlesByCategoryResponse
  knowledgeArticlesForUser: (args: {
    category?: Maybe<ScalarsEnums['String']>
    locale?: Maybe<ScalarsEnums['String']>
    pagination?: Maybe<PaginationInput>
    userContext: UserContextInput
  }) => Array<KnowledgeArticle>
  knowledgeDocument: (args: { id: ScalarsEnums['ID'] }) => Maybe<KnowledgeDocument>
  knowledgeDocuments: (args: {
    category?: Maybe<ScalarsEnums['String']>
    corporateId: ScalarsEnums['String']
    pagination?: Maybe<PaginationInput>
  }) => Array<KnowledgeDocument>
  /**
   * Get last attendance requiring feedback for a client at a site
   */
  lastAttendanceFeedback: (args: {
    clientId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Maybe<LastAttendanceFeedback>
  /**
   * Get the most recent TANNING check-in for a client at a site created today. Used to link equipment assignments for credit consumption.
   */
  latestTanningCheckIn: (args: {
    clientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Maybe<CheckIn>
  /**
   * Aggregate check-in counts per client for leaderboard materialization. Internal query used by the corporates server materialization engine.
   */
  leaderboardAttendanceAggregation: (args: {
    periodEnd: ScalarsEnums['String']
    periodStart: ScalarsEnums['String']
    sessionTypeIds?: Maybe<Array<ScalarsEnums['String']>>
    siteIds: Array<ScalarsEnums['String']>
  }) => Array<LeaderboardAttendanceAggregation>
  /**
   * Get a single leaderboard config by ID
   */
  leaderboardConfig: (args: {
    leaderboardConfigId: ScalarsEnums['String']
  }) => Maybe<LeaderboardConfig>
  /**
   * List leaderboard configs with filters and pagination
   */
  leaderboardConfigs: (args: {
    afterCursor?: Maybe<ScalarsEnums['String']>
    leaderboardType?: Maybe<LeaderboardType>
    limit: ScalarsEnums['Float']
    scope?: Maybe<LeaderboardScope>
    search?: Maybe<ScalarsEnums['String']>
    status?: Maybe<LeaderboardStatus>
  }) => LeaderboardConfigConnection
  /**
   * Dashboard summary: latest stats per leaderboard
   */
  leaderboardDashboard: Array<LeaderboardDashboard>
  /**
   * Get historical snapshots for a leaderboard
   */
  leaderboardSnapshots: (args: {
    endDate: ScalarsEnums['String']
    leaderboardConfigId: ScalarsEnums['String']
    startDate: ScalarsEnums['String']
  }) => Array<LeaderboardSnapshot>
  /**
   * Non-secret Inception settings migrated from V1 for a site, used to prefill a new access point
   */
  legacyInceptionConfig: (args: { siteId: ScalarsEnums['String'] }) => Maybe<LegacyInceptionConfig>
  /**
   * Get all clients with pagination and search (admin access - all clients in database)
   */
  listAllClients: (args?: {
    growStatus?: Maybe<GrowStatusFilter>
    limit?: Maybe<ScalarsEnums['Float']>
    offset?: Maybe<ScalarsEnums['Float']>
    paginate?: Maybe<PaginationInput>
    search?: Maybe<ScalarsEnums['String']>
    siteId?: Maybe<ScalarsEnums['String']>
    sort?: Maybe<FindClientsSortOptions>
  }) => ListAllClients
  /**
   * Discover gs:// bundle prefixes (folders that contain .zip objects)
   */
  listGcsBundlePrefixes: (args?: { root?: Maybe<ScalarsEnums['String']> }) => ListGcsBundlePrefixes
  /**
   * List the .zip objects under a gs:// bundle prefix for in-place import
   */
  listGcsBundleZips: (args: { prefix: ScalarsEnums['String'] }) => ListGcsBundleZips
  /**
   * List all recurring invoices (past materialized + future virtual) for a service
   */
  listInvoicesByService: (args: {
    lookAheadMonths?: Maybe<ScalarsEnums['Float']>
    serviceId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Array<VirtualInvoice>
  /**
   * List past recurring invoices for a service with cursor-based pagination
   */
  listPastInvoicesByService: (args: {
    args: ListPastInvoicesByServiceArgs
    siteId: ScalarsEnums['ID']
  }) => ListPastInvoicesByService
  /**
   * List recurring invoices for a site with cursor-based pagination
   */
  listRecurringInvoices: (args: {
    input: ListRecurringInvoicesInput
    siteId: ScalarsEnums['ID']
  }) => RecurringInvoicesPaginationResult
  /**
   * List scheduled/future recurring invoices for a service with offset-based pagination
   */
  listScheduledInvoicesByService: (args: {
    args: ListScheduledInvoicesByServiceArgs
    siteId: ScalarsEnums['ID']
  }) => ListScheduledInvoicesByServiceResult
  /**
   * Paginated run history for a scheduled job
   */
  listScheduledJobRuns: (args: {
    corporateId?: Maybe<ScalarsEnums['ID']>
    jobKey: ScalarsEnums['String']
    paginate: ListScheduledJobRunsPaginateInput
    siteId?: Maybe<ScalarsEnums['ID']>
    status?: Maybe<ScheduledJobRunStatus>
  }) => ScheduledJobRunsResult
  /**
   * List scheduled jobs with live registration state and last run
   */
  listScheduledJobs: (args?: {
    corporateId?: Maybe<ScalarsEnums['ID']>
    level?: Maybe<ScheduledJobLevel>
    siteId?: Maybe<ScalarsEnums['ID']>
  }) => Array<ScheduledJob>
  /**
   * List services by template type (PACKAGE or MEMBERSHIP) for a site
   */
  listServicesByTemplateType: (args: {
    input: ListServicesByTemplateTypeInput
    siteId: ScalarsEnums['ID']
  }) => ServicesPaginationResult
  /**
   * Get aggregated counts for all location operations data (custom properties, policies, forms, reasons, etc.)
   */
  locationOperationsCounts: (args: { siteId: ScalarsEnums['ID'] }) => LocationOperationsCounts
  /**
   * Whether the location has a maintenance email, readable by any staff member who can send a maintenance request there
   */
  maintenanceEmailConfigured: (args: { siteId: ScalarsEnums['ID'] }) => ScalarsEnums['Boolean']
  /**
   * Returns the current user's data.
   */
  me: Self
  /**
   * List all virtual media folders as a tree, derived from the folder column on media assets
   */
  mediaFolders: (args?: { mediaType?: Maybe<MediaType> }) => Array<MediaFolder>
  /**
   * List Member API request/response audit logs for the authenticated corporate
   */
  memberApiAuditLogs: (args: {
    limit: ScalarsEnums['Float']
    method?: Maybe<ScalarsEnums['String']>
    offset: ScalarsEnums['Float']
    pathContains?: Maybe<ScalarsEnums['String']>
    siteId?: Maybe<ScalarsEnums['String']>
    status?: Maybe<ScalarsEnums['Float']>
  }) => Array<MemberApiAuditLog>
  /**
   * Get audit trail for a specific member
   */
  memberAuditEvents: (args: {
    corporateId: ScalarsEnums['String']
    memberId: ScalarsEnums['String']
    pagination?: Maybe<AuditEventsPaginationInput>
  }) => AuditQueryResult
  /**
   * Get branding configuration for a corporate (returns defaults if none configured)
   */
  memberExperienceBranding: (args: {
    corporateId: ScalarsEnums['String']
  }) => MemberExperienceBranding
  /**
   * Get fonts configuration for a corporate (returns defaults if none configured)
   */
  memberExperienceFonts: (args: { corporateId: ScalarsEnums['String'] }) => MemberExperienceFonts
  /**
   * Get the resolved public member experience for a surface and language
   */
  memberExperienceRuntime: (args: {
    corporateId: ScalarsEnums['ID']
    language: ScalarsEnums['String']
    surface: MemberExperienceSurface
  }) => MemberExperienceRuntime
  /**
   * Get settings configuration for a corporate (returns defaults if none configured)
   */
  memberExperienceSettings: (args: {
    corporateId: ScalarsEnums['String']
  }) => MemberExperienceSettings
  /**
   * Raw per-surface colour override row, null while the surface inherits
   */
  memberExperienceSurfaceBranding: (args: {
    corporateId: ScalarsEnums['String']
    surface: MemberExperienceSurface
  }) => Maybe<MemberExperienceSurfaceBranding>
  /**
   * Per-surface integration credentials configured for a corporate
   */
  memberExperienceSurfaceIntegrations: (args: {
    corporateId: ScalarsEnums['String']
  }) => Array<MemberExperienceSurfaceIntegration>
  /**
   * Resolved colours for one surface, falling back to the global theme, with the source of the values
   */
  memberExperienceTheme: (args: {
    corporateId: ScalarsEnums['String']
    surface: MemberExperienceSurface
  }) => MemberExperienceTheme
  /**
   * A single MemberMovement — DETAIL projection incl. gateResults + snapshot
   */
  memberMovement: (args: { movementId: ScalarsEnums['ID'] }) => Maybe<MemberMovementDetail>
  /**
   * Attestation Register (Issue 12, B8) — immutable liability paper trail (PRD §7.4). member_movement__view + tenant guard.
   */
  memberMovementAttestationRegister: (args: {
    input: MemberMovementAttestationRegisterInput
  }) => MemberMovementAttestationRegisterResult
  /**
   * Blocked/Replay queue (Issue 7b, B5) — BLOCKED + MOVE_FAILED movements, LIST projection, filterable by blockedReason + site pair. member_movement__view + tenant guard.
   */
  memberMovementBlockedQueue: (args: {
    input: MemberMovementBlockedQueueInput
  }) => MemberMovementConnection
  /**
   * MEMBERSHIP templates a member may be moved onto at a site: ACTIVE ones, plus ARCHIVED ones when the brand allows archived destinations
   */
  memberMovementDestinationTemplates: (args: {
    siteId: ScalarsEnums['ID']
  }) => Array<MemberMovementDestinationTemplate>
  /**
   * On-demand live gate evaluation for one membership — persists nothing (D-19)
   */
  memberMovementEligibilityCheck: (args: {
    input: MemberMovementEligibilityCheckInput
  }) => MemberMovementEligibilityResult
  /**
   * OC-1461 — this run's memberships already held open by a movement elsewhere
   */
  memberMovementHeldMovements: (args: {
    runId: ScalarsEnums['ID']
  }) => Array<MemberMovementHeldMovement>
  /**
   * Home-site recovery worklist (Issue 7b) — MOVED_PENDING_HOMESITE + REVERTED-with-pending-marker movements, LIST projection. member_movement__view + tenant guard.
   */
  memberMovementHomeSiteRecoveryQueue: (args: {
    input: MemberMovementHomeSiteRecoveryInput
  }) => MemberMovementConnection
  /**
   * Incoming-approval queue (OC-1461) — members qualified to move INTO a location under rolling APPROVAL mode, awaiting acceptance. Scoped to the sites the caller holds member_movement__approve_incoming on; a corporate member_movement__approve sees the brand.
   */
  memberMovementIncomingApprovals: (args: {
    input: MemberMovementIncomingApprovalQueueInput
  }) => MemberMovementConnection
  /**
   * Active memberships at an incoming movement’s receiving location (OC-2075). Gated exactly like chooseIncomingMovementDestination.
   */
  memberMovementIncomingDestinationTemplates: (args: {
    input: MemberMovementIncomingDestinationTemplatesInput
  }) => Array<MemberMovementIncomingDestinationTemplate>
  /**
   * One incoming movement with the source membership’s live price and next billing date and what the caller may do with it (OC-2075). Out-of-scope rows read as not found.
   */
  memberMovementIncomingMovement: (args: {
    input: MemberMovementIncomingMovementInput
  }) => MemberMovementIncomingMovement
  /**
   * Active staff at a location who may be chosen as incoming notification recipients (OC-2075). Gated exactly like setMemberMovementIncomingNotifiers.
   */
  memberMovementIncomingNotifierCandidates: (args: {
    input: MemberMovementIncomingNotifierCandidatesInput
  }) => Array<MemberMovementIncomingNotifierCandidate>
  /**
   * A location’s incoming member movements by segment (OC-2075): AWAITING a decision, UNMATCHED (no membership yet), FAILED (blocked or failed rolling/replay moves) and HISTORY. Scoped to locations where the caller holds member_movement__approve_incoming or member_movement__manage_incoming; destinationSiteId narrows, never widens. `sites` carries the name, timezone and currency of every location on the page.
   */
  memberMovementIncomingQueue: (args: {
    input: MemberMovementIncomingQueueInput
  }) => MemberMovementIncomingConnection
  /**
   * Awaiting, unmatched and failed incoming movement counts (OC-2075): for one location, or across every location the caller can see when destinationSiteId is omitted. Same scope as memberMovementIncomingQueue.
   */
  memberMovementIncomingSummary: (args: {
    input: MemberMovementIncomingSummaryInput
  }) => MemberMovementIncomingSummary
  /**
   * Brand rolling approval posture and each location’s override, effective posture and notification recipients (OC-2075). Scoped to the locations the caller may see; siteIds narrows, never widens.
   */
  memberMovementLocationPostures: (args: {
    input: MemberMovementLocationPosturesInput
  }) => MemberMovementLocationPostures
  /**
   * Memberships locations chose where the brand has no mapping (OC-2075), with how many members still wait unmatched on the same pair. Corporate member_movement__view.
   */
  memberMovementLocationResolutions: (args: {
    input: MemberMovementLocationResolutionsInput
  }) => MemberMovementLocationResolutionConnection
  /**
   * Read-only preview of a manual transfer (PRD §12) — resolved destination template, carried billing dates, secondary-fee outcome, cross-currency note, agreement carry, and the member-specific payment-migration outlook. Mutates nothing. member_movement__view + tenant guard.
   */
  memberMovementManualTransferPreview: (args: {
    input: MemberMovementManualTransferInput
  }) => MemberMovementManualTransferPreview
  /**
   * OC-1461 — other non-terminal period runs overlapping this run's period
   */
  memberMovementOverlappingRuns: (args: {
    runId: ScalarsEnums['ID']
  }) => Array<MemberMovementOverlappingRun>
  /**
   * Payment Collection worklist (Issue 12, B6 brand-wide / L3 site-scoped) — movements whose payment method could not migrate (NOT_POSSIBLE/FAILED). member_movement__view + tenant guard.
   */
  memberMovementPaymentCollection: (args: {
    input: MemberMovementPaymentCollectionInput
  }) => MemberMovementConnection
  /**
   * On-demand "How payment methods transfer" capability matrix for a brand (PRD §10.2 / D-24) — site topology (gateway/country/Stripe platform) + resolved pair outlook. member_movement__view.
   */
  memberMovementPaymentTransferMatrix: (args: {
    corporateId: ScalarsEnums['ID']
  }) => MemberMovementPaymentTransferMatrix
  /**
   * Revert Log (Issue 12, B7) — REVERTED movements. member_movement__view + tenant guard.
   */
  memberMovementRevertLog: (args: {
    input: MemberMovementRevertLogInput
  }) => MemberMovementConnection
  /**
   * Live rolling-evaluation cron state for a corporate (OC-1857 item 2) — whether rolling is on, whether a cron is actually registered behind it, and when it next fires. Read from the scheduler, never derived from the configured cadence. member_movement__view.
   */
  memberMovementRollingSchedulerStatus: (args: {
    corporateId: ScalarsEnums['ID']
  }) => MemberMovementRollingSchedulerStatus
  /**
   * A single Member Movement run
   */
  memberMovementRun: (args: { runId: ScalarsEnums['ID'] }) => Maybe<MemberMovementRun>
  /**
   * Whole-run approval-gate counts (unresolved mappings, approved movements)
   */
  memberMovementRunApprovalReadiness: (args: {
    input: MemberMovementApprovalReadinessInput
  }) => MemberMovementApprovalReadiness
  /**
   * Paginated Member Movement run history for a corporate (Runs tab / B4)
   */
  memberMovementRuns: (args: { input: MemberMovementRunsInput }) => MemberMovementRunConnection
  /**
   * List persisted Member Movement source->destination service-template mappings for a corporate
   */
  memberMovementTemplateMappings: (args: {
    corporateId: ScalarsEnums['ID']
  }) => Array<MemberMovementTemplateMapping>
  /**
   * A member's movable memberships for the Manual Transfer picker (Issue 12, PRD §12) — ACTIVE and SUSPENDED MEMBERSHIP services only, the set the execution pre-flight accepts as a source. member_movement__view + assert-corporate.
   */
  memberMovementTransferableMemberships: (args: {
    clientId: ScalarsEnums['ID']
    corporateId: ScalarsEnums['ID']
  }) => Array<MemberMovementTransferableMembership>
  /**
   * Signed download URL for a run’s generated workbook — null while still building (poll). Issue 11.
   */
  memberMovementWorkbookUrl: (args: { runId: ScalarsEnums['ID'] }) => Maybe<ScalarsEnums['String']>
  /**
   * Paginated MemberMovement rows (grid / ledger / blocked queue) — LIST projection
   */
  memberMovements: (args: { filter: MemberMovementsFilterInput }) => MemberMovementConnection
  /**
   * Channels the MEMBERSHIP_UPDATED template will send on at this site once brand and location settings are applied. A member notification requested on any other channel is skipped, so the notify step offers only these.
   */
  memberNotificationChannels: (args: {
    siteId: ScalarsEnums['ID']
  }) => Array<ScalarsEnums['MessageType']>
  /**
   * Look up an existing member's home site (for the X-Site-ID header) by email, scoped to the caller's corporate
   */
  memberSiteByEmail: (args: { email: ScalarsEnums['String'] }) => Maybe<MemberSiteInfo>
  /**
   * Active member counts for a set of membership templates at a site
   */
  membershipActiveCounts: (args: {
    serviceTemplateIds: Array<ScalarsEnums['ID']>
    siteId: ScalarsEnums['ID']
  }) => MembershipActiveCountsResult
  /**
   * List active members on a membership template with credit usage
   */
  membershipActiveMembers: (args: {
    cursor?: Maybe<ScalarsEnums['String']>
    pageSize?: Maybe<ScalarsEnums['Float']>
    serviceTemplateId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => MembershipActiveMembersResult
  /**
   * Count the buyers of a membership or package template per status tab
   */
  membershipMemberStatusCounts: (args: {
    serviceTemplateId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => MembershipMemberStatusCounts
  /**
   * List the buyers of a membership or package template by status, with ledger credit usage
   */
  membershipMembers: (args: {
    cursor?: Maybe<ScalarsEnums['String']>
    pageSize?: Maybe<ScalarsEnums['Float']>
    serviceTemplateId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
    status: MembershipMemberStatusFilter
  }) => MembershipMembersResult
  /**
   * Generate a preview of what merging two clients would do
   */
  mergeClientsPreview: (args: { input: MergeClientsPreviewInput }) => MergeClientsPreview
  /**
   * Check if a client has been merged and return redirect info for the target client
   */
  mergedClientInfo: (args: { clientId: ScalarsEnums['String'] }) => MergedClientInfo
  /**
   * Get information about available messaging providers
   */
  messagingProviders: Array<ProviderInfo>
  /**
   * Get all import sessions belonging to a specific migration run
   */
  migrationSessions: (args: { migrationId: ScalarsEnums['ID'] }) => MigrationSessions
  /**
   * List all migration runs for a corporate, grouped by migrationId, newest first
   */
  migrations: (args: { corporateId: ScalarsEnums['ID'] }) => Migrations
  /**
   * Get mobile app branding configuration for a corporate (returns defaults if none configured)
   */
  mobileAppBranding: (args: { corporateId: ScalarsEnums['String'] }) => MobileAppBranding
  /**
   * Native change and build drift for a brand
   */
  mobileAppBuildOverview: (args: { brandId: ScalarsEnums['String'] }) => MobileAppBuildOverview
  /**
   * Get mobile app channels configuration (returns defaults if not configured)
   */
  mobileAppChannels: (args: { corporateId: ScalarsEnums['String'] }) => MobileAppChannels
  /**
   * Get mobile app configuration for corporate
   */
  mobileAppConfig: (args: { corporateId: ScalarsEnums['String'] }) => MobileSetupResponse
  /**
   * Whether this business may have a mobile app created for it from Admin, evaluated with the same per-corporate check the creation mutation applies
   */
  mobileAppCreateEnabled: (args: { corporateId: ScalarsEnums['String'] }) => ScalarsEnums['Boolean']
  /**
   * Get mobile app profile configuration (returns null if not configured)
   */
  mobileAppProfile: (args: { corporateId: ScalarsEnums['String'] }) => Maybe<MobileAppProfile>
  /**
   * Get sessions grouped by day for month view with configurable sessions per day limit
   */
  monthViewSessions: (args: {
    endDate: ScalarsEnums['String']
    filters?: Maybe<SessionQueryFiltersInput>
    sessionsPerDay?: Maybe<ScalarsEnums['Float']>
    siteId: ScalarsEnums['String']
    startDate: ScalarsEnums['String']
    status?: Maybe<ScalarsEnums['String']>
    timezone?: Maybe<ScalarsEnums['String']>
  }) => Array<MonthViewDay>
  /**
   * Whether the signed-in staff member has an approval PIN and whether it is locked
   */
  myApprovalPinStatus: ApprovalPinStatus
  /**
   * The signed-in staff member's private iCal feed URL for a location, or null when the feed is not enabled there
   */
  myCalendarFeedUrl: (args: { siteId: ScalarsEnums['String'] }) => Maybe<ScalarsEnums['String']>
  /**
   * The signed-in staff member's commission for a period (current by default)
   */
  myCommission: (args?: { commissionPeriodId?: Maybe<ScalarsEnums['ID']> }) => Maybe<MyCommission>
  /**
   * How the signed-in instructor receives class cover offers
   */
  myCoverPreferences: MyCoverPreferences
  /**
   * Class covers the signed-in instructor requested, is being covered on, or is covering
   */
  myCoverRequests: Array<CoverRequestView>
  /**
   * The ACTIVE family the signed-in member belongs to, with its members; null when they have none
   */
  myFamily: (args: { siteId: ScalarsEnums['ID'] }) => Maybe<Family>
  /**
   * Pending invitations for the signed-in member to join a family
   */
  myFamilyInvites: (args: { siteId: ScalarsEnums['ID'] }) => Array<FamilyInvite>
  /**
   * Get one outstanding form for the signed-in member to fill in
   */
  myFormSubmission: (args: { formSubmissionId: ScalarsEnums['String'] }) => MemberFormDetail
  /**
   * For an admin of an ACTIVE family: members who have left or been removed, with their confirmed future bookings paid with a family package; empty for anyone else
   */
  myFormerFamilyMemberBookings: (args: {
    siteId: ScalarsEnums['ID']
  }) => Array<FormerFamilyMemberBookings>
  /**
   * The signed-in member's own gift cards with balance, status and expiry, newest first
   */
  myGiftCards: (args: { siteId: ScalarsEnums['ID'] }) => Array<MemberGiftCard>
  /**
   * Everything the app needs before the calling member picks pause dates for their own membership: whether self-service pause applies, the blockers already in force, the yearly allowance used and remaining, the date rules and billing dates, the reasons the operator allows, the fee and pause type, and the add-ons that pause with it.
   */
  myMembershipPauseOptions: (args: {
    serviceId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => MemberPauseOptions
  /**
   * List the forms the signed-in member still has to complete at a location
   */
  myPendingForms: (args: {
    after?: Maybe<ScalarsEnums['String']>
    first?: Maybe<ScalarsEnums['Float']>
    siteId: ScalarsEnums['String']
  }) => MemberPendingFormsPage
  /**
   * Policies the signed-in member and every dependant they are an active guardian of still have to accept or sign at a location
   */
  myPendingPolicies: (args: { siteId: ScalarsEnums['ID'] }) => MyPendingPolicies
  /**
   * Credit-based packages shared with the authenticated member (recipient)
   */
  mySharedPackages: Array<MySharedPackage>
  /**
   * Get onboarding checklist progress for a corporate
   */
  onboardingProgress: (args: { corporateId: ScalarsEnums['ID'] }) => OnboardingProgress
  /**
   * Upcoming class covers the signed-in instructor can claim, or has claimed
   */
  openCoversForMe: (args?: {
    siteIds?: Maybe<Array<ScalarsEnums['ID']>>
  }) => Array<CoverRequestView>
  /**
   * An organisation's next consolidated charge and the card it will use
   */
  organisationBillingPreview: (args: {
    organisationClientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => OrganisationBillingPreview
  /**
   * Employees an organisation pays for
   */
  organisationEmployees: (args: {
    organisationClientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Array<OrganisationEmployee>
  /**
   * Staff who can approve a paper policy form at this location: active, allowed to approve there, with a usable approval PIN, excluding the signed-in recorder
   */
  paperFormApprovers: (args: { siteId: ScalarsEnums['ID'] }) => Array<PaperFormApprover>
  /**
   * Get an invoice by ID
   */
  payment: (args: { paymentId: ScalarsEnums['ID']; siteId: ScalarsEnums['ID'] }) => Payment
  /**
   * Get client secret for a payment that requires 3DS authentication
   */
  paymentClientSecret: (args: {
    clientId: ScalarsEnums['ID']
    invoiceId: ScalarsEnums['ID']
    paymentId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => PaymentClientSecret
  /**
   * Recovery options for a payment held for remote 3DS approval: whether the client can be emailed (masked address only), the approval link state, the deadline, and whether a card reader is available. Staff with retail access, or the member who owns the payment.
   */
  paymentRecovery: (args: {
    invoiceId: ScalarsEnums['ID']
    paymentId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => PaymentRecovery
  /**
   * Current state of a payment held for remote 3DS approval, read from the database for polling: held, succeeded, failed, expired or with_staff.
   */
  paymentRecoveryStatus: (args: {
    invoiceId: ScalarsEnums['ID']
    paymentId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => PaymentRecoveryStatus
  /**
   * OC-7: private booking requests awaiting staff confirmation for a site (PENDING on PRIVATE sessions), ordered by session start ascending. Powers the scheduler banner.
   */
  pendingBookingRequests: (args: { siteId: ScalarsEnums['ID'] }) => Array<PendingBookingRequest>
  /**
   * OC-7: count of booking requests awaiting staff confirmation for a site. Lightweight scalar for the scheduler banner on page load.
   */
  pendingBookingRequestsCount: (args: { siteId: ScalarsEnums['ID'] }) => ScalarsEnums['Float']
  /**
   * Client-cancellation cash refunds awaiting physical payout at the counter
   */
  pendingCashDrawerPayouts: (args: { siteId: ScalarsEnums['ID'] }) => Array<PendingCashDrawerPayout>
  /**
   * PENDING guest passes sent to a verified email, oldest first, each with its invite token. Reached only through the servers/api bridge, which passes the email verified by Firebase; empty when the email is null.
   */
  pendingGuestPassesForEmail: (args?: {
    verifiedEmail?: Maybe<ScalarsEnums['String']>
  }) => Array<PendingGuestPassForEmail>
  /**
   * Get the live status of one pending-items link and which of its items are done
   */
  pendingItemsHandoff: (args: { handoffId: ScalarsEnums['ID'] }) => PendingItemsHandoff
  /**
   * Who the send panel can address for a client: the client and each authorised guardian, with a masked mobile, text consent and whether their date of birth is verified
   */
  pendingItemsRecipients: (args: {
    clientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Array<PendingItemsRecipient>
  pendingKnowledgeArticleRevisionCount: ScalarsEnums['Int']
  pendingKnowledgeArticleRevisionForArticle: (args: {
    knowledgeArticleId: ScalarsEnums['ID']
  }) => Maybe<KnowledgeArticleRevision>
  /**
   * Get active policy templates that a client has not yet signed
   */
  pendingPolicies: (args: {
    clientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Array<SiteAgreementTemplate>
  /**
   * Get physical locations for a site
   */
  physicalLocations: (args: { siteId: ScalarsEnums['ID'] }) => Array<SiteLocation>
  /**
   * Who a bulk pending-items send from the compliance report would text, who it would skip and why, and the SMS credit cost (recipients x segments)
   */
  policyBulkSendPreview: (args: {
    clientIds?: Maybe<Array<ScalarsEnums['ID']>>
    equipmentCategory?: Maybe<PolicyEquipmentScope>
    search?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['ID']
    statuses?: Maybe<Array<EquipmentComplianceStatus>>
  }) => PolicyBulkSendPreview
  /**
   * Progress of one bulk pending-items send
   */
  policyBulkSendRun: (args: {
    runId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => PolicyBulkSendRun
  /**
   * Recent policy evidence exports for a location, newest first
   */
  policyEvidenceExports: (args: { siteId: ScalarsEnums['ID'] }) => Array<PolicyEvidenceExport>
  /**
   * Get POS categories for a site
   */
  posCategories: (args: { siteId: ScalarsEnums['ID'] }) => Array<CreatePosCategoryResponse>
  /**
   * Get a single POS product by ID with all variants and attributes
   */
  posProduct: (args: {
    posProductId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => UpdatePosProductResponse
  /**
   * Get activity logs for a product with staff user information
   */
  posProductActivityLogs: (args: {
    limit: ScalarsEnums['Int']
    posProductId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Array<PosProductActivityLogWithStaff>
  /**
   * Find product by SKU or barcode
   */
  posProductByCode: (args: {
    code: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => Maybe<UpdatePosProductResponse>
  /**
   * Find POS product-variable pairs (flattened) for table display
   */
  posProductVariablesFlat: (args: {
    categoryId?: Maybe<ScalarsEnums['ID']>
    cursor?: Maybe<ScalarsEnums['String']>
    featured?: Maybe<ScalarsEnums['Boolean']>
    isEnabledForSale?: Maybe<ScalarsEnums['Boolean']>
    limit: ScalarsEnums['Int']
    search?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['ID']
    status?: Maybe<PosProductStatus>
  }) => PosProductVariablesFlat
  /**
   * Find POS products with cursor-based pagination, search, and filters
   */
  posProducts: (args: {
    categoryId?: Maybe<ScalarsEnums['ID']>
    cursor?: Maybe<ScalarsEnums['String']>
    featured?: Maybe<ScalarsEnums['Boolean']>
    isEnabledForSale?: Maybe<ScalarsEnums['Boolean']>
    limit: ScalarsEnums['Int']
    search?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['ID']
    status?: Maybe<PosProductStatus>
  }) => PosProducts
  /**
   * Get stock adjustment history for a product variant
   */
  posStockAdjustments: (args: {
    limit: ScalarsEnums['Int']
    posProductVariableId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Array<PosStockAdjustment>
  /**
   * Preview the externalId → Client match rate for selected GCS-bundle ZIPs
   */
  previewGcsBundleMatch: (args: {
    corporateId: ScalarsEnums['ID']
    gcsUrls: Array<ScalarsEnums['String']>
    importType: ScalarsEnums['String']
  }) => PreviewGcsBundleMatch
  /**
   * Preview the proration amount for an immediate membership plan change. Returns null when no proration applies (downgrade or same price).
   */
  previewMembershipPlanChange: (args: {
    customPrice?: Maybe<ScalarsEnums['String']>
    serviceId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
    toServiceTemplateId: ScalarsEnums['ID']
  }) => PreviewMembershipPlanChangeResult
  /**
   * What pausing the calling member's own membership over the given dates will do to their billing: the payments skipped, the pause fee, the credit for unused days, the first charge after resume, the add-ons paused and any commitment change. Returns blockers instead of figures when the dates break a rule.
   */
  previewMyMembershipPause: (args: {
    input: MemberPauseWindowInput
    serviceId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => MemberPausePreview
  /**
   * What resuming the calling member's own paused membership will charge today. Returns null when the membership has no active pause.
   */
  previewMyMembershipResume: (args: {
    serviceId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Maybe<PreviewServiceResumeResult>
  /**
   * Price a candidate pre-sale opening-date move without applying it. Returns the shortfall the member would owe (opening pulled forward) or the overpayment to be credited (opening delayed); both null when the move costs nothing. Drives the charge-or-absorb prompt.
   */
  previewPresaleDateShift: (args: {
    input: PreviewPresaleDateShiftInput
    siteId: ScalarsEnums['ID']
  }) => PresaleDateShiftPreview
  /**
   * Preview a PRORATED pause before it is created: the entry-cycle credit, whether that cycle was paid, the grid-aligned next billing date, the cycles deferred, and the basis the Pause summary renders — the credit method, the unused days or credits the credit was sized from, the first invoice after resume before and after every outstanding credit lands on it, and whether leftover credit converts to account credit. Returns null when the membership has no primary recurring invoice; a null on any summary field means that figure is not determinable for this pause. commitmentExtensionDays is always null here: a PRORATED pause never shifts the credit allocation dates, so the extension the cancellation gate would project for it evaporates at activation (round-7 A11).
   */
  previewProratedSuspension: (args: {
    endDate?: Maybe<ScalarsEnums['String']>
    serviceId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
    startDate: ScalarsEnums['String']
  }) => Maybe<PreviewProratedSuspensionResult>
  /**
   * Quote a membership cancellation before it is booked: the effective date from the template policy (notice period and effective-date rule), the tenure-based or flat cancellation fee, the bill dates still charged before the effective date, and any blocker. Pass effectiveDate to quote a date chosen instead of the policy date. Staff need the service-cancellation permission; a member can only quote their own membership.
   */
  previewServiceCancellation: (args: {
    asOf?: Maybe<ScalarsEnums['String']>
    cancelAt?: Maybe<ScalarsEnums['String']>
    effectiveDate?: Maybe<ScalarsEnums['String']>
    serviceId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => PreviewServiceCancellationResult
  /**
   * What resuming a membership will charge and settle, quoted before staff confirm: the prorated re-entry charge, the credit applied to it, what remains, and whether that remainder converts to account credit. Returns null when the membership is not suspended.
   */
  previewServiceResume: (args: {
    restartDate?: Maybe<ScalarsEnums['String']>
    serviceId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Maybe<PreviewServiceResumeResult>
  /**
   * Preview the RECURRING suspension fee for a pause that has not been created yet: every date it will bill on, the per-charge amount and the total. Returns null when the pause crosses no billing date, so it costs nothing. An indefinite pause returns an empty billingDates with a null occurrences and total, because its length is not knowable until it is resumed.
   */
  previewSuspensionFee: (args: {
    chargeAmount: ScalarsEnums['String']
    endDate?: Maybe<ScalarsEnums['String']>
    feeBillingCycleAmount?: Maybe<ScalarsEnums['Float']>
    feeBillingCycleUnit?: Maybe<ScalarsEnums['String']>
    serviceId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
    startDate: ScalarsEnums['String']
  }) => Maybe<PreviewSuspensionFeeResult>
  /**
   * Quote every pause in a composed set at once, each against the billing schedule the pauses before it leave behind. One query rather than N because a per-pause component would price every pause against the LIVE dates, so pause #2 would be quoted as though pause #1 did not exist. Each entry carries the caller's own index, and isEstimate is true for any pause that has not activated — a later pause in the set, or one starting after the site's today.
   */
  previewSuspensionPlan: (args: {
    pauses: Array<PreviewSuspensionPlanPauseInput>
    serviceId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => PreviewSuspensionPlanResult
  /**
   * Preview what a pause does to the membership's secondary recurring fee. Returns null when the membership has no secondary fee.
   */
  previewSuspensionSecondaryFee: (args: {
    endDate?: Maybe<ScalarsEnums['String']>
    serviceId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
    startDate: ScalarsEnums['String']
    suspensionType?: Maybe<ServiceSuspensionType>
  }) => Maybe<PreviewSuspensionSecondaryFeeResult>
  /**
   * Preview a TIME_SHIFT pause before it is created: the date the next charge moves to, and how many days the pause pushes out the earliest date the membership can be cancelled. Returns null when the membership has no primary recurring invoice. A null nextBillingDate means the pause is indefinite, so the shifted date is not yet knowable; a null commitmentExtensionDays means the membership has no minimum term, or the pause is indefinite. This is the only preview that quotes a commitment extension — a PRORATED pause never shifts the credit allocation dates, so the extension the cancellation gate would project for it evaporates at activation (round-7 A11).
   */
  previewTimeShiftSuspension: (args: {
    endDate?: Maybe<ScalarsEnums['String']>
    serviceId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
    startDate: ScalarsEnums['String']
  }) => Maybe<PreviewTimeShiftSuspensionResult>
  /**
   * Get a promo code by ID
   */
  promoCode: (args: { promoCodeId: ScalarsEnums['ID'] }) => Maybe<PromoCode>
  /**
   * Get a promo code by code string
   */
  promoCodeByCode: (args: {
    code: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => Maybe<PromoCode>
  /**
   * List promo codes for a site with cursor-based pagination, filtering, and sorting
   */
  promoCodes: (args: {
    cursor?: Maybe<ScalarsEnums['String']>
    discountType?: Maybe<PromoCodeDiscountType>
    endDateFrom?: Maybe<ScalarsEnums['String']>
    endDateTo?: Maybe<ScalarsEnums['String']>
    limit: ScalarsEnums['Int']
    search?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['ID']
    sort?: Maybe<PromoCodeSort>
    startDateFrom?: Maybe<ScalarsEnums['String']>
    startDateTo?: Maybe<ScalarsEnums['String']>
    status?: Maybe<PromoCodeStatus>
  }) => PromoCodes
  /**
   * Get rebate template by ID
   */
  rebateTemplate: (args: { id: ScalarsEnums['ID'] }) => RebateTemplate
  /**
   * Get all rebate templates across all sites
   */
  rebateTemplates: (args: {
    cursor?: Maybe<ScalarsEnums['String']>
    orderBy: Array<RebateTemplatesOrderByInput>
    pageSize?: Maybe<ScalarsEnums['Float']>
    search?: Maybe<ScalarsEnums['String']>
  }) => RebateTemplates
  /**
   * Get recent webhook deliveries across all webhooks for a corporate
   */
  recentWebhookDeliveries: (args: {
    corporateId: ScalarsEnums['String']
    pagination?: Maybe<AuditEventsPaginationInput>
    siteId?: Maybe<ScalarsEnums['String']>
  }) => AuditQueryResult
  /**
   * Pattern lineage summary for a clicked session, used by the Edit and Cancel dialogs to render the bounded vs unbounded THIS_AND_FUTURE option. Returns null when the session is not part of a recurring pattern.
   */
  recurringPatternBoundaries: (args: {
    sessionId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Maybe<RecurringPatternBoundaries>
  /**
   * Get all bookable instances of a recurring session within the booking window
   */
  recurringSessionInstances: (args: {
    recurringSessionsId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => RecurringSessionInstancesResponse
  /**
   * Get the clientId who referred this client at a given site, or null if not referred
   */
  referredBy: (args: {
    clientId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Maybe<ReferredBy>
  /**
   * Get a refund by ID
   */
  refund: (args: { refundId: ScalarsEnums['ID']; siteId: ScalarsEnums['ID'] }) => Refund
  /**
   * Get region by ID
   */
  region: (args: { regionId: ScalarsEnums['ID'] }) => Maybe<Regions>
  /**
   * Get all regions for current brand
   */
  regions: Array<Regions>
  /**
   * One customer-visible release note with its help docs and related notes
   */
  releaseHubNote: (args: {
    siteId?: Maybe<ScalarsEnums['ID']>
    slug: ScalarsEnums['String']
  }) => Maybe<ReleaseHubNote>
  /**
   * Customer-visible release notes released in the given months (YYYY-MM), optionally with Coming soon notes
   */
  releaseHubNotes: (args: {
    includeComingSoon?: Maybe<ScalarsEnums['Boolean']>
    months: Array<ScalarsEnums['String']>
    siteId?: Maybe<ScalarsEnums['ID']>
  }) => Array<ReleaseHubNote>
  /**
   * Month counts for the What's new rail, plus how many Coming soon notes exist
   */
  releaseHubRail: (args?: { siteId?: Maybe<ScalarsEnums['ID']> }) => ReleaseHubRail
  releaseNote: (args?: {
    releaseNoteId?: Maybe<ScalarsEnums['ID']>
    slug?: Maybe<ScalarsEnums['String']>
  }) => Maybe<ReleaseNote>
  releaseNoteStats: ReleaseNoteStats
  releaseNoteTranslation: (args: {
    locale: ScalarsEnums['String']
    releaseNoteId: ScalarsEnums['ID']
  }) => Maybe<ReleaseNoteTranslation>
  releaseNoteTranslations: (args: {
    releaseNoteId: ScalarsEnums['ID']
  }) => Array<ReleaseNoteTranslation>
  releaseNotes: (args?: {
    filter?: Maybe<ReleaseNoteFilterInput>
    pagination?: Maybe<PaginationInput>
  }) => ReleaseNotesResponse
  releaseNotesForUser: (args: {
    includeReadStatus?: Maybe<ScalarsEnums['Boolean']>
    pagination?: Maybe<PaginationInput>
    releaseType?: Maybe<ReleaseNoteType>
    userContext: UserContextInput
  }) => Array<ReleaseNote>
  /**
   * Get a single report definition with dynamic columns resolved for the given sites
   */
  reportDefinition: (args: { input: ReportDefinitionInputInput }) => ReportDefinition
  /**
   * Resolve the destination service template for a Member Movement candidate — persisted mapping, then exact-name auto-match, then NOMINATED_DEFAULT, else unresolved
   */
  resolveMovementTemplate: (args: {
    destinationSiteId: ScalarsEnums['ID']
    sourceServiceTemplateId: ScalarsEnums['ID']
  }) => ResolveMovementTemplate
  /**
   * Get resolved custom text for a language (DB overrides + member.json defaults)
   */
  resolvedCustomText: (args: {
    corporateId: ScalarsEnums['String']
    language: ScalarsEnums['String']
  }) => ResolvedCustomText
  /**
   * Get a room custom property requirement by ID
   */
  roomCustomPropertyRequirement: (args: {
    roomResourceTemplateId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
    siteRoomResourceTemplatePropertyId: ScalarsEnums['String']
  }) => Maybe<SiteRoomResourceTemplateProperty>
  /**
   * List all room custom property requirements for a template
   */
  roomCustomPropertyRequirements: (args: {
    roomResourceTemplateId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Array<SiteRoomResourceTemplateProperty>
  /**
   * Get a room resource template by ID
   */
  roomResourceTemplate: (args: {
    id: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Maybe<SiteRoomResourceTemplateResponse>
  /**
   * Get a room resource template by ID for session detail views
   */
  roomResourceTemplateForSession: (args: {
    id: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Maybe<SiteRoomResourceTemplateResponse>
  /**
   * List all room resource templates for a site
   */
  roomResourceTemplates: (args: {
    siteId: ScalarsEnums['String']
  }) => Array<SiteRoomResourceTemplateResponse>
  /**
   * Get royalties and fees template by ID
   */
  royaltiesAndFeesTemplate: (args: { id: ScalarsEnums['ID'] }) => RoyaltiesAndFeesTemplate
  /**
   * Get all royalties and fees templates across all sites
   */
  royaltiesAndFeesTemplates: (args: {
    cursor?: Maybe<ScalarsEnums['String']>
    orderBy: Array<RoyaltiesAndFeesTemplatesOrderByInput>
    pageSize?: Maybe<ScalarsEnums['Float']>
    search?: Maybe<ScalarsEnums['String']>
  }) => RoyaltiesAndFeesTemplates
  /**
   * Execute a report with filters, pagination, and column selection
   */
  runReport: (args: { input: RunReportInputInput }) => RunReport
  /**
   * Paginated brands from prod BigQuery admin_dwh_datastream.Corporates. Defaults to active brands.
   */
  sandboxBrands: (args: {
    brandStatus?: Maybe<BrandStatus>
    offset: ScalarsEnums['Float']
    pageSize: ScalarsEnums['Float']
    sandboxStatus?: Maybe<SandboxStatusFilter>
    search?: Maybe<ScalarsEnums['String']>
  }) => SandboxBrands
  /**
   * Get the latest sandbox job for a brand
   */
  sandboxLatestJob: (args: { brandSlug: ScalarsEnums['String'] }) => Maybe<SandboxMigrationJob>
  /**
   * Get a sandbox migration job by ID
   */
  sandboxMigrationJob: (args: { jobId: ScalarsEnums['String'] }) => Maybe<SandboxMigrationJob>
  /**
   * Get a single saved report by ID
   */
  savedReport: (args: { savedReportId: ScalarsEnums['String'] }) => SavedReport
  /**
   * List saved report categories for the current corporate, filtered by visibility targeting
   */
  savedReportCategories: (args?: {
    siteId?: Maybe<ScalarsEnums['String']>
  }) => Array<SavedReportCategories>
  /**
   * List all saved reports for the current corporate. Corporate admins receive targeting metadata.
   */
  savedReports: (args?: { siteId?: Maybe<ScalarsEnums['String']> }) => Array<SavedReports>
  /**
   * List all scheduled invoices (single + recurring) for a site with unified pagination, search, and filtering. Returns both materialized and virtual future invoices.
   */
  scheduledInvoices: (args: {
    input: ListAllScheduledInvoicesInput
    siteId: ScalarsEnums['ID']
  }) => ListAllScheduledInvoicesResult
  /**
   * How many members a push audience would reach at the site right now
   */
  scheduledPushAudiencePreview: (args: {
    audienceType: ScheduledPushAudienceType
    sessionId?: Maybe<ScalarsEnums['ID']>
    siteId: ScalarsEnums['ID']
  }) => ScheduledPushAudiencePreview
  /**
   * Push notifications scheduled or sent for a site, newest send time first
   */
  scheduledPushSends: (args: { siteId: ScalarsEnums['ID'] }) => Array<ScheduledPushSend>
  /**
   * Count the pending unscored assignments that turning on scoring would withdraw
   */
  scoringConversionPreview: (args: {
    siteFormId: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => ScoringConversionPreview
  /**
   * Search Google Fonts API with pagination (1000+ fonts)
   */
  searchGoogleFonts: (args: {
    limit: ScalarsEnums['Float']
    offset: ScalarsEnums['Float']
    search: ScalarsEnums['String']
  }) => SearchGoogleFonts
  /**
   * Search HubSpot companies
   */
  searchHubSpotCompanies: (args?: {
    limit?: Maybe<ScalarsEnums['Int']>
    query?: Maybe<ScalarsEnums['String']>
  }) => HubSpotCompaniesSearchResult
  searchKnowledge: (args: { input: KnowledgeSearchInput }) => KnowledgeSearchResponse
  /**
   * Hybrid search: Vertex semantic + fresh Spanner matches, deduped by slug
   */
  searchKnowledgeArticles: (args: {
    limit?: Maybe<ScalarsEnums['Int']>
    publishedOnly?: Maybe<ScalarsEnums['Boolean']>
    search: ScalarsEnums['String']
  }) => Array<KnowledgeArticle>
  /**
   * Get a service by ID
   */
  service: (args: { serviceId: ScalarsEnums['String'] }) => Maybe<Service>
  /**
   * Get credit adjustment notes history for a service. Used by UpdateCreditsDialog notes history view.
   */
  serviceCreditAdjustmentNotes: (args: {
    cursor?: Maybe<ScalarsEnums['String']>
    pageSize?: Maybe<ScalarsEnums['Float']>
    serviceId: ScalarsEnums['String']
  }) => CreditAdjustmentNotesResult
  /**
   * Get all billing periods with credit allocation data for a service. Used by Credits Summary dialog. Optionally filter by session type.
   */
  serviceCreditSummaryPeriods: (args: {
    serviceId: ScalarsEnums['String']
    siteSessionTypeId?: Maybe<ScalarsEnums['String']>
    siteSessionTypeIds?: Maybe<Array<ScalarsEnums['String']>>
  }) => CreditSummaryResult
  /**
   * Get credit usage history for a service. Used by Visits History dialog.
   */
  serviceCreditUsageHistory: (args: {
    cursor?: Maybe<ScalarsEnums['String']>
    pageSize?: Maybe<ScalarsEnums['Float']>
    serviceId: ScalarsEnums['String']
  }) => CreditUsageHistoryResult
  /**
   * Get a service template by ID
   */
  serviceTemplate: (args: { serviceTemplateId: ScalarsEnums['String'] }) => Maybe<ServiceTemplate>
  /**
   * The ACTIVE parent templates each add-on template is enabled on, named — the New Sale ineligibility warning (OC-880). Gated on access__retail so a seller without add-on settings access still gets it.
   */
  serviceTemplateAddOnEligibleParents: (args: {
    addOnServiceTemplateIds: Array<ScalarsEnums['ID']>
    siteId: ScalarsEnums['ID']
  }) => Array<ServiceTemplateAddOnEligibleParent>
  /**
   * An add-on template's parent attachments (price/payment type per parent)
   */
  serviceTemplateAddOnParents: (args: {
    addOnServiceTemplateId: ScalarsEnums['String']
  }) => Array<ServiceTemplateAddOn>
  /**
   * List a membership's or package's add-on price per price group
   */
  serviceTemplateAddOnPriceGroupPrices: (args: {
    serviceTemplateId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Array<AddOnPriceGroupPrice>
  /**
   * Add-Ons list-page enrichment: parent attachments and ACTIVE service count per add-on template, batched per page
   */
  serviceTemplateAddOnSummaries: (args: {
    addOnServiceTemplateIds: Array<ScalarsEnums['String']>
    siteId: ScalarsEnums['String']
  }) => Array<ServiceTemplateAddOnSummary>
  /**
   * Enabled add-on attachments for a set of parent templates, enriched with the add-on template's display fields — the New Sale eligibility read (OC-880). FE groups by parentServiceTemplateId.
   */
  serviceTemplateAddOnsForParents: (args: {
    parentServiceTemplateIds: Array<ScalarsEnums['ID']>
    siteId: ScalarsEnums['ID']
  }) => Array<ServiceTemplateAddOnForParent>
  /**
   * Get service template categories for a site
   */
  serviceTemplateCategories: (args: {
    siteId: ScalarsEnums['String']
  }) => Array<CreateServiceTemplateCategoryResponse>
  /**
   * Lean active, online-sale-enabled service-template options (id/name/type/category/site, no credits) for the CMS content editor package pickers. Templates belonging to an inactive or deleted location are excluded (MEM-388).
   */
  serviceTemplateOptions: (args?: {
    siteIds?: Maybe<Array<ScalarsEnums['String']>>
  }) => Array<ServiceTemplateOption>
  /**
   * List add-on pricing configurations for a site
   */
  serviceTemplateSessionTypeAddOns: (args: {
    siteId: ScalarsEnums['ID']
  }) => Array<ServiceTemplateSessionTypeAddOn>
  /**
   * List service templates, optionally filtered by site IDs, type, status, category, search, and intro offer
   */
  serviceTemplates: (args?: {
    categoryId?: Maybe<ScalarsEnums['String']>
    isIntroOffer?: Maybe<ScalarsEnums['Boolean']>
    search?: Maybe<ScalarsEnums['String']>
    serviceTemplateIds?: Maybe<Array<ScalarsEnums['String']>>
    siteIds?: Maybe<Array<ScalarsEnums['String']>>
    status?: Maybe<ServiceTemplateStatus>
    type?: Maybe<ServiceTemplateType>
  }) => Array<ServiceTemplate>
  /**
   * List service templates with cursor-based pagination, search, and filtering by site, type, status, and category
   */
  serviceTemplatesPaginated: (args?: {
    categoryId?: Maybe<ScalarsEnums['String']>
    cursor?: Maybe<ScalarsEnums['String']>
    isIntroOffer?: Maybe<ScalarsEnums['Boolean']>
    orderBy?: Maybe<Array<ServiceTemplatesPaginatedOrderByInput>>
    pageSize?: Maybe<ScalarsEnums['Float']>
    search?: Maybe<ScalarsEnums['String']>
    siteId?: Maybe<ScalarsEnums['String']>
    siteIds?: Maybe<Array<ScalarsEnums['String']>>
    status?: Maybe<ServiceTemplateStatus>
    type?: Maybe<ServiceTemplateType>
  }) => ServiceTemplatesPaginated
  /**
   * Get a session by ID
   */
  session: (args: { id: ScalarsEnums['String']; siteId: ScalarsEnums['String'] }) => Maybe<Session>
  /**
   * Preview what deleting a session (scope single) or it and its later occurrences (scope future) would remove: session, booking, booked-member and waitlist counts
   */
  sessionDeletionPreview: (args: { input: SessionDeletionPreviewInput }) => SessionDeletionPreview
  /**
   * Get session feedback by ID at a site; staff only, requires session-feedback-config-enabled
   */
  sessionFeedback: (args: {
    sessionFeedbackId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Maybe<SessionFeedback>
  /**
   * Get session feedback for a specific attendance at a site; staff only, requires session-feedback-config-enabled
   */
  sessionFeedbackByAttendanceId: (args: {
    attendanceId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Maybe<SessionFeedback>
  /**
   * Get a client's session feedback history at a site; staff or the member themselves, requires session-feedback-config-enabled
   */
  sessionFeedbackByClientId: (args: {
    clientId: ScalarsEnums['ID']
    limit?: Maybe<ScalarsEnums['Float']>
    siteId: ScalarsEnums['ID']
  }) => Array<SessionFeedback>
  /**
   * Get all feedback for a session at a site; staff only, requires session-feedback-config-enabled
   */
  sessionFeedbackBySessionId: (args: {
    sessionId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Array<SessionFeedback>
  /**
   * List a site's configured session feedback questions
   */
  sessionFeedbackQuestions: (args: { siteId: ScalarsEnums['ID'] }) => Array<SessionFeedbackQuestion>
  /**
   * The member's feedback status for each of the given sessions, by the same rules as lastAttendanceFeedback; requires session-feedback-config-enabled
   */
  sessionFeedbackStatuses: (args: {
    clientId: ScalarsEnums['ID']
    sessionIds: Array<ScalarsEnums['ID']>
  }) => Array<SessionFeedbackStatusEntry>
  /**
   * The no-show and late-cancel fee a session charges, resolved exactly as the charge path does
   */
  sessionFees: (args: { sessionId: ScalarsEnums['ID']; siteId: ScalarsEnums['ID'] }) => SessionFees
  /**
   * Get a session filter by ID
   */
  sessionFilter: (args: {
    sessionFilterId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Maybe<SessionFilter>
  /**
   * Get all session filters for a site
   */
  sessionFilters: (args: { siteId: ScalarsEnums['String'] }) => Array<SessionFilter>
  /**
   * Get a session template by ID
   */
  sessionTemplate: (args: {
    id: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Maybe<SessionTemplate>
  /**
   * List the session-feedback questions selected for a schedule template, in order
   */
  sessionTemplateFeedbackQuestions: (args: {
    sessionTemplateId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Array<SessionFeedbackQuestion>
  /**
   * List session templates for a site with cursor-based pagination
   */
  sessionTemplates: (args: {
    category?: Maybe<SessionCategory>
    cursor?: Maybe<ScalarsEnums['String']>
    pageSize?: Maybe<ScalarsEnums['Float']>
    search?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['String']
    siteSessionTypeId?: Maybe<ScalarsEnums['String']>
    sortByDisplayOrder?: Maybe<ScalarsEnums['Boolean']>
  }) => SessionTemplatePaginationResult
  /**
   * Get count of waitlist entries for a session
   */
  sessionWaitlistCount: (args: {
    sessionId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => ScalarsEnums['Float']
  /**
   * Get all waitlist entries for a specific session
   */
  sessionWaitlistEntries: (args: {
    sessionId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Array<SessionWaitlistEntry>
  /**
   * Get all sessions within a date range
   */
  sessions: (args: {
    endDate: ScalarsEnums['String']
    filters?: Maybe<SessionQueryFiltersInput>
    limit?: Maybe<ScalarsEnums['Float']>
    offset?: Maybe<ScalarsEnums['Float']>
    siteId: ScalarsEnums['String']
    startDate: ScalarsEnums['String']
    status?: Maybe<ScalarsEnums['String']>
  }) => Array<Session>
  /**
   * Get paginated sessions for a single day with cursor-based pagination
   */
  sessionsForDay: (args: {
    cursor?: Maybe<ScalarsEnums['String']>
    date: ScalarsEnums['String']
    filters?: Maybe<SessionQueryFiltersInput>
    limit?: Maybe<ScalarsEnums['Float']>
    siteId: ScalarsEnums['String']
    status?: Maybe<ScalarsEnums['String']>
    timezone?: Maybe<ScalarsEnums['String']>
  }) => DaySessionsPage
  /**
   * Find non-block-slot sessions that overlap with a time range
   */
  sessionsInTimeRange: (args: {
    endTime: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
    siteLocationRoomId?: Maybe<ScalarsEnums['String']>
    staffUserIds?: Maybe<Array<ScalarsEnums['String']>>
    startTime: ScalarsEnums['String']
  }) => Array<Session>
  /**
   * Get sessions within a date range with offset-based pagination and total count
   */
  sessionsPaginated: (args: {
    endDate: ScalarsEnums['String']
    filters?: Maybe<SessionQueryFiltersInput>
    limit: ScalarsEnums['Float']
    offset: ScalarsEnums['Float']
    siteId: ScalarsEnums['String']
    startDate: ScalarsEnums['String']
    status?: Maybe<ScalarsEnums['String']>
  }) => SessionsPage
  /**
   * Clients a member can pick as a shared-credit recipient — scoped to the site, widening to the whole corporate when corporate client lookup is on
   */
  shareableClients: (args: {
    search: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => Array<ShareableClient>
  /**
   * Read-only share-link check (does NOT consume the token) plus the owner name and a freshly signed profile image (recipient, mobile)
   */
  sharedCreditInviteContext: (args: {
    inviteToken: ScalarsEnums['String']
  }) => SharedCreditInviteContext
  /**
   * Whether each candidate recipient belongs to a location where the package can be used (OC-8 #11)
   */
  sharedCreditRecipientEligibility: (args: {
    clientIds: Array<ScalarsEnums['ID']>
    serviceId: ScalarsEnums['ID']
  }) => Array<SharedCreditRecipientEligibility>
  /**
   * Recipients of a shared package with allocation and derived credits consumed
   */
  sharedCreditsDetails: (args: { serviceId: ScalarsEnums['ID'] }) => Array<SharedCreditsDetail>
  /**
   * Owner view of a shared package: its recipients and how credits were used
   */
  sharedPackageDetails: (args: { serviceId: ScalarsEnums['ID'] }) => SharedPackageDetails
  /**
   * Shared-credit activity log between a client and a related counterparty
   */
  sharedRelationActivity: (args: {
    clientId: ScalarsEnums['ID']
    counterpartyClientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Array<SharedRelationActivityEntry>
  /**
   * Short-TTL signed URL for the frozen signed-agreement PDF. Null when the agreement has no flattened PDF yet (pre-rollout rows or before the deferred activation-flatten completes).
   */
  signedAgreementPdfUrl: (args: {
    agreementId: ScalarsEnums['ID']
    clientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Maybe<ScalarsEnums['String']>
  /**
   * The client's signed POLICY agreements (siteAgreementTemplateId + dates)
   */
  signedPolicyAgreements: (args: {
    clientId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Array<SignedPolicyAgreements>
  /**
   * Get a site by its ID
   */
  site: (args: { siteId: ScalarsEnums['ID'] }) => Maybe<Site>
  /**
   * Get a site access point by ID
   */
  siteAccessPoint: (args: {
    siteAccessPointId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => SiteAccessPoint
  /**
   * Get credential fields required for a provider
   */
  siteAccessPointCredentialSchema: (args: {
    provider: DoorProvider
    siteId: ScalarsEnums['String']
  }) => Array<CredentialField>
  /**
   * Live reachability status for a site’s access point devices
   */
  siteAccessPointDeviceStatuses: (args: {
    siteId: ScalarsEnums['String']
  }) => Array<SiteAccessPointDeviceStatus>
  /**
   * Configuration currently active on an access point’s physical device
   */
  siteAccessPointLiveDeviceConfig: (args: {
    siteAccessPointId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => SiteAccessPointLiveDeviceConfig
  /**
   * List all access points for a site
   */
  siteAccessPoints: (args: { siteId: ScalarsEnums['String'] }) => Array<SiteAccessPoint>
  /**
   * List all access zones for a site
   */
  siteAccessZones: (args: { siteId: ScalarsEnums['String'] }) => Array<SiteAccessZone>
  /**
   * Get a single accounting code by ID
   */
  siteAccountCode: (args: {
    accountCodeId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Maybe<SiteAccountCode>
  /**
   * Count + list of service templates currently referencing an account code (powers the DD-009 deactivate / value-edit warning modals)
   */
  siteAccountCodeTemplatesInUse: (args: {
    accountCodeId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => TemplatesUsingAccountCodeResult
  /**
   * List the accounting codes for a site (active + inactive, excludes hard-deleted)
   */
  siteAccountCodes: (args: { siteId: ScalarsEnums['ID'] }) => Array<SiteAccountCode>
  /**
   * Alerts a location is showing right now, urgent first then newest
   */
  siteActiveAlerts: (args: { siteId: ScalarsEnums['String'] }) => SiteActiveAlerts
  /**
   * List only active terminal readers ordered by name
   */
  siteActiveTerminalReaders: (args: { siteId: ScalarsEnums['ID'] }) => Array<SiteTerminalReader>
  /**
   * Whether reservations from an aggregator provider that name no spot are placed on the first free spot at this site
   */
  siteAggregatorAutoAssignSpot: (args: {
    aggregatorProviderId: ScalarsEnums['String']
    siteId: ScalarsEnums['ID']
  }) => ScalarsEnums['Boolean']
  /**
   * A location's active agreement templates, ordered by name
   */
  siteAgreementTemplates: (args: { siteId: ScalarsEnums['ID'] }) => Array<SiteAgreementTemplate>
  /**
   * Active, scheduled and recently ended location alerts: active first, then scheduled by start, then ended newest first
   */
  siteAlerts: (args: { siteId: ScalarsEnums['String'] }) => Array<SiteAlertListItem>
  /**
   * Get audit events for a specific site
   */
  siteAuditEvents: (args: {
    corporateId: ScalarsEnums['String']
    filter?: Maybe<SiteAuditEventsFilterInput>
    pagination?: Maybe<AuditEventsPaginationInput>
    siteId: ScalarsEnums['String']
    sort?: Maybe<AuditEventsSortInput>
  }) => AuditQueryResult
  /**
   * Get aggregate challenge stats across all challenges for a site
   */
  siteChallengeOverview: (args: { siteId: ScalarsEnums['ID'] }) => SiteChallengeOverview
  /**
   * Get statistics for a client at a site
   */
  siteClientStats: (args: { siteId: ScalarsEnums['String'] }) => ClientSiteStatsResponse
  /**
   * Get all clients for a specific site
   */
  siteClients: (args: { siteId: ScalarsEnums['String'] }) => SiteClientsResponse
  /**
   * A site duplicate job of this brand, with its progress and outcome
   */
  siteCloneJob: (args: { siteCloneJobId: ScalarsEnums['ID'] }) => SiteCloneJob
  /**
   * How many rows of each configuration area a duplicate of this site would copy
   */
  siteCloneManifest: (args: { siteId: ScalarsEnums['ID'] }) => SiteCloneManifest
  /**
   * Sessions that a temporary closure between two instants would cancel
   */
  siteClosureSessionsPreview: (args: {
    from: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
    to: ScalarsEnums['String']
  }) => Array<SiteClosureSession>
  /**
   * Active or scheduled temporarily-closed alerts overlapping a site-local date range, for the schedule
   */
  siteClosures: (args: {
    endDate: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
    startDate: ScalarsEnums['String']
  }) => Array<SiteClosure>
  /**
   * Get a site communication template by siteId and alias
   */
  siteCommunicationTemplate: (args: {
    alias: CommunicationTemplateAliases
    siteId: ScalarsEnums['ID']
  }) => SiteCommunicationTemplate
  /**
   * Get a site communication template by ID
   */
  siteCommunicationTemplateById: (args: {
    siteCommunicationTemplateId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Maybe<SiteCommunicationTemplateById>
  /**
   * Render the final email HTML a site communication template would send, with sample placeholder values, without sending it
   */
  siteCommunicationTemplateEmailPreview: (args: {
    alias: CommunicationTemplateAliases
    emailBody?: Maybe<ScalarsEnums['String']>
    emailSubject?: Maybe<ScalarsEnums['String']>
    emailUseHapanaLayout?: Maybe<ScalarsEnums['Boolean']>
    siteId: ScalarsEnums['ID']
  }) => SiteCommunicationTemplateEmailPreview
  /**
   * Get available placeholders for site communication templates
   */
  siteCommunicationTemplatePlaceholders: (args: {
    siteId: ScalarsEnums['ID']
  }) => Array<ScalarsEnums['String']>
  /**
   * List site communication templates with pagination
   */
  siteCommunicationTemplates: (args: {
    activeCommunicationType?: Maybe<SiteCommunicationTemplatesActiveCommunicationTypeInput>
    alias?: Maybe<CommunicationTemplateAliases>
    cursor?: Maybe<ScalarsEnums['String']>
    pageSize?: Maybe<ScalarsEnums['Float']>
    search?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['ID']
  }) => SiteCommunicationTemplatePaginationResultSchema
  /**
   * Class cover settings for a location, with the brand defaults it inherits
   */
  siteCoverSettings: (args: { siteId: ScalarsEnums['ID'] }) => SiteCoverSettings
  /**
   * Get custom third-party integrations configuration for a site
   */
  siteCustomIntegrations: (args: { siteId: ScalarsEnums['ID'] }) => Array<SiteCustomIntegrations>
  /**
   * List active devices paired to a site (Check-In Agents and kiosks) with their kind, capabilities, liveness and busy state.
   */
  siteDevices: (args: { siteId: ScalarsEnums['String'] }) => SiteDevices
  /**
   * Paginated door access event log for a site
   */
  siteDoorAccessEvents: (args: {
    clientId?: Maybe<ScalarsEnums['String']>
    cursor?: Maybe<ScalarsEnums['String']>
    endDate?: Maybe<ScalarsEnums['String']>
    pageSize?: Maybe<ScalarsEnums['Float']>
    search?: Maybe<ScalarsEnums['String']>
    siteAccessPointId?: Maybe<ScalarsEnums['String']>
    siteAccessZoneId?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['String']
    sortDirection?: Maybe<SortDirection>
    sortField?: Maybe<DoorAccessEventSortField>
    startDate?: Maybe<ScalarsEnums['String']>
  }) => SiteDoorAccessEvents
  /**
   * Get aggregator provider IDs enabled for a site
   */
  siteEnabledAggregatorProviderIds: (args: {
    siteId: ScalarsEnums['ID']
  }) => Array<ScalarsEnums['String']>
  /**
   * What this location is entitled to: its effective plan, the features that plan grants, and the themes it could buy. Reports everything enabled while product tiering is switched off for the brand.
   */
  siteEntitlements: (args: { siteId: ScalarsEnums['ID'] }) => SiteEntitlements
  /**
   * Get a site form by ID
   */
  siteForm: (args: { id: ScalarsEnums['String']; siteId: ScalarsEnums['ID'] }) => Maybe<SiteForm>
  /**
   * List the Hapana form templates a location can create a form from
   */
  siteFormTemplates: (args: { siteId: ScalarsEnums['ID'] }) => Array<SiteFormTemplate>
  /**
   * List all site forms for a site
   */
  siteForms: (args: { siteId: ScalarsEnums['ID'] }) => Array<SiteForm>
  /**
   * Get a site group by its ID
   */
  siteGroup: (args: { siteGroupId: ScalarsEnums['ID'] }) => SiteGroup
  /**
   * The brand memberships, packages and add-ons that target a site group
   */
  siteGroupBrandServiceTemplateNames: (args: {
    siteGroupId: ScalarsEnums['ID']
  }) => Array<BrandServiceTemplateName>
  /**
   * The live brand memberships, packages and add-ons a site group change takes off sale, and where: with siteIds, an edit to those sites; without, a delete
   */
  siteGroupBrandServiceTemplateWithdrawals: (args: {
    siteGroupId: ScalarsEnums['ID']
    siteIds?: Maybe<Array<ScalarsEnums['ID']>>
  }) => Array<BrandServiceTemplateWithdrawal>
  /**
   * Names of the brand session groups that target a site group
   */
  siteGroupBrandSessionGroupNames: (args: {
    siteGroupId: ScalarsEnums['ID']
  }) => Array<ScalarsEnums['String']>
  /**
   * Names of the brand tax settings that target a site group
   */
  siteGroupBrandTaxSettingNames: (args: {
    siteGroupId: ScalarsEnums['ID']
  }) => Array<ScalarsEnums['String']>
  /**
   * List all site groups
   */
  siteGroups: (args: {
    cursor?: Maybe<ScalarsEnums['String']>
    orderBy: Array<SiteGroupsOrderByInput>
    pageSize?: Maybe<ScalarsEnums['Float']>
    search?: Maybe<ScalarsEnums['String']>
  }) => SiteGroups
  /**
   * Get all site groups that are available to assign
   */
  siteGroupsAvailableToAssign: (args: {
    staffAccessPolicyId: ScalarsEnums['ID']
  }) => Array<SiteGroup>
  /**
   * Get all site groups that include a specific site
   */
  siteGroupsBySite: (args: { siteId: ScalarsEnums['ID'] }) => Array<SiteGroup>
  /**
   * Get site Grow integration status from GrowLocation table
   */
  siteGrowStatus: (args: { siteId: ScalarsEnums['String'] }) => SiteGrowStatus
  /**
   * What each custom late-cancel fee is currently applied to — schedule templates, recurring series, and standalone sessions
   */
  siteLateCancelFeeUsage: (args: {
    lateCancelFeeIds: Array<ScalarsEnums['ID']>
    siteId: ScalarsEnums['ID']
  }) => Array<SiteLateCancelFeeUsageEntry>
  /**
   * List the custom late-cancel fees configured for a site
   */
  siteLateCancelFees: (args: { siteId: ScalarsEnums['ID'] }) => Array<SiteLateCancelFee>
  /**
   * Live occupancy label for a location; null when the live meter is not offered
   */
  siteLiveOccupancy: (args: { siteId: ScalarsEnums['String'] }) => Maybe<SiteLiveOccupancy>
  /**
   * Get a site location by IDs
   */
  siteLocation: (args: {
    siteId: ScalarsEnums['ID']
    siteLocationId: ScalarsEnums['ID']
  }) => Maybe<SiteLocation>
  /**
   * Get a room by its ID
   */
  siteLocationRoom: (args: {
    siteId: ScalarsEnums['ID']
    siteLocationId: ScalarsEnums['ID']
    siteLocationRoomId: ScalarsEnums['ID']
  }) => Maybe<SiteLocationRoom>
  /**
   * Get locations for a site
   */
  siteLocations: (args: { siteId: ScalarsEnums['ID'] }) => Array<SiteLocation>
  /**
   * A location’s Plan your visit configuration with staff-only calibration read-outs
   */
  siteMemberAppSettings: (args: { siteId: ScalarsEnums['String'] }) => SiteMemberAppSettingsResult
  /**
   * When the location’s alerts next start or end, so member caches never outlive an alert change
   */
  siteNextAlertChange: (args: { siteId: ScalarsEnums['String'] }) => Maybe<ScalarsEnums['String']>
  /**
   * What each custom no-show fee is currently applied to — schedule templates, recurring series, and standalone sessions
   */
  siteNoShowFeeUsage: (args: {
    noShowFeeIds: Array<ScalarsEnums['ID']>
    siteId: ScalarsEnums['ID']
  }) => Array<SiteNoShowFeeUsageEntry>
  /**
   * List the custom no-show fees configured for a site
   */
  siteNoShowFees: (args: { siteId: ScalarsEnums['ID'] }) => Array<SiteNoShowFee>
  /**
   * Get the brand payment-authorisation config for a site (settings form).
   */
  sitePaymentAuthorisationConfig: (args: {
    siteId: ScalarsEnums['ID']
  }) => SitePaymentAuthorisationConfig
  /**
   * Get payment gateway information for a site including bank account capabilities
   */
  sitePaymentGateway: (args: { siteId: ScalarsEnums['ID'] }) => SitePaymentGatewayInfo
  /**
   * Get current payment method for site SMS purchases
   */
  sitePaymentMethod: (args: { siteId: ScalarsEnums['String'] }) => Maybe<SitePaymentMethodDetails>
  /**
   * Get a payroll tier by ID with configurations and assignments
   */
  sitePayrollTier: (args: {
    assignmentsSearch?: Maybe<ScalarsEnums['String']>
    configurationsSearch?: Maybe<ScalarsEnums['String']>
    id: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Maybe<SitePayrollTier>
  /**
   * List all payroll tiers for a site
   */
  sitePayrollTiers: (args: { siteId: ScalarsEnums['ID'] }) => Array<SitePayrollTiers>
  /**
   * Member-facing Plan your visit widget and gym information, resolved in the site timezone; null when not offered
   */
  sitePlanYourVisit: (args: { siteId: ScalarsEnums['String'] }) => Maybe<SitePlanYourVisit>
  /**
   * List all site policies for a site
   */
  sitePolicies: (args: { siteId: ScalarsEnums['String'] }) => Array<SitePolicy>
  /**
   * Get a site policy by ID
   */
  sitePolicy: (args: {
    id: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Maybe<SitePolicy>
  /**
   * The location's equipment policy settings: guardian consent age, consent ceremony, automatic link sends and queueing
   */
  sitePolicyComplianceSettings: (args: { siteId: ScalarsEnums['ID'] }) => PolicyComplianceSettings
  /**
   * Every published revision of a site policy, newest first, with its effective status
   */
  sitePolicyRevisions: (args: {
    siteId: ScalarsEnums['ID']
    sitePolicyId: ScalarsEnums['ID']
  }) => Array<SitePolicyRevision>
  /**
   * Active recurring workshop series at a site (Website Widgets configurator)
   */
  siteRecurringWorkshops: (args: { siteId: ScalarsEnums['String'] }) => Array<SiteRecurringWorkshop>
  /**
   * Get a site session type by ID
   */
  siteSessionType: (args: {
    id: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => Maybe<SiteSessionType>
  /**
   * List all session types, optionally filtered by site and search term
   */
  siteSessionTypes: (args: {
    search?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['String']
  }) => Array<SiteSessionType>
  /**
   * Get session types by IDs for a site
   */
  siteSessionTypesByIds: (args: {
    siteId: ScalarsEnums['String']
    siteSessionTypeIds: Array<ScalarsEnums['String']>
  }) => Array<SiteSessionType>
  /**
   * Get suppliers for a site
   */
  siteSuppliers: (args: { siteId: ScalarsEnums['String'] }) => Array<CreateSiteSupplierResponse>
  /**
   * The profile details a reader can collect that this location requires when a client signs up
   */
  siteTerminalHandoffRequiredFields: (args: {
    siteId: ScalarsEnums['ID']
  }) => Array<ScalarsEnums['TerminalHandoffField']>
  /**
   * How a location uses its Stripe readers for agreement signatures and member details, with defaults when nothing is saved
   */
  siteTerminalHandoffSettings: (args: {
    siteId: ScalarsEnums['ID']
  }) => SiteTerminalHandoffSettingsView
  /**
   * Get a terminal reader by site ID and terminal reader ID
   */
  siteTerminalReader: (args: {
    siteId: ScalarsEnums['ID']
    siteTerminalReaderId: ScalarsEnums['ID']
  }) => SiteTerminalReader
  /**
   * Site address fields still required before the first terminal reader can be registered
   */
  siteTerminalReaderRegistrationReadiness: (args: {
    siteId: ScalarsEnums['ID']
  }) => SiteTerminalReaderRegistrationReadiness
  /**
   * List terminal readers with pagination and sorting
   */
  siteTerminalReaders: (args: {
    cursor?: Maybe<ScalarsEnums['String']>
    orderBy?: Maybe<Array<SiteTerminalReadersOrderByInput>>
    pageSize?: Maybe<ScalarsEnums['Float']>
    search?: Maybe<ScalarsEnums['String']>
    siteId: ScalarsEnums['ID']
  }) => SiteTerminalReaderPaginationResult
  /**
   * Check if a theme is active for a specific site, including feature manifest
   */
  siteThemeStatus: (args: {
    corporateId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
    themeSlug: ScalarsEnums['String']
  }) => ThemeEntitlementResult
  /**
   * Per-site enablement of every theme the brand subscribes to — one call for the whole add-ons list, each row keyed by slug
   */
  siteThemeStatuses: (args: {
    corporateId: ScalarsEnums['ID']
    siteId: ScalarsEnums['ID']
  }) => Array<SiteThemeStatusRow>
  /**
   * Get a site webhook by ID
   */
  siteWebhook: (args: {
    siteId: ScalarsEnums['String']
    webhookId: ScalarsEnums['String']
  }) => Maybe<SiteWebhook>
  /**
   * Get delivery history for a webhook
   */
  siteWebhookDeliveries: (args: {
    limit?: Maybe<ScalarsEnums['Float']>
    offset?: Maybe<ScalarsEnums['Float']>
    siteId: ScalarsEnums['String']
    status?: Maybe<SiteWebhookDeliveryStatus>
    webhookId: ScalarsEnums['String']
  }) => Array<SiteWebhookDelivery>
  /**
   * Get a specific delivery by ID
   */
  siteWebhookDelivery: (args: {
    deliveryId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
    webhookId: ScalarsEnums['String']
  }) => Maybe<SiteWebhookDelivery>
  /**
   * List all webhooks for a site
   */
  siteWebhooks: (args: {
    endingBefore?: Maybe<ScalarsEnums['String']>
    limit?: Maybe<ScalarsEnums['Float']>
    siteId: ScalarsEnums['String']
    startingAfter?: Maybe<ScalarsEnums['String']>
    status?: Maybe<SiteWebhookStatus>
  }) => Array<SiteWebhook>
  /**
   * Count webhooks for a site
   */
  siteWebhooksCount: (args: {
    siteId: ScalarsEnums['String']
    status?: Maybe<SiteWebhookStatus>
  }) => ScalarsEnums['Float']
  /**
   * Check if site-level webhooks are enabled for a corporate
   */
  siteWebhooksEnabled: (args: { corporateId: ScalarsEnums['ID'] }) => ScalarsEnums['Boolean']
  /**
   * Upcoming non-recurring workshop occurrences at a site (Website Widgets configurator)
   */
  siteWorkshops: (args: {
    siteId: ScalarsEnums['String']
    type: SiteWorkshopTypes
  }) => Array<SiteWorkshop>
  /**
   * Find sites with search and pagination
   */
  sites: (args?: {
    cursor?: Maybe<ScalarsEnums['String']>
    filter?: Maybe<SitesFilterInput>
    orderBy?: Maybe<Array<SitesOrderByInput>>
    pageSize?: Maybe<ScalarsEnums['Float']>
    search?: Maybe<ScalarsEnums['String']>
  }) => Sites
  /**
   * Get sites available to assign to an access policy
   */
  sitesAvailableToAssign: (args: {
    staffAccessPolicyId: ScalarsEnums['ID']
  }) => Array<SiteReference>
  /**
   * Every location of this brand and which may override its plan (OC-320); ids only and unpaginated so a paged picker can still express the whole set, including 'select all'
   */
  sitesPlanOverrideSelection: SitesPlanOverrideSelection
  /**
   * Get paginated SMS credits history with cursor-based pagination
   */
  smsCreditsHistory: (args: {
    cursor?: Maybe<ScalarsEnums['String']>
    direction?: Maybe<SmsCreditsDirection>
    endDate?: Maybe<ScalarsEnums['String']>
    pageSize?: Maybe<ScalarsEnums['Float']>
    reason?: Maybe<SmsCreditsReason>
    siteId: ScalarsEnums['String']
    startDate?: Maybe<ScalarsEnums['String']>
  }) => SmsCreditsHistory
  /**
   * Get SMS package by ID with its pricing options
   */
  smsPackage: (args: { smsPackageId: ScalarsEnums['ID'] }) => SmsPackage
  /**
   * Find SMS packages with pagination, search, and filtering
   */
  smsPackages: (args: {
    cursor?: Maybe<ScalarsEnums['String']>
    filter?: Maybe<SmsPackagesFilterInput>
    orderBy: Array<SmsPackagesOrderByInput>
    pageSize?: Maybe<ScalarsEnums['Float']>
    search?: Maybe<ScalarsEnums['String']>
  }) => SmsPackages
  /**
   * Get SMS package for a specific country with its pricing options
   */
  smsPackagesByCountry: (args: { countryId: ScalarsEnums['String'] }) => Maybe<SmsPackage>
  /**
   * Get a SOAP note by ID
   */
  soapNote: (args: {
    siteId: ScalarsEnums['String']
    soapNoteId: ScalarsEnums['String']
  }) => Maybe<SoapNote>
  /**
   * Get all SOAP notes for a client
   */
  soapNotes: (args: {
    clientId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => SoapNotesResponse
  /**
   * Get all SOAP notes for a session
   */
  soapNotesBySession: (args: {
    sessionId: ScalarsEnums['String']
    siteId: ScalarsEnums['String']
  }) => SoapNotesResponse
  /**
   * List all staff access policies
   */
  staffAccessPolicies: (args: {
    cursor?: Maybe<ScalarsEnums['String']>
    orderBy: Array<StaffAccessPoliciesOrderByInput>
    pageSize?: Maybe<ScalarsEnums['Float']>
    search?: Maybe<ScalarsEnums['String']>
  }) => StaffAccessPolicies
  /**
   * List staff access policies that the current user can assign to other users
   */
  staffAccessPoliciesAvailableToAssign: Array<StaffAccessPolicy>
  /**
   * Get a staff access policy by its ID
   */
  staffAccessPolicy: (args: { staffAccessPolicyId: ScalarsEnums['ID'] }) => StaffAccessPolicy
  /**
   * For one staff access policy, each location and location group the current user can reach, whether the policy can be assigned there, and the permissions missing where it cannot
   */
  staffAccessPolicyAssignability: (args: {
    staffAccessPolicyId: ScalarsEnums['ID']
  }) => StaffAccessPolicyAssignability
  /**
   * For every staff access policy, how many of the locations and location groups the current user can reach accept it, and the fewest permissions missing at any of them
   */
  staffAccessPolicyAssignabilitySummary: Array<StaffAccessPolicyAssignabilitySummary>
  /**
   * List the IDs of staff access policies the current user can grant on at least one location or location group
   */
  staffAccessPolicyIdsGrantable: Array<ScalarsEnums['ID']>
  /**
   * An allowed network by its ID
   */
  staffAllowedNetwork: (args: { staffAllowedNetworkId: ScalarsEnums['ID'] }) => StaffAllowedNetwork
  /**
   * The brand's allowed networks, optionally only those of one location
   */
  staffAllowedNetworks: (args?: {
    /**
     * Only networks assigned to this location (for location-level team member forms)
     */
    siteId?: Maybe<ScalarsEnums['ID']>
  }) => Array<StaffAllowedNetwork>
  /**
   * List staff invitations for a corporate
   */
  staffInvitationsList: (args: {
    corporateId: ScalarsEnums['ID']
    limit?: Maybe<ScalarsEnums['Float']>
    offset?: Maybe<ScalarsEnums['Float']>
    status?: Maybe<InvitationStatus>
  }) => Array<StaffInvitation>
  /**
   * Lean, ACTIVE-only staff options (id + name only, no permission blobs) for pickers; permission-scoped identically to staffUsers. Deactivated staff are excluded (MEM-46), as is staff left with only inactive locations (MEM-388).
   */
  staffOptions: Array<StaffUserOption>
  /**
   * Active staff assigned to a specific location, for location-scoped pickers such as "Sale referred by" on New Sale. Scoped to the given site, NOT to the caller's own access breadth.
   */
  staffOptionsBySite: (args: { siteId: ScalarsEnums['ID'] }) => Array<StaffUserOption>
  /**
   * Get a staff session assignment by ID
   */
  staffSessionAssignment: (args: {
    staffSessionAssignmentId: ScalarsEnums['ID']
  }) => Maybe<StaffSessionAssignment>
  /**
   * List staff session assignments with cursor-based pagination
   */
  staffSessionAssignments: (args?: {
    cursor?: Maybe<ScalarsEnums['String']>
    pageSize?: Maybe<ScalarsEnums['Float']>
    sessionId?: Maybe<ScalarsEnums['String']>
    staffUserId?: Maybe<ScalarsEnums['String']>
  }) => StaffSessionAssignmentPaginationResult
  /**
   * Get all staff session assignments for a specific session
   */
  staffSessionAssignmentsBySession: (args: {
    sessionId: ScalarsEnums['ID']
  }) => Array<StaffSessionAssignment>
  /**
   * Get all staff session assignments for a specific staff user
   */
  staffSessionAssignmentsByStaffUser: (args: {
    staffUserId: ScalarsEnums['ID']
  }) => Array<StaffSessionAssignment>
  /**
   * The brand's staff session policy (idle timeout and maximum session length)
   */
  staffSessionPolicy: StaffSessionPolicy
  /**
   * Paginated clock-in/out history for a staff user at a site.
   */
  staffTimeClockActivityLog: (args: {
    limit?: Maybe<ScalarsEnums['Float']>
    offset?: Maybe<ScalarsEnums['Float']>
    siteId: ScalarsEnums['ID']
    staffUserId: ScalarsEnums['ID']
  }) => StaffTimeClockActivityLog
  /**
   * Current clock status (IN/OUT) for the given staff users at a site.
   */
  staffTimeClockStatuses: (args: {
    siteId: ScalarsEnums['ID']
    staffUserIds: Array<ScalarsEnums['ID']>
  }) => Array<StaffTimeClockStatus>
  /**
   * Get an staff user by its ID
   */
  staffUser: (args: { staffUserId: ScalarsEnums['ID'] }) => StaffUser
  staffUserSmartGroups: (args: {
    siteId: ScalarsEnums['String']
    staffUserId: ScalarsEnums['String']
  }) => Array<StaffUserSmartGroup>
  /**
   * List all staff users
   */
  staffUsers: Array<StaffUser>
  /**
   * Get all Stripe connected accounts with usage information
   */
  stripeConnectAccounts: Array<StripeConnectAccount>
  supportChat: (args: { supportChatId: ScalarsEnums['ID'] }) => Maybe<SupportChat>
  supportChatMessages: (args: {
    pagination?: Maybe<PaginationInput>
    supportChatId: ScalarsEnums['String']
  }) => Array<SupportChatMessage>
  supportChatWithMessages: (args: {
    supportChatId: ScalarsEnums['ID']
  }) => Maybe<SupportChatWithMessages>
  /**
   * Health of the site's tanning connector: verdict, stored start and callback history, a live check and the connector's diagnostics
   */
  tanningConnectorHealth: (args: { siteId: ScalarsEnums['ID'] }) => TanningConnectorHealth
  /**
   * Check whether a client is eligible to use tanning equipment at this moment, against the given bed when equipmentId is set, otherwise against a bed of the category
   */
  tanningEligibility: (args: {
    category: EquipmentCategory
    clientId: ScalarsEnums['String']
    equipmentId?: Maybe<ScalarsEnums['ID']>
    siteId: ScalarsEnums['String']
  }) => TanningEligibility
  /**
   * Get a tax setting by ID
   */
  taxSetting: (args: {
    siteId: ScalarsEnums['ID']
    taxSettingId: ScalarsEnums['ID']
  }) => Maybe<TaxSetting>
  /**
   * List all tax settings for a site
   */
  taxSettings: (args: {
    enabled?: Maybe<ScalarsEnums['Boolean']>
    siteId: ScalarsEnums['ID']
  }) => Maybe<Array<TaxSetting>>
  /**
   * Get tax settings by IDs for a site
   */
  taxSettingsByIds: (args: {
    siteId: ScalarsEnums['ID']
    taxSettingIds: Array<ScalarsEnums['ID']>
  }) => Array<TaxSetting>
  /**
   * Get count of tax settings for a site
   */
  taxSettingsCount: (args: { siteId: ScalarsEnums['ID'] }) => ScalarsEnums['Float']
  /**
   * What a reader hand-off can collect at a location: switches, signing device, the readers that can show forms and, for a client, the required details they are missing
   */
  terminalHandoffPlan: (args: {
    clientId?: Maybe<ScalarsEnums['ID']>
    siteId: ScalarsEnums['ID']
  }) => TerminalHandoffPlan
  /**
   * One reader hand-off, caught up with the reader when its webhook is overdue. Polled while staff wait.
   */
  terminalHandoffRequest: (args: {
    siteId: ScalarsEnums['ID']
    terminalHandoffRequestId: ScalarsEnums['ID']
  }) => TerminalHandoffRequest
  /**
   * List disposable test members provisioned for the authenticated corporate
   */
  testMembers: Array<TestMember>
  /**
   * For every add-on the brand subscribes to, the locations it is deployed to — one call for the whole add-ons panel, where a location is deployed only if it holds an ACTIVE row (no row means off)
   */
  themeDeployments: (args: { corporateId: ScalarsEnums['ID'] }) => Array<ThemeDeploymentRow>
  /**
   * Get the subscription status for a specific theme by corporate and theme slug
   */
  themeSubscription: (args: {
    corporateId: ScalarsEnums['ID']
    themeSlug: ScalarsEnums['String']
  }) => Maybe<ThemeSubscription>
  /**
   * List all theme subscriptions for a corporate
   */
  themeSubscriptions: (args: { corporateId: ScalarsEnums['ID'] }) => Array<ThemeSubscription>
  /**
   * Get a third party integration by its ID
   */
  thirdPartyIntegration: (args: {
    thirdPartyIntegrationId: ScalarsEnums['ID']
  }) => ThirdPartyIntegrationWithKeys
  /**
   * List all third party integrations
   */
  thirdPartyIntegrations: Array<ThirdPartyIntegrationWithKeys>
  /**
   * Get all trials for the admin pipeline dashboard
   */
  trialPipeline: Array<TrialPipelineItem>
  /**
   * Get trial status and onboarding progress for a corporate
   */
  trialStatus: (args: { corporateId: ScalarsEnums['ID'] }) => TrialStatusResponse
  unreadReleaseNotes: (args: {
    limit?: Maybe<ScalarsEnums['Int']>
    userContext: UserContextInput
  }) => Array<ReleaseNote>
  unreadReleaseNotesCount: (args: { userContext: UserContextInput }) => ScalarsEnums['Int']
  userSupportChats: (args: {
    pagination?: Maybe<PaginationInput>
    status?: Maybe<SupportChatStatus>
    userId: ScalarsEnums['String']
  }) => Array<SupportChat>
  /**
   * Get users assigned to a specific access policy
   */
  usersAssignedToPolicy: (args: {
    search?: Maybe<ScalarsEnums['String']>
    staffAccessPolicyId: ScalarsEnums['ID']
  }) => Array<StaffUserReference>
  /**
   * Validate a gift card code and return its balance
   */
  validateGiftCard: (args: { code: ScalarsEnums['String'] }) => ValidateGiftCardResult
  /**
   * Validate if a promo code can be used
   */
  validatePromoCode: (args: {
    input: PromoCodeValidationInput
    siteId: ScalarsEnums['ID']
  }) => ValidatePromoCode
  /**
   * Validate that all site IDs exist
   */
  validateSiteIds: (args: { siteIds: Array<ScalarsEnums['ID']> }) => ScalarsEnums['Boolean']
  /**
   * Verify a completed Stripe Checkout Session
   */
  verifyCheckoutSession: (args: { sessionId: ScalarsEnums['String'] }) => VerifySessionResponse
  /**
   * List all visible custom links
   */
  visibleCustomLinks: Array<CustomLink>
  /**
   * Get webhook delivery history for a specific webhook endpoint
   */
  webhookDeliveryHistory: (args: {
    corporateId: ScalarsEnums['String']
    pagination?: Maybe<AuditEventsPaginationInput>
    siteId?: Maybe<ScalarsEnums['String']>
    webhookId: ScalarsEnums['String']
    webhookType?: Maybe<WebhookType>
  }) => AuditQueryResult
  /**
   * Get sessions for week view with visible sessions (full details) and overflow sessions (minimal details)
   */
  weekViewSessions: (args: {
    endDate: ScalarsEnums['String']
    filters?: Maybe<SessionQueryFiltersInput>
    siteId: ScalarsEnums['String']
    startDate: ScalarsEnums['String']
    status?: Maybe<ScalarsEnums['String']>
    timezone?: Maybe<ScalarsEnums['String']>
    visiblePerDay?: Maybe<ScalarsEnums['Float']>
  }) => Array<WeekViewDay>
  /**
   * Where the Hapana schedule and the Wellhub catalog disagree for this site, across the site materialization window (INT-141 slice 5, TDD §10). Read-only, and slow on purpose: it lists the Wellhub classes of the gym and then the slots of every mapped class, one live HTTP call each, so it answers in seconds and is a deliberate operator action rather than something a screen polls. Every finding names a remedy; none is applied automatically.
   */
  wellhubDivergenceReport: (args: { siteId: ScalarsEnums['ID'] }) => WellhubDivergenceReport
  /**
   * List the Wellhub product mappings per session type for this site (INT-139)
   */
  wellhubProductMappings: (args: { siteId: ScalarsEnums['ID'] }) => Array<WellhubProductMapping>
  /**
   * List the Wellhub commercial products of the gym connected to this site (INT-139, TDD §5.2)
   */
  wellhubProducts: (args: { siteId: ScalarsEnums['ID'] }) => Array<WellhubProductEntry>
  /**
   * Per session type, how many sessions saving a Wellhub product mapping would publish and how many are already published (INT-141)
   */
  wellhubSessionTypePublishCounts: (args: {
    siteId: ScalarsEnums['ID']
  }) => Array<WellhubSessionTypePublishCounts>
  /**
   * Check if a location has an active Zapier connection and list its subscriptions
   */
  zapierStatus: (args: { siteId: ScalarsEnums['ID'] }) => ZapierStatus
  /**
   * Get zone by countryId and zoneId - both required for efficient Spanner interleaved table lookup
   */
  zone: (args: {
    /**
     * Parent country ID - required for efficient Spanner interleaved table lookup
     */
    countryId: ScalarsEnums['ID']
    /**
     * Zone ID
     */
    zoneId: ScalarsEnums['ID']
  }) => Zone
  /**
   * Find zones with pagination, search, and filtering
   */
  zones: (args?: {
    cursor?: Maybe<ScalarsEnums['String']>
    filter?: Maybe<ZonesFilterInput>
    orderBy?: Maybe<Array<ZonesOrderByInput>>
    pageSize?: Maybe<ScalarsEnums['Float']>
    search?: Maybe<ScalarsEnums['String']>
  }) => Zones
  /**
   * Zoom integration connection status for a site (MA-77)
   */
  zoomConnectionStatus: (args: { siteId: ScalarsEnums['ID'] }) => ZoomConnectionStatus
  /**
   * Active Zoom users on the connected Zoom account — host picker (MA-77)
   */
  zoomUsers: (args: { siteId: ScalarsEnums['ID'] }) => Array<ZoomAccountUser>
}

export interface Subscription {
  __typename?: 'Subscription'
}

export interface $CompletionConfig {
  EzypayCompletionConfig?: EzypayCompletionConfig
  StripeCompletionConfig?: StripeCompletionConfig
}

export interface GeneratedSchema {
  query: Query
  mutation: Mutation
  subscription: Subscription
}

export type ScalarsEnums = {
  [Key in keyof Scalars]: Scalars[Key] extends { output: unknown } ? Scalars[Key]['output'] : never
} & {
  AccessControlProvider: AccessControlProvider
  AccessMode: AccessMode
  AccessPermissions: AccessPermissions
  AccessProvider: AccessProvider
  ActivityStreamOrderByColumn: ActivityStreamOrderByColumn
  AddOnDiscountScope: AddOnDiscountScope
  AddtionalBillingType: AddtionalBillingType
  AdminAggregatorSessionSort: AdminAggregatorSessionSort
  AdminMobileFleetAppleSessionAction: AdminMobileFleetAppleSessionAction
  AdminMobileFleetAppleTeamIssue: AdminMobileFleetAppleTeamIssue
  AdminMobileFleetBlocker: AdminMobileFleetBlocker
  AdminMobileFleetCredentialState: AdminMobileFleetCredentialState
  AdminMobileFleetCredentialsStatus: AdminMobileFleetCredentialsStatus
  AdminMobileFleetNextActionKind: AdminMobileFleetNextActionKind
  AdminMobileFleetPlatformFilter: AdminMobileFleetPlatformFilter
  AdminMobileFleetQuickFilter: AdminMobileFleetQuickFilter
  AdminMobileFleetReleaseStage: AdminMobileFleetReleaseStage
  AdminMobileFleetSeverity: AdminMobileFleetSeverity
  AdminMobileFleetStatusFilter: AdminMobileFleetStatusFilter
  AdminUserPermissions: AdminUserPermissions
  AdminUserStatus: AdminUserStatus
  AdminUsersOrderBy: AdminUsersOrderBy
  AgeBandOutcome: AgeBandOutcome
  AgeEvidenceRequired: AgeEvidenceRequired
  AgeVerificationMethod: AgeVerificationMethod
  AgentStatus: AgentStatus
  AgreementMethod: AgreementMethod
  AgreementSignedSource: AgreementSignedSource
  AgreementStatus: AgreementStatus
  AgreementType: AgreementType
  AlertOperator: AlertOperator
  AnalyticsV2FilterOperator: AnalyticsV2FilterOperator
  AnalyticsV2OrderDirection: AnalyticsV2OrderDirection
  AnalyticsV2TimeGranularity: AnalyticsV2TimeGranularity
  AnalyticsV2TrustTier: AnalyticsV2TrustTier
  AndroidPermission: AndroidPermission
  ApiCallLogCredentialType: ApiCallLogCredentialType
  ApiCallLogStatus: ApiCallLogStatus
  ApiCallLogType: ApiCallLogType
  ApiCredentialEnv: ApiCredentialEnv
  ApiCredentialKind: ApiCredentialKind
  ApiCredentialStatus: ApiCredentialStatus
  AppleAccountSessionMode: AppleAccountSessionMode
  AppleAccountSessionStatus: AppleAccountSessionStatus
  AppleAutomationReason: AppleAutomationReason
  AppleAutomationSource: AppleAutomationSource
  AppleContentRightsDeclaration: AppleContentRightsDeclaration
  AssignabilityBlockedReason: AssignabilityBlockedReason
  AssignedStaffSource: AssignedStaffSource
  AttendanceSource: AttendanceSource
  AttendanceStatus: AttendanceStatus
  AttendanceType: AttendanceType
  AuditAction: AuditAction
  AuditAggregationGroupBy: AuditAggregationGroupBy
  AuditDeviceType: AuditDeviceType
  AuditPlatform: AuditPlatform
  AuditResource: AuditResource
  AuditSeverity: AuditSeverity
  AuditSortDirection: AuditSortDirection
  AuditSortField: AuditSortField
  AuditSource: AuditSource
  AuditVisibility: AuditVisibility
  AutoConvertTrigger: AutoConvertTrigger
  AutoLogoutMinutes: AutoLogoutMinutes
  AutoRenewType: AutoRenewType
  BiParityStatus: BiParityStatus
  BigQueryExportName: BigQueryExportName
  BillingCycleUnit: BillingCycleUnit
  BookingActivityType: BookingActivityType
  BookingAvailability: BookingAvailability
  BookingCreditPackageIneligibleReason: BookingCreditPackageIneligibleReason
  BookingFeeType: BookingFeeType
  BookingPaymentMethodKind: BookingPaymentMethodKind
  BookingPaymentStatus: BookingPaymentStatus
  BookingSource: BookingSource
  BookingStatus: BookingStatus
  BrandAddOnField: BrandAddOnField
  BrandAddOnSkippedLinkReason: BrandAddOnSkippedLinkReason
  BrandArtworkField: BrandArtworkField
  BrandArtworkFormat: BrandArtworkFormat
  BrandBuildConfigViewStatus: BrandBuildConfigViewStatus
  BrandConfigSavedByPersona: BrandConfigSavedByPersona
  BrandEnvironment: BrandEnvironment
  BrandNativeReleaseReason: BrandNativeReleaseReason
  BrandNativeReleaseStatus: BrandNativeReleaseStatus
  BrandNavigationArtworkField: BrandNavigationArtworkField
  BrandObservePerfStatus: BrandObservePerfStatus
  BrandPlatform: BrandPlatform
  BrandProvisionStatus: BrandProvisionStatus
  BrandProvisionStep: BrandProvisionStep
  BrandProvisioningOwner: BrandProvisioningOwner
  BrandProvisioningStepStatus: BrandProvisioningStepStatus
  BrandPushPath: BrandPushPath
  BrandRegistryStatus: BrandRegistryStatus
  BrandReleaseRequirement: BrandReleaseRequirement
  BrandReleaseStoreVerdict: BrandReleaseStoreVerdict
  BrandScheduleClock: BrandScheduleClock
  BrandServiceTemplateArchiveSkipReason: BrandServiceTemplateArchiveSkipReason
  BrandServiceTemplateBlockedReasonCode: BrandServiceTemplateBlockedReasonCode
  BrandServiceTemplateChangeSetKind: BrandServiceTemplateChangeSetKind
  BrandServiceTemplateChangeSetSiteStatus: BrandServiceTemplateChangeSetSiteStatus
  BrandServiceTemplateChangeSetStatus: BrandServiceTemplateChangeSetStatus
  BrandServiceTemplateMemberImpact: BrandServiceTemplateMemberImpact
  BrandServiceTemplateRefusalCode: BrandServiceTemplateRefusalCode
  BrandServiceTemplateSection: BrandServiceTemplateSection
  BrandServiceTemplateSiteAction: BrandServiceTemplateSiteAction
  BrandSetupEvidence: BrandSetupEvidence
  BrandSetupStep: BrandSetupStep
  BrandSetupStepState: BrandSetupStepState
  BrandStatus: BrandStatus
  BrandStoreAssetFormat: BrandStoreAssetFormat
  BrandStoreAssetStatus: BrandStoreAssetStatus
  BrandStoreAssetType: BrandStoreAssetType
  BrandStoreListingPublicationStatus: BrandStoreListingPublicationStatus
  BrandStoreOperationAction: BrandStoreOperationAction
  BrandStoreOperationStatus: BrandStoreOperationStatus
  BrandStoreProvider: BrandStoreProvider
  BrandStoreSnapshotStatus: BrandStoreSnapshotStatus
  BrandStoreTesterSource: BrandStoreTesterSource
  BrandUpdateChannel: BrandUpdateChannel
  BrandingImageFieldName: BrandingImageFieldName
  BuildConfigSource: BuildConfigSource
  BusinessProfileTab: BusinessProfileTab
  BusinessType: BusinessType
  CancelPendingClientActionOutcome: CancelPendingClientActionOutcome
  CancelSessionScope: CancelSessionScope
  CancellationEffectiveDateRule: CancellationEffectiveDateRule
  CancellationFeeBreakdownKind: CancellationFeeBreakdownKind
  CancellationFeeSource: CancellationFeeSource
  CancellationFeeValueKind: CancellationFeeValueKind
  CancellationNoticePeriodUnit: CancellationNoticePeriodUnit
  CancellationPreviewBlocker: CancellationPreviewBlocker
  CancellationTierBasis: CancellationTierBasis
  CardFunding: CardFunding
  CashDrawerSessionStatus: CashDrawerSessionStatus
  CashDrawerTransactionKind: CashDrawerTransactionKind
  CatalogOrderBy: CatalogOrderBy
  CheckInAttemptStatus: CheckInAttemptStatus
  CheckInAuditFailReason: CheckInAuditFailReason
  CheckInFailReason: CheckInFailReason
  CheckInSource: CheckInSource
  CheckInStatus: CheckInStatus
  CheckInType: CheckInType
  ClientActivityFeedKind: ClientActivityFeedKind
  ClientBookingBuddyStatus: ClientBookingBuddyStatus
  ClientBookingOrderByColumn: ClientBookingOrderByColumn
  ClientFamilyRelationship: ClientFamilyRelationship
  ClientGrowSyncStatus: ClientGrowSyncStatus
  ClientOrderBy: ClientOrderBy
  ClientPaymentMethodStatus: ClientPaymentMethodStatus
  ClientPaymentMethodType: ClientPaymentMethodType
  ClientProfileTab: ClientProfileTab
  ClientRelationStatus: ClientRelationStatus
  ClientRelationType: ClientRelationType
  ClientRelationViewType: ClientRelationViewType
  ClientServicesSortBy: ClientServicesSortBy
  ClientSiteLinkSource: ClientSiteLinkSource
  ClientSource: ClientSource
  ClientTimelineActorType: ClientTimelineActorType
  ClientTimelineEventType: ClientTimelineEventType
  ClientTimelinePlatform: ClientTimelinePlatform
  ClientTimelineSource: ClientTimelineSource
  ClientType: ClientType
  ClockStatus: ClockStatus
  CloseReason: CloseReason
  CmsContentEntrySource: CmsContentEntrySource
  CmsCustomEntryKind: CmsCustomEntryKind
  CmsGranularity: CmsGranularity
  CmsImportChangeType: CmsImportChangeType
  CmsImportMappingStatus: CmsImportMappingStatus
  CmsImportMode: CmsImportMode
  CmsImportRunStatus: CmsImportRunStatus
  CmsImportStepStatus: CmsImportStepStatus
  CmsImportStepType: CmsImportStepType
  CmsVideoSortBy: CmsVideoSortBy
  ColumnFormat: ColumnFormat
  CommPrefsSource: CommPrefsSource
  CommissionAttributionSourceSetting: CommissionAttributionSourceSetting
  CommissionBase: CommissionBase
  CommissionCategory: CommissionCategory
  CommissionDashboardEmployeeStatus: CommissionDashboardEmployeeStatus
  CommissionDashboardReviewReason: CommissionDashboardReviewReason
  CommissionEarnerRole: CommissionEarnerRole
  CommissionEnablementReason: CommissionEnablementReason
  CommissionEventKind: CommissionEventKind
  CommissionEventStatus: CommissionEventStatus
  CommissionItemSettingSource: CommissionItemSettingSource
  CommissionItemType: CommissionItemType
  CommissionLeaverRule: CommissionLeaverRule
  CommissionLineKind: CommissionLineKind
  CommissionManagerScope: CommissionManagerScope
  CommissionOwnerChangeMode: CommissionOwnerChangeMode
  CommissionPeriodLength: CommissionPeriodLength
  CommissionPeriodStatus: CommissionPeriodStatus
  CommissionPeriodTransitionTarget: CommissionPeriodTransitionTarget
  CommissionPlanScope: CommissionPlanScope
  CommissionPlanSource: CommissionPlanSource
  CommissionPlanStatus: CommissionPlanStatus
  CommunicationTemplateAliases: CommunicationTemplateAliases
  CommunicationTemplatePlaceholders: CommunicationTemplatePlaceholders
  CommunicationType: CommunicationType
  ConsentWithdrawalSource: ConsentWithdrawalSource
  ContactlessCheckInFormQuestionType: ContactlessCheckInFormQuestionType
  ContentApiKeyStatus: ContentApiKeyStatus
  ContentBulkAction: ContentBulkAction
  ContentEntryLevel: ContentEntryLevel
  ContentEntryOrderBy: ContentEntryOrderBy
  ContentStatus: ContentStatus
  ContentTypeGroup: ContentTypeGroup
  ContentVideoSource: ContentVideoSource
  CoreAppServiceKeyName: CoreAppServiceKeyName
  CorePlanLevel: CorePlanLevel
  CorporateFaqStatus: CorporateFaqStatus
  CorporatePayoutAccountOrderBy: CorporatePayoutAccountOrderBy
  CorporatePermissions: CorporatePermissions
  CorporateServiceTemplateStatus: CorporateServiceTemplateStatus
  CorporateServiceTemplateType: CorporateServiceTemplateType
  CorporateSessionTypeNameClash: CorporateSessionTypeNameClash
  CorporateSessionTypeWithdrawMode: CorporateSessionTypeWithdrawMode
  CorporateTier: CorporateTier
  CorporateWebhookStatus: CorporateWebhookStatus
  CountriesOrderBy: CountriesOrderBy
  CoverApprovalMode: CoverApprovalMode
  CoverCancelReason: CoverCancelReason
  CoverClaimStatus: CoverClaimStatus
  CoverClaimVia: CoverClaimVia
  CoverCommunicationChannel: CoverCommunicationChannel
  CoverCommunicationKind: CoverCommunicationKind
  CoverCommunicationSkipReason: CoverCommunicationSkipReason
  CoverCommunicationStatus: CoverCommunicationStatus
  CoverEligibilityWarning: CoverEligibilityWarning
  CoverFilledVia: CoverFilledVia
  CoverIneligibilityReason: CoverIneligibilityReason
  CoverMemberNotification: CoverMemberNotification
  CoverMessageAudienceRole: CoverMessageAudienceRole
  CoverMessageChannel: CoverMessageChannel
  CoverMessageRecipientMode: CoverMessageRecipientMode
  CoverOfferStatus: CoverOfferStatus
  CoverOfferStrategy: CoverOfferStrategy
  CoverRequestStatus: CoverRequestStatus
  CreatedAtLevel: CreatedAtLevel
  CreatedByType: CreatedByType
  CredentialFieldType: CredentialFieldType
  CreditExpirationType: CreditExpirationType
  CreditExpirationUnit: CreditExpirationUnit
  CreditRolloverPolicy: CreditRolloverPolicy
  CreditShortfallReason: CreditShortfallReason
  CreditType: CreditType
  Currency: Currency
  CustomLinkOpeningMethod: CustomLinkOpeningMethod
  CustomPropertyCategory: CustomPropertyCategory
  CustomPropertyChangedByType: CustomPropertyChangedByType
  CustomPropertyType: CustomPropertyType
  DarkModeStrategy: DarkModeStrategy
  DatabaseType: DatabaseType
  DateFilterOperator: DateFilterOperator
  DateRangeDirection: DateRangeDirection
  DateRangeType: DateRangeType
  DayOfWeek: DayOfWeek
  DeepLinkDestination: DeepLinkDestination
  DemoSeedingDensity: DemoSeedingDensity
  DemoSeedingJobStatus: DemoSeedingJobStatus
  DemoSeedingPersona: DemoSeedingPersona
  DeviceBusyReason: DeviceBusyReason
  DeviceCapability: DeviceCapability
  DeviceInputMode: DeviceInputMode
  DeviceKind: DeviceKind
  DeviceLiveness: DeviceLiveness
  DevicePlatform: DevicePlatform
  DeviceReachability: DeviceReachability
  DirectUploadFormat: DirectUploadFormat
  DirectUploadTarget: DirectUploadTarget
  DiscountType: DiscountType
  DisputeStatus: DisputeStatus
  DnsRecordStatus: DnsRecordStatus
  DnsRecordType: DnsRecordType
  DocumentFileVersionFormat: DocumentFileVersionFormat
  DocumentFileVersionType: DocumentFileVersionType
  DoorAccessCredentialType: DoorAccessCredentialType
  DoorAccessEventDeniedBy: DoorAccessEventDeniedBy
  DoorAccessEventSortField: DoorAccessEventSortField
  DoorAccessOutcome: DoorAccessOutcome
  DoorConnectionFailureReason: DoorConnectionFailureReason
  DoorProvider: DoorProvider
  DoorReconcileStatus: DoorReconcileStatus
  DoorType: DoorType
  DropInRefundMethod: DropInRefundMethod
  ESignConsentProfile: ESignConsentProfile
  EarlyAccessApplyTo: EarlyAccessApplyTo
  EarlyAccessDurationUnit: EarlyAccessDurationUnit
  EgymMembershipType: EgymMembershipType
  EmailCopyEmployee: EmailCopyEmployee
  EmailDomainStatus: EmailDomainStatus
  EmailSendAs: EmailSendAs
  EmailSendBeforeUnit: EmailSendBeforeUnit
  EmbedAppearanceButtonStyle: EmbedAppearanceButtonStyle
  EmbedButtonStyle: EmbedButtonStyle
  EmbedSidebarPosition: EmbedSidebarPosition
  EmployeeLinkOutcome: EmployeeLinkOutcome
  EquipmentAssignmentStatus: EquipmentAssignmentStatus
  EquipmentCategory: EquipmentCategory
  EquipmentComplianceSort: EquipmentComplianceSort
  EquipmentComplianceSortDirection: EquipmentComplianceSortDirection
  EquipmentComplianceStatus: EquipmentComplianceStatus
  EquipmentComplianceWarningCode: EquipmentComplianceWarningCode
  EquipmentLampLogEventType: EquipmentLampLogEventType
  EquipmentLampSet: EquipmentLampSet
  EquipmentLampState: EquipmentLampState
  EquipmentQualityCategory: EquipmentQualityCategory
  EquipmentSessionTypeAvailabilityKind: EquipmentSessionTypeAvailabilityKind
  EquipmentSessionTypeBlockReason: EquipmentSessionTypeBlockReason
  EquipmentStartDecision: EquipmentStartDecision
  EquipmentStatus: EquipmentStatus
  EquipmentType: EquipmentType
  ExportFormat: ExportFormat
  ExportJobStatusEnum: ExportJobStatusEnum
  ExternalVideoMimeType: ExternalVideoMimeType
  FailedPaymentFeeScope: FailedPaymentFeeScope
  FailureCategory: FailureCategory
  FamilyMemberRole: FamilyMemberRole
  FamilyMemberStatus: FamilyMemberStatus
  FamilyStatus: FamilyStatus
  FeatureDataRefreshState: FeatureDataRefreshState
  FeeAccountType: FeeAccountType
  FeeClassificationTypes: FeeClassificationTypes
  FeeConfigurationOrderBy: FeeConfigurationOrderBy
  FeeEventType: FeeEventType
  FeeRateType: FeeRateType
  FeedbackQuestionType: FeedbackQuestionType
  FileUploadConfigFieldPendingStatus: FileUploadConfigFieldPendingStatus
  FileUploadConfigFieldStatus: FileUploadConfigFieldStatus
  FindClientFeesTemplatesSortFields: FindClientFeesTemplatesSortFields
  FindClientsSortFields: FindClientsSortFields
  FindCorporatesSortFields: FindCorporatesSortFields
  FindFeesTemplatesSortFields: FindFeesTemplatesSortFields
  FirebaseAppProjectEnvironment: FirebaseAppProjectEnvironment
  FirebaseAppProjectStatus: FirebaseAppProjectStatus
  FirstCreditAllocationDateType: FirstCreditAllocationDateType
  FirstCycleSettlementKind: FirstCycleSettlementKind
  FirstPaymentAfterUnit: FirstPaymentAfterUnit
  FitnessPassportCheckOutcome: FitnessPassportCheckOutcome
  FitnessPassportConnectionState: FitnessPassportConnectionState
  FitnessPassportFailurePolicy: FitnessPassportFailurePolicy
  FitnessPassportLinkStatus: FitnessPassportLinkStatus
  FitnessPassportVisitOutcome: FitnessPassportVisitOutcome
  FobByteOrder: FobByteOrder
  FobCaptureResultCode: FobCaptureResultCode
  FobCaptureStatus: FobCaptureStatus
  FobController: FobController
  FobReaderFormat: FobReaderFormat
  FobSerialNotation: FobSerialNotation
  FontFieldName: FontFieldName
  FontFormat: FontFormat
  FontSource: FontSource
  FormBookingGateMode: FormBookingGateMode
  FormCompletedVia: FormCompletedVia
  FormExternalResultSource: FormExternalResultSource
  FormHandoffChannel: FormHandoffChannel
  FormHandoffResultCode: FormHandoffResultCode
  FormHandoffStatus: FormHandoffStatus
  FormRequiredBefore: FormRequiredBefore
  FormSignatureFormat: FormSignatureFormat
  FormSubmissionStatus: FormSubmissionStatus
  GatewayType: GatewayType
  GiftCardExpiryMode: GiftCardExpiryMode
  GiftCardExpiryPolicy: GiftCardExpiryPolicy
  GiftCardExpiryRuleHistoryAction: GiftCardExpiryRuleHistoryAction
  GiftCardExpiryRuleReviewStatus: GiftCardExpiryRuleReviewStatus
  GiftCardExpiryRuleSource: GiftCardExpiryRuleSource
  GiftCardFilterType: GiftCardFilterType
  GiftCardStatus: GiftCardStatus
  GiftCardTemplateSortFields: GiftCardTemplateSortFields
  GiftCardTemplateStatus: GiftCardTemplateStatus
  GiftCardValidationReason: GiftCardValidationReason
  GrowStatusFilter: GrowStatusFilter
  GuestPassByTokenError: GuestPassByTokenError
  GuestPassExpiryBehaviour: GuestPassExpiryBehaviour
  GuestPassStatus: GuestPassStatus
  HeadingFontSource: HeadingFontSource
  HeldPaymentReleaseOutcome: HeldPaymentReleaseOutcome
  HeldPaymentReleaseReason: HeldPaymentReleaseReason
  ImageFileVersionFormat: ImageFileVersionFormat
  ImageFileVersionType: ImageFileVersionType
  ImageSupportedVariant: ImageSupportedVariant
  ImportPreviewFilterBy: ImportPreviewFilterBy
  ImportSessionStatusEnum: ImportSessionStatusEnum
  InvitationRole: InvitationRole
  InvitationStatus: InvitationStatus
  InvoiceCancellationSource: InvoiceCancellationSource
  InvoiceItemType: InvoiceItemType
  InvoicePendingReason: InvoicePendingReason
  InvoiceSource: InvoiceSource
  InvoiceStatus: InvoiceStatus
  InvoiceType: InvoiceType
  InvoicesOrderBy: InvoicesOrderBy
  IosUsageDescriptionKey: IosUsageDescriptionKey
  JurisdictionRuleStatus: JurisdictionRuleStatus
  KnowledgeArticleStatus: KnowledgeArticleStatus
  LeadSource: LeadSource
  LeaderboardMetric: LeaderboardMetric
  LeaderboardScope: LeaderboardScope
  LeaderboardStatus: LeaderboardStatus
  LeaderboardType: LeaderboardType
  LeaderboardVisibility: LeaderboardVisibility
  LiveOccupancyLabelKey: LiveOccupancyLabelKey
  LiveOccupancyStatus: LiveOccupancyStatus
  LogicalOperator: LogicalOperator
  MediaOrderBy: MediaOrderBy
  MediaType: MediaType
  MemberDisplayFormat: MemberDisplayFormat
  MemberExperienceDarkMode: MemberExperienceDarkMode
  MemberExperienceStreakScope: MemberExperienceStreakScope
  MemberExperienceSurface: MemberExperienceSurface
  MemberExperienceSurfaceIntegrationProvider: MemberExperienceSurfaceIntegrationProvider
  MemberFormChannel: MemberFormChannel
  MemberLinkStatus: MemberLinkStatus
  MemberMovementApprovalPostureSource: MemberMovementApprovalPostureSource
  MemberMovementAttestationScope: MemberMovementAttestationScope
  MemberMovementBillingAmountStrategy: MemberMovementBillingAmountStrategy
  MemberMovementBlockedNotificationCadence: MemberMovementBlockedNotificationCadence
  MemberMovementBlockedReason: MemberMovementBlockedReason
  MemberMovementCandidateHomeExclusion: MemberMovementCandidateHomeExclusion
  MemberMovementDurationUnit: MemberMovementDurationUnit
  MemberMovementGateKey: MemberMovementGateKey
  MemberMovementGateStatus: MemberMovementGateStatus
  MemberMovementIncomingSegment: MemberMovementIncomingSegment
  MemberMovementMappingMatchType: MemberMovementMappingMatchType
  MemberMovementMappingStateFilter: MemberMovementMappingStateFilter
  MemberMovementOperatingMode: MemberMovementOperatingMode
  MemberMovementPaymentMigrationReason: MemberMovementPaymentMigrationReason
  MemberMovementPaymentMigrationStatus: MemberMovementPaymentMigrationStatus
  MemberMovementReasonCode: MemberMovementReasonCode
  MemberMovementReviewStatus: MemberMovementReviewStatus
  MemberMovementRollingApprovalType: MemberMovementRollingApprovalType
  MemberMovementRunMode: MemberMovementRunMode
  MemberMovementRunStatus: MemberMovementRunStatus
  MemberMovementStatus: MemberMovementStatus
  MemberMovementTemplateMappingMode: MemberMovementTemplateMappingMode
  MemberMovementTrigger: MemberMovementTrigger
  MemberMovementVisitsScope: MemberMovementVisitsScope
  MemberPauseAllowanceUnit: MemberPauseAllowanceUnit
  MemberPauseBlocker: MemberPauseBlocker
  MemberServiceSuspensionSource: MemberServiceSuspensionSource
  MembershipImportBlockingIssueCode: MembershipImportBlockingIssueCode
  MembershipMemberStatusFilter: MembershipMemberStatusFilter
  MergeScope: MergeScope
  MessageType: MessageType
  MinimumTermAfterUnit: MinimumTermAfterUnit
  MobileAppChangeField: MobileAppChangeField
  MobileAppChangeImpact: MobileAppChangeImpact
  MobileAppPlatform: MobileAppPlatform
  MobileSupportedLanguage: MobileSupportedLanguage
  MultipleReservationOutcome: MultipleReservationOutcome
  MyPendingRelationship: MyPendingRelationship
  MyPolicyRefusalCode: MyPolicyRefusalCode
  NativePermissionSource: NativePermissionSource
  NewSaleItemTypes: NewSaleItemTypes
  NonUvCategory: NonUvCategory
  NotificationMethod: NotificationMethod
  NumericFilterOperator: NumericFilterOperator
  NumericToDateFilterOperator: NumericToDateFilterOperator
  OccupancyDisplayMode: OccupancyDisplayMode
  OnboardingCategory: OnboardingCategory
  OnboardingStepKey: OnboardingStepKey
  OrderByDirection: OrderByDirection
  PaymentApprovalDeliveryState: PaymentApprovalDeliveryState
  PaymentApprovalLinkState: PaymentApprovalLinkState
  PaymentDisputeState: PaymentDisputeState
  PaymentFallbackReason: PaymentFallbackReason
  PaymentFallbackState: PaymentFallbackState
  PaymentGateway: PaymentGateway
  PaymentGatewayTransactionStatus: PaymentGatewayTransactionStatus
  PaymentMethodRemovalBlockReason: PaymentMethodRemovalBlockReason
  PaymentMethodType: PaymentMethodType
  PaymentMode: PaymentMode
  PaymentRecoveryState: PaymentRecoveryState
  PaymentRoutingMode: PaymentRoutingMode
  PaymentStatus: PaymentStatus
  PaymentStatusFilter: PaymentStatusFilter
  PaymentWallet: PaymentWallet
  PaymentsPipelineMode: PaymentsPipelineMode
  PayrollAdditionalTypes: PayrollAdditionalTypes
  PayrollTierType: PayrollTierType
  PayrollType: PayrollType
  PendingChangeType: PendingChangeType
  PendingItemHandoffCapability: PendingItemHandoffCapability
  PendingItemKind: PendingItemKind
  PendingItemsAutoSendSkipReason: PendingItemsAutoSendSkipReason
  PendingItemsChannel: PendingItemsChannel
  PendingItemsHandoffStatus: PendingItemsHandoffStatus
  PendingPaymentCancellationOutcome: PendingPaymentCancellationOutcome
  PendingPaymentCancellationReason: PendingPaymentCancellationReason
  PeriodOfTime: PeriodOfTime
  PiiClassification: PiiClassification
  PlanChangeDirection: PlanChangeDirection
  PolicyAcceptanceMethod: PolicyAcceptanceMethod
  PolicyAcceptanceState: PolicyAcceptanceState
  PolicyBulkSendStatus: PolicyBulkSendStatus
  PolicyEquipmentScope: PolicyEquipmentScope
  PolicyEvidenceExportStatus: PolicyEvidenceExportStatus
  PolicyRevisionStatus: PolicyRevisionStatus
  PolicySignerRule: PolicySignerRule
  PosActivityCategory: PosActivityCategory
  PosActivityType: PosActivityType
  PosCategoryStatus: PosCategoryStatus
  PosProductStatus: PosProductStatus
  PosStockAdjusmentType: PosStockAdjusmentType
  PresaleShortfallAction: PresaleShortfallAction
  ProcessCSVImportStatus: ProcessCSVImportStatus
  ProcessZIPImportStatus: ProcessZIPImportStatus
  ProductPlanTier: ProductPlanTier
  PromoCodeDiscountType: PromoCodeDiscountType
  PromoCodeItemType: PromoCodeItemType
  PromoCodeSortFields: PromoCodeSortFields
  PromoCodeStatus: PromoCodeStatus
  PublicApiLogLevel: PublicApiLogLevel
  PublicSigningPaymentMethodType: PublicSigningPaymentMethodType
  PushProvider: PushProvider
  RankingDirection: RankingDirection
  ReaderType: ReaderType
  ReadinessItemTiming: ReadinessItemTiming
  ReadinessReasonCode: ReadinessReasonCode
  ReadinessStatus: ReadinessStatus
  ReasonsNotAutoRetryable: ReasonsNotAutoRetryable
  RebateTemplateOrderBy: RebateTemplateOrderBy
  RecurrenceType: RecurrenceType
  RecurringInvoiceOrderBy: RecurringInvoiceOrderBy
  RecurringInvoiceStatus: RecurringInvoiceStatus
  RecurringInvoiceType: RecurringInvoiceType
  RecurringSessionEditScope: RecurringSessionEditScope
  RecurringSessionStatus: RecurringSessionStatus
  RedirectAfterPackagePayment: RedirectAfterPackagePayment
  RefreshFrequency: RefreshFrequency
  RefundAllocationMethod: RefundAllocationMethod
  RefundOrigin: RefundOrigin
  RefundStatus: RefundStatus
  RefundType: RefundType
  RefundableGatewayFeeCode: RefundableGatewayFeeCode
  ReinstateBlockedReason: ReinstateBlockedReason
  ReleaseHubAvailabilityKind: ReleaseHubAvailabilityKind
  ReleaseHubScope: ReleaseHubScope
  ReleaseHubStage: ReleaseHubStage
  ReleaseHubType: ReleaseHubType
  ReleaseNoteStatus: ReleaseNoteStatus
  ReleaseNoteTranslationStatus: ReleaseNoteTranslationStatus
  ReleaseNoteType: ReleaseNoteType
  ReleaseTerminalPaymentOutcome: ReleaseTerminalPaymentOutcome
  ReleaseType: ReleaseType
  ReplaceExternalVideoMimeType: ReplaceExternalVideoMimeType
  ReportName: ReportName
  ReportNoticeLevel: ReportNoticeLevel
  ReportPermissionCategory: ReportPermissionCategory
  RestartEquipmentAssignmentOutcome: RestartEquipmentAssignmentOutcome
  ResurveyInterval: ResurveyInterval
  RevenueTagMapping: RevenueTagMapping
  ReversalReason: ReversalReason
  RevisionChangeType: RevisionChangeType
  RevisionReviewState: RevisionReviewState
  RoomResourceTemplateBookingPropertyTypes: RoomResourceTemplateBookingPropertyTypes
  RoyaltiesAndFeesTemplateOrderBy: RoyaltiesAndFeesTemplateOrderBy
  RoyaltyBaseMode: RoyaltyBaseMode
  SaleAvailabilityState: SaleAvailabilityState
  SaleItemType: SaleItemType
  SandboxAnonymisedClientColumn: SandboxAnonymisedClientColumn
  SandboxJobKind: SandboxJobKind
  SandboxJobStatus: SandboxJobStatus
  SandboxReportClientAction: SandboxReportClientAction
  SandboxStatusFilter: SandboxStatusFilter
  SandboxStepName: SandboxStepName
  SandboxStepStatus: SandboxStepStatus
  SavedReportVisibility: SavedReportVisibility
  ScheduleAction: ScheduleAction
  ScheduleDefaultView: ScheduleDefaultView
  ScheduledInvoiceType: ScheduledInvoiceType
  ScheduledJobLevel: ScheduledJobLevel
  ScheduledJobRunStatus: ScheduledJobRunStatus
  ScheduledJobTriggerSafety: ScheduledJobTriggerSafety
  ScheduledJobTriggerSource: ScheduledJobTriggerSource
  ScheduledPushAudienceType: ScheduledPushAudienceType
  ScheduledPushFailureReason: ScheduledPushFailureReason
  ScheduledPushSendStatus: ScheduledPushSendStatus
  SchedulerTimeSlotDuration: SchedulerTimeSlotDuration
  ScoreType: ScoreType
  SelectFilterOperator: SelectFilterOperator
  SelfServicePauseCadenceUnit: SelfServicePauseCadenceUnit
  SelfServicePauseChargeMode: SelfServicePauseChargeMode
  SelfServicePauseDurationUnit: SelfServicePauseDurationUnit
  ServiceActionType: ServiceActionType
  ServiceCancellationStatus: ServiceCancellationStatus
  ServiceCreditLedgerDirection: ServiceCreditLedgerDirection
  ServiceCreditLedgerTransactionType: ServiceCreditLedgerTransactionType
  ServiceCreditShareStatus: ServiceCreditShareStatus
  ServiceExtensionType: ServiceExtensionType
  ServiceExtensionUnit: ServiceExtensionUnit
  ServiceLengthType: ServiceLengthType
  ServiceLengthUnit: ServiceLengthUnit
  ServicePlanChangeEffectiveType: ServicePlanChangeEffectiveType
  ServicePlanChangeStatus: ServicePlanChangeStatus
  ServiceStatus: ServiceStatus
  ServiceSuspensionChargeMode: ServiceSuspensionChargeMode
  ServiceSuspensionCreditMethod: ServiceSuspensionCreditMethod
  ServiceSuspensionType: ServiceSuspensionType
  ServiceTemplateAddOnPaymentType: ServiceTemplateAddOnPaymentType
  ServiceTemplateCategoryStatus: ServiceTemplateCategoryStatus
  ServiceTemplateOrderBy: ServiceTemplateOrderBy
  ServiceTemplateStatus: ServiceTemplateStatus
  ServiceTemplateType: ServiceTemplateType
  SessionCategory: SessionCategory
  SessionDisplayType: SessionDisplayType
  SessionFeeMode: SessionFeeMode
  SessionFeeSource: SessionFeeSource
  SessionFeedbackAnswerType: SessionFeedbackAnswerType
  SessionFeedbackStatus: SessionFeedbackStatus
  SessionFilterCalendarMode: SessionFilterCalendarMode
  SessionFilterVisibility: SessionFilterVisibility
  SessionGroupSection: SessionGroupSection
  SessionStatus: SessionStatus
  SettlementExportType: SettlementExportType
  SharedRelationActivityType: SharedRelationActivityType
  ShiftDatesApplyTo: ShiftDatesApplyTo
  SidebarPosition: SidebarPosition
  SignerCapacity: SignerCapacity
  SiteAccessPointStatus: SiteAccessPointStatus
  SiteAccountCodeStatus: SiteAccountCodeStatus
  SiteAlertStatus: SiteAlertStatus
  SiteAlertTheme: SiteAlertTheme
  SiteAmenityGroup: SiteAmenityGroup
  SiteAmenityKey: SiteAmenityKey
  SiteAmenityStatus: SiteAmenityStatus
  SiteCloneArea: SiteCloneArea
  SiteCloneJobStatus: SiteCloneJobStatus
  SiteCloneJobStep: SiteCloneJobStep
  SiteDuplicateErrorCode: SiteDuplicateErrorCode
  SiteFormQuestionType: SiteFormQuestionType
  SiteFormTemplateKey: SiteFormTemplateKey
  SiteGroupOrderBy: SiteGroupOrderBy
  SiteInfoBlockIcon: SiteInfoBlockIcon
  SiteInfoIcon: SiteInfoIcon
  SiteLocationType: SiteLocationType
  SitePaymentGatewayOnboardingStatus: SitePaymentGatewayOnboardingStatus
  SitePermissions: SitePermissions
  SiteRoomResourceTemplatePropertyTypes: SiteRoomResourceTemplatePropertyTypes
  SiteStatus: SiteStatus
  SiteSupplierStatus: SiteSupplierStatus
  SiteTerminalReaderOrderByField: SiteTerminalReaderOrderByField
  SiteThemeStatus: SiteThemeStatus
  SiteWebhookDeliveryStatus: SiteWebhookDeliveryStatus
  SiteWebhookStatus: SiteWebhookStatus
  SiteWebhookStatusInput: SiteWebhookStatusInput
  SiteWorkshopType: SiteWorkshopType
  SiteWorkshopTypes: SiteWorkshopTypes
  SitesOrderBy: SitesOrderBy
  SkinTypeEligibilityStatus: SkinTypeEligibilityStatus
  SkinTypePermittedAction: SkinTypePermittedAction
  SkinTypeRequirementMode: SkinTypeRequirementMode
  SmsAllowedCurrencies: SmsAllowedCurrencies
  SmsCreditsDirection: SmsCreditsDirection
  SmsCreditsReason: SmsCreditsReason
  SmsPackagesOrderBy: SmsPackagesOrderBy
  SortDirection: SortDirection
  SortOrder: SortOrder
  SortPackageDirection: SortPackageDirection
  SortPackageField: SortPackageField
  Source: Source
  StaffAccessPolicyOrderBy: StaffAccessPolicyOrderBy
  StaffAccessRuleAssignmentType: StaffAccessRuleAssignmentType
  StaffSessionRole: StaffSessionRole
  StaffUserAccessLevel: StaffUserAccessLevel
  StaffUserOrderBy: StaffUserOrderBy
  StaffUserStatus: StaffUserStatus
  StoreBlockerKind: StoreBlockerKind
  StripeAgreementType: StripeAgreementType
  StripePayoutCurrency: StripePayoutCurrency
  SupportChatSource: SupportChatSource
  SupportChatStatus: SupportChatStatus
  SupportIssueType: SupportIssueType
  SupportMessageRole: SupportMessageRole
  SupportedPaymentGateway: SupportedPaymentGateway
  SuspensionRowState: SuspensionRowState
  SyncStatus: SyncStatus
  TagMatch: TagMatch
  TanningConnectorErrorKind: TanningConnectorErrorKind
  TanningConnectorHealthReason: TanningConnectorHealthReason
  TanningConnectorVerdict: TanningConnectorVerdict
  TanningRegulationRule: TanningRegulationRule
  TanningSessionVoidReason: TanningSessionVoidReason
  TargetType: TargetType
  TaxSettingType: TaxSettingType
  TaxType: TaxType
  TemplateSource: TemplateSource
  TerminalHandoffFailureCode: TerminalHandoffFailureCode
  TerminalHandoffField: TerminalHandoffField
  TerminalHandoffHoldReason: TerminalHandoffHoldReason
  TerminalHandoffSourceSurface: TerminalHandoffSourceSurface
  TerminalHandoffStatus: TerminalHandoffStatus
  TerminalHandoffStepKind: TerminalHandoffStepKind
  TerminalHandoffStepState: TerminalHandoffStepState
  TerminalLocationAddressField: TerminalLocationAddressField
  TerminalPaymentMethodType: TerminalPaymentMethodType
  TerminalReaderInputType: TerminalReaderInputType
  TerminalReaderUnsupportedReason: TerminalReaderUnsupportedReason
  TerminalSignatureDevice: TerminalSignatureDevice
  TerminalSignatureFallback: TerminalSignatureFallback
  TextFilterOperator: TextFilterOperator
  ThemeKey: ThemeKey
  ThemeSubscriptionStatus: ThemeSubscriptionStatus
  ThemeValueSource: ThemeValueSource
  ThirdPartyIntegrationAvailableFor: ThirdPartyIntegrationAvailableFor
  ThirdPartyIntegrationUniqueAcross: ThirdPartyIntegrationUniqueAcross
  ThirdPartyIntegrationVisibilityAt: ThirdPartyIntegrationVisibilityAt
  TimePeriodType: TimePeriodType
  TransactionFeePreference: TransactionFeePreference
  TranslationStatus: TranslationStatus
  TrialStatus: TrialStatus
  UserType: UserType
  VideoTranscodingStatus: VideoTranscodingStatus
  VideoUploadStatus: VideoUploadStatus
  VisibilityScope: VisibilityScope
  WaitlistEntryStatus: WaitlistEntryStatus
  WaitlistInvitationStrategy: WaitlistInvitationStrategy
  WaitlistPromotionMethod: WaitlistPromotionMethod
  WaitlistRestrictionType: WaitlistRestrictionType
  WaitlistStrategy: WaitlistStrategy
  WebhookType: WebhookType
  WellhubDivergenceKind: WellhubDivergenceKind
  WidgetButtonStyle: WidgetButtonStyle
  ZonesOrderBy: ZonesOrderBy
}
